import { Lawyer } from '../types';

// Updated from parsing-2026-01-31
// Updated on 2026-03-31 13:24:36
// Total entries: 7741

export const allLawyersFromJsonParser: Lawyer[] = [
  {
    "id": "35e74c66-ffd0-4b2c-bc7c-025474d0a49d",
    "slug": "abdulla-alateibi-advocates-legal-consultants",
    "name": "DR ADNAN MOHAMED ALHAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDULLA ALATEIBI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_35e74c66-ffd0-4b2c-bc7c-025474d0a49d",
        "address": "",
        "phone": "97145859327 / 971503148845",
        "email": "info@amalc.net",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "ADNAN MOHAMED YOUSEF MALAHAYAN",
    "address": "-",
    "phone": "97145859327",
    "email": "info@amalc.net",
    "registrationNumber": "-"
  },
  {
    "id": "7d06b333-b07b-4ed3-813b-3b56f638b071",
    "slug": "aaesha-alteneiji-advocates-legal-consultants",
    "name": "AAESHA ALTENEIJI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/17/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/16/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AAESHA ALTENEIJI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7d06b333-b07b-4ed3-813b-3b56f638b071",
        "address": "السابع - مكتب 704 ,قرية الأعمال - بلوك B ,دوار الساعة ,183303 ,Dubai",
        "phone": "97142280050",
        "email": "aisha@aishalawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Aaesha Rashed Mohammed Abas Ali Al-Tenniji",
    "address": "السابع - مكتب 704,قرية الأعمال - بلوك B,ديرة",
    "phone": "97142280050",
    "email": "aisha@aishalawyers.com",
    "registrationNumber": "ADF-2015-341"
  },
  {
    "id": "2ba14bc2-2913-4786-a320-b15dfea056e2",
    "slug": "abdalla-al-yassi-advocates-and-legal-consultancy",
    "name": "HAMDAN SULAIMAN SALIM ALMAAZMI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "01/29/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDALLA AL YASSI ADVOCATES AND LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2ba14bc2-2913-4786-a320-b15dfea056e2",
        "address": "",
        "phone": "97140000000 / 971507448882",
        "email": "a.alyassi@alyassi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "-",
    "address": "Deira - Al Maktoum Street - Al Ghanim 3 - Riggat Al Bateen Plaza Building - Office No. 706, Makani No: 3092994922",
    "phone": "97140000000",
    "email": "a.alyassi@alyassi.com",
    "registrationNumber": "-"
  },
  {
    "id": "45b62390-1485-4ade-802f-2848c7b2451b",
    "slug": "abdalla-almazrooqi-advocates-legal-consultants",
    "name": "ABDALLA ALMAZROOQI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/14/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/13/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDALLA ALMAZROOQI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_45b62390-1485-4ade-802f-2848c7b2451b",
        "address": "Abdalla Saleh Almarzooqi ,4th ,   Business Avenue 515 ,Dubai Airport ,111107 ,Dubai",
        "phone": "97145750781 / 971504108014",
        "email": "abdallaalmarzooqi@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Abdalla Saleh Mohammed Abdulwahed Almarzooqi",
    "address": "4th,   Business Avenue 515, Sheikh Rashid RD",
    "phone": "97145750781",
    "email": "abdallaalmarzooqi@hotmail.com",
    "registrationNumber": "ADF-2020-519"
  },
  {
    "id": "927c60c9-145e-4bb5-8913-d6d6aa72f891",
    "slug": "abdalla-alnakhi-advocates-legal-consultants",
    "name": "SAIF ALSHAMSI ADVOCATES AND LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "08/25/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDALLA ALNAKHI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_927c60c9-145e-4bb5-8913-d6d6aa72f891",
        "address": "mohamed mahmoud mohamed elkormany ,بناية الوصل ,R549 يناية الوصل ,سيتي سنتر ديره ,83620 ,Dubai",
        "phone": "97142542000",
        "email": "info@aaalegalconsultants.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "-",
    "address": "Office No. 532, 5TH Level, Business Village Tower, Port Saeed, Deira, Makani No. 3141894477",
    "phone": "97142542000",
    "email": "info@aaalegalconsultants.ae",
    "registrationNumber": "-"
  },
  {
    "id": "83647634-f0b7-4ccb-b71c-6d00bfdb84de",
    "slug": "abdalla-alowais-advocates-and-legal-consultants",
    "name": "ABDALLA ALOWAIS ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/12/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/11/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDALLA ALOWAIS ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_83647634-f0b7-4ccb-b71c-6d00bfdb84de",
        "address": "702-703 ,THE EXCHANGE TOWER ,NEAR IN BUSINESS BAY METRO STATION ,90009 ,Dubai",
        "phone": "97142327888",
        "email": "info@alowaislaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "702-703,THE EXCHANGE TOWER,BUSINESS BAY,Dubai",
    "phone": "97142327888",
    "email": "yasser@alowaislaw.com",
    "registrationNumber": "ADF-2012-247"
  },
  {
    "id": "3ab5acef-85ac-482b-91f2-4e0a34fd6af7",
    "slug": "abdelaziz-al-bloushi-advocates-legal-consultants",
    "name": "ABDELAZIZ AL BLOUSHI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/16/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDELAZIZ AL BLOUSHI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3ab5acef-85ac-482b-91f2-4e0a34fd6af7",
        "address": "",
        "phone": "97142396646",
        "email": "advo_alblooshi@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "ABDELAZIZ ABDULLA YOUSIF MOHAMED AL BLOUSHI",
    "address": "N/A",
    "phone": "97142396646",
    "email": "advo_alblooshi@yahoo.com",
    "registrationNumber": "ADF-2021-578"
  },
  {
    "id": "73e54a15-f797-4e91-a501-ef988d8f8bf8",
    "slug": "abdelaziz-al-khamiri-advocates-legal-consultants",
    "name": "ABDELAZIZ AL KHAMIRI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/10/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/09/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDELAZIZ AL KHAMIRI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_73e54a15-f797-4e91-a501-ef988d8f8bf8",
        "address": "ABDELAZIZ MOHAMED ABDELGHANI AL KHAMIRI AL ALI ,3 ,DUBAI SUPREME COURT COMPLEX ,DUBAI COURT ,128334 ,Dubai",
        "phone": "97145519341 / 971505788557",
        "email": "info@raalc.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Abdelaziz Mohamed Abdelghani Ali Alkhamiri Alali",
    "address": "312,dubai supreme court complex,alriyadh,Duba",
    "phone": "97145519341",
    "email": "info@raalc.ae",
    "registrationNumber": "ADF-2020-498"
  },
  {
    "id": "e0e3b92e-72b4-41ed-8cc0-7280ac4233dd",
    "slug": "abdelaziz-al-zaabi-advocates-legal-consultants",
    "name": "ABDELAZIZ AL ZAABI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/23/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "02/22/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDELAZIZ AL ZAABI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e0e3b92e-72b4-41ed-8cc0-7280ac4233dd",
        "address": "طابق الميزانين ، مكتب M05 ,ملتقى الأعمال (بناية تسهيل) ,خلف نادي النصر الرياضي ,414121 ,Dubai",
        "phone": "97143888252",
        "email": "alzaabiadvo8@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Abdelaziz Mohamed A.Binkhalfan Alzaabi",
    "address": "طابق الميزانين ، مكتب M05,ملتقى الأعمال (بناي",
    "phone": "97143888252",
    "email": "alzaabiadvo8@gmail.com",
    "registrationNumber": "ADF-2015-337"
  },
  {
    "id": "eb84bd6d-a78c-4fd6-8f46-4fab8eea60b5",
    "slug": "abdelaziz-alhanaee-advocates-legal-consultancy",
    "name": "ABDELAZIZ ALHANAEE ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/13/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "08/12/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDELAZIZ ALHANAEE ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_eb84bd6d-a78c-4fd6-8f46-4fab8eea60b5",
        "address": "",
        "phone": "97143316868 / 971561446981",
        "email": "info@alhanaee.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Abdel Aziz Khalifa Masoud Shaikhan Al Hanaee",
    "address": "N/A",
    "phone": "97143316868",
    "email": "info@alhanaee.com",
    "registrationNumber": "ADF-2012-238"
  },
  {
    "id": "e04d8a88-3378-40c8-a33a-b5e26a0c8507",
    "slug": "abdelrahman-al-maazmi-advocates-legal-consultants",
    "name": "ABDELRAHMAN AL MAAZMI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/05/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "02/04/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDELRAHMAN AL MAAZMI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e04d8a88-3378-40c8-a33a-b5e26a0c8507",
        "address": "",
        "phone": "97142552220",
        "email": "almaazmi.office@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Abdelrahman Mohamamed Murad Abdelrahman",
    "address": "N/A",
    "phone": "97142552220",
    "email": "almaazmi.office@gmail.com",
    "registrationNumber": "ADF-2013-269"
  },
  {
    "id": "f53e2f02-5ed9-4762-aa43-0f59c198e69a",
    "slug": "abdul-hadi-jasim-al-hammadi-advocates-legal-consultants",
    "name": "ABDUL HADI JASIM AL HAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/22/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "08/21/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDUL HADI JASIM AL HAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f53e2f02-5ed9-4762-aa43-0f59c198e69a",
        "address": "Office 214 ,Dubai Autism Center ,Makani No: 3349592541 ,000 ,Dubai",
        "phone": "97100000000 / 971503377345",
        "email": "abd3377345@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Abdelhadi Jasim Mohamed Abdalla Alhammadi",
    "address": "Office 214,Dubai Autism Center,Garhoud,Dubai,",
    "phone": "97100000000",
    "email": "abd3377345@gmail.com",
    "registrationNumber": "ADF-2023-691"
  },
  {
    "id": "d9e56be7-6c69-408a-9a66-04ced959910a",
    "slug": "abdul-rahman-al-motawa-advocates-legal-consultants",
    "name": "ABDUL RAHMAN AL MOTAWA ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFSCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/21/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/20/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDUL RAHMAN AL MOTAWA ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d9e56be7-6c69-408a-9a66-04ced959910a",
        "address": "",
        "phone": "97142664424",
        "email": "nagm009@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Abdulrahman Hassan Mohammad Al Mutawa",
    "address": "N/A",
    "phone": "97142664424",
    "email": "nagm009@yahoo.com",
    "registrationNumber": "ADF-2012-126"
  },
  {
    "id": "867bd7af-cc46-48b7-a06b-d9d319725a02",
    "slug": "abdul-rahman-lootah-associates-advocates-legal-consultancy",
    "name": "ABDUL RAHMAN LOOTAH & ASSOCIATES ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFSCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/15/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "12/14/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDUL RAHMAN LOOTAH & ASSOCIATES ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_867bd7af-cc46-48b7-a06b-d9d319725a02",
        "address": "",
        "phone": "97142944111",
        "email": "info@lootahlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Badreya Mohammed Malik Alblooshi",
    "address": "N/A",
    "phone": "97142944111",
    "email": "info@lootahlaw.ae",
    "registrationNumber": "ADF-2011-68"
  },
  {
    "id": "e6573267-5872-48d8-add1-06a3deccf9e4",
    "slug": "abdul-rahman-naseeb-advocates-legal-consultants",
    "name": "HANAN SALEM ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFSCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "04/08/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDUL RAHMAN NASEEB ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e6573267-5872-48d8-add1-06a3deccf9e4",
        "address": "",
        "phone": "97144472020",
        "email": "info@arnadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "-",
    "address": "Office No. (1202& 1203), Level 12, M M Towers Building , Al Maktoum Street, Deira,",
    "phone": "97144472020",
    "email": "info@arnadvocates.com",
    "registrationNumber": "-"
  },
  {
    "id": "9257678d-4d2f-46be-8660-57f1b1acddc0",
    "slug": "abdulbaset-abdulla-aljneibi-advocates-legal-consultants",
    "name": "ABDULBASET ABDULLA ALJNEIBI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/13/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "02/12/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDULBASET ABDULLA ALJNEIBI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9257678d-4d2f-46be-8660-57f1b1acddc0",
        "address": "",
        "phone": "97143240008 / 971555573999",
        "email": "info@asolutions.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Abdulbaset Abdulla Hamad Yousef Aljneibi",
    "address": "N/A",
    "phone": "97143240008",
    "email": "info@asolutions.ae",
    "registrationNumber": "ADF-2025-760"
  },
  {
    "id": "4e2e2375-ce6e-4d10-936d-68285844f2c0",
    "slug": "abdulhakim-binherz-advocates-legal-consultants",
    "name": "ABDULHAKIM BINHERZ ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFCCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/13/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/12/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDULHAKIM BINHERZ ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4e2e2375-ce6e-4d10-936d-68285844f2c0",
        "address": "Abdulhakim Habib Mansoor Binherz  ,38 ,Latifa Tower  , Crowne Plaza Hotel ,97598 ,Dubai",
        "phone": "97102544490",
        "email": "litigation@binherzadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Abdulhakim Habib Mansoor Binherz",
    "address": "38,Latifa Tower ,Sheikh Zayed Road ,Dubai,975",
    "phone": "97102544490",
    "email": "litigation@binherzadvocates.ae",
    "registrationNumber": "ADF-2014-313"
  },
  {
    "id": "aa38fc5e-9318-46e5-aaeb-e64f98419097",
    "slug": "abdulhameed-aljasmi-advocates-and-legal-consultants",
    "name": "ABDULHAMEED ALJASMI ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/20/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/19/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDULHAMEED ALJASMI ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_aa38fc5e-9318-46e5-aaeb-e64f98419097",
        "address": "",
        "phone": "97142251011",
        "email": "info@ajlc.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97142251011",
    "email": "info@ajlc.ae",
    "registrationNumber": "ADF-2016-394"
  },
  {
    "id": "afd89d37-3e2e-4b36-b832-8f5d3b8ee42d",
    "slug": "abdulhamid-yousuf-albalooshi-advocates-legal-consultants",
    "name": "ABDULHAMID YOUSUF ALBALOOSHI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFZCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/22/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/21/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDULHAMID YOUSUF ALBALOOSHI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_afd89d37-3e2e-4b36-b832-8f5d3b8ee42d",
        "address": "Zahraa ALSaedi ,Floor 14 - Offices No.1401,1402,1404 ,Aspin Commercial Tower  ,Shangri-La Hotel ,62999 ,Dubai",
        "phone": "97142224460 / 97142224460",
        "email": "info@dubailawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Abdulhamid Ghuloom Murad Yousuf Saleh Albalooshi",
    "address": "Floor 14 - Offices No.1401,1402,1404,Aspin Co",
    "phone": "97142224460",
    "email": "info@dubailawfirm.ae",
    "registrationNumber": "ADF-2019-479"
  },
  {
    "id": "a65968c3-f5c5-4cf1-89eb-1704f1c99056",
    "slug": "abdulla-al-ali-associates-advocates-legal-consultants",
    "name": "PRESTIGE ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "02/06/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDULLA AL - ALI & ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a65968c3-f5c5-4cf1-89eb-1704f1c99056",
        "address": "",
        "phone": "97142959933",
        "email": "alaliadv@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "-",
    "address": "Office No. R03-R04, Al Saffa First, Sheikh Zayed Road , Building MSM 1, P.O. Box. 62639, Dubai",
    "phone": "97142959933",
    "email": "alaliadv@emirates.net.ae",
    "registrationNumber": "-"
  },
  {
    "id": "5075821f-98f5-4546-8fcd-6cdc74967dac",
    "slug": "abdulla-al-awadi-advocates-legal-consultants",
    "name": "ABDULLA AL AWADI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/05/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/04/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDULLA AL AWADI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5075821f-98f5-4546-8fcd-6cdc74967dac",
        "address": "Advo. Abdulla Al Awadi ,العاشر  ,برايم تاور  ,فندق فيدا ,26665 ,Dubai",
        "phone": "97143352200",
        "email": "info@abdullaalawadi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Abdulla Mohammed Haji Al Awadi",
    "address": "العاشر ,برايم تاور ,شارع برج خليفة - بيزنس با",
    "phone": "97143352200",
    "email": "info@abdullaalawadi.com",
    "registrationNumber": "ADF-2012-112"
  },
  {
    "id": "7d47fa75-0239-4031-a3a5-d132d2fa393b",
    "slug": "abdulla-al-haddad-advocates-and-legal-consultants",
    "name": "ABDULLA AL HADDAD ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/30/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/29/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDULLA AL HADDAD ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7d47fa75-0239-4031-a3a5-d132d2fa393b",
        "address": "الطابق الثالث ,مجمع المحكمة العليا دبي ,مجمع المحكمة العليا دبي ,45556 ,Dubai",
        "phone": "97145570632 / 971503977375",
        "email": "rasmi@aahadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Abdulla Ahmad Abdulaziz Qassim Al Haddad",
    "address": "الطابق الثالث,مجمع المحكمة العليا دبي,أم هرير",
    "phone": "97145570632",
    "email": "rasmi@aahadvocates.ae",
    "registrationNumber": "ADF-2022-627"
  },
  {
    "id": "4f9219c1-5db2-45f9-bc5b-838c784a6216",
    "slug": "abdulla-al-mansoori-advocates-legal-consultants",
    "name": "ABDULLA AL MANSOORI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/22/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/21/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDULLA AL MANSOORI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4f9219c1-5db2-45f9-bc5b-838c784a6216",
        "address": "abdulla al mansoori ,الطابق السابع  ,الغزال ستاندرد  ,مول الغزال ,393164 ,Dubai",
        "phone": "97145531403 / 971569305848",
        "email": "info@abmadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "الطابق السابع ,الغزال ستاندرد ,البدع ,Dubai,3",
    "phone": "97145531403",
    "email": "info@abmadvocates.ae",
    "registrationNumber": "ADF-2014-326"
  },
  {
    "id": "6ba19c75-28b1-4ab5-a6e7-2cf619cceeaa",
    "slug": "abdulla-al-raeesi-advocates-legal-consultants",
    "name": "ABDULLA AL RAEESI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/06/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/05/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDULLA AL RAEESI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6ba19c75-28b1-4ab5-a6e7-2cf619cceeaa",
        "address": "Office No.B3604 ,Latifa tower  ,Sheikh zayed rd ,895 ,Dubai",
        "phone": "97100000000 / 971000000000",
        "email": "alraeesi@aradvoc.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Abdulla Adam Mohammed Al Raisi",
    "address": "Office No.B3604,Latifa tower ,Sheikh Zayed ro",
    "phone": "97100000000",
    "email": "alraeesi@aradvoc.com",
    "registrationNumber": "ADF-2023-705"
  },
  {
    "id": "525230a9-87e0-4951-b745-c8d2a983cf8e",
    "slug": "abdulla-al-suwaidi-advocates-legal-consultant",
    "name": "ABDULLA AL SUWAIDI ADVOCATES & LEGAL CONSULTANT",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/09/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "12/08/2025 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDULLA AL SUWAIDI ADVOCATES & LEGAL CONSULTANT",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_525230a9-87e0-4951-b745-c8d2a983cf8e",
        "address": "بلوك بي  ,R338 ,بجانب بناية سيتي بنك - بجوار مركز وافي  ,0554060326 ,Dubai",
        "phone": "97143337444",
        "email": "info@alsuwaidi-advo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Abdulla Ali Abdulwahab Abdulla Alsuwidi",
    "address": "بلوك بي ,R338,شارع الشيخ راشد - ام هرير 2 - ب",
    "phone": "97143337444",
    "email": "info@alsuwaidi-advo.com",
    "registrationNumber": "ADF-2014-331"
  },
  {
    "id": "da078082-58a6-4951-b43c-9a5a9bf24934",
    "slug": "abdulla-al-zarooni-advocates-legal-consultants",
    "name": "ABDULLA AL ZAROONI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/06/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/05/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDULLA AL ZAROONI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_da078082-58a6-4951-b43c-9a5a9bf24934",
        "address": "ABDULLAH AMIN ALZAROONI ,209+210+611+211 ,بزنس افينيو ,خلف وكالة النيسان ,12781 ,Dubai",
        "phone": "97142954299",
        "email": "zaroonilawyers@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "209+210+611+211,بزنس افينيو,بورسعيد - الخبيصى",
    "phone": "97142954299",
    "email": "zaroonilawyers@yahoo.com",
    "registrationNumber": "ADF-2012-164"
  },
  {
    "id": "f52d0783-6392-4dc6-8bba-a330837691af",
    "slug": "abdulla-ali-aljnaibi-advocates-legal-consultants",
    "name": "ABDULLA ALI ALJNAIBI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/03/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2024-02-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDULLA ALI ALJNAIBI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f52d0783-6392-4dc6-8bba-a330837691af",
        "address": "",
        "phone": "",
        "email": "admin@aljunaibi-advocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "N/A",
    "email": "admin@aljunaibi-advocates.ae",
    "registrationNumber": "ADF-2023-699"
  },
  {
    "id": "05d59198-4e23-4b78-bb9b-d55bfcd69060",
    "slug": "abdulla-alkaabi-advocates-legal-consultants",
    "name": "ABDULLA ALKAABI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/23/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/22/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDULLA ALKAABI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_05d59198-4e23-4b78-bb9b-d55bfcd69060",
        "address": "abdulla nasser mansour hamad alkaabi ,life pharmacy ,al safa ,millennium plaza hotel ,113713 ,Dubai",
        "phone": "97143598998",
        "email": "advo.akd@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "ABDULLA NASSER MANSOUR HAMAD AL KAABI",
    "address": "life pharmacy,al safa,sheikh zayed road,Dubai",
    "phone": "97143598998",
    "email": "advo.akd@gmail.com",
    "registrationNumber": "ADF-2015-367"
  },
  {
    "id": "d509f1aa-3c88-499b-8ad7-0ac050a88123",
    "slug": "abdulla-alnajjar-advocates-legal-consultants",
    "name": "ABDULLA ALNAJJAR ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/12/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/11/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDULLA ALNAJJAR ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d509f1aa-3c88-499b-8ad7-0ac050a88123",
        "address": "31/3107 ,ابراج لطيفة ,بنك الكويت الوطني ,442 ,Dubai",
        "phone": "97197143706 / 971558775654",
        "email": "alnajjar_ab@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Abdulla Yousuf Mirza Ali Hassan Alnajjar",
    "address": "31/3107,ابراج لطيفة,شارع الشيخ زايد,Dubai,442",
    "phone": "97197143706",
    "email": "alnajjar_ab@hotmail.com",
    "registrationNumber": "ADF-2019-488"
  },
  {
    "id": "608b7768-a584-45d4-beb5-e67ccb685c53",
    "slug": "abdulla-alnuaimi-advocates-legal-consultants",
    "name": "ABDULLA ALNUAIMI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/30/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/29/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDULLA ALNUAIMI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_608b7768-a584-45d4-beb5-e67ccb685c53",
        "address": "",
        "phone": "97142200065",
        "email": "Abdulla-Alnuaimi-legal@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Abdulla Mohammed Salem Hmouda Alnuaimi",
    "address": "N/A",
    "phone": "97142200065",
    "email": "Abdulla-Alnuaimi-legal@outlook.com",
    "registrationNumber": "ADF-2022-610"
  },
  {
    "id": "ad6c697f-ac72-4c32-a757-7cd13a6fcd3f",
    "slug": "abdulla-alobeidli-advocates-legal-consultants",
    "name": "ABDULLA ALOBEIDLI ADVOCATES &LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/22/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDULLA ALOBEIDLI ADVOCATES &LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ad6c697f-ac72-4c32-a757-7cd13a6fcd3f",
        "address": "",
        "phone": "97142775444 / 971507886668",
        "email": "info@abdlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Abdulla Ali Mohamed Ahmed Alobeidli",
    "address": "N/A",
    "phone": "97142775444",
    "email": "info@abdlaw.ae",
    "registrationNumber": "ADF-2021-580"
  },
  {
    "id": "c0d5ee8d-2020-4bd5-8b4f-efe6ea0f4acc",
    "slug": "abdulla-alomran-advocates-legal-consultants",
    "name": "ABDULLA ALOMRAN ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/26/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/25/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDULLA ALOMRAN ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c0d5ee8d-2020-4bd5-8b4f-efe6ea0f4acc",
        "address": "",
        "phone": "97143528314",
        "email": "alomran.advocates@alaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Abdulla Mohamed Abdulla Alomran Alshamsi",
    "address": "N/A",
    "phone": "97143528314",
    "email": "alomran.law@gmail.com",
    "registrationNumber": "ADF-2013-289"
  },
  {
    "id": "9a3c6439-8f4f-47b9-a3e6-6c7d15cb891f",
    "slug": "abdulla-alqadi-advocates-and-legal-consultants",
    "name": "ABDULLA ALQADI ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/07/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "08/06/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDULLA ALQADI ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9a3c6439-8f4f-47b9-a3e6-6c7d15cb891f",
        "address": "",
        "phone": "/ 971506278383",
        "email": "alqadi1974@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "abdulla mohamed abdulla sulaiman alqadi",
    "address": "N/A",
    "phone": "N/A",
    "email": "alqadi1974@yahoo.com",
    "registrationNumber": "ADF-2024-737"
  },
  {
    "id": "076d7792-b703-42a1-b104-c37dc1a5f37c",
    "slug": "abdulla-binhamad-almheiri-advocates-and-legal-consultants",
    "name": "ABDULLA BINHAMAD ALMHEIRI ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFCCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/20/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "01/19/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDULLA BINHAMAD ALMHEIRI ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_076d7792-b703-42a1-b104-c37dc1a5f37c",
        "address": "",
        "phone": "97142944000 / 971501826000",
        "email": "info@binhamadlegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97142944000",
    "email": "info@binhamadlegal.com",
    "registrationNumber": "ADF-2021-541"
  },
  {
    "id": "19c9c654-e8a0-4ae8-b2e6-1f0b9dfac171",
    "slug": "abdulla-ebrahim-almansoori-lawyers-and-legal-consultants",
    "name": "ABDULLA EBRAHIM ALMANSOORI LAWYERS AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFFCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/08/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDULLA EBRAHIM ALMANSOORI LAWYERS AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_19c9c654-e8a0-4ae8-b2e6-1f0b9dfac171",
        "address": "",
        "phone": "97142343373 / 971507004104",
        "email": "almansoorilawyer@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97142343373",
    "email": "almansoorilawyer@hotmail.com",
    "registrationNumber": "ADF-2021-574"
  },
  {
    "id": "1f7b1225-9eb2-412b-9776-298c43ff6240",
    "slug": "abdulla-ebrahim-almulla-advocates-and-legal-consultants",
    "name": "ABDULLA EBRAHIM ALMULLA ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFFCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/25/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/24/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDULLA EBRAHIM ALMULLA ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1f7b1225-9eb2-412b-9776-298c43ff6240",
        "address": "",
        "phone": "97145571020",
        "email": "abdullaalmansoori80@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Abdulla Ebrahim Hasan Almulla Almansoori",
    "address": "N/A",
    "phone": "97145571020",
    "email": "abdullaalmansoori80@gmail.com",
    "registrationNumber": "ADF-2022-636"
  },
  {
    "id": "a687e1d2-fda1-4db2-9333-2407481ae527",
    "slug": "abdulla-haji-advocates-legal-consultants",
    "name": "SAEED ALBARQ ADVOCATE & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "11/26/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDULLA HAJI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a687e1d2-fda1-4db2-9333-2407481ae527",
        "address": "الطابق السادس  مكتب 602 ,المسعود ,دوار الساعة  ,97766 ,Dubai",
        "phone": "97142369336",
        "email": "ahlawyer20@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "-",
    "address": "Office No. 801, Level 8, Al Masaood Building, Airport Street, Port Saeed Area, Deira, P.O. Box 22334, Dubai",
    "phone": "97142369336",
    "email": "ahlawyer20@yahoo.com",
    "registrationNumber": "-"
  },
  {
    "id": "72fce5f8-422f-47e1-b013-84b844329982",
    "slug": "abdulla-matar-alfalasi-advocates-legal-consultants",
    "name": "ABDULLA MATAR ALFALASI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/28/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "07/27/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDULLA MATAR ALFALASI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_72fce5f8-422f-47e1-b013-84b844329982",
        "address": "الطابق 23 - مكتب رقم 2304 ,ايريس باي ,رقم مكاني: 2466086696 ,23328 ,Dubai",
        "phone": "97143250002 / 971508090162",
        "email": "aflawfirm@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Abdulla Matar Bakhit Khalfan Alfalasi",
    "address": "الطابق 23 - مكتب رقم 2304,ايريس باي,شارع المس",
    "phone": "97143250002",
    "email": "aflawfirm@hotmail.com",
    "registrationNumber": "ADF-2023-683"
  },
  {
    "id": "b52d5afe-29b2-4dff-8d38-ec0587312c64",
    "slug": "abdulla-mattar-al-zaabi-advocates-legal-consultants",
    "name": "ALAWADHI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "09/28/2025 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDULLA MATTAR AL ZAABI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b52d5afe-29b2-4dff-8d38-ec0587312c64",
        "address": "Abdullah Matar Al Zaabi ,1604 ,اكزيكتف باي  ,اكزيكتف باي ,0000 ,Dubai",
        "phone": "97143203616",
        "email": "advozaabi@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "-",
    "address": "Al Hathbour Building, Floor 111, Abu Hail, near Canadian Hospital / Abgar Grand Hotel, P.O. Box 96555",
    "phone": "97143203616",
    "email": "advozaabi@gmail.com",
    "registrationNumber": "-"
  },
  {
    "id": "833edb7f-7a70-4ab6-9838-4782eb1b4f8a",
    "slug": "abdulla-mohammed-rasoul-alharmoodi-advocates-legal-consultants",
    "name": "ABDULLA MOHAMMED RASOUL ALHARMOODI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/24/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "02/23/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDULLA MOHAMMED RASOUL ALHARMOODI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_833edb7f-7a70-4ab6-9838-4782eb1b4f8a",
        "address": "1 ,Crystal Tower ,Business Bay ,1859 ,Dubai",
        "phone": "97142956661",
        "email": "info@amrplc.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "1,Crystal Tower,Al Assaiyl street, Business B",
    "phone": "97142956661",
    "email": "info@amrplc.com",
    "registrationNumber": "ADF-2015-338"
  },
  {
    "id": "9367d5c4-b8c9-49a6-a229-7da2663c3957",
    "slug": "abdullah-hussain-advocates-legal-consultants",
    "name": "ABDULLAH HUSSAIN ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/19/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/18/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDULLAH HUSSAIN ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9367d5c4-b8c9-49a6-a229-7da2663c3957",
        "address": "",
        "phone": "97142512221",
        "email": "info@ahal-advocacy.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Abdulla Husain Bakhit Hudaijan",
    "address": "N/A",
    "phone": "97142512221",
    "email": "info@ahal-advocacy.com",
    "registrationNumber": "ADF-2013-288"
  },
  {
    "id": "85d9abe5-e426-495c-965e-7b1bbdb21e4c",
    "slug": "abdullatif-al-hammadi-advocates-and-legal-consultants",
    "name": "ABDULLATIF AL HAMMADI ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/11/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/10/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDULLATIF AL HAMMADI ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_85d9abe5-e426-495c-965e-7b1bbdb21e4c",
        "address": "ABDULLATIF ALHAMMADI ,1 ,ABDULLA KAMBER BUSINESS CENTRE , ABU BAKER AL SIDDIQUE METRO STATION ,202142 ,Dubai",
        "phone": "97143212266",
        "email": "alhammadi@alhammadilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Abdullatif Mohammed Abubaker A.Alhammadi",
    "address": "1,ABDULLA KAMBER BUSINESS CENTRE,HOR ALANZ,Du",
    "phone": "97143212266",
    "email": "alhammadi@alhammadilaw.com",
    "registrationNumber": "ADF-2012-137"
  },
  {
    "id": "06e43c95-38ec-43ea-aa9f-c2ca90c53cac",
    "slug": "abdullatif-aljassmi-advocates-and-legal-consultants",
    "name": "ABDULLATIF ALJASSMI ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/21/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "12/20/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDULLATIF ALJASSMI ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_06e43c95-38ec-43ea-aa9f-c2ca90c53cac",
        "address": "Abdullatif Aljassmi ,Floor No.23- Office No. 2309 ,Burlington Tower ,The Oberoi Dubai ,0000 ,Dubai",
        "phone": "97147700321 / 971506441515",
        "email": "info@aaljassmiadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Abdullatif Mohammed Saleh Abdulla Aljassmi",
    "address": "Floor No.23- Office No. 2309,Burlington Tower",
    "phone": "97147700321",
    "email": "info@aaljassmiadvocates.com",
    "registrationNumber": "ADF-2020-533"
  },
  {
    "id": "19925cdf-cf68-49a0-8196-3b36ace2acdb",
    "slug": "abdulljawad-alqasem-advocates-legal-consultants",
    "name": "ABDULLJAWAD ALQASEM ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/03/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/02/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDULLJAWAD ALQASEM ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_19925cdf-cf68-49a0-8196-3b36ace2acdb",
        "address": "",
        "phone": "97143304457",
        "email": "abduljawad@alqasemadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Jamal Ismail",
    "address": "N/A",
    "phone": "97143304457",
    "email": "abduljawad@alqasemadvocates.com",
    "registrationNumber": "ADF-2022-639"
  },
  {
    "id": "5714833f-5b48-477b-a556-efa3a779f522",
    "slug": "abdulmalik-associates-advocates-legal-consultants",
    "name": "ABDULMALIK & ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/05/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "07/04/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDULMALIK & ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5714833f-5b48-477b-a556-efa3a779f522",
        "address": "",
        "phone": "97142227008 / 971506245451",
        "email": "info@abdulmaliklaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Mohammed Abdulmalek Mustafa Ahli",
    "address": "N/A",
    "phone": "97142227008",
    "email": "info@abdulmaliklaw.ae",
    "registrationNumber": "ADF-2012-218"
  },
  {
    "id": "e49cde31-d86a-482d-a53c-b2eb1265fb1f",
    "slug": "abdulrahman-ahmed-advocates-legal-consultants",
    "name": "ABDULRAHMAN AHMED ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/16/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "07/15/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDULRAHMAN AHMED ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e49cde31-d86a-482d-a53c-b2eb1265fb1f",
        "address": "",
        "phone": "97148843777 / 971508825889",
        "email": "info@arlawyers.me",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "AbdulRahman Ahmed Abdullah Mohammed",
    "address": "N/A",
    "phone": "97148843777",
    "email": "info@arlawyers.me",
    "registrationNumber": "ADF-2020-503"
  },
  {
    "id": "bf13bfd5-9c31-447d-a1f6-1939ed8ab235",
    "slug": "abdulrahman-alameri-advocates-legal-consultants",
    "name": "ABDULRAHMAN ALAMERI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/31/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/30/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDULRAHMAN ALAMERI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bf13bfd5-9c31-447d-a1f6-1939ed8ab235",
        "address": "ABDULRAHMAN MOHAMED ALAAMRI ,306 ,ACICO BUISINESS PARK ,NISSAN SHOW ROOM ,33731 ,Dubai",
        "phone": "97148819818 / 971503933245",
        "email": "info@alaamri.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Abdulrahman Mohamed Eissa Al Naroi Alaamri",
    "address": "306,ACICO BUISINESS PARK,PORT SAIED,Dubai,337",
    "phone": "97148819818",
    "email": "info@alaamri.ae",
    "registrationNumber": "ADF-2019-478"
  },
  {
    "id": "9c0c6c1b-d946-4437-a37d-6b795f15818e",
    "slug": "abdulrazaq-marjan-advocates-and-legal-consultants",
    "name": "ABDULRAZAQ MARJAN ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/16/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/15/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDULRAZAQ MARJAN ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9c0c6c1b-d946-4437-a37d-6b795f15818e",
        "address": "",
        "phone": "97143218833 / 971506563555",
        "email": "abmarjanadv@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Abdulrazaq Marjan Mabrook Bilal",
    "address": "N/A",
    "phone": "97143218833",
    "email": "abmarjanadv@gmail.com",
    "registrationNumber": "ADF-2022-598"
  },
  {
    "id": "8fc61dff-5618-4cd0-91c2-617c55c9acda",
    "slug": "abdulrhman-alshaali-advocates-legal-consultants",
    "name": "ABDULRHMAN ALSHAALI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/01/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/31/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDULRHMAN ALSHAALI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8fc61dff-5618-4cd0-91c2-617c55c9acda",
        "address": "Abdulrahman Ali Alshaali  ,7 ,برج المسعود 2 ,معرض سيارات تويوتا - ديره ,00000 ,Dubai",
        "phone": "97143300780 / 971971454749",
        "email": "abdulrahman@alshaalilegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Abdulrahman Ali Hussain Mohammed Alshaali",
    "address": "7,برج المسعود 2,ديرة - بور سعيد ,Dubai,00000",
    "phone": "97143300780",
    "email": "abdulrahman@alshaalilegal.com",
    "registrationNumber": "ADF-2021-571"
  },
  {
    "id": "1bb062dc-0c34-48e7-ae21-6d47ad68302f",
    "slug": "abeer-musabbah-obaid-advocates-legal-consultants",
    "name": "ABEER MUSABBAH OBAID ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/17/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "01/16/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABEER MUSABBAH OBAID ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1bb062dc-0c34-48e7-ae21-6d47ad68302f",
        "address": "",
        "phone": "",
        "email": "info@abeeradvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "ABEER MUSABBAH OBAID SULAIMAN ALMEESHANI",
    "address": "N/A",
    "phone": "N/A",
    "email": "info@abeeradvocates.com",
    "registrationNumber": "ADF-2022-653"
  },
  {
    "id": "417f90a1-03be-4dab-8eea-1bba7e16f536",
    "slug": "abu-baker-salem-advocates-legal-consultants",
    "name": "ABU BAKER SALEM ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFCCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/05/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-04-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABU BAKER SALEM ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_417f90a1-03be-4dab-8eea-1bba7e16f536",
        "address": "6F 603, 605, 7F 704 ,Crystal Tower ,Dubai Mall ,117538 ,Dubai",
        "phone": "97146098700",
        "email": "pro@miolawfirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "6F 603, 605, 7F 704,Crystal Tower,Business Ba",
    "phone": "97146098700",
    "email": "pro@miolawfirm.com",
    "registrationNumber": "ADF-2012-75"
  },
  {
    "id": "0c25ab44-71a4-49f3-9d94-7b5a222500f2",
    "slug": "accord-international-advocates-legal-consultants",
    "name": "ACCORD INTERNATIONAL ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFJCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/15/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/14/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ACCORD INTERNATIONAL ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0c25ab44-71a4-49f3-9d94-7b5a222500f2",
        "address": "",
        "phone": "97143366080",
        "email": "info@accordlawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97143366080",
    "email": "info@accordlawyers.com",
    "registrationNumber": "ADF-2012-122"
  },
  {
    "id": "d0789ea6-22d2-4893-aa99-e55ff1b4473a",
    "slug": "adel-al-ghafri-advocates-legal-consultants",
    "name": "ADEL AL GHAFRI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/01/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "07/31/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ADEL AL GHAFRI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d0789ea6-22d2-4893-aa99-e55ff1b4473a",
        "address": "Adel Salem Abdulla Salem Alghafri ,16th floor, Office: 1602 ,Aspect Tower ,Bay Avenue Mall ,444470 ,Dubai",
        "phone": "97142807052 / 971555666589",
        "email": "info@adelalghafri.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Adel Salem Abdulla Salem Alghafri",
    "address": "16th floor, Office: 1602,Aspect Tower,Al Must",
    "phone": "97142807052",
    "email": "info@adelalghafri.ae",
    "registrationNumber": "ADF-2023-685"
  },
  {
    "id": "f570e356-e048-4da0-8823-0ef1ae1b6723",
    "slug": "adel-aljneibi-advocates-legal-consultancy",
    "name": "ADEL ALJNEIBI ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/16/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "08/15/2022 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ADEL ALJNEIBI ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f570e356-e048-4da0-8823-0ef1ae1b6723",
        "address": "Adel Abdulla Khamis Musallem Aljuneibi ,903 ,السركال 2 ,خلف البيت الاخضر بالقرب من معرض TOYOTA  الفطيم ,26620 ,Dubai",
        "phone": "97144523399 / 971504487844",
        "email": "aljneibimk@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Adel Abdulla Khamis Musallem Aljuneibi",
    "address": "903,السركال 2,ال مكتوم بور سعيد,Dubai,26620",
    "phone": "97144523399",
    "email": "aljneibimk@gmail.com",
    "registrationNumber": "ADF-2015-359"
  },
  {
    "id": "9ffb2fa6-afdb-42b7-aedd-65a84179cb43",
    "slug": "adil-almaamri-advocates-and-legal-consultants",
    "name": "ADIL ALMAAMRI ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/17/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "02/16/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ADIL ALMAAMRI ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9ffb2fa6-afdb-42b7-aedd-65a84179cb43",
        "address": "",
        "phone": "97143347598 / 971509571957",
        "email": "alitezanlawyers@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97143347598",
    "email": "alitezanlawyers@gmail.com",
    "registrationNumber": "ADF-2022-595"
  },
  {
    "id": "1e06cd20-952b-4e9c-a03f-71547dae8665",
    "slug": "adil-fakhir-advocates-legal-consultants",
    "name": "ADIL FAKHIR ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFGCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/21/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/20/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ADIL FAKHIR ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1e06cd20-952b-4e9c-a03f-71547dae8665",
        "address": "Adil Fakhir ,الطابق الخامس - 502 ,العويس ,خلف وكالة النيسان ,231211 ,Dubai",
        "phone": "97143232888",
        "email": "a.fakhir@adilfakhir.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "الطابق الخامس - 502,العويس,بورسعيد,Dubai,2312",
    "phone": "97143232888",
    "email": "a.fakhir@adilfakhir.com",
    "registrationNumber": "ADF-2017-418"
  },
  {
    "id": "b49edb5e-abf1-49fe-8f56-ded39a7348cc",
    "slug": "adnan-obaid-alshaali-advocates-legal-consultants",
    "name": "ADNAN OBAID ALSHAALI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFPCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/04/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/03/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ADNAN OBAID ALSHAALI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b49edb5e-abf1-49fe-8f56-ded39a7348cc",
        "address": "ADNAN OBAID ALSHAALI , Second floor - FLAT 201A ,Al Khaimah Building ,Al Ittihad Road, Deira ,238837 ,Dubai",
        "phone": "97142392332 / 971505544558",
        "email": "adnan@alshaali-advocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Adnan Obaid Mohammed Hussain Alshaali",
    "address": "Second floor - FLAT 201A,Al Khaimah Building",
    "phone": "97142392332",
    "email": "adnan@alshaali-advocates.com",
    "registrationNumber": "ADF-2015-364"
  },
  {
    "id": "0f4257b6-c2a1-4f9d-9998-ce8f5ea9f2a3",
    "slug": "afaf-marjan-advocates-legal-consultant",
    "name": "AFAF MARJAN ADVOCATES & LEGAL CONSULTANT",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/31/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/30/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AFAF MARJAN ADVOCATES & LEGAL CONSULTANT",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0f4257b6-c2a1-4f9d-9998-ce8f5ea9f2a3",
        "address": "AFAF MARJAN NASIB ,3 ,GULF TOWERS  ,DUBAI MUNICIPALITY ,35192 ,Dubai",
        "phone": "97143333929 / 97143333929",
        "email": "info@afafmarjan.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "3,GULF TOWERS ,UM HURAIR SECOND ,Dubai,35192",
    "phone": "97143333929",
    "email": "info@afafmarjan.ae",
    "registrationNumber": "ADF-2018-451"
  },
  {
    "id": "56af6f31-f5cd-419b-a092-a41cfdd84e52",
    "slug": "ahmad-abdulla-ahli-advocates-legal-consultants",
    "name": "AHMAD ABDULLA AHLI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/09/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/08/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AHMAD ABDULLA AHLI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_56af6f31-f5cd-419b-a092-a41cfdd84e52",
        "address": "",
        "phone": "97142244442",
        "email": "info@ahli-law.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97142244442",
    "email": "info@ahli-law.com",
    "registrationNumber": "ADF-2022-641"
  },
  {
    "id": "8076512e-bc04-491e-b324-0d1cb2c52193",
    "slug": "ahmad-anwahi-advocates-legal-consultancy",
    "name": "AHMAD ANWAHI ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/06/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "01/05/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AHMAD ANWAHI ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8076512e-bc04-491e-b324-0d1cb2c52193",
        "address": "الثانى ,امارة دبي - منطقه الوصل - مزايا سنتر - شارع الشيخ زايد - الطابق الثانى - مكتب 2005 و 2006 ,مزايا سنتر  ,68480 ,Dubai",
        "phone": "97145148870",
        "email": "info@anwahilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Ahmad Abdulla Mohammad Malik Anwahi",
    "address": "الثانى,امارة دبي - منطقه الوصل - مزايا سنتر -",
    "phone": "97145148870",
    "email": "info@anwahilaw.com",
    "registrationNumber": "ADF-2016-371"
  },
  {
    "id": "d8054ded-92b9-44bc-9ef2-6741d7d462b7",
    "slug": "ahmad-galadari-associates-advocates-legal-consultant",
    "name": "AHMAD GALADARI & ASSOCIATES ADVOCATES & LEGAL CONSULTANT",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFHCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/19/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/18/2022 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AHMAD GALADARI & ASSOCIATES ADVOCATES & LEGAL CONSULTANT",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d8054ded-92b9-44bc-9ef2-6741d7d462b7",
        "address": "AHMAD HASSAN IBRAIM GALADARI ,السابع  ,بناية مكاتب  ,وكالة نسيان للسيارات  ,99664 ,Dubai",
        "phone": "97142977884",
        "email": "mr.galadari@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "السابع ,بناية مكاتب ,بور سعيد ,Dubai,99664",
    "phone": "97142977884",
    "email": "mr.galadari@hotmail.com",
    "registrationNumber": "ADF-2012-145"
  },
  {
    "id": "5d109744-ba6c-40c9-8bf5-8f23cc33dc17",
    "slug": "ahmed-abdulrahman-alzarooni-advocates-legal-consultants",
    "name": "AHMED ABDULRAHMAN ALZAROONI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/03/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/02/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AHMED ABDULRAHMAN ALZAROONI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5d109744-ba6c-40c9-8bf5-8f23cc33dc17",
        "address": "Office No. 116 ,Makeen Building ,Makani No: 3312794001 ,000 ,Dubai",
        "phone": "97142558462 / 971506358668",
        "email": "ahmed_alzarooni@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Ahmed Abdulrahman Mohamed Alzarooni",
    "address": "Office No. 116,Makeen Building,Dubai Internat",
    "phone": "97142558462",
    "email": "ahmed_alzarooni@hotmail.com",
    "registrationNumber": "ADF-2024-732"
  },
  {
    "id": "982063ca-143c-4793-84a0-193c57c43740",
    "slug": "ahmed-al-ali-advocates-legal-consultancy",
    "name": "AHMED AL ALI ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/01/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "08/31/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AHMED AL ALI ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_982063ca-143c-4793-84a0-193c57c43740",
        "address": "",
        "phone": "/ 971000000000",
        "email": "ahmed.advo@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Ahmed Abdulla Mohammed Alattar al-ali",
    "address": "N/A",
    "phone": "N/A",
    "email": "ahmed.advo@hotmail.com",
    "registrationNumber": "ADF-2020-506"
  },
  {
    "id": "91d66bc6-9b89-4272-9d03-494aed8c3f9e",
    "slug": "ahmed-al-amiri-advocates-legal-consultancy",
    "name": "AHMED AL AMIRI ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/28/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "08/27/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AHMED AL AMIRI ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_91d66bc6-9b89-4272-9d03-494aed8c3f9e",
        "address": "العاشر ,المسعود ,بجوار معرض تويوتا ,20085 ,Dubai",
        "phone": "97142945554",
        "email": "ahmedalamiri_law@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Ahmad Ali Ibraheim Alameeri",
    "address": "العاشر,المسعود,شارع ال مكتوم - منطقة بورسعيد,",
    "phone": "97142945554",
    "email": "ahmedalamiri_law@hotmail.com",
    "registrationNumber": "ADF-2012-243"
  },
  {
    "id": "31ff4d2d-2472-462b-b78c-c6b4f099b603",
    "slug": "ahmed-al-raeesi-advocates-legal-consultants",
    "name": "AHMED AL RAEESI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/15/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/14/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AHMED AL RAEESI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_31ff4d2d-2472-462b-b78c-c6b4f099b603",
        "address": "Ahmed alraeesi  ,1303 ,Salmiya Tower ,Salmiya Tower ,00 ,Dubai",
        "phone": "97142222330 / 971502727580",
        "email": "admin@alraeesilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "1303,Salmiya Tower,Baniyas Road, Deira,Dubai,",
    "phone": "97142222330",
    "email": "admin@alraeesilaw.com",
    "registrationNumber": "ADF-2018-446"
  },
  {
    "id": "4a2de7d0-110d-4514-a3ea-9fa2d2b61618",
    "slug": "ahmed-alhamli-advocates-and-legal-consultants",
    "name": "AHMED ALHAMLI ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/02/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/01/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AHMED ALHAMLI ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4a2de7d0-110d-4514-a3ea-9fa2d2b61618",
        "address": "",
        "phone": "97142508799 / 971504748037",
        "email": "info@alhamlifirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97142508799",
    "email": "info@alhamlifirm.ae",
    "registrationNumber": "ADF-2020-523"
  },
  {
    "id": "3083f53b-2676-4d9b-81b3-86ac3e91fc28",
    "slug": "ahmed-almaazmi-advocates-and-legal-consultants",
    "name": "AHMED ALMAAZMI ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/28/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AHMED ALMAAZMI ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3083f53b-2676-4d9b-81b3-86ac3e91fc28",
        "address": "الاول 107 ,مجمع المحكمة العليا بدبي  ,محاكم دبي  ,56637 ,Dubai",
        "phone": "97142568008",
        "email": "info@almaazmi-law.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Ahmed Ali Saleh Nasir AlMaazmi",
    "address": "الاول 107,مجمع المحكمة العليا بدبي ,5 شارع ال",
    "phone": "97142568008",
    "email": "info@almaazmi-law.com",
    "registrationNumber": "ADF-2012-155"
  },
  {
    "id": "0f57dd9c-c65a-4c45-bd06-695ca9e13f69",
    "slug": "ahmed-almazrouei-advocates-legal-consultants",
    "name": "AHMED ALMAZROUEI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/16/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/15/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AHMED ALMAZROUEI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0f57dd9c-c65a-4c45-bd06-695ca9e13f69",
        "address": "الطابق العاشر - 1003 ,برج الريم ,خلف مقر اتصالات - ديرة ,64166 ,Dubai",
        "phone": "97143395953 / 971502110022",
        "email": "info@almazroueiadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "الطابق العاشر - 1003,برج الريم,شارع آل مكتوم",
    "phone": "97143395953",
    "email": "info@almazroueiadvocates.ae",
    "registrationNumber": "ADF-2018-461"
  },
  {
    "id": "47a484be-41d3-4e29-a5c3-ac1971bb44b0",
    "slug": "ahmed-alshaali-attorneys-at-law",
    "name": "AHMED ALSHAALI ATTORNEYS AT LAW",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/30/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AHMED ALSHAALI ATTORNEYS AT LAW",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_47a484be-41d3-4e29-a5c3-ac1971bb44b0",
        "address": "Office M21 ,Garhoud Business Center ,Near GG Ko Metro Station Makani No: 4002124052 ,000 ,Dubai",
        "phone": "97142527751 / 971567778217",
        "email": "alshaaliattorneys25@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Ahmed Ali Hussain Mohammed Al Shaali",
    "address": "Office M21,Garhoud Business Center,Garhoud,Du",
    "phone": "97142527751",
    "email": "alshaaliattorneys25@gmail.com",
    "registrationNumber": "ADF-2024-755"
  },
  {
    "id": "abaeef69-3741-441b-b7fa-26710741464e",
    "slug": "ahmed-alzarooni-advocates-legal-consultants",
    "name": "AHMED ALZAROONI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/23/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/22/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AHMED ALZAROONI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_abaeef69-3741-441b-b7fa-26710741464e",
        "address": "",
        "phone": "97143331110",
        "email": "info@azlegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Ahmed Ibrahim Abdulrahman Alzarooni",
    "address": "N/A",
    "phone": "97143331110",
    "email": "info@azlegal.ae",
    "registrationNumber": "ADF-2023-708"
  },
  {
    "id": "5b668acf-1fdb-4057-81f9-05d9aeb7aca9",
    "slug": "ahmed-bin-dhahi-advocates-legal-consultants",
    "name": "AHMED BIN DHAHI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFCCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/20/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/19/2025 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AHMED BIN DHAHI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5b668acf-1fdb-4057-81f9-05d9aeb7aca9",
        "address": "",
        "phone": "97143573330",
        "email": "admin@dhahiadvocate.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Ahmad Abdulla Dhahi Abdulla Albuamaim",
    "address": "N/A",
    "phone": "97143573330",
    "email": "admin@dhahiadvocate.com",
    "registrationNumber": "ADF-2011-53"
  },
  {
    "id": "842516a6-1ad5-4983-a200-988a79ca1193",
    "slug": "ahmed-eisa-advocates-legal-consultants",
    "name": "AHMED EISA ADVOCATES &LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFFCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/12/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "01/11/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AHMED EISA ADVOCATES &LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_842516a6-1ad5-4983-a200-988a79ca1193",
        "address": "Ahmed Eisa Mohammed Eisa  ,2nd floor- office 210  ,Al Khaima  ,Al Khabaisi Park ,14748 ,Dubai",
        "phone": "97197150649 / 971506496333",
        "email": "ahmedissaadvocates@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Ahmed Eisa Mohamed Eisa",
    "address": "2nd floor- office 210 ,Al Khaima ,Al Itihad R",
    "phone": "97197150649",
    "email": "ahmedissaadvocates@gmail.com",
    "registrationNumber": "ADF-2022-585"
  },
  {
    "id": "107faf6f-c31c-4e99-b96f-f36f9b8e35e9",
    "slug": "ahmed-german-advocates-legal-consultants",
    "name": "AHMED GERMAN ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFHCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/15/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AHMED GERMAN ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_107faf6f-c31c-4e99-b96f-f36f9b8e35e9",
        "address": "AHMAD GERMAN ,Frist Floor office 03 ,GARHOUD ,Makani Number 32607 94119 ,00 ,Dubai",
        "phone": "97140000000 / 971521477743",
        "email": "ahmadjarman2@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "Frist Floor office 03,GARHOUD,Al Garhoud Area",
    "phone": "97140000000",
    "email": "ahmadjarman2@gmail.com",
    "registrationNumber": "ADF-2021-576"
  },
  {
    "id": "6d921a3f-66d8-409c-82d0-47ea77e53617",
    "slug": "ahmed-hassan-almaazmi-advocates-legal-consultants",
    "name": "AHMED HASSAN ALMAAZMI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/31/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/30/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AHMED HASSAN ALMAAZMI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6d921a3f-66d8-409c-82d0-47ea77e53617",
        "address": "",
        "phone": "97142594601",
        "email": "info@almazmilawfirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Ahmad Hassan Mohammed Abdulla Almaazmi",
    "address": "N/A",
    "phone": "97142594601",
    "email": "info@almazmilawfirm.com",
    "registrationNumber": "ADF-2012-254"
  },
  {
    "id": "dbb4bc27-1ace-4e78-8ee2-db7bfd85e001",
    "slug": "ahmed-ibrahim-advocates-legal-consultants",
    "name": "AHMED IBRAHIM ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFJCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/22/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "07/21/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AHMED IBRAHIM ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dbb4bc27-1ace-4e78-8ee2-db7bfd85e001",
        "address": "4/406 ,Acico Business Park  ,Behind Nissan Showroom ,186344 ,Dubai",
        "phone": "97142989888 / 971505948989",
        "email": "AHMEDIBRAHIMLAW@GMAIL.COM",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Ahmed Ebrahim Ahmed Mohammed",
    "address": "4/406,Acico Business Park ,Deira/Port Saeed/D",
    "phone": "97142989888",
    "email": "AHMEDIBRAHIMLAW@GMAIL.COM",
    "registrationNumber": "ADF-2012-224"
  },
  {
    "id": "5cbbbc4c-2394-453c-819a-94b1d296a1e9",
    "slug": "ahmed-khamies-alzeyoudi-advocates-legal-consultants",
    "name": "AHMED KHAMIES ALZEYOUDI ADVOCATES &LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFLCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/11/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/10/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AHMED KHAMIES ALZEYOUDI ADVOCATES &LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5cbbbc4c-2394-453c-819a-94b1d296a1e9",
        "address": "",
        "phone": "97142212205 / 971558866989",
        "email": "info@akzlawfirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97142212205",
    "email": "info@akzlawfirm.com",
    "registrationNumber": "ADF-2021-565"
  },
  {
    "id": "4cb37c1d-1403-421d-bc15-9451cc629e9d",
    "slug": "ahmed-matar-al-mheiri-advocates-legal-consultancy",
    "name": "AHMED MATAR AL MHEIRI ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/14/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "01/13/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AHMED MATAR AL MHEIRI ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4cb37c1d-1403-421d-bc15-9451cc629e9d",
        "address": "Ahmed Mohammed Matar Matar Almheiri ,4 ,SOBHA SAPPHIRE ,Bussines Bay ,393294 ,Dubai",
        "phone": "97143387880 / 971506478881",
        "email": "almheiricourts@bridgelg.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Ahmed Mohammed Matar Matar Almheiri",
    "address": "4,SOBHA SAPPHIRE,Bussines Bay Street 2,Dubai,",
    "phone": "97143387880",
    "email": "almheiricourts@bridgelg.com",
    "registrationNumber": "ADF-2018-435"
  },
  {
    "id": "5e6872f8-1250-480b-86b9-25b02a58a971",
    "slug": "ahmed-mohamed-mobarak-advocates-legal-consultancy",
    "name": "AHMED MOHAMED MOBARAK ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/03/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/02/2019 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AHMED MOHAMED MOBARAK ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5e6872f8-1250-480b-86b9-25b02a58a971",
        "address": "",
        "phone": "97143333379",
        "email": "mubarak.legalfirm@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97143333379",
    "email": "mubarak.legalfirm@gmail.com",
    "registrationNumber": "ADF-2014-301"
  },
  {
    "id": "e3088c8b-a7dc-4f38-a04d-cb4c7d050ed9",
    "slug": "ahmed-mohammed-bashir-advocates-legal-consultants",
    "name": "AHMED MOHAMMED BASHIR ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/16/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/15/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AHMED MOHAMMED BASHIR ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e3088c8b-a7dc-4f38-a04d-cb4c7d050ed9",
        "address": "801/802 ,Park Place ,WTC ,384557 ,Dubai",
        "phone": "97143203999",
        "email": "info.dubai@alemlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Ahmed Mohammed Bashir Husain Alshaqfa",
    "address": "801/802,Park Place,Sheikh Zayed Road,Dubai,38",
    "phone": "97143203999",
    "email": "info.dubai@alemlaw.com",
    "registrationNumber": "ADF-2017-413"
  },
  {
    "id": "08cb3f04-3a05-4815-9f28-6aa33c4b63dd",
    "slug": "ahmed-ramadan-advocates-legal-consultants",
    "name": "AHMED RAMADAN ADVOCATES &LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFSCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/29/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "12/28/2025 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AHMED RAMADAN ADVOCATES &LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_08cb3f04-3a05-4815-9f28-6aa33c4b63dd",
        "address": "18 ,برج السلام ,سما تاور ,68068 ,Dubai",
        "phone": "97143519700 / 971507973939",
        "email": "info@ramadanlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "18,برج السلام,شارع الشيخ زايد,Dubai,68068",
    "phone": "97143519700",
    "email": "info@ramadanlaw.ae",
    "registrationNumber": "ADF-2021-582"
  },
  {
    "id": "41b50db5-21d7-4d6b-87f5-e6f70e54d8af",
    "slug": "aisha-al-mansoori-advocates-legal-consultancy",
    "name": "AISHA AL MANSOORI ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/18/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "02/17/2025 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AISHA AL MANSOORI ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_41b50db5-21d7-4d6b-87f5-e6f70e54d8af",
        "address": "Aisha Al Mansoori ,الطابق 3   - مكتب 303 ,برج بيناري ,دبي مول ,65452 ,Dubai",
        "phone": "97144058200 / 97144058200",
        "email": "aisha@aalmansoori.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "الطابق 3   - مكتب 303,برج بيناري,شارع الأبراج",
    "phone": "97144058200",
    "email": "aisha@aalmansoori.ae",
    "registrationNumber": "ADF-2019-470"
  },
  {
    "id": "fe265115-cd56-43ce-b8be-22056eb663f3",
    "slug": "aisha-ateeq-advocets-and-legal-consaltant",
    "name": "AISHA ATEEQ ADVOCETS AND LEGAL CONSALTANT",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/26/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "08/25/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AISHA ATEEQ ADVOCETS AND LEGAL CONSALTANT",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fe265115-cd56-43ce-b8be-22056eb663f3",
        "address": "",
        "phone": "97142515900 / 971509394393",
        "email": "mail@aaadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "AISHA ATEEQ ALI BILAL JOHAR",
    "address": "N/A",
    "phone": "97142515900",
    "email": "mail@aaadvocates.ae",
    "registrationNumber": "ADF-2012-241"
  },
  {
    "id": "f81e35e3-2b71-42e5-9587-c64764d2d4cf",
    "slug": "aishah-khalaf-almazrouei-advocates-legal-consultants",
    "name": "AISHAH KHALAF ALMAZROUEI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFLCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/02/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/01/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AISHAH KHALAF ALMAZROUEI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f81e35e3-2b71-42e5-9587-c64764d2d4cf",
        "address": "",
        "phone": "97142881170 / 971502080879",
        "email": "aka_lawyers@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Aishah khalaf obaid almazrouei",
    "address": "N/A",
    "phone": "97142881170",
    "email": "aka_lawyers@yahoo.com",
    "registrationNumber": "ADF-2024-740"
  },
  {
    "id": "15e908f0-9bde-4c5d-b1d8-f353f2e537d9",
    "slug": "al-ahli-advocates-legal-consultants",
    "name": "AL AHLI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/13/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "02/12/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL AHLI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_15e908f0-9bde-4c5d-b1d8-f353f2e537d9",
        "address": "",
        "phone": "97143352000",
        "email": "info@alahlialkhaja.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Emad Juma Husain Ali Ahli",
    "address": "N/A",
    "phone": "97143352000",
    "email": "info@alahlialkhaja.com",
    "registrationNumber": "ADF-2012-93"
  },
  {
    "id": "9a923766-1fd1-4e06-a871-89662120384e",
    "slug": "al-aidarous-advocates-and-legal-consultants",
    "name": "AL AIDAROUS ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/19/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "02/18/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL AIDAROUS ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9a923766-1fd1-4e06-a871-89662120384e",
        "address": "Gamal Yassein Abdalla ,الطابق 13  Floor No 13 ,بناية مركز ابروي (The Oberoi Center) ,فندق ابروي (The Oberoi Hotel) ,33299 ,Dubai",
        "phone": "97142828000",
        "email": "litigation@alaidarous.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Ali Mohammed Ali Al-Aidrous",
    "address": "الطابق 13  Floor No 13,بناية مركز ابروي (The",
    "phone": "97142828000",
    "email": "litigation@alaidarous.ae",
    "registrationNumber": "ADF-2012-97"
  },
  {
    "id": "a462d9d5-41a1-490a-b3a2-1aafb1963331",
    "slug": "al-bahar-associates-advocates-and-legal-consultancy",
    "name": "AL BAHAR & ASSOCIATES ADVOCATES AND LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFCCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/12/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/11/2024 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL BAHAR & ASSOCIATES ADVOCATES AND LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a462d9d5-41a1-490a-b3a2-1aafb1963331",
        "address": "Third Floor - Office 310 ,Oud Metha Offices ,DEWA ,49408 ,Dubai",
        "phone": "97143245444",
        "email": "bahradvt@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "Third Floor - Office 310,Oud Metha Offices,Ou",
    "phone": "97143245444",
    "email": "bahradvt@emirates.net.ae",
    "registrationNumber": "ADF-2012-139"
  },
  {
    "id": "cf14fc58-f25f-463d-b60f-bfe4a127da8b",
    "slug": "al-bannai-al-rashedan-advocates-legal-consultants",
    "name": "AL BANNAI & AL RASHEDAN ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFCCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/05/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/04/2027 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL BANNAI & AL RASHEDAN ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cf14fc58-f25f-463d-b60f-bfe4a127da8b",
        "address": "الطابق الخامس  ,القيادة ,مطار دبى رقم 2 ,13917 ,Dubai",
        "phone": "97142949003",
        "email": "info@brlegalese.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Ahmad Ali Redha Ebrahim Al Bannai",
    "address": "الطابق الخامس ,القيادة,الاتحاد,Dubai,13917",
    "phone": "97142949003",
    "email": "info@brlegalese.ae",
    "registrationNumber": "ADF-2012-109"
  },
  {
    "id": "7e820dd9-2748-4876-88db-ff7948542895",
    "slug": "al-bastaki-al-jasmi-advocates-legal-consultants",
    "name": "AL BASTAKI & Al JASMI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFCCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/08/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/07/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL BASTAKI & Al JASMI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7e820dd9-2748-4876-88db-ff7948542895",
        "address": "Bader Aljassmy ,3 ,دبي كوميرسيتي ,دبي كوميرسيتي ,410004 ,Dubai",
        "phone": "97148760777 / 971586842086",
        "email": "info@bajlegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Bader Abdulrahman Mohmmed Abdulrahim Al Jassmy",
    "address": "3,دبي كوميرسيتي,مبنى رقم 2 - الوحدة رقم Busin",
    "phone": "97148760777",
    "email": "info@bajlegal.com",
    "registrationNumber": "ADF-2020-511"
  },
  {
    "id": "0723aecf-8cde-4976-bd8d-dc29c3cac701",
    "slug": "al-bawardi-advocate-legal-consultants",
    "name": "AL BAWARDI ADVOCATE & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFCCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/20/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/19/2021 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL BAWARDI ADVOCATE & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0723aecf-8cde-4976-bd8d-dc29c3cac701",
        "address": "7th floor, 701 ,Al Khaleej Centre ,near Al Fahidi Metro Station ,5083 ,Dubai",
        "phone": "97143591115",
        "email": "jummaadv@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Juma Buti Juma Al-Bawardi",
    "address": "7th floor, 701,Al Khaleej Centre,Al Mankhool",
    "phone": "97143591115",
    "email": "jummaadv@emirates.net.ae",
    "registrationNumber": "ADF-2011-30"
  },
  {
    "id": "cf3c19c0-d396-4bcb-b1db-b81273ed0b4c",
    "slug": "al-dhaheri-international-advocates-legal-consultants",
    "name": "AL DHAHERI INTERNATIONAL ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFECiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/14/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/13/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL DHAHERI INTERNATIONAL ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cf3c19c0-d396-4bcb-b1db-b81273ed0b4c",
        "address": "4th Floor/ Office no. 401 ,Business Avenue  ,Infront- Terminal 2  ,115263 ,Dubai",
        "phone": "97144518866",
        "email": "info@aldhaheriinternational.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Ali Rashed Saeed Nasser Al Dhaheri",
    "address": "4th Floor/ Office no. 401,Business Avenue ,Sh",
    "phone": "97144518866",
    "email": "info@aldhaheriinternational.com",
    "registrationNumber": "ADF-2012-119"
  },
  {
    "id": "b137c424-599c-4988-9999-0de6f476dca5",
    "slug": "al-fadeela-advocates",
    "name": "AL FADEELA ADVOCATES",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFGCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/11/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/10/2018 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL FADEELA ADVOCATES",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b137c424-599c-4988-9999-0de6f476dca5",
        "address": "",
        "phone": "97142288824",
        "email": "alfad224@eim.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97142288824",
    "email": "alfad224@eim.ae",
    "registrationNumber": "ADF-2012-246"
  },
  {
    "id": "8f050b70-3ac6-4282-b9f7-ce19f14b4787",
    "slug": "al-fajer-advocate-legal-consultants",
    "name": "AL FAJER ADVOCATE & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFGCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/04/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/03/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL FAJER ADVOCATE & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8f050b70-3ac6-4282-b9f7-ce19f14b4787",
        "address": "ABDULKARIM MAKKI ,1605 ,Exchange Tower ,JW Marriott Marquis Hotel Dubai ,98777 ,Dubai",
        "phone": "97142406606",
        "email": "info@alfajeradvocate.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "1605,Exchange Tower,Business Bay / Al Saada S",
    "phone": "97142406606",
    "email": "info@alfajeradvocate.com",
    "registrationNumber": "ADF-2012-184"
  },
  {
    "id": "eb1babc3-0723-4d8e-a69c-728a5dcce69e",
    "slug": "al-falasi-advocates-legal-consultants",
    "name": "AL FALASI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFGCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/02/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "07/01/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL FALASI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_eb1babc3-0723-4d8e-a69c-728a5dcce69e",
        "address": "",
        "phone": "97143456345 / 971582878951",
        "email": "alfalasi_advocates@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Ali Saeed Essa Al Falasi",
    "address": "N/A",
    "phone": "97143456345",
    "email": "alfalasi_advocates@yahoo.com",
    "registrationNumber": "ADF-2012-212"
  },
  {
    "id": "d9edc27e-b886-4495-9c20-11ed3c12f407",
    "slug": "al-haddad-associates-advocates-legal-consultants",
    "name": "AL HADDAD & ASSOCIATES  ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/03/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/02/2025 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL HADDAD & ASSOCIATES  ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d9edc27e-b886-4495-9c20-11ed3c12f407",
        "address": "",
        "phone": "97143311224",
        "email": "info@alhaddadco.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Ali Sultan Ali Al-Haddad",
    "address": "N/A",
    "phone": "97143311224",
    "email": "info@alhaddadco.com",
    "registrationNumber": "ADF-2011-39"
  },
  {
    "id": "f091b928-9e3d-4e24-b489-65ca31481366",
    "slug": "al-hajeya-alnoobi-advocates-and-legal-consultant",
    "name": "AL HAJEYA ALNOOBI ADVOCATES AND LEGAL CONSULTANT",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/16/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/15/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL HAJEYA ALNOOBI ADVOCATES AND LEGAL CONSULTANT",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f091b928-9e3d-4e24-b489-65ca31481366",
        "address": "Alhajeya salem saeed alnoobi ,3rd  ,Al-hawai Tower  ,Behind financial center metro station  ,39779 ,Dubai",
        "phone": "97142963813",
        "email": "adv_aljazeera@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Al-Hajjiah Salem Saed Al Nobi",
    "address": "3rd ,Al-hawai Tower ,Sheikh zayed road / fina",
    "phone": "97142963813",
    "email": "adv_aljazeera@outlook.com",
    "registrationNumber": "ADF-2011-46"
  },
  {
    "id": "c063023c-8d6f-4566-8537-31e0c9977c77",
    "slug": "al-hosany-advocates-legal-consultancy",
    "name": "AL HOSANY ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/25/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/24/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL HOSANY ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c063023c-8d6f-4566-8537-31e0c9977c77",
        "address": "Noushad kn ,1 ,sama tower ,Chello Restaurant  ,87706 ,Dubai",
        "phone": "97142822744",
        "email": "info@hosanilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Khalaf Abdalla Malalla Al Hosany",
    "address": "1,sama tower,shk zayed road,Dubai,87706",
    "phone": "97142822744",
    "email": "info@hosanilaw.com",
    "registrationNumber": "ADF-2012-152"
  },
  {
    "id": "da82aaa3-2103-44dd-8c58-96cbf6efd6d0",
    "slug": "al-houby-advocate-legal-consultancy-office",
    "name": "AL HOUBY ADVOCATE & LEGAL CONSULTANCY OFFICE",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/30/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/29/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL HOUBY ADVOCATE & LEGAL CONSULTANCY OFFICE",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_da82aaa3-2103-44dd-8c58-96cbf6efd6d0",
        "address": "16 مكتب رقم 1606 ,ذا بريم تاور ,رقم مكاني 2583686879 ,13050 ,Dubai",
        "phone": "97142662233",
        "email": "info@houbylaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Shehdah Hassan Juma Al-Houby",
    "address": "16 مكتب رقم 1606,ذا بريم تاور,الخليج التجاري,",
    "phone": "97142662233",
    "email": "info@houbylaw.ae",
    "registrationNumber": "ADF-2012-180"
  },
  {
    "id": "617b9580-cff5-4ffa-b2bc-8788300a3c6e",
    "slug": "al-huqooq-for-advocacy-and-legal-consultancy",
    "name": "AL HUQOOQ FOR ADVOCACY AND LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/13/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/12/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL HUQOOQ FOR ADVOCACY AND LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_617b9580-cff5-4ffa-b2bc-8788300a3c6e",
        "address": "ABDULRAHMAN OMAR  ABDULLA MUKHAYER  ,NBK BANK ,LATIFA TOWER  ,NEAR CROWN PLAZA  ,185616 ,Dubai",
        "phone": "97143296968",
        "email": "hlp@hlplawfirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Abdulrahman Omar Abdulla Makhayar",
    "address": "NBK BANK,LATIFA TOWER ,TRADE CENTER FIRST ,Du",
    "phone": "97143296968",
    "email": "hlp@hlplawfirm.com",
    "registrationNumber": "ADF-2012-172"
  },
  {
    "id": "2176cd73-0d8d-41e1-9db6-ab2d6fa210b5",
    "slug": "al-insaf-advocates-and-legal-consultants",
    "name": "AL INSAF ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFJCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/28/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/27/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL INSAF ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2176cd73-0d8d-41e1-9db6-ab2d6fa210b5",
        "address": "",
        "phone": "97142515101",
        "email": "legal@alinsaf.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97142515101",
    "email": "legal@alinsaf.ae",
    "registrationNumber": "ADF-2011-58"
  },
  {
    "id": "f44b772a-3149-4fde-85f7-177a97847c52",
    "slug": "al-jabri-advocates-legal-consultants",
    "name": "AL JABRI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFKCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/01/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/30/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL JABRI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f44b772a-3149-4fde-85f7-177a97847c52",
        "address": "الميزانين - مكتب رقم 2  ,جسكوم جراند ريزيدنس  ,خلف المستشفي الكندي  ,12923 ,Dubai",
        "phone": "97142224668",
        "email": "aljabriadvocates@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "الميزانين - مكتب رقم 2 ,جسكوم جراند ريزيدنس ,",
    "phone": "97142224668",
    "email": "aljabriadvocates@yahoo.com",
    "registrationNumber": "ADF-2012-210"
  },
  {
    "id": "d54e2e1d-7afb-435d-ab9e-5301c7e17a1f",
    "slug": "al-jallaf-advocates-legal-consultants",
    "name": "AL JALLAF ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFKCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/04/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/03/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL JALLAF ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d54e2e1d-7afb-435d-ab9e-5301c7e17a1f",
        "address": "",
        "phone": "97143366260",
        "email": "mail@aljallaflegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Amna Khelfan Saleh Al-Jalaf",
    "address": "N/A",
    "phone": "97143366260",
    "email": "mail@aljallaflegal.com",
    "registrationNumber": "ADF-2011-18"
  },
  {
    "id": "403277a6-eef2-4cfd-af95-9959280d6b40",
    "slug": "al-kaitoob-advocates-legal-consultants",
    "name": "AL KAITOOB ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFLCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/15/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/14/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL KAITOOB ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_403277a6-eef2-4cfd-af95-9959280d6b40",
        "address": "khalid al kaitoob ,12 ,نسيمية تاور الطابق 12 1202 B ,فندق الفوكو  ,10755 ,Dubai",
        "phone": "97143586555",
        "email": "info@alkaitooblawyer.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Khalid Ahmad Ali Rashed Alkatitoob",
    "address": "12,نسيمية تاور الطابق 12 1202 B,شارع الشيخ زا",
    "phone": "97143586555",
    "email": "info@alkaitooblawyer.com",
    "registrationNumber": "ADF-2012-252"
  },
  {
    "id": "054f38f4-9e51-4623-ad36-7941043a051c",
    "slug": "al-kamali-company-advocates-and-legal-consultants",
    "name": "AL KAMALI & COMPANY ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFLCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/16/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/15/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL KAMALI & COMPANY ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_054f38f4-9e51-4623-ad36-7941043a051c",
        "address": "3-505 ,AL KHABEESI BLDG ,AL KABEESI ,4948 ,Dubai",
        "phone": "97142222228",
        "email": "info@alkamali.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "102,MAKTOUM ROAD BUILDING,MAKTOUM ROAD,Dubai,",
    "phone": "97142222228",
    "email": "info@alkamali.ae",
    "registrationNumber": "ADF-2011-44"
  },
  {
    "id": "2c26b6ea-311a-459a-aae1-8d9965fc9200",
    "slug": "al-khaleej-advocates-legal-consultants",
    "name": "AL KHALEEJ ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFLCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/07/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "02/06/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL KHALEEJ ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2c26b6ea-311a-459a-aae1-8d9965fc9200",
        "address": "2 ,B62 ,Clock Tower ,13903 ,Dubai",
        "phone": "97142288808",
        "email": "Lawfirm@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Abdulla Taleb Mohammed Ahmad",
    "address": "2,B62,Al Maktoum Street/Riggat Al Buteen/Deir",
    "phone": "97142288808",
    "email": "Lawfirm@emirates.net.ae",
    "registrationNumber": "ADF-2013-271"
  },
  {
    "id": "7076c088-41b3-40f1-872e-6df5351625da",
    "slug": "al-kumaiti-advocates",
    "name": "AL KUMAITI ADVOCATES",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFLCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/23/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/22/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL KUMAITI ADVOCATES",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7076c088-41b3-40f1-872e-6df5351625da",
        "address": "ABDULHAMEED ALI ALKUMITY ,الطابق الأول  ,BMTC ,معرض هيونداي للسيارات  ,33998 ,Dubai",
        "phone": "97142686855",
        "email": "info@alkumaitiadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Abdulhameed Ali Humaid Al Kumity",
    "address": "الطابق الأول ,BMTC,الخبيصي,Dubai,33998",
    "phone": "97142686855",
    "email": "info@alkumaitiadvocates.com",
    "registrationNumber": "ADF-2012-200"
  },
  {
    "id": "3aecd13e-7d3e-45ab-a8a3-b58a36ee77b3",
    "slug": "al-maarif-advocates-legal-consultants",
    "name": "AL MAARIF ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/10/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/09/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL MAARIF ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3aecd13e-7d3e-45ab-a8a3-b58a36ee77b3",
        "address": "",
        "phone": "97142229944",
        "email": "almaarif_law@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Arif Mohamed Khadim Salim Al Teraifi",
    "address": "N/A",
    "phone": "97142229944",
    "email": "almaarif_law@hotmail.com",
    "registrationNumber": "ADF-2012-189"
  },
  {
    "id": "77cfdeb0-2d07-462a-b700-a778b0ba393b",
    "slug": "al-madani-associates-advocates-legal-consultancy",
    "name": "AL MADANI & ASSOCIATES ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/09/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/08/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL MADANI & ASSOCIATES ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_77cfdeb0-2d07-462a-b700-a778b0ba393b",
        "address": "abdulla almadani ,6th Floor, Office No. 604 ,Dubai National Insurance Company ,Deira City Center ,80305 ,Dubai",
        "phone": "97143978578",
        "email": "almadanilawfirm@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "6th Floor, Office No. 604,Dubai National Insu",
    "phone": "97143978578",
    "email": "almadanilawfirm@gmail.com",
    "registrationNumber": "ADF-2012-169"
  },
  {
    "id": "2510dab9-717a-4a15-b189-4272261227e3",
    "slug": "al-madhani-al-shamsi-advocates-legal-consultants",
    "name": "AL MADHANI & AL SHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/05/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/04/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL MADHANI & AL SHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2510dab9-717a-4a15-b189-4272261227e3",
        "address": "",
        "phone": "97143298881",
        "email": "info@mslawuae.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Obaid Omran Ali Obaid Al shamsi",
    "address": "N/A",
    "phone": "97143298881",
    "email": "info@mslawuae.com",
    "registrationNumber": "ADF-2012-110"
  },
  {
    "id": "a48d1666-6ca7-461a-8197-a892ef0f3545",
    "slug": "al-maidoor-advocates-legal-consultants",
    "name": "AL MAIDOOR ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/01/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/31/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL MAIDOOR ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a48d1666-6ca7-461a-8197-a892ef0f3545",
        "address": "",
        "phone": "97143348481",
        "email": "lawyers@maidor.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Ahmad Alhaj Khadim Buti Al Maidoor Al Muhairi",
    "address": "N/A",
    "phone": "97143348481",
    "email": "lawyers@maidor.ae",
    "registrationNumber": "ADF-2011-37"
  },
  {
    "id": "fc5a1beb-1c2d-4f6e-b20d-7e80a8f75e91",
    "slug": "al-mashrq-international-advocates-legal-consultancy",
    "name": "AL MASHRQ INTERNATIONAL ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/19/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/18/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL MASHRQ INTERNATIONAL ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fc5a1beb-1c2d-4f6e-b20d-7e80a8f75e91",
        "address": "HAMAD BIN SALMEEN ,الثامن 801 ,برج برلنجتون ,محطة مترو الخليج التجاري ,97779 ,Dubai",
        "phone": "97142666699",
        "email": "almashreq@levarilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Hamad Ali Mohammad Bin Salmeen Al Suwaidi",
    "address": "الثامن 801,برج برلنجتون,شارع الابراج,Dubai,97",
    "phone": "97142666699",
    "email": "almashreq@levarilaw.com",
    "registrationNumber": "ADF-2012-148"
  },
  {
    "id": "4e22d3f8-438f-4c16-9a7f-91e6e29dc5f6",
    "slug": "al-matrooshi-advocates-and-legal-consultants",
    "name": "AL MATROOSHI ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/11/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/10/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL MATROOSHI ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4e22d3f8-438f-4c16-9a7f-91e6e29dc5f6",
        "address": "4TH FLOOR ,AL HARTHY ,DUBAI CUSTOMS ,34143 ,Dubai",
        "phone": "97143930039",
        "email": "admin@advocatesuae.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "4TH FLOOR,AL HARTHY,AL MINA ROAD,Dubai,34143",
    "phone": "97143930039",
    "email": "admin@advocatesuae.com",
    "registrationNumber": "ADF-2012-138"
  },
  {
    "id": "cf51873d-8fdb-48e8-b771-023c7e40ae1d",
    "slug": "al-menhali-advocates-legal-consultant",
    "name": "AL MENHALI ADVOCATES & LEGAL CONSULTANT",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/13/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/12/2018 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL MENHALI ADVOCATES & LEGAL CONSULTANT",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cf51873d-8fdb-48e8-b771-023c7e40ae1d",
        "address": "",
        "phone": "97142504080",
        "email": "alminhaliadv@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97142504080",
    "email": "alminhaliadv@gmail.com",
    "registrationNumber": "ADF-2011-40"
  },
  {
    "id": "fe9068a7-b94d-49bb-88b3-6f8491a15389",
    "slug": "al-midfa-associates",
    "name": "AL MIDFA & ASSOCIATES",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/25/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/24/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL MIDFA & ASSOCIATES",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fe9068a7-b94d-49bb-88b3-6f8491a15389",
        "address": "10th Floor ,AlReem Tower ,Dubai Land Department ,32367 ,Dubai",
        "phone": "97142272701",
        "email": "midfaadv@eim.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Sami Salim Mohammad Jasim Al Midfa",
    "address": "10th Floor,AlReem Tower,Al Maktoum Road/ Deir",
    "phone": "97142272701",
    "email": "midfaadv@eim.ae",
    "registrationNumber": "ADF-2012-154"
  },
  {
    "id": "806f31e8-0ed0-40a1-9d26-ef999012f7ed",
    "slug": "al-mudharreb-company-advocates-legal-consultants",
    "name": "AL MUDHARREB & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/15/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/14/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL MUDHARREB & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_806f31e8-0ed0-40a1-9d26-ef999012f7ed",
        "address": "الثاني ,الفجر للاعمال  ,مركز القرهود للياقة الطبية - مستشفى القرهود  ,15105 ,Dubai",
        "phone": "97142222800",
        "email": "info@almudharreb.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Abdulla Abdulrhman Abdulla Al Mudharreb",
    "address": "الثاني,الفجر للاعمال ,القرهود - شارع المطار ,",
    "phone": "97142222800",
    "email": "info@almudharreb.com",
    "registrationNumber": "ADF-2012-140"
  },
  {
    "id": "651d46a2-cdc6-4e8e-99ad-7ee0f3ddca7a",
    "slug": "al-muhamoon-al-arab-lawyer-legal-consultancy",
    "name": "AL MUHAMOON AL ARAB LAWYER & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/27/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/26/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL MUHAMOON AL ARAB LAWYER & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_651d46a2-cdc6-4e8e-99ad-7ee0f3ddca7a",
        "address": "",
        "phone": "97142736666",
        "email": "almohmon@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "NASSER ABDULLA HASSAN MOHAMMED MURSHED",
    "address": "N/A",
    "phone": "97142736666",
    "email": "almohmon@hotmail.com",
    "registrationNumber": "ADF-2011-56"
  },
  {
    "id": "83443142-de5a-4089-8798-9ed25b7885de",
    "slug": "al-nassar-advocates-legal-consultants",
    "name": "AL NASSAR ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFOCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/28/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/27/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL NASSAR ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_83443142-de5a-4089-8798-9ed25b7885de",
        "address": "HOSSAM GAMAL MOHAMED ELSOKARY ,26 ,Citadel tower ,Marasi Drive ,5586 ,Dubai",
        "phone": "97142555110",
        "email": "fetouh@alnassar.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Fetouh Yousef Mohammed Hussain Al-Nassar",
    "address": "26,Citadel tower,Business Bay, Citadel Tower,",
    "phone": "97142555110",
    "email": "fetouh@alnassar.ae",
    "registrationNumber": "ADF-2012-131"
  },
  {
    "id": "5e10a3c0-085d-4e92-84b1-ec3013bc4bae",
    "slug": "al-otaibi-advocates-legal-consultants",
    "name": "AL OTAIBI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFPCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/04/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/03/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL OTAIBI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5e10a3c0-085d-4e92-84b1-ec3013bc4bae",
        "address": "Ahmad Al Otaibi ,6th floor /606 ,Century 21 Tower ,Alqabayel Center ,126936 ,Dubai",
        "phone": "97142697670",
        "email": "info@otaibilc.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Ahmed Mahdi Fahad Badi Alataeibi",
    "address": "6th floor /606,Century 21 Tower,Abu Baker/ Al",
    "phone": "97142697670",
    "email": "info@otaibilc.com",
    "registrationNumber": "ADF-2014-312"
  },
  {
    "id": "da23f476-a80d-4d5a-b180-5dbd879b540e",
    "slug": "al-owais-advocates-legal-consultants",
    "name": "AL OWAIS ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFPCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/26/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/25/2025 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL OWAIS ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_da23f476-a80d-4d5a-b180-5dbd879b540e",
        "address": "Sultan Hadif Al Owais ,504 ,Oud Metha ,Wafi Mall ,16686 ,Dubai",
        "phone": "97105053953 / 971509793158",
        "email": "info@alowaislegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "504,Oud Metha,Um Huriar Second,Dubai,16686",
    "phone": "97105053953",
    "email": "info@alowaislegal.com",
    "registrationNumber": "ADF-2011-05"
  },
  {
    "id": "25d2c9bd-dbba-41ac-aff9-5ba0f37290d6",
    "slug": "al-qari-advocates-and-legal-consultants",
    "name": "AL QARI ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFRCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/25/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "07/24/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL QARI ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_25d2c9bd-dbba-41ac-aff9-5ba0f37290d6",
        "address": "الخامس  ,مكاتب عود ميثاء ,فندق رافلز ,11268 ,Dubai",
        "phone": "97143243330",
        "email": "avocat@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Naji Emile Boulos",
    "address": "الخامس ,مكاتب عود ميثاء,عود ميثاء,Dubai,11268",
    "phone": "97143243330",
    "email": "avocat@emirates.net.ae",
    "registrationNumber": "ADF-2012-227"
  },
  {
    "id": "d7e59e90-7dc8-4877-9c43-b3f1f8a52e72",
    "slug": "al-raya-advocates-legal-consultants",
    "name": "AL RAYA ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFSCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/04/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/03/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL RAYA ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d7e59e90-7dc8-4877-9c43-b3f1f8a52e72",
        "address": "saadaldain ,407 ,سيتي باي مركز الاعمال  ,المستشفي الكندي ,182435 ,Dubai",
        "phone": "97142280908",
        "email": "alraya990@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Saadaldin Jaffer Abdulla Al Noakhatha",
    "address": "407,سيتي باي مركز الاعمال ,ابو هيل,Dubai,1824",
    "phone": "97142280908",
    "email": "alraya990@gmail.com",
    "registrationNumber": "ADF-2012-108"
  },
  {
    "id": "ba85e0f4-24ae-4065-9d96-7392f96f75fe",
    "slug": "al-redha-company-advocates-legal-consultants",
    "name": "AL REDHA & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFSCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/04/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/03/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL REDHA & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ba85e0f4-24ae-4065-9d96-7392f96f75fe",
        "address": "الثاني 201 ,مركز البخيت ,بالقرب من مركز القبائل للتخفيضات ,12020 ,Dubai",
        "phone": "97142664411",
        "email": "redhalaw@eim.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Mohd Abdulla Jan Ali Al -Redha",
    "address": "الثاني 201,مركز البخيت,شارع أبوبكر الصديق,Dub",
    "phone": "97142664411",
    "email": "redhalaw@eim.ae",
    "registrationNumber": "ADF-2011-17"
  },
  {
    "id": "b7bbfaeb-1fdb-46d2-97cf-8e6432a9b8a7",
    "slug": "al-safar-partners-advocates-legal-consultants",
    "name": "AL SAFAR & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/14/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/13/2027 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL SAFAR & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b7bbfaeb-1fdb-46d2-97cf-8e6432a9b8a7",
        "address": "4th floor ,Al Saaha Offices Block D office 401A ,Burj Khalifa ,283773 ,Dubai",
        "phone": "97144221944",
        "email": "gov.depts@alsafarpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Mehdi Safar Ghulom Abdulla",
    "address": "4th floor,Al Saaha Offices Block D office 401",
    "phone": "97144221944",
    "email": "gov.depts@alsafarpartners.com",
    "registrationNumber": "ADF-2012-120"
  },
  {
    "id": "a6811a79-5470-4c33-ad95-3ff8f661c052",
    "slug": "al-sahlawi-co-advocates-consultants",
    "name": "AL SAHLAWI & CO ADVOCATES & CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/05/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/04/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL SAHLAWI & CO ADVOCATES & CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a6811a79-5470-4c33-ad95-3ff8f661c052",
        "address": "الطابق الخامس ,الساحة ,سوق البحار ,26011 ,Dubai",
        "phone": "97142277717",
        "email": "info@alsahlawico.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Yousif Hussain Mohamed Alsahlawi Al Ali",
    "address": "الطابق الخامس,الساحة,برج خليفة,Dubai,26011",
    "phone": "97142277717",
    "email": "info@alsahlawico.com",
    "registrationNumber": "ADF-2011-20"
  },
  {
    "id": "dbd24b15-854f-4da7-b9a6-0eb7a3aae993",
    "slug": "al-saqer-advocates",
    "name": "AL SAQER ADVOCATES",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/14/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "02/13/2021 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL SAQER ADVOCATES",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dbd24b15-854f-4da7-b9a6-0eb7a3aae993",
        "address": "MOUHAMAD RAMEZ YOUSSEF FUSTUQ ,212 ,DIAMOND BUSINESS CENTER 1 - B ,Dubai Miracle Garden ,81359 ,Dubai",
        "phone": "97142384727",
        "email": "mandflaw@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Mohammed Ramez Yousef Fustoq",
    "address": "212,DIAMOND BUSINESS CENTER 1 - B,ALBARSHAA S",
    "phone": "97142384727",
    "email": "mandflaw@emirates.net.ae",
    "registrationNumber": "ADF-2012-94"
  },
  {
    "id": "2cfc8314-1db4-4102-9720-3a65b58a8b0d",
    "slug": "al-sayyah-advocates-legal-consultants",
    "name": "AL SAYYAH ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/10/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/09/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL SAYYAH ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2cfc8314-1db4-4102-9720-3a65b58a8b0d",
        "address": "Hamdan Abdulla Mohamed Al Sayyah ,First Floor Office 108 ,Alserkal Building ,Beside Alkhoory Sky Gardens ,116499 ,Dubai",
        "phone": "97144491085",
        "email": "info@als-legal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Hamdan Abdullah Mohammed Ibrahim Sayyah",
    "address": "First Floor Office 108,Alserkal Building, Por",
    "phone": "97144491085",
    "email": "info@als-legal.com",
    "registrationNumber": "ADF-2012-191"
  },
  {
    "id": "a58e33e7-4134-4c4f-afa6-c129aefe104c",
    "slug": "al-shaali-company-advocates-legal-consultants",
    "name": "AL SHAALI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/20/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/19/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL SHAALI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a58e33e7-4134-4c4f-afa6-c129aefe104c",
        "address": "Ibrahim Nagi ,Office 207, Level 2 ,Al Khaimah Building ,Behind Nissan Showroom ,20220 ,Dubai",
        "phone": "97142950001",
        "email": "info@alshaali-co.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Salem Salem Mohammed AL-Shaali",
    "address": "Office 207, Level 2,Al Khaimah Building,Al It",
    "phone": "97142950001",
    "email": "info@alshaali-co.com",
    "registrationNumber": "ADF-2011-31"
  },
  {
    "id": "d29f6d04-dad1-4f59-9ae2-d4d245f63133",
    "slug": "al-shamsi-partners-advocates-legal-consultants",
    "name": "AL SHAMSI & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/25/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL SHAMSI & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d29f6d04-dad1-4f59-9ae2-d4d245f63133",
        "address": "",
        "phone": "97108307033",
        "email": "general.alshamsi@lawuae.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Ali Abdulla Majed Al-Shamsi",
    "address": "N/A",
    "phone": "97144224303",
    "email": "general.alshamsi@lawuae.com",
    "registrationNumber": "ADF-2012-83"
  },
  {
    "id": "dab6c960-06bf-4107-b633-52015cf4be6a",
    "slug": "al-sharif-advocates-legal-consultants",
    "name": "AL SHARIF ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/18/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL SHARIF ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dab6c960-06bf-4107-b633-52015cf4be6a",
        "address": "7 ,سوفيتل ,محطة برج خليفة  ,8867 ,Dubai",
        "phone": "97143488808",
        "email": "secretary@dubailaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Abdulrahman Abdulghaffar Abdulrahman Al-Sharif",
    "address": "7,سوفيتل,دبي داون تاون ,Dubai,8867",
    "phone": "97143488808",
    "email": "secretary@dubailaw.ae",
    "registrationNumber": "ADF-2011-69"
  },
  {
    "id": "bcc63eb3-5fc8-42bd-beb1-b29798bdcee4",
    "slug": "al-shehhi-group-advocates-legal-consultant",
    "name": "AL SHEHHI GROUP ADVOCATES & LEGAL CONSULTANT",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/06/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/05/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL SHEHHI GROUP ADVOCATES & LEGAL CONSULTANT",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bcc63eb3-5fc8-42bd-beb1-b29798bdcee4",
        "address": "AL SHEHHI GROUP ADVOCATES & LEGAL CONSULTANT ,الأول ,بناية المسعود ,مقابل لفندي ماريوت ,172662 ,Dubai",
        "phone": "97142384222",
        "email": "dubai@alshehhilawyer.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Younes Mohamed Ali M. Alyas Alshehhi",
    "address": "الأول,بناية المسعود,رقة البطين,Dubai,172662",
    "phone": "97142384222",
    "email": "dubai@alshehhilawyer.ae",
    "registrationNumber": "ADF-2012-163"
  },
  {
    "id": "aced7900-0571-43e1-b49b-4740c6dc298f",
    "slug": "al-taher-al-sabri-advocates",
    "name": "AL TAHER & AL SABRI ADVOCATES",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFUCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/13/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "01/12/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL TAHER & AL SABRI ADVOCATES",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_aced7900-0571-43e1-b49b-4740c6dc298f",
        "address": "السادس , مباني الحضيبة للجوائز  ,علم الاتحاد ,200 ,Dubai",
        "phone": "97143545111",
        "email": "altaher_alsabri@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Mohammed Salman Hassan Al-Saberi",
    "address": "السادس, مباني الحضيبة للجوائز , الجميرا (1)",
    "phone": "97143545111",
    "email": "altaher_alsabri@hotmail.com",
    "registrationNumber": "ADF-2013-265"
  },
  {
    "id": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "slug": "al-tamimi-company-advocates-legal-consultants",
    "name": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFUCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/01/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "07/31/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Essam Abdulamir Hammadi Alfadhli Al-Temimi",
    "address": "full floors 6 and 7,Central Park Office Tower",
    "phone": "97143641731",
    "email": "j.morris@tamimi.com",
    "registrationNumber": "ADF-2012-234"
  },
  {
    "id": "0ba96df8-e4cc-49c2-8ae4-a42878d95926",
    "slug": "al-tamimi-company-advocates-legal-consultants-llc",
    "name": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFUCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/28/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "02/27/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS LLC",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0ba96df8-e4cc-49c2-8ae4-a42878d95926",
        "address": "",
        "phone": "97143641686 / 971506288801",
        "email": "b.kadir@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97143641686",
    "email": "b.kadir@tamimi.com",
    "registrationNumber": "ADF-2012-105"
  },
  {
    "id": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "slug": "al-tamimi-company-limited",
    "name": "AL TAMIMI & COMPANY LIMITED",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFUCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/08/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/07/2024 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL TAMIMI & COMPANY LIMITED",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2d30e6cf-d364-474a-abe0-690798e7f9ca",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "Level 6 & Level 7,Central Park Tower,Shk Zaye",
    "phone": "97143641737",
    "email": "j.morris@tamimi.com",
    "registrationNumber": "ADF-2013-275-1"
  },
  {
    "id": "ece8ea60-9ecb-4d8c-aca3-fb73e4e52406",
    "slug": "al-wasl-international-group-advocates-legal-consultants",
    "name": "AL WASL INTERNATIONAL GROUP - ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFXCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/17/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/16/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL WASL INTERNATIONAL GROUP - ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ece8ea60-9ecb-4d8c-aca3-fb73e4e52406",
        "address": "",
        "phone": "97143212555",
        "email": "awigdubai@awiglaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Abdelaziz Abdalla Mohamed Abdalla Al Hammadi",
    "address": "N/A",
    "phone": "97143212555",
    "email": "awigdubai@awiglaw.ae",
    "registrationNumber": "ADF-2011-51"
  },
  {
    "id": "e0e9ae88-3bda-4570-8591-d79757732608",
    "slug": "al-wasl-international-group-advocates-and-legal-consultants-the-dubai-technology-and-media-free-zone-branch",
    "name": "AL WASL INTERNATIONAL GROUP ADVOCATES AND LEGAL CONSULTANTS- THE DUBAI TECHNOLOGY AND MEDIA FREE ZONE BRANCH",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFXCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/01/2012",
    "licenseStatus": "active",
    "licenseExpiry": "2013-01-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL WASL INTERNATIONAL GROUP ADVOCATES AND LEGAL CONSULTANTS- THE DUBAI TECHNOLOGY AND MEDIA FREE ZONE BRANCH",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e0e9ae88-3bda-4570-8591-d79757732608",
        "address": "",
        "phone": "97143901155",
        "email": "legal@awigdic.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null
  },
  {
    "id": "fd77d7cf-7bee-4da2-8757-d004294b9189",
    "slug": "al-zahmi-advocates-legal-consultants",
    "name": "AL ZAHMI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFaCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/26/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/25/2019 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL ZAHMI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fd77d7cf-7bee-4da2-8757-d004294b9189",
        "address": "",
        "phone": "97142865353 / 971551986013",
        "email": "info@alzahmyadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97142865353",
    "email": "info@alzahmyadvocates.com",
    "registrationNumber": "ADF-2011-09"
  },
  {
    "id": "e5af688d-2190-4a5e-bb51-52b925fc1fb7",
    "slug": "al-zeyoudi-advocates-legal-consultants",
    "name": "AL ZEYOUDI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFaCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/26/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "07/25/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL ZEYOUDI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e5af688d-2190-4a5e-bb51-52b925fc1fb7",
        "address": "مركز وافي للتسوق  ,بلوك ايه ,خلف فندق موفنبيك ,11672 ,Dubai",
        "phone": "97143796990",
        "email": "alzeyoudi@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "مركز وافي للتسوق ,بلوك ايه,عود ميثا,Dubai,116",
    "phone": "97143796990",
    "email": "alzeyoudi@yahoo.com",
    "registrationNumber": "ADF-2012-231"
  },
  {
    "id": "b1c98bb5-4fdc-4e2a-8d16-ba2fa7afcace",
    "slug": "alawadhi-advocates-legal-consultants",
    "name": "ALAWADHI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/21/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/24/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALAWADHI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b1c98bb5-4fdc-4e2a-8d16-ba2fa7afcace",
        "address": "111 ,AL HATHBOUR ,CANADIAN HOSPITAL ,96555 ,Dubai",
        "phone": "97142656000",
        "email": "alawadhi.advocates@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "111,AL HATHBOUR,ABU HAIL,Dubai,96555",
    "phone": "97142656000",
    "email": "alawadhi.advocates@hotmail.com",
    "registrationNumber": "ADF-2011-54"
  },
  {
    "id": "6ada2495-c722-4585-bbc3-2b70e5c9fcf9",
    "slug": "alawami-almansoori-advocates-and-legal-consultants",
    "name": "ALAWAMI ALMANSOORI ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/12/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "01/11/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALAWAMI ALMANSOORI ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6ada2495-c722-4585-bbc3-2b70e5c9fcf9",
        "address": "Mohammed Saghaer Ali Al Awami Al Mansoori ,3 ,IT PLAZA ,Green Belt Supermarket ,25626 ,Dubai",
        "phone": "97143338885",
        "email": "info@alawami.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Mohammed Saghaer Ali Alawami Almansoori",
    "address": "3,IT PLAZA,OFFICE 313- Silicon Oasis,Dubai,25",
    "phone": "97143338885",
    "email": "info@alawami.ae",
    "registrationNumber": "ADF-2017-399"
  },
  {
    "id": "80667ff5-8d9d-4ce3-860f-34cd7e4937bc",
    "slug": "alawi-aljaberi-advocates-legal-consultants",
    "name": "ALAWI ALJABERI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/27/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/26/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALAWI ALJABERI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_80667ff5-8d9d-4ce3-860f-34cd7e4937bc",
        "address": "Alawi Ghaleb Ali Saeed Aljaberi ,M ,Bussiness venue building  ,al nase club ,10103 ,Dubai",
        "phone": "97143436652",
        "email": "ajadvo017@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Alawi Ghaleb Ali Saeed Aljaberi",
    "address": "M,Bussiness venue building ,Um Hurer road - o",
    "phone": "97143436652",
    "email": "ajadvo017@gmail.com",
    "registrationNumber": "ADF-2022-638"
  },
  {
    "id": "5fd2b33a-4bae-47d7-86ce-bdbd42af4336",
    "slug": "albalooshi-and-almarashida-advocates-and-legal-consultants",
    "name": "ALBALOOSHI AND ALMARASHIDA ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/11/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "01/10/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALBALOOSHI AND ALMARASHIDA ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5fd2b33a-4bae-47d7-86ce-bdbd42af4336",
        "address": "",
        "phone": "97143333245 / 97143333245",
        "email": "y.albulooshi@yhadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Yousuf Abbas Yousuf Ahmed M Albalooshi",
    "address": "N/A",
    "phone": "97143333245",
    "email": "y.albulooshi@yhadvocates.ae",
    "registrationNumber": "ADF-2018-433"
  },
  {
    "id": "73525ec0-5573-4652-8fd8-c2ef0f19b399",
    "slug": "albannai-co",
    "name": "ALBANNAI & CO.",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFDCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/07/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/06/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALBANNAI & CO.",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_73525ec0-5573-4652-8fd8-c2ef0f19b399",
        "address": "",
        "phone": "97142946164",
        "email": "info@albannai-law.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97142946164",
    "email": "info@albannai-law.com",
    "registrationNumber": "ADF-2012-186"
  },
  {
    "id": "c8fbcee3-eac8-43ed-8cea-d0c5483a5ae1",
    "slug": "aleasima-advocates-legal-consultants",
    "name": "ALEASIMA ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/22/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/21/2025 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALEASIMA ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c8fbcee3-eac8-43ed-8cea-d0c5483a5ae1",
        "address": "",
        "phone": "97144470190",
        "email": "maged.elfawal@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "shaikha salem nassib mubarak al neyadi",
    "address": "N/A",
    "phone": "97144470190",
    "email": "maged.elfawal@yahoo.com",
    "registrationNumber": "ADF-2023-665"
  },
  {
    "id": "b1e23b77-356c-4678-ae4d-2ff4e494702b",
    "slug": "algharib-partners-advocates-and-legal-consultants",
    "name": "ALGHARIB & PARTNERS ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFQCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/30/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/29/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALGHARIB & PARTNERS ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b1e23b77-356c-4678-ae4d-2ff4e494702b",
        "address": "الطابق الثاني - مكتب رقم 203 و 204  ,سيتي أفينو ,سيتى سنتر ديرة  ,83666 ,Dubai",
        "phone": "97142955050",
        "email": "adv.algharib@alghariblawfirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Mukhtar Mohammed Baqir Gharib",
    "address": "الطابق الثاني - مكتب رقم 203 و 204 ,سيتي أفين",
    "phone": "97142955050",
    "email": "adv.algharib@alghariblawfirm.com",
    "registrationNumber": "ADF-2012-156"
  },
  {
    "id": "2f9514bf-2175-40fe-8539-d1b4b32074b7",
    "slug": "algurg-almatrooshi-advocates-ligal-consultants",
    "name": "ALGURG & ALMATROOSHI ADVOCATES & LIGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/11/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/10/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALGURG & ALMATROOSHI ADVOCATES & LIGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2f9514bf-2175-40fe-8539-d1b4b32074b7",
        "address": "",
        "phone": "97142828999",
        "email": "info@gmalc.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Ahmed Saif Majed Bin Salem Al-Matrooshi",
    "address": "N/A",
    "phone": "97142828999",
    "email": "info@gmalc.ae",
    "registrationNumber": "ADF-2012-116"
  },
  {
    "id": "f2476874-d6f1-491d-857f-df0917f9997a",
    "slug": "alhamad-advocates-legal-consultants",
    "name": "ALHAMAD ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/03/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/02/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALHAMAD ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f2476874-d6f1-491d-857f-df0917f9997a",
        "address": "Hamad Abdul wahab alqawadi ,الطابق العاشر / مكتب 1002 ,فندق ذا اتش  ,المركز التجاري  ,00000 ,Dubai",
        "phone": "97145681225",
        "email": "alhamad_advo@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "HAMAD ABDELWAHAB HASSAN MOHAMED AL QAWADI",
    "address": "الطابق العاشر / مكتب 1002,فندق ذا اتش ,شارع ا",
    "phone": "97145681225",
    "email": "alhamad_advo@hotmail.com",
    "registrationNumber": "ADF-2022-661"
  },
  {
    "id": "9dedc5d0-f4c4-47ed-a06b-62ab5e13a6cd",
    "slug": "alhashimi-law-firms-and-legal-consulting",
    "name": "ALHASHIMI LAW FIRMS AND LEGAL CONSULTING",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFMCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/26/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/25/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALHASHIMI LAW FIRMS AND LEGAL CONSULTING",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9dedc5d0-f4c4-47ed-a06b-62ab5e13a6cd",
        "address": "HASHIM SAYED AHMED SAYED A RAHIM ALHASHIMI ,ZOOM ,بناية مكاتب ,مقابل معرض تويوتا - خلف وكالة نيسان ,2852 ,Dubai",
        "phone": "",
        "email": "lawyers@alhashimi-lf.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Hashim Ahmed AbdulRahem Hashim",
    "address": "ZOOM,بناية مكاتب,شارع المكتوم - منطقة بور سعي",
    "phone": "N/A",
    "email": "lawyers@alhashimi-lf.com",
    "registrationNumber": "ADF-2011-35"
  },
  {
    "id": "4675606d-79bb-4fd1-a3f6-a469d3d7cd31",
    "slug": "alhefeiti-advocates-and-legal-consultants",
    "name": "ALHEFEITI ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/06/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/05/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALHEFEITI ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4675606d-79bb-4fd1-a3f6-a469d3d7cd31",
        "address": "13 ,Fairmont Hotel ,World Trade Centre metro station ,187082 ,Dubai",
        "phone": "97142367881",
        "email": "info@alhefeitilaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Mohamed Saif Obaid Al Hefeiti",
    "address": "13,Fairmont Hotel,Sheikh Zayed Road,Dubai,187",
    "phone": "97142367881",
    "email": "info@alhefeitilaw.ae",
    "registrationNumber": "ADF-2012-161"
  },
  {
    "id": "21562057-4573-49b3-bd96-20c932058ea3",
    "slug": "ali-ahmed-aldiqqi-advocates-legal-consultants",
    "name": "ALI AHMED ALDIQQI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/31/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/30/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALI AHMED ALDIQQI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_21562057-4573-49b3-bd96-20c932058ea3",
        "address": "",
        "phone": "97143384004 / 971566651137",
        "email": "aaldiqqi@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Ali Ahmed Hassan Al Diqqi",
    "address": "N/A",
    "phone": "97143384004",
    "email": "aaldiqqi@gmail.com",
    "registrationNumber": "ADF-2021-550"
  },
  {
    "id": "e8cecbdb-d935-4626-8634-7c0a23598474",
    "slug": "ali-al-mannaei-advocates-legal-consultants",
    "name": "ALI AL MANNAEI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/16/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/15/2024 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALI AL MANNAEI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e8cecbdb-d935-4626-8634-7c0a23598474",
        "address": "",
        "phone": "97142552008",
        "email": "info@alialmannaei.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Ali Ahmed Ali Obaid Al-Mannaei",
    "address": "N/A",
    "phone": "97142552008",
    "email": "info@alialmannaei.com",
    "registrationNumber": "ADF-2011-48"
  },
  {
    "id": "79c6a7a9-d0cc-420b-b3ad-61dae9a0b284",
    "slug": "ali-al-nuaimi-advocates-legal-consultants",
    "name": "ALI AL NUAIMI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/07/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/09/2025 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALI AL NUAIMI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_79c6a7a9-d0cc-420b-b3ad-61dae9a0b284",
        "address": "",
        "phone": "97143241116 / 971501264770",
        "email": "info@uaealnuaimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97143241116",
    "email": "info@uaealnuaimi.com",
    "registrationNumber": "ADF-2020-509"
  },
  {
    "id": "e22c751b-e66d-497c-b5ee-3df32eab4831",
    "slug": "ali-al-shimmari-advocates-legal-consultants",
    "name": "ALI AL SHIMMARI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/11/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "02/10/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALI AL SHIMMARI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e22c751b-e66d-497c-b5ee-3df32eab4831",
        "address": "",
        "phone": "97142500717",
        "email": "alishamrilawfirm@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97142500717",
    "email": "alishamrilawfirm@gmail.com",
    "registrationNumber": "ADF-2013-273"
  },
  {
    "id": "9dd97fa5-b744-465f-bac7-8ab23b9eda4f",
    "slug": "ali-aleter-advocates-legal-consultancy",
    "name": "ALI ALETER ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/29/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/28/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALI ALETER ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9dd97fa5-b744-465f-bac7-8ab23b9eda4f",
        "address": "ali mohamed saif ,مكتب 1501 ,داماس ,رقة البطين ,25900 ,Dubai",
        "phone": "97142555779 / 971553616616",
        "email": "info@aleter.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Ali Mohamed saif Aleter Aldhanhani",
    "address": "مكتب 1501,داماس,رقة البطين  ديرة,Dubai,25900",
    "phone": "97142555779",
    "email": "info@aleter.ae",
    "registrationNumber": "ADF-2018-430"
  },
  {
    "id": "373da443-20e8-461a-b11d-dba4d77f1b45",
    "slug": "ali-alhammadi-advocates-legal-consultants",
    "name": "ALI ALHAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/01/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "02/28/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALI ALHAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_373da443-20e8-461a-b11d-dba4d77f1b45",
        "address": "110 ,بناية مكاتب عود ميثاء R338 ,مقابل وافى مول وفندق رافلز دبى ,624494 ,Dubai",
        "phone": "97143231881",
        "email": "info@alialhammadi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Ali Abdulla Ali Alqawadi Alhammadi",
    "address": "110,بناية مكاتب عود ميثاء R338,أم هرير الثاني",
    "phone": "97143231881",
    "email": "info@alialhammadi.com",
    "registrationNumber": "ADF-2017-403"
  },
  {
    "id": "8b17fa0a-9280-4fda-9e0e-dd7a826edb51",
    "slug": "ali-alshowab-advocates-legal-consultants",
    "name": "ALI ALSHOWAB ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/11/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/10/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALI ALSHOWAB ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8b17fa0a-9280-4fda-9e0e-dd7a826edb51",
        "address": "",
        "phone": "97144205111",
        "email": "info@showab.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Ali Saleh Abdulrasool Abdulla Al Showab",
    "address": "N/A",
    "phone": "97144205111",
    "email": "info@showab.ae",
    "registrationNumber": "ADF-2024-724"
  },
  {
    "id": "1b20a190-96ba-4853-9ea4-6233323402f4",
    "slug": "ali-bin-tamim-co-advocates-legal-consultancy",
    "name": "ALI BIN TAMIM & CO ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFCCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/25/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/26/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALI BIN TAMIM & CO ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1b20a190-96ba-4853-9ea4-6233323402f4",
        "address": "",
        "phone": "97142689978",
        "email": "info@abtadvo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Ali Mohammad Mahmood Bin Tamim",
    "address": "N/A",
    "phone": "97142689978",
    "email": "info@abtadvo.com",
    "registrationNumber": "ADF-2011-08"
  },
  {
    "id": "eae5fb25-fd19-436c-8668-3ac309424db4",
    "slug": "ali-habib-and-associates-advocates-and-legal-consultancy",
    "name": "ALI HABIB AND ASSOCIATES ADVOCATES AND LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/14/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/13/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALI HABIB AND ASSOCIATES ADVOCATES AND LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_eae5fb25-fd19-436c-8668-3ac309424db4",
        "address": "",
        "phone": "97100000000",
        "email": "dubai@ahlegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97100000000",
    "email": "dubai@ahlegal.ae",
    "registrationNumber": "ADF-2012-195"
  },
  {
    "id": "1b2ae5cc-a1db-4e6a-bf98-59d41bdb6127",
    "slug": "ali-hasan-alhammadi-advocates-legal-consultants",
    "name": "ALI HASAN ALHAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/13/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/12/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALI HASAN ALHAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1b2ae5cc-a1db-4e6a-bf98-59d41bdb6127",
        "address": "التاسع ,مكتب 903 ملك خالد عبدالرحيم احمد العطار - ذا تاور بلازا ,ذا تاور بلازا ,38350 ,Dubai",
        "phone": "97145873377 / 971564643109",
        "email": "ahm@ahmlawfirms.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Ali Hasan Yousif Hasan Alhammadi",
    "address": "التاسع,مكتب 903 ملك خالد عبدالرحيم احمد العطا",
    "phone": "97145873377",
    "email": "ahm@ahmlawfirms.com",
    "registrationNumber": "ADF-2018-464"
  },
  {
    "id": "5029a3dc-098b-4d3f-9e38-afb0eb4319d0",
    "slug": "ali-ibrahim-advocates-legal-consultants",
    "name": "ALI IBRAHIM ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFJCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/01/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "02/28/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALI IBRAHIM ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5029a3dc-098b-4d3f-9e38-afb0eb4319d0",
        "address": "",
        "phone": "97142280002",
        "email": "advoali2020@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Ali Ibrahim Mohamed Alhammadi",
    "address": "N/A",
    "phone": "97142280002",
    "email": "advoali2020@gmail.com",
    "registrationNumber": "ADF-2012-106"
  },
  {
    "id": "75886cf6-ccb6-4f1b-bd9e-15371e41d8ef",
    "slug": "ali-khalaf-alhosani-advocates-legal-consultants",
    "name": "ALI KHALAF ALHOSANI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFLCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/06/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/05/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALI KHALAF ALHOSANI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_75886cf6-ccb6-4f1b-bd9e-15371e41d8ef",
        "address": "برج المناره ,برج المناره ,فندق جي دبليو ماريوت ماركيز ,135574 ,Dubai",
        "phone": "97144226166 / 971506464911",
        "email": "info@alialhosani.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Ali Khalaf Husain Alhosani",
    "address": "برج المناره,برج المناره,شارع الأبراج- الخليج",
    "phone": "97144226166",
    "email": "info@alialhosani.com",
    "registrationNumber": "ADF-2016-378"
  },
  {
    "id": "22d91b55-d8b8-4ccf-be32-aba1f5dea289",
    "slug": "ali-musabbah-advocates-legal-consultancy",
    "name": "ALI MUSABBAH ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/25/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/24/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALI MUSABBAH ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_22d91b55-d8b8-4ccf-be32-aba1f5dea289",
        "address": "",
        "phone": "97143334212",
        "email": "secretary@alimusabbah.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97143334212",
    "email": "secretary@alimusabbah.com",
    "registrationNumber": "ADF-2016-380"
  },
  {
    "id": "298ff405-ca8b-4fc8-a674-74ae24832268",
    "slug": "ali-naqi-advocates-legal-consultants",
    "name": "ALI NAQI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFOCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/14/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/13/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALI NAQI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_298ff405-ca8b-4fc8-a674-74ae24832268",
        "address": "ali mohamed amin  ,205 - 104  ,اثراء  ,بالقرب من فندق جميرا طيران الامارات  ,10155 ,Dubai",
        "phone": "97143967188",
        "email": "aliadvocates71@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Ali Mohamed Amin Abdullah Naqi",
    "address": "205 - 104 ,اثراء ,القرهود - ديرة ,Dubai,10155",
    "phone": "97143967188",
    "email": "aliadvocates71@gmail.com",
    "registrationNumber": "ADF-2015-346"
  },
  {
    "id": "fa7eb7e5-d5d3-404a-91ba-06a1efeb207e",
    "slug": "ali-obaid-alshamsi-lawyers-legal-consultants",
    "name": "ALI OBAID ALSHAMSI LAWYERS & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFPCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/18/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "02/17/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALI OBAID ALSHAMSI LAWYERS & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fa7eb7e5-d5d3-404a-91ba-06a1efeb207e",
        "address": "1606 ,فندق الكونراد - برج المكاتب ,فندق الفيرمونت ,84333 ,Dubai",
        "phone": "97142218787 / 971505773332",
        "email": "info@alshamsilawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Ali Obaid Humaid Obaid Alshamsi",
    "address": "1606,فندق الكونراد - برج المكاتب,شارع الشيخ ز",
    "phone": "97142218787",
    "email": "info@alshamsilawyers.com",
    "registrationNumber": "ADF-2020-496"
  },
  {
    "id": "843234aa-d59b-4763-b69a-ba92f9cbba70",
    "slug": "ali-yousuf-alawadhi-advocates-legal-consultants-llc",
    "name": "ALI YOUSUF ALAWADHI ADVOCATES & LEGAL CONSULTANTS L.L.C",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFZCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/22/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/21/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALI YOUSUF ALAWADHI ADVOCATES & LEGAL CONSULTANTS L.L.C",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_843234aa-d59b-4763-b69a-ba92f9cbba70",
        "address": "",
        "phone": "97122222222",
        "email": "info@ayalegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Ali Yousuf Abdulla Abdulraheem Alawadhi",
    "address": "N/A",
    "phone": "97122222222",
    "email": "info@ayalegal.ae",
    "registrationNumber": "ADF-2024-753"
  },
  {
    "id": "64ce7252-a854-4e99-8c45-6681a4c7ca55",
    "slug": "alia-alattar-advocates-legal-consultants",
    "name": "ALIA ALATTAR ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/17/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/16/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALIA ALATTAR ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_64ce7252-a854-4e99-8c45-6681a4c7ca55",
        "address": "",
        "phone": "97148876711",
        "email": "info@alattarlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97148876711",
    "email": "info@alattarlaw.ae",
    "registrationNumber": "ADF-2022-644"
  },
  {
    "id": "a9193879-c34b-4dae-99aa-d8e5ac8517cc",
    "slug": "al-kabban-associates-advocates-legal-consultants",
    "name": "AL-KABBAN & ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/02/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "07/01/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL-KABBAN & ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a9193879-c34b-4dae-99aa-d8e5ac8517cc",
        "address": "29TH  ,PRISM TOWER ,J W MARRIOTT MARQUIS HOTEL  ,4790 ,Dubai",
        "phone": "97144539090",
        "email": "info@alkabban.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Rayadh Abdulmajeid Mohmood Al-Kabban",
    "address": "29TH ,PRISM TOWER,AL SAADA STREET, BUSINESS B",
    "phone": "97144539090",
    "email": "info@alkabban.com",
    "registrationNumber": "ADF-2012-211"
  },
  {
    "id": "1829252a-0804-4aaa-ad2a-4212e680346d",
    "slug": "allied-advocates-legal-consultants",
    "name": "ALLIED ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/25/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/24/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALLIED ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1829252a-0804-4aaa-ad2a-4212e680346d",
        "address": "403 ,الطابق الاول مكتب 101 ,بناية الكنال سنترال ,اكاديمية هايونداي للتدريب  ,90209 ,Dubai",
        "phone": "97142970007",
        "email": "altdamon@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "الطابق الاول مكتب 101,بناية الكنال سنترال,الخ",
    "phone": "97142970007",
    "email": "altdamon@emirates.net.ae",
    "registrationNumber": "ADF-2012-153"
  },
  {
    "id": "5c727678-4d31-4064-9400-932655fce73e",
    "slug": "almasa-advocates",
    "name": "UNITED ADVOCATES",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "09/25/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALMASA ADVOCATES",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5c727678-4d31-4064-9400-932655fce73e",
        "address": "FATIMA MOHAMMAD ALMAZAM ,3RD FLOOR ,LIBERTY ,BESIDE BANK OF SHARJAH ,35630 ,Dubai",
        "phone": "97142822278",
        "email": "tanany@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "-",
    "address": "Office No.3901, 3902, Level 39, Single Business Tower, Sheikh Zayed Road, Burj Khalifa District, Bur Dubai, P.O. Box 90077, Dubai",
    "phone": "97142822278",
    "email": "tanany@emirates.net.ae",
    "registrationNumber": "-"
  },
  {
    "id": "8644c882-8dd2-4973-854c-d4417713cfc4",
    "slug": "almubasheri-advocates-legal-consultancy",
    "name": "ALMUBASHERI ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/19/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/18/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALMUBASHERI ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8644c882-8dd2-4973-854c-d4417713cfc4",
        "address": "611-612 ,مباني الحضيبة للجوائز  ,متحف الإتحاد ,6178 ,Dubai",
        "phone": "97143589998 / 971553690566",
        "email": "info@mublegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Salah Hasan Mohamed Mubasheri",
    "address": "611-612,مباني الحضيبة للجوائز ,شارع المينا -",
    "phone": "97143589998",
    "email": "info@mublegal.com",
    "registrationNumber": "ADF-2011-29"
  },
  {
    "id": "ad71430e-83ee-4cb5-a530-bc58db2618f6",
    "slug": "alnaqbi-partners-advocates-legal-consultants",
    "name": "ALNAQBI & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFQCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "09/25/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALNAQBI & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ad71430e-83ee-4cb5-a530-bc58db2618f6",
        "address": "YASIR AL NAQBI ,21 ,48 BURJ ,SOFITEL DOWN  TOWN ,181111 ,Dubai",
        "phone": "97142689949",
        "email": "info@alnaqbipartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "-",
    "address": "Office No. B 2101, Level 21, Commercial gulf, The Gate Tower 48, Sheikh Zayed Street, Bur Dubai, P.O. Box 181111, Dubai",
    "phone": "97142689949",
    "email": "info@alnaqbipartners.com",
    "registrationNumber": "-"
  },
  {
    "id": "4bf6169e-af5d-43e6-867c-8219fdfb27b1",
    "slug": "alnasr-offce-advocates-legal-consultancy",
    "name": "ALNASR OFFCE ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFPCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/06/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "02/05/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALNASR OFFCE ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4bf6169e-af5d-43e6-867c-8219fdfb27b1",
        "address": "",
        "phone": "97142989455",
        "email": "adv_nasr@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97142989455",
    "email": "adv_nasr@yahoo.com",
    "registrationNumber": "ADF-2012-88"
  },
  {
    "id": "7a155f4a-20ec-44ff-863f-4f9fb43d0af4",
    "slug": "alobaidli-alzarooni-advocateslegal-consultants",
    "name": "ALOBAIDLI & ALZAROONI ADVOCATES&LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/03/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/02/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALOBAIDLI & ALZAROONI ADVOCATES&LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7a155f4a-20ec-44ff-863f-4f9fb43d0af4",
        "address": "ادارة ا لمبنى  ,الريم ,الاتصالات  ,42423 ,Dubai",
        "phone": "97142222066",
        "email": "info@ozleco.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Mohammed Abdulla Al-Ebidli",
    "address": "ادارة ا لمبنى ,الريم,المكتوم,Dubai,42423",
    "phone": "97142222066",
    "email": "info@ozleco.com",
    "registrationNumber": "ADF-2012-183"
  },
  {
    "id": "171b4622-e4ec-4375-a9c4-3637bf6a8b17",
    "slug": "alomar-alsabah-advocates-legal-consultancy",
    "name": "ALOMAR & ALSABAH ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/05/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/04/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALOMAR & ALSABAH ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_171b4622-e4ec-4375-a9c4-3637bf6a8b17",
        "address": "omar abdulazizi alomar ,15 ,prime tower ,blom bank france ,211940 ,Dubai",
        "phone": "97143808838 / 971504598082",
        "email": "omar.omar@oghlegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Omar Abdulaziz Abdulla Aziz Al Omar",
    "address": "15,prime tower,business bay,Dubai,211940",
    "phone": "97143808838",
    "email": "omar.omar@oghlegal.com",
    "registrationNumber": "ADF-2016-390"
  },
  {
    "id": "34156aa2-d714-4a9a-875a-eb422ea3c4c2",
    "slug": "alotaiba-hamdan-budebes-advocates-legal-consultants",
    "name": "ALOTAIBA & HAMDAN BUDEBES ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/30/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/29/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALOTAIBA & HAMDAN BUDEBES ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_34156aa2-d714-4a9a-875a-eb422ea3c4c2",
        "address": "HAMDAN BUDEBES  ,1614 ,BLUE BAY TOWER ,BUSINESS BAY ,127637 ,Dubai",
        "phone": "97142505612",
        "email": "info-dubai@alotaiba-law.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Hamdan Ahmed Mohammed Husain Hamdan BuDebs",
    "address": "B102,مجموعة شركات ومؤسسات الكاظم,القرهود,Duba",
    "phone": "97142505612",
    "email": "info-dubai@alotaiba-law.ae",
    "registrationNumber": "ADF-2012-157"
  },
  {
    "id": "588c9e2f-4f09-44bb-9e80-4e56d3f821b6",
    "slug": "alowais-al-matrooshi-advocates-and-legal-consultants",
    "name": "ALOWAIS & AL MATROOSHI ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/13/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "01/12/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALOWAIS & AL MATROOSHI ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_588c9e2f-4f09-44bb-9e80-4e56d3f821b6",
        "address": "Mezzanine / 09 ,Business Point  ,Behind Nissan Showroom ,85825 ,Dubai",
        "phone": "97142595777",
        "email": "ALMATROOSHI@OMALC.AE",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Abdulla Marwan Abdulla Ahmed Bekhit Al Matrooshi",
    "address": "Mezzanine / 09,Business Point ,4b Street,Duba",
    "phone": "97142595777",
    "email": "ALMATROOSHI@OMALC.AE",
    "registrationNumber": "ADF-2013-266"
  },
  {
    "id": "8576864d-ec5e-4834-b800-88160aa2c0a5",
    "slug": "alpha-advocates-legal-consultants",
    "name": "ALPHA ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/29/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/28/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALPHA ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8576864d-ec5e-4834-b800-88160aa2c0a5",
        "address": "",
        "phone": "/ 97151111146",
        "email": "info@alphalegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Mohammed Slayem Suhail Al Aswad Alameri",
    "address": "N/A",
    "phone": "N/A",
    "email": "info@alphalegal.ae",
    "registrationNumber": "ADF-2024-749"
  },
  {
    "id": "4d4c6395-3d11-4910-a051-36f65e9486a7",
    "slug": "alraaisi-alowais-advocates-legal-consultant",
    "name": "ALRAAISI & ALOWAIS ADVOCATES & LEGAL CONSULTANT",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/22/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/21/2021 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALRAAISI & ALOWAIS ADVOCATES & LEGAL CONSULTANT",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4d4c6395-3d11-4910-a051-36f65e9486a7",
        "address": "samia ibrahim hassan ahmed alraisi ,الميزانين مكتب رقم 8 ,الطوار سنتر ,بجوار وزارة التربية والتعليم  ووزارة العدل ,239353 ,Dubai",
        "phone": "97142680030 / 971503004400",
        "email": "info@aalegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "الميزانين مكتب رقم 8,الطوار سنتر,القصيص الثان",
    "phone": "97142680030",
    "email": "info@aalegal.ae",
    "registrationNumber": "ADF-2018-443"
  },
  {
    "id": "a4fce061-88d2-4308-9c3a-dbb02f5cbe82",
    "slug": "alrasheed-partners",
    "name": "ALRASHEED & PARTNERS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFQCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/12/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/11/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALRASHEED & PARTNERS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a4fce061-88d2-4308-9c3a-dbb02f5cbe82",
        "address": "6 ,Business Point ,Nissan Showroom  ,443 ,Dubai",
        "phone": "97142999991",
        "email": "dubai@alrasheed.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Rashed Mohammed Ali Mohammed Al-Rasheed",
    "address": "6,Business Point,Port Saeed,Dubai,443",
    "phone": "97142999991",
    "email": "dubai@alrasheed.ae",
    "registrationNumber": "ADF-2012-171"
  },
  {
    "id": "5684cb2e-d43e-411d-b69e-2e1976782a55",
    "slug": "alsaeedi-advocates-legal-consultants",
    "name": "ALSAEEDI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/16/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "01/15/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALSAEEDI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5684cb2e-d43e-411d-b69e-2e1976782a55",
        "address": "almetaq insurance  ,alnouf tower ,business vilage  ,92422 ,Dubai",
        "phone": "97142974555",
        "email": "info@alsaeedilaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Abdulla Abdulrahman Mohammed Al-Saeedi",
    "address": "almetaq insurance ,alnouf tower,um hurair,Dub",
    "phone": "97142974555",
    "email": "info@alsaeedilaw.ae",
    "registrationNumber": "ADF-2012-79"
  },
  {
    "id": "edc444ef-59f2-4e2d-ad83-413023ea6e33",
    "slug": "alsalman-advocates-and-legal-consultants",
    "name": "ALSALMAN ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/16/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/15/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALSALMAN ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_edc444ef-59f2-4e2d-ad83-413023ea6e33",
        "address": "2 ,BUSINESS AVENUE BUILDING ,NISSAN SHOWROOM  ,95230 ,Dubai",
        "phone": "97142999099",
        "email": "info@alsalmanadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "khalifa Rashid Hassan Ahmed Al Salman",
    "address": "2,BUSINESS AVENUE BUILDING,PORT SAEED DEIRA,D",
    "phone": "97142999099",
    "email": "info@alsalmanadvocates.ae",
    "registrationNumber": "ADF-2011-49"
  },
  {
    "id": "3de1a3a0-760f-4d53-95b1-cecbac061394",
    "slug": "alshaiba-advocates-legal-consultants",
    "name": "ALSHAIBA ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/20/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/19/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALSHAIBA ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3de1a3a0-760f-4d53-95b1-cecbac061394",
        "address": "MOHAMED IBRAHIM HASSAN ALSHAIBA ,KANA CAF ,51TOWER ,KANA CAFE ,35351 ,Dubai",
        "phone": "97142384444",
        "email": "Alshaiba@alshaibaadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "KANA CAF,51TOWER,BUSINESS BAY - AL ABRAJ STRE",
    "phone": "97142384444",
    "email": "Alshaiba@alshaibaadvocates.ae",
    "registrationNumber": "ADF-2012-198"
  },
  {
    "id": "0e5c3637-bc12-475c-a6b5-2d9ae84f2b8e",
    "slug": "al-suwaidi-company",
    "name": "AL-SUWAIDI & COMPANY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFDCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/28/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL-SUWAIDI & COMPANY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0e5c3637-bc12-475c-a6b5-2d9ae84f2b8e",
        "address": "Samia Luqman ,2nd floor ,Emarat Atrium Building ,across Holiday Inn Express Safa Park ,7273 ,Dubai",
        "phone": "97143211000",
        "email": "info@alsuwaidi.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Mohammed Rashed Mohammed Jabr Al-Suwiadi",
    "address": "2nd floor,Emarat Atrium Building,Sheikh Zayed",
    "phone": "97143211000",
    "email": "info@alsuwaidi.ae",
    "registrationNumber": "ADF-2011-74"
  },
  {
    "id": "eb927a69-9421-4515-bc18-08b71fb44bb2",
    "slug": "amal-al-rashdi-advocates-legal-consultants",
    "name": "AMAL AL RASHDI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/15/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AMAL AL RASHDI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_eb927a69-9421-4515-bc18-08b71fb44bb2",
        "address": "",
        "phone": "97142414303",
        "email": "info@eslegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Amal Abdulla Salem Saeed Alrashdi",
    "address": "N/A",
    "phone": "97142414303",
    "email": "info@eslegal.ae",
    "registrationNumber": "ADF-2023-712"
  },
  {
    "id": "f852bccd-2696-4190-9b40-77a8fb9c460f",
    "slug": "amal-albastaki-advocates-legal-consultancy",
    "name": "AMAL ALBASTAKI ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/05/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/04/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AMAL ALBASTAKI ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f852bccd-2696-4190-9b40-77a8fb9c460f",
        "address": "amal albastaki ,1903 ,court ,business bay ,127477 ,Dubai",
        "phone": "97142522202",
        "email": "info@amaladvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Amal Ibrahim Abdulla Kamal Poor Albastaki",
    "address": "1903,court,business bay,Dubai,127477",
    "phone": "97142522202",
    "email": "info@amaladvocates.com",
    "registrationNumber": "ADF-2012-113"
  },
  {
    "id": "f04c12ed-cc71-442c-b504-173bbb4d322f",
    "slug": "amal-alsubaei-advocates-legal-consultants",
    "name": "AMAL ALSUBAEI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/06/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "02/05/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AMAL ALSUBAEI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f04c12ed-cc71-442c-b504-173bbb4d322f",
        "address": "1302/ مكتب 1302 ,فندق الفيرمونت ,محطة مترو المركز التجاري ,33026 ,Dubai",
        "phone": "97143586113",
        "email": "info@ablawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Amal Omair Ali Albakri Alsebeyi",
    "address": "1302/ مكتب 1302,فندق الفيرمونت,شارع الشيخ زاي",
    "phone": "97143586113",
    "email": "info@ablawfirm.ae",
    "registrationNumber": "ADF-2012-89"
  },
  {
    "id": "99eb0f0c-7559-4826-a035-6f38ef3676a9",
    "slug": "amal-khamis-advocates-legal-consultants",
    "name": "AMAL KHAMIS ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFLCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/07/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/06/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AMAL KHAMIS ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_99eb0f0c-7559-4826-a035-6f38ef3676a9",
        "address": "Amal Khamis Darwish Al Blooshi ,floor23-office2304 ,Aspect Tower ,Bay Avenue ,103951 ,Dubai",
        "phone": "97142276165",
        "email": "info@amalkhamisadvo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "floor23-office2304,Aspect Tower,Business Bay,",
    "phone": "97142276165",
    "email": "info@amalkhamisadvo.com",
    "registrationNumber": "ADF-2014-327"
  },
  {
    "id": "27ee82c9-8f98-4b21-b9be-2de8fe329b61",
    "slug": "amani-alkindi-advocates-legal-consultants",
    "name": "AMANI ALKINDI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/11/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/10/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AMANI ALKINDI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_27ee82c9-8f98-4b21-b9be-2de8fe329b61",
        "address": "",
        "phone": "97148328997",
        "email": "info@alkindiadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Amani Abdalla Ali Abdalla Alkindi",
    "address": "N/A",
    "phone": "97148328997",
    "email": "info@alkindiadvocates.ae",
    "registrationNumber": "ADF-2023-693"
  },
  {
    "id": "7ed7234c-a176-47f9-b66e-18524305fe3e",
    "slug": "amer-al-marzooqi-advocates-legal-consultants",
    "name": "AMER AL MARZOOQI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/13/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/12/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AMER AL MARZOOQI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7ed7234c-a176-47f9-b66e-18524305fe3e",
        "address": "Amer Sayed Al Marzooqi ,603 ,SAMA TOWER ,TRADE CENTER ,41727 ,Dubai",
        "phone": "97142500023",
        "email": "info@mlegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Amer Sayed Mohammed Sayed Muhi Ruushin Al Marzooqi",
    "address": "603,SAMA TOWER,شارع الشيخ زايد,Dubai,41727",
    "phone": "97142500023",
    "email": "info@mlegal.ae",
    "registrationNumber": "ADF-2011-42"
  },
  {
    "id": "d4393464-394a-4311-ac7d-2247c5af8bad",
    "slug": "amira-saqer-advocates-legal-consultants",
    "name": "AMIRA SAQER ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/15/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/14/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AMIRA SAQER ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d4393464-394a-4311-ac7d-2247c5af8bad",
        "address": "B2207 ,لطيفة تاور ,بجانب فندق فوكو دبي‎ ,410889 ,Dubai",
        "phone": "97143447557",
        "email": "info@amirasaqeradvo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Amira Mohammad Saqer Mohammad Alsoori",
    "address": "B2207,لطيفة تاور,شارع الشيخ زايد ,Dubai,41088",
    "phone": "97143447557",
    "email": "info@amirasaqeradvo.com",
    "registrationNumber": "ADF-2017-420"
  },
  {
    "id": "0bd0eefd-956b-4c8b-ab5d-ebbcae894927",
    "slug": "amiri-advocates-legal-consultant",
    "name": "AMIRI ADVOCATES & LEGAL CONSULTANT",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/28/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AMIRI ADVOCATES & LEGAL CONSULTANT",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0bd0eefd-956b-4c8b-ab5d-ebbcae894927",
        "address": "",
        "phone": "97142999926",
        "email": "amiriadvocates@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Ahmad Mir Mutalleb Mir Murtadha Amiri",
    "address": "N/A",
    "phone": "97142999926",
    "email": "amiriadvocates@outlook.com",
    "registrationNumber": "ADF-2012-257"
  },
  {
    "id": "becf727c-133c-4718-b959-762d1beaee4d",
    "slug": "ammar-almulla-advocates-legal-consultants",
    "name": "AMMAR ALMULLA ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/01/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "01/31/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AMMAR ALMULLA ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_becf727c-133c-4718-b959-762d1beaee4d",
        "address": "",
        "phone": "97144298492",
        "email": "Ammaraalmulla@GMAIL.COM",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Ammar Ali Ahmed Ali Almulla",
    "address": "N/A",
    "phone": "97144298492",
    "email": "Ammaraalmulla@GMAIL.COM",
    "registrationNumber": "ADF-2024-717"
  },
  {
    "id": "d272aefd-4d27-44d1-9b31-1df8b0682365",
    "slug": "amna-almuhsen-advocates-legal-consultants",
    "name": "AMNA ALMUHSEN ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/02/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/01/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AMNA ALMUHSEN ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d272aefd-4d27-44d1-9b31-1df8b0682365",
        "address": "AMNA IBRAHIM ALMUHSEN ,الطابق الاول مكتب 110  ,مركز الدانة ,بجانب فندق كارلتون بالاس ,171300 ,Dubai",
        "phone": "97143300766",
        "email": "amnaadvo@eim.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Amna Ibrahim Mohammed Hassan Almuhsen",
    "address": "الطابق الاول مكتب 110 ,مركز الدانة,آل مكتوم,D",
    "phone": "97143300766",
    "email": "amnaadvo@eim.ae",
    "registrationNumber": "ADF-2016-377"
  },
  {
    "id": "a30322e3-d9be-4ba2-ba94-2ebf6f963319",
    "slug": "amna-alzaabi-advocates-legal-consultants",
    "name": "AMNA ALZAABI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/28/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/27/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AMNA ALZAABI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a30322e3-d9be-4ba2-ba94-2ebf6f963319",
        "address": "amna alzaabi ,213 ,مبنى مكاتب عود ميثاء ,سيتي بنك ,16189 ,Dubai",
        "phone": "97145822422",
        "email": "info@amnalegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Amna Abdalla Matar Abdalla Alzaabi",
    "address": "213,مبنى مكاتب عود ميثاء,شارع عود ميثاء,Dubai",
    "phone": "97145822422",
    "email": "info@amnalegal.com",
    "registrationNumber": "ADF-2022-615"
  },
  {
    "id": "f8f827cb-389c-48f1-841e-a39afdd09f7d",
    "slug": "apex-juris-advocates-legal-consultants",
    "name": "APEX JURIS ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFKCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/06/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/05/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: APEX JURIS ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f8f827cb-389c-48f1-841e-a39afdd09f7d",
        "address": "TWENTY ,ALMASRAF TOWER ,DUBAI MUNICIPALITY ,3858 ,Dubai",
        "phone": "97142222314",
        "email": "apxjuris@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Makkawi Awadh Al-Makkawi Ismail",
    "address": "TWENTY,ALMASRAF TOWER,Beniyas Street / Riqqa",
    "phone": "97142222314",
    "email": "apxjuris@emirates.net.ae",
    "registrationNumber": "ADF-2012-165"
  },
  {
    "id": "aab79fde-e700-45d7-904f-bde0a593a087",
    "slug": "araa-group-advocates-legal-consultants",
    "name": "ARAA GROUP ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFHCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/16/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/15/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ARAA GROUP ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_aab79fde-e700-45d7-904f-bde0a593a087",
        "address": "Ali Saleh Atrooz  ,1103 ,EMPIRE HEIGHTS B ,دبي مول  ,18433 ,Dubai",
        "phone": "97142222511",
        "email": "info@araalaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Abdulla Yousof Ahmad Abdulqader Al Nasser",
    "address": "1103,EMPIRE HEIGHTS B,الخليج التجاري ,Dubai,1",
    "phone": "97142222511",
    "email": "info@araalaw.com",
    "registrationNumber": "ADF-2012-141"
  },
  {
    "id": "2a8599d2-a4d7-4456-9165-ad546262d108",
    "slug": "arif-bushaqer-advocates-legal-consultants",
    "name": "ARIF BUSHAQER ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFCCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/24/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/23/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ARIF BUSHAQER ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2a8599d2-a4d7-4456-9165-ad546262d108",
        "address": "",
        "phone": "97145770472",
        "email": "bushaqer4@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Arif Mohammad Obaid Bushaqer Alfalasi",
    "address": "N/A",
    "phone": "97145770472",
    "email": "bushaqer4@gmail.com",
    "registrationNumber": "ADF-2022-635"
  },
  {
    "id": "bd7685ea-a57c-4a81-8b1b-d6c690263d86",
    "slug": "ashwaq-qaid-advocates-legal-consultants",
    "name": "ASHWAQ QAID ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFRCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/12/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "08/11/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ASHWAQ QAID ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bd7685ea-a57c-4a81-8b1b-d6c690263d86",
        "address": "",
        "phone": "97148812191 / 971526343439",
        "email": "info@aqadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Ashwaq Qaid Nasser Alqamesh",
    "address": "N/A",
    "phone": "97148812191",
    "email": "info@aqadvocates.com",
    "registrationNumber": "ADF-2024-739"
  },
  {
    "id": "aa022dc2-ef28-4d77-8cfc-629cfc691bf2",
    "slug": "asma-ali-almessabi-advocates-and-legal-consultants",
    "name": "ASMA ALI ALMESSABI ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/04/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/03/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ASMA ALI ALMESSABI ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_aa022dc2-ef28-4d77-8cfc-629cfc691bf2",
        "address": "",
        "phone": "97143269559 / 971552095466",
        "email": "admin@asmaadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "303-09,الخيمة,بور سعيد,Dubai,3235694882",
    "phone": "97143269559",
    "email": "admin@asmaadvocates.com",
    "registrationNumber": "ADF-2021-564"
  },
  {
    "id": "3ab5603b-a1b7-45e3-8c5a-2c1b1dfc1a5f",
    "slug": "asmaa-abulla-alabdouli-advocates-and-legal-consultants",
    "name": "ASMAA ABULLA ALABDOULI ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/13/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/12/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ASMAA ABULLA ALABDOULI ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3ab5603b-a1b7-45e3-8c5a-2c1b1dfc1a5f",
        "address": "Second Floor - Office B2 ,Al Khor Tower ,Makani No: 3027595041 ,000 ,Dubai",
        "phone": "97143322613 / 971527759923",
        "email": "asmaaalabdouliadvocates@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Asmaa Abdulla Saeed khameis Alabdouli",
    "address": "Second Floor - Office B2,Al Khor Tower,Deira,",
    "phone": "97143322613",
    "email": "asmaaalabdouliadvocates@gmail.com",
    "registrationNumber": "ADF-2023-701"
  },
  {
    "id": "11a91dbf-baf8-4c44-9d14-8059e4c80590",
    "slug": "asmaa-altamimi-advocates-and-legal-consultants",
    "name": "ASMAA ALTAMIMI ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/07/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ASMAA ALTAMIMI ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_11a91dbf-baf8-4c44-9d14-8059e4c80590",
        "address": "",
        "phone": "97100000000",
        "email": "info@lawyeraaltamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "ASMAA ABDULLA YAQOOT DHEYAB ALTAMIMI",
    "address": "N/A",
    "phone": "97100000000",
    "email": "info@lawyeraaltamimi.com",
    "registrationNumber": "ADF-2023-711"
  },
  {
    "id": "dfb85a31-3414-4198-9ccd-c3ae8ac4ed71",
    "slug": "awad-alaryani-advocates-legal-consultancy",
    "name": "AWAD ALARYANI ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/20/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/19/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AWAD ALARYANI ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dfb85a31-3414-4198-9ccd-c3ae8ac4ed71",
        "address": "",
        "phone": "97143444491 / 971508002092",
        "email": "awdfms@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Dr. Awad Mohammed Matar Mohammed Alaryani",
    "address": "N/A",
    "phone": "97143444491",
    "email": "awdfms@gmail.com",
    "registrationNumber": "ADF-2017-421"
  },
  {
    "id": "c4d62742-d18f-4b40-a85c-e95245605003",
    "slug": "awadh-almheiri-advocates-legal-consultants",
    "name": "AWADH ALMHEIRI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/18/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/17/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AWADH ALMHEIRI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c4d62742-d18f-4b40-a85c-e95245605003",
        "address": "",
        "phone": "/ 971509449447",
        "email": "awadh.a.lflc@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "AWADH MUBARAK RASHED BIN ZERAIJ ALMEHAIRI",
    "address": "N/A",
    "phone": "N/A",
    "email": "awadh.a.lflc@gmail.com",
    "registrationNumber": "ADF-2024-751-1"
  },
  {
    "id": "759f5477-fdbd-406b-8831-354639c31036",
    "slug": "awatif-mohammad-shoqi-advocates-legal-consultancy",
    "name": "AWATIF MOHAMMAD SHOQI ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/20/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/19/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AWATIF MOHAMMAD SHOQI ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_759f5477-fdbd-406b-8831-354639c31036",
        "address": "29 ,ذا اتش هوتيل ,فندق فيرمونت ,40073 ,Dubai",
        "phone": "97143254000",
        "email": "info@alrowaad.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Awatif Mohammed Showqi",
    "address": "29,ذا اتش هوتيل,البدع,Dubai,40073",
    "phone": "97143254000",
    "email": "info@alrowaad.ae",
    "registrationNumber": "ADF-2012-199"
  },
  {
    "id": "7c6b5984-e1c6-4726-b68d-0413ab504704",
    "slug": "ayesha-al-jaziri-advocates-legal-consultants",
    "name": "AYESHA AL JAZIRI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/21/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/20/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AYESHA AL JAZIRI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7c6b5984-e1c6-4726-b68d-0413ab504704",
        "address": "",
        "phone": "",
        "email": "info@aljaziriadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Ayesha Abdulsalam Mohammad Aljaziri",
    "address": "19,S.I.T Tower,واحه السليكون,Dubai,3116",
    "phone": "N/A",
    "email": "info@aljaziriadvocates.com",
    "registrationNumber": "ADF-2024-747"
  },
  {
    "id": "0892f012-3fc4-4895-8d3b-abbb036938aa",
    "slug": "ayesha-aldhaheri-advocates-legal-consultants",
    "name": "AYESHA ALDHAHERI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/07/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "02/06/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AYESHA ALDHAHERI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0892f012-3fc4-4895-8d3b-abbb036938aa",
        "address": "Office 308 ,Owned by ACICO Gulf Real Estate LLC, Dubai branch ,Makani No: 3250094543 ,000 ,Dubai",
        "phone": "97142697998 / 971503567998",
        "email": "info@ayshamslaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Ayesha Sabt Jawhar Suwaid Aldhaheri",
    "address": "Office 308,Owned by ACICO Gulf Real Estate LL",
    "phone": "97142697998",
    "email": "info@ayshamslaw.com",
    "registrationNumber": "ADF-2024-718"
  },
  {
    "id": "fbf6220f-2608-4caa-895e-d45ae8a259a2",
    "slug": "azza-ebrahim-hasan-almulla-advocates-and-legal-consultants",
    "name": "AZZA EBRAHIM HASAN ALMULLA ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFFCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/17/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/16/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AZZA EBRAHIM HASAN ALMULLA ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fbf6220f-2608-4caa-895e-d45ae8a259a2",
        "address": "Azza Ebrahim Hasan Almulla ,6(602-603) ,Al Shoalla Building (Al Naboodah) ,deira city center ,12871 ,Dubai",
        "phone": "97142950010",
        "email": "dubai-secretary@dralmulla.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Azza Ebrahim Hasan Almulla Almansoori",
    "address": "6(602-603),Al Shoalla Building (Al Naboodah),",
    "phone": "97142950010",
    "email": "dubai-secretary@dralmulla.com",
    "registrationNumber": "ADF-2011-50"
  },
  {
    "id": "9ae2d0ab-41cc-421c-8579-e2f2b211ddf0",
    "slug": "b-s-a-ahmed-bin-hazeem-associates",
    "name": "B S A AHMED BIN HAZEEM & ASSOCIATES",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEJTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/28/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/27/2025 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: B S A AHMED BIN HAZEEM & ASSOCIATES",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9ae2d0ab-41cc-421c-8579-e2f2b211ddf0",
        "address": "Unit No. 509-8,  ,Apricot Tower ,Dubai Silicon Oasis ,262 ,Dubai",
        "phone": "97143685555",
        "email": "info@bsabh.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "Unit No. 509-8, ,Apricot Tower,Dubai,Dubai,26",
    "phone": "97143685555",
    "email": "info@bsabh.com",
    "registrationNumber": "ADF-2012-129"
  },
  {
    "id": "8afa232f-52ff-4dad-82c3-9a04d66eb853",
    "slug": "b-s-a-ahmed-bin-hazeem-associates-llp-difc",
    "name": "B S A AHMED BIN HAZEEM & ASSOCIATES LLP - DIFC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEJTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/28/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: B S A AHMED BIN HAZEEM & ASSOCIATES LLP - DIFC",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8afa232f-52ff-4dad-82c3-9a04d66eb853",
        "address": "",
        "phone": "97143685555",
        "email": "maisa.maarouf@bsabh.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Dr. Ahmed Saeed Salem Bin Hazeem",
    "address": "N/A",
    "phone": "97143685555",
    "email": "maisa.maarouf@bsalaw.com",
    "registrationNumber": "ADF-2012-104"
  },
  {
    "id": "c507bf6b-00f8-4c70-8580-9e267ce5bbf3",
    "slug": "bader-hamad-alzaabi-advocates-legal-consultants",
    "name": "BADER HAMAD ALZAABI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEJICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/30/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "01/02/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: BADER HAMAD ALZAABI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c507bf6b-00f8-4c70-8580-9e267ce5bbf3",
        "address": "",
        "phone": "97142555111 / 971500000000",
        "email": "info@legalemirates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Anwar Nabil Anwar Elemiry",
    "address": "N/A",
    "phone": "97142555111",
    "email": "info@legalemirates.com",
    "registrationNumber": "ADF-2019-492"
  },
  {
    "id": "a1a1a791-7d0a-4afa-a043-cd85f0998888",
    "slug": "baitulhikma-lawyers",
    "name": "BAITULHIKMA LAWYERS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEJMCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/15/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/14/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: BAITULHIKMA LAWYERS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a1a1a791-7d0a-4afa-a043-cd85f0998888",
        "address": "الطابق 8 مكتب رقم 802-804 ,AL MASAOOD TOWE 2 ,الفطيم للسيارات  - ديرة  ,31909 ,Dubai",
        "phone": "97142946948",
        "email": "hadi.jomah@baitulhikma.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Mohammed Essa Sultan Al-Sowaidi",
    "address": "الطابق 8 مكتب رقم 802-804,AL MASAOOD TOWE 2,ب",
    "phone": "97142946948",
    "email": "hadi.jomah@baitulhikma.com",
    "registrationNumber": "ADF-2012-176"
  },
  {
    "id": "6530c077-1201-41ce-b3d8-f4966b7cc2aa",
    "slug": "bamedhaf-associates",
    "name": "BAMEDHAF ASSOCIATES",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEJBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/06/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/05/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: BAMEDHAF ASSOCIATES",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6530c077-1201-41ce-b3d8-f4966b7cc2aa",
        "address": "M4 ,DAR AL SAFIYA BLDG ,مستشفى إن إم سي ,40403 ,Dubai",
        "phone": "97142294666",
        "email": "bamlegal@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "ABDULLA HASSAN AHMED BAMEDHAF",
    "address": "M4,DAR AL SAFIYA BLDG,AL QUDS STREET,Dubai,40",
    "phone": "97142294666",
    "email": "bamlegal@emirates.net.ae",
    "registrationNumber": "ADF-2012-159"
  },
  {
    "id": "a1c5fd44-9a8b-4235-8ba0-8499d6832520",
    "slug": "bashar-almasayba-advocates-legal-consultants",
    "name": "BASHAR ALMASAYBA ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEJBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/21/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "07/20/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: BASHAR ALMASAYBA ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a1c5fd44-9a8b-4235-8ba0-8499d6832520",
        "address": "",
        "phone": "97143266669 / 971505479696",
        "email": "almasayba@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Bashar Abdalla Ali Ibrahim Almasayba",
    "address": "N/A",
    "phone": "97143266669",
    "email": "almasayba@hotmail.com",
    "registrationNumber": "ADF-2014-321"
  },
  {
    "id": "ea633c29-6b4a-48a8-aaec-c801ece50744",
    "slug": "bin-eid-advocates-legal-consultants",
    "name": "BIN EID ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEJFCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/23/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "02/22/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: BIN EID ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ea633c29-6b4a-48a8-aaec-c801ece50744",
        "address": "ABDULLKAREIM AHMED ABDULLA EID ,الطابق الثانى - مكتب رقم 014 ,مركز الممزر  ,مقابل القياده العامه لشرطة دبي - بجوار مكتب وزارة العمل والعمال القديم  ,89505 ,Dubai",
        "phone": "97142388850",
        "email": "bineidadvocates@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "الطابق الثانى - مكتب رقم 014,مركز الممزر ,شار",
    "phone": "97142388850",
    "email": "bineidadvocates@gmail.com",
    "registrationNumber": "ADF-2012-103"
  },
  {
    "id": "61266d12-f5b4-4466-a1a8-a45934d9e511",
    "slug": "bin-haider-advocates-legal-consultants",
    "name": "BIN HAIDER ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEJICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/25/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "01/24/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: BIN HAIDER ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_61266d12-f5b4-4466-a1a8-a45934d9e511",
        "address": "18 ,فندق مونارك  ,مركز التجاري ,98444 ,Dubai",
        "phone": "97143588777",
        "email": "info@bhadvoc.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Essa Abdullah Heedar Bin Heedar",
    "address": "18,فندق مونارك ,الشارع الشيخ زايد,Dubai,98444",
    "phone": "97143588777",
    "email": "info@bhadvoc.com",
    "registrationNumber": "ADF-2012-82"
  },
  {
    "id": "19d3b420-9a9f-4734-8da2-1f2abf00e898",
    "slug": "bin-ismail-advocates-legal-consultants",
    "name": "BIN ISMAIL ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEJJCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/21/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/20/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: BIN ISMAIL ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_19d3b420-9a9f-4734-8da2-1f2abf00e898",
        "address": "10 ,Rigga Al Bateen Plaza Building ,اعلي مطعم صدف الايراني  ,115791 ,Dubai",
        "phone": "97142666352",
        "email": "bnesmael@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "10,Rigga Al Bateen Plaza Building,Deira – Al",
    "phone": "97142666352",
    "email": "bnesmael@yahoo.com",
    "registrationNumber": "ADF-2012-127"
  },
  {
    "id": "92b4dcc3-f700-41f5-a968-832fa8e3f315",
    "slug": "bin-khalfoon-advocates-and-legal-consultants",
    "name": "BIN KHALFOON ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEJLCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/16/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "08/15/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: BIN KHALFOON ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_92b4dcc3-f700-41f5-a968-832fa8e3f315",
        "address": "الرابع ,ذا اتريوم سنتر ,محطة مترو الفهيدي ,33773 ,Dubai",
        "phone": "97143795050",
        "email": "lawyerbk@eim.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Adil Humaid Rashid Bin Khalfoon Al-Ali",
    "address": "الرابع,ذا اتريوم سنتر,شارع خالد بن الوليد,Dub",
    "phone": "97143795050",
    "email": "lawyerbk@eim.ae",
    "registrationNumber": "ADF-2012-240"
  },
  {
    "id": "d4ea63a4-952e-4374-a9df-97a521bb4cd5",
    "slug": "bin-meshar-co-advocates-legal-consultants",
    "name": "BIN MESHAR & CO ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEJNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/03/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/02/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: BIN MESHAR & CO ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d4ea63a4-952e-4374-a9df-97a521bb4cd5",
        "address": "4th Floor – offices 408 - 411 - 412 ,Business Village Building  - Block B ,Near Clock Tower ,49425 ,Dubai",
        "phone": "97143869999 / 971506446650",
        "email": "advocates@binmeshar.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "4th Floor – offices 408 - 411 - 412,Business",
    "phone": "97143869999",
    "email": "advocates@binmeshar.com",
    "registrationNumber": "ADF-2012-244"
  },
  {
    "id": "4d3c9dcc-51c6-4883-b9ed-c65a7d1c5a57",
    "slug": "bin-sevan-advocates-legal-consultancy",
    "name": "BIN SEVAN ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEJTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/02/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "07/01/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: BIN SEVAN ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4d3c9dcc-51c6-4883-b9ed-c65a7d1c5a57",
        "address": "Firas Hassan Al Choufi ,701 ,The Prime Tower ,Makani No: 25836 86879 ,125305 ,Dubai",
        "phone": "97144357246",
        "email": "info@binsevanadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "GHAZI IBRAHIM AHMAD BIN SIFAN",
    "address": "701,The Prime Tower,Sheikh Khalifa Street, Bu",
    "phone": "97144357246",
    "email": "info@binsevanadvocates.com",
    "registrationNumber": "ADF-2012-213"
  },
  {
    "id": "36d64a1b-4461-4159-9965-ed44c59d3e88",
    "slug": "bin-sowaidan-advocates-legal-consultantcy",
    "name": "BIN SOWAIDAN ADVOCATES & LEGAL CONSULTANTCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEJTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/26/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/25/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: BIN SOWAIDAN ADVOCATES & LEGAL CONSULTANTCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_36d64a1b-4461-4159-9965-ed44c59d3e88",
        "address": "4 ,ALHUDIBA AWARD COMPLEX BLOCK B ,UNION FLAG HOUSE ,50229 ,Dubai",
        "phone": "97143258888 / 971501009595",
        "email": "hr@binsowaidan.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Abdul Munem Salem Obaid Bin Sowaidan",
    "address": "4,ALHUDIBA AWARD COMPLEX BLOCK B,2ND OF DECEM",
    "phone": "97143258888",
    "email": "hr@binsowaidan.ae",
    "registrationNumber": "ADF-2011-02"
  },
  {
    "id": "7adc24ae-eaae-40c6-a30b-5097991f467b",
    "slug": "bujessaim-al-maliki-advocates-legal-consultants",
    "name": "BUJESSAIM & AL MALIKI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEJBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "07/28/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: BUJESSAIM & AL MALIKI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7adc24ae-eaae-40c6-a30b-5097991f467b",
        "address": "",
        "phone": "97142221758 / 971506984647",
        "email": "droit@eim.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Rashed Mohammed Saed Bu-Jusaim",
    "address": "N/A",
    "phone": "97142221758",
    "email": "droit@eim.ae",
    "registrationNumber": "ADF-2012-232"
  },
  {
    "id": "ebfce11b-8cb4-42cc-95d3-71c6e17bfdf0",
    "slug": "busit-advocates-and-legal-consultants",
    "name": "BUSIT ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEJBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/25/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "01/24/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: BUSIT ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ebfce11b-8cb4-42cc-95d3-71c6e17bfdf0",
        "address": "OBAID SAQER OBAID BUSIT ,20 ,Grosvenor Business Tower -  ,Sheikha noora tower ,333341 ,Dubai",
        "phone": "97144472777",
        "email": "busit@busitlegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Obaid Saqer Obaid Busit",
    "address": "20,Grosvenor Business Tower - ,شارع 11,Dubai,",
    "phone": "97144472777",
    "email": "busit@busitlegal.com",
    "registrationNumber": "ADF-2012-81"
  },
  {
    "id": "de3ee3af-bda3-4ac6-96b7-fc737b52458c",
    "slug": "daina-hamade-attornyes-at-law",
    "name": "DAINA HAMADE ATTORNYES AT LAW",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIERICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/05/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/04/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: DAINA HAMADE ATTORNYES AT LAW",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_de3ee3af-bda3-4ac6-96b7-fc737b52458c",
        "address": "Diana Mohamed Hamade ,A.301.S-7 ,Multaqa Avenue 1 ,Mirdif ,10223 ,Dubai",
        "phone": "97142733029",
        "email": "info@dianahamade.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Diana mohd hamada",
    "address": "A.301.S-7,Multaqa Avenue 1,78,Dubai,10223",
    "phone": "97142733029",
    "email": "info@dianahamade.ae",
    "registrationNumber": "ADF-2012-185"
  },
  {
    "id": "564fc438-ce0f-40b0-9dc2-c01709da9e46",
    "slug": "dalmook-mohammed-dalmook-advocate-legal-consultancy",
    "name": "DALMOOK MOHAMMED DALMOOK ( ADVOCATE & LEGAL CONSULTANCY )",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIERNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/05/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/04/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: DALMOOK MOHAMMED DALMOOK ( ADVOCATE & LEGAL CONSULTANCY )",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_564fc438-ce0f-40b0-9dc2-c01709da9e46",
        "address": "dalmook mohamed bin dalmook ,التاسع - مكتب 901 ,الشركة الوطنية للتأمينات العامة NGI ,مقابل سيتي سنتر ديرة بجوار سندس سويتس مريديان وفلورا كريك هوتيل ,3467 ,Dubai",
        "phone": "97142989222 / 971506455800",
        "email": "information@dalmook.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Dalmook Mohammed Humaid Dalmook",
    "address": "التاسع - مكتب 901,الشركة الوطنية للتأمينات ال",
    "phone": "97142989222",
    "email": "information@dalmook.ae",
    "registrationNumber": "ADF-2011-23"
  },
  {
    "id": "61efd89c-1d0d-4136-8397-2814c745f0da",
    "slug": "dar-al-adalah-advocates-legal-consultants",
    "name": "DAR AL ADALAH ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIERBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/05/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: DAR AL ADALAH ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_61efd89c-1d0d-4136-8397-2814c745f0da",
        "address": "",
        "phone": "97143355577",
        "email": "daraladalah1991@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Abdulla Mutar Khames Al-Mezaina",
    "address": "N/A",
    "phone": "97143355577",
    "email": "daraladalah1991@gmail.com",
    "registrationNumber": "ADF-2011-61"
  },
  {
    "id": "183a898c-3779-4747-92dd-33a8feb6a42c",
    "slug": "dar-al-balagh-advocates-legal-consultancy",
    "name": "DAR AL BALAGH ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIERBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/11/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: DAR AL BALAGH ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_183a898c-3779-4747-92dd-33a8feb6a42c",
        "address": "1404 ,توين  تاورز  ,بجانب فندق ريدسون بلو  ,40227 ,Dubai",
        "phone": "97142222407",
        "email": "info@daralbalaghadvocate.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Masooma Hassan Naser Al-Sayegh",
    "address": "1404,توين  تاورز ,بني ياس  / ديرة / الرقة ,Du",
    "phone": "97142222407",
    "email": "info@daralbalaghadvocate.com",
    "registrationNumber": "ADF-2011-64"
  },
  {
    "id": "3eaca0c8-938e-4864-add1-73e5c902b168",
    "slug": "dar-al-bayan-advocates-legal-consultants",
    "name": "DAR AL BAYAN ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIERBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/26/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "07/25/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: DAR AL BAYAN ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3eaca0c8-938e-4864-add1-73e5c902b168",
        "address": "",
        "phone": "97142212494",
        "email": "bayanlaw@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97142212494",
    "email": "bayanlaw@emirates.net.ae",
    "registrationNumber": "ADF-2012-230"
  },
  {
    "id": "e9592d3b-4f5e-43bf-9305-f85447bc9653",
    "slug": "dar-al-hekmah-lawyers-legal-consultancy",
    "name": "DAR AL HEKMAH LAWYERS & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIERBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/11/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: DAR AL HEKMAH LAWYERS & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e9592d3b-4f5e-43bf-9305-f85447bc9653",
        "address": "الثامن مكتب 815 ,بزنس افينو  ,خلف وكالة نيسان  ,57134 ,Dubai",
        "phone": "97145463588",
        "email": "hisham@daralhekma.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "الثامن مكتب 815,بزنس افينو ,ديره - بورسعيد ,D",
    "phone": "97145463588",
    "email": "hisham@daralhekma.ae",
    "registrationNumber": "ADF-2011-63"
  },
  {
    "id": "a35adad8-13e3-467b-8652-912b433c3fa4",
    "slug": "dar-al-huqooq-legal-consultants",
    "name": "DAR AL HUQOOQ LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIERBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/15/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/14/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: DAR AL HUQOOQ LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a35adad8-13e3-467b-8652-912b433c3fa4",
        "address": "",
        "phone": "97142211313",
        "email": "info@daralhuqooq.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Maroun Wadih Matar",
    "address": "N/A",
    "phone": "97142211313",
    "email": "info@daralhuqooq.com",
    "registrationNumber": "ADF-2012-175"
  },
  {
    "id": "b7a53c09-124c-4689-81ff-992765c70b8a",
    "slug": "deaifis-advocates-legal-consultants",
    "name": "DEAIFIS ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIERBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/25/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/24/2019 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: DEAIFIS ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b7a53c09-124c-4689-81ff-992765c70b8a",
        "address": "8 ,Burlington Tower ,SAFA park ,46886 ,Dubai",
        "phone": "97143425552 / 971509025904",
        "email": "info@deaifis.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "8,Burlington Tower,Business Bay,Dubai,46886",
    "phone": "97143425552",
    "email": "info@deaifis.com",
    "registrationNumber": "ADF-2012-205"
  },
  {
    "id": "1d2a0393-9ac4-495c-aa17-4eedfdb418af",
    "slug": "dr-adil-almemari-advocates-legal-consultants",
    "name": "DR ADIL ALMEMARI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIERBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/27/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/26/2018 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: DR ADIL ALMEMARI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1d2a0393-9ac4-495c-aa17-4eedfdb418af",
        "address": "",
        "phone": "97142438663",
        "email": "bosabbahmed@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Adel Abdulla Khamis Al-Maameri",
    "address": "N/A",
    "phone": "97142438663",
    "email": "bosabbahmed@yahoo.com",
    "registrationNumber": "ADF-2014-330"
  },
  {
    "id": "c31ad0e5-b382-4c9a-9fab-8853b1330f6b",
    "slug": "dr-al-sabbhan-legal-group",
    "name": "DR AL SABBHAN LEGAL GROUP",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIERBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/07/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/06/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: DR AL SABBHAN LEGAL GROUP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c31ad0e5-b382-4c9a-9fab-8853b1330f6b",
        "address": "",
        "phone": "97143474007",
        "email": "info@alsabhanlegalgroup.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Fahad Ibrahim Abdulrahman Mohammed Al-Sabhan",
    "address": "N/A",
    "phone": "97143474007",
    "email": "info@alsabhanlegalgroup.com",
    "registrationNumber": "ADF-2012-166"
  },
  {
    "id": "09f7b67c-8405-4dc9-982f-b8f9b921043c",
    "slug": "dr-amira-al-bastaki-advocates-and-legal-consultant",
    "name": "DR AMIRA AL BASTAKI ADVOCATES AND LEGAL CONSULTANT",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIERBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/31/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/30/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: DR AMIRA AL BASTAKI ADVOCATES AND LEGAL CONSULTANT",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_09f7b67c-8405-4dc9-982f-b8f9b921043c",
        "address": "11 ,ميلينيوم بلازا  ,بجوار محطة ابراج الأمارات  ,410961 ,Dubai",
        "phone": "97142954626",
        "email": "info@advoamira.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Amira Ibrahim Abdoulla Abdulwahid Kamal Poor AlBastaki",
    "address": "11,ميلينيوم بلازا ,شارع الشيخ زايد ,Dubai,410",
    "phone": "97142954626",
    "email": "info@advoamira.ae",
    "registrationNumber": "ADF-2013-286"
  },
  {
    "id": "45fb8910-008e-414c-8a9b-d5ab51b7d2f6",
    "slug": "dr-ghaith-alsuwaidi-advocates-legal-consultants",
    "name": "DR GHAITH ALSUWAIDI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIERHCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/21/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/20/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: DR GHAITH ALSUWAIDI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_45fb8910-008e-414c-8a9b-d5ab51b7d2f6",
        "address": "",
        "phone": "97143411355 / 971505527552",
        "email": "advocates@drghaith.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Gaith Ghanim Saif Obaid Alsuwaifi",
    "address": "N/A",
    "phone": "97143411355",
    "email": "advocates@drghaith.com",
    "registrationNumber": "ADF-2024-746"
  },
  {
    "id": "23c4faff-c170-4bb3-a3be-3279aa038027",
    "slug": "dr-hamad-alustath-advocates-legal-consultants",
    "name": "DR HAMAD ALUSTATH ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIERICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/16/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: DR HAMAD ALUSTATH ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_23c4faff-c170-4bb3-a3be-3279aa038027",
        "address": "",
        "phone": "97142959844 / 971501411515",
        "email": "info@alustathlawfirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Hamad ibrahim ahmad ali alustath",
    "address": "N/A",
    "phone": "97142959844",
    "email": "info@alustathlawfirm.com",
    "registrationNumber": "ADF-2025-772"
  },
  {
    "id": "63cfb3ce-7534-4062-bf6b-f32265680c63",
    "slug": "dr-jamal-al-marri-advocates-legal-services",
    "name": "DR JAMAL AL MARRI ADVOCATES & LEGAL SERVICES",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIERKCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/25/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "12/24/2024 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: DR JAMAL AL MARRI ADVOCATES & LEGAL SERVICES",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_63cfb3ce-7534-4062-bf6b-f32265680c63",
        "address": "1st floor office no.122 ,khalfan Business Center ,khalfan Business Center ,124289 ,Dubai",
        "phone": "97143806882",
        "email": "info@drjamaladvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "1st floor office no.122,khalfan Business Cent",
    "phone": "97143806882",
    "email": "info@drjamaladvocates.com",
    "registrationNumber": "ADF-2011-72"
  },
  {
    "id": "1b84b124-19de-41b5-89de-ec40b2bd1d01",
    "slug": "dr-jamal-alnuaimi-advocates-legal-consultants",
    "name": "DR JAMAL ALNUAIMI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIERKCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/12/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/11/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: DR JAMAL ALNUAIMI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1b84b124-19de-41b5-89de-ec40b2bd1d01",
        "address": "",
        "phone": "97142722998",
        "email": "jalnuaimi.adv@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Dr. Jamal Abdulrahman Jasem Albagham Alnuaimi",
    "address": "N/A",
    "phone": "97142722998",
    "email": "jalnuaimi.adv@outlook.com",
    "registrationNumber": "ADF-2023-663-1"
  },
  {
    "id": "8a3b8670-2b6e-4692-b71b-6abf145a3b6a",
    "slug": "dr-khaled-ali-alhadhrami-advocates-legal-consultants",
    "name": "DR KHALED ALI ALHADHRAMI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIERLCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/23/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: DR KHALED ALI ALHADHRAMI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8a3b8670-2b6e-4692-b71b-6abf145a3b6a",
        "address": "",
        "phone": "/ 971506158015",
        "email": "lawyer.uae@live.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Khaled Ali Mohamed Ali Alhadhrami",
    "address": "N/A",
    "phone": "N/A",
    "email": "lawyer.uae@live.com",
    "registrationNumber": "ADF-2025-777"
  },
  {
    "id": "612e75e6-c3f3-479b-bc93-ee88982dea58",
    "slug": "dr-mohamed-alhammadi-advocates-legal-consultants-office",
    "name": "DR MOHAMED ALHAMMADI ADVOCATES & LEGAL CONSULTANTS OFFICE",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIERNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/17/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/16/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: DR MOHAMED ALHAMMADI ADVOCATES & LEGAL CONSULTANTS OFFICE",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_612e75e6-c3f3-479b-bc93-ee88982dea58",
        "address": "Mohamed Alhammadi ,FLOOR 16 OFFICE B1605 ,LATIFA TOWER ,CLOSE TO CROWN PLAZA HOTEL ,76550 ,Dubai",
        "phone": "97143298866",
        "email": "admin@dralhammadilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Mohamed Shaker Jumaa Hasan Alhammadi",
    "address": "FLOOR 16 OFFICE B1605,LATIFA TOWER,SHEIK ZAYE",
    "phone": "97143298866",
    "email": "admin@dralhammadilaw.com",
    "registrationNumber": "ADF-2012-143"
  },
  {
    "id": "cfc90bc1-eca3-4d64-879b-70aeaa0925d3",
    "slug": "dr-mohamed-almur-advocates-legal-consultants",
    "name": "DR MOHAMED ALMUR ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIERNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/07/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/06/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: DR MOHAMED ALMUR ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cfc90bc1-eca3-4d64-879b-70aeaa0925d3",
        "address": "",
        "phone": "97143944088 / 971547800401",
        "email": "info@almurlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Mohamed Abdalla Mohamed Abdalla AlMur",
    "address": "N/A",
    "phone": "97143944088",
    "email": "info@almurlaw.com",
    "registrationNumber": "ADF-2024-744"
  },
  {
    "id": "14541022-bde4-43ab-9ba1-489e87187b42",
    "slug": "dr-sarhan-almuaini-advocates-legal-consultants",
    "name": "DR SARHAN ALMUAINI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIERTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/16/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/15/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: DR SARHAN ALMUAINI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_14541022-bde4-43ab-9ba1-489e87187b42",
        "address": "Sarhan Hassan Mohamed Hassan Almuaini ,Office 1002, Level 10 ,THE OBEROI CENTRE ,Business Bay Metro Station ,1169 ,Dubai",
        "phone": "97142324000",
        "email": "info@drsarhanlawyer.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Sarhan Hassan Mohamed Hassan Almuaini",
    "address": "Office 1002, Level 10,THE OBEROI CENTRE,الاعم",
    "phone": "97142324000",
    "email": "info@drsarhanlawyer.ae",
    "registrationNumber": "ADF-2017-404"
  },
  {
    "id": "653e8321-5f9e-4eae-8740-cc250fc3a19b",
    "slug": "dr-zubaida-jasim-almaazmi-advocates-legal-consultants",
    "name": "DR ZUBAIDA JASIM ALMAAZMI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIERaCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/05/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "12/04/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: DR ZUBAIDA JASIM ALMAAZMI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_653e8321-5f9e-4eae-8740-cc250fc3a19b",
        "address": "3rd Floor - Office No. 301 ,Wasel Business Building ,Makani No: 3242894178 ,000 ,Dubai",
        "phone": "97145460005 / 971552666381",
        "email": "Dr.khaled1234@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "DR. Zubaida Jasim Mohamed Ismail Almaazmi",
    "address": "3rd Floor - Office No. 301,Wasel Business Bui",
    "phone": "97145460005",
    "email": "info@drzubida.com",
    "registrationNumber": "ADF-2023-710"
  },
  {
    "id": "b84458c4-4c08-4fa7-8fd9-05b8787d4896",
    "slug": "dr-ahmed-alramsi-advocates-legal-consultants",
    "name": "DR. AHMED ALRAMSI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIERBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/16/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/16/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: DR. AHMED ALRAMSI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b84458c4-4c08-4fa7-8fd9-05b8787d4896",
        "address": "Ahmed Saleh Abulla Khamis ALramsi ,1305 ,Fairmont Dubai ,Burj Khalifa ,77857 ,Dubai",
        "phone": "97142720066",
        "email": "info@alramsyadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Ahmed Saleh Abdulla Khamees Al Ramsi",
    "address": "1305,Fairmont Dubai,Sheik Zayed RD,Dubai,7785",
    "phone": "97142720066",
    "email": "info@alramsyadvocates.com",
    "registrationNumber": "ADF-2017-417"
  },
  {
    "id": "a21a2f30-a19c-45e0-a56d-4f7c221741b6",
    "slug": "dr-ibrahim-mahmood-advocates-legal-consultants",
    "name": "DR. IBRAHIM MAHMOOD ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIERJCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/05/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "08/04/2022 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: DR. IBRAHIM MAHMOOD ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a21a2f30-a19c-45e0-a56d-4f7c221741b6",
        "address": "",
        "phone": "97145897555 / 971045897555",
        "email": "Humidi01@eim.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97145897555",
    "email": "Humidi01@eim.ae",
    "registrationNumber": "ADF-2020-505"
  },
  {
    "id": "c71d58e6-10a2-4e8f-955a-724c85e22687",
    "slug": "dr-mohammed-hassan-alraeesi-advocates-legal-consultants",
    "name": "DR. MOHAMMED HASSAN ALRAEESI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIERNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/14/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: DR. MOHAMMED HASSAN ALRAEESI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c71d58e6-10a2-4e8f-955a-724c85e22687",
        "address": "",
        "phone": "97145281450 / 971504465545",
        "email": "alraisim@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97145281450",
    "email": "alraisim@gmail.com",
    "registrationNumber": "ADF-2025-768"
  },
  {
    "id": "2ccc0c02-0a73-4b44-90ac-83ff8bce7db0",
    "slug": "dr-riasa-abdulrahman-advocates-legal-consultants",
    "name": "DR. RIASA ABDULRAHMAN ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIERSCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/14/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: DR. RIASA ABDULRAHMAN ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2ccc0c02-0a73-4b44-90ac-83ff8bce7db0",
        "address": "DR. RAISA ABDULRAHMAN SAEED AHMED ,19 ,برج المدينة 2 ,أمام متحف المستقبل بدبي ,24847 ,Dubai",
        "phone": "97143581800 / 971527588525",
        "email": "info@drraisaadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Riyasah Abdulrahman Saeed Ahmed",
    "address": "19,برج المدينة 2,منطقة الخليج التجاري الأول -",
    "phone": "97143581800",
    "email": "info@drraisaadvocates.ae",
    "registrationNumber": "ADF-2022-650"
  },
  {
    "id": "dd2f1b59-88fd-4ade-9d8f-139a4b75fef0",
    "slug": "dubai-advocates-legal-consultants",
    "name": "DUBAI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIERBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/29/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/28/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: DUBAI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dd2f1b59-88fd-4ade-9d8f-139a4b75fef0",
        "address": "",
        "phone": "97142830088 / 971505951775",
        "email": "dubai_lc@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Yaqoob Qasem Shahin Abdulla",
    "address": "N/A",
    "phone": "97142830088",
    "email": "dubai_lc@emirates.net.ae",
    "registrationNumber": "ADF-2011-14"
  },
  {
    "id": "af9dbfb0-4310-41bb-90aa-a3055b865d84",
    "slug": "ebrahim-ali-al-mousa-advocates-legal-consultants",
    "name": "EBRAHIM ALI AL MOUSA ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEVBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/03/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "12/02/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: EBRAHIM ALI AL MOUSA ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_af9dbfb0-4310-41bb-90aa-a3055b865d84",
        "address": "الخامس ,مونتانا ,هوم سنتر ,28834 ,Dubai",
        "phone": "97143963739",
        "email": "mousaadv@eim.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "EBRAHIM ALI ALMOUSA",
    "address": "الخامس,مونتانا,زعبيل ,Dubai,28834",
    "phone": "97143963739",
    "email": "mousaadv@eim.ae",
    "registrationNumber": "ADF-2013-290"
  },
  {
    "id": "e7b0608d-7f88-4f47-bbef-b92448c666cb",
    "slug": "ebrahim-altenaiji-advocates-and-legal-consultants",
    "name": "EBRAHIM ALTENAIJI ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEVBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/25/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "01/24/2019 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: EBRAHIM ALTENAIJI ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e7b0608d-7f88-4f47-bbef-b92448c666cb",
        "address": "",
        "phone": "97142276655",
        "email": "altenaiji.advocates@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97142276655",
    "email": "altenaiji.advocates@gmail.com",
    "registrationNumber": "ADF-2012-84"
  },
  {
    "id": "6735fd57-e905-4af6-a113-cc1e784b2510",
    "slug": "ebrahim-moosa-advocates-legal-consultants",
    "name": "EBRAHIM MOOSA ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEVNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/28/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "02/27/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: EBRAHIM MOOSA ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6735fd57-e905-4af6-a113-cc1e784b2510",
        "address": "الطابق الثاني عشر - مكتب رقم 1203 ,برج سيتاديل ,مقابل فندق جي دبليو ماريوت ,91427 ,Dubai",
        "phone": "97143629899",
        "email": "md@imlawyeruae.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "الطابق الثاني عشر - مكتب رقم 1203,برج سيتاديل",
    "phone": "97143629899",
    "email": "md@imlawyeruae.com",
    "registrationNumber": "ADF-2013-274"
  },
  {
    "id": "3b88b4a9-6858-4b28-a99f-b982d1cc2ea7",
    "slug": "eisa-salem-advocates-legal-consultants",
    "name": "EISA SALEM ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEVTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/10/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/09/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: EISA SALEM ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3b88b4a9-6858-4b28-a99f-b982d1cc2ea7",
        "address": "Eissa Salem ,911 ,ALFATTAN PLAZA ,مقابل مطار دبي، مبنى الوصول 1 ,26141 ,Dubai",
        "phone": "97143484809 / 971502226366",
        "email": "info.admin@eslawyers.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Eisa Salem Ahmed Alharsi Almahri",
    "address": "911,ALFATTAN PLAZA,القرهود,Dubai,26141",
    "phone": "97143484809",
    "email": "info.admin@eslawyers.ae",
    "registrationNumber": "ADF-2019-487"
  },
  {
    "id": "c13d6ec8-66e4-4366-a35a-da9ebde7e7c5",
    "slug": "eisa-salim-alqaydi-advocates-legal-consultants",
    "name": "EISA SALIM ALQAYDI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEVTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/31/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "07/30/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: EISA SALIM ALQAYDI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c13d6ec8-66e4-4366-a35a-da9ebde7e7c5",
        "address": "Office No. 102 ,Mohammed Bu Farousha Building ,Makani No: 3240794064 ,000 ,Dubai",
        "phone": "97143304403 / 971509991543",
        "email": "alqaydi@esqadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Eisa Salim Ali Salim Alqaydi",
    "address": "Office No. 102,Mohammed Bu Farousha Building,",
    "phone": "97143304403",
    "email": "alqaydi@esqadvocates.com",
    "registrationNumber": "ADF-2023-684"
  },
  {
    "id": "6b78f3c8-38be-42c4-8688-24beb0278cda",
    "slug": "eisa-taher-advocates-legal-consultants",
    "name": "EISA TAHER ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEVUCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/14/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "01/13/2020 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: EISA TAHER ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6b78f3c8-38be-42c4-8688-24beb0278cda",
        "address": "Eisa Taher Sultan  ,الميزانين  ,State 1  ,مركز بخيت ,238801 ,Dubai",
        "phone": "97148868508 / 971504772370",
        "email": "essataher@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "الميزانين ,State 1 ,شارع المرقبات,Dubai,23880",
    "phone": "97148868508",
    "email": "essataher@hotmail.com",
    "registrationNumber": "ADF-2018-437"
  },
  {
    "id": "b4cf66fb-0b00-4b16-b27a-932fcb898cda",
    "slug": "eissa-alhousani-advocate-legal-consultant",
    "name": "EISSA ALHOUSANI ADVOCATE LEGAL CONSULTANT",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEVBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/13/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/12/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: EISSA ALHOUSANI ADVOCATE LEGAL CONSULTANT",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b4cf66fb-0b00-4b16-b27a-932fcb898cda",
        "address": "EISSA MOHAMMED SALEH ALHOUSAANI ,الطابق الثانى مكتب رقم 203  ,اوبال تاور  ,مصرف الامارات الاسلامى  ,22856 ,Dubai",
        "phone": "97143992229",
        "email": "e.alhousani@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "الطابق الثانى مكتب رقم 203 ,اوبال تاور ,منطقة",
    "phone": "97143992229",
    "email": "e.alhousani@hotmail.com",
    "registrationNumber": "ADF-2012-173"
  },
  {
    "id": "24e2b72a-28d1-4d8f-aac7-c7d8ff2061f4",
    "slug": "eman-al-ali-advocates-legal-consultants",
    "name": "EMAN AL ALI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEVBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/25/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/24/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: EMAN AL ALI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_24e2b72a-28d1-4d8f-aac7-c7d8ff2061f4",
        "address": "eman hassn  ,37 ,latifa tower ,dubai islamic bank ,384980 ,Dubai",
        "phone": "97142953088 / 971567779905",
        "email": "eman.advocates@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "37,latifa tower,sheikh zayid rood,Dubai,38498",
    "phone": "97142953088",
    "email": "eman.advocates@gmail.com",
    "registrationNumber": "ADF-2019-476"
  },
  {
    "id": "a1561ffd-3e53-4123-85a7-7437d4abf2f8",
    "slug": "eman-alrifai-advocates-legal-consultants",
    "name": "EMAN ALRIFAI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEVBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/12/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/11/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: EMAN ALRIFAI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a1561ffd-3e53-4123-85a7-7437d4abf2f8",
        "address": "الطابق 11 - مكتب رقم (1105 ، 1106)  ,برج السلام  ,منطقة المركز التجاري العالمي 1 ,211911 ,Dubai",
        "phone": "97143366769 / 971503636617",
        "email": "info@erlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Dr EIMAN YOUNES MOHAMED E . ALRIFAI",
    "address": "الطابق 11 - مكتب رقم (1105 ، 1106) ,برج السلا",
    "phone": "97143366769",
    "email": "info@erlaw.ae",
    "registrationNumber": "ADF-2019-474"
  },
  {
    "id": "f7823b07-a968-474f-8a13-a4454ef2d990",
    "slug": "emirates-advocates-legal-consultants",
    "name": "EMIRATES ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEVBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/20/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/19/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: EMIRATES ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f7823b07-a968-474f-8a13-a4454ef2d990",
        "address": "",
        "phone": "97143304343",
        "email": "hamad@emiratesadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Hamad Mohammed Kadfoor Abdulla Al-Mehairi",
    "address": "N/A",
    "phone": "97143304343",
    "email": "hamad@emiratesadvocates.com",
    "registrationNumber": "ADF-2011-32"
  },
  {
    "id": "9e273d2c-1c61-4c3b-81a1-bd8ab8390862",
    "slug": "emirates-advocates-legal-consultants-dcca-branch",
    "name": "EMIRATES ADVOCATES & LEGAL CONSULTANTS - DCCA BRANCH",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEVBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/06/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/05/2020 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: EMIRATES ADVOCATES & LEGAL CONSULTANTS - DCCA BRANCH",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9e273d2c-1c61-4c3b-81a1-bd8ab8390862",
        "address": "",
        "phone": "97143304343 / 971504198080",
        "email": "deena@emiratesadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97143304343",
    "email": "deena@emiratesadvocates.com",
    "registrationNumber": "ADF-2012-245"
  },
  {
    "id": "2c10c414-70fa-4a29-b8ce-a320239738ad",
    "slug": "engy-nabeel-advocates-legal-consultants",
    "name": "ENGY NABEEL ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEVOCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/28/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/27/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ENGY NABEEL ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2c10c414-70fa-4a29-b8ce-a320239738ad",
        "address": "engy nabeel ,609 ,Business Avenue Building ,خلف معرض نيسان للسيارات ,114332 ,Dubai",
        "phone": "97142666983 / 971505049385",
        "email": "mtgdubai@mtglegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Engy Nabeel Mahmood",
    "address": "609,Business Avenue Building,ديرة - بورسعيد -",
    "phone": "97142666983",
    "email": "mtgdubai@mtglegal.com",
    "registrationNumber": "ADF-2013-285"
  },
  {
    "id": "f6dee20d-9392-4f89-96bd-b1f89bcef71a",
    "slug": "esam-alzarooni-advocates-legal-consultants",
    "name": "ESAM ALZAROONI ADVOCATES &LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEVBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/15/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "12/14/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ESAM ALZAROONI ADVOCATES &LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f6dee20d-9392-4f89-96bd-b1f89bcef71a",
        "address": "",
        "phone": "97100000000 / 971504766660",
        "email": "info@eza.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "esam abdelraman hassan ali alzarooni",
    "address": "N/A",
    "phone": "97100000000",
    "email": "info@eza.ae",
    "registrationNumber": "ADF-2021-577"
  },
  {
    "id": "7dd7860a-cd36-443b-a1b7-62dd3050e6b9",
    "slug": "fahad-abdulla-advocates-legal-consultants",
    "name": "FAHAD ABDULLA ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEZBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/14/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: FAHAD ABDULLA ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7dd7860a-cd36-443b-a1b7-62dd3050e6b9",
        "address": "الثالث  ,اركاد  ,الطاير للسيارات  ,20877 ,Dubai",
        "phone": "97142833355",
        "email": "Fahadadvo@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Fahad Abdalla Qambar Mohamed",
    "address": "الثالث ,بنايه بوشقر ,القرهود,Dubai,20877",
    "phone": "97142833355",
    "email": "Fahadadvo@gmail.com",
    "registrationNumber": "ADF-2017-419"
  },
  {
    "id": "592fec74-e0bd-48e3-93e8-b883d0461137",
    "slug": "fahad-abdulla-daen-advocates-legal-consultants",
    "name": "FAHAD ABDULLA DAEN ADVOCATES &LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEZBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/30/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/29/2025 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: FAHAD ABDULLA DAEN ADVOCATES &LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_592fec74-e0bd-48e3-93e8-b883d0461137",
        "address": "",
        "phone": "97145476776 / 971971454767",
        "email": "fahadalshebli.uae@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97145476776",
    "email": "fahadalshebli.uae@hotmail.com",
    "registrationNumber": "ADF-2021-556"
  },
  {
    "id": "aea24945-594d-49dd-8077-830efa5e95ff",
    "slug": "fahad-alhosani-advocates-legal-consultants",
    "name": "FAHAD ALHOSANI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEZBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/25/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "08/24/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: FAHAD ALHOSANI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_aea24945-594d-49dd-8077-830efa5e95ff",
        "address": "fahad alhosani ,Office No. 1006 ,ASPECT TOWER ,Near Burj Khalifa ,000 ,Dubai",
        "phone": "97100000000 / 971551111723",
        "email": "info@fahadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Fahad Mohammed Abdulla Khamis Alhosani",
    "address": "Office No. 1006,ASPECT TOWER,Al Mostaqbal Str",
    "phone": "97100000000",
    "email": "info@fahadvocates.com",
    "registrationNumber": "ADF-2023-689"
  },
  {
    "id": "6924283e-95b7-4af2-85a3-cc6cbcc10a20",
    "slug": "fahad-bin-tamim-advocates-and-legal-consultants",
    "name": "FAHAD BIN TAMIM ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEZCCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/03/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/02/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: FAHAD BIN TAMIM ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6924283e-95b7-4af2-85a3-cc6cbcc10a20",
        "address": "",
        "phone": "97143380333",
        "email": "info@fahadbintamim.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Fahad Ahmad Ali Mohammad Bin Tamim",
    "address": "N/A",
    "phone": "97143380333",
    "email": "info@fahadbintamim.ae",
    "registrationNumber": "ADF-2015-339"
  },
  {
    "id": "920b183d-3abe-4de5-8df6-79ab571d2d74",
    "slug": "fahad-saeed-alzeyoudi-advocates-legal-consultants",
    "name": "FAHAD SAEED ALZEYOUDI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEZTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/10/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "12/09/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: FAHAD SAEED ALZEYOUDI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_920b183d-3abe-4de5-8df6-79ab571d2d74",
        "address": "الخطوط الاردنية ,بيزنس افينو ,الرستماني  ,00 ,Dubai",
        "phone": "97145468245 / 971505003153",
        "email": "AJ@alzeyoudiadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Fahad Saeed Alsumm Alzeyoudi",
    "address": "الخطوط الاردنية,بيزنس افينو,بورسعيد,Dubai,00",
    "phone": "97145468245",
    "email": "AJ@alzeyoudiadvocates.com",
    "registrationNumber": "ADF-2020-532"
  },
  {
    "id": "db28e7c2-7457-4e60-93b2-309b9cd0d259",
    "slug": "faisal-alhefeiti-advocates-legal-consultants",
    "name": "FAISAL ALHEFEITI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEZBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/15/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "08/14/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: FAISAL ALHEFEITI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_db28e7c2-7457-4e60-93b2-309b9cd0d259",
        "address": "103 ,DUBAI SUPREME COURT COMPLEX ,DUBAI COURT ,00 ,Dubai",
        "phone": "97143038303 / 971504999947",
        "email": "dr.faisal@lawfaisal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "faisal saeed mohamed rashed alhefeiti",
    "address": "103,DUBAI SUPREME COURT COMPLEX,O,Dubai,00",
    "phone": "97143038303",
    "email": "dr.faisal@lawfaisal.com",
    "registrationNumber": "ADF-2023-688"
  },
  {
    "id": "49438fce-e755-46d9-80f0-c9316172970a",
    "slug": "faisal-alnsour-advocates-legal-consultants",
    "name": "FAISAL ALNSOUR ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEZBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/20/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: FAISAL ALNSOUR ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_49438fce-e755-46d9-80f0-c9316172970a",
        "address": "Office No. 049 - 1603 ,Al Moosa Tower 1 ,Makani No: 26486900052 ,000 ,Dubai",
        "phone": "97143445789 / 971503571571",
        "email": "legal@faisalalnsouradvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "FAISAL ABDALLA HASSAN ALNSOUR",
    "address": "office no 201,129-374port saeed,deira ,dubai,",
    "phone": "97143445789",
    "email": "legal@faisalalnsouradvocates.com",
    "registrationNumber": "ADF-2024-752"
  },
  {
    "id": "896b6ab4-30f1-4f72-86fe-c7ea8653a027",
    "slug": "faisal-alzarooni-advocates-legal-consultants",
    "name": "FAISAL ALZAROONI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEZBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/22/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/21/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: FAISAL ALZAROONI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_896b6ab4-30f1-4f72-86fe-c7ea8653a027",
        "address": "301 ,Clover Bay Tower ,Burj Khalifa ,414077 ,Dubai",
        "phone": "97145135166",
        "email": "info@faisalalzarooni.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Faisal Abdulrahman Abdulrahim",
    "address": "301,Clover Bay Tower,Business Bay,Dubai,41407",
    "phone": "97145135166",
    "email": "info@faisalalzarooni.com",
    "registrationNumber": "ADF-2014-311"
  },
  {
    "id": "fd647c60-3bff-4297-87f1-6437acf45575",
    "slug": "faisal-salem-advocates-and-legal-consultants",
    "name": "FAISAL SALEM ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEZTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/04/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "07/03/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: FAISAL SALEM ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fd647c60-3bff-4297-87f1-6437acf45575",
        "address": "",
        "phone": "97145132619 / 971543630593",
        "email": "info@alfaisal.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Faisal Salem Fairooz Salem",
    "address": "N/A",
    "phone": "97145132619",
    "email": "info@alfaisal.law",
    "registrationNumber": "ADF-2022-616"
  },
  {
    "id": "13bcdb23-b6a5-4aef-a1bc-3d57c5b2034b",
    "slug": "fareed-alhassan-advocates-and-legal-consultants",
    "name": "FAREED ALHASSAN ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEZBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/24/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/23/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: FAREED ALHASSAN ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_13bcdb23-b6a5-4aef-a1bc-3d57c5b2034b",
        "address": "FAREED FAIROUZ MOHD ALI ALHASSAN ,الميزانين - مكتب رقم M03 ,جولدن بيزنس تاور ,خلف معرض نيسان الرستماني ,455067 ,Dubai",
        "phone": "97143266117",
        "email": "Fs4591190fs@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Fareed Fairouz Mohammad Ali Alhassan",
    "address": "الميزانين - مكتب رقم M03,جولدن بيزنس تاور,دير",
    "phone": "97143266117",
    "email": "Fs4591190fs@gmail.com",
    "registrationNumber": "ADF-2022-609"
  },
  {
    "id": "56a08801-face-44ef-b719-6ba08c6cae57",
    "slug": "fatem-saeed-mohamed-bin-yarouf-almansoori-advocates-legal-consultants",
    "name": "FATEM SAEED MOHAMED BIN YAROUF ALMANSOORI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEZTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/21/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/20/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: FATEM SAEED MOHAMED BIN YAROUF ALMANSOORI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_56a08801-face-44ef-b719-6ba08c6cae57",
        "address": "",
        "phone": "97144455555 / 971503499791",
        "email": "fatmaamansoori@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "FATEMA SAEED MOHAMED YAROUF ALMANSOORI",
    "address": "N/A",
    "phone": "97144455555",
    "email": "fatmaamansoori@yahoo.com",
    "registrationNumber": "ADF-2023-660"
  },
  {
    "id": "a359d947-1da5-4ef9-af87-719d01287fd0",
    "slug": "fatema-almheiri-advocates-legal-consultants",
    "name": "FATEMA ALMHEIRI ADVOCATES &LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEZBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/21/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "01/20/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: FATEMA ALMHEIRI ADVOCATES &LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a359d947-1da5-4ef9-af87-719d01287fd0",
        "address": "Mohamed Nagy ,First floor  ,Clover Bay ,Business bay ,108 ,Dubai",
        "phone": "97143366404",
        "email": "fatimaalmehri5@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "FATEMA SAIF ABDULRAHMAN LAGHRAB ALMHEIRI",
    "address": "First floor ,Clover Bay,Business bay,Dubai,10",
    "phone": "97143366404",
    "email": "fatimaalmehri5@gmail.com",
    "registrationNumber": "ADF-2022-586"
  },
  {
    "id": "690778ba-3332-4c06-b01f-ab5ec89ee304",
    "slug": "fatema-hasan-alshehhi-advocates-and-legal-consultants",
    "name": "FATEMA HASAN ALSHEHHI ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEZICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/27/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/26/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: FATEMA HASAN ALSHEHHI ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_690778ba-3332-4c06-b01f-ab5ec89ee304",
        "address": "الثالث  ,برج جيت  48  ,مخرج ميترو برج خليفه / دبي مول  ,181111 ,Dubai",
        "phone": "97145143423 / 971971451434",
        "email": "info.justice@fhsadvo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Fatema Hasan Sulaiman Alhadboor Alshehhi",
    "address": "الثالث ,برج جيت  48 ,داون تاون,Dubai,181111",
    "phone": "97145143423",
    "email": "info.justice@fhsadvo.com",
    "registrationNumber": "ADF-2022-608"
  },
  {
    "id": "8ae2a2bf-6a88-4194-87ef-f1ac38baef55",
    "slug": "fatima-abdelaziz-advocates-legal-consultant",
    "name": "FATIMA ABDELAZIZ ADVOCATES & LEGAL CONSULTANT",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEZBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/05/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "08/04/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: FATIMA ABDELAZIZ ADVOCATES & LEGAL CONSULTANT",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8ae2a2bf-6a88-4194-87ef-f1ac38baef55",
        "address": "FATIMA ABDULAZIZ  ,الطابق السابع ,برج المنال  ,مقابل متحف المستقبل  ,861 ,Dubai",
        "phone": "97143555566",
        "email": "info@fazlegal.net",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "الطابق السابع,برج المنال ,شارع الشيخ زايد ,Du",
    "phone": "97143555566",
    "email": "info@fazlegal.net",
    "registrationNumber": "ADF-2018-459"
  },
  {
    "id": "54992389-d43d-4ec8-acd7-437592996504",
    "slug": "fatima-hussein-advocates-legal-consultants",
    "name": "FATIMA HUSSEIN ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEZICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/04/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "02/03/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: FATIMA HUSSEIN ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_54992389-d43d-4ec8-acd7-437592996504",
        "address": "OB-101-141 ,Majid Al Futtaim - City Centre Deira ,Makani No: 3204893785 ,000 ,Dubai",
        "phone": "97140000000 / 971506946464",
        "email": "Admin@fha.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Fatima Hussein Ali Ahmad",
    "address": "OB-101-141,Majid Al Futtaim - City Centre Dei",
    "phone": "97140000000",
    "email": "Admin@fha.law",
    "registrationNumber": "ADF-2025-758"
  },
  {
    "id": "f9b7a676-34db-4e8e-97b5-3ae354ee0661",
    "slug": "fatima-mohammed-advocates-legal-consultants",
    "name": "FATIMA MOHAMMED ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEZNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/07/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/06/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: FATIMA MOHAMMED ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f9b7a676-34db-4e8e-97b5-3ae354ee0661",
        "address": "Fatima Mohammed Youseef Saddiq ,Floor 2, Office 215 ,Sultan Business Center ,Lamcy Plaza  ,114713 ,Dubai",
        "phone": "97145703330 / 971500000000",
        "email": "info@mnlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "Floor 2, Office 215,Sultan Business Center,Ou",
    "phone": "97145703330",
    "email": "info@mnlaw.ae",
    "registrationNumber": "ADF-2020-510"
  },
  {
    "id": "0e37962d-dd91-4a8c-876d-08343e3124cb",
    "slug": "fatma-al-moosa-advocates-legal-consultancy",
    "name": "FATMA AL MOOSA ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEZBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/23/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/22/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: FATMA AL MOOSA ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0e37962d-dd91-4a8c-876d-08343e3124cb",
        "address": "Adv Fatma Moosa Ali ,30 ,IRIS Bay Tower ,Business Bay ,33727 ,Dubai",
        "phone": "97143328182",
        "email": "mahir@fatmaalmoosa.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "30,IRIS Bay Tower,Happiness ST/Business Bay,D",
    "phone": "97143328182",
    "email": "mahir@fatmaalmoosa.com",
    "registrationNumber": "ADF-2012-150"
  },
  {
    "id": "9f91cca7-a15d-499f-b265-2a032fe38fa1",
    "slug": "fatma-almutawa-advocates-legal-consultants",
    "name": "FATMA ALMUTAWA ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEZBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/13/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/12/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: FATMA ALMUTAWA ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9f91cca7-a15d-499f-b265-2a032fe38fa1",
        "address": "",
        "phone": "97145579711",
        "email": "info@mqadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Fatma Hassan Mohammed Ahmad Almutawa",
    "address": "N/A",
    "phone": "97145579711",
    "email": "info@mqadvocates.com",
    "registrationNumber": "ADF-2015-365"
  },
  {
    "id": "a1add4ec-4f01-41b2-9875-540545839906",
    "slug": "fatmah-al-ali-advocates-legal-consultancy",
    "name": "Fatmah Al Ali Advocates & Legal Consultancy",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEZBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/26/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/25/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Fatmah Al Ali Advocates & Legal Consultancy",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a1add4ec-4f01-41b2-9875-540545839906",
        "address": "",
        "phone": "97145539905",
        "email": "info@ama-alali.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97145539905",
    "email": "info@ama-alali.com",
    "registrationNumber": "ADF-2016-387"
  },
  {
    "id": "5659e22e-56c3-4e28-8165-14d3772da734",
    "slug": "fattiha-gourari-advocates-legal-consultants",
    "name": "FATTIHA GOURARI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEZHCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/05/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/04/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: FATTIHA GOURARI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5659e22e-56c3-4e28-8165-14d3772da734",
        "address": "",
        "phone": "97142394000",
        "email": "info@fatihagourari.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Fatiha Mohamed Barrahou Gourari",
    "address": "N/A",
    "phone": "97142394000",
    "email": "info@fatihagourari.com",
    "registrationNumber": "ADF-2016-386"
  },
  {
    "id": "336f9090-d6f4-4c0b-bccb-c08fd95ea5cc",
    "slug": "fawzia-mohammad-advocates-legal-consultants",
    "name": "FAWZIA MOHAMMAD ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEZNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/10/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/09/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: FAWZIA MOHAMMAD ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_336f9090-d6f4-4c0b-bccb-c08fd95ea5cc",
        "address": "",
        "phone": "",
        "email": "fawzia.mohd.2009@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Fawzia Mohammad Azim Saifuddin Yaqoob",
    "address": "N/A",
    "phone": "N/A",
    "email": "fawzia.mohd.2009@gmail.com",
    "registrationNumber": "ADF-2022-642"
  },
  {
    "id": "1fba2390-a8a7-4185-9ffd-f6f93f0fe965",
    "slug": "fouzeya-al-mulla-advocates-legal-consultants",
    "name": "FOUZEYA AL MULLA ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEZBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/19/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/18/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: FOUZEYA AL MULLA ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1fba2390-a8a7-4185-9ffd-f6f93f0fe965",
        "address": "",
        "phone": "97143283749",
        "email": "info@famlc.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Fouzeya Mahmood Ahmad Mohamad Almulla",
    "address": "N/A",
    "phone": "97143283749",
    "email": "info@famlc.ae",
    "registrationNumber": "ADF-2023-670"
  },
  {
    "id": "d863b662-c864-4193-8b3a-ff6ee5fe6c64",
    "slug": "galadari-advocates-legal-consultants",
    "name": "GALADARI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEdBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/10/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/09/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: GALADARI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d863b662-c864-4193-8b3a-ff6ee5fe6c64",
        "address": "",
        "phone": "97143937700",
        "email": "info@galadarilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Ziad Abdulla Ibrahim Galadari",
    "address": "N/A",
    "phone": "97143937700",
    "email": "info@galadarilaw.com",
    "registrationNumber": "ADF-2012-190"
  },
  {
    "id": "1ddb9aa2-a883-464a-a447-4dc47ac35a87",
    "slug": "galadari-advocates-legal-consultants-difc",
    "name": "GALADARI ADVOCATES & LEGAL CONSULTANTS (DIFC)",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEdBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/11/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "02/10/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: GALADARI ADVOCATES & LEGAL CONSULTANTS (DIFC)",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1ddb9aa2-a883-464a-a447-4dc47ac35a87",
        "address": "Ahmed Galadari ,1st Floor ,GA-00-SZ-L1-DD-01, Innovation Hive, Gate Avenue - South Zone ,World Trade Center ,506916 ,Dubai",
        "phone": "97143711999",
        "email": "ajith@galadarilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "1st Floor,GA-00-SZ-L1-DD-01, Innovation Hive,",
    "phone": "97143711999",
    "email": "ajith@galadarilaw.com",
    "registrationNumber": "ADF-2014-297"
  },
  {
    "id": "6bba74cb-688b-40e3-b624-be70505eb5f9",
    "slug": "galal-hussein-legal-consultancies-and-advocates",
    "name": "GALAL HUSSEIN LEGAL CONSULTANCIES AND ADVOCATES",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEdICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/11/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "02/10/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: GALAL HUSSEIN LEGAL CONSULTANCIES AND ADVOCATES",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6bba74cb-688b-40e3-b624-be70505eb5f9",
        "address": "GALAL ELDIN HUSSEIN SALEH DIAB ,الطابق السادس ,مكاتب ,معرض هوندا الفطيم للسيارات - ديره ,115506 ,Dubai",
        "phone": "97197150655",
        "email": "galal5152@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Galal Eldin Hussein Saleh Diab",
    "address": "الطابق السادس,مكاتب,شارع المكتوم - منطقة بورس",
    "phone": "97197150655",
    "email": "galal5152@hotmail.com",
    "registrationNumber": "ADF-2014-299"
  },
  {
    "id": "4eac7236-c896-444b-a5ea-e4ff06ff2f5a",
    "slug": "gharib-alshamsi-advocates-legal-consultants",
    "name": "GHARIB ALSHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEdBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/23/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/22/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: GHARIB ALSHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4eac7236-c896-444b-a5ea-e4ff06ff2f5a",
        "address": "",
        "phone": "97142208816",
        "email": "g.alshamsiadvocate@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Gharib Khalifa Gharib Walid Alshamsi",
    "address": "N/A",
    "phone": "97142208816",
    "email": "g.alshamsiadvocate@gmail.com",
    "registrationNumber": "ADF-2022-626"
  },
  {
    "id": "9b42810f-1d55-4aea-ac4a-7d9d1b25ac08",
    "slug": "global-advocacy-legal-counsel",
    "name": "GLOBAL ADVOCACY & LEGAL COUNSEL",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEdBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/13/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/12/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: GLOBAL ADVOCACY & LEGAL COUNSEL",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9b42810f-1d55-4aea-ac4a-7d9d1b25ac08",
        "address": "21 ,Rolex Tower ,Emirates Grand Hotel ,94334 ,Dubai",
        "phone": "97143277772 / 97145584900",
        "email": "info@globaladvocates.net",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Ali Sayed Abdulla Sayed Ibrahim Al-Hashimi",
    "address": "21,Rolex Tower,21st Floor, Rolex Tower, DIFC,",
    "phone": "97143277772",
    "email": "info@globaladvocates.net",
    "registrationNumber": "ADF-2011-25"
  },
  {
    "id": "05351a6c-fcad-4824-9aba-1031f82e3720",
    "slug": "glory-international-advocates-legal-consultants",
    "name": "GLORY INTERNATIONAL ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEdJCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/01/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "07/31/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: GLORY INTERNATIONAL ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_05351a6c-fcad-4824-9aba-1031f82e3720",
        "address": "",
        "phone": "97142628001",
        "email": "gloryadvocate@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Salem Rashed Ali obaid Al Maftool",
    "address": "N/A",
    "phone": "97142628001",
    "email": "gloryadvocate@gmail.com",
    "registrationNumber": "ADF-2012-233"
  },
  {
    "id": "4ca62fa9-28fb-4024-84aa-9b82cccde1b5",
    "slug": "gulf-consultant-advocates-legal-consultancy",
    "name": "GULF CONSULTANT ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEdDCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/23/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/08/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: GULF CONSULTANT ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4ca62fa9-28fb-4024-84aa-9b82cccde1b5",
        "address": "",
        "phone": "97142830009",
        "email": "abakgulfconsultant@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Ahmed Abdulla Mohammed Al-Kendri",
    "address": "N/A",
    "phone": "97142830009",
    "email": "abakgulfconsultant@yahoo.com",
    "registrationNumber": "ADF-2012-170"
  },
  {
    "id": "3eba82bb-8ec4-4cbd-80d0-a793cb993fde",
    "slug": "habib-al-mulla-partners-advocates-legal-consultants",
    "name": "Habib Al Mulla & Partners ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/26/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/25/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Habib Al Mulla & Partners ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3eba82bb-8ec4-4cbd-80d0-a793cb993fde",
        "address": "",
        "phone": "97144230000 / 971552009022",
        "email": "UAE-CourtClerks@habibalmulla.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Habib Mohammed Shareif Abdulla Al-Mulla",
    "address": "N/A",
    "phone": "97144230000",
    "email": "UAE-CourtClerks@habibalmulla.com",
    "registrationNumber": "ADF-2011-12"
  },
  {
    "id": "373bb6e6-5948-493f-a6ac-2ea343840160",
    "slug": "habib-alhosani-lawyers-legal-consultants",
    "name": "HABIB ALHOSANI LAWYERS & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/30/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/29/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HABIB ALHOSANI LAWYERS & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_373bb6e6-5948-493f-a6ac-2ea343840160",
        "address": "الثالث مكتب 304 ,برج سما ,المركز التجاري  ,116623 ,Dubai",
        "phone": "97142723388",
        "email": "info@habibllc.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Habib Abdul Rahim Abdulla",
    "address": "الثالث مكتب 304,برج سما,بر دبي / المركز التجا",
    "phone": "97142723388",
    "email": "info@habibllc.ae",
    "registrationNumber": "ADF-2017-405"
  },
  {
    "id": "18a7fc47-63d9-4928-a864-fa55559de45b",
    "slug": "hadeel-alshaali-advocates-legal-consultants",
    "name": "HADEEL ALSHAALI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/09/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/08/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HADEEL ALSHAALI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_18a7fc47-63d9-4928-a864-fa55559de45b",
        "address": "Hadeel Ali alshaali  ,الطابق السادس  ,بناية زمردة ,بلدية دبي المختبرات المركزية ,212633 ,Dubai",
        "phone": "97165503035",
        "email": "hadeelalshaali_90@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Hadeel Ali Khalifa Ali Alshaali",
    "address": "الطابق السادس ,بناية زمردة,الكرامة,Dubai,2126",
    "phone": "97165503035",
    "email": "hadeelalshaali_90@hotmail.com",
    "registrationNumber": "ADF-2014-316"
  },
  {
    "id": "4330d61f-8871-40ec-a461-8380e14c745d",
    "slug": "hadef-partners-llc",
    "name": "HADEF & PARTNERS L.L.C",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhQCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/29/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/28/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HADEF & PARTNERS L.L.C",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4330d61f-8871-40ec-a461-8380e14c745d",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Faraj abdulla ahnaish saleh ahnaish",
    "address": "Level 5,Emaar Square Building 3,Downtown,Duba",
    "phone": "97144292999",
    "email": "e.araza@hadefpartners.com",
    "registrationNumber": "ADF-2011-59"
  },
  {
    "id": "93736908-026c-4a6a-bbaf-2e67ee1366c6",
    "slug": "hadeya-hamad-advocacy-and-legal-consultancy",
    "name": "HADEYA HAMAD ADVOCACY AND LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/17/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "07/16/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HADEYA HAMAD ADVOCACY AND LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_93736908-026c-4a6a-bbaf-2e67ee1366c6",
        "address": "ADEL ALSAID  ,203 ,BAY SQUARE-02 ,BAY SQUARE  ,37105 ,Dubai",
        "phone": "97143555253 / 971507562138",
        "email": "hhlegal@hhlegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Hadeya Abdulrazzaq Mahmoud Hamad",
    "address": "2707,SILVER TOWER,BUSINESS BAY,Dubai,58820",
    "phone": "97143555253",
    "email": "hhlegal@hhlegal.ae",
    "registrationNumber": "ADF-2014-320"
  },
  {
    "id": "f074c445-924d-40b2-9832-0b0a040c4e63",
    "slug": "haider-bin-haider-advocates-and-legal-consultant",
    "name": "HAIDER BIN HAIDER ADVOCATES AND LEGAL CONSULTANT",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhCCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/13/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/12/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HAIDER BIN HAIDER ADVOCATES AND LEGAL CONSULTANT",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f074c445-924d-40b2-9832-0b0a040c4e63",
        "address": "",
        "phone": "97142770003",
        "email": "info@hbhadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Haider Salem Ali Bin Haider",
    "address": "N/A",
    "phone": "97142770003",
    "email": "info@hbhadvocates.ae",
    "registrationNumber": "ADF-2012-194"
  },
  {
    "id": "a257089c-d1b4-4f81-b4d7-14d1a0c34eb5",
    "slug": "haitham-salah-advocates-legal-consultants",
    "name": "HAITHAM SALAH ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/01/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "01/31/2025 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HAITHAM SALAH ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a257089c-d1b4-4f81-b4d7-14d1a0c34eb5",
        "address": "M ,al garhoud busniss center ,dubai international airport ,451878 ,Dubai",
        "phone": "97143964926 / 971503470066",
        "email": "lawyer-haitham@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "haitham salah jalal abdulla mohammad",
    "address": "M,al garhoud busniss center,57th st,Dubai,451",
    "phone": "97143964926",
    "email": "lawyer-haitham@hotmail.com",
    "registrationNumber": "ADF-2022-589"
  },
  {
    "id": "4fb21617-b070-488f-8ce5-516725154e59",
    "slug": "haleema-almarzooqi-partners-advocates-legal-consultants",
    "name": "HALEEMA ALMARZOOQI & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/22/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/21/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HALEEMA ALMARZOOQI & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4fb21617-b070-488f-8ce5-516725154e59",
        "address": "haleema almarzooqi ,3 ,building 7A ,D3 ,9569 ,Dubai",
        "phone": "97143621113",
        "email": "haleema.almarzooqi@dhalaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Haleema Murtadha Mohamed Mukhtar Almarzooqi",
    "address": "3,building 7A,D3,Dubai,9569",
    "phone": "97143621113",
    "email": "haleema.almarzooqi@dhalaw.com",
    "registrationNumber": "ADF-2011-55"
  },
  {
    "id": "38838899-8c67-45c6-8699-4c822e13f4b8",
    "slug": "hamad-al-sayegh-advocates-legal-consultants",
    "name": "HAMAD AL SAYEGH ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/27/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "02/26/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HAMAD AL SAYEGH ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_38838899-8c67-45c6-8699-4c822e13f4b8",
        "address": "Second Floor - Office No. 224 ,Business Center ,Makani No: 3274893760 ,000 ,Dubai",
        "phone": "97145671576 / 971529969969",
        "email": "info@hamadalsayegh.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Hamad Ahmad Obaid Mohammad Alsayegh",
    "address": "Second Floor - Office No. 224,Business Center",
    "phone": "97145671576",
    "email": "info@hamadalsayegh.com",
    "registrationNumber": "ADF-2024-721"
  },
  {
    "id": "469613e7-96d7-4b4d-82f2-5ab24490a43f",
    "slug": "hamad-alessa-advocates-legal-consultants",
    "name": "HAMAD ALESSA ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/15/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/14/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HAMAD ALESSA ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_469613e7-96d7-4b4d-82f2-5ab24490a43f",
        "address": "13 ,المنارة ,الخليج التجاري  ,455755 ,Dubai",
        "phone": "97144106480",
        "email": "alessalawfirm@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Hamad Essa Mohammad Alessa",
    "address": "13,المنارة,الخليج التجاري - شارع الأصايل,Duba",
    "phone": "97144106480",
    "email": "alessalawfirm@gmail.com",
    "registrationNumber": "ADF-2023-658"
  },
  {
    "id": "ff6f54b7-0992-43dc-8480-cfff31538d52",
    "slug": "hamad-alzaabi-muna-bin-ghalaita-advocates-legal-consultants",
    "name": "HAMAD ALZAABI & MUNA BIN GHALAITA ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/28/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HAMAD ALZAABI & MUNA BIN GHALAITA ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ff6f54b7-0992-43dc-8480-cfff31538d52",
        "address": "Office 413 - Block B ,Hamdan Bin Rashid Al Maktoum Foundation for Medical Science ,Makani No: 2598892707 ,000 ,Dubai",
        "phone": "97142571323 / 971554377771",
        "email": "info@alzaabi-binghalaita.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Muna Ahmed Ali Bin Ghalaita Almheiri",
    "address": "Office 413 - Block B,Hamdan Bin Rashid Al Mak",
    "phone": "97142571323",
    "email": "info@alzaabi-binghalaita.com",
    "registrationNumber": "ADF-2025-757"
  },
  {
    "id": "aaee8e41-be83-4596-99e8-716e84e93e28",
    "slug": "hamda-makki-advocates-legal-consultants",
    "name": "HAMDA MAKKI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/20/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/19/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HAMDA MAKKI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_aaee8e41-be83-4596-99e8-716e84e93e28",
        "address": "جائزة الشيخ حمدان ,مبانى الحضيبة للجوائز - البلوك ب - الطابق السادس ,متحف الضيافة ,26596 ,Dubai",
        "phone": "97143889770",
        "email": "hamdamakkiadvocates@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "جائزة الشيخ حمدان,مبانى الحضيبة للجوائز - الب",
    "phone": "97143889770",
    "email": "hamdamakkiadvocates@gmail.com",
    "registrationNumber": "ADF-2016-395"
  },
  {
    "id": "b0830edc-21a4-4df9-9d83-febcab7756da",
    "slug": "hamdan-al-harmi-associates-advocates-legal-consultants",
    "name": "HAMDAN AL HARMI & ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/20/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/19/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HAMDAN AL HARMI & ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b0830edc-21a4-4df9-9d83-febcab7756da",
        "address": "Hamdan Abdullah Abdulrahman Ali Alharmi ,2 office 211 ,MSM 1 ,Auto Land Motors ,6064 ,Dubai",
        "phone": "97142999559",
        "email": "hamdan@harmilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Hamdan Abdulla Abdulrahman Ali Al Harmi",
    "address": "2 office 211,MSM 1,Alsafa 1,Dubai,6064",
    "phone": "97142999559",
    "email": "hamdan@harmilaw.com",
    "registrationNumber": "ADF-2011-33"
  },
  {
    "id": "d73d1b91-74ae-4266-9f38-d28296d70f52",
    "slug": "hamdan-alkaabi-advocates-legal-consultants",
    "name": "HAMDAN ALKAABI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/12/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "01/11/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HAMDAN ALKAABI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d73d1b91-74ae-4266-9f38-d28296d70f52",
        "address": "MOSTAFA MAHMOUD  ,1304 ,AL MOOSA TOWER 1 ,First Trade Center ,25635 ,Dubai",
        "phone": "97142254438",
        "email": "info@hkadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Hamdan Abdulla Subaih Saif Alkaabi",
    "address": "1304,AL MOOSA TOWER 1,TRADE CENTER STREET / S",
    "phone": "97142254438",
    "email": "info@hkadvocates.com",
    "registrationNumber": "ADF-2017-398"
  },
  {
    "id": "de2c61a6-9d00-457e-ad1d-e73e4e62d9bd",
    "slug": "hamdan-alshamsi-lawyer-legal-consultants",
    "name": "HAMDAN ALSHAMSI LAWYER & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/25/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/24/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HAMDAN ALSHAMSI LAWYER & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_de2c61a6-9d00-457e-ad1d-e73e4e62d9bd",
        "address": "HAMDAN ALSHAMSI ,الطابق الرابع مكتب 401, 406,407 ,بي سكوير 01 ,مجمع دبي سكوير ,116564 ,Dubai",
        "phone": "97143469262",
        "email": "courts@has.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "HAMDAN MOHD HAMDAN ABDULLA AL SHAMSI",
    "address": "الطابق الرابع مكتب 401, 406,407,بي سكوير 01,ش",
    "phone": "97143469262",
    "email": "courts@has.law",
    "registrationNumber": "ADF-2012-202"
  },
  {
    "id": "522234a0-35f4-468e-8f86-5633ca5ea354",
    "slug": "hamdan-rashoud-alzeyoudi-advocates-and-legal-consultants",
    "name": "HAMDAN RASHOUD ALZEYOUDI ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhSCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/12/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/11/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HAMDAN RASHOUD ALZEYOUDI ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_522234a0-35f4-468e-8f86-5633ca5ea354",
        "address": "",
        "phone": "97148845339 / 971505303737",
        "email": "office@law-hrz.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Hamdan Rashed Ali Rashoud Alzeyoudi",
    "address": "N/A",
    "phone": "97148845339",
    "email": "office@law-hrz.com",
    "registrationNumber": "ADF-2021-561"
  },
  {
    "id": "b0870ce2-bb48-4fd6-84c4-b053eeef75bd",
    "slug": "hamdan-sulaiman-salim-almaazmi-advocates-legal-consultants",
    "name": "HAMDAN SULAIMAN SALIM ALMAAZMI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/30/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HAMDAN SULAIMAN SALIM ALMAAZMI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b0870ce2-bb48-4fd6-84c4-b053eeef75bd",
        "address": "",
        "phone": "97142566628 / 971508908030",
        "email": "info@halmaazmilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Hamdan Sulaiman Salim Sulaiman Almaazmi",
    "address": "N/A",
    "phone": "97142566628",
    "email": "info@halmaazmilaw.com",
    "registrationNumber": "ADF-2024-754"
  },
  {
    "id": "f58725e5-47e3-4ed2-8325-35655ffe5771",
    "slug": "hanan-salem-advocates-legal-consultants",
    "name": "HANAN SALEM ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/02/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "08/01/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HANAN SALEM ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f58725e5-47e3-4ed2-8325-35655ffe5771",
        "address": "104 ,سان شاين 1  ,شقق جرين هاوس الفندقية ,0000 ,Dubai",
        "phone": "97142280666 / 97142280666",
        "email": "Hanansalem.advocate@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Hanan Salem Hasan Albayyed Alshemeili",
    "address": "104,سان شاين 1 ,بردبي,Dubai,0000",
    "phone": "97142280666",
    "email": "Hanansalem.advocate@gmail.com",
    "registrationNumber": "ADF-2012-235"
  },
  {
    "id": "04b37ea9-3ebd-45ff-9b0f-56fa9ee7e6fd",
    "slug": "hani-al-jasmi-advocates-and-legal-consultants",
    "name": "HANI AL JASMI ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/14/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/13/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HANI AL JASMI ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_04b37ea9-3ebd-45ff-9b0f-56fa9ee7e6fd",
        "address": "HANI RAJAB MOOSA ABDULLA ALJASMI ,M ,LIBERTY ,SHARJAH BANK ,123887 ,Dubai",
        "phone": "97142957744",
        "email": "info@aljasmilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Hani Rajab Moosa Abdulla AlJasmi",
    "address": "M,LIBERTY,SHIKH RASHED,Dubai,123887",
    "phone": "97142957744",
    "email": "info@aljasmilaw.com",
    "registrationNumber": "ADF-2012-174"
  },
  {
    "id": "a40a2f1f-69a9-429c-8086-dba9d985532b",
    "slug": "hasan-alrayyami-advocates-legal-consultants",
    "name": "HASAN ALRAYYAMI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/10/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/09/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HASAN ALRAYYAMI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a40a2f1f-69a9-429c-8086-dba9d985532b",
        "address": "HASSAN ALI MATAR ALRIYAMI ,24 ,GRASVENOR BUSINESS TOWER ,NEEDS SUPERMARKET ,215880 ,Dubai",
        "phone": "97144534188",
        "email": "courts@alriyamiadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Hassan Ali Mattar Al Riyami",
    "address": "24,GRASVENOR BUSINESS TOWER,Barsha heights,Du",
    "phone": "97144534188",
    "email": "courts@alriyamiadvocates.com",
    "registrationNumber": "ADF-2014-305"
  },
  {
    "id": "c77eda8b-21fd-4df8-b5b6-1c2876b9c6cf",
    "slug": "hashem-alhashmi-advocates-legal-consultants",
    "name": "HASHEM ALHASHMI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/16/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/15/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HASHEM ALHASHMI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c77eda8b-21fd-4df8-b5b6-1c2876b9c6cf",
        "address": "",
        "phone": "/ 971562331154",
        "email": "info@hashem-alhashmi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Hashem Ali Hashem Ahmed",
    "address": "N/A",
    "phone": "N/A",
    "email": "info@hashem-alhashmi.com",
    "registrationNumber": "ADF-2024-745"
  },
  {
    "id": "9925de3a-6943-440f-95fb-60499c669e9a",
    "slug": "hashim-group-advocates-legal-consultants",
    "name": "HASHIM GROUP ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhHCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/20/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "07/19/2025 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HASHIM GROUP ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9925de3a-6943-440f-95fb-60499c669e9a",
        "address": "",
        "phone": "97143555600",
        "email": "hashimgroup786@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Ahmad Hassan Ali Hashem",
    "address": "N/A",
    "phone": "97143555600",
    "email": "hashimgroup786@gmail.com",
    "registrationNumber": "ADF-2012-223"
  },
  {
    "id": "2fec32c1-d380-4c19-b90e-b30c48520701",
    "slug": "hashim-salem-saif-salem-advocates-and-legal-consultants",
    "name": "HASHIM SALEM SAIF SALEM ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/04/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/03/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HASHIM SALEM SAIF SALEM ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2fec32c1-d380-4c19-b90e-b30c48520701",
        "address": "الطابق التاسع ,الفتان بلازا ,مطار دبي الدولي ,00 ,Dubai",
        "phone": "97145689958 / 971508742777",
        "email": "hashim.salem@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Hashim salem saif Abdulla salem",
    "address": "الطابق التاسع,الفتان بلازا,القرهود,Dubai,00",
    "phone": "97145689958",
    "email": "hashim.salem@yahoo.com",
    "registrationNumber": "ADF-2021-563"
  },
  {
    "id": "746e4dd4-f7bb-4efd-84f5-ad6b769ad28c",
    "slug": "hassan-al-abdooli-advocates-legal-consultants",
    "name": "HASSAN AL ABDOOLI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/17/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/16/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HASSAN AL ABDOOLI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_746e4dd4-f7bb-4efd-84f5-ad6b769ad28c",
        "address": "Hitham Bassam ,1 ,R549 ,بنك مصر ,99094 ,Dubai",
        "phone": "97142355517",
        "email": "hassanalabdooli@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Hassan Abdulla Mohammad Alabdooli",
    "address": "1,R549,بورسعيد / ديرة,Dubai,99094",
    "phone": "97142355517",
    "email": "hassanalabdooli@gmail.com",
    "registrationNumber": "ADF-2011-52"
  },
  {
    "id": "37ab9a73-e65f-4829-9402-6eac64c4c621",
    "slug": "hassan-al-ali-advocates-legal-consultancy",
    "name": "HASSAN AL ALI ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/01/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/30/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HASSAN AL ALI ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_37ab9a73-e65f-4829-9402-6eac64c4c621",
        "address": "الطابق الثامن ,بزنس أفنيو ,خلف وكالة نيسان ,444775 ,Dubai",
        "phone": "97142501414",
        "email": "info@halalilaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Hassan Abdalla Mohamed Ali Al Ali",
    "address": "الطابق الثامن,بزنس أفنيو,منطقة بور سعيد ديرة",
    "phone": "97142501414",
    "email": "info@halalilaw.ae",
    "registrationNumber": "ADF-2017-415"
  },
  {
    "id": "6a822223-cec3-43fe-b3a7-3d4a10d010c4",
    "slug": "hassan-ashoor-al-mulla-advocates-legal-consultants",
    "name": "HASSAN ASHOOR AL MULLA ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/10/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/09/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HASSAN ASHOOR AL MULLA ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6a822223-cec3-43fe-b3a7-3d4a10d010c4",
        "address": "11 مكتب رقم 1104 ,وصل بيزنش سنترال ,خلف سيتي سنتر ديره ,23404 ,Dubai",
        "phone": "97142865503 / 971502705678",
        "email": "info-dxb@almulla-advocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Hassan Ashoor Hassan Abdulla Almulla",
    "address": "11 مكتب رقم 1104,وصل بيزنش سنترال,شارع الاتحا",
    "phone": "97142865503",
    "email": "info-dxb@almulla-advocates.ae",
    "registrationNumber": "ADF-2019-473"
  },
  {
    "id": "92cddf0e-969b-47c0-a9a7-9fb57a11d292",
    "slug": "hassan-humaid-al-suwaidi-advocates-and-legal-consultancy",
    "name": "HASSAN HUMAID AL SUWAIDI ADVOCATES AND LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/17/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/16/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HASSAN HUMAID AL SUWAIDI ADVOCATES AND LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_92cddf0e-969b-47c0-a9a7-9fb57a11d292",
        "address": "",
        "phone": "97142500251",
        "email": "hassan.suwaidi@hhslawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Hassan Humaid Abdulla Hassan Al Suwaidi",
    "address": "N/A",
    "phone": "97142500251",
    "email": "hassan.suwaidi@hhslawyers.com",
    "registrationNumber": "ADF-2012-178"
  },
  {
    "id": "6e2fe0dd-c3f8-40ae-9ed8-5e4fdf894d9b",
    "slug": "hassan-tamim-advocates-legal-consultants",
    "name": "HASSAN TAMIM ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhUCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/20/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HASSAN TAMIM ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6e2fe0dd-c3f8-40ae-9ed8-5e4fdf894d9b",
        "address": "Hassan Mohammad Hassan Tamim ,الطابق السادس 614 ,اعمار بزنس بارك - 4  ,Zabeel house the greens - hotel  ,18122 ,Dubai",
        "phone": "97142999972",
        "email": "info@htlawyers.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Hassan Mohammad Hassan Tamim",
    "address": "الطابق السادس 614,اعمار بزنس بارك - 4 ,الشيخ",
    "phone": "97142999972",
    "email": "tamimadvocates@gmail.com",
    "registrationNumber": "ADF-2014-292"
  },
  {
    "id": "6089dcf8-5807-40f2-a1ef-e628a0f31e26",
    "slug": "heba-ahli-advocates-legal-consultancy",
    "name": "HEBA AHLI ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/14/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "01/13/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HEBA AHLI ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6089dcf8-5807-40f2-a1ef-e628a0f31e26",
        "address": "Heba Ahli ,6th Floor  ,Prime Business Building  ,Khansour Community Park ,414142 ,Dubai",
        "phone": "97143358885 / 971505509997",
        "email": "info@mitchelpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "6th Floor ,Prime Business Building ,Jumeirah",
    "phone": "97143358885",
    "email": "info@mitchelpartners.com",
    "registrationNumber": "ADF-2018-439"
  },
  {
    "id": "ee61dd8d-28a2-4c21-9a46-a87635463b13",
    "slug": "hend-alktebi-advocates-legal-consultants",
    "name": "HEND ALKTEBI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/11/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/10/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HEND ALKTEBI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ee61dd8d-28a2-4c21-9a46-a87635463b13",
        "address": "",
        "phone": "97143968700",
        "email": "admin@haklegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Hend Humaid Ali Ghudayer Alktebi",
    "address": "N/A",
    "phone": "97143968700",
    "email": "admin@haklegal.com",
    "registrationNumber": "ADF-2013-287"
  },
  {
    "id": "17773ca4-24da-4486-9931-d51188bf4d88",
    "slug": "hend-bin-hendi-advocates-legal-consultants",
    "name": "HEND BIN HENDI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhCCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/07/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/06/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HEND BIN HENDI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_17773ca4-24da-4486-9931-d51188bf4d88",
        "address": "Hend Humaid Khalifa Bin Hendi Alaleeli  ,2/201 ,ALMIHIRI BLAZA - Al Khabisi , Hyundai Show ROOM  ,000 ,Dubai",
        "phone": "97143999691 / 971000000000",
        "email": "hend.alaleeli@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "HEND HUMAID KHALIFA BINHENDI ALALEELI",
    "address": "2/201,ALMIHIRI BLAZA - Al Khabisi,الخبيصى ,Du",
    "phone": "97143999691",
    "email": "hend.alaleeli@gmail.com",
    "registrationNumber": "ADF-2024-734"
  },
  {
    "id": "ebacdf1e-411d-4d78-a4e2-7b41750d6c08",
    "slug": "hessa-al-jaberi-advocates-legal-consultants",
    "name": "HESSA AL JABERI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/28/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "01/27/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HESSA AL JABERI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ebacdf1e-411d-4d78-a4e2-7b41750d6c08",
        "address": "201 ,Bou Haliba Building  ,Opposite of Al Bakhit Centre ,181116 ,Dubai",
        "phone": "97142507711",
        "email": "h.aljaberiadvocates@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "201,Bou Haliba Building ,Muraqabat Road,Dubai",
    "phone": "97142507711",
    "email": "h.aljaberiadvocates@gmail.com",
    "registrationNumber": "ADF-2013-268"
  },
  {
    "id": "d6da9923-01fb-4fd8-a9da-a02d2122dbde",
    "slug": "hessa-al-shehhi-advocates-legal-consultants",
    "name": "Hessa Al Shehhi ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/12/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/11/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Hessa Al Shehhi ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d6da9923-01fb-4fd8-a9da-a02d2122dbde",
        "address": "HAMAD ABDULLA ABDULRAHMAN ALRAHMA ALHAMMADI ,14TH FLOOR - 1403 ,PARK PLACE TOWER ,WORLD TRADE CENTER ,114295 ,Dubai",
        "phone": "97144227465 / 971555507070",
        "email": "hessa.alshehhi@primecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "HESSAH SAEED MOHAMED ALSHEHHI",
    "address": "14TH FLOOR - 1403,PARK PLACE TOWER,SHEIKH ZAY",
    "phone": "97144227465",
    "email": "hessa.alshehhi@primecase.com",
    "registrationNumber": "ADF-2018-444"
  },
  {
    "id": "110bcc76-e3fc-40c6-960f-9dfd1ffd5067",
    "slug": "hessa-alattay-advocates-legal-consultants",
    "name": "HESSA ALATTAY ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/31/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/30/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HESSA ALATTAY ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_110bcc76-e3fc-40c6-960f-9dfd1ffd5067",
        "address": "",
        "phone": "97143688984",
        "email": "legalsolutions@alattay.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97143688984",
    "email": "legalsolutions@alattay.com",
    "registrationNumber": "ADF-2012-253"
  },
  {
    "id": "e78d4c87-2450-4a73-af8f-bdea91defa61",
    "slug": "hessa-alhammadi-advocates-legal-consultants",
    "name": "HESSA ALHAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/01/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "08/31/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HESSA ALHAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e78d4c87-2450-4a73-af8f-bdea91defa61",
        "address": "",
        "phone": "97143339002 / 971558818724",
        "email": "info@nhalhammadi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Hessa Salem Ismail Saeed Alhammadi",
    "address": "N/A",
    "phone": "97143339002",
    "email": "info@nhalhammadi.com",
    "registrationNumber": "ADF-2020-507"
  },
  {
    "id": "432dbfa7-962d-4bbc-a64a-c3185bf78a66",
    "slug": "hessa-humaid-al-shara-advocates-legal-consultants",
    "name": "HESSA HUMAID AL SHARA ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/31/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "01/30/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HESSA HUMAID AL SHARA ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_432dbfa7-962d-4bbc-a64a-c3185bf78a66",
        "address": "10 Floor - Office No. 10001 ,Latifa Tower ,Makani No: 9063026848 ,000 ,Dubai",
        "phone": "97142522995 / 971505897795",
        "email": "a.legal.uae@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "hessah humaid abdulla alshara almaazmi",
    "address": "10 Floor - Office No. 10001,Latifa Tower,Shei",
    "phone": "97142522995",
    "email": "a.legal.uae@gmail.com",
    "registrationNumber": "ADF-2023-654"
  },
  {
    "id": "06d1b0e4-10d9-46d5-9f6b-44710029bb65",
    "slug": "hiba-maani-advocates-legal-consultants",
    "name": "HIBA MAANI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/29/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "01/28/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HIBA MAANI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_06d1b0e4-10d9-46d5-9f6b-44710029bb65",
        "address": "",
        "phone": "97142986558",
        "email": "mak@maklegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97142986558",
    "email": "mak@maklegal.ae",
    "registrationNumber": "ADF-2015-334"
  },
  {
    "id": "216ebf72-e55b-4446-b7a6-5c17ba8c9b5d",
    "slug": "hikmat-fayad-and-associates-advocates-legal-consultants",
    "name": "HIKMAT FAYAD AND ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhGCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/26/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/25/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HIKMAT FAYAD AND ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_216ebf72-e55b-4446-b7a6-5c17ba8c9b5d",
        "address": "الخامس  ,البرج الأخضر  ,خلف فندق موسكو  ,5630 ,Dubai",
        "phone": "97142222888",
        "email": "fayadlaw@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "الخامس ,البرج الأخضر ,ديرة رقة البطين ,Dubai,",
    "phone": "97142222888",
    "email": "fayadlaw@emirates.net.ae",
    "registrationNumber": "ADF-2011-01"
  },
  {
    "id": "f765f492-2c17-47d7-b80f-bf6cb7669cbe",
    "slug": "hilal-associates-advocates-legal-consultants",
    "name": "HILAL & ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/29/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/28/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HILAL & ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f765f492-2c17-47d7-b80f-bf6cb7669cbe",
        "address": "",
        "phone": "97142955388 / 971507739863",
        "email": "arhilal@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Sultan Rashid Ahmed Helal",
    "address": "N/A",
    "phone": "97142955388",
    "email": "arhilal@emirates.net.ae",
    "registrationNumber": "ADF-2011-16"
  },
  {
    "id": "e1992c6d-5368-42d8-b1d8-fb5d1790ad62",
    "slug": "hind-ali-advocates-legal-consultants",
    "name": "HIND ALI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/06/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2021-05-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HIND ALI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e1992c6d-5368-42d8-b1d8-fb5d1790ad62",
        "address": "",
        "phone": "97143999565",
        "email": "law.uae@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97143999565",
    "email": "law.uae@hotmail.com",
    "registrationNumber": "ADF-2020-518"
  },
  {
    "id": "4e25fb39-6659-44f0-bc8b-3ff0f067beb0",
    "slug": "horizons-co-law-firm",
    "name": "HORIZONS & CO - LAW FIRM",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhDCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/25/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "07/24/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HORIZONS & CO - LAW FIRM",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4e25fb39-6659-44f0-bc8b-3ff0f067beb0",
        "address": "O-4801, O-4901 ,Burj al Salam Office Tower ,H Hotel ,111801 ,Dubai",
        "phone": "97143544444",
        "email": "administration@horizlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Ali Ismail Mohammed Abdulla Alzarooni",
    "address": "O-4801, O-4901,Burj al Salam Office Tower,She",
    "phone": "97143544444",
    "email": "administration@horizlaw.ae",
    "registrationNumber": "ADF-2012-225"
  },
  {
    "id": "c7a17e12-3d49-4166-82c8-271a6d223675",
    "slug": "hourani-patners",
    "name": "HOURANI & PATNERS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhQCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/11/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "01/10/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HOURANI & PATNERS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c7a17e12-3d49-4166-82c8-271a6d223675",
        "address": "Fadi H. Hourani ,3 ,The Offices 5, One Central ,The Museum of the Future ,10152 ,Dubai",
        "phone": "97142052000",
        "email": "info@houranipartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Fadi Hayel Al-Hourani",
    "address": "3,The Offices 5, One Central,Dubai World Trad",
    "phone": "97142052000",
    "email": "info@houranipartners.com",
    "registrationNumber": "ADF-2012-78"
  },
  {
    "id": "d34586c5-1e0a-4290-af29-23366d37b852",
    "slug": "hoyam-alzarouni-advocates-legal-consultants",
    "name": "HOYAM ALZAROUNI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/19/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/18/2025 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HOYAM ALZAROUNI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d34586c5-1e0a-4290-af29-23366d37b852",
        "address": "",
        "phone": "97143116556 / 971000000000",
        "email": "info@hazlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Hoyam Younis Zainal Hussain Ali",
    "address": "N/A",
    "phone": "97143116556",
    "email": "info@hazlaw.ae",
    "registrationNumber": "ADF-2020-520"
  },
  {
    "id": "ad6144aa-8e59-43ea-9119-f2856d122685",
    "slug": "huda-alhammadi-advocates-legal-consultants",
    "name": "HUDA ALHAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/05/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HUDA ALHAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ad6144aa-8e59-43ea-9119-f2856d122685",
        "address": "",
        "phone": "97142551142 / 971502226062",
        "email": "Huda@halhammadi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Huda Hasan Yousef mohamed",
    "address": "الاول مكتب رقم 101,ACICO GULF REAL ESTATE L.L",
    "phone": "97142551142",
    "email": "Huda@halhammadi.com",
    "registrationNumber": "ADF-2025-771"
  },
  {
    "id": "a1cee907-ce7d-484b-a20d-16cb79cd6c04",
    "slug": "huda-almaazmi-advocates-legal-consultants",
    "name": "HUDA ALMAAZMI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/06/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/05/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HUDA ALMAAZMI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a1cee907-ce7d-484b-a20d-16cb79cd6c04",
        "address": "الطابق الحادي عشر ,بناية الحواي ,متحف المستقبل ,183335 ,Dubai",
        "phone": "97142888874 / 971551740400",
        "email": "h.almazmi89@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Huda Mohamed Ali Juma Almaazmi",
    "address": "الطابق الحادي عشر,بناية الحواي,شارع الشيخ زاي",
    "phone": "97142888874",
    "email": "h.almazmi89@gmail.com",
    "registrationNumber": "ADF-2020-551"
  },
  {
    "id": "0d19b22a-0678-43d9-ae17-061958b88e0e",
    "slug": "huda-yaqoob-advocates-legal-consultants",
    "name": "HUDA YAQOOB ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhZCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/06/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/05/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HUDA YAQOOB ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0d19b22a-0678-43d9-ae17-061958b88e0e",
        "address": "",
        "phone": "97145293307",
        "email": "info@hyadvocate.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Huda Yaqoob Darwish Johar Marzooq",
    "address": "N/A",
    "phone": "97145293307",
    "email": "info@hyadvocate.com",
    "registrationNumber": "ADF-2022-630"
  },
  {
    "id": "42521deb-a4c5-41c9-989c-c10b046f34b5",
    "slug": "humaid-alansari-advocates-legal-consultants",
    "name": "HUMAID ALANSARI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/24/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "01/23/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HUMAID ALANSARI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_42521deb-a4c5-41c9-989c-c10b046f34b5",
        "address": "",
        "phone": "97143585135 / 971503564426",
        "email": "info@alansarilaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Humaid Mohammed Redha Alansari",
    "address": "N/A",
    "phone": "97143585135",
    "email": "info@alansarilaw.ae",
    "registrationNumber": "ADF-2021-587"
  },
  {
    "id": "bcfc630f-83fd-48e1-88ff-51688a450f17",
    "slug": "humaid-darwish-advocates-legal-consultants",
    "name": "HUMAID DARWISH ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhECiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/18/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/17/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HUMAID DARWISH ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bcfc630f-83fd-48e1-88ff-51688a450f17",
        "address": "",
        "phone": "97143324114",
        "email": "humaidhd@eim.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97143324114",
    "email": "humaidhd@eim.ae",
    "registrationNumber": "ADF-2011-26"
  },
  {
    "id": "e07b0a55-9fe6-457d-a9ff-a1dada995416",
    "slug": "humaid-yousuf-advocates-legal-consultants",
    "name": "HUMAID YOUSUF ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhZCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/07/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "02/06/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HUMAID YOUSUF ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e07b0a55-9fe6-457d-a9ff-a1dada995416",
        "address": "M19 ,بناية مركز القرهود للأعمال ,مستشفى القرهود التخصصي  ,445499 ,Dubai",
        "phone": "97142999949",
        "email": "info@hsadvo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Humaid Yousuf Rubaya Ali",
    "address": "M19,بناية مركز القرهود للأعمال,شارع 57 منطقة",
    "phone": "97142999949",
    "email": "info@hsadvo.com",
    "registrationNumber": "ADF-2017-402"
  },
  {
    "id": "79eb0fc3-cc12-46e8-a1fe-a548453d5278",
    "slug": "husain-hasan-mohamed-al-ali-advocates-legal-consultants",
    "name": "HUSAIN HASAN MOHAMED AL ALI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/08/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "08/07/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HUSAIN HASAN MOHAMED AL ALI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_79eb0fc3-cc12-46e8-a1fe-a548453d5278",
        "address": "Fourth Floor - Office No. 411 ,Oud Metha Office Building ,Makani No: 3093891125 ,49909 ,Dubai",
        "phone": "97100000000 / 971507559971",
        "email": "husain.alali@alaliadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Husain Hasan Mohamed Al Ali",
    "address": "Fourth Floor - Office No. 411,Oud Metha Offic",
    "phone": "97100000000",
    "email": "husain.alali@alaliadvocates.com",
    "registrationNumber": "ADF-2023-687"
  },
  {
    "id": "1d48c777-9533-4c84-8e5b-5abde5f50dab",
    "slug": "hussa-ali-alqubaisi-advocates-legal-consultants",
    "name": "HUSSA ALI ALQUBAISI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/13/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/12/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HUSSA ALI ALQUBAISI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1d48c777-9533-4c84-8e5b-5abde5f50dab",
        "address": "HUSSA ALI ALQUBAISI ,FLOOR 31 OFFICE 3103 ,BURLINGTON TOWER ,DUBAI ISLAMIC BANK ,15002 ,Dubai",
        "phone": "97142427805",
        "email": "info@haqlegalconsultants.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Hussa Ali Mohamed Haji Alqubaisi",
    "address": "FLOOR 31 OFFICE 3103,BURLINGTON TOWER,BUSINES",
    "phone": "97142427805",
    "email": "info@haqlegalconsultants.com",
    "registrationNumber": "ADF-2017-411"
  },
  {
    "id": "9ac6b6e4-eb41-48d4-9dfa-407f711a64ad",
    "slug": "hussain-aljahazi-advocates-legal-consultancy",
    "name": "HUSSAIN ALJAHAZI ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/06/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-05-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HUSSAIN ALJAHAZI ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9ac6b6e4-eb41-48d4-9dfa-407f711a64ad",
        "address": "",
        "phone": "97142678800 / 971050646353",
        "email": "info@hussainaljahazilawyer.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Hussain Mohammed Hassan Aljahazi",
    "address": "N/A",
    "phone": "97142678800",
    "email": "info@hussainaljahazilawyer.ae",
    "registrationNumber": "ADF-2021-540"
  },
  {
    "id": "4ad67cb4-18b4-4417-9b6a-d23a9fb368fb",
    "slug": "hussain-lootah-partners-attorneys-counsellors-at-law",
    "name": "HUSSAIN LOOTAH & PARTNERS - ATTORNEYS & COUNSELLORS AT LAW",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhMCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/08/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/07/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HUSSAIN LOOTAH & PARTNERS - ATTORNEYS & COUNSELLORS AT LAW",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4ad67cb4-18b4-4417-9b6a-d23a9fb368fb",
        "address": "الطابق الثامن  ,برج الجرج 1 ,دائرة الاراضي و الاملاك  ,9117 ,Dubai",
        "phone": "97143320004",
        "email": "info@hlootahlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Ahmad Hussain Ali Abdulrahman Lootah",
    "address": "الطابق الثامن ,برج الجرج 1,رقه البطين ,Dubai,",
    "phone": "97143320004",
    "email": "info@hlootahlaw.com",
    "registrationNumber": "ADF-2012-168"
  },
  {
    "id": "e1228738-be5a-4b34-8ced-b04d430944d0",
    "slug": "hussain-mirza-advocates-legal-consultants",
    "name": "HUSSAIN MIRZA ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/28/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/27/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HUSSAIN MIRZA ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e1228738-be5a-4b34-8ced-b04d430944d0",
        "address": "Office No. 1310 ,Saheel 2 Building ,Al Nahda 1 – Saheel 2 Building ,00 ,Dubai",
        "phone": "97145856322",
        "email": "husain.almahdi@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Hussain Mirza Ahmed Abdalla Almahdi",
    "address": "Office No. 1310,Saheel 2 Building,Al Nahda 1,",
    "phone": "97145856322",
    "email": "husain.almahdi@gmail.com",
    "registrationNumber": "ADF-2022-648"
  },
  {
    "id": "8127d958-05bb-47c2-bae1-2d1548de2cf3",
    "slug": "hussain-mohamed-alhosani-advocates-legal-consultants",
    "name": "HUSSAIN MOHAMED ALHOSANI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/24/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "01/23/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HUSSAIN MOHAMED ALHOSANI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8127d958-05bb-47c2-bae1-2d1548de2cf3",
        "address": "Hussain Mohamed AL Hosani ,Office 314 ,Bussnis Avenue ,AL Roustomani ,7094 ,Dubai",
        "phone": "97143322338 / 971568842488",
        "email": "info@hmalegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Hussain Mohamed Hasan Hatem",
    "address": "Office 314,Bussnis Avenue,Shikh Rashid AL Mak",
    "phone": "97143322338",
    "email": "info@hmalegal.ae",
    "registrationNumber": "ADF-2019-469"
  },
  {
    "id": "41cb350f-b39d-4e9d-aaed-e79bb9af487d",
    "slug": "ibrahim-al-qassim-advocates-legal-consultants",
    "name": "IBRAHIM AL QASSIM ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIElBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/19/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/18/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: IBRAHIM AL QASSIM ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_41cb350f-b39d-4e9d-aaed-e79bb9af487d",
        "address": "",
        "phone": "97142224441",
        "email": "info@ialqassim.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Ibraheim Mohammed Ahmad Mphammed Al-Qasem",
    "address": "N/A",
    "phone": "97142224441",
    "email": "info@ialqassim.com",
    "registrationNumber": "ADF-2012-197"
  },
  {
    "id": "e3ffafe9-0f0c-4d88-a976-2bdfd7d18411",
    "slug": "ibrahim-albanna-advocates-legal-consultants",
    "name": "IBRAHIM ALBANNA ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIElBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/27/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/26/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: IBRAHIM ALBANNA ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e3ffafe9-0f0c-4d88-a976-2bdfd7d18411",
        "address": "الطابق الرابع ,الصقر للاعمال ,محطة مترو ابراج الامارات  ,67476 ,Dubai",
        "phone": "97143444210",
        "email": "assistant@albannaadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Ibrahim Mohammad Ibrahim Abdulla Albanna",
    "address": "الطابق الرابع,الصقر للاعمال,شارع الشيخ زايد,D",
    "phone": "97143444210",
    "email": "assistant@albannaadvocates.com",
    "registrationNumber": "ADF-2015-348"
  },
  {
    "id": "da36558c-bfcb-4fbf-8416-f80643ccb280",
    "slug": "ibrahim-alhammadi-advocates-and-legal-consultants",
    "name": "IBRAHIM ALHAMMADI ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIElBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/16/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/15/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: IBRAHIM ALHAMMADI ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_da36558c-bfcb-4fbf-8416-f80643ccb280",
        "address": "",
        "phone": "97143334404",
        "email": "info@ihadvo.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Ibrahim Hasan Salem Ali Alhmmadi",
    "address": "N/A",
    "phone": "97143334404",
    "email": "info@ihadvo.ae",
    "registrationNumber": "ADF-2022-643"
  },
  {
    "id": "196bb7bb-4be6-4029-9367-c100bd219d3f",
    "slug": "ibrahim-alserkal-advocates-legal-consultants",
    "name": "IBRAHIM ALSERKAL ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIElBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/29/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "07/28/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: IBRAHIM ALSERKAL ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_196bb7bb-4be6-4029-9367-c100bd219d3f",
        "address": "15th Floor _ Office No. 1504 ,SOBHA SAPPHIRE ,Makani No: 2612485764 ,000 ,Dubai",
        "phone": "97145570789 / 971521800001",
        "email": "Info@iserkal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Ibrahim Ali Ibrahim Ali AlSerkal",
    "address": "15th Floor _ Office No. 1504,SOBHA SAPPHIRE,B",
    "phone": "97145570789",
    "email": "Info@iserkal.com",
    "registrationNumber": "ADF-2024-736"
  },
  {
    "id": "20341bc8-5500-4b12-a88b-d8341d03d88c",
    "slug": "ibrahim-haddad-advocates-and-legal-consultancy",
    "name": "IBRAHIM HADDAD ADVOCATES AND LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIElICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/20/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/19/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: IBRAHIM HADDAD ADVOCATES AND LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_20341bc8-5500-4b12-a88b-d8341d03d88c",
        "address": "IBRAHIM ,الاول 107 ,مبني العويس المطار ,بنايه بيزنس افينو ,41334 ,Dubai",
        "phone": "97142566888",
        "email": "info@ihadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Ibrahim Mohamed Ali Haddad",
    "address": "الاول 107,مبني العويس المطار,بورسعيد ديره ,Du",
    "phone": "97142566888",
    "email": "info@ihadvocates.com",
    "registrationNumber": "ADF-2015-351"
  },
  {
    "id": "7f366bee-e90b-4c77-b535-ccd366935872",
    "slug": "ibrahim-khouri-advocates-legal-consultants",
    "name": "IBRAHIM KHOURI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIElLCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/08/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "07/07/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: IBRAHIM KHOURI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7f366bee-e90b-4c77-b535-ccd366935872",
        "address": "",
        "phone": "97143266677 / 971506234989",
        "email": "md@khourilawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "IBRAHIM ALI KARAM MOHAMMED ALKHOORI",
    "address": "N/A",
    "phone": "97143266677",
    "email": "md@khourilawyers.com",
    "registrationNumber": "ADF-2012-219"
  },
  {
    "id": "57836e55-f90c-4fb1-81d0-a735a168b9ac",
    "slug": "international-consultant-law-office",
    "name": "INTERNATIONAL CONSULTANT LAW OFFICE",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIElDCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/02/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/01/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: INTERNATIONAL CONSULTANT LAW OFFICE",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_57836e55-f90c-4fb1-81d0-a735a168b9ac",
        "address": "Saleh Ahmed Yousif Saleh Alobeidli ,2nd ,DUBAI SUPREME COURT COMPLEX ,Dubai Courts ,333842 ,Dubai",
        "phone": "97143546762",
        "email": "Laila@iclo.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Saleh Ahmed Yousif Saleh Alobaidli",
    "address": "3rd,DCCI-NEW BUILDING EXTENSION,Rega Al Butee",
    "phone": "97143546762",
    "email": "Laila@iclo.ae",
    "registrationNumber": "ADF-2014-308"
  },
  {
    "id": "382198c6-5727-490a-963b-91b675ddc7bc",
    "slug": "international-counsels-advocates-legal-consultants",
    "name": "INTERNATIONAL COUNSELS ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIElDCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/09/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/08/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: INTERNATIONAL COUNSELS ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_382198c6-5727-490a-963b-91b675ddc7bc",
        "address": "4 - 449 ,Emarat Atrium ,Gulf News ,413533 ,Dubai",
        "phone": "97143211966",
        "email": "icalc@internationalcounsels.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Michel Amado Chalhoub",
    "address": "4 - 449,Emarat Atrium,Sheikh Zayed Road - Al",
    "phone": "97143211966",
    "email": "icalc@internationalcounsels.ae",
    "registrationNumber": "ADF-2014-309"
  },
  {
    "id": "ceb9cbcf-79f3-462d-afe2-aa4c62eff72b",
    "slug": "ismail-alsaffar-advocates-legal-consultants",
    "name": "ISMAIL ALSAFFAR ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIElBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/22/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "02/21/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ISMAIL ALSAFFAR ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ceb9cbcf-79f3-462d-afe2-aa4c62eff72b",
        "address": "ISMAIL HASSAN EBRAHIM ALSAFFAR ,الطابق الثامن - مكتب 801 AFR ,الصقر للاعمال ,يوجد اسفل البناية مطعم وينديز ,25752 ,Dubai",
        "phone": "97143276805",
        "email": "info@alsaffar-legal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Ismail Hassan Ibrahim Al-Saffar",
    "address": "الطابق الثامن - مكتب 801 AFR,الصقر للاعمال,ال",
    "phone": "97143276805",
    "email": "info@alsaffar-legal.com",
    "registrationNumber": "ADF-2015-336"
  },
  {
    "id": "fc756ad4-f6fc-481e-9094-41cdf623131d",
    "slug": "ismail-alzarooni-advocacy-and-legal-consultancy",
    "name": "ISMAIL ALZAROONI ADVOCACY AND LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIElBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/11/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/10/2019 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ISMAIL ALZAROONI ADVOCACY AND LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fc756ad4-f6fc-481e-9094-41cdf623131d",
        "address": "",
        "phone": "97143433443 / 971509494490",
        "email": "ismail@izlegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97143433443",
    "email": "ismail@izlegal.ae",
    "registrationNumber": "ADF-2017-428"
  },
  {
    "id": "e7fa8685-3867-4766-b10a-4ac053ce23cf",
    "slug": "ismail-hassan-advocates-legal-consultant",
    "name": "ISMAIL HASSAN ADVOCATES & LEGAL CONSULTANT",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIElICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/30/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "07/29/2019 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ISMAIL HASSAN ADVOCATES & LEGAL CONSULTANT",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e7fa8685-3867-4766-b10a-4ac053ce23cf",
        "address": "ISMAIL HASSAN ALI MOHAMMAD ALJAABI ,102 ,PORT SAEED BUILDING ,EPPCO ,22703 ,Dubai",
        "phone": "97142395958",
        "email": "ismail.hassanlegal@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "102,PORT SAEED BUILDING,PORT SAEED / A St -22",
    "phone": "97142395958",
    "email": "ismail.hassanlegal@gmail.com",
    "registrationNumber": "ADF-2015-357"
  },
  {
    "id": "55eb8a12-f67e-4da7-ba9f-a908826c5c44",
    "slug": "ismail-ibrahim-alhosani-advocates-legal-consultants",
    "name": "ISMAIL IBRAHIM ALHOSANI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIElJCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/28/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/27/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ISMAIL IBRAHIM ALHOSANI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_55eb8a12-f67e-4da7-ba9f-a908826c5c44",
        "address": "ISMAIL IBRAHIM ALHOSANI ,الثالث ,القرهود ستار ,سالم لفحص اللياقة ,76113 ,Dubai",
        "phone": "97144498077 / 971508133077",
        "email": "advocateismailalhosani@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "ISMAIL IBRAHIM SAQER IBRAHIM AL-HOSANI",
    "address": "الثالث,القرهود ستار,61A/ديرة/القرهود,Dubai,76",
    "phone": "97144498077",
    "email": "advocateismailalhosani@gmail.com",
    "registrationNumber": "ADF-2023-664"
  },
  {
    "id": "ee41a5ea-49b1-4cd3-950b-d073f9bf8158",
    "slug": "issa-abi-younes-advocates-legal-consultants",
    "name": "ISSA & ABI YOUNES ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIElBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/23/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "02/22/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ISSA & ABI YOUNES ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ee41a5ea-49b1-4cd3-950b-d073f9bf8158",
        "address": "ROULA MAALOUF ,5- UNIT 514 ,LIBERTY HOUSE ,RITZ HOTEL DIFC ,506949 ,Dubai",
        "phone": "97148359858",
        "email": "issa@iaalo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Elias Abi Younes",
    "address": "5- UNIT 514,LIBERTY HOUSE,DIFC,Dubai,506949",
    "phone": "97148359858",
    "email": "issa@iaalo.com",
    "registrationNumber": "ADF-2022-656"
  },
  {
    "id": "c58d8654-b428-46b3-abd5-024e4331ee53",
    "slug": "jaafar-alwan-al-jaziri-associates",
    "name": "JAAFAR ALWAN & AL JAZIRI & ASSOCIATES",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEpBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/27/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/26/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: JAAFAR ALWAN & AL JAZIRI & ASSOCIATES",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c58d8654-b428-46b3-abd5-024e4331ee53",
        "address": "Hussain Ali Al Jaziri ,11 ,City Tower 2 ,Crown Plaza hotel Sheikh Zayed Road ,4253 ,Dubai",
        "phone": "97142626777 / 971529087670",
        "email": "courts@jaflaws.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Hussain Ali Hussain Al-Jaziri",
    "address": "11,City Tower 2,Sheikh Zayed Road,Dubai,4253",
    "phone": "97142626777",
    "email": "courts@jaflaws.com",
    "registrationNumber": "ADF-2019-477"
  },
  {
    "id": "ee5a7838-1f12-4443-832e-a3a87eff8dd6",
    "slug": "jabir-rashid-al-salami-advocates-legal-consultants",
    "name": "JABIR RASHID AL SALAMI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEpSCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/04/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/03/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: JABIR RASHID AL SALAMI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ee5a7838-1f12-4443-832e-a3a87eff8dd6",
        "address": "jabir rashid alsalami ,b3607 ,latifa tower ,crowne plaza hotel - dubai ,3117 ,Dubai",
        "phone": "97143599997",
        "email": "jabir@jabiralsalami.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "b3607,latifa tower,trade center frist - sheik",
    "phone": "97143599997",
    "email": "jabir@jabiralsalami.com",
    "registrationNumber": "ADF-2014-302"
  },
  {
    "id": "4c91b3c6-b64f-4855-bd5e-44d442d235bf",
    "slug": "jamal-alshamsi-advocates-legal-consultants",
    "name": "JAMAL ALSHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEpBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/26/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/25/2025 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: JAMAL ALSHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4c91b3c6-b64f-4855-bd5e-44d442d235bf",
        "address": "",
        "phone": "97144919339 / 971000000000",
        "email": "info@advo.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97144919339",
    "email": "info@advo.ae",
    "registrationNumber": "ADF-2021-568"
  },
  {
    "id": "e0974afb-31b9-4ece-8c6e-ed607a9e9e04",
    "slug": "jamal-alshehhi-advocates-legal-consultants",
    "name": "JAMAL ALSHEHHI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEpBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/15/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: JAMAL ALSHEHHI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e0974afb-31b9-4ece-8c6e-ed607a9e9e04",
        "address": "Jamal Hamad Obaid Alshehhi ,7 ,CENTURY 21 BLDG ,مركز حمر عين - مركز القبائل ,11977 ,Dubai",
        "phone": "97143376360 / 971556980980",
        "email": "info@alshehilaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Jamal Hamad Obaid Alshehhi",
    "address": "7,CENTURY 21 BLDG,شارع ابوبكر الصديق / المرقب",
    "phone": "97143376360",
    "email": "info@alshehilaw.ae",
    "registrationNumber": "ADF-2025-769"
  },
  {
    "id": "55170c84-533c-4f35-8372-4130cfb0aad9",
    "slug": "jamila-almehiri-advocates-legal-consultants",
    "name": "JAMILA ALMEHIRI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEpBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/15/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "08/14/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: JAMILA ALMEHIRI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_55170c84-533c-4f35-8372-4130cfb0aad9",
        "address": "JAMILA SAEED ,طابق الميزانين مكتب رقم M18 ,برج بيزنيس أفينيو ,معرض شركة نيسان للسيارات ,23677 ,Dubai",
        "phone": "97148866123 / 971528003000",
        "email": "jamila.almheiriadvocates@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Jamila Saeed Majid Saeed Al Mheiri",
    "address": "طابق الميزانين مكتب رقم M18,برج بيزنيس أفينيو",
    "phone": "97148866123",
    "email": "jamila.almheiriadvocates@gmail.com",
    "registrationNumber": "ADF-2017-425"
  },
  {
    "id": "8785e2d6-1e31-405c-b3b7-6422459731c0",
    "slug": "jamila-alzahrani-advocates-legal-consultants",
    "name": "JAMILA ALZAHRANI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEpBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/08/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/07/2027 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: JAMILA ALZAHRANI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8785e2d6-1e31-405c-b3b7-6422459731c0",
        "address": "",
        "phone": "97145681225",
        "email": "info@jalzahrani.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Jamila Hussain Ali Muaid Al Zahrani",
    "address": "N/A",
    "phone": "97145681225",
    "email": "info@jalzahrani.ae",
    "registrationNumber": "ADF-2022-640"
  },
  {
    "id": "077da0c2-09f9-4187-b455-b548a4c10707",
    "slug": "jasem-al-bloushi-advocates-and-legal-consultants",
    "name": "JASEM AL BLOUSHI ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEpBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/22/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "08/21/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: JASEM AL BLOUSHI ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_077da0c2-09f9-4187-b455-b548a4c10707",
        "address": "",
        "phone": "97145780666",
        "email": "courts@jasem-legal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Jasem Abdulla Mohammed Ahmed Al Bloushi",
    "address": "N/A",
    "phone": "97145780666",
    "email": "courts@jasem-legal.com",
    "registrationNumber": "ADF-2022-620"
  },
  {
    "id": "490cb579-167c-4a7e-b679-997fb6780992",
    "slug": "jasim-alhaddad-advocates-legal-consultants",
    "name": "JASIM ALHADDAD ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEpBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/12/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "08/11/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: JASIM ALHADDAD ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_490cb579-167c-4a7e-b679-997fb6780992",
        "address": "الثاني عشر مكتب 1201 ,مبنى امباير هايتس البرج B ,بنك رأس الخيمة ,00000 ,Dubai",
        "phone": "97142611689 / 971561234514",
        "email": "info@nja.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Jasim ali abdalla alhaddad alraeesi",
    "address": "الثاني عشر مكتب 1201,مبنى امباير هايتس البرج",
    "phone": "97142611689",
    "email": "info@nja.ae",
    "registrationNumber": "ADF-2022-617"
  },
  {
    "id": "5a33c148-b449-40a3-a945-e3a2eb7cbdda",
    "slug": "jasim-almaeeni-advocates-legal-consultant",
    "name": "JASIM ALMAEENI ADVOCATES & LEGAL CONSULTANT",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEpBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/28/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/27/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: JASIM ALMAEENI ADVOCATES & LEGAL CONSULTANT",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5a33c148-b449-40a3-a945-e3a2eb7cbdda",
        "address": "Floor 7 ,Sama Tower  ,Dubai World Trade Centre ,120059 ,Dubai",
        "phone": "97142954626 / 971506311169",
        "email": "info@jmadvocatesuae.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Jasim Mohamed Sulaiman Ali Mohamed Almaeeni",
    "address": "Floor 7,Sama Tower ,Sheikh Zayed Road,Dubai,1",
    "phone": "97142954626",
    "email": "info@jmadvocatesuae.com",
    "registrationNumber": "ADF-2018-452"
  },
  {
    "id": "6fab0ce0-5a6b-4586-a900-862950161d02",
    "slug": "jasim-alzarooni-advocates-legal-consultants",
    "name": "JASIM ALZAROONI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEpBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/18/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-01-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: JASIM ALZAROONI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6fab0ce0-5a6b-4586-a900-862950161d02",
        "address": "KEFAH ALZAABI ,3005 ,برج لطيفه  ,ابراج لطيفه  ,97597 ,Dubai",
        "phone": "97142522260",
        "email": "info@jazlawyers.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Jasim Rida Mohamed Saleh Alzarooni",
    "address": "3005,برج لطيفه ,الشيخ زايد ,Dubai,97597",
    "phone": "97142522260",
    "email": "info@jazlawyers.ae",
    "registrationNumber": "ADF-2012-80"
  },
  {
    "id": "838d8111-1e4d-43cc-88f7-71f2dcb24635",
    "slug": "jassim-al-suwaidi-advocates-and-legal-consultants",
    "name": "JASSIM AL SUWAIDI ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEpBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/19/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/18/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: JASSIM AL SUWAIDI ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_838d8111-1e4d-43cc-88f7-71f2dcb24635",
        "address": "",
        "phone": "97143530018",
        "email": "info@alsuwaidiadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Jassim Mohamed Abdul Aziz Mohamed Majed Al Suwaidi",
    "address": "N/A",
    "phone": "97143530018",
    "email": "info@alsuwaidiadvocates.com",
    "registrationNumber": "ADF-2022-605"
  },
  {
    "id": "c8d741bf-af4d-4742-8212-d56536005745",
    "slug": "juma-alnaqbi-advocates-legal-consultants",
    "name": "JUMA ALNAQBI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEpBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/28/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/27/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: JUMA ALNAQBI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c8d741bf-af4d-4742-8212-d56536005745",
        "address": "Juma Alnaqbi  ,1105 ,IRIS BAY ,Burj Khalifa  ,11161 ,Dubai",
        "phone": "97142999006 / 971504908111",
        "email": "jumaalnaqbi.dxb@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Juma Mohamed Juma Saeed Al Naqbi",
    "address": "1105,IRIS BAY,Sheikh Zayed Road,Dubai,11161",
    "phone": "97142999006",
    "email": "jumaalnaqbi.dxb@gmail.com",
    "registrationNumber": "ADF-2016-381"
  },
  {
    "id": "59231a3a-5ffa-40a6-83b0-43ab2d1b68a1",
    "slug": "juma-khalifa-advocates-legal-consultants",
    "name": "JUMA KHALIFA ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEpLCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/20/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/19/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: JUMA KHALIFA ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_59231a3a-5ffa-40a6-83b0-43ab2d1b68a1",
        "address": "Juma Khalifa  ,Block A office A304 ,Saraya avenue  ,GGCO metro station  ,430055 ,Dubai",
        "phone": "97142229449 / 971508857744",
        "email": "Gov@jkuaeadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Juma Khalifa Juma Alhamidh",
    "address": "Block A office A304,Saraya avenue ,AlGARHOUD",
    "phone": "97142229449",
    "email": "Gov@jkuaeadvocates.com",
    "registrationNumber": "ADF-2021-549"
  },
  {
    "id": "d0e51371-a813-49c7-a99e-641fda6bca77",
    "slug": "kanaan-advocates-legal-consultants",
    "name": "KANAAN ADVOCATES& LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEtBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/06/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/05/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: KANAAN ADVOCATES& LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d0e51371-a813-49c7-a99e-641fda6bca77",
        "address": "Samir Kanaan ,Office 502 Floor 5 ,Bay Square Building 11 ,South Ridge Apartments ,101 ,Dubai",
        "phone": "97142775444",
        "email": "info@kanlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Samir Halim Kanaan",
    "address": "Office 502 Floor 5,Bay Square Building 11,Al",
    "phone": "97142775444",
    "email": "info@kanlaw.ae",
    "registrationNumber": "ADF-2012-160"
  },
  {
    "id": "c10da728-25b9-442e-857b-2a98261fbe38",
    "slug": "kashwani-law-firm",
    "name": "KASHWANI LAW FIRM",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEtMCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/12/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: KASHWANI LAW FIRM",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c10da728-25b9-442e-857b-2a98261fbe38",
        "address": "",
        "phone": "97143528887",
        "email": "info@kashwanilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Ahmad Abdulaziz Jasem Abdulla Kashwani",
    "address": "N/A",
    "phone": "97143528887",
    "email": "info@kashwanilaw.com",
    "registrationNumber": "ADF-2012-259"
  },
  {
    "id": "a3ee9588-d2b8-4dd3-b653-95e4b34d54bf",
    "slug": "khadija-alkhanbouli-advocates-legal-consultants",
    "name": "KHADIJA ALKHANBOULI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEtBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/30/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/29/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: KHADIJA ALKHANBOULI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a3ee9588-d2b8-4dd3-b653-95e4b34d54bf",
        "address": "khadija sulaiman obaid alkhanboli ,18 ,opal tawer ,burj khalifa ,31431 ,Dubai",
        "phone": "97153966699",
        "email": "lawyer.khadija.alkhanbouli@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "18,opal tawer,1806,Dubai,31431",
    "phone": "97153966699",
    "email": "lawyer.khadija.alkhanbouli@gmail.com",
    "registrationNumber": "ADF-2011-60"
  },
  {
    "id": "264cfea6-1419-45d4-9264-7dba3f26da68",
    "slug": "khadijah-sohail-lawyers-legal-consultants",
    "name": "KHADIJAH SOHAIL LAWYERS & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEtTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/01/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/31/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: KHADIJAH SOHAIL LAWYERS & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_264cfea6-1419-45d4-9264-7dba3f26da68",
        "address": "khadijah sohail hassan asaadi ,طابق الميزانيين  ,ايميجت  ,مترو الخليج التجاري  ,41342 ,Dubai",
        "phone": "97143438885",
        "email": "info@asaadi.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "طابق الميزانيين ,ايميجت ,شارع الشيخ زايد ,Dub",
    "phone": "97143438885",
    "email": "info@asaadi.ae",
    "registrationNumber": "ADF-2015-344"
  },
  {
    "id": "97d00ba6-5323-4b87-8fdb-6382334c3d16",
    "slug": "khaifa-alkhatri-advocates-legal-consultants",
    "name": "KHAIFA ALKHATRI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEtBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/04/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/03/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: KHAIFA ALKHATRI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_97d00ba6-5323-4b87-8fdb-6382334c3d16",
        "address": "",
        "phone": "",
        "email": "info@khalifaadv.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "khalifa Abdalla Mohamed Alkhatri",
    "address": "N/A",
    "phone": "N/A",
    "email": "info@khalifaadv.com",
    "registrationNumber": "ADF-2022-628"
  },
  {
    "id": "74569c18-b69d-4159-813d-9923b25d2dca",
    "slug": "khairallah-advocates-legal-consultants",
    "name": "KHAIRALLAH ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEtBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/18/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/17/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: KHAIRALLAH ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_74569c18-b69d-4159-813d-9923b25d2dca",
        "address": "",
        "phone": "97144270845",
        "email": "info@khairallahlegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97144270845",
    "email": "info@khlegal.ae",
    "registrationNumber": "ADF-2011-28"
  },
  {
    "id": "d42ce31f-e881-40e1-bd66-bf2e5bb9bb1e",
    "slug": "khaled-almarri-partners-legal-consultations",
    "name": "KHALED ALMARRI & PARTNERS& LEGAL CONSULTATIONS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEtBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/05/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/04/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: KHALED ALMARRI & PARTNERS& LEGAL CONSULTATIONS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d42ce31f-e881-40e1-bd66-bf2e5bb9bb1e",
        "address": "",
        "phone": "97142659440",
        "email": "info@klaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Mohammed Ali Sultan Altaweel Almheiri",
    "address": "N/A",
    "phone": "97142659440",
    "email": "info@klaw.ae",
    "registrationNumber": "ADF-2023-663"
  },
  {
    "id": "80c1d0d8-bc34-4358-b07f-35c5f9408311",
    "slug": "khalfan-alkaabi-advocates-legal-consultants",
    "name": "KHALFAN ALKAABI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEtBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/30/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/29/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: KHALFAN ALKAABI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_80c1d0d8-bc34-4358-b07f-35c5f9408311",
        "address": "الطابق الثامن ,بزنس افنيو ,فندق الخوري سكاي جاردن  ,126510 ,Dubai",
        "phone": "97142572778",
        "email": "zakia@houseofj.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "KHALFAN GHANIM SAEED KHALFAN AL KAABI",
    "address": "الطابق الثامن,بزنس افنيو,ديرة - بورسعيد,Dubai",
    "phone": "97142572778",
    "email": "zakia@houseofj.ae",
    "registrationNumber": "ADF-2017-406"
  },
  {
    "id": "16b22176-f21c-4b46-a680-0b13263876bf",
    "slug": "khalid-abdalla-altamimi-advocates-legal-consultants",
    "name": "KHALID ABDALLA ALTAMIMI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEtBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/20/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/19/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: KHALID ABDALLA ALTAMIMI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_16b22176-f21c-4b46-a680-0b13263876bf",
        "address": "الطابق 7 مكتب رقم 070A ,برج رولكس  ,محطة مترو المركز المالي  ,66300 ,Dubai",
        "phone": "97143444029",
        "email": "ekp.khalidaltmimi@ekplegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Khalid Abdulla Mohamed Abdulla Ahmed",
    "address": "الطابق 7 مكتب رقم 070A,برج رولكس ,شارع الشيخ",
    "phone": "97143444029",
    "email": "ekp.khalidaltmimi@ekplegal.com",
    "registrationNumber": "ADF-2015-353"
  },
  {
    "id": "1c406a06-cff7-4412-89fa-f6e5d9b647c0",
    "slug": "khalid-alsarookh-advocates-and-legal-consutancy",
    "name": "KHALID ALSAROOKH ADVOCATES AND LEGAL CONSUTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEtBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/21/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/20/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: KHALID ALSAROOKH ADVOCATES AND LEGAL CONSUTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1c406a06-cff7-4412-89fa-f6e5d9b647c0",
        "address": "",
        "phone": "97143304477 / 97143304477",
        "email": "admin@os-legal.net",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Khalid Mohammed Abdulla Alsarookh",
    "address": "N/A",
    "phone": "97143304477",
    "email": "admin@os-legal.net",
    "registrationNumber": "ADF-2018-448"
  },
  {
    "id": "6a3b5690-6f16-4367-9122-6c2a585fb92d",
    "slug": "khalid-alsuwaidi-lawyers-legal-consultants",
    "name": "KHALID ALSUWAIDI LAWYERS LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEtBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/10/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "07/09/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: KHALID ALSUWAIDI LAWYERS LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6a3b5690-6f16-4367-9122-6c2a585fb92d",
        "address": "",
        "phone": "97142429499 / 97142429499",
        "email": "k.alsuwaidi@kmsadvocate.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Khalid Mohammad Ahmad Muhanna Al Suwaidi",
    "address": "N/A",
    "phone": "97142429499",
    "email": "k.alsuwaidi@kmsadvocate.com",
    "registrationNumber": "ADF-2018-455"
  },
  {
    "id": "83a1e95e-0701-4150-9f11-a92aa75b5939",
    "slug": "khalid-alzaabi-advocates-legal-consultants",
    "name": "KHALID ALZAABI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEtBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/31/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "08/30/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: KHALID ALZAABI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_83a1e95e-0701-4150-9f11-a92aa75b5939",
        "address": "304 ,Ithraa Building ,Emirates Aviation Academy Street / In front of Al Garhoud Mosque ,0000 ,Dubai",
        "phone": "97148323133",
        "email": "khalidalzaabiadvocates@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Khalid Mohamed Abdulla Saeed Alzaabi",
    "address": "304,Ithraa Building,Al Garhoud Area,Dubai,000",
    "phone": "97148323133",
    "email": "khalidalzaabiadvocates@gmail.com",
    "registrationNumber": "ADF-2022-622"
  },
  {
    "id": "252ab43e-3522-46a6-b674-822fde821536",
    "slug": "khalid-alzarooni-advocates-legal-consultants",
    "name": "KHALID ALZAROONI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEtBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/22/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/25/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: KHALID ALZAROONI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_252ab43e-3522-46a6-b674-822fde821536",
        "address": "الرابع /412 ,مركز سلطان للأعمال  ,لامسى بلازا  ,97916 ,Dubai",
        "phone": "97144533568 / 971502744454",
        "email": "khalid.alzarooniadvocate@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Khalid Ismail Abdulaziz Mohamed Alzarooni",
    "address": "الرابع /412,مركز سلطان للأعمال ,لامسى بلازا ,",
    "phone": "97144533568",
    "email": "khalid.alzarooniadvocate@gmail.com",
    "registrationNumber": "ADF-2015-343"
  },
  {
    "id": "b9d24779-27c2-4989-bf7f-4e73e5a670ff",
    "slug": "khalid-bin-mohammad-alqasemi-attorney-legal-consultants",
    "name": "KHALID BIN MOHAMMAD ALQASEMI ATTORNEY & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEtCCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/30/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/29/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: KHALID BIN MOHAMMAD ALQASEMI ATTORNEY & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b9d24779-27c2-4989-bf7f-4e73e5a670ff",
        "address": "6 ,latifa tower ,near crown plaza hotel  ,102999 ,Dubai",
        "phone": "97143799979",
        "email": "lawkmq@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "khalid Mohammad Abdul Rahman Al Qassimi",
    "address": "6,latifa tower,sheikh zayed road,Dubai,102999",
    "phone": "97143799979",
    "email": "lawkmq@gmail.com",
    "registrationNumber": "ADF-2012-158"
  },
  {
    "id": "d78c4298-7657-48f1-b796-d57a48829a70",
    "slug": "khalid-hathboor-advocates-legal-consultants",
    "name": "KHALID HATHBOOR ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEtICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/11/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/10/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: KHALID HATHBOOR ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d78c4298-7657-48f1-b796-d57a48829a70",
        "address": "KHALID KHALIFA MOHD SAIF HATHBOOR ,OFFICE 1001 ,NOUF TOWER ,BUSINESS VILLAGA ,300643 ,Dubai",
        "phone": "97142230257 / 971567057052",
        "email": "info@khhlawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "OFFICE 1001,NOUF TOWER,TARIQ BIN ZIYAD / DEIR",
    "phone": "97142230257",
    "email": "info@khhlawyers.com",
    "registrationNumber": "ADF-2019-481"
  },
  {
    "id": "48ef4874-8647-4fb6-bedd-ffbad25accd1",
    "slug": "khalid-kalandar-almaazmi-advocates-and-legal-consultants",
    "name": "KHALID KALANDAR ALMAAZMI ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEtLCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/31/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "01/30/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: KHALID KALANDAR ALMAAZMI ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_48ef4874-8647-4fb6-bedd-ffbad25accd1",
        "address": "",
        "phone": "97142942616",
        "email": "info@ilofficeuae.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Khalid Kalander Abdalla Hussain Almazzmi",
    "address": "N/A",
    "phone": "97142942616",
    "email": "info@ilofficeuae.com",
    "registrationNumber": "ADF-2012-87"
  },
  {
    "id": "bc6598b4-c5d3-4280-b29d-4c3c132c3a21",
    "slug": "khalifa-al-maftool-advocates-and-legal-consultants",
    "name": "KHALIFA AL MAFTOOL ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEtBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/19/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/18/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: KHALIFA AL MAFTOOL ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bc6598b4-c5d3-4280-b29d-4c3c132c3a21",
        "address": "next level restaurant  , centurion star - block B - office 806 & 807 ,behind day to day - opposite deira city center ,237766 ,Dubai",
        "phone": "97142622002",
        "email": "info@almaftool-advocate.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Khalifa Abdulla Mohammed Khalifa Al-Maftool",
    "address": "next level restaurant , centurion star - bloc",
    "phone": "97142622002",
    "email": "info@almaftool-advocate.com",
    "registrationNumber": "ADF-2012-125"
  },
  {
    "id": "ec4ada87-49a0-432b-a843-e47adccd286f",
    "slug": "khalifa-alsada-advocates-and-legal-consultants",
    "name": "KHALIFA ALSADA ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEtBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/05/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/04/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: KHALIFA ALSADA ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ec4ada87-49a0-432b-a843-e47adccd286f",
        "address": "الطابق الثالث ,بناية مكاتب عود ميثاء ,سيتي بانك ,78853 ,Dubai",
        "phone": "97142220585 / 971506555166",
        "email": "info@kasadv.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "الطابق الثالث,بناية مكاتب عود ميثاء,عود ميثاء",
    "phone": "97142220585",
    "email": "info@kasadv.com",
    "registrationNumber": "ADF-2020-525"
  },
  {
    "id": "0e4b9f0a-83fc-45c9-b0d3-f38013690624",
    "slug": "khalifa-bin-huwaidan-alketbi-advocates-legal-consultant",
    "name": "KHALIFA BIN HUWAIDAN ALKETBI ADVOCATES & LEGAL CONSULTANT",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEtCCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/12/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/17/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: KHALIFA BIN HUWAIDAN ALKETBI ADVOCATES & LEGAL CONSULTANT",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0e4b9f0a-83fc-45c9-b0d3-f38013690624",
        "address": "",
        "phone": "97142555000",
        "email": "info@kha.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Khalifa Abdalla Bin Huwaidan Alketbi",
    "address": "N/A",
    "phone": "97142555000",
    "email": "info@kha.ae",
    "registrationNumber": "ADF-2012-256"
  },
  {
    "id": "34306e48-bd22-4b51-b883-2a538d4f1890",
    "slug": "khalifa-bin-omair-advocates-legal-consultant",
    "name": "KHALIFA BIN OMAIR ADVOCATES & LEGAL CONSULTANT",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEtCCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/09/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "08/08/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: KHALIFA BIN OMAIR ADVOCATES & LEGAL CONSULTANT",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_34306e48-bd22-4b51-b883-2a538d4f1890",
        "address": "4 ,Century 21 building ,al kabayel discount centre ,340781 ,Dubai",
        "phone": "97142417888 / 971562693277",
        "email": "dubai@khbinomair.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Khalifa Yousef Mohammed Ali Bin Omair",
    "address": "4,Century 21 building,Abu Baker Al Siddique S",
    "phone": "97142417888",
    "email": "dubai@khbinomair.com",
    "registrationNumber": "ADF-2017-423"
  },
  {
    "id": "ad9c6a3f-6399-462e-bfe9-cd1c41311c75",
    "slug": "khalil-bin-saif-advocates-legal-consultants",
    "name": "KHALIL BIN SAIF ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEtCCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/14/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/13/2025 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: KHALIL BIN SAIF ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ad9c6a3f-6399-462e-bfe9-cd1c41311c75",
        "address": "",
        "phone": "97142955545",
        "email": "dr.khalil.saif@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Khalil Mohamed Ahmed Saif Alhosany",
    "address": "N/A",
    "phone": "97142955545",
    "email": "dr.khalil.saif@gmail.com",
    "registrationNumber": "ADF-2023-706"
  },
  {
    "id": "2fb2bd9b-adf2-48f2-a4d0-26aa52ed5e26",
    "slug": "khawla-al-mheiri-advocates-legal-consultants",
    "name": "KHAWLA AL MHEIRI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEtBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/26/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/25/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: KHAWLA AL MHEIRI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2fb2bd9b-adf2-48f2-a4d0-26aa52ed5e26",
        "address": "Office No. 601 ,Business Avenue Building ,Behind Nissan Showroom, Makani No: 3248594620 ,000 ,Dubai",
        "phone": "97142369992 / 971503199393",
        "email": "info@almheiriadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Khawla Thani Mohammad Saif Al Mahiri",
    "address": "Office No. 601,Business Avenue Building,Port",
    "phone": "97142369992",
    "email": "info@almheiriadvocates.ae",
    "registrationNumber": "ADF-2023-696"
  },
  {
    "id": "e961ec37-b1f5-4b83-8382-639604c8fdaf",
    "slug": "khawla-saeed-advocates-legal-consultants",
    "name": "KHAWLA SAEED ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEtTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/09/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: KHAWLA SAEED ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e961ec37-b1f5-4b83-8382-639604c8fdaf",
        "address": "Khawla Saeed Mohammed Salem ,414 ,DBCS BUILDING ,محكمة الاحوال الشخصية ,73879 ,Dubai",
        "phone": "97143530354 / 971503787848",
        "email": "info@ksadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "khawla saeed mohammad salem",
    "address": "414,DBCS BUILDING,شارع 40,Dubai,73879",
    "phone": "97143530354",
    "email": "info@ksadvocates.ae",
    "registrationNumber": "ADF-2018-466"
  },
  {
    "id": "661fa52a-1fed-4a42-af84-3e1a7ba76603",
    "slug": "khuloud-saeed-advocates-legal-consultants",
    "name": "KHULOUD SAEED ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEtTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/17/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "01/16/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: KHULOUD SAEED ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_661fa52a-1fed-4a42-af84-3e1a7ba76603",
        "address": "Mohamed Ibrahim amer ,25 ,Iris bay ,Business bay ,3939 ,Dubai",
        "phone": "97125520551",
        "email": "admin@khuloudsaeed.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Khuloud Saeed Ali Al Ali",
    "address": "25,Iris bay,Iris bay,Dubai,3939",
    "phone": "97125520551",
    "email": "admin@khuloudsaeed.com",
    "registrationNumber": "ADF-2017-400"
  },
  {
    "id": "c137b8ba-d9dd-4ca4-9448-55721c8b99a4",
    "slug": "law-firm-international-advocates-legal-consultancy",
    "name": "LAW FIRM INTERNATIONAL ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIExGCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/05/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/04/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: LAW FIRM INTERNATIONAL ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c137b8ba-d9dd-4ca4-9448-55721c8b99a4",
        "address": "",
        "phone": "97142959506",
        "email": "contactus@lawfirmint.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97142959506",
    "email": "contactus@lawfirmint.com",
    "registrationNumber": "ADF-2012-133"
  },
  {
    "id": "0793b25d-a3a5-4843-aaaf-84c9d74e7644",
    "slug": "law-office-ahmed-jasem-abdulla-advocates-legal-consultants",
    "name": "LAW OFFICE AHMED JASEM ABDULLA ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIExPCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/13/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/12/2018 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: LAW OFFICE AHMED JASEM ABDULLA ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0793b25d-a3a5-4843-aaaf-84c9d74e7644",
        "address": "",
        "phone": "97142957785",
        "email": "alrashed-advocates@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97142957785",
    "email": "alrashed-advocates@hotmail.com",
    "registrationNumber": "ADF-2013-280"
  },
  {
    "id": "3f1d962a-159f-4d0f-82d0-ebd94930d6ae",
    "slug": "law-office-of-mahmoud-al-hawai-attorneys-consultants-at-law",
    "name": "LAW OFFICE OF MAHMOUD AL HAWAI ATTORNEYS &CONSULTANTS AT LAW",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIExPCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/08/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/07/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: LAW OFFICE OF MAHMOUD AL HAWAI ATTORNEYS &CONSULTANTS AT LAW",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3f1d962a-159f-4d0f-82d0-ebd94930d6ae",
        "address": "",
        "phone": "97142868681",
        "email": "hawailaw@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Mahmood Ibraheim Abdulla Abdulkareim Haway",
    "address": "N/A",
    "phone": "97142868681",
    "email": "hawailaw@emirates.net.ae",
    "registrationNumber": "ADF-2012-167"
  },
  {
    "id": "a791ae2d-579f-42dd-945f-b28c198a33e4",
    "slug": "liberals-lawyers-legal-consultants-and-lawyers",
    "name": "LIBERALS LAWYERS LEGAL CONSULTANTS AND LAWYERS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIExMCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/03/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "07/02/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: LIBERALS LAWYERS LEGAL CONSULTANTS AND LAWYERS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a791ae2d-579f-42dd-945f-b28c198a33e4",
        "address": "",
        "phone": "97143213302",
        "email": "lawfirm@liberallawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97143213302",
    "email": "lawfirm@liberallawyers.com",
    "registrationNumber": "ADF-2012-215"
  },
  {
    "id": "f33057ab-5fd7-4d0d-87ad-9fe76e01c0af",
    "slug": "lootah-advocates-legal-consultants",
    "name": "LOOTAH ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIExBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/12/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "12/11/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: LOOTAH ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f33057ab-5fd7-4d0d-87ad-9fe76e01c0af",
        "address": "",
        "phone": "97142957333",
        "email": "info@lootah-law.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Fahad Sultan Ali Lootah",
    "address": "N/A",
    "phone": "97142957333",
    "email": "info@lootah-law.com",
    "registrationNumber": "ADF-2011-65"
  },
  {
    "id": "a0cf1971-30cd-464c-b2a2-7f5f34200229",
    "slug": "loubna-walied-mohamed-advocates-legal-consultants",
    "name": "LOUBNA WALIED MOHAMED ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIExXCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/22/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/21/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: LOUBNA WALIED MOHAMED ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a0cf1971-30cd-464c-b2a2-7f5f34200229",
        "address": "",
        "phone": "97100000000 / 971544444720",
        "email": "info@lwlawyers.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Loubna Walied Mohamed Tommalia",
    "address": "309,SAPPHIRE BULDING,PORT SAEED,Dubai,123537",
    "phone": "97100000000",
    "email": "info@lwlawyers.ae",
    "registrationNumber": "ADF-2021-572"
  },
  {
    "id": "fed194c9-41cf-42f3-888e-924faa26b282",
    "slug": "lubna-moosa-advocates-legal-consultants",
    "name": "LUBNA MOOSA ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIExNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/18/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/17/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: LUBNA MOOSA ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fed194c9-41cf-42f3-888e-924faa26b282",
        "address": "",
        "phone": "97145799599 / 971457995992",
        "email": "info@lmlegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Lubna Moosa Rasheed Hatamleh",
    "address": "N/A",
    "phone": "97145799599",
    "email": "info@lmlegal.ae",
    "registrationNumber": "ADF-2022-600"
  },
  {
    "id": "9a3d884b-a443-4037-9eb4-f810c596cf33",
    "slug": "lutfi-company-advocates-legal-consultants",
    "name": "LUTFI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIExDCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/05/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "12/04/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: LUTFI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9a3d884b-a443-4037-9eb4-f810c596cf33",
        "address": "1201 ,برج تريو اي بي اي اوفيس  ,فندق نوافتيل ,8812 ,Dubai",
        "phone": "97144222555",
        "email": "lutfilaw2020@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Salman Lutfi Ali Husain",
    "address": "1201,برج تريو اي بي اي اوفيس ,شارع الشيخ زايد",
    "phone": "97144222555",
    "email": "lutfilaw2020@gmail.com",
    "registrationNumber": "ADF-2012-258"
  },
  {
    "id": "0188c41d-cec9-4993-8610-23001bfcf8a7",
    "slug": "maamoun-al-khouli-associates-advocates-legal-consultants",
    "name": "MAAMOUN AL KHOULI & ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/27/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/26/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MAAMOUN AL KHOULI & ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0188c41d-cec9-4993-8610-23001bfcf8a7",
        "address": "",
        "phone": "97143368833",
        "email": "alkhouli@alkhoulilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97143368833",
    "email": "alkhouli@alkhoulilaw.com",
    "registrationNumber": "ADF-2012-207"
  },
  {
    "id": "97346e41-f636-4b96-a028-acaddbef67e8",
    "slug": "maha-alfahim-lawyer-legal-consultants",
    "name": "MAHA ALFAHIM LAWYER & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/26/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "07/25/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MAHA ALFAHIM LAWYER & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_97346e41-f636-4b96-a028-acaddbef67e8",
        "address": "",
        "phone": "97142805852 / 971528500681",
        "email": "info@alfahimadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Maha Ali Ismail Ali Alfahim",
    "address": "N/A",
    "phone": "97142805852",
    "email": "info@alfahimadvocates.com",
    "registrationNumber": "ADF-2018-457"
  },
  {
    "id": "95d56953-378a-4ade-a995-fee8035a4699",
    "slug": "maha-bin-hendi-law-firm",
    "name": "MAHA BIN HENDI LAW FIRM",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1CCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/04/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "02/03/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MAHA BIN HENDI LAW FIRM",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_95d56953-378a-4ade-a995-fee8035a4699",
        "address": "",
        "phone": "97142405888",
        "email": "m.binhendi@mbhlawfirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Maha Mohi Din Abdulkadir Ibrahim Bin Hendi",
    "address": "N/A",
    "phone": "97142405888",
    "email": "m.binhendi@mbhlawfirm.com",
    "registrationNumber": "ADF-2016-375"
  },
  {
    "id": "3c72f5a1-f8c3-4098-84d7-7886d6ea0165",
    "slug": "mahmood-bin-jaber-advocates-legal-consultants",
    "name": "MAHMOOD BIN JABER ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1CCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/22/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/21/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MAHMOOD BIN JABER ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3c72f5a1-f8c3-4098-84d7-7886d6ea0165",
        "address": "",
        "phone": "97140000000 / 971504404084",
        "email": "info@mjlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Mahmood Mohamed Jaber Mohamed Alali",
    "address": "N/A",
    "phone": "97140000000",
    "email": "info@mjlaw.ae",
    "registrationNumber": "ADF-2021-554"
  },
  {
    "id": "f3309481-3edd-4503-92d2-bd9f71ba513a",
    "slug": "mahmood-hussain-advocates-legal-consultancy",
    "name": "MAHMOOD HUSSAIN ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1ICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/19/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/18/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MAHMOOD HUSSAIN ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f3309481-3edd-4503-92d2-bd9f71ba513a",
        "address": "sohail jassem pararin ,34 ,Central Park Tower ,Dubai Mall ,233066 ,Dubai",
        "phone": "97144228410",
        "email": "info@mahmoodhussain.net",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Mahmood Hussain Ali Ahmad",
    "address": "34,Central Park Tower,aleumlat Street,Dubai,2",
    "phone": "97144228410",
    "email": "info@mahmoodhussain.net",
    "registrationNumber": "ADF-2012-248"
  },
  {
    "id": "6845576a-b39d-45a5-a726-55d73bb5ee05",
    "slug": "mai-alfalasi-advocates-legal-consultants",
    "name": "MAI ALFALASI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/09/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "07/08/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MAI ALFALASI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6845576a-b39d-45a5-a726-55d73bb5ee05",
        "address": "MAI ALFALASI ADVOCATES AND LEGAL CONSULTANCY ,RECEPTION ,GREEN TOWER ,UNITED ARAB BANK ,93279 ,Dubai",
        "phone": "97142230666 / 97142230666",
        "email": "info@maaflegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Mai Abdulrahman Nasib Binnasib Alfalasi",
    "address": "RECEPTION,GREEN TOWER,BIN YAS,Dubai,93279",
    "phone": "97142230666",
    "email": "info@maaflegal.ae",
    "registrationNumber": "ADF-2018-454"
  },
  {
    "id": "1d8ed4ed-c950-4b53-ab18-fbbffbd29451",
    "slug": "maitha-dalmook-advocates-and-legal-consultancy",
    "name": "MAITHA DALMOOK ADVOCATES AND LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1ECiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/27/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/26/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MAITHA DALMOOK ADVOCATES AND LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1d8ed4ed-c950-4b53-ab18-fbbffbd29451",
        "address": "الطابق العاشر .. Tenth floor ,برج الحواي .. AL HAWAI TOWER  ,محطة مترو المركز المالي .. Financial Centre Metro Station  ,444091 ,Dubai",
        "phone": "97143393880 / 971554003333",
        "email": "info@maithadalmook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Maitha Saeed Hamdan Bin Dalmook Al Falasi",
    "address": "الطابق العاشر .. Tenth floor,برج الحواي .. A",
    "phone": "97143393880",
    "email": "info@maithadalmook.com",
    "registrationNumber": "ADF-2021-569"
  },
  {
    "id": "0fb04adb-315b-4377-84b9-e59f2c0cd43f",
    "slug": "majed-binweqaish-shoaib-alawadhi-advocates-legal-consultants",
    "name": "MAJED BINWEQAISH & SHOAIB ALAWADHI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1CCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/20/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/19/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MAJED BINWEQAISH & SHOAIB ALAWADHI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0fb04adb-315b-4377-84b9-e59f2c0cd43f",
        "address": "Office F13 ,Business Center - CAPITAL UNITED ,Makani No: 3274893760 ,000 ,Dubai",
        "phone": "97100000000 / 971528588888",
        "email": "shoaib@mswlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Shoaip Azeiz Mohamed Sharief Alawadhi",
    "address": "Office F13,Business Center - CAPITAL UNITED,A",
    "phone": "97100000000",
    "email": "shoaib@mswlaw.ae",
    "registrationNumber": "ADF-2023-707"
  },
  {
    "id": "ac58d621-9c02-48ae-8edc-dcf1b34a893d",
    "slug": "majid-aljassim-advocates-legal-consultants",
    "name": "MAJID ALJASSIM ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/13/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "01/12/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MAJID ALJASSIM ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ac58d621-9c02-48ae-8edc-dcf1b34a893d",
        "address": "",
        "phone": "97142212112",
        "email": "info@mjlaw.co",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Majid Ahmed Mohammed Abdullah Aljassim",
    "address": "N/A",
    "phone": "97142212112",
    "email": "info@mjlaw.co",
    "registrationNumber": "ADF-2024-715"
  },
  {
    "id": "da6588ae-fc3b-4a88-8a5e-7836becb47d2",
    "slug": "majid-alskaikh-advocates-legal-consultants",
    "name": "MAJID ALSKAIKH ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/07/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/06/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MAJID ALSKAIKH ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_da6588ae-fc3b-4a88-8a5e-7836becb47d2",
        "address": "11 ,بناية صبحة ايفوري 2 ,ماما شيلتر أوتيل ,9598 ,Dubai",
        "phone": "97143880171 / 971565359809",
        "email": "malawyer@malawyer.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Majid Mohammed Alshaikh Ahmad Bin Alshaikh Hassan Alkhazraji",
    "address": "11,بناية صبحة ايفوري 2,شارع الاصايل,Dubai,959",
    "phone": "97143880171",
    "email": "malawyer@malawyer.ae",
    "registrationNumber": "ADF-2012-251"
  },
  {
    "id": "b380d172-f6fb-41f1-ad4f-0b8fa3c870fb",
    "slug": "majid-hamad-al-kalbani-advocates-legal-consultants",
    "name": "MAJID HAMAD AL KALBANI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1ICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/09/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/08/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MAJID HAMAD AL KALBANI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b380d172-f6fb-41f1-ad4f-0b8fa3c870fb",
        "address": "BLOCK B - OFFICE NO. 208 ,BUSHAQER Building ,Makani No: 3289393656 ,000 ,Dubai",
        "phone": "97142217010 / 971504993366",
        "email": "majidlawyer726@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Majid Hamad Saeed Hamad Alkalbani",
    "address": "BLOCK B - OFFICE NO. 208,BUSHAQER Building,Al",
    "phone": "97142217010",
    "email": "majidlawyer726@gmail.com",
    "registrationNumber": "ADF-2023-657"
  },
  {
    "id": "ceae5357-8b8a-4b2f-aa2f-9655068e48d3",
    "slug": "makki-advocates-legal-consultants",
    "name": "MAKKI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/12/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "12/11/2024 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MAKKI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ceae5357-8b8a-4b2f-aa2f-9655068e48d3",
        "address": "",
        "phone": "97142209370",
        "email": "tmjs1951_advocatelaw@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Tariq Makki Jaffar Saleh",
    "address": "N/A",
    "phone": "97142209370",
    "email": "tmjs1951_advocatelaw@yahoo.com",
    "registrationNumber": "ADF-2012-260"
  },
  {
    "id": "3348a745-bb42-4126-a65b-9c6cb87944af",
    "slug": "manawaha-hashim-advocates-legal-consultants",
    "name": "MANAWAHA HASHIM ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1ICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/16/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/15/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MANAWAHA HASHIM ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3348a745-bb42-4126-a65b-9c6cb87944af",
        "address": "",
        "phone": "97142621293",
        "email": "manawaha369advocates@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Manawaha Saadeldin Merghani Hashim",
    "address": "N/A",
    "phone": "97142621293",
    "email": "manawaha369advocates@outlook.com",
    "registrationNumber": "ADF-2023-702"
  },
  {
    "id": "57b33e16-bbbb-4226-9eb9-8e310c0898b9",
    "slug": "manea-almheiri-advocates-legal-consultants",
    "name": "MANEA ALMHEIRI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/15/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2019-04-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MANEA ALMHEIRI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_57b33e16-bbbb-4226-9eb9-8e310c0898b9",
        "address": "",
        "phone": "97142500007",
        "email": "info@maadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97142500007",
    "email": "info@maadvocates.com",
    "registrationNumber": "ADF-2018-445"
  },
  {
    "id": "4488ad94-e6b8-4b33-8e21-04e8986bf218",
    "slug": "mansoor-lotaah-advocates-legal-consultancy",
    "name": "MANSOOR LOTAAH ADVOCATES &LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1MCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/08/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "08/07/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MANSOOR LOTAAH ADVOCATES &LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4488ad94-e6b8-4b33-8e21-04e8986bf218",
        "address": "mansoor lootah ,مطعم شيلز ,صالح بن لاحج , مطعم شيلز  ,95151 ,Dubai",
        "phone": "97142833337 / 971559596445",
        "email": "info@mansoorlootahadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "مطعم شيلز,صالح بن لاحج,ديرة - القرهود - شارع",
    "phone": "97142833337",
    "email": "info@mansoorlootahadvocates.ae",
    "registrationNumber": "ADF-2012-237"
  },
  {
    "id": "a2e703c0-b558-4d8f-9bd3-c77475c407b1",
    "slug": "mariam-ahmed-salem-advocates-legal-consultant",
    "name": "MARIAM AHMED SALEM ADVOCATES & LEGAL CONSULTANT",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/05/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "07/04/2025 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MARIAM AHMED SALEM ADVOCATES & LEGAL CONSULTANT",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a2e703c0-b558-4d8f-9bd3-c77475c407b1",
        "address": "talal  ,2TH FLOOR ,AL ETIHAD BUILDING  ,DEIRA CITY CENTRE ,1111 ,Dubai",
        "phone": "97142236999 / 97142236999",
        "email": "mariamahmedadvocate@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Mariam Ahmed Salem Musallem Almuharrami",
    "address": "2TH FLOOR,AL ETIHAD BUILDING ,DEIRA PORT SAEE",
    "phone": "97142236999",
    "email": "mariamahmedadvocate@gmail.com",
    "registrationNumber": "ADF-2018-453"
  },
  {
    "id": "0a80a9dd-7ded-4752-af6a-4444111bc177",
    "slug": "mariam-al-shamsi-advocates-legal-consultants",
    "name": "MARIAM AL SHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/29/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2025-04-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MARIAM AL SHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0a80a9dd-7ded-4752-af6a-4444111bc177",
        "address": "",
        "phone": "97142554421",
        "email": "mariam.alshamsi@triumphco.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Mariam Eisa Ali Eisa ALshamsi",
    "address": "N/A",
    "phone": "97142554421",
    "email": "mariam.alshamsi@triumphco.com",
    "registrationNumber": "ADF-2024-729"
  },
  {
    "id": "2aa8bbb5-b5ae-454c-82c6-6ea027e24908",
    "slug": "mariam-ibrahim-alameri-advocates-legal-consultants",
    "name": "MARIAM IBRAHIM ALAMERI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1JCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/04/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "07/03/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MARIAM IBRAHIM ALAMERI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2aa8bbb5-b5ae-454c-82c6-6ea027e24908",
        "address": "",
        "phone": "",
        "email": "info@mariamalameri.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Mariam Ibrahim Mohamed Ali Alameri",
    "address": "N/A",
    "phone": "N/A",
    "email": "info@mariamalameri.ae",
    "registrationNumber": "ADF-2023-679"
  },
  {
    "id": "9b90fac9-ee1a-47ff-b174-149dfeec39b8",
    "slug": "mariam-obaid-alblooshi-advocates-legal-consultants",
    "name": "MARIAM OBAID ALBLOOSHI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1PCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/26/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "02/25/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MARIAM OBAID ALBLOOSHI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9b90fac9-ee1a-47ff-b174-149dfeec39b8",
        "address": "Second Floor - Office No. 208 ,Al Wasl Tower - City Walk - Sheikha Raisa Khalifa Bin Saeed Al Maktoum Building ,Makani No:  2550888537 ,000 ,Dubai",
        "phone": "97150707114 / 971507071144",
        "email": "mem.aaa.lawyer@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Mariam Obaid Abdulla Mohammed Alblooshi",
    "address": "Second Floor - Office No. 208,Al Wasl Tower -",
    "phone": "97150707114",
    "email": "mem.aaa.lawyer@gmail.com",
    "registrationNumber": "ADF-2024-720"
  },
  {
    "id": "10e703d5-3aef-48b8-80b8-127a5cdee02b",
    "slug": "marwa-al-suwaidi-advocates-legal-consultancy",
    "name": "MARWA Al SUWAIDI ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/26/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/25/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MARWA Al SUWAIDI ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_10e703d5-3aef-48b8-80b8-127a5cdee02b",
        "address": "",
        "phone": "97143991619 / 971566355726",
        "email": "info@marwaadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Marwa Ali Juma Ali Alsuwaidi",
    "address": "N/A",
    "phone": "97143991619",
    "email": "info@marwaadvocates.ae",
    "registrationNumber": "ADF-2018-462"
  },
  {
    "id": "eeb7cff7-edda-42f6-a44e-676d412929de",
    "slug": "marwa-alriyami-advocates-legal-consultants",
    "name": "MARWA ALRIYAMI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/18/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "07/17/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MARWA ALRIYAMI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_eeb7cff7-edda-42f6-a44e-676d412929de",
        "address": "marwa hamad saeed Musallam alriyami ,12 ,concord tower ,media city ,1500377 ,Dubai",
        "phone": "97144473110",
        "email": "Marwa_alriyami@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Marwa Hamad Saeed Musallam Alriyami",
    "address": "12,concord tower,al safouh second,Dubai,15003",
    "phone": "97144473110",
    "email": "Marwa_alriyami@hotmail.com",
    "registrationNumber": "ADF-2023-682"
  },
  {
    "id": "16c3bc7d-4188-486f-835f-cc7565c69af8",
    "slug": "marwa-suliman-advocates-legal-consultants",
    "name": "MARWA SULIMAN ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1TCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/05/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/04/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MARWA SULIMAN ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_16c3bc7d-4188-486f-835f-cc7565c69af8",
        "address": "",
        "phone": "/ 971501077776",
        "email": "mimalsham@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Marwa Suliman Mohammed Karazon",
    "address": "N/A",
    "phone": "N/A",
    "email": "mimalsham@gmail.com",
    "registrationNumber": "ADF-2025-765"
  },
  {
    "id": "2485aa73-a460-4867-9452-297e9feb733e",
    "slug": "maryam-abdullah-advocates-and-legal-consultants",
    "name": "MARYAM ABDULLAH ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/12/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "08/11/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MARYAM ABDULLAH ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2485aa73-a460-4867-9452-297e9feb733e",
        "address": "الطابق الاول  ,بناية مشاريع قرقاش - مكتب رقم 102  ,وكاله مرسيدس  ,393947 ,Dubai",
        "phone": "97143799917",
        "email": "info@amt-legal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Maryam Abdullah Murad Alblooshi",
    "address": "الطابق الاول ,بناية مشاريع قرقاش - مكتب رقم 1",
    "phone": "97143799917",
    "email": "info@amt-legal.com",
    "registrationNumber": "ADF-2014-323"
  },
  {
    "id": "20f968ff-e5db-45d4-b645-48a15e7e7808",
    "slug": "maryam-alyassi-advocates-legal-consultants",
    "name": "MARYAM ALYASSI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/15/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/14/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MARYAM ALYASSI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_20f968ff-e5db-45d4-b645-48a15e7e7808",
        "address": "Maryam Essa Mohammad Abdulaziz Alyassi ,M06  ,THE ARCADE  ,ALGARHOUD METRO STATION  ,283023 ,Dubai",
        "phone": "97143852835 / 971543314762",
        "email": "info@alyassiadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Maryam Essa Mohammad Abdulaziz Alyassi",
    "address": "M06 ,THE ARCADE , STREET 214  ALGARHOUD ,Duba",
    "phone": "97143852835",
    "email": "info@alyassiadvocates.com",
    "registrationNumber": "ADF-2021-562"
  },
  {
    "id": "fc7bbac7-d29b-4486-8335-92c217bfd653",
    "slug": "maryam-hayyaz-wejdan-bushahab-advocates-legal-consultants",
    "name": "MARYAM HAYYAZ & WEJDAN BUSHAHAB ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1ICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/10/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MARYAM HAYYAZ & WEJDAN BUSHAHAB ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fc7bbac7-d29b-4486-8335-92c217bfd653",
        "address": "",
        "phone": "97143422244 / 97143422244",
        "email": "info@maryamwejdan.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Maryam Ali Saleh Hayyaz Alaleeli",
    "address": "N/A",
    "phone": "97143422244",
    "email": "info@maryamwejdan.com",
    "registrationNumber": "ADF-2018-467"
  },
  {
    "id": "82512feb-5424-43d4-8fe8-b84a1a0e1c4f",
    "slug": "maryam-saif-khatem-advocates-legal-consultants",
    "name": "MARYAM SAIF KHATEM ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1TCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/23/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/22/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MARYAM SAIF KHATEM ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_82512feb-5424-43d4-8fe8-b84a1a0e1c4f",
        "address": "Office No. M26 ,Al Garhoud Business Centre ,Al Garhoud Business Centre ,000 ,Dubai",
        "phone": "97142520160 / 971000000000",
        "email": "info@msklaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "MARYAM SAIF ALI KHATEM",
    "address": "Office No. M26,Al Garhoud Business Centre,Al",
    "phone": "97142520160",
    "email": "info@msklaw.ae",
    "registrationNumber": "ADF-2024-731"
  },
  {
    "id": "314249aa-2f57-4a5c-bfb1-c5056cca52c8",
    "slug": "mayed-almarashda-advocates-legal-consultants",
    "name": "MAYED ALMARASHDA ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/08/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "08/07/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MAYED ALMARASHDA ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_314249aa-2f57-4a5c-bfb1-c5056cca52c8",
        "address": "MAYED  AL MRASHIDA  ,طيران ايران  ,برج السالمية  الطابق 8 مكتب رقم 804 ,الربج الاخضر  ,354999 ,Dubai",
        "phone": "97142225955 / 971552298952",
        "email": "info@mayedadv.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "طيران ايران ,برج السالمية  الطابق 8 مكتب رقم",
    "phone": "97142225955",
    "email": "info@mayedadv.ae",
    "registrationNumber": "ADF-2019-483"
  },
  {
    "id": "f766fe59-4307-4881-a130-fde85d0dd65d",
    "slug": "meg-legal-services",
    "name": "MEG LEGAL SERVICES",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1MCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/08/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "01/07/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MEG LEGAL SERVICES",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f766fe59-4307-4881-a130-fde85d0dd65d",
        "address": "NABIH AHMED BADER ,Level M Office 203   , The Dubai Mall Fountain Views ,Social District Fountain Views,  Burak Restaurant ,182859 ,Dubai",
        "phone": "97142384655",
        "email": "nbader@eptalex.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Nabeeh Ahmad Badr",
    "address": "Level M Office 203  , The Dubai Mall Fountain",
    "phone": "97142384655",
    "email": "nbader@eptalex.com",
    "registrationNumber": "ADF-2012-76"
  },
  {
    "id": "5dd70a2b-2ada-48f1-81e2-5885629a7035",
    "slug": "meleih-advocates-legal-consultants",
    "name": "MELEIH ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/22/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "02/21/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MELEIH ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5dd70a2b-2ada-48f1-81e2-5885629a7035",
        "address": "",
        "phone": "97142999720",
        "email": "meleihadvocates@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Jumah Ahmed Obaid Ahmed Meleh Dhanhani",
    "address": "N/A",
    "phone": "97142999720",
    "email": "meleihadvocates@gmail.com",
    "registrationNumber": "ADF-2012-101"
  },
  {
    "id": "1dc550f7-81c5-4a5a-9096-682d651b8688",
    "slug": "moaza-al-khadar-advocates-legal-consultants",
    "name": "MOAZA AL KHADAR ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/01/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/30/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MOAZA AL KHADAR ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1dc550f7-81c5-4a5a-9096-682d651b8688",
        "address": "مطعم زعتر وزيت  ,اسبكت تاور  ,فندق تاج  ,118212 ,Dubai",
        "phone": "97144433013 / 97144433013",
        "email": "moaza.alkhadar.alc@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Moza Ubaid Rabea Al Kheder",
    "address": "مطعم زعتر وزيت ,اسبكت تاور ,الخليج التجاري -",
    "phone": "97144433013",
    "email": "moaza.alkhadar.alc@gmail.com",
    "registrationNumber": "ADF-2013-284"
  },
  {
    "id": "f3bfca9b-f895-41b7-aa09-b350673f8d3d",
    "slug": "mohamad-ibrahim-salmeen-advocates-legal-consultants",
    "name": "MOHAMAD IBRAHIM SALMEEN ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1JCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/19/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/18/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MOHAMAD IBRAHIM SALMEEN ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f3bfca9b-f895-41b7-aa09-b350673f8d3d",
        "address": "MOHAMAD SALMEEN ,304 ,بيزنس افنيو ,مطار دبي ,119474 ,Dubai",
        "phone": "97143300346",
        "email": "info@mis.lawyer",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Mohamad Ibrahim Mohamad Salmeen",
    "address": "901,برج سما,شارع الشيخ زايد - ,Dubai,119474",
    "phone": "97143300346",
    "email": "info@mis.lawyer",
    "registrationNumber": "ADF-2022-625"
  },
  {
    "id": "33e18285-3dec-403b-b2e2-7862ae1993cc",
    "slug": "mohamed-abdulilah-alhamed-advocates-legal-consultants",
    "name": "MOHAMED ABDULILAH ALHAMED ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/09/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/08/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MOHAMED ABDULILAH ALHAMED ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_33e18285-3dec-403b-b2e2-7862ae1993cc",
        "address": "الطابق الثاني ,امارات اتريوم ,مبني الامارات للبترول ,2311 ,Dubai",
        "phone": "97145823288 / 971552222311",
        "email": "info@lmh.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Mohamed Abdullah Hadi Husain Alhamed",
    "address": "الطابق الثاني,امارات اتريوم,منطقة الوصل,Dubai",
    "phone": "97145823288",
    "email": "info@lmh.ae",
    "registrationNumber": "ADF-2022-631"
  },
  {
    "id": "22c36bcb-1914-4128-9816-406ffc0aec47",
    "slug": "mohamed-abdulla-yousuf-alhammadi-advocates-legal-consultants",
    "name": "MOHAMED ABDULLA & YOUSUF ALHAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/24/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/23/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MOHAMED ABDULLA & YOUSUF ALHAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_22c36bcb-1914-4128-9816-406ffc0aec47",
        "address": "",
        "phone": "97143702000 / 971504844414",
        "email": "advoy.m@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Yousuf Mohamed Ali Ahmad Alhammadi",
    "address": "N/A",
    "phone": "97143702000",
    "email": "advoy.m@gmail.com",
    "registrationNumber": "ADF-2019-475"
  },
  {
    "id": "fd6217fa-7d75-4e40-9295-6daa554c87d1",
    "slug": "mohamed-abdulla-almarzooqi-advocates-legal-consultants",
    "name": "MOHAMED ABDULLA ALMARZOOQI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/01/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/30/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MOHAMED ABDULLA ALMARZOOQI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fd6217fa-7d75-4e40-9295-6daa554c87d1",
        "address": "Second Floor - Office No. 44 ,SUNSET Mall ,Makani No: 2129186503 ,000 ,Dubai",
        "phone": "97100000000 / 971558989828",
        "email": "L.ALMARZOOQI1110@GMAIL.COM",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Mohamed Abdulla Hamad Abdulla Almarzouqi",
    "address": "Second Floor - Office No. 44,SUNSET Mall,Jume",
    "phone": "97100000000",
    "email": "L.ALMARZOOQI1110@GMAIL.COM",
    "registrationNumber": "ADF-2024-730"
  },
  {
    "id": "00b6334f-44e7-458e-8ce5-7d4256840067",
    "slug": "mohamed-abdulla-lawyers-and-legal-consultants",
    "name": "MOHAMED ABDULLA LAWYERS AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/03/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/02/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MOHAMED ABDULLA LAWYERS AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_00b6334f-44e7-458e-8ce5-7d4256840067",
        "address": "samer tohme ,4th- office 433 ,Emarat Atrium ,Dubai Canal ,79436 ,Dubai",
        "phone": "97126722500",
        "email": "info@dxblawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "4th- office 433,Emarat Atrium,Sheikh Zayed Rd",
    "phone": "97126722500",
    "email": "info@dxblawfirm.ae",
    "registrationNumber": "ADF-2012-132"
  },
  {
    "id": "85fc2f18-8a0a-4682-9735-2be49a8b75f9",
    "slug": "mohamed-al-ghefli-advocates-legal-consultants",
    "name": "MOHAMED AL GHEFLI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/29/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "01/28/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MOHAMED AL GHEFLI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_85fc2f18-8a0a-4682-9735-2be49a8b75f9",
        "address": "",
        "phone": "97142945678",
        "email": "maadvdubai@maadv.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "MOHAMED KHALIFA SALEM M.M.ALEGHFELI",
    "address": "N/A",
    "phone": "97142945678",
    "email": "maadvdubai@maadv.ae",
    "registrationNumber": "ADF-2014-294"
  },
  {
    "id": "593a5a42-a340-4daa-a8db-6d2673de29d5",
    "slug": "mohamed-al-hajeri-advocates-legal-consultants-notary-public",
    "name": "MOHAMED AL HAJERI ADVOCATES & LEGAL CONSULTANTS  & NOTARY PUBLIC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/18/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/17/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MOHAMED AL HAJERI ADVOCATES & LEGAL CONSULTANTS  & NOTARY PUBLIC",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_593a5a42-a340-4daa-a8db-6d2673de29d5",
        "address": "000000000 ,4 ,الريم  ,بلدية دبي  ,14593 ,Dubai",
        "phone": "97142276777",
        "email": "info@tglawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Mohamed Saleh Mohamed Ahmed Alhajeri",
    "address": "4,الريم ,ال مكتوم ,Dubai,14593",
    "phone": "97142276777",
    "email": "info@tglawfirm.ae",
    "registrationNumber": "ADF-2014-318"
  },
  {
    "id": "07521705-aa90-4c3a-b5fd-c55e54889e60",
    "slug": "mohamed-al-hammadi-advocates-legal-consultants",
    "name": "MOHAMED AL HAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/15/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/14/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MOHAMED AL HAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_07521705-aa90-4c3a-b5fd-c55e54889e60",
        "address": "",
        "phone": "97142566800",
        "email": "fatema@alhammadiadvocate.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Mohamed Ibrahim Mohamed Abdulla Alhammadi",
    "address": "N/A",
    "phone": "97142566800",
    "email": "fatema@alhammadiadvocate.ae",
    "registrationNumber": "ADF-2012-123"
  },
  {
    "id": "92d43169-f680-4fdb-a7c0-1397ce308994",
    "slug": "mohamed-alazazi-lawyers-legal-consultancy",
    "name": "MOHAMED ALAZAZI LAWYERS & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/18/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/17/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MOHAMED ALAZAZI LAWYERS & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_92d43169-f680-4fdb-a7c0-1397ce308994",
        "address": "",
        "phone": "97143997700 / 971503707978",
        "email": "info@alazazi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Mohamed Hamed Qayed Alazazi",
    "address": "N/A",
    "phone": "97143997700",
    "email": "info@alazazi.com",
    "registrationNumber": "ADF-2020-501"
  },
  {
    "id": "a1880a30-0b15-4045-b91e-b3e4e776bc7e",
    "slug": "mohamed-alhathboor-advocates-legal-consultants",
    "name": "MOHAMED ALHATHBOOR ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/18/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/17/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MOHAMED ALHATHBOOR ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a1880a30-0b15-4045-b91e-b3e4e776bc7e",
        "address": "",
        "phone": "97143799916 / 971556407627",
        "email": "ask@mahlawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Mohamed Jamal Saif Alhathboor Alremethi",
    "address": "N/A",
    "phone": "97143799916",
    "email": "ask@mahlawfirm.ae",
    "registrationNumber": "ADF-2019-486"
  },
  {
    "id": "52d0e50e-9741-4720-8ae1-7de3cbda373d",
    "slug": "mohamed-alhemeiri-lawyers-and-legal-consultants",
    "name": "MOHAMED ALHEMEIRI LAWYERS AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/31/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/30/2025 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MOHAMED ALHEMEIRI LAWYERS AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_52d0e50e-9741-4720-8ae1-7de3cbda373d",
        "address": "",
        "phone": "97145911811 / 971506137373",
        "email": "info@advoalhadhrami.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Mohamed Abdulla Ali Bamakhrama Alhemeiri",
    "address": "N/A",
    "phone": "97145911811",
    "email": "info@advoalhadhrami.ae",
    "registrationNumber": "ADF-2021-570"
  },
  {
    "id": "af85c161-b73d-46a2-9fd7-4d8604007473",
    "slug": "mohamed-ali-alhammadi-advocates-legal-consultant",
    "name": "MOHAMED ALI ALHAMMADI ADVOCATES & LEGAL CONSULTANT",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/05/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "08/04/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MOHAMED ALI ALHAMMADI ADVOCATES & LEGAL CONSULTANT",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_af85c161-b73d-46a2-9fd7-4d8604007473",
        "address": "",
        "phone": "97143300009 / 971501215000",
        "email": "mohamed@maa.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Mohamed Ali Jabir Saleh Alhammadi",
    "address": "N/A",
    "phone": "97143300009",
    "email": "mohamed@maa.law",
    "registrationNumber": "ADF-2018-458"
  },
  {
    "id": "ec23636d-f937-474e-b86d-d7470fbb385b",
    "slug": "mohamed-alkheyaili-advocates-legal-consultants",
    "name": "MOHAMED ALKHEYAILI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/04/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/03/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MOHAMED ALKHEYAILI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ec23636d-f937-474e-b86d-d7470fbb385b",
        "address": "Mohamed Ali Saeed Humaid Al Kheyaili  ,Seventh Floor  ,Al Masaood Tower 2 ,Al Tadawi Medical Centre  ,88314 ,Dubai",
        "phone": "97142989662",
        "email": "info@mkladvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "Seventh Floor ,Al Masaood Tower 2,Port Said A",
    "phone": "97142989662",
    "email": "info@mkladvocates.com",
    "registrationNumber": "ADF-2012-255"
  },
  {
    "id": "e4e4dd86-434d-4a53-a225-b2315793281a",
    "slug": "mohamed-almarzooqi-advocates-legal-consultancy",
    "name": "MOHAMED ALMARZOOQI ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/02/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "08/01/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MOHAMED ALMARZOOQI ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e4e4dd86-434d-4a53-a225-b2315793281a",
        "address": "",
        "phone": "97142253131 / 971503534441",
        "email": "info@ml-advocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Mohamed Mahmoud Ali Mahmoud Almarzooqi",
    "address": "N/A",
    "phone": "97142253131",
    "email": "info@ml-advocates.com",
    "registrationNumber": "ADF-2016-388"
  },
  {
    "id": "ea7d794d-7136-45d1-8ebe-5833f286db4a",
    "slug": "mohamed-alsawan-advocates-legal-consultants",
    "name": "MOHAMED ALSAWAN ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/10/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "12/09/2019 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MOHAMED ALSAWAN ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ea7d794d-7136-45d1-8ebe-5833f286db4a",
        "address": "",
        "phone": "97143359122",
        "email": "alsawan64@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Mohmaed Mahmoud Mohamed Mousa Alswan",
    "address": "N/A",
    "phone": "97143359122",
    "email": "alsawan64@gmail.com",
    "registrationNumber": "ADF-2015-368"
  },
  {
    "id": "2a224392-a975-448f-aec5-0460984b1124",
    "slug": "mohamed-alserkal-advocates-legal-consultants",
    "name": "MOHAMED ALSERKAL ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/07/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/06/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MOHAMED ALSERKAL ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2a224392-a975-448f-aec5-0460984b1124",
        "address": "Mohamed Thamer Yaqub Yousef Alserkal ,الطابق الثاني ,اعمار سكوير - بناء رقم 4 ,برج خليفة ,57409 ,Dubai",
        "phone": "97142622217 / 97142622217",
        "email": "mohamed@alserkallawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "الطابق الثاني,اعمار سكوير - بناء رقم 4,اعمار",
    "phone": "97142622217",
    "email": "mohamed@alserkallawfirm.ae",
    "registrationNumber": "ADF-2018-442"
  },
  {
    "id": "73d5d3aa-9089-4c36-8cd2-4057677338f3",
    "slug": "mohamed-alshaikh-advocates-legal-consultants",
    "name": "MOHAMED ALSHAIKH ADVOCATES &LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/29/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MOHAMED ALSHAIKH ADVOCATES &LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_73d5d3aa-9089-4c36-8cd2-4057677338f3",
        "address": "",
        "phone": "97142424288 / 971588961163",
        "email": "info@malshaikhadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97142424288",
    "email": "info@malshaikhadvocates.com",
    "registrationNumber": "ADF-2021-581"
  },
  {
    "id": "f087c317-0869-4d12-b034-ddc32f8f8c9f",
    "slug": "mohamed-alsuwaidi-advocates-legal-consultants",
    "name": "MOHAMED ALSUWAIDI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/20/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2018-09-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MOHAMED ALSUWAIDI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f087c317-0869-4d12-b034-ddc32f8f8c9f",
        "address": "",
        "phone": "97142957399",
        "email": "advo.uae1@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97142957399",
    "email": "advo.uae1@gmail.com",
    "registrationNumber": "ADF-2017-427"
  },
  {
    "id": "ff04cc72-9052-4ab2-baad-0b386a4b23cb",
    "slug": "mohamed-binqanzoul-alketbi-advocates-legal-consultants",
    "name": "MOHAMED BINQANZOUL ALKETBI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1CCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/04/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "07/03/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MOHAMED BINQANZOUL ALKETBI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ff04cc72-9052-4ab2-baad-0b386a4b23cb",
        "address": "MOHAMED RASHID ALKETBI ,G ,AIRPORT BUILDING ,مصرف أبو ظبي الإسلامي ,13094 ,Dubai",
        "phone": "97143332709",
        "email": "binqanzoul.ae@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "G,AIRPORT BUILDING,بور سعيد-ديرة سيتي سنتر-رق",
    "phone": "97143332709",
    "email": "binqanzoul.ae@outlook.com",
    "registrationNumber": "ADF-2023-680"
  },
  {
    "id": "6bba829c-0392-4c72-a71b-01da72cb24ae",
    "slug": "mohamed-salman-advocate-legal-consultancy",
    "name": "MOHAMED SALMAN ADVOCATE & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1TCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/31/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MOHAMED SALMAN ADVOCATE & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6bba829c-0392-4c72-a71b-01da72cb24ae",
        "address": "MOHAMMED ALI SALMAN AL MARZOOQI ,الثالث  ,السركال  ,معرض سيارات الفطيم  ,39059 ,Dubai",
        "phone": "97142500008",
        "email": "adv.saad@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Mohammed Ali Salman Al-Marzooqi",
    "address": "الثالث ,السركال ,المطار .ديره.بورسعيد ,Dubai,",
    "phone": "97142500008",
    "email": "adv.saad@outlook.com",
    "registrationNumber": "ADF-2012-264"
  },
  {
    "id": "466f3ad4-73e1-44db-b8ec-b01e829d77c4",
    "slug": "mohammad-allinjawi-advocates-legal-consultants",
    "name": "MOHAMMAD ALLINJAWI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/27/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/26/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MOHAMMAD ALLINJAWI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_466f3ad4-73e1-44db-b8ec-b01e829d77c4",
        "address": "",
        "phone": "97143333386 / 971549916936",
        "email": "info@mtaadv.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97143333386",
    "email": "info@mtaadv.com",
    "registrationNumber": "ADF-2020-514"
  },
  {
    "id": "455b5977-b40f-4801-b6bf-70838bb69abe",
    "slug": "mohammad-almeihri-advocates-legal-consultants",
    "name": "MOHAMMAD ALMEIHRI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/17/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "08/16/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MOHAMMAD ALMEIHRI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_455b5977-b40f-4801-b6bf-70838bb69abe",
        "address": "Mohammad Al Mheiri ,الاول ,امارات اتريم  ,شارع الشيخ زايد ,37979 ,Dubai",
        "phone": "97143333405",
        "email": "info@al-mheiri.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Mohammad Ali Mohammad Bin Qedad Almehairi",
    "address": "الاول,امارات اتريم ,شارع الوصل ,Dubai,37979",
    "phone": "97143333405",
    "email": "info@al-mheiri.com",
    "registrationNumber": "ADF-2016-389"
  },
  {
    "id": "1670d8d1-6114-4b77-b2da-9d4c0dc0054b",
    "slug": "mohammad-alnajjar-advocates-legal-consultants",
    "name": "MOHAMMAD ALNAJJAR ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/30/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/29/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MOHAMMAD ALNAJJAR ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1670d8d1-6114-4b77-b2da-9d4c0dc0054b",
        "address": "",
        "phone": "97145642777 / 971508551535",
        "email": "legal@alnajjarlawyer.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Mohammad Ahmad Ali Abdulla Alnajjar",
    "address": "N/A",
    "phone": "97145642777",
    "email": "legal@alnajjarlawyer.com",
    "registrationNumber": "ADF-2019-480"
  },
  {
    "id": "8e611697-c589-4346-a3da-969764421cb6",
    "slug": "mohammad-alsaadi-advocates-legal-consultants",
    "name": "MOHAMMAD ALSAADI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/07/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/06/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MOHAMMAD ALSAADI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8e611697-c589-4346-a3da-969764421cb6",
        "address": "210 ,OPAL TOWER ,BURJ KHALIFA ,96044 ,Dubai",
        "phone": "97143889993",
        "email": "admin@alsaadi-advocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "210,OPAL TOWER,ALASAYEL STREET,Dubai,96044",
    "phone": "97143889993",
    "email": "admin@alsaadi-advocates.com",
    "registrationNumber": "ADF-2012-114"
  },
  {
    "id": "21caacdc-9052-48b5-921c-7c973ac4abd3",
    "slug": "mohammad-masoud-advocates-legal-consultants",
    "name": "MOHAMMAD MASOUD ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1NCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/10/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "08/09/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MOHAMMAD MASOUD ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_21caacdc-9052-48b5-921c-7c973ac4abd3",
        "address": "13 ,INTERNATIONAL BUSINESS TOWER ,Next to The First Collection Business Bay Hotel ,6917 ,Dubai",
        "phone": "97143421661 / 971527070780",
        "email": "mohammad@masoudlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Mohammad Hamad Masoud Ali Almusalam",
    "address": "13,INTERNATIONAL BUSINESS TOWER,Business Bay,",
    "phone": "97143421661",
    "email": "mohammad@masoudlaw.com",
    "registrationNumber": "ADF-2017-424"
  },
  {
    "id": "05dddabf-0dfa-4843-b0a8-cf6eaa27136d",
    "slug": "mohammad-shehab-alfarsi-advocates-legal-consultants",
    "name": "MOHAMMAD SHEHAB ALFARSI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1TCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/10/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/09/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MOHAMMAD SHEHAB ALFARSI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_05dddabf-0dfa-4843-b0a8-cf6eaa27136d",
        "address": "",
        "phone": "97143256020 / 971504400073",
        "email": "info@sw-advocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "MOHAMMAD SHEHAB AHMAD THANI ALFARSI",
    "address": "N/A",
    "phone": "97143256020",
    "email": "info@sw-advocates.com",
    "registrationNumber": "ADF-2022-613"
  },
  {
    "id": "ef095fb8-c3b5-42bc-92fc-43528c870fe7",
    "slug": "mohammed-abdulla-albreike-advocates-legal-consultants",
    "name": "MOHAMMED ABDULLA ALBREIKE ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/04/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/06/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MOHAMMED ABDULLA ALBREIKE ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ef095fb8-c3b5-42bc-92fc-43528c870fe7",
        "address": "MOHAMMED ABDULLA MOHSIN ABDURAHIM ALBREIKI ,406 ,ويست بيري ,برج خليفة ,220219 ,Dubai",
        "phone": "97145574529",
        "email": "d@albraikiadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Mohammed Abdulla Mohsin Abdulrahim Albreki",
    "address": "406,ويست بيري,مراسي درايف,Dubai,220219",
    "phone": "97145574529",
    "email": "d@albraikiadvocates.com",
    "registrationNumber": "ADF-2014-303"
  },
  {
    "id": "9aeb8716-ff23-4200-90de-c2e0ee86076e",
    "slug": "mohammed-ahmed-advocates-legal-consultants",
    "name": "MOHAMMED AHMED ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/28/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "01/27/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MOHAMMED AHMED ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9aeb8716-ff23-4200-90de-c2e0ee86076e",
        "address": "",
        "phone": "97143588887",
        "email": "e.lawyersd@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Mohammed Ahmed Mohammed Abdulla",
    "address": "N/A",
    "phone": "97143588887",
    "email": "e.lawyersd@gmail.com",
    "registrationNumber": "ADF-2013-267"
  },
  {
    "id": "4287f048-dc0c-4d51-9e0c-0c23356040ee",
    "slug": "mohammed-al-dahbashi-advocates",
    "name": "MOHAMMED AL DAHBASHI ADVOCATES",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/20/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/19/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MOHAMMED AL DAHBASHI ADVOCATES",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4287f048-dc0c-4d51-9e0c-0c23356040ee",
        "address": "الطابق 14  ,برج 48 جيت  ,محطة مترو دبي  ,413633 ,Dubai",
        "phone": "97144412031",
        "email": "courts@adglegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Mohd Ali Mohd Ali Aldahbashi",
    "address": "الطابق 14 ,برج 48 جيت ,شارع برج خليفة ,Dubai,",
    "phone": "97144412031",
    "email": "courts@adglegal.com",
    "registrationNumber": "ADF-2015-354"
  },
  {
    "id": "a5a2640f-b1b8-4512-b9ee-a8802d0c30fc",
    "slug": "mohammed-al-hashimi-advocates-and-legal-consultants",
    "name": "MOHAMMED AL HASHIMI ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/26/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/25/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MOHAMMED AL HASHIMI ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a5a2640f-b1b8-4512-b9ee-a8802d0c30fc",
        "address": "MOHAMMED MURTADA ALHASHMI ,3 ,LATIFA TOWER  ,CROWN PLAZA ,231400 ,Dubai",
        "phone": "97143521131",
        "email": "info@mhadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Mohammad Murtada Yaqoob Burhan AlHashimi",
    "address": "3,LATIFA TOWER ,SHEIKH ZAYED ROAD - TRADE CEN",
    "phone": "97143521131",
    "email": "info@mhadvocates.ae",
    "registrationNumber": "ADF-2015-347"
  },
  {
    "id": "d064ef91-4855-4ed3-b54e-062ea8ccc287",
    "slug": "mohammed-alkumaiti-advocates-legal-consultants",
    "name": "MOHAMMED ALKUMAITI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/24/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "07/23/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MOHAMMED ALKUMAITI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d064ef91-4855-4ed3-b54e-062ea8ccc287",
        "address": "Office 210 ,Al-Fajr Complex ,Makani No: 2999793136 ,000 ,Dubai",
        "phone": "97142297799 / 971505504550",
        "email": "info@mkumaiti.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Mohammed Ali Humaid Alkumaiti Alshamsi",
    "address": "Office 210,Al-Fajr Complex,Oud Metha - Umm Hu",
    "phone": "97142297799",
    "email": "info@mkumaiti.com",
    "registrationNumber": "ADF-2024-735-1"
  },
  {
    "id": "2d3e210f-8234-4e00-b9e6-1167758a43ee",
    "slug": "mohammed-bani-hashem-advocates-legal-consultants",
    "name": "MOHAMMED BANI HASHEM ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1CCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/10/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "07/09/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MOHAMMED BANI HASHEM ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2d3e210f-8234-4e00-b9e6-1167758a43ee",
        "address": "1007 ,برج لطيفة ,بجوار فندق كراون بلازل ,94873 ,Abu Dhabi",
        "phone": "97142951555 / 971567573911",
        "email": "info@mbhadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "1007,برج لطيفة,شارع الشيخ زايد,Abu Dhabi,9487",
    "phone": "97142951555",
    "email": "info@mbhadvocates.com",
    "registrationNumber": "ADF-2013-282"
  },
  {
    "id": "b47f195f-addd-458d-85ec-bb93239bbe4b",
    "slug": "mohammed-bekhit-advocates-legal-consultants",
    "name": "MOHAMMED BEKHIT ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1CCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/10/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "01/09/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MOHAMMED BEKHIT ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b47f195f-addd-458d-85ec-bb93239bbe4b",
        "address": "406 ,رقة البطين  ,بجوار فندق كونكورد  ,92414 ,Dubai",
        "phone": "97142666331",
        "email": "almeshref2019@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Mohammed Husein Bekhit Hidijan Al-Msa'abin",
    "address": "406,رقة البطين ,ال مكتوم ,Dubai,92414",
    "phone": "97142666331",
    "email": "almeshref2019@gmail.com",
    "registrationNumber": "ADF-2012-77"
  },
  {
    "id": "fff633e0-9416-4010-8c31-24269ee2cf79",
    "slug": "mohammed-bin-suwaidan-almeqbaali-advocates-legal-consultants",
    "name": "MOHAMMED BIN SUWAIDAN ALMEQBAALI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1CCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/13/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/12/2019 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MOHAMMED BIN SUWAIDAN ALMEQBAALI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fff633e0-9416-4010-8c31-24269ee2cf79",
        "address": "MOHAMMED SALEM ,11th floor, Office No. 1105 ,LAKE CENTRAL ,BURJ KHALIFA ,87087 ,Dubai",
        "phone": "97142411333",
        "email": "ga@hegazylaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "11th floor, Office No. 1105,LAKE CENTRAL,BUSA",
    "phone": "97142411333",
    "email": "ga@hegazylaw.com",
    "registrationNumber": "ADF-2017-412"
  },
  {
    "id": "c9f7542e-9b4a-43f5-bfc5-ec984563c41c",
    "slug": "mohammed-nekhira-aldhaheri-advocates-legal-consultants",
    "name": "MOHAMMED NEKHIRA ALDHAHERI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1OCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/30/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/29/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MOHAMMED NEKHIRA ALDHAHERI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c9f7542e-9b4a-43f5-bfc5-ec984563c41c",
        "address": "MOHAMMED NEKHAIRA ALDHAHERI ADVOCATES AND LEGAL CONSULTANT ,16 ,IRIS BAY ,ZOOM ,28177 ,Dubai",
        "phone": "97143323231 / 97143323231",
        "email": "Info@binnakhira.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Abdulwahhab Meer Ahmed Abdool",
    "address": "16,IRIS BAY,BUSINESS BAY ALMUSTQBAL STREET,Du",
    "phone": "97143323231",
    "email": "Info@binnakhira.com",
    "registrationNumber": "ADF-2018-450"
  },
  {
    "id": "e9d4f001-7001-4958-b95a-f283f1583a31",
    "slug": "mohammed-saeed-alshamsi-advocates-legal-consultants",
    "name": "MOHAMMED SAEED ALSHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1TCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/16/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/15/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MOHAMMED SAEED ALSHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e9d4f001-7001-4958-b95a-f283f1583a31",
        "address": "mohammed saeed salem alshamsi ,الاول ,مبنى خالد شعبان   ,دوار الساعه ,16916 ,Dubai",
        "phone": "",
        "email": "info@lawyer-uae.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "2402,محمد ناصر محمد اقبال,1100-0 /Nadd Hessa",
    "phone": "N/A",
    "email": "info@lawyer-uae.ae",
    "registrationNumber": "ADF-2024-727"
  },
  {
    "id": "9ae432c2-4110-4a73-9ff7-f5f33baaef76",
    "slug": "mohammed-yousuf-advocates-legal-consultants",
    "name": "MOHAMMED YOUSUF ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1ZCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/23/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/22/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MOHAMMED YOUSUF ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9ae432c2-4110-4a73-9ff7-f5f33baaef76",
        "address": "",
        "phone": "/ 971500000000",
        "email": "morshedy.legal@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Mohammed Yousuf Abdulrahim Abdulla",
    "address": "N/A",
    "phone": "N/A",
    "email": "morshedy.legal@gmail.com",
    "registrationNumber": "ADF-2020-513"
  },
  {
    "id": "2f87d653-d6e3-4b98-81e9-0ab05f928b31",
    "slug": "monther-al-hammadi-advocates-legal-consultants",
    "name": "MONTHER AL HAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/06/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MONTHER AL HAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2f87d653-d6e3-4b98-81e9-0ab05f928b31",
        "address": "MONTHER MOHAMWD ALHAMMADI ,API TOWER ,API WORLD TOWER ,CONRAD HOTEL ,300806 ,Dubai",
        "phone": "97142508555 / 971000000000",
        "email": "montheruae@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Monther Mohamed Malalla s.Alhammadi",
    "address": "API TOWER,API WORLD TOWER,TRADE CENTER FIRST-",
    "phone": "97142508555",
    "email": "montheruae@gmail.com",
    "registrationNumber": "ADF-2020-531"
  },
  {
    "id": "33313c27-5476-4398-bde0-ff404d0480c1",
    "slug": "mousa-alamri-advocates-legel-consultants",
    "name": "MOUSA ALAMRI ADVOCATES & LEGEL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/25/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/24/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MOUSA ALAMRI ADVOCATES & LEGEL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_33313c27-5476-4398-bde0-ff404d0480c1",
        "address": "",
        "phone": "97142237666",
        "email": "info@musaalamri.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Mousa Essa Mousa Al-Amri",
    "address": "N/A",
    "phone": "97142237666",
    "email": "info@musaalamri.com",
    "registrationNumber": "ADF-2012-204"
  },
  {
    "id": "6311e53c-d1e0-469a-92a1-e290c2faf954",
    "slug": "moza-aljabri-advocates-legal-consultants",
    "name": "MOZA ALJABRI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/03/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/02/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MOZA ALJABRI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6311e53c-d1e0-469a-92a1-e290c2faf954",
        "address": "",
        "phone": "97142999434 / 971563666333",
        "email": "info@moaza-advocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Moaza Saif Salem Saif Aljabri",
    "address": "N/A",
    "phone": "97142999434",
    "email": "info@moaza-advocates.com",
    "registrationNumber": "ADF-2020-524"
  },
  {
    "id": "4575cb41-efe0-44d1-8595-31c2dbb97e68",
    "slug": "muna-al-ansari-advocates-legal-consultants",
    "name": "MUNA AL ANSARI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/08/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "07/07/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MUNA AL ANSARI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4575cb41-efe0-44d1-8595-31c2dbb97e68",
        "address": "الأول 107 ,ناصر الساير ,فندق أسيانا ,27252 ,Dubai",
        "phone": "97142699255",
        "email": "mona1@lawyer.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Muna Mohammed Redha Al-Ansari",
    "address": "الأول 107,ناصر الساير,ديره المرقبات شارع صلاح",
    "phone": "97142699255",
    "email": "mona1@lawyer.com",
    "registrationNumber": "ADF-2012-220"
  },
  {
    "id": "ebaad15b-7645-4eda-aeab-efd4a2f10a2f",
    "slug": "muna-almazrouei-advocates-legal-consultants",
    "name": "MUNA ALMAZROUEI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/01/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/30/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MUNA ALMAZROUEI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ebaad15b-7645-4eda-aeab-efd4a2f10a2f",
        "address": "",
        "phone": "97143553062 / 971506316315",
        "email": "moc@lawyermuna.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97143553062",
    "email": "moc@lawyermuna.ae",
    "registrationNumber": "ADF-2020-517"
  },
  {
    "id": "4a5b2020-9a90-4726-b8ef-245a8f009364",
    "slug": "muna-almulla-advocates-legal-consultants",
    "name": "MUNA ALMULLA ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/22/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "02/21/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MUNA ALMULLA ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4a5b2020-9a90-4726-b8ef-245a8f009364",
        "address": "الطابق الرابع ,مركز الرقة للأعمال ,قرب مصرف الإمارات الإسلامي ,187103 ,Dubai",
        "phone": "97142384840",
        "email": "legalco@eim.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Muna Mohammed Faraj Mohammed Almulla",
    "address": "الطابق الرابع,مركز الرقة للأعمال,شارع الرقة,D",
    "phone": "97142384840",
    "email": "legalco@eim.ae",
    "registrationNumber": "ADF-2012-102"
  },
  {
    "id": "120e4ca7-7727-4524-9d53-5656ff95eea7",
    "slug": "muna-alsabbagh-advocates-legal-consultants",
    "name": "MUNA ALSABBAGH ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/27/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "01/26/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MUNA ALSABBAGH ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_120e4ca7-7727-4524-9d53-5656ff95eea7",
        "address": "Muna Ahmed Abdul-aziz Al-Sabbagh ,الطابق الخامس ,الزمردة ,مختبر دبي المركزي ,115578 ,Dubai",
        "phone": "97142283414",
        "email": "info@alwifaqlegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Muna Ahmed Abdulaziz Yousuf Alsabbagh",
    "address": "الطابق الخامس,الزمردة,ام هرير ,Dubai,115578",
    "phone": "97142283414",
    "email": "info@alwifaqlegal.com",
    "registrationNumber": "ADF-2016-373"
  },
  {
    "id": "a92c9f4c-fad2-4893-b407-713b48ab7143",
    "slug": "muna-alshamsi-advocates-legal-consultants",
    "name": "MUNA ALSHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/31/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "01/30/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MUNA ALSHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a92c9f4c-fad2-4893-b407-713b48ab7143",
        "address": "",
        "phone": "97143553023",
        "email": "info@munaalshamsi30.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Muna Khalifa Rashed Al Shamsi",
    "address": "N/A",
    "phone": "97143553023",
    "email": "info@munaalshamsi30.com",
    "registrationNumber": "ADF-2024-716"
  },
  {
    "id": "24f8f7c8-a688-4587-9e87-f3105a99533a",
    "slug": "musaab-ali-al-naqbi-advocates-legal-consultancy",
    "name": "MUSAAB ALI AL NAQBI ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/03/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "01/02/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MUSAAB ALI AL NAQBI ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_24f8f7c8-a688-4587-9e87-f3105a99533a",
        "address": "13 ,Le Solarium Tower ,Arabian Gate ,185430 ,Dubai",
        "phone": "97145805135 / 971558703836",
        "email": "info@alnaqbilaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Musaab Ali Mohamed Abdalla Alnaqbi",
    "address": "13,Le Solarium Tower,Dubai Silicon Oasis ,Dub",
    "phone": "97145805135",
    "email": "info@alnaqbilaw.ae",
    "registrationNumber": "ADF-2021-538"
  },
  {
    "id": "ebbfa096-ef29-4660-9201-8c03bd4be3fe",
    "slug": "musallam-almahhrami-advocates-legal-consultants",
    "name": "MUSALLAM ALMAHHRAMI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/12/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "08/11/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MUSALLAM ALMAHHRAMI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ebbfa096-ef29-4660-9201-8c03bd4be3fe",
        "address": "",
        "phone": "97144560410 / 971551096724",
        "email": "info1@a-lawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Musallam Hamed Musallam Bakheet Almahhrami",
    "address": "N/A",
    "phone": "97144560410",
    "email": "info1@a-lawyers.com",
    "registrationNumber": "ADF-2015-358"
  },
  {
    "id": "8b9b9a1d-f3d0-4a3f-a743-67fa6fc84709",
    "slug": "nadia-abdolrazagh-advocacy-legal-consultations",
    "name": "NADIA ABDOLRAZAGH ADVOCACY & LEGAL CONSULTATIONS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE5BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/12/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: NADIA ABDOLRAZAGH ADVOCACY & LEGAL CONSULTATIONS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8b9b9a1d-f3d0-4a3f-a743-67fa6fc84709",
        "address": "",
        "phone": "97142999934",
        "email": "info@nadiaadvocacy.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Nadia Abdolrazagh Mohammadi",
    "address": "N/A",
    "phone": "97142999934",
    "email": "info@nadiaadvocacy.ae",
    "registrationNumber": "ADF-2012-261"
  },
  {
    "id": "76cab153-5498-48e2-acc7-4fb5c4cb1236",
    "slug": "nadia-alyousuf-advocates-legal-consultants",
    "name": "NADIA ALYOUSUF ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE5BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/27/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: NADIA ALYOUSUF ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_76cab153-5498-48e2-acc7-4fb5c4cb1236",
        "address": "FIRST ,KIA FLAG SHIP ,KIA CAR SHOWROOM ,2031 ,Dubai",
        "phone": "97143444210 / 971505522350",
        "email": "official@nylegalfirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Nadia Mohamed Habib Alyousuf",
    "address": "FIRST,KIA FLAG SHIP,SHEIKH ZAYED ROAD,Dubai,2",
    "phone": "97143444210",
    "email": "official@nylegalfirm.com",
    "registrationNumber": "ADF-2020-536"
  },
  {
    "id": "7e92f791-0024-4f89-84eb-1e2d979fd2d2",
    "slug": "nadia-mohammed-advocates-legal-consultancy",
    "name": "NADIA MOHAMMED ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE5NCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/06/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/05/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: NADIA MOHAMMED ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7e92f791-0024-4f89-84eb-1e2d979fd2d2",
        "address": "first floor ,Al Ferdous 4 ,Park and Shop ,12018 ,Dubai",
        "phone": "97143930222 / 971505122999",
        "email": "info@amanidarwishlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Nadia Mohammad Ramadan",
    "address": "first floor,Al Ferdous 4,Al Safa 1st,Dubai,12",
    "phone": "97143930222",
    "email": "info@amanidarwishlaw.ae",
    "registrationNumber": "ADF-2019-472"
  },
  {
    "id": "c8946f42-15b9-4001-93e7-05c5d766ac30",
    "slug": "nadya-ahmed-hasan-advocates-legal-consultants",
    "name": "NADYA AHMED HASAN ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE5BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/25/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: NADYA AHMED HASAN ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c8946f42-15b9-4001-93e7-05c5d766ac30",
        "address": "",
        "phone": "97143387678 / 971503938886",
        "email": "INFO@ADVOCATESDXB.AE",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "NADYA AHMED HASAN ALHAR ALSHEHHI",
    "address": "N/A",
    "phone": "97143387678",
    "email": "INFO@ADVOCATESDXB.AE",
    "registrationNumber": "ADF-2025-766"
  },
  {
    "id": "170463c8-fa0b-4323-bb48-8ea54d32ed3d",
    "slug": "naji-beidoun-advocates-legal-consultants",
    "name": "NAJI BEIDOUN ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE5CCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/14/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/13/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: NAJI BEIDOUN ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_170463c8-fa0b-4323-bb48-8ea54d32ed3d",
        "address": "الثالث - 329 ,إمارات اتريوم  ,مزايا سنتر ,4609 ,Dubai",
        "phone": "97142225151",
        "email": "team@nbadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Naji Ali Alhaj Ibrahim Baidhoun",
    "address": "الثالث - 329,إمارات اتريوم ,الشيخ زايد - منطق",
    "phone": "97142225151",
    "email": "team@nbadvocates.com",
    "registrationNumber": "ADF-2012-121"
  },
  {
    "id": "bc5ea246-1523-48e3-917c-682ff8a19466",
    "slug": "naser-abdulla-almuharrami-advocates-legal-consultants",
    "name": "NASER ABDULLA ALMUHARRAMI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE5BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/07/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "02/06/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: NASER ABDULLA ALMUHARRAMI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bc5ea246-1523-48e3-917c-682ff8a19466",
        "address": "Naser almuharrami ,التاسع  ,SAMA TOWER ,مطعم تشيلو  ,0000 ,Dubai",
        "phone": "97144581795 / 971507388622",
        "email": "info@lawdxb.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "التاسع ,SAMA TOWER,TRADE CENTER  FIRST,Dubai,",
    "phone": "97144581795",
    "email": "info@lawdxb.ae",
    "registrationNumber": "ADF-2022-590"
  },
  {
    "id": "e9977c41-28ca-4173-b8d2-ef9fa1de8472",
    "slug": "nasser-al-jaroodi-advocates-legal-consultants",
    "name": "NASSER AL JAROODI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE5BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/04/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/03/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: NASSER AL JAROODI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e9977c41-28ca-4173-b8d2-ef9fa1de8472",
        "address": "Nasser Yousuf Mohammed Aljaroodi ,الطابق الثاني - مكتب رقم 2015A ,مركز مزايا للتسوق  ,بالقرب من محطة مترو برج خليفة - دبي مول - مخرج رقم 2 ,5958 ,Dubai",
        "phone": "97143699915 / 971561339712",
        "email": "info@aljaroodiadv.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Naser Yousef Mohammed Naser Al-Jaroodi",
    "address": "الطابق الثاني - مكتب رقم 2015A,مركز مزايا للت",
    "phone": "97143699915",
    "email": "info@aljaroodiadv.com",
    "registrationNumber": "ADF-2012-250"
  },
  {
    "id": "4b400e1b-7731-4a4b-9c37-a77e3c03ab78",
    "slug": "nasser-al-shamsi-advocates-legal-consultants",
    "name": "NASSER AL SHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE5BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/23/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "01/22/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: NASSER AL SHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4b400e1b-7731-4a4b-9c37-a77e3c03ab78",
        "address": "",
        "phone": "97142507778 / 971506421661",
        "email": "feedback@alshamsilawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "NASER HAMAD SULAIMAN JABER AL SHAMSI",
    "address": "N/A",
    "phone": "97142507778",
    "email": "feedback@alshamsilawfirm.ae",
    "registrationNumber": "ADF-2018-441"
  },
  {
    "id": "0209756c-e854-4fa0-836a-abe019e9fcd0",
    "slug": "nasser-alawar-advocates-legal-consultants",
    "name": "NASSER ALAWAR ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE5BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/12/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/09/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: NASSER ALAWAR ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0209756c-e854-4fa0-836a-abe019e9fcd0",
        "address": "",
        "phone": "97143793798 / 971504407878",
        "email": "n.alawar@alawarlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Nasser Abdulwahed Abdulrahman Alawar",
    "address": "N/A",
    "phone": "97143793798",
    "email": "n.alawar@alawarlaw.ae",
    "registrationNumber": "ADF-2020-529"
  },
  {
    "id": "86fac3dc-bced-468b-8e4c-43324e2aa906",
    "slug": "nasser-alkhamis-advocates-legal-consultants",
    "name": "NASSER ALKHAMIS ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE5BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/26/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/25/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: NASSER ALKHAMIS ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_86fac3dc-bced-468b-8e4c-43324e2aa906",
        "address": "",
        "phone": "97145548499",
        "email": "legal@nyk.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Nasser Yousuf Ali Nasser Alkhamis",
    "address": "N/A",
    "phone": "97145548499",
    "email": "legal@nyk.ae",
    "registrationNumber": "ADF-2022-607"
  },
  {
    "id": "32035dc2-f9b0-4d08-a142-f280db15a2aa",
    "slug": "nasser-malalla-advocates-legal-consultants",
    "name": "NASSER MALALLA ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE5NCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/06/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/05/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: NASSER MALALLA ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_32035dc2-f9b0-4d08-a142-f280db15a2aa",
        "address": "",
        "phone": "97148321212",
        "email": "nasser@nmlawyers.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Naser Malalla Mohammed Ghanem",
    "address": "N/A",
    "phone": "97148321212",
    "email": "nasser@nmlawyers.ae",
    "registrationNumber": "ADF-2012-162"
  },
  {
    "id": "c134cfc4-beae-44f1-96b0-d2828db33d03",
    "slug": "national-group-advocates-legal-consultants",
    "name": "NATIONAL GROUP ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE5HCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/11/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/10/2018 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: NATIONAL GROUP ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c134cfc4-beae-44f1-96b0-d2828db33d03",
        "address": "",
        "phone": "97143366173",
        "email": "info@uaenationalgroup.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97143366173",
    "email": "info@uaenationalgroup.com",
    "registrationNumber": "ADF-2012-117"
  },
  {
    "id": "ea00f5ec-97d3-419d-9c91-b66e5d05e2e8",
    "slug": "nawal-al-merbati-advocates-legal-consultants",
    "name": "NAWAL AL MERBATI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE5BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/27/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/26/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: NAWAL AL MERBATI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ea00f5ec-97d3-419d-9c91-b66e5d05e2e8",
        "address": "NAWAL AL MERBATI ,2, 208 ,RAK Bank Building ,RAK Bank ,99272 ,Dubai",
        "phone": "97142233775 / 971564454162",
        "email": "nawal.almurbati@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Nawal Mustafa Mohammed Saleh Al-Merbati",
    "address": "2, 208,RAK Bank Building,Al Maktoum Street,Du",
    "phone": "97142233775",
    "email": "nawal.almurbati@hotmail.com",
    "registrationNumber": "ADF-2011-13"
  },
  {
    "id": "bf5657d9-ea57-4099-89ca-c51bd6c1c641",
    "slug": "nawal-alhosani-advocates-and-legal-consultants",
    "name": "NAWAL ALHOSANI ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE5BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/10/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/09/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: NAWAL ALHOSANI ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bf5657d9-ea57-4099-89ca-c51bd6c1c641",
        "address": "",
        "phone": "97145148832 / 971502061303",
        "email": "dxbcourts@nhadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97145148832",
    "email": "dxbcourts@nhadvocates.com",
    "registrationNumber": "ADF-2015-362"
  },
  {
    "id": "09f7be53-e98a-499b-a46b-3635ebba9c54",
    "slug": "nawal-mohamed-al-bady-advocates-legal-consultancy",
    "name": "NAWAL MOHAMED AL BADY  ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE5NCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/16/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "02/15/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: NAWAL MOHAMED AL BADY  ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_09f7be53-e98a-499b-a46b-3635ebba9c54",
        "address": "شركة قطر للتأمين ,مركز الدانة ,فندق كارلتون بالاس ,80239 ,Dubai",
        "phone": "97142247451",
        "email": "nooradvo@eim.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "شركة قطر للتأمين,مركز الدانة,شارع المكتوم/دير",
    "phone": "97142247451",
    "email": "nooradvo@eim.ae",
    "registrationNumber": "ADF-2012-95"
  },
  {
    "id": "8d7ab4a5-3c4d-4fa5-a466-d525e2054af8",
    "slug": "nawal-salem-saeed-advocates-legal-consultants",
    "name": "NAWAL SALEM SAEED ADVOCATES &LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE5TCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/27/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "01/29/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: NAWAL SALEM SAEED ADVOCATES &LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8d7ab4a5-3c4d-4fa5-a466-d525e2054af8",
        "address": "Nawal Salem Saeed Salem ,508 ,S. I. T Tower ,SILICON OASIS ,0000 ,Dubai",
        "phone": "97145582139 / 971555425608",
        "email": "courts@nslawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "508,S. I. T Tower,NADD HESSA,Dubai,0000",
    "phone": "97145582139",
    "email": "courts@nslawfirm.ae",
    "registrationNumber": "ADF-2021-542"
  },
  {
    "id": "cdefbdd8-ff2a-4404-ab83-1565e2c39e9d",
    "slug": "nisma-aljanahi-advocates-legal-consultants",
    "name": "NISMA ALJANAHI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE5BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/10/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/09/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: NISMA ALJANAHI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cdefbdd8-ff2a-4404-ab83-1565e2c39e9d",
        "address": "Majed Naim ,5 ,Aspect Tower ,Bay Avenue Mall ,554868 ,Dubai",
        "phone": "97147701106 / 971557665402",
        "email": "communicate@janahilegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "5,Aspect Tower,Business Bay,Dubai,554868",
    "phone": "97147701106",
    "email": "communicate@janahilegal.com",
    "registrationNumber": "ADF-2020-527"
  },
  {
    "id": "5a93b856-f9cc-4d4f-98a4-be6c119e4fe3",
    "slug": "noof-alabdulla-advocates-legal-consultants-llc",
    "name": "NOOF ALABDULLA ADVOCATES & LEGAL CONSULTANTS L.L.C",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE5BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/21/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: NOOF ALABDULLA ADVOCATES & LEGAL CONSULTANTS L.L.C",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5a93b856-f9cc-4d4f-98a4-be6c119e4fe3",
        "address": "",
        "phone": "97143889955",
        "email": "m.alhanafi@nooflaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Noof Abdulla Ahmad Alabdulla",
    "address": "N/A",
    "phone": "97143889955",
    "email": "m.alhanafi@nooflaw.com",
    "registrationNumber": "ADF-2011-71"
  },
  {
    "id": "ca27884c-48bb-4c1a-bcba-dd4c938fe85b",
    "slug": "noora-ahmad-advocates-legal-consultants",
    "name": "NOORA AHMAD ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE5BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/12/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "12/11/2025 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: NOORA AHMAD ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ca27884c-48bb-4c1a-bcba-dd4c938fe85b",
        "address": "",
        "phone": "97142222282",
        "email": "N.moosaa@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Noora Ahmad Moosa Sanqoor",
    "address": "N/A",
    "phone": "97142222282",
    "email": "N.moosaa@gmail.com",
    "registrationNumber": "ADF-2022-649"
  },
  {
    "id": "8fd1535a-4b34-4e52-83df-139fcfb26305",
    "slug": "noorhan-abdullatif-alzaabi-advocates-legal-consultants",
    "name": "NOORHAN ABDULLATIF ALZAABI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE5BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/29/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "08/28/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: NOORHAN ABDULLATIF ALZAABI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8fd1535a-4b34-4e52-83df-139fcfb26305",
        "address": "",
        "phone": "97148761744 / 971971487617",
        "email": "info@noorhanlawyer.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97148761744",
    "email": "info@noorhanlawyer.com",
    "registrationNumber": "ADF-2021-558"
  },
  {
    "id": "ea2fa1be-e299-4370-b7f3-bdd8c7bf051d",
    "slug": "nouf-qasem-advocates-legal-consultants",
    "name": "NOUF QASEM ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE5RCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/10/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/09/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: NOUF QASEM ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ea2fa1be-e299-4370-b7f3-bdd8c7bf051d",
        "address": "",
        "phone": "",
        "email": "noufyamgy4@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "NOUF ABDULFADHEL MOHD QASEM BAIDARYAMCHE",
    "address": "N/A",
    "phone": "97142696240",
    "email": "noufyamgy4@gmail.com",
    "registrationNumber": "ADF-2024-735"
  },
  {
    "id": "4f4b0a10-f71b-4c6e-9bea-8fcaa4c64b75",
    "slug": "noura-alamiri-advocates-legal-consultants",
    "name": "NOURA ALAMIRI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE5BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/16/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "07/15/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: NOURA ALAMIRI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4f4b0a10-f71b-4c6e-9bea-8fcaa4c64b75",
        "address": "الطابق الثالث  ,SMJ1 ,مطعم حتوته مصرية  ,554531 ,Dubai",
        "phone": "97143443388 / 971524193537",
        "email": "info@nialawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "الطابق الثالث ,SMJ1,شارع الشيخ زايد ,Dubai,55",
    "phone": "97143443388",
    "email": "info@nialawfirm.ae",
    "registrationNumber": "ADF-2020-504"
  },
  {
    "id": "4e636842-b67d-49a6-a11f-607b9a136380",
    "slug": "noura-alhajeri-and-fahd-alhadouri-advocates-legal-consultants",
    "name": "NOURA ALHAJERI AND FAHD ALHADOURI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE5BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/21/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/20/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: NOURA ALHAJERI AND FAHD ALHADOURI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4e636842-b67d-49a6-a11f-607b9a136380",
        "address": "FAHD MOHAMED RASHED ALHADOURI ALYAMMAHI ,10 ,MAZE TOWER ,DIFC - FUTURE MUSEUM ,127077 ,Dubai",
        "phone": "97143596555",
        "email": "fhd6767@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Fahd Mohamed Rashid Al Hadouri Al Yamahi",
    "address": "10,MAZE TOWER,TRADE CENTER SECOND,Dubai,12707",
    "phone": "97143596555",
    "email": "fhd6767@hotmail.com",
    "registrationNumber": "ADF-2014-315"
  },
  {
    "id": "e56938ba-8d38-4268-9706-651d4c984db9",
    "slug": "noura-almaazmi-advocates-legal-consultancy",
    "name": "NOURA ALMAAZMI ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE5BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/14/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/13/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: NOURA ALMAAZMI ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e56938ba-8d38-4268-9706-651d4c984db9",
        "address": "Noura Mohamed Abdelrahman Almaazmi ,17 ,The Oberoi Center ,Burlington Tower ,414224 ,Dubai",
        "phone": "97143215777",
        "email": "case@almaazmilawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Noura Mohamed Murad Abdelrahman Almaazmi",
    "address": "17,The Oberoi Center,Al A’amal St,Dubai,41422",
    "phone": "97143215777",
    "email": "case@almaazmilawyers.com",
    "registrationNumber": "ADF-2015-355"
  },
  {
    "id": "a653164d-3cbc-49d0-a7cd-ba5fe563222d",
    "slug": "noura-taysser-advocates-legal-consultants",
    "name": "NOURA TAYSSER ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE5UCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/22/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/21/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: NOURA TAYSSER ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a653164d-3cbc-49d0-a7cd-ba5fe563222d",
        "address": "1606 ,متروبوليس تاور  ,داماك ,0000000 ,Dubai",
        "phone": "",
        "email": "noura.taisser@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Noura taysser mohamed nasib",
    "address": "1606,متروبوليس تاور ,مراسي درايف - الخليج الت",
    "phone": "N/A",
    "email": "noura.taisser@gmail.com",
    "registrationNumber": "ADF-2023-666"
  },
  {
    "id": "019941a6-be29-4b9c-a1ee-6f6cf6c599de",
    "slug": "nujood-bin-haider-advocates-legal-consultants",
    "name": "NUJOOD BIN HAIDER ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE5CCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/19/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "08/18/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: NUJOOD BIN HAIDER ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_019941a6-be29-4b9c-a1ee-6f6cf6c599de",
        "address": "1 ,MOBH Building 2 ,GGICO Metro Station ,3555 ,Dubai",
        "phone": "97142821191 / 971552222519",
        "email": "nujoodlegal@mobhgroup.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "1,MOBH Building 2,Garhoud,Dubai,3555",
    "phone": "97142821191",
    "email": "nujoodlegal@mobhgroup.com",
    "registrationNumber": "ADF-2014-324"
  },
  {
    "id": "43806daf-e311-4130-a270-8aabc08c4ef4",
    "slug": "obaid-al-ebri-advocates-legal-consultants",
    "name": "OBAID AL EBRI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE9BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/01/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "07/31/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: OBAID AL EBRI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_43806daf-e311-4130-a270-8aabc08c4ef4",
        "address": "",
        "phone": "97142966772",
        "email": "info@advocates-consultation.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Obaid Abdulla Mubarak Abdulla Alebri",
    "address": "N/A",
    "phone": "97142966772",
    "email": "info@alebrilegalfirm.ae",
    "registrationNumber": "ADF-2023-686"
  },
  {
    "id": "c8252dab-1a42-4878-a3ee-50ba9dddb978",
    "slug": "obaid-al-shamsi-advocates-legal-consultants",
    "name": "OBAID AL SHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE9BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/30/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/29/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: OBAID AL SHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c8252dab-1a42-4878-a3ee-50ba9dddb978",
        "address": "OBAID AL SHAMSI ADVOCATES & LEGAL CONSULTANTS ,لا يوجد ,AL GARHOUD BUSINESS CENTER ,AL GARHOUD BUSINESS CENTER ,1903 ,Dubai",
        "phone": "97129555545",
        "email": "info@oaslawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Obaid Saeed Ali Obaid Alshamsi",
    "address": "لا يوجد,AL GARHOUD BUSINESS CENTER,AL GARHOUD",
    "phone": "97142503455",
    "email": "info@oaslawfirm.ae",
    "registrationNumber": "ADF-2017-407"
  },
  {
    "id": "70a8fb70-2729-4348-b87b-258c7dc7a387",
    "slug": "obaid-almaazmi-lawyer-and-legal-consultant",
    "name": "OBAID ALMAAZMI LAWYER AND LEGAL CONSULTANT",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE9BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/11/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/10/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: OBAID ALMAAZMI LAWYER AND LEGAL CONSULTANT",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_70a8fb70-2729-4348-b87b-258c7dc7a387",
        "address": "Obaid Ishaq Ismail Al-Maazmi ,الطابق 21 ,ذا اكستشينج تاور  ,فندق جي دبليو ماريوت ماركي ,238365 ,Dubai",
        "phone": "97143584737",
        "email": "obaidotp@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Obaid Ishaq Abdalla Ismall A lmaazmi",
    "address": "الطابق 21,ذا اكستشينج تاور ,شارع المستقبل / م",
    "phone": "97143584737",
    "email": "obaidotp@gmail.com",
    "registrationNumber": "ADF-2016-384"
  },
  {
    "id": "c4d12b8a-d69f-4e74-9553-68259f3cf171",
    "slug": "obaid-bingadeem-al-suwaidi-advocates-legal-consultants",
    "name": "OBAID BINGADEEM AL SUWAIDI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE9CCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/07/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/06/2018 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: OBAID BINGADEEM AL SUWAIDI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c4d12b8a-d69f-4e74-9553-68259f3cf171",
        "address": "",
        "phone": "97142772442",
        "email": "info@obs-legal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97142772442",
    "email": "info@obs-legal.com",
    "registrationNumber": "ADF-2016-379"
  },
  {
    "id": "edbb7814-39f9-4ec9-b01d-9de1117e343e",
    "slug": "omar-khalifa-advocates-legal-consultants",
    "name": "OMAR KHALIFA ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE9LCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/11/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "01/10/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: OMAR KHALIFA ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_edbb7814-39f9-4ec9-b01d-9de1117e343e",
        "address": "901-902 ,برج السلام ,فندق جراند شيراتون ,2741291443 ,Dubai",
        "phone": "97145877794 / 971586606660",
        "email": "obh@obhlawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Omar Khalifa Abdulkarim Yousef Alblooshi",
    "address": "901-902,برج السلام,شارع الشيخ زايد - المركز ا",
    "phone": "97145877794",
    "email": "obh@obhlawyers.com",
    "registrationNumber": "ADF-2022-652"
  },
  {
    "id": "9990674d-a6d3-4791-b6b7-76573d232260",
    "slug": "omar-rashid-al-ghafri-lawyer-and-legal-consultants",
    "name": "OMAR RASHID AL GHAFRI LAWYER AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE9SCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/12/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "01/11/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: OMAR RASHID AL GHAFRI LAWYER AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9990674d-a6d3-4791-b6b7-76573d232260",
        "address": "",
        "phone": "97165333314 / 971569381334",
        "email": "info@alghafri.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Omar Rashid Hamid Masoud Alghafri",
    "address": "N/A",
    "phone": "97165333314",
    "email": "info@alghafri.ae",
    "registrationNumber": "ADF-2022-584"
  },
  {
    "id": "28a8ce78-f0bd-48d6-98f4-daaba78a6427",
    "slug": "omar-sharif-advocates-legal-consultants",
    "name": "OMAR SHARIF ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE9TCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/29/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/28/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: OMAR SHARIF ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_28a8ce78-f0bd-48d6-98f4-daaba78a6427",
        "address": "OMAR MOHAMMED SHARIF ,1 ,THE VILLGE ,JUMAIURAH MOUSQE ,341 ,Dubai",
        "phone": "97143336699 / 971508899153",
        "email": "oslawyer007@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "1,THE VILLGE,JUMAIRAH STREET,Dubai,341",
    "phone": "97143336699",
    "email": "oslawyer007@gmail.com",
    "registrationNumber": "ADF-2021-547"
  },
  {
    "id": "fc32d495-1259-45d6-ab30-9199bdf008a2",
    "slug": "omran-alrawi-advocates-legal-consultants",
    "name": "OMRAN ALRAWI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE9BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/16/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/15/2019 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: OMRAN ALRAWI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fc32d495-1259-45d6-ab30-9199bdf008a2",
        "address": "",
        "phone": "97142327722",
        "email": "adv.alrawi@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97142327722",
    "email": "adv.alrawi@gmail.com",
    "registrationNumber": "ADF-2011-47"
  },
  {
    "id": "fb54dcbf-2615-4f90-bca6-662e7d2b9561",
    "slug": "omran-darwish-advocate-legal-consultants",
    "name": "OMRAN DARWISH ADVOCATE LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE9ECiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/25/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/24/2025 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: OMRAN DARWISH ADVOCATE LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fb54dcbf-2615-4f90-bca6-662e7d2b9561",
        "address": "التاسع 903 ,الخور بلازا  ,نادي خور دبي  ,125656 ,Dubai",
        "phone": "97143266661",
        "email": "od_alc@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "التاسع 903,الخور بلازا ,بورسعيد - شارع الشيخ",
    "phone": "97143266661",
    "email": "od_alc@hotmail.com",
    "registrationNumber": "ADF-2012-203"
  },
  {
    "id": "3246ef73-8e28-43dd-8693-01e8119a2f64",
    "slug": "osama-alsalmi-advocates-legal-consultants",
    "name": "OSAMA ALSALMI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE9BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/18/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/17/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: OSAMA ALSALMI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3246ef73-8e28-43dd-8693-01e8119a2f64",
        "address": "Osama Alsalmi ,5 ,Makateb building  ,Tasheel ,00 ,Dubai",
        "phone": "97148187210",
        "email": "info@alsalmilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Osamah Mohamed Ahmed Salem Alsalmi",
    "address": "5,Makateb building ,Almaktoum road deira port",
    "phone": "97148187210",
    "email": "info@alsalmilaw.com",
    "registrationNumber": "ADF-2022-634"
  },
  {
    "id": "a0cdd94d-cc5a-4617-b6a3-b23deb9852d5",
    "slug": "othman-almarzooqi-advocates-legal-consultants",
    "name": "OTHMAN ALMARZOOQI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE9BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/27/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "07/26/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: OTHMAN ALMARZOOQI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a0cdd94d-cc5a-4617-b6a3-b23deb9852d5",
        "address": "othman almarzooqi ,19th ,single business tower ,samaya tower ,114333 ,Dubai",
        "phone": "97142999970 / 971500000000",
        "email": "info@othmanadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Othman Mohamed Hassan Mohamed Almarzooqi",
    "address": "19th,single business tower,sheikh zayed road,",
    "phone": "97142999970",
    "email": "info@othmanadvocates.ae",
    "registrationNumber": "ADF-2021-557"
  },
  {
    "id": "22043b7f-55d2-4eb4-a173-3077ba390351",
    "slug": "prestige-advocates-legal-consultants",
    "name": "PRESTIGE ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFBBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/08/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/07/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: PRESTIGE ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_22043b7f-55d2-4eb4-a173-3077ba390351",
        "address": "Dr. Ali Ismail Aljarman ,Roof Floor - Offices R03 & R04 ,MSM 1 Building ,Al Saffa First ,62639 ,Dubai",
        "phone": "97144393733",
        "email": "info@prestigeadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "ALI ISMAIL IBRAHIM ALJARMAN",
    "address": "Roof Floor - Offices R03 & R04,MSM 1 Building",
    "phone": "97144393733",
    "email": "info@prestigeadvocates.com",
    "registrationNumber": "ADF-2012-134"
  },
  {
    "id": "c314e20b-1f39-4c2d-8b81-8af5888cee30",
    "slug": "proconsult-advocates-legal-consultants",
    "name": "PROCONSULT ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFBBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/04/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "07/03/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: PROCONSULT ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c314e20b-1f39-4c2d-8b81-8af5888cee30",
        "address": "Mubarak Abdullah ,7 ,Westburry Offices Tower 1 ,Burj Khalifa ,122352 ,Dubai",
        "phone": "97143298711 / 971504649812",
        "email": "proconsult@uaeahead.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "7,Westburry Offices Tower 1,Marasi Drive Busi",
    "phone": "97143298711",
    "email": "proconsult@uaeahead.com",
    "registrationNumber": "ADF-2012-216"
  },
  {
    "id": "3117b2a0-79c7-477b-b710-1b6eb632bccc",
    "slug": "qumasha-ali-mohammad-advocates-legal-consultants",
    "name": "QUMASHA ALI MOHAMMAD ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/25/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/24/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: QUMASHA ALI MOHAMMAD ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3117b2a0-79c7-477b-b710-1b6eb632bccc",
        "address": "",
        "phone": "97145650550",
        "email": "uae.courts@qamadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "QUMASHA ALI MOHAMMAD ABDULLA",
    "address": "N/A",
    "phone": "97145650550",
    "email": "uae.courts@qamadvocates.com",
    "registrationNumber": "ADF-2023-704"
  },
  {
    "id": "4eb56ada-9f3f-49f6-bcf7-af77724c94cd",
    "slug": "raja-al-saleh-advocates-legal-consultants",
    "name": "RAJA AL SALEH ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFJBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/13/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/12/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: RAJA AL SALEH ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4eb56ada-9f3f-49f6-bcf7-af77724c94cd",
        "address": "Mezzanine - Office M19 ,Business Avenue ,Makani No: 3248594620 ,000 ,Dubai",
        "phone": "97142855669 / 971554722231",
        "email": "lawyerrajaa2002@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "Mezzanine - Office M19,Business Avenue,Port S",
    "phone": "97142855669",
    "email": "lawyerrajaa2002@hotmail.com",
    "registrationNumber": "ADF-2023-694"
  },
  {
    "id": "473600a9-e063-4cba-8a12-b6f05db35951",
    "slug": "rashed-abdulla-alhefeiti-advocates-legal-consultants",
    "name": "RASHED ABDULLA ALHEFEITI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFJBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/20/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/19/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: RASHED ABDULLA ALHEFEITI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_473600a9-e063-4cba-8a12-b6f05db35951",
        "address": "",
        "phone": "97145686887 / 971566651137",
        "email": "info@case-laws.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97145686887",
    "email": "info@case-laws.com",
    "registrationNumber": "ADF-2020-521"
  },
  {
    "id": "c567de5a-f399-4c56-829e-06e37a2eb4fc",
    "slug": "rashed-ahmed-alsereidi-advocates-legal-consultants",
    "name": "RASHED AHMED ALSEREIDI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFJBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/08/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/07/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: RASHED AHMED ALSEREIDI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c567de5a-f399-4c56-829e-06e37a2eb4fc",
        "address": "0 ,بن فارس 2 ,مستشفى البراحة ,22662 ,Dubai",
        "phone": "97142203333 / 9715048999911",
        "email": "seridi.advo@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Rashed Ahmed Ghareib Huwashel Alsereidi",
    "address": "0,بن فارس 2,البراحة,Dubai,22662",
    "phone": "97142203333",
    "email": "seridi.advo@gmail.com",
    "registrationNumber": "ADF-2022-612"
  },
  {
    "id": "33654f3d-b8f9-48ad-bbba-42847367b511",
    "slug": "rashed-al-shehhi-advocates-legal-consultants",
    "name": "RASHED AL SHEHHI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFJBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/30/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/29/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: RASHED AL SHEHHI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_33654f3d-b8f9-48ad-bbba-42847367b511",
        "address": "السادس - مكتب 604 ,الوصل بيزنس سنتر - مبنى رقم R549 ,بنك مصر ,2079 ,Dubai",
        "phone": "97143961112",
        "email": "reception@rslawfirm.org",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Rashed Saeed Rashed Ali",
    "address": "السادس - مكتب 604,الوصل بيزنس سنتر - مبنى رقم",
    "phone": "97143961112",
    "email": "reception@rslawfirm.org",
    "registrationNumber": "ADF-2013-276"
  },
  {
    "id": "c12d8618-835a-40dd-8841-3290c77a2e93",
    "slug": "rashed-al-suwaidi-advocates-legal-consultants",
    "name": "RASHED Al SUWAIDI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFJBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/17/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/16/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: RASHED Al SUWAIDI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c12d8618-835a-40dd-8841-3290c77a2e93",
        "address": "Rashed Abdulrahman Mohammed abdullah Alsuwaidi ,الطابق الخامس 504 ,كورت تاور  ,الخليج التجاري ,35836 ,Dubai",
        "phone": "97145723403 / 971557679696",
        "email": "info@ralsuwaidi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "7, Businees village , Block _ B,port saeed,Du",
    "phone": "97143254520",
    "email": "info@ralsuwaidi.com",
    "registrationNumber": "ADF-2019-485"
  },
  {
    "id": "a718961d-c976-4a3c-bd09-585ec7c81310",
    "slug": "rashed-bin-arab-advocate-and-legal-consultants",
    "name": "RASHED BIN ARAB ADVOCATE AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFJCCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/04/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/03/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: RASHED BIN ARAB ADVOCATE AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a718961d-c976-4a3c-bd09-585ec7c81310",
        "address": "Jane Naoe Elsayed ,Level No. 22 – Office No. (2201 – 2202) ,Concord Tower ,Media City ,99779 ,Dubai",
        "phone": "97143575999",
        "email": "info@binarab.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Rashid Abdulla Ali Bin Arab",
    "address": "Level No. 22 – Office No. (2201 – 2202),Conco",
    "phone": "97143575999",
    "email": "info@binarab.ae",
    "registrationNumber": "ADF-2012-107"
  },
  {
    "id": "6966793e-be56-4683-9aad-1912a5885631",
    "slug": "rashed-lootah-advocates-legal-consultants",
    "name": "RASHED LOOTAH ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFJMCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/23/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/22/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: RASHED LOOTAH ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6966793e-be56-4683-9aad-1912a5885631",
        "address": "",
        "phone": "97142713893",
        "email": "info@rashedlootah.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Rashed Mohammed Abdulla Saeed Lootah",
    "address": "N/A",
    "phone": "97142713893",
    "email": "info@rashedlootah.com",
    "registrationNumber": "ADF-2022-647"
  },
  {
    "id": "3441316e-de6b-4504-b709-05dd1a15a73a",
    "slug": "rashed-tahlak-advocates-legal-consultants",
    "name": "RASHED TAHLAK ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFJUCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/31/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/30/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: RASHED TAHLAK ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3441316e-de6b-4504-b709-05dd1a15a73a",
        "address": "3 - مكتب رقم 310  ,بناية الجمعية التعاونية للاسكان والتعمير بدبي  ,جوار محكمة الاحوال الشخصية  ,212109 ,Dubai",
        "phone": "97142981222",
        "email": "rashid@tahlak-advocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "3 - مكتب رقم 310 ,بناية الجمعية التعاونية للا",
    "phone": "97142981222",
    "email": "rashid@tahlak-advocates.com",
    "registrationNumber": "ADF-2011-36"
  },
  {
    "id": "ec7c49dc-c9c8-4800-b91f-d9fdf344dff1",
    "slug": "rashid-abbas-advocates-legal-consultants",
    "name": "RASHID ABBAS ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFJBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/02/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/01/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: RASHID ABBAS ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ec7c49dc-c9c8-4800-b91f-d9fdf344dff1",
        "address": "Office No. 802 ,Al Ghanim Building 3 ,Makani No: 3092994922 ,000 ,Dubai",
        "phone": "97140000000 / 971501031116",
        "email": "rashidabbasadvocates@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Rashid Abbas Dadia Ghuloum Robari",
    "address": "Office No. 802,Al Ghanim Building 3,Al Muraqq",
    "phone": "97140000000",
    "email": "rashidabbasadvocates@gmail.com",
    "registrationNumber": "ADF-2024-743"
  },
  {
    "id": "8ea99c01-7cd1-44a3-84c3-8dd51ccf5908",
    "slug": "rashid-al-kaitoob-advocates-legal-cosultants",
    "name": "RASHID AL KAITOOB ADVOCATES & LEGAL COSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFJBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/21/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/20/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: RASHID AL KAITOOB ADVOCATES & LEGAL COSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8ea99c01-7cd1-44a3-84c3-8dd51ccf5908",
        "address": "",
        "phone": "97143595552",
        "email": "rashid.alkaitoob@rk-advocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Rashid Sultan Rashid Sultan Alkaitoob Alnuaimi",
    "address": "N/A",
    "phone": "97143595552",
    "email": "rashid.alkaitoob@rk-advocates.com",
    "registrationNumber": "ADF-2014-329"
  },
  {
    "id": "1db67184-8393-4efd-a82c-3b72528a605a",
    "slug": "rashid-alnagbi-advocates-legal-consultancy",
    "name": "RASHID ALNAGBI ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFJBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/14/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "01/13/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: RASHID ALNAGBI ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1db67184-8393-4efd-a82c-3b72528a605a",
        "address": "RASHID ALI ,2 ,DUBAI NATIONAL INSURACE  ,DEIRA CITY CENTER ,117277 ,Dubai",
        "phone": "97144214021 / 971551191143",
        "email": "ra_huraithi@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Rashid Ali Mohamed Alhuraithi Alnaqbi",
    "address": "2,DUBAI NATIONAL INSURACE ,PORT SAEED,Dubai,1",
    "phone": "97144214021",
    "email": "ra_huraithi@hotmail.com",
    "registrationNumber": "ADF-2018-438"
  },
  {
    "id": "750060a5-046b-4af5-b4ba-46d9c547184a",
    "slug": "rashid-deemas-alsuwaidi-advocates-legal-consultants",
    "name": "RASHID DEEMAS ALSUWAIDI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFJECiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/18/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/17/2024 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: RASHID DEEMAS ALSUWAIDI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_750060a5-046b-4af5-b4ba-46d9c547184a",
        "address": "Office No. 908 ,Owned by ACICO Gulf Real Estate Building ,Makani No: 3250094543 ,000 ,Dubai",
        "phone": "97143377688 / 971502883999",
        "email": "info@rds-law.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Rashid Ahmed Obaid Deemas Alsuwaidi",
    "address": "Office No. 908,Owned by ACICO Gulf Real Estat",
    "phone": "97143377688",
    "email": "info@rds-law.ae",
    "registrationNumber": "ADF-2022-645"
  },
  {
    "id": "8bea7298-efc4-496a-bda1-06dff28f4a69",
    "slug": "rashid-khalil-obaid-advocates-legal-consultants",
    "name": "RASHID KHALIL OBAID ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFJLCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/07/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/06/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: RASHID KHALIL OBAID ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8bea7298-efc4-496a-bda1-06dff28f4a69",
        "address": "Office No. 201 ,FRONDS BUILDING ,Makani No: 3273193073 ,000 ,Dubai",
        "phone": "97100000000",
        "email": "ro.legalconsultation@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Rashid Khalil Obaid Ali",
    "address": "Office No. 201,FRONDS BUILDING,AL GARHOUD,Dub",
    "phone": "97100000000",
    "email": "ro.legalconsultation@gmail.com",
    "registrationNumber": "ADF-2024-733"
  },
  {
    "id": "64d7de50-52a2-47b8-b964-f265348dacce",
    "slug": "rashid-shahin-advocates-legal-consultants",
    "name": "RASHID SHAHIN ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFJTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/05/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "07/04/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: RASHID SHAHIN ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_64d7de50-52a2-47b8-b964-f265348dacce",
        "address": "",
        "phone": "97100000000",
        "email": "info@rslaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97100000000",
    "email": "info@rslaw.ae",
    "registrationNumber": "ADF-2023-681"
  },
  {
    "id": "676fafb7-1ca5-46d2-943e-39c211542422",
    "slug": "raya-al-ameri-advocates-legal-consultants",
    "name": "RAYA AL AMERI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFJBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/12/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/11/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: RAYA AL AMERI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_676fafb7-1ca5-46d2-943e-39c211542422",
        "address": "",
        "phone": "97145786050 / 971509711102",
        "email": "info@emirates.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Raya Salem Suhail Awaidan Alameri",
    "address": "N/A",
    "phone": "97145786050",
    "email": "info@emirates.law",
    "registrationNumber": "ADF-2019-489"
  },
  {
    "id": "2c9d4a42-7cb3-4c95-88eb-2792bb07b395",
    "slug": "rayyan-advocates-legal-consultants",
    "name": "RAYYAN ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFJBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/05/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "07/04/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: RAYYAN ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2c9d4a42-7cb3-4c95-88eb-2792bb07b395",
        "address": "الطابق الثاني 206 ,باي سكوير رقم 11 ,دبي مول ,49793 ,Dubai",
        "phone": "97144518209 / 971506503353",
        "email": "info@rayyanadvo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "SALEM ABDULLA SULTAN ALI ALHAMMADI",
    "address": "الطابق الثاني 206,باي سكوير رقم 11,شارع مراسي",
    "phone": "97144518209",
    "email": "info@rayyanadvo.com",
    "registrationNumber": "ADF-2012-217"
  },
  {
    "id": "d544ee54-219a-446f-86c7-d6f4d1b1588c",
    "slug": "reem-saleh-advocates-legal-consultants",
    "name": "REEM SALEH ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFJTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/16/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/15/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: REEM SALEH ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d544ee54-219a-446f-86c7-d6f4d1b1588c",
        "address": "",
        "phone": "97142949937",
        "email": "info@rslawyers.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Reem Saleh Mahdi",
    "address": "N/A",
    "phone": "97142949937",
    "email": "info@rslawyers.ae",
    "registrationNumber": "ADF-2024-742"
  },
  {
    "id": "18906d5a-a350-4afa-be12-29a69a83b69b",
    "slug": "roya-alawadhi-advocates-legal-consultants",
    "name": "ROYA ALAWADHI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFJBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/03/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/02/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ROYA ALAWADHI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_18906d5a-a350-4afa-be12-29a69a83b69b",
        "address": "108 - Block B ,Saraya Avenue ,Near Al Dar University ,712 ,Dubai",
        "phone": "97142990995",
        "email": "info@royaalawadhi.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "108 - Block B,Saraya Avenue,65 street,Dubai,7",
    "phone": "97142990995",
    "email": "info@royaalawadhi.ae",
    "registrationNumber": "ADF-2014-325"
  },
  {
    "id": "49d8fc58-8bb3-4f84-8486-6aa5cd43e6ff",
    "slug": "rudha-alattar-advocates-legal-consultants",
    "name": "RUDHA ALATTAR ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFJBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/18/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/17/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: RUDHA ALATTAR ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_49d8fc58-8bb3-4f84-8486-6aa5cd43e6ff",
        "address": "",
        "phone": "97142776979",
        "email": "info@raadvocates.co",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Rudha Hussain Sayed Mohsin Alattar",
    "address": "N/A",
    "phone": "97142776979",
    "email": "info@raadvocates.co",
    "registrationNumber": "ADF-2014-314"
  },
  {
    "id": "9659cd0a-cae8-4cd6-b368-91211918771b",
    "slug": "ruqayya-mohammed-al-janaahi-advocates-legal-consultants",
    "name": "RUQAYYA MOHAMMED AL JANAAHI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFJNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/11/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/10/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: RUQAYYA MOHAMMED AL JANAAHI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9659cd0a-cae8-4cd6-b368-91211918771b",
        "address": "",
        "phone": "97142955545 / 971505199627",
        "email": "rj@aljanahiadvocate.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97142955545",
    "email": "rj@aljanahiadvocate.ae",
    "registrationNumber": "ADF-2024-751"
  },
  {
    "id": "18923100-5b94-44e2-b580-2e3b0cc17bf6",
    "slug": "saad-al-hammadi-advocates-legal-consultants",
    "name": "SAAD AL HAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/13/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/12/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SAAD AL HAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_18923100-5b94-44e2-b580-2e3b0cc17bf6",
        "address": "SAAD AL HAMMADI ,مدخل البرج ,ويست بيري ,برج خليفه ,41747 ,Dubai",
        "phone": "97142405222",
        "email": "info@saadpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Saad Mohammed Abdulla Al-Hammadi",
    "address": "مدخل البرج,ويست بيري,الخليج التجاري,Dubai,417",
    "phone": "97142405222",
    "email": "info@saadpartners.com",
    "registrationNumber": "ADF-2011-41"
  },
  {
    "id": "e9e9c3e3-c37e-43ae-b338-58589939c804",
    "slug": "sabeel-salem-advocates-legal-consultants",
    "name": "SABEEL SALEM ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/19/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/18/2019 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SABEEL SALEM ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e9e9c3e3-c37e-43ae-b338-58589939c804",
        "address": "",
        "phone": "97142369992",
        "email": "info@sabeeladvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97142369992",
    "email": "info@sabeeladvocates.ae",
    "registrationNumber": "ADF-2015-342"
  },
  {
    "id": "854c7388-093b-4e7c-b181-6a3d10225967",
    "slug": "saeed-al-dahmani-advocates-legal-consultants",
    "name": "SAEED AL DAHMANI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/03/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/02/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SAEED AL DAHMANI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_854c7388-093b-4e7c-b181-6a3d10225967",
        "address": "Office No. 216 ,Al Wasl Building ,Opposite Dubai Mall Metro Station; Makani No: 8853725508 ,000 ,Dubai",
        "phone": "97145708388",
        "email": "sa.legaladvo@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Saeed Khalfan Mohammed Ali Al Dahmani",
    "address": "Office No. 216,Al Wasl Building,Sheikh Zayed",
    "phone": "97145708388",
    "email": "sa.legaladvo@gmail.com",
    "registrationNumber": "ADF-2023-698"
  },
  {
    "id": "6136e013-f23c-455c-a7ed-8d017eb15356",
    "slug": "saeed-al-ghailani-advocate-legal-consultancy",
    "name": "SAEED AL GHAILANI ADVOCATE & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/26/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/25/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SAEED AL GHAILANI ADVOCATE & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6136e013-f23c-455c-a7ed-8d017eb15356",
        "address": "- ,- ,- ,00 ,Dubai",
        "phone": "97142502203",
        "email": "saed_ghailani@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Said Juma Saleh Mubarak Al-Ghelani",
    "address": "-,-,-,Dubai,00",
    "phone": "97142502203",
    "email": "saed_ghailani@hotmail.com",
    "registrationNumber": "ADF-2012-206"
  },
  {
    "id": "c0273ff0-aced-4d48-98fb-07c20ed5fbc2",
    "slug": "saeed-al-mheiri-advocates-legal-consultants",
    "name": "SAEED AL MHEIRI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/16/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SAEED AL MHEIRI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c0273ff0-aced-4d48-98fb-07c20ed5fbc2",
        "address": "Saeed almheiri  ,1907 ,Churchill tower 1 ,Bur Khalifa  ,37979 ,Dubai",
        "phone": "97143944183 / 971504544002",
        "email": "advocates@saeed-almheiri.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "saeed ali mohammad binqedad almheiri",
    "address": "2105,332 - API TRIO TOWERS - O,Al Barsha Firs",
    "phone": "97142725200",
    "email": "Info@saeed-almheiri.ae",
    "registrationNumber": "ADF-2023-703"
  },
  {
    "id": "bf78dc70-00fa-4098-8c14-62ac235bd5b2",
    "slug": "saeed-alawadhi-advocates-legal-consultants",
    "name": "SAEED ALAWADHI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/24/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/23/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SAEED ALAWADHI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bf78dc70-00fa-4098-8c14-62ac235bd5b2",
        "address": "",
        "phone": "97143430934",
        "email": "salegal.ae@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Saeed Ahmad Mohamed Mahmood Alawadhi",
    "address": "N/A",
    "phone": "97143430934",
    "email": "salegal.ae@gmail.com",
    "registrationNumber": "ADF-2023-667"
  },
  {
    "id": "9535b5d7-6a09-418c-b56b-edbf77856722",
    "slug": "saeed-albarq-advocate-legal-consultants",
    "name": "SAEED ALBARQ ADVOCATE & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/25/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "01/24/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SAEED ALBARQ ADVOCATE & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9535b5d7-6a09-418c-b56b-edbf77856722",
        "address": "6/601 ,SHAIK HAMDAN BUILDING ,ALTAWASEL RESTURANT ,22334 ,Dubai",
        "phone": "97142500012",
        "email": "lawpower2009@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "6/601,SHAIK HAMDAN BUILDING,ABU BAKER ALSIDDI",
    "phone": "97142500012",
    "email": "lawpower2009@gmail.com",
    "registrationNumber": "ADF-2012-85"
  },
  {
    "id": "5acd50c8-df41-496b-a969-926d40e45c46",
    "slug": "saeed-alghafri-advocates-legal-consultants",
    "name": "SAEED ALGHAFRI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/03/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/02/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SAEED ALGHAFRI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5acd50c8-df41-496b-a969-926d40e45c46",
        "address": "saeed ,310 & 311 ,business avenue ,منطقه بور سعيد التجاريه ,19410 ,Dubai",
        "phone": "97148868812",
        "email": "info@saeedalghafri.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "310 & 311,business avenue,Al Ittihad ,Dubai,1",
    "phone": "97148868812",
    "email": "info@saeedalghafri.ae",
    "registrationNumber": "ADF-2016-392"
  },
  {
    "id": "ce1aadbc-a1c1-4002-90eb-cfa12655b1d1",
    "slug": "saeed-alhashmi-advocates-legal-consultancy",
    "name": "SAEED ALHASHMI ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/22/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "07/21/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SAEED ALHASHMI ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ce1aadbc-a1c1-4002-90eb-cfa12655b1d1",
        "address": "203 ,BUSINESS VENUE BLDG ,TASHEEL ,444249 ,Dubai",
        "phone": "97145807964 / 971562302002",
        "email": "info@emirates-lawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Saeed Ibrahim Alsayed Ahmad Alhashimi",
    "address": "203,BUSINESS VENUE BLDG,UM HURAIR / OUD MEITH",
    "phone": "97145807964",
    "email": "info@emirates-lawyers.com",
    "registrationNumber": "ADF-2018-456"
  },
  {
    "id": "19abc134-e04a-4728-8b0b-04814e587c5b",
    "slug": "saeed-ali-taher-advocates-legal-consultants",
    "name": "SAEED ALI TAHER ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/05/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "01/04/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SAEED ALI TAHER ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_19abc134-e04a-4728-8b0b-04814e587c5b",
        "address": "",
        "phone": "97145686887 / 971000000000",
        "email": "info@satlawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Saeed Ali Mohamed Tahir",
    "address": "N/A",
    "phone": "97145686887",
    "email": "info@satlawfirm.ae",
    "registrationNumber": "ADF-2021-539"
  },
  {
    "id": "abb9efff-73d9-42e6-af59-29b92f4e2d09",
    "slug": "saeed-almuharrami-advocates-legal-consultants",
    "name": "SAEED ALMUHARRAMI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/04/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/03/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SAEED ALMUHARRAMI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_abb9efff-73d9-42e6-af59-29b92f4e2d09",
        "address": "الطابق الثالث -مكتب رقم 312  ,اعمار بزنس بارك -مبنى رقم 4  ,مصرف رأس الخيمة الوطنى ,336684 ,Dubai",
        "phone": "97144466072 / 971569807807",
        "email": "infobiadvocates@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Saeed Mohammed Saeed Khalifa Almuharrami",
    "address": "الطابق الثالث -مكتب رقم 312 ,اعمار بزنس بارك",
    "phone": "97144466072",
    "email": "infobiadvocates@gmail.com",
    "registrationNumber": "ADF-2016-393"
  },
  {
    "id": "c7f1e07b-8d68-4b46-bf95-a7d3fdf534c0",
    "slug": "saeed-alsharmi-advocates-legal-consultants",
    "name": "SAEED ALSHARMI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/27/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "02/26/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SAEED ALSHARMI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c7f1e07b-8d68-4b46-bf95-a7d3fdf534c0",
        "address": "الطابق الرابع 415 ,بزنس افنيو 515 ,ستي سنتر ديرة ,0000 ,Dubai",
        "phone": "97148345000 / 971506996499",
        "email": "INFO@ALSHARMILAW.COM",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Saeed Abdulla Khameis Alkhalawi Alsharmi",
    "address": "الطابق الرابع 415,بزنس افنيو 515,ديرة بورسعيد",
    "phone": "97148345000",
    "email": "INFO@ALSHARMILAW.COM",
    "registrationNumber": "ADF-2024-722"
  },
  {
    "id": "bdfc9a52-bffc-4712-acc9-96eb498c7238",
    "slug": "saeed-alsuwaidi-lawyers-legal-consultants",
    "name": "SAEED ALSUWAIDI LAWYERS & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/01/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/30/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SAEED ALSUWAIDI LAWYERS & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bdfc9a52-bffc-4712-acc9-96eb498c7238",
        "address": "saeed juma saeed alsuwaidi ,الثامن عشر مكتب 1801 ,almasraf tower ,بجوار بلدية دبي ,36997 ,Dubai",
        "phone": "97142567771",
        "email": "info@saeedalsuwaidi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "الثامن عشر مكتب 1801,almasraf tower,ديره- شار",
    "phone": "97142567771",
    "email": "info@saeedalsuwaidi.com",
    "registrationNumber": "ADF-2012-249"
  },
  {
    "id": "ef647e96-a648-4410-bb78-03c38a83d79e",
    "slug": "saeed-bin-ghulaita-advocates-legal-consultants",
    "name": "SAEED BIN GHULAITA ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNCCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/27/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "08/26/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SAEED BIN GHULAITA ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ef647e96-a648-4410-bb78-03c38a83d79e",
        "address": "saeed thani ben ghulaita ,الطابق الاول علوي رقم المكتب 109  ,التجاري ام الشيف  ,مطعم سلطان سراي ,398 ,Dubai",
        "phone": "97143333309 / 971502660044",
        "email": "saeedalmuhairi@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Saeed Thani Ali Khalifa Bin Ghulaita Almuhairi",
    "address": "الطابق الاول علوي رقم المكتب 109 ,التجاري ام",
    "phone": "97143333309",
    "email": "saeedalmuhairi@yahoo.com",
    "registrationNumber": "ADF-2018-460"
  },
  {
    "id": "3f85aa24-b612-477c-9af1-5067f3afda7d",
    "slug": "saeed-hatem-almenhali-and-associates-advocates-legal-consultants",
    "name": "SAEED HATEM ALMENHALI AND ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/28/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2025-10-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SAEED HATEM ALMENHALI AND ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3f85aa24-b612-477c-9af1-5067f3afda7d",
        "address": "Office No. 604 ,Gulf Commercial - Shoba Sapphire Building ,Makani No: 2612485764 ,000 ,Dubai",
        "phone": "97150411984 / 971504119844",
        "email": "s.almenhali.advocates@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Saeed Hatem Karama Almenhali",
    "address": "Office No. 604,Gulf Commercial - Shoba Sapphi",
    "phone": "97150411984",
    "email": "s.almenhali.advocates@gmail.com",
    "registrationNumber": "ADF-2024-748"
  },
  {
    "id": "b221d5d0-c8b1-4064-a7a5-84cf410fd408",
    "slug": "saeed-sulayem-advocates-legal-consultants",
    "name": "SAEED SULAYEM ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/20/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "12/22/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SAEED SULAYEM ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b221d5d0-c8b1-4064-a7a5-84cf410fd408",
        "address": "Saeed Sulayem Rashed Almazrouei ,M05 ,Al Durrah 4 ,Behind GGICO metro station ,11311 ,Dubai",
        "phone": "97143889000",
        "email": "info@sulayemlegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Saeed Sulayem Rashed Almazrouei",
    "address": "M05,Al Durrah 4,Garhoud,Dubai,11311",
    "phone": "97143889000",
    "email": "info@sulayemlegal.com",
    "registrationNumber": "ADF-2012-262"
  },
  {
    "id": "81bae066-e6a9-4931-b879-707d032a8ec5",
    "slug": "sahar-adnan-advocates-legal-consultants",
    "name": "SAHAR ADNAN ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/12/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/11/2025 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SAHAR ADNAN ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_81bae066-e6a9-4931-b879-707d032a8ec5",
        "address": "الدور 19 ,كونراد هوتيل ,كونراد هوتيل ,29799 ,Dubai",
        "phone": "",
        "email": "info.saharadvocates@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "الدور 19,كونراد هوتيل,الشيخ زايد,Dubai,29799",
    "phone": "N/A",
    "email": "info.saharadvocates@gmail.com",
    "registrationNumber": "ADF-2022-602"
  },
  {
    "id": "a1313be0-55e4-49d0-987d-98d1dd84db7e",
    "slug": "saif-alshamsi-advocates-and-legal-consultancy",
    "name": "SAIF ALSHAMSI ADVOCATES AND LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/26/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "02/17/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SAIF ALSHAMSI ADVOCATES AND LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a1313be0-55e4-49d0-987d-98d1dd84db7e",
        "address": "",
        "phone": "97145477552 / 971507474706",
        "email": "saifalshamsi.law@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Saif Ubaid Rashid Ubaid Al Shamsi",
    "address": "N/A",
    "phone": "97145477552",
    "email": "saifalshamsi.law@gmail.com",
    "registrationNumber": "ADF-2021-541- 1"
  },
  {
    "id": "ba81cc15-7448-4103-91bf-70c7e3f12812",
    "slug": "saif-sultan-almehrzi-advocates-legal-consultants",
    "name": "SAIF SULTAN ALMEHRZI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/10/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "02/09/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SAIF SULTAN ALMEHRZI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ba81cc15-7448-4103-91bf-70c7e3f12812",
        "address": "Office No. 211 ,Al Wasl Building ,Makani No: 2479487549 ,000 ,Dubai",
        "phone": "97142733476 / 97142733476",
        "email": "abo_sultan_s@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Saif Sultan Ali Almehrzi",
    "address": "Office No. 211,Al Wasl Building,Sheikh Zayed",
    "phone": "97142733476",
    "email": "abo_sultan_s@hotmail.com",
    "registrationNumber": "ADF-2023-655"
  },
  {
    "id": "1b4e6bd9-712b-49bf-a169-fd31ea45cd51",
    "slug": "salam-advocate-legal-consultants",
    "name": "SALAM ADVOCATE  & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/05/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/04/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SALAM ADVOCATE  & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1b4e6bd9-712b-49bf-a169-fd31ea45cd51",
        "address": "الخامس ,الشعلة بلوك اية ,داناتا ,127179 ,Dubai",
        "phone": "97143318888 / 971509984724",
        "email": "ameizar@salamadvo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "الخامس,الشعلة بلوك اية,بورسعيد,Dubai,127179",
    "phone": "97143318888",
    "email": "ameizar@salamadvo.com",
    "registrationNumber": "ADF-2011-21"
  },
  {
    "id": "5f03bc77-9f77-429d-96bf-c040a7037da1",
    "slug": "saleh-al-saleh-advocates-legal-consultants",
    "name": "SALEH AL SALEH ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/09/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/08/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SALEH AL SALEH ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5f03bc77-9f77-429d-96bf-c040a7037da1",
        "address": "",
        "phone": "97140000000 / 971504554699",
        "email": "salehalsalehadvo@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Saleh Abdulrahman Saif Abdulrahman Alsaleh",
    "address": "N/A",
    "phone": "97140000000",
    "email": "salehalsalehadvo@gmail.com",
    "registrationNumber": "ADF-2021-560"
  },
  {
    "id": "45c3eabb-348d-429a-98c8-35613c7f89fe",
    "slug": "salem-al-khateri-advocates-legal-consultants",
    "name": "SALEM AL KHATERI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/27/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/26/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SALEM AL KHATERI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_45c3eabb-348d-429a-98c8-35613c7f89fe",
        "address": "Block B, Office 711 ,Business Village Building ,Next to Clock Circle, Makani No: 9443231484 ,000 ,Dubai",
        "phone": "97144503646 / 971504282855",
        "email": "info@uaelawyers.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Salem Rashed Abdulla Muftah Alkhateri",
    "address": "Block B, Office 711,Business Village Building",
    "phone": "97144503646",
    "email": "info@uaelawyers.ae",
    "registrationNumber": "ADF-2023-697"
  },
  {
    "id": "710524e6-a0b5-44fe-929d-85bfc4bf27dc",
    "slug": "salem-alharthi-advocates-and-legal-consultants",
    "name": "SALEM ALHARTHI ADVOCATES AND & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/02/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/01/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SALEM ALHARTHI ADVOCATES AND & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_710524e6-a0b5-44fe-929d-85bfc4bf27dc",
        "address": "",
        "phone": "97143699967",
        "email": "advo@dsh-legal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97143699967",
    "email": "advo@dsh-legal.com",
    "registrationNumber": "ADF-2013-278"
  },
  {
    "id": "bf4b9303-d534-41b4-a671-e8c4a3f032bd",
    "slug": "salem-alkubaisi-advocates-legal-consultants",
    "name": "SALEM ALKUBAISI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/11/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "01/10/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SALEM ALKUBAISI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bf4b9303-d534-41b4-a671-e8c4a3f032bd",
        "address": "1-114 ,سيتى باى للاعمال ,مقابل المستشفى الكندى ,93075 ,Dubai",
        "phone": "97143853266 / 971506131373",
        "email": "salemalkubaisidubai@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Salem Saif Salem Al Kubaisi Al-Ali",
    "address": "1-114,سيتى باى للاعمال,ابو هيل,Dubai,93075",
    "phone": "97143853266",
    "email": "salemalkubaisidubai@gmail.com",
    "registrationNumber": "ADF-2018-434"
  },
  {
    "id": "6850aee4-bff6-42c3-a738-12cee3f47b0d",
    "slug": "salem-bin-bahyan-advocates-legal-consultancy",
    "name": "SALEM BIN BAHYAN ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNCCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/19/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/18/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SALEM BIN BAHYAN ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6850aee4-bff6-42c3-a738-12cee3f47b0d",
        "address": "Salem Bahyan ,1103 ,Latifa ,First Trade Center ,20611 ,Dubai",
        "phone": "97143214231 / 97145645961",
        "email": "info@bbadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Salem Hamad Bahyan Barout Alameri",
    "address": "1103,Latifa,Sheikh Zayed road,Dubai,20611",
    "phone": "97143214231",
    "email": "info@bbadvocates.com",
    "registrationNumber": "ADF-2017-429"
  },
  {
    "id": "c34580b3-9e80-4326-bd68-0eb2abbb06fc",
    "slug": "salha-albasti-advocates-legal-consultants",
    "name": "SALHA ALBASTI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/14/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "12/13/2025 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SALHA ALBASTI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c34580b3-9e80-4326-bd68-0eb2abbb06fc",
        "address": "5 ,tasheel bldg ,nasr club ,116749 ,Dubai",
        "phone": "97143970701",
        "email": "salha@albastiadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "5,tasheel bldg,um harir road,Dubai,116749",
    "phone": "97143970701",
    "email": "salha@albastiadvocates.com",
    "registrationNumber": "ADF-2014-332"
  },
  {
    "id": "851f7f37-c259-4afc-af8e-dbf6e9e86120",
    "slug": "salha-alkhallafi-advocates-legal-consultants",
    "name": "SALHA ALKHALLAFI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/16/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SALHA ALKHALLAFI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_851f7f37-c259-4afc-af8e-dbf6e9e86120",
        "address": "",
        "phone": "/ 971505588450",
        "email": "salha.kk@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Salha Khalifa Mohammed Al Khallafi",
    "address": "N/A",
    "phone": "N/A",
    "email": "salha.kk@hotmail.com",
    "registrationNumber": "ADF-2021-579"
  },
  {
    "id": "aaf3cbd8-7acd-4f76-b9b5-6a5794e8de26",
    "slug": "salma-alketbi-advocates-legal-consultants",
    "name": "SALMA ALKETBI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/29/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/28/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SALMA ALKETBI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_aaf3cbd8-7acd-4f76-b9b5-6a5794e8de26",
        "address": "SALMA SAEED MUSABBEH ALKETBI  ,الطابق الثالث ,بيراميد سنتر  ,وافي مول ,117452 ,Dubai",
        "phone": "97145484741 / 971508981112",
        "email": "info@salketbi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "الطابق الثالث,بيراميد سنتر ,منطقة عود ميثاء -",
    "phone": "97145484741",
    "email": "info@salketbi.com",
    "registrationNumber": "ADF-2020-502"
  },
  {
    "id": "b6a5205a-5af5-4847-aeaa-7f6c924a8ea6",
    "slug": "salwa-omar-advocates-legal-consultancy",
    "name": "SALWA OMAR ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNPCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/01/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "08/31/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SALWA OMAR ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b6a5205a-5af5-4847-aeaa-7f6c924a8ea6",
        "address": "",
        "phone": "97148769883 / 971048769883",
        "email": "info@salwaadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Salwa Mohammad Mohammad Omar",
    "address": "N/A",
    "phone": "97148769883",
    "email": "info@salwaadvocates.com",
    "registrationNumber": "ADF-2020-508"
  },
  {
    "id": "54ec8975-566c-41d9-929c-bb8b3dbcca1e",
    "slug": "sami-alsawalhi-advocates-and-legal-consultants",
    "name": "SAMI ALSAWALHI ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/21/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/20/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SAMI ALSAWALHI ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_54ec8975-566c-41d9-929c-bb8b3dbcca1e",
        "address": "",
        "phone": "97148818001",
        "email": "info@sqadvo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Sami Jamal Yousuf Abdulrahman Alsawalhi",
    "address": "N/A",
    "phone": "97148818001",
    "email": "info@sqadvo.com",
    "registrationNumber": "ADF-2022-604"
  },
  {
    "id": "195798f1-50a3-4188-9de2-ad54b9a70bb4",
    "slug": "samira-abdulla-ali-gargash-advocate-and-legal-consultants",
    "name": "SAMIRA ABDULLA ALI GARGASH ADVOCATE AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/10/2011",
    "licenseStatus": "active",
    "licenseExpiry": "2012-10-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SAMIRA ABDULLA ALI GARGASH ADVOCATE AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_195798f1-50a3-4188-9de2-ad54b9a70bb4",
        "address": "",
        "phone": "97144504430 / 97144504430",
        "email": "samira@samiragargash.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Samira Abdulla Ali Gargash"
  },
  {
    "id": "f31df5d9-3a8e-4129-a132-6bb30c924a15",
    "slug": "samira-alzarooni-advocates-and-legal-consultants",
    "name": "SAMIRA ALZAROONI ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/13/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/12/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SAMIRA ALZAROONI ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f31df5d9-3a8e-4129-a132-6bb30c924a15",
        "address": "samira ismail  ,الطابق التاسع - مكتب 902 ,برج سعيد 2 ,بنفس المبنى كنتاكي ,22223 ,Dubai",
        "phone": "97148873880 / 971585323296",
        "email": "info.zaroonilawyers@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Samira Ismail Mohamed Ahmed Alzarooni",
    "address": "الطابق التاسع - مكتب 902,برج سعيد 2,شارع الشي",
    "phone": "97148873880",
    "email": "info.zaroonilawyers@gmail.com",
    "registrationNumber": "ADF-2020-512"
  },
  {
    "id": "43903b58-f2e6-4825-beac-fd001ee7018a",
    "slug": "samya-saeed-advocates-legal-consultants",
    "name": "SAMYA SAEED ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/08/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SAMYA SAEED ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_43903b58-f2e6-4825-beac-fd001ee7018a",
        "address": "",
        "phone": "97142200399 / 971971422003",
        "email": "info@ssjlawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97142200399",
    "email": "info@ssjlawyers.com",
    "registrationNumber": "ADF-2021-573"
  },
  {
    "id": "10ab8c4c-bed3-4b47-8076-3b1a7b9615db",
    "slug": "saoud-mohamad-advocates-legal-consultants",
    "name": "SAOUD MOHAMAD ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/19/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/18/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SAOUD MOHAMAD ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_10ab8c4c-bed3-4b47-8076-3b1a7b9615db",
        "address": "",
        "phone": "97144356173 / 971509444622",
        "email": "saoud.m222@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97144356173",
    "email": "saoud.m222@gmail.com",
    "registrationNumber": "ADF-2020-530"
  },
  {
    "id": "9271d191-2f3e-4570-93bf-34fb919bf6e0",
    "slug": "sara-advocates-legal-consultancy",
    "name": "SARA ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/08/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/07/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SARA ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9271d191-2f3e-4570-93bf-34fb919bf6e0",
        "address": "Sara Shah Baik Elbloshi ,الطابق 13 - مكتب 1306 ,CLOVER BAY ,بجوار SONDER HOTEL ,112773 ,Dubai",
        "phone": "97143514666",
        "email": "admin@saraadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Sara Shah Baik Mohamad Albaloushi",
    "address": "الطابق 13 - مكتب 1306,CLOVER BAY,شارع السعادة",
    "phone": "97143514666",
    "email": "admin@saraadvocates.com",
    "registrationNumber": "ADF-2016-382"
  },
  {
    "id": "05d75e59-9d4d-4662-bfa2-7bab4d6085da",
    "slug": "sara-albaqishi-advocates-legal-consultancy",
    "name": "SARA ALBAQISHI ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/30/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/29/2019 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SARA ALBAQISHI ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_05d75e59-9d4d-4662-bfa2-7bab4d6085da",
        "address": "",
        "phone": "97143468388",
        "email": "albaqishilaw@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97143468388",
    "email": "albaqishilaw@gmail.com",
    "registrationNumber": "ADF-2017-408"
  },
  {
    "id": "c1be7ace-26d4-45ed-8292-e5992286f1ef",
    "slug": "sara-alsaedi-advocates-and-legal-consultants",
    "name": "Sara Alsaedi Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/04/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "02/03/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Sara Alsaedi Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c1be7ace-26d4-45ed-8292-e5992286f1ef",
        "address": "",
        "phone": "97150399980 / 971501547188",
        "email": "advocatesaraalsaedi@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Sara Helal Sulaiman Salem Alsaedi",
    "address": "N/A",
    "phone": "97150399980",
    "email": "advocatesaraalsaedi@gmail.com",
    "registrationNumber": "ADF-2020-495"
  },
  {
    "id": "f859d6ac-c6c4-4800-9053-0586a66732d2",
    "slug": "sara-ibrahim-advocates-legal-consultants",
    "name": "SARA IBRAHIM ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNJCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/28/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/27/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SARA IBRAHIM ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f859d6ac-c6c4-4800-9053-0586a66732d2",
        "address": "sara ibrahim  ,m1 ,ملك محمد عتيق احمد المري ,شارع المركاض ,14049 ,Dubai",
        "phone": "97142545233 / 971554080104",
        "email": "info@thecounsels.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Sara Ibrahim Ali Ahmed",
    "address": "m1,ملك محمد عتيق احمد المري,راس الخور الصناعي",
    "phone": "97142545233",
    "email": "info@thecounsels.ae",
    "registrationNumber": "ADF-2020-515"
  },
  {
    "id": "d0aa88d9-03fd-49f6-83da-bce7d0e19a17",
    "slug": "sarah-albaqishi-advocates-legal-consultants",
    "name": "SARAH ALBAQISHI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/12/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/11/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SARAH ALBAQISHI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d0aa88d9-03fd-49f6-83da-bce7d0e19a17",
        "address": "",
        "phone": "",
        "email": "albaqishilaw@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Sarah Yousef Abdulrahman Albaqishi Alabdouli",
    "address": "N/A",
    "phone": "N/A",
    "email": "albaqishilaw@gmail.com",
    "registrationNumber": "ADF-2022-601"
  },
  {
    "id": "d0e8d9f9-263d-4e8a-af05-984f0cc97149",
    "slug": "sat-co-advocates-legal-consultants",
    "name": "SAT & CO ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNDCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/16/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/15/2025 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SAT & CO ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d0e8d9f9-263d-4e8a-af05-984f0cc97149",
        "address": "الجناح الشمالي الطابق التاسع الوحدة 902 ,بنك المشرق جلوبال اتش كيه  ,برج خليفة  ,41422 ,Dubai",
        "phone": "97145514441",
        "email": "info@sat-law.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Salah Al Din Shahdad Wayed Al Balooshi",
    "address": "الجناح الشمالي الطابق التاسع الوحدة 902,بنك ا",
    "phone": "97145514441",
    "email": "info@sat-law.com",
    "registrationNumber": "ADF-2016-397"
  },
  {
    "id": "b3f35be9-7673-4d3f-954b-6f64de96bc2b",
    "slug": "saud-alshebli-advocates-legal-consultants",
    "name": "SAUD ALSHEBLI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/17/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/16/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SAUD ALSHEBLI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b3f35be9-7673-4d3f-954b-6f64de96bc2b",
        "address": "SAUD SULTAN HAMAD ,1st Floor ,AL GARHOOD BUSINESS CENTER ,Al Garhoud Medical Fitness Center ,21785 ,Dubai",
        "phone": "97143331110 / 971551127667",
        "email": "info@alshebliadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "1st Floor,AL GARHOOD BUSINESS CENTER,Al Garho",
    "phone": "97143331110",
    "email": "info@alshebliadvocates.ae",
    "registrationNumber": "ADF-2019-491"
  },
  {
    "id": "3885e377-9074-4ec7-bbae-db808d2d27b8",
    "slug": "saud-alzarooni-advocates-legal-consultants",
    "name": "SAUD ALZAROONI  ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/25/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/24/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SAUD ALZAROONI  ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3885e377-9074-4ec7-bbae-db808d2d27b8",
        "address": "SAUD AHMED ,الاول  مكتب 115 ,مكاتب عود ميثاء ,مقابل فندق رافلز  وخلف بناية ستي بنك  ,47700 ,Dubai",
        "phone": "97145476944 / 97142350070",
        "email": "info@salzarooni.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Saud Ahmed Abdelkarim Ismail Alzarooni",
    "address": "الاول  مكتب 115,مكاتب عود ميثاء, ام هرير الثا",
    "phone": "97145476944",
    "email": "info@salzarooni.com",
    "registrationNumber": "ADF-2019-465"
  },
  {
    "id": "51a05ad7-acb3-4d1a-9ec9-658d683dc4dc",
    "slug": "sendeyyah-alhantoobi-advocates-legal-consultants",
    "name": "SENDEYYAH ALHANTOOBI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/13/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "02/12/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SENDEYYAH ALHANTOOBI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_51a05ad7-acb3-4d1a-9ec9-658d683dc4dc",
        "address": "Second Floor - Office No. 202 ,Union Building ,Makani No: 3234793883 ,000 ,Dubai",
        "phone": "97140000000 / 971569848432",
        "email": "info@advsendeyyah.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Sendeyyah Ali Salem Hassan Alhantoobi",
    "address": "Second Floor - Office No. 202,Union Building,",
    "phone": "97140000000",
    "email": "info@advsendeyyah.com",
    "registrationNumber": "ADF-2025-761"
  },
  {
    "id": "2c2cba6d-fae5-429a-b197-7434c0a1d19d",
    "slug": "shaikh-rashid-bin-nasser-al-nuaimi-advocates-legal-consultants",
    "name": "SHAIKH RASHID BIN NASSER AL NUAIMI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNSCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/04/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "07/03/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SHAIKH RASHID BIN NASSER AL NUAIMI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2c2cba6d-fae5-429a-b197-7434c0a1d19d",
        "address": "مكتب رقم 303 ,NAEMA ALI BUAMIM رقم مكاني 2937992197 ,المركز التجاري الماليزي ,000 ,Dubai",
        "phone": "97144475234 / 971547447744",
        "email": "RASHIDALNUIMIEST@GMAIL.COM",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "SHEIKH RASHID NASSER RASHID HUMAID ALNUAIMI",
    "address": "مكتب رقم 303,NAEMA ALI BUAMIM رقم مكاني 29379",
    "phone": "97144475234",
    "email": "RASHIDALNUIMIEST@GMAIL.COM",
    "registrationNumber": "ADF-2023-678"
  },
  {
    "id": "80a47f20-166e-40d9-9dea-d793f4708270",
    "slug": "shaikha-ahmad-advocateslegal-consultants",
    "name": "SHAIKHA AHMAD ADVOCATES&LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/25/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "07/24/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SHAIKHA AHMAD ADVOCATES&LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_80a47f20-166e-40d9-9dea-d793f4708270",
        "address": "مكتب رقم 403 – 504 - 102 ,القرن الواحد وعشرون ,مركز القبائل للتخفيضات ,68441 ,Dubai",
        "phone": "97142388763",
        "email": "shaikha.advo@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "مكتب رقم 403 – 504 - 102,القرن الواحد وعشرون,",
    "phone": "97142388763",
    "email": "shaikha.advo@gmail.com",
    "registrationNumber": "ADF-2012-226"
  },
  {
    "id": "a63e5f0c-ffcb-4321-8f10-96802ff52a3e",
    "slug": "shaikha-almehrzi-advocates-legal-consultants",
    "name": "SHAIKHA ALMEHRZI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/12/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/11/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SHAIKHA ALMEHRZI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a63e5f0c-ffcb-4321-8f10-96802ff52a3e",
        "address": "TAMER YASER ALFAYAD  ,9 ,THE H HOTEL - COMPLEX ,THE H HOTEL ,72281 ,Dubai",
        "phone": "97143517909",
        "email": "dubai@lawhouse.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Shaikha Mohammed Saif Ali Al Mehrzi",
    "address": "9,THE H HOTEL - COMPLEX,TRADE CENTER FIRST ,D",
    "phone": "97143517909",
    "email": "dubai@lawhouse.ae",
    "registrationNumber": "ADF-2013-279"
  },
  {
    "id": "89bb61d6-b0b9-4316-8983-c9a88f94a1e8",
    "slug": "shaikha-saqer-almansoori-advocates-legal-consultants",
    "name": "Shaikha Saqer Almansoori Advocates & Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/12/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/11/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Shaikha Saqer Almansoori Advocates & Legal Consultants",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_89bb61d6-b0b9-4316-8983-c9a88f94a1e8",
        "address": "",
        "phone": "97143333040 / 971000000000",
        "email": "info@ssm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Shaikha Saqer Saif Saleh Almansoori",
    "address": "N/A",
    "phone": "97143333040",
    "email": "info@ssm.ae",
    "registrationNumber": "ADF-2021-566"
  },
  {
    "id": "8803af03-8167-4a6e-806b-62cf3ec20afb",
    "slug": "shamsa-albedwawi-advocates-legal-consultants",
    "name": "SHAMSA ALBEDWAWI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/09/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/08/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SHAMSA ALBEDWAWI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8803af03-8167-4a6e-806b-62cf3ec20afb",
        "address": "",
        "phone": "97145872888 / 971556022223",
        "email": "Shamsa@shadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97145872888",
    "email": "Shamsa@shadvocates.com",
    "registrationNumber": "ADF-2021-546"
  },
  {
    "id": "b5f1d60b-df9b-4054-ac59-4543a6d06af4",
    "slug": "shouq-alkathiri-advocates-legal-consultants",
    "name": "SHOUQ ALKATHIRI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/12/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/11/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SHOUQ ALKATHIRI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b5f1d60b-df9b-4054-ac59-4543a6d06af4",
        "address": "HASSAN AL BAKRI ,16 ,THE EXCHANGE TOWER ,DUBAI WATER CANAL ,89179 ,Dubai",
        "phone": "97145807888",
        "email": "secretary@alkathirilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Shouq Mohsen Bader AlKethiri",
    "address": "16,THE EXCHANGE TOWER,BUSINESS BAY,Dubai,8917",
    "phone": "97145807888",
    "email": "secretary@alkathirilaw.com",
    "registrationNumber": "ADF-2012-193"
  },
  {
    "id": "78c43380-32d9-4a67-b4df-cf726a455430",
    "slug": "suad-mohamed-advocates-legal-consultants",
    "name": "SUAD MOHAMED ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/13/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/12/2025 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SUAD MOHAMED ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_78c43380-32d9-4a67-b4df-cf726a455430",
        "address": "SUAD MOHAMMED ,Mezzanine102-08 ,ملك الشيخة مهره احمد الغرير ,Al Tawar Center ,446009 ,Dubai",
        "phone": "97145477711 / 971558800890",
        "email": "suad.lawyer@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "Mezzanine102-08,ملك الشيخة مهره احمد الغرير,T",
    "phone": "97145477711",
    "email": "suad.lawyer@hotmail.com",
    "registrationNumber": "ADF-2021-553"
  },
  {
    "id": "762ae1a5-2cc6-418c-a6fd-6e195fe7234d",
    "slug": "suhad-aljuboori-advocates-legal-consultants",
    "name": "SUHAD ALJUBOORI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/06/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/05/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SUHAD ALJUBOORI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_762ae1a5-2cc6-418c-a6fd-6e195fe7234d",
        "address": "SUHAD FADHIL JABBAR MAHADI ALJUBOORI  ,1602 ,ذا اتش ,المركز التجارى الاول  ,99827 ,Dubai",
        "phone": "97142711100 / 971508661717",
        "email": "sj@suhadaljuboorilawfirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "1602,ذا اتش,ش الشيخ زايد,Dubai,99827",
    "phone": "97142711100",
    "email": "sj@suhadaljuboorilawfirm.com",
    "registrationNumber": "ADF-2018-447"
  },
  {
    "id": "3f71c0fe-93b9-4bea-82c4-fad46b21e883",
    "slug": "suhaila-almarzooqi-advocates-legal-consultants",
    "name": "SUHAILA ALMARZOOQI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/17/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/16/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SUHAILA ALMARZOOQI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3f71c0fe-93b9-4bea-82c4-fad46b21e883",
        "address": "",
        "phone": "97144531888 / 971971445318",
        "email": "info@suhaila.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Suhaila Yousuf Moosa Almarzooqi",
    "address": "N/A",
    "phone": "97144531888",
    "email": "info@suhaila.ae",
    "registrationNumber": "ADF-2022-599"
  },
  {
    "id": "d10fb0e9-ccd7-4ac9-8f58-e21ff0d7d2f2",
    "slug": "sulaiman-al-naqbi-advocates-legal-consultants",
    "name": "SULAIMAN AL NAQBI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/24/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/23/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SULAIMAN AL NAQBI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d10fb0e9-ccd7-4ac9-8f58-e21ff0d7d2f2",
        "address": "SULAIMAN ALNAQBI ,5 ,Emaar Business Park 1 ,Emaar Business Park 1 ,0000 ,Dubai",
        "phone": "",
        "email": "hsrgro@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "5,Emaar Business Park 1,AL Thanyah Tird,Dubai",
    "phone": "N/A",
    "email": "hsrgro@gmail.com",
    "registrationNumber": "ADF-2017-414"
  },
  {
    "id": "0e62e480-e84f-4560-8f59-ad0f1a6cbbad",
    "slug": "sulaiman-alshebli-advocates-and-legal-consultants",
    "name": "Sulaiman Alshebli Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/24/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/23/2025 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Sulaiman Alshebli Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0e62e480-e84f-4560-8f59-ad0f1a6cbbad",
        "address": "",
        "phone": "97142693680",
        "email": "info@sas-advocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Suliman Saleh Ali Salem Al Shebli",
    "address": "N/A",
    "phone": "97142693680",
    "email": "info@sas-advocates.com",
    "registrationNumber": "ADF-2022-606"
  },
  {
    "id": "cef52068-add5-4e5a-83c8-600f746d48e3",
    "slug": "sulaiman-salem-alkarbi-advocates-and-legal-consultants",
    "name": "SULAIMAN SALEM ALKARBI ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/05/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/04/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SULAIMAN SALEM ALKARBI ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cef52068-add5-4e5a-83c8-600f746d48e3",
        "address": "",
        "phone": "97145686887 / 971566665693",
        "email": "info@alkirbilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Sulaiman Salem Mohammed Zaid Alkarbi",
    "address": "N/A",
    "phone": "97145686887",
    "email": "info@alkirbilaw.com",
    "registrationNumber": "ADF-2021-559"
  },
  {
    "id": "71f6bdc3-3543-4f76-97c4-2d3113da5a11",
    "slug": "tareq-thabit-advocates-legal-consultants",
    "name": "TAREQ THABIT ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFRUCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/05/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2024-04-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: TAREQ THABIT ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_71f6bdc3-3543-4f76-97c4-2d3113da5a11",
        "address": "الثالث ,بناية الجوهرة  ,مركز برجمان ,635 ,Dubai",
        "phone": "/ 971505777314",
        "email": "tariqthabit1975@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Tareq Natheer Saleh Thabit",
    "address": "الثالث,بناية الجوهرة ,شارع خالد بن الوليد,Dub",
    "phone": "N/A",
    "email": "tariqthabit1975@gmail.com",
    "registrationNumber": "ADF-2023-692"
  },
  {
    "id": "ca640589-e7ab-45e9-8d6e-52a161a80279",
    "slug": "tarish-almansoori-advocates-legal-consultants",
    "name": "TARISH ALMANSOORI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFRBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/31/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/30/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: TARISH ALMANSOORI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ca640589-e7ab-45e9-8d6e-52a161a80279",
        "address": "14th Floor, No.2 ,Al Burj Al Salam ,Makani No: 27412 91443 ,000 ,Dubai",
        "phone": "97148823210 / 971565301153",
        "email": "info@tarishlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Tarish Eid Mohammed Bin Ghuwaifa Almansoori",
    "address": "14th Floor, No.2,Al Burj Al Salam,Sheikh Road",
    "phone": "97148823210",
    "email": "info@tarishlaw.com",
    "registrationNumber": "ADF-2024-750"
  },
  {
    "id": "ca5e0fcb-5014-42d5-ba5a-e405395a2d30",
    "slug": "test",
    "name": "test",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFRFCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/12/2023",
    "licenseStatus": "active",
    "licenseExpiry": "2024-12-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: test",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ca5e0fcb-5014-42d5-ba5a-e405395a2d30",
        "address": "",
        "phone": "97100000000",
        "email": "as@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Test AD1"
  },
  {
    "id": "39ca834a-2d19-42ff-9625-e989d9c3a682",
    "slug": "thamer-ali-beljafla-advocates-and-legal-consultants",
    "name": "THAMER ALI BELJAFLA ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFRBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/24/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/23/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: THAMER ALI BELJAFLA ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_39ca834a-2d19-42ff-9625-e989d9c3a682",
        "address": "",
        "phone": "",
        "email": "thamerbeljaflalawyer@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Thamer Ali Khamis Khalfan Beljafla",
    "address": "N/A",
    "phone": "N/A",
    "email": "thamerbeljaflalawyer@gmail.com",
    "registrationNumber": "ADF-2023-00709"
  },
  {
    "id": "b0e9ddc9-f4a3-4647-97ae-dc4ca90bcb6c",
    "slug": "the-advocates",
    "name": "THE ADVOCATES",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFECiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/05/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/04/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: THE ADVOCATES",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b0e9ddc9-f4a3-4647-97ae-dc4ca90bcb6c",
        "address": "KHALED AHMED ABDULLA AHMED ,24 ,Clover Bay ,SAAS Tower  ,288 ,Dubai",
        "phone": "97143453233",
        "email": "info@theadvocates.io",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "24,Clover Bay,Business Bay,Dubai,288",
    "phone": "97143453233",
    "email": "info@theadvocates.io",
    "registrationNumber": "ADF-2022-629"
  },
  {
    "id": "931ca6f7-8621-4da0-9545-a993725337e0",
    "slug": "the-attornies-advocates-legal-consultant",
    "name": "THE ATTORNIES ADVOCATES & LEGAL CONSULTANT",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/16/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/15/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: THE ATTORNIES ADVOCATES & LEGAL CONSULTANT",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_931ca6f7-8621-4da0-9545-a993725337e0",
        "address": "",
        "phone": "97143433300",
        "email": "info@theattorneys.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Abdulla Mohammed Abdulla AbdulRahman Al Bannai",
    "address": "N/A",
    "phone": "97143433300",
    "email": "info@theattorneys.ae",
    "registrationNumber": "ADF-2011-43"
  },
  {
    "id": "30f935cb-bbe9-41cc-95a7-f12ee003b96e",
    "slug": "the-future-advocates-legal-consultants",
    "name": "THE FUTURE ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEZBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/13/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/12/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: THE FUTURE ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_30f935cb-bbe9-41cc-95a7-f12ee003b96e",
        "address": "Salah Abdelkarim Abdellah Alhamadani ,1st Floor, Office F46 ,Warba Centre ,Al Muraqqabat Police Station ,12898 ,Dubai",
        "phone": "97142963333",
        "email": "salah653@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Salah Abdelkerim Abdelelah Alhamadani",
    "address": "1st Floor, Office F46,Warba Centre,Abu Baker",
    "phone": "97142963333",
    "email": "salah653@hotmail.com",
    "registrationNumber": "ADF-2012-118"
  },
  {
    "id": "74f923b2-ef17-48a4-9af4-e15ddacb5e0e",
    "slug": "the-legal-group-advocates-legal-consultants",
    "name": "THE LEGAL GROUP- ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIExHCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/25/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "07/24/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: THE LEGAL GROUP- ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_74f923b2-ef17-48a4-9af4-e15ddacb5e0e",
        "address": "Saif Saeed Rashid Alghubar Alshamsi ,الطابق 3 مكتب E313  ,مكاتب الساحة ب  ,برج خليفة ,20338 ,Dubai",
        "phone": "97144477044 / 971551630600",
        "email": "info@tlg.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Saif Saeed Rashid Al Gubar Al Shamsi",
    "address": "الطابق 3 مكتب E313 ,مكاتب الساحة ب ,سوق البحا",
    "phone": "97144477044",
    "email": "info@tlg.ae",
    "registrationNumber": "ADF-2012-228"
  },
  {
    "id": "109f3fc4-62e8-4523-9372-95aaf9a76483",
    "slug": "union-advocates-legal-consultants",
    "name": "UNION ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFVBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/08/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "02/07/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: UNION ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_109f3fc4-62e8-4523-9372-95aaf9a76483",
        "address": "first/105 ,Al Shafar Investment ,noor bank metro station ,34655 ,Dubai",
        "phone": "97143386111",
        "email": "unionadvocates1@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "mohamed yousef ahmed mohamed alyousef",
    "address": "first/105,Al Shafar Investment,sheikh zayed r",
    "phone": "97143386111",
    "email": "unionadvocates1@gmail.com",
    "registrationNumber": "ADF-2012-92"
  },
  {
    "id": "52ebf695-ce46-4e03-abc9-f4d8d2f8a356",
    "slug": "united-advocates",
    "name": "UNITED ADVOCATES",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFVBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/26/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/25/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: UNITED ADVOCATES",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_52ebf695-ce46-4e03-abc9-f4d8d2f8a356",
        "address": "3902 ,single business tower ,Sheikh Zayed Rd.  ,90077 ,Dubai",
        "phone": "97143804141 / 97143804141",
        "email": "info@united-advocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Abdulla Mohamed Ali Al Zari Al Shamsi",
    "address": "3902,single business tower,Business Bay,Dubai",
    "phone": "97143804141",
    "email": "info@united-advocates.com",
    "registrationNumber": "ADF-2011-06"
  },
  {
    "id": "cff602ab-b742-4297-bd86-07e92f2bf607",
    "slug": "wafa-ali-alhosanyi-advocates-legal-consultants",
    "name": "WAFA ALI ALHOSANYI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFdBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/04/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "02/03/2025 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: WAFA ALI ALHOSANYI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cff602ab-b742-4297-bd86-07e92f2bf607",
        "address": "WAFA_ALI_ALHOSANY ,الطابق الأول - مكتب 110 ,مجمع محكمة التمييز  ,محاكم دبي  ,0000 ,Dubai",
        "phone": "97155828080 / 971507329805",
        "email": "777lawyer.wafa@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "الطابق الأول - مكتب 110,مجمع محكمة التمييز ,ا",
    "phone": "97155828080",
    "email": "777lawyer.wafa@gmail.com",
    "registrationNumber": "ADF-2021-544"
  },
  {
    "id": "b96dccbc-837b-4d8b-9f42-3bb6ac9a07c0",
    "slug": "wala-jaber-alrahma-advocates-legal-consultants",
    "name": "WALA JABER ALRAHMA ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFdKCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/27/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: WALA JABER ALRAHMA ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b96dccbc-837b-4d8b-9f42-3bb6ac9a07c0",
        "address": "Second Floor - A 202 ,Golf Tower ,Makani No: 3064392025 ,000 ,Dubai",
        "phone": "97100000000 / 97100000000",
        "email": "Walaalrahma@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "wala Jaber Nasser saleh Alrahma",
    "address": "Second Floor - A 202,Golf Tower,Oud Metha,Dub",
    "phone": "97100000000",
    "email": "Walaalrahma@gmail.com",
    "registrationNumber": "ADF-2022-651"
  },
  {
    "id": "332a3a67-50f2-424a-a5c1-d5abaf9a030b",
    "slug": "waleed-almarzooqi-and-khalid-mohamed-advocates-and-legal-consultants",
    "name": "WALEED ALMARZOOQI AND KHALID MOHAMED ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFdBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/08/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/07/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: WALEED ALMARZOOQI AND KHALID MOHAMED ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_332a3a67-50f2-424a-a5c1-d5abaf9a030b",
        "address": "الطابق 33/ الوحدة : 3304 ,مبني المنارة /   الطابق 33/ الوحدة : 3304 ,فندق جي دبليو ماركيز  ,24002 ,Dubai",
        "phone": "97144254373",
        "email": "info@wkadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Waleed Mohamed Husain Ahmed AlMarzooqi",
    "address": "الطابق 33/ الوحدة : 3304,مبني المنارة /   ا",
    "phone": "97144254373",
    "email": "info@wkadvocates.ae",
    "registrationNumber": "ADF-2016-383"
  },
  {
    "id": "54c8ea54-1d98-4e28-8dc3-288bbc4098a1",
    "slug": "walid-bin-theban-advocates-legal-consultants",
    "name": "WALID BIN THEBAN ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFdCCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/31/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/30/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: WALID BIN THEBAN ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_54c8ea54-1d98-4e28-8dc3-288bbc4098a1",
        "address": "",
        "phone": "",
        "email": "walidalfalasi@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Walid Humaid Bin Theyban Alfalasi",
    "address": "N/A",
    "phone": "N/A",
    "email": "walidalfalasi@gmail.com",
    "registrationNumber": "ADF-2012-182"
  },
  {
    "id": "00c4764a-95da-417c-bdfc-8bafd4ff9fca",
    "slug": "world-center-advocates-legal-consultants",
    "name": "WORLD CENTER ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFdDCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/21/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "02/20/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: WORLD CENTER ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_00c4764a-95da-417c-bdfc-8bafd4ff9fca",
        "address": "",
        "phone": "97145539555",
        "email": "world-center@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Bader Abdulla Khamis Abdulla",
    "address": "N/A",
    "phone": "97145539555",
    "email": "world-center@hotmail.com",
    "registrationNumber": "ADF-2012-99"
  },
  {
    "id": "3e828642-9baf-47a6-a42a-320c714638bf",
    "slug": "yaqoub-almaazmi-advocates-legal-consultants",
    "name": "YAQOUB ALMAAZMI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFlBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/17/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "02/16/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: YAQOUB ALMAAZMI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3e828642-9baf-47a6-a42a-320c714638bf",
        "address": "Yaqoub Almaamzi ,6th Floor, office 606 ,Building 1 A ,Near Dubai Mall ,554801 ,Dubai",
        "phone": "97145686523 / 971000000000",
        "email": "info@almazmy.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Yaqoub Mohamed Murad Abdulrahman Almaazmi",
    "address": "6th Floor, office 606,Building 1 A,Dubai Desi",
    "phone": "97145686523",
    "email": "info@almazmy.com",
    "registrationNumber": "ADF-2021-545"
  },
  {
    "id": "af6ac730-58a7-44a4-9f60-78811de374c7",
    "slug": "yasin-alhamed-advocates-legal-consultants",
    "name": "YASIN ALHAMED ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFlBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/10/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/09/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: YASIN ALHAMED ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_af6ac730-58a7-44a4-9f60-78811de374c7",
        "address": "",
        "phone": "97142955575",
        "email": "info@yalhamed.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97142955575",
    "email": "info@yalhamed.com",
    "registrationNumber": "ADF-2015-340"
  },
  {
    "id": "5e5426f9-6497-4993-ba14-59bbfd263c0f",
    "slug": "yaslem-al-sadi-advocate-legal-consultant",
    "name": "YASLEM AL SADI ADVOCATE & LEGAL CONSULTANT",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFlBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/03/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "07/02/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: YASLEM AL SADI ADVOCATE & LEGAL CONSULTANT",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5e5426f9-6497-4993-ba14-59bbfd263c0f",
        "address": "",
        "phone": "97143808881 / 971505256777",
        "email": "legal@alyafee.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Yaslem Saleh Ahmed Al-Sadi",
    "address": "N/A",
    "phone": "97143808881",
    "email": "legal@alyafee.com",
    "registrationNumber": "ADF-2012-214"
  },
  {
    "id": "27278b02-4edf-490f-9d50-a1bc00678b6a",
    "slug": "younis-mohammed-al-blooshi-lawyer-legal-consultants",
    "name": "YOUNIS MOHAMMED AL BLOOSHI LAWYER & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFlNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/29/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/30/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: YOUNIS MOHAMMED AL BLOOSHI LAWYER & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_27278b02-4edf-490f-9d50-a1bc00678b6a",
        "address": "YOUNIS MOHAMMED ALBLOOSHI ,3 - 1 ,the icon ,السيلكون ,117548 ,Dubai",
        "phone": "97145693206 / 971000000000",
        "email": "info@yblooshiadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Younis Mohamed Abdalla Hassan Alblooshi",
    "address": "3 - 1,the icon,ند حصا,Dubai,117548",
    "phone": "97145693206",
    "email": "info@yblooshiadvocates.com",
    "registrationNumber": "ADF-2020-516"
  },
  {
    "id": "59aaa82d-162e-4646-9bcc-f3349dfb2512",
    "slug": "yousef-almaazmi-advocates-legal-consultants",
    "name": "YOUSEF ALMAAZMI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFlBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/22/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/21/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: YOUSEF ALMAAZMI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_59aaa82d-162e-4646-9bcc-f3349dfb2512",
        "address": "yousif almaazmi ,التاسع  ,سيتاديل تاور  ,خلف فندق جي دبليوماريوت  ,94646 ,Dubai",
        "phone": "97144517744",
        "email": "info@cityint.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Yousef Mohammed Ibrahim Abdulla",
    "address": "التاسع ,سيتاديل تاور ,الابراج ,Dubai,94646",
    "phone": "97144517744",
    "email": "info@cityint.com",
    "registrationNumber": "ADF-2012-128"
  },
  {
    "id": "4ac59896-a747-47f0-931f-b7f0e54e27c6",
    "slug": "yousif-al-ali-advocates-and-legal-consultants",
    "name": "YOUSIF AL ALI ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFlBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/24/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/23/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: YOUSIF AL ALI ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4ac59896-a747-47f0-931f-b7f0e54e27c6",
        "address": "lujain waleed ,2 ,AL Bakhit Center ,Next to Abu Dhabi First Bank ,14916 ,Dubai",
        "phone": "97142977706",
        "email": "yousefa3@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Yousuf Ahmed Ali Al Ali",
    "address": "2,AL Bakhit Center,AL Muraqqabat Road,Dubai,1",
    "phone": "97142977706",
    "email": "yousefa3@emirates.net.ae",
    "registrationNumber": "ADF-2012-151"
  },
  {
    "id": "b2331b5f-91be-4205-ad5c-6af317f654a4",
    "slug": "yousif-alhammadi-advocates-legal-consultancy",
    "name": "YOUSIF ALHAMMADI ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFlBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/01/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/30/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: YOUSIF ALHAMMADI ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b2331b5f-91be-4205-ad5c-6af317f654a4",
        "address": "yousif alhammadi ,الخامس 513،514 ,بيزنس افينيو ,وكالة نيسان ,414145 ,Dubai",
        "phone": "97143307771",
        "email": "yousifadv@alhammadilegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Yousif Mohamed Ahmed Yousif Alhammadi",
    "address": "الخامس 513،514,بيزنس افينيو,منطقة بورسعيد /دي",
    "phone": "97143307771",
    "email": "yousifadv@alhammadilegal.ae",
    "registrationNumber": "ADF-2015-356"
  },
  {
    "id": "28be4513-86ae-4602-b4cc-8d52ba959e9e",
    "slug": "yousuf-al-sharif-advocates-legal-consultants",
    "name": "YOUSUF AL SHARIF ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFlBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/19/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: YOUSUF AL SHARIF ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_28be4513-86ae-4602-b4cc-8d52ba959e9e",
        "address": "",
        "phone": "97142566660",
        "email": "dlr@ysalc.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Yousef Abdulghaffar Abdulrahman AL-Shreif",
    "address": "N/A",
    "phone": "97142566660",
    "email": "dlr@ysalc.ae",
    "registrationNumber": "ADF-2011-70"
  },
  {
    "id": "8d0af4a8-053e-49f9-bed7-795d52e23286",
    "slug": "yousuf-bin-hammad-associates-advocates-legal-consultants",
    "name": "YOUSUF BIN HAMMAD & ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFlCCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/17/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/16/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: YOUSUF BIN HAMMAD & ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8d0af4a8-053e-49f9-bed7-795d52e23286",
        "address": "",
        "phone": "97142220011",
        "email": "info@hammad.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Yousef Khalifa Ahmad Bin Hammad Almarri",
    "address": "N/A",
    "phone": "97142220011",
    "email": "info@hammad.ae",
    "registrationNumber": "ADF-2012-177"
  },
  {
    "id": "295c7198-77b4-4f9a-a4d2-bad9a78e074d",
    "slug": "zayed-al-shamsi-advocates-legal-consultants",
    "name": "ZAYED AL SHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFpBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/26/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/27/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ZAYED AL SHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_295c7198-77b4-4f9a-a4d2-bad9a78e074d",
        "address": "zayed saeed saif alshamsi ,الرابع مكتب رقم 414 ,قرية الاعمال ,بجانب دائرة التنمية الاقتصادية - دوار الساعة  ,6030 ,Dubai",
        "phone": "97142680800",
        "email": "info@zayedalshamsi.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "Zayed Saeed Saif Saeed Al-Shamsi",
    "address": "الرابع مكتب رقم 414,قرية الاعمال,بور سعيد,Dub",
    "phone": "97142680800",
    "email": "info@zayedalshamsi.ae",
    "registrationNumber": "ADF-2012-147"
  },
  {
    "id": "1266128b-21ba-400a-98b8-cef5142128d1",
    "slug": "zayed-al-shehhi-advocates-legal-consultants",
    "name": "ZAYED AL SHEHHI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFpBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/27/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/26/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ZAYED AL SHEHHI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1266128b-21ba-400a-98b8-cef5142128d1",
        "address": "",
        "phone": "97142566000 / 971567346502",
        "email": "info@zayedalshehhi-adv.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97142566000",
    "email": "info@zayedalshehhi-adv.ae",
    "registrationNumber": "ADF-2012-209"
  },
  {
    "id": "2dfa7ef4-9fdc-41b0-96fa-6bb79c7ca596",
    "slug": "zayed-almazrouei-advocates-legal-consultants",
    "name": "ZAYED ALMAZROUEI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFpBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/29/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/28/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ZAYED ALMAZROUEI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2dfa7ef4-9fdc-41b0-96fa-6bb79c7ca596",
        "address": "",
        "phone": "97142366520 / 971506177071",
        "email": "zayed@zayedlegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "ZAYED MATAR KHAMIS KHALFAN ALMAZROUEI",
    "address": "N/A",
    "phone": "97142366520",
    "email": "zayed@zayedlegal.ae",
    "registrationNumber": "ADF-2024-728"
  },
  {
    "id": "fd86842c-ebb0-4c94-b81a-5fc571367af7",
    "slug": "zubaida-bin-hendi-advocates-legal-consultants",
    "name": "ZUBAIDA BIN HENDI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFpCCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/01/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2025-03-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ZUBAIDA BIN HENDI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fd86842c-ebb0-4c94-b81a-5fc571367af7",
        "address": "",
        "phone": "97143979948",
        "email": "info@zbh-lawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "owner": "zubaida mubarak bin hendi",
    "address": "N/A",
    "phone": "97143979948",
    "email": "info@zbh-lawfirm.ae",
    "registrationNumber": "ADF-2024-726"
  },
  {
    "id": "13ef60e9-93aa-4118-937c-43385ae6c7b4",
    "slug": "abdalla-alzaabi-legal-consultants-llc",
    "name": "SAID ABOUELMAKAREMALIGOMAA",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "07/11/2024 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Abdalla AlZaabi Legal Consultants L.L.C",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_13ef60e9-93aa-4118-937c-43385ae6c7b4",
        "address": "Office No.WH2-04A-M-52 ,P2/Block A ,Saih Shuaib 3 ,000 ,Dubai",
        "phone": "97140000000 / 971525525252",
        "email": "alzaabbi@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "سعيد ابو المكارم على جمعه",
    "address": "-",
    "phone": "97140000000",
    "email": "alzaabbi@gmail.com",
    "registrationNumber": "-"
  },
  {
    "id": "1ae95666-08c9-4857-b2b4-480be766b063",
    "slug": "acker-choquette-legal-consultants",
    "name": "Mohammad Alsaboosi Legal Advice",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFDCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 28,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "12/07/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Acker Choquette Legal Consultants",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1ae95666-08c9-4857-b2b4-480be766b063",
        "address": "",
        "phone": "97143550004 / 971506246248",
        "email": "canlaw@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "-",
    "address": "Office No.5-A 28, Bin Dasmal Building, Al Goze Industrial First, Dubai, UNITED ARAB EMIRATES",
    "phone": "97143550004",
    "email": "canlaw@emirates.net.ae",
    "registrationNumber": "-"
  },
  {
    "id": "8690f7d5-6b96-4649-9589-71303f2c2707",
    "slug": "addleshaw-goddard-middle-east-llp",
    "name": "Addleshaw Goddard (Middle East) LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFHCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/24/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/15/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Addleshaw Goddard (Middle East) LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8690f7d5-6b96-4649-9589-71303f2c2707",
        "address": "6 ,Office Nos. 603, 604 & 605, Level 6, Burj Daman ,Dubai International Financial Centre ,506555 ,Dubai",
        "phone": "97143506400 / 971504654755",
        "email": "r.hickman@aglaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Robin Hickman",
    "address": "6,Office Nos. 603, 604 & 605, Level 6, Burj D",
    "phone": "97143506400",
    "email": "a.johnston@aglaw.com",
    "registrationNumber": "CF-2012-00103"
  },
  {
    "id": "30ce50dc-01a6-499d-8ace-3f807ddcb08d",
    "slug": "afridi-angell-ded",
    "name": "Afridi & Angell-DED",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 50,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/09/1975 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Afridi & Angell-DED",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_30ce50dc-01a6-499d-8ace-3f807ddcb08d",
        "address": "",
        "phone": "97143303900 / 971561753537",
        "email": "christopher@afridi-angell.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Bashir Ahmed",
    "address": "N/A",
    "phone": "97143303900",
    "email": "christopher@afridi-angell.com",
    "registrationNumber": "CF-1975-00001"
  },
  {
    "id": "3e464dc8-b800-4ba2-ad91-24a5f9640fef",
    "slug": "afridi-angell-difc",
    "name": "Afridi & Angell-DIFC",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 50,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/09/1975 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Afridi & Angell-DIFC",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3e464dc8-b800-4ba2-ad91-24a5f9640fef",
        "address": "- ,Index Tower ,Dubai International Financial Centre ,9371 ,Dubai",
        "phone": "97143303900 / 971561753537",
        "email": "christopher@afridi-angell.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": null,
    "address": "-,Index Tower,Al Mustaqbal Street,Dubai,9371",
    "phone": "97143303900",
    "email": "christopher@afridi-angell.com",
    "registrationNumber": "CF-1975-00137"
  },
  {
    "id": "4d1f95f5-2298-4b6a-a003-65d083d3eebb",
    "slug": "ajith-m-legal-consultancy",
    "name": "Ajith M Legal Consultancy",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/13/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/12/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Ajith M Legal Consultancy",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4d1f95f5-2298-4b6a-a003-65d083d3eebb",
        "address": "Building 10, Unit P05 ,Business Bay ,999041 ,",
        "phone": "97100000000 / 971502870418",
        "email": "adv.m.ajith@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Ajith Madhavan",
    "address": ",Building 10, Unit P05,Bay Square,,999041",
    "phone": "97100000000",
    "email": "adv.m.ajith@gmail.com",
    "registrationNumber": "CF-2023-00172"
  },
  {
    "id": "9ff29eab-adb8-40f9-ab84-216e01a381e4",
    "slug": "akin-gump-strauss-hauer-feld-llp",
    "name": "Akin Gump Strauss Hauer & Feld LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFHCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 20,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/09/2005 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "08/31/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Akin Gump Strauss Hauer & Feld LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9ff29eab-adb8-40f9-ab84-216e01a381e4",
        "address": "ICD Brookfield Place ,DIFC ,120109 ,",
        "phone": "97143173000 / 971504465229",
        "email": "DubaiLAD@akingump.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Mahmoud Fadlallah",
    "address": ",ICD Brookfield Place,Al Mustaqbal Street,,12",
    "phone": "97143173000",
    "email": "DubaiLAD@akingump.com",
    "registrationNumber": "CF-2005-00055"
  },
  {
    "id": "58c5bed4-4c54-495f-91b1-65941ca72065",
    "slug": "al-montasser-business-law-consultancy-centre",
    "name": "Al Montasser Business Law Consultancy Centre",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 22,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/09/2003 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/19/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Al Montasser Business Law Consultancy Centre",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_58c5bed4-4c54-495f-91b1-65941ca72065",
        "address": "",
        "phone": "97143467333 / 971505357973",
        "email": "info@emilawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Fetih Al-Montasser",
    "address": "N/A",
    "phone": "97143467333",
    "email": "info@emilawyers.com",
    "registrationNumber": "CF-2003-00041"
  },
  {
    "id": "e6ff998b-c5d8-4ed8-8c69-9574d5cfe8f4",
    "slug": "al-noor-legal-consultants",
    "name": "Al Noor Legal Consultants",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFOCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 22,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/20/2003 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/29/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Al Noor Legal Consultants",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e6ff998b-c5d8-4ed8-8c69-9574d5cfe8f4",
        "address": "MARYAM AHMAD BLDG ,Al Barha ,45777 ,",
        "phone": "97143117401 / 971508537396",
        "email": "faiq@alchalaby.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Faiq Alchalaby",
    "address": ",MARYAM AHMAD BLDG,Al Barha,,45777",
    "phone": "97143117401",
    "email": "faiq@alchalaby.com",
    "registrationNumber": "CF-2003-00046"
  },
  {
    "id": "f18ce257-9c27-4dbc-8186-c51fff8ec4f9",
    "slug": "al-zubi-partners-legal-consultants",
    "name": "Al Zubi & Partners Legal Consultants",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFaCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 24,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/14/2001 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/18/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Al Zubi & Partners Legal Consultants",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f18ce257-9c27-4dbc-8186-c51fff8ec4f9",
        "address": "Emirates Tower LLC ,Trade Centre 2 Dubai ,487915 ,",
        "phone": "97145548182 / 971559921117",
        "email": "hqzubi@zubipartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Hatim Alzubi",
    "address": ",Emirates Tower LLC,Sheikh Zayed Road -Trade",
    "phone": "97145548182",
    "email": "hqzubi@zubipartners.com",
    "registrationNumber": "CF-2001-00030"
  },
  {
    "id": "d3fb2743-87e9-4b67-88f9-a1fd221c9e75",
    "slug": "alameeri-legal-consultants-llc",
    "name": "Alameeri Legal Consultants L.L.C",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFMCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/16/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "02/15/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Alameeri Legal Consultants L.L.C",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d3fb2743-87e9-4b67-88f9-a1fd221c9e75",
        "address": "Opal Tower ,Dubai ,392087 ,",
        "phone": "/ 971501152345",
        "email": "info@alameeri-legal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Adnan Abdulrahim Hussain Ibrahim Alameeri",
    "address": ",Opal Tower,Burj Khalifa Blvd,,392087",
    "phone": "N/A",
    "email": "info@alameeri-legal.com",
    "registrationNumber": "CF-2023-00167"
  },
  {
    "id": "55e38c6c-febf-429c-aa23-024ec5811406",
    "slug": "allen-overy-shearman-sterling-llp",
    "name": "Allen Overy Shearman Sterling LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFPCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 48,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/29/1977 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/19/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Allen Overy Shearman Sterling LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_55e38c6c-febf-429c-aa23-024ec5811406",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "David Foster",
    "address": "0,Burj Daman,Al Mustaqbal Street,Dubai,506678",
    "phone": "97144267100",
    "email": "david.foster@allenovery.com",
    "registrationNumber": "CF-1977-00004"
  },
  {
    "id": "fede060d-ee8a-4d28-b07d-69793cc407bc",
    "slug": "altieri-firm-llc",
    "name": "Altieri Firm L.L.C",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFGCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/23/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/22/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Altieri Firm L.L.C",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fede060d-ee8a-4d28-b07d-69793cc407bc",
        "address": "The Binary by Omniyat ,Business Bay ,371473 ,",
        "phone": "97156288020 / 971562880200",
        "email": "chad@gsilaw.global",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Chad Michael Altieri",
    "address": ",The Binary by Omniyat,Marasi Drive St,,37147",
    "phone": "97156288020",
    "email": "chad@gsilaw.global",
    "registrationNumber": "CF-2023-00168"
  },
  {
    "id": "a139ca64-8897-4d1d-8d71-97446bc1e15a",
    "slug": "amereller-legal-consultancy-llc-soc",
    "name": "Amereller Legal Consultancy LLC SOC",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFMCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 22,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/06/2003 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/29/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Amereller Legal Consultancy LLC SOC",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a139ca64-8897-4d1d-8d71-97446bc1e15a",
        "address": "",
        "phone": "97144323671 / 971505589395",
        "email": "fba@amereller.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Florian Amereller",
    "address": "N/A",
    "phone": "97144323671",
    "email": "fba@amereller.com",
    "registrationNumber": "CF-2003-00042"
  },
  {
    "id": "ead06df1-7efa-4b25-80d0-710f815a1677",
    "slug": "anders-legal-consultancy-llc",
    "name": "Anders Legal Consultancy LLC",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFMCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 20,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/21/2005 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/04/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Anders Legal Consultancy LLC",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ead06df1-7efa-4b25-80d0-710f815a1677",
        "address": "",
        "phone": "97143275888 / 971504506620",
        "email": "anders@anders.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Dr. Ines Anders",
    "address": "N/A",
    "phone": "97143275888",
    "email": "anders@anders.ae",
    "registrationNumber": "CF-2005-00056"
  },
  {
    "id": "42192f9f-9b0f-46c8-82ea-5b01bfbb71e6",
    "slug": "andreeva-legal-consultancy-llc",
    "name": "Andreeva Legal Consultancy LLC",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFMCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/26/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Andreeva Legal Consultancy LLC",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_42192f9f-9b0f-46c8-82ea-5b01bfbb71e6",
        "address": "Bayswater Bay Tower ,Business Bay ,38252 ,",
        "phone": "97143246444 / 971506244364",
        "email": "6244364@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Lina Anatoliy Andreeva",
    "address": ",Bayswater Bay Tower,Bayswater Bay Tower,,382",
    "phone": "97143246444",
    "email": "info@lawyer4you.ae",
    "registrationNumber": "CF-2025-00179"
  },
  {
    "id": "4f3e1e80-c812-4585-9570-229cd96776a4",
    "slug": "anjarwalla-collins-and-haidermota-legal-consultants",
    "name": "Anjarwalla, Collins and Haidermota Legal Consultants",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFDCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 15,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/01/2010 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "07/21/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Anjarwalla, Collins and Haidermota Legal Consultants",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4f3e1e80-c812-4585-9570-229cd96776a4",
        "address": "",
        "phone": "97144529091 / 971552805308",
        "email": "ashafi@ach-legal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Adil Shafi Khan",
    "address": "N/A",
    "phone": "97144529091",
    "email": "aanjarwalla@ach-legal.com",
    "registrationNumber": "CF-2010-00096"
  },
  {
    "id": "2834e81b-8706-4672-8b39-01356b145ac0",
    "slug": "antonio-m-varvaro-legal-consultants",
    "name": "Antonio M Varvaro Legal Consultants",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/10/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/08/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Antonio M Varvaro Legal Consultants",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2834e81b-8706-4672-8b39-01356b145ac0",
        "address": "",
        "phone": "97145851677 / 971508009612",
        "email": "antonio.varvaro@amv-eurolegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Antonio Maria Varvaro",
    "address": "N/A",
    "phone": "97145851677",
    "email": "antonio.varvaro@amv-eurolegal.com",
    "registrationNumber": "CF-2018-00147"
  },
  {
    "id": "d45f1c65-7336-4362-b823-660251efae7c",
    "slug": "antoun-milan-legal-consultants",
    "name": "Antoun Milan Legal Consultants",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 23,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/30/2001 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/20/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Antoun Milan Legal Consultants",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d45f1c65-7336-4362-b823-660251efae7c",
        "address": "TWIN TOWERS -  ,AL RIGA ,42001 ,",
        "phone": "97142281212 / 971504595431",
        "email": "milanlawfirm@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Antoun Milan",
    "address": ",TWIN TOWERS - ,BANIYAS ROAD,,42001",
    "phone": "97142281212",
    "email": "milanlawfirm@gmail.com",
    "registrationNumber": "CF-2001-00031"
  },
  {
    "id": "f39b81d1-9085-4c4e-a69b-3d9349f8f28c",
    "slug": "ashish-mehta-associates-legal-consultants-llc",
    "name": "Ashish Mehta & Associates Legal Consultants LLC",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 25,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/18/2000 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/25/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Ashish Mehta & Associates Legal Consultants LLC",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f39b81d1-9085-4c4e-a69b-3d9349f8f28c",
        "address": "Saeed Tower 2 ,Sheikh Zayed Road ,32045 ,",
        "phone": "97143518989 / 971506466213",
        "email": "ashish.mehta@amalawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Ashish Mehta",
    "address": ",Saeed Tower 2,Sheikh Zayed Road,,32045",
    "phone": "97143518989",
    "email": "ashish.mehta@amalawyers.com",
    "registrationNumber": "CF-2000-00028"
  },
  {
    "id": "af016ea4-05d8-4845-9d38-b95de499a172",
    "slug": "ashurst-llp-legal-consultants-dubai-branch-ded",
    "name": "Ashurst LLP Legal Consultants Dubai Branch-DED",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFMCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 20,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/18/2005 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/14/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Ashurst LLP Legal Consultants Dubai Branch-DED",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_af016ea4-05d8-4845-9d38-b95de499a172",
        "address": "NA ,Park Lane Tower ,NA ,119974 ,Dubai",
        "phone": "97143652000 / 971504515630",
        "email": "david.charlier@ashurst.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": null,
    "address": "NA,Park Lane Tower,Al Amal Street,Dubai,11997",
    "phone": "97143652000",
    "email": "david.charlier@ashurst.com",
    "registrationNumber": "CF-2005-00057"
  },
  {
    "id": "c01c3c61-4d90-4058-8429-61dd01e615f5",
    "slug": "ashurst-llp-difc",
    "name": "Ashurst LLP-DIFC",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFMCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 20,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/18/2005 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/14/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Ashurst LLP-DIFC",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c01c3c61-4d90-4058-8429-61dd01e615f5",
        "address": "ICD-Brookfield Place ,DIFC ,119974 ,",
        "phone": "97143652000",
        "email": "david.charlier@ashurst.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "David Charlier",
    "address": ",ICD-Brookfield Place,312 Al Mustaqbal St ,,1",
    "phone": "97143652000",
    "email": "david.charlier@ashurst.com",
    "registrationNumber": "CF-2005-00141"
  },
  {
    "id": "169d1d08-9788-417a-9352-9189689cf5fb",
    "slug": "azhari-legal-consultancy",
    "name": "Azhari Legal Consultancy",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFMCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 21,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/30/2004 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/06/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Azhari Legal Consultancy",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_169d1d08-9788-417a-9352-9189689cf5fb",
        "address": "",
        "phone": "97144473557 / 971506884811",
        "email": "ceo@azhari-law.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Rassan Azhari",
    "address": "N/A",
    "phone": "97144473557",
    "email": "ceo@azhari-law.com",
    "registrationNumber": "CF-2004-00049"
  },
  {
    "id": "acd81e81-dead-4f7c-839e-0f2a57897265",
    "slug": "baker-mckenzie-llp",
    "name": "Baker & Mckenzie LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEJNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/10/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/09/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Baker & Mckenzie LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_acd81e81-dead-4f7c-839e-0f2a57897265",
        "address": "Al Fattan Currency House Tower 2 ,DIFC ,507176 ,",
        "phone": "/ 971552009003",
        "email": "Mohammad.AlRasheed@bakermckenzie.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Mohammed Marwan Al Rasheed",
    "address": ",Al Fattan Currency House Tower 2,Al Mustakba",
    "phone": "N/A",
    "email": "Borys.Dackiw@bakermckenzie.com",
    "registrationNumber": "CF-2022-00164"
  },
  {
    "id": "fd5d6571-d053-4436-9de5-c8a36ce7c6c9",
    "slug": "baker-botts-llp-legal-consultants-dubai-branch",
    "name": "Baker Botts LLP Legal Consultants Dubai Branch",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEJCCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 20,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/24/2005 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "02/20/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Baker Botts LLP Legal Consultants Dubai Branch",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fd5d6571-d053-4436-9de5-c8a36ce7c6c9",
        "address": "",
        "phone": "97144363636 / 971505572900",
        "email": "hassan.elsayed@bakerbotts.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Mark Bisch",
    "address": "N/A",
    "phone": "97144363636",
    "email": "hassan.elsayed@bakerbotts.com",
    "registrationNumber": "CF-2005-00051"
  },
  {
    "id": "bb8d29c8-092a-44ba-b960-00b20d622b97",
    "slug": "barahim-legal-consultants",
    "name": "Barahim Legal Consultants",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEJMCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/03/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "12/26/2025 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Barahim Legal Consultants",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bb8d29c8-092a-44ba-b960-00b20d622b97",
        "address": "AL DIYAR RAG BIZ HQ BUSINESS CENTER ,ALWASL ,5922 ,",
        "phone": "97142284399 / 971506540033",
        "email": "nabil.barahim@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Nabil Barahim",
    "address": ",AL DIYAR RAG BIZ HQ BUSINESS CENTER,BAY STRE",
    "phone": "97142284399",
    "email": "nabil.barahim@yahoo.com",
    "registrationNumber": "CF-2013-00109"
  },
  {
    "id": "9c5f75c6-0137-45c8-87b2-e7f4a4884749",
    "slug": "bayat-legal-services",
    "name": "Bayat Legal Services",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEJMCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 32,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/13/1993 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "12/28/2025 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Bayat Legal Services",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9c5f75c6-0137-45c8-87b2-e7f4a4884749",
        "address": "Al Moosa tower 2 ,Trade Center  ,32422 ,",
        "phone": "97143554646 / 971527547777",
        "email": "sam.bayat@bayatgroup.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Sam Bayat Makou",
    "address": ",Al Moosa tower 2,Sheikh Zayed Road,,32422",
    "phone": "97143554646",
    "email": "sam.bayat@bayatgroup.com",
    "registrationNumber": "CF-1993-00011"
  },
  {
    "id": "0f74c5fc-87d6-451a-b380-576b0bc3ceb8",
    "slug": "beale-company-middle-east",
    "name": "Beale & Company (Middle East)",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEJDCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/18/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/12/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Beale & Company (Middle East)",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0f74c5fc-87d6-451a-b380-576b0bc3ceb8",
        "address": "",
        "phone": "97143563900 / 971564663035",
        "email": "c.miller@Beale-Law.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Claire Miller",
    "address": "N/A",
    "phone": "97143563900",
    "email": "c.miller@Beale-Law.com",
    "registrationNumber": "CF-2015-00126"
  },
  {
    "id": "6ced8db0-e5c9-4227-9e21-ea84258e3de8",
    "slug": "bin-bashir-legal-consultants",
    "name": "Bin Bashir Legal Consultants",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEJCCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/27/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/26/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Bin Bashir Legal Consultants",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6ced8db0-e5c9-4227-9e21-ea84258e3de8",
        "address": "",
        "phone": "971504514531 / 971504514531",
        "email": "bashirso@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Majid Obaid Saeed Bin Bashir Almheiri",
    "address": "N/A",
    "phone": "971504514531",
    "email": "bashirso@gmail.com",
    "registrationNumber": "CF-2022-00161"
  },
  {
    "id": "3e1526e6-4c8d-4b6f-985f-ea05e9f99bcb",
    "slug": "bird-bird-mea-llp",
    "name": "Bird & Bird (MEA) LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEJCCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/04/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "08/28/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Bird & Bird (MEA) LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3e1526e6-4c8d-4b6f-985f-ea05e9f99bcb",
        "address": "",
        "phone": "97143093222 / 971566651954",
        "email": "melissa.murray@twobirds.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Melissa Murray",
    "address": "N/A",
    "phone": "97143093222",
    "email": "melissa.murray@twobirds.com",
    "registrationNumber": "CF-2013-00114"
  },
  {
    "id": "f77150e9-6cee-4d5e-9619-7fa5f488aee3",
    "slug": "bonellierede-middle-east-llp",
    "name": "BonelliErede Middle East LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEJNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/25/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/22/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: BonelliErede Middle East LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f77150e9-6cee-4d5e-9619-7fa5f488aee3",
        "address": "NA ,Index tower ,NA ,506828 ,Dubai",
        "phone": "97154228569 / 971525567076",
        "email": "silviaelba.sartori@belex.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Marco De Leo",
    "address": "NA,Index tower,Al Mustaqbal St,Dubai,506828",
    "phone": "97154228569",
    "email": "silviaelba.sartori@belex.com",
    "registrationNumber": "CF-2017-00146"
  },
  {
    "id": "2b373724-e557-4c31-a968-7d37d9393842",
    "slug": "bonnard-lawson-legal-consultants-llc",
    "name": "Bonnard Lawson Legal Consultants L.L.C",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEJMCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/27/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "02/20/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Bonnard Lawson Legal Consultants L.L.C",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2b373724-e557-4c31-a968-7d37d9393842",
        "address": "",
        "phone": "97145683100 / 971559223103",
        "email": "rossi@bonnard-lawson.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Giovanni Rossi",
    "address": "N/A",
    "phone": "97145683100",
    "email": "rossi@bonnard-lawson.com",
    "registrationNumber": "CF-2014-00117"
  },
  {
    "id": "106d3ee7-86f2-4eae-9b49-fd8423095983",
    "slug": "bracewell-llp",
    "name": "Bracewell LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEJMCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 36,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/21/1988 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "01/25/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Bracewell LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_106d3ee7-86f2-4eae-9b49-fd8423095983",
        "address": "",
        "phone": "97143506800 / 971507244940",
        "email": "Chris.Williams@bracewelllaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Christopher Williams",
    "address": "N/A",
    "phone": "97143506800",
    "email": "Chris.Williams@bracewelllaw.com",
    "registrationNumber": "CF-1988-00005"
  },
  {
    "id": "6c617112-4b98-414c-868a-7d0316427c21",
    "slug": "bryan-cave-leighton-paisner-llp",
    "name": "Bryan Cave Leighton Paisner LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEJDCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/15/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "07/07/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Bryan Cave Leighton Paisner LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6c617112-4b98-414c-868a-7d0316427c21",
        "address": "",
        "phone": "97145119777 / 971508184427",
        "email": "richard.davies@bclplaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Richard Huw Davies",
    "address": "N/A",
    "phone": "97145119777",
    "email": "richard.davies@bclplaw.com",
    "registrationNumber": "CF-2012-00105"
  },
  {
    "id": "8cca52de-2c74-4743-b8f2-0b904d96b132",
    "slug": "cc-worldwide-limited",
    "name": "CC Worldwide Limited",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIENXCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/08/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/05/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: CC Worldwide Limited",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8cca52de-2c74-4743-b8f2-0b904d96b132",
        "address": "",
        "phone": "97145032600 / 971504577931",
        "email": "edmund.boyo@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Edmund Boyo",
    "address": "N/A",
    "phone": "97145032600",
    "email": "edmund.boyo@cliffordchance.com",
    "registrationNumber": "CF-2018-00150"
  },
  {
    "id": "e2ac552e-b9a7-450b-a84d-15119e583220",
    "slug": "charles-russell-speechlys-llp",
    "name": "Charles Russell Speechlys LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIENSCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/28/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/25/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Charles Russell Speechlys LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e2ac552e-b9a7-450b-a84d-15119e583220",
        "address": "20 ,Index Tower West Tower ,DIFC ,507226 ,Dubai",
        "phone": "97142461900 / 971523391604",
        "email": "patrick.gearon@crsblaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Simon Edwin Bowshell Green",
    "address": "20,Index Tower West Tower,Happiness Street,Du",
    "phone": "97142461900",
    "email": "patrick.gearon@crsblaw.com",
    "registrationNumber": "CF-2017-00143"
  },
  {
    "id": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "slug": "clifford-chance-llp-difc",
    "name": "Clifford Chance LLP-DIFC",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIENDCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 50,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/09/1975 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "02/22/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Clifford Chance LLP-DIFC",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_210291f4-864f-4eb4-b150-d4b9536c8005",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Mohammed Al- Shukairy",
    "address": ",ICD Brookfield Place ,Al-Mustaqbal,,9380",
    "phone": "97145032600",
    "email": "mo.al-shukairy@cliffordchance.com",
    "registrationNumber": "CF-1975-00139"
  },
  {
    "id": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "slug": "clyde-co-llp",
    "name": "Clyde & Co LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIENDCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 36,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/27/1989 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/02/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Clyde & Co LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Jonathan Silver",
    "address": "N/A",
    "phone": "97143844000",
    "email": "Sophie.Seymour@clydeco.ae",
    "registrationNumber": "CF-1989-00007"
  },
  {
    "id": "7a59d310-ff72-4318-b41c-27095c163d0f",
    "slug": "cms-uae-llp",
    "name": "CMS (UAE) LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEMoCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/04/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/27/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: CMS (UAE) LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7a59d310-ff72-4318-b41c-27095c163d0f",
        "address": "",
        "phone": "97143742800 / 971506450677",
        "email": "jabbott21@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "James Abbott",
    "address": "N/A",
    "phone": "97143742800",
    "email": "James.Abbott@cms-cmno.com",
    "registrationNumber": "CF-2013-00115"
  },
  {
    "id": "59026ad8-89bd-42f6-8906-801068aae6fe",
    "slug": "cohen-gresser-llp",
    "name": "Cohen & Gresser LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIENHCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/24/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/23/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Cohen & Gresser LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_59026ad8-89bd-42f6-8906-801068aae6fe",
        "address": "",
        "phone": "/ 971585357048",
        "email": "JJonas@CohenGresser.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "N/A",
    "email": "JJonas@CohenGresser.com",
    "registrationNumber": "CF-2025-00183"
  },
  {
    "id": "65a2e90a-6978-4292-b3f1-ecbebedd7b9a",
    "slug": "covington-burling-llp-middle-east",
    "name": "Covington & Burling LLP (Middle East)",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIENCCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/18/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/13/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Covington & Burling LLP (Middle East)",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_65a2e90a-6978-4292-b3f1-ecbebedd7b9a",
        "address": "",
        "phone": "97142472100 / 971509224336",
        "email": "bhaley@cov.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Benjamin Sherwood Haley",
    "address": "N/A",
    "phone": "97142472100",
    "email": "jhuizing@cov.com",
    "registrationNumber": "CF-2016-00131"
  },
  {
    "id": "0867bcc5-10fa-4783-91ae-b8f63e02e81a",
    "slug": "curtis-mallet-prevost-colt-mosle-llp",
    "name": "Curtis Mallet-Prevost, Colt & Mosle LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIENNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 17,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/23/2008 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "07/12/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Curtis Mallet-Prevost, Colt & Mosle LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0867bcc5-10fa-4783-91ae-b8f63e02e81a",
        "address": "",
        "phone": "97143826100 / 971507380618",
        "email": "jmiocevic@curtis.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Jeremy Miocevic",
    "address": "N/A",
    "phone": "97143826100",
    "email": "jmiocevic@curtis.com",
    "registrationNumber": "CF-2008-00081"
  },
  {
    "id": "6677b738-cb41-400c-82d4-a31fd0e5b559",
    "slug": "cvml-limited",
    "name": "CVML Limited",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIENMCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 15,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/27/2009 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/07/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: CVML Limited",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6677b738-cb41-400c-82d4-a31fd0e5b559",
        "address": "South Tower, Emirates Financial Towers ,DIFC ,482025 ,",
        "phone": "97145875333 / 971503444388",
        "email": "c.dersahakian@cvml.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Charbel Dersahakian",
    "address": ",South Tower, Emirates Financial Towers,Al Su",
    "phone": "97145875333",
    "email": "c.dersahakian@cvml.com",
    "registrationNumber": "CF-2009-00090"
  },
  {
    "id": "d0200f27-9504-4653-a5c6-05e4bcab7ff0",
    "slug": "davidson-co-legal-consultants",
    "name": "Davidson & Co Legal Consultants",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIERDCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/23/2008 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/24/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Davidson & Co Legal Consultants",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d0200f27-9504-4653-a5c6-05e4bcab7ff0",
        "address": "",
        "phone": "97143438897 / 971507753952",
        "email": "jdavidson@davidson-legal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Jonathan Davidson",
    "address": "N/A",
    "phone": "97143438897",
    "email": "jdavidson@davidson-legal.com",
    "registrationNumber": "CF-2008-00082"
  },
  {
    "id": "7b0531fd-1de7-4fe5-b6d8-7a5de645b631",
    "slug": "dechert-llp",
    "name": "Dechert LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIERMCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/24/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/15/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Dechert LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7b0531fd-1de7-4fe5-b6d8-7a5de645b631",
        "address": "Emirates Financial Tower, South Tower ,Dubai International Financial Center ,506675 ,",
        "phone": "97144256300 / 971558560783",
        "email": "rebecca.hird@dechert.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Christopher Radley-Gardner",
    "address": ",Emirates Financial Tower, South Tower,Al Suk",
    "phone": "97144256300",
    "email": "rebecca.hird@dechert.com",
    "registrationNumber": "CF-2012-00102"
  },
  {
    "id": "dfe13b7e-6625-45fd-ad63-9ee83af41194",
    "slug": "dentons-co-dubai-branch-ded",
    "name": "Dentons & Co Dubai Branch-DED",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIERDCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 26,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/10/1998 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "02/16/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Dentons & Co Dubai Branch-DED",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dfe13b7e-6625-45fd-ad63-9ee83af41194",
        "address": "",
        "phone": "97144020800 / 971566830829",
        "email": "dean.ryburn@dentons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Dean Ryburn",
    "address": "N/A",
    "phone": "97144020800",
    "email": "riyaz.ahamed@dentons.com",
    "registrationNumber": "CF-1998-00022"
  },
  {
    "id": "0deeb936-18fc-456c-97dc-2e1cce547c2d",
    "slug": "di-francia-law-firm-dubai-branch",
    "name": "Di Francia Law Firm (Dubai Branch)",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIERGCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 15,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/12/2010 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/02/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Di Francia Law Firm (Dubai Branch)",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0deeb936-18fc-456c-97dc-2e1cce547c2d",
        "address": "5 ,AL SUAIDI ,AL MARARR ,506803 ,Dubai",
        "phone": "97148283966 / 971502473435",
        "email": "info@difranciafirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Daniela Di Francia",
    "address": "5,AL SUAIDI,AL MARARR,Dubai,506803",
    "phone": "97148283966",
    "email": "info@difranciafirm.com",
    "registrationNumber": "CF-2010-00148"
  },
  {
    "id": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "slug": "dla-piper-middle-east-llp",
    "name": "DLA Piper Middle East LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIERQCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 19,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/31/2005 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/27/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: DLA Piper Middle East LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_de972132-ce4d-4000-b7ee-71cb5557b048",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Peter Somekh",
    "address": "N/A",
    "phone": "97144386100",
    "email": "peter.somekh@dlapiper.com",
    "registrationNumber": "CF-2005-00059"
  },
  {
    "id": "24541c75-dcba-47a9-b858-e6bc97c41dbc",
    "slug": "donald-harry-bunker-legal-consultants",
    "name": "Donald Harry Bunker Legal Consultants",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIERICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 15,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/06/2010 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/26/2025 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Donald Harry Bunker Legal Consultants",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_24541c75-dcba-47a9-b858-e6bc97c41dbc",
        "address": "Business Village Building A ,Port Saeed ,42717 ,",
        "phone": "97142229747 / 971506546369",
        "email": "iveall@dhbassociates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Ian Veall",
    "address": ",Business Village Building A,Al Maktoum Stree",
    "phone": "97142229747",
    "email": "iveall@dhbassociates.ae",
    "registrationNumber": "CF-2010-00093"
  },
  {
    "id": "ecf18fcb-ce6b-40ab-8725-6734f867bcde",
    "slug": "dr-hassan-abdalla-legal-consultancy",
    "name": "Dr. Hassan Abdalla Legal Consultancy",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIERICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/23/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Dr. Hassan Abdalla Legal Consultancy",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ecf18fcb-ce6b-40ab-8725-6734f867bcde",
        "address": "",
        "phone": "/ 971556915188",
        "email": "hassan.a.m.89@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "HASSAN ABDALLA HASSAN MOHAMED",
    "address": "N/A",
    "phone": "N/A",
    "email": "hassan.a.m.89@gmail.com",
    "registrationNumber": "CF-2025-00180"
  },
  {
    "id": "6e5f6dba-07af-4109-8c34-175296450f94",
    "slug": "dwf-middle-east-llp",
    "name": "DWF (Middle East) LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEQoCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/23/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/17/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: DWF (Middle East) LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6e5f6dba-07af-4109-8c34-175296450f94",
        "address": "Al Fattan Currency House - Tower 1  ,Dubai International Financial Center  ,507104 ,",
        "phone": "97143978565 / 971504587822",
        "email": "Raafat.hares@dwf.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "James Fox",
    "address": ",Al Fattan Currency House - Tower 1 ,Al Musta",
    "phone": "97143978565",
    "email": "Raafat.hares@dwf.law",
    "registrationNumber": "CF-2014-00121"
  },
  {
    "id": "e2c7ecee-1913-48a7-a833-a10d08f984f4",
    "slug": "epam-legal-llc",
    "name": "EPAM Legal LLC",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEVMCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/16/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/15/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: EPAM Legal LLC",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e2c7ecee-1913-48a7-a833-a10d08f984f4",
        "address": "",
        "phone": "/ 971527856097",
        "email": "roman_zhavner@epamlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Roman Zhavner",
    "address": ",Offices 4, One Central,Offices 4, One Centra",
    "phone": "N/A",
    "email": "roman_zhavner@epamlaw.com",
    "registrationNumber": "CF-2022-00166"
  },
  {
    "id": "74a21d43-41d8-480a-a6af-6939b7c98a95",
    "slug": "eversheds-sutherland-international-llp-dubai-branch",
    "name": "Eversheds Sutherland (International LLP) Dubai Branch",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEVTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/10/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/02/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Eversheds Sutherland (International LLP) Dubai Branch",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_74a21d43-41d8-480a-a6af-6939b7c98a95",
        "address": "",
        "phone": "97143897000 / 971506553198",
        "email": "nasseralikhasawneh@eversheds-sutherland.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Nasser Ali Khasawneh",
    "address": "N/A",
    "phone": "97143897000",
    "email": "NasseraliKhasawneh@eversheds-sutherland.com",
    "registrationNumber": "CF-2012-00104"
  },
  {
    "id": "42e536ef-e3d8-4339-8572-657a7f7a0331",
    "slug": "ey-law-llp",
    "name": "EY Law LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEVMCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/21/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/20/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: EY Law LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_42e536ef-e3d8-4339-8572-657a7f7a0331",
        "address": "1 ,ICD Brookfield Place ,Dubai International Financial Centre ,9267 ,Dubai",
        "phone": "97147010975 / 971502977062",
        "email": "chris.sioufi@ae.ey.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Chris Sioufi",
    "address": "1,ICD Brookfield Place,Al Mustaqbal Street,Du",
    "phone": "97147010975",
    "email": "rebecca.platts@ae.ey.com",
    "registrationNumber": "CF-2019-00152"
  },
  {
    "id": "72115619-3e10-432c-a345-048c61fd3382",
    "slug": "falah-legal-consultants",
    "name": "Falah Legal Consultants",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEZMCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 29,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/10/1996 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-11-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Falah Legal Consultants",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_72115619-3e10-432c-a345-048c61fd3382",
        "address": "",
        "phone": "97142242514 / 971504533640",
        "email": "falahleg@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Abdul Mahdi Falah",
    "address": "N/A",
    "phone": "97142242514",
    "email": "falahleg@emirates.net.ae",
    "registrationNumber": "CF-1996-00015"
  },
  {
    "id": "45b03212-ac3a-4dbc-8b2d-10fc81273543",
    "slug": "fenwick-elliott-llp-dmcc-branch",
    "name": "Fenwick Elliott LLP (DMCC Branch)",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEZFCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/28/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/22/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Fenwick Elliott LLP (DMCC Branch)",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_45b03212-ac3a-4dbc-8b2d-10fc81273543",
        "address": "Office 1A ,Silver Tower ,DMCC Al Mas Tower ,283149 ,Dubai",
        "phone": "97144542355 / 971564092949",
        "email": "pstone@fenwickelliott.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Patrick David Stone",
    "address": "Office 1A,Silver Tower,Cluster i, Jumeirah La",
    "phone": "97144542355",
    "email": "pstone@fenwickelliott.com",
    "registrationNumber": "CF-2015-00125"
  },
  {
    "id": "77bf4fd2-1cd1-4bda-a0c2-ffcac3980b76",
    "slug": "fichte-co-legal-consultancy",
    "name": "Fichte & Co Legal Consultancy",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEZDCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 20,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/16/2004 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/07/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Fichte & Co Legal Consultancy",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_77bf4fd2-1cd1-4bda-a0c2-ffcac3980b76",
        "address": "23 ,Rolex Tower ,Trade Center Second ,116637 ,Dubai",
        "phone": "97144357577 / 971502101003",
        "email": "jasamin.fichte@fichtelegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Jasamin Fichte",
    "address": "23,Rolex Tower,Sheikh Zayed Road,Dubai,116637",
    "phone": "97144357577",
    "email": "jasamin.fichte@fichtelegal.com",
    "registrationNumber": "CF-2004-00050"
  },
  {
    "id": "970f6246-e737-41a7-9c6c-5aa5b8335d45",
    "slug": "freshfields-llp-difc",
    "name": "Freshfields LLP DIFC",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEZMCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 20,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/09/2005 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "08/30/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Freshfields LLP DIFC",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_970f6246-e737-41a7-9c6c-5aa5b8335d45",
        "address": "0 ,ICD Brookfield Place Level 13 ,Trade Centre ,506569 ,Dubai",
        "phone": "97145099100 / 971501006965",
        "email": "menahr@freshfields.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Sami Tannous",
    "address": "0,ICD Brookfield Place Level 13,Al Mustaqbal",
    "phone": "97145099100",
    "email": "menahr@freshfields.com",
    "registrationNumber": "CF-2005-00135"
  },
  {
    "id": "d74ebaf8-dc08-4894-a6df-1939881d0261",
    "slug": "freshfields-llp-dubai-branch-det",
    "name": "Freshfields LLP- Dubai Branch DET",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEZMCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 20,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/09/2005 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "08/30/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Freshfields LLP- Dubai Branch DET",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d74ebaf8-dc08-4894-a6df-1939881d0261",
        "address": "",
        "phone": "97145099100 / 971501006965",
        "email": "menahr@freshfields.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "97145099100",
    "email": "menahr@freshfields.com",
    "registrationNumber": "CF-2005-00054"
  },
  {
    "id": "3cb06a05-1ad1-4487-9624-c2b716bfd2a7",
    "slug": "gateley-uk-llp",
    "name": "Gateley UK LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEdVCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 17,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/23/2007 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "01/30/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Gateley UK LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3cb06a05-1ad1-4487-9624-c2b716bfd2a7",
        "address": "Burj Daman ,Dubai International Financial Center ,213241 ,",
        "phone": "97144549586 / 971564189768",
        "email": "darrenaharris123@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Darren Harris",
    "address": ",Burj Daman,Al Mustaqbal Street,,213241",
    "phone": "97144549586",
    "email": "Lspragg@gateleyae.com",
    "registrationNumber": "CF-2007-00078"
  },
  {
    "id": "c9d2c9d0-6e43-4253-a75d-cdeb400f8d8e",
    "slug": "gibson-dunn-crutcher-llp",
    "name": "Gibson Dunn & Crutcher LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEdECiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 18,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/12/2007 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/02/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Gibson Dunn & Crutcher LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c9d2c9d0-6e43-4253-a75d-cdeb400f8d8e",
        "address": "",
        "phone": "97143184600 / 971504468184",
        "email": "melaraby@gibsondunn.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Marwan Elaraby",
    "address": "N/A",
    "phone": "97143184600",
    "email": "jowens@gibsondunn.com",
    "registrationNumber": "CF-2007-00076"
  },
  {
    "id": "436703ba-b9c0-4dcb-93b2-1299c7a051f4",
    "slug": "gowling-wlg-uk-llp-dubai-branch",
    "name": "Gowling WLG (UK) LLP (Dubai Branch)",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEdXCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 18,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/21/2007 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "12/28/2025 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Gowling WLG (UK) LLP (Dubai Branch)",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_436703ba-b9c0-4dcb-93b2-1299c7a051f4",
        "address": "Level 17, ICD Brookfield Place ,DIFC ,506503 ,",
        "phone": "97144375100 / 971588271196",
        "email": "libby.edwards-smith@gowlingwlg.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Timothy Casben",
    "address": ",Level 17, ICD Brookfield Place,Dubai Interna",
    "phone": "97144375100",
    "email": "libby.edwards-smith@gowlingwlg.com",
    "registrationNumber": "CF-2007-00074"
  },
  {
    "id": "b4146aa6-efd1-41d7-819d-49da46353b0b",
    "slug": "greenberg-traurig-limited",
    "name": "Greenberg Traurig Limited",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEdUCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/02/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/01/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Greenberg Traurig Limited",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b4146aa6-efd1-41d7-819d-49da46353b0b",
        "address": "",
        "phone": "97145953601 / 971508728645",
        "email": "Steven.Bainbridge@gtlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Steven Bainbridge",
    "address": "N/A",
    "phone": "97145953601",
    "email": "Steven.Bainbridge@gtlaw.com",
    "registrationNumber": "CF-2023-00170"
  },
  {
    "id": "18561830-7fc4-44dd-8c1a-aeecc61cd63f",
    "slug": "helene-mathieu-legal-consultants",
    "name": "Helene Mathieu Legal Consultants",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 27,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/17/1997 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "02/16/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Helene Mathieu Legal Consultants",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_18561830-7fc4-44dd-8c1a-aeecc61cd63f",
        "address": "21 ,Ontario Tower ,Oposite Side Obberoi Hotel ,28845 ,Dubai",
        "phone": "97143644333 / 971506326165",
        "email": "helene@hmlc.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Helene Mathieu",
    "address": "21,Ontario Tower,Al Abraaj St,Dubai,28845",
    "phone": "97143644333",
    "email": "helene@hmlc.ae",
    "registrationNumber": "CF-1997-00020"
  },
  {
    "id": "2f0389b3-bfde-44f4-bdd6-6e1a22f9cab2",
    "slug": "herbert-smith-freehills-kramer-llp",
    "name": "Herbert Smith Freehills Kramer LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 19,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/11/2006 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "02/16/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Herbert Smith Freehills Kramer LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2f0389b3-bfde-44f4-bdd6-6e1a22f9cab2",
        "address": "",
        "phone": "97144286300 / 971506256686",
        "email": "stuart.paterson@hsf.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Stuart Paterson",
    "address": "N/A",
    "phone": "97144286300",
    "email": "stuart.paterson@hsf.com",
    "registrationNumber": "CF-2006-00070"
  },
  {
    "id": "2476b8c2-8925-4cd7-8215-0d7a0791a955",
    "slug": "hoda-barakat-legal-consultancy",
    "name": "Hoda Barakat Legal Consultancy",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhCCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/22/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "08/13/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Hoda Barakat Legal Consultancy",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2476b8c2-8925-4cd7-8215-0d7a0791a955",
        "address": "The H Hotel ,334249 ,Dubai",
        "phone": "97143050858 / 971506454751",
        "email": "hoda@hblegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Hoda Barakat",
    "address": ",The H Hotel,Sheikh Zayed Road,Dubai,334249",
    "phone": "97143050858",
    "email": "hoda@hblegal.ae",
    "registrationNumber": "CF-2011-00101"
  },
  {
    "id": "ef4b209f-a5f1-446f-82de-1b0675bbf53b",
    "slug": "hogan-lovells-middle-east-llp",
    "name": "Hogan Lovells Middle East LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhMCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 18,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/07/2006 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/02/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Hogan Lovells Middle East LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ef4b209f-a5f1-446f-82de-1b0675bbf53b",
        "address": "",
        "phone": "97143779377 / 971505528593",
        "email": "rahail.ali@hoganlovells.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Rahail Ali",
    "address": "N/A",
    "phone": "97143779377",
    "email": "rahail.ali@hoganlovells.com",
    "registrationNumber": "CF-2006-00071"
  },
  {
    "id": "c462c65e-185a-4e81-8425-a87e3a2b6842",
    "slug": "holman-fenwick-willan-middle-east-llp",
    "name": "Holman Fenwick Willan Middle East LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhGCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 20,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/11/2005 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/28/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Holman Fenwick Willan Middle East LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c462c65e-185a-4e81-8425-a87e3a2b6842",
        "address": "",
        "phone": "97144230555 / 971504788443",
        "email": "yah@hfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Yaman Al Hawamdeh",
    "address": "N/A",
    "phone": "97144230555",
    "email": "yah@hfw.com",
    "registrationNumber": "CF-2005-00058"
  },
  {
    "id": "59a73632-40a0-4849-b120-4308dc6f8015",
    "slug": "hourani-partners-legal-consultancy-fzco",
    "name": "Hourani & Partners Legal Consultancy FZCO",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhQCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/05/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "08/04/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Hourani & Partners Legal Consultancy FZCO",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_59a73632-40a0-4849-b120-4308dc6f8015",
        "address": "One Central, The Offices 5 ,Dubai World Trade Centre ,554660 ,",
        "phone": "97142052030 / 971506566494",
        "email": "chourani@houranipartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Chadi Fadi Hourani",
    "address": ",One Central, The Offices 5,Trade Centre Seco",
    "phone": "97142052030",
    "email": "chourani@houranipartners.com",
    "registrationNumber": "CF-2021-00158"
  },
  {
    "id": "dd62d765-3845-4e09-b92b-1ba92c1e27e4",
    "slug": "hpl-yamalova-plewka-fzco",
    "name": "HPL Yamalova & Plewka FZCO",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhZCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/09/2009 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "08/30/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: HPL Yamalova & Plewka FZCO",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dd62d765-3845-4e09-b92b-1ba92c1e27e4",
        "address": "",
        "phone": "97144279812 / 971504597319",
        "email": "lyamalova@lylawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Lyudmila Yamalova",
    "address": "N/A",
    "phone": "97144279812",
    "email": "lyamalova@lylawyers.com",
    "registrationNumber": "CF-2009-00088"
  },
  {
    "id": "9acfebc7-35ab-48b8-94cf-e2dc19cd54c6",
    "slug": "hugh-fraser-international-legal-consultancy",
    "name": "Hugh Fraser International Legal Consultancy",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhGCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/01/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Hugh Fraser International Legal Consultancy",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9acfebc7-35ab-48b8-94cf-e2dc19cd54c6",
        "address": "Level 41, Emirates Towers ,Sheykh Zayed Road, World Trade Center, DIFC ,31303 ,",
        "phone": "97143827717 / 971585956361",
        "email": "hugh.fraser@hfi-consulting.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Hugh Fraser",
    "address": ",Level 41, Emirates Towers,Sheykh Zayed Road,",
    "phone": "97143197411",
    "email": "hugh.fraser@hfi-consulting.com",
    "registrationNumber": "CF-2021-00157"
  },
  {
    "id": "61016a31-ead9-482a-b4d3-7cd63e5ba82b",
    "slug": "hunton-andrews-kurth-ltd",
    "name": "Hunton Andrews Kurth Ltd",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/18/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/11/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Hunton Andrews Kurth Ltd",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_61016a31-ead9-482a-b4d3-7cd63e5ba82b",
        "address": "1 ,The Gate, East. ,The Gate District ,118273 ,Dubai",
        "phone": "97144019160 / 971506575038",
        "email": "ptiller@huntonak.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "JASON BRYAN PARKER",
    "address": "1,The Gate, East.,The Gate District,Dubai,118",
    "phone": "97144019160",
    "email": "ptiller@huntonak.com",
    "registrationNumber": "CF-2013-00111"
  },
  {
    "id": "8d9bc487-6793-4ea8-a629-49ba36823552",
    "slug": "iaa-middle-east-legal-consultants-ltd",
    "name": "IAA MIDDLE EAST LEGAL CONSULTANTS LTD",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIElNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/30/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/24/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: IAA MIDDLE EAST LEGAL CONSULTANTS LTD",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8d9bc487-6793-4ea8-a629-49ba36823552",
        "address": "5 ,LIBERTY HOUSE ,RITZ HOTEL DIFC ,506949 ,Dubai",
        "phone": "97143860090 / 971507887401",
        "email": "maalouf@iaalo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Roula Maalouf",
    "address": "5,LIBERTY HOUSE,DIFC,Dubai,506949",
    "phone": "97143860090",
    "email": "maalouf@iaalo.com",
    "registrationNumber": "CF-2014-00122"
  },
  {
    "id": "f85683bf-f79f-4e38-9b7c-a1a75cd840b4",
    "slug": "james-berry-associates-legal-consultants",
    "name": "James Berry & Associates Legal Consultants",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEpCCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 36,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/26/1989 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "12/08/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: James Berry & Associates Legal Consultants",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f85683bf-f79f-4e38-9b7c-a1a75cd840b4",
        "address": "1 ,API World Tower ,258.37 square meters ,52294 ,Dubai",
        "phone": "97143317552 / 971504524322",
        "email": "berry@jamesberrylaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "James Boyd Berry",
    "address": "1,API World Tower,Sheikh Zayed Road,Dubai,522",
    "phone": "97143317552",
    "email": "berry@jamesberrylaw.ae",
    "registrationNumber": "CF-1989-00008"
  },
  {
    "id": "8892bfe9-d3ec-4158-b4fd-1844606f4f30",
    "slug": "jones-day",
    "name": "Jones Day",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEpECiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/08/2009 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "01/28/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Jones Day",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8892bfe9-d3ec-4158-b4fd-1844606f4f30",
        "address": "",
        "phone": "97147098484 / 971505577206",
        "email": "slshadmand@jonesday.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Sheila Shadmand",
    "address": "N/A",
    "phone": "97147098484",
    "email": "slshadmand@jonesday.com",
    "registrationNumber": "CF-2009-00084"
  },
  {
    "id": "fb8fc340-ceef-4b83-8f2b-9b24d4604967",
    "slug": "k-l-gates-llp",
    "name": "K & L Gates LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEtMCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/29/2009 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/20/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: K & L Gates LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fb8fc340-ceef-4b83-8f2b-9b24d4604967",
        "address": "",
        "phone": "97144272700 / 971545824605",
        "email": "tony.griffiths@klgates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "ANTONY GRIFFITHS",
    "address": "N/A",
    "phone": "97144272700",
    "email": "tony.griffiths@klgates.com",
    "registrationNumber": "CF-2009-00087"
  },
  {
    "id": "f56db7d0-6202-42ba-ba72-78fe503184bd",
    "slug": "kamel-abu-saqer-legal-consultancy",
    "name": "Kamel Abu Saqer Legal Consultancy",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEtBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 21,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/15/2004 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/11/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Kamel Abu Saqer Legal Consultancy",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f56db7d0-6202-42ba-ba72-78fe503184bd",
        "address": "",
        "phone": "97144489983 / 971506554033",
        "email": "kamel@kaslegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Kamel Abu Saqer",
    "address": "N/A",
    "phone": "97144489983",
    "email": "kamel@kaslegal.com",
    "registrationNumber": "CF-2004-00048"
  },
  {
    "id": "291a9c0d-030a-4cef-8739-c6946f741117",
    "slug": "kbh-limited",
    "name": "KBH Limited",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEtMCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 19,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/01/2006 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/25/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: KBH Limited",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_291a9c0d-030a-4cef-8739-c6946f741117",
        "address": "Emirates Financial Towers (South) ,DIFC ,506546 ,",
        "phone": "97147096700 / 971505573843",
        "email": "dk@kbh.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Daleep Singh",
    "address": ",Emirates Financial Towers (South),DIFC,,5065",
    "phone": "97147096700",
    "email": "dk@kbh.ae",
    "registrationNumber": "CF-2006-00068"
  },
  {
    "id": "83d3ede1-3a28-4b03-8c92-6bd31a1cb95e",
    "slug": "kennedys-dubai-llp",
    "name": "Kennedys Dubai LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEtECiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 19,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/11/2006 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/20/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Kennedys Dubai LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_83d3ede1-3a28-4b03-8c92-6bd31a1cb95e",
        "address": "Building 5 ,Dubai World Trade Centre ,212620 ,",
        "phone": "97143503600 / 971563631562",
        "email": "p.ellingham@kennedys-law.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Peter Ellingham",
    "address": ",Building 5,One Central,,212620",
    "phone": "97143503600",
    "email": "p.ellingham@kennedys-law.com",
    "registrationNumber": "CF-2006-00066"
  },
  {
    "id": "dff8529a-82be-431a-b72b-0192ff238011",
    "slug": "king-spalding-llp",
    "name": "King & Spalding LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEtTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 18,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/18/2006 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/13/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: King & Spalding LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dff8529a-82be-431a-b72b-0192ff238011",
        "address": "",
        "phone": "97143779900 / 971508548052",
        "email": "jali@kslaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Nabil Issa",
    "address": "N/A",
    "phone": "97143779900",
    "email": "jali@kslaw.com",
    "registrationNumber": "CF-2006-00072"
  },
  {
    "id": "259f7732-3596-4559-ae29-21cb6f4aa7d8",
    "slug": "kobre-kim-gcc-llp",
    "name": "Kobre & Kim (GCC) LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEtLCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/03/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/02/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Kobre & Kim (GCC) LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_259f7732-3596-4559-ae29-21cb6f4aa7d8",
        "address": "",
        "phone": "97144543900 / 971569199020",
        "email": "paul.hughes@kobrekim.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Paul Hughes",
    "address": "N/A",
    "phone": "97144543900",
    "email": "paul.hughes@kobrekim.com",
    "registrationNumber": "CF-2021-00159"
  },
  {
    "id": "847eff7c-4142-431e-a8d6-f58ff60964f6",
    "slug": "kochhar-co-inc-legal-consultants-dubai-branch",
    "name": "Kochhar & Co Inc Legal Consultants (Dubai Branch)",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEtDCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/18/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/12/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Kochhar & Co Inc Legal Consultants (Dubai Branch)",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_847eff7c-4142-431e-a8d6-f58ff60964f6",
        "address": "",
        "phone": "97142776075 / 971588324788",
        "email": "avichal@kochhardubai.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Avichal Prasad Ashutosh Prasad",
    "address": "N/A",
    "phone": "97142776075",
    "email": "anjulis@kochhardubai.com",
    "registrationNumber": "CF-2014-00119"
  },
  {
    "id": "b2b92ce9-90a4-4e34-ae2f-ae0dc7ca9060",
    "slug": "latham-watkins-llp",
    "name": "Latham & Watkins LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIExXCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 17,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/26/2008 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "02/21/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Latham & Watkins LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b2b92ce9-90a4-4e34-ae2f-ae0dc7ca9060",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506698 ,Dubai",
        "phone": "97147046300 / 971507900661",
        "email": "nada.mourad@lw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Eyad Hashash",
    "address": "1,ICD Brookfield Place,Al Mustaqbal Street,Du",
    "phone": "97147046300",
    "email": "nada.mourad@lw.com",
    "registrationNumber": "CF-2008-00079"
  },
  {
    "id": "5cec94c0-0649-43b6-a2be-ab17ff422bce",
    "slug": "linklaters-llp",
    "name": "LinkLaters LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIExMCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 19,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/22/2006 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/27/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: LinkLaters LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5cec94c0-0649-43b6-a2be-ab17ff422bce",
        "address": "ICD Brookfield Place ,DIFC ,506516 ,",
        "phone": "97143695800 / 971505526206",
        "email": "scott.campbell@linklaters.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Scott Campbell",
    "address": ",ICD Brookfield Place,Mustaqbal Street,,50651",
    "phone": "97143695800",
    "email": "scott.campbell@linklaters.com",
    "registrationNumber": "CF-2006-00064"
  },
  {
    "id": "41e09f1e-f4be-4459-9a18-68ffbf7af78f",
    "slug": "long-an-law-firm-dubai-branch",
    "name": "Long An Law Firm - Dubai Branch",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIExBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/27/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Long An Law Firm - Dubai Branch",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_41e09f1e-f4be-4459-9a18-68ffbf7af78f",
        "address": "",
        "phone": "/ 971502168600",
        "email": "dabing@longanlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "N/A",
    "email": "dabing@longanlaw.com",
    "registrationNumber": "CF-2024-00178"
  },
  {
    "id": "4c158c98-1a29-48da-ade1-54e60bfd5b78",
    "slug": "lpa-middle-east-ltd",
    "name": "LPA (Middle East) LTD",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEwoCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/18/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/13/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: LPA (Middle East) LTD",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4c158c98-1a29-48da-ade1-54e60bfd5b78",
        "address": "Central Park Towers ,507120 ,",
        "phone": "97143200940 / 971502397176",
        "email": "lsahbani@lpalaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Nigel Hartridge",
    "address": ",Central Park Towers,Happiness Street,,507120",
    "phone": "97143200940",
    "email": "lsahbani@lpalaw.com",
    "registrationNumber": "CF-2016-00132"
  },
  {
    "id": "8569b29e-bcb6-4ddd-90d8-c6b90718e267",
    "slug": "mandviwalla-zafar-limited-liability-partnership",
    "name": "Mandviwalla & Zafar Limited Liability Partnership",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1aCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 18,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/10/2006 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/04/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Mandviwalla & Zafar Limited Liability Partnership",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8569b29e-bcb6-4ddd-90d8-c6b90718e267",
        "address": "AG House- Building Num 581 ,Al Muteena, Dubai ,11169 ,",
        "phone": "97143257977 / 971507086100",
        "email": "sheeza@mandviwallaandzafar.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Sheeza Ahmed",
    "address": ",AG House- Building Num 581,Salahuddin Street",
    "phone": "97143257977",
    "email": "sheeza@mandviwallaandzafar.com",
    "registrationNumber": "CF-2005-00062"
  },
  {
    "id": "0c02b881-6155-4298-81da-bf9bb6c1a171",
    "slug": "manuel-calzada-legal-consultancy-fz-llc",
    "name": "Manuel Calzada Legal Consultancy FZ LLC",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1DCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/08/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/07/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Manuel Calzada Legal Consultancy FZ LLC",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0c02b881-6155-4298-81da-bf9bb6c1a171",
        "address": "",
        "phone": "/ 971543665504",
        "email": "MC@ManuelCalzadaLegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Manuel Calzada Pla",
    "address": "N/A",
    "phone": "N/A",
    "email": "MC@ManuelCalzadaLegal.com",
    "registrationNumber": "CF-2022-00165"
  },
  {
    "id": "cb7cc285-8538-469a-b075-ef30819bce69",
    "slug": "maples-calder-dubai-llp",
    "name": "Maples & Calder (Dubai) LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1DCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 20,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/09/2005 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/28/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Maples & Calder (Dubai) LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cb7cc285-8538-469a-b075-ef30819bce69",
        "address": "Level 14 ,Burj Daman ,Four Seasons Hotel ,119980 ,Dubai",
        "phone": "97143604070 / 971502450485",
        "email": "Philip.ireland@maples.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Philip Ireland",
    "address": "Level 14,Burj Daman,Dubai International Finan",
    "phone": "97143604070",
    "email": "Philip.ireland@maples.com",
    "registrationNumber": "CF-2005-00053"
  },
  {
    "id": "2670beb4-7797-49f9-be6b-fab06a95fa93",
    "slug": "marina-fox-legal-consultancy",
    "name": "Marina Fox Legal Consultancy",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1GCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 20,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/09/2005 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/28/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Marina Fox Legal Consultancy",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2670beb4-7797-49f9-be6b-fab06a95fa93",
        "address": "",
        "phone": "97144312968 / 971505588607",
        "email": "mail@marinafox.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Marina Fox",
    "address": "N/A",
    "phone": "97144312968",
    "email": "mail@marinafox.com",
    "registrationNumber": "CF-2005-00052"
  },
  {
    "id": "c7f52b69-c049-4246-963a-9805b241f88a",
    "slug": "mayer-brown-llp",
    "name": "Mayer Brown LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1CCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/18/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/14/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Mayer Brown LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c7f52b69-c049-4246-963a-9805b241f88a",
        "address": "Index Tower ,Dubai International Financial Centre ,507115 ,",
        "phone": "97143757160 / 971523490280",
        "email": "tthraya@mayerbrown.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Tahan Thraya",
    "address": ",Index Tower,Al Mostaqbal Street,,507115",
    "phone": "97143757160",
    "email": "tthraya@mayerbrown.com",
    "registrationNumber": "CF-2016-00129"
  },
  {
    "id": "e294ccf7-baca-4016-876d-fcf8d296a3fc",
    "slug": "meyer-reumann-partners",
    "name": "Meyer Reumann & Partners",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1SCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 36,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/27/1989 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/05/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Meyer Reumann & Partners",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e294ccf7-baca-4016-876d-fcf8d296a3fc",
        "address": "1 ,Park Place Towe ,. ,9353 ,Dubai",
        "phone": "97143317110 / 971000000000",
        "email": "elena@meyer-reumann.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Elena Schildgen",
    "address": "1,Park Place Towe,Sheikh Zayed Road,Dubai,935",
    "phone": "97143317110",
    "email": "elena@meyer-reumann.com",
    "registrationNumber": "CF-1989-00006"
  },
  {
    "id": "18d46314-9f85-4421-9ec3-09c58c01fb76",
    "slug": "meysan-lawyers-and-legal-consultants-wll",
    "name": "Meysan Lawyers and Legal Consultants WLL",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1MCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/26/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/25/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Meysan Lawyers and Legal Consultants WLL",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_18d46314-9f85-4421-9ec3-09c58c01fb76",
        "address": "",
        "phone": "97100000000 / 971529999965",
        "email": "beljeaan@meysan.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Bader A N A Eljeaan",
    "address": "N/A",
    "phone": "97100000000",
    "email": "beljeaan@meysan.com",
    "registrationNumber": "CF-2024-00177"
  },
  {
    "id": "79cd353b-3808-4251-9bbc-af97fdf40780",
    "slug": "mohammad-alsaboosi-legal-advice",
    "name": "Mohammad Alsaboosi Legal Advice",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/02/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/01/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Mohammad Alsaboosi Legal Advice",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_79cd353b-3808-4251-9bbc-af97fdf40780",
        "address": "BIN DASMAL BUILDING ,Al Goze ,00000 ,",
        "phone": "/ 971557959999",
        "email": "mahmmadalsaboosi@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Mohammad Atiq Mubarak Saleh Alsaboosi",
    "address": ",BIN DASMAL BUILDING,Al Goze Industrial First",
    "phone": "N/A",
    "email": "mahmmadalsaboosi@gmail.com",
    "registrationNumber": "CF-2022-00163"
  },
  {
    "id": "e98bf25b-3da7-44cf-bb1c-28f6e31e271a",
    "slug": "mohammed-raei-alboom-legal-consultants",
    "name": "Mohammed Raei Alboom Legal Consultants",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1SCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/28/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Mohammed Raei Alboom Legal Consultants",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e98bf25b-3da7-44cf-bb1c-28f6e31e271a",
        "address": "",
        "phone": "/ 971555527527",
        "email": "m.raialboomadvocates@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Mohammed Yousuf Ahmed RaeiAlboom",
    "address": "N/A",
    "phone": "N/A",
    "email": "m.raialboomadvocates@gmail.com",
    "registrationNumber": "CF-2025-00182"
  },
  {
    "id": "6f0ce9e2-8a80-46ee-a843-15e621a85237",
    "slug": "mojahed-al-sebae-legal-consultancy",
    "name": "Mojahed Al Sebae Legal Consultancy",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/04/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/03/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Mojahed Al Sebae Legal Consultancy",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6f0ce9e2-8a80-46ee-a843-15e621a85237",
        "address": "",
        "phone": "/ 971000000000",
        "email": "info@alsebae.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Mojahed Al Sebae",
    "address": "N/A",
    "phone": "N/A",
    "email": "info@alsebae.com",
    "registrationNumber": "CF-2024-00175"
  },
  {
    "id": "6eab20d7-8716-4b0a-8710-144d1d951c23",
    "slug": "morgan-lewis-bockius-llp-dubai-branch",
    "name": "Morgan, Lewis & Bockius LLP (dubai Branch)",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1MCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/07/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "07/01/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Morgan, Lewis & Bockius LLP (dubai Branch)",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6eab20d7-8716-4b0a-8710-144d1d951c23",
        "address": "",
        "phone": "97143121800 / 971566017967",
        "email": "alishia.sullivan@morganlewis.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Alishia Kathryn Sullivan",
    "address": ",One Za'abeel Tower/ Offices No. 1203, 1204,",
    "phone": "97143121800",
    "email": "alishia.sullivan@morganlewis.com",
    "registrationNumber": "CF-2014-00120"
  },
  {
    "id": "b898c8c8-b27a-4895-a7df-903b3dec14f6",
    "slug": "motei-associates-llc",
    "name": "Motei & Associates L.L.C",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 23,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/31/2002 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/18/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Motei & Associates L.L.C",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b898c8c8-b27a-4895-a7df-903b3dec14f6",
        "address": "Unit 801, 8th Floor ,Damac Executive Heights ,Time Oak Hotel ,112888 ,Dubai",
        "phone": "97144355959 / 971551049797",
        "email": "a.motei@motei.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Ashraf El Motei",
    "address": "Unit 801, 8th Floor,Damac Executive Heights,E",
    "phone": "97144355959",
    "email": "a.motei@motei.com",
    "registrationNumber": "CF-2003-00040"
  },
  {
    "id": "03128ecc-d5a8-4c5b-bf8d-e4b8ca185b21",
    "slug": "najjar-associates-legal-consultants",
    "name": "Najjar & Associates Legal Consultants",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE5BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 23,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/31/2002 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/13/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Najjar & Associates Legal Consultants",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_03128ecc-d5a8-4c5b-bf8d-e4b8ca185b21",
        "address": "",
        "phone": "97143244662 / 971506518966",
        "email": "najarlaw@eim.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Imad Najjar",
    "address": "N/A",
    "phone": "97143244662",
    "email": "najarlaw@eim.ae",
    "registrationNumber": "CF-2002-00034"
  },
  {
    "id": "42a35604-227b-4c05-8095-770c821b3d4f",
    "slug": "nexlaw-maritime-legal-consultancy",
    "name": "Nexlaw Maritime Legal Consultancy",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE5NCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/05/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/01/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Nexlaw Maritime Legal Consultancy",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_42a35604-227b-4c05-8095-770c821b3d4f",
        "address": "Saeed Tower 2 ,Trade centre ,124942 ,",
        "phone": "/ 971508470447",
        "email": "ravi@nexlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Ravi Ravindran",
    "address": ",Saeed Tower 2,Sh. Zayed Road,,124942",
    "phone": "N/A",
    "email": "ravi@nexlaw.com",
    "registrationNumber": "CF-2016-00130"
  },
  {
    "id": "e6861747-2e67-4f04-9544-43b42661b573",
    "slug": "norton-rose-fulbright-middle-east-llp-dubai-branch",
    "name": "Norton Rose Fulbright (Middle East) LLP Dubai Branch",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE5SCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 22,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/20/2003 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/28/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Norton Rose Fulbright (Middle East) LLP Dubai Branch",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e6861747-2e67-4f04-9544-43b42661b573",
        "address": "0 ,ICD Brookfield Place ,Za'abeel 2 ,103747 ,Dubai",
        "phone": "97143696300 / 971506008159",
        "email": "mohammed.paracha@nortonrosefulbright.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": null,
    "address": "0,ICD Brookfield Place,Al Mustaqbal St.,Dubai",
    "phone": "97143696300",
    "email": "mohammed.paracha@nortonrosefulbright.com",
    "registrationNumber": "CF-2003-00145"
  },
  {
    "id": "c4aaee93-0ec4-4982-9a48-a23699492056",
    "slug": "norton-rose-fullbright-middle-east-llp",
    "name": "Norton Rose Fullbright (Middle East) LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE5SCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 22,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/20/2003 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/28/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Norton Rose Fullbright (Middle East) LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c4aaee93-0ec4-4982-9a48-a23699492056",
        "address": "ICD Brookfield Place ,Za'abeel 2 ,103747 ,",
        "phone": "97143696300 / 971506008159",
        "email": "mohammed.paracha@nortonrosefulbright.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Mohammad Paracha",
    "address": ",ICD Brookfield Place,Al Mustaqbal St.,,10374",
    "phone": "97143696300",
    "email": "mohammed.paracha@nortonrosefulbright.com",
    "registrationNumber": "CF-2003-00045"
  },
  {
    "id": "6412dd75-56e7-47d4-90a8-5c34e1e0eb3a",
    "slug": "obeid-law-firm-partners-dubai-branch",
    "name": "Obeid Law Firm & Partners-Dubai Branch",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE9MCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/17/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "01/16/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Obeid Law Firm & Partners-Dubai Branch",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6412dd75-56e7-47d4-90a8-5c34e1e0eb3a",
        "address": "",
        "phone": "97140000000 / 971564600544",
        "email": "nayla@obeidpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Nayla Comair",
    "address": "N/A",
    "phone": "97140000000",
    "email": "nayla@obeidpartners.com",
    "registrationNumber": "CF-2021-00154"
  },
  {
    "id": "7387d35c-79ea-44c2-88c5-58669a5e825d",
    "slug": "ogier-difc-llp",
    "name": "Ogier (DIFC) LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE8oCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/24/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "08/23/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Ogier (DIFC) LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7387d35c-79ea-44c2-88c5-58669a5e825d",
        "address": "Unit No. S1003, Level 10 ,Emirates Financial Towers ,Dubai International Financial Centre ,000 ,Dubai",
        "phone": "97144501900 / 971566072398",
        "email": "david.welford@ogier.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "David Iain Fraser Welford",
    "address": "Unit No. S1003, Level 10,Emirates Financial T",
    "phone": "97144501900",
    "email": "david.welford@ogier.com",
    "registrationNumber": "CF-2023-00171"
  },
  {
    "id": "361fdc64-6b6f-4f37-abca-c52af8473b84",
    "slug": "pinsent-masons-llp-dwtca-branch",
    "name": "Pinsent Masons  LLP (DWTCA Branch)",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFBNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 17,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/29/2008 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/27/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Pinsent Masons  LLP (DWTCA Branch)",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_361fdc64-6b6f-4f37-abca-c52af8473b84",
        "address": "THE OFFICES 1 ,DWTC ,115580 ,",
        "phone": "97143739700 / 971501148248",
        "email": "nitesh.pradhan@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": null,
    "address": ",THE OFFICES 1,SHEIKH ZAYED ROAD,,115580",
    "phone": "97143739700",
    "email": "nitesh.pradhan@pinsentmasons.com",
    "registrationNumber": "CF-2008-00153"
  },
  {
    "id": "6b4ebb23-ef2e-4305-a1ee-43a11e4b1cae",
    "slug": "pinsent-masons-llp-dubai-branch",
    "name": "Pinsent Masons LLP - Dubai Branch",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFBNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 17,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/29/2008 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/27/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Pinsent Masons LLP - Dubai Branch",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6b4ebb23-ef2e-4305-a1ee-43a11e4b1cae",
        "address": "- ,THE OFFICES 1 ,DWTC ,115580 ,Dubai",
        "phone": "97143739700 / 971562196031",
        "email": "catherine.workman@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "CATHERINE ANN WORKMAN",
    "address": "-,THE OFFICES 1,SHEKH ZAYED ROAD,Dubai,115580",
    "phone": "97143739700",
    "email": "catherine.workman@pinsentmasons.com",
    "registrationNumber": "CF-2008-00080"
  },
  {
    "id": "34535f10-f4ea-464a-93a1-5337328fdd81",
    "slug": "pro-lcf1-desc",
    "name": "Pro LCF1 (DESC)",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFBMCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/09/2021",
    "licenseStatus": "active",
    "licenseExpiry": "2022-09-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Pro LCF1 (DESC)",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_34535f10-f4ea-464a-93a1-5337328fdd81",
        "address": "",
        "phone": "97140000000 / 971508360023",
        "email": "annadurai@legal.dubai.gov.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Pro LC1 (DESC)"
  },
  {
    "id": "ea026b18-c93c-4f67-a1f2-4546320f8f3e",
    "slug": "pwc-legal-middle-east-llp",
    "name": "PWC Legal Middle East LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFBMCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 15,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/27/2009 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/07/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: PWC Legal Middle East LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ea026b18-c93c-4f67-a1f2-4546320f8f3e",
        "address": "1 ,Emaar Square 5 ,sheikh mohammed bin rashid BVD ,11987 ,Dubai",
        "phone": "97143043100 / 971507325154",
        "email": "amir.kordvani@pwc.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Amir Kordvani",
    "address": "1,Emaar Square 5,Emaar Square ,Dubai,11987",
    "phone": "97143043100",
    "email": "walaa.ibrahim@pwc.com",
    "registrationNumber": "CF-2009-00089"
  },
  {
    "id": "00f80d3b-b680-4931-9e94-ba7b92b50375",
    "slug": "quinn-emanuel-urquhart-sullivan-uk-llp-dubai-branch",
    "name": "Quinn Emanuel Urquhart & Sullivan UK LLP- Dubai Branch",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFFFCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/12/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/11/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Quinn Emanuel Urquhart & Sullivan UK LLP- Dubai Branch",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_00f80d3b-b680-4931-9e94-ba7b92b50375",
        "address": "",
        "phone": "/ 971507758307",
        "email": "joannestrain@quinnemanuel.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": null,
    "address": "N/A",
    "phone": "N/A",
    "email": "joannestrain@quinnemanuel.com",
    "registrationNumber": "CF-2025-00181"
  },
  {
    "id": "b3f87e90-7ce9-4097-82c4-15232365f175",
    "slug": "reed-smith-llp",
    "name": "Reed Smith LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFJTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 19,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/25/2006 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/28/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Reed Smith LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b3f87e90-7ce9-4097-82c4-15232365f175",
        "address": "Index Tower ,506548 ,Dubai",
        "phone": "97147096300 / 971506767433",
        "email": "amateen@reedsmith.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Sachin Kerur",
    "address": ",Index Tower,Al Saada Street,Dubai,506548",
    "phone": "97147096300",
    "email": "amateen@reedsmith.com",
    "registrationNumber": "CF-2006-00069"
  },
  {
    "id": "827d9d4c-3af8-4363-a38f-9b8eafda9b85",
    "slug": "riaa-barker-gillette-middle-east-llp",
    "name": "RIAA Barker Gillette (Middle East) LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFJCCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/23/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "07/18/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: RIAA Barker Gillette (Middle East) LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_827d9d4c-3af8-4363-a38f-9b8eafda9b85",
        "address": "Level 07, Gate Village Building 10 ,Dubai International Financial Centre ,507014 ,",
        "phone": "97144019410 / 971504557972",
        "email": "hasan.rizvi@riaabg.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Syed Rizvi",
    "address": ",Level 07, Gate Village Building 10,Dubai Int",
    "phone": "97144019410",
    "email": "hasan.rizvi@riaabg.com",
    "registrationNumber": "CF-2015-00123"
  },
  {
    "id": "3d9f2bb9-85fe-49cc-9187-0b808bfa2a2d",
    "slug": "rindala-beydoun-legal-consultancy",
    "name": "Rindala Beydoun Legal Consultancy",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFJCCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/22/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "12/21/2025 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Rindala Beydoun Legal Consultancy",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3d9f2bb9-85fe-49cc-9187-0b808bfa2a2d",
        "address": "",
        "phone": "97145979700 / 971505532609",
        "email": "rbeydoun@t-lawadvisors.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Rindala Beydoun",
    "address": "N/A",
    "phone": "97145979700",
    "email": "rbeydoun@t-lawadvisors.com",
    "registrationNumber": "CF-2002-00035"
  },
  {
    "id": "e92477d1-b4b2-4506-b1a4-99c4a9cfa443",
    "slug": "roedl-partner-dubai-branch",
    "name": "Roedl & Partner (Dubai Branch)",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFJQCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/02/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/26/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Roedl & Partner (Dubai Branch)",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e92477d1-b4b2-4506-b1a4-99c4a9cfa443",
        "address": "Boulevard Plaza Tower 2 ,Burj Khalifa ,23297 ,",
        "phone": "97142950020 / 971526443550",
        "email": "nicola.lohrey@roedl.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Nicola Lohrey Hontarrede",
    "address": ",Boulevard Plaza Tower 2,Burj Khalifa,,23297",
    "phone": "97142950020",
    "email": "mohammad.elneemani@roedl.com",
    "registrationNumber": "CF-2013-00112"
  },
  {
    "id": "9df4d4e5-5243-4fae-8d95-463d110ce6a8",
    "slug": "rouse-co-international-limited-dubai-branch",
    "name": "Rouse & Co International Limited (Dubai Branch)",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFJDCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 23,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/19/2002 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "02/24/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Rouse & Co International Limited (Dubai Branch)",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9df4d4e5-5243-4fae-8d95-463d110ce6a8",
        "address": "",
        "phone": "97143098000 / 971552210883",
        "email": "belturk@rouse.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Bassel El Turk",
    "address": "N/A",
    "phone": "97143098000",
    "email": "belturk@rouse.com",
    "registrationNumber": "CF-2002-00032"
  },
  {
    "id": "7a4cdbcc-cf3b-4347-b745-b8e670c81ca0",
    "slug": "rycx-legal-consultants",
    "name": "Rycx Legal Consultants",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFJMCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 27,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/17/1997 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/23/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Rycx Legal Consultants",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7a4cdbcc-cf3b-4347-b745-b8e670c81ca0",
        "address": "",
        "phone": "97143467303 / 971506565383",
        "email": "rycx@rycx-advocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Jean-Francois Rycx",
    "address": "N/A",
    "phone": "97143467303",
    "email": "rycx@rycx-advocates.com",
    "registrationNumber": "CF-1997-00019"
  },
  {
    "id": "2ce110f0-b433-4dbc-b15f-ab1a3b291c28",
    "slug": "schluter-graf-legal-consultants-llc",
    "name": "Schluter Graf Legal Consultants LLC",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNHCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 29,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/25/1996 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "11/13/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Schluter Graf Legal Consultants LLC",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2ce110f0-b433-4dbc-b15f-ab1a3b291c28",
        "address": "A7 ,Dubai Silicon Oasis ,29337 ,",
        "phone": "97144313060 / 971528448686",
        "email": "andres.ring@schlueter-graf.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Andrés Ring",
    "address": ",A7,Dubai Digital Park,,29337",
    "phone": "97144313060",
    "email": "andres.ring@schlueter-graf.com",
    "registrationNumber": "CF-1996-00017"
  },
  {
    "id": "37640b04-09c4-40ce-9a45-39984d67ff30",
    "slug": "shurooq-zainal-legal-consultants-llc",
    "name": "Shurooq Zainal Legal Consultants LLC",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNaCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/21/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Shurooq Zainal Legal Consultants LLC",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_37640b04-09c4-40ce-9a45-39984d67ff30",
        "address": "Office No.08-150 ,Dubai World Trade Centre ,Dubai World Trade Centre ,000 ,Dubai",
        "phone": "97100000000 / 971504598323",
        "email": "Shurooq.f.zainal@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": null,
    "address": "Office No.08-150,Dubai World Trade Centre,Tra",
    "phone": "97100000000",
    "email": "Shurooq.f.zainal@gmail.com",
    "registrationNumber": "CF-2025-00184"
  },
  {
    "id": "32091971-c716-41d1-a21d-cc50c9fb3214",
    "slug": "sidley-austin-llp",
    "name": "Sidley Austin LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/19/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/18/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Sidley Austin LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_32091971-c716-41d1-a21d-cc50c9fb3214",
        "address": "",
        "phone": "/ 971000000000",
        "email": "tthesing@sidley.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Thomas Moore Thesing",
    "address": "N/A",
    "phone": "N/A",
    "email": "tthesing@sidley.com",
    "registrationNumber": "CF-2023-00174"
  },
  {
    "id": "790219ab-49b9-40f2-97c3-bff01feebf69",
    "slug": "silk-legal-company-limited",
    "name": "Silk Legal Company Limited",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNMCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/28/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/27/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Silk Legal Company Limited",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_790219ab-49b9-40f2-97c3-bff01feebf69",
        "address": "Unit 03-OF-02-03-OF-09, Level 03 ,Gate Village Building 08 ,Dubai International Financial Centre ,000 ,Dubai",
        "phone": "97100000000 / 971501051651",
        "email": "gabriel@uae.silklegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Gabriel Khoury",
    "address": "Unit 03-OF-02-03-OF-09, Level 03,Gate Village",
    "phone": "97100000000",
    "email": "gabriel@uae.silklegal.com",
    "registrationNumber": "CF-2023-00173"
  },
  {
    "id": "4598ef43-2037-4fbd-8019-d73482ff25f9",
    "slug": "simmons-simmons-middle-east-llp-ded",
    "name": "Simmons & Simmons (Middle East) LLP-DED",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 21,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/13/2004 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Simmons & Simmons (Middle East) LLP-DED",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4598ef43-2037-4fbd-8019-d73482ff25f9",
        "address": "- ,The Gate Village Building 10 ,DIFC ,506688 ,Dubai",
        "phone": "97147096600 / 971505564007",
        "email": "muneer.khan@simmons-simmons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": null,
    "address": "-,The Gate Village Building 10,Dubai Internat",
    "phone": "97147096600",
    "email": "muneer.khan@simmons-simmons.com",
    "registrationNumber": "CF-2003-00043"
  },
  {
    "id": "d1725ca7-06ac-41b2-8d7b-a6e60665b73d",
    "slug": "simmons-simmons-middle-east-llp-difc",
    "name": "Simmons & Simmons (Middle East) LLP-DIFC",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 21,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/13/2004 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/28/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Simmons & Simmons (Middle East) LLP-DIFC",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d1725ca7-06ac-41b2-8d7b-a6e60665b73d",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506688 ,Dubai",
        "phone": "97147096600 / 971503556811",
        "email": "muneer.khan@simmons-simmons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Muneer Khan",
    "address": "1,ICD Brookfield Place,Al Mustaqbal St,Dubai,",
    "phone": "97147096600",
    "email": "muneer.khan@simmons-simmons.com",
    "registrationNumber": "CF-2003-00136"
  },
  {
    "id": "85be541a-c87f-45a9-a321-d90abd6b7298",
    "slug": "squire-patton-boggs-mea-llp",
    "name": "Squire Patton Boggs (MEA) LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNQCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 18,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/15/2007 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/04/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Squire Patton Boggs (MEA) LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_85be541a-c87f-45a9-a321-d90abd6b7298",
        "address": "",
        "phone": "97144478700 / 971528553200",
        "email": "Thomas.Wilson@squirepb.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Thomas Wilson",
    "address": "N/A",
    "phone": "97144478700",
    "email": "Thomas.Wilson@squirepb.com",
    "registrationNumber": "CF-2007-00073"
  },
  {
    "id": "dd5042a2-bb41-4123-9544-79c3fa831332",
    "slug": "stephenson-harwood-middle-east-llp",
    "name": "Stephenson Harwood (Middle East) LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/04/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/26/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Stephenson Harwood (Middle East) LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dd5042a2-bb41-4123-9544-79c3fa831332",
        "address": "",
        "phone": "97144073901 / 971503479508",
        "email": "Rania.Tadros@stephensonharwood.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Rania Tadros",
    "address": "N/A",
    "phone": "97144073901",
    "email": "Rania.Tadros@stephensonharwood.com",
    "registrationNumber": "CF-2012-00108"
  },
  {
    "id": "1607c199-ca4b-4bc1-89e9-98dad0300645",
    "slug": "support-legal-difc-limited",
    "name": "Support Legal ( DIFC) Limited",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNMCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/18/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/17/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Support Legal ( DIFC) Limited",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1607c199-ca4b-4bc1-89e9-98dad0300645",
        "address": "IH-00-01-CP-05 ,DIFC ,506832 ,",
        "phone": "/ 971506957753",
        "email": "admin@supportlegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Lee Michael Mcmahon",
    "address": ",IH-00-01-CP-05,Innovation One ,,506832",
    "phone": "N/A",
    "email": "admin@supportlegal.com",
    "registrationNumber": "CF-2021-00156"
  },
  {
    "id": "d51b6f43-8c62-486f-a1ab-6ee3b87c8006",
    "slug": "taylor-wessing-llp-dubai-branch",
    "name": "Taylor Wessing LLP (Dubai Branch)",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFRXCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 15,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/02/2009 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "08/30/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Taylor Wessing LLP (Dubai Branch)",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d51b6f43-8c62-486f-a1ab-6ee3b87c8006",
        "address": "",
        "phone": "97104309100 / 971564013758",
        "email": "c.royle@taylorwessing.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "RONALD STEWART GRAHAM",
    "address": "N/A",
    "phone": "97104309100",
    "email": "c.royle@taylorwessing.com",
    "registrationNumber": "CF-2009-00091"
  },
  {
    "id": "32cfe924-83e7-4945-9ef4-a245de15d0ee",
    "slug": "the-international-law-firm",
    "name": "The International Law Firm",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIElMCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/24/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/16/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: The International Law Firm",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_32cfe924-83e7-4945-9ef4-a245de15d0ee",
        "address": "Sapphire Tower ,Port Saeed ,28411 ,",
        "phone": "97142287730 / 971506284004",
        "email": "lawfirm@ilf.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Abdelhalim Kadi",
    "address": ",Sapphire Tower,Al Ittihad Street,,28411",
    "phone": "97142287730",
    "email": "lawfirm@ilf.ae",
    "registrationNumber": "CF-2012-00027"
  },
  {
    "id": "9b87f290-69e4-4ce7-abac-c0457574a0a5",
    "slug": "tiefenthaler-attorneys-incorporated-dubai-branch",
    "name": "Tiefenthaler Attorneys Incorporated - Dubai Branch",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFRBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/28/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/27/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Tiefenthaler Attorneys Incorporated - Dubai Branch",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9b87f290-69e4-4ce7-abac-c0457574a0a5",
        "address": "",
        "phone": "97145124129 / 971547315151",
        "email": "ryan@constructionlaw.co.za",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Ryan Du Preez",
    "address": "N/A",
    "phone": "97145124129",
    "email": "ryan@constructionlaw.co.za",
    "registrationNumber": "CF-2024-00176"
  },
  {
    "id": "4a6253d9-d6c0-479e-81a8-dcfe44ef60fa",
    "slug": "trench-associates-dmcc",
    "name": "Trench & Associates DMCC",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFRBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 29,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/10/1996 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "08/30/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Trench & Associates DMCC",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4a6253d9-d6c0-479e-81a8-dcfe44ef60fa",
        "address": "",
        "phone": "97143553146 / 971506240472",
        "email": "ct@trenchlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Cynthia Trench",
    "address": "N/A",
    "phone": "97143553146",
    "email": "ct@trenchlaw.com",
    "registrationNumber": "CF-1996-00013"
  },
  {
    "id": "976857f5-9092-43cf-987d-bfa794a3fa51",
    "slug": "trowers-hamlins-llp",
    "name": "Trowers & Hamlins LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFRICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 34,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/26/1991 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "10/02/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Trowers & Hamlins LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_976857f5-9092-43cf-987d-bfa794a3fa51",
        "address": "",
        "phone": "97143025100 / 971501501837",
        "email": "ccairns@trowers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Cheryl Cairns",
    "address": "N/A",
    "phone": "97143025100",
    "email": "ccairns@trowers.com",
    "registrationNumber": "CF-1991-00010"
  },
  {
    "id": "272328d6-db51-4b0e-b8bc-5297a958940d",
    "slug": "tws-legal-consultants-dmcc",
    "name": "TWS Legal Consultants DMCC",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFRMCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 15,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/29/2010 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/18/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: TWS Legal Consultants DMCC",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_272328d6-db51-4b0e-b8bc-5297a958940d",
        "address": "",
        "phone": "97144484284 / 971559776272",
        "email": "nita@willsuae.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Nita Maru",
    "address": "N/A",
    "phone": "97144484284",
    "email": "nita@willsuae.com",
    "registrationNumber": "CF-2010-00092"
  },
  {
    "id": "61216046-6cd5-410d-a301-532f3e520e30",
    "slug": "vinson-elkins-llp",
    "name": "Vinson & Elkins LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFZFCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 22,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/20/2003 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/28/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Vinson & Elkins LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_61216046-6cd5-410d-a301-532f3e520e30",
        "address": "Gate Village 10 ,Dubai International Financial Centre ,504945 ,",
        "phone": "97143301800 / 971569904245",
        "email": "nikram@velaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Nabeel Ikram",
    "address": ",Gate Village 10,Al Mustaqbal Street,,504945",
    "phone": "97143301800",
    "email": "nikram@velaw.com",
    "registrationNumber": "CF-2003-00044"
  },
  {
    "id": "a3a9927b-d51c-490c-8be6-d575ea3eb041",
    "slug": "walkers-middle-east-llp",
    "name": "Walkers (Middle East) LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFcoCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 19,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/28/2005 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "08/30/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Walkers (Middle East) LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a3a9927b-d51c-490c-8be6-d575ea3eb041",
        "address": "",
        "phone": "97143637999 / 971506525633",
        "email": "daniel.wood@walkersglobal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Daniel Wood",
    "address": "N/A",
    "phone": "97143637999",
    "email": "daniel.wood@walkersglobal.com",
    "registrationNumber": "CF-2005-00061"
  },
  {
    "id": "e2b82cfc-80a5-4957-ae41-b1a7beb693c1",
    "slug": "watson-farley-williams-middle-east-llp",
    "name": "Watson, Farley & Williams (Middle East) LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFdGCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/18/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/11/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Watson, Farley & Williams (Middle East) LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e2b82cfc-80a5-4957-ae41-b1a7beb693c1",
        "address": "Index Tower ,DIFC ,506896 ,",
        "phone": "97142782300 / 971551154791",
        "email": "GLeggate@wfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Charlotte Bijlani",
    "address": ",Index Tower,Al Mustaqbal Street,,506896",
    "phone": "97142782300",
    "email": "GLeggate@wfw.com",
    "registrationNumber": "CF-2014-00118"
  },
  {
    "id": "563739b7-e060-4925-9dc8-6c36ec982349",
    "slug": "white-case-llp-difc",
    "name": "White & Case LLP-DIFC",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMzNzQxNTE7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNmE3NDg0O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFdDCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/22/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "04/14/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: White & Case LLP-DIFC",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_563739b7-e060-4925-9dc8-6c36ec982349",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultancy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Firms",
    "owner": "Jan Olavi Jensen",
    "address": ",ICD Brookfield Place ,Dubai International Fi",
    "phone": "97143816200",
    "email": "asif.abubacker@whitecase.com",
    "registrationNumber": "CF-2013-00140"
  },
  {
    "id": "abe632e4-47b0-4905-9985-f23689fdc747",
    "slug": "abdulla-abdulrahman-abdulkarim-abdulla-alkhatib",
    "name": "ABDULLA ABDULRAHMAN SH ABDULKARIM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/12/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Abdulrahman Abdulkarim Abdulla Alkhatib",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_abe632e4-47b0-4905-9985-f23689fdc747",
        "address": "ali mohamed saif ,مكتب 1501 ,داماس ,رقة البطين ,25900 ,Dubai",
        "phone": "97142555779 / 971553616616",
        "email": "info@aleter.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "9dd97fa5-b744-465f-bac7-8ab23b9eda4f",
    "firmName": "ALI ALETER ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-1329",
    "licenseIssueDate": "12/24/2018 00:00:00",
    "licenseExpiryDate": "12/23/2025 00:00:00"
  },
  {
    "id": "2f34eb85-30ff-4d36-9a90-eabe67509524",
    "slug": "abdulla-abdulrahman-mohammed-al-saeedi",
    "name": "ABDULLA ABDULRAHMAN MOHAMMED ALSAEEDI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 42,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/11/1982",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Abdulrahman Mohammed Al-Saeedi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2f34eb85-30ff-4d36-9a90-eabe67509524",
        "address": "almetaq insurance  ,alnouf tower ,business vilage  ,92422 ,Dubai",
        "phone": "97142974555",
        "email": "info@alsaeedilaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "5684cb2e-d43e-411d-b69e-2e1976782a55",
    "firmName": "ALSAEEDI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-112",
    "licenseIssueDate": "11/30/1982 00:00:00",
    "licenseExpiryDate": "11/29/2025 00:00:00"
  },
  {
    "id": "8a851f45-338c-4077-be00-810804840aab",
    "slug": "abdulla-hassan-abdulla-ibrahim-al-ali",
    "name": "ABDALLA HASSAN ABDALLA IBRAHIM ALALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 34,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/12/1990",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Hassan Abdulla Ibrahim Al-Ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8a851f45-338c-4077-be00-810804840aab",
        "address": "",
        "phone": "97142959933",
        "email": "alaliadv@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "a65968c3-f5c5-4cf1-89eb-1704f1c99056",
    "firmName": "ABDULLA AL - ALI & ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-219",
    "licenseIssueDate": "12/12/1990 00:00:00",
    "licenseExpiryDate": "12/11/2025 00:00:00"
  },
  {
    "id": "3b5bd5ba-e23b-47a8-8e5a-cfd630f9027c",
    "slug": "abdulrahman-abdulghaffar-abdulrahman-al-sharif",
    "name": "ABDULRAHMAN ABDULGHAFFAR ABDULRAHMAN ALSHARIF",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 42,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/11/1982",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulrahman Abdulghaffar Abdulrahman Al-Sharif",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3b5bd5ba-e23b-47a8-8e5a-cfd630f9027c",
        "address": "7 ,سوفيتل ,محطة برج خليفة  ,8867 ,Dubai",
        "phone": "97143488808",
        "email": "secretary@dubailaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "dab6c960-06bf-4107-b633-52015cf4be6a",
    "firmName": "AL SHARIF ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-111",
    "licenseIssueDate": "11/20/1982 00:00:00",
    "licenseExpiryDate": "11/19/2025 00:00:00"
  },
  {
    "id": "af228b12-b3e4-4a1b-9b11-56772d6828e4",
    "slug": "abdulrahman-ahmed-abdullah-mohammed",
    "name": "ABDULRAHMAN AHMAD ABDULLA MOHAMMAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/01/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: AbdulRahman Ahmed Abdullah Mohammed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_af228b12-b3e4-4a1b-9b11-56772d6828e4",
        "address": "",
        "phone": "97148843777 / 971508825889",
        "email": "info@arlawyers.me",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "e49cde31-d86a-482d-a53c-b2eb1265fb1f",
    "firmName": "ABDULRAHMAN AHMED ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-158",
    "licenseIssueDate": "01/26/2011 00:00:00",
    "licenseExpiryDate": "01/25/2026 00:00:00"
  },
  {
    "id": "b239604c-b3a6-4b1b-9dbf-0225e51468fe",
    "slug": "hamdan-abdullah-mohammed-ibrahim-sayyah",
    "name": "HAMDAN ABDULLA MOHAMED SAYYAH ALMARZOOQI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 20,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/01/2005",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hamdan Abdullah Mohammed Ibrahim Sayyah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b239604c-b3a6-4b1b-9dbf-0225e51468fe",
        "address": "Hamdan Abdulla Mohamed Al Sayyah ,First Floor Office 108 ,Alserkal Building ,Beside Alkhoory Sky Gardens ,116499 ,Dubai",
        "phone": "97144491085",
        "email": "info@als-legal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "2cfc8314-1db4-4102-9720-3a65b58a8b0d",
    "firmName": "AL SAYYAH ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-501",
    "licenseIssueDate": "01/10/2005 00:00:00",
    "licenseExpiryDate": "01/09/2026 00:00:00"
  },
  {
    "id": "d54fe7af-d3c6-4b34-a815-db25cf852c8b",
    "slug": "hashim-ahmed-abdulrahem-hashim",
    "name": "HASHIM S AHMAD S ABDULRAHIM ALHASHIMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 18,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/04/2007",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hashim Ahmed AbdulRahem Hashim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d54fe7af-d3c6-4b34-a815-db25cf852c8b",
        "address": "HASHIM SAYED AHMED SAYED A RAHIM ALHASHIMI ,ZOOM ,بناية مكاتب ,مقابل معرض تويوتا - خلف وكالة نيسان ,2852 ,Dubai",
        "phone": "",
        "email": "lawyers@alhashimi-lf.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "9dedc5d0-f4c4-47ed-a06b-62ab5e13a6cd",
    "firmName": "ALHASHIMI LAW FIRMS AND LEGAL CONSULTING",
    "registrationNumber": "L-187",
    "licenseIssueDate": "04/16/2007 00:00:00",
    "licenseExpiryDate": "04/15/2026 00:00:00"
  },
  {
    "id": "f54f97da-c7a4-4991-8f74-8bf5745b3cd7",
    "slug": "ibraheim-mohammed-ahmad-mphammed-al-qasem",
    "name": "IBRAHIM MOHAMMAD AHMAD MOHAMMAD ALQASSIM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 35,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/11/1989",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ibraheim Mohammed Ahmad Mphammed Al-Qasem",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f54f97da-c7a4-4991-8f74-8bf5745b3cd7",
        "address": "",
        "phone": "97142224441",
        "email": "info@ialqassim.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "41cb350f-b39d-4e9d-aaed-e79bb9af487d",
    "firmName": "IBRAHIM AL QASSIM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-200",
    "licenseIssueDate": "11/18/1989 00:00:00",
    "licenseExpiryDate": "11/17/2025 00:00:00"
  },
  {
    "id": "8ccd26c9-ba64-41c2-aecc-1cc873abd1c7",
    "slug": "mohammad-murtada-yaqoob-burhan-alhashimi",
    "name": "MOHAMMAD MURTADA YAQOOB MURTADA ALHASHMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/04/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammad Murtada Yaqoob Burhan AlHashimi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8ccd26c9-ba64-41c2-aecc-1cc873abd1c7",
        "address": "MOHAMMED MURTADA ALHASHMI ,3 ,LATIFA TOWER  ,CROWN PLAZA ,231400 ,Dubai",
        "phone": "97143521131",
        "email": "info@mhadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "a5a2640f-b1b8-4512-b9ee-a8802d0c30fc",
    "firmName": "MOHAMMED AL HASHIMI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-803",
    "licenseIssueDate": "04/18/2012 00:00:00",
    "licenseExpiryDate": "04/17/2026 00:00:00"
  },
  {
    "id": "47ea026d-3c5e-4ce5-b7a7-e8f63d59e4ac",
    "slug": "mohammed-rashed-mohammed-jabr-al-suwiadi",
    "name": "MOHAMMED RASHED MOHD BIN JABER",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 27,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/12/1997",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammed Rashed Mohammed Jabr Al-Suwiadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_47ea026d-3c5e-4ce5-b7a7-e8f63d59e4ac",
        "address": "Samia Luqman ,2nd floor ,Emarat Atrium Building ,across Holiday Inn Express Safa Park ,7273 ,Dubai",
        "phone": "97143211000",
        "email": "info@alsuwaidi.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "0e5c3637-bc12-475c-a6b5-2d9ae84f2b8e",
    "firmName": "ALSUWAIDI & COMPANY L.L.C",
    "registrationNumber": "L-170",
    "licenseIssueDate": "12/29/1997 00:00:00",
    "licenseExpiryDate": "12/28/2025 00:00:00"
  },
  {
    "id": "8e8bd6ed-a01c-4b1e-8d69-0f02185e34fd",
    "slug": "nabeel-abdulla-abdulrasoul-al-shawab",
    "name": "NABIL ABDULLA ABDULRASOOL",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 33,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/11/1991",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Nabeel Abdulla Abdulrasoul Al Shawab",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8e8bd6ed-a01c-4b1e-8d69-0f02185e34fd",
        "address": "",
        "phone": "97143355577",
        "email": "daraladalah1991@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "61efd89c-1d0d-4136-8397-2814c745f0da",
    "firmName": "DAR AL ADALA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-243",
    "licenseIssueDate": "11/26/1991 00:00:00",
    "licenseExpiryDate": "11/25/2025 00:00:00"
  },
  {
    "id": "76ac108e-b24a-450c-8d58-23a2f6c5e655",
    "slug": "rashed-mohammed-ali-mohammed-al-rasheed",
    "name": "RASHID MOHAMED ALI MOHAMED AL RASHEED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 39,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/02/1986",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Rashed Mohammed Ali Mohammed Al-Rasheed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_76ac108e-b24a-450c-8d58-23a2f6c5e655",
        "address": "6 ,Business Point ,Nissan Showroom  ,443 ,Dubai",
        "phone": "97142999991",
        "email": "dubai@alrasheed.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "a4fce061-88d2-4308-9c3a-dbb02f5cbe82",
    "firmName": "AL RASHEED & PARTNERS",
    "registrationNumber": "L-160",
    "licenseIssueDate": "02/19/1986 00:00:00",
    "licenseExpiryDate": "02/18/2026 00:00:00"
  },
  {
    "id": "0d90f5e0-72e7-4572-82ba-3edd65dcb0aa",
    "slug": "rashid-qassim-shahin-abdulla",
    "name": "RASHID QASSIM SHAHIN ABDULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSUQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/07/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Rashid Qassim Shahin Abdulla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0d90f5e0-72e7-4572-82ba-3edd65dcb0aa",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-796",
    "licenseIssueDate": "07/05/2023 00:00:00",
    "licenseExpiryDate": "07/04/2026 00:00:00"
  },
  {
    "id": "1cca0fa5-3486-4a85-a085-26b8187e3672",
    "slug": "ryasa-digam-ktami",
    "name": "RYASA TH KTAMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/05/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ryasa Digam Ktami",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1cca0fa5-3486-4a85-a085-26b8187e3672",
        "address": "",
        "phone": "97100000000",
        "email": "dubai@ahlegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "eae5fb25-fd19-436c-8668-3ac309424db4",
    "firmName": "ALI HABIB ADVOCATES AND LEGAL CONSULTANCY",
    "registrationNumber": "L-1358",
    "licenseIssueDate": "05/04/2019 00:00:00",
    "licenseExpiryDate": "05/03/2026 00:00:00"
  },
  {
    "id": "b2781232-5e3a-4a7b-ae67-142ca7f3ad05",
    "slug": "aadel-obaid-mobarak-alshareef-alali",
    "name": "BOTHAINAH AHMED ABDULLA S ALDHANHANI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/07/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Aadel Obaid Mobarak Alshareef Alali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b2781232-5e3a-4a7b-ae67-142ca7f3ad05",
        "address": "",
        "phone": "97142944000 / 971501826000",
        "email": "info@binhamadlegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "076d7792-b703-42a1-b104-c37dc1a5f37c",
    "firmName": "HASAN ALRAYYAMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1687",
    "licenseIssueDate": "08/18/2022 00:00:00",
    "licenseExpiryDate": "08/17/2026 00:00:00"
  },
  {
    "id": "67bc8802-8825-4c85-966e-da4f04f56b58",
    "slug": "aaesha-rashed-mohammed-abas-ali-al-tenniji",
    "name": "AAESHA RASHED MOHAMMED ABBAS ALTENEIJI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 22,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/06/2003",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Aaesha Rashed Mohammed Abas Ali Al-Tenniji",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_67bc8802-8825-4c85-966e-da4f04f56b58",
        "address": "السابع - مكتب 704 ,قرية الأعمال - بلوك B ,دوار الساعة ,183303 ,Dubai",
        "phone": "97142280050",
        "email": "aisha@aishalawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "7d06b333-b07b-4ed3-813b-3b56f638b071",
    "firmName": "AAESHA ALTENEAJI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-450",
    "licenseIssueDate": "06/17/2003 00:00:00",
    "licenseExpiryDate": "06/16/2026 00:00:00"
  },
  {
    "id": "c6b8b17e-a7f3-479d-b94e-205f134dba03",
    "slug": "aamer-salem-abdulkhaleq-binshaqnoot-almahri",
    "name": "AAMER SALEM ABDULKHALEQ BINSHAQNOOT ALMAHRI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/03/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Aamer Salem Abdulkhaleq Binshaqnoot Almahri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c6b8b17e-a7f3-479d-b94e-205f134dba03",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1157",
    "licenseIssueDate": "03/16/2017 00:00:00",
    "licenseExpiryDate": "03/15/2026 00:00:00"
  },
  {
    "id": "e78852cd-18d0-4b48-8cd8-53911ec192ef",
    "slug": "aasya-ebrahim-moosa-almoosa-alnuaimi",
    "name": "SAARA GHULAM RASOOL",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/02/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-02-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Aasya Ebrahim Moosa Almoosa Alnuaimi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e78852cd-18d0-4b48-8cd8-53911ec192ef",
        "address": "21 ,Rolex Tower ,Emirates Grand Hotel ,94334 ,Dubai",
        "phone": "97143277772 / 97145584900",
        "email": "info@globaladvocates.net",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "9b42810f-1d55-4aea-ac4a-7d9d1b25ac08",
    "firmName": "ALMAIDOOR ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1764",
    "licenseIssueDate": "02/23/2023 00:00:00",
    "licenseExpiryDate": "02/22/2026 00:00:00"
  },
  {
    "id": "828a1fc8-0950-4e9c-85d6-732e9a6f1b45",
    "slug": "abbas-mehdi-al-said-khalaf-al-tahri",
    "name": "ABBAS MAHDI SAYED KHALAF",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/01/2009",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abbas Mehdi Al-Said Khalaf Al-Tahri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_828a1fc8-0950-4e9c-85d6-732e9a6f1b45",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-126",
    "licenseIssueDate": "01/26/2009 00:00:00",
    "licenseExpiryDate": "01/25/2026 00:00:00"
  },
  {
    "id": "58dd0792-aa3b-45a7-9666-80f3c0797bbc",
    "slug": "abbas-naser-ali-naser-al-hawai",
    "name": "ABBAS NASSER ALI NASSER",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 35,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/11/1989",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abbas Naser Ali Naser Al-Hawai",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_58dd0792-aa3b-45a7-9666-80f3c0797bbc",
        "address": "18 ,برج السلام ,سما تاور ,68068 ,Dubai",
        "phone": "97143519700 / 971507973939",
        "email": "info@ramadanlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "08cb3f04-3a05-4815-9f28-6aa33c4b63dd",
    "firmName": "AHMED RAMADAN ADVOCATES &LEGAL CONSULTANTS",
    "registrationNumber": "L-198",
    "licenseIssueDate": "11/18/1989 00:00:00",
    "licenseExpiryDate": "11/17/2025 00:00:00"
  },
  {
    "id": "dd9c7a9e-4273-45cb-b791-ff8e8b120366",
    "slug": "abdalla-jasim-abdalla-abdelrazaq-al-naqbi",
    "name": "WALA JUMA HASSAN KHAMIS",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/04/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: abdalla jasim abdalla abdelrazaq  al naqbi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dd9c7a9e-4273-45cb-b791-ff8e8b120366",
        "address": "YASIR AL NAQBI ,21 ,48 BURJ ,SOFITEL DOWN  TOWN ,181111 ,Dubai",
        "phone": "97142689949",
        "email": "info@alnaqbipartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "ad71430e-83ee-4cb5-a530-bc58db2618f6",
    "firmName": "ABDULHAKIM BINHERZ ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-1800",
    "licenseIssueDate": "05/17/2023 00:00:00",
    "licenseExpiryDate": "05/16/2026 00:00:00"
  },
  {
    "id": "851b33d4-14d0-472d-919d-f9d8d2da3110",
    "slug": "abdalla-khalifa-ahmed-bin-yarouf-alnaqbi",
    "name": "ABDALLA KHALIFA AHMED BINYAROUF ALNAQBI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/06/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdalla Khalifa Ahmed Bin Yarouf Alnaqbi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_851b33d4-14d0-472d-919d-f9d8d2da3110",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1019",
    "licenseIssueDate": "06/05/2023 00:00:00",
    "licenseExpiryDate": "06/04/2026 00:00:00"
  },
  {
    "id": "f40e7e22-bde7-4d9b-86ba-c2a9bc21d6c2",
    "slug": "abdalla-khamis-gharib-al-nakhi-al-ali",
    "name": "ABDALLA KHAMIS GHARIB ALNAKHI AL-ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Personal Status-Custody & Alimony",
      "Criminal Law-Crimes against persons",
      "Commercial Transactions-Commercial Companies",
      "Civil Transactions-Labor & Workers",
      "Criminal Law-Drug Crimes",
      "Personal Status-Marriage & Divorce",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 15,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/08/2010",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdalla Khamis Gharib Al Nakhi Al Ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f40e7e22-bde7-4d9b-86ba-c2a9bc21d6c2",
        "address": "mohamed mahmoud mohamed elkormany ,بناية الوصل ,R549 يناية الوصل ,سيتي سنتر ديره ,83620 ,Dubai",
        "phone": "97142542000",
        "email": "info@aaalegalconsultants.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "927c60c9-145e-4bb5-8913-d6d6aa72f891",
    "firmName": "ABDALLA ALNAKHI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-724",
    "licenseIssueDate": "08/19/2010 00:00:00",
    "licenseExpiryDate": "08/18/2026 00:00:00"
  },
  {
    "id": "531a3e2e-8a87-4b41-90f0-3ba74a45019b",
    "slug": "abdalla-mohamed-abdelrahman-saad",
    "name": "Abdalla Mohamed Abdelrahman Saad",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/07/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdalla Mohamed Abdelrahman Saad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_531a3e2e-8a87-4b41-90f0-3ba74a45019b",
        "address": "",
        "phone": "97142555000",
        "email": "info@kha.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "0e4b9f0a-83fc-45c9-b0d3-f38013690624",
    "firmName": "KHALIFA BIN HUWAIDAN ALKETBI ADVOCATES & LEGA",
    "registrationNumber": "1493",
    "licenseIssueDate": "01/07/2021 00:00:00",
    "licenseExpiryDate": "01/06/2026 00:00:00"
  },
  {
    "id": "1ab8d016-09a0-4e71-a4fa-aa6b654c096b",
    "slug": "abdalla-mohamed-ali-salman-almarzuqi",
    "name": "ABDALLA MOHAMED ALI SALMAN ALMARZOOQI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 18,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/06/2007",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ABDALLA MOHAMED ALI SALMAN ALMARZUQI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1ab8d016-09a0-4e71-a4fa-aa6b654c096b",
        "address": "MOHAMMED ALI SALMAN AL MARZOOQI ,الثالث  ,السركال  ,معرض سيارات الفطيم  ,39059 ,Dubai",
        "phone": "97142500008",
        "email": "adv.saad@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "6bba829c-0392-4c72-a71b-01da72cb24ae",
    "firmName": "MOHAMED SALMAN ADVOCATE & LEGAL CONSULTANCY",
    "registrationNumber": "L-608",
    "licenseIssueDate": "06/07/2007 00:00:00",
    "licenseExpiryDate": "06/09/2026 00:00:00"
  },
  {
    "id": "cd043c69-4d3e-49a4-bf18-bdb6f35684ee",
    "slug": "abdalla-rahma-abdalla-alowais-alshamsi",
    "name": "ABDALLA RAHMA ABDALLA ALOWAIS ALSHAMSI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/04/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdalla Rahma Abdalla Alowais Alshamsi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cd043c69-4d3e-49a4-bf18-bdb6f35684ee",
        "address": "702-703 ,THE EXCHANGE TOWER ,NEAR IN BUSINESS BAY METRO STATION ,90009 ,Dubai",
        "phone": "97142327888",
        "email": "info@alowaislaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "83647634-f0b7-4ccb-b71c-6d00bfdb84de",
    "firmName": "ABDALLA ALOWAIS ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-751",
    "licenseIssueDate": "03/26/2007 00:00:00",
    "licenseExpiryDate": "03/25/2026 00:00:00"
  },
  {
    "id": "1699d12d-a601-4455-a792-9c60c333cdc9",
    "slug": "abdalla-saleh-mohammed-abdulwahed-almarzooqi",
    "name": "SALEH MOHAMMED ABDELWAHID",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/04/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdalla Saleh Mohammed Abdulwahed Almarzooqi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1699d12d-a601-4455-a792-9c60c333cdc9",
        "address": "Abdalla Saleh Almarzooqi ,4th ,   Business Avenue 515 ,Dubai Airport ,111107 ,Dubai",
        "phone": "97145750781 / 971504108014",
        "email": "abdallaalmarzooqi@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "45b62390-1485-4ade-802f-2848c7b2451b",
    "firmName": "ABDALLA ALMARZOOQI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1169",
    "licenseIssueDate": "04/13/2017 00:00:00",
    "licenseExpiryDate": "04/12/2026 00:00:00"
  },
  {
    "id": "7946beec-96d8-430a-8ecb-4d02753d654a",
    "slug": "abdalla-salim-mohamed-rashid-alqaydi",
    "name": "ABDALLA SALIM MOHAMED RASHID",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/08/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdalla Salim Mohamed Rashid Alqaydi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7946beec-96d8-430a-8ecb-4d02753d654a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-586",
    "licenseIssueDate": "08/14/2017 00:00:00",
    "licenseExpiryDate": "08/13/2026 00:00:00"
  },
  {
    "id": "5d58fbee-691c-43d8-97ee-da077a586d02",
    "slug": "abdalla-salim-mohamed-salim-almarzouqi",
    "name": "ABDALLA SALIM MOHAMED SALIM ALMARZOOQI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 19,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/05/2006",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ABDALLA SALIM MOHAMED SALIM ALMARZOUQI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5d58fbee-691c-43d8-97ee-da077a586d02",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-572",
    "licenseIssueDate": "05/24/2006 00:00:00",
    "licenseExpiryDate": "05/23/2026 00:00:00"
  },
  {
    "id": "5c29bbe8-907d-4c21-bbb4-64dc1b6a723b",
    "slug": "abdel-aziz-khalifa-masoud-shaikhan-al-hanaee",
    "name": "ABDELAZIZ KHALIFA MASOUD SHAIKHAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 21,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/01/2004",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdel Aziz Khalifa Masoud Shaikhan Al Hanaee",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5c29bbe8-907d-4c21-bbb4-64dc1b6a723b",
        "address": "",
        "phone": "97143316868 / 971561446981",
        "email": "info@alhanaee.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "eb84bd6d-a78c-4fd6-8f46-4fab8eea60b5",
    "firmName": "ABDELAZIZ ALHANAEE ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-467",
    "licenseIssueDate": "01/25/2004 00:00:00",
    "licenseExpiryDate": "01/24/2026 00:00:00"
  },
  {
    "id": "179347f4-b316-468e-83ee-4ee927f9fc6a",
    "slug": "abdel-rahman-nasir-ali-al-fardan",
    "name": "ABDELRAHMAN NASIR ALI ALFARDAN ALNUAIMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 19,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/02/2006",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdel Rahman Nasir Ali Al Fardan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_179347f4-b316-468e-83ee-4ee927f9fc6a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-514",
    "licenseIssueDate": "02/07/2006 00:00:00",
    "licenseExpiryDate": "02/06/2026 00:00:00"
  },
  {
    "id": "159796c4-e7ab-4036-abc2-33d9c9035902",
    "slug": "abdelaziz-abdalla-mohamed-abdalla-al-hammadi",
    "name": "ABDELAZIZ ABDALLA MOHAMED ABDALLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 20,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/12/2004",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdelaziz Abdalla Mohamed Abdalla Al Hammadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_159796c4-e7ab-4036-abc2-33d9c9035902",
        "address": "",
        "phone": "97143212555",
        "email": "awigdubai@awiglaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "ece8ea60-9ecb-4d8c-aca3-fb73e4e52406",
    "firmName": "AL WASL INTERNATIONAL GROUP - ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-493",
    "licenseIssueDate": "12/25/2004 00:00:00",
    "licenseExpiryDate": "12/24/2025 00:00:00"
  },
  {
    "id": "f491b2c2-9538-4ee7-ae90-fd80e4799de3",
    "slug": "abdelaziz-abdulla-yousif-mohamed-al-bloushi",
    "name": "ABDELAZIZ ABDALLA YOUSIF M.ALBLOOSHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 17,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/03/2008",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ABDELAZIZ ABDULLA YOUSIF MOHAMED AL BLOUSHI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f491b2c2-9538-4ee7-ae90-fd80e4799de3",
        "address": "",
        "phone": "97142396646",
        "email": "advo_alblooshi@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "3ab5acef-85ac-482b-91f2-4e0a34fd6af7",
    "firmName": "ABDELAZIZ AL BLOUSHI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-625",
    "licenseIssueDate": "03/03/2008 00:00:00",
    "licenseExpiryDate": "03/02/2026 00:00:00"
  },
  {
    "id": "e0b175c8-51f0-4538-b796-6841307c5bd6",
    "slug": "abdelaziz-ahmed-abdelaziz-ahmed-alzarouni",
    "name": "ABDELAZIZ AHMED ABDELAZIZ AHMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/08/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdelaziz Ahmed Abdelaziz Ahmed Alzarouni",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e0b175c8-51f0-4538-b796-6841307c5bd6",
        "address": "Sarhan Hassan Mohamed Hassan Almuaini ,Office 1002, Level 10 ,THE OBEROI CENTRE ,Business Bay Metro Station ,1169 ,Dubai",
        "phone": "97142324000",
        "email": "info@drsarhanlawyer.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "14541022-bde4-43ab-9ba1-489e87187b42",
    "firmName": "DR SARHAN ALMUAINI ADVOCATE AND LEGAL CONSULTANT",
    "registrationNumber": "L-715",
    "licenseIssueDate": "08/08/2021 00:00:00",
    "licenseExpiryDate": "08/07/2026 00:00:00"
  },
  {
    "id": "132d782a-620b-4cac-b779-6e7cff0c5b06",
    "slug": "abdelaziz-mohamed-abinkhalfan-alzaabi",
    "name": "ABDELAZIZ MOHAMED A BINKHALFAN ALZAABI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/02/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdelaziz Mohamed A.Binkhalfan Alzaabi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_132d782a-620b-4cac-b779-6e7cff0c5b06",
        "address": "طابق الميزانين ، مكتب M05 ,ملتقى الأعمال (بناية تسهيل) ,خلف نادي النصر الرياضي ,414121 ,Dubai",
        "phone": "97143888252",
        "email": "alzaabiadvo8@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "e0e3b92e-72b4-41ed-8cc0-7280ac4233dd",
    "firmName": "ABDELAZIZ ALZAABI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-632",
    "licenseIssueDate": "02/22/2015 00:00:00",
    "licenseExpiryDate": "02/21/2026 00:00:00"
  },
  {
    "id": "54973a48-c779-4e44-a7d7-5015fcc2805b",
    "slug": "abdelaziz-mohamed-abdelghani-ali-alkhamiri-alali",
    "name": "ABDELAZIZ MOHAMED A ALKHAMIRI AL ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/06/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdelaziz Mohamed Abdelghani Ali Alkhamiri Alali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_54973a48-c779-4e44-a7d7-5015fcc2805b",
        "address": "ABDELAZIZ MOHAMED ABDELGHANI AL KHAMIRI AL ALI ,3 ,DUBAI SUPREME COURT COMPLEX ,DUBAI COURT ,128334 ,Dubai",
        "phone": "97145519341 / 971505788557",
        "email": "info@raalc.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "73e54a15-f797-4e91-a501-ef988d8f8bf8",
    "firmName": "ABDELAZIZ AL KHAMIRI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1094",
    "licenseIssueDate": "06/05/2016 00:00:00",
    "licenseExpiryDate": "06/04/2026 00:00:00"
  },
  {
    "id": "27b3fe21-aa4b-4b65-a6ce-471b6a06225d",
    "slug": "abdelhadi-jasim-mohamed-abdalla-alhammadi",
    "name": "JASIM MOHAMED ABDALLA TALIB",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/11/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdelhadi Jasim Mohamed Abdalla Alhammadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_27b3fe21-aa4b-4b65-a6ce-471b6a06225d",
        "address": "Office 214 ,Dubai Autism Center ,Makani No: 3349592541 ,000 ,Dubai",
        "phone": "97100000000 / 971503377345",
        "email": "abd3377345@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "f53e2f02-5ed9-4762-aa43-0f59c198e69a",
    "firmName": "ABDUL HADI JASIM AL HAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1477",
    "licenseIssueDate": "11/11/2020 00:00:00",
    "licenseExpiryDate": "11/10/2025 00:00:00"
  },
  {
    "id": "68a14ce9-9636-4524-8d2a-f515a1420000",
    "slug": "abdelhakeem-hamad-maihad-mohamed-almheiri",
    "name": "ABDELHAKEEM HAMAD MAIHAD MOHAMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/12/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdelhakeem Hamad Maihad Mohamed Almheiri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_68a14ce9-9636-4524-8d2a-f515a1420000",
        "address": "",
        "phone": "97143304343",
        "email": "hamad@emiratesadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "f7823b07-a968-474f-8a13-a4454ef2d990",
    "firmName": "EMIRATES ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1396",
    "licenseIssueDate": "12/17/2019 00:00:00",
    "licenseExpiryDate": "12/17/2025 00:00:00"
  },
  {
    "id": "c1482a25-27b7-4904-8676-bc6a223ea82f",
    "slug": "abdelkarim-ali-abdelkaim-mohamed-alali",
    "name": "MOHAMED AHMED ALI ABDALLA ALMURSHIDI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/07/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ABDELKARIM ALI ABDELKAIM MOHAMED ALALI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c1482a25-27b7-4904-8676-bc6a223ea82f",
        "address": "ABDULHAMEED ALI ALKUMITY ,الطابق الأول  ,BMTC ,معرض هيونداي للسيارات  ,33998 ,Dubai",
        "phone": "97142686855",
        "email": "info@alkumaitiadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "7076c088-41b3-40f1-872e-6df5351625da",
    "firmName": "ESAM ALZAROONI ADVOCATES &LEGAL CONSULTANTS",
    "registrationNumber": "L-1840",
    "licenseIssueDate": "08/04/2023 00:00:00",
    "licenseExpiryDate": "08/03/2026 00:00:00"
  },
  {
    "id": "6c8340e1-394b-46f1-8372-a27fae060b5c",
    "slug": "abdelkarim-hassan-abdalla-al-hashimi",
    "name": "ABDELKARIM HASSAN ABDALLA ALHASHMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 20,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/02/2005",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdelkarim Hassan Abdalla Al Hashimi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6c8340e1-394b-46f1-8372-a27fae060b5c",
        "address": "lujain waleed ,2 ,AL Bakhit Center ,Next to Abu Dhabi First Bank ,14916 ,Dubai",
        "phone": "97142977706",
        "email": "yousefa3@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "4ac59896-a747-47f0-931f-b7f0e54e27c6",
    "firmName": "YOUSIF AL ALI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-510",
    "licenseIssueDate": "02/15/2005 00:00:00",
    "licenseExpiryDate": "02/14/2026 00:00:00"
  },
  {
    "id": "e7f20e87-174f-429a-96a7-99034a793986",
    "slug": "abdelmotaleb-ali-ahmed",
    "name": "Abdelmotaleb Ali Ahmed",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 21,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/15/2003 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdelmotaleb Ali Ahmed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e7f20e87-174f-429a-96a7-99034a793986",
        "address": "الطابق الثاني - مكتب رقم 203 و 204  ,سيتي أفينو ,سيتى سنتر ديرة  ,83666 ,Dubai",
        "phone": "97142955050",
        "email": "adv.algharib@alghariblawfirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "b1e23b77-356c-4678-ae4d-2ff4e494702b",
    "firmName": "ALGHARIB & PARTNERS ADVOCATES AND LEGAL CONSU",
    "registrationNumber": "465",
    "licenseIssueDate": "12/15/2003 00:00:00",
    "licenseExpiryDate": "12/14/2025 00:00:00"
  },
  {
    "id": "f54a086d-84dc-4166-9ec5-0723b2be5a2c",
    "slug": "abdelrahman-mohamamed-murad-abdelrahman",
    "name": "ABDELRAHMAN MOHAMED MURAD ALMAAZMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/06/2009",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdelrahman Mohamamed Murad Abdelrahman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f54a086d-84dc-4166-9ec5-0723b2be5a2c",
        "address": "",
        "phone": "97142552220",
        "email": "almaazmi.office@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "e04d8a88-3378-40c8-a33a-b5e26a0c8507",
    "firmName": "ABDELRAHMAN ALMAAZMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-668",
    "licenseIssueDate": "06/07/2009 00:00:00",
    "licenseExpiryDate": "06/06/2026 00:00:00"
  },
  {
    "id": "16bfee74-08dc-42db-8b94-3ffce3b3d7c5",
    "slug": "abdul-azeez-karama-saleh",
    "name": "ABDUL AZEEZ KARAMA SALEH",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 19,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/10/2005",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ABDUL AZEEZ KARAMA SALEH",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_16bfee74-08dc-42db-8b94-3ffce3b3d7c5",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-530",
    "licenseIssueDate": "10/16/2005 00:00:00",
    "licenseExpiryDate": "10/15/2025 00:00:00"
  },
  {
    "id": "128930d7-fb07-49d2-a6e0-9036f4c0ea24",
    "slug": "abdul-hakim-ali-husain-maqlam-alkhalifi",
    "name": "ABDUL HAKIM ALI HUSAIN MAQLAM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/08/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdul Hakim Ali Husain Maqlam Alkhalifi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_128930d7-fb07-49d2-a6e0-9036f4c0ea24",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1447",
    "licenseIssueDate": "08/27/2020 00:00:00",
    "licenseExpiryDate": "08/26/2026 00:00:00"
  },
  {
    "id": "b533041c-f5a8-4fca-9be3-e785c26fc0c7",
    "slug": "abdul-munem-salem-obaid-bin-sowaidan",
    "name": "ABDULMUNEM SALEM OBAID",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 28,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/10/1997",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdul Munem Salem Obaid Bin Sowaidan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b533041c-f5a8-4fca-9be3-e785c26fc0c7",
        "address": "4 ,ALHUDIBA AWARD COMPLEX BLOCK B ,UNION FLAG HOUSE ,50229 ,Dubai",
        "phone": "97143258888 / 971501009595",
        "email": "hr@binsowaidan.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "36d64a1b-4461-4159-9965-ed44c59d3e88",
    "firmName": "BIN SOWAIDAN ADVOCATES & LEGAL CONSULTANTCY",
    "registrationNumber": "L-308",
    "licenseIssueDate": "10/04/1997 00:00:00",
    "licenseExpiryDate": "10/03/2026 00:00:00"
  },
  {
    "id": "02f890ef-30ff-4cb4-af25-5b87c0acf989",
    "slug": "abdulaziz-abdulrhman-mohammed-al-sharif",
    "name": "ABDULAZIZ ABDULRAHMAN MOHAMED ALSHARIF",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/02/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-02-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulaziz Abdulrhman Mohammed Al Sharif",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_02f890ef-30ff-4cb4-af25-5b87c0acf989",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-861",
    "licenseIssueDate": "02/26/2013 00:00:00",
    "licenseExpiryDate": "02/25/2026 00:00:00"
  },
  {
    "id": "9579bb6f-51ae-4c6d-ae0f-ad0ceeeb3803",
    "slug": "abdulaziz-ali-juma-salhi",
    "name": "NASHWA AHMED W.O. MOHAMED S.A.M.ALKHADIM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/12/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulaziz Ali Juma Salhi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9579bb6f-51ae-4c6d-ae0f-ad0ceeeb3803",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-2053",
    "licenseIssueDate": "12/27/2024 00:00:00",
    "licenseExpiryDate": "12/26/2025 00:00:00"
  },
  {
    "id": "17c804e3-7e13-49a8-8a1d-5436eec49462",
    "slug": "abdulaziz-dawood-saifuddin-alyaquob",
    "name": "ABDULAZIZ DAWOOD SAIFUDDIN AL YAQUOB",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/07/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulaziz Dawood Saifuddin Alyaquob",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_17c804e3-7e13-49a8-8a1d-5436eec49462",
        "address": "4 ,ALHUDIBA AWARD COMPLEX BLOCK B ,UNION FLAG HOUSE ,50229 ,Dubai",
        "phone": "97143258888 / 971501009595",
        "email": "hr@binsowaidan.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "36d64a1b-4461-4159-9965-ed44c59d3e88",
    "firmName": "BIN SOWAIDAN ADVOCATES & LEGAL CONSULTANTCY",
    "registrationNumber": "L-1439",
    "licenseIssueDate": "07/16/2020 00:00:00",
    "licenseExpiryDate": "07/15/2026 00:00:00"
  },
  {
    "id": "5146749e-dc32-4f35-b950-8699935d9280",
    "slug": "abdulaziz-essa-hassan-abdulla-al-ashab-al-matroshi",
    "name": "Abdulaziz Essa Hassan Abdulla Al Ashab Al Matroshi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 21,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/12/2003 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulaziz Essa Hassan Abdulla Al Ashab Al Matroshi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5146749e-dc32-4f35-b950-8699935d9280",
        "address": "4TH FLOOR ,AL HARTHY ,DUBAI CUSTOMS ,34143 ,Dubai",
        "phone": "97143930039",
        "email": "admin@advocatesuae.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "4e22d3f8-438f-4c16-9a7f-91e6e29dc5f6",
    "firmName": "AL MATROOSHI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "461",
    "licenseIssueDate": "11/12/2003 00:00:00",
    "licenseExpiryDate": "11/11/2025 00:00:00"
  },
  {
    "id": "49dc8fba-6d82-40df-aad1-0f74635d6502",
    "slug": "abdulaziz-ibrahim-salem-al-ablam",
    "name": "ABDULAZIZ IBRAHIM SALEM ALABLAM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 21,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/09/2004",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulaziz Ibrahim Salem Al Ablam",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_49dc8fba-6d82-40df-aad1-0f74635d6502",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-492",
    "licenseIssueDate": "09/18/2004 00:00:00",
    "licenseExpiryDate": "09/17/2026 00:00:00"
  },
  {
    "id": "e3e7d752-8e78-481f-a5b9-fa25056e66ca",
    "slug": "abdulaziz-khamis-ali-faraj-alshamsi",
    "name": "ABDUL AZIZ KHAMIS ALI FARAJ ALSHAMSI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/01/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulaziz Khamis Ali Faraj Alshamsi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e3e7d752-8e78-481f-a5b9-fa25056e66ca",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1141",
    "licenseIssueDate": "01/12/2017 00:00:00",
    "licenseExpiryDate": "01/11/2026 00:00:00"
  },
  {
    "id": "7083192a-60c0-4569-9c16-51ee314c8699",
    "slug": "abdulbaset-abdulla-hamad-yousef-aljneibi",
    "name": "ENAS ABDULLA NAJI ALMAZNAEI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/05/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulbaset Abdulla Hamad Yousef Aljneibi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7083192a-60c0-4569-9c16-51ee314c8699",
        "address": "",
        "phone": "97143240008 / 971555573999",
        "email": "info@asolutions.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "9257678d-4d2f-46be-8660-57f1b1acddc0",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1809",
    "licenseIssueDate": "06/12/2023 00:00:00",
    "licenseExpiryDate": "06/11/2026 00:00:00"
  },
  {
    "id": "25b2efa0-6d9b-4329-b7d1-6d13da01b8d7",
    "slug": "abdulhakim-habib-mansoor-binherz",
    "name": "ABDULHAKIM HABIB MANSOOR",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/05/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulhakim Habib Mansoor Binherz",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_25b2efa0-6d9b-4329-b7d1-6d13da01b8d7",
        "address": "Abdulhakim Habib Mansoor Binherz  ,38 ,Latifa Tower  , Crowne Plaza Hotel ,97598 ,Dubai",
        "phone": "97102544490",
        "email": "litigation@binherzadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "4e2e2375-ce6e-4d10-936d-68285844f2c0",
    "firmName": "ABDULHAKIM BINHERZ ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-945",
    "licenseIssueDate": "05/13/2014 00:00:00",
    "licenseExpiryDate": "05/12/2026 00:00:00"
  },
  {
    "id": "c9db3e9b-8a16-4046-8e1e-75c934c3c883",
    "slug": "abdulhameed-ali-humaid-al-kumity",
    "name": "Abdulhameed Ali Humaid Al Kumity",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 26,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/17/1999 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulhameed Ali Humaid Al Kumity",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c9db3e9b-8a16-4046-8e1e-75c934c3c883",
        "address": "ABDULHAMEED ALI ALKUMITY ,الطابق الأول  ,BMTC ,معرض هيونداي للسيارات  ,33998 ,Dubai",
        "phone": "97142686855",
        "email": "info@alkumaitiadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "7076c088-41b3-40f1-872e-6df5351625da",
    "firmName": "AL KUMAITI ADVOCATES",
    "registrationNumber": "356",
    "licenseIssueDate": "03/17/1999 00:00:00",
    "licenseExpiryDate": "03/16/2026 00:00:00"
  },
  {
    "id": "71128728-84c7-4bb1-a311-afd3ac318c1f",
    "slug": "abdulhameed-mohammed-hassan-aljasmi",
    "name": "ABDULHAMEED MOHAMMED HASSAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/02/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulhameed Mohammed hassan Aljasmi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_71128728-84c7-4bb1-a311-afd3ac318c1f",
        "address": "",
        "phone": "97142251011",
        "email": "info@ajlc.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "aa38fc5e-9318-46e5-aaeb-e64f98419097",
    "firmName": "ABDULHAMEED ALJASMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-988",
    "licenseIssueDate": "02/11/2015 00:00:00",
    "licenseExpiryDate": "02/10/2026 00:00:00"
  },
  {
    "id": "07769b6c-6d5c-4cac-ab07-c171b554a899",
    "slug": "abdulhameid-abdulmalek-mustafa-ahli",
    "name": "ABDULHAMUID ABDULMALIK MUSTAFA ALI AHLI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 27,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/01/1998",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulhameid Abdulmalek Mustafa Ahli",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_07769b6c-6d5c-4cac-ab07-c171b554a899",
        "address": "",
        "phone": "97142227008 / 971506245451",
        "email": "info@abdulmaliklaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "5714833f-5b48-477b-a556-efa3a779f522",
    "firmName": "ABDULMALIK & ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-323",
    "licenseIssueDate": "01/10/1998 00:00:00",
    "licenseExpiryDate": "01/09/2026 00:00:00"
  },
  {
    "id": "102efd91-6e83-490b-8ecd-541b2fca5c5a",
    "slug": "abdulhameid-ali-ibraheim-mohamed-mansy",
    "name": "ABDELHAMID ALI IBRAHIM MOHAMED MANSY",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 19,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/02/2006",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulhameid Ali Ibraheim Mohamed Mansy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_102efd91-6e83-490b-8ecd-541b2fca5c5a",
        "address": "",
        "phone": "97142957333",
        "email": "info@lootah-law.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "f33057ab-5fd7-4d0d-87ad-9fe76e01c0af",
    "firmName": "LOOTAH ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-537",
    "licenseIssueDate": "02/07/2006 00:00:00",
    "licenseExpiryDate": "02/06/2026 00:00:00"
  },
  {
    "id": "7c9511d9-6433-4879-912d-e54ac7f202b3",
    "slug": "abdulhamid-ghuloom-murad-yousuf-saleh-albalooshi",
    "name": "ABDULHAMID GHULOOM MURAD YOUSUF SALEH",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/08/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulhamid Ghuloom Murad Yousuf Saleh Albalooshi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7c9511d9-6433-4879-912d-e54ac7f202b3",
        "address": "Zahraa ALSaedi ,Floor 14 - Offices No.1401,1402,1404 ,Aspin Commercial Tower  ,Shangri-La Hotel ,62999 ,Dubai",
        "phone": "97142224460 / 97142224460",
        "email": "info@dubailawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "afd89d37-3e2e-4b36-b832-8f5d3b8ee42d",
    "firmName": "ABDULHAMID YOUSUF ALBALOOSHI ADVOCATE & LEGAL CONSULTANTS",
    "registrationNumber": "L-1106",
    "licenseIssueDate": "09/01/2016 00:00:00",
    "licenseExpiryDate": "08/31/2026 00:00:00"
  },
  {
    "id": "b7f5911b-8a64-4164-837e-5435d65c49d0",
    "slug": "abduljawad-abdulaziz-mohammad-alqasem",
    "name": "ABDULJAWAD ABDULAZIZ MOHAMMAD ALQASEM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/06/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: abduljawad abdulaziz mohammad alqasem",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b7f5911b-8a64-4164-837e-5435d65c49d0",
        "address": "",
        "phone": "97143304457",
        "email": "abduljawad@alqasemadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "19925cdf-cf68-49a0-8196-3b36ace2acdb",
    "firmName": "ABDULLJAWAD ALQASEM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1536",
    "licenseIssueDate": "06/17/2021 00:00:00",
    "licenseExpiryDate": "06/16/2026 00:00:00"
  },
  {
    "id": "c01d3b2c-b491-4fac-9072-72411d3bbb87",
    "slug": "abdulkareim-ahmed-abbdulla-eid",
    "name": "ABDULKARIM AHMED ABDULLAH EID",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 23,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/04/2002",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulkareim Ahmed Abbdulla Eid",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c01d3b2c-b491-4fac-9072-72411d3bbb87",
        "address": "ABDULLKAREIM AHMED ABDULLA EID ,الطابق الثانى - مكتب رقم 014 ,مركز الممزر  ,مقابل القياده العامه لشرطة دبي - بجوار مكتب وزارة العمل والعمال القديم  ,89505 ,Dubai",
        "phone": "97142388850",
        "email": "bineidadvocates@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "ea633c29-6b4a-48a8-aaec-c801ece50744",
    "firmName": "BIN EID ADVOCATES & LEGEL CONSULTANTS",
    "registrationNumber": "L-425",
    "licenseIssueDate": "04/23/2002 00:00:00",
    "licenseExpiryDate": "04/22/2026 00:00:00"
  },
  {
    "id": "654a99c1-5f09-4d07-8927-ab6a90ee547f",
    "slug": "abdulkareim-jowdat-abdulla-istetiah",
    "name": "ABDUL KAREEM JAWDAT ABDALLAH ISTETEH",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 22,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/08/2003",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulkareim Jowdat Abdulla Istetiah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_654a99c1-5f09-4d07-8927-ab6a90ee547f",
        "address": "AFAF MARJAN NASIB ,3 ,GULF TOWERS  ,DUBAI MUNICIPALITY ,35192 ,Dubai",
        "phone": "97143333929 / 97143333929",
        "email": "info@afafmarjan.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "0f4257b6-c2a1-4f9d-9998-ce8f5ea9f2a3",
    "firmName": "AFAF MORJAN ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-457",
    "licenseIssueDate": "08/16/2003 00:00:00",
    "licenseExpiryDate": "08/15/2026 00:00:00"
  },
  {
    "id": "f0dbf1f1-2af6-4aa3-af39-cba51491849c",
    "slug": "abdulkarem-makki-jaffar",
    "name": "ABDULKARIM MAKKI JAFFAR ALMAKDOUM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 18,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/03/2007",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulkarem Makki Jaffar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f0dbf1f1-2af6-4aa3-af39-cba51491849c",
        "address": "ABDULKARIM MAKKI ,1605 ,Exchange Tower ,JW Marriott Marquis Hotel Dubai ,98777 ,Dubai",
        "phone": "97142406606",
        "email": "info@alfajeradvocate.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "8f050b70-3ac6-4282-b9f7-ce19f14b4787",
    "firmName": "AL FAJER ADVOCATE & LEGAL CONSULTANTS",
    "registrationNumber": "L-593",
    "licenseIssueDate": "03/06/2007 00:00:00",
    "licenseExpiryDate": "03/05/2026 00:00:00"
  },
  {
    "id": "b52921f7-505d-4be9-ae5d-b9b108c3ca1e",
    "slug": "abdulla-abdulla-fadhel-saqer-al-hammadi",
    "name": "ABDULLA ABDULLA FADHEL SAQER ALHAMMADI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 20,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/08/2005",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Abdulla Fadhel Saqer Al-Hammadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b52921f7-505d-4be9-ae5d-b9b108c3ca1e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-212",
    "licenseIssueDate": "08/24/2005 00:00:00",
    "licenseExpiryDate": "08/23/2026 00:00:00"
  },
  {
    "id": "092ad630-db86-4c9f-a984-6776b0e2d425",
    "slug": "abdulla-abdulqader-alawi-alhaithami-alharthi",
    "name": "ABDULLA ABDULQADER ALAWI N. ALHAITHAMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/01/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Abdulqader Alawi Alhaithami Alharthi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_092ad630-db86-4c9f-a984-6776b0e2d425",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-984",
    "licenseIssueDate": "01/19/2015 00:00:00",
    "licenseExpiryDate": "01/18/2026 00:00:00"
  },
  {
    "id": "19e8bb6f-7601-4573-a49a-a533e918d468",
    "slug": "abdulla-abdulrhman-abdulla-al-mudharreb",
    "name": "ABDULLA ABDULRAHMAN ABDULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 17,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/03/2008",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Abdulrhman Abdulla Al Mudharreb",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_19e8bb6f-7601-4573-a49a-a533e918d468",
        "address": "الثاني ,الفجر للاعمال  ,مركز القرهود للياقة الطبية - مستشفى القرهود  ,15105 ,Dubai",
        "phone": "97142222800",
        "email": "info@almudharreb.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "806f31e8-0ed0-40a1-9d26-ef999012f7ed",
    "firmName": "AL MUDHARREB & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-622",
    "licenseIssueDate": "03/03/2008 00:00:00",
    "licenseExpiryDate": "03/02/2026 00:00:00"
  },
  {
    "id": "38b603a6-6b49-4d15-aa1d-a48eeacf20da",
    "slug": "abdulla-abdulwahab-abdulaziz-mohammed-alhosani",
    "name": "ABDULWAHAB ABDULAZIZ MOHAMMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/04/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Abdulwahab Abdulaziz Mohammed Alhosani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_38b603a6-6b49-4d15-aa1d-a48eeacf20da",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1176",
    "licenseIssueDate": "04/18/2017 00:00:00",
    "licenseExpiryDate": "04/17/2026 00:00:00"
  },
  {
    "id": "cb839337-0399-4992-9209-a2317d0e61c5",
    "slug": "abdulla-adam-mohammed-al-raisi",
    "name": "ABDULLA ADAM MOHAMED ALRAEESI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Commercial Agency",
      "Proceedings-Cases and Proceedings before Dubai International Financial Centre",
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Civil Transactions-POA & Sponsorship",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Civil Transactions-Insurance",
      "Personal Status-Wills",
      "Civil Transactions-Construction and Contracts for Services",
      "Civil Transactions-Ownership & Title",
      "Civil Transactions-HR & Employee Affairs",
      "Commercial Transactions-Commercial Mortgage",
      "Criminal Law-Family Crimes",
      "Personal Status-Custody & Alimony",
      "Commercial Transactions-Commercial Contracts",
      "Commercial Transactions-Bankruptcy",
      "Commercial Transactions-Commercial Real Estate",
      "Civil Transactions-Residential Real Estate",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Civil Transactions-Arbitration",
      "Criminal Law-Hate crimes",
      "Civil Transactions-Tenancy",
      "Criminal Law-Crimes against persons",
      "Personal Status-Legacies and Inheritance",
      "Commercial Transactions-Commercial Companies",
      "Civil Transactions-Labor & Workers",
      "Personal Status-Legal Capacity & Guardianship",
      "Criminal Law-Drug Crimes",
      "Civil Transactions-Sale",
      "Commercial Transactions-Sea and air freight",
      "Proceedings-Cases and Proceedings before arbitral tribunals and other alternative dispute resolution bodies",
      "Commercial Transactions-Consumer protection",
      "Personal Status-Marriage & Divorce",
      "Personal Status-Child Abuse & Abduction",
      "Civil Transactions-Compensation",
      "Commercial Transactions-Stock",
      "Criminal Law-Crimes against properties",
      "Commercial Transactions-E-Commerce",
      "Criminal Law-Cybercrimes",
      "Commercial Transactions-Intellectual Property (includes trademarks",
      "copy rights",
      "patents)",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/03/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Adam Mohammed Al Raisi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cb839337-0399-4992-9209-a2317d0e61c5",
        "address": "Office No.B3604 ,Latifa tower  ,Sheikh zayed rd ,895 ,Dubai",
        "phone": "97100000000 / 971000000000",
        "email": "alraeesi@aradvoc.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "6ba19c75-28b1-4ab5-a6e7-2cf619cceeaa",
    "firmName": "ABDULLA AL RAEESI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-920",
    "licenseIssueDate": "03/06/2014 00:00:00",
    "licenseExpiryDate": "03/05/2026 00:00:00"
  },
  {
    "id": "6ca70a0c-9ac9-4263-9486-3b9f7e3f92a6",
    "slug": "abdulla-ahmad-abdulaziz-qassim-al-haddad",
    "name": "SALEM ALI MANEA MUFARREH AL AHBABI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/09/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Ahmad Abdulaziz Qassim Al Haddad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6ca70a0c-9ac9-4263-9486-3b9f7e3f92a6",
        "address": "الطابق الثالث ,مجمع المحكمة العليا دبي ,مجمع المحكمة العليا دبي ,45556 ,Dubai",
        "phone": "97145570632 / 971503977375",
        "email": "rasmi@aahadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "7d47fa75-0239-4031-a3a5-d132d2fa393b",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1703",
    "licenseIssueDate": "09/29/2022 00:00:00",
    "licenseExpiryDate": "09/28/2026 00:00:00"
  },
  {
    "id": "cd35acec-e27c-49d2-8cfc-dfc06fd89b7a",
    "slug": "abdulla-ahmad-abdulla-mohammad-ahli",
    "name": "MARWA SAIF JUMA HAMAD MOHAMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/04/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Ahmad Abdulla Mohammad Ahli",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cd35acec-e27c-49d2-8cfc-dfc06fd89b7a",
        "address": "21 ,Rolex Tower ,Emirates Grand Hotel ,94334 ,Dubai",
        "phone": "97143277772 / 97145584900",
        "email": "info@globaladvocates.net",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "9b42810f-1d55-4aea-ac4a-7d9d1b25ac08",
    "firmName": "MOHAMMED AL DAHBASHI ADVOCATES",
    "registrationNumber": "L-1945",
    "licenseIssueDate": "04/26/2024 00:00:00",
    "licenseExpiryDate": "04/25/2026 00:00:00"
  },
  {
    "id": "d52bd520-d2f1-455d-807f-45904a18e086",
    "slug": "abdulla-ahmed-ahmed-ghunaim-alshehhi",
    "name": "ABDULLA AHMED AHMED GHUNAIM ALSHEHHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/10/2010",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Ahmed Ahmed Ghunaim Alshehhi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d52bd520-d2f1-455d-807f-45904a18e086",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-732",
    "licenseIssueDate": "10/27/2010 00:00:00",
    "licenseExpiryDate": "10/26/2025 00:00:00"
  },
  {
    "id": "50ccb7af-0fd5-4ea5-8eaf-736b86413cc2",
    "slug": "abdulla-ali-abdulla-alghailani-aljneibi",
    "name": "ABDULLA ALI ABDULLA ALGHAILANI ALJNEIBI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/12/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Ali Abdulla Alghailani Aljneibi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_50ccb7af-0fd5-4ea5-8eaf-736b86413cc2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1613",
    "licenseIssueDate": "12/23/2021 00:00:00",
    "licenseExpiryDate": "12/22/2025 00:00:00"
  },
  {
    "id": "46e85d0f-b487-4335-8139-410bd9502a99",
    "slug": "abdulla-ali-abdulwahab-abdulla-alsuwidi",
    "name": "ABDUULA ALI ABDULWAHAB ABDULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 15,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/02/2010",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Ali Abdulwahab Abdulla Alsuwidi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_46e85d0f-b487-4335-8139-410bd9502a99",
        "address": "بلوك بي  ,R338 ,بجانب بناية سيتي بنك - بجوار مركز وافي  ,0554060326 ,Dubai",
        "phone": "97143337444",
        "email": "info@alsuwaidi-advo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "525230a9-87e0-4951-b745-c8d2a983cf8e",
    "firmName": "ABDULLA ALSUWAIDI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-698",
    "licenseIssueDate": "02/09/2010 00:00:00",
    "licenseExpiryDate": "02/08/2026 00:00:00"
  },
  {
    "id": "5bd4c81c-c470-426f-a69a-e2ca8eafd656",
    "slug": "abdulla-ali-mohamed-ahmed-alobeidli",
    "name": "Abdulla Ali Mohamed Ahmed Alobeidli",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/14/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Ali Mohamed Ahmed Alobeidli",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5bd4c81c-c470-426f-a69a-e2ca8eafd656",
        "address": "",
        "phone": "97142775444 / 971507886668",
        "email": "info@abdlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "ad6c697f-ac72-4c32-a757-7cd13a6fcd3f",
    "firmName": "ABDULLA ALOBEIDLI ADVOCATES &LEGAL CONSULTANT",
    "registrationNumber": "971",
    "licenseIssueDate": "10/14/2014 00:00:00",
    "licenseExpiryDate": "10/13/2026 00:00:00"
  },
  {
    "id": "9c9835c5-8c00-48ff-a270-102ade5a58ab",
    "slug": "abdulla-ali-mohammed-binhatem",
    "name": "ABDULLA ALI MOHAMMED BINHATEM ALBLOOSHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Criminal Law-Family Crimes",
      "Civil Transactions-Tenancy",
      "Civil Transactions-Labor & Workers",
      "Commercial Transactions-Consumer protection",
      "Commercial Transactions-Intellectual Property (includes trademarks",
      "copy rights",
      "patents)"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/11/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: abdulla ali mohammed binhatem",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9c9835c5-8c00-48ff-a270-102ade5a58ab",
        "address": "1 ,Crystal Tower ,Business Bay ,1859 ,Dubai",
        "phone": "97142956661",
        "email": "info@amrplc.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "833edb7f-7a70-4ab6-9838-4782eb1b4f8a",
    "firmName": "ABDULLA MOHAMMED RASOUL ALHARMOODI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1320",
    "licenseIssueDate": "11/07/2018 00:00:00",
    "licenseExpiryDate": "11/06/2025 00:00:00"
  },
  {
    "id": "e50aa5fa-165c-4c62-a679-f2c4f566b52b",
    "slug": "abdulla-amin-abdulrahim-k-alzarooni",
    "name": "ABDULLA AMIN ABDULRAHIM KAIKHOH ALZAROONI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 15,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/02/2010",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Amin Abdulrahim k. Alzarooni",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e50aa5fa-165c-4c62-a679-f2c4f566b52b",
        "address": "ABDULLAH AMIN ALZAROONI ,209+210+611+211 ,بزنس افينيو ,خلف وكالة النيسان ,12781 ,Dubai",
        "phone": "97142954299",
        "email": "zaroonilawyers@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "da078082-58a6-4951-b43c-9a5a9bf24934",
    "firmName": "ABDULLA AL ZAROONI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-700",
    "licenseIssueDate": "02/28/2010 00:00:00",
    "licenseExpiryDate": "02/27/2026 00:00:00"
  },
  {
    "id": "aeae4201-b007-46ff-8985-bd663dbd4b8f",
    "slug": "abdulla-aqeel-taher-aqeel-almahri",
    "name": "ABDULLA AQEEL TAHER AQEEL ALMAHRI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/11/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Aqeel Taher Aqeel Almahri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_aeae4201-b007-46ff-8985-bd663dbd4b8f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1322",
    "licenseIssueDate": "11/07/2018 00:00:00",
    "licenseExpiryDate": "11/06/2025 00:00:00"
  },
  {
    "id": "192c53e3-e10f-4d72-85c3-1c8b899b96d5",
    "slug": "abdulla-ebrahim-hasan-almulla-almansoori",
    "name": "ABDULLA EBRAHIM HASAN E ALMULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/01/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Ebrahim Hasan Almulla Almansoori",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_192c53e3-e10f-4d72-85c3-1c8b899b96d5",
        "address": "",
        "phone": "97145571020",
        "email": "abdullaalmansoori80@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "1f7b1225-9eb2-412b-9776-298c43ff6240",
    "firmName": "ABDULLA EBRAHIM ALMULLA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1142",
    "licenseIssueDate": "01/15/2017 00:00:00",
    "licenseExpiryDate": "01/14/2026 00:00:00"
  },
  {
    "id": "f483fd35-d5fe-4b21-b90a-d14cd5e64d81",
    "slug": "abdulla-ebrahim-jasim-khamis-almansoori",
    "name": "EBRAHIM JASIM KHAMIS OBAID",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/12/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Ebrahim Jasim Khamis Almansoori",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f483fd35-d5fe-4b21-b90a-d14cd5e64d81",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1605",
    "licenseIssueDate": "12/08/2021 00:00:00",
    "licenseExpiryDate": "12/07/2025 00:00:00"
  },
  {
    "id": "ebd84968-1baf-4da9-aa00-7517fe12b44e",
    "slug": "abdulla-ebrahim-mohammed-amin-alhurmoodi",
    "name": "Abdulla Ebrahim Mohammed Amin Alhurmoodi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/03/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Ebrahim Mohammed Amin Alhurmoodi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ebd84968-1baf-4da9-aa00-7517fe12b44e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "1049",
    "licenseIssueDate": "02/03/2016 00:00:00",
    "licenseExpiryDate": "02/02/2026 00:00:00"
  },
  {
    "id": "91fbc116-c2a2-47e0-a9b2-36db4f7f999a",
    "slug": "abdulla-haji-ghulam-ali",
    "name": "ABDULLA HAJI GHULAM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 15,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/12/2009",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Haji Ghulam Ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_91fbc116-c2a2-47e0-a9b2-36db4f7f999a",
        "address": "الطابق السادس  مكتب 602 ,المسعود ,دوار الساعة  ,97766 ,Dubai",
        "phone": "97142369336",
        "email": "ahlawyer20@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "a687e1d2-fda1-4db2-9333-2407481ae527",
    "firmName": "ABDULLA HAJI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-690",
    "licenseIssueDate": "12/24/2009 00:00:00",
    "licenseExpiryDate": "12/23/2025 00:00:00"
  },
  {
    "id": "44afebdd-b4ff-4c72-a176-6b923cc3bf71",
    "slug": "abdulla-hamdan-rashed-ali-aizeyoudi",
    "name": "ABDULLA HAMDAN RASHED RASHOUD AIZEYOUDI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/01/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ABDULLA HAMDAN RASHED ALI AIZEYOUDI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_44afebdd-b4ff-4c72-a176-6b923cc3bf71",
        "address": "",
        "phone": "97148845339 / 971505303737",
        "email": "office@law-hrz.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "522234a0-35f4-468e-8f86-5633ca5ea354",
    "firmName": "HAMDAN RASHOUD ALZEYOUDI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-1494",
    "licenseIssueDate": "01/13/2021 00:00:00",
    "licenseExpiryDate": "01/12/2026 00:00:00"
  },
  {
    "id": "f6705032-d9b6-4088-bc1b-1c1065357d58",
    "slug": "abdulla-hassan-ahmad-taher",
    "name": "ABDULLA HASSAN AHMAD TAHER",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 38,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/12/1986",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Hassan Ahmad Taher",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f6705032-d9b6-4088-bc1b-1c1065357d58",
        "address": "السادس , مباني الحضيبة للجوائز  ,علم الاتحاد ,200 ,Dubai",
        "phone": "97143545111",
        "email": "altaher_alsabri@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "aced7900-0571-43e1-b49b-4740c6dc298f",
    "firmName": "AL TAHER & AL SABRI ADVOCATES",
    "registrationNumber": "L-169",
    "licenseIssueDate": "12/22/1986 00:00:00",
    "licenseExpiryDate": "12/21/2025 00:00:00"
  },
  {
    "id": "92f43885-8be6-45fa-b06f-b1b50ea66b78",
    "slug": "abdulla-hassan-ahmed-bamedhaf",
    "name": "ABDULLA HASSAN AHMED BAMEDHAF",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 19,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/08/2006 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ABDULLA HASSAN AHMED BAMEDHAF",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_92f43885-8be6-45fa-b06f-b1b50ea66b78",
        "address": "M4 ,DAR AL SAFIYA BLDG ,مستشفى إن إم سي ,40403 ,Dubai",
        "phone": "97142294666",
        "email": "bamlegal@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "6530c077-1201-41ce-b3d8-f4966b7cc2aa",
    "firmName": "BAMEDHAF ASSOCIATES",
    "registrationNumber": "571",
    "licenseIssueDate": "05/08/2006 00:00:00",
    "licenseExpiryDate": "05/07/2026 00:00:00"
  },
  {
    "id": "6c1ee5cf-6843-4745-8890-b9cea97ce54f",
    "slug": "abdulla-husain-bakhit-hudaijan",
    "name": "ABDULLA HUSAIN BAKHIT HUDAIJAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/07/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Husain Bakhit Hudaijan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6c1ee5cf-6843-4745-8890-b9cea97ce54f",
        "address": "",
        "phone": "97142512221",
        "email": "info@ahal-advocacy.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "9367d5c4-b8c9-49a6-a229-7da2663c3957",
    "firmName": "ABDULLAH HUSSAIN ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-825",
    "licenseIssueDate": "07/17/2012 00:00:00",
    "licenseExpiryDate": "07/16/2026 00:00:00"
  },
  {
    "id": "f1c07b64-d5d7-4f18-a87d-e6f90d7b04b0",
    "slug": "abdulla-hussain-rashed-lootah",
    "name": "ABDULLA HUSSAIN RASHED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/10/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Hussain Rashed Lootah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f1c07b64-d5d7-4f18-a87d-e6f90d7b04b0",
        "address": "mansoor lootah ,مطعم شيلز ,صالح بن لاحج , مطعم شيلز  ,95151 ,Dubai",
        "phone": "97142833337 / 971559596445",
        "email": "info@mansoorlootahadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "4488ad94-e6b8-4b33-8e21-04e8986bf218",
    "firmName": "MANSOOR LOOTAH ADVOCATES &LEGAL CONSULTANCY",
    "registrationNumber": "L-1116",
    "licenseIssueDate": "10/12/2016 00:00:00",
    "licenseExpiryDate": "10/11/2025 00:00:00"
  },
  {
    "id": "498b2769-3063-49b6-91ec-e93e727a45cd",
    "slug": "abdulla-ibrahim-mohammad-ahmad-alqassim",
    "name": "ABDULLA IBRAHIM MOHAMMAD AHMAD ALQASSIM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/02/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Ibrahim Mohammad Ahmad Alqassim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_498b2769-3063-49b6-91ec-e93e727a45cd",
        "address": "",
        "phone": "97142224441",
        "email": "info@ialqassim.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "41cb350f-b39d-4e9d-aaed-e79bb9af487d",
    "firmName": "IBRAHIM AL QASSIM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1148",
    "licenseIssueDate": "02/08/2017 00:00:00",
    "licenseExpiryDate": "02/07/2026 00:00:00"
  },
  {
    "id": "e5899b74-a24c-42d6-ac52-ebeca81fcc2e",
    "slug": "abdulla-jumah-saad-alhabshi-al-ali",
    "name": "ABDULRAHMAN ABDULLA ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/04/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: abdulla jumah saad alhabshi al-ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e5899b74-a24c-42d6-ac52-ebeca81fcc2e",
        "address": "MOSTAFA MAHMOUD  ,1304 ,AL MOOSA TOWER 1 ,First Trade Center ,25635 ,Dubai",
        "phone": "97142254438",
        "email": "info@hkadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "d73d1b91-74ae-4266-9f38-d28296d70f52",
    "firmName": "ALOBAIDLI & ALZAROONI ADVOCATES&LEGAL CONSULTANTS",
    "registrationNumber": "L-1650",
    "licenseIssueDate": "05/10/2022 00:00:00",
    "licenseExpiryDate": "05/09/2026 00:00:00"
  },
  {
    "id": "9e3b08a1-2cd0-4182-aed5-158c5ae30744",
    "slug": "abdulla-khamis-saeed-aldhaheri",
    "name": "SAOUD MUBARAK SALEH",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/06/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: abdulla khamis saeed aldhaheri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9e3b08a1-2cd0-4182-aed5-158c5ae30744",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1825",
    "licenseIssueDate": "07/11/2023 00:00:00",
    "licenseExpiryDate": "07/10/2026 00:00:00"
  },
  {
    "id": "fdf38179-a0c8-4720-91b8-914f64212908",
    "slug": "abdulla-khelfan-mohammed-khelfan-al-madhani",
    "name": "ABDULLA KHALFAN MOHAMMAD KHALFAN ALMADHANI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 22,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/08/2003",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Khelfan Mohammed Khelfan Al-Madhani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fdf38179-a0c8-4720-91b8-914f64212908",
        "address": "",
        "phone": "97143298881",
        "email": "info@mslawuae.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "2510dab9-717a-4a15-b189-4272261227e3",
    "firmName": "AL MADHANI & ALSHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-454",
    "licenseIssueDate": "08/16/2003 00:00:00",
    "licenseExpiryDate": "08/15/2026 00:00:00"
  },
  {
    "id": "539ff803-9c98-4a0e-9d8d-c8a2d3affb6c",
    "slug": "abdulla-mabkhout-salem-mohammed-alrashdi",
    "name": "ABDULLA MABKHOUT SALEM MOHAMMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/10/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Mabkhout Salem Mohammed Alrashdi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_539ff803-9c98-4a0e-9d8d-c8a2d3affb6c",
        "address": "",
        "phone": "97143444491 / 971508002092",
        "email": "awdfms@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "dfb85a31-3414-4198-9ccd-c3ae8ac4ed71",
    "firmName": "AWAD ALARYANI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1462",
    "licenseIssueDate": "10/08/2020 00:00:00",
    "licenseExpiryDate": "10/07/2026 00:00:00"
  },
  {
    "id": "3e60fa90-c620-4ce4-8c18-1b67837383ed",
    "slug": "abdulla-mahdi-fahed-badi-alateibi",
    "name": "ALYAA OBAID SAEED OBAID SAEED ALHEFEITI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/11/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Mahdi Fahed Badi Alateibi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3e60fa90-c620-4ce4-8c18-1b67837383ed",
        "address": "",
        "phone": "97145859327 / 971503148845",
        "email": "info@amalc.net",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "35e74c66-ffd0-4b2c-bc7c-025474d0a49d",
    "firmName": "BAITULHIKMA LAWYERS",
    "registrationNumber": "L-2045",
    "licenseIssueDate": "11/21/2024 00:00:00",
    "licenseExpiryDate": "11/20/2025 00:00:00"
  },
  {
    "id": "7043a6fd-75e8-4ee0-b3cc-93bffd96caa3",
    "slug": "abdulla-marwan-abdulla-ahmed-bekhit-al-matrooshi",
    "name": "ABDULLA MARWAN ABDULLA AHMED ALMATROOSHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/05/2009",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Marwan Abdulla Ahmed Bekhit Al Matrooshi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7043a6fd-75e8-4ee0-b3cc-93bffd96caa3",
        "address": "Mezzanine / 09 ,Business Point  ,Behind Nissan Showroom ,85825 ,Dubai",
        "phone": "97142595777",
        "email": "ALMATROOSHI@OMALC.AE",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "588c9e2f-4f09-44bb-9e80-4e56d3f821b6",
    "firmName": "ALOWAIS AND ALMATROOSHI ADVOCATE AND LEGAL CONSULTANTS",
    "registrationNumber": "L-666",
    "licenseIssueDate": "05/03/2009 00:00:00",
    "licenseExpiryDate": "05/02/2026 00:00:00"
  },
  {
    "id": "5eb42313-3f2c-402d-85ff-e5c3b3e0e4a4",
    "slug": "abdulla-matar-bakhit-khalfan-alfalasi",
    "name": "ABDULLA MATAR BAKHIT KHALFAN ALFALASI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/10/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Matar Bakhit Khalfan Alfalasi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5eb42313-3f2c-402d-85ff-e5c3b3e0e4a4",
        "address": "الطابق 23 - مكتب رقم 2304 ,ايريس باي ,رقم مكاني: 2466086696 ,23328 ,Dubai",
        "phone": "97143250002 / 971508090162",
        "email": "aflawfirm@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "72fce5f8-422f-47e1-b013-84b844329982",
    "firmName": "ABDULLA MATAR ALFALASI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-972",
    "licenseIssueDate": "10/15/2014 00:00:00",
    "licenseExpiryDate": "10/14/2026 00:00:00"
  },
  {
    "id": "46fd80bc-e73f-4a02-94e0-2ac61f266c25",
    "slug": "abdulla-mohamed-abdulla-abdulrahman-alyassi",
    "name": "AHMED RASHED AHMED HASAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/01/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Mohamed Abdulla Abdulrahman Alyassi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_46fd80bc-e73f-4a02-94e0-2ac61f266c25",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1916",
    "licenseIssueDate": "02/11/2024 00:00:00",
    "licenseExpiryDate": "02/10/2026 00:00:00"
  },
  {
    "id": "5f477cb5-a730-46ea-a192-88742ead86ea",
    "slug": "abdulla-mohamed-abdulla-alomran-alshamsi",
    "name": "ABDULLA MOHAMED ALOMRAN AL SHAMSI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/11/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-11-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Mohamed Abdulla Alomran Alshamsi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5f477cb5-a730-46ea-a192-88742ead86ea",
        "address": "",
        "phone": "97143528314",
        "email": "alomran.advocates@alaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "c0d5ee8d-2020-4bd5-8b4f-efe6ea0f4acc",
    "firmName": "ABDULLA ALOMRAN ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-900",
    "licenseIssueDate": "11/24/2013 00:00:00",
    "licenseExpiryDate": "11/23/2025 00:00:00"
  },
  {
    "id": "e51ef950-1fb1-4ace-a167-75ac4b6be09f",
    "slug": "abdulla-mohamed-abdulla-hasan-alsaadi",
    "name": "NOURAH RASHED JUMAH A A AL MORSHEDI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/02/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Mohamed Abdulla Hasan Alsaadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e51ef950-1fb1-4ace-a167-75ac4b6be09f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1771",
    "licenseIssueDate": "03/03/2023 00:00:00",
    "licenseExpiryDate": "03/02/2024 00:00:00"
  },
  {
    "id": "8d04513e-8726-45ab-acf8-84a01ecb21ca",
    "slug": "abdulla-mohamed-abdulla-sulaiman-alqadi",
    "name": "TAREQ N S THABET",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/09/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: abdulla mohamed abdulla sulaiman alqadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8d04513e-8726-45ab-acf8-84a01ecb21ca",
        "address": "",
        "phone": "/ 971506278383",
        "email": "alqadi1974@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "9a3c6439-8f4f-47b9-a3e6-6c7d15cb891f",
    "firmName": "TAREQ THABIT ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1867",
    "licenseIssueDate": "09/22/2023 00:00:00",
    "licenseExpiryDate": "09/21/2026 00:00:00"
  },
  {
    "id": "172ead2d-675b-499b-ac39-3befa0a11214",
    "slug": "abdulla-mohamed-ali-al-zari-al-shamsi",
    "name": "ABDALLA MOHAMED ALI ALZARI ALSHAMSI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/03/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Mohamed Ali Al Zari Al Shamsi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_172ead2d-675b-499b-ac39-3befa0a11214",
        "address": "3902 ,single business tower ,Sheikh Zayed Rd.  ,90077 ,Dubai",
        "phone": "97143804141 / 97143804141",
        "email": "info@united-advocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "52ebf695-ce46-4e03-abc9-f4d8d2f8a356",
    "firmName": "UNITED ADVOCATES",
    "registrationNumber": "L-922",
    "licenseIssueDate": "03/24/2014 00:00:00",
    "licenseExpiryDate": "03/23/2026 00:00:00"
  },
  {
    "id": "ce5378f0-b42a-47e1-9133-40824ded6bcd",
    "slug": "abdulla-mohamed-ebrahim-hadoof-alhammadi",
    "name": "ABDULLA MOHAMED EBRAHIM HADDOOF",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/08/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Mohamed Ebrahim Hadoof Alhammadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ce5378f0-b42a-47e1-9133-40824ded6bcd",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-887",
    "licenseIssueDate": "09/01/2013 00:00:00",
    "licenseExpiryDate": "08/31/2026 00:00:00"
  },
  {
    "id": "ea9eb07c-eb9d-437a-b2bc-21aaee867bd6",
    "slug": "abdulla-mohammad-saeed-banama",
    "name": "ABDULLA MOHAMMED SAEED BANAMA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Civil Transactions-HR & Employee Affairs",
      "Personal Status-Custody & Alimony",
      "Civil Transactions-Immigration and Residency",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Criminal Law-Hate crimes",
      "Civil Transactions-Tenancy",
      "Criminal Law-Crimes against persons",
      "Personal Status-Legacies and Inheritance",
      "Civil Transactions-Labor & Workers",
      "Criminal Law-Drug Crimes",
      "Civil Transactions-Sale",
      "Personal Status-Marriage & Divorce",
      "Personal Status-Child Abuse & Abduction",
      "Criminal Law-Crimes against properties",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/01/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Mohammad Saeed Banama",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ea9eb07c-eb9d-437a-b2bc-21aaee867bd6",
        "address": "18 ,فندق مونارك  ,مركز التجاري ,98444 ,Dubai",
        "phone": "97143588777",
        "email": "info@bhadvoc.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "61266d12-f5b4-4466-a1a8-a45934d9e511",
    "firmName": "BIN HAIDER ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-738",
    "licenseIssueDate": "01/25/2011 00:00:00",
    "licenseExpiryDate": "01/24/2026 00:00:00"
  },
  {
    "id": "9de2eb69-1ff3-4ef2-9e5e-c3a7e15ff016",
    "slug": "abdulla-mohammed-abdulla-abdulrahman-al-bannai",
    "name": "ABDULLA MOHAMMED ABDULLA A ALBANNAI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 22,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/05/2003",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Mohammed Abdulla AbdulRahman Al Bannai",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9de2eb69-1ff3-4ef2-9e5e-c3a7e15ff016",
        "address": "",
        "phone": "97143433300",
        "email": "info@theattorneys.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "931ca6f7-8621-4da0-9545-a993725337e0",
    "firmName": "THE ATTORNIES ADVOCATES & LEGAL CONSULTANT",
    "registrationNumber": "L-446",
    "licenseIssueDate": "05/24/2003 00:00:00",
    "licenseExpiryDate": "05/23/2026 00:00:00"
  },
  {
    "id": "6ec1e6cb-a5f5-43fb-87a0-3d6f17953013",
    "slug": "abdulla-mohammed-ahmed-naser-alyassi",
    "name": "ABDALLA MOHAMED AHMED NASIR ALYASSI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/01/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Mohammed Ahmed Naser Alyassi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6ec1e6cb-a5f5-43fb-87a0-3d6f17953013",
        "address": "",
        "phone": "97140000000 / 971507448882",
        "email": "a.alyassi@alyassi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "2ba14bc2-2913-4786-a320-b15dfea056e2",
    "firmName": "ABDALLA AL YASSI ADVOCATES AND LEGAL CONSULTANCY",
    "registrationNumber": "L-1502",
    "licenseIssueDate": "01/28/2021 00:00:00",
    "licenseExpiryDate": "01/27/2026 00:00:00"
  },
  {
    "id": "1d84023e-6b81-4ecd-9cb6-8c35b5df2a7e",
    "slug": "abdulla-mohammed-haji-al-awadi",
    "name": "ABDULLA MOHAMED HAJI ALI ALAWADHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 27,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/01/1998",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Mohammed Haji Al Awadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1d84023e-6b81-4ecd-9cb6-8c35b5df2a7e",
        "address": "Advo. Abdulla Al Awadi ,العاشر  ,برايم تاور  ,فندق فيدا ,26665 ,Dubai",
        "phone": "97143352200",
        "email": "info@abdullaalawadi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "5075821f-98f5-4546-8fcd-6cdc74967dac",
    "firmName": "ABDULLA ALAWADI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-324",
    "licenseIssueDate": "01/10/1998 00:00:00",
    "licenseExpiryDate": "01/09/2026 00:00:00"
  },
  {
    "id": "cf896526-e47d-4b8c-9a14-f99d71de4ec7",
    "slug": "abdulla-mohammed-obaid-almaftool-alali",
    "name": "AHMED HELAL EBRAHEIM AL GHEES ALDHANHANI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/06/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: abdulla mohammed obaid almaftool alali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cf896526-e47d-4b8c-9a14-f99d71de4ec7",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1992",
    "licenseIssueDate": "06/26/2024 00:00:00",
    "licenseExpiryDate": "06/25/2026 00:00:00"
  },
  {
    "id": "41fe373b-a859-4208-9008-86c38a13fced",
    "slug": "abdulla-mohammed-rasoul-ali-al-harmoudi",
    "name": "ABDULLA MOHAMMED RASOUL ALI ALHARMOODI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Criminal Law-Family Crimes",
      "Civil Transactions-Immigration and Residency",
      "Civil Transactions-Tenancy",
      "Civil Transactions-Labor & Workers",
      "Commercial Transactions-Consumer protection"
    ],
    "experience": 20,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/01/2005",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Mohammed Rasoul Ali Al Harmoudi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_41fe373b-a859-4208-9008-86c38a13fced",
        "address": "1 ,Crystal Tower ,Business Bay ,1859 ,Dubai",
        "phone": "97142956661",
        "email": "info@amrplc.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "833edb7f-7a70-4ab6-9838-4782eb1b4f8a",
    "firmName": "ABDULLA MOHAMMED RASOUL ALHARMOODI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-498",
    "licenseIssueDate": "01/10/2005 00:00:00",
    "licenseExpiryDate": "01/09/2026 00:00:00"
  },
  {
    "id": "799b64f6-6ddb-4abe-aa52-a6e4b3a12bd2",
    "slug": "abdulla-mohammed-salem-hmouda-alnuaimi",
    "name": "JASEM MOHAMMED ABDULKAREEM M.ALMUDHARREB",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/05/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Mohammed Salem Hmouda Alnuaimi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_799b64f6-6ddb-4abe-aa52-a6e4b3a12bd2",
        "address": "",
        "phone": "97142200065",
        "email": "Abdulla-Alnuaimi-legal@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "608b7768-a584-45d4-beb5-e67ccb685c53",
    "firmName": "LAW FIRM INTERNATIONAL ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-1660",
    "licenseIssueDate": "05/27/2022 00:00:00",
    "licenseExpiryDate": "05/26/2026 00:00:00"
  },
  {
    "id": "3ed79db3-7068-4b84-b5ec-140f1aef2ec7",
    "slug": "abdulla-mohammed-yousef-abdulla-alhassan-almansoori",
    "name": "ABDULLA MOHAMMED YOUSEF A ALHASAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 15,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/03/2010",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Mohammed Yousef Abdulla Alhassan Almansoori",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3ed79db3-7068-4b84-b5ec-140f1aef2ec7",
        "address": "Hussain Ali Al Jaziri ,11 ,City Tower 2 ,Crown Plaza hotel Sheikh Zayed Road ,4253 ,Dubai",
        "phone": "97142626777 / 971529087670",
        "email": "courts@jaflaws.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "c58d8654-b428-46b3-abd5-024e4331ee53",
    "firmName": "JAAFAR ALWAN & AL JAZIRI & ASSOCIATES",
    "registrationNumber": "L-701",
    "licenseIssueDate": "03/07/2010 00:00:00",
    "licenseExpiryDate": "03/06/2026 00:00:00"
  },
  {
    "id": "376a6a3e-320e-4c6b-aa6c-defa6204eb57",
    "slug": "abdulla-mohd-jaber-abdulla-al-harbi",
    "name": "AMNA MOHAMED ALI MOHAMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/01/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Mohd Jaber Abdulla Al Harbi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_376a6a3e-320e-4c6b-aa6c-defa6204eb57",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1755",
    "licenseIssueDate": "02/09/2023 00:00:00",
    "licenseExpiryDate": "02/08/2026 00:00:00"
  },
  {
    "id": "e97e5ee2-5090-475e-b5ae-ee4eb5e40249",
    "slug": "abdulla-mubarak-mabrouk-omar-alameri",
    "name": "ABDULLA MUBARAK MABROUK OMAR ALAMERI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/12/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Mubarak Mabrouk Omar Alameri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e97e5ee2-5090-475e-b5ae-ee4eb5e40249",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1489",
    "licenseIssueDate": "12/24/2020 00:00:00",
    "licenseExpiryDate": "12/23/2025 00:00:00"
  },
  {
    "id": "c3db4462-e536-46db-b48b-33894257100d",
    "slug": "abdulla-mubarak-mohamed-houfan-al-mansoori",
    "name": "ABDULLA MUBARAK MOHAMED HOUFAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Criminal Law-Cybercrimes"
    ],
    "experience": 15,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/12/2009",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Mubarak Mohamed Houfan Al Mansoori",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c3db4462-e536-46db-b48b-33894257100d",
        "address": "abdulla al mansoori ,الطابق السابع  ,الغزال ستاندرد  ,مول الغزال ,393164 ,Dubai",
        "phone": "97145531403 / 971569305848",
        "email": "info@abmadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "4f9219c1-5db2-45f9-bc5b-838c784a6216",
    "firmName": "ABDULLA AL MANSOORI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-692",
    "licenseIssueDate": "12/30/2009 00:00:00",
    "licenseExpiryDate": "12/29/2025 00:00:00"
  },
  {
    "id": "56f85cd2-6d48-4f5e-9920-0c1045ad6fa2",
    "slug": "abdulla-musabbeh-obaid-binhamad-almheiri",
    "name": "ABDULLA MUSABBEH OBAID B.HAMAD ALMHEIRI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/10/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Musabbeh Obaid Binhamad Almheiri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_56f85cd2-6d48-4f5e-9920-0c1045ad6fa2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1112",
    "licenseIssueDate": "10/03/2016 00:00:00",
    "licenseExpiryDate": "10/02/2026 00:00:00"
  },
  {
    "id": "3258a241-6836-4610-b59f-85ad2ff385e4",
    "slug": "abdulla-musabbeh-saeed-ali-almazrouei",
    "name": "ABDULRAHMAN OMAR ABDULLATIF M ALZAROONI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/05/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ABDULLA MUSABBEH SAEED ALI ALMAZROUEI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3258a241-6836-4610-b59f-85ad2ff385e4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1977",
    "licenseIssueDate": "06/05/2024 00:00:00",
    "licenseExpiryDate": "06/04/2026 00:00:00"
  },
  {
    "id": "5867185b-ac21-4064-8371-b1399dab3f17",
    "slug": "abdulla-mutar-khames-al-mezaina",
    "name": "ABDULLA MATTAR KHAMIS ALMEZAINA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 33,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/11/1991",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Mutar Khames Al-Mezaina",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5867185b-ac21-4064-8371-b1399dab3f17",
        "address": "",
        "phone": "97143355577",
        "email": "daraladalah1991@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "61efd89c-1d0d-4136-8397-2814c745f0da",
    "firmName": "DAR AL ADALA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-242",
    "licenseIssueDate": "11/26/1991 00:00:00",
    "licenseExpiryDate": "11/25/2025 00:00:00"
  },
  {
    "id": "ce1d4890-0082-4d44-85bb-1209570684c8",
    "slug": "abdulla-nasser-mansour-hamad-al-kaabi",
    "name": "ABDULLA NASSER MANSOUR HAMAD ALKAABI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 17,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/08/2008",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ABDULLA NASSER MANSOUR HAMAD AL KAABI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ce1d4890-0082-4d44-85bb-1209570684c8",
        "address": "abdulla nasser mansour hamad alkaabi ,life pharmacy ,al safa ,millennium plaza hotel ,113713 ,Dubai",
        "phone": "97143598998",
        "email": "advo.akd@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "05d59198-4e23-4b78-bb9b-d55bfcd69060",
    "firmName": "ABDULLA AL KAABI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-642",
    "licenseIssueDate": "09/01/2008 00:00:00",
    "licenseExpiryDate": "08/31/2026 00:00:00"
  },
  {
    "id": "57c30161-5652-4607-a57a-08ae881fdf02",
    "slug": "abdulla-obaid-sulaiman-hamad-almutawa",
    "name": "SAEED MOHAMED RASHED OBAID",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/08/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Obaid Sulaiman Hamad Almutawa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_57c30161-5652-4607-a57a-08ae881fdf02",
        "address": "13 ,Le Solarium Tower ,Arabian Gate ,185430 ,Dubai",
        "phone": "97145805135 / 971558703836",
        "email": "info@alnaqbilaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "24f8f7c8-a688-4587-9e87-f3105a99533a",
    "firmName": "DR FAISAL ALHEFEITI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1850",
    "licenseIssueDate": "08/24/2023 00:00:00",
    "licenseExpiryDate": "08/23/2026 00:00:00"
  },
  {
    "id": "de1ffdb9-e40c-4445-8b29-78d994a11a97",
    "slug": "abdulla-rashed-abdulla-alsahwa-alhebsi",
    "name": "ABDULLA RASHED ABDULLA ALSAHWA ALHEBSI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/09/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Rashed Abdulla Alsahwa Alhebsi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_de1ffdb9-e40c-4445-8b29-78d994a11a97",
        "address": "",
        "phone": "97145686887 / 971000000000",
        "email": "info@satlawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "19abc134-e04a-4728-8b0b-04814e587c5b",
    "firmName": "SAEED ALI TAHER ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-1449",
    "licenseIssueDate": "09/06/2020 00:00:00",
    "licenseExpiryDate": "09/05/2026 00:00:00"
  },
  {
    "id": "2c2b42ea-a764-4cac-b57c-598cd5de3046",
    "slug": "abdulla-rashed-mohamed-rashed-alzaabi",
    "name": "ABDULLA RASHED MOHAMED RASHED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/03/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Rashed Mohamed Rashed Alzaabi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2c2b42ea-a764-4cac-b57c-598cd5de3046",
        "address": "6F 603, 605, 7F 704 ,Crystal Tower ,Dubai Mall ,117538 ,Dubai",
        "phone": "97146098700",
        "email": "pro@miolawfirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "417f90a1-03be-4dab-8eea-1bba7e16f536",
    "firmName": "ABU BAKER SALEM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1346",
    "licenseIssueDate": "03/01/2019 00:00:00",
    "licenseExpiryDate": "02/28/2026 00:00:00"
  },
  {
    "id": "b9b30671-410c-484b-a68f-af7d71637232",
    "slug": "abdulla-rashed-saeed-barshoud-almurshidi",
    "name": "WEDAD ALI HUSSAIN HASSAN MOHAMMAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/10/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: abdulla rashed saeed barshoud almurshidi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b9b30671-410c-484b-a68f-af7d71637232",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1717",
    "licenseIssueDate": "11/11/2022 00:00:00",
    "licenseExpiryDate": "11/10/2025 00:00:00"
  },
  {
    "id": "a0dcc2e5-c13d-4179-be2e-fcb94bf65c48",
    "slug": "abdulla-rashid-obaid-bukhuwaisra-alshamsi",
    "name": "BUSHRA OBAID MOHAMED ALI ALMANSOORI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/05/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ABDULLA RASHID OBAID BUKHUWAISRA ALSHAMSI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a0dcc2e5-c13d-4179-be2e-fcb94bf65c48",
        "address": "4 ,Century 21 building ,al kabayel discount centre ,340781 ,Dubai",
        "phone": "97142417888 / 971562693277",
        "email": "dubai@khbinomair.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "34306e48-bd22-4b51-b883-2a538d4f1890",
    "firmName": "HANAN SALEM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1960",
    "licenseIssueDate": "05/17/2024 00:00:00",
    "licenseExpiryDate": "05/16/2026 00:00:00"
  },
  {
    "id": "2b258c3f-1ff9-41ed-8eb3-73a97b365410",
    "slug": "abdulla-saeed-abdulla-mohamed-alawadhi",
    "name": "ABDULLA SAEED ABDULLA MOHAMED ROKNAH",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/01/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Saeed Abdulla Mohamed Alawadhi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2b258c3f-1ff9-41ed-8eb3-73a97b365410",
        "address": "الطابق 14  ,برج 48 جيت  ,محطة مترو دبي  ,413633 ,Dubai",
        "phone": "97144412031",
        "email": "courts@adglegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "4287f048-dc0c-4d51-9e0c-0c23356040ee",
    "firmName": "MOHAMMED AL DAHBASHI ADVOCATES",
    "registrationNumber": "L-1400",
    "licenseIssueDate": "01/22/2020 00:00:00",
    "licenseExpiryDate": "01/21/2026 00:00:00"
  },
  {
    "id": "c28c9027-3c59-4976-9632-17cacf8b6507",
    "slug": "abdulla-saeed-hassan-saif-alzaabi",
    "name": "OTHAIBA ANBAR OBAID ALMAZROUEI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/01/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Saeed Hassan Saif Alzaabi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c28c9027-3c59-4976-9632-17cacf8b6507",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1913",
    "licenseIssueDate": "02/07/2024 00:00:00",
    "licenseExpiryDate": "02/06/2026 00:00:00"
  },
  {
    "id": "8f59b1e5-ef1b-43ca-bd4a-2dbccde17e3c",
    "slug": "abdulla-saeed-mohammed-salmeen-almahri",
    "name": "ABDULLA SAEED MOHAMMED SALMEEN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/02/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Saeed Mohammed Salmeen Almahri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8f59b1e5-ef1b-43ca-bd4a-2dbccde17e3c",
        "address": "samer tohme ,4th- office 433 ,Emarat Atrium ,Dubai Canal ,79436 ,Dubai",
        "phone": "97126722500",
        "email": "info@dxblawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "00b6334f-44e7-458e-8ce5-7d4256840067",
    "firmName": "MOHAMED ABDULLA LAWYERS AND LEGAL CONSULTANTS",
    "registrationNumber": "L-1408",
    "licenseIssueDate": "02/16/2020 00:00:00",
    "licenseExpiryDate": "02/15/2026 00:00:00"
  },
  {
    "id": "ff1191ec-3998-4c82-a6da-03d59ad0910b",
    "slug": "abdulla-saeed-rashed-mohammad-alfalasi",
    "name": "SARAH ABDULMUNEM SALEM OBAID",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/06/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Saeed Rashed Mohammad Alfalasi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ff1191ec-3998-4c82-a6da-03d59ad0910b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1823",
    "licenseIssueDate": "07/03/2023 00:00:00",
    "licenseExpiryDate": "07/02/2025 00:00:00"
  },
  {
    "id": "0571a6d5-e585-4636-99e3-f45874326b23",
    "slug": "abdulla-saif-kharbash-saeed-alsaedi",
    "name": "ABDULLA SAIF KHARBASH SAEED ALSAEDI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/12/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla saif kharbash saeed ALsaedi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0571a6d5-e585-4636-99e3-f45874326b23",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1487",
    "licenseIssueDate": "12/16/2020 00:00:00",
    "licenseExpiryDate": "12/15/2025 00:00:00"
  },
  {
    "id": "76b9f031-a7cd-40da-b720-b0b2ebddd9b9",
    "slug": "abdulla-saleh-abdulrahman-alhamadani",
    "name": "ABDULLA SALEH ABDUL RAHMAN AL HAMDANI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/11/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Saleh Abdulrahman Alhamadani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_76b9f031-a7cd-40da-b720-b0b2ebddd9b9",
        "address": "الطابق الثامن ,بزنس افنيو ,فندق الخوري سكاي جاردن  ,126510 ,Dubai",
        "phone": "97142572778",
        "email": "zakia@houseofj.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "80c1d0d8-bc34-4358-b07f-35c5f9408311",
    "firmName": "KHALFAN ALKAABI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-731",
    "licenseIssueDate": "11/18/2024 00:00:00",
    "licenseExpiryDate": "11/17/2025 00:00:00"
  },
  {
    "id": "b61e9113-a879-477d-8453-63d80a4d5ae8",
    "slug": "abdulla-salem-ebrahim-alyaqoob-alzaabi",
    "name": "ABDULLA SALEM EBRAHIM ALYAQOOB ALZAABI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/03/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Salem Ebrahim Alyaqoob Alzaabi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b61e9113-a879-477d-8453-63d80a4d5ae8",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1515",
    "licenseIssueDate": "03/03/2021 00:00:00",
    "licenseExpiryDate": "03/02/2026 00:00:00"
  },
  {
    "id": "daf6dca0-20e9-4712-907a-88e655533705",
    "slug": "abdulla-sultan-ibrahim-nasser-alblooshi",
    "name": "ABDULLA SULTAN IBRAHIM NASSER MOHAMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/07/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ABDULLA SULTAN IBRAHIM NASSER ALBLOOSHI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_daf6dca0-20e9-4712-907a-88e655533705",
        "address": "",
        "phone": "97144230000 / 971552009022",
        "email": "UAE-CourtClerks@habibalmulla.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "3eba82bb-8ec4-4cbd-80d0-a793cb993fde",
    "firmName": "HABIB ALMULLA & PARTNERS",
    "registrationNumber": "L-1549",
    "licenseIssueDate": "07/26/2021 00:00:00",
    "licenseExpiryDate": "07/25/2026 00:00:00"
  },
  {
    "id": "5018a918-dc98-459f-98cd-5b2ea1584ff6",
    "slug": "abdulla-suwaiket-mohammad-alhajri",
    "name": "ABDULLA SUWAIKET MOHAMMAD ALHAJRI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/06/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Suwaiket Mohammad Alhajri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5018a918-dc98-459f-98cd-5b2ea1584ff6",
        "address": "engy nabeel ,609 ,Business Avenue Building ,خلف معرض نيسان للسيارات ,114332 ,Dubai",
        "phone": "97142666983 / 971505049385",
        "email": "mtgdubai@mtglegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "2c10c414-70fa-4a29-b8ce-a320239738ad",
    "firmName": "ENGY NABEEL ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-954",
    "licenseIssueDate": "06/09/2014 00:00:00",
    "licenseExpiryDate": "06/08/2026 00:00:00"
  },
  {
    "id": "5f1b45c7-91c6-497a-abbc-dd2fb78d9b10",
    "slug": "abdulla-taleb-mohammed-ahmad",
    "name": "ABDULLA TALIB MOHAMMAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 33,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/11/1991",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-11-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Taleb Mohammed Ahmad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5f1b45c7-91c6-497a-abbc-dd2fb78d9b10",
        "address": "2 ,B62 ,Clock Tower ,13903 ,Dubai",
        "phone": "97142288808",
        "email": "Lawfirm@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "2c26b6ea-311a-459a-aae1-8d9965fc9200",
    "firmName": "AL KHALEEJ ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-245",
    "licenseIssueDate": "11/26/1991 00:00:00",
    "licenseExpiryDate": "11/25/2025 00:00:00"
  },
  {
    "id": "d9352036-8071-440f-8149-cb5b43f9d8c3",
    "slug": "abdulla-yousof-ahmad-abdulqader-al-nasser",
    "name": "ABDULLA YOUSUF AHMAD ABDULQADIR AL NASSER",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Personal Status-Wills",
      "Personal Status-Custody & Alimony",
      "Commercial Transactions-Commercial Contracts",
      "Civil Transactions-Residential Real Estate",
      "Civil Transactions-Arbitration",
      "Civil Transactions-Tenancy",
      "Commercial Transactions-Unfair competition",
      "Personal Status-Legacies and Inheritance",
      "Commercial Transactions-Commercial Companies",
      "Personal Status-Legal Capacity & Guardianship",
      "Civil Transactions-Sale",
      "Commercial Transactions-Sea and air freight",
      "Personal Status-Marriage & Divorce",
      "Civil Transactions-Compensation",
      "Criminal Law-Crimes against properties",
      "Commercial Transactions-E-Commerce",
      "Criminal Law-Cybercrimes",
      "Commercial Transactions-Intellectual Property (includes trademarks",
      "copy rights",
      "patents)"
    ],
    "experience": 19,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/04/2006",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Yousof Ahmad Abdulqader Al Nasser",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d9352036-8071-440f-8149-cb5b43f9d8c3",
        "address": "Ali Saleh Atrooz  ,1103 ,EMPIRE HEIGHTS B ,دبي مول  ,18433 ,Dubai",
        "phone": "97142222511",
        "email": "info@araalaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "aab79fde-e700-45d7-904f-bde0a593a087",
    "firmName": "ARAA GROUP ADVOCATE & LEGAL CONSULTANCY",
    "registrationNumber": "L-558",
    "licenseIssueDate": "04/24/2006 00:00:00",
    "licenseExpiryDate": "04/23/2026 00:00:00"
  },
  {
    "id": "86696cf2-5be9-49c7-b5df-0f8a79e4fe73",
    "slug": "abdulla-yousuf-mirza-ali-hassan-alnajjar",
    "name": "Abdulla Yousuf Mirza Ali Hassan Alnajjar",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/30/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Yousuf Mirza Ali Hassan Alnajjar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_86696cf2-5be9-49c7-b5df-0f8a79e4fe73",
        "address": "31/3107 ,ابراج لطيفة ,بنك الكويت الوطني ,442 ,Dubai",
        "phone": "97197143706 / 971558775654",
        "email": "alnajjar_ab@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "d509f1aa-3c88-499b-8ad7-0ac050a88123",
    "firmName": "ABDULLA ALNAJJAR ADVOCATES & LEGAL CONSULTANT",
    "registrationNumber": "1039",
    "licenseIssueDate": "11/30/2015 00:00:00",
    "licenseExpiryDate": "11/29/2025 00:00:00"
  },
  {
    "id": "12e68df2-7d16-49c4-9f40-43a01c4945ba",
    "slug": "abdulla-yusuf-abdulla-bin-hareb-almehiri",
    "name": "ABDULLH YOUSUF ABDULLH BINHARIB ALMHEIRI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/07/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Yusuf Abdulla Bin Hareb Almehiri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_12e68df2-7d16-49c4-9f40-43a01c4945ba",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1099",
    "licenseIssueDate": "07/19/2016 00:00:00",
    "licenseExpiryDate": "07/18/2026 00:00:00"
  },
  {
    "id": "ee2c52df-78d6-42b1-a851-591cebf94ec2",
    "slug": "abdulla-zeyad-abdulla-ibrahim-galadari",
    "name": "ABDULLA ZEYAD ABDULLA IBRAHIM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBWgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-02-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulla Zeyad Abdulla Ibrahim Galadari",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ee2c52df-78d6-42b1-a851-591cebf94ec2",
        "address": "",
        "phone": "97143937700",
        "email": "info@galadarilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "d863b662-c864-4193-8b3a-ff6ee5fe6c64",
    "firmName": "GALADARI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-791",
    "licenseIssueDate": "02/19/2012 00:00:00",
    "licenseExpiryDate": "02/18/2026 00:00:00"
  },
  {
    "id": "1d727c29-0c13-4d01-8b75-d7c04ee1689d",
    "slug": "abdullah-abbas-yousuf-ahmed-albalushi",
    "name": "AYSHA SHAMES QEAIT YEAIL ALMENHALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/02/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdullah Abbas Yousuf Ahmed Albalushi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1d727c29-0c13-4d01-8b75-d7c04ee1689d",
        "address": "",
        "phone": "97143333245 / 97143333245",
        "email": "y.albulooshi@yhadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "5fd2b33a-4bae-47d7-86ce-bdbd42af4336",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1767",
    "licenseIssueDate": "02/23/2023 00:00:00",
    "licenseExpiryDate": "02/22/2026 00:00:00"
  },
  {
    "id": "148a38b5-c2c4-4e8b-88a4-5e21b42300de",
    "slug": "abdullah-ali-mohammed-al-shahi",
    "name": "Abdullah Ali Mohammed Al Shahi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/14/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-01-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdullah Ali Mohammed Al Shahi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_148a38b5-c2c4-4e8b-88a4-5e21b42300de",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "907",
    "licenseIssueDate": "01/14/2014 00:00:00",
    "licenseExpiryDate": "01/13/2026 00:00:00"
  },
  {
    "id": "7aea8164-3680-4939-9071-10d6e271b0c1",
    "slug": "abdullah-mohammad-tawfeeq-al-madani",
    "name": "ABDULLA MOHD TAWFIQ",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 25,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/05/2000",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdullah Mohammad Tawfeeq Al Madani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7aea8164-3680-4939-9071-10d6e271b0c1",
        "address": "abdulla almadani ,6th Floor, Office No. 604 ,Dubai National Insurance Company ,Deira City Center ,80305 ,Dubai",
        "phone": "97143978578",
        "email": "almadanilawfirm@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "77cfdeb0-2d07-462a-b700-a778b0ba393b",
    "firmName": "AL MADANI & ASSOCIATES ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-379",
    "licenseIssueDate": "05/14/2000 00:00:00",
    "licenseExpiryDate": "05/13/2026 00:00:00"
  },
  {
    "id": "0b1e0053-9963-4d77-95e7-3c5e7fab2f07",
    "slug": "abdullah-qahtan-abdullah-mohammed-alshehhi",
    "name": "ABDULLA QAHTAN ABDULLA M ALSHEHHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/03/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdullah Qahtan Abdullah Mohammed Alshehhi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0b1e0053-9963-4d77-95e7-3c5e7fab2f07",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1415",
    "licenseIssueDate": "03/04/2020 00:00:00",
    "licenseExpiryDate": "03/03/2026 00:00:00"
  },
  {
    "id": "64108fe7-9872-40fb-9f29-7b907cffd72a",
    "slug": "abdullatif-mohammed-abubaker-aalhammadi",
    "name": "ABDULLATIF MOHAMMED ABUBAKR A.ALHAMMADI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 17,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/08/2008",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdullatif Mohammed Abubaker A.Alhammadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_64108fe7-9872-40fb-9f29-7b907cffd72a",
        "address": "ABDULLATIF ALHAMMADI ,1 ,ABDULLA KAMBER BUSINESS CENTRE , ABU BAKER AL SIDDIQUE METRO STATION ,202142 ,Dubai",
        "phone": "97143212266",
        "email": "alhammadi@alhammadilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "85d9abe5-e426-495c-965e-7b1bbdb21e4c",
    "firmName": "ABDULLATIF AL HAMMADI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-639",
    "licenseIssueDate": "09/01/2008 00:00:00",
    "licenseExpiryDate": "08/31/2026 00:00:00"
  },
  {
    "id": "4321ec77-57e8-421e-81cc-2ac632303d33",
    "slug": "abdullatif-mohammed-saleh-abdulla-aljassmi",
    "name": "Abdullatif Mohammed Saleh Abdulla Aljassmi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/22/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdullatif Mohammed Saleh Abdulla Aljassmi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4321ec77-57e8-421e-81cc-2ac632303d33",
        "address": "Abdullatif Aljassmi ,Floor No.23- Office No. 2309 ,Burlington Tower ,The Oberoi Dubai ,0000 ,Dubai",
        "phone": "97147700321 / 971506441515",
        "email": "info@aaljassmiadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "06e43c95-38ec-43ea-aa9f-c2ca90c53cac",
    "firmName": "ABDULLATIF ALJASSMI ADVOCATES AND LEGAL CONSU",
    "registrationNumber": "960",
    "licenseIssueDate": "12/22/2020 00:00:00",
    "licenseExpiryDate": "12/21/2025 00:00:00"
  },
  {
    "id": "3f27ad84-d449-47ed-816a-139b4b817946",
    "slug": "abdullrahman-hussain-muhammed-hussain",
    "name": "ABDELRAHMAN HUSSAIN MOHAMED HUSSAIN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 20,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/04/2005",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: AbdullRahman Hussain Muhammed Hussain",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3f27ad84-d449-47ed-816a-139b4b817946",
        "address": "",
        "phone": "97142868681",
        "email": "hawailaw@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "3f1d962a-159f-4d0f-82d0-ebd94930d6ae",
    "firmName": "LAW OFFICE OF MAHMOUD AL HAWAI ATTORNEYS & CONSULTANTS AT LAW",
    "registrationNumber": "L-148",
    "licenseIssueDate": "04/13/2005 00:00:00",
    "licenseExpiryDate": "04/12/2026 00:00:00"
  },
  {
    "id": "aa8ab4c5-99b4-4831-8729-e5a742db944b",
    "slug": "abdulqader-ismail-mohammed-jarooh",
    "name": "ABDELQADIR ISMAIL MOHAMED JAROH",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 27,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/11/1997",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulqader Ismail Mohammed Jarooh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_aa8ab4c5-99b4-4831-8729-e5a742db944b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-316",
    "licenseIssueDate": "11/18/1997 00:00:00",
    "licenseExpiryDate": "11/17/2025 00:00:00"
  },
  {
    "id": "8cb15847-4850-4e2b-81b0-1a55bdb2cd39",
    "slug": "abdulrahman-abdulla-ahmed-mahmoud-almarzouqi",
    "name": "Abdulrahman Abdulla Ahmed Mahmoud Almarzouqi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/07/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulrahman Abdulla Ahmed Mahmoud Almarzouqi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8cb15847-4850-4e2b-81b0-1a55bdb2cd39",
        "address": "",
        "phone": "97143300009 / 971501215000",
        "email": "mohamed@maa.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "af85c161-b73d-46a2-9fd7-4d8604007473",
    "firmName": "ADVOCATES UNIT",
    "registrationNumber": "1984",
    "licenseIssueDate": "06/07/2024 00:00:00",
    "licenseExpiryDate": "06/06/2026 00:00:00"
  },
  {
    "id": "2ec85958-337e-482b-bcd4-bb089f27b7c0",
    "slug": "abdulrahman-abdulla-qassem-mohamed-alharbi",
    "name": "Abdulrahman Abdulla Qassem Mohamed Alharbi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/25/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulrahman Abdulla Qassem Mohamed Alharbi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2ec85958-337e-482b-bcd4-bb089f27b7c0",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "1835",
    "licenseIssueDate": "07/25/2023 00:00:00",
    "licenseExpiryDate": "07/24/2026 00:00:00"
  },
  {
    "id": "3172bb86-39d0-4d29-a76f-905af6aba77a",
    "slug": "abdulrahman-abdulrazzaq-mohamed-ahmad-alqassem",
    "name": "SALEM MUBARAK HAMAD ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/02/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulrahman Abdulrazzaq Mohamed Ahmad Alqassem",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3172bb86-39d0-4d29-a76f-905af6aba77a",
        "address": "",
        "phone": "97144230000 / 971552009022",
        "email": "UAE-CourtClerks@habibalmulla.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "3eba82bb-8ec4-4cbd-80d0-a793cb993fde",
    "firmName": "AMAL KHAMIS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1762",
    "licenseIssueDate": "02/22/2023 00:00:00",
    "licenseExpiryDate": "02/21/2026 00:00:00"
  },
  {
    "id": "75382f27-5fba-4beb-9e7f-66ae8dc52040",
    "slug": "abdulrahman-ali-abdulrahman-lootah",
    "name": "ABDULRAHMAN ALI ABDULRAHMAN LOOTAH",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 44,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/09/1981",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulrahman Ali Abdulrahman Lootah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_75382f27-5fba-4beb-9e7f-66ae8dc52040",
        "address": "",
        "phone": "97142944111",
        "email": "info@lootahlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "867bd7af-cc46-48b7-a06b-d9d319725a02",
    "firmName": "ABDULRAHMAN LOOTAH & ASSOCIATES ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-93",
    "licenseIssueDate": "09/20/1981 00:00:00",
    "licenseExpiryDate": "09/19/2026 00:00:00"
  },
  {
    "id": "450cbc45-0234-47aa-b9ba-d241599c8801",
    "slug": "abdulrahman-ali-hussain-mohammed-alshaali",
    "name": "ALI HUSSAIN MOHAMMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/07/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulrahman Ali Hussain Mohammed Alshaali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_450cbc45-0234-47aa-b9ba-d241599c8801",
        "address": "Abdulrahman Ali Alshaali  ,7 ,برج المسعود 2 ,معرض سيارات تويوتا - ديره ,00000 ,Dubai",
        "phone": "97143300780 / 971971454749",
        "email": "abdulrahman@alshaalilegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "8fc61dff-5618-4cd0-91c2-617c55c9acda",
    "firmName": "ABDULRHMAN ALSHAALI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1368",
    "licenseIssueDate": "07/07/2019 00:00:00",
    "licenseExpiryDate": "07/06/2026 00:00:00"
  },
  {
    "id": "7004d4b9-f2a2-41ef-b02e-dc337bf1c719",
    "slug": "abdulrahman-fahad-ibrahim-al-sabhan",
    "name": "ABDULRAHMAN FAHAD IBRAHIM ABDELRAHMAN MOHAMMAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/02/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulrahman Fahad Ibrahim Al Sabhan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7004d4b9-f2a2-41ef-b02e-dc337bf1c719",
        "address": "",
        "phone": "97143474007",
        "email": "info@alsabhanlegalgroup.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "c31ad0e5-b382-4c9a-9fab-8853b1330f6b",
    "firmName": "DR AL SABBHAN LEGAL GROUP&ASSOCLATES",
    "registrationNumber": "L-994",
    "licenseIssueDate": "02/26/2015 00:00:00",
    "licenseExpiryDate": "02/25/2026 00:00:00"
  },
  {
    "id": "0f74e7b8-1c73-424a-8bfc-0d03f7bbfd23",
    "slug": "abdulrahman-hassan-mohammad-al-mutawa",
    "name": "ABDULRAHMAN HASSAN MOHAMMAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 26,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/02/1999",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulrahman Hassan Mohammad Al Mutawa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0f74e7b8-1c73-424a-8bfc-0d03f7bbfd23",
        "address": "",
        "phone": "97142664424",
        "email": "nagm009@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "d9e56be7-6c69-408a-9a66-04ced959910a",
    "firmName": "ABDUL RAHMAN AL MUTAWA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-349",
    "licenseIssueDate": "02/20/1999 00:00:00",
    "licenseExpiryDate": "02/19/2026 00:00:00"
  },
  {
    "id": "ffa7704f-52ee-40d8-80ce-f4110c62a8fe",
    "slug": "abdulrahman-junaid-hassan-mohammad-essa",
    "name": "ABDULRAHMAN JUNAID HASSAN MOHAMMAD ESSA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/08/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulrahman junaid Hassan Mohammad Essa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ffa7704f-52ee-40d8-80ce-f4110c62a8fe",
        "address": "الطابق 14  ,برج 48 جيت  ,محطة مترو دبي  ,413633 ,Dubai",
        "phone": "97144412031",
        "email": "courts@adglegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "4287f048-dc0c-4d51-9e0c-0c23356040ee",
    "firmName": "MOHAMMED AL DAHBASHI ADVOCATES",
    "registrationNumber": "L-1218",
    "licenseIssueDate": "08/23/2017 00:00:00",
    "licenseExpiryDate": "08/22/2026 00:00:00"
  },
  {
    "id": "440ad29b-dabd-45b0-ab43-c102fad21285",
    "slug": "abdulrahman-mohamed-abdulla-alobeidli-alhammadi",
    "name": "KHALED AJAIL ALI ABDULLA ALJNEIBI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/03/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ABDULRAHMAN MOHAMED ABDULLA ALOBEIDLI ALHAMMADI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_440ad29b-dabd-45b0-ab43-c102fad21285",
        "address": "ادارة ا لمبنى  ,الريم ,الاتصالات  ,42423 ,Dubai",
        "phone": "97142222066",
        "email": "info@ozleco.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "7a155f4a-20ec-44ff-863f-4f9fb43d0af4",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1641",
    "licenseIssueDate": "04/04/2022 00:00:00",
    "licenseExpiryDate": "04/03/2026 00:00:00"
  },
  {
    "id": "7522475e-af4c-4ed8-873e-7e6e03c5f401",
    "slug": "abdulrahman-mohamed-eissa-al-naroi-alaamri",
    "name": "ABDULRAHMAN MOHAMMED EASA M.ALNAWRI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/11/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulrahman Mohamed Eissa Al Naroi Alaamri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7522475e-af4c-4ed8-873e-7e6e03c5f401",
        "address": "ABDULRAHMAN MOHAMED ALAAMRI ,306 ,ACICO BUISINESS PARK ,NISSAN SHOW ROOM ,33731 ,Dubai",
        "phone": "97148819818 / 971503933245",
        "email": "info@alaamri.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "bf13bfd5-9c31-447d-a1f6-1939ed8ab235",
    "firmName": "ABDULRAHMAN ALAAMRI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1130",
    "licenseIssueDate": "11/29/2016 00:00:00",
    "licenseExpiryDate": "11/28/2025 00:00:00"
  },
  {
    "id": "77e66eb4-5c4b-4796-b7cb-1ed667d62e8e",
    "slug": "abdulrahman-mohamed-sultan-alazem-al-ali",
    "name": "ABDULRAHMAN MOHAMED SULTAN ALAZEM AL ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/06/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulrahman Mohamed Sultan Alazem Al Ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_77e66eb4-5c4b-4796-b7cb-1ed667d62e8e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-956",
    "licenseIssueDate": "06/18/2014 00:00:00",
    "licenseExpiryDate": "06/17/2026 00:00:00"
  },
  {
    "id": "78b58181-ce6d-401a-b8d5-c2cb30408ed6",
    "slug": "abdulrahman-mohammed-essa-juma",
    "name": "ABDULRAHMAN MOHAMMAD ESSA MELIK",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 26,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/09/1999",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulrahman Mohammed Essa Juma",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_78b58181-ce6d-401a-b8d5-c2cb30408ed6",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-365",
    "licenseIssueDate": "09/07/1999 00:00:00",
    "licenseExpiryDate": "09/06/2026 00:00:00"
  },
  {
    "id": "6de01a56-4161-4745-a4ca-fe302b79474d",
    "slug": "abdulrahman-nasib-abdulrahman",
    "name": "ABDULRAHMAN NASIB ABDULRAHMAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/08/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulrahman Nasib Abdulrahman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6de01a56-4161-4745-a4ca-fe302b79474d",
        "address": "",
        "phone": "97144472020",
        "email": "info@arnadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "e6573267-5872-48d8-add1-06a3deccf9e4",
    "firmName": "MAI ALFALASI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1105",
    "licenseIssueDate": "06/11/2009 00:00:00",
    "licenseExpiryDate": "06/10/2026 00:00:00"
  },
  {
    "id": "a7d430a9-51cb-41a9-8527-85899ea2d82a",
    "slug": "abdulrahman-obaid-humaid-rashed-almusaibi",
    "name": "Abdulrahman Obaid Humaid Rashed Almusaibi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/06/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulrahman Obaid Humaid Rashed Almusaibi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a7d430a9-51cb-41a9-8527-85899ea2d82a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "1952",
    "licenseIssueDate": "05/06/2024 00:00:00",
    "licenseExpiryDate": "05/05/2026 00:00:00"
  },
  {
    "id": "075f0c49-7591-4687-812d-a800f203cd93",
    "slug": "abdulrahman-omar-abdulla-makhayar",
    "name": "ABDULRAHMAN OMAR ABDULLA MUKHAYER",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 24,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/02/2001",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulrahman Omar Abdulla Makhayar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_075f0c49-7591-4687-812d-a800f203cd93",
        "address": "ABDULRAHMAN OMAR  ABDULLA MUKHAYER  ,NBK BANK ,LATIFA TOWER  ,NEAR CROWN PLAZA  ,185616 ,Dubai",
        "phone": "97143296968",
        "email": "hlp@hlplawfirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "617b9580-cff5-4ffa-b2bc-8788300a3c6e",
    "firmName": "AL HUQOOQ FOR ADVOCACY AND LEGAL CONSULTANCY",
    "registrationNumber": "L-395",
    "licenseIssueDate": "02/27/2001 00:00:00",
    "licenseExpiryDate": "02/26/2026 00:00:00"
  },
  {
    "id": "6e706cf7-5676-4b00-a3b1-158d28f60720",
    "slug": "abdulrahman-omar-abdullatif-mohamed-alzarooni",
    "name": "HASINA RASHED HUMAID RASHED ALMEMARI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/05/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulrahman Omar Abdullatif Mohamed Alzarooni",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6e706cf7-5676-4b00-a3b1-158d28f60720",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "DR JAMAL ALNUAIMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1971",
    "licenseIssueDate": "05/30/2024 00:00:00",
    "licenseExpiryDate": "05/29/2026 00:00:00"
  },
  {
    "id": "1a7de412-f162-4bda-8e8e-152c8aa90c3e",
    "slug": "abdulrazaq-marjan-mabrook-bilal",
    "name": "ABDULRAZAQ MARJAN MABROOK",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/09/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulrazaq Marjan Mabrook Bilal",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1a7de412-f162-4bda-8e8e-152c8aa90c3e",
        "address": "",
        "phone": "97143218833 / 971506563555",
        "email": "abmarjanadv@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "9c0c6c1b-d946-4437-a37d-6b795f15818e",
    "firmName": "ABDULRAZAQ MARJAN ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-1383",
    "licenseIssueDate": "09/12/2019 00:00:00",
    "licenseExpiryDate": "09/11/2026 00:00:00"
  },
  {
    "id": "d9cf8095-fa8c-4dfb-b75c-d88119bb2047",
    "slug": "abdulrazaq-salih-sulaiman-mohammed",
    "name": "ABDELRAZAG SALIH SULIMAN MOHAMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 24,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/12/2000",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulrazaq Salih SUlaiman Mohammed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d9cf8095-fa8c-4dfb-b75c-d88119bb2047",
        "address": "",
        "phone": "97142830088 / 971505951775",
        "email": "dubai_lc@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "dd2f1b59-88fd-4ade-9d8f-139a4b75fef0",
    "firmName": "DUBAI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-391",
    "licenseIssueDate": "12/11/2000 00:00:00",
    "licenseExpiryDate": "12/10/2025 00:00:00"
  },
  {
    "id": "235fb574-f26a-47c4-9037-31dd52fb8265",
    "slug": "abdulrazzaq-mohamed-hamza-shah-alblooshi",
    "name": "EISA MOHAMMED FAQEIR MULA ZAHI ALBLOOSHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/10/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulrazzaq mohamed hamza shah alblooshi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_235fb574-f26a-47c4-9037-31dd52fb8265",
        "address": "Azza Ebrahim Hasan Almulla ,6(602-603) ,Al Shoalla Building (Al Naboodah) ,deira city center ,12871 ,Dubai",
        "phone": "97142950010",
        "email": "dubai-secretary@dralmulla.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "fbf6220f-2608-4caa-895e-d45ae8a259a2",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1721",
    "licenseIssueDate": "11/17/2022 00:00:00",
    "licenseExpiryDate": "11/16/2025 00:00:00"
  },
  {
    "id": "a4ac172b-cfd5-4fd8-b694-78927721623e",
    "slug": "abdulwahhab-meer-ahmed-abdool",
    "name": "ABDULWAHHAB MEER AHMED ABDOOL ALAWADHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/11/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abdulwahhab Meer Ahmed Abdool",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a4ac172b-cfd5-4fd8-b694-78927721623e",
        "address": "MOHAMMED NEKHAIRA ALDHAHERI ADVOCATES AND LEGAL CONSULTANT ,16 ,IRIS BAY ,ZOOM ,28177 ,Dubai",
        "phone": "97143323231 / 97143323231",
        "email": "Info@binnakhira.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "c9f7542e-9b4a-43f5-bfc5-ec984563c41c",
    "firmName": "MOHAMMED NEKHIRA ALDHAHERI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1391",
    "licenseIssueDate": "11/14/2019 00:00:00",
    "licenseExpiryDate": "11/16/2025 00:00:00"
  },
  {
    "id": "b84fc365-a8d6-424f-8d64-1016bd7ac420",
    "slug": "abeer-abdulrahim-mohammad-sharif-alali",
    "name": "ABEER ABDULRAHIM W O ALI I ALJARMAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/07/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abeer Abdulrahim Mohammad Sharif Alali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b84fc365-a8d6-424f-8d64-1016bd7ac420",
        "address": "Dr. Ali Ismail Aljarman ,Roof Floor - Offices R03 & R04 ,MSM 1 Building ,Al Saffa First ,62639 ,Dubai",
        "phone": "97144393733",
        "email": "info@prestigeadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "22043b7f-55d2-4eb4-a173-3077ba390351",
    "firmName": "PRESTIGE ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1297",
    "licenseIssueDate": "07/17/2018 00:00:00",
    "licenseExpiryDate": "07/16/2026 00:00:00"
  },
  {
    "id": "2f8e2623-8d92-4565-974a-417ff925b075",
    "slug": "abeer-musabbah-obaid-sulaiman-almeeshani",
    "name": "ABEER MUSABBAH OBAID SULAIMAN ALMEESHANI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/17/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ABEER MUSABBAH OBAID SULAIMAN ALMEESHANI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2f8e2623-8d92-4565-974a-417ff925b075",
        "address": "",
        "phone": "",
        "email": "info@abeeradvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "1bb062dc-0c34-48e7-ae21-6d47ad68302f",
    "firmName": "ABEER MUSABBAH OBAID ADVOCATES & LEGAL CONSUL",
    "registrationNumber": "1612",
    "licenseIssueDate": "01/17/2022 00:00:00",
    "licenseExpiryDate": "01/16/2026 00:00:00"
  },
  {
    "id": "5479777c-0ef1-471b-8271-d59622ae5b7d",
    "slug": "abeer-obaid-fares-ghafan-adahmani",
    "name": "ABEER OBAID FARES GHAFAN ALDAHMANI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/09/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abeer Obaid Fares Ghafan Adahmani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5479777c-0ef1-471b-8271-d59622ae5b7d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1028",
    "licenseIssueDate": "09/10/2015 00:00:00",
    "licenseExpiryDate": "09/09/2026 00:00:00"
  },
  {
    "id": "b6f57e51-b28b-4920-8b19-9d3341783041",
    "slug": "abu-baker-salem-awad-al-menhali",
    "name": "ABU BAKER SALEM AWADH ALMENHALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 21,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/05/2004",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abu Baker Salem Awad Al Menhali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b6f57e51-b28b-4920-8b19-9d3341783041",
        "address": "6F 603, 605, 7F 704 ,Crystal Tower ,Dubai Mall ,117538 ,Dubai",
        "phone": "97146098700",
        "email": "pro@miolawfirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "417f90a1-03be-4dab-8eea-1bba7e16f536",
    "firmName": "ABU BAKER SALEM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-488",
    "licenseIssueDate": "05/22/2004 00:00:00",
    "licenseExpiryDate": "05/21/2026 00:00:00"
  },
  {
    "id": "63f6168c-b92e-4644-b009-5c97d27b48a7",
    "slug": "abubakar-abdulqader-mohamed-y-karmustaji",
    "name": "ABUBAKAR ABDULQADER MOHAMED YOUSUF KARMUSTAJI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/05/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Abubakar Abdulqader Mohamed Y Karmustaji",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_63f6168c-b92e-4644-b009-5c97d27b48a7",
        "address": "الجناح الشمالي الطابق التاسع الوحدة 902 ,بنك المشرق جلوبال اتش كيه  ,برج خليفة  ,41422 ,Dubai",
        "phone": "97145514441",
        "email": "info@sat-law.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "d0e8d9f9-263d-4e8a-af05-984f0cc97149",
    "firmName": "SAT & CO ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-940",
    "licenseIssueDate": "05/04/2014 00:00:00",
    "licenseExpiryDate": "05/03/2026 00:00:00"
  },
  {
    "id": "1dd93149-8b5a-4392-a587-592715852057",
    "slug": "adel-abdulla-khamis-al-maameri",
    "name": "ADIL ABDALLA KHAMIS JUMA ALMEMARI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 19,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/02/2006",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Adel Abdulla Khamis Al-Maameri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1dd93149-8b5a-4392-a587-592715852057",
        "address": "",
        "phone": "97142438663",
        "email": "bosabbahmed@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "1d2a0393-9ac4-495c-aa17-4eedfdb418af",
    "firmName": "ALITEZAN ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-539",
    "licenseIssueDate": "02/07/2006 00:00:00",
    "licenseExpiryDate": "02/06/2026 00:00:00"
  },
  {
    "id": "4cd9384c-d1c5-413e-b4a5-6589169dcd9e",
    "slug": "adel-abdulla-khamis-musallem-aljuneibi",
    "name": "ADEL ABDULLA KHAMIS MUSALLEM ALJNEIBI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/06/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Adel Abdulla Khamis Musallem Aljuneibi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4cd9384c-d1c5-413e-b4a5-6589169dcd9e",
        "address": "Adel Abdulla Khamis Musallem Aljuneibi ,903 ,السركال 2 ,خلف البيت الاخضر بالقرب من معرض TOYOTA  الفطيم ,26620 ,Dubai",
        "phone": "97144523399 / 971504487844",
        "email": "aljneibimk@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "f570e356-e048-4da0-8823-0ef1ae1b6723",
    "firmName": "ADVOCATES UNIT",
    "registrationNumber": "L-879",
    "licenseIssueDate": "07/01/2013 00:00:00",
    "licenseExpiryDate": "06/30/2026 00:00:00"
  },
  {
    "id": "ef5108ca-4a49-48d1-a7b5-be2224d5c451",
    "slug": "adel-husain-falooh-badar-alraeea",
    "name": "ALWIYA SHAKER SAYED HUSSAIN S SHUBBER S ALAWI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/09/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ADEL HUSAIN FALOOH BADAR ALRAEEA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ef5108ca-4a49-48d1-a7b5-be2224d5c451",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1872",
    "licenseIssueDate": "10/11/2023 00:00:00",
    "licenseExpiryDate": "10/10/2026 00:00:00"
  },
  {
    "id": "8f4d9158-c547-4053-ad0b-5d3aa4663639",
    "slug": "adel-mohammed-abdulrahman-al-qasemi",
    "name": "ADEL MOHAMMAD ABDULRAHMAN AL QASEMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/04/2009",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Adel Mohammed Abdulrahman Al-Qasemi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8f4d9158-c547-4053-ad0b-5d3aa4663639",
        "address": "6 ,latifa tower ,near crown plaza hotel  ,102999 ,Dubai",
        "phone": "97143799979",
        "email": "lawkmq@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "b9d24779-27c2-4989-bf7f-4e73e5a670ff",
    "firmName": "KHALID BIN MOHAMMAD ALQASEMI ATTORNEY & LEGAL CONSULTANTS",
    "registrationNumber": "L-538",
    "licenseIssueDate": "04/16/2009 00:00:00",
    "licenseExpiryDate": "04/15/2026 00:00:00"
  },
  {
    "id": "7cf44716-0d25-41d9-97df-7bb828fca318",
    "slug": "adel-mohammed-taher-alblooshi",
    "name": "AHMED HADID THUWAINI WALEED ALJNEIBE",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/10/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Adel Mohammed Taher Alblooshi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7cf44716-0d25-41d9-97df-7bb828fca318",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1716",
    "licenseIssueDate": "11/09/2022 00:00:00",
    "licenseExpiryDate": "11/08/2025 00:00:00"
  },
  {
    "id": "77db1f54-8ede-4a99-b766-e3774b7f7736",
    "slug": "adel-salem-abdulla-salem-alghafri",
    "name": "ADEL SALEM ABDULLA SALEM ALGHAFRI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/02/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Adel Salem Abdulla Salem Alghafri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_77db1f54-8ede-4a99-b766-e3774b7f7736",
        "address": "Adel Salem Abdulla Salem Alghafri ,16th floor, Office: 1602 ,Aspect Tower ,Bay Avenue Mall ,444470 ,Dubai",
        "phone": "97142807052 / 971555666589",
        "email": "info@adelalghafri.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "d0789ea6-22d2-4893-aa99-e55ff1b4473a",
    "firmName": "ADEL ALGHAFRI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1144",
    "licenseIssueDate": "02/06/2017 00:00:00",
    "licenseExpiryDate": "02/05/2026 00:00:00"
  },
  {
    "id": "979797a9-c906-440c-b2e3-5aefeb78beb4",
    "slug": "adil-abdeqadir-humaid-fakhir",
    "name": "ADIL ABDELQADIR HUMAID FAKHIR",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/11/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-11-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Adil Abdeqadir Humaid Fakhir",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_979797a9-c906-440c-b2e3-5aefeb78beb4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1132",
    "licenseIssueDate": "11/29/2016 00:00:00",
    "licenseExpiryDate": "11/28/2025 00:00:00"
  },
  {
    "id": "5a79267f-3917-484b-ab1c-32a2733bb29b",
    "slug": "adil-humaid-rashid-bin-khalfoon-al-ali",
    "name": "ADIL HUMAID RASHID BIN KHALFOON AL-ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/08/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Adil Humaid Rashid Bin Khalfoon Al-Ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5a79267f-3917-484b-ab1c-32a2733bb29b",
        "address": "الرابع ,ذا اتريوم سنتر ,محطة مترو الفهيدي ,33773 ,Dubai",
        "phone": "97143795050",
        "email": "lawyerbk@eim.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "92b4dcc3-f700-41f5-a968-832fa8e3f315",
    "firmName": "BIN KHALFOON VOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-830",
    "licenseIssueDate": "08/02/2012 00:00:00",
    "licenseExpiryDate": "08/01/2026 00:00:00"
  },
  {
    "id": "0e2587f6-40d9-42bc-a5f6-3fcf238a6a30",
    "slug": "adnan-mohamed-yousuf-melaihan-alhammadi",
    "name": "ADNAN MOHAMED YOUSEF MALAHAYAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/04/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Adnan Mohamed Yousuf Melaihan Alhammadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0e2587f6-40d9-42bc-a5f6-3fcf238a6a30",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1182",
    "licenseIssueDate": "04/30/2017 00:00:00",
    "licenseExpiryDate": "04/29/2026 00:00:00"
  },
  {
    "id": "9d359ef1-ccf4-4719-bfc5-c0d783c00323",
    "slug": "adnan-obaid-mohammed-hussain-alshaali",
    "name": "ADNAN OBAID MOHD HUSSAIN ALSHAALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/07/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Adnan Obaid Mohammed Hussain Alshaali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9d359ef1-ccf4-4719-bfc5-c0d783c00323",
        "address": "ADNAN OBAID ALSHAALI , Second floor - FLAT 201A ,Al Khaimah Building ,Al Ittihad Road, Deira ,238837 ,Dubai",
        "phone": "97142392332 / 971505544558",
        "email": "adnan@alshaali-advocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "b49edb5e-abf1-49fe-8f56-ded39a7348cc",
    "firmName": "ADNAN OBAID ALSHAALI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-828",
    "licenseIssueDate": "07/24/2012 00:00:00",
    "licenseExpiryDate": "07/23/2026 00:00:00"
  },
  {
    "id": "721a6917-402e-4db4-be7b-770dfb00761d",
    "slug": "afaf-marjan-nasib-mubarak",
    "name": "AFAF MARJAN NASIB MUBARAK",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/11/2008",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Afaf Marjan Nasib Mubarak",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_721a6917-402e-4db4-be7b-770dfb00761d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-644",
    "licenseIssueDate": "11/17/2008 00:00:00",
    "licenseExpiryDate": "11/16/2025 00:00:00"
  },
  {
    "id": "cd25b449-cef9-41f7-800f-ec0b6146f503",
    "slug": "afra-abdulrahman-obaid-khalifa-ahli",
    "name": "AFRA ABDULRAHAN OBAID KHALIFA AHLI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/04/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Afra Abdulrahman Obaid Khalifa Ahli",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cd25b449-cef9-41f7-800f-ec0b6146f503",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1278",
    "licenseIssueDate": "05/01/2018 00:00:00",
    "licenseExpiryDate": "04/30/2026 00:00:00"
  },
  {
    "id": "e7e34536-e119-47f7-a1b5-0bab5dd7ba9b",
    "slug": "afra-ali-rashed-mohammed-alkuwaiti",
    "name": "SALMAN QAHTAN OBAID",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/04/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Afra Ali Rashed Mohammed Alkuwaiti",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e7e34536-e119-47f7-a1b5-0bab5dd7ba9b",
        "address": "1 ,Crystal Tower ,Business Bay ,1859 ,Dubai",
        "phone": "97142956661",
        "email": "info@amrplc.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "833edb7f-7a70-4ab6-9838-4782eb1b4f8a",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1802",
    "licenseIssueDate": "05/17/2023 00:00:00",
    "licenseExpiryDate": "05/16/2026 00:00:00"
  },
  {
    "id": "585fae46-1843-446e-9410-93ba73254744",
    "slug": "afra-mohammed-khamis-mughair-alkhaili",
    "name": "SHEIKH RASHID BIN NASSER BIN RASHID BIN HUMAID ALNOAIMII",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Civil Transactions-POA & Sponsorship",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Civil Transactions-Insurance",
      "Personal Status-Wills",
      "Civil Transactions-Construction and Contracts for Services",
      "Civil Transactions-Ownership & Title",
      "Civil Transactions-HR & Employee Affairs",
      "Criminal Law-Family Crimes",
      "Personal Status-Custody & Alimony",
      "Civil Transactions-Immigration and Residency",
      "Civil Transactions-Residential Real Estate",
      "Criminal Law-Hate crimes",
      "Civil Transactions-Tenancy",
      "Criminal Law-Crimes against persons",
      "Personal Status-Legacies and Inheritance",
      "Civil Transactions-Labor & Workers",
      "Personal Status-Legal Capacity & Guardianship",
      "Criminal Law-Drug Crimes",
      "Civil Transactions-Sale",
      "Personal Status-Marriage & Divorce",
      "Personal Status-Child Abuse & Abduction",
      "Civil Transactions-Compensation",
      "Criminal Law-Crimes against properties",
      "Criminal Law-Cybercrimes",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/04/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: afra mohammed khamis mughair alkhaili",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_585fae46-1843-446e-9410-93ba73254744",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1796",
    "licenseIssueDate": "05/02/2023 00:00:00",
    "licenseExpiryDate": "05/01/2026 00:00:00"
  },
  {
    "id": "d64e3e97-4f03-46a8-bb5c-79a6a3499bdc",
    "slug": "afra-mukhtar-mohame-ali-almarzooqi",
    "name": "EMAN AHMED ABDELRAHMAN ABDALLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/10/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Afra mukhtar mohame ali almarzooqi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d64e3e97-4f03-46a8-bb5c-79a6a3499bdc",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1879",
    "licenseIssueDate": "11/02/2023 00:00:00",
    "licenseExpiryDate": "11/01/2025 00:00:00"
  },
  {
    "id": "92dff4c9-c4b6-4092-b441-832af1d384e9",
    "slug": "afraa-aidrous-mohamed-alhashmi",
    "name": "AFRAA AIDROUS MOHAMED AL HASHMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/04/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Afraa Aidrous Mohamed Alhashmi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_92dff4c9-c4b6-4092-b441-832af1d384e9",
        "address": "Samia Luqman ,2nd floor ,Emarat Atrium Building ,across Holiday Inn Express Safa Park ,7273 ,Dubai",
        "phone": "97143211000",
        "email": "info@alsuwaidi.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "0e5c3637-bc12-475c-a6b5-2d9ae84f2b8e",
    "firmName": "ALSUWAIDI & COMPANY L.L.C",
    "registrationNumber": "L-1526",
    "licenseIssueDate": "04/21/2021 00:00:00",
    "licenseExpiryDate": "04/20/2026 00:00:00"
  },
  {
    "id": "e75d5641-97a2-459e-ae98-54242ca9bcbd",
    "slug": "ahad-saif-mohammed-alghais-alzaabi",
    "name": "MANSOOR JUMA MOHAMMED BUTAWEEL ALMATROOSHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/03/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: AHAD SAIF MOHAMMED ALGHAIS ALZAABI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e75d5641-97a2-459e-ae98-54242ca9bcbd",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1931",
    "licenseIssueDate": "03/25/2024 00:00:00",
    "licenseExpiryDate": "03/24/2026 00:00:00"
  },
  {
    "id": "efaba914-6a00-46c3-87c9-6636fc356868",
    "slug": "ahmad-abdulaziz-jasem-abdulla-kashwani",
    "name": "AHMED ABDELAZIZ JASIM ABDALLA ALKASHWANI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/10/2010",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmad Abdulaziz Jasem Abdulla Kashwani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_efaba914-6a00-46c3-87c9-6636fc356868",
        "address": "",
        "phone": "97143528887",
        "email": "info@kashwanilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "01ccf3a9-cfd3-4fb5-b5ac-a912503c2630",
    "firmName": "KASHWANI LAW FIRM",
    "registrationNumber": "L-150",
    "licenseIssueDate": "10/25/2010 00:00:00",
    "licenseExpiryDate": "10/24/2025 00:00:00"
  },
  {
    "id": "10978270-83e2-4e5a-b696-8ba8c8a9d7bc",
    "slug": "ahmad-abdulla-dhahi-abdulla-albuamaim",
    "name": "AHMAD ABDULLA DHAHI ABDULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 15,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/12/2009",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmad Abdulla Dhahi Abdulla Albuamaim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_10978270-83e2-4e5a-b696-8ba8c8a9d7bc",
        "address": "",
        "phone": "97143573330",
        "email": "admin@dhahiadvocate.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "5b668acf-1fdb-4057-81f9-05d9aeb7aca9",
    "firmName": "AHMAD BIN DHAHI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-688",
    "licenseIssueDate": "12/24/2009 00:00:00",
    "licenseExpiryDate": "12/23/2025 00:00:00"
  },
  {
    "id": "b8c93cbc-758e-49fa-bcd1-3ce89d310113",
    "slug": "ahmad-abdulla-hassan-aljaziri",
    "name": "AHMAD ABDULLA SALEH HASSAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/04/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmad Abdulla Hassan Aljaziri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b8c93cbc-758e-49fa-bcd1-3ce89d310113",
        "address": "ABDULLAH AMIN ALZAROONI ,209+210+611+211 ,بزنس افينيو ,خلف وكالة النيسان ,12781 ,Dubai",
        "phone": "97142954299",
        "email": "zaroonilawyers@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "da078082-58a6-4951-b43c-9a5a9bf24934",
    "firmName": "ABDULLA AL ZAROONI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1166",
    "licenseIssueDate": "04/06/2017 00:00:00",
    "licenseExpiryDate": "04/05/2026 00:00:00"
  },
  {
    "id": "4468e6e9-7231-4b59-b272-ba197363b2de",
    "slug": "ahmad-abdulla-ibrahim-galadari",
    "name": "AHMED ABDULLA IBRAHIM GALADARI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 34,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/11/1990",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmad Abdulla Ibrahim Galadari",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4468e6e9-7231-4b59-b272-ba197363b2de",
        "address": "",
        "phone": "97143937700",
        "email": "info@galadarilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "d863b662-c864-4193-8b3a-ff6ee5fe6c64",
    "firmName": "GALADARI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-213",
    "licenseIssueDate": "11/12/1990 00:00:00",
    "licenseExpiryDate": "11/11/2025 00:00:00"
  },
  {
    "id": "66f2650b-8407-466a-b92d-72527dfb1099",
    "slug": "ahmad-abdulla-mohammad-hussain-ahli",
    "name": "MOHAMED SAEED MOHAMED HILAL ALMHEIRI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/10/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmad abdulla mohammad hussain ahli",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_66f2650b-8407-466a-b92d-72527dfb1099",
        "address": "",
        "phone": "97142244442",
        "email": "info@ahli-law.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "56af6f31-f5cd-419b-a092-a41cfdd84e52",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1715",
    "licenseIssueDate": "11/09/2022 00:00:00",
    "licenseExpiryDate": "11/08/2025 00:00:00"
  },
  {
    "id": "81eac079-7999-4f5a-b59c-4abe81725e4b",
    "slug": "ahmad-abdulla-mohammad-malik-anwahi",
    "name": "Ahmad Abdulla Mohammad Malik Anwahi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/06/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmad Abdulla Mohammad Malik Anwahi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_81eac079-7999-4f5a-b59c-4abe81725e4b",
        "address": "الثانى ,امارة دبي - منطقه الوصل - مزايا سنتر - شارع الشيخ زايد - الطابق الثانى - مكتب 2005 و 2006 ,مزايا سنتر  ,68480 ,Dubai",
        "phone": "97145148870",
        "email": "info@anwahilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "8076512e-bc04-491e-b324-0d1cb2c52193",
    "firmName": "AHMAD ANWAHI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "1041",
    "licenseIssueDate": "01/06/2016 00:00:00",
    "licenseExpiryDate": "01/05/2026 00:00:00"
  },
  {
    "id": "ffeab203-3536-4a4b-b549-056e50f5a709",
    "slug": "ahmad-abdulla-mussa-murad",
    "name": "SHOAIB AZEIZ MOHAMED SHAREIF ALAWADHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/12/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: AHMAD ABDULLA MUSSA MURAD",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ffeab203-3536-4a4b-b549-056e50f5a709",
        "address": "الثالث  ,برج جيت  48  ,مخرج ميترو برج خليفه / دبي مول  ,181111 ,Dubai",
        "phone": "97145143423 / 971971451434",
        "email": "info.justice@fhsadvo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "690778ba-3332-4c06-b01f-ab5ec89ee304",
    "firmName": "MAJED BINWEQAISH & SHOAIB ALAWADHI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1737",
    "licenseIssueDate": "01/07/2023 00:00:00",
    "licenseExpiryDate": "01/06/2026 00:00:00"
  },
  {
    "id": "c416feef-5b8a-4a51-969d-921d58aae997",
    "slug": "ahmad-alhaj-khadim-buti-al-maidoor-al-muhairi",
    "name": "AHMAD ALHAJ KHADIM BUTI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 21,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/11/2003",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmad Alhaj Khadim Buti Al Maidoor Al Muhairi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c416feef-5b8a-4a51-969d-921d58aae997",
        "address": "",
        "phone": "97143348481",
        "email": "lawyers@maidor.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "a48d1666-6ca7-461a-8197-a892ef0f3545",
    "firmName": "ALMAIDOOR ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-460",
    "licenseIssueDate": "11/12/2003 00:00:00",
    "licenseExpiryDate": "11/11/2025 00:00:00"
  },
  {
    "id": "5bf3c1c0-b17c-4a57-9984-5143549efc6a",
    "slug": "ahmad-ali-ibraheim-alameeri",
    "name": "AHMED ALI EBRAHIM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 24,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/06/2001",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmad Ali Ibraheim Alameeri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5bf3c1c0-b17c-4a57-9984-5143549efc6a",
        "address": "العاشر ,المسعود ,بجوار معرض تويوتا ,20085 ,Dubai",
        "phone": "97142945554",
        "email": "ahmedalamiri_law@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "91d66bc6-9b89-4272-9d03-494aed8c3f9e",
    "firmName": "AHMED AL AMIRI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-405",
    "licenseIssueDate": "06/05/2001 00:00:00",
    "licenseExpiryDate": "06/04/2026 00:00:00"
  },
  {
    "id": "89cb1425-d341-4f98-bce7-d0ee3cde48c5",
    "slug": "ahmad-ali-redha-ebrahim-al-bannai",
    "name": "AHMAD ALI REDHA EBRAHIM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 18,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/05/2007",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmad Ali Redha Ebrahim Al Bannai",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_89cb1425-d341-4f98-bce7-d0ee3cde48c5",
        "address": "الطابق الخامس  ,القيادة ,مطار دبى رقم 2 ,13917 ,Dubai",
        "phone": "97142949003",
        "email": "info@brlegalese.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "cf14fc58-f25f-463d-b60f-bfe4a127da8b",
    "firmName": "AHMED ALBANNAI ADVOCATES LEGAL CONSULTANTS",
    "registrationNumber": "L-605",
    "licenseIssueDate": "05/02/2007 00:00:00",
    "licenseExpiryDate": "05/01/2026 00:00:00"
  },
  {
    "id": "c75ab9a4-cf50-4869-b99a-8ef59053afbc",
    "slug": "ahmad-hassan-ahmad-hassan-germen",
    "name": "AHMAD HASSAN AHMAD HASSAN GERMAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/11/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: AHMAD HASSAN AHMAD HASSAN GERMEN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c75ab9a4-cf50-4869-b99a-8ef59053afbc",
        "address": "MOHAMMED MURTADA ALHASHMI ,3 ,LATIFA TOWER  ,CROWN PLAZA ,231400 ,Dubai",
        "phone": "97143521131",
        "email": "info@mhadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "a5a2640f-b1b8-4512-b9ee-a8802d0c30fc",
    "firmName": "AHMED GERMAN ADVOCATES &LEGAL CONSULTANTS",
    "registrationNumber": "L-1321",
    "licenseIssueDate": "11/07/2018 00:00:00",
    "licenseExpiryDate": "11/06/2025 00:00:00"
  },
  {
    "id": "c044bd3f-4571-4d81-8150-7bf44f499bc1",
    "slug": "ahmad-hassan-ali-hashem",
    "name": "AHMED HASSAN ALI HASHIM ALHAMMADI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 32,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/02/1993",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmad Hassan Ali Hashem",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c044bd3f-4571-4d81-8150-7bf44f499bc1",
        "address": "",
        "phone": "97143555600",
        "email": "hashimgroup786@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "9925de3a-6943-440f-95fb-60499c669e9a",
    "firmName": "HASHIM GROUP ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-251",
    "licenseIssueDate": "02/10/1993 00:00:00",
    "licenseExpiryDate": "02/09/2026 00:00:00"
  },
  {
    "id": "2cb51501-ce60-4308-8160-7793af4f043e",
    "slug": "ahmad-hassan-mohammed-abdulla-almaazmi",
    "name": "AHMED HASSAN MOHAMED ABDALLA ALMAAZMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 25,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/03/2000",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmad Hassan Mohammed Abdulla Almaazmi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2cb51501-ce60-4308-8160-7793af4f043e",
        "address": "",
        "phone": "97142594601",
        "email": "info@almazmilawfirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "6d921a3f-66d8-409c-82d0-47ea77e53617",
    "firmName": "AHMED HASSAN ALMAAZMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-376",
    "licenseIssueDate": "03/11/2000 00:00:00",
    "licenseExpiryDate": "03/10/2026 00:00:00"
  },
  {
    "id": "b105f9b3-5aa9-4cc0-804c-e59f40f58b79",
    "slug": "ahmad-hussain-ali-abdulrahman-lootah",
    "name": "AHMAD HUSSAIN ALI ABDULRAHMAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/04/2009",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmad Hussain Ali Abdulrahman Lootah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b105f9b3-5aa9-4cc0-804c-e59f40f58b79",
        "address": "الطابق الثامن  ,برج الجرج 1 ,دائرة الاراضي و الاملاك  ,9117 ,Dubai",
        "phone": "97143320004",
        "email": "info@hlootahlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "4ad67cb4-18b4-4417-9b6a-d23a9fb368fb",
    "firmName": "HUSSAIN LOOTAH & PARTNERS - ATTORNEYS & COUNSELLORS AT LAW",
    "registrationNumber": "L-664",
    "licenseIssueDate": "04/21/2009 00:00:00",
    "licenseExpiryDate": "04/20/2026 00:00:00"
  },
  {
    "id": "d1a59319-7db9-4c44-b096-551bc8b48f55",
    "slug": "ahmad-hussein-ali-nazari-almarzooqi",
    "name": "SALEH RAMADHAN ABDULLA MOHAMMED ALQEBLAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/08/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmad Hussein Ali Nazari Almarzooqi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d1a59319-7db9-4c44-b096-551bc8b48f55",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-2020",
    "licenseIssueDate": "09/05/2024 00:00:00",
    "licenseExpiryDate": "09/04/2026 00:00:00"
  },
  {
    "id": "dfe0b357-b263-4b2f-a74c-d84fc05e2712",
    "slug": "ahmad-mehair-khamis-obaid-bin-meshar",
    "name": "AHMAD MEHAIR KHAMIS OBAID BIN MESHAR",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/06/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmad Mehair Khamis Obaid Bin Meshar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dfe0b357-b263-4b2f-a74c-d84fc05e2712",
        "address": "4th Floor – offices 408 - 411 - 412 ,Business Village Building  - Block B ,Near Clock Tower ,49425 ,Dubai",
        "phone": "97143869999 / 971506446650",
        "email": "advocates@binmeshar.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "d4ea63a4-952e-4374-a9df-97a521bb4cd5",
    "firmName": "BIN MESHAR & CO ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-762",
    "licenseIssueDate": "06/12/2011 00:00:00",
    "licenseExpiryDate": "06/11/2026 00:00:00"
  },
  {
    "id": "3b2d3024-eb29-4236-9730-c30ab00adc7d",
    "slug": "ahmad-mir-mutalleb-mir-murtadha-amiri",
    "name": "AHMAD MIR MUTALLEB MIR MURTADHA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Civil Transactions-POA & Sponsorship",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Civil Transactions-Insurance",
      "Civil Transactions-Construction and Contracts for Services",
      "Civil Transactions-Ownership & Title",
      "Civil Transactions-HR & Employee Affairs",
      "Criminal Law-Family Crimes",
      "Personal Status-Custody & Alimony",
      "Commercial Transactions-Commercial Contracts",
      "Civil Transactions-Immigration and Residency",
      "Commercial Transactions-Commercial Real Estate",
      "Civil Transactions-Residential Real Estate",
      "Criminal Law-Hate crimes",
      "Civil Transactions-Tenancy",
      "Commercial Transactions-Unfair competition",
      "Criminal Law-Crimes against persons",
      "Personal Status-Legacies and Inheritance",
      "Commercial Transactions-Commercial Companies",
      "Commercial Transactions-Banking Operations",
      "Civil Transactions-Labor & Workers",
      "Criminal Law-Drug Crimes",
      "Civil Transactions-Sale",
      "Commercial Transactions-Consumer protection",
      "Personal Status-Marriage & Divorce",
      "Criminal Law-Crimes against properties",
      "Criminal Law-Cybercrimes",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/12/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmad Mir Mutalleb Mir Murtadha Amiri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3b2d3024-eb29-4236-9730-c30ab00adc7d",
        "address": "",
        "phone": "97142999926",
        "email": "amiriadvocates@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "0bd0eefd-956b-4c8b-ab5d-ebbcae894927",
    "firmName": "AMIRI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-843",
    "licenseIssueDate": "12/18/2012 00:00:00",
    "licenseExpiryDate": "12/17/2025 00:00:00"
  },
  {
    "id": "4267bbda-464e-4a0a-a2de-a397ae5abfb8",
    "slug": "ahmad-mohamed-abdulhassan-alluz",
    "name": "AHMAD MOHAMED ABDULHASSAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 24,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/02/2001",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmad Mohamed Abdulhassan Alluz",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4267bbda-464e-4a0a-a2de-a397ae5abfb8",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-398",
    "licenseIssueDate": "02/27/2001 00:00:00",
    "licenseExpiryDate": "02/26/2026 00:00:00"
  },
  {
    "id": "808ea7ba-63c2-444b-9b38-949c3b676e73",
    "slug": "ahmad-mohammed-ali-kamali",
    "name": "AHMED MOHD ALI MOHD ALKAMALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 28,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/10/1997",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmad Mohammed Ali Kamali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_808ea7ba-63c2-444b-9b38-949c3b676e73",
        "address": "3-505 ,AL KHABEESI BLDG ,AL KABEESI ,4948 ,Dubai",
        "phone": "97142222228",
        "email": "info@alkamali.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "054f38f4-9e51-4623-ad36-7941043a051c",
    "firmName": "ALKAMALI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-301",
    "licenseIssueDate": "10/04/1997 00:00:00",
    "licenseExpiryDate": "10/03/2026 00:00:00"
  },
  {
    "id": "d2ff7a8f-9a13-4251-bb98-9441a7aa426d",
    "slug": "ahmad-mohammed-ali-mohammed-al-rasheed",
    "name": "AHMED MOHAMED ALI MOHAMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 42,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/11/1982",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmad Mohammed Ali Mohammed Al-Rasheed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d2ff7a8f-9a13-4251-bb98-9441a7aa426d",
        "address": "6 ,Business Point ,Nissan Showroom  ,443 ,Dubai",
        "phone": "97142999991",
        "email": "dubai@alrasheed.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "a4fce061-88d2-4308-9c3a-dbb02f5cbe82",
    "firmName": "AL RASHEED & PARTNERS",
    "registrationNumber": "L-117",
    "licenseIssueDate": "12/01/1982 00:00:00",
    "licenseExpiryDate": "11/30/2025 00:00:00"
  },
  {
    "id": "0b59b27d-aaae-4174-ad69-4ea519149487",
    "slug": "ahmad-zeyad-abdulla-ibrahim-galadari",
    "name": "AHMAD ZEYAD ABDULLA IBRAHIM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBWgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/03/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmad Zeyad Abdulla Ibrahim Galadari",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0b59b27d-aaae-4174-ad69-4ea519149487",
        "address": "",
        "phone": "97143937700",
        "email": "info@galadarilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "d863b662-c864-4193-8b3a-ff6ee5fe6c64",
    "firmName": "GALADARI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1513",
    "licenseIssueDate": "03/02/2021 00:00:00",
    "licenseExpiryDate": "03/01/2026 00:00:00"
  },
  {
    "id": "2f63db0b-2559-4bd6-adef-f447439b1ef3",
    "slug": "ahmed-abdalla-mohmmed-binaskar-alnaqbi",
    "name": "AHMED ABDALLA MOHAMMED BINASKAR",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/05/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: AHMED ABDALLA MOHMMED BINASKAR ALNAQBI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2f63db0b-2559-4bd6-adef-f447439b1ef3",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1530",
    "licenseIssueDate": "05/06/2021 00:00:00",
    "licenseExpiryDate": "05/05/2026 00:00:00"
  },
  {
    "id": "d2b05e2c-c89b-43c9-a671-a678d49ac06e",
    "slug": "ahmed-abdulkarim-ahmed-abdalla-eid",
    "name": "ABDULKARIM AHMED ABDALLA EID",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/03/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmed Abdulkarim Ahmed Abdalla Eid",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d2b05e2c-c89b-43c9-a671-a678d49ac06e",
        "address": "ABDULLKAREIM AHMED ABDULLA EID ,الطابق الثانى - مكتب رقم 014 ,مركز الممزر  ,مقابل القياده العامه لشرطة دبي - بجوار مكتب وزارة العمل والعمال القديم  ,89505 ,Dubai",
        "phone": "97142388850",
        "email": "bineidadvocates@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "ea633c29-6b4a-48a8-aaec-c801ece50744",
    "firmName": "BIN EID ADVOCATES & LEGEL CONSULTANTS",
    "registrationNumber": "L-999",
    "licenseIssueDate": "03/23/2015 00:00:00",
    "licenseExpiryDate": "03/22/2026 00:00:00"
  },
  {
    "id": "722a978f-35a1-4928-a134-93d0ff6bf12e",
    "slug": "ahmed-abdulla-mohammed-alattar-al-ali",
    "name": "AHMED ABDULLA MOHAMMED AL ATTAR",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/05/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmed Abdulla Mohammed Alattar al-ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_722a978f-35a1-4928-a134-93d0ff6bf12e",
        "address": "",
        "phone": "/ 971000000000",
        "email": "ahmed.advo@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "982063ca-143c-4793-84a0-193c57c43740",
    "firmName": "AHMED AL ALI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-755",
    "licenseIssueDate": "05/10/2011 00:00:00",
    "licenseExpiryDate": "05/09/2026 00:00:00"
  },
  {
    "id": "400d8afd-b2f5-45d3-bf23-ee729c243c92",
    "slug": "ahmed-abdulla-mohammed-al-kendri",
    "name": "AHMED ABDULLA MOHAMED ALKANDRI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Bankruptcy",
      "Personal Status-Marriage & Divorce",
      "Criminal Law-Crimes against properties",
      "Criminal Law-Crimes against persons",
      "Criminal Law-Drug Crimes",
      "Civil Transactions-Labor & Workers",
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Personal Status-Legacies and Inheritance",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Personal Status-Custody & Alimony",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 23,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/04/2002",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmed Abdulla Mohammed Al-Kendri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_400d8afd-b2f5-45d3-bf23-ee729c243c92",
        "address": "",
        "phone": "97142830009",
        "email": "abakgulfconsultant@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "4ca62fa9-28fb-4024-84aa-9b82cccde1b5",
    "firmName": "GULF CONSULTANT ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-335",
    "licenseIssueDate": "04/02/2002 00:00:00",
    "licenseExpiryDate": "04/01/2026 00:00:00"
  },
  {
    "id": "a72d3434-83dc-4c0e-b415-3349760ef729",
    "slug": "ahmed-abdulla-rashed-saeed-aldhaheri",
    "name": "AHMED ABDULLA RASHED SAEED ALDHAHERI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/07/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmed Abdulla Rashed saeed Aldhaheri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a72d3434-83dc-4c0e-b415-3349760ef729",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1376",
    "licenseIssueDate": "07/29/2019 00:00:00",
    "licenseExpiryDate": "07/28/2026 00:00:00"
  },
  {
    "id": "0383f2c6-f494-44d1-a3d3-6192d4f56ba2",
    "slug": "ahmed-abdullah-mohd-saeed-al-suwaidi",
    "name": "AHMED ABDALLA MOHAMED SAEED ALSUWAIDI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 24,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/02/2001",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmed Abdullah Mohd Saeed Al Suwaidi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0383f2c6-f494-44d1-a3d3-6192d4f56ba2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-394",
    "licenseIssueDate": "02/26/2001 00:00:00",
    "licenseExpiryDate": "02/25/2026 00:00:00"
  },
  {
    "id": "384c5618-31a4-423a-84e6-39e94d1e7a7e",
    "slug": "ahmed-abdullatif-dhaen-abdulla-aldhaen",
    "name": "AHMED ABDULLATIF DHAEN ABDULLA ALDHAEN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/26/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: AHMED ABDULLATIF DHAEN ABDULLA ALDHAEN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_384c5618-31a4-423a-84e6-39e94d1e7a7e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "16071",
    "licenseIssueDate": "12/26/2021 00:00:00",
    "licenseExpiryDate": "12/25/2025 00:00:00"
  },
  {
    "id": "96f5e008-5d84-4444-aa04-331b91e1e4f7",
    "slug": "ahmed-abdulrahman-abdulla-ali-alhammadi",
    "name": "MARYAM ISMAEIL MOHAMMED ALHOSANI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/03/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: AHMED ABDULRAHMAN ABDULLA ALI ALHAMMADI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_96f5e008-5d84-4444-aa04-331b91e1e4f7",
        "address": "ادارة ا لمبنى  ,الريم ,الاتصالات  ,42423 ,Dubai",
        "phone": "97142222066",
        "email": "info@ozleco.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "7a155f4a-20ec-44ff-863f-4f9fb43d0af4",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1642",
    "licenseIssueDate": "04/04/2022 00:00:00",
    "licenseExpiryDate": "04/03/2026 00:00:00"
  },
  {
    "id": "f493bc8c-8c3e-4a17-950f-0785e646a261",
    "slug": "ahmed-abdulrahman-mohamed-alzarooni",
    "name": "AHMED ABDULRAHMAN MOHAMED ALZAROONI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/06/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmed Abdulrahman Mohamed Alzarooni",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f493bc8c-8c3e-4a17-950f-0785e646a261",
        "address": "Office No. 116 ,Makeen Building ,Makani No: 3312794001 ,000 ,Dubai",
        "phone": "97142558462 / 971506358668",
        "email": "ahmed_alzarooni@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "5d109744-ba6c-40c9-8bf5-8f23cc33dc17",
    "firmName": "AHMED ABDULRAHMAN ALZAROONI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1981",
    "licenseIssueDate": "05/31/2024 00:00:00",
    "licenseExpiryDate": "05/30/2026 00:00:00"
  },
  {
    "id": "144bc543-a088-4f3e-a523-77266c3062fd",
    "slug": "ahmed-ali-hussain-mohammed-al-shaali",
    "name": "AHMED ALIHUSSAIN MOHAMMED ALSHAALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/12/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmed Ali Hussain Mohammed Al Shaali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_144bc543-a088-4f3e-a523-77266c3062fd",
        "address": "Office M21 ,Garhoud Business Center ,Near GG Ko Metro Station Makani No: 4002124052 ,000 ,Dubai",
        "phone": "97142527751 / 971567778217",
        "email": "alshaaliattorneys25@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "47a484be-41d3-4e29-a5c3-ac1971bb44b0",
    "firmName": "AHMED ALSHAALI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-1488",
    "licenseIssueDate": "12/21/2020 00:00:00",
    "licenseExpiryDate": "12/20/2025 00:00:00"
  },
  {
    "id": "6bdf5ec9-93e1-4e86-b5c9-cb418cee5e37",
    "slug": "ahmed-ali-mohamed-mansour-zeyoudi",
    "name": "AHMED ALI MOHAMED MANSOUR",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 19,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/04/2006",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: AHMED ALI MOHAMED MANSOUR ZEYOUDI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6bdf5ec9-93e1-4e86-b5c9-cb418cee5e37",
        "address": "مركز وافي للتسوق  ,بلوك ايه ,خلف فندق موفنبيك ,11672 ,Dubai",
        "phone": "97143796990",
        "email": "alzeyoudi@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "e5af688d-2190-4a5e-bb51-52b925fc1fb7",
    "firmName": "AL ZEYOUDI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-556",
    "licenseIssueDate": "04/24/2006 00:00:00",
    "licenseExpiryDate": "04/23/2026 00:00:00"
  },
  {
    "id": "6277a48f-40cc-480f-b603-8759f7a643f3",
    "slug": "ahmed-ali-saeed-al-hussaini",
    "name": "AHEMD ALI SAEED ALHUSAINI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/04/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmed Ali Saeed Al Hussaini",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6277a48f-40cc-480f-b603-8759f7a643f3",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1011",
    "licenseIssueDate": "04/27/2015 00:00:00",
    "licenseExpiryDate": "04/26/2026 00:00:00"
  },
  {
    "id": "9cc17b0a-dd63-4313-98c3-039d5fe29942",
    "slug": "ahmed-ali-saleh-nasir-almaazmi",
    "name": "AHMED ALI SALEH NASIR ALMAAZMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/04/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmed Ali Saleh Nasir AlMaazmi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9cc17b0a-dd63-4313-98c3-039d5fe29942",
        "address": "الاول 107 ,مجمع المحكمة العليا بدبي  ,محاكم دبي  ,56637 ,Dubai",
        "phone": "97142568008",
        "email": "info@almaazmi-law.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "3083f53b-2676-4d9b-81b3-86ac3e91fc28",
    "firmName": "AHMED AL MAZMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-799",
    "licenseIssueDate": "04/18/2012 00:00:00",
    "licenseExpiryDate": "04/17/2026 00:00:00"
  },
  {
    "id": "032a51b2-49de-4904-8e0a-76741c4a9712",
    "slug": "ahmed-ebrahim-ahmed-mohammed",
    "name": "AHMED IBRAHIM AHMED MOHAMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 28,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/10/1997",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmed Ebrahim Ahmed Mohammed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_032a51b2-49de-4904-8e0a-76741c4a9712",
        "address": "4/406 ,Acico Business Park  ,Behind Nissan Showroom ,186344 ,Dubai",
        "phone": "97142989888 / 971505948989",
        "email": "AHMEDIBRAHIMLAW@GMAIL.COM",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "dbb4bc27-1ace-4e78-8ee2-db7bfd85e001",
    "firmName": "AHMED IBRAHIM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-311",
    "licenseIssueDate": "10/12/1997 00:00:00",
    "licenseExpiryDate": "10/11/2026 00:00:00"
  },
  {
    "id": "348edca9-3255-4f72-a6ec-055e16f61984",
    "slug": "ahmed-eisa-mohamed-eisa",
    "name": "AHMED EISA MOHAMED EISA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Civil Transactions-Ownership & Title",
      "Criminal Law-Family Crimes",
      "Personal Status-Custody & Alimony",
      "Commercial Transactions-Bankruptcy",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Criminal Law-Crimes against persons",
      "Commercial Transactions-Banking Operations",
      "Criminal Law-Drug Crimes",
      "Personal Status-Marriage & Divorce",
      "Civil Transactions-Compensation",
      "Criminal Law-Crimes against properties",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/01/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmed Eisa Mohamed Eisa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_348edca9-3255-4f72-a6ec-055e16f61984",
        "address": "Ahmed Eisa Mohammed Eisa  ,2nd floor- office 210  ,Al Khaima  ,Al Khabaisi Park ,14748 ,Dubai",
        "phone": "97197150649 / 971506496333",
        "email": "ahmedissaadvocates@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "842516a6-1ad5-4983-a200-988a79ca1193",
    "firmName": "AHMED EISA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-292",
    "licenseIssueDate": "01/12/2022 00:00:00",
    "licenseExpiryDate": "01/11/2026 00:00:00"
  },
  {
    "id": "76cd14bf-bb62-4089-a5d2-bc4a6bd93879",
    "slug": "ahmed-hadid-thuwaini-waleed-aljneibi",
    "name": "SARA MOHAMED SALEH SALEM ALHAMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/09/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmed Hadid Thuwaini Waleed Aljneibi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_76cd14bf-bb62-4089-a5d2-bc4a6bd93879",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1708",
    "licenseIssueDate": "10/25/2022 00:00:00",
    "licenseExpiryDate": "10/24/2025 00:00:00"
  },
  {
    "id": "f4b74504-972e-4af5-9118-bcc2746d27ea",
    "slug": "ahmed-hasan-ahmed-hasan-alzaabi",
    "name": "HASAN AHMED HASAN NASER",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/07/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmed Hasan Ahmed Hasan Alzaabi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f4b74504-972e-4af5-9118-bcc2746d27ea",
        "address": "",
        "phone": "97144230000 / 971552009022",
        "email": "UAE-CourtClerks@habibalmulla.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "3eba82bb-8ec4-4cbd-80d0-a793cb993fde",
    "firmName": "HABIB ALMULLA & PARTNERS",
    "registrationNumber": "L-1298",
    "licenseIssueDate": "07/23/2018 00:00:00",
    "licenseExpiryDate": "07/22/2026 00:00:00"
  },
  {
    "id": "82e19796-c17a-4208-916f-da5b01d4e2b2",
    "slug": "ahmed-hasan-saeed-omar-alzubaidi",
    "name": "AHMED HASAN SAEED OMAR",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/09/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmed Hasan Saeed Omar Alzubaidi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_82e19796-c17a-4208-916f-da5b01d4e2b2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1226",
    "licenseIssueDate": "09/28/2017 00:00:00",
    "licenseExpiryDate": "09/27/2026 00:00:00"
  },
  {
    "id": "dd44f5c6-b2ca-435d-9db9-f80402f73eda",
    "slug": "ahmed-hassan-ramadan-al-ali",
    "name": "AHMED HASSAN RAMADAN AL ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Civil Transactions-POA & Sponsorship",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Civil Transactions-Insurance",
      "Personal Status-Wills",
      "Civil Transactions-Construction and Contracts for Services",
      "Civil Transactions-Ownership & Title",
      "Civil Transactions-HR & Employee Affairs",
      "Commercial Transactions-Commercial Mortgage",
      "Criminal Law-Family Crimes",
      "Commercial Transactions-Commercial Contracts",
      "Civil Transactions-Immigration and Residency",
      "Commercial Transactions-Bankruptcy",
      "Commercial Transactions-Commercial Real Estate",
      "Civil Transactions-Residential Real Estate",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Civil Transactions-Arbitration",
      "Criminal Law-Hate crimes",
      "Civil Transactions-Tenancy",
      "Commercial Transactions-Unfair competition",
      "Criminal Law-Crimes against persons",
      "Personal Status-Legacies and Inheritance",
      "Commercial Transactions-Commercial Companies",
      "Commercial Transactions-Banking Operations",
      "Civil Transactions-Labor & Workers",
      "Personal Status-Legal Capacity & Guardianship",
      "Criminal Law-Drug Crimes",
      "Civil Transactions-Sale",
      "Commercial Transactions-Sea and air freight",
      "Personal Status-Marriage & Divorce",
      "Personal Status-Child Abuse & Abduction",
      "Civil Transactions-Compensation",
      "Criminal Law-Crimes against properties",
      "Commercial Transactions-E-Commerce",
      "Criminal Law-Cybercrimes",
      "Commercial Transactions-Intellectual Property (includes trademarks",
      "copy rights",
      "patents)",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 15,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/10/2010",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmed Hassan Ramadan Al Ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dd44f5c6-b2ca-435d-9db9-f80402f73eda",
        "address": "18 ,برج السلام ,سما تاور ,68068 ,Dubai",
        "phone": "97143519700 / 971507973939",
        "email": "info@ramadanlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "08cb3f04-3a05-4815-9f28-6aa33c4b63dd",
    "firmName": "AHMED RAMADAN ADVOCATES &LEGAL CONSULTANTS",
    "registrationNumber": "L-727",
    "licenseIssueDate": "10/05/2010 00:00:00",
    "licenseExpiryDate": "10/04/2026 00:00:00"
  },
  {
    "id": "d52913f1-3286-4eb8-ac1d-b28fc9e72f55",
    "slug": "ahmed-helal-ebrahiem-aldhanhani",
    "name": "FATIMA MOHAMED YOUSIF AHMED ABDALLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/06/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ahmed helal ebrahiem aldhanhani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d52913f1-3286-4eb8-ac1d-b28fc9e72f55",
        "address": "",
        "phone": "",
        "email": "info@khalifaadv.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "97d00ba6-5323-4b87-8fdb-6382334c3d16",
    "firmName": "WALEED ALMARZOOQI AND KHALID MOHAMED ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-1986",
    "licenseIssueDate": "06/13/2024 00:00:00",
    "licenseExpiryDate": "06/12/2026 00:00:00"
  },
  {
    "id": "b2bb1220-eac0-479e-9581-3a216f0cddaa",
    "slug": "ahmed-humaid-abbas-karmak-alblooshi",
    "name": "MOUZA MOHAMMED SAEED A KHAMMAS",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/04/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmed Humaid Abbas Karmak Alblooshi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b2bb1220-eac0-479e-9581-3a216f0cddaa",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1797",
    "licenseIssueDate": "05/08/2023 00:00:00",
    "licenseExpiryDate": "05/07/2026 00:00:00"
  },
  {
    "id": "8261f764-295e-4aea-97f9-0daa5acc0dca",
    "slug": "ahmed-ibrahim-abdulrahman-alzarooni",
    "name": "AHMED IBRAHIM ABDULRAHMAN IBRAHIM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/01/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmed Ibrahim Abdulrahman Alzarooni",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8261f764-295e-4aea-97f9-0daa5acc0dca",
        "address": "",
        "phone": "97143331110",
        "email": "info@azlegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "abaeef69-3741-441b-b7fa-26710741464e",
    "firmName": "AHMED ALZAROONI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1406",
    "licenseIssueDate": "01/30/2020 00:00:00",
    "licenseExpiryDate": "01/29/2026 00:00:00"
  },
  {
    "id": "32fc3fcb-09ca-4d4c-97b6-578efd5304c1",
    "slug": "ahmed-jasem-abdullah",
    "name": "AHMED JASEM ABDULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 21,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/02/2004",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmed Jasem Abdullah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_32fc3fcb-09ca-4d4c-97b6-578efd5304c1",
        "address": "",
        "phone": "97142957785",
        "email": "alrashed-advocates@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "0793b25d-a3a5-4843-aaaf-84c9d74e7644",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-480",
    "licenseIssueDate": "02/28/2004 00:00:00",
    "licenseExpiryDate": "02/27/2026 00:00:00"
  },
  {
    "id": "0f06a08c-3cd7-4ef7-8e09-0723660567f0",
    "slug": "ahmed-khamies-saeed-alsumm-alzeyoudi",
    "name": "AHMED KHAMEIS SAEED ALSUMM ALZEYOUDI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/04/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmed Khamies Saeed Alsumm Alzeyoudi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0f06a08c-3cd7-4ef7-8e09-0723660567f0",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1273",
    "licenseIssueDate": "04/15/2018 00:00:00",
    "licenseExpiryDate": "04/14/2026 00:00:00"
  },
  {
    "id": "807e66bc-4469-40c2-8187-b5712c4883b8",
    "slug": "ahmed-mahdi-fahad-badi-alataeibi",
    "name": "AHMED MAHDI FAHED BADI ALATEIBI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/04/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmed Mahdi Fahad Badi Alataeibi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_807e66bc-4469-40c2-8187-b5712c4883b8",
        "address": "Ahmad Al Otaibi ,6th floor /606 ,Century 21 Tower ,Alqabayel Center ,126936 ,Dubai",
        "phone": "97142697670",
        "email": "info@otaibilc.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "5e10a3c0-085d-4e92-84b1-ec3013bc4bae",
    "firmName": "AL OTAIBI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-693",
    "licenseIssueDate": "04/03/2014 00:00:00",
    "licenseExpiryDate": "04/02/2026 00:00:00"
  },
  {
    "id": "19b9ce3f-c48a-4bee-a255-6074679eceb3",
    "slug": "ahmed-mohamed-abdulla-barakat-abdulsamad",
    "name": "NASER ABDULLA SALEM ALI ALMUHARRAMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/12/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmed Mohamed Abdulla Barakat Abdulsamad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_19b9ce3f-c48a-4bee-a255-6074679eceb3",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1609",
    "licenseIssueDate": "01/05/2022 00:00:00",
    "licenseExpiryDate": "01/04/2026 00:00:00"
  },
  {
    "id": "9187a546-32d6-4ab6-bde3-4753d2ee7e73",
    "slug": "ahmed-mohamed-abdulrhman-abdulkarim-almarzooqi",
    "name": "MOHAMED ABDULRAHMAN ABDULKARIM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Criminal Law-Family Crimes",
      "Criminal Law-Hate crimes",
      "Civil Transactions-Tenancy",
      "Commercial Transactions-Unfair competition",
      "Criminal Law-Crimes against persons",
      "Criminal Law-Drug Crimes",
      "Personal Status-Marriage & Divorce",
      "Personal Status-Child Abuse & Abduction",
      "Criminal Law-Crimes against properties",
      "Criminal Law-Cybercrimes",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/05/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmed Mohamed Abdulrhman Abdulkarim Almarzooqi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9187a546-32d6-4ab6-bde3-4753d2ee7e73",
        "address": "",
        "phone": "97142552220",
        "email": "almaazmi.office@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "e04d8a88-3378-40c8-a33a-b5e26a0c8507",
    "firmName": "ABDELRAHMAN ALMAAZMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1281",
    "licenseIssueDate": "05/10/2018 00:00:00",
    "licenseExpiryDate": "05/09/2026 00:00:00"
  },
  {
    "id": "466a8623-6690-4a1b-b9ce-c42a5d59ba85",
    "slug": "ahmed-mohamed-mobarak-abdulla-alhmoudi",
    "name": "AHMED MOHAMED MOBARAK ABDULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/04/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmed Mohamed Mobarak Abdulla ALhmoudi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_466a8623-6690-4a1b-b9ce-c42a5d59ba85",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-752",
    "licenseIssueDate": "04/12/2011 00:00:00",
    "licenseExpiryDate": "04/11/2026 00:00:00"
  },
  {
    "id": "aba17d61-2404-4333-811d-e28ba47bf491",
    "slug": "ahmed-mohamed-saeed-ahmed-almazrouei",
    "name": "AHMED MOHAMED SAEED A A ALMAZROUEI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/11/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmed Mohamed Saeed Ahmed Almazrouei",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_aba17d61-2404-4333-811d-e28ba47bf491",
        "address": "الطابق العاشر - 1003 ,برج الريم ,خلف مقر اتصالات - ديرة ,64166 ,Dubai",
        "phone": "97143395953 / 971502110022",
        "email": "info@almazroueiadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "0f57dd9c-c65a-4c45-bd06-695ca9e13f69",
    "firmName": "AHMED ALMAZROUEI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-1036",
    "licenseIssueDate": "11/30/2015 00:00:00",
    "licenseExpiryDate": "11/29/2025 00:00:00"
  },
  {
    "id": "a6713661-e49b-427b-96c3-ed377d280f67",
    "slug": "ahmed-mohammed-bashir-husain-alshaqfa",
    "name": "AHMED MOHAMMED BASHIR HUSAIN AL SHAQFA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/01/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmed Mohammed Bashir Husain Alshaqfa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a6713661-e49b-427b-96c3-ed377d280f67",
        "address": "801/802 ,Park Place ,WTC ,384557 ,Dubai",
        "phone": "97143203999",
        "email": "info.dubai@alemlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "e3088c8b-a7dc-4f38-a04d-cb4c7d050ed9",
    "firmName": "AHMED MOHAMMED BASHIR ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-985",
    "licenseIssueDate": "01/22/2015 00:00:00",
    "licenseExpiryDate": "01/21/2026 00:00:00"
  },
  {
    "id": "9d92e92b-b3bc-4156-bd0e-fc033ff7c089",
    "slug": "ahmed-mohammed-haji-alhammadi",
    "name": "AHMED MOHAMMED HAJI ALHAMMADI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/01/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: AHMED MOHAMMED HAJI ALHAMMADI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9d92e92b-b3bc-4156-bd0e-fc033ff7c089",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-1498",
    "licenseIssueDate": "01/19/2021 00:00:00",
    "licenseExpiryDate": "01/18/2026 00:00:00"
  },
  {
    "id": "2832a3ed-05a3-46b1-bcc2-1e1719b61c24",
    "slug": "ahmed-mohammed-mahmood",
    "name": "AHMED HOSSEYN ALI NAZARI AL MARZUQI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/09/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmed Mohammed Mahmood",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2832a3ed-05a3-46b1-bcc2-1e1719b61c24",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-2026",
    "licenseIssueDate": "09/23/2024 00:00:00",
    "licenseExpiryDate": "09/22/2026 00:00:00"
  },
  {
    "id": "6a2f3cd0-dec6-4907-9330-dcfe5d03fbcd",
    "slug": "ahmed-mohammed-matar-matar-almheiri",
    "name": "AHMED MOHAMED MATAR M ALMHEIRI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/07/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmed Mohammed Matar Matar Almheiri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6a2f3cd0-dec6-4907-9330-dcfe5d03fbcd",
        "address": "Ahmed Mohammed Matar Matar Almheiri ,4 ,SOBHA SAPPHIRE ,Bussines Bay ,393294 ,Dubai",
        "phone": "97143387880 / 971506478881",
        "email": "almheiricourts@bridgelg.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "4cb37c1d-1403-421d-bc15-9451cc629e9d",
    "firmName": "AHMED MATAR AL MHEIRI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-1211",
    "licenseIssueDate": "07/31/2017 00:00:00",
    "licenseExpiryDate": "07/30/2026 00:00:00"
  },
  {
    "id": "9d9adaa6-429c-4e42-9275-897eb1b9de33",
    "slug": "ahmed-mohammed-rashed-bin-al-shaibah-almheiri",
    "name": "SAIF AHMED IBRAHIM MOHAMMED ALBLOOSHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/08/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmed Mohammed Rashed Bin Al Shaibah Almheiri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9d9adaa6-429c-4e42-9275-897eb1b9de33",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1855",
    "licenseIssueDate": "08/25/2023 00:00:00",
    "licenseExpiryDate": "08/24/2026 00:00:00"
  },
  {
    "id": "f7fe4fd5-c362-4017-80c5-61782036887b",
    "slug": "ahmed-murad-abdullah-ali-al-blooshi",
    "name": "AHMED MURAD ABDULLA ALI ALBLOOSHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/11/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-11-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmed Murad Abdullah  Ali Al Blooshi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f7fe4fd5-c362-4017-80c5-61782036887b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1481",
    "licenseIssueDate": "11/26/2020 00:00:00",
    "licenseExpiryDate": "11/25/2025 00:00:00"
  },
  {
    "id": "357c294c-0c15-4188-bb28-62afeb56f6b6",
    "slug": "ahmed-obaid-khamis-ali-albedwawi",
    "name": "AHMED OBAID KHAMIS ALI ALBADWAWI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Civil Transactions-Insurance",
      "Personal Status-Wills",
      "Criminal Law-Family Crimes",
      "Personal Status-Custody & Alimony",
      "Criminal Law-Hate crimes",
      "Civil Transactions-Tenancy",
      "Criminal Law-Crimes against persons",
      "Personal Status-Legacies and Inheritance",
      "Civil Transactions-Labor & Workers",
      "Personal Status-Legal Capacity & Guardianship",
      "Criminal Law-Drug Crimes",
      "Personal Status-Marriage & Divorce",
      "Personal Status-Child Abuse & Abduction",
      "Civil Transactions-Compensation",
      "Criminal Law-Crimes against properties",
      "Commercial Transactions-E-Commerce",
      "Criminal Law-Cybercrimes",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/01/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmed Obaid Khamis ALi Albedwawi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_357c294c-0c15-4188-bb28-62afeb56f6b6",
        "address": "almetaq insurance  ,alnouf tower ,business vilage  ,92422 ,Dubai",
        "phone": "97142974555",
        "email": "info@alsaeedilaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "5684cb2e-d43e-411d-b69e-2e1976782a55",
    "firmName": "ALSAEEDI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1403",
    "licenseIssueDate": "01/29/2020 00:00:00",
    "licenseExpiryDate": "01/28/2026 00:00:00"
  },
  {
    "id": "40144d97-05f4-4e7d-8688-c0218babacd3",
    "slug": "ahmed-rashid-mohamed-jaber-alsalami",
    "name": "AHMED RASHID MOHAMED JABIR",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/12/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmed Rashid Mohamed Jaber Alsalami",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_40144d97-05f4-4e7d-8688-c0218babacd3",
        "address": "jabir rashid alsalami ,b3607 ,latifa tower ,crowne plaza hotel - dubai ,3117 ,Dubai",
        "phone": "97143599997",
        "email": "jabir@jabiralsalami.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "ee5a7838-1f12-4443-832e-a3a87eff8dd6",
    "firmName": "JABIR RASHID ALSALAMI ADVOCATES & LEGEL CONSULTANCY",
    "registrationNumber": "L-1326",
    "licenseIssueDate": "12/04/2018 00:00:00",
    "licenseExpiryDate": "12/03/2025 00:00:00"
  },
  {
    "id": "51ee6c52-5922-40d3-893e-0f22b775093a",
    "slug": "ahmed-saeed-mobarak-obaid-alzahmi",
    "name": "AHMED SAEED MOBARAK OBAID ALZAHMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/11/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmed Saeed Mobarak Obaid Alzahmi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_51ee6c52-5922-40d3-893e-0f22b775093a",
        "address": "",
        "phone": "97142865353 / 971551986013",
        "email": "info@alzahmyadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "fd77d7cf-7bee-4da2-8757-d004294b9189",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1472",
    "licenseIssueDate": "11/08/2020 00:00:00",
    "licenseExpiryDate": "11/07/2025 00:00:00"
  },
  {
    "id": "c7f30121-e935-4338-8b50-757919d0216a",
    "slug": "ahmed-saeed-sulayem-rashed-almazrouei",
    "name": "AHMAD SAEED SULAYEM RASHED ALMAZROUEI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/06/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmed Saeed Sulayem Rashed Almazrouei",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c7f30121-e935-4338-8b50-757919d0216a",
        "address": "Saeed Sulayem Rashed Almazrouei ,M05 ,Al Durrah 4 ,Behind GGICO metro station ,11311 ,Dubai",
        "phone": "97143889000",
        "email": "info@sulayemlegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "b221d5d0-c8b1-4064-a7a5-84cf410fd408",
    "firmName": "SAEED SULAYEM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1545",
    "licenseIssueDate": "08/01/2021 00:00:00",
    "licenseExpiryDate": "06/28/2026 00:00:00"
  },
  {
    "id": "a4d0b410-f9ac-4971-b37e-796c0c9f792a",
    "slug": "ahmed-saif-majed-bin-salem-al-matrooshi",
    "name": "AHMAD SAIF MAJID BIN SALEM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 27,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/11/1997",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmed Saif Majed Bin Salem Al-Matrooshi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a4d0b410-f9ac-4971-b37e-796c0c9f792a",
        "address": "",
        "phone": "97142828999",
        "email": "info@gmalc.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "2f9514bf-2175-40fe-8539-d1b4b32074b7",
    "firmName": "ALGURG & ALMATROOSHI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-317",
    "licenseIssueDate": "11/20/1997 00:00:00",
    "licenseExpiryDate": "11/19/2025 00:00:00"
  },
  {
    "id": "81f0f6ec-12ce-4c3b-90d9-07d283454581",
    "slug": "ahmed-saleh-abdulla-khamees-al-ramsi",
    "name": "AHMED SALEH ABDALLA KHAMIS",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/10/2009",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmed Saleh Abdulla Khamees Al Ramsi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_81f0f6ec-12ce-4c3b-90d9-07d283454581",
        "address": "Ahmed Saleh Abulla Khamis ALramsi ,1305 ,Fairmont Dubai ,Burj Khalifa ,77857 ,Dubai",
        "phone": "97142720066",
        "email": "info@alramsyadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "b84458c4-4c08-4fa7-8fd9-05b8787d4896",
    "firmName": "DR.AHMED ALRAMSY LAWYERS & CONSULTANTS",
    "registrationNumber": "L-679",
    "licenseIssueDate": "10/04/2009 00:00:00",
    "licenseExpiryDate": "10/03/2026 00:00:00"
  },
  {
    "id": "31d91619-a732-494c-9d8c-0d1d423d37e9",
    "slug": "ahmed-saleh-ahmed-abdulla-alothali",
    "name": "AHMED SALEH AHMED ABDULLA ALOTHALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/06/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmed Saleh Ahmed Abdulla Alothali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_31d91619-a732-494c-9d8c-0d1d423d37e9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-750",
    "licenseIssueDate": "06/24/2025 00:00:00",
    "licenseExpiryDate": "06/23/2026 00:00:00"
  },
  {
    "id": "7a947e2b-df6e-44b0-8858-c6d800f37065",
    "slug": "ahmed-salem-mohammed-murshed-alkaabi",
    "name": "HAMAD SAEED OBAID SULAIJ",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/10/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmed Salem Mohammed Murshed Alkaabi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7a947e2b-df6e-44b0-8858-c6d800f37065",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1719",
    "licenseIssueDate": "11/14/2022 00:00:00",
    "licenseExpiryDate": "11/13/2025 00:00:00"
  },
  {
    "id": "8cad0945-5d8d-4124-9faa-66bce5213aba",
    "slug": "ahmed-salem-saif-mohammed-alnuaimi",
    "name": "JASIM MOHAMED ABDALLA MURAD ALBLOOSHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/09/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: AHMED SALEM SAIF MOHAMMED ALNUAIMI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8cad0945-5d8d-4124-9faa-66bce5213aba",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-2030",
    "licenseIssueDate": "10/03/2024 00:00:00",
    "licenseExpiryDate": "10/02/2026 00:00:00"
  },
  {
    "id": "e47c0a67-5c00-4a32-9bd1-90fe6f5ea6be",
    "slug": "ahmed-salem-sultan-saeed-al-saedi",
    "name": "AHMED SALEM SULTAN SAEED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/05/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmed Salem Sultan Saeed Al Saedi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e47c0a67-5c00-4a32-9bd1-90fe6f5ea6be",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-944",
    "licenseIssueDate": "05/06/2014 00:00:00",
    "licenseExpiryDate": "05/05/2026 00:00:00"
  },
  {
    "id": "07ab685e-825d-438a-a44a-1a476ad88e31",
    "slug": "ahmed-sultan-ahmed-sultan-al-hantoobi",
    "name": "AHMED SULTAN AHMED SULTAN ALHANTOOBI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/07/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmed Sultan Ahmed Sultan Al Hantoobi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_07ab685e-825d-438a-a44a-1a476ad88e31",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-958",
    "licenseIssueDate": "07/21/2014 00:00:00",
    "licenseExpiryDate": "07/20/2026 00:00:00"
  },
  {
    "id": "87cbaca7-369b-4bd1-a050-d060e94718f1",
    "slug": "ahmed-yousef-ali-mohammed-alqaydi",
    "name": "AHMED YOUSEF ALI MOHAMMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Criminal Law-Family Crimes",
      "Civil Transactions-Tenancy",
      "Civil Transactions-Labor & Workers",
      "Commercial Transactions-Consumer protection",
      "Commercial Transactions-Intellectual Property (includes trademarks",
      "copy rights",
      "patents)"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/10/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ahmed Yousef  Ali Mohammed Alqaydi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_87cbaca7-369b-4bd1-a050-d060e94718f1",
        "address": "1 ,Crystal Tower ,Business Bay ,1859 ,Dubai",
        "phone": "97142956661",
        "email": "info@amrplc.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "833edb7f-7a70-4ab6-9838-4782eb1b4f8a",
    "firmName": "ABDULLA MOHAMMED RASOUL ALHARMOODI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-975",
    "licenseIssueDate": "10/28/2014 00:00:00",
    "licenseExpiryDate": "10/27/2025 00:00:00"
  },
  {
    "id": "2cf9000b-8055-4870-8776-45717ea0c3ca",
    "slug": "aisha-abdulkarim-ahmed-abdulla-eid",
    "name": "AISHA ABDULKARIM AHMED ABDULLAH EID",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/06/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Aisha Abdulkarim Ahmed Abdulla Eid",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2cf9000b-8055-4870-8776-45717ea0c3ca",
        "address": "ABDULLKAREIM AHMED ABDULLA EID ,الطابق الثانى - مكتب رقم 014 ,مركز الممزر  ,مقابل القياده العامه لشرطة دبي - بجوار مكتب وزارة العمل والعمال القديم  ,89505 ,Dubai",
        "phone": "97142388850",
        "email": "bineidadvocates@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "ea633c29-6b4a-48a8-aaec-c801ece50744",
    "firmName": "BIN EID ADVOCATES & LEGEL CONSULTANTS",
    "registrationNumber": "L-783",
    "licenseIssueDate": "06/09/2014 00:00:00",
    "licenseExpiryDate": "06/08/2026 00:00:00"
  },
  {
    "id": "6166bd17-c807-41f2-bf56-68fd90cfbacb",
    "slug": "aisha-ateeq-ali-bilal-johar",
    "name": "ATEEQ ALI BILAL JOHAR",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 17,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/03/2008",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: AISHA ATEEQ ALI BILAL JOHAR",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6166bd17-c807-41f2-bf56-68fd90cfbacb",
        "address": "",
        "phone": "97142515900 / 971509394393",
        "email": "mail@aaadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "fe265115-cd56-43ce-b8be-22056eb663f3",
    "firmName": "AISHA ATEEQ ADVOCETS AND LEGAL CONSALTINT",
    "registrationNumber": "L-624",
    "licenseIssueDate": "03/03/2008 00:00:00",
    "licenseExpiryDate": "03/02/2026 00:00:00"
  },
  {
    "id": "a10da993-7051-4812-87f7-d1a04b073c43",
    "slug": "aisha-eisa-yousif-ahmed-alawadhi",
    "name": "AISHA EISA YOUSIF AHMED ALAWADHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/07/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Aisha Eisa Yousif Ahmed Alawadhi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a10da993-7051-4812-87f7-d1a04b073c43",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1430",
    "licenseIssueDate": "07/11/2020 00:00:00",
    "licenseExpiryDate": "07/10/2026 00:00:00"
  },
  {
    "id": "5c0f2f85-c72f-4b52-8082-f6e43df7449e",
    "slug": "aisha-saif-sultan-alkhabeel-almehrzi",
    "name": "AISHA SAIF SULTAN ALI ALKHABEEL",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/11/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Aisha Saif Sultan Alkhabeel Almehrzi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5c0f2f85-c72f-4b52-8082-f6e43df7449e",
        "address": "Office No. 211 ,Al Wasl Building ,Makani No: 2479487549 ,000 ,Dubai",
        "phone": "97142733476 / 97142733476",
        "email": "abo_sultan_s@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "ba81cc15-7448-4103-91bf-70c7e3f12812",
    "firmName": "SAIF SULTAN ALMEHRZI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1468",
    "licenseIssueDate": "11/01/2020 00:00:00",
    "licenseExpiryDate": "10/31/2025 00:00:00"
  },
  {
    "id": "472c2c26-6345-4b12-8a76-8cb423036652",
    "slug": "aisha-salem-ali-abdulla-aldhaheri",
    "name": "WAFA OBAID MASOOD SALMIN ALFALASI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/01/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Aisha Salem Ali Abdulla Aldhaheri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_472c2c26-6345-4b12-8a76-8cb423036652",
        "address": "الثالث  ,برج جيت  48  ,مخرج ميترو برج خليفه / دبي مول  ,181111 ,Dubai",
        "phone": "97145143423 / 971971451434",
        "email": "info.justice@fhsadvo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "690778ba-3332-4c06-b01f-ab5ec89ee304",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1743",
    "licenseIssueDate": "01/17/2023 00:00:00",
    "licenseExpiryDate": "01/16/2026 00:00:00"
  },
  {
    "id": "737e6030-31a8-4fbd-bae1-590a77cde154",
    "slug": "aishah-khalaf-obaid-almazrouei",
    "name": "FATIMA ABDELQUDOUS A ALSIDDIQ ALOBEIDLI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/03/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Aishah khalaf obaid almazrouei",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_737e6030-31a8-4fbd-bae1-590a77cde154",
        "address": "",
        "phone": "97142881170 / 971502080879",
        "email": "aka_lawyers@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "f81e35e3-2b71-42e5-9587-c64764d2d4cf",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1640",
    "licenseIssueDate": "04/03/2022 00:00:00",
    "licenseExpiryDate": "04/02/2026 00:00:00"
  },
  {
    "id": "92affe34-201d-4e46-8c98-ffd6a98382a1",
    "slug": "akram-ahmed-ali-mohsin-al-baiti-al-hashmi",
    "name": "Akram Ahmed Ali Mohsin Al Baiti Al Hashmi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/12/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Akram Ahmed Ali Mohsin Al Baiti Al Hashmi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_92affe34-201d-4e46-8c98-ffd6a98382a1",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "1043",
    "licenseIssueDate": "01/12/2016 00:00:00",
    "licenseExpiryDate": "01/11/2026 00:00:00"
  },
  {
    "id": "183dcf62-380f-41ce-8405-b8876dddb8e8",
    "slug": "al-anoud-alshaiba-ali-salem-al-dramaki",
    "name": "AL ANOUD AL SHAIBA ALI SALEM ALDARMAKI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/01/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Al Anoud Alshaiba Ali Salem Al Dramaki",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_183dcf62-380f-41ce-8405-b8876dddb8e8",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1333",
    "licenseIssueDate": "01/06/2019 00:00:00",
    "licenseExpiryDate": "01/05/2026 00:00:00"
  },
  {
    "id": "e9b5985a-6c1d-4ddd-97c4-854bfe12d861",
    "slug": "al-anoud-mohamed-saleh-alawi",
    "name": "ALANOUD MOHAMMED SALEH ALAWI ALBREIKI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/09/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Al Anoud Mohamed Saleh Alawi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e9b5985a-6c1d-4ddd-97c4-854bfe12d861",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1560",
    "licenseIssueDate": "09/01/2021 00:00:00",
    "licenseExpiryDate": "08/31/2026 00:00:00"
  },
  {
    "id": "af5e92a7-e2f2-45bc-85da-8a44b013f83f",
    "slug": "al-fadhel-muatasem-abdul-rahman-al-maqboul",
    "name": "ALFADHEL MUATASEM ABDULRAHMAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 19,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/01/2006",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: AL FADHEL MUATASEM ABDUL RAHMAN AL MAQBOUL",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_af5e92a7-e2f2-45bc-85da-8a44b013f83f",
        "address": "الثامن مكتب 815 ,بزنس افينو  ,خلف وكالة نيسان  ,57134 ,Dubai",
        "phone": "97145463588",
        "email": "hisham@daralhekma.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "e9592d3b-4f5e-43bf-9305-f85447bc9653",
    "firmName": "DAR AL HEKMA LAWYERS & LEGAL CONSULTANCY",
    "registrationNumber": "L-535",
    "licenseIssueDate": "01/17/2006 00:00:00",
    "licenseExpiryDate": "01/16/2026 00:00:00"
  },
  {
    "id": "ec3e791f-bd9b-42fe-8ece-1d1aca1bb5bf",
    "slug": "ala-ibrahim-mohamed-abdalla-aljasmi",
    "name": "IBRAHIM MOHAMED ABDALLA AHMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/11/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ala Ibrahim Mohamed Abdalla Aljasmi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ec3e791f-bd9b-42fe-8ece-1d1aca1bb5bf",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1478",
    "licenseIssueDate": "11/13/2020 00:00:00",
    "licenseExpiryDate": "11/12/2025 00:00:00"
  },
  {
    "id": "314e3512-4f27-4cf3-bec9-15394de03345",
    "slug": "alaa-salem-ali-jazem-omar",
    "name": "ABDULLA RASHID OBAID B ALSHAMSI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/05/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: alaa salem ali jazem omar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_314e3512-4f27-4cf3-bec9-15394de03345",
        "address": "",
        "phone": "97100000000",
        "email": "dubai@ahlegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "eae5fb25-fd19-436c-8668-3ac309424db4",
    "firmName": "KHALIFA BIN OMAIR ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1966",
    "licenseIssueDate": "05/26/2024 00:00:00",
    "licenseExpiryDate": "05/25/2026 00:00:00"
  },
  {
    "id": "6e879e34-eca9-4e96-8810-49bfc2b397dc",
    "slug": "alanood-salem-mohammad-ali-alriyami",
    "name": "SHAIKHA MOHAMED IBRAHIM ALGHUMLASI ALSHAMSI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/06/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Alanood Salem Mohammad Ali Alriyami",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6e879e34-eca9-4e96-8810-49bfc2b397dc",
        "address": "",
        "phone": "97144230000 / 971552009022",
        "email": "UAE-CourtClerks@habibalmulla.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "3eba82bb-8ec4-4cbd-80d0-a793cb993fde",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-2000",
    "licenseIssueDate": "07/04/2024 00:00:00",
    "licenseExpiryDate": "07/03/2026 00:00:00"
  },
  {
    "id": "2aacc243-4a43-4ed4-b7bc-a791ea510d3d",
    "slug": "alawi-ghaleb-ali-saeed-aljaberi",
    "name": "ALAWI GHALEB ALI SAEED ALJABRI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/10/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Alawi Ghaleb Ali Saeed Aljaberi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2aacc243-4a43-4ed4-b7bc-a791ea510d3d",
        "address": "Alawi Ghaleb Ali Saeed Aljaberi ,M ,Bussiness venue building  ,al nase club ,10103 ,Dubai",
        "phone": "97143436652",
        "email": "ajadvo017@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "80667ff5-8d9d-4ce3-860f-34cd7e4937bc",
    "firmName": "ALAWI ALJABERI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1121",
    "licenseIssueDate": "10/27/2022 00:00:00",
    "licenseExpiryDate": "10/26/2025 00:00:00"
  },
  {
    "id": "91160423-072d-43fb-91a1-31415db25365",
    "slug": "al-hajjiah-salem-saed-al-nobi",
    "name": "ALHAJEYA SALEM SAEED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 26,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/06/1999",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Al-Hajjiah Salem Saed Al Nobi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_91160423-072d-43fb-91a1-31415db25365",
        "address": "Alhajeya salem saeed alnoobi ,3rd  ,Al-hawai Tower  ,Behind financial center metro station  ,39779 ,Dubai",
        "phone": "97142963813",
        "email": "adv_aljazeera@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "f091b928-9e3d-4e24-b489-65ca31481366",
    "firmName": "Al HAJEYA ALNOOBI ADVOCATES AND LEGAL CONSULTANT",
    "registrationNumber": "L-246",
    "licenseIssueDate": "06/29/1999 00:00:00",
    "licenseExpiryDate": "06/28/2026 00:00:00"
  },
  {
    "id": "54985f60-f0b4-4ed4-9721-40c4cc3eaf70",
    "slug": "ali-abdulla-ali-alqawadi-alhammadi",
    "name": "ALI ABDALLA ALI AHMED ALQAWADI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Personal Status-Wills",
      "Criminal Law-Family Crimes",
      "Personal Status-Custody & Alimony",
      "Commercial Transactions-Bankruptcy",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Criminal Law-Hate crimes",
      "Criminal Law-Crimes against persons",
      "Personal Status-Legacies and Inheritance",
      "Personal Status-Legal Capacity & Guardianship",
      "Criminal Law-Drug Crimes",
      "Personal Status-Marriage & Divorce",
      "Personal Status-Child Abuse & Abduction",
      "Criminal Law-Crimes against properties",
      "Criminal Law-Cybercrimes"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/02/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ali Abdulla Ali Alqawadi Alhammadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_54985f60-f0b4-4ed4-9721-40c4cc3eaf70",
        "address": "110 ,بناية مكاتب عود ميثاء R338 ,مقابل وافى مول وفندق رافلز دبى ,624494 ,Dubai",
        "phone": "97143231881",
        "email": "info@alialhammadi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "373da443-20e8-461a-b11d-dba4d77f1b45",
    "firmName": "ALI ALHAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1055",
    "licenseIssueDate": "02/28/2016 00:00:00",
    "licenseExpiryDate": "02/27/2026 00:00:00"
  },
  {
    "id": "957bb75a-b202-4ab0-808e-46498b58eb57",
    "slug": "ali-abdulla-ibrahim-mohamed-almansoori",
    "name": "ALI ABUDLLA IBRAHIM MOHAMED ALMANSOORI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/03/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ali Abdulla Ibrahim Mohamed Almansoori",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_957bb75a-b202-4ab0-808e-46498b58eb57",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-866",
    "licenseIssueDate": "03/11/2013 00:00:00",
    "licenseExpiryDate": "03/10/2026 00:00:00"
  },
  {
    "id": "12d0811d-6c54-48ea-8b1a-6d5bccfc5197",
    "slug": "ali-abdulla-majed-al-shamsi",
    "name": "ALI ABDULLA MAJED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 34,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/11/1990",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ali Abdulla Majed Al-Shamsi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_12d0811d-6c54-48ea-8b1a-6d5bccfc5197",
        "address": "",
        "phone": "97108307033",
        "email": "general.alshamsi@lawuae.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "d29f6d04-dad1-4f59-9ae2-d4d245f63133",
    "firmName": "AL SHAMSI & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-209",
    "licenseIssueDate": "11/12/1990 00:00:00",
    "licenseExpiryDate": "11/11/2025 00:00:00"
  },
  {
    "id": "87066c8f-8220-4a60-8089-f2c53f77119e",
    "slug": "ali-abdulla-mohammed-ahmed-alnuaimi",
    "name": "ALI ABDULLA MOHAMMED AHMED ALNUAIMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/02/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ali Abdulla Mohammed Ahmed AlNuaimi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_87066c8f-8220-4a60-8089-f2c53f77119e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1345",
    "licenseIssueDate": "02/21/2019 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "2cfa2dac-f7a9-4b17-8941-cb83ad6951fe",
    "slug": "ali-abdulla-sorour-abdulla-alqareiny",
    "name": "ALI ABDULLA SOROUR A AL QAREINY",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/11/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-11-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ali Abdulla Sorour Abdulla Alqareiny",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2cfa2dac-f7a9-4b17-8941-cb83ad6951fe",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-840",
    "licenseIssueDate": "11/20/2012 00:00:00",
    "licenseExpiryDate": "11/19/2025 00:00:00"
  },
  {
    "id": "48cbbf49-6dd6-4f69-ac8d-553e57cd5ea4",
    "slug": "ali-ahmad-ibrahim-ali-al-sallani",
    "name": "ALI AHMED ALI ALSALLANI ALANSAARI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 25,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/10/2000",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ali Ahmad Ibrahim Ali Al-Sallani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_48cbbf49-6dd6-4f69-ac8d-553e57cd5ea4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-387",
    "licenseIssueDate": "10/10/2000 00:00:00",
    "licenseExpiryDate": "10/09/2025 00:00:00"
  },
  {
    "id": "b64628d6-50d7-4b82-9e73-c729534fceec",
    "slug": "ali-ahmed-ali-obaid-al-mannaei",
    "name": "ALI AHMED ALI OBAID ALMANNAEE",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 21,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/03/2004",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ali Ahmed Ali Obaid Al-Mannaei",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b64628d6-50d7-4b82-9e73-c729534fceec",
        "address": "",
        "phone": "97142552008",
        "email": "info@alialmannaei.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "e8cecbdb-d935-4626-8634-7c0a23598474",
    "firmName": "ALI AL MANNAEI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-481",
    "licenseIssueDate": "03/06/2004 00:00:00",
    "licenseExpiryDate": "03/05/2026 00:00:00"
  },
  {
    "id": "ac99b75e-c0cc-4af5-8f86-81290936371a",
    "slug": "ali-ahmed-habib-abdul-karim-al-khaja",
    "name": "ALI AHMED HABIB ABDUL KARIM AL KHAJA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 17,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/01/2008 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ALI AHMED HABIB ABDUL KARIM AL KHAJA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ac99b75e-c0cc-4af5-8f86-81290936371a",
        "address": "",
        "phone": "97100000000",
        "email": "dubai@ahlegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "eae5fb25-fd19-436c-8668-3ac309424db4",
    "firmName": "ALI HABIB AND ASSOCIATES ADVOCATES AND LEGAL",
    "registrationNumber": "641",
    "licenseIssueDate": "09/01/2008 00:00:00",
    "licenseExpiryDate": "08/31/2026 00:00:00"
  },
  {
    "id": "386200f6-2be7-44ad-9d8f-3c0f9a6aa49f",
    "slug": "ali-ahmed-hassan-al-diqqi",
    "name": "ALI AHMED HASSAN ALDIQQI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/05/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ali Ahmed Hassan Al Diqqi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_386200f6-2be7-44ad-9d8f-3c0f9a6aa49f",
        "address": "",
        "phone": "97143384004 / 971566651137",
        "email": "aaldiqqi@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "21562057-4573-49b3-bd96-20c932058ea3",
    "firmName": "ALI AHMED ALDIQQI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-305",
    "licenseIssueDate": "05/31/2021 00:00:00",
    "licenseExpiryDate": "05/30/2026 00:00:00"
  },
  {
    "id": "2deaa5ac-d775-430a-ab4d-f3549f0a71c9",
    "slug": "ali-amer-abdul-hadi-soufan-al-ahbabi",
    "name": "ALI AMER ABDULHADI SOUFAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/02/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ali Amer Abdul Hadi Soufan Al Ahbabi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2deaa5ac-d775-430a-ab4d-f3549f0a71c9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-917",
    "licenseIssueDate": "02/24/2014 00:00:00",
    "licenseExpiryDate": "02/23/2026 00:00:00"
  },
  {
    "id": "f3c8eef6-9b7a-44e4-b1be-d17162119095",
    "slug": "ali-essa-mohannad-alsamt",
    "name": "Ali Essa Mohannad Alsamt",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/30/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2021-07-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ali Essa Mohannad Alsamt",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f3c8eef6-9b7a-44e4-b1be-d17162119095",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "1210",
    "licenseIssueDate": "07/30/2017 00:00:00",
    "licenseExpiryDate": "07/29/2021 00:00:00"
  },
  {
    "id": "f5f5e53a-03b4-40bf-a5d1-6f01fc9565f0",
    "slug": "ali-hadi-hamad-awam-alyaami",
    "name": "ALI HADI HAMAD AWAM ALYAAMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/04/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ali Hadi Hamad Awam Alyaami",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f5f5e53a-03b4-40bf-a5d1-6f01fc9565f0",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1071",
    "licenseIssueDate": "05/01/2016 00:00:00",
    "licenseExpiryDate": "04/30/2026 00:00:00"
  },
  {
    "id": "54d1556a-a204-4314-a491-fe5693910803",
    "slug": "ali-hamad-saif-nasser-alebri",
    "name": "SAEED SALEM BALARSA AL SHAMISI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/05/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ALI HAMAD SAIF NASSER ALEBRI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_54d1556a-a204-4314-a491-fe5693910803",
        "address": "الطابق الثامن ,بزنس افنيو ,فندق الخوري سكاي جاردن  ,126510 ,Dubai",
        "phone": "97142572778",
        "email": "zakia@houseofj.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "80c1d0d8-bc34-4358-b07f-35c5f9408311",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1811",
    "licenseIssueDate": "06/14/2023 00:00:00",
    "licenseExpiryDate": "06/13/2026 00:00:00"
  },
  {
    "id": "0152e700-625f-442b-ac21-47a93f30b7a4",
    "slug": "ali-hasan-yousif-hasan-alhammadi",
    "name": "ALI HASAN YOUSIF HASAN ALHAMMADI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/03/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ali Hasan Yousif Hasan Alhammadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0152e700-625f-442b-ac21-47a93f30b7a4",
        "address": "التاسع ,مكتب 903 ملك خالد عبدالرحيم احمد العطار - ذا تاور بلازا ,ذا تاور بلازا ,38350 ,Dubai",
        "phone": "97145873377 / 971564643109",
        "email": "ahm@ahmlawfirms.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "1b2ae5cc-a1db-4e6a-bf98-59d41bdb6127",
    "firmName": "ALI HASAN ALHAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1064",
    "licenseIssueDate": "03/24/2016 00:00:00",
    "licenseExpiryDate": "03/23/2026 00:00:00"
  },
  {
    "id": "1e24a6e6-a6dd-4410-98ec-51e1ab4760d7",
    "slug": "ali-husain-adday-al-shemari",
    "name": "ALI HUSAIN ADDAY ALSHIMMARI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/01/2009",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ali Husain Adday Al-Shemari",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1e24a6e6-a6dd-4410-98ec-51e1ab4760d7",
        "address": "",
        "phone": "97142500717",
        "email": "alishamrilawfirm@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "e22c751b-e66d-497c-b5ee-3df32eab4831",
    "firmName": "ALI ALSHIMMARI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-410",
    "licenseIssueDate": "01/26/2009 00:00:00",
    "licenseExpiryDate": "01/25/2026 00:00:00"
  },
  {
    "id": "2caf1131-60cd-4b15-b53a-ff0eed229fba",
    "slug": "ali-hussain-ali-mohmoud-al-raeesi",
    "name": "ALI HUSSAIN ALI MAHMOUD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 17,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/03/2008",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ali Hussain Ali Mohmoud Al Raeesi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2caf1131-60cd-4b15-b53a-ff0eed229fba",
        "address": "Samia Luqman ,2nd floor ,Emarat Atrium Building ,across Holiday Inn Express Safa Park ,7273 ,Dubai",
        "phone": "97143211000",
        "email": "info@alsuwaidi.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "0e5c3637-bc12-475c-a6b5-2d9ae84f2b8e",
    "firmName": "ALSUWAIDI & COMPANY L.L.C",
    "registrationNumber": "L-621",
    "licenseIssueDate": "03/03/2008 00:00:00",
    "licenseExpiryDate": "03/02/2026 00:00:00"
  },
  {
    "id": "396d8dc0-a775-4e39-8f02-cc1de83f2b01",
    "slug": "ali-hussein-mal-allah-hussein-alhammadi",
    "name": "ALI HUSSAIN MALALLA HUSSAIN ALHAMMADI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/05/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ali Hussein Mal Allah Hussein Alhammadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_396d8dc0-a775-4e39-8f02-cc1de83f2b01",
        "address": "ادارة ا لمبنى  ,الريم ,الاتصالات  ,42423 ,Dubai",
        "phone": "97142222066",
        "email": "info@ozleco.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "7a155f4a-20ec-44ff-863f-4f9fb43d0af4",
    "firmName": "SAEED BIN GHULATA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1290",
    "licenseIssueDate": "05/31/2018 00:00:00",
    "licenseExpiryDate": "05/30/2026 00:00:00"
  },
  {
    "id": "82246610-fdad-4146-a9d3-d940cec52bad",
    "slug": "ali-ibrahim-ahmed-hasouna",
    "name": "ALY IBRAHIM AHMED HASOUNA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Criminal Law-Crimes against properties"
    ],
    "experience": 15,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/11/2009",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ali Ibrahim Ahmed Hasouna",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_82246610-fdad-4146-a9d3-d940cec52bad",
        "address": "first/105 ,Al Shafar Investment ,noor bank metro station ,34655 ,Dubai",
        "phone": "97143386111",
        "email": "unionadvocates1@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "109f3fc4-62e8-4523-9372-95aaf9a76483",
    "firmName": "UNION ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-503",
    "licenseIssueDate": "11/18/2009 00:00:00",
    "licenseExpiryDate": "11/17/2025 00:00:00"
  },
  {
    "id": "b2771fc3-c4cc-49b8-983e-74a012049c43",
    "slug": "ali-ibrahim-mohamed-alhammadi",
    "name": "ALI IBRAHIM MOHAMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 15,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/03/2010",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ali Ibrahim Mohamed Alhammadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b2771fc3-c4cc-49b8-983e-74a012049c43",
        "address": "",
        "phone": "97142280002",
        "email": "advoali2020@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "5029a3dc-098b-4d3f-9e38-afb0eb4319d0",
    "firmName": "ALI IBRAHIM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-704",
    "licenseIssueDate": "03/18/2010 00:00:00",
    "licenseExpiryDate": "03/17/2026 00:00:00"
  },
  {
    "id": "16e81be6-3dae-42a9-a285-fd986dbdc73d",
    "slug": "ali-ismail-ibrahim-aljarman",
    "name": "ALI ISMAIL IBRAHIM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 19,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/04/2006",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ALI ISMAIL IBRAHIM ALJARMAN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_16e81be6-3dae-42a9-a285-fd986dbdc73d",
        "address": "Dr. Ali Ismail Aljarman ,Roof Floor - Offices R03 & R04 ,MSM 1 Building ,Al Saffa First ,62639 ,Dubai",
        "phone": "97144393733",
        "email": "info@prestigeadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "22043b7f-55d2-4eb4-a173-3077ba390351",
    "firmName": "PRESTIGE ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-553",
    "licenseIssueDate": "04/24/2006 00:00:00",
    "licenseExpiryDate": "04/23/2026 00:00:00"
  },
  {
    "id": "d695c9db-d766-4d3e-bf8e-9ba4fbaf25d6",
    "slug": "ali-ismail-mohammed-abdulla-alzarooni",
    "name": "ALI ISMAIL MOHAMED ABDULLA ALZAROONI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Civil Transactions-Arbitration"
    ],
    "experience": 27,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/11/1997",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ali Ismail Mohammed Abdulla Alzarooni",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d695c9db-d766-4d3e-bf8e-9ba4fbaf25d6",
        "address": "O-4801, O-4901 ,Burj al Salam Office Tower ,H Hotel ,111801 ,Dubai",
        "phone": "97143544444",
        "email": "administration@horizlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "4e25fb39-6659-44f0-bc8b-3ff0f067beb0",
    "firmName": "HORIZONS & CO - LAW FIRM",
    "registrationNumber": "L-321",
    "licenseIssueDate": "11/20/1997 00:00:00",
    "licenseExpiryDate": "11/19/2025 00:00:00"
  },
  {
    "id": "88770c5e-bb70-4972-b395-800abd1d0674",
    "slug": "ali-jasim-mohammed-al-taniji",
    "name": "ALI JASEM MOHAMED ALTENEIJI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 23,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/03/2002",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ali Jasim Mohammed Al Taniji",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_88770c5e-bb70-4972-b395-800abd1d0674",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-421",
    "licenseIssueDate": "03/26/2002 00:00:00",
    "licenseExpiryDate": "03/25/2026 00:00:00"
  },
  {
    "id": "70aac006-5857-4ed2-9965-aec494dc059f",
    "slug": "ali-juma-obaid-zayed-alketbi",
    "name": "ALI JUMA OBAID ZAYED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/11/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ali Juma Obaid Zayed Alketbi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_70aac006-5857-4ed2-9965-aec494dc059f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1236",
    "licenseIssueDate": "11/20/2017 00:00:00",
    "licenseExpiryDate": "11/19/2025 00:00:00"
  },
  {
    "id": "bf31bc22-6074-4a7c-af74-1d069b0a4bba",
    "slug": "ali-juwair-alla-ali-manea-alahbabi",
    "name": "ALI JUWAIR ALLA ALI MANEA AL AHBABI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/11/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ALI JUWAIR ALLA ALI MANEA ALAHBABI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bf31bc22-6074-4a7c-af74-1d069b0a4bba",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1599",
    "licenseIssueDate": "11/21/2021 00:00:00",
    "licenseExpiryDate": "11/20/2025 00:00:00"
  },
  {
    "id": "66931df9-a1f8-4f99-9dfd-f7935a7ed385",
    "slug": "ali-kabol-faghiri-tombanooei",
    "name": "FAHAD MOHAMAD ALI NASSER",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/11/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ALI KABOL FAGHIRI TOMBANOOEI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_66931df9-a1f8-4f99-9dfd-f7935a7ed385",
        "address": "",
        "phone": "97143333245 / 97143333245",
        "email": "y.albulooshi@yhadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "5fd2b33a-4bae-47d7-86ce-bdbd42af4336",
    "firmName": "DR SARHAN ALMUAINI ADVOCATE AND LEGAL CONSULTANT",
    "registrationNumber": "L-1896",
    "licenseIssueDate": "12/14/2023 00:00:00",
    "licenseExpiryDate": "12/13/2025 00:00:00"
  },
  {
    "id": "80291ebd-76bb-43ab-9a6f-5280548fa987",
    "slug": "ali-khadher-ali-mohammed-al-abbadi",
    "name": "ALI KHADER ALI M.ALABADI ALMANSOORI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 20,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/03/2005",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ali Khadher Ali Mohammed Al-Abbadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_80291ebd-76bb-43ab-9a6f-5280548fa987",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-416",
    "licenseIssueDate": "03/07/2005 00:00:00",
    "licenseExpiryDate": "03/06/2026 00:00:00"
  },
  {
    "id": "14727ebc-628e-4604-9dea-094adfda2c7e",
    "slug": "ali-khalaf-husain-alhosani",
    "name": "ALI KHALAF HUSAIN KHALFANI ALHOSANI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Criminal Law-Family Crimes",
      "Personal Status-Custody & Alimony",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Personal Status-Marriage & Divorce",
      "Personal Status-Child Abuse & Abduction",
      "Civil Transactions-Compensation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/09/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ali Khalaf Husain Alhosani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_14727ebc-628e-4604-9dea-094adfda2c7e",
        "address": "برج المناره ,برج المناره ,فندق جي دبليو ماريوت ماركيز ,135574 ,Dubai",
        "phone": "97144226166 / 971506464911",
        "email": "info@alialhosani.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "75886cf6-ccb6-4f1b-bd9e-15371e41d8ef",
    "firmName": "ALI KHALAF AL HOSANI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1024",
    "licenseIssueDate": "09/02/2015 00:00:00",
    "licenseExpiryDate": "09/01/2026 00:00:00"
  },
  {
    "id": "2d26d07e-1c4e-4594-b57d-f55b795a51b5",
    "slug": "ali-mir-muttalib-mir-murtaza-amiri",
    "name": "ALI MIR MUTTALIB MIR MURTAZA AMIRI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 23,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/05/2002",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ali Mir Muttalib Mir Murtaza Amiri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2d26d07e-1c4e-4594-b57d-f55b795a51b5",
        "address": "",
        "phone": "97142999926",
        "email": "amiriadvocates@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "0bd0eefd-956b-4c8b-ab5d-ebbcae894927",
    "firmName": "AMIRI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-427",
    "licenseIssueDate": "05/28/2002 00:00:00",
    "licenseExpiryDate": "05/27/2026 00:00:00"
  },
  {
    "id": "43599e4b-81dc-4188-9e3c-7b2292fa8b48",
    "slug": "ali-mohamed-amin-abdullah-naqi",
    "name": "ALI MOHD AMIN ABDULLA NAQI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/04/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ali Mohamed Amin Abdullah Naqi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_43599e4b-81dc-4188-9e3c-7b2292fa8b48",
        "address": "ali mohamed amin  ,205 - 104  ,اثراء  ,بالقرب من فندق جميرا طيران الامارات  ,10155 ,Dubai",
        "phone": "97143967188",
        "email": "aliadvocates71@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "298ff405-ca8b-4fc8-a674-74ae24832268",
    "firmName": "ALI NAQI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1006",
    "licenseIssueDate": "04/12/2015 00:00:00",
    "licenseExpiryDate": "04/11/2026 00:00:00"
  },
  {
    "id": "149573b2-da95-4164-afcf-50eff5597fba",
    "slug": "ali-mohamed-hamdan-salem-almahri",
    "name": "ALI MOHAMED HAMDAN SALEM ALMAHRI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/03/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ali mohamed Hamdan Salem Almahri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_149573b2-da95-4164-afcf-50eff5597fba",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1349",
    "licenseIssueDate": "03/13/2019 00:00:00",
    "licenseExpiryDate": "03/12/2026 00:00:00"
  },
  {
    "id": "deed2f3b-ec66-4d05-8c7a-56c0558b98de",
    "slug": "ali-mohamed-hasan-aljallaf",
    "name": "Ali Mohamed Hasan Aljallaf",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/09/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ali Mohamed Hasan Aljallaf",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_deed2f3b-ec66-4d05-8c7a-56c0558b98de",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "1417",
    "licenseIssueDate": "03/09/2020 00:00:00",
    "licenseExpiryDate": "03/08/2026 00:00:00"
  },
  {
    "id": "9e93c3f0-b367-458d-b01a-a21b03b8b980",
    "slug": "ali-mohamed-saif-aleter-aldhanhani",
    "name": "ALI MOHAMED SAIF M. AL ATAR",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/11/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ali Mohamed saif Aleter Aldhanhani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9e93c3f0-b367-458d-b01a-a21b03b8b980",
        "address": "ali mohamed saif ,مكتب 1501 ,داماس ,رقة البطين ,25900 ,Dubai",
        "phone": "97142555779 / 971553616616",
        "email": "info@aleter.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "9dd97fa5-b744-465f-bac7-8ab23b9eda4f",
    "firmName": "ALI ALETER ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-1126",
    "licenseIssueDate": "11/29/2016 00:00:00",
    "licenseExpiryDate": "11/28/2025 00:00:00"
  },
  {
    "id": "9457ba09-deb1-432a-bcc7-cca3ca0b1e5c",
    "slug": "ali-mohammad-ahmed-mahmood-rahimi-shahwari",
    "name": "QAIS ABDULWAHED MOHAMMED JASEM ALBLOOSHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/06/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ali Mohammad Ahmed Mahmood Rahimi Shahwari",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9457ba09-deb1-432a-bcc7-cca3ca0b1e5c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1677",
    "licenseIssueDate": "07/18/2022 00:00:00",
    "licenseExpiryDate": "07/17/2026 00:00:00"
  },
  {
    "id": "aa6a7c5a-26b1-4e73-a8c2-c744b098540b",
    "slug": "ali-mohammad-mahmood-bin-tamim",
    "name": "ALI MOHAMMAD MAHMOOD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 20,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/01/2005",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ali Mohammad Mahmood Bin Tamim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_aa6a7c5a-26b1-4e73-a8c2-c744b098540b",
        "address": "",
        "phone": "97142689978",
        "email": "info@abtadvo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "1b20a190-96ba-4853-9ea4-6233323402f4",
    "firmName": "ALI BIN TAMIM & CO ADVOCATES & LEGAL CONSULTANSY",
    "registrationNumber": "L-496",
    "licenseIssueDate": "01/10/2005 00:00:00",
    "licenseExpiryDate": "01/09/2026 00:00:00"
  },
  {
    "id": "38b98f66-2e7b-4da3-954b-ce671e9342e5",
    "slug": "ali-mohammed-ali-al-aidrous",
    "name": "ALI MOHAMMED OMAR ALAIDAROUS",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 32,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/04/1993",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ali Mohammed Ali Al-Aidrous",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_38b98f66-2e7b-4da3-954b-ce671e9342e5",
        "address": "Gamal Yassein Abdalla ,الطابق 13  Floor No 13 ,بناية مركز ابروي (The Oberoi Center) ,فندق ابروي (The Oberoi Hotel) ,33299 ,Dubai",
        "phone": "97142828000",
        "email": "litigation@alaidarous.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "9a923766-1fd1-4e06-a871-89662120384e",
    "firmName": "AL AIDAROUS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-256",
    "licenseIssueDate": "04/14/1993 00:00:00",
    "licenseExpiryDate": "04/13/2026 00:00:00"
  },
  {
    "id": "cf458c7c-28ea-41dd-b2dd-9d87bac8abca",
    "slug": "ali-mohammed-ali-al-dali",
    "name": "Ali Mohammed Ali Al-Dali",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 25,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/11/2000 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2019-10-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ali Mohammed Ali Al-Dali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cf458c7c-28ea-41dd-b2dd-9d87bac8abca",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "377",
    "licenseIssueDate": "04/11/2000 00:00:00",
    "licenseExpiryDate": "04/10/2019 00:00:00"
  },
  {
    "id": "2958c054-b9df-4ca0-8c38-cf1589292899",
    "slug": "ali-mohsin-saleh-suwaidan-alameri",
    "name": "ALI MOHSIN SALEH SUWAIDAN ALAMERI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/04/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ali Mohsin Saleh Suwaidan Alameri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2958c054-b9df-4ca0-8c38-cf1589292899",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1529",
    "licenseIssueDate": "04/29/2021 00:00:00",
    "licenseExpiryDate": "04/28/2026 00:00:00"
  },
  {
    "id": "1f6dcd5f-0729-4996-8fde-96553211fa32",
    "slug": "ali-mubarak-mohammed-alwesham-aljenaibi",
    "name": "ALI MUBARAK MOHD ALWESHAM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/04/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ali Mubarak Mohammed Alwesham Aljenaibi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1f6dcd5f-0729-4996-8fde-96553211fa32",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-753",
    "licenseIssueDate": "04/12/2011 00:00:00",
    "licenseExpiryDate": "04/11/2026 00:00:00"
  },
  {
    "id": "f74f0dfb-be7e-4926-bc47-e61eb5add29e",
    "slug": "ali-musabbah-ali-dhahi",
    "name": "ALI MUSABBAH ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Civil Transactions-POA & Sponsorship",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Criminal Law-Family Crimes",
      "Personal Status-Custody & Alimony",
      "Commercial Transactions-Commercial Contracts",
      "Civil Transactions-Immigration and Residency",
      "Commercial Transactions-Commercial Real Estate",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Criminal Law-Hate crimes",
      "Criminal Law-Crimes against persons",
      "Personal Status-Legacies and Inheritance",
      "Commercial Transactions-Commercial Companies",
      "Civil Transactions-Labor & Workers",
      "Criminal Law-Drug Crimes",
      "Proceedings-Cases and Proceedings before arbitral tribunals and other alternative dispute resolution bodies",
      "Personal Status-Marriage & Divorce",
      "Personal Status-Child Abuse & Abduction",
      "Civil Transactions-Compensation",
      "Criminal Law-Crimes against properties",
      "Criminal Law-Cybercrimes",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 19,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/05/2006",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ALI MUSABBAH ALI DHAHI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f74f0dfb-be7e-4926-bc47-e61eb5add29e",
        "address": "",
        "phone": "97143334212",
        "email": "secretary@alimusabbah.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "22d91b55-d8b8-4ccf-be32-aba1f5dea289",
    "firmName": "ALI MUSABBAH ADVOCATES & LEGEL CONSULTANTS",
    "registrationNumber": "L-565",
    "licenseIssueDate": "05/08/2006 00:00:00",
    "licenseExpiryDate": "05/07/2026 00:00:00"
  },
  {
    "id": "468f59be-c3a7-454b-be3d-0ac862414c35",
    "slug": "ali-naser-salem-ali-albusaeedi",
    "name": "AASYA EBRAHIM MOOSA ALMOOSA ALNUAI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/02/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ali Naser Salem Ali Albusaeedi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_468f59be-c3a7-454b-be3d-0ac862414c35",
        "address": "000000000 ,4 ,الريم  ,بلدية دبي  ,14593 ,Dubai",
        "phone": "97142276777",
        "email": "info@tglawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "593a5a42-a340-4daa-a8db-6d2673de29d5",
    "firmName": "ADVOCATES UNIT",
    "registrationNumber": "L-1772",
    "licenseIssueDate": "03/03/2023 00:00:00",
    "licenseExpiryDate": "04/22/2026 00:00:00"
  },
  {
    "id": "11d3fe68-3f8c-4eda-b99b-a240dbdd427c",
    "slug": "ali-obaid-humaid-obaid-alshamsi",
    "name": "ALI OBAID HUMAID OBAID ALSHAMSI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/05/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ali Obaid Humaid Obaid Alshamsi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_11d3fe68-3f8c-4eda-b99b-a240dbdd427c",
        "address": "1606 ,فندق الكونراد - برج المكاتب ,فندق الفيرمونت ,84333 ,Dubai",
        "phone": "97142218787 / 971505773332",
        "email": "info@alshamsilawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "fa7eb7e5-d5d3-404a-91ba-06a1efeb207e",
    "firmName": "ALI OBAID ALSHAMSI LAWYERS & LEGAL CONSULTANTS",
    "registrationNumber": "L-1079",
    "licenseIssueDate": "05/29/2016 00:00:00",
    "licenseExpiryDate": "05/28/2026 00:00:00"
  },
  {
    "id": "9a245904-6310-4205-a41c-dfa430730898",
    "slug": "ali-obaid-mohamed-sulaiman-alsuroomi",
    "name": "ALI OBAID MOHAMMED ALSUROOMI ALSHEMEILI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/04/2009",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ali Obaid Mohamed Sulaiman Alsuroomi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9a245904-6310-4205-a41c-dfa430730898",
        "address": "10th Floor ,AlReem Tower ,Dubai Land Department ,32367 ,Dubai",
        "phone": "97142272701",
        "email": "midfaadv@eim.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "fe9068a7-b94d-49bb-88b3-6f8491a15389",
    "firmName": "AL MIDFA & ASSOCIATES",
    "registrationNumber": "L-663",
    "licenseIssueDate": "04/16/2009 00:00:00",
    "licenseExpiryDate": "04/15/2026 00:00:00"
  },
  {
    "id": "8dcd4ccc-6929-4472-b680-2c2e8d3d57bc",
    "slug": "ali-rashed-saeed-nasser-al-dhaheri",
    "name": "ALI RASHED SAEED NASSER",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 23,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/02/2002",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ali Rashed Saeed Nasser Al Dhaheri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8dcd4ccc-6929-4472-b680-2c2e8d3d57bc",
        "address": "4th Floor/ Office no. 401 ,Business Avenue  ,Infront- Terminal 2  ,115263 ,Dubai",
        "phone": "97144518866",
        "email": "info@aldhaheriinternational.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "cf3c19c0-d396-4bcb-b1db-b81273ed0b4c",
    "firmName": "AL DHAHERI INTERNATIONAL ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-420",
    "licenseIssueDate": "02/12/2002 00:00:00",
    "licenseExpiryDate": "02/11/2026 00:00:00"
  },
  {
    "id": "6156d210-0c78-4015-9061-66d6f6ce9f0c",
    "slug": "ali-rashid-ali-saif-almansoori",
    "name": "ABDUL RAHMAN ABDULLA QASSEM M ALUDAINI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/07/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ali Rashid Ali Saif Almansoori",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6156d210-0c78-4015-9061-66d6f6ce9f0c",
        "address": "YOUNIS MOHAMMED ALBLOOSHI ,3 - 1 ,the icon ,السيلكون ,117548 ,Dubai",
        "phone": "97145693206 / 971000000000",
        "email": "info@yblooshiadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "27278b02-4edf-490f-9d50-a1bc00678b6a",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1843",
    "licenseIssueDate": "08/16/2023 00:00:00",
    "licenseExpiryDate": "08/15/2026 00:00:00"
  },
  {
    "id": "60e214ee-446d-416a-a04d-74a4a34ebdb3",
    "slug": "ali-saeed-ali-abdelrahman-alnaqbi",
    "name": "ALI SAEED ALI ABDELRAHMAN ALNAQBI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/03/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ali Saeed Ali Abdelrahman Alnaqbi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_60e214ee-446d-416a-a04d-74a4a34ebdb3",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-696",
    "licenseIssueDate": "03/10/2020 00:00:00",
    "licenseExpiryDate": "03/09/2026 00:00:00"
  },
  {
    "id": "ba5ab0df-2943-4e3d-9fb2-f4c74a671e8f",
    "slug": "ali-saeed-essa-al-falasi",
    "name": "Ali Saeed Essa Al Falasi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 27,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/14/1998 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ali Saeed Essa Al Falasi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ba5ab0df-2943-4e3d-9fb2-f4c74a671e8f",
        "address": "",
        "phone": "97143456345 / 971582878951",
        "email": "alfalasi_advocates@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "eb1babc3-0723-4d8e-a69c-728a5dcce69e",
    "firmName": "AL FALASI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "178",
    "licenseIssueDate": "07/14/1998 00:00:00",
    "licenseExpiryDate": "07/13/2026 00:00:00"
  },
  {
    "id": "c33f32de-23ec-4347-96d4-f26ee4943626",
    "slug": "ali-saeed-rashed-ali-alhefeiti",
    "name": "ALI SAEED RASHED ALI ALHEFEITI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/01/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ali Saeed Rashed Ali Alhefeiti",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c33f32de-23ec-4347-96d4-f26ee4943626",
        "address": "6F 603, 605, 7F 704 ,Crystal Tower ,Dubai Mall ,117538 ,Dubai",
        "phone": "97146098700",
        "email": "pro@miolawfirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "417f90a1-03be-4dab-8eea-1bba7e16f536",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1247",
    "licenseIssueDate": "01/24/2018 00:00:00",
    "licenseExpiryDate": "01/23/2026 00:00:00"
  },
  {
    "id": "fef43990-fc39-4c89-b5e4-3e12a43439a0",
    "slug": "ali-saif-mohamed-amin-al-khajah",
    "name": "Ali Saif Mohamed Amin Al Khajah",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/01/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ali Saif Mohamed Amin Al Khajah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fef43990-fc39-4c89-b5e4-3e12a43439a0",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "1143",
    "licenseIssueDate": "02/01/2017 00:00:00",
    "licenseExpiryDate": "01/31/2026 00:00:00"
  },
  {
    "id": "58c69a09-df26-4d5f-902f-a0e1bc93fe74",
    "slug": "ali-saleh-abdulrasool-abdulla-al-showab",
    "name": "ALI SALEH ABDULLRASOUL ABDULLA ALSHOWAB",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/03/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ali Saleh Abdulrasool Abdulla Al Showab",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_58c69a09-df26-4d5f-902f-a0e1bc93fe74",
        "address": "",
        "phone": "97144205111",
        "email": "info@showab.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "8b17fa0a-9280-4fda-9e0e-dd7a826edb51",
    "firmName": "ALI ALSHOWAB ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-132",
    "licenseIssueDate": "03/17/2015 00:00:00",
    "licenseExpiryDate": "03/16/2026 00:00:00"
  },
  {
    "id": "08abca9e-6818-4c91-97ea-1bbae3a087f9",
    "slug": "ali-salim-obaid-alkhayyal-alali",
    "name": "ALI SALIM OBAID ALKHAYYAL AL ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/02/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ali salim obaid alkhayyal alali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_08abca9e-6818-4c91-97ea-1bbae3a087f9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1411",
    "licenseIssueDate": "02/20/2020 00:00:00",
    "licenseExpiryDate": "02/19/2026 00:00:00"
  },
  {
    "id": "2b24148c-c02b-45ce-9213-f614934e9905",
    "slug": "ali-sayed-abdulla-sayed-ibrahim-al-hashimi",
    "name": "ALI SAYED ABDULLA SAYED IBRAHIM ALHASHIMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 25,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/11/1999",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ali Sayed Abdulla Sayed Ibrahim Al-Hashimi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2b24148c-c02b-45ce-9213-f614934e9905",
        "address": "21 ,Rolex Tower ,Emirates Grand Hotel ,94334 ,Dubai",
        "phone": "97143277772 / 97145584900",
        "email": "info@globaladvocates.net",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "9b42810f-1d55-4aea-ac4a-7d9d1b25ac08",
    "firmName": "GLOBAL ADVOCACY & LEGAL COUNSEL",
    "registrationNumber": "L-368",
    "licenseIssueDate": "11/20/1999 00:00:00",
    "licenseExpiryDate": "11/19/2025 00:00:00"
  },
  {
    "id": "cfd92d1a-2409-4876-91e9-fc280cade887",
    "slug": "ali-sulaiman-abdalla-alaqeed-alnaqbi",
    "name": "ALI SULAIMAN ABDALLA ALAQEED ALNAQBI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/10/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ali Sulaiman Abdalla Alaqeed Alnaqbi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cfd92d1a-2409-4876-91e9-fc280cade887",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-654",
    "licenseIssueDate": "11/01/2017 00:00:00",
    "licenseExpiryDate": "10/31/2025 00:00:00"
  },
  {
    "id": "95eafa4b-56c3-485a-a8b8-7deee5b8410b",
    "slug": "ali-sultan-ali-al-haddad",
    "name": "ALI SULTAN ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 27,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/11/1997",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-11-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ali Sultan Ali Al-Haddad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_95eafa4b-56c3-485a-a8b8-7deee5b8410b",
        "address": "",
        "phone": "97143311224",
        "email": "info@alhaddadco.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "d9edc27e-b886-4495-9c20-11ed3c12f407",
    "firmName": "AL HADDAD & ASSOCIATES - ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-313",
    "licenseIssueDate": "11/09/1997 00:00:00",
    "licenseExpiryDate": "11/08/2025 00:00:00"
  },
  {
    "id": "97dab9c8-d635-4dae-a897-ab4c9e7c33fb",
    "slug": "ali-sultan-humaid-qadib-alali",
    "name": "ALI SULTAN HUMAID QADIB AL-ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/02/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ali sultan humaid qadib alali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_97dab9c8-d635-4dae-a897-ab4c9e7c33fb",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1507",
    "licenseIssueDate": "02/19/2021 00:00:00",
    "licenseExpiryDate": "02/18/2026 00:00:00"
  },
  {
    "id": "98a9a0f0-b98d-447c-b3f5-dc89d4a1f70d",
    "slug": "ali-sultan-salim-alkindi",
    "name": "Ali Sultan Salim Alkindi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/12/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ali Sultan Salim Alkindi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_98a9a0f0-b98d-447c-b3f5-dc89d4a1f70d",
        "address": "Mohammad Al Mheiri ,الاول ,امارات اتريم  ,شارع الشيخ زايد ,37979 ,Dubai",
        "phone": "97143333405",
        "email": "info@al-mheiri.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "455b5977-b40f-4801-b6bf-70838bb69abe",
    "firmName": "MOHAMMAD ALMEIHRI ADVOCATES & LEGAL CONSULTAN",
    "registrationNumber": "749",
    "licenseIssueDate": "04/12/2011 00:00:00",
    "licenseExpiryDate": "04/11/2026 00:00:00"
  },
  {
    "id": "2db1652e-ccfd-418f-bc55-a32239f6d022",
    "slug": "ali-yousuf-abdulla-abdulraheem-alawadhi",
    "name": "AHMAD ABDULWAHAB AHMAD ALFILI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/11/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-11-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ali Yousuf Abdulla Abdulraheem Alawadhi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2db1652e-ccfd-418f-bc55-a32239f6d022",
        "address": "",
        "phone": "97122222222",
        "email": "info@ayalegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "843234aa-d59b-4763-b69a-ba92f9cbba70",
    "firmName": "ALMASA ADVOCATES",
    "registrationNumber": "L-2047",
    "licenseIssueDate": "11/22/2024 00:00:00",
    "licenseExpiryDate": "11/21/2025 00:00:00"
  },
  {
    "id": "821d39e8-a99d-41ec-a237-8f2c9299e7f5",
    "slug": "alia-abdulla-mubarak-al-dhahri",
    "name": "Alia Abdulla Mubarak Al dhahri",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/04/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Alia Abdulla Mubarak Al dhahri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_821d39e8-a99d-41ec-a237-8f2c9299e7f5",
        "address": "",
        "phone": "97142659440",
        "email": "info@klaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "d42ce31f-e881-40e1-bd66-bf2e5bb9bb1e",
    "firmName": "KHALED ALMARRI & PARTNERS& LEGAL CONSULTATION",
    "registrationNumber": "1904",
    "licenseIssueDate": "01/04/2024 00:00:00",
    "licenseExpiryDate": "01/03/2026 00:00:00"
  },
  {
    "id": "2679a1ec-80dc-4ac2-ab25-cc14dbbfb959",
    "slug": "alia-ahmed-adbulrahim-atattar",
    "name": "ALIA AHMED ABDULRAHIM ALATTAR",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/08/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: alia ahmed adbulrahim atattar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2679a1ec-80dc-4ac2-ab25-cc14dbbfb959",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1558",
    "licenseIssueDate": "08/26/2021 00:00:00",
    "licenseExpiryDate": "08/25/2026 00:00:00"
  },
  {
    "id": "6a4b40a2-0e89-4edd-a273-e92e2d835462",
    "slug": "alia-habib-mohammad-sharif-almulla",
    "name": "ALIA HABIB MOHD SHARIF ABDULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/05/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Alia Habib Mohammad Sharif Almulla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6a4b40a2-0e89-4edd-a273-e92e2d835462",
        "address": "",
        "phone": "97144230000 / 971552009022",
        "email": "UAE-CourtClerks@habibalmulla.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "3eba82bb-8ec4-4cbd-80d0-a793cb993fde",
    "firmName": "HABIB ALMULLA & PARTNERS",
    "registrationNumber": "L-1078",
    "licenseIssueDate": "05/29/2016 00:00:00",
    "licenseExpiryDate": "05/28/2026 00:00:00"
  },
  {
    "id": "4d2cd41a-53be-4fe2-a8bb-7a7bda6c0f23",
    "slug": "aliaa-saeed-saif-alebri",
    "name": "ADEL MOHAMMED MOOSA TAHER ALBLOOSHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/11/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ALIAA SAEED SAIF ALEBRI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4d2cd41a-53be-4fe2-a8bb-7a7bda6c0f23",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1724",
    "licenseIssueDate": "11/21/2022 00:00:00",
    "licenseExpiryDate": "11/20/2025 00:00:00"
  },
  {
    "id": "da3876cf-240a-4589-a17f-52b1aeaf418c",
    "slug": "alma-atef-ahmad-helwa",
    "name": "YOUSUF SAEED MUBARAK",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/05/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Alma atef Ahmad Helwa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_da3876cf-240a-4589-a17f-52b1aeaf418c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1659",
    "licenseIssueDate": "05/25/2022 00:00:00",
    "licenseExpiryDate": "05/24/2026 00:00:00"
  },
  {
    "id": "34942b1e-d2bb-4020-bbc1-fd222fad13b4",
    "slug": "almothanna-mohamed-ali-ahmed-alramsi",
    "name": "ALMOTHANNA MOHAMED ALI AHMED ALRAMSI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/02/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Almothanna Mohamed Ali Ahmed Alramsi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_34942b1e-d2bb-4020-bbc1-fd222fad13b4",
        "address": "",
        "phone": "97143368833",
        "email": "alkhouli@alkhoulilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "0188c41d-cec9-4993-8610-23001bfcf8a7",
    "firmName": "ADVOCATES UNIT",
    "registrationNumber": "L-856",
    "licenseIssueDate": "02/10/2013 00:00:00",
    "licenseExpiryDate": "02/09/2026 00:00:00"
  },
  {
    "id": "de92aba6-3c24-476a-9ad2-d902110aa764",
    "slug": "alonood-yaqoob-yousuf-mohammed-alshamsi",
    "name": "Alonood Yaqoob Yousuf Mohammed Alshamsi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/14/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Alonood Yaqoob Yousuf Mohammed Alshamsi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_de92aba6-3c24-476a-9ad2-d902110aa764",
        "address": "21 ,Rolex Tower ,Emirates Grand Hotel ,94334 ,Dubai",
        "phone": "97143277772 / 97145584900",
        "email": "info@globaladvocates.net",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "9b42810f-1d55-4aea-ac4a-7d9d1b25ac08",
    "firmName": "GLOBAL ADVOCACY & LEGAL COUNSEL",
    "registrationNumber": "1666",
    "licenseIssueDate": "06/14/2022 00:00:00",
    "licenseExpiryDate": "06/13/2026 00:00:00"
  },
  {
    "id": "188588f4-2c25-4341-99b6-0f6eae36a8bd",
    "slug": "alunood-ali-saeed-ham-abdulla",
    "name": "RAFEEAH SAEED ALI SALEM ALSHEHHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/04/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Alunood Ali Saeed Ham Abdulla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_188588f4-2c25-4341-99b6-0f6eae36a8bd",
        "address": "",
        "phone": "97143212555",
        "email": "awigdubai@awiglaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "ece8ea60-9ecb-4d8c-aca3-fb73e4e52406",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1939",
    "licenseIssueDate": "04/24/2024 00:00:00",
    "licenseExpiryDate": "04/23/2026 00:00:00"
  },
  {
    "id": "00398e7b-a066-4a94-b5a7-7c3cc992040a",
    "slug": "alwiya-shaker-sayed-hussain-s-shubber-s-alawi",
    "name": "MOHAMED ALI AHMED ABDULLA OBAID",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/08/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: alwiya shaker sayed hussain s shubber s alawi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_00398e7b-a066-4a94-b5a7-7c3cc992040a",
        "address": "sohail jassem pararin ,34 ,Central Park Tower ,Dubai Mall ,233066 ,Dubai",
        "phone": "97144228410",
        "email": "info@mahmoodhussain.net",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "f3309481-3edd-4503-92d2-bd9f71ba513a",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1864",
    "licenseIssueDate": "09/19/2023 00:00:00",
    "licenseExpiryDate": "09/18/2026 00:00:00"
  },
  {
    "id": "9da34c5d-b50d-4c88-a0f0-85ecfc21dae1",
    "slug": "alya-abdulla-khaleel-ali-almarzooqi",
    "name": "ALYA ABDULLA KHALEEL ALI ALMARZOOQI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/03/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Alya Abdulla khaleel ali almarzooqi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9da34c5d-b50d-4c88-a0f0-85ecfc21dae1",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1521",
    "licenseIssueDate": "03/31/2021 00:00:00",
    "licenseExpiryDate": "03/30/2026 00:00:00"
  },
  {
    "id": "cd94243e-8c2d-4bc8-8a45-a506e2984e48",
    "slug": "alya-ali-husain-gheloum-ali-al-attar",
    "name": "ALYA ALI HUSSAIN ALATTAR",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 21,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/02/2004",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Alya Ali Husain Gheloum Ali Al-Attar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cd94243e-8c2d-4bc8-8a45-a506e2984e48",
        "address": "",
        "phone": "97142989455",
        "email": "adv_nasr@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "4bf6169e-af5d-43e6-867c-8219fdfb27b1",
    "firmName": "ALNASR OFFCE ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-479",
    "licenseIssueDate": "02/28/2004 00:00:00",
    "licenseExpiryDate": "02/27/2026 00:00:00"
  },
  {
    "id": "824bad65-ce5c-43ae-bd44-dfc9718534eb",
    "slug": "alya-ali-saleh-hayya-alaleeli",
    "name": "KHAMIS RASHED K R ALMUKHAINI ALJNEIBE",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/05/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Alya Ali Saleh Hayya Alaleeli",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_824bad65-ce5c-43ae-bd44-dfc9718534eb",
        "address": "Adel Salem Abdulla Salem Alghafri ,16th floor, Office: 1602 ,Aspect Tower ,Bay Avenue Mall ,444470 ,Dubai",
        "phone": "97142807052 / 971555666589",
        "email": "info@adelalghafri.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "d0789ea6-22d2-4893-aa99-e55ff1b4473a",
    "firmName": "NAWAL SALEM SAEED ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1964",
    "licenseIssueDate": "05/22/2024 00:00:00",
    "licenseExpiryDate": "05/21/2026 00:00:00"
  },
  {
    "id": "87d780ca-909c-4b88-8511-c7d0f80d3a16",
    "slug": "alya-khalifa-salim-khalifa-alsuwaidi",
    "name": "ALYA KHALIFA SALIM KHALIFA ALSUWAIDI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/01/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Alya Khalifa Salim Khalifa Alsuwaidi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_87d780ca-909c-4b88-8511-c7d0f80d3a16",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-848",
    "licenseIssueDate": "01/10/2013 00:00:00",
    "licenseExpiryDate": "01/09/2026 00:00:00"
  },
  {
    "id": "46055e55-1433-4210-bb34-a0ca176b340e",
    "slug": "alya-salem-saeed-bin-sulaiman-alnuaimi",
    "name": "SALEM SAEED ABDULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/01/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Alya Salem Saeed Bin Sulaiman Alnuaimi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_46055e55-1433-4210-bb34-a0ca176b340e",
        "address": "",
        "phone": "97143422244 / 97143422244",
        "email": "info@maryamwejdan.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "fc7bbac7-d29b-4486-8335-92c217bfd653",
    "firmName": "MARYAM HAYYAZ & WEJDAN BUSHAHAB ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1174",
    "licenseIssueDate": "01/11/2022 00:00:00",
    "licenseExpiryDate": "01/10/2026 00:00:00"
  },
  {
    "id": "0058b957-b564-4c1d-9afc-5387c3857956",
    "slug": "alyaa-obadi-saeed-obaid-al-hefiti",
    "name": "alyaa obadi saeed obaid al hefiti",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/13/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: alyaa obadi saeed obaid al hefiti",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0058b957-b564-4c1d-9afc-5387c3857956",
        "address": "الطابق 8 مكتب رقم 802-804 ,AL MASAOOD TOWE 2 ,الفطيم للسيارات  - ديرة  ,31909 ,Dubai",
        "phone": "97142946948",
        "email": "hadi.jomah@baitulhikma.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "a1a1a791-7d0a-4afa-a043-cd85f0998888",
    "firmName": "BAITULHIKMA LAWYERS",
    "registrationNumber": "2040",
    "licenseIssueDate": "11/13/2024 00:00:00",
    "licenseExpiryDate": "11/12/2025 00:00:00"
  },
  {
    "id": "d6ec92aa-fb18-4d89-9e1f-bcee8744e1ec",
    "slug": "alyazia-mohammed-helal-arar-aldhaheri",
    "name": "AZBA HASAN HAMAD ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/11/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-11-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Alyazia Mohammed Helal Arar Aldhaheri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d6ec92aa-fb18-4d89-9e1f-bcee8744e1ec",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1894",
    "licenseIssueDate": "12/11/2023 00:00:00",
    "licenseExpiryDate": "12/10/2025 00:00:00"
  },
  {
    "id": "bd030179-371d-4faa-af49-ddb88f655ef7",
    "slug": "alyazia-suhail-hareb-alnuaimi",
    "name": "FATMA ABDULLA MOHAMMAD SULAIMAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/03/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: alyazia suhail hareb alnuaimi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bd030179-371d-4faa-af49-ddb88f655ef7",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1646",
    "licenseIssueDate": "04/10/2022 00:00:00",
    "licenseExpiryDate": "04/09/2026 00:00:00"
  },
  {
    "id": "7e2263de-096b-4b86-9a78-790c8cd6bb4f",
    "slug": "alyzia-rashed-khamus-alsubousi",
    "name": "ABDULRAHMAN ABDULRAZZAQ MOHAMED AHMAD ALQASSEM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/02/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-02-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Alyzia rashed khamus alsubousi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7e2263de-096b-4b86-9a78-790c8cd6bb4f",
        "address": "SALMA SAEED MUSABBEH ALKETBI  ,الطابق الثالث ,بيراميد سنتر  ,وافي مول ,117452 ,Dubai",
        "phone": "97145484741 / 971508981112",
        "email": "info@salketbi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "aaf3cbd8-7acd-4f76-b9b5-6a5794e8de26",
    "firmName": "HABIB ALMULLA & PARTNERS",
    "registrationNumber": "L-1770",
    "licenseIssueDate": "03/02/2023 00:00:00",
    "licenseExpiryDate": "03/01/2026 00:00:00"
  },
  {
    "id": "38f68e88-c3e5-4524-a664-d8338ecb7d51",
    "slug": "amal-ahmad-essa-taher-alblooshi",
    "name": "SULAIMAN MOHAMED MOHAMED M ABDOH",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/02/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-02-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Amal  Ahmad Essa Taher Alblooshi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_38f68e88-c3e5-4524-a664-d8338ecb7d51",
        "address": "",
        "phone": "97142222282",
        "email": "N.moosaa@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "ca27884c-48bb-4c1a-bcba-dd4c938fe85b",
    "firmName": "ARAA GROUP ADVOCATE & LEGAL CONSULTANCY",
    "registrationNumber": "L-1922",
    "licenseIssueDate": "03/04/2024 00:00:00",
    "licenseExpiryDate": "03/03/2026 00:00:00"
  },
  {
    "id": "a85b4da7-467a-469a-844d-c2f3a3344a98",
    "slug": "amal-abdulla-ali-alhammadi",
    "name": "AMAL ABDULLA ALI ALHAMMADI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/05/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: amal abdulla ali alhammadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a85b4da7-467a-469a-844d-c2f3a3344a98",
        "address": "",
        "phone": "97143333386 / 971549916936",
        "email": "info@mtaadv.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "466f3ad4-73e1-44db-b8ec-b01e829d77c4",
    "firmName": "MOHAMMED ALLINJAWI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1978",
    "licenseIssueDate": "05/31/2024 00:00:00",
    "licenseExpiryDate": "05/30/2026 00:00:00"
  },
  {
    "id": "3387a40d-ae16-4535-bb12-35d05faac660",
    "slug": "amal-abdulla-salem-saeed-alrashdi",
    "name": "Amal Abdulla Salem Saeed Alrashdi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/12/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Amal Abdulla Salem Saeed Alrashdi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3387a40d-ae16-4535-bb12-35d05faac660",
        "address": "",
        "phone": "97142414303",
        "email": "info@eslegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "eb927a69-9421-4515-bc18-08b71fb44bb2",
    "firmName": "AMAL AL RASHDI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-747",
    "licenseIssueDate": "12/15/2023 00:00:00",
    "licenseExpiryDate": "12/14/2025 00:00:00"
  },
  {
    "id": "bd652fc5-12cb-4028-ba29-0f414eb4dc35",
    "slug": "amal-ahmed-abdulla-khamis-alameri",
    "name": "KHALID JUMA ABDULLA MOHAMED ALSUWAIDI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/07/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Amal Ahmed Abdulla khamis alameri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bd652fc5-12cb-4028-ba29-0f414eb4dc35",
        "address": "Samia Luqman ,2nd floor ,Emarat Atrium Building ,across Holiday Inn Express Safa Park ,7273 ,Dubai",
        "phone": "97143211000",
        "email": "info@alsuwaidi.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "0e5c3637-bc12-475c-a6b5-2d9ae84f2b8e",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1683",
    "licenseIssueDate": "08/08/2022 00:00:00",
    "licenseExpiryDate": "08/07/2026 00:00:00"
  },
  {
    "id": "ad218ef1-0321-4b8e-abf7-2862714afbc4",
    "slug": "amal-hassan-mohamed-haji-karam",
    "name": "HASSAN MOHD HAJI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/01/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: AMAL HASSAN MOHAMED HAJI KARAM",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ad218ef1-0321-4b8e-abf7-2862714afbc4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1332",
    "licenseIssueDate": "01/03/2019 00:00:00",
    "licenseExpiryDate": "01/02/2026 00:00:00"
  },
  {
    "id": "f1892da4-5837-4aa5-ba5f-dc500bdfd12b",
    "slug": "amal-ibrahim-abdulla-kamal-poor-albastaki",
    "name": "AMAL IBRAHIM ABDULLA KAMAL POOR ALBASTAKI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/02/2009",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Amal Ibrahim Abdulla Kamal Poor Albastaki",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f1892da4-5837-4aa5-ba5f-dc500bdfd12b",
        "address": "amal albastaki ,1903 ,court ,business bay ,127477 ,Dubai",
        "phone": "97142522202",
        "email": "info@amaladvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "f852bccd-2696-4190-9b40-77a8fb9c460f",
    "firmName": "AMAL ALBASTAKI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-649",
    "licenseIssueDate": "02/16/2009 00:00:00",
    "licenseExpiryDate": "02/15/2026 00:00:00"
  },
  {
    "id": "0d186773-e9ad-42c5-a103-2f10fbcd7142",
    "slug": "amal-khamis-darwish-mohd-al-balooshi",
    "name": "AMAL KHAMIS DARWISH MOHAMMAD ALBLOOSHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/03/2009",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Amal Khamis Darwish Mohd Al Balooshi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0d186773-e9ad-42c5-a103-2f10fbcd7142",
        "address": "Amal Khamis Darwish Al Blooshi ,floor23-office2304 ,Aspect Tower ,Bay Avenue ,103951 ,Dubai",
        "phone": "97142276165",
        "email": "info@amalkhamisadvo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "99eb0f0c-7559-4826-a035-6f38ef3676a9",
    "firmName": "AMAL KHAMIS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-655",
    "licenseIssueDate": "03/30/2009 00:00:00",
    "licenseExpiryDate": "03/29/2026 00:00:00"
  },
  {
    "id": "7521c6e3-d69d-4916-b12b-30435fa7dc59",
    "slug": "amal-mohamed-sabhe-shaik-omar",
    "name": "AMAL MOHAMED W/O KHALFAN SAEED K.ALQEMZI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/05/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Amal Mohamed Sabhe Shaik Omar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7521c6e3-d69d-4916-b12b-30435fa7dc59",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1282",
    "licenseIssueDate": "05/13/2018 00:00:00",
    "licenseExpiryDate": "05/12/2026 00:00:00"
  },
  {
    "id": "4c99c687-605f-4a6a-a949-f5f8940d3211",
    "slug": "amal-nazeeh-abdullah-mutlaq",
    "name": "Amal Nazeeh Abdullah Mutlaq",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/07/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Amal Nazeeh Abdullah Mutlaq",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4c99c687-605f-4a6a-a949-f5f8940d3211",
        "address": "1201 ,برج تريو اي بي اي اوفيس  ,فندق نوافتيل ,8812 ,Dubai",
        "phone": "97144222555",
        "email": "lutfilaw2020@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "9a3d884b-a443-4037-9eb4-f810c596cf33",
    "firmName": "LUTFI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "1981",
    "licenseIssueDate": "06/07/2024 00:00:00",
    "licenseExpiryDate": "06/06/2026 00:00:00"
  },
  {
    "id": "8f7eb5ed-5d1e-4fba-879d-bdab820f1a81",
    "slug": "amal-omair-ali-albakri-alsebeyi",
    "name": "AMAL OMAIR W O SAEED ERHAMA ALFALASI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 21,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/02/2004",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Amal Omair Ali Albakri Alsebeyi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8f7eb5ed-5d1e-4fba-879d-bdab820f1a81",
        "address": "1302/ مكتب 1302 ,فندق الفيرمونت ,محطة مترو المركز التجاري ,33026 ,Dubai",
        "phone": "97143586113",
        "email": "info@ablawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "f04c12ed-cc71-442c-b504-173bbb4d322f",
    "firmName": "AMAL ALSUBAEI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-478",
    "licenseIssueDate": "02/28/2004 00:00:00",
    "licenseExpiryDate": "02/27/2026 00:00:00"
  },
  {
    "id": "dd1bf740-9b33-4ced-a2fd-9a26b5f4dd04",
    "slug": "amal-qaid-nasser-alqamesh",
    "name": "Amal qaid nasser alqamesh",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/22/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Amal qaid nasser alqamesh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dd1bf740-9b33-4ced-a2fd-9a26b5f4dd04",
        "address": "fahad alhosani ,Office No. 1006 ,ASPECT TOWER ,Near Burj Khalifa ,000 ,Dubai",
        "phone": "97100000000 / 971551111723",
        "email": "info@fahadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "aea24945-594d-49dd-8077-830efa5e95ff",
    "firmName": "FAHAD ALHOSANI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "2036",
    "licenseIssueDate": "10/22/2024 00:00:00",
    "licenseExpiryDate": "10/21/2025 00:00:00"
  },
  {
    "id": "c0d8e867-0fec-4a60-a74b-8f7e53e10347",
    "slug": "amal-saeed-rashed-jasem-alzaabi",
    "name": "AMAL SAEED RASHED J ALZAABI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/10/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-10-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Amal Saeed Rashed Jasem Alzaabi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c0d8e867-0fec-4a60-a74b-8f7e53e10347",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-844",
    "licenseIssueDate": "10/18/2018 00:00:00",
    "licenseExpiryDate": "10/17/2026 00:00:00"
  },
  {
    "id": "b4e5d380-303c-4ae9-88d1-478656243a99",
    "slug": "amani-abdalla-ali-abdalla-alkindi",
    "name": "AMANI ABDALLA ALI ABDALLA ALKINDI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/05/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Amani Abdalla Ali Abdalla Alkindi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b4e5d380-303c-4ae9-88d1-478656243a99",
        "address": "",
        "phone": "97148328997",
        "email": "info@alkindiadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "27ee82c9-8f98-4b21-b9be-2de8fe329b61",
    "firmName": "AMANI ALKINDI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1184",
    "licenseIssueDate": "05/07/2017 00:00:00",
    "licenseExpiryDate": "05/06/2026 00:00:00"
  },
  {
    "id": "e328ed1b-b43b-449d-8e98-9ff8bdd802b5",
    "slug": "amani-ibrahim-khalifa-mohammed-alsaeedi",
    "name": "AMANI IBRAHIM KHALIFA MOHAMMED ALSAEEDI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/02/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Amani Ibrahim Khalifa Mohammed alsaeedi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e328ed1b-b43b-449d-8e98-9ff8bdd802b5",
        "address": "901-902 ,برج السلام ,فندق جراند شيراتون ,2741291443 ,Dubai",
        "phone": "97145877794 / 971586606660",
        "email": "obh@obhlawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "edbb7814-39f9-4ec9-b01d-9de1117e343e",
    "firmName": "OMAR KHALIFA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-935",
    "licenseIssueDate": "02/12/2025 00:00:00",
    "licenseExpiryDate": "02/11/2026 00:00:00"
  },
  {
    "id": "7f728093-eefc-4908-8630-8ab0062e75cf",
    "slug": "ameena-ahmed-hasan-mubarak-alahmed",
    "name": "NASSER HUMAID ABDULLA HUMAID",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/03/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: AMEENA AHMED HASAN MUBARAK ALAHMED",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7f728093-eefc-4908-8630-8ab0062e75cf",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-2086",
    "licenseIssueDate": "04/08/2025 00:00:00",
    "licenseExpiryDate": "04/07/2026 00:00:00"
  },
  {
    "id": "593ce425-a3ff-4129-addd-d11ca6e4c0f6",
    "slug": "ameera-juma-saeed-sbait-alkaabi",
    "name": "FATMA MOHD W O SALAH HUSSAIN TAHLAK",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/06/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ameera juma saeed sbait alkaabi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_593ce425-a3ff-4129-addd-d11ca6e4c0f6",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1991",
    "licenseIssueDate": "06/24/2024 00:00:00",
    "licenseExpiryDate": "06/23/2026 00:00:00"
  },
  {
    "id": "ed465960-0b84-48c8-9761-abb8f041bf0a",
    "slug": "ameera-salem-mubarak-hamad-ali-al-junaibi",
    "name": "SUOOD AHMED ALI BEEBI ALSHEHHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/01/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ameera salem mubarak hamad ali al junaibi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ed465960-0b84-48c8-9761-abb8f041bf0a",
        "address": "Amal Khamis Darwish Al Blooshi ,floor23-office2304 ,Aspect Tower ,Bay Avenue ,103951 ,Dubai",
        "phone": "97142276165",
        "email": "info@amalkhamisadvo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "99eb0f0c-7559-4826-a035-6f38ef3676a9",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1754",
    "licenseIssueDate": "02/09/2023 00:00:00",
    "licenseExpiryDate": "02/08/2026 00:00:00"
  },
  {
    "id": "10b4553b-e7c5-4017-a087-94aaecb01bb2",
    "slug": "amena-ali-salem-bin-mahri-alkatheeri",
    "name": "AMMAR ABDULLA ABDULRAHMAN MOHAMMED ALSAEEDI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/10/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: AMENA ALI SALEM BIN MAHRI ALKATHEERI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_10b4553b-e7c5-4017-a087-94aaecb01bb2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1876",
    "licenseIssueDate": "10/20/2023 00:00:00",
    "licenseExpiryDate": "10/19/2025 00:00:00"
  },
  {
    "id": "4d65c095-cfca-4398-9e99-cdede626aa9e",
    "slug": "amer-sayed-mohammed-sayed-muhi-ruushin-al-marzooqi",
    "name": "AMER S MOHAMMED S M RUUSHIN AL MARZOOQI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 15,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/04/2010",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Amer Sayed Mohammed Sayed Muhi Ruushin Al Marzooqi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4d65c095-cfca-4398-9e99-cdede626aa9e",
        "address": "Amer Sayed Al Marzooqi ,603 ,SAMA TOWER ,TRADE CENTER ,41727 ,Dubai",
        "phone": "97142500023",
        "email": "info@mlegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "7ed7234c-a176-47f9-b66e-18524305fe3e",
    "firmName": "AMER AL MARZOOQI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-707",
    "licenseIssueDate": "04/19/2010 00:00:00",
    "licenseExpiryDate": "04/18/2026 00:00:00"
  },
  {
    "id": "789d2230-62bb-40ed-809a-b4ee9a57c61d",
    "slug": "amina-ali-jafar-ali-binjafar",
    "name": "AMINA ALI JAFAR ALI BIN JAFAR",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/01/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Amina Ali Jafar Ali Binjafar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_789d2230-62bb-40ed-809a-b4ee9a57c61d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1076",
    "licenseIssueDate": "01/19/2023 00:00:00",
    "licenseExpiryDate": "01/18/2026 00:00:00"
  },
  {
    "id": "7944e008-c58b-4931-9d51-e9f8c9301a0c",
    "slug": "amir-mohd-yousuf-alkhaja",
    "name": "Amir MOHD Yousuf Alkhaja",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/12/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-11-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Amir MOHD Yousuf Alkhaja",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7944e008-c58b-4931-9d51-e9f8c9301a0c",
        "address": "",
        "phone": "97144230000 / 971552009022",
        "email": "UAE-CourtClerks@habibalmulla.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "3eba82bb-8ec4-4cbd-80d0-a793cb993fde",
    "firmName": "Habib Al Mulla & Partners ADVOCATES & LEGAL C",
    "registrationNumber": "989",
    "licenseIssueDate": "02/12/2015 00:00:00",
    "licenseExpiryDate": "02/11/2026 00:00:00"
  },
  {
    "id": "fcd8ffb2-81e2-418a-a8fa-0c746b8299d1",
    "slug": "amira-ibrahim-abdoulla-abdulwahid-kamal-poor-albastaki",
    "name": "AMIRA IBRAHIM ABDULLA A KAMAL POOR",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 18,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/03/2007",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Amira Ibrahim Abdoulla Abdulwahid Kamal Poor AlBastaki",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fcd8ffb2-81e2-418a-a8fa-0c746b8299d1",
        "address": "11 ,ميلينيوم بلازا  ,بجوار محطة ابراج الأمارات  ,410961 ,Dubai",
        "phone": "97142954626",
        "email": "info@advoamira.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "09f7b67c-8405-4dc9-982f-b8f9b921043c",
    "firmName": "DR AMIRA Al BASTAKI ADVOCATES AND LEGAL CONSULTANT",
    "registrationNumber": "L-595",
    "licenseIssueDate": "03/06/2007 00:00:00",
    "licenseExpiryDate": "03/05/2026 00:00:00"
  },
  {
    "id": "bc5a878c-6554-4534-a7fa-eacd345c9ae2",
    "slug": "amira-mohammad-saqer-mohammad-alsoori",
    "name": "MOHAMMAD SAQER MOHAMMAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/04/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Amira Mohammad Saqer Mohammad Alsoori",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bc5a878c-6554-4534-a7fa-eacd345c9ae2",
        "address": "B2207 ,لطيفة تاور ,بجانب فندق فوكو دبي‎ ,410889 ,Dubai",
        "phone": "97143447557",
        "email": "info@amirasaqeradvo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "d4393464-394a-4311-ac7d-2247c5af8bad",
    "firmName": "AMIRA SAQER ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1010",
    "licenseIssueDate": "04/19/2015 00:00:00",
    "licenseExpiryDate": "04/18/2026 00:00:00"
  },
  {
    "id": "ea06c102-39c0-4a42-8551-dfb17b8b1dc6",
    "slug": "amirah-rashed-mohamed-salem-alsereidi",
    "name": "Amirah Rashed Mohamed Salem Alsereidi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/27/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Amirah Rashed Mohamed Salem Alsereidi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ea06c102-39c0-4a42-8551-dfb17b8b1dc6",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "1034",
    "licenseIssueDate": "10/27/2015 00:00:00",
    "licenseExpiryDate": "10/26/2025 00:00:00"
  },
  {
    "id": "8e70b4d3-5229-4ff1-a17c-40003e4d5b9e",
    "slug": "ammar-abdulla-abdulrahman-alsaeedi",
    "name": "FARHAN SAEED HMOUD AL BADI ALATEIBI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/09/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ammar abdulla abdulrahman alsaeedi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8e70b4d3-5229-4ff1-a17c-40003e4d5b9e",
        "address": "almetaq insurance  ,alnouf tower ,business vilage  ,92422 ,Dubai",
        "phone": "97142974555",
        "email": "info@alsaeedilaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "5684cb2e-d43e-411d-b69e-2e1976782a55",
    "firmName": "ALPHA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1868",
    "licenseIssueDate": "10/03/2023 00:00:00",
    "licenseExpiryDate": "10/02/2026 00:00:00"
  },
  {
    "id": "f717972f-5fa5-4cac-bc3c-ae7e69f0b61b",
    "slug": "ammar-ali-ahmed-ali-almulla",
    "name": "ALIA ABDULLA MUBARAK",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/01/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ammar Ali Ahmed Ali Almulla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f717972f-5fa5-4cac-bc3c-ae7e69f0b61b",
        "address": "",
        "phone": "97144298492",
        "email": "Ammaraalmulla@GMAIL.COM",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "becf727c-133c-4718-b959-762d1beaee4d",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1911",
    "licenseIssueDate": "01/31/2024 00:00:00",
    "licenseExpiryDate": "01/30/2026 00:00:00"
  },
  {
    "id": "b7254252-4f85-441d-a92d-9cfafe7d395b",
    "slug": "ammar-khalfan-mohammed-ali-aldahmani",
    "name": "ABDULLA MOHAMED ABDULLA SULAIMAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/09/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ammar Khalfan Mohammed Ali Aldahmani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b7254252-4f85-441d-a92d-9cfafe7d395b",
        "address": "",
        "phone": "97142566660",
        "email": "dlr@ysalc.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "28be4513-86ae-4602-b4cc-8d52ba959e9e",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1875",
    "licenseIssueDate": "10/20/2023 00:00:00",
    "licenseExpiryDate": "10/19/2026 00:00:00"
  },
  {
    "id": "3bbec781-815c-4276-9cd0-42bd8a318262",
    "slug": "amna-abdalla-matar-abdalla-alzaabi",
    "name": "AMNA ABDALLA MATAR ABDALLA ALZAABI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/07/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Amna Abdalla Matar Abdalla Alzaabi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3bbec781-815c-4276-9cd0-42bd8a318262",
        "address": "amna alzaabi ,213 ,مبنى مكاتب عود ميثاء ,سيتي بنك ,16189 ,Dubai",
        "phone": "97145822422",
        "email": "info@amnalegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "a30322e3-d9be-4ba2-ba94-2ebf6f963319",
    "firmName": "AMNA ALZAABI ADVOCATES &LEGAL CONSULTANTS",
    "registrationNumber": "L-1435",
    "licenseIssueDate": "07/14/2020 00:00:00",
    "licenseExpiryDate": "07/13/2026 00:00:00"
  },
  {
    "id": "7ce3792c-4a49-4ede-8f8e-ce8dacf573ce",
    "slug": "amna-ali-ibrahim-alkayyay-alshamsi",
    "name": "AMNA ALI IBRAHIM ALKAYYAY",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/02/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Amna Ali Ibrahim Alkayyay Alshamsi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7ce3792c-4a49-4ede-8f8e-ce8dacf573ce",
        "address": "",
        "phone": "97142515101",
        "email": "legal@alinsaf.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "2176cd73-0d8d-41e1-9db6-ab2d6fa210b5",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1344",
    "licenseIssueDate": "02/20/2019 00:00:00",
    "licenseExpiryDate": "02/19/2026 00:00:00"
  },
  {
    "id": "52cded1d-c5a3-4c42-ab28-c108fe98576d",
    "slug": "amna-ali-qassem-shahin",
    "name": "ALI QASSEM SHAHIN ABDULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/10/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Amna Ali Qassem Shahin",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_52cded1d-c5a3-4c42-ab28-c108fe98576d",
        "address": "",
        "phone": "97142830088 / 971505951775",
        "email": "dubai_lc@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "dd2f1b59-88fd-4ade-9d8f-139a4b75fef0",
    "firmName": "DUBAI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1229",
    "licenseIssueDate": "10/11/2017 00:00:00",
    "licenseExpiryDate": "10/10/2025 00:00:00"
  },
  {
    "id": "61e6e7f6-a643-4485-b654-7fee59d99ae7",
    "slug": "amna-ibrahim-mohammed-hassan-almuhsen",
    "name": "AMNA IBRAHIM MOHAMMED HASSAN ALMUHSEN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/11/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Amna Ibrahim Mohammed Hassan Almuhsen",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_61e6e7f6-a643-4485-b654-7fee59d99ae7",
        "address": "AMNA IBRAHIM ALMUHSEN ,الطابق الاول مكتب 110  ,مركز الدانة ,بجانب فندق كارلتون بالاس ,171300 ,Dubai",
        "phone": "97143300766",
        "email": "amnaadvo@eim.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "d272aefd-4d27-44d1-9b31-1df8b0682365",
    "firmName": "AMNA ALMUHSEN ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-837",
    "licenseIssueDate": "11/11/2012 00:00:00",
    "licenseExpiryDate": "11/10/2024 00:00:00"
  },
  {
    "id": "a43c9b38-bb99-4bbe-9149-a21f9dd82893",
    "slug": "amna-ismail-khalaf-ismail",
    "name": "HESSAH ALI HASSAN ALI ALMESMARI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Commercial Real Estate"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/05/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: AMNA ISMAIL KHALAF ISMAIL",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a43c9b38-bb99-4bbe-9149-a21f9dd82893",
        "address": "الخطوط الاردنية ,بيزنس افينو ,الرستماني  ,00 ,Dubai",
        "phone": "97145468245 / 971505003153",
        "email": "AJ@alzeyoudiadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "920b183d-3abe-4de5-8df6-79ab571d2d74",
    "firmName": "UNION ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1961",
    "licenseIssueDate": "05/17/2024 00:00:00",
    "licenseExpiryDate": "05/16/2026 00:00:00"
  },
  {
    "id": "7baf820a-5317-489e-86a8-0ca0b884a0a2",
    "slug": "amna-khalid-mohammad-kadfoor-almheiri",
    "name": "AMNA KHALID MOHAMMAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/01/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Amna Khalid Mohammad Kadfoor Almheiri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7baf820a-5317-489e-86a8-0ca0b884a0a2",
        "address": "",
        "phone": "97143304343",
        "email": "hamad@emiratesadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "f7823b07-a968-474f-8a13-a4454ef2d990",
    "firmName": "EMIRATES ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1404",
    "licenseIssueDate": "01/29/2020 00:00:00",
    "licenseExpiryDate": "01/28/2026 00:00:00"
  },
  {
    "id": "22839ad5-5710-4071-af66-583ee8d62cac",
    "slug": "amna-khelfan-saleh-al-jalaf",
    "name": "AMNA KHALFAN SALEH AL JALAF",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Sea and air freight"
    ],
    "experience": 29,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/07/1996",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Amna Khelfan Saleh Al-Jalaf",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_22839ad5-5710-4071-af66-583ee8d62cac",
        "address": "",
        "phone": "97143366260",
        "email": "mail@aljallaflegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "d54e2e1d-7afb-435d-ab9e-5301c7e17a1f",
    "firmName": "AL JALLAF ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-284",
    "licenseIssueDate": "07/09/1996 00:00:00",
    "licenseExpiryDate": "07/08/2026 00:00:00"
  },
  {
    "id": "d7e81f83-495e-4061-8448-8b312e2f45d7",
    "slug": "amna-majid-mohamed-alshaikhahmed-alkhazraji",
    "name": "MOHAMMED AL BREK ABDULLA SALEM M AHMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/05/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Amna majid Mohamed alshaikhahmed Alkhazraji",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d7e81f83-495e-4061-8448-8b312e2f45d7",
        "address": "11 ,بناية صبحة ايفوري 2 ,ماما شيلتر أوتيل ,9598 ,Dubai",
        "phone": "97143880171 / 971565359809",
        "email": "malawyer@malawyer.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "da6588ae-fc3b-4a88-8a5e-7836becb47d2",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1953",
    "licenseIssueDate": "05/09/2024 00:00:00",
    "licenseExpiryDate": "05/08/2026 00:00:00"
  },
  {
    "id": "ee24e0c8-e58a-41a9-a8cc-b4b7550df565",
    "slug": "amna-mohamed-ali-mohamed",
    "name": "RASHED MOHAMED ABDULLA MOHAMED ALHEFEITI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/01/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Amna Mohamed Ali Mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ee24e0c8-e58a-41a9-a8cc-b4b7550df565",
        "address": "HASSAN ALI MATAR ALRIYAMI ,24 ,GRASVENOR BUSINESS TOWER ,NEEDS SUPERMARKET ,215880 ,Dubai",
        "phone": "97144534188",
        "email": "courts@alriyamiadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "a40a2f1f-69a9-429c-8086-dba9d985532b",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1747",
    "licenseIssueDate": "01/19/2023 00:00:00",
    "licenseExpiryDate": "01/18/2026 00:00:00"
  },
  {
    "id": "f212946e-15ca-42ca-ac7b-87721494e015",
    "slug": "amna-moosa-mohammad-matar-ahmad",
    "name": "AMNA MOOSA MOHD MATAR AHMAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Personal Status-Legal Capacity & Guardianship",
      "Personal Status-Child Abuse & Abduction"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/04/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Amna Moosa Mohammad Matar Ahmad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f212946e-15ca-42ca-ac7b-87721494e015",
        "address": "4th Floor/ Office no. 401 ,Business Avenue  ,Infront- Terminal 2  ,115263 ,Dubai",
        "phone": "97144518866",
        "email": "info@aldhaheriinternational.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "cf3c19c0-d396-4bcb-b1db-b81273ed0b4c",
    "firmName": "AL DHAHERI INTERNATIONAL ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1075",
    "licenseIssueDate": "05/01/2016 00:00:00",
    "licenseExpiryDate": "04/30/2026 00:00:00"
  },
  {
    "id": "f0f35462-42c2-4826-8b0f-363a2efb3d4d",
    "slug": "amna-rasheed-ahmed-rasheed-alharmoodi",
    "name": "MAZNA MOHAMED THAMER MOHAMED ALMANSOORI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/11/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-11-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Amna rasheed ahmed rasheed alharmoodi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f0f35462-42c2-4826-8b0f-363a2efb3d4d",
        "address": "301 ,Clover Bay Tower ,Burj Khalifa ,414077 ,Dubai",
        "phone": "97145135166",
        "email": "info@faisalalzarooni.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "896b6ab4-30f1-4f72-86fe-c7ea8653a027",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1728",
    "licenseIssueDate": "12/15/2022 00:00:00",
    "licenseExpiryDate": "12/14/2025 00:00:00"
  },
  {
    "id": "d9a983a9-bded-4680-b1be-a2987539361a",
    "slug": "amna-said-shafqt-ali",
    "name": "AMNA SAYED SHAFQAT ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/07/2009",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Amna said shafqt ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d9a983a9-bded-4680-b1be-a2987539361a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-673",
    "licenseIssueDate": "07/08/2009 00:00:00",
    "licenseExpiryDate": "07/07/2026 00:00:00"
  },
  {
    "id": "b87252d6-5692-4a2b-a93b-7d1318a70a31",
    "slug": "amnah-ali-obaid-ali-alkaabi",
    "name": "JUMA SAEED SBAIT SALMEEN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/06/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: AMNAH ALI OBAID ALI ALKAABI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b87252d6-5692-4a2b-a93b-7d1318a70a31",
        "address": "",
        "phone": "97142865353 / 971551986013",
        "email": "info@alzahmyadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "fd77d7cf-7bee-4da2-8757-d004294b9189",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1997",
    "licenseIssueDate": "06/28/2024 00:00:00",
    "licenseExpiryDate": "06/27/2026 00:00:00"
  },
  {
    "id": "5376ecae-217c-4d10-9c1f-11c98936e587",
    "slug": "amnah-mohamed-ahmed-rashed-alshehhi",
    "name": "AMNAH MOHAMED AHMED RASHED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/02/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Amnah Mohamed Ahmed Rashed Alshehhi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5376ecae-217c-4d10-9c1f-11c98936e587",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-860",
    "licenseIssueDate": "02/24/2013 00:00:00",
    "licenseExpiryDate": "02/23/2026 00:00:00"
  },
  {
    "id": "aa9dfacf-88f7-43f6-943c-44bb74878060",
    "slug": "aneesa-mohamed-nasser",
    "name": "ANEESA MOHAMED NASSER",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/08/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Aneesa Mohamed Nasser",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_aa9dfacf-88f7-43f6-943c-44bb74878060",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1214",
    "licenseIssueDate": "08/15/2017 00:00:00",
    "licenseExpiryDate": "08/14/2026 00:00:00"
  },
  {
    "id": "5505adfe-4b62-434e-ab9f-eccc04735c52",
    "slug": "anwar-mohammed-hussein-farajallah",
    "name": "Anwar Mohammed Hussein Farajallah",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/08/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2021-07-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Anwar Mohammed Hussein Farajallah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5505adfe-4b62-434e-ab9f-eccc04735c52",
        "address": "",
        "phone": "97143799916 / 971556407627",
        "email": "ask@mahlawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "a1880a30-0b15-4045-b91e-b3e4e776bc7e",
    "firmName": "MOHAMED ALHATHBOOR ADVOCATES & LEGAL CONSULTA",
    "registrationNumber": "1306",
    "licenseIssueDate": "08/08/2018 00:00:00",
    "licenseExpiryDate": "08/07/2021 00:00:00"
  },
  {
    "id": "6b164e23-ed93-4403-8d3d-861767e54629",
    "slug": "aref-salem-alabed-almenhali",
    "name": "AREF SALEM AL ABED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/03/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Aref Salem Alabed Almenhali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6b164e23-ed93-4403-8d3d-861767e54629",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1517",
    "licenseIssueDate": "03/09/2021 00:00:00",
    "licenseExpiryDate": "03/08/2026 00:00:00"
  },
  {
    "id": "ea090015-efd5-49b3-87f2-53517dd9e9d4",
    "slug": "arif-mohamed-khadim-salim-al-teraifi",
    "name": "ARIF MOHAMED KHADIM ALTERAIFI ALSHAMSI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 26,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/1999",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Arif Mohamed Khadim Salim Al Teraifi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ea090015-efd5-49b3-87f2-53517dd9e9d4",
        "address": "",
        "phone": "97142229944",
        "email": "almaarif_law@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "3aecd13e-7d3e-45ab-a8a3-b58a36ee77b3",
    "firmName": "AL MAARIF ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-351",
    "licenseIssueDate": "03/01/1999 00:00:00",
    "licenseExpiryDate": "02/28/2026 00:00:00"
  },
  {
    "id": "4a453fb0-fc07-4e32-9ef8-eabbf67ea21c",
    "slug": "arif-mohammad-obaid-bushaqer-alfalasi",
    "name": "ARIF MOHD OBAID BISHAQER ALFALASI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/10/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Arif Mohammad Obaid Bushaqer Alfalasi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4a453fb0-fc07-4e32-9ef8-eabbf67ea21c",
        "address": "",
        "phone": "97145770472",
        "email": "bushaqer4@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "2a8599d2-a4d7-4456-9165-ad546262d108",
    "firmName": "ARIF BUSHAQER ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-414",
    "licenseIssueDate": "10/24/2022 00:00:00",
    "licenseExpiryDate": "10/23/2025 00:00:00"
  },
  {
    "id": "900c63c8-60d1-4ed8-888c-4696a51b08ac",
    "slug": "ashwaq-qaid-nasser-alqamesh",
    "name": "SUAD HASAN W/O FAHAD A ALJASMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/07/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ashwaq Qaid Nasser Alqamesh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_900c63c8-60d1-4ed8-888c-4696a51b08ac",
        "address": "",
        "phone": "97148812191 / 971526343439",
        "email": "info@aqadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "bd7685ea-a57c-4a81-8b1b-d6c690263d86",
    "firmName": "GALADARI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-2012",
    "licenseIssueDate": "08/10/2024 00:00:00",
    "licenseExpiryDate": "08/09/2026 00:00:00"
  },
  {
    "id": "b7e76f2b-9e97-41f0-8323-df2d6baa9b12",
    "slug": "asma-abdulla-rashed-saeed-momhammed-alzaabi",
    "name": "ASMA ABDULLA RASHED S M ALZAABI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/01/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Asma Abdulla Rashed Saeed Momhammed Alzaabi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b7e76f2b-9e97-41f0-8323-df2d6baa9b12",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-737",
    "licenseIssueDate": "01/12/2011 00:00:00",
    "licenseExpiryDate": "01/11/2026 00:00:00"
  },
  {
    "id": "0fe2b27b-1bac-485f-b006-883ca811445e",
    "slug": "asma-ahmed-mohamed-ali-mohamed-alrasheed",
    "name": "ASMA AHMED MOHAMED ALI MOHD ALRASHEED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/04/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Asma Ahmed Mohamed Ali Mohamed Alrasheed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0fe2b27b-1bac-485f-b006-883ca811445e",
        "address": "6 ,Business Point ,Nissan Showroom  ,443 ,Dubai",
        "phone": "97142999991",
        "email": "dubai@alrasheed.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "a4fce061-88d2-4308-9c3a-dbb02f5cbe82",
    "firmName": "AL RASHEED & PARTNERS",
    "registrationNumber": "L-806",
    "licenseIssueDate": "04/29/2012 00:00:00",
    "licenseExpiryDate": "04/28/2026 00:00:00"
  },
  {
    "id": "d7cd84bf-5449-4940-953c-9e84d30c03f3",
    "slug": "asma-ali-mohsin-almessabi",
    "name": "ASMA ALI MOHSIN ALMESSABI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/04/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Asma Ali Mohsin Almessabi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d7cd84bf-5449-4940-953c-9e84d30c03f3",
        "address": "",
        "phone": "97143269559 / 971552095466",
        "email": "admin@asmaadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "aa022dc2-ef28-4d77-8cfc-629cfc691bf2",
    "firmName": "ASMA ALI ALMESSABI ADVOCATES &LEGAL CONSULTANTS",
    "registrationNumber": "L-1009",
    "licenseIssueDate": "04/16/2015 00:00:00",
    "licenseExpiryDate": "04/15/2026 00:00:00"
  },
  {
    "id": "e016e19d-c8d3-488d-8d7d-6a43baa924b5",
    "slug": "asma-andulrahman-sharaf-mohammed-almemari",
    "name": "MAHBOOBA BAQER HUSSAIN AZDERI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/05/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Asma Andulrahman Sharaf Mohammed Almemari",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e016e19d-c8d3-488d-8d7d-6a43baa924b5",
        "address": "",
        "phone": "97143528887",
        "email": "info@kashwanilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "01ccf3a9-cfd3-4fb5-b5ac-a912503c2630",
    "firmName": "MANSOOR LOOTAH ADVOCATES &LEGAL CONSULTANCY",
    "registrationNumber": "L-1665",
    "licenseIssueDate": "06/14/2022 00:00:00",
    "licenseExpiryDate": "06/13/2026 00:00:00"
  },
  {
    "id": "359f681f-3ba0-484b-90b4-91534bf8e580",
    "slug": "asma-mohammed-sultan-abdulla-alshamsi",
    "name": "FAISAL ESSA ALQASIM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/02/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Asma Mohammed Sultan Abdulla Alshamsi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_359f681f-3ba0-484b-90b4-91534bf8e580",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1636",
    "licenseIssueDate": "03/26/2022 00:00:00",
    "licenseExpiryDate": "03/25/2026 00:00:00"
  },
  {
    "id": "5cfff812-3e89-4d9a-b176-efe658cc55be",
    "slug": "asmaa-abdulla-saeed-khameis-alabdouli",
    "name": "MOHAMED JASIM MOHAMED MURAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/08/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Asmaa Abdulla Saeed khameis Alabdouli",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5cfff812-3e89-4d9a-b176-efe658cc55be",
        "address": "Second Floor - Office B2 ,Al Khor Tower ,Makani No: 3027595041 ,000 ,Dubai",
        "phone": "97143322613 / 971527759923",
        "email": "asmaaalabdouliadvocates@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "3ab5603b-a1b7-45e3-8c5a-2c1b1dfc1a5f",
    "firmName": "ABDELAZIZ AL KHAMIRI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1697",
    "licenseIssueDate": "09/12/2022 00:00:00",
    "licenseExpiryDate": "09/11/2026 00:00:00"
  },
  {
    "id": "68d2a8ea-dce3-440d-9dd5-fb3a40c2ff62",
    "slug": "asmaa-abdulla-yaqoot-dheyab-altamimi",
    "name": "ASMAA ABDULLA YAQOOT DHEYAB ALTAMIMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/07/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ASMAA ABDULLA YAQOOT DHEYAB ALTAMIMI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_68d2a8ea-dce3-440d-9dd5-fb3a40c2ff62",
        "address": "",
        "phone": "97100000000",
        "email": "info@lawyeraaltamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "11a91dbf-baf8-4c44-9d14-8059e4c80590",
    "firmName": "ASMAA ALTAMIMI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-1552",
    "licenseIssueDate": "07/29/2021 00:00:00",
    "licenseExpiryDate": "07/28/2026 00:00:00"
  },
  {
    "id": "96f059f5-c373-4594-8888-8286826dbba0",
    "slug": "awadh-mubarak-rashed-bin-zeraij-almehairi",
    "name": "AWADH MUBARAK RASHED BIN ZERAIJ",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 19,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/04/2006",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: AWADH MUBARAK RASHED BIN ZERAIJ ALMEHAIRI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_96f059f5-c373-4594-8888-8286826dbba0",
        "address": "",
        "phone": "/ 971509449447",
        "email": "awadh.a.lflc@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "c4d62742-d18f-4b40-a85c-e95245605003",
    "firmName": "AWADH ALMHEIRI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-557",
    "licenseIssueDate": "04/24/2006 00:00:00",
    "licenseExpiryDate": "04/23/2026 00:00:00"
  },
  {
    "id": "6b42f634-b420-4210-b1ee-8126f24437ba",
    "slug": "awatif-mohammed-showqi",
    "name": "AWATIF MOHD W O ABDULWAHAB H KHOORY",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 21,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/12/2003",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Awatif Mohammed Showqi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6b42f634-b420-4210-b1ee-8126f24437ba",
        "address": "29 ,ذا اتش هوتيل ,فندق فيرمونت ,40073 ,Dubai",
        "phone": "97143254000",
        "email": "info@alrowaad.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "759f5477-fdbd-406b-8831-354639c31036",
    "firmName": "AWATIF MOHAMMAD SHOQI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-386",
    "licenseIssueDate": "12/15/2003 00:00:00",
    "licenseExpiryDate": "12/14/2025 00:00:00"
  },
  {
    "id": "d7299c24-8d7e-49e7-b4ec-dbe69f1be2a9",
    "slug": "ayaha-abdulrahman-mohamed-abdulla-alteneiji",
    "name": "Ayaha Abdulrahman Mohamed Abdulla Alteneiji",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/18/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ayaha Abdulrahman Mohamed Abdulla Alteneiji",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d7299c24-8d7e-49e7-b4ec-dbe69f1be2a9",
        "address": "901-902 ,برج السلام ,فندق جراند شيراتون ,2741291443 ,Dubai",
        "phone": "97145877794 / 971586606660",
        "email": "obh@obhlawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "edbb7814-39f9-4ec9-b01d-9de1117e343e",
    "firmName": "OMAR KHALIFA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "1927",
    "licenseIssueDate": "03/18/2024 00:00:00",
    "licenseExpiryDate": "03/17/2026 00:00:00"
  },
  {
    "id": "ff3bcc49-10aa-45c6-87b7-367fa1bd83f5",
    "slug": "ayeda-obaid-mesarri-salem-aldhaheri",
    "name": "AYEDA OBAID MESARRI SALEM ALDHAHERI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/11/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ayeda obaid mesarri salem aldhaheri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ff3bcc49-10aa-45c6-87b7-367fa1bd83f5",
        "address": "",
        "phone": "97143588887",
        "email": "e.lawyersd@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "9aeb8716-ff23-4200-90de-c2e0ee86076e",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1590",
    "licenseIssueDate": "11/03/2021 00:00:00",
    "licenseExpiryDate": "11/02/2025 00:00:00"
  },
  {
    "id": "bd6925af-91e6-4820-9b9e-0a5110e51fed",
    "slug": "ayesha-abdullatif-dhaen-abdulla-al-dhaen",
    "name": "ALUNOOD ALI SAEED HAM ABDULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/04/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ayesha Abdullatif Dhaen Abdulla Al Dhaen",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bd6925af-91e6-4820-9b9e-0a5110e51fed",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1944",
    "licenseIssueDate": "04/26/2024 00:00:00",
    "licenseExpiryDate": "04/25/2026 00:00:00"
  },
  {
    "id": "e6624196-02b1-4454-9a32-633781480d07",
    "slug": "ayesha-abdulsalam-mohammad-aljaziri",
    "name": "AYESHA ABDULSALAM MOHAMMAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/04/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ayesha Abdulsalam Mohammad Aljaziri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e6624196-02b1-4454-9a32-633781480d07",
        "address": "",
        "phone": "",
        "email": "info@aljaziriadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "7c6b5984-e1c6-4726-b68d-0413ab504704",
    "firmName": "AYESHA AL JAZIRI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1177",
    "licenseIssueDate": "04/19/2017 00:00:00",
    "licenseExpiryDate": "04/18/2026 00:00:00"
  },
  {
    "id": "5c7e4526-db5f-4143-9c8f-836dfe4e1540",
    "slug": "ayesha-marwan-saif-obaid-alzaabi",
    "name": "MUKHTAR MOHAMED ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/11/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ayesha marwan saif obaid alzaabi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5c7e4526-db5f-4143-9c8f-836dfe4e1540",
        "address": "",
        "phone": "97145548499",
        "email": "legal@nyk.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "86fac3dc-bced-468b-8e4c-43324e2aa906",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1887",
    "licenseIssueDate": "11/19/2023 00:00:00",
    "licenseExpiryDate": "11/18/2025 00:00:00"
  },
  {
    "id": "deb9f24f-337d-4c07-bcc2-1ff8ce957e5e",
    "slug": "ayesha-mohammad-hassan-taher",
    "name": "Ayesha Mohammad Hassan Taher",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 17,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/15/2008 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2021-10-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ayesha Mohammad Hassan Taher",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_deb9f24f-337d-4c07-bcc2-1ff8ce957e5e",
        "address": "الطابق الخامس ,الساحة ,سوق البحار ,26011 ,Dubai",
        "phone": "97142277717",
        "email": "info@alsahlawico.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "a6811a79-5470-4c33-ad95-3ff8f661c052",
    "firmName": "AL SAHLAWI & CO ADVOCATES & CONSULTANTS",
    "registrationNumber": "472",
    "licenseIssueDate": "10/15/2008 00:00:00",
    "licenseExpiryDate": "10/14/2021 00:00:00"
  },
  {
    "id": "268d7d0a-07bb-47c1-947b-68ea290af022",
    "slug": "ayesha-sabt-jawhar-suwaid-aldhaheri",
    "name": "AYESHA SABT JAWHAR SUWAID ALDHAHERI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/10/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ayesha Sabt Jawhar Suwaid Aldhaheri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_268d7d0a-07bb-47c1-947b-68ea290af022",
        "address": "Office 308 ,Owned by ACICO Gulf Real Estate LLC, Dubai branch ,Makani No: 3250094543 ,000 ,Dubai",
        "phone": "97142697998 / 971503567998",
        "email": "info@ayshamslaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "0892f012-3fc4-4895-8d3b-abbb036938aa",
    "firmName": "AYESHA ALDHAHERI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1578",
    "licenseIssueDate": "10/10/2021 00:00:00",
    "licenseExpiryDate": "10/09/2026 00:00:00"
  },
  {
    "id": "783a9747-bcd7-4087-881b-320ceb7452b5",
    "slug": "ayisha-nasser-mohammed-ahmad-alzarouni",
    "name": "AYISHA NASSER MOHAMMED AHMAD ALZAROUNI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/12/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ayisha Nasser Mohammed Ahmad Alzarouni",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_783a9747-bcd7-4087-881b-320ceb7452b5",
        "address": "",
        "phone": "97144205111",
        "email": "info@showab.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "8b17fa0a-9280-4fda-9e0e-dd7a826edb51",
    "firmName": "ADVOCATES UNIT",
    "registrationNumber": "L-950",
    "licenseIssueDate": "12/06/2024 00:00:00",
    "licenseExpiryDate": "12/05/2025 00:00:00"
  },
  {
    "id": "59178802-e27b-453b-82c4-d6b782be9ccc",
    "slug": "ayman-abdulraheim-ahmad-abdulla-mardas",
    "name": "AYMAN ABDULRAHIM AHMAD ABDULLA MARDAS",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 25,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2000",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ayman Abdulraheim Ahmad Abdulla Mardas",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_59178802-e27b-453b-82c4-d6b782be9ccc",
        "address": "21 ,Rolex Tower ,Emirates Grand Hotel ,94334 ,Dubai",
        "phone": "97143277772 / 97145584900",
        "email": "info@globaladvocates.net",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "9b42810f-1d55-4aea-ac4a-7d9d1b25ac08",
    "firmName": "GLOBAL ADVOCACY & LEGAL COUNSEL",
    "registrationNumber": "L-375",
    "licenseIssueDate": "02/29/2000 00:00:00",
    "licenseExpiryDate": "02/28/2026 00:00:00"
  },
  {
    "id": "9f75eb66-0ec7-4049-a2a2-110457926233",
    "slug": "ayoub-ghazi-ghuloum-mohammed",
    "name": "AYOUB GHAZI GHOLOOM MOHAMAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 24,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/09/2001",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ayoub Ghazi Ghuloum Mohammed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9f75eb66-0ec7-4049-a2a2-110457926233",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-412",
    "licenseIssueDate": "09/25/2001 00:00:00",
    "licenseExpiryDate": "09/24/2026 00:00:00"
  },
  {
    "id": "26df7eed-a640-4f76-a7ad-166085fdf6ee",
    "slug": "aysha-ahmed-sultan-khamis-alkaabi",
    "name": "FATMAH HOMOUD RASHED ALSEREIDI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/06/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Aysha Ahmed Sultan Khamis Alkaabi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_26df7eed-a640-4f76-a7ad-166085fdf6ee",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1822",
    "licenseIssueDate": "06/30/2023 00:00:00",
    "licenseExpiryDate": "06/29/2026 00:00:00"
  },
  {
    "id": "203b97a8-03d0-4368-9663-8c108f5f0aa8",
    "slug": "aysha-mohamed-saleh-ahmed-al-marzooqi",
    "name": "MOHAMED SALEH AHMED ABDULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/12/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Aysha Mohamed Saleh Ahmed Al Marzooqi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_203b97a8-03d0-4368-9663-8c108f5f0aa8",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1490",
    "licenseIssueDate": "12/26/2020 00:00:00",
    "licenseExpiryDate": "12/25/2025 00:00:00"
  },
  {
    "id": "a32aa137-20d5-45e2-8b29-7d996c51d30b",
    "slug": "aysha-mohammad-omar-mohammad-albannai",
    "name": "AYSHA MOHAMMAD OMAR MOHAMMAD ALBANNAI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/06/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Aysha Mohammad Omar Mohammad Albannai",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a32aa137-20d5-45e2-8b29-7d996c51d30b",
        "address": "",
        "phone": "97142212205 / 971558866989",
        "email": "info@akzlawfirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "5cbbbc4c-2394-453c-819a-94b1d296a1e9",
    "firmName": "AHMED KHAMIES ALZEYOUDI ADVOCATES &LEGAL CONSULTANTS",
    "registrationNumber": "L-1197",
    "licenseIssueDate": "06/22/2017 00:00:00",
    "licenseExpiryDate": "06/21/2026 00:00:00"
  },
  {
    "id": "35d530e8-8714-4580-9efa-fc33f47c9af6",
    "slug": "aysha-shames-qeait-yeail-almenhali",
    "name": "SAEED SALEM KHALIFA SALEM ALMAZROUEI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/01/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Aysha Shames Qeait Yeail Almenhali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_35d530e8-8714-4580-9efa-fc33f47c9af6",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1759",
    "licenseIssueDate": "02/10/2023 00:00:00",
    "licenseExpiryDate": "02/09/2026 00:00:00"
  },
  {
    "id": "186d571a-dc29-4056-bc59-b829a24f078e",
    "slug": "azbz-hasan-hamad-ali-alhajeri",
    "name": "MOHAMED KHAMEIS SAEED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/10/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: azbz hasan hamad ali alhajeri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_186d571a-dc29-4056-bc59-b829a24f078e",
        "address": "4 ,Century 21 building ,al kabayel discount centre ,340781 ,Dubai",
        "phone": "97142417888 / 971562693277",
        "email": "dubai@khbinomair.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "34306e48-bd22-4b51-b883-2a538d4f1890",
    "firmName": "HESSA HUMAID AL SHARA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1886",
    "licenseIssueDate": "11/19/2023 00:00:00",
    "licenseExpiryDate": "11/18/2025 00:00:00"
  },
  {
    "id": "b8a626d9-cf03-4df3-bb26-ce27b679d16d",
    "slug": "azza-ebrahim-hasan-almulla-almansoori",
    "name": "AZZA EBRAHIM HASAN ALMULLA ALMANSOORI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/02/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-02-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Azza Ebrahim Hasan Almulla Almansoori",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b8a626d9-cf03-4df3-bb26-ce27b679d16d",
        "address": "Azza Ebrahim Hasan Almulla ,6(602-603) ,Al Shoalla Building (Al Naboodah) ,deira city center ,12871 ,Dubai",
        "phone": "97142950010",
        "email": "dubai-secretary@dralmulla.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "fbf6220f-2608-4caa-895e-d45ae8a259a2",
    "firmName": "AZZA IBRAHIM HASSAN AL MULLA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-505",
    "licenseIssueDate": "02/07/2018 00:00:00",
    "licenseExpiryDate": "02/06/2026 00:00:00"
  },
  {
    "id": "d6c61f6c-def1-49db-882e-20686d6acb81",
    "slug": "bader-abdulla-hassan-abdulla-balhosh",
    "name": "BADER ABDULLA HASSAN ABDULLA BALHOSH",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Commercial Agency",
      "Proceedings-Cases and Proceedings before Dubai International Financial Centre",
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Civil Transactions-Insurance",
      "Personal Status-Wills",
      "Commercial Transactions-Commercial Mortgage",
      "Criminal Law-Family Crimes",
      "Personal Status-Custody & Alimony",
      "Commercial Transactions-Commercial Contracts",
      "Commercial Transactions-Commercial Real Estate",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Criminal Law-Crimes against persons",
      "Personal Status-Legacies and Inheritance",
      "Commercial Transactions-Commercial Companies",
      "Personal Status-Legal Capacity & Guardianship",
      "Criminal Law-Drug Crimes",
      "Commercial Transactions-Sea and air freight",
      "Proceedings-Cases and Proceedings before arbitral tribunals and other alternative dispute resolution bodies",
      "Personal Status-Marriage & Divorce",
      "Criminal Law-Crimes against properties",
      "Criminal Law-Cybercrimes",
      "Commercial Transactions-Intellectual Property (includes trademarks",
      "copy rights",
      "patents)",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/08/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Bader Abdulla  Hassan  Abdulla Balhosh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d6c61f6c-def1-49db-882e-20686d6acb81",
        "address": "Advo. Abdulla Al Awadi ,العاشر  ,برايم تاور  ,فندق فيدا ,26665 ,Dubai",
        "phone": "97143352200",
        "email": "info@abdullaalawadi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "5075821f-98f5-4546-8fcd-6cdc74967dac",
    "firmName": "ABDULLA ALAWADI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1443",
    "licenseIssueDate": "08/12/2020 00:00:00",
    "licenseExpiryDate": "08/11/2026 00:00:00"
  },
  {
    "id": "56b226f4-7409-4371-8613-4f75bd5bd8dc",
    "slug": "bader-abdulla-khamis-abdulla",
    "name": "BADER ABDULLA KHAMIS",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 18,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/03/2007",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Bader Abdulla Khamis Abdulla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_56b226f4-7409-4371-8613-4f75bd5bd8dc",
        "address": "",
        "phone": "97145539555",
        "email": "world-center@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "00c4764a-95da-417c-bdfc-8bafd4ff9fca",
    "firmName": "WORLD CENTER ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-590",
    "licenseIssueDate": "03/06/2007 00:00:00",
    "licenseExpiryDate": "03/05/2026 00:00:00"
  },
  {
    "id": "c7151ed9-be94-47a8-bfd3-78ef710569fc",
    "slug": "bader-abdulrahman-mohmmed-abdulrahim-al-jassmy",
    "name": "BADER ABDULRAHMAN MOHAMMAD ALJASSMY",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/02/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Bader Abdulrahman Mohmmed Abdulrahim Al Jassmy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c7151ed9-be94-47a8-bfd3-78ef710569fc",
        "address": "Bader Aljassmy ,3 ,دبي كوميرسيتي ,دبي كوميرسيتي ,410004 ,Dubai",
        "phone": "97148760777 / 971586842086",
        "email": "info@bajlegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "7e820dd9-2748-4876-88db-ff7948542895",
    "firmName": "AL BASTAKI & Al JASMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1340",
    "licenseIssueDate": "02/11/2019 00:00:00",
    "licenseExpiryDate": "02/10/2026 00:00:00"
  },
  {
    "id": "4d283aac-569e-4001-8b98-c5e8e7dbf982",
    "slug": "bader-hamad-ahmad-humaid-alzaabi",
    "name": "BADER HAMAD AHMAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/10/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Bader Hamad Ahmad Humaid Alzaabi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4d283aac-569e-4001-8b98-c5e8e7dbf982",
        "address": "",
        "phone": "97142555111 / 971500000000",
        "email": "info@legalemirates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "c507bf6b-00f8-4c70-8580-9e267ce5bbf3",
    "firmName": "Bader Hamad Al Zaabi Advocates and Legal consultants",
    "registrationNumber": "L-1115",
    "licenseIssueDate": "10/12/2016 00:00:00",
    "licenseExpiryDate": "10/11/2026 00:00:00"
  },
  {
    "id": "9fca8999-03e7-4b1b-9061-8fa506e300e1",
    "slug": "bader-mohammed-ali-al-gurg",
    "name": "BADR MOHD ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 26,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/06/1999",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Bader Mohammed Ali Al-Gurg",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9fca8999-03e7-4b1b-9061-8fa506e300e1",
        "address": "",
        "phone": "97142828999",
        "email": "info@gmalc.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "2f9514bf-2175-40fe-8539-d1b4b32074b7",
    "firmName": "ALGURG & ALMATROOSHI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-362",
    "licenseIssueDate": "06/29/1999 00:00:00",
    "licenseExpiryDate": "06/28/2026 00:00:00"
  },
  {
    "id": "b310dacf-7667-454e-8df7-61b606ef3a4b",
    "slug": "bader-saleh-faraj-saeed-alkatheeri",
    "name": "HUDA IBRAHIM W O OMAR M H M I ALHAMMADI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/01/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Bader Saleh Faraj Saeed Alkatheeri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b310dacf-7667-454e-8df7-61b606ef3a4b",
        "address": "HASSAN ALI MATAR ALRIYAMI ,24 ,GRASVENOR BUSINESS TOWER ,NEEDS SUPERMARKET ,215880 ,Dubai",
        "phone": "97144534188",
        "email": "courts@alriyamiadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "a40a2f1f-69a9-429c-8086-dba9d985532b",
    "firmName": "HUDA ALHAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1753",
    "licenseIssueDate": "02/07/2023 00:00:00",
    "licenseExpiryDate": "02/06/2026 00:00:00"
  },
  {
    "id": "9de94b28-2218-416b-87b9-c096a53cf8f8",
    "slug": "badreya-mohammed-malik-alblooshi",
    "name": "BADREYA MOHAMMED MALIK ALBLOOSHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 26,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/09/1999",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Badreya Mohammed Malik Alblooshi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9de94b28-2218-416b-87b9-c096a53cf8f8",
        "address": "",
        "phone": "97142944111",
        "email": "info@lootahlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "867bd7af-cc46-48b7-a06b-d9d319725a02",
    "firmName": "ABDULRAHMAN LOOTAH & ASSOCIATES ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-367",
    "licenseIssueDate": "09/07/1999 00:00:00",
    "licenseExpiryDate": "09/06/2026 00:00:00"
  },
  {
    "id": "94b9a1d2-297f-4f3c-b21c-f9e1c405331c",
    "slug": "badria-abdulla-ahmad-alayoubi",
    "name": "Badria Abdulla Ahmad Alayoubi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/15/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Badria Abdulla Ahmad Alayoubi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_94b9a1d2-297f-4f3c-b21c-f9e1c405331c",
        "address": "Hussain Ali Al Jaziri ,11 ,City Tower 2 ,Crown Plaza hotel Sheikh Zayed Road ,4253 ,Dubai",
        "phone": "97142626777 / 971529087670",
        "email": "courts@jaflaws.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "c58d8654-b428-46b3-abd5-024e4331ee53",
    "firmName": "JAAFAR ALWAN & AL JAZIRI & ASSOCIATES",
    "registrationNumber": "822",
    "licenseIssueDate": "11/15/2017 00:00:00",
    "licenseExpiryDate": "11/14/2025 00:00:00"
  },
  {
    "id": "7dd7201d-71ea-4a77-a3ba-9a1df688ef75",
    "slug": "bashar-abdalla-ali-ibrahim-almasayba",
    "name": "BASHAR ABDALLA ALI IBRAHIM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/07/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Bashar Abdalla Ali Ibrahim Almasayba",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7dd7201d-71ea-4a77-a3ba-9a1df688ef75",
        "address": "",
        "phone": "97143266669 / 971505479696",
        "email": "almasayba@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "a1c5fd44-9a8b-4235-8ba0-8499d6832520",
    "firmName": "BASHAR ALMASAYBA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-961",
    "licenseIssueDate": "07/21/2014 00:00:00",
    "licenseExpiryDate": "07/20/2026 00:00:00"
  },
  {
    "id": "883e22ba-b5a5-4625-8282-e8195795429d",
    "slug": "bothainah-ahmed-abdulla-saeed-aldhanhani",
    "name": "SARA HELAL SULAIMAN SALEM ALSAEDI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/06/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Bothainah Ahmed Abdulla Saeed Aldhanhani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_883e22ba-b5a5-4625-8282-e8195795429d",
        "address": "HASSAN ALI MATAR ALRIYAMI ,24 ,GRASVENOR BUSINESS TOWER ,NEEDS SUPERMARKET ,215880 ,Dubai",
        "phone": "97144534188",
        "email": "courts@alriyamiadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "a40a2f1f-69a9-429c-8086-dba9d985532b",
    "firmName": "SARA AL SAEDI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1679",
    "licenseIssueDate": "07/18/2022 00:00:00",
    "licenseExpiryDate": "07/17/2026 00:00:00"
  },
  {
    "id": "0094fb65-6095-40cf-93e1-101d1514370c",
    "slug": "bushra-obaid-mohamed-almansoori",
    "name": "BUSHRA OBAID MOHAMED ALMANSOORI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/09/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: BUSHRA OBAID MOHAMED ALMANSOORI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0094fb65-6095-40cf-93e1-101d1514370c",
        "address": "104 ,سان شاين 1  ,شقق جرين هاوس الفندقية ,0000 ,Dubai",
        "phone": "97142280666 / 97142280666",
        "email": "Hanansalem.advocate@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "f58725e5-47e3-4ed2-8325-35655ffe5771",
    "firmName": "HANAN SALEM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "1954",
    "licenseIssueDate": "05/09/2024 00:00:00",
    "licenseExpiryDate": "05/08/2026 00:00:00"
  },
  {
    "id": "b5602949-c2ba-439c-80d9-2285f0d539cf",
    "slug": "chafiah-hussain-ali-hussain-aljaziri",
    "name": "CHAFIAH HUSSAIN ALI HUSSAIN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/06/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Chafiah Hussain Ali Hussain Aljaziri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b5602949-c2ba-439c-80d9-2285f0d539cf",
        "address": "Hussain Ali Al Jaziri ,11 ,City Tower 2 ,Crown Plaza hotel Sheikh Zayed Road ,4253 ,Dubai",
        "phone": "97142626777 / 971529087670",
        "email": "courts@jaflaws.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "c58d8654-b428-46b3-abd5-024e4331ee53",
    "firmName": "JAAFAR ALWAN & AL JAZIRI & ASSOCIATES",
    "registrationNumber": "L-765",
    "licenseIssueDate": "06/29/2011 00:00:00",
    "licenseExpiryDate": "06/28/2026 00:00:00"
  },
  {
    "id": "00b08299-7188-4c74-a084-42645bfe73b3",
    "slug": "dalmook-mohammed-humaid-dalmook",
    "name": "DALMOOK MOHAMAD HUMID BIN DALMOOK",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBETQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 45,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/10/1979",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Dalmook Mohammed Humaid Dalmook",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_00b08299-7188-4c74-a084-42645bfe73b3",
        "address": "dalmook mohamed bin dalmook ,التاسع - مكتب 901 ,الشركة الوطنية للتأمينات العامة NGI ,مقابل سيتي سنتر ديرة بجوار سندس سويتس مريديان وفلورا كريك هوتيل ,3467 ,Dubai",
        "phone": "97142989222 / 971506455800",
        "email": "information@dalmook.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "564fc438-ce0f-40b0-9dc2-c01709da9e46",
    "firmName": "DALMOOK MOHAMMED DALMOOK ADVOCATE & LEGAL CONSULTANCY",
    "registrationNumber": "L-87",
    "licenseIssueDate": "10/24/1979 00:00:00",
    "licenseExpiryDate": "10/23/2026 00:00:00"
  },
  {
    "id": "5d077a36-b767-4aa5-8253-f6c2cb362037",
    "slug": "dana-sabah-mohamed",
    "name": "DANA SABAH MOHAMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 18,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/03/2007",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Dana Sabah Mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5d077a36-b767-4aa5-8253-f6c2cb362037",
        "address": "Muna Ahmed Abdul-aziz Al-Sabbagh ,الطابق الخامس ,الزمردة ,مختبر دبي المركزي ,115578 ,Dubai",
        "phone": "97142283414",
        "email": "info@alwifaqlegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "120e4ca7-7727-4524-9d53-5656ff95eea7",
    "firmName": "MUNA AL SABBAGH ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-602",
    "licenseIssueDate": "03/26/2007 00:00:00",
    "licenseExpiryDate": "03/25/2026 00:00:00"
  },
  {
    "id": "59daeeb6-1860-413a-ac5b-871ab2263f3c",
    "slug": "dhaif-saeed-eshaq-hasan-al-ameri",
    "name": "DHAIF SAEED ESHAQ HASAN AL AMERI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/15/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: DHAIF SAEED ESHAQ HASAN AL AMERI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_59daeeb6-1860-413a-ac5b-871ab2263f3c",
        "address": "ادارة ا لمبنى  ,الريم ,الاتصالات  ,42423 ,Dubai",
        "phone": "97142222066",
        "email": "info@ozleco.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "7a155f4a-20ec-44ff-863f-4f9fb43d0af4",
    "firmName": "ALOBAIDLI & ALZAROONI ADVOCATES&LEGAL CONSULT",
    "registrationNumber": "1987",
    "licenseIssueDate": "06/15/2024 00:00:00",
    "licenseExpiryDate": "06/14/2026 00:00:00"
  },
  {
    "id": "8d1f71a4-35f3-41c2-b097-20ab680befd7",
    "slug": "diana-mohd-hamada",
    "name": "DIANA MOHD W O HAMAD MAJID ALGHURIR",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBETQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 17,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/06/2008",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Diana mohd hamada",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8d1f71a4-35f3-41c2-b097-20ab680befd7",
        "address": "Diana Mohamed Hamade ,A.301.S-7 ,Multaqa Avenue 1 ,Mirdif ,10223 ,Dubai",
        "phone": "97142733029",
        "email": "info@dianahamade.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "de3ee3af-bda3-4ac6-96b7-fc737b52458c",
    "firmName": "DIANA HAMADE ATTORNEYS AT LAW",
    "registrationNumber": "L-637",
    "licenseIssueDate": "06/25/2008 00:00:00",
    "licenseExpiryDate": "06/24/2026 00:00:00"
  },
  {
    "id": "de8a3cd1-770b-4539-9402-e76424f8b7ad",
    "slug": "dr-abdulrahman-abdulla-yaqoot-theyab-altamimi",
    "name": "ABDULRAHMAN ABDULLA YAQOOT D. ALTAMIMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/05/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Dr Abdulrahman Abdulla Yaqoot Theyab Altamimi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_de8a3cd1-770b-4539-9402-e76424f8b7ad",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1286",
    "licenseIssueDate": "05/23/2018 00:00:00",
    "licenseExpiryDate": "05/22/2026 00:00:00"
  },
  {
    "id": "cd466935-738c-405a-81f3-7cd7a0c5c8aa",
    "slug": "dr-ahmed-ali-hamoud-ali-almemari",
    "name": "AHMED ALI HAMOUD ALI ALMEMARI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/06/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Dr Ahmed Ali Hamoud Ali Almemari",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cd466935-738c-405a-81f3-7cd7a0c5c8aa",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1198",
    "licenseIssueDate": "06/22/2017 00:00:00",
    "licenseExpiryDate": "06/21/2026 00:00:00"
  },
  {
    "id": "3d8ac95d-2d40-4f64-b8a5-693639f311aa",
    "slug": "dr-eiman-younes-mohamed-e-alrifai",
    "name": "YOUNIS MOHAMMED ESMAEIL",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBERQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 18,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/12/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Dr EIMAN YOUNES MOHAMED E . ALRIFAI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3d8ac95d-2d40-4f64-b8a5-693639f311aa",
        "address": "الطابق 11 - مكتب رقم (1105 ، 1106)  ,برج السلام  ,منطقة المركز التجاري العالمي 1 ,211911 ,Dubai",
        "phone": "97143366769 / 971503636617",
        "email": "info@erlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "fffe1b8f-e9ab-488f-82eb-6151b8f007df",
    "firmName": "EMAN ALRIFAI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1066",
    "licenseIssueDate": "03/06/2007 00:00:00",
    "licenseExpiryDate": "03/05/2026 00:00:00"
  },
  {
    "id": "db116c7b-d12e-4acc-9af5-c86e6d76ebde",
    "slug": "dr-meead-yousef-abdulkarim-y-al-shirawi",
    "name": "MEEAD YOUSEF ABDULKARIM Y ALSHIRAWI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBETQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/05/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Dr Meead Yousef Abdulkarim Y Al Shirawi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_db116c7b-d12e-4acc-9af5-c86e6d76ebde",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-939",
    "licenseIssueDate": "05/04/2014 00:00:00",
    "licenseExpiryDate": "05/03/2026 00:00:00"
  },
  {
    "id": "af8ed892-98a4-48b8-bb8d-1a7e4006bb1b",
    "slug": "dr-zayed-salim-said-al-shibli",
    "name": "Dr Zayed Salim Said Al Shibli",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEWgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/03/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Dr Zayed Salim Said Al Shibli",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_af8ed892-98a4-48b8-bb8d-1a7e4006bb1b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "926",
    "licenseIssueDate": "04/03/2014 00:00:00",
    "licenseExpiryDate": "04/02/2026 00:00:00"
  },
  {
    "id": "afe91e51-095a-40a2-b832-c313f7ac595e",
    "slug": "dr-abdulrahman-nasser-alwi-abdulla-albuhaleeqa",
    "name": "ABDULRAHMAN NASSER ALWI ABDULLA ALBBUHALEEQA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/09/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Dr. Abdulrahman Nasser Alwi Abdulla Albuhaleeqa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_afe91e51-095a-40a2-b832-c313f7ac595e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1453",
    "licenseIssueDate": "09/25/2020 00:00:00",
    "licenseExpiryDate": "09/24/2026 00:00:00"
  },
  {
    "id": "3a8f323d-6467-47ff-904f-a9a58edea76b",
    "slug": "dr-ahmed-mohamed-khamees-al-dhalaya-al-zaabi",
    "name": "AHMED MOHAMED KHAMIS MOHAMED ALDHELAIA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/06/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Dr. Ahmed Mohamed Khamees Al Dhalaya Al Zaabi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3a8f323d-6467-47ff-904f-a9a58edea76b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-876",
    "licenseIssueDate": "06/05/2013 00:00:00",
    "licenseExpiryDate": "06/04/2026 00:00:00"
  },
  {
    "id": "a870a9dc-4818-4753-9cab-9aeccafae625",
    "slug": "dr-ahmed-saeed-salem-bin-hazeem",
    "name": "AHMAD SAEED SALEM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/04/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Dr. Ahmed Saeed Salem Bin Hazeem",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a870a9dc-4818-4753-9cab-9aeccafae625",
        "address": "",
        "phone": "97143685555",
        "email": "maisa.maarouf@bsabh.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "8afa232f-52ff-4dad-82c3-9a04d66eb853",
    "firmName": "B S A AHMAD BIN HAZEEM & ASSOCIATES",
    "registrationNumber": "L-1001",
    "licenseIssueDate": "04/02/2015 00:00:00",
    "licenseExpiryDate": "04/01/2026 00:00:00"
  },
  {
    "id": "a496c4c7-7aae-4cbd-88f1-d2698070c43d",
    "slug": "dr-ahmed-thani-juma-alhamli",
    "name": "AHMED THANI JUMA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/01/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Dr. Ahmed Thani juma Alhamli",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a496c4c7-7aae-4cbd-88f1-d2698070c43d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1399",
    "licenseIssueDate": "01/15/2020 00:00:00",
    "licenseExpiryDate": "01/14/2026 00:00:00"
  },
  {
    "id": "aa5591b3-8d31-4eea-98c2-fb593323ab8f",
    "slug": "dr-awad-mohammed-matar-mohammed-alaryani",
    "name": "AWAD ALARYANI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/06/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Dr. Awad Mohammed Matar Mohammed Alaryani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_aa5591b3-8d31-4eea-98c2-fb593323ab8f",
        "address": "",
        "phone": "97143444491 / 971508002092",
        "email": "awdfms@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "dfb85a31-3414-4198-9ccd-c3ae8ac4ed71",
    "firmName": "AWAD ALARYANI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1193",
    "licenseIssueDate": "06/19/2017 00:00:00",
    "licenseExpiryDate": "06/18/2026 00:00:00"
  },
  {
    "id": "780ae44e-1475-45ad-b1a0-9036b531ac5d",
    "slug": "dr-jamal-abdulrahman-jasem-albagham-alnuaimi",
    "name": "JAMAL ABDULRAHMAN JASEM IBRAHIM ALNUAIMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBESgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/06/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Dr. Jamal Abdulrahman Jasem Albagham Alnuaimi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_780ae44e-1475-45ad-b1a0-9036b531ac5d",
        "address": "",
        "phone": "97142722998",
        "email": "jalnuaimi.adv@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "1b84b124-19de-41b5-89de-ec40b2bd1d01",
    "firmName": "DR JAMAL ALNUAIMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1420",
    "licenseIssueDate": "06/04/2020 00:00:00",
    "licenseExpiryDate": "06/03/2026 00:00:00"
  },
  {
    "id": "8f2e3191-9e9e-4973-8212-01cb726f91d0",
    "slug": "dr-khaled-ali-ahmed-mohamed-aldhanhani",
    "name": "AYESHA ABDULLATIF DHAEN ABDULLA AL DHAEN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBESwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/04/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Dr. Khaled Ali Ahmed Mohamed Aldhanhani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8f2e3191-9e9e-4973-8212-01cb726f91d0",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1950",
    "licenseIssueDate": "05/05/2024 00:00:00",
    "licenseExpiryDate": "05/04/2026 00:00:00"
  },
  {
    "id": "d69c2286-4844-4a23-996f-de0e8a1c9047",
    "slug": "dr-mohamed-saeed-mohamed-hilal-almheiri",
    "name": "FATMA MOHAMMAD OMAR MUBARAK BAWAZIR",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBETQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/09/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Dr. Mohamed Saeed Mohamed Hilal Almheiri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d69c2286-4844-4a23-996f-de0e8a1c9047",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1707",
    "licenseIssueDate": "10/17/2022 00:00:00",
    "licenseExpiryDate": "10/16/2025 00:00:00"
  },
  {
    "id": "55a89f1f-5a16-4b68-901d-36ac694073da",
    "slug": "dr-mohammed-saif-abdulrahman-alteneiji",
    "name": "AHMAD ABDULLA MOHAMMAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBETQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/11/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Dr. Mohammed Saif Abdulrahman Alteneiji",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_55a89f1f-5a16-4b68-901d-36ac694073da",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1723",
    "licenseIssueDate": "11/18/2022 00:00:00",
    "licenseExpiryDate": "11/17/2025 00:00:00"
  },
  {
    "id": "9dccae1a-8378-4509-99e0-687bf2ea48bd",
    "slug": "dr-raed-saeed-saleh-abdullah-awlaqi",
    "name": "RAED SAEED SALEH A.AWLAQI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 29,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/02/1996",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-02-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Dr. Raed Saeed Saleh Abdullah Awlaqi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9dccae1a-8378-4509-99e0-687bf2ea48bd",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-275",
    "licenseIssueDate": "02/10/1996 00:00:00",
    "licenseExpiryDate": "02/09/2026 00:00:00"
  },
  {
    "id": "8e07d6ca-babe-46a1-99e7-ba5581f67062",
    "slug": "dr-salem-abdulla-mohammed-abdulla-almur",
    "name": "SALEM ABDULLA MOHAMMED ABDULLA ALMUR",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/06/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Dr. Salem Abdulla Mohammed Abdulla Almur",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8e07d6ca-babe-46a1-99e7-ba5581f67062",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1014",
    "licenseIssueDate": "06/17/2015 00:00:00",
    "licenseExpiryDate": "06/16/2026 00:00:00"
  },
  {
    "id": "e7565abd-da85-40af-8609-801a86c990d1",
    "slug": "dr-salem-ismail-fairouz-alharthi",
    "name": "SALEM ISMAIL FAIROUZ ALHARTHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 17,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/04/2008",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Dr. Salem Ismail Fairouz Alharthi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e7565abd-da85-40af-8609-801a86c990d1",
        "address": "",
        "phone": "97143699967",
        "email": "advo@dsh-legal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "710524e6-a0b5-44fe-929d-85bfc4bf27dc",
    "firmName": "SALEM ALHARTHI LAW ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-458",
    "licenseIssueDate": "04/06/2008 00:00:00",
    "licenseExpiryDate": "04/05/2026 00:00:00"
  },
  {
    "id": "3f330673-c8c4-40b2-8983-6a45b1fe7d35",
    "slug": "dr-yaser-ali-ahmed-al-hadhari",
    "name": "Dr. Yaser Ali Ahmed Al Hadhari",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/11/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Dr. Yaser Ali Ahmed Al Hadhari",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3f330673-c8c4-40b2-8983-6a45b1fe7d35",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "969",
    "licenseIssueDate": "09/11/2014 00:00:00",
    "licenseExpiryDate": "09/10/2026 00:00:00"
  },
  {
    "id": "ad65bd90-c957-4299-a7aa-da8663c7f73b",
    "slug": "dr-yousif-mohamed-ahmed-ibrahim-alnaqbi",
    "name": "YOUSIF MOHAMED AHMED IBRAHIM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/10/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Dr. Yousif Mohamed Ahmed Ibrahim Alnaqbi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ad65bd90-c957-4299-a7aa-da8663c7f73b",
        "address": "HANI RAJAB MOOSA ABDULLA ALJASMI ,M ,LIBERTY ,SHARJAH BANK ,123887 ,Dubai",
        "phone": "97142957744",
        "email": "info@aljasmilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "04b37ea9-3ebd-45ff-9b0f-56fa9ee7e6fd",
    "firmName": "HANI AL JASMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1111",
    "licenseIssueDate": "10/03/2016 00:00:00",
    "licenseExpiryDate": "10/17/2026 00:00:00"
  },
  {
    "id": "e1cc1144-52f4-4420-9158-7da1a979b4d5",
    "slug": "dr-zubaida-jasim-mohamed-ismail-almaazmi",
    "name": "ZUBAIDA JASIM MOHAMED ISMAIL ALMAAZMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEWgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/04/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: DR. Zubaida Jasim Mohamed Ismail Almaazmi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e1cc1144-52f4-4420-9158-7da1a979b4d5",
        "address": "3rd Floor - Office No. 301 ,Wasel Business Building ,Makani No: 3242894178 ,000 ,Dubai",
        "phone": "97145460005 / 971552666381",
        "email": "Dr.khaled1234@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "653e8321-5f9e-4eae-8740-cc250fc3a19b",
    "firmName": "DR ZUBAIDA JASIM ALMAAZMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1352",
    "licenseIssueDate": "04/02/2019 00:00:00",
    "licenseExpiryDate": "04/01/2026 00:00:00"
  },
  {
    "id": "ccd8497c-f91a-4228-8be6-cf42bddfe542",
    "slug": "easa-ahmed-easa-bin-salman-alnuaimi",
    "name": "EASA AHMED EASA A BIN SALMAN ALNEAIMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/01/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Easa Ahmed Easa Bin Salman Alnuaimi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ccd8497c-f91a-4228-8be6-cf42bddfe542",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1401",
    "licenseIssueDate": "01/23/2020 00:00:00",
    "licenseExpiryDate": "01/22/2026 00:00:00"
  },
  {
    "id": "61bd210e-2b81-46af-8fd8-487b7627c679",
    "slug": "ebrahim-ali-almousa",
    "name": "EBRAHIM ALI ALMOUSA ALHAMMADI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Commercial Agency",
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Civil Transactions-Insurance",
      "Commercial Transactions-Commercial Mortgage",
      "Criminal Law-Family Crimes",
      "Personal Status-Custody & Alimony",
      "Commercial Transactions-Commercial Contracts",
      "Civil Transactions-Residential Real Estate",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Criminal Law-Hate crimes",
      "Civil Transactions-Tenancy",
      "Commercial Transactions-Unfair competition",
      "Criminal Law-Crimes against persons",
      "Commercial Transactions-Commercial Companies",
      "Commercial Transactions-Banking Operations",
      "Criminal Law-Drug Crimes",
      "Civil Transactions-Sale",
      "Proceedings-Cases and Proceedings before arbitral tribunals and other alternative dispute resolution bodies",
      "Commercial Transactions-Consumer protection",
      "Personal Status-Marriage & Divorce",
      "Personal Status-Child Abuse & Abduction",
      "Civil Transactions-Compensation",
      "Criminal Law-Crimes against properties",
      "Commercial Transactions-E-Commerce",
      "Criminal Law-Cybercrimes",
      "Commercial Transactions-Intellectual Property (includes trademarks",
      "copy rights",
      "patents)"
    ],
    "experience": 17,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/03/2008",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: EBRAHIM ALI ALMOUSA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_61bd210e-2b81-46af-8fd8-487b7627c679",
        "address": "الخامس ,مونتانا ,هوم سنتر ,28834 ,Dubai",
        "phone": "97143963739",
        "email": "mousaadv@eim.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "af9dbfb0-4310-41bb-90aa-a3055b865d84",
    "firmName": "EBRAHIM ALI AL MOUSA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-626",
    "licenseIssueDate": "03/03/2008 00:00:00",
    "licenseExpiryDate": "03/02/2026 00:00:00"
  },
  {
    "id": "37efa163-19ac-4cc0-b23e-12a1a1b29914",
    "slug": "ebrahim-mohammed-abdulla-rashid-alyamazi-altenaiji",
    "name": "EBRAHIM MOHAMMED ABDULLA R.A.ALTENAIJI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/03/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ebrahim Mohammed Abdulla Rashid Alyamazi Altenaiji",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_37efa163-19ac-4cc0-b23e-12a1a1b29914",
        "address": "4th Floor/ Office no. 401 ,Business Avenue  ,Infront- Terminal 2  ,115263 ,Dubai",
        "phone": "97144518866",
        "email": "info@aldhaheriinternational.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "cf3c19c0-d396-4bcb-b1db-b81273ed0b4c",
    "firmName": "AL DHAHERI INTERNATIONAL ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-743",
    "licenseIssueDate": "03/08/2011 00:00:00",
    "licenseExpiryDate": "03/07/2026 00:00:00"
  },
  {
    "id": "391ea97d-baab-41df-9429-4cb63a4f26ce",
    "slug": "ebrahim-moosa-ali-murad-albelooshi",
    "name": "EBRAHIM MOOSA ALI MURAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 15,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/08/2010",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ebrahim Moosa Ali Murad Albelooshi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_391ea97d-baab-41df-9429-4cb63a4f26ce",
        "address": "الطابق الثاني عشر - مكتب رقم 1203 ,برج سيتاديل ,مقابل فندق جي دبليو ماريوت ,91427 ,Dubai",
        "phone": "97143629899",
        "email": "md@imlawyeruae.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "6735fd57-e905-4af6-a113-cc1e784b2510",
    "firmName": "EBRAHIM MOOSA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-638",
    "licenseIssueDate": "08/29/2010 00:00:00",
    "licenseExpiryDate": "08/28/2026 00:00:00"
  },
  {
    "id": "d30d0944-d236-4b55-b7a3-e1ff0d0456d5",
    "slug": "ebtesam-hossein-ahmad-chreaghi-moezabadi",
    "name": "EBTESAM HOSSEIN AHMAD CHREAGHI MOEZABADI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/14/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: EBTESAM HOSSEIN AHMAD CHREAGHI MOEZABADI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d30d0944-d236-4b55-b7a3-e1ff0d0456d5",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "1885",
    "licenseIssueDate": "11/14/2023 00:00:00",
    "licenseExpiryDate": "11/13/2025 00:00:00"
  },
  {
    "id": "61629a63-4195-4ef5-855d-928fec45aead",
    "slug": "eiman-abdulla-saad-salem-alkhanbashi",
    "name": "KHADEEJA SAEED MUBARAK M REHAN ALZAABI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Commercial Agency",
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Civil Transactions-POA & Sponsorship",
      "Civil Transactions-Insurance",
      "Personal Status-Custody & Alimony",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Civil Transactions-Tenancy",
      "Criminal Law-Drug Crimes",
      "Civil Transactions-Sale",
      "Commercial Transactions-Sea and air freight",
      "Personal Status-Marriage & Divorce",
      "Civil Transactions-Compensation",
      "Criminal Law-Crimes against properties",
      "Criminal Law-Cybercrimes",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/08/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: EIMAN ABDULLA SAAD SALEM ALKHANBASHI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_61629a63-4195-4ef5-855d-928fec45aead",
        "address": "",
        "phone": "97145799599 / 971457995992",
        "email": "info@lmlegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "fed194c9-41cf-42f3-888e-924faa26b282",
    "firmName": "OBAID AL EBRI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-2022",
    "licenseIssueDate": "09/13/2024 00:00:00",
    "licenseExpiryDate": "09/12/2026 00:00:00"
  },
  {
    "id": "1ddc6a2c-0b7f-4eca-8392-104f92c0bcc2",
    "slug": "eisa-ahmed-ali-bintowaih-alsuwaidi",
    "name": "EISA AHMED ALI BINTOWAIH ALSUWAIDI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/06/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Eisa Ahmed Ali Bintowaih Alsuwaidi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1ddc6a2c-0b7f-4eca-8392-104f92c0bcc2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1091",
    "licenseIssueDate": "06/05/2016 00:00:00",
    "licenseExpiryDate": "06/04/2026 00:00:00"
  },
  {
    "id": "7bed86a4-0669-48f2-b53c-28980208ccab",
    "slug": "eisa-ahmed-ali-shattaf-alali",
    "name": "EISA AHMED ALI OBAID SHATTAF",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/04/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Eisa Ahmed Ali Shattaf Alali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7bed86a4-0669-48f2-b53c-28980208ccab",
        "address": "mansoor lootah ,مطعم شيلز ,صالح بن لاحج , مطعم شيلز  ,95151 ,Dubai",
        "phone": "97142833337 / 971559596445",
        "email": "info@mansoorlootahadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "4488ad94-e6b8-4b33-8e21-04e8986bf218",
    "firmName": "MANSOOR LOOTAH ADVOCATES &LEGAL CONSULTANCY",
    "registrationNumber": "L-1175",
    "licenseIssueDate": "04/18/2017 00:00:00",
    "licenseExpiryDate": "04/22/2026 00:00:00"
  },
  {
    "id": "5856789a-5a3c-400c-80df-76fe0cb17182",
    "slug": "eisa-hassan-abdallah-alhassouni",
    "name": "Eisa Hassan Abdallah Alhassouni",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/03/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Eisa Hassan Abdallah Alhassouni",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5856789a-5a3c-400c-80df-76fe0cb17182",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "1704",
    "licenseIssueDate": "10/03/2022 00:00:00",
    "licenseExpiryDate": "10/02/2026 00:00:00"
  },
  {
    "id": "0e1b55de-28d7-4cdd-a626-962fd60c522b",
    "slug": "eisa-mohammed-faqeir-alblooshi",
    "name": "Eisa Mohammed Faqeir Alblooshi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/27/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Eisa Mohammed Faqeir Alblooshi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0e1b55de-28d7-4cdd-a626-962fd60c522b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "1713",
    "licenseIssueDate": "10/27/2022 00:00:00",
    "licenseExpiryDate": "10/26/2025 00:00:00"
  },
  {
    "id": "85bce963-0a29-4cf3-9d0e-6653a29ba9aa",
    "slug": "eisa-salem-ahmed-alharsi-almahri",
    "name": "EISSA SALEM AHMED ALHARSI ALMAHRI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/05/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Eisa Salem Ahmed Alharsi Almahri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_85bce963-0a29-4cf3-9d0e-6653a29ba9aa",
        "address": "Eissa Salem ,911 ,ALFATTAN PLAZA ,مقابل مطار دبي، مبنى الوصول 1 ,26141 ,Dubai",
        "phone": "97143484809 / 971502226366",
        "email": "info.admin@eslawyers.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "3b88b4a9-6858-4b28-a99f-b982d1cc2ea7",
    "firmName": "EISA SALEM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1085",
    "licenseIssueDate": "05/29/2016 00:00:00",
    "licenseExpiryDate": "05/28/2026 00:00:00"
  },
  {
    "id": "4fd233de-9548-4974-9e21-908e368bceae",
    "slug": "eisa-salim-ali-salim-alqaydi",
    "name": "EISA SALIM ALI SALIM ALQAYDI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/06/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Eisa Salim Ali Salim Alqaydi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4fd233de-9548-4974-9e21-908e368bceae",
        "address": "Office No. 102 ,Mohammed Bu Farousha Building ,Makani No: 3240794064 ,000 ,Dubai",
        "phone": "97143304403 / 971509991543",
        "email": "alqaydi@esqadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "c13d6ec8-66e4-4366-a35a-da9ebde7e7c5",
    "firmName": "EISA SALIM ALQAYDI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1366",
    "licenseIssueDate": "06/30/2019 00:00:00",
    "licenseExpiryDate": "06/29/2026 00:00:00"
  },
  {
    "id": "d6494cb9-d3f3-4198-9a15-997e1bdf8999",
    "slug": "eissa-mohammed-saleh-abdulla-alhousaani",
    "name": "EISSA MOHAMMED SALEH ABDULLA ALHOUSAANI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 15,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/18/2009 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: EISSA MOHAMMED SALEH ABDULLA ALHOUSAANI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d6494cb9-d3f3-4198-9a15-997e1bdf8999",
        "address": "EISSA MOHAMMED SALEH ALHOUSAANI ,الطابق الثانى مكتب رقم 203  ,اوبال تاور  ,مصرف الامارات الاسلامى  ,22856 ,Dubai",
        "phone": "97143992229",
        "email": "e.alhousani@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "b4cf66fb-0b00-4b16-b27a-932fcb898cda",
    "firmName": "EISSA ALHOUSANI ADVOCATE LEGAL CONSULTANT",
    "registrationNumber": "683",
    "licenseIssueDate": "11/18/2009 00:00:00",
    "licenseExpiryDate": "11/17/2025 00:00:00"
  },
  {
    "id": "ce259ffc-67d9-42e0-ad50-78ca05794f87",
    "slug": "elias-abi-younes",
    "name": "REEM AWAD ALABED ALI ALAMERI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/02/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Elias Abi Younes",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ce259ffc-67d9-42e0-ad50-78ca05794f87",
        "address": "ROULA MAALOUF ,5- UNIT 514 ,LIBERTY HOUSE ,RITZ HOTEL DIFC ,506949 ,Dubai",
        "phone": "97148359858",
        "email": "issa@iaalo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "ee41a5ea-49b1-4cd3-950b-d073f9bf8158",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1765",
    "licenseIssueDate": "02/23/2023 00:00:00",
    "licenseExpiryDate": "02/22/2026 00:00:00"
  },
  {
    "id": "7605c3c0-39f8-4435-9c30-7a89c667f21f",
    "slug": "elias-wadih-hanna",
    "name": "ELIAS WADIH HANNA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 31,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/11/1993",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Elias Wadih Hanna",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7605c3c0-39f8-4435-9c30-7a89c667f21f",
        "address": "الخامس  ,مكاتب عود ميثاء ,فندق رافلز ,11268 ,Dubai",
        "phone": "97143243330",
        "email": "avocat@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "25d2c9bd-dbba-41ac-aff9-5ba0f37290d6",
    "firmName": "AL QARI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-259",
    "licenseIssueDate": "11/23/1993 00:00:00",
    "licenseExpiryDate": "11/22/2025 00:00:00"
  },
  {
    "id": "c1713f7f-2e84-4233-a70b-414a97ddbad4",
    "slug": "emad-juma-husain-ali-ahli",
    "name": "EMAD JUMA HUSSAIN ALI AHLI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 27,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/05/1998",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Emad Juma Husain Ali Ahli",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c1713f7f-2e84-4233-a70b-414a97ddbad4",
        "address": "",
        "phone": "97143352000",
        "email": "info@alahlialkhaja.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "34476e35-fd77-4a2d-9ad0-cf8cca5e403a",
    "firmName": "AL AHLI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-340",
    "licenseIssueDate": "06/01/1998 00:00:00",
    "licenseExpiryDate": "05/31/2026 00:00:00"
  },
  {
    "id": "7a109ca1-35f9-480f-8114-8acde1d245fd",
    "slug": "eman-abdalla-sabt-salim-alhammadi",
    "name": "EMAN ABDALLA SABT SALIM ALHAMMADI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/07/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Eman Abdalla Sabt Salim Alhammadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7a109ca1-35f9-480f-8114-8acde1d245fd",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-826",
    "licenseIssueDate": "07/23/2012 00:00:00",
    "licenseExpiryDate": "07/22/2026 00:00:00"
  },
  {
    "id": "cf078db0-54ec-4596-b2a6-19610a5a2774",
    "slug": "eman-ahmed-abdelrahman-abdalla-alabdouli",
    "name": "MARYAM SAEED HUMAID ABDULLA ALARAJ",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/09/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: eman ahmed abdelrahman abdalla alabdouli",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cf078db0-54ec-4596-b2a6-19610a5a2774",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1871",
    "licenseIssueDate": "10/11/2023 00:00:00",
    "licenseExpiryDate": "10/10/2026 00:00:00"
  },
  {
    "id": "df2258fe-e169-4b87-86cc-3917449896e4",
    "slug": "eman-asad-akbar-asad-al-amiri",
    "name": "EMAN ASAD AKBAR ASAD ALAMEERI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 20,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/08/2005",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Eman Asad Akbar Asad Al-Amiri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_df2258fe-e169-4b87-86cc-3917449896e4",
        "address": "",
        "phone": "97144230000 / 971552009022",
        "email": "UAE-CourtClerks@habibalmulla.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "3eba82bb-8ec4-4cbd-80d0-a793cb993fde",
    "firmName": "HABIB ALMULLA & PARTNERS",
    "registrationNumber": "L-524",
    "licenseIssueDate": "08/03/2005 00:00:00",
    "licenseExpiryDate": "08/02/2026 00:00:00"
  },
  {
    "id": "5c192c80-9cd6-4a68-9056-4a795a46f078",
    "slug": "eman-hassan-ali-mohammad-al-ali",
    "name": "IMAN HASSAN ALI AL ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/05/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Eman Hassan Ali Mohammad Al Ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5c192c80-9cd6-4a68-9056-4a795a46f078",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1084",
    "licenseIssueDate": "05/29/2016 00:00:00",
    "licenseExpiryDate": "05/28/2026 00:00:00"
  },
  {
    "id": "62a841f3-9e43-444b-976c-be1b4bdf3771",
    "slug": "eman-jalal-ahmad-abdulla-koodarzi",
    "name": "EMAN JALAL AHMAD ABDULLA KOODARZI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/07/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Eman Jalal Ahmad Abdulla Koodarzi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_62a841f3-9e43-444b-976c-be1b4bdf3771",
        "address": "Gamal Yassein Abdalla ,الطابق 13  Floor No 13 ,بناية مركز ابروي (The Oberoi Center) ,فندق ابروي (The Oberoi Hotel) ,33299 ,Dubai",
        "phone": "97142828000",
        "email": "litigation@alaidarous.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "9a923766-1fd1-4e06-a871-89662120384e",
    "firmName": "AL AIDAROUS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-829",
    "licenseIssueDate": "07/24/2012 00:00:00",
    "licenseExpiryDate": "07/23/2026 00:00:00"
  },
  {
    "id": "e6f6f60c-674a-4e25-844a-3ed10cf5b402",
    "slug": "eman-musallam-rashid-alriyami",
    "name": "EMAN MUSALLAM RASHID ALRIYAMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/01/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Eman Musallam Rashid Alriyami",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e6f6f60c-674a-4e25-844a-3ed10cf5b402",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-849",
    "licenseIssueDate": "01/16/2013 00:00:00",
    "licenseExpiryDate": "01/15/2026 00:00:00"
  },
  {
    "id": "ad96fc83-d838-46ba-8c0a-64298e78bf5d",
    "slug": "enas-abdulla-naji-almaznaei",
    "name": "KHADIJA AHMED MOHAMMED ALI AL MEER",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/04/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Enas Abdulla Naji Almaznaei",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ad96fc83-d838-46ba-8c0a-64298e78bf5d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1801",
    "licenseIssueDate": "05/17/2023 00:00:00",
    "licenseExpiryDate": "05/16/2026 00:00:00"
  },
  {
    "id": "cbadea5b-4764-4c24-8f21-2d98b6757648",
    "slug": "engy-nabeel-mahmood",
    "name": "ENGY NABEEL MAHMOOD ALI HASAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 15,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/03/2010",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Engy Nabeel Mahmood",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cbadea5b-4764-4c24-8f21-2d98b6757648",
        "address": "engy nabeel ,609 ,Business Avenue Building ,خلف معرض نيسان للسيارات ,114332 ,Dubai",
        "phone": "97142666983 / 971505049385",
        "email": "mtgdubai@mtglegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "2c10c414-70fa-4a29-b8ce-a320239738ad",
    "firmName": "ENGY NABEEL ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-703",
    "licenseIssueDate": "03/18/2010 00:00:00",
    "licenseExpiryDate": "03/17/2026 00:00:00"
  },
  {
    "id": "c01ed850-cd63-4387-beaa-d2ee0ebe202e",
    "slug": "esam-abdelraman-hassan-ali-alzarooni",
    "name": "SARA ABDULHAMID W O DR AHMED A ALKANDARI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/11/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: esam abdelraman hassan ali alzarooni",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c01ed850-cd63-4387-beaa-d2ee0ebe202e",
        "address": "",
        "phone": "97100000000 / 971504766660",
        "email": "info@eza.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "f6dee20d-9392-4f89-96bd-b1f89bcef71a",
    "firmName": "GULF CONSULTANT ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-1600",
    "licenseIssueDate": "12/15/2021 00:00:00",
    "licenseExpiryDate": "12/14/2025 00:00:00"
  },
  {
    "id": "b2be8675-04e1-4976-904e-1e82da275fc3",
    "slug": "essa-abdull-lateef-mohammed-al-zarawni",
    "name": "EISSA ABDULATIF MOHAMED A ALZAROONI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 22,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/02/2003",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Essa Abdull Lateef Mohammed Al Zarawni",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b2be8675-04e1-4976-904e-1e82da275fc3",
        "address": "",
        "phone": "97142955388 / 971507739863",
        "email": "arhilal@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "364483f1-f3e9-4475-a7de-733d3e03062c",
    "firmName": "HILAL &ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-151",
    "licenseIssueDate": "02/18/2003 00:00:00",
    "licenseExpiryDate": "02/17/2026 00:00:00"
  },
  {
    "id": "a4d260fc-52bc-4e7a-973c-625000f75e82",
    "slug": "essa-abdullah-heedar-bin-heedar",
    "name": "ISA ABDULLA HAIDER OBAID BIN HAIDER",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 28,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/10/1997",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Essa Abdullah Heedar Bin Heedar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a4d260fc-52bc-4e7a-973c-625000f75e82",
        "address": "18 ,فندق مونارك  ,مركز التجاري ,98444 ,Dubai",
        "phone": "97143588777",
        "email": "info@bhadvoc.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "61266d12-f5b4-4466-a1a8-a45934d9e511",
    "firmName": "BIN HAIDER ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-299",
    "licenseIssueDate": "10/04/1997 00:00:00",
    "licenseExpiryDate": "10/03/2026 00:00:00"
  },
  {
    "id": "39fedf10-938a-4137-ba2c-69079ca81518",
    "slug": "essa-aqeel-abdulla-al-shehhi",
    "name": "ISSA AQEEL ABDULLAH ALSHEHHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/03/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Essa Aqeel Abdulla Al Shehhi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_39fedf10-938a-4137-ba2c-69079ca81518",
        "address": "khalid al kaitoob ,12 ,نسيمية تاور الطابق 12 1202 B ,فندق الفوكو  ,10755 ,Dubai",
        "phone": "97143586555",
        "email": "info@alkaitooblawyer.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "403277a6-eef2-4cfd-af95-9959280d6b40",
    "firmName": "AL KAITOOB ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-924",
    "licenseIssueDate": "03/24/2014 00:00:00",
    "licenseExpiryDate": "03/23/2026 00:00:00"
  },
  {
    "id": "8d4719e3-a581-4e65-8839-0e25b21f08b9",
    "slug": "essa-mohammed-muhana-majid-al-noaimi",
    "name": "EISA MOHAMED MUHANNA MAJID ALNUAIMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/10/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Essa Mohammed Muhana Majid Al Noaimi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8d4719e3-a581-4e65-8839-0e25b21f08b9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-184",
    "licenseIssueDate": "10/19/2011 00:00:00",
    "licenseExpiryDate": "10/18/2026 00:00:00"
  },
  {
    "id": "180b9dc2-f663-43d4-ac22-224ecee7504d",
    "slug": "essa-zeyad-abdulla-ibrahim-galadari",
    "name": "ESSA ZIYAD ABDULLA IBRAHIM GALADARI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFWgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/03/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Essa Zeyad Abdulla Ibrahim Galadari",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_180b9dc2-f663-43d4-ac22-224ecee7504d",
        "address": "",
        "phone": "97143937700",
        "email": "info@galadarilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "d863b662-c864-4193-8b3a-ff6ee5fe6c64",
    "firmName": "GALADARI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1512",
    "licenseIssueDate": "03/02/2021 00:00:00",
    "licenseExpiryDate": "03/01/2026 00:00:00"
  },
  {
    "id": "f2b326c4-77ec-4f88-a882-25bb9146a674",
    "slug": "essam-abdulamir-hammadi-alfadhli-al-temimi",
    "name": "ESSAM ABDULAMIR ALFADHLI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 36,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/04/1989",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Essam Abdulamir Hammadi Alfadhli Al-Temimi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f2b326c4-77ec-4f88-a882-25bb9146a674",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-191",
    "licenseIssueDate": "04/13/1989 00:00:00",
    "licenseExpiryDate": "04/12/2026 00:00:00"
  },
  {
    "id": "0d549cb5-290f-4f39-a689-c2a25b2db85b",
    "slug": "fadi-hayel-al-hourani",
    "name": "FADI HAYEL HOURANI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 47,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/04/1978",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Fadi Hayel Al-Hourani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0d549cb5-290f-4f39-a689-c2a25b2db85b",
        "address": "Fadi H. Hourani ,3 ,The Offices 5, One Central ,The Museum of the Future ,10152 ,Dubai",
        "phone": "97142052000",
        "email": "info@houranipartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "c7a17e12-3d49-4166-82c8-271a6d223675",
    "firmName": "HOURANI & PARTNERS",
    "registrationNumber": "L-58",
    "licenseIssueDate": "04/30/1978 00:00:00",
    "licenseExpiryDate": "04/29/2026 00:00:00"
  },
  {
    "id": "e2b56a47-45c5-45b8-9737-e4c9dd5c1856",
    "slug": "fadil-ahmed-ramadan-ali-alzarooni",
    "name": "AYSHA AHMED SULTAN KHAMIS ALKAABI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/07/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: FADIL AHMED RAMADAN ALI ALZAROONI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e2b56a47-45c5-45b8-9737-e4c9dd5c1856",
        "address": "Amal Khamis Darwish Al Blooshi ,floor23-office2304 ,Aspect Tower ,Bay Avenue ,103951 ,Dubai",
        "phone": "97142276165",
        "email": "info@amalkhamisadvo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "99eb0f0c-7559-4826-a035-6f38ef3676a9",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1830",
    "licenseIssueDate": "07/16/2023 00:00:00",
    "licenseExpiryDate": "07/15/2026 00:00:00"
  },
  {
    "id": "ae00762f-cb70-4e56-80e5-df5005750c76",
    "slug": "fahad-abdalla-qambar-mohamed",
    "name": "Fahad Abdalla Qambar Mohamed",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/07/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Fahad Abdalla Qambar Mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ae00762f-cb70-4e56-80e5-df5005750c76",
        "address": "الثالث  ,اركاد  ,الطاير للسيارات  ,20877 ,Dubai",
        "phone": "97142833355",
        "email": "Fahadadvo@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "7dd7860a-cd36-443b-a1b7-62dd3050e6b9",
    "firmName": "FAHAD ABDULLA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "930",
    "licenseIssueDate": "04/07/2014 00:00:00",
    "licenseExpiryDate": "04/06/2026 00:00:00"
  },
  {
    "id": "66a6eee4-a75c-4ba1-a3cb-47e35c8eff4e",
    "slug": "fahad-ahmad-ali-mohammad-bin-tamim",
    "name": "FAHAD AHMAD ALI MOHAMMAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/05/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Fahad Ahmad Ali Mohammad Bin Tamim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_66a6eee4-a75c-4ba1-a3cb-47e35c8eff4e",
        "address": "",
        "phone": "97143380333",
        "email": "info@fahadbintamim.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "6924283e-95b7-4af2-85a3-cc6cbcc10a20",
    "firmName": "FAHAD BIN TAMIM ADVOCATES & LEGAL CONSULTANTCY",
    "registrationNumber": "L-873",
    "licenseIssueDate": "05/16/2013 00:00:00",
    "licenseExpiryDate": "05/15/2026 00:00:00"
  },
  {
    "id": "1d16eaf7-71b0-4ecc-8018-929cded956f2",
    "slug": "fahad-bin-rahsed-bin-essa-bin-adbulatif-alserkal",
    "name": "FAHAD BIN RASHED BIN ESSA BIN ABDULLATIF",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/01/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Fahad bin Rahsed Bin Essa Bin Adbulatif Alserkal",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1d16eaf7-71b0-4ecc-8018-929cded956f2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1496",
    "licenseIssueDate": "01/16/2021 00:00:00",
    "licenseExpiryDate": "01/15/2026 00:00:00"
  },
  {
    "id": "ea224012-3cbe-4a9f-b3fa-ef431a80362f",
    "slug": "fahad-ibrahim-abdulrahman-mohammed-al-sabhan",
    "name": "DR FAHAD IBRAHIM A MOHAMMAD ALSABHAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 25,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/04/2000",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Fahad Ibrahim Abdulrahman Mohammed Al-Sabhan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ea224012-3cbe-4a9f-b3fa-ef431a80362f",
        "address": "",
        "phone": "97143474007",
        "email": "info@alsabhanlegalgroup.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "c31ad0e5-b382-4c9a-9fab-8853b1330f6b",
    "firmName": "DR AL SABBHAN LEGAL GROUP&ASSOCLATES",
    "registrationNumber": "L-378",
    "licenseIssueDate": "04/16/2000 00:00:00",
    "licenseExpiryDate": "04/17/2026 00:00:00"
  },
  {
    "id": "1632fb2b-9823-4433-9dcc-bc5fc3e08a1b",
    "slug": "fahad-mohamad-ali-nasser",
    "name": "MATAR JUMAH RASHED MUSABBEH",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/11/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Fahad Mohamad Ali Nasser",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1632fb2b-9823-4433-9dcc-bc5fc3e08a1b",
        "address": "Sarhan Hassan Mohamed Hassan Almuaini ,Office 1002, Level 10 ,THE OBEROI CENTRE ,Business Bay Metro Station ,1169 ,Dubai",
        "phone": "97142324000",
        "email": "info@drsarhanlawyer.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "14541022-bde4-43ab-9ba1-489e87187b42",
    "firmName": "HORIZONS & CO - LAW FIRM",
    "registrationNumber": "L-1888",
    "licenseIssueDate": "11/24/2023 00:00:00",
    "licenseExpiryDate": "11/23/2025 00:00:00"
  },
  {
    "id": "1ed55b01-7ee4-4a21-9ffd-423957e9a7c4",
    "slug": "fahad-mohammed-abdulla-khamis-alhosani",
    "name": "Fahad Mohammed Abdulla Khamis Alhosani",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/25/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Fahad Mohammed Abdulla Khamis Alhosani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1ed55b01-7ee4-4a21-9ffd-423957e9a7c4",
        "address": "fahad alhosani ,Office No. 1006 ,ASPECT TOWER ,Near Burj Khalifa ,000 ,Dubai",
        "phone": "97100000000 / 971551111723",
        "email": "info@fahadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "aea24945-594d-49dd-8077-830efa5e95ff",
    "firmName": "FAHAD ALHOSANI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "1854",
    "licenseIssueDate": "08/25/2023 00:00:00",
    "licenseExpiryDate": "08/24/2026 00:00:00"
  },
  {
    "id": "74330243-c12f-4b0d-b462-f35734bf552d",
    "slug": "fahad-saeed-alsumm-alzeyoudi",
    "name": "FAHAD SAEED ALI SAEED AL SUMM ALZEYOUDI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/05/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Fahad Saeed Alsumm Alzeyoudi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_74330243-c12f-4b0d-b462-f35734bf552d",
        "address": "الخطوط الاردنية ,بيزنس افينو ,الرستماني  ,00 ,Dubai",
        "phone": "97145468245 / 971505003153",
        "email": "AJ@alzeyoudiadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "920b183d-3abe-4de5-8df6-79ab571d2d74",
    "firmName": "FAHAD SAEED ALZEYOUDI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1077",
    "licenseIssueDate": "05/29/2016 00:00:00",
    "licenseExpiryDate": "05/28/2026 00:00:00"
  },
  {
    "id": "35666cc5-2f2e-43d6-9dd6-e883281dfdc6",
    "slug": "fahad-sultan-ali-lootah",
    "name": "FAHAD SULTAN ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 35,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/10/1990",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Fahad Sultan Ali Lootah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_35666cc5-2f2e-43d6-9dd6-e883281dfdc6",
        "address": "",
        "phone": "97142957333",
        "email": "info@lootah-law.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "f33057ab-5fd7-4d0d-87ad-9fe76e01c0af",
    "firmName": "LOOTAH ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-206",
    "licenseIssueDate": "10/06/1990 00:00:00",
    "licenseExpiryDate": "10/05/2026 00:00:00"
  },
  {
    "id": "96311e22-0836-4900-846f-84d902d056cd",
    "slug": "fahd-mohamed-rashid-al-hadouri-al-yamahi",
    "name": "FAHD MOHAMED RASHED ALHADOURI ALYAMMAHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/10/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Fahd Mohamed Rashid Al Hadouri Al Yamahi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_96311e22-0836-4900-846f-84d902d056cd",
        "address": "FAHD MOHAMED RASHED ALHADOURI ALYAMMAHI ,10 ,MAZE TOWER ,DIFC - FUTURE MUSEUM ,127077 ,Dubai",
        "phone": "97143596555",
        "email": "fhd6767@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "4e636842-b67d-49a6-a11f-607b9a136380",
    "firmName": "NOURA ALHAJERI AND FAHD ALHADOURI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-895",
    "licenseIssueDate": "10/27/2013 00:00:00",
    "licenseExpiryDate": "10/26/2026 00:00:00"
  },
  {
    "id": "290e906d-c387-45b2-bdc5-0f6a6d9bfaf9",
    "slug": "fahed-sultan-mohamed-baharoon-al-ali",
    "name": "FAHED SULTAN MOHAMED BAHAROON AL ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/11/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: FAHED SULTAN MOHAMED BAHAROON AL-ALI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_290e906d-c387-45b2-bdc5-0f6a6d9bfaf9",
        "address": "Obaid Ishaq Ismail Al-Maazmi ,الطابق 21 ,ذا اكستشينج تاور  ,فندق جي دبليو ماريوت ماركي ,238365 ,Dubai",
        "phone": "97143584737",
        "email": "obaidotp@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "70a8fb70-2729-4348-b87b-258c7dc7a387",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1595",
    "licenseIssueDate": "11/15/2021 00:00:00",
    "licenseExpiryDate": "11/14/2025 00:00:00"
  },
  {
    "id": "15cf157a-1a59-4b77-a196-f5859867338d",
    "slug": "fahmi-omar-abdulla-mukhayer",
    "name": "ABDULLA ABDOU SAEED AHMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/06/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Fahmi Omar Abdulla Mukhayer",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_15cf157a-1a59-4b77-a196-f5859867338d",
        "address": "ABDULRAHMAN OMAR  ABDULLA MUKHAYER  ,NBK BANK ,LATIFA TOWER  ,NEAR CROWN PLAZA  ,185616 ,Dubai",
        "phone": "97143296968",
        "email": "hlp@hlplawfirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "617b9580-cff5-4ffa-b2bc-8788300a3c6e",
    "firmName": "GALADARI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-2001",
    "licenseIssueDate": "07/10/2024 00:00:00",
    "licenseExpiryDate": "07/09/2026 00:00:00"
  },
  {
    "id": "b27c6496-3c73-4c89-a20c-a0d021abf482",
    "slug": "faisal-abdalla-hassan-alnsour",
    "name": "FAISAL ABDALLA HASSAN ALANSARI ALNSOUR",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 19,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/11/2005",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-11-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: FAISAL ABDALLA HASSAN ALNSOUR",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b27c6496-3c73-4c89-a20c-a0d021abf482",
        "address": "Office No. 049 - 1603 ,Al Moosa Tower 1 ,Makani No: 26486900052 ,000 ,Dubai",
        "phone": "97143445789 / 971503571571",
        "email": "legal@faisalalnsouradvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "49438fce-e755-46d9-80f0-c9316172970a",
    "firmName": "FAISAL ALNSOUR ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-532",
    "licenseIssueDate": "11/15/2005 00:00:00",
    "licenseExpiryDate": "11/14/2025 00:00:00"
  },
  {
    "id": "b8ee7f2a-33ba-491a-99c4-78627702464e",
    "slug": "faisal-abdulrahman-abdulrahim",
    "name": "ABDULRAHMAN ABDULRAHIM ABDULRAHMAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/11/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Faisal Abdulrahman Abdulrahim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b8ee7f2a-33ba-491a-99c4-78627702464e",
        "address": "301 ,Clover Bay Tower ,Burj Khalifa ,414077 ,Dubai",
        "phone": "97145135166",
        "email": "info@faisalalzarooni.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "896b6ab4-30f1-4f72-86fe-c7ea8653a027",
    "firmName": "FAISAL ALZAROONI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-841",
    "licenseIssueDate": "11/21/2012 00:00:00",
    "licenseExpiryDate": "11/20/2025 00:00:00"
  },
  {
    "id": "1a919ec6-098f-4f88-a3fb-1a4801f99701",
    "slug": "faisal-ahmad-ali-al-haddad-alhazmi",
    "name": "Faisal Ahmad Ali Al Haddad AlHazmi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/27/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Faisal Ahmad Ali Al Haddad AlHazmi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1a919ec6-098f-4f88-a3fb-1a4801f99701",
        "address": "الطابق الخامس ,الساحة ,سوق البحار ,26011 ,Dubai",
        "phone": "97142277717",
        "email": "info@alsahlawico.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "a6811a79-5470-4c33-ad95-3ff8f661c052",
    "firmName": "AL SAHLAWI & CO ADVOCATES & CONSULTANTS",
    "registrationNumber": "1661",
    "licenseIssueDate": "05/27/2022 00:00:00",
    "licenseExpiryDate": "05/26/2026 00:00:00"
  },
  {
    "id": "8f6a932b-8ff6-48dd-a056-03a7074c23e6",
    "slug": "faisal-essa-alqasim",
    "name": "KHALID IBRAHIM HUSSAIN MAHMOOD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/02/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Faisal essa alqasim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8f6a932b-8ff6-48dd-a056-03a7074c23e6",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1628",
    "licenseIssueDate": "02/22/2022 00:00:00",
    "licenseExpiryDate": "02/21/2026 00:00:00"
  },
  {
    "id": "81ca8655-07bb-4337-aa11-d965318f75fc",
    "slug": "faisal-hamad-nour-mohammed-almula-alblooshi",
    "name": "FAISAL HAMAD NOUR MOHAMMED ALMULA ALBLOOSHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/04/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Faisal Hamad Nour Mohammed Almula Alblooshi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_81ca8655-07bb-4337-aa11-d965318f75fc",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1276",
    "licenseIssueDate": "04/30/2018 00:00:00",
    "licenseExpiryDate": "04/29/2026 00:00:00"
  },
  {
    "id": "9988dd27-ecac-4481-adb3-5ac791c99fff",
    "slug": "faisal-hassan-ali-alshehhi",
    "name": "ALI RASHID ALI SAIF ALMANSOORI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/08/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: faisal hassan ali alshehhi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9988dd27-ecac-4481-adb3-5ac791c99fff",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1851",
    "licenseIssueDate": "08/24/2023 00:00:00",
    "licenseExpiryDate": "08/23/2026 00:00:00"
  },
  {
    "id": "ad29cd27-aae3-4364-8d5c-cd79689a676b",
    "slug": "faisal-rashed-obaid-bin-dawi-alneaimi",
    "name": "Faisal Rashed Obaid Bin Dawi Alneaimi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/29/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Faisal Rashed Obaid Bin Dawi Alneaimi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ad29cd27-aae3-4364-8d5c-cd79689a676b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "1427",
    "licenseIssueDate": "06/29/2020 00:00:00",
    "licenseExpiryDate": "06/28/2026 00:00:00"
  },
  {
    "id": "08ce9cba-3105-49e5-a5c4-929f727086aa",
    "slug": "faisal-saeed-ali-binzaal-aldhaheri",
    "name": "SHAHAD YOUSIF ABDALGHAFAR ABDULRAHMAN ABDALGHAFAR",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/05/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: faisal saeed ali binzaal aldhaheri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_08ce9cba-3105-49e5-a5c4-929f727086aa",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1662",
    "licenseIssueDate": "06/09/2022 00:00:00",
    "licenseExpiryDate": "06/08/2026 00:00:00"
  },
  {
    "id": "fdd8bfaf-ffda-41f4-9c33-1891f546e472",
    "slug": "faisal-saeed-mohamed-rashed-alhefeiti",
    "name": "FATIMA YOUSIF W.O.ANWAR Y.M.A. ALTHAHAB",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/07/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: faisal saeed mohamed rashed alhefeiti",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fdd8bfaf-ffda-41f4-9c33-1891f546e472",
        "address": "103 ,DUBAI SUPREME COURT COMPLEX ,DUBAI COURT ,00 ,Dubai",
        "phone": "97143038303 / 971504999947",
        "email": "dr.faisal@lawfaisal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "db28e7c2-7457-4e60-93b2-309b9cd0d259",
    "firmName": "ALPHA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1842",
    "licenseIssueDate": "08/15/2023 00:00:00",
    "licenseExpiryDate": "08/14/2026 00:00:00"
  },
  {
    "id": "c326e998-f87d-46d8-9951-837f059b1553",
    "slug": "faisal-salem-fairooz-salem",
    "name": "FAISAL SALEM FAIROOZ SALEM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/09/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Faisal Salem Fairooz Salem",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c326e998-f87d-46d8-9951-837f059b1553",
        "address": "",
        "phone": "97145132619 / 971543630593",
        "email": "info@alfaisal.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "fd647c60-3bff-4297-87f1-6437acf45575",
    "firmName": "FAISAL SALEM ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-1221",
    "licenseIssueDate": "09/07/2017 00:00:00",
    "licenseExpiryDate": "09/06/2026 00:00:00"
  },
  {
    "id": "e5d68dd4-c687-40a9-8e9b-364745fcc3b1",
    "slug": "faisal-younis-zainal-abedeen-alkhaja",
    "name": "FAISAL YOUNIS ZAINAL ABEDEEN ALKHAJA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 15,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/08/2010",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Faisal Younis Zainal Abedeen Alkhaja",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e5d68dd4-c687-40a9-8e9b-364745fcc3b1",
        "address": "",
        "phone": "97143352000",
        "email": "info@alahlialkhaja.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "34476e35-fd77-4a2d-9ad0-cf8cca5e403a",
    "firmName": "AL AHLI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-722",
    "licenseIssueDate": "08/12/2010 00:00:00",
    "licenseExpiryDate": "08/11/2026 00:00:00"
  },
  {
    "id": "b3ba6582-dcce-4d71-beae-3bd69789e100",
    "slug": "falah-anwar-saleh-felaih-mohammad-alsehali",
    "name": "Falah Anwar Saleh Felaih Mohammad Alsehali",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/16/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Falah Anwar Saleh Felaih Mohammad Alsehali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b3ba6582-dcce-4d71-beae-3bd69789e100",
        "address": "khadijah sohail hassan asaadi ,طابق الميزانيين  ,ايميجت  ,مترو الخليج التجاري  ,41342 ,Dubai",
        "phone": "97143438885",
        "email": "info@asaadi.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "264cfea6-1419-45d4-9264-7dba3f26da68",
    "firmName": "KHADIJAH SOHAIL LAWYERS & LEGAL CONSULTANTS",
    "registrationNumber": "812",
    "licenseIssueDate": "05/16/2012 00:00:00",
    "licenseExpiryDate": "05/15/2026 00:00:00"
  },
  {
    "id": "453cb1b5-51ff-41ed-bc64-e9b06e1e8882",
    "slug": "faraj-abdulla-ahnaish-saleh-ahnaish",
    "name": "FARAJ ABDULLA AHNAISH SALEH",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 17,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/05/2008",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Faraj abdulla ahnaish saleh ahnaish",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_453cb1b5-51ff-41ed-bc64-e9b06e1e8882",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-630",
    "licenseIssueDate": "05/27/2008 00:00:00",
    "licenseExpiryDate": "05/26/2026 00:00:00"
  },
  {
    "id": "d1759add-f1a7-4b1c-b9ae-978ea9d647a5",
    "slug": "fareed-abdulla-abdulrahman-al-awadhi",
    "name": "Fareed Abdulla Abdulrahman Al Awadhi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 19,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/14/2006 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Fareed Abdulla Abdulrahman Al Awadhi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d1759add-f1a7-4b1c-b9ae-978ea9d647a5",
        "address": "111 ,AL HATHBOUR ,CANADIAN HOSPITAL ,96555 ,Dubai",
        "phone": "97142656000",
        "email": "alawadhi.advocates@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "b1c98bb5-4fdc-4e2a-8d16-ba2fa7afcace",
    "firmName": "ALAWADHI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "580",
    "licenseIssueDate": "09/14/2006 00:00:00",
    "licenseExpiryDate": "09/13/2026 00:00:00"
  },
  {
    "id": "b1dbf5b4-303c-464c-8819-b50e5ea2b89e",
    "slug": "fareed-fairouz-mohammad-ali-alhassan",
    "name": "FAREED FAIROUZ MOHD ALI HASSAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/08/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Fareed Fairouz Mohammad Ali Alhassan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b1dbf5b4-303c-464c-8819-b50e5ea2b89e",
        "address": "FAREED FAIROUZ MOHD ALI ALHASSAN ,الميزانين - مكتب رقم M03 ,جولدن بيزنس تاور ,خلف معرض نيسان الرستماني ,455067 ,Dubai",
        "phone": "97143266117",
        "email": "Fs4591190fs@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "13bcdb23-b6a5-4aef-a1bc-3d57c5b2034b",
    "firmName": "FAREED ALHASSAN ADVOCATES &LEGAL CONSULTANTS",
    "registrationNumber": "L-1305",
    "licenseIssueDate": "08/05/2018 00:00:00",
    "licenseExpiryDate": "08/04/2026 00:00:00"
  },
  {
    "id": "77185687-678e-4717-a9e2-f271eea00ab5",
    "slug": "farhan-saeed-hmoud-albadi-alateibi",
    "name": "Farhan Saeed Hmoud Albadi Alateibi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/05/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Farhan Saeed Hmoud Albadi Alateibi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_77185687-678e-4717-a9e2-f271eea00ab5",
        "address": "",
        "phone": "/ 97151111146",
        "email": "info@alphalegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "8576864d-ec5e-4834-b800-88160aa2c0a5",
    "firmName": "ALPHA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "1860",
    "licenseIssueDate": "09/05/2023 00:00:00",
    "licenseExpiryDate": "09/04/2026 00:00:00"
  },
  {
    "id": "ee44eed7-cc8d-4b29-a161-2796f4aebe69",
    "slug": "faris-hasan-yousef-mohamed-alhammadi",
    "name": "FARIS HASAN YOUSEF MOHAMED ALHAMMADI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/11/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: FARIS HASAN YOUSEF MOHAMED ALHAMMADI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ee44eed7-cc8d-4b29-a161-2796f4aebe69",
        "address": "",
        "phone": "97142438663",
        "email": "bosabbahmed@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "1d2a0393-9ac4-495c-aa17-4eedfdb418af",
    "firmName": "ALITEZAN ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-1593",
    "licenseIssueDate": "11/04/2021 00:00:00",
    "licenseExpiryDate": "11/03/2025 00:00:00"
  },
  {
    "id": "97c61de6-3d0e-44aa-9d69-07280058ff64",
    "slug": "farouq-abdualla-qambar-mohamed",
    "name": "FAROUQ ABDALLA QAMBAR MOHAMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/11/2008",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: FAROUQ ABDUALLA QAMBAR MOHAMED",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_97c61de6-3d0e-44aa-9d69-07280058ff64",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-645",
    "licenseIssueDate": "11/17/2008 00:00:00",
    "licenseExpiryDate": "11/16/2025 00:00:00"
  },
  {
    "id": "41626399-9c82-4c2a-bcc2-33b5cafc9fd2",
    "slug": "farouq-mohammed-abdulla-mohammed-al-hammadi",
    "name": "FAROUQ MOHAMMED ABDULLA M ALHAMMADI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/10/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Farouq Mohammed Abdulla Mohammed Al Hammadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_41626399-9c82-4c2a-bcc2-33b5cafc9fd2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1574",
    "licenseIssueDate": "10/07/2021 00:00:00",
    "licenseExpiryDate": "10/06/2026 00:00:00"
  },
  {
    "id": "cac5a45d-a20e-4ccd-94df-1383e85ea5db",
    "slug": "fatema-abdulla-khamees-binhukaim-aldahmani",
    "name": "SHAMSA IBRAHIM SAHIBKHAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/02/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: fatema abdulla khamees binhukaim aldahmani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cac5a45d-a20e-4ccd-94df-1383e85ea5db",
        "address": "13 ,Le Solarium Tower ,Arabian Gate ,185430 ,Dubai",
        "phone": "97145805135 / 971558703836",
        "email": "info@alnaqbilaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "24f8f7c8-a688-4587-9e87-f3105a99533a",
    "firmName": "KHALID ABDULLA AL TAMIMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1769",
    "licenseIssueDate": "03/01/2023 00:00:00",
    "licenseExpiryDate": "02/28/2026 00:00:00"
  },
  {
    "id": "b39ecedf-1fea-4ec3-bae1-864989c75666",
    "slug": "fatema-abdulla-mohamed-abdulla-alhammadi",
    "name": "FATEMA ABDULLA MOHAMED ABDULLA ALHAMMADI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/03/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Fatema Abdulla Mohamed Abdulla Alhammadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b39ecedf-1fea-4ec3-bae1-864989c75666",
        "address": "",
        "phone": "97142566800",
        "email": "fatema@alhammadiadvocate.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "07521705-aa90-4c3a-b5fd-c55e54889e60",
    "firmName": "MOHAMED AL HAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1065",
    "licenseIssueDate": "03/24/2016 00:00:00",
    "licenseExpiryDate": "03/23/2026 00:00:00"
  },
  {
    "id": "99d339fa-7281-4f57-806f-cfb7173d6fd2",
    "slug": "fatema-hasan-ahmed-turki-alshehhi",
    "name": "FATEMA HASAN AHMED TURKI ALSHEHHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/05/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: fatema hasan ahmed turki alshehhi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_99d339fa-7281-4f57-806f-cfb7173d6fd2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1531",
    "licenseIssueDate": "05/18/2021 00:00:00",
    "licenseExpiryDate": "05/17/2026 00:00:00"
  },
  {
    "id": "b85daae1-0ec8-4777-9435-70d8d59b5517",
    "slug": "fatema-hasan-sulaiman-alhadboor-alshehhi",
    "name": "FATEMA HASAN SULAIMAN H ALHADBOOR",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/11/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Fatema Hasan Sulaiman Alhadboor Alshehhi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b85daae1-0ec8-4777-9435-70d8d59b5517",
        "address": "الثالث  ,برج جيت  48  ,مخرج ميترو برج خليفه / دبي مول  ,181111 ,Dubai",
        "phone": "97145143423 / 971971451434",
        "email": "info.justice@fhsadvo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "690778ba-3332-4c06-b01f-ab5ec89ee304",
    "firmName": "FATEMA HASAN ALSHEHHI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-1479",
    "licenseIssueDate": "11/17/2020 00:00:00",
    "licenseExpiryDate": "11/16/2025 00:00:00"
  },
  {
    "id": "8ffef1ce-2415-4ba1-8abc-de6eeef0a5e2",
    "slug": "fatema-majed-mehayer-ghanem-alqubaisi",
    "name": "HAMAD MOHAMMED ZAYED SULAIMAN ALEISSAEE",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/06/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Fatema Majed Mehayer Ghanem Alqubaisi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8ffef1ce-2415-4ba1-8abc-de6eeef0a5e2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1982",
    "licenseIssueDate": "06/07/2024 00:00:00",
    "licenseExpiryDate": "06/06/2026 00:00:00"
  },
  {
    "id": "dc39b421-600c-4329-8ed5-e039343589e8",
    "slug": "fatema-mosa-ali",
    "name": "FATMA MOOSA ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 20,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/06/2005",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Fatema Mosa Ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dc39b421-600c-4329-8ed5-e039343589e8",
        "address": "Adv Fatma Moosa Ali ,30 ,IRIS Bay Tower ,Business Bay ,33727 ,Dubai",
        "phone": "97143328182",
        "email": "mahir@fatmaalmoosa.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "0e37962d-dd91-4a8c-876d-08343e3124cb",
    "firmName": "FATMA AL MOOSA ADVOCATE & LEGAL CONSULTANCY",
    "registrationNumber": "L-522",
    "licenseIssueDate": "06/07/2005 00:00:00",
    "licenseExpiryDate": "06/06/2026 00:00:00"
  },
  {
    "id": "eea8b8aa-ad59-4333-a063-f9c37834c580",
    "slug": "fatema-saeed-mohamed-yarouf-almansoori",
    "name": "FATEMA SAEED MOHAMED YAROUF ALMANSOORI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/03/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: FATEMA SAEED MOHAMED YAROUF ALMANSOORI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_eea8b8aa-ad59-4333-a063-f9c37834c580",
        "address": "",
        "phone": "97144455555 / 971503499791",
        "email": "fatmaamansoori@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "56a08801-face-44ef-b719-6ba08c6cae57",
    "firmName": "FATEM SAEED MOHAMED BIN YAROUF ALMANSOORI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-517",
    "licenseIssueDate": "03/21/2023 00:00:00",
    "licenseExpiryDate": "03/20/2026 00:00:00"
  },
  {
    "id": "cf628588-d91b-4df0-9eb6-7d2aef240238",
    "slug": "fatema-saif-abdulrahman-laghrab-almheiri",
    "name": "FATEMA SAIF ABDULRAHMAN E ALMHEIRI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/04/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: FATEMA SAIF ABDULRAHMAN LAGHRAB ALMHEIRI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cf628588-d91b-4df0-9eb6-7d2aef240238",
        "address": "Mohamed Nagy ,First floor  ,Clover Bay ,Business bay ,108 ,Dubai",
        "phone": "97143366404",
        "email": "fatimaalmehri5@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "a359d947-1da5-4ef9-af87-719d01287fd0",
    "firmName": "FATEMA ALMHEIRI ADVOCATES &LEGAL CONSULTANTS",
    "registrationNumber": "L-1523",
    "licenseIssueDate": "04/15/2021 00:00:00",
    "licenseExpiryDate": "04/14/2026 00:00:00"
  },
  {
    "id": "3af30d7e-d8d6-4ff0-95d8-98a9fda8b261",
    "slug": "fatema-saif-mohammed-sulaiman-almazrouei",
    "name": "SAIF MOHAMMED SULAIMAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/12/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Fatema Saif Mohammed Sulaiman Almazrouei",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3af30d7e-d8d6-4ff0-95d8-98a9fda8b261",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1395",
    "licenseIssueDate": "12/04/2019 00:00:00",
    "licenseExpiryDate": "12/03/2025 00:00:00"
  },
  {
    "id": "de863d58-53fd-488d-adaa-0d3f093621ea",
    "slug": "fatiha-mohamed-barrahou-gourari",
    "name": "FATIHA MOHAMED BARRAHOU GOURARI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/04/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Fatiha Mohamed Barrahou Gourari",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_de863d58-53fd-488d-adaa-0d3f093621ea",
        "address": "",
        "phone": "97142394000",
        "email": "info@fatihagourari.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "5659e22e-56c3-4e28-8165-14d3772da734",
    "firmName": "FATTIHA GOURARI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1004",
    "licenseIssueDate": "04/02/2015 00:00:00",
    "licenseExpiryDate": "04/01/2026 00:00:00"
  },
  {
    "id": "203e4e74-fccb-4d9a-bbe8-9dea1696ed96",
    "slug": "fatima-abdalla-mohamed-ali-almemari",
    "name": "Fatima Abdalla Mohamed Ali Almemari",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/17/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Fatima Abdalla Mohamed Ali Almemari",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_203e4e74-fccb-4d9a-bbe8-9dea1696ed96",
        "address": "haleema almarzooqi ,3 ,building 7A ,D3 ,9569 ,Dubai",
        "phone": "97143621113",
        "email": "haleema.almarzooqi@dhalaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "4fb21617-b070-488f-8ce5-516725154e59",
    "firmName": "HALEEMA ALMARZOOQI & PARTNERS ADVOCATES & LEG",
    "registrationNumber": "1051",
    "licenseIssueDate": "02/17/2016 00:00:00",
    "licenseExpiryDate": "02/16/2026 00:00:00"
  },
  {
    "id": "e8080044-a1ee-4486-b308-64c69b780c7b",
    "slug": "fatima-abdelqudous-abdelrazaq-alsiddiq-alobeidli",
    "name": "FATIMA ABDELQUDOUS ABDELRAZAQ ALSIDDIQ ALOBEIDLI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/15/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: FATIMA ABDELQUDOUS ABDELRAZAQ ALSIDDIQ ALOBEIDLI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e8080044-a1ee-4486-b308-64c69b780c7b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "16401",
    "licenseIssueDate": "03/15/2022 00:00:00",
    "licenseExpiryDate": "03/14/2026 00:00:00"
  },
  {
    "id": "a378bb69-bcd0-4f4f-9c1e-42f781aa1a17",
    "slug": "fatima-abdulaziz-mohamed-murad-shakir",
    "name": "FATIMA ABDULAZIZ MOHAMED MURAD SHAKIR",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 18,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/09/2007",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Fatima Abdulaziz Mohamed Murad Shakir",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a378bb69-bcd0-4f4f-9c1e-42f781aa1a17",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-612",
    "licenseIssueDate": "09/24/2007 00:00:00",
    "licenseExpiryDate": "09/23/2026 00:00:00"
  },
  {
    "id": "13aab5ab-256c-4955-a6d3-f03b907162f5",
    "slug": "fatima-abdulla-omar-abdulla-balfaqeeh",
    "name": "ABDALLA JASIM ABDALLAABELRSZAQ ALNAQBI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/05/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Fatima Abdulla Omar Abdulla Balfaqeeh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_13aab5ab-256c-4955-a6d3-f03b907162f5",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1808",
    "licenseIssueDate": "06/11/2023 00:00:00",
    "licenseExpiryDate": "06/10/2026 00:00:00"
  },
  {
    "id": "2fe78ab2-b3d8-46d5-ba2a-246754f45932",
    "slug": "fatima-ahmad-salem-saeed",
    "name": "FATIMA AHMAD SALEM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/01/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Fatima Ahmad Salem Saeed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2fe78ab2-b3d8-46d5-ba2a-246754f45932",
        "address": "Dr. Ali Ismail Aljarman ,Roof Floor - Offices R03 & R04 ,MSM 1 Building ,Al Saffa First ,62639 ,Dubai",
        "phone": "97144393733",
        "email": "info@prestigeadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "22043b7f-55d2-4eb4-a173-3077ba390351",
    "firmName": "PRESTIGE ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1500",
    "licenseIssueDate": "01/24/2021 00:00:00",
    "licenseExpiryDate": "01/23/2026 00:00:00"
  },
  {
    "id": "cbf6c214-901c-4c07-88fc-0cab8792ca49",
    "slug": "fatima-hussein-ali-ahmad",
    "name": "Fatima Hussein Ali Ahmad",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/17/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Fatima Hussein Ali Ahmad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cbf6c214-901c-4c07-88fc-0cab8792ca49",
        "address": "OB-101-141 ,Majid Al Futtaim - City Centre Deira ,Makani No: 3204893785 ,000 ,Dubai",
        "phone": "97140000000 / 971506946464",
        "email": "Admin@fha.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "54992389-d43d-4ec8-acd7-437592996504",
    "firmName": "FATIMA HUSSEIN ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "1053",
    "licenseIssueDate": "02/17/2016 00:00:00",
    "licenseExpiryDate": "02/16/2026 00:00:00"
  },
  {
    "id": "9ab72f77-78ca-4c51-bebc-cdc31beadee0",
    "slug": "fatima-mohamad-yousif-ahmed-alyassi",
    "name": "SHAIKHAH SAEED SALEM SAEED ALABDOULI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/06/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Fatima Mohamad Yousif Ahmed AlYassi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9ab72f77-78ca-4c51-bebc-cdc31beadee0",
        "address": "الطابق 33/ الوحدة : 3304 ,مبني المنارة /   الطابق 33/ الوحدة : 3304 ,فندق جي دبليو ماركيز  ,24002 ,Dubai",
        "phone": "97144254373",
        "email": "info@wkadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "332a3a67-50f2-424a-a5c1-d5abaf9a030b",
    "firmName": "ALI HABIB ADVOCATES AND LEGAL CONSULTANCY",
    "registrationNumber": "L-1980",
    "licenseIssueDate": "06/07/2024 00:00:00",
    "licenseExpiryDate": "06/06/2026 00:00:00"
  },
  {
    "id": "6d96810f-db5e-43c7-8f0f-cf81b54cda4b",
    "slug": "fatima-mohamed-juma-mohamed-mahmoud",
    "name": "MOHAMMED ABBAS QAMBAR MOHAMMED ALBLOOSHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/07/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: fatima mohamed juma mohamed mahmoud",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6d96810f-db5e-43c7-8f0f-cf81b54cda4b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-2008",
    "licenseIssueDate": "07/24/2024 00:00:00",
    "licenseExpiryDate": "07/23/2025 00:00:00"
  },
  {
    "id": "10d1b2e5-e033-43cc-a2b1-b83812af7834",
    "slug": "fatima-mohammad-ali-hussain-almazami",
    "name": "FATIMA MOHAMMAD ALI HUSSAIN ALAAZMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/06/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Fatima Mohammad Ali Hussain Almazami",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_10d1b2e5-e033-43cc-a2b1-b83812af7834",
        "address": "FATIMA MOHAMMAD ALMAZAM ,3RD FLOOR ,LIBERTY ,BESIDE BANK OF SHARJAH ,35630 ,Dubai",
        "phone": "97142822278",
        "email": "tanany@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "5c727678-4d31-4064-9400-932655fce73e",
    "firmName": "ALMASA ADVOCATES",
    "registrationNumber": "L-817",
    "licenseIssueDate": "06/13/2012 00:00:00",
    "licenseExpiryDate": "06/12/2026 00:00:00"
  },
  {
    "id": "ce00789d-8f01-48a6-83e1-6822561c252d",
    "slug": "fatima-mohammed-youseef-saddiq",
    "name": "FATIMA MUAMMAD YOUSOF SADDIQ",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/01/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Fatima Mohammed Youseef Saddiq",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ce00789d-8f01-48a6-83e1-6822561c252d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1135",
    "licenseIssueDate": "01/04/2017 00:00:00",
    "licenseExpiryDate": "01/03/2026 00:00:00"
  },
  {
    "id": "5635a55d-4b75-4848-8bf5-c2feee08d9c3",
    "slug": "fatima-muslit-hani-saeed",
    "name": "ABDULLA RAHMA AHMED OMRAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/09/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: FATIMA MUSLIT HANI SAEED",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5635a55d-4b75-4848-8bf5-c2feee08d9c3",
        "address": "",
        "phone": "97142770003",
        "email": "info@hbhadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "f074c445-924d-40b2-9832-0b0a040c4e63",
    "firmName": "OBAID ALSHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1869",
    "licenseIssueDate": "10/03/2023 00:00:00",
    "licenseExpiryDate": "10/02/2026 00:00:00"
  },
  {
    "id": "86c5ab6e-75f7-4327-a09f-26a975b64b23",
    "slug": "fatima-saeed-khamis-samsoum-alkaabi",
    "name": "FATIMA SAEED KHAMIS SAMSOUM MUBARAK",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/07/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Fatima Saeed Khamis Samsoum Alkaabi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_86c5ab6e-75f7-4327-a09f-26a975b64b23",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1302",
    "licenseIssueDate": "08/01/2018 00:00:00",
    "licenseExpiryDate": "07/31/2026 00:00:00"
  },
  {
    "id": "6db3474c-26d2-4a0f-badd-45231d5e82b9",
    "slug": "fatima-saeed-salem-alkaabi",
    "name": "FATIMA SAEED SALEM ALKAABI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/03/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Fatima Saeed Salem Alkaabi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6db3474c-26d2-4a0f-badd-45231d5e82b9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1516",
    "licenseIssueDate": "03/09/2021 00:00:00",
    "licenseExpiryDate": "03/08/2026 00:00:00"
  },
  {
    "id": "a6f5e0e3-8a53-4d9d-930b-d6f24d53e866",
    "slug": "fatima-saleh-humaid-abdulla-alrashdi",
    "name": "AMMAR KHALFAN MOHAMMED ALI ALDAHMANI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/10/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: fatima saleh humaid abdulla alrashdi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a6f5e0e3-8a53-4d9d-930b-d6f24d53e866",
        "address": "",
        "phone": "97143266677 / 971506234989",
        "email": "md@khourilawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "7f366bee-e90b-4c77-b535-ccd366935872",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1883",
    "licenseIssueDate": "11/13/2023 00:00:00",
    "licenseExpiryDate": "11/12/2025 00:00:00"
  },
  {
    "id": "3590cf7a-b445-42d9-862c-d0c22346cb43",
    "slug": "fatima-salem-abdulla-saeed-alameri",
    "name": "FATIMA SALEM ABDULLA SAEED ALAMERI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/07/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Fatima Salem Abdulla Saeed Alameri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3590cf7a-b445-42d9-862c-d0c22346cb43",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1373",
    "licenseIssueDate": "07/10/2019 00:00:00",
    "licenseExpiryDate": "07/09/2026 00:00:00"
  },
  {
    "id": "a1d695ce-eaea-46ab-9c2a-b8717f4b7b19",
    "slug": "fatima-shairmohamed-juma-bahader-almaazmi",
    "name": "HASSAN MOHAMED YAHYA ABDALLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/11/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Fatima Shairmohamed Juma Bahader Almaazmi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a1d695ce-eaea-46ab-9c2a-b8717f4b7b19",
        "address": "الطابق الحادي عشر ,بناية الحواي ,متحف المستقبل ,183335 ,Dubai",
        "phone": "97142888874 / 971551740400",
        "email": "h.almazmi89@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "a1cee907-ce7d-484b-a20d-16cb79cd6c04",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1889",
    "licenseIssueDate": "11/25/2023 00:00:00",
    "licenseExpiryDate": "11/24/2025 00:00:00"
  },
  {
    "id": "da1c612e-8e95-4244-9e03-b1e473b25db9",
    "slug": "fatima-sharif-mohamed-yousif-alobeidli",
    "name": "FATIMA SHARIF MOHAMED YOUSIF SHARIF",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/08/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Fatima Sharif Mohamed Yousif Alobeidli",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_da1c612e-8e95-4244-9e03-b1e473b25db9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1556",
    "licenseIssueDate": "08/24/2021 00:00:00",
    "licenseExpiryDate": "08/23/2026 00:00:00"
  },
  {
    "id": "01e23774-e992-4696-a0ab-c2d4f96825dc",
    "slug": "fatima-yousef-ahmed-abdulia-almulla",
    "name": "FATIMA YOUSEF AHMED ABDULIA ALMULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/05/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: FATIMA YOUSEF AHMED ABDULIA ALMULLA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_01e23774-e992-4696-a0ab-c2d4f96825dc",
        "address": "next level restaurant  , centurion star - block B - office 806 & 807 ,behind day to day - opposite deira city center ,237766 ,Dubai",
        "phone": "97142622002",
        "email": "info@almaftool-advocate.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "bc6598b4-c5d3-4280-b29d-4c3c132c3a21",
    "firmName": "KHALIFA AL MAFTOOL ADVOCATES AND LEGAL CONSUL",
    "registrationNumber": "15941",
    "licenseIssueDate": "12/05/2021 00:00:00",
    "licenseExpiryDate": "12/04/2025 00:00:00"
  },
  {
    "id": "f9d8fbb4-ac79-4b2a-8dfe-d9ed7ef676ec",
    "slug": "fatima-yousif-khalil-alyassi",
    "name": "SHAMMA HAMAD MOHAMED KADFOOR",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/07/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Fatima yousif khalil alyassi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f9d8fbb4-ac79-4b2a-8dfe-d9ed7ef676ec",
        "address": "",
        "phone": "/ 97151111146",
        "email": "info@alphalegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "8576864d-ec5e-4834-b800-88160aa2c0a5",
    "firmName": "EMIRATES ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1834",
    "licenseIssueDate": "07/25/2023 00:00:00",
    "licenseExpiryDate": "07/24/2026 00:00:00"
  },
  {
    "id": "f179d25f-0811-4de9-94f0-76e6a3dea090",
    "slug": "fatma-abdulaziz-mohammad-ali-alqassim",
    "name": "HANI FAYEZ MUSTAFA KARKABA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/09/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Fatma Abdulaziz Mohammad Ali Alqassim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f179d25f-0811-4de9-94f0-76e6a3dea090",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-2027",
    "licenseIssueDate": "09/24/2024 00:00:00",
    "licenseExpiryDate": "09/23/2026 00:00:00"
  },
  {
    "id": "c2cc33ff-cc58-460d-af9f-2aed7e5d7985",
    "slug": "fatma-abdulla-mohammad-suliman",
    "name": "MARYAM SAIF ALI KHATEM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/03/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Fatma abdulla mohammad suliman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c2cc33ff-cc58-460d-af9f-2aed7e5d7985",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1638",
    "licenseIssueDate": "03/31/2022 00:00:00",
    "licenseExpiryDate": "03/30/2027 00:00:00"
  },
  {
    "id": "ed1d03c6-78ab-4127-b984-dfaac15429a7",
    "slug": "fatma-ahmed-mihamed-alrais",
    "name": "FATMA AHMAD MOHD HASSAN IBRAHIM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 24,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/04/2001",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Fatma Ahmed Mihamed AlRais",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ed1d03c6-78ab-4127-b984-dfaac15429a7",
        "address": "7 ,سوفيتل ,محطة برج خليفة  ,8867 ,Dubai",
        "phone": "97143488808",
        "email": "secretary@dubailaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "dab6c960-06bf-4107-b633-52015cf4be6a",
    "firmName": "AL SHARIF ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-402",
    "licenseIssueDate": "05/01/2001 00:00:00",
    "licenseExpiryDate": "04/30/2026 00:00:00"
  },
  {
    "id": "0b617759-e44b-40e5-a804-b69c22b7c404",
    "slug": "fatma-ali-malalla-mohammad-ghanem",
    "name": "KANAAN EISA YOUSUF AHMED ALHOSANI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/05/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Fatma Ali Malalla Mohammad Ghanem",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0b617759-e44b-40e5-a804-b69c22b7c404",
        "address": "",
        "phone": "97148321212",
        "email": "nasser@nmlawyers.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "71709458-e40a-45b3-9319-4c51c18891be",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1655",
    "licenseIssueDate": "05/24/2022 00:00:00",
    "licenseExpiryDate": "05/23/2026 00:00:00"
  },
  {
    "id": "d23e3d55-929c-472d-be6e-f5a06c0b0294",
    "slug": "fatma-ali-mohammad-hassan",
    "name": "fatma ali mohammad hassan",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/03/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: fatma ali mohammad hassan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d23e3d55-929c-472d-be6e-f5a06c0b0294",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "1775",
    "licenseIssueDate": "03/03/2023 00:00:00",
    "licenseExpiryDate": "03/02/2026 00:00:00"
  },
  {
    "id": "2ab9f868-2ebe-4c1d-a16b-29cfb0e92690",
    "slug": "fatma-hassan-mohammed-ahmad-almutawa",
    "name": "FATMA HASSAN MOHD AHMAD ABDULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/07/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Fatma Hassan Mohammed Ahmad Almutawa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2ab9f868-2ebe-4c1d-a16b-29cfb0e92690",
        "address": "",
        "phone": "97145579711",
        "email": "info@mqadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "9f91cca7-a15d-499f-b265-2a032fe38fa1",
    "firmName": "FATMA AL MUTAWA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-824",
    "licenseIssueDate": "07/17/2012 00:00:00",
    "licenseExpiryDate": "07/16/2026 00:00:00"
  },
  {
    "id": "8d46360f-eec8-4084-ba5a-e900d90ebbe2",
    "slug": "fatma-mohammad-omar-mubarak-bawazir",
    "name": "HALIMA YOUSUF KHAMIS ABDULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/08/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: fatma mohammad omar mubarak bawazir",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8d46360f-eec8-4084-ba5a-e900d90ebbe2",
        "address": "",
        "phone": "97145650550",
        "email": "uae.courts@qamadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "3117b2a0-79c7-477b-b710-1b6eb632bccc",
    "firmName": "ADVOCATES UNIT",
    "registrationNumber": "L-1699",
    "licenseIssueDate": "09/15/2022 00:00:00",
    "licenseExpiryDate": "09/14/2026 00:00:00"
  },
  {
    "id": "2b304de5-11b8-492c-90fa-2e3cdd7630f1",
    "slug": "fatma-moosa-darwish-al-balooshi",
    "name": "FATMA MOOSA DARWISH ALBALOOSHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 20,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/01/2005",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Fatma Moosa Darwish Al Balooshi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2b304de5-11b8-492c-90fa-2e3cdd7630f1",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-499",
    "licenseIssueDate": "01/10/2005 00:00:00",
    "licenseExpiryDate": "01/09/2026 00:00:00"
  },
  {
    "id": "01b16904-4b15-40a0-9557-f56d85e0a6b8",
    "slug": "fatma-salim-ali-bin-alnuman-alshsmai",
    "name": "SALIM ALI SALIM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/08/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: fatma salim ali bin alnuman alshsmai",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_01b16904-4b15-40a0-9557-f56d85e0a6b8",
        "address": "ABDULRAHMAN MOHAMED ALAAMRI ,306 ,ACICO BUISINESS PARK ,NISSAN SHOW ROOM ,33731 ,Dubai",
        "phone": "97148819818 / 971503933245",
        "email": "info@alaamri.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "bf13bfd5-9c31-447d-a1f6-1939ed8ab235",
    "firmName": "ABDULRAHMAN ALAAMRI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1448",
    "licenseIssueDate": "09/01/2020 00:00:00",
    "licenseExpiryDate": "08/31/2026 00:00:00"
  },
  {
    "id": "31de0e69-0577-449f-a4ac-f8ced530c82b",
    "slug": "fatmah-abdulla-mohamed-alwatani-al-ali",
    "name": "FATMAH ABDULLA W O AHMED A M SAEED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/03/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Fatmah Abdulla Mohamed Alwatani Al Ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_31de0e69-0577-449f-a4ac-f8ced530c82b",
        "address": "",
        "phone": "97145539905",
        "email": "info@ama-alali.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "a1add4ec-4f01-41b2-9875-540545839906",
    "firmName": "FATMAH AL ALI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-1265",
    "licenseIssueDate": "03/08/2018 00:00:00",
    "licenseExpiryDate": "03/07/2026 00:00:00"
  },
  {
    "id": "e7bd9495-ed53-4008-8ae3-25d98743d5d2",
    "slug": "fatmah-hamdan-rashed-alghasyah-aldhanhani",
    "name": "Fatmah Hamdan Rashed Alghasyah Aldhanhani",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/04/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2022-03-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Fatmah Hamdan Rashed Alghasyah Aldhanhani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e7bd9495-ed53-4008-8ae3-25d98743d5d2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "1261",
    "licenseIssueDate": "03/04/2018 00:00:00",
    "licenseExpiryDate": "03/03/2022 00:00:00"
  },
  {
    "id": "31f6e8d8-2f0e-4229-88f2-ac475069b631",
    "slug": "fatmah-homoud-rashed-alsereidi",
    "name": "KHALID ALI AHMAD KHALIFA HAMMAD ALMARRI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/06/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: fatmah homoud Rashed Alsereidi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_31f6e8d8-2f0e-4229-88f2-ac475069b631",
        "address": "samer tohme ,4th- office 433 ,Emarat Atrium ,Dubai Canal ,79436 ,Dubai",
        "phone": "97126722500",
        "email": "info@dxblawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "00b6334f-44e7-458e-8ce5-7d4256840067",
    "firmName": "NAWAL MOHAMED ALBADY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1814",
    "licenseIssueDate": "06/19/2023 00:00:00",
    "licenseExpiryDate": "06/18/2026 00:00:00"
  },
  {
    "id": "e26946e5-0f1e-4c3d-af3f-42bea4bd5b51",
    "slug": "fatmah-mohamed-hassan-mohamed-alhashmi",
    "name": "FATMAH MOHAMED HASSAN MOHAMED ALHASHMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/02/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: FATMAH MOHAMED HASSAN MOHAMED ALHASHMI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e26946e5-0f1e-4c3d-af3f-42bea4bd5b51",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1258",
    "licenseIssueDate": "02/13/2018 00:00:00",
    "licenseExpiryDate": "02/12/2026 00:00:00"
  },
  {
    "id": "6c14a61d-7117-4937-9d5b-5127146eafe7",
    "slug": "fatmamohammed-alialattar",
    "name": "KHALED ALI MOHAMED ALI ALHADHRAMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/06/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: FatmaMohammed AliAlattar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6c14a61d-7117-4937-9d5b-5127146eafe7",
        "address": "amna alzaabi ,213 ,مبنى مكاتب عود ميثاء ,سيتي بنك ,16189 ,Dubai",
        "phone": "97145822422",
        "email": "info@amnalegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "a30322e3-d9be-4ba2-ba94-2ebf6f963319",
    "firmName": "DR KHALED ALI ALHADHRAMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1985",
    "licenseIssueDate": "06/12/2024 00:00:00",
    "licenseExpiryDate": "06/11/2026 00:00:00"
  },
  {
    "id": "971b3037-0555-4015-a8c5-c7855c118590",
    "slug": "fawzia-mohammad-azim-saifuddin-yaqoob",
    "name": "ABDULRAHMAN MOHAMED ABDULLA ALOBEIDLI ALHAMMADI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/04/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Fawzia Mohammad Azim Saifuddin Yaqoob",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_971b3037-0555-4015-a8c5-c7855c118590",
        "address": "",
        "phone": "",
        "email": "fawzia.mohd.2009@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "336f9090-d6f4-4c0b-bccb-c08fd95ea5cc",
    "firmName": "ALOBAIDLI & ALZAROONI ADVOCATES&LEGAL CONSULTANTS",
    "registrationNumber": "L-1649",
    "licenseIssueDate": "05/09/2022 00:00:00",
    "licenseExpiryDate": "05/08/2026 00:00:00"
  },
  {
    "id": "803c194a-7181-4c92-bb08-28da713b5d17",
    "slug": "fawzia-mohammed-hassan-al-mulla",
    "name": "FAWZIA MOHAMMED HASSAN MULLA ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/11/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Fawzia Mohammed Hassan Al Mulla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_803c194a-7181-4c92-bb08-28da713b5d17",
        "address": "",
        "phone": "97108307033",
        "email": "general.alshamsi@lawuae.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "d29f6d04-dad1-4f59-9ae2-d4d245f63133",
    "firmName": "AL SHAMSI & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1474",
    "licenseIssueDate": "11/08/2020 00:00:00",
    "licenseExpiryDate": "11/07/2025 00:00:00"
  },
  {
    "id": "df19e3b8-5cf6-4152-b188-f7bdc76259f3",
    "slug": "fayza-mousa-sulaiman",
    "name": "FAYZA MOUSA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 19,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/02/2006",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: FAYZA MOUSA SULAIMAN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_df19e3b8-5cf6-4152-b188-f7bdc76259f3",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-547",
    "licenseIssueDate": "02/07/2006 00:00:00",
    "licenseExpiryDate": "02/06/2026 00:00:00"
  },
  {
    "id": "fca5fa72-d867-49c7-a912-85fb51bff9ec",
    "slug": "fetouh-yousef-mohammed-hussain-al-nassar",
    "name": "Fetouh Yousef Mohammed Hussain Al-Nassar",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 25,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/01/2000 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Fetouh Yousef Mohammed Hussain Al-Nassar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fca5fa72-d867-49c7-a912-85fb51bff9ec",
        "address": "HOSSAM GAMAL MOHAMED ELSOKARY ,26 ,Citadel tower ,Marasi Drive ,5586 ,Dubai",
        "phone": "97142555110",
        "email": "fetouh@alnassar.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "83443142-de5a-4089-8798-9ed25b7885de",
    "firmName": "AL NASSAR ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "230",
    "licenseIssueDate": "02/01/2000 00:00:00",
    "licenseExpiryDate": "01/31/2026 00:00:00"
  },
  {
    "id": "5effbcde-be2b-4b87-a0c5-b6582b836262",
    "slug": "fouzeya-mahmood-ahmad-mohamad-almulla",
    "name": "FOUZEYA MAHMOOD AHMAD MOHD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/05/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Fouzeya Mahmood Ahmad Mohamad Almulla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5effbcde-be2b-4b87-a0c5-b6582b836262",
        "address": "",
        "phone": "97143283749",
        "email": "info@famlc.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "1fba2390-a8a7-4185-9ffd-f6f93f0fe965",
    "firmName": "FOUZEYA AL MULLA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1360",
    "licenseIssueDate": "05/18/2019 00:00:00",
    "licenseExpiryDate": "05/17/2026 00:00:00"
  },
  {
    "id": "188b575a-3d80-422a-bb85-3dd64ecc15a3",
    "slug": "gaith-ghanim-saif-obaid-alsuwaifi",
    "name": "KHALIFA MOHAMED ABDULLA MOHAMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/09/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Gaith Ghanim Saif Obaid Alsuwaifi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_188b575a-3d80-422a-bb85-3dd64ecc15a3",
        "address": "",
        "phone": "97143411355 / 971505527552",
        "email": "advocates@drghaith.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "45fb8910-008e-414c-8a9b-d5ab51b7d2f6",
    "firmName": "ALI HABIB ADVOCATES AND LEGAL CONSULTANCY",
    "registrationNumber": "L-2035",
    "licenseIssueDate": "10/21/2024 00:00:00",
    "licenseExpiryDate": "10/20/2026 00:00:00"
  },
  {
    "id": "989bd4bb-9015-4c01-aff8-ef90f23a3f6a",
    "slug": "galal-eldin-hussein-saleh-diab",
    "name": "GALALELDIN HUSSEIN SALEH DIAB",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/02/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Galal Eldin Hussein Saleh Diab",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_989bd4bb-9015-4c01-aff8-ef90f23a3f6a",
        "address": "GALAL ELDIN HUSSEIN SALEH DIAB ,الطابق السادس ,مكاتب ,معرض هوندا الفطيم للسيارات - ديره ,115506 ,Dubai",
        "phone": "97197150655",
        "email": "galal5152@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "6bba74cb-688b-40e3-b624-be70505eb5f9",
    "firmName": "GALAL HUSSEIN LEGAL CONSULTANCIES AND ADVOCATES",
    "registrationNumber": "L-916",
    "licenseIssueDate": "02/12/2014 00:00:00",
    "licenseExpiryDate": "02/11/2026 00:00:00"
  },
  {
    "id": "e0a5e788-b696-4296-be08-0a1564c153d7",
    "slug": "ghalia-khalid-ibrahim-hussain-mahmood",
    "name": "MUSABBAH OBAID SULAIMAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/01/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ghalia Khalid Ibrahim Hussain Mahmood",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e0a5e788-b696-4296-be08-0a1564c153d7",
        "address": "",
        "phone": "97143348481",
        "email": "lawyers@maidor.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "a48d1666-6ca7-461a-8197-a892ef0f3545",
    "firmName": "ABEER MUSABBAH OBAID ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1620",
    "licenseIssueDate": "02/02/2022 00:00:00",
    "licenseExpiryDate": "02/01/2026 00:00:00"
  },
  {
    "id": "1300a61a-e741-4ead-a4ed-faecf8e63cee",
    "slug": "ghanem-jaber-ghassab-alfahid-alhajeri",
    "name": "GHANEM JABER GHASSAB ALI ALHAJERI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/04/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ghanem Jaber Ghassab Alfahid Alhajeri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1300a61a-e741-4ead-a4ed-faecf8e63cee",
        "address": "Saleh Ahmed Yousif Saleh Alobeidli ,2nd ,DUBAI SUPREME COURT COMPLEX ,Dubai Courts ,333842 ,Dubai",
        "phone": "97143546762",
        "email": "Laila@iclo.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "57836e55-f90c-4fb1-81d0-a735a168b9ac",
    "firmName": "INTERNATIONAL CONSULTANT LAW OFFICE",
    "registrationNumber": "L-1007",
    "licenseIssueDate": "04/12/2015 00:00:00",
    "licenseExpiryDate": "04/11/2026 00:00:00"
  },
  {
    "id": "e21c406b-7ba9-4ec3-83d3-70bd6e3c23a9",
    "slug": "ghanim-ali-nasser-ali-al-ahbabi",
    "name": "GHANIM ALI NASSER ALI AL AHBABI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/07/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ghanim Ali Nasser Ali Al Ahbabi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e21c406b-7ba9-4ec3-83d3-70bd6e3c23a9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1433",
    "licenseIssueDate": "07/12/2020 00:00:00",
    "licenseExpiryDate": "07/11/2026 00:00:00"
  },
  {
    "id": "7e3a2f8c-8a8d-41a5-a3df-06b507beb6e1",
    "slug": "ghanim-mohamed-saeed-mohamed-almheiri",
    "name": "Ghanim Mohamed Saeed Mohamed Almheiri",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/25/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ghanim Mohamed Saeed Mohamed Almheiri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7e3a2f8c-8a8d-41a5-a3df-06b507beb6e1",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "1614",
    "licenseIssueDate": "01/25/2022 00:00:00",
    "licenseExpiryDate": "01/24/2026 00:00:00"
  },
  {
    "id": "959ae245-2bd3-43e1-bb91-c1685afe0f94",
    "slug": "gharib-khalifa-gharib-walid-alshamsi",
    "name": "GHARIB KHALIFA GHARIB WALID",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/09/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Gharib Khalifa Gharib Walid Alshamsi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_959ae245-2bd3-43e1-bb91-c1685afe0f94",
        "address": "",
        "phone": "97142208816",
        "email": "g.alshamsiadvocate@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "4eac7236-c896-444b-a5ea-e4ff06ff2f5a",
    "firmName": "GHARIB ALSHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1222",
    "licenseIssueDate": "09/13/2017 00:00:00",
    "licenseExpiryDate": "09/14/2026 00:00:00"
  },
  {
    "id": "66aef8a7-23f2-41f9-852d-60ea30c2dec4",
    "slug": "ghazi-ibrahim-ahmad-bin-sifan",
    "name": "GHAZI IBRAHIM AHMAD BINSAIFAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 19,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/09/2006",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: GHAZI IBRAHIM AHMAD BIN SIFAN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_66aef8a7-23f2-41f9-852d-60ea30c2dec4",
        "address": "Firas Hassan Al Choufi ,701 ,The Prime Tower ,Makani No: 25836 86879 ,125305 ,Dubai",
        "phone": "97144357246",
        "email": "info@binsevanadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "4d3c9dcc-51c6-4883-b9ed-c65a7d1c5a57",
    "firmName": "BIN SEVAN ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-577",
    "licenseIssueDate": "09/14/2006 00:00:00",
    "licenseExpiryDate": "09/13/2026 00:00:00"
  },
  {
    "id": "a806dd27-b399-4c8f-ba37-43eef214f7a2",
    "slug": "habib-abdul-rahim-abdulla",
    "name": "HABIB ABDUL RAHIM ABDULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/05/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Habib Abdul Rahim Abdulla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a806dd27-b399-4c8f-ba37-43eef214f7a2",
        "address": "الثالث مكتب 304 ,برج سما ,المركز التجاري  ,116623 ,Dubai",
        "phone": "97142723388",
        "email": "info@habibllc.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "373bb6e6-5948-493f-a6ac-2ea343840160",
    "firmName": "HABIB AL HOSANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-871",
    "licenseIssueDate": "05/06/2013 00:00:00",
    "licenseExpiryDate": "05/05/2026 00:00:00"
  },
  {
    "id": "845a162f-79c8-40b5-826e-27e079561e9b",
    "slug": "habib-mohammed-shareif-abdulla-al-mulla",
    "name": "Habib Mohammed Shareif Abdulla Al-Mulla",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 41,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/30/1984 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Habib Mohammed Shareif Abdulla Al-Mulla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_845a162f-79c8-40b5-826e-27e079561e9b",
        "address": "",
        "phone": "97144230000 / 971552009022",
        "email": "UAE-CourtClerks@habibalmulla.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "3eba82bb-8ec4-4cbd-80d0-a793cb993fde",
    "firmName": "Habib Al Mulla & Partners ADVOCATES & LEGAL C",
    "registrationNumber": "139",
    "licenseIssueDate": "07/30/1984 00:00:00",
    "licenseExpiryDate": "07/29/2026 00:00:00"
  },
  {
    "id": "694a4634-846f-43d9-b37d-5fdf9251ec63",
    "slug": "hadeel-ali-khalifa-ali-alshaali",
    "name": "Hadeel Ali Khalifa Ali Alshaali",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/29/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hadeel Ali Khalifa Ali Alshaali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_694a4634-846f-43d9-b37d-5fdf9251ec63",
        "address": "Hadeel Ali alshaali  ,الطابق السادس  ,بناية زمردة ,بلدية دبي المختبرات المركزية ,212633 ,Dubai",
        "phone": "97165503035",
        "email": "hadeelalshaali_90@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "18a7fc47-63d9-4928-a864-fa55559de45b",
    "firmName": "HADEEL ALSHAALI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "1038",
    "licenseIssueDate": "03/29/2018 00:00:00",
    "licenseExpiryDate": "03/28/2026 00:00:00"
  },
  {
    "id": "819a5459-cd83-4e57-81d7-8a86ee937c66",
    "slug": "hadef-jouan-rashed-ahmed-aldhaeri",
    "name": "HADEF JOUAN RASHED AHMED ALDHAHERI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBISgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/09/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hadef Jouan Rashed Ahmed Aldhaeri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_819a5459-cd83-4e57-81d7-8a86ee937c66",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-344",
    "licenseIssueDate": "09/09/2015 00:00:00",
    "licenseExpiryDate": "09/08/2026 00:00:00"
  },
  {
    "id": "acddbef9-47a6-41fd-b614-ee49fc984fd7",
    "slug": "hadeya-abdulrazzaq-mahmoud-hamad",
    "name": "HADEYA ABDULRAZZAQ MAHMOUD HAMAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/12/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hadeya Abdulrazzaq Mahmoud Hamad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_acddbef9-47a6-41fd-b614-ee49fc984fd7",
        "address": "ADEL ALSAID  ,203 ,BAY SQUARE-02 ,BAY SQUARE  ,37105 ,Dubai",
        "phone": "97143555253 / 971507562138",
        "email": "hhlegal@hhlegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "93736908-026c-4a6a-bbaf-2e67ee1366c6",
    "firmName": "HADEYA HAMAD ADVOCACY & LEGAL CONSULTANCY",
    "registrationNumber": "L-847",
    "licenseIssueDate": "12/23/2012 00:00:00",
    "licenseExpiryDate": "12/22/2025 00:00:00"
  },
  {
    "id": "903f17d2-07cb-4938-a6df-29695accc1b0",
    "slug": "haider-salem-ali-bin-haider",
    "name": "HAIDER SALEM ALI BIN HAIDER",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 20,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/04/2005",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Haider Salem Ali Bin Haider",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_903f17d2-07cb-4938-a6df-29695accc1b0",
        "address": "",
        "phone": "97142770003",
        "email": "info@hbhadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "f074c445-924d-40b2-9832-0b0a040c4e63",
    "firmName": "HAIDER BIN HAIDER ADVOCATES AND LEGAL CONSULTANT",
    "registrationNumber": "L-518",
    "licenseIssueDate": "04/13/2005 00:00:00",
    "licenseExpiryDate": "04/12/2026 00:00:00"
  },
  {
    "id": "62c83eaa-5d80-40f6-adcd-638576b82366",
    "slug": "haiel-mohamed-abdulmajeed-al-harbi",
    "name": "HAIEL MOHAMED ABDULMAJEED ALHARBI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/07/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Haiel Mohamed Abdulmajeed Al Harbi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_62c83eaa-5d80-40f6-adcd-638576b82366",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-433",
    "licenseIssueDate": "07/31/2019 00:00:00",
    "licenseExpiryDate": "07/30/2026 00:00:00"
  },
  {
    "id": "cd2ee7e2-eb93-477e-b574-f64e7f40cb42",
    "slug": "haitham-salah-jalal-abdulla-mohammad",
    "name": "HAITHAM SALAH JALAL ABDULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/03/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: haitham salah jalal abdulla mohammad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cd2ee7e2-eb93-477e-b574-f64e7f40cb42",
        "address": "M ,al garhoud busniss center ,dubai international airport ,451878 ,Dubai",
        "phone": "97143964926 / 971503470066",
        "email": "lawyer-haitham@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "a257089c-d1b4-4f81-b4d7-14d1a0c34eb5",
    "firmName": "HAITHAM SALAH ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1350",
    "licenseIssueDate": "03/13/2019 00:00:00",
    "licenseExpiryDate": "03/13/2026 00:00:00"
  },
  {
    "id": "077aee3f-602a-4e1d-a7cf-00e5c46fbaec",
    "slug": "hala-musadq-abduljalil-mubarak",
    "name": "HALLA MUSADEQ ABDULJALIL MUBARAK",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 15,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/05/2010",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hala Musadq Abduljalil Mubarak",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_077aee3f-602a-4e1d-a7cf-00e5c46fbaec",
        "address": "14th Floor, No.2 ,Al Burj Al Salam ,Makani No: 27412 91443 ,000 ,Dubai",
        "phone": "97148823210 / 971565301153",
        "email": "info@tarishlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "ca640589-e7ab-45e9-8d6e-52a161a80279",
    "firmName": "TARISH ALMANSOORI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-716",
    "licenseIssueDate": "05/31/2010 00:00:00",
    "licenseExpiryDate": "05/30/2026 00:00:00"
  },
  {
    "id": "5c76359d-7864-4e2f-b7a9-9960a21add14",
    "slug": "halawa-ali-mohammed-bin-sarhan-alshehhi",
    "name": "ABDUL RAHMAN ABDULLA AHMED MAHMOUD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/06/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: halawa ali mohammed bin sarhan alshehhi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5c76359d-7864-4e2f-b7a9-9960a21add14",
        "address": "",
        "phone": "97100000000 / 971504766660",
        "email": "info@eza.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "f6dee20d-9392-4f89-96bd-b1f89bcef71a",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1990",
    "licenseIssueDate": "06/20/2024 00:00:00",
    "licenseExpiryDate": "06/19/2026 00:00:00"
  },
  {
    "id": "5b9e4cf0-d531-4589-9d0e-f06d0e925803",
    "slug": "haleema-murtadha-mohamed-mukhtar-almarzooqi",
    "name": "HALEEMA MURTADHA MOHAMED M ALMARZOOQI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/09/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Haleema Murtadha Mohamed Mukhtar Almarzooqi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5b9e4cf0-d531-4589-9d0e-f06d0e925803",
        "address": "haleema almarzooqi ,3 ,building 7A ,D3 ,9569 ,Dubai",
        "phone": "97143621113",
        "email": "haleema.almarzooqi@dhalaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "4fb21617-b070-488f-8ce5-516725154e59",
    "firmName": "HALEEMA ALMARZOOQI &PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-475",
    "licenseIssueDate": "09/20/2015 00:00:00",
    "licenseExpiryDate": "09/19/2026 00:00:00"
  },
  {
    "id": "db8cfed5-e80b-46af-9c25-140fb8d6b8cf",
    "slug": "halima-yousif-khamis-abdalla-alnaqbi",
    "name": "AMAL AHMED ABDULLA KHAMIS ALAMERI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/08/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: HALIMA YOUSIF KHAMIS ABDALLA ALNAQBI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_db8cfed5-e80b-46af-9c25-140fb8d6b8cf",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1691",
    "licenseIssueDate": "08/19/2022 00:00:00",
    "licenseExpiryDate": "08/18/2026 00:00:00"
  },
  {
    "id": "a03165da-725d-4bf0-91b0-d625f176393f",
    "slug": "hamad-abdelwahab-hassan-mohamed-al-qawadi",
    "name": "HAMAD ABDELWAHAB HASSAN MOHAMED ALQAWADI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/11/2008",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-11-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: HAMAD ABDELWAHAB HASSAN MOHAMED AL QAWADI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a03165da-725d-4bf0-91b0-d625f176393f",
        "address": "Hamad Abdul wahab alqawadi ,الطابق العاشر / مكتب 1002 ,فندق ذا اتش  ,المركز التجاري  ,00000 ,Dubai",
        "phone": "97145681225",
        "email": "alhamad_advo@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "f2476874-d6f1-491d-857f-df0917f9997a",
    "firmName": "ALHAMAD ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-568",
    "licenseIssueDate": "11/23/2008 00:00:00",
    "licenseExpiryDate": "11/22/2025 00:00:00"
  },
  {
    "id": "72a5344e-5789-4e69-ad68-32734b6bd5c9",
    "slug": "hamad-abdulla-abdulrahman-al-rahma-al-hammadi",
    "name": "HAMAD ABDULLA ABDULRAHMAN ALRAHMA ALHAMMADI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/03/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hamad Abdulla Abdulrahman Al Rahma Al Hammadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_72a5344e-5789-4e69-ad68-32734b6bd5c9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-918",
    "licenseIssueDate": "03/03/2014 00:00:00",
    "licenseExpiryDate": "03/02/2026 00:00:00"
  },
  {
    "id": "f39c03fc-ed35-430a-a33b-d7ae311133b0",
    "slug": "hamad-abdulla-abdulrahman-mohamed-alsaeedi",
    "name": "ABDULLA ABDULRAHMAN MOHAMMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/04/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hamad Abdulla Abdulrahman Mohamed Alsaeedi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f39c03fc-ed35-430a-a33b-d7ae311133b0",
        "address": "almetaq insurance  ,alnouf tower ,business vilage  ,92422 ,Dubai",
        "phone": "97142974555",
        "email": "info@alsaeedilaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "5684cb2e-d43e-411d-b69e-2e1976782a55",
    "firmName": "ALSAEEDI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1008",
    "licenseIssueDate": "04/14/2015 00:00:00",
    "licenseExpiryDate": "04/13/2026 00:00:00"
  },
  {
    "id": "989b9f36-8456-4778-9c5f-c57769565282",
    "slug": "hamad-ahmad-obaid-mohammad-alsayegh",
    "name": "HAMAD AHMAD OBAID MOHAMMAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/08/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hamad Ahmad Obaid Mohammad Alsayegh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_989b9f36-8456-4778-9c5f-c57769565282",
        "address": "Second Floor - Office No. 224 ,Business Center ,Makani No: 3274893760 ,000 ,Dubai",
        "phone": "97145671576 / 971529969969",
        "email": "info@hamadalsayegh.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "38838899-8c67-45c6-8699-4c822e13f4b8",
    "firmName": "HAMAD AL SAYEGH ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1216",
    "licenseIssueDate": "08/20/2017 00:00:00",
    "licenseExpiryDate": "08/19/2026 00:00:00"
  },
  {
    "id": "bf4beeb5-c98d-48f7-b6fd-f3ff475be16b",
    "slug": "hamad-ali-abdulla-aldabani-alnuaimi",
    "name": "HAMAD ALI ABDULLA ALDABANI ALNUAIMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/11/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-11-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hamad Ali Abdulla Aldabani Alnuaimi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bf4beeb5-c98d-48f7-b6fd-f3ff475be16b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1131",
    "licenseIssueDate": "11/29/2016 00:00:00",
    "licenseExpiryDate": "11/28/2025 00:00:00"
  },
  {
    "id": "9c30af1c-f20d-429f-be5f-2dad4781b71a",
    "slug": "hamad-ali-mohammad-bin-salmeen-al-suwaidi",
    "name": "HAMAD ALI MOHAMMAD BIN SALMEEN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/01/2009",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hamad Ali Mohammad Bin Salmeen Al Suwaidi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9c30af1c-f20d-429f-be5f-2dad4781b71a",
        "address": "HAMAD BIN SALMEEN ,الثامن 801 ,برج برلنجتون ,محطة مترو الخليج التجاري ,97779 ,Dubai",
        "phone": "97142666699",
        "email": "almashreq@levarilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "fc5a1beb-1c2d-4f6e-b20d-7e80a8f75e91",
    "firmName": "AL MASHREQ INTERNATIONAL ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-648",
    "licenseIssueDate": "01/26/2009 00:00:00",
    "licenseExpiryDate": "01/25/2026 00:00:00"
  },
  {
    "id": "af337d97-8039-4e8a-8bad-fb5edd0f92ee",
    "slug": "hamad-arif-faraj-mohammed-alseiari",
    "name": "HAMAD AREF FARAJ MOHAMMED ALSEIARI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/11/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hamad Arif Faraj Mohammed Alseiari",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_af337d97-8039-4e8a-8bad-fb5edd0f92ee",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1471",
    "licenseIssueDate": "11/02/2020 00:00:00",
    "licenseExpiryDate": "11/01/2025 00:00:00"
  },
  {
    "id": "c4d5ab1b-59cc-4e08-9a0a-27d92f4057e9",
    "slug": "hamad-dehai-khassib-mazoul-almuqbali",
    "name": "HAMAD DEHAI KHASSIB MAZOUL",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/06/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hamad Dehai khassib Mazoul AlMuqbali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c4d5ab1b-59cc-4e08-9a0a-27d92f4057e9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1546",
    "licenseIssueDate": "06/30/2021 00:00:00",
    "licenseExpiryDate": "06/29/2026 00:00:00"
  },
  {
    "id": "148e0d95-de50-4a90-8b8b-65446372e4a3",
    "slug": "hamad-essa-mohammad-alessa",
    "name": "HAMAD ESSA MOHAMMAD ALESSA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/03/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hamad Essa Mohammad Alessa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_148e0d95-de50-4a90-8b8b-65446372e4a3",
        "address": "13 ,المنارة ,الخليج التجاري  ,455755 ,Dubai",
        "phone": "97144106480",
        "email": "alessalawfirm@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "469613e7-96d7-4b4d-82f2-5ab24490a43f",
    "firmName": "HAMAD ALESSA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1351",
    "licenseIssueDate": "03/14/2019 00:00:00",
    "licenseExpiryDate": "03/13/2026 00:00:00"
  },
  {
    "id": "b502ef75-12c8-48e3-86e8-ff94fb93a50d",
    "slug": "hamad-humaid-essa-sultan-al-suwaidi",
    "name": "AHMED MOHAMED ABDULLA BARAKAT ABDULSAMAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBISAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/01/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: hamad humaid essa sultan al suwaidi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b502ef75-12c8-48e3-86e8-ff94fb93a50d",
        "address": "1606 ,متروبوليس تاور  ,داماك ,0000000 ,Dubai",
        "phone": "",
        "email": "noura.taisser@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "a653164d-3cbc-49d0-a7cd-ba5fe563222d",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1617",
    "licenseIssueDate": "01/28/2022 00:00:00",
    "licenseExpiryDate": "01/27/2026 00:00:00"
  },
  {
    "id": "c3c9e9d5-5e66-47c8-aec7-65ca9fee023e",
    "slug": "hamad-ibrahim-ahmad-ali-alustath",
    "name": "FATIMA YOUSEF AHMED ABDULLA ALMULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBISQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/12/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hamad ibrahim ahmad ali alustath",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c3c9e9d5-5e66-47c8-aec7-65ca9fee023e",
        "address": "",
        "phone": "97142959844 / 971501411515",
        "email": "info@alustathlawfirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "23c4faff-c170-4bb3-a3be-3279aa038027",
    "firmName": "KHALIFA AL MAFTOOL ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1602",
    "licenseIssueDate": "05/16/2025 00:00:00",
    "licenseExpiryDate": "05/15/2026 00:00:00"
  },
  {
    "id": "4dd9a6b6-3e85-4852-a550-27882db52a96",
    "slug": "hamad-mohammed-almutawa-alnuaimi",
    "name": "HAMAD MOHAMMED AL MUTAWA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/10/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: HAMAD MOHAMMED ALMUTAWA ALNUAIMI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4dd9a6b6-3e85-4852-a550-27882db52a96",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1458",
    "licenseIssueDate": "10/04/2020 00:00:00",
    "licenseExpiryDate": "10/03/2026 00:00:00"
  },
  {
    "id": "eb4a6d52-5f7e-4e45-b5f0-dee706c81cfc",
    "slug": "hamad-mohammed-kadfoor-abdulla-al-mehairi",
    "name": "HAMAD MOHD KADFOOR ABDULLA AL MEHAIRI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 28,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/10/1997",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hamad Mohammed Kadfoor Abdulla Al-Mehairi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_eb4a6d52-5f7e-4e45-b5f0-dee706c81cfc",
        "address": "",
        "phone": "97143304343",
        "email": "hamad@emiratesadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "f7823b07-a968-474f-8a13-a4454ef2d990",
    "firmName": "EMIRATES ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-312",
    "licenseIssueDate": "10/12/1997 00:00:00",
    "licenseExpiryDate": "10/11/2025 00:00:00"
  },
  {
    "id": "0eb27284-b13e-4d1c-baeb-f52a8875dc52",
    "slug": "hamad-mohammed-zayed-sulaiman-aleissaee",
    "name": "SALEH KHALIFA RASHED SAEED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/05/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hamad Mohammed Zayed Sulaiman Aleissaee",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0eb27284-b13e-4d1c-baeb-f52a8875dc52",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1976",
    "licenseIssueDate": "06/05/2024 00:00:00",
    "licenseExpiryDate": "06/04/2026 00:00:00"
  },
  {
    "id": "0d284e0c-3cf1-467b-9467-47c318b5892e",
    "slug": "hamad-naser-saeed-salem-alalawi",
    "name": "JUMA MOHAMMED AHMED DOURA ALKAABI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/11/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-11-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hamad Naser Saeed Salem Alalawi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0d284e0c-3cf1-467b-9467-47c318b5892e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1898",
    "licenseIssueDate": "12/16/2023 00:00:00",
    "licenseExpiryDate": "12/15/2025 00:00:00"
  },
  {
    "id": "fc4c23b2-501b-43f2-ac6f-20c8a8f065f8",
    "slug": "hamad-saeed-mubarak-jarwan-alshamisi",
    "name": "HAMAD SAEED MUBARAK JARWAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/01/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hamad Saeed Mubarak Jarwan Alshamisi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fc4c23b2-501b-43f2-ac6f-20c8a8f065f8",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1250",
    "licenseIssueDate": "01/28/2018 00:00:00",
    "licenseExpiryDate": "01/27/2026 00:00:00"
  },
  {
    "id": "1d1b25a7-95f5-41a0-b96d-87a301ad391d",
    "slug": "hamad-saeed-obaid-sulaij-alketbi",
    "name": "ABDULLA AHMED ABDULAZIZ QASSIM ALHADDAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/09/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hamad Saeed Obaid Sulaij Alketbi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1d1b25a7-95f5-41a0-b96d-87a301ad391d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1711",
    "licenseIssueDate": "10/26/2022 00:00:00",
    "licenseExpiryDate": "10/25/2025 00:00:00"
  },
  {
    "id": "3a06b693-db94-49db-a461-a9044add18e9",
    "slug": "hamad-saif-ebrahim-mohammed-alzaabi",
    "name": "hamad saif ebrahim mohammed alzaabi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/29/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: hamad saif ebrahim mohammed alzaabi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3a06b693-db94-49db-a461-a9044add18e9",
        "address": "Office 413 - Block B ,Hamdan Bin Rashid Al Maktoum Foundation for Medical Science ,Makani No: 2598892707 ,000 ,Dubai",
        "phone": "97142571323 / 971554377771",
        "email": "info@alzaabi-binghalaita.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "ff6f54b7-0992-43dc-8480-cfff31538d52",
    "firmName": "HAMAD ALZAABI & MUNA BIN GHALAITA ADVOCATES &",
    "registrationNumber": "1784",
    "licenseIssueDate": "03/29/2023 00:00:00",
    "licenseExpiryDate": "03/28/2026 00:00:00"
  },
  {
    "id": "8d72bc5a-0190-4765-88b4-66b4f91ffe18",
    "slug": "hamda-hussain-ahmad-jassim",
    "name": "HOMDA HUSSEIN AHMED GASEM MKA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBISAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Civil Transactions-POA & Sponsorship",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Civil Transactions-Insurance",
      "Civil Transactions-Construction and Contracts for Services",
      "Civil Transactions-Ownership & Title",
      "Civil Transactions-HR & Employee Affairs",
      "Commercial Transactions-Commercial Mortgage",
      "Criminal Law-Family Crimes",
      "Personal Status-Custody & Alimony",
      "Civil Transactions-Immigration and Residency",
      "Commercial Transactions-Bankruptcy",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Civil Transactions-Arbitration",
      "Criminal Law-Hate crimes",
      "Criminal Law-Crimes against persons",
      "Personal Status-Legacies and Inheritance",
      "Commercial Transactions-Commercial Companies",
      "Commercial Transactions-Banking Operations",
      "Civil Transactions-Labor & Workers",
      "Criminal Law-Drug Crimes",
      "Civil Transactions-Sale",
      "Commercial Transactions-Consumer protection",
      "Personal Status-Marriage & Divorce",
      "Civil Transactions-Compensation",
      "Criminal Law-Crimes against properties",
      "Commercial Transactions-E-Commerce",
      "Criminal Law-Cybercrimes",
      "Commercial Transactions-Intellectual Property (includes trademarks",
      "copy rights",
      "patents)",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/07/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: HAMDA HUSSAIN AHMAD JASSIM",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8d72bc5a-0190-4765-88b4-66b4f91ffe18",
        "address": "جائزة الشيخ حمدان ,مبانى الحضيبة للجوائز - البلوك ب - الطابق السادس ,متحف الضيافة ,26596 ,Dubai",
        "phone": "97143889770",
        "email": "hamdamakkiadvocates@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "aaee8e41-be83-4596-99e8-716e84e93e28",
    "firmName": "HAMDA MAKKI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-767",
    "licenseIssueDate": "07/19/2011 00:00:00",
    "licenseExpiryDate": "07/18/2026 00:00:00"
  },
  {
    "id": "8ab12d0e-88a4-446f-ac85-743c9eb58957",
    "slug": "hamdan-abdulla-abdulrahman-ali-al-harmi",
    "name": "HAMDAN ABDULLA ABDULRAHMAN ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 22,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/10/2002",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hamdan Abdulla Abdulrahman Ali Al Harmi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8ab12d0e-88a4-446f-ac85-743c9eb58957",
        "address": "Hamdan Abdullah Abdulrahman Ali Alharmi ,2 office 211 ,MSM 1 ,Auto Land Motors ,6064 ,Dubai",
        "phone": "97142999559",
        "email": "hamdan@harmilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "b0830edc-21a4-4df9-9d83-febcab7756da",
    "firmName": "HAMDAN AL HARMI & ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-436",
    "licenseIssueDate": "10/22/2002 00:00:00",
    "licenseExpiryDate": "10/21/2025 00:00:00"
  },
  {
    "id": "a929055b-d04e-47bc-abaa-c8c27b0df4b3",
    "slug": "hamdan-abdulla-subaih-saif-alkaabi",
    "name": "HAMDAN ABDULLA SUBAIH SAIF ALKAABI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/11/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hamdan Abdulla Subaih Saif Alkaabi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a929055b-d04e-47bc-abaa-c8c27b0df4b3",
        "address": "MOSTAFA MAHMOUD  ,1304 ,AL MOOSA TOWER 1 ,First Trade Center ,25635 ,Dubai",
        "phone": "97142254438",
        "email": "info@hkadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "d73d1b91-74ae-4266-9f38-d28296d70f52",
    "firmName": "HAMDAN ALKAABI ADVOCATES & LEGAL CONSULTANS",
    "registrationNumber": "L-899",
    "licenseIssueDate": "11/24/2013 00:00:00",
    "licenseExpiryDate": "11/23/2025 00:00:00"
  },
  {
    "id": "edd43785-8b73-4526-800a-ce8aad68197d",
    "slug": "hamdan-ahmed-mohammed-husain-hamdan-budebs",
    "name": "HAMDAN AHMED MOHAMED HUSAIN HAMDAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 19,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/11/2005",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-11-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hamdan Ahmed Mohammed Husain Hamdan BuDebs",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_edd43785-8b73-4526-800a-ce8aad68197d",
        "address": "HAMDAN BUDEBES  ,1614 ,BLUE BAY TOWER ,BUSINESS BAY ,127637 ,Dubai",
        "phone": "97142505612",
        "email": "info-dubai@alotaiba-law.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "34156aa2-d714-4a9a-875a-eb422ea3c4c2",
    "firmName": "ALOTEIBA & HAMDAN BUDEBES ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-294",
    "licenseIssueDate": "11/20/2005 00:00:00",
    "licenseExpiryDate": "11/19/2025 00:00:00"
  },
  {
    "id": "71443983-c9e8-4751-ab2e-f097e9cbf096",
    "slug": "hamdan-dehai-khalfansubaih-alkaabi",
    "name": "SALEH ABDULLA MUBARAK ALSENAANI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/01/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: HAMDAN DEHAI KHALFANSUBAIH ALKAABI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_71443983-c9e8-4751-ab2e-f097e9cbf096",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1621",
    "licenseIssueDate": "02/08/2022 00:00:00",
    "licenseExpiryDate": "02/07/2026 00:00:00"
  },
  {
    "id": "f74e5f61-3eb9-482a-af01-07ddc2800ca4",
    "slug": "hamdan-mohd-hamdan-abdulla-al-shamsi",
    "name": "HAMDAN MOHD HAMDAN ABDULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/10/2010",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: HAMDAN MOHD HAMDAN ABDULLA AL SHAMSI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f74e5f61-3eb9-482a-af01-07ddc2800ca4",
        "address": "HAMDAN ALSHAMSI ,الطابق الرابع مكتب 401, 406,407 ,بي سكوير 01 ,مجمع دبي سكوير ,116564 ,Dubai",
        "phone": "97143469262",
        "email": "courts@has.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "de2c61a6-9d00-457e-ad1d-e73e4e62d9bd",
    "firmName": "HAMDAN ALSHAMSI LAWYER & LEGAL CONSULTANTS",
    "registrationNumber": "L-658",
    "licenseIssueDate": "10/25/2010 00:00:00",
    "licenseExpiryDate": "10/24/2025 00:00:00"
  },
  {
    "id": "6c121a20-ed39-4bf4-ba9b-605ad53321dd",
    "slug": "hamdan-rashed-ali-rashoud-alzeyoudi",
    "name": "HAMDAN RASHED ALI RASHOUD ALZEYOUDI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/04/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hamdan Rashed Ali Rashoud Alzeyoudi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6c121a20-ed39-4bf4-ba9b-605ad53321dd",
        "address": "",
        "phone": "97148845339 / 971505303737",
        "email": "office@law-hrz.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "522234a0-35f4-468e-8f86-5633ca5ea354",
    "firmName": "HAMDAN RASHOUD ALZEYOUDI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-1002",
    "licenseIssueDate": "04/02/2015 00:00:00",
    "licenseExpiryDate": "04/01/2026 00:00:00"
  },
  {
    "id": "8ab1c911-a653-4167-a84e-5cc0a8c821c7",
    "slug": "hamdan-sulaiman-salim-sulaiman-almaazmi",
    "name": "AHMED ABDUL LATIF DHAEN ABDULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/12/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hamdan Sulaiman Salim Sulaiman Almaazmi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8ab1c911-a653-4167-a84e-5cc0a8c821c7",
        "address": "",
        "phone": "97142566628 / 971508908030",
        "email": "info@halmaazmilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "b0870ce2-bb48-4fd6-84c4-b053eeef75bd",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1615",
    "licenseIssueDate": "01/25/2022 00:00:00",
    "licenseExpiryDate": "01/24/2026 00:00:00"
  },
  {
    "id": "eb8d45ef-28b5-4c96-ac49-377a61b16787",
    "slug": "hamdy-ahmed-mohamed-khalifa",
    "name": "HAMDY AHMED MOHAMED KHALIFA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/06/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hamdy Ahmed Mohamed Khalifa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_eb8d45ef-28b5-4c96-ac49-377a61b16787",
        "address": "الطابق الخامس ,الساحة ,سوق البحار ,26011 ,Dubai",
        "phone": "97142277717",
        "email": "info@alsahlawico.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "a6811a79-5470-4c33-ad95-3ff8f661c052",
    "firmName": "AL SAHLAWI & CO ADVOCATES & CONSULTANTS",
    "registrationNumber": "L-877",
    "licenseIssueDate": "06/30/2013 00:00:00",
    "licenseExpiryDate": "06/29/2026 00:00:00"
  },
  {
    "id": "e5bee81b-7fc3-40b9-be67-a811828666e5",
    "slug": "hamed-awadh-husain-mohammed-al-menhali",
    "name": "HAMID AWADH HUSSAIN MOHAMED ALMENHALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 20,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/04/2005",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hamed Awadh Husain Mohammed Al-Menhali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e5bee81b-7fc3-40b9-be67-a811828666e5",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-333",
    "licenseIssueDate": "04/13/2005 00:00:00",
    "licenseExpiryDate": "04/12/2026 00:00:00"
  },
  {
    "id": "8aaf77ac-ac46-4e50-bec0-00ca2278d585",
    "slug": "hamid-jawad-attia",
    "name": "HAMID JAWAD ATTIA KHAZRAJI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBISgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/05/2009",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hamid Jawad Attia",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8aaf77ac-ac46-4e50-bec0-00ca2278d585",
        "address": "",
        "phone": "97144472020",
        "email": "info@arnadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "e6573267-5872-48d8-add1-06a3deccf9e4",
    "firmName": "ABDUL RAHMAN NASEEB ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-667",
    "licenseIssueDate": "05/18/2009 00:00:00",
    "licenseExpiryDate": "05/17/2026 00:00:00"
  },
  {
    "id": "e28d6e52-e24f-428d-9111-097f9576cfe3",
    "slug": "hammam-ramlan-mohamed-alhajeri",
    "name": "HAMMAM RAMLAN MOHAMED BIN AJJAJ ALHAJERI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/03/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hammam Ramlan Mohamed Alhajeri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e28d6e52-e24f-428d-9111-097f9576cfe3",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-925",
    "licenseIssueDate": "03/30/2014 00:00:00",
    "licenseExpiryDate": "03/29/2026 00:00:00"
  },
  {
    "id": "c6491782-bf6a-48ea-884b-17fd614e55ed",
    "slug": "hanan-ahmed-hassan-ahmed-alblooshi",
    "name": "HANAN AHMED HASSAN AHMED ALBLOOSHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/07/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hanan Ahmed Hassan Ahmed Alblooshi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c6491782-bf6a-48ea-884b-17fd614e55ed",
        "address": "الثالث مكتب 304 ,برج سما ,المركز التجاري  ,116623 ,Dubai",
        "phone": "97142723388",
        "email": "info@habibllc.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "373bb6e6-5948-493f-a6ac-2ea343840160",
    "firmName": "HABIB AL HOSANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1202",
    "licenseIssueDate": "07/13/2017 00:00:00",
    "licenseExpiryDate": "07/12/2026 00:00:00"
  },
  {
    "id": "dc103feb-c135-436a-b31f-47d7b3feb44a",
    "slug": "hanan-mohamed-saeed-homoud-almazrouei",
    "name": "HANAN MOHAMED SAEED HUMOUD ALMAZROUEI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/03/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hanan Mohamed Saeed Homoud Almazrouei",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dc103feb-c135-436a-b31f-47d7b3feb44a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1263",
    "licenseIssueDate": "03/07/2018 00:00:00",
    "licenseExpiryDate": "03/06/2026 00:00:00"
  },
  {
    "id": "4e466d7d-d11a-410d-87f0-b215204feea4",
    "slug": "hanan-salem-hasan-albayyed-alshemeili",
    "name": "Hanan Salem Hasan Albayyed Alshemeili",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/01/2009 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hanan Salem Hasan Albayyed Alshemeili",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4e466d7d-d11a-410d-87f0-b215204feea4",
        "address": "104 ,سان شاين 1  ,شقق جرين هاوس الفندقية ,0000 ,Dubai",
        "phone": "97142280666 / 97142280666",
        "email": "Hanansalem.advocate@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "f58725e5-47e3-4ed2-8325-35655ffe5771",
    "firmName": "HANAN SALEM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "670",
    "licenseIssueDate": "07/01/2009 00:00:00",
    "licenseExpiryDate": "06/30/2026 00:00:00"
  },
  {
    "id": "3ca0886f-43f9-43c6-a9e3-52956af6e710",
    "slug": "hanan-yahya-ali-butabtoub",
    "name": "HALAWA ALI MOHAMMED S BIN SARHAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/06/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hanan Yahya Ali Butabtoub",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3ca0886f-43f9-43c6-a9e3-52956af6e710",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1996",
    "licenseIssueDate": "06/27/2024 00:00:00",
    "licenseExpiryDate": "06/26/2026 00:00:00"
  },
  {
    "id": "466f5b7a-6c5e-40e6-b22c-eaf1f705b4ab",
    "slug": "hani-fayez-mustafa-karkaba",
    "name": "MARIAM MOHAMMED MUBARAK MUGHEER ALKHYELI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/08/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: hani fayez mustafa karkaba",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_466f5b7a-6c5e-40e6-b22c-eaf1f705b4ab",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-2021",
    "licenseIssueDate": "09/06/2024 00:00:00",
    "licenseExpiryDate": "09/05/2026 00:00:00"
  },
  {
    "id": "8f8fdeed-2f25-4a52-a3e1-409a47bb9347",
    "slug": "hani-rajab-moosa-abdulla-aljasmi",
    "name": "HANI RAJAB MOOSA ABDULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/04/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hani Rajab Moosa Abdulla AlJasmi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8f8fdeed-2f25-4a52-a3e1-409a47bb9347",
        "address": "HANI RAJAB MOOSA ABDULLA ALJASMI ,M ,LIBERTY ,SHARJAH BANK ,123887 ,Dubai",
        "phone": "97142957744",
        "email": "info@aljasmilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "04b37ea9-3ebd-45ff-9b0f-56fa9ee7e6fd",
    "firmName": "HANI AL JASMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-801",
    "licenseIssueDate": "04/18/2012 00:00:00",
    "licenseExpiryDate": "04/17/2026 00:00:00"
  },
  {
    "id": "6d0bbf72-175d-4d73-ac17-0498addfc665",
    "slug": "hannan-ahmad-hussain-ali-albalooshi",
    "name": "FATMA ALI MALALLA MOHAMED GHANEM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/05/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: HANNAN AHMAD HUSSAIN ALI ALBALOOSHI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6d0bbf72-175d-4d73-ac17-0498addfc665",
        "address": "",
        "phone": "97148761744 / 971971487617",
        "email": "info@noorhanlawyer.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "8fd1535a-4b34-4e52-83df-139fcfb26305",
    "firmName": "NASSER MALALLA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1663",
    "licenseIssueDate": "06/10/2022 00:00:00",
    "licenseExpiryDate": "06/09/2026 00:00:00"
  },
  {
    "id": "390e0786-7b76-4d2e-a1db-f7ad145fd036",
    "slug": "hanoof-mohamed-ali-tameem",
    "name": "HANOOF MOHAMED ALI TAMEEM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/01/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hanoof Mohamed Ali Tameem",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_390e0786-7b76-4d2e-a1db-f7ad145fd036",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1245",
    "licenseIssueDate": "01/11/2018 00:00:00",
    "licenseExpiryDate": "01/10/2026 00:00:00"
  },
  {
    "id": "95019270-b80a-4ba2-8481-5ad51c5c581f",
    "slug": "hasan-ali-hasan-ali-almarzooqi",
    "name": "HASAN ALI HASAN ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/05/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hasan Ali Hasan Ali Almarzooqi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_95019270-b80a-4ba2-8481-5ad51c5c581f",
        "address": "OBAID SAQER OBAID BUSIT ,20 ,Grosvenor Business Tower -  ,Sheikha noora tower ,333341 ,Dubai",
        "phone": "97144472777",
        "email": "busit@busitlegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "ebfce11b-8cb4-42cc-95d3-71c6e17bfdf0",
    "firmName": "BUSIT ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-1279",
    "licenseIssueDate": "05/07/2018 00:00:00",
    "licenseExpiryDate": "05/06/2026 00:00:00"
  },
  {
    "id": "c4f97697-abc6-43ff-b3d6-15296c00438c",
    "slug": "hasan-ali-yousef-juma-almarzooqi",
    "name": "HASAN ALI YOUSEF J ALMARZOOQI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/05/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hasan Ali Yousef Juma Almarzooqi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c4f97697-abc6-43ff-b3d6-15296c00438c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-872",
    "licenseIssueDate": "05/16/2013 00:00:00",
    "licenseExpiryDate": "05/15/2026 00:00:00"
  },
  {
    "id": "c33ada56-00d6-4b5c-9e04-fb6c30f51e20",
    "slug": "hasan-ismail-alaydaroos",
    "name": "HASAN ISMAIL ALAYDAROOS",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBISQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 15,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/12/2009",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hasan Ismail Alaydaroos",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c33ada56-00d6-4b5c-9e04-fb6c30f51e20",
        "address": "10 ,Rigga Al Bateen Plaza Building ,اعلي مطعم صدف الايراني  ,115791 ,Dubai",
        "phone": "97142666352",
        "email": "bnesmael@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "19d3b420-9a9f-4734-8da2-1f2abf00e898",
    "firmName": "BIN ISMAIL ADVOCATES AND LEGAL CONSULTANCY",
    "registrationNumber": "L-686",
    "licenseIssueDate": "12/24/2009 00:00:00",
    "licenseExpiryDate": "12/23/2025 00:00:00"
  },
  {
    "id": "f5f18fe0-e029-4625-9ffa-3c75bb25a3bd",
    "slug": "hasan-salem-smyea-alahbabi",
    "name": "HASAN SALEM SMAYEA SAADAN ALAHBABI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/07/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: hasan salem smyea alahbabi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f5f18fe0-e029-4625-9ffa-3c75bb25a3bd",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1551",
    "licenseIssueDate": "07/27/2021 00:00:00",
    "licenseExpiryDate": "07/26/2026 00:00:00"
  },
  {
    "id": "2ccc7d1a-4c20-45b3-9060-2824c2ee365a",
    "slug": "hashem-ali-hashem-ahmed",
    "name": "HASHEM ALI HASHEM AHMED ALHASHMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/10/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hashem Ali Hashem Ahmed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2ccc7d1a-4c20-45b3-9060-2824c2ee365a",
        "address": "",
        "phone": "/ 971562331154",
        "email": "info@hashem-alhashmi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "c77eda8b-21fd-4df8-b5b6-1c2876b9c6cf",
    "firmName": "HASHEM ALHASHMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-665",
    "licenseIssueDate": "10/16/2024 00:00:00",
    "licenseExpiryDate": "10/15/2025 00:00:00"
  },
  {
    "id": "4f1c62df-ea18-48f9-a7e0-241208385886",
    "slug": "hashem-ali-mohammed-omar-alaidarous",
    "name": "HASHEM ALI MOHAMMED OMAR ALAIDAROUS",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/01/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hashem Ali Mohammed Omar Alaidarous",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4f1c62df-ea18-48f9-a7e0-241208385886",
        "address": "Gamal Yassein Abdalla ,الطابق 13  Floor No 13 ,بناية مركز ابروي (The Oberoi Center) ,فندق ابروي (The Oberoi Hotel) ,33299 ,Dubai",
        "phone": "97142828000",
        "email": "litigation@alaidarous.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "9a923766-1fd1-4e06-a871-89662120384e",
    "firmName": "AL AIDAROUS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1072",
    "licenseIssueDate": "01/15/2020 00:00:00",
    "licenseExpiryDate": "01/14/2026 00:00:00"
  },
  {
    "id": "74b668ca-b1cd-4598-a07e-59f75ab0fbe7",
    "slug": "hashim-malik-abbas-alblooshi",
    "name": "HASHIM MALIK ABBAS",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 18,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/03/2007",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: HASHIM MALIK ABBAS ALBLOOSHI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_74b668ca-b1cd-4598-a07e-59f75ab0fbe7",
        "address": "",
        "phone": "97142555000",
        "email": "info@kha.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "0e4b9f0a-83fc-45c9-b0d3-f38013690624",
    "firmName": "KHALIFA BIN HUWAIDAN ALKATBI ADVOCATES & LEGAL CONSULTANT",
    "registrationNumber": "L-594",
    "licenseIssueDate": "03/06/2007 00:00:00",
    "licenseExpiryDate": "03/05/2026 00:00:00"
  },
  {
    "id": "b7593c77-fcd3-4619-8060-bedfad6535e3",
    "slug": "hashim-salem-saif-abdulla-salem",
    "name": "HASHIM SALEM SAIF ABDULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Commercial Agency",
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Civil Transactions-POA & Sponsorship",
      "Civil Transactions-Insurance",
      "Personal Status-Wills",
      "Civil Transactions-Construction and Contracts for Services",
      "Civil Transactions-Ownership & Title",
      "Civil Transactions-HR & Employee Affairs",
      "Criminal Law-Family Crimes",
      "Personal Status-Custody & Alimony",
      "Civil Transactions-Immigration and Residency",
      "Commercial Transactions-Commercial Real Estate",
      "Civil Transactions-Residential Real Estate",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Criminal Law-Hate crimes",
      "Civil Transactions-Tenancy",
      "Criminal Law-Crimes against persons",
      "Personal Status-Legacies and Inheritance",
      "Commercial Transactions-Commercial Companies",
      "Civil Transactions-Labor & Workers",
      "Personal Status-Legal Capacity & Guardianship",
      "Criminal Law-Drug Crimes",
      "Proceedings-Cases and Proceedings before arbitral tribunals and other alternative dispute resolution bodies",
      "Commercial Transactions-Consumer protection",
      "Personal Status-Marriage & Divorce",
      "Personal Status-Child Abuse & Abduction",
      "Civil Transactions-Compensation",
      "Criminal Law-Crimes against properties",
      "Criminal Law-Cybercrimes",
      "Commercial Transactions-Intellectual Property (includes trademarks",
      "copy rights",
      "patents)",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/12/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hashim salem saif Abdulla salem",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b7593c77-fcd3-4619-8060-bedfad6535e3",
        "address": "الطابق التاسع ,الفتان بلازا ,مطار دبي الدولي ,00 ,Dubai",
        "phone": "97145689958 / 971508742777",
        "email": "hashim.salem@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "2fec32c1-d380-4c19-b90e-b30c48520701",
    "firmName": "HASHIM SALEM SAIF ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-1328",
    "licenseIssueDate": "12/06/2018 00:00:00",
    "licenseExpiryDate": "12/05/2025 00:00:00"
  },
  {
    "id": "5294d774-73fb-46bb-a561-59017937edc6",
    "slug": "hasina-rashed-humaid-rashed-almemari",
    "name": "TALAL HASSAN HADAF MUSLEM KHAWAR",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/05/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: HASINA RASHED HUMAID RASHED ALMEMARI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5294d774-73fb-46bb-a561-59017937edc6",
        "address": "",
        "phone": "97142722998",
        "email": "jalnuaimi.adv@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "1b84b124-19de-41b5-89de-ec40b2bd1d01",
    "firmName": "MARIAM AHMED SALEM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1965",
    "licenseIssueDate": "05/24/2024 00:00:00",
    "licenseExpiryDate": "05/23/2026 00:00:00"
  },
  {
    "id": "6c51e33a-02eb-4458-832a-467de5a4956a",
    "slug": "hassan-abdalla-mohamed-ali-al-ali",
    "name": "HASSAN ABDALLA MOHAMED ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/04/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hassan Abdalla Mohamed Ali Al Ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6c51e33a-02eb-4458-832a-467de5a4956a",
        "address": "الطابق الثامن ,بزنس أفنيو ,خلف وكالة نيسان ,444775 ,Dubai",
        "phone": "97142501414",
        "email": "info@halalilaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "37ab9a73-e65f-4829-9402-6eac64c4c621",
    "firmName": "HASSAN AL ALI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-955",
    "licenseIssueDate": "05/01/2017 00:00:00",
    "licenseExpiryDate": "04/30/2026 00:00:00"
  },
  {
    "id": "09a52d3c-29fb-4b1b-9ae6-b8d2c0aaac0a",
    "slug": "hassan-abdulla-mohamed-bin-essa-al-ghfeli",
    "name": "IBRAHIM MAHMOUD I ALHAWAI ALZAROONI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/08/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: hassan abdulla mohamed bin essa al ghfeli",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_09a52d3c-29fb-4b1b-9ae6-b8d2c0aaac0a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-2023",
    "licenseIssueDate": "09/13/2024 00:00:00",
    "licenseExpiryDate": "09/12/2026 00:00:00"
  },
  {
    "id": "f2bc455c-d21a-4b10-ad61-415bcb6ea83d",
    "slug": "hassan-abdulla-mohammad-alabdooli",
    "name": "HASSAN ABDULLA MOHAMMAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/12/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hassan Abdulla Mohammad Alabdooli",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f2bc455c-d21a-4b10-ad61-415bcb6ea83d",
        "address": "Hitham Bassam ,1 ,R549 ,بنك مصر ,99094 ,Dubai",
        "phone": "97142355517",
        "email": "hassanalabdooli@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "746e4dd4-f7bb-4efd-84f5-ad6b769ad28c",
    "firmName": "HASSAN AL ABDOOLI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-785",
    "licenseIssueDate": "12/14/2011 00:00:00",
    "licenseExpiryDate": "12/13/2025 00:00:00"
  },
  {
    "id": "d71d34e7-12ed-4ff8-a255-820ebbca2aec",
    "slug": "hassan-abdulrahman-hassan-abdullah",
    "name": "HASSAN ABDULRAHMAN HASSAN ABDULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/03/2009",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hassan Abdulrahman Hassan Abdullah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d71d34e7-12ed-4ff8-a255-820ebbca2aec",
        "address": "3902 ,single business tower ,Sheikh Zayed Rd.  ,90077 ,Dubai",
        "phone": "97143804141 / 97143804141",
        "email": "info@united-advocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "52ebf695-ce46-4e03-abc9-f4d8d2f8a356",
    "firmName": "UNITED ADVOCATES",
    "registrationNumber": "L-653",
    "licenseIssueDate": "03/16/2009 00:00:00",
    "licenseExpiryDate": "03/15/2026 00:00:00"
  },
  {
    "id": "fa5f3de7-250f-4bf6-8ee9-96e726b556d1",
    "slug": "hassan-ahmed-abdelaziz-jasim-abdalla",
    "name": "HASSAN AHMED ABDELAZIZ JASIM ABDALLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/01/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hassan Ahmed Abdelaziz Jasim Abdalla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fa5f3de7-250f-4bf6-8ee9-96e726b556d1",
        "address": "",
        "phone": "97143528887",
        "email": "info@kashwanilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "01ccf3a9-cfd3-4fb5-b5ac-a912503c2630",
    "firmName": "KASHWANI LAW FIRM",
    "registrationNumber": "L-852",
    "licenseIssueDate": "01/31/2013 00:00:00",
    "licenseExpiryDate": "01/30/2026 00:00:00"
  },
  {
    "id": "051eee91-9e5f-40fb-a94a-ab58685ca879",
    "slug": "hassan-ali-abdulla-shahdad",
    "name": "HASSAN ALI ABDULLA SHAHDAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/11/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hassan Ali Abdulla Shahdad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_051eee91-9e5f-40fb-a94a-ab58685ca879",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1390",
    "licenseIssueDate": "11/04/2019 00:00:00",
    "licenseExpiryDate": "11/03/2025 00:00:00"
  },
  {
    "id": "68300863-bd8d-43b0-b2c5-1d8e0ce9fe68",
    "slug": "hassan-ali-hassan-ahmed-alhouli",
    "name": "HASSAN ALI HASSAN AHMED ALHOULI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/07/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: HASSAN ALI HASSAN AHMED ALHOULI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_68300863-bd8d-43b0-b2c5-1d8e0ce9fe68",
        "address": "",
        "phone": "97142868681",
        "email": "hawailaw@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "3f1d962a-159f-4d0f-82d0-ebd94930d6ae",
    "firmName": "LAW OFFICE OF MAHMOUD AL HAWAI ATTORNEYS & CONSULTANTS AT LAW",
    "registrationNumber": "L-1372",
    "licenseIssueDate": "07/10/2019 00:00:00",
    "licenseExpiryDate": "07/09/2026 00:00:00"
  },
  {
    "id": "76f44cd2-e876-4716-bed3-9f3cb86e45cd",
    "slug": "hassan-ali-humaid-naser-al-shaqsi",
    "name": "Hassan Ali Humaid Naser AL-Shaqsi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 27,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/12/1998 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-09-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hassan Ali Humaid Naser AL-Shaqsi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_76f44cd2-e876-4716-bed3-9f3cb86e45cd",
        "address": "21 ,Rolex Tower ,Emirates Grand Hotel ,94334 ,Dubai",
        "phone": "97143277772 / 97145584900",
        "email": "info@globaladvocates.net",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "9b42810f-1d55-4aea-ac4a-7d9d1b25ac08",
    "firmName": "GLOBAL ADVOCACY & LEGAL COUNSEL",
    "registrationNumber": "325",
    "licenseIssueDate": "01/12/1998 00:00:00",
    "licenseExpiryDate": "01/09/2026 00:00:00"
  },
  {
    "id": "ab623a6c-398c-40cd-91e0-3aaf494da748",
    "slug": "hassan-ali-mattar-al-riyami",
    "name": "HASSAN ALI MATAR ALRIYAMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 17,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/08/2008",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hassan Ali Mattar Al Riyami",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ab623a6c-398c-40cd-91e0-3aaf494da748",
        "address": "HASSAN ALI MATAR ALRIYAMI ,24 ,GRASVENOR BUSINESS TOWER ,NEEDS SUPERMARKET ,215880 ,Dubai",
        "phone": "97144534188",
        "email": "courts@alriyamiadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "a40a2f1f-69a9-429c-8086-dba9d985532b",
    "firmName": "HASAN ALRAYYAMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-640",
    "licenseIssueDate": "09/01/2008 00:00:00",
    "licenseExpiryDate": "08/31/2026 00:00:00"
  },
  {
    "id": "e1332b0a-f1f1-41ea-8ddc-e665eba065cf",
    "slug": "hassan-ashoor-hassan-abdulla-almulla",
    "name": "HASSAN ASHOOR HASSAN ABDULLA ALMULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/06/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hassan Ashoor Hassan Abdulla Almulla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e1332b0a-f1f1-41ea-8ddc-e665eba065cf",
        "address": "11 مكتب رقم 1104 ,وصل بيزنش سنترال ,خلف سيتي سنتر ديره ,23404 ,Dubai",
        "phone": "97142865503 / 971502705678",
        "email": "info-dxb@almulla-advocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "6a822223-cec3-43fe-b3a7-3d4a10d010c4",
    "firmName": "HASSAN ASHOOR ALMULLA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1194",
    "licenseIssueDate": "06/19/2017 00:00:00",
    "licenseExpiryDate": "06/18/2026 00:00:00"
  },
  {
    "id": "3d59e6e6-c187-46a1-9f7e-e55b1827c2ab",
    "slug": "hassan-humaid-abdulla-hassan-al-suwaidi",
    "name": "HASSAN HUMAID ABDALLA HASSAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBISAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 23,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/07/2002",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hassan Humaid Abdulla Hassan Al Suwaidi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3d59e6e6-c187-46a1-9f7e-e55b1827c2ab",
        "address": "",
        "phone": "97142500251",
        "email": "hassan.suwaidi@hhslawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "92cddf0e-969b-47c0-a9a7-9fb57a11d292",
    "firmName": "HASSAN HUMAID AL SUWAIDI ADVOCATES AND LEGAL CONSULTANCY",
    "registrationNumber": "L-431",
    "licenseIssueDate": "07/16/2002 00:00:00",
    "licenseExpiryDate": "07/15/2026 00:00:00"
  },
  {
    "id": "c12ad477-e712-40d9-8864-43e5069cfeeb",
    "slug": "hassan-malalla-khalfn-khalaf-alhammadi",
    "name": "EISA HASSAN ABDALLA ISMAIL HASOUNI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/10/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hassan Malalla Khalfn Khalaf Alhammadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c12ad477-e712-40d9-8864-43e5069cfeeb",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1712",
    "licenseIssueDate": "10/27/2022 00:00:00",
    "licenseExpiryDate": "10/26/2025 00:00:00"
  },
  {
    "id": "2938615f-eb25-4b18-badc-5ef87c963898",
    "slug": "hassan-mohamed-darwish-mohamed-alhosani",
    "name": "HASSAN MOHAMED DARWISH MOHAMED ALHOSANI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/06/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hassan Mohamed Darwish Mohamed Alhosani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2938615f-eb25-4b18-badc-5ef87c963898",
        "address": "",
        "phone": "97143585135 / 971503564426",
        "email": "info@alansarilaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "42521deb-a4c5-41c9-989c-c10b046f34b5",
    "firmName": "HUMAID ALANSARI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-2109",
    "licenseIssueDate": "06/25/2025 00:00:00",
    "licenseExpiryDate": "06/24/2026 00:00:00"
  },
  {
    "id": "d1945ad9-79f0-4d74-904f-16aaec7d8a60",
    "slug": "hassan-mohamed-hassan-karam",
    "name": "MOHAMMED HELAL ARAR SHAHWAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/12/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hassan Mohamed Hassan Karam",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d1945ad9-79f0-4d74-904f-16aaec7d8a60",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1902",
    "licenseIssueDate": "01/03/2024 00:00:00",
    "licenseExpiryDate": "01/02/2026 00:00:00"
  },
  {
    "id": "59ed4a69-60af-4b42-a79f-10ed051650c7",
    "slug": "hassan-mohamed-yahya-abdalla",
    "name": "SULTAN SAEED MOHAMMED ALBADI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/10/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hassan Mohamed Yahya Abdalla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_59ed4a69-60af-4b42-a79f-10ed051650c7",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1881",
    "licenseIssueDate": "11/04/2023 00:00:00",
    "licenseExpiryDate": "11/03/2025 00:00:00"
  },
  {
    "id": "cbd4f5ee-c09e-4f13-99ae-165fd1fd8197",
    "slug": "hassan-mohammad-arab-darwish",
    "name": "HASSAN MOHAMED ARAB DARWISH",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 27,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/05/1998",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hassan Mohammad Arab Darwish",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cbd4f5ee-c09e-4f13-99ae-165fd1fd8197",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-338",
    "licenseIssueDate": "06/01/1998 00:00:00",
    "licenseExpiryDate": "05/31/2026 00:00:00"
  },
  {
    "id": "65724905-f46a-4b58-a97b-13b9b716f8aa",
    "slug": "hassan-mohammad-hassan-tamim",
    "name": "HASSAN MOHAMMAD HASSAN TAMIM ALTAMIMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/12/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hassan Mohammad Hassan Tamim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_65724905-f46a-4b58-a97b-13b9b716f8aa",
        "address": "Hassan Mohammad Hassan Tamim ,الطابق السادس 614 ,اعمار بزنس بارك - 4  ,Zabeel house the greens - hotel  ,18122 ,Dubai",
        "phone": "97142999972",
        "email": "info@htlawyers.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "6e2fe0dd-c3f8-40ae-9ed8-5e4fdf894d9b",
    "firmName": "HASSAN TAMIM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-905",
    "licenseIssueDate": "12/11/2013 00:00:00",
    "licenseExpiryDate": "12/10/2025 00:00:00"
  },
  {
    "id": "bdbae819-a847-46de-bbbe-653bdaa12843",
    "slug": "hassan-murad-abdalla-shamal-alraeesi",
    "name": "HASSAN MURAD ABDALLA MOHAMED SHAMAL",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/09/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hassan Murad Abdalla Shamal Alraeesi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bdbae819-a847-46de-bbbe-653bdaa12843",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1566",
    "licenseIssueDate": "09/22/2021 00:00:00",
    "licenseExpiryDate": "09/21/2026 00:00:00"
  },
  {
    "id": "941d16b1-b170-40f7-8b2a-7d797ecb7b33",
    "slug": "hassan-obaid-mousa-abdalla-alkaabi",
    "name": "MOHAMMED RASHED SALEM RASHED ALEGHFELI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/12/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: HASSAN OBAID MOUSA ABDALLA ALKAABI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_941d16b1-b170-40f7-8b2a-7d797ecb7b33",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1905",
    "licenseIssueDate": "01/04/2024 00:00:00",
    "licenseExpiryDate": "01/03/2026 00:00:00"
  },
  {
    "id": "50aaa206-359f-42a9-85a1-3a80f5ec9a66",
    "slug": "hassan-rashid-hassan-ahmed-almarashda",
    "name": "HASSAN RASHID HASSAN AHMED ALMARASHDA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Cases and Proceedings before Dubai International Financial Centre",
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Civil Transactions-Insurance",
      "Personal Status-Wills",
      "Personal Status-Custody & Alimony",
      "Commercial Transactions-Bankruptcy",
      "Personal Status-Legacies and Inheritance",
      "Personal Status-Legal Capacity & Guardianship",
      "Criminal Law-Drug Crimes",
      "Proceedings-Cases and Proceedings before arbitral tribunals and other alternative dispute resolution bodies",
      "Personal Status-Marriage & Divorce",
      "Personal Status-Child Abuse & Abduction",
      "Civil Transactions-Compensation",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/07/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hassan Rashid Hassan Ahmed Almarashda",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_50aaa206-359f-42a9-85a1-3a80f5ec9a66",
        "address": "",
        "phone": "97143333245 / 97143333245",
        "email": "y.albulooshi@yhadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "5fd2b33a-4bae-47d7-86ce-bdbd42af4336",
    "firmName": "AL BALOOSHI AND AL MARASHDA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-883",
    "licenseIssueDate": "07/31/2013 00:00:00",
    "licenseExpiryDate": "07/30/2026 00:00:00"
  },
  {
    "id": "4bc202ad-2ee2-499d-9af5-e3cf0befcc50",
    "slug": "hassan-reda-ahmed-hassan-almulla",
    "name": "Hassan Reda Ahmed Hassan Almulla",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/08/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hassan Reda Ahmed Hassan Almulla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4bc202ad-2ee2-499d-9af5-e3cf0befcc50",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "835",
    "licenseIssueDate": "10/08/2012 00:00:00",
    "licenseExpiryDate": "10/07/2026 00:00:00"
  },
  {
    "id": "1117f15c-425b-4a1d-bf7f-a14f7c2b3384",
    "slug": "hatem-saeed-salem-khamis-alshamsi",
    "name": "ALMA ATEF",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/05/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hatem Saeed Salem Khamis Alshamsi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1117f15c-425b-4a1d-bf7f-a14f7c2b3384",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1667",
    "licenseIssueDate": "06/15/2022 00:00:00",
    "licenseExpiryDate": "06/14/2026 00:00:00"
  },
  {
    "id": "32ca7094-87cf-4761-be58-e66b3f3e9a4d",
    "slug": "hatim-husain-naser-abdulla-alkhlaifi",
    "name": "HATIM HUSAIN NASER ABDULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBISAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/02/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hatim Husain Naser Abdulla Alkhlaifi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_32ca7094-87cf-4761-be58-e66b3f3e9a4d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1407",
    "licenseIssueDate": "02/10/2020 00:00:00",
    "licenseExpiryDate": "02/09/2026 00:00:00"
  },
  {
    "id": "45ed666d-c2b9-4a8b-a807-e1a1353f45e2",
    "slug": "hawra-moosa-abdulrasool-moosa",
    "name": "HAWRA MOOSA ABDULRASOOL MOOSA AHMAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/01/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hawra Moosa Abdulrasool Moosa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_45ed666d-c2b9-4a8b-a807-e1a1353f45e2",
        "address": "YASIR AL NAQBI ,21 ,48 BURJ ,SOFITEL DOWN  TOWN ,181111 ,Dubai",
        "phone": "97142689949",
        "email": "info@alnaqbipartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "ad71430e-83ee-4cb5-a530-bc58db2618f6",
    "firmName": "ALNAQBI & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-912",
    "licenseIssueDate": "01/29/2014 00:00:00",
    "licenseExpiryDate": "01/27/2026 00:00:00"
  },
  {
    "id": "190c7086-9a61-42f2-9f1e-24dfe467e946",
    "slug": "hayat-mohamed-ibrahim-mohamed-alnaqbi",
    "name": "MOHAMED IBRAHIM MOHAMED ASKAR",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/03/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hayat Mohamed Ibrahim Mohamed Alnaqbi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_190c7086-9a61-42f2-9f1e-24dfe467e946",
        "address": "Eissa Salem ,911 ,ALFATTAN PLAZA ,مقابل مطار دبي، مبنى الوصول 1 ,26141 ,Dubai",
        "phone": "97143484809 / 971502226366",
        "email": "info.admin@eslawyers.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "3b88b4a9-6858-4b28-a99f-b982d1cc2ea7",
    "firmName": "EISA SALEM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1518",
    "licenseIssueDate": "03/14/2021 00:00:00",
    "licenseExpiryDate": "03/13/2026 00:00:00"
  },
  {
    "id": "2cca9274-4723-4ba1-8c8a-de826cf90414",
    "slug": "hayfa-ahmed-abdulla-alaajel-alteneiji",
    "name": "MARIAM AHMED ABAD AL RAHMAN AHMED AL GARMAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Commercial Agency",
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Civil Transactions-Insurance",
      "Civil Transactions-Construction and Contracts for Services",
      "Civil Transactions-Ownership & Title",
      "Commercial Transactions-Commercial Mortgage",
      "Commercial Transactions-Commercial Contracts",
      "Commercial Transactions-Bankruptcy",
      "Commercial Transactions-Commercial Real Estate",
      "Civil Transactions-Residential Real Estate",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Civil Transactions-Tenancy",
      "Commercial Transactions-Unfair competition",
      "Personal Status-Legacies and Inheritance",
      "Commercial Transactions-Commercial Companies",
      "Commercial Transactions-Banking Operations",
      "Civil Transactions-Labor & Workers",
      "Civil Transactions-Sale",
      "Commercial Transactions-Sea and air freight",
      "Commercial Transactions-Consumer protection",
      "Civil Transactions-Compensation",
      "Commercial Transactions-Stock",
      "Criminal Law-Cybercrimes",
      "Commercial Transactions-Intellectual Property (includes trademarks",
      "copy rights",
      "patents)"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/12/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hayfa Ahmed Abdulla Alaajel Alteneiji",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2cca9274-4723-4ba1-8c8a-de826cf90414",
        "address": "Azza Ebrahim Hasan Almulla ,6(602-603) ,Al Shoalla Building (Al Naboodah) ,deira city center ,12871 ,Dubai",
        "phone": "97142950010",
        "email": "dubai-secretary@dralmulla.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "fbf6220f-2608-4caa-895e-d45ae8a259a2",
    "firmName": "KHALED ALMARRI & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1908",
    "licenseIssueDate": "01/12/2024 00:00:00",
    "licenseExpiryDate": "01/11/2026 00:00:00"
  },
  {
    "id": "5be37c16-da9c-4f18-93c6-daec76efd9b2",
    "slug": "haytham-ahmed-saif-naji-alameri",
    "name": "MUNA RASHED SAEED ALQAISHI ALSHEHHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/02/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: HAYTHAM AHMED SAIF NAJI ALAMERI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5be37c16-da9c-4f18-93c6-daec76efd9b2",
        "address": "مكتب رقم 303 ,NAEMA ALI BUAMIM رقم مكاني 2937992197 ,المركز التجاري الماليزي ,000 ,Dubai",
        "phone": "97144475234 / 971547447744",
        "email": "RASHIDALNUIMIEST@GMAIL.COM",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "2c2cba6d-fae5-429a-b197-7434c0a1d19d",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1926",
    "licenseIssueDate": "03/16/2024 00:00:00",
    "licenseExpiryDate": "03/15/2026 00:00:00"
  },
  {
    "id": "7dc035e0-f8da-420d-bd04-1879f6a5cb56",
    "slug": "heba-alaa-el-deen-hassan-mohammed-hassan-maana",
    "name": "HIBA ALLAALDIN HASSAN MOHAMED MAANI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 19,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/11/2005",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-11-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Heba Alaa El Deen Hassan Mohammed Hassan Maana",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7dc035e0-f8da-420d-bd04-1879f6a5cb56",
        "address": "",
        "phone": "97142986558",
        "email": "mak@maklegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "06d1b0e4-10d9-46d5-9f6b-44710029bb65",
    "firmName": "HIBA MAANI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-534",
    "licenseIssueDate": "11/20/2005 00:00:00",
    "licenseExpiryDate": "11/19/2025 00:00:00"
  },
  {
    "id": "57f2b67b-24d4-4174-8f42-46279e143d56",
    "slug": "heba-ali-ghuloom-mohammad-baker-ahli",
    "name": "HEBA ALI GHULOOM MOHAMMAD AHLI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 19,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/04/2006",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: HEBA ALI GHULOOM MOHAMMAD BAKER AHLI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_57f2b67b-24d4-4174-8f42-46279e143d56",
        "address": "",
        "phone": "97143334212",
        "email": "secretary@alimusabbah.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "22d91b55-d8b8-4ccf-be32-aba1f5dea289",
    "firmName": "HEBA AHLI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-563",
    "licenseIssueDate": "04/24/2006 00:00:00",
    "licenseExpiryDate": "04/23/2026 00:00:00"
  },
  {
    "id": "1f0e9d3d-e8de-4672-b802-0b362e12c4ec",
    "slug": "hebah-mohammed-yahya-hasan-hamiko-dado",
    "name": "MEERA ALI KHAMIS ALI AL ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/07/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: HEBAH MOHAMMED YAHYA HASAN HAMIKO DADO",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1f0e9d3d-e8de-4672-b802-0b362e12c4ec",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-2011",
    "licenseIssueDate": "08/01/2024 00:00:00",
    "licenseExpiryDate": "07/31/2026 00:00:00"
  },
  {
    "id": "fdc8cb8f-df2c-4954-bbca-f7c188ef8331",
    "slug": "hend-humaid-abdulla-alshaiba-alnuaimi",
    "name": "MARYAM ABDULWAHAB TALAL ALHERAIBI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBISAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/11/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: HEND HUMAID ABDULLA ALSHAIBA ALNUAIMI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fdc8cb8f-df2c-4954-bbca-f7c188ef8331",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1892",
    "licenseIssueDate": "12/01/2023 00:00:00",
    "licenseExpiryDate": "11/30/2025 00:00:00"
  },
  {
    "id": "d2f90193-d5cf-4190-b28c-ee4908f703bc",
    "slug": "hend-humaid-ali-ghudayer-alktebi",
    "name": "HUMAID ALI GHUDAYER MOHAMMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBISAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 15,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/04/2010",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hend Humaid Ali Ghudayer Alktebi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d2f90193-d5cf-4190-b28c-ee4908f703bc",
        "address": "",
        "phone": "97143968700",
        "email": "admin@haklegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "ee61dd8d-28a2-4c21-9a46-a87635463b13",
    "firmName": "HEND ALKTEBI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-709",
    "licenseIssueDate": "04/21/2010 00:00:00",
    "licenseExpiryDate": "04/20/2026 00:00:00"
  },
  {
    "id": "ef7a121c-ccce-448e-9be1-7916d1e30910",
    "slug": "hend-humaid-khalifa-binhendi-alaleeli",
    "name": "ABDULLA MUSABBEH SAEED ALI ALMAZROOEI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBISAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/06/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: HEND HUMAID KHALIFA BINHENDI ALALEELI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ef7a121c-ccce-448e-9be1-7916d1e30910",
        "address": "Hend Humaid Khalifa Bin Hendi Alaleeli  ,2/201 ,ALMIHIRI BLAZA - Al Khabisi , Hyundai Show ROOM  ,000 ,Dubai",
        "phone": "97143999691 / 971000000000",
        "email": "hend.alaleeli@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "17773ca4-24da-4486-9931-d51188bf4d88",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1983",
    "licenseIssueDate": "06/07/2024 00:00:00",
    "licenseExpiryDate": "06/06/2026 00:00:00"
  },
  {
    "id": "aee0d082-b7e9-4d33-8cec-a93136dea60e",
    "slug": "hend-rashid-abdulmajid-almehairi",
    "name": "MAIDEID MAIDEID MOHAMED DHAEN ALMANSOORI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/07/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hend Rashid Abdulmajid Almehairi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_aee0d082-b7e9-4d33-8cec-a93136dea60e",
        "address": "",
        "phone": "97143641686 / 971506288801",
        "email": "b.kadir@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "0ba96df8-e4cc-49c2-8ae4-a42878d95926",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1686",
    "licenseIssueDate": "08/10/2022 00:00:00",
    "licenseExpiryDate": "08/09/2026 00:00:00"
  },
  {
    "id": "11de518e-6525-4ca2-9e1c-acfa5de9cbc4",
    "slug": "hend-shehab-hamad-khalifa-alhooli",
    "name": "Hend Shehab Hamad Khalifa Alhooli",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/02/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hend Shehab Hamad Khalifa Alhooli",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_11de518e-6525-4ca2-9e1c-acfa5de9cbc4",
        "address": "",
        "phone": "97142507778 / 971506421661",
        "email": "feedback@alshamsilawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "4b400e1b-7731-4a4b-9c37-a77e3c03ab78",
    "firmName": "NASSER AL SHAMSI ADVOCATES & LEGAL CONSULTANT",
    "registrationNumber": "890",
    "licenseIssueDate": "02/02/2023 00:00:00",
    "licenseExpiryDate": "02/01/2026 00:00:00"
  },
  {
    "id": "d20040ed-aaa3-4993-a83a-472392856589",
    "slug": "hesham-khalil-mohammed-almutawa",
    "name": "HESHAM KHALIL MOHD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBISwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/06/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hesham Khalil Mohammed Almutawa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d20040ed-aaa3-4993-a83a-472392856589",
        "address": "Unit No. 509-8,  ,Apricot Tower ,Dubai Silicon Oasis ,262 ,Dubai",
        "phone": "97143685555",
        "email": "info@bsabh.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "9ae2d0ab-41cc-421c-8579-e2f2b211ddf0",
    "firmName": "B S A AHMAD BIN HAZEEM & ASSOCIATES",
    "registrationNumber": "L-1291",
    "licenseIssueDate": "06/04/2018 00:00:00",
    "licenseExpiryDate": "06/03/2026 00:00:00"
  },
  {
    "id": "a235d149-dc1b-4168-8495-327f64be11c4",
    "slug": "hessa-abdulla-ahmed-hasani-alshehhi",
    "name": "ABDULLA AHMAD MOHAMMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/10/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hessa Abdulla Ahmed Hasani Alshehhi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a235d149-dc1b-4168-8495-327f64be11c4",
        "address": "",
        "phone": "97143530018",
        "email": "info@alsuwaidiadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "838d8111-1e4d-43cc-88f7-71f2dcb24635",
    "firmName": "JASSIM AL SUWAIDI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-1579",
    "licenseIssueDate": "10/11/2021 00:00:00",
    "licenseExpiryDate": "10/10/2025 00:00:00"
  },
  {
    "id": "e6eb5a34-29b0-4d97-8692-c1ec702d706e",
    "slug": "hessa-mubarak-thani-bilal-buthani-al-attay",
    "name": "Hessa Mubarak Thani Bilal BuThani Al Attay",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/25/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hessa Mubarak Thani Bilal BuThani Al Attay",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e6eb5a34-29b0-4d97-8692-c1ec702d706e",
        "address": "",
        "phone": "97143688984",
        "email": "legalsolutions@alattay.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "110bcc76-e3fc-40c6-960f-9dfd1ffd5067",
    "firmName": "HESSA ALATTAY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "445",
    "licenseIssueDate": "10/25/2011 00:00:00",
    "licenseExpiryDate": "10/24/2025 00:00:00"
  },
  {
    "id": "cdc24e29-5f7e-4a5d-8fbc-8b45305fa833",
    "slug": "hessa-saif-salem-saif-al-jabri",
    "name": "saif salem saif",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 17,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/04/2008",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: HESSA SAIF SALEM SAIF AL JABRI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cdc24e29-5f7e-4a5d-8fbc-8b45305fa833",
        "address": "201 ,Bou Haliba Building  ,Opposite of Al Bakhit Centre ,181116 ,Dubai",
        "phone": "97142507711",
        "email": "h.aljaberiadvocates@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "ebacdf1e-411d-4d78-a4e2-7b41750d6c08",
    "firmName": "HESSA AL JABERI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-627",
    "licenseIssueDate": "04/06/2008 00:00:00",
    "licenseExpiryDate": "04/05/2026 00:00:00"
  },
  {
    "id": "e7a79a71-7639-46a7-9e74-b0bfefc6ac45",
    "slug": "hessa-salem-ismail-saeed-alhammadi",
    "name": "HESSAH SALEM ISMAIL SAEED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/07/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hessa Salem Ismail Saeed Alhammadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e7a79a71-7639-46a7-9e74-b0bfefc6ac45",
        "address": "",
        "phone": "97143339002 / 971558818724",
        "email": "info@nhalhammadi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "e78d4c87-2450-4a73-af8f-bdea91defa61",
    "firmName": "HESSA ALHAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1207",
    "licenseIssueDate": "07/23/2017 00:00:00",
    "licenseExpiryDate": "07/22/2026 00:00:00"
  },
  {
    "id": "904fc1ac-5f46-4dcd-ba33-2a66770b34bd",
    "slug": "hessah-ali-hassan-ali-almesmari",
    "name": "KHULOOD KHALFAN OBAID ALI ALALEELI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/05/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: hessah ali hassan ali almesmari",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_904fc1ac-5f46-4dcd-ba33-2a66770b34bd",
        "address": "first/105 ,Al Shafar Investment ,noor bank metro station ,34655 ,Dubai",
        "phone": "97143386111",
        "email": "unionadvocates1@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "109f3fc4-62e8-4523-9372-95aaf9a76483",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1955",
    "licenseIssueDate": "05/10/2024 00:00:00",
    "licenseExpiryDate": "05/09/2026 00:00:00"
  },
  {
    "id": "f23f630e-c8d6-46b4-b4ab-057c9b1b2d49",
    "slug": "hessah-humaid-abdulla-alshara-almaazmi",
    "name": "HESSAH HUMAID ABDULLA M AL SHARA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBISAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/09/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: hessah humaid abdulla alshara almaazmi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f23f630e-c8d6-46b4-b4ab-057c9b1b2d49",
        "address": "10 Floor - Office No. 10001 ,Latifa Tower ,Makani No: 9063026848 ,000 ,Dubai",
        "phone": "97142522995 / 971505897795",
        "email": "a.legal.uae@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "432dbfa7-962d-4bbc-a64a-c3185bf78a66",
    "firmName": "HESSA HUMAID AL SHARA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1561",
    "licenseIssueDate": "09/02/2021 00:00:00",
    "licenseExpiryDate": "09/01/2026 00:00:00"
  },
  {
    "id": "67d27c3b-8aa2-4844-b762-a9a8da469aa9",
    "slug": "hessah-saeed-mohamed-alshehhi",
    "name": "HESSAH SAEED W O SALEM R M ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 15,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/07/2010",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: HESSAH SAEED MOHAMED ALSHEHHI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_67d27c3b-8aa2-4844-b762-a9a8da469aa9",
        "address": "HAMAD ABDULLA ABDULRAHMAN ALRAHMA ALHAMMADI ,14TH FLOOR - 1403 ,PARK PLACE TOWER ,WORLD TRADE CENTER ,114295 ,Dubai",
        "phone": "97144227465 / 971555507070",
        "email": "hessa.alshehhi@primecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "d6da9923-01fb-4fd8-a9da-a02d2122dbde",
    "firmName": "HESSAH ALSHEHHI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-719",
    "licenseIssueDate": "07/28/2010 00:00:00",
    "licenseExpiryDate": "07/27/2026 00:00:00"
  },
  {
    "id": "486facc1-a5f5-4198-995f-eff60f0daff8",
    "slug": "hikmat-mahmoud-fayad",
    "name": "HIKMAT MAHMOUD FAYAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Commercial Agency",
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Civil Transactions-Construction and Contracts for Services",
      "Civil Transactions-Ownership & Title",
      "Civil Transactions-HR & Employee Affairs",
      "Personal Status-Custody & Alimony",
      "Commercial Transactions-Commercial Contracts",
      "Commercial Transactions-Bankruptcy",
      "Commercial Transactions-Commercial Real Estate",
      "Civil Transactions-Residential Real Estate",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Civil Transactions-Tenancy",
      "Commercial Transactions-Unfair competition",
      "Personal Status-Legacies and Inheritance",
      "Commercial Transactions-Commercial Companies",
      "Commercial Transactions-Banking Operations",
      "Civil Transactions-Labor & Workers",
      "Criminal Law-Drug Crimes",
      "Civil Transactions-Sale",
      "Personal Status-Marriage & Divorce",
      "Civil Transactions-Compensation",
      "Criminal Law-Crimes against properties",
      "Commercial Transactions-E-Commerce",
      "Commercial Transactions-Intellectual Property (includes trademarks",
      "copy rights",
      "patents)",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 43,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/12/1981",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hikmat Mahmoud Fayad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_486facc1-a5f5-4198-995f-eff60f0daff8",
        "address": "الخامس  ,البرج الأخضر  ,خلف فندق موسكو  ,5630 ,Dubai",
        "phone": "97142222888",
        "email": "fayadlaw@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "216ebf72-e55b-4446-b7a6-5c17ba8c9b5d",
    "firmName": "HIKMAT FAYAD & ASSOCIATES ADVO.& LEG.CONSULTANTS",
    "registrationNumber": "L-97",
    "licenseIssueDate": "12/28/1981 00:00:00",
    "licenseExpiryDate": "12/27/2025 00:00:00"
  },
  {
    "id": "d959bc26-e3f9-4275-a7f6-3b13f52e0024",
    "slug": "hilal-abdalla-ahmed-hilal-alsaadi",
    "name": "HILAL ABDALLA AHMED HILAL ALSAADI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/08/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hilal Abdalla Ahmed Hilal Alsaadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d959bc26-e3f9-4275-a7f6-3b13f52e0024",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-831",
    "licenseIssueDate": "08/29/2012 00:00:00",
    "licenseExpiryDate": "08/28/2026 00:00:00"
  },
  {
    "id": "b9182fd7-ad85-44cf-955d-3d2a702b91e5",
    "slug": "hilal-amur-hamad-saif-alswaei",
    "name": "JAMAL HASSAN ABDO ALNAJAR",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/04/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hilal Amur Hamad saif Alswaei",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b9182fd7-ad85-44cf-955d-3d2a702b91e5",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1795",
    "licenseIssueDate": "05/01/2023 00:00:00",
    "licenseExpiryDate": "04/30/2026 00:00:00"
  },
  {
    "id": "3b77653a-6bc5-413c-bb72-73701562606e",
    "slug": "hind-abdelaziz-shahdad-sulaiman-almaazmi",
    "name": "HIND ABDELAZIZ SHAHDAD SULAIMAN HASSAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/04/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hind Abdelaziz Shahdad Sulaiman Almaazmi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3b77653a-6bc5-413c-bb72-73701562606e",
        "address": "Obaid Ishaq Ismail Al-Maazmi ,الطابق 21 ,ذا اكستشينج تاور  ,فندق جي دبليو ماريوت ماركي ,238365 ,Dubai",
        "phone": "97143584737",
        "email": "obaidotp@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "70a8fb70-2729-4348-b87b-258c7dc7a387",
    "firmName": "OBAID AL MAZIMI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-1167",
    "licenseIssueDate": "04/06/2017 00:00:00",
    "licenseExpiryDate": "04/05/2026 00:00:00"
  },
  {
    "id": "413dfdc7-2e11-4059-b758-d9fd3d8c516e",
    "slug": "hind-ali-saeed-ham-abdulla",
    "name": "HIND ALI SAEED HAM ABDULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 18,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/03/2007",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: HIND ALI SAEED HAM ABDULLA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_413dfdc7-2e11-4059-b758-d9fd3d8c516e",
        "address": "",
        "phone": "97143212555",
        "email": "awigdubai@awiglaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "ece8ea60-9ecb-4d8c-aca3-fb73e4e52406",
    "firmName": "AL WASL INTERNATIONAL GROUP - ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-598",
    "licenseIssueDate": "03/06/2007 00:00:00",
    "licenseExpiryDate": "03/05/2026 00:00:00"
  },
  {
    "id": "8b193aee-2b64-433a-b712-3ebd5eba2193",
    "slug": "hind-mohamed-humaid-abdalla-alowais-alshamsi",
    "name": "HIND MOHAMED HUMAID ALOWAIS ALSHAMSI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/12/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hind Mohamed Humaid Abdalla Alowais Alshamsi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8b193aee-2b64-433a-b712-3ebd5eba2193",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1244",
    "licenseIssueDate": "12/21/2017 00:00:00",
    "licenseExpiryDate": "12/20/2025 00:00:00"
  },
  {
    "id": "427f174a-b9fd-4195-9270-56be6cde8f2d",
    "slug": "hind-salem-hassan-alshehhi",
    "name": "Hind Salem Hassan Alshehhi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/17/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hind Salem Hassan Alshehhi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_427f174a-b9fd-4195-9270-56be6cde8f2d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "1813",
    "licenseIssueDate": "06/17/2023 00:00:00",
    "licenseExpiryDate": "06/16/2026 00:00:00"
  },
  {
    "id": "b5051bda-cf48-4d4c-8a47-d85b77ba9143",
    "slug": "hind-salem-saeed-mohamed-aljaberi",
    "name": "HIND SALEM SAEED MOHAMED ALJABERI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/10/2010",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hind Salem Saeed Mohamed Aljaberi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b5051bda-cf48-4d4c-8a47-d85b77ba9143",
        "address": "الميزانين - مكتب رقم 2  ,جسكوم جراند ريزيدنس  ,خلف المستشفي الكندي  ,12923 ,Dubai",
        "phone": "97142224668",
        "email": "aljabriadvocates@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "f44b772a-3149-4fde-85f7-177a97847c52",
    "firmName": "AL JABRI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-730",
    "licenseIssueDate": "10/17/2010 00:00:00",
    "licenseExpiryDate": "10/16/2026 00:00:00"
  },
  {
    "id": "89cb353b-047f-4702-9c55-0d64357ad186",
    "slug": "hoyam-younis-zainal-hussain-ali",
    "name": "HOYAM YOUNIS ZAINAL HUSSAIN ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/04/2009",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hoyam Younis Zainal Hussain Ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_89cb353b-047f-4702-9c55-0d64357ad186",
        "address": "",
        "phone": "97143116556 / 971000000000",
        "email": "info@hazlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "d34586c5-1e0a-4290-af29-23366d37b852",
    "firmName": "HOYAM ALZAROUNI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-662",
    "licenseIssueDate": "04/16/2009 00:00:00",
    "licenseExpiryDate": "04/15/2026 00:00:00"
  },
  {
    "id": "27d30d28-3e55-45b1-81fc-8df309cdbb43",
    "slug": "huda-ahmed-alshikh-nassar-ibrahim-alshmmari",
    "name": "HUDA AHMED ALSHAIKHNASSAR I ALSHIMMARI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/10/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Huda Ahmed Alshikh Nassar Ibrahim Alshmmari",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_27d30d28-3e55-45b1-81fc-8df309cdbb43",
        "address": "1007 ,برج لطيفة ,بجوار فندق كراون بلازل ,94873 ,Abu Dhabi",
        "phone": "97142951555 / 971567573911",
        "email": "info@mbhadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "2d3e210f-8234-4e00-b9e6-1167758a43ee",
    "firmName": "MOHAMMED BANI HASHEM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1173",
    "licenseIssueDate": "04/18/2017 00:00:00",
    "licenseExpiryDate": "10/21/2025 00:00:00"
  },
  {
    "id": "aed3747a-e66f-46a4-94bf-d9368fb8753f",
    "slug": "huda-essa-jan-ali-bin-ali-redha",
    "name": "Huda Essa Jan Ali Bin Ali Redha",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/29/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2023-05-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Huda Essa Jan Ali Bin Ali Redha",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_aed3747a-e66f-46a4-94bf-d9368fb8753f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "1086",
    "licenseIssueDate": "05/29/2016 00:00:00",
    "licenseExpiryDate": "05/28/2023 00:00:00"
  },
  {
    "id": "e54e8f5b-d01e-4a24-8fee-9e9e2caadb07",
    "slug": "huda-hasan-yousef-mohamed",
    "name": "Huda Hasan Yousef mohamed",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBISAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/24/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Huda Hasan Yousef mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e54e8f5b-d01e-4a24-8fee-9e9e2caadb07",
        "address": "",
        "phone": "97142551142 / 971502226062",
        "email": "Huda@halhammadi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "ad6144aa-8e59-43ea-9119-f2856d122685",
    "firmName": "HUDA ALHAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "1656",
    "licenseIssueDate": "05/24/2022 00:00:00",
    "licenseExpiryDate": "05/23/2026 00:00:00"
  },
  {
    "id": "a8e5ee76-8275-4228-abd5-993ce0a5a667",
    "slug": "huda-ibraim-ibrahim-mustafa-alhammadi",
    "name": "AHMAD ABDALLAH MUSSA MURAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBISQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Commercial Companies"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/01/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: HUDA IBRAIM IBRAHIM MUSTAFA ALHAMMADI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a8e5ee76-8275-4228-abd5-993ce0a5a667",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1745",
    "licenseIssueDate": "01/18/2023 00:00:00",
    "licenseExpiryDate": "01/17/2026 00:00:00"
  },
  {
    "id": "7c7e7ac9-3629-4a23-b135-e682ec6656ca",
    "slug": "huda-mohamed-ali-juma-almaazmi",
    "name": "HUDA MOHAMED ALI JUMA ALMAAZMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/01/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Huda Mohamed Ali Juma Almaazmi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7c7e7ac9-3629-4a23-b135-e682ec6656ca",
        "address": "الطابق الحادي عشر ,بناية الحواي ,متحف المستقبل ,183335 ,Dubai",
        "phone": "97142888874 / 971551740400",
        "email": "h.almazmi89@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "a1cee907-ce7d-484b-a20d-16cb79cd6c04",
    "firmName": "HUDA ALMAAZMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1251",
    "licenseIssueDate": "02/01/2018 00:00:00",
    "licenseExpiryDate": "01/31/2026 00:00:00"
  },
  {
    "id": "54ac5bdc-b62f-4a93-a95b-0d4ce5533c07",
    "slug": "huda-rostom-ibrahim-ahmad",
    "name": "HUDA ROSTOM IBRAHIM AHMAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Commercial Agency",
      "Proceedings-Cases and Proceedings before Dubai International Financial Centre",
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Civil Transactions-POA & Sponsorship",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Civil Transactions-Insurance",
      "Civil Transactions-Construction and Contracts for Services",
      "Civil Transactions-Ownership & Title",
      "Civil Transactions-HR & Employee Affairs",
      "Commercial Transactions-Commercial Mortgage",
      "Criminal Law-Family Crimes",
      "Commercial Transactions-Commercial Contracts",
      "Civil Transactions-Immigration and Residency",
      "Commercial Transactions-Bankruptcy",
      "Commercial Transactions-Commercial Real Estate",
      "Civil Transactions-Residential Real Estate",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Civil Transactions-Arbitration",
      "Criminal Law-Hate crimes",
      "Civil Transactions-Tenancy",
      "Commercial Transactions-Unfair competition",
      "Criminal Law-Crimes against persons",
      "Personal Status-Legacies and Inheritance",
      "Commercial Transactions-Commercial Companies",
      "Commercial Transactions-Banking Operations",
      "Civil Transactions-Labor & Workers",
      "Civil Transactions-Sale",
      "Commercial Transactions-Sea and air freight",
      "Commercial Transactions-Consumer protection",
      "Civil Transactions-Compensation",
      "Commercial Transactions-Stock",
      "Criminal Law-Crimes against properties",
      "Criminal Law-Cybercrimes",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/02/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Huda Rostom Ibrahim Ahmad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_54ac5bdc-b62f-4a93-a95b-0d4ce5533c07",
        "address": "",
        "phone": "97142251011",
        "email": "info@ajlc.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "aa38fc5e-9318-46e5-aaeb-e64f98419097",
    "firmName": "ABDULHAMEED ALJASMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-853",
    "licenseIssueDate": "02/04/2013 00:00:00",
    "licenseExpiryDate": "02/03/2026 00:00:00"
  },
  {
    "id": "0db73ada-0fa2-49e6-a453-d2d75a84df28",
    "slug": "huda-salem-awad-mohammed-alblooshi",
    "name": "HUDA SALEM AWAD MOHAMMED ALBLOOSHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/08/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: HUDA SALEM AWAD MOHAMMED ALBLOOSHI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0db73ada-0fa2-49e6-a453-d2d75a84df28",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1555",
    "licenseIssueDate": "08/18/2021 00:00:00",
    "licenseExpiryDate": "08/17/2026 00:00:00"
  },
  {
    "id": "8357ddb7-8662-46aa-81d0-5f7f53bcec46",
    "slug": "huda-yaqoob-darwish-johar-marzooq",
    "name": "HUDA YAQOOB DARWISH JOHAR",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/10/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Huda Yaqoob Darwish Johar Marzooq",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8357ddb7-8662-46aa-81d0-5f7f53bcec46",
        "address": "",
        "phone": "97145293307",
        "email": "info@hyadvocate.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "0d19b22a-0678-43d9-ae17-061958b88e0e",
    "firmName": "HUDA YAQOOB ADVOCATES &LEGAL CONSULTANTS",
    "registrationNumber": "L-1232",
    "licenseIssueDate": "10/30/2017 00:00:00",
    "licenseExpiryDate": "10/29/2025 00:00:00"
  },
  {
    "id": "d64501de-f8bc-4bb7-92cf-923beb3c427a",
    "slug": "humaid-ali-ghulam-abbas-ashkanani",
    "name": "MOHAMED ALI MOHAMED HUSSAIN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Civil Transactions-Ownership & Title",
      "Commercial Transactions-Banking Operations",
      "Criminal Law-Drug Crimes",
      "Personal Status-Marriage & Divorce",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/08/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Humaid Ali Ghulam Abbas Ashkanani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d64501de-f8bc-4bb7-92cf-923beb3c427a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1692",
    "licenseIssueDate": "08/23/2022 00:00:00",
    "licenseExpiryDate": "08/22/2026 00:00:00"
  },
  {
    "id": "f73517d9-4f14-4a4d-9994-eaa6caa8f403",
    "slug": "humaid-ali-mohammed-hussain-almaazmi",
    "name": "HUMAID ALI MOHAMED HUSSAIN ALMAAZMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-02-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Humaid Ali Mohammed Hussain AlMaazmi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f73517d9-4f14-4a4d-9994-eaa6caa8f403",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1510",
    "licenseIssueDate": "02/28/2021 00:00:00",
    "licenseExpiryDate": "02/27/2027 00:00:00"
  },
  {
    "id": "b5924cf5-d1f4-43cb-85b9-8537c6d31596",
    "slug": "humaid-ghulam-darwish-ibrahim",
    "name": "HUMAID GHULAM DARWISH IBRAHIM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 19,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/04/2006",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Humaid Ghulam Darwish Ibrahim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b5924cf5-d1f4-43cb-85b9-8537c6d31596",
        "address": "",
        "phone": "97143324114",
        "email": "humaidhd@eim.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "bcfc630f-83fd-48e1-88ff-51688a450f17",
    "firmName": "HUMAID DARWISH ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-552",
    "licenseIssueDate": "04/24/2006 00:00:00",
    "licenseExpiryDate": "04/23/2026 00:00:00"
  },
  {
    "id": "1ed8c404-20a3-42eb-bc6a-6513702c7a06",
    "slug": "humaid-mohammed-redha-alansari",
    "name": "HUMAID MOHAMED REDHA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/05/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Humaid Mohammed Redha Alansari",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1ed8c404-20a3-42eb-bc6a-6513702c7a06",
        "address": "",
        "phone": "97143585135 / 971503564426",
        "email": "info@alansarilaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "42521deb-a4c5-41c9-989c-c10b046f34b5",
    "firmName": "HUMAID ALANSARI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1285",
    "licenseIssueDate": "05/23/2018 00:00:00",
    "licenseExpiryDate": "05/22/2026 00:00:00"
  },
  {
    "id": "a3e3a731-1dac-49b6-9f66-70bc3957d12f",
    "slug": "humaid-mubarak-yaqout-mubarak-aleghfeli",
    "name": "HUMAID MUBARAK YAQOUT MUBARAK ALGHFELI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/03/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Humaid Mubarak Yaqout Mubarak Aleghfeli",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a3e3a731-1dac-49b6-9f66-70bc3957d12f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-995",
    "licenseIssueDate": "03/05/2015 00:00:00",
    "licenseExpiryDate": "03/04/2026 00:00:00"
  },
  {
    "id": "69ece7d3-f1a2-43b4-9ff7-e194f4cf804e",
    "slug": "humaid-yousuf-rubaya-ali",
    "name": "HUMAID YOUSSEF RABIE ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/05/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Humaid Yousuf Rubaya Ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_69ece7d3-f1a2-43b4-9ff7-e194f4cf804e",
        "address": "M19 ,بناية مركز القرهود للأعمال ,مستشفى القرهود التخصصي  ,445499 ,Dubai",
        "phone": "97142999949",
        "email": "info@hsadvo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "e07b0a55-9fe6-457d-a9ff-a1dada995416",
    "firmName": "HUMAID YOUSUF ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-952",
    "licenseIssueDate": "05/18/2014 00:00:00",
    "licenseExpiryDate": "05/17/2026 00:00:00"
  },
  {
    "id": "cfe82964-362d-41fd-9e5f-272ebe369898",
    "slug": "hureyya-matar-jumah-rashed-alqaydi",
    "name": "ADEL HUSAIN FALOOH BADAR AL RABEEA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/10/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hureyya Matar Jumah Rashed Alqaydi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cfe82964-362d-41fd-9e5f-272ebe369898",
        "address": "O-4801, O-4901 ,Burj al Salam Office Tower ,H Hotel ,111801 ,Dubai",
        "phone": "97143544444",
        "email": "administration@horizlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "4e25fb39-6659-44f0-bc8b-3ff0f067beb0",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1880",
    "licenseIssueDate": "11/02/2023 00:00:00",
    "licenseExpiryDate": "11/01/2025 00:00:00"
  },
  {
    "id": "73c858e6-5bfe-4551-b71b-4e7960b07f03",
    "slug": "husain-ali-mohamed-hasan-albeshr",
    "name": "AMNA RASHEED AHMED RASHEED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/12/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Husain Ali Mohamed Hasan Albeshr",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_73c858e6-5bfe-4551-b71b-4e7960b07f03",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1736",
    "licenseIssueDate": "01/06/2023 00:00:00",
    "licenseExpiryDate": "01/05/2026 00:00:00"
  },
  {
    "id": "faf3f1a4-c88a-4e2a-bb10-fc33d7f8976a",
    "slug": "husain-hasan-mohamed-al-ali",
    "name": "HUSAIN HASAN MOHAMED ALALI AL-ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBISAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/08/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Husain Hasan Mohamed Al Ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_faf3f1a4-c88a-4e2a-bb10-fc33d7f8976a",
        "address": "Fourth Floor - Office No. 411 ,Oud Metha Office Building ,Makani No: 3093891125 ,49909 ,Dubai",
        "phone": "97100000000 / 971507559971",
        "email": "husain.alali@alaliadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "79eb0fc3-cc12-46e8-a1fe-a548453d5278",
    "firmName": "HUSAIN HASAN MOHAMED AL ALI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1446",
    "licenseIssueDate": "08/11/2020 00:00:00",
    "licenseExpiryDate": "08/11/2026 00:00:00"
  },
  {
    "id": "72006147-9167-4145-a397-c3474cecb4fe",
    "slug": "hussa-ali-mohamed-haji-alqubaisi",
    "name": "HUSSA ALI MOHAMED HAJI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/11/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-11-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hussa Ali Mohamed Haji Alqubaisi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_72006147-9167-4145-a397-c3474cecb4fe",
        "address": "HUSSA ALI ALQUBAISI ,FLOOR 31 OFFICE 3103 ,BURLINGTON TOWER ,DUBAI ISLAMIC BANK ,15002 ,Dubai",
        "phone": "97142427805",
        "email": "info@haqlegalconsultants.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "1d48c777-9533-4c84-8e5b-5abde5f50dab",
    "firmName": "HUSSA ALI ALQUBAISI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1129",
    "licenseIssueDate": "11/29/2016 00:00:00",
    "licenseExpiryDate": "11/28/2025 00:00:00"
  },
  {
    "id": "b44e4357-bded-412c-a8a9-17cf906baa0b",
    "slug": "hussain-abdulla-saleh-ahmad-binrasheed",
    "name": "HUSSAIN ABDULLA SALEH AHMAD BIN RASHEED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/05/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hussain Abdulla Saleh Ahmad Binrasheed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b44e4357-bded-412c-a8a9-17cf906baa0b",
        "address": "الطابق الخامس ,الساحة ,سوق البحار ,26011 ,Dubai",
        "phone": "97142277717",
        "email": "info@alsahlawico.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "a6811a79-5470-4c33-ad95-3ff8f661c052",
    "firmName": "AL SAHLAWI & CO ADVOCATES & CONSULTANTS",
    "registrationNumber": "L-1359",
    "licenseIssueDate": "05/07/2019 00:00:00",
    "licenseExpiryDate": "05/06/2026 00:00:00"
  },
  {
    "id": "9025ec80-a8fc-4475-b6bf-f5a8b2ba0f49",
    "slug": "hussain-abdulqader-abdulla-alemadi",
    "name": "ALI MOHAMMAD AHMAD MAHMOOD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/07/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: hussain abdulqader abdulla alemadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9025ec80-a8fc-4475-b6bf-f5a8b2ba0f49",
        "address": "",
        "phone": "97142945678",
        "email": "maadvdubai@maadv.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "85fc2f18-8a0a-4682-9735-2be49a8b75f9",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1685",
    "licenseIssueDate": "08/10/2022 00:00:00",
    "licenseExpiryDate": "08/09/2026 00:00:00"
  },
  {
    "id": "a4c7be46-840a-47e0-af02-17e34ef49c40",
    "slug": "hussain-ali-abdulrahman-lootah",
    "name": "Hussain Ali Abdulrahman Lootah",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 29,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/02/1996 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hussain Ali Abdulrahman Lootah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a4c7be46-840a-47e0-af02-17e34ef49c40",
        "address": "الطابق الثامن  ,برج الجرج 1 ,دائرة الاراضي و الاملاك  ,9117 ,Dubai",
        "phone": "97143320004",
        "email": "info@hlootahlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "4ad67cb4-18b4-4417-9b6a-d23a9fb368fb",
    "firmName": "HUSSAIN LOOTAH & PARTNERS - ATTORNEYS & COUNS",
    "registrationNumber": "167",
    "licenseIssueDate": "07/02/1996 00:00:00",
    "licenseExpiryDate": "07/01/2026 00:00:00"
  },
  {
    "id": "1a7163ce-6c00-4e50-9b2e-d98e3e4a20cb",
    "slug": "hussain-ali-hasan-ali-al-bannai",
    "name": "HUSSAIN ALI HASSAN ALBANNAI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 24,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/02/2001",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hussain Ali Hasan Ali Al-Bannai",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1a7163ce-6c00-4e50-9b2e-d98e3e4a20cb",
        "address": "",
        "phone": "97142946164",
        "email": "info@albannai-law.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "73525ec0-5573-4652-8fd8-c2ef0f19b399",
    "firmName": "ALBANNAI & CO.",
    "registrationNumber": "L-396",
    "licenseIssueDate": "02/27/2001 00:00:00",
    "licenseExpiryDate": "02/26/2026 00:00:00"
  },
  {
    "id": "619738cb-c71e-432b-88dd-f12f1c1eee80",
    "slug": "hussain-ali-hussain-al-jaziri",
    "name": "HUSSAIN ALI HUSSAIN ALJAZIRI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 42,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/02/1983",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-02-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hussain Ali Hussain Al-Jaziri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_619738cb-c71e-432b-88dd-f12f1c1eee80",
        "address": "Hussain Ali Al Jaziri ,11 ,City Tower 2 ,Crown Plaza hotel Sheikh Zayed Road ,4253 ,Dubai",
        "phone": "97142626777 / 971529087670",
        "email": "courts@jaflaws.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "c58d8654-b428-46b3-abd5-024e4331ee53",
    "firmName": "JAAFAR ALWAN & AL JAZIRI & ASSOCIATES",
    "registrationNumber": "L-120",
    "licenseIssueDate": "02/06/1983 00:00:00",
    "licenseExpiryDate": "02/05/2026 00:00:00"
  },
  {
    "id": "a08babca-5cc1-4fe2-9e6a-7f1c36fdc3a3",
    "slug": "hussain-ali-naseer-alharthi",
    "name": "ABDULLA AHMAD ABDULLA MOHAMMAD AHLI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/04/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: HUSSAIN ALI NASEER ALHARTHI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a08babca-5cc1-4fe2-9e6a-7f1c36fdc3a3",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1951",
    "licenseIssueDate": "05/06/2024 00:00:00",
    "licenseExpiryDate": "05/05/2026 00:00:00"
  },
  {
    "id": "62b5bcad-9bd5-4636-8edb-e5cb47da5b9b",
    "slug": "hussain-mirza-ahmed-abdalla-almahdi",
    "name": "HUSSAIN MIRZA AHMED ABDALLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/04/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hussain Mirza Ahmed Abdalla Almahdi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_62b5bcad-9bd5-4636-8edb-e5cb47da5b9b",
        "address": "Office No. 1310 ,Saheel 2 Building ,Al Nahda 1 – Saheel 2 Building ,00 ,Dubai",
        "phone": "97145856322",
        "email": "husain.almahdi@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "e1228738-be5a-4b34-8ced-b04d430944d0",
    "firmName": "HUSSAIN MIRZA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1524",
    "licenseIssueDate": "04/18/2021 00:00:00",
    "licenseExpiryDate": "04/17/2026 00:00:00"
  },
  {
    "id": "a5206e00-a9f5-4e68-bd9b-049eeed73521",
    "slug": "hussain-mohamed-hasan-hatem",
    "name": "HUSSAIN MOHAMED HASAN HATEM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/01/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hussain Mohamed Hasan Hatem",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a5206e00-a9f5-4e68-bd9b-049eeed73521",
        "address": "Hussain Mohamed AL Hosani ,Office 314 ,Bussnis Avenue ,AL Roustomani ,7094 ,Dubai",
        "phone": "97143322338 / 971568842488",
        "email": "info@hmalegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "8127d958-05bb-47c2-bae1-2d1548de2cf3",
    "firmName": "HUSSAIN MOHAMED ALHOSANI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-1046",
    "licenseIssueDate": "10/20/2015 00:00:00",
    "licenseExpiryDate": "10/19/2025 00:00:00"
  },
  {
    "id": "6b93bd91-cca6-4647-b40b-3afee710b0ad",
    "slug": "hussain-mohammed-hassan-aljahazi",
    "name": "HUSSAIN MOHAMMAD HASSAN ALJAHAZI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/01/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Hussain Mohammed Hassan Aljahazi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6b93bd91-cca6-4647-b40b-3afee710b0ad",
        "address": "",
        "phone": "97142678800 / 971050646353",
        "email": "info@hussainaljahazilawyer.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "9ac6b6e4-eb41-48d4-9dfa-407f711a64ad",
    "firmName": "HUSSAIN ALJAHAZI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-1492",
    "licenseIssueDate": "01/06/2021 00:00:00",
    "licenseExpiryDate": "01/05/2026 00:00:00"
  },
  {
    "id": "5f97e431-3d55-45df-9aff-118a160cdb1b",
    "slug": "ibrahim-abdulrazzaq-ibrahim-al-tamimi",
    "name": "IBRAHIM ABDUL RAZZAQ IBRAHIM ALTAMIMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 32,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/02/1993",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ibrahim Abdulrazzaq Ibrahim Al-Tamimi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5f97e431-3d55-45df-9aff-118a160cdb1b",
        "address": "TWENTY ,ALMASRAF TOWER ,DUBAI MUNICIPALITY ,3858 ,Dubai",
        "phone": "97142222314",
        "email": "apxjuris@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "f8f827cb-389c-48f1-841e-a39afdd09f7d",
    "firmName": "APEX JURIS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-252",
    "licenseIssueDate": "02/10/1993 00:00:00",
    "licenseExpiryDate": "02/09/2026 00:00:00"
  },
  {
    "id": "e6da9e75-6504-43db-a21e-47861a83b8ec",
    "slug": "ibrahim-ali-ibrahim-ali-alserkal",
    "name": "KHALID SOWAIKET MOHD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/07/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ibrahim Ali Ibrahim Ali AlSerkal",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e6da9e75-6504-43db-a21e-47861a83b8ec",
        "address": "15th Floor _ Office No. 1504 ,SOBHA SAPPHIRE ,Makani No: 2612485764 ,000 ,Dubai",
        "phone": "97145570789 / 971521800001",
        "email": "Info@iserkal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "196bb7bb-4be6-4029-9367-c100bd219d3f",
    "firmName": "JUMA KHALIFA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-2010",
    "licenseIssueDate": "07/29/2024 00:00:00",
    "licenseExpiryDate": "07/28/2026 00:00:00"
  },
  {
    "id": "dd9b0b14-22fe-4acc-b6b6-84e1e420306c",
    "slug": "ibrahim-ali-karam-mohammed-alkhoori",
    "name": "IBRAHIM ALI KARAM MOHAMMED KHOURI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Personal Status-Custody & Alimony",
      "Commercial Transactions-Commercial Companies",
      "Civil Transactions-Compensation",
      "Criminal Law-Cybercrimes"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/07/2009",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: IBRAHIM ALI KARAM MOHAMMED ALKHOORI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dd9b0b14-22fe-4acc-b6b6-84e1e420306c",
        "address": "",
        "phone": "97143266677 / 971506234989",
        "email": "md@khourilawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "7f366bee-e90b-4c77-b535-ccd366935872",
    "firmName": "IBRAHIM KHOURI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-672",
    "licenseIssueDate": "07/08/2009 00:00:00",
    "licenseExpiryDate": "07/07/2026 00:00:00"
  },
  {
    "id": "01e877cb-0ee1-4278-b305-096529635af9",
    "slug": "ibrahim-hasan-salem-ali-alhmmadi",
    "name": "NOUF ABILFADHEL MOHD QASEM BAIDARY AMCHE",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/03/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ibrahim Hasan Salem Ali Alhmmadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_01e877cb-0ee1-4278-b305-096529635af9",
        "address": "",
        "phone": "97143334404",
        "email": "info@ihadvo.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "da36558c-bfcb-4fbf-8416-f80643ccb280",
    "firmName": "NOUF QASEM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1637",
    "licenseIssueDate": "03/28/2022 00:00:00",
    "licenseExpiryDate": "03/27/2026 00:00:00"
  },
  {
    "id": "f8b86dcb-6c90-49aa-91d7-7c36dec038bd",
    "slug": "ibrahim-hassan-ibrahim-al-mulla",
    "name": "EBRAHIM HASAN EBRAHIM ALMULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 30,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/02/1995",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-02-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ibrahim Hassan Ibrahim Al-Mulla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f8b86dcb-6c90-49aa-91d7-7c36dec038bd",
        "address": "Azza Ebrahim Hasan Almulla ,6(602-603) ,Al Shoalla Building (Al Naboodah) ,deira city center ,12871 ,Dubai",
        "phone": "97142950010",
        "email": "dubai-secretary@dralmulla.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "fbf6220f-2608-4caa-895e-d45ae8a259a2",
    "firmName": "AZZA IBRAHIM HASSAN AL MULLA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-267",
    "licenseIssueDate": "02/27/1995 00:00:00",
    "licenseExpiryDate": "02/26/2026 00:00:00"
  },
  {
    "id": "f00935a3-0fc1-4cdb-a3b1-fcdfc25f086d",
    "slug": "ibrahim-helal-obaid-salem-alneyadi",
    "name": "IBRAHIM HELAL OBAID SALEM ALNEYADI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/07/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ibrahim Helal Obaid Salem Alneyadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f00935a3-0fc1-4cdb-a3b1-fcdfc25f086d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1201",
    "licenseIssueDate": "07/12/2017 00:00:00",
    "licenseExpiryDate": "07/11/2026 00:00:00"
  },
  {
    "id": "378ec1c5-9099-4ff9-9d64-e984eec5fd86",
    "slug": "ibrahim-mahmoud-ibrahim-al-hawai-alzarooni",
    "name": "HEBAH MOHAMMED YAHYA HASAN HAMIKO DADO",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/08/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: IBRAHIM MAHMOUD IBRAHIM AL HAWAI ALZAROONI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_378ec1c5-9099-4ff9-9d64-e984eec5fd86",
        "address": "",
        "phone": "97142868681",
        "email": "hawailaw@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "3f1d962a-159f-4d0f-82d0-ebd94930d6ae",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-2017",
    "licenseIssueDate": "08/29/2024 00:00:00",
    "licenseExpiryDate": "08/28/2026 00:00:00"
  },
  {
    "id": "64c3e724-ae79-4497-bd2d-51b66fef33ff",
    "slug": "ibrahim-mohamed-ali-haddad",
    "name": "IBRAHIM MOHAMED ALI HADDAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/05/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ibrahim Mohamed Ali Haddad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_64c3e724-ae79-4497-bd2d-51b66fef33ff",
        "address": "IBRAHIM ,الاول 107 ,مبني العويس المطار ,بنايه بيزنس افينو ,41334 ,Dubai",
        "phone": "97142566888",
        "email": "info@ihadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "20341bc8-5500-4b12-a88b-d8341d03d88c",
    "firmName": "IBRAHIM HADDAD ADVOCATES AND LEGAL CONSULTANCY",
    "registrationNumber": "L-809",
    "licenseIssueDate": "05/08/2012 00:00:00",
    "licenseExpiryDate": "05/07/2026 00:00:00"
  },
  {
    "id": "24633377-6aa3-482c-8f52-a54bb9c899ef",
    "slug": "ibrahim-mohamed-hassan-khalifa-al-hosani",
    "name": "IBRAHIM MOHAMED HASSAN KHALIFA ALHOSANI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/05/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ibrahim Mohamed Hassan Khalifa Al Hosani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_24633377-6aa3-482c-8f52-a54bb9c899ef",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-942",
    "licenseIssueDate": "05/04/2014 00:00:00",
    "licenseExpiryDate": "05/03/2026 00:00:00"
  },
  {
    "id": "97b003e7-914b-40ae-8197-e6c986efa103",
    "slug": "ibrahim-mohammad-ibrahim-abdulla-albanna",
    "name": "IBRAHIM MOHAMMAD IBRAHIM ABDULLA ALBANNA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ibrahim Mohammad Ibrahim Abdulla Albanna",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_97b003e7-914b-40ae-8197-e6c986efa103",
        "address": "الطابق الرابع ,الصقر للاعمال ,محطة مترو ابراج الامارات  ,67476 ,Dubai",
        "phone": "97143444210",
        "email": "assistant@albannaadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "e3ffafe9-0f0c-4d88-a976-2bdfd7d18411",
    "firmName": "IBRAHIM ALBANNA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-792",
    "licenseIssueDate": "02/19/2012 00:00:00",
    "licenseExpiryDate": "02/18/2026 00:00:00"
  },
  {
    "id": "c5da1231-dd3a-4141-878a-ca4bc243880e",
    "slug": "ibtesam-abdulla-salem-addas-aljaberi",
    "name": "AMAL AHMAD RASHED TAHER",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/03/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ibtesam Abdulla Salem Addas Aljaberi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c5da1231-dd3a-4141-878a-ca4bc243880e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1929",
    "licenseIssueDate": "03/21/2024 00:00:00",
    "licenseExpiryDate": "03/20/2026 00:00:00"
  },
  {
    "id": "4ffd86b0-6db4-46a7-83dc-b8ab5fae441c",
    "slug": "ibtsam-jaffar-ali-ghuloom",
    "name": "IBTESAM JAFFAR ALI GHULOOM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/02/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-02-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ibtsam Jaffar Ali Ghuloom",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4ffd86b0-6db4-46a7-83dc-b8ab5fae441c",
        "address": "",
        "phone": "97143937700",
        "email": "info@galadarilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "d863b662-c864-4193-8b3a-ff6ee5fe6c64",
    "firmName": "GALADARI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1509",
    "licenseIssueDate": "02/27/2021 00:00:00",
    "licenseExpiryDate": "02/26/2026 00:00:00"
  },
  {
    "id": "2359f9f7-a61e-46ae-846d-28d5062a5f41",
    "slug": "insijam-alsayed-ahmed-mohammed-al-ahdaily-almsably",
    "name": "INSIJAM A AHMED MOHAMMED A ALMSABLY",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/06/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Insijam Alsayed Ahmed Mohammed Al Ahdaily Almsably",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2359f9f7-a61e-46ae-846d-28d5062a5f41",
        "address": "",
        "phone": "97143528887",
        "email": "info@kashwanilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "01ccf3a9-cfd3-4fb5-b5ac-a912503c2630",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1013",
    "licenseIssueDate": "06/17/2015 00:00:00",
    "licenseExpiryDate": "06/16/2026 00:00:00"
  },
  {
    "id": "bc958878-6af4-40bc-a91d-39ec56e56652",
    "slug": "intisar-salem-hasan-alhmood",
    "name": "INTISAR SALEM HASAN ALHMOOD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/10/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Intisar Salem Hasan Alhmood",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bc958878-6af4-40bc-a91d-39ec56e56652",
        "address": "Hussain Mohamed AL Hosani ,Office 314 ,Bussnis Avenue ,AL Roustomani ,7094 ,Dubai",
        "phone": "97143322338 / 971568842488",
        "email": "info@hmalegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "8127d958-05bb-47c2-bae1-2d1548de2cf3",
    "firmName": "HUSSAIN MOHAMED ALHOSANI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-1589",
    "licenseIssueDate": "11/01/2021 00:00:00",
    "licenseExpiryDate": "10/31/2025 00:00:00"
  },
  {
    "id": "07d5d16c-8239-4601-af3b-512c3e58913e",
    "slug": "ismaeil-humaid-ismaeil-alherdah-alzaabi",
    "name": "ISMAEIL HUMAID ISMAEIL ALHERDAH ALZAABI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/24/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ISMAEIL HUMAID ISMAEIL ALHERDAH ALZAABI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_07d5d16c-8239-4601-af3b-512c3e58913e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "1818",
    "licenseIssueDate": "06/24/2023 00:00:00",
    "licenseExpiryDate": "06/23/2026 00:00:00"
  },
  {
    "id": "2d2f74f1-53b1-4de4-82b5-3bbd5854fe92",
    "slug": "ismail-hassan-ali-mohammad-al-jaabi",
    "name": "ISMAIL HASSAN ALI MOHAMMAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 15,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/01/2010",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ismail Hassan Ali Mohammad Al Jaabi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2d2f74f1-53b1-4de4-82b5-3bbd5854fe92",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-694",
    "licenseIssueDate": "01/10/2010 00:00:00",
    "licenseExpiryDate": "01/09/2026 00:00:00"
  },
  {
    "id": "ae6faa9e-3c48-4852-923b-59e26469ea5d",
    "slug": "ismail-hassan-ibrahim-al-saffar",
    "name": "Ismail Hassan Ibrahim Al-Saffar",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 29,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/10/1996 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ismail Hassan Ibrahim Al-Saffar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ae6faa9e-3c48-4852-923b-59e26469ea5d",
        "address": "ISMAIL HASSAN EBRAHIM ALSAFFAR ,الطابق الثامن - مكتب 801 AFR ,الصقر للاعمال ,يوجد اسفل البناية مطعم وينديز ,25752 ,Dubai",
        "phone": "97143276805",
        "email": "info@alsaffar-legal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "ceb9cbcf-79f3-462d-afe2-aa4c62eff72b",
    "firmName": "ISMAIL ALSAFFAR ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "199",
    "licenseIssueDate": "07/10/1996 00:00:00",
    "licenseExpiryDate": "07/09/2026 00:00:00"
  },
  {
    "id": "652b9819-c1a8-4e31-bc57-554f12a09413",
    "slug": "ismail-ibrahim-saqer-ibrahim-al-hosani",
    "name": "NOURA TAYSSER MOHAMAD NASIB CHAMAMIT",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/02/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ISMAIL IBRAHIM SAQER IBRAHIM AL-HOSANI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_652b9819-c1a8-4e31-bc57-554f12a09413",
        "address": "ISMAIL IBRAHIM ALHOSANI ,الثالث ,القرهود ستار ,سالم لفحص اللياقة ,76113 ,Dubai",
        "phone": "97144498077 / 971508133077",
        "email": "advocateismailalhosani@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "55eb8a12-f67e-4da7-ba9f-a908826c5c44",
    "firmName": "NOURA TAYSSER ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1626",
    "licenseIssueDate": "02/16/2022 00:00:00",
    "licenseExpiryDate": "02/15/2026 00:00:00"
  },
  {
    "id": "fae07659-e7be-43e3-9d6c-a77c9b049462",
    "slug": "issa-abdulwahid-abdulwahid-abdulla-alshehhi",
    "name": "ISSA ABDUL WAHID ABDUL WAHID ABDULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/06/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ISSA ABDULWAHID ABDULWAHID ABDULLA ALSHEHHI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fae07659-e7be-43e3-9d6c-a77c9b049462",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1543",
    "licenseIssueDate": "06/25/2021 00:00:00",
    "licenseExpiryDate": "06/24/2026 00:00:00"
  },
  {
    "id": "e20bd880-5bbf-4820-aa69-4a666caa60b9",
    "slug": "jaafar-redha-mohammed-al-tooq",
    "name": "Jaafar Redha Mohammed Al-Tooq",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 27,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/12/1998 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Jaafar Redha Mohammed Al-Tooq",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e20bd880-5bbf-4820-aa69-4a666caa60b9",
        "address": "6 ,Business Point ,Nissan Showroom  ,443 ,Dubai",
        "phone": "97142999991",
        "email": "dubai@alrasheed.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "a4fce061-88d2-4308-9c3a-dbb02f5cbe82",
    "firmName": "ALRASHEED & PARTNERS",
    "registrationNumber": "334",
    "licenseIssueDate": "05/12/1998 00:00:00",
    "licenseExpiryDate": "05/11/2026 00:00:00"
  },
  {
    "id": "3d063712-e308-49c5-a87e-f41b4a4a24f2",
    "slug": "jaber-abdulla-ibrahim-alameeri",
    "name": "JABER ABDULLA IBRAHIM ALAMEERI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/12/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Jaber Abdulla Ibrahim Alameeri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3d063712-e308-49c5-a87e-f41b4a4a24f2",
        "address": "الطابق 14  ,برج 48 جيت  ,محطة مترو دبي  ,413633 ,Dubai",
        "phone": "97144412031",
        "email": "courts@adglegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "4287f048-dc0c-4d51-9e0c-0c23356040ee",
    "firmName": "MOHAMMED AL DAHBASHI ADVOCATES",
    "registrationNumber": "L-1242",
    "licenseIssueDate": "12/20/2017 00:00:00",
    "licenseExpiryDate": "12/19/2025 00:00:00"
  },
  {
    "id": "baee8965-a5c7-4369-a2c2-0f4e2eecee6f",
    "slug": "jaber-rashed-mohamed-jabir-rashid",
    "name": "JABIR RASHID MOHAMED JABIR ALSALAMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/03/2009",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: JABER RASHED MOHAMED JABIR RASHID",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_baee8965-a5c7-4369-a2c2-0f4e2eecee6f",
        "address": "jabir rashid alsalami ,b3607 ,latifa tower ,crowne plaza hotel - dubai ,3117 ,Dubai",
        "phone": "97143599997",
        "email": "jabir@jabiralsalami.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "ee5a7838-1f12-4443-832e-a3a87eff8dd6",
    "firmName": "JABIR RASHID ALSALAMI ADVOCATES & LEGEL CONSULTANCY",
    "registrationNumber": "L-657",
    "licenseIssueDate": "03/30/2009 00:00:00",
    "licenseExpiryDate": "03/29/2026 00:00:00"
  },
  {
    "id": "3dbcc999-440a-4b67-8b4a-9018a953fe0f",
    "slug": "jabir-jafar-qambar-ali-alansari",
    "name": "JABIR JAFAR QAMBAR ALI ALANSARI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 19,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/04/2006",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: JABIR JAFAR QAMBAR ALI ALANSARI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3dbcc999-440a-4b67-8b4a-9018a953fe0f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-554",
    "licenseIssueDate": "04/24/2006 00:00:00",
    "licenseExpiryDate": "04/23/2026 00:00:00"
  },
  {
    "id": "80dd6749-c766-4f40-933a-a3626700e2db",
    "slug": "jamal-abdulla-majed-al-shamsi",
    "name": "Jamal Abdulla Majed Al-Shamsi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/10/2021",
    "licenseStatus": "active",
    "licenseExpiry": "2022-10-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Jamal Abdulla Majed Al-Shamsi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_80dd6749-c766-4f40-933a-a3626700e2db",
        "address": "",
        "phone": "97144919339 / 971000000000",
        "email": "info@advo.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "4c91b3c6-b64f-4855-bd5e-44d442d235bf",
    "firmName": "JAMAL ALSHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "287",
    "licenseIssueDate": "10/26/2021 00:00:00",
    "licenseExpiryDate": "10/25/2025 00:00:00"
  },
  {
    "id": "379352ce-e427-4309-a52e-8ede532513b6",
    "slug": "jamal-hamad-obaid-alshehhi",
    "name": "YOUSEF SAYED ALI AL REFAEI ALHOSANI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/11/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-11-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Jamal Hamad Obaid Alshehhi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_379352ce-e427-4309-a52e-8ede532513b6",
        "address": "Jamal Hamad Obaid Alshehhi ,7 ,CENTURY 21 BLDG ,مركز حمر عين - مركز القبائل ,11977 ,Dubai",
        "phone": "97143376360 / 971556980980",
        "email": "info@alshehilaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "e0974afb-31b9-4ece-8c6e-ed607a9e9e04",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1899",
    "licenseIssueDate": "12/17/2023 00:00:00",
    "licenseExpiryDate": "12/16/2025 00:00:00"
  },
  {
    "id": "9f009a68-16ea-4e56-92c6-1b689e9379de",
    "slug": "jamal-hassan-abdo-al-najar",
    "name": "JAMAL HASSAN ABDO AL NAJAR",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/07/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: JAMAL HASSAN ABDO AL NAJAR",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9f009a68-16ea-4e56-92c6-1b689e9379de",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "1787",
    "licenseIssueDate": "04/07/2023 00:00:00",
    "licenseExpiryDate": "04/06/2026 00:00:00"
  },
  {
    "id": "fb4a724a-7569-4722-8428-2cd69472f123",
    "slug": "jamal-hussain-ahmed-alsumaiti",
    "name": "ALI HAMAD SAIF NASSER ALEBRI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/06/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Jamal Hussain Ahmed Alsumaiti",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fb4a724a-7569-4722-8428-2cd69472f123",
        "address": "Bader Aljassmy ,3 ,دبي كوميرسيتي ,دبي كوميرسيتي ,410004 ,Dubai",
        "phone": "97148760777 / 971586842086",
        "email": "info@bajlegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "7e820dd9-2748-4876-88db-ff7948542895",
    "firmName": "KHALFAN ALKAABI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1819",
    "licenseIssueDate": "06/26/2023 00:00:00",
    "licenseExpiryDate": "06/25/2026 00:00:00"
  },
  {
    "id": "ab848174-77d2-4dfc-82c5-8e2b85d744f7",
    "slug": "jamal-mohammad-aqil-sayed-mohammad-al-quraishi",
    "name": "JAMAL MOHAMMAD AQIL SAYED MOHAMMAD ALQURASHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 17,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/11/2007",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: JAMAL MOHAMMAD AQIL SAYED MOHAMMAD AL QURAISHI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ab848174-77d2-4dfc-82c5-8e2b85d744f7",
        "address": "الخامس ,الشعلة بلوك اية ,داناتا ,127179 ,Dubai",
        "phone": "97143318888 / 971509984724",
        "email": "ameizar@salamadvo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "1b4e6bd9-712b-49bf-a169-fd31ea45cd51",
    "firmName": "SALAM ADVOCATE & LEGAL CONSULTANTS",
    "registrationNumber": "L-616",
    "licenseIssueDate": "11/05/2007 00:00:00",
    "licenseExpiryDate": "11/04/2025 00:00:00"
  },
  {
    "id": "5fe31464-c56f-4dee-ac2b-b6cd7317ab35",
    "slug": "jamal-murad-ali-murad-al-raeesi",
    "name": "HASAN YOUSEF MOHAMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/05/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: jamal murad ali murad al raeesi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5fe31464-c56f-4dee-ac2b-b6cd7317ab35",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1664",
    "licenseIssueDate": "06/12/2022 00:00:00",
    "licenseExpiryDate": "06/11/2026 00:00:00"
  },
  {
    "id": "12cf06a9-6f12-438a-b41d-5fbfd53b0978",
    "slug": "jamela-saleh-ahmed-mohammed-altenaijy",
    "name": "JAMELA SALEH AHMED ALTENEIJI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 20,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/08/2005",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Jamela Saleh Ahmed Mohammed Altenaijy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_12cf06a9-6f12-438a-b41d-5fbfd53b0978",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-529",
    "licenseIssueDate": "08/24/2005 00:00:00",
    "licenseExpiryDate": "08/23/2026 00:00:00"
  },
  {
    "id": "2a1e58ab-a70b-42c1-be84-5907e05f4dd0",
    "slug": "jamila-hussain-ali-muaid-al-zahrani",
    "name": "JAMILA HUSSAIN ALI MUAID ALZAHRANI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/11/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Jamila Hussain Ali Muaid Al Zahrani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2a1e58ab-a70b-42c1-be84-5907e05f4dd0",
        "address": "",
        "phone": "97145681225",
        "email": "info@jalzahrani.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "8785e2d6-1e31-405c-b3b7-6422459731c0",
    "firmName": "JAMILA ALZAHRANI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-699",
    "licenseIssueDate": "11/08/2022 00:00:00",
    "licenseExpiryDate": "11/07/2025 00:00:00"
  },
  {
    "id": "586aab87-8702-4d11-9364-e1f9fec91df1",
    "slug": "jamila-saeed-majid-saeed-al-mheiri",
    "name": "JAMILA SAEED MAJID SAEED ALMHEIRI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/12/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Jamila Saeed Majid Saeed Al Mheiri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_586aab87-8702-4d11-9364-e1f9fec91df1",
        "address": "JAMILA SAEED ,طابق الميزانين مكتب رقم M18 ,برج بيزنيس أفينيو ,معرض شركة نيسان للسيارات ,23677 ,Dubai",
        "phone": "97148866123 / 971528003000",
        "email": "jamila.almheiriadvocates@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "55170c84-533c-4f35-8372-4130cfb0aad9",
    "firmName": "JAMILA ALMEHIRI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-981",
    "licenseIssueDate": "12/11/2014 00:00:00",
    "licenseExpiryDate": "12/10/2025 00:00:00"
  },
  {
    "id": "3c4eacaf-d531-4ac1-b6a2-f9070c66a72a",
    "slug": "jasem-abdulla-mohammed-ahmed-al-bloushi",
    "name": "JASEM ABDULLA MOHAMMED AHMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/03/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Jasem Abdulla Mohammed Ahmed Al Bloushi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3c4eacaf-d531-4ac1-b6a2-f9070c66a72a",
        "address": "",
        "phone": "97145780666",
        "email": "courts@jasem-legal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "077da0c2-09f9-4187-b455-b548a4c10707",
    "firmName": "JASEM AL BLOUSHI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-1519",
    "licenseIssueDate": "03/24/2021 00:00:00",
    "licenseExpiryDate": "03/23/2026 00:00:00"
  },
  {
    "id": "37f77739-35d9-4265-b886-4892334f0d0e",
    "slug": "jasem-ali-salem-naser-al-shamsi",
    "name": "JASSIM ALI SALEM NASSER ALSHAMSI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 43,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/03/1982",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Jasem Ali Salem Naser Al-Shamsi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_37f77739-35d9-4265-b886-4892334f0d0e",
        "address": "Mohamed Alhammadi ,FLOOR 16 OFFICE B1605 ,LATIFA TOWER ,CLOSE TO CROWN PLAZA HOTEL ,76550 ,Dubai",
        "phone": "97143298866",
        "email": "admin@dralhammadilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "612e75e6-c3f3-479b-bc93-ee88982dea58",
    "firmName": "DR MOHAMED ALHAMMADI ADVOCATES & LEGAL CONSULTANTS OFFICE",
    "registrationNumber": "L-107",
    "licenseIssueDate": "03/24/1982 00:00:00",
    "licenseExpiryDate": "03/23/2026 00:00:00"
  },
  {
    "id": "52415a19-73b3-48bc-8196-6bc3e2e6894a",
    "slug": "jasem-mohammed-abdulkareem",
    "name": "JASEM MOHAMMED ABDULKAREEM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/12/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: JASEM MOHAMMED ABDULKAREEM",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_52415a19-73b3-48bc-8196-6bc3e2e6894a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "1652",
    "licenseIssueDate": "05/12/2022 00:00:00",
    "licenseExpiryDate": "05/11/2026 00:00:00"
  },
  {
    "id": "383d2dfb-6eea-4bd3-98f9-172ffc047e04",
    "slug": "jasem-mohammed-abdulla-babaaish",
    "name": "JASSIM MOHD ABDULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 30,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/12/1994",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Jasem Mohammed Abdulla Babaaish",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_383d2dfb-6eea-4bd3-98f9-172ffc047e04",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-266",
    "licenseIssueDate": "12/14/1994 00:00:00",
    "licenseExpiryDate": "12/13/2025 00:00:00"
  },
  {
    "id": "7215a42b-4aff-4338-918c-ce2a0769a949",
    "slug": "jasem-mohd-rashed-khamis-alkhaddeim-alantali",
    "name": "JASEM MOHD RASHED K AL KHADDEIM ALANTALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/10/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Jasem Mohd Rashed Khamis Alkhaddeim Alantali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7215a42b-4aff-4338-918c-ce2a0769a949",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-903",
    "licenseIssueDate": "10/21/2024 00:00:00",
    "licenseExpiryDate": "10/20/2025 00:00:00"
  },
  {
    "id": "2b7442aa-4402-45ae-ac6d-3fb272b890c6",
    "slug": "jasim-abdalla-abdelrazaq-abdalla-al-naqbi",
    "name": "Jasim Abdalla Abdelrazaq Abdalla Al Naqbi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 20,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/10/2005 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-09-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Jasim Abdalla Abdelrazaq Abdalla Al Naqbi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2b7442aa-4402-45ae-ac6d-3fb272b890c6",
        "address": "YASIR AL NAQBI ,21 ,48 BURJ ,SOFITEL DOWN  TOWN ,181111 ,Dubai",
        "phone": "97142689949",
        "email": "info@alnaqbipartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "ad71430e-83ee-4cb5-a530-bc58db2618f6",
    "firmName": "ALNAQBI & PARTNERS ADVOCATES & LEGAL CONSULTA",
    "registrationNumber": "495",
    "licenseIssueDate": "01/10/2005 00:00:00",
    "licenseExpiryDate": "01/09/2026 00:00:00"
  },
  {
    "id": "ad9a2136-2f76-43f2-b4ed-b8fd64c407be",
    "slug": "jasim-ali-abdalla-alhaddad-alraeesi",
    "name": "JASIM ALI ABDALLA ALHADDAD ALRAEESI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/07/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Jasim ali abdalla alhaddad alraeesi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ad9a2136-2f76-43f2-b4ed-b8fd64c407be",
        "address": "الثاني عشر مكتب 1201 ,مبنى امباير هايتس البرج B ,بنك رأس الخيمة ,00000 ,Dubai",
        "phone": "97142611689 / 971561234514",
        "email": "info@nja.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "490cb579-167c-4a7e-b679-997fb6780992",
    "firmName": "JASIM AL HADDAD ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1436",
    "licenseIssueDate": "07/15/2020 00:00:00",
    "licenseExpiryDate": "07/14/2026 00:00:00"
  },
  {
    "id": "5658e924-7bba-46e1-a7ce-90fa67dd2bc8",
    "slug": "jasim-mohamed-abdalla-murad-alblooshi",
    "name": "jasim mohamed abdalla murad alblooshi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/19/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: jasim mohamed abdalla murad alblooshi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5658e924-7bba-46e1-a7ce-90fa67dd2bc8",
        "address": "1 ,Crystal Tower ,Business Bay ,1859 ,Dubai",
        "phone": "97142956661",
        "email": "info@amrplc.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "833edb7f-7a70-4ab6-9838-4782eb1b4f8a",
    "firmName": "ABDULLA MOHAMMED RASOUL ALHARMOODI ADVOCATES",
    "registrationNumber": "2024",
    "licenseIssueDate": "09/19/2024 00:00:00",
    "licenseExpiryDate": "09/18/2026 00:00:00"
  },
  {
    "id": "9663d2bd-dd90-4e9a-859d-0f9a9d3127b7",
    "slug": "jasim-mohamed-sulaiman-ali-mohamed-almaeeni",
    "name": "JASIM MOHAMED SULAIMAN ALI MOHD ALMAEENI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Criminal Law-Family Crimes",
      "Criminal Law-Hate crimes",
      "Criminal Law-Crimes against persons",
      "Criminal Law-Drug Crimes",
      "Criminal Law-Crimes against properties",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/03/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Jasim Mohamed Sulaiman Ali Mohamed Almaeeni",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9663d2bd-dd90-4e9a-859d-0f9a9d3127b7",
        "address": "Floor 7 ,Sama Tower  ,Dubai World Trade Centre ,120059 ,Dubai",
        "phone": "97142954626 / 971506311169",
        "email": "info@jmadvocatesuae.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "5a33c148-b449-40a3-a945-e3a2eb7cbdda",
    "firmName": "JASIM ALMAEENI LAW ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-868",
    "licenseIssueDate": "03/12/2013 00:00:00",
    "licenseExpiryDate": "03/11/2026 00:00:00"
  },
  {
    "id": "63e4d2ea-4f1a-43c1-a3f4-465509252516",
    "slug": "jasim-rida-mohamed-saleh-alzarooni",
    "name": "JASIM RIDA MOHAMED SALEH ALZAROUNI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/04/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Jasim Rida Mohamed Saleh Alzarooni",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_63e4d2ea-4f1a-43c1-a3f4-465509252516",
        "address": "KEFAH ALZAABI ,3005 ,برج لطيفه  ,ابراج لطيفه  ,97597 ,Dubai",
        "phone": "97142522260",
        "email": "info@jazlawyers.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "6fab0ce0-5a6b-4586-a900-862950161d02",
    "firmName": "JASIM ALZAROONI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1170",
    "licenseIssueDate": "04/18/2017 00:00:00",
    "licenseExpiryDate": "04/17/2026 00:00:00"
  },
  {
    "id": "b3da4625-7ca2-4e50-9b92-5d9bfee2ea75",
    "slug": "jassem-salem-musabeh-salem",
    "name": "JASSEM SALEM MUSABEH",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Personal Status-Wills",
      "Criminal Law-Family Crimes",
      "Personal Status-Custody & Alimony",
      "Criminal Law-Hate crimes",
      "Criminal Law-Crimes against persons",
      "Personal Status-Legacies and Inheritance",
      "Personal Status-Legal Capacity & Guardianship",
      "Criminal Law-Drug Crimes",
      "Personal Status-Marriage & Divorce",
      "Personal Status-Child Abuse & Abduction",
      "Criminal Law-Crimes against properties",
      "Criminal Law-Cybercrimes"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/04/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Jassem Salem Musabeh Salem",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b3da4625-7ca2-4e50-9b92-5d9bfee2ea75",
        "address": "4th Floor/ Office no. 401 ,Business Avenue  ,Infront- Terminal 2  ,115263 ,Dubai",
        "phone": "97144518866",
        "email": "info@aldhaheriinternational.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "cf3c19c0-d396-4bcb-b1db-b81273ed0b4c",
    "firmName": "AL DHAHERI INTERNATIONAL ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-870",
    "licenseIssueDate": "05/01/2013 00:00:00",
    "licenseExpiryDate": "04/30/2026 00:00:00"
  },
  {
    "id": "aa6a887b-b859-450c-bbb6-9bee07f9754d",
    "slug": "jassim-mohamed-abdul-aziz-mohamed-majed-al-suwaidi",
    "name": "JASSIM MOHAMED ABDUL AZIZ M ALSUWAIDI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/10/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Jassim Mohamed Abdul Aziz Mohamed Majed Al Suwaidi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_aa6a887b-b859-450c-bbb6-9bee07f9754d",
        "address": "",
        "phone": "97143530018",
        "email": "info@alsuwaidiadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "838d8111-1e4d-43cc-88f7-71f2dcb24635",
    "firmName": "JASSIM AL SUWAIDI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-1316",
    "licenseIssueDate": "10/08/2018 00:00:00",
    "licenseExpiryDate": "10/07/2025 00:00:00"
  },
  {
    "id": "bae6946f-7f45-4af4-aa72-947f5289e6dc",
    "slug": "jawhar-mohamed-ghanim-mohamed-alghaith-al-marri",
    "name": "JAWAHER MOHAMED G M ALGHAITH ALMARRI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/06/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Jawhar Mohamed Ghanim Mohamed Alghaith Al Marri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bae6946f-7f45-4af4-aa72-947f5289e6dc",
        "address": "21 ,Rolex Tower ,Emirates Grand Hotel ,94334 ,Dubai",
        "phone": "97143277772 / 97145584900",
        "email": "info@globaladvocates.net",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "9b42810f-1d55-4aea-ac4a-7d9d1b25ac08",
    "firmName": "GLOBAL ADVOCACY & LEGAL COUNSEL",
    "registrationNumber": "L-1533",
    "licenseIssueDate": "06/07/2021 00:00:00",
    "licenseExpiryDate": "06/06/2026 00:00:00"
  },
  {
    "id": "dedb06f4-1235-4cba-870e-2db4d4bbfe84",
    "slug": "jehad-saeed-ali-binsahoo-alsuwaidi",
    "name": "JEHAD SAEED ALI BIN SAHOO",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/03/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Jehad Saeed Ali Binsahoo Alsuwaidi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dedb06f4-1235-4cba-870e-2db4d4bbfe84",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1266",
    "licenseIssueDate": "03/12/2018 00:00:00",
    "licenseExpiryDate": "03/11/2026 00:00:00"
  },
  {
    "id": "e66592c2-3ee5-433e-b5d9-b1fb5e64db11",
    "slug": "jouslin-chibli",
    "name": "JOUSLIN CHIBLI KHAIRALLAH",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Civil Transactions-Insurance",
      "Civil Transactions-Construction and Contracts for Services",
      "Commercial Transactions-Commercial Contracts",
      "Commercial Transactions-Bankruptcy",
      "Civil Transactions-Residential Real Estate",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Commercial Transactions-Commercial Companies",
      "Civil Transactions-Compensation",
      "Commercial Transactions-Intellectual Property (includes trademarks",
      "copy rights",
      "patents)"
    ],
    "experience": 19,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/05/2006",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: JOUSLIN CHIBLI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e66592c2-3ee5-433e-b5d9-b1fb5e64db11",
        "address": "",
        "phone": "97144270845",
        "email": "info@khairallahlegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "74569c18-b69d-4159-813d-9923b25d2dca",
    "firmName": "KHAIRALLAH ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-567",
    "licenseIssueDate": "05/08/2006 00:00:00",
    "licenseExpiryDate": "05/07/2026 00:00:00"
  },
  {
    "id": "66c55533-f2e9-43b9-a0ce-8e268f76e119",
    "slug": "juma-buti-juma-al-bawardi",
    "name": "Juma Buti Juma Al-Bawardi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 28,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/19/1996 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2021-12-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Juma Buti Juma Al-Bawardi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_66c55533-f2e9-43b9-a0ce-8e268f76e119",
        "address": "7th floor, 701 ,Al Khaleej Centre ,near Al Fahidi Metro Station ,5083 ,Dubai",
        "phone": "97143591115",
        "email": "jummaadv@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "0723aecf-8cde-4976-bd8d-dc29c3cac701",
    "firmName": "AL BAWARDI ADVOCATE & LEGAL CONSULTANTS",
    "registrationNumber": "31",
    "licenseIssueDate": "12/19/1996 00:00:00",
    "licenseExpiryDate": "12/18/2021 00:00:00"
  },
  {
    "id": "57c90c03-762c-4e0e-816a-2210badd4bc2",
    "slug": "juma-khalifa-juma-alhamidh",
    "name": "JUMA KHALIFA JUMA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Civil Transactions-POA & Sponsorship",
      "Civil Transactions-Insurance",
      "Civil Transactions-Construction and Contracts for Services",
      "Civil Transactions-Ownership & Title",
      "Criminal Law-Family Crimes",
      "Personal Status-Custody & Alimony",
      "Civil Transactions-Immigration and Residency",
      "Commercial Transactions-Bankruptcy",
      "Commercial Transactions-Commercial Real Estate",
      "Civil Transactions-Residential Real Estate",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Criminal Law-Hate crimes",
      "Civil Transactions-Tenancy",
      "Commercial Transactions-Unfair competition",
      "Criminal Law-Crimes against persons",
      "Commercial Transactions-Banking Operations",
      "Civil Transactions-Labor & Workers",
      "Criminal Law-Drug Crimes",
      "Civil Transactions-Sale",
      "Civil Transactions-Compensation",
      "Criminal Law-Crimes against properties",
      "Criminal Law-Cybercrimes",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/07/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Juma Khalifa Juma Alhamidh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_57c90c03-762c-4e0e-816a-2210badd4bc2",
        "address": "Juma Khalifa  ,Block A office A304 ,Saraya avenue  ,GGCO metro station  ,430055 ,Dubai",
        "phone": "97142229449 / 971508857744",
        "email": "Gov@jkuaeadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "59231a3a-5ffa-40a6-83b0-43ab2d1b68a1",
    "firmName": "JUMA KHALIFA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1199",
    "licenseIssueDate": "07/02/2017 00:00:00",
    "licenseExpiryDate": "07/01/2026 00:00:00"
  },
  {
    "id": "f040b846-5ad9-4244-836d-43faeff7c54d",
    "slug": "juma-mohamed-juma-saeed-al-naqbi",
    "name": "JUMA MOHAMED JUMA SAEED ALNAQBI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/01/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Juma Mohamed Juma Saeed Al Naqbi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f040b846-5ad9-4244-836d-43faeff7c54d",
        "address": "Juma Alnaqbi  ,1105 ,IRIS BAY ,Burj Khalifa  ,11161 ,Dubai",
        "phone": "97142999006 / 971504908111",
        "email": "jumaalnaqbi.dxb@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "c8d741bf-af4d-4742-8212-d56536005745",
    "firmName": "JUMA AL NAQBI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-909",
    "licenseIssueDate": "01/14/2014 00:00:00",
    "licenseExpiryDate": "01/13/2026 00:00:00"
  },
  {
    "id": "0cfdf6b7-544c-4284-8216-61b3b386e2fb",
    "slug": "juma-mohammed-ahmed-doura-alkaabi",
    "name": "SARA ABDUL RAHMAN ABDUL AZIZ A ALDOSARI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/11/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Juma Mohammed Ahmed Doura Alkaabi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0cfdf6b7-544c-4284-8216-61b3b386e2fb",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1890",
    "licenseIssueDate": "11/27/2023 00:00:00",
    "licenseExpiryDate": "11/26/2025 00:00:00"
  },
  {
    "id": "3de56d27-a9c0-47db-85bd-c8ed219a5504",
    "slug": "jumah-ahmed-obaid-ahmed-meleh-dhanhani",
    "name": "JUMAH AHMED OBAID AHMED MELEIH",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 17,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/05/2008",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Jumah Ahmed Obaid Ahmed Meleh Dhanhani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3de56d27-a9c0-47db-85bd-c8ed219a5504",
        "address": "",
        "phone": "97142999720",
        "email": "meleihadvocates@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "5dd70a2b-2ada-48f1-81e2-5885629a7035",
    "firmName": "MELEIH ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-629",
    "licenseIssueDate": "05/19/2008 00:00:00",
    "licenseExpiryDate": "05/18/2026 00:00:00"
  },
  {
    "id": "1120b4a0-3570-46fd-aa9c-3982b1c6118e",
    "slug": "jumaia-saleh-jumea-saleh",
    "name": "JUMAIA SALEH JUMEA SALEH",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/07/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: JUMAIA SALEH JUMEA SALEH",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1120b4a0-3570-46fd-aa9c-3982b1c6118e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1438",
    "licenseIssueDate": "07/16/2020 00:00:00",
    "licenseExpiryDate": "07/15/2026 00:00:00"
  },
  {
    "id": "f2c5c4f6-b88c-4d76-b797-f998f3b863f2",
    "slug": "kaaseb-mohamed-rashed-ahmad-alhassani",
    "name": "FADIL AHMED RAMADAN ALI ALZAROONI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/07/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Kaaseb Mohamed Rashed Ahmad Alhassani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f2c5c4f6-b88c-4d76-b797-f998f3b863f2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1838",
    "licenseIssueDate": "07/28/2023 00:00:00",
    "licenseExpiryDate": "07/27/2026 00:00:00"
  },
  {
    "id": "a7d109cf-40c6-4fa9-8429-8c360c049684",
    "slug": "kaltham-adel-hassan-almehza",
    "name": "KALTHAM ADEL HASSAN ALMEHZA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/06/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Kaltham Adel Hassan ALmehza",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a7d109cf-40c6-4fa9-8429-8c360c049684",
        "address": "",
        "phone": "97145642777 / 971508551535",
        "email": "legal@alnajjarlawyer.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "1670d8d1-6114-4b77-b2da-9d4c0dc0054b",
    "firmName": "MOHAMMAD ALNAJJAR ADVOCATES LEGAL CONSULTANTS",
    "registrationNumber": "L-1425",
    "licenseIssueDate": "06/23/2020 00:00:00",
    "licenseExpiryDate": "06/22/2026 00:00:00"
  },
  {
    "id": "60b6f09d-41dd-48b1-b60c-d2010bbe65ec",
    "slug": "kaltham-mohammad-juma-abdulla-alfalasi",
    "name": "MOHAMMAD JUMA ABDULLA MOHAMMAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/12/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: kaltham mohammad juma abdulla alfalasi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_60b6f09d-41dd-48b1-b60c-d2010bbe65ec",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1604",
    "licenseIssueDate": "12/07/2021 00:00:00",
    "licenseExpiryDate": "12/06/2025 00:00:00"
  },
  {
    "id": "427af2db-e523-4e8a-b7e0-b064eee2b363",
    "slug": "kanaan-eisa-yousuf-ahmed-alhosani",
    "name": "SALEM MOHAMMED HMOUD ALDEREI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/03/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Kanaan Eisa Yousuf Ahmed Alhosani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_427af2db-e523-4e8a-b7e0-b064eee2b363",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1647",
    "licenseIssueDate": "04/30/2022 00:00:00",
    "licenseExpiryDate": "04/29/2026 00:00:00"
  },
  {
    "id": "0363c8c8-db35-438e-948b-5fad396a3fcc",
    "slug": "kawthar-ibrahim-mohammad",
    "name": "KAWTHAR IBRAHIM W O MOHD SH ALBALOOSHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 21,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/01/2004",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Kawthar Ibrahim Mohammad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0363c8c8-db35-438e-948b-5fad396a3fcc",
        "address": "",
        "phone": "97143699967",
        "email": "advo@dsh-legal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "710524e6-a0b5-44fe-929d-85bfc4bf27dc",
    "firmName": "SALEM ALHARTHI LAW ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-470",
    "licenseIssueDate": "01/25/2004 00:00:00",
    "licenseExpiryDate": "01/24/2026 00:00:00"
  },
  {
    "id": "d12858c8-1e49-4a52-abe1-899a48acdd44",
    "slug": "kefah-mohamed-al-zaabi",
    "name": "KEFAH MOHAMED NASIR ALSHAHSI ALZAABI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/01/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: KEFAH MOHAMED AL-ZAABI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d12858c8-1e49-4a52-abe1-899a48acdd44",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-615",
    "licenseIssueDate": "01/17/2012 00:00:00",
    "licenseExpiryDate": "01/16/2026 00:00:00"
  },
  {
    "id": "3f206419-f9d9-46ce-b5af-a571dda1378a",
    "slug": "khadeeja-mohamed-nour-almarzooqi",
    "name": "Khadeeja Mohamed Nour Almarzooqi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/13/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Khadeeja Mohamed Nour Almarzooqi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3f206419-f9d9-46ce-b5af-a571dda1378a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "1040",
    "licenseIssueDate": "12/13/2015 00:00:00",
    "licenseExpiryDate": "12/12/2025 00:00:00"
  },
  {
    "id": "a0ba4da2-6ef9-463f-a354-7df8a3bb076d",
    "slug": "khadeeja-saeed-mubarak-mahboub-alzaabi",
    "name": "IBRAHIM ALI IBRAHIM ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/07/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Khadeeja Saeed Mubarak Mahboub Alzaabi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a0ba4da2-6ef9-463f-a354-7df8a3bb076d",
        "address": "",
        "phone": "97142966772",
        "email": "info@advocates-consultation.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "43806daf-e311-4130-a270-8aabc08c4ef4",
    "firmName": "IBRAHIM ALSERKAL ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-2016",
    "licenseIssueDate": "08/21/2024 00:00:00",
    "licenseExpiryDate": "08/20/2026 00:00:00"
  },
  {
    "id": "bba315a4-e01a-43b7-abf9-194ca43fc4e3",
    "slug": "khadija-ahmed-mohammed-ali-al-meer",
    "name": "MARWA SULAIMAN MOHAMMED KARAZON",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/04/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Khadija Ahmed Mohammed Ali Al Meer",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bba315a4-e01a-43b7-abf9-194ca43fc4e3",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1793",
    "licenseIssueDate": "04/25/2023 00:00:00",
    "licenseExpiryDate": "04/24/2026 00:00:00"
  },
  {
    "id": "1dd570ee-ddcb-4f0a-ab86-ee535cedca9e",
    "slug": "khadija-mohammed-ali-ahmad-alhammadi",
    "name": "AMMAR ALI AHMED ALI ABDELRAHMAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Criminal Law-Family Crimes",
      "Personal Status-Custody & Alimony",
      "Commercial Transactions-Commercial Contracts",
      "Civil Transactions-Arbitration",
      "Criminal Law-Hate crimes",
      "Criminal Law-Crimes against persons",
      "Civil Transactions-Labor & Workers",
      "Civil Transactions-Sale",
      "Proceedings-Cases and Proceedings before arbitral tribunals and other alternative dispute resolution bodies",
      "Personal Status-Marriage & Divorce",
      "Civil Transactions-Compensation",
      "Criminal Law-Crimes against properties",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/01/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Khadija mohammed ali ahmad alhammadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1dd570ee-ddcb-4f0a-ab86-ee535cedca9e",
        "address": "",
        "phone": "97143702000 / 971504844414",
        "email": "advoy.m@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "22c36bcb-1914-4128-9816-406ffc0aec47",
    "firmName": "AMMAR ALMULLA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1918",
    "licenseIssueDate": "02/21/2024 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "8ae88511-f250-4db8-9eee-34a3d9f6d7ae",
    "slug": "khadija-sulaaiman-obaid-al-khanbooli",
    "name": "KHADIJA SULAIMAN OBAID ADWAH ALKHANBOULI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Personal Status-Custody & Alimony",
      "Criminal Law-Drug Crimes",
      "Criminal Law-Crimes against properties",
      "Personal Status-Marriage & Divorce",
      "Criminal Law-Crimes against persons"
    ],
    "experience": 15,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/12/2009",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Khadija Sulaaiman Obaid Al Khanbooli",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8ae88511-f250-4db8-9eee-34a3d9f6d7ae",
        "address": "khadija sulaiman obaid alkhanboli ,18 ,opal tawer ,burj khalifa ,31431 ,Dubai",
        "phone": "97153966699",
        "email": "lawyer.khadija.alkhanbouli@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "a3ee9588-d2b8-4dd3-b653-95e4b34d54bf",
    "firmName": "KHADIJA ALKHANBOULI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-689",
    "licenseIssueDate": "12/24/2009 00:00:00",
    "licenseExpiryDate": "12/23/2025 00:00:00"
  },
  {
    "id": "3671b7d2-ca2e-49d8-80d0-70bf162d1002",
    "slug": "khadijah-sohail-hassan-asaadi",
    "name": "KHADIJAH SOHAIL HASSAN ALSAADI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Commercial Agency",
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Civil Transactions-POA & Sponsorship",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Civil Transactions-Insurance",
      "Civil Transactions-Construction and Contracts for Services",
      "Civil Transactions-Ownership & Title",
      "Civil Transactions-HR & Employee Affairs",
      "Commercial Transactions-Commercial Mortgage",
      "Criminal Law-Family Crimes",
      "Personal Status-Custody & Alimony",
      "Commercial Transactions-Commercial Contracts",
      "Civil Transactions-Immigration and Residency",
      "Commercial Transactions-Bankruptcy",
      "Commercial Transactions-Commercial Real Estate",
      "Civil Transactions-Residential Real Estate",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Civil Transactions-Arbitration",
      "Criminal Law-Hate crimes",
      "Civil Transactions-Tenancy",
      "Commercial Transactions-Unfair competition",
      "Criminal Law-Crimes against persons",
      "Personal Status-Legacies and Inheritance",
      "Commercial Transactions-Commercial Companies",
      "Civil Transactions-Labor & Workers",
      "Personal Status-Legal Capacity & Guardianship",
      "Criminal Law-Drug Crimes",
      "Civil Transactions-Sale",
      "Commercial Transactions-Sea and air freight",
      "Commercial Transactions-Consumer protection",
      "Personal Status-Marriage & Divorce",
      "Personal Status-Child Abuse & Abduction",
      "Civil Transactions-Compensation",
      "Commercial Transactions-Stock",
      "Criminal Law-Crimes against properties",
      "Commercial Transactions-E-Commerce",
      "Criminal Law-Cybercrimes",
      "Commercial Transactions-Intellectual Property (includes trademarks",
      "copy rights",
      "patents)",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/03/2009",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Khadijah Sohail Hassan Asaadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3671b7d2-ca2e-49d8-80d0-70bf162d1002",
        "address": "khadijah sohail hassan asaadi ,طابق الميزانيين  ,ايميجت  ,مترو الخليج التجاري  ,41342 ,Dubai",
        "phone": "97143438885",
        "email": "info@asaadi.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "264cfea6-1419-45d4-9264-7dba3f26da68",
    "firmName": "KHADIJAH SOHAIL ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-652",
    "licenseIssueDate": "03/16/2009 00:00:00",
    "licenseExpiryDate": "03/15/2026 00:00:00"
  },
  {
    "id": "a9b5d943-80dd-4469-9dfe-05b4604a3d7e",
    "slug": "khalaf-abdalla-malalla-al-hosany",
    "name": "KHALAF ABDALLA MALALLA ALHOSANI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 23,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/04/2002",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Khalaf Abdalla Malalla Al Hosany",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a9b5d943-80dd-4469-9dfe-05b4604a3d7e",
        "address": "Noushad kn ,1 ,sama tower ,Chello Restaurant  ,87706 ,Dubai",
        "phone": "97142822744",
        "email": "info@hosanilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "c063023c-8d6f-4566-8537-31e0c9977c77",
    "firmName": "AL HOSANY ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-423",
    "licenseIssueDate": "04/23/2002 00:00:00",
    "licenseExpiryDate": "04/22/2026 00:00:00"
  },
  {
    "id": "a619459e-f141-4cc9-9934-e77baf42f18b",
    "slug": "khaled-abdulwahab-faraj-afifi",
    "name": "KHALED ABDELWAHAB FARAG AFIFI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 25,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/07/2000",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Khaled Abdulwahab Faraj Afifi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a619459e-f141-4cc9-9934-e77baf42f18b",
        "address": "10th Floor ,AlReem Tower ,Dubai Land Department ,32367 ,Dubai",
        "phone": "97142272701",
        "email": "midfaadv@eim.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "fe9068a7-b94d-49bb-88b3-6f8491a15389",
    "firmName": "AL MIDFA & ASSOCIATES",
    "registrationNumber": "L-382",
    "licenseIssueDate": "07/18/2000 00:00:00",
    "licenseExpiryDate": "07/17/2026 00:00:00"
  },
  {
    "id": "600c32d6-40b7-4581-bbaf-2910d101cd48",
    "slug": "khaled-ahmed-abdulla-ahmed",
    "name": "KHALED AHMED ABDULLA AHMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/09/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Khaled Ahmed Abdulla Ahmed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_600c32d6-40b7-4581-bbaf-2910d101cd48",
        "address": "KHALED AHMED ABDULLA AHMED ,24 ,Clover Bay ,SAAS Tower  ,288 ,Dubai",
        "phone": "97143453233",
        "email": "info@theadvocates.io",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "b0e9ddc9-f4a3-4647-97ae-dc4ca90bcb6c",
    "firmName": "THE ADVOCATES",
    "registrationNumber": "L-500",
    "licenseIssueDate": "09/29/2022 00:00:00",
    "licenseExpiryDate": "09/28/2026 00:00:00"
  },
  {
    "id": "c7db1783-798a-49f1-80d5-d809633ae4f1",
    "slug": "khaled-ajail-ali-abdulla-aljneibi",
    "name": "SHAIKHA SAIF OBAID SAIF ALKINDI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/02/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: khaled ajail ali abdulla aljneibi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c7db1783-798a-49f1-80d5-d809633ae4f1",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1633",
    "licenseIssueDate": "03/16/2022 00:00:00",
    "licenseExpiryDate": "03/15/2026 00:00:00"
  },
  {
    "id": "a844e77a-a42f-48f3-a623-660572bb9afb",
    "slug": "khaled-ali-mohamed-ali-alhadhrami",
    "name": "SAEED DARWEISH SAEED AL ABD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/05/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Khaled Ali Mohamed Ali Alhadhrami",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a844e77a-a42f-48f3-a623-660572bb9afb",
        "address": "",
        "phone": "/ 971506158015",
        "email": "lawyer.uae@live.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "8a3b8670-2b6e-4692-b71b-6abf145a3b6a",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1979",
    "licenseIssueDate": "06/07/2024 00:00:00",
    "licenseExpiryDate": "06/06/2026 00:00:00"
  },
  {
    "id": "7a639040-7a5b-4f59-b4ef-637c3f855119",
    "slug": "khaled-khalfan-hamad-majed-almarri",
    "name": "KHALED KHALFAN HAMAD MAJED ALMARRI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/06/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Khaled Khalfan Hamad Majed Almarri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7a639040-7a5b-4f59-b4ef-637c3f855119",
        "address": "",
        "phone": "97142659440",
        "email": "info@klaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "d42ce31f-e881-40e1-bd66-bf2e5bb9bb1e",
    "firmName": "KHALED ALMARRI & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1539",
    "licenseIssueDate": "06/22/2021 00:00:00",
    "licenseExpiryDate": "06/21/2026 00:00:00"
  },
  {
    "id": "74f3a562-6176-43f8-b02b-5d68072c02fe",
    "slug": "khaled-mohamed-ali-alhammadi",
    "name": "KHALED MOHAMED ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/10/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Khaled Mohamed Ali Alhammadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_74f3a562-6176-43f8-b02b-5d68072c02fe",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1031",
    "licenseIssueDate": "10/12/2015 00:00:00",
    "licenseExpiryDate": "10/11/2025 00:00:00"
  },
  {
    "id": "8af6e6db-7ff2-4982-9d22-884977745b32",
    "slug": "khaled-mohammed-kadfoor-al-meheiri",
    "name": "KHALID MOHAMMAD KADFOOR",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/01/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Khaled Mohammed Kadfoor Al-Meheiri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8af6e6db-7ff2-4982-9d22-884977745b32",
        "address": "",
        "phone": "97143304343",
        "email": "hamad@emiratesadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "f7823b07-a968-474f-8a13-a4454ef2d990",
    "firmName": "EMIRATES ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-205",
    "licenseIssueDate": "01/27/2021 00:00:00",
    "licenseExpiryDate": "01/26/2026 00:00:00"
  },
  {
    "id": "a75a9d22-823c-4dc9-891a-59ec83b46470",
    "slug": "khaled-mustafa-jasem-mohammed-aljasmi",
    "name": "KHALED MUSTAFA JASEM MOHAMMED ALJASMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/10/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Khaled Mustafa Jasem Mohammed Aljasmi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a75a9d22-823c-4dc9-891a-59ec83b46470",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1117",
    "licenseIssueDate": "10/12/2016 00:00:00",
    "licenseExpiryDate": "10/11/2026 00:00:00"
  },
  {
    "id": "73ec813b-ef17-47b3-b5d5-60ac20a3863f",
    "slug": "khaled-saleh-omar-bin-fadhel-albreiki",
    "name": "KHALED SALEH OMAR BIN FADHEL ALBREIKI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/10/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Khaled Saleh Omar Bin Fadhel Albreiki",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_73ec813b-ef17-47b3-b5d5-60ac20a3863f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1581",
    "licenseIssueDate": "10/25/2021 00:00:00",
    "licenseExpiryDate": "10/24/2025 00:00:00"
  },
  {
    "id": "f9e79f08-4c33-44c9-ad1d-09bad6ce405f",
    "slug": "khalfan-ghanim-saeed-khalfan-al-kaabi",
    "name": "KHALFAN GHANIM SAEED KHALFAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 19,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/02/2006",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: KHALFAN GHANIM SAEED KHALFAN AL KAABI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f9e79f08-4c33-44c9-ad1d-09bad6ce405f",
        "address": "الطابق الثامن ,بزنس افنيو ,فندق الخوري سكاي جاردن  ,126510 ,Dubai",
        "phone": "97142572778",
        "email": "zakia@houseofj.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "80c1d0d8-bc34-4358-b07f-35c5f9408311",
    "firmName": "KHALFAN ALKAABI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-545",
    "licenseIssueDate": "02/07/2006 00:00:00",
    "licenseExpiryDate": "02/06/2026 00:00:00"
  },
  {
    "id": "d57cecc4-5adf-40df-8b09-3ca601c12016",
    "slug": "khalfan-khalifa-rashed-sabt-alshamsi",
    "name": "KHADIJAMOHAMMED ALI AHMAD ALHAMMADI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/02/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: khalfan khalifa rashed sabt alshamsi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d57cecc4-5adf-40df-8b09-3ca601c12016",
        "address": "",
        "phone": "97145548499",
        "email": "legal@nyk.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "86fac3dc-bced-468b-8e4c-43324e2aa906",
    "firmName": "MOHAMMED ABDULLA & YOUSUF ALHAMMADI ADVOCATE LEGAL CONSULTANTS",
    "registrationNumber": "L-1925",
    "licenseIssueDate": "03/08/2024 00:00:00",
    "licenseExpiryDate": "03/07/2026 00:00:00"
  },
  {
    "id": "a1cd62f8-989f-4be6-b5cb-ad67df1d3ae1",
    "slug": "khalid-abdalla-abdelrazaq-abdalla-alnaqbi",
    "name": "KHALID ABDALLA ABDELRAZAQ ABDALLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Civil Transactions-HR & Employee Affairs",
      "Personal Status-Legacies and Inheritance",
      "Criminal Law-Drug Crimes",
      "Criminal Law-Crimes against properties",
      "Commercial Transactions-Intellectual Property (includes trademarks",
      "copy rights",
      "patents)",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/02/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Khalid Abdalla Abdelrazaq Abdalla Alnaqbi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a1cd62f8-989f-4be6-b5cb-ad67df1d3ae1",
        "address": "YASIR AL NAQBI ,21 ,48 BURJ ,SOFITEL DOWN  TOWN ,181111 ,Dubai",
        "phone": "97142689949",
        "email": "info@alnaqbipartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "ad71430e-83ee-4cb5-a530-bc58db2618f6",
    "firmName": "ALNAQBI & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1256",
    "licenseIssueDate": "02/07/2018 00:00:00",
    "licenseExpiryDate": "02/06/2026 00:00:00"
  },
  {
    "id": "af387cd8-7aab-4a39-bf29-e75a650270d0",
    "slug": "khalid-abdulla-mohamed-abdulla-ahmed",
    "name": "KHALID ABDALLA MOHAMED ABDALLA AHMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/06/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Khalid Abdulla Mohamed Abdulla Ahmed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_af387cd8-7aab-4a39-bf29-e75a650270d0",
        "address": "الطابق 7 مكتب رقم 070A ,برج رولكس  ,محطة مترو المركز المالي  ,66300 ,Dubai",
        "phone": "97143444029",
        "email": "ekp.khalidaltmimi@ekplegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "400838f1-4e75-4836-9698-b9e19dd30a18",
    "firmName": "KHALID ABDULLA AL TAMIMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-819",
    "licenseIssueDate": "06/13/2012 00:00:00",
    "licenseExpiryDate": "06/12/2026 00:00:00"
  },
  {
    "id": "f06a6c03-7a77-4d15-a5af-45ce61b36a3a",
    "slug": "khalid-ahmad-ali-rashed-alkatitoob",
    "name": "KHALID AHMAD ALI ALKAITOOB ALNUAIMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/03/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Khalid Ahmad Ali Rashed Alkatitoob",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f06a6c03-7a77-4d15-a5af-45ce61b36a3a",
        "address": "khalid al kaitoob ,12 ,نسيمية تاور الطابق 12 1202 B ,فندق الفوكو  ,10755 ,Dubai",
        "phone": "97143586555",
        "email": "info@alkaitooblawyer.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "403277a6-eef2-4cfd-af95-9959280d6b40",
    "firmName": "AL KAITOOB ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-745",
    "licenseIssueDate": "03/13/2011 00:00:00",
    "licenseExpiryDate": "03/12/2026 00:00:00"
  },
  {
    "id": "6986a2f6-142a-409b-8cd7-f95c28812bb2",
    "slug": "khalid-ali-ahmed-bin-hammad-al-marri",
    "name": "MARIAM IBRAHIM GHLOOM ALI ABDALLA ROBAR",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/05/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Khalid Ali Ahmed Bin Hammad Al Marri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6986a2f6-142a-409b-8cd7-f95c28812bb2",
        "address": "شركة قطر للتأمين ,مركز الدانة ,فندق كارلتون بالاس ,80239 ,Dubai",
        "phone": "97142247451",
        "email": "nooradvo@eim.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "09f7be53-e98a-499b-a46b-3635ebba9c54",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1806",
    "licenseIssueDate": "06/02/2023 00:00:00",
    "licenseExpiryDate": "06/01/2026 00:00:00"
  },
  {
    "id": "c9b57bb4-f6d8-414f-922d-74946c126280",
    "slug": "khalid-ali-nasser-jamhour-al-ahbabi",
    "name": "KHALED ALI NASSER MANEA JAMHOUR",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/02/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Khalid Ali Nasser Jamhour Al Ahbabi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c9b57bb4-f6d8-414f-922d-74946c126280",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-987",
    "licenseIssueDate": "02/04/2015 00:00:00",
    "licenseExpiryDate": "02/03/2026 00:00:00"
  },
  {
    "id": "d9de8899-1017-4f5f-a665-b825d4e6d29f",
    "slug": "khalid-atiq-ali-meshwat-almarri",
    "name": "KHALID ATIQ ALI MISHWAT ALMARI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/03/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Khalid Atiq Ali Meshwat Almarri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d9de8899-1017-4f5f-a665-b825d4e6d29f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1267",
    "licenseIssueDate": "03/13/2018 00:00:00",
    "licenseExpiryDate": "03/12/2026 00:00:00"
  },
  {
    "id": "06203dc4-be3a-4bd7-8eb2-dc46aea71ece",
    "slug": "khalid-essa-mohammad-abdulaziz-alyassi",
    "name": "ABDULLA MOHAMMED SALEM HMOUDA ALNUAIMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/05/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Khalid Essa Mohammad Abdulaziz Alyassi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_06203dc4-be3a-4bd7-8eb2-dc46aea71ece",
        "address": "",
        "phone": "97145911811 / 971506137373",
        "email": "info@advoalhadhrami.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "52d0e50e-9741-4720-8ae1-7de3cbda373d",
    "firmName": "ABDULLA ALNUAIMI ADVOCATES &LEGAL CONSULTANTS",
    "registrationNumber": "L-1668",
    "licenseIssueDate": "06/26/2022 00:00:00",
    "licenseExpiryDate": "06/25/2026 00:00:00"
  },
  {
    "id": "c4aca724-ac6b-4571-825d-038e0ae57b02",
    "slug": "khalid-hassan-saleh-hassan-almarzooqi",
    "name": "KHALID HASSAN SALEH HASSAN ALMARZOOQI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/08/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: khalid hassan saleh hassan almarzooqi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c4aca724-ac6b-4571-825d-038e0ae57b02",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-2131",
    "licenseIssueDate": "08/19/2025 00:00:00",
    "licenseExpiryDate": "08/18/2026 00:00:00"
  },
  {
    "id": "fabc2a99-12cd-4cb0-b3fe-ac70fd73b4e6",
    "slug": "khalid-ismail-abdulaziz-mohamed-alzarooni",
    "name": "KHALID ISMAIL ABDULAZIZ MOHD ALZAROONI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/03/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Khalid Ismail Abdulaziz Mohamed Alzarooni",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fabc2a99-12cd-4cb0-b3fe-ac70fd73b4e6",
        "address": "الرابع /412 ,مركز سلطان للأعمال  ,لامسى بلازا  ,97916 ,Dubai",
        "phone": "97144533568 / 971502744454",
        "email": "khalid.alzarooniadvocate@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "252ab43e-3522-46a6-b674-822fde821536",
    "firmName": "KHALID ALZAROONI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-798",
    "licenseIssueDate": "03/18/2012 00:00:00",
    "licenseExpiryDate": "03/17/2026 00:00:00"
  },
  {
    "id": "a60d7f6f-da31-40f4-b70b-cc647f8c8f71",
    "slug": "khalid-juma-abdulla-mohamed-alsuwaidi",
    "name": "HATEM SAEED SALEM KHAMIS ALSHAMSI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/06/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Khalid Juma Abdulla Mohamed Alsuwaidi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a60d7f6f-da31-40f4-b70b-cc647f8c8f71",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1675",
    "licenseIssueDate": "07/05/2022 00:00:00",
    "licenseExpiryDate": "07/04/2026 00:00:00"
  },
  {
    "id": "c1ee86de-5dd4-48f7-abc1-2bb71ffd5562",
    "slug": "khalid-kalander-abdalla-hussain-almazzmi",
    "name": "KHALID KALANDAR ABDALLA HUSSAIN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/01/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Khalid Kalander Abdalla Hussain Almazzmi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c1ee86de-5dd4-48f7-abc1-2bb71ffd5562",
        "address": "",
        "phone": "97142942616",
        "email": "info@ilofficeuae.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "48ef4874-8647-4fb6-bedd-ffbad25accd1",
    "firmName": "KHALID KALANDAR ALMAAZMI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-790",
    "licenseIssueDate": "01/31/2012 00:00:00",
    "licenseExpiryDate": "01/30/2026 00:00:00"
  },
  {
    "id": "2f3b96c9-3b2d-4be4-b736-b8f4b383b4b1",
    "slug": "khalid-khalifa-mohammed-saif-hathboor",
    "name": "KHALID KHALIFA MOHD SAIF HATHBOOR",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/08/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Khalid Khalifa Mohammed Saif Hathboor",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2f3b96c9-3b2d-4be4-b736-b8f4b383b4b1",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1108",
    "licenseIssueDate": "09/01/2016 00:00:00",
    "licenseExpiryDate": "08/31/2026 00:00:00"
  },
  {
    "id": "89b85f0e-08a5-48cd-98b4-fd2138b344f4",
    "slug": "khalid-mohamed-abdulla-saeed-alzaabi",
    "name": "KHALID MOHAMED ABDALLA SAEED ALZAABI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/05/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Khalid Mohamed Abdulla Saeed Alzaabi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_89b85f0e-08a5-48cd-98b4-fd2138b344f4",
        "address": "304 ,Ithraa Building ,Emirates Aviation Academy Street / In front of Al Garhoud Mosque ,0000 ,Dubai",
        "phone": "97148323133",
        "email": "khalidalzaabiadvocates@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "83a1e95e-0701-4150-9f11-a92aa75b5939",
    "firmName": "KHALID ALZAABI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-1191",
    "licenseIssueDate": "05/21/2017 00:00:00",
    "licenseExpiryDate": "05/20/2026 00:00:00"
  },
  {
    "id": "ab03dd92-7892-45ec-bd7c-5339241bdc22",
    "slug": "khalid-mohamed-galloum-abdulla-robari",
    "name": "KHALID MOHAMED GHULOUM ABDALLA ROBARI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/04/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Khalid Mohamed Galloum Abdulla Robari",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ab03dd92-7892-45ec-bd7c-5339241bdc22",
        "address": "الطابق 33/ الوحدة : 3304 ,مبني المنارة /   الطابق 33/ الوحدة : 3304 ,فندق جي دبليو ماركيز  ,24002 ,Dubai",
        "phone": "97144254373",
        "email": "info@wkadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "332a3a67-50f2-424a-a5c1-d5abaf9a030b",
    "firmName": "WALEED ALMARZOOQI AND KHALID MOHAMED ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-802",
    "licenseIssueDate": "04/18/2012 00:00:00",
    "licenseExpiryDate": "04/17/2026 00:00:00"
  },
  {
    "id": "fa8b7709-8b23-4b26-ac4b-277204a64e19",
    "slug": "khalid-mohammad-abdul-rahman-al-qassimi",
    "name": "KHALID MOHAMMAD ABDULRAHMAN ALQASSIMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 22,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/12/2002",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: khalid Mohammad Abdul Rahman Al Qassimi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fa8b7709-8b23-4b26-ac4b-277204a64e19",
        "address": "6 ,latifa tower ,near crown plaza hotel  ,102999 ,Dubai",
        "phone": "97143799979",
        "email": "lawkmq@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "b9d24779-27c2-4989-bf7f-4e73e5a670ff",
    "firmName": "KHALID BIN MOHAMMAD ALQASEMI ATTORNEY & LEGAL CONSULTANTS",
    "registrationNumber": "L-439",
    "licenseIssueDate": "12/31/2002 00:00:00",
    "licenseExpiryDate": "12/30/2025 00:00:00"
  },
  {
    "id": "02301b6e-beca-4af6-9ec5-6f140cfb4664",
    "slug": "khalid-mohammad-abdulraheem-banar-al-awadi",
    "name": "KHALID MOHAMMAD ABDULRAHIM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Commercial Transactions-Bankruptcy",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Personal Status-Legacies and Inheritance",
      "Commercial Transactions-Commercial Companies",
      "Civil Transactions-Compensation",
      "Criminal Law-Crimes against properties"
    ],
    "experience": 26,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/11/1998",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Khalid Mohammad AbdulRaheem Banar Al Awadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_02301b6e-beca-4af6-9ec5-6f140cfb4664",
        "address": "الطابق الخامس ,الساحة ,سوق البحار ,26011 ,Dubai",
        "phone": "97142277717",
        "email": "info@alsahlawico.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "a6811a79-5470-4c33-ad95-3ff8f661c052",
    "firmName": "AL SAHLAWI & CO ADVOCATES & CONSULTANTS",
    "registrationNumber": "L-345",
    "licenseIssueDate": "11/17/1998 00:00:00",
    "licenseExpiryDate": "11/16/2025 00:00:00"
  },
  {
    "id": "4ae2cfc5-7013-4ccb-bad2-053e06a39cc1",
    "slug": "khalid-mohammad-ahmad-muhanna-al-suwaidi",
    "name": "KHALID MOHAMMAD AHMAD MUHANNA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/01/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Khalid Mohammad Ahmad Muhanna Al Suwaidi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4ae2cfc5-7013-4ccb-bad2-053e06a39cc1",
        "address": "",
        "phone": "97142429499 / 97142429499",
        "email": "k.alsuwaidi@kmsadvocate.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "6a3b5690-6f16-4367-9122-6c2a585fb92d",
    "firmName": "KHALID ALSUWADI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-983",
    "licenseIssueDate": "01/19/2015 00:00:00",
    "licenseExpiryDate": "01/18/2026 00:00:00"
  },
  {
    "id": "85cd01f3-94ef-448c-ae47-de1b7f705a61",
    "slug": "khalid-mohammad-saeed-bu-jsaim",
    "name": "KHALID MOHAMMED SAEED BUJSAIM ALFALASI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 28,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/10/1997",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Khalid Mohammad Saeed Bu Jsaim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_85cd01f3-94ef-448c-ae47-de1b7f705a61",
        "address": "Unit No. 509-8,  ,Apricot Tower ,Dubai Silicon Oasis ,262 ,Dubai",
        "phone": "97143685555",
        "email": "info@bsabh.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "9ae2d0ab-41cc-421c-8579-e2f2b211ddf0",
    "firmName": "B S A AHMAD BIN HAZEEM & ASSOCIATES",
    "registrationNumber": "L-307",
    "licenseIssueDate": "10/04/1997 00:00:00",
    "licenseExpiryDate": "10/03/2026 00:00:00"
  },
  {
    "id": "abbb294a-825e-4210-a44d-e652279efa24",
    "slug": "khalid-mohammed-abdulla-alsarookh",
    "name": "KHALID MOHD ABDULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/11/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Khalid Mohammed Abdulla Alsarookh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_abbb294a-825e-4210-a44d-e652279efa24",
        "address": "",
        "phone": "97143304477 / 97143304477",
        "email": "admin@os-legal.net",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "1c406a06-cff7-4412-89fa-f6e5d9b647c0",
    "firmName": "KHALID ALSAROOKH ADVOCATES AND LEGAL CONSUTANCY",
    "registrationNumber": "L-1128",
    "licenseIssueDate": "11/29/2016 00:00:00",
    "licenseExpiryDate": "11/28/2025 00:00:00"
  },
  {
    "id": "1383a277-0c28-408a-9be4-007f243e535f",
    "slug": "khalid-ramadan-darwish-mohamad-alhosani",
    "name": "FATIMA KHALIFA MOHAMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/03/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Khalid Ramadan Darwish Mohamad Alhosani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1383a277-0c28-408a-9be4-007f243e535f",
        "address": "",
        "phone": "97142566628 / 971508908030",
        "email": "info@halmaazmilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "b0870ce2-bb48-4fd6-84c4-b053eeef75bd",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-2084",
    "licenseIssueDate": "04/07/2025 00:00:00",
    "licenseExpiryDate": "04/06/2026 00:00:00"
  },
  {
    "id": "76a9ff5e-c766-4b9f-bc11-33255b2e634d",
    "slug": "khalid-rashed-essa-rashed-alhamrani",
    "name": "KHALID RASHED ESSA RASHED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 24,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/03/2001",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Khalid Rashed Essa Rashed ALHamrani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_76a9ff5e-c766-4b9f-bc11-33255b2e634d",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-399",
    "licenseIssueDate": "03/13/2001 00:00:00",
    "licenseExpiryDate": "03/12/2026 00:00:00"
  },
  {
    "id": "a0934770-29bc-4d3c-b405-697dfc1de795",
    "slug": "khalid-sowaiket-mohamed-alhajeri",
    "name": "SARA ABDULRAHMAN ABDULHADI MAFRH AL AHBABI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/06/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: khalid sowaiket mohamed alhajeri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a0934770-29bc-4d3c-b405-697dfc1de795",
        "address": "Juma Khalifa  ,Block A office A304 ,Saraya avenue  ,GGCO metro station  ,430055 ,Dubai",
        "phone": "97142229449 / 971508857744",
        "email": "Gov@jkuaeadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "59231a3a-5ffa-40a6-83b0-43ab2d1b68a1",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-2004",
    "licenseIssueDate": "07/22/2024 00:00:00",
    "licenseExpiryDate": "07/21/2026 00:00:00"
  },
  {
    "id": "62499812-b318-45e8-b4eb-2eb4c7b8b4c5",
    "slug": "khalifa-abdalla-bin-huwaidan-alketbi",
    "name": "Khalifa Abdalla Bin Huwaidan Alketbi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/25/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Khalifa Abdalla Bin Huwaidan Alketbi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_62499812-b318-45e8-b4eb-2eb4c7b8b4c5",
        "address": "",
        "phone": "97142555000",
        "email": "info@kha.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "0e4b9f0a-83fc-45c9-b0d3-f38013690624",
    "firmName": "KHALIFA BIN HUWAIDAN ALKETBI ADVOCATES & LEGA",
    "registrationNumber": "786",
    "licenseIssueDate": "12/25/2011 00:00:00",
    "licenseExpiryDate": "12/24/2025 00:00:00"
  },
  {
    "id": "4cabb2d6-1e74-4dcb-9efb-818e28856229",
    "slug": "khalifa-abdalla-mohamed-alkhatri",
    "name": "KHALIFA ABDALLA MOHAMED HASSAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/12/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: khalifa Abdalla Mohamed Alkhatri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4cabb2d6-1e74-4dcb-9efb-818e28856229",
        "address": "",
        "phone": "",
        "email": "info@khalifaadv.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "97d00ba6-5323-4b87-8fdb-6382334c3d16",
    "firmName": "KHAIFA ALKHATRI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1243",
    "licenseIssueDate": "12/21/2017 00:00:00",
    "licenseExpiryDate": "12/20/2025 00:00:00"
  },
  {
    "id": "dfd78ed4-4cdb-47fe-a183-c6bf6c125264",
    "slug": "khalifa-abdulla-mohammed-khalifa-al-maftool",
    "name": "KHALIFA ABDALLA MOHAMED KH ALMAFTOUL",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 37,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/01/1988",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Khalifa Abdulla Mohammed Khalifa Al-Maftool",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dfd78ed4-4cdb-47fe-a183-c6bf6c125264",
        "address": "next level restaurant  , centurion star - block B - office 806 & 807 ,behind day to day - opposite deira city center ,237766 ,Dubai",
        "phone": "97142622002",
        "email": "info@almaftool-advocate.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "bc6598b4-c5d3-4280-b29d-4c3c132c3a21",
    "firmName": "KHALIFA AL MAFTOOL ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-179",
    "licenseIssueDate": "01/20/1988 00:00:00",
    "licenseExpiryDate": "01/19/2026 00:00:00"
  },
  {
    "id": "28ae5246-7aae-4f14-8d12-6bb199d55e1f",
    "slug": "khalifa-abdulrahman-sayed-ibrahim-sayed-khalifa-alsada",
    "name": "KHALIFA ABDULRAHMAN SAYED IBRAHIM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/10/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Khalifa Abdulrahman Sayed Ibrahim Sayed Khalifa Alsada",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_28ae5246-7aae-4f14-8d12-6bb199d55e1f",
        "address": "Third Floor - Office 310 ,Oud Metha Offices ,DEWA ,49408 ,Dubai",
        "phone": "97143245444",
        "email": "bahradvt@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "a462d9d5-41a1-490a-b3a2-1aafb1963331",
    "firmName": "KHALIFA ALSADA ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-1124",
    "licenseIssueDate": "10/27/2016 00:00:00",
    "licenseExpiryDate": "10/26/2025 00:00:00"
  },
  {
    "id": "9d4aade2-d4b5-4cc7-9eb1-c991e878af1d",
    "slug": "khalifa-khalfan-salem-muftah-almansoori",
    "name": "KHALFAN SALEM MUFTAH",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/03/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Khalifa Khalfan Salem Muftah Almansoori",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9d4aade2-d4b5-4cc7-9eb1-c991e878af1d",
        "address": "",
        "phone": "97143333040 / 971000000000",
        "email": "info@ssm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "89bb61d6-b0b9-4316-8983-c9a88f94a1e8",
    "firmName": "SHAIKHA SAQER ALMANSOORI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1348",
    "licenseIssueDate": "03/13/2019 00:00:00",
    "licenseExpiryDate": "03/12/2026 00:00:00"
  },
  {
    "id": "8f1fb722-d447-4bcd-b5c4-ac5c874ca22f",
    "slug": "khalifa-mohamedabdulla-mohamed",
    "name": "EIMAN ABDULLA SAAD SALEM ALKHANBASHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/09/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: KHALIFA MOHAMEDABDULLA MOHAMED",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8f1fb722-d447-4bcd-b5c4-ac5c874ca22f",
        "address": "",
        "phone": "97100000000",
        "email": "dubai@ahlegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "eae5fb25-fd19-436c-8668-3ac309424db4",
    "firmName": "LUBNA MOOSA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-2028",
    "licenseIssueDate": "09/26/2024 00:00:00",
    "licenseExpiryDate": "09/25/2026 00:00:00"
  },
  {
    "id": "03a42449-7f8a-4c68-82a7-c3cec1dfd232",
    "slug": "khalifa-muhain-bakhit-mubarak-altunaiji",
    "name": "KHALIFA MUHAIN BAKHIT MUBARAK",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 15,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/08/2010",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Khalifa Muhain Bakhit Mubarak Altunaiji",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_03a42449-7f8a-4c68-82a7-c3cec1dfd232",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-721",
    "licenseIssueDate": "08/11/2010 00:00:00",
    "licenseExpiryDate": "08/10/2026 00:00:00"
  },
  {
    "id": "aed0314e-d2cc-4e04-826a-39e20406d78b",
    "slug": "khalifa-rashid-hassan-ahmed-al-salman",
    "name": "KHALIFA RASHID HASSAN ALSALMAN AL ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Criminal Law-Crimes against persons",
      "Criminal Law-Crimes against properties",
      "Criminal Law-Crimes against persons",
      "Criminal Law-Crimes against properties"
    ],
    "experience": 20,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/02/2005",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: khalifa Rashid Hassan Ahmed Al Salman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_aed0314e-d2cc-4e04-826a-39e20406d78b",
        "address": "2 ,BUSINESS AVENUE BUILDING ,NISSAN SHOWROOM  ,95230 ,Dubai",
        "phone": "97142999099",
        "email": "info@alsalmanadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "edc444ef-59f2-4e2d-ad83-413023ea6e33",
    "firmName": "ALSALMAN ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-511",
    "licenseIssueDate": "02/15/2005 00:00:00",
    "licenseExpiryDate": "02/14/2026 00:00:00"
  },
  {
    "id": "7eff8d3f-1497-468b-bafd-ba88a4700961",
    "slug": "khalifa-yousef-mohammed-ali-bin-omair",
    "name": "KHALIFA YOUSEF MOHAMED BIN OMAIR AL-ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 23,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/04/2002",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Khalifa Yousef Mohammed Ali Bin Omair",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7eff8d3f-1497-468b-bafd-ba88a4700961",
        "address": "4 ,Century 21 building ,al kabayel discount centre ,340781 ,Dubai",
        "phone": "97142417888 / 971562693277",
        "email": "dubai@khbinomair.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "34306e48-bd22-4b51-b883-2a538d4f1890",
    "firmName": "KHALIFA BIN OMAIR ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-422",
    "licenseIssueDate": "04/02/2002 00:00:00",
    "licenseExpiryDate": "04/01/2026 00:00:00"
  },
  {
    "id": "23dd39ad-48ad-43e4-a959-7f046ac292d0",
    "slug": "khalil-khadhar-ali-alabadi-al-mansoori",
    "name": "KHALIL KHADER ALI M A ALMANSOORI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/11/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Khalil Khadhar Ali Alabadi  Al-Mansoori",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_23dd39ad-48ad-43e4-a959-7f046ac292d0",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-293",
    "licenseIssueDate": "11/22/2017 00:00:00",
    "licenseExpiryDate": "11/21/2025 00:00:00"
  },
  {
    "id": "00699f60-7fa5-42ab-8559-41d683d3a41d",
    "slug": "khalil-mohamed-ahmed-saif-alhosany",
    "name": "KHALIL MOHAMED AHMED SAIF",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 17,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/03/2008",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Khalil Mohamed Ahmed Saif Alhosany",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_00699f60-7fa5-42ab-8559-41d683d3a41d",
        "address": "",
        "phone": "97142955545",
        "email": "dr.khalil.saif@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "ad9c6a3f-6399-462e-bfe9-cd1c41311c75",
    "firmName": "KHALIL BIN SAIF ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-570",
    "licenseIssueDate": "03/05/2008 00:00:00",
    "licenseExpiryDate": "03/04/2026 00:00:00"
  },
  {
    "id": "f63b6ec6-2f6f-43b1-8cd7-77b07547fc0a",
    "slug": "khaloud-mohammed-ahmed-alsaadi",
    "name": "IBRAHIM HASAN SALEM ALI ALHAMMADI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/03/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: KHALOUD MOHAMMED AHMED ALSAADI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f63b6ec6-2f6f-43b1-8cd7-77b07547fc0a",
        "address": "210 ,OPAL TOWER ,BURJ KHALIFA ,96044 ,Dubai",
        "phone": "97143889993",
        "email": "admin@alsaadi-advocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "8e611697-c589-4346-a3da-969764421cb6",
    "firmName": "IBRAHIM ALHAMMADI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-1645",
    "licenseIssueDate": "04/07/2022 00:00:00",
    "licenseExpiryDate": "04/06/2026 00:00:00"
  },
  {
    "id": "e7fff5f9-7244-497e-affb-3db1e171721b",
    "slug": "khamis-rashed-khamis-almukhanini-aljneibi",
    "name": "ABDULRAHMAN OBAID HUMAID RASHED SAIF",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/05/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Khamis Rashed Khamis Almukhanini AlJneibi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e7fff5f9-7244-497e-affb-3db1e171721b",
        "address": "Nawal Salem Saeed Salem ,508 ,S. I. T Tower ,SILICON OASIS ,0000 ,Dubai",
        "phone": "97145582139 / 971555425608",
        "email": "courts@nslawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "8d7ab4a5-3c4d-4fa5-a466-d525e2054af8",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1958",
    "licenseIssueDate": "05/10/2024 00:00:00",
    "licenseExpiryDate": "05/09/2026 00:00:00"
  },
  {
    "id": "134ab2ad-9abc-4b4e-88cc-a6fc4629c8f8",
    "slug": "khamis-salem-saeed-aldhaheri",
    "name": "KHAMIS SALEM SAEED MOHAMMED ALDHAHERI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/01/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Khamis Salem Saeed Aldhaheri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_134ab2ad-9abc-4b4e-88cc-a6fc4629c8f8",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1138",
    "licenseIssueDate": "01/04/2017 00:00:00",
    "licenseExpiryDate": "01/03/2026 00:00:00"
  },
  {
    "id": "ab5ce86c-0543-4624-84dc-6f2b46f08dd7",
    "slug": "khawla-ahmed-mohamed-dimas",
    "name": "khawla ahmed mohamed dimas",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/04/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-03-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: khawla ahmed mohamed dimas",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ab5ce86c-0543-4624-84dc-6f2b46f08dd7",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "1734",
    "licenseIssueDate": "01/04/2023 00:00:00",
    "licenseExpiryDate": "01/03/2026 00:00:00"
  },
  {
    "id": "d4a2accd-c77d-43b9-8edd-ad1cedd5d3f8",
    "slug": "khawla-mohammad-yahya-ismail-alblooshi",
    "name": "MAITHA HAMAD SAEED ALALAWI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/12/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: khawla mohammad yahya ismail alblooshi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d4a2accd-c77d-43b9-8edd-ad1cedd5d3f8",
        "address": "yousif alhammadi ,الخامس 513،514 ,بيزنس افينيو ,وكالة نيسان ,414145 ,Dubai",
        "phone": "97143307771",
        "email": "yousifadv@alhammadilegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "b2331b5f-91be-4205-ad5c-6af317f654a4",
    "firmName": "ABU BAKER SALEM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1903",
    "licenseIssueDate": "01/03/2024 00:00:00",
    "licenseExpiryDate": "01/02/2025 00:00:00"
  },
  {
    "id": "64e16992-3aeb-4b1a-abb5-fc6babcd637a",
    "slug": "khawla-saeed-mohammad-salem",
    "name": "KHAWLA SAEED MOHAMMAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Civil Transactions-Insurance",
      "Personal Status-Wills",
      "Civil Transactions-Construction and Contracts for Services",
      "Criminal Law-Family Crimes",
      "Personal Status-Custody & Alimony",
      "Commercial Transactions-Commercial Contracts",
      "Commercial Transactions-Commercial Real Estate",
      "Civil Transactions-Residential Real Estate",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Civil Transactions-Tenancy",
      "Personal Status-Legacies and Inheritance",
      "Commercial Transactions-Commercial Companies",
      "Commercial Transactions-Banking Operations",
      "Civil Transactions-Labor & Workers",
      "Civil Transactions-Sale",
      "Commercial Transactions-Sea and air freight",
      "Commercial Transactions-Consumer protection",
      "Personal Status-Marriage & Divorce",
      "Civil Transactions-Compensation",
      "Commercial Transactions-E-Commerce",
      "Commercial Transactions-Intellectual Property (includes trademarks",
      "copy rights",
      "patents)"
    ],
    "experience": 19,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/11/2005",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-11-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: khawla saeed mohammad salem",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_64e16992-3aeb-4b1a-abb5-fc6babcd637a",
        "address": "Khawla Saeed Mohammed Salem ,414 ,DBCS BUILDING ,محكمة الاحوال الشخصية ,73879 ,Dubai",
        "phone": "97143530354 / 971503787848",
        "email": "info@ksadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "e961ec37-b1f5-4b83-8382-639604c8fdaf",
    "firmName": "KHAWLA SAEED ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-533",
    "licenseIssueDate": "11/20/2005 00:00:00",
    "licenseExpiryDate": "11/19/2025 00:00:00"
  },
  {
    "id": "90cd97d7-fc78-429d-9884-ca37f5b51fcc",
    "slug": "khawla-saeed-mohammed-busais-alteneiji",
    "name": "Khawla Saeed Mohammed Busais ALteneiji",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/20/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Khawla Saeed Mohammed Busais ALteneiji",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_90cd97d7-fc78-429d-9884-ca37f5b51fcc",
        "address": "Office No. 908 ,Owned by ACICO Gulf Real Estate Building ,Makani No: 3250094543 ,000 ,Dubai",
        "phone": "97143377688 / 971502883999",
        "email": "info@rds-law.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "750060a5-046b-4af5-b4ba-46d9c547184a",
    "firmName": "RASHID DEEMAS ALSUWAIDI ADVOCATES & LEGAL CON",
    "registrationNumber": "2025",
    "licenseIssueDate": "09/20/2024 00:00:00",
    "licenseExpiryDate": "09/19/2026 00:00:00"
  },
  {
    "id": "4f4e8031-97cb-475c-835b-982837161b24",
    "slug": "khawla-thani-mohammad-saif-al-mahiri",
    "name": "KHAWLA THANI M. SAIF BUHOWAINI ALMHEIRI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/02/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Khawla Thani Mohammad Saif Al Mahiri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4f4e8031-97cb-475c-835b-982837161b24",
        "address": "Office No. 601 ,Business Avenue Building ,Behind Nissan Showroom, Makani No: 3248594620 ,000 ,Dubai",
        "phone": "97142369992 / 971503199393",
        "email": "info@almheiriadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "2fb2bd9b-adf2-48f2-a4d0-26aa52ed5e26",
    "firmName": "KHAWLA AL MHEIRI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1338",
    "licenseIssueDate": "02/05/2019 00:00:00",
    "licenseExpiryDate": "02/04/2026 00:00:00"
  },
  {
    "id": "4dce88dd-2f13-48b0-bb0a-6fadae4009b1",
    "slug": "khidir-ibrahim-khidir-ibrahim",
    "name": "KHIDIR IBRAHIM KHIDIR IBRAHIM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/05/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Khidir Ibrahim Khidir Ibrahim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4dce88dd-2f13-48b0-bb0a-6fadae4009b1",
        "address": "",
        "phone": "97143218833 / 971506563555",
        "email": "abmarjanadv@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "9c0c6c1b-d946-4437-a37d-6b795f15818e",
    "firmName": "ABDULRAZAQ MARJAN ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-943",
    "licenseIssueDate": "05/06/2014 00:00:00",
    "licenseExpiryDate": "05/05/2026 00:00:00"
  },
  {
    "id": "e8ac8e88-497e-4a75-a0e0-ce1f34fc5254",
    "slug": "khoula-rashid-murad-alblooshi",
    "name": "AMNA AHMAD W O A KARIM E JUMA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/11/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-11-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Khoula Rashid Murad Alblooshi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e8ac8e88-497e-4a75-a0e0-ce1f34fc5254",
        "address": "",
        "phone": "97143334404",
        "email": "info@ihadvo.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "da36558c-bfcb-4fbf-8416-f80643ccb280",
    "firmName": "ADVOCATES UNIT",
    "registrationNumber": "L-2046",
    "licenseIssueDate": "11/22/2024 00:00:00",
    "licenseExpiryDate": "11/21/2025 00:00:00"
  },
  {
    "id": "cc7f3dcc-930b-41bc-a681-70ff5fe167dd",
    "slug": "khulood-hamza-ibrahim-almallouhi",
    "name": "KHULOOD HAMZA IBRAHIM ALMALLOUHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/09/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Khulood Hamza Ibrahim Almallouhi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cc7f3dcc-930b-41bc-a681-70ff5fe167dd",
        "address": "Obaid Ishaq Ismail Al-Maazmi ,الطابق 21 ,ذا اكستشينج تاور  ,فندق جي دبليو ماريوت ماركي ,238365 ,Dubai",
        "phone": "97143584737",
        "email": "obaidotp@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "70a8fb70-2729-4348-b87b-258c7dc7a387",
    "firmName": "OBAID AL MAZIMI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-1562",
    "licenseIssueDate": "09/18/2021 00:00:00",
    "licenseExpiryDate": "09/17/2026 00:00:00"
  },
  {
    "id": "736303a1-eac3-45f9-8fe6-8d419e32115e",
    "slug": "khulood-khalfan-obaid-ali-alaleeli",
    "name": "NAHYAN EBRAHIM KHALIL EBRAHIM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/04/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Khulood Khalfan Obaid Ali Alaleeli",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_736303a1-eac3-45f9-8fe6-8d419e32115e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1949",
    "licenseIssueDate": "05/06/2024 00:00:00",
    "licenseExpiryDate": "05/05/2026 00:00:00"
  },
  {
    "id": "8bcb9a44-35ee-4ddd-8aa5-8b302751cebd",
    "slug": "khuloud-saeed-ali-al-ali",
    "name": "KHULOUD SAEED ALI SAEED AL ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Civil Transactions-Insurance",
      "Personal Status-Wills",
      "Civil Transactions-Construction and Contracts for Services",
      "Criminal Law-Family Crimes",
      "Personal Status-Custody & Alimony",
      "Commercial Transactions-Commercial Real Estate",
      "Civil Transactions-Residential Real Estate",
      "Civil Transactions-Tenancy",
      "Criminal Law-Crimes against persons",
      "Personal Status-Legacies and Inheritance",
      "Commercial Transactions-Banking Operations",
      "Civil Transactions-Labor & Workers",
      "Personal Status-Legal Capacity & Guardianship",
      "Criminal Law-Drug Crimes",
      "Civil Transactions-Sale",
      "Proceedings-Cases and Proceedings before arbitral tribunals and other alternative dispute resolution bodies",
      "Personal Status-Marriage & Divorce",
      "Personal Status-Child Abuse & Abduction",
      "Civil Transactions-Compensation",
      "Criminal Law-Crimes against properties",
      "Criminal Law-Cybercrimes",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/11/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Khuloud Saeed Ali Al Ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8bcb9a44-35ee-4ddd-8aa5-8b302751cebd",
        "address": "Mohamed Ibrahim amer ,25 ,Iris bay ,Business bay ,3939 ,Dubai",
        "phone": "97125520551",
        "email": "admin@khuloudsaeed.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "661fa52a-1fed-4a42-af84-3e1a7ba76603",
    "firmName": "KHULOUD SAEED ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-901",
    "licenseIssueDate": "11/25/2013 00:00:00",
    "licenseExpiryDate": "11/24/2025 00:00:00"
  },
  {
    "id": "4720494b-f42e-4f10-a6cd-18f7a6373e91",
    "slug": "laila-eissa-suliman-almahri",
    "name": "LAILA EISSA SULAIMAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/03/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Laila Eissa Suliman Almahri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4720494b-f42e-4f10-a6cd-18f7a6373e91",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1062",
    "licenseIssueDate": "03/24/2016 00:00:00",
    "licenseExpiryDate": "03/23/2026 00:00:00"
  },
  {
    "id": "95044529-e9f6-4a0a-83bd-62c59156a646",
    "slug": "laila-hamza-ismail-al-mulla",
    "name": "LAILA HAMZA W O AHMAD ABDULHAMID QASSEM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/02/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-02-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Laila Hamza Ismail Al Mulla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_95044529-e9f6-4a0a-83bd-62c59156a646",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-915",
    "licenseIssueDate": "02/11/2014 00:00:00",
    "licenseExpiryDate": "02/10/2026 00:00:00"
  },
  {
    "id": "eb7e9c62-61aa-4538-aabe-f813f2541ca9",
    "slug": "latifa-abdulmoneim-salem-bin-suwaidan-alsuwaidi",
    "name": "Latifa Abdulmoneim Salem Bin Suwaidan Alsuwaidi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/16/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Latifa Abdulmoneim Salem Bin Suwaidan Alsuwaidi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_eb7e9c62-61aa-4538-aabe-f813f2541ca9",
        "address": "4 ,ALHUDIBA AWARD COMPLEX BLOCK B ,UNION FLAG HOUSE ,50229 ,Dubai",
        "phone": "97143258888 / 971501009595",
        "email": "hr@binsowaidan.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "36d64a1b-4461-4159-9965-ed44c59d3e88",
    "firmName": "BIN SOWAIDAN ADVOCATES & LEGAL CONSULTANTCY",
    "registrationNumber": "1780",
    "licenseIssueDate": "03/16/2023 00:00:00",
    "licenseExpiryDate": "03/15/2026 00:00:00"
  },
  {
    "id": "e07ed353-f556-40d5-aec2-562cd7cbac77",
    "slug": "layla-mohammed-ahmed-touei",
    "name": "MOHAMMAD MUBARAK MOHAMMAD A ALJNEIBI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/10/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: LAYLA MOHAMMED AHMED TOUEI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e07ed353-f556-40d5-aec2-562cd7cbac77",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1752",
    "licenseIssueDate": "02/02/2023 00:00:00",
    "licenseExpiryDate": "02/01/2026 00:00:00"
  },
  {
    "id": "c3bf2f7c-dfe8-44e1-993a-0c5c7a23d834",
    "slug": "layla-saeed-abdulla-leqteri-alateibi",
    "name": "LAYLA SAEED ABDULLA AHMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/01/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Layla Saeed Abdulla Leqteri Alateibi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c3bf2f7c-dfe8-44e1-993a-0c5c7a23d834",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1497",
    "licenseIssueDate": "01/19/2021 00:00:00",
    "licenseExpiryDate": "01/18/2026 00:00:00"
  },
  {
    "id": "71700878-a330-4488-9ec5-b5448562d4cb",
    "slug": "loubna-walied-mohamed-tommalia",
    "name": "LOUBNA WALIED MOHAMED TOMMALIA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/12/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Loubna Walied Mohamed Tommalia",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_71700878-a330-4488-9ec5-b5448562d4cb",
        "address": "",
        "phone": "97100000000 / 971544444720",
        "email": "info@lwlawyers.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "a0cf1971-30cd-464c-b2a2-7f5f34200229",
    "firmName": "LOUBNA WALIED MOHAMED ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1327",
    "licenseIssueDate": "12/04/2018 00:00:00",
    "licenseExpiryDate": "12/03/2025 00:00:00"
  },
  {
    "id": "ed08e121-c973-4595-9bf5-cfddc6b08686",
    "slug": "lubna-moosa-rasheed-hatamleh",
    "name": "LUBNA MOOSA RASHEED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/12/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Lubna Moosa Rasheed Hatamleh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ed08e121-c973-4595-9bf5-cfddc6b08686",
        "address": "",
        "phone": "97145799599 / 971457995992",
        "email": "info@lmlegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "fed194c9-41cf-42f3-888e-924faa26b282",
    "firmName": "LUBNA MOOSA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1394",
    "licenseIssueDate": "12/04/2019 00:00:00",
    "licenseExpiryDate": "12/03/2025 00:00:00"
  },
  {
    "id": "960750c2-0ad7-47af-b0c7-6bf2b217a897",
    "slug": "madhheya-salem-kedairi-mohamed-almenhali",
    "name": "Madhheya Salem Kedairi Mohamed Almenhali",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/28/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Madhheya Salem Kedairi Mohamed Almenhali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_960750c2-0ad7-47af-b0c7-6bf2b217a897",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "1047",
    "licenseIssueDate": "01/28/2016 00:00:00",
    "licenseExpiryDate": "01/27/2026 00:00:00"
  },
  {
    "id": "b01999e1-3a5c-4a32-982d-697fb6211a5b",
    "slug": "maha-abdulla-mahmoud",
    "name": "SALAMA ALNUAIMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/01/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Maha Abdulla Mahmoud",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b01999e1-3a5c-4a32-982d-697fb6211a5b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1616",
    "licenseIssueDate": "01/26/2022 00:00:00",
    "licenseExpiryDate": "01/25/2026 00:00:00"
  },
  {
    "id": "a8bfc474-4aac-4b2a-ab55-a74fb9afcaf8",
    "slug": "maha-ali-ismail-ali-alfahim",
    "name": "MAHA ALI ISMAIL ALI ALFAHIM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/09/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Maha Ali Ismail Ali Alfahim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a8bfc474-4aac-4b2a-ab55-a74fb9afcaf8",
        "address": "",
        "phone": "97142805852 / 971528500681",
        "email": "info@alfahimadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "97346e41-f636-4b96-a028-acaddbef67e8",
    "firmName": "MAHA ALFAHIM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-951",
    "licenseIssueDate": "09/07/2015 00:00:00",
    "licenseExpiryDate": "09/06/2026 00:00:00"
  },
  {
    "id": "463509c9-5c8b-4411-a661-2c89fe087b0a",
    "slug": "maha-mohi-din-abdulkadir-ibrahim-bin-hendi",
    "name": "MAHA MOHI DIN ABDALKADIR I BIN HENDI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/01/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Maha Mohi Din Abdulkadir Ibrahim Bin Hendi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_463509c9-5c8b-4411-a661-2c89fe087b0a",
        "address": "",
        "phone": "97142405888",
        "email": "m.binhendi@mbhlawfirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "95d56953-378a-4ade-a995-fee8035a4699",
    "firmName": "MAHA BIN HENDI LAW FIRM",
    "registrationNumber": "L-913",
    "licenseIssueDate": "01/30/2014 00:00:00",
    "licenseExpiryDate": "01/29/2026 00:00:00"
  },
  {
    "id": "f77dc4b5-d7da-4e94-9f16-05003f87f82f",
    "slug": "maha-yousif-salim-malik-almansoori",
    "name": "Maha Yousif Salim Malik Almansoori",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/23/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Maha Yousif Salim Malik Almansoori",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f77dc4b5-d7da-4e94-9f16-05003f87f82f",
        "address": "4 - 449 ,Emarat Atrium ,Gulf News ,413533 ,Dubai",
        "phone": "97143211966",
        "email": "icalc@internationalcounsels.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "382198c6-5727-490a-963b-91b675ddc7bc",
    "firmName": "INTERNATIONAL COUNSELS ADVOCATES & LEGAL CONS",
    "registrationNumber": "1963",
    "licenseIssueDate": "05/23/2024 00:00:00",
    "licenseExpiryDate": "05/22/2026 00:00:00"
  },
  {
    "id": "20d0a086-84aa-4761-a1fa-33855a13481f",
    "slug": "mahbooba-baqer-hussain-azderi",
    "name": "FAWZIA MOHD SAIF",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/05/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mahbooba baqer Hussain Azderi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_20d0a086-84aa-4761-a1fa-33855a13481f",
        "address": "mansoor lootah ,مطعم شيلز ,صالح بن لاحج , مطعم شيلز  ,95151 ,Dubai",
        "phone": "97142833337 / 971559596445",
        "email": "info@mansoorlootahadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "4488ad94-e6b8-4b33-8e21-04e8986bf218",
    "firmName": "FAWZIA MOHAMMAD ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1657",
    "licenseIssueDate": "05/25/2022 00:00:00",
    "licenseExpiryDate": "05/24/2026 00:00:00"
  },
  {
    "id": "63454584-a3a0-49eb-9e57-90689db8a4fc",
    "slug": "mahmood-hussain-ali-ahmad",
    "name": "MAHMOOD HUSSAIN ALI AHMAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/05/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mahmood Hussain Ali Ahmad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_63454584-a3a0-49eb-9e57-90689db8a4fc",
        "address": "sohail jassem pararin ,34 ,Central Park Tower ,Dubai Mall ,233066 ,Dubai",
        "phone": "97144228410",
        "email": "info@mahmoodhussain.net",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "f3309481-3edd-4503-92d2-bd9f71ba513a",
    "firmName": "DR MAHMOOD HUSSAIN ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-808",
    "licenseIssueDate": "05/08/2012 00:00:00",
    "licenseExpiryDate": "05/07/2026 00:00:00"
  },
  {
    "id": "2da0df7b-7f53-478e-b3b2-2203b3f155de",
    "slug": "mahmood-ibraheim-abdulla-abdulkareim-haway",
    "name": "Mahmood Ibraheim Abdulla Abdulkareim Haway",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 39,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/19/1986 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mahmood Ibraheim Abdulla Abdulkareim Haway",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2da0df7b-7f53-478e-b3b2-2203b3f155de",
        "address": "",
        "phone": "97142868681",
        "email": "hawailaw@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "3f1d962a-159f-4d0f-82d0-ebd94930d6ae",
    "firmName": "LAW OFFICE OF MAHMOUD AL HAWAI ATTORNEYS &CON",
    "registrationNumber": "157",
    "licenseIssueDate": "02/19/1986 00:00:00",
    "licenseExpiryDate": "02/18/2026 00:00:00"
  },
  {
    "id": "2276d402-b998-4f80-8ab0-507e62ed4a9e",
    "slug": "mahmood-mohamed-jaber-mohamed-alali",
    "name": "MAHMOOD MOHAMED JABER MOHAMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/05/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mahmood Mohamed Jaber Mohamed Alali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2276d402-b998-4f80-8ab0-507e62ed4a9e",
        "address": "",
        "phone": "97140000000 / 971504404084",
        "email": "info@mjlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "3c72f5a1-f8c3-4098-84d7-7886d6ea0165",
    "firmName": "MAHMOOD BIN JABER ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1280",
    "licenseIssueDate": "05/09/2018 00:00:00",
    "licenseExpiryDate": "05/08/2026 00:00:00"
  },
  {
    "id": "1e34427d-6dd3-4923-9817-5bf6e3c65700",
    "slug": "mahmood-mohammed-abdulla-jamal-ahli",
    "name": "MAHMOOD MOHD ABDULLA MOHD JAMAL",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 37,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/01/1988",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mahmood Mohammed Abdulla Jamal Ahli",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1e34427d-6dd3-4923-9817-5bf6e3c65700",
        "address": "",
        "phone": "97143355577",
        "email": "daraladalah1991@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "61efd89c-1d0d-4136-8397-2814c745f0da",
    "firmName": "DAR AL ADALA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-176",
    "licenseIssueDate": "01/20/1988 00:00:00",
    "licenseExpiryDate": "01/19/2026 00:00:00"
  },
  {
    "id": "2d14623c-47b8-47b4-b077-2f44ca34771e",
    "slug": "mahmood-yousuf-abdulrahim-ahmad-alhammadi",
    "name": "RASHID ABDALLA HUMAID ALJARI ALKTEBI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/05/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mahmood Yousuf Abdulrahim Ahmad Alhammadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2d14623c-47b8-47b4-b077-2f44ca34771e",
        "address": "khadijah sohail hassan asaadi ,طابق الميزانيين  ,ايميجت  ,مترو الخليج التجاري  ,41342 ,Dubai",
        "phone": "97143438885",
        "email": "info@asaadi.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "264cfea6-1419-45d4-9264-7dba3f26da68",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1962",
    "licenseIssueDate": "05/21/2024 00:00:00",
    "licenseExpiryDate": "05/20/2026 00:00:00"
  },
  {
    "id": "a422e07b-b35d-443a-b6e8-0afdda48349b",
    "slug": "mahmoud-haggag-azab-abou-gareda",
    "name": "MAHMOUD HAGAG AZAB ABOUGERIDA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 19,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/06/2006",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: MAHMOUD HAGGAG AZAB ABOU GAREDA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a422e07b-b35d-443a-b6e8-0afdda48349b",
        "address": "",
        "phone": "97143212555",
        "email": "awigdubai@awiglaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "ece8ea60-9ecb-4d8c-aca3-fb73e4e52406",
    "firmName": "AL WASL INTERNATIONAL GROUP - ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-573",
    "licenseIssueDate": "06/06/2006 00:00:00",
    "licenseExpiryDate": "06/05/2026 00:00:00"
  },
  {
    "id": "1556310d-ba86-4d24-b429-bd7cf81d29c6",
    "slug": "mahra-abdulla-mohammad-belobaida-alsuwaidi",
    "name": "ABDULLA JUMAH SAAD A ALALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/05/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: mahra abdulla mohammad belobaida alsuwaidi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1556310d-ba86-4d24-b429-bd7cf81d29c6",
        "address": "HASSAN ALI MATAR ALRIYAMI ,24 ,GRASVENOR BUSINESS TOWER ,NEEDS SUPERMARKET ,215880 ,Dubai",
        "phone": "97144534188",
        "email": "courts@alriyamiadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "a40a2f1f-69a9-429c-8086-dba9d985532b",
    "firmName": "HAMDAN ALKAABI ADVOCATES & LEGAL CONSULTANS",
    "registrationNumber": "L-1658",
    "licenseIssueDate": "05/25/2022 00:00:00",
    "licenseExpiryDate": "05/24/2026 00:00:00"
  },
  {
    "id": "3b968532-a5bb-4d66-9ed1-4c89effcbd68",
    "slug": "mai-abdulrahman-nasib-binnasib-alfalasi",
    "name": "Mai Abdulrahman Nasib Binnasib Alfalasi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/01/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mai Abdulrahman Nasib Binnasib Alfalasi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3b968532-a5bb-4d66-9ed1-4c89effcbd68",
        "address": "MAI ALFALASI ADVOCATES AND LEGAL CONSULTANCY ,RECEPTION ,GREEN TOWER ,UNITED ARAB BANK ,93279 ,Dubai",
        "phone": "97142230666 / 97142230666",
        "email": "info@maaflegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "6845576a-b39d-45a5-a726-55d73bb5ee05",
    "firmName": "MAI ALFALASI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "1105",
    "licenseIssueDate": "09/01/2016 00:00:00",
    "licenseExpiryDate": "08/31/2026 00:00:00"
  },
  {
    "id": "acee6043-af2d-4e4e-8408-432a1c9e4e99",
    "slug": "maideid-maideid-mohamed-dhaen-almansoori",
    "name": "Maideid Maideid Mohamed Dhaen Almansoori",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/18/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Maideid Maideid Mohamed Dhaen Almansoori",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_acee6043-af2d-4e4e-8408-432a1c9e4e99",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "1678",
    "licenseIssueDate": "07/18/2022 00:00:00",
    "licenseExpiryDate": "07/17/2026 00:00:00"
  },
  {
    "id": "3eb4616b-37eb-40b6-909c-6fb56bd7bf1c",
    "slug": "maitha-abdulmunem-salem-binsuwaidan-alsuwaidi",
    "name": "SALEM SAEED MOHAMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/02/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-02-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Maitha Abdulmunem Salem Binsuwaidan Alsuwaidi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3eb4616b-37eb-40b6-909c-6fb56bd7bf1c",
        "address": "4 ,ALHUDIBA AWARD COMPLEX BLOCK B ,UNION FLAG HOUSE ,50229 ,Dubai",
        "phone": "97143258888 / 971501009595",
        "email": "hr@binsowaidan.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "36d64a1b-4461-4159-9965-ed44c59d3e88",
    "firmName": "AL JABRI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-2076",
    "licenseIssueDate": "04/06/2023 00:00:00",
    "licenseExpiryDate": "04/05/2026 00:00:00"
  },
  {
    "id": "0f351b7a-8df7-41f0-867a-9d7dd03039ff",
    "slug": "maitha-abdulrahman-nasib-bin-nasib-al-falasi",
    "name": "MAITHA ABDULRAHMAN NASIB BINNASIB ALFALASI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/06/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: maitha abdulrahman nasib bin nasib al falasi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0f351b7a-8df7-41f0-867a-9d7dd03039ff",
        "address": "",
        "phone": "97144472020",
        "email": "info@arnadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "e6573267-5872-48d8-add1-06a3deccf9e4",
    "firmName": "ABDUL RAHMAN NASEEB ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1544",
    "licenseIssueDate": "06/27/2021 00:00:00",
    "licenseExpiryDate": "06/26/2026 00:00:00"
  },
  {
    "id": "de1bf544-ac43-4946-8951-dc6ad394518e",
    "slug": "maitha-ali-khamis-mohammed-alhassani",
    "name": "IBTSAM HUSSAIN CHERAGHI MOEZABADI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/11/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Maitha Ali Khamis mohammed Alhassani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_de1bf544-ac43-4946-8951-dc6ad394518e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1893",
    "licenseIssueDate": "12/11/2023 00:00:00",
    "licenseExpiryDate": "12/10/2025 00:00:00"
  },
  {
    "id": "3dc7eb6a-438c-43e9-b234-9cb49d222e75",
    "slug": "maitha-hamad-saeed-alalawi",
    "name": "AYESHA MARWAN SAIF OBAID ALZAABI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/11/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-11-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Maitha Hamad Saeed Alalawi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3dc7eb6a-438c-43e9-b234-9cb49d222e75",
        "address": "6F 603, 605, 7F 704 ,Crystal Tower ,Dubai Mall ,117538 ,Dubai",
        "phone": "97146098700",
        "email": "pro@miolawfirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "417f90a1-03be-4dab-8eea-1bba7e16f536",
    "firmName": "NASSER YOUSUF ALKHAMIS ADVOCATES &LEGAL CONSULTANTS",
    "registrationNumber": "L-1895",
    "licenseIssueDate": "12/14/2023 00:00:00",
    "licenseExpiryDate": "12/13/2025 00:00:00"
  },
  {
    "id": "067218ae-2127-4a4b-9146-737f327fc626",
    "slug": "maitha-saeed-hamdan-bin-dalmook-al-falasi",
    "name": "MAITHA SAEED HAMDAN A A D ALFALASI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/10/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Maitha Saeed Hamdan Bin Dalmook Al Falasi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_067218ae-2127-4a4b-9146-737f327fc626",
        "address": "الطابق العاشر .. Tenth floor ,برج الحواي .. AL HAWAI TOWER  ,محطة مترو المركز المالي .. Financial Centre Metro Station  ,444091 ,Dubai",
        "phone": "97143393880 / 971554003333",
        "email": "info@maithadalmook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "1d8ed4ed-c950-4b53-ab18-fbbffbd29451",
    "firmName": "MAITHA DALMOOK ADVOCATES AND LEGAL CONSULTANCY",
    "registrationNumber": "L-1582",
    "licenseIssueDate": "10/27/2021 00:00:00",
    "licenseExpiryDate": "10/26/2025 00:00:00"
  },
  {
    "id": "c9444c94-75ad-44e3-89c6-31ef63ec96a0",
    "slug": "maitha-talib-khamis-alblooshi",
    "name": "MAITHA TALIB KHAMIS ALBALOOSHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/08/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Maitha Talib Khamis Alblooshi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c9444c94-75ad-44e3-89c6-31ef63ec96a0",
        "address": "",
        "phone": "97145539555",
        "email": "world-center@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "00c4764a-95da-417c-bdfc-8bafd4ff9fca",
    "firmName": "WORLD CENTER ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1442",
    "licenseIssueDate": "08/09/2020 00:00:00",
    "licenseExpiryDate": "08/08/2026 00:00:00"
  },
  {
    "id": "7bfe5084-9620-4940-9cfa-bacf05717323",
    "slug": "majed-abdulla-jumaa-mohamed-alhosani",
    "name": "IBRAHIM HASSAN ABDULRAHIM MOHD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/05/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Majed Abdulla Jumaa Mohamed Alhosani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7bfe5084-9620-4940-9cfa-bacf05717323",
        "address": "zayed saeed saif alshamsi ,الرابع مكتب رقم 414 ,قرية الاعمال ,بجانب دائرة التنمية الاقتصادية - دوار الساعة  ,6030 ,Dubai",
        "phone": "97142680800",
        "email": "info@zayedalshamsi.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "295c7198-77b4-4f9a-a4d2-bad9a78e074d",
    "firmName": "DR MOHAMED ALMUR ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-2101",
    "licenseIssueDate": "06/19/2025 00:00:00",
    "licenseExpiryDate": "06/18/2026 00:00:00"
  },
  {
    "id": "3ee7fb29-9046-48e5-a7cc-0ef143481bf7",
    "slug": "majed-fahad-ibrahim-alsabhan-alshimari",
    "name": "MAJED FAHAD IBRAHIM ALSABHAN ALSHIMMARI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/02/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Majed Fahad Ibrahim Alsabhan Alshimari",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3ee7fb29-9046-48e5-a7cc-0ef143481bf7",
        "address": "",
        "phone": "97143474007",
        "email": "info@alsabhanlegalgroup.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "c31ad0e5-b382-4c9a-9fab-8853b1330f6b",
    "firmName": "DR AL SABBHAN LEGAL GROUP&ASSOCLATES",
    "registrationNumber": "L-1147",
    "licenseIssueDate": "02/08/2017 00:00:00",
    "licenseExpiryDate": "02/07/2026 00:00:00"
  },
  {
    "id": "efead7eb-fd6d-4e53-8b06-c9d689c747c4",
    "slug": "majed-sultan-obaid-bin-weqaish-aldhaheri",
    "name": "MAJED SULTAN OBAID WEQAISH",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/07/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Majed Sultan Obaid Bin Weqaish Aldhaheri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_efead7eb-fd6d-4e53-8b06-c9d689c747c4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1371",
    "licenseIssueDate": "07/09/2019 00:00:00",
    "licenseExpiryDate": "07/08/2026 00:00:00"
  },
  {
    "id": "ca078085-6e4a-4b0f-a59d-5fbe9d8dc9ca",
    "slug": "majid-ahmed-mohammed-abdullah-aljassim",
    "name": "Majid Ahmed Mohammed Abdullah Aljassim",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/13/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Majid Ahmed Mohammed Abdullah Aljassim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ca078085-6e4a-4b0f-a59d-5fbe9d8dc9ca",
        "address": "",
        "phone": "97142212112",
        "email": "info@mjlaw.co",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "ac58d621-9c02-48ae-8edc-dcf1b34a893d",
    "firmName": "MAJID ALJASSIM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "1434",
    "licenseIssueDate": "07/13/2020 00:00:00",
    "licenseExpiryDate": "07/12/2026 00:00:00"
  },
  {
    "id": "3bdc7937-62d7-43cb-a114-2511a363ad16",
    "slug": "majid-asad-akbar-asad",
    "name": "MAJID ASAD AKBAR ASAD ALAMEERI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 19,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/04/2006",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: MAJID ASAD AKBAR ASAD",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3bdc7937-62d7-43cb-a114-2511a363ad16",
        "address": "الطابق الثامن  ,برج الجرج 1 ,دائرة الاراضي و الاملاك  ,9117 ,Dubai",
        "phone": "97143320004",
        "email": "info@hlootahlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "4ad67cb4-18b4-4417-9b6a-d23a9fb368fb",
    "firmName": "HUSSAIN LOOTAH & PARTNERS - ATTORNEYS & COUNSELLORS AT LAW",
    "registrationNumber": "L-559",
    "licenseIssueDate": "04/24/2006 00:00:00",
    "licenseExpiryDate": "04/23/2026 00:00:00"
  },
  {
    "id": "cf96a71f-889e-450e-8e90-63fdbc709998",
    "slug": "majid-hamad-saeed-hamad-alkalbani",
    "name": "MAJID HAMAD SAEED HAMAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/06/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Majid Hamad Saeed Hamad Alkalbani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cf96a71f-889e-450e-8e90-63fdbc709998",
        "address": "BLOCK B - OFFICE NO. 208 ,BUSHAQER Building ,Makani No: 3289393656 ,000 ,Dubai",
        "phone": "97142217010 / 971504993366",
        "email": "majidlawyer726@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "b380d172-f6fb-41f1-ad4f-0b8fa3c870fb",
    "firmName": "MAJID HAMAD AL KALBANI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1423",
    "licenseIssueDate": "06/20/2020 00:00:00",
    "licenseExpiryDate": "06/20/2026 00:00:00"
  },
  {
    "id": "a09249ab-66b8-4d2b-9029-d9c356732a7a",
    "slug": "majid-mohamed-abdulla-abdulla-alameri",
    "name": "MAJID MOHAMED ABDULLA ABDULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/08/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Majid Mohamed Abdulla Abdulla Alameri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a09249ab-66b8-4d2b-9029-d9c356732a7a",
        "address": "",
        "phone": "97142343373 / 971507004104",
        "email": "almansoorilawyer@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "19c9c654-e8a0-4ae8-b2e6-1f0b9dfac171",
    "firmName": "ABDULLA EBRAHIM ALMANSOORI LAWYERS AND LEGAL CONSULTANTS",
    "registrationNumber": "L-1696",
    "licenseIssueDate": "08/18/2022 00:00:00",
    "licenseExpiryDate": "08/17/2026 00:00:00"
  },
  {
    "id": "0636d419-2ad7-402f-a549-1019657b4fb5",
    "slug": "majid-mohammed-alshaikh-ahmad-bin-alshaikh-hassan-alkhazraji",
    "name": "MAJID MOHD ALSHAIKH AHMAD BIN SH HASSAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/09/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Majid Mohammed Alshaikh Ahmad Bin Alshaikh Hassan Alkhazraji",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0636d419-2ad7-402f-a549-1019657b4fb5",
        "address": "11 ,بناية صبحة ايفوري 2 ,ماما شيلتر أوتيل ,9598 ,Dubai",
        "phone": "97143880171 / 971565359809",
        "email": "malawyer@malawyer.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "da6588ae-fc3b-4a88-8a5e-7836becb47d2",
    "firmName": "MAJID ALSKAIKH ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-98",
    "licenseIssueDate": "09/26/2012 00:00:00",
    "licenseExpiryDate": "09/25/2026 00:00:00"
  },
  {
    "id": "739dfe12-208b-4050-96da-832b3c5dc969",
    "slug": "majid-saeed-hamad-aljallaf-alshuweihi",
    "name": "MAJID SAEED HAMAD ALJALLAF ALSHUWEIHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/08/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Majid Saeed Hamad Aljallaf Alshuweihi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_739dfe12-208b-4050-96da-832b3c5dc969",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-771",
    "licenseIssueDate": "08/22/2011 00:00:00",
    "licenseExpiryDate": "08/21/2026 00:00:00"
  },
  {
    "id": "ed4f665f-1837-4861-b760-3c4fa4d2568d",
    "slug": "makkawi-awadh-al-makkawi-ismail",
    "name": "MAKKAWI AWAD ELMAKKAWI ISMAIL ELMAKKAWI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 32,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/02/1993",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Makkawi Awadh Al-Makkawi Ismail",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ed4f665f-1837-4861-b760-3c4fa4d2568d",
        "address": "TWENTY ,ALMASRAF TOWER ,DUBAI MUNICIPALITY ,3858 ,Dubai",
        "phone": "97142222314",
        "email": "apxjuris@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "f8f827cb-389c-48f1-841e-a39afdd09f7d",
    "firmName": "APEX JURIS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-254",
    "licenseIssueDate": "02/21/1993 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "8ec5fb49-cafe-45db-a92f-c65763d9fb8f",
    "slug": "malek-ibrahim-hanounik",
    "name": "Malek Ibrahim Hanounik",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 20,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/01/2005 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2023-07-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Malek Ibrahim Hanounik",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8ec5fb49-cafe-45db-a92f-c65763d9fb8f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "523",
    "licenseIssueDate": "08/01/2005 00:00:00",
    "licenseExpiryDate": "07/31/2023 00:00:00"
  },
  {
    "id": "c0efe5dd-f64b-46da-aedd-05d92a8f2c22",
    "slug": "mana-ahmad-mohammad-ahmad",
    "name": "HIND SALEM HASSAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/06/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mana ahmad mohammad ahmad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c0efe5dd-f64b-46da-aedd-05d92a8f2c22",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1821",
    "licenseIssueDate": "06/28/2023 00:00:00",
    "licenseExpiryDate": "06/27/2026 00:00:00"
  },
  {
    "id": "ed5e177f-b27e-442d-b8f9-eb51a5d9dd17",
    "slug": "manal-abdulrahman-ibrahim",
    "name": "MANAL ABDULRAHMAN W O ALFADHEL ALMAQBOUL",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Manal Abdulrahman Ibrahim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ed5e177f-b27e-442d-b8f9-eb51a5d9dd17",
        "address": "الثامن مكتب 815 ,بزنس افينو  ,خلف وكالة نيسان  ,57134 ,Dubai",
        "phone": "97145463588",
        "email": "hisham@daralhekma.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "e9592d3b-4f5e-43bf-9305-f85447bc9653",
    "firmName": "DAR AL HEKMA LAWYERS & LEGAL CONSULTANCY",
    "registrationNumber": "L-1511",
    "licenseIssueDate": "03/01/2021 00:00:00",
    "licenseExpiryDate": "02/28/2026 00:00:00"
  },
  {
    "id": "36198fef-6b9b-42b1-85f0-2d60755493d4",
    "slug": "manar-saif-ali-almuslimani-alnaqbi",
    "name": "SAIF ALI SAIF ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/10/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Manar Saif Ali Almuslimani Alnaqbi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_36198fef-6b9b-42b1-85f0-2d60755493d4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1580",
    "licenseIssueDate": "10/14/2021 00:00:00",
    "licenseExpiryDate": "10/13/2026 00:00:00"
  },
  {
    "id": "4bdf2de0-2d07-4cb1-a85d-33f22c5ce615",
    "slug": "manawaha-saadeldin-merghani-hashim",
    "name": "MARYAM GHALEB SAEED BIN HAMMAD ALNUAIMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/09/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Manawaha Saadeldin Merghani Hashim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4bdf2de0-2d07-4cb1-a85d-33f22c5ce615",
        "address": "",
        "phone": "97142621293",
        "email": "manawaha369advocates@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "3348a745-bb42-4126-a65b-9c6cb87944af",
    "firmName": "AHMED MOHAMMED BASHIR ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1874",
    "licenseIssueDate": "10/12/2023 00:00:00",
    "licenseExpiryDate": "10/11/2026 00:00:00"
  },
  {
    "id": "82b5c6f8-d287-4c38-bc27-6a6676155fcc",
    "slug": "manea-mohammed-ahmed-mohammed-abdulla",
    "name": "MANEA MOHAMMED AHMED MOHAMMED ABDULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/06/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: manea mohammed ahmed mohammed abdulla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_82b5c6f8-d287-4c38-bc27-6a6676155fcc",
        "address": "",
        "phone": "97143588887",
        "email": "e.lawyersd@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "9aeb8716-ff23-4200-90de-c2e0ee86076e",
    "firmName": "MOHAMMED AHMED ADVOCATE & LEGEL CONSULTANTS",
    "registrationNumber": "L-1820",
    "licenseIssueDate": "06/17/2023 00:00:00",
    "licenseExpiryDate": "06/16/2026 00:00:00"
  },
  {
    "id": "70ec2b4d-f8b1-40d0-89e6-a872ca265b92",
    "slug": "manea-saeed-saif-hareb-almheiri",
    "name": "MANEA SAEED SAIF SAEED HAREB",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/11/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Manea Saeed Saif Hareb Almheiri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_70ec2b4d-f8b1-40d0-89e6-a872ca265b92",
        "address": "Dr. Ali Ismail Aljarman ,Roof Floor - Offices R03 & R04 ,MSM 1 Building ,Al Saffa First ,62639 ,Dubai",
        "phone": "97144393733",
        "email": "info@prestigeadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "22043b7f-55d2-4eb4-a173-3077ba390351",
    "firmName": "PRESTIGE ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1272",
    "licenseIssueDate": "11/25/2019 00:00:00",
    "licenseExpiryDate": "11/24/2025 00:00:00"
  },
  {
    "id": "a8909096-5482-47ac-8e82-d3a6af6012d8",
    "slug": "mansoor-abdulla-mohammad-albastaki",
    "name": "Mansoor Abdulla Mohammad Albastaki",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/08/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mansoor Abdulla Mohammad Albastaki",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a8909096-5482-47ac-8e82-d3a6af6012d8",
        "address": "Bader Aljassmy ,3 ,دبي كوميرسيتي ,دبي كوميرسيتي ,410004 ,Dubai",
        "phone": "97148760777 / 971586842086",
        "email": "info@bajlegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "7e820dd9-2748-4876-88db-ff7948542895",
    "firmName": "AL BASTAKI & Al JASMI ADVOCATES & LEGAL CONSU",
    "registrationNumber": "1450",
    "licenseIssueDate": "09/08/2020 00:00:00",
    "licenseExpiryDate": "09/07/2026 00:00:00"
  },
  {
    "id": "77689d05-a4ff-4f61-9020-70682b5d77e4",
    "slug": "mansoor-abdulla-mohd-ahmed",
    "name": "MANSOOR ABDULLA MOHD AHMAD ALZAROONI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 15,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/12/2009",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: MANSOOR ABDULLA MOHD AHMED",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_77689d05-a4ff-4f61-9020-70682b5d77e4",
        "address": "",
        "phone": "97142515101",
        "email": "legal@alinsaf.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "2176cd73-0d8d-41e1-9db6-ab2d6fa210b5",
    "firmName": "AL INSAF ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-691",
    "licenseIssueDate": "12/27/2009 00:00:00",
    "licenseExpiryDate": "12/26/2025 00:00:00"
  },
  {
    "id": "be880594-138a-460f-a7dc-e62fc2d52272",
    "slug": "mansoor-essa-ibraheim-lootah",
    "name": "MANSOOR ESSA EBRAHIM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 22,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/11/2002",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mansoor Essa Ibraheim Lootah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_be880594-138a-460f-a7dc-e62fc2d52272",
        "address": "mansoor lootah ,مطعم شيلز ,صالح بن لاحج , مطعم شيلز  ,95151 ,Dubai",
        "phone": "97142833337 / 971559596445",
        "email": "info@mansoorlootahadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "4488ad94-e6b8-4b33-8e21-04e8986bf218",
    "firmName": "MANSOOR LOOTAH ADVOCATES &LEGAL CONSULTANCY",
    "registrationNumber": "L-438",
    "licenseIssueDate": "11/18/2002 00:00:00",
    "licenseExpiryDate": "11/17/2025 00:00:00"
  },
  {
    "id": "7c2ea603-cca1-4c46-ba1e-c5274de3a99a",
    "slug": "mansoor-fehaid-saeed-alharthi",
    "name": "MANSOOR FEHAID SAEED ALHARTHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/06/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: MANSOOR FEHAID SAEED ALHARTHI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7c2ea603-cca1-4c46-ba1e-c5274de3a99a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1537",
    "licenseIssueDate": "06/21/2021 00:00:00",
    "licenseExpiryDate": "06/20/2026 00:00:00"
  },
  {
    "id": "b9bc6620-7e49-4e90-aa91-f34f4d51aac2",
    "slug": "mansoor-juma-mohammed-butweel-almatrooshi",
    "name": "mansoor juma mohammed Butweel Almatrooshi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/07/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: mansoor juma mohammed Butweel Almatrooshi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b9bc6620-7e49-4e90-aa91-f34f4d51aac2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "1924",
    "licenseIssueDate": "03/07/2024 00:00:00",
    "licenseExpiryDate": "03/06/2026 00:00:00"
  },
  {
    "id": "1c708ad3-4219-4289-bf71-9d45a7764f34",
    "slug": "mansoor-mohammed-ali-mmohammed-alkamali",
    "name": "MOHAMMAD ALI MOHAMMAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/10/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mansoor Mohammed Ali Mmohammed Alkamali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1c708ad3-4219-4289-bf71-9d45a7764f34",
        "address": "Hussain Ali Al Jaziri ,11 ,City Tower 2 ,Crown Plaza hotel Sheikh Zayed Road ,4253 ,Dubai",
        "phone": "97142626777 / 971529087670",
        "email": "courts@jaflaws.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "c58d8654-b428-46b3-abd5-024e4331ee53",
    "firmName": "JAAFAR ALWAN & AL JAZIRI & ASSOCIATES",
    "registrationNumber": "L-1056",
    "licenseIssueDate": "10/18/2018 00:00:00",
    "licenseExpiryDate": "10/17/2026 00:00:00"
  },
  {
    "id": "d9750e2d-4b05-4d32-8f19-42d4905ca479",
    "slug": "mansoor-mohd-murad-murad-mohd-al-mazmi",
    "name": "MANSOOR MOHD MURAD MOHD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 17,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/05/2008",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mansoor Mohd Murad Murad Mohd Al Mazmi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d9750e2d-4b05-4d32-8f19-42d4905ca479",
        "address": "4th Floor – offices 408 - 411 - 412 ,Business Village Building  - Block B ,Near Clock Tower ,49425 ,Dubai",
        "phone": "97143869999 / 971506446650",
        "email": "advocates@binmeshar.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "d4ea63a4-952e-4374-a9df-97a521bb4cd5",
    "firmName": "BIN MESHAR & CO ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-631",
    "licenseIssueDate": "05/27/2008 00:00:00",
    "licenseExpiryDate": "05/26/2026 00:00:00"
  },
  {
    "id": "280fc82e-c4ac-4428-8873-8c9f9ff2d8a2",
    "slug": "mansour-abdulqader-ali-mohmmed-mahmoud",
    "name": "MANSOUR ABDULQADER ALI MOHAMMED MAHMOUD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/10/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mansour Abdulqader Ali Mohmmed Mahmoud",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_280fc82e-c4ac-4428-8873-8c9f9ff2d8a2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1461",
    "licenseIssueDate": "10/07/2020 00:00:00",
    "licenseExpiryDate": "10/06/2026 00:00:00"
  },
  {
    "id": "69a69812-6971-4db1-9bea-bbda28c852bc",
    "slug": "mariam-ahmed-ali-abdulla-alshamsi",
    "name": "MARIAM AHMED ALI ABDULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/01/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mariam Ahmed Ali Abdulla AlShamsi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_69a69812-6971-4db1-9bea-bbda28c852bc",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1331",
    "licenseIssueDate": "01/02/2019 00:00:00",
    "licenseExpiryDate": "01/01/2026 00:00:00"
  },
  {
    "id": "0d04a02a-2c92-4b56-95b7-d92a19d8fede",
    "slug": "mariam-ahmed-salem-musallem-almuharrami",
    "name": "AHMED SALEM MUSALLEM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/02/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mariam Ahmed Salem Musallem Almuharrami",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0d04a02a-2c92-4b56-95b7-d92a19d8fede",
        "address": "talal  ,2TH FLOOR ,AL ETIHAD BUILDING  ,DEIRA CITY CENTRE ,1111 ,Dubai",
        "phone": "97142236999 / 97142236999",
        "email": "mariamahmedadvocate@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "a2e703c0-b558-4d8f-9bd3-c77475c407b1",
    "firmName": "MARIAM AHMED SALEM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1149",
    "licenseIssueDate": "02/15/2017 00:00:00",
    "licenseExpiryDate": "02/14/2026 00:00:00"
  },
  {
    "id": "b7c2e99e-41d1-4a3c-820c-cb01b8d46ae8",
    "slug": "mariam-ali-abdulla-mohammed-alblooshi",
    "name": "MARIAM ALI ABDULLA MOHAMMED ALBLOOSHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/10/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: mariam ali abdulla mohammed alblooshi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b7c2e99e-41d1-4a3c-820c-cb01b8d46ae8",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1465",
    "licenseIssueDate": "10/22/2020 00:00:00",
    "licenseExpiryDate": "10/21/2026 00:00:00"
  },
  {
    "id": "f2c87677-f372-4364-aa82-29464ffedfaa",
    "slug": "mariam-ali-mubarak-hamid-aldarmaky",
    "name": "AIL MUBARAK KAIDI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/09/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: MARIAM ALI MUBARAK HAMID ALDARMAKY",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f2c87677-f372-4364-aa82-29464ffedfaa",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1563",
    "licenseIssueDate": "09/19/2021 00:00:00",
    "licenseExpiryDate": "09/18/2026 00:00:00"
  },
  {
    "id": "7ed53f84-a79f-4365-99ed-08122a8ff597",
    "slug": "mariam-eisa-ali-eisa-alshamsi",
    "name": "MARIAM EISA ALI EISA ALSHAMSI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/03/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mariam Eisa Ali Eisa ALshamsi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7ed53f84-a79f-4365-99ed-08122a8ff597",
        "address": "",
        "phone": "97142554421",
        "email": "mariam.alshamsi@triumphco.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "0a80a9dd-7ded-4752-af6a-4444111bc177",
    "firmName": "MARIAM AL SHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1416",
    "licenseIssueDate": "03/08/2020 00:00:00",
    "licenseExpiryDate": "03/07/2026 00:00:00"
  },
  {
    "id": "f6e6c78b-b418-4a30-ac8f-c789fc568898",
    "slug": "mariam-ibrahim-ghloom-ali-robar",
    "name": "MOHAMMED HASSAN YOUSEF HATEM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/04/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: MARIAM IBRAHIM GHLOOM ALI ROBAR",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f6e6c78b-b418-4a30-ac8f-c789fc568898",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1798",
    "licenseIssueDate": "05/11/2023 00:00:00",
    "licenseExpiryDate": "05/10/2026 00:00:00"
  },
  {
    "id": "aa32a33c-dbff-4b81-a73c-7ea7a6dd6f1a",
    "slug": "mariam-ibrahim-mohamed-ali-alameri",
    "name": "IBRAHIM MOHAMED ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/11/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mariam Ibrahim Mohamed Ali Alameri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_aa32a33c-dbff-4b81-a73c-7ea7a6dd6f1a",
        "address": "",
        "phone": "",
        "email": "info@mariamalameri.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "2aa8bbb5-b5ae-454c-82c6-6ea027e24908",
    "firmName": "MARIAM IBRAHIM ALAMERI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1233",
    "licenseIssueDate": "11/02/2017 00:00:00",
    "licenseExpiryDate": "11/01/2025 00:00:00"
  },
  {
    "id": "cd131b7b-7246-4d22-8d77-e23dac764322",
    "slug": "mariam-jumaa-ibrahim-mohamed-alhammadi",
    "name": "SALMA SAEED MOHAMMED ALBAKR ALZAABI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/03/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: mariam jumaa ibrahim mohamed alhammadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cd131b7b-7246-4d22-8d77-e23dac764322",
        "address": "",
        "phone": "97145148832 / 971502061303",
        "email": "dxbcourts@nhadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "bf5657d9-ea57-4099-89ca-c51bd6c1c641",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1643",
    "licenseIssueDate": "04/04/2022 00:00:00",
    "licenseExpiryDate": "04/03/2026 00:00:00"
  },
  {
    "id": "d408ec4f-ff7d-4604-af32-2cad160780be",
    "slug": "mariam-khamis-ahmed-khamis-ashtiri",
    "name": "MARIAM KHAMIS AHMED KHAMIS ASHTIRI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/09/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: mariam khamis ahmed khamis ashtiri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d408ec4f-ff7d-4604-af32-2cad160780be",
        "address": "",
        "phone": "97100000000",
        "email": "dubai@ahlegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "eae5fb25-fd19-436c-8668-3ac309424db4",
    "firmName": "ALI HABIB ADVOCATES AND LEGAL CONSULTANCY",
    "registrationNumber": "L-1455",
    "licenseIssueDate": "09/29/2020 00:00:00",
    "licenseExpiryDate": "09/28/2026 00:00:00"
  },
  {
    "id": "80b01f8b-a843-4249-b639-95e659eb4cd8",
    "slug": "mariam-mohamed-ali-alhudouri-alhmoudi",
    "name": "MOHAMED ALI SAEED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/11/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-11-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mariam Mohamed Ali Alhudouri Alhmoudi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_80b01f8b-a843-4249-b639-95e659eb4cd8",
        "address": "dalmook mohamed bin dalmook ,التاسع - مكتب 901 ,الشركة الوطنية للتأمينات العامة NGI ,مقابل سيتي سنتر ديرة بجوار سندس سويتس مريديان وفلورا كريك هوتيل ,3467 ,Dubai",
        "phone": "97142989222 / 971506455800",
        "email": "information@dalmook.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "564fc438-ce0f-40b0-9dc2-c01709da9e46",
    "firmName": "DALMOOK MOHAMMED DALMOOK ADVOCATE & LEGAL CONSULTANCY",
    "registrationNumber": "L-1037",
    "licenseIssueDate": "11/30/2015 00:00:00",
    "licenseExpiryDate": "11/29/2025 00:00:00"
  },
  {
    "id": "0590bb4a-367b-4542-be4a-1958710938c8",
    "slug": "mariam-mohamed-khalfan-hassan-alteneji",
    "name": "MARIAM MOHAMED KHALFAN HASSAN ALTENEIJI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/05/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mariam Mohamed Khalfan Hassan Alteneji",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0590bb4a-367b-4542-be4a-1958710938c8",
        "address": "901-902 ,برج السلام ,فندق جراند شيراتون ,2741291443 ,Dubai",
        "phone": "97145877794 / 971586606660",
        "email": "obh@obhlawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "edbb7814-39f9-4ec9-b01d-9de1117e343e",
    "firmName": "OMAR KHALIFA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1154",
    "licenseIssueDate": "05/10/2023 00:00:00",
    "licenseExpiryDate": "05/09/2026 00:00:00"
  },
  {
    "id": "bb35f56f-564b-4538-8b71-bd6d5d224452",
    "slug": "mariam-mohammed-mugheer-alkhyeli",
    "name": "MOHAMMED ABDULLA SALEM NASSER ALAMERI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/07/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: mariam mohammed mugheer alkhyeli",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bb35f56f-564b-4538-8b71-bd6d5d224452",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-2015",
    "licenseIssueDate": "08/21/2024 00:00:00",
    "licenseExpiryDate": "08/20/2026 00:00:00"
  },
  {
    "id": "0553aef6-d35f-4ada-b737-89ea6a53f3b7",
    "slug": "mariam-obaid-abdulla-mohammed-alblooshi",
    "name": "MARIAM OBAID ABDULLA MOHAMMED ALBLOOSHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Commercial Agency",
      "Proceedings-Cases and Proceedings before Dubai International Financial Centre",
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Civil Transactions-POA & Sponsorship",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Civil Transactions-Insurance",
      "Personal Status-Wills",
      "Civil Transactions-Construction and Contracts for Services",
      "Civil Transactions-Ownership & Title",
      "Civil Transactions-HR & Employee Affairs",
      "Commercial Transactions-Commercial Mortgage",
      "Criminal Law-Family Crimes",
      "Personal Status-Custody & Alimony",
      "Commercial Transactions-Commercial Contracts",
      "Civil Transactions-Immigration and Residency",
      "Commercial Transactions-Bankruptcy",
      "Commercial Transactions-Commercial Real Estate",
      "Civil Transactions-Residential Real Estate",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Civil Transactions-Arbitration",
      "Criminal Law-Hate crimes",
      "Civil Transactions-Tenancy",
      "Commercial Transactions-Unfair competition",
      "Criminal Law-Crimes against persons",
      "Personal Status-Legacies and Inheritance",
      "Commercial Transactions-Commercial Companies",
      "Civil Transactions-Labor & Workers",
      "Personal Status-Legal Capacity & Guardianship",
      "Criminal Law-Drug Crimes",
      "Civil Transactions-Sale",
      "Commercial Transactions-Sea and air freight",
      "Proceedings-Cases and Proceedings before arbitral tribunals and other alternative dispute resolution bodies",
      "Personal Status-Marriage & Divorce",
      "Personal Status-Child Abuse & Abduction",
      "Civil Transactions-Compensation",
      "Commercial Transactions-Stock",
      "Criminal Law-Crimes against properties",
      "Commercial Transactions-E-Commerce",
      "Criminal Law-Cybercrimes",
      "Commercial Transactions-Intellectual Property (includes trademarks",
      "copy rights",
      "patents)",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/11/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mariam Obaid Abdulla Mohammed Alblooshi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0553aef6-d35f-4ada-b737-89ea6a53f3b7",
        "address": "Second Floor - Office No. 208 ,Al Wasl Tower - City Walk - Sheikha Raisa Khalifa Bin Saeed Al Maktoum Building ,Makani No:  2550888537 ,000 ,Dubai",
        "phone": "97150707114 / 971507071144",
        "email": "mem.aaa.lawyer@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "9b90fac9-ee1a-47ff-b174-149dfeec39b8",
    "firmName": "MARIAM OBAID ALBLOOSHI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1480",
    "licenseIssueDate": "11/23/2020 00:00:00",
    "licenseExpiryDate": "11/22/2025 00:00:00"
  },
  {
    "id": "0ad42121-d057-4816-9ec5-03f262c59a7f",
    "slug": "mariam-omar-abdalla-salim-bahuwairth",
    "name": "MARIAM OMAR ABDALLA SALIM BAHUWAIRTH",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 20,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/08/2005",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mariam Omar Abdalla Salim Bahuwairth",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0ad42121-d057-4816-9ec5-03f262c59a7f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-526",
    "licenseIssueDate": "08/03/2005 00:00:00",
    "licenseExpiryDate": "08/02/2026 00:00:00"
  },
  {
    "id": "a284a7df-a4cf-4369-a483-206ce8f0a2bf",
    "slug": "mariam-rashid-mohamed-jabir-alsalami",
    "name": "MOHAMED SAEED MOHAMED FAHAD ALAHBABI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/12/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: MARIAM RASHID MOHAMED JABIR ALSALAMI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a284a7df-a4cf-4369-a483-206ce8f0a2bf",
        "address": "jabir rashid alsalami ,b3607 ,latifa tower ,crowne plaza hotel - dubai ,3117 ,Dubai",
        "phone": "97143599997",
        "email": "jabir@jabiralsalami.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "ee5a7838-1f12-4443-832e-a3a87eff8dd6",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1738",
    "licenseIssueDate": "01/10/2023 00:00:00",
    "licenseExpiryDate": "01/09/2026 00:00:00"
  },
  {
    "id": "578133cc-1d66-401f-b5f1-1082e1631908",
    "slug": "maroun-wadih-matar",
    "name": "MAROUN WADIH MATAR",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 32,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/04/1993",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Maroun Wadih Matar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_578133cc-1d66-401f-b5f1-1082e1631908",
        "address": "",
        "phone": "97142211313",
        "email": "info@daralhuqooq.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "a35adad8-13e3-467b-8652-912b433c3fa4",
    "firmName": "DAR AL HUQOOQ LEGAL CONSULTANTS",
    "registrationNumber": "L-258",
    "licenseIssueDate": "04/14/1993 00:00:00",
    "licenseExpiryDate": "04/13/2026 00:00:00"
  },
  {
    "id": "8c346d73-fa84-4cc8-bd77-d23559840eed",
    "slug": "marwa-ali-juma-ali-alsuwaidi",
    "name": "ALI JUMA ALI SEBT",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Commercial Transactions-Commercial Contracts",
      "Civil Transactions-Tenancy",
      "Commercial Transactions-Commercial Companies",
      "Commercial Transactions-Banking Operations",
      "Commercial Transactions-Sea and air freight",
      "Personal Status-Marriage & Divorce",
      "Criminal Law-Crimes against properties"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/09/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Marwa Ali Juma Ali Alsuwaidi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8c346d73-fa84-4cc8-bd77-d23559840eed",
        "address": "",
        "phone": "97143991619 / 971566355726",
        "email": "info@marwaadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "10e703d5-3aef-48b8-80b8-127a5cdee02b",
    "firmName": "MARWA Al SUWAIDI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1312",
    "licenseIssueDate": "09/26/2018 00:00:00",
    "licenseExpiryDate": "09/25/2026 00:00:00"
  },
  {
    "id": "c14ce756-ec31-4d22-ac1b-ce6879b1b93a",
    "slug": "marwa-hamad-saeed-musallam-alriyami",
    "name": "MARWA HAMAD SAEED MUSALLAM MOHAMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/06/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Marwa Hamad Saeed Musallam Alriyami",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c14ce756-ec31-4d22-ac1b-ce6879b1b93a",
        "address": "marwa hamad saeed Musallam alriyami ,12 ,concord tower ,media city ,1500377 ,Dubai",
        "phone": "97144473110",
        "email": "Marwa_alriyami@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "eeb7cff7-edda-42f6-a44e-676d412929de",
    "firmName": "MARWA ALRIYAMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1081",
    "licenseIssueDate": "06/07/2018 00:00:00",
    "licenseExpiryDate": "06/06/2026 00:00:00"
  },
  {
    "id": "00b97bbe-5b97-4d22-b9cb-5dea156d6d77",
    "slug": "marwa-saif-juma-hamad-almashghouni",
    "name": "AHAD SAIF MOHAMMED AHMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/03/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Marwa Saif Juma Hamad Almashghouni",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_00b97bbe-5b97-4d22-b9cb-5dea156d6d77",
        "address": "الطابق 14  ,برج 48 جيت  ,محطة مترو دبي  ,413633 ,Dubai",
        "phone": "97144412031",
        "email": "courts@adglegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "4287f048-dc0c-4d51-9e0c-0c23356040ee",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1938",
    "licenseIssueDate": "04/24/2024 00:00:00",
    "licenseExpiryDate": "04/23/2026 00:00:00"
  },
  {
    "id": "25ab28c4-1705-4636-9cff-deb65fe07bb7",
    "slug": "marwa-saleh-khalifa-rashed-almheiri",
    "name": "ALI SALEH HUMAID ABDULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/05/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: marwa saleh khalifa rashed almheiri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_25ab28c4-1705-4636-9cff-deb65fe07bb7",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1970",
    "licenseIssueDate": "05/28/2024 00:00:00",
    "licenseExpiryDate": "05/27/2026 00:00:00"
  },
  {
    "id": "34d0e83d-3ce6-41bd-a3fd-8c3a37a3e89f",
    "slug": "marwa-suliman-mohammed-karazon",
    "name": "MOHAMED OMAR HEDAIB SALEM ALSEYABI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/03/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Marwa Suliman Mohammed Karazon",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_34d0e83d-3ce6-41bd-a3fd-8c3a37a3e89f",
        "address": "",
        "phone": "/ 971501077776",
        "email": "mimalsham@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "16c3bc7d-4188-486f-835f-cc7565c69af8",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1785",
    "licenseIssueDate": "04/05/2023 00:00:00",
    "licenseExpiryDate": "04/04/2026 00:00:00"
  },
  {
    "id": "72fb524b-4768-4dfb-9dce-99ebb4dcaaa0",
    "slug": "marwan-mohamed-ahmed-nour-al-mazim",
    "name": "Marwan Mohamed Ahmed Nour Al Mazim",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/30/2009 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Marwan Mohamed Ahmed Nour Al Mazim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_72fb524b-4768-4dfb-9dce-99ebb4dcaaa0",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "677",
    "licenseIssueDate": "07/30/2009 00:00:00",
    "licenseExpiryDate": "07/29/2026 00:00:00"
  },
  {
    "id": "db63ecdd-a7eb-4201-9718-329d1d47ce59",
    "slug": "marwan-mohammed-ali-al-schrkh",
    "name": "MARWAN MHD ALI AL CHRKH",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts"
    ],
    "experience": 34,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/06/1991",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Marwan Mohammed Ali Al Schrkh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_db63ecdd-a7eb-4201-9718-329d1d47ce59",
        "address": "",
        "phone": "97143937700",
        "email": "info@galadarilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "d863b662-c864-4193-8b3a-ff6ee5fe6c64",
    "firmName": "GALADARI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-239",
    "licenseIssueDate": "06/26/1991 00:00:00",
    "licenseExpiryDate": "06/25/2026 00:00:00"
  },
  {
    "id": "478b29d9-67c9-430d-87e5-9dcea2a50cea",
    "slug": "maryam-abdulaziz-mohamed-kadfoor-almheiri",
    "name": "MARYEM ABDULAZIZ MOHD KADFOOR",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/10/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Maryam Abdulaziz Mohamed Kadfoor Almheiri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_478b29d9-67c9-430d-87e5-9dcea2a50cea",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-818",
    "licenseIssueDate": "10/12/2015 00:00:00",
    "licenseExpiryDate": "10/11/2025 00:00:00"
  },
  {
    "id": "9d90c514-d51b-43e5-a7e9-268cbe5b493f",
    "slug": "maryam-abdullah-murad-alblooshi",
    "name": "MARYAM ABDULLAH MURAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/12/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Maryam Abdullah Murad Alblooshi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9d90c514-d51b-43e5-a7e9-268cbe5b493f",
        "address": "الطابق الاول  ,بناية مشاريع قرقاش - مكتب رقم 102  ,وكاله مرسيدس  ,393947 ,Dubai",
        "phone": "97143799917",
        "email": "info@amt-legal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "2485aa73-a460-4867-9452-297e9feb733e",
    "firmName": "MARYAM ABDULLAH ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-1241",
    "licenseIssueDate": "12/11/2017 00:00:00",
    "licenseExpiryDate": "12/10/2025 00:00:00"
  },
  {
    "id": "9461eda2-58fd-46c0-8f88-a3d4ef650a44",
    "slug": "maryam-abdulwahab-talal-alheraibi",
    "name": "AMENA ALI SALEM BIN MAHRI ALKATHEERI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/10/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: maryam abdulwahab talal alheraibi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9461eda2-58fd-46c0-8f88-a3d4ef650a44",
        "address": "",
        "phone": "97143595552",
        "email": "rashid.alkaitoob@rk-advocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "8ea99c01-7cd1-44a3-84c3-8dd51ccf5908",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1884",
    "licenseIssueDate": "11/13/2023 00:00:00",
    "licenseExpiryDate": "11/12/2025 00:00:00"
  },
  {
    "id": "5ae13702-0d80-43a9-9ff5-a81916cf3035",
    "slug": "maryam-ahmad-abdulrahman-aljarman",
    "name": "MAITHA ALI KHAMIS MOHAMMED ALHASSANI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/12/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Maryam Ahmad Abdulrahman Aljarman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5ae13702-0d80-43a9-9ff5-a81916cf3035",
        "address": "",
        "phone": "97142659440",
        "email": "info@klaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "d42ce31f-e881-40e1-bd66-bf2e5bb9bb1e",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1901",
    "licenseIssueDate": "12/24/2023 00:00:00",
    "licenseExpiryDate": "12/23/2025 00:00:00"
  },
  {
    "id": "4a56df9c-89eb-48fd-a13c-092bc0a7e0c0",
    "slug": "maryam-ali-saleh-hayyaz-alaleeli",
    "name": "MARYAM ALI SALEH HUMAID HAYYAZ",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/09/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Maryam Ali Saleh Hayyaz Alaleeli",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4a56df9c-89eb-48fd-a13c-092bc0a7e0c0",
        "address": "",
        "phone": "97143422244 / 97143422244",
        "email": "info@maryamwejdan.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "fc7bbac7-d29b-4486-8335-92c217bfd653",
    "firmName": "MARYAM HAYYAZ & WEJDAN BUSHAHAB ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1225",
    "licenseIssueDate": "09/27/2017 00:00:00",
    "licenseExpiryDate": "09/26/2026 00:00:00"
  },
  {
    "id": "ef2d4f37-8d0d-417b-88d2-3443f5f623af",
    "slug": "maryam-easa-ahmed-bin-salman-alnuaimi",
    "name": "MARYAM EASA AHMED EASA ABDULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/02/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Maryam Easa Ahmed Bin Salman Alnuaimi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ef2d4f37-8d0d-417b-88d2-3443f5f623af",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1412",
    "licenseIssueDate": "02/23/2020 00:00:00",
    "licenseExpiryDate": "02/22/2026 00:00:00"
  },
  {
    "id": "ed030a8d-a9a3-4fc5-8065-53c5d5487878",
    "slug": "maryam-essa-mohammad-abdulaziz-alyassi",
    "name": "MARYAM ESSA MOHAMMAD ABDULAZIZ",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/03/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Maryam Essa Mohammad Abdulaziz Alyassi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ed030a8d-a9a3-4fc5-8065-53c5d5487878",
        "address": "Maryam Essa Mohammad Abdulaziz Alyassi ,M06  ,THE ARCADE  ,ALGARHOUD METRO STATION  ,283023 ,Dubai",
        "phone": "97143852835 / 971543314762",
        "email": "info@alyassiadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "20f968ff-e5db-45d4-b645-48a15e7e7808",
    "firmName": "MARYAM ALYASSI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1163",
    "licenseIssueDate": "03/30/2017 00:00:00",
    "licenseExpiryDate": "03/29/2026 00:00:00"
  },
  {
    "id": "b22ea04a-5f7d-4c64-a4ff-e9db0a4898f3",
    "slug": "maryam-ghaleb-saeed-bin-hammad-alnuaimi",
    "name": "SAIF NASER MUSABAH KHAMIS",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/08/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: maryam ghaleb saeed bin hammad alnuaimi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b22ea04a-5f7d-4c64-a4ff-e9db0a4898f3",
        "address": "801/802 ,Park Place ,WTC ,384557 ,Dubai",
        "phone": "97143203999",
        "email": "info.dubai@alemlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "e3088c8b-a7dc-4f38-a04d-cb4c7d050ed9",
    "firmName": "ALPHA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1866",
    "licenseIssueDate": "09/21/2023 00:00:00",
    "licenseExpiryDate": "09/20/2026 00:00:00"
  },
  {
    "id": "6a516106-b5c7-4e58-89b4-b65753d44d23",
    "slug": "maryam-hassan-abdulla-ali-alhammadi",
    "name": "SALMA SHNAIN OBAID",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/07/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Maryam Hassan Abdulla Ali Alhammadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6a516106-b5c7-4e58-89b4-b65753d44d23",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1841",
    "licenseIssueDate": "08/15/2023 00:00:00",
    "licenseExpiryDate": "08/14/2026 00:00:00"
  },
  {
    "id": "3073c994-f1d5-4167-bbea-456a7e5323ae",
    "slug": "maryam-humaid-abdulla-alshaiba-aluaimi",
    "name": "MARYAM HUMAID ABDULLA HUMAID ALSHAIBA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/06/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Maryam Humaid Abdulla Alshaiba Aluaimi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3073c994-f1d5-4167-bbea-456a7e5323ae",
        "address": "2 ,B62 ,Clock Tower ,13903 ,Dubai",
        "phone": "97142288808",
        "email": "Lawfirm@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "2c26b6ea-311a-459a-aae1-8d9965fc9200",
    "firmName": "AL KHALEEJ ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1541",
    "licenseIssueDate": "06/23/2021 00:00:00",
    "licenseExpiryDate": "06/22/2026 00:00:00"
  },
  {
    "id": "db24440b-40f4-4f58-aa95-79313f8899c7",
    "slug": "maryam-hussain-abdulla-hussain",
    "name": "HUSSAIN ABDULLA HUSSAIN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 19,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/04/2006",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Maryam Hussain Abdulla Hussain",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_db24440b-40f4-4f58-aa95-79313f8899c7",
        "address": "الخامس  ,مكاتب عود ميثاء ,فندق رافلز ,11268 ,Dubai",
        "phone": "97143243330",
        "email": "avocat@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "25d2c9bd-dbba-41ac-aff9-5ba0f37290d6",
    "firmName": "AL QARI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-564",
    "licenseIssueDate": "04/24/2006 00:00:00",
    "licenseExpiryDate": "04/23/2026 00:00:00"
  },
  {
    "id": "3590883e-6464-4c64-a5e6-f5eb45250f99",
    "slug": "maryam-ismaeil-mohammed-alhosni",
    "name": "Maryam Ismaeil Mohammed Alhosni",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/17/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Maryam Ismaeil Mohammed Alhosni",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3590883e-6464-4c64-a5e6-f5eb45250f99",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "1634",
    "licenseIssueDate": "03/17/2022 00:00:00",
    "licenseExpiryDate": "03/16/2026 00:00:00"
  },
  {
    "id": "30c9035a-cc2c-4fd5-b297-3f3e65922e51",
    "slug": "maryam-saeed-belal-al-wehaibi-alzeyoudi",
    "name": "MARYAM SAEED BELAL AL WEHAIBI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 17,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/01/2008",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: MARYAM SAEED BELAL AL WEHAIBI ALZEYOUDI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_30c9035a-cc2c-4fd5-b297-3f3e65922e51",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-618",
    "licenseIssueDate": "01/07/2008 00:00:00",
    "licenseExpiryDate": "01/06/2026 00:00:00"
  },
  {
    "id": "19c676a2-1347-47cc-ab93-de11aae16b69",
    "slug": "maryam-saeed-humaid-alaraj-alsuwaidi",
    "name": "AHMED MOHAMMED RASHED A ALMHEIRI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/08/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: maryam saeed humaid alaraj alsuwaidi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_19c676a2-1347-47cc-ab93-de11aae16b69",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1863",
    "licenseIssueDate": "09/19/2023 00:00:00",
    "licenseExpiryDate": "09/18/2026 00:00:00"
  },
  {
    "id": "a771b802-2674-4b17-ba94-b90d50ec1cf5",
    "slug": "maryam-saif-abdulla-khalfan-albedwawi",
    "name": "SALIM MOHAMED ESSA ALJABER AL ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/03/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: MARYAM SAIF ABDULLA KHALFAN ALBEDWAWI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a771b802-2674-4b17-ba94-b90d50ec1cf5",
        "address": "engy nabeel ,609 ,Business Avenue Building ,خلف معرض نيسان للسيارات ,114332 ,Dubai",
        "phone": "97142666983 / 971505049385",
        "email": "mtgdubai@mtglegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "2c10c414-70fa-4a29-b8ce-a320239738ad",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1935",
    "licenseIssueDate": "04/17/2024 00:00:00",
    "licenseExpiryDate": "04/16/2026 00:00:00"
  },
  {
    "id": "f0471759-7b2b-4c57-a351-494716a5ca7c",
    "slug": "maryam-saif-ali-khatem",
    "name": "SAEED KHAMIS SAEED JUMA ALNAQBI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/02/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: MARYAM SAIF ALI  KHATEM",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f0471759-7b2b-4c57-a351-494716a5ca7c",
        "address": "Office No. M26 ,Al Garhoud Business Centre ,Al Garhoud Business Centre ,000 ,Dubai",
        "phone": "97142520160 / 971000000000",
        "email": "info@msklaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "82512feb-5424-43d4-8fe8-b84a1a0e1c4f",
    "firmName": "SAEED ALNAQBI ADVOCATES &LEGAL CONSULTANTS",
    "registrationNumber": "L-1630",
    "licenseIssueDate": "03/09/2022 00:00:00",
    "licenseExpiryDate": "03/08/2026 00:00:00"
  },
  {
    "id": "77acb74d-a4f1-4e5a-8f38-8099dea1989e",
    "slug": "masooma-hassan-naser-al-sayegh",
    "name": "HASSAN NASSER HASSAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Criminal Law-Family Crimes",
      "Criminal Law-Crimes against persons",
      "Criminal Law-Drug Crimes",
      "Criminal Law-Crimes against properties",
      "Criminal Law-Cybercrimes",
      "Criminal Law-Family Crimes",
      "Criminal Law-Crimes against persons",
      "Criminal Law-Drug Crimes",
      "Criminal Law-Crimes against properties",
      "Criminal Law-Cybercrimes"
    ],
    "experience": 26,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/12/1998",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Masooma Hassan Naser Al-Sayegh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_77acb74d-a4f1-4e5a-8f38-8099dea1989e",
        "address": "1404 ,توين  تاورز  ,بجانب فندق ريدسون بلو  ,40227 ,Dubai",
        "phone": "97142222407",
        "email": "info@daralbalaghadvocate.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "183a898c-3779-4747-92dd-33a8feb6a42c",
    "firmName": "DAR AL BALAGH ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-346",
    "licenseIssueDate": "12/09/1998 00:00:00",
    "licenseExpiryDate": "12/08/2025 00:00:00"
  },
  {
    "id": "97d4a075-3681-4253-8ea6-47f75784d0b7",
    "slug": "mayed-mohamed-juma-humaid-almarashda",
    "name": "MAYED MOHAMED JUMA HUMAID ALMARASHDA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/01/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mayed Mohamed Juma Humaid Almarashda",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_97d4a075-3681-4253-8ea6-47f75784d0b7",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1248",
    "licenseIssueDate": "01/25/2018 00:00:00",
    "licenseExpiryDate": "01/24/2026 00:00:00"
  },
  {
    "id": "ee6c73ad-d696-4949-b05e-e54a57974c66",
    "slug": "mazna-mohamed-thamer-mohamed-almansoori",
    "name": "HASSAN MALALLA KHALFAN KHALAF",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/10/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: mazna mohamed thamer mohamed almansoori",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ee6c73ad-d696-4949-b05e-e54a57974c66",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1720",
    "licenseIssueDate": "11/14/2022 00:00:00",
    "licenseExpiryDate": "11/13/2025 00:00:00"
  },
  {
    "id": "c9960f8d-43f3-4d7d-8c08-8a48e23333a1",
    "slug": "meera-ali-khamis-ali-al-ali",
    "name": "SAIF AHMED SAEED OTHMAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/07/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: MEERA ALI KHAMIS ALI AL ALI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c9960f8d-43f3-4d7d-8c08-8a48e23333a1",
        "address": "",
        "phone": "97143937700",
        "email": "info@galadarilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "d863b662-c864-4193-8b3a-ff6ee5fe6c64",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-2005",
    "licenseIssueDate": "07/23/2024 00:00:00",
    "licenseExpiryDate": "07/22/2026 00:00:00"
  },
  {
    "id": "ab24d9f1-bcc6-4732-b7d9-1557ba282ace",
    "slug": "meera-ali-mohamed-hasan-aljallaf",
    "name": "MEERA ALI MOHAMED HASAN ALJALLAF",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/08/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Meera Ali Mohamed Hasan Aljallaf",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ab24d9f1-bcc6-4732-b7d9-1557ba282ace",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1307",
    "licenseIssueDate": "08/13/2018 00:00:00",
    "licenseExpiryDate": "08/12/2026 00:00:00"
  },
  {
    "id": "13013997-150e-4dc4-ab8d-2952a4028873",
    "slug": "meerah-jalal-akbar-juma-alblooshi",
    "name": "MEERAH JALAL AKBAR J. J. AL BOLOUSHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/02/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Meerah Jalal Akbar Juma Alblooshi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_13013997-150e-4dc4-ab8d-2952a4028873",
        "address": "ABDULRAHMAN OMAR  ABDULLA MUKHAYER  ,NBK BANK ,LATIFA TOWER  ,NEAR CROWN PLAZA  ,185616 ,Dubai",
        "phone": "97143296968",
        "email": "hlp@hlplawfirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "617b9580-cff5-4ffa-b2bc-8788300a3c6e",
    "firmName": "AL HUQOOQ FOR ADVOCACY AND LEGAL CONSULTANCY",
    "registrationNumber": "L-1410",
    "licenseIssueDate": "02/20/2020 00:00:00",
    "licenseExpiryDate": "02/19/2026 00:00:00"
  },
  {
    "id": "693edfd0-0b17-46ae-9756-32a8a6c255bd",
    "slug": "mehdi-safar-ghulom-abdulla",
    "name": "MAHDI SAFAR GHULOOM ABDULLA ALMAJEDI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 41,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/12/1983",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mehdi Safar Ghulom Abdulla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_693edfd0-0b17-46ae-9756-32a8a6c255bd",
        "address": "4th floor ,Al Saaha Offices Block D office 401A ,Burj Khalifa ,283773 ,Dubai",
        "phone": "97144221944",
        "email": "gov.depts@alsafarpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "b7bbfaeb-1fdb-46d2-97cf-8e6432a9b8a7",
    "firmName": "AL SAFAR & PARTNERS ADVOCATES &LEGAL CONSULTANTS",
    "registrationNumber": "L-130",
    "licenseIssueDate": "12/25/1983 00:00:00",
    "licenseExpiryDate": "12/24/2025 00:00:00"
  },
  {
    "id": "b0bc9148-9b50-48da-9c87-c0a75657b523",
    "slug": "meirah-saeed-hassan-saghairy-alhamoudi",
    "name": "MEIRAH SAEED HASSAN SAGHAIRY ALHMOUDI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/11/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Meirah Saeed Hassan Saghairy Alhamoudi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b0bc9148-9b50-48da-9c87-c0a75657b523",
        "address": "FAHD MOHAMED RASHED ALHADOURI ALYAMMAHI ,10 ,MAZE TOWER ,DIFC - FUTURE MUSEUM ,127077 ,Dubai",
        "phone": "97143596555",
        "email": "fhd6767@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "4e636842-b67d-49a6-a11f-607b9a136380",
    "firmName": "NOURA ALHAJERI AND FAHD ALHADOURI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1598",
    "licenseIssueDate": "11/17/2021 00:00:00",
    "licenseExpiryDate": "11/16/2025 00:00:00"
  },
  {
    "id": "be13701f-5ea0-40c4-aed7-f85fa8ed72f1",
    "slug": "michel-amado-chalhoub",
    "name": "MICHEL AMADO CHALHOUB",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Civil Transactions-Construction and Contracts for Services",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Civil Transactions-Arbitration",
      "Criminal Law-Crimes against persons",
      "Commercial Transactions-Commercial Companies",
      "Commercial Transactions-Sea and air freight",
      "Proceedings-Cases and Proceedings before arbitral tribunals and other alternative dispute resolution bodies",
      "Civil Transactions-Compensation",
      "Criminal Law-Crimes against properties",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/04/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Michel Amado Chalhoub",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_be13701f-5ea0-40c4-aed7-f85fa8ed72f1",
        "address": "4 - 449 ,Emarat Atrium ,Gulf News ,413533 ,Dubai",
        "phone": "97143211966",
        "email": "icalc@internationalcounsels.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "382198c6-5727-490a-963b-91b675ddc7bc",
    "firmName": "INTERNATIONAL COUNSELS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-929",
    "licenseIssueDate": "04/07/2014 00:00:00",
    "licenseExpiryDate": "04/06/2026 00:00:00"
  },
  {
    "id": "75704a02-9152-4960-972f-e59f7f7d6f5e",
    "slug": "mira-khalfan-saif-beljaflah-almansoori",
    "name": "HAMAD IBRAHIM AHMAD ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/05/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mira Khalfan Saif Beljaflah Almansoori",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_75704a02-9152-4960-972f-e59f7f7d6f5e",
        "address": "Hadeel Ali alshaali  ,الطابق السادس  ,بناية زمردة ,بلدية دبي المختبرات المركزية ,212633 ,Dubai",
        "phone": "97165503035",
        "email": "hadeelalshaali_90@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "18a7fc47-63d9-4928-a864-fa55559de45b",
    "firmName": "DR HAMAD ALUSTATH ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1610",
    "licenseIssueDate": "01/08/2022 00:00:00",
    "licenseExpiryDate": "01/07/2026 00:00:00"
  },
  {
    "id": "d1c9576c-b1a2-4052-99c7-db0993913626",
    "slug": "mitha-abdulrahman-alsayed-ahmed-alhashimi",
    "name": "ABDULRAHMAN ALSAYEDAHMAD ABDURAHMAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Civil Transactions-Insurance",
      "Civil Transactions-Construction and Contracts for Services",
      "Commercial Transactions-Commercial Mortgage",
      "Commercial Transactions-Commercial Contracts",
      "Civil Transactions-Arbitration",
      "Civil Transactions-Tenancy",
      "Commercial Transactions-Unfair competition",
      "Personal Status-Legacies and Inheritance",
      "Commercial Transactions-Commercial Companies",
      "Commercial Transactions-Banking Operations",
      "Civil Transactions-Labor & Workers",
      "Commercial Transactions-Sea and air freight",
      "Civil Transactions-Compensation",
      "Criminal Law-Cybercrimes",
      "Commercial Transactions-Intellectual Property (includes trademarks",
      "copy rights",
      "patents)"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/05/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mitha Abdulrahman Alsayed Ahmed Alhashimi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d1c9576c-b1a2-4052-99c7-db0993913626",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1188",
    "licenseIssueDate": "05/11/2017 00:00:00",
    "licenseExpiryDate": "05/10/2026 00:00:00"
  },
  {
    "id": "5c274393-fb6c-4174-9fd1-057a68b3184a",
    "slug": "moaza-saif-salem-saif-aljabri",
    "name": "MOAZA SAIF SALEM SAIF ALJABRI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 18,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/03/2007",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Moaza Saif Salem Saif Aljabri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5c274393-fb6c-4174-9fd1-057a68b3184a",
        "address": "",
        "phone": "97142999434 / 971563666333",
        "email": "info@moaza-advocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "6311e53c-d1e0-469a-92a1-e290c2faf954",
    "firmName": "MOZA ALJABRI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-592",
    "licenseIssueDate": "03/06/2007 00:00:00",
    "licenseExpiryDate": "03/05/2026 00:00:00"
  },
  {
    "id": "1f838919-f591-4611-aae2-10f8f18f2671",
    "slug": "mohad-saeed-bakheet-salem-alkatheeri",
    "name": "MOHAD SAEED BAKHEET SALEM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/07/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohad Saeed Bakheet Salem Alkatheeri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1f838919-f591-4611-aae2-10f8f18f2671",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-978",
    "licenseIssueDate": "07/23/2024 00:00:00",
    "licenseExpiryDate": "07/22/2026 00:00:00"
  },
  {
    "id": "01e8fe54-9976-4d5d-9c8d-8dbe3e1ccc44",
    "slug": "mohamad-ibrahim-mohamad-salmeen",
    "name": "MOHAMAD IBRAHIM MOHAMAD SALMEEN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/01/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohamad Ibrahim Mohamad Salmeen",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_01e8fe54-9976-4d5d-9c8d-8dbe3e1ccc44",
        "address": "MOHAMAD SALMEEN ,304 ,بيزنس افنيو ,مطار دبي ,119474 ,Dubai",
        "phone": "97143300346",
        "email": "info@mis.lawyer",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "f3bfca9b-f895-41b7-aa09-b350673f8d3d",
    "firmName": "MOHAMAD IBRAHIM SALMEEN ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1335",
    "licenseIssueDate": "01/21/2019 00:00:00",
    "licenseExpiryDate": "01/20/2026 00:00:00"
  },
  {
    "id": "dc229cf0-5dd1-4662-8192-b946ec6663a6",
    "slug": "mohamed-abbas-qambar-mohammed-alblooshi",
    "name": "HANAN YAHYA ALI BUTABTOUB",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/06/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: MOHAMED ABBAS QAMBAR MOHAMMED ALBLOOSHI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dc229cf0-5dd1-4662-8192-b946ec6663a6",
        "address": "Hamad Abdul wahab alqawadi ,الطابق العاشر / مكتب 1002 ,فندق ذا اتش  ,المركز التجاري  ,00000 ,Dubai",
        "phone": "97145681225",
        "email": "alhamad_advo@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "f2476874-d6f1-491d-857f-df0917f9997a",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-2002",
    "licenseIssueDate": "07/11/2024 00:00:00",
    "licenseExpiryDate": "07/10/2026 00:00:00"
  },
  {
    "id": "b7b57894-b312-45c1-bbf4-12273405c753",
    "slug": "mohamed-abdalla-ahmed-mohamed-almulla",
    "name": "MOHAMED ABDALLA AHMED MOHAMED ALMULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/06/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohamed Abdalla Ahmed Mohamed Almulla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b7b57894-b312-45c1-bbf4-12273405c753",
        "address": "BLOCK B - OFFICE NO. 208 ,BUSHAQER Building ,Makani No: 3289393656 ,000 ,Dubai",
        "phone": "97142217010 / 971504993366",
        "email": "majidlawyer726@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "b380d172-f6fb-41f1-ad4f-0b8fa3c870fb",
    "firmName": "MAJID HAMAD AL KALBANI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1422",
    "licenseIssueDate": "06/15/2020 00:00:00",
    "licenseExpiryDate": "06/15/2026 00:00:00"
  },
  {
    "id": "7d314161-1776-4843-a15c-3208c9c12fa4",
    "slug": "mohamed-abdalla-mohamed-abdalla-almur",
    "name": "FATMA ABDULAZIZ ALQASSIM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/09/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohamed Abdalla Mohamed Abdalla AlMur",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7d314161-1776-4843-a15c-3208c9c12fa4",
        "address": "",
        "phone": "97143944088 / 971547800401",
        "email": "info@almurlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "cfc90bc1-eca3-4d64-879b-70aeaa0925d3",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-2033",
    "licenseIssueDate": "10/07/2024 00:00:00",
    "licenseExpiryDate": "10/06/2026 00:00:00"
  },
  {
    "id": "c1c70f45-754d-4d2b-965a-67a5aa5c0e94",
    "slug": "mohamed-abdelrahman-mohamed-abdalla-alsuwaidi",
    "name": "MOHAMED ABDELRAHMAN MOHAMED A ALSUWAIDI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/08/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohamed Abdelrahman Mohamed Abdalla Alsuwaidi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c1c70f45-754d-4d2b-965a-67a5aa5c0e94",
        "address": "YOUNIS MOHAMMED ALBLOOSHI ,3 - 1 ,the icon ,السيلكون ,117548 ,Dubai",
        "phone": "97145693206 / 971000000000",
        "email": "info@yblooshiadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "27278b02-4edf-490f-9d50-a1bc00678b6a",
    "firmName": "YOUNIS MOHAMMED AL BLOOSHI LAWYER & LEGAL CONSULTANTS",
    "registrationNumber": "L-1304",
    "licenseIssueDate": "08/02/2018 00:00:00",
    "licenseExpiryDate": "08/01/2026 00:00:00"
  },
  {
    "id": "54e566f6-6ffc-45ff-81dd-030a313bdc41",
    "slug": "mohamed-abdulla-ali-bamakhrama-alhemeiri",
    "name": "MOHAMED ABDULLA ALI BAMAKHRAMA ALHEMEIRI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/09/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohamed Abdulla Ali Bamakhrama Alhemeiri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_54e566f6-6ffc-45ff-81dd-030a313bdc41",
        "address": "",
        "phone": "97145911811 / 971506137373",
        "email": "info@advoalhadhrami.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "52d0e50e-9741-4720-8ae1-7de3cbda373d",
    "firmName": "MOHAMED ALHEMEIRI LAWYERS AND LEGAL CONSULTANTS",
    "registrationNumber": "L-1385",
    "licenseIssueDate": "09/19/2019 00:00:00",
    "licenseExpiryDate": "09/18/2026 00:00:00"
  },
  {
    "id": "fa789324-40e8-4ad4-9509-4b7ddba04428",
    "slug": "mohamed-abdulla-hamad-abdulla-almarzouqi",
    "name": "MOHAMED ABDULLA HAMAD ABDULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/06/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohamed Abdulla Hamad Abdulla Almarzouqi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fa789324-40e8-4ad4-9509-4b7ddba04428",
        "address": "Second Floor - Office No. 44 ,SUNSET Mall ,Makani No: 2129186503 ,000 ,Dubai",
        "phone": "97100000000 / 971558989828",
        "email": "L.ALMARZOOQI1110@GMAIL.COM",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "fd6217fa-7d75-4e40-9295-6daa554c87d1",
    "firmName": "MOHAMED ABDULLA ALMARZOOQI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-764",
    "licenseIssueDate": "06/27/2011 00:00:00",
    "licenseExpiryDate": "06/26/2026 00:00:00"
  },
  {
    "id": "6796e3b3-a5cb-4bcb-882c-c8cedc033d46",
    "slug": "mohamed-abdulla-mohamed-al-ameri",
    "name": "MOHAMED ABDULLA MOHAMED ALAMERI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 19,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/04/2006",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: MOHAMED ABDULLA MOHAMED AL AMERI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6796e3b3-a5cb-4bcb-882c-c8cedc033d46",
        "address": "samer tohme ,4th- office 433 ,Emarat Atrium ,Dubai Canal ,79436 ,Dubai",
        "phone": "97126722500",
        "email": "info@dxblawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "00b6334f-44e7-458e-8ce5-7d4256840067",
    "firmName": "MOHAMED ABDULLA LAWYERS AND LEGAL CONSULTANTS",
    "registrationNumber": "L-550",
    "licenseIssueDate": "04/08/2006 00:00:00",
    "licenseExpiryDate": "04/07/2026 00:00:00"
  },
  {
    "id": "5a91ee8c-2e08-4d2d-8035-4a9e436139fb",
    "slug": "mohamed-abdullah-hadi-husain-alhamed",
    "name": "ABDULELAH HADI HUSSAIN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/10/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohamed Abdullah Hadi Husain Alhamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5a91ee8c-2e08-4d2d-8035-4a9e436139fb",
        "address": "الطابق الثاني ,امارات اتريوم ,مبني الامارات للبترول ,2311 ,Dubai",
        "phone": "97145823288 / 971552222311",
        "email": "info@lmh.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "33e18285-3dec-403b-b2e2-7862ae1993cc",
    "firmName": "MOHAMED ABDULILAH ALHAMED ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1317",
    "licenseIssueDate": "10/08/2018 00:00:00",
    "licenseExpiryDate": "10/07/2026 00:00:00"
  },
  {
    "id": "a8d8772a-7934-4864-8da2-93a52ec4aef9",
    "slug": "mohamed-ahmad-alshaikh-m-alshaikh",
    "name": "MOHAMED AHMAD ALSHAIKH MAHFOODH ALSHAIKH",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/09/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohamed Ahmad Alshaikh M Alshaikh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a8d8772a-7934-4864-8da2-93a52ec4aef9",
        "address": "",
        "phone": "97142424288 / 971588961163",
        "email": "info@malshaikhadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "73d5d3aa-9089-4c36-8cd2-4057677338f3",
    "firmName": "MOHAMED ALSHAIKH ADVOCATES &LEGAL CONSULTANTS",
    "registrationNumber": "L-1313",
    "licenseIssueDate": "09/26/2018 00:00:00",
    "licenseExpiryDate": "09/25/2026 00:00:00"
  },
  {
    "id": "d44c21cb-923f-4c91-93e6-854e8718b80a",
    "slug": "mohamed-ahmed-ali-abdulla-almurshidi",
    "name": "MOHAMED HAMAD MABKHOOT SUWAIDAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/07/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohamed Ahmed Ali Abdulla Almurshidi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d44c21cb-923f-4c91-93e6-854e8718b80a",
        "address": "",
        "phone": "97100000000 / 971504766660",
        "email": "info@eza.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "f6dee20d-9392-4f89-96bd-b1f89bcef71a",
    "firmName": "HAMDAN ALKAABI ADVOCATES & LEGAL CONSULTANS",
    "registrationNumber": "L-1832",
    "licenseIssueDate": "07/19/2023 00:00:00",
    "licenseExpiryDate": "07/18/2026 00:00:00"
  },
  {
    "id": "0abad0e0-08ae-4785-8fe9-22b31991c881",
    "slug": "mohamed-ahmed-ali-alhadhrami",
    "name": "Mohamed Ahmed Ali Alhadhrami",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/06/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohamed Ahmed Ali Alhadhrami",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0abad0e0-08ae-4785-8fe9-22b31991c881",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "855",
    "licenseIssueDate": "02/06/2013 00:00:00",
    "licenseExpiryDate": "02/05/2026 00:00:00"
  },
  {
    "id": "1548e84a-94bd-4f55-9e8d-becb8079720a",
    "slug": "mohamed-ahmed-ali-ebrahim-alameeri",
    "name": "MOHAMED AHMED ALI EBRAHIM ALAMEERI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/04/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohamed Ahmed Ali Ebrahim Alameeri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1548e84a-94bd-4f55-9e8d-becb8079720a",
        "address": "العاشر ,المسعود ,بجوار معرض تويوتا ,20085 ,Dubai",
        "phone": "97142945554",
        "email": "ahmedalamiri_law@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "91d66bc6-9b89-4272-9d03-494aed8c3f9e",
    "firmName": "AHMED AL AMIRI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-1179",
    "licenseIssueDate": "04/27/2017 00:00:00",
    "licenseExpiryDate": "04/26/2026 00:00:00"
  },
  {
    "id": "49634cb0-fa85-431c-9862-7e5e4dd3c87f",
    "slug": "mohamed-ahmed-mohamedrasool-abdulkarim-alzaabi",
    "name": "MOHAMED AHMED M R ABDUL KARIM ALZAABI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/05/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohamed Ahmed Mohamedrasool Abdulkarim Alzaabi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_49634cb0-fa85-431c-9862-7e5e4dd3c87f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1082",
    "licenseIssueDate": "05/29/2016 00:00:00",
    "licenseExpiryDate": "05/28/2026 00:00:00"
  },
  {
    "id": "196ae3d4-9d86-4434-a534-0c53f3aa8387",
    "slug": "mohamed-ali-abdulla-alhouti-almaazmi",
    "name": "MOHAMED ALI ABDULLA ALHOUTI ALMAAZMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/08/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: mohamed ali abdulla alhouti almaazmi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_196ae3d4-9d86-4434-a534-0c53f3aa8387",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1852",
    "licenseIssueDate": "08/17/2023 00:00:00",
    "licenseExpiryDate": "08/16/2026 00:00:00"
  },
  {
    "id": "b2582225-47da-4d66-9003-0ab5113c2093",
    "slug": "mohamed-ali-ahmed-abdulla-aldhanhani",
    "name": "MOHAMED ALI AHMED ABDULLA ALDHANHANI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/30/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: MOHAMED ALI AHMED ABDULLA ALDHANHANI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b2582225-47da-4d66-9003-0ab5113c2093",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "1856",
    "licenseIssueDate": "08/30/2023 00:00:00",
    "licenseExpiryDate": "08/29/2026 00:00:00"
  },
  {
    "id": "237c2f07-d602-4fa8-8a64-8b4e8b0c1aea",
    "slug": "mohamed-ali-jabir-saleh-alhammadi",
    "name": "MOHAMED ALI JABIR SALEH ALHAMMADI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/09/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohamed Ali Jabir Saleh Alhammadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_237c2f07-d602-4fa8-8a64-8b4e8b0c1aea",
        "address": "",
        "phone": "97143300009 / 971501215000",
        "email": "mohamed@maa.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "af85c161-b73d-46a2-9fd7-4d8604007473",
    "firmName": "MOHAMMED ALI ALHAMMADI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-834",
    "licenseIssueDate": "09/25/2012 00:00:00",
    "licenseExpiryDate": "09/24/2026 00:00:00"
  },
  {
    "id": "67d13d3d-f0f6-403e-b531-968409e7aa5e",
    "slug": "mohamed-ali-mohamed-hussain-al-ali",
    "name": "MOHAMED BUTTI THANI TARISH ALSHAMSI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/07/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: mohamed ali mohamed hussain al ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_67d13d3d-f0f6-403e-b531-968409e7aa5e",
        "address": "Sarhan Hassan Mohamed Hassan Almuaini ,Office 1002, Level 10 ,THE OBEROI CENTRE ,Business Bay Metro Station ,1169 ,Dubai",
        "phone": "97142324000",
        "email": "info@drsarhanlawyer.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "14541022-bde4-43ab-9ba1-489e87187b42",
    "firmName": "ZAYED AL SHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1684",
    "licenseIssueDate": "08/09/2022 00:00:00",
    "licenseExpiryDate": "08/08/2026 00:00:00"
  },
  {
    "id": "2b1e65bd-dbec-4828-94e6-ae8845690eb2",
    "slug": "mohamed-ali-saeed-humaid-alkheyaili",
    "name": "MOHAMED ALI SAEED HUMAID ALKHYELI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/07/2009",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: MOHAMED ALI SAEED HUMAID ALKHEYAILI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2b1e65bd-dbec-4828-94e6-ae8845690eb2",
        "address": "Mohamed Ali Saeed Humaid Al Kheyaili  ,Seventh Floor  ,Al Masaood Tower 2 ,Al Tadawi Medical Centre  ,88314 ,Dubai",
        "phone": "97142989662",
        "email": "info@mkladvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "ec23636d-f937-474e-b86d-d7470fbb385b",
    "firmName": "MOHAMED ALKHEYAILI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-676",
    "licenseIssueDate": "07/23/2009 00:00:00",
    "licenseExpiryDate": "07/22/2026 00:00:00"
  },
  {
    "id": "41857568-4deb-47d1-a292-396da80502df",
    "slug": "mohamed-ali-saleh-mohamed-alshehhi",
    "name": "Mohamed Ali Saleh Mohamed Alshehhi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 20,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/03/2005 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2025-02-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohamed Ali Saleh Mohamed Alshehhi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_41857568-4deb-47d1-a292-396da80502df",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "525",
    "licenseIssueDate": "08/03/2005 00:00:00",
    "licenseExpiryDate": "08/02/2025 00:00:00"
  },
  {
    "id": "d4fc7e9a-3ce1-4c87-8043-4b6432fab2f1",
    "slug": "mohamed-aliasghar-alirda-ali",
    "name": "MOHAMED ALI ASGHAR ALI RIDA ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Civil Transactions-Compensation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/03/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohamed Aliasghar Alirda Ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d4fc7e9a-3ce1-4c87-8043-4b6432fab2f1",
        "address": "O-4801, O-4901 ,Burj al Salam Office Tower ,H Hotel ,111801 ,Dubai",
        "phone": "97143544444",
        "email": "administration@horizlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "4e25fb39-6659-44f0-bc8b-3ff0f067beb0",
    "firmName": "HORIZONS & CO - LAW FIRM",
    "registrationNumber": "L-997",
    "licenseIssueDate": "03/19/2015 00:00:00",
    "licenseExpiryDate": "03/18/2026 00:00:00"
  },
  {
    "id": "82fdecfb-176d-46c0-b94e-8ffc51946c39",
    "slug": "mohamed-alibaik-mohamed-bashir-almaazmi",
    "name": "MOHAMED ALIBAIK MOHAMED BASHIR ALMAAZMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 24,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/05/2001",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohamed Alibaik Mohamed Bashir ALmaazmi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_82fdecfb-176d-46c0-b94e-8ffc51946c39",
        "address": "403 ,الطابق الاول مكتب 101 ,بناية الكنال سنترال ,اكاديمية هايونداي للتدريب  ,90209 ,Dubai",
        "phone": "97142970007",
        "email": "altdamon@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "1829252a-0804-4aaa-ad2a-4212e680346d",
    "firmName": "ALLIED ADVOCATES & LEAGL CONSULTANTS L.L.C",
    "registrationNumber": "L-403",
    "licenseIssueDate": "05/08/2001 00:00:00",
    "licenseExpiryDate": "05/07/2026 00:00:00"
  },
  {
    "id": "3039430e-389f-4a8c-aca5-5061c0af2ce0",
    "slug": "mohamed-alkori-mohamed-suhail-alameri",
    "name": "FATMA ALI MOHD HASSAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/03/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: MOHAMED ALKORI MOHAMED SUHAIL ALAMERI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3039430e-389f-4a8c-aca5-5061c0af2ce0",
        "address": "Office No. 604 ,Gulf Commercial - Shoba Sapphire Building ,Makani No: 2612485764 ,000 ,Dubai",
        "phone": "97150411984 / 971504119844",
        "email": "s.almenhali.advocates@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "3f85aa24-b612-477c-9af1-5067f3afda7d",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1783",
    "licenseIssueDate": "03/29/2023 00:00:00",
    "licenseExpiryDate": "03/28/2026 00:00:00"
  },
  {
    "id": "e4bc0110-3f9d-4ec3-bfb6-18dc35e939eb",
    "slug": "mohamed-alomer-saleh-saeed-almenhali",
    "name": "MOHAMED ALOMAR SALEH SAEED ALMENHALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/10/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohamed Alomer Saleh Saeed Almenhali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e4bc0110-3f9d-4ec3-bfb6-18dc35e939eb",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1466",
    "licenseIssueDate": "10/28/2020 00:00:00",
    "licenseExpiryDate": "10/27/2026 00:00:00"
  },
  {
    "id": "2e2717f0-8fad-4772-8d6d-56c3f884eef2",
    "slug": "mohamed-butti-thani-tarish-alshamsi",
    "name": "KHALID ESSA MOHAMMAD ABDULAZIZ",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/06/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohamed Butti Thani Tarish Alshamsi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2e2717f0-8fad-4772-8d6d-56c3f884eef2",
        "address": "zayed saeed saif alshamsi ,الرابع مكتب رقم 414 ,قرية الاعمال ,بجانب دائرة التنمية الاقتصادية - دوار الساعة  ,6030 ,Dubai",
        "phone": "97142680800",
        "email": "info@zayedalshamsi.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "295c7198-77b4-4f9a-a4d2-bad9a78e074d",
    "firmName": "MOHAMED ALHEMEIRI LAWYERS AND LEGAL CONSULTANTS",
    "registrationNumber": "L-1676",
    "licenseIssueDate": "07/06/2022 00:00:00",
    "licenseExpiryDate": "07/05/2026 00:00:00"
  },
  {
    "id": "58bebea1-af16-438a-b2b2-633f81eb8fea",
    "slug": "mohamed-eid-jassim-mohamed-alsuwaidi",
    "name": "EID JASSIM MOHAMMAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/10/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohamed Eid Jassim Mohamed Alsuwaidi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_58bebea1-af16-438a-b2b2-633f81eb8fea",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1118",
    "licenseIssueDate": "10/27/2016 00:00:00",
    "licenseExpiryDate": "10/26/2025 00:00:00"
  },
  {
    "id": "04ab0feb-f2b6-4c1a-950d-1516a082cb4d",
    "slug": "mohamed-eissa-bakheet-huwaireb-almansoori",
    "name": "MOHAMED EISSA BAKHEET HUWAIREB",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/10/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-10-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohamed Eissa Bakheet Huwaireb AlMansoori",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_04ab0feb-f2b6-4c1a-950d-1516a082cb4d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1389",
    "licenseIssueDate": "10/31/2019 00:00:00",
    "licenseExpiryDate": "10/30/2026 00:00:00"
  },
  {
    "id": "d3c798b4-0759-4d57-8737-3029d963e9e6",
    "slug": "mohamed-hamad-mabkhoot-suwaidan-al-menhali",
    "name": "MOHAMED HAMAD MABKHOOT SUWAIDAN AL MENHALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/03/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: MOHAMED HAMAD MABKHOOT SUWAIDAN AL MENHALI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d3c798b4-0759-4d57-8737-3029d963e9e6",
        "address": "MOSTAFA MAHMOUD  ,1304 ,AL MOOSA TOWER 1 ,First Trade Center ,25635 ,Dubai",
        "phone": "97142254438",
        "email": "info@hkadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "d73d1b91-74ae-4266-9f38-d28296d70f52",
    "firmName": "HAMDAN ALKAABI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "1824",
    "licenseIssueDate": "07/03/2023 00:00:00",
    "licenseExpiryDate": "07/02/2026 00:00:00"
  },
  {
    "id": "4f022b6f-2ade-4fa9-a821-754a18d77d14",
    "slug": "mohamed-hamed-qayed-alazazi",
    "name": "Mohamed Hamed Qayed Alazazi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/13/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohamed Hamed Qayed Alazazi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4f022b6f-2ade-4fa9-a821-754a18d77d14",
        "address": "",
        "phone": "97143997700 / 971503707978",
        "email": "info@alazazi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "92d43169-f680-4fdb-a7c0-1397ce308994",
    "firmName": "MOHAMED ALAZAZI LAWYERS & LEGAL CONSULTANCY",
    "registrationNumber": "748",
    "licenseIssueDate": "03/13/2011 00:00:00",
    "licenseExpiryDate": "03/12/2026 00:00:00"
  },
  {
    "id": "6f7c1832-1940-4507-b3a0-10d6f2319968",
    "slug": "mohamed-hasan-mohamed-ahmed-al-marzouqi",
    "name": "MOHAMED HASAN MOHAMED AHMED ALMARZOOQI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 21,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/11/2003",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohamed Hasan Mohamed Ahmed Al Marzouqi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6f7c1832-1940-4507-b3a0-10d6f2319968",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-459",
    "licenseIssueDate": "11/12/2003 00:00:00",
    "licenseExpiryDate": "11/11/2025 00:00:00"
  },
  {
    "id": "243dc117-4ea1-4fff-9921-61f1976bfc7c",
    "slug": "mohamed-hassan-mohamed-arab-darwish",
    "name": "Mohamed Hassan Mohamed Arab Darwish",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/05/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohamed Hassan Mohamed Arab Darwish",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_243dc117-4ea1-4fff-9921-61f1976bfc7c",
        "address": "",
        "phone": "97143641686 / 971506288801",
        "email": "b.kadir@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "0ba96df8-e4cc-49c2-8ae4-a42878d95926",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULT",
    "registrationNumber": "1572",
    "licenseIssueDate": "10/05/2021 00:00:00",
    "licenseExpiryDate": "10/04/2026 00:00:00"
  },
  {
    "id": "e9c75244-a75f-4381-b52a-3a64d1f81b7d",
    "slug": "mohamed-humaid-abdulla-hasan-alsabah",
    "name": "MOHAMED HUMAID ABDULLA HASAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/08/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohamed Humaid Abdulla Hasan Alsabah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e9c75244-a75f-4381-b52a-3a64d1f81b7d",
        "address": "omar abdulazizi alomar ,15 ,prime tower ,blom bank france ,211940 ,Dubai",
        "phone": "97143808838 / 971504598082",
        "email": "omar.omar@oghlegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "171b4622-e4ec-4375-a9c4-3637bf6a8b17",
    "firmName": "ALOMAR & ALSABAH ADVOCATES",
    "registrationNumber": "L-1023",
    "licenseIssueDate": "08/23/2015 00:00:00",
    "licenseExpiryDate": "08/22/2026 00:00:00"
  },
  {
    "id": "fd11f350-4dd7-40a3-9a88-c897a20668fd",
    "slug": "mohamed-humaid-obaid-h-alzari-alshamsi",
    "name": "MOHAMED HUMAID OBAID ALZARI ALSHAMSI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 23,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/02/2002",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohamed Humaid Obaid H Alzari Alshamsi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fd11f350-4dd7-40a3-9a88-c897a20668fd",
        "address": "الخامس ,الشعلة بلوك اية ,داناتا ,127179 ,Dubai",
        "phone": "97143318888 / 971509984724",
        "email": "ameizar@salamadvo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "1b4e6bd9-712b-49bf-a169-fd31ea45cd51",
    "firmName": "SALAM ADVOCATE & LEGAL CONSULTANTS",
    "registrationNumber": "L-419",
    "licenseIssueDate": "02/04/2002 00:00:00",
    "licenseExpiryDate": "02/03/2026 00:00:00"
  },
  {
    "id": "5ccbbf21-25e8-41dc-9948-91d597ed347b",
    "slug": "mohamed-hussain-ali-bin-hussain-al-ali",
    "name": "Mohamed Hussain Ali Bin Hussain Al Ali",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/05/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohamed Hussain Ali Bin Hussain Al Ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5ccbbf21-25e8-41dc-9948-91d597ed347b",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "1978",
    "licenseIssueDate": "06/05/2024 00:00:00",
    "licenseExpiryDate": "06/04/2026 00:00:00"
  },
  {
    "id": "b14ac3bf-ebf2-4620-8be7-8d7d68292f2b",
    "slug": "mohamed-ibrahim-abduljabar-mohamed-saeed",
    "name": "FATEMA MAJED MEHAYAR GHANEM ALQUBAISI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/06/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohamed Ibrahim Abduljabar Mohamed Saeed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b14ac3bf-ebf2-4620-8be7-8d7d68292f2b",
        "address": "",
        "phone": "97142945678",
        "email": "maadvdubai@maadv.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "85fc2f18-8a0a-4682-9735-2be49a8b75f9",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1988",
    "licenseIssueDate": "06/19/2024 00:00:00",
    "licenseExpiryDate": "06/18/2026 00:00:00"
  },
  {
    "id": "08a0d23d-a2c7-4d7c-978d-b33882d54812",
    "slug": "mohamed-ibrahim-ali-sultan-alrayssi",
    "name": "MOHAMED IBRAHIM ALI SULTAN ALRAYSSI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/02/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-02-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohamed Ibrahim Ali Sultan Alrayssi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_08a0d23d-a2c7-4d7c-978d-b33882d54812",
        "address": "engy nabeel ,609 ,Business Avenue Building ,خلف معرض نيسان للسيارات ,114332 ,Dubai",
        "phone": "97142666983 / 971505049385",
        "email": "mtgdubai@mtglegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "2c10c414-70fa-4a29-b8ce-a320239738ad",
    "firmName": "ENGY NABEEL ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1339",
    "licenseIssueDate": "02/06/2019 00:00:00",
    "licenseExpiryDate": "02/05/2026 00:00:00"
  },
  {
    "id": "2d1d196d-3df0-4d1c-9b20-3c86fbd2ccd3",
    "slug": "mohamed-ibrahim-hassn-ali-almarzooqi",
    "name": "IBRAHIM HASAN ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/03/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohamed IbrahIm Hassn Ali Almarzooqi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2d1d196d-3df0-4d1c-9b20-3c86fbd2ccd3",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1418",
    "licenseIssueDate": "03/11/2020 00:00:00",
    "licenseExpiryDate": "03/10/2026 00:00:00"
  },
  {
    "id": "4d7f7004-6ce6-4fed-9000-1d73a175914b",
    "slug": "mohamed-ibrahim-mohamed-abdulla-alhammadi",
    "name": "MOHAMED IBRAHIM MOHAMED A.ALHAMMADI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/01/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohamed Ibrahim Mohamed Abdulla Alhammadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4d7f7004-6ce6-4fed-9000-1d73a175914b",
        "address": "",
        "phone": "97142566800",
        "email": "fatema@alhammadiadvocate.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "07521705-aa90-4c3a-b5fd-c55e54889e60",
    "firmName": "MOHAMED AL HAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-787",
    "licenseIssueDate": "01/16/2012 00:00:00",
    "licenseExpiryDate": "01/15/2026 00:00:00"
  },
  {
    "id": "cb3c83ca-aca3-4b83-bcdc-3b1c1dec8e22",
    "slug": "mohamed-jamal-saif-alhathboor-alremethi",
    "name": "MOHAMED JAMAL SAIF OBAID",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/10/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohamed Jamal Saif Alhathboor Alremethi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cb3c83ca-aca3-4b83-bcdc-3b1c1dec8e22",
        "address": "",
        "phone": "97143799916 / 971556407627",
        "email": "ask@mahlawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "a1880a30-0b15-4045-b91e-b3e4e776bc7e",
    "firmName": "MOHAMED ALHATHBOOR ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1109",
    "licenseIssueDate": "10/03/2016 00:00:00",
    "licenseExpiryDate": "10/02/2026 00:00:00"
  },
  {
    "id": "fca61711-671e-4f49-8fb8-044304038a5d",
    "slug": "mohamed-jamil-ghanim-ali-alalawi",
    "name": "MOHAMED JAMIL GHANIM ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/11/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohamed Jamil Ghanim Ali Alalawi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fca61711-671e-4f49-8fb8-044304038a5d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1469",
    "licenseIssueDate": "11/02/2020 00:00:00",
    "licenseExpiryDate": "11/01/2025 00:00:00"
  },
  {
    "id": "a5a003a9-6335-4f88-adff-da6b322a1e1e",
    "slug": "mohamed-jasim-mohmed-murad-almaazmi",
    "name": "NOUF SUHAIL SAEED ALI KHAMIS ALKAABI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/07/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohamed Jasim Mohmed Murad Almaazmi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a5a003a9-6335-4f88-adff-da6b322a1e1e",
        "address": "ABDELAZIZ MOHAMED ABDELGHANI AL KHAMIRI AL ALI ,3 ,DUBAI SUPREME COURT COMPLEX ,DUBAI COURT ,128334 ,Dubai",
        "phone": "97145519341 / 971505788557",
        "email": "info@raalc.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "73e54a15-f797-4e91-a501-ef988d8f8bf8",
    "firmName": "RASHID KHALIL OBAID ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1689",
    "licenseIssueDate": "08/18/2022 00:00:00",
    "licenseExpiryDate": "08/17/2026 00:00:00"
  },
  {
    "id": "3686c89e-bc35-4c06-afc3-c1076ce412eb",
    "slug": "mohamed-khalifa-salem-mmaleghfeli",
    "name": "MOHAMED KHALIFA SALEM MATAR ALEGHFELI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 18,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/07/2007",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: MOHAMED KHALIFA SALEM M.M.ALEGHFELI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3686c89e-bc35-4c06-afc3-c1076ce412eb",
        "address": "",
        "phone": "97142945678",
        "email": "maadvdubai@maadv.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "85fc2f18-8a0a-4682-9735-2be49a8b75f9",
    "firmName": "MOHAMED ALEGHFELI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-609",
    "licenseIssueDate": "07/03/2007 00:00:00",
    "licenseExpiryDate": "07/02/2026 00:00:00"
  },
  {
    "id": "023e1c16-7eee-4ad3-8e89-b4cd3a2325bd",
    "slug": "mohamed-madhad-saleh-buqaarah-alhemeiri",
    "name": "MOHAMED MADHAD SALEH BUQAARAH ALHEMEIRI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/11/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohamed Madhad Saleh Buqaarah Alhemeiri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_023e1c16-7eee-4ad3-8e89-b4cd3a2325bd",
        "address": "",
        "phone": "97142508799 / 971504748037",
        "email": "info@alhamlifirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "4a2de7d0-110d-4514-a3ea-9fa2d2b61618",
    "firmName": "AHMED ALHAMLI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-1393",
    "licenseIssueDate": "11/20/2019 00:00:00",
    "licenseExpiryDate": "11/19/2025 00:00:00"
  },
  {
    "id": "74c25d56-ef21-43ce-89cf-30b9d7cccddc",
    "slug": "mohamed-mahmoud-ali-mahmoud-almarzooqi",
    "name": "MOHAMED MAHMOUD ALI MAHMOUD ALMARZOOQI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/08/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohamed Mahmoud Ali Mahmoud Almarzooqi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_74c25d56-ef21-43ce-89cf-30b9d7cccddc",
        "address": "",
        "phone": "97142253131 / 971503534441",
        "email": "info@ml-advocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "e4e4dd86-434d-4a53-a225-b2315793281a",
    "firmName": "MOHAMMED AL MARZOOQI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-966",
    "licenseIssueDate": "08/31/2014 00:00:00",
    "licenseExpiryDate": "08/30/2026 00:00:00"
  },
  {
    "id": "b9b3014e-64c3-44c4-bc57-3fdafd911094",
    "slug": "mohamed-obaid-yousif-alowasia-alzaabi",
    "name": "MOHAMED OBAID YOUSIF ALOWASIA ALZAABI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/05/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohamed Obaid Yousif Alowasia Alzaabi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b9b3014e-64c3-44c4-bc57-3fdafd911094",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1807",
    "licenseIssueDate": "05/17/2023 00:00:00",
    "licenseExpiryDate": "05/16/2026 00:00:00"
  },
  {
    "id": "61488914-0939-4d5d-8acc-32bfce2fb6cd",
    "slug": "mohamed-omar-hedaib-salem-alseyabi",
    "name": "ABDULLA KHAMIS SALEM KHAMIS",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/03/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: mohamed omar hedaib salem alseyabi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_61488914-0939-4d5d-8acc-32bfce2fb6cd",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1777",
    "licenseIssueDate": "03/09/2023 00:00:00",
    "licenseExpiryDate": "03/08/2026 00:00:00"
  },
  {
    "id": "c449ee52-4327-4ed9-abb3-0af042485fdd",
    "slug": "mohamed-rashed-ali-rashed-al-hosani",
    "name": "MOHAMED RASHED ALI RASHED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/07/2009",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: MOHAMED RASHED ALI RASHED AL HOSANI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c449ee52-4327-4ed9-abb3-0af042485fdd",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-675",
    "licenseIssueDate": "07/23/2009 00:00:00",
    "licenseExpiryDate": "07/22/2026 00:00:00"
  },
  {
    "id": "912a7898-b7b4-4e49-8b37-e8990330db94",
    "slug": "mohamed-rashed-salem-rashed-alghfeli",
    "name": "FATIMA SHAIRMOHAMED JUMA B ALMAAZMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/11/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-11-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohamed Rashed Salem Rashed Alghfeli",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_912a7898-b7b4-4e49-8b37-e8990330db94",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1897",
    "licenseIssueDate": "12/16/2023 00:00:00",
    "licenseExpiryDate": "12/15/2025 00:00:00"
  },
  {
    "id": "303c54f3-07c9-49b0-a4d0-247dd76aef87",
    "slug": "mohamed-rashid-mohame-binqanzoul-alketbi",
    "name": "MOHAMED RASHID MOHD M BINQANZOUL ALKTEBI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/09/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: mohamed rashid mohame binqanzoul alketbi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_303c54f3-07c9-49b0-a4d0-247dd76aef87",
        "address": "MOHAMED RASHID ALKETBI ,G ,AIRPORT BUILDING ,مصرف أبو ظبي الإسلامي ,13094 ,Dubai",
        "phone": "97143332709",
        "email": "binqanzoul.ae@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "ff04cc72-9052-4ab2-baad-0b386a4b23cb",
    "firmName": "MOHAMED BINQANZOUL ALKETBI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1564",
    "licenseIssueDate": "09/22/2021 00:00:00",
    "licenseExpiryDate": "09/21/2026 00:00:00"
  },
  {
    "id": "ae8a7ad6-53c9-4842-a454-17895627bea6",
    "slug": "mohamed-rashid-salim-al-owais",
    "name": "Mohamed Rashid Salim Al Owais",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/01/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2023-06-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohamed Rashid Salim Al Owais",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ae8a7ad6-53c9-4842-a454-17895627bea6",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "878",
    "licenseIssueDate": "07/01/2013 00:00:00",
    "licenseExpiryDate": "06/30/2023 00:00:00"
  },
  {
    "id": "1d44ee54-cd8f-4797-ad89-1d916676048d",
    "slug": "mohamed-saeed-abdulla-alhumaidi-alshemeili",
    "name": "HEND HUMAID ABDULLA H ALSHAIBA ALNUAIMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/11/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: MOHAMED SAEED ABDULLA ALHUMAIDI ALSHEMEILI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1d44ee54-cd8f-4797-ad89-1d916676048d",
        "address": "",
        "phone": "97143298881",
        "email": "info@mslawuae.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "2510dab9-717a-4a15-b189-4272261227e3",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1900",
    "licenseIssueDate": "12/18/2023 00:00:00",
    "licenseExpiryDate": "12/17/2025 00:00:00"
  },
  {
    "id": "986d0a69-c614-48b5-a14d-4e3609e21f68",
    "slug": "mohamed-saeed-mohamed-fahad-alahbabi",
    "name": "ZAYED SAAD ABDULLA ALI ALMENHALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/11/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-11-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: mohamed saeed mohamed fahad alahbabi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_986d0a69-c614-48b5-a14d-4e3609e21f68",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1730",
    "licenseIssueDate": "12/16/2022 00:00:00",
    "licenseExpiryDate": "12/15/2025 00:00:00"
  },
  {
    "id": "f76e0067-e534-422b-ac01-7246c79134c7",
    "slug": "mohamed-saeed-obaid-matar-alnaqb",
    "name": "MOHAMMED SAIF ABDULRAHMAN BINDARWISH ALTENEIJI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/11/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: MOHAMED SAEED OBAID MATAR ALNAQB",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f76e0067-e534-422b-ac01-7246c79134c7",
        "address": "29 ,ذا اتش هوتيل ,فندق فيرمونت ,40073 ,Dubai",
        "phone": "97143254000",
        "email": "info@alrowaad.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "759f5477-fdbd-406b-8831-354639c31036",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1731",
    "licenseIssueDate": "12/26/2022 00:00:00",
    "licenseExpiryDate": "12/25/2025 00:00:00"
  },
  {
    "id": "5ed1cb9d-38d1-41ab-8959-c09ecc1f31c9",
    "slug": "mohamed-saif-humaid-bo-ausaiba-al-ali",
    "name": "Mohamed Saif Humaid Bo Ausaiba Al Ali",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/19/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohamed Saif Humaid Bo Ausaiba Al Ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5ed1cb9d-38d1-41ab-8959-c09ecc1f31c9",
        "address": "",
        "phone": "97142955388 / 971507739863",
        "email": "arhilal@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "364483f1-f3e9-4475-a7de-733d3e03062c",
    "firmName": "HILAL & ASSOCIATES ADVOCATES & LEGAL CONSULTA",
    "registrationNumber": "1690",
    "licenseIssueDate": "08/19/2022 00:00:00",
    "licenseExpiryDate": "08/18/2026 00:00:00"
  },
  {
    "id": "1164b9bb-e397-4425-83ee-56ad74ac2d70",
    "slug": "mohamed-saif-obaid-al-hefeiti",
    "name": "MOHAMED SAIF OBAID ALI ALHEFEITI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 15,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/04/2010",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohamed Saif Obaid Al Hefeiti",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1164b9bb-e397-4425-83ee-56ad74ac2d70",
        "address": "13 ,Fairmont Hotel ,World Trade Centre metro station ,187082 ,Dubai",
        "phone": "97142367881",
        "email": "info@alhefeitilaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "4675606d-79bb-4fd1-a3f6-a469d3d7cd31",
    "firmName": "ALHEFEITI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-706",
    "licenseIssueDate": "04/19/2010 00:00:00",
    "licenseExpiryDate": "04/18/2026 00:00:00"
  },
  {
    "id": "3ca3e10e-08a6-483b-96cf-cd1ba5467e78",
    "slug": "mohamed-saleh-ahmed-abdulla-almulla",
    "name": "MOHAMED SALEH AHMED ABDULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/12/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohamed Saleh Ahmed Abdulla Almulla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3ca3e10e-08a6-483b-96cf-cd1ba5467e78",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-904",
    "licenseIssueDate": "12/09/2013 00:00:00",
    "licenseExpiryDate": "12/08/2025 00:00:00"
  },
  {
    "id": "eae7fac5-5213-4b76-9eac-450d66d82dba",
    "slug": "mohamed-saleh-mohamed-ahmed-alhajeri",
    "name": "MOHAMED SALEH MOHAMED AHMED ALHAJERI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/07/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohamed Saleh Mohamed Ahmed Alhajeri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_eae7fac5-5213-4b76-9eac-450d66d82dba",
        "address": "000000000 ,4 ,الريم  ,بلدية دبي  ,14593 ,Dubai",
        "phone": "97142276777",
        "email": "info@tglawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "593a5a42-a340-4daa-a8db-6d2673de29d5",
    "firmName": "MOHAMED ALHAJERI ADVOCATES & LEGAL CONSULTANTS& NOTARY PUBLIC",
    "registrationNumber": "L-827",
    "licenseIssueDate": "07/24/2012 00:00:00",
    "licenseExpiryDate": "07/23/2026 00:00:00"
  },
  {
    "id": "ba418986-d2ca-4670-8300-7a2017e0ff5c",
    "slug": "mohamed-shaker-jumaa-hasan-alhammadi",
    "name": "MOHAMED SHAKER JUMAA HASAN ALHAMMADI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 15,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/05/2010",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohamed Shaker Jumaa Hasan Alhammadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ba418986-d2ca-4670-8300-7a2017e0ff5c",
        "address": "Mohamed Alhammadi ,FLOOR 16 OFFICE B1605 ,LATIFA TOWER ,CLOSE TO CROWN PLAZA HOTEL ,76550 ,Dubai",
        "phone": "97143298866",
        "email": "admin@dralhammadilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "612e75e6-c3f3-479b-bc93-ee88982dea58",
    "firmName": "DR MOHAMED ALHAMMADI ADVOCATES & LEGAL CONSULTANTS OFFICE",
    "registrationNumber": "L-711",
    "licenseIssueDate": "05/09/2010 00:00:00",
    "licenseExpiryDate": "05/08/2026 00:00:00"
  },
  {
    "id": "8a02f73b-0c45-4377-a5a5-bb12e0a14499",
    "slug": "mohamed-thamer-yagub-yousef-alserkal",
    "name": "MOHAMED THAMER YAGUB YOUSEF ALSERKAL",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/03/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohamed Thamer Yagub Yousef Alserkal",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8a02f73b-0c45-4377-a5a5-bb12e0a14499",
        "address": "Mohamed Thamer Yaqub Yousef Alserkal ,الطابق الثاني ,اعمار سكوير - بناء رقم 4 ,برج خليفة ,57409 ,Dubai",
        "phone": "97142622217 / 97142622217",
        "email": "mohamed@alserkallawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "2a224392-a975-448f-aec5-0460984b1124",
    "firmName": "MOHAMED ALSERKAL ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-865",
    "licenseIssueDate": "03/07/2018 00:00:00",
    "licenseExpiryDate": "03/06/2026 00:00:00"
  },
  {
    "id": "aaba8110-2478-42b1-9362-22efda7c5b62",
    "slug": "mohamed-yousef-ahmed-mohamed-alyousef",
    "name": "MOHAMED YOUSEF AHMED MOHAMED ALYOUSIF",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Bankruptcy"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/04/2009",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: mohamed yousef ahmed mohamed alyousef",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_aaba8110-2478-42b1-9362-22efda7c5b62",
        "address": "first/105 ,Al Shafar Investment ,noor bank metro station ,34655 ,Dubai",
        "phone": "97143386111",
        "email": "unionadvocates1@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "109f3fc4-62e8-4523-9372-95aaf9a76483",
    "firmName": "UNION ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-603",
    "licenseIssueDate": "04/15/2009 00:00:00",
    "licenseExpiryDate": "04/14/2026 00:00:00"
  },
  {
    "id": "c7b8fc13-b4d2-411c-8a63-73f8eec63127",
    "slug": "mohammad-najib-abdulla-alhaj-hassan-fadhlani",
    "name": "HASSAN OBAID MOUSA ABDALLA ALKAABI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/01/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammad  Najib Abdulla Alhaj Hassan Fadhlani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c7b8fc13-b4d2-411c-8a63-73f8eec63127",
        "address": "الثالث  ,اركاد  ,الطاير للسيارات  ,20877 ,Dubai",
        "phone": "97142833355",
        "email": "Fahadadvo@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "7dd7860a-cd36-443b-a1b7-62dd3050e6b9",
    "firmName": "ADVOCATES UNIT",
    "registrationNumber": "L-1912",
    "licenseIssueDate": "02/01/2024 00:00:00",
    "licenseExpiryDate": "01/31/2026 00:00:00"
  },
  {
    "id": "559df7df-e3d6-44aa-8879-0653d8799905",
    "slug": "mohammad-abdulla-mohammed-hussain-alhammadi",
    "name": "MOHAMMAD ABDULLA MOHAMMAD HUSSAIN MOHAMMAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/09/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammad Abdulla Mohammed Hussain Alhammadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_559df7df-e3d6-44aa-8879-0653d8799905",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-973",
    "licenseIssueDate": "09/19/2019 00:00:00",
    "licenseExpiryDate": "09/18/2026 00:00:00"
  },
  {
    "id": "10eacbc7-8e95-4f81-8700-4978c0884095",
    "slug": "mohammad-abdullatif-mohammad-fiarooz-albalooshi",
    "name": "ABDULLATIF MOHAMMAD FAIROOZ",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/02/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammad Abdullatif Mohammad Fiarooz Albalooshi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_10eacbc7-8e95-4f81-8700-4978c0884095",
        "address": "YOUNIS MOHAMMED ALBLOOSHI ,3 - 1 ,the icon ,السيلكون ,117548 ,Dubai",
        "phone": "97145693206 / 971000000000",
        "email": "info@yblooshiadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "27278b02-4edf-490f-9d50-a1bc00678b6a",
    "firmName": "YOUNIS MOHAMMED AL BLOOSHI LAWYER & LEGAL CONSULTANTS",
    "registrationNumber": "L-858",
    "licenseIssueDate": "02/21/2013 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "30d6e655-42cd-4552-8114-a413380b66d3",
    "slug": "mohammad-abdulrahman-mohammad-abdulwahed",
    "name": "MOHAMMAD ABDULRAHMAN MOHD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/08/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammad Abdulrahman Mohammad Abdulwahed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_30d6e655-42cd-4552-8114-a413380b66d3",
        "address": "13 ,INTERNATIONAL BUSINESS TOWER ,Next to The First Collection Business Bay Hotel ,6917 ,Dubai",
        "phone": "97143421661 / 971527070780",
        "email": "mohammad@masoudlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "21caacdc-9052-48b5-921c-7c973ac4abd3",
    "firmName": "MOHAMMAD MASOUD ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-769",
    "licenseIssueDate": "08/03/2011 00:00:00",
    "licenseExpiryDate": "08/02/2026 00:00:00"
  },
  {
    "id": "4b619e9f-ed97-412d-a2bc-212cb93cb4a1",
    "slug": "mohammad-ahmad-ali-abdulla-alnajjar",
    "name": "MOHAMMAD AHMAD ALI ABDULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/12/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammad Ahmad Ali Abdulla Alnajjar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4b619e9f-ed97-412d-a2bc-212cb93cb4a1",
        "address": "",
        "phone": "97145642777 / 971508551535",
        "email": "legal@alnajjarlawyer.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "1670d8d1-6114-4b77-b2da-9d4c0dc0054b",
    "firmName": "MOHAMMAD ALNAJJAR ADVOCATES LEGAL CONSULTANTS",
    "registrationNumber": "L-1330",
    "licenseIssueDate": "12/27/2018 00:00:00",
    "licenseExpiryDate": "12/26/2025 00:00:00"
  },
  {
    "id": "dceca5d7-72e6-4bb1-b10f-b363d498d9c8",
    "slug": "mohammad-ahmad-ali-ahmad-allinjawi",
    "name": "MOHAMMAD AHMAD ALI AHMAD ALLINJAWI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/09/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammad Ahmad Ali Ahmad Allinjawi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dceca5d7-72e6-4bb1-b10f-b363d498d9c8",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-968",
    "licenseIssueDate": "09/08/2014 00:00:00",
    "licenseExpiryDate": "09/07/2026 00:00:00"
  },
  {
    "id": "4cf700ee-bdd3-4eb0-9fab-74d9166830d9",
    "slug": "mohammad-ahmad-mohammad-abdulla-loubari",
    "name": "MOHAMMAD AHMAD MOHAMMAD ABDULLA LOUBARI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/10/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammad Ahmad Mohammad Abdulla Loubari",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4cf700ee-bdd3-4eb0-9fab-74d9166830d9",
        "address": "4/406 ,Acico Business Park  ,Behind Nissan Showroom ,186344 ,Dubai",
        "phone": "97142989888 / 971505948989",
        "email": "AHMEDIBRAHIMLAW@GMAIL.COM",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "dbb4bc27-1ace-4e78-8ee2-db7bfd85e001",
    "firmName": "AHMED IBRAHIM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1388",
    "licenseIssueDate": "10/29/2019 00:00:00",
    "licenseExpiryDate": "10/28/2025 00:00:00"
  },
  {
    "id": "e7a035ce-47ba-42ae-ac2a-a573421c19a9",
    "slug": "mohammad-ahmad-saeed-al-saadi",
    "name": "Mohammad Ahmad Saeed Al-Saadi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 20,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/03/2005 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammad Ahmad Saeed Al-Saadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e7a035ce-47ba-42ae-ac2a-a573421c19a9",
        "address": "210 ,OPAL TOWER ,BURJ KHALIFA ,96044 ,Dubai",
        "phone": "97143889993",
        "email": "admin@alsaadi-advocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "8e611697-c589-4346-a3da-969764421cb6",
    "firmName": "MOHAMMAD ALSAADI ADVOCATES & LEGAL CONSULTANT",
    "registrationNumber": "527",
    "licenseIssueDate": "08/03/2005 00:00:00",
    "licenseExpiryDate": "08/02/2026 00:00:00"
  },
  {
    "id": "d4dc9fac-9cc6-4a4d-a334-0ec95b1cfc47",
    "slug": "mohammad-ali-mohammad-bin-qedad-almehairi",
    "name": "MOHAMMAD ALI MOHAMMAD BIN QEDAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/07/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammad Ali Mohammad Bin Qedad Almehairi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d4dc9fac-9cc6-4a4d-a334-0ec95b1cfc47",
        "address": "Mohammad Al Mheiri ,الاول ,امارات اتريم  ,شارع الشيخ زايد ,37979 ,Dubai",
        "phone": "97143333405",
        "email": "info@al-mheiri.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "455b5977-b40f-4801-b6bf-70838bb69abe",
    "firmName": "MOHAMMAD ALMEIHRI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1204",
    "licenseIssueDate": "07/17/2017 00:00:00",
    "licenseExpiryDate": "07/16/2026 00:00:00"
  },
  {
    "id": "d2c4955b-0489-4615-96b2-ad9ce07279be",
    "slug": "mohammad-essa-shambih-meftah-alblooshi",
    "name": "SAEED MOHAMMED MOHAMMED AHMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/09/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: MOHAMMAD ESSA SHAMBIH MEFTAH ALBLOOSHI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d2c4955b-0489-4615-96b2-ad9ce07279be",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-2031",
    "licenseIssueDate": "10/04/2024 00:00:00",
    "licenseExpiryDate": "10/03/2026 00:00:00"
  },
  {
    "id": "86439550-bce6-445d-94a0-00e976ea43df",
    "slug": "mohammad-hamad-masoud-ali-almusalam",
    "name": "MOHAMMAD HAMAD MASOUD ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/02/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammad Hamad Masoud Ali Almusalam",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_86439550-bce6-445d-94a0-00e976ea43df",
        "address": "13 ,INTERNATIONAL BUSINESS TOWER ,Next to The First Collection Business Bay Hotel ,6917 ,Dubai",
        "phone": "97143421661 / 971527070780",
        "email": "mohammad@masoudlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "21caacdc-9052-48b5-921c-7c973ac4abd3",
    "firmName": "MOHAMMAD MASOUD ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-857",
    "licenseIssueDate": "02/12/2013 00:00:00",
    "licenseExpiryDate": "02/11/2026 00:00:00"
  },
  {
    "id": "acc0d24e-01ea-425c-9964-6dec83761cfe",
    "slug": "mohammad-ibrahim-abdulla-kamalpoor-albastaki",
    "name": "MOHAMMAD IBRAHIM ABDULLA KAMALPOOR ALBASTAKI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/09/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammad Ibrahim Abdulla Kamalpoor Albastaki",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_acc0d24e-01ea-425c-9964-6dec83761cfe",
        "address": "amal albastaki ,1903 ,court ,business bay ,127477 ,Dubai",
        "phone": "97142522202",
        "email": "info@amaladvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "f852bccd-2696-4190-9b40-77a8fb9c460f",
    "firmName": "AMAL ALBASTAKI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-1227",
    "licenseIssueDate": "10/01/2017 00:00:00",
    "licenseExpiryDate": "09/30/2026 00:00:00"
  },
  {
    "id": "136b86d9-1966-4097-ac76-d57b2d4af03f",
    "slug": "mohammad-ibrahim-abdulrahim-abdulla",
    "name": "MOHAMMAD IBRAHIM ABDULRAHIM ABDULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/11/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammad Ibrahim Abdulrahim Abdulla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_136b86d9-1966-4097-ac76-d57b2d4af03f",
        "address": "الطابق 33/ الوحدة : 3304 ,مبني المنارة /   الطابق 33/ الوحدة : 3304 ,فندق جي دبليو ماركيز  ,24002 ,Dubai",
        "phone": "97144254373",
        "email": "info@wkadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "332a3a67-50f2-424a-a5c1-d5abaf9a030b",
    "firmName": "WALEED ALMARZOOQI AND KHALID MOHAMED ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-1324",
    "licenseIssueDate": "11/20/2018 00:00:00",
    "licenseExpiryDate": "11/19/2025 00:00:00"
  },
  {
    "id": "3669ae73-0a3f-4429-97c6-abc9be4d285b",
    "slug": "mohammad-ibrahim-mohammad-ahmad-mohammad-alqassim",
    "name": "MOHAMMAD IBRAHIM MOHAMMAD AHMAD ALQASSIM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/05/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammad Ibrahim Mohammad Ahmad Mohammad Alqassim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3669ae73-0a3f-4429-97c6-abc9be4d285b",
        "address": "",
        "phone": "97142224441",
        "email": "info@ialqassim.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "41cb350f-b39d-4e9d-aaed-e79bb9af487d",
    "firmName": "IBRAHIM AL QASSIM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-757",
    "licenseIssueDate": "05/12/2011 00:00:00",
    "licenseExpiryDate": "05/11/2026 00:00:00"
  },
  {
    "id": "56449d74-16a9-45ab-ae98-a8873209478c",
    "slug": "mohammad-mubarak-mohammad-alwasham-aljneibi",
    "name": "HUSAIN ALI MOHAMED HASAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/01/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammad Mubarak Mohammad Alwasham Aljneibi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_56449d74-16a9-45ab-ae98-a8873209478c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1744"
  },
  {
    "id": "d9480a76-b389-406d-8305-4814a14f5bbc",
    "slug": "mohammad-obaod-khalfan-al-raddha",
    "name": "MOHAMMAD OBAID KHALFAN ALRADDHA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Civil Transactions-Construction and Contracts for Services",
      "Criminal Law-Family Crimes",
      "Civil Transactions-Immigration and Residency",
      "Commercial Transactions-Commercial Real Estate",
      "Civil Transactions-Residential Real Estate",
      "Criminal Law-Crimes against persons",
      "Personal Status-Legacies and Inheritance",
      "Criminal Law-Drug Crimes",
      "Civil Transactions-Sale",
      "Personal Status-Marriage & Divorce",
      "Personal Status-Child Abuse & Abduction",
      "Civil Transactions-Compensation",
      "Criminal Law-Crimes against properties",
      "Criminal Law-Cybercrimes",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 20,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/02/2005",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammad Obaod Khalfan Al Raddha",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d9480a76-b389-406d-8305-4814a14f5bbc",
        "address": "",
        "phone": "97143366080",
        "email": "info@accordlawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "0c25ab44-71a4-49f3-9d94-7b5a222500f2",
    "firmName": "ACCORD INTERNATIONAL ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-512",
    "licenseIssueDate": "02/27/2005 00:00:00",
    "licenseExpiryDate": "02/26/2026 00:00:00"
  },
  {
    "id": "b818cf78-94f2-4bb8-bb40-f8e302d62d6d",
    "slug": "mohammad-saleh-tuwired-salem-almenhali",
    "name": "MOHAMED SALEH TUWIRED SALEM ALMENHALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Civil Transactions-Tenancy"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/07/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammad Saleh Tuwired Salem Almenhali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b818cf78-94f2-4bb8-bb40-f8e302d62d6d",
        "address": "first/105 ,Al Shafar Investment ,noor bank metro station ,34655 ,Dubai",
        "phone": "97143386111",
        "email": "unionadvocates1@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "109f3fc4-62e8-4523-9372-95aaf9a76483",
    "firmName": "UNION ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1301",
    "licenseIssueDate": "08/01/2018 00:00:00",
    "licenseExpiryDate": "07/31/2026 00:00:00"
  },
  {
    "id": "9849cb2e-a56a-4d68-b2f7-7817dab34585",
    "slug": "mohammad-shehab-ahmad-thani-alfarsi",
    "name": "MOHAMMAD SHEHAB AHMAD THANI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/11/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: MOHAMMAD SHEHAB AHMAD THANI ALFARSI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9849cb2e-a56a-4d68-b2f7-7817dab34585",
        "address": "",
        "phone": "97143256020 / 971504400073",
        "email": "info@sw-advocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "05dddabf-0dfa-4843-b0a8-cf6eaa27136d",
    "firmName": "MOHAMMAD SHEHAB ALFARSI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1592",
    "licenseIssueDate": "11/04/2021 00:00:00",
    "licenseExpiryDate": "11/03/2025 00:00:00"
  },
  {
    "id": "3a52a175-d22b-46c0-a764-8e27672ed956",
    "slug": "mohammad-talal-mohammad-hassan-al-tamimi",
    "name": "MOHAMMAD TALAL MOHAMMAD ALTAMIMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Civil Transactions-HR & Employee Affairs",
      "Criminal Law-Family Crimes",
      "Personal Status-Custody & Alimony",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Civil Transactions-Tenancy",
      "Criminal Law-Crimes against persons",
      "Personal Status-Legacies and Inheritance",
      "Personal Status-Legal Capacity & Guardianship",
      "Personal Status-Marriage & Divorce",
      "Civil Transactions-Compensation",
      "Criminal Law-Cybercrimes"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/03/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammad Talal Mohammad Hassan Al Tamimi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3a52a175-d22b-46c0-a764-8e27672ed956",
        "address": "",
        "phone": "97143300009 / 971501215000",
        "email": "mohamed@maa.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "af85c161-b73d-46a2-9fd7-4d8604007473",
    "firmName": "MOHAMMED ALI ALHAMMADI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-923",
    "licenseIssueDate": "03/24/2014 00:00:00",
    "licenseExpiryDate": "03/23/2026 00:00:00"
  },
  {
    "id": "585fdbfc-c745-41bf-9410-e23c7cc50a27",
    "slug": "mohammed-abdulhameid-abdulla-al-khazraji",
    "name": "MOHAMED ABDUL HAMEED ABDULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 15,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/05/2010",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammed Abdulhameid Abdulla Al-Khazraji",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_585fdbfc-c745-41bf-9410-e23c7cc50a27",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-388",
    "licenseIssueDate": "05/10/2010 00:00:00",
    "licenseExpiryDate": "05/09/2026 00:00:00"
  },
  {
    "id": "7661d66b-63f6-4389-af41-1222056da919",
    "slug": "mohammed-abdulla-abdulkareim-blooki",
    "name": "MOHAMMAD ABDULLA ABDULKARIM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 27,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/01/1998",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammed Abdulla Abdulkareim Blooki",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7661d66b-63f6-4389-af41-1222056da919",
        "address": "الخامس ,الشعلة بلوك اية ,داناتا ,127179 ,Dubai",
        "phone": "97143318888 / 971509984724",
        "email": "ameizar@salamadvo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "1b4e6bd9-712b-49bf-a169-fd31ea45cd51",
    "firmName": "SALAM ADVOCATE & LEGAL CONSULTANTS",
    "registrationNumber": "L-326",
    "licenseIssueDate": "01/19/1998 00:00:00",
    "licenseExpiryDate": "01/18/2026 00:00:00"
  },
  {
    "id": "1ae7226f-cad4-48bb-bda5-9cb780c861ae",
    "slug": "mohammed-abdulla-al-ebidli",
    "name": "MOHAMED ABDULLA ALI ALOBEIDLI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 27,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/05/1998",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammed Abdulla Al-Ebidli",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1ae7226f-cad4-48bb-bda5-9cb780c861ae",
        "address": "ادارة ا لمبنى  ,الريم ,الاتصالات  ,42423 ,Dubai",
        "phone": "97142222066",
        "email": "info@ozleco.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "7a155f4a-20ec-44ff-863f-4f9fb43d0af4",
    "firmName": "ALOBAIDLI & ALZAROONI ADVOCATES&LEGAL CONSULTANTS",
    "registrationNumber": "L-336",
    "licenseIssueDate": "06/01/1998 00:00:00",
    "licenseExpiryDate": "05/31/2026 00:00:00"
  },
  {
    "id": "cd092105-e1f7-4fb3-8d72-e1799a41fa57",
    "slug": "mohammed-abdulla-ali-mohammed-ahmed",
    "name": "MOHAMMED ABDULLA ALI MOHD AHMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/05/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammed Abdulla Ali Mohammed Ahmed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cd092105-e1f7-4fb3-8d72-e1799a41fa57",
        "address": "",
        "phone": "97143702000 / 971504844414",
        "email": "advoy.m@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "22c36bcb-1914-4128-9816-406ffc0aec47",
    "firmName": "MOHAMMED ABDULLA & YOUSUF ALHAMMADI ADVOCATE LEGAL CONSULTANTS",
    "registrationNumber": "L-810",
    "licenseIssueDate": "05/13/2012 00:00:00",
    "licenseExpiryDate": "05/12/2026 00:00:00"
  },
  {
    "id": "fd23b6d3-b64d-46c6-8772-fbd0bfefcc5e",
    "slug": "mohammed-abdulla-mohsin-abdulrahim-albreki",
    "name": "MOHAMMED ABDULLA MOHSIN ABDULRAHIM ALBREIKI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/11/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammed Abdulla Mohsin Abdulrahim Albreki",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fd23b6d3-b64d-46c6-8772-fbd0bfefcc5e",
        "address": "MOHAMMED ABDULLA MOHSIN ABDURAHIM ALBREIKI ,406 ,ويست بيري ,برج خليفة ,220219 ,Dubai",
        "phone": "97145574529",
        "email": "d@albraikiadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "ef095fb8-c3b5-42bc-92fc-43528c870fe7",
    "firmName": "MOHAMMED ABDULLA ALBREIKE LEGAL CONSULTANTS",
    "registrationNumber": "L-842",
    "licenseIssueDate": "11/26/2012 00:00:00",
    "licenseExpiryDate": "11/25/2025 00:00:00"
  },
  {
    "id": "ef402d04-7da2-4537-bdff-2a82121b0d3c",
    "slug": "mohammed-abdulla-saeed-nehail-alnuaimi",
    "name": "MOHAMMED ABDULLA SAEED NEHAIL ALNUAIMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/02/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammed Abdulla Saeed Nehail Alnuaimi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ef402d04-7da2-4537-bdff-2a82121b0d3c",
        "address": "Salem Bahyan ,1103 ,Latifa ,First Trade Center ,20611 ,Dubai",
        "phone": "97143214231 / 97145645961",
        "email": "info@bbadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "6850aee4-bff6-42c3-a738-12cee3f47b0d",
    "firmName": "SALEM BIN BAHYAN ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1635",
    "licenseIssueDate": "02/17/2022 00:00:00",
    "licenseExpiryDate": "02/16/2026 00:00:00"
  },
  {
    "id": "5129b4a6-27c8-4410-a67a-3add46199653",
    "slug": "mohammed-abdulla-salem-nasser-alameri",
    "name": "MOHMMEAD SULTAN ABDULAZIZ RASHED ALNUAIMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/07/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: MOHAMMED ABDULLA SALEM NASSER ALAMERI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5129b4a6-27c8-4410-a67a-3add46199653",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-2009",
    "licenseIssueDate": "07/24/2024 00:00:00",
    "licenseExpiryDate": "07/23/2026 00:00:00"
  },
  {
    "id": "9f7e3897-7c36-4553-9439-047cf474b887",
    "slug": "mohammed-abdulmalek-mustafa-ahli",
    "name": "MOHAMMAD ABDULMALIK MUSTAFA AHLI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 28,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/11/1996",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammed Abdulmalek Mustafa Ahli",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9f7e3897-7c36-4553-9439-047cf474b887",
        "address": "",
        "phone": "97142227008 / 971506245451",
        "email": "info@abdulmaliklaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "5714833f-5b48-477b-a556-efa3a779f522",
    "firmName": "ABDULMALIK & ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-285",
    "licenseIssueDate": "11/14/1996 00:00:00",
    "licenseExpiryDate": "11/13/2025 00:00:00"
  },
  {
    "id": "8ea75209-7f57-420e-9a39-587faa12b165",
    "slug": "mohammed-abdulrahman-al-bakr",
    "name": "MOHAMMED ABDULRAHMAN MOHAMMED ALBAKR",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/10/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammed Abdulrahman Al Bakr",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8ea75209-7f57-420e-9a39-587faa12b165",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-156",
    "licenseIssueDate": "10/23/2013 00:00:00",
    "licenseExpiryDate": "10/22/2025 00:00:00"
  },
  {
    "id": "ef500dc6-3393-41de-863a-fd6830667240",
    "slug": "mohammed-ahmad-ham-salem-al-ketheri",
    "name": "Mohammed Ahmad Ham Salem Al-Ketheri",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/15/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammed Ahmad Ham Salem Al-Ketheri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ef500dc6-3393-41de-863a-fd6830667240",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "369",
    "licenseIssueDate": "03/15/2021 00:00:00",
    "licenseExpiryDate": "03/14/2026 00:00:00"
  },
  {
    "id": "8119ad8a-514f-425c-816d-6e59b6003457",
    "slug": "mohammed-ahmed-ali-abdulrahman-buhashem",
    "name": "MOHAMMED AHMED ALI BUHASHEM ALHASHMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/03/2009",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: MOHAMMED AHMED ALI ABDULRAHMAN BUHASHEM",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8119ad8a-514f-425c-816d-6e59b6003457",
        "address": "1007 ,برج لطيفة ,بجوار فندق كراون بلازل ,94873 ,Abu Dhabi",
        "phone": "97142951555 / 971567573911",
        "email": "info@mbhadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "2d3e210f-8234-4e00-b9e6-1167758a43ee",
    "firmName": "MOHAMMED BANI HASHEM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-659",
    "licenseIssueDate": "03/30/2009 00:00:00",
    "licenseExpiryDate": "03/29/2026 00:00:00"
  },
  {
    "id": "b8059129-e4bb-4d30-8822-977b26deacf8",
    "slug": "mohammed-ahmed-mohammed-abdulla",
    "name": "MOHAMMED AHMED MOHAMMED ABDULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 15,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/09/2010",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammed Ahmed Mohammed Abdulla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b8059129-e4bb-4d30-8822-977b26deacf8",
        "address": "",
        "phone": "97143588887",
        "email": "e.lawyersd@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "9aeb8716-ff23-4200-90de-c2e0ee86076e",
    "firmName": "MOHAMMED AHMED ADVOCATE & LEGEL CONSULTANTS",
    "registrationNumber": "L-726",
    "licenseIssueDate": "09/29/2010 00:00:00",
    "licenseExpiryDate": "09/28/2026 00:00:00"
  },
  {
    "id": "98424f2c-9274-44f2-b9d8-d566c074e157",
    "slug": "mohammed-albrek-abdulla-salem-alameri",
    "name": "YOUSEF SAIF MOHAMMED BAL ASLI AL DHAHERI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/04/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: mohammed albrek abdulla salem alameri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_98424f2c-9274-44f2-b9d8-d566c074e157",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1947",
    "licenseIssueDate": "05/05/2024 00:00:00",
    "licenseExpiryDate": "05/04/2026 00:00:00"
  },
  {
    "id": "6f3f2f88-cec2-404e-879a-6528820a1fd7",
    "slug": "mohammed-ali-abdulla-kamali",
    "name": "MOHAMMAD ALI ABDULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 27,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/11/1997",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-11-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammed Ali Abdulla Kamali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6f3f2f88-cec2-404e-879a-6528820a1fd7",
        "address": "3-505 ,AL KHABEESI BLDG ,AL KABEESI ,4948 ,Dubai",
        "phone": "97142222228",
        "email": "info@alkamali.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "054f38f4-9e51-4623-ad36-7941043a051c",
    "firmName": "ALKAMALI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-320",
    "licenseIssueDate": "11/20/1997 00:00:00",
    "licenseExpiryDate": "11/19/2025 00:00:00"
  },
  {
    "id": "89a586d4-4c9b-4fd5-8420-73149fa711b0",
    "slug": "mohammed-ali-humaid-alkumaiti-alshamsi",
    "name": "MOHAMMED ALI H. ALKUMAITI ALSHAMSI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/01/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammed Ali Humaid Alkumaiti Alshamsi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_89a586d4-4c9b-4fd5-8420-73149fa711b0",
        "address": "Office 210 ,Al-Fajr Complex ,Makani No: 2999793136 ,000 ,Dubai",
        "phone": "97142297799 / 971505504550",
        "email": "info@mkumaiti.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "d064ef91-4855-4ed3-b54e-062ea8ccc287",
    "firmName": "MOHAMMED ALKUMAITI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-910",
    "licenseIssueDate": "01/16/2014 00:00:00",
    "licenseExpiryDate": "01/15/2026 00:00:00"
  },
  {
    "id": "a913ade9-23e8-4505-8a16-e027c1983cc4",
    "slug": "mohammed-ali-salman-al-marzooqi",
    "name": "MOHAMED ALI SALMAN ALMARZOOQI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 32,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/02/1993",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammed Ali Salman Al-Marzooqi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a913ade9-23e8-4505-8a16-e027c1983cc4",
        "address": "MOHAMMED ALI SALMAN AL MARZOOQI ,الثالث  ,السركال  ,معرض سيارات الفطيم  ,39059 ,Dubai",
        "phone": "97142500008",
        "email": "adv.saad@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "6bba829c-0392-4c72-a71b-01da72cb24ae",
    "firmName": "MOHAMED SALMAN ADVOCATE & LEGAL CONSULTANCY",
    "registrationNumber": "L-253",
    "licenseIssueDate": "02/21/1993 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "93b0daf1-8bab-41e8-950f-34802dab339a",
    "slug": "mohammed-ali-sultan-altaweel-almheiri",
    "name": "MOHAMMED ALI SULTAN ALTAWEEL ALMHEIRI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/04/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammed Ali Sultan Altaweel Almheiri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_93b0daf1-8bab-41e8-950f-34802dab339a",
        "address": "",
        "phone": "97142659440",
        "email": "info@klaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "d42ce31f-e881-40e1-bd66-bf2e5bb9bb1e",
    "firmName": "KHALED ALMARRI & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1102",
    "licenseIssueDate": "04/05/2023 00:00:00",
    "licenseExpiryDate": "04/04/2026 00:00:00"
  },
  {
    "id": "9df7115b-bff6-4858-bc33-3091a33b978a",
    "slug": "mohammed-ebrahim-hasan-almulla-almansoori",
    "name": "MOHAMMED EBRAHIM HASAN ALMANSOORI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/07/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammed Ebrahim Hasan Almulla Almansoori",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9df7115b-bff6-4858-bc33-3091a33b978a",
        "address": "Azza Ebrahim Hasan Almulla ,6(602-603) ,Al Shoalla Building (Al Naboodah) ,deira city center ,12871 ,Dubai",
        "phone": "97142950010",
        "email": "dubai-secretary@dralmulla.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "fbf6220f-2608-4caa-895e-d45ae8a259a2",
    "firmName": "AZZA IBRAHIM HASSAN AL MULLA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-807",
    "licenseIssueDate": "07/19/2023 00:00:00",
    "licenseExpiryDate": "07/18/2026 00:00:00"
  },
  {
    "id": "1626722b-36e2-4d2d-8395-f22922096159",
    "slug": "mohammed-essa-sultan-al-sowaidi",
    "name": "MOHAMMAD ESSA SULTAN AL SOWAIDI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 24,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/12/2000",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammed Essa Sultan Al-Sowaidi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1626722b-36e2-4d2d-8395-f22922096159",
        "address": "الطابق 8 مكتب رقم 802-804 ,AL MASAOOD TOWE 2 ,الفطيم للسيارات  - ديرة  ,31909 ,Dubai",
        "phone": "97142946948",
        "email": "hadi.jomah@baitulhikma.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "a1a1a791-7d0a-4afa-a043-cd85f0998888",
    "firmName": "BAITULHIKMA LAWYERS",
    "registrationNumber": "L-108",
    "licenseIssueDate": "12/11/2000 00:00:00",
    "licenseExpiryDate": "12/10/2025 00:00:00"
  },
  {
    "id": "7cc39053-a98a-44b4-b647-1af68dfb0269",
    "slug": "mohammed-hadef-jouan-rashed-aldhaheri",
    "name": "MOHAMMED HADEF JOUAN RASHED ALDHAHERI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/03/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammed Hadef Jouan Rashed Aldhaheri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7cc39053-a98a-44b4-b647-1af68dfb0269",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-744",
    "licenseIssueDate": "03/08/2011 00:00:00",
    "licenseExpiryDate": "03/07/2026 00:00:00"
  },
  {
    "id": "04784a03-2cca-4d90-bc8d-df87205ec146",
    "slug": "mohammed-haji-hasan-ali-al-marzooqi",
    "name": "MOHAMED HAJI HASAN ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/01/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammed Haji Hasan Ali Al Marzooqi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_04784a03-2cca-4d90-bc8d-df87205ec146",
        "address": "التاسع ,مكتب 903 ملك خالد عبدالرحيم احمد العطار - ذا تاور بلازا ,ذا تاور بلازا ,38350 ,Dubai",
        "phone": "97145873377 / 971564643109",
        "email": "ahm@ahmlawfirms.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "1b2ae5cc-a1db-4e6a-bf98-59d41bdb6127",
    "firmName": "ALI HASAN ALHAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1499",
    "licenseIssueDate": "01/20/2021 00:00:00",
    "licenseExpiryDate": "01/19/2026 00:00:00"
  },
  {
    "id": "276dc3a8-ca9c-4811-a2a6-fb94f3962bbe",
    "slug": "mohammed-hassan-darweesh-ali-al-raeesi",
    "name": "SULAIMAN AHMED SULAIMAN ALSHARARI ALDHANHANI AL SHARARI ALDHANHANI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/03/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammed Hassan Darweesh Ali Al Raeesi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_276dc3a8-ca9c-4811-a2a6-fb94f3962bbe",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-2087",
    "licenseIssueDate": "04/11/2025 00:00:00",
    "licenseExpiryDate": "04/10/2026 00:00:00"
  },
  {
    "id": "f2c1e865-958e-41ee-aafd-5f72c8a61c45",
    "slug": "mohammed-hassan-ibrahim-abdulla-alshaer",
    "name": "MOHAMMAD HASSAN IBRAHIM ABDULLA ALSHAER",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/12/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammed Hassan Ibrahim Abdulla Alshaer",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f2c1e865-958e-41ee-aafd-5f72c8a61c45",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1484",
    "licenseIssueDate": "12/08/2020 00:00:00",
    "licenseExpiryDate": "12/07/2025 00:00:00"
  },
  {
    "id": "7ac81255-ca02-467e-903b-703adb21cb68",
    "slug": "mohammed-hassan-yousef-hatem-alhosani",
    "name": "SAEED EISSA BAKHEET HUWAIREB ALMANSOORI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/03/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: mohammed hassan yousef hatem alhosani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7ac81255-ca02-467e-903b-703adb21cb68",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1790",
    "licenseIssueDate": "04/19/2023 00:00:00",
    "licenseExpiryDate": "04/18/2026 00:00:00"
  },
  {
    "id": "2093ad84-c26c-49fb-9cdb-2eb5ab6479bd",
    "slug": "mohammed-husein-bekhit-hidijan-al-msaabin",
    "name": "MOHAMED HUSAIN BAKHEET HEDAIJAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 20,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/06/2005",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammed Husein Bekhit Hidijan Al-Msa'abin",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2093ad84-c26c-49fb-9cdb-2eb5ab6479bd",
        "address": "406 ,رقة البطين  ,بجوار فندق كونكورد  ,92414 ,Dubai",
        "phone": "97142666331",
        "email": "almeshref2019@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "b47f195f-addd-458d-85ec-bb93239bbe4b",
    "firmName": "MOHAMMED BEKHIT ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-521",
    "licenseIssueDate": "06/07/2005 00:00:00",
    "licenseExpiryDate": "06/06/2026 00:00:00"
  },
  {
    "id": "ae6db301-2835-420a-9374-f12378bfd655",
    "slug": "mohammed-ibraheim-hasan-al-sheibah",
    "name": "MOHAMED IBRAHIM HASSAN ALSHAIBA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 22,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/06/2003",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammed Ibraheim Hasan Al-Sheibah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ae6db301-2835-420a-9374-f12378bfd655",
        "address": "MOHAMED IBRAHIM HASSAN ALSHAIBA ,KANA CAF ,51TOWER ,KANA CAFE ,35351 ,Dubai",
        "phone": "97142384444",
        "email": "Alshaiba@alshaibaadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "3de1a3a0-760f-4d53-95b1-cecbac061394",
    "firmName": "ALSHAIBA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-452",
    "licenseIssueDate": "06/21/2003 00:00:00",
    "licenseExpiryDate": "06/20/2026 00:00:00"
  },
  {
    "id": "ba919786-caa1-4c7b-9539-cc76ecf95db5",
    "slug": "mohammed-jaber-ahmed-binjaber-alshamsi",
    "name": "MOHAMMED JABER AHMED BINJABER ALSHAMSI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/09/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammed Jaber Ahmed Binjaber Alshamsi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ba919786-caa1-4c7b-9539-cc76ecf95db5",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1568",
    "licenseIssueDate": "09/23/2021 00:00:00",
    "licenseExpiryDate": "09/22/2026 00:00:00"
  },
  {
    "id": "66f00b98-32fe-4adf-b464-3b091d8d6e67",
    "slug": "mohammed-jasem-mohammed-fahad-almari",
    "name": "MOHAMMED JASEM MOHAMMED GHURAB ALMARRI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/08/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammed Jasem Mohammed Fahad Almari",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_66f00b98-32fe-4adf-b464-3b091d8d6e67",
        "address": "",
        "phone": "97143213302",
        "email": "lawfirm@liberallawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "a791ae2d-579f-42dd-945f-b28c198a33e4",
    "firmName": "LIBERALS LAWYERS LEGAL CONSULTANTS AND LAWYERS",
    "registrationNumber": "L-1303",
    "licenseIssueDate": "08/02/2018 00:00:00",
    "licenseExpiryDate": "08/01/2026 00:00:00"
  },
  {
    "id": "31b5abd9-3049-4259-bc70-83462708d336",
    "slug": "mohammed-khadem-saeed-mohammed-alghaithi",
    "name": "MOHAMMED KHADEM SAEED MOHAMMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/07/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammed Khadem Saeed Mohammed Alghaithi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_31b5abd9-3049-4259-bc70-83462708d336",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1296",
    "licenseIssueDate": "07/03/2018 00:00:00",
    "licenseExpiryDate": "07/02/2026 00:00:00"
  },
  {
    "id": "1d543c29-9e3c-484c-a3d7-f9cd583f36dd",
    "slug": "mohammed-khalifa-abdulah-rashid-al-mualla",
    "name": "SHAIKH MOHAMED KHALIFA ABDULLA ALMUALLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 23,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/07/2002",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammed Khalifa Abdulah Rashid Al Mualla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1d543c29-9e3c-484c-a3d7-f9cd583f36dd",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-430",
    "licenseIssueDate": "07/16/2002 00:00:00",
    "licenseExpiryDate": "07/15/2026 00:00:00"
  },
  {
    "id": "05913821-9a17-4a75-8d6c-39cac5380823",
    "slug": "mohammed-mahfoodh-mohammed-ali-alshehhi",
    "name": "MOHAMMED MAHFOODH MOHAMMED A ALSHEHHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/07/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammed Mahfoodh Mohammed Ali Alshehhi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_05913821-9a17-4a75-8d6c-39cac5380823",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-766",
    "licenseIssueDate": "07/05/2011 00:00:00",
    "licenseExpiryDate": "07/04/2026 00:00:00"
  },
  {
    "id": "c2bb95d8-8e78-4f9c-9a8d-eb2f99cf753a",
    "slug": "mohammed-marwan-abdulla-almatrooshi",
    "name": "NASIR SALEH AHMED DHAIFALLA ALMESSABI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/08/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: mohammed marwan abdulla almatrooshi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c2bb95d8-8e78-4f9c-9a8d-eb2f99cf753a",
        "address": "Mezzanine / 09 ,Business Point  ,Behind Nissan Showroom ,85825 ,Dubai",
        "phone": "97142595777",
        "email": "ALMATROOSHI@OMALC.AE",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "588c9e2f-4f09-44bb-9e80-4e56d3f821b6",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1857",
    "licenseIssueDate": "08/30/2023 00:00:00",
    "licenseExpiryDate": "08/29/2026 00:00:00"
  },
  {
    "id": "20105416-8bd7-4d88-8844-5aef955e45f4",
    "slug": "mohammed-naseser-abdulla-bufarha-alshamsi",
    "name": "MOHAMMED NASSER A BUFARHA ALSHAMSI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/08/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammed Naseser Abdulla Bufarha Alshamsi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_20105416-8bd7-4d88-8844-5aef955e45f4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1440",
    "licenseIssueDate": "08/04/2020 00:00:00",
    "licenseExpiryDate": "08/03/2026 00:00:00"
  },
  {
    "id": "c8e45b2f-fd96-452a-af43-a855d39e5fe1",
    "slug": "mohammed-ramez-yousef-fustoq",
    "name": "Mohammed Ramez Yousef Fustoq",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 47,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/08/1978 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2022-07-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammed Ramez Yousef Fustoq",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c8e45b2f-fd96-452a-af43-a855d39e5fe1",
        "address": "MOUHAMAD RAMEZ YOUSSEF FUSTUQ ,212 ,DIAMOND BUSINESS CENTER 1 - B ,Dubai Miracle Garden ,81359 ,Dubai",
        "phone": "97142384727",
        "email": "mandflaw@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "dbd24b15-854f-4da7-b9a6-0eb7a3aae993",
    "firmName": "AL SAQER ADVOCATES",
    "registrationNumber": "65",
    "licenseIssueDate": "05/08/1978 00:00:00",
    "licenseExpiryDate": "05/07/2022 00:00:00"
  },
  {
    "id": "e46edddd-7847-4752-9804-aa8e6600abf2",
    "slug": "mohammed-saghaer-ali-alawami-almansoori",
    "name": "MOHAMMED SAGHAER ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/01/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammed Saghaer Ali Alawami Almansoori",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e46edddd-7847-4752-9804-aa8e6600abf2",
        "address": "Mohammed Saghaer Ali Al Awami Al Mansoori ,3 ,IT PLAZA ,Green Belt Supermarket ,25626 ,Dubai",
        "phone": "97143338885",
        "email": "info@alawami.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "6ada2495-c722-4585-bbc3-2b70e5c9fcf9",
    "firmName": "ALAWAMI ALMANSOORI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-1136",
    "licenseIssueDate": "01/04/2017 00:00:00",
    "licenseExpiryDate": "01/03/2026 00:00:00"
  },
  {
    "id": "e7cc29a0-1d81-4251-b45f-63c24cbff0f9",
    "slug": "mohammed-said-salim-al-shamsi",
    "name": "MOHAMMED SAEED SALEM ALSHAMSI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/01/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammed Said Salim Al Shamsi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e7cc29a0-1d81-4251-b45f-63c24cbff0f9",
        "address": "الطابق الثالث -مكتب رقم 312  ,اعمار بزنس بارك -مبنى رقم 4  ,مصرف رأس الخيمة الوطنى ,336684 ,Dubai",
        "phone": "97144466072 / 971569807807",
        "email": "infobiadvocates@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "abb9efff-73d9-42e6-af59-29b92f4e2d09",
    "firmName": "MOHAMMED SAEED ALSHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-906",
    "licenseIssueDate": "01/14/2014 00:00:00",
    "licenseExpiryDate": "01/13/2026 00:00:00"
  },
  {
    "id": "f33a15e0-c0d6-4766-9f1c-859d6d9f5c08",
    "slug": "mohammed-saif-mohammed-saif-altamimi",
    "name": "MOHAMMED SAIF MOHAMMED SAIF",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/08/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammed Saif Mohammed Saif Altamimi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f33a15e0-c0d6-4766-9f1c-859d6d9f5c08",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1217",
    "licenseIssueDate": "08/21/2017 00:00:00",
    "licenseExpiryDate": "08/20/2026 00:00:00"
  },
  {
    "id": "18692d8a-38b5-4bfb-a3f3-cc43a6c39a06",
    "slug": "mohammed-salem-mohammed-hasan-alkhateri",
    "name": "MOHAMMED SALEM MOHAMMED H ALKHATRI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/12/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: MOHAMMED SALEM MOHAMMED HASAN ALKHATERI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_18692d8a-38b5-4bfb-a3f3-cc43a6c39a06",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1240",
    "licenseIssueDate": "12/10/2017 00:00:00",
    "licenseExpiryDate": "12/09/2025 00:00:00"
  },
  {
    "id": "18e07d4c-cc13-4bcd-9866-2d503ab90e60",
    "slug": "mohammed-salman-hassan-al-saberi",
    "name": "MOHAMMED SALMAN HASSAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 38,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/12/1986",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammed Salman Hassan Al-Saberi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_18e07d4c-cc13-4bcd-9866-2d503ab90e60",
        "address": "السادس , مباني الحضيبة للجوائز  ,علم الاتحاد ,200 ,Dubai",
        "phone": "97143545111",
        "email": "altaher_alsabri@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "aced7900-0571-43e1-b49b-4740c6dc298f",
    "firmName": "AL TAHER & AL SABRI ADVOCATES",
    "registrationNumber": "L-168",
    "licenseIssueDate": "12/22/1986 00:00:00",
    "licenseExpiryDate": "12/21/2025 00:00:00"
  },
  {
    "id": "5d9c85a4-1247-4fe5-94bb-963a6ed6a8c2",
    "slug": "mohammed-slayem-suhail-al-aswad-alameri",
    "name": "MOHAMMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/04/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammed Slayem Suhail Al Aswad Alameri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5d9c85a4-1247-4fe5-94bb-963a6ed6a8c2",
        "address": "",
        "phone": "/ 97151111146",
        "email": "info@alphalegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "8576864d-ec5e-4834-b800-88160aa2c0a5",
    "firmName": "ALPHA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-936",
    "licenseIssueDate": "04/21/2014 00:00:00",
    "licenseExpiryDate": "04/20/2026 00:00:00"
  },
  {
    "id": "a19fd153-bcb6-4987-a09a-2c7c42af9d8b",
    "slug": "mohammed-sultan-abdul-aziz-rashed-alnuaimi",
    "name": "AMNAH ALI OBAID ALI AL KAABI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/06/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammed Sultan Abdul Aziz Rashed Alnuaimi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a19fd153-bcb6-4987-a09a-2c7c42af9d8b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-2003",
    "licenseIssueDate": "07/21/2024 00:00:00",
    "licenseExpiryDate": "07/20/2026 00:00:00"
  },
  {
    "id": "cc39d214-9482-4910-a983-a6ece56e1d57",
    "slug": "mohammed-yousuf-abdulrahim-abdulla",
    "name": "MOHAMMED YOUSUF ABDULRAHIM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/10/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohammed Yousuf Abdulrahim Abdulla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cc39d214-9482-4910-a983-a6ece56e1d57",
        "address": "",
        "phone": "/ 971500000000",
        "email": "morshedy.legal@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "9ae432c2-4110-4a73-9ff7-f5f33baaef76",
    "firmName": "MOHAMMED YOUSUF ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-833",
    "licenseIssueDate": "10/27/2019 00:00:00",
    "licenseExpiryDate": "10/26/2025 00:00:00"
  },
  {
    "id": "7f220db7-2508-4999-b268-5126d91a7820",
    "slug": "mohd-abdulla-jan-ali-al-redha",
    "name": "MOHAMMAD ABDULLA JAN ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Commercial Agency",
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Civil Transactions-POA & Sponsorship",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Personal Status-Wills",
      "Civil Transactions-Construction and Contracts for Services",
      "Civil Transactions-Ownership & Title",
      "Civil Transactions-HR & Employee Affairs",
      "Criminal Law-Family Crimes",
      "Civil Transactions-Immigration and Residency",
      "Commercial Transactions-Commercial Real Estate",
      "Civil Transactions-Residential Real Estate",
      "Criminal Law-Hate crimes",
      "Civil Transactions-Tenancy",
      "Criminal Law-Crimes against persons",
      "Personal Status-Legacies and Inheritance",
      "Commercial Transactions-Banking Operations",
      "Civil Transactions-Labor & Workers",
      "Personal Status-Legal Capacity & Guardianship",
      "Criminal Law-Drug Crimes",
      "Civil Transactions-Sale",
      "Personal Status-Marriage & Divorce",
      "Personal Status-Child Abuse & Abduction",
      "Criminal Law-Crimes against properties",
      "Criminal Law-Cybercrimes",
      "Commercial Transactions-Intellectual Property (includes trademarks",
      "copy rights",
      "patents)",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 25,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/07/2000",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohd Abdulla Jan Ali Al -Redha",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7f220db7-2508-4999-b268-5126d91a7820",
        "address": "الثاني 201 ,مركز البخيت ,بالقرب من مركز القبائل للتخفيضات ,12020 ,Dubai",
        "phone": "97142664411",
        "email": "redhalaw@eim.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "ba85e0f4-24ae-4065-9d96-7392f96f75fe",
    "firmName": "AL REDHA & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-381",
    "licenseIssueDate": "07/11/2000 00:00:00",
    "licenseExpiryDate": "07/10/2026 00:00:00"
  },
  {
    "id": "e898068a-a58d-42bf-94b5-4ea804abe125",
    "slug": "mohd-ali-mohd-ali-aldahbashi",
    "name": "Mohd Ali Mohd Ali Aldahbashi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/14/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohd Ali Mohd Ali Aldahbashi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e898068a-a58d-42bf-94b5-4ea804abe125",
        "address": "الطابق 14  ,برج 48 جيت  ,محطة مترو دبي  ,413633 ,Dubai",
        "phone": "97144412031",
        "email": "courts@adglegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "4287f048-dc0c-4d51-9e0c-0c23356040ee",
    "firmName": "MOHAMMED AL DAHBASHI ADVOCATES",
    "registrationNumber": "946",
    "licenseIssueDate": "05/14/2014 00:00:00",
    "licenseExpiryDate": "05/13/2026 00:00:00"
  },
  {
    "id": "b9f54431-0c7d-46ca-9586-ec471d48f6d4",
    "slug": "mohmaed-ahmed-ghulam-darweesh-albalooshi",
    "name": "MOHAMED AHMED GHULAM DARWEESH ALBLOOSHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/09/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohmaed Ahmed Ghulam Darweesh Albalooshi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b9f54431-0c7d-46ca-9586-ec471d48f6d4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1025",
    "licenseIssueDate": "09/03/2015 00:00:00",
    "licenseExpiryDate": "09/02/2026 00:00:00"
  },
  {
    "id": "9b575664-24d6-4109-a152-636728c63223",
    "slug": "mohmaed-mahmoud-mohamed-mousa-alswan",
    "name": "MOHAMED MAHMOUD MOHAMED MOUSA ALSAWAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/05/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mohmaed Mahmoud Mohamed Mousa Alswan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9b575664-24d6-4109-a152-636728c63223",
        "address": "",
        "phone": "97143359122",
        "email": "alsawan64@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "ea7d794d-7136-45d1-8ebe-5833f286db4a",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1012",
    "licenseIssueDate": "05/14/2015 00:00:00",
    "licenseExpiryDate": "05/13/2026 00:00:00"
  },
  {
    "id": "3f70ad89-49e6-4a1c-ba83-216a6db91df2",
    "slug": "mona-saif-khalifa-buadeel-almazrouei",
    "name": "MUNA SAIF KHALIFA BUADEEL",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/09/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mona Saif Khalifa Buadeel Almazrouei",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3f70ad89-49e6-4a1c-ba83-216a6db91df2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1457",
    "licenseIssueDate": "10/01/2020 00:00:00",
    "licenseExpiryDate": "09/30/2026 00:00:00"
  },
  {
    "id": "d3c9f64a-e5fe-4010-8100-a1cb12cd3737",
    "slug": "mona-saif-mohammed-amin-al-khaja",
    "name": "MUNA SAIF MOHAMED AMIN ALKHAJEH",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 20,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/02/2005",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mona Saif Mohammed Amin Al Khaja",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d3c9f64a-e5fe-4010-8100-a1cb12cd3737",
        "address": "6 ,Business Point ,Nissan Showroom  ,443 ,Dubai",
        "phone": "97142999991",
        "email": "dubai@alrasheed.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "a4fce061-88d2-4308-9c3a-dbb02f5cbe82",
    "firmName": "AL RASHEED & PARTNERS",
    "registrationNumber": "L-506",
    "licenseIssueDate": "02/15/2005 00:00:00",
    "licenseExpiryDate": "02/14/2026 00:00:00"
  },
  {
    "id": "115507a5-11f7-45d1-ab41-6992a62bbeb4",
    "slug": "monther-mohamed-malalla-salhammadi",
    "name": "MONTHER MOHAMED MALALLA S. ALHAMMADI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/10/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Monther Mohamed Malalla s.Alhammadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_115507a5-11f7-45d1-ab41-6992a62bbeb4",
        "address": "MONTHER MOHAMWD ALHAMMADI ,API TOWER ,API WORLD TOWER ,CONRAD HOTEL ,300806 ,Dubai",
        "phone": "97142508555 / 971000000000",
        "email": "montheruae@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "2f87d653-d6e3-4b98-81e9-0ab05f928b31",
    "firmName": "MONTHER AL HAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-776",
    "licenseIssueDate": "11/01/2011 00:00:00",
    "licenseExpiryDate": "10/31/2025 00:00:00"
  },
  {
    "id": "11f90c5f-55a4-453e-9d32-beb1c4009852",
    "slug": "mousa-essa-mousa-al-amri",
    "name": "MOUSA EISA MOUSA MOHAMED ALAMIRI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 28,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/01/1997",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mousa Essa Mousa Al-Amri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_11f90c5f-55a4-453e-9d32-beb1c4009852",
        "address": "",
        "phone": "97142237666",
        "email": "info@musaalamri.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "33313c27-5476-4398-bde0-ff404d0480c1",
    "firmName": "MOUSA ALAMRI ADVOCATES & LEGEL CONSULTANTS",
    "registrationNumber": "L-288",
    "licenseIssueDate": "01/18/1997 00:00:00",
    "licenseExpiryDate": "01/17/2026 00:00:00"
  },
  {
    "id": "1edb4aab-e37d-4db2-a704-2b5d6e143137",
    "slug": "mouza-hamad-obaid-alnuaimi",
    "name": "THURAIYA HASAN AHMED ALAWI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/08/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mouza Hamad Obaid Alnuaimi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1edb4aab-e37d-4db2-a704-2b5d6e143137",
        "address": "ABDELAZIZ MOHAMED ABDELGHANI AL KHAMIRI AL ALI ,3 ,DUBAI SUPREME COURT COMPLEX ,DUBAI COURT ,128334 ,Dubai",
        "phone": "97145519341 / 971505788557",
        "email": "info@raalc.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "73e54a15-f797-4e91-a501-ef988d8f8bf8",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1701",
    "licenseIssueDate": "09/28/2022 00:00:00",
    "licenseExpiryDate": "09/27/2026 00:00:00"
  },
  {
    "id": "4b66cbd7-fb6b-4b04-b4ac-326d7bee6368",
    "slug": "mouza-mohammed-saeed-khammas-aldhuhoori",
    "name": "SULTAN SALEH AWADH MOHSIN ALWAHEDI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/03/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mouza Mohammed Saeed Khammas Aldhuhoori",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4b66cbd7-fb6b-4b04-b4ac-326d7bee6368",
        "address": "104 ,سان شاين 1  ,شقق جرين هاوس الفندقية ,0000 ,Dubai",
        "phone": "97142280666 / 97142280666",
        "email": "Hanansalem.advocate@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "f58725e5-47e3-4ed2-8325-35655ffe5771",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1789",
    "licenseIssueDate": "04/17/2023 00:00:00",
    "licenseExpiryDate": "04/16/2026 00:00:00"
  },
  {
    "id": "42519cac-5fa0-4afc-b0e3-c09665d30c96",
    "slug": "moza-ali-murad-ibrahim-alblooshi",
    "name": "MOZA ALI MURAD IBRAHIM ALBLOOSHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/08/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Moza Ali Murad Ibrahim Alblooshi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_42519cac-5fa0-4afc-b0e3-c09665d30c96",
        "address": "",
        "phone": "97142566800",
        "email": "fatema@alhammadiadvocate.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "07521705-aa90-4c3a-b5fd-c55e54889e60",
    "firmName": "MOHAMED AL HAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1553",
    "licenseIssueDate": "08/02/2021 00:00:00",
    "licenseExpiryDate": "08/01/2026 00:00:00"
  },
  {
    "id": "1a5abd51-2b29-4e9e-ac83-5bc4fe79f0c6",
    "slug": "moza-humaid-sultan-abdulla-alsuwaidi",
    "name": "RASHED MOHAMMED ABDULLA SAEED LOOTAH",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/11/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-11-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Moza Humaid Sultan Abdulla Alsuwaidi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1a5abd51-2b29-4e9e-ac83-5bc4fe79f0c6",
        "address": "الثاني عشر مكتب 1201 ,مبنى امباير هايتس البرج B ,بنك رأس الخيمة ,00000 ,Dubai",
        "phone": "97142611689 / 971561234514",
        "email": "info@nja.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "490cb579-167c-4a7e-b679-997fb6780992",
    "firmName": "RASHED LOOTAH ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1733",
    "licenseIssueDate": "01/03/2023 00:00:00",
    "licenseExpiryDate": "01/02/2026 00:00:00"
  },
  {
    "id": "460efa24-6d57-40c4-a552-1f503ebf56d2",
    "slug": "moza-mohamed-masoud",
    "name": "MOZAH MOHAMED MASOUD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/05/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Moza Mohamed Masoud",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_460efa24-6d57-40c4-a552-1f503ebf56d2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-811",
    "licenseIssueDate": "05/15/2012 00:00:00",
    "licenseExpiryDate": "05/14/2026 00:00:00"
  },
  {
    "id": "b4d0432c-ab8a-41e6-9915-5d85945e59bd",
    "slug": "moza-ubaid-rabea-al-kheder",
    "name": "MOAZA OBAID RUBAYA ALKHADAR",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNVQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/09/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Moza Ubaid Rabea Al Kheder",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b4d0432c-ab8a-41e6-9915-5d85945e59bd",
        "address": "مطعم زعتر وزيت  ,اسبكت تاور  ,فندق تاج  ,118212 ,Dubai",
        "phone": "97144433013 / 97144433013",
        "email": "moaza.alkhadar.alc@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "1dc550f7-81c5-4a5a-9096-682d651b8688",
    "firmName": "MOAZA ALKHADAR ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-892",
    "licenseIssueDate": "09/30/2013 00:00:00",
    "licenseExpiryDate": "09/29/2026 00:00:00"
  },
  {
    "id": "ce2b4a93-f7e5-42d3-8fbd-51a0d7d729ec",
    "slug": "mubarak-abdulla-al-qiti-al-masabein",
    "name": "MUBARAK ABDULLA AL QAITI ALMESSABI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 21,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/09/2004",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mubarak Abdulla Al-Qiti Al-Masabein",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ce2b4a93-f7e5-42d3-8fbd-51a0d7d729ec",
        "address": "Mubarak Abdullah ,7 ,Westburry Offices Tower 1 ,Burj Khalifa ,122352 ,Dubai",
        "phone": "97143298711 / 971504649812",
        "email": "proconsult@uaeahead.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "c314e20b-1f39-4c2d-8b81-8af5888cee30",
    "firmName": "PROCONSULT ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-491",
    "licenseIssueDate": "09/11/2004 00:00:00",
    "licenseExpiryDate": "09/10/2026 00:00:00"
  },
  {
    "id": "832a7a6b-93db-4cc3-b6ed-2ac86d394669",
    "slug": "mukhtar-mohammed-baqir-gharib",
    "name": "MUKHTAR MOHAMMAD BAQIR GHARIB",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 26,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/09/1999",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Mukhtar Mohammed Baqir Gharib",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_832a7a6b-93db-4cc3-b6ed-2ac86d394669",
        "address": "الطابق الثاني - مكتب رقم 203 و 204  ,سيتي أفينو ,سيتى سنتر ديرة  ,83666 ,Dubai",
        "phone": "97142955050",
        "email": "adv.algharib@alghariblawfirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "b1e23b77-356c-4678-ae4d-2ff4e494702b",
    "firmName": "AL GHARIB & PARTNERS ADVOCATES LEGAL CONSULTANTS",
    "registrationNumber": "L-364",
    "licenseIssueDate": "09/07/1999 00:00:00",
    "licenseExpiryDate": "09/06/2026 00:00:00"
  },
  {
    "id": "7775a6c6-5a5c-48ff-beae-06bd7d74d398",
    "slug": "muna-ahmed-ali-bin-ghalaita-almheiri",
    "name": "ASMA ABDULRAHMAN SHARAF MOHAMMAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/06/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Muna Ahmed  Ali Bin Ghalaita Almheiri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7775a6c6-5a5c-48ff-beae-06bd7d74d398",
        "address": "Office 413 - Block B ,Hamdan Bin Rashid Al Maktoum Foundation for Medical Science ,Makani No: 2598892707 ,000 ,Dubai",
        "phone": "97142571323 / 971554377771",
        "email": "info@alzaabi-binghalaita.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "ff6f54b7-0992-43dc-8480-cfff31538d52",
    "firmName": "KASHWANI LAW FIRM",
    "registrationNumber": "L-1673",
    "licenseIssueDate": "07/04/2022 00:00:00",
    "licenseExpiryDate": "07/03/2026 00:00:00"
  },
  {
    "id": "0df3a99a-2a4e-41c3-ae36-5bfc7b1b5d7e",
    "slug": "muna-ahmed-abdulaziz-yousuf-alsabbagh",
    "name": "AHMED ABDULAZIZ YOUSIF",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/03/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Muna Ahmed Abdulaziz Yousuf Alsabbagh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0df3a99a-2a4e-41c3-ae36-5bfc7b1b5d7e",
        "address": "Muna Ahmed Abdul-aziz Al-Sabbagh ,الطابق الخامس ,الزمردة ,مختبر دبي المركزي ,115578 ,Dubai",
        "phone": "97142283414",
        "email": "info@alwifaqlegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "120e4ca7-7727-4524-9d53-5656ff95eea7",
    "firmName": "MUNA AL SABBAGH ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-795",
    "licenseIssueDate": "03/07/2012 00:00:00",
    "licenseExpiryDate": "03/06/2026 00:00:00"
  },
  {
    "id": "f230b38b-644a-4dfd-95ec-1b9593214039",
    "slug": "muna-juma-abbas-al-balooshi",
    "name": "MUNA JUMA ABBAS ABDULLA ALBALOOSHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 15,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/05/2010",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Muna Juma Abbas Al Balooshi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f230b38b-644a-4dfd-95ec-1b9593214039",
        "address": "MOHAMMED ALI SALMAN AL MARZOOQI ,الثالث  ,السركال  ,معرض سيارات الفطيم  ,39059 ,Dubai",
        "phone": "97142500008",
        "email": "adv.saad@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "6bba829c-0392-4c72-a71b-01da72cb24ae",
    "firmName": "MOHAMED SALMAN ADVOCATE & LEGAL CONSULTANCY",
    "registrationNumber": "L-528",
    "licenseIssueDate": "05/30/2010 00:00:00",
    "licenseExpiryDate": "05/29/2026 00:00:00"
  },
  {
    "id": "a116f9b1-9d7e-4f45-99f7-01a22533a922",
    "slug": "muna-khalifa-rashed-al-shamsi",
    "name": "MUNA KHALIFA RASHED ALBADWI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/04/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Muna Khalifa Rashed Al Shamsi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a116f9b1-9d7e-4f45-99f7-01a22533a922",
        "address": "",
        "phone": "97143553023",
        "email": "info@munaalshamsi30.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "a92c9f4c-fad2-4893-b407-713b48ab7143",
    "firmName": "MUNA ALSHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1356",
    "licenseIssueDate": "04/08/2019 00:00:00",
    "licenseExpiryDate": "04/07/2026 00:00:00"
  },
  {
    "id": "492311c6-28c5-4e71-9438-157067388d00",
    "slug": "muna-mohammed-faraj-mohammed-almulla",
    "name": "MUNA MOHD FARAJ W/O MARWAN A ALYAMANI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Cases and Proceedings before Dubai International Financial Centre",
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Civil Transactions-POA & Sponsorship",
      "Civil Transactions-HR & Employee Affairs",
      "Criminal Law-Family Crimes",
      "Personal Status-Custody & Alimony",
      "Commercial Transactions-Commercial Contracts",
      "Commercial Transactions-Bankruptcy",
      "Commercial Transactions-Commercial Real Estate",
      "Civil Transactions-Residential Real Estate",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Civil Transactions-Tenancy",
      "Criminal Law-Crimes against persons",
      "Civil Transactions-Labor & Workers",
      "Personal Status-Legal Capacity & Guardianship",
      "Criminal Law-Drug Crimes",
      "Civil Transactions-Sale",
      "Commercial Transactions-Consumer protection",
      "Personal Status-Marriage & Divorce",
      "Personal Status-Child Abuse & Abduction",
      "Civil Transactions-Compensation",
      "Criminal Law-Crimes against properties",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/06/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Muna Mohammed Faraj Mohammed Almulla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_492311c6-28c5-4e71-9438-157067388d00",
        "address": "الطابق الرابع ,مركز الرقة للأعمال ,قرب مصرف الإمارات الإسلامي ,187103 ,Dubai",
        "phone": "97142384840",
        "email": "legalco@eim.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "4a5b2020-9a90-4726-b8ef-245a8f009364",
    "firmName": "MUNA ALMULLA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1090",
    "licenseIssueDate": "06/05/2016 00:00:00",
    "licenseExpiryDate": "06/04/2026 00:00:00"
  },
  {
    "id": "647d965f-1e82-4dfd-ba03-d96a9bc5059b",
    "slug": "muna-mohammed-mosa-almandoos-alblooshi",
    "name": "MUNA MOHAMMED MOOSA AL MANDOOS ALBLOOSHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/08/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Muna Mohammed Mosa Almandoos Alblooshi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_647d965f-1e82-4dfd-ba03-d96a9bc5059b",
        "address": "18 ,فندق مونارك  ,مركز التجاري ,98444 ,Dubai",
        "phone": "97143588777",
        "email": "info@bhadvoc.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "61266d12-f5b4-4466-a1a8-a45934d9e511",
    "firmName": "BIN HAIDER ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1104",
    "licenseIssueDate": "09/01/2016 00:00:00",
    "licenseExpiryDate": "08/31/2026 00:00:00"
  },
  {
    "id": "cc1689fd-03e9-4c7f-8034-6fb75e63e3d2",
    "slug": "muna-mohammed-redha-al-ansari",
    "name": "MUNA MOHAMED W O HASSAN KHAMIS MOHD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 34,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/04/1991",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Muna Mohammed Redha Al-Ansari",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cc1689fd-03e9-4c7f-8034-6fb75e63e3d2",
        "address": "الأول 107 ,ناصر الساير ,فندق أسيانا ,27252 ,Dubai",
        "phone": "97142699255",
        "email": "mona1@lawyer.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "4575cb41-efe0-44d1-8595-31c2dbb97e68",
    "firmName": "MUNA AL ANSARI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-233",
    "licenseIssueDate": "04/06/1991 00:00:00",
    "licenseExpiryDate": "04/05/2026 00:00:00"
  },
  {
    "id": "3a5c4f2c-df35-42e8-9d9c-2d1b4825fcf2",
    "slug": "muna-mohammed-salem-rashdan",
    "name": "MONA MOHAMMED SALEM RASHDAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/10/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Muna Mohammed Salem Rashdan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3a5c4f2c-df35-42e8-9d9c-2d1b4825fcf2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1123",
    "licenseIssueDate": "10/27/2016 00:00:00",
    "licenseExpiryDate": "10/26/2025 00:00:00"
  },
  {
    "id": "523b6db3-2602-4fb8-84bf-37f85e8e23d6",
    "slug": "muna-mubarak-mohamed-abukhater-alqubaisi",
    "name": "HASSAN HUMAID HASSAN KHATAM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/07/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Muna Mubarak Mohamed Abukhater Alqubaisi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_523b6db3-2602-4fb8-84bf-37f85e8e23d6",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1845",
    "licenseIssueDate": "08/17/2023 00:00:00",
    "licenseExpiryDate": "08/16/2026 00:00:00"
  },
  {
    "id": "efcbf6b1-dcf9-4ec6-95d1-4c53631a7231",
    "slug": "muna-rashed-saeed-alqaishi-alshehhi",
    "name": "MOHAMMAD NAJIB ABDULLA ALHAJ HASSAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/01/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Muna Rashed Saeed Alqaishi Alshehhi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_efcbf6b1-dcf9-4ec6-95d1-4c53631a7231",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1919",
    "licenseIssueDate": "02/22/2024 00:00:00",
    "licenseExpiryDate": "02/21/2026 00:00:00"
  },
  {
    "id": "e6f9bfc5-fb40-4cc9-8240-ebe04ea29030",
    "slug": "muna-salim-hassan-ali-almuallim",
    "name": "MUNA SALIM HASSAN ALI ALMUALLIM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/08/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Muna Salim Hassan Ali Almuallim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e6f9bfc5-fb40-4cc9-8240-ebe04ea29030",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1103",
    "licenseIssueDate": "08/10/2016 00:00:00",
    "licenseExpiryDate": "08/09/2026 00:00:00"
  },
  {
    "id": "5d1877d0-bfe1-4a4d-8386-09aa588f6004",
    "slug": "muna-seed-mohammed-masan",
    "name": "MUNA SAEED MOHAMMED MASAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/07/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Muna seed Mohammed Masan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5d1877d0-bfe1-4a4d-8386-09aa588f6004",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1374",
    "licenseIssueDate": "07/10/2019 00:00:00",
    "licenseExpiryDate": "07/09/2026 00:00:00"
  },
  {
    "id": "3ac88502-4e86-4894-a665-8733c8542b4f",
    "slug": "muneera-ahmed-eidha-mubarak-alameri",
    "name": "MUNEERA AHMED EIDHA MUBARAK",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/02/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Muneera Ahmed Eidha Mubarak Alameri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3ac88502-4e86-4894-a665-8733c8542b4f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1259",
    "licenseIssueDate": "02/19/2018 00:00:00",
    "licenseExpiryDate": "02/18/2026 00:00:00"
  },
  {
    "id": "c42e2481-3e4f-4365-b93b-e2446fd4b15c",
    "slug": "munira-abdulla-sabt-alhammadi",
    "name": "MUNIRA ABDULLA W O ABDULMUNIM E AL TAYER",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/10/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Munira Abdulla Sabt Alhammadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c42e2481-3e4f-4365-b93b-e2446fd4b15c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1587",
    "licenseIssueDate": "11/01/2021 00:00:00",
    "licenseExpiryDate": "10/31/2025 00:00:00"
  },
  {
    "id": "0db2f9bf-582f-4171-abfe-918f50fee916",
    "slug": "munira-mohammed-redha-ali-lari",
    "name": "MUNIRA MOHAMMED RAZA ALI LARI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/11/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Munira Mohammed Redha Ali Lari",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0db2f9bf-582f-4171-abfe-918f50fee916",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1482",
    "licenseIssueDate": "11/30/2020 00:00:00",
    "licenseExpiryDate": "11/29/2025 00:00:00"
  },
  {
    "id": "3e5e8a90-4930-4b8a-bd29-c1499ea2d49d",
    "slug": "musaab-ali-mohamed-abdalla-alnaqbi",
    "name": "MUSAAB ALI MOHAMED ABDALLA ABDELRAZAQ",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/02/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Musaab Ali Mohamed Abdalla Alnaqbi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3e5e8a90-4930-4b8a-bd29-c1499ea2d49d",
        "address": "13 ,Le Solarium Tower ,Arabian Gate ,185430 ,Dubai",
        "phone": "97145805135 / 971558703836",
        "email": "info@alnaqbilaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "24f8f7c8-a688-4587-9e87-f3105a99533a",
    "firmName": "MUSAAB ALI AL NAQBI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-1150",
    "licenseIssueDate": "02/19/2017 00:00:00",
    "licenseExpiryDate": "02/18/2026 00:00:00"
  },
  {
    "id": "f9019c39-6d0c-4245-a4e2-0e4393db4cb3",
    "slug": "musallam-ashour-mohamed-salem-alkatheeri",
    "name": "MUSALLAM ASHOUR MOHAMED SALEM ALKATHEERI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/09/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Musallam Ashour Mohamed Salem Alkatheeri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f9019c39-6d0c-4245-a4e2-0e4393db4cb3",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-990",
    "licenseIssueDate": "09/04/2017 00:00:00",
    "licenseExpiryDate": "09/03/2026 00:00:00"
  },
  {
    "id": "ba27d2b9-710a-4721-afdf-b319e8b15549",
    "slug": "musallam-hamed-musallam-bakheet-almahhrami",
    "name": "MOHD RADDAD MAHMOUD KHALIL MAAITAH",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/08/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Musallam Hamed Musallam Bakheet Almahhrami",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ba27d2b9-710a-4721-afdf-b319e8b15549",
        "address": "",
        "phone": "97144560410 / 971551096724",
        "email": "info1@a-lawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "ebbfa096-ef29-4660-9201-8c03bd4be3fe",
    "firmName": "MUSALLAM ALMAHHRAMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1021",
    "licenseIssueDate": "08/02/2015 00:00:00",
    "licenseExpiryDate": "08/01/2026 00:00:00"
  },
  {
    "id": "289f4306-8817-4e49-9711-ea8b4fd1aa9d",
    "slug": "nabeeh-ahmad-badr",
    "name": "NABIH AHMED BADER",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 41,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/06/1984",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Nabeeh Ahmad Badr",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_289f4306-8817-4e49-9711-ea8b4fd1aa9d",
        "address": "NABIH AHMED BADER ,Level M Office 203   , The Dubai Mall Fountain Views ,Social District Fountain Views,  Burak Restaurant ,182859 ,Dubai",
        "phone": "97142384655",
        "email": "nbader@eptalex.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "f766fe59-4307-4881-a130-fde85d0dd65d",
    "firmName": "MEG LEGAL SERVICES",
    "registrationNumber": "L-137",
    "licenseIssueDate": "06/24/1984 00:00:00",
    "licenseExpiryDate": "06/23/2026 00:00:00"
  },
  {
    "id": "94f65019-7c0c-404d-99d6-6c059324c7c6",
    "slug": "nada-eid-salem-mohamed-almuharrami",
    "name": "SAIF HUMAID SULTAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBORQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/08/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Nada Eid Salem Mohamed Almuharrami",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_94f65019-7c0c-404d-99d6-6c059324c7c6",
        "address": "",
        "phone": "97143530018",
        "email": "info@alsuwaidiadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "838d8111-1e4d-43cc-88f7-71f2dcb24635",
    "firmName": "HILAL &ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1698",
    "licenseIssueDate": "09/14/2022 00:00:00",
    "licenseExpiryDate": "09/13/2026 00:00:00"
  },
  {
    "id": "8285ad08-a641-417c-866a-958143882522",
    "slug": "nada-mohamed-khamis-hasan-almehairbi",
    "name": "NADA MOHAMED KHAMIS HASAN ALMEHAIRBI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/02/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Nada Mohamed Khamis Hasan Almehairbi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8285ad08-a641-417c-866a-958143882522",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1504",
    "licenseIssueDate": "02/03/2021 00:00:00",
    "licenseExpiryDate": "02/02/2026 00:00:00"
  },
  {
    "id": "53cebffd-12da-414e-9ab0-1e1be86645d3",
    "slug": "nada-sarour-aljaberi",
    "name": "AHMAD A LATIF AHMAD YOUNIS",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/02/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: NADA SAROUR ALJABERI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_53cebffd-12da-414e-9ab0-1e1be86645d3",
        "address": "",
        "phone": "97142555000",
        "email": "info@kha.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "0e4b9f0a-83fc-45c9-b0d3-f38013690624",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-2074",
    "licenseIssueDate": "02/20/2025 00:00:00",
    "licenseExpiryDate": "02/19/2026 00:00:00"
  },
  {
    "id": "ec72ea77-0dea-48ae-9a0e-b52d0d91c058",
    "slug": "nadhema-mahammed-ahmed-mohammed-alawadi",
    "name": "NADHEMA MOHAMMED AHMED M ALAWADHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/09/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Nadhema Mahammed Ahmed Mohammed Alawadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ec72ea77-0dea-48ae-9a0e-b52d0d91c058",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1567",
    "licenseIssueDate": "09/22/2021 00:00:00",
    "licenseExpiryDate": "09/21/2026 00:00:00"
  },
  {
    "id": "518afdac-4b12-46fa-856c-af2fa999e6c4",
    "slug": "nadia-abdolrazagh-mohammadi",
    "name": "MAKIYEH JASIM ARADI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Commercial Transactions-Commercial Contracts",
      "Civil Transactions-Tenancy",
      "Civil Transactions-Labor & Workers"
    ],
    "experience": 19,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/04/2006",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Nadia Abdolrazagh Mohammadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_518afdac-4b12-46fa-856c-af2fa999e6c4",
        "address": "",
        "phone": "97142999934",
        "email": "info@nadiaadvocacy.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "8b9b9a1d-f3d0-4a3f-a743-67fa6fc84709",
    "firmName": "NADIA ABDOLRAZAGH ADVOCACY & LEGAL CONSULTATIONS",
    "registrationNumber": "L-561",
    "licenseIssueDate": "04/24/2006 00:00:00",
    "licenseExpiryDate": "04/23/2026 00:00:00"
  },
  {
    "id": "9539ffd9-4d82-4759-ab19-d243dcb54734",
    "slug": "nadia-mohamed-habib-alyousuf",
    "name": "NADIA MOHAMED HABIB",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/08/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Nadia Mohamed Habib Alyousuf",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9539ffd9-4d82-4759-ab19-d243dcb54734",
        "address": "FIRST ,KIA FLAG SHIP ,KIA CAR SHOWROOM ,2031 ,Dubai",
        "phone": "97143444210 / 971505522350",
        "email": "official@nylegalfirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "76cab153-5498-48e2-acc7-4fb5c4cb1236",
    "firmName": "NADIA ALYOUSUF ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-1100",
    "licenseIssueDate": "08/10/2016 00:00:00",
    "licenseExpiryDate": "08/09/2026 00:00:00"
  },
  {
    "id": "f1c0bd70-37f8-4aa8-9aa5-99811bf67176",
    "slug": "nadia-mohammad-ramadan",
    "name": "NADIA MOHAMMAD RAMADAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/03/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Nadia Mohammad Ramadan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f1c0bd70-37f8-4aa8-9aa5-99811bf67176",
        "address": "first floor ,Al Ferdous 4 ,Park and Shop ,12018 ,Dubai",
        "phone": "97143930222 / 971505122999",
        "email": "info@amanidarwishlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "7e92f791-0024-4f89-84eb-1e2d979fd2d2",
    "firmName": "NADIA MOHAMMED LAW FIRM LEGAL CONSULTANCY",
    "registrationNumber": "L-1159",
    "licenseIssueDate": "03/21/2017 00:00:00",
    "licenseExpiryDate": "03/20/2026 00:00:00"
  },
  {
    "id": "67ac1813-de87-4cbd-b86b-b9a32eb30a4b",
    "slug": "nadya-ahmed-hasan-alhar-alshehhi",
    "name": "NADYA AHMED HASAN ALHAR ALSHEHHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/03/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: NADYA AHMED HASAN ALHAR ALSHEHHI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_67ac1813-de87-4cbd-b86b-b9a32eb30a4b",
        "address": "",
        "phone": "97143387678 / 971503938886",
        "email": "INFO@ADVOCATESDXB.AE",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "c8946f42-15b9-4001-93e7-05c5d766ac30",
    "firmName": "NADYA AHMED HASAN ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1387",
    "licenseIssueDate": "03/25/2025 00:00:00",
    "licenseExpiryDate": "03/24/2026 00:00:00"
  },
  {
    "id": "6a40bff3-7131-4b71-89dc-9fac245c7a93",
    "slug": "nahed-abdulla-humaid-khuwaidem-alebri",
    "name": "KHALIFA MOHAMED ABDULLA MOHAMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/09/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Nahed Abdulla Humaid khuwaidem Alebri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6a40bff3-7131-4b71-89dc-9fac245c7a93",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-2034",
    "licenseIssueDate": "10/10/2024 00:00:00",
    "licenseExpiryDate": "10/09/2026 00:00:00"
  },
  {
    "id": "21602bd0-b337-4576-a512-838322aa21c0",
    "slug": "nahes-a-n-ch-al-anazi",
    "name": "Nahes a n ch al anazi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 17,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/10/2008 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Nahes a n ch al anazi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_21602bd0-b337-4576-a512-838322aa21c0",
        "address": "4/406 ,Acico Business Park  ,Behind Nissan Showroom ,186344 ,Dubai",
        "phone": "97142989888 / 971505948989",
        "email": "AHMEDIBRAHIMLAW@GMAIL.COM",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "dbb4bc27-1ace-4e78-8ee2-db7bfd85e001",
    "firmName": "AHMED IBRAHIM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "636",
    "licenseIssueDate": "06/10/2008 00:00:00",
    "licenseExpiryDate": "06/09/2026 00:00:00"
  },
  {
    "id": "8c92c308-6207-4347-8fb2-74c2a81be1dd",
    "slug": "naji-ali-alhaj-ibrahim-baidhoun",
    "name": "NAJI ALI EL HAJ IBRAHIM BEIDOUN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 49,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/02/1976",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Naji Ali Alhaj Ibrahim Baidhoun",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8c92c308-6207-4347-8fb2-74c2a81be1dd",
        "address": "الثالث - 329 ,إمارات اتريوم  ,مزايا سنتر ,4609 ,Dubai",
        "phone": "97142225151",
        "email": "team@nbadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "170463c8-fa0b-4323-bb48-8ea54d32ed3d",
    "firmName": "NAJI BEIDOUN ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-26",
    "licenseIssueDate": "02/14/1976 00:00:00",
    "licenseExpiryDate": "02/13/2026 00:00:00"
  },
  {
    "id": "39801c97-33cc-4bff-ae15-e6d7f1e16ee2",
    "slug": "naji-emile-boulos",
    "name": "NAJI EMILE BOULOS",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBORQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 48,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/01/1977",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Naji Emile Boulos",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_39801c97-33cc-4bff-ae15-e6d7f1e16ee2",
        "address": "الخامس  ,مكاتب عود ميثاء ,فندق رافلز ,11268 ,Dubai",
        "phone": "97143243330",
        "email": "avocat@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "25d2c9bd-dbba-41ac-aff9-5ba0f37290d6",
    "firmName": "AL QARI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-46",
    "licenseIssueDate": "01/08/1977 00:00:00",
    "licenseExpiryDate": "01/07/2026 00:00:00"
  },
  {
    "id": "9e09b712-a56e-468e-8977-2006e1d687ac",
    "slug": "najla-ahmed-bedaiwi-alkubaisi",
    "name": "NAJLA AHMED BEDAIWI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/10/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Najla Ahmed Bedaiwi Alkubaisi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9e09b712-a56e-468e-8977-2006e1d687ac",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1110",
    "licenseIssueDate": "10/03/2016 00:00:00",
    "licenseExpiryDate": "10/02/2026 00:00:00"
  },
  {
    "id": "3347c08d-c213-4f13-bc34-9185b78c5bbf",
    "slug": "najm-abdalla-abdelrahim-abdalla-alkashwani",
    "name": "NAJM ABDALLA ABDELRAHIM A KASHWANI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/05/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Najm Abdalla Abdelrahim Abdalla Alkashwani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3347c08d-c213-4f13-bc34-9185b78c5bbf",
        "address": "YOUNIS MOHAMMED ALBLOOSHI ,3 - 1 ,the icon ,السيلكون ,117548 ,Dubai",
        "phone": "97145693206 / 971000000000",
        "email": "info@yblooshiadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "27278b02-4edf-490f-9d50-a1bc00678b6a",
    "firmName": "YOUNIS MOHAMMED AL BLOOSHI LAWYER & LEGAL CONSULTANTS",
    "registrationNumber": "L-1287",
    "licenseIssueDate": "05/23/2018 00:00:00",
    "licenseExpiryDate": "05/22/2026 00:00:00"
  },
  {
    "id": "69207adc-a8a9-4cda-b801-cdf86ccef755",
    "slug": "najma-hasan-ali-ibrahim-almarzooqi",
    "name": "NAJMA HASAN W O TARIQ HUSSAIN A ALSERKAL",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/02/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Najma Hasan Ali Ibrahim Almarzooqi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_69207adc-a8a9-4cda-b801-cdf86ccef755",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1145",
    "licenseIssueDate": "02/07/2017 00:00:00",
    "licenseExpiryDate": "02/06/2026 00:00:00"
  },
  {
    "id": "28bcc977-ab0e-431f-bb06-091e0b8c8a65",
    "slug": "najood-nahyan-ebrahim-khalil-alhammadi",
    "name": "SALMA RASHED KHALFAN ABAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/04/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Najood Nahyan Ebrahim Khalil Alhammadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_28bcc977-ab0e-431f-bb06-091e0b8c8a65",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1943",
    "licenseIssueDate": "04/25/2024 00:00:00",
    "licenseExpiryDate": "04/24/2026 00:00:00"
  },
  {
    "id": "f020bcd6-9e79-4261-ab07-d58c1d81e306",
    "slug": "najwa-waheed-zaki-akoush",
    "name": "ZIAD JOSEPH ISSA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/02/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: najwa waheed zaki akoush",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f020bcd6-9e79-4261-ab07-d58c1d81e306",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1774",
    "licenseIssueDate": "03/06/2023 00:00:00",
    "licenseExpiryDate": "03/05/2026 00:00:00"
  },
  {
    "id": "0909abf3-5db0-4466-ae7e-98ccb324f678",
    "slug": "narmin-ahmad-ali-issa",
    "name": "NARMIN AHMAD ALI ISSA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/03/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Narmin Ahmad Ali Issa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0909abf3-5db0-4466-ae7e-98ccb324f678",
        "address": "",
        "phone": "97142946164",
        "email": "info@albannai-law.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "73525ec0-5573-4652-8fd8-c2ef0f19b399",
    "firmName": "ALBANNAI & CO.",
    "registrationNumber": "L-342",
    "licenseIssueDate": "03/25/2025 00:00:00",
    "licenseExpiryDate": "03/24/2026 00:00:00"
  },
  {
    "id": "05e868db-1247-423c-a128-6ae1b9435f90",
    "slug": "naser-abdulla-salem-ali-almuharram",
    "name": "NASER ABDULLA SALEM ALI ALMUHARRAM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/15/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: NASER ABDULLA SALEM ALI ALMUHARRAM",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_05e868db-1247-423c-a128-6ae1b9435f90",
        "address": "Naser almuharrami ,التاسع  ,SAMA TOWER ,مطعم تشيلو  ,0000 ,Dubai",
        "phone": "97144581795 / 971507388622",
        "email": "info@lawdxb.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "bc5ea246-1523-48e3-917c-682ff8a19466",
    "firmName": "NASER ABDULLA ALMUHARRAMI ADVOCATES & LEGAL C",
    "registrationNumber": "16010",
    "licenseIssueDate": "12/15/2021 00:00:00",
    "licenseExpiryDate": "12/14/2025 00:00:00"
  },
  {
    "id": "29c099f6-6f81-4402-8bf2-eb95a22ba211",
    "slug": "naser-ahmed-naser-al-osaiba",
    "name": "NASSER AHMED NASSER ALOSAIBA AL ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 18,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/09/2007",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Naser Ahmed Naser Al-Osaiba",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_29c099f6-6f81-4402-8bf2-eb95a22ba211",
        "address": "21 ,Rolex Tower ,Emirates Grand Hotel ,94334 ,Dubai",
        "phone": "97143277772 / 97145584900",
        "email": "info@globaladvocates.net",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "9b42810f-1d55-4aea-ac4a-7d9d1b25ac08",
    "firmName": "GLOBAL ADVOCACY & LEGAL COUNSEL",
    "registrationNumber": "L-401",
    "licenseIssueDate": "09/24/2007 00:00:00",
    "licenseExpiryDate": "09/23/2026 00:00:00"
  },
  {
    "id": "fbab1bf7-8bc7-411e-a322-2b1e5e683317",
    "slug": "naser-hamad-sulaiman-jaber-al-shamsi",
    "name": "NASER HAMAD SULAIMAN JABER AL SHAMSI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 19,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/14/2006 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: NASER HAMAD SULAIMAN JABER AL SHAMSI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fbab1bf7-8bc7-411e-a322-2b1e5e683317",
        "address": "",
        "phone": "97142507778 / 971506421661",
        "email": "feedback@alshamsilawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "4b400e1b-7731-4a4b-9c37-a77e3c03ab78",
    "firmName": "NASSER AL SHAMSI ADVOCATES & LEGAL CONSULTANT",
    "registrationNumber": "579",
    "licenseIssueDate": "09/14/2006 00:00:00",
    "licenseExpiryDate": "09/13/2026 00:00:00"
  },
  {
    "id": "ae01012e-c17d-4aa1-b60b-00c60f326d51",
    "slug": "naser-malalla-mohammed-ghanem",
    "name": "NASSER MALALLA MOHAMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 24,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/11/2000",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Naser Malalla Mohammed Ghanem",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ae01012e-c17d-4aa1-b60b-00c60f326d51",
        "address": "",
        "phone": "97148321212",
        "email": "nasser@nmlawyers.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "71709458-e40a-45b3-9319-4c51c18891be",
    "firmName": "NASSER MALALLA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-389",
    "licenseIssueDate": "11/07/2000 00:00:00",
    "licenseExpiryDate": "11/06/2025 00:00:00"
  },
  {
    "id": "9cdc31be-7406-4f74-a059-60539404d92d",
    "slug": "naser-malalla-qasem-hasan-alhammadi",
    "name": "NASER MALALLA QASEM HASAN ALHAMMADI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/09/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: NASER MALALLA QASEM HASAN ALHAMMADI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9cdc31be-7406-4f74-a059-60539404d92d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "1807",
    "licenseIssueDate": "06/09/2023 00:00:00",
    "licenseExpiryDate": "06/08/2026 00:00:00"
  },
  {
    "id": "e177fc3c-130b-485e-bd56-467d61052baa",
    "slug": "naser-yousef-mohammed-naser-al-jaroodi",
    "name": "NASSER YOUSUF MOHD NASSER",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 36,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/06/1989",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Naser Yousef Mohammed Naser Al-Jaroodi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e177fc3c-130b-485e-bd56-467d61052baa",
        "address": "Nasser Yousuf Mohammed Aljaroodi ,الطابق الثاني - مكتب رقم 2015A ,مركز مزايا للتسوق  ,بالقرب من محطة مترو برج خليفة - دبي مول - مخرج رقم 2 ,5958 ,Dubai",
        "phone": "97143699915 / 971561339712",
        "email": "info@aljaroodiadv.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "e9977c41-28ca-4173-b8d2-ef9fa1de8472",
    "firmName": "NASSER AL JAROODI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-195",
    "licenseIssueDate": "06/13/1989 00:00:00",
    "licenseExpiryDate": "06/12/2026 00:00:00"
  },
  {
    "id": "cf8bc319-943a-45c5-818f-3a2f5d1efa68",
    "slug": "nashwa-abdullah-khalifa-abdullah-al-qubaisi",
    "name": "NASHWA ABDULLA KHALIFA ALQUBAISI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/01/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Nashwa Abdullah Khalifa Abdullah Al Qubaisi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cf8bc319-943a-45c5-818f-3a2f5d1efa68",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-489",
    "licenseIssueDate": "01/28/2014 00:00:00",
    "licenseExpiryDate": "01/27/2026 00:00:00"
  },
  {
    "id": "30aef8cc-ddf2-408a-a640-d715781551b9",
    "slug": "nasir-saleh-ahmed-dhaifalla-almessabi",
    "name": "MARYAM HASSAN ABDULLA ALI ALHAMMADI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/08/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Nasir saleh ahmed dhaifalla almessabi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_30aef8cc-ddf2-408a-a640-d715781551b9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1849",
    "licenseIssueDate": "08/22/2023 00:00:00",
    "licenseExpiryDate": "08/21/2026 00:00:00"
  },
  {
    "id": "7607ecf8-ac45-43b1-ae6f-b4380fb9674c",
    "slug": "nasr-aly-nasr",
    "name": "NASR ALY NASR ALY",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 21,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/05/2004",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Nasr Aly Nasr",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7607ecf8-ac45-43b1-ae6f-b4380fb9674c",
        "address": "",
        "phone": "97142989455",
        "email": "adv_nasr@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "4bf6169e-af5d-43e6-867c-8219fdfb27b1",
    "firmName": "ALNASR OFFCE ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-485",
    "licenseIssueDate": "05/22/2004 00:00:00",
    "licenseExpiryDate": "05/21/2026 00:00:00"
  },
  {
    "id": "a0b330c7-9a09-4aee-8adc-59070b5134be",
    "slug": "nasreen-ibrahim-abdulla",
    "name": "NASREEN IBRAHIM ABDULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/05/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Nasreen Ibrahim Abdulla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a0b330c7-9a09-4aee-8adc-59070b5134be",
        "address": "haleema almarzooqi ,3 ,building 7A ,D3 ,9569 ,Dubai",
        "phone": "97143621113",
        "email": "haleema.almarzooqi@dhalaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "4fb21617-b070-488f-8ce5-516725154e59",
    "firmName": "HALEEMA ALMARZOOQI &PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-815",
    "licenseIssueDate": "05/23/2012 00:00:00",
    "licenseExpiryDate": "05/22/2026 00:00:00"
  },
  {
    "id": "56748990-c607-4a25-ad25-a874a6f16435",
    "slug": "nasser-abdulla-hassan-mohammed-murshed",
    "name": "NASSER ABDULLA HASSAN MOHAMMED MURSHED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 18,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/12/2006",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: NASSER ABDULLA HASSAN MOHAMMED MURSHED",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_56748990-c607-4a25-ad25-a874a6f16435",
        "address": "",
        "phone": "97142736666",
        "email": "almohmon@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "651d46a2-cdc6-4e8e-99ad-7ee0f3ddca7a",
    "firmName": "AL MUHAMOON AL ARAB LAWYER & LEGAL CONSULTANCY",
    "registrationNumber": "L-583",
    "licenseIssueDate": "12/06/2006 00:00:00",
    "licenseExpiryDate": "12/05/2025 00:00:00"
  },
  {
    "id": "436ecef7-9af6-4e3c-9060-951df9b7ea74",
    "slug": "nasser-abdulrahman-mohammed-ismael-alhosani",
    "name": "NASSER ABDULRAHMAN MOHD ISMAEL ALHOSANI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/08/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Nasser Abdulrahman Mohammed Ismael Alhosani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_436ecef7-9af6-4e3c-9060-951df9b7ea74",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1557",
    "licenseIssueDate": "08/24/2021 00:00:00",
    "licenseExpiryDate": "08/23/2026 00:00:00"
  },
  {
    "id": "bd935372-206c-4076-b2e8-b5237cead440",
    "slug": "nasser-abdulwahed-abdulrahman-alawar",
    "name": "NASSER A WAHED A RAHMAN ALAWAR",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Civil Transactions-Construction and Contracts for Services",
      "Civil Transactions-Ownership & Title",
      "Personal Status-Custody & Alimony",
      "Commercial Transactions-Commercial Real Estate",
      "Civil Transactions-Tenancy",
      "Personal Status-Legacies and Inheritance",
      "Commercial Transactions-Commercial Companies",
      "Civil Transactions-Labor & Workers",
      "Criminal Law-Drug Crimes",
      "Civil Transactions-Sale",
      "Commercial Transactions-Consumer protection",
      "Personal Status-Marriage & Divorce",
      "Personal Status-Child Abuse & Abduction",
      "Civil Transactions-Compensation",
      "Criminal Law-Cybercrimes",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/05/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Nasser Abdulwahed Abdulrahman Alawar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bd935372-206c-4076-b2e8-b5237cead440",
        "address": "",
        "phone": "97143793798 / 971504407878",
        "email": "n.alawar@alawarlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "0209756c-e854-4fa0-836a-abe019e9fcd0",
    "firmName": "NASSER ALAWAR ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1361",
    "licenseIssueDate": "05/22/2019 00:00:00",
    "licenseExpiryDate": "05/21/2026 00:00:00"
  },
  {
    "id": "c43fa206-ccda-4c1c-b545-3f55c1434c09",
    "slug": "nasser-ali-saeed-bouasaibah-alali",
    "name": "NASSER ALI SAEED BO AUSAIBAH AL ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/03/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Nasser Ali Saeed Bouasaibah Alali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c43fa206-ccda-4c1c-b545-3f55c1434c09",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-1060",
    "licenseIssueDate": "03/10/2016 00:00:00",
    "licenseExpiryDate": "03/09/2026 00:00:00"
  },
  {
    "id": "844324ca-45eb-4cdf-8e3c-4831213112aa",
    "slug": "nasser-jerman-buti-ayed-al-ahbabi",
    "name": "NASSER JERMAN BUTI AYED AL AHBABI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/10/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Nasser Jerman Buti Ayed Al Ahbabi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_844324ca-45eb-4cdf-8e3c-4831213112aa",
        "address": "Mohammad Al Mheiri ,الاول ,امارات اتريم  ,شارع الشيخ زايد ,37979 ,Dubai",
        "phone": "97143333405",
        "email": "info@al-mheiri.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "455b5977-b40f-4801-b6bf-70838bb69abe",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1033",
    "licenseIssueDate": "10/22/2015 00:00:00",
    "licenseExpiryDate": "10/21/2026 00:00:00"
  },
  {
    "id": "fc38fac2-ba8f-4b79-8223-a203474cbf1f",
    "slug": "nasser-mohamed-hashem-metwally",
    "name": "NASSER MOHAMED HASHEM MOHAMED METWALLY",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 19,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/02/2006",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Nasser Mohamed Hashem Metwally",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fc38fac2-ba8f-4b79-8223-a203474cbf1f",
        "address": "",
        "phone": "97148321212",
        "email": "nasser@nmlawyers.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "71709458-e40a-45b3-9319-4c51c18891be",
    "firmName": "NASSER MALALLA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-549",
    "licenseIssueDate": "02/11/2006 00:00:00",
    "licenseExpiryDate": "02/10/2026 00:00:00"
  },
  {
    "id": "5d0aff31-c92f-4ff7-babb-61c390fc46dc",
    "slug": "nasser-saeed-majid-saeed-almheiri",
    "name": "WAFAA SULAIMAN SAEED A ALDHANHANI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/01/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Nasser Saeed Majid Saeed Almheiri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5d0aff31-c92f-4ff7-babb-61c390fc46dc",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1750",
    "licenseIssueDate": "01/29/2023 00:00:00",
    "licenseExpiryDate": "01/28/2026 00:00:00"
  },
  {
    "id": "86d446e9-2598-41b6-a01e-152def8a82d5",
    "slug": "nasser-shayea-hmoud-slayem-alhajeri",
    "name": "HAYTHAM AHMED SAIF NAJI ALAMERI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/03/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: NASSER SHAYEA HMOUD SLAYEM ALHAJERI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_86d446e9-2598-41b6-a01e-152def8a82d5",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1933",
    "licenseIssueDate": "04/16/2024 00:00:00",
    "licenseExpiryDate": "04/15/2026 00:00:00"
  },
  {
    "id": "74b33f0a-8b4c-454b-b604-f3dc67f13bb6",
    "slug": "nasser-yousuf-ali-nasser-alkhamis",
    "name": "NASSER YOUSUF ALI NASSER",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/06/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Nasser Yousuf Ali Nasser Alkhamis",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_74b33f0a-8b4c-454b-b604-f3dc67f13bb6",
        "address": "",
        "phone": "97145548499",
        "email": "legal@nyk.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "86fac3dc-bced-468b-8e4c-43324e2aa906",
    "firmName": "NASSER YOUSUF ALKHAMIS ADVOCATES &LEGAL CONSULTANTS",
    "registrationNumber": "L-1542",
    "licenseIssueDate": "06/25/2021 00:00:00",
    "licenseExpiryDate": "06/24/2026 00:00:00"
  },
  {
    "id": "01f9fe36-6c4c-4ffe-b05b-2a15f4632a18",
    "slug": "nawal-eissa-humaid-abdulla",
    "name": "NAWAL EISSA HUMAID ABDULLA ALZAABI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBORQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/01/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: nawal eissa humaid abdulla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_01f9fe36-6c4c-4ffe-b05b-2a15f4632a18",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1501",
    "licenseIssueDate": "01/27/2021 00:00:00",
    "licenseExpiryDate": "01/26/2026 00:00:00"
  },
  {
    "id": "516c357e-929b-401a-8f64-fd1596ff9455",
    "slug": "nawal-hassan-khalaf-mohamed-alhosani",
    "name": "HASSAN KHALAF MOHAMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/07/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Nawal Hassan Khalaf Mohamed Alhosani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_516c357e-929b-401a-8f64-fd1596ff9455",
        "address": "",
        "phone": "97143352000",
        "email": "info@alahlialkhaja.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "34476e35-fd77-4a2d-9ad0-cf8cca5e403a",
    "firmName": "AL AHLI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-882",
    "licenseIssueDate": "07/21/2013 00:00:00",
    "licenseExpiryDate": "07/20/2026 00:00:00"
  },
  {
    "id": "de0316a6-e2ad-409c-bbd4-5ef1b409f767",
    "slug": "nawal-mohamed-saif-al-bady-dhofouri",
    "name": "NAWAL MOHAMED SAIF AL BADY",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 17,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/03/2008",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Nawal Mohamed Saif Al Bady Dhofouri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_de0316a6-e2ad-409c-bbd4-5ef1b409f767",
        "address": "شركة قطر للتأمين ,مركز الدانة ,فندق كارلتون بالاس ,80239 ,Dubai",
        "phone": "97142247451",
        "email": "nooradvo@eim.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "09f7be53-e98a-499b-a46b-3635ebba9c54",
    "firmName": "NAWAL MOHAMED ALBADY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-623",
    "licenseIssueDate": "03/03/2008 00:00:00",
    "licenseExpiryDate": "03/02/2026 00:00:00"
  },
  {
    "id": "b1faf025-eeeb-4ac5-a998-65c387dd512d",
    "slug": "nawal-mustafa-mohammed-saleh-al-merbati",
    "name": "Nawal Mustafa Mohammed Saleh Al-Merbati",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 27,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/21/1998 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Nawal Mustafa Mohammed Saleh Al-Merbati",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b1faf025-eeeb-4ac5-a998-65c387dd512d",
        "address": "NAWAL AL MERBATI ,2, 208 ,RAK Bank Building ,RAK Bank ,99272 ,Dubai",
        "phone": "97142233775 / 971564454162",
        "email": "nawal.almurbati@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "ea00f5ec-97d3-419d-9c91-b66e5d05e2e8",
    "firmName": "NAWAL AL MERBATI ADVOCATES & LEGAL CONSULTANT",
    "registrationNumber": "332",
    "licenseIssueDate": "04/21/1998 00:00:00",
    "licenseExpiryDate": "04/20/2026 00:00:00"
  },
  {
    "id": "e24e728f-20fd-4f98-812e-d7ee21382482",
    "slug": "nawal-salem-seed-salem-batwaih",
    "name": "NAWAL SALEM SAEED SALEM BATWAIH",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/02/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Nawal Salem Seed Salem Batwaih",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e24e728f-20fd-4f98-812e-d7ee21382482",
        "address": "Nawal Salem Saeed Salem ,508 ,S. I. T Tower ,SILICON OASIS ,0000 ,Dubai",
        "phone": "97145582139 / 971555425608",
        "email": "courts@nslawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "8d7ab4a5-3c4d-4fa5-a466-d525e2054af8",
    "firmName": "NAWAL SALEM SAEED ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1254",
    "licenseIssueDate": "02/07/2018 00:00:00",
    "licenseExpiryDate": "02/06/2026 00:00:00"
  },
  {
    "id": "0ea46e3b-3a7b-444e-88d8-5a9b81d59bdc",
    "slug": "nawal-zayed-salmeen-dhabeek-alhosany",
    "name": "NAWAL ZAYED SALMEEN DHABEEK",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOWgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/12/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Nawal Zayed Salmeen Dhabeek Alhosany",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0ea46e3b-3a7b-444e-88d8-5a9b81d59bdc",
        "address": "",
        "phone": "97145148832 / 971502061303",
        "email": "dxbcourts@nhadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "bf5657d9-ea57-4099-89ca-c51bd6c1c641",
    "firmName": "NAWAL ALHOSANI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-720",
    "licenseIssueDate": "12/18/2014 00:00:00",
    "licenseExpiryDate": "12/17/2025 00:00:00"
  },
  {
    "id": "0866315e-bd34-497c-a474-0cfff7ca1203",
    "slug": "neela-ali-khamis-mohammed-al-muhairi",
    "name": "Neela Ali Khamis Mohammed Al Muhairi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/21/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Neela Ali Khamis Mohammed Al Muhairi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0866315e-bd34-497c-a474-0cfff7ca1203",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "1508",
    "licenseIssueDate": "02/21/2021 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "0ba15e63-16eb-421e-9468-d5b28b2e9ab6",
    "slug": "nisma-moin-mohamed-faqih-al-janahi",
    "name": "NISMA MOIN MOHAMED FAQIH ALJANAAHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/11/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-11-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Nisma Moin Mohamed Faqih Al Janahi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0ba15e63-16eb-421e-9468-d5b28b2e9ab6",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-782",
    "licenseIssueDate": "11/28/2011 00:00:00",
    "licenseExpiryDate": "11/27/2025 00:00:00"
  },
  {
    "id": "51c78350-fad9-40b0-9087-4d4a08028b2b",
    "slug": "noof-abdulla-ahmad-alabdulla",
    "name": "NOOF ABDULLA AHMAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/10/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Noof Abdulla Ahmad Alabdulla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_51c78350-fad9-40b0-9087-4d4a08028b2b",
        "address": "",
        "phone": "97143889955",
        "email": "m.alhanafi@nooflaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "6a72f470-256a-46d0-bead-acf13b981406",
    "firmName": "NOOF ALABDULLA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1125",
    "licenseIssueDate": "10/27/2016 00:00:00",
    "licenseExpiryDate": "10/26/2026 00:00:00"
  },
  {
    "id": "69f22f37-c285-4376-932c-048c0567ce5e",
    "slug": "noor-saeed-juma-saeed-alsuwaidi",
    "name": "SAEED JUMA SAEED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/09/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Noor Saeed Juma Saeed Alsuwaidi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_69f22f37-c285-4376-932c-048c0567ce5e",
        "address": "saeed juma saeed alsuwaidi ,الثامن عشر مكتب 1801 ,almasraf tower ,بجوار بلدية دبي ,36997 ,Dubai",
        "phone": "97142567771",
        "email": "info@saeedalsuwaidi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "bdfc9a52-bffc-4712-acc9-96eb498c7238",
    "firmName": "SAEED ALSUWAIDI LAWYERS & LEGAL CONSULTANTS",
    "registrationNumber": "L-1219",
    "licenseIssueDate": "09/05/2017 00:00:00",
    "licenseExpiryDate": "09/04/2026 00:00:00"
  },
  {
    "id": "7df211ae-f31b-403f-904a-bc5b75c25774",
    "slug": "noora-ahmad-moosa-sanqoor",
    "name": "NOORA AHMAD MOOSA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/03/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Noora Ahmad Moosa Sanqoor",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7df211ae-f31b-403f-904a-bc5b75c25774",
        "address": "",
        "phone": "97142222282",
        "email": "N.moosaa@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "ca27884c-48bb-4c1a-bcba-dd4c938fe85b",
    "firmName": "NOORA AHMAD ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1158",
    "licenseIssueDate": "03/20/2017 00:00:00",
    "licenseExpiryDate": "03/19/2026 00:00:00"
  },
  {
    "id": "0cea8a2b-1ffd-4f49-8c4f-a164bcf547c3",
    "slug": "noora-mohamed-mahmood-mahmood",
    "name": "Noora mohamed mahmood mahmood",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/25/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Noora mohamed mahmood mahmood",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0cea8a2b-1ffd-4f49-8c4f-a164bcf547c3",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "1749",
    "licenseIssueDate": "01/25/2023 00:00:00",
    "licenseExpiryDate": "01/24/2026 00:00:00"
  },
  {
    "id": "36fe74ff-9003-436f-a420-a46fd7e31a9f",
    "slug": "noorah-ahmed-mohammed-ahmed-alhousani",
    "name": "NOORAH AHMED MOHAMMED ALHOUSANI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/10/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Noorah Ahmed Mohammed Ahmed Alhousani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_36fe74ff-9003-436f-a420-a46fd7e31a9f",
        "address": "Sara Shah Baik Elbloshi ,الطابق 13 - مكتب 1306 ,CLOVER BAY ,بجوار SONDER HOTEL ,112773 ,Dubai",
        "phone": "97143514666",
        "email": "admin@saraadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "9271d191-2f3e-4570-93bf-34fb919bf6e0",
    "firmName": "SARA ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-1231",
    "licenseIssueDate": "10/29/2017 00:00:00",
    "licenseExpiryDate": "10/28/2025 00:00:00"
  },
  {
    "id": "574d0b5d-9f6c-4fc6-b02e-261714b038a2",
    "slug": "noorah-nasser-dos-mohammed-ali",
    "name": "NOORAH NASSER DOS MOHAMMED ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/01/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Noorah Nasser Dos Mohammed Ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_574d0b5d-9f6c-4fc6-b02e-261714b038a2",
        "address": "mohamed mahmoud mohamed elkormany ,بناية الوصل ,R549 يناية الوصل ,سيتي سنتر ديره ,83620 ,Dubai",
        "phone": "97142542000",
        "email": "info@aaalegalconsultants.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "927c60c9-145e-4bb5-8913-d6d6aa72f891",
    "firmName": "ABDALLA ALNAKHI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-911",
    "licenseIssueDate": "01/28/2014 00:00:00",
    "licenseExpiryDate": "01/27/2026 00:00:00"
  },
  {
    "id": "91842482-a970-4ef7-bbf2-d98b938a85a5",
    "slug": "noorhan-abdullatif-abdulrahman-ebrahim-alzaabi",
    "name": "NOORHAN ABDULLATIF ABDULRAHMAN ALZAABI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/06/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Noorhan Abdullatif  Abdulrahman Ebrahim Alzaabi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_91842482-a970-4ef7-bbf2-d98b938a85a5",
        "address": "",
        "phone": "97148761744 / 971971487617",
        "email": "info@noorhanlawyer.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "8fd1535a-4b34-4e52-83df-139fcfb26305",
    "firmName": "NOORHAN ABDULLATIF ALZAABI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1367",
    "licenseIssueDate": "07/01/2019 00:00:00",
    "licenseExpiryDate": "06/30/2026 00:00:00"
  },
  {
    "id": "30597368-88a1-43cd-87e0-532661a31802",
    "slug": "nouf-abdulfadhel-mohd-qasem-baidaryamche",
    "name": "HAMDAN DEHAI KHALFAN SUBAIH",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/02/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: NOUF ABDULFADHEL MOHD QASEM BAIDARYAMCHE",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_30597368-88a1-43cd-87e0-532661a31802",
        "address": "",
        "phone": "",
        "email": "noufyamgy4@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "ea2fa1be-e299-4370-b7f3-bdd8c7bf051d",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1629",
    "licenseIssueDate": "03/02/2022 00:00:00",
    "licenseExpiryDate": "03/01/2026 00:00:00"
  },
  {
    "id": "3190b753-c0c1-4a0b-86de-cd01a5c76e48",
    "slug": "nouf-abdulrahim-mohammed-abdullatif-alhashmi",
    "name": "ABDULRAHIM MOHAMMED ABDULLATIF",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/03/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Nouf Abdulrahim Mohammed Abdullatif Alhashmi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3190b753-c0c1-4a0b-86de-cd01a5c76e48",
        "address": "",
        "phone": "97143380333",
        "email": "info@fahadbintamim.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "6924283e-95b7-4af2-85a3-cc6cbcc10a20",
    "firmName": "FAHAD BIN TAMIM ADVOCATES & LEGAL CONSULTANTCY",
    "registrationNumber": "L-1270",
    "licenseIssueDate": "03/28/2023 00:00:00",
    "licenseExpiryDate": "03/27/2026 00:00:00"
  },
  {
    "id": "e7615f40-1b7b-47b5-b9c5-96c8a9247988",
    "slug": "nouf-darweesh-khameis-masoud-almatrooshi",
    "name": "NOUF DARWEISH KHAMEIS M S ALMATROOSHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBORAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/04/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Nouf Darweesh Khameis Masoud Almatrooshi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e7615f40-1b7b-47b5-b9c5-96c8a9247988",
        "address": "O-4801, O-4901 ,Burj al Salam Office Tower ,H Hotel ,111801 ,Dubai",
        "phone": "97143544444",
        "email": "administration@horizlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "4e25fb39-6659-44f0-bc8b-3ff0f067beb0",
    "firmName": "HORIZONS & CO - LAW FIRM",
    "registrationNumber": "L-1067",
    "licenseIssueDate": "04/07/2016 00:00:00",
    "licenseExpiryDate": "04/06/2027 00:00:00"
  },
  {
    "id": "24e51ce2-c553-4ea8-8557-7e5c79eabe90",
    "slug": "nouf-suhail-saeed-ali-alkaabi",
    "name": "MUNA AHMAD ALI W O AHMAD J BIN GHALAITA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/07/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Nouf Suhail Saeed Ali Alkaabi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_24e51ce2-c553-4ea8-8557-7e5c79eabe90",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1681",
    "licenseIssueDate": "07/21/2022 00:00:00",
    "licenseExpiryDate": "07/20/2026 00:00:00"
  },
  {
    "id": "9f9480ed-a082-4b54-8810-aafb1696eff1",
    "slug": "nouf-yousif-hassan-alhammadi",
    "name": "YOUSIF HASSAN ALI HASHIM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/07/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Nouf Yousif Hassan Alhammadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9f9480ed-a082-4b54-8810-aafb1696eff1",
        "address": "",
        "phone": "97142227008 / 971506245451",
        "email": "info@abdulmaliklaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "5714833f-5b48-477b-a556-efa3a779f522",
    "firmName": "ABDULMALIK & ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1016",
    "licenseIssueDate": "07/07/2015 00:00:00",
    "licenseExpiryDate": "07/06/2026 00:00:00"
  },
  {
    "id": "cd304caf-f76b-4d7d-b768-85d2dbaaff6b",
    "slug": "noura-hasan-marzouq-awadh-alseiari",
    "name": "FAHMI OMAR ABDULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/07/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: NOURA HASAN MARZOUQ AWADH ALSEIARI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cd304caf-f76b-4d7d-b768-85d2dbaaff6b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-2007",
    "licenseIssueDate": "07/23/2024 00:00:00",
    "licenseExpiryDate": "07/22/2026 00:00:00"
  },
  {
    "id": "753196b3-1c8f-4795-9279-e94d8039d234",
    "slug": "noura-ibrahim-hassan-ali-alamiri",
    "name": "IBRAHIM HASSAN ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 15,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/01/2010",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Noura Ibrahim Hassan Ali Alamiri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_753196b3-1c8f-4795-9279-e94d8039d234",
        "address": "HUSSA ALI ALQUBAISI ,FLOOR 31 OFFICE 3103 ,BURLINGTON TOWER ,DUBAI ISLAMIC BANK ,15002 ,Dubai",
        "phone": "97142427805",
        "email": "info@haqlegalconsultants.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "1d48c777-9533-4c84-8e5b-5abde5f50dab",
    "firmName": "NOURA ALAMIRI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-695",
    "licenseIssueDate": "01/10/2010 00:00:00",
    "licenseExpiryDate": "01/09/2026 00:00:00"
  },
  {
    "id": "30faf121-1193-41de-aec1-ff7ac6ffa7ad",
    "slug": "noura-mohamed-murad-abdelrahman-almaazmi",
    "name": "NOURA MOHAMED MURAD ABDELRAHMAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Civil Transactions-POA & Sponsorship",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Civil Transactions-Insurance",
      "Personal Status-Wills",
      "Civil Transactions-Construction and Contracts for Services",
      "Civil Transactions-Ownership & Title",
      "Civil Transactions-HR & Employee Affairs",
      "Personal Status-Custody & Alimony",
      "Civil Transactions-Immigration and Residency",
      "Civil Transactions-Residential Real Estate",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Civil Transactions-Tenancy",
      "Criminal Law-Crimes against persons",
      "Personal Status-Legacies and Inheritance",
      "Commercial Transactions-Commercial Companies",
      "Commercial Transactions-Banking Operations",
      "Civil Transactions-Labor & Workers",
      "Personal Status-Legal Capacity & Guardianship",
      "Criminal Law-Drug Crimes",
      "Civil Transactions-Sale",
      "Personal Status-Marriage & Divorce",
      "Civil Transactions-Compensation",
      "Criminal Law-Crimes against properties",
      "Criminal Law-Cybercrimes",
      "Commercial Transactions-Intellectual Property (includes trademarks",
      "copy rights",
      "patents)",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/01/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Noura Mohamed Murad Abdelrahman Almaazmi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_30faf121-1193-41de-aec1-ff7ac6ffa7ad",
        "address": "Noura Mohamed Abdelrahman Almaazmi ,17 ,The Oberoi Center ,Burlington Tower ,414224 ,Dubai",
        "phone": "97143215777",
        "email": "case@almaazmilawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "e56938ba-8d38-4268-9706-651d4c984db9",
    "firmName": "NOURA ALMAAZMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-788",
    "licenseIssueDate": "01/26/2012 00:00:00",
    "licenseExpiryDate": "01/25/2026 00:00:00"
  },
  {
    "id": "e700d2c0-a313-453e-ba4a-60710a11076f",
    "slug": "noura-sahmi-nasser-jaml-alhajeri",
    "name": "NOURA SEHMI NASSER JAML ALHAJERI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/05/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Noura Sahmi Nasser Jaml Alhajeri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e700d2c0-a313-453e-ba4a-60710a11076f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1190",
    "licenseIssueDate": "05/21/2017 00:00:00",
    "licenseExpiryDate": "05/20/2026 00:00:00"
  },
  {
    "id": "ff5397f7-b293-4e82-a15f-2dd268f523e4",
    "slug": "noura-saleh-mohamed-ahmed-alhajeri",
    "name": "NOURA SALEH MOHAMED AHMED ALHAJERI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/10/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Noura Saleh Mohamed Ahmed Alhajeri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ff5397f7-b293-4e82-a15f-2dd268f523e4",
        "address": "FAHD MOHAMED RASHED ALHADOURI ALYAMMAHI ,10 ,MAZE TOWER ,DIFC - FUTURE MUSEUM ,127077 ,Dubai",
        "phone": "97143596555",
        "email": "fhd6767@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "4e636842-b67d-49a6-a11f-607b9a136380",
    "firmName": "NOURA ALHAJERI AND FAHD ALHADOURI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-894",
    "licenseIssueDate": "10/27/2013 00:00:00",
    "licenseExpiryDate": "10/26/2026 00:00:00"
  },
  {
    "id": "2694ea0e-4d40-44a0-a9b4-958f17222b47",
    "slug": "noura-taysser-mohamed-nasib",
    "name": "KHALFAN SAIF KHALFAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/01/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Noura taysser mohamed nasib",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2694ea0e-4d40-44a0-a9b4-958f17222b47",
        "address": "1606 ,متروبوليس تاور  ,داماك ,0000000 ,Dubai",
        "phone": "",
        "email": "noura.taisser@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "a653164d-3cbc-49d0-a7cd-ba5fe563222d",
    "firmName": "HADEEL AL SHAALI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1618",
    "licenseIssueDate": "02/02/2022 00:00:00",
    "licenseExpiryDate": "02/01/2026 00:00:00"
  },
  {
    "id": "f27233f7-118a-4283-89ae-34866945b307",
    "slug": "nourah-rashed-jumah-alrashdi-almurshidi",
    "name": "ABDULLA MOHD JABER ABDULLA ALHARBI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/02/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Nourah Rashed Jumah Alrashdi Almurshidi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f27233f7-118a-4283-89ae-34866945b307",
        "address": "",
        "phone": "97145132619 / 971543630593",
        "email": "info@alfaisal.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "fd647c60-3bff-4297-87f1-6437acf45575",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1763",
    "licenseIssueDate": "02/22/2023 00:00:00",
    "licenseExpiryDate": "02/21/2026 00:00:00"
  },
  {
    "id": "3763b3a5-0c1c-497b-8933-f71b801371da",
    "slug": "nujood-mohammed-omar-ali-bin-haider",
    "name": "NUJOOD MOHAMMED OMAR ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/08/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Nujood Mohammed Omar Ali Bin Haider",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3763b3a5-0c1c-497b-8933-f71b801371da",
        "address": "1 ,MOBH Building 2 ,GGICO Metro Station ,3555 ,Dubai",
        "phone": "97142821191 / 971552222519",
        "email": "nujoodlegal@mobhgroup.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "019941a6-be29-4b9c-a1ee-6f6cf6c599de",
    "firmName": "NUJOOD BIN HAIDER ADVOCATES & LEAGL CONSULTANTS",
    "registrationNumber": "L-434",
    "licenseIssueDate": "08/19/2014 00:00:00",
    "licenseExpiryDate": "08/18/2026 00:00:00"
  },
  {
    "id": "36e39066-f24f-4af5-ab48-23f2a32c469b",
    "slug": "obaid-abdulla-mubarak-abdulla-alebri",
    "name": "OBAID ABDULLA MUBARAK ABDULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/09/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Obaid Abdulla Mubarak Abdulla Alebri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_36e39066-f24f-4af5-ab48-23f2a32c469b",
        "address": "",
        "phone": "97142966772",
        "email": "info@advocates-consultation.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "43806daf-e311-4130-a270-8aabc08c4ef4",
    "firmName": "OBAID AL EBRI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1569",
    "licenseIssueDate": "09/23/2021 00:00:00",
    "licenseExpiryDate": "09/22/2026 00:00:00"
  },
  {
    "id": "b1d2d88a-60f4-4376-a252-75edcb13cbd9",
    "slug": "obaid-ishaq-abdalla-ismall-a-lmaazmi",
    "name": "OBAID ISHAQ ABDALLA ISMAIL ALMAAZMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/10/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Obaid Ishaq Abdalla  Ismall A lmaazmi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b1d2d88a-60f4-4376-a252-75edcb13cbd9",
        "address": "Obaid Ishaq Ismail Al-Maazmi ,الطابق 21 ,ذا اكستشينج تاور  ,فندق جي دبليو ماريوت ماركي ,238365 ,Dubai",
        "phone": "97143584737",
        "email": "obaidotp@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "70a8fb70-2729-4348-b87b-258c7dc7a387",
    "firmName": "OBAID AL MAZIMI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-836",
    "licenseIssueDate": "11/01/2012 00:00:00",
    "licenseExpiryDate": "10/31/2025 00:00:00"
  },
  {
    "id": "ea44b43a-74a3-402c-9650-076ecdf8888d",
    "slug": "obaid-mohamed-ibrahim-mubarak-alhammadi",
    "name": "MANA AHMAD MOHAMMAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/07/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Obaid Mohamed Ibrahim Mubarak Alhammadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ea44b43a-74a3-402c-9650-076ecdf8888d",
        "address": "ادارة ا لمبنى  ,الريم ,الاتصالات  ,42423 ,Dubai",
        "phone": "97142222066",
        "email": "info@ozleco.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "7a155f4a-20ec-44ff-863f-4f9fb43d0af4",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1829",
    "licenseIssueDate": "07/13/2023 00:00:00",
    "licenseExpiryDate": "07/12/2026 00:00:00"
  },
  {
    "id": "1dafff22-41ac-49fd-9510-0dd517fc709d",
    "slug": "obaid-omran-ali-obaid-al-shamsi",
    "name": "OBAID OMRAN ALI OBAID ALSHAMSI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/12/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Obaid Omran Ali Obaid Al shamsi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1dafff22-41ac-49fd-9510-0dd517fc709d",
        "address": "",
        "phone": "97143298881",
        "email": "info@mslawuae.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "2510dab9-717a-4a15-b189-4272261227e3",
    "firmName": "AL MADHANI & ALSHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-845",
    "licenseIssueDate": "12/20/2012 00:00:00",
    "licenseExpiryDate": "12/19/2025 00:00:00"
  },
  {
    "id": "d0bc2b92-ca69-4e08-a6b8-a6267f6cf330",
    "slug": "obaid-saeed-ali-obaid-alshamsi",
    "name": "OBAID SAEED ALI OBAID ALSHAMSI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/03/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Obaid Saeed Ali Obaid Alshamsi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d0bc2b92-ca69-4e08-a6b8-a6267f6cf330",
        "address": "OBAID AL SHAMSI ADVOCATES & LEGAL CONSULTANTS ,لا يوجد ,AL GARHOUD BUSINESS CENTER ,AL GARHOUD BUSINESS CENTER ,1903 ,Dubai",
        "phone": "97129555545",
        "email": "info@oaslawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "c8252dab-1a42-4878-a3ee-50ba9dddb978",
    "firmName": "OBAID ALSHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-864",
    "licenseIssueDate": "03/03/2013 00:00:00",
    "licenseExpiryDate": "03/02/2026 00:00:00"
  },
  {
    "id": "58bd97b2-3e00-4277-8086-dc49754d656b",
    "slug": "obaid-said-essa-abdullateif-al-serkal",
    "name": "OBAID SAEED EISSA ABDULLATIF ALSERKAL",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/11/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Obaid Said Essa Abdullateif Al-Serkal",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_58bd97b2-3e00-4277-8086-dc49754d656b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-359",
    "licenseIssueDate": "11/24/2016 00:00:00",
    "licenseExpiryDate": "11/23/2025 00:00:00"
  },
  {
    "id": "31e0039c-c15c-4bc0-9934-e74c69e95dc3",
    "slug": "obaid-saleh-obaid-bin-khesaif-alshuweihi",
    "name": "ABDULLA MOHAMED A. ABDULRAHMAN ALYASSI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/02/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: obaid saleh obaid bin khesaif alshuweihi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_31e0039c-c15c-4bc0-9934-e74c69e95dc3",
        "address": "4 ,Century 21 building ,al kabayel discount centre ,340781 ,Dubai",
        "phone": "97142417888 / 971562693277",
        "email": "dubai@khbinomair.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "34306e48-bd22-4b51-b883-2a538d4f1890",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1923",
    "licenseIssueDate": "03/06/2024 00:00:00",
    "licenseExpiryDate": "03/05/2026 00:00:00"
  },
  {
    "id": "8f10cf6c-45d5-44ea-897b-20cec33a1798",
    "slug": "obaid-saqer-obaid-busit",
    "name": "OBAID SAQER OBAID BUSIT",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 21,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/01/2004",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Obaid Saqer Obaid Busit",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8f10cf6c-45d5-44ea-897b-20cec33a1798",
        "address": "OBAID SAQER OBAID BUSIT ,20 ,Grosvenor Business Tower -  ,Sheikha noora tower ,333341 ,Dubai",
        "phone": "97144472777",
        "email": "busit@busitlegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "ebfce11b-8cb4-42cc-95d3-71c6e17bfdf0",
    "firmName": "BUSIT ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-181",
    "licenseIssueDate": "01/25/2004 00:00:00",
    "licenseExpiryDate": "01/24/2026 00:00:00"
  },
  {
    "id": "0177ea10-b6d0-425a-9a7b-837d534f7d8c",
    "slug": "ohood-amer-ali-alnayeli-alshamsi",
    "name": "OHOOD AMER ALI ALNAYELI ALSHAMSI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/09/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ohood Amer Ali Alnayeli Alshamsi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0177ea10-b6d0-425a-9a7b-837d534f7d8c",
        "address": "",
        "phone": "97142989455",
        "email": "adv_nasr@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "4bf6169e-af5d-43e6-867c-8219fdfb27b1",
    "firmName": "ALNASR OFFCE ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-1565",
    "licenseIssueDate": "09/22/2021 00:00:00",
    "licenseExpiryDate": "09/21/2026 00:00:00"
  },
  {
    "id": "27862a07-c3cb-4978-9e18-a7fc2dd8b34e",
    "slug": "ohoud-khalaf-ali-khalaf-alhosani",
    "name": "ABDULLA SALEM ADDAS",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/03/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: OHOUD KHALAF ALI KHALAF ALHOSANI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_27862a07-c3cb-4978-9e18-a7fc2dd8b34e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1936",
    "licenseIssueDate": "04/18/2024 00:00:00",
    "licenseExpiryDate": "04/17/2026 00:00:00"
  },
  {
    "id": "1eff7ab4-d39b-4c1c-8962-43e4a7e0137e",
    "slug": "omair-naser-husain-abdulla-alharthi",
    "name": "OMAIR NASER HUSAIN ABDULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/03/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Omair Naser Husain Abdulla Alharthi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1eff7ab4-d39b-4c1c-8962-43e4a7e0137e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1520",
    "licenseIssueDate": "03/30/2021 00:00:00",
    "licenseExpiryDate": "03/29/2026 00:00:00"
  },
  {
    "id": "06cb0c8f-c07d-43a2-8705-01a06617b96f",
    "slug": "omar-abdulaziz-abdulla-aziz-al-omar",
    "name": "OMAR ABDULAZIZ ABDULLA AZIZ",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/08/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Omar Abdulaziz Abdulla Aziz Al Omar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_06cb0c8f-c07d-43a2-8705-01a06617b96f",
        "address": "omar abdulazizi alomar ,15 ,prime tower ,blom bank france ,211940 ,Dubai",
        "phone": "97143808838 / 971504598082",
        "email": "omar.omar@oghlegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "171b4622-e4ec-4375-a9c4-3637bf6a8b17",
    "firmName": "ALOMAR & ALSABAH ADVOCATES",
    "registrationNumber": "L-885",
    "licenseIssueDate": "08/11/2013 00:00:00",
    "licenseExpiryDate": "08/10/2026 00:00:00"
  },
  {
    "id": "450b8484-4166-42d5-9951-806778e83ef3",
    "slug": "omar-abdulaziz-ibrahim-alsebhan",
    "name": "OMAR ABDULAZIZ IBRAHIM ALSEBHAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/02/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Omar Abdulaziz Ibrahim Alsebhan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_450b8484-4166-42d5-9951-806778e83ef3",
        "address": "",
        "phone": "97143474007",
        "email": "info@alsabhanlegalgroup.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "c31ad0e5-b382-4c9a-9fab-8853b1330f6b",
    "firmName": "DR AL SABBHAN LEGAL GROUP&ASSOCLATES",
    "registrationNumber": "L-993",
    "licenseIssueDate": "02/26/2015 00:00:00",
    "licenseExpiryDate": "02/25/2026 00:00:00"
  },
  {
    "id": "dfee79c5-ea3c-49ca-bb29-9ae631eedfe1",
    "slug": "omar-abdulla-ebrahim-mohamad-al-heloo",
    "name": "OMAR ABDULLA EBRAHIM MOHAMMAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 17,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/02/2008",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: OMAR ABDULLA EBRAHIM MOHAMAD AL HELOO",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dfee79c5-ea3c-49ca-bb29-9ae631eedfe1",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-620",
    "licenseIssueDate": "02/03/2008 00:00:00",
    "licenseExpiryDate": "02/02/2026 00:00:00"
  },
  {
    "id": "878c912c-b0bb-4dfc-82b7-e49477a27994",
    "slug": "omar-abdulwahab-abdulla-abdulrahman-alawadhi",
    "name": "OMAR ABDULWAHAB ABDULLA ABDULRAHMAN ALAWADHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/03/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Omar Abdulwahab Abdulla Abdulrahman Alawadhi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_878c912c-b0bb-4dfc-82b7-e49477a27994",
        "address": "MOHAMMED MURTADA ALHASHMI ,3 ,LATIFA TOWER  ,CROWN PLAZA ,231400 ,Dubai",
        "phone": "97143521131",
        "email": "info@mhadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "a5a2640f-b1b8-4512-b9ee-a8802d0c30fc",
    "firmName": "ADVOCATES UNIT",
    "registrationNumber": "L-1063",
    "licenseIssueDate": "03/24/2016 00:00:00",
    "licenseExpiryDate": "03/23/2026 00:00:00"
  },
  {
    "id": "bcca8b26-bc8b-4dd5-bbd6-fd8e3ace1e86",
    "slug": "omar-ahmed-khamis-bin-madi-alhelali",
    "name": "OMAR AHMED KHAMIS BIN MADI ALHELALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/01/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Omar Ahmed Khamis Bin Madi Alhelali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bcca8b26-bc8b-4dd5-bbd6-fd8e3ace1e86",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1398",
    "licenseIssueDate": "01/09/2020 00:00:00",
    "licenseExpiryDate": "01/08/2026 00:00:00"
  },
  {
    "id": "8198a3dd-80cc-4656-81dc-9d1876c941df",
    "slug": "omar-ali-saeed-mahboob-alnuaimi",
    "name": "OMAR ALI SAEED MAHBOOB ALNUAIMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/10/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Omar Ali Saeed Mahboob Alnuaimi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8198a3dd-80cc-4656-81dc-9d1876c941df",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1588",
    "licenseIssueDate": "11/01/2021 00:00:00",
    "licenseExpiryDate": "10/31/2025 00:00:00"
  },
  {
    "id": "1c04bbea-52bd-4b0d-ad87-4ad6052be93d",
    "slug": "omar-el-shaik-said-ahmed-el-shaik",
    "name": "OMER ELSHAIKH SIDAHMED ELSHAIKH",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 20,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/01/2005",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Omar El Shaik Said Ahmed El Shaik",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1c04bbea-52bd-4b0d-ad87-4ad6052be93d",
        "address": "Muna Ahmed Abdul-aziz Al-Sabbagh ,الطابق الخامس ,الزمردة ,مختبر دبي المركزي ,115578 ,Dubai",
        "phone": "97142283414",
        "email": "info@alwifaqlegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "120e4ca7-7727-4524-9d53-5656ff95eea7",
    "firmName": "MUNA AL SABBAGH ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-504",
    "licenseIssueDate": "01/10/2005 00:00:00",
    "licenseExpiryDate": "01/09/2026 00:00:00"
  },
  {
    "id": "83176a1a-744a-49e9-93bc-43b16a7dd20d",
    "slug": "omar-humaid-obaid-humaid-alshamsi",
    "name": "AHMED SALEM MOHAMMED MURSHED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/11/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: omar humaid obaid humaid alshamsi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_83176a1a-744a-49e9-93bc-43b16a7dd20d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1727",
    "licenseIssueDate": "11/27/2022 00:00:00",
    "licenseExpiryDate": "11/26/2025 00:00:00"
  },
  {
    "id": "dd930027-ba19-4d2f-aa3e-8f584e6f9a06",
    "slug": "omar-humaidan-mohammed-humaidan-alzaabi",
    "name": "OMAR HUMAIDAN MOHAMMED H ALZAABI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/10/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: OMAR HUMAIDAN MOHAMMED HUMAIDAN ALZAABI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dd930027-ba19-4d2f-aa3e-8f584e6f9a06",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1573",
    "licenseIssueDate": "10/07/2021 00:00:00",
    "licenseExpiryDate": "10/06/2026 00:00:00"
  },
  {
    "id": "40fdb545-716d-4710-a6fb-f7ab4f1eb1c2",
    "slug": "omar-khalifa-abdulkarim-yousef-alblooshi",
    "name": "SAFA MOHAMED SANQOUR QAMBAR ALMAAZMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/12/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Omar Khalifa Abdulkarim Yousef Alblooshi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_40fdb545-716d-4710-a6fb-f7ab4f1eb1c2",
        "address": "901-902 ,برج السلام ,فندق جراند شيراتون ,2741291443 ,Dubai",
        "phone": "97145877794 / 971586606660",
        "email": "obh@obhlawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "edbb7814-39f9-4ec9-b01d-9de1117e343e",
    "firmName": "SALHA ALBASTI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1740",
    "licenseIssueDate": "01/10/2023 00:00:00",
    "licenseExpiryDate": "01/09/2026 00:00:00"
  },
  {
    "id": "8e98a671-dffa-49e9-8e43-e150c6573218",
    "slug": "omar-mohamed-sharif-othman-yousuf-sulaiman",
    "name": "OMAR MOHAMED SHARIF O YOUSUF SULAIMAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/11/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Omar Mohamed Sharif Othman Yousuf Sulaiman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8e98a671-dffa-49e9-8e43-e150c6573218",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1325",
    "licenseIssueDate": "11/22/2018 00:00:00",
    "licenseExpiryDate": "11/21/2025 00:00:00"
  },
  {
    "id": "5b84cbb8-4343-4015-b89d-999e460dfb49",
    "slug": "omar-mohamed-yousef-mandi-altamimi",
    "name": "OMAR MOHAMMED YOUSEF MANDI ALTAMIMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/06/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Omar Mohamed Yousef Mandi Altamimi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5b84cbb8-4343-4015-b89d-999e460dfb49",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-1535",
    "licenseIssueDate": "06/15/2021 00:00:00",
    "licenseExpiryDate": "06/14/2026 00:00:00"
  },
  {
    "id": "d7c771f7-1171-49ae-b6df-cc72e9e79923",
    "slug": "omar-obaid-khamis-obaid-sulaiman-alzaher",
    "name": "OMAR OBAID KHAMIS O S ALZAHER",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/12/2010",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Omar Obaid Khamis Obaid Sulaiman Alzaher",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d7c771f7-1171-49ae-b6df-cc72e9e79923",
        "address": "10th Floor ,AlReem Tower ,Dubai Land Department ,32367 ,Dubai",
        "phone": "97142272701",
        "email": "midfaadv@eim.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "fe9068a7-b94d-49bb-88b3-6f8491a15389",
    "firmName": "AL MIDFA & ASSOCIATES",
    "registrationNumber": "L-735",
    "licenseIssueDate": "12/28/2010 00:00:00",
    "licenseExpiryDate": "12/27/2025 00:00:00"
  },
  {
    "id": "e4bf40b7-693b-4b87-bcde-5dd30815e967",
    "slug": "omar-rashid-hamid-masoud-alghafri",
    "name": "RASHID HAMID MASOUD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/07/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Omar Rashid Hamid Masoud Alghafri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e4bf40b7-693b-4b87-bcde-5dd30815e967",
        "address": "",
        "phone": "97165333314 / 971569381334",
        "email": "info@alghafri.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "9990674d-a6d3-4791-b6b7-76573d232260",
    "firmName": "OMAR RASHID AL GHAFRI LAWYER AND LEGAL CONSULTANTS",
    "registrationNumber": "L-1200",
    "licenseIssueDate": "07/10/2017 00:00:00",
    "licenseExpiryDate": "07/09/2026 00:00:00"
  },
  {
    "id": "a838d604-47fa-4c04-aa77-85d12ecff7f1",
    "slug": "omran-darwish-ahmad-mohammad-albalooshi",
    "name": "Omran Darwish Ahmad Mohammad Albalooshi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/05/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Omran Darwish Ahmad Mohammad Albalooshi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a838d604-47fa-4c04-aa77-85d12ecff7f1",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "736",
    "licenseIssueDate": "01/05/2011 00:00:00",
    "licenseExpiryDate": "01/04/2026 00:00:00"
  },
  {
    "id": "0dcc9c3b-edda-4357-a7d7-a91231ff0d29",
    "slug": "omran-rashed-abdulla-rashed-al-nuaimi",
    "name": "OMRAN RASHED ABDULLA RASHED ALNUAIMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Commercial Agency",
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Civil Transactions-POA & Sponsorship",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Civil Transactions-Construction and Contracts for Services",
      "Civil Transactions-Ownership & Title",
      "Civil Transactions-HR & Employee Affairs",
      "Commercial Transactions-Commercial Mortgage",
      "Personal Status-Custody & Alimony",
      "Commercial Transactions-Commercial Contracts",
      "Commercial Transactions-Commercial Real Estate",
      "Civil Transactions-Residential Real Estate",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Civil Transactions-Arbitration",
      "Civil Transactions-Tenancy",
      "Commercial Transactions-Unfair competition",
      "Personal Status-Legacies and Inheritance",
      "Commercial Transactions-Commercial Companies",
      "Personal Status-Legal Capacity & Guardianship",
      "Personal Status-Marriage & Divorce",
      "Personal Status-Child Abuse & Abduction",
      "Civil Transactions-Compensation",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 18,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/03/2007",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Omran Rashed Abdulla Rashed Al Nuaimi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0dcc9c3b-edda-4357-a7d7-a91231ff0d29",
        "address": "",
        "phone": "97143213302",
        "email": "lawfirm@liberallawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "a791ae2d-579f-42dd-945f-b28c198a33e4",
    "firmName": "LIBERALS LAWYERS LEGAL CONSULTANTS AND LAWYERS",
    "registrationNumber": "L-600",
    "licenseIssueDate": "03/06/2007 00:00:00",
    "licenseExpiryDate": "03/05/2026 00:00:00"
  },
  {
    "id": "7bbfffc6-ebc1-4653-8ed3-d70ca9b1e6a8",
    "slug": "osama-hassan-othman-dablook",
    "name": "OSAMA HASSAN OSMAN DABLOUK",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 26,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/06/1999",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Osama Hassan Othman Dablook",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7bbfffc6-ebc1-4653-8ed3-d70ca9b1e6a8",
        "address": "Dr. Ali Ismail Aljarman ,Roof Floor - Offices R03 & R04 ,MSM 1 Building ,Al Saffa First ,62639 ,Dubai",
        "phone": "97144393733",
        "email": "info@prestigeadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "22043b7f-55d2-4eb4-a173-3077ba390351",
    "firmName": "PRESTIGE ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-360",
    "licenseIssueDate": "06/14/1999 00:00:00",
    "licenseExpiryDate": "06/13/2026 00:00:00"
  },
  {
    "id": "0b9a700b-cfd7-45b1-816f-8392217472f0",
    "slug": "osamah-mohamed-ahmed-salem-alsalmi",
    "name": "OSAMAH MOHAMED AHMED SALEM AL SALMY",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Commercial Agency",
      "Proceedings-Cases and Proceedings before Dubai International Financial Centre",
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Civil Transactions-POA & Sponsorship",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Civil Transactions-Insurance",
      "Civil Transactions-Construction and Contracts for Services",
      "Civil Transactions-Ownership & Title",
      "Civil Transactions-HR & Employee Affairs",
      "Commercial Transactions-Commercial Mortgage",
      "Criminal Law-Family Crimes",
      "Commercial Transactions-Commercial Contracts",
      "Civil Transactions-Immigration and Residency",
      "Commercial Transactions-Bankruptcy",
      "Commercial Transactions-Commercial Real Estate",
      "Civil Transactions-Residential Real Estate",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Civil Transactions-Arbitration",
      "Criminal Law-Hate crimes",
      "Civil Transactions-Tenancy",
      "Commercial Transactions-Unfair competition",
      "Criminal Law-Crimes against persons",
      "Commercial Transactions-Banking Operations",
      "Civil Transactions-Labor & Workers",
      "Criminal Law-Drug Crimes",
      "Civil Transactions-Sale",
      "Commercial Transactions-Sea and air freight",
      "Proceedings-Cases and Proceedings before arbitral tribunals and other alternative dispute resolution bodies",
      "Commercial Transactions-Consumer protection",
      "Civil Transactions-Compensation",
      "Commercial Transactions-Stock",
      "Criminal Law-Crimes against properties",
      "Commercial Transactions-E-Commerce",
      "Criminal Law-Cybercrimes",
      "Commercial Transactions-Intellectual Property (includes trademarks",
      "copy rights",
      "patents)",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/04/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Osamah Mohamed Ahmed Salem Alsalmi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0b9a700b-cfd7-45b1-816f-8392217472f0",
        "address": "Osama Alsalmi ,5 ,Makateb building  ,Tasheel ,00 ,Dubai",
        "phone": "97148187210",
        "email": "info@alsalmilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "3246ef73-8e28-43dd-8693-01e8119a2f64",
    "firmName": "OSAMA ALSALMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1069",
    "licenseIssueDate": "04/07/2016 00:00:00",
    "licenseExpiryDate": "04/06/2026 00:00:00"
  },
  {
    "id": "36713d9c-6427-4d42-9c6e-7933cca5464d",
    "slug": "osha-abdulla-said",
    "name": "OSHA ABDULLA W O MOHAMED SAEED ALQAMZI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/02/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Osha Abdulla Said",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_36713d9c-6427-4d42-9c6e-7933cca5464d",
        "address": "sohail jassem pararin ,34 ,Central Park Tower ,Dubai Mall ,233066 ,Dubai",
        "phone": "97144228410",
        "email": "info@mahmoodhussain.net",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "f3309481-3edd-4503-92d2-bd9f71ba513a",
    "firmName": "DR MAHMOOD HUSSAIN ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-1632",
    "licenseIssueDate": "02/14/2022 00:00:00",
    "licenseExpiryDate": "02/13/2026 00:00:00"
  },
  {
    "id": "c6bdcf85-fc84-4517-bfe1-948541593ae1",
    "slug": "otaiba-khalaf-ahmed-khalaf-alotaiba",
    "name": "OTAIBA KHALAF AHMED KHALAF ALOTAIBA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/10/2010",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Otaiba Khalaf Ahmed Khalaf Alotaiba",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c6bdcf85-fc84-4517-bfe1-948541593ae1",
        "address": "HAMDAN BUDEBES  ,1614 ,BLUE BAY TOWER ,BUSINESS BAY ,127637 ,Dubai",
        "phone": "97142505612",
        "email": "info-dubai@alotaiba-law.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "34156aa2-d714-4a9a-875a-eb422ea3c4c2",
    "firmName": "ALOTEIBA & HAMDAN BUDEBES ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-728",
    "licenseIssueDate": "10/17/2010 00:00:00",
    "licenseExpiryDate": "10/16/2025 00:00:00"
  },
  {
    "id": "61db810f-3c08-416c-be36-f276142a5833",
    "slug": "othaiba-anbar-obaid-almazrouei",
    "name": "HAMAD NASER SAEED SALEM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/12/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Othaiba Anbar Obaid Almazrouei",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_61db810f-3c08-416c-be36-f276142a5833",
        "address": "Abdullah Matar Al Zaabi ,1604 ,اكزيكتف باي  ,اكزيكتف باي ,0000 ,Dubai",
        "phone": "97143203616",
        "email": "advozaabi@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "b52d5afe-29b2-4dff-8d38-ec0587312c64",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1906",
    "licenseIssueDate": "01/05/2024 00:00:00",
    "licenseExpiryDate": "01/04/2026 00:00:00"
  },
  {
    "id": "c8a09fa7-c502-48c1-a485-f10dfb0e2f73",
    "slug": "othman-abdulla-rahma-omran-alshamsi",
    "name": "YOUSEF ABDULKARIM YOUSEF ABDULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/08/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: othman abdulla rahma omran alshamsi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c8a09fa7-c502-48c1-a485-f10dfb0e2f73",
        "address": "OBAID AL SHAMSI ADVOCATES & LEGAL CONSULTANTS ,لا يوجد ,AL GARHOUD BUSINESS CENTER ,AL GARHOUD BUSINESS CENTER ,1903 ,Dubai",
        "phone": "97129555545",
        "email": "info@oaslawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "c8252dab-1a42-4878-a3ee-50ba9dddb978",
    "firmName": "OBAID AL MAZIMI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-1861",
    "licenseIssueDate": "09/11/2023 00:00:00",
    "licenseExpiryDate": "09/10/2026 00:00:00"
  },
  {
    "id": "a7c7dcd4-597c-485a-b4c6-29b0b9c4c562",
    "slug": "othman-mohamed-hassan-mohamed-almarzooqi",
    "name": "OTHMAN MOHAMED HASAN MOHAMED ALMARZOOQI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/07/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Othman Mohamed Hassan Mohamed Almarzooqi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a7c7dcd4-597c-485a-b4c6-29b0b9c4c562",
        "address": "othman almarzooqi ,19th ,single business tower ,samaya tower ,114333 ,Dubai",
        "phone": "97142999970 / 971500000000",
        "email": "info@othmanadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "a0cdd94d-cc5a-4617-b6a3-b23deb9852d5",
    "firmName": "OTHMAN ALMARZOOQI ADVOCATES AND LEGAL CONSULTATIONS",
    "registrationNumber": "L-1550",
    "licenseIssueDate": "07/27/2021 00:00:00",
    "licenseExpiryDate": "07/26/2026 00:00:00"
  },
  {
    "id": "8f183a28-fba9-4c15-bcb6-ec051df43187",
    "slug": "qais-abdulwahed-mohammed-jasem-alblooshi",
    "name": "FAISAL AHMAD ALI AHMAD ALHAZMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBRQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/05/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Qais Abdulwahed Mohammed Jasem Alblooshi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8f183a28-fba9-4c15-bcb6-ec051df43187",
        "address": "",
        "phone": "97143641686 / 971506288801",
        "email": "b.kadir@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "0ba96df8-e4cc-49c2-8ae4-a42878d95926",
    "firmName": "AL SAHLAWI & CO ADVOCATES & CONSULTANTS",
    "registrationNumber": "L-1669",
    "licenseIssueDate": "06/28/2022 00:00:00",
    "licenseExpiryDate": "06/27/2026 00:00:00"
  },
  {
    "id": "f4799b85-c768-4db2-8ccb-bf76ec68b137",
    "slug": "qamar-saleh-salem-alkassadi",
    "name": "Qamar Saleh Salem Alkassadi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBRUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/28/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Qamar Saleh Salem Alkassadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f4799b85-c768-4db2-8ccb-bf76ec68b137",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "1046",
    "licenseIssueDate": "01/28/2016 00:00:00",
    "licenseExpiryDate": "01/27/2026 00:00:00"
  },
  {
    "id": "984f68e4-499a-417b-b78c-5107533be266",
    "slug": "qumasha-ali-mohammad-abdulla",
    "name": "QUMASHA ALI MOHAMMAD ABDULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBRQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/10/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: QUMASHA ALI MOHAMMAD ABDULLA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_984f68e4-499a-417b-b78c-5107533be266",
        "address": "",
        "phone": "97145650550",
        "email": "uae.courts@qamadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "3117b2a0-79c7-477b-b710-1b6eb632bccc",
    "firmName": "QUMASHA ALI MOHAMMAD ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1585",
    "licenseIssueDate": "10/31/2021 00:00:00",
    "licenseExpiryDate": "10/30/2025 00:00:00"
  },
  {
    "id": "d42a5a77-23bb-470f-a719-01e9083fec29",
    "slug": "rabeaa-abdulrahman-mahboob",
    "name": "RABEAA ABDULRAHMAN MAHBOOB",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/08/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Rabeaa Abdulrahman Mahboob",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d42a5a77-23bb-470f-a719-01e9083fec29",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1101",
    "licenseIssueDate": "08/10/2016 00:00:00",
    "licenseExpiryDate": "08/09/2026 00:00:00"
  },
  {
    "id": "9af4169a-2d6f-414c-8105-fef1c1ee95eb",
    "slug": "rafeeah-saeed-ali-salem-alshehhi",
    "name": "rafeeah saeed  ali salem alshehhi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/15/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: rafeeah saeed  ali salem alshehhi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9af4169a-2d6f-414c-8105-fef1c1ee95eb",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "1932",
    "licenseIssueDate": "04/15/2024 00:00:00",
    "licenseExpiryDate": "04/14/2026 00:00:00"
  },
  {
    "id": "5d8aca5a-dd9c-4bd6-bac2-eb38bdf2cf0f",
    "slug": "rafia-mohd-kadfoor-almehairi",
    "name": "RAFIA MOHD KADFOOR ABDULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/09/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Rafia MOHD Kadfoor Almehairi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5d8aca5a-dd9c-4bd6-bac2-eb38bdf2cf0f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-634",
    "licenseIssueDate": "09/07/2015 00:00:00",
    "licenseExpiryDate": "09/06/2026 00:00:00"
  },
  {
    "id": "cebc5303-844b-40b2-83ef-211163f861e1",
    "slug": "raja-abdalla-hamad-alhadfi-alketbi",
    "name": "OMAR KHALIFA ABDULKARIM YOUSEF ALBLOOSHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/01/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Raja Abdalla Hamad Alhadfi Alketbi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cebc5303-844b-40b2-83ef-211163f861e1",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1748",
    "licenseIssueDate": "01/23/2023 00:00:00",
    "licenseExpiryDate": "01/22/2026 00:00:00"
  },
  {
    "id": "ead40b6a-41ad-473b-8175-12caf9df09a1",
    "slug": "raja-ali-ali-alsaleh",
    "name": "RAJA ALI ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Commercial Agency",
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Civil Transactions-POA & Sponsorship",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Civil Transactions-Insurance",
      "Personal Status-Wills",
      "Civil Transactions-Ownership & Title",
      "Civil Transactions-HR & Employee Affairs",
      "Commercial Transactions-Commercial Mortgage",
      "Commercial Transactions-Commercial Contracts",
      "Civil Transactions-Immigration and Residency",
      "Commercial Transactions-Bankruptcy",
      "Commercial Transactions-Commercial Real Estate",
      "Civil Transactions-Residential Real Estate",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Criminal Law-Hate crimes",
      "Civil Transactions-Tenancy",
      "Commercial Transactions-Unfair competition",
      "Personal Status-Legacies and Inheritance",
      "Commercial Transactions-Banking Operations",
      "Civil Transactions-Labor & Workers",
      "Personal Status-Legal Capacity & Guardianship",
      "Criminal Law-Drug Crimes",
      "Civil Transactions-Sale",
      "Commercial Transactions-Sea and air freight",
      "Proceedings-Cases and Proceedings before arbitral tribunals and other alternative dispute resolution bodies",
      "Commercial Transactions-Consumer protection",
      "Personal Status-Marriage & Divorce",
      "Personal Status-Child Abuse & Abduction",
      "Civil Transactions-Compensation",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/03/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Raja Ali Ali Alsaleh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ead40b6a-41ad-473b-8175-12caf9df09a1",
        "address": "Mezzanine - Office M19 ,Business Avenue ,Makani No: 3248594620 ,000 ,Dubai",
        "phone": "97142855669 / 971554722231",
        "email": "lawyerrajaa2002@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "4eb56ada-9f3f-49f6-bcf7-af77724c94cd",
    "firmName": "RAJA AL SALEH ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-548",
    "licenseIssueDate": "03/15/2021 00:00:00",
    "licenseExpiryDate": "03/16/2026 00:00:00"
  },
  {
    "id": "7621c9a9-8cae-45fe-8189-4f5cbc9db1f4",
    "slug": "rashed-abdulla-hassan-abboud-alhefeiti",
    "name": "RASHED ABDULLA HASSAN ABBOUD ALHEFEITI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/03/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Rashed Abdulla Hassan Abboud Alhefeiti",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7621c9a9-8cae-45fe-8189-4f5cbc9db1f4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1269",
    "licenseIssueDate": "03/29/2018 00:00:00",
    "licenseExpiryDate": "03/28/2026 00:00:00"
  },
  {
    "id": "5b43b397-aeaa-4bc5-9b49-d05d3cee33e3",
    "slug": "rashed-abdulla-salem-mohammad-sumaity",
    "name": "RASHED ABDULLA SALEM MOHAMMAD SUMAITY",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/08/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Rashed Abdulla Salem Mohammad Sumaity",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5b43b397-aeaa-4bc5-9b49-d05d3cee33e3",
        "address": "",
        "phone": "97143937700",
        "email": "info@galadarilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "d863b662-c864-4193-8b3a-ff6ee5fe6c64",
    "firmName": "GALADARI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-886",
    "licenseIssueDate": "08/20/2013 00:00:00",
    "licenseExpiryDate": "08/19/2026 00:00:00"
  },
  {
    "id": "65b199d2-64e0-4e6f-84b7-933022e7ef87",
    "slug": "rashed-abdulrahman-mohammed-abdullah-alsuwaidi",
    "name": "RASHID ABDELRAHMAN MOHAMED A ALSUWAIDI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/11/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Rashed Abdulrahman Mohammed Abdullah Alsuwaidi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_65b199d2-64e0-4e6f-84b7-933022e7ef87",
        "address": "Rashed Abdulrahman Mohammed abdullah Alsuwaidi ,الطابق الخامس 504 ,كورت تاور  ,الخليج التجاري ,35836 ,Dubai",
        "phone": "97145723403 / 971557679696",
        "email": "info@ralsuwaidi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "c12d8618-835a-40dd-8841-3290c77a2e93",
    "firmName": "RASHED Al SUWAIDI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-778",
    "licenseIssueDate": "11/10/2011 00:00:00",
    "licenseExpiryDate": "11/09/2025 00:00:00"
  },
  {
    "id": "e1baae4d-9a78-4be8-ac4c-b4b1b41c0a7b",
    "slug": "rashed-abdulrazaq-mohd-tahlak",
    "name": "Rashed Abdulrazaq Mohd Tahlak",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 19,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/24/2006 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Rashed Abdulrazaq Mohd Tahlak",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e1baae4d-9a78-4be8-ac4c-b4b1b41c0a7b",
        "address": "3 - مكتب رقم 310  ,بناية الجمعية التعاونية للاسكان والتعمير بدبي  ,جوار محكمة الاحوال الشخصية  ,212109 ,Dubai",
        "phone": "97142981222",
        "email": "rashid@tahlak-advocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "3441316e-de6b-4504-b709-05dd1a15a73a",
    "firmName": "RASHED TAHLAK ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "560",
    "licenseIssueDate": "04/24/2006 00:00:00",
    "licenseExpiryDate": "04/23/2026 00:00:00"
  },
  {
    "id": "0fc3c8a8-9265-4482-9726-bee2b49c9a64",
    "slug": "rashed-ahmed-ghareib-huwashel-alsereidi",
    "name": "RASHED AHMED GHAREIB H. AL SERAIDY",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/09/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Rashed Ahmed Ghareib Huwashel Alsereidi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0fc3c8a8-9265-4482-9726-bee2b49c9a64",
        "address": "0 ,بن فارس 2 ,مستشفى البراحة ,22662 ,Dubai",
        "phone": "97142203333 / 9715048999911",
        "email": "seridi.advo@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "c567de5a-f399-4c56-829e-06e37a2eb4fc",
    "firmName": "RASHED AHMED AL SEREIDI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-1310",
    "licenseIssueDate": "09/16/2018 00:00:00",
    "licenseExpiryDate": "09/15/2026 00:00:00"
  },
  {
    "id": "412e40a8-1036-4980-9d8a-461c9c47531d",
    "slug": "rashed-ahmed-rashed-ahmed-alshehhi",
    "name": "HASSAN MOHAMED HASSAN KARAM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/01/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Rashed Ahmed Rashed Ahmed Alshehhi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_412e40a8-1036-4980-9d8a-461c9c47531d",
        "address": "3rd Floor - Office No. 301 ,Wasel Business Building ,Makani No: 3242894178 ,000 ,Dubai",
        "phone": "97145460005 / 971552666381",
        "email": "Dr.khaled1234@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "653e8321-5f9e-4eae-8740-cc250fc3a19b",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1909",
    "licenseIssueDate": "01/29/2024 00:00:00",
    "licenseExpiryDate": "01/28/2026 00:00:00"
  },
  {
    "id": "b60b81da-ddf2-4749-a4eb-73050c385ec5",
    "slug": "rashed-ali-ershood-alkhanbooli-alshehhi",
    "name": "RASHED ALI ERSHOOD A A ALSHEHHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/09/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Rashed Ali Ershood Alkhanbooli Alshehhi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b60b81da-ddf2-4749-a4eb-73050c385ec5",
        "address": "",
        "phone": "/ 97151111146",
        "email": "info@alphalegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "8576864d-ec5e-4834-b800-88160aa2c0a5",
    "firmName": "ALPHA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1451",
    "licenseIssueDate": "09/08/2020 00:00:00",
    "licenseExpiryDate": "09/07/2026 00:00:00"
  },
  {
    "id": "dc7c5dc8-3af0-4051-98c3-7ad713fbce12",
    "slug": "rashed-hasan-rashed-alhammadi",
    "name": "RASHED HASAN RASHED J ALHAMMADI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/07/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: RASHED HASAN RASHED ALHAMMADI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dc7c5dc8-3af0-4051-98c3-7ad713fbce12",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1437",
    "licenseIssueDate": "07/15/2020 00:00:00",
    "licenseExpiryDate": "07/14/2026 00:00:00"
  },
  {
    "id": "5e77b53c-8ed2-4d56-af90-2679d177fccb",
    "slug": "rashed-mohamed-abdulla-mohamed-alhefeiti",
    "name": "MOHAMED SAEED OBAID MATAR SAIF",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/12/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Rashed Mohamed Abdulla Mohamed Alhefeiti",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5e77b53c-8ed2-4d56-af90-2679d177fccb",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1739",
    "licenseIssueDate": "01/10/2023 00:00:00",
    "licenseExpiryDate": "01/09/2026 00:00:00"
  },
  {
    "id": "8376c730-8bf2-4a7f-a549-9db852d186e2",
    "slug": "rashed-mohammed-abdulla-saeed-lootah",
    "name": "ABDULLA RASHED SAEED BARSHOUD ALMURSHIDI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/11/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Rashed Mohammed Abdulla Saeed Lootah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8376c730-8bf2-4a7f-a549-9db852d186e2",
        "address": "",
        "phone": "97142713893",
        "email": "info@rashedlootah.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "6966793e-be56-4683-9aad-1912a5885631",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1725",
    "licenseIssueDate": "11/23/2022 00:00:00",
    "licenseExpiryDate": "11/22/2025 00:00:00"
  },
  {
    "id": "c6b3f2da-6d92-48d9-a2b5-6c6b851111a6",
    "slug": "rashed-mohammed-saed-bu-jusaim",
    "name": "RASHID MOHAMED SAEED BUJSAIM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 48,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/12/1976",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Rashed Mohammed Saed Bu-Jusaim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c6b3f2da-6d92-48d9-a2b5-6c6b851111a6",
        "address": "",
        "phone": "97142221758 / 971506984647",
        "email": "droit@eim.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "7adc24ae-eaae-40c6-a30b-5097991f467b",
    "firmName": "BUJESSAIM & AL MALIKI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-41",
    "licenseIssueDate": "12/29/1976 00:00:00",
    "licenseExpiryDate": "12/28/2025 00:00:00"
  },
  {
    "id": "374d619a-ec11-47e2-8a83-c476f028d565",
    "slug": "rashed-obaid-saif-hammad-al-hefiti",
    "name": "RASHED OBAID SAIF HAMMAD ALHEFAITI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 17,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/11/2007",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Rashed Obaid Saif Hammad Al-Hefiti",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_374d619a-ec11-47e2-8a83-c476f028d565",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-409",
    "licenseIssueDate": "11/05/2007 00:00:00",
    "licenseExpiryDate": "11/04/2025 00:00:00"
  },
  {
    "id": "99908a1f-882e-40ea-92ef-0d736b9817b3",
    "slug": "rashed-saeed-rashed-ali",
    "name": "RASHED SAEED RASHED ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/07/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Rashed Saeed Rashed Ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_99908a1f-882e-40ea-92ef-0d736b9817b3",
        "address": "السادس - مكتب 604 ,الوصل بيزنس سنتر - مبنى رقم R549 ,بنك مصر ,2079 ,Dubai",
        "phone": "97143961112",
        "email": "reception@rslawfirm.org",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "33654f3d-b8f9-48ad-bbba-42847367b511",
    "firmName": "RASHED ALSHEHHI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-768",
    "licenseIssueDate": "07/26/2011 00:00:00",
    "licenseExpiryDate": "07/25/2026 00:00:00"
  },
  {
    "id": "b6df9468-f417-4f5e-942d-dff0d87f7319",
    "slug": "rashid-abbas-dadia-ghuloum-robari",
    "name": "RASHID ABBAS DADIA GHULOUM ROBARI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/10/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Rashid Abbas Dadia Ghuloum Robari",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b6df9468-f417-4f5e-942d-dff0d87f7319",
        "address": "Office No. 802 ,Al Ghanim Building 3 ,Makani No: 3092994922 ,000 ,Dubai",
        "phone": "97140000000 / 971501031116",
        "email": "rashidabbasadvocates@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "ec7c49dc-c9c8-4800-b91f-d9fdf344dff1",
    "firmName": "RASHID ABBAS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1230",
    "licenseIssueDate": "10/17/2017 00:00:00",
    "licenseExpiryDate": "10/16/2025 00:00:00"
  },
  {
    "id": "b59e631c-1c7f-45c5-8b72-c0ff3a5aab89",
    "slug": "rashid-abdalla-humaid-aljari-alketbi",
    "name": "KHALED ALI AHMED MOHAMED ALDHANHANI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts",
      "Criminal Law-Cybercrimes",
      "Criminal Law-Drug Crimes"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/05/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Rashid Abdalla Humaid Aljari Alketbi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b59e631c-1c7f-45c5-8b72-c0ff3a5aab89",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1956",
    "licenseIssueDate": "05/10/2024 00:00:00",
    "licenseExpiryDate": "05/09/2026 00:00:00"
  },
  {
    "id": "5509c83c-b8b2-4929-b8c0-3494d9a7ec01",
    "slug": "rashid-abdulla-ali-bin-arab",
    "name": "RASHED ABDULLA ALI AHMED BIN ARAB",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 23,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/04/2002",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Rashid Abdulla Ali Bin Arab",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5509c83c-b8b2-4929-b8c0-3494d9a7ec01",
        "address": "Jane Naoe Elsayed ,Level No. 22 – Office No. (2201 – 2202) ,Concord Tower ,Media City ,99779 ,Dubai",
        "phone": "97143575999",
        "email": "info@binarab.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "a718961d-c976-4a3c-bd09-585ec7c81310",
    "firmName": "RASHED BIN ARAB ADVOCATE AND LEGAL COLSULTANTS",
    "registrationNumber": "L-424",
    "licenseIssueDate": "04/23/2002 00:00:00",
    "licenseExpiryDate": "04/22/2026 00:00:00"
  },
  {
    "id": "52c63d2c-7303-41a6-944b-d3b73f213ecd",
    "slug": "rashid-ahmed-obaid-deemas-alsuwaidi",
    "name": "RASHID AHMED OBAID EID DEEMAS",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/06/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Rashid Ahmed Obaid Deemas Alsuwaidi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_52c63d2c-7303-41a6-944b-d3b73f213ecd",
        "address": "Office No. 908 ,Owned by ACICO Gulf Real Estate Building ,Makani No: 3250094543 ,000 ,Dubai",
        "phone": "97143377688 / 971502883999",
        "email": "info@rds-law.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "750060a5-046b-4af5-b4ba-46d9c547184a",
    "firmName": "RASHID DEEMAS ALSUWAIDI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1093",
    "licenseIssueDate": "06/05/2016 00:00:00",
    "licenseExpiryDate": "06/04/2026 00:00:00"
  },
  {
    "id": "b408b7c3-9f6d-480f-9523-b3efe94d5933",
    "slug": "rashid-ali-mohamed-alhuraithi-alnaqbi",
    "name": "RASHID ALI MOHAMED ALHURAITHI ALNAQBI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/02/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Rashid Ali Mohamed Alhuraithi Alnaqbi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b408b7c3-9f6d-480f-9523-b3efe94d5933",
        "address": "RASHID ALI ,2 ,DUBAI NATIONAL INSURACE  ,DEIRA CITY CENTER ,117277 ,Dubai",
        "phone": "97144214021 / 971551191143",
        "email": "ra_huraithi@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "1db67184-8393-4efd-a82c-3b72528a605a",
    "firmName": "RASHID ALNAQBI VOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-991",
    "licenseIssueDate": "02/18/2015 00:00:00",
    "licenseExpiryDate": "02/17/2026 00:00:00"
  },
  {
    "id": "f076d315-3d5f-4212-ac93-bebde7bcf27d",
    "slug": "rashid-khalil-obaid-ali",
    "name": "RASHID KHALIL OBAID ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/11/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-11-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Rashid Khalil Obaid Ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f076d315-3d5f-4212-ac93-bebde7bcf27d",
        "address": "Office No. 201 ,FRONDS BUILDING ,Makani No: 3273193073 ,000 ,Dubai",
        "phone": "97100000000",
        "email": "ro.legalconsultation@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "8bea7298-efc4-496a-bda1-06dff28f4a69",
    "firmName": "RASHID KHALIL OBAID ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1127",
    "licenseIssueDate": "11/29/2016 00:00:00",
    "licenseExpiryDate": "11/28/2025 00:00:00"
  },
  {
    "id": "2b48f5bc-0101-40c5-ac02-0dd8f29f777b",
    "slug": "rashid-saeed-salem-ubaid-salem-bin-suwaidan-al-suwaidi",
    "name": "RASHED SAEED SALEM BIN SUWAIDAN ALSUWAIDI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/04/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Rashid Saeed Salem Ubaid Salem bin Suwaidan Al Suwaidi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2b48f5bc-0101-40c5-ac02-0dd8f29f777b",
        "address": "4 ,ALHUDIBA AWARD COMPLEX BLOCK B ,UNION FLAG HOUSE ,50229 ,Dubai",
        "phone": "97143258888 / 971501009595",
        "email": "hr@binsowaidan.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "36d64a1b-4461-4159-9965-ed44c59d3e88",
    "firmName": "BIN SOWAIDAN ADVOCATES & LEGAL CONSULTANTCY",
    "registrationNumber": "L-934",
    "licenseIssueDate": "04/20/2014 00:00:00",
    "licenseExpiryDate": "04/19/2026 00:00:00"
  },
  {
    "id": "ab1527fc-8cb0-47ed-9554-52cd7ee6501d",
    "slug": "rashid-sultan-rashid-sultan-alkaitoob-alnuaimi",
    "name": "RASHID SULTAN RASHID ALKAITOOB ALNUAIMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/08/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Rashid Sultan Rashid Sultan Alkaitoob Alnuaimi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ab1527fc-8cb0-47ed-9554-52cd7ee6501d",
        "address": "",
        "phone": "97143595552",
        "email": "rashid.alkaitoob@rk-advocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "8ea99c01-7cd1-44a3-84c3-8dd51ccf5908",
    "firmName": "RASHID ALKAITOOB ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-963",
    "licenseIssueDate": "08/20/2014 00:00:00",
    "licenseExpiryDate": "08/19/2026 00:00:00"
  },
  {
    "id": "30be6eba-d7ab-4162-876b-2c955f323154",
    "slug": "rawdha-mohmmed-salem-hayai-almansoori",
    "name": "WADHA MOHAMMED ABDULLA ALNUAIMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/05/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: rawdha mohmmed salem hayai almansoori",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_30be6eba-d7ab-4162-876b-2c955f323154",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1680",
    "licenseIssueDate": "07/19/2022 00:00:00",
    "licenseExpiryDate": "07/18/2026 00:00:00"
  },
  {
    "id": "54b736e0-6d29-4f13-86f4-3a29a2a61925",
    "slug": "raya-nasser-hamad-albaloushi",
    "name": "RAYA NASSER HAMAD NASSER ALBLOOSHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/02/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Raya nasser hamad albaloushi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_54b736e0-6d29-4f13-86f4-3a29a2a61925",
        "address": "6F 603, 605, 7F 704 ,Crystal Tower ,Dubai Mall ,117538 ,Dubai",
        "phone": "97146098700",
        "email": "pro@miolawfirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "417f90a1-03be-4dab-8eea-1bba7e16f536",
    "firmName": "ABU BAKER SALEM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1252",
    "licenseIssueDate": "02/05/2018 00:00:00",
    "licenseExpiryDate": "02/04/2026 00:00:00"
  },
  {
    "id": "5b197ae4-2aa5-4809-8419-b773e44422b6",
    "slug": "raya-salem-suhail-awaidan-alameri",
    "name": "RAYA SALEM SUHAIL AWAIDAN AL AMERI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/10/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Raya Salem Suhail Awaidan Alameri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5b197ae4-2aa5-4809-8419-b773e44422b6",
        "address": "",
        "phone": "97145786050 / 971509711102",
        "email": "info@emirates.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "676fafb7-1ca5-46d2-943e-39c211542422",
    "firmName": "RAYA ALAMERI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1120",
    "licenseIssueDate": "10/27/2016 00:00:00",
    "licenseExpiryDate": "10/26/2025 00:00:00"
  },
  {
    "id": "ac19cd79-86ab-463a-a1bd-30a0705b4029",
    "slug": "rayadh-abdulmajeid-mohmood-al-kabban",
    "name": "REYADH ABDULMAJEED MAHMOOD AL KABBAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 35,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/02/1990",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Rayadh Abdulmajeid Mohmood Al-Kabban",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ac19cd79-86ab-463a-a1bd-30a0705b4029",
        "address": "29TH  ,PRISM TOWER ,J W MARRIOTT MARQUIS HOTEL  ,4790 ,Dubai",
        "phone": "97144539090",
        "email": "info@alkabban.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "a9193879-c34b-4dae-99aa-d8e5ac8517cc",
    "firmName": "AL-KABBAN & ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-202",
    "licenseIssueDate": "02/03/1990 00:00:00",
    "licenseExpiryDate": "02/02/2026 00:00:00"
  },
  {
    "id": "b066c9a2-ceab-472c-a5a3-035520db1a57",
    "slug": "reed-hamad-khamis-alsheryani-aldhaheri",
    "name": "REED HAMAD KHAMIS ALSHERYANI ALDHAHERI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/03/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Reed Hamad Khamis Alsheryani Aldhaheri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b066c9a2-ceab-472c-a5a3-035520db1a57",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1061",
    "licenseIssueDate": "03/24/2016 00:00:00",
    "licenseExpiryDate": "03/23/2026 00:00:00"
  },
  {
    "id": "6d9c1505-0b41-4066-80ba-905855f01f70",
    "slug": "reem-abdullah-ahmed-mohamed-alhammadi",
    "name": "REEM ABDULLA AHMED MOHAMMAD HAJI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Civil Transactions-Insurance",
      "Personal Status-Custody & Alimony",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Civil Transactions-Tenancy",
      "Civil Transactions-Labor & Workers",
      "Personal Status-Marriage & Divorce",
      "Civil Transactions-Compensation",
      "Criminal Law-Cybercrimes"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/06/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Reem Abdullah Ahmed Mohamed Alhammadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6d9c1505-0b41-4066-80ba-905855f01f70",
        "address": "MOHAMMED MURTADA ALHASHMI ,3 ,LATIFA TOWER  ,CROWN PLAZA ,231400 ,Dubai",
        "phone": "97143521131",
        "email": "info@mhadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "a5a2640f-b1b8-4512-b9ee-a8802d0c30fc",
    "firmName": "MOHAMMED AL HASHIMI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-1540",
    "licenseIssueDate": "06/22/2021 00:00:00",
    "licenseExpiryDate": "06/21/2026 00:00:00"
  },
  {
    "id": "51bc1333-c2f9-4883-b25f-5cf2516a4f11",
    "slug": "reem-awad-alabed-ali-alameri",
    "name": "NOORA MOHAMMED MAHMOOD MAHMOOD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/01/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: REEM AWAD ALABED ALI ALAMERI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_51bc1333-c2f9-4883-b25f-5cf2516a4f11",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1757",
    "licenseIssueDate": "02/09/2023 00:00:00",
    "licenseExpiryDate": "02/08/2026 00:00:00"
  },
  {
    "id": "09f65a75-eeb7-472b-ad3d-41b37a60e0d7",
    "slug": "reem-saleh-mahdi",
    "name": "REEM SALEH MAHDI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/06/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Reem Saleh Mahdi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_09f65a75-eeb7-472b-ad3d-41b37a60e0d7",
        "address": "",
        "phone": "97142949937",
        "email": "info@rslawyers.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "d544ee54-219a-446f-86c7-d6f4d1b1588c",
    "firmName": "REEM SALEH ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1015",
    "licenseIssueDate": "07/01/2015 00:00:00",
    "licenseExpiryDate": "06/30/2026 00:00:00"
  },
  {
    "id": "ba45f95a-ba58-463e-8397-c5431d2cdbda",
    "slug": "rima-abdulhakim-mustafa-aljarshi",
    "name": "RIMA ABDULHAKIM MUSTAFA ALJARSHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 17,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/10/2008",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Rima Abdulhakim Mustafa Aljarshi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ba45f95a-ba58-463e-8397-c5431d2cdbda",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-643",
    "licenseIssueDate": "10/15/2008 00:00:00",
    "licenseExpiryDate": "10/14/2026 00:00:00"
  },
  {
    "id": "4b5008a5-6e07-476d-851b-85d8bc23094b",
    "slug": "riyasah-abdulrahman-saeed-ahmed",
    "name": "RAISA ABDULRAHMAN SAEED AHMAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/03/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Riyasah Abdulrahman Saeed Ahmed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4b5008a5-6e07-476d-851b-85d8bc23094b",
        "address": "DR. RAISA ABDULRAHMAN SAEED AHMED ,19 ,برج المدينة 2 ,أمام متحف المستقبل بدبي ,24847 ,Dubai",
        "phone": "97143581800 / 971527588525",
        "email": "info@drraisaadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "2ccc0c02-0a73-4b44-90ac-83ff8bce7db0",
    "firmName": "DR. RIASA ABDULRAHMAN ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1161",
    "licenseIssueDate": "03/23/2017 00:00:00",
    "licenseExpiryDate": "03/22/2026 00:00:00"
  },
  {
    "id": "5ebcd871-90e3-44cc-9408-044ea69a2b21",
    "slug": "rodha-abdulaziz-abdulrahman-folad",
    "name": "RODHA ABDULAZIZ ABDULRAHMAN FOLAD HASSAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/09/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Rodha Abdulaziz Abdulrahman Folad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5ebcd871-90e3-44cc-9408-044ea69a2b21",
        "address": "haleema almarzooqi ,3 ,building 7A ,D3 ,9569 ,Dubai",
        "phone": "97143621113",
        "email": "haleema.almarzooqi@dhalaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "4fb21617-b070-488f-8ce5-516725154e59",
    "firmName": "HALEEMA ALMARZOOQI &PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1223",
    "licenseIssueDate": "09/13/2017 00:00:00",
    "licenseExpiryDate": "09/12/2026 00:00:00"
  },
  {
    "id": "108a83cf-244c-4adb-b8e4-f16f4f2729a0",
    "slug": "rola-ibrahim-muhsen-jaber",
    "name": "SHAIKHA SALEM NASSIB MUBARAK ALNEYADI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/02/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Rola Ibrahim Muhsen Jaber",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_108a83cf-244c-4adb-b8e4-f16f4f2729a0",
        "address": "",
        "phone": "97143300009 / 971501215000",
        "email": "mohamed@maa.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "af85c161-b73d-46a2-9fd7-4d8604007473",
    "firmName": "ALEASIMA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1768",
    "licenseIssueDate": "02/24/2023 00:00:00",
    "licenseExpiryDate": "02/23/2026 00:00:00"
  },
  {
    "id": "45df3a81-e678-49b1-b8ec-195a6bdd24a2",
    "slug": "roukoz-jeorjes-hobaika",
    "name": "ROUKOZ GEORGES HOBEIKA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 22,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/08/2003",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Roukoz Jeorjes Hobaika",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_45df3a81-e678-49b1-b8ec-195a6bdd24a2",
        "address": "",
        "phone": "97142212494",
        "email": "bayanlaw@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "3eaca0c8-938e-4864-add1-73e5c902b168",
    "firmName": "DAR AL BAYAN ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-455",
    "licenseIssueDate": "08/16/2003 00:00:00",
    "licenseExpiryDate": "08/15/2026 00:00:00"
  },
  {
    "id": "54d82cf7-8345-4a66-b391-fe5baf39b344",
    "slug": "roya-abdulla-mohammed-al-awadhi",
    "name": "ROYA ABDULLA MOHAMED ABDULLA ALAWADHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Civil Transactions-POA & Sponsorship",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Civil Transactions-Insurance",
      "Personal Status-Wills",
      "Civil Transactions-Construction and Contracts for Services",
      "Civil Transactions-Ownership & Title",
      "Civil Transactions-HR & Employee Affairs",
      "Commercial Transactions-Commercial Mortgage",
      "Criminal Law-Family Crimes",
      "Personal Status-Custody & Alimony",
      "Commercial Transactions-Commercial Contracts",
      "Civil Transactions-Immigration and Residency",
      "Commercial Transactions-Bankruptcy",
      "Commercial Transactions-Commercial Real Estate",
      "Civil Transactions-Residential Real Estate",
      "Civil Transactions-Arbitration",
      "Criminal Law-Hate crimes",
      "Civil Transactions-Tenancy",
      "Commercial Transactions-Unfair competition",
      "Personal Status-Legacies and Inheritance",
      "Commercial Transactions-Commercial Companies",
      "Commercial Transactions-Banking Operations",
      "Civil Transactions-Labor & Workers",
      "Personal Status-Legal Capacity & Guardianship",
      "Criminal Law-Drug Crimes",
      "Civil Transactions-Sale",
      "Personal Status-Marriage & Divorce",
      "Personal Status-Child Abuse & Abduction",
      "Civil Transactions-Compensation",
      "Commercial Transactions-Stock",
      "Commercial Transactions-E-Commerce",
      "Criminal Law-Cybercrimes",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 22,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/08/2003",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Roya Abdulla Mohammed Al-Awadhi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_54d82cf7-8345-4a66-b391-fe5baf39b344",
        "address": "108 - Block B ,Saraya Avenue ,Near Al Dar University ,712 ,Dubai",
        "phone": "97142990995",
        "email": "info@royaalawadhi.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "18906d5a-a350-4afa-be12-29a69a83b69b",
    "firmName": "ROYA ALAWADHI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-456",
    "licenseIssueDate": "08/16/2003 00:00:00",
    "licenseExpiryDate": "08/15/2026 00:00:00"
  },
  {
    "id": "1dd03442-52ee-4c11-b9b3-f060b6f8c98a",
    "slug": "rudha-hussain-sayed-mohsin-alattar",
    "name": "RUDHA HUSSAIN SAYED MOHSIN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/05/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Rudha Hussain Sayed Mohsin Alattar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1dd03442-52ee-4c11-b9b3-f060b6f8c98a",
        "address": "",
        "phone": "97142776979",
        "email": "info@raadvocates.co",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "49d8fc58-8bb3-4f84-8486-6aa5cd43e6ff",
    "firmName": "RUDHA ALATTAR ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-758",
    "licenseIssueDate": "05/12/2011 00:00:00",
    "licenseExpiryDate": "05/11/2026 00:00:00"
  },
  {
    "id": "be5c83b8-4408-40aa-be64-e5f641ab4b4c",
    "slug": "ruqayya-mohammed-ali-abdulla-aljanahy",
    "name": "RUQAYYA MOHAMMED A A ALJANAHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/11/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ruqayya Mohammed Ali Abdulla Aljanahy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_be5c83b8-4408-40aa-be64-e5f641ab4b4c",
        "address": "",
        "phone": "97142955545 / 971505199627",
        "email": "rj@aljanahiadvocate.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "9659cd0a-cae8-4cd6-b368-91211918771b",
    "firmName": "RUQAYYA MOHAMMED AL JANAAHI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1424",
    "licenseIssueDate": "11/11/2024 00:00:00",
    "licenseExpiryDate": "11/10/2025 00:00:00"
  },
  {
    "id": "06ccb178-6ea4-4b84-b1c0-a682bed9e8d9",
    "slug": "ruqiya-ali-mohamed-baghi",
    "name": "RUQIYA ALI MOHAMED BAGHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/04/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ruqiya Ali Mohamed Baghi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_06ccb178-6ea4-4b84-b1c0-a682bed9e8d9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1183",
    "licenseIssueDate": "04/30/2017 00:00:00",
    "licenseExpiryDate": "04/29/2026 00:00:00"
  },
  {
    "id": "1c63c832-ae0d-47bc-8184-3d6ca6d282fd",
    "slug": "saad-mohammed-abdulla-al-hammadi",
    "name": "SAAD MOHAMMAD ABDULLA ALHAMMADI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 26,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/03/1999",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Saad Mohammed Abdulla Al-Hammadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1c63c832-ae0d-47bc-8184-3d6ca6d282fd",
        "address": "SAAD AL HAMMADI ,مدخل البرج ,ويست بيري ,برج خليفه ,41747 ,Dubai",
        "phone": "97142405222",
        "email": "info@saadpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "18923100-5b94-44e2-b580-2e3b0cc17bf6",
    "firmName": "SAAD AL HAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-355",
    "licenseIssueDate": "03/13/1999 00:00:00",
    "licenseExpiryDate": "03/12/2026 00:00:00"
  },
  {
    "id": "cd1c135e-132d-4ca6-aa2c-299c1f00c88b",
    "slug": "saad-mohammed-ali-salman-al-marzooqi",
    "name": "SAAD MOHAMED ALI SALMAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/11/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Saad Mohammed Ali Salman Al Marzooqi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cd1c135e-132d-4ca6-aa2c-299c1f00c88b",
        "address": "MOHAMMED ALI SALMAN AL MARZOOQI ,الثالث  ,السركال  ,معرض سيارات الفطيم  ,39059 ,Dubai",
        "phone": "97142500008",
        "email": "adv.saad@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "6bba829c-0392-4c72-a71b-01da72cb24ae",
    "firmName": "MOHAMED SALMAN ADVOCATE & LEGAL CONSULTANCY",
    "registrationNumber": "L-897",
    "licenseIssueDate": "11/06/2013 00:00:00",
    "licenseExpiryDate": "11/05/2025 00:00:00"
  },
  {
    "id": "d89543b6-417f-48b7-a243-3cdc4da443a8",
    "slug": "saadaldin-jaffer-abdulla-al-noakhatha",
    "name": "Saadaldin Jaffer Abdulla Al Noakhatha",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 20,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/14/2005 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Saadaldin Jaffer Abdulla Al Noakhatha",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d89543b6-417f-48b7-a243-3cdc4da443a8",
        "address": "saadaldain ,407 ,سيتي باي مركز الاعمال  ,المستشفي الكندي ,182435 ,Dubai",
        "phone": "97142280908",
        "email": "alraya990@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "d7e59e90-7dc8-4877-9c43-b3f1f8a52e72",
    "firmName": "AL RAYA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "515",
    "licenseIssueDate": "03/14/2005 00:00:00",
    "licenseExpiryDate": "03/13/2026 00:00:00"
  },
  {
    "id": "27ba1a39-d96f-477e-adeb-21be92a07a04",
    "slug": "sabeel-salim-rashid-rahma",
    "name": "SABEEL SALIM RASHID",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/01/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Sabeel Salim Rashid Rahma",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_27ba1a39-d96f-477e-adeb-21be92a07a04",
        "address": "",
        "phone": "97142369992",
        "email": "info@sabeeladvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "e9e9c3e3-c37e-43ae-b338-58589939c804",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-908",
    "licenseIssueDate": "01/14/2014 00:00:00",
    "licenseExpiryDate": "01/13/2026 00:00:00"
  },
  {
    "id": "6766b777-287a-4dd9-8d59-ab0e4c87b09b",
    "slug": "sabehah-salem-mohamed-salem-alsereidi",
    "name": "SABEIHAH SALEM MOHAMED SALEM ALSEREIDI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/02/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Sabehah Salem Mohamed Salem Alsereidi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6766b777-287a-4dd9-8d59-ab0e4c87b09b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1260",
    "licenseIssueDate": "02/27/2018 00:00:00",
    "licenseExpiryDate": "02/26/2026 00:00:00"
  },
  {
    "id": "1e37a614-2626-43c5-a127-277ad749a000",
    "slug": "saed-mubarak-obaid-ahmad-al-zahmi",
    "name": "SAEED MOBARAK OBAID AHMED AL ZAHMY",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 30,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/12/1994",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Saed Mubarak Obaid Ahmad Al-Zahmi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1e37a614-2626-43c5-a127-277ad749a000",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-265",
    "licenseIssueDate": "12/14/1994 00:00:00",
    "licenseExpiryDate": "12/13/2025 00:00:00"
  },
  {
    "id": "ee783fdc-e9c1-448e-9d26-0fcaa2051047",
    "slug": "saeed-abdalla-ahmed-almutawa-alsuwaidi",
    "name": "Saeed Abdalla Ahmed Almutawa Alsuwaidi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/11/2013",
    "licenseStatus": "active",
    "licenseExpiry": "2014-11-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Saeed Abdalla Ahmed Almutawa Alsuwaidi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ee783fdc-e9c1-448e-9d26-0fcaa2051047",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "896",
    "licenseIssueDate": "11/04/2013 00:00:00",
    "licenseExpiryDate": "11/03/2025 00:00:00"
  },
  {
    "id": "5115557e-33f2-40a3-b0e5-e4bafcf8e4b2",
    "slug": "saeed-abdulla-khameis-alkhalawi-alsharmi",
    "name": "SAEED ABDULLA KHAMEIS AL KHALAWI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/07/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Saeed Abdulla Khameis Alkhalawi Alsharmi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5115557e-33f2-40a3-b0e5-e4bafcf8e4b2",
        "address": "الطابق الرابع 415 ,بزنس افنيو 515 ,ستي سنتر ديرة ,0000 ,Dubai",
        "phone": "97148345000 / 971506996499",
        "email": "INFO@ALSHARMILAW.COM",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "c7f1e07b-8d68-4b46-bf95-a7d3fdf534c0",
    "firmName": "SAEED ALSHARMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1432",
    "licenseIssueDate": "07/12/2020 00:00:00",
    "licenseExpiryDate": "07/11/2026 00:00:00"
  },
  {
    "id": "a512310d-4672-4ff4-9114-cf424375680c",
    "slug": "saeed-ahmad-mohamed-mahmood-alawadhi",
    "name": "SAEED AHMAD MOHAMED MAHMOOD ALAWADHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/04/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Saeed Ahmad Mohamed Mahmood Alawadhi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a512310d-4672-4ff4-9114-cf424375680c",
        "address": "",
        "phone": "97143430934",
        "email": "salegal.ae@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "bf78dc70-00fa-4098-8c14-62ac235bd5b2",
    "firmName": "SAEED ALAWADHI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1070",
    "licenseIssueDate": "04/07/2016 00:00:00",
    "licenseExpiryDate": "04/06/2026 00:00:00"
  },
  {
    "id": "5af7f7f1-85d0-4ac2-8533-0712456902ab",
    "slug": "saeed-ali-mohamed-tahir",
    "name": "SAEED ALI MOHAMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/11/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Saeed Ali Mohamed Tahir",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5af7f7f1-85d0-4ac2-8533-0712456902ab",
        "address": "",
        "phone": "97145686887 / 971000000000",
        "email": "info@satlawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "19abc134-e04a-4728-8b0b-04814e587c5b",
    "firmName": "SAEED ALI TAHER ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-779",
    "licenseIssueDate": "11/10/2011 00:00:00",
    "licenseExpiryDate": "11/09/2025 00:00:00"
  },
  {
    "id": "2c55522b-7649-4097-9ae9-9dad31184520",
    "slug": "saeed-ali-mohammad-binqedad-almheiri",
    "name": "saeed ali mohammad binqedad almheiri",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/08/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: saeed ali mohammad binqedad almheiri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2c55522b-7649-4097-9ae9-9dad31184520",
        "address": "Saeed almheiri  ,1907 ,Churchill tower 1 ,Bur Khalifa  ,37979 ,Dubai",
        "phone": "97143944183 / 971504544002",
        "email": "advocates@saeed-almheiri.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "c0273ff0-aced-4d48-98fb-07c20ed5fbc2",
    "firmName": "SAEED AL MHEIRI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "15980",
    "licenseIssueDate": "12/08/2021 00:00:00",
    "licenseExpiryDate": "12/07/2025 00:00:00"
  },
  {
    "id": "445752d1-c426-4d06-b9f8-968e2c3319e8",
    "slug": "saeed-darweish-saeed-alabd-aldhanhani",
    "name": "SAEED DARWEISH SAEED ALABD ALDHANHANI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/31/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: SAEED DARWEISH SAEED ALABD ALDHANHANI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_445752d1-c426-4d06-b9f8-968e2c3319e8",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "1973",
    "licenseIssueDate": "05/31/2024 00:00:00",
    "licenseExpiryDate": "05/30/2026 00:00:00"
  },
  {
    "id": "7485ff02-a005-47c0-9e4b-a98ca9e076ae",
    "slug": "saeed-eissa-bakheet-huwaireb-almansoori",
    "name": "NAJWA WAHEED ZAKI AKOUSH",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/03/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Saeed Eissa Bakheet Huwaireb Almansoori",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7485ff02-a005-47c0-9e4b-a98ca9e076ae",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1782",
    "licenseIssueDate": "03/28/2023 00:00:00",
    "licenseExpiryDate": "03/27/2026 00:00:00"
  },
  {
    "id": "bfef373f-93d7-4364-9abe-05b3340eee07",
    "slug": "saeed-hatem-karama-almenhali",
    "name": "SAEED HATEM KRAMA ALMENHALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/02/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Saeed Hatem Karama Almenhali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bfef373f-93d7-4364-9abe-05b3340eee07",
        "address": "Office No. 604 ,Gulf Commercial - Shoba Sapphire Building ,Makani No: 2612485764 ,000 ,Dubai",
        "phone": "97150411984 / 971504119844",
        "email": "s.almenhali.advocates@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "3f85aa24-b612-477c-9af1-5067f3afda7d",
    "firmName": "SAEED HATEM ALMENHALI AND ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1253",
    "licenseIssueDate": "02/05/2018 00:00:00",
    "licenseExpiryDate": "02/04/2026 00:00:00"
  },
  {
    "id": "ab490313-ebef-4517-884b-96767843257c",
    "slug": "saeed-ibrahim-alsayed-ahmad-alhashimi",
    "name": "SAEED IBRAHIM ALSAYED AHMAD ABDULRAHIM ALHASHMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/09/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Saeed Ibrahim Alsayed Ahmad Alhashimi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ab490313-ebef-4517-884b-96767843257c",
        "address": "203 ,BUSINESS VENUE BLDG ,TASHEEL ,444249 ,Dubai",
        "phone": "97145807964 / 971562302002",
        "email": "info@emirates-lawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "ce1aadbc-a1c1-4002-90eb-cfa12655b1d1",
    "firmName": "SAEED ALHASHMI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-1029",
    "licenseIssueDate": "09/22/2015 00:00:00",
    "licenseExpiryDate": "09/21/2026 00:00:00"
  },
  {
    "id": "72a513f7-ecf1-4b4d-829e-91f1a3d52593",
    "slug": "saeed-juma-saeed-al-suwaidi",
    "name": "SAEED JUMA SAEED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/03/2009",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: SAEED JUMA SAEED AL SUWAIDI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_72a513f7-ecf1-4b4d-829e-91f1a3d52593",
        "address": "saeed juma saeed alsuwaidi ,الثامن عشر مكتب 1801 ,almasraf tower ,بجوار بلدية دبي ,36997 ,Dubai",
        "phone": "97142567771",
        "email": "info@saeedalsuwaidi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "bdfc9a52-bffc-4712-acc9-96eb498c7238",
    "firmName": "SAEED ALSUWAIDI LAWYERS & LEGAL CONSULTANTS",
    "registrationNumber": "L-660",
    "licenseIssueDate": "03/30/2009 00:00:00",
    "licenseExpiryDate": "03/29/2026 00:00:00"
  },
  {
    "id": "757b6dbf-9950-4aee-a8c3-dd2f8944cfa5",
    "slug": "saeed-khalfan-mohammed-ali-al-dahmani",
    "name": "SAEED KHALFAN MOHAMED A ALDAHMANI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/10/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Saeed Khalfan Mohammed Ali Al Dahmani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_757b6dbf-9950-4aee-a8c3-dd2f8944cfa5",
        "address": "Office No. 216 ,Al Wasl Building ,Opposite Dubai Mall Metro Station; Makani No: 8853725508 ,000 ,Dubai",
        "phone": "97145708388",
        "email": "sa.legaladvo@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "854c7388-093b-4e7c-b181-6a3d10225967",
    "firmName": "SAEED AL DAHMANI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1315",
    "licenseIssueDate": "10/08/2018 00:00:00",
    "licenseExpiryDate": "10/07/2025 00:00:00"
  },
  {
    "id": "87c873c9-1cda-4bd5-96cc-eb834b631a93",
    "slug": "saeed-khamis-saeed-alnaqbi",
    "name": "MOHAMED SAEED MOHAMED HILAL",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/01/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Saeed Khamis Saeed Alnaqbi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_87c873c9-1cda-4bd5-96cc-eb834b631a93",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1622",
    "licenseIssueDate": "02/09/2022 00:00:00",
    "licenseExpiryDate": "02/08/2026 00:00:00"
  },
  {
    "id": "a3dd0a0d-e994-436f-9eec-a839ef48035b",
    "slug": "saeed-mohammad-abdulla-salem-alsayegh-alghafri",
    "name": "SAEED MOHAMMAD ABDULLA ALSAYEGH ALGHAFRI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/05/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Saeed Mohammad Abdulla Salem Alsayegh Alghafri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a3dd0a0d-e994-436f-9eec-a839ef48035b",
        "address": "saeed ,310 & 311 ,business avenue ,منطقه بور سعيد التجاريه ,19410 ,Dubai",
        "phone": "97148868812",
        "email": "info@saeedalghafri.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "5acd50c8-df41-496b-a969-926d40e45c46",
    "firmName": "SAEED ALGHAFRI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-756",
    "licenseIssueDate": "05/10/2011 00:00:00",
    "licenseExpiryDate": "05/09/2026 00:00:00"
  },
  {
    "id": "c2c55d9a-a71f-47be-9aac-65f45ce9a79f",
    "slug": "saeed-mohammed-saeed-khalifa-almuharrami",
    "name": "SAEED MOHAMMED SAEED KHALIFA ALMUHARRAMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/10/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Saeed Mohammed Saeed Khalifa Almuharrami",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c2c55d9a-a71f-47be-9aac-65f45ce9a79f",
        "address": "الطابق الثالث -مكتب رقم 312  ,اعمار بزنس بارك -مبنى رقم 4  ,مصرف رأس الخيمة الوطنى ,336684 ,Dubai",
        "phone": "97144466072 / 971569807807",
        "email": "infobiadvocates@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "abb9efff-73d9-42e6-af59-29b92f4e2d09",
    "firmName": "SAEED ALMUHARRAMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-974",
    "licenseIssueDate": "10/23/2014 00:00:00",
    "licenseExpiryDate": "10/22/2025 00:00:00"
  },
  {
    "id": "970a1606-b103-47a9-b5d6-8da26bb89484",
    "slug": "saeed-musabeh-saeed-musabeh-al-nasiri",
    "name": "SAEED MUSABEH SAEED MUSABEH ALNASRI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 18,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/07/2007",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: SAEED MUSABEH SAEED MUSABEH AL NASIRI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_970a1606-b103-47a9-b5d6-8da26bb89484",
        "address": "YASIR AL NAQBI ,21 ,48 BURJ ,SOFITEL DOWN  TOWN ,181111 ,Dubai",
        "phone": "97142689949",
        "email": "info@alnaqbipartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "ad71430e-83ee-4cb5-a530-bc58db2618f6",
    "firmName": "ALNAQBI & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-611",
    "licenseIssueDate": "07/03/2007 00:00:00",
    "licenseExpiryDate": "07/02/2026 00:00:00"
  },
  {
    "id": "744bf287-fed3-44e8-9f38-9473c2dddb63",
    "slug": "saeed-rashid-ali-rashid-al-nuaimi",
    "name": "SAEED RASHED ALI RASHED ALNUAIMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/08/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Saeed Rashid Ali Rashid Al Nuaimi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_744bf287-fed3-44e8-9f38-9473c2dddb63",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1554",
    "licenseIssueDate": "08/09/2021 00:00:00",
    "licenseExpiryDate": "08/08/2026 00:00:00"
  },
  {
    "id": "4afcd5b2-295f-4469-862e-be461c873521",
    "slug": "saeed-salem-balarsa-alshamsi",
    "name": "HILAL AMUR HAMED SAIF ALSAWAI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/04/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: saeed salem balarsa alshamsi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4afcd5b2-295f-4469-862e-be461c873521",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1803",
    "licenseIssueDate": "05/24/2023 00:00:00",
    "licenseExpiryDate": "05/23/2026 00:00:00"
  },
  {
    "id": "6586459e-4994-4b3f-a4a8-e4e9891fbaf5",
    "slug": "saeed-salem-khalifa-salem-almazrouei",
    "name": "AISHA SALEM ALI ABDULLA ALDHAHERI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/01/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: SAEED SALEM KHALIFA SALEM ALMAZROUEI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6586459e-4994-4b3f-a4a8-e4e9891fbaf5",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1751",
    "licenseIssueDate": "01/31/2023 00:00:00",
    "licenseExpiryDate": "01/30/2026 00:00:00"
  },
  {
    "id": "747b8275-9a91-458d-a0f7-2e0a54314127",
    "slug": "saeed-salmeen-naseeb-mghaithat-al-menhali",
    "name": "SAEED SALMEEN NASEEB MGHAITHAT ALMENHALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/09/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Saeed Salmeen Naseeb Mghaithat Al Menhali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_747b8275-9a91-458d-a0f7-2e0a54314127",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-633",
    "licenseIssueDate": "09/21/2020 00:00:00",
    "licenseExpiryDate": "09/20/2026 00:00:00"
  },
  {
    "id": "5304dda6-0901-42fb-9522-009cf79d5b07",
    "slug": "saeed-suhael-musalam-alrashdi",
    "name": "SAEED SUHAIL MUSALLAM ALRASHDI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/03/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Saeed Suhael Musalam Alrashdi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5304dda6-0901-42fb-9522-009cf79d5b07",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1152",
    "licenseIssueDate": "03/09/2017 00:00:00",
    "licenseExpiryDate": "03/08/2026 00:00:00"
  },
  {
    "id": "2ca7ae22-7aa8-4cdc-b8d2-ca71a3e4751f",
    "slug": "saeed-sulayem-rashed-almazrouei",
    "name": "SAEED SULAYEM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/11/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Saeed Sulayem Rashed Almazrouei",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2ca7ae22-7aa8-4cdc-b8d2-ca71a3e4751f",
        "address": "Saeed Sulayem Rashed Almazrouei ,M05 ,Al Durrah 4 ,Behind GGICO metro station ,11311 ,Dubai",
        "phone": "97143889000",
        "email": "info@sulayemlegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "b221d5d0-c8b1-4064-a7a5-84cf410fd408",
    "firmName": "SAEED SULAYEM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-838",
    "licenseIssueDate": "11/12/2012 00:00:00",
    "licenseExpiryDate": "11/11/2025 00:00:00"
  },
  {
    "id": "f9df24ad-c029-4d54-8aee-5ecec05ad829",
    "slug": "saeed-thani-ali-khalifa-bin-ghulaita-almuhairi",
    "name": "SAEED THANI ALI BIN GHULAITA ALMUHAIRI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Civil Transactions-Construction and Contracts for Services",
      "Commercial Transactions-Commercial Mortgage",
      "Personal Status-Custody & Alimony",
      "Commercial Transactions-Commercial Contracts",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Civil Transactions-Tenancy",
      "Commercial Transactions-Unfair competition",
      "Criminal Law-Crimes against persons",
      "Commercial Transactions-Commercial Companies",
      "Civil Transactions-Labor & Workers",
      "Personal Status-Legal Capacity & Guardianship",
      "Criminal Law-Drug Crimes",
      "Civil Transactions-Sale",
      "Commercial Transactions-Sea and air freight",
      "Personal Status-Marriage & Divorce",
      "Criminal Law-Crimes against properties",
      "Criminal Law-Cybercrimes",
      "Commercial Transactions-Intellectual Property (includes trademarks",
      "copy rights",
      "patents)",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/08/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Saeed Thani Ali Khalifa Bin Ghulaita Almuhairi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f9df24ad-c029-4d54-8aee-5ecec05ad829",
        "address": "saeed thani ben ghulaita ,الطابق الاول علوي رقم المكتب 109  ,التجاري ام الشيف  ,مطعم سلطان سراي ,398 ,Dubai",
        "phone": "97143333309 / 971502660044",
        "email": "saeedalmuhairi@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "ef647e96-a648-4410-bb78-03c38a83d79e",
    "firmName": "SAEED BIN GHULATA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1308",
    "licenseIssueDate": "08/27/2018 00:00:00",
    "licenseExpiryDate": "08/26/2026 00:00:00"
  },
  {
    "id": "4d3f78fc-d18a-41bf-aed1-81dccc5b67af",
    "slug": "safa-mohamed-sanqour-qamber-almaazmi",
    "name": "ALIAA SAEED SAIF ALABRI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/11/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Safa Mohamed Sanqour Qamber  Almaazmi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4d3f78fc-d18a-41bf-aed1-81dccc5b67af",
        "address": "5 ,tasheel bldg ,nasr club ,116749 ,Dubai",
        "phone": "97143970701",
        "email": "salha@albastiadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "c34580b3-9e80-4326-bd68-0eb2abbb06fc",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1732",
    "licenseIssueDate": "12/30/2022 00:00:00",
    "licenseExpiryDate": "12/29/2025 00:00:00"
  },
  {
    "id": "d8f8584b-9ebb-4bcf-9bfb-a90586ef7c59",
    "slug": "safia-sultan-ahmeed",
    "name": "SAFIA SULTAN W O ABDULKARIM AHMED A EID",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 18,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/03/2007",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: SAFIA SULTAN AHMEED",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d8f8584b-9ebb-4bcf-9bfb-a90586ef7c59",
        "address": "ABDULLKAREIM AHMED ABDULLA EID ,الطابق الثانى - مكتب رقم 014 ,مركز الممزر  ,مقابل القياده العامه لشرطة دبي - بجوار مكتب وزارة العمل والعمال القديم  ,89505 ,Dubai",
        "phone": "97142388850",
        "email": "bineidadvocates@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "ea633c29-6b4a-48a8-aaec-c801ece50744",
    "firmName": "BIN EID ADVOCATES & LEGEL CONSULTANTS",
    "registrationNumber": "L-599",
    "licenseIssueDate": "03/06/2007 00:00:00",
    "licenseExpiryDate": "03/05/2026 00:00:00"
  },
  {
    "id": "33a45b1b-10b1-4854-a8d4-af876912ceb1",
    "slug": "sahhar-adnan-rman",
    "name": "SAHAR ADNAN RMAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 19,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/10/2006",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: sahhar adnan rman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_33a45b1b-10b1-4854-a8d4-af876912ceb1",
        "address": "الدور 19 ,كونراد هوتيل ,كونراد هوتيل ,29799 ,Dubai",
        "phone": "",
        "email": "info.saharadvocates@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "81bae066-e6a9-4931-b879-707d032a8ec5",
    "firmName": "SAHAR ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-582",
    "licenseIssueDate": "10/11/2006 00:00:00",
    "licenseExpiryDate": "10/10/2026 00:00:00"
  },
  {
    "id": "2a1880a8-3f38-4411-9cd8-ea936aab873d",
    "slug": "said-juma-saleh-mubarak-al-ghelani",
    "name": "Said Juma Saleh Mubarak Al-Ghelani",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 24,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/05/2000 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Said Juma Saleh Mubarak Al-Ghelani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2a1880a8-3f38-4411-9cd8-ea936aab873d",
        "address": "- ,- ,- ,00 ,Dubai",
        "phone": "97142502203",
        "email": "saed_ghailani@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "6136e013-f23c-455c-a7ed-8d017eb15356",
    "firmName": "SAEED AL GHAILANI ADVOCATE & LEGAL CONSULTANC",
    "registrationNumber": "390",
    "licenseIssueDate": "12/05/2000 00:00:00",
    "licenseExpiryDate": "12/04/2025 00:00:00"
  },
  {
    "id": "6fcc9be9-74cb-4719-8bac-763d3d8fd6bb",
    "slug": "saif-ahmed-ibrahim-mohammed-alblooshi",
    "name": "Saif Ahmed Ibrahim Mohammed Alblooshi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/20/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Saif Ahmed Ibrahim Mohammed Alblooshi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6fcc9be9-74cb-4719-8bac-763d3d8fd6bb",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "1847",
    "licenseIssueDate": "08/20/2023 00:00:00",
    "licenseExpiryDate": "08/19/2026 00:00:00"
  },
  {
    "id": "70dd893f-6bd6-4de1-90d1-bdca7dc8eb9f",
    "slug": "saif-ahmed-saeed-othman-alwahedi",
    "name": "SHAMSA HASHEM SALEM KHEDAIM ALWAHSHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/06/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Saif Ahmed Saeed Othman Alwahedi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_70dd893f-6bd6-4de1-90d1-bdca7dc8eb9f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1999",
    "licenseIssueDate": "07/02/2024 00:00:00",
    "licenseExpiryDate": "07/01/2026 00:00:00"
  },
  {
    "id": "bdfedc2b-50ef-4ead-859b-d7ede15ce72e",
    "slug": "saif-ali-ebraheem-alhammadi",
    "name": "JAMAL HAMAD OBAID",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/12/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: saif ali ebraheem alhammadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bdfedc2b-50ef-4ead-859b-d7ede15ce72e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1907",
    "licenseIssueDate": "01/10/2024 00:00:00",
    "licenseExpiryDate": "01/09/2026 00:00:00"
  },
  {
    "id": "d72f38a2-4fa0-4576-9864-2fcf7cabcd26",
    "slug": "saif-khalifa-yarouf-khalifa-alsubousi",
    "name": "SAIF KHALIFA YAROUF KHALIFA ALSUBOUSI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/07/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Saif Khalifa Yarouf Khalifa Alsubousi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d72f38a2-4fa0-4576-9864-2fcf7cabcd26",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1431",
    "licenseIssueDate": "07/12/2020 00:00:00",
    "licenseExpiryDate": "07/11/2026 00:00:00"
  },
  {
    "id": "d37c4861-f9c1-47ea-91ed-23576248a25c",
    "slug": "saif-naser-musabah-khamis-alkalbani",
    "name": "ABDULLA OBAID SULAIMAN HAMAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/08/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Saif Naser Musabah Khamis Alkalbani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d37c4861-f9c1-47ea-91ed-23576248a25c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1858",
    "licenseIssueDate": "08/30/2023 00:00:00",
    "licenseExpiryDate": "08/29/2026 00:00:00"
  },
  {
    "id": "6032c4ad-cf3d-4363-97ab-03c5ab8caf1f",
    "slug": "saif-rashed-saif-sowaihi-aizhmhmi",
    "name": "SAIF RASHED SAIF SOWAIHI ALZAHMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/03/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: SAIF RASHED SAIF SOWAIHI AIZHMHMI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6032c4ad-cf3d-4363-97ab-03c5ab8caf1f",
        "address": "",
        "phone": "97145859327 / 971503148845",
        "email": "info@amalc.net",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "35e74c66-ffd0-4b2c-bc7c-025474d0a49d",
    "firmName": "ABDULLA ALATEIBI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1058",
    "licenseIssueDate": "03/07/2016 00:00:00",
    "licenseExpiryDate": "03/06/2026 00:00:00"
  },
  {
    "id": "ab7b9172-a937-4351-b1a5-2a5946b652d8",
    "slug": "saif-saeed-rashid-al-gubar-al-shamsi",
    "name": "SAIF SAEED RASHID ALGHUBAR",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 28,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/10/1997",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Saif Saeed Rashid Al Gubar Al Shamsi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ab7b9172-a937-4351-b1a5-2a5946b652d8",
        "address": "Saif Saeed Rashid Alghubar Alshamsi ,الطابق 3 مكتب E313  ,مكاتب الساحة ب  ,برج خليفة ,20338 ,Dubai",
        "phone": "97144477044 / 971551630600",
        "email": "info@tlg.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "74f923b2-ef17-48a4-9af4-e15ddacb5e0e",
    "firmName": "THE LEGAL GROUP- ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-310",
    "licenseIssueDate": "10/04/1997 00:00:00",
    "licenseExpiryDate": "10/03/2026 00:00:00"
  },
  {
    "id": "7cce370e-964e-4ccb-a916-7d1b9df5b5d3",
    "slug": "saif-saleh-mohammed-darwish-al-mutawa",
    "name": "SAIF SALEH MOHD DARWISH AL MUTAWA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 34,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/11/1990",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Saif Saleh Mohammed Darwish Al-Mutawa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7cce370e-964e-4ccb-a916-7d1b9df5b5d3",
        "address": "29TH  ,PRISM TOWER ,J W MARRIOTT MARQUIS HOTEL  ,4790 ,Dubai",
        "phone": "97144539090",
        "email": "info@alkabban.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "a9193879-c34b-4dae-99aa-d8e5ac8517cc",
    "firmName": "AL-KABBAN & ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-211",
    "licenseIssueDate": "11/12/1990 00:00:00",
    "licenseExpiryDate": "11/11/2025 00:00:00"
  },
  {
    "id": "b9551921-4df3-4af5-9ba2-0c03c31ae630",
    "slug": "saif-salman-qahtan-obaid-alshamsi",
    "name": "MAITHA ABDULMUNEM SALEM OBAID",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/04/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: SAIF SALMAN QAHTAN OBAID ALSHAMSI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b9551921-4df3-4af5-9ba2-0c03c31ae630",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1794",
    "licenseIssueDate": "04/29/2023 00:00:00",
    "licenseExpiryDate": "04/28/2026 00:00:00"
  },
  {
    "id": "e5a51cdf-94a7-4554-9177-bc47d7574625",
    "slug": "saif-sultan-ali-almehrzi",
    "name": "SAIF SULTAN AL ALMEHRZI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/11/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Saif Sultan Ali Almehrzi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e5a51cdf-94a7-4554-9177-bc47d7574625",
        "address": "Office No. 211 ,Al Wasl Building ,Makani No: 2479487549 ,000 ,Dubai",
        "phone": "97142733476 / 97142733476",
        "email": "abo_sultan_s@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "ba81cc15-7448-4103-91bf-70c7e3f12812",
    "firmName": "SAIF SULTAN ALMEHRZI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1467",
    "licenseIssueDate": "11/01/2020 00:00:00",
    "licenseExpiryDate": "10/31/2025 00:00:00"
  },
  {
    "id": "5e360205-9cd8-4c47-ae9f-87e9567b850d",
    "slug": "saif-ubaid-rashid-ubaid-al-shamsi",
    "name": "SAIF OBAID RASHED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTVQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/04/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Saif Ubaid Rashid Ubaid Al Shamsi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5e360205-9cd8-4c47-ae9f-87e9567b850d",
        "address": "",
        "phone": "97145477552 / 971507474706",
        "email": "saifalshamsi.law@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "a1313be0-55e4-49d0-987d-98d1dd84db7e",
    "firmName": "SAIF ALSHAMSI ADVOCATES AND LEGAL CONSULTANCY",
    "registrationNumber": "L-927",
    "licenseIssueDate": "04/03/2014 00:00:00",
    "licenseExpiryDate": "04/02/2026 00:00:00"
  },
  {
    "id": "09bc39f3-ddda-41f9-91d9-1d7bd53f9821",
    "slug": "saif-younis-mohamed-esmaeel-alrifai",
    "name": "Saif Younis Mohamed Esmaeel Alrifai",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/11/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Saif Younis Mohamed Esmaeel Alrifai",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_09bc39f3-ddda-41f9-91d9-1d7bd53f9821",
        "address": "الطابق 11 - مكتب رقم (1105 ، 1106)  ,برج السلام  ,منطقة المركز التجاري العالمي 1 ,211911 ,Dubai",
        "phone": "97143366769 / 971503636617",
        "email": "info@erlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "fffe1b8f-e9ab-488f-82eb-6151b8f007df",
    "firmName": "EMAN ALRIFAI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "1066",
    "licenseIssueDate": "12/11/2018 00:00:00",
    "licenseExpiryDate": "12/10/2025 00:00:00"
  },
  {
    "id": "5a4eadde-4723-44c0-83b7-e84033e28046",
    "slug": "salah-abdelkerim-abdelelah-alhamadani",
    "name": "Salah Abdelkerim Abdelelah Alhamadani",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/13/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Salah Abdelkerim Abdelelah Alhamadani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5a4eadde-4723-44c0-83b7-e84033e28046",
        "address": "Salah Abdelkarim Abdellah Alhamadani ,1st Floor, Office F46 ,Warba Centre ,Al Muraqqabat Police Station ,12898 ,Dubai",
        "phone": "97142963333",
        "email": "salah653@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "30f935cb-bbe9-41cc-95a7-f12ee003b96e",
    "firmName": "THE FUTURE ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "797",
    "licenseIssueDate": "03/13/2012 00:00:00",
    "licenseExpiryDate": "03/12/2026 00:00:00"
  },
  {
    "id": "94dac61f-d6f3-463b-a8a3-dff1520216ed",
    "slug": "salah-al-din-shahdad-wayed-al-balooshi",
    "name": "Salah Al Din Shahdad Wayed Al Balooshi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 21,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/25/2004 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-01-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Salah Al Din Shahdad Wayed Al Balooshi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_94dac61f-d6f3-463b-a8a3-dff1520216ed",
        "address": "الجناح الشمالي الطابق التاسع الوحدة 902 ,بنك المشرق جلوبال اتش كيه  ,برج خليفة  ,41422 ,Dubai",
        "phone": "97145514441",
        "email": "info@sat-law.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "d0e8d9f9-263d-4e8a-af05-984f0cc97149",
    "firmName": "SAT & CO ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "476",
    "licenseIssueDate": "01/25/2004 00:00:00",
    "licenseExpiryDate": "01/24/2026 00:00:00"
  },
  {
    "id": "d1957eb6-5dfb-4170-bd61-a992d94aea65",
    "slug": "salah-ali-alawi-al-barazanaji",
    "name": "Salah Ali Alawi Al Barazanaji",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/23/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Salah Ali Alawi Al Barazanaji",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d1957eb6-5dfb-4170-bd61-a992d94aea65",
        "address": "ادارة ا لمبنى  ,الريم ,الاتصالات  ,42423 ,Dubai",
        "phone": "97142222066",
        "email": "info@ozleco.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "7a155f4a-20ec-44ff-863f-4f9fb43d0af4",
    "firmName": "ALOBAIDLI & ALZAROONI ADVOCATES&LEGAL CONSULT",
    "registrationNumber": "874",
    "licenseIssueDate": "05/23/2013 00:00:00",
    "licenseExpiryDate": "05/22/2026 00:00:00"
  },
  {
    "id": "910a0b95-845a-4b81-ab20-d5bf75ce2bce",
    "slug": "salah-hasan-mohamed-mubasheri",
    "name": "SALAH HASAN MOHAMED MUBASHERI ALMARZOUQI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/08/2009",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Salah Hasan Mohamed Mubasheri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_910a0b95-845a-4b81-ab20-d5bf75ce2bce",
        "address": "611-612 ,مباني الحضيبة للجوائز  ,متحف الإتحاد ,6178 ,Dubai",
        "phone": "97143589998 / 971553690566",
        "email": "info@mublegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "8644c882-8dd2-4973-854c-d4417713cfc4",
    "firmName": "ALMUBASHERI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-678",
    "licenseIssueDate": "08/26/2009 00:00:00",
    "licenseExpiryDate": "08/25/2026 00:00:00"
  },
  {
    "id": "0a735693-490a-420b-bbd2-7d232d7b166c",
    "slug": "salah-mohamed-husain-alhasani",
    "name": "Salah Mohamed Husain Alhasani",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/21/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Salah Mohamed Husain Alhasani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0a735693-490a-420b-bbd2-7d232d7b166c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "569",
    "licenseIssueDate": "02/21/2025 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "6993b030-5e32-46be-82b4-4f06d5c40592",
    "slug": "salama-ali-ahmed-al-salf-alnuaimi",
    "name": "Salama Ali Ahmed Al salf Alnuaimi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/04/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Salama Ali Ahmed Al salf Alnuaimi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6993b030-5e32-46be-82b4-4f06d5c40592",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "1608",
    "licenseIssueDate": "01/04/2022 00:00:00",
    "licenseExpiryDate": "01/03/2026 00:00:00"
  },
  {
    "id": "511f62ab-ba0e-40dc-9cd4-941e0e7e1f60",
    "slug": "salama-mubarak-ghalib-khusouni-alketbi",
    "name": "SALAMA MUBARAK GHALIB SAEED KHUSOUNI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/04/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: salama mubarak Ghalib khusouni alketbi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_511f62ab-ba0e-40dc-9cd4-941e0e7e1f60",
        "address": "",
        "phone": "97148761744 / 971971487617",
        "email": "info@noorhanlawyer.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "8fd1535a-4b34-4e52-83df-139fcfb26305",
    "firmName": "BIN SEVAN ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-1594",
    "licenseIssueDate": "04/12/2023 00:00:00",
    "licenseExpiryDate": "04/11/2026 00:00:00"
  },
  {
    "id": "aa3c4c34-b6ad-407b-bd63-2df1968dad4d",
    "slug": "saleh-abdulla-mubarak-al-senani",
    "name": "Saleh Abdulla Mubarak Al Senani",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/19/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Saleh Abdulla Mubarak Al Senani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_aa3c4c34-b6ad-407b-bd63-2df1968dad4d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "1613",
    "licenseIssueDate": "01/19/2022 00:00:00",
    "licenseExpiryDate": "01/18/2026 00:00:00"
  },
  {
    "id": "5685cf58-a4fa-48e1-9417-12870cd4cdcd",
    "slug": "saleh-abdulrahman-saif-abdulrahman-alsaleh",
    "name": "SALEH ABDULRAHMAN SAIF",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/07/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Saleh Abdulrahman Saif Abdulrahman Alsaleh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5685cf58-a4fa-48e1-9417-12870cd4cdcd",
        "address": "",
        "phone": "97140000000 / 971504554699",
        "email": "salehalsalehadvo@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "5f03bc77-9f77-429d-96bf-c040a7037da1",
    "firmName": "SALEH AL SALEH ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1299",
    "licenseIssueDate": "07/31/2018 00:00:00",
    "licenseExpiryDate": "07/30/2026 00:00:00"
  },
  {
    "id": "8d229f59-6371-49eb-9922-234b6f0f045f",
    "slug": "saleh-ahmed-obaid-algharbi-alkindi",
    "name": "SALEH AHMED OBAID ALGHARBI ALKINDI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Personal Status-Custody & Alimony",
      "Civil Transactions-Tenancy",
      "Commercial Transactions-Banking Operations",
      "Civil Transactions-Labor & Workers",
      "Personal Status-Marriage & Divorce"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/12/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: SALEH AHMED OBAID ALGHARBI ALKINDI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8d229f59-6371-49eb-9922-234b6f0f045f",
        "address": "Khawla Saeed Mohammed Salem ,414 ,DBCS BUILDING ,محكمة الاحوال الشخصية ,73879 ,Dubai",
        "phone": "97143530354 / 971503787848",
        "email": "info@ksadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "e961ec37-b1f5-4b83-8382-639604c8fdaf",
    "firmName": "KHAWLA SAEED ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1607",
    "licenseIssueDate": "12/09/2021 00:00:00",
    "licenseExpiryDate": "12/08/2025 00:00:00"
  },
  {
    "id": "29869cb5-a81b-4de1-9680-c90f91eb5551",
    "slug": "saleh-ahmed-yousif-saleh-alobaidli",
    "name": "SALEH AHMED YOUSIF SALEH",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/11/2008",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Saleh Ahmed Yousif Saleh Alobaidli",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_29869cb5-a81b-4de1-9680-c90f91eb5551",
        "address": "Saleh Ahmed Yousif Saleh Alobeidli ,2nd ,DUBAI SUPREME COURT COMPLEX ,Dubai Courts ,333842 ,Dubai",
        "phone": "97143546762",
        "email": "Laila@iclo.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "57836e55-f90c-4fb1-81d0-a735a168b9ac",
    "firmName": "INTERNATIONAL CONSULTANT LAW OFFICE",
    "registrationNumber": "L-574",
    "licenseIssueDate": "11/17/2008 00:00:00",
    "licenseExpiryDate": "11/16/2025 00:00:00"
  },
  {
    "id": "5995f733-5318-4a5c-a286-ee914da9174e",
    "slug": "saleh-ramadhan-abdulla-mohammed-alqeblan",
    "name": "Saleh Ramadhan Abdulla Mohammed Alqeblan",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/20/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Saleh Ramadhan Abdulla Mohammed Alqeblan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5995f733-5318-4a5c-a286-ee914da9174e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "2014",
    "licenseIssueDate": "08/20/2024 00:00:00",
    "licenseExpiryDate": "08/19/2026 00:00:00"
  },
  {
    "id": "d7fb65f0-762b-48c1-a981-0f4e94ec934b",
    "slug": "salem-abdulla-sultan-ali-alhammadi",
    "name": "SALEM ABDULLA SULTAN ALI ALHAMMADI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/07/2009",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: SALEM ABDULLA SULTAN ALI ALHAMMADI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d7fb65f0-762b-48c1-a981-0f4e94ec934b",
        "address": "الطابق الثاني 206 ,باي سكوير رقم 11 ,دبي مول ,49793 ,Dubai",
        "phone": "97144518209 / 971506503353",
        "email": "info@rayyanadvo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "2c9d4a42-7cb3-4c95-88eb-2792bb07b395",
    "firmName": "RAYYAN ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-674",
    "licenseIssueDate": "07/22/2009 00:00:00",
    "licenseExpiryDate": "07/21/2026 00:00:00"
  },
  {
    "id": "85d3eb6d-c0d1-4a25-847c-e05007ce09bb",
    "slug": "salem-ahmed-salem-alkait-alali",
    "name": "SALEM AHMED SALEM ALKAIT ALALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/03/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Salem Ahmed Salem Alkait Alali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_85d3eb6d-c0d1-4a25-847c-e05007ce09bb",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1162",
    "licenseIssueDate": "03/30/2017 00:00:00",
    "licenseExpiryDate": "03/29/2026 00:00:00"
  },
  {
    "id": "b638e00d-b159-48c6-94b1-9bac3d1533b6",
    "slug": "salem-ali-manea-mufarreh-al-ahbabi",
    "name": "AADEL OBAID MOBARAK ALSHAREEF AL ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/08/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Salem Ali Manea Mufarreh Al Ahbabi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b638e00d-b159-48c6-94b1-9bac3d1533b6",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1695",
    "licenseIssueDate": "09/07/2022 00:00:00",
    "licenseExpiryDate": "09/06/2026 00:00:00"
  },
  {
    "id": "0fc69e61-ff3d-467c-a1d3-74c7b5f2dc95",
    "slug": "salem-fayez-khamis-fayez-alkaabi",
    "name": "SALIM FAYEZ KHAMIS FAYEZ ALKAABI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/07/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Salem Fayez Khamis Fayez Alkaabi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0fc69e61-ff3d-467c-a1d3-74c7b5f2dc95",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-881",
    "licenseIssueDate": "07/15/2013 00:00:00",
    "licenseExpiryDate": "07/14/2026 00:00:00"
  },
  {
    "id": "ec4d5fd1-1a76-40a4-bc32-0cc7e97bfcab",
    "slug": "salem-hamad-bahyan-barout-alameri",
    "name": "SALEM HAMAD BAHYAN BAROUT",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/02/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Salem Hamad Bahyan Barout Alameri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ec4d5fd1-1a76-40a4-bc32-0cc7e97bfcab",
        "address": "Salem Bahyan ,1103 ,Latifa ,First Trade Center ,20611 ,Dubai",
        "phone": "97143214231 / 97145645961",
        "email": "info@bbadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "6850aee4-bff6-42c3-a738-12cee3f47b0d",
    "firmName": "SALEM BIN BAHYAN ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-741",
    "licenseIssueDate": "02/24/2011 00:00:00",
    "licenseExpiryDate": "02/23/2026 00:00:00"
  },
  {
    "id": "f0075d77-fd81-474d-ad3c-348105294b32",
    "slug": "salem-khamais-salem-aljalboubi",
    "name": "SALEM KHAMIS SALEM ALJALBOUBI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/03/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: salem khamais salem aljalboubi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f0075d77-fd81-474d-ad3c-348105294b32",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1548",
    "licenseIssueDate": "03/02/2023 00:00:00",
    "licenseExpiryDate": "03/01/2026 00:00:00"
  },
  {
    "id": "1bc1a0fd-f6d3-45ec-ac3d-0a9e3add6686",
    "slug": "salem-khameis-saeed-hassan-alyammahi",
    "name": "SALEM KHAMEIS SAEED HASSAN ALYAMMAHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/05/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Salem Khameis Saeed Hassan Alyammahi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1bc1a0fd-f6d3-45ec-ac3d-0a9e3add6686",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1284",
    "licenseIssueDate": "05/22/2018 00:00:00",
    "licenseExpiryDate": "05/21/2026 00:00:00"
  },
  {
    "id": "26e69467-91a5-4974-a70a-3655f1c9163e",
    "slug": "salem-marhoun-musallem-rashed-alyahyaee",
    "name": "SALEM MARHOUN MUSALLEM RASHED ALYAHYAEE",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/01/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Salem Marhoun Musallem Rashed Alyahyaee",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_26e69467-91a5-4974-a70a-3655f1c9163e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1137",
    "licenseIssueDate": "01/04/2017 00:00:00",
    "licenseExpiryDate": "01/03/2026 00:00:00"
  },
  {
    "id": "a6a428b5-c63f-498b-8c38-084b9f168cf6",
    "slug": "salem-mohamed-essa-aljaber-al-ali",
    "name": "Salem Mohamed Essa Aljaber Al-Ali",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/21/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Salem Mohamed Essa Aljaber Al-Ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a6a428b5-c63f-498b-8c38-084b9f168cf6",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "1928",
    "licenseIssueDate": "03/21/2024 00:00:00",
    "licenseExpiryDate": "03/20/2026 00:00:00"
  },
  {
    "id": "cb1e4d75-ff47-4b8f-a0fe-71c585c30c5f",
    "slug": "salem-mohammed-hmoud-alderei",
    "name": "SULTAN ABDULLA OBAID MOUSA ALFARSI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/03/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Salem Mohammed Hmoud Alderei",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cb1e4d75-ff47-4b8f-a0fe-71c585c30c5f",
        "address": "",
        "phone": "97140000000 / 971504404084",
        "email": "info@mjlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "3c72f5a1-f8c3-4098-84d7-7886d6ea0165",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1639",
    "licenseIssueDate": "03/31/2022 00:00:00",
    "licenseExpiryDate": "03/30/2026 00:00:00"
  },
  {
    "id": "7e55009b-b190-4806-8782-123da9d14d62",
    "slug": "salem-mohammed-obaid-khamis-alabd-alnaqbi",
    "name": "SALEM MOHAMMED OBAID K ALABD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/02/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Salem Mohammed Obaid khamis Alabd Alnaqbi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7e55009b-b190-4806-8782-123da9d14d62",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-862",
    "licenseIssueDate": "02/26/2013 00:00:00",
    "licenseExpiryDate": "02/25/2026 00:00:00"
  },
  {
    "id": "cbea7897-7653-445d-a6ea-3e18d861fafa",
    "slug": "salem-obaid-salem-sahoh",
    "name": "SALIM OBAID SALIM JUMA SAHOH",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 37,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/01/1988",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Salem Obaid Salem Sahoh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cbea7897-7653-445d-a6ea-3e18d861fafa",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-180",
    "licenseIssueDate": "01/20/1988 00:00:00",
    "licenseExpiryDate": "01/19/2026 00:00:00"
  },
  {
    "id": "03355433-fded-4db1-a6b0-2b704b0ea1a2",
    "slug": "salem-rashed-abdulla-muftah-alkhateri",
    "name": "SALEM RASHED ABDULLA M ALKHATERI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/11/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Salem Rashed Abdulla Muftah Alkhateri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_03355433-fded-4db1-a6b0-2b704b0ea1a2",
        "address": "Block B, Office 711 ,Business Village Building ,Next to Clock Circle, Makani No: 9443231484 ,000 ,Dubai",
        "phone": "97144503646 / 971504282855",
        "email": "info@uaelawyers.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "45c3eabb-348d-429a-98c8-35613c7f89fe",
    "firmName": "SALEM AL KHATERI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1234",
    "licenseIssueDate": "11/05/2017 00:00:00",
    "licenseExpiryDate": "11/04/2025 00:00:00"
  },
  {
    "id": "ae980463-db67-4359-bfb3-a3dcaaa58215",
    "slug": "salem-rashed-ali-obaid-al-maftool",
    "name": "SALEM RASHED ALI O ALMAFTOOL",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 21,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/03/2004",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Salem Rashed Ali obaid Al Maftool",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ae980463-db67-4359-bfb3-a3dcaaa58215",
        "address": "",
        "phone": "97142628001",
        "email": "gloryadvocate@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "05351a6c-fcad-4824-9aba-1031f82e3720",
    "firmName": "AL MAFTOOL ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-483",
    "licenseIssueDate": "03/31/2004 00:00:00",
    "licenseExpiryDate": "03/30/2026 00:00:00"
  },
  {
    "id": "76ccd44a-fd98-4307-abf7-b5b023f123f9",
    "slug": "salem-saeed-ahmed-saeed-bin-kowair",
    "name": "SALEM SAEED AHMAD SAEED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/08/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Salem Saeed Ahmed Saeed Bin Kowair",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_76ccd44a-fd98-4307-abf7-b5b023f123f9",
        "address": "18 ,فندق مونارك  ,مركز التجاري ,98444 ,Dubai",
        "phone": "97143588777",
        "email": "info@bhadvoc.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "61266d12-f5b4-4466-a1a8-a45934d9e511",
    "firmName": "BIN HAIDER ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1215",
    "licenseIssueDate": "08/17/2017 00:00:00",
    "licenseExpiryDate": "08/16/2026 00:00:00"
  },
  {
    "id": "1a13c52f-3113-48e2-8133-7abbd173b4b8",
    "slug": "salem-saif-salem-al-kubaisi-al-ali",
    "name": "SALEM SAIF SALEM AL KUBAISI AL-ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/11/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Salem Saif Salem Al Kubaisi Al-Ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1a13c52f-3113-48e2-8133-7abbd173b4b8",
        "address": "1-114 ,سيتى باى للاعمال ,مقابل المستشفى الكندى ,93075 ,Dubai",
        "phone": "97143853266 / 971506131373",
        "email": "salemalkubaisidubai@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "bf4b9303-d534-41b4-a671-e8c4a3f032bd",
    "firmName": "SALEM KUBAISI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-106",
    "licenseIssueDate": "11/19/2015 00:00:00",
    "licenseExpiryDate": "11/18/2025 00:00:00"
  },
  {
    "id": "eab93855-a18f-4192-a459-e273cbfb0408",
    "slug": "salem-salem-mohammed-al-shaali",
    "name": "SALEM SALEM MOHAMED AL SHAALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 28,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/10/1997",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Salem Salem Mohammed AL-Shaali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_eab93855-a18f-4192-a459-e273cbfb0408",
        "address": "Ibrahim Nagi ,Office 207, Level 2 ,Al Khaimah Building ,Behind Nissan Showroom ,20220 ,Dubai",
        "phone": "97142950001",
        "email": "info@alshaali-co.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "a58e33e7-4134-4c4f-afa6-c129aefe104c",
    "firmName": "AL SHAALI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-300",
    "licenseIssueDate": "10/04/1997 00:00:00",
    "licenseExpiryDate": "10/03/2026 00:00:00"
  },
  {
    "id": "f9f7c2c0-9624-4777-a4e9-65e332979cbd",
    "slug": "salha-khalifa-lahij-khalifa-albasti",
    "name": "KHALIFA LAHEJ KHALIFA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/06/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Salha Khalifa Lahij Khalifa Albasti",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f9f7c2c0-9624-4777-a4e9-65e332979cbd",
        "address": "5 ,tasheel bldg ,nasr club ,116749 ,Dubai",
        "phone": "97143970701",
        "email": "salha@albastiadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "c34580b3-9e80-4326-bd68-0eb2abbb06fc",
    "firmName": "SALHA ALBASTI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-763",
    "licenseIssueDate": "06/27/2011 00:00:00",
    "licenseExpiryDate": "06/26/2026 00:00:00"
  },
  {
    "id": "b674ccdb-db9c-465d-9594-9784f7db8504",
    "slug": "salha-khalifa-mohammed-al-khallafi",
    "name": "ZELAIKHA HASAN AHMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/12/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Salha Khalifa Mohammed Al Khallafi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b674ccdb-db9c-465d-9594-9784f7db8504",
        "address": "",
        "phone": "/ 971505588450",
        "email": "salha.kk@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "851f7f37-c259-4afc-af8e-dbf6e9e86120",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1603",
    "licenseIssueDate": "12/16/2021 00:00:00",
    "licenseExpiryDate": "12/15/2025 00:00:00"
  },
  {
    "id": "48356254-8feb-4129-ad7b-731865b4f4fc",
    "slug": "salha-khudaim-mubarak-aljabri-aljasmi",
    "name": "SALHA KHUDAIM MUBARAK KHUDAIM ALJABRI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/09/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Salha Khudaim Mubarak Aljabri Aljasmi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_48356254-8feb-4129-ad7b-731865b4f4fc",
        "address": "Mohamed Ali Saeed Humaid Al Kheyaili  ,Seventh Floor  ,Al Masaood Tower 2 ,Al Tadawi Medical Centre  ,88314 ,Dubai",
        "phone": "97142989662",
        "email": "info@mkladvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "ec23636d-f937-474e-b86d-d7470fbb385b",
    "firmName": "SALHA HUDAIM ALJABRI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-970",
    "licenseIssueDate": "09/21/2014 00:00:00",
    "licenseExpiryDate": "09/20/2026 00:00:00"
  },
  {
    "id": "6a84efc7-71a7-43f7-aa8e-f576fac1c3ea",
    "slug": "salim-hadeed-obaid-gharib-al-khamisi",
    "name": "SALIM HADEED OBAID GHARIB ALKHAMISI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/11/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Salim Hadeed Obaid Gharib Al Khamisi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6a84efc7-71a7-43f7-aa8e-f576fac1c3ea",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-977",
    "licenseIssueDate": "11/10/2014 00:00:00",
    "licenseExpiryDate": "11/09/2025 00:00:00"
  },
  {
    "id": "e38c58e7-c54e-4c2f-9f25-655df1c85c39",
    "slug": "salim-khamis-salim-almamari",
    "name": "Salim Khamis Salim Almamari",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/19/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Salim Khamis Salim Almamari",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e38c58e7-c54e-4c2f-9f25-655df1c85c39",
        "address": "",
        "phone": "97142949937",
        "email": "info@rslawyers.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "d544ee54-219a-446f-86c7-d6f4d1b1588c",
    "firmName": "REEM SALEH ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "832",
    "licenseIssueDate": "09/19/2012 00:00:00",
    "licenseExpiryDate": "09/18/2026 00:00:00"
  },
  {
    "id": "114c8465-f5f2-405d-90cb-d71c4db548fd",
    "slug": "salma-hamad-saoud-almaamri",
    "name": "SALMA HAMAD SAOD SALEM AL MOAMMERA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Cases and Proceedings before Dubai International Financial Centre",
      "Personal Status-Wills",
      "Civil Transactions-Ownership & Title",
      "Civil Transactions-HR & Employee Affairs",
      "Criminal Law-Family Crimes",
      "Personal Status-Custody & Alimony",
      "Civil Transactions-Arbitration",
      "Civil Transactions-Tenancy",
      "Criminal Law-Crimes against persons",
      "Commercial Transactions-Consumer protection",
      "Personal Status-Marriage & Divorce",
      "Personal Status-Child Abuse & Abduction",
      "Criminal Law-Crimes against properties",
      "Commercial Transactions-Intellectual Property (includes trademarks",
      "copy rights",
      "patents)",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/04/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Salma Hamad Saoud ALmaamri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_114c8465-f5f2-405d-90cb-d71c4db548fd",
        "address": "MOHAMMED ABDULLA MOHSIN ABDURAHIM ALBREIKI ,406 ,ويست بيري ,برج خليفة ,220219 ,Dubai",
        "phone": "97145574529",
        "email": "d@albraikiadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "ef095fb8-c3b5-42bc-92fc-43528c870fe7",
    "firmName": "MOHAMMED ABDULLA ALBREIKE LEGAL CONSULTANTS",
    "registrationNumber": "L-1527",
    "licenseIssueDate": "04/27/2021 00:00:00",
    "licenseExpiryDate": "04/26/2026 00:00:00"
  },
  {
    "id": "aa87fbb1-c1ed-4f29-9d31-025c8fe92955",
    "slug": "salma-maher-mohammed-sawalmah",
    "name": "Salma Maher Mohammed Sawalmah",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/11/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Salma Maher Mohammed Sawalmah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_aa87fbb1-c1ed-4f29-9d31-025c8fe92955",
        "address": "الطابق الخامس ,الساحة ,سوق البحار ,26011 ,Dubai",
        "phone": "97142277717",
        "email": "info@alsahlawico.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "a6811a79-5470-4c33-ad95-3ff8f661c052",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-07083",
    "licenseIssueDate": "10/22/2024 00:00:00",
    "licenseExpiryDate": "10/21/2025 00:00:00"
  },
  {
    "id": "8dee213c-b5fc-484f-9843-08b0f9bca05b",
    "slug": "salma-mohamed-salem-shafi-almansoori",
    "name": "SALMA MOHAMED SALEM SHAFI ALMANSOORI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/06/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Salma Mohamed Salem Shafi Almansoori",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8dee213c-b5fc-484f-9843-08b0f9bca05b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1428",
    "licenseIssueDate": "06/29/2020 00:00:00",
    "licenseExpiryDate": "06/28/2026 00:00:00"
  },
  {
    "id": "c06a126b-8c6b-4018-b091-a46187f73118",
    "slug": "salma-rashed-khalfan-abad-almansoori",
    "name": "Salma Rashed Khalfan Abad ALMansoori",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/19/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Salma Rashed Khalfan Abad ALMansoori",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c06a126b-8c6b-4018-b091-a46187f73118",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "1937",
    "licenseIssueDate": "04/19/2024 00:00:00",
    "licenseExpiryDate": "04/18/2026 00:00:00"
  },
  {
    "id": "4027d1e3-9a07-47bd-9117-8865bb0dcc62",
    "slug": "salma-saeed-mohammed-albakr-alzaabi",
    "name": "salma saeed mohammed albakr alzaabi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/26/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: salma saeed mohammed albakr alzaabi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4027d1e3-9a07-47bd-9117-8865bb0dcc62",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "1635",
    "licenseIssueDate": "03/26/2022 00:00:00",
    "licenseExpiryDate": "03/25/2026 00:00:00"
  },
  {
    "id": "8efdcb50-f8b6-4cb9-8b25-208680caa079",
    "slug": "salma-saeed-mohammed-alquhoumi-alzeyoudi",
    "name": "SAEED MOHAMED KHAMIS",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/10/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Salma Saeed Mohammed Alquhoumi Alzeyoudi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8efdcb50-f8b6-4cb9-8b25-208680caa079",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1460",
    "licenseIssueDate": "10/07/2020 00:00:00",
    "licenseExpiryDate": "10/06/2026 00:00:00"
  },
  {
    "id": "6cbe99ed-04b2-4f96-a7c3-ebdda416ee3d",
    "slug": "salma-saeed-musabbeh-alketbi",
    "name": "SALMA SAEED W O HAMAD KH OMAIR",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/09/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Salma Saeed Musabbeh Alketbi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6cbe99ed-04b2-4f96-a7c3-ebdda416ee3d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1027",
    "licenseIssueDate": "09/07/2015 00:00:00",
    "licenseExpiryDate": "09/06/2026 00:00:00"
  },
  {
    "id": "691b5643-c7a2-4648-9602-d138bcd7efdf",
    "slug": "salma-shnain-obaid-salem-almazrooei",
    "name": "ABDULLA KHAMIS SAEED NASSER ALDHAHERI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/07/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: SALMA SHNAIN OBAID SALEM ALMAZROOEI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_691b5643-c7a2-4648-9602-d138bcd7efdf",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1833",
    "licenseIssueDate": "07/20/2023 00:00:00",
    "licenseExpiryDate": "07/19/2026 00:00:00"
  },
  {
    "id": "e743281d-0eb9-4a5a-a5f7-dafc6ffb4b60",
    "slug": "salman-lutfi-ali-husain",
    "name": "SALMAN LUTFI ALI HUSSAIN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 43,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/12/1981",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Salman Lutfi Ali Husain",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e743281d-0eb9-4a5a-a5f7-dafc6ffb4b60",
        "address": "1201 ,برج تريو اي بي اي اوفيس  ,فندق نوافتيل ,8812 ,Dubai",
        "phone": "97144222555",
        "email": "lutfilaw2020@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "9a3d884b-a443-4037-9eb4-f810c596cf33",
    "firmName": "LUTFI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-96",
    "licenseIssueDate": "12/13/1981 00:00:00",
    "licenseExpiryDate": "12/12/2025 00:00:00"
  },
  {
    "id": "ef0e170f-bbca-4ee1-9fa5-681ee3701465",
    "slug": "salman-mohamed-ahmad-mohamed-mahmood-altuweel",
    "name": "SALMAN MOHD AHMAD MOHD MAHMOOD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/04/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Salman Mohamed Ahmad Mohamed Mahmood Altuweel",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ef0e170f-bbca-4ee1-9fa5-681ee3701465",
        "address": "sohail jassem pararin ,34 ,Central Park Tower ,Dubai Mall ,233066 ,Dubai",
        "phone": "97144228410",
        "email": "info@mahmoodhussain.net",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "f3309481-3edd-4503-92d2-bd9f71ba513a",
    "firmName": "DR MAHMOOD HUSSAIN ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-1181",
    "licenseIssueDate": "04/30/2017 00:00:00",
    "licenseExpiryDate": "04/29/2026 00:00:00"
  },
  {
    "id": "727833a5-e9cf-4889-95ca-e4982ecada29",
    "slug": "salwa-hassan-ali",
    "name": "SALWA HASSAN W O HUMAID AHMED ALBALOOSHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/04/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: salwa hassan ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_727833a5-e9cf-4889-95ca-e4982ecada29",
        "address": "الطابق الثاني عشر - مكتب رقم 1203 ,برج سيتاديل ,مقابل فندق جي دبليو ماريوت ,91427 ,Dubai",
        "phone": "97143629899",
        "email": "md@imlawyeruae.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "6735fd57-e905-4af6-a113-cc1e784b2510",
    "firmName": "EBRAHIM MOOSA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-575",
    "licenseIssueDate": "04/24/2023 00:00:00",
    "licenseExpiryDate": "04/23/2026 00:00:00"
  },
  {
    "id": "da5d4f80-b7db-4eaf-b480-688fad9e94a9",
    "slug": "salwa-mohammad-mohammad-omar",
    "name": "SALWA MOHAMMAD MOHAMMAD OMAR",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/07/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Salwa Mohammad Mohammad Omar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_da5d4f80-b7db-4eaf-b480-688fad9e94a9",
        "address": "",
        "phone": "97148769883 / 971048769883",
        "email": "info@salwaadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "b6a5205a-5af5-4847-aeaa-7f6c924a8ea6",
    "firmName": "SALWA OMAR ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1203",
    "licenseIssueDate": "07/16/2017 00:00:00",
    "licenseExpiryDate": "07/15/2026 00:00:00"
  },
  {
    "id": "7795152b-e773-441b-85f1-edca504d6986",
    "slug": "samar-marwan-khalid-joha",
    "name": "SAMAR MARWAN KHALID JOHA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/11/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Samar Marwan Khalid Joha",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7795152b-e773-441b-85f1-edca504d6986",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1475",
    "licenseIssueDate": "11/09/2020 00:00:00",
    "licenseExpiryDate": "11/08/2025 00:00:00"
  },
  {
    "id": "be4e388e-6129-43d5-88fe-e533fcf1ec9e",
    "slug": "samar-raouf-tawfiq-murad",
    "name": "SAMAR RAOUF TAWFIQ MURAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/09/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Samar Raouf Tawfiq Murad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_be4e388e-6129-43d5-88fe-e533fcf1ec9e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1452",
    "licenseIssueDate": "09/14/2020 00:00:00",
    "licenseExpiryDate": "09/13/2026 00:00:00"
  },
  {
    "id": "b07e7e87-0726-44e0-9a94-230aed9b4b4d",
    "slug": "sameirah-saeed-salem-saeed-alabdouli",
    "name": "SAMEIRAH SAEED SALEM ALABDOULI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/04/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Sameirah Saeed Salem Saeed Alabdouli",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b07e7e87-0726-44e0-9a94-230aed9b4b4d",
        "address": "Mezzanine / 09 ,Business Point  ,Behind Nissan Showroom ,85825 ,Dubai",
        "phone": "97142595777",
        "email": "ALMATROOSHI@OMALC.AE",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "588c9e2f-4f09-44bb-9e80-4e56d3f821b6",
    "firmName": "ALOWAIS AND ALMATROOSHI ADVOCATE AND LEGAL CONSULTANTS",
    "registrationNumber": "L-1525",
    "licenseIssueDate": "04/18/2021 00:00:00",
    "licenseExpiryDate": "04/17/2026 00:00:00"
  },
  {
    "id": "842ae6ad-543e-4d58-84ba-83b091774b8d",
    "slug": "sami-jamal-yousuf-abdulrahman-alsawalhi",
    "name": "SAMI JAMAL YOUSUF ABDULRAHMAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/06/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Sami Jamal Yousuf Abdulrahman Alsawalhi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_842ae6ad-543e-4d58-84ba-83b091774b8d",
        "address": "",
        "phone": "97148818001",
        "email": "info@sqadvo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "54ec8975-566c-41d9-929c-bb8b3dbcca1e",
    "firmName": "SAMI ALSAWALHI ADVOCATES &LEGAL CONSULTANTS",
    "registrationNumber": "L-1293",
    "licenseIssueDate": "06/05/2018 00:00:00",
    "licenseExpiryDate": "06/04/2026 00:00:00"
  },
  {
    "id": "8920de0d-20b8-4aa4-894c-ef708aa40935",
    "slug": "sami-salim-mohammad-jasim-al-midfa",
    "name": "SAMI SALIM MOHAMED JASIM ALMIDFA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 28,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/05/1997",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Sami Salim Mohammad Jasim Al Midfa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8920de0d-20b8-4aa4-894c-ef708aa40935",
        "address": "10th Floor ,AlReem Tower ,Dubai Land Department ,32367 ,Dubai",
        "phone": "97142272701",
        "email": "midfaadv@eim.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "fe9068a7-b94d-49bb-88b3-6f8491a15389",
    "firmName": "AL MIDFA & ASSOCIATES",
    "registrationNumber": "L-297",
    "licenseIssueDate": "05/13/1997 00:00:00",
    "licenseExpiryDate": "05/12/2026 00:00:00"
  },
  {
    "id": "cd71131a-ae61-4dbc-9c39-f986974baa93",
    "slug": "samir-halim-kanaan",
    "name": "Samir Halim Kanaan",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 48,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/01/1977",
    "licenseStatus": "active",
    "licenseExpiry": "1978-01-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Samir Halim Kanaan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cd71131a-ae61-4dbc-9c39-f986974baa93",
        "address": "Samir Kanaan ,Office 502 Floor 5 ,Bay Square Building 11 ,South Ridge Apartments ,101 ,Dubai",
        "phone": "97142775444",
        "email": "info@kanlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "d0e51371-a813-49c7-a99e-641fda6bca77",
    "firmName": "KANAAN ADVOCATES& LEGAL CONSULTANTS",
    "registrationNumber": "44",
    "licenseIssueDate": "01/05/1977 00:00:00",
    "licenseExpiryDate": "01/04/2026 00:00:00"
  },
  {
    "id": "53aa6f15-a395-497c-a490-51024137f296",
    "slug": "samira-abdulla-ali-gargash",
    "name": "Samira Abdulla Ali Gargash",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 43,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/10/1981",
    "licenseStatus": "active",
    "licenseExpiry": "1982-10-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Samira Abdulla Ali Gargash",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_53aa6f15-a395-497c-a490-51024137f296",
        "address": "",
        "phone": "97144504430 / 97144504430",
        "email": "samira@samiragargash.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "195798f1-50a3-4188-9de2-ad54b9a70bb4",
    "firmName": "SAMIRA ABDULLA ALI GARGASH ADVOCATE AND LEGAL CONSULTANTS",
    "registrationNumber": "94",
    "licenseIssueDate": "10/24/1981 00:00:00",
    "licenseExpiryDate": "10/23/2025 00:00:00"
  },
  {
    "id": "62e8836f-fe91-485f-b932-933bd6e969b0",
    "slug": "samira-ismail-mohamed-ahmed-alzarooni",
    "name": "SAMIRA ISMAIL MOHAMED AHMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/09/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Samira Ismail Mohamed Ahmed Alzarooni",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_62e8836f-fe91-485f-b932-933bd6e969b0",
        "address": "samira ismail  ,الطابق التاسع - مكتب 902 ,برج سعيد 2 ,بنفس المبنى كنتاكي ,22223 ,Dubai",
        "phone": "97148873880 / 971585323296",
        "email": "info.zaroonilawyers@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "f31df5d9-3a8e-4129-a132-6bb30c924a15",
    "firmName": "SAMIRA ALZAROONI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-780",
    "licenseIssueDate": "09/13/2020 00:00:00",
    "licenseExpiryDate": "09/12/2026 00:00:00"
  },
  {
    "id": "ff8408d0-60ac-49d5-8836-fac201b7c3bf",
    "slug": "samya-saeed-mohammed-ayoob",
    "name": "SAMYA SAEED MOHAMMED AYOOB",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/09/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Samya Saeed Mohammed Ayoob",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ff8408d0-60ac-49d5-8836-fac201b7c3bf",
        "address": "",
        "phone": "97142200399 / 971971422003",
        "email": "info@ssjlawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "43903b58-f2e6-4825-beac-fd001ee7018a",
    "firmName": "SAMYA SAEED ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1382",
    "licenseIssueDate": "09/11/2019 00:00:00",
    "licenseExpiryDate": "09/10/2026 00:00:00"
  },
  {
    "id": "8a7b1dde-9598-41ec-9b63-a5da6de74588",
    "slug": "saoud-abdul-azeez-abdul-rahman-abdulla-al-qahtani",
    "name": "SAOUD ABDULL AZEEZ ABDUL RAHMAN ABDULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 18,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/01/2007",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: SAOUD ABDUL AZEEZ ABDUL RAHMAN ABDULLA AL QAHTANI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8a7b1dde-9598-41ec-9b63-a5da6de74588",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-584",
    "licenseIssueDate": "01/31/2007 00:00:00",
    "licenseExpiryDate": "01/30/2026 00:00:00"
  },
  {
    "id": "80b7bf20-2cab-4acf-b65f-6f96cf77af19",
    "slug": "saoud-mohd-abdulhameed-mohd",
    "name": "SAOUD MOHD ABDULHAMEED MOHAMMAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/01/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Saoud Mohd Abdulhameed Mohd",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_80b7bf20-2cab-4acf-b65f-6f96cf77af19",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1249",
    "licenseIssueDate": "01/25/2018 00:00:00",
    "licenseExpiryDate": "01/24/2026 00:00:00"
  },
  {
    "id": "0676f9c9-2885-4f1a-98d4-18a07ccc1aa4",
    "slug": "saoud-mubarak-saleh-shahball-altamimi",
    "name": "ABDULBASET ABDULLA HAMAD YOUSEF ALJNEIBI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/06/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Saoud Mubarak Saleh Shahball Altamimi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0676f9c9-2885-4f1a-98d4-18a07ccc1aa4",
        "address": "HASSAN ALI MATAR ALRIYAMI ,24 ,GRASVENOR BUSINESS TOWER ,NEEDS SUPERMARKET ,215880 ,Dubai",
        "phone": "97144534188",
        "email": "courts@alriyamiadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "a40a2f1f-69a9-429c-8086-dba9d985532b",
    "firmName": "ABDULBASET ABDULLA ALJNEIBI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1817",
    "licenseIssueDate": "06/21/2023 00:00:00",
    "licenseExpiryDate": "06/20/2026 00:00:00"
  },
  {
    "id": "7f02a425-2d07-4286-99cc-d6d483c85ffc",
    "slug": "saqer-ibrahim-saqer-almarzooqi",
    "name": "SAQER IBRAHIM SAQER ALMARZOOQI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/11/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-11-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: saqer Ibrahim saqer Almarzooqi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7f02a425-2d07-4286-99cc-d6d483c85ffc",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1597",
    "licenseIssueDate": "11/16/2021 00:00:00",
    "licenseExpiryDate": "11/15/2025 00:00:00"
  },
  {
    "id": "0f0db4df-a2d1-4645-98f1-5c7b5a898ffe",
    "slug": "sara-abdul-rahman-abdul-aziz-abdul-karim-aldosari",
    "name": "MONAWAHA SAADELDIN MERGHANI HASHIM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Commercial Agency",
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Civil Transactions-Insurance",
      "Personal Status-Wills",
      "Civil Transactions-Ownership & Title",
      "Civil Transactions-HR & Employee Affairs",
      "Commercial Transactions-Commercial Mortgage",
      "Criminal Law-Family Crimes",
      "Personal Status-Custody & Alimony",
      "Civil Transactions-Immigration and Residency",
      "Civil Transactions-Residential Real Estate",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Criminal Law-Hate crimes",
      "Civil Transactions-Tenancy",
      "Commercial Transactions-Unfair competition",
      "Criminal Law-Crimes against persons",
      "Personal Status-Legacies and Inheritance",
      "Commercial Transactions-Commercial Companies",
      "Civil Transactions-Labor & Workers",
      "Personal Status-Legal Capacity & Guardianship",
      "Criminal Law-Drug Crimes",
      "Civil Transactions-Sale",
      "Personal Status-Marriage & Divorce",
      "Personal Status-Child Abuse & Abduction",
      "Commercial Transactions-Stock",
      "Criminal Law-Crimes against properties",
      "Criminal Law-Cybercrimes",
      "Commercial Transactions-Intellectual Property (includes trademarks",
      "copy rights",
      "patents)",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/10/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Sara Abdul Rahman Abdul Aziz Abdul Karim Aldosari",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0f0db4df-a2d1-4645-98f1-5c7b5a898ffe",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1882",
    "licenseIssueDate": "11/07/2023 00:00:00",
    "licenseExpiryDate": "11/06/2025 00:00:00"
  },
  {
    "id": "b7995d3d-8c18-4142-8a47-5719b09764b9",
    "slug": "sara-abdulhamid-mohammad-ismail-alaskar",
    "name": "SARA ABDULHAMID MOHAMMAD ISMAIL ALASKAR",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/24/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: SARA ABDULHAMID MOHAMMAD ISMAIL ALASKAR",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b7995d3d-8c18-4142-8a47-5719b09764b9",
        "address": "",
        "phone": "97142830009",
        "email": "abakgulfconsultant@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "4ca62fa9-28fb-4024-84aa-9b82cccde1b5",
    "firmName": "GULF CONSULTANT ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "15921",
    "licenseIssueDate": "11/24/2021 00:00:00",
    "licenseExpiryDate": "11/23/2025 00:00:00"
  },
  {
    "id": "a14f71bf-71cb-4e0f-91de-800f31f97de5",
    "slug": "sara-abdulmunem-salem-bin-sowiadan-alsuwaidi",
    "name": "NASER MALALLA QASEM HASAN HUSAIN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/06/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Sara abdulmunem salem bin sowiadan alsuwaidi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a14f71bf-71cb-4e0f-91de-800f31f97de5",
        "address": "4 ,ALHUDIBA AWARD COMPLEX BLOCK B ,UNION FLAG HOUSE ,50229 ,Dubai",
        "phone": "97143258888 / 971501009595",
        "email": "hr@binsowaidan.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "36d64a1b-4461-4159-9965-ed44c59d3e88",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1815",
    "licenseIssueDate": "06/20/2023 00:00:00",
    "licenseExpiryDate": "06/19/2026 00:00:00"
  },
  {
    "id": "4e4a8677-f8b2-49e7-98c8-e1e266f452c4",
    "slug": "sara-abdulrahman-abdulhadi-mafrh-al-ahbabi",
    "name": "ABDULLA MOHAMED OBAID A.ALMAFTOOL AALALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/06/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Sara Abdulrahman Abdulhadi Mafrh Al Ahbabi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4e4a8677-f8b2-49e7-98c8-e1e266f452c4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1998",
    "licenseIssueDate": "06/28/2024 00:00:00",
    "licenseExpiryDate": "06/27/2026 00:00:00"
  },
  {
    "id": "efea4ee8-50c4-4bca-ae59-cfa4e55e872e",
    "slug": "sara-bader-mahfoudh-alhadhrami",
    "name": "SHUAIB MOHD AHMAD MATAR",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/06/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Sara Bader Mahfoudh Alhadhrami",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_efea4ee8-50c4-4bca-ae59-cfa4e55e872e",
        "address": "OBAID SAQER OBAID BUSIT ,20 ,Grosvenor Business Tower -  ,Sheikha noora tower ,333341 ,Dubai",
        "phone": "97144472777",
        "email": "busit@busitlegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "ebfce11b-8cb4-42cc-95d3-71c6e17bfdf0",
    "firmName": "AHMAD ABDULLA AHLI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1828",
    "licenseIssueDate": "07/12/2023 00:00:00",
    "licenseExpiryDate": "07/11/2026 00:00:00"
  },
  {
    "id": "e89ca6b8-09ae-4a5f-88b2-34cb32d2ec98",
    "slug": "sara-ebrahim-hasan-saleh-aldhefairi",
    "name": "HASSAN ABDULLA MOHAMED BIN E. ALEGHFELI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/09/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Sara Ebrahim Hasan Saleh Aldhefairi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e89ca6b8-09ae-4a5f-88b2-34cb32d2ec98",
        "address": "Office No. 211 ,Al Wasl Building ,Makani No: 2479487549 ,000 ,Dubai",
        "phone": "97142733476 / 97142733476",
        "email": "abo_sultan_s@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "ba81cc15-7448-4103-91bf-70c7e3f12812",
    "firmName": "ABDULLA MOHAMMED RASOUL ALHARMOODI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-2029",
    "licenseIssueDate": "09/26/2024 00:00:00",
    "licenseExpiryDate": "09/25/2026 00:00:00"
  },
  {
    "id": "e4491fb1-77e6-4775-9989-182239761afc",
    "slug": "sara-ghulam-rasool-mohamad-othman",
    "name": "RAJA ABDALLA HAMAD ALHADFI ALKTEBI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/01/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: SARA GHULAM RASOOL MOHAMAD OTHMAN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e4491fb1-77e6-4775-9989-182239761afc",
        "address": "",
        "phone": "97143348481",
        "email": "lawyers@maidor.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "a48d1666-6ca7-461a-8197-a892ef0f3545",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1756",
    "licenseIssueDate": "02/09/2023 00:00:00",
    "licenseExpiryDate": "02/08/2026 00:00:00"
  },
  {
    "id": "6f7abd85-24b4-4008-bcdf-3fdad1209cea",
    "slug": "sara-hasan-easa-ali-alblooshi",
    "name": "YOUSUF ABDULRAHIM AHMAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/05/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: sara hasan easa ali alblooshi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6f7abd85-24b4-4008-bcdf-3fdad1209cea",
        "address": "",
        "phone": "97143333386 / 971549916936",
        "email": "info@mtaadv.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "466f3ad4-73e1-44db-b8ec-b01e829d77c4",
    "firmName": "KHADIJAH SOHAIL ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1968",
    "licenseIssueDate": "05/27/2024 00:00:00",
    "licenseExpiryDate": "05/26/2026 00:00:00"
  },
  {
    "id": "9dfa2dbe-7635-4a37-a229-8cef30f54b06",
    "slug": "sara-helal-sulaiman-salem-alsaedi",
    "name": "Sara Helal Sulaiman Salem Alsaedi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/30/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Sara Helal Sulaiman Salem Alsaedi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9dfa2dbe-7635-4a37-a229-8cef30f54b06",
        "address": "",
        "phone": "97150399980 / 971501547188",
        "email": "advocatesaraalsaedi@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "c1be7ace-26d4-45ed-8292-e5992286f1ef",
    "firmName": "Sara Alsaedi Advocates and Legal Consultants",
    "registrationNumber": "1671",
    "licenseIssueDate": "06/30/2022 00:00:00",
    "licenseExpiryDate": "06/29/2026 00:00:00"
  },
  {
    "id": "ce9fa1e6-699e-436e-9683-21831e76b79c",
    "slug": "sara-hussain-mohammad-saleh-alyasi",
    "name": "HUSSAIN MOHAMMAD SALEH ALYASI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/06/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Sara Hussain Mohammad Saleh Alyasi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ce9fa1e6-699e-436e-9683-21831e76b79c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1294",
    "licenseIssueDate": "06/24/2018 00:00:00",
    "licenseExpiryDate": "06/23/2026 00:00:00"
  },
  {
    "id": "d5a47d0b-c80d-4e1f-aa16-cda8a1953fa9",
    "slug": "sara-ibrahim-ali-ahmed",
    "name": "SARA IBRAHIM ALI AHMAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/07/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Sara Ibrahim Ali Ahmed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d5a47d0b-c80d-4e1f-aa16-cda8a1953fa9",
        "address": "sara ibrahim  ,m1 ,ملك محمد عتيق احمد المري ,شارع المركاض ,14049 ,Dubai",
        "phone": "97142545233 / 971554080104",
        "email": "info@thecounsels.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "f859d6ac-c6c4-4800-9053-0586a66732d2",
    "firmName": "SARA IBRAHIM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1097",
    "licenseIssueDate": "07/19/2016 00:00:00",
    "licenseExpiryDate": "07/18/2026 00:00:00"
  },
  {
    "id": "1166abc0-69bd-4b10-8789-a783c0fbaa3a",
    "slug": "sara-juma-saeed-khalifa-alkaabi",
    "name": "ZAYED MATAR KHAMIS KHALFAN ALMAZROUEI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Commercial Agency",
      "Proceedings-Cases and Proceedings before Dubai International Financial Centre",
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Civil Transactions-POA & Sponsorship",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Civil Transactions-Insurance",
      "Personal Status-Wills",
      "Civil Transactions-Construction and Contracts for Services",
      "Civil Transactions-Ownership & Title",
      "Civil Transactions-HR & Employee Affairs",
      "Commercial Transactions-Commercial Mortgage",
      "Criminal Law-Family Crimes",
      "Commercial Transactions-Commercial Contracts",
      "Civil Transactions-Immigration and Residency",
      "Commercial Transactions-Bankruptcy",
      "Commercial Transactions-Commercial Real Estate",
      "Civil Transactions-Residential Real Estate",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Civil Transactions-Arbitration",
      "Criminal Law-Hate crimes",
      "Civil Transactions-Tenancy",
      "Commercial Transactions-Unfair competition",
      "Criminal Law-Crimes against persons",
      "Personal Status-Legacies and Inheritance",
      "Commercial Transactions-Commercial Companies",
      "Civil Transactions-Labor & Workers",
      "Personal Status-Legal Capacity & Guardianship",
      "Criminal Law-Drug Crimes",
      "Civil Transactions-Sale",
      "Commercial Transactions-Sea and air freight",
      "Proceedings-Cases and Proceedings before arbitral tribunals and other alternative dispute resolution bodies",
      "Commercial Transactions-Consumer protection",
      "Personal Status-Marriage & Divorce",
      "Personal Status-Child Abuse & Abduction",
      "Commercial Transactions-Stock",
      "Criminal Law-Crimes against properties",
      "Commercial Transactions-E-Commerce",
      "Criminal Law-Cybercrimes",
      "Commercial Transactions-Intellectual Property (includes trademarks",
      "copy rights",
      "patents)",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/10/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: sara juma saeed khalifa alkaabi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1166abc0-69bd-4b10-8789-a783c0fbaa3a",
        "address": "ABDULRAHMAN MOHAMED ALAAMRI ,306 ,ACICO BUISINESS PARK ,NISSAN SHOW ROOM ,33731 ,Dubai",
        "phone": "97148819818 / 971503933245",
        "email": "info@alaamri.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "bf13bfd5-9c31-447d-a1f6-1939ed8ab235",
    "firmName": "ZAYED ALMAZROUEI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1714",
    "licenseIssueDate": "11/03/2022 00:00:00",
    "licenseExpiryDate": "11/02/2025 00:00:00"
  },
  {
    "id": "8d0331e3-fca9-4561-ab2f-0fd51edbc6ef",
    "slug": "sara-mohamed-saleh-salem-alhamed",
    "name": "HUMAID ALI GHULAM ABBAS ASHKANANI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/08/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Sara Mohamed Saleh Salem Alhamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8d0331e3-fca9-4561-ab2f-0fd51edbc6ef",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1700",
    "licenseIssueDate": "09/22/2022 00:00:00",
    "licenseExpiryDate": "09/21/2026 00:00:00"
  },
  {
    "id": "7da583bb-c2a5-4340-888a-deb72404b330",
    "slug": "sara-shah-baik-mohamad-albaloushi",
    "name": "SARA SHAH BAIK MOHAMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/01/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Sara Shah Baik Mohamad Albaloushi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7da583bb-c2a5-4340-888a-deb72404b330",
        "address": "Sara Shah Baik Elbloshi ,الطابق 13 - مكتب 1306 ,CLOVER BAY ,بجوار SONDER HOTEL ,112773 ,Dubai",
        "phone": "97143514666",
        "email": "admin@saraadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "9271d191-2f3e-4570-93bf-34fb919bf6e0",
    "firmName": "SARA ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-850",
    "licenseIssueDate": "01/30/2013 00:00:00",
    "licenseExpiryDate": "01/29/2026 00:00:00"
  },
  {
    "id": "f5b83ae2-25da-49c7-bfcb-e301b3e98edb",
    "slug": "sara-yousif-ahmed-abdalla",
    "name": "YOUSIF SALIM ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/05/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Sara Yousif Ahmed Abdalla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f5b83ae2-25da-49c7-bfcb-e301b3e98edb",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1969",
    "licenseIssueDate": "05/27/2024 00:00:00",
    "licenseExpiryDate": "05/26/2026 00:00:00"
  },
  {
    "id": "1b15a9d5-1564-45ce-adfa-62321117fe82",
    "slug": "sarah-abdulla-ghanem-ahmed-abdulqader",
    "name": "Sarah Abdulla Ghanem Ahmed Abdulqader",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/19/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Sarah Abdulla Ghanem Ahmed Abdulqader",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1b15a9d5-1564-45ce-adfa-62321117fe82",
        "address": "",
        "phone": "97142775444 / 971507886668",
        "email": "info@abdlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "ad6c697f-ac72-4c32-a757-7cd13a6fcd3f",
    "firmName": "ABDULLA ALOBEIDLI ADVOCATES &LEGAL CONSULTANT",
    "registrationNumber": "1196",
    "licenseIssueDate": "06/19/2017 00:00:00",
    "licenseExpiryDate": "06/18/2026 00:00:00"
  },
  {
    "id": "b14e27ce-645e-4780-b817-cc3ec0c7d4b5",
    "slug": "sarah-mohammed-ahmed-nusairi",
    "name": "SARAH MOHAMMED AHMED JAFAR NUSAIRI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/11/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-11-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Sarah Mohammed Ahmed Nusairi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b14e27ce-645e-4780-b817-cc3ec0c7d4b5",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1392",
    "licenseIssueDate": "11/19/2019 00:00:00",
    "licenseExpiryDate": "11/18/2025 00:00:00"
  },
  {
    "id": "d8dccb8c-f58a-4196-a022-a3a39f935b3d",
    "slug": "sarah-yousef-abdulrahman-albaqishi-alabdouli",
    "name": "Sarah Yousef Abdulrahman Albaqishi Alabdouli",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/01/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Sarah Yousef Abdulrahman Albaqishi Alabdouli",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d8dccb8c-f58a-4196-a022-a3a39f935b3d",
        "address": "",
        "phone": "",
        "email": "albaqishilaw@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "d0aa88d9-03fd-49f6-83da-bce7d0e19a17",
    "firmName": "SARAH ALBAQISHI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "1107",
    "licenseIssueDate": "09/01/2016 00:00:00",
    "licenseExpiryDate": "08/31/2026 00:00:00"
  },
  {
    "id": "1220d79f-af73-4d5e-8f91-4a217756543d",
    "slug": "sarhan-hassan-mohamed-hassan-almuaini",
    "name": "SARHAN HASSAN MOHAMED HASSAN ALMUAINI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/03/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Sarhan Hassan Mohamed Hassan Almuaini",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1220d79f-af73-4d5e-8f91-4a217756543d",
        "address": "Sarhan Hassan Mohamed Hassan Almuaini ,Office 1002, Level 10 ,THE OBEROI CENTRE ,Business Bay Metro Station ,1169 ,Dubai",
        "phone": "97142324000",
        "email": "info@drsarhanlawyer.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "14541022-bde4-43ab-9ba1-489e87187b42",
    "firmName": "DR SARHAN ALMUAINI ADVOCATE AND LEGAL CONSULTANT",
    "registrationNumber": "L-1155",
    "licenseIssueDate": "03/13/2017 00:00:00",
    "licenseExpiryDate": "03/12/2026 00:00:00"
  },
  {
    "id": "213f8452-c510-40ba-8962-e437d696de81",
    "slug": "saud-abdelrahman-mohamed-balhaj-almarashda",
    "name": "ABDELRAHMAN MOHAMED BALHAJ",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/07/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2022-06-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Saud Abdelrahman Mohamed Balhaj Almarashda",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_213f8452-c510-40ba-8962-e437d696de81",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1295",
    "licenseIssueDate": "07/02/2018 00:00:00",
    "licenseExpiryDate": "07/01/2022 00:00:00"
  },
  {
    "id": "f04da92e-df94-4f49-83c0-5b90b71b2db3",
    "slug": "saud-abdulaziz-abdulla-al-zarooni",
    "name": "SAUD ABDULAZIZ ABDULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 22,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/01/2003",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Saud Abdulaziz Abdulla Al Zarooni",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f04da92e-df94-4f49-83c0-5b90b71b2db3",
        "address": "ادارة ا لمبنى  ,الريم ,الاتصالات  ,42423 ,Dubai",
        "phone": "97142222066",
        "email": "info@ozleco.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "7a155f4a-20ec-44ff-863f-4f9fb43d0af4",
    "firmName": "ALOBAIDLI & ALZAROONI ADVOCATES&LEGAL CONSULTANTS",
    "registrationNumber": "L-441",
    "licenseIssueDate": "01/19/2003 00:00:00",
    "licenseExpiryDate": "01/18/2026 00:00:00"
  },
  {
    "id": "2fd88bc6-9297-4001-9ad1-b0fb9c7cdaed",
    "slug": "saud-ahmed-abdelkarim-ismail-alzarooni",
    "name": "SAUD AHMED ABDELKARIM ISMAIL ALZAROONI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/11/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Saud Ahmed Abdelkarim Ismail Alzarooni",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2fd88bc6-9297-4001-9ad1-b0fb9c7cdaed",
        "address": "SAUD AHMED ,الاول  مكتب 115 ,مكاتب عود ميثاء ,مقابل فندق رافلز  وخلف بناية ستي بنك  ,47700 ,Dubai",
        "phone": "97145476944 / 97142350070",
        "email": "info@salzarooni.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "3885e377-9074-4ec7-bbae-db808d2d27b8",
    "firmName": "SAUD ALZAROONI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1323",
    "licenseIssueDate": "11/13/2018 00:00:00",
    "licenseExpiryDate": "11/12/2025 00:00:00"
  },
  {
    "id": "38557785-ed03-40a9-bb46-676239c97dbe",
    "slug": "saud-sultan-hamad-alshebli",
    "name": "SAUD SULTAN HAMAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/01/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Saud Sultan Hamad Alshebli",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_38557785-ed03-40a9-bb46-676239c97dbe",
        "address": "SAUD SULTAN HAMAD ,1st Floor ,AL GARHOOD BUSINESS CENTER ,Al Garhoud Medical Fitness Center ,21785 ,Dubai",
        "phone": "97143331110 / 971551127667",
        "email": "info@alshebliadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "b3f35be9-7673-4d3f-954b-6f64de96bc2b",
    "firmName": "SAUD AL SHEBLI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1334",
    "licenseIssueDate": "01/21/2019 00:00:00",
    "licenseExpiryDate": "01/20/2026 00:00:00"
  },
  {
    "id": "1f8dd78a-c926-45e0-90e1-d47ee5eaf15f",
    "slug": "sendeyyah-ali-salem-hassan-alhantoobi",
    "name": "SENDEYYAH ALI SALEM HASSAN ALHANTOOBI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Personal Status-Wills",
      "Criminal Law-Family Crimes",
      "Personal Status-Custody & Alimony",
      "Commercial Transactions-Commercial Contracts",
      "Civil Transactions-Residential Real Estate",
      "Criminal Law-Crimes against persons",
      "Personal Status-Legacies and Inheritance",
      "Civil Transactions-Labor & Workers",
      "Criminal Law-Drug Crimes",
      "Personal Status-Marriage & Divorce",
      "Civil Transactions-Compensation",
      "Criminal Law-Crimes against properties",
      "Criminal Law-Cybercrimes",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/06/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Sendeyyah Ali Salem Hassan Alhantoobi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1f8dd78a-c926-45e0-90e1-d47ee5eaf15f",
        "address": "Second Floor - Office No. 202 ,Union Building ,Makani No: 3234793883 ,000 ,Dubai",
        "phone": "97140000000 / 971569848432",
        "email": "info@advsendeyyah.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "51a05ad7-acb3-4d1a-9ec9-658d683dc4dc",
    "firmName": "SENDEYYAH ALHANTOOBI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1292",
    "licenseIssueDate": "06/05/2018 00:00:00",
    "licenseExpiryDate": "06/04/2026 00:00:00"
  },
  {
    "id": "b8e6446e-5d80-49ee-9138-cdd361f3757e",
    "slug": "shahad-yousif-abdelghaffar-abudulrahman-al-sharif",
    "name": "ALYAZIA SUHAIL HAREB ZUWAID ALNUAIMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/04/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: shahad yousif abdelghaffar abudulrahman al sharif",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b8e6446e-5d80-49ee-9138-cdd361f3757e",
        "address": "",
        "phone": "97142566660",
        "email": "dlr@ysalc.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "28be4513-86ae-4602-b4cc-8d52ba959e9e",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1654",
    "licenseIssueDate": "05/20/2022 00:00:00",
    "licenseExpiryDate": "05/19/2026 00:00:00"
  },
  {
    "id": "a059db4a-ccb8-499f-90d3-40bb0e0acf90",
    "slug": "shahd-ibrahim-abdallah-adish-almaazmi",
    "name": "SHAHD IBRAHIM ABDALLA ADEESH ALMAAZMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/04/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Shahd Ibrahim Abdallah Adish almaazmi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a059db4a-ccb8-499f-90d3-40bb0e0acf90",
        "address": "الطابق الثالث ,بناية مكاتب عود ميثاء ,سيتي بانك ,78853 ,Dubai",
        "phone": "97142220585 / 971506555166",
        "email": "info@kasadv.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "ec4ada87-49a0-432b-a843-e47adccd286f",
    "firmName": "KHALIFA ALSADA ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-1354",
    "licenseIssueDate": "04/03/2019 00:00:00",
    "licenseExpiryDate": "04/02/2026 00:00:00"
  },
  {
    "id": "1c6d282c-9b2e-424b-b328-372482ddd806",
    "slug": "shaikh-ali-jamal-bin-naser-bin-rashed-al-nuaimi",
    "name": "ABDULLA MAHDI FAHED BADI ALATIBI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/11/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Shaikh Ali Jamal Bin Naser Bin Rashed Al Nuaimi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1c6d282c-9b2e-424b-b328-372482ddd806",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-2050",
    "licenseIssueDate": "12/04/2024 00:00:00",
    "licenseExpiryDate": "12/03/2025 00:00:00"
  },
  {
    "id": "4520c3ff-494b-47f2-8d0c-2dd9d2ce7402",
    "slug": "shaikha-abdulla-rashid-juma-al-shamsi",
    "name": "SHAIKHA ABDULLA RASHED JUMA ALSHAMSI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Criminal Law-Cybercrimes",
      "Civil Transactions-Arbitration",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/10/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Shaikha Abdulla Rashid Juma Al Shamsi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4520c3ff-494b-47f2-8d0c-2dd9d2ce7402",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1576",
    "licenseIssueDate": "10/07/2021 00:00:00",
    "licenseExpiryDate": "10/06/2026 00:00:00"
  },
  {
    "id": "4ae11e89-8231-47c9-a56f-8bd7944e602a",
    "slug": "shaikha-ahmed-abdulla-sultan",
    "name": "SHAIKHA AHMED ABDULLA SULTAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 15,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/19/2010 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: SHAIKHA AHMED ABDULLA SULTAN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4ae11e89-8231-47c9-a56f-8bd7944e602a",
        "address": "مكتب رقم 403 – 504 - 102 ,القرن الواحد وعشرون ,مركز القبائل للتخفيضات ,68441 ,Dubai",
        "phone": "97142388763",
        "email": "shaikha.advo@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "80a47f20-166e-40d9-9dea-d793f4708270",
    "firmName": "SHAIKHA AHMAD ADVOCATES&LEGAL CONSULTANTS",
    "registrationNumber": "717",
    "licenseIssueDate": "07/19/2010 00:00:00",
    "licenseExpiryDate": "07/18/2026 00:00:00"
  },
  {
    "id": "ea75b7aa-239e-42b5-9e94-beeef74069fb",
    "slug": "shaikha-ali-hamad-bin-afid-alqaydi",
    "name": "SHAIKHA ALI HAMAD BIN AFID ALQAYDI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/30/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: SHAIKHA ALI HAMAD BIN AFID ALQAYDI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ea75b7aa-239e-42b5-9e94-beeef74069fb",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "1343",
    "licenseIssueDate": "10/30/2023 00:00:00",
    "licenseExpiryDate": "10/29/2025 00:00:00"
  },
  {
    "id": "a80ef095-7f65-479e-9f70-ef82805d8309",
    "slug": "shaikha-ali-omar-abubaker-alzubaidi",
    "name": "SHAIKHA ALI OMAR ABUBAKR ALZBEIDI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/01/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Shaikha Ali Omar Abubaker Alzubaidi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a80ef095-7f65-479e-9f70-ef82805d8309",
        "address": "Ahmed Saleh Abulla Khamis ALramsi ,1305 ,Fairmont Dubai ,Burj Khalifa ,77857 ,Dubai",
        "phone": "97142720066",
        "email": "info@alramsyadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "b84458c4-4c08-4fa7-8fd9-05b8787d4896",
    "firmName": "DR.AHMED ALRAMSY LAWYERS & CONSULTANTS",
    "registrationNumber": "L-1491",
    "licenseIssueDate": "01/06/2021 00:00:00",
    "licenseExpiryDate": "01/05/2026 00:00:00"
  },
  {
    "id": "c6ea64a6-8ebf-479e-b847-c2f0a221493c",
    "slug": "shaikha-amer-saif-mohammed-alalawi",
    "name": "SHAIKHA AMER SAIF MOHAMMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/12/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: SHAIKHA AMER SAIF MOHAMMED ALALAWI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c6ea64a6-8ebf-479e-b847-c2f0a221493c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1486",
    "licenseIssueDate": "12/15/2020 00:00:00",
    "licenseExpiryDate": "12/14/2025 00:00:00"
  },
  {
    "id": "3c87e80a-14b7-4571-8d91-396b5ebfa20b",
    "slug": "shaikha-ghaleb-mohammed-saeed-almansoo",
    "name": "MOHAMED HASSAN GHULOUM AHMED ALHAMMADI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/02/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: SHAIKHA GHALEB MOHAMMED SAEED ALMANSOO",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3c87e80a-14b7-4571-8d91-396b5ebfa20b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-2073",
    "licenseIssueDate": "02/20/2025 00:00:00",
    "licenseExpiryDate": "02/19/2026 00:00:00"
  },
  {
    "id": "638ba059-0dd8-42b8-902b-d559ae11a9d2",
    "slug": "shaikha-mohammed-saif-ali-al-mehrzi",
    "name": "SHAIKHA MOHAMMED SAIF ALI ALMEHRZI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/05/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Shaikha Mohammed Saif Ali Al Mehrzi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_638ba059-0dd8-42b8-902b-d559ae11a9d2",
        "address": "TAMER YASER ALFAYAD  ,9 ,THE H HOTEL - COMPLEX ,THE H HOTEL ,72281 ,Dubai",
        "phone": "97143517909",
        "email": "dubai@lawhouse.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "a63e5f0c-ffcb-4321-8f10-96802ff52a3e",
    "firmName": "SHAIKHA ALMEHRZI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-875",
    "licenseIssueDate": "05/27/2013 00:00:00",
    "licenseExpiryDate": "05/26/2026 00:00:00"
  },
  {
    "id": "5c0e2aef-da7f-444b-800b-2a01c203b447",
    "slug": "shaikha-mohmmed-ibrahim-rashed-alghumlasi",
    "name": "MOHAMED IBRAHIM ABDULJABAR MOHAMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Commercial Agency",
      "Proceedings-Cases and Proceedings before Dubai International Financial Centre",
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Civil Transactions-POA & Sponsorship",
      "Civil Transactions-Insurance",
      "Personal Status-Wills",
      "Civil Transactions-Construction and Contracts for Services",
      "Civil Transactions-Ownership & Title",
      "Civil Transactions-HR & Employee Affairs",
      "Commercial Transactions-Commercial Mortgage",
      "Criminal Law-Family Crimes",
      "Personal Status-Custody & Alimony",
      "Commercial Transactions-Commercial Contracts",
      "Civil Transactions-Immigration and Residency",
      "Commercial Transactions-Bankruptcy",
      "Commercial Transactions-Commercial Real Estate",
      "Civil Transactions-Residential Real Estate",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Civil Transactions-Arbitration",
      "Civil Transactions-Tenancy",
      "Commercial Transactions-Unfair competition",
      "Criminal Law-Crimes against persons",
      "Personal Status-Legacies and Inheritance",
      "Commercial Transactions-Commercial Companies",
      "Commercial Transactions-Banking Operations",
      "Civil Transactions-Labor & Workers",
      "Personal Status-Legal Capacity & Guardianship",
      "Criminal Law-Drug Crimes",
      "Civil Transactions-Sale",
      "Commercial Transactions-Sea and air freight",
      "Proceedings-Cases and Proceedings before arbitral tribunals and other alternative dispute resolution bodies",
      "Commercial Transactions-Consumer protection",
      "Personal Status-Marriage & Divorce",
      "Personal Status-Child Abuse & Abduction",
      "Civil Transactions-Compensation",
      "Commercial Transactions-Stock",
      "Criminal Law-Crimes against properties",
      "Commercial Transactions-E-Commerce",
      "Criminal Law-Cybercrimes",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/06/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: shaikha mohmmed ibrahim rashed alghumlasi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5c0e2aef-da7f-444b-800b-2a01c203b447",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1994",
    "licenseIssueDate": "06/27/2024 00:00:00",
    "licenseExpiryDate": "06/26/2026 00:00:00"
  },
  {
    "id": "0ab899ed-0e8e-4191-a9f8-626a1f7d9067",
    "slug": "shaikha-nooh-mohammed-buhumaid-altamimi",
    "name": "SHAIKHA NOOH MOHAMMED BUHUMAID ALTAMIMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/05/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Shaikha Nooh Mohammed Buhumaid Altamimi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0ab899ed-0e8e-4191-a9f8-626a1f7d9067",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1083",
    "licenseIssueDate": "05/29/2016 00:00:00",
    "licenseExpiryDate": "05/28/2026 00:00:00"
  },
  {
    "id": "77d85c5a-e177-4166-b9e3-9cde30a7a69b",
    "slug": "shaikha-saif-obaid-al-kindi",
    "name": "shaikha saif obaid al kindi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/16/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: shaikha saif obaid al kindi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_77d85c5a-e177-4166-b9e3-9cde30a7a69b",
        "address": "مكتب رقم 403 – 504 - 102 ,القرن الواحد وعشرون ,مركز القبائل للتخفيضات ,68441 ,Dubai",
        "phone": "97142388763",
        "email": "shaikha.advo@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "80a47f20-166e-40d9-9dea-d793f4708270",
    "firmName": "SHAIKHA AHMAD ADVOCATES&LEGAL CONSULTANTS",
    "registrationNumber": "1625",
    "licenseIssueDate": "02/16/2022 00:00:00",
    "licenseExpiryDate": "02/15/2026 00:00:00"
  },
  {
    "id": "06160b9f-605a-4914-90c8-0bbc9af1c198",
    "slug": "shaikha-salem-nassib-mubarak-al-neyadi",
    "name": "LAYLA MHAMMED AHMED TOUEI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/02/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: shaikha salem nassib mubarak al neyadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_06160b9f-605a-4914-90c8-0bbc9af1c198",
        "address": "",
        "phone": "97144470190",
        "email": "maged.elfawal@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "c8fbcee3-eac8-43ed-8cea-d0c5483a5ae1",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1760",
    "licenseIssueDate": "02/13/2023 00:00:00",
    "licenseExpiryDate": "02/12/2026 00:00:00"
  },
  {
    "id": "76e38ad4-5923-43e2-94d5-45ab15f1f2ea",
    "slug": "shaikha-saqer-saif-saleh-almansoori",
    "name": "SHAIKHA SAQER SAIF SALEH ALMANSOORI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/05/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Shaikha Saqer Saif Saleh Almansoori",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_76e38ad4-5923-43e2-94d5-45ab15f1f2ea",
        "address": "",
        "phone": "97143333040 / 971000000000",
        "email": "info@ssm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "89bb61d6-b0b9-4316-8983-c9a88f94a1e8",
    "firmName": "SHAIKHA SAQER ALMANSOORI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1192",
    "licenseIssueDate": "05/21/2017 00:00:00",
    "licenseExpiryDate": "05/20/2026 00:00:00"
  },
  {
    "id": "98af69c5-e0de-4817-9c83-143f360d728e",
    "slug": "shaikhah-saeed-salem-saeed",
    "name": "SARA HASAN EASA A HUSAIN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/05/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: shaikhah saeed salem saeed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_98af69c5-e0de-4817-9c83-143f360d728e",
        "address": "",
        "phone": "97100000000",
        "email": "dubai@ahlegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "eae5fb25-fd19-436c-8668-3ac309424db4",
    "firmName": "MOHAMMED ALLINJAWI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1974",
    "licenseIssueDate": "05/31/2024 00:00:00",
    "licenseExpiryDate": "05/30/2026 00:00:00"
  },
  {
    "id": "6b3d2691-107e-4d89-9f9b-ad5c01c1ef8a",
    "slug": "shaima-abdulla-abdo-saeed-alazazi",
    "name": "MOHAMED ABDULRAHMAN ABDULAZEEZ ABDULRAHMAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/06/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: SHAIMA ABDULLA ABDO SAEED ALAZAZI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6b3d2691-107e-4d89-9f9b-ad5c01c1ef8a",
        "address": "13 ,Le Solarium Tower ,Arabian Gate ,185430 ,Dubai",
        "phone": "97145805135 / 971558703836",
        "email": "info@alnaqbilaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "24f8f7c8-a688-4587-9e87-f3105a99533a",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1995",
    "licenseIssueDate": "06/27/2024 00:00:00",
    "licenseExpiryDate": "06/26/2026 00:00:00"
  },
  {
    "id": "d4d0173b-1ef9-481e-a472-773580a2e25b",
    "slug": "shaima-ghanim-saeed-khalfan-alkaabi",
    "name": "GHANIM SAEED KHALFAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/08/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: SHAIMA GHANIM SAEED KHALFAN ALKAABI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d4d0173b-1ef9-481e-a472-773580a2e25b",
        "address": "الطابق الثامن ,بزنس افنيو ,فندق الخوري سكاي جاردن  ,126510 ,Dubai",
        "phone": "97142572778",
        "email": "zakia@houseofj.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "80c1d0d8-bc34-4358-b07f-35c5f9408311",
    "firmName": "KHALFAN ALKAABI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1559",
    "licenseIssueDate": "08/29/2021 00:00:00",
    "licenseExpiryDate": "08/28/2026 00:00:00"
  },
  {
    "id": "e70e21fd-0a8a-4dfb-8c83-6e13a2e91a3e",
    "slug": "shaker-maatouq-marzouq-al-marzooqi",
    "name": "SHAKIR MAATOUQ MARZOUQ",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 18,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/07/2007",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Shaker Maatouq Marzouq AL- MARZOOQI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e70e21fd-0a8a-4dfb-8c83-6e13a2e91a3e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-370",
    "licenseIssueDate": "07/03/2007 00:00:00",
    "licenseExpiryDate": "07/02/2026 00:00:00"
  },
  {
    "id": "aedaf422-3577-4bee-b221-22fef1474913",
    "slug": "shamma-hamad-mohammad-kadfoor-almheiri",
    "name": "ISMAEIL HUMAID ISMAEIL AL HERDAH ALZAABI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/06/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Shamma Hamad Mohammad Kadfoor Almheiri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_aedaf422-3577-4bee-b221-22fef1474913",
        "address": "",
        "phone": "97143304343",
        "email": "hamad@emiratesadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "f7823b07-a968-474f-8a13-a4454ef2d990",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1826",
    "licenseIssueDate": "07/11/2023 00:00:00",
    "licenseExpiryDate": "07/10/2026 00:00:00"
  },
  {
    "id": "25b0f88e-6885-42ac-8130-5fc1cadd9649",
    "slug": "shamma-hassan-humaid-hassan-al-shamsi",
    "name": "OBAID MOHAMED IBRAHIM MUBARAK ALHAMMADI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/07/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Shamma Hassan Humaid Hassan Al Shamsi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_25b0f88e-6885-42ac-8130-5fc1cadd9649",
        "address": "",
        "phone": "97143316868 / 971561446981",
        "email": "info@alhanaee.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "eb84bd6d-a78c-4fd6-8f46-4fab8eea60b5",
    "firmName": "ALOBAIDLI & ALZAROONI ADVOCATES&LEGAL CONSULTANTS",
    "registrationNumber": "L-1837",
    "licenseIssueDate": "07/27/2023 00:00:00",
    "licenseExpiryDate": "07/26/2026 00:00:00"
  },
  {
    "id": "abd97628-06f2-4719-a5e0-7c55df6fcd30",
    "slug": "shamma-mohamed-hasan-mohamed-almarzooqi",
    "name": "SHAMMA MOHAMED HASAN MOHAMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/08/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Shamma Mohamed Hasan Mohamed Almarzooqi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_abd97628-06f2-4719-a5e0-7c55df6fcd30",
        "address": "othman almarzooqi ,19th ,single business tower ,samaya tower ,114333 ,Dubai",
        "phone": "97142999970 / 971500000000",
        "email": "info@othmanadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "a0cdd94d-cc5a-4617-b6a3-b23deb9852d5",
    "firmName": "OTHMAN ALMARZOOQI ADVOCATES AND LEGAL CONSULTATIONS",
    "registrationNumber": "L-1213",
    "licenseIssueDate": "08/08/2017 00:00:00",
    "licenseExpiryDate": "08/07/2026 00:00:00"
  },
  {
    "id": "d37832ed-ca96-490c-a5df-8f920a0f62a9",
    "slug": "shamma-musabbeh-saeed-khalaf-alkaabi",
    "name": "SHAMMA MUSABBEH SAEED ALI KH SAEED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/03/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: SHAMMA MUSABBEH SAEED KHALAF ALKAABI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d37832ed-ca96-490c-a5df-8f920a0f62a9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1419",
    "licenseIssueDate": "03/19/2020 00:00:00",
    "licenseExpiryDate": "03/18/2026 00:00:00"
  },
  {
    "id": "4088c42d-62b9-4325-8641-0938d372765a",
    "slug": "shamma-rashid-obaid-lowaina-alkindi",
    "name": "RASHID OBAID RASHID",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/04/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: SHAMMA RASHID OBAID LOWAINA ALKINDI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4088c42d-62b9-4325-8641-0938d372765a",
        "address": "",
        "phone": "97143685555",
        "email": "maisa.maarouf@bsabh.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "8afa232f-52ff-4dad-82c3-9a04d66eb853",
    "firmName": "B S A AHMAD BIN HAZEEM & ASSOCIATES",
    "registrationNumber": "L-1528",
    "licenseIssueDate": "04/28/2021 00:00:00",
    "licenseExpiryDate": "04/27/2026 00:00:00"
  },
  {
    "id": "0e1b556a-4078-4eb7-8ad2-f923363eb42e",
    "slug": "shamma-salem-saeed-binhashel-alteneiji",
    "name": "RASHED KHAMIS KARAZ AHMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/03/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Shamma Salem Saeed BinHashel Alteneiji",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0e1b556a-4078-4eb7-8ad2-f923363eb42e",
        "address": "",
        "phone": "",
        "email": "info@khalifaadv.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "97d00ba6-5323-4b87-8fdb-6382334c3d16",
    "firmName": "SALMA ALKETBI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1778",
    "licenseIssueDate": "08/04/2025 00:00:00",
    "licenseExpiryDate": "08/03/2026 00:00:00"
  },
  {
    "id": "633177c6-8ac8-46f9-a2c5-7bfba5ff5a3f",
    "slug": "shamsa-ali-rashid-saif-albedwawi",
    "name": "SHAMSA ALI RASHID SAIF",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/04/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Shamsa Ali rashid Saif Albedwawi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_633177c6-8ac8-46f9-a2c5-7bfba5ff5a3f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1074",
    "licenseIssueDate": "05/01/2016 00:00:00",
    "licenseExpiryDate": "04/30/2026 00:00:00"
  },
  {
    "id": "6411e6fe-1d9a-4f1c-85f7-fb62e7e318f3",
    "slug": "shamsa-hashem-salem-khedaim-alwahshi",
    "name": "shamsa hashem salem khedaim alwahshi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/27/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: shamsa hashem salem khedaim alwahshi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6411e6fe-1d9a-4f1c-85f7-fb62e7e318f3",
        "address": "MOSTAFA MAHMOUD  ,1304 ,AL MOOSA TOWER 1 ,First Trade Center ,25635 ,Dubai",
        "phone": "97142254438",
        "email": "info@hkadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "d73d1b91-74ae-4266-9f38-d28296d70f52",
    "firmName": "HAMDAN ALKAABI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "1993",
    "licenseIssueDate": "06/27/2024 00:00:00",
    "licenseExpiryDate": "06/26/2026 00:00:00"
  },
  {
    "id": "91679ed0-a897-4c8b-8af6-37e8977d1046",
    "slug": "shamsa-ibrahim-sahibkhan-almandoos",
    "name": "BADER SALEH FARAJ SAEED ALKATHEERI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/02/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-02-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: SHAMSA IBRAHIM SAHIBKHAN ALMANDOOS",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_91679ed0-a897-4c8b-8af6-37e8977d1046",
        "address": "الطابق 7 مكتب رقم 070A ,برج رولكس  ,محطة مترو المركز المالي  ,66300 ,Dubai",
        "phone": "97143444029",
        "email": "ekp.khalidaltmimi@ekplegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "400838f1-4e75-4836-9698-b9e19dd30a18",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1761",
    "licenseIssueDate": "02/21/2023 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "e42e6bb3-b0d9-44a4-8fab-eb683b43e214",
    "slug": "sharif-mohammad-yosuif-sharif-obaidly",
    "name": "SHARIF MOHAMED YOUSIF SHARIF ALOBEIDLI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 17,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/01/2008",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Sharif Mohammad Yosuif Sharif Obaidly",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e42e6bb3-b0d9-44a4-8fab-eb683b43e214",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-291",
    "licenseIssueDate": "01/30/2008 00:00:00",
    "licenseExpiryDate": "01/29/2026 00:00:00"
  },
  {
    "id": "0d0aaebb-9459-4305-bbb7-31968403cda5",
    "slug": "sharina-naji-rashed-musbbuh-aldhaheri",
    "name": "MOHAMMED MARWAN ABDULLA AHMED ALMATROOSHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/08/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Sharina Naji Rashed Musbbuh ALdhaheri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0d0aaebb-9459-4305-bbb7-31968403cda5",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1865",
    "licenseIssueDate": "09/20/2023 00:00:00",
    "licenseExpiryDate": "09/19/2026 00:00:00"
  },
  {
    "id": "552429d4-7fc1-492c-915f-b15bcf0c148c",
    "slug": "shayma-saif-ahmed-saif-alshehhi",
    "name": "SHAIMA SAIF AHMED S SALEM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/06/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: shayma saif ahmed saif  alshehhi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_552429d4-7fc1-492c-915f-b15bcf0c148c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1363",
    "licenseIssueDate": "06/12/2019 00:00:00",
    "licenseExpiryDate": "06/11/2026 00:00:00"
  },
  {
    "id": "3a8d9bda-1156-4d57-85a1-a44f31fe7785",
    "slug": "shehab-ahmed-abdalla-mahmoud-al-mazimi",
    "name": "SHEHAB AHMED ABDALLA MAHMOUD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 22,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/05/2003",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Shehab Ahmed Abdalla Mahmoud Al Mazimi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3a8d9bda-1156-4d57-85a1-a44f31fe7785",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-447",
    "licenseIssueDate": "05/24/2003 00:00:00",
    "licenseExpiryDate": "05/23/2026 00:00:00"
  },
  {
    "id": "e107b423-8758-463c-be81-52942d4f7514",
    "slug": "shehdah-hassan-juma-al-houby",
    "name": "SHEHDAH HASSAN GOMAH ALHOUBY",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 47,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/05/1978",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Shehdah Hassan Juma Al-Houby",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e107b423-8758-463c-be81-52942d4f7514",
        "address": "16 مكتب رقم 1606 ,ذا بريم تاور ,رقم مكاني 2583686879 ,13050 ,Dubai",
        "phone": "97142662233",
        "email": "info@houbylaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "da82aaa3-2103-44dd-8c58-96cbf6efd6d0",
    "firmName": "ALHOUBY ADVOCATE & LEGAL CONSULTANCY OFFICE",
    "registrationNumber": "L-64",
    "licenseIssueDate": "05/08/1978 00:00:00",
    "licenseExpiryDate": "05/07/2026 00:00:00"
  },
  {
    "id": "0e713c07-96fd-4966-a774-ef4a13cb8d4b",
    "slug": "sheikh-rashid-nasser-rashid-humaid-alnuaimi",
    "name": "LATIFA ABDULMUNEM SALEM OBAID",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/03/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: SHEIKH RASHID NASSER RASHID HUMAID ALNUAIMI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0e713c07-96fd-4966-a774-ef4a13cb8d4b",
        "address": "مكتب رقم 303 ,NAEMA ALI BUAMIM رقم مكاني 2937992197 ,المركز التجاري الماليزي ,000 ,Dubai",
        "phone": "97144475234 / 971547447744",
        "email": "RASHIDALNUIMIEST@GMAIL.COM",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "2c2cba6d-fae5-429a-b197-7434c0a1d19d",
    "firmName": "BIN SOWAIDAN ADVOCATES & LEGAL CONSULTANTCY",
    "registrationNumber": "L-1788",
    "licenseIssueDate": "04/13/2023 00:00:00",
    "licenseExpiryDate": "04/12/2026 00:00:00"
  },
  {
    "id": "b3b12c66-929e-4e99-ba68-4cc2ef94783a",
    "slug": "shoaip-azeiz-mohamed-sharief-alawadhi",
    "name": "ABDULRAZZAQ MOHAMED HAMZA SH. ALBLOOSHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/11/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Shoaip Azeiz Mohamed Sharief Alawadhi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b3b12c66-929e-4e99-ba68-4cc2ef94783a",
        "address": "Office F13 ,Business Center - CAPITAL UNITED ,Makani No: 3274893760 ,000 ,Dubai",
        "phone": "97100000000 / 971528588888",
        "email": "shoaib@mswlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "0fb04adb-315b-4377-84b9-e59f2c0cd43f",
    "firmName": "AZZA IBRAHIM HASSAN AL MULLA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1729",
    "licenseIssueDate": "12/16/2022 00:00:00",
    "licenseExpiryDate": "12/15/2025 00:00:00"
  },
  {
    "id": "6176f9e8-f1c3-4dbb-a258-6ff5d74a07ef",
    "slug": "shouq-mohsen-bader-alkethiri",
    "name": "SHOUQ MUHSIN W O KHALIFA M A S HUWAIDIN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/06/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Shouq Mohsen Bader AlKethiri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6176f9e8-f1c3-4dbb-a258-6ff5d74a07ef",
        "address": "HASSAN AL BAKRI ,16 ,THE EXCHANGE TOWER ,DUBAI WATER CANAL ,89179 ,Dubai",
        "phone": "97145807888",
        "email": "secretary@alkathirilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "b5f1d60b-df9b-4054-ac59-4543a6d06af4",
    "firmName": "SHOUQ ALKATHIRI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-404",
    "licenseIssueDate": "06/13/2011 00:00:00",
    "licenseExpiryDate": "06/12/2026 00:00:00"
  },
  {
    "id": "21f76f06-5e74-44e4-b120-700449a2c38a",
    "slug": "shrook-ali-saeed-ham-abdullah",
    "name": "NASSER SHAYEA HMOUD SLAYEM ALHAJERI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/04/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Shrook Ali Saeed Ham Abdullah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_21f76f06-5e74-44e4-b120-700449a2c38a",
        "address": "",
        "phone": "97143901155",
        "email": "legal@awigdic.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "e0e9ae88-3bda-4570-8591-d79757732608",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1940",
    "licenseIssueDate": "04/24/2024 00:00:00",
    "licenseExpiryDate": "04/23/2026 00:00:00"
  },
  {
    "id": "3830bb2f-c12f-41f9-a8cf-4487f86fefe3",
    "slug": "shuaib-mohamed-ahmad-matar-alsuwaidi",
    "name": "Shuaib Mohamed Ahmad Matar Alsuwaidi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/26/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Shuaib Mohamed Ahmad Matar Alsuwaidi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3830bb2f-c12f-41f9-a8cf-4487f86fefe3",
        "address": "",
        "phone": "97142244442",
        "email": "info@ahli-law.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "56af6f31-f5cd-419b-a092-a41cfdd84e52",
    "firmName": "AHMAD ABDULLA AHLI ADVOCATES & LEGAL CONSULTA",
    "registrationNumber": "1820",
    "licenseIssueDate": "06/26/2023 00:00:00",
    "licenseExpiryDate": "06/25/2026 00:00:00"
  },
  {
    "id": "f3fbc75f-d77c-43cd-8af6-1808aebfc84b",
    "slug": "shwikar-mohammad-midhat-jumaa",
    "name": "SHWIKAR MOHAMMAD MIDHAT JUMAA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Shwikar Mohammad Midhat Jumaa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f3fbc75f-d77c-43cd-8af6-1808aebfc84b",
        "address": "Mohamed Alhammadi ,FLOOR 16 OFFICE B1605 ,LATIFA TOWER ,CLOSE TO CROWN PLAZA HOTEL ,76550 ,Dubai",
        "phone": "97143298866",
        "email": "admin@dralhammadilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "612e75e6-c3f3-479b-bc93-ee88982dea58",
    "firmName": "DR MOHAMED ALHAMMADI ADVOCATES & LEGAL CONSULTANTS OFFICE",
    "registrationNumber": "L-793",
    "licenseIssueDate": "02/26/2012 00:00:00",
    "licenseExpiryDate": "02/25/2026 00:00:00"
  },
  {
    "id": "7919b17f-df93-4857-939b-ecf8e70f7fc8",
    "slug": "somayyah-mohamed-khameis-saeed-alkaabi",
    "name": "Somayyah Mohamed Khameis Saeed Alkaabi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/01/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Somayyah Mohamed Khameis Saeed Alkaabi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7919b17f-df93-4857-939b-ecf8e70f7fc8",
        "address": "10 Floor - Office No. 10001 ,Latifa Tower ,Makani No: 9063026848 ,000 ,Dubai",
        "phone": "97142522995 / 971505897795",
        "email": "a.legal.uae@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "432dbfa7-962d-4bbc-a64a-c3185bf78a66",
    "firmName": "HESSA HUMAID AL SHARA ADVOCATES & LEGAL CONSU",
    "registrationNumber": "1878",
    "licenseIssueDate": "11/01/2023 00:00:00",
    "licenseExpiryDate": "10/31/2025 00:00:00"
  },
  {
    "id": "992937d1-6760-42a3-b94e-dca55c56d962",
    "slug": "sooud-mohammed-issa-alsuwadi",
    "name": "SOOUD MOHAMMED ISSA ALSUWAIDI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/09/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: SOOUD MOHAMMED ISSA ALSUWADI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_992937d1-6760-42a3-b94e-dca55c56d962",
        "address": "الطابق 8 مكتب رقم 802-804 ,AL MASAOOD TOWE 2 ,الفطيم للسيارات  - ديرة  ,31909 ,Dubai",
        "phone": "97142946948",
        "email": "hadi.jomah@baitulhikma.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "a1a1a791-7d0a-4afa-a043-cd85f0998888",
    "firmName": "BAITULHIKMA LAWYERS",
    "registrationNumber": "L-1309",
    "licenseIssueDate": "09/04/2018 00:00:00",
    "licenseExpiryDate": "09/03/2026 00:00:00"
  },
  {
    "id": "0c094f4c-122e-426a-93ca-9ef51d18cec5",
    "slug": "suad-hasan-ajlan-hussain",
    "name": "SALEM MOHAMMAD ALI SALEM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/07/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: SUAD HASAN AJLAN HUSSAIN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0c094f4c-122e-426a-93ca-9ef51d18cec5",
        "address": "",
        "phone": "97143937700",
        "email": "info@galadarilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "d863b662-c864-4193-8b3a-ff6ee5fe6c64",
    "firmName": "HABIB ALMULLA & PARTNERS",
    "registrationNumber": "L-2006",
    "licenseIssueDate": "07/23/2024 00:00:00",
    "licenseExpiryDate": "07/22/2026 00:00:00"
  },
  {
    "id": "a5d43198-851c-412f-a656-ac178fab3193",
    "slug": "suad-mohamed-abdulaziz-abdulghani",
    "name": "SUAD MOHAMMEDD ABDULAZIZ ABDULGHANI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/04/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Suad Mohamed Abdulaziz Abdulghani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a5d43198-851c-412f-a656-ac178fab3193",
        "address": "SUAD MOHAMMED ,Mezzanine102-08 ,ملك الشيخة مهره احمد الغرير ,Al Tawar Center ,446009 ,Dubai",
        "phone": "97145477711 / 971558800890",
        "email": "suad.lawyer@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "95dc25d5-a785-46c2-a024-19c0658325e6",
    "firmName": "ALAWAMI ALMANSOORI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-804",
    "licenseIssueDate": "04/29/2012 00:00:00",
    "licenseExpiryDate": "04/28/2026 00:00:00"
  },
  {
    "id": "bcc58d7f-360a-4e03-afb6-fa523f1405e4",
    "slug": "subhi-hussain-ahmed",
    "name": "SUBHI HUSSEIN AHMED SALIHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 20,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/01/2005",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Subhi Hussain Ahmed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bcc58d7f-360a-4e03-afb6-fa523f1405e4",
        "address": "الطابق 8 مكتب رقم 802-804 ,AL MASAOOD TOWE 2 ,الفطيم للسيارات  - ديرة  ,31909 ,Dubai",
        "phone": "97142946948",
        "email": "hadi.jomah@baitulhikma.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "a1a1a791-7d0a-4afa-a043-cd85f0998888",
    "firmName": "BAITULHIKMA LAWYERS",
    "registrationNumber": "L-502",
    "licenseIssueDate": "01/10/2005 00:00:00",
    "licenseExpiryDate": "01/09/2026 00:00:00"
  },
  {
    "id": "62bb61ac-f6fd-423b-b03a-ef3203e6433e",
    "slug": "sughra-salem-obaid-bin-sarm",
    "name": "SUGHRA SALEM OBAID BIN SARM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/04/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Sughra Salem Obaid Bin Sarm",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_62bb61ac-f6fd-423b-b03a-ef3203e6433e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1271",
    "licenseIssueDate": "04/10/2018 00:00:00",
    "licenseExpiryDate": "04/09/2026 00:00:00"
  },
  {
    "id": "71439e95-ae4c-42cc-bb33-96eb68973892",
    "slug": "suhad-fadhil-jabbar-mahdi-aljuboori",
    "name": "SUHAD FADEL JABBAR MAHDI AL JABOORI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/06/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Suhad Fadhil Jabbar Mahdi Aljuboori",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_71439e95-ae4c-42cc-bb33-96eb68973892",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1095",
    "licenseIssueDate": "06/28/2016 00:00:00",
    "licenseExpiryDate": "06/27/2026 00:00:00"
  },
  {
    "id": "3a0769e2-311b-4725-9144-808e46961b9a",
    "slug": "suhail-ashour-mohamed-salem-alkatheeri",
    "name": "OHOUD KHALAF ALI KHALAF ALHOSANI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/04/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: SUHAIL ASHOUR MOHAMED SALEM ALKATHEERI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3a0769e2-311b-4725-9144-808e46961b9a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1942",
    "licenseIssueDate": "04/25/2024 00:00:00",
    "licenseExpiryDate": "04/24/2026 00:00:00"
  },
  {
    "id": "0b05ad8f-35f9-450f-b3a5-e8022e195103",
    "slug": "suhail-haj-saad-alshaikh-saad-quraish",
    "name": "SUHAIL HAJ SAAD ALSHAIKH SAAD QURAISH",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/01/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Suhail Haj Saad Alshaikh Saad Quraish",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0b05ad8f-35f9-450f-b3a5-e8022e195103",
        "address": "1007 ,برج لطيفة ,بجوار فندق كراون بلازل ,94873 ,Abu Dhabi",
        "phone": "97142951555 / 971567573911",
        "email": "info@mbhadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "2d3e210f-8234-4e00-b9e6-1167758a43ee",
    "firmName": "MOHAMMED BANI HASHEM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1139",
    "licenseIssueDate": "01/04/2017 00:00:00",
    "licenseExpiryDate": "01/03/2026 00:00:00"
  },
  {
    "id": "8a53d7ec-e185-434f-a21f-6fdb6096b1aa",
    "slug": "suhaila-yousuf-moosa-almarzooqi",
    "name": "Suhaila Yousuf Moosa Almarzooqi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/07/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Suhaila Yousuf Moosa Almarzooqi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8a53d7ec-e185-434f-a21f-6fdb6096b1aa",
        "address": "",
        "phone": "97144531888 / 971971445318",
        "email": "info@suhaila.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "3f71c0fe-93b9-4bea-82c4-fad46b21e883",
    "firmName": "SUHAILA ALMARZOOQI ADVOCATES & LEGAL CONSULTA",
    "registrationNumber": "1369",
    "licenseIssueDate": "07/07/2019 00:00:00",
    "licenseExpiryDate": "07/06/2026 00:00:00"
  },
  {
    "id": "526e8300-ce3d-4985-ab4c-ec4040235795",
    "slug": "sulaiman-ahmad-rasheid-al-menhali",
    "name": "SULAIMAN AHMED RASHEED ALMENHALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 24,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/10/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Sulaiman Ahmad Rasheid Al-Menhali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_526e8300-ce3d-4985-ab4c-ec4040235795",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-411",
    "licenseIssueDate": "09/18/2001 00:00:00",
    "licenseExpiryDate": "10/19/2026 00:00:00"
  },
  {
    "id": "3e48c71d-1486-48c9-a2fc-bfeef6696e9c",
    "slug": "sulaiman-mohamed-mohamed-mohmed-alshareif",
    "name": "HAYFA AHMED ABDULLA A ALAAJEL ALTENAIJI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/01/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: SULAIMAN MOHAMED MOHAMED MOHMED ALSHAREIF",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3e48c71d-1486-48c9-a2fc-bfeef6696e9c",
        "address": "Ali Saleh Atrooz  ,1103 ,EMPIRE HEIGHTS B ,دبي مول  ,18433 ,Dubai",
        "phone": "97142222511",
        "email": "info@araalaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "aab79fde-e700-45d7-904f-bde0a593a087",
    "firmName": "AZZA IBRAHIM HASSAN AL MULLA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1915",
    "licenseIssueDate": "02/09/2024 00:00:00",
    "licenseExpiryDate": "02/08/2026 00:00:00"
  },
  {
    "id": "e2d91004-38b5-4d8a-b003-c588db4f553b",
    "slug": "sulaiman-mohammed-hassan-almemari",
    "name": "SULAIMAN MOHAMMED HASAN ALMEMARI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/10/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Sulaiman Mohammed Hassan Almemari",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e2d91004-38b5-4d8a-b003-c588db4f553b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1459",
    "licenseIssueDate": "10/06/2020 00:00:00",
    "licenseExpiryDate": "10/05/2026 00:00:00"
  },
  {
    "id": "f772c8ee-28b5-4f6b-b567-cad72abae7cb",
    "slug": "sulaiman-nasir-mohameed-sulaiman-al-naqbi",
    "name": "SULAIMAN NASIR MOHAMED SULAIMAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/03/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Sulaiman Nasir Mohameed Sulaiman Al Naqbi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f772c8ee-28b5-4f6b-b567-cad72abae7cb",
        "address": "SULAIMAN ALNAQBI ,5 ,Emaar Business Park 1 ,Emaar Business Park 1 ,0000 ,Dubai",
        "phone": "",
        "email": "hsrgro@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "d10fb0e9-ccd7-4ac9-8f58-e21ff0d7d2f2",
    "firmName": "SULIMAN AL NAQBI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-614",
    "licenseIssueDate": "03/15/2017 00:00:00",
    "licenseExpiryDate": "03/14/2026 00:00:00"
  },
  {
    "id": "30d6b739-54b5-4198-9fb5-b02f72af7408",
    "slug": "sulaiman-salem-mohammed-zaid-alkarbi",
    "name": "SULAIMAN SALEM MOHAMMED ZAID",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/05/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Sulaiman Salem Mohammed Zaid Alkarbi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_30d6b739-54b5-4198-9fb5-b02f72af7408",
        "address": "",
        "phone": "97145686887 / 971566665693",
        "email": "info@alkirbilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "cef52068-add5-4e5a-83c8-600f746d48e3",
    "firmName": "SULAIMAN SALEM ALKARBI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1189",
    "licenseIssueDate": "05/21/2017 00:00:00",
    "licenseExpiryDate": "05/20/2026 00:00:00"
  },
  {
    "id": "70d252da-c08f-4107-9815-8cdd8157435d",
    "slug": "suliman-saleh-ali-salem-al-shebli",
    "name": "SULAIMAN SALEH ALI SALEM ALSHEBLI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/05/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Suliman Saleh Ali Salem Al Shebli",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_70d252da-c08f-4107-9815-8cdd8157435d",
        "address": "",
        "phone": "97142693680",
        "email": "info@sas-advocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "0e62e480-e84f-4560-8f59-ad0f1a6cbbad",
    "firmName": "SULAIMAN AL SHEBLI ADVOCATES &LEGAL CONSULTANTS",
    "registrationNumber": "L-941",
    "licenseIssueDate": "05/04/2014 00:00:00",
    "licenseExpiryDate": "05/03/2026 00:00:00"
  },
  {
    "id": "5adc7c20-5ae3-45b0-8a86-308869f313d9",
    "slug": "sultan-abdulla-mohamed-almarzooqi",
    "name": "SULTAN ABDULLA MOHAMED ALMARZOOQI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/11/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-11-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Sultan Abdulla Mohamed Almarzooqi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5adc7c20-5ae3-45b0-8a86-308869f313d9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1035",
    "licenseIssueDate": "11/19/2015 00:00:00",
    "licenseExpiryDate": "11/18/2025 00:00:00"
  },
  {
    "id": "14c7742c-3289-4cb8-82c3-417fb6b52b5a",
    "slug": "sultan-abdulla-obaid-musa-alfarsi",
    "name": "Sultan Abdulla Obaid Musa Alfarsi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/09/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Sultan Abdulla Obaid Musa Alfarsi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_14c7742c-3289-4cb8-82c3-417fb6b52b5a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "1631",
    "licenseIssueDate": "03/09/2022 00:00:00",
    "licenseExpiryDate": "03/08/2026 00:00:00"
  },
  {
    "id": "59d236c0-a1d3-467a-98e5-7ce228040261",
    "slug": "sultan-ahmad-abdelkarim-karam-albloosh",
    "name": "SULTAN AHMED ABDELKARIM KARAM ALBLOOSHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/09/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Sultan Ahmad Abdelkarim Karam Albloosh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_59d236c0-a1d3-467a-98e5-7ce228040261",
        "address": "",
        "phone": "97142552220",
        "email": "almaazmi.office@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "e04d8a88-3378-40c8-a33a-b5e26a0c8507",
    "firmName": "ABDELRAHMAN ALMAAZMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-967",
    "licenseIssueDate": "09/07/2014 00:00:00",
    "licenseExpiryDate": "09/06/2026 00:00:00"
  },
  {
    "id": "8247d645-e35a-485a-b6df-3702efee7726",
    "slug": "sultan-hadif-rashid-abdalla-alowais",
    "name": "SULTAN HADIF RASHID ABDALLA ALOWAIS",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 15,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/04/2010",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Sultan Hadif Rashid Abdalla Alowais",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8247d645-e35a-485a-b6df-3702efee7726",
        "address": "Sultan Hadif Al Owais ,504 ,Oud Metha ,Wafi Mall ,16686 ,Dubai",
        "phone": "97105053953 / 971509793158",
        "email": "info@alowaislegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "da23f476-a80d-4d5a-b180-5dbd879b540e",
    "firmName": "ADVOCATES UNIT",
    "registrationNumber": "L-708",
    "licenseIssueDate": "04/21/2010 00:00:00",
    "licenseExpiryDate": "04/20/2026 00:00:00"
  },
  {
    "id": "c8d4f4da-045c-4a08-a0ac-416e6dca19ce",
    "slug": "sultan-ibrahim-sultan-mohamed-alobeidli",
    "name": "SULTAN IBRAHIM SULTAN MOHAMED ALOBEIDLI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Commercial Agency",
      "Proceedings-Cases and Proceedings before Dubai International Financial Centre",
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Personal Status-Wills",
      "Civil Transactions-Construction and Contracts for Services",
      "Commercial Transactions-Commercial Contracts",
      "Civil Transactions-Residential Real Estate",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Civil Transactions-Tenancy",
      "Commercial Transactions-Unfair competition",
      "Personal Status-Legacies and Inheritance",
      "Commercial Transactions-Commercial Companies",
      "Commercial Transactions-Banking Operations",
      "Civil Transactions-Labor & Workers",
      "Civil Transactions-Sale",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/02/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Sultan Ibrahim Sultan Mohamed Alobeidli",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c8d4f4da-045c-4a08-a0ac-416e6dca19ce",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1342",
    "licenseIssueDate": "02/14/2019 00:00:00",
    "licenseExpiryDate": "02/13/2026 00:00:00"
  },
  {
    "id": "e324ea70-4012-41c4-a4a9-404eebe7c7fe",
    "slug": "sultan-khalfan-sultan-bin-hussain",
    "name": "SULTAN KHALFAN SULTAN BIN HUSSAIN AL ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 15,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/07/2010",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: SULTAN KHALFAN SULTAN BIN HUSSAIN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e324ea70-4012-41c4-a4a9-404eebe7c7fe",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-718",
    "licenseIssueDate": "07/25/2010 00:00:00",
    "licenseExpiryDate": "07/24/2026 00:00:00"
  },
  {
    "id": "ad83b093-d0ed-49fc-bdc8-e0a639621d2e",
    "slug": "sultan-mohamed-abdulrahman-abdulaziz-almatrooshi",
    "name": "HEND HUMAID KHALIFA BINHENDI ALALEELI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/06/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Sultan Mohamed Abdulrahman Abdulaziz Almatrooshi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ad83b093-d0ed-49fc-bdc8-e0a639621d2e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1989",
    "licenseIssueDate": "06/20/2024 00:00:00",
    "licenseExpiryDate": "06/19/2026 00:00:00"
  },
  {
    "id": "e0886803-c1b8-4636-ae0a-9db30661de67",
    "slug": "sultan-obaid-mohammed-busloom-alzaabi",
    "name": "SULTAN OBAID MOHAMMED BUSLOOM ALZAABI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/11/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Sultan Obaid Mohammed Busloom Alzaabi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e0886803-c1b8-4636-ae0a-9db30661de67",
        "address": "Obaid Ishaq Ismail Al-Maazmi ,الطابق 21 ,ذا اكستشينج تاور  ,فندق جي دبليو ماريوت ماركي ,238365 ,Dubai",
        "phone": "97143584737",
        "email": "obaidotp@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "70a8fb70-2729-4348-b87b-258c7dc7a387",
    "firmName": "OBAID AL MAZIMI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-1476",
    "licenseIssueDate": "11/09/2020 00:00:00",
    "licenseExpiryDate": "11/08/2025 00:00:00"
  },
  {
    "id": "3a53a11f-8c7d-4447-a5ea-c550baaf8c51",
    "slug": "sultan-obaid-salem-bin-theeban-almansoori",
    "name": "SULTAN OBAID SALEM BIN TH ALMANSOORI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/02/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Sultan Obaid Salem Bin Theeban Almansoori",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3a53a11f-8c7d-4447-a5ea-c550baaf8c51",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1409",
    "licenseIssueDate": "02/20/2020 00:00:00",
    "licenseExpiryDate": "02/19/2026 00:00:00"
  },
  {
    "id": "4b7925db-363a-422f-af2d-828716083da0",
    "slug": "sultan-rashid-ahmed-helal",
    "name": "SULTAN RASHID AHMED HELAL AL ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 22,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/02/2003",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Sultan Rashid Ahmed Helal",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4b7925db-363a-422f-af2d-828716083da0",
        "address": "",
        "phone": "97142955388 / 971507739863",
        "email": "arhilal@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "364483f1-f3e9-4475-a7de-733d3e03062c",
    "firmName": "HILAL &ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-174",
    "licenseIssueDate": "02/18/2003 00:00:00",
    "licenseExpiryDate": "02/17/2026 00:00:00"
  },
  {
    "id": "2c18f661-70e7-464a-b921-0dc3a7ebec54",
    "slug": "sultan-saeed-mohamed-albadi-aldhaheri",
    "name": "SHARINA NAJI RASHED MUSABBEH ALDHAHERI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/09/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Sultan Saeed Mohamed Albadi Aldhaheri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2c18f661-70e7-464a-b921-0dc3a7ebec54",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1873",
    "licenseIssueDate": "10/11/2023 00:00:00",
    "licenseExpiryDate": "10/10/2025 00:00:00"
  },
  {
    "id": "f8b1a820-e92c-43d8-96df-abc77ec5a01a",
    "slug": "sultan-saleh-awadh-mohsin-alwahedi",
    "name": "ZAINAB ABDULRAHMAN OBAID ALRISI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/03/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: sultan saleh awadh mohsin alwahedi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f8b1a820-e92c-43d8-96df-abc77ec5a01a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1781",
    "licenseIssueDate": "03/27/2023 00:00:00",
    "licenseExpiryDate": "03/26/2026 00:00:00"
  },
  {
    "id": "ee0d427c-bd5a-42ef-8f8b-79cabad39c91",
    "slug": "sultan-yousif-ahmed-ali-al-ali",
    "name": "Sultan Yousif Ahmed Ali Al-Ali",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/15/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Sultan Yousif Ahmed Ali Al-Ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ee0d427c-bd5a-42ef-8f8b-79cabad39c91",
        "address": "lujain waleed ,2 ,AL Bakhit Center ,Next to Abu Dhabi First Bank ,14916 ,Dubai",
        "phone": "97142977706",
        "email": "yousefa3@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "4ac59896-a747-47f0-931f-b7f0e54e27c6",
    "firmName": "YOUSIF AL ALI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "1917",
    "licenseIssueDate": "02/15/2024 00:00:00",
    "licenseExpiryDate": "02/14/2026 00:00:00"
  },
  {
    "id": "b1034417-772a-49cb-8e69-79fc77a067cf",
    "slug": "sultan-yousuf-ahmad-mohd-aljaziri",
    "name": "SULTAN YOUSUF AHMAD MOHD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/10/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Sultan Yousuf Ahmad Mohd Aljaziri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b1034417-772a-49cb-8e69-79fc77a067cf",
        "address": "Hussain Ali Al Jaziri ,11 ,City Tower 2 ,Crown Plaza hotel Sheikh Zayed Road ,4253 ,Dubai",
        "phone": "97142626777 / 971529087670",
        "email": "courts@jaflaws.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "c58d8654-b428-46b3-abd5-024e4331ee53",
    "firmName": "JAAFAR ALWAN & AL JAZIRI & ASSOCIATES",
    "registrationNumber": "L-1583",
    "licenseIssueDate": "10/27/2021 00:00:00",
    "licenseExpiryDate": "10/26/2026 00:00:00"
  },
  {
    "id": "db12eca0-679c-4203-81b7-0af51248406f",
    "slug": "suood-ahmed-ali-beebi-alshehhi",
    "name": "MARIAM RASHID MOHAMED JABIR",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/01/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: suood ahmed ali beebi alshehhi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_db12eca0-679c-4203-81b7-0af51248406f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1746",
    "licenseIssueDate": "01/18/2023 00:00:00",
    "licenseExpiryDate": "01/17/2026 00:00:00"
  },
  {
    "id": "676a4b59-e5e1-49b7-a320-8cf77a5ab48f",
    "slug": "taher-abdeen-taher-zainal-ibrahim",
    "name": "ABDEEN TAHER ZAINAL IBRAHIM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/03/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Taher Abdeen Taher Zainal Ibrahim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_676a4b59-e5e1-49b7-a320-8cf77a5ab48f",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-996",
    "licenseIssueDate": "03/14/2016 00:00:00",
    "licenseExpiryDate": "03/15/2026 00:00:00"
  },
  {
    "id": "4165734a-1d35-4294-a145-e04feec2053d",
    "slug": "tahreer-saleh-khamis-almukhaini-aljneibi",
    "name": "SALEH KHAMIS SALEH",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/01/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Tahreer Saleh Khamis Almukhaini Aljneibi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4165734a-1d35-4294-a145-e04feec2053d",
        "address": "ABDULHAMEED ALI ALKUMITY ,الطابق الأول  ,BMTC ,معرض هيونداي للسيارات  ,33998 ,Dubai",
        "phone": "97142686855",
        "email": "info@alkumaitiadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "7076c088-41b3-40f1-872e-6df5351625da",
    "firmName": "AL KUMAITI ADVOCATES",
    "registrationNumber": "L-1405",
    "licenseIssueDate": "01/29/2020 00:00:00",
    "licenseExpiryDate": "01/28/2026 00:00:00"
  },
  {
    "id": "106c9c66-5aec-4ff5-ab45-cd565f5bf713",
    "slug": "taiba-sayed-asghar-sayed-mohd-alsafar",
    "name": "TAIBA SAYED ASGHAR SAYED MOHD ALSAFAR",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 19,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/04/2006",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: TAIBA SAYED ASGHAR SAYED MOHD ALSAFAR",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_106c9c66-5aec-4ff5-ab45-cd565f5bf713",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-562",
    "licenseIssueDate": "04/24/2006 00:00:00",
    "licenseExpiryDate": "04/23/2026 00:00:00"
  },
  {
    "id": "e2bada9d-1a73-43e5-8002-8eb2aa3b1974",
    "slug": "taima-yousuf-saeed-jumairi-almazrouei",
    "name": "MARIAM JUMAA IBRAHIM MOHAMED ALHAMMADI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/04/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Taima Yousuf Saeed Jumairi AlMazrouei",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e2bada9d-1a73-43e5-8002-8eb2aa3b1974",
        "address": "Mohamed Thamer Yaqub Yousef Alserkal ,الطابق الثاني ,اعمار سكوير - بناء رقم 4 ,برج خليفة ,57409 ,Dubai",
        "phone": "97142622217 / 97142622217",
        "email": "mohamed@alserkallawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "2a224392-a975-448f-aec5-0460984b1124",
    "firmName": "NAWAL ALHOSANI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-1651",
    "licenseIssueDate": "05/10/2022 00:00:00",
    "licenseExpiryDate": "05/09/2026 00:00:00"
  },
  {
    "id": "232def54-256b-481e-9ee8-390f3ac0c354",
    "slug": "talal-hassan-hadaf-muslem-khawar",
    "name": "AMNA MAJID MOHD ALSHAIKH AHMAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/05/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Talal Hassan Hadaf Muslem Khawar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_232def54-256b-481e-9ee8-390f3ac0c354",
        "address": "talal  ,2TH FLOOR ,AL ETIHAD BUILDING  ,DEIRA CITY CENTRE ,1111 ,Dubai",
        "phone": "97142236999 / 97142236999",
        "email": "mariamahmedadvocate@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "a2e703c0-b558-4d8f-9bd3-c77475c407b1",
    "firmName": "MAJID ALSKAIKH ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1959",
    "licenseIssueDate": "05/16/2024 00:00:00",
    "licenseExpiryDate": "05/15/2026 00:00:00"
  },
  {
    "id": "95c157a5-bfce-4781-9bc9-1133ddbc9827",
    "slug": "tamadher-ahmed-radhed-al-malek",
    "name": "tamadher ahmed radhed al malek",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/26/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: tamadher ahmed radhed al malek",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_95c157a5-bfce-4781-9bc9-1133ddbc9827",
        "address": "HAMDAN ALSHAMSI ,الطابق الرابع مكتب 401, 406,407 ,بي سكوير 01 ,مجمع دبي سكوير ,116564 ,Dubai",
        "phone": "97143469262",
        "email": "courts@has.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "de2c61a6-9d00-457e-ad1d-e73e4e62d9bd",
    "firmName": "HAMDAN ALSHAMSI LAWYER & LEGAL CONSULTANTS",
    "registrationNumber": "1710",
    "licenseIssueDate": "10/26/2022 00:00:00",
    "licenseExpiryDate": "10/25/2025 00:00:00"
  },
  {
    "id": "f1ff64af-cb55-4558-ac65-da9bb32e365f",
    "slug": "tareq-natheer-saleh-thabit",
    "name": "Tareq Natheer Saleh Thabit",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/04/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Tareq Natheer Saleh Thabit",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f1ff64af-cb55-4558-ac65-da9bb32e365f",
        "address": "الثالث ,بناية الجوهرة  ,مركز برجمان ,635 ,Dubai",
        "phone": "/ 971505777314",
        "email": "tariqthabit1975@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "71f6bdc3-3543-4f76-97c4-2d3113da5a11",
    "firmName": "TAREQ THABIT ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "1859",
    "licenseIssueDate": "09/04/2023 00:00:00",
    "licenseExpiryDate": "09/03/2026 00:00:00"
  },
  {
    "id": "aad735c4-3447-4fc7-a66f-dc7fda05077c",
    "slug": "tareq-saeed-saif-saeed-al-shamsi",
    "name": "SAEED SAIF SAEED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 20,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/01/2005",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Tareq Saeed Saif Saeed Al Shamsi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_aad735c4-3447-4fc7-a66f-dc7fda05077c",
        "address": "الجناح الشمالي الطابق التاسع الوحدة 902 ,بنك المشرق جلوبال اتش كيه  ,برج خليفة  ,41422 ,Dubai",
        "phone": "97145514441",
        "email": "info@sat-law.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "d0e8d9f9-263d-4e8a-af05-984f0cc97149",
    "firmName": "SAT & CO ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-497",
    "licenseIssueDate": "01/10/2005 00:00:00",
    "licenseExpiryDate": "01/09/2026 00:00:00"
  },
  {
    "id": "5fd95c74-2930-47f8-afaf-bc09c5bce3a7",
    "slug": "tariq-hussain-abdul-latif-abdulrahman-al-serkal-al-ali",
    "name": "TARIQ HUSSAIN ABDULLATIF ALSERKAL AL ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 23,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/04/2002",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Tariq Hussain Abdul Latif AbdulRahman Al-Serkal Al--Ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5fd95c74-2930-47f8-afaf-bc09c5bce3a7",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-289",
    "licenseIssueDate": "04/30/2002 00:00:00",
    "licenseExpiryDate": "04/29/2026 00:00:00"
  },
  {
    "id": "ecf3c8ea-94d8-4853-ba45-2d63f1fd4db0",
    "slug": "tariq-makki-jaffar-saleh",
    "name": "TARIQ MAKKI JAFFAR SALEH",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 20,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/03/2005",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Tariq Makki Jaffar Saleh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ecf3c8ea-94d8-4853-ba45-2d63f1fd4db0",
        "address": "",
        "phone": "97142209370",
        "email": "tmjs1951_advocatelaw@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "ceae5357-8b8a-4b2f-aa2f-9655068e48d3",
    "firmName": "MAKKI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-263",
    "licenseIssueDate": "03/07/2005 00:00:00",
    "licenseExpiryDate": "03/06/2026 00:00:00"
  },
  {
    "id": "2d59cbeb-9e1e-49bb-b296-12ef006f8ae0",
    "slug": "tarish-eid-mohammed-bin-ghuwaifa-almansoori",
    "name": "TARISH EID MOHAMMED BIN GHUWAIFA ALMANSOORI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBURQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/10/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Tarish Eid Mohammed Bin Ghuwaifa Almansoori",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2d59cbeb-9e1e-49bb-b296-12ef006f8ae0",
        "address": "14th Floor, No.2 ,Al Burj Al Salam ,Makani No: 27412 91443 ,000 ,Dubai",
        "phone": "97148823210 / 971565301153",
        "email": "info@tarishlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "ca640589-e7ab-45e9-8d6e-52a161a80279",
    "firmName": "TARISH ALMANSOORI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-2044",
    "licenseIssueDate": "10/30/2024 00:00:00",
    "licenseExpiryDate": "10/29/2025 00:00:00"
  },
  {
    "id": "c321383b-2534-4f46-ac26-4b231ad4cce6",
    "slug": "test-ad1",
    "name": "Test AD1",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/03/2022",
    "licenseStatus": "active",
    "licenseExpiry": "2023-03-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Test AD1",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c321383b-2534-4f46-ac26-4b231ad4cce6",
        "address": "",
        "phone": "97100000000",
        "email": "as@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "ca5e0fcb-5014-42d5-ba5a-e405395a2d30",
    "firmName": "test"
  },
  {
    "id": "d29380ff-d20f-43aa-a034-be0bfca73f16",
    "slug": "thamer-ali-khamis-khalfan-beljafla",
    "name": "THAMER ALI KHAMIS K BELJAFLA ALHEMAIRI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/11/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-11-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Thamer Ali Khamis Khalfan Beljafla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d29380ff-d20f-43aa-a034-be0bfca73f16",
        "address": "",
        "phone": "",
        "email": "thamerbeljaflalawyer@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "39ca834a-2d19-42ff-9625-e989d9c3a682",
    "firmName": "THAMER ALI BELJAFLA ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-1483",
    "licenseIssueDate": "11/30/2020 00:00:00",
    "licenseExpiryDate": "11/29/2025 00:00:00"
  },
  {
    "id": "53d351e8-0293-4be4-934d-33b01292badf",
    "slug": "thaqeba-ahmed-abdulaziz-yousuf-alsabbagh",
    "name": "Thaqeba Ahmed Abdulaziz Yousuf Alsabbagh",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/18/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Thaqeba Ahmed Abdulaziz Yousuf Alsabbagh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_53d351e8-0293-4be4-934d-33b01292badf",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "1274",
    "licenseIssueDate": "04/18/2018 00:00:00",
    "licenseExpiryDate": "04/17/2026 00:00:00"
  },
  {
    "id": "de327542-3b2f-4694-9e14-95137e2a2569",
    "slug": "thuraiya-hasan-ahmed-alawi-alaidarous",
    "name": "HUSSAIN ABDULQADER ABDULLA ALEMADI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/08/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Thuraiya Hasan Ahmed Alawi Alaidarous",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_de327542-3b2f-4694-9e14-95137e2a2569",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1693",
    "licenseIssueDate": "08/23/2022 00:00:00",
    "licenseExpiryDate": "08/22/2026 00:00:00"
  },
  {
    "id": "ef29acfc-1485-4a25-85f2-abb5b5b68dac",
    "slug": "turki-abdul-rahman-abdulla-al-belooshi",
    "name": "TURKI ABDUL RAHMAN ABDULLA ALBLOOSHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/12/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Turki Abdul Rahman Abdulla Al Belooshi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ef29acfc-1485-4a25-85f2-abb5b5b68dac",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-277",
    "licenseIssueDate": "12/27/2016 00:00:00",
    "licenseExpiryDate": "12/26/2025 00:00:00"
  },
  {
    "id": "39c76ac4-88f8-4e24-951a-cd7b47a5af9d",
    "slug": "uday-taki-hal-kazwini",
    "name": "UDAY TAKI H AL KAZWINI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBVVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Civil Transactions-Insurance",
      "Civil Transactions-Construction and Contracts for Services",
      "Civil Transactions-Compensation",
      "Civil Transactions-Insurance",
      "Civil Transactions-Construction and Contracts for Services",
      "Civil Transactions-Compensation"
    ],
    "experience": 18,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/03/2007",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: UDAY TAKI .H.AL-KAZWINI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_39c76ac4-88f8-4e24-951a-cd7b47a5af9d",
        "address": "1404 ,توين  تاورز  ,بجانب فندق ريدسون بلو  ,40227 ,Dubai",
        "phone": "97142222407",
        "email": "info@daralbalaghadvocate.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "183a898c-3779-4747-92dd-33a8feb6a42c",
    "firmName": "DAR AL BALAGH ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-588",
    "licenseIssueDate": "03/06/2007 00:00:00",
    "licenseExpiryDate": "03/05/2026 00:00:00"
  },
  {
    "id": "8b40d036-b66a-4fba-a223-3bc4137c2c0a",
    "slug": "ulyaa-hussain-ali-mohamed-alhelo",
    "name": "ULYAA HUSSAIN ALI MOHAMMAD ABDULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBVSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/05/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ulyaa Hussain Ali Mohamed AlHelo",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8b40d036-b66a-4fba-a223-3bc4137c2c0a",
        "address": "",
        "phone": "97143333245 / 97143333245",
        "email": "y.albulooshi@yhadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "5fd2b33a-4bae-47d7-86ce-bdbd42af4336",
    "firmName": "AL BALOOSHI AND AL MARASHDA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-949",
    "licenseIssueDate": "05/18/2014 00:00:00",
    "licenseExpiryDate": "05/17/2026 00:00:00"
  },
  {
    "id": "74187cb5-370d-41af-b33a-b2294b171e72",
    "slug": "wadha-mohammed-abdulla-alnuaimi",
    "name": "JAMAL MURAD ALI MURAD SULTAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/06/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Wadha Mohammed Abdulla AlnuaImi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_74187cb5-370d-41af-b33a-b2294b171e72",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1672",
    "licenseIssueDate": "05/04/2024 00:00:00",
    "licenseExpiryDate": "05/03/2026 00:00:00"
  },
  {
    "id": "c47216b3-ef46-4247-9371-d7e4d2e2ae0b",
    "slug": "wafa-ali-ibrahim-abdalla-alhosany",
    "name": "WAFA ALI IBRAHIM ABDALLA ALHOSANY",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/05/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Wafa Ali Ibrahim Abdalla Alhosany",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c47216b3-ef46-4247-9371-d7e4d2e2ae0b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1186",
    "licenseIssueDate": "05/10/2017 00:00:00",
    "licenseExpiryDate": "05/09/2026 00:00:00"
  },
  {
    "id": "27d8ab74-2478-4eeb-91de-b1cb5f11a038",
    "slug": "wafa-obaid-masood-ayalsalmin-alfalasi",
    "name": "HUMAID OBAID HUMAID",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/11/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-11-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Wafa Obaid Masood Ayalsalmin Alfalasi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_27d8ab74-2478-4eeb-91de-b1cb5f11a038",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1735",
    "licenseIssueDate": "01/05/2023 00:00:00",
    "licenseExpiryDate": "01/04/2026 00:00:00"
  },
  {
    "id": "69fe1f4b-0951-4115-8cf5-e5940df80dec",
    "slug": "wafaa-sulaiman-saeed-ali-aldhanhani",
    "name": "KHAWLA AHMED MOHAMED DIMAS ALSUWAIDI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/01/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: wafaa sulaiman saeed ali aldhanhani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_69fe1f4b-0951-4115-8cf5-e5940df80dec",
        "address": "",
        "phone": "97145539905",
        "email": "info@ama-alali.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "a1add4ec-4f01-41b2-9875-540545839906",
    "firmName": "ADVOCATES UNIT",
    "registrationNumber": "L-1742",
    "licenseIssueDate": "01/11/2023 00:00:00",
    "licenseExpiryDate": "01/10/2026 00:00:00"
  },
  {
    "id": "34419a16-98fc-4711-88a1-c1b538b3978b",
    "slug": "wala-jaber-nasser-saleh-alrahma",
    "name": "WALA JABER NASSER SALEH ALRAHMA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Cases and Proceedings before Dubai International Financial Centre",
      "Personal Status-Wills",
      "Personal Status-Custody & Alimony",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Civil Transactions-Arbitration",
      "Criminal Law-Hate crimes",
      "Criminal Law-Crimes against persons",
      "Personal Status-Legacies and Inheritance",
      "Personal Status-Legal Capacity & Guardianship",
      "Criminal Law-Drug Crimes",
      "Proceedings-Cases and Proceedings before arbitral tribunals and other alternative dispute resolution bodies",
      "Personal Status-Marriage & Divorce",
      "Personal Status-Child Abuse & Abduction",
      "Criminal Law-Crimes against properties",
      "Criminal Law-Cybercrimes"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/02/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: wala Jaber Nasser saleh Alrahma",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_34419a16-98fc-4711-88a1-c1b538b3978b",
        "address": "Second Floor - A 202 ,Golf Tower ,Makani No: 3064392025 ,000 ,Dubai",
        "phone": "97100000000 / 97100000000",
        "email": "Walaalrahma@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "b96dccbc-837b-4d8b-9f42-3bb6ac9a07c0",
    "firmName": "WALA JABER ALRAHMA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1413",
    "licenseIssueDate": "02/24/2020 00:00:00",
    "licenseExpiryDate": "02/23/2026 00:00:00"
  },
  {
    "id": "201beab5-b509-4414-9725-9a66a79d11de",
    "slug": "wala-juma-hassan-khamis-bukattara",
    "name": "HAMAD SAIF EBRAHIM A.ALZAABI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/03/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Wala Juma Hassan Khamis Bukattara",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_201beab5-b509-4414-9725-9a66a79d11de",
        "address": "Abdulhakim Habib Mansoor Binherz  ,38 ,Latifa Tower  , Crowne Plaza Hotel ,97598 ,Dubai",
        "phone": "97102544490",
        "email": "litigation@binherzadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "4e2e2375-ce6e-4d10-936d-68285844f2c0",
    "firmName": "HAMAD ALZAABI & MUNA BIN GHALAITA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1792",
    "licenseIssueDate": "04/24/2023 00:00:00",
    "licenseExpiryDate": "04/23/2026 00:00:00"
  },
  {
    "id": "92f268b6-6665-4d51-bcc0-21d6b4271fd4",
    "slug": "waleed-abdulla-rashed-bin-alawi-alshemeili",
    "name": "WALEED ABDULLA RASHED B A ALSHEMEILI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/06/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: WALEED ABDULLA RASHED BIN ALAWI ALSHEMEILI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_92f268b6-6665-4d51-bcc0-21d6b4271fd4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1534",
    "licenseIssueDate": "06/12/2021 00:00:00",
    "licenseExpiryDate": "06/11/2026 00:00:00"
  },
  {
    "id": "6178aa4a-d062-4422-b60e-9a9af847bb97",
    "slug": "waleed-khaled-mohamed-abdulla-alseiari",
    "name": "waleed khaled mohamed abdulla alseiari",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/02/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: waleed khaled mohamed abdulla alseiari",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6178aa4a-d062-4422-b60e-9a9af847bb97",
        "address": "الطابق الثاني ,امارات اتريوم ,مبني الامارات للبترول ,2311 ,Dubai",
        "phone": "97145823288 / 971552222311",
        "email": "info@lmh.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "33e18285-3dec-403b-b2e2-7862ae1993cc",
    "firmName": "MOHAMED ABDULILAH ALHAMED ADVOCATES & LEGAL C",
    "registrationNumber": "1921",
    "licenseIssueDate": "03/02/2024 00:00:00",
    "licenseExpiryDate": "03/01/2026 00:00:00"
  },
  {
    "id": "4aa477c3-0401-4f98-b9f5-b7aff07702a4",
    "slug": "waleed-mohamed-husain-ahmed-almarzooqi",
    "name": "WALEED MOHAMED HUSAIN AHMED ALMARZOOQI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Civil Transactions-Insurance",
      "Personal Status-Wills",
      "Criminal Law-Family Crimes",
      "Commercial Transactions-Commercial Contracts",
      "Commercial Transactions-Bankruptcy",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Criminal Law-Hate crimes",
      "Criminal Law-Crimes against persons",
      "Commercial Transactions-Commercial Companies",
      "Civil Transactions-Labor & Workers",
      "Criminal Law-Drug Crimes",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/04/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Waleed Mohamed Husain Ahmed AlMarzooqi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4aa477c3-0401-4f98-b9f5-b7aff07702a4",
        "address": "الطابق 33/ الوحدة : 3304 ,مبني المنارة /   الطابق 33/ الوحدة : 3304 ,فندق جي دبليو ماركيز  ,24002 ,Dubai",
        "phone": "97144254373",
        "email": "info@wkadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "332a3a67-50f2-424a-a5c1-d5abaf9a030b",
    "firmName": "WALEED ALMARZOOQI AND KHALID MOHAMED ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-800",
    "licenseIssueDate": "04/18/2012 00:00:00",
    "licenseExpiryDate": "04/17/2026 00:00:00"
  },
  {
    "id": "66aeaf31-1006-4950-9072-3a3a32c7d632",
    "slug": "waleed-mubarak-obaid-al-alawi",
    "name": "Waleed Mubarak Obaid Al Alawi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/11/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Waleed Mubarak Obaid Al Alawi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_66aeaf31-1006-4950-9072-3a3a32c7d632",
        "address": "",
        "phone": "97143997700 / 971503707978",
        "email": "info@alazazi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "92d43169-f680-4fdb-a7c0-1397ce308994",
    "firmName": "MOHAMED ALAZAZI LAWYERS & LEGAL CONSULTANCY",
    "registrationNumber": "914",
    "licenseIssueDate": "02/11/2014 00:00:00",
    "licenseExpiryDate": "02/10/2026 00:00:00"
  },
  {
    "id": "4202795e-4e5c-4770-a13a-cf9a40144e96",
    "slug": "walid-humaid-bin-theyban-alfalasi",
    "name": "WALID HUMAID KHALIFA BIN DHEEBAN ALFALASI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/12/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Walid Humaid Bin Theyban Alfalasi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4202795e-4e5c-4770-a13a-cf9a40144e96",
        "address": "",
        "phone": "",
        "email": "walidalfalasi@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "54c8ea54-1d98-4e28-8dc3-288bbc4098a1",
    "firmName": "WALID BIN THEBAN ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-846",
    "licenseIssueDate": "12/23/2012 00:00:00",
    "licenseExpiryDate": "12/22/2025 00:00:00"
  },
  {
    "id": "f328dec3-4174-4461-8147-f97aa32eabfd",
    "slug": "wedad-ali-hussain-hassan-mohammed",
    "name": "MOUZA HAMAD OBAID ALNOUIMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/09/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Wedad Ali Hussain Hassan Mohammed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f328dec3-4174-4461-8147-f97aa32eabfd",
        "address": "6F 603, 605, 7F 704 ,Crystal Tower ,Dubai Mall ,117538 ,Dubai",
        "phone": "97146098700",
        "email": "pro@miolawfirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "417f90a1-03be-4dab-8eea-1bba7e16f536",
    "firmName": "ABDELAZIZ AL KHAMIRI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1709",
    "licenseIssueDate": "10/25/2022 00:00:00",
    "licenseExpiryDate": "10/24/2025 00:00:00"
  },
  {
    "id": "2d98fdb2-788a-44a3-bb36-d63e32b611e6",
    "slug": "wejdan-abdulla-mohammed-bushahab-alsuwaidi",
    "name": "WEJDAN ABDULLA M BUSHAHAB ALSUWAIDI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/10/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Wejdan Abdulla Mohammed Bushahab Alsuwaidi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2d98fdb2-788a-44a3-bb36-d63e32b611e6",
        "address": "",
        "phone": "97143422244 / 97143422244",
        "email": "info@maryamwejdan.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "fc7bbac7-d29b-4486-8335-92c217bfd653",
    "firmName": "MARYAM HAYYAZ & WEJDAN BUSHAHAB ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1114",
    "licenseIssueDate": "10/03/2016 00:00:00",
    "licenseExpiryDate": "10/02/2026 00:00:00"
  },
  {
    "id": "95286dc4-ed77-492f-bfa2-08566ff1c5ec",
    "slug": "yaqoob-qasem-shahin-abdulla",
    "name": "YAQOOB QASSEM SHAHIN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZUQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 24,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/02/2001",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Yaqoob Qasem Shahin Abdulla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_95286dc4-ed77-492f-bfa2-08566ff1c5ec",
        "address": "",
        "phone": "97142830088 / 971505951775",
        "email": "dubai_lc@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "dd2f1b59-88fd-4ade-9d8f-139a4b75fef0",
    "firmName": "DUBAI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-397",
    "licenseIssueDate": "02/27/2001 00:00:00",
    "licenseExpiryDate": "02/26/2026 00:00:00"
  },
  {
    "id": "6c4a2d92-7912-4c33-bfe0-7d9da7c84c4a",
    "slug": "yaqoub-mohamed-murad-abdulrahman-almaazmi",
    "name": "YAQOUB MOHAMED MURAD A.ALMAAZMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/10/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Yaqoub Mohamed Murad Abdulrahman Almaazmi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6c4a2d92-7912-4c33-bfe0-7d9da7c84c4a",
        "address": "Yaqoub Almaamzi ,6th Floor, office 606 ,Building 1 A ,Near Dubai Mall ,554801 ,Dubai",
        "phone": "97145686523 / 971000000000",
        "email": "info@almazmy.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "3e828642-9baf-47a6-a42a-320c714638bf",
    "firmName": "YAQOUB ALMAAZMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1113",
    "licenseIssueDate": "10/03/2016 00:00:00",
    "licenseExpiryDate": "10/02/2026 00:00:00"
  },
  {
    "id": "6325a407-fe5a-4508-9c43-6730bcab28d8",
    "slug": "yasin-abubakr-salem-alhamed",
    "name": "YASIN ABUBAKR SALEM ALHAMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/02/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Yasin Abubakr Salem Alhamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6325a407-fe5a-4508-9c43-6730bcab28d8",
        "address": "",
        "phone": "97142955575",
        "email": "info@yalhamed.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "af6ac730-58a7-44a4-9f60-78811de374c7",
    "firmName": "YASIN ALHAMED ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-714",
    "licenseIssueDate": "02/13/2014 00:00:00",
    "licenseExpiryDate": "02/12/2026 00:00:00"
  },
  {
    "id": "89c93ee9-e40a-4d7c-a8c5-52b747fa1cbc",
    "slug": "yasir-abdalla-abdelrazaq-abdalla-al-naqbi",
    "name": "YASIR ABDALLA ABDELRAZAQ ABDALLA ALNAQBI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 21,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/01/2004",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Yasir Abdalla Abdelrazaq Abdalla Al Naqbi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_89c93ee9-e40a-4d7c-a8c5-52b747fa1cbc",
        "address": "YASIR AL NAQBI ,21 ,48 BURJ ,SOFITEL DOWN  TOWN ,181111 ,Dubai",
        "phone": "97142689949",
        "email": "info@alnaqbipartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "ad71430e-83ee-4cb5-a530-bc58db2618f6",
    "firmName": "ALNAQBI & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-473",
    "licenseIssueDate": "01/25/2004 00:00:00",
    "licenseExpiryDate": "01/24/2026 00:00:00"
  },
  {
    "id": "7dd62c1f-4cd4-4c9c-bd24-be1e315adc81",
    "slug": "yaslem-saleh-ahmed-al-sadi",
    "name": "YASLEM SALEH AHMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Commercial Agency",
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Personal Status-Wills",
      "Commercial Transactions-Bankruptcy",
      "Commercial Transactions-Commercial Real Estate",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Civil Transactions-Tenancy",
      "Criminal Law-Crimes against persons",
      "Personal Status-Legacies and Inheritance",
      "Commercial Transactions-Commercial Companies",
      "Civil Transactions-Labor & Workers",
      "Civil Transactions-Sale",
      "Personal Status-Marriage & Divorce",
      "Civil Transactions-Compensation",
      "Criminal Law-Crimes against properties",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 19,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/10/2006",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Yaslem Saleh Ahmed Al-Sadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7dd62c1f-4cd4-4c9c-bd24-be1e315adc81",
        "address": "",
        "phone": "97143808881 / 971505256777",
        "email": "legal@alyafee.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "5e5426f9-6497-4993-ba14-59bbfd263c0f",
    "firmName": "YASLEM ALSAADI ADVOCATE & LEGAL CONSULTANT",
    "registrationNumber": "L-373",
    "licenseIssueDate": "10/11/2006 00:00:00",
    "licenseExpiryDate": "10/10/2026 00:00:00"
  },
  {
    "id": "32990082-6871-41af-8c0a-78512d193b49",
    "slug": "yathreb-abdulaziz-yahya-shafyan",
    "name": "YATHREB ABDULAZIZ YAHYA SHAFYAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/01/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: yathreb abdulaziz yahya shafyan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_32990082-6871-41af-8c0a-78512d193b49",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1503",
    "licenseIssueDate": "01/31/2021 00:00:00",
    "licenseExpiryDate": "01/30/2026 00:00:00"
  },
  {
    "id": "5dfa4d13-3795-4eb3-a7f4-615dfcf84309",
    "slug": "younes-abdulqader-mohamed-hassan-alblooshi",
    "name": "YOUNES ABDULQADER MOHAMED H ALBLOOSHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/04/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Younes Abdulqader Mohamed Hassan Alblooshi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5dfa4d13-3795-4eb3-a7f4-615dfcf84309",
        "address": "",
        "phone": "97142280002",
        "email": "advoali2020@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "5029a3dc-098b-4d3f-9e38-afb0eb4319d0",
    "firmName": "ALI IBRAHIM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1277",
    "licenseIssueDate": "05/01/2018 00:00:00",
    "licenseExpiryDate": "04/30/2026 00:00:00"
  },
  {
    "id": "98211cb8-c18c-424c-90aa-e368ec3110e0",
    "slug": "younes-mohamed-ali-m-alyas-alshehhi",
    "name": "YOUNES MOHAMMED ALI ALYAS ALSHEHHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 19,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/06/2006",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Younes Mohamed Ali M. Alyas Alshehhi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_98211cb8-c18c-424c-90aa-e368ec3110e0",
        "address": "AL SHEHHI GROUP ADVOCATES & LEGAL CONSULTANT ,الأول ,بناية المسعود ,مقابل لفندي ماريوت ,172662 ,Dubai",
        "phone": "97142384222",
        "email": "dubai@alshehhilawyer.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "bcc63eb3-5fc8-42bd-beb1-b29798bdcee4",
    "firmName": "AL SHEHHI GROUP ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-576",
    "licenseIssueDate": "06/20/2006 00:00:00",
    "licenseExpiryDate": "06/19/2026 00:00:00"
  },
  {
    "id": "3c05a831-c99c-4242-9c39-271b5ccbecf4",
    "slug": "younis-mohamed-abdalla-hassan-alblooshi",
    "name": "YOUNIS MOHAMED ABDALLA HASSAN KARAM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/09/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Younis Mohamed Abdalla Hassan Alblooshi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3c05a831-c99c-4242-9c39-271b5ccbecf4",
        "address": "YOUNIS MOHAMMED ALBLOOSHI ,3 - 1 ,the icon ,السيلكون ,117548 ,Dubai",
        "phone": "97145693206 / 971000000000",
        "email": "info@yblooshiadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "27278b02-4edf-490f-9d50-a1bc00678b6a",
    "firmName": "YOUNIS MOHAMMED AL BLOOSHI LAWYER & LEGAL CONSULTANTS",
    "registrationNumber": "L-1224",
    "licenseIssueDate": "09/14/2017 00:00:00",
    "licenseExpiryDate": "09/13/2026 00:00:00"
  },
  {
    "id": "131d440b-4878-4b8d-9169-3effdf770adc",
    "slug": "yousef-abdulghaffar-abdulrahman-al-shreif",
    "name": "YOUSIF ABDALGHAFAR A A ALSHARIF",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 30,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/04/1995",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Yousef Abdulghaffar Abdulrahman AL-Shreif",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_131d440b-4878-4b8d-9169-3effdf770adc",
        "address": "",
        "phone": "97142566660",
        "email": "dlr@ysalc.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "28be4513-86ae-4602-b4cc-8d52ba959e9e",
    "firmName": "YOUSUF AL SHARIF ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-269",
    "licenseIssueDate": "04/30/1995 00:00:00",
    "licenseExpiryDate": "04/29/2026 00:00:00"
  },
  {
    "id": "99387d1e-0150-4bee-9cfb-eb4b616266cb",
    "slug": "yousef-abdulkarim-yousef-adbulla",
    "name": "MUNA MUBARAK MOHAMED ABUKHATER ALQUBAISI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/08/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Yousef Abdulkarim Yousef Adbulla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_99387d1e-0150-4bee-9cfb-eb4b616266cb",
        "address": "Obaid Ishaq Ismail Al-Maazmi ,الطابق 21 ,ذا اكستشينج تاور  ,فندق جي دبليو ماريوت ماركي ,238365 ,Dubai",
        "phone": "97143584737",
        "email": "obaidotp@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "70a8fb70-2729-4348-b87b-258c7dc7a387",
    "firmName": "OUTSIDE DUBAI FIRM",
    "registrationNumber": "L-1853",
    "licenseIssueDate": "08/24/2023 00:00:00",
    "licenseExpiryDate": "08/23/2026 00:00:00"
  },
  {
    "id": "e0be7d0e-39bc-4a03-92c3-2df639a5405b",
    "slug": "yousef-ahmad-abdulla-abdulraheim",
    "name": "YOUSIF AHMED ABDALLA A ALHARMOODI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 24,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/06/2001",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Yousef Ahmad Abdulla Abdulraheim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e0be7d0e-39bc-4a03-92c3-2df639a5405b",
        "address": "",
        "phone": "97142212494",
        "email": "bayanlaw@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "3eaca0c8-938e-4864-add1-73e5c902b168",
    "firmName": "DAR AL BAYAN ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-407",
    "licenseIssueDate": "06/26/2001 00:00:00",
    "licenseExpiryDate": "06/25/2026 00:00:00"
  },
  {
    "id": "1a82e488-d3d8-44f4-8472-32ec10a43213",
    "slug": "yousef-ali-hasan-kandary-almarzooqi",
    "name": "YOUSEF ALI HASAN ALMARZOOQI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/11/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-11-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: yousef ali hasan kandary almarzooqi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1a82e488-d3d8-44f4-8472-32ec10a43213",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1237",
    "licenseIssueDate": "11/23/2017 00:00:00",
    "licenseExpiryDate": "11/22/2025 00:00:00"
  },
  {
    "id": "ef13ca36-f387-4133-9cd8-c27f18ee67c4",
    "slug": "yousef-ebrahim-obaid-ebrahim-alqaz-alneaimi",
    "name": "YOUSEF EBRAHIM OBAID E ALQAZ",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/11/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Yousef Ebrahim Obaid Ebrahim Alqaz Alneaimi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ef13ca36-f387-4133-9cd8-c27f18ee67c4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-839",
    "licenseIssueDate": "11/20/2012 00:00:00",
    "licenseExpiryDate": "11/19/2025 00:00:00"
  },
  {
    "id": "c9b9c0c7-e972-411c-8f40-28d4d1ae2bc5",
    "slug": "yousef-khalifa-ahmad-bin-hammad-almarri",
    "name": "YOUSUF KHALIFA AHMAD BIN HAMMAD ALMARRI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 34,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/04/1991",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Yousef Khalifa Ahmad Bin Hammad Almarri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c9b9c0c7-e972-411c-8f40-28d4d1ae2bc5",
        "address": "",
        "phone": "97142220011",
        "email": "info@hammad.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "8d0af4a8-053e-49f9-bed7-795d52e23286",
    "firmName": "YOUSUF BIN HAMMAD & ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-237",
    "licenseIssueDate": "04/06/1991 00:00:00",
    "licenseExpiryDate": "04/05/2026 00:00:00"
  },
  {
    "id": "40a9148f-9d5c-4f3a-9a80-e2980080ac91",
    "slug": "yousef-mohammed-ibrahim-abdulla",
    "name": "YOUSIF MOHAMED IBRAHIM ABDALLA ALMAAZMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 27,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/09/1998",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Yousef Mohammed Ibrahim Abdulla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_40a9148f-9d5c-4f3a-9a80-e2980080ac91",
        "address": "yousif almaazmi ,التاسع  ,سيتاديل تاور  ,خلف فندق جي دبليوماريوت  ,94646 ,Dubai",
        "phone": "97144517744",
        "email": "info@cityint.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "59aaa82d-162e-4646-9bcc-f3349dfb2512",
    "firmName": "YOUSIF ALMAAZMI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-343",
    "licenseIssueDate": "09/29/1998 00:00:00",
    "licenseExpiryDate": "09/28/2026 00:00:00"
  },
  {
    "id": "b3b9dd1e-90f6-401d-8826-fb6b1406d827",
    "slug": "yousef-saif-mohammed-balasli-aldhaheri",
    "name": "SAIF ABDULLA KHALFAN MOHAMMAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/04/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: YOUSEF SAIF MOHAMMED BALASLI ALDHAHERI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b3b9dd1e-90f6-401d-8826-fb6b1406d827",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1941",
    "licenseIssueDate": "04/24/2024 00:00:00",
    "licenseExpiryDate": "04/23/2026 00:00:00"
  },
  {
    "id": "5c32705a-2c15-4ea4-9c44-be1da8098524",
    "slug": "yousef-sayedali-alrefaei-alhosani",
    "name": "FATMA SALEH HAMEED ABADALLA AL RASHDA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/11/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-11-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: YOUSEF SAYEDALI ALREFAEI ALHOSANI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5c32705a-2c15-4ea4-9c44-be1da8098524",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1891",
    "licenseIssueDate": "11/27/2023 00:00:00",
    "licenseExpiryDate": "11/26/2025 00:00:00"
  },
  {
    "id": "7fcbaed2-9967-4cc0-88aa-c9643a9709a1",
    "slug": "yousif-abdulla-alsayedahmed-almarzooqi",
    "name": "YOUSIF ABDULLA ALSAYEDAHMED ALMARZOOQI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/11/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Yousif Abdulla ALsayedahmed Almarzooqi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7fcbaed2-9967-4cc0-88aa-c9643a9709a1",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1596",
    "licenseIssueDate": "11/16/2021 00:00:00",
    "licenseExpiryDate": "11/15/2025 00:00:00"
  },
  {
    "id": "3d0857b3-255b-4aa1-8e51-c0f7334e5925",
    "slug": "yousif-ahmed-hasan-abdulla-almarzouqi",
    "name": "YOUSIF AHMED HASAN ABDULLA ALMARZOOQI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/05/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Yousif Ahmed Hasan Abdulla Almarzouqi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3d0857b3-255b-4aa1-8e51-c0f7334e5925",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-754",
    "licenseIssueDate": "05/09/2011 00:00:00",
    "licenseExpiryDate": "05/08/2026 00:00:00"
  },
  {
    "id": "7da25619-394c-4ddf-8d11-e1783a3d93b7",
    "slug": "yousif-hussain-mohamed-alsahlawi-al-ali",
    "name": "YOUSIF HUSSAIN MOHAMED ALSAHLAWI AL-ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/09/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Yousif Hussain Mohamed Alsahlawi Al Ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7da25619-394c-4ddf-8d11-e1783a3d93b7",
        "address": "الطابق الخامس ,الساحة ,سوق البحار ,26011 ,Dubai",
        "phone": "97142277717",
        "email": "info@alsahlawico.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "a6811a79-5470-4c33-ad95-3ff8f661c052",
    "firmName": "AL SAHLAWI & CO ADVOCATES & CONSULTANTS",
    "registrationNumber": "L-304",
    "licenseIssueDate": "09/09/2015 00:00:00",
    "licenseExpiryDate": "09/08/2026 00:00:00"
  },
  {
    "id": "cf39c394-2ec3-4757-9f47-2e173a269a00",
    "slug": "yousif-mohamed-ahmed-yousif-alhammadi",
    "name": "YOUSIF MOHAMED AHMED YOUSIF ALHAMMADI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Commercial Transactions-Commercial Companies",
      "Civil Transactions-Labor & Workers",
      "Civil Transactions-Sale",
      "Personal Status-Marriage & Divorce",
      "Criminal Law-Crimes against properties",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/02/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Yousif Mohamed Ahmed Yousif Alhammadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cf39c394-2ec3-4757-9f47-2e173a269a00",
        "address": "yousif alhammadi ,الخامس 513،514 ,بيزنس افينيو ,وكالة نيسان ,414145 ,Dubai",
        "phone": "97143307771",
        "email": "yousifadv@alhammadilegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "b2331b5f-91be-4205-ad5c-6af317f654a4",
    "firmName": "YOUSIF AL HAMMADI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-740",
    "licenseIssueDate": "02/21/2011 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "2b028be4-8e95-49aa-9e02-90ab227a7eba",
    "slug": "yousif-mohamed-yousif-ahmed-alyousif",
    "name": "YOUSIF MOHAMED YOUSEF AHMED ALYOUSIF",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Personal Status-Legacies and Inheritance"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/09/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Yousif Mohamed Yousif Ahmed Alyousif",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2b028be4-8e95-49aa-9e02-90ab227a7eba",
        "address": "first/105 ,Al Shafar Investment ,noor bank metro station ,34655 ,Dubai",
        "phone": "97143386111",
        "email": "unionadvocates1@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "109f3fc4-62e8-4523-9372-95aaf9a76483",
    "firmName": "UNION ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1311",
    "licenseIssueDate": "09/18/2018 00:00:00",
    "licenseExpiryDate": "09/17/2026 00:00:00"
  },
  {
    "id": "f1b9cf58-6a36-48a2-9233-acf307f6e524",
    "slug": "yousuf-abbas-yousuf-ahmed-m-albalooshi",
    "name": "Yousuf Abbas Yousuf Ahmed M Albalooshi",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/14/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Yousuf Abbas Yousuf Ahmed M Albalooshi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f1b9cf58-6a36-48a2-9233-acf307f6e524",
        "address": "",
        "phone": "97143333245 / 97143333245",
        "email": "y.albulooshi@yhadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "5fd2b33a-4bae-47d7-86ce-bdbd42af4336",
    "firmName": "ALBALOOSHI AND ALMARASHIDA ADVOCATES AND LEGA",
    "registrationNumber": "784",
    "licenseIssueDate": "12/14/2011 00:00:00",
    "licenseExpiryDate": "12/13/2025 00:00:00"
  },
  {
    "id": "30fb6463-1540-40a6-87a4-ee64d1919370",
    "slug": "yousuf-ahmed-ali-al-ali",
    "name": "YOUSUF AHMED ALI ALـALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 26,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/1999",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Yousuf Ahmed Ali Al Ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_30fb6463-1540-40a6-87a4-ee64d1919370",
        "address": "lujain waleed ,2 ,AL Bakhit Center ,Next to Abu Dhabi First Bank ,14916 ,Dubai",
        "phone": "97142977706",
        "email": "yousefa3@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "4ac59896-a747-47f0-931f-b7f0e54e27c6",
    "firmName": "YOUSIF AL ALI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-353",
    "licenseIssueDate": "03/01/1999 00:00:00",
    "licenseExpiryDate": "02/28/2026 00:00:00"
  },
  {
    "id": "d4418694-522f-42f9-8d7a-8097d4f2a998",
    "slug": "yousuf-essa-selam-alsayyah",
    "name": "YOUSUF ESSA SALEM ALSAYYAH",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/04/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Yousuf Essa Selam Alsayyah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d4418694-522f-42f9-8d7a-8097d4f2a998",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1355",
    "licenseIssueDate": "04/04/2019 00:00:00",
    "licenseExpiryDate": "04/03/2026 00:00:00"
  },
  {
    "id": "f1a978f8-1444-43d2-898b-5ced8527f8eb",
    "slug": "yousuf-mohamed-ali-ahmad-alhammadi",
    "name": "YOUSUF MOHAMED ALI AHMAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/10/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Yousuf Mohamed Ali Ahmad Alhammadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f1a978f8-1444-43d2-898b-5ced8527f8eb",
        "address": "",
        "phone": "97143702000 / 971504844414",
        "email": "advoy.m@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "22c36bcb-1914-4128-9816-406ffc0aec47",
    "firmName": "MOHAMMED ABDULLA & YOUSUF ALHAMMADI ADVOCATE LEGAL CONSULTANTS",
    "registrationNumber": "L-1119",
    "licenseIssueDate": "10/27/2016 00:00:00",
    "licenseExpiryDate": "10/26/2025 00:00:00"
  },
  {
    "id": "fe196d51-aca4-444b-b81d-3dccf9f640ea",
    "slug": "yousuf-mohamed-rashed-ali-alzeyoudi",
    "name": "YOUSUF MOHAMED RASHED ALI ALZEYOUDI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/04/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Yousuf Mohamed Rashed Ali Alzeyoudi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fe196d51-aca4-444b-b81d-3dccf9f640ea",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1005",
    "licenseIssueDate": "04/05/2015 00:00:00",
    "licenseExpiryDate": "04/04/2026 00:00:00"
  },
  {
    "id": "edd0d7e3-b1e6-4122-aa61-e42380d9e245",
    "slug": "zahrah-azzah-idris-abutaj",
    "name": "ZAHRA AZZA IDRIS ABUTAJ",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/03/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Zahrah Azzah Idris Abutaj",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_edd0d7e3-b1e6-4122-aa61-e42380d9e245",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1160",
    "licenseIssueDate": "03/23/2017 00:00:00",
    "licenseExpiryDate": "03/22/2026 00:00:00"
  },
  {
    "id": "d7cd65ac-fdd9-4348-929f-7e12d612ce0a",
    "slug": "zainab-abdulrahman-obaid-alrayssi",
    "name": "ELIAS RAFIC ABI YOUNES",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/02/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Zainab Abdulrahman Obaid Alrayssi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d7cd65ac-fdd9-4348-929f-7e12d612ce0a",
        "address": "29 ,ذا اتش هوتيل ,فندق فيرمونت ,40073 ,Dubai",
        "phone": "97143254000",
        "email": "info@alrowaad.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "759f5477-fdbd-406b-8831-354639c31036",
    "firmName": "ISSA & ABI YOUNES ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1773",
    "licenseIssueDate": "03/03/2023 00:00:00",
    "licenseExpiryDate": "03/02/2026 00:00:00"
  },
  {
    "id": "c17124ec-29e4-465a-ac8b-ead56d38533b",
    "slug": "zainab-qalzar-ali-daberaldeen-alblooshi",
    "name": "ZAINAB QULZAR ALI DABER ALDEEN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaUQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/12/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Zainab Qalzar Ali Daberaldeen Alblooshi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c17124ec-29e4-465a-ac8b-ead56d38533b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-1485",
    "licenseIssueDate": "12/14/2020 00:00:00",
    "licenseExpiryDate": "12/13/2025 00:00:00"
  },
  {
    "id": "c2ff5a19-2889-4853-83b0-eec9ed3150ea",
    "slug": "zayed-matar-khamis-khalfan-almazrouei",
    "name": "NADA EID SALEM MOHAMED SAAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/09/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ZAYED MATAR KHAMIS KHALFAN ALMAZROUEI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c2ff5a19-2889-4853-83b0-eec9ed3150ea",
        "address": "",
        "phone": "97142366520 / 971506177071",
        "email": "zayed@zayedlegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "2dfa7ef4-9fdc-41b0-96fa-6bb79c7ca596",
    "firmName": "JASSIM AL SUWAIDI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-1706",
    "licenseIssueDate": "10/06/2022 00:00:00",
    "licenseExpiryDate": "10/05/2026 00:00:00"
  },
  {
    "id": "6e07efec-9915-4a4e-a02c-765d53cea0d5",
    "slug": "zayed-saad-abdulla-ali-almenhali",
    "name": "SARA JUMA SAEED KHALIFA ALKABI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/11/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: zayed saad abdulla ali almenhali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6e07efec-9915-4a4e-a02c-765d53cea0d5",
        "address": "1 ,MOBH Building 2 ,GGICO Metro Station ,3555 ,Dubai",
        "phone": "97142821191 / 971552222519",
        "email": "nujoodlegal@mobhgroup.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "019941a6-be29-4b9c-a1ee-6f6cf6c599de",
    "firmName": "ABDULRAHMAN ALAAMRI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1722",
    "licenseIssueDate": "11/17/2022 00:00:00",
    "licenseExpiryDate": "11/16/2025 00:00:00"
  },
  {
    "id": "5bac51f2-e3e6-4604-a269-d506b46600c7",
    "slug": "zayed-saeed-rashed-saeed-al-shehhi",
    "name": "ZAYED SAEED RASHED SAEED ALSHEHHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 15,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/12/2009",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Zayed Saeed Rashed Saeed Al Shehhi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5bac51f2-e3e6-4604-a269-d506b46600c7",
        "address": "",
        "phone": "97142566000 / 971567346502",
        "email": "info@zayedalshehhi-adv.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "1266128b-21ba-400a-98b8-cef5142128d1",
    "firmName": "ZAYED AL SHEHHI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-685",
    "licenseIssueDate": "12/24/2009 00:00:00",
    "licenseExpiryDate": "12/23/2025 00:00:00"
  },
  {
    "id": "22faf2ff-44a2-41e7-85a8-107dfb148d30",
    "slug": "zayed-saeed-saif-saeed-al-shamsi",
    "name": "ZAYED SAEED SAIF SAEED ALSHAMSI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 27,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/04/1998",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Zayed Saeed Saif Saeed Al-Shamsi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_22faf2ff-44a2-41e7-85a8-107dfb148d30",
        "address": "zayed saeed saif alshamsi ,الرابع مكتب رقم 414 ,قرية الاعمال ,بجانب دائرة التنمية الاقتصادية - دوار الساعة  ,6030 ,Dubai",
        "phone": "97142680800",
        "email": "info@zayedalshamsi.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "295c7198-77b4-4f9a-a4d2-bad9a78e074d",
    "firmName": "ZAYED AL SHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-331",
    "licenseIssueDate": "04/21/1998 00:00:00",
    "licenseExpiryDate": "04/20/2026 00:00:00"
  },
  {
    "id": "16f20840-9e58-48d6-9111-e88feac7bc70",
    "slug": "zeinab-ali-issa-niang",
    "name": "Zeinab Ali Issa Niang",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/17/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Zeinab Ali Issa Niang",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_16f20840-9e58-48d6-9111-e88feac7bc70",
        "address": "الاول 107 ,مجمع المحكمة العليا بدبي  ,محاكم دبي  ,56637 ,Dubai",
        "phone": "97142568008",
        "email": "info@almaazmi-law.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "3083f53b-2676-4d9b-81b3-86ac3e91fc28",
    "firmName": "AHMED ALMAAZMI ADVOCATES AND LEGAL CONSULTANT",
    "registrationNumber": "1052",
    "licenseIssueDate": "02/17/2016 00:00:00",
    "licenseExpiryDate": "02/16/2026 00:00:00"
  },
  {
    "id": "975e32b0-eba4-43d1-a9bd-90db8fbd663b",
    "slug": "zelaikha-hasan-ahmed-alhosani",
    "name": "ZELAIKHA HASAN AHMED ALHOSANI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/06/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ZELAIKHA HASAN AHMED ALHOSANI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_975e32b0-eba4-43d1-a9bd-90db8fbd663b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "registrationNumber": "15950",
    "licenseIssueDate": "12/06/2021 00:00:00",
    "licenseExpiryDate": "12/05/2025 00:00:00"
  },
  {
    "id": "c6dfa090-3e6f-4029-92c6-f60534631226",
    "slug": "ziad-abdulla-ibrahim-galadari",
    "name": "ZIAD ABDULLA IBRAHIM GALADARI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Personal Status-Legacies and Inheritance"
    ],
    "experience": 42,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/05/1983",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ziad Abdulla Ibrahim Galadari",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c6dfa090-3e6f-4029-92c6-f60534631226",
        "address": "",
        "phone": "97143937700",
        "email": "info@galadarilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "d863b662-c864-4193-8b3a-ff6ee5fe6c64",
    "firmName": "GALADARI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-125",
    "licenseIssueDate": "05/28/1983 00:00:00",
    "licenseExpiryDate": "05/27/2026 00:00:00"
  },
  {
    "id": "2cd04a9d-e672-4020-b7ef-e199beba091f",
    "slug": "ziad-joseph-issa",
    "name": "Ziad Joseph Issa",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/23/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: Ziad Joseph Issa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2cd04a9d-e672-4020-b7ef-e199beba091f",
        "address": "ROULA MAALOUF ,5- UNIT 514 ,LIBERTY HOUSE ,RITZ HOTEL DIFC ,506949 ,Dubai",
        "phone": "97148359858",
        "email": "issa@iaalo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Team Member",
    "firmId": "ee41a5ea-49b1-4cd3-950b-d073f9bf8158",
    "firmName": "ISSA & ABI YOUNES ADVOCATES & LEGAL CONSULTAN",
    "registrationNumber": "1766",
    "licenseIssueDate": "02/23/2023 00:00:00",
    "licenseExpiryDate": "02/22/2026 00:00:00"
  },
  {
    "id": "29087a61-fdb4-422f-9b84-b5bb0a1aafa2",
    "slug": "zubaida-mubarak-bin-hendi",
    "name": "ZUBAIDA MUBARAK BIN HENDI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Commercial Agency",
      "Proceedings-Cases and Proceedings before Dubai International Financial Centre",
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Civil Transactions-POA & Sponsorship",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Civil Transactions-Insurance",
      "Personal Status-Wills",
      "Civil Transactions-Construction and Contracts for Services",
      "Civil Transactions-Ownership & Title",
      "Civil Transactions-HR & Employee Affairs",
      "Commercial Transactions-Commercial Mortgage",
      "Criminal Law-Family Crimes",
      "Personal Status-Custody & Alimony",
      "Commercial Transactions-Commercial Contracts",
      "Civil Transactions-Immigration and Residency",
      "Commercial Transactions-Bankruptcy",
      "Commercial Transactions-Commercial Real Estate",
      "Civil Transactions-Residential Real Estate",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Civil Transactions-Arbitration",
      "Criminal Law-Hate crimes",
      "Civil Transactions-Tenancy",
      "Commercial Transactions-Unfair competition",
      "Criminal Law-Crimes against persons",
      "Personal Status-Legacies and Inheritance",
      "Commercial Transactions-Commercial Companies",
      "Commercial Transactions-Banking Operations",
      "Civil Transactions-Labor & Workers",
      "Personal Status-Legal Capacity & Guardianship",
      "Criminal Law-Drug Crimes",
      "Civil Transactions-Sale",
      "Commercial Transactions-Sea and air freight",
      "Proceedings-Cases and Proceedings before arbitral tribunals and other alternative dispute resolution bodies",
      "Commercial Transactions-Consumer protection",
      "Personal Status-Marriage & Divorce",
      "Personal Status-Child Abuse & Abduction",
      "Civil Transactions-Compensation",
      "Commercial Transactions-Stock",
      "Criminal Law-Crimes against properties",
      "Commercial Transactions-E-Commerce",
      "Criminal Law-Cybercrimes",
      "Commercial Transactions-Intellectual Property (includes trademarks",
      "copy rights",
      "patents)",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/01/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: zubaida mubarak bin hendi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_29087a61-fdb4-422f-9b84-b5bb0a1aafa2",
        "address": "",
        "phone": "97143979948",
        "email": "info@zbh-lawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocate services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "role": "Owner",
    "firmId": "fd86842c-ebb0-4c94-b81a-5fc571367af7",
    "firmName": "ZUBAIDA BIN HENDI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-1337",
    "licenseIssueDate": "01/23/2019 00:00:00",
    "licenseExpiryDate": "01/22/2026 00:00:00"
  },
  {
    "id": "de670129-9b92-444f-9929-4ce87afd1e90",
    "slug": "islam-mohamed-takyeldin-ahmed-lotfy-hegab",
    "name": "Islam Mohamed Takyeldin Ahmed Lotfy Hegab",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/22/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Islam Mohamed Takyeldin Ahmed Lotfy Hegab",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_de670129-9b92-444f-9929-4ce87afd1e90",
        "address": "",
        "phone": "97143555600",
        "email": "hashimgroup786@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9925de3a-6943-440f-95fb-60499c669e9a",
    "firmName": "HASHIM GROUP ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04110",
    "licenseIssueDate": "07/22/2020 00:00:00",
    "licenseExpiryDate": "07/21/2026 00:00:00"
  },
  {
    "id": "02f05767-4b2a-4b56-b764-11fa478919e0",
    "slug": "jochen-murach",
    "name": "Jochen Murach",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/08/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jochen Murach",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_02f05767-4b2a-4b56-b764-11fa478919e0",
        "address": "",
        "phone": "97144323671 / 971505589395",
        "email": "fba@amereller.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a139ca64-8897-4d1d-8d71-97446bc1e15a",
    "firmName": "Amereller Legal Consultancy LLC SOC",
    "registrationNumber": "L-00487",
    "licenseIssueDate": "10/08/2011 00:00:00",
    "licenseExpiryDate": "09/29/2026 00:00:00"
  },
  {
    "id": "92f5f9a0-4b91-4359-bb05-f3e9c566b769",
    "slug": "mohd-baker-abdelkarim-estaitieh",
    "name": "(Moh'd Baker) Abdelkarim Estaitieh",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICAoQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/10/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: (Moh'd Baker) Abdelkarim Estaitieh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_92f5f9a0-4b91-4359-bb05-f3e9c566b769",
        "address": "AFAF MARJAN NASIB ,3 ,GULF TOWERS  ,DUBAI MUNICIPALITY ,35192 ,Dubai",
        "phone": "97143333929 / 97143333929",
        "email": "info@afafmarjan.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0f4257b6-c2a1-4f9d-9998-ce8f5ea9f2a3",
    "firmName": "AFAF MARJAN ADVOCATES & LEGAL CONSULTANT",
    "registrationNumber": "L-01858",
    "licenseIssueDate": "10/10/2012 00:00:00",
    "licenseExpiryDate": "10/02/2026 00:00:00"
  },
  {
    "id": "fef81949-aae8-41c9-b5a8-cc268df1189c",
    "slug": "aaina-grover",
    "name": "Aaina Grover",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/04/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Aaina Grover",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fef81949-aae8-41c9-b5a8-cc268df1189c",
        "address": "6 ,Office Nos. 603, 604 & 605, Level 6, Burj Daman ,Dubai International Financial Centre ,506555 ,Dubai",
        "phone": "97143506400 / 971504654755",
        "email": "r.hickman@aglaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8690f7d5-6b96-4649-9589-71303f2c2707",
    "firmName": "Addleshaw Goddard (Middle East) LLP",
    "registrationNumber": "L-06470",
    "licenseIssueDate": "09/04/2024 00:00:00",
    "licenseExpiryDate": "09/03/2026 00:00:00"
  },
  {
    "id": "02e7926b-b0a3-4c8f-a38e-ccf0e8d1a390",
    "slug": "aakriti-sharma",
    "name": "Aakriti Sharma",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/06/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Aakriti Sharma",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_02e7926b-b0a3-4c8f-a38e-ccf0e8d1a390",
        "address": "One Central, The Offices 5 ,Dubai World Trade Centre ,554660 ,",
        "phone": "97142052030 / 971506566494",
        "email": "chourani@houranipartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "59a73632-40a0-4849-b120-4308dc6f8015",
    "firmName": "Hourani & Partners Legal Consultancy FZCO",
    "registrationNumber": "L-06101",
    "licenseIssueDate": "12/06/2023 00:00:00",
    "licenseExpiryDate": "12/05/2025 00:00:00"
  },
  {
    "id": "fdc90a39-eb5c-42a3-86fc-bbbdab20b2d9",
    "slug": "aamer-nizar-saade",
    "name": "Aamer Nizar Saade",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/23/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Aamer Nizar Saade",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fdc90a39-eb5c-42a3-86fc-bbbdab20b2d9",
        "address": "الطابق الرابع ,مركز الرقة للأعمال ,قرب مصرف الإمارات الإسلامي ,187103 ,Dubai",
        "phone": "97142384840",
        "email": "legalco@eim.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4a5b2020-9a90-4726-b8ef-245a8f009364",
    "firmName": "MUNA ALMULLA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02271",
    "licenseIssueDate": "09/23/2013 00:00:00",
    "licenseExpiryDate": "09/16/2026 00:00:00"
  },
  {
    "id": "9e8e6286-f77d-455d-88a0-8a11cc820238",
    "slug": "aaron-portero-fandino",
    "name": "AARON PORTERO FANDINO",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/02/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Aaron Portero Fandino",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9e8e6286-f77d-455d-88a0-8a11cc820238",
        "address": "Noura Mohamed Abdelrahman Almaazmi ,17 ,The Oberoi Center ,Burlington Tower ,414224 ,Dubai",
        "phone": "97143215777",
        "email": "case@almaazmilawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e56938ba-8d38-4268-9706-651d4c984db9",
    "firmName": "NOURA ALMAAZMI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-04320",
    "licenseIssueDate": "02/21/2019 00:00:00",
    "licenseExpiryDate": "02/20/2020 00:00:00"
  },
  {
    "id": "e58533b1-1ab3-468c-b5fe-97a96c1098a6",
    "slug": "aaron-singh-pooni",
    "name": "Aaron Singh Pooni",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/18/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Aaron Singh Pooni",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e58533b1-1ab3-468c-b5fe-97a96c1098a6",
        "address": "",
        "phone": "97144073901 / 971503479508",
        "email": "Rania.Tadros@stephensonharwood.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dd5042a2-bb41-4123-9544-79c3fa831332",
    "firmName": "Stephenson Harwood (Middle East) LLP",
    "registrationNumber": "L-06908",
    "licenseIssueDate": "08/18/2025 00:00:00",
    "licenseExpiryDate": "08/17/2026 00:00:00"
  },
  {
    "id": "3b837432-9864-421f-95db-b6a1bf04fbd2",
    "slug": "aaron-temple",
    "name": "Aaron Temple",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/05/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Aaron Temple",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3b837432-9864-421f-95db-b6a1bf04fbd2",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-01102",
    "licenseIssueDate": "11/05/2012 00:00:00",
    "licenseExpiryDate": "10/28/2026 00:00:00"
  },
  {
    "id": "e562f1ac-1563-4e56-bccd-1982d143798c",
    "slug": "aarti-thadani",
    "name": "Aarti Thadani",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/11/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Aarti Thadani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e562f1ac-1563-4e56-bccd-1982d143798c",
        "address": "ICD Brookfield Place ,Za'abeel 2 ,103747 ,",
        "phone": "97143696300 / 971506008159",
        "email": "mohammed.paracha@nortonrosefulbright.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c4aaee93-0ec4-4982-9a48-a23699492056",
    "firmName": "Norton Rose Fullbright (Middle East) LLP",
    "registrationNumber": "L-03062",
    "licenseIssueDate": "08/11/2015 00:00:00",
    "licenseExpiryDate": "08/06/2026 00:00:00"
  },
  {
    "id": "ecc8f8e0-1513-4773-b202-e2d456e8338f",
    "slug": "abanoub-awni-gobran-rezkalla-hanna",
    "name": "abanoub awni gobran rezkalla hanna",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/21/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: abanoub awni gobran rezkalla hanna",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ecc8f8e0-1513-4773-b202-e2d456e8338f",
        "address": "الخطوط الاردنية ,بيزنس افينو ,الرستماني  ,00 ,Dubai",
        "phone": "97145468245 / 971505003153",
        "email": "AJ@alzeyoudiadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "920b183d-3abe-4de5-8df6-79ab571d2d74",
    "firmName": "FAHAD SAEED ALZEYOUDI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05678",
    "licenseIssueDate": "12/21/2022 00:00:00",
    "licenseExpiryDate": "12/20/2025 00:00:00"
  },
  {
    "id": "5610e338-6908-4c89-8bcf-659dbc9c7fea",
    "slug": "abbas-ahmed-abbas-elbahrawy",
    "name": "Abbas Ahmed Abbas Elbahrawy",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/26/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abbas Ahmed Abbas Elbahrawy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5610e338-6908-4c89-8bcf-659dbc9c7fea",
        "address": "OMAR MOHAMMED SHARIF ,1 ,THE VILLGE ,JUMAIURAH MOUSQE ,341 ,Dubai",
        "phone": "97143336699 / 971508899153",
        "email": "oslawyer007@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "28a8ce78-f0bd-48d6-98f4-daaba78a6427",
    "firmName": "OMAR SHARIF ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03432",
    "licenseIssueDate": "01/26/2024 00:00:00",
    "licenseExpiryDate": "01/25/2026 00:00:00"
  },
  {
    "id": "30fbc3ba-0806-4fb7-aca0-818bc6a2df9b",
    "slug": "abboud-mardini",
    "name": "Abboud Mardini",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/04/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abboud Mardini",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_30fbc3ba-0806-4fb7-aca0-818bc6a2df9b",
        "address": "Ahmed Mohammed Matar Matar Almheiri ,4 ,SOBHA SAPPHIRE ,Bussines Bay ,393294 ,Dubai",
        "phone": "97143387880 / 971506478881",
        "email": "almheiricourts@bridgelg.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4cb37c1d-1403-421d-bc15-9451cc629e9d",
    "firmName": "AHMED MATAR AL MHEIRI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-03879",
    "licenseIssueDate": "10/04/2017 00:00:00",
    "licenseExpiryDate": "10/01/2026 00:00:00"
  },
  {
    "id": "8548ac96-a104-4776-b1e8-6fd6e3787eb0",
    "slug": "abdalla-abdelmoaz-abdalla-ibrahim",
    "name": "ABDALLA ABDELMOAZ ABDALLA IBRAHIM",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/23/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ABDALLA ABDELMOAZ ABDALLA IBRAHIM",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8548ac96-a104-4776-b1e8-6fd6e3787eb0",
        "address": "",
        "phone": "97143212555",
        "email": "awigdubai@awiglaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ece8ea60-9ecb-4d8c-aca3-fb73e4e52406",
    "firmName": "AL WASL INTERNATIONAL GROUP - ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04716",
    "licenseIssueDate": "07/23/2020 00:00:00",
    "licenseExpiryDate": "07/22/2026 00:00:00"
  },
  {
    "id": "3531bc91-3d5d-406b-804f-39308c7c7eac",
    "slug": "abdalla-aboubakr-mohyeldin-amin",
    "name": "ABDALLA ABOUBAKR MOHYELDIN AMIN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/13/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ABDALLA ABOUBAKR MOHYELDIN AMIN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3531bc91-3d5d-406b-804f-39308c7c7eac",
        "address": "RASHID ALI ,2 ,DUBAI NATIONAL INSURACE  ,DEIRA CITY CENTER ,117277 ,Dubai",
        "phone": "97144214021 / 971551191143",
        "email": "ra_huraithi@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "1db67184-8393-4efd-a82c-3b72528a605a",
    "firmName": "RASHID ALNAGBI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-04183",
    "licenseIssueDate": "08/13/2018 00:00:00",
    "licenseExpiryDate": "08/12/2026 00:00:00"
  },
  {
    "id": "22a862b6-18ad-487f-9f8a-d1ba149c7f1d",
    "slug": "abdalla-ahmed-ahmed",
    "name": "Abdalla Ahmed Ahmed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/12/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abdalla Ahmed Ahmed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_22a862b6-18ad-487f-9f8a-d1ba149c7f1d",
        "address": "الطابق الخامس ,الساحة ,سوق البحار ,26011 ,Dubai",
        "phone": "97142277717",
        "email": "info@alsahlawico.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a6811a79-5470-4c33-ad95-3ff8f661c052",
    "firmName": "AL SAHLAWI & CO ADVOCATES & CONSULTANTS",
    "registrationNumber": "L-01403",
    "licenseIssueDate": "10/12/2020 00:00:00",
    "licenseExpiryDate": "10/11/2026 00:00:00"
  },
  {
    "id": "58c92b90-c724-469f-af39-cb62dcb926d7",
    "slug": "abdalla-eisa",
    "name": "Abdalla Eisa",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/08/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-07-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abdalla Eisa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_58c92b90-c724-469f-af39-cb62dcb926d7",
        "address": "الطابق 7 مكتب رقم 070A ,برج رولكس  ,محطة مترو المركز المالي  ,66300 ,Dubai",
        "phone": "97143444029",
        "email": "ekp.khalidaltmimi@ekplegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "400838f1-4e75-4836-9698-b9e19dd30a18",
    "firmName": "KHALID ABDALLA ALTAMIMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03381",
    "licenseIssueDate": "02/08/2024 00:00:00",
    "licenseExpiryDate": "02/07/2026 00:00:00"
  },
  {
    "id": "615e279e-b1b8-407a-9514-794946e46327",
    "slug": "abdalla-elsayed-elsayed-ibrahim",
    "name": "Abdalla Elsayed Elsayed Ibrahim",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abdalla Elsayed Elsayed Ibrahim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_615e279e-b1b8-407a-9514-794946e46327",
        "address": "",
        "phone": "97100000000",
        "email": "dubai@ahlegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "eae5fb25-fd19-436c-8668-3ac309424db4",
    "firmName": "ALI HABIB AND ASSOCIATES ADVOCATES AND LEGAL CONSULTANCY",
    "registrationNumber": "L-01836",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "5bf10a26-b2ad-4ed2-8e77-80295aa9678d",
    "slug": "abdalla-ibrahim-yousif-arab-al-zaabi",
    "name": "ABDALLA IBRAHIM YOUSIF ARAB ALZAABI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/09/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2024-09-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abdalla Ibrahim Yousif Arab Al Zaabi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5bf10a26-b2ad-4ed2-8e77-80295aa9678d",
        "address": "Office No.WH2-04A-M-52 ,P2/Block A ,Saih Shuaib 3 ,000 ,Dubai",
        "phone": "97140000000 / 971525525252",
        "email": "alzaabbi@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "13ef60e9-93aa-4118-937c-43385ae6c7b4",
    "firmName": "Abdalla AlZaabi Legal Consultants L.L.C",
    "registrationNumber": "L-06009",
    "licenseIssueDate": "09/27/2023 00:00:00",
    "licenseExpiryDate": "09/26/2024 00:00:00"
  },
  {
    "id": "50110e9f-590d-4cdb-9d70-4d95e301dd99",
    "slug": "abdalla-mohamed-ahmed",
    "name": "Abdalla Mohamed Ahmed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abdalla Mohamed Ahmed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_50110e9f-590d-4cdb-9d70-4d95e301dd99",
        "address": "السادس , مباني الحضيبة للجوائز  ,علم الاتحاد ,200 ,Dubai",
        "phone": "97143545111",
        "email": "altaher_alsabri@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "aced7900-0571-43e1-b49b-4740c6dc298f",
    "firmName": "AL TAHER & AL SABRI ADVOCATES",
    "registrationNumber": "L-02219",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "6ec83e97-6714-4566-9f73-bd2f5300aad8",
    "slug": "abdallah-feras-mohammad-doudin",
    "name": "Abdallah Feras Mohammad Doudin",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/01/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abdallah Feras Mohammad Doudin",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6ec83e97-6714-4566-9f73-bd2f5300aad8",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-05348",
    "licenseIssueDate": "06/01/2022 00:00:00",
    "licenseExpiryDate": "05/31/2026 00:00:00"
  },
  {
    "id": "95a5e4e3-3925-4f14-9b9c-ebd3e91492db",
    "slug": "abdallah-mohamed-mohamed-shebl-bargal",
    "name": "Abdallah Mohamed Mohamed Shebl Bargal",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/25/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abdallah Mohamed Mohamed Shebl Bargal",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_95a5e4e3-3925-4f14-9b9c-ebd3e91492db",
        "address": "",
        "phone": "",
        "email": "info@abeeradvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "1bb062dc-0c34-48e7-ae21-6d47ad68302f",
    "firmName": "ABEER MUSABBAH OBAID ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04705",
    "licenseIssueDate": "06/25/2020 00:00:00",
    "licenseExpiryDate": "06/24/2026 00:00:00"
  },
  {
    "id": "b1508174-7e17-4d31-8e5e-60a05d666dc7",
    "slug": "abdallah-mohammed-hemdan-refaie",
    "name": "Abdallah Mohammed Hemdan Refaie",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/29/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abdallah Mohammed Hemdan Refaie",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b1508174-7e17-4d31-8e5e-60a05d666dc7",
        "address": "saeed juma saeed alsuwaidi ,الثامن عشر مكتب 1801 ,almasraf tower ,بجوار بلدية دبي ,36997 ,Dubai",
        "phone": "97142567771",
        "email": "info@saeedalsuwaidi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "bdfc9a52-bffc-4712-acc9-96eb498c7238",
    "firmName": "SAEED ALSUWAIDI LAWYERS & LEGAL CONSULTANTS",
    "registrationNumber": "L-01865",
    "licenseIssueDate": "09/29/2011 00:00:00",
    "licenseExpiryDate": "09/20/2026 00:00:00"
  },
  {
    "id": "c06155e0-7c5e-4050-82fc-9a8968282e51",
    "slug": "abdalmeged-ahmed-abdalmeged-ahmed-alsweedy",
    "name": "Abdalmeged Ahmed Abdalmeged Ahmed Alsweedy",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/15/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abdalmeged Ahmed Abdalmeged Ahmed Alsweedy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c06155e0-7c5e-4050-82fc-9a8968282e51",
        "address": "",
        "phone": "97143937700",
        "email": "info@galadarilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d863b662-c864-4193-8b3a-ff6ee5fe6c64",
    "firmName": "GALADARI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04873",
    "licenseIssueDate": "03/15/2021 00:00:00",
    "licenseExpiryDate": "03/14/2026 00:00:00"
  },
  {
    "id": "c276d5b1-a208-49e6-bb52-6dc72dad6295",
    "slug": "abdel-hakim-berrah",
    "name": "Abdel Hakim BERRAH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/05/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abdel Hakim BERRAH",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c276d5b1-a208-49e6-bb52-6dc72dad6295",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-05521",
    "licenseIssueDate": "10/05/2022 00:00:00",
    "licenseExpiryDate": "10/04/2025 00:00:00"
  },
  {
    "id": "f62c164b-8fc7-4f24-bb88-f24ed5e4b775",
    "slug": "abdel-rahman-nashaat-ismail-ziada",
    "name": "ABDEL RAHMAN NASHAAT ISMAIL ZIADA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/22/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ABDEL RAHMAN NASHAAT ISMAIL ZIADA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f62c164b-8fc7-4f24-bb88-f24ed5e4b775",
        "address": "khalid al kaitoob ,12 ,نسيمية تاور الطابق 12 1202 B ,فندق الفوكو  ,10755 ,Dubai",
        "phone": "97143586555",
        "email": "info@alkaitooblawyer.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "403277a6-eef2-4cfd-af95-9959280d6b40",
    "firmName": "AL KAITOOB ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06157",
    "licenseIssueDate": "12/22/2023 00:00:00",
    "licenseExpiryDate": "12/21/2025 00:00:00"
  },
  {
    "id": "bbac104b-61cc-45dd-a729-08f5eac88633",
    "slug": "abdel-samad-mahmoud-alrezej",
    "name": "Abdel Samad Mahmoud Alrezej",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/28/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abdel Samad Mahmoud Alrezej",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bbac104b-61cc-45dd-a729-08f5eac88633",
        "address": "بلوك بي  ,R338 ,بجانب بناية سيتي بنك - بجوار مركز وافي  ,0554060326 ,Dubai",
        "phone": "97143337444",
        "email": "info@alsuwaidi-advo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "525230a9-87e0-4951-b745-c8d2a983cf8e",
    "firmName": "ABDULLA AL SUWAIDI ADVOCATES & LEGAL CONSULTANT",
    "registrationNumber": "L-04123",
    "licenseIssueDate": "05/28/2018 00:00:00",
    "licenseExpiryDate": "05/26/2026 00:00:00"
  },
  {
    "id": "e813369b-e3ae-48fb-b115-8fe5a1dc3633",
    "slug": "abdelalim-ahmed-mahmoud-mohamed",
    "name": "Abdelalim Ahmed Mahmoud Mohamed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/03/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abdelalim Ahmed Mahmoud Mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e813369b-e3ae-48fb-b115-8fe5a1dc3633",
        "address": "18 ,برج السلام ,سما تاور ,68068 ,Dubai",
        "phone": "97143519700 / 971507973939",
        "email": "info@ramadanlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "08cb3f04-3a05-4815-9f28-6aa33c4b63dd",
    "firmName": "AHMED RAMADAN ADVOCATES &LEGAL CONSULTANTS",
    "registrationNumber": "L-06397",
    "licenseIssueDate": "07/03/2024 00:00:00",
    "licenseExpiryDate": "07/02/2026 00:00:00"
  },
  {
    "id": "19280b63-0045-4ebb-8560-6b0f35a35548",
    "slug": "abdelazim-sayed-ahmed-abdelazim-zaher",
    "name": "abdelazim sayed ahmed abdelazim zaher",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/03/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: abdelazim sayed ahmed abdelazim zaher",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_19280b63-0045-4ebb-8560-6b0f35a35548",
        "address": "Noura Mohamed Abdelrahman Almaazmi ,17 ,The Oberoi Center ,Burlington Tower ,414224 ,Dubai",
        "phone": "97143215777",
        "email": "case@almaazmilawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e56938ba-8d38-4268-9706-651d4c984db9",
    "firmName": "NOURA ALMAAZMI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-04507",
    "licenseIssueDate": "10/03/2019 00:00:00",
    "licenseExpiryDate": "10/02/2026 00:00:00"
  },
  {
    "id": "bdce7941-2d03-49e2-934b-0dc7b6ffea67",
    "slug": "abdelfattah-mabrouk-abdelfattah-aly",
    "name": "Abdelfattah Mabrouk Abdelfattah Aly",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/28/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abdelfattah Mabrouk Abdelfattah Aly",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bdce7941-2d03-49e2-934b-0dc7b6ffea67",
        "address": "omar abdulazizi alomar ,15 ,prime tower ,blom bank france ,211940 ,Dubai",
        "phone": "97143808838 / 971504598082",
        "email": "omar.omar@oghlegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "171b4622-e4ec-4375-a9c4-3637bf6a8b17",
    "firmName": "ALOMAR & ALSABAH ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-06451",
    "licenseIssueDate": "08/28/2024 00:00:00",
    "licenseExpiryDate": "08/27/2026 00:00:00"
  },
  {
    "id": "b8688ed8-3005-4b49-86ff-c43b84dd1fa2",
    "slug": "abdelhadi-ali-enan",
    "name": "Abdelhadi Ali Enan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/25/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abdelhadi Ali Enan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b8688ed8-3005-4b49-86ff-c43b84dd1fa2",
        "address": "",
        "phone": "97143352000",
        "email": "info@alahlialkhaja.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "34476e35-fd77-4a2d-9ad0-cf8cca5e403a",
    "firmName": "AL AHLI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01356",
    "licenseIssueDate": "01/25/2012 00:00:00",
    "licenseExpiryDate": "01/16/2026 00:00:00"
  },
  {
    "id": "876cff09-26f7-4d82-bd17-74702150e2e7",
    "slug": "abdelhak-el-kinany",
    "name": "Abdelhak El Kinany",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/14/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abdelhak El Kinany",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_876cff09-26f7-4d82-bd17-74702150e2e7",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-03904",
    "licenseIssueDate": "11/14/2017 00:00:00",
    "licenseExpiryDate": "11/11/2025 00:00:00"
  },
  {
    "id": "0809106f-8138-4345-b785-9e53cbb20448",
    "slug": "abdelhalim-kadi",
    "name": "Abdelhalim Kadi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abdelhalim Kadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0809106f-8138-4345-b785-9e53cbb20448",
        "address": "Sapphire Tower ,Port Saeed ,28411 ,",
        "phone": "97142287730 / 971506284004",
        "email": "lawfirm@ilf.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "32cfe924-83e7-4945-9ef4-a245de15d0ee",
    "firmName": "The International Law Firm",
    "registrationNumber": "L-01072",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "57f32e61-feaa-44d9-9d63-85953c2110f3",
    "slug": "abdelhalim-mohamed-abdelhalim-aldahma",
    "name": "abdelhalim mohamed abdelhalim aldahma",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/13/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: abdelhalim mohamed abdelhalim aldahma",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_57f32e61-feaa-44d9-9d63-85953c2110f3",
        "address": "الثالث مكتب 304 ,برج سما ,المركز التجاري  ,116623 ,Dubai",
        "phone": "97142723388",
        "email": "info@habibllc.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "373bb6e6-5948-493f-a6ac-2ea343840160",
    "firmName": "HABIB ALHOSANI LAWYERS & LEGAL CONSULTANTS",
    "registrationNumber": "L-05033",
    "licenseIssueDate": "09/13/2021 00:00:00",
    "licenseExpiryDate": "09/12/2026 00:00:00"
  },
  {
    "id": "4d6ba08f-7bf9-4103-81ce-193e0cb787e4",
    "slug": "abdelhamid-elsayed-mohamed-elnebiry",
    "name": "Abdelhamid Elsayed Mohamed Elnebiry",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abdelhamid Elsayed Mohamed Elnebiry",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4d6ba08f-7bf9-4103-81ce-193e0cb787e4",
        "address": "الأول 107 ,ناصر الساير ,فندق أسيانا ,27252 ,Dubai",
        "phone": "97142699255",
        "email": "mona1@lawyer.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4575cb41-efe0-44d1-8595-31c2dbb97e68",
    "firmName": "MUNA AL ANSARI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01443",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "d8715734-42b8-4e77-b4ea-f34ae5eba8bc",
    "slug": "abdelhamid-mohamed-ibrahim",
    "name": "Abdelhamid Mohamed Ibrahim",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abdelhamid Mohamed Ibrahim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d8715734-42b8-4e77-b4ea-f34ae5eba8bc",
        "address": "",
        "phone": "97143298881",
        "email": "info@mslawuae.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2510dab9-717a-4a15-b189-4272261227e3",
    "firmName": "AL MADHANI & AL SHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01563",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "7f4f23fb-2e13-424b-98ff-0036b9fa0788",
    "slug": "abdelmajeed-zwairi",
    "name": "Abdelmajeed Zwairi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBWgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/12/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abdelmajeed Zwairi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7f4f23fb-2e13-424b-98ff-0036b9fa0788",
        "address": "Mohamed Thamer Yaqub Yousef Alserkal ,الطابق الثاني ,اعمار سكوير - بناء رقم 4 ,برج خليفة ,57409 ,Dubai",
        "phone": "97142622217 / 97142622217",
        "email": "mohamed@alserkallawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2a224392-a975-448f-aec5-0460984b1124",
    "firmName": "MOHAMED ALSERKAL ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01512",
    "licenseIssueDate": "09/12/2012 00:00:00",
    "licenseExpiryDate": "09/04/2026 00:00:00"
  },
  {
    "id": "3c84f255-94b5-4a78-8027-bc4960d0e50e",
    "slug": "abdelmawgoud-ahmed-abdelmawgoud-abdelsanad",
    "name": "abdelmawgoud ahmed abdelmawgoud abdelsanad",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/04/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: abdelmawgoud ahmed abdelmawgoud abdelsanad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3c84f255-94b5-4a78-8027-bc4960d0e50e",
        "address": "amna alzaabi ,213 ,مبنى مكاتب عود ميثاء ,سيتي بنك ,16189 ,Dubai",
        "phone": "97145822422",
        "email": "info@amnalegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a30322e3-d9be-4ba2-ba94-2ebf6f963319",
    "firmName": "AMNA ALZAABI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04343",
    "licenseIssueDate": "09/04/2025 00:00:00",
    "licenseExpiryDate": "09/03/2026 00:00:00"
  },
  {
    "id": "55456956-915e-4adb-846a-e1c79c2021e0",
    "slug": "abdelmohsen-mohamed-ali",
    "name": "Abdelmohsen Mohamed Ali",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/17/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abdelmohsen Mohamed Ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_55456956-915e-4adb-846a-e1c79c2021e0",
        "address": "MOHAMMED ALI SALMAN AL MARZOOQI ,الثالث  ,السركال  ,معرض سيارات الفطيم  ,39059 ,Dubai",
        "phone": "97142500008",
        "email": "adv.saad@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6bba829c-0392-4c72-a71b-01da72cb24ae",
    "firmName": "MOHAMED SALMAN ADVOCATE & LEGAL CONSULTANCY",
    "registrationNumber": "L-02372",
    "licenseIssueDate": "04/17/2014 00:00:00",
    "licenseExpiryDate": "04/10/2026 00:00:00"
  },
  {
    "id": "c467d673-e119-4815-82ec-ead4db0e2453",
    "slug": "abdelrafea-sheishaa",
    "name": "ABDELRAFEA ABDELHAMID MANDOUR SHEISHAA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/09/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-09-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abdelrafea Sheishaa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c467d673-e119-4815-82ec-ead4db0e2453",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-01404",
    "licenseIssueDate": "10/01/2012 00:00:00",
    "licenseExpiryDate": "09/23/2020 00:00:00"
  },
  {
    "id": "2908577c-2f7f-4710-9f42-6cd4529f8117",
    "slug": "abdelrahman-abdalla-elshafie",
    "name": "Abdelrahman Abdalla Elshafie",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/25/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abdelrahman Abdalla Elshafie",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2908577c-2f7f-4710-9f42-6cd4529f8117",
        "address": "ISMAIL HASSAN EBRAHIM ALSAFFAR ,الطابق الثامن - مكتب 801 AFR ,الصقر للاعمال ,يوجد اسفل البناية مطعم وينديز ,25752 ,Dubai",
        "phone": "97143276805",
        "email": "info@alsaffar-legal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ceb9cbcf-79f3-462d-afe2-aa4c62eff72b",
    "firmName": "ISMAIL ALSAFFAR ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01227",
    "licenseIssueDate": "01/25/2012 00:00:00",
    "licenseExpiryDate": "01/16/2026 00:00:00"
  },
  {
    "id": "8f53ea6f-4c6a-477a-a167-fda815e507b6",
    "slug": "abdelrahman-ashraf-ahmed-shafik",
    "name": "Abdelrahman Ashraf Ahmed Shafik",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/19/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abdelrahman Ashraf Ahmed Shafik",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8f53ea6f-4c6a-477a-a167-fda815e507b6",
        "address": "1 ,Emaar Square 5 ,sheikh mohammed bin rashid BVD ,11987 ,Dubai",
        "phone": "97143043100 / 971507325154",
        "email": "amir.kordvani@pwc.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ea026b18-c93c-4f67-a1f2-4546320f8f3e",
    "firmName": "PWC Legal Middle East LLP",
    "registrationNumber": "L-06831",
    "licenseIssueDate": "05/19/2025 00:00:00",
    "licenseExpiryDate": "05/18/2026 00:00:00"
  },
  {
    "id": "766365f4-0251-4662-875a-1bae3b3c8ea0",
    "slug": "abdelrahman-khaled-said-attia-shalaby",
    "name": "Abdelrahman Khaled Said Attia Shalaby",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/02/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abdelrahman Khaled Said Attia Shalaby",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_766365f4-0251-4662-875a-1bae3b3c8ea0",
        "address": "",
        "phone": "97143937700",
        "email": "info@galadarilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d863b662-c864-4193-8b3a-ff6ee5fe6c64",
    "firmName": "GALADARI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06746",
    "licenseIssueDate": "04/02/2025 00:00:00",
    "licenseExpiryDate": "04/01/2026 00:00:00"
  },
  {
    "id": "5b3b2d30-7fb7-4a39-9ae9-e6684c992aed",
    "slug": "abdelrahman-makki",
    "name": "Abdelrahman Makki",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/20/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abdelrahman Makki",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5b3b2d30-7fb7-4a39-9ae9-e6684c992aed",
        "address": "",
        "phone": "97145799599 / 971457995992",
        "email": "info@lmlegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "fed194c9-41cf-42f3-888e-924faa26b282",
    "firmName": "LUBNA MOOSA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01191",
    "licenseIssueDate": "10/20/2011 00:00:00",
    "licenseExpiryDate": "10/11/2026 00:00:00"
  },
  {
    "id": "c68dbf2c-3dd7-40f0-acec-328de8c83d4a",
    "slug": "abdelsalam-mohamed-awad",
    "name": "Abdelsalam Mohamed Awad",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/11/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abdelsalam Mohamed Awad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c68dbf2c-3dd7-40f0-acec-328de8c83d4a",
        "address": "21 ,Rolex Tower ,Emirates Grand Hotel ,94334 ,Dubai",
        "phone": "97143277772 / 97145584900",
        "email": "info@globaladvocates.net",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9b42810f-1d55-4aea-ac4a-7d9d1b25ac08",
    "firmName": "GLOBAL ADVOCACY & LEGAL COUNSEL",
    "registrationNumber": "L-01748",
    "licenseIssueDate": "10/11/2011 00:00:00",
    "licenseExpiryDate": "10/02/2026 00:00:00"
  },
  {
    "id": "ee620233-4096-4a08-a38c-ca330af4b2f4",
    "slug": "abdelsatar-akilh",
    "name": "Abdelsatar Akilh",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/21/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abdelsatar Akilh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ee620233-4096-4a08-a38c-ca330af4b2f4",
        "address": "الخامس ,مونتانا ,هوم سنتر ,28834 ,Dubai",
        "phone": "97143963739",
        "email": "mousaadv@eim.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "af9dbfb0-4310-41bb-90aa-a3055b865d84",
    "firmName": "EBRAHIM ALI AL MOUSA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01398",
    "licenseIssueDate": "11/21/2012 00:00:00",
    "licenseExpiryDate": "11/13/2025 00:00:00"
  },
  {
    "id": "47698a52-c45b-4734-b657-dafe4c7bbe2b",
    "slug": "abdelwanis-said-abdelrakeeb-abousaif-daghar",
    "name": "Abdelwanis Said Abdelrakeeb Abousaif Daghar",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/26/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abdelwanis Said Abdelrakeeb Abousaif Daghar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_47698a52-c45b-4734-b657-dafe4c7bbe2b",
        "address": "",
        "phone": "97143585135 / 971503564426",
        "email": "info@alansarilaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "42521deb-a4c5-41c9-989c-c10b046f34b5",
    "firmName": "HUMAID ALANSARI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05558",
    "licenseIssueDate": "10/26/2022 00:00:00",
    "licenseExpiryDate": "10/25/2025 00:00:00"
  },
  {
    "id": "88552bae-418d-4fb3-864c-72f56da74f7b",
    "slug": "abdou-ibrahim-mohamed-okba",
    "name": "Abdou Ibrahim Mohamed Okba",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/20/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abdou Ibrahim Mohamed Okba",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_88552bae-418d-4fb3-864c-72f56da74f7b",
        "address": "2 ,BUSINESS AVENUE BUILDING ,NISSAN SHOWROOM  ,95230 ,Dubai",
        "phone": "97142999099",
        "email": "info@alsalmanadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "edc444ef-59f2-4e2d-ad83-413023ea6e33",
    "firmName": "ALSALMAN ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-01964",
    "licenseIssueDate": "01/20/2013 00:00:00",
    "licenseExpiryDate": "01/12/2026 00:00:00"
  },
  {
    "id": "7c98e344-b4de-4d98-b96f-a1e591c1b2e6",
    "slug": "abdul-azeem-so-abdul-samad",
    "name": "Abdul Azeem So Abdul Samad",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/12/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abdul Azeem So Abdul Samad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7c98e344-b4de-4d98-b96f-a1e591c1b2e6",
        "address": "20 ,Index Tower West Tower ,DIFC ,507226 ,Dubai",
        "phone": "97142461900 / 971523391604",
        "email": "patrick.gearon@crsblaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e2ac552e-b9a7-450b-a84d-15119e583220",
    "firmName": "Charles Russell Speechlys LLP",
    "registrationNumber": "L-06623",
    "licenseIssueDate": "12/12/2024 00:00:00",
    "licenseExpiryDate": "12/11/2025 00:00:00"
  },
  {
    "id": "2c05f684-d4ea-4c35-a08a-12ada87bb4ee",
    "slug": "abdul-hannan-mian-mian-abdul-naim",
    "name": "Abdul Hannan Mian Mian Abdul Naim",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/26/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abdul Hannan Mian Mian Abdul Naim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2c05f684-d4ea-4c35-a08a-12ada87bb4ee",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-05003",
    "licenseIssueDate": "07/26/2021 00:00:00",
    "licenseExpiryDate": "07/25/2026 00:00:00"
  },
  {
    "id": "36f622ab-985b-4e23-af7d-788d7ae2066c",
    "slug": "abdul-kharim-shamsudeen",
    "name": "Abdul Kharim Shamsudeen",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abdul Kharim Shamsudeen",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_36f622ab-985b-4e23-af7d-788d7ae2066c",
        "address": "Office 308 ,Owned by ACICO Gulf Real Estate LLC, Dubai branch ,Makani No: 3250094543 ,000 ,Dubai",
        "phone": "97142697998 / 971503567998",
        "email": "info@ayshamslaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0892f012-3fc4-4895-8d3b-abbb036938aa",
    "firmName": "AYESHA ALDHAHERI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01395",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "ec231f5b-f3ec-4052-8098-974a0489c1df",
    "slug": "abdul-mahdi-falah",
    "name": "Abdul Mahdi  Falah",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/20/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-11-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abdul Mahdi  Falah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ec231f5b-f3ec-4052-8098-974a0489c1df",
        "address": "",
        "phone": "97142242514 / 971504533640",
        "email": "falahleg@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "72115619-3e10-432c-a345-048c61fd3382",
    "firmName": "Falah Legal Consultants",
    "registrationNumber": "L-00379",
    "licenseIssueDate": "01/20/2012 00:00:00",
    "licenseExpiryDate": "01/11/2026 00:00:00"
  },
  {
    "id": "f534027f-4bb5-4a08-b5b6-db163f607829",
    "slug": "abdul-sattar-pirzada-abdul-hafeez-pirzada",
    "name": "ABDUL SATTAR PIRZADA ABDUL HAFEEZ PIRZADA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/06/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ABDUL SATTAR PIRZADA ABDUL HAFEEZ PIRZADA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f534027f-4bb5-4a08-b5b6-db163f607829",
        "address": "",
        "phone": "97142659440",
        "email": "info@klaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d42ce31f-e881-40e1-bd66-bf2e5bb9bb1e",
    "firmName": "KHALED ALMARRI & PARTNERS& LEGAL CONSULTATIONS",
    "registrationNumber": "L-06003",
    "licenseIssueDate": "09/06/2023 00:00:00",
    "licenseExpiryDate": "09/05/2026 00:00:00"
  },
  {
    "id": "80a86be7-1035-4470-b795-0e10941eff94",
    "slug": "abdulgadir-abdallah-daffaallah-gudoora",
    "name": "Abdulgadir Abdallah Daffaallah Gudoora",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/08/2017",
    "licenseStatus": "active",
    "licenseExpiry": "2018-08-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abdulgadir Abdallah Daffaallah Gudoora",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_80a86be7-1035-4470-b795-0e10941eff94",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03876",
    "licenseIssueDate": "08/03/2017 00:00:00",
    "licenseExpiryDate": "07/31/2026 00:00:00"
  },
  {
    "id": "5fbe35ee-2af2-4cdb-9c4e-18dc80efa59e",
    "slug": "abdulhaq-mohamed-elhassan-badi",
    "name": "Abdulhaq Mohamed Elhassan Badi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/17/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abdulhaq Mohamed Elhassan Badi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5fbe35ee-2af2-4cdb-9c4e-18dc80efa59e",
        "address": "4th Floor – offices 408 - 411 - 412 ,Business Village Building  - Block B ,Near Clock Tower ,49425 ,Dubai",
        "phone": "97143869999 / 971506446650",
        "email": "advocates@binmeshar.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d4ea63a4-952e-4374-a9df-97a521bb4cd5",
    "firmName": "BIN MESHAR & CO ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05833",
    "licenseIssueDate": "05/17/2023 00:00:00",
    "licenseExpiryDate": "05/16/2026 00:00:00"
  },
  {
    "id": "5604c35f-ee72-4c6e-aa86-38806976bc45",
    "slug": "abdulla-mazen-ishnaneh",
    "name": "Abdulla Mazen Ishnaneh",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abdulla Mazen Ishnaneh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5604c35f-ee72-4c6e-aa86-38806976bc45",
        "address": "",
        "phone": "97143685555",
        "email": "maisa.maarouf@bsabh.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8afa232f-52ff-4dad-82c3-9a04d66eb853",
    "firmName": "B S A AHMED BIN HAZEEM & ASSOCIATES LLP - DIFC",
    "registrationNumber": "L-01622",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "51ba7f61-4ffd-4ee0-be14-03e15c37fc89",
    "slug": "abdulla-mohamed-sultan-jasim-ahmed-alhashili",
    "name": "Abdulla Mohamed Sultan Jasim Ahmed Alhashili",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/04/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abdulla Mohamed Sultan Jasim Ahmed Alhashili",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_51ba7f61-4ffd-4ee0-be14-03e15c37fc89",
        "address": "",
        "phone": "97145953601 / 971508728645",
        "email": "Steven.Bainbridge@gtlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b4146aa6-efd1-41d7-819d-49da46353b0b",
    "firmName": "Greenberg Traurig Limited",
    "registrationNumber": "L-05049",
    "licenseIssueDate": "10/04/2021 00:00:00",
    "licenseExpiryDate": "10/03/2026 00:00:00"
  },
  {
    "id": "23ca50b7-4ab6-4b01-ac62-0d8cf271865e",
    "slug": "abdullah-mutawi",
    "name": "Abdullah Mutawi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/11/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abdullah Mutawi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_23ca50b7-4ab6-4b01-ac62-0d8cf271865e",
        "address": "",
        "phone": "97104309100 / 971564013758",
        "email": "c.royle@taylorwessing.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d51b6f43-8c62-486f-a1ab-6ee3b87c8006",
    "firmName": "Taylor Wessing LLP (Dubai Branch)",
    "registrationNumber": "L-00357",
    "licenseIssueDate": "10/11/2011 00:00:00",
    "licenseExpiryDate": "10/02/2026 00:00:00"
  },
  {
    "id": "b14c3f5d-0681-4ab2-9976-bd7f28a77dd0",
    "slug": "abdullah-nasser-ahmed-al-uwaimri",
    "name": "Abdullah Nasser Ahmed Al Uwaimri",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/08/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abdullah Nasser Ahmed Al Uwaimri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b14c3f5d-0681-4ab2-9976-bd7f28a77dd0",
        "address": "21 ,Rolex Tower ,Emirates Grand Hotel ,94334 ,Dubai",
        "phone": "97143277772 / 97145584900",
        "email": "info@globaladvocates.net",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9b42810f-1d55-4aea-ac4a-7d9d1b25ac08",
    "firmName": "GLOBAL ADVOCACY & LEGAL COUNSEL",
    "registrationNumber": "L-06463",
    "licenseIssueDate": "08/28/2024 00:00:00",
    "licenseExpiryDate": "08/27/2026 00:00:00"
  },
  {
    "id": "371444c1-6ff3-4057-8aca-57d8530a3223",
    "slug": "abdullatif-mali-hafiz",
    "name": "Abdullatif M.Ali Hafiz",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/20/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abdullatif M.Ali Hafiz",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_371444c1-6ff3-4057-8aca-57d8530a3223",
        "address": "FAHD MOHAMED RASHED ALHADOURI ALYAMMAHI ,10 ,MAZE TOWER ,DIFC - FUTURE MUSEUM ,127077 ,Dubai",
        "phone": "97143596555",
        "email": "fhd6767@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4e636842-b67d-49a6-a11f-607b9a136380",
    "firmName": "NOURA ALHAJERI AND FAHD ALHADOURI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02217",
    "licenseIssueDate": "12/20/2016 00:00:00",
    "licenseExpiryDate": "12/16/2025 00:00:00"
  },
  {
    "id": "ae871b77-cb03-4087-a87a-2ca29db157b5",
    "slug": "abdulsattar-aziz-tayah",
    "name": "Abdulsattar Aziz Tayah",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abdulsattar Aziz Tayah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ae871b77-cb03-4087-a87a-2ca29db157b5",
        "address": "الطابق الثالث ,بناية مكاتب عود ميثاء ,سيتي بانك ,78853 ,Dubai",
        "phone": "97142220585 / 971506555166",
        "email": "info@kasadv.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ec4ada87-49a0-432b-a843-e47adccd286f",
    "firmName": "KHALIFA ALSADA ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-02128",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "1e678960-3799-4d18-9480-cc63313ad9cd",
    "slug": "abdultaiyab-gulamhusain-bahrainwala",
    "name": "Abdultaiyab Gulamhusain Bahrainwala",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/01/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abdultaiyab Gulamhusain Bahrainwala",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1e678960-3799-4d18-9480-cc63313ad9cd",
        "address": "",
        "phone": "97144270845",
        "email": "info@khairallahlegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "74569c18-b69d-4159-813d-9923b25d2dca",
    "firmName": "KHAIRALLAH ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05215",
    "licenseIssueDate": "03/01/2022 00:00:00",
    "licenseExpiryDate": "02/28/2026 00:00:00"
  },
  {
    "id": "951cb2ef-99d4-404a-8d47-9054d2ed09bc",
    "slug": "abdulwahid-alulama",
    "name": "Abdulwahid Alulama",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/22/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abdulwahid Alulama",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_951cb2ef-99d4-404a-8d47-9054d2ed09bc",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-02386",
    "licenseIssueDate": "04/22/2013 00:00:00",
    "licenseExpiryDate": "04/14/2026 00:00:00"
  },
  {
    "id": "fa6e36e7-a6b0-4866-8fde-46101e3d9eec",
    "slug": "abdus-samad",
    "name": "Abdus Samad",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/28/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abdus Samad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fa6e36e7-a6b0-4866-8fde-46101e3d9eec",
        "address": "",
        "phone": "97143303900 / 971561753537",
        "email": "christopher@afridi-angell.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "30ce50dc-01a6-499d-8ace-3f807ddcb08d",
    "firmName": "Afridi & Angell-DED",
    "registrationNumber": "L-00101",
    "licenseIssueDate": "11/28/2016 00:00:00",
    "licenseExpiryDate": "11/24/2025 00:00:00"
  },
  {
    "id": "edfc17f5-0262-4c6d-81cb-ef814b109e7a",
    "slug": "abdussalam-mohamed-wali",
    "name": "Abdussalam Mohamed Wali",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/13/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abdussalam Mohamed Wali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_edfc17f5-0262-4c6d-81cb-ef814b109e7a",
        "address": "One Central, The Offices 5 ,Dubai World Trade Centre ,554660 ,",
        "phone": "97142052030 / 971506566494",
        "email": "chourani@houranipartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "59a73632-40a0-4849-b120-4308dc6f8015",
    "firmName": "Hourani & Partners Legal Consultancy FZCO",
    "registrationNumber": "L-07006"
  },
  {
    "id": "eedf5673-5650-463f-aeed-06c0e6feae9c",
    "slug": "abeer-jarrar",
    "name": "Abeer Jarrar",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abeer Jarrar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_eedf5673-5650-463f-aeed-06c0e6feae9c",
        "address": "Al Fattan Currency House Tower 2 ,DIFC ,507176 ,",
        "phone": "/ 971552009003",
        "email": "Mohammad.AlRasheed@bakermckenzie.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "acd81e81-dead-4f7c-839e-0f2a57897265",
    "firmName": "Baker & Mckenzie LLP",
    "registrationNumber": "L-00128",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "0c4c9340-6c48-4589-8464-3ec3b21964eb",
    "slug": "abhimanyu-jalan",
    "name": "Abhimanyu Jalan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/11/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abhimanyu Jalan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0c4c9340-6c48-4589-8464-3ec3b21964eb",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-00256",
    "licenseIssueDate": "10/11/2011 00:00:00",
    "licenseExpiryDate": "10/02/2026 00:00:00"
  },
  {
    "id": "81991b03-2b26-42f5-9839-22b72db13e9b",
    "slug": "abhishek-banerji-arup-banerji",
    "name": "Abhishek Banerji Arup Banerji",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/27/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abhishek Banerji Arup Banerji",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_81991b03-2b26-42f5-9839-22b72db13e9b",
        "address": "الطابق 7 مكتب رقم 070A ,برج رولكس  ,محطة مترو المركز المالي  ,66300 ,Dubai",
        "phone": "97143444029",
        "email": "ekp.khalidaltmimi@ekplegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "400838f1-4e75-4836-9698-b9e19dd30a18",
    "firmName": "KHALID ABDALLA ALTAMIMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05625",
    "licenseIssueDate": "11/27/2023 00:00:00",
    "licenseExpiryDate": "11/26/2025 00:00:00"
  },
  {
    "id": "981854f4-30a3-4998-b93b-5f2691effee3",
    "slug": "abigail-cannon",
    "name": "Abigail Cannon",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/21/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abigail Cannon",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_981854f4-30a3-4998-b93b-5f2691effee3",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-06472",
    "licenseIssueDate": "08/21/2024 00:00:00",
    "licenseExpiryDate": "08/20/2026 00:00:00"
  },
  {
    "id": "705fa6f8-64e2-4f3a-ba44-ebbab384b9d7",
    "slug": "abigail-mary-ali-peepper",
    "name": "Abigail Mary Ali Peepper",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/04/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abigail Mary Ali Peepper",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_705fa6f8-64e2-4f3a-ba44-ebbab384b9d7",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-06033",
    "licenseIssueDate": "10/04/2023 00:00:00",
    "licenseExpiryDate": "10/03/2026 00:00:00"
  },
  {
    "id": "2640e83b-89fe-4d12-b896-cbe14e89ece4",
    "slug": "abigail-tiffany-roycroft-davis",
    "name": "Abigail Tiffany Roycroft Davis",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/01/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abigail Tiffany Roycroft Davis",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2640e83b-89fe-4d12-b896-cbe14e89ece4",
        "address": "",
        "phone": "97145953601 / 971508728645",
        "email": "Steven.Bainbridge@gtlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b4146aa6-efd1-41d7-819d-49da46353b0b",
    "firmName": "Greenberg Traurig Limited",
    "registrationNumber": "L-06972",
    "licenseIssueDate": "09/24/2025 00:00:00",
    "licenseExpiryDate": "09/23/2026 00:00:00"
  },
  {
    "id": "9004952e-1f57-45b7-9c91-05ba71aa907a",
    "slug": "abu-almawaheb-mohamed-mohamed",
    "name": "Abu Almawaheb Mohamed Mohamed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abu Almawaheb Mohamed Mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9004952e-1f57-45b7-9c91-05ba71aa907a",
        "address": "الطابق 23 - مكتب رقم 2304 ,ايريس باي ,رقم مكاني: 2466086696 ,23328 ,Dubai",
        "phone": "97143250002 / 971508090162",
        "email": "aflawfirm@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "72fce5f8-422f-47e1-b013-84b844329982",
    "firmName": "ABDULLA MATAR ALFALASI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01232",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "851cbccf-7438-4a11-976e-4a41f555570f",
    "slug": "abu-midian-mamoun-karom",
    "name": "Abu Midian Mamoun Karom",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/24/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abu Midian Mamoun Karom",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_851cbccf-7438-4a11-976e-4a41f555570f",
        "address": "",
        "phone": "97144472020",
        "email": "info@arnadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e6573267-5872-48d8-add1-06a3deccf9e4",
    "firmName": "ABDUL RAHMAN NASEEB ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02336",
    "licenseIssueDate": "09/24/2013 00:00:00",
    "licenseExpiryDate": "09/17/2026 00:00:00"
  },
  {
    "id": "9490ad98-3ffa-4bef-872a-8a7802a2040b",
    "slug": "abumadyan-wedaatalla-mohamad-yousif",
    "name": "ABUMADYAN WEDAATALLA MOHAMAD YOUSIF",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/15/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ABUMADYAN WEDAATALLA MOHAMAD YOUSIF",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9490ad98-3ffa-4bef-872a-8a7802a2040b",
        "address": "",
        "phone": "97144270845",
        "email": "info@khairallahlegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "74569c18-b69d-4159-813d-9923b25d2dca",
    "firmName": "KHAIRALLAH ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05430",
    "licenseIssueDate": "05/15/2025 00:00:00",
    "licenseExpiryDate": "05/14/2026 00:00:00"
  },
  {
    "id": "79b77b1a-ceac-4cec-b080-f9418c7e49ec",
    "slug": "achmet-el-sarkaoui",
    "name": "Achmet El Sarkaoui",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/25/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Achmet El Sarkaoui",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_79b77b1a-ceac-4cec-b080-f9418c7e49ec",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-06562",
    "licenseIssueDate": "10/25/2024 00:00:00",
    "licenseExpiryDate": "10/24/2026 00:00:00"
  },
  {
    "id": "62da6cd6-61cd-4cbd-856a-ea52023f1452",
    "slug": "adain-shakoy-soshanah-bailey",
    "name": "Adain Shakoy Soshanah Bailey",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/06/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Adain Shakoy Soshanah Bailey",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_62da6cd6-61cd-4cbd-856a-ea52023f1452",
        "address": "Level 17, ICD Brookfield Place ,DIFC ,506503 ,",
        "phone": "97144375100 / 971588271196",
        "email": "libby.edwards-smith@gowlingwlg.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "436703ba-b9c0-4dcb-93b2-1299c7a051f4",
    "firmName": "Gowling WLG (UK) LLP (Dubai Branch)",
    "registrationNumber": "L-06577",
    "licenseIssueDate": "10/25/2024 00:00:00",
    "licenseExpiryDate": "10/24/2026 00:00:00"
  },
  {
    "id": "f1858daa-68d1-4635-b50b-6a25439a5d13",
    "slug": "adam-banks",
    "name": "Adam Banks",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/24/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Adam Banks",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f1858daa-68d1-4635-b50b-6a25439a5d13",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-02934",
    "licenseIssueDate": "03/24/2015 00:00:00",
    "licenseExpiryDate": "03/18/2026 00:00:00"
  },
  {
    "id": "8988a41e-efd9-4d98-b69c-36c2bd22ffd8",
    "slug": "adam-bradshaw",
    "name": "Adam Bradshaw",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/30/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Adam Bradshaw",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8988a41e-efd9-4d98-b69c-36c2bd22ffd8",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-02992",
    "licenseIssueDate": "03/30/2015 00:00:00",
    "licenseExpiryDate": "03/24/2026 00:00:00"
  },
  {
    "id": "a1b08581-7222-4d20-ae39-5c62b0c4231d",
    "slug": "adam-christopher-perry",
    "name": "Adam Christopher Perry",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/13/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Adam Christopher Perry",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a1b08581-7222-4d20-ae39-5c62b0c4231d",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-06230",
    "licenseIssueDate": "03/13/2024 00:00:00",
    "licenseExpiryDate": "03/12/2026 00:00:00"
  },
  {
    "id": "09f0f2d7-a91a-4ede-89f9-ac67214dfcb0",
    "slug": "adam-derek-laking",
    "name": "Adam Derek Laking",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/30/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Adam Derek Laking",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_09f0f2d7-a91a-4ede-89f9-ac67214dfcb0",
        "address": "",
        "phone": "97144230555 / 971504788443",
        "email": "yah@hfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c462c65e-185a-4e81-8425-a87e3a2b6842",
    "firmName": "Holman Fenwick Willan Middle East LLP",
    "registrationNumber": "L-06769",
    "licenseIssueDate": "04/30/2025 00:00:00",
    "licenseExpiryDate": "04/29/2026 00:00:00"
  },
  {
    "id": "dafdf263-6f4f-4220-ad67-78435a736859",
    "slug": "adam-haque",
    "name": "Adam Haque",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/13/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Adam Haque",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dafdf263-6f4f-4220-ad67-78435a736859",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-02658",
    "licenseIssueDate": "10/13/2014 00:00:00",
    "licenseExpiryDate": "10/07/2026 00:00:00"
  },
  {
    "id": "fd8e2379-3874-4484-ac29-5691cd4fe803",
    "slug": "adam-joseph-pryor",
    "name": "Adam Joseph Pryor",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/08/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Adam Joseph Pryor",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fd8e2379-3874-4484-ac29-5691cd4fe803",
        "address": "Al Fattan Currency House - Tower 1  ,Dubai International Financial Center  ,507104 ,",
        "phone": "97143978565 / 971504587822",
        "email": "Raafat.hares@dwf.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6e5f6dba-07af-4109-8c34-175296450f94",
    "firmName": "DWF (Middle East) LLP",
    "registrationNumber": "L-04090",
    "licenseIssueDate": "05/08/2018 00:00:00",
    "licenseExpiryDate": "05/06/2026 00:00:00"
  },
  {
    "id": "a3d2794c-b5c5-4135-b5ea-8f68447b9f95",
    "slug": "adam-nicholas-halewood",
    "name": "Adam Nicholas Halewood",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/11/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Adam Nicholas Halewood",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a3d2794c-b5c5-4135-b5ea-8f68447b9f95",
        "address": "0 ,ICD Brookfield Place Level 13 ,Trade Centre ,506569 ,Dubai",
        "phone": "97145099100 / 971501006965",
        "email": "menahr@freshfields.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "970f6246-e737-41a7-9c6c-5aa5b8335d45",
    "firmName": "Freshfields LLP DIFC",
    "registrationNumber": "L-03993",
    "licenseIssueDate": "02/11/2018 00:00:00",
    "licenseExpiryDate": "02/08/2026 00:00:00"
  },
  {
    "id": "908b7f19-25c8-42bb-9a9f-ed001c0afbec",
    "slug": "adam-patrick-fadian",
    "name": "Adam Patrick Fadian",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/01/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Adam Patrick Fadian",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_908b7f19-25c8-42bb-9a9f-ed001c0afbec",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-04227",
    "licenseIssueDate": "07/01/2021 00:00:00",
    "licenseExpiryDate": "06/30/2026 00:00:00"
  },
  {
    "id": "e457a5c9-a059-40b9-96a8-25e143a978ee",
    "slug": "adam-souheil-reda",
    "name": "Adam Souheil Reda",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/01/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Adam Souheil Reda",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e457a5c9-a059-40b9-96a8-25e143a978ee",
        "address": "ICD-Brookfield Place ,DIFC ,119974 ,",
        "phone": "97143652000",
        "email": "david.charlier@ashurst.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c01c3c61-4d90-4058-8429-61dd01e615f5",
    "firmName": "Ashurst LLP-DIFC",
    "registrationNumber": "L-05738",
    "licenseIssueDate": "03/01/2023 00:00:00",
    "licenseExpiryDate": "02/28/2026 00:00:00"
  },
  {
    "id": "90c2ca1e-8c75-4cba-8253-e44c0f979978",
    "slug": "adam-vause",
    "name": "Adam Vause",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBVgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/10/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Adam Vause",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_90c2ca1e-8c75-4cba-8253-e44c0f979978",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-00492",
    "licenseIssueDate": "01/10/2012 00:00:00",
    "licenseExpiryDate": "01/01/2026 00:00:00"
  },
  {
    "id": "0a611835-6037-4708-b4ce-e05b4a748226",
    "slug": "adam-wariss-ismail",
    "name": "ADAM WARISS ISMAIL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/26/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ADAM WARISS ISMAIL",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0a611835-6037-4708-b4ce-e05b4a748226",
        "address": "",
        "phone": "97144363636 / 971505572900",
        "email": "hassan.elsayed@bakerbotts.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "fd5d6571-d053-4436-9de5-c8a36ce7c6c9",
    "firmName": "Baker Botts LLP Legal Consultants Dubai Branch",
    "registrationNumber": "L-05931",
    "licenseIssueDate": "07/26/2023 00:00:00",
    "licenseExpiryDate": "07/25/2026 00:00:00"
  },
  {
    "id": "473c42eb-5df1-4612-9dfb-571d849cd67e",
    "slug": "adam-wolstenholme",
    "name": "Adam Wolstenholme",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/18/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Adam Wolstenholme",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_473c42eb-5df1-4612-9dfb-571d849cd67e",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506688 ,Dubai",
        "phone": "97147096600 / 971503556811",
        "email": "muneer.khan@simmons-simmons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d1725ca7-06ac-41b2-8d7b-a6e60665b73d",
    "firmName": "Simmons & Simmons (Middle East) LLP-DIFC",
    "registrationNumber": "L-03614",
    "licenseIssueDate": "12/18/2016 00:00:00",
    "licenseExpiryDate": "12/14/2025 00:00:00"
  },
  {
    "id": "a46582b8-0287-4094-b6a1-0c40d39f7bb2",
    "slug": "adel-abdellatif-abdou-ali",
    "name": "Adel Abdellatif Abdou Ali",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Adel Abdellatif Abdou Ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a46582b8-0287-4094-b6a1-0c40d39f7bb2",
        "address": "HASSAN AL BAKRI ,16 ,THE EXCHANGE TOWER ,DUBAI WATER CANAL ,89179 ,Dubai",
        "phone": "97145807888",
        "email": "secretary@alkathirilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b5f1d60b-df9b-4054-ac59-4543a6d06af4",
    "firmName": "SHOUQ ALKATHIRI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01526",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "d59068d5-3c27-4c43-b0f3-fee6d1233584",
    "slug": "adel-ahmed-mohamed",
    "name": "Adel Ahmed Mohamed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/08/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Adel Ahmed Mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d59068d5-3c27-4c43-b0f3-fee6d1233584",
        "address": "",
        "phone": "97148321212",
        "email": "nasser@nmlawyers.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "71709458-e40a-45b3-9319-4c51c18891be",
    "firmName": "NASSER MALALLA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02995",
    "licenseIssueDate": "04/08/2015 00:00:00",
    "licenseExpiryDate": "04/02/2026 00:00:00"
  },
  {
    "id": "f26665c7-e816-487c-807e-2e4993864de5",
    "slug": "adel-ali-elmetkel",
    "name": "Adel Ali Elmetkel",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Adel Ali Elmetkel",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f26665c7-e816-487c-807e-2e4993864de5",
        "address": "mansoor lootah ,مطعم شيلز ,صالح بن لاحج , مطعم شيلز  ,95151 ,Dubai",
        "phone": "97142833337 / 971559596445",
        "email": "info@mansoorlootahadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4488ad94-e6b8-4b33-8e21-04e8986bf218",
    "firmName": "MANSOOR LOTAAH ADVOCATES &LEGAL CONSULTANCY",
    "registrationNumber": "L-01427",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "e6b8b757-54ae-4555-b1ce-91b9e9776b5e",
    "slug": "adel-attia-mahmoud-emam",
    "name": "Adel Attia Mahmoud Emam",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/14/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Adel Attia Mahmoud Emam",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e6b8b757-54ae-4555-b1ce-91b9e9776b5e",
        "address": "Hussain Ali Al Jaziri ,11 ,City Tower 2 ,Crown Plaza hotel Sheikh Zayed Road ,4253 ,Dubai",
        "phone": "97142626777 / 971529087670",
        "email": "courts@jaflaws.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c58d8654-b428-46b3-abd5-024e4331ee53",
    "firmName": "JAAFAR ALWAN & AL JAZIRI & ASSOCIATES",
    "registrationNumber": "L-01854",
    "licenseIssueDate": "01/14/2012 00:00:00",
    "licenseExpiryDate": "01/05/2026 00:00:00"
  },
  {
    "id": "1f2c081f-1667-45d7-babb-639dca09dd59",
    "slug": "adel-elsaid-hassan-hussein-elkerm",
    "name": "Adel Elsaid Hassan Hussein Elkerm",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/25/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Adel Elsaid Hassan Hussein Elkerm",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1f2c081f-1667-45d7-babb-639dca09dd59",
        "address": "ADEL ALSAID  ,203 ,BAY SQUARE-02 ,BAY SQUARE  ,37105 ,Dubai",
        "phone": "97143555253 / 971507562138",
        "email": "hhlegal@hhlegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "93736908-026c-4a6a-bbaf-2e67ee1366c6",
    "firmName": "HADEYA HAMAD ADVOCACY AND LEGAL CONSULTANCY",
    "registrationNumber": "L-03974",
    "licenseIssueDate": "12/25/2017 00:00:00",
    "licenseExpiryDate": "12/22/2025 00:00:00"
  },
  {
    "id": "e4d5ec0d-2390-4973-a3e8-096f33fa3a0d",
    "slug": "adel-hamada-kotb-abouarab",
    "name": "Adel Hamada Kotb Abouarab",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/12/2024",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Adel Hamada Kotb Abouarab",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e4d5ec0d-2390-4973-a3e8-096f33fa3a0d",
        "address": "Hadeel Ali alshaali  ,الطابق السادس  ,بناية زمردة ,بلدية دبي المختبرات المركزية ,212633 ,Dubai",
        "phone": "97165503035",
        "email": "hadeelalshaali_90@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "18a7fc47-63d9-4928-a864-fa55559de45b",
    "firmName": "HADEEL ALSHAALI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06591",
    "licenseIssueDate": "12/05/2024 00:00:00",
    "licenseExpiryDate": "12/04/2025 00:00:00"
  },
  {
    "id": "17f3106c-a1be-49d5-831a-3be4ed923ec0",
    "slug": "adel-mohamed-abdelhay-ghonim",
    "name": "Adel Mohamed Abdelhay Ghonim",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/05/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Adel Mohamed Abdelhay Ghonim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_17f3106c-a1be-49d5-831a-3be4ed923ec0",
        "address": "",
        "phone": "97143355577",
        "email": "daraladalah1991@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "61efd89c-1d0d-4136-8397-2814c745f0da",
    "firmName": "DAR AL ADALAH ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02042",
    "licenseIssueDate": "12/05/2011 00:00:00",
    "licenseExpiryDate": "11/26/2025 00:00:00"
  },
  {
    "id": "5d1ac78e-1306-452a-92e0-fbaf6764bfd1",
    "slug": "adel-shageev",
    "name": "Adel Shageev",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/30/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Adel Shageev",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5d1ac78e-1306-452a-92e0-fbaf6764bfd1",
        "address": "",
        "phone": "97144286300 / 971506256686",
        "email": "stuart.paterson@hsf.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2f0389b3-bfde-44f4-bdd6-6e1a22f9cab2",
    "firmName": "Herbert Smith Freehills Kramer LLP",
    "registrationNumber": "L-05622",
    "licenseIssueDate": "11/30/2022 00:00:00",
    "licenseExpiryDate": "11/29/2025 00:00:00"
  },
  {
    "id": "c6e219a4-ebab-449d-8d26-ad8ff5de5a30",
    "slug": "adela-mues",
    "name": "Adela Mues",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/08/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Adela Mues",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c6e219a4-ebab-449d-8d26-ad8ff5de5a30",
        "address": "Index Tower ,506548 ,Dubai",
        "phone": "97147096300 / 971506767433",
        "email": "amateen@reedsmith.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b3f87e90-7ce9-4097-82c4-15232365f175",
    "firmName": "Reed Smith LLP",
    "registrationNumber": "L-00992",
    "licenseIssueDate": "09/08/2011 00:00:00",
    "licenseExpiryDate": "08/30/2026 00:00:00"
  },
  {
    "id": "af7de033-5fb4-4b90-b73b-767d665649f0",
    "slug": "adela-ottermann",
    "name": "Adela Ottermann",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/09/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Adela Ottermann",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_af7de033-5fb4-4b90-b73b-767d665649f0",
        "address": "",
        "phone": "97144230555 / 971504788443",
        "email": "yah@hfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c462c65e-185a-4e81-8425-a87e3a2b6842",
    "firmName": "Holman Fenwick Willan Middle East LLP",
    "registrationNumber": "L-05008",
    "licenseIssueDate": "08/09/2021 00:00:00",
    "licenseExpiryDate": "08/08/2026 00:00:00"
  },
  {
    "id": "4572a16c-f98f-44fd-80c3-638e1d5986f3",
    "slug": "adhiraj-malhotra-atul-malhotra",
    "name": "ADHIRAJ MALHOTRA ATUL MALHOTRA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/07/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ADHIRAJ MALHOTRA ATUL MALHOTRA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4572a16c-f98f-44fd-80c3-638e1d5986f3",
        "address": "HAMDAN ALSHAMSI ,الطابق الرابع مكتب 401, 406,407 ,بي سكوير 01 ,مجمع دبي سكوير ,116564 ,Dubai",
        "phone": "97143469262",
        "email": "courts@has.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de2c61a6-9d00-457e-ad1d-e73e4e62d9bd",
    "firmName": "HAMDAN ALSHAMSI LAWYER & LEGAL CONSULTANTS",
    "registrationNumber": "L-06890",
    "licenseIssueDate": "07/07/2025 00:00:00",
    "licenseExpiryDate": "07/06/2026 00:00:00"
  },
  {
    "id": "837aa5a4-17a4-48df-b791-3c9b766427a4",
    "slug": "adil-hassan-ali",
    "name": "Adil Hassan Ali",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Adil Hassan Ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_837aa5a4-17a4-48df-b791-3c9b766427a4",
        "address": "العاشر ,المسعود ,بجوار معرض تويوتا ,20085 ,Dubai",
        "phone": "97142945554",
        "email": "ahmedalamiri_law@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "91d66bc6-9b89-4272-9d03-494aed8c3f9e",
    "firmName": "AHMED AL AMIRI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-01669",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "13dd4b09-08ad-4cea-88be-537cff15bf30",
    "slug": "adil-hussain",
    "name": "Adil Hussain",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/14/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Adil Hussain",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_13dd4b09-08ad-4cea-88be-537cff15bf30",
        "address": "Al Fattan Currency House Tower 2 ,DIFC ,507176 ,",
        "phone": "/ 971552009003",
        "email": "Mohammad.AlRasheed@bakermckenzie.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "acd81e81-dead-4f7c-839e-0f2a57897265",
    "firmName": "Baker & Mckenzie LLP",
    "registrationNumber": "L-05619",
    "licenseIssueDate": "12/14/2022 00:00:00",
    "licenseExpiryDate": "12/13/2025 00:00:00"
  },
  {
    "id": "6df1a43e-32c4-4601-9f51-473f32f33676",
    "slug": "adil-khalifa",
    "name": "Adil Khalifa",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Adil Khalifa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6df1a43e-32c4-4601-9f51-473f32f33676",
        "address": "الطابق الثاني - مكتب رقم 203 و 204  ,سيتي أفينو ,سيتى سنتر ديرة  ,83666 ,Dubai",
        "phone": "97142955050",
        "email": "adv.algharib@alghariblawfirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b1e23b77-356c-4678-ae4d-2ff4e494702b",
    "firmName": "ALGHARIB & PARTNERS ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-01383",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "154e449c-7b5f-4438-bf2e-06ddf834e4a5",
    "slug": "adil-shafi-khan",
    "name": "Adil Shafi Khan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/30/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Adil Shafi Khan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_154e449c-7b5f-4438-bf2e-06ddf834e4a5",
        "address": "",
        "phone": "97144529091 / 971552805308",
        "email": "ashafi@ach-legal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "4f3e1e80-c812-4585-9570-229cd96776a4",
    "firmName": "Anjarwalla, Collins and Haidermota Legal Consultants",
    "registrationNumber": "L-01159",
    "licenseIssueDate": "04/30/2013 00:00:00",
    "licenseExpiryDate": "04/22/2026 00:00:00"
  },
  {
    "id": "2855e9e4-6362-4263-a568-caa0e1ec7651",
    "slug": "adite-aloke",
    "name": "Adite Aloke",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/15/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Adite Aloke",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2855e9e4-6362-4263-a568-caa0e1ec7651",
        "address": "",
        "phone": "97143897000 / 971506553198",
        "email": "nasseralikhasawneh@eversheds-sutherland.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "74a21d43-41d8-480a-a6af-6939b7c98a95",
    "firmName": "Eversheds Sutherland (International LLP) Dubai Branch",
    "registrationNumber": "L-02487",
    "licenseIssueDate": "05/15/2016 00:00:00",
    "licenseExpiryDate": "05/11/2026 00:00:00"
  },
  {
    "id": "4c91b9d9-2dcb-44af-a513-22955f38230a",
    "slug": "aditi-sanyal",
    "name": "Aditi Sanyal",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/21/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Aditi Sanyal",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4c91b9d9-2dcb-44af-a513-22955f38230a",
        "address": "ICD Brookfield Place ,Za'abeel 2 ,103747 ,",
        "phone": "97143696300 / 971506008159",
        "email": "mohammed.paracha@nortonrosefulbright.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c4aaee93-0ec4-4982-9a48-a23699492056",
    "firmName": "Norton Rose Fullbright (Middle East) LLP",
    "registrationNumber": "L-00765",
    "licenseIssueDate": "04/21/2021 00:00:00",
    "licenseExpiryDate": "04/20/2026 00:00:00"
  },
  {
    "id": "37e9e26d-ebe5-43e2-9964-69bd7acc25ae",
    "slug": "adjou-ben-idir",
    "name": "Adjou Ben Idir",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/22/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Adjou Ben Idir",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_37e9e26d-ebe5-43e2-9964-69bd7acc25ae",
        "address": "ICD Brookfield Place ,Za'abeel 2 ,103747 ,",
        "phone": "97143696300 / 971506008159",
        "email": "mohammed.paracha@nortonrosefulbright.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c4aaee93-0ec4-4982-9a48-a23699492056",
    "firmName": "Norton Rose Fullbright (Middle East) LLP",
    "registrationNumber": "L-01130",
    "licenseIssueDate": "11/22/2012 00:00:00",
    "licenseExpiryDate": "11/14/2025 00:00:00"
  },
  {
    "id": "0bf6f0e1-8a45-4a68-8fc7-bdfb73be8def",
    "slug": "adnan-abdulrahim-hussain-ibrahim-alameeri",
    "name": "Adnan Abdulrahim Hussain Ibrahim Alameeri",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/31/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Adnan Abdulrahim Hussain Ibrahim Alameeri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0bf6f0e1-8a45-4a68-8fc7-bdfb73be8def",
        "address": "Opal Tower ,Dubai ,392087 ,",
        "phone": "/ 971501152345",
        "email": "info@alameeri-legal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "d3fb2743-87e9-4b67-88f9-a1fd221c9e75",
    "firmName": "Alameeri Legal Consultants L.L.C",
    "registrationNumber": "L-05887",
    "licenseIssueDate": "05/31/2023 00:00:00",
    "licenseExpiryDate": "05/30/2026 00:00:00"
  },
  {
    "id": "e2a3497c-7a58-4f7b-acbf-a0a7439e42b7",
    "slug": "adnan-ahmad-almasri",
    "name": "Adnan ahmad almasri",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/17/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Adnan ahmad almasri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e2a3497c-7a58-4f7b-acbf-a0a7439e42b7",
        "address": "",
        "phone": "97143256020 / 971504400073",
        "email": "info@sw-advocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "05dddabf-0dfa-4843-b0a8-cf6eaa27136d",
    "firmName": "MOHAMMAD SHEHAB ALFARSI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06958",
    "licenseIssueDate": "09/17/2025 00:00:00",
    "licenseExpiryDate": "09/16/2026 00:00:00"
  },
  {
    "id": "86d4602e-3aba-45a1-9c31-4123e67e620f",
    "slug": "adnan-doha",
    "name": "Adnan Doha",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/10/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Adnan Doha",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_86d4602e-3aba-45a1-9c31-4123e67e620f",
        "address": "Al Fattan Currency House Tower 2 ,DIFC ,507176 ,",
        "phone": "/ 971552009003",
        "email": "Mohammad.AlRasheed@bakermckenzie.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "acd81e81-dead-4f7c-839e-0f2a57897265",
    "firmName": "Baker & Mckenzie LLP",
    "registrationNumber": "L-02239",
    "licenseIssueDate": "11/10/2021 00:00:00",
    "licenseExpiryDate": "11/09/2025 00:00:00"
  },
  {
    "id": "bfe66c76-6bb1-470f-a473-789581adeba9",
    "slug": "adnene-gargouri",
    "name": "Adnene Gargouri",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/13/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Adnene Gargouri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bfe66c76-6bb1-470f-a473-789581adeba9",
        "address": "",
        "phone": "97147098484 / 971505577206",
        "email": "slshadmand@jonesday.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8892bfe9-d3ec-4158-b4fd-1844606f4f30",
    "firmName": "Jones Day",
    "registrationNumber": "L-06982"
  },
  {
    "id": "5c049055-61a2-47fa-8ca5-0021b406454c",
    "slug": "adriaan-cornelis-hoeben",
    "name": "Adriaan Cornelis Hoeben",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/30/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Adriaan Cornelis Hoeben",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5c049055-61a2-47fa-8ca5-0021b406454c",
        "address": "",
        "phone": "97143897000 / 971506553198",
        "email": "nasseralikhasawneh@eversheds-sutherland.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "74a21d43-41d8-480a-a6af-6939b7c98a95",
    "firmName": "Eversheds Sutherland (International LLP) Dubai Branch",
    "registrationNumber": "L-05018",
    "licenseIssueDate": "08/30/2021 00:00:00",
    "licenseExpiryDate": "08/29/2026 00:00:00"
  },
  {
    "id": "eb25946b-3f69-4997-92e3-2e11a3c1aaa2",
    "slug": "adrian-chadwick",
    "name": "Adrian Chadwick",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/29/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Adrian Chadwick",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_eb25946b-3f69-4997-92e3-2e11a3c1aaa2",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-02058",
    "licenseIssueDate": "11/29/2011 00:00:00",
    "licenseExpiryDate": "11/20/2025 00:00:00"
  },
  {
    "id": "f1b9bc89-8766-46b8-82ca-4e42c50b4792",
    "slug": "adrian-low",
    "name": "Adrian Low",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/14/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Adrian Low",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f1b9bc89-8766-46b8-82ca-4e42c50b4792",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-00257",
    "licenseIssueDate": "10/14/2022 00:00:00",
    "licenseExpiryDate": "10/13/2026 00:00:00"
  },
  {
    "id": "2203d779-ec42-4f4e-aeb9-1517ea2f615e",
    "slug": "adrianus-schoorl",
    "name": "Adrianus Schoorl",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/26/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Adrianus Schoorl",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2203d779-ec42-4f4e-aeb9-1517ea2f615e",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-00631",
    "licenseIssueDate": "04/26/2024 00:00:00",
    "licenseExpiryDate": "04/25/2026 00:00:00"
  },
  {
    "id": "0050f7f2-e763-45ad-a4a2-1ad033d2e830",
    "slug": "aed-bou-chakra",
    "name": "Aed Bou Chakra",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Aed Bou Chakra",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0050f7f2-e763-45ad-a4a2-1ad033d2e830",
        "address": "ABDULRAHMAN OMAR  ABDULLA MUKHAYER  ,NBK BANK ,LATIFA TOWER  ,NEAR CROWN PLAZA  ,185616 ,Dubai",
        "phone": "97143296968",
        "email": "hlp@hlplawfirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "617b9580-cff5-4ffa-b2bc-8788300a3c6e",
    "firmName": "AL HUQOOQ FOR ADVOCACY AND LEGAL CONSULTANCY",
    "registrationNumber": "L-01201",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "f07bffc0-f847-4014-88fe-a54ec3a11d74",
    "slug": "aeeda-alibrahim",
    "name": "Aeeda Alibrahim",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Aeeda Alibrahim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f07bffc0-f847-4014-88fe-a54ec3a11d74",
        "address": "",
        "phone": "97143937700",
        "email": "info@galadarilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d863b662-c864-4193-8b3a-ff6ee5fe6c64",
    "firmName": "GALADARI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01483",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "a0eebaf2-b686-4a5c-9049-60cf50e2fb2c",
    "slug": "afif-jadallah-ammoury",
    "name": "Afif jadallah Ammoury",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/09/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Afif jadallah Ammoury",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a0eebaf2-b686-4a5c-9049-60cf50e2fb2c",
        "address": "HAMDAN ALSHAMSI ,الطابق الرابع مكتب 401, 406,407 ,بي سكوير 01 ,مجمع دبي سكوير ,116564 ,Dubai",
        "phone": "97143469262",
        "email": "courts@has.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de2c61a6-9d00-457e-ad1d-e73e4e62d9bd",
    "firmName": "HAMDAN ALSHAMSI LAWYER & LEGAL CONSULTANTS",
    "registrationNumber": "L-01990",
    "licenseIssueDate": "02/09/2024 00:00:00",
    "licenseExpiryDate": "02/08/2026 00:00:00"
  },
  {
    "id": "aa4db774-9ae2-4aa2-ab60-b6db70c857bc",
    "slug": "afra-abdelhakim-osman",
    "name": "Afra Abdelhakim Osman",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/07/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Afra Abdelhakim Osman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_aa4db774-9ae2-4aa2-ab60-b6db70c857bc",
        "address": "ادارة ا لمبنى  ,الريم ,الاتصالات  ,42423 ,Dubai",
        "phone": "97142222066",
        "email": "info@ozleco.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7a155f4a-20ec-44ff-863f-4f9fb43d0af4",
    "firmName": "ALOBAIDLI & ALZAROONI ADVOCATES&LEGAL CONSULTANTS",
    "registrationNumber": "L-01380",
    "licenseIssueDate": "03/07/2013 00:00:00",
    "licenseExpiryDate": "02/27/2026 00:00:00"
  },
  {
    "id": "46a06902-7bce-4b9a-9cbd-f77f13ce7e4d",
    "slug": "afraz-hussain",
    "name": "Afraz Hussain",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/23/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Afraz Hussain",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_46a06902-7bce-4b9a-9cbd-f77f13ce7e4d",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-03372",
    "licenseIssueDate": "10/23/2021 00:00:00",
    "licenseExpiryDate": "10/22/2025 00:00:00"
  },
  {
    "id": "a0db9de1-1b1c-48be-beb4-8bd462f765a8",
    "slug": "afsha-karim",
    "name": "Afsha Karim",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Afsha Karim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a0db9de1-1b1c-48be-beb4-8bd462f765a8",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-00201",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "0cf8617c-6242-4669-bbe9-db5ee8995ce9",
    "slug": "agnieszka-maria-gronwald",
    "name": "Agnieszka Maria Gronwald",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/25/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Agnieszka Maria Gronwald",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0cf8617c-6242-4669-bbe9-db5ee8995ce9",
        "address": "",
        "phone": "97142472100 / 971509224336",
        "email": "bhaley@cov.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "65a2e90a-6978-4292-b3f1-ecbebedd7b9a",
    "firmName": "Covington & Burling LLP (Middle East)",
    "registrationNumber": "L-06580",
    "licenseIssueDate": "10/25/2024 00:00:00",
    "licenseExpiryDate": "10/24/2026 00:00:00"
  },
  {
    "id": "09cdda82-aa94-4314-b58c-c3c8b6788460",
    "slug": "ahmad-alrajoub",
    "name": "Ahmad Alrajoub",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/17/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-12-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmad Alrajoub",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_09cdda82-aa94-4314-b58c-c3c8b6788460",
        "address": "الطابق الثاني - مكتب رقم 203 و 204  ,سيتي أفينو ,سيتى سنتر ديرة  ,83666 ,Dubai",
        "phone": "97142955050",
        "email": "adv.algharib@alghariblawfirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b1e23b77-356c-4678-ae4d-2ff4e494702b",
    "firmName": "ALGHARIB & PARTNERS ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-03337",
    "licenseIssueDate": "01/17/2016 00:00:00",
    "licenseExpiryDate": "01/12/2026 00:00:00"
  },
  {
    "id": "35f53e98-1338-4939-b541-dfab6286b37d",
    "slug": "ahmad-mohamad-kamel-alahmar",
    "name": "Ahmad Mohamad Kamel Alahmar",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/28/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmad Mohamad Kamel Alahmar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_35f53e98-1338-4939-b541-dfab6286b37d",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-04934",
    "licenseIssueDate": "04/28/2021 00:00:00",
    "licenseExpiryDate": "04/27/2026 00:00:00"
  },
  {
    "id": "6515a5d0-8460-4ecd-8ef1-50d1600a6cf8",
    "slug": "ahmad-mohamed",
    "name": "Ahmad Mohamed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/06/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmad Mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6515a5d0-8460-4ecd-8ef1-50d1600a6cf8",
        "address": "20 ,Index Tower West Tower ,DIFC ,507226 ,Dubai",
        "phone": "97142461900 / 971523391604",
        "email": "patrick.gearon@crsblaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e2ac552e-b9a7-450b-a84d-15119e583220",
    "firmName": "Charles Russell Speechlys LLP",
    "registrationNumber": "L-00632",
    "licenseIssueDate": "10/06/2019 00:00:00",
    "licenseExpiryDate": "10/05/2026 00:00:00"
  },
  {
    "id": "1eb28819-39cc-4902-b7ec-c847333d7ec9",
    "slug": "ahmad-mohammad-issa-ahmad",
    "name": "Ahmad Mohammad Issa Ahmad",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/08/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmad Mohammad Issa Ahmad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1eb28819-39cc-4902-b7ec-c847333d7ec9",
        "address": "6F 603, 605, 7F 704 ,Crystal Tower ,Dubai Mall ,117538 ,Dubai",
        "phone": "97146098700",
        "email": "pro@miolawfirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "417f90a1-03be-4dab-8eea-1bba7e16f536",
    "firmName": "ABU BAKER SALEM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05092",
    "licenseIssueDate": "11/08/2021 00:00:00",
    "licenseExpiryDate": "11/07/2025 00:00:00"
  },
  {
    "id": "de1c3edc-57db-4a80-a209-0ad971b826ce",
    "slug": "ahmad-mohammad-zaza",
    "name": "Ahmad Mohammad Zaza",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmad Mohammad Zaza",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_de1c3edc-57db-4a80-a209-0ad971b826ce",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01239",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "b8d3a15c-7e37-4430-9ec3-e55dd75fa108",
    "slug": "ahmad-saleh",
    "name": "Ahmad Saleh",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmad Saleh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b8d3a15c-7e37-4430-9ec3-e55dd75fa108",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-00443",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "f25778c0-d9ac-4ca9-93ae-7189eb1af164",
    "slug": "ahmad-sergieh",
    "name": "Ahmad Sergieh",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/29/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmad Sergieh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f25778c0-d9ac-4ca9-93ae-7189eb1af164",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-02059",
    "licenseIssueDate": "11/29/2011 00:00:00",
    "licenseExpiryDate": "11/20/2025 00:00:00"
  },
  {
    "id": "2e63c279-76f1-4ed4-8605-3c38e3567b09",
    "slug": "ahmed-abdalla-elbastawisy-ibrahim",
    "name": "ahmed abdalla elbastawisy ibrahim",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/10/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ahmed abdalla elbastawisy ibrahim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2e63c279-76f1-4ed4-8605-3c38e3567b09",
        "address": "Mezzanine / 09 ,Business Point  ,Behind Nissan Showroom ,85825 ,Dubai",
        "phone": "97142595777",
        "email": "ALMATROOSHI@OMALC.AE",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "588c9e2f-4f09-44bb-9e80-4e56d3f821b6",
    "firmName": "ALOWAIS & AL MATROOSHI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-02205",
    "licenseIssueDate": "03/10/2019 00:00:00",
    "licenseExpiryDate": "03/08/2026 00:00:00"
  },
  {
    "id": "1b59d0d7-f728-45a8-96aa-fbce917a4f7f",
    "slug": "ahmed-abdallah-ali-abdallah",
    "name": "Ahmed Abdallah Ali Abdallah",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/09/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Abdallah Ali Abdallah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1b59d0d7-f728-45a8-96aa-fbce917a4f7f",
        "address": "",
        "phone": "97145650550",
        "email": "uae.courts@qamadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3117b2a0-79c7-477b-b710-1b6eb632bccc",
    "firmName": "QUMASHA ALI MOHAMMAD ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01974",
    "licenseIssueDate": "07/09/2024 00:00:00",
    "licenseExpiryDate": "07/08/2026 00:00:00"
  },
  {
    "id": "6c5f6c42-2695-42f0-be22-ad24e954d7e5",
    "slug": "ahmed-abdallah-el-khalil",
    "name": "Ahmed Abdallah El Khalil",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/14/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Abdallah El Khalil",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6c5f6c42-2695-42f0-be22-ad24e954d7e5",
        "address": "HAMDAN ALSHAMSI ,الطابق الرابع مكتب 401, 406,407 ,بي سكوير 01 ,مجمع دبي سكوير ,116564 ,Dubai",
        "phone": "97143469262",
        "email": "courts@has.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de2c61a6-9d00-457e-ad1d-e73e4e62d9bd",
    "firmName": "HAMDAN ALSHAMSI LAWYER & LEGAL CONSULTANTS",
    "registrationNumber": "L-03007",
    "licenseIssueDate": "01/14/2015 00:00:00",
    "licenseExpiryDate": "01/08/2026 00:00:00"
  },
  {
    "id": "445214d0-a557-4733-9aca-cf03d14b4d92",
    "slug": "ahmed-abdelazim-abdelgadr-esmael",
    "name": "AHMED ABDELAZIM ABDELGADR ESMAEL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/13/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: AHMED ABDELAZIM ABDELGADR ESMAEL",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_445214d0-a557-4733-9aca-cf03d14b4d92",
        "address": "18 ,فندق مونارك  ,مركز التجاري ,98444 ,Dubai",
        "phone": "97143588777",
        "email": "info@bhadvoc.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "61266d12-f5b4-4466-a1a8-a45934d9e511",
    "firmName": "BIN HAIDER ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06145",
    "licenseIssueDate": "12/13/2023 00:00:00",
    "licenseExpiryDate": "12/12/2025 00:00:00"
  },
  {
    "id": "8daf3046-ba10-4c93-9b03-3365a99e9cb9",
    "slug": "ahmed-abdelaziz-metawee",
    "name": "Ahmed Abdelaziz Metawee",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/03/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Abdelaziz Metawee",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8daf3046-ba10-4c93-9b03-3365a99e9cb9",
        "address": "",
        "phone": "97143333386 / 971549916936",
        "email": "info@mtaadv.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "466f3ad4-73e1-44db-b8ec-b01e829d77c4",
    "firmName": "MOHAMMAD ALLINJAWI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02190",
    "licenseIssueDate": "11/03/2022 00:00:00",
    "licenseExpiryDate": "11/02/2025 00:00:00"
  },
  {
    "id": "de602a85-e1fb-4555-9599-58c4417fe92d",
    "slug": "ahmed-abdelfatah",
    "name": "Ahmed Abdelfatah",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Abdelfatah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_de602a85-e1fb-4555-9599-58c4417fe92d",
        "address": "",
        "phone": "97144230000 / 971552009022",
        "email": "UAE-CourtClerks@habibalmulla.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3eba82bb-8ec4-4cbd-80d0-a793cb993fde",
    "firmName": "Habib Al Mulla & Partners ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01181",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "256c0925-f563-4241-ad43-c4ff74f12d45",
    "slug": "ahmed-abdelghany-ahmed-gad-ibrahim",
    "name": "ahmed abdelghany ahmed gad ibrahim",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/21/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ahmed abdelghany ahmed gad ibrahim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_256c0925-f563-4241-ad43-c4ff74f12d45",
        "address": "406 ,رقة البطين  ,بجوار فندق كونكورد  ,92414 ,Dubai",
        "phone": "97142666331",
        "email": "almeshref2019@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b47f195f-addd-458d-85ec-bb93239bbe4b",
    "firmName": "MOHAMMED BEKHIT ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06266",
    "licenseIssueDate": "03/21/2024 00:00:00",
    "licenseExpiryDate": "03/20/2026 00:00:00"
  },
  {
    "id": "590a37bf-7980-44e1-ad49-43e7f8618b23",
    "slug": "ahmed-abdellatif-abdelgawwad-amoussa",
    "name": "Ahmed Abdellatif Abdelgawwad Amoussa",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/26/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Abdellatif Abdelgawwad Amoussa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_590a37bf-7980-44e1-ad49-43e7f8618b23",
        "address": "304 ,Ithraa Building ,Emirates Aviation Academy Street / In front of Al Garhoud Mosque ,0000 ,Dubai",
        "phone": "97148323133",
        "email": "khalidalzaabiadvocates@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "83a1e95e-0701-4150-9f11-a92aa75b5939",
    "firmName": "KHALID ALZAABI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06700",
    "licenseIssueDate": "02/26/2025 00:00:00",
    "licenseExpiryDate": "02/25/2026 00:00:00"
  },
  {
    "id": "1826d286-3200-43be-9c00-b91efa744bec",
    "slug": "ahmed-abdellatif-kodari-mohamed-sayed-ahmed-habib",
    "name": "Ahmed Abdellatif Kodari  Mohamed Sayed Ahmed Habib",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/11/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Abdellatif Kodari  Mohamed Sayed Ahmed Habib",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1826d286-3200-43be-9c00-b91efa744bec",
        "address": "KEFAH ALZAABI ,3005 ,برج لطيفه  ,ابراج لطيفه  ,97597 ,Dubai",
        "phone": "97142522260",
        "email": "info@jazlawyers.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6fab0ce0-5a6b-4586-a900-862950161d02",
    "firmName": "JASIM ALZAROONI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06052",
    "licenseIssueDate": "10/11/2023 00:00:00",
    "licenseExpiryDate": "10/10/2026 00:00:00"
  },
  {
    "id": "ca3ac33a-ac74-490f-ada2-65c4b0879967",
    "slug": "ahmed-abdelnabi-ali-mohamed-abdelnabi",
    "name": "Ahmed Abdelnabi Ali Mohamed Abdelnabi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/12/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Abdelnabi Ali Mohamed Abdelnabi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ca3ac33a-ac74-490f-ada2-65c4b0879967",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-05293",
    "licenseIssueDate": "04/12/2022 00:00:00",
    "licenseExpiryDate": "04/11/2026 00:00:00"
  },
  {
    "id": "73779880-b992-4062-9cbc-127f1d67a647",
    "slug": "ahmed-abdelsatar-abdelkarim",
    "name": "Ahmed Abdelsatar Abdelkarim",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Abdelsatar Abdelkarim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_73779880-b992-4062-9cbc-127f1d67a647",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-01659",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "ed898f66-978e-406d-a646-16631f06029a",
    "slug": "ahmed-abdelwahab-yousif-elturabi",
    "name": "AHMED ABDELWAHAB YOUSIF ELTURABI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/09/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Abdelwahab Yousif Elturabi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ed898f66-978e-406d-a646-16631f06029a",
        "address": "Muna Ahmed Abdul-aziz Al-Sabbagh ,الطابق الخامس ,الزمردة ,مختبر دبي المركزي ,115578 ,Dubai",
        "phone": "97142283414",
        "email": "info@alwifaqlegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "120e4ca7-7727-4524-9d53-5656ff95eea7",
    "firmName": "MUNA ALSABBAGH ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02481",
    "licenseIssueDate": "09/17/2013 00:00:00",
    "licenseExpiryDate": "09/10/2026 00:00:00"
  },
  {
    "id": "da96624a-c5e2-416a-8811-5ffc8d5bbbc7",
    "slug": "ahmed-adel-ahmed-mohamed-el-gharably",
    "name": "Ahmed Adel Ahmed Mohamed El gharably",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/22/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Adel Ahmed Mohamed El gharably",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_da96624a-c5e2-416a-8811-5ffc8d5bbbc7",
        "address": "",
        "phone": "",
        "email": "noufyamgy4@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ea2fa1be-e299-4370-b7f3-bdd8c7bf051d",
    "firmName": "NOUF QASEM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06637",
    "licenseIssueDate": "01/22/2025 00:00:00",
    "licenseExpiryDate": "01/21/2026 00:00:00"
  },
  {
    "id": "ef211c57-26b7-447a-99d9-c8c0d41ce052",
    "slug": "ahmed-adel-hussein-hussein-elhoseny",
    "name": "Ahmed Adel Hussein Hussein Elhoseny",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/06/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Adel Hussein Hussein Elhoseny",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ef211c57-26b7-447a-99d9-c8c0d41ce052",
        "address": "702-703 ,THE EXCHANGE TOWER ,NEAR IN BUSINESS BAY METRO STATION ,90009 ,Dubai",
        "phone": "97142327888",
        "email": "info@alowaislaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "83647634-f0b7-4ccb-b71c-6d00bfdb84de",
    "firmName": "ABDALLA ALOWAIS ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-06243",
    "licenseIssueDate": "03/06/2024 00:00:00",
    "licenseExpiryDate": "03/05/2026 00:00:00"
  },
  {
    "id": "95736623-691c-4913-9cf1-8f26cc687a5a",
    "slug": "ahmed-alfreahat",
    "name": "Ahmed Alfreahat",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/16/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Alfreahat",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_95736623-691c-4913-9cf1-8f26cc687a5a",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506698 ,Dubai",
        "phone": "97147046300 / 971507900661",
        "email": "nada.mourad@lw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b2b92ce9-90a4-4e34-ae2f-ae0dc7ca9060",
    "firmName": "Latham & Watkins LLP",
    "registrationNumber": "L-05620",
    "licenseIssueDate": "11/16/2022 00:00:00",
    "licenseExpiryDate": "11/15/2025 00:00:00"
  },
  {
    "id": "b6edf6d7-d3ab-4730-ad55-476830e7b21a",
    "slug": "ahmed-ali-abdalltif-wedalla",
    "name": "Ahmed Ali Abdalltif Wedalla",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/06/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Ali Abdalltif Wedalla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b6edf6d7-d3ab-4730-ad55-476830e7b21a",
        "address": "Office No.B3604 ,Latifa tower  ,Sheikh zayed rd ,895 ,Dubai",
        "phone": "97100000000 / 971000000000",
        "email": "alraeesi@aradvoc.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6ba19c75-28b1-4ab5-a6e7-2cf619cceeaa",
    "firmName": "ABDULLA AL RAEESI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06238",
    "licenseIssueDate": "03/06/2024 00:00:00",
    "licenseExpiryDate": "03/05/2026 00:00:00"
  },
  {
    "id": "4075615a-6d87-459a-9d2e-9a2f5842f4a3",
    "slug": "ahmed-ali-mahmoud",
    "name": "Ahmed Ali Mahmoud",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/16/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Ali Mahmoud",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4075615a-6d87-459a-9d2e-9a2f5842f4a3",
        "address": "",
        "phone": "97142736666",
        "email": "almohmon@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "651d46a2-cdc6-4e8e-99ad-7ee0f3ddca7a",
    "firmName": "AL MUHAMOON AL ARAB LAWYER & LEGAL CONSULTANCY",
    "registrationNumber": "L-02623",
    "licenseIssueDate": "06/16/2014 00:00:00",
    "licenseExpiryDate": "06/10/2026 00:00:00"
  },
  {
    "id": "0d783622-ef77-4177-b2ed-99ffc6ead41d",
    "slug": "ahmed-alkotby",
    "name": "Ahmed Alkotby",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/27/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Alkotby",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0d783622-ef77-4177-b2ed-99ffc6ead41d",
        "address": "الطابق 14  ,برج 48 جيت  ,محطة مترو دبي  ,413633 ,Dubai",
        "phone": "97144412031",
        "email": "courts@adglegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4287f048-dc0c-4d51-9e0c-0c23356040ee",
    "firmName": "MOHAMMED AL DAHBASHI ADVOCATES",
    "registrationNumber": "L-03701",
    "licenseIssueDate": "02/27/2017 00:00:00",
    "licenseExpiryDate": "02/23/2026 00:00:00"
  },
  {
    "id": "f69c4f65-6de8-4d2e-a7e1-249f542aa7b7",
    "slug": "ahmed-atef-ahmed-al-sadi",
    "name": "Ahmed Atef Ahmed Al Sadi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/08/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Atef Ahmed Al Sadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f69c4f65-6de8-4d2e-a7e1-249f542aa7b7",
        "address": "Khawla Saeed Mohammed Salem ,414 ,DBCS BUILDING ,محكمة الاحوال الشخصية ,73879 ,Dubai",
        "phone": "97143530354 / 971503787848",
        "email": "info@ksadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e961ec37-b1f5-4b83-8382-639604c8fdaf",
    "firmName": "KHAWLA SAEED ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06983"
  },
  {
    "id": "08d2cf0f-626f-48dd-a7fd-cc12d1a2ae0c",
    "slug": "ahmed-bider-mohamed-elmoghazy",
    "name": "Ahmed Bider Mohamed Elmoghazy",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Bider Mohamed Elmoghazy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_08d2cf0f-626f-48dd-a7fd-cc12d1a2ae0c",
        "address": "next level restaurant  , centurion star - block B - office 806 & 807 ,behind day to day - opposite deira city center ,237766 ,Dubai",
        "phone": "97142622002",
        "email": "info@almaftool-advocate.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "bc6598b4-c5d3-4280-b29d-4c3c132c3a21",
    "firmName": "REEM SALEH ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01801",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "db8bb857-2b34-4fb9-bbbc-8fbcb633af8a",
    "slug": "ahmed-butt",
    "name": "Ahmed Butt",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/23/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Butt",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_db8bb857-2b34-4fb9-bbbc-8fbcb633af8a",
        "address": "",
        "phone": "97144020800 / 971566830829",
        "email": "dean.ryburn@dentons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dfe13b7e-6625-45fd-ad63-9ee83af41194",
    "firmName": "Dentons & Co Dubai Branch-DED",
    "registrationNumber": "L-00532",
    "licenseIssueDate": "02/23/2025 00:00:00",
    "licenseExpiryDate": "02/22/2026 00:00:00"
  },
  {
    "id": "846dd5b2-80b2-4618-bb69-1f7e1c57a1b5",
    "slug": "ahmed-daoud-mohamed-hasabelnaby",
    "name": "Ahmed Daoud Mohamed Hasabelnaby",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/31/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Daoud Mohamed Hasabelnaby",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_846dd5b2-80b2-4618-bb69-1f7e1c57a1b5",
        "address": "Second Floor - Office No. 202 ,Union Building ,Makani No: 3234793883 ,000 ,Dubai",
        "phone": "97140000000 / 971569848432",
        "email": "info@advsendeyyah.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "51a05ad7-acb3-4d1a-9ec9-658d683dc4dc",
    "firmName": "SENDEYYAH ALHANTOOBI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05481",
    "licenseIssueDate": "08/31/2022 00:00:00",
    "licenseExpiryDate": "08/30/2026 00:00:00"
  },
  {
    "id": "f8f9430e-b6c5-4be0-bab6-5633de3d8923",
    "slug": "ahmed-eldesouky-elasily",
    "name": "Ahmed Eldesouky Elasily",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/25/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-01-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Eldesouky Elasily",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f8f9430e-b6c5-4be0-bab6-5633de3d8923",
        "address": "",
        "phone": "97143573330",
        "email": "admin@dhahiadvocate.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5b668acf-1fdb-4057-81f9-05d9aeb7aca9",
    "firmName": "AHMED BIN DHAHI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01224",
    "licenseIssueDate": "01/25/2012 00:00:00",
    "licenseExpiryDate": "01/16/2026 00:00:00"
  },
  {
    "id": "24ad8252-3f39-4c27-9511-a76b370f1fae",
    "slug": "ahmed-elmagzoub-mohamed-hagelmahi",
    "name": "Ahmed Elmagzoub Mohamed Hagelmahi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/27/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Elmagzoub Mohamed Hagelmahi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_24ad8252-3f39-4c27-9511-a76b370f1fae",
        "address": "الطابق الثاني - مكتب رقم 203 و 204  ,سيتي أفينو ,سيتى سنتر ديرة  ,83666 ,Dubai",
        "phone": "97142955050",
        "email": "adv.algharib@alghariblawfirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b1e23b77-356c-4678-ae4d-2ff4e494702b",
    "firmName": "ALGHARIB & PARTNERS ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-05043",
    "licenseIssueDate": "09/27/2021 00:00:00",
    "licenseExpiryDate": "09/26/2026 00:00:00"
  },
  {
    "id": "63941e55-e6b9-41ba-a52b-7213e2e40b97",
    "slug": "ahmed-elmakkawi",
    "name": "AHMED ELMAKKAWI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/01/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: AHMED ELMAKKAWI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_63941e55-e6b9-41ba-a52b-7213e2e40b97",
        "address": "TWENTY ,ALMASRAF TOWER ,DUBAI MUNICIPALITY ,3858 ,Dubai",
        "phone": "97142222314",
        "email": "apxjuris@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "f8f827cb-389c-48f1-841e-a39afdd09f7d",
    "firmName": "APEX JURIS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04046",
    "licenseIssueDate": "04/01/2018 00:00:00",
    "licenseExpiryDate": "03/29/2026 00:00:00"
  },
  {
    "id": "8752167f-b33c-4d62-bbc7-1e31d6fbf78e",
    "slug": "ahmed-elsayed-ahmed-abouzaid",
    "name": "Ahmed Elsayed Ahmed Abouzaid",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/12/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Elsayed Ahmed Abouzaid",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8752167f-b33c-4d62-bbc7-1e31d6fbf78e",
        "address": "HASSAN ALI MATAR ALRIYAMI ,24 ,GRASVENOR BUSINESS TOWER ,NEEDS SUPERMARKET ,215880 ,Dubai",
        "phone": "97144534188",
        "email": "courts@alriyamiadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a40a2f1f-69a9-429c-8086-dba9d985532b",
    "firmName": "HASAN ALRAYYAMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04664",
    "licenseIssueDate": "03/12/2020 00:00:00",
    "licenseExpiryDate": "03/11/2026 00:00:00"
  },
  {
    "id": "aa876956-909e-438e-8ca9-783d6fe4d95c",
    "slug": "ahmed-fahmy-hassan",
    "name": "Ahmed Fahmy Hassan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/08/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Fahmy Hassan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_aa876956-909e-438e-8ca9-783d6fe4d95c",
        "address": "",
        "phone": "97145539555",
        "email": "world-center@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "00c4764a-95da-417c-bdfc-8bafd4ff9fca",
    "firmName": "WORLD CENTER ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02875",
    "licenseIssueDate": "02/08/2015 00:00:00",
    "licenseExpiryDate": "02/02/2026 00:00:00"
  },
  {
    "id": "32bc4254-b4cc-4c41-b512-519d6b2d4be9",
    "slug": "ahmed-farouk-ragab",
    "name": "Ahmed Farouk Ragab",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/10/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Farouk Ragab",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_32bc4254-b4cc-4c41-b512-519d6b2d4be9",
        "address": "Advo. Abdulla Al Awadi ,العاشر  ,برايم تاور  ,فندق فيدا ,26665 ,Dubai",
        "phone": "97143352200",
        "email": "info@abdullaalawadi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5075821f-98f5-4546-8fcd-6cdc74967dac",
    "firmName": "ABDULLA AL AWADI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02338",
    "licenseIssueDate": "07/10/2012 00:00:00",
    "licenseExpiryDate": "07/02/2026 00:00:00"
  },
  {
    "id": "46919252-7e5f-4ea9-b6ac-ea2d65710621",
    "slug": "ahmed-fawzy-fahmy-abozeid",
    "name": "Ahmed Fawzy Fahmy Abozeid",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/22/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Fawzy Fahmy Abozeid",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_46919252-7e5f-4ea9-b6ac-ea2d65710621",
        "address": "",
        "phone": "97142507778 / 971506421661",
        "email": "feedback@alshamsilawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4b400e1b-7731-4a4b-9c37-a77e3c03ab78",
    "firmName": "NASSER AL SHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05187",
    "licenseIssueDate": "02/22/2022 00:00:00",
    "licenseExpiryDate": "02/21/2026 00:00:00"
  },
  {
    "id": "d28ab6ef-d45f-4f48-9b9b-a030fbc7d2c1",
    "slug": "ahmed-gaber-ansary-mohamed-hammoury",
    "name": "Ahmed Gaber Ansary Mohamed Hammoury",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/23/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Gaber Ansary Mohamed Hammoury",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d28ab6ef-d45f-4f48-9b9b-a030fbc7d2c1",
        "address": "0 ,بن فارس 2 ,مستشفى البراحة ,22662 ,Dubai",
        "phone": "97142203333 / 9715048999911",
        "email": "seridi.advo@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c567de5a-f399-4c56-829e-06e37a2eb4fc",
    "firmName": "RASHED AHMED ALSEREIDI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06875",
    "licenseIssueDate": "06/23/2025 00:00:00",
    "licenseExpiryDate": "06/22/2026 00:00:00"
  },
  {
    "id": "afd0f591-5bae-4267-b3bb-61854f66ff78",
    "slug": "ahmed-gaber-mahmoud",
    "name": "Ahmed Gaber Mahmoud",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/16/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Gaber Mahmoud",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_afd0f591-5bae-4267-b3bb-61854f66ff78",
        "address": "شركة قطر للتأمين ,مركز الدانة ,فندق كارلتون بالاس ,80239 ,Dubai",
        "phone": "97142247451",
        "email": "nooradvo@eim.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "09f7be53-e98a-499b-a46b-3635ebba9c54",
    "firmName": "NAWAL MOHAMED AL BADY  ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-01721",
    "licenseIssueDate": "02/16/2012 00:00:00",
    "licenseExpiryDate": "02/07/2026 00:00:00"
  },
  {
    "id": "e9b8afcc-5c79-4093-9076-4ef864f21dfe",
    "slug": "ahmed-gamal-ahmed-mohamed-othman",
    "name": "Ahmed Gamal Ahmed Mohamed Othman",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/30/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Gamal Ahmed Mohamed Othman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e9b8afcc-5c79-4093-9076-4ef864f21dfe",
        "address": "Noura Mohamed Abdelrahman Almaazmi ,17 ,The Oberoi Center ,Burlington Tower ,414224 ,Dubai",
        "phone": "97143215777",
        "email": "case@almaazmilawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e56938ba-8d38-4268-9706-651d4c984db9",
    "firmName": "NOURA ALMAAZMI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-06917",
    "licenseIssueDate": "07/30/2025 00:00:00",
    "licenseExpiryDate": "07/29/2026 00:00:00"
  },
  {
    "id": "61809977-f7a3-4afd-86f0-bfb28f8b5437",
    "slug": "ahmed-gamal-asi",
    "name": "Ahmed Gamal Asi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/10/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-01-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Gamal Asi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_61809977-f7a3-4afd-86f0-bfb28f8b5437",
        "address": "Obaid Ishaq Ismail Al-Maazmi ,الطابق 21 ,ذا اكستشينج تاور  ,فندق جي دبليو ماريوت ماركي ,238365 ,Dubai",
        "phone": "97143584737",
        "email": "obaidotp@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "70a8fb70-2729-4348-b87b-258c7dc7a387",
    "firmName": "OBAID ALMAAZMI LAWYER AND LEGAL CONSULTANT",
    "registrationNumber": "L-02479",
    "licenseIssueDate": "01/10/2012 00:00:00",
    "licenseExpiryDate": "01/01/2026 00:00:00"
  },
  {
    "id": "21b43986-3c1c-4603-bf1b-af4179a0a13d",
    "slug": "ahmed-hamdy-hamad",
    "name": "Ahmed Hamdy Hamad",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/15/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Hamdy Hamad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_21b43986-3c1c-4603-bf1b-af4179a0a13d",
        "address": "",
        "phone": "97144472020",
        "email": "info@arnadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e6573267-5872-48d8-add1-06a3deccf9e4",
    "firmName": "ABDUL RAHMAN NASEEB ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03042",
    "licenseIssueDate": "06/15/2015 00:00:00",
    "licenseExpiryDate": "06/10/2026 00:00:00"
  },
  {
    "id": "520a17e3-e311-4c75-9d3e-c48ad94b2466",
    "slug": "ahmed-hamed-mahmoud-sayed-ahmed",
    "name": "Ahmed Hamed Mahmoud Sayed Ahmed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/25/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Hamed Mahmoud Sayed Ahmed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_520a17e3-e311-4c75-9d3e-c48ad94b2466",
        "address": "GALAL ELDIN HUSSEIN SALEH DIAB ,الطابق السادس ,مكاتب ,معرض هوندا الفطيم للسيارات - ديره ,115506 ,Dubai",
        "phone": "97197150655",
        "email": "galal5152@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6bba74cb-688b-40e3-b624-be70505eb5f9",
    "firmName": "GALAL HUSSEIN LEGAL CONSULTANCIES AND ADVOCATES",
    "registrationNumber": "L-05492",
    "licenseIssueDate": "01/25/2023 00:00:00",
    "licenseExpiryDate": "01/24/2026 00:00:00"
  },
  {
    "id": "ddc44aba-2d64-405b-b584-17e6ebdb80f1",
    "slug": "ahmed-hammadi",
    "name": "Ahmed Hammadi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/27/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Hammadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ddc44aba-2d64-405b-b584-17e6ebdb80f1",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-02735",
    "licenseIssueDate": "11/27/2023 00:00:00",
    "licenseExpiryDate": "11/26/2025 00:00:00"
  },
  {
    "id": "6ee5c90d-d3df-4eda-b1ea-b26a5b14fdf7",
    "slug": "ahmed-hassan-al-said-moawad",
    "name": "Ahmed Hassan Al Said Moawad",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/18/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Hassan Al Said Moawad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6ee5c90d-d3df-4eda-b1ea-b26a5b14fdf7",
        "address": "",
        "phone": "97142227008 / 971506245451",
        "email": "info@abdulmaliklaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5714833f-5b48-477b-a556-efa3a779f522",
    "firmName": "ABDULMALIK & ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02012",
    "licenseIssueDate": "09/18/2013 00:00:00",
    "licenseExpiryDate": "09/11/2026 00:00:00"
  },
  {
    "id": "cc4eee5b-b18a-4a80-a9c3-962a46e08aff",
    "slug": "ahmed-hassan-morsy-hassan-mobasher",
    "name": "ahmed hassan morsy hassan mobasher",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/25/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ahmed hassan morsy hassan mobasher",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cc4eee5b-b18a-4a80-a9c3-962a46e08aff",
        "address": "yousif alhammadi ,الخامس 513،514 ,بيزنس افينيو ,وكالة نيسان ,414145 ,Dubai",
        "phone": "97143307771",
        "email": "yousifadv@alhammadilegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b2331b5f-91be-4205-ad5c-6af317f654a4",
    "firmName": "YOUSIF ALHAMMADI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-05450",
    "licenseIssueDate": "07/25/2022 00:00:00",
    "licenseExpiryDate": "07/24/2026 00:00:00"
  },
  {
    "id": "7613225c-8b3d-4e02-a485-9074bb3f1703",
    "slug": "ahmed-helmi-mohamed-hatem",
    "name": "Ahmed Helmi Mohamed Hatem",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/08/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-07-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Helmi Mohamed Hatem",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7613225c-8b3d-4e02-a485-9074bb3f1703",
        "address": "4th floor ,Al Saaha Offices Block D office 401A ,Burj Khalifa ,283773 ,Dubai",
        "phone": "97144221944",
        "email": "gov.depts@alsafarpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b7bbfaeb-1fdb-46d2-97cf-8e6432a9b8a7",
    "firmName": "AL SAFAR & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05177",
    "licenseIssueDate": "02/08/2022 00:00:00",
    "licenseExpiryDate": "02/07/2026 00:00:00"
  },
  {
    "id": "417e0ae9-24cb-45a4-8a4f-a4963841629b",
    "slug": "ahmed-hussein-ahmed-abdelmeguid",
    "name": "ahmed hussein ahmed abdelmeguid",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/01/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ahmed hussein ahmed abdelmeguid",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_417e0ae9-24cb-45a4-8a4f-a4963841629b",
        "address": "",
        "phone": "97142942616",
        "email": "info@ilofficeuae.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "48ef4874-8647-4fb6-bedd-ffbad25accd1",
    "firmName": "KHALID KALANDAR ALMAAZMI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-04447",
    "licenseIssueDate": "07/01/2019 00:00:00",
    "licenseExpiryDate": "06/30/2026 00:00:00"
  },
  {
    "id": "f1aa2970-a2c1-4c05-9fb6-ecb1d3717e76",
    "slug": "ahmed-ibrahim-abdelhamid-ibrahim",
    "name": "Ahmed Ibrahim Abdelhamid Ibrahim",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/19/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Ibrahim Abdelhamid Ibrahim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f1aa2970-a2c1-4c05-9fb6-ecb1d3717e76",
        "address": "1201 ,برج تريو اي بي اي اوفيس  ,فندق نوافتيل ,8812 ,Dubai",
        "phone": "97144222555",
        "email": "lutfilaw2020@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9a3d884b-a443-4037-9eb4-f810c596cf33",
    "firmName": "LUTFI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06429",
    "licenseIssueDate": "07/19/2024 00:00:00",
    "licenseExpiryDate": "07/18/2026 00:00:00"
  },
  {
    "id": "1d39f8a3-c6c1-4e22-a913-accdc8844d15",
    "slug": "ahmed-ibrahim-ahmed-nofal",
    "name": "Ahmed Ibrahim Ahmed Nofal",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Ibrahim Ahmed Nofal",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1d39f8a3-c6c1-4e22-a913-accdc8844d15",
        "address": "4/406 ,Acico Business Park  ,Behind Nissan Showroom ,186344 ,Dubai",
        "phone": "97142989888 / 971505948989",
        "email": "AHMEDIBRAHIMLAW@GMAIL.COM",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dbb4bc27-1ace-4e78-8ee2-db7bfd85e001",
    "firmName": "AHMED IBRAHIM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01346",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "d335ef4f-9ee4-46f2-8f3c-2197ce522eb5",
    "slug": "ahmed-ibrahim-emam-ibrahim",
    "name": "Ahmed Ibrahim Emam Ibrahim",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Ibrahim Emam Ibrahim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d335ef4f-9ee4-46f2-8f3c-2197ce522eb5",
        "address": "الطابق الرابع ,الصقر للاعمال ,محطة مترو ابراج الامارات  ,67476 ,Dubai",
        "phone": "97143444210",
        "email": "assistant@albannaadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e3ffafe9-0f0c-4d88-a976-2bdfd7d18411",
    "firmName": "IBRAHIM ALBANNA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01600",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "fe73aff5-d616-4c34-bf47-010db4af892f",
    "slug": "ahmed-ibrahim-ghazaly",
    "name": "Ahmed Ibrahim Ghazaly",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/02/2014",
    "licenseStatus": "active",
    "licenseExpiry": "2015-02-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Ibrahim Ghazaly",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fe73aff5-d616-4c34-bf47-010db4af892f",
        "address": "Firas Hassan Al Choufi ,701 ,The Prime Tower ,Makani No: 25836 86879 ,125305 ,Dubai",
        "phone": "97144357246",
        "email": "info@binsevanadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4d3c9dcc-51c6-4883-b9ed-c65a7d1c5a57",
    "firmName": "BIN SEVAN ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-02650",
    "licenseIssueDate": "02/10/2014 00:00:00",
    "licenseExpiryDate": "02/03/2026 00:00:00"
  },
  {
    "id": "99eb1e84-a613-40f1-b8df-dabfd0a772e0",
    "slug": "ahmed-ibrahim-hassan",
    "name": "Ahmed Ibrahim Hassan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/17/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Ibrahim Hassan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_99eb1e84-a613-40f1-b8df-dabfd0a772e0",
        "address": "",
        "phone": "97142955575",
        "email": "info@yalhamed.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "af6ac730-58a7-44a4-9f60-78811de374c7",
    "firmName": "YASIN ALHAMED ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01683",
    "licenseIssueDate": "05/17/2012 00:00:00",
    "licenseExpiryDate": "05/09/2026 00:00:00"
  },
  {
    "id": "65385e74-3cb3-411f-a051-4ffe27ac104e",
    "slug": "ahmed-ibrahim-hosny-ibrahim",
    "name": "Ahmed Ibrahim Hosny Ibrahim",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/03/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Ibrahim Hosny Ibrahim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_65385e74-3cb3-411f-a051-4ffe27ac104e",
        "address": "",
        "phone": "97143266669 / 971505479696",
        "email": "almasayba@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a1c5fd44-9a8b-4235-8ba0-8499d6832520",
    "firmName": "BASHAR ALMASAYBA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05453",
    "licenseIssueDate": "08/03/2022 00:00:00",
    "licenseExpiryDate": "08/02/2026 00:00:00"
  },
  {
    "id": "153d7d6f-01c8-4989-953f-f28f9728478a",
    "slug": "ahmed-kamel-salaman-attia",
    "name": "Ahmed Kamel Salaman Attia",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/22/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Kamel Salaman Attia",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_153d7d6f-01c8-4989-953f-f28f9728478a",
        "address": "",
        "phone": "97143937700",
        "email": "info@galadarilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d863b662-c864-4193-8b3a-ff6ee5fe6c64",
    "firmName": "GALADARI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05754",
    "licenseIssueDate": "02/22/2023 00:00:00",
    "licenseExpiryDate": "02/21/2026 00:00:00"
  },
  {
    "id": "8337c049-9ae3-4681-9805-1527a63da397",
    "slug": "ahmed-kamran-mohammad-amjad-bashir-sheikh",
    "name": "Ahmed Kamran Mohammad Amjad Bashir Sheikh",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/03/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Kamran Mohammad Amjad Bashir Sheikh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8337c049-9ae3-4681-9805-1527a63da397",
        "address": "",
        "phone": "97143685555",
        "email": "maisa.maarouf@bsabh.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8afa232f-52ff-4dad-82c3-9a04d66eb853",
    "firmName": "B S A AHMED BIN HAZEEM & ASSOCIATES LLP - DIFC",
    "registrationNumber": "L-06926",
    "licenseIssueDate": "08/07/2025 00:00:00",
    "licenseExpiryDate": "08/06/2026 00:00:00"
  },
  {
    "id": "af306a85-908d-4ff1-9334-361d51d31a25",
    "slug": "ahmed-khaled-mahmoud-bakry",
    "name": "Ahmed Khaled Mahmoud Bakry",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/10/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Khaled Mahmoud Bakry",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_af306a85-908d-4ff1-9334-361d51d31a25",
        "address": "",
        "phone": "97143937700",
        "email": "info@galadarilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d863b662-c864-4193-8b3a-ff6ee5fe6c64",
    "firmName": "GALADARI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06895",
    "licenseIssueDate": "07/10/2025 00:00:00",
    "licenseExpiryDate": "07/09/2026 00:00:00"
  },
  {
    "id": "d8454c10-3dba-4818-8121-21024ebe8fde",
    "slug": "ahmed-labib-mohamed-mohamed-salman",
    "name": "Ahmed Labib Mohamed Mohamed Salman",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/05/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Labib Mohamed Mohamed Salman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d8454c10-3dba-4818-8121-21024ebe8fde",
        "address": "",
        "phone": "97143685555",
        "email": "maisa.maarouf@bsabh.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8afa232f-52ff-4dad-82c3-9a04d66eb853",
    "firmName": "B S A AHMED BIN HAZEEM & ASSOCIATES LLP - DIFC",
    "registrationNumber": "L-04883",
    "licenseIssueDate": "04/05/2021 00:00:00",
    "licenseExpiryDate": "04/04/2026 00:00:00"
  },
  {
    "id": "b05432ad-9889-414d-a911-8716d427bdab",
    "slug": "ahmed-mahmoud-ramadan-ghoneim",
    "name": "ahmed mahmoud ramadan ghoneim",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/22/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ahmed mahmoud ramadan ghoneim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b05432ad-9889-414d-a911-8716d427bdab",
        "address": "الطابق 33/ الوحدة : 3304 ,مبني المنارة /   الطابق 33/ الوحدة : 3304 ,فندق جي دبليو ماركيز  ,24002 ,Dubai",
        "phone": "97144254373",
        "email": "info@wkadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "332a3a67-50f2-424a-a5c1-d5abaf9a030b",
    "firmName": "WALEED ALMARZOOQI AND KHALID MOHAMED ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-01585",
    "licenseIssueDate": "03/22/2018 00:00:00",
    "licenseExpiryDate": "03/20/2026 00:00:00"
  },
  {
    "id": "b82edeef-3870-4b53-9658-b74750300f69",
    "slug": "ahmed-mahrous-ali-nagy",
    "name": "AHMED MAHROUS ALI NAGY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/06/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2023-06-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Mahrous Ali Nagy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b82edeef-3870-4b53-9658-b74750300f69",
        "address": "",
        "phone": "97142280002",
        "email": "advoali2020@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5029a3dc-098b-4d3f-9e38-afb0eb4319d0",
    "firmName": "ALI IBRAHIM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04923",
    "licenseIssueDate": "06/14/2021 00:00:00",
    "licenseExpiryDate": "06/13/2023 00:00:00"
  },
  {
    "id": "2f16fb57-5ae0-413d-b2e2-418c6c960cb8",
    "slug": "ahmed-mahrous-hassan-saleh",
    "name": "Ahmed Mahrous Hassan Saleh",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Mahrous Hassan Saleh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2f16fb57-5ae0-413d-b2e2-418c6c960cb8",
        "address": "",
        "phone": "97142405888",
        "email": "m.binhendi@mbhlawfirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "95d56953-378a-4ade-a995-fee8035a4699",
    "firmName": "MAHA BIN HENDI LAW FIRM",
    "registrationNumber": "L-01545",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "ad58e677-bce8-44f4-acf9-f4ef704b24d4",
    "slug": "ahmed-mohamed-abbas-mohamed",
    "name": "Ahmed Mohamed Abbas Mohamed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/27/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Mohamed Abbas Mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ad58e677-bce8-44f4-acf9-f4ef704b24d4",
        "address": "Mohamed Nagy ,First floor  ,Clover Bay ,Business bay ,108 ,Dubai",
        "phone": "97143366404",
        "email": "fatimaalmehri5@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a359d947-1da5-4ef9-af87-719d01287fd0",
    "firmName": "FATEMA ALMHEIRI ADVOCATES &LEGAL CONSULTANTS",
    "registrationNumber": "L-06019",
    "licenseIssueDate": "09/27/2023 00:00:00",
    "licenseExpiryDate": "09/26/2026 00:00:00"
  },
  {
    "id": "d9b67015-55c0-4e93-9f0e-edd085d96ffd",
    "slug": "ahmed-mohamed-abd-elaal-ahmaed",
    "name": "Ahmed Mohamed Abd Elaal Ahmaed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/22/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Mohamed Abd Elaal Ahmaed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d9b67015-55c0-4e93-9f0e-edd085d96ffd",
        "address": "الطابق 11 - مكتب رقم (1105 ، 1106)  ,برج السلام  ,منطقة المركز التجاري العالمي 1 ,211911 ,Dubai",
        "phone": "97143366769 / 971503636617",
        "email": "info@erlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "fffe1b8f-e9ab-488f-82eb-6151b8f007df",
    "firmName": "EMAN ALRIFAI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05726",
    "licenseIssueDate": "02/22/2023 00:00:00",
    "licenseExpiryDate": "02/21/2026 00:00:00"
  },
  {
    "id": "6a14ca32-1ba2-4c3e-a1f2-7369064574ec",
    "slug": "ahmed-mohamed-abdalla-attia-elaghoury",
    "name": "Ahmed Mohamed Abdalla Attia Elaghoury",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/26/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Mohamed Abdalla Attia Elaghoury",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6a14ca32-1ba2-4c3e-a1f2-7369064574ec",
        "address": "Samia Luqman ,2nd floor ,Emarat Atrium Building ,across Holiday Inn Express Safa Park ,7273 ,Dubai",
        "phone": "97143211000",
        "email": "info@alsuwaidi.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0e5c3637-bc12-475c-a6b5-2d9ae84f2b8e",
    "firmName": "AL-SUWAIDI & COMPANY",
    "registrationNumber": "L-06690",
    "licenseIssueDate": "02/26/2025 00:00:00",
    "licenseExpiryDate": "02/25/2026 00:00:00"
  },
  {
    "id": "70c5506a-8e17-4c76-9757-0e1afa6cb1da",
    "slug": "ahmed-mohamed-abdelghani-aboutaleb",
    "name": "Ahmed Mohamed Abdelghani Aboutaleb",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/20/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-01-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Mohamed Abdelghani Aboutaleb",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_70c5506a-8e17-4c76-9757-0e1afa6cb1da",
        "address": "",
        "phone": "97143528314",
        "email": "alomran.advocates@alaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c0d5ee8d-2020-4bd5-8b4f-efe6ea0f4acc",
    "firmName": "ABDULLA ALOMRAN ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01864",
    "licenseIssueDate": "01/20/2016 00:00:00",
    "licenseExpiryDate": "01/15/2026 00:00:00"
  },
  {
    "id": "4d3d17f3-e242-47a9-9959-223e6395ce1c",
    "slug": "ahmed-mohamed-abdelhasseb-arafa",
    "name": "Ahmed Mohamed Abdelhasseb Arafa",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/20/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Mohamed Abdelhasseb Arafa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4d3d17f3-e242-47a9-9959-223e6395ce1c",
        "address": "omar abdulazizi alomar ,15 ,prime tower ,blom bank france ,211940 ,Dubai",
        "phone": "97143808838 / 971504598082",
        "email": "omar.omar@oghlegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "171b4622-e4ec-4375-a9c4-3637bf6a8b17",
    "firmName": "ALOMAR & ALSABAH ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-03960",
    "licenseIssueDate": "12/20/2017 00:00:00",
    "licenseExpiryDate": "12/17/2025 00:00:00"
  },
  {
    "id": "1bb837ad-c163-401a-97de-8f2c6212f910",
    "slug": "ahmed-mohamed-abdelkader-gadelrab",
    "name": "Ahmed Mohamed Abdelkader Gadelrab",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/01/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Mohamed Abdelkader Gadelrab",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1bb837ad-c163-401a-97de-8f2c6212f910",
        "address": "omar abdulazizi alomar ,15 ,prime tower ,blom bank france ,211940 ,Dubai",
        "phone": "97143808838 / 971504598082",
        "email": "omar.omar@oghlegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "171b4622-e4ec-4375-a9c4-3637bf6a8b17",
    "firmName": "ALOMAR & ALSABAH ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-04361",
    "licenseIssueDate": "04/01/2019 00:00:00",
    "licenseExpiryDate": "03/30/2026 00:00:00"
  },
  {
    "id": "ce727dd4-bd5a-4c4c-ba54-02fed86a916d",
    "slug": "ahmed-mohamed-abdelsalam-mohamed-saad",
    "name": "Ahmed Mohamed Abdelsalam Mohamed Saad",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/19/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Mohamed Abdelsalam Mohamed Saad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ce727dd4-bd5a-4c4c-ba54-02fed86a916d",
        "address": "Ali Saleh Atrooz  ,1103 ,EMPIRE HEIGHTS B ,دبي مول  ,18433 ,Dubai",
        "phone": "97142222511",
        "email": "info@araalaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "aab79fde-e700-45d7-904f-bde0a593a087",
    "firmName": "ARAA GROUP ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04411",
    "licenseIssueDate": "05/19/2019 00:00:00",
    "licenseExpiryDate": "05/18/2026 00:00:00"
  },
  {
    "id": "dc9bb2cc-9e75-46b3-a04b-078ae747d8e8",
    "slug": "ahmed-mohamed-abdelwahab-elkelany",
    "name": "AHMED MOHAMED ABDELWAHAB ELKELANY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/18/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: AHMED MOHAMED ABDELWAHAB ELKELANY",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dc9bb2cc-9e75-46b3-a04b-078ae747d8e8",
        "address": "103 ,DUBAI SUPREME COURT COMPLEX ,DUBAI COURT ,00 ,Dubai",
        "phone": "97143038303 / 971504999947",
        "email": "dr.faisal@lawfaisal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "db28e7c2-7457-4e60-93b2-309b9cd0d259",
    "firmName": "FAISAL ALHEFEITI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06532",
    "licenseIssueDate": "10/03/2024 00:00:00",
    "licenseExpiryDate": "10/02/2025 00:00:00"
  },
  {
    "id": "83feec95-f6d1-454a-9c9e-ab701ec0ae10",
    "slug": "ahmed-mohamed-adly-osman",
    "name": "Ahmed Mohamed Adly Osman",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/12/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Mohamed Adly Osman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_83feec95-f6d1-454a-9c9e-ab701ec0ae10",
        "address": "",
        "phone": "97140000000 / 971507448882",
        "email": "a.alyassi@alyassi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2ba14bc2-2913-4786-a320-b15dfea056e2",
    "firmName": "ABDALLA AL YASSI ADVOCATES AND LEGAL CONSULTANCY",
    "registrationNumber": "L-05297",
    "licenseIssueDate": "04/12/2022 00:00:00",
    "licenseExpiryDate": "04/11/2026 00:00:00"
  },
  {
    "id": "09c6cbe0-df78-4f4c-bd72-58db4d9f9727",
    "slug": "ahmed-mohamed-ahmed-abdelbasset",
    "name": "AHMED MOHAMED AHMED ABDELBASSET",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/02/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2022-02-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ahmed mohamed ahmed abdelbasset",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_09c6cbe0-df78-4f4c-bd72-58db4d9f9727",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-04008",
    "licenseIssueDate": "02/18/2018 00:00:00",
    "licenseExpiryDate": "02/15/2022 00:00:00"
  },
  {
    "id": "b947da39-ec98-4623-a01d-ae6e31c6674d",
    "slug": "ahmed-mohamed-ahmed-eldeek",
    "name": "ahmed mohamed ahmed eldeek",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/26/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ahmed mohamed ahmed eldeek",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b947da39-ec98-4623-a01d-ae6e31c6674d",
        "address": "",
        "phone": "97143348481",
        "email": "lawyers@maidor.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a48d1666-6ca7-461a-8197-a892ef0f3545",
    "firmName": "AL MAIDOOR ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05318",
    "licenseIssueDate": "04/26/2022 00:00:00",
    "licenseExpiryDate": "04/25/2026 00:00:00"
  },
  {
    "id": "af163e5a-1bd9-4645-894d-d5fcaf304fb3",
    "slug": "ahmed-mohamed-ahmed-shafiek-mohamed",
    "name": "Ahmed Mohamed Ahmed Shafiek Mohamed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/22/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Mohamed Ahmed Shafiek Mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_af163e5a-1bd9-4645-894d-d5fcaf304fb3",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-05209",
    "licenseIssueDate": "02/22/2022 00:00:00",
    "licenseExpiryDate": "02/21/2026 00:00:00"
  },
  {
    "id": "d0bc1fac-893b-4197-b5b6-269b1d4af46a",
    "slug": "ahmed-mohamed-haaban-abd-elsalam-elaghir",
    "name": "AHMED MOHAMED HAABAN ABD ELSALAM ELAGHIR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/12/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: AHMED MOHAMED HAABAN ABD ELSALAM ELAGHIR",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d0bc1fac-893b-4197-b5b6-269b1d4af46a",
        "address": "Amer Sayed Al Marzooqi ,603 ,SAMA TOWER ,TRADE CENTER ,41727 ,Dubai",
        "phone": "97142500023",
        "email": "info@mlegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7ed7234c-a176-47f9-b66e-18524305fe3e",
    "firmName": "AMER AL MARZOOQI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05301",
    "licenseIssueDate": "04/12/2022 00:00:00",
    "licenseExpiryDate": "04/11/2026 00:00:00"
  },
  {
    "id": "69a32f71-6073-4d17-8864-a891bc85e400",
    "slug": "ahmed-mohamed-kamal-zidan",
    "name": "Ahmed Mohamed Kamal Zidan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/02/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Mohamed Kamal Zidan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_69a32f71-6073-4d17-8864-a891bc85e400",
        "address": "",
        "phone": "97142253131 / 971503534441",
        "email": "info@ml-advocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e4e4dd86-434d-4a53-a225-b2315793281a",
    "firmName": "MOHAMED ALMARZOOQI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-05007",
    "licenseIssueDate": "08/02/2021 00:00:00",
    "licenseExpiryDate": "08/01/2026 00:00:00"
  },
  {
    "id": "e0bec653-efc8-4919-83eb-293cd91208e8",
    "slug": "ahmed-mohamed-korany-moahmed",
    "name": "ahmed mohamed korany moahmed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/03/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ahmed mohamed korany moahmed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e0bec653-efc8-4919-83eb-293cd91208e8",
        "address": "saeed ,310 & 311 ,business avenue ,منطقه بور سعيد التجاريه ,19410 ,Dubai",
        "phone": "97148868812",
        "email": "info@saeedalghafri.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5acd50c8-df41-496b-a969-926d40e45c46",
    "firmName": "SAEED ALGHAFRI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06407",
    "licenseIssueDate": "07/03/2024 00:00:00",
    "licenseExpiryDate": "07/02/2026 00:00:00"
  },
  {
    "id": "0c32bf41-aee5-4c35-9021-1c305a072e75",
    "slug": "ahmed-mohamed-mohamed-mahmoud-el-sayed",
    "name": "Ahmed Mohamed Mohamed Mahmoud El Sayed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/25/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Mohamed Mohamed Mahmoud El Sayed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0c32bf41-aee5-4c35-9021-1c305a072e75",
        "address": "الطابق 7 مكتب رقم 070A ,برج رولكس  ,محطة مترو المركز المالي  ,66300 ,Dubai",
        "phone": "97143444029",
        "email": "ekp.khalidaltmimi@ekplegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "400838f1-4e75-4836-9698-b9e19dd30a18",
    "firmName": "KHALID ABDALLA ALTAMIMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04694",
    "licenseIssueDate": "06/25/2020 00:00:00",
    "licenseExpiryDate": "06/24/2026 00:00:00"
  },
  {
    "id": "e0730f73-0dde-40cb-87cc-127c56156ff6",
    "slug": "ahmed-mohamed-nor-elden",
    "name": "Ahmed Mohamed Nor Elden",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/07/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Mohamed Nor Elden",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e0730f73-0dde-40cb-87cc-127c56156ff6",
        "address": "Abdulhakim Habib Mansoor Binherz  ,38 ,Latifa Tower  , Crowne Plaza Hotel ,97598 ,Dubai",
        "phone": "97102544490",
        "email": "litigation@binherzadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4e2e2375-ce6e-4d10-936d-68285844f2c0",
    "firmName": "ABDULHAKIM BINHERZ ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01959",
    "licenseIssueDate": "03/07/2012 00:00:00",
    "licenseExpiryDate": "02/26/2026 00:00:00"
  },
  {
    "id": "72d4ee7f-4ce8-4b05-bbf9-f3c513b86848",
    "slug": "ahmed-mohamed-samir-mohamed-ahmed-omer",
    "name": "Ahmed Mohamed Samir Mohamed Ahmed Omer",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/16/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Mohamed Samir Mohamed Ahmed Omer",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_72d4ee7f-4ce8-4b05-bbf9-f3c513b86848",
        "address": "Mohamed Ibrahim amer ,25 ,Iris bay ,Business bay ,3939 ,Dubai",
        "phone": "97125520551",
        "email": "admin@khuloudsaeed.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "661fa52a-1fed-4a42-af84-3e1a7ba76603",
    "firmName": "KHULOUD SAEED ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06216",
    "licenseIssueDate": "02/16/2024 00:00:00",
    "licenseExpiryDate": "02/15/2026 00:00:00"
  },
  {
    "id": "ecf33fbb-6651-488a-a8ce-bcd785311f95",
    "slug": "ahmed-mohamed-selim",
    "name": "Ahmed Mohamed Selim",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Mohamed Selim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ecf33fbb-6651-488a-a8ce-bcd785311f95",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01240",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "2ba7bdc2-e6b8-45f7-8a47-68315c85dc61",
    "slug": "ahmed-mohamed-zaki",
    "name": "Ahmed Mohamed Zaki",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/12/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-06-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Mohamed Zaki",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2ba7bdc2-e6b8-45f7-8a47-68315c85dc61",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02848",
    "licenseIssueDate": "01/12/2015 00:00:00",
    "licenseExpiryDate": "01/06/2026 00:00:00"
  },
  {
    "id": "069f23d7-3da5-4f50-9d53-89b745b5b353",
    "slug": "ahmed-mohamedtahir-ahmedtahir-mageet",
    "name": "Ahmed Mohamedtahir Ahmedtahir Mageet",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/07/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Mohamedtahir Ahmedtahir Mageet",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_069f23d7-3da5-4f50-9d53-89b745b5b353",
        "address": "Office No. M26 ,Al Garhoud Business Centre ,Al Garhoud Business Centre ,000 ,Dubai",
        "phone": "97142520160 / 971000000000",
        "email": "info@msklaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "82512feb-5424-43d4-8fe8-b84a1a0e1c4f",
    "firmName": "MARYAM SAIF KHATEM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06800",
    "licenseIssueDate": "05/07/2025 00:00:00",
    "licenseExpiryDate": "05/06/2026 00:00:00"
  },
  {
    "id": "fc7afb18-673b-49dc-921f-4b654fd0e1a6",
    "slug": "ahmed-mohammed-abdelkader-abuzahra",
    "name": "Ahmed Mohammed Abdelkader Abuzahra",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/20/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Mohammed Abdelkader Abuzahra",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fc7afb18-673b-49dc-921f-4b654fd0e1a6",
        "address": "",
        "phone": "97145293307",
        "email": "info@hyadvocate.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0d19b22a-0678-43d9-ae17-061958b88e0e",
    "firmName": "HUDA YAQOOB ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06155",
    "licenseIssueDate": "12/20/2023 00:00:00",
    "licenseExpiryDate": "12/19/2025 00:00:00"
  },
  {
    "id": "a2075783-173a-4976-bbac-66885337e569",
    "slug": "ahmed-mohammed-ahmed-kheiri",
    "name": "Ahmed Mohammed Ahmed Kheiri",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/29/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Mohammed Ahmed Kheiri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a2075783-173a-4976-bbac-66885337e569",
        "address": "",
        "phone": "97142212112",
        "email": "info@mjlaw.co",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ac58d621-9c02-48ae-8edc-dcf1b34a893d",
    "firmName": "MAJID ALJASSIM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06356",
    "licenseIssueDate": "05/29/2024 00:00:00",
    "licenseExpiryDate": "05/28/2026 00:00:00"
  },
  {
    "id": "26c461d6-bc82-4944-8aa4-0c76d70d4939",
    "slug": "ahmed-mokhtar-abdelazim-mohamed",
    "name": "Ahmed Mokhtar Abdelazim Mohamed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/03/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Mokhtar Abdelazim Mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_26c461d6-bc82-4944-8aa4-0c76d70d4939",
        "address": "مكتب رقم 403 – 504 - 102 ,القرن الواحد وعشرون ,مركز القبائل للتخفيضات ,68441 ,Dubai",
        "phone": "97142388763",
        "email": "shaikha.advo@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "80a47f20-166e-40d9-9dea-d793f4708270",
    "firmName": "SHAIKHA AHMAD ADVOCATES&LEGAL CONSULTANTS",
    "registrationNumber": "L-05224",
    "licenseIssueDate": "02/03/2022 00:00:00",
    "licenseExpiryDate": "02/02/2026 00:00:00"
  },
  {
    "id": "515e4e0a-9b9c-40a7-bcb0-54a25effd6b1",
    "slug": "ahmed-monir-elshaer",
    "name": "Ahmed Monir Elshaer",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/09/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Monir Elshaer",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_515e4e0a-9b9c-40a7-bcb0-54a25effd6b1",
        "address": "15th Floor _ Office No. 1504 ,SOBHA SAPPHIRE ,Makani No: 2612485764 ,000 ,Dubai",
        "phone": "97145570789 / 971521800001",
        "email": "Info@iserkal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "196bb7bb-4be6-4029-9367-c100bd219d3f",
    "firmName": "IBRAHIM ALSERKAL ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01747",
    "licenseIssueDate": "09/09/2012 00:00:00",
    "licenseExpiryDate": "09/01/2026 00:00:00"
  },
  {
    "id": "c5fa342e-d3b6-4b1b-8893-d2b19e665ed0",
    "slug": "ahmed-mostafa-gamal-mostafa-mohamed",
    "name": "AHMED MOSTAFA GAMAL MOSTAFA  MOHAMED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/26/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: AHMED MOSTAFA GAMAL MOSTAFA  MOHAMED",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c5fa342e-d3b6-4b1b-8893-d2b19e665ed0",
        "address": "",
        "phone": "97143266677 / 971506234989",
        "email": "md@khourilawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7f366bee-e90b-4c77-b535-ccd366935872",
    "firmName": "IBRAHIM KHOURI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05780",
    "licenseIssueDate": "04/26/2023 00:00:00",
    "licenseExpiryDate": "04/25/2026 00:00:00"
  },
  {
    "id": "f195117e-ef4f-4893-9443-b58ea134ef3e",
    "slug": "ahmed-moustafa-hafez-elrefaey",
    "name": "Ahmed Moustafa Hafez Elrefaey",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/07/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-07-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Moustafa Hafez Elrefaey",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f195117e-ef4f-4893-9443-b58ea134ef3e",
        "address": "AL SHEHHI GROUP ADVOCATES & LEGAL CONSULTANT ,الأول ,بناية المسعود ,مقابل لفندي ماريوت ,172662 ,Dubai",
        "phone": "97142384222",
        "email": "dubai@alshehhilawyer.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "bcc63eb3-5fc8-42bd-beb1-b29798bdcee4",
    "firmName": "AL SHEHHI GROUP ADVOCATES & LEGAL CONSULTANT",
    "registrationNumber": "L-03420",
    "licenseIssueDate": "08/01/2016 00:00:00",
    "licenseExpiryDate": "07/28/2025 00:00:00"
  },
  {
    "id": "af1f71f8-05ee-447d-a52c-864a1640e094",
    "slug": "ahmed-muhammed-el-bayouk",
    "name": "Ahmed Muhammed El Bayouk",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/12/2018",
    "licenseStatus": "active",
    "licenseExpiry": "2019-12-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Muhammed El Bayouk",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_af1f71f8-05ee-447d-a52c-864a1640e094",
        "address": "",
        "phone": "97144020800 / 971566830829",
        "email": "dean.ryburn@dentons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dfe13b7e-6625-45fd-ad63-9ee83af41194",
    "firmName": "Dentons & Co Dubai Branch-DED",
    "registrationNumber": "L-04285",
    "licenseIssueDate": "12/19/2018 00:00:00",
    "licenseExpiryDate": "12/17/2025 00:00:00"
  },
  {
    "id": "b3f1b576-663b-440d-a1ac-cb17345cf24c",
    "slug": "ahmed-mutawakil-eldirdiri",
    "name": "Ahmed Mutawakil Eldirdiri",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/29/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Mutawakil Eldirdiri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b3f1b576-663b-440d-a1ac-cb17345cf24c",
        "address": "",
        "phone": "97142830088 / 971505951775",
        "email": "dubai_lc@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dd2f1b59-88fd-4ade-9d8f-139a4b75fef0",
    "firmName": "DUBAI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02311",
    "licenseIssueDate": "09/29/2011 00:00:00",
    "licenseExpiryDate": "09/20/2026 00:00:00"
  },
  {
    "id": "e371f5d7-5af8-46bc-922a-013fab4f84db",
    "slug": "ahmed-osman-ahmed-mohammed",
    "name": "Ahmed Osman Ahmed Mohammed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/07/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Osman Ahmed Mohammed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e371f5d7-5af8-46bc-922a-013fab4f84db",
        "address": "",
        "phone": "97143553023",
        "email": "info@munaalshamsi30.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a92c9f4c-fad2-4893-b407-713b48ab7143",
    "firmName": "MUNA ALSHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06321",
    "licenseIssueDate": "05/07/2024 00:00:00",
    "licenseExpiryDate": "05/06/2026 00:00:00"
  },
  {
    "id": "17024b36-d310-4bdf-935b-53aab4514cc0",
    "slug": "ahmed-ramdan-attia-moustafa-mohamed",
    "name": "ahmed ramdan attia moustafa mohamed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/26/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ahmed ramdan attia moustafa mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_17024b36-d310-4bdf-935b-53aab4514cc0",
        "address": "saeed ,310 & 311 ,business avenue ,منطقه بور سعيد التجاريه ,19410 ,Dubai",
        "phone": "97148868812",
        "email": "info@saeedalghafri.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5acd50c8-df41-496b-a969-926d40e45c46",
    "firmName": "SAEED ALGHAFRI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05585",
    "licenseIssueDate": "10/26/2022 00:00:00",
    "licenseExpiryDate": "10/25/2025 00:00:00"
  },
  {
    "id": "9ebbdc08-a144-45e5-997f-ca21bace74b7",
    "slug": "ahmed-rashad-abdo-al-areqi",
    "name": "Ahmed Rashad Abdo Al Areqi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/18/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Rashad Abdo Al Areqi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9ebbdc08-a144-45e5-997f-ca21bace74b7",
        "address": "SAUD SULTAN HAMAD ,1st Floor ,AL GARHOOD BUSINESS CENTER ,Al Garhoud Medical Fitness Center ,21785 ,Dubai",
        "phone": "97143331110 / 971551127667",
        "email": "info@alshebliadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b3f35be9-7673-4d3f-954b-6f64de96bc2b",
    "firmName": "SAUD ALSHEBLI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06863",
    "licenseIssueDate": "06/18/2025 00:00:00",
    "licenseExpiryDate": "06/17/2026 00:00:00"
  },
  {
    "id": "10531485-a8ed-4d7e-a3b7-e938bfeaf963",
    "slug": "ahmed-refaat-sayed-refaei",
    "name": "Ahmed Refaat Sayed Refaei",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/29/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Refaat Sayed Refaei",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_10531485-a8ed-4d7e-a3b7-e938bfeaf963",
        "address": "4th Floor/ Office no. 401 ,Business Avenue  ,Infront- Terminal 2  ,115263 ,Dubai",
        "phone": "97144518866",
        "email": "info@aldhaheriinternational.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "cf3c19c0-d396-4bcb-b1db-b81273ed0b4c",
    "firmName": "AL DHAHERI INTERNATIONAL ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06845",
    "licenseIssueDate": "05/29/2025 00:00:00",
    "licenseExpiryDate": "05/28/2026 00:00:00"
  },
  {
    "id": "1bbbad06-c72c-4043-9f55-df452c9eb42d",
    "slug": "ahmed-saad-elhassanen-elfiky",
    "name": "Ahmed Saad Elhassanen Elfiky",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/28/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Saad Elhassanen Elfiky",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1bbbad06-c72c-4043-9f55-df452c9eb42d",
        "address": "ISMAIL HASSAN EBRAHIM ALSAFFAR ,الطابق الثامن - مكتب 801 AFR ,الصقر للاعمال ,يوجد اسفل البناية مطعم وينديز ,25752 ,Dubai",
        "phone": "97143276805",
        "email": "info@alsaffar-legal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ceb9cbcf-79f3-462d-afe2-aa4c62eff72b",
    "firmName": "ISMAIL ALSAFFAR ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05524",
    "licenseIssueDate": "09/28/2022 00:00:00",
    "licenseExpiryDate": "09/27/2026 00:00:00"
  },
  {
    "id": "b785070e-f3cd-44a7-8c63-a6723b7eb4f4",
    "slug": "ahmed-saber-ahmed",
    "name": "Ahmed Saber Ahmed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/26/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Saber Ahmed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b785070e-f3cd-44a7-8c63-a6723b7eb4f4",
        "address": "B2207 ,لطيفة تاور ,بجانب فندق فوكو دبي‎ ,410889 ,Dubai",
        "phone": "97143447557",
        "email": "info@amirasaqeradvo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d4393464-394a-4311-ac7d-2247c5af8bad",
    "firmName": "AMIRA SAQER ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01757",
    "licenseIssueDate": "09/26/2011 00:00:00",
    "licenseExpiryDate": "09/17/2026 00:00:00"
  },
  {
    "id": "10bc9b4d-0816-4b85-a18d-5f5374cb766e",
    "slug": "ahmed-saeed-abdelmohsen-mahrous",
    "name": "Ahmed Saeed Abdelmohsen Mahrous",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/02/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Saeed Abdelmohsen Mahrous",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_10bc9b4d-0816-4b85-a18d-5f5374cb766e",
        "address": "11 ,ميلينيوم بلازا  ,بجوار محطة ابراج الأمارات  ,410961 ,Dubai",
        "phone": "97142954626",
        "email": "info@advoamira.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "09f7b67c-8405-4dc9-982f-b8f9b921043c",
    "firmName": "DR AMIRA AL BASTAKI ADVOCATES AND LEGAL CONSULTANT",
    "registrationNumber": "L-05000",
    "licenseIssueDate": "08/02/2021 00:00:00",
    "licenseExpiryDate": "08/01/2026 00:00:00"
  },
  {
    "id": "5beab356-5170-4f98-810e-0e131ade8614",
    "slug": "ahmed-salah-ibrahim-mohamed",
    "name": "AHMED SALAH IBRAHIM MOHAMED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/09/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: AHMED SALAH IBRAHIM MOHAMED",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5beab356-5170-4f98-810e-0e131ade8614",
        "address": "",
        "phone": "97145686887 / 971566665693",
        "email": "info@alkirbilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "cef52068-add5-4e5a-83c8-600f746d48e3",
    "firmName": "SULAIMAN SALEM ALKARBI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-04711",
    "licenseIssueDate": "07/09/2020 00:00:00",
    "licenseExpiryDate": "07/08/2026 00:00:00"
  },
  {
    "id": "78f383b1-d001-403d-baf6-406f94e4e128",
    "slug": "ahmed-salah-ramadan",
    "name": "Ahmed Salah Ramadan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/09/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Salah Ramadan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_78f383b1-d001-403d-baf6-406f94e4e128",
        "address": "6F 603, 605, 7F 704 ,Crystal Tower ,Dubai Mall ,117538 ,Dubai",
        "phone": "97146098700",
        "email": "pro@miolawfirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "417f90a1-03be-4dab-8eea-1bba7e16f536",
    "firmName": "ABU BAKER SALEM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02200",
    "licenseIssueDate": "02/09/2012 00:00:00",
    "licenseExpiryDate": "01/31/2026 00:00:00"
  },
  {
    "id": "5c21cc6a-11c3-408b-830b-26a2a19ec573",
    "slug": "ahmed-sayed-ahmed-ahmed-boraey",
    "name": "Ahmed Sayed Ahmed Ahmed Boraey",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/12/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Sayed Ahmed Ahmed Boraey",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5c21cc6a-11c3-408b-830b-26a2a19ec573",
        "address": "18 ,برج السلام ,سما تاور ,68068 ,Dubai",
        "phone": "97143519700 / 971507973939",
        "email": "info@ramadanlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "08cb3f04-3a05-4815-9f28-6aa33c4b63dd",
    "firmName": "AHMED RAMADAN ADVOCATES &LEGAL CONSULTANTS",
    "registrationNumber": "L-04332",
    "licenseIssueDate": "03/12/2019 00:00:00",
    "licenseExpiryDate": "03/10/2026 00:00:00"
  },
  {
    "id": "5e8a9324-8854-48ee-a07e-4189ac21a353",
    "slug": "ahmed-sayed-aly-eid",
    "name": "Ahmed Sayed Aly Eid",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/29/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Sayed Aly Eid",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5e8a9324-8854-48ee-a07e-4189ac21a353",
        "address": "",
        "phone": "97143316868 / 971561446981",
        "email": "info@alhanaee.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "eb84bd6d-a78c-4fd6-8f46-4fab8eea60b5",
    "firmName": "ABDELAZIZ ALHANAEE ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-01755",
    "licenseIssueDate": "05/29/2024 00:00:00",
    "licenseExpiryDate": "05/28/2026 00:00:00"
  },
  {
    "id": "e4180552-8404-48f2-bcd6-abc3764f3be0",
    "slug": "ahmed-sobhi-abd-el-latif-attia",
    "name": "Ahmed Sobhi Abd El Latif Attia",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/27/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Sobhi Abd El Latif Attia",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e4180552-8404-48f2-bcd6-abc3764f3be0",
        "address": "",
        "phone": "97142212494",
        "email": "bayanlaw@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3eaca0c8-938e-4864-add1-73e5c902b168",
    "firmName": "DAR AL BAYAN ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02049",
    "licenseIssueDate": "04/27/2016 00:00:00",
    "licenseExpiryDate": "04/23/2026 00:00:00"
  },
  {
    "id": "cd9b5404-e6d2-462b-8409-0d51b1309408",
    "slug": "ahmed-sobhy-hamed-abdelkhalek-mahmoud",
    "name": "Ahmed Sobhy Hamed Abdelkhalek Mahmoud",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/15/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Sobhy Hamed Abdelkhalek Mahmoud",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cd9b5404-e6d2-462b-8409-0d51b1309408",
        "address": "21 ,Rolex Tower ,Emirates Grand Hotel ,94334 ,Dubai",
        "phone": "97143277772 / 97145584900",
        "email": "info@globaladvocates.net",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9b42810f-1d55-4aea-ac4a-7d9d1b25ac08",
    "firmName": "GLOBAL ADVOCACY & LEGAL COUNSEL",
    "registrationNumber": "L-06896",
    "licenseIssueDate": "07/15/2025 00:00:00",
    "licenseExpiryDate": "07/14/2026 00:00:00"
  },
  {
    "id": "71d3b658-708b-41a1-ab0b-761b04eca796",
    "slug": "ahmed-torki",
    "name": "Ahmed Torki",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/01/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Torki",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_71d3b658-708b-41a1-ab0b-761b04eca796",
        "address": "403 ,الطابق الاول مكتب 101 ,بناية الكنال سنترال ,اكاديمية هايونداي للتدريب  ,90209 ,Dubai",
        "phone": "97142970007",
        "email": "altdamon@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "1829252a-0804-4aaa-ad2a-4212e680346d",
    "firmName": "ALLIED ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02862",
    "licenseIssueDate": "03/01/2015 00:00:00",
    "licenseExpiryDate": "02/23/2026 00:00:00"
  },
  {
    "id": "1de5a259-4fc0-4888-940b-19343369abfb",
    "slug": "ahmed-yasser-abdelkarim-abdelghany-elfouli",
    "name": "Ahmed Yasser Abdelkarim Abdelghany Elfouli",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/06/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Yasser Abdelkarim Abdelghany Elfouli",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1de5a259-4fc0-4888-940b-19343369abfb",
        "address": "",
        "phone": "97144073901 / 971503479508",
        "email": "Rania.Tadros@stephensonharwood.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dd5042a2-bb41-4123-9544-79c3fa831332",
    "firmName": "Stephenson Harwood (Middle East) LLP",
    "registrationNumber": "L-05372",
    "licenseIssueDate": "07/06/2022 00:00:00",
    "licenseExpiryDate": "07/05/2026 00:00:00"
  },
  {
    "id": "fa830d7f-74ff-4a7a-8a55-4866fafa781d",
    "slug": "ahmed-yehia-ali-mohamed",
    "name": "Ahmed Yehia Ali Mohamed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/05/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Yehia Ali Mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fa830d7f-74ff-4a7a-8a55-4866fafa781d",
        "address": "الجناح الشمالي الطابق التاسع الوحدة 902 ,بنك المشرق جلوبال اتش كيه  ,برج خليفة  ,41422 ,Dubai",
        "phone": "97145514441",
        "email": "info@sat-law.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d0e8d9f9-263d-4e8a-af05-984f0cc97149",
    "firmName": "SAT & CO ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04895",
    "licenseIssueDate": "04/05/2021 00:00:00",
    "licenseExpiryDate": "04/04/2026 00:00:00"
  },
  {
    "id": "2004c611-ad31-4530-8dac-11ddd32f643e",
    "slug": "ahmed-yousif-mohammed-salih",
    "name": "Ahmed Yousif Mohammed  Salih",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/12/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Yousif Mohammed  Salih",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2004c611-ad31-4530-8dac-11ddd32f643e",
        "address": "",
        "phone": "97143333245 / 97143333245",
        "email": "y.albulooshi@yhadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5fd2b33a-4bae-47d7-86ce-bdbd42af4336",
    "firmName": "ALBALOOSHI AND ALMARASHIDA ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-04136",
    "licenseIssueDate": "06/12/2018 00:00:00",
    "licenseExpiryDate": "06/10/2026 00:00:00"
  },
  {
    "id": "62a7cfc6-7af1-4f2f-888b-dcdf0d7d424e",
    "slug": "ahmed-zonkel",
    "name": "Ahmed Zonkel",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBWgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/07/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Zonkel",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_62a7cfc6-7af1-4f2f-888b-dcdf0d7d424e",
        "address": "",
        "phone": "97148843777 / 971508825889",
        "email": "info@arlawyers.me",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e49cde31-d86a-482d-a53c-b2eb1265fb1f",
    "firmName": "ABDULRAHMAN AHMED ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03656",
    "licenseIssueDate": "02/07/2023 00:00:00",
    "licenseExpiryDate": "02/06/2026 00:00:00"
  },
  {
    "id": "d66eded5-bd04-485d-b1c5-dc589c3a7902",
    "slug": "ahmet-kalafat",
    "name": "Ahmet Kalafat",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/07/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmet Kalafat",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d66eded5-bd04-485d-b1c5-dc589c3a7902",
        "address": "",
        "phone": "97143779377 / 971505528593",
        "email": "rahail.ali@hoganlovells.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ef4b209f-a5f1-446f-82de-1b0675bbf53b",
    "firmName": "Hogan Lovells Middle East LLP",
    "registrationNumber": "L-00493",
    "licenseIssueDate": "10/07/2011 00:00:00",
    "licenseExpiryDate": "09/28/2026 00:00:00"
  },
  {
    "id": "cf0e039b-b879-4460-9b2a-9c353769e3ff",
    "slug": "aidan-barry",
    "name": "Aidan Barry",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/26/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Aidan Barry",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cf0e039b-b879-4460-9b2a-9c353769e3ff",
        "address": "6 ,Office Nos. 603, 604 & 605, Level 6, Burj Daman ,Dubai International Financial Centre ,506555 ,Dubai",
        "phone": "97143506400 / 971504654755",
        "email": "r.hickman@aglaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8690f7d5-6b96-4649-9589-71303f2c2707",
    "firmName": "Addleshaw Goddard (Middle East) LLP",
    "registrationNumber": "L-06657",
    "licenseIssueDate": "03/26/2025 00:00:00",
    "licenseExpiryDate": "03/25/2026 00:00:00"
  },
  {
    "id": "6c512ad4-f8f1-4d57-bb4f-393c98612e03",
    "slug": "aidan-thomas-fittis",
    "name": "Aidan Thomas Fittis",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/15/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Aidan Thomas Fittis",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6c512ad4-f8f1-4d57-bb4f-393c98612e03",
        "address": "6 ,Office Nos. 603, 604 & 605, Level 6, Burj Daman ,Dubai International Financial Centre ,506555 ,Dubai",
        "phone": "97143506400 / 971504654755",
        "email": "r.hickman@aglaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8690f7d5-6b96-4649-9589-71303f2c2707",
    "firmName": "Addleshaw Goddard (Middle East) LLP",
    "registrationNumber": "L-04851",
    "licenseIssueDate": "02/15/2021 00:00:00",
    "licenseExpiryDate": "02/14/2026 00:00:00"
  },
  {
    "id": "6df57c9c-9348-4578-abf4-419ed47bf086",
    "slug": "ailbhe-siobhain-ni-bhriain",
    "name": "Ailbhe Siobhain Ni Bhriain",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/09/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ailbhe Siobhain Ni Bhriain",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6df57c9c-9348-4578-abf4-419ed47bf086",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506688 ,Dubai",
        "phone": "97147096600 / 971503556811",
        "email": "muneer.khan@simmons-simmons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d1725ca7-06ac-41b2-8d7b-a6e60665b73d",
    "firmName": "Simmons & Simmons (Middle East) LLP-DIFC",
    "registrationNumber": "L-05679",
    "licenseIssueDate": "02/09/2023 00:00:00",
    "licenseExpiryDate": "02/08/2026 00:00:00"
  },
  {
    "id": "420515b8-bc42-4f4d-92c9-b777434e70bc",
    "slug": "aiman-mohamed-mohamed-abdellatif",
    "name": "Aiman Mohamed Mohamed Abdellatif",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/24/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Aiman Mohamed Mohamed Abdellatif",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_420515b8-bc42-4f4d-92c9-b777434e70bc",
        "address": "Obaid Ishaq Ismail Al-Maazmi ,الطابق 21 ,ذا اكستشينج تاور  ,فندق جي دبليو ماريوت ماركي ,238365 ,Dubai",
        "phone": "97143584737",
        "email": "obaidotp@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "70a8fb70-2729-4348-b87b-258c7dc7a387",
    "firmName": "OBAID ALMAAZMI LAWYER AND LEGAL CONSULTANT",
    "registrationNumber": "L-04440",
    "licenseIssueDate": "06/24/2019 00:00:00",
    "licenseExpiryDate": "06/23/2026 00:00:00"
  },
  {
    "id": "3e653513-0c10-418b-860e-044cb306872e",
    "slug": "aimy-roshan",
    "name": "Aimy Roshan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/17/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Aimy Roshan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3e653513-0c10-418b-860e-044cb306872e",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-02710",
    "licenseIssueDate": "03/17/2014 00:00:00",
    "licenseExpiryDate": "03/10/2026 00:00:00"
  },
  {
    "id": "8743ad8a-7a8d-41b0-986d-63a235eb148f",
    "slug": "aishwarya-rao",
    "name": "Aishwarya Rao",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/05/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Aishwarya Rao",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8743ad8a-7a8d-41b0-986d-63a235eb148f",
        "address": "ICD Brookfield Place ,DIFC ,506516 ,",
        "phone": "97143695800 / 971505526206",
        "email": "scott.campbell@linklaters.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5cec94c0-0649-43b6-a2be-ab17ff422bce",
    "firmName": "LinkLaters LLP",
    "registrationNumber": "L-04640",
    "licenseIssueDate": "03/05/2020 00:00:00",
    "licenseExpiryDate": "03/04/2026 00:00:00"
  },
  {
    "id": "b43a8dd9-2bbe-4cd9-bd1f-0746468184a0",
    "slug": "aishwarya-suresh-nair",
    "name": "Aishwarya Suresh Nair",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/30/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Aishwarya Suresh Nair",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b43a8dd9-2bbe-4cd9-bd1f-0746468184a0",
        "address": "20 ,Index Tower West Tower ,DIFC ,507226 ,Dubai",
        "phone": "97142461900 / 971523391604",
        "email": "patrick.gearon@crsblaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e2ac552e-b9a7-450b-a84d-15119e583220",
    "firmName": "Charles Russell Speechlys LLP",
    "registrationNumber": "L-04607",
    "licenseIssueDate": "06/30/2025 00:00:00",
    "licenseExpiryDate": "06/29/2026 00:00:00"
  },
  {
    "id": "348549cf-46e9-4217-9a38-d5217098c914",
    "slug": "ajai-ramakrishnan-nellayappa-iyer-ramakrishna-iyer",
    "name": "Ajai Ramakrishnan Nellayappa Iyer Ramakrishna Iyer",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/02/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ajai Ramakrishnan Nellayappa Iyer Ramakrishna Iyer",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_348549cf-46e9-4217-9a38-d5217098c914",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-04505",
    "licenseIssueDate": "10/02/2019 00:00:00",
    "licenseExpiryDate": "10/01/2026 00:00:00"
  },
  {
    "id": "a3d4378d-572e-47f6-9e8d-dd322618f842",
    "slug": "ajith-madhavan",
    "name": "Ajith Madhavan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/31/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ajith Madhavan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a3d4378d-572e-47f6-9e8d-dd322618f842",
        "address": "Building 10, Unit P05 ,Business Bay ,999041 ,",
        "phone": "97100000000 / 971502870418",
        "email": "adv.m.ajith@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "4d1f95f5-2298-4b6a-a003-65d083d3eebb",
    "firmName": "Ajith M Legal Consultancy",
    "registrationNumber": "L-06194",
    "licenseIssueDate": "01/31/2024 00:00:00",
    "licenseExpiryDate": "01/30/2026 00:00:00"
  },
  {
    "id": "227c334f-4899-4fe0-b11a-77c85d998d98",
    "slug": "akber-ali-oravan-kundil",
    "name": "Akber Ali Oravan Kundil",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/15/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Akber Ali Oravan Kundil",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_227c334f-4899-4fe0-b11a-77c85d998d98",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04211",
    "licenseIssueDate": "09/15/2018 00:00:00",
    "licenseExpiryDate": "09/13/2026 00:00:00"
  },
  {
    "id": "4134d0ec-d1e4-412c-81a6-7a5f30a942b9",
    "slug": "akeem-kelson-robinson",
    "name": "Akeem Kelson Robinson",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/26/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Akeem Kelson Robinson",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4134d0ec-d1e4-412c-81a6-7a5f30a942b9",
        "address": "",
        "phone": "97143637999 / 971506525633",
        "email": "daniel.wood@walkersglobal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a3a9927b-d51c-490c-8be6-d575ea3eb041",
    "firmName": "Walkers (Middle East) LLP",
    "registrationNumber": "L-06360",
    "licenseIssueDate": "06/26/2024 00:00:00",
    "licenseExpiryDate": "06/25/2026 00:00:00"
  },
  {
    "id": "1410dbc4-4062-48e7-8459-d20ff7757907",
    "slug": "akihiro-hanoshima",
    "name": "Akihiro Hanoshima",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/19/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Akihiro Hanoshima",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1410dbc4-4062-48e7-8459-d20ff7757907",
        "address": "- ,Index Tower ,Dubai International Financial Centre ,9371 ,Dubai",
        "phone": "97143303900 / 971561753537",
        "email": "christopher@afridi-angell.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3e464dc8-b800-4ba2-ad91-24a5f9640fef",
    "firmName": "Afridi & Angell-DIFC",
    "registrationNumber": "L-05914",
    "licenseIssueDate": "07/19/2023 00:00:00",
    "licenseExpiryDate": "07/18/2026 00:00:00"
  },
  {
    "id": "8b27f975-7480-4cc0-8d88-7366172613e3",
    "slug": "al-ameer-meliegy-ali-ghanem",
    "name": "Al Ameer Meliegy Ali Ghanem",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/01/2021",
    "licenseStatus": "active",
    "licenseExpiry": "2022-01-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Al Ameer Meliegy Ali Ghanem",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8b27f975-7480-4cc0-8d88-7366172613e3",
        "address": "6F 603, 605, 7F 704 ,Crystal Tower ,Dubai Mall ,117538 ,Dubai",
        "phone": "97146098700",
        "email": "pro@miolawfirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "417f90a1-03be-4dab-8eea-1bba7e16f536",
    "firmName": "ABU BAKER SALEM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04832",
    "licenseIssueDate": "01/14/2021 00:00:00",
    "licenseExpiryDate": "01/13/2026 00:00:00"
  },
  {
    "id": "5d6a40d1-7250-48bb-8879-a936fd8115d6",
    "slug": "al-cheikh-najib-kais",
    "name": "Al Cheikh Najib Kais",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/20/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Al Cheikh Najib Kais",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5d6a40d1-7250-48bb-8879-a936fd8115d6",
        "address": "",
        "phone": "97144529091 / 971552805308",
        "email": "ashafi@ach-legal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4f3e1e80-c812-4585-9570-229cd96776a4",
    "firmName": "Anjarwalla, Collins and Haidermota Legal Consultants",
    "registrationNumber": "L-01870",
    "licenseIssueDate": "04/20/2022 00:00:00",
    "licenseExpiryDate": "04/19/2026 00:00:00"
  },
  {
    "id": "dacefa6d-4790-4382-ab95-58fdd35b0bf3",
    "slug": "al-misbah-abdelghadir-ahmed",
    "name": "Al Misbah Abdelghadir Ahmed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/28/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Al Misbah Abdelghadir Ahmed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dacefa6d-4790-4382-ab95-58fdd35b0bf3",
        "address": "MOSTAFA MAHMOUD  ,1304 ,AL MOOSA TOWER 1 ,First Trade Center ,25635 ,Dubai",
        "phone": "97142254438",
        "email": "info@hkadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d73d1b91-74ae-4266-9f38-d28296d70f52",
    "firmName": "HAMDAN ALKAABI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01241",
    "licenseIssueDate": "12/28/2022 00:00:00",
    "licenseExpiryDate": "12/27/2025 00:00:00"
  },
  {
    "id": "10229d49-e2ff-498e-991d-3f62e8c9cd8b",
    "slug": "alaa-abdelaziz-eldakrouri-farag-eldakrouri",
    "name": "ALAA ABDELAZIZ ELDAKROURI FARAG ELDAKROURI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/12/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2021-12-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: alaa abdelaziz eldakrouri farag eldakrouri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_10229d49-e2ff-498e-991d-3f62e8c9cd8b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-03947",
    "licenseIssueDate": "12/27/2017 00:00:00",
    "licenseExpiryDate": "12/24/2021 00:00:00"
  },
  {
    "id": "91383c7b-a56e-48d5-9f5b-0bea6dc62698",
    "slug": "alaa-abdelkarim",
    "name": "Alaa Abdelkarim",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/04/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alaa Abdelkarim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_91383c7b-a56e-48d5-9f5b-0bea6dc62698",
        "address": "الطابق الاول  ,بناية مشاريع قرقاش - مكتب رقم 102  ,وكاله مرسيدس  ,393947 ,Dubai",
        "phone": "97143799917",
        "email": "info@amt-legal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2485aa73-a460-4867-9452-297e9feb733e",
    "firmName": "MARYAM ABDULLAH ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-02839",
    "licenseIssueDate": "11/04/2014 00:00:00",
    "licenseExpiryDate": "10/29/2026 00:00:00"
  },
  {
    "id": "968f6166-15c2-4618-8ff0-2582844c6ff8",
    "slug": "alaa-eraki-mohamed-farag",
    "name": "Alaa Eraki Mohamed Farag",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/17/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alaa Eraki Mohamed Farag",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_968f6166-15c2-4618-8ff0-2582844c6ff8",
        "address": "3-505 ,AL KHABEESI BLDG ,AL KABEESI ,4948 ,Dubai",
        "phone": "97142222228",
        "email": "info@alkamali.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "054f38f4-9e51-4623-ad36-7941043a051c",
    "firmName": "AL KAMALI & COMPANY ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-02246",
    "licenseIssueDate": "05/17/2012 00:00:00",
    "licenseExpiryDate": "05/09/2026 00:00:00"
  },
  {
    "id": "221f5aa9-7ba2-40ca-aea4-3be12cd63fd4",
    "slug": "alaa-fadhil-babr",
    "name": "Alaa Fadhil Babr",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alaa Fadhil Babr",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_221f5aa9-7ba2-40ca-aea4-3be12cd63fd4",
        "address": "Noushad kn ,1 ,sama tower ,Chello Restaurant  ,87706 ,Dubai",
        "phone": "97142822744",
        "email": "info@hosanilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c063023c-8d6f-4566-8537-31e0c9977c77",
    "firmName": "AL HOSANY ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-02398",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "030e2e55-0cf7-45c8-a2fa-14c835421852",
    "slug": "alaa-farahat",
    "name": "ALAA FARAHAT",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/21/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ALAA FARAHAT",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_030e2e55-0cf7-45c8-a2fa-14c835421852",
        "address": "",
        "phone": "97142500251",
        "email": "hassan.suwaidi@hhslawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "92cddf0e-969b-47c0-a9a7-9fb57a11d292",
    "firmName": "HASSAN HUMAID AL SUWAIDI ADVOCATES AND LEGAL CONSULTANCY",
    "registrationNumber": "L-06460",
    "licenseIssueDate": "08/21/2024 00:00:00",
    "licenseExpiryDate": "08/20/2026 00:00:00"
  },
  {
    "id": "b9958db6-439d-414d-9bc0-40b36bfbecbb",
    "slug": "alaa-gaber-mohamed-el-houshy",
    "name": "Alaa Gaber Mohamed El Houshy",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/29/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alaa Gaber Mohamed El Houshy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b9958db6-439d-414d-9bc0-40b36bfbecbb",
        "address": "Amal Khamis Darwish Al Blooshi ,floor23-office2304 ,Aspect Tower ,Bay Avenue ,103951 ,Dubai",
        "phone": "97142276165",
        "email": "info@amalkhamisadvo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "99eb0f0c-7559-4826-a035-6f38ef3676a9",
    "firmName": "AMAL KHAMIS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01358",
    "licenseIssueDate": "12/29/2014 00:00:00",
    "licenseExpiryDate": "12/22/2025 00:00:00"
  },
  {
    "id": "37c1a638-f593-4bfc-95ea-c9d883ebfeae",
    "slug": "alaa-issam-mroueh",
    "name": "Alaa Issam Mroueh",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/27/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alaa Issam Mroueh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_37c1a638-f593-4bfc-95ea-c9d883ebfeae",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-05437",
    "licenseIssueDate": "07/27/2022 00:00:00",
    "licenseExpiryDate": "07/26/2026 00:00:00"
  },
  {
    "id": "919f282b-90c4-4371-b149-9d8c1266f083",
    "slug": "alaa-momtaz",
    "name": "Alaa Momtaz",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/24/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-01-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alaa Momtaz",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_919f282b-90c4-4371-b149-9d8c1266f083",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03595",
    "licenseIssueDate": "01/24/2017 00:00:00",
    "licenseExpiryDate": "01/20/2026 00:00:00"
  },
  {
    "id": "24bfa508-2c1a-45e6-9a5f-af8b275f3ad5",
    "slug": "alaaalden-aboshanab",
    "name": "Alaaalden Aboshanab",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/04/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alaaalden Aboshanab",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_24bfa508-2c1a-45e6-9a5f-af8b275f3ad5",
        "address": "",
        "phone": "97143300009 / 971501215000",
        "email": "mohamed@maa.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "af85c161-b73d-46a2-9fd7-4d8604007473",
    "firmName": "MOHAMED ALI ALHAMMADI ADVOCATES & LEGAL CONSULTANT",
    "registrationNumber": "L-03561",
    "licenseIssueDate": "01/04/2017 00:00:00",
    "licenseExpiryDate": "12/31/2025 00:00:00"
  },
  {
    "id": "418eb9b1-5dd1-4d61-9f4e-902a159f579a",
    "slug": "alaaeldin-abdallah-emad-ahmed",
    "name": "Alaaeldin Abdallah Emad Ahmed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/04/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alaaeldin Abdallah Emad Ahmed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_418eb9b1-5dd1-4d61-9f4e-902a159f579a",
        "address": "Sarhan Hassan Mohamed Hassan Almuaini ,Office 1002, Level 10 ,THE OBEROI CENTRE ,Business Bay Metro Station ,1169 ,Dubai",
        "phone": "97142324000",
        "email": "info@drsarhanlawyer.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "14541022-bde4-43ab-9ba1-489e87187b42",
    "firmName": "DR SARHAN ALMUAINI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03562",
    "licenseIssueDate": "01/04/2017 00:00:00",
    "licenseExpiryDate": "12/31/2025 00:00:00"
  },
  {
    "id": "c00a32da-945d-4645-9a68-c08df4e7097c",
    "slug": "alaaeldin-mohamed-elsayed-morad",
    "name": "alaaeldin mohamed elsayed morad",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/14/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: alaaeldin mohamed elsayed morad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c00a32da-945d-4645-9a68-c08df4e7097c",
        "address": "O-4801, O-4901 ,Burj al Salam Office Tower ,H Hotel ,111801 ,Dubai",
        "phone": "97143544444",
        "email": "administration@horizlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4e25fb39-6659-44f0-bc8b-3ff0f067beb0",
    "firmName": "HORIZONS & CO - LAW FIRM",
    "registrationNumber": "L-04672",
    "licenseIssueDate": "05/14/2020 00:00:00",
    "licenseExpiryDate": "05/13/2026 00:00:00"
  },
  {
    "id": "745220d6-bac4-49b1-b5eb-f8708a21f199",
    "slug": "aladdin-hamza-alamin-ahmed",
    "name": "Aladdin Hamza Alamin Ahmed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/17/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Aladdin Hamza Alamin Ahmed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_745220d6-bac4-49b1-b5eb-f8708a21f199",
        "address": "",
        "phone": "",
        "email": "fawzia.mohd.2009@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "336f9090-d6f4-4c0b-bccb-c08fd95ea5cc",
    "firmName": "FAWZIA MOHAMMAD ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06941",
    "licenseIssueDate": "09/17/2025 00:00:00",
    "licenseExpiryDate": "09/16/2026 00:00:00"
  },
  {
    "id": "4efbc9ba-6db6-4770-9906-fc9c411cc027",
    "slug": "alagammai-murugappan",
    "name": "Alagammai Murugappan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/21/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alagammai Murugappan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4efbc9ba-6db6-4770-9906-fc9c411cc027",
        "address": "",
        "phone": "97144286300 / 971506256686",
        "email": "stuart.paterson@hsf.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2f0389b3-bfde-44f4-bdd6-6e1a22f9cab2",
    "firmName": "Herbert Smith Freehills Kramer LLP",
    "registrationNumber": "L-06601",
    "licenseIssueDate": "11/21/2024 00:00:00",
    "licenseExpiryDate": "11/20/2025 00:00:00"
  },
  {
    "id": "4ae85624-2809-41e8-bae4-1b417c15612f",
    "slug": "alain-sfeir",
    "name": "Alain Sfeir",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alain Sfeir",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4ae85624-2809-41e8-bae4-1b417c15612f",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-00258",
    "licenseIssueDate": "05/29/2012 00:00:00",
    "licenseExpiryDate": "05/21/2026 00:00:00"
  },
  {
    "id": "29632f2c-a194-47b5-a6a5-cb87de5ec148",
    "slug": "alam-abdelaal-nassar",
    "name": "Alam Abdelaal Nassar",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/24/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alam Abdelaal Nassar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_29632f2c-a194-47b5-a6a5-cb87de5ec148",
        "address": "",
        "phone": "97142508799 / 971504748037",
        "email": "info@alhamlifirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4a2de7d0-110d-4514-a3ea-9fa2d2b61618",
    "firmName": "AHMED ALHAMLI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-02316",
    "licenseIssueDate": "05/24/2022 00:00:00",
    "licenseExpiryDate": "05/23/2026 00:00:00"
  },
  {
    "id": "3852acc0-33eb-4c93-af2a-233329cec312",
    "slug": "alamir-izzat-al-amir-ghaleb-alayoubi",
    "name": "Alamir Izzat Al Amir Ghaleb Alayoubi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/12/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alamir Izzat Al Amir Ghaleb Alayoubi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3852acc0-33eb-4c93-af2a-233329cec312",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-05563",
    "licenseIssueDate": "10/12/2022 00:00:00",
    "licenseExpiryDate": "10/11/2026 00:00:00"
  },
  {
    "id": "658fc49a-d338-46bf-a1b7-d9662e081fab",
    "slug": "alan-james-scurry",
    "name": "Alan James Scurry",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/05/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alan James Scurry",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_658fc49a-d338-46bf-a1b7-d9662e081fab",
        "address": "",
        "phone": "97144073901 / 971503479508",
        "email": "Rania.Tadros@stephensonharwood.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dd5042a2-bb41-4123-9544-79c3fa831332",
    "firmName": "Stephenson Harwood (Middle East) LLP",
    "registrationNumber": "L-06673",
    "licenseIssueDate": "03/05/2025 00:00:00",
    "licenseExpiryDate": "03/04/2026 00:00:00"
  },
  {
    "id": "89ffbfa5-3162-433e-8fe8-4c9f8fed58fd",
    "slug": "alan-rodgers",
    "name": "Alan Rodgers",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/29/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alan Rodgers",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_89ffbfa5-3162-433e-8fe8-4c9f8fed58fd",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-02060",
    "licenseIssueDate": "11/29/2011 00:00:00",
    "licenseExpiryDate": "11/20/2025 00:00:00"
  },
  {
    "id": "31b8cad3-339f-42b4-9301-1a2d034a0a93",
    "slug": "alan-wahid",
    "name": "Alan Wahid",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/22/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alan Wahid",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_31b8cad3-339f-42b4-9301-1a2d034a0a93",
        "address": "1 ,ICD Brookfield Place ,Dubai International Financial Centre ,9267 ,Dubai",
        "phone": "97147010975 / 971502977062",
        "email": "chris.sioufi@ae.ey.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "42e536ef-e3d8-4339-8572-657a7f7a0331",
    "firmName": "EY Law LLP",
    "registrationNumber": "L-05120",
    "licenseIssueDate": "11/22/2021 00:00:00",
    "licenseExpiryDate": "11/21/2025 00:00:00"
  },
  {
    "id": "cd21eec6-e1b1-4f5e-aae5-46d791695f70",
    "slug": "alan-wood",
    "name": "Alan Wood",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alan Wood",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cd21eec6-e1b1-4f5e-aae5-46d791695f70",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-02692",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "d6bfd0af-0132-49dd-91df-6665e9c84f14",
    "slug": "alana-stephanie-burton",
    "name": "Alana Stephanie Burton",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/11/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alana Stephanie Burton",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d6bfd0af-0132-49dd-91df-6665e9c84f14",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-04931",
    "licenseIssueDate": "04/11/2025 00:00:00",
    "licenseExpiryDate": "04/10/2026 00:00:00"
  },
  {
    "id": "9b54fb80-8c20-4335-ae65-625e77c88840",
    "slug": "alanood-issam-sinjab",
    "name": "Alanood Issam Sinjab",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/02/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alanood Issam Sinjab",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9b54fb80-8c20-4335-ae65-625e77c88840",
        "address": "Index Tower ,Dubai International Financial Centre ,507115 ,",
        "phone": "97143757160 / 971523490280",
        "email": "tthraya@mayerbrown.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c7f52b69-c049-4246-963a-9805b241f88a",
    "firmName": "Mayer Brown LLP",
    "registrationNumber": "L-06634",
    "licenseIssueDate": "01/02/2025 00:00:00",
    "licenseExpiryDate": "01/01/2026 00:00:00"
  },
  {
    "id": "e411db29-9233-4d66-b361-3724319f6696",
    "slug": "alastair-glover",
    "name": "Alastair Glover",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/29/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alastair Glover",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e411db29-9233-4d66-b361-3724319f6696",
        "address": "",
        "phone": "97144073901 / 971503479508",
        "email": "Rania.Tadros@stephensonharwood.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dd5042a2-bb41-4123-9544-79c3fa831332",
    "firmName": "Stephenson Harwood (Middle East) LLP",
    "registrationNumber": "L-02150",
    "licenseIssueDate": "09/29/2013 00:00:00",
    "licenseExpiryDate": "09/22/2026 00:00:00"
  },
  {
    "id": "bc7d5de8-97c7-4b8d-b41a-feaab719d732",
    "slug": "alastair-holland",
    "name": "Alastair Holland",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/22/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alastair Holland",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bc7d5de8-97c7-4b8d-b41a-feaab719d732",
        "address": "Index Tower ,DIFC ,506896 ,",
        "phone": "97142782300 / 971551154791",
        "email": "GLeggate@wfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e2b82cfc-80a5-4957-ae41-b1a7beb693c1",
    "firmName": "Watson, Farley & Williams (Middle East) LLP",
    "registrationNumber": "L-03640",
    "licenseIssueDate": "02/22/2017 00:00:00",
    "licenseExpiryDate": "02/18/2026 00:00:00"
  },
  {
    "id": "555eafb4-12bc-42a4-addc-816c058d377c",
    "slug": "alawi-salem-mohammed-alsakkaf",
    "name": "ALAWI SALEM MOHAMMED ALSAKKAF",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/22/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ALAWI SALEM MOHAMMED ALSAKKAF",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_555eafb4-12bc-42a4-addc-816c058d377c",
        "address": "18 ,فندق مونارك  ,مركز التجاري ,98444 ,Dubai",
        "phone": "97143588777",
        "email": "info@bhadvoc.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "61266d12-f5b4-4466-a1a8-a45934d9e511",
    "firmName": "BIN HAIDER ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05255",
    "licenseIssueDate": "03/22/2022 00:00:00",
    "licenseExpiryDate": "03/21/2026 00:00:00"
  },
  {
    "id": "71604fb2-76d6-4645-9279-6bddf98f31a4",
    "slug": "albert-jove-franco",
    "name": "Albert Jove Franco",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/27/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Albert Jove Franco",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_71604fb2-76d6-4645-9279-6bddf98f31a4",
        "address": "A7 ,Dubai Silicon Oasis ,29337 ,",
        "phone": "97144313060 / 971528448686",
        "email": "andres.ring@schlueter-graf.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2ce110f0-b433-4dbc-b15f-ab1a3b291c28",
    "firmName": "Schluter Graf Legal Consultants LLC",
    "registrationNumber": "L-03759",
    "licenseIssueDate": "04/27/2017 00:00:00",
    "licenseExpiryDate": "04/23/2026 00:00:00"
  },
  {
    "id": "234ce874-297d-4143-b9cc-297819eac300",
    "slug": "albert-kromm",
    "name": "Albert Kromm",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/28/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Albert Kromm",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_234ce874-297d-4143-b9cc-297819eac300",
        "address": "THE OFFICES 1 ,DWTC ,115580 ,",
        "phone": "97143739700 / 971501148248",
        "email": "nitesh.pradhan@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "361fdc64-6b6f-4f37-abca-c52af8473b84",
    "firmName": "Pinsent Masons  LLP (DWTCA Branch)",
    "registrationNumber": "L-04480",
    "licenseIssueDate": "08/28/2019 00:00:00",
    "licenseExpiryDate": "08/27/2026 00:00:00"
  },
  {
    "id": "a5363b8a-1715-43a7-a8a2-3a502d3c7a3f",
    "slug": "aleefa",
    "name": "Aleefa",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/18/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Aleefa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a5363b8a-1715-43a7-a8a2-3a502d3c7a3f",
        "address": "",
        "phone": "97143303900 / 971561753537",
        "email": "christopher@afridi-angell.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "30ce50dc-01a6-499d-8ace-3f807ddcb08d",
    "firmName": "Afridi & Angell-DED",
    "registrationNumber": "L-06056",
    "licenseIssueDate": "10/18/2023 00:00:00",
    "licenseExpiryDate": "10/17/2025 00:00:00"
  },
  {
    "id": "fa9e7ad9-969c-4c04-bf35-35aad65038d0",
    "slug": "alejandra-esmoris",
    "name": "Alejandra Esmoris",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/19/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alejandra Esmoris",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fa9e7ad9-969c-4c04-bf35-35aad65038d0",
        "address": "South Tower, Emirates Financial Towers ,DIFC ,482025 ,",
        "phone": "97145875333 / 971503444388",
        "email": "c.dersahakian@cvml.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e2c6db70-04e7-4c7b-882a-6d2ffe4469ed",
    "firmName": "CVML Limited",
    "registrationNumber": "L-04805",
    "licenseIssueDate": "11/19/2020 00:00:00",
    "licenseExpiryDate": "11/18/2025 00:00:00"
  },
  {
    "id": "0441b177-0536-4726-9f1f-d000e1730a93",
    "slug": "alekhya-prakash",
    "name": "Alekhya Prakash",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/15/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alekhya Prakash",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0441b177-0536-4726-9f1f-d000e1730a93",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-00130",
    "licenseIssueDate": "05/15/2025 00:00:00",
    "licenseExpiryDate": "05/14/2026 00:00:00"
  },
  {
    "id": "180d7024-e996-4afb-9996-1eb5c753943b",
    "slug": "aleksandr-tombak",
    "name": "Aleksandr Tombak",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/24/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Aleksandr Tombak",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_180d7024-e996-4afb-9996-1eb5c753943b",
        "address": "",
        "phone": "97143121800 / 971566017967",
        "email": "alishia.sullivan@morganlewis.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6eab20d7-8716-4b0a-8710-144d1d951c23",
    "firmName": "Morgan, Lewis & Bockius LLP (dubai Branch)",
    "registrationNumber": "L-05805",
    "licenseIssueDate": "05/24/2023 00:00:00",
    "licenseExpiryDate": "05/23/2026 00:00:00"
  },
  {
    "id": "2a6695a0-df6f-4f51-ae06-64ebf70c4485",
    "slug": "aleksandra-saj",
    "name": "Aleksandra Saj",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/01/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Aleksandra Saj",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2a6695a0-df6f-4f51-ae06-64ebf70c4485",
        "address": "Al Fattan Currency House - Tower 1  ,Dubai International Financial Center  ,507104 ,",
        "phone": "97143978565 / 971504587822",
        "email": "Raafat.hares@dwf.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6e5f6dba-07af-4109-8c34-175296450f94",
    "firmName": "DWF (Middle East) LLP",
    "registrationNumber": "L-06978",
    "licenseIssueDate": "09/25/2025 00:00:00",
    "licenseExpiryDate": "09/24/2026 00:00:00"
  },
  {
    "id": "59344779-4425-4bd5-a403-81e9eb37107b",
    "slug": "aleksei-chetov",
    "name": "Aleksei Chetov",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/08/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Aleksei Chetov",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_59344779-4425-4bd5-a403-81e9eb37107b",
        "address": "",
        "phone": "97143121800 / 971566017967",
        "email": "alishia.sullivan@morganlewis.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6eab20d7-8716-4b0a-8710-144d1d951c23",
    "firmName": "Morgan, Lewis & Bockius LLP (dubai Branch)",
    "registrationNumber": "L-05357",
    "licenseIssueDate": "06/08/2022 00:00:00",
    "licenseExpiryDate": "06/07/2026 00:00:00"
  },
  {
    "id": "198a1b2f-cbca-44ee-aefd-2cf069b81d07",
    "slug": "alena-neskoromyuk",
    "name": "Alena Neskoromyuk",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/11/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alena Neskoromyuk",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_198a1b2f-cbca-44ee-aefd-2cf069b81d07",
        "address": "",
        "phone": "97143121800 / 971566017967",
        "email": "alishia.sullivan@morganlewis.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6eab20d7-8716-4b0a-8710-144d1d951c23",
    "firmName": "Morgan, Lewis & Bockius LLP (dubai Branch)",
    "registrationNumber": "L-05797",
    "licenseIssueDate": "05/11/2023 00:00:00",
    "licenseExpiryDate": "05/10/2026 00:00:00"
  },
  {
    "id": "74332002-817e-4540-8a8a-f5006a8d96a3",
    "slug": "alessandro-tricoli",
    "name": "Alessandro Tricoli",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alessandro Tricoli",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_74332002-817e-4540-8a8a-f5006a8d96a3",
        "address": "23 ,Rolex Tower ,Trade Center Second ,116637 ,Dubai",
        "phone": "97144357577 / 971502101003",
        "email": "jasamin.fichte@fichtelegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "77bf4fd2-1cd1-4bda-a0c2-ffcac3980b76",
    "firmName": "Fichte & Co Legal Consultancy",
    "registrationNumber": "L-00544",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "fdd27336-358d-40b9-b9e9-05f7bc5e14c4",
    "slug": "alessandro-vaselli",
    "name": "Alessandro Vaselli",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBVgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/10/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alessandro Vaselli",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fdd27336-358d-40b9-b9e9-05f7bc5e14c4",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-06619",
    "licenseIssueDate": "12/10/2024 00:00:00",
    "licenseExpiryDate": "12/09/2025 00:00:00"
  },
  {
    "id": "70e9e28a-4339-4687-9bd1-b85def149c66",
    "slug": "alessio-chirumbolo",
    "name": "Alessio Chirumbolo",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/09/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alessio Chirumbolo",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_70e9e28a-4339-4687-9bd1-b85def149c66",
        "address": "",
        "phone": "97145579711",
        "email": "info@mqadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9f91cca7-a15d-499f-b265-2a032fe38fa1",
    "firmName": "FATMA ALMUTAWA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05966",
    "licenseIssueDate": "08/09/2023 00:00:00",
    "licenseExpiryDate": "08/08/2026 00:00:00"
  },
  {
    "id": "8c83e434-2f31-4cf1-bb02-49937e08b135",
    "slug": "alex-hamilton",
    "name": "Alex Hamilton",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/21/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alex Hamilton",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8c83e434-2f31-4cf1-bb02-49937e08b135",
        "address": "",
        "phone": "97144286300 / 971506256686",
        "email": "stuart.paterson@hsf.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2f0389b3-bfde-44f4-bdd6-6e1a22f9cab2",
    "firmName": "Herbert Smith Freehills Kramer LLP",
    "registrationNumber": "L-06474",
    "licenseIssueDate": "08/21/2024 00:00:00",
    "licenseExpiryDate": "08/20/2026 00:00:00"
  },
  {
    "id": "3c547725-feeb-45f1-b82f-ae7d2e12fd14",
    "slug": "alex-katelyn-vromans",
    "name": "Alex Katelyn Vromans",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/08/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alex Katelyn Vromans",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3c547725-feeb-45f1-b82f-ae7d2e12fd14",
        "address": "",
        "phone": "97104309100 / 971564013758",
        "email": "c.royle@taylorwessing.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d51b6f43-8c62-486f-a1ab-6ee3b87c8006",
    "firmName": "Taylor Wessing LLP (Dubai Branch)",
    "registrationNumber": "L-04753",
    "licenseIssueDate": "10/08/2020 00:00:00",
    "licenseExpiryDate": "10/07/2026 00:00:00"
  },
  {
    "id": "e1654613-04f6-4982-8a74-babfd313856e",
    "slug": "alexander-alan-claybourn",
    "name": "Alexander Alan Claybourn",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/06/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alexander Alan Claybourn",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e1654613-04f6-4982-8a74-babfd313856e",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-06542",
    "licenseIssueDate": "11/06/2024 00:00:00",
    "licenseExpiryDate": "11/05/2025 00:00:00"
  },
  {
    "id": "2b08bc32-3c03-419f-9608-2f4dbd179ba3",
    "slug": "alexander-andrew-grant",
    "name": "Alexander Andrew Grant",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/03/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alexander Andrew Grant",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2b08bc32-3c03-419f-9608-2f4dbd179ba3",
        "address": "- ,Index Tower ,Dubai International Financial Centre ,9371 ,Dubai",
        "phone": "97143303900 / 971561753537",
        "email": "christopher@afridi-angell.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3e464dc8-b800-4ba2-ad91-24a5f9640fef",
    "firmName": "Afridi & Angell-DIFC",
    "registrationNumber": "L-06530",
    "licenseIssueDate": "10/03/2024 00:00:00",
    "licenseExpiryDate": "10/02/2026 00:00:00"
  },
  {
    "id": "be63f710-dad6-4a1a-be79-7cab14ac4a74",
    "slug": "alexander-carroll",
    "name": "Alexander Carroll",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/25/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-02-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alexander Carroll",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_be63f710-dad6-4a1a-be79-7cab14ac4a74",
        "address": "",
        "phone": "97144020800 / 971566830829",
        "email": "dean.ryburn@dentons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dfe13b7e-6625-45fd-ad63-9ee83af41194",
    "firmName": "Dentons & Co Dubai Branch-DED",
    "registrationNumber": "L-00400",
    "licenseIssueDate": "02/25/2012 00:00:00",
    "licenseExpiryDate": "02/16/2026 00:00:00"
  },
  {
    "id": "7f33784d-4d1f-49e9-a08f-fcb074a89c8d",
    "slug": "alexander-gasparyan",
    "name": "ALEXANDER GASPARYAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/16/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ALEXANDER GASPARYAN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7f33784d-4d1f-49e9-a08f-fcb074a89c8d",
        "address": "",
        "phone": "97143779377 / 971505528593",
        "email": "rahail.ali@hoganlovells.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ef4b209f-a5f1-446f-82de-1b0675bbf53b",
    "firmName": "Hogan Lovells Middle East LLP",
    "registrationNumber": "L-05575",
    "licenseIssueDate": "11/16/2022 00:00:00",
    "licenseExpiryDate": "11/15/2025 00:00:00"
  },
  {
    "id": "6a82965d-2f7b-4463-89ec-ce0506092288",
    "slug": "alexander-gordon-hendry",
    "name": "Alexander Gordon Hendry",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/08/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alexander Gordon Hendry",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6a82965d-2f7b-4463-89ec-ce0506092288",
        "address": "",
        "phone": "97144363636 / 971505572900",
        "email": "hassan.elsayed@bakerbotts.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "fd5d6571-d053-4436-9de5-c8a36ce7c6c9",
    "firmName": "Baker Botts LLP Legal Consultants Dubai Branch",
    "registrationNumber": "L-04551",
    "licenseIssueDate": "03/08/2024 00:00:00",
    "licenseExpiryDate": "03/07/2026 00:00:00"
  },
  {
    "id": "22e3b417-2ef4-4ee3-a0f9-81d9213544f2",
    "slug": "alexander-james-douglas-sparrow",
    "name": "Alexander James Douglas Sparrow",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/12/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alexander James Douglas Sparrow",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_22e3b417-2ef4-4ee3-a0f9-81d9213544f2",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-06414",
    "licenseIssueDate": "07/12/2024 00:00:00",
    "licenseExpiryDate": "07/11/2026 00:00:00"
  },
  {
    "id": "88a24a82-3905-469a-adc4-7a99dd356be3",
    "slug": "alexander-kitaev",
    "name": "Alexander Kitaev",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/21/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alexander Kitaev",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_88a24a82-3905-469a-adc4-7a99dd356be3",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05510",
    "licenseIssueDate": "09/21/2022 00:00:00",
    "licenseExpiryDate": "09/20/2026 00:00:00"
  },
  {
    "id": "99b7604c-5700-419b-a4c6-14cdf7abe1de",
    "slug": "alexander-layden",
    "name": "Alexander Layden",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/16/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alexander Layden",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_99b7604c-5700-419b-a4c6-14cdf7abe1de",
        "address": "",
        "phone": "97144529091 / 971552805308",
        "email": "ashafi@ach-legal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4f3e1e80-c812-4585-9570-229cd96776a4",
    "firmName": "Anjarwalla, Collins and Haidermota Legal Consultants",
    "registrationNumber": "L-05286",
    "licenseIssueDate": "01/16/2025 00:00:00",
    "licenseExpiryDate": "01/15/2026 00:00:00"
  },
  {
    "id": "44e74271-4002-4389-a708-a021d9e07cff",
    "slug": "alexander-luetgendorf",
    "name": "Alexander Luetgendorf",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/05/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alexander Luetgendorf",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_44e74271-4002-4389-a708-a021d9e07cff",
        "address": "",
        "phone": "97144323671 / 971505589395",
        "email": "fba@amereller.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a139ca64-8897-4d1d-8d71-97446bc1e15a",
    "firmName": "Amereller Legal Consultancy LLC SOC",
    "registrationNumber": "L-01919",
    "licenseIssueDate": "12/05/2012 00:00:00",
    "licenseExpiryDate": "11/27/2025 00:00:00"
  },
  {
    "id": "a0bb031b-d14a-4482-ad14-b8994ebc0c99",
    "slug": "alexander-patrick-field",
    "name": "Alexander Patrick Field",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/08/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alexander Patrick Field",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a0bb031b-d14a-4482-ad14-b8994ebc0c99",
        "address": "ICD Brookfield Place ,Za'abeel 2 ,103747 ,",
        "phone": "97143696300 / 971506008159",
        "email": "mohammed.paracha@nortonrosefulbright.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c4aaee93-0ec4-4982-9a48-a23699492056",
    "firmName": "Norton Rose Fullbright (Middle East) LLP",
    "registrationNumber": "L-04740",
    "licenseIssueDate": "10/08/2020 00:00:00",
    "licenseExpiryDate": "10/07/2026 00:00:00"
  },
  {
    "id": "05835615-5acb-4593-b3c6-03787c255c21",
    "slug": "alexander-reid",
    "name": "Alexander Reid",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/04/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alexander Reid",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_05835615-5acb-4593-b3c6-03787c255c21",
        "address": "20 ,Index Tower West Tower ,DIFC ,507226 ,Dubai",
        "phone": "97142461900 / 971523391604",
        "email": "patrick.gearon@crsblaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e2ac552e-b9a7-450b-a84d-15119e583220",
    "firmName": "Charles Russell Speechlys LLP",
    "registrationNumber": "L-03317",
    "licenseIssueDate": "02/04/2016 00:00:00",
    "licenseExpiryDate": "01/30/2026 00:00:00"
  },
  {
    "id": "667f85a3-1320-41ad-b0b4-7ed3522ec39b",
    "slug": "alexander-reurt-barker",
    "name": "Alexander Reurt Barker",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/21/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alexander Reurt Barker",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_667f85a3-1320-41ad-b0b4-7ed3522ec39b",
        "address": "",
        "phone": "97143779900 / 971508548052",
        "email": "jali@kslaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dff8529a-82be-431a-b72b-0192ff238011",
    "firmName": "King & Spalding LLP",
    "registrationNumber": "L-06471",
    "licenseIssueDate": "08/21/2024 00:00:00",
    "licenseExpiryDate": "08/20/2026 00:00:00"
  },
  {
    "id": "a78ecf19-4f7d-44ed-867c-f459b5a87513",
    "slug": "alexander-robert-wagg",
    "name": "Alexander Robert Wagg",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/07/2021",
    "licenseStatus": "active",
    "licenseExpiry": "2022-07-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alexander Robert Wagg",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a78ecf19-4f7d-44ed-867c-f459b5a87513",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-04975",
    "licenseIssueDate": "07/05/2021 00:00:00",
    "licenseExpiryDate": "07/04/2026 00:00:00"
  },
  {
    "id": "4fe176bc-efe3-4101-aba8-ef78d9f45e0a",
    "slug": "alexander-sarac",
    "name": "Alexander Sarac",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/14/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alexander Sarac",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4fe176bc-efe3-4101-aba8-ef78d9f45e0a",
        "address": "6 ,Office Nos. 603, 604 & 605, Level 6, Burj Daman ,Dubai International Financial Centre ,506555 ,Dubai",
        "phone": "97143506400 / 971504654755",
        "email": "r.hickman@aglaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8690f7d5-6b96-4649-9589-71303f2c2707",
    "firmName": "Addleshaw Goddard (Middle East) LLP",
    "registrationNumber": "L-03423",
    "licenseIssueDate": "08/14/2016 00:00:00",
    "licenseExpiryDate": "08/10/2026 00:00:00"
  },
  {
    "id": "69baeea2-5588-478b-992e-0e009dba05ea",
    "slug": "alexander-stephen-mackay",
    "name": "Alexander Stephen Mackay",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/15/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-01-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alexander Stephen Mackay",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_69baeea2-5588-478b-992e-0e009dba05ea",
        "address": "Index Tower ,506548 ,Dubai",
        "phone": "97147096300 / 971506767433",
        "email": "amateen@reedsmith.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b3f87e90-7ce9-4097-82c4-15232365f175",
    "firmName": "Reed Smith LLP",
    "registrationNumber": "L-04594",
    "licenseIssueDate": "01/15/2020 00:00:00",
    "licenseExpiryDate": "01/14/2026 00:00:00"
  },
  {
    "id": "a5ee6b1c-f0ea-4c1e-820a-0fd08fb0e148",
    "slug": "alexandra-alayche",
    "name": "Alexandra Alayche",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/14/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alexandra Alayche",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a5ee6b1c-f0ea-4c1e-820a-0fd08fb0e148",
        "address": "",
        "phone": "97145953601 / 971508728645",
        "email": "Steven.Bainbridge@gtlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b4146aa6-efd1-41d7-819d-49da46353b0b",
    "firmName": "Greenberg Traurig Limited",
    "registrationNumber": "L-06794",
    "licenseIssueDate": "05/14/2025 00:00:00",
    "licenseExpiryDate": "05/13/2026 00:00:00"
  },
  {
    "id": "c819d97c-a6d0-4e39-9119-1b7b243df565",
    "slug": "alexandra-braterskaya",
    "name": "Alexandra Braterskaya",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/08/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alexandra Braterskaya",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c819d97c-a6d0-4e39-9119-1b7b243df565",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-05397",
    "licenseIssueDate": "01/08/2025 00:00:00",
    "licenseExpiryDate": "01/07/2026 00:00:00"
  },
  {
    "id": "046216ac-83cb-44ad-a129-bdf8ffe3d2e3",
    "slug": "alexandra-catherine-marion-ivy-aikman",
    "name": "Alexandra Catherine Marion Ivy Aikman",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/14/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-01-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alexandra Catherine Marion Ivy Aikman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_046216ac-83cb-44ad-a129-bdf8ffe3d2e3",
        "address": "THE OFFICES 1 ,DWTC ,115580 ,",
        "phone": "97143739700 / 971501148248",
        "email": "nitesh.pradhan@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "361fdc64-6b6f-4f37-abca-c52af8473b84",
    "firmName": "Pinsent Masons  LLP (DWTCA Branch)",
    "registrationNumber": "L-03890",
    "licenseIssueDate": "01/14/2025 00:00:00",
    "licenseExpiryDate": "01/13/2026 00:00:00"
  },
  {
    "id": "4ad44b3e-006c-401a-9a41-8d1d45afdeca",
    "slug": "alexandra-chayenne-bertz",
    "name": "Alexandra Chayenne Bertz",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/18/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-01-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alexandra Chayenne Bertz",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4ad44b3e-006c-401a-9a41-8d1d45afdeca",
        "address": "THE OFFICES 1 ,DWTC ,115580 ,",
        "phone": "97143739700 / 971501148248",
        "email": "nitesh.pradhan@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "361fdc64-6b6f-4f37-abca-c52af8473b84",
    "firmName": "Pinsent Masons  LLP (DWTCA Branch)",
    "registrationNumber": "L-05702",
    "licenseIssueDate": "01/18/2023 00:00:00",
    "licenseExpiryDate": "01/17/2026 00:00:00"
  },
  {
    "id": "e49533f5-fe89-4465-9592-0ed9c590d1b0",
    "slug": "alexandra-ellen-dorothea-c-harmer",
    "name": "Alexandra Ellen Dorothea C Harmer",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/08/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alexandra Ellen Dorothea C Harmer",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e49533f5-fe89-4465-9592-0ed9c590d1b0",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506688 ,Dubai",
        "phone": "97147096600 / 971503556811",
        "email": "muneer.khan@simmons-simmons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d1725ca7-06ac-41b2-8d7b-a6e60665b73d",
    "firmName": "Simmons & Simmons (Middle East) LLP-DIFC",
    "registrationNumber": "L-06285",
    "licenseIssueDate": "05/08/2024 00:00:00",
    "licenseExpiryDate": "05/07/2026 00:00:00"
  },
  {
    "id": "7aaa7b14-b5d5-4a52-84f6-dbfbcf8cd280",
    "slug": "alexandra-hall",
    "name": "Alexandra Hall",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/07/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alexandra Hall",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7aaa7b14-b5d5-4a52-84f6-dbfbcf8cd280",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-03054",
    "licenseIssueDate": "12/07/2014 00:00:00",
    "licenseExpiryDate": "12/01/2025 00:00:00"
  },
  {
    "id": "7e6cae87-c984-4797-9c9e-7ad9497d6034",
    "slug": "alexandra-khvorostyanova",
    "name": "Alexandra Khvorostyanova",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/16/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alexandra Khvorostyanova",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7e6cae87-c984-4797-9c9e-7ad9497d6034",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-05755",
    "licenseIssueDate": "03/16/2023 00:00:00",
    "licenseExpiryDate": "03/15/2026 00:00:00"
  },
  {
    "id": "f9d60cc2-1c9e-43b2-a78c-e0510c98a1e8",
    "slug": "alexandra-lester",
    "name": "Alexandra Lester",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/14/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alexandra Lester",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f9d60cc2-1c9e-43b2-a78c-e0510c98a1e8",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-03234",
    "licenseIssueDate": "12/14/2015 00:00:00",
    "licenseExpiryDate": "12/09/2025 00:00:00"
  },
  {
    "id": "2dd57746-bc19-47d7-ab7f-5b2c50e404c7",
    "slug": "alexandra-lily-harding",
    "name": "Alexandra Lily Harding",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/03/2022",
    "licenseStatus": "active",
    "licenseExpiry": "2023-03-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alexandra Lily Harding",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2dd57746-bc19-47d7-ab7f-5b2c50e404c7",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-05230",
    "licenseIssueDate": "03/15/2022 00:00:00",
    "licenseExpiryDate": "03/14/2026 00:00:00"
  },
  {
    "id": "c0dbfa48-0c65-4e89-bdf8-04d2f2b9041d",
    "slug": "alexandra-ohare",
    "name": "Alexandra O'Hare",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/09/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alexandra O'Hare",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c0dbfa48-0c65-4e89-bdf8-04d2f2b9041d",
        "address": "Building 5 ,Dubai World Trade Centre ,212620 ,",
        "phone": "97143503600 / 971563631562",
        "email": "p.ellingham@kennedys-law.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "83d3ede1-3a28-4b03-8c92-6bd31a1cb95e",
    "firmName": "Kennedys Dubai LLP",
    "registrationNumber": "L-06856",
    "licenseIssueDate": "07/09/2025 00:00:00",
    "licenseExpiryDate": "07/08/2026 00:00:00"
  },
  {
    "id": "a4036c34-c2bb-4022-a4b1-eaf181e39af6",
    "slug": "alexandre-brazeau",
    "name": "Alexandre Brazeau",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/20/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alexandre Brazeau",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a4036c34-c2bb-4022-a4b1-eaf181e39af6",
        "address": "Level 17, ICD Brookfield Place ,DIFC ,506503 ,",
        "phone": "97144375100 / 971588271196",
        "email": "libby.edwards-smith@gowlingwlg.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "436703ba-b9c0-4dcb-93b2-1299c7a051f4",
    "firmName": "Gowling WLG (UK) LLP (Dubai Branch)",
    "registrationNumber": "L-03519",
    "licenseIssueDate": "10/20/2016 00:00:00",
    "licenseExpiryDate": "10/16/2026 00:00:00"
  },
  {
    "id": "a4d3171e-6c8c-46bc-9464-c83b2a9a58b9",
    "slug": "alexandros-roussos",
    "name": "Alexandros Roussos",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/07/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alexandros Roussos",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a4d3171e-6c8c-46bc-9464-c83b2a9a58b9",
        "address": "",
        "phone": "97145953601 / 971508728645",
        "email": "Steven.Bainbridge@gtlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b4146aa6-efd1-41d7-819d-49da46353b0b",
    "firmName": "Greenberg Traurig Limited",
    "registrationNumber": "L-00494",
    "licenseIssueDate": "10/07/2011 00:00:00",
    "licenseExpiryDate": "09/28/2026 00:00:00"
  },
  {
    "id": "cd984b14-0fdf-47f2-b7db-0097ef740afc",
    "slug": "alexey-pashinskiy",
    "name": "Alexey Pashinskiy",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/04/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-03-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alexey Pashinskiy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cd984b14-0fdf-47f2-b7db-0097ef740afc",
        "address": "",
        "phone": "97143121800 / 971566017967",
        "email": "alishia.sullivan@morganlewis.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6eab20d7-8716-4b0a-8710-144d1d951c23",
    "firmName": "Morgan, Lewis & Bockius LLP (dubai Branch)",
    "registrationNumber": "L-06150",
    "licenseIssueDate": "01/04/2024 00:00:00",
    "licenseExpiryDate": "01/03/2026 00:00:00"
  },
  {
    "id": "9d80710d-760c-4d95-af07-b375ebb9256d",
    "slug": "alexis-waller",
    "name": "Alexis Waller",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/11/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alexis Waller",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9d80710d-760c-4d95-af07-b375ebb9256d",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-00261",
    "licenseIssueDate": "10/11/2011 00:00:00",
    "licenseExpiryDate": "10/02/2026 00:00:00"
  },
  {
    "id": "f012640e-ba51-46eb-8be7-b3581ac2fd2e",
    "slug": "aleyna-aydin",
    "name": "Aleyna Aydin",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/14/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Aleyna Aydin",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f012640e-ba51-46eb-8be7-b3581ac2fd2e",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-06787",
    "licenseIssueDate": "05/14/2025 00:00:00",
    "licenseExpiryDate": "05/13/2026 00:00:00"
  },
  {
    "id": "0a8eff97-7e81-42fa-96eb-5fc2dbfec934",
    "slug": "alhassane-barry",
    "name": "Alhassane Barry",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/08/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alhassane Barry",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0a8eff97-7e81-42fa-96eb-5fc2dbfec934",
        "address": "Index Tower ,DIFC ,506896 ,",
        "phone": "97142782300 / 971551154791",
        "email": "GLeggate@wfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e2b82cfc-80a5-4957-ae41-b1a7beb693c1",
    "firmName": "Watson, Farley & Williams (Middle East) LLP",
    "registrationNumber": "L-04589",
    "licenseIssueDate": "01/08/2020 00:00:00",
    "licenseExpiryDate": "01/07/2026 00:00:00"
  },
  {
    "id": "95698091-069e-47a8-8cfb-51268d974669",
    "slug": "ali-abdalla-mohamed-el-shakh",
    "name": "Ali Abdalla Mohamed El Shakh",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ali Abdalla Mohamed El Shakh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_95698091-069e-47a8-8cfb-51268d974669",
        "address": "",
        "phone": "97142507778 / 971506421661",
        "email": "feedback@alshamsilawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4b400e1b-7731-4a4b-9c37-a77e3c03ab78",
    "firmName": "NASSER AL SHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01754",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "eb2e511c-b431-451b-bdcc-30cac141df74",
    "slug": "ali-abdallah-abdelmoez-abdallah-abdelhaleem",
    "name": "Ali Abdallah Abdelmoez Abdallah Abdelhaleem",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/29/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ali Abdallah Abdelmoez Abdallah Abdelhaleem",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_eb2e511c-b431-451b-bdcc-30cac141df74",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-06351",
    "licenseIssueDate": "05/29/2024 00:00:00",
    "licenseExpiryDate": "05/28/2026 00:00:00"
  },
  {
    "id": "44c55847-d051-4575-8ef0-f3fa87c5d24e",
    "slug": "ali-ahmad-awad",
    "name": "Ali Ahmad Awad",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/16/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ali Ahmad Awad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_44c55847-d051-4575-8ef0-f3fa87c5d24e",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03439",
    "licenseIssueDate": "08/16/2016 00:00:00",
    "licenseExpiryDate": "08/12/2026 00:00:00"
  },
  {
    "id": "adf4ef6b-bd58-4321-b5c5-7d853ecfa3a1",
    "slug": "ali-ahmed-ibrahim-mohamed",
    "name": "Ali Ahmed Ibrahim Mohamed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/12/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ali Ahmed Ibrahim Mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_adf4ef6b-bd58-4321-b5c5-7d853ecfa3a1",
        "address": "",
        "phone": "97142955575",
        "email": "info@yalhamed.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "af6ac730-58a7-44a4-9f60-78811de374c7",
    "firmName": "YASIN ALHAMED ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05542",
    "licenseIssueDate": "10/12/2022 00:00:00",
    "licenseExpiryDate": "10/11/2025 00:00:00"
  },
  {
    "id": "1d04d38a-d77a-466d-9763-70a343e895a2",
    "slug": "ali-ajjob",
    "name": "Ali Ajjob",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ali Ajjob",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1d04d38a-d77a-466d-9763-70a343e895a2",
        "address": "",
        "phone": "97143256020 / 971504400073",
        "email": "info@sw-advocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "05dddabf-0dfa-4843-b0a8-cf6eaa27136d",
    "firmName": "MOHAMMAD SHEHAB ALFARSI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01400",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "1c3326b7-a293-4287-a56d-fb6724b8017f",
    "slug": "ali-al-assaad",
    "name": "Ali Al Assaad",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/14/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ali Al Assaad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1c3326b7-a293-4287-a56d-fb6724b8017f",
        "address": "",
        "phone": "97144020800 / 971566830829",
        "email": "dean.ryburn@dentons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dfe13b7e-6625-45fd-ad63-9ee83af41194",
    "firmName": "Dentons & Co Dubai Branch-DED",
    "registrationNumber": "L-03559",
    "licenseIssueDate": "04/14/2021 00:00:00",
    "licenseExpiryDate": "04/13/2026 00:00:00"
  },
  {
    "id": "b17b8a49-2df5-47e1-8558-af8e1d2788ff",
    "slug": "ali-bachrouch",
    "name": "Ali Bachrouch",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ali Bachrouch",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b17b8a49-2df5-47e1-8558-af8e1d2788ff",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02303",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "a5a19c5a-d649-4fd5-9792-426641369aca",
    "slug": "ali-ibrahim-el-maoula",
    "name": "ALI IBRAHIM EL MAOULA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/22/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ALI IBRAHIM EL MAOULA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a5a19c5a-d649-4fd5-9792-426641369aca",
        "address": "YASIR AL NAQBI ,21 ,48 BURJ ,SOFITEL DOWN  TOWN ,181111 ,Dubai",
        "phone": "97142689949",
        "email": "info@alnaqbipartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ad71430e-83ee-4cb5-a530-bc58db2618f6",
    "firmName": "ALNAQBI & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04857",
    "licenseIssueDate": "02/22/2021 00:00:00",
    "licenseExpiryDate": "02/21/2026 00:00:00"
  },
  {
    "id": "c41e1760-c4d9-469b-bfe2-fb7e34ea67f6",
    "slug": "ali-ismail-ali-mahmoud-hegazy",
    "name": "ALI ISMAIL ALI MAHMOUD HEGAZY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/05/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2024-04-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ali Ismail Ali Mahmoud Hegazy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c41e1760-c4d9-469b-bfe2-fb7e34ea67f6",
        "address": "الثالث  ,برج جيت  48  ,مخرج ميترو برج خليفه / دبي مول  ,181111 ,Dubai",
        "phone": "97145143423 / 971971451434",
        "email": "info.justice@fhsadvo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "690778ba-3332-4c06-b01f-ab5ec89ee304",
    "firmName": "FATEMA HASAN ALSHEHHI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-04902",
    "licenseIssueDate": "04/05/2021 00:00:00",
    "licenseExpiryDate": "04/04/2024 00:00:00"
  },
  {
    "id": "15cb6c72-2658-40ca-bec1-9d3399fad2de",
    "slug": "ali-kamal-mostafa-ahmed",
    "name": "Ali Kamal Mostafa Ahmed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/19/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ali Kamal Mostafa Ahmed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_15cb6c72-2658-40ca-bec1-9d3399fad2de",
        "address": "",
        "phone": "97142227008 / 971506245451",
        "email": "info@abdulmaliklaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5714833f-5b48-477b-a556-efa3a779f522",
    "firmName": "ABDULMALIK & ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03941",
    "licenseIssueDate": "12/19/2017 00:00:00",
    "licenseExpiryDate": "12/16/2025 00:00:00"
  },
  {
    "id": "4c0e31cb-9d3a-4ac7-8c72-f6881bc95314",
    "slug": "ali-khalid-mohamed-ali-alhammadi",
    "name": "ALI KHALID MOHAMED ALI ALHAMMADI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/03/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ALI KHALID MOHAMED ALI ALHAMMADI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4c0e31cb-9d3a-4ac7-8c72-f6881bc95314",
        "address": "",
        "phone": "97143444491 / 971508002092",
        "email": "awdfms@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dfb85a31-3414-4198-9ccd-c3ae8ac4ed71",
    "firmName": "AWAD ALARYANI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-06521",
    "licenseIssueDate": "10/03/2024 00:00:00",
    "licenseExpiryDate": "10/02/2026 00:00:00"
  },
  {
    "id": "b2d6495e-80e7-4dfd-80bb-d736ed6ad1b7",
    "slug": "ali-mohamed-ali-abouali",
    "name": "Ali Mohamed Ali Abouali",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/25/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ali Mohamed Ali Abouali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b2d6495e-80e7-4dfd-80bb-d736ed6ad1b7",
        "address": "",
        "phone": "97145539905",
        "email": "info@ama-alali.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a1add4ec-4f01-41b2-9875-540545839906",
    "firmName": "Fatmah Al Ali Advocates & Legal Consultancy",
    "registrationNumber": "L-03946",
    "licenseIssueDate": "12/25/2017 00:00:00",
    "licenseExpiryDate": "12/22/2025 00:00:00"
  },
  {
    "id": "68ad655f-630e-41b6-adc1-def32f738d66",
    "slug": "ali-omer-elbadawi-ali",
    "name": "Ali Omer Elbadawi Ali",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/06/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ali Omer Elbadawi Ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_68ad655f-630e-41b6-adc1-def32f738d66",
        "address": "",
        "phone": "97142343373 / 971507004104",
        "email": "almansoorilawyer@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "19c9c654-e8a0-4ae8-b2e6-1f0b9dfac171",
    "firmName": "ABDULLA EBRAHIM ALMANSOORI LAWYERS AND LEGAL CONSULTANTS",
    "registrationNumber": "L-06202",
    "licenseIssueDate": "03/06/2024 00:00:00",
    "licenseExpiryDate": "03/05/2026 00:00:00"
  },
  {
    "id": "61b3082b-cefa-4de0-bc9b-0a3d19a6369a",
    "slug": "ali-saleh-atrooz-al-sudani",
    "name": "Ali Saleh Atrooz Al Sudani",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/24/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ali Saleh Atrooz Al Sudani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_61b3082b-cefa-4de0-bc9b-0a3d19a6369a",
        "address": "Ali Saleh Atrooz  ,1103 ,EMPIRE HEIGHTS B ,دبي مول  ,18433 ,Dubai",
        "phone": "97142222511",
        "email": "info@araalaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "aab79fde-e700-45d7-904f-bde0a593a087",
    "firmName": "ARAA GROUP ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06876",
    "licenseIssueDate": "06/24/2025 00:00:00",
    "licenseExpiryDate": "06/23/2026 00:00:00"
  },
  {
    "id": "f372edb4-1964-4276-b136-2f312d1348f7",
    "slug": "ali-salim-dakhlallah",
    "name": "ALI SALIM DAKHLALLAH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/02/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ALI SALIM DAKHLALLAH",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f372edb4-1964-4276-b136-2f312d1348f7",
        "address": "",
        "phone": "97144230000 / 971552009022",
        "email": "UAE-CourtClerks@habibalmulla.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3eba82bb-8ec4-4cbd-80d0-a793cb993fde",
    "firmName": "Habib Al Mulla & Partners ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04452",
    "licenseIssueDate": "07/02/2019 00:00:00",
    "licenseExpiryDate": "07/01/2026 00:00:00"
  },
  {
    "id": "79abff0d-56c6-452e-82a9-2f2e58187f7a",
    "slug": "ali-shaikley",
    "name": "Ali Shaikley",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/10/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ali Shaikley",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_79abff0d-56c6-452e-82a9-2f2e58187f7a",
        "address": "",
        "phone": "/ 971000000000",
        "email": "tthesing@sidley.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "32091971-c716-41d1-a21d-cc50c9fb3214",
    "firmName": "Sidley Austin LLP",
    "registrationNumber": "L-02754",
    "licenseIssueDate": "09/10/2024 00:00:00",
    "licenseExpiryDate": "09/09/2026 00:00:00"
  },
  {
    "id": "e21348a9-58a4-40b5-b981-c962a4e91e2e",
    "slug": "ali-sholkami-mohamed",
    "name": "Ali Sholkami Mohamed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ali Sholkami Mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e21348a9-58a4-40b5-b981-c962a4e91e2e",
        "address": "",
        "phone": "97143889955",
        "email": "m.alhanafi@nooflaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "6a72f470-256a-46d0-bead-acf13b981406",
    "firmName": "NOOF ALABDULLA ADVOCATES & LEGAL CONSULTANTS L.L.C",
    "registrationNumber": "L-01482",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "49ef9874-8232-4624-b90f-739af7822115",
    "slug": "ali-sikander",
    "name": "Ali Sikander",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/05/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ali Sikander",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_49ef9874-8232-4624-b90f-739af7822115",
        "address": "One Central, The Offices 5 ,Dubai World Trade Centre ,554660 ,",
        "phone": "97142052030 / 971506566494",
        "email": "chourani@houranipartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "59a73632-40a0-4849-b120-4308dc6f8015",
    "firmName": "Hourani & Partners Legal Consultancy FZCO",
    "registrationNumber": "L-06340",
    "licenseIssueDate": "06/05/2024 00:00:00",
    "licenseExpiryDate": "06/04/2026 00:00:00"
  },
  {
    "id": "2cf90f9b-0f3c-4901-b263-bb43936b7563",
    "slug": "ali-yassin-awadelgeed-adam",
    "name": "Ali Yassin Awadelgeed Adam",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/29/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ali Yassin Awadelgeed Adam",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2cf90f9b-0f3c-4901-b263-bb43936b7563",
        "address": "",
        "phone": "97142830088 / 971505951775",
        "email": "dubai_lc@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dd2f1b59-88fd-4ade-9d8f-139a4b75fef0",
    "firmName": "DUBAI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01809",
    "licenseIssueDate": "09/29/2011 00:00:00",
    "licenseExpiryDate": "09/20/2026 00:00:00"
  },
  {
    "id": "44b62b73-d2cf-4551-9b97-60cc0651849a",
    "slug": "alia-koudsi",
    "name": "Alia Koudsi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/22/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-01-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alia Koudsi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_44b62b73-d2cf-4551-9b97-60cc0651849a",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06645",
    "licenseIssueDate": "01/22/2025 00:00:00",
    "licenseExpiryDate": "01/21/2026 00:00:00"
  },
  {
    "id": "c994981c-32b2-4551-8879-f504ff0c4df0",
    "slug": "aliaa-firas-ibrahim-ibrahim",
    "name": "Aliaa Firas Ibrahim Ibrahim",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/18/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Aliaa Firas Ibrahim Ibrahim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c994981c-32b2-4551-8879-f504ff0c4df0",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-05077",
    "licenseIssueDate": "10/18/2021 00:00:00",
    "licenseExpiryDate": "10/17/2026 00:00:00"
  },
  {
    "id": "1ed94a2a-2355-4fd9-a07f-565f4a41a04d",
    "slug": "aliana-dhanani",
    "name": "Aliana Dhanani",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/01/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Aliana Dhanani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1ed94a2a-2355-4fd9-a07f-565f4a41a04d",
        "address": "0 ,ICD Brookfield Place Level 13 ,Trade Centre ,506569 ,Dubai",
        "phone": "97145099100 / 971501006965",
        "email": "menahr@freshfields.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "970f6246-e737-41a7-9c6c-5aa5b8335d45",
    "firmName": "Freshfields LLP DIFC",
    "registrationNumber": "L-05231",
    "licenseIssueDate": "03/01/2022 00:00:00",
    "licenseExpiryDate": "02/28/2026 00:00:00"
  },
  {
    "id": "af9ba5f2-4594-42b4-807b-6790a622d422",
    "slug": "aline-von-during",
    "name": "Aline Von During",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBVgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/12/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Aline Von During",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_af9ba5f2-4594-42b4-807b-6790a622d422",
        "address": "",
        "phone": "97145683100 / 971559223103",
        "email": "rossi@bonnard-lawson.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2b373724-e557-4c31-a968-7d37d9393842",
    "firmName": "Bonnard Lawson Legal Consultants L.L.C",
    "registrationNumber": "L-02945",
    "licenseIssueDate": "12/12/2023 00:00:00",
    "licenseExpiryDate": "12/11/2025 00:00:00"
  },
  {
    "id": "941d54b1-2796-4d53-963d-22d6b7c912e4",
    "slug": "alisha-syeda-rasul",
    "name": "Alisha Syeda Rasul",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/26/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alisha Syeda Rasul",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_941d54b1-2796-4d53-963d-22d6b7c912e4",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506688 ,Dubai",
        "phone": "97147096600 / 971503556811",
        "email": "muneer.khan@simmons-simmons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d1725ca7-06ac-41b2-8d7b-a6e60665b73d",
    "firmName": "Simmons & Simmons (Middle East) LLP-DIFC",
    "registrationNumber": "L-04991",
    "licenseIssueDate": "07/26/2021 00:00:00",
    "licenseExpiryDate": "07/25/2026 00:00:00"
  },
  {
    "id": "d3eca4aa-9a28-4b2c-b950-63e94486aa5a",
    "slug": "alishia-kathryn-sullivan",
    "name": "Alishia Kathryn Sullivan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/14/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alishia Kathryn Sullivan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d3eca4aa-9a28-4b2c-b950-63e94486aa5a",
        "address": "",
        "phone": "97143121800 / 971566017967",
        "email": "alishia.sullivan@morganlewis.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "6eab20d7-8716-4b0a-8710-144d1d951c23",
    "firmName": "Morgan, Lewis & Bockius LLP (dubai Branch)",
    "registrationNumber": "L-05474",
    "licenseIssueDate": "09/14/2022 00:00:00",
    "licenseExpiryDate": "09/13/2026 00:00:00"
  },
  {
    "id": "ad9d97a9-13c7-4bf3-ad6c-1a7963f7424e",
    "slug": "alison-claire-hubbard",
    "name": "Alison Claire Hubbard",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/30/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alison Claire Hubbard",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ad9d97a9-13c7-4bf3-ad6c-1a7963f7424e",
        "address": "IH-00-01-CP-05 ,DIFC ,506832 ,",
        "phone": "/ 971506957753",
        "email": "admin@supportlegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "1607c199-ca4b-4bc1-89e9-98dad0300645",
    "firmName": "Support Legal ( DIFC) Limited",
    "registrationNumber": "L-04622",
    "licenseIssueDate": "09/30/2024 00:00:00",
    "licenseExpiryDate": "09/29/2026 00:00:00"
  },
  {
    "id": "8f6c4f43-dfdb-4f94-9a1f-c40375f4b5e3",
    "slug": "alison-eslick",
    "name": "Alison Eslick",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/09/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alison Eslick",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8f6c4f43-dfdb-4f94-9a1f-c40375f4b5e3",
        "address": "Index Tower ,506548 ,Dubai",
        "phone": "97147096300 / 971506767433",
        "email": "amateen@reedsmith.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b3f87e90-7ce9-4097-82c4-15232365f175",
    "firmName": "Reed Smith LLP",
    "registrationNumber": "L-00759",
    "licenseIssueDate": "12/09/2018 00:00:00",
    "licenseExpiryDate": "12/07/2025 00:00:00"
  },
  {
    "id": "444f2886-db76-48c7-bc7a-1843a71ed64f",
    "slug": "aliya-fatema-padhani",
    "name": "Aliya Fatema Padhani",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/31/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Aliya Fatema Padhani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_444f2886-db76-48c7-bc7a-1843a71ed64f",
        "address": "",
        "phone": "97143184600 / 971504468184",
        "email": "melaraby@gibsondunn.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c9d2c9d0-6e43-4253-a75d-cdeb400f8d8e",
    "firmName": "Gibson Dunn & Crutcher LLP",
    "registrationNumber": "L-06358",
    "licenseIssueDate": "05/31/2024 00:00:00",
    "licenseExpiryDate": "05/30/2026 00:00:00"
  },
  {
    "id": "e5a1f99d-695c-4654-bcc6-ccecde110936",
    "slug": "alshafie-ibrahim",
    "name": "Alshafie Ibrahim",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/21/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alshafie Ibrahim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e5a1f99d-695c-4654-bcc6-ccecde110936",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-02558",
    "licenseIssueDate": "08/21/2014 00:00:00",
    "licenseExpiryDate": "08/15/2026 00:00:00"
  },
  {
    "id": "c8d7689d-454f-417b-9c60-e1c1ec991883",
    "slug": "alshekh-salim-omar-mohammad-alashqar",
    "name": "Alshekh Salim Omar Mohammad Alashqar",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/25/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alshekh Salim Omar Mohammad Alashqar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c8d7689d-454f-417b-9c60-e1c1ec991883",
        "address": "Khawla Saeed Mohammed Salem ,414 ,DBCS BUILDING ,محكمة الاحوال الشخصية ,73879 ,Dubai",
        "phone": "97143530354 / 971503787848",
        "email": "info@ksadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e961ec37-b1f5-4b83-8382-639604c8fdaf",
    "firmName": "KHAWLA SAEED ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06911",
    "licenseIssueDate": "07/25/2025 00:00:00",
    "licenseExpiryDate": "07/24/2026 00:00:00"
  },
  {
    "id": "752757c1-721c-4279-8c38-d83a710f1153",
    "slug": "aly-hussein-abdelaal-hussein",
    "name": "Aly Hussein Abdelaal Hussein",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/26/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Aly Hussein Abdelaal Hussein",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_752757c1-721c-4279-8c38-d83a710f1153",
        "address": "4 ,ALHUDIBA AWARD COMPLEX BLOCK B ,UNION FLAG HOUSE ,50229 ,Dubai",
        "phone": "97143258888 / 971501009595",
        "email": "hr@binsowaidan.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "36d64a1b-4461-4159-9965-ed44c59d3e88",
    "firmName": "BIN SOWAIDAN ADVOCATES & LEGAL CONSULTANTCY",
    "registrationNumber": "L-01882",
    "licenseIssueDate": "09/26/2011 00:00:00",
    "licenseExpiryDate": "09/17/2026 00:00:00"
  },
  {
    "id": "a1b39bd9-ef13-4941-81ea-6faa92ad2ff1",
    "slug": "aly-nabil-anwar-mohamed-elemiry",
    "name": "Aly Nabil Anwar Mohamed Elemiry",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/01/2025",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Aly Nabil Anwar Mohamed Elemiry",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a1b39bd9-ef13-4941-81ea-6faa92ad2ff1",
        "address": "",
        "phone": "97122222222",
        "email": "info@ayalegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "843234aa-d59b-4763-b69a-ba92f9cbba70",
    "firmName": "ALI YOUSUF ALAWADHI ADVOCATES & LEGAL CONSULTANTS L.L.C",
    "registrationNumber": "L-06638",
    "licenseIssueDate": "01/22/2025 00:00:00",
    "licenseExpiryDate": "01/21/2026 00:00:00"
  },
  {
    "id": "52fa9758-a8bd-4e14-97b0-4c8aca21f8d7",
    "slug": "alya-faruq-mohammad-khair",
    "name": "Alya Faruq Mohammad Khair",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/27/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alya Faruq Mohammad Khair",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_52fa9758-a8bd-4e14-97b0-4c8aca21f8d7",
        "address": "",
        "phone": "97144020800 / 971566830829",
        "email": "dean.ryburn@dentons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dfe13b7e-6625-45fd-ad63-9ee83af41194",
    "firmName": "Dentons & Co Dubai Branch-DED",
    "registrationNumber": "L-04984",
    "licenseIssueDate": "06/27/2021 00:00:00",
    "licenseExpiryDate": "06/13/2026 00:00:00"
  },
  {
    "id": "3589ef63-5719-47d7-8780-ed2a1b395d2d",
    "slug": "alya-jaafar-abdulnabi-isa-alzeera",
    "name": "Alya Jaafar Abdulnabi Isa Alzeera",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/06/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alya Jaafar Abdulnabi Isa Alzeera",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3589ef63-5719-47d7-8780-ed2a1b395d2d",
        "address": "",
        "phone": "97143889955",
        "email": "m.alhanafi@nooflaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6a72f470-256a-46d0-bead-acf13b981406",
    "firmName": "NOOF ALABDULLA ADVOCATES & LEGAL CONSULTANTS L.L.C",
    "registrationNumber": "L-04204",
    "licenseIssueDate": "05/06/2025 00:00:00",
    "licenseExpiryDate": "05/05/2026 00:00:00"
  },
  {
    "id": "ecfd3ad7-73f7-466a-b5a2-7587f88189a0",
    "slug": "alyzeh-vana",
    "name": "Alyzeh Vana",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBVgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/04/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alyzeh Vana",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ecfd3ad7-73f7-466a-b5a2-7587f88189a0",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02484",
    "licenseIssueDate": "06/04/2014 00:00:00",
    "licenseExpiryDate": "05/29/2026 00:00:00"
  },
  {
    "id": "a1486170-b8e9-4713-8b4c-9994b1017c0d",
    "slug": "amal-mohammad-hasan-atieh",
    "name": "Amal Mohammad Hasan Atieh",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/15/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Amal Mohammad Hasan Atieh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a1486170-b8e9-4713-8b4c-9994b1017c0d",
        "address": "",
        "phone": "97104309100 / 971564013758",
        "email": "c.royle@taylorwessing.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d51b6f43-8c62-486f-a1ab-6ee3b87c8006",
    "firmName": "Taylor Wessing LLP (Dubai Branch)",
    "registrationNumber": "L-04162",
    "licenseIssueDate": "07/15/2018 00:00:00",
    "licenseExpiryDate": "07/13/2026 00:00:00"
  },
  {
    "id": "bb78b6db-8bfa-49ea-9e4d-69c0fdb21397",
    "slug": "amal-nadem-kaseb",
    "name": "Amal Nadem Kaseb",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/16/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Amal Nadem Kaseb",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bb78b6db-8bfa-49ea-9e4d-69c0fdb21397",
        "address": "BLOCK B - OFFICE NO. 208 ,BUSHAQER Building ,Makani No: 3289393656 ,000 ,Dubai",
        "phone": "97142217010 / 971504993366",
        "email": "majidlawyer726@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b380d172-f6fb-41f1-ad4f-0b8fa3c870fb",
    "firmName": "MAJID HAMAD AL KALBANI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06199",
    "licenseIssueDate": "02/16/2024 00:00:00",
    "licenseExpiryDate": "02/15/2026 00:00:00"
  },
  {
    "id": "85c0d80f-1284-4f28-9972-24d65446bc8a",
    "slug": "amani-cherry-mohsen-khalifa",
    "name": "Amani Cherry Mohsen Khalifa",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/20/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Amani Cherry Mohsen Khalifa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_85c0d80f-1284-4f28-9972-24d65446bc8a",
        "address": "0 ,ICD Brookfield Place Level 13 ,Trade Centre ,506569 ,Dubai",
        "phone": "97145099100 / 971501006965",
        "email": "menahr@freshfields.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "970f6246-e737-41a7-9c6c-5aa5b8335d45",
    "firmName": "Freshfields LLP DIFC",
    "registrationNumber": "L-04410",
    "licenseIssueDate": "05/20/2019 00:00:00",
    "licenseExpiryDate": "05/19/2026 00:00:00"
  },
  {
    "id": "2ef04c53-b35e-4201-acde-0cf224ee48c4",
    "slug": "amani-mohammed-mustafa-ejami",
    "name": "Amani Mohammed Mustafa Ejami",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/22/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Amani Mohammed Mustafa Ejami",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2ef04c53-b35e-4201-acde-0cf224ee48c4",
        "address": "",
        "phone": "97143333245 / 97143333245",
        "email": "y.albulooshi@yhadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5fd2b33a-4bae-47d7-86ce-bdbd42af4336",
    "firmName": "ALBALOOSHI AND ALMARASHIDA ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-04077",
    "licenseIssueDate": "04/22/2018 00:00:00",
    "licenseExpiryDate": "04/19/2026 00:00:00"
  },
  {
    "id": "1b538924-ead7-42ac-a8d8-0b976eb02cff",
    "slug": "amanjit-fagura",
    "name": "Amanjit Fagura",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/21/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Amanjit Fagura",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1b538924-ead7-42ac-a8d8-0b976eb02cff",
        "address": "Emirates Financial Tower, South Tower ,Dubai International Financial Center ,506675 ,",
        "phone": "97144256300 / 971558560783",
        "email": "rebecca.hird@dechert.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7b0531fd-1de7-4fe5-b6d8-7a5de645b631",
    "firmName": "Dechert LLP",
    "registrationNumber": "L-00519",
    "licenseIssueDate": "09/21/2014 00:00:00",
    "licenseExpiryDate": "09/15/2026 00:00:00"
  },
  {
    "id": "c8b1a6ce-eef7-4541-9cda-bb422735df42",
    "slug": "amany-essam-ahmed-maamoon",
    "name": "Amany Essam Ahmed Maamoon",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/07/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Amany Essam Ahmed Maamoon",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c8b1a6ce-eef7-4541-9cda-bb422735df42",
        "address": "الطابق 7 مكتب رقم 070A ,برج رولكس  ,محطة مترو المركز المالي  ,66300 ,Dubai",
        "phone": "97143444029",
        "email": "ekp.khalidaltmimi@ekplegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "400838f1-4e75-4836-9698-b9e19dd30a18",
    "firmName": "KHALID ABDALLA ALTAMIMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04544",
    "licenseIssueDate": "11/07/2019 00:00:00",
    "licenseExpiryDate": "11/06/2025 00:00:00"
  },
  {
    "id": "308e3dc7-ebac-4fed-8380-3be6c41cf70f",
    "slug": "amar-ahmed-amar",
    "name": "Amar Ahmed Amar",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/27/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Amar Ahmed Amar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_308e3dc7-ebac-4fed-8380-3be6c41cf70f",
        "address": "",
        "phone": "97143968700",
        "email": "admin@haklegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ee61dd8d-28a2-4c21-9a46-a87635463b13",
    "firmName": "HEND ALKTEBI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02007",
    "licenseIssueDate": "06/27/2012 00:00:00",
    "licenseExpiryDate": "06/19/2026 00:00:00"
  },
  {
    "id": "04e805dc-15e6-4883-b815-f041f149914d",
    "slug": "amar-mustafa-fahmy",
    "name": "Amar Mustafa Fahmy",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/24/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Amar Mustafa Fahmy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_04e805dc-15e6-4883-b815-f041f149914d",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-05466",
    "licenseIssueDate": "08/24/2022 00:00:00",
    "licenseExpiryDate": "08/23/2026 00:00:00"
  },
  {
    "id": "02516be9-e46e-4ba3-911d-62b7b15830ee",
    "slug": "ameen-kim",
    "name": "Ameen Kim",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/26/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ameen Kim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_02516be9-e46e-4ba3-911d-62b7b15830ee",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-06392",
    "licenseIssueDate": "06/26/2024 00:00:00",
    "licenseExpiryDate": "06/25/2026 00:00:00"
  },
  {
    "id": "6bee26a9-1832-4f9c-8ff5-92ee57766c22",
    "slug": "amelia-arabella-kathryn-bowring",
    "name": "Amelia Arabella Kathryn Bowring",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/12/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2025-11-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Amelia Arabella Kathryn Bowring",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6bee26a9-1832-4f9c-8ff5-92ee57766c22",
        "address": "",
        "phone": "97143506800 / 971507244940",
        "email": "Chris.Williams@bracewelllaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "106d3ee7-86f2-4eae-9b49-fd8423095983",
    "firmName": "Bracewell LLP",
    "registrationNumber": "L-04582",
    "licenseIssueDate": "12/12/2019 00:00:00",
    "licenseExpiryDate": "12/11/2025 00:00:00"
  },
  {
    "id": "3d480f39-3475-4ea1-957b-353f3328a89f",
    "slug": "amelia-lucy-mary-cave",
    "name": "Amelia Lucy Mary Cave",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/22/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Amelia Lucy Mary Cave",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3d480f39-3475-4ea1-957b-353f3328a89f",
        "address": "THE OFFICES 1 ,DWTC ,115580 ,",
        "phone": "97143739700 / 971501148248",
        "email": "nitesh.pradhan@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "361fdc64-6b6f-4f37-abca-c52af8473b84",
    "firmName": "Pinsent Masons  LLP (DWTCA Branch)",
    "registrationNumber": "L-04765",
    "licenseIssueDate": "10/22/2020 00:00:00",
    "licenseExpiryDate": "10/21/2026 00:00:00"
  },
  {
    "id": "ecff9af2-3208-469e-8331-819aac9754b1",
    "slug": "amer-khaled-osman",
    "name": "Amer Khaled Osman",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/22/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Amer Khaled Osman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ecff9af2-3208-469e-8331-819aac9754b1",
        "address": "",
        "phone": "97142211313",
        "email": "info@daralhuqooq.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a35adad8-13e3-467b-8652-912b433c3fa4",
    "firmName": "DAR AL HUQOOQ LEGAL CONSULTANTS",
    "registrationNumber": "L-06245",
    "licenseIssueDate": "03/22/2024 00:00:00",
    "licenseExpiryDate": "03/21/2026 00:00:00"
  },
  {
    "id": "60ccb451-bea2-4dcb-adb4-8b298654d30f",
    "slug": "amer-nabulsi",
    "name": "Amer Nabulsi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/03/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Amer Nabulsi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_60ccb451-bea2-4dcb-adb4-8b298654d30f",
        "address": "Unit 03-OF-02-03-OF-09, Level 03 ,Gate Village Building 08 ,Dubai International Financial Centre ,000 ,Dubai",
        "phone": "97100000000 / 971501051651",
        "email": "gabriel@uae.silklegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "790219ab-49b9-40f2-97c3-bff01feebf69",
    "firmName": "Silk Legal Company Limited",
    "registrationNumber": "L-03743",
    "licenseIssueDate": "03/03/2025 00:00:00",
    "licenseExpiryDate": "03/02/2026 00:00:00"
  },
  {
    "id": "df13ef89-45c7-40bd-bdd8-2f817d79c679",
    "slug": "amer-ragab-hassan",
    "name": "Amer Ragab Hassan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/11/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2022-11-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Amer Ragab Hassan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_df13ef89-45c7-40bd-bdd8-2f817d79c679",
        "address": "",
        "phone": "97143433300",
        "email": "info@theattorneys.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "931ca6f7-8621-4da0-9545-a993725337e0",
    "firmName": "THE ATTORNIES ADVOCATES & LEGAL CONSULTANT",
    "registrationNumber": "L-02025",
    "licenseIssueDate": "11/16/2011 00:00:00",
    "licenseExpiryDate": "11/07/2022 00:00:00"
  },
  {
    "id": "608cc9af-d255-4825-869d-f1f8a7936f23",
    "slug": "amer-sulaiman-abbas-yousuf",
    "name": "AMER SULAIMAN ABBAS YOUSUF",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/22/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-01-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: AMER SULAIMAN ABBAS YOUSUF",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_608cc9af-d255-4825-869d-f1f8a7936f23",
        "address": "مكتب رقم 403 – 504 - 102 ,القرن الواحد وعشرون ,مركز القبائل للتخفيضات ,68441 ,Dubai",
        "phone": "97142388763",
        "email": "shaikha.advo@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "80a47f20-166e-40d9-9dea-d793f4708270",
    "firmName": "SHAIKHA AHMAD ADVOCATES&LEGAL CONSULTANTS",
    "registrationNumber": "L-06651",
    "licenseIssueDate": "01/22/2025 00:00:00",
    "licenseExpiryDate": "01/21/2026 00:00:00"
  },
  {
    "id": "ee062da3-9982-40ed-9566-37963a6ad4c0",
    "slug": "amin-ameer",
    "name": "Amin Ameer",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/07/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Amin Ameer",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ee062da3-9982-40ed-9566-37963a6ad4c0",
        "address": "THE OFFICES 1 ,DWTC ,115580 ,",
        "phone": "97143739700 / 971501148248",
        "email": "nitesh.pradhan@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "361fdc64-6b6f-4f37-abca-c52af8473b84",
    "firmName": "Pinsent Masons  LLP (DWTCA Branch)",
    "registrationNumber": "L-04819",
    "licenseIssueDate": "01/07/2021 00:00:00",
    "licenseExpiryDate": "01/06/2026 00:00:00"
  },
  {
    "id": "45e3ce83-8859-4a4b-96d6-3acabd451353",
    "slug": "amin-haroun-abdelaziz-alshraiedeh",
    "name": "AMIN HAROUN ABDELAZIZ ALSHRAIEDEH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/09/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-09-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Amin Haroun Abdelaziz Alshraiedeh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_45e3ce83-8859-4a4b-96d6-3acabd451353",
        "address": "",
        "phone": "97143588887",
        "email": "e.lawyersd@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9aeb8716-ff23-4200-90de-c2e0ee86076e",
    "firmName": "MOHAMMED AHMED ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06503",
    "licenseIssueDate": "09/16/2024 00:00:00",
    "licenseExpiryDate": "09/15/2025 00:00:00"
  },
  {
    "id": "1b346f60-cf92-4b23-9bdd-a0f2f92b1511",
    "slug": "amina-jmiaa-ouannass",
    "name": "Amina Jmiaa Ouannass",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/31/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Amina Jmiaa Ouannass",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1b346f60-cf92-4b23-9bdd-a0f2f92b1511",
        "address": "Boulevard Plaza Tower 2 ,Burj Khalifa ,23297 ,",
        "phone": "97142950020 / 971526443550",
        "email": "nicola.lohrey@roedl.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e92477d1-b4b2-4506-b1a4-99c4a9cfa443",
    "firmName": "Roedl & Partner (Dubai Branch)",
    "registrationNumber": "L-06319",
    "licenseIssueDate": "05/31/2024 00:00:00",
    "licenseExpiryDate": "05/30/2026 00:00:00"
  },
  {
    "id": "1c236c65-d5e0-419a-a306-98b5f96fd567",
    "slug": "amir-ahmad",
    "name": "Amir Ahmad",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Amir Ahmad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1c236c65-d5e0-419a-a306-98b5f96fd567",
        "address": "Index Tower ,506548 ,Dubai",
        "phone": "97147096300 / 971506767433",
        "email": "amateen@reedsmith.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b3f87e90-7ce9-4097-82c4-15232365f175",
    "firmName": "Reed Smith LLP",
    "registrationNumber": "L-00897",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "3f9d0a26-b4b0-42d2-8847-77d0efd47dc5",
    "slug": "amir-kordvani",
    "name": "Amir Kordvani",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/10/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Amir Kordvani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3f9d0a26-b4b0-42d2-8847-77d0efd47dc5",
        "address": "1 ,Emaar Square 5 ,sheikh mohammed bin rashid BVD ,11987 ,Dubai",
        "phone": "97143043100 / 971507325154",
        "email": "amir.kordvani@pwc.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "ea026b18-c93c-4f67-a1f2-4546320f8f3e",
    "firmName": "PWC Legal Middle East LLP",
    "registrationNumber": "L-03495",
    "licenseIssueDate": "10/10/2016 00:00:00",
    "licenseExpiryDate": "10/06/2026 00:00:00"
  },
  {
    "id": "9f2f95bf-639c-4087-9ba9-da4f34d461ce",
    "slug": "amir-makee-mosa",
    "name": "AMIR MAKEE MOSA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/08/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: AMIR MAKEE MOSA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9f2f95bf-639c-4087-9ba9-da4f34d461ce",
        "address": "A7 ,Dubai Silicon Oasis ,29337 ,",
        "phone": "97144313060 / 971528448686",
        "email": "andres.ring@schlueter-graf.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2ce110f0-b433-4dbc-b15f-ab1a3b291c28",
    "firmName": "Schluter Graf Legal Consultants LLC",
    "registrationNumber": "L-06286",
    "licenseIssueDate": "05/08/2024 00:00:00",
    "licenseExpiryDate": "05/07/2026 00:00:00"
  },
  {
    "id": "d8a2c633-1b80-4c58-835a-f2d05be89e88",
    "slug": "amir-mehdizadeh-iranpour",
    "name": "Amir Mehdizadeh Iranpour",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/19/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Amir Mehdizadeh Iranpour",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d8a2c633-1b80-4c58-835a-f2d05be89e88",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-05899",
    "licenseIssueDate": "07/19/2023 00:00:00",
    "licenseExpiryDate": "07/18/2026 00:00:00"
  },
  {
    "id": "a5124df4-d6aa-42d7-98f4-f3d252f94b84",
    "slug": "amir-omar-hamid-ibrahim",
    "name": "Amir Omar Hamid Ibrahim",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/05/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Amir Omar Hamid Ibrahim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a5124df4-d6aa-42d7-98f4-f3d252f94b84",
        "address": "Ahmed alraeesi  ,1303 ,Salmiya Tower ,Salmiya Tower ,00 ,Dubai",
        "phone": "97142222330 / 971502727580",
        "email": "admin@alraeesilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "31ff4d2d-2472-462b-b78c-c6b4f099b603",
    "firmName": "AHMED AL RAEESI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04889",
    "licenseIssueDate": "04/05/2021 00:00:00",
    "licenseExpiryDate": "04/04/2026 00:00:00"
  },
  {
    "id": "1f0a522b-1f86-4304-a302-3d29a4c710a8",
    "slug": "amir-saeed-mahdavi",
    "name": "Amir Saeed Mahdavi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/05/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Amir Saeed Mahdavi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1f0a522b-1f86-4304-a302-3d29a4c710a8",
        "address": "Index Tower ,DIFC ,506896 ,",
        "phone": "97142782300 / 971551154791",
        "email": "GLeggate@wfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e2b82cfc-80a5-4957-ae41-b1a7beb693c1",
    "firmName": "Watson, Farley & Williams (Middle East) LLP",
    "registrationNumber": "L-04995",
    "licenseIssueDate": "07/05/2021 00:00:00",
    "licenseExpiryDate": "07/04/2026 00:00:00"
  },
  {
    "id": "91a77f38-78f9-4f5d-91b5-4ebb3d0f9fdc",
    "slug": "amir-zafar-khan",
    "name": "Amir Zafar Khan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBWgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/30/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Amir Zafar Khan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_91a77f38-78f9-4f5d-91b5-4ebb3d0f9fdc",
        "address": "",
        "phone": "97143937700",
        "email": "info@galadarilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d863b662-c864-4193-8b3a-ff6ee5fe6c64",
    "firmName": "GALADARI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06758",
    "licenseIssueDate": "04/30/2025 00:00:00",
    "licenseExpiryDate": "04/29/2026 00:00:00"
  },
  {
    "id": "ceb39b07-f95f-4947-b50c-870129f89028",
    "slug": "amira-seddik-mohamed-elkholany",
    "name": "Amira Seddik Mohamed Elkholany",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/08/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Amira Seddik Mohamed Elkholany",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ceb39b07-f95f-4947-b50c-870129f89028",
        "address": "",
        "phone": "97143742800 / 971506450677",
        "email": "jabbott21@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7a59d310-ff72-4318-b41c-27095c163d0f",
    "firmName": "CMS (UAE) LLP",
    "registrationNumber": "L-05906",
    "licenseIssueDate": "08/08/2023 00:00:00",
    "licenseExpiryDate": "08/07/2026 00:00:00"
  },
  {
    "id": "0407511e-995b-4eda-89f7-87b2e2833a52",
    "slug": "amjad-tawil",
    "name": "Amjad Tawil",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Amjad Tawil",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0407511e-995b-4eda-89f7-87b2e2833a52",
        "address": "مركز وافي للتسوق  ,بلوك ايه ,خلف فندق موفنبيك ,11672 ,Dubai",
        "phone": "97143796990",
        "email": "alzeyoudi@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e5af688d-2190-4a5e-bb51-52b925fc1fb7",
    "firmName": "AL ZEYOUDI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01220",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "f9abf563-3c21-43fe-a33b-0a8924d750a6",
    "slug": "ammar",
    "name": "Ammar",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/18/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ammar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f9abf563-3c21-43fe-a33b-0a8924d750a6",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-06928",
    "licenseIssueDate": "08/18/2025 00:00:00",
    "licenseExpiryDate": "08/17/2026 00:00:00"
  },
  {
    "id": "1410af04-78a9-400d-9ffa-1c1d7be181ef",
    "slug": "ammarah-asad-shamim",
    "name": "Ammarah Asad Shamim",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/05/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ammarah Asad Shamim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1410af04-78a9-400d-9ffa-1c1d7be181ef",
        "address": "Burj Daman ,Dubai International Financial Center ,213241 ,",
        "phone": "97144549586 / 971564189768",
        "email": "darrenaharris123@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3cb06a05-1ad1-4487-9624-c2b716bfd2a7",
    "firmName": "Gateley UK LLP",
    "registrationNumber": "L-05897",
    "licenseIssueDate": "07/05/2023 00:00:00",
    "licenseExpiryDate": "07/04/2026 00:00:00"
  },
  {
    "id": "3f7233c4-7019-4019-a6c2-afa549301a19",
    "slug": "ammer-jamoukha",
    "name": "Ammer Jamoukha",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/08/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ammer Jamoukha",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3f7233c4-7019-4019-a6c2-afa549301a19",
        "address": "",
        "phone": "97144323671 / 971505589395",
        "email": "fba@amereller.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a139ca64-8897-4d1d-8d71-97446bc1e15a",
    "firmName": "Amereller Legal Consultancy LLC SOC",
    "registrationNumber": "L-00483",
    "licenseIssueDate": "10/08/2011 00:00:00",
    "licenseExpiryDate": "09/29/2026 00:00:00"
  },
  {
    "id": "4ef1b871-230e-47fe-9952-ecb3744d52d1",
    "slug": "ammina-fayyaz-khan",
    "name": "Ammina Fayyaz Khan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/14/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ammina Fayyaz Khan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4ef1b871-230e-47fe-9952-ecb3744d52d1",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-06631",
    "licenseIssueDate": "02/14/2025 00:00:00",
    "licenseExpiryDate": "02/13/2026 00:00:00"
  },
  {
    "id": "2d6785d2-749a-4185-8107-151626cdbcb3",
    "slug": "amna-abdalla-idris-abozomam",
    "name": "Amna Abdalla Idris Abozomam",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/28/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Amna Abdalla Idris Abozomam",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2d6785d2-749a-4185-8107-151626cdbcb3",
        "address": "4th floor ,Al Saaha Offices Block D office 401A ,Burj Khalifa ,283773 ,Dubai",
        "phone": "97144221944",
        "email": "gov.depts@alsafarpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b7bbfaeb-1fdb-46d2-97cf-8e6432a9b8a7",
    "firmName": "AL SAFAR & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06473",
    "licenseIssueDate": "08/28/2024 00:00:00",
    "licenseExpiryDate": "08/27/2026 00:00:00"
  },
  {
    "id": "f0dd96f2-2170-4770-9989-e0f560141b7a",
    "slug": "amr-ahmed-abdelmoaty-abdelgawad",
    "name": "Amr Ahmed Abdelmoaty Abdelgawad",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/22/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Amr Ahmed Abdelmoaty Abdelgawad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f0dd96f2-2170-4770-9989-e0f560141b7a",
        "address": "",
        "phone": "97143573330",
        "email": "admin@dhahiadvocate.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5b668acf-1fdb-4057-81f9-05d9aeb7aca9",
    "firmName": "AHMED BIN DHAHI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06659",
    "licenseIssueDate": "01/22/2025 00:00:00",
    "licenseExpiryDate": "01/21/2026 00:00:00"
  },
  {
    "id": "7150ab30-1086-47f3-85d7-7420286d0f98",
    "slug": "amr-ibrahim-sayed-ahmed-zarad",
    "name": "Amr Ibrahim Sayed Ahmed Zarad",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/06/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Amr Ibrahim Sayed Ahmed Zarad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7150ab30-1086-47f3-85d7-7420286d0f98",
        "address": "HUSSA ALI ALQUBAISI ,FLOOR 31 OFFICE 3103 ,BURLINGTON TOWER ,DUBAI ISLAMIC BANK ,15002 ,Dubai",
        "phone": "97142427805",
        "email": "info@haqlegalconsultants.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "1d48c777-9533-4c84-8e5b-5abde5f50dab",
    "firmName": "HUSSA ALI ALQUBAISI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04393",
    "licenseIssueDate": "05/06/2019 00:00:00",
    "licenseExpiryDate": "05/05/2026 00:00:00"
  },
  {
    "id": "28e301dc-d90d-4800-a894-857fdd0b58e3",
    "slug": "amr-mahmoud-ali-mahmoud",
    "name": "Amr mahmoud ali mahmoud",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/28/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Amr mahmoud ali mahmoud",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_28e301dc-d90d-4800-a894-857fdd0b58e3",
        "address": "OBAID AL SHAMSI ADVOCATES & LEGAL CONSULTANTS ,لا يوجد ,AL GARHOUD BUSINESS CENTER ,AL GARHOUD BUSINESS CENTER ,1903 ,Dubai",
        "phone": "97129555545",
        "email": "info@oaslawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c8252dab-1a42-4878-a3ee-50ba9dddb978",
    "firmName": "OBAID AL SHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05531",
    "licenseIssueDate": "09/28/2022 00:00:00",
    "licenseExpiryDate": "09/27/2026 00:00:00"
  },
  {
    "id": "27a8aaee-6cee-4d43-9180-a11b1e7e966b",
    "slug": "amr-mohamed-abdelsayed-sayed-ahmed-elnaggar",
    "name": "amr mohamed abdelsayed sayed ahmed elnaggar",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/07/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: amr mohamed abdelsayed sayed ahmed elnaggar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_27a8aaee-6cee-4d43-9180-a11b1e7e966b",
        "address": "abdulla al mansoori ,الطابق السابع  ,الغزال ستاندرد  ,مول الغزال ,393164 ,Dubai",
        "phone": "97145531403 / 971569305848",
        "email": "info@abmadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4f9219c1-5db2-45f9-bc5b-838c784a6216",
    "firmName": "ABDULLA AL MANSOORI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06801",
    "licenseIssueDate": "05/07/2025 00:00:00",
    "licenseExpiryDate": "05/06/2026 00:00:00"
  },
  {
    "id": "971f42e8-ce0f-4a7f-87f3-44d0c0a52e3d",
    "slug": "amr-mohamed-elamrousy",
    "name": "Amr Mohamed Elamrousy",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/23/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Amr Mohamed Elamrousy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_971f42e8-ce0f-4a7f-87f3-44d0c0a52e3d",
        "address": "29 ,ذا اتش هوتيل ,فندق فيرمونت ,40073 ,Dubai",
        "phone": "97143254000",
        "email": "info@alrowaad.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "759f5477-fdbd-406b-8831-354639c31036",
    "firmName": "AWATIF MOHAMMAD SHOQI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-02789",
    "licenseIssueDate": "10/23/2014 00:00:00",
    "licenseExpiryDate": "10/17/2026 00:00:00"
  },
  {
    "id": "2bb906eb-4e6f-40ae-b354-c312588cc1fc",
    "slug": "amr-mosaad-sherif",
    "name": "Amr Mosaad Sherif",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Amr Mosaad Sherif",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2bb906eb-4e6f-40ae-b354-c312588cc1fc",
        "address": "Hussain Ali Al Jaziri ,11 ,City Tower 2 ,Crown Plaza hotel Sheikh Zayed Road ,4253 ,Dubai",
        "phone": "97142626777 / 971529087670",
        "email": "courts@jaflaws.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c58d8654-b428-46b3-abd5-024e4331ee53",
    "firmName": "JAAFAR ALWAN & AL JAZIRI & ASSOCIATES",
    "registrationNumber": "L-01610",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "d82accc5-03ca-4657-8a49-12f0812b1e81",
    "slug": "amr-moustafa-saed-abdelhamid-mohamed-ibrahim",
    "name": "Amr Moustafa Saed Abdelhamid Mohamed Ibrahim",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/02/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Amr Moustafa Saed Abdelhamid Mohamed Ibrahim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d82accc5-03ca-4657-8a49-12f0812b1e81",
        "address": "",
        "phone": "97144230000 / 971552009022",
        "email": "UAE-CourtClerks@habibalmulla.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3eba82bb-8ec4-4cbd-80d0-a793cb993fde",
    "firmName": "Habib Al Mulla & Partners ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06317",
    "licenseIssueDate": "05/02/2024 00:00:00",
    "licenseExpiryDate": "05/01/2026 00:00:00"
  },
  {
    "id": "887304cf-885c-432a-bb1f-9b238528dc76",
    "slug": "amr-omran",
    "name": "Amr Omran",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/09/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Amr Omran",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_887304cf-885c-432a-bb1f-9b238528dc76",
        "address": "0 ,ICD Brookfield Place Level 13 ,Trade Centre ,506569 ,Dubai",
        "phone": "97145099100 / 971501006965",
        "email": "menahr@freshfields.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "970f6246-e737-41a7-9c6c-5aa5b8335d45",
    "firmName": "Freshfields LLP DIFC",
    "registrationNumber": "L-03147",
    "licenseIssueDate": "09/09/2015 00:00:00",
    "licenseExpiryDate": "09/04/2026 00:00:00"
  },
  {
    "id": "fb61504f-ebd8-4200-8cb9-78d29ecb3f5e",
    "slug": "amre-abdulkader-bajamal",
    "name": "Amre Abdulkader Bajamal",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Amre Abdulkader Bajamal",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fb61504f-ebd8-4200-8cb9-78d29ecb3f5e",
        "address": "amal albastaki ,1903 ,court ,business bay ,127477 ,Dubai",
        "phone": "97142522202",
        "email": "info@amaladvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "f852bccd-2696-4190-9b40-77a8fb9c460f",
    "firmName": "AMAL ALBASTAKI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-02305",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "79b3dca0-5aa0-4bfa-ae39-3768a3efd72e",
    "slug": "amrik-sangha",
    "name": "Amrik Sangha",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/08/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Amrik Sangha",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_79b3dca0-5aa0-4bfa-ae39-3768a3efd72e",
        "address": "Burj Daman ,Dubai International Financial Center ,213241 ,",
        "phone": "97144549586 / 971564189768",
        "email": "darrenaharris123@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3cb06a05-1ad1-4487-9624-c2b716bfd2a7",
    "firmName": "Gateley UK LLP",
    "registrationNumber": "L-00866",
    "licenseIssueDate": "02/08/2012 00:00:00",
    "licenseExpiryDate": "01/30/2026 00:00:00"
  },
  {
    "id": "f84e48d2-b892-4d85-a8ec-a1dc0a873371",
    "slug": "amro-al-ahmar",
    "name": "Amro Al-Ahmar",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/26/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Amro Al-Ahmar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f84e48d2-b892-4d85-a8ec-a1dc0a873371",
        "address": "",
        "phone": "97144286300 / 971506256686",
        "email": "stuart.paterson@hsf.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2f0389b3-bfde-44f4-bdd6-6e1a22f9cab2",
    "firmName": "Herbert Smith Freehills Kramer LLP",
    "registrationNumber": "L-04916",
    "licenseIssueDate": "04/26/2021 00:00:00",
    "licenseExpiryDate": "04/25/2026 00:00:00"
  },
  {
    "id": "151f59bb-e382-4466-a517-0e6d38cc44b5",
    "slug": "amro-mohamed-abashar-hassan",
    "name": "Amro Mohamed Abashar Hassan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/08/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Amro Mohamed Abashar Hassan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_151f59bb-e382-4466-a517-0e6d38cc44b5",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03802",
    "licenseIssueDate": "08/08/2017 00:00:00",
    "licenseExpiryDate": "08/05/2026 00:00:00"
  },
  {
    "id": "4aafdfe4-41ac-4340-b864-efd686364119",
    "slug": "amun-bashir",
    "name": "Amun Bashir",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/13/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Amun Bashir",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4aafdfe4-41ac-4340-b864-efd686364119",
        "address": "Burj Daman ,Dubai International Financial Center ,213241 ,",
        "phone": "97144549586 / 971564189768",
        "email": "darrenaharris123@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3cb06a05-1ad1-4487-9624-c2b716bfd2a7",
    "firmName": "Gateley UK LLP",
    "registrationNumber": "L-03036",
    "licenseIssueDate": "05/13/2015 00:00:00",
    "licenseExpiryDate": "05/12/2026 00:00:00"
  },
  {
    "id": "c3c77eaf-6ed6-412b-af86-fcec3c714702",
    "slug": "amy-drew-roberts",
    "name": "Amy Drew Roberts",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/06/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Amy Drew Roberts",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c3c77eaf-6ed6-412b-af86-fcec3c714702",
        "address": "THE OFFICES 1 ,DWTC ,115580 ,",
        "phone": "97143739700 / 971501148248",
        "email": "nitesh.pradhan@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "361fdc64-6b6f-4f37-abca-c52af8473b84",
    "firmName": "Pinsent Masons  LLP (DWTCA Branch)",
    "registrationNumber": "L-06114",
    "licenseIssueDate": "12/06/2023 00:00:00",
    "licenseExpiryDate": "12/05/2025 00:00:00"
  },
  {
    "id": "fb13c326-1d0d-4edc-9e3c-7f1c03cffd4e",
    "slug": "amy-elizabeth-jones",
    "name": "Amy Elizabeth Jones",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/03/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-03-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Amy Elizabeth Jones",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fb13c326-1d0d-4edc-9e3c-7f1c03cffd4e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-04050",
    "licenseIssueDate": "03/21/2018 00:00:00",
    "licenseExpiryDate": "03/19/2020 00:00:00"
  },
  {
    "id": "77a17ec6-0852-4eb0-bbf6-ce3a37bdef2c",
    "slug": "analia-wlazlo",
    "name": "Analia Wlazlo",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/09/2014",
    "licenseStatus": "active",
    "licenseExpiry": "2015-09-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Analia Wlazlo",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_77a17ec6-0852-4eb0-bbf6-ce3a37bdef2c",
        "address": "",
        "phone": "97143826100 / 971507380618",
        "email": "jmiocevic@curtis.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0867bcc5-10fa-4783-91ae-b8f63e02e81a",
    "firmName": "Curtis Mallet-Prevost, Colt & Mosle LLP",
    "registrationNumber": "L-00795",
    "licenseIssueDate": "09/17/2014 00:00:00",
    "licenseExpiryDate": "11/22/2025 00:00:00"
  },
  {
    "id": "a0233dea-4bed-4262-a466-26f33852c9af",
    "slug": "anand-singh",
    "name": "Anand Singh",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/14/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Anand Singh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a0233dea-4bed-4262-a466-26f33852c9af",
        "address": "",
        "phone": "97143641686 / 971506288801",
        "email": "b.kadir@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0ba96df8-e4cc-49c2-8ae4-a42878d95926",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS LLC",
    "registrationNumber": "L-02738",
    "licenseIssueDate": "10/14/2014 00:00:00",
    "licenseExpiryDate": "10/08/2026 00:00:00"
  },
  {
    "id": "d6b411f9-dee2-42a8-9f85-5db02ba714e7",
    "slug": "ananthu-suresh-suresh-krishnan-nair-krishnan-nair",
    "name": "Ananthu Suresh Suresh Krishnan Nair Krishnan Nair",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/16/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ananthu Suresh Suresh Krishnan Nair Krishnan Nair",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d6b411f9-dee2-42a8-9f85-5db02ba714e7",
        "address": "702-703 ,THE EXCHANGE TOWER ,NEAR IN BUSINESS BAY METRO STATION ,90009 ,Dubai",
        "phone": "97142327888",
        "email": "info@alowaislaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "83647634-f0b7-4ccb-b71c-6d00bfdb84de",
    "firmName": "ABDALLA ALOWAIS ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-06865",
    "licenseIssueDate": "06/16/2025 00:00:00",
    "licenseExpiryDate": "06/15/2026 00:00:00"
  },
  {
    "id": "913e87d2-f184-4818-bacc-73ae700bbad1",
    "slug": "ananya-pandit",
    "name": "Ananya Pandit",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/19/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ananya Pandit",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_913e87d2-f184-4818-bacc-73ae700bbad1",
        "address": "",
        "phone": "97143303900 / 971561753537",
        "email": "christopher@afridi-angell.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "30ce50dc-01a6-499d-8ace-3f807ddcb08d",
    "firmName": "Afridi & Angell-DED",
    "registrationNumber": "L-05915",
    "licenseIssueDate": "07/19/2023 00:00:00",
    "licenseExpiryDate": "07/18/2026 00:00:00"
  },
  {
    "id": "bb57f196-40b7-49ec-a35b-96bed233ff72",
    "slug": "anas-al-tarawneh",
    "name": "Anas Al-Tarawneh",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/17/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Anas Al-Tarawneh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bb57f196-40b7-49ec-a35b-96bed233ff72",
        "address": "",
        "phone": "97144230555 / 971504788443",
        "email": "yah@hfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c462c65e-185a-4e81-8425-a87e3a2b6842",
    "firmName": "Holman Fenwick Willan Middle East LLP",
    "registrationNumber": "L-00611",
    "licenseIssueDate": "11/17/2011 00:00:00",
    "licenseExpiryDate": "11/08/2025 00:00:00"
  },
  {
    "id": "afac54bb-2702-42c7-8483-26013fc42001",
    "slug": "anastasia-dergacheva",
    "name": "Anastasia Dergacheva",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/22/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Anastasia Dergacheva",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_afac54bb-2702-42c7-8483-26013fc42001",
        "address": "",
        "phone": "97143121800 / 971566017967",
        "email": "alishia.sullivan@morganlewis.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6eab20d7-8716-4b0a-8710-144d1d951c23",
    "firmName": "Morgan, Lewis & Bockius LLP (dubai Branch)",
    "registrationNumber": "L-05369",
    "licenseIssueDate": "06/22/2022 00:00:00",
    "licenseExpiryDate": "06/21/2026 00:00:00"
  },
  {
    "id": "f31c7fd8-76cc-442b-b0cf-74387410ec38",
    "slug": "anastasia-kastelskaya",
    "name": "Anastasia Kastelskaya",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/14/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Anastasia Kastelskaya",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f31c7fd8-76cc-442b-b0cf-74387410ec38",
        "address": "",
        "phone": "97145953601 / 971508728645",
        "email": "Steven.Bainbridge@gtlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b4146aa6-efd1-41d7-819d-49da46353b0b",
    "firmName": "Greenberg Traurig Limited",
    "registrationNumber": "L-05488",
    "licenseIssueDate": "09/14/2022 00:00:00",
    "licenseExpiryDate": "09/13/2026 00:00:00"
  },
  {
    "id": "786407ee-2f74-43e5-ab12-6ca3efa181bf",
    "slug": "andras-balazs-klupacs",
    "name": "Andras Balazs Klupacs",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/11/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Andras Balazs Klupacs",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_786407ee-2f74-43e5-ab12-6ca3efa181bf",
        "address": "",
        "phone": "97143742800 / 971506450677",
        "email": "jabbott21@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7a59d310-ff72-4318-b41c-27095c163d0f",
    "firmName": "CMS (UAE) LLP",
    "registrationNumber": "L-06491",
    "licenseIssueDate": "09/11/2024 00:00:00",
    "licenseExpiryDate": "09/10/2026 00:00:00"
  },
  {
    "id": "454e3515-2c30-4edf-a3bc-a1086cef61db",
    "slug": "andre-linus-anthony",
    "name": "Andre Linus Anthony",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/22/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Andre Linus Anthony",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_454e3515-2c30-4edf-a3bc-a1086cef61db",
        "address": "",
        "phone": "97143742800 / 971506450677",
        "email": "jabbott21@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7a59d310-ff72-4318-b41c-27095c163d0f",
    "firmName": "CMS (UAE) LLP",
    "registrationNumber": "L-06658",
    "licenseIssueDate": "01/22/2025 00:00:00",
    "licenseExpiryDate": "01/21/2026 00:00:00"
  },
  {
    "id": "21ce31d4-715b-4eb4-b628-8e9775e5ecdc",
    "slug": "andrea-kidman",
    "name": "Andrea Kidman",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/08/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-07-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Andrea Kidman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_21ce31d4-715b-4eb4-b628-8e9775e5ecdc",
        "address": "Emirates Financial Towers (South) ,DIFC ,506546 ,",
        "phone": "97147096700 / 971505573843",
        "email": "dk@kbh.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "291a9c0d-030a-4cef-8739-c6946f741117",
    "firmName": "KBH Limited",
    "registrationNumber": "L-06629",
    "licenseIssueDate": "01/08/2025 00:00:00",
    "licenseExpiryDate": "01/07/2026 00:00:00"
  },
  {
    "id": "cd4554f4-5315-43ab-b159-988e340b01cb",
    "slug": "andrea-krage",
    "name": "Andrea Krage",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/05/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Andrea Krage",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cd4554f4-5315-43ab-b159-988e340b01cb",
        "address": "4th floor ,Al Saaha Offices Block D office 401A ,Burj Khalifa ,283773 ,Dubai",
        "phone": "97144221944",
        "email": "gov.depts@alsafarpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b7bbfaeb-1fdb-46d2-97cf-8e6432a9b8a7",
    "firmName": "AL SAFAR & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06374",
    "licenseIssueDate": "06/05/2024 00:00:00",
    "licenseExpiryDate": "06/04/2026 00:00:00"
  },
  {
    "id": "53ebdb14-7480-42ee-9e50-3fb37da31fa8",
    "slug": "andrea-margaret-pandazopoulos",
    "name": "Andrea Margaret Pandazopoulos",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/19/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-02-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Andrea Margaret Pandazopoulos",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_53ebdb14-7480-42ee-9e50-3fb37da31fa8",
        "address": "0 ,ICD Brookfield Place Level 13 ,Trade Centre ,506569 ,Dubai",
        "phone": "97145099100 / 971501006965",
        "email": "menahr@freshfields.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "970f6246-e737-41a7-9c6c-5aa5b8335d45",
    "firmName": "Freshfields LLP DIFC",
    "registrationNumber": "L-06699",
    "licenseIssueDate": "02/19/2025 00:00:00",
    "licenseExpiryDate": "02/18/2026 00:00:00"
  },
  {
    "id": "d90b7165-adaf-4a40-9c80-5cc03832ac4e",
    "slug": "andrei-cherkasov",
    "name": "Andrei Cherkasov",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/09/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Andrei Cherkasov",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d90b7165-adaf-4a40-9c80-5cc03832ac4e",
        "address": "",
        "phone": "97143098000 / 971552210883",
        "email": "belturk@rouse.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9df4d4e5-5243-4fae-8d95-463d110ce6a8",
    "firmName": "Rouse & Co International Limited (Dubai Branch)",
    "registrationNumber": "L-05716",
    "licenseIssueDate": "02/09/2023 00:00:00",
    "licenseExpiryDate": "02/08/2026 00:00:00"
  },
  {
    "id": "33326e4f-e3bd-4688-9310-a8bbd50f77f0",
    "slug": "andrej-kormuth",
    "name": "Andrej Kormuth",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/19/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Andrej Kormuth",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_33326e4f-e3bd-4688-9310-a8bbd50f77f0",
        "address": "",
        "phone": "97143506800 / 971507244940",
        "email": "Chris.Williams@bracewelllaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "106d3ee7-86f2-4eae-9b49-fd8423095983",
    "firmName": "Bracewell LLP",
    "registrationNumber": "L-00131",
    "licenseIssueDate": "01/19/2015 00:00:00",
    "licenseExpiryDate": "01/13/2026 00:00:00"
  },
  {
    "id": "b9b72eff-e590-487b-a279-d35895526ea6",
    "slug": "andrés-ring",
    "name": "Andrés Ring",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/22/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Andrés Ring",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b9b72eff-e590-487b-a279-d35895526ea6",
        "address": "A7 ,Dubai Silicon Oasis ,29337 ,",
        "phone": "97144313060 / 971528448686",
        "email": "andres.ring@schlueter-graf.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "2ce110f0-b433-4dbc-b15f-ab1a3b291c28",
    "firmName": "Schluter Graf Legal Consultants LLC",
    "registrationNumber": "L-00386",
    "licenseIssueDate": "11/22/2011 00:00:00",
    "licenseExpiryDate": "11/13/2025 00:00:00"
  },
  {
    "id": "6c57ecc3-006b-4581-876a-5b82dee93109",
    "slug": "andrew-bryce-scott",
    "name": "Andrew Bryce Scott",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/11/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Andrew Bryce Scott",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6c57ecc3-006b-4581-876a-5b82dee93109",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-06488",
    "licenseIssueDate": "09/11/2024 00:00:00",
    "licenseExpiryDate": "09/10/2026 00:00:00"
  },
  {
    "id": "6353d47d-eeb0-4b04-ac37-2a9daebe2b16",
    "slug": "andrew-david-archer",
    "name": "Andrew David Archer",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/01/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Andrew David Archer",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6353d47d-eeb0-4b04-ac37-2a9daebe2b16",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-05339",
    "licenseIssueDate": "06/01/2022 00:00:00",
    "licenseExpiryDate": "05/31/2026 00:00:00"
  },
  {
    "id": "7eea4238-eae0-4833-83af-93fe7bc10006",
    "slug": "andrew-el-khoury",
    "name": "Andrew El Khoury",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/13/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Andrew El Khoury",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7eea4238-eae0-4833-83af-93fe7bc10006",
        "address": "",
        "phone": "97144286300 / 971506256686",
        "email": "stuart.paterson@hsf.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2f0389b3-bfde-44f4-bdd6-6e1a22f9cab2",
    "firmName": "Herbert Smith Freehills Kramer LLP",
    "registrationNumber": "L-05136",
    "licenseIssueDate": "12/13/2021 00:00:00",
    "licenseExpiryDate": "12/12/2025 00:00:00"
  },
  {
    "id": "a08d459b-8db1-4c44-b5db-920808472c44",
    "slug": "andrew-james-stewart-morrison",
    "name": "Andrew James Stewart Morrison",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/22/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Andrew James Stewart Morrison",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a08d459b-8db1-4c44-b5db-920808472c44",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-06661",
    "licenseIssueDate": "01/22/2025 00:00:00",
    "licenseExpiryDate": "01/21/2026 00:00:00"
  },
  {
    "id": "55f21610-a3ec-4f3c-8da6-3966ac1bfec1",
    "slug": "andrew-lyons",
    "name": "Andrew Lyons",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Andrew Lyons",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_55f21610-a3ec-4f3c-8da6-3966ac1bfec1",
        "address": "",
        "phone": "97143438897 / 971507753952",
        "email": "jdavidson@davidson-legal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d0200f27-9504-4653-a5c6-05e4bcab7ff0",
    "firmName": "Davidson & Co Legal Consultants",
    "registrationNumber": "L-00933",
    "licenseIssueDate": "01/29/2012 00:00:00",
    "licenseExpiryDate": "01/20/2026 00:00:00"
  },
  {
    "id": "e7c04414-49ee-4c27-944c-7dabaf2fa69c",
    "slug": "andrew-mackenzie",
    "name": "Andrew Mackenzie",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/07/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Andrew Mackenzie",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e7c04414-49ee-4c27-944c-7dabaf2fa69c",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-00534",
    "licenseIssueDate": "10/07/2011 00:00:00",
    "licenseExpiryDate": "09/28/2026 00:00:00"
  },
  {
    "id": "92ab16ad-814a-423e-b19b-1426c5dc1908",
    "slug": "andrew-massey",
    "name": "Andrew Massey",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/09/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Andrew Massey",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_92ab16ad-814a-423e-b19b-1426c5dc1908",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-02149",
    "licenseIssueDate": "06/09/2022 00:00:00",
    "licenseExpiryDate": "06/08/2026 00:00:00"
  },
  {
    "id": "c13511c6-88e2-4c00-bb69-bddd06311886",
    "slug": "andrew-mcfadden",
    "name": "Andrew McFadden",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/02/2024",
    "licenseStatus": "active",
    "licenseExpiry": "2025-02-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Andrew McFadden",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c13511c6-88e2-4c00-bb69-bddd06311886",
        "address": "Building 5 ,Dubai World Trade Centre ,212620 ,",
        "phone": "97143503600 / 971563631562",
        "email": "p.ellingham@kennedys-law.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "83d3ede1-3a28-4b03-8c92-6bd31a1cb95e",
    "firmName": "Kennedys Dubai LLP",
    "registrationNumber": "L-06210",
    "licenseIssueDate": "02/21/2024 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "d23e6888-25eb-4230-b726-7cb680bffc4c",
    "slug": "andrew-peter-ross-tweedie",
    "name": "Andrew Peter Ross Tweedie",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/18/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Andrew Peter Ross Tweedie",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d23e6888-25eb-4230-b726-7cb680bffc4c",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-06053",
    "licenseIssueDate": "10/18/2023 00:00:00",
    "licenseExpiryDate": "10/17/2025 00:00:00"
  },
  {
    "id": "832d6d0b-e746-4162-a943-612afab64341",
    "slug": "andrew-robert-gallagher",
    "name": "Andrew Robert Gallagher",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/13/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Andrew Robert Gallagher",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_832d6d0b-e746-4162-a943-612afab64341",
        "address": "",
        "phone": "97144020800 / 971566830829",
        "email": "dean.ryburn@dentons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dfe13b7e-6625-45fd-ad63-9ee83af41194",
    "firmName": "Dentons & Co Dubai Branch-DED",
    "registrationNumber": "L-06996"
  },
  {
    "id": "dee863ea-cb45-494a-a82a-d9e8a7f9f8c3",
    "slug": "andrew-tarbuck",
    "name": "Andrew Tarbuck",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Andrew Tarbuck",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dee863ea-cb45-494a-a82a-d9e8a7f9f8c3",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-00870",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "c59f1044-9256-48ea-9fb5-1679cde9362a",
    "slug": "andrew-thomas-heller",
    "name": "Andrew Thomas Heller",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/12/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-11-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Andrew Thomas Heller",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c59f1044-9256-48ea-9fb5-1679cde9362a",
        "address": "ICD Brookfield Place ,DIFC ,120109 ,",
        "phone": "97143173000 / 971504465229",
        "email": "DubaiLAD@akingump.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9ff29eab-adb8-40f9-ab84-216e01a381e4",
    "firmName": "Akin Gump Strauss Hauer & Feld LLP",
    "registrationNumber": "L-04604",
    "licenseIssueDate": "01/12/2020 00:00:00",
    "licenseExpiryDate": "01/11/2026 00:00:00"
  },
  {
    "id": "4cd9ee74-9fc8-4415-a5df-8804a0fd1b64",
    "slug": "andrew-thomson",
    "name": "Andrew Thomson",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/11/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Andrew Thomson",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4cd9ee74-9fc8-4415-a5df-8804a0fd1b64",
        "address": "",
        "phone": "97143641686 / 971506288801",
        "email": "b.kadir@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0ba96df8-e4cc-49c2-8ae4-a42878d95926",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS LLC",
    "registrationNumber": "L-00265",
    "licenseIssueDate": "10/11/2011 00:00:00",
    "licenseExpiryDate": "10/02/2026 00:00:00"
  },
  {
    "id": "76b98e48-c6e1-43c2-a5b2-930090210419",
    "slug": "andrew-van-zyl-thomas-gow",
    "name": "Andrew Van Zyl Thomas Gow",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBVgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/05/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-02-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Andrew Van Zyl Thomas Gow",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_76b98e48-c6e1-43c2-a5b2-930090210419",
        "address": "0 ,ICD Brookfield Place Level 13 ,Trade Centre ,506569 ,Dubai",
        "phone": "97145099100 / 971501006965",
        "email": "menahr@freshfields.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "970f6246-e737-41a7-9c6c-5aa5b8335d45",
    "firmName": "Freshfields LLP DIFC",
    "registrationNumber": "L-03985",
    "licenseIssueDate": "02/05/2018 00:00:00",
    "licenseExpiryDate": "02/02/2026 00:00:00"
  },
  {
    "id": "f7eced4b-5efc-42e3-aefd-157fe2baaaa4",
    "slug": "andrew-workman",
    "name": "Andrew Workman",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/11/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-11-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Andrew Workman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f7eced4b-5efc-42e3-aefd-157fe2baaaa4",
        "address": "HAMDAN ALSHAMSI ,الطابق الرابع مكتب 401, 406,407 ,بي سكوير 01 ,مجمع دبي سكوير ,116564 ,Dubai",
        "phone": "97143469262",
        "email": "courts@has.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de2c61a6-9d00-457e-ad1d-e73e4e62d9bd",
    "firmName": "HAMDAN ALSHAMSI LAWYER & LEGAL CONSULTANTS",
    "registrationNumber": "L-03305",
    "licenseIssueDate": "11/16/2015 00:00:00",
    "licenseExpiryDate": "11/11/2020 00:00:00"
  },
  {
    "id": "bf2eb8e6-89e2-49c9-8473-3e4a5aa8d935",
    "slug": "andrey-ignatenko",
    "name": "Andrey Ignatenko",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/21/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Andrey Ignatenko",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bf2eb8e6-89e2-49c9-8473-3e4a5aa8d935",
        "address": "",
        "phone": "97143121800 / 971566017967",
        "email": "alishia.sullivan@morganlewis.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6eab20d7-8716-4b0a-8710-144d1d951c23",
    "firmName": "Morgan, Lewis & Bockius LLP (dubai Branch)",
    "registrationNumber": "L-05514",
    "licenseIssueDate": "09/21/2022 00:00:00",
    "licenseExpiryDate": "09/20/2026 00:00:00"
  },
  {
    "id": "a4b027cb-49ed-4ec6-93a4-fb00ed7c98cb",
    "slug": "andrey-kulikov",
    "name": "Andrey Kulikov",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/12/2022",
    "licenseStatus": "active",
    "licenseExpiry": "2023-12-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Andrey Kulikov",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a4b027cb-49ed-4ec6-93a4-fb00ed7c98cb",
        "address": "ICD Brookfield Place ,DIFC ,120109 ,",
        "phone": "97143173000 / 971504465229",
        "email": "DubaiLAD@akingump.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9ff29eab-adb8-40f9-ab84-216e01a381e4",
    "firmName": "Akin Gump Strauss Hauer & Feld LLP",
    "registrationNumber": "L-05629",
    "licenseIssueDate": "12/07/2022 00:00:00",
    "licenseExpiryDate": "12/06/2025 00:00:00"
  },
  {
    "id": "33eb8a57-f70e-4158-8525-d8dcc640f6a8",
    "slug": "andrzej-czernis",
    "name": "Andrzej Czernis",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/22/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Andrzej Czernis",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_33eb8a57-f70e-4158-8525-d8dcc640f6a8",
        "address": "",
        "phone": "97144230555 / 971504788443",
        "email": "yah@hfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c462c65e-185a-4e81-8425-a87e3a2b6842",
    "firmName": "Holman Fenwick Willan Middle East LLP",
    "registrationNumber": "L-04874",
    "licenseIssueDate": "03/22/2021 00:00:00",
    "licenseExpiryDate": "03/21/2026 00:00:00"
  },
  {
    "id": "3f4f1317-f49b-4802-8d43-c1001622755b",
    "slug": "aneesha-jagatia",
    "name": "Aneesha Jagatia",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/03/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Aneesha Jagatia",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3f4f1317-f49b-4802-8d43-c1001622755b",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-06939",
    "licenseIssueDate": "08/21/2025 00:00:00",
    "licenseExpiryDate": "08/20/2026 00:00:00"
  },
  {
    "id": "3b669dc7-66e2-45c1-87d5-329a2b9f855d",
    "slug": "angad-chaturvedi",
    "name": "Angad Chaturvedi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/13/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Angad Chaturvedi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3b669dc7-66e2-45c1-87d5-329a2b9f855d",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-03819",
    "licenseIssueDate": "08/13/2017 00:00:00",
    "licenseExpiryDate": "08/10/2026 00:00:00"
  },
  {
    "id": "8cedcdab-ce52-4182-9ac2-1740778c6457",
    "slug": "angela-bhaseen",
    "name": "Angela Bhaseen",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/11/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Angela Bhaseen",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8cedcdab-ce52-4182-9ac2-1740778c6457",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-06849",
    "licenseIssueDate": "06/11/2025 00:00:00",
    "licenseExpiryDate": "06/10/2026 00:00:00"
  },
  {
    "id": "f5703a02-900f-4ae0-a238-e5c62b58e192",
    "slug": "angela-croker",
    "name": "Angela Croker",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/23/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Angela Croker",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f5703a02-900f-4ae0-a238-e5c62b58e192",
        "address": "",
        "phone": "97145953601 / 971508728645",
        "email": "Steven.Bainbridge@gtlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b4146aa6-efd1-41d7-819d-49da46353b0b",
    "firmName": "Greenberg Traurig Limited",
    "registrationNumber": "L-03048",
    "licenseIssueDate": "04/23/2014 00:00:00",
    "licenseExpiryDate": "04/16/2026 00:00:00"
  },
  {
    "id": "9fe5340c-502d-4dab-ae7f-577c493dcd71",
    "slug": "angus-adair-weston-ryan",
    "name": "Angus Adair Weston Ryan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/05/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Angus Adair Weston Ryan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9fe5340c-502d-4dab-ae7f-577c493dcd71",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-05874",
    "licenseIssueDate": "07/05/2023 00:00:00",
    "licenseExpiryDate": "07/04/2026 00:00:00"
  },
  {
    "id": "fcbcc239-de80-40e7-9ba5-71b2c414fdcc",
    "slug": "anika-havaldar",
    "name": "Anika Havaldar",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/11/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Anika Havaldar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fcbcc239-de80-40e7-9ba5-71b2c414fdcc",
        "address": "0 ,ICD Brookfield Place Level 13 ,Trade Centre ,506569 ,Dubai",
        "phone": "97145099100 / 971501006965",
        "email": "menahr@freshfields.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "970f6246-e737-41a7-9c6c-5aa5b8335d45",
    "firmName": "Freshfields LLP DIFC",
    "registrationNumber": "L-06857",
    "licenseIssueDate": "06/11/2025 00:00:00",
    "licenseExpiryDate": "06/10/2026 00:00:00"
  },
  {
    "id": "fe6a8a40-e12d-4ac2-91ed-cdb1ec09a8f4",
    "slug": "anilkumar-pillai",
    "name": "Anilkumar Pillai",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/24/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Anilkumar Pillai",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fe6a8a40-e12d-4ac2-91ed-cdb1ec09a8f4",
        "address": "الرابع /412 ,مركز سلطان للأعمال  ,لامسى بلازا  ,97916 ,Dubai",
        "phone": "97144533568 / 971502744454",
        "email": "khalid.alzarooniadvocate@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "252ab43e-3522-46a6-b674-822fde821536",
    "firmName": "KHALID ALZAROONI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02678",
    "licenseIssueDate": "11/24/2014 00:00:00",
    "licenseExpiryDate": "11/18/2025 00:00:00"
  },
  {
    "id": "a143720f-cb35-4ff4-b185-d57c6ac040a1",
    "slug": "aniqah-aishah-bashir",
    "name": "Aniqah Aishah Bashir",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/21/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Aniqah Aishah Bashir",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a143720f-cb35-4ff4-b185-d57c6ac040a1",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-06089",
    "licenseIssueDate": "02/21/2024 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "7a697b8f-66ef-48f3-9d79-0ef4f11dff4d",
    "slug": "anita-hormis",
    "name": "Anita Hormis",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/13/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Anita Hormis",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7a697b8f-66ef-48f3-9d79-0ef4f11dff4d",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-00898",
    "licenseIssueDate": "03/13/2025 00:00:00",
    "licenseExpiryDate": "03/12/2026 00:00:00"
  },
  {
    "id": "a1a5dab5-5df7-459c-b69d-f8bf8d7cf8da",
    "slug": "anja-adam",
    "name": "Anja Adam",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/22/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Anja Adam",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a1a5dab5-5df7-459c-b69d-f8bf8d7cf8da",
        "address": "A7 ,Dubai Silicon Oasis ,29337 ,",
        "phone": "97144313060 / 971528448686",
        "email": "andres.ring@schlueter-graf.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2ce110f0-b433-4dbc-b15f-ab1a3b291c28",
    "firmName": "Schluter Graf Legal Consultants LLC",
    "registrationNumber": "L-00387",
    "licenseIssueDate": "11/22/2011 00:00:00",
    "licenseExpiryDate": "11/13/2025 00:00:00"
  },
  {
    "id": "ebdea801-4e9d-4d71-b3c5-a70d55af09d1",
    "slug": "ann-marie-matthias",
    "name": "Ann Marie Matthias",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/26/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ann Marie Matthias",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ebdea801-4e9d-4d71-b3c5-a70d55af09d1",
        "address": "0 ,ICD Brookfield Place Level 13 ,Trade Centre ,506569 ,Dubai",
        "phone": "97145099100 / 971501006965",
        "email": "menahr@freshfields.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "970f6246-e737-41a7-9c6c-5aa5b8335d45",
    "firmName": "Freshfields LLP DIFC",
    "registrationNumber": "L-05320",
    "licenseIssueDate": "04/26/2022 00:00:00",
    "licenseExpiryDate": "04/25/2026 00:00:00"
  },
  {
    "id": "a4364b64-cdeb-4f5a-804d-697be1172e0a",
    "slug": "anna-elisabeth-dellapa",
    "name": "Anna Elisabeth Dellapa",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/03/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Anna Elisabeth Dellapa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a4364b64-cdeb-4f5a-804d-697be1172e0a",
        "address": "",
        "phone": "97144478700 / 971528553200",
        "email": "Thomas.Wilson@squirepb.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "85be541a-c87f-45a9-a321-d90abd6b7298",
    "firmName": "Squire Patton Boggs (MEA) LLP",
    "registrationNumber": "L-05817",
    "licenseIssueDate": "05/03/2023 00:00:00",
    "licenseExpiryDate": "05/02/2026 00:00:00"
  },
  {
    "id": "1d1a1cf4-5d5a-4932-9006-2623336e6fd8",
    "slug": "anna-elizabeth-sara-george",
    "name": "Anna Elizabeth Sara George",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/03/2025",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Anna Elizabeth Sara George",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1d1a1cf4-5d5a-4932-9006-2623336e6fd8",
        "address": "Al Fattan Currency House Tower 2 ,DIFC ,507176 ,",
        "phone": "/ 971552009003",
        "email": "Mohammad.AlRasheed@bakermckenzie.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "acd81e81-dead-4f7c-839e-0f2a57897265",
    "firmName": "Baker & Mckenzie LLP",
    "registrationNumber": "L-06691",
    "licenseIssueDate": "03/26/2025 00:00:00",
    "licenseExpiryDate": "03/25/2026 00:00:00"
  },
  {
    "id": "9246f238-1510-4b7a-ab87-1e95b9121ade",
    "slug": "anna-helena-zeitlin",
    "name": "Anna Helena Zeitlin",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/22/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Anna Helena Zeitlin",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9246f238-1510-4b7a-ab87-1e95b9121ade",
        "address": "6 ,Office Nos. 603, 604 & 605, Level 6, Burj Daman ,Dubai International Financial Centre ,506555 ,Dubai",
        "phone": "97143506400 / 971504654755",
        "email": "r.hickman@aglaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8690f7d5-6b96-4649-9589-71303f2c2707",
    "firmName": "Addleshaw Goddard (Middle East) LLP",
    "registrationNumber": "L-06306",
    "licenseIssueDate": "05/22/2024 00:00:00",
    "licenseExpiryDate": "05/21/2026 00:00:00"
  },
  {
    "id": "6f0c0591-db85-429b-b3db-05263e7bbab5",
    "slug": "anna-jadwiga-szyndler",
    "name": "Anna Jadwiga Szyndler",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/18/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Anna Jadwiga Szyndler",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6f0c0591-db85-429b-b3db-05263e7bbab5",
        "address": "",
        "phone": "97144286300 / 971506256686",
        "email": "stuart.paterson@hsf.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2f0389b3-bfde-44f4-bdd6-6e1a22f9cab2",
    "firmName": "Herbert Smith Freehills Kramer LLP",
    "registrationNumber": "L-04237",
    "licenseIssueDate": "10/18/2018 00:00:00",
    "licenseExpiryDate": "10/16/2026 00:00:00"
  },
  {
    "id": "d926b5a6-9c29-4512-98f1-d93a26d2dd83",
    "slug": "anna-mkrtchyan",
    "name": "Anna Mkrtchyan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/29/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Anna Mkrtchyan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d926b5a6-9c29-4512-98f1-d93a26d2dd83",
        "address": "23 ,Rolex Tower ,Trade Center Second ,116637 ,Dubai",
        "phone": "97144357577 / 971502101003",
        "email": "jasamin.fichte@fichtelegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "77bf4fd2-1cd1-4bda-a0c2-ffcac3980b76",
    "firmName": "Fichte & Co Legal Consultancy",
    "registrationNumber": "L-04893",
    "licenseIssueDate": "03/29/2021 00:00:00",
    "licenseExpiryDate": "03/28/2026 00:00:00"
  },
  {
    "id": "ef2486cf-bb5f-4d14-8d9f-d9efdeb8831f",
    "slug": "anna-monika-van-den-ackerveken",
    "name": "Anna Monika Van Den Ackerveken",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/01/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Anna Monika Van Den Ackerveken",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ef2486cf-bb5f-4d14-8d9f-d9efdeb8831f",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506698 ,Dubai",
        "phone": "97147046300 / 971507900661",
        "email": "nada.mourad@lw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b2b92ce9-90a4-4e34-ae2f-ae0dc7ca9060",
    "firmName": "Latham & Watkins LLP",
    "registrationNumber": "L-05208",
    "licenseIssueDate": "03/01/2022 00:00:00",
    "licenseExpiryDate": "02/28/2026 00:00:00"
  },
  {
    "id": "eb897774-a243-43f1-af8d-da861fa6b70f",
    "slug": "anna-nersesyan",
    "name": "Anna Nersesyan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/20/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Anna Nersesyan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_eb897774-a243-43f1-af8d-da861fa6b70f",
        "address": "0 ,ICD Brookfield Place Level 13 ,Trade Centre ,506569 ,Dubai",
        "phone": "97145099100 / 971501006965",
        "email": "menahr@freshfields.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "970f6246-e737-41a7-9c6c-5aa5b8335d45",
    "firmName": "Freshfields LLP DIFC",
    "registrationNumber": "L-05388",
    "licenseIssueDate": "07/20/2022 00:00:00",
    "licenseExpiryDate": "07/19/2026 00:00:00"
  },
  {
    "id": "cf65deeb-8c65-47b0-a965-ff24a24c3fb8",
    "slug": "anna-terrizzi",
    "name": "Anna Terrizzi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/11/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Anna Terrizzi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cf65deeb-8c65-47b0-a965-ff24a24c3fb8",
        "address": "",
        "phone": "97144020800 / 971566830829",
        "email": "dean.ryburn@dentons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dfe13b7e-6625-45fd-ad63-9ee83af41194",
    "firmName": "Dentons & Co Dubai Branch-DED",
    "registrationNumber": "L-00403",
    "licenseIssueDate": "02/11/2019 00:00:00",
    "licenseExpiryDate": "02/09/2026 00:00:00"
  },
  {
    "id": "d8e38a3d-722f-4679-934a-74559334e45f",
    "slug": "anna-white",
    "name": "Anna White",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/05/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Anna White",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d8e38a3d-722f-4679-934a-74559334e45f",
        "address": "",
        "phone": "97143641686 / 971506288801",
        "email": "b.kadir@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0ba96df8-e4cc-49c2-8ae4-a42878d95926",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS LLC",
    "registrationNumber": "L-03654",
    "licenseIssueDate": "03/05/2017 00:00:00",
    "licenseExpiryDate": "03/01/2026 00:00:00"
  },
  {
    "id": "a3c83cc3-f145-4296-8436-49615927fb60",
    "slug": "annabel-levick",
    "name": "Annabel Levick",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/03/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Annabel Levick",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a3c83cc3-f145-4296-8436-49615927fb60",
        "address": "",
        "phone": "97144020800 / 971566830829",
        "email": "dean.ryburn@dentons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dfe13b7e-6625-45fd-ad63-9ee83af41194",
    "firmName": "Dentons & Co Dubai Branch-DED",
    "registrationNumber": "L-02682",
    "licenseIssueDate": "03/03/2021 00:00:00",
    "licenseExpiryDate": "03/02/2026 00:00:00"
  },
  {
    "id": "d1ffdeb7-5e8c-4cdb-bd09-fc8d93f9a3f9",
    "slug": "annabelle-polly-sikora",
    "name": "Annabelle Polly Sikora",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/28/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Annabelle Polly Sikora",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d1ffdeb7-5e8c-4cdb-bd09-fc8d93f9a3f9",
        "address": "",
        "phone": "97145953601 / 971508728645",
        "email": "Steven.Bainbridge@gtlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b4146aa6-efd1-41d7-819d-49da46353b0b",
    "firmName": "Greenberg Traurig Limited",
    "registrationNumber": "L-06832",
    "licenseIssueDate": "05/28/2025 00:00:00",
    "licenseExpiryDate": "05/27/2026 00:00:00"
  },
  {
    "id": "0460f68d-1595-45d5-8889-053400f3b188",
    "slug": "anne-marie-katharina-wicks",
    "name": "Anne Marie Katharina Wicks",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/09/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Anne Marie Katharina Wicks",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0460f68d-1595-45d5-8889-053400f3b188",
        "address": "Index Tower ,Dubai International Financial Centre ,507115 ,",
        "phone": "97143757160 / 971523490280",
        "email": "tthraya@mayerbrown.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c7f52b69-c049-4246-963a-9805b241f88a",
    "firmName": "Mayer Brown LLP",
    "registrationNumber": "L-05970",
    "licenseIssueDate": "08/09/2023 00:00:00",
    "licenseExpiryDate": "08/08/2026 00:00:00"
  },
  {
    "id": "8569d3cf-7b71-4602-9615-24fce70348ed",
    "slug": "anne-sophie-marie-frederique-c-rolland",
    "name": "Anne Sophie Marie Frederique C Rolland",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/22/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Anne Sophie Marie Frederique C Rolland",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8569d3cf-7b71-4602-9615-24fce70348ed",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506688 ,Dubai",
        "phone": "97147096600 / 971503556811",
        "email": "muneer.khan@simmons-simmons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d1725ca7-06ac-41b2-8d7b-a6e60665b73d",
    "firmName": "Simmons & Simmons (Middle East) LLP-DIFC",
    "registrationNumber": "L-06095",
    "licenseIssueDate": "11/22/2023 00:00:00",
    "licenseExpiryDate": "11/21/2025 00:00:00"
  },
  {
    "id": "24ae0c54-9c8d-4cc1-a9eb-f58184a425ac",
    "slug": "anne-caroline-albrecht",
    "name": "Anne-Caroline Albrecht",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/10/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Anne-Caroline Albrecht",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_24ae0c54-9c8d-4cc1-a9eb-f58184a425ac",
        "address": "",
        "phone": "97145683100 / 971559223103",
        "email": "rossi@bonnard-lawson.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2b373724-e557-4c31-a968-7d37d9393842",
    "firmName": "Bonnard Lawson Legal Consultants L.L.C",
    "registrationNumber": "L-02472",
    "licenseIssueDate": "06/10/2014 00:00:00",
    "licenseExpiryDate": "06/04/2026 00:00:00"
  },
  {
    "id": "0ee9d276-3eb5-4bf3-ad57-bbac7e04984d",
    "slug": "annie-anngoc-luong",
    "name": "Annie AnNgoc Luong",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/02/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Annie AnNgoc Luong",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0ee9d276-3eb5-4bf3-ad57-bbac7e04984d",
        "address": "",
        "phone": "97143742800 / 971506450677",
        "email": "jabbott21@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7a59d310-ff72-4318-b41c-27095c163d0f",
    "firmName": "CMS (UAE) LLP",
    "registrationNumber": "L-05700",
    "licenseIssueDate": "05/02/2025 00:00:00",
    "licenseExpiryDate": "05/01/2026 00:00:00"
  },
  {
    "id": "8c65d4c4-503a-49c1-831a-f34a39309692",
    "slug": "anshuman-rakesh-jaruhar",
    "name": "Anshuman Rakesh Jaruhar",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/31/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Anshuman Rakesh Jaruhar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8c65d4c4-503a-49c1-831a-f34a39309692",
        "address": "- ,Index Tower ,Dubai International Financial Centre ,9371 ,Dubai",
        "phone": "97143303900 / 971561753537",
        "email": "christopher@afridi-angell.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3e464dc8-b800-4ba2-ad91-24a5f9640fef",
    "firmName": "Afridi & Angell-DIFC",
    "registrationNumber": "L-06354",
    "licenseIssueDate": "05/31/2024 00:00:00",
    "licenseExpiryDate": "05/30/2026 00:00:00"
  },
  {
    "id": "a401fd5a-2a2d-4ca3-8fce-9bbd49a9ea56",
    "slug": "anthony-davies",
    "name": "Anthony Davies",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/27/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Anthony Davies",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a401fd5a-2a2d-4ca3-8fce-9bbd49a9ea56",
        "address": "Hamdan Abdulla Mohamed Al Sayyah ,First Floor Office 108 ,Alserkal Building ,Beside Alkhoory Sky Gardens ,116499 ,Dubai",
        "phone": "97144491085",
        "email": "info@als-legal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2cfc8314-1db4-4102-9720-3a65b58a8b0d",
    "firmName": "AL SAYYAH ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-00979",
    "licenseIssueDate": "08/27/2014 00:00:00",
    "licenseExpiryDate": "08/21/2026 00:00:00"
  },
  {
    "id": "cfc73415-011a-4f4d-be50-c2b3b8e02774",
    "slug": "anthony-hajji",
    "name": "Anthony Hajji",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/09/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Anthony Hajji",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cfc73415-011a-4f4d-be50-c2b3b8e02774",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-06534",
    "licenseIssueDate": "10/09/2024 00:00:00",
    "licenseExpiryDate": "10/08/2026 00:00:00"
  },
  {
    "id": "f45e9d36-3c80-4979-b59f-3b06859c3e1d",
    "slug": "anthony-ibrahim-traboulsi",
    "name": "Anthony Ibrahim Traboulsi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/27/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Anthony Ibrahim Traboulsi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f45e9d36-3c80-4979-b59f-3b06859c3e1d",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-04631",
    "licenseIssueDate": "02/27/2020 00:00:00",
    "licenseExpiryDate": "02/26/2026 00:00:00"
  },
  {
    "id": "59cb1c0d-b3d1-4f82-8751-6d3c724cd8e7",
    "slug": "anthony-james-fielding",
    "name": "Anthony James Fielding",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/03/2024",
    "licenseStatus": "active",
    "licenseExpiry": "2025-03-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Anthony James Fielding",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_59cb1c0d-b3d1-4f82-8751-6d3c724cd8e7",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-04060",
    "licenseIssueDate": "03/05/2024 00:00:00",
    "licenseExpiryDate": "03/04/2026 00:00:00"
  },
  {
    "id": "323a22ce-6360-4e18-bcc3-5deff931e5b6",
    "slug": "anthony-mrad",
    "name": "Anthony Mrad",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/29/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Anthony Mrad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_323a22ce-6360-4e18-bcc3-5deff931e5b6",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-03605",
    "licenseIssueDate": "01/29/2017 00:00:00",
    "licenseExpiryDate": "01/25/2026 00:00:00"
  },
  {
    "id": "33782b84-3cab-411b-b72c-a894170e95b2",
    "slug": "anthony-phan",
    "name": "Anthony Phan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/12/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Anthony Phan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_33782b84-3cab-411b-b72c-a894170e95b2",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506688 ,Dubai",
        "phone": "97147096600 / 971503556811",
        "email": "muneer.khan@simmons-simmons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d1725ca7-06ac-41b2-8d7b-a6e60665b73d",
    "firmName": "Simmons & Simmons (Middle East) LLP-DIFC",
    "registrationNumber": "L-06714",
    "licenseIssueDate": "03/12/2025 00:00:00",
    "licenseExpiryDate": "03/11/2026 00:00:00"
  },
  {
    "id": "071c565a-d57b-4bf1-9f48-148dea0aa62f",
    "slug": "anthony-richard-wilson",
    "name": "Anthony Richard Wilson",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/22/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Anthony Richard Wilson",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_071c565a-d57b-4bf1-9f48-148dea0aa62f",
        "address": "",
        "phone": "97143339002 / 971558818724",
        "email": "info@nhalhammadi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e78d4c87-2450-4a73-af8f-bdea91defa61",
    "firmName": "HESSA ALHAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05216",
    "licenseIssueDate": "01/22/2022 00:00:00",
    "licenseExpiryDate": "01/21/2026 00:00:00"
  },
  {
    "id": "e8654139-b172-438f-8c12-ae561008d058",
    "slug": "antoine-bechara",
    "name": "ANTOINE BECHARA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/06/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ANTOINE BECHARA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e8654139-b172-438f-8c12-ae561008d058",
        "address": "fahad alhosani ,Office No. 1006 ,ASPECT TOWER ,Near Burj Khalifa ,000 ,Dubai",
        "phone": "97100000000 / 971551111723",
        "email": "info@fahadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "aea24945-594d-49dd-8077-830efa5e95ff",
    "firmName": "FAHAD ALHOSANI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06231",
    "licenseIssueDate": "03/06/2024 00:00:00",
    "licenseExpiryDate": "03/05/2026 00:00:00"
  },
  {
    "id": "a7a0dedc-5ec4-49a8-9faa-2493c25c4337",
    "slug": "anton-konnov",
    "name": "ANTON KONNOV",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/05/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ANTON KONNOV",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a7a0dedc-5ec4-49a8-9faa-2493c25c4337",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05553",
    "licenseIssueDate": "10/05/2022 00:00:00",
    "licenseExpiryDate": "10/04/2026 00:00:00"
  },
  {
    "id": "54e17384-ef16-4920-aa20-89c64932f974",
    "slug": "anton-malakhov",
    "name": "Anton Malakhov",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/25/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Anton Malakhov",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_54e17384-ef16-4920-aa20-89c64932f974",
        "address": "",
        "phone": "97147098484 / 971505577206",
        "email": "slshadmand@jonesday.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8892bfe9-d3ec-4158-b4fd-1844606f4f30",
    "firmName": "Jones Day",
    "registrationNumber": "L-06964",
    "licenseIssueDate": "09/25/2025 00:00:00",
    "licenseExpiryDate": "09/24/2026 00:00:00"
  },
  {
    "id": "52384e2b-7464-4f27-b184-cfd985c081ff",
    "slug": "antonin-sobek",
    "name": "Antonin Sobek",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/22/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Antonin Sobek",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_52384e2b-7464-4f27-b184-cfd985c081ff",
        "address": "Index Tower ,Dubai International Financial Centre ,507115 ,",
        "phone": "97143757160 / 971523490280",
        "email": "tthraya@mayerbrown.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c7f52b69-c049-4246-963a-9805b241f88a",
    "firmName": "Mayer Brown LLP",
    "registrationNumber": "L-06326",
    "licenseIssueDate": "05/22/2024 00:00:00",
    "licenseExpiryDate": "05/21/2026 00:00:00"
  },
  {
    "id": "1837ce84-bbbd-4d0a-87d9-ec7d714c7d63",
    "slug": "antonina-birt",
    "name": "Antonina Birt",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/06/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Antonina Birt",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1837ce84-bbbd-4d0a-87d9-ec7d714c7d63",
        "address": "Index Tower ,506548 ,Dubai",
        "phone": "97147096300 / 971506767433",
        "email": "amateen@reedsmith.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b3f87e90-7ce9-4097-82c4-15232365f175",
    "firmName": "Reed Smith LLP",
    "registrationNumber": "L-00567",
    "licenseIssueDate": "11/06/2016 00:00:00",
    "licenseExpiryDate": "11/02/2025 00:00:00"
  },
  {
    "id": "dcc9d8e4-41bd-4aee-b25e-d48404f8dde6",
    "slug": "antonio-maria-varvaro",
    "name": "Antonio Maria Varvaro",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/02/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Antonio Maria Varvaro",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dcc9d8e4-41bd-4aee-b25e-d48404f8dde6",
        "address": "",
        "phone": "97145851677 / 971508009612",
        "email": "antonio.varvaro@amv-eurolegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "2834e81b-8706-4672-8b39-01356b145ac0",
    "firmName": "Antonio M Varvaro Legal Consultants",
    "registrationNumber": "L-04202",
    "licenseIssueDate": "09/02/2018 00:00:00",
    "licenseExpiryDate": "08/31/2026 00:00:00"
  },
  {
    "id": "027a8571-8b35-4838-b825-e1c31403ae44",
    "slug": "antonio-michaelides",
    "name": "Antonio Michaelides",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/12/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Antonio Michaelides",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_027a8571-8b35-4838-b825-e1c31403ae44",
        "address": "",
        "phone": "97142472100 / 971509224336",
        "email": "bhaley@cov.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "65a2e90a-6978-4292-b3f1-ecbebedd7b9a",
    "firmName": "Covington & Burling LLP (Middle East)",
    "registrationNumber": "L-01875",
    "licenseIssueDate": "03/12/2019 00:00:00",
    "licenseExpiryDate": "03/10/2026 00:00:00"
  },
  {
    "id": "1c2a1b9a-c564-41e0-b02c-d482814d2a6d",
    "slug": "antonios-dimitrakopoulos",
    "name": "Antonios Dimitrakopoulos",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Antonios Dimitrakopoulos",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1c2a1b9a-c564-41e0-b02c-d482814d2a6d",
        "address": "",
        "phone": "97143685555",
        "email": "maisa.maarouf@bsabh.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8afa232f-52ff-4dad-82c3-9a04d66eb853",
    "firmName": "B S A AHMED BIN HAZEEM & ASSOCIATES LLP - DIFC",
    "registrationNumber": "L-01625",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "a0b3b297-e989-43dd-b033-17cb1d141e83",
    "slug": "antony-griffiths",
    "name": "ANTONY GRIFFITHS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/02/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ANTONY GRIFFITHS",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a0b3b297-e989-43dd-b033-17cb1d141e83",
        "address": "",
        "phone": "97144272700 / 971545824605",
        "email": "tony.griffiths@klgates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "fb8fc340-ceef-4b83-8f2b-9b24d4604967",
    "firmName": "K & L Gates LLP",
    "registrationNumber": "L-04391",
    "licenseIssueDate": "10/02/2019 00:00:00",
    "licenseExpiryDate": "10/01/2026 00:00:00"
  },
  {
    "id": "51d94aef-f2c9-4c2c-9171-43ca25b6c908",
    "slug": "antoun-milan",
    "name": "Antoun Milan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/29/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Antoun Milan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_51d94aef-f2c9-4c2c-9171-43ca25b6c908",
        "address": "TWIN TOWERS -  ,AL RIGA ,42001 ,",
        "phone": "97142281212 / 971504595431",
        "email": "milanlawfirm@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "d45f1c65-7336-4362-b823-660251efae7c",
    "firmName": "Antoun Milan Legal Consultants",
    "registrationNumber": "L-00441",
    "licenseIssueDate": "10/29/2011 00:00:00",
    "licenseExpiryDate": "10/20/2025 00:00:00"
  },
  {
    "id": "bdbd5995-2e12-40a6-9bd3-c2bebf3912c6",
    "slug": "anuj-bhasin",
    "name": "Anuj Bhasin",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/25/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Anuj Bhasin",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bdbd5995-2e12-40a6-9bd3-c2bebf3912c6",
        "address": "",
        "phone": "97143641686 / 971506288801",
        "email": "b.kadir@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0ba96df8-e4cc-49c2-8ae4-a42878d95926",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS LLC",
    "registrationNumber": "L-05087",
    "licenseIssueDate": "10/25/2021 00:00:00",
    "licenseExpiryDate": "10/24/2026 00:00:00"
  },
  {
    "id": "82377526-d496-4d9b-820f-e20fd43cb7bb",
    "slug": "anuj-johar",
    "name": "ANUJ JOHAR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/07/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ANUJ JOHAR",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_82377526-d496-4d9b-820f-e20fd43cb7bb",
        "address": "Level 17, ICD Brookfield Place ,DIFC ,506503 ,",
        "phone": "97144375100 / 971588271196",
        "email": "libby.edwards-smith@gowlingwlg.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "436703ba-b9c0-4dcb-93b2-1299c7a051f4",
    "firmName": "Gowling WLG (UK) LLP (Dubai Branch)",
    "registrationNumber": "L-03994",
    "licenseIssueDate": "02/07/2018 00:00:00",
    "licenseExpiryDate": "02/04/2026 00:00:00"
  },
  {
    "id": "728ddf0c-0d5d-41f0-a0e0-5f12734b7068",
    "slug": "anuradha-vobbilisetty",
    "name": "Anuradha Vobbilisetty",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBVgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/17/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Anuradha Vobbilisetty",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_728ddf0c-0d5d-41f0-a0e0-5f12734b7068",
        "address": "Azza Ebrahim Hasan Almulla ,6(602-603) ,Al Shoalla Building (Al Naboodah) ,deira city center ,12871 ,Dubai",
        "phone": "97142950010",
        "email": "dubai-secretary@dralmulla.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "fbf6220f-2608-4caa-895e-d45ae8a259a2",
    "firmName": "AZZA EBRAHIM HASAN ALMULLA ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-02056",
    "licenseIssueDate": "11/17/2011 00:00:00",
    "licenseExpiryDate": "11/08/2025 00:00:00"
  },
  {
    "id": "fb7a5002-c91c-444d-bca2-ef5353457c1d",
    "slug": "anusha-aggarwal",
    "name": "Anusha Aggarwal",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/15/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Anusha Aggarwal",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fb7a5002-c91c-444d-bca2-ef5353457c1d",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-06153",
    "licenseIssueDate": "12/15/2023 00:00:00",
    "licenseExpiryDate": "12/14/2025 00:00:00"
  },
  {
    "id": "f96559de-315c-40e6-b566-64a674eb1a54",
    "slug": "anwar-hasan-said-al-karmi",
    "name": "Anwar Hasan Said Al-Karmi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/04/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Anwar Hasan Said Al-Karmi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f96559de-315c-40e6-b566-64a674eb1a54",
        "address": "ISMAIL HASSAN EBRAHIM ALSAFFAR ,الطابق الثامن - مكتب 801 AFR ,الصقر للاعمال ,يوجد اسفل البناية مطعم وينديز ,25752 ,Dubai",
        "phone": "97143276805",
        "email": "info@alsaffar-legal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ceb9cbcf-79f3-462d-afe2-aa4c62eff72b",
    "firmName": "ISMAIL ALSAFFAR ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01828",
    "licenseIssueDate": "03/04/2021 00:00:00",
    "licenseExpiryDate": "03/03/2026 00:00:00"
  },
  {
    "id": "3f19235f-9b44-4252-8c87-71e072d1ba6b",
    "slug": "anwar-nabil-anwar-elemiry",
    "name": "Anwar Nabil Anwar Elemiry",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/19/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Anwar Nabil Anwar Elemiry",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3f19235f-9b44-4252-8c87-71e072d1ba6b",
        "address": "",
        "phone": "97142555111 / 971500000000",
        "email": "info@legalemirates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "c507bf6b-00f8-4c70-8580-9e267ce5bbf3",
    "firmName": "BADER HAMAD ALZAABI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03165",
    "licenseIssueDate": "03/19/2015 00:00:00",
    "licenseExpiryDate": "03/13/2026 00:00:00"
  },
  {
    "id": "6cb366e4-f9ba-48bc-95b4-46fba2f10682",
    "slug": "anzal-mohammed",
    "name": "Anzal Mohammed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Anzal Mohammed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6cb366e4-f9ba-48bc-95b4-46fba2f10682",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-00204",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "ba26a3d3-a394-4b4b-898a-b0c64effa4d1",
    "slug": "aparajita-chakraborty",
    "name": "Aparajita Chakraborty",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/14/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Aparajita Chakraborty",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ba26a3d3-a394-4b4b-898a-b0c64effa4d1",
        "address": "Emirates Financial Towers (South) ,DIFC ,506546 ,",
        "phone": "97147096700 / 971505573843",
        "email": "dk@kbh.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "291a9c0d-030a-4cef-8739-c6946f741117",
    "firmName": "KBH Limited",
    "registrationNumber": "L-04515",
    "licenseIssueDate": "06/14/2024 00:00:00",
    "licenseExpiryDate": "06/13/2026 00:00:00"
  },
  {
    "id": "036d0a3f-fa8d-45e3-b393-106950e2844e",
    "slug": "aparna-vidya",
    "name": "Aparna Vidya",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBVgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/22/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Aparna Vidya",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_036d0a3f-fa8d-45e3-b393-106950e2844e",
        "address": "4th floor ,Al Saaha Offices Block D office 401A ,Burj Khalifa ,283773 ,Dubai",
        "phone": "97144221944",
        "email": "gov.depts@alsafarpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b7bbfaeb-1fdb-46d2-97cf-8e6432a9b8a7",
    "firmName": "AL SAFAR & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02458",
    "licenseIssueDate": "07/22/2012 00:00:00",
    "licenseExpiryDate": "07/29/2026 00:00:00"
  },
  {
    "id": "f8b4fc41-d17c-4f3d-8ba0-50beedb1023e",
    "slug": "aqsa-adil-muhammad-adil",
    "name": "Aqsa Adil Muhammad Adil",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/19/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Aqsa Adil Muhammad Adil",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f8b4fc41-d17c-4f3d-8ba0-50beedb1023e",
        "address": "",
        "phone": "97143937700",
        "email": "info@galadarilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d863b662-c864-4193-8b3a-ff6ee5fe6c64",
    "firmName": "GALADARI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06693",
    "licenseIssueDate": "02/19/2025 00:00:00",
    "licenseExpiryDate": "02/18/2026 00:00:00"
  },
  {
    "id": "19f357f4-a821-4a35-9d9e-0082bd322d49",
    "slug": "aqsa-sadiq",
    "name": "Aqsa Sadiq",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/26/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Aqsa Sadiq",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_19f357f4-a821-4a35-9d9e-0082bd322d49",
        "address": "Al Fattan Currency House Tower 2 ,DIFC ,507176 ,",
        "phone": "/ 971552009003",
        "email": "Mohammad.AlRasheed@bakermckenzie.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "acd81e81-dead-4f7c-839e-0f2a57897265",
    "firmName": "Baker & Mckenzie LLP",
    "registrationNumber": "L-03067",
    "licenseIssueDate": "07/26/2021 00:00:00",
    "licenseExpiryDate": "07/25/2026 00:00:00"
  },
  {
    "id": "8790fd91-acf8-4efc-af32-583a83febf4e",
    "slug": "arafa-shiba-youssef-elabd",
    "name": "Arafa Shiba youssef elabd",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/23/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Arafa Shiba youssef elabd",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8790fd91-acf8-4efc-af32-583a83febf4e",
        "address": "",
        "phone": "97142713893",
        "email": "info@rashedlootah.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6966793e-be56-4683-9aad-1912a5885631",
    "firmName": "RASHED LOOTAH ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05978",
    "licenseIssueDate": "08/23/2023 00:00:00",
    "licenseExpiryDate": "08/22/2026 00:00:00"
  },
  {
    "id": "b06d1d9c-0f68-4213-8028-6a08e0fc71fa",
    "slug": "arasa-tharshini-rasadurai",
    "name": "ARASA THARSHINI RASADURAI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/19/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-01-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ARASA THARSHINI RASADURAI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b06d1d9c-0f68-4213-8028-6a08e0fc71fa",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-06171",
    "licenseIssueDate": "01/19/2024 00:00:00",
    "licenseExpiryDate": "01/18/2026 00:00:00"
  },
  {
    "id": "4d6e21d1-3a12-48de-83b7-769f65205849",
    "slug": "arash-haghshenas-zad",
    "name": "Arash Haghshenas Zad",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/18/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Arash Haghshenas Zad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4d6e21d1-3a12-48de-83b7-769f65205849",
        "address": "Ali Saleh Atrooz  ,1103 ,EMPIRE HEIGHTS B ,دبي مول  ,18433 ,Dubai",
        "phone": "97142222511",
        "email": "info@araalaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "aab79fde-e700-45d7-904f-bde0a593a087",
    "firmName": "ARAA GROUP ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03050",
    "licenseIssueDate": "01/18/2023 00:00:00",
    "licenseExpiryDate": "01/17/2026 00:00:00"
  },
  {
    "id": "297b00fe-a555-49c4-b22e-e9639d92ab22",
    "slug": "arash-koozehkanani",
    "name": "Arash Koozehkanani",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/22/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Arash Koozehkanani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_297b00fe-a555-49c4-b22e-e9639d92ab22",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-03163",
    "licenseIssueDate": "09/22/2015 00:00:00",
    "licenseExpiryDate": "09/17/2026 00:00:00"
  },
  {
    "id": "5f23edf5-b83a-4ff7-965e-2990a6b82826",
    "slug": "archana-r-modgekar",
    "name": "Archana R Modgekar",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/24/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Archana R Modgekar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5f23edf5-b83a-4ff7-965e-2990a6b82826",
        "address": "Advo. Abdulla Al Awadi ,العاشر  ,برايم تاور  ,فندق فيدا ,26665 ,Dubai",
        "phone": "97143352200",
        "email": "info@abdullaalawadi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5075821f-98f5-4546-8fcd-6cdc74967dac",
    "firmName": "ABDULLA AL AWADI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05814",
    "licenseIssueDate": "05/24/2023 00:00:00",
    "licenseExpiryDate": "05/23/2026 00:00:00"
  },
  {
    "id": "609b6982-e834-4ddd-8a5d-d222d83637cd",
    "slug": "areen-khaldoun-jayousi",
    "name": "Areen Khaldoun Jayousi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/17/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Areen Khaldoun Jayousi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_609b6982-e834-4ddd-8a5d-d222d83637cd",
        "address": "O-4801, O-4901 ,Burj al Salam Office Tower ,H Hotel ,111801 ,Dubai",
        "phone": "97143544444",
        "email": "administration@horizlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4e25fb39-6659-44f0-bc8b-3ff0f067beb0",
    "firmName": "HORIZONS & CO - LAW FIRM",
    "registrationNumber": "L-05330",
    "licenseIssueDate": "05/17/2022 00:00:00",
    "licenseExpiryDate": "05/16/2026 00:00:00"
  },
  {
    "id": "92cdbc99-c22d-4010-b58f-e71ab5f05800",
    "slug": "aref-yahya-al-sharafi",
    "name": "Aref Yahya Al Sharafi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/22/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Aref Yahya Al Sharafi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_92cdbc99-c22d-4010-b58f-e71ab5f05800",
        "address": "18 ,فندق مونارك  ,مركز التجاري ,98444 ,Dubai",
        "phone": "97143588777",
        "email": "info@bhadvoc.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "61266d12-f5b4-4466-a1a8-a45934d9e511",
    "firmName": "BIN HAIDER ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02613",
    "licenseIssueDate": "07/22/2014 00:00:00",
    "licenseExpiryDate": "07/16/2026 00:00:00"
  },
  {
    "id": "a9a6953b-aadc-41fc-9f6e-8213e94d0072",
    "slug": "arif-amir-doha-chowdhury",
    "name": "Arif Amir Doha Chowdhury",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/09/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Arif Amir Doha Chowdhury",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a9a6953b-aadc-41fc-9f6e-8213e94d0072",
        "address": "",
        "phone": "97144020800 / 971566830829",
        "email": "dean.ryburn@dentons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dfe13b7e-6625-45fd-ad63-9ee83af41194",
    "firmName": "Dentons & Co Dubai Branch-DED",
    "registrationNumber": "L-06719",
    "licenseIssueDate": "04/09/2025 00:00:00",
    "licenseExpiryDate": "04/08/2026 00:00:00"
  },
  {
    "id": "91df19c7-94af-4b36-ac08-7ddb1cd7ad27",
    "slug": "arihant-om-mohta",
    "name": "Arihant Om Mohta",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/11/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Arihant Om Mohta",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_91df19c7-94af-4b36-ac08-7ddb1cd7ad27",
        "address": "3902 ,single business tower ,Sheikh Zayed Rd.  ,90077 ,Dubai",
        "phone": "97143804141 / 97143804141",
        "email": "info@united-advocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "52ebf695-ce46-4e03-abc9-f4d8d2f8a356",
    "firmName": "UNITED ADVOCATES",
    "registrationNumber": "L-05802",
    "licenseIssueDate": "05/11/2023 00:00:00",
    "licenseExpiryDate": "05/10/2026 00:00:00"
  },
  {
    "id": "54a2cf54-c377-48a6-bd7c-656ff1d105b1",
    "slug": "arina-gidwani",
    "name": "Arina Gidwani",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Arina Gidwani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_54a2cf54-c377-48a6-bd7c-656ff1d105b1",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01245",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "f9a99958-8bb0-4824-a120-2265d3e54e9b",
    "slug": "aris-garas",
    "name": "Aris Garas",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/19/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Aris Garas",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f9a99958-8bb0-4824-a120-2265d3e54e9b",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-06694",
    "licenseIssueDate": "02/19/2025 00:00:00",
    "licenseExpiryDate": "02/18/2026 00:00:00"
  },
  {
    "id": "3ca2e915-c795-4dbd-b1b4-52a742b818f1",
    "slug": "arman-rafiei-ghafarokhi",
    "name": "Arman Rafiei Ghafarokhi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/16/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Arman Rafiei Ghafarokhi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3ca2e915-c795-4dbd-b1b4-52a742b818f1",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-04457",
    "licenseIssueDate": "07/16/2020 00:00:00",
    "licenseExpiryDate": "07/15/2026 00:00:00"
  },
  {
    "id": "f1052101-a6b4-4624-b26b-1d48778afa84",
    "slug": "arnaud-francis-daniel-depierrefeu",
    "name": "Arnaud Francis Daniel Depierrefeu",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/20/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Arnaud Francis Daniel Depierrefeu",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f1052101-a6b4-4624-b26b-1d48778afa84",
        "address": "Central Park Towers ,507120 ,",
        "phone": "97143200940 / 971502397176",
        "email": "lsahbani@lpalaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4c158c98-1a29-48da-ade1-54e60bfd5b78",
    "firmName": "LPA (Middle East) LTD",
    "registrationNumber": "L-06654",
    "licenseIssueDate": "01/20/2025 00:00:00",
    "licenseExpiryDate": "01/19/2026 00:00:00"
  },
  {
    "id": "1fefbbb8-a607-4d69-8937-9f9ed1c9c30e",
    "slug": "arnolds-krutilins",
    "name": "Arnolds Krutilins",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/01/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Arnolds Krutilins",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1fefbbb8-a607-4d69-8937-9f9ed1c9c30e",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-05748",
    "licenseIssueDate": "03/01/2023 00:00:00",
    "licenseExpiryDate": "02/28/2026 00:00:00"
  },
  {
    "id": "808c6f52-76c1-48ee-a281-ddd454a6d43c",
    "slug": "arsalan-tariq-aziz",
    "name": "Arsalan Tariq Aziz",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/24/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Arsalan Tariq Aziz",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_808c6f52-76c1-48ee-a281-ddd454a6d43c",
        "address": "",
        "phone": "97143685555",
        "email": "maisa.maarouf@bsabh.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8afa232f-52ff-4dad-82c3-9a04d66eb853",
    "firmName": "B S A AHMED BIN HAZEEM & ASSOCIATES LLP - DIFC",
    "registrationNumber": "L-05835",
    "licenseIssueDate": "05/24/2023 00:00:00",
    "licenseExpiryDate": "05/23/2026 00:00:00"
  },
  {
    "id": "a9a7b3e9-197c-4659-8a5f-5c203ec09486",
    "slug": "arsen-khachikian",
    "name": "Arsen Khachikian",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/11/2022",
    "licenseStatus": "active",
    "licenseExpiry": "2023-11-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Arsen Khachikian",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a9a7b3e9-197c-4659-8a5f-5c203ec09486",
        "address": "ICD Brookfield Place ,DIFC ,120109 ,",
        "phone": "97143173000 / 971504465229",
        "email": "DubaiLAD@akingump.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9ff29eab-adb8-40f9-ab84-216e01a381e4",
    "firmName": "Akin Gump Strauss Hauer & Feld LLP",
    "registrationNumber": "L-05600",
    "licenseIssueDate": "11/30/2022 00:00:00",
    "licenseExpiryDate": "11/29/2025 00:00:00"
  },
  {
    "id": "57321297-f221-4092-ad4c-0fd109c01486",
    "slug": "arturs-dedels",
    "name": "Arturs Dedels",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/23/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Arturs Dedels",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_57321297-f221-4092-ad4c-0fd109c01486",
        "address": "23 ,Rolex Tower ,Trade Center Second ,116637 ,Dubai",
        "phone": "97144357577 / 971502101003",
        "email": "jasamin.fichte@fichtelegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "77bf4fd2-1cd1-4bda-a0c2-ffcac3980b76",
    "firmName": "Fichte & Co Legal Consultancy",
    "registrationNumber": "L-05024",
    "licenseIssueDate": "06/23/2025 00:00:00",
    "licenseExpiryDate": "06/22/2026 00:00:00"
  },
  {
    "id": "5be280f9-4c5e-402d-a91a-c6aed4118e34",
    "slug": "arun-abraham",
    "name": "Arun Abraham",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/04/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Arun Abraham",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5be280f9-4c5e-402d-a91a-c6aed4118e34",
        "address": "الخامس ,الشعلة بلوك اية ,داناتا ,127179 ,Dubai",
        "phone": "97143318888 / 971509984724",
        "email": "ameizar@salamadvo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "1b4e6bd9-712b-49bf-a169-fd31ea45cd51",
    "firmName": "SALAM ADVOCATE  & LEGAL CONSULTANTS",
    "registrationNumber": "L-03563",
    "licenseIssueDate": "01/04/2017 00:00:00",
    "licenseExpiryDate": "12/31/2025 00:00:00"
  },
  {
    "id": "40614a05-0b91-48c3-852c-9c6a19c5c994",
    "slug": "arun-visweswaran",
    "name": "Arun Visweswaran",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBVgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/04/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Arun Visweswaran",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_40614a05-0b91-48c3-852c-9c6a19c5c994",
        "address": "6 ,Office Nos. 603, 604 & 605, Level 6, Burj Daman ,Dubai International Financial Centre ,506555 ,Dubai",
        "phone": "97143506400 / 971504654755",
        "email": "r.hickman@aglaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8690f7d5-6b96-4649-9589-71303f2c2707",
    "firmName": "Addleshaw Goddard (Middle East) LLP",
    "registrationNumber": "L-01090",
    "licenseIssueDate": "10/04/2012 00:00:00",
    "licenseExpiryDate": "09/26/2026 00:00:00"
  },
  {
    "id": "6c83c741-d2dd-4aaa-9149-ad6aef1f3950",
    "slug": "arwa-abdeh",
    "name": "Arwa Abdeh",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/12/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Arwa Abdeh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6c83c741-d2dd-4aaa-9149-ad6aef1f3950",
        "address": "Level 17, ICD Brookfield Place ,DIFC ,506503 ,",
        "phone": "97144375100 / 971588271196",
        "email": "libby.edwards-smith@gowlingwlg.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "436703ba-b9c0-4dcb-93b2-1299c7a051f4",
    "firmName": "Gowling WLG (UK) LLP (Dubai Branch)",
    "registrationNumber": "L-06401",
    "licenseIssueDate": "07/12/2024 00:00:00",
    "licenseExpiryDate": "07/11/2026 00:00:00"
  },
  {
    "id": "46ac0b03-ffbb-455f-8750-604645bf92fb",
    "slug": "arzan-zarolia-tehemton-zarolia",
    "name": "Arzan Zarolia Tehemton Zarolia",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBWgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/12/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Arzan Zarolia Tehemton Zarolia",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_46ac0b03-ffbb-455f-8750-604645bf92fb",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-06404",
    "licenseIssueDate": "07/12/2024 00:00:00",
    "licenseExpiryDate": "07/11/2026 00:00:00"
  },
  {
    "id": "6ae7f14c-9247-4a1d-8bda-f21b13dd6d11",
    "slug": "asal-saghari",
    "name": "Asal Saghari",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/10/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Asal Saghari",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6ae7f14c-9247-4a1d-8bda-f21b13dd6d11",
        "address": "",
        "phone": "97143779900 / 971508548052",
        "email": "jali@kslaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dff8529a-82be-431a-b72b-0192ff238011",
    "firmName": "Eversheds Sutherland (International LLP) Dubai Branch",
    "registrationNumber": "L-03726",
    "licenseIssueDate": "05/10/2017 00:00:00",
    "licenseExpiryDate": "05/06/2026 00:00:00"
  },
  {
    "id": "286d9724-42ef-4b79-99a3-611293d63042",
    "slug": "asheesh-kumar-das",
    "name": "Asheesh Kumar Das",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/20/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Asheesh Kumar Das",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_286d9724-42ef-4b79-99a3-611293d63042",
        "address": "",
        "phone": "97144230555 / 971504788443",
        "email": "yah@hfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c462c65e-185a-4e81-8425-a87e3a2b6842",
    "firmName": "Holman Fenwick Willan Middle East LLP",
    "registrationNumber": "L-06045",
    "licenseIssueDate": "12/20/2023 00:00:00",
    "licenseExpiryDate": "12/19/2025 00:00:00"
  },
  {
    "id": "1983158c-5710-4067-8295-9d3abbb310c8",
    "slug": "ashish-mehta",
    "name": "Ashish Mehta",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ashish Mehta",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1983158c-5710-4067-8295-9d3abbb310c8",
        "address": "Saeed Tower 2 ,Sheikh Zayed Road ,32045 ,",
        "phone": "97143518989 / 971506466213",
        "email": "ashish.mehta@amalawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "f39b81d1-9085-4c4e-a69b-3d9349f8f28c",
    "firmName": "Ashish Mehta & Associates Legal Consultants LLC",
    "registrationNumber": "L-00436",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "24f7a10f-bc10-4022-8171-02ab56717f6a",
    "slug": "ashley-brook-williams",
    "name": "Ashley Brook Williams",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/23/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ashley Brook Williams",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_24f7a10f-bc10-4022-8171-02ab56717f6a",
        "address": "",
        "phone": "97145032600 / 971504577931",
        "email": "edmund.boyo@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8cca52de-2c74-4743-b8f2-0b904d96b132",
    "firmName": "CC Worldwide Limited",
    "registrationNumber": "L-06763",
    "licenseIssueDate": "04/23/2025 00:00:00",
    "licenseExpiryDate": "04/22/2026 00:00:00"
  },
  {
    "id": "b63c5055-9947-4eb1-b10d-8b9dd8c27584",
    "slug": "ashley-cywicki",
    "name": "Ashley Cywicki",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/02/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ashley Cywicki",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b63c5055-9947-4eb1-b10d-8b9dd8c27584",
        "address": "",
        "phone": "97143184600 / 971504468184",
        "email": "melaraby@gibsondunn.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c9d2c9d0-6e43-4253-a75d-cdeb400f8d8e",
    "firmName": "Gibson Dunn & Crutcher LLP",
    "registrationNumber": "L-03314",
    "licenseIssueDate": "06/02/2022 00:00:00",
    "licenseExpiryDate": "06/01/2026 00:00:00"
  },
  {
    "id": "1dc38096-6045-4765-b593-45b393edf4cf",
    "slug": "ashley-halewood",
    "name": "Ashley Halewood",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/12/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ashley Halewood",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1dc38096-6045-4765-b593-45b393edf4cf",
        "address": "",
        "phone": "97143897000 / 971506553198",
        "email": "nasseralikhasawneh@eversheds-sutherland.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "74a21d43-41d8-480a-a6af-6939b7c98a95",
    "firmName": "Eversheds Sutherland (International LLP) Dubai Branch",
    "registrationNumber": "L-00706",
    "licenseIssueDate": "03/12/2012 00:00:00",
    "licenseExpiryDate": "03/03/2026 00:00:00"
  },
  {
    "id": "ea3a295e-35b2-4148-86ee-1b3d783842c7",
    "slug": "ashley-robert-connick",
    "name": "Ashley Robert Connick",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/21/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ashley Robert Connick",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ea3a295e-35b2-4148-86ee-1b3d783842c7",
        "address": "",
        "phone": "97143826100 / 971507380618",
        "email": "jmiocevic@curtis.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0867bcc5-10fa-4783-91ae-b8f63e02e81a",
    "firmName": "Curtis Mallet-Prevost, Colt & Mosle LLP",
    "registrationNumber": "L-04613",
    "licenseIssueDate": "01/21/2020 00:00:00",
    "licenseExpiryDate": "01/20/2026 00:00:00"
  },
  {
    "id": "89cdd6f1-0604-447b-a838-2d0781ea4913",
    "slug": "ashley-robert-murtha",
    "name": "Ashley Robert Murtha",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/03/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ashley Robert Murtha",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_89cdd6f1-0604-447b-a838-2d0781ea4913",
        "address": "THE OFFICES 1 ,DWTC ,115580 ,",
        "phone": "97143739700 / 971501148248",
        "email": "nitesh.pradhan@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "361fdc64-6b6f-4f37-abca-c52af8473b84",
    "firmName": "Pinsent Masons  LLP (DWTCA Branch)",
    "registrationNumber": "L-06934",
    "licenseIssueDate": "08/15/2025 00:00:00",
    "licenseExpiryDate": "08/14/2026 00:00:00"
  },
  {
    "id": "0cb85742-c257-4903-867b-a76dc78f537c",
    "slug": "ashour-mohamed-aly-abdalla",
    "name": "ASHOUR MOHAMED ALY ABDALLA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/05/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ASHOUR MOHAMED ALY ABDALLA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0cb85742-c257-4903-867b-a76dc78f537c",
        "address": "",
        "phone": "97143333386 / 971549916936",
        "email": "info@mtaadv.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "466f3ad4-73e1-44db-b8ec-b01e829d77c4",
    "firmName": "MOHAMMAD ALLINJAWI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04901",
    "licenseIssueDate": "04/05/2021 00:00:00",
    "licenseExpiryDate": "04/04/2026 00:00:00"
  },
  {
    "id": "d7506de4-ea5a-460e-9438-ed914369d1a2",
    "slug": "ashraf-abdelhakim-elahmady-elhadidy",
    "name": "ashraf abdelhakim elahmady elhadidy",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/01/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ashraf abdelhakim elahmady elhadidy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d7506de4-ea5a-460e-9438-ed914369d1a2",
        "address": "31/3107 ,ابراج لطيفة ,بنك الكويت الوطني ,442 ,Dubai",
        "phone": "97197143706 / 971558775654",
        "email": "alnajjar_ab@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d509f1aa-3c88-499b-8ad7-0ac050a88123",
    "firmName": "ABDULLA ALNAJJAR ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04757",
    "licenseIssueDate": "10/01/2020 00:00:00",
    "licenseExpiryDate": "09/30/2026 00:00:00"
  },
  {
    "id": "1a99ded7-b144-4202-8446-05d614666fa0",
    "slug": "ashraf-abdelrazek-fathalla-ramadan",
    "name": "Ashraf Abdelrazek Fathalla Ramadan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/05/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ashraf Abdelrazek Fathalla Ramadan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1a99ded7-b144-4202-8446-05d614666fa0",
        "address": "almetaq insurance  ,alnouf tower ,business vilage  ,92422 ,Dubai",
        "phone": "97142974555",
        "email": "info@alsaeedilaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5684cb2e-d43e-411d-b69e-2e1976782a55",
    "firmName": "ALSAEEDI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04903",
    "licenseIssueDate": "04/05/2021 00:00:00",
    "licenseExpiryDate": "04/04/2026 00:00:00"
  },
  {
    "id": "8f71d550-62b2-475b-b60b-7240d677dc22",
    "slug": "ashraf-ahmed-mohsen",
    "name": "Ashraf Ahmed Mohsen",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ashraf Ahmed Mohsen",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8f71d550-62b2-475b-b60b-7240d677dc22",
        "address": "",
        "phone": "97143528887",
        "email": "info@kashwanilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "01ccf3a9-cfd3-4fb5-b5ac-a912503c2630",
    "firmName": "KASHWANI LAW FIRM",
    "registrationNumber": "L-02187",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "6ee80d93-b095-44fd-b3ca-43ab1e400b08",
    "slug": "ashraf-amin-youssef",
    "name": "Ashraf Amin Youssef",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ashraf Amin Youssef",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6ee80d93-b095-44fd-b3ca-43ab1e400b08",
        "address": "",
        "phone": "97142220011",
        "email": "info@hammad.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8d0af4a8-053e-49f9-bed7-795d52e23286",
    "firmName": "YOUSUF BIN HAMMAD & ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01577",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "bae2c6f5-f40b-483b-b98f-baf22eba9917",
    "slug": "ashraf-el-motei",
    "name": "Ashraf El Motei",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ashraf El Motei",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bae2c6f5-f40b-483b-b98f-baf22eba9917",
        "address": "Unit 801, 8th Floor ,Damac Executive Heights ,Time Oak Hotel ,112888 ,Dubai",
        "phone": "97144355959 / 971551049797",
        "email": "a.motei@motei.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "b898c8c8-b27a-4895-a7df-903b3dec14f6",
    "firmName": "Motei & Associates L.L.C",
    "registrationNumber": "L-00451",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "fff92185-7fa0-48b9-b9f2-e1a8eb76ecca",
    "slug": "ashraf-el-sayed-el-sayed",
    "name": "Ashraf El Sayed El Sayed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/10/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ashraf El Sayed El Sayed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fff92185-7fa0-48b9-b9f2-e1a8eb76ecca",
        "address": "",
        "phone": "97104309100 / 971564013758",
        "email": "c.royle@taylorwessing.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d51b6f43-8c62-486f-a1ab-6ee3b87c8006",
    "firmName": "Taylor Wessing LLP (Dubai Branch)",
    "registrationNumber": "L-02461",
    "licenseIssueDate": "10/10/2013 00:00:00",
    "licenseExpiryDate": "10/03/2026 00:00:00"
  },
  {
    "id": "1054b402-21d4-40ed-90ea-d85215957574",
    "slug": "ashraf-elagami-elmandouh",
    "name": "Ashraf Elagami ElMandouh",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ashraf Elagami ElMandouh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1054b402-21d4-40ed-90ea-d85215957574",
        "address": "Hussain Ali Al Jaziri ,11 ,City Tower 2 ,Crown Plaza hotel Sheikh Zayed Road ,4253 ,Dubai",
        "phone": "97142626777 / 971529087670",
        "email": "courts@jaflaws.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c58d8654-b428-46b3-abd5-024e4331ee53",
    "firmName": "JAAFAR ALWAN & AL JAZIRI & ASSOCIATES",
    "registrationNumber": "L-01613",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "aecec14e-913a-4a64-8210-1f46bbceb6fb",
    "slug": "ashraf-elbakri",
    "name": "Ashraf Elbakri",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/07/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ashraf Elbakri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_aecec14e-913a-4a64-8210-1f46bbceb6fb",
        "address": "",
        "phone": "97144230555 / 971504788443",
        "email": "yah@hfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c462c65e-185a-4e81-8425-a87e3a2b6842",
    "firmName": "Holman Fenwick Willan Middle East LLP",
    "registrationNumber": "L-00613",
    "licenseIssueDate": "10/07/2011 00:00:00",
    "licenseExpiryDate": "09/28/2026 00:00:00"
  },
  {
    "id": "44b201e6-e7e2-4fc1-8f93-d95de955a50c",
    "slug": "ashraf-elsayed-mousa-elsayed-mohamed",
    "name": "ASHRAF ELSAYED MOUSA ELSAYED MOHAMED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/20/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ASHRAF ELSAYED MOUSA ELSAYED MOHAMED",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_44b201e6-e7e2-4fc1-8f93-d95de955a50c",
        "address": "OBAID AL SHAMSI ADVOCATES & LEGAL CONSULTANTS ,لا يوجد ,AL GARHOUD BUSINESS CENTER ,AL GARHOUD BUSINESS CENTER ,1903 ,Dubai",
        "phone": "97129555545",
        "email": "info@oaslawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c8252dab-1a42-4878-a3ee-50ba9dddb978",
    "firmName": "OBAID AL SHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04845",
    "licenseIssueDate": "02/20/2023 00:00:00",
    "licenseExpiryDate": "02/19/2026 00:00:00"
  },
  {
    "id": "7fbc56c0-cd01-4658-87ce-b25fd54b57e1",
    "slug": "ashraf-elzibair-ibrahim-elzibair",
    "name": "Ashraf Elzibair Ibrahim Elzibair",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/14/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ashraf Elzibair Ibrahim Elzibair",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7fbc56c0-cd01-4658-87ce-b25fd54b57e1",
        "address": "MOHAMMED ALI SALMAN AL MARZOOQI ,الثالث  ,السركال  ,معرض سيارات الفطيم  ,39059 ,Dubai",
        "phone": "97142500008",
        "email": "adv.saad@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6bba829c-0392-4c72-a71b-01da72cb24ae",
    "firmName": "MOHAMED SALMAN ADVOCATE & LEGAL CONSULTANCY",
    "registrationNumber": "L-01853",
    "licenseIssueDate": "01/14/2012 00:00:00",
    "licenseExpiryDate": "01/05/2026 00:00:00"
  },
  {
    "id": "00f96304-47fb-4559-b437-31631f0b01fc",
    "slug": "ashraf-fathy-mohammed-abdelhafiz",
    "name": "Ashraf Fathy Mohammed Abdelhafiz",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/17/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ashraf Fathy Mohammed Abdelhafiz",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_00f96304-47fb-4559-b437-31631f0b01fc",
        "address": "مكتب رقم 403 – 504 - 102 ,القرن الواحد وعشرون ,مركز القبائل للتخفيضات ,68441 ,Dubai",
        "phone": "97142388763",
        "email": "shaikha.advo@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "80a47f20-166e-40d9-9dea-d793f4708270",
    "firmName": "SHAIKHA AHMAD ADVOCATES&LEGAL CONSULTANTS",
    "registrationNumber": "L-01954",
    "licenseIssueDate": "11/17/2011 00:00:00",
    "licenseExpiryDate": "11/08/2026 00:00:00"
  },
  {
    "id": "99c971ac-cd9e-4833-96fd-805af711d76b",
    "slug": "ashraf-ibrahim-mohamed",
    "name": "Ashraf Ibrahim Mohamed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/17/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ashraf Ibrahim Mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_99c971ac-cd9e-4833-96fd-805af711d76b",
        "address": "",
        "phone": "97144073901 / 971503479508",
        "email": "Rania.Tadros@stephensonharwood.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dd5042a2-bb41-4123-9544-79c3fa831332",
    "firmName": "Stephenson Harwood (Middle East) LLP",
    "registrationNumber": "L-02585",
    "licenseIssueDate": "08/17/2014 00:00:00",
    "licenseExpiryDate": "08/11/2026 00:00:00"
  },
  {
    "id": "2da700d3-9e8e-4027-a387-54de1ef4d73e",
    "slug": "ashraf-konsowa",
    "name": "Ashraf Konsowa",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/04/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ashraf Konsowa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2da700d3-9e8e-4027-a387-54de1ef4d73e",
        "address": "",
        "phone": "97142500717",
        "email": "alishamrilawfirm@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e22c751b-e66d-497c-b5ee-3df32eab4831",
    "firmName": "ALI AL SHIMMARI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03565",
    "licenseIssueDate": "01/04/2017 00:00:00",
    "licenseExpiryDate": "12/31/2025 00:00:00"
  },
  {
    "id": "a46e56ff-b1cd-4fb5-8804-337451ee2add",
    "slug": "ashraf-rouby-latif-aboseif",
    "name": "Ashraf Rouby Latif Aboseif",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/26/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ashraf Rouby Latif Aboseif",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a46e56ff-b1cd-4fb5-8804-337451ee2add",
        "address": "21 ,Rolex Tower ,Emirates Grand Hotel ,94334 ,Dubai",
        "phone": "97143277772 / 97145584900",
        "email": "info@globaladvocates.net",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9b42810f-1d55-4aea-ac4a-7d9d1b25ac08",
    "firmName": "GLOBAL ADVOCACY & LEGAL COUNSEL",
    "registrationNumber": "L-05570",
    "licenseIssueDate": "10/26/2022 00:00:00",
    "licenseExpiryDate": "10/25/2025 00:00:00"
  },
  {
    "id": "4027f828-f60b-4656-94f5-65c8a2d7d4ef",
    "slug": "ashraf-sabri-ali",
    "name": "Ashraf Sabri Ali",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/01/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ashraf Sabri Ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4027f828-f60b-4656-94f5-65c8a2d7d4ef",
        "address": "3-505 ,AL KHABEESI BLDG ,AL KABEESI ,4948 ,Dubai",
        "phone": "97142222228",
        "email": "info@alkamali.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "054f38f4-9e51-4623-ad36-7941043a051c",
    "firmName": "AL KAMALI & COMPANY ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-02614",
    "licenseIssueDate": "07/01/2014 00:00:00",
    "licenseExpiryDate": "06/25/2026 00:00:00"
  },
  {
    "id": "96ecac51-6c6e-4102-a8f9-74c2f96ac63c",
    "slug": "ashwin-gopakumar",
    "name": "Ashwin Gopakumar",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/16/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ashwin Gopakumar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_96ecac51-6c6e-4102-a8f9-74c2f96ac63c",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-06867",
    "licenseIssueDate": "06/16/2025 00:00:00",
    "licenseExpiryDate": "06/15/2026 00:00:00"
  },
  {
    "id": "f763287e-225c-4a2a-9ec6-3cb4772aa6e1",
    "slug": "ashwin-raj-rajendra-kumar-bala-krishnan",
    "name": "Ashwin Raj Rajendra Kumar Bala Krishnan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/10/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ashwin Raj Rajendra Kumar Bala Krishnan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f763287e-225c-4a2a-9ec6-3cb4772aa6e1",
        "address": "",
        "phone": "97142776075 / 971588324788",
        "email": "avichal@kochhardubai.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "847eff7c-4142-431e-a8d6-f58ff60964f6",
    "firmName": "Kochhar & Co Inc Legal Consultants (Dubai Branch)",
    "registrationNumber": "L-06956",
    "licenseIssueDate": "09/02/2025 00:00:00",
    "licenseExpiryDate": "09/01/2026 00:00:00"
  },
  {
    "id": "9e2d6b43-4168-46d2-9c96-408be4a132c1",
    "slug": "asim-abdelgadir-ba-biker",
    "name": "Asim Abdelgadir Ba Biker",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Asim Abdelgadir Ba Biker",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9e2d6b43-4168-46d2-9c96-408be4a132c1",
        "address": "",
        "phone": "97143685555",
        "email": "maisa.maarouf@bsabh.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8afa232f-52ff-4dad-82c3-9a04d66eb853",
    "firmName": "B S A AHMED BIN HAZEEM & ASSOCIATES LLP - DIFC",
    "registrationNumber": "L-01626",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "61dfe5a9-afa8-45a9-8706-abfcc40ea1b2",
    "slug": "asma-siddiqui",
    "name": "Asma Siddiqui",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/08/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-04-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Asma Siddiqui",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_61dfe5a9-afa8-45a9-8706-abfcc40ea1b2",
        "address": "",
        "phone": "97143685555",
        "email": "maisa.maarouf@bsabh.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8afa232f-52ff-4dad-82c3-9a04d66eb853",
    "firmName": "B S A AHMED BIN HAZEEM & ASSOCIATES LLP - DIFC",
    "registrationNumber": "L-03619",
    "licenseIssueDate": "02/08/2017 00:00:00",
    "licenseExpiryDate": "02/04/2026 00:00:00"
  },
  {
    "id": "4ea7646c-6edc-4cbd-bf92-aabba95ff5f2",
    "slug": "asmaa-mohamed-abdelsalam-abdelmegid-badawy",
    "name": "Asmaa Mohamed Abdelsalam Abdelmegid Badawy",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/03/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Asmaa Mohamed Abdelsalam Abdelmegid Badawy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4ea7646c-6edc-4cbd-bf92-aabba95ff5f2",
        "address": "",
        "phone": "97104309100 / 971564013758",
        "email": "c.royle@taylorwessing.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d51b6f43-8c62-486f-a1ab-6ee3b87c8006",
    "firmName": "Taylor Wessing LLP (Dubai Branch)",
    "registrationNumber": "L-06743",
    "licenseIssueDate": "03/27/2025 00:00:00",
    "licenseExpiryDate": "03/26/2026 00:00:00"
  },
  {
    "id": "6dd795a8-04f1-4890-8b38-4b2172eb0627",
    "slug": "assad-bishara",
    "name": "ASSAD BISHARA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/18/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ASSAD BISHARA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6dd795a8-04f1-4890-8b38-4b2172eb0627",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-06063",
    "licenseIssueDate": "10/18/2023 00:00:00",
    "licenseExpiryDate": "10/17/2026 00:00:00"
  },
  {
    "id": "0fbd4b96-1d53-44d3-9a5f-dff078f73b1f",
    "slug": "atef-abosaif",
    "name": "Atef Abosaif",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/04/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Atef Abosaif",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0fbd4b96-1d53-44d3-9a5f-dff078f73b1f",
        "address": "",
        "phone": "97142942616",
        "email": "info@ilofficeuae.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "48ef4874-8647-4fb6-bedd-ffbad25accd1",
    "firmName": "KHALID KALANDAR ALMAAZMI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-01388",
    "licenseIssueDate": "10/04/2012 00:00:00",
    "licenseExpiryDate": "09/26/2026 00:00:00"
  },
  {
    "id": "9ffc5970-882d-4414-ab9d-1f8154138532",
    "slug": "atif-gasm-alla-mukhtar-karmalla",
    "name": "Atif Gasm Alla Mukhtar Karmalla",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/30/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Atif Gasm Alla Mukhtar Karmalla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9ffc5970-882d-4414-ab9d-1f8154138532",
        "address": "",
        "phone": "97142770003",
        "email": "info@hbhadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "f074c445-924d-40b2-9832-0b0a040c4e63",
    "firmName": "HAIDER BIN HAIDER ADVOCATES AND LEGAL CONSULTANT",
    "registrationNumber": "L-05998",
    "licenseIssueDate": "08/30/2023 00:00:00",
    "licenseExpiryDate": "08/29/2026 00:00:00"
  },
  {
    "id": "7c571f5f-940a-426c-9076-1380e9342838",
    "slug": "atiq-anjarwalla",
    "name": "Atiq Anjarwalla",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Atiq Anjarwalla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7c571f5f-940a-426c-9076-1380e9342838",
        "address": "",
        "phone": "97144529091 / 971552805308",
        "email": "ashafi@ach-legal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4f3e1e80-c812-4585-9570-229cd96776a4",
    "firmName": "Anjarwalla, Collins and Haidermota Legal Consultants",
    "registrationNumber": "L-01022",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "24f5ea27-f642-492f-ab9f-73e40341ace7",
    "slug": "attia-mohamed-ali-eltayyar",
    "name": "Attia Mohamed Ali Eltayyar",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/16/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Attia Mohamed Ali Eltayyar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_24f5ea27-f642-492f-ab9f-73e40341ace7",
        "address": "mansoor lootah ,مطعم شيلز ,صالح بن لاحج , مطعم شيلز  ,95151 ,Dubai",
        "phone": "97142833337 / 971559596445",
        "email": "info@mansoorlootahadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4488ad94-e6b8-4b33-8e21-04e8986bf218",
    "firmName": "MANSOOR LOTAAH ADVOCATES &LEGAL CONSULTANCY",
    "registrationNumber": "L-06554",
    "licenseIssueDate": "10/16/2024 00:00:00",
    "licenseExpiryDate": "10/15/2025 00:00:00"
  },
  {
    "id": "ad6206ff-e2f5-4344-ab1b-0b2c3da3640a",
    "slug": "attia-mohamed-attia-elmoghazy-ali",
    "name": "attia mohamed attia elmoghazy ali",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/31/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: attia mohamed attia elmoghazy ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ad6206ff-e2f5-4344-ab1b-0b2c3da3640a",
        "address": "IBRAHIM ,الاول 107 ,مبني العويس المطار ,بنايه بيزنس افينو ,41334 ,Dubai",
        "phone": "97142566888",
        "email": "info@ihadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "20341bc8-5500-4b12-a88b-d8341d03d88c",
    "firmName": "IBRAHIM HADDAD ADVOCATES AND LEGAL CONSULTANCY",
    "registrationNumber": "L-05494",
    "licenseIssueDate": "08/31/2022 00:00:00",
    "licenseExpiryDate": "08/30/2026 00:00:00"
  },
  {
    "id": "e7896f45-718d-428c-a647-917cae19cd87",
    "slug": "attwa-hussain",
    "name": "Attwa Hussain",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/26/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Attwa Hussain",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e7896f45-718d-428c-a647-917cae19cd87",
        "address": "Noura Mohamed Abdelrahman Almaazmi ,17 ,The Oberoi Center ,Burlington Tower ,414224 ,Dubai",
        "phone": "97143215777",
        "email": "case@almaazmilawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e56938ba-8d38-4268-9706-651d4c984db9",
    "firmName": "NOURA ALMAAZMI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-03221",
    "licenseIssueDate": "03/26/2025 00:00:00",
    "licenseExpiryDate": "03/25/2026 00:00:00"
  },
  {
    "id": "1cde89f6-3158-4f26-83db-00987141d732",
    "slug": "authug-sultan-m-alshehail",
    "name": "AUTHUG SULTAN M ALSHEHAIL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/04/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2023-02-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: AUTHUG SULTAN M ALSHEHAIL",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1cde89f6-3158-4f26-83db-00987141d732",
        "address": "MOHAMMED ALI SALMAN AL MARZOOQI ,الثالث  ,السركال  ,معرض سيارات الفطيم  ,39059 ,Dubai",
        "phone": "97142500008",
        "email": "adv.saad@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6bba829c-0392-4c72-a71b-01da72cb24ae",
    "firmName": "MOHAMED SALMAN ADVOCATE & LEGAL CONSULTANCY",
    "registrationNumber": "L-04220",
    "licenseIssueDate": "10/04/2018 00:00:00",
    "licenseExpiryDate": "10/02/2023 00:00:00"
  },
  {
    "id": "aa6dfeb8-efdf-4877-9c25-ef88779cd718",
    "slug": "avichal-prasad-ashutosh-prasad",
    "name": "Avichal Prasad Ashutosh Prasad",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/08/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Avichal Prasad Ashutosh Prasad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_aa6dfeb8-efdf-4877-9c25-ef88779cd718",
        "address": "",
        "phone": "97142776075 / 971588324788",
        "email": "avichal@kochhardubai.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "847eff7c-4142-431e-a8d6-f58ff60964f6",
    "firmName": "Kochhar & Co Inc Legal Consultants (Dubai Branch)",
    "registrationNumber": "L-05366",
    "licenseIssueDate": "06/08/2022 00:00:00",
    "licenseExpiryDate": "06/07/2026 00:00:00"
  },
  {
    "id": "caa55178-6d20-4e0a-9473-4b0e0dddb547",
    "slug": "avinash-poorooye",
    "name": "Avinash Poorooye",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/26/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Avinash Poorooye",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_caa55178-6d20-4e0a-9473-4b0e0dddb547",
        "address": "Index Tower ,506548 ,Dubai",
        "phone": "97147096300 / 971506767433",
        "email": "amateen@reedsmith.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b3f87e90-7ce9-4097-82c4-15232365f175",
    "firmName": "Reed Smith LLP",
    "registrationNumber": "L-05923",
    "licenseIssueDate": "07/26/2023 00:00:00",
    "licenseExpiryDate": "07/25/2026 00:00:00"
  },
  {
    "id": "41f2a8a0-46ec-4afa-8050-3d53fe365dc8",
    "slug": "avni-chordia-arun-kumar-chordia",
    "name": "Avni Chordia Arun Kumar Chordia",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/13/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Avni Chordia Arun Kumar Chordia",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_41f2a8a0-46ec-4afa-8050-3d53fe365dc8",
        "address": "",
        "phone": "97143553146 / 971506240472",
        "email": "ct@trenchlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4a6253d9-d6c0-479e-81a8-dcfe44ef60fa",
    "firmName": "Trench & Associates DMCC",
    "registrationNumber": "L-06017",
    "licenseIssueDate": "09/13/2023 00:00:00",
    "licenseExpiryDate": "09/12/2026 00:00:00"
  },
  {
    "id": "02e48e1f-2937-4027-ac63-e91f958120be",
    "slug": "avni-priyadarshi-ajay-priyadarshi",
    "name": "Avni Priyadarshi Ajay Priyadarshi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/21/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Avni Priyadarshi Ajay Priyadarshi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_02e48e1f-2937-4027-ac63-e91f958120be",
        "address": "Al Fattan Currency House Tower 2 ,DIFC ,507176 ,",
        "phone": "/ 971552009003",
        "email": "Mohammad.AlRasheed@bakermckenzie.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "acd81e81-dead-4f7c-839e-0f2a57897265",
    "firmName": "Baker & Mckenzie LLP",
    "registrationNumber": "L-06215",
    "licenseIssueDate": "02/21/2024 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "dd0f6926-3eca-4e7c-bf2b-86eb4b5886f4",
    "slug": "awad-el-karim-mohamed-ali-awad-el-karim",
    "name": "Awad El Karim Mohamed Ali Awad El Karim",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/18/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Awad El Karim Mohamed Ali Awad El Karim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dd0f6926-3eca-4e7c-bf2b-86eb4b5886f4",
        "address": "MOHAMMED NEKHAIRA ALDHAHERI ADVOCATES AND LEGAL CONSULTANT ,16 ,IRIS BAY ,ZOOM ,28177 ,Dubai",
        "phone": "97143323231 / 97143323231",
        "email": "Info@binnakhira.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c9f7542e-9b4a-43f5-bfc5-ec984563c41c",
    "firmName": "MOHAMMED NEKHIRA ALDHAHERI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02142",
    "licenseIssueDate": "09/18/2013 00:00:00",
    "licenseExpiryDate": "09/11/2026 00:00:00"
  },
  {
    "id": "8cda994f-7076-4b87-991c-25e31fe05cd1",
    "slug": "awad-mohamed-awad-jheen",
    "name": "Awad Mohamed Awad Jheen",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/18/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Awad Mohamed Awad Jheen",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8cda994f-7076-4b87-991c-25e31fe05cd1",
        "address": "Gamal Yassein Abdalla ,الطابق 13  Floor No 13 ,بناية مركز ابروي (The Oberoi Center) ,فندق ابروي (The Oberoi Hotel) ,33299 ,Dubai",
        "phone": "97142828000",
        "email": "litigation@alaidarous.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9a923766-1fd1-4e06-a871-89662120384e",
    "firmName": "AL AIDAROUS ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-02154",
    "licenseIssueDate": "12/18/2011 00:00:00",
    "licenseExpiryDate": "12/09/2025 00:00:00"
  },
  {
    "id": "27d06e9b-cf4a-4629-bfca-e97ee94478b5",
    "slug": "awale-ali-deria",
    "name": "Awale Ali Deria",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/11/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Awale Ali Deria",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_27d06e9b-cf4a-4629-bfca-e97ee94478b5",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-06847",
    "licenseIssueDate": "06/11/2025 00:00:00",
    "licenseExpiryDate": "06/10/2026 00:00:00"
  },
  {
    "id": "5386a868-c0cc-4138-a1c2-e403c0de2d83",
    "slug": "aws-younus",
    "name": "Aws Younus",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/11/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Aws Younus",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5386a868-c0cc-4138-a1c2-e403c0de2d83",
        "address": "SUHAD FADHIL JABBAR MAHADI ALJUBOORI  ,1602 ,ذا اتش ,المركز التجارى الاول  ,99827 ,Dubai",
        "phone": "97142711100 / 971508661717",
        "email": "sj@suhadaljuboorilawfirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "762ae1a5-2cc6-418c-a6fd-6e195fe7234d",
    "firmName": "SUHAD ALJUBOORI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01662",
    "licenseIssueDate": "04/11/2023 00:00:00",
    "licenseExpiryDate": "04/10/2026 00:00:00"
  },
  {
    "id": "dabfe26b-e005-4da3-a9dc-a70af3bec0e4",
    "slug": "ayesha-najeeb-najeeb-ur-rehman",
    "name": "Ayesha Najeeb Najeeb Ur Rehman",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/08/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ayesha Najeeb Najeeb Ur Rehman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dabfe26b-e005-4da3-a9dc-a70af3bec0e4",
        "address": "O-4801, O-4901 ,Burj al Salam Office Tower ,H Hotel ,111801 ,Dubai",
        "phone": "97143544444",
        "email": "administration@horizlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4e25fb39-6659-44f0-bc8b-3ff0f067beb0",
    "firmName": "HORIZONS & CO - LAW FIRM",
    "registrationNumber": "L-06302",
    "licenseIssueDate": "05/08/2024 00:00:00",
    "licenseExpiryDate": "05/07/2026 00:00:00"
  },
  {
    "id": "81fc95fa-d8b5-4087-b9a2-5c5016145640",
    "slug": "ayesha-zia-zia-uddin",
    "name": "Ayesha Zia Zia Uddin",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBWgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/26/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ayesha Zia Zia Uddin",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_81fc95fa-d8b5-4087-b9a2-5c5016145640",
        "address": "sohail jassem pararin ,34 ,Central Park Tower ,Dubai Mall ,233066 ,Dubai",
        "phone": "97144228410",
        "email": "info@mahmoodhussain.net",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "f3309481-3edd-4503-92d2-bd9f71ba513a",
    "firmName": "MAHMOOD HUSSAIN ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-05911",
    "licenseIssueDate": "07/26/2023 00:00:00",
    "licenseExpiryDate": "07/25/2026 00:00:00"
  },
  {
    "id": "c8364f17-c657-49bf-85c6-f15eeb880ec4",
    "slug": "ayeshah-fatima-faisal-alam-muhammad-faisal-kamal-alam",
    "name": "Ayeshah Fatima Faisal Alam Muhammad Faisal Kamal Alam",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/08/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ayeshah Fatima Faisal Alam Muhammad Faisal Kamal Alam",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c8364f17-c657-49bf-85c6-f15eeb880ec4",
        "address": "",
        "phone": "97144529091 / 971552805308",
        "email": "ashafi@ach-legal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4f3e1e80-c812-4585-9570-229cd96776a4",
    "firmName": "Anjarwalla, Collins and Haidermota Legal Consultants",
    "registrationNumber": "L-06301",
    "licenseIssueDate": "05/08/2024 00:00:00",
    "licenseExpiryDate": "05/07/2026 00:00:00"
  },
  {
    "id": "35f768f8-7523-4f32-95bf-ed5c68d7a5e8",
    "slug": "ayham-adnan-al-choufi",
    "name": "Ayham Adnan Al choufi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/22/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ayham Adnan Al choufi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_35f768f8-7523-4f32-95bf-ed5c68d7a5e8",
        "address": "",
        "phone": "",
        "email": "info@abeeradvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "1bb062dc-0c34-48e7-ae21-6d47ad68302f",
    "firmName": "ABEER MUSABBAH OBAID ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04118",
    "licenseIssueDate": "09/22/2020 00:00:00",
    "licenseExpiryDate": "09/21/2026 00:00:00"
  },
  {
    "id": "46472060-d3d1-48de-8055-68d6ad477930",
    "slug": "ayman-abdelghani",
    "name": "Ayman Abdelghani",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ayman Abdelghani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_46472060-d3d1-48de-8055-68d6ad477930",
        "address": "Hussain Ali Al Jaziri ,11 ,City Tower 2 ,Crown Plaza hotel Sheikh Zayed Road ,4253 ,Dubai",
        "phone": "97142626777 / 971529087670",
        "email": "courts@jaflaws.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c58d8654-b428-46b3-abd5-024e4331ee53",
    "firmName": "JAAFAR ALWAN & AL JAZIRI & ASSOCIATES",
    "registrationNumber": "L-01615",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "a385b451-edc3-4402-984d-96ba9a5d9bd5",
    "slug": "ayman-abdel-khaleq",
    "name": "Ayman Abdel-Khaleq",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/17/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ayman Abdel-Khaleq",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a385b451-edc3-4402-984d-96ba9a5d9bd5",
        "address": "",
        "phone": "97143121800 / 971566017967",
        "email": "alishia.sullivan@morganlewis.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6eab20d7-8716-4b0a-8710-144d1d951c23",
    "firmName": "Morgan, Lewis & Bockius LLP (dubai Branch)",
    "registrationNumber": "L-00514",
    "licenseIssueDate": "09/17/2014 00:00:00",
    "licenseExpiryDate": "09/11/2026 00:00:00"
  },
  {
    "id": "c2ce391f-b2e0-401a-aa3c-dbbc9eb16b3c",
    "slug": "ayman-abdulla-awdah-albayaa",
    "name": "Ayman Abdulla Awdah Albayaa",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/17/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ayman Abdulla Awdah Albayaa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c2ce391f-b2e0-401a-aa3c-dbbc9eb16b3c",
        "address": "",
        "phone": "97143212555",
        "email": "awigdubai@awiglaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ece8ea60-9ecb-4d8c-aca3-fb73e4e52406",
    "firmName": "AL WASL INTERNATIONAL GROUP - ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01950",
    "licenseIssueDate": "11/17/2011 00:00:00",
    "licenseExpiryDate": "11/08/2025 00:00:00"
  },
  {
    "id": "86404bae-40e2-48f3-8732-b840c2f7756c",
    "slug": "ayman-ahmed-diab",
    "name": "Ayman Ahmed Diab",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/29/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ayman Ahmed Diab",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_86404bae-40e2-48f3-8732-b840c2f7756c",
        "address": "",
        "phone": "97144230000 / 971552009022",
        "email": "UAE-CourtClerks@habibalmulla.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3eba82bb-8ec4-4cbd-80d0-a793cb993fde",
    "firmName": "Habib Al Mulla & Partners ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02065",
    "licenseIssueDate": "11/29/2011 00:00:00",
    "licenseExpiryDate": "11/20/2025 00:00:00"
  },
  {
    "id": "f9718722-63e9-483d-a165-ee00a1dca2f5",
    "slug": "ayman-al-hussiny-alashry",
    "name": "Ayman Al Hussiny Alashry",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/20/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ayman Al Hussiny Alashry",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f9718722-63e9-483d-a165-ee00a1dca2f5",
        "address": "الطابق 14  ,برج 48 جيت  ,محطة مترو دبي  ,413633 ,Dubai",
        "phone": "97144412031",
        "email": "courts@adglegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4287f048-dc0c-4d51-9e0c-0c23356040ee",
    "firmName": "B S A AHMED BIN HAZEEM & ASSOCIATES LLP - DIFC",
    "registrationNumber": "L-01991",
    "licenseIssueDate": "10/20/2011 00:00:00",
    "licenseExpiryDate": "10/11/2026 00:00:00"
  },
  {
    "id": "5af6364d-c56b-4800-8e2e-b8f6a58b6f3b",
    "slug": "ayman-ali-abdalla-mohamed",
    "name": "Ayman Ali Abdalla Mohamed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/21/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ayman Ali Abdalla Mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5af6364d-c56b-4800-8e2e-b8f6a58b6f3b",
        "address": "mohamed mahmoud mohamed elkormany ,بناية الوصل ,R549 يناية الوصل ,سيتي سنتر ديره ,83620 ,Dubai",
        "phone": "97142542000",
        "email": "info@aaalegalconsultants.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "927c60c9-145e-4bb5-8913-d6d6aa72f891",
    "firmName": "ABDALLA ALNAKHI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05686",
    "licenseIssueDate": "12/21/2022 00:00:00",
    "licenseExpiryDate": "12/20/2025 00:00:00"
  },
  {
    "id": "e53a0456-5b85-4911-beb6-b1056c949538",
    "slug": "ayman-fouad-ibrahim-elmorsy",
    "name": "Ayman Fouad Ibrahim Elmorsy",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/19/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ayman Fouad Ibrahim Elmorsy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e53a0456-5b85-4911-beb6-b1056c949538",
        "address": "Noura Mohamed Abdelrahman Almaazmi ,17 ,The Oberoi Center ,Burlington Tower ,414224 ,Dubai",
        "phone": "97143215777",
        "email": "case@almaazmilawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e56938ba-8d38-4268-9706-651d4c984db9",
    "firmName": "NOURA ALMAAZMI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-04348",
    "licenseIssueDate": "03/19/2019 00:00:00",
    "licenseExpiryDate": "03/17/2026 00:00:00"
  },
  {
    "id": "efb078dc-be14-4298-b747-3fc039d8466a",
    "slug": "ayman-ibrahim",
    "name": "Ayman Ibrahim",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/03/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ayman Ibrahim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_efb078dc-be14-4298-b747-3fc039d8466a",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-03549",
    "licenseIssueDate": "11/03/2016 00:00:00",
    "licenseExpiryDate": "10/30/2026 00:00:00"
  },
  {
    "id": "c467eb2f-f179-4894-be0c-201e4848a5d4",
    "slug": "ayman-ibrahim-alkhalidi",
    "name": "AYMAN IBRAHIM KHALIFEH ALKHALIDI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/02/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-01-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ayman Ibrahim Alkhalidi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c467eb2f-f179-4894-be0c-201e4848a5d4",
        "address": "الطابق 7 مكتب رقم 070A ,برج رولكس  ,محطة مترو المركز المالي  ,66300 ,Dubai",
        "phone": "97143444029",
        "email": "ekp.khalidaltmimi@ekplegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "400838f1-4e75-4836-9698-b9e19dd30a18",
    "firmName": "KHALID ABDALLA ALTAMIMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03091",
    "licenseIssueDate": "02/03/2015 00:00:00",
    "licenseExpiryDate": "01/29/2020 00:00:00"
  },
  {
    "id": "c4425680-4ed4-4e6c-a901-334a4898118d",
    "slug": "ayman-mhd-dib-al-bakouni",
    "name": "Ayman Mhd Dib Al Bakouni",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/19/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ayman Mhd Dib Al Bakouni",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c4425680-4ed4-4e6c-a901-334a4898118d",
        "address": "",
        "phone": "97148812191 / 971526343439",
        "email": "info@aqadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "bd7685ea-a57c-4a81-8b1b-d6c690263d86",
    "firmName": "ASHWAQ QAID ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06720",
    "licenseIssueDate": "03/19/2025 00:00:00",
    "licenseExpiryDate": "03/18/2026 00:00:00"
  },
  {
    "id": "83ffa84b-cc43-4b6e-a189-d7dd59473f2c",
    "slug": "ayman-mohamed-ahmed-hamam",
    "name": "AYMAN MOHAMED AHMED HAMAM",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/01/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-01-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ayman mohamed ahmed hamam",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_83ffa84b-cc43-4b6e-a189-d7dd59473f2c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-03970",
    "licenseIssueDate": "01/16/2018 00:00:00",
    "licenseExpiryDate": "01/15/2019 00:00:00"
  },
  {
    "id": "f96066ec-16c5-4749-b6af-0fa4459b498e",
    "slug": "ayman-o-m-awamleh",
    "name": "Ayman O M Awamleh",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/12/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ayman O M Awamleh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f96066ec-16c5-4749-b6af-0fa4459b498e",
        "address": "",
        "phone": "97145686887 / 971566651137",
        "email": "info@case-laws.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "473600a9-e063-4cba-8a12-b6f05db35951",
    "firmName": "RASHED ABDULLA ALHEFEITI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05296",
    "licenseIssueDate": "04/12/2022 00:00:00",
    "licenseExpiryDate": "04/11/2026 00:00:00"
  },
  {
    "id": "dee47c04-86ab-464f-b8b5-df4849fa4708",
    "slug": "aysha-adel-abdulaziz-mohd-khadem-alawadhi",
    "name": "Aysha Adel Abdulaziz Mohd. Khadem Alawadhi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/09/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Aysha Adel Abdulaziz Mohd. Khadem Alawadhi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dee47c04-86ab-464f-b8b5-df4849fa4708",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-06960",
    "licenseIssueDate": "09/17/2025 00:00:00",
    "licenseExpiryDate": "09/16/2026 00:00:00"
  },
  {
    "id": "d563062c-ef72-4717-b70a-c9c4595ed27b",
    "slug": "ayush-sharma",
    "name": "Ayush Sharma",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/14/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ayush Sharma",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d563062c-ef72-4717-b70a-c9c4595ed27b",
        "address": "- ,Index Tower ,Dubai International Financial Centre ,9371 ,Dubai",
        "phone": "97143303900 / 971561753537",
        "email": "christopher@afridi-angell.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3e464dc8-b800-4ba2-ad91-24a5f9640fef",
    "firmName": "Afridi & Angell-DIFC",
    "registrationNumber": "L-05493",
    "licenseIssueDate": "09/14/2022 00:00:00",
    "licenseExpiryDate": "09/13/2026 00:00:00"
  },
  {
    "id": "17fb61aa-b1ce-4061-a4ac-47f67f47db19",
    "slug": "aziz-yasin",
    "name": "Aziz Yasin",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/06/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Aziz Yasin",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_17fb61aa-b1ce-4061-a4ac-47f67f47db19",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-05566",
    "licenseIssueDate": "10/06/2022 00:00:00",
    "licenseExpiryDate": "10/05/2026 00:00:00"
  },
  {
    "id": "f7b740ce-54a8-4cd4-94cb-a757fe355371",
    "slug": "azza-osman",
    "name": "Azza Osman",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Azza Osman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f7b740ce-54a8-4cd4-94cb-a757fe355371",
        "address": "ادارة ا لمبنى  ,الريم ,الاتصالات  ,42423 ,Dubai",
        "phone": "97142222066",
        "email": "info@ozleco.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7a155f4a-20ec-44ff-863f-4f9fb43d0af4",
    "firmName": "ALOBAIDLI & ALZAROONI ADVOCATES&LEGAL CONSULTANTS",
    "registrationNumber": "L-01376",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "e42e6c23-86b8-4474-9ffa-34555c169c15",
    "slug": "babak-namazi",
    "name": "Babak Namazi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/09/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Babak Namazi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e42e6c23-86b8-4474-9ffa-34555c169c15",
        "address": "",
        "phone": "97144323671 / 971505589395",
        "email": "fba@amereller.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a139ca64-8897-4d1d-8d71-97446bc1e15a",
    "firmName": "Amereller Legal Consultancy LLC SOC",
    "registrationNumber": "L-00484",
    "licenseIssueDate": "01/09/2012 00:00:00",
    "licenseExpiryDate": "12/31/2025 00:00:00"
  },
  {
    "id": "bd818853-6de7-4793-8da3-7abda2594962",
    "slug": "babiker-omer-babiker",
    "name": "Babiker Omer Babiker",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Babiker Omer Babiker",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bd818853-6de7-4793-8da3-7abda2594962",
        "address": "",
        "phone": "97144472020",
        "email": "info@arnadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e6573267-5872-48d8-add1-06a3deccf9e4",
    "firmName": "ABDUL RAHMAN NASEEB ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01549",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "ae3fca9b-ed5a-4921-841c-44230136ebb7",
    "slug": "bader-a-n-a-eljeaan",
    "name": "Bader A N A Eljeaan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/12/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Bader A N A Eljeaan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ae3fca9b-ed5a-4921-841c-44230136ebb7",
        "address": "",
        "phone": "97100000000 / 971529999965",
        "email": "beljeaan@meysan.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "18d46314-9f85-4421-9ec3-09c58c01fb76",
    "firmName": "Meysan Lawyers and Legal Consultants WLL",
    "registrationNumber": "L-06604",
    "licenseIssueDate": "12/25/2024 00:00:00",
    "licenseExpiryDate": "12/24/2025 00:00:00"
  },
  {
    "id": "91bb1660-01e8-4741-b33a-4bd7b02daeeb",
    "slug": "bader-el-khoury",
    "name": "Bader El Khoury",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/17/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Bader El Khoury",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_91bb1660-01e8-4741-b33a-4bd7b02daeeb",
        "address": "الطابق 7 مكتب رقم 070A ,برج رولكس  ,محطة مترو المركز المالي  ,66300 ,Dubai",
        "phone": "97143444029",
        "email": "ekp.khalidaltmimi@ekplegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "400838f1-4e75-4836-9698-b9e19dd30a18",
    "firmName": "KHALID ABDALLA ALTAMIMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05701",
    "licenseIssueDate": "10/17/2024 00:00:00",
    "licenseExpiryDate": "10/16/2026 00:00:00"
  },
  {
    "id": "f1234547-b20b-45f8-b6e0-4c3f907bdbff",
    "slug": "badih-moukarzel",
    "name": "Badih Moukarzel",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Badih Moukarzel",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f1234547-b20b-45f8-b6e0-4c3f907bdbff",
        "address": "ABDULRAHMAN OMAR  ABDULLA MUKHAYER  ,NBK BANK ,LATIFA TOWER  ,NEAR CROWN PLAZA  ,185616 ,Dubai",
        "phone": "97143296968",
        "email": "hlp@hlplawfirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "617b9580-cff5-4ffa-b2bc-8788300a3c6e",
    "firmName": "AL HUQOOQ FOR ADVOCACY AND LEGAL CONSULTANCY",
    "registrationNumber": "L-01200",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "9fedbf62-6329-44f3-8a3c-552bbdb6f6a8",
    "slug": "badreldeen-elrasheed-abdall-elawad",
    "name": "badreldeen Elrasheed Abdall Elawad",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/14/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: badreldeen Elrasheed Abdall Elawad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9fedbf62-6329-44f3-8a3c-552bbdb6f6a8",
        "address": "",
        "phone": "97142555000",
        "email": "info@kha.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0e4b9f0a-83fc-45c9-b0d3-f38013690624",
    "firmName": "KHALIFA BIN HUWAIDAN ALKETBI ADVOCATES & LEGAL CONSULTANT",
    "registrationNumber": "L-06151",
    "licenseIssueDate": "12/14/2023 00:00:00",
    "licenseExpiryDate": "12/13/2025 00:00:00"
  },
  {
    "id": "2e222a08-cbad-4aca-82eb-19de6aa419fb",
    "slug": "bagyasree-nambron",
    "name": "Bagyasree Nambron",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/06/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Bagyasree Nambron",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2e222a08-cbad-4aca-82eb-19de6aa419fb",
        "address": "",
        "phone": "97143506800 / 971507244940",
        "email": "Chris.Williams@bracewelllaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "106d3ee7-86f2-4eae-9b49-fd8423095983",
    "firmName": "Bracewell LLP",
    "registrationNumber": "L-06116",
    "licenseIssueDate": "12/06/2023 00:00:00",
    "licenseExpiryDate": "12/05/2025 00:00:00"
  },
  {
    "id": "2d1da052-f43a-43f5-9c3d-4ac795bf598c",
    "slug": "bahaa-elsharkawy",
    "name": "Bahaa Elsharkawy",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/26/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Bahaa Elsharkawy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2d1da052-f43a-43f5-9c3d-4ac795bf598c",
        "address": "4th Floor/ Office no. 401 ,Business Avenue  ,Infront- Terminal 2  ,115263 ,Dubai",
        "phone": "97144518866",
        "email": "info@aldhaheriinternational.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "cf3c19c0-d396-4bcb-b1db-b81273ed0b4c",
    "firmName": "AL DHAHERI INTERNATIONAL ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03289",
    "licenseIssueDate": "09/26/2015 00:00:00",
    "licenseExpiryDate": "09/21/2026 00:00:00"
  },
  {
    "id": "0ebef35f-aad6-4e05-aa69-2040b38294a3",
    "slug": "bahez-talabani",
    "name": "Bahez Talabani",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/21/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Bahez Talabani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0ebef35f-aad6-4e05-aa69-2040b38294a3",
        "address": "Hamdan Abdullah Abdulrahman Ali Alharmi ,2 office 211 ,MSM 1 ,Auto Land Motors ,6064 ,Dubai",
        "phone": "97142999559",
        "email": "hamdan@harmilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b0830edc-21a4-4df9-9d83-febcab7756da",
    "firmName": "HAMDAN AL HARMI & ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06569",
    "licenseIssueDate": "10/21/2024 00:00:00",
    "licenseExpiryDate": "10/20/2026 00:00:00"
  },
  {
    "id": "306b5766-6c8e-4f66-a6b1-daa3c5bd7f52",
    "slug": "bahy-elshahat-abdelrazek-elgendy",
    "name": "Bahy Elshahat Abdelrazek Elgendy",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Bahy Elshahat Abdelrazek Elgendy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_306b5766-6c8e-4f66-a6b1-daa3c5bd7f52",
        "address": "1302/ مكتب 1302 ,فندق الفيرمونت ,محطة مترو المركز التجاري ,33026 ,Dubai",
        "phone": "97143586113",
        "email": "info@ablawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "f04c12ed-cc71-442c-b504-173bbb4d322f",
    "firmName": "AMAL ALSUBAEI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01410",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "90e3a40c-825f-4869-8ac4-cec43a6da2cc",
    "slug": "bakar-palavandishvili",
    "name": "Bakar Palavandishvili",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/06/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Bakar Palavandishvili",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_90e3a40c-825f-4869-8ac4-cec43a6da2cc",
        "address": "",
        "phone": "97143937700",
        "email": "info@galadarilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d863b662-c864-4193-8b3a-ff6ee5fe6c64",
    "firmName": "GALADARI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06131",
    "licenseIssueDate": "12/06/2023 00:00:00",
    "licenseExpiryDate": "12/05/2025 00:00:00"
  },
  {
    "id": "0c12622f-16d5-40e3-88ee-746217c8421b",
    "slug": "baligh-hamdi-abdelkader-abdelkader",
    "name": "baligh hamdi abdelkader abdelkader",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/07/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: baligh hamdi abdelkader abdelkader",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0c12622f-16d5-40e3-88ee-746217c8421b",
        "address": "6 ,latifa tower ,near crown plaza hotel  ,102999 ,Dubai",
        "phone": "97143799979",
        "email": "lawkmq@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b9d24779-27c2-4989-bf7f-4e73e5a670ff",
    "firmName": "KHALID BIN MOHAMMAD ALQASEMI ATTORNEY & LEGAL CONSULTANTS",
    "registrationNumber": "L-06784",
    "licenseIssueDate": "05/07/2025 00:00:00",
    "licenseExpiryDate": "05/06/2026 00:00:00"
  },
  {
    "id": "fbce9635-5e7c-46d4-a761-db434bab9f09",
    "slug": "balwinder-kaur-sagoo",
    "name": "Balwinder Kaur Sagoo",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/16/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Balwinder Kaur Sagoo",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fbce9635-5e7c-46d4-a761-db434bab9f09",
        "address": "3902 ,single business tower ,Sheikh Zayed Rd.  ,90077 ,Dubai",
        "phone": "97143804141 / 97143804141",
        "email": "info@united-advocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "52ebf695-ce46-4e03-abc9-f4d8d2f8a356",
    "firmName": "UNITED ADVOCATES",
    "registrationNumber": "L-05963",
    "licenseIssueDate": "08/16/2023 00:00:00",
    "licenseExpiryDate": "08/15/2026 00:00:00"
  },
  {
    "id": "05002cee-dd8c-45c1-ab4c-8320d92b1291",
    "slug": "barbara-wanda-kramarz",
    "name": "Barbara Wanda Kramarz",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/18/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Barbara Wanda Kramarz",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_05002cee-dd8c-45c1-ab4c-8320d92b1291",
        "address": "Level 14 ,Burj Daman ,Four Seasons Hotel ,119980 ,Dubai",
        "phone": "97143604070 / 971502450485",
        "email": "Philip.ireland@maples.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "cb7cc285-8538-469a-b075-ef30819bce69",
    "firmName": "Maples & Calder (Dubai) LLP",
    "registrationNumber": "L-05402",
    "licenseIssueDate": "07/18/2022 00:00:00",
    "licenseExpiryDate": "07/17/2026 00:00:00"
  },
  {
    "id": "282a84e5-2e6e-4984-b58f-bc6e461495d7",
    "slug": "barkha-doshi",
    "name": "Barkha Doshi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/26/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Barkha Doshi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_282a84e5-2e6e-4984-b58f-bc6e461495d7",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-04985",
    "licenseIssueDate": "07/26/2021 00:00:00",
    "licenseExpiryDate": "07/25/2026 00:00:00"
  },
  {
    "id": "0456aa40-f45a-4271-9969-6386d2621cd6",
    "slug": "bashir-abdelalim-moustafa",
    "name": "Bashir Abdelalim Moustafa",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/24/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Bashir Abdelalim Moustafa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0456aa40-f45a-4271-9969-6386d2621cd6",
        "address": "403 ,الطابق الاول مكتب 101 ,بناية الكنال سنترال ,اكاديمية هايونداي للتدريب  ,90209 ,Dubai",
        "phone": "97142970007",
        "email": "altdamon@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "1829252a-0804-4aaa-ad2a-4212e680346d",
    "firmName": "ALLIED ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02392",
    "licenseIssueDate": "04/24/2014 00:00:00",
    "licenseExpiryDate": "04/17/2026 00:00:00"
  },
  {
    "id": "f609e56a-cca8-4eec-a1b4-e42f4778b1b2",
    "slug": "bashir-ahmed",
    "name": "Bashir Ahmed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/16/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Bashir Ahmed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f609e56a-cca8-4eec-a1b4-e42f4778b1b2",
        "address": "",
        "phone": "97143303900 / 971561753537",
        "email": "christopher@afridi-angell.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "30ce50dc-01a6-499d-8ace-3f807ddcb08d",
    "firmName": "Afridi & Angell-DED",
    "registrationNumber": "L-00105",
    "licenseIssueDate": "12/16/2011 00:00:00",
    "licenseExpiryDate": "12/07/2025 00:00:00"
  },
  {
    "id": "d3035e53-786c-489e-adf7-8fdadf7f6eee",
    "slug": "basil-al-jafari",
    "name": "Basil Al Jafari",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/13/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Basil Al Jafari",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d3035e53-786c-489e-adf7-8fdadf7f6eee",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506698 ,Dubai",
        "phone": "97147046300 / 971507900661",
        "email": "nada.mourad@lw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b2b92ce9-90a4-4e34-ae2f-ae0dc7ca9060",
    "firmName": "Latham & Watkins LLP",
    "registrationNumber": "L-00873",
    "licenseIssueDate": "08/13/2018 00:00:00",
    "licenseExpiryDate": "08/11/2026 00:00:00"
  },
  {
    "id": "6b2bbb03-4005-4859-a3cd-d981ff4f3a69",
    "slug": "basma-abdelmaksoud-mohamed",
    "name": "Basma Abdelmaksoud Mohamed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/13/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Basma Abdelmaksoud Mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6b2bbb03-4005-4859-a3cd-d981ff4f3a69",
        "address": "110 ,بناية مكاتب عود ميثاء R338 ,مقابل وافى مول وفندق رافلز دبى ,624494 ,Dubai",
        "phone": "97143231881",
        "email": "info@alialhammadi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "373da443-20e8-461a-b11d-dba4d77f1b45",
    "firmName": "ALI ALHAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03442",
    "licenseIssueDate": "04/13/2023 00:00:00",
    "licenseExpiryDate": "04/12/2026 00:00:00"
  },
  {
    "id": "0f16e4c8-8304-41ad-9865-0be4ccd7f1a2",
    "slug": "bassam-elselk",
    "name": "Bassam Elselk",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/21/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Bassam Elselk",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0f16e4c8-8304-41ad-9865-0be4ccd7f1a2",
        "address": "4 ,Century 21 building ,al kabayel discount centre ,340781 ,Dubai",
        "phone": "97142417888 / 971562693277",
        "email": "dubai@khbinomair.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "34306e48-bd22-4b51-b883-2a538d4f1890",
    "firmName": "KHALIFA BIN OMAIR ADVOCATES & LEGAL CONSULTANT",
    "registrationNumber": "L-03220",
    "licenseIssueDate": "09/21/2023 00:00:00",
    "licenseExpiryDate": "09/20/2026 00:00:00"
  },
  {
    "id": "fddd575d-66b2-4bb3-9843-b8ba396800ca",
    "slug": "bassam-salah-abdal-rahman-al-azzeh",
    "name": "Bassam Salah Abdal Rahman Al Azzeh",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/20/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Bassam Salah Abdal Rahman Al Azzeh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fddd575d-66b2-4bb3-9843-b8ba396800ca",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04213",
    "licenseIssueDate": "09/20/2018 00:00:00",
    "licenseExpiryDate": "09/18/2026 00:00:00"
  },
  {
    "id": "2f5ed211-f577-4882-8219-a09fabe60f1e",
    "slug": "bassel-abdulmajid-ostwani",
    "name": "Bassel Abdulmajid Ostwani",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/04/2019",
    "licenseStatus": "active",
    "licenseExpiry": "2020-04-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Bassel Abdulmajid Ostwani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2f5ed211-f577-4882-8219-a09fabe60f1e",
        "address": "الطابق الثامن  ,برج الجرج 1 ,دائرة الاراضي و الاملاك  ,9117 ,Dubai",
        "phone": "97143320004",
        "email": "info@hlootahlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4ad67cb4-18b4-4417-9b6a-d23a9fb368fb",
    "firmName": "HUSSAIN LOOTAH & PARTNERS - ATTORNEYS & COUNSELLORS AT LAW",
    "registrationNumber": "L-04372",
    "licenseIssueDate": "04/04/2019 00:00:00",
    "licenseExpiryDate": "04/02/2026 00:00:00"
  },
  {
    "id": "3068c740-2b84-42b1-89d9-24e3d1460e63",
    "slug": "bassel-boulos-assaad-boutros",
    "name": "Bassel Boulos Assaad Boutros",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/22/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Bassel Boulos Assaad Boutros",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3068c740-2b84-42b1-89d9-24e3d1460e63",
        "address": "",
        "phone": "97143685555",
        "email": "maisa.maarouf@bsabh.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8afa232f-52ff-4dad-82c3-9a04d66eb853",
    "firmName": "B S A AHMED BIN HAZEEM & ASSOCIATES LLP - DIFC",
    "registrationNumber": "L-04859",
    "licenseIssueDate": "02/22/2021 00:00:00",
    "licenseExpiryDate": "02/21/2026 00:00:00"
  },
  {
    "id": "3672483c-3f18-4029-9146-8e9500287f7b",
    "slug": "bassel-el-turk",
    "name": "Bassel El Turk",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Bassel El Turk",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3672483c-3f18-4029-9146-8e9500287f7b",
        "address": "",
        "phone": "97143098000 / 971552210883",
        "email": "belturk@rouse.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "9df4d4e5-5243-4fae-8d95-463d110ce6a8",
    "firmName": "Rouse & Co International Limited (Dubai Branch)",
    "registrationNumber": "L-00444",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "2327b3b9-ebc9-49c1-bd03-0acf068f8691",
    "slug": "bassem-ehab-hussein-aly-ibrahim",
    "name": "Bassem Ehab Hussein Aly Ibrahim",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/27/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Bassem Ehab Hussein Aly Ibrahim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2327b3b9-ebc9-49c1-bd03-0acf068f8691",
        "address": "",
        "phone": "97144230000 / 971552009022",
        "email": "UAE-CourtClerks@habibalmulla.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3eba82bb-8ec4-4cbd-80d0-a793cb993fde",
    "firmName": "Habib Al Mulla & Partners ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05428",
    "licenseIssueDate": "07/27/2022 00:00:00",
    "licenseExpiryDate": "07/26/2026 00:00:00"
  },
  {
    "id": "7a5eb175-0b0e-4435-a77c-079632d65035",
    "slug": "bassem-pierre-daher",
    "name": "Bassem Pierre Daher",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/31/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Bassem Pierre Daher",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7a5eb175-0b0e-4435-a77c-079632d65035",
        "address": "",
        "phone": "97143937700",
        "email": "info@galadarilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d863b662-c864-4193-8b3a-ff6ee5fe6c64",
    "firmName": "GALADARI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04952",
    "licenseIssueDate": "05/31/2021 00:00:00",
    "licenseExpiryDate": "05/30/2026 00:00:00"
  },
  {
    "id": "f620241a-1fdb-4032-99a0-4984904bd53e",
    "slug": "batoul-abd-alhaseeb-orabi",
    "name": "batoul abd alhaseeb orabi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/12/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: batoul abd alhaseeb orabi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f620241a-1fdb-4032-99a0-4984904bd53e",
        "address": "YOUNIS MOHAMMED ALBLOOSHI ,3 - 1 ,the icon ,السيلكون ,117548 ,Dubai",
        "phone": "97145693206 / 971000000000",
        "email": "info@yblooshiadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "27278b02-4edf-490f-9d50-a1bc00678b6a",
    "firmName": "YOUNIS MOHAMMED AL BLOOSHI LAWYER & LEGAL CONSULTANTS",
    "registrationNumber": "L-06368",
    "licenseIssueDate": "06/12/2024 00:00:00",
    "licenseExpiryDate": "06/11/2026 00:00:00"
  },
  {
    "id": "1d66ae12-19aa-4957-8807-606ef769c7ea",
    "slug": "batoul-hani-hanafi-mhamoud-ahmed",
    "name": "Batoul Hani Hanafi Mhamoud Ahmed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/21/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Batoul Hani Hanafi Mhamoud Ahmed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1d66ae12-19aa-4957-8807-606ef769c7ea",
        "address": "15th Floor _ Office No. 1504 ,SOBHA SAPPHIRE ,Makani No: 2612485764 ,000 ,Dubai",
        "phone": "97145570789 / 971521800001",
        "email": "Info@iserkal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "196bb7bb-4be6-4029-9367-c100bd219d3f",
    "firmName": "IBRAHIM ALSERKAL ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06838",
    "licenseIssueDate": "05/21/2025 00:00:00",
    "licenseExpiryDate": "05/20/2026 00:00:00"
  },
  {
    "id": "13eec6c9-82df-4d87-bc5f-f331046457e7",
    "slug": "bayan-jafari-eshaiker",
    "name": "Bayan Jafari Eshaiker",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/30/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Bayan Jafari Eshaiker",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_13eec6c9-82df-4d87-bc5f-f331046457e7",
        "address": "",
        "phone": "97144020800 / 971566830829",
        "email": "dean.ryburn@dentons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dfe13b7e-6625-45fd-ad63-9ee83af41194",
    "firmName": "Dentons & Co Dubai Branch-DED",
    "registrationNumber": "L-05151",
    "licenseIssueDate": "12/30/2021 00:00:00",
    "licenseExpiryDate": "12/29/2025 00:00:00"
  },
  {
    "id": "9cfcba0f-7c09-4468-afa9-e3a739952376",
    "slug": "bedadutta-nag",
    "name": "Bedadutta Nag",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/26/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Bedadutta Nag",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9cfcba0f-7c09-4468-afa9-e3a739952376",
        "address": "Saeed Tower 2 ,Sheikh Zayed Road ,32045 ,",
        "phone": "97143518989 / 971506466213",
        "email": "ashish.mehta@amalawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "f39b81d1-9085-4c4e-a69b-3d9349f8f28c",
    "firmName": "Ashish Mehta & Associates Legal Consultants LLC",
    "registrationNumber": "L-02383",
    "licenseIssueDate": "04/26/2014 00:00:00",
    "licenseExpiryDate": "04/20/2026 00:00:00"
  },
  {
    "id": "9c741f4e-511b-4ae7-8a6b-37fbdac7dccd",
    "slug": "belinda-wilkinson-brady",
    "name": "Belinda Wilkinson Brady",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/09/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Belinda Wilkinson Brady",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9c741f4e-511b-4ae7-8a6b-37fbdac7dccd",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-06523",
    "licenseIssueDate": "10/09/2024 00:00:00",
    "licenseExpiryDate": "10/08/2026 00:00:00"
  },
  {
    "id": "80207417-7582-416c-885b-743bddbc6411",
    "slug": "ben-aaron-phillips",
    "name": "Ben Aaron Phillips",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/16/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ben Aaron Phillips",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_80207417-7582-416c-885b-743bddbc6411",
        "address": "Al Fattan Currency House Tower 2 ,DIFC ,507176 ,",
        "phone": "/ 971552009003",
        "email": "Mohammad.AlRasheed@bakermckenzie.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "acd81e81-dead-4f7c-839e-0f2a57897265",
    "firmName": "Baker & Mckenzie LLP",
    "registrationNumber": "L-06868",
    "licenseIssueDate": "06/16/2025 00:00:00",
    "licenseExpiryDate": "06/15/2026 00:00:00"
  },
  {
    "id": "fe0dd6eb-fe13-4e09-8b8f-42063a26cf80",
    "slug": "ben-matthew-gibson",
    "name": "Ben Matthew Gibson",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/26/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ben Matthew Gibson",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fe0dd6eb-fe13-4e09-8b8f-42063a26cf80",
        "address": "",
        "phone": "97143742800 / 971506450677",
        "email": "jabbott21@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7a59d310-ff72-4318-b41c-27095c163d0f",
    "firmName": "CMS (UAE) LLP",
    "registrationNumber": "L-04414",
    "licenseIssueDate": "05/26/2019 00:00:00",
    "licenseExpiryDate": "05/25/2026 00:00:00"
  },
  {
    "id": "24a2efc6-b217-4e6f-b13d-3c30dcb9234e",
    "slug": "ben-thomas",
    "name": "Ben Thomas",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/26/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ben Thomas",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_24a2efc6-b217-4e6f-b13d-3c30dcb9234e",
        "address": "6 ,Office Nos. 603, 604 & 605, Level 6, Burj Daman ,Dubai International Financial Centre ,506555 ,Dubai",
        "phone": "97143506400 / 971504654755",
        "email": "r.hickman@aglaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8690f7d5-6b96-4649-9589-71303f2c2707",
    "firmName": "Addleshaw Goddard (Middle East) LLP",
    "registrationNumber": "L-05163",
    "licenseIssueDate": "01/26/2022 00:00:00",
    "licenseExpiryDate": "01/25/2026 00:00:00"
  },
  {
    "id": "09815975-3024-48da-ab78-58f66da6c99b",
    "slug": "benjamin-alain-richard-ruffet",
    "name": "Benjamin Alain Richard Ruffet",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/22/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Benjamin Alain Richard Ruffet",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_09815975-3024-48da-ab78-58f66da6c99b",
        "address": "Index Tower ,DIFC ,506896 ,",
        "phone": "97142782300 / 971551154791",
        "email": "GLeggate@wfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e2b82cfc-80a5-4957-ae41-b1a7beb693c1",
    "firmName": "Watson, Farley & Williams (Middle East) LLP",
    "registrationNumber": "L-06314",
    "licenseIssueDate": "05/22/2024 00:00:00",
    "licenseExpiryDate": "05/21/2026 00:00:00"
  },
  {
    "id": "733c81d3-5b70-4522-b8d0-f48a6a94be5a",
    "slug": "benjamin-brown",
    "name": "Benjamin Brown",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/24/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Benjamin Brown",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_733c81d3-5b70-4522-b8d0-f48a6a94be5a",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-02712",
    "licenseIssueDate": "09/24/2014 00:00:00",
    "licenseExpiryDate": "09/18/2026 00:00:00"
  },
  {
    "id": "8492d73f-8a7b-4f5f-8d36-e10214bc794b",
    "slug": "benjamin-christian-blackman",
    "name": "Benjamin Christian Blackman",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/06/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Benjamin Christian Blackman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8492d73f-8a7b-4f5f-8d36-e10214bc794b",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506688 ,Dubai",
        "phone": "97147096600 / 971503556811",
        "email": "muneer.khan@simmons-simmons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d1725ca7-06ac-41b2-8d7b-a6e60665b73d",
    "firmName": "Simmons & Simmons (Middle East) LLP-DIFC",
    "registrationNumber": "L-06072",
    "licenseIssueDate": "11/06/2023 00:00:00",
    "licenseExpiryDate": "11/05/2025 00:00:00"
  },
  {
    "id": "28d3f7f2-30ea-48ff-819d-7290de6e52fe",
    "slug": "benjamin-daniel-gerard-suthers",
    "name": "Benjamin Daniel Gerard Suthers",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/06/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Benjamin Daniel Gerard Suthers",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_28d3f7f2-30ea-48ff-819d-7290de6e52fe",
        "address": "",
        "phone": "97144020800 / 971566830829",
        "email": "dean.ryburn@dentons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dfe13b7e-6625-45fd-ad63-9ee83af41194",
    "firmName": "Dentons & Co Dubai Branch-DED",
    "registrationNumber": "L-06575",
    "licenseIssueDate": "10/24/2024 00:00:00",
    "licenseExpiryDate": "10/23/2025 00:00:00"
  },
  {
    "id": "c7ed9365-4344-4bf4-b9e7-40ad167361fe",
    "slug": "benjamin-daniel-jones",
    "name": "Benjamin Daniel Jones",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/22/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Benjamin Daniel Jones",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c7ed9365-4344-4bf4-b9e7-40ad167361fe",
        "address": "",
        "phone": "97145953601 / 971508728645",
        "email": "Steven.Bainbridge@gtlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b4146aa6-efd1-41d7-819d-49da46353b0b",
    "firmName": "Greenberg Traurig Limited",
    "registrationNumber": "L-04782",
    "licenseIssueDate": "10/22/2020 00:00:00",
    "licenseExpiryDate": "10/21/2026 00:00:00"
  },
  {
    "id": "77eae360-1b62-45d9-806f-2e328a144154",
    "slug": "benjamin-ian-francis-sharpley",
    "name": "BENJAMIN IAN FRANCIS SHARPLEY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/19/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: BENJAMIN IAN FRANCIS SHARPLEY",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_77eae360-1b62-45d9-806f-2e328a144154",
        "address": "Hamdan Abdullah Abdulrahman Ali Alharmi ,2 office 211 ,MSM 1 ,Auto Land Motors ,6064 ,Dubai",
        "phone": "97142999559",
        "email": "hamdan@harmilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b0830edc-21a4-4df9-9d83-febcab7756da",
    "firmName": "HAMDAN AL HARMI & ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06165",
    "licenseIssueDate": "01/19/2024 00:00:00",
    "licenseExpiryDate": "01/18/2026 00:00:00"
  },
  {
    "id": "04c9d786-8d91-4e61-8c96-ba2225901231",
    "slug": "benjamin-james-williams",
    "name": "BENJAMIN JAMES WILLIAMS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/04/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: BENJAMIN JAMES WILLIAMS",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_04c9d786-8d91-4e61-8c96-ba2225901231",
        "address": "",
        "phone": "97143779900 / 971508548052",
        "email": "jali@kslaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dff8529a-82be-431a-b72b-0192ff238011",
    "firmName": "King & Spalding LLP",
    "registrationNumber": "L-04636",
    "licenseIssueDate": "03/04/2020 00:00:00",
    "licenseExpiryDate": "03/03/2026 00:00:00"
  },
  {
    "id": "0a34df8e-e392-40f2-9d45-abf06674c5d1",
    "slug": "benjamin-kenard-ward",
    "name": "Benjamin Kenard Ward",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/22/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Benjamin Kenard Ward",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0a34df8e-e392-40f2-9d45-abf06674c5d1",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-04242",
    "licenseIssueDate": "10/22/2018 00:00:00",
    "licenseExpiryDate": "10/20/2026 00:00:00"
  },
  {
    "id": "b1b77265-c6e0-4fad-a245-e7da333f8d03",
    "slug": "benjamin-kozica",
    "name": "Benjamin Kozica",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/28/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Benjamin Kozica",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b1b77265-c6e0-4fad-a245-e7da333f8d03",
        "address": "Boulevard Plaza Tower 2 ,Burj Khalifa ,23297 ,",
        "phone": "97142950020 / 971526443550",
        "email": "nicola.lohrey@roedl.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e92477d1-b4b2-4506-b1a4-99c4a9cfa443",
    "firmName": "Roedl & Partner (Dubai Branch)",
    "registrationNumber": "L-06839",
    "licenseIssueDate": "05/28/2025 00:00:00",
    "licenseExpiryDate": "05/27/2026 00:00:00"
  },
  {
    "id": "3e9ef781-440f-4a43-9ed2-2eb3deb770fd",
    "slug": "benjamin-robert-mellett",
    "name": "Benjamin Robert Mellett",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/04/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Benjamin Robert Mellett",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3e9ef781-440f-4a43-9ed2-2eb3deb770fd",
        "address": "ICD Brookfield Place ,Za'abeel 2 ,103747 ,",
        "phone": "97143696300 / 971506008159",
        "email": "mohammed.paracha@nortonrosefulbright.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c4aaee93-0ec4-4982-9a48-a23699492056",
    "firmName": "Norton Rose Fullbright (Middle East) LLP",
    "registrationNumber": "L-03912",
    "licenseIssueDate": "05/04/2023 00:00:00",
    "licenseExpiryDate": "05/03/2026 00:00:00"
  },
  {
    "id": "6ea222f9-1f2e-455b-93c0-f2dddf886091",
    "slug": "benjamin-sherwood-haley",
    "name": "Benjamin Sherwood Haley",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/06/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Benjamin Sherwood Haley",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6ea222f9-1f2e-455b-93c0-f2dddf886091",
        "address": "",
        "phone": "97142472100 / 971509224336",
        "email": "bhaley@cov.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "65a2e90a-6978-4292-b3f1-ecbebedd7b9a",
    "firmName": "Covington & Burling LLP (Middle East)",
    "registrationNumber": "L-05987",
    "licenseIssueDate": "09/06/2023 00:00:00",
    "licenseExpiryDate": "09/05/2026 00:00:00"
  },
  {
    "id": "9d954ea5-b2d7-40af-828c-9e56414e7fa1",
    "slug": "benjamin-smith",
    "name": "Benjamin Smith",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/11/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Benjamin Smith",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9d954ea5-b2d7-40af-828c-9e56414e7fa1",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-00268",
    "licenseIssueDate": "10/11/2011 00:00:00",
    "licenseExpiryDate": "10/02/2026 00:00:00"
  },
  {
    "id": "71e273ab-a20c-4994-9c3b-e30f5cf9c095",
    "slug": "bennacer-ferhi",
    "name": "Bennacer Ferhi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/11/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-11-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Bennacer Ferhi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_71e273ab-a20c-4994-9c3b-e30f5cf9c095",
        "address": "",
        "phone": "97142555000",
        "email": "info@kha.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0e4b9f0a-83fc-45c9-b0d3-f38013690624",
    "firmName": "KHALIFA BIN HUWAIDAN ALKETBI ADVOCATES & LEGAL CONSULTANT",
    "registrationNumber": "L-03896",
    "licenseIssueDate": "11/12/2017 00:00:00",
    "licenseExpiryDate": "11/10/2019 00:00:00"
  },
  {
    "id": "98e18f1d-d958-4e07-ad88-7804149a2369",
    "slug": "benoy-sasi",
    "name": "Benoy Sasi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Benoy Sasi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_98e18f1d-d958-4e07-ad88-7804149a2369",
        "address": "29TH  ,PRISM TOWER ,J W MARRIOTT MARQUIS HOTEL  ,4790 ,Dubai",
        "phone": "97144539090",
        "email": "info@alkabban.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a9193879-c34b-4dae-99aa-d8e5ac8517cc",
    "firmName": "AL-KABBAN & ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01393",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "6f5f29e0-ef72-4b19-ac85-43ec4d152820",
    "slug": "bernard-fouad-el-hindi",
    "name": "Bernard Fouad El Hindi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/24/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Bernard Fouad El Hindi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6f5f29e0-ef72-4b19-ac85-43ec4d152820",
        "address": "samer tohme ,4th- office 433 ,Emarat Atrium ,Dubai Canal ,79436 ,Dubai",
        "phone": "97126722500",
        "email": "info@dxblawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "00b6334f-44e7-458e-8ce5-7d4256840067",
    "firmName": "MOHAMED ABDULLA LAWYERS AND LEGAL CONSULTANTS",
    "registrationNumber": "L-04387",
    "licenseIssueDate": "04/24/2019 00:00:00",
    "licenseExpiryDate": "04/22/2026 00:00:00"
  },
  {
    "id": "951aa05f-cdf5-40f3-9c8b-419c804a3c6a",
    "slug": "bertrand-claude-dumon",
    "name": "BERTRAND CLAUDE DUMON",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/05/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-05-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Bertrand Claude Dumon",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_951aa05f-cdf5-40f3-9c8b-419c804a3c6a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-03369",
    "licenseIssueDate": "05/26/2016 00:00:00",
    "licenseExpiryDate": "05/22/2020 00:00:00"
  },
  {
    "id": "21633063-9285-46c3-a27b-5566b5075836",
    "slug": "besma-rezaiguia",
    "name": "Besma Rezaiguia",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/17/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Besma Rezaiguia",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_21633063-9285-46c3-a27b-5566b5075836",
        "address": "",
        "phone": "97144531888 / 971971445318",
        "email": "info@suhaila.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3f71c0fe-93b9-4bea-82c4-fad46b21e883",
    "firmName": "SUHAILA ALMARZOOQI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05855",
    "licenseIssueDate": "05/17/2023 00:00:00",
    "licenseExpiryDate": "05/16/2026 00:00:00"
  },
  {
    "id": "ef5a9364-38f8-43a3-be75-136dee599844",
    "slug": "bettina-isabel-partzsch",
    "name": "Bettina Isabel Partzsch",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/05/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Bettina Isabel Partzsch",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ef5a9364-38f8-43a3-be75-136dee599844",
        "address": "",
        "phone": "97143275888 / 971504506620",
        "email": "anders@anders.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ead06df1-7efa-4b25-80d0-710f815a1677",
    "firmName": "Anders Legal Consultancy LLC",
    "registrationNumber": "L-04972",
    "licenseIssueDate": "07/05/2021 00:00:00",
    "licenseExpiryDate": "07/04/2026 00:00:00"
  },
  {
    "id": "c70aed7b-0315-42ae-9699-c08c8973d64d",
    "slug": "bevan-farmer",
    "name": "Bevan Farmer",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/11/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Bevan Farmer",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c70aed7b-0315-42ae-9699-c08c8973d64d",
        "address": "6 ,Office Nos. 603, 604 & 605, Level 6, Burj Daman ,Dubai International Financial Centre ,506555 ,Dubai",
        "phone": "97143506400 / 971504654755",
        "email": "r.hickman@aglaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8690f7d5-6b96-4649-9589-71303f2c2707",
    "firmName": "Addleshaw Goddard (Middle East) LLP",
    "registrationNumber": "L-00269",
    "licenseIssueDate": "10/11/2011 00:00:00",
    "licenseExpiryDate": "10/02/2026 00:00:00"
  },
  {
    "id": "6beadfaa-192c-476e-b9d6-4e22d49e7dc2",
    "slug": "bhavesh-bipin-madia",
    "name": "Bhavesh Bipin Madia",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/12/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Bhavesh Bipin Madia",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6beadfaa-192c-476e-b9d6-4e22d49e7dc2",
        "address": "",
        "phone": "97144478700 / 971528553200",
        "email": "Thomas.Wilson@squirepb.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "85be541a-c87f-45a9-a321-d90abd6b7298",
    "firmName": "Squire Patton Boggs (MEA) LLP",
    "registrationNumber": "L-06411",
    "licenseIssueDate": "07/12/2024 00:00:00",
    "licenseExpiryDate": "07/11/2026 00:00:00"
  },
  {
    "id": "0a3cf002-d1a3-48a0-afa8-88479f02c07d",
    "slug": "bhavesh-dattani",
    "name": "Bhavesh Dattani",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/31/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Bhavesh Dattani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0a3cf002-d1a3-48a0-afa8-88479f02c07d",
        "address": "Al Fattan Currency House - Tower 1  ,Dubai International Financial Center  ,507104 ,",
        "phone": "97143978565 / 971504587822",
        "email": "Raafat.hares@dwf.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6e5f6dba-07af-4109-8c34-175296450f94",
    "firmName": "DWF (Middle East) LLP",
    "registrationNumber": "L-05959",
    "licenseIssueDate": "07/31/2023 00:00:00",
    "licenseExpiryDate": "07/30/2026 00:00:00"
  },
  {
    "id": "8ea089f4-e8d3-438a-b94d-ed72a38601e7",
    "slug": "bilal-ahmad",
    "name": "Bilal Ahmad",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Bilal Ahmad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8ea089f4-e8d3-438a-b94d-ed72a38601e7",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-00206",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "d53b054e-876d-4520-b14c-6581615b0de6",
    "slug": "bilal-b-mirza",
    "name": "Bilal B Mirza",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/01/2024",
    "licenseStatus": "active",
    "licenseExpiry": "2025-01-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Bilal B Mirza",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d53b054e-876d-4520-b14c-6581615b0de6",
        "address": "",
        "phone": "97143025100 / 971501501837",
        "email": "ccairns@trowers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "976857f5-9092-43cf-987d-bfa794a3fa51",
    "firmName": "Trowers & Hamlins LLP",
    "registrationNumber": "L-06200",
    "licenseIssueDate": "01/31/2024 00:00:00",
    "licenseExpiryDate": "01/30/2026 00:00:00"
  },
  {
    "id": "1dfc344f-7bf7-42b6-8dba-8750685af294",
    "slug": "bilal-salman-abu-snanieh",
    "name": "Bilal Salman Abu Snanieh",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/29/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Bilal Salman Abu Snanieh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1dfc344f-7bf7-42b6-8dba-8750685af294",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-02067",
    "licenseIssueDate": "11/29/2011 00:00:00",
    "licenseExpiryDate": "11/20/2025 00:00:00"
  },
  {
    "id": "f513c765-d082-4a6d-abee-a7db07d5bd78",
    "slug": "bilal-shamsudeen-shamsudeen-abdul-kareem",
    "name": "Bilal Shamsudeen Shamsudeen Abdul Kareem",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/30/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Bilal Shamsudeen Shamsudeen Abdul Kareem",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f513c765-d082-4a6d-abee-a7db07d5bd78",
        "address": "Office 308 ,Owned by ACICO Gulf Real Estate LLC, Dubai branch ,Makani No: 3250094543 ,000 ,Dubai",
        "phone": "97142697998 / 971503567998",
        "email": "info@ayshamslaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0892f012-3fc4-4895-8d3b-abbb036938aa",
    "firmName": "AYESHA ALDHAHERI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06891",
    "licenseIssueDate": "07/30/2025 00:00:00",
    "licenseExpiryDate": "07/29/2026 00:00:00"
  },
  {
    "id": "9a8b6525-cbfb-4538-8400-95fb4d12f23b",
    "slug": "bindu-chettur",
    "name": "Bindu Chettur",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/11/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Bindu Chettur",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9a8b6525-cbfb-4538-8400-95fb4d12f23b",
        "address": "MOHAMMED ALI SALMAN AL MARZOOQI ,الثالث  ,السركال  ,معرض سيارات الفطيم  ,39059 ,Dubai",
        "phone": "97142500008",
        "email": "adv.saad@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6bba829c-0392-4c72-a71b-01da72cb24ae",
    "firmName": "MOHAMED SALMAN ADVOCATE & LEGAL CONSULTANCY",
    "registrationNumber": "L-02901",
    "licenseIssueDate": "03/11/2015 00:00:00",
    "licenseExpiryDate": "03/05/2026 00:00:00"
  },
  {
    "id": "cb69f7a4-7093-454b-bfe8-5456efc1142e",
    "slug": "bini-babu",
    "name": "Bini Babu",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/07/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Bini Babu",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cb69f7a4-7093-454b-bfe8-5456efc1142e",
        "address": "",
        "phone": "97142555000",
        "email": "info@kha.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0e4b9f0a-83fc-45c9-b0d3-f38013690624",
    "firmName": "KHALIFA BIN HUWAIDAN ALKETBI ADVOCATES & LEGAL CONSULTANT",
    "registrationNumber": "L-01373",
    "licenseIssueDate": "05/07/2015 00:00:00",
    "licenseExpiryDate": "05/02/2026 00:00:00"
  },
  {
    "id": "7c190b17-51c8-4299-aff7-7c56df7b0635",
    "slug": "binu-karthikeyan-girijakumari",
    "name": "BINU KARTHIKEYAN GIRIJAKUMARI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/21/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: BINU KARTHIKEYAN GIRIJAKUMARI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7c190b17-51c8-4299-aff7-7c56df7b0635",
        "address": "engy nabeel ,609 ,Business Avenue Building ,خلف معرض نيسان للسيارات ,114332 ,Dubai",
        "phone": "97142666983 / 971505049385",
        "email": "mtgdubai@mtglegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2c10c414-70fa-4a29-b8ce-a320239738ad",
    "firmName": "ENGY NABEEL ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02665",
    "licenseIssueDate": "03/21/2018 00:00:00",
    "licenseExpiryDate": "03/18/2026 00:00:00"
  },
  {
    "id": "f56796e6-0647-4d4f-887e-95a6c26689df",
    "slug": "blair-jones",
    "name": "Blair Jones",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/17/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Blair Jones",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f56796e6-0647-4d4f-887e-95a6c26689df",
        "address": "",
        "phone": "97143742800 / 971506450677",
        "email": "jabbott21@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7a59d310-ff72-4318-b41c-27095c163d0f",
    "firmName": "CMS (UAE) LLP",
    "registrationNumber": "L-03736",
    "licenseIssueDate": "04/17/2017 00:00:00",
    "licenseExpiryDate": "04/13/2026 00:00:00"
  },
  {
    "id": "5670de3c-cc63-4332-aba1-f02481121f90",
    "slug": "bolanle-coker",
    "name": "Bolanle Coker",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/20/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Bolanle Coker",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5670de3c-cc63-4332-aba1-f02481121f90",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-04101",
    "licenseIssueDate": "05/20/2018 00:00:00",
    "licenseExpiryDate": "05/18/2026 00:00:00"
  },
  {
    "id": "582fd84b-6949-44cf-a95c-8fc6122acc35",
    "slug": "brad-sandford",
    "name": "Brad Sandford",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/26/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Brad Sandford",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_582fd84b-6949-44cf-a95c-8fc6122acc35",
        "address": "",
        "phone": "97143025100 / 971501501837",
        "email": "ccairns@trowers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "976857f5-9092-43cf-987d-bfa794a3fa51",
    "firmName": "Trowers & Hamlins LLP",
    "registrationNumber": "L-01412",
    "licenseIssueDate": "02/26/2022 00:00:00",
    "licenseExpiryDate": "02/25/2026 00:00:00"
  },
  {
    "id": "55327880-e948-424a-be15-84f5f1d0acf1",
    "slug": "brendan-daniel-molck",
    "name": "Brendan Daniel Molck",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/13/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Brendan Daniel Molck",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_55327880-e948-424a-be15-84f5f1d0acf1",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-05129",
    "licenseIssueDate": "12/13/2021 00:00:00",
    "licenseExpiryDate": "12/12/2025 00:00:00"
  },
  {
    "id": "33ad1133-329d-4e93-9f8e-34da406b3777",
    "slug": "brendan-david-hundt",
    "name": "Brendan David Hundt",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/06/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Brendan David Hundt",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_33ad1133-329d-4e93-9f8e-34da406b3777",
        "address": "",
        "phone": "97143779900 / 971508548052",
        "email": "jali@kslaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dff8529a-82be-431a-b72b-0192ff238011",
    "firmName": "King & Spalding LLP",
    "registrationNumber": "L-04139",
    "licenseIssueDate": "06/06/2018 00:00:00",
    "licenseExpiryDate": "06/04/2026 00:00:00"
  },
  {
    "id": "18209e99-9511-4bb2-89e1-c7c992bff9bf",
    "slug": "brian-alade-samson-shonubi",
    "name": "Brian Alade Samson Shonubi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/12/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Brian Alade Samson Shonubi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_18209e99-9511-4bb2-89e1-c7c992bff9bf",
        "address": "",
        "phone": "97142472100 / 971509224336",
        "email": "bhaley@cov.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "65a2e90a-6978-4292-b3f1-ecbebedd7b9a",
    "firmName": "Covington & Burling LLP (Middle East)",
    "registrationNumber": "L-06402",
    "licenseIssueDate": "07/12/2024 00:00:00",
    "licenseExpiryDate": "07/11/2026 00:00:00"
  },
  {
    "id": "e984c1e6-031e-4990-81e4-cc962cd97a56",
    "slug": "brian-boahene",
    "name": "Brian Boahene",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/22/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Brian Boahene",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e984c1e6-031e-4990-81e4-cc962cd97a56",
        "address": "Al Fattan Currency House - Tower 1  ,Dubai International Financial Center  ,507104 ,",
        "phone": "97143978565 / 971504587822",
        "email": "Raafat.hares@dwf.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6e5f6dba-07af-4109-8c34-175296450f94",
    "firmName": "DWF (Middle East) LLP",
    "registrationNumber": "L-00695",
    "licenseIssueDate": "04/22/2021 00:00:00",
    "licenseExpiryDate": "04/21/2026 00:00:00"
  },
  {
    "id": "b8193f64-3792-4c6d-9ef9-c65c784907f5",
    "slug": "brian-fadi-oneissy",
    "name": "Brian Fadi Oneissy",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/05/2025",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Brian Fadi Oneissy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b8193f64-3792-4c6d-9ef9-c65c784907f5",
        "address": "الطابق 7 مكتب رقم 070A ,برج رولكس  ,محطة مترو المركز المالي  ,66300 ,Dubai",
        "phone": "97143444029",
        "email": "ekp.khalidaltmimi@ekplegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "400838f1-4e75-4836-9698-b9e19dd30a18",
    "firmName": "KHALID ABDALLA ALTAMIMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06830",
    "licenseIssueDate": "05/15/2025 00:00:00",
    "licenseExpiryDate": "05/14/2026 00:00:00"
  },
  {
    "id": "21f14c6c-4b4d-443d-805f-fbeda723cfc2",
    "slug": "brian-james-oleary",
    "name": "Brian James O'leary",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/23/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-01-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Brian James O'leary",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_21f14c6c-4b4d-443d-805f-fbeda723cfc2",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-01093",
    "licenseIssueDate": "01/23/2025 00:00:00",
    "licenseExpiryDate": "01/22/2026 00:00:00"
  },
  {
    "id": "e4bf6409-31ba-4014-99e9-835225162c9d",
    "slug": "brodie-violet-may-collar",
    "name": "Brodie Violet May Collar",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCVgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/09/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Brodie Violet May Collar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e4bf6409-31ba-4014-99e9-835225162c9d",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-06879",
    "licenseIssueDate": "07/09/2025 00:00:00",
    "licenseExpiryDate": "07/08/2026 00:00:00"
  },
  {
    "id": "09032a84-abeb-428b-aec5-fa81c64cae14",
    "slug": "brooke-laine-gilbey",
    "name": "Brooke Laine Gilbey",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/13/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Brooke Laine Gilbey",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_09032a84-abeb-428b-aec5-fa81c64cae14",
        "address": "",
        "phone": "97144230555 / 971504788443",
        "email": "yah@hfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c462c65e-185a-4e81-8425-a87e3a2b6842",
    "firmName": "Holman Fenwick Willan Middle East LLP",
    "registrationNumber": "L-05130",
    "licenseIssueDate": "12/13/2021 00:00:00",
    "licenseExpiryDate": "12/12/2025 00:00:00"
  },
  {
    "id": "b1e9b1ee-c889-402b-b7ba-2f00a21cf8fb",
    "slug": "bruce-sandness-wilson",
    "name": "Bruce Sandness Wilson",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/04/2018",
    "licenseStatus": "active",
    "licenseExpiry": "2019-04-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Bruce Sandness Wilson",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b1e9b1ee-c889-402b-b7ba-2f00a21cf8fb",
        "address": "",
        "phone": "97142472100 / 971509224336",
        "email": "bhaley@cov.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "65a2e90a-6978-4292-b3f1-ecbebedd7b9a",
    "firmName": "Covington & Burling LLP (Middle East)",
    "registrationNumber": "L-04094",
    "licenseIssueDate": "04/24/2018 00:00:00",
    "licenseExpiryDate": "04/21/2026 00:00:00"
  },
  {
    "id": "4a896940-70aa-4ef5-80ba-9df98f9dd1d6",
    "slug": "bryan-dayton",
    "name": "Bryan Dayton",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/09/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Bryan Dayton",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4a896940-70aa-4ef5-80ba-9df98f9dd1d6",
        "address": "",
        "phone": "97144478700 / 971528553200",
        "email": "Thomas.Wilson@squirepb.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "85be541a-c87f-45a9-a321-d90abd6b7298",
    "firmName": "Squire Patton Boggs (MEA) LLP",
    "registrationNumber": "L-03078",
    "licenseIssueDate": "02/09/2024 00:00:00",
    "licenseExpiryDate": "02/08/2026 00:00:00"
  },
  {
    "id": "9cebfcd1-21f0-440a-be2e-0d5b247a5109",
    "slug": "burak-ozsoy",
    "name": "BURAK OZSOY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/26/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: BURAK OZSOY",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9cebfcd1-21f0-440a-be2e-0d5b247a5109",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-05922",
    "licenseIssueDate": "07/26/2023 00:00:00",
    "licenseExpiryDate": "07/25/2026 00:00:00"
  },
  {
    "id": "e1dbe98a-596c-499e-a48f-220a184a7807",
    "slug": "bushra-abu-tayeh",
    "name": "Bushra Abu Tayeh",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/22/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Bushra Abu Tayeh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e1dbe98a-596c-499e-a48f-220a184a7807",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01246",
    "licenseIssueDate": "10/22/2012 00:00:00",
    "licenseExpiryDate": "10/14/2026 00:00:00"
  },
  {
    "id": "1ebe902a-1ac0-4c6c-a8ba-e4e968bde225",
    "slug": "bushra-ahmed",
    "name": "Bushra Ahmed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/13/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-05-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Bushra Ahmed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1ebe902a-1ac0-4c6c-a8ba-e4e968bde225",
        "address": "Emirates Financial Towers (South) ,DIFC ,506546 ,",
        "phone": "97147096700 / 971505573843",
        "email": "dk@kbh.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "291a9c0d-030a-4cef-8739-c6946f741117",
    "firmName": "KBH Limited",
    "registrationNumber": "L-02505",
    "licenseIssueDate": "01/13/2013 00:00:00",
    "licenseExpiryDate": "01/05/2026 00:00:00"
  },
  {
    "id": "715011c5-940a-43f6-b8db-d4dfd338a2b5",
    "slug": "bushra-begum",
    "name": "Bushra Begum",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/14/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Bushra Begum",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_715011c5-940a-43f6-b8db-d4dfd338a2b5",
        "address": "Al Fattan Currency House Tower 2 ,DIFC ,507176 ,",
        "phone": "/ 971552009003",
        "email": "Mohammad.AlRasheed@bakermckenzie.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "acd81e81-dead-4f7c-839e-0f2a57897265",
    "firmName": "Baker & Mckenzie LLP",
    "registrationNumber": "L-06666",
    "licenseIssueDate": "02/14/2025 00:00:00",
    "licenseExpiryDate": "02/13/2026 00:00:00"
  },
  {
    "id": "98e437f1-2b71-4b9b-9f22-17fb975e6f9e",
    "slug": "caitlin-coady",
    "name": "Caitlin Coady",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/02/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Caitlin Coady",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_98e437f1-2b71-4b9b-9f22-17fb975e6f9e",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Greenberg Traurig Limited",
    "registrationNumber": "L-05583",
    "licenseIssueDate": "11/02/2022 00:00:00",
    "licenseExpiryDate": "11/01/2025 00:00:00"
  },
  {
    "id": "2ca7a0d3-4895-4952-88d5-ca520dee8acc",
    "slug": "caitlin-elizabeth-mcphee",
    "name": "Caitlin Elizabeth McPhee",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/31/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Caitlin Elizabeth McPhee",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2ca7a0d3-4895-4952-88d5-ca520dee8acc",
        "address": "",
        "phone": "97143184600 / 971504468184",
        "email": "melaraby@gibsondunn.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c9d2c9d0-6e43-4253-a75d-cdeb400f8d8e",
    "firmName": "Gibson Dunn & Crutcher LLP",
    "registrationNumber": "L-05241",
    "licenseIssueDate": "07/31/2025 00:00:00",
    "licenseExpiryDate": "07/30/2026 00:00:00"
  },
  {
    "id": "8648fe78-0e3a-4b43-b4d7-e70f9aa36721",
    "slug": "caleb-raywood",
    "name": "Caleb Raywood",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/04/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Caleb Raywood",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8648fe78-0e3a-4b43-b4d7-e70f9aa36721",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-06239",
    "licenseIssueDate": "03/04/2024 00:00:00",
    "licenseExpiryDate": "03/03/2026 00:00:00"
  },
  {
    "id": "0e8dc13b-64dd-42d0-80ac-d23c82c94338",
    "slug": "callum-joel-gribbin",
    "name": "Callum Joel Gribbin",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/24/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Callum Joel Gribbin",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0e8dc13b-64dd-42d0-80ac-d23c82c94338",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-05841",
    "licenseIssueDate": "05/24/2023 00:00:00",
    "licenseExpiryDate": "05/23/2026 00:00:00"
  },
  {
    "id": "8b4b402d-2d1d-4b06-a618-179ccf66d4d8",
    "slug": "camellia-homampour",
    "name": "Camellia Homampour",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/22/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Camellia Homampour",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8b4b402d-2d1d-4b06-a618-179ccf66d4d8",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-06094",
    "licenseIssueDate": "11/22/2023 00:00:00",
    "licenseExpiryDate": "11/21/2025 00:00:00"
  },
  {
    "id": "220185db-164e-46dc-8cb8-3cba283a98c1",
    "slug": "cameron-cuffe",
    "name": "Cameron Cuffe",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/24/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Cameron Cuffe",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_220185db-164e-46dc-8cb8-3cba283a98c1",
        "address": "ICD-Brookfield Place ,DIFC ,119974 ,",
        "phone": "97143652000",
        "email": "david.charlier@ashurst.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c01c3c61-4d90-4058-8429-61dd01e615f5",
    "firmName": "Ashurst LLP-DIFC",
    "registrationNumber": "L-00569",
    "licenseIssueDate": "01/24/2016 00:00:00",
    "licenseExpiryDate": "01/19/2026 00:00:00"
  },
  {
    "id": "9ff1f436-29aa-4c34-b793-81487a37a72b",
    "slug": "cameron-griff-griffiths",
    "name": "Cameron Griff Griffiths",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/21/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Cameron Griff Griffiths",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9ff1f436-29aa-4c34-b793-81487a37a72b",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-06223",
    "licenseIssueDate": "02/21/2024 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "fbf9cbb8-9385-4825-ab4a-4dddfe3c268d",
    "slug": "cameron-james-busch",
    "name": "Cameron James Busch",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/18/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Cameron James Busch",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fbf9cbb8-9385-4825-ab4a-4dddfe3c268d",
        "address": "",
        "phone": "97142472100 / 971509224336",
        "email": "bhaley@cov.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "65a2e90a-6978-4292-b3f1-ecbebedd7b9a",
    "firmName": "Covington & Burling LLP (Middle East)",
    "registrationNumber": "L-06016",
    "licenseIssueDate": "10/18/2023 00:00:00",
    "licenseExpiryDate": "10/17/2026 00:00:00"
  },
  {
    "id": "6c629aec-78d6-43eb-9af4-595bd61ebbf5",
    "slug": "cameron-lyall-boyd",
    "name": "Cameron Lyall Boyd",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/08/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Cameron Lyall Boyd",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6c629aec-78d6-43eb-9af4-595bd61ebbf5",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-06279",
    "licenseIssueDate": "05/08/2024 00:00:00",
    "licenseExpiryDate": "05/07/2026 00:00:00"
  },
  {
    "id": "f3e2f8c2-9237-47e1-855f-ddd880557631",
    "slug": "carla-alarmaly",
    "name": "CARLA ALARMALY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/04/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: CARLA ALARMALY",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f3e2f8c2-9237-47e1-855f-ddd880557631",
        "address": "",
        "phone": "97142552220",
        "email": "almaazmi.office@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e04d8a88-3378-40c8-a33a-b5e26a0c8507",
    "firmName": "ABDELRAHMAN AL MAAZMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04626",
    "licenseIssueDate": "03/04/2020 00:00:00",
    "licenseExpiryDate": "03/03/2026 00:00:00"
  },
  {
    "id": "bd5e4652-8fcb-4e71-805d-b503b2a76c5d",
    "slug": "carla-saliba",
    "name": "Carla Saliba",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Carla Saliba",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bd5e4652-8fcb-4e71-805d-b503b2a76c5d",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01247",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "a95e461d-4ff1-4d62-9a2d-089389583483",
    "slug": "carlo-pianese",
    "name": "Carlo Pianese",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/15/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Carlo Pianese",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a95e461d-4ff1-4d62-9a2d-089389583483",
        "address": "",
        "phone": "97145979700 / 971505532609",
        "email": "rbeydoun@t-lawadvisors.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3d9f2bb9-85fe-49cc-9187-0b808bfa2a2d",
    "firmName": "Rindala Beydoun Legal Consultancy",
    "registrationNumber": "L-01067",
    "licenseIssueDate": "03/15/2021 00:00:00",
    "licenseExpiryDate": "03/14/2026 00:00:00"
  },
  {
    "id": "e1d4a9b8-68d7-4a44-8852-e0a54abdeac9",
    "slug": "carlyn-lobo",
    "name": "Carlyn Lobo",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/24/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Carlyn Lobo",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e1d4a9b8-68d7-4a44-8852-e0a54abdeac9",
        "address": "",
        "phone": "97142776075 / 971588324788",
        "email": "avichal@kochhardubai.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "847eff7c-4142-431e-a8d6-f58ff60964f6",
    "firmName": "Kochhar & Co Inc Legal Consultants (Dubai Branch)",
    "registrationNumber": "L-03465",
    "licenseIssueDate": "08/24/2016 00:00:00",
    "licenseExpiryDate": "08/20/2026 00:00:00"
  },
  {
    "id": "78070392-f1a9-40d1-aca9-0decd9224ed9",
    "slug": "carola-uva",
    "name": "Carola Uva",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDVQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/22/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Carola Uva",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_78070392-f1a9-40d1-aca9-0decd9224ed9",
        "address": "23 ,Rolex Tower ,Trade Center Second ,116637 ,Dubai",
        "phone": "97144357577 / 971502101003",
        "email": "jasamin.fichte@fichtelegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "77bf4fd2-1cd1-4bda-a0c2-ffcac3980b76",
    "firmName": "Fichte & Co Legal Consultancy",
    "registrationNumber": "L-06271",
    "licenseIssueDate": "03/22/2024 00:00:00",
    "licenseExpiryDate": "03/21/2026 00:00:00"
  },
  {
    "id": "82422788-9edd-4aff-9ce3-0a3ddb888755",
    "slug": "caroline-emma-hibberd",
    "name": "Caroline Emma Hibberd",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/21/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Caroline Emma Hibberd",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_82422788-9edd-4aff-9ce3-0a3ddb888755",
        "address": "",
        "phone": "97144073901 / 971503479508",
        "email": "Rania.Tadros@stephensonharwood.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dd5042a2-bb41-4123-9544-79c3fa831332",
    "firmName": "Stephenson Harwood (Middle East) LLP",
    "registrationNumber": "L-04549",
    "licenseIssueDate": "08/21/2023 00:00:00",
    "licenseExpiryDate": "08/20/2026 00:00:00"
  },
  {
    "id": "9eee7fa1-9cca-47c9-b9a9-59e851380fcc",
    "slug": "carolyn-abram",
    "name": "Carolyn Abram",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/29/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Carolyn Abram",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9eee7fa1-9cca-47c9-b9a9-59e851380fcc",
        "address": "",
        "phone": "97143184600 / 971504468184",
        "email": "melaraby@gibsondunn.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c9d2c9d0-6e43-4253-a75d-cdeb400f8d8e",
    "firmName": "Gibson Dunn & Crutcher LLP",
    "registrationNumber": "L-03485",
    "licenseIssueDate": "06/29/2016 00:00:00",
    "licenseExpiryDate": "06/25/2026 00:00:00"
  },
  {
    "id": "074b3acd-836b-417c-a12f-4b3a46102f3c",
    "slug": "carolyn-talia-cormack",
    "name": "Carolyn Talia Cormack",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/25/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Carolyn Talia Cormack",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_074b3acd-836b-417c-a12f-4b3a46102f3c",
        "address": "Building 5 ,Dubai World Trade Centre ,212620 ,",
        "phone": "97143503600 / 971563631562",
        "email": "p.ellingham@kennedys-law.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "83d3ede1-3a28-4b03-8c92-6bd31a1cb95e",
    "firmName": "Kennedys Dubai LLP",
    "registrationNumber": "L-06967",
    "licenseIssueDate": "09/25/2025 00:00:00",
    "licenseExpiryDate": "09/24/2026 00:00:00"
  },
  {
    "id": "45af89bf-02ce-4c02-b3ec-377b86e3906e",
    "slug": "cassandra-mady",
    "name": "Cassandra Mady",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/17/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Cassandra Mady",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_45af89bf-02ce-4c02-b3ec-377b86e3906e",
        "address": "samer tohme ,4th- office 433 ,Emarat Atrium ,Dubai Canal ,79436 ,Dubai",
        "phone": "97126722500",
        "email": "info@dxblawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "00b6334f-44e7-458e-8ce5-7d4256840067",
    "firmName": "MOHAMED ABDULLA LAWYERS AND LEGAL CONSULTANTS",
    "registrationNumber": "L-06296",
    "licenseIssueDate": "04/17/2024 00:00:00",
    "licenseExpiryDate": "04/16/2026 00:00:00"
  },
  {
    "id": "cde68432-5fcf-48af-bf6a-7eb729a0efa7",
    "slug": "cassandra-mary-lobo",
    "name": "Cassandra Mary Lobo",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/25/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Cassandra Mary Lobo",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cde68432-5fcf-48af-bf6a-7eb729a0efa7",
        "address": "",
        "phone": "97108307033",
        "email": "general.alshamsi@lawuae.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d29f6d04-dad1-4f59-9ae2-d4d245f63133",
    "firmName": "AL SHAMSI & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01230",
    "licenseIssueDate": "01/25/2012 00:00:00",
    "licenseExpiryDate": "01/16/2026 00:00:00"
  },
  {
    "id": "eb7adc2b-b421-4ad5-ad64-291cf02e27fd",
    "slug": "cassy-victoria-raby",
    "name": "Cassy Victoria Raby",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDVgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/18/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Cassy Victoria Raby",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_eb7adc2b-b421-4ad5-ad64-291cf02e27fd",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-05425",
    "licenseIssueDate": "07/18/2022 00:00:00",
    "licenseExpiryDate": "07/17/2026 00:00:00"
  },
  {
    "id": "bd462e22-eec3-4b1a-877c-e3ffea0f2bfb",
    "slug": "catharine-islay-barbour",
    "name": "Catharine Islay Barbour",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/12/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Catharine Islay Barbour",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bd462e22-eec3-4b1a-877c-e3ffea0f2bfb",
        "address": "",
        "phone": "97143637999 / 971506525633",
        "email": "daniel.wood@walkersglobal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a3a9927b-d51c-490c-8be6-d575ea3eb041",
    "firmName": "Walkers (Middle East) LLP",
    "registrationNumber": "L-04906",
    "licenseIssueDate": "04/12/2021 00:00:00",
    "licenseExpiryDate": "04/11/2026 00:00:00"
  },
  {
    "id": "384be01f-76da-4ce8-93ff-3f60ee7c1148",
    "slug": "catherine-ann-workman",
    "name": "CATHERINE ANN WORKMAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/07/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: CATHERINE ANN WORKMAN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_384be01f-76da-4ce8-93ff-3f60ee7c1148",
        "address": "- ,THE OFFICES 1 ,DWTC ,115580 ,Dubai",
        "phone": "97143739700 / 971562196031",
        "email": "catherine.workman@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "6b4ebb23-ef2e-4305-a1ee-43a11e4b1cae",
    "firmName": "Pinsent Masons LLP - Dubai Branch",
    "registrationNumber": "L-04396",
    "licenseIssueDate": "05/07/2019 00:00:00",
    "licenseExpiryDate": "05/06/2026 00:00:00"
  },
  {
    "id": "b3e5d7f0-ad33-4b01-91b5-91d9c4b4fc1f",
    "slug": "catherine-louise-fisher",
    "name": "Catherine Louise Fisher",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/28/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Catherine Louise Fisher",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b3e5d7f0-ad33-4b01-91b5-91d9c4b4fc1f",
        "address": "",
        "phone": "97144478700 / 971528553200",
        "email": "Thomas.Wilson@squirepb.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "85be541a-c87f-45a9-a321-d90abd6b7298",
    "firmName": "Squire Patton Boggs (MEA) LLP",
    "registrationNumber": "L-04246",
    "licenseIssueDate": "10/28/2018 00:00:00",
    "licenseExpiryDate": "12/19/2025 00:00:00"
  },
  {
    "id": "b4d1aada-325d-4217-9174-50e755b1b640",
    "slug": "catherine-patricia-osborn",
    "name": "Catherine Patricia Osborn",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/26/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Catherine Patricia Osborn",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b4d1aada-325d-4217-9174-50e755b1b640",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-05303",
    "licenseIssueDate": "04/26/2022 00:00:00",
    "licenseExpiryDate": "04/25/2026 00:00:00"
  },
  {
    "id": "d18baafa-6f35-4afd-a3f7-17dad2584b51",
    "slug": "catriona-jane-mcdevitt",
    "name": "Catriona Jane McDevitt",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/20/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Catriona Jane McDevitt",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d18baafa-6f35-4afd-a3f7-17dad2584b51",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-05037",
    "licenseIssueDate": "09/20/2021 00:00:00",
    "licenseExpiryDate": "09/19/2026 00:00:00"
  },
  {
    "id": "84b904d6-a9c0-42a8-aacf-42a02a353e00",
    "slug": "celia-anne-johnson-morgan",
    "name": "Celia Anne Johnson-Morgan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/26/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Celia Anne Johnson-Morgan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_84b904d6-a9c0-42a8-aacf-42a02a353e00",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-05002",
    "licenseIssueDate": "07/26/2021 00:00:00",
    "licenseExpiryDate": "07/25/2026 00:00:00"
  },
  {
    "id": "ce4ebdeb-df99-4b7d-b9b1-d4f9b2cbd3ef",
    "slug": "celine-abi-habib",
    "name": "Celine Abi Habib",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/26/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Celine Abi Habib",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ce4ebdeb-df99-4b7d-b9b1-d4f9b2cbd3ef",
        "address": "الطابق 7 مكتب رقم 070A ,برج رولكس  ,محطة مترو المركز المالي  ,66300 ,Dubai",
        "phone": "97143444029",
        "email": "ekp.khalidaltmimi@ekplegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "400838f1-4e75-4836-9698-b9e19dd30a18",
    "firmName": "KHALID ABDALLA ALTAMIMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01761",
    "licenseIssueDate": "09/26/2011 00:00:00",
    "licenseExpiryDate": "09/17/2026 00:00:00"
  },
  {
    "id": "9106bd57-1037-415e-b854-c2d1034ee13c",
    "slug": "cesar-antoine-ghaleb",
    "name": "Cesar Antoine Ghaleb",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/02/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Cesar Antoine Ghaleb",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9106bd57-1037-415e-b854-c2d1034ee13c",
        "address": "",
        "phone": "97142554421",
        "email": "mariam.alshamsi@triumphco.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0a80a9dd-7ded-4752-af6a-4444111bc177",
    "firmName": "MARIAM AL SHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04368",
    "licenseIssueDate": "04/02/2019 00:00:00",
    "licenseExpiryDate": "03/31/2026 00:00:00"
  },
  {
    "id": "8e8d60c3-46e4-4f98-8345-b2e7ad41fc5a",
    "slug": "chad-jonathon-passlow",
    "name": "Chad Jonathon Passlow",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/12/2023",
    "licenseStatus": "active",
    "licenseExpiry": "2024-12-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Chad Jonathon Passlow",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8e8d60c3-46e4-4f98-8345-b2e7ad41fc5a",
        "address": "",
        "phone": "97144363636 / 971505572900",
        "email": "hassan.elsayed@bakerbotts.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "fd5d6571-d053-4436-9de5-c8a36ce7c6c9",
    "firmName": "Baker Botts LLP Legal Consultants Dubai Branch",
    "registrationNumber": "L-06134",
    "licenseIssueDate": "12/07/2023 00:00:00",
    "licenseExpiryDate": "12/06/2025 00:00:00"
  },
  {
    "id": "05a563ee-b508-4f81-9d92-3c864c3534b0",
    "slug": "chad-michael-altieri",
    "name": "Chad Michael Altieri",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/19/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-01-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Chad Michael Altieri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_05a563ee-b508-4f81-9d92-3c864c3534b0",
        "address": "The Binary by Omniyat ,Business Bay ,371473 ,",
        "phone": "97156288020 / 971562880200",
        "email": "chad@gsilaw.global",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "fede060d-ee8a-4d28-b07d-69793cc407bc",
    "firmName": "Altieri Firm L.L.C",
    "registrationNumber": "L-06166",
    "licenseIssueDate": "01/19/2024 00:00:00",
    "licenseExpiryDate": "01/18/2026 00:00:00"
  },
  {
    "id": "2279a916-fbdc-4baa-a9e0-20a16a6b29cb",
    "slug": "chadi-atallah-salloum",
    "name": "Chadi Atallah Salloum",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/12/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Chadi Atallah Salloum",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2279a916-fbdc-4baa-a9e0-20a16a6b29cb",
        "address": "",
        "phone": "97145953601 / 971508728645",
        "email": "Steven.Bainbridge@gtlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b4146aa6-efd1-41d7-819d-49da46353b0b",
    "firmName": "Greenberg Traurig Limited",
    "registrationNumber": "L-04658",
    "licenseIssueDate": "03/12/2020 00:00:00",
    "licenseExpiryDate": "03/11/2026 00:00:00"
  },
  {
    "id": "cbed445e-8810-4efd-bcc5-2bfaebf1cc12",
    "slug": "chadi-fadi-hourani",
    "name": "Chadi Fadi Hourani",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/11/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-02-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Chadi Fadi Hourani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cbed445e-8810-4efd-bcc5-2bfaebf1cc12",
        "address": "One Central, The Offices 5 ,Dubai World Trade Centre ,554660 ,",
        "phone": "97142052030 / 971506566494",
        "email": "chourani@houranipartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "59a73632-40a0-4849-b120-4308dc6f8015",
    "firmName": "Hourani & Partners Legal Consultancy FZCO",
    "registrationNumber": "L-01207",
    "licenseIssueDate": "01/11/2012 00:00:00",
    "licenseExpiryDate": "01/02/2026 00:00:00"
  },
  {
    "id": "34385c5a-92f9-40a0-8320-c74dd3bda719",
    "slug": "chakrapani-bodapati-sita-rama-mohan-bodapati",
    "name": "Chakrapani Bodapati Sita Rama Mohan Bodapati",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/26/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Chakrapani Bodapati Sita Rama Mohan Bodapati",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_34385c5a-92f9-40a0-8320-c74dd3bda719",
        "address": "23 ,Rolex Tower ,Trade Center Second ,116637 ,Dubai",
        "phone": "97144357577 / 971502101003",
        "email": "jasamin.fichte@fichtelegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "77bf4fd2-1cd1-4bda-a0c2-ffcac3980b76",
    "firmName": "Fichte & Co Legal Consultancy",
    "registrationNumber": "L-05311",
    "licenseIssueDate": "04/26/2022 00:00:00",
    "licenseExpiryDate": "04/25/2026 00:00:00"
  },
  {
    "id": "755c1ef4-0c55-4596-a884-f27b3861dfb2",
    "slug": "chandani-rajapakse",
    "name": "Chandani Rajapakse",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Chandani Rajapakse",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_755c1ef4-0c55-4596-a884-f27b3861dfb2",
        "address": "AG House- Building Num 581 ,Al Muteena, Dubai ,11169 ,",
        "phone": "97143257977 / 971507086100",
        "email": "sheeza@mandviwallaandzafar.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8569b29e-bcb6-4ddd-90d8-c6b90718e267",
    "firmName": "Mandviwalla & Zafar Limited Liability Partnership",
    "registrationNumber": "L-00825",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "d34335a3-734f-4e37-9482-578c51dad14e",
    "slug": "charbel-dersahakian",
    "name": "Charbel Dersahakian",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/16/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Charbel Dersahakian",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d34335a3-734f-4e37-9482-578c51dad14e",
        "address": "South Tower, Emirates Financial Towers ,DIFC ,482025 ,",
        "phone": "97145875333 / 971503444388",
        "email": "c.dersahakian@cvml.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e2c6db70-04e7-4c7b-882a-6d2ffe4469ed",
    "firmName": "CVML Limited",
    "registrationNumber": "L-03664",
    "licenseIssueDate": "03/16/2017 00:00:00",
    "licenseExpiryDate": "03/13/2026 00:00:00"
  },
  {
    "id": "a4b1417a-1e08-4d6b-a240-0063761771e4",
    "slug": "charbel-fadel",
    "name": "Charbel Fadel",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/14/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Charbel Fadel",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a4b1417a-1e08-4d6b-a240-0063761771e4",
        "address": "Ahmed Galadari ,1st Floor ,GA-00-SZ-L1-DD-01, Innovation Hive, Gate Avenue - South Zone ,World Trade Center ,506916 ,Dubai",
        "phone": "97143711999",
        "email": "ajith@galadarilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "1ddb9aa2-a883-464a-a447-4dc47ac35a87",
    "firmName": "GALADARI ADVOCATES & LEGAL CONSULTANTS (DIFC)",
    "registrationNumber": "L-03065",
    "licenseIssueDate": "06/14/2015 00:00:00",
    "licenseExpiryDate": "06/09/2026 00:00:00"
  },
  {
    "id": "4e96238e-4792-47b8-89c5-7fe53556aea7",
    "slug": "charbel-jean-el-zoghby",
    "name": "Charbel Jean El Zoghby",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/28/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Charbel Jean El Zoghby",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4e96238e-4792-47b8-89c5-7fe53556aea7",
        "address": "YASIR AL NAQBI ,21 ,48 BURJ ,SOFITEL DOWN  TOWN ,181111 ,Dubai",
        "phone": "97142689949",
        "email": "info@alnaqbipartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ad71430e-83ee-4cb5-a530-bc58db2618f6",
    "firmName": "ALNAQBI & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06468",
    "licenseIssueDate": "08/28/2024 00:00:00",
    "licenseExpiryDate": "08/27/2026 00:00:00"
  },
  {
    "id": "07db128a-eddf-4b78-95fd-d71be76a8d00",
    "slug": "charlene-helena-de-souza",
    "name": "Charlene Helena De Souza",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/15/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Charlene Helena De Souza",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_07db128a-eddf-4b78-95fd-d71be76a8d00",
        "address": "6 ,Office Nos. 603, 604 & 605, Level 6, Burj Daman ,Dubai International Financial Centre ,506555 ,Dubai",
        "phone": "97143506400 / 971504654755",
        "email": "r.hickman@aglaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8690f7d5-6b96-4649-9589-71303f2c2707",
    "firmName": "Addleshaw Goddard (Middle East) LLP",
    "registrationNumber": "L-05192",
    "licenseIssueDate": "02/15/2022 00:00:00",
    "licenseExpiryDate": "02/14/2026 00:00:00"
  },
  {
    "id": "33c1db5a-05e7-47ce-891f-9b4382faff23",
    "slug": "charlene-kong-yuiin-yee",
    "name": "Charlene Kong Yuiin Yee",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/09/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Charlene Kong Yuiin Yee",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_33c1db5a-05e7-47ce-891f-9b4382faff23",
        "address": "",
        "phone": "97143025100 / 971501501837",
        "email": "ccairns@trowers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "976857f5-9092-43cf-987d-bfa794a3fa51",
    "firmName": "Trowers & Hamlins LLP",
    "registrationNumber": "L-06739",
    "licenseIssueDate": "04/09/2025 00:00:00",
    "licenseExpiryDate": "04/08/2026 00:00:00"
  },
  {
    "id": "1accb65d-776f-4f49-a706-a27711cc0668",
    "slug": "charles-andrew-newman",
    "name": "Charles Andrew Newman",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/13/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Charles Andrew Newman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1accb65d-776f-4f49-a706-a27711cc0668",
        "address": "6 ,Office Nos. 603, 604 & 605, Level 6, Burj Daman ,Dubai International Financial Centre ,506555 ,Dubai",
        "phone": "97143506400 / 971504654755",
        "email": "r.hickman@aglaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8690f7d5-6b96-4649-9589-71303f2c2707",
    "firmName": "Addleshaw Goddard (Middle East) LLP",
    "registrationNumber": "L-06255",
    "licenseIssueDate": "03/13/2024 00:00:00",
    "licenseExpiryDate": "03/12/2026 00:00:00"
  },
  {
    "id": "11d38950-20a5-492d-be79-7081ce3c2589",
    "slug": "charles-cockrell",
    "name": "Charles Cockrell",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/24/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-01-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Charles Cockrell",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_11d38950-20a5-492d-be79-7081ce3c2589",
        "address": "",
        "phone": "97144230555 / 971504788443",
        "email": "yah@hfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c462c65e-185a-4e81-8425-a87e3a2b6842",
    "firmName": "Holman Fenwick Willan Middle East LLP",
    "registrationNumber": "L-00615",
    "licenseIssueDate": "01/24/2012 00:00:00",
    "licenseExpiryDate": "01/15/2026 00:00:00"
  },
  {
    "id": "8880e7c6-e597-4310-805e-923cbf290d93",
    "slug": "charles-david-oliver",
    "name": "Charles David Oliver",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/20/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Charles David Oliver",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8880e7c6-e597-4310-805e-923cbf290d93",
        "address": "",
        "phone": "97144286300 / 971506256686",
        "email": "stuart.paterson@hsf.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2f0389b3-bfde-44f4-bdd6-6e1a22f9cab2",
    "firmName": "Herbert Smith Freehills Kramer LLP",
    "registrationNumber": "L-04633",
    "licenseIssueDate": "02/20/2020 00:00:00",
    "licenseExpiryDate": "02/19/2026 00:00:00"
  },
  {
    "id": "14fae5d4-f798-4b2b-8269-7dc6342b6ed3",
    "slug": "charles-edward-tuckwell",
    "name": "Charles Edward Tuckwell",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/04/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Charles Edward Tuckwell",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_14fae5d4-f798-4b2b-8269-7dc6342b6ed3",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-06467",
    "licenseIssueDate": "09/04/2024 00:00:00",
    "licenseExpiryDate": "09/03/2026 00:00:00"
  },
  {
    "id": "5f558c36-2cc4-4f1a-a01d-979659ef03b1",
    "slug": "charles-ryland-christie",
    "name": "Charles Ryland Christie",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/06/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Charles Ryland Christie",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5f558c36-2cc4-4f1a-a01d-979659ef03b1",
        "address": "",
        "phone": "97143093222 / 971566651954",
        "email": "melissa.murray@twobirds.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3e1526e6-4c8d-4b6f-985f-ea05e9f99bcb",
    "firmName": "Bird & Bird (MEA) LLP",
    "registrationNumber": "L-06068",
    "licenseIssueDate": "11/06/2023 00:00:00",
    "licenseExpiryDate": "11/05/2025 00:00:00"
  },
  {
    "id": "7f1be756-4aa3-4b8a-8b99-7c6d6fb90b83",
    "slug": "charles-s-laubach",
    "name": "Charles S. Laubach",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/16/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Charles S. Laubach",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7f1be756-4aa3-4b8a-8b99-7c6d6fb90b83",
        "address": "",
        "phone": "97143303900 / 971561753537",
        "email": "christopher@afridi-angell.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "30ce50dc-01a6-499d-8ace-3f807ddcb08d",
    "firmName": "Afridi & Angell-DED",
    "registrationNumber": "L-00107",
    "licenseIssueDate": "12/16/2011 00:00:00",
    "licenseExpiryDate": "12/07/2025 00:00:00"
  },
  {
    "id": "d8e09fe6-4967-4045-b4c1-b43d118a3689",
    "slug": "charlotte-bijlani",
    "name": "Charlotte Bijlani",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/17/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Charlotte Bijlani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d8e09fe6-4967-4045-b4c1-b43d118a3689",
        "address": "Index Tower ,DIFC ,506896 ,",
        "phone": "97142782300 / 971551154791",
        "email": "GLeggate@wfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "e2b82cfc-80a5-4957-ae41-b1a7beb693c1",
    "firmName": "Watson, Farley & Williams (Middle East) LLP",
    "registrationNumber": "L-02909",
    "licenseIssueDate": "04/17/2014 00:00:00",
    "licenseExpiryDate": "04/10/2026 00:00:00"
  },
  {
    "id": "cac86ee1-863b-4066-b6db-75f466e5a8de",
    "slug": "charlotte-eleanor-keenan-wright",
    "name": "Charlotte Eleanor Keenan Wright",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/01/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Charlotte Eleanor Keenan Wright",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cac86ee1-863b-4066-b6db-75f466e5a8de",
        "address": "Level 17, ICD Brookfield Place ,DIFC ,506503 ,",
        "phone": "97144375100 / 971588271196",
        "email": "libby.edwards-smith@gowlingwlg.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "436703ba-b9c0-4dcb-93b2-1299c7a051f4",
    "firmName": "Gowling WLG (UK) LLP (Dubai Branch)",
    "registrationNumber": "L-05088",
    "licenseIssueDate": "11/01/2021 00:00:00",
    "licenseExpiryDate": "10/31/2026 00:00:00"
  },
  {
    "id": "f4969755-dc9e-4002-b804-a3bdcc71818e",
    "slug": "charlotte-frances-killen",
    "name": "Charlotte Frances Killen",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/28/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Charlotte Frances Killen",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f4969755-dc9e-4002-b804-a3bdcc71818e",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-06826",
    "licenseIssueDate": "05/28/2025 00:00:00",
    "licenseExpiryDate": "05/27/2026 00:00:00"
  },
  {
    "id": "487389f1-21fb-48e7-b7fc-dd9a2dfed178",
    "slug": "charlotte-mary-knight",
    "name": "Charlotte Mary Knight",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/14/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Charlotte Mary Knight",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_487389f1-21fb-48e7-b7fc-dd9a2dfed178",
        "address": "Index Tower ,DIFC ,506896 ,",
        "phone": "97142782300 / 971551154791",
        "email": "GLeggate@wfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e2b82cfc-80a5-4957-ae41-b1a7beb693c1",
    "firmName": "Watson, Farley & Williams (Middle East) LLP",
    "registrationNumber": "L-04163",
    "licenseIssueDate": "08/14/2018 00:00:00",
    "licenseExpiryDate": "08/12/2026 00:00:00"
  },
  {
    "id": "850f24c7-f36c-495b-b584-19bf3ad91021",
    "slug": "charlotte-victoria-davis",
    "name": "Charlotte Victoria Davis",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDVgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/22/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Charlotte Victoria Davis",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_850f24c7-f36c-495b-b584-19bf3ad91021",
        "address": "",
        "phone": "97143641686 / 971506288801",
        "email": "b.kadir@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0ba96df8-e4cc-49c2-8ae4-a42878d95926",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS LLC",
    "registrationNumber": "L-04820",
    "licenseIssueDate": "12/22/2020 00:00:00",
    "licenseExpiryDate": "12/21/2025 00:00:00"
  },
  {
    "id": "43708a75-8a10-4e41-adfb-48d10ca7ae34",
    "slug": "chatura-randeniya",
    "name": "Chatura Randeniya",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/16/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Chatura Randeniya",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_43708a75-8a10-4e41-adfb-48d10ca7ae34",
        "address": "",
        "phone": "97143303900 / 971561753537",
        "email": "christopher@afridi-angell.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "30ce50dc-01a6-499d-8ace-3f807ddcb08d",
    "firmName": "Afridi & Angell-DED",
    "registrationNumber": "L-00108",
    "licenseIssueDate": "12/16/2011 00:00:00",
    "licenseExpiryDate": "12/07/2025 00:00:00"
  },
  {
    "id": "cd6aaaed-7f0f-4b7e-b8c5-9dda63016ccb",
    "slug": "chaya-sudhakar-gupta-gupta",
    "name": "Chaya Sudhakar Gupta Gupta",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/01/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Chaya Sudhakar Gupta Gupta",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cd6aaaed-7f0f-4b7e-b8c5-9dda63016ccb",
        "address": "Al Fattan Currency House Tower 2 ,DIFC ,507176 ,",
        "phone": "/ 971552009003",
        "email": "Mohammad.AlRasheed@bakermckenzie.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "acd81e81-dead-4f7c-839e-0f2a57897265",
    "firmName": "Baker & Mckenzie LLP",
    "registrationNumber": "L-04868",
    "licenseIssueDate": "03/01/2021 00:00:00",
    "licenseExpiryDate": "02/28/2026 00:00:00"
  },
  {
    "id": "df68aa95-a8e1-4e51-bd86-2581a5c8bbad",
    "slug": "chelsea-lynn-pollard",
    "name": "Chelsea Lynn Pollard",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/31/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Chelsea Lynn Pollard",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_df68aa95-a8e1-4e51-bd86-2581a5c8bbad",
        "address": "",
        "phone": "97143121800 / 971566017967",
        "email": "alishia.sullivan@morganlewis.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6eab20d7-8716-4b0a-8710-144d1d951c23",
    "firmName": "Morgan, Lewis & Bockius LLP (dubai Branch)",
    "registrationNumber": "L-06196",
    "licenseIssueDate": "01/31/2024 00:00:00",
    "licenseExpiryDate": "01/30/2026 00:00:00"
  },
  {
    "id": "71f1032e-d4a9-453b-a898-d29f98b0fd3b",
    "slug": "cheppayil-yamuna-menon",
    "name": "CHEPPAYIL YAMUNA MENON",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/28/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: CHEPPAYIL YAMUNA MENON",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_71f1032e-d4a9-453b-a898-d29f98b0fd3b",
        "address": "ICD Brookfield Place ,DIFC ,506516 ,",
        "phone": "97143695800 / 971505526206",
        "email": "scott.campbell@linklaters.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5cec94c0-0649-43b6-a2be-ab17ff422bce",
    "firmName": "LinkLaters LLP",
    "registrationNumber": "L-06820",
    "licenseIssueDate": "05/28/2025 00:00:00",
    "licenseExpiryDate": "05/27/2026 00:00:00"
  },
  {
    "id": "cb0b5b13-4c4e-44f0-8bb7-0b0ea79ab54b",
    "slug": "cheryl-cairns",
    "name": "Cheryl Cairns",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/11/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Cheryl Cairns",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cb0b5b13-4c4e-44f0-8bb7-0b0ea79ab54b",
        "address": "",
        "phone": "97143025100 / 971501501837",
        "email": "ccairns@trowers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "976857f5-9092-43cf-987d-bfa794a3fa51",
    "firmName": "Trowers & Hamlins LLP",
    "registrationNumber": "L-00359",
    "licenseIssueDate": "10/11/2011 00:00:00",
    "licenseExpiryDate": "10/02/2026 00:00:00"
  },
  {
    "id": "0a6977c5-588d-4c82-847d-05c99bdd490a",
    "slug": "cheuk-yin-cheung",
    "name": "Cheuk Yin Cheung",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/19/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Cheuk Yin Cheung",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0a6977c5-588d-4c82-847d-05c99bdd490a",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-00136",
    "licenseIssueDate": "04/19/2024 00:00:00",
    "licenseExpiryDate": "04/18/2026 00:00:00"
  },
  {
    "id": "5f628b76-ba75-4dd0-904a-1f804909678a",
    "slug": "chinar-nuzhat-zaidi",
    "name": "Chinar Nuzhat Zaidi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/25/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Chinar Nuzhat Zaidi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5f628b76-ba75-4dd0-904a-1f804909678a",
        "address": "",
        "phone": "97144073901 / 971503479508",
        "email": "Rania.Tadros@stephensonharwood.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dd5042a2-bb41-4123-9544-79c3fa831332",
    "firmName": "Stephenson Harwood (Middle East) LLP",
    "registrationNumber": "L-04463",
    "licenseIssueDate": "07/25/2019 00:00:00",
    "licenseExpiryDate": "07/24/2026 00:00:00"
  },
  {
    "id": "96a96e15-9c15-4006-91a5-efddd5698ad0",
    "slug": "chirag-jayant-sanghrajka",
    "name": "Chirag Jayant Sanghrajka",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/04/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Chirag Jayant Sanghrajka",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_96a96e15-9c15-4006-91a5-efddd5698ad0",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-05114",
    "licenseIssueDate": "11/04/2021 00:00:00",
    "licenseExpiryDate": "11/02/2025 00:00:00"
  },
  {
    "id": "4d2b90dc-014a-47ef-9258-de18c37521a8",
    "slug": "chloe-anne-mcintosh",
    "name": "Chloe Anne McIntosh",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/09/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Chloe Anne McIntosh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4d2b90dc-014a-47ef-9258-de18c37521a8",
        "address": "6 ,Office Nos. 603, 604 & 605, Level 6, Burj Daman ,Dubai International Financial Centre ,506555 ,Dubai",
        "phone": "97143506400 / 971504654755",
        "email": "r.hickman@aglaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8690f7d5-6b96-4649-9589-71303f2c2707",
    "firmName": "Addleshaw Goddard (Middle East) LLP",
    "registrationNumber": "L-05823",
    "licenseIssueDate": "06/09/2023 00:00:00",
    "licenseExpiryDate": "06/08/2026 00:00:00"
  },
  {
    "id": "31db8d35-3317-4f2c-8171-16fa4e59083c",
    "slug": "chloe-atoussa-heydarian",
    "name": "Chloe Atoussa Heydarian",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/01/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Chloe Atoussa Heydarian",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_31db8d35-3317-4f2c-8171-16fa4e59083c",
        "address": "",
        "phone": "97143937700",
        "email": "info@galadarilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d863b662-c864-4193-8b3a-ff6ee5fe6c64",
    "firmName": "GALADARI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06981",
    "licenseIssueDate": "09/29/2025 00:00:00",
    "licenseExpiryDate": "09/28/2026 00:00:00"
  },
  {
    "id": "b2197703-6123-4ef0-aed4-7435b059d046",
    "slug": "chloe-bernadette-chantal-mockel",
    "name": "Chloe Bernadette Chantal Mockel",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/11/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Chloe Bernadette Chantal Mockel",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b2197703-6123-4ef0-aed4-7435b059d046",
        "address": "ICD Brookfield Place ,Za'abeel 2 ,103747 ,",
        "phone": "97143696300 / 971506008159",
        "email": "mohammed.paracha@nortonrosefulbright.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c4aaee93-0ec4-4982-9a48-a23699492056",
    "firmName": "Norton Rose Fullbright (Middle East) LLP",
    "registrationNumber": "L-06843",
    "licenseIssueDate": "06/11/2025 00:00:00",
    "licenseExpiryDate": "06/10/2026 00:00:00"
  },
  {
    "id": "d29b7938-fb09-42cb-9fe5-b8a4083b21ed",
    "slug": "chloe-hannah-benton",
    "name": "Chloe Hannah Benton",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/11/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Chloe Hannah Benton",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d29b7938-fb09-42cb-9fe5-b8a4083b21ed",
        "address": "",
        "phone": "97143742800 / 971506450677",
        "email": "jabbott21@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7a59d310-ff72-4318-b41c-27095c163d0f",
    "firmName": "CMS (UAE) LLP",
    "registrationNumber": "L-06848",
    "licenseIssueDate": "06/11/2025 00:00:00",
    "licenseExpiryDate": "06/10/2026 00:00:00"
  },
  {
    "id": "e7a26ae4-5867-43e0-a7b0-d71540b3d8d4",
    "slug": "chris-sioufi",
    "name": "Chris Sioufi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Chris Sioufi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e7a26ae4-5867-43e0-a7b0-d71540b3d8d4",
        "address": "1 ,ICD Brookfield Place ,Dubai International Financial Centre ,9267 ,Dubai",
        "phone": "97147010975 / 971502977062",
        "email": "chris.sioufi@ae.ey.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "42e536ef-e3d8-4339-8572-657a7f7a0331",
    "firmName": "EY Law LLP",
    "registrationNumber": "L-01056",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "0c9dbd4a-ec66-4a14-a2a1-4eacfb245795",
    "slug": "chrisoula-georgina-vassiliou",
    "name": "Chrisoula Georgina Vassiliou",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/17/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Chrisoula Georgina Vassiliou",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0c9dbd4a-ec66-4a14-a2a1-4eacfb245795",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-06284",
    "licenseIssueDate": "04/17/2024 00:00:00",
    "licenseExpiryDate": "04/16/2026 00:00:00"
  },
  {
    "id": "b8ae6ec0-afa9-4db0-9cdf-6337537d3d33",
    "slug": "christian-adams",
    "name": "Christian Adams",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/01/2022",
    "licenseStatus": "active",
    "licenseExpiry": "2023-01-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Christian Adams",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b8ae6ec0-afa9-4db0-9cdf-6337537d3d33",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506698 ,Dubai",
        "phone": "97147046300 / 971507900661",
        "email": "nada.mourad@lw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b2b92ce9-90a4-4e34-ae2f-ae0dc7ca9060",
    "firmName": "Latham & Watkins LLP",
    "registrationNumber": "L-05207",
    "licenseIssueDate": "01/19/2022 00:00:00",
    "licenseExpiryDate": "01/18/2026 00:00:00"
  },
  {
    "id": "c1f1382e-3aee-4433-b75f-6628e188769b",
    "slug": "christian-james-parker",
    "name": "Christian James Parker",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/08/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Christian James Parker",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c1f1382e-3aee-4433-b75f-6628e188769b",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-04406",
    "licenseIssueDate": "05/08/2019 00:00:00",
    "licenseExpiryDate": "05/07/2026 00:00:00"
  },
  {
    "id": "e4ead2df-e928-4eb5-97ef-8c25483b066d",
    "slug": "christian-kramer",
    "name": "Christian Kramer",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/07/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Christian Kramer",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e4ead2df-e928-4eb5-97ef-8c25483b066d",
        "address": "1 ,Park Place Towe ,. ,9353 ,Dubai",
        "phone": "97143317110 / 971000000000",
        "email": "elena@meyer-reumann.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e294ccf7-baca-4016-876d-fcf8d296a3fc",
    "firmName": "Meyer Reumann & Partners",
    "registrationNumber": "L-00994",
    "licenseIssueDate": "06/07/2015 00:00:00",
    "licenseExpiryDate": "06/02/2026 00:00:00"
  },
  {
    "id": "fd511b52-0727-47e6-a789-ad858628709f",
    "slug": "christine-maksoud",
    "name": "Christine Maksoud",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/25/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-01-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Christine Maksoud",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fd511b52-0727-47e6-a789-ad858628709f",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03268",
    "licenseIssueDate": "01/25/2021 00:00:00",
    "licenseExpiryDate": "01/24/2026 00:00:00"
  },
  {
    "id": "65946e5d-a3d5-42db-a39c-a789b87c8913",
    "slug": "christine-veall",
    "name": "Christine Veall",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDVgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Christine Veall",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_65946e5d-a3d5-42db-a39c-a789b87c8913",
        "address": "Business Village Building A ,Port Saeed ,42717 ,",
        "phone": "97142229747 / 971506546369",
        "email": "iveall@dhbassociates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "24541c75-dcba-47a9-b858-e6bc97c41dbc",
    "firmName": "Donald Harry Bunker Legal Consultants",
    "registrationNumber": "L-01014",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2025 00:00:00"
  },
  {
    "id": "4355ced1-13a7-4e6d-b17e-e69df425029e",
    "slug": "christoph-keimer",
    "name": "Christoph Keimer",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/22/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Christoph Keimer",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4355ced1-13a7-4e6d-b17e-e69df425029e",
        "address": "A7 ,Dubai Silicon Oasis ,29337 ,",
        "phone": "97144313060 / 971528448686",
        "email": "andres.ring@schlueter-graf.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2ce110f0-b433-4dbc-b15f-ab1a3b291c28",
    "firmName": "Schluter Graf Legal Consultants LLC",
    "registrationNumber": "L-00388",
    "licenseIssueDate": "11/22/2011 00:00:00",
    "licenseExpiryDate": "11/13/2025 00:00:00"
  },
  {
    "id": "fcb404ea-6381-412b-b1dc-4b4f46030ab3",
    "slug": "christopher-angus",
    "name": "Christopher Angus",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Christopher Angus",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fcb404ea-6381-412b-b1dc-4b4f46030ab3",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-00211",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "e38060de-8d72-4fdb-93a5-f26de2d0c9e3",
    "slug": "christopher-cross",
    "name": "Christopher Cross",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/05/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Christopher Cross",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e38060de-8d72-4fdb-93a5-f26de2d0c9e3",
        "address": "",
        "phone": "97144286300 / 971506256686",
        "email": "stuart.paterson@hsf.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2f0389b3-bfde-44f4-bdd6-6e1a22f9cab2",
    "firmName": "Herbert Smith Freehills Kramer LLP",
    "registrationNumber": "L-00796",
    "licenseIssueDate": "08/05/2021 00:00:00",
    "licenseExpiryDate": "08/04/2026 00:00:00"
  },
  {
    "id": "7c418efd-7597-4015-9a1c-0ccbbb0ad087",
    "slug": "christopher-edwards",
    "name": "Christopher Edwards",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/10/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Christopher Edwards",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7c418efd-7597-4015-9a1c-0ccbbb0ad087",
        "address": "Index Tower ,506548 ,Dubai",
        "phone": "97147096300 / 971506767433",
        "email": "amateen@reedsmith.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b3f87e90-7ce9-4097-82c4-15232365f175",
    "firmName": "Reed Smith LLP",
    "registrationNumber": "L-02277",
    "licenseIssueDate": "10/28/2013 00:00:00",
    "licenseExpiryDate": "10/21/2025 00:00:00"
  },
  {
    "id": "b9c5a66a-c6f2-4ab0-af9d-f14aa3b79a94",
    "slug": "christopher-gunson",
    "name": "Christopher Gunson",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/01/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Christopher Gunson",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b9c5a66a-c6f2-4ab0-af9d-f14aa3b79a94",
        "address": "",
        "phone": "97144323671 / 971505589395",
        "email": "fba@amereller.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a139ca64-8897-4d1d-8d71-97446bc1e15a",
    "firmName": "Amereller Legal Consultancy LLC SOC",
    "registrationNumber": "L-03760",
    "licenseIssueDate": "06/01/2017 00:00:00",
    "licenseExpiryDate": "05/29/2026 00:00:00"
  },
  {
    "id": "41c2729b-4c74-478f-963a-f87056dd6e3a",
    "slug": "christopher-james-bailey-gibbs",
    "name": "Christopher James Bailey Gibbs",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/14/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Christopher James Bailey Gibbs",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_41c2729b-4c74-478f-963a-f87056dd6e3a",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-06441",
    "licenseIssueDate": "08/14/2024 00:00:00",
    "licenseExpiryDate": "08/13/2026 00:00:00"
  },
  {
    "id": "d6b8ea67-65a8-4424-ae8f-e8b2dc4773d6",
    "slug": "christopher-james-fenn",
    "name": "Christopher James Fenn",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/09/2021",
    "licenseStatus": "active",
    "licenseExpiry": "2022-09-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Christopher James Fenn",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d6b8ea67-65a8-4424-ae8f-e8b2dc4773d6",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-05041",
    "licenseIssueDate": "09/20/2021 00:00:00",
    "licenseExpiryDate": "09/19/2026 00:00:00"
  },
  {
    "id": "d4cc1f82-f479-4484-8f29-f6298b774545",
    "slug": "christopher-john-brennan",
    "name": "Christopher John Brennan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/24/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Christopher John Brennan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d4cc1f82-f479-4484-8f29-f6298b774545",
        "address": "",
        "phone": "97144020800 / 971566830829",
        "email": "dean.ryburn@dentons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dfe13b7e-6625-45fd-ad63-9ee83af41194",
    "firmName": "Dentons & Co Dubai Branch-DED",
    "registrationNumber": "L-05803",
    "licenseIssueDate": "05/24/2023 00:00:00",
    "licenseExpiryDate": "05/23/2026 00:00:00"
  },
  {
    "id": "f6889f9e-67e2-4d9b-b82d-387d88f49458",
    "slug": "christopher-john-thorn",
    "name": "Christopher John Thorn",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/21/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Christopher John Thorn",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f6889f9e-67e2-4d9b-b82d-387d88f49458",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-04655",
    "licenseIssueDate": "05/21/2020 00:00:00",
    "licenseExpiryDate": "05/20/2026 00:00:00"
  },
  {
    "id": "8bf00f8d-3b47-44a1-9b4a-0963ef843098",
    "slug": "christopher-lloyd-norris",
    "name": "Christopher Lloyd Norris",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/06/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Christopher Lloyd Norris",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8bf00f8d-3b47-44a1-9b4a-0963ef843098",
        "address": "",
        "phone": "97147098484 / 971505577206",
        "email": "slshadmand@jonesday.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8892bfe9-d3ec-4158-b4fd-1844606f4f30",
    "firmName": "Jones Day",
    "registrationNumber": "L-06586",
    "licenseIssueDate": "10/30/2024 00:00:00",
    "licenseExpiryDate": "10/29/2025 00:00:00"
  },
  {
    "id": "c002827c-f2a2-4d3c-ac4a-b7f93b0c1731",
    "slug": "christopher-michael-beaumont-mcquillan",
    "name": "Christopher Michael Beaumont-McQuillan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/24/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Christopher Michael Beaumont-McQuillan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c002827c-f2a2-4d3c-ac4a-b7f93b0c1731",
        "address": "",
        "phone": "97145119777 / 971508184427",
        "email": "richard.davies@bclplaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6c617112-4b98-414c-868a-7d0316427c21",
    "firmName": "Bryan Cave Leighton Paisner LLP",
    "registrationNumber": "L-06282",
    "licenseIssueDate": "07/24/2024 00:00:00",
    "licenseExpiryDate": "07/23/2026 00:00:00"
  },
  {
    "id": "f4976ab2-1daf-47ba-bcb2-da69c68009fc",
    "slug": "christopher-neal",
    "name": "Christopher Neal",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Christopher Neal",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f4976ab2-1daf-47ba-bcb2-da69c68009fc",
        "address": "THE OFFICES 1 ,DWTC ,115580 ,",
        "phone": "97143739700 / 971501148248",
        "email": "nitesh.pradhan@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "361fdc64-6b6f-4f37-abca-c52af8473b84",
    "firmName": "Pinsent Masons  LLP (DWTCA Branch)",
    "registrationNumber": "L-01170",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "415f7520-782a-41f9-bff6-6db202d74850",
    "slug": "christopher-peter-hall",
    "name": "Christopher Peter Hall",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/21/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Christopher Peter Hall",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_415f7520-782a-41f9-bff6-6db202d74850",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-05869",
    "licenseIssueDate": "06/21/2023 00:00:00",
    "licenseExpiryDate": "06/20/2026 00:00:00"
  },
  {
    "id": "14c5d01d-9545-41ca-b68b-7bfa4ff243db",
    "slug": "christopher-radley-gardner",
    "name": "Christopher Radley-Gardner",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/22/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Christopher Radley-Gardner",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_14c5d01d-9545-41ca-b68b-7bfa4ff243db",
        "address": "Emirates Financial Tower, South Tower ,Dubai International Financial Center ,506675 ,",
        "phone": "97144256300 / 971558560783",
        "email": "rebecca.hird@dechert.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "7b0531fd-1de7-4fe5-b6d8-7a5de645b631",
    "firmName": "Dechert LLP",
    "registrationNumber": "L-05382",
    "licenseIssueDate": "06/22/2022 00:00:00",
    "licenseExpiryDate": "06/21/2026 00:00:00"
  },
  {
    "id": "c854bbe8-cd5b-4625-9fbd-1657f995e0cb",
    "slug": "christopher-walters",
    "name": "Christopher Walters",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/04/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Christopher Walters",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c854bbe8-cd5b-4625-9fbd-1657f995e0cb",
        "address": "",
        "phone": "97144286300 / 971506256686",
        "email": "stuart.paterson@hsf.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2f0389b3-bfde-44f4-bdd6-6e1a22f9cab2",
    "firmName": "Herbert Smith Freehills Kramer LLP",
    "registrationNumber": "L-02883",
    "licenseIssueDate": "02/04/2015 00:00:00",
    "licenseExpiryDate": "01/29/2026 00:00:00"
  },
  {
    "id": "f006c85f-a026-432b-9694-e737a162f4b6",
    "slug": "christopher-williams",
    "name": "Christopher Williams",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/03/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Christopher Williams",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f006c85f-a026-432b-9694-e737a162f4b6",
        "address": "",
        "phone": "97143506800 / 971507244940",
        "email": "Chris.Williams@bracewelllaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "106d3ee7-86f2-4eae-9b49-fd8423095983",
    "firmName": "Bracewell LLP",
    "registrationNumber": "L-00835",
    "licenseIssueDate": "02/03/2012 00:00:00",
    "licenseExpiryDate": "01/25/2026 00:00:00"
  },
  {
    "id": "033fce17-9919-40b5-9764-59a264967a7f",
    "slug": "ciara-mary-hickey",
    "name": "Ciara Mary Hickey",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/20/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ciara Mary Hickey",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_033fce17-9919-40b5-9764-59a264967a7f",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-04643",
    "licenseIssueDate": "02/20/2020 00:00:00",
    "licenseExpiryDate": "02/19/2026 00:00:00"
  },
  {
    "id": "34bf0ddc-ea63-4191-aea7-766865d09ec7",
    "slug": "ciaran-bohnacker",
    "name": "Ciaran Bohnacker",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/08/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ciaran Bohnacker",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_34bf0ddc-ea63-4191-aea7-766865d09ec7",
        "address": "",
        "phone": "97143637999 / 971506525633",
        "email": "daniel.wood@walkersglobal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a3a9927b-d51c-490c-8be6-d575ea3eb041",
    "firmName": "Walkers (Middle East) LLP",
    "registrationNumber": "L-00689",
    "licenseIssueDate": "09/08/2011 00:00:00",
    "licenseExpiryDate": "08/30/2026 00:00:00"
  },
  {
    "id": "1fb3c45c-9272-4c2a-b13a-1b0c5aab75cc",
    "slug": "claire-alice-neil",
    "name": "Claire Alice Neil",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/08/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-07-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Claire Alice Neil",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1fb3c45c-9272-4c2a-b13a-1b0c5aab75cc",
        "address": "ICD Brookfield Place ,DIFC ,506516 ,",
        "phone": "97143695800 / 971505526206",
        "email": "scott.campbell@linklaters.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5cec94c0-0649-43b6-a2be-ab17ff422bce",
    "firmName": "LinkLaters LLP",
    "registrationNumber": "L-04597",
    "licenseIssueDate": "01/08/2020 00:00:00",
    "licenseExpiryDate": "01/07/2026 00:00:00"
  },
  {
    "id": "fa07df13-4e4a-40fb-9f55-e553e09d067d",
    "slug": "claire-grainger",
    "name": "Claire Grainger",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/17/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Claire Grainger",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fa07df13-4e4a-40fb-9f55-e553e09d067d",
        "address": "الثالث - 329 ,إمارات اتريوم  ,مزايا سنتر ,4609 ,Dubai",
        "phone": "97142225151",
        "email": "team@nbadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "170463c8-fa0b-4323-bb48-8ea54d32ed3d",
    "firmName": "NAJI BEIDOUN ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03740",
    "licenseIssueDate": "05/17/2017 00:00:00",
    "licenseExpiryDate": "05/14/2026 00:00:00"
  },
  {
    "id": "6887008d-a84b-413e-91d4-66d24e03f600",
    "slug": "claire-kirton",
    "name": "Claire Kirton",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Claire Kirton",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6887008d-a84b-413e-91d4-66d24e03f600",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-00797",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "ee923f43-f456-44ad-aa38-a9d9f5b4716b",
    "slug": "claire-miller",
    "name": "Claire Miller",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/11/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Claire Miller",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ee923f43-f456-44ad-aa38-a9d9f5b4716b",
        "address": "",
        "phone": "97143563900 / 971564663035",
        "email": "c.miller@Beale-Law.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "0f74c5fc-87d6-451a-b380-576b0bc3ceb8",
    "firmName": "Beale & Company (Middle East)",
    "registrationNumber": "L-03324",
    "licenseIssueDate": "11/05/2015 00:00:00",
    "licenseExpiryDate": "10/31/2025 00:00:00"
  },
  {
    "id": "79ca4533-7381-4038-b578-ec7766f60697",
    "slug": "claire-rhiannon-stephens",
    "name": "Claire Rhiannon Stephens",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/28/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Claire Rhiannon Stephens",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_79ca4533-7381-4038-b578-ec7766f60697",
        "address": "",
        "phone": "97144230555 / 971504788443",
        "email": "yah@hfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c462c65e-185a-4e81-8425-a87e3a2b6842",
    "firmName": "Holman Fenwick Willan Middle East LLP",
    "registrationNumber": "L-06821",
    "licenseIssueDate": "05/28/2025 00:00:00",
    "licenseExpiryDate": "05/27/2026 00:00:00"
  },
  {
    "id": "0bb5e06b-7b45-45e6-a8b7-6e7de8324839",
    "slug": "claudio-medeossi",
    "name": "Claudio Medeossi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/23/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Claudio Medeossi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0bb5e06b-7b45-45e6-a8b7-6e7de8324839",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-03124",
    "licenseIssueDate": "06/23/2023 00:00:00",
    "licenseExpiryDate": "06/22/2026 00:00:00"
  },
  {
    "id": "ff38c6cd-24f5-43e3-a405-e710b7720f06",
    "slug": "clint-dempsey",
    "name": "Clint Dempsey",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/18/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Clint Dempsey",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ff38c6cd-24f5-43e3-a405-e710b7720f06",
        "address": "ICD-Brookfield Place ,DIFC ,119974 ,",
        "phone": "97143652000",
        "email": "david.charlier@ashurst.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c01c3c61-4d90-4058-8429-61dd01e615f5",
    "firmName": "Ashurst LLP-DIFC",
    "registrationNumber": "L-01942",
    "licenseIssueDate": "11/18/2012 00:00:00",
    "licenseExpiryDate": "11/10/2025 00:00:00"
  },
  {
    "id": "da1997c2-4cf1-424c-89c6-39525d52c3d1",
    "slug": "colin-robert-john-macginn-sharpsmith",
    "name": "Colin Robert John Macginn Sharpsmith",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/21/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Colin Robert John Macginn Sharpsmith",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_da1997c2-4cf1-424c-89c6-39525d52c3d1",
        "address": "Emirates Financial Tower, South Tower ,Dubai International Financial Center ,506675 ,",
        "phone": "97144256300 / 971558560783",
        "email": "rebecca.hird@dechert.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7b0531fd-1de7-4fe5-b6d8-7a5de645b631",
    "firmName": "Dechert LLP",
    "registrationNumber": "L-06214",
    "licenseIssueDate": "02/21/2024 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "2603b99b-bf6e-40b8-9d38-4a92a26170a6",
    "slug": "corrie-martin-van-der-schyf",
    "name": "Corrie Martin Van Der Schyf",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/05/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Corrie Martin Van Der Schyf",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2603b99b-bf6e-40b8-9d38-4a92a26170a6",
        "address": "",
        "phone": "97145124129 / 971547315151",
        "email": "ryan@constructionlaw.co.za",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9b87f290-69e4-4ce7-abac-c0457574a0a5",
    "firmName": "Tiefenthaler Attorneys Incorporated - Dubai Branch",
    "registrationNumber": "L-06620",
    "licenseIssueDate": "03/05/2025 00:00:00",
    "licenseExpiryDate": "03/04/2026 00:00:00"
  },
  {
    "id": "5219fcb2-1f0a-4b45-8174-72f0efc1a259",
    "slug": "courtney-rothery",
    "name": "Courtney Rothery",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/16/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Courtney Rothery",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5219fcb2-1f0a-4b45-8174-72f0efc1a259",
        "address": "",
        "phone": "97143742800 / 971506450677",
        "email": "jabbott21@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7a59d310-ff72-4318-b41c-27095c163d0f",
    "firmName": "CMS (UAE) LLP",
    "registrationNumber": "L-00830",
    "licenseIssueDate": "05/16/2024 00:00:00",
    "licenseExpiryDate": "05/15/2026 00:00:00"
  },
  {
    "id": "0e97d31e-2411-4ca3-affe-9753e8f2c151",
    "slug": "cynthia-trench",
    "name": "Cynthia Trench",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/08/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Cynthia Trench",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0e97d31e-2411-4ca3-affe-9753e8f2c151",
        "address": "",
        "phone": "97143553146 / 971506240472",
        "email": "ct@trenchlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "4a6253d9-d6c0-479e-81a8-dcfe44ef60fa",
    "firmName": "Trench & Associates DMCC",
    "registrationNumber": "L-00382",
    "licenseIssueDate": "09/08/2011 00:00:00",
    "licenseExpiryDate": "08/30/2026 00:00:00"
  },
  {
    "id": "3ebaa2bf-7ffa-48b1-8f70-e3869edc6a5d",
    "slug": "cyril-hannibal-cotterall-debay",
    "name": "Cyril Hannibal Cotterall Debay",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/02/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Cyril Hannibal Cotterall Debay",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3ebaa2bf-7ffa-48b1-8f70-e3869edc6a5d",
        "address": "",
        "phone": "97147098484 / 971505577206",
        "email": "slshadmand@jonesday.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8892bfe9-d3ec-4158-b4fd-1844606f4f30",
    "firmName": "Jones Day",
    "registrationNumber": "L-05957",
    "licenseIssueDate": "08/02/2023 00:00:00",
    "licenseExpiryDate": "08/01/2026 00:00:00"
  },
  {
    "id": "8385c84c-912c-485b-814f-80e7bd085664",
    "slug": "daegan-cory-mclaughlin",
    "name": "Daegan Cory Mclaughlin",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/30/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Daegan Cory Mclaughlin",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8385c84c-912c-485b-814f-80e7bd085664",
        "address": "",
        "phone": "97143637999 / 971506525633",
        "email": "daniel.wood@walkersglobal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a3a9927b-d51c-490c-8be6-d575ea3eb041",
    "firmName": "Walkers (Middle East) LLP",
    "registrationNumber": "L-06782",
    "licenseIssueDate": "04/30/2025 00:00:00",
    "licenseExpiryDate": "04/29/2026 00:00:00"
  },
  {
    "id": "a2b50867-c12a-4508-9279-28cd5659ee4d",
    "slug": "dalal-alhouti",
    "name": "Dalal Alhouti",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/27/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Dalal Alhouti",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a2b50867-c12a-4508-9279-28cd5659ee4d",
        "address": "20 ,Index Tower West Tower ,DIFC ,507226 ,Dubai",
        "phone": "97142461900 / 971523391604",
        "email": "patrick.gearon@crsblaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e2ac552e-b9a7-450b-a84d-15119e583220",
    "firmName": "Charles Russell Speechlys LLP",
    "registrationNumber": "L-02288",
    "licenseIssueDate": "10/27/2021 00:00:00",
    "licenseExpiryDate": "10/26/2026 00:00:00"
  },
  {
    "id": "ccc3806e-9b9c-4e2f-ab2e-fbac8fe40bca",
    "slug": "dalal-sarkis-noujaim",
    "name": "Dalal Sarkis Noujaim",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/07/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Dalal Sarkis Noujaim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ccc3806e-9b9c-4e2f-ab2e-fbac8fe40bca",
        "address": "الطابق الخامس ,الساحة ,سوق البحار ,26011 ,Dubai",
        "phone": "97142277717",
        "email": "info@alsahlawico.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a6811a79-5470-4c33-ad95-3ff8f661c052",
    "firmName": "AMAL ALBASTAKI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-06929",
    "licenseIssueDate": "08/07/2025 00:00:00",
    "licenseExpiryDate": "08/06/2026 00:00:00"
  },
  {
    "id": "96da504c-5f0c-44b7-8229-417463ffa4cc",
    "slug": "dale-moulden",
    "name": "Dale Moulden",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBETQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/17/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Dale Moulden",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_96da504c-5f0c-44b7-8229-417463ffa4cc",
        "address": "ICD Brookfield Place ,Za'abeel 2 ,103747 ,",
        "phone": "97143696300 / 971506008159",
        "email": "mohammed.paracha@nortonrosefulbright.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c4aaee93-0ec4-4982-9a48-a23699492056",
    "firmName": "Norton Rose Fullbright (Middle East) LLP",
    "registrationNumber": "L-06281",
    "licenseIssueDate": "04/17/2024 00:00:00",
    "licenseExpiryDate": "04/16/2026 00:00:00"
  },
  {
    "id": "3c9ae87c-4c7a-4f8b-a2c6-ed6313fcb338",
    "slug": "daleep-singh",
    "name": "Daleep Singh",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Daleep Singh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3c9ae87c-4c7a-4f8b-a2c6-ed6313fcb338",
        "address": "Emirates Financial Towers (South) ,DIFC ,506546 ,",
        "phone": "97147096700 / 971505573843",
        "email": "dk@kbh.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "291a9c0d-030a-4cef-8739-c6946f741117",
    "firmName": "KBH Limited",
    "registrationNumber": "L-00754",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "0260b6d9-2917-4904-837b-801821695a55",
    "slug": "dalia-nammari",
    "name": "Dalia Nammari",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBETgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Dalia Nammari",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0260b6d9-2917-4904-837b-801821695a55",
        "address": "ICD Brookfield Place ,DIFC ,506516 ,",
        "phone": "97143695800 / 971505526206",
        "email": "scott.campbell@linklaters.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5cec94c0-0649-43b6-a2be-ab17ff422bce",
    "firmName": "LinkLaters LLP",
    "registrationNumber": "L-00711",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "928ffc9e-85e1-49ef-9b09-ebe685c123b9",
    "slug": "damian-crosse",
    "name": "Damian Crosse",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/22/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Damian Crosse",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_928ffc9e-85e1-49ef-9b09-ebe685c123b9",
        "address": "- ,THE OFFICES 1 ,DWTC ,115580 ,Dubai",
        "phone": "97143739700 / 971562196031",
        "email": "catherine.workman@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6b4ebb23-ef2e-4305-a1ee-43a11e4b1cae",
    "firmName": "Pinsent Masons LLP - Dubai Branch",
    "registrationNumber": "L-02125",
    "licenseIssueDate": "04/22/2014 00:00:00",
    "licenseExpiryDate": "04/15/2026 00:00:00"
  },
  {
    "id": "9cf807b5-11a3-4794-8d9f-1a95c110ebd6",
    "slug": "damian-john-wright",
    "name": "Damian John Wright",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBESgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/15/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Damian John Wright",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9cf807b5-11a3-4794-8d9f-1a95c110ebd6",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-05201",
    "licenseIssueDate": "02/15/2022 00:00:00",
    "licenseExpiryDate": "02/14/2026 00:00:00"
  },
  {
    "id": "383c01b8-9392-4367-8550-5f37c0c431b5",
    "slug": "dania-yassin",
    "name": "Dania Yassin",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/05/2023",
    "licenseStatus": "active",
    "licenseExpiry": "2024-05-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Dania Yassin",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_383c01b8-9392-4367-8550-5f37c0c431b5",
        "address": "",
        "phone": "97143685555",
        "email": "maisa.maarouf@bsabh.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8afa232f-52ff-4dad-82c3-9a04d66eb853",
    "firmName": "B S A AHMED BIN HAZEEM & ASSOCIATES LLP - DIFC",
    "registrationNumber": "L-05851",
    "licenseIssueDate": "05/31/2023 00:00:00",
    "licenseExpiryDate": "05/30/2026 00:00:00"
  },
  {
    "id": "7936a836-0418-4453-bd80-e7fd85840cd4",
    "slug": "danial-o-toole",
    "name": "Danial O Toole",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBETwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/21/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Danial O Toole",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7936a836-0418-4453-bd80-e7fd85840cd4",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506688 ,Dubai",
        "phone": "97147096600 / 971503556811",
        "email": "muneer.khan@simmons-simmons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d1725ca7-06ac-41b2-8d7b-a6e60665b73d",
    "firmName": "Simmons & Simmons (Middle East) LLP-DIFC",
    "registrationNumber": "L-06603",
    "licenseIssueDate": "11/21/2024 00:00:00",
    "licenseExpiryDate": "11/20/2025 00:00:00"
  },
  {
    "id": "ed68984e-2ff9-4d1f-91c2-22e27be1f676",
    "slug": "daniel-erez-hannuna",
    "name": "Daniel Erez Hannuna",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBERQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/05/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Daniel Erez Hannuna",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ed68984e-2ff9-4d1f-91c2-22e27be1f676",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-04971",
    "licenseIssueDate": "07/05/2021 00:00:00",
    "licenseExpiryDate": "07/04/2026 00:00:00"
  },
  {
    "id": "e590420e-6072-4099-b015-faaaafa4bace",
    "slug": "daniel-fadi-bishara-eid",
    "name": "Daniel Fadi Bishara Eid",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBERgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/12/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Daniel Fadi Bishara Eid",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e590420e-6072-4099-b015-faaaafa4bace",
        "address": "Level 17, ICD Brookfield Place ,DIFC ,506503 ,",
        "phone": "97144375100 / 971588271196",
        "email": "libby.edwards-smith@gowlingwlg.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "436703ba-b9c0-4dcb-93b2-1299c7a051f4",
    "firmName": "Gowling WLG (UK) LLP (Dubai Branch)",
    "registrationNumber": "L-06379",
    "licenseIssueDate": "06/12/2024 00:00:00",
    "licenseExpiryDate": "06/11/2026 00:00:00"
  },
  {
    "id": "ded5faa7-a1e9-4b7b-9679-fbb72a1d4668",
    "slug": "daniel-luke-goddard",
    "name": "Daniel Luke Goddard",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBETAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/26/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Daniel Luke Goddard",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ded5faa7-a1e9-4b7b-9679-fbb72a1d4668",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-05308",
    "licenseIssueDate": "04/26/2022 00:00:00",
    "licenseExpiryDate": "04/25/2026 00:00:00"
  },
  {
    "id": "88d8923d-205c-43ee-a7d9-48f567bd1ad5",
    "slug": "daniel-nicholas-mccarthy",
    "name": "Daniel Nicholas Mccarthy",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBETgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/14/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Daniel Nicholas Mccarthy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_88d8923d-205c-43ee-a7d9-48f567bd1ad5",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-06681",
    "licenseIssueDate": "02/14/2025 00:00:00",
    "licenseExpiryDate": "02/13/2026 00:00:00"
  },
  {
    "id": "d6becc5c-d897-4252-9e51-d1738bd1c022",
    "slug": "daniel-patrovi",
    "name": "Daniel Patrovi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/06/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Daniel Patrovi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d6becc5c-d897-4252-9e51-d1738bd1c022",
        "address": "",
        "phone": "97147098484 / 971505577206",
        "email": "slshadmand@jonesday.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8892bfe9-d3ec-4158-b4fd-1844606f4f30",
    "firmName": "Jones Day",
    "registrationNumber": "L-00940",
    "licenseIssueDate": "02/06/2012 00:00:00",
    "licenseExpiryDate": "01/28/2026 00:00:00"
  },
  {
    "id": "e650c2dd-7a43-4840-8bc6-5da417e2fcd2",
    "slug": "daniel-smith",
    "name": "Daniel Smith",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/02/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Daniel Smith",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e650c2dd-7a43-4840-8bc6-5da417e2fcd2",
        "address": "",
        "phone": "97143025100 / 971501501837",
        "email": "ccairns@trowers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "976857f5-9092-43cf-987d-bfa794a3fa51",
    "firmName": "Trowers & Hamlins LLP",
    "registrationNumber": "L-03537",
    "licenseIssueDate": "11/02/2016 00:00:00",
    "licenseExpiryDate": "10/29/2025 00:00:00"
  },
  {
    "id": "db955086-4e33-408a-9523-39e9bc9a7f4c",
    "slug": "daniel-trent-bunoza",
    "name": "Daniel Trent Bunoza",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/03/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Daniel Trent Bunoza",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_db955086-4e33-408a-9523-39e9bc9a7f4c",
        "address": "Building 5 ,Dubai World Trade Centre ,212620 ,",
        "phone": "97143503600 / 971563631562",
        "email": "p.ellingham@kennedys-law.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "83d3ede1-3a28-4b03-8c92-6bd31a1cb95e",
    "firmName": "Kennedys Dubai LLP",
    "registrationNumber": "L-05448",
    "licenseIssueDate": "08/03/2022 00:00:00",
    "licenseExpiryDate": "08/02/2026 00:00:00"
  },
  {
    "id": "2f6c8b3d-d530-49d5-9be8-5310a9add9fc",
    "slug": "daniel-wood",
    "name": "Daniel Wood",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/08/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Daniel Wood",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2f6c8b3d-d530-49d5-9be8-5310a9add9fc",
        "address": "",
        "phone": "97143637999 / 971506525633",
        "email": "daniel.wood@walkersglobal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "a3a9927b-d51c-490c-8be6-d575ea3eb041",
    "firmName": "Walkers (Middle East) LLP",
    "registrationNumber": "L-00690",
    "licenseIssueDate": "09/08/2011 00:00:00",
    "licenseExpiryDate": "08/30/2026 00:00:00"
  },
  {
    "id": "4b5dc93b-c9a0-4577-be53-212296c2cf84",
    "slug": "daniela-di-francia",
    "name": "Daniela Di Francia",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBERAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/11/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Daniela Di Francia",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4b5dc93b-c9a0-4577-be53-212296c2cf84",
        "address": "5 ,AL SUAIDI ,AL MARARR ,506803 ,Dubai",
        "phone": "97148283966 / 971502473435",
        "email": "info@difranciafirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "0deeb936-18fc-456c-97dc-2e1cce547c2d",
    "firmName": "Di Francia Law Firm (Dubai Branch)",
    "registrationNumber": "L-01030",
    "licenseIssueDate": "10/11/2011 00:00:00",
    "licenseExpiryDate": "10/02/2025 00:00:00"
  },
  {
    "id": "be009816-0f56-4c6e-954a-e0e439e1ccc6",
    "slug": "danielle-elizabeth-crowe",
    "name": "Danielle Elizabeth Crowe",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBERQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/17/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Danielle Elizabeth Crowe",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_be009816-0f56-4c6e-954a-e0e439e1ccc6",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Walkers (Middle East) LLP",
    "registrationNumber": "L-06287",
    "licenseIssueDate": "04/17/2024 00:00:00",
    "licenseExpiryDate": "04/16/2026 00:00:00"
  },
  {
    "id": "15d61732-e2cc-46f7-b205-1f4e863d2126",
    "slug": "danielle-frances-lobo",
    "name": "Danielle Frances Lobo",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBERgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/16/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Danielle Frances Lobo",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_15d61732-e2cc-46f7-b205-1f4e863d2126",
        "address": "",
        "phone": "97143303900 / 971561753537",
        "email": "christopher@afridi-angell.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "30ce50dc-01a6-499d-8ace-3f807ddcb08d",
    "firmName": "Afridi & Angell-DED",
    "registrationNumber": "L-00109",
    "licenseIssueDate": "12/16/2011 00:00:00",
    "licenseExpiryDate": "12/07/2025 00:00:00"
  },
  {
    "id": "25057b1c-b631-4ea8-9d85-7d25ee1cbbe6",
    "slug": "danielle-renee-o-brien",
    "name": "Danielle Renee O Brien",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/26/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Danielle Renee O Brien",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_25057b1c-b631-4ea8-9d85-7d25ee1cbbe6",
        "address": "Al Fattan Currency House - Tower 1  ,Dubai International Financial Center  ,507104 ,",
        "phone": "97143978565 / 971504587822",
        "email": "Raafat.hares@dwf.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6e5f6dba-07af-4109-8c34-175296450f94",
    "firmName": "DWF (Middle East) LLP",
    "registrationNumber": "L-06394",
    "licenseIssueDate": "06/26/2024 00:00:00",
    "licenseExpiryDate": "06/25/2026 00:00:00"
  },
  {
    "id": "b6f9b05b-1ade-4930-9bc2-86c1cc7b3459",
    "slug": "daniil-vlasenko",
    "name": "Daniil Vlasenko",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEVgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/09/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Daniil Vlasenko",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b6f9b05b-1ade-4930-9bc2-86c1cc7b3459",
        "address": "",
        "phone": "97143826100 / 971507380618",
        "email": "jmiocevic@curtis.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0867bcc5-10fa-4783-91ae-b8f63e02e81a",
    "firmName": "Curtis Mallet-Prevost, Colt & Mosle LLP",
    "registrationNumber": "L-06496",
    "licenseIssueDate": "10/09/2024 00:00:00",
    "licenseExpiryDate": "10/08/2026 00:00:00"
  },
  {
    "id": "5052c53b-2293-4b21-ab21-4c62bcf84c92",
    "slug": "danila-kriuchkov",
    "name": "Danila Kriuchkov",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBESwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/16/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Danila Kriuchkov",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5052c53b-2293-4b21-ab21-4c62bcf84c92",
        "address": "",
        "phone": "97144230000 / 971552009022",
        "email": "UAE-CourtClerks@habibalmulla.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3eba82bb-8ec4-4cbd-80d0-a793cb993fde",
    "firmName": "Habib Al Mulla & Partners ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06557",
    "licenseIssueDate": "10/16/2024 00:00:00",
    "licenseExpiryDate": "10/15/2026 00:00:00"
  },
  {
    "id": "72f1d747-c0e4-4ab1-9b8f-a6ccfb16389f",
    "slug": "danila-logofet",
    "name": "Danila Logofet",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBETAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/26/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Danila Logofet",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_72f1d747-c0e4-4ab1-9b8f-a6ccfb16389f",
        "address": "",
        "phone": "97144286300 / 971506256686",
        "email": "stuart.paterson@hsf.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2f0389b3-bfde-44f4-bdd6-6e1a22f9cab2",
    "firmName": "Herbert Smith Freehills Kramer LLP",
    "registrationNumber": "L-05298",
    "licenseIssueDate": "04/26/2022 00:00:00",
    "licenseExpiryDate": "04/25/2026 00:00:00"
  },
  {
    "id": "1afc6135-db6e-4139-be04-6cb977408984",
    "slug": "danish-qazi-qazi-majid-ali",
    "name": "Danish Qazi Qazi Majid Ali",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEUQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/14/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Danish Qazi Qazi Majid Ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1afc6135-db6e-4139-be04-6cb977408984",
        "address": "",
        "phone": "97143685555",
        "email": "maisa.maarouf@bsabh.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8afa232f-52ff-4dad-82c3-9a04d66eb853",
    "firmName": "B S A AHMED BIN HAZEEM & ASSOCIATES LLP - DIFC",
    "registrationNumber": "L-06440",
    "licenseIssueDate": "08/14/2024 00:00:00",
    "licenseExpiryDate": "08/13/2026 00:00:00"
  },
  {
    "id": "7d33598d-debc-45cb-b44a-46651fb5e723",
    "slug": "darcy-downie",
    "name": "Darcy Downie",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBERAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/06/2012",
    "licenseStatus": "active",
    "licenseExpiry": "2013-06-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Darcy Downie",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7d33598d-debc-45cb-b44a-46651fb5e723",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-00275",
    "licenseIssueDate": "06/28/2012 00:00:00",
    "licenseExpiryDate": "06/20/2026 00:00:00"
  },
  {
    "id": "87453dfb-1958-4a1c-8c2b-2912832dd824",
    "slug": "darcy-elizabeth-lubich",
    "name": "Darcy Elizabeth Lubich",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBERQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/30/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Darcy Elizabeth Lubich",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_87453dfb-1958-4a1c-8c2b-2912832dd824",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-06705",
    "licenseIssueDate": "04/30/2025 00:00:00",
    "licenseExpiryDate": "04/29/2026 00:00:00"
  },
  {
    "id": "7992d11f-d909-4b5d-9b7c-bceea4ece3dd",
    "slug": "daria-plotnikova",
    "name": "Daria Plotnikova",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/31/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-01-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Daria Plotnikova",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7992d11f-d909-4b5d-9b7c-bceea4ece3dd",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-06184",
    "licenseIssueDate": "01/31/2024 00:00:00",
    "licenseExpiryDate": "01/30/2026 00:00:00"
  },
  {
    "id": "47794198-13ba-4492-a3c2-91fd7496d0ea",
    "slug": "daria-selivanova",
    "name": "Daria Selivanova",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/09/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Daria Selivanova",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_47794198-13ba-4492-a3c2-91fd7496d0ea",
        "address": "",
        "phone": "97144230000 / 971552009022",
        "email": "UAE-CourtClerks@habibalmulla.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3eba82bb-8ec4-4cbd-80d0-a793cb993fde",
    "firmName": "Habib Al Mulla & Partners ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06510",
    "licenseIssueDate": "10/09/2024 00:00:00",
    "licenseExpiryDate": "10/08/2026 00:00:00"
  },
  {
    "id": "e52311fd-f45a-4e2c-b1e9-2e18e001f6d6",
    "slug": "darik-abdi-ibrahim",
    "name": "Darik Abdi Ibrahim",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/04/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Darik Abdi Ibrahim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e52311fd-f45a-4e2c-b1e9-2e18e001f6d6",
        "address": "ICD Brookfield Place ,DIFC ,120109 ,",
        "phone": "97143173000 / 971504465229",
        "email": "DubaiLAD@akingump.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9ff29eab-adb8-40f9-ab84-216e01a381e4",
    "firmName": "Akin Gump Strauss Hauer & Feld LLP",
    "registrationNumber": "L-06479",
    "licenseIssueDate": "09/04/2024 00:00:00",
    "licenseExpiryDate": "09/03/2026 00:00:00"
  },
  {
    "id": "3aa146c7-0513-4ca9-909d-00ef582aed82",
    "slug": "darren-bradshaw",
    "name": "Darren Bradshaw",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/18/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Darren Bradshaw",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3aa146c7-0513-4ca9-909d-00ef582aed82",
        "address": "O-4801, O-4901 ,Burj al Salam Office Tower ,H Hotel ,111801 ,Dubai",
        "phone": "97143544444",
        "email": "administration@horizlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4e25fb39-6659-44f0-bc8b-3ff0f067beb0",
    "firmName": "HORIZONS & CO - LAW FIRM",
    "registrationNumber": "L-06061",
    "licenseIssueDate": "10/18/2023 00:00:00",
    "licenseExpiryDate": "10/17/2026 00:00:00"
  },
  {
    "id": "2d28edfe-2821-4bdd-b490-39a9f949f361",
    "slug": "darren-harris",
    "name": "Darren Harris",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBESAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/20/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Darren Harris",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2d28edfe-2821-4bdd-b490-39a9f949f361",
        "address": "Burj Daman ,Dubai International Financial Center ,213241 ,",
        "phone": "97144549586 / 971564189768",
        "email": "darrenaharris123@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "3cb06a05-1ad1-4487-9624-c2b716bfd2a7",
    "firmName": "Gateley UK LLP",
    "registrationNumber": "L-02400",
    "licenseIssueDate": "03/20/2014 00:00:00",
    "licenseExpiryDate": "03/13/2026 00:00:00"
  },
  {
    "id": "1058df1a-376e-4f99-ad07-4a4d36d5077d",
    "slug": "darrin-carey",
    "name": "Darrin Carey",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/26/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Darrin Carey",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1058df1a-376e-4f99-ad07-4a4d36d5077d",
        "address": "0 ,ICD Brookfield Place Level 13 ,Trade Centre ,506569 ,Dubai",
        "phone": "97145099100 / 971501006965",
        "email": "menahr@freshfields.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "970f6246-e737-41a7-9c6c-5aa5b8335d45",
    "firmName": "Freshfields LLP DIFC",
    "registrationNumber": "L-06384",
    "licenseIssueDate": "06/26/2024 00:00:00",
    "licenseExpiryDate": "06/25/2026 00:00:00"
  },
  {
    "id": "1d3c6af1-1406-4825-8bd5-0c0c5940cc0f",
    "slug": "dasith-madhusanka-vithanage",
    "name": "Dasith Madhusanka Vithanage",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBETQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/09/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Dasith Madhusanka Vithanage",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1d3c6af1-1406-4825-8bd5-0c0c5940cc0f",
        "address": "ICD-Brookfield Place ,DIFC ,119974 ,",
        "phone": "97143652000",
        "email": "david.charlier@ashurst.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c01c3c61-4d90-4058-8429-61dd01e615f5",
    "firmName": "Ashurst LLP-DIFC",
    "registrationNumber": "L-06541",
    "licenseIssueDate": "10/09/2024 00:00:00",
    "licenseExpiryDate": "10/08/2026 00:00:00"
  },
  {
    "id": "e8eaaff5-fbdd-41b3-aca1-a30df1560578",
    "slug": "david-alexander-mcgrory",
    "name": "David Alexander Mcgrory",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/13/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: David Alexander Mcgrory",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e8eaaff5-fbdd-41b3-aca1-a30df1560578",
        "address": "",
        "phone": "97144020800 / 971566830829",
        "email": "dean.ryburn@dentons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dfe13b7e-6625-45fd-ad63-9ee83af41194",
    "firmName": "Dentons & Co Dubai Branch-DED",
    "registrationNumber": "L-05126",
    "licenseIssueDate": "12/13/2021 00:00:00",
    "licenseExpiryDate": "12/12/2025 00:00:00"
  },
  {
    "id": "c1efc2da-0b87-4f1a-98a4-96847f651861",
    "slug": "david-andrew-keen",
    "name": "David Andrew Keen",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/13/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: David Andrew Keen",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c1efc2da-0b87-4f1a-98a4-96847f651861",
        "address": "THE OFFICES 1 ,DWTC ,115580 ,",
        "phone": "97143739700 / 971501148248",
        "email": "nitesh.pradhan@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "361fdc64-6b6f-4f37-abca-c52af8473b84",
    "firmName": "Pinsent Masons  LLP (DWTCA Branch)",
    "registrationNumber": "L-07004"
  },
  {
    "id": "a80314df-3e4f-40e6-b9bb-9144483ab70c",
    "slug": "david-andrew-true",
    "name": "David Andrew True",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/02/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: David Andrew True",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a80314df-3e4f-40e6-b9bb-9144483ab70c",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-04943",
    "licenseIssueDate": "09/02/2024 00:00:00",
    "licenseExpiryDate": "09/01/2026 00:00:00"
  },
  {
    "id": "f6134a28-dcd2-458e-81d3-7e97c6622118",
    "slug": "david-anthony-hayward",
    "name": "David Anthony Hayward",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/12/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-11-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: David Anthony Hayward",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f6134a28-dcd2-458e-81d3-7e97c6622118",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506698 ,Dubai",
        "phone": "97147046300 / 971507900661",
        "email": "nada.mourad@lw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b2b92ce9-90a4-4e34-ae2f-ae0dc7ca9060",
    "firmName": "Latham & Watkins LLP",
    "registrationNumber": "L-04605",
    "licenseIssueDate": "01/12/2020 00:00:00",
    "licenseExpiryDate": "01/11/2026 00:00:00"
  },
  {
    "id": "683eb5f2-0e12-4d82-a762-c0739bc2bc17",
    "slug": "david-bevan",
    "name": "David Bevan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/28/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: David Bevan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_683eb5f2-0e12-4d82-a762-c0739bc2bc17",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-03739",
    "licenseIssueDate": "03/28/2017 00:00:00",
    "licenseExpiryDate": "03/24/2026 00:00:00"
  },
  {
    "id": "d26196f5-e42c-44d6-ad50-ab8d2f21bce5",
    "slug": "david-charlier",
    "name": "David Charlier",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: David Charlier",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d26196f5-e42c-44d6-ad50-ab8d2f21bce5",
        "address": "ICD-Brookfield Place ,DIFC ,119974 ,",
        "phone": "97143652000",
        "email": "david.charlier@ashurst.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "c01c3c61-4d90-4058-8429-61dd01e615f5",
    "firmName": "Ashurst LLP-DIFC",
    "registrationNumber": "L-00602",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "0c15f29b-652f-4da0-9dd9-cc86b0a8d9cb",
    "slug": "david-damilola-temitope-odejayi",
    "name": "David Damilola Temitope Odejayi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBERAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/10/2021",
    "licenseStatus": "active",
    "licenseExpiry": "2022-10-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: David Damilola Temitope Odejayi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0c15f29b-652f-4da0-9dd9-cc86b0a8d9cb",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-05066",
    "licenseIssueDate": "10/11/2021 00:00:00",
    "licenseExpiryDate": "10/10/2026 00:00:00"
  },
  {
    "id": "27dcac39-a7f2-4597-97ea-77187dd228cc",
    "slug": "david-eric-william-leckie",
    "name": "david eric william  leckie",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBERQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/05/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: david eric william  leckie",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_27dcac39-a7f2-4597-97ea-77187dd228cc",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-05520",
    "licenseIssueDate": "10/05/2022 00:00:00",
    "licenseExpiryDate": "10/04/2026 00:00:00"
  },
  {
    "id": "f6276ab9-cd1c-4684-9fb2-83dd3388338f",
    "slug": "david-foster",
    "name": "David Foster",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBERgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: David Foster",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f6276ab9-cd1c-4684-9fb2-83dd3388338f",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-00216",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "b0d9bd21-3d4d-4af9-8100-6cc019ca2b8e",
    "slug": "david-iain-fraser-welford",
    "name": "David Iain Fraser Welford",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBESQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/13/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: David Iain Fraser Welford",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b0d9bd21-3d4d-4af9-8100-6cc019ca2b8e",
        "address": "Unit No. S1003, Level 10 ,Emirates Financial Towers ,Dubai International Financial Centre ,000 ,Dubai",
        "phone": "97144501900 / 971566072398",
        "email": "david.welford@ogier.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "7387d35c-79ea-44c2-88c5-58669a5e825d",
    "firmName": "Ogier (DIFC) LLP",
    "registrationNumber": "L-06148",
    "licenseIssueDate": "12/13/2023 00:00:00",
    "licenseExpiryDate": "12/12/2025 00:00:00"
  },
  {
    "id": "c7bc4fe4-1674-43ae-ba63-962193598f6d",
    "slug": "david-james-kidman",
    "name": "David James Kidman",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBESgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/08/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-07-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: David James Kidman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c7bc4fe4-1674-43ae-ba63-962193598f6d",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506688 ,Dubai",
        "phone": "97147096600 / 971503556811",
        "email": "muneer.khan@simmons-simmons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d1725ca7-06ac-41b2-8d7b-a6e60665b73d",
    "firmName": "Simmons & Simmons (Middle East) LLP-DIFC",
    "registrationNumber": "L-06633",
    "licenseIssueDate": "01/08/2025 00:00:00",
    "licenseExpiryDate": "01/07/2026 00:00:00"
  },
  {
    "id": "756fa79e-1869-4082-bad0-b46fe6473b7f",
    "slug": "david-jeremy-wloszczowski",
    "name": "David Jeremy Wloszczowski",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBESgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/10/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: David Jeremy Wloszczowski",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_756fa79e-1869-4082-bad0-b46fe6473b7f",
        "address": "IH-00-01-CP-05 ,DIFC ,506832 ,",
        "phone": "/ 971506957753",
        "email": "admin@supportlegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "1607c199-ca4b-4bc1-89e9-98dad0300645",
    "firmName": "Support Legal ( DIFC) Limited",
    "registrationNumber": "L-04732",
    "licenseIssueDate": "01/10/2025 00:00:00",
    "licenseExpiryDate": "01/09/2026 00:00:00"
  },
  {
    "id": "942c06d8-91da-4c07-bf36-606067be1641",
    "slug": "david-john-holloway",
    "name": "David John Holloway",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBESgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/09/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: David John Holloway",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_942c06d8-91da-4c07-bf36-606067be1641",
        "address": "",
        "phone": "97143641686 / 971506288801",
        "email": "b.kadir@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0ba96df8-e4cc-49c2-8ae4-a42878d95926",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS LLC",
    "registrationNumber": "L-05718",
    "licenseIssueDate": "02/09/2023 00:00:00",
    "licenseExpiryDate": "02/08/2026 00:00:00"
  },
  {
    "id": "a36a53d2-93cd-4c3a-85ec-2729dc161fa3",
    "slug": "david-larcombe-yates",
    "name": "David Larcombe Yates",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBETAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/02/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: David Larcombe Yates",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a36a53d2-93cd-4c3a-85ec-2729dc161fa3",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-05574",
    "licenseIssueDate": "11/02/2022 00:00:00",
    "licenseExpiryDate": "11/01/2025 00:00:00"
  },
  {
    "id": "48105369-0062-47dc-8602-477e60b871cc",
    "slug": "david-leon-rustin-berman",
    "name": "David Leon Rustin Berman",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBETAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/15/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-02-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: David Leon Rustin Berman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_48105369-0062-47dc-8602-477e60b871cc",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-04860",
    "licenseIssueDate": "02/15/2021 00:00:00",
    "licenseExpiryDate": "02/14/2026 00:00:00"
  },
  {
    "id": "0b1aa85c-277a-4453-9921-cfcb7fb2ba6f",
    "slug": "david-lyndon-richards",
    "name": "DAVID LYNDON RICHARDS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBETAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/20/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: DAVID LYNDON RICHARDS",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0b1aa85c-277a-4453-9921-cfcb7fb2ba6f",
        "address": "",
        "phone": "97143563900 / 971564663035",
        "email": "c.miller@Beale-Law.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0f74c5fc-87d6-451a-b380-576b0bc3ceb8",
    "firmName": "Beale & Company (Middle East)",
    "registrationNumber": "L-04392",
    "licenseIssueDate": "10/20/2020 00:00:00",
    "licenseExpiryDate": "10/19/2025 00:00:00"
  },
  {
    "id": "90c78450-c7ef-45f1-89c8-63a1b95af3ee",
    "slug": "david-mcdonald",
    "name": "David McDonald",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBETQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/14/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: David McDonald",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_90c78450-c7ef-45f1-89c8-63a1b95af3ee",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506688 ,Dubai",
        "phone": "97147096600 / 971503556811",
        "email": "muneer.khan@simmons-simmons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d1725ca7-06ac-41b2-8d7b-a6e60665b73d",
    "firmName": "Simmons & Simmons (Middle East) LLP-DIFC",
    "registrationNumber": "L-02561",
    "licenseIssueDate": "05/14/2014 00:00:00",
    "licenseExpiryDate": "05/08/2026 00:00:00"
  },
  {
    "id": "6fc2f997-f4a8-46f2-8316-d8eaca663765",
    "slug": "david-pang",
    "name": "David Pang",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/11/2013",
    "licenseStatus": "active",
    "licenseExpiry": "2014-11-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: David Pang",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6fc2f997-f4a8-46f2-8316-d8eaca663765",
        "address": "",
        "phone": "97144020800 / 971566830829",
        "email": "dean.ryburn@dentons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dfe13b7e-6625-45fd-ad63-9ee83af41194",
    "firmName": "Dentons & Co Dubai Branch-DED",
    "registrationNumber": "L-02691",
    "licenseIssueDate": "11/12/2013 00:00:00",
    "licenseExpiryDate": "11/05/2025 00:00:00"
  },
  {
    "id": "6feda015-cc2b-419c-bfa4-0bdfbfec86dd",
    "slug": "david-platt",
    "name": "David Platt",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/11/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: David Platt",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6feda015-cc2b-419c-bfa4-0bdfbfec86dd",
        "address": "THE OFFICES 1 ,DWTC ,115580 ,",
        "phone": "97143739700 / 971501148248",
        "email": "nitesh.pradhan@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "361fdc64-6b6f-4f37-abca-c52af8473b84",
    "firmName": "Pinsent Masons  LLP (DWTCA Branch)",
    "registrationNumber": "L-05798",
    "licenseIssueDate": "05/11/2023 00:00:00",
    "licenseExpiryDate": "05/10/2026 00:00:00"
  },
  {
    "id": "39515b96-39aa-4d22-8f11-91bbc808b5b6",
    "slug": "david-rowcroft-bintliff",
    "name": "DAVID ROWCROFT BINTLIFF",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/07/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: DAVID ROWCROFT BINTLIFF",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_39515b96-39aa-4d22-8f11-91bbc808b5b6",
        "address": "",
        "phone": "97145953601 / 971508728645",
        "email": "Steven.Bainbridge@gtlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b4146aa6-efd1-41d7-819d-49da46353b0b",
    "firmName": "Greenberg Traurig Limited",
    "registrationNumber": "L-03959",
    "licenseIssueDate": "01/07/2018 00:00:00",
    "licenseExpiryDate": "01/04/2026 00:00:00"
  },
  {
    "id": "841a6a1d-4c80-4a00-a6a3-e39a9951d381",
    "slug": "david-russell-gallo",
    "name": "David Russell Gallo",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/04/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: David Russell Gallo",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_841a6a1d-4c80-4a00-a6a3-e39a9951d381",
        "address": "zayed saeed saif alshamsi ,الرابع مكتب رقم 414 ,قرية الاعمال ,بجانب دائرة التنمية الاقتصادية - دوار الساعة  ,6030 ,Dubai",
        "phone": "97142680800",
        "email": "info@zayedalshamsi.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "295c7198-77b4-4f9a-a4d2-bad9a78e074d",
    "firmName": "ZAYED AL SHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05057",
    "licenseIssueDate": "10/04/2021 00:00:00",
    "licenseExpiryDate": "10/03/2026 00:00:00"
  },
  {
    "id": "4e1f163a-b5b2-44ec-90ba-aa8764228e7d",
    "slug": "david-slim",
    "name": "David Slim",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/31/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: David Slim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4e1f163a-b5b2-44ec-90ba-aa8764228e7d",
        "address": "",
        "phone": "97144020800 / 971566830829",
        "email": "dean.ryburn@dentons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dfe13b7e-6625-45fd-ad63-9ee83af41194",
    "firmName": "Dentons & Co Dubai Branch-DED",
    "registrationNumber": "L-04345",
    "licenseIssueDate": "03/31/2019 00:00:00",
    "licenseExpiryDate": "03/29/2026 00:00:00"
  },
  {
    "id": "a35b5ba6-d1ef-4e98-a544-fc6012b35590",
    "slug": "david-thomas-garvin",
    "name": "DAVID THOMAS GARVIN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/08/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: DAVID THOMAS GARVIN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a35b5ba6-d1ef-4e98-a544-fc6012b35590",
        "address": "Level 14 ,Burj Daman ,Four Seasons Hotel ,119980 ,Dubai",
        "phone": "97143604070 / 971502450485",
        "email": "Philip.ireland@maples.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "cb7cc285-8538-469a-b075-ef30819bce69",
    "firmName": "Maples & Calder (Dubai) LLP",
    "registrationNumber": "L-04583",
    "licenseIssueDate": "01/08/2020 00:00:00",
    "licenseExpiryDate": "01/07/2026 00:00:00"
  },
  {
    "id": "29975802-c114-4256-871c-468d67cebf48",
    "slug": "dawood-sulaiman-agha",
    "name": "DAWOOD SULAIMAN SULAIMAN AGHA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/09/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-09-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Dawood Sulaiman Agha",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_29975802-c114-4256-871c-468d67cebf48",
        "address": "",
        "phone": "97142865353 / 971551986013",
        "email": "info@alzahmyadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "fd77d7cf-7bee-4da2-8757-d004294b9189",
    "firmName": "AL ZAHMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02601",
    "licenseIssueDate": "09/26/2011 00:00:00",
    "licenseExpiryDate": "09/17/2020 00:00:00"
  },
  {
    "id": "05712a88-ac75-48f0-aa25-a15c9ba90a76",
    "slug": "dean-frances",
    "name": "Dean Frances",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBERgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/24/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Dean Frances",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_05712a88-ac75-48f0-aa25-a15c9ba90a76",
        "address": "Burj Daman ,Dubai International Financial Center ,213241 ,",
        "phone": "97144549586 / 971564189768",
        "email": "darrenaharris123@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3cb06a05-1ad1-4487-9624-c2b716bfd2a7",
    "firmName": "Gateley UK LLP",
    "registrationNumber": "L-02401",
    "licenseIssueDate": "04/24/2014 00:00:00",
    "licenseExpiryDate": "04/17/2026 00:00:00"
  },
  {
    "id": "72890e84-b1cd-42f7-a3c9-b3df5233ad62",
    "slug": "dean-oleary",
    "name": "Dean O'Leary",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBETwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/22/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Dean O'Leary",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_72890e84-b1cd-42f7-a3c9-b3df5233ad62",
        "address": "الطابق 7 مكتب رقم 070A ,برج رولكس  ,محطة مترو المركز المالي  ,66300 ,Dubai",
        "phone": "97143444029",
        "email": "ekp.khalidaltmimi@ekplegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "400838f1-4e75-4836-9698-b9e19dd30a18",
    "firmName": "KHALID ABDALLA ALTAMIMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01249",
    "licenseIssueDate": "03/22/2012 00:00:00",
    "licenseExpiryDate": "03/13/2026 00:00:00"
  },
  {
    "id": "c9f71f79-5804-4273-9eee-c01d34430542",
    "slug": "dean-ryburn",
    "name": "Dean Ryburn",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/10/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Dean Ryburn",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c9f71f79-5804-4273-9eee-c01d34430542",
        "address": "",
        "phone": "97144020800 / 971566830829",
        "email": "dean.ryburn@dentons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "dfe13b7e-6625-45fd-ad63-9ee83af41194",
    "firmName": "Dentons & Co Dubai Branch-DED",
    "registrationNumber": "L-00408",
    "licenseIssueDate": "04/10/2017 00:00:00",
    "licenseExpiryDate": "04/06/2026 00:00:00"
  },
  {
    "id": "48d2ba28-d411-4d45-b76e-0571735720f7",
    "slug": "debashis-dey",
    "name": "Debashis Dey",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBERAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Debashis Dey",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_48d2ba28-d411-4d45-b76e-0571735720f7",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-00141",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "ca0d40a7-f197-47b9-8ac8-b06219fee1ce",
    "slug": "debbie-stevens",
    "name": "Debbie Stevens",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/16/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Debbie Stevens",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ca0d40a7-f197-47b9-8ac8-b06219fee1ce",
        "address": "",
        "phone": "97144286300 / 971506256686",
        "email": "stuart.paterson@hsf.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2f0389b3-bfde-44f4-bdd6-6e1a22f9cab2",
    "firmName": "Herbert Smith Freehills Kramer LLP",
    "registrationNumber": "L-05665",
    "licenseIssueDate": "03/16/2023 00:00:00",
    "licenseExpiryDate": "03/15/2026 00:00:00"
  },
  {
    "id": "cbcaf4fe-984a-4345-8045-382de9b3c711",
    "slug": "declan-ned-lok-hey-ng",
    "name": "Declan Ned Lok Hey Ng",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBETgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/21/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Declan Ned Lok Hey Ng",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cbcaf4fe-984a-4345-8045-382de9b3c711",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-06207",
    "licenseIssueDate": "02/21/2024 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "a029c19e-46ab-4907-bf6c-9aff95a1e417",
    "slug": "deepa-popat",
    "name": "Deepa Popat",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/23/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Deepa Popat",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a029c19e-46ab-4907-bf6c-9aff95a1e417",
        "address": "1 ,API World Tower ,258.37 square meters ,52294 ,Dubai",
        "phone": "97143317552 / 971504524322",
        "email": "berry@jamesberrylaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "f85683bf-f79f-4e38-9b7c-a1a75cd840b4",
    "firmName": "James Berry & Associates Legal Consultants",
    "registrationNumber": "L-02584",
    "licenseIssueDate": "06/23/2014 00:00:00",
    "licenseExpiryDate": "06/17/2026 00:00:00"
  },
  {
    "id": "a99ce7d9-ce00-4c16-a280-6a7013a96a92",
    "slug": "deepa-sureshbabu",
    "name": "Deepa Sureshbabu",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/28/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Deepa Sureshbabu",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a99ce7d9-ce00-4c16-a280-6a7013a96a92",
        "address": "1 ,API World Tower ,258.37 square meters ,52294 ,Dubai",
        "phone": "97143317552 / 971504524322",
        "email": "berry@jamesberrylaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "f85683bf-f79f-4e38-9b7c-a1a75cd840b4",
    "firmName": "James Berry & Associates Legal Consultants",
    "registrationNumber": "L-03016",
    "licenseIssueDate": "05/28/2015 00:00:00",
    "licenseExpiryDate": "05/23/2026 00:00:00"
  },
  {
    "id": "ff266660-eaa6-4ee2-afd6-a5a49e2fbb54",
    "slug": "deepak-azad",
    "name": "Deepak Azad",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/25/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Deepak Azad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ff266660-eaa6-4ee2-afd6-a5a49e2fbb54",
        "address": "",
        "phone": "97142659440",
        "email": "info@klaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d42ce31f-e881-40e1-bd66-bf2e5bb9bb1e",
    "firmName": "KHALED ALMARRI & PARTNERS& LEGAL CONSULTATIONS",
    "registrationNumber": "L-04719",
    "licenseIssueDate": "04/25/2022 00:00:00",
    "licenseExpiryDate": "04/24/2026 00:00:00"
  },
  {
    "id": "cd87def8-319c-4d54-922a-f5342ee123c5",
    "slug": "deepak-kumar-nagpal",
    "name": "Deepak Kumar Nagpal",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBESwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/13/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Deepak Kumar Nagpal",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cd87def8-319c-4d54-922a-f5342ee123c5",
        "address": "THE OFFICES 1 ,DWTC ,115580 ,",
        "phone": "97143739700 / 971501148248",
        "email": "nitesh.pradhan@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "361fdc64-6b6f-4f37-abca-c52af8473b84",
    "firmName": "Pinsent Masons  LLP (DWTCA Branch)",
    "registrationNumber": "L-07003"
  },
  {
    "id": "77553c91-288e-4d17-9ce4-9e014c3ca980",
    "slug": "denis-acker",
    "name": "Denis Acker",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/16/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Denis Acker",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_77553c91-288e-4d17-9ce4-9e014c3ca980",
        "address": "",
        "phone": "97143550004 / 971506246248",
        "email": "canlaw@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "1ae95666-08c9-4857-b2b4-480be766b063",
    "firmName": "Acker Choquette Legal Consultants",
    "registrationNumber": "L-00394",
    "licenseIssueDate": "12/16/2011 00:00:00",
    "licenseExpiryDate": "12/07/2025 00:00:00"
  },
  {
    "id": "e86b2a69-9ece-4517-88db-c5ee42f2b8cc",
    "slug": "denis-moriarty",
    "name": "Denis Moriarty",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBETQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/11/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Denis Moriarty",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e86b2a69-9ece-4517-88db-c5ee42f2b8cc",
        "address": "",
        "phone": "97143438897 / 971507753952",
        "email": "jdavidson@davidson-legal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d0200f27-9504-4653-a5c6-05e4bcab7ff0",
    "firmName": "Davidson & Co Legal Consultants",
    "registrationNumber": "L-00747",
    "licenseIssueDate": "10/11/2021 00:00:00",
    "licenseExpiryDate": "10/10/2025 00:00:00"
  },
  {
    "id": "88e214e8-e071-4347-80a9-9eaf13836fe5",
    "slug": "deniz-ghazal",
    "name": "DENIZ GHAZAL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBERwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/08/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2022-08-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Deniz Ghazal",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_88e214e8-e071-4347-80a9-9eaf13836fe5",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04191",
    "licenseIssueDate": "08/29/2018 00:00:00",
    "licenseExpiryDate": "08/27/2022 00:00:00"
  },
  {
    "id": "4c6b2253-ddd4-45aa-a967-c645835a30b9",
    "slug": "deniz-tas",
    "name": "Deniz Tas",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/01/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Deniz Tas",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4c6b2253-ddd4-45aa-a967-c645835a30b9",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-02918",
    "licenseIssueDate": "02/01/2015 00:00:00",
    "licenseExpiryDate": "01/26/2026 00:00:00"
  },
  {
    "id": "c6870688-d251-437f-b6c9-ae1f1b16c860",
    "slug": "derek-kirton",
    "name": "Derek Kirton",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBESwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/16/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Derek Kirton",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c6870688-d251-437f-b6c9-ae1f1b16c860",
        "address": "",
        "phone": "97142472100 / 971509224336",
        "email": "bhaley@cov.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "65a2e90a-6978-4292-b3f1-ecbebedd7b9a",
    "firmName": "Covington & Burling LLP (Middle East)",
    "registrationNumber": "L-00855",
    "licenseIssueDate": "12/16/2011 00:00:00",
    "licenseExpiryDate": "12/07/2025 00:00:00"
  },
  {
    "id": "3372cec5-a383-48a2-9ea0-a927ab2a47d3",
    "slug": "derek-scott-robins",
    "name": "Derek Scott Robins",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/30/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Derek Scott Robins",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3372cec5-a383-48a2-9ea0-a927ab2a47d3",
        "address": "",
        "phone": "97143685555",
        "email": "maisa.maarouf@bsabh.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8afa232f-52ff-4dad-82c3-9a04d66eb853",
    "firmName": "B S A AHMED BIN HAZEEM & ASSOCIATES LLP - DIFC",
    "registrationNumber": "L-05149",
    "licenseIssueDate": "12/30/2021 00:00:00",
    "licenseExpiryDate": "12/29/2025 00:00:00"
  },
  {
    "id": "ea4a9cfe-9d94-4c28-a237-544ad3a69bee",
    "slug": "devvrat-periwal",
    "name": "Devvrat Periwal",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/03/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Devvrat Periwal",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ea4a9cfe-9d94-4c28-a237-544ad3a69bee",
        "address": "",
        "phone": "97144529091 / 971552805308",
        "email": "ashafi@ach-legal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4f3e1e80-c812-4585-9570-229cd96776a4",
    "firmName": "Anjarwalla, Collins and Haidermota Legal Consultants",
    "registrationNumber": "L-02488",
    "licenseIssueDate": "04/03/2014 00:00:00",
    "licenseExpiryDate": "03/27/2026 00:00:00"
  },
  {
    "id": "5e1470ab-0c8e-453e-8ee3-273e922d4006",
    "slug": "deyaaldeen-safwat-aldeeb",
    "name": "Deyaaldeen  Safwat Aldeeb",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/31/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Deyaaldeen  Safwat Aldeeb",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5e1470ab-0c8e-453e-8ee3-273e922d4006",
        "address": "Mohamed Alhammadi ,FLOOR 16 OFFICE B1605 ,LATIFA TOWER ,CLOSE TO CROWN PLAZA HOTEL ,76550 ,Dubai",
        "phone": "97143298866",
        "email": "admin@dralhammadilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "612e75e6-c3f3-479b-bc93-ee88982dea58",
    "firmName": "DR MOHAMED ALHAMMADI ADVOCATES & LEGAL CONSULTANTS OFFICE",
    "registrationNumber": "L-01430",
    "licenseIssueDate": "03/31/2013 00:00:00",
    "licenseExpiryDate": "03/23/2026 00:00:00"
  },
  {
    "id": "f36a9c37-5172-4546-baba-bf4b16018f8e",
    "slug": "dhruv-agarwal-anil-agarwal",
    "name": "DHRUV AGARWAL ANIL AGARWAL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/20/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: DHRUV AGARWAL ANIL AGARWAL",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f36a9c37-5172-4546-baba-bf4b16018f8e",
        "address": "",
        "phone": "97145979700 / 971505532609",
        "email": "rbeydoun@t-lawadvisors.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3d9f2bb9-85fe-49cc-9187-0b808bfa2a2d",
    "firmName": "Rindala Beydoun Legal Consultancy",
    "registrationNumber": "L-05032",
    "licenseIssueDate": "09/20/2021 00:00:00",
    "licenseExpiryDate": "09/19/2026 00:00:00"
  },
  {
    "id": "83e4151e-d975-43cf-9031-fe20a0d499d5",
    "slug": "diana-ruth-froyland",
    "name": "Diana Ruth Froyland",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/18/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-01-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Diana Ruth Froyland",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_83e4151e-d975-43cf-9031-fe20a0d499d5",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-05670",
    "licenseIssueDate": "01/18/2023 00:00:00",
    "licenseExpiryDate": "01/17/2026 00:00:00"
  },
  {
    "id": "36091af3-9fb0-4be6-b7c6-07f6c5f01924",
    "slug": "diederik-wintershoven",
    "name": "Diederik Wintershoven",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/18/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Diederik Wintershoven",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_36091af3-9fb0-4be6-b7c6-07f6c5f01924",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506688 ,Dubai",
        "phone": "97147096600 / 971503556811",
        "email": "muneer.khan@simmons-simmons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d1725ca7-06ac-41b2-8d7b-a6e60665b73d",
    "firmName": "Simmons & Simmons (Middle East) LLP-DIFC",
    "registrationNumber": "L-06900",
    "licenseIssueDate": "08/18/2025 00:00:00",
    "licenseExpiryDate": "08/17/2026 00:00:00"
  },
  {
    "id": "76a1fbe6-d54d-43f1-a5b7-d19c6a2f8706",
    "slug": "dilara-uludag",
    "name": "Dilara Uludag",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEVQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/01/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Dilara Uludag",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_76a1fbe6-d54d-43f1-a5b7-d19c6a2f8706",
        "address": "",
        "phone": "97145132619 / 971543630593",
        "email": "info@alfaisal.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "fd647c60-3bff-4297-87f1-6437acf45575",
    "firmName": "FAISAL SALEM ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-06973",
    "licenseIssueDate": "09/24/2025 00:00:00",
    "licenseExpiryDate": "09/23/2026 00:00:00"
  },
  {
    "id": "0b8304f4-8def-4c01-a728-bf012cb85bb8",
    "slug": "dilini-purnima-lokuaddassuriyage",
    "name": "Dilini Purnima Lokuaddassuriyage",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/22/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Dilini Purnima Lokuaddassuriyage",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0b8304f4-8def-4c01-a728-bf012cb85bb8",
        "address": "Burj Daman ,Dubai International Financial Center ,213241 ,",
        "phone": "97144549586 / 971564189768",
        "email": "darrenaharris123@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3cb06a05-1ad1-4487-9624-c2b716bfd2a7",
    "firmName": "Gateley UK LLP",
    "registrationNumber": "L-04828",
    "licenseIssueDate": "12/22/2023 00:00:00",
    "licenseExpiryDate": "12/21/2025 00:00:00"
  },
  {
    "id": "59304ed7-1405-4564-9b09-aa738d9de19a",
    "slug": "dimitriy-mednikov",
    "name": "Dimitriy Mednikov",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBETQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/29/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Dimitriy Mednikov",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_59304ed7-1405-4564-9b09-aa738d9de19a",
        "address": "",
        "phone": "97144230000 / 971552009022",
        "email": "UAE-CourtClerks@habibalmulla.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3eba82bb-8ec4-4cbd-80d0-a793cb993fde",
    "firmName": "Habib Al Mulla & Partners ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05776",
    "licenseIssueDate": "03/29/2023 00:00:00",
    "licenseExpiryDate": "03/28/2026 00:00:00"
  },
  {
    "id": "d8cdeb4b-76a4-41ec-9295-3506ded38104",
    "slug": "dina-mustafa-shriem",
    "name": "Dina Mustafa Shriem",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBETQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/20/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Dina Mustafa Shriem",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d8cdeb4b-76a4-41ec-9295-3506ded38104",
        "address": "",
        "phone": "97144230555 / 971504788443",
        "email": "yah@hfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c462c65e-185a-4e81-8425-a87e3a2b6842",
    "firmName": "Holman Fenwick Willan Middle East LLP",
    "registrationNumber": "L-06140",
    "licenseIssueDate": "12/20/2023 00:00:00",
    "licenseExpiryDate": "12/19/2025 00:00:00"
  },
  {
    "id": "0572258f-897a-4fbe-ba8f-5d976270f945",
    "slug": "dinush-justin-de-silva-wickremanayake",
    "name": "Dinush Justin De Silva Wickremanayake",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBESgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/12/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Dinush Justin De Silva Wickremanayake",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0572258f-897a-4fbe-ba8f-5d976270f945",
        "address": "ICD Brookfield Place ,DIFC ,506516 ,",
        "phone": "97143695800 / 971505526206",
        "email": "scott.campbell@linklaters.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5cec94c0-0649-43b6-a2be-ab17ff422bce",
    "firmName": "LinkLaters LLP",
    "registrationNumber": "L-04888",
    "licenseIssueDate": "04/12/2021 00:00:00",
    "licenseExpiryDate": "04/11/2026 00:00:00"
  },
  {
    "id": "9d8375ab-e49f-4eb7-8c37-e1edc66bd823",
    "slug": "dipak-thakur",
    "name": "Dipak Thakur",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/11/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Dipak Thakur",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9d8375ab-e49f-4eb7-8c37-e1edc66bd823",
        "address": "الطابق الثاني 206 ,باي سكوير رقم 11 ,دبي مول ,49793 ,Dubai",
        "phone": "97144518209 / 971506503353",
        "email": "info@rayyanadvo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2c9d4a42-7cb3-4c95-88eb-2792bb07b395",
    "firmName": "RAYYAN ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02729",
    "licenseIssueDate": "11/11/2014 00:00:00",
    "licenseExpiryDate": "11/05/2025 00:00:00"
  },
  {
    "id": "073f2417-9eaa-442e-9e49-15eb0fce0c16",
    "slug": "dipali-maldonado",
    "name": "Dipali Maldonado",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBETQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/08/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Dipali Maldonado",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_073f2417-9eaa-442e-9e49-15eb0fce0c16",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02286",
    "licenseIssueDate": "09/08/2013 00:00:00",
    "licenseExpiryDate": "09/01/2026 00:00:00"
  },
  {
    "id": "c7a3e5cf-90f8-42d8-8a24-6acd5f9b0b9b",
    "slug": "divya-gambhir",
    "name": "Divya Gambhir",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBERwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Divya Gambhir",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c7a3e5cf-90f8-42d8-8a24-6acd5f9b0b9b",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01251",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "28235ca7-7073-4d2f-b6bf-0aa1c7dd038a",
    "slug": "divya-kothari",
    "name": "Divya Kothari",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBESwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/04/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Divya Kothari",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_28235ca7-7073-4d2f-b6bf-0aa1c7dd038a",
        "address": "Noura Mohamed Abdelrahman Almaazmi ,17 ,The Oberoi Center ,Burlington Tower ,414224 ,Dubai",
        "phone": "97143215777",
        "email": "case@almaazmilawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e56938ba-8d38-4268-9706-651d4c984db9",
    "firmName": "MAHMOOD HUSSAIN ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-06160",
    "licenseIssueDate": "01/04/2024 00:00:00",
    "licenseExpiryDate": "01/03/2026 00:00:00"
  },
  {
    "id": "b22c5ecf-6c6a-442f-991d-58336bf631e6",
    "slug": "divya-malhotra",
    "name": "Divya Malhotra",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBETQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/03/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Divya Malhotra",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b22c5ecf-6c6a-442f-991d-58336bf631e6",
        "address": "",
        "phone": "97143366260",
        "email": "mail@aljallaflegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d54e2e1d-7afb-435d-ab9e-5301c7e17a1f",
    "firmName": "AL JALLAF ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06940",
    "licenseIssueDate": "08/21/2025 00:00:00",
    "licenseExpiryDate": "08/20/2026 00:00:00"
  },
  {
    "id": "b8b25358-9993-4aaf-896e-09fca2d2a825",
    "slug": "diwakar-agarwal",
    "name": "Diwakar Agarwal",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Diwakar Agarwal",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b8b25358-9993-4aaf-896e-09fca2d2a825",
        "address": "",
        "phone": "97144073901 / 971503479508",
        "email": "Rania.Tadros@stephensonharwood.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dd5042a2-bb41-4123-9544-79c3fa831332",
    "firmName": "Stephenson Harwood (Middle East) LLP",
    "registrationNumber": "L-00640",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "a42a92ad-851f-4b8a-aa6f-1cfbfbb01acd",
    "slug": "doaa-ali-mohammed",
    "name": "Doaa Ali Mohammed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/23/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Doaa Ali Mohammed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a42a92ad-851f-4b8a-aa6f-1cfbfbb01acd",
        "address": "Floor 7 ,Sama Tower  ,Dubai World Trade Centre ,120059 ,Dubai",
        "phone": "97142954626 / 971506311169",
        "email": "info@jmadvocatesuae.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5a33c148-b449-40a3-a945-e3a2eb7cbdda",
    "firmName": "JASIM ALMAEENI ADVOCATES & LEGAL CONSULTANT",
    "registrationNumber": "L-02629",
    "licenseIssueDate": "12/23/2013 00:00:00",
    "licenseExpiryDate": "12/16/2025 00:00:00"
  },
  {
    "id": "8f0ff055-e10f-460e-9ab9-2619c8b4d36a",
    "slug": "dominic-pavandeep-singh-athwal",
    "name": "Dominic Pavandeep Singh Athwal",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/22/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Dominic Pavandeep Singh Athwal",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8f0ff055-e10f-460e-9ab9-2619c8b4d36a",
        "address": "Unit No. S1003, Level 10 ,Emirates Financial Towers ,Dubai International Financial Centre ,000 ,Dubai",
        "phone": "97144501900 / 971566072398",
        "email": "david.welford@ogier.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7387d35c-79ea-44c2-88c5-58669a5e825d",
    "firmName": "Ogier (DIFC) LLP",
    "registrationNumber": "L-06324",
    "licenseIssueDate": "05/22/2024 00:00:00",
    "licenseExpiryDate": "05/21/2026 00:00:00"
  },
  {
    "id": "d17a4acd-3b21-4b06-8aac-277e7790641a",
    "slug": "donal-campbell",
    "name": "Donal Campbell",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/01/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Donal Campbell",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d17a4acd-3b21-4b06-8aac-277e7790641a",
        "address": "Level 14 ,Burj Daman ,Four Seasons Hotel ,119980 ,Dubai",
        "phone": "97143604070 / 971502450485",
        "email": "Philip.ireland@maples.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "cb7cc285-8538-469a-b075-ef30819bce69",
    "firmName": "Maples & Calder (Dubai) LLP",
    "registrationNumber": "L-06969",
    "licenseIssueDate": "09/22/2025 00:00:00",
    "licenseExpiryDate": "09/21/2026 00:00:00"
  },
  {
    "id": "9db9cc29-82ff-4de0-a48b-6f8b23113b4f",
    "slug": "donal-scott",
    "name": "Donal Scott",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/26/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Donal Scott",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9db9cc29-82ff-4de0-a48b-6f8b23113b4f",
        "address": "Al Fattan Currency House - Tower 1  ,Dubai International Financial Center  ,507104 ,",
        "phone": "97143978565 / 971504587822",
        "email": "Raafat.hares@dwf.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6e5f6dba-07af-4109-8c34-175296450f94",
    "firmName": "DWF (Middle East) LLP",
    "registrationNumber": "L-03132",
    "licenseIssueDate": "09/26/2022 00:00:00",
    "licenseExpiryDate": "09/25/2026 00:00:00"
  },
  {
    "id": "aaf46dbc-59bd-49c8-a11f-1c0e5b7cd60d",
    "slug": "donatella-gallazzi",
    "name": "Donatella Gallazzi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBERwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/05/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Donatella Gallazzi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_aaf46dbc-59bd-49c8-a11f-1c0e5b7cd60d",
        "address": "",
        "phone": "97145683100 / 971559223103",
        "email": "rossi@bonnard-lawson.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2b373724-e557-4c31-a968-7d37d9393842",
    "firmName": "Bonnard Lawson Legal Consultants L.L.C",
    "registrationNumber": "L-06373",
    "licenseIssueDate": "06/05/2024 00:00:00",
    "licenseExpiryDate": "06/04/2026 00:00:00"
  },
  {
    "id": "7690673f-539f-4d42-8971-f4eb8458c3de",
    "slug": "doneen-johanna-ennis",
    "name": "Doneen Johanna Ennis",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBESgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/09/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Doneen Johanna Ennis",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7690673f-539f-4d42-8971-f4eb8458c3de",
        "address": "- ,Index Tower ,Dubai International Financial Centre ,9371 ,Dubai",
        "phone": "97143303900 / 971561753537",
        "email": "christopher@afridi-angell.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3e464dc8-b800-4ba2-ad91-24a5f9640fef",
    "firmName": "Afridi & Angell-DIFC",
    "registrationNumber": "L-06531",
    "licenseIssueDate": "10/09/2024 00:00:00",
    "licenseExpiryDate": "10/08/2026 00:00:00"
  },
  {
    "id": "f418b878-a4a6-49a9-a50a-0b9f3ba1fb5c",
    "slug": "dorminic-kang-wei-jie",
    "name": "Dorminic Kang wei jie",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBESwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/14/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Dorminic Kang wei jie",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f418b878-a4a6-49a9-a50a-0b9f3ba1fb5c",
        "address": "Gamal Yassein Abdalla ,الطابق 13  Floor No 13 ,بناية مركز ابروي (The Oberoi Center) ,فندق ابروي (The Oberoi Hotel) ,33299 ,Dubai",
        "phone": "97142828000",
        "email": "litigation@alaidarous.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9a923766-1fd1-4e06-a871-89662120384e",
    "firmName": "AL AIDAROUS ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-06791",
    "licenseIssueDate": "05/14/2025 00:00:00",
    "licenseExpiryDate": "05/13/2026 00:00:00"
  },
  {
    "id": "9c1465df-7cf1-4f30-a175-f5cf1f19172d",
    "slug": "dounia-sabrina-mansour",
    "name": "Dounia Sabrina Mansour",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/12/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Dounia Sabrina Mansour",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9c1465df-7cf1-4f30-a175-f5cf1f19172d",
        "address": "",
        "phone": "97143779900 / 971508548052",
        "email": "jali@kslaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dff8529a-82be-431a-b72b-0192ff238011",
    "firmName": "King & Spalding LLP",
    "registrationNumber": "L-04314",
    "licenseIssueDate": "02/12/2019 00:00:00",
    "licenseExpiryDate": "02/10/2026 00:00:00"
  },
  {
    "id": "07a33b37-bdc5-41fc-8db2-ffaec277e386",
    "slug": "dr-ines-anders",
    "name": "Dr. Ines Anders",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBESQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Dr. Ines Anders",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_07a33b37-bdc5-41fc-8db2-ffaec277e386",
        "address": "",
        "phone": "97143275888 / 971504506620",
        "email": "anders@anders.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "ead06df1-7efa-4b25-80d0-710f815a1677",
    "firmName": "Anders Legal Consultancy LLC",
    "registrationNumber": "L-00598",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "578e6b66-9d82-453f-8c4b-0f16ccf07b40",
    "slug": "dr-waleed-hamoda",
    "name": "WALEED MOHAMED ELSAYED HAMODA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-02-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Dr. Waleed Hamoda",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_578e6b66-9d82-453f-8c4b-0f16ccf07b40",
        "address": "السادس , مباني الحضيبة للجوائز  ,علم الاتحاد ,200 ,Dubai",
        "phone": "97143545111",
        "email": "altaher_alsabri@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "aced7900-0571-43e1-b49b-4740c6dc298f",
    "firmName": "AL TAHER & AL SABRI ADVOCATES",
    "registrationNumber": "L-01367",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/23/2018 00:00:00"
  },
  {
    "id": "cb854373-0d15-4cec-ac85-6d8936aaa95b",
    "slug": "dyala-ali",
    "name": "Dyala Ali",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/16/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Dyala Ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cb854373-0d15-4cec-ac85-6d8936aaa95b",
        "address": "THE OFFICES 1 ,DWTC ,115580 ,",
        "phone": "97143739700 / 971501148248",
        "email": "nitesh.pradhan@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "361fdc64-6b6f-4f37-abca-c52af8473b84",
    "firmName": "Pinsent Masons  LLP (DWTCA Branch)",
    "registrationNumber": "L-00893",
    "licenseIssueDate": "09/16/2024 00:00:00",
    "licenseExpiryDate": "09/15/2026 00:00:00"
  },
  {
    "id": "60e4d550-ba97-4a92-be58-6a03094b0d37",
    "slug": "dylan-nathwani",
    "name": "Dylan Nathwani",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBETgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/06/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Dylan Nathwani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_60e4d550-ba97-4a92-be58-6a03094b0d37",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-05989",
    "licenseIssueDate": "09/06/2023 00:00:00",
    "licenseExpiryDate": "09/05/2026 00:00:00"
  },
  {
    "id": "6106f2ba-28e9-4747-8b4a-55991ee427bb",
    "slug": "eamon-joseph-patrick-gallagher",
    "name": "Eamon Joseph Patrick Gallagher",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/14/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Eamon Joseph Patrick Gallagher",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6106f2ba-28e9-4747-8b4a-55991ee427bb",
        "address": "",
        "phone": "97144363636 / 971505572900",
        "email": "hassan.elsayed@bakerbotts.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "fd5d6571-d053-4436-9de5-c8a36ce7c6c9",
    "firmName": "Baker Botts LLP Legal Consultants Dubai Branch",
    "registrationNumber": "L-06665",
    "licenseIssueDate": "02/14/2025 00:00:00",
    "licenseExpiryDate": "02/13/2026 00:00:00"
  },
  {
    "id": "5a8ee32d-2f06-4aac-8c16-69b8ae012307",
    "slug": "eddie-chi-chung-chiu",
    "name": "Eddie Chi Chung Chiu",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/30/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Eddie Chi Chung Chiu",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5a8ee32d-2f06-4aac-8c16-69b8ae012307",
        "address": "",
        "phone": "97143093222 / 971566651954",
        "email": "melissa.murray@twobirds.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3e1526e6-4c8d-4b6f-985f-ea05e9f99bcb",
    "firmName": "Bird & Bird (MEA) LLP",
    "registrationNumber": "L-05027",
    "licenseIssueDate": "08/30/2021 00:00:00",
    "licenseExpiryDate": "08/29/2026 00:00:00"
  },
  {
    "id": "6e0cfc8e-c6c4-4d9a-875f-682aed316915",
    "slug": "edmund-boyo",
    "name": "Edmund Boyo",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/13/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Edmund Boyo",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6e0cfc8e-c6c4-4d9a-875f-682aed316915",
        "address": "",
        "phone": "97145032600 / 971504577931",
        "email": "edmund.boyo@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "8cca52de-2c74-4743-b8f2-0b904d96b132",
    "firmName": "CC Worldwide Limited",
    "registrationNumber": "L-03863",
    "licenseIssueDate": "08/13/2017 00:00:00",
    "licenseExpiryDate": "08/10/2026 00:00:00"
  },
  {
    "id": "91560b9b-472a-4aa6-a4aa-a7a56428fd27",
    "slug": "edward-brown",
    "name": "Edward Brown",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/08/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Edward Brown",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_91560b9b-472a-4aa6-a4aa-a7a56428fd27",
        "address": "Level 17, ICD Brookfield Place ,DIFC ,506503 ,",
        "phone": "97144375100 / 971588271196",
        "email": "libby.edwards-smith@gowlingwlg.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "436703ba-b9c0-4dcb-93b2-1299c7a051f4",
    "firmName": "Gowling WLG (UK) LLP (Dubai Branch)",
    "registrationNumber": "L-01252",
    "licenseIssueDate": "03/08/2012 00:00:00",
    "licenseExpiryDate": "02/27/2026 00:00:00"
  },
  {
    "id": "224e24e5-6ddc-44d9-a5d0-40ea602830e9",
    "slug": "edward-james-mc-cullagh",
    "name": "Edward James Mc Cullagh",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/28/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Edward James Mc Cullagh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_224e24e5-6ddc-44d9-a5d0-40ea602830e9",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-04382",
    "licenseIssueDate": "03/28/2025 00:00:00",
    "licenseExpiryDate": "03/27/2026 00:00:00"
  },
  {
    "id": "7bf226c8-585e-4003-bfef-6e6961c1d6ee",
    "slug": "edward-jiun-saville-imrie",
    "name": "Edward Jiun Saville Imrie",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/25/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Edward Jiun Saville Imrie",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7bf226c8-585e-4003-bfef-6e6961c1d6ee",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-06495",
    "licenseIssueDate": "09/25/2024 00:00:00",
    "licenseExpiryDate": "09/24/2026 00:00:00"
  },
  {
    "id": "789d5561-ff85-4dec-8387-5bf92bbe5656",
    "slug": "edward-john-joseph-foster",
    "name": "Edward John Joseph Foster",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/05/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Edward John Joseph Foster",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_789d5561-ff85-4dec-8387-5bf92bbe5656",
        "address": "6 ,Office Nos. 603, 604 & 605, Level 6, Burj Daman ,Dubai International Financial Centre ,506555 ,Dubai",
        "phone": "97143506400 / 971504654755",
        "email": "r.hickman@aglaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8690f7d5-6b96-4649-9589-71303f2c2707",
    "firmName": "Addleshaw Goddard (Middle East) LLP",
    "registrationNumber": "L-06364",
    "licenseIssueDate": "06/05/2024 00:00:00",
    "licenseExpiryDate": "06/04/2026 00:00:00"
  },
  {
    "id": "48bc2217-d179-45af-aa8d-9dde844f7dfb",
    "slug": "edward-kimani",
    "name": "Edward Kimani",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/08/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Edward Kimani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_48bc2217-d179-45af-aa8d-9dde844f7dfb",
        "address": "",
        "phone": "97144529091 / 971552805308",
        "email": "ashafi@ach-legal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4f3e1e80-c812-4585-9570-229cd96776a4",
    "firmName": "Anjarwalla, Collins and Haidermota Legal Consultants",
    "registrationNumber": "L-03719",
    "licenseIssueDate": "05/08/2017 00:00:00",
    "licenseExpiryDate": "05/04/2026 00:00:00"
  },
  {
    "id": "7d7e8c50-e96c-47de-9a75-f88ecec23501",
    "slug": "ehab-elsayed-mosaad-youssef-badr",
    "name": "Ehab Elsayed Mosaad Youssef Badr",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/10/2025",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ehab Elsayed Mosaad Youssef Badr",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7d7e8c50-e96c-47de-9a75-f88ecec23501",
        "address": "",
        "phone": "97143116556 / 971000000000",
        "email": "info@hazlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d34586c5-1e0a-4290-af29-23366d37b852",
    "firmName": "HOYAM ALZAROUNI ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "fca5fe8b-8c7a-4132-ad0d-629ead40b382",
    "slug": "ehab-essameldin-ibrahim-mohamed",
    "name": "Ehab Essameldin Ibrahim Mohamed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/07/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ehab Essameldin Ibrahim Mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fca5fe8b-8c7a-4132-ad0d-629ead40b382",
        "address": "ABDELAZIZ MOHAMED ABDELGHANI AL KHAMIRI AL ALI ,3 ,DUBAI SUPREME COURT COMPLEX ,DUBAI COURT ,128334 ,Dubai",
        "phone": "97145519341 / 971505788557",
        "email": "info@raalc.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "73e54a15-f797-4e91-a501-ef988d8f8bf8",
    "firmName": "ABDELAZIZ AL KHAMIRI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04817",
    "licenseIssueDate": "01/07/2021 00:00:00",
    "licenseExpiryDate": "01/06/2026 00:00:00"
  },
  {
    "id": "f36ddd13-e824-48af-ac0f-4fe6f22a9510",
    "slug": "ehab-hassan-abouelela-mohamed-ahmed-elzankalouni",
    "name": "EHAB HASSAN ABOUELELA MOHAMED AHMED ELZANKALOUNI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/22/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: EHAB HASSAN ABOUELELA MOHAMED AHMED ELZANKALOUNI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f36ddd13-e824-48af-ac0f-4fe6f22a9510",
        "address": "الطابق الخامس ,الساحة ,سوق البحار ,26011 ,Dubai",
        "phone": "97142277717",
        "email": "info@alsahlawico.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a6811a79-5470-4c33-ad95-3ff8f661c052",
    "firmName": "AL SAHLAWI & CO ADVOCATES & CONSULTANTS",
    "registrationNumber": "L-05189",
    "licenseIssueDate": "02/22/2022 00:00:00",
    "licenseExpiryDate": "02/21/2026 00:00:00"
  },
  {
    "id": "38214e94-5a9b-499d-9c78-242ae47217be",
    "slug": "ehab-lamie-macar",
    "name": "Ehab Lamie Macar",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ehab Lamie Macar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_38214e94-5a9b-499d-9c78-242ae47217be",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01253",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "b9f7149b-6c28-4a2d-b794-fc646f352346",
    "slug": "ehab-magdy-mohamed-abousoliman",
    "name": "Ehab Magdy Mohamed AbouSoliman",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/12/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ehab Magdy Mohamed AbouSoliman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b9f7149b-6c28-4a2d-b794-fc646f352346",
        "address": "",
        "phone": "97143889955",
        "email": "m.alhanafi@nooflaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6a72f470-256a-46d0-bead-acf13b981406",
    "firmName": "NOOF ALABDULLA ADVOCATES & LEGAL CONSULTANTS L.L.C",
    "registrationNumber": "L-05891",
    "licenseIssueDate": "07/12/2023 00:00:00",
    "licenseExpiryDate": "07/11/2026 00:00:00"
  },
  {
    "id": "bd73f77b-8b6b-4b9d-9aa8-3ab996339ceb",
    "slug": "ehab-mohamed-mohamed-abdelfattah-hegazy",
    "name": "EHAB MOHAMED MOHAMED ABDELFATTAH HEGAZY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/11/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-10-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: EHAB MOHAMED MOHAMED ABDELFATTAH HEGAZY",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bd73f77b-8b6b-4b9d-9aa8-3ab996339ceb",
        "address": "",
        "phone": "97143588887",
        "email": "e.lawyersd@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9aeb8716-ff23-4200-90de-c2e0ee86076e",
    "firmName": "MOHAMMED AHMED ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06249",
    "licenseIssueDate": "03/11/2024 00:00:00",
    "licenseExpiryDate": "03/10/2025 00:00:00"
  },
  {
    "id": "1e17b528-c50b-4c0f-8084-3f52d8738658",
    "slug": "eileen-elizabeth-duncan",
    "name": "Eileen Elizabeth Duncan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/31/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Eileen Elizabeth Duncan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1e17b528-c50b-4c0f-8084-3f52d8738658",
        "address": "",
        "phone": "97143025100 / 971501501837",
        "email": "ccairns@trowers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "976857f5-9092-43cf-987d-bfa794a3fa51",
    "firmName": "Trowers & Hamlins LLP",
    "registrationNumber": "L-06362",
    "licenseIssueDate": "05/31/2024 00:00:00",
    "licenseExpiryDate": "05/30/2026 00:00:00"
  },
  {
    "id": "3186c806-2776-40a1-a9aa-548567d2ec0c",
    "slug": "eileen-loebig",
    "name": "Eileen Loebig",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/12/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Eileen Loebig",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3186c806-2776-40a1-a9aa-548567d2ec0c",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-06143",
    "licenseIssueDate": "12/12/2023 00:00:00",
    "licenseExpiryDate": "12/11/2025 00:00:00"
  },
  {
    "id": "8076e006-acae-4fc6-9423-ffad51a1b044",
    "slug": "ejaz-ahmad",
    "name": "Ejaz Ahmad",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/10/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-10-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ejaz Ahmad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8076e006-acae-4fc6-9423-ffad51a1b044",
        "address": "",
        "phone": "97142945678",
        "email": "maadvdubai@maadv.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "85fc2f18-8a0a-4682-9735-2be49a8b75f9",
    "firmName": "MOHAMED AL GHEFLI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03882",
    "licenseIssueDate": "10/26/2017 00:00:00",
    "licenseExpiryDate": "10/24/2019 00:00:00"
  },
  {
    "id": "ceedf34b-ffb5-4628-ab54-f649804ecfce",
    "slug": "ejiroghene-noah-otu",
    "name": "Ejiroghene Noah Otu",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/01/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ejiroghene Noah Otu",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ceedf34b-ffb5-4628-ab54-f649804ecfce",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-05681",
    "licenseIssueDate": "03/01/2023 00:00:00",
    "licenseExpiryDate": "02/28/2026 00:00:00"
  },
  {
    "id": "66d4d421-8034-4cdf-baba-b18f259408af",
    "slug": "el-fatih-ahmed-bagouri",
    "name": "El Fatih Ahmed Bagouri",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/27/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: El Fatih Ahmed Bagouri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_66d4d421-8034-4cdf-baba-b18f259408af",
        "address": "18 ,فندق مونارك  ,مركز التجاري ,98444 ,Dubai",
        "phone": "97143588777",
        "email": "info@bhadvoc.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "61266d12-f5b4-4466-a1a8-a45934d9e511",
    "firmName": "BIN HAIDER ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01830",
    "licenseIssueDate": "05/27/2012 00:00:00",
    "licenseExpiryDate": "05/19/2026 00:00:00"
  },
  {
    "id": "05106f01-5d8e-43b3-81c5-8ac1058777e1",
    "slug": "el-nazir-el-siddig-el-nazir",
    "name": "El Nazir El Siddig El Nazir",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: El Nazir El Siddig El Nazir",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_05106f01-5d8e-43b3-81c5-8ac1058777e1",
        "address": "",
        "phone": "97142945678",
        "email": "maadvdubai@maadv.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "85fc2f18-8a0a-4682-9735-2be49a8b75f9",
    "firmName": "MOHAMED AL GHEFLI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01366",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "ed418a12-634e-4c34-8e0d-7e9cf7591da4",
    "slug": "elabbas-azhry-mohamed-ahmed",
    "name": "ELABBAS AZHRY MOHAMED AHMED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/26/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ELABBAS AZHRY MOHAMED AHMED",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ed418a12-634e-4c34-8e0d-7e9cf7591da4",
        "address": "",
        "phone": "97143333245 / 97143333245",
        "email": "y.albulooshi@yhadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5fd2b33a-4bae-47d7-86ce-bdbd42af4336",
    "firmName": "ALBALOOSHI AND ALMARASHIDA ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-06702",
    "licenseIssueDate": "02/26/2025 00:00:00",
    "licenseExpiryDate": "02/25/2026 00:00:00"
  },
  {
    "id": "a6dd17cb-fdca-4956-a11d-d2520fc2c61f",
    "slug": "eleanor-rosamund-anne-lane",
    "name": "Eleanor Rosamund Anne lane",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/11/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Eleanor Rosamund Anne lane",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a6dd17cb-fdca-4956-a11d-d2520fc2c61f",
        "address": "",
        "phone": "97143742800 / 971506450677",
        "email": "jabbott21@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7a59d310-ff72-4318-b41c-27095c163d0f",
    "firmName": "CMS (UAE) LLP",
    "registrationNumber": "L-06615",
    "licenseIssueDate": "12/11/2024 00:00:00",
    "licenseExpiryDate": "12/10/2025 00:00:00"
  },
  {
    "id": "1564f5d3-3eb4-4e95-8aff-8f9229a92d77",
    "slug": "elena-bolychevskaia",
    "name": "ELENA BOLYCHEVSKAIA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/11/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ELENA BOLYCHEVSKAIA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1564f5d3-3eb4-4e95-8aff-8f9229a92d77",
        "address": "1 ,ICD Brookfield Place ,Dubai International Financial Centre ,9267 ,Dubai",
        "phone": "97147010975 / 971502977062",
        "email": "chris.sioufi@ae.ey.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "42e536ef-e3d8-4339-8572-657a7f7a0331",
    "firmName": "EY Law LLP",
    "registrationNumber": "L-05844",
    "licenseIssueDate": "05/11/2023 00:00:00",
    "licenseExpiryDate": "05/10/2026 00:00:00"
  },
  {
    "id": "4d7261c2-ce5c-4b48-afc2-2d956ec53d7b",
    "slug": "elena-schildgen",
    "name": "Elena Schildgen",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Elena Schildgen",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4d7261c2-ce5c-4b48-afc2-2d956ec53d7b",
        "address": "1 ,Park Place Towe ,. ,9353 ,Dubai",
        "phone": "97143317110 / 971000000000",
        "email": "elena@meyer-reumann.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "e294ccf7-baca-4016-876d-fcf8d296a3fc",
    "firmName": "Meyer Reumann & Partners",
    "registrationNumber": "L-00342",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "3bb4d2aa-ab9a-44c7-a5b9-2a2642d147bd",
    "slug": "elena-vasilyeva",
    "name": "Elena Vasilyeva",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFVgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/06/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Elena Vasilyeva",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3bb4d2aa-ab9a-44c7-a5b9-2a2642d147bd",
        "address": "20 ,Index Tower West Tower ,DIFC ,507226 ,Dubai",
        "phone": "97142461900 / 971523391604",
        "email": "patrick.gearon@crsblaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e2ac552e-b9a7-450b-a84d-15119e583220",
    "firmName": "Charles Russell Speechlys LLP",
    "registrationNumber": "L-06117",
    "licenseIssueDate": "12/06/2023 00:00:00",
    "licenseExpiryDate": "12/05/2025 00:00:00"
  },
  {
    "id": "2dcc395d-3c28-47de-8403-e304f89bff90",
    "slug": "elgendi-ahmed-elgendi",
    "name": "Elgendi Ahmed Elgendi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/24/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Elgendi Ahmed Elgendi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2dcc395d-3c28-47de-8403-e304f89bff90",
        "address": "Khawla Saeed Mohammed Salem ,414 ,DBCS BUILDING ,محكمة الاحوال الشخصية ,73879 ,Dubai",
        "phone": "97143530354 / 971503787848",
        "email": "info@ksadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e961ec37-b1f5-4b83-8382-639604c8fdaf",
    "firmName": "KHAWLA SAEED ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01673",
    "licenseIssueDate": "06/24/2025 00:00:00",
    "licenseExpiryDate": "06/23/2026 00:00:00"
  },
  {
    "id": "ed47d538-c1e0-478e-a5fa-d2d20574fb86",
    "slug": "elhassan-mamdouh-mamdouh-abdelrazek",
    "name": "Elhassan Mamdouh Mamdouh Abdelrazek",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/25/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Elhassan Mamdouh Mamdouh Abdelrazek",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ed47d538-c1e0-478e-a5fa-d2d20574fb86",
        "address": "amal albastaki ,1903 ,court ,business bay ,127477 ,Dubai",
        "phone": "97142522202",
        "email": "info@amaladvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "f852bccd-2696-4190-9b40-77a8fb9c460f",
    "firmName": "AMAL ALBASTAKI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-06617",
    "licenseIssueDate": "12/25/2024 00:00:00",
    "licenseExpiryDate": "12/24/2025 00:00:00"
  },
  {
    "id": "b748815d-d25c-4345-b6ce-8d5b0b2938d9",
    "slug": "elias-aoun",
    "name": "ELIAS YOUSSEF AOUN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/09/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2023-09-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Elias Aoun",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b748815d-d25c-4345-b6ce-8d5b0b2938d9",
        "address": "",
        "phone": "97142405888",
        "email": "m.binhendi@mbhlawfirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "95d56953-378a-4ade-a995-fee8035a4699",
    "firmName": "MAHA BIN HENDI LAW FIRM",
    "registrationNumber": "L-04473",
    "licenseIssueDate": "09/19/2019 00:00:00",
    "licenseExpiryDate": "09/18/2023 00:00:00"
  },
  {
    "id": "8595283b-0d37-4f1a-b9e9-dc9fb2b01833",
    "slug": "elias-bou-khalil",
    "name": "Elias Bou Khalil",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/07/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Elias Bou Khalil",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8595283b-0d37-4f1a-b9e9-dc9fb2b01833",
        "address": "MOHAMMED MURTADA ALHASHMI ,3 ,LATIFA TOWER  ,CROWN PLAZA ,231400 ,Dubai",
        "phone": "97143521131",
        "email": "info@mhadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a5a2640f-b1b8-4512-b9ee-a8802d0c30fc",
    "firmName": "MOHAMMED AL HASHIMI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-04468",
    "licenseIssueDate": "08/07/2019 00:00:00",
    "licenseExpiryDate": "08/06/2026 00:00:00"
  },
  {
    "id": "10c5fbea-6d4b-43bb-974f-07a5dcd1f002",
    "slug": "elias-hayek",
    "name": "Elias Hayek",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/10/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Elias Hayek",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_10c5fbea-6d4b-43bb-974f-07a5dcd1f002",
        "address": "",
        "phone": "97145953601 / 971508728645",
        "email": "Steven.Bainbridge@gtlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b4146aa6-efd1-41d7-819d-49da46353b0b",
    "firmName": "Greenberg Traurig Limited",
    "registrationNumber": "L-03844",
    "licenseIssueDate": "09/10/2017 00:00:00",
    "licenseExpiryDate": "09/07/2026 00:00:00"
  },
  {
    "id": "e81fd987-a74e-4142-bd3d-d1e2c18a515f",
    "slug": "elias-moubarak",
    "name": "Elias Moubarak",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/23/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Elias Moubarak",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e81fd987-a74e-4142-bd3d-d1e2c18a515f",
        "address": "",
        "phone": "97143025100 / 971501501837",
        "email": "ccairns@trowers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "976857f5-9092-43cf-987d-bfa794a3fa51",
    "firmName": "Trowers & Hamlins LLP",
    "registrationNumber": "L-00143",
    "licenseIssueDate": "05/23/2025 00:00:00",
    "licenseExpiryDate": "05/22/2026 00:00:00"
  },
  {
    "id": "2a8d10b9-f14f-4d38-a741-fbc40f2b6f23",
    "slug": "elias-nabil-hassoun",
    "name": "ELIAS NABIL HASSOUN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/03/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ELIAS NABIL HASSOUN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2a8d10b9-f14f-4d38-a741-fbc40f2b6f23",
        "address": "5 ,LIBERTY HOUSE ,RITZ HOTEL DIFC ,506949 ,Dubai",
        "phone": "97143860090 / 971507887401",
        "email": "maalouf@iaalo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8d9bc487-6793-4ea8-a629-49ba36823552",
    "firmName": "IAA MIDDLE EAST LEGAL CONSULTANTS LTD",
    "registrationNumber": "L-06393",
    "licenseIssueDate": "07/03/2024 00:00:00",
    "licenseExpiryDate": "07/02/2026 00:00:00"
  },
  {
    "id": "5759b646-3fdd-4726-bd19-ab49f6162089",
    "slug": "elisabeth-eniola-fapuro",
    "name": "Elisabeth Eniola Fapuro",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/10/2024",
    "licenseStatus": "active",
    "licenseExpiry": "2025-10-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Elisabeth Eniola Fapuro",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5759b646-3fdd-4726-bd19-ab49f6162089",
        "address": "",
        "phone": "97143779900 / 971508548052",
        "email": "jali@kslaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dff8529a-82be-431a-b72b-0192ff238011",
    "firmName": "King & Spalding LLP",
    "registrationNumber": "L-06525",
    "licenseIssueDate": "10/09/2024 00:00:00",
    "licenseExpiryDate": "10/08/2025 00:00:00"
  },
  {
    "id": "3fa96349-c944-414e-8beb-b42e109bbf82",
    "slug": "elizabeth-aletta-sophia-sonnekus",
    "name": "Elizabeth Aletta Sophia Sonnekus",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/11/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Elizabeth Aletta Sophia Sonnekus",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3fa96349-c944-414e-8beb-b42e109bbf82",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-05064",
    "licenseIssueDate": "10/11/2021 00:00:00",
    "licenseExpiryDate": "10/10/2026 00:00:00"
  },
  {
    "id": "4d76dd0d-4924-47da-b071-0e5a1c64089e",
    "slug": "elizabeth-jane-wood",
    "name": "Elizabeth Jane Wood",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/22/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Elizabeth Jane Wood",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4d76dd0d-4924-47da-b071-0e5a1c64089e",
        "address": "",
        "phone": "97143184600 / 971504468184",
        "email": "melaraby@gibsondunn.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c9d2c9d0-6e43-4253-a75d-cdeb400f8d8e",
    "firmName": "Gibson Dunn & Crutcher LLP",
    "registrationNumber": "L-06115",
    "licenseIssueDate": "11/22/2023 00:00:00",
    "licenseExpiryDate": "11/21/2025 00:00:00"
  },
  {
    "id": "0fb0b067-bf90-4c8c-ae6f-f4bb90630bf9",
    "slug": "ellen-elizabeth-ray",
    "name": "Ellen Elizabeth Ray",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/26/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ellen Elizabeth Ray",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0fb0b067-bf90-4c8c-ae6f-f4bb90630bf9",
        "address": "One Central, The Offices 5 ,Dubai World Trade Centre ,554660 ,",
        "phone": "97142052030 / 971506566494",
        "email": "chourani@houranipartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "59a73632-40a0-4849-b120-4308dc6f8015",
    "firmName": "Hourani & Partners Legal Consultancy FZCO",
    "registrationNumber": "L-04993",
    "licenseIssueDate": "07/26/2021 00:00:00",
    "licenseExpiryDate": "07/25/2026 00:00:00"
  },
  {
    "id": "6e13543c-b952-4fd1-a1c7-c5ea856263fc",
    "slug": "elliot-john-hamlin",
    "name": "Elliot John Hamlin",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/04/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Elliot John Hamlin",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6e13543c-b952-4fd1-a1c7-c5ea856263fc",
        "address": "",
        "phone": "97144073901 / 971503479508",
        "email": "Rania.Tadros@stephensonharwood.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dd5042a2-bb41-4123-9544-79c3fa831332",
    "firmName": "Stephenson Harwood (Middle East) LLP",
    "registrationNumber": "L-06478",
    "licenseIssueDate": "09/04/2024 00:00:00",
    "licenseExpiryDate": "09/03/2026 00:00:00"
  },
  {
    "id": "f8dc97a2-154a-4789-95d8-f3f4bc76d5cf",
    "slug": "elliott-sawford",
    "name": "Elliott Sawford",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/23/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Elliott Sawford",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f8dc97a2-154a-4789-95d8-f3f4bc76d5cf",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-02743",
    "licenseIssueDate": "09/23/2014 00:00:00",
    "licenseExpiryDate": "09/17/2026 00:00:00"
  },
  {
    "id": "ba1b91ba-f2c5-4db6-b80c-eb8134870154",
    "slug": "ellise-victoria-chesterton",
    "name": "ELLISE VICTORIA CHESTERTON",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFVgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/12/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ELLISE VICTORIA CHESTERTON",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ba1b91ba-f2c5-4db6-b80c-eb8134870154",
        "address": "",
        "phone": "97143438897 / 971507753952",
        "email": "jdavidson@davidson-legal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d0200f27-9504-4653-a5c6-05e4bcab7ff0",
    "firmName": "Davidson & Co Legal Consultants",
    "registrationNumber": "L-06395",
    "licenseIssueDate": "07/12/2024 00:00:00",
    "licenseExpiryDate": "07/11/2026 00:00:00"
  },
  {
    "id": "c7be453a-b7d1-4052-8d9a-5805e8e86b66",
    "slug": "elmahbob-ahmed-elmin-abdelrahman",
    "name": "Elmahbob Ahmed Elmin Abdelrahman",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/05/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2022-01-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Elmahbob Ahmed Elmin Abdelrahman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c7be453a-b7d1-4052-8d9a-5805e8e86b66",
        "address": "Muna Ahmed Abdul-aziz Al-Sabbagh ,الطابق الخامس ,الزمردة ,مختبر دبي المركزي ,115578 ,Dubai",
        "phone": "97142283414",
        "email": "info@alwifaqlegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "120e4ca7-7727-4524-9d53-5656ff95eea7",
    "firmName": "MUNA ALSABBAGH ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03770",
    "licenseIssueDate": "03/05/2017 00:00:00",
    "licenseExpiryDate": "03/01/2022 00:00:00"
  },
  {
    "id": "0ea7790b-039c-476c-88eb-13828e2cc34e",
    "slug": "elmukashfi-majzoob-sadalla-mohamed",
    "name": "Elmukashfi Majzoob Sadalla Mohamed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/28/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Elmukashfi Majzoob Sadalla Mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0ea7790b-039c-476c-88eb-13828e2cc34e",
        "address": "- ,Index Tower ,Dubai International Financial Centre ,9371 ,Dubai",
        "phone": "97143303900 / 971561753537",
        "email": "christopher@afridi-angell.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3e464dc8-b800-4ba2-ad91-24a5f9640fef",
    "firmName": "Afridi & Angell-DIFC",
    "registrationNumber": "L-04247",
    "licenseIssueDate": "08/28/2023 00:00:00",
    "licenseExpiryDate": "08/27/2026 00:00:00"
  },
  {
    "id": "7d6c9ccd-53b7-4433-848d-65ec40a24f20",
    "slug": "elnazeer-elkheir-hamad",
    "name": "ELNAZEER ELKHEIR SALIH HAMAD",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/11/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-11-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Elnazeer Elkheir Hamad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7d6c9ccd-53b7-4433-848d-65ec40a24f20",
        "address": "YASIR AL NAQBI ,21 ,48 BURJ ,SOFITEL DOWN  TOWN ,181111 ,Dubai",
        "phone": "97142689949",
        "email": "info@alnaqbipartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ad71430e-83ee-4cb5-a530-bc58db2618f6",
    "firmName": "ALNAQBI & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02644",
    "licenseIssueDate": "11/19/2012 00:00:00",
    "licenseExpiryDate": "11/11/2020 00:00:00"
  },
  {
    "id": "787a770a-63c7-47d6-b190-0bbdb7b9f3bb",
    "slug": "elodie-elias-chalhoub",
    "name": "Elodie Elias Chalhoub",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/22/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Elodie Elias Chalhoub",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_787a770a-63c7-47d6-b190-0bbdb7b9f3bb",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-05194",
    "licenseIssueDate": "02/22/2022 00:00:00",
    "licenseExpiryDate": "02/21/2026 00:00:00"
  },
  {
    "id": "e069a7c4-9f9c-4dd0-a153-54d9320a2026",
    "slug": "elsabbah-ashri-mansour",
    "name": "ELSABBAH ASHRI AHMED MANSOUR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/06/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-06-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Elsabbah Ashri Mansour",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e069a7c4-9f9c-4dd0-a153-54d9320a2026",
        "address": "6 ,latifa tower ,near crown plaza hotel  ,102999 ,Dubai",
        "phone": "97143799979",
        "email": "lawkmq@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b9d24779-27c2-4989-bf7f-4e73e5a670ff",
    "firmName": "KHALID BIN MOHAMMAD ALQASEMI ATTORNEY & LEGAL CONSULTANTS",
    "registrationNumber": "L-01572",
    "licenseIssueDate": "06/14/2012 00:00:00",
    "licenseExpiryDate": "06/06/2020 00:00:00"
  },
  {
    "id": "8ca86aa7-7444-4b86-8272-db1e39f618b9",
    "slug": "elsadig-mahmoud-elshekh-hamad",
    "name": "Elsadig Mahmoud Elshekh Hamad",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/24/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Elsadig Mahmoud Elshekh Hamad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8ca86aa7-7444-4b86-8272-db1e39f618b9",
        "address": "",
        "phone": "97143366080",
        "email": "info@accordlawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0c25ab44-71a4-49f3-9d94-7b5a222500f2",
    "firmName": "ACCORD INTERNATIONAL ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06183",
    "licenseIssueDate": "01/24/2024 00:00:00",
    "licenseExpiryDate": "01/23/2026 00:00:00"
  },
  {
    "id": "0bc01993-a258-4d3d-a91a-2b2999cfc2c8",
    "slug": "elsafy-farouk-mohamed-attalla-ebeid",
    "name": "ELSAFY FAROUK MOHAMED ATTALLA EBEID",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/11/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ELSAFY FAROUK MOHAMED ATTALLA EBEID",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0bc01993-a258-4d3d-a91a-2b2999cfc2c8",
        "address": "",
        "phone": "97143333386 / 971549916936",
        "email": "info@mtaadv.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "466f3ad4-73e1-44db-b8ec-b01e829d77c4",
    "firmName": "MOHAMMAD ALLINJAWI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04850",
    "licenseIssueDate": "02/11/2021 00:00:00",
    "licenseExpiryDate": "02/10/2026 00:00:00"
  },
  {
    "id": "a3c643eb-99aa-4879-b0a9-e81d60a45468",
    "slug": "elsayed-abdelmoamen-kotb-afify-hassan",
    "name": "Elsayed Abdelmoamen Kotb Afify Hassan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Elsayed Abdelmoamen Kotb Afify Hassan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a3c643eb-99aa-4879-b0a9-e81d60a45468",
        "address": "",
        "phone": "97143348481",
        "email": "lawyers@maidor.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a48d1666-6ca7-461a-8197-a892ef0f3545",
    "firmName": "AL MAIDOOR ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01851",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "50bfb339-50bf-456a-a7e4-2d6c07d4b54c",
    "slug": "elsayed-aboubakr-mahgoub",
    "name": "Elsayed Aboubakr Mahgoub",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/25/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Elsayed Aboubakr Mahgoub",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_50bfb339-50bf-456a-a7e4-2d6c07d4b54c",
        "address": "",
        "phone": "97144560410 / 971551096724",
        "email": "info1@a-lawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ebbfa096-ef29-4660-9201-8c03bd4be3fe",
    "firmName": "MUSALLAM ALMAHHRAMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01665",
    "licenseIssueDate": "11/25/2015 00:00:00",
    "licenseExpiryDate": "11/20/2025 00:00:00"
  },
  {
    "id": "a63baa34-357e-468d-b98f-fd0e83287879",
    "slug": "elsayed-raafat-elsayed-khashaba",
    "name": "elsayed raafat elsayed  khashaba",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/10/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: elsayed raafat elsayed  khashaba",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a63baa34-357e-468d-b98f-fd0e83287879",
        "address": "الخامس  ,مكاتب عود ميثاء ,فندق رافلز ,11268 ,Dubai",
        "phone": "97143243330",
        "email": "avocat@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "25d2c9bd-dbba-41ac-aff9-5ba0f37290d6",
    "firmName": "AL QARI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-05438",
    "licenseIssueDate": "08/10/2022 00:00:00",
    "licenseExpiryDate": "08/09/2026 00:00:00"
  },
  {
    "id": "f81e76b7-204f-4435-8a44-df4a4b5f3ee7",
    "slug": "eltayeb-hassabelrasoul-abdulla",
    "name": "Eltayeb Hassabelrasoul Abdulla",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/28/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Eltayeb Hassabelrasoul Abdulla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f81e76b7-204f-4435-8a44-df4a4b5f3ee7",
        "address": "الطابق الثاني - مكتب رقم 203 و 204  ,سيتي أفينو ,سيتى سنتر ديرة  ,83666 ,Dubai",
        "phone": "97142955050",
        "email": "adv.algharib@alghariblawfirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b1e23b77-356c-4678-ae4d-2ff4e494702b",
    "firmName": "ALGHARIB & PARTNERS ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-02978",
    "licenseIssueDate": "04/28/2015 00:00:00",
    "licenseExpiryDate": "04/23/2026 00:00:00"
  },
  {
    "id": "85704d00-284f-4ad3-a576-5b9b4132823b",
    "slug": "emad-abdel-halim-shaker-el-sayed-el-shennawy",
    "name": "Emad Abdel Halim Shaker El-Sayed El-Shennawy",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/27/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Emad Abdel Halim Shaker El-Sayed El-Shennawy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_85704d00-284f-4ad3-a576-5b9b4132823b",
        "address": "",
        "phone": "97145293307",
        "email": "info@hyadvocate.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0d19b22a-0678-43d9-ae17-061958b88e0e",
    "firmName": "HUDA YAQOOB ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05055",
    "licenseIssueDate": "09/27/2021 00:00:00",
    "licenseExpiryDate": "09/26/2026 00:00:00"
  },
  {
    "id": "a1d132b0-4d0e-4ce9-9b32-9888c8503436",
    "slug": "emad-abdulla-awdah-albayaa",
    "name": "Emad Abdulla Awdah Albayaa",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/17/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Emad Abdulla Awdah Albayaa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a1d132b0-4d0e-4ce9-9b32-9888c8503436",
        "address": "",
        "phone": "97143212555",
        "email": "awigdubai@awiglaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ece8ea60-9ecb-4d8c-aca3-fb73e4e52406",
    "firmName": "AL WASL INTERNATIONAL GROUP - ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01948",
    "licenseIssueDate": "11/17/2011 00:00:00",
    "licenseExpiryDate": "11/08/2025 00:00:00"
  },
  {
    "id": "67152f29-6eb3-4b63-833f-05885d16617e",
    "slug": "emad-al-habbak",
    "name": "Emad Al Habbak",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Emad Al Habbak",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_67152f29-6eb3-4b63-833f-05885d16617e",
        "address": "",
        "phone": "97143937700",
        "email": "info@galadarilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d863b662-c864-4193-8b3a-ff6ee5fe6c64",
    "firmName": "GALADARI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01489",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "9ecd9a64-0136-471e-b262-efdb90890e13",
    "slug": "emad-elsayed-attia-ali-abousalem",
    "name": "Emad Elsayed Attia Ali Abousalem",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/11/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Emad Elsayed Attia Ali Abousalem",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9ecd9a64-0136-471e-b262-efdb90890e13",
        "address": "khalid al kaitoob ,12 ,نسيمية تاور الطابق 12 1202 B ,فندق الفوكو  ,10755 ,Dubai",
        "phone": "97143586555",
        "email": "info@alkaitooblawyer.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "403277a6-eef2-4cfd-af95-9959280d6b40",
    "firmName": "AL KAITOOB ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05121",
    "licenseIssueDate": "01/11/2022 00:00:00",
    "licenseExpiryDate": "01/10/2026 00:00:00"
  },
  {
    "id": "a3dc7e23-56e9-4974-8672-aa5d69741188",
    "slug": "emad-mamoon-hassan-ahmed",
    "name": "emad mamoon hassan ahmed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/22/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: emad mamoon hassan ahmed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a3dc7e23-56e9-4974-8672-aa5d69741188",
        "address": "YASIR AL NAQBI ,21 ,48 BURJ ,SOFITEL DOWN  TOWN ,181111 ,Dubai",
        "phone": "97142689949",
        "email": "info@alnaqbipartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ad71430e-83ee-4cb5-a530-bc58db2618f6",
    "firmName": "ALNAQBI & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04855",
    "licenseIssueDate": "02/22/2021 00:00:00",
    "licenseExpiryDate": "02/21/2026 00:00:00"
  },
  {
    "id": "25266d7f-1eff-4337-bdef-d926b1813161",
    "slug": "emad-mansi-ibrahim-ahmed",
    "name": "Emad Mansi Ibrahim Ahmed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Emad Mansi Ibrahim Ahmed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_25266d7f-1eff-4337-bdef-d926b1813161",
        "address": "",
        "phone": "97142280002",
        "email": "advoali2020@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5029a3dc-098b-4d3f-9e38-afb0eb4319d0",
    "firmName": "ALI IBRAHIM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01527",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "2ea7748a-59af-4afa-9022-beac49a64e24",
    "slug": "emad-nour-eldeen-mahmoud-mahamed-abdekbaky",
    "name": "Emad Nour Eldeen Mahmoud Mahamed Abdekbaky",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/08/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Emad Nour Eldeen Mahmoud Mahamed Abdekbaky",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2ea7748a-59af-4afa-9022-beac49a64e24",
        "address": "",
        "phone": "97143298881",
        "email": "info@mslawuae.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2510dab9-717a-4a15-b189-4272261227e3",
    "firmName": "AL MADHANI & AL SHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05763",
    "licenseIssueDate": "03/08/2023 00:00:00",
    "licenseExpiryDate": "03/07/2026 00:00:00"
  },
  {
    "id": "3c14f32e-2ea3-41a8-a05a-ba70d124ca73",
    "slug": "emadeldin-hayoub",
    "name": "Emadeldin Hayoub",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/06/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-05-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Emadeldin Hayoub",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3c14f32e-2ea3-41a8-a05a-ba70d124ca73",
        "address": "210 ,OPAL TOWER ,BURJ KHALIFA ,96044 ,Dubai",
        "phone": "97143889993",
        "email": "admin@alsaadi-advocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8e611697-c589-4346-a3da-969764421cb6",
    "firmName": "MOHAMMAD ALSAADI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03179",
    "licenseIssueDate": "02/06/2024 00:00:00",
    "licenseExpiryDate": "02/05/2025 00:00:00"
  },
  {
    "id": "16e8cb6c-9e41-4ab1-99e4-83164f8e7f86",
    "slug": "eman-fathi-abdou-elsayed-fayed",
    "name": "Eman Fathi Abdou Elsayed Fayed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/08/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Eman Fathi Abdou Elsayed Fayed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_16e8cb6c-9e41-4ab1-99e4-83164f8e7f86",
        "address": "MOSTAFA MAHMOUD  ,1304 ,AL MOOSA TOWER 1 ,First Trade Center ,25635 ,Dubai",
        "phone": "97142254438",
        "email": "info@hkadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d73d1b91-74ae-4266-9f38-d28296d70f52",
    "firmName": "HAMDAN ALKAABI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05758",
    "licenseIssueDate": "03/08/2023 00:00:00",
    "licenseExpiryDate": "03/07/2026 00:00:00"
  },
  {
    "id": "c08c4b46-8a74-4b85-99ca-8b06ed382ae0",
    "slug": "eman-mohamed-aly-balaou",
    "name": "Eman Mohamed Aly Balaou",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/26/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Eman Mohamed Aly Balaou",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c08c4b46-8a74-4b85-99ca-8b06ed382ae0",
        "address": "3902 ,single business tower ,Sheikh Zayed Rd.  ,90077 ,Dubai",
        "phone": "97143804141 / 97143804141",
        "email": "info@united-advocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "52ebf695-ce46-4e03-abc9-f4d8d2f8a356",
    "firmName": "UNITED ADVOCATES",
    "registrationNumber": "L-04210",
    "licenseIssueDate": "08/26/2024 00:00:00",
    "licenseExpiryDate": "08/25/2026 00:00:00"
  },
  {
    "id": "f152da76-db89-408d-9852-f4ec8a238259",
    "slug": "emile-boulos",
    "name": "Emile Boulos",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/15/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Emile Boulos",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f152da76-db89-408d-9852-f4ec8a238259",
        "address": "",
        "phone": "97145979700 / 971505532609",
        "email": "rbeydoun@t-lawadvisors.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3d9f2bb9-85fe-49cc-9187-0b808bfa2a2d",
    "firmName": "Rindala Beydoun Legal Consultancy",
    "registrationNumber": "L-00515",
    "licenseIssueDate": "03/15/2021 00:00:00",
    "licenseExpiryDate": "03/14/2026 00:00:00"
  },
  {
    "id": "4b1b91d4-ff9e-48df-8731-9a1f6fb4bc3d",
    "slug": "emily-angharad-coates",
    "name": "Emily Angharad Coates",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/05/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Emily Angharad Coates",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4b1b91d4-ff9e-48df-8731-9a1f6fb4bc3d",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-05555",
    "licenseIssueDate": "10/05/2022 00:00:00",
    "licenseExpiryDate": "10/04/2026 00:00:00"
  },
  {
    "id": "d7220052-6111-4f42-a823-0ae9375efd20",
    "slug": "emily-aryeetey",
    "name": "Emily Aryeetey",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/22/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Emily Aryeetey",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d7220052-6111-4f42-a823-0ae9375efd20",
        "address": "",
        "phone": "97144073901 / 971503479508",
        "email": "Rania.Tadros@stephensonharwood.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dd5042a2-bb41-4123-9544-79c3fa831332",
    "firmName": "Stephenson Harwood (Middle East) LLP",
    "registrationNumber": "L-03666",
    "licenseIssueDate": "02/22/2017 00:00:00",
    "licenseExpiryDate": "02/18/2026 00:00:00"
  },
  {
    "id": "e3bd4c23-a05f-456f-a95d-fa070fbff726",
    "slug": "emily-beirne",
    "name": "Emily Beirne",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/23/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Emily Beirne",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e3bd4c23-a05f-456f-a95d-fa070fbff726",
        "address": "",
        "phone": "97144543900 / 971569199020",
        "email": "paul.hughes@kobrekim.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "259f7732-3596-4559-ae29-21cb6f4aa7d8",
    "firmName": "Kobre & Kim (GCC) LLP",
    "registrationNumber": "L-02686",
    "licenseIssueDate": "01/23/2024 00:00:00",
    "licenseExpiryDate": "01/22/2026 00:00:00"
  },
  {
    "id": "9c75aaf7-8b76-4870-9a52-769ff4c602dd",
    "slug": "emily-grace-verbiski",
    "name": "Emily Grace Verbiski",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/21/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Emily Grace Verbiski",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9c75aaf7-8b76-4870-9a52-769ff4c602dd",
        "address": "",
        "phone": "97143025100 / 971501501837",
        "email": "ccairns@trowers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "976857f5-9092-43cf-987d-bfa794a3fa51",
    "firmName": "Trowers & Hamlins LLP",
    "registrationNumber": "L-05859",
    "licenseIssueDate": "06/21/2023 00:00:00",
    "licenseExpiryDate": "06/20/2026 00:00:00"
  },
  {
    "id": "a6524b16-c447-4824-8b7c-7d38a4ccce4b",
    "slug": "emily-johanna-daly",
    "name": "Emily Johanna Daly",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/12/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Emily Johanna Daly",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a6524b16-c447-4824-8b7c-7d38a4ccce4b",
        "address": "",
        "phone": "97144073901 / 971503479508",
        "email": "Rania.Tadros@stephensonharwood.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dd5042a2-bb41-4123-9544-79c3fa831332",
    "firmName": "Stephenson Harwood (Middle East) LLP",
    "registrationNumber": "L-06405",
    "licenseIssueDate": "07/12/2024 00:00:00",
    "licenseExpiryDate": "07/11/2026 00:00:00"
  },
  {
    "id": "2a275ba1-df93-4d87-8ef1-e667a418737a",
    "slug": "emily-katherine-kemp",
    "name": "Emily Katherine Kemp",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/18/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-01-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Emily Katherine Kemp",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2a275ba1-df93-4d87-8ef1-e667a418737a",
        "address": "",
        "phone": "97144073901 / 971503479508",
        "email": "Rania.Tadros@stephensonharwood.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dd5042a2-bb41-4123-9544-79c3fa831332",
    "firmName": "Stephenson Harwood (Middle East) LLP",
    "registrationNumber": "L-05595",
    "licenseIssueDate": "01/18/2023 00:00:00",
    "licenseExpiryDate": "01/17/2026 00:00:00"
  },
  {
    "id": "3f92cac7-3209-4081-a84b-d84fc5fb0872",
    "slug": "emily-louise-widdrington",
    "name": "Emily Louise Widdrington",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/11/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Emily Louise Widdrington",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3f92cac7-3209-4081-a84b-d84fc5fb0872",
        "address": "Index Tower ,DIFC ,506896 ,",
        "phone": "97142782300 / 971551154791",
        "email": "GLeggate@wfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e2b82cfc-80a5-4957-ae41-b1a7beb693c1",
    "firmName": "Watson, Farley & Williams (Middle East) LLP",
    "registrationNumber": "L-06493",
    "licenseIssueDate": "09/11/2024 00:00:00",
    "licenseExpiryDate": "09/10/2026 00:00:00"
  },
  {
    "id": "2b0ee98e-3ed1-483b-b8d4-456f561b8d0a",
    "slug": "emily-marie-law-greig",
    "name": "Emily Marie Law Greig",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/18/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Emily Marie Law Greig",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2b0ee98e-3ed1-483b-b8d4-456f561b8d0a",
        "address": "ICD Brookfield Place ,Za'abeel 2 ,103747 ,",
        "phone": "97143696300 / 971506008159",
        "email": "mohammed.paracha@nortonrosefulbright.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c4aaee93-0ec4-4982-9a48-a23699492056",
    "firmName": "Norton Rose Fullbright (Middle East) LLP",
    "registrationNumber": "L-05375",
    "licenseIssueDate": "07/18/2022 00:00:00",
    "licenseExpiryDate": "07/17/2026 00:00:00"
  },
  {
    "id": "0632beea-12f4-4d17-b0a3-3a12504adf8c",
    "slug": "emma-elizabeth-fidler",
    "name": "Emma Elizabeth Fidler",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/01/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Emma Elizabeth Fidler",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0632beea-12f4-4d17-b0a3-3a12504adf8c",
        "address": "",
        "phone": "97144073901 / 971503479508",
        "email": "Rania.Tadros@stephensonharwood.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dd5042a2-bb41-4123-9544-79c3fa831332",
    "firmName": "Stephenson Harwood (Middle East) LLP",
    "registrationNumber": "L-04869",
    "licenseIssueDate": "03/01/2021 00:00:00",
    "licenseExpiryDate": "02/28/2026 00:00:00"
  },
  {
    "id": "19c356e5-63c6-4881-b78f-ae3953fb7754",
    "slug": "emma-louise-noble",
    "name": "Emma Louise Noble",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/24/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Emma Louise Noble",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_19c356e5-63c6-4881-b78f-ae3953fb7754",
        "address": "THE OFFICES 1 ,DWTC ,115580 ,",
        "phone": "97143739700 / 971501148248",
        "email": "nitesh.pradhan@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "361fdc64-6b6f-4f37-abca-c52af8473b84",
    "firmName": "Pinsent Masons  LLP (DWTCA Branch)",
    "registrationNumber": "L-06436",
    "licenseIssueDate": "07/24/2024 00:00:00",
    "licenseExpiryDate": "07/23/2026 00:00:00"
  },
  {
    "id": "c45bb6ed-45e0-4066-ab5f-3e3e3829b423",
    "slug": "emma-louise-tormey",
    "name": "Emma Louise Tormey",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/28/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Emma Louise Tormey",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c45bb6ed-45e0-4066-ab5f-3e3e3829b423",
        "address": "ICD-Brookfield Place ,DIFC ,119974 ,",
        "phone": "97143652000",
        "email": "david.charlier@ashurst.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c01c3c61-4d90-4058-8429-61dd01e615f5",
    "firmName": "Ashurst LLP-DIFC",
    "registrationNumber": "L-04120",
    "licenseIssueDate": "05/28/2018 00:00:00",
    "licenseExpiryDate": "05/26/2026 00:00:00"
  },
  {
    "id": "91dc32e0-bf6e-4630-b4f2-34d0b2f9aab5",
    "slug": "emma-milne",
    "name": "Emma Milne",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Emma Milne",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_91dc32e0-bf6e-4630-b4f2-34d0b2f9aab5",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-00144",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "76a17ecc-7081-4c0b-ad40-03298f7ae51d",
    "slug": "emma-rachael-george",
    "name": "Emma Rachael George",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/01/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Emma Rachael George",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_76a17ecc-7081-4c0b-ad40-03298f7ae51d",
        "address": "",
        "phone": "97143897000 / 971506553198",
        "email": "nasseralikhasawneh@eversheds-sutherland.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "74a21d43-41d8-480a-a6af-6939b7c98a95",
    "firmName": "Eversheds Sutherland (International LLP) Dubai Branch",
    "registrationNumber": "L-05346",
    "licenseIssueDate": "06/01/2022 00:00:00",
    "licenseExpiryDate": "05/31/2026 00:00:00"
  },
  {
    "id": "dec398f5-3a50-4ea2-afba-f6a5ee1ca9a7",
    "slug": "emmanuel-ninos",
    "name": "Emmanuel Ninos",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/03/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Emmanuel Ninos",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dec398f5-3a50-4ea2-afba-f6a5ee1ca9a7",
        "address": "Index Tower ,DIFC ,506896 ,",
        "phone": "97142782300 / 971551154791",
        "email": "GLeggate@wfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e2b82cfc-80a5-4957-ae41-b1a7beb693c1",
    "firmName": "Watson, Farley & Williams (Middle East) LLP",
    "registrationNumber": "L-06945",
    "licenseIssueDate": "08/22/2025 00:00:00",
    "licenseExpiryDate": "08/21/2026 00:00:00"
  },
  {
    "id": "b481b2ec-6401-4d13-ae3e-19414ce8fa26",
    "slug": "engie-osama-mohsen",
    "name": "Engie Osama Mohsen",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/29/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Engie Osama Mohsen",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b481b2ec-6401-4d13-ae3e-19414ce8fa26",
        "address": "0 ,ICD Brookfield Place Level 13 ,Trade Centre ,506569 ,Dubai",
        "phone": "97145099100 / 971501006965",
        "email": "menahr@freshfields.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "970f6246-e737-41a7-9c6c-5aa5b8335d45",
    "firmName": "Freshfields LLP DIFC",
    "registrationNumber": "L-04890",
    "licenseIssueDate": "03/29/2021 00:00:00",
    "licenseExpiryDate": "03/28/2026 00:00:00"
  },
  {
    "id": "f6d94379-def1-4f24-b9fa-d1ddf0562bb9",
    "slug": "eric-teo",
    "name": "Eric Teo",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/15/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Eric Teo",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f6d94379-def1-4f24-b9fa-d1ddf0562bb9",
        "address": "3902 ,single business tower ,Sheikh Zayed Rd.  ,90077 ,Dubai",
        "phone": "97143804141 / 97143804141",
        "email": "info@united-advocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "52ebf695-ce46-4e03-abc9-f4d8d2f8a356",
    "firmName": "UNITED ADVOCATES",
    "registrationNumber": "L-00361",
    "licenseIssueDate": "04/15/2015 00:00:00",
    "licenseExpiryDate": "04/09/2026 00:00:00"
  },
  {
    "id": "0b1ea61b-df7d-4c7f-8d58-b268d1ce8f01",
    "slug": "erika-lauren-couchman",
    "name": "Erika Lauren Couchman",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/18/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-01-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Erika Lauren Couchman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0b1ea61b-df7d-4c7f-8d58-b268d1ce8f01",
        "address": "Index Tower ,506548 ,Dubai",
        "phone": "97147096300 / 971506767433",
        "email": "amateen@reedsmith.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b3f87e90-7ce9-4097-82c4-15232365f175",
    "firmName": "Reed Smith LLP",
    "registrationNumber": "L-05677",
    "licenseIssueDate": "01/18/2023 00:00:00",
    "licenseExpiryDate": "01/17/2026 00:00:00"
  },
  {
    "id": "c45e5305-cc00-4741-b6e5-a09370482639",
    "slug": "erin-louise-miller-rankin",
    "name": "Erin Louise Miller Rankin",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/01/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Erin Louise Miller Rankin",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c45e5305-cc00-4741-b6e5-a09370482639",
        "address": "0 ,ICD Brookfield Place Level 13 ,Trade Centre ,506569 ,Dubai",
        "phone": "97145099100 / 971501006965",
        "email": "menahr@freshfields.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "970f6246-e737-41a7-9c6c-5aa5b8335d45",
    "firmName": "Freshfields LLP DIFC",
    "registrationNumber": "L-00571",
    "licenseIssueDate": "04/01/2012 00:00:00",
    "licenseExpiryDate": "03/23/2026 00:00:00"
  },
  {
    "id": "eb29643b-1ceb-4700-bc8f-b715ec773769",
    "slug": "esam-omar-elsharaby",
    "name": "Esam Omar Elsharaby",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Esam Omar Elsharaby",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_eb29643b-1ceb-4700-bc8f-b715ec773769",
        "address": "",
        "phone": "97142414303",
        "email": "info@eslegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "eb927a69-9421-4515-bc18-08b71fb44bb2",
    "firmName": "WALEED ALMARZOOQI AND KHALID MOHAMED ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-01586",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "589463ae-dc24-4019-86b2-e55dd48a81a0",
    "slug": "eslam-adel-hussein-mahmoud",
    "name": "Eslam Adel Hussein Mahmoud",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/13/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Eslam Adel Hussein Mahmoud",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_589463ae-dc24-4019-86b2-e55dd48a81a0",
        "address": "4th Floor/ Office no. 401 ,Business Avenue  ,Infront- Terminal 2  ,115263 ,Dubai",
        "phone": "97144518866",
        "email": "info@aldhaheriinternational.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "cf3c19c0-d396-4bcb-b1db-b81273ed0b4c",
    "firmName": "AL DHAHERI INTERNATIONAL ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05023",
    "licenseIssueDate": "09/13/2021 00:00:00",
    "licenseExpiryDate": "09/12/2026 00:00:00"
  },
  {
    "id": "8a3f74ef-c40f-41f1-8bf8-50f2ef9b324d",
    "slug": "eslam-ahmed-mohamed-omar-elnager",
    "name": "ESLAM AHMED MOHAMED OMAR ELNAGER",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/19/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ESLAM AHMED MOHAMED OMAR ELNAGER",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8a3f74ef-c40f-41f1-8bf8-50f2ef9b324d",
        "address": "203 ,BUSINESS VENUE BLDG ,TASHEEL ,444249 ,Dubai",
        "phone": "97145807964 / 971562302002",
        "email": "info@emirates-lawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ce1aadbc-a1c1-4002-90eb-cfa12655b1d1",
    "firmName": "SAEED ALHASHMI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-06937",
    "licenseIssueDate": "08/19/2025 00:00:00",
    "licenseExpiryDate": "08/18/2026 00:00:00"
  },
  {
    "id": "360ddf3c-39d4-4855-b29e-5101b89f3b79",
    "slug": "eslam-farouk-abdelhamed-abdelwahab",
    "name": "Eslam Farouk Abdelhamed Abdelwahab",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/08/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Eslam Farouk Abdelhamed Abdelwahab",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_360ddf3c-39d4-4855-b29e-5101b89f3b79",
        "address": "11 مكتب رقم 1104 ,وصل بيزنش سنترال ,خلف سيتي سنتر ديره ,23404 ,Dubai",
        "phone": "97142865503 / 971502705678",
        "email": "info-dxb@almulla-advocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6a822223-cec3-43fe-b3a7-3d4a10d010c4",
    "firmName": "HASSAN ASHOOR AL MULLA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05105",
    "licenseIssueDate": "11/08/2021 00:00:00",
    "licenseExpiryDate": "11/07/2025 00:00:00"
  },
  {
    "id": "43e8f2e6-17f1-42af-b167-d8566861fe33",
    "slug": "eslam-hassan-ali-hassan",
    "name": "Eslam Hassan Ali Hassan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/15/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Eslam Hassan Ali Hassan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_43e8f2e6-17f1-42af-b167-d8566861fe33",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04085",
    "licenseIssueDate": "04/15/2018 00:00:00",
    "licenseExpiryDate": "04/12/2026 00:00:00"
  },
  {
    "id": "e14aa66d-f27e-459e-9c10-97d167065b5c",
    "slug": "eslam-hossam-talaat-hegazy",
    "name": "eslam hossam talaat hegazy",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/28/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: eslam hossam talaat hegazy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e14aa66d-f27e-459e-9c10-97d167065b5c",
        "address": "",
        "phone": "97144472020",
        "email": "info@arnadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e6573267-5872-48d8-add1-06a3deccf9e4",
    "firmName": "ABDUL RAHMAN NASEEB ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06475",
    "licenseIssueDate": "08/28/2024 00:00:00",
    "licenseExpiryDate": "08/27/2026 00:00:00"
  },
  {
    "id": "03eee573-f88e-4acf-a521-0593b97a05a9",
    "slug": "eslam-mohamed-abualfotouh-mostafa-soliman",
    "name": "eslam mohamed abualfotouh mostafa soliman",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/12/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: eslam mohamed abualfotouh mostafa soliman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_03eee573-f88e-4acf-a521-0593b97a05a9",
        "address": "4th Floor/ Office no. 401 ,Business Avenue  ,Infront- Terminal 2  ,115263 ,Dubai",
        "phone": "97144518866",
        "email": "info@aldhaheriinternational.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "cf3c19c0-d396-4bcb-b1db-b81273ed0b4c",
    "firmName": "AL DHAHERI INTERNATIONAL ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05306",
    "licenseIssueDate": "04/12/2022 00:00:00",
    "licenseExpiryDate": "04/11/2026 00:00:00"
  },
  {
    "id": "562a6a95-b552-4c18-9225-1148bd28f235",
    "slug": "eslam-salah-ashry-mohamed",
    "name": "Eslam Salah Ashry Mohamed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/22/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Eslam Salah Ashry Mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_562a6a95-b552-4c18-9225-1148bd28f235",
        "address": "6 ,Office Nos. 603, 604 & 605, Level 6, Burj Daman ,Dubai International Financial Centre ,506555 ,Dubai",
        "phone": "97143506400 / 971504654755",
        "email": "r.hickman@aglaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8690f7d5-6b96-4649-9589-71303f2c2707",
    "firmName": "Addleshaw Goddard (Middle East) LLP",
    "registrationNumber": "L-05723",
    "licenseIssueDate": "02/22/2023 00:00:00",
    "licenseExpiryDate": "02/21/2026 00:00:00"
  },
  {
    "id": "eca7e844-67f7-4e51-a1d0-913f0243994a",
    "slug": "esraa-essam-ahmed-mohamed",
    "name": "Esraa Essam Ahmed Mohamed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/21/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Esraa Essam Ahmed Mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_eca7e844-67f7-4e51-a1d0-913f0243994a",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-06835",
    "licenseIssueDate": "05/21/2025 00:00:00",
    "licenseExpiryDate": "05/20/2026 00:00:00"
  },
  {
    "id": "f30781df-a208-4be7-8aae-878c4c8175d4",
    "slug": "esraa-mohammad-ahmad-alqudah",
    "name": "Esraa Mohammad Ahmad Alqudah",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/29/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Esraa Mohammad Ahmad Alqudah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f30781df-a208-4be7-8aae-878c4c8175d4",
        "address": "801/802 ,Park Place ,WTC ,384557 ,Dubai",
        "phone": "97143203999",
        "email": "info.dubai@alemlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e3088c8b-a7dc-4f38-a04d-cb4c7d050ed9",
    "firmName": "AHMED MOHAMMED BASHIR ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06677",
    "licenseIssueDate": "01/29/2025 00:00:00",
    "licenseExpiryDate": "01/28/2026 00:00:00"
  },
  {
    "id": "2630f7d5-625c-441b-b0a4-51b024bf281e",
    "slug": "essam-al-asaad",
    "name": "Essam Al Asaad",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/16/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Essam Al Asaad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2630f7d5-625c-441b-b0a4-51b024bf281e",
        "address": "4/406 ,Acico Business Park  ,Behind Nissan Showroom ,186344 ,Dubai",
        "phone": "97142989888 / 971505948989",
        "email": "AHMEDIBRAHIMLAW@GMAIL.COM",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dbb4bc27-1ace-4e78-8ee2-db7bfd85e001",
    "firmName": "AHMED IBRAHIM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02886",
    "licenseIssueDate": "10/16/2014 00:00:00",
    "licenseExpiryDate": "10/10/2026 00:00:00"
  },
  {
    "id": "8ce769d2-7da5-4504-abbc-3b40ae813977",
    "slug": "essam-eldin-abdelrahman",
    "name": "Essam Eldin Abdelrahman",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/28/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Essam Eldin Abdelrahman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8ce769d2-7da5-4504-abbc-3b40ae813977",
        "address": "",
        "phone": "97142946164",
        "email": "info@albannai-law.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "73525ec0-5573-4652-8fd8-c2ef0f19b399",
    "firmName": "ALBANNAI & CO.",
    "registrationNumber": "L-02497",
    "licenseIssueDate": "11/28/2013 00:00:00",
    "licenseExpiryDate": "11/21/2025 00:00:00"
  },
  {
    "id": "fccd9062-7c7b-4368-adbf-3540016ed941",
    "slug": "essam-ibrahim-suwarelzahab",
    "name": "Essam Ibrahim Suwarelzahab",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Essam Ibrahim Suwarelzahab",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fccd9062-7c7b-4368-adbf-3540016ed941",
        "address": "",
        "phone": "97142999434 / 971563666333",
        "email": "info@moaza-advocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6311e53c-d1e0-469a-92a1-e290c2faf954",
    "firmName": "MOZA ALJABRI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02021",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "54c018d0-8ddf-4807-9777-c4600e649ce0",
    "slug": "essam-mohamed",
    "name": "Essam Mohamed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/13/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Essam Mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_54c018d0-8ddf-4807-9777-c4600e649ce0",
        "address": "",
        "phone": "97143528314",
        "email": "alomran.advocates@alaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c0d5ee8d-2020-4bd5-8b4f-efe6ea0f4acc",
    "firmName": "ABDULLA ALOMRAN ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03517",
    "licenseIssueDate": "10/13/2016 00:00:00",
    "licenseExpiryDate": "10/09/2026 00:00:00"
  },
  {
    "id": "319fe68c-5643-4ac6-808b-b02ae2a474ca",
    "slug": "essam-salah-ahmed-esmail",
    "name": "ESSAM SALAH AHMED ESMAIL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/05/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ESSAM SALAH AHMED ESMAIL",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_319fe68c-5643-4ac6-808b-b02ae2a474ca",
        "address": "khalid al kaitoob ,12 ,نسيمية تاور الطابق 12 1202 B ,فندق الفوكو  ,10755 ,Dubai",
        "phone": "97143586555",
        "email": "info@alkaitooblawyer.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "403277a6-eef2-4cfd-af95-9959280d6b40",
    "firmName": "AL KAITOOB ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06814",
    "licenseIssueDate": "05/13/2025 00:00:00",
    "licenseExpiryDate": "05/12/2026 00:00:00"
  },
  {
    "id": "e58272bf-506c-45dd-8db6-69707136d613",
    "slug": "essia-meddeb",
    "name": "Essia Meddeb",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/08/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Essia Meddeb",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e58272bf-506c-45dd-8db6-69707136d613",
        "address": "Hussain Ali Al Jaziri ,11 ,City Tower 2 ,Crown Plaza hotel Sheikh Zayed Road ,4253 ,Dubai",
        "phone": "97142626777 / 971529087670",
        "email": "courts@jaflaws.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c58d8654-b428-46b3-abd5-024e4331ee53",
    "firmName": "JAAFAR ALWAN & AL JAZIRI & ASSOCIATES",
    "registrationNumber": "L-04588",
    "licenseIssueDate": "01/08/2020 00:00:00",
    "licenseExpiryDate": "01/07/2026 00:00:00"
  },
  {
    "id": "29c9dc2d-ad0e-4400-b741-513f20b3d3a6",
    "slug": "eugenie-camille-marie-claude-bruyas",
    "name": "Eugenie Camille Marie Claude Bruyas",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/07/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Eugenie Camille Marie Claude Bruyas",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_29c9dc2d-ad0e-4400-b741-513f20b3d3a6",
        "address": "IH-00-01-CP-05 ,DIFC ,506832 ,",
        "phone": "/ 971506957753",
        "email": "admin@supportlegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "1607c199-ca4b-4bc1-89e9-98dad0300645",
    "firmName": "Support Legal ( DIFC) Limited",
    "registrationNumber": "L-05058",
    "licenseIssueDate": "03/07/2024 00:00:00",
    "licenseExpiryDate": "03/06/2026 00:00:00"
  },
  {
    "id": "380a05ae-b2fa-465b-85f5-912fc7822d42",
    "slug": "evania-dsouza",
    "name": "Evania D'Souza",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/14/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Evania D'Souza",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_380a05ae-b2fa-465b-85f5-912fc7822d42",
        "address": "6 ,Office Nos. 603, 604 & 605, Level 6, Burj Daman ,Dubai International Financial Centre ,506555 ,Dubai",
        "phone": "97143506400 / 971504654755",
        "email": "r.hickman@aglaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8690f7d5-6b96-4649-9589-71303f2c2707",
    "firmName": "Addleshaw Goddard (Middle East) LLP",
    "registrationNumber": "L-06802",
    "licenseIssueDate": "05/14/2025 00:00:00",
    "licenseExpiryDate": "05/13/2026 00:00:00"
  },
  {
    "id": "60060af9-89f5-421c-8fdd-c4e855cf8f30",
    "slug": "eve-brady",
    "name": "Eve Brady",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/04/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-03-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Eve Brady",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_60060af9-89f5-421c-8fdd-c4e855cf8f30",
        "address": "",
        "phone": "97143742800 / 971506450677",
        "email": "jabbott21@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7a59d310-ff72-4318-b41c-27095c163d0f",
    "firmName": "CMS (UAE) LLP",
    "registrationNumber": "L-06091",
    "licenseIssueDate": "01/04/2024 00:00:00",
    "licenseExpiryDate": "01/03/2026 00:00:00"
  },
  {
    "id": "c6188837-f88c-498d-b6a5-c2eee1a1792e",
    "slug": "eve-ormond-cristo",
    "name": "Eve Ormond Cristo",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/14/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Eve Ormond Cristo",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c6188837-f88c-498d-b6a5-c2eee1a1792e",
        "address": "",
        "phone": "97143025100 / 971501501837",
        "email": "ccairns@trowers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "976857f5-9092-43cf-987d-bfa794a3fa51",
    "firmName": "Trowers & Hamlins LLP",
    "registrationNumber": "L-06773",
    "licenseIssueDate": "05/14/2025 00:00:00",
    "licenseExpiryDate": "05/13/2026 00:00:00"
  },
  {
    "id": "cad46229-5cad-4168-9f91-34646763f5b2",
    "slug": "ewan-andrew-john-sherriff",
    "name": "Ewan Andrew John Sherriff",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/13/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ewan Andrew John Sherriff",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cad46229-5cad-4168-9f91-34646763f5b2",
        "address": "",
        "phone": "97104309100 / 971564013758",
        "email": "c.royle@taylorwessing.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d51b6f43-8c62-486f-a1ab-6ee3b87c8006",
    "firmName": "Taylor Wessing LLP (Dubai Branch)",
    "registrationNumber": "L-06240",
    "licenseIssueDate": "03/13/2024 00:00:00",
    "licenseExpiryDate": "03/12/2026 00:00:00"
  },
  {
    "id": "2666b4e8-a03c-4518-9982-52cda638c1b1",
    "slug": "eyad-hashash",
    "name": "Eyad Hashash",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/10/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Eyad Hashash",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2666b4e8-a03c-4518-9982-52cda638c1b1",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506698 ,Dubai",
        "phone": "97147046300 / 971507900661",
        "email": "nada.mourad@lw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "b2b92ce9-90a4-4e34-ae2f-ae0dc7ca9060",
    "firmName": "Latham & Watkins LLP",
    "registrationNumber": "L-03489",
    "licenseIssueDate": "10/10/2016 00:00:00",
    "licenseExpiryDate": "10/06/2025 00:00:00"
  },
  {
    "id": "6b313c65-b176-4367-a172-229bc6c2f998",
    "slug": "ezzat-hossin",
    "name": "Ezzat Hossin",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ezzat Hossin",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6b313c65-b176-4367-a172-229bc6c2f998",
        "address": "",
        "phone": "97144230000 / 971552009022",
        "email": "UAE-CourtClerks@habibalmulla.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3eba82bb-8ec4-4cbd-80d0-a793cb993fde",
    "firmName": "Habib Al Mulla & Partners ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01425",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "9596c87b-6930-42e8-96ae-c7a42760ff9b",
    "slug": "fadi-nader",
    "name": "FADI NADER",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/21/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: FADI NADER",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9596c87b-6930-42e8-96ae-c7a42760ff9b",
        "address": "Ahmed Mohammed Matar Matar Almheiri ,4 ,SOBHA SAPPHIRE ,Bussines Bay ,393294 ,Dubai",
        "phone": "97143387880 / 971506478881",
        "email": "almheiricourts@bridgelg.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4cb37c1d-1403-421d-bc15-9451cc629e9d",
    "firmName": "AHMED MATAR AL MHEIRI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-04638",
    "licenseIssueDate": "04/21/2020 00:00:00",
    "licenseExpiryDate": "04/20/2026 00:00:00"
  },
  {
    "id": "9e63deef-8fef-4204-8f25-cccec8073d1f",
    "slug": "fady-essam-saleh",
    "name": "Fady Essam Saleh",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/14/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Fady Essam Saleh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9e63deef-8fef-4204-8f25-cccec8073d1f",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506698 ,Dubai",
        "phone": "97147046300 / 971507900661",
        "email": "nada.mourad@lw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b2b92ce9-90a4-4e34-ae2f-ae0dc7ca9060",
    "firmName": "Latham & Watkins LLP",
    "registrationNumber": "L-06790",
    "licenseIssueDate": "05/14/2025 00:00:00",
    "licenseExpiryDate": "05/13/2026 00:00:00"
  },
  {
    "id": "670b9b4e-3fc5-4c46-9838-30db14974f37",
    "slug": "fady-ghanem",
    "name": "Fady Ghanem",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Fady Ghanem",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_670b9b4e-3fc5-4c46-9838-30db14974f37",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01329",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "85e0533d-85e7-47ab-8363-98836c1bc5e4",
    "slug": "fahad-khalid-khalid-mustaghis",
    "name": "Fahad Khalid Khalid Mustaghis",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/24/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Fahad Khalid Khalid Mustaghis",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_85e0533d-85e7-47ab-8363-98836c1bc5e4",
        "address": "HAMDAN ALSHAMSI ,الطابق الرابع مكتب 401, 406,407 ,بي سكوير 01 ,مجمع دبي سكوير ,116564 ,Dubai",
        "phone": "97143469262",
        "email": "courts@has.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de2c61a6-9d00-457e-ad1d-e73e4e62d9bd",
    "firmName": "HAMDAN ALSHAMSI LAWYER & LEGAL CONSULTANTS",
    "registrationNumber": "L-06403",
    "licenseIssueDate": "07/24/2024 00:00:00",
    "licenseExpiryDate": "07/23/2026 00:00:00"
  },
  {
    "id": "c4a21a60-cf10-4036-9e28-6df3066460d2",
    "slug": "fahmy-fahmy-elhallag",
    "name": "Fahmy Fahmy Elhallag",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/28/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Fahmy Fahmy Elhallag",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c4a21a60-cf10-4036-9e28-6df3066460d2",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-02235",
    "licenseIssueDate": "12/28/2011 00:00:00",
    "licenseExpiryDate": "12/19/2025 00:00:00"
  },
  {
    "id": "7b6b3740-f21a-4b1c-8d86-5acff9c3e44f",
    "slug": "faiq-alchalaby",
    "name": "Faiq Alchalaby",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/08/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Faiq Alchalaby",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7b6b3740-f21a-4b1c-8d86-5acff9c3e44f",
        "address": "MARYAM AHMAD BLDG ,Al Barha ,45777 ,",
        "phone": "97143117401 / 971508537396",
        "email": "faiq@alchalaby.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "e6ff998b-c5d8-4ed8-8c69-9574d5cfe8f4",
    "firmName": "Al Noor Legal Consultants",
    "registrationNumber": "L-00491",
    "licenseIssueDate": "10/08/2011 00:00:00",
    "licenseExpiryDate": "09/29/2026 00:00:00"
  },
  {
    "id": "9c3b8290-d8c2-4b50-af4c-4c81532f4eab",
    "slug": "fairouz-zaher-addeen",
    "name": "Fairouz Zaher Addeen",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGWgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/30/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Fairouz Zaher Addeen",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9c3b8290-d8c2-4b50-af4c-4c81532f4eab",
        "address": "الثالث - 329 ,إمارات اتريوم  ,مزايا سنتر ,4609 ,Dubai",
        "phone": "97142225151",
        "email": "team@nbadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "170463c8-fa0b-4323-bb48-8ea54d32ed3d",
    "firmName": "NAJI BEIDOUN ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01216",
    "licenseIssueDate": "07/30/2013 00:00:00",
    "licenseExpiryDate": "07/23/2026 00:00:00"
  },
  {
    "id": "2993477a-6cf5-41d6-8137-e3ea24325079",
    "slug": "faisal-ahmad-sinan",
    "name": "Faisal Ahmad Sinan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/25/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Faisal Ahmad Sinan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2993477a-6cf5-41d6-8137-e3ea24325079",
        "address": "21 ,Rolex Tower ,Emirates Grand Hotel ,94334 ,Dubai",
        "phone": "97143277772 / 97145584900",
        "email": "info@globaladvocates.net",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9b42810f-1d55-4aea-ac4a-7d9d1b25ac08",
    "firmName": "GLOBAL ADVOCACY & LEGAL COUNSEL",
    "registrationNumber": "L-06626",
    "licenseIssueDate": "12/25/2024 00:00:00",
    "licenseExpiryDate": "12/24/2025 00:00:00"
  },
  {
    "id": "fdcedbd2-520b-446f-bdb6-7183c7a75ca1",
    "slug": "faisal-attia-attia",
    "name": "Faisal Attia Attia",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Faisal Attia Attia",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fdcedbd2-520b-446f-bdb6-7183c7a75ca1",
        "address": "- ,THE OFFICES 1 ,DWTC ,115580 ,Dubai",
        "phone": "97143739700 / 971562196031",
        "email": "catherine.workman@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6b4ebb23-ef2e-4305-a1ee-43a11e4b1cae",
    "firmName": "Pinsent Masons LLP - Dubai Branch",
    "registrationNumber": "L-01256",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "d9222fd1-a105-42dc-9675-de999f0b498f",
    "slug": "faisal-mohamed-ali-al-hinai",
    "name": "Faisal Mohamed Ali Al Hinai",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/08/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Faisal Mohamed Ali Al Hinai",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d9222fd1-a105-42dc-9675-de999f0b498f",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-05233",
    "licenseIssueDate": "03/08/2022 00:00:00",
    "licenseExpiryDate": "03/07/2026 00:00:00"
  },
  {
    "id": "50714303-ba6f-4074-abd3-8eb7f3a25100",
    "slug": "faisal-mohammad-hashim-alblooshi",
    "name": "faisal mohammad hashim alblooshi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/07/2023",
    "licenseStatus": "active",
    "licenseExpiry": "2024-07-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: faisal mohammad hashim alblooshi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_50714303-ba6f-4074-abd3-8eb7f3a25100",
        "address": "الطابق الاول  ,بناية مشاريع قرقاش - مكتب رقم 102  ,وكاله مرسيدس  ,393947 ,Dubai",
        "phone": "97143799917",
        "email": "info@amt-legal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2485aa73-a460-4867-9452-297e9feb733e",
    "firmName": "MARYAM ABDULLAH ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-05933",
    "licenseIssueDate": "07/12/2023 00:00:00",
    "licenseExpiryDate": "07/11/2026 00:00:00"
  },
  {
    "id": "0519d3c4-fd8c-4e50-9fa0-12cfc7ff4aa6",
    "slug": "faisal-sameeruddin-khan",
    "name": "Faisal Sameeruddin Khan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/02/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Faisal Sameeruddin Khan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0519d3c4-fd8c-4e50-9fa0-12cfc7ff4aa6",
        "address": "Adel Salem Abdulla Salem Alghafri ,16th floor, Office: 1602 ,Aspect Tower ,Bay Avenue Mall ,444470 ,Dubai",
        "phone": "97142807052 / 971555666589",
        "email": "info@adelalghafri.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d0789ea6-22d2-4893-aa99-e55ff1b4473a",
    "firmName": "ADEL AL GHAFRI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02861",
    "licenseIssueDate": "10/02/2023 00:00:00",
    "licenseExpiryDate": "10/01/2026 00:00:00"
  },
  {
    "id": "9b1e4acc-36b2-4ba7-82d7-18e54bc38259",
    "slug": "faiza-khalifa",
    "name": "Faiza Khalifa",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Faiza Khalifa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9b1e4acc-36b2-4ba7-82d7-18e54bc38259",
        "address": "TWENTY ,ALMASRAF TOWER ,DUBAI MUNICIPALITY ,3858 ,Dubai",
        "phone": "97142222314",
        "email": "apxjuris@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "f8f827cb-389c-48f1-841e-a39afdd09f7d",
    "firmName": "APEX JURIS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01436",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "f8124345-af21-40fa-8bcb-01bb45796988",
    "slug": "faizan-daud-daud-ahmed",
    "name": "Faizan Daud Daud Ahmed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/06/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Faizan Daud Daud Ahmed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f8124345-af21-40fa-8bcb-01bb45796988",
        "address": "",
        "phone": "97143937700",
        "email": "info@galadarilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d863b662-c864-4193-8b3a-ff6ee5fe6c64",
    "firmName": "GALADARI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06121",
    "licenseIssueDate": "12/06/2023 00:00:00",
    "licenseExpiryDate": "12/05/2025 00:00:00"
  },
  {
    "id": "9022bb76-979b-43d9-bbcf-a406b092824c",
    "slug": "farag-abdelhalim-fergani",
    "name": "Farag Abdelhalim Fergani",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/27/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Farag Abdelhalim Fergani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9022bb76-979b-43d9-bbcf-a406b092824c",
        "address": "B2207 ,لطيفة تاور ,بجانب فندق فوكو دبي‎ ,410889 ,Dubai",
        "phone": "97143447557",
        "email": "info@amirasaqeradvo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d4393464-394a-4311-ac7d-2247c5af8bad",
    "firmName": "AMIRA SAQER ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03052",
    "licenseIssueDate": "05/27/2015 00:00:00",
    "licenseExpiryDate": "05/22/2026 00:00:00"
  },
  {
    "id": "b28fc92b-f642-4af5-b3e6-aeff8568d16d",
    "slug": "farag-ibrahim-deifalla-mohamed",
    "name": "Farag Ibrahim Deifalla Mohamed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/28/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Farag Ibrahim Deifalla Mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b28fc92b-f642-4af5-b3e6-aeff8568d16d",
        "address": "",
        "phone": "97142693680",
        "email": "info@sas-advocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0e62e480-e84f-4560-8f59-ad0f1a6cbbad",
    "firmName": "Sulaiman Alshebli Advocates and Legal Consultants",
    "registrationNumber": "L-05526",
    "licenseIssueDate": "09/28/2022 00:00:00",
    "licenseExpiryDate": "09/27/2026 00:00:00"
  },
  {
    "id": "d7544d0f-7909-4383-ae9a-b4773bded274",
    "slug": "farah-al-nabulsi",
    "name": "Farah Al-Nabulsi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/03/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Farah Al-Nabulsi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d7544d0f-7909-4383-ae9a-b4773bded274",
        "address": "",
        "phone": "97144272700 / 971545824605",
        "email": "tony.griffiths@klgates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "fb8fc340-ceef-4b83-8f2b-9b24d4604967",
    "firmName": "K & L Gates LLP",
    "registrationNumber": "L-03504",
    "licenseIssueDate": "10/03/2016 00:00:00",
    "licenseExpiryDate": "09/28/2026 00:00:00"
  },
  {
    "id": "c7c91e52-38e7-493e-a9bc-85f249af2946",
    "slug": "farah-chawki-bou-nassar",
    "name": "Farah Chawki Bou Nassar",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/07/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Farah Chawki Bou Nassar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c7c91e52-38e7-493e-a9bc-85f249af2946",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-06765",
    "licenseIssueDate": "05/07/2025 00:00:00",
    "licenseExpiryDate": "05/06/2026 00:00:00"
  },
  {
    "id": "00b33c35-735f-4d99-8862-800556e2ef40",
    "slug": "farah-el-masri",
    "name": "Farah El Masri",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/10/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Farah El Masri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_00b33c35-735f-4d99-8862-800556e2ef40",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506698 ,Dubai",
        "phone": "97147046300 / 971507900661",
        "email": "nada.mourad@lw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b2b92ce9-90a4-4e34-ae2f-ae0dc7ca9060",
    "firmName": "Latham & Watkins LLP",
    "registrationNumber": "L-04339",
    "licenseIssueDate": "03/10/2019 00:00:00",
    "licenseExpiryDate": "03/08/2026 00:00:00"
  },
  {
    "id": "4fac007b-994f-4bad-b5bf-82e06697b42d",
    "slug": "farah-ibrahim-wahab",
    "name": "FARAH IBRAHIM WAHAB",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/01/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: FARAH IBRAHIM WAHAB",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4fac007b-994f-4bad-b5bf-82e06697b42d",
        "address": "YASIR AL NAQBI ,21 ,48 BURJ ,SOFITEL DOWN  TOWN ,181111 ,Dubai",
        "phone": "97142689949",
        "email": "info@alnaqbipartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ad71430e-83ee-4cb5-a530-bc58db2618f6",
    "firmName": "ALNAQBI & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06066",
    "licenseIssueDate": "11/01/2023 00:00:00",
    "licenseExpiryDate": "10/31/2025 00:00:00"
  },
  {
    "id": "5fe7e09d-32d6-4ec6-aa29-b4da07394311",
    "slug": "farakh-ahmad",
    "name": "Farakh Ahmad",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/26/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Farakh Ahmad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5fe7e09d-32d6-4ec6-aa29-b4da07394311",
        "address": "",
        "phone": "97144484284 / 971559776272",
        "email": "nita@willsuae.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "272328d6-db51-4b0e-b8bc-5297a958940d",
    "firmName": "TWS Legal Consultants DMCC",
    "registrationNumber": "L-02960",
    "licenseIssueDate": "04/26/2015 00:00:00",
    "licenseExpiryDate": "04/20/2026 00:00:00"
  },
  {
    "id": "8d87c847-eea1-479b-be7b-cb67a95b990a",
    "slug": "faraz-salat-eliyas-ibrahim",
    "name": "Faraz Salat Eliyas Ibrahim",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/10/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Faraz Salat Eliyas Ibrahim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8d87c847-eea1-479b-be7b-cb67a95b990a",
        "address": "29 ,ذا اتش هوتيل ,فندق فيرمونت ,40073 ,Dubai",
        "phone": "97143254000",
        "email": "info@alrowaad.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "759f5477-fdbd-406b-8831-354639c31036",
    "firmName": "AWATIF MOHAMMAD SHOQI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-04330",
    "licenseIssueDate": "03/10/2019 00:00:00",
    "licenseExpiryDate": "03/08/2026 00:00:00"
  },
  {
    "id": "623ce43e-39b9-42f4-8daf-7ecd045a1d33",
    "slug": "fares-ahmed-abdelsalam-salem-raian",
    "name": "Fares Ahmed Abdelsalam Salem Raian",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/18/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Fares Ahmed Abdelsalam Salem Raian",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_623ce43e-39b9-42f4-8daf-7ecd045a1d33",
        "address": "11 ,بناية صبحة ايفوري 2 ,ماما شيلتر أوتيل ,9598 ,Dubai",
        "phone": "97143880171 / 971565359809",
        "email": "malawyer@malawyer.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "da6588ae-fc3b-4a88-8a5e-7836becb47d2",
    "firmName": "MAJID ALSKAIKH ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06872",
    "licenseIssueDate": "06/18/2025 00:00:00",
    "licenseExpiryDate": "06/17/2026 00:00:00"
  },
  {
    "id": "5cf53805-a13e-46ed-9157-d96aff0b8e69",
    "slug": "fares-khaled-tareq-abdullah",
    "name": "Fares Khaled Tareq Abdullah",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/13/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Fares Khaled Tareq Abdullah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5cf53805-a13e-46ed-9157-d96aff0b8e69",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-06253",
    "licenseIssueDate": "03/13/2024 00:00:00",
    "licenseExpiryDate": "03/12/2026 00:00:00"
  },
  {
    "id": "67f610d4-9b96-4737-9690-e78da4d63763",
    "slug": "fares-youssef-ghanem",
    "name": "Fares Youssef Ghanem",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/12/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Fares Youssef Ghanem",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_67f610d4-9b96-4737-9690-e78da4d63763",
        "address": "",
        "phone": "97145579711",
        "email": "info@mqadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9f91cca7-a15d-499f-b265-2a032fe38fa1",
    "firmName": "FATMA ALMUTAWA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04997",
    "licenseIssueDate": "07/12/2021 00:00:00",
    "licenseExpiryDate": "07/11/2026 00:00:00"
  },
  {
    "id": "a9f35d84-d65b-4bd6-8469-981776e69ce0",
    "slug": "farhan-ali",
    "name": "Farhan Ali",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/12/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Farhan Ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a9f35d84-d65b-4bd6-8469-981776e69ce0",
        "address": "Al Fattan Currency House Tower 2 ,DIFC ,507176 ,",
        "phone": "/ 971552009003",
        "email": "Mohammad.AlRasheed@bakermckenzie.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "acd81e81-dead-4f7c-839e-0f2a57897265",
    "firmName": "Baker & Mckenzie LLP",
    "registrationNumber": "L-06349",
    "licenseIssueDate": "07/12/2024 00:00:00",
    "licenseExpiryDate": "07/11/2026 00:00:00"
  },
  {
    "id": "872603d9-427e-47e1-8bfe-d3519c2075d8",
    "slug": "farhan-hasan",
    "name": "Farhan Hasan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/21/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Farhan Hasan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_872603d9-427e-47e1-8bfe-d3519c2075d8",
        "address": "",
        "phone": "97104309100 / 971564013758",
        "email": "c.royle@taylorwessing.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d51b6f43-8c62-486f-a1ab-6ee3b87c8006",
    "firmName": "Taylor Wessing LLP (Dubai Branch)",
    "registrationNumber": "L-06209",
    "licenseIssueDate": "02/21/2024 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "7cb86d70-f7a4-4c3a-8a44-6603f8f1d6ec",
    "slug": "farid-haroun",
    "name": "Farid Haroun",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/27/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Farid Haroun",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7cb86d70-f7a4-4c3a-8a44-6603f8f1d6ec",
        "address": "Index Tower ,Dubai International Financial Centre ,507115 ,",
        "phone": "97143757160 / 971523490280",
        "email": "tthraya@mayerbrown.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c7f52b69-c049-4246-963a-9805b241f88a",
    "firmName": "Mayer Brown LLP",
    "registrationNumber": "L-01765",
    "licenseIssueDate": "11/27/2016 00:00:00",
    "licenseExpiryDate": "11/23/2025 00:00:00"
  },
  {
    "id": "23bc70af-9647-4327-9a18-63f0a698e2bb",
    "slug": "farida-sadiq",
    "name": "Farida Sadiq",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/01/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Farida Sadiq",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_23bc70af-9647-4327-9a18-63f0a698e2bb",
        "address": "",
        "phone": "97145119777 / 971508184427",
        "email": "richard.davies@bclplaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6c617112-4b98-414c-868a-7d0316427c21",
    "firmName": "Bryan Cave Leighton Paisner LLP",
    "registrationNumber": "L-01076",
    "licenseIssueDate": "10/01/2012 00:00:00",
    "licenseExpiryDate": "09/23/2026 00:00:00"
  },
  {
    "id": "a7e97af2-f89c-40c1-b383-71bb9482d884",
    "slug": "faris-shehabi",
    "name": "Faris Shehabi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/21/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Faris Shehabi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a7e97af2-f89c-40c1-b383-71bb9482d884",
        "address": "",
        "phone": "97144020800 / 971566830829",
        "email": "dean.ryburn@dentons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dfe13b7e-6625-45fd-ad63-9ee83af41194",
    "firmName": "Dentons & Co Dubai Branch-DED",
    "registrationNumber": "L-04239",
    "licenseIssueDate": "10/21/2018 00:00:00",
    "licenseExpiryDate": "10/19/2026 00:00:00"
  },
  {
    "id": "4b24e438-a038-4892-911d-f670b2bb6ced",
    "slug": "farouk-salah-khalifa-hassan-khalifa",
    "name": "Farouk Salah Khalifa Hassan Khalifa",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/02/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Farouk Salah Khalifa Hassan Khalifa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4b24e438-a038-4892-911d-f670b2bb6ced",
        "address": "6 ,latifa tower ,near crown plaza hotel  ,102999 ,Dubai",
        "phone": "97143799979",
        "email": "lawkmq@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b9d24779-27c2-4989-bf7f-4e73e5a670ff",
    "firmName": "KHALID BIN MOHAMMAD ALQASEMI ATTORNEY & LEGAL CONSULTANTS",
    "registrationNumber": "L-06793",
    "licenseIssueDate": "05/02/2025 00:00:00",
    "licenseExpiryDate": "05/01/2026 00:00:00"
  },
  {
    "id": "fc666993-d8f1-4588-97b3-c70ae24aa376",
    "slug": "farsheed-abdul-rahman",
    "name": "Farsheed Abdul Rahman",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/10/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Farsheed Abdul Rahman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fc666993-d8f1-4588-97b3-c70ae24aa376",
        "address": "",
        "phone": "97147098484 / 971505577206",
        "email": "slshadmand@jonesday.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8892bfe9-d3ec-4158-b4fd-1844606f4f30",
    "firmName": "Jones Day",
    "registrationNumber": "L-03180",
    "licenseIssueDate": "11/10/2015 00:00:00",
    "licenseExpiryDate": "11/05/2025 00:00:00"
  },
  {
    "id": "159fea61-fe14-46f6-86a8-d0ff30c55eea",
    "slug": "fathi-yehia-abdelazim-yehia",
    "name": "Fathi Yehia Abdelazim Yehia",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/03/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Fathi Yehia Abdelazim Yehia",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_159fea61-fe14-46f6-86a8-d0ff30c55eea",
        "address": "",
        "phone": "97142828999",
        "email": "info@gmalc.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2f9514bf-2175-40fe-8539-d1b4b32074b7",
    "firmName": "ALGURG & ALMATROOSHI ADVOCATES & LIGAL CONSULTANTS",
    "registrationNumber": "L-06400",
    "licenseIssueDate": "07/03/2024 00:00:00",
    "licenseExpiryDate": "07/02/2026 00:00:00"
  },
  {
    "id": "286bcb08-68f5-4ce8-8654-8d0359b0463e",
    "slug": "fatma-said-khamis-al-zadjali",
    "name": "Fatma Said Khamis Al Zadjali",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/08/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Fatma Said Khamis Al Zadjali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_286bcb08-68f5-4ce8-8654-8d0359b0463e",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05943",
    "licenseIssueDate": "08/08/2023 00:00:00",
    "licenseExpiryDate": "08/07/2026 00:00:00"
  },
  {
    "id": "660989dd-8878-4a31-aba0-cadb8225e100",
    "slug": "fatme-hodroje",
    "name": "Fatme Hodroje",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/21/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Fatme Hodroje",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_660989dd-8878-4a31-aba0-cadb8225e100",
        "address": "21 ,Rolex Tower ,Emirates Grand Hotel ,94334 ,Dubai",
        "phone": "97143277772 / 97145584900",
        "email": "info@globaladvocates.net",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9b42810f-1d55-4aea-ac4a-7d9d1b25ac08",
    "firmName": "GLOBAL ADVOCACY & LEGAL COUNSEL",
    "registrationNumber": "L-05517",
    "licenseIssueDate": "09/21/2022 00:00:00",
    "licenseExpiryDate": "09/20/2026 00:00:00"
  },
  {
    "id": "fed7aade-4f9f-4655-a3e4-6b33cefde536",
    "slug": "fawaz-elmalki",
    "name": "Fawaz Elmalki",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/22/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Fawaz Elmalki",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fed7aade-4f9f-4655-a3e4-6b33cefde536",
        "address": "",
        "phone": "97104309100 / 971564013758",
        "email": "c.royle@taylorwessing.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d51b6f43-8c62-486f-a1ab-6ee3b87c8006",
    "firmName": "Taylor Wessing LLP (Dubai Branch)",
    "registrationNumber": "L-06312",
    "licenseIssueDate": "05/22/2024 00:00:00",
    "licenseExpiryDate": "05/21/2026 00:00:00"
  },
  {
    "id": "295218b2-722b-4079-a8f7-a2e5ee649c9b",
    "slug": "fawzi-oueidat",
    "name": "Fawzi Oueidat",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/01/2021",
    "licenseStatus": "active",
    "licenseExpiry": "2022-01-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Fawzi Oueidat",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_295218b2-722b-4079-a8f7-a2e5ee649c9b",
        "address": "",
        "phone": "97143742800 / 971506450677",
        "email": "jabbott21@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7a59d310-ff72-4318-b41c-27095c163d0f",
    "firmName": "CMS (UAE) LLP",
    "registrationNumber": "L-04825",
    "licenseIssueDate": "01/07/2021 00:00:00",
    "licenseExpiryDate": "01/06/2026 00:00:00"
  },
  {
    "id": "4517e78d-508c-4e5c-86c5-64fcdb932a9a",
    "slug": "faye-victoria-rose-priestley",
    "name": "Faye Victoria Rose Priestley",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGVgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/13/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Faye Victoria Rose Priestley",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4517e78d-508c-4e5c-86c5-64fcdb932a9a",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-05139",
    "licenseIssueDate": "12/13/2021 00:00:00",
    "licenseExpiryDate": "12/12/2025 00:00:00"
  },
  {
    "id": "131707c3-a994-4945-8241-d3e0f0a8b661",
    "slug": "felicia-olamide-abosede-abeni-parvin",
    "name": "Felicia Olamide Abosede Abeni Parvin",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/04/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Felicia Olamide Abosede Abeni Parvin",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_131707c3-a994-4945-8241-d3e0f0a8b661",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-06480",
    "licenseIssueDate": "09/04/2024 00:00:00",
    "licenseExpiryDate": "09/03/2026 00:00:00"
  },
  {
    "id": "7aba95d7-41de-42bc-bea0-186b056fdffa",
    "slug": "felicity-jane-hammond",
    "name": "Felicity Jane Hammond",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/23/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Felicity Jane Hammond",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7aba95d7-41de-42bc-bea0-186b056fdffa",
        "address": "",
        "phone": "97143685555",
        "email": "maisa.maarouf@bsabh.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8afa232f-52ff-4dad-82c3-9a04d66eb853",
    "firmName": "B S A AHMED BIN HAZEEM & ASSOCIATES LLP - DIFC",
    "registrationNumber": "L-04718",
    "licenseIssueDate": "07/23/2020 00:00:00",
    "licenseExpiryDate": "07/22/2026 00:00:00"
  },
  {
    "id": "485b5354-5baf-4591-b43d-b825bb70577b",
    "slug": "felix-olaf-muller",
    "name": "Felix Olaf Muller",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/31/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Felix Olaf Muller",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_485b5354-5baf-4591-b43d-b825bb70577b",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-06330",
    "licenseIssueDate": "05/31/2024 00:00:00",
    "licenseExpiryDate": "05/30/2026 00:00:00"
  },
  {
    "id": "ff49dfb5-a130-4c3e-87fd-b58864e90474",
    "slug": "fernando-ortega",
    "name": "Fernando Ortega",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/20/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Fernando Ortega",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ff49dfb5-a130-4c3e-87fd-b58864e90474",
        "address": "5 ,LIBERTY HOUSE ,RITZ HOTEL DIFC ,506949 ,Dubai",
        "phone": "97143860090 / 971507887401",
        "email": "maalouf@iaalo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8d9bc487-6793-4ea8-a629-49ba36823552",
    "firmName": "IAA MIDDLE EAST LEGAL CONSULTANTS LTD",
    "registrationNumber": "L-04409",
    "licenseIssueDate": "05/20/2019 00:00:00",
    "licenseExpiryDate": "05/19/2026 00:00:00"
  },
  {
    "id": "989f5a3e-b67d-4940-b064-00f083026d62",
    "slug": "fesal-abbas",
    "name": "Fesal Abbas",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/14/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Fesal Abbas",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_989f5a3e-b67d-4940-b064-00f083026d62",
        "address": "210 ,OPAL TOWER ,BURJ KHALIFA ,96044 ,Dubai",
        "phone": "97143889993",
        "email": "admin@alsaadi-advocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8e611697-c589-4346-a3da-969764421cb6",
    "firmName": "MOHAMMAD ALSAADI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03564",
    "licenseIssueDate": "08/14/2025 00:00:00",
    "licenseExpiryDate": "08/13/2026 00:00:00"
  },
  {
    "id": "4b3cff9c-b4c2-4f8a-910a-4e2030333939",
    "slug": "fetih-al-montasser",
    "name": "Fetih Al-Montasser",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Fetih Al-Montasser",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4b3cff9c-b4c2-4f8a-910a-4e2030333939",
        "address": "",
        "phone": "97143467333 / 971505357973",
        "email": "info@emilawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "58c5bed4-4c54-495f-91b1-65941ca72065",
    "firmName": "Al Montasser Business Law Consultancy Centre",
    "registrationNumber": "L-00473",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "f356ea7f-ab2b-418d-ae1e-bcacbffbd805",
    "slug": "fidele-juliano-kamel",
    "name": "FIDELE JULIANO KAMEL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/29/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: FIDELE JULIANO KAMEL",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f356ea7f-ab2b-418d-ae1e-bcacbffbd805",
        "address": "YASIR AL NAQBI ,21 ,48 BURJ ,SOFITEL DOWN  TOWN ,181111 ,Dubai",
        "phone": "97142689949",
        "email": "info@alnaqbipartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ad71430e-83ee-4cb5-a530-bc58db2618f6",
    "firmName": "ALNAQBI & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06357",
    "licenseIssueDate": "05/29/2024 00:00:00",
    "licenseExpiryDate": "05/28/2026 00:00:00"
  },
  {
    "id": "6738dfdd-d0e6-4524-b47c-3fafa81ae5ac",
    "slug": "finlay-david-thomas-donaldson",
    "name": "Finlay David Thomas Donaldson",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/22/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-01-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Finlay David Thomas Donaldson",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6738dfdd-d0e6-4524-b47c-3fafa81ae5ac",
        "address": "Index Tower ,506548 ,Dubai",
        "phone": "97147096300 / 971506767433",
        "email": "amateen@reedsmith.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b3f87e90-7ce9-4097-82c4-15232365f175",
    "firmName": "Reed Smith LLP",
    "registrationNumber": "L-04618",
    "licenseIssueDate": "01/22/2020 00:00:00",
    "licenseExpiryDate": "01/21/2026 00:00:00"
  },
  {
    "id": "b15234d4-74ae-4dc9-b549-192d0b814909",
    "slug": "fiona-holly-moignard",
    "name": "Fiona Holly Moignard",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/09/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Fiona Holly Moignard",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b15234d4-74ae-4dc9-b549-192d0b814909",
        "address": "Level 17, ICD Brookfield Place ,DIFC ,506503 ,",
        "phone": "97144375100 / 971588271196",
        "email": "libby.edwards-smith@gowlingwlg.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "436703ba-b9c0-4dcb-93b2-1299c7a051f4",
    "firmName": "Gowling WLG (UK) LLP (Dubai Branch)",
    "registrationNumber": "L-06529",
    "licenseIssueDate": "10/09/2024 00:00:00",
    "licenseExpiryDate": "10/08/2026 00:00:00"
  },
  {
    "id": "5265d04f-f52f-4c1d-92e6-424c0d359646",
    "slug": "fiona-mc-cormack",
    "name": "Fiona Mc Cormack",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/01/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Fiona Mc Cormack",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5265d04f-f52f-4c1d-92e6-424c0d359646",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506688 ,Dubai",
        "phone": "97147096600 / 971503556811",
        "email": "muneer.khan@simmons-simmons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d1725ca7-06ac-41b2-8d7b-a6e60665b73d",
    "firmName": "Simmons & Simmons (Middle East) LLP-DIFC",
    "registrationNumber": "L-06974",
    "licenseIssueDate": "09/25/2025 00:00:00",
    "licenseExpiryDate": "09/24/2026 00:00:00"
  },
  {
    "id": "52c32a70-3aea-4421-8dd8-5106a904bd80",
    "slug": "firas-alchoufi",
    "name": "Firas Alchoufi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/05/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Firas Alchoufi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_52c32a70-3aea-4421-8dd8-5106a904bd80",
        "address": "Firas Hassan Al Choufi ,701 ,The Prime Tower ,Makani No: 25836 86879 ,125305 ,Dubai",
        "phone": "97144357246",
        "email": "info@binsevanadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4d3c9dcc-51c6-4883-b9ed-c65a7d1c5a57",
    "firmName": "BIN SEVAN ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-03794",
    "licenseIssueDate": "07/05/2017 00:00:00",
    "licenseExpiryDate": "07/02/2026 00:00:00"
  },
  {
    "id": "c8a30d24-da5d-4c5e-8ba5-801e7ee8a59d",
    "slug": "firas-habib",
    "name": "Firas Habib",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/24/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Firas Habib",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c8a30d24-da5d-4c5e-8ba5-801e7ee8a59d",
        "address": "",
        "phone": "97145683100 / 971559223103",
        "email": "rossi@bonnard-lawson.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2b373724-e557-4c31-a968-7d37d9393842",
    "firmName": "Bonnard Lawson Legal Consultants L.L.C",
    "registrationNumber": "L-06425",
    "licenseIssueDate": "07/24/2024 00:00:00",
    "licenseExpiryDate": "07/23/2026 00:00:00"
  },
  {
    "id": "1d700cf1-e838-4568-99d6-68d79f8a1a97",
    "slug": "firas-mohamed-adi",
    "name": "Firas Mohamed Adi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/27/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Firas Mohamed Adi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1d700cf1-e838-4568-99d6-68d79f8a1a97",
        "address": "",
        "phone": "97145683100 / 971559223103",
        "email": "rossi@bonnard-lawson.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2b373724-e557-4c31-a968-7d37d9393842",
    "firmName": "Bonnard Lawson Legal Consultants L.L.C",
    "registrationNumber": "L-02366",
    "licenseIssueDate": "05/27/2013 00:00:00",
    "licenseExpiryDate": "05/20/2026 00:00:00"
  },
  {
    "id": "3e0c38f8-438f-4636-b797-bb0d4a9a6def",
    "slug": "firas-zegallai",
    "name": "Firas Zegallai",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGWgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/05/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Firas Zegallai",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3e0c38f8-438f-4636-b797-bb0d4a9a6def",
        "address": "South Tower, Emirates Financial Towers ,DIFC ,482025 ,",
        "phone": "97145875333 / 971503444388",
        "email": "c.dersahakian@cvml.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e2c6db70-04e7-4c7b-882a-6d2ffe4469ed",
    "firmName": "CVML Limited",
    "registrationNumber": "L-05557",
    "licenseIssueDate": "10/05/2022 00:00:00",
    "licenseExpiryDate": "10/04/2026 00:00:00"
  },
  {
    "id": "e067c849-bcd0-411f-b09c-73b5760b8699",
    "slug": "firat-gulum",
    "name": "Firat Gulum",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/09/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Firat Gulum",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e067c849-bcd0-411f-b09c-73b5760b8699",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-05856",
    "licenseIssueDate": "06/09/2023 00:00:00",
    "licenseExpiryDate": "06/08/2026 00:00:00"
  },
  {
    "id": "3dcf6f4b-bd60-4ea9-9b91-0297ac5cd1e4",
    "slug": "flora-salma-annie-haidar",
    "name": "Flora Salma Annie Haidar",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/15/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Flora Salma Annie Haidar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3dcf6f4b-bd60-4ea9-9b91-0297ac5cd1e4",
        "address": "",
        "phone": "97145119777 / 971508184427",
        "email": "richard.davies@bclplaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6c617112-4b98-414c-868a-7d0316427c21",
    "firmName": "Bryan Cave Leighton Paisner LLP",
    "registrationNumber": "L-05183",
    "licenseIssueDate": "02/15/2022 00:00:00",
    "licenseExpiryDate": "02/14/2026 00:00:00"
  },
  {
    "id": "97e8e792-6d6b-4971-afbe-2b8baf6d927d",
    "slug": "florence-jerome-ball",
    "name": "Florence Jerome Ball",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/05/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Florence Jerome Ball",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_97e8e792-6d6b-4971-afbe-2b8baf6d927d",
        "address": "",
        "phone": "97145953601 / 971508728645",
        "email": "Steven.Bainbridge@gtlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b4146aa6-efd1-41d7-819d-49da46353b0b",
    "firmName": "Greenberg Traurig Limited",
    "registrationNumber": "L-06369",
    "licenseIssueDate": "06/05/2024 00:00:00",
    "licenseExpiryDate": "06/04/2026 00:00:00"
  },
  {
    "id": "e1d90989-c052-421e-868a-f5864939db4a",
    "slug": "florian-amereller",
    "name": "Florian Amereller",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/08/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Florian Amereller",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e1d90989-c052-421e-868a-f5864939db4a",
        "address": "",
        "phone": "97144323671 / 971505589395",
        "email": "fba@amereller.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "a139ca64-8897-4d1d-8d71-97446bc1e15a",
    "firmName": "Amereller Legal Consultancy LLC SOC",
    "registrationNumber": "L-00486",
    "licenseIssueDate": "10/08/2011 00:00:00",
    "licenseExpiryDate": "09/29/2026 00:00:00"
  },
  {
    "id": "1338c91f-da4a-4c2e-aaf1-6b84bafc7c84",
    "slug": "forhad-ahmed",
    "name": "Forhad Ahmed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/09/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Forhad Ahmed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1338c91f-da4a-4c2e-aaf1-6b84bafc7c84",
        "address": "",
        "phone": "97143025100 / 971501501837",
        "email": "ccairns@trowers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "976857f5-9092-43cf-987d-bfa794a3fa51",
    "firmName": "Trowers & Hamlins LLP",
    "registrationNumber": "L-05961",
    "licenseIssueDate": "08/09/2023 00:00:00",
    "licenseExpiryDate": "08/08/2026 00:00:00"
  },
  {
    "id": "fc0998e6-5a82-4bdc-8416-99f662159393",
    "slug": "fouad-barbar",
    "name": "Fouad Barbar",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/29/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Fouad Barbar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fc0998e6-5a82-4bdc-8416-99f662159393",
        "address": "Heba Ahli ,6th Floor  ,Prime Business Building  ,Khansour Community Park ,414142 ,Dubai",
        "phone": "97143358885 / 971505509997",
        "email": "info@mitchelpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6089dcf8-5807-40f2-a1ef-e628a0f31e26",
    "firmName": "HEBA AHLI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-04111",
    "licenseIssueDate": "05/29/2018 00:00:00",
    "licenseExpiryDate": "05/27/2026 00:00:00"
  },
  {
    "id": "0233da64-0a8b-4607-9fe1-2b991dc1160e",
    "slug": "francesca-eliza-north",
    "name": "Francesca Eliza North",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/02/2025",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Francesca Eliza North",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0233da64-0a8b-4607-9fe1-2b991dc1160e",
        "address": "ICD Brookfield Place ,Za'abeel 2 ,103747 ,",
        "phone": "97143696300 / 971506008159",
        "email": "mohammed.paracha@nortonrosefulbright.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c4aaee93-0ec4-4982-9a48-a23699492056",
    "firmName": "Norton Rose Fullbright (Middle East) LLP",
    "registrationNumber": "L-06195",
    "licenseIssueDate": "02/06/2025 00:00:00",
    "licenseExpiryDate": "02/05/2026 00:00:00"
  },
  {
    "id": "5e1801c2-5b2b-4fd1-bb53-ccb13c9676de",
    "slug": "francesco-bulleri",
    "name": "Francesco Bulleri",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/15/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Francesco Bulleri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5e1801c2-5b2b-4fd1-bb53-ccb13c9676de",
        "address": "الطابق 14  ,برج 48 جيت  ,محطة مترو دبي  ,413633 ,Dubai",
        "phone": "97144412031",
        "email": "courts@adglegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4287f048-dc0c-4d51-9e0c-0c23356040ee",
    "firmName": "MOHAMMED AL DAHBASHI ADVOCATES",
    "registrationNumber": "L-05111",
    "licenseIssueDate": "11/15/2021 00:00:00",
    "licenseExpiryDate": "11/14/2025 00:00:00"
  },
  {
    "id": "92036f3b-974a-413d-8aad-0c90facf371c",
    "slug": "francesco-fiorilli",
    "name": "Francesco Fiorilli",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/16/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Francesco Fiorilli",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_92036f3b-974a-413d-8aad-0c90facf371c",
        "address": "",
        "phone": "97144230555 / 971504788443",
        "email": "yah@hfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c462c65e-185a-4e81-8425-a87e3a2b6842",
    "firmName": "Holman Fenwick Willan Middle East LLP",
    "registrationNumber": "L-03319",
    "licenseIssueDate": "02/16/2016 00:00:00",
    "licenseExpiryDate": "02/11/2026 00:00:00"
  },
  {
    "id": "eefdd921-41b3-45fc-ac1d-d4e852a57825",
    "slug": "frederic-akiki",
    "name": "Frederic Akiki",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/09/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-08-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Frederic Akiki",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_eefdd921-41b3-45fc-ac1d-d4e852a57825",
        "address": "ICD Brookfield Place ,DIFC ,120109 ,",
        "phone": "97143173000 / 971504465229",
        "email": "DubaiLAD@akingump.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9ff29eab-adb8-40f9-ab84-216e01a381e4",
    "firmName": "Akin Gump Strauss Hauer & Feld LLP",
    "registrationNumber": "L-05682",
    "licenseIssueDate": "02/09/2023 00:00:00",
    "licenseExpiryDate": "02/08/2026 00:00:00"
  },
  {
    "id": "02d330d5-c503-4334-89fc-32821050b841",
    "slug": "fuad-attyeh",
    "name": "Fuad Attyeh",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/23/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Fuad Attyeh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_02d330d5-c503-4334-89fc-32821050b841",
        "address": "Samia Luqman ,2nd floor ,Emarat Atrium Building ,across Holiday Inn Express Safa Park ,7273 ,Dubai",
        "phone": "97143211000",
        "email": "info@alsuwaidi.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0e5c3637-bc12-475c-a6b5-2d9ae84f2b8e",
    "firmName": "AL-SUWAIDI & COMPANY",
    "registrationNumber": "L-03498",
    "licenseIssueDate": "03/23/2022 00:00:00",
    "licenseExpiryDate": "03/22/2026 00:00:00"
  },
  {
    "id": "1c7a6a11-4352-40ac-847b-e73243ea2c37",
    "slug": "furat-fakhreddin",
    "name": "Furat Fakhreddin",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/28/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Furat Fakhreddin",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1c7a6a11-4352-40ac-847b-e73243ea2c37",
        "address": "21 ,Rolex Tower ,Emirates Grand Hotel ,94334 ,Dubai",
        "phone": "97143277772 / 97145584900",
        "email": "info@globaladvocates.net",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9b42810f-1d55-4aea-ac4a-7d9d1b25ac08",
    "firmName": "GLOBAL ADVOCACY & LEGAL COUNSEL",
    "registrationNumber": "L-06796",
    "licenseIssueDate": "05/28/2025 00:00:00",
    "licenseExpiryDate": "05/27/2026 00:00:00"
  },
  {
    "id": "92d59e6b-1816-4009-baf6-5fc800106602",
    "slug": "gaber-gaber-mohamed-elhoushy",
    "name": "gaber gaber mohamed elhoushy",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/31/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: gaber gaber mohamed elhoushy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_92d59e6b-1816-4009-baf6-5fc800106602",
        "address": "11 ,ميلينيوم بلازا  ,بجوار محطة ابراج الأمارات  ,410961 ,Dubai",
        "phone": "97142954626",
        "email": "info@advoamira.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "09f7b67c-8405-4dc9-982f-b8f9b921043c",
    "firmName": "DR AMIRA AL BASTAKI ADVOCATES AND LEGAL CONSULTANT",
    "registrationNumber": "L-04946",
    "licenseIssueDate": "05/31/2021 00:00:00",
    "licenseExpiryDate": "05/30/2026 00:00:00"
  },
  {
    "id": "e92e90ee-fd52-4c52-b8f9-15773097d523",
    "slug": "gabriel-khoury",
    "name": "Gabriel Khoury",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/07/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Gabriel Khoury",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e92e90ee-fd52-4c52-b8f9-15773097d523",
        "address": "Unit 03-OF-02-03-OF-09, Level 03 ,Gate Village Building 08 ,Dubai International Financial Centre ,000 ,Dubai",
        "phone": "97100000000 / 971501051651",
        "email": "gabriel@uae.silklegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "790219ab-49b9-40f2-97c3-bff01feebf69",
    "firmName": "Silk Legal Company Limited",
    "registrationNumber": "L-06290",
    "licenseIssueDate": "04/07/2024 00:00:00",
    "licenseExpiryDate": "04/06/2026 00:00:00"
  },
  {
    "id": "0566c0db-2219-40a5-998d-776e7d4b6281",
    "slug": "gabriella-carole-savastano",
    "name": "Gabriella Carole Savastano",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/28/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Gabriella Carole Savastano",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0566c0db-2219-40a5-998d-776e7d4b6281",
        "address": "",
        "phone": "97143742800 / 971506450677",
        "email": "jabbott21@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7a59d310-ff72-4318-b41c-27095c163d0f",
    "firmName": "CMS (UAE) LLP",
    "registrationNumber": "L-05550"
  },
  {
    "id": "c68844fc-b2b7-44ab-9d84-29ff697f03cf",
    "slug": "gabrielle-georges-okais",
    "name": "Gabrielle Georges Okais",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/19/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Gabrielle Georges Okais",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c68844fc-b2b7-44ab-9d84-29ff697f03cf",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-06381",
    "licenseIssueDate": "07/19/2024 00:00:00",
    "licenseExpiryDate": "07/18/2026 00:00:00"
  },
  {
    "id": "3c1867a9-5c05-4755-8025-a8d20ad654ad",
    "slug": "gabrielle-lowe",
    "name": "Gabrielle Lowe",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/05/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Gabrielle Lowe",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3c1867a9-5c05-4755-8025-a8d20ad654ad",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-04785",
    "licenseIssueDate": "11/05/2020 00:00:00",
    "licenseExpiryDate": "11/04/2025 00:00:00"
  },
  {
    "id": "8bbe0143-1808-41b7-a65d-d78951f26863",
    "slug": "gamal-barakat-gad-almawla-amer",
    "name": "Gamal Barakat Gad Almawla Amer",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/28/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Gamal Barakat Gad Almawla Amer",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8bbe0143-1808-41b7-a65d-d78951f26863",
        "address": "Azza Ebrahim Hasan Almulla ,6(602-603) ,Al Shoalla Building (Al Naboodah) ,deira city center ,12871 ,Dubai",
        "phone": "97142950010",
        "email": "dubai-secretary@dralmulla.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "fbf6220f-2608-4caa-895e-d45ae8a259a2",
    "firmName": "AZZA EBRAHIM HASAN ALMULLA ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-04054",
    "licenseIssueDate": "08/28/2025 00:00:00",
    "licenseExpiryDate": "08/27/2026 00:00:00"
  },
  {
    "id": "7d507be1-3a8e-4da5-9708-559ead1a93dc",
    "slug": "gamal-farag-darwish-madkour",
    "name": "gamal farag darwish madkour",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/22/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: gamal farag darwish madkour",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7d507be1-3a8e-4da5-9708-559ead1a93dc",
        "address": "Maryam Essa Mohammad Abdulaziz Alyassi ,M06  ,THE ARCADE  ,ALGARHOUD METRO STATION  ,283023 ,Dubai",
        "phone": "97143852835 / 971543314762",
        "email": "info@alyassiadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "20f968ff-e5db-45d4-b645-48a15e7e7808",
    "firmName": "MARYAM ALYASSI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05184",
    "licenseIssueDate": "02/22/2022 00:00:00",
    "licenseExpiryDate": "02/21/2026 00:00:00"
  },
  {
    "id": "ea9afc8f-3250-432f-9b36-23f4c6aea742",
    "slug": "gamal-mahmoud-emara",
    "name": "Gamal Mahmoud Emara",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/05/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Gamal Mahmoud Emara",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ea9afc8f-3250-432f-9b36-23f4c6aea742",
        "address": "saeed ,310 & 311 ,business avenue ,منطقه بور سعيد التجاريه ,19410 ,Dubai",
        "phone": "97148868812",
        "email": "info@saeedalghafri.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5acd50c8-df41-496b-a969-926d40e45c46",
    "firmName": "SAEED ALGHAFRI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01815",
    "licenseIssueDate": "10/05/2011 00:00:00",
    "licenseExpiryDate": "09/25/2026 00:00:00"
  },
  {
    "id": "9777d908-2e70-4b4b-a7a7-7b4fa6186350",
    "slug": "gamal-shamseldin-abdelmaksoud-elsaify",
    "name": "GAMAL SHAMSELDIN ABDELMAKSOUD ELSAIFY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/09/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2021-09-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Gamal Shamseldin Abdelmaksoud Elsaify",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9777d908-2e70-4b4b-a7a7-7b4fa6186350",
        "address": "Azza Ebrahim Hasan Almulla ,6(602-603) ,Al Shoalla Building (Al Naboodah) ,deira city center ,12871 ,Dubai",
        "phone": "97142950010",
        "email": "dubai-secretary@dralmulla.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "fbf6220f-2608-4caa-895e-d45ae8a259a2",
    "firmName": "AZZA EBRAHIM HASAN ALMULLA ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-04758",
    "licenseIssueDate": "10/01/2020 00:00:00",
    "licenseExpiryDate": "09/30/2021 00:00:00"
  },
  {
    "id": "a600766b-ca71-42a1-a8fc-1f251953e63c",
    "slug": "ganepallekoralage-bandara",
    "name": "Ganepallekoralage Bandara",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/24/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ganepallekoralage Bandara",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a600766b-ca71-42a1-a8fc-1f251953e63c",
        "address": "",
        "phone": "97143303900 / 971561753537",
        "email": "christopher@afridi-angell.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "30ce50dc-01a6-499d-8ace-3f807ddcb08d",
    "firmName": "Afridi & Angell-DED",
    "registrationNumber": "L-03463",
    "licenseIssueDate": "08/24/2016 00:00:00",
    "licenseExpiryDate": "08/20/2026 00:00:00"
  },
  {
    "id": "dd14df75-14f8-4976-bf60-0fe9a5b44249",
    "slug": "ganna-vlasenko",
    "name": "Ganna Vlasenko",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHVgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/05/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ganna Vlasenko",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dd14df75-14f8-4976-bf60-0fe9a5b44249",
        "address": "ICD Brookfield Place ,Za'abeel 2 ,103747 ,",
        "phone": "97143696300 / 971506008159",
        "email": "mohammed.paracha@nortonrosefulbright.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c4aaee93-0ec4-4982-9a48-a23699492056",
    "firmName": "Norton Rose Fullbright (Middle East) LLP",
    "registrationNumber": "L-03934",
    "licenseIssueDate": "10/05/2017 00:00:00",
    "licenseExpiryDate": "10/02/2026 00:00:00"
  },
  {
    "id": "ec98b3b0-b7ce-41db-b3f2-f612d6401594",
    "slug": "gareth-edgar-dray",
    "name": "Gareth Edgar Dray",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/23/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Gareth Edgar Dray",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ec98b3b0-b7ce-41db-b3f2-f612d6401594",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-04035",
    "licenseIssueDate": "01/23/2018 00:00:00",
    "licenseExpiryDate": "01/20/2026 00:00:00"
  },
  {
    "id": "a2983edb-520c-40a6-9a92-84b2caca6c3d",
    "slug": "gareth-lond",
    "name": "Gareth Lond",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/06/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Gareth Lond",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a2983edb-520c-40a6-9a92-84b2caca6c3d",
        "address": "",
        "phone": "97143637999 / 971506525633",
        "email": "daniel.wood@walkersglobal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a3a9927b-d51c-490c-8be6-d575ea3eb041",
    "firmName": "Walkers (Middle East) LLP",
    "registrationNumber": "L-03689",
    "licenseIssueDate": "04/06/2023 00:00:00",
    "licenseExpiryDate": "04/05/2026 00:00:00"
  },
  {
    "id": "56c9950c-8066-48b4-b3b4-664ef7b92205",
    "slug": "gareth-morgan-grant-hodder",
    "name": "Gareth Morgan Grant Hodder",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/01/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Gareth Morgan Grant Hodder",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_56c9950c-8066-48b4-b3b4-664ef7b92205",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-05727",
    "licenseIssueDate": "03/01/2023 00:00:00",
    "licenseExpiryDate": "02/28/2026 00:00:00"
  },
  {
    "id": "14b4c625-8c50-47f7-9639-110f42129079",
    "slug": "gassan-adnan-baloul",
    "name": "Gassan Adnan Baloul",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/23/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Gassan Adnan Baloul",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_14b4c625-8c50-47f7-9639-110f42129079",
        "address": "",
        "phone": "97144478700 / 971528553200",
        "email": "Thomas.Wilson@squirepb.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "85be541a-c87f-45a9-a321-d90abd6b7298",
    "firmName": "Squire Patton Boggs (MEA) LLP",
    "registrationNumber": "L-06745",
    "licenseIssueDate": "04/23/2025 00:00:00",
    "licenseExpiryDate": "04/22/2026 00:00:00"
  },
  {
    "id": "ef665026-1e24-46a7-a360-67257d6fb7b5",
    "slug": "gehad-abdulla-awdah-elbyaa",
    "name": "Gehad Abdulla Awdah Elbyaa",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/17/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Gehad Abdulla Awdah Elbyaa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ef665026-1e24-46a7-a360-67257d6fb7b5",
        "address": "",
        "phone": "97143212555",
        "email": "awigdubai@awiglaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ece8ea60-9ecb-4d8c-aca3-fb73e4e52406",
    "firmName": "AL WASL INTERNATIONAL GROUP - ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01949",
    "licenseIssueDate": "11/17/2011 00:00:00",
    "licenseExpiryDate": "11/08/2025 00:00:00"
  },
  {
    "id": "10fd0b92-2468-4170-9285-6b03ad444ac4",
    "slug": "gemma-kotak",
    "name": "Gemma Kotak",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/06/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Gemma Kotak",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_10fd0b92-2468-4170-9285-6b03ad444ac4",
        "address": "Burj Daman ,Dubai International Financial Center ,213241 ,",
        "phone": "97144549586 / 971564189768",
        "email": "darrenaharris123@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3cb06a05-1ad1-4487-9624-c2b716bfd2a7",
    "firmName": "Gateley UK LLP",
    "registrationNumber": "L-03998",
    "licenseIssueDate": "11/06/2021 00:00:00",
    "licenseExpiryDate": "11/05/2025 00:00:00"
  },
  {
    "id": "862ac336-d43c-4842-95ee-235be7d1a2a2",
    "slug": "gemma-yvonne-gregory",
    "name": "Gemma Yvonne Gregory",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/07/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Gemma Yvonne Gregory",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_862ac336-d43c-4842-95ee-235be7d1a2a2",
        "address": "6 ,Office Nos. 603, 604 & 605, Level 6, Burj Daman ,Dubai International Financial Centre ,506555 ,Dubai",
        "phone": "97143506400 / 971504654755",
        "email": "r.hickman@aglaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8690f7d5-6b96-4649-9589-71303f2c2707",
    "firmName": "Addleshaw Goddard (Middle East) LLP",
    "registrationNumber": "L-05258",
    "licenseIssueDate": "04/07/2022 00:00:00",
    "licenseExpiryDate": "04/06/2026 00:00:00"
  },
  {
    "id": "fd541aa5-4bb6-4efa-a310-f72946462553",
    "slug": "geoffrey-neilson-smith",
    "name": "Geoffrey Neilson Smith",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/12/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Geoffrey Neilson Smith",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fd541aa5-4bb6-4efa-a310-f72946462553",
        "address": "",
        "phone": "97143742800 / 971506450677",
        "email": "jabbott21@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7a59d310-ff72-4318-b41c-27095c163d0f",
    "firmName": "CMS (UAE) LLP",
    "registrationNumber": "L-01121",
    "licenseIssueDate": "11/12/2012 00:00:00",
    "licenseExpiryDate": "11/04/2025 00:00:00"
  },
  {
    "id": "32ceada4-0cab-4117-955f-c210ad8671bc",
    "slug": "george-david-inns",
    "name": "George David Inns",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/18/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: George David Inns",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_32ceada4-0cab-4117-955f-c210ad8671bc",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-06260",
    "licenseIssueDate": "03/18/2024 00:00:00",
    "licenseExpiryDate": "03/17/2026 00:00:00"
  },
  {
    "id": "9be25f5b-e8f1-4bef-b984-7b2b3d7257fd",
    "slug": "george-rasmi-ghabrial",
    "name": "George Rasmi Ghabrial",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/08/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: George Rasmi Ghabrial",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9be25f5b-e8f1-4bef-b984-7b2b3d7257fd",
        "address": "الطابق الثالث ,مجمع المحكمة العليا دبي ,مجمع المحكمة العليا دبي ,45556 ,Dubai",
        "phone": "97145570632 / 971503977375",
        "email": "rasmi@aahadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d47fa75-0239-4031-a3a5-d132d2fa393b",
    "firmName": "ABDULLA AL HADDAD ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-06752",
    "licenseIssueDate": "04/08/2025 00:00:00",
    "licenseExpiryDate": "04/07/2026 00:00:00"
  },
  {
    "id": "bb3340cc-ff5f-4a2e-b793-184ba40d045b",
    "slug": "george-saji-kuruvilla",
    "name": "George Saji Kuruvilla",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/01/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: George Saji Kuruvilla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bb3340cc-ff5f-4a2e-b793-184ba40d045b",
        "address": "",
        "phone": "97144298492",
        "email": "Ammaraalmulla@GMAIL.COM",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "becf727c-133c-4718-b959-762d1beaee4d",
    "firmName": "AMMAR ALMULLA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06968",
    "licenseIssueDate": "09/22/2025 00:00:00",
    "licenseExpiryDate": "09/21/2026 00:00:00"
  },
  {
    "id": "71a20cef-33db-4ba1-9bc6-13152e00e822",
    "slug": "george-thomas-pointer",
    "name": "George Thomas Pointer",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/03/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: George Thomas Pointer",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_71a20cef-33db-4ba1-9bc6-13152e00e822",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506688 ,Dubai",
        "phone": "97147096600 / 971503556811",
        "email": "muneer.khan@simmons-simmons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d1725ca7-06ac-41b2-8d7b-a6e60665b73d",
    "firmName": "Simmons & Simmons (Middle East) LLP-DIFC",
    "registrationNumber": "L-06948",
    "licenseIssueDate": "08/25/2025 00:00:00",
    "licenseExpiryDate": "08/24/2026 00:00:00"
  },
  {
    "id": "8bc29731-c791-4875-8f10-0ca0ecc4a657",
    "slug": "georges-daaboul",
    "name": "Georges Daaboul",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/23/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Georges Daaboul",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8bc29731-c791-4875-8f10-0ca0ecc4a657",
        "address": "",
        "phone": "97142552220",
        "email": "almaazmi.office@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e04d8a88-3378-40c8-a33a-b5e26a0c8507",
    "firmName": "ABDELRAHMAN AL MAAZMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01873",
    "licenseIssueDate": "07/23/2013 00:00:00",
    "licenseExpiryDate": "07/16/2026 00:00:00"
  },
  {
    "id": "a9a0072d-09c8-4563-88e6-601b7cb73879",
    "slug": "georges-faouzi-haddad",
    "name": "Georges Faouzi Haddad",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/17/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Georges Faouzi Haddad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a9a0072d-09c8-4563-88e6-601b7cb73879",
        "address": "",
        "phone": "97143901155",
        "email": "legal@awigdic.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e0e9ae88-3bda-4570-8591-d79757732608",
    "firmName": "AL WASL INTERNATIONAL GROUP ADVOCATES AND LEGAL CONSULTANTS- THE DUBAI TECHNOLOGY AND MEDIA FREE ZON",
    "registrationNumber": "L-01946",
    "licenseIssueDate": "11/17/2011 00:00:00",
    "licenseExpiryDate": "11/08/2025 00:00:00"
  },
  {
    "id": "8a67f80d-c112-44b9-9c5e-e2fdc24e4ca6",
    "slug": "georges-joseph-abou-zogheib",
    "name": "Georges Joseph Abou Zogheib",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/22/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Georges Joseph Abou Zogheib",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8a67f80d-c112-44b9-9c5e-e2fdc24e4ca6",
        "address": "",
        "phone": "97142554421",
        "email": "mariam.alshamsi@triumphco.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0a80a9dd-7ded-4752-af6a-4444111bc177",
    "firmName": "MARIAM AL SHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05213",
    "licenseIssueDate": "02/22/2022 00:00:00",
    "licenseExpiryDate": "02/21/2026 00:00:00"
  },
  {
    "id": "c8018709-87b7-4b9b-a6d3-c4a3ef37577e",
    "slug": "georges-saade",
    "name": "Georges Saade",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/24/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Georges Saade",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c8018709-87b7-4b9b-a6d3-c4a3ef37577e",
        "address": "",
        "phone": "97142594601",
        "email": "info@almazmilawfirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6d921a3f-66d8-409c-82d0-47ea77e53617",
    "firmName": "AHMED HASSAN ALMAAZMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02648",
    "licenseIssueDate": "06/24/2013 00:00:00",
    "licenseExpiryDate": "06/17/2026 00:00:00"
  },
  {
    "id": "1e8ff42f-36f5-4fc2-9edd-f95d98f1e1f7",
    "slug": "georges-youssef-khalaf",
    "name": "Georges Youssef Khalaf",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/13/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Georges Youssef Khalaf",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1e8ff42f-36f5-4fc2-9edd-f95d98f1e1f7",
        "address": "South Tower, Emirates Financial Towers ,DIFC ,482025 ,",
        "phone": "97145875333 / 971503444388",
        "email": "c.dersahakian@cvml.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e2c6db70-04e7-4c7b-882a-6d2ffe4469ed",
    "firmName": "CVML Limited",
    "registrationNumber": "L-05994",
    "licenseIssueDate": "12/13/2023 00:00:00",
    "licenseExpiryDate": "12/12/2025 00:00:00"
  },
  {
    "id": "069778a1-394a-458d-91b2-7a73669616aa",
    "slug": "georgia-fullarton",
    "name": "Georgia Fullarton",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/09/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Georgia Fullarton",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_069778a1-394a-458d-91b2-7a73669616aa",
        "address": "20 ,Index Tower West Tower ,DIFC ,507226 ,Dubai",
        "phone": "97142461900 / 971523391604",
        "email": "patrick.gearon@crsblaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e2ac552e-b9a7-450b-a84d-15119e583220",
    "firmName": "Charles Russell Speechlys LLP",
    "registrationNumber": "L-05824",
    "licenseIssueDate": "06/09/2023 00:00:00",
    "licenseExpiryDate": "06/08/2026 00:00:00"
  },
  {
    "id": "442d31f3-5bc2-4523-bbb0-eadea7e134cd",
    "slug": "georgia-isabelle-losy",
    "name": "Georgia Isabelle Losy",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/30/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Georgia Isabelle Losy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_442d31f3-5bc2-4523-bbb0-eadea7e134cd",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-06783",
    "licenseIssueDate": "04/30/2025 00:00:00",
    "licenseExpiryDate": "04/29/2026 00:00:00"
  },
  {
    "id": "3c2f43b3-9497-4a0a-ab7e-156ddbac8d5d",
    "slug": "georgii-vinogradov",
    "name": "Georgii Vinogradov",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHVgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/20/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Georgii Vinogradov",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3c2f43b3-9497-4a0a-ab7e-156ddbac8d5d",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-05404",
    "licenseIssueDate": "07/20/2022 00:00:00",
    "licenseExpiryDate": "07/19/2026 00:00:00"
  },
  {
    "id": "a4c4f6f8-359e-45e7-90a3-afcf165a102e",
    "slug": "georgina-beatrice-moore",
    "name": "Georgina Beatrice Moore",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/07/2023",
    "licenseStatus": "active",
    "licenseExpiry": "2024-07-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Georgina Beatrice Moore",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a4c4f6f8-359e-45e7-90a3-afcf165a102e",
        "address": "",
        "phone": "97143742800 / 971506450677",
        "email": "jabbott21@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7a59d310-ff72-4318-b41c-27095c163d0f",
    "firmName": "CMS (UAE) LLP",
    "registrationNumber": "L-05909",
    "licenseIssueDate": "07/26/2023 00:00:00",
    "licenseExpiryDate": "07/25/2026 00:00:00"
  },
  {
    "id": "cc45eda1-3825-4ad3-bf61-59e3947739ee",
    "slug": "georgina-devlin-munnik",
    "name": "Georgina Devlin Munnik",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/17/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Georgina Devlin Munnik",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cc45eda1-3825-4ad3-bf61-59e3947739ee",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-06265",
    "licenseIssueDate": "04/17/2024 00:00:00",
    "licenseExpiryDate": "04/16/2026 00:00:00"
  },
  {
    "id": "03aa6dbc-bcbd-4d24-a7ee-a3cf9a22f9ca",
    "slug": "georgina-elizabeth-stokoe",
    "name": "Georgina Elizabeth Stokoe",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/09/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Georgina Elizabeth Stokoe",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_03aa6dbc-bcbd-4d24-a7ee-a3cf9a22f9ca",
        "address": "",
        "phone": "97145132619 / 971543630593",
        "email": "info@alfaisal.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "fd647c60-3bff-4297-87f1-6437acf45575",
    "firmName": "FAISAL SALEM ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-05850",
    "licenseIssueDate": "06/09/2023 00:00:00",
    "licenseExpiryDate": "06/08/2026 00:00:00"
  },
  {
    "id": "b871a74f-9dd1-4a70-b14e-b1672bc46d8a",
    "slug": "gerald-rogers",
    "name": "Gerald Rogers",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/19/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Gerald Rogers",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b871a74f-9dd1-4a70-b14e-b1672bc46d8a",
        "address": "",
        "phone": "97144230000 / 971552009022",
        "email": "UAE-CourtClerks@habibalmulla.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3eba82bb-8ec4-4cbd-80d0-a793cb993fde",
    "firmName": "Habib Al Mulla & Partners ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02425",
    "licenseIssueDate": "03/19/2015 00:00:00",
    "licenseExpiryDate": "03/13/2026 00:00:00"
  },
  {
    "id": "69c7ce50-5b6a-493f-9aaa-eca9d852c1df",
    "slug": "gerard-moore",
    "name": "Gerard Moore",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/10/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Gerard Moore",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_69c7ce50-5b6a-493f-9aaa-eca9d852c1df",
        "address": "Index Tower ,Dubai International Financial Centre ,507115 ,",
        "phone": "97143757160 / 971523490280",
        "email": "tthraya@mayerbrown.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c7f52b69-c049-4246-963a-9805b241f88a",
    "firmName": "Mayer Brown LLP",
    "registrationNumber": "L-03492",
    "licenseIssueDate": "10/10/2016 00:00:00",
    "licenseExpiryDate": "10/06/2026 00:00:00"
  },
  {
    "id": "8ff6d1f9-d036-40fd-a1db-f5128cdf7f86",
    "slug": "ghalib-mahmoud",
    "name": "Ghalib Mahmoud",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/15/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ghalib Mahmoud",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8ff6d1f9-d036-40fd-a1db-f5128cdf7f86",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-03846",
    "licenseIssueDate": "08/15/2017 00:00:00",
    "licenseExpiryDate": "08/12/2026 00:00:00"
  },
  {
    "id": "7beeb5af-e719-4c77-b424-f41ffa7fdd7b",
    "slug": "ghalya-ali-abdulrazzaq-rashid",
    "name": "Ghalya Ali Abdulrazzaq Rashid",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/24/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ghalya Ali Abdulrazzaq Rashid",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7beeb5af-e719-4c77-b424-f41ffa7fdd7b",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-04527",
    "licenseIssueDate": "10/24/2019 00:00:00",
    "licenseExpiryDate": "10/23/2025 00:00:00"
  },
  {
    "id": "90ad0af3-ae22-498c-824b-5b47496b72ef",
    "slug": "ghassan-atris",
    "name": "Ghassan  Atris",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/16/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ghassan  Atris",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_90ad0af3-ae22-498c-824b-5b47496b72ef",
        "address": "Gamal Yassein Abdalla ,الطابق 13  Floor No 13 ,بناية مركز ابروي (The Oberoi Center) ,فندق ابروي (The Oberoi Hotel) ,33299 ,Dubai",
        "phone": "97142828000",
        "email": "litigation@alaidarous.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9a923766-1fd1-4e06-a871-89662120384e",
    "firmName": "AL AIDAROUS ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-03367",
    "licenseIssueDate": "05/16/2016 00:00:00",
    "licenseExpiryDate": "05/12/2026 00:00:00"
  },
  {
    "id": "e32a4b4e-2421-4e8a-975d-760aa34a148b",
    "slug": "ghassan-el-daye",
    "name": "Ghassan El-Daye",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/26/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ghassan El-Daye",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e32a4b4e-2421-4e8a-975d-760aa34a148b",
        "address": "20 ,Index Tower West Tower ,DIFC ,507226 ,Dubai",
        "phone": "97142461900 / 971523391604",
        "email": "patrick.gearon@crsblaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e2ac552e-b9a7-450b-a84d-15119e583220",
    "firmName": "Charles Russell Speechlys LLP",
    "registrationNumber": "L-00643",
    "licenseIssueDate": "09/26/2011 00:00:00",
    "licenseExpiryDate": "09/17/2026 00:00:00"
  },
  {
    "id": "4adc029a-fe7d-464d-b072-d0c4b8d6c896",
    "slug": "ghassan-saleem-arnous",
    "name": "ghassan saleem arnous",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/05/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ghassan saleem arnous",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4adc029a-fe7d-464d-b072-d0c4b8d6c896",
        "address": "zayed saeed saif alshamsi ,الرابع مكتب رقم 414 ,قرية الاعمال ,بجانب دائرة التنمية الاقتصادية - دوار الساعة  ,6030 ,Dubai",
        "phone": "97142680800",
        "email": "info@zayedalshamsi.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "295c7198-77b4-4f9a-a4d2-bad9a78e074d",
    "firmName": "ZAYED AL SHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04610",
    "licenseIssueDate": "03/05/2020 00:00:00",
    "licenseExpiryDate": "03/04/2026 00:00:00"
  },
  {
    "id": "ae414f32-edd0-4436-9095-9cae3fbf2bc8",
    "slug": "ghazal-jalal-y-alkhawaldh",
    "name": "GHAZAL JALAL Y ALKHAWALDH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/08/2025",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: GHAZAL JALAL Y ALKHAWALDH",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ae414f32-edd0-4436-9095-9cae3fbf2bc8",
        "address": "",
        "phone": "97148321212",
        "email": "nasser@nmlawyers.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "71709458-e40a-45b3-9319-4c51c18891be",
    "firmName": "NASSER MALALLA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06947",
    "licenseIssueDate": "08/25/2025 00:00:00",
    "licenseExpiryDate": "08/24/2026 00:00:00"
  },
  {
    "id": "f2ea645b-d880-422b-be09-750cd1716cd7",
    "slug": "ghazi-moreed-ghazi-abuyounis",
    "name": "Ghazi Moreed Ghazi Abuyounis",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/04/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ghazi Moreed Ghazi Abuyounis",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f2ea645b-d880-422b-be09-750cd1716cd7",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-06035",
    "licenseIssueDate": "10/04/2023 00:00:00",
    "licenseExpiryDate": "10/03/2026 00:00:00"
  },
  {
    "id": "5b201964-23c1-47b5-b0a8-c41a871e2837",
    "slug": "ghazwan-al-kinaan",
    "name": "Ghazwan Al Kinaan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/16/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ghazwan Al Kinaan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5b201964-23c1-47b5-b0a8-c41a871e2837",
        "address": "",
        "phone": "97142966772",
        "email": "info@advocates-consultation.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "43806daf-e311-4130-a270-8aabc08c4ef4",
    "firmName": "OBAID AL EBRI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03662",
    "licenseIssueDate": "03/16/2017 00:00:00",
    "licenseExpiryDate": "03/13/2026 00:00:00"
  },
  {
    "id": "57a2b3e2-2c7f-4af1-8ec1-e2d7668c3ebb",
    "slug": "gheith-marwan-cherkeh",
    "name": "Gheith Marwan Cherkeh",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/11/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Gheith Marwan Cherkeh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_57a2b3e2-2c7f-4af1-8ec1-e2d7668c3ebb",
        "address": "",
        "phone": "97143937700",
        "email": "info@galadarilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d863b662-c864-4193-8b3a-ff6ee5fe6c64",
    "firmName": "GALADARI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06544",
    "licenseIssueDate": "10/11/2024 00:00:00",
    "licenseExpiryDate": "10/10/2026 00:00:00"
  },
  {
    "id": "1a911315-335d-4b9a-82b6-e6e20b9f7734",
    "slug": "gibbs-alan-johnson",
    "name": "Gibbs Alan Johnson",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/10/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Gibbs Alan Johnson",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1a911315-335d-4b9a-82b6-e6e20b9f7734",
        "address": "",
        "phone": "97145032600 / 971504577931",
        "email": "edmund.boyo@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8cca52de-2c74-4743-b8f2-0b904d96b132",
    "firmName": "CC Worldwide Limited",
    "registrationNumber": "L-04728",
    "licenseIssueDate": "09/10/2020 00:00:00",
    "licenseExpiryDate": "09/09/2026 00:00:00"
  },
  {
    "id": "70bf8cef-10ab-430b-9ee8-a94c50f5ed07",
    "slug": "gilbert-hakim",
    "name": "Gilbert Hakim",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/19/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Gilbert Hakim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_70bf8cef-10ab-430b-9ee8-a94c50f5ed07",
        "address": "Office 1A ,Silver Tower ,DMCC Al Mas Tower ,283149 ,Dubai",
        "phone": "97144542355 / 971564092949",
        "email": "pstone@fenwickelliott.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "45b03212-ac3a-4dbc-8b2d-10fc81273543",
    "firmName": "Fenwick Elliott LLP (DMCC Branch)",
    "registrationNumber": "L-02399",
    "licenseIssueDate": "12/19/2013 00:00:00",
    "licenseExpiryDate": "12/12/2025 00:00:00"
  },
  {
    "id": "cbf53864-8e7a-4c5e-ae4b-084c93cfc321",
    "slug": "gillian-elizabeth-flannighan",
    "name": "Gillian Elizabeth Flannighan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/11/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Gillian Elizabeth Flannighan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cbf53864-8e7a-4c5e-ae4b-084c93cfc321",
        "address": "",
        "phone": "97143897000 / 971506553198",
        "email": "nasseralikhasawneh@eversheds-sutherland.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "74a21d43-41d8-480a-a6af-6939b7c98a95",
    "firmName": "Eversheds Sutherland (International LLP) Dubai Branch",
    "registrationNumber": "L-03924",
    "licenseIssueDate": "12/11/2017 00:00:00",
    "licenseExpiryDate": "12/08/2025 00:00:00"
  },
  {
    "id": "8b69a409-eff9-4dae-b5d4-eeea2a423f46",
    "slug": "gillian-pareicia-orourke",
    "name": "Gillian Pareicia Orourke",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/03/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Gillian Pareicia Orourke",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8b69a409-eff9-4dae-b5d4-eeea2a423f46",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-05781",
    "licenseIssueDate": "05/03/2023 00:00:00",
    "licenseExpiryDate": "05/02/2026 00:00:00"
  },
  {
    "id": "3f8d3fbb-9bef-4b2b-8c91-ca6c4d5bffb0",
    "slug": "giovanni-rossi",
    "name": "Giovanni Rossi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/06/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Giovanni Rossi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3f8d3fbb-9bef-4b2b-8c91-ca6c4d5bffb0",
        "address": "",
        "phone": "97145683100 / 971559223103",
        "email": "rossi@bonnard-lawson.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "2b373724-e557-4c31-a968-7d37d9393842",
    "firmName": "Bonnard Lawson Legal Consultants L.L.C",
    "registrationNumber": "L-02470",
    "licenseIssueDate": "04/06/2014 00:00:00",
    "licenseExpiryDate": "03/30/2026 00:00:00"
  },
  {
    "id": "633a1310-4ea9-432a-8f59-fe8e54988f31",
    "slug": "giuliano-parlascino",
    "name": "Giuliano Parlascino",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/21/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Giuliano Parlascino",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_633a1310-4ea9-432a-8f59-fe8e54988f31",
        "address": "Gate Village 10 ,Dubai International Financial Centre ,504945 ,",
        "phone": "97143301800 / 971569904245",
        "email": "nikram@velaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "61216046-6cd5-410d-a301-532f3e520e30",
    "firmName": "Vinson & Elkins LLP",
    "registrationNumber": "L-06221",
    "licenseIssueDate": "02/21/2024 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "e540f1c4-735b-438a-9eaf-47b0b601dd01",
    "slug": "giuseppe-lepore",
    "name": "Giuseppe Lepore",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/06/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Giuseppe Lepore",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e540f1c4-735b-438a-9eaf-47b0b601dd01",
        "address": "",
        "phone": "97145851677 / 971508009612",
        "email": "antonio.varvaro@amv-eurolegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2834e81b-8706-4672-8b39-01356b145ac0",
    "firmName": "Antonio M Varvaro Legal Consultants",
    "registrationNumber": "L-06126",
    "licenseIssueDate": "12/06/2023 00:00:00",
    "licenseExpiryDate": "12/05/2025 00:00:00"
  },
  {
    "id": "e91f4256-31aa-44a1-99e6-597203c0c7e4",
    "slug": "glenn-anthony-bull",
    "name": "Glenn Anthony Bull",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/23/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Glenn Anthony Bull",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e91f4256-31aa-44a1-99e6-597203c0c7e4",
        "address": "20 ,Index Tower West Tower ,DIFC ,507226 ,Dubai",
        "phone": "97142461900 / 971523391604",
        "email": "patrick.gearon@crsblaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e2ac552e-b9a7-450b-a84d-15119e583220",
    "firmName": "Charles Russell Speechlys LLP",
    "registrationNumber": "L-04720",
    "licenseIssueDate": "07/23/2020 00:00:00",
    "licenseExpiryDate": "07/22/2026 00:00:00"
  },
  {
    "id": "b0e443e2-b4fa-415c-9927-0fc6d935acc2",
    "slug": "gloria-estolano",
    "name": "Gloria Estolano",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/08/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Gloria Estolano",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b0e443e2-b4fa-415c-9927-0fc6d935acc2",
        "address": "sohail jassem pararin ,34 ,Central Park Tower ,Dubai Mall ,233066 ,Dubai",
        "phone": "97144228410",
        "email": "info@mahmoodhussain.net",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "f3309481-3edd-4503-92d2-bd9f71ba513a",
    "firmName": "MAHMOOD HUSSAIN ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-03647",
    "licenseIssueDate": "02/08/2017 00:00:00",
    "licenseExpiryDate": "02/04/2026 00:00:00"
  },
  {
    "id": "5d6af146-19bb-4879-ba29-4f381a84fea4",
    "slug": "goitseone-kagiso-mangope",
    "name": "Goitseone Kagiso Mangope",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/21/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Goitseone Kagiso Mangope",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5d6af146-19bb-4879-ba29-4f381a84fea4",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-06585",
    "licenseIssueDate": "11/21/2024 00:00:00",
    "licenseExpiryDate": "11/20/2025 00:00:00"
  },
  {
    "id": "c460ca34-0bee-4a47-8fd5-d3a2ea583441",
    "slug": "gordon-barr",
    "name": "Gordon Barr",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Gordon Barr",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c460ca34-0bee-4a47-8fd5-d3a2ea583441",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01262",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "dd6a9c95-6d38-4217-bf83-7b1903df4c9b",
    "slug": "grace-goh-hui-tse",
    "name": "Grace Goh Hui Tse",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/10/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-09-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Grace Goh Hui Tse",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dd6a9c95-6d38-4217-bf83-7b1903df4c9b",
        "address": "THE OFFICES 1 ,DWTC ,115580 ,",
        "phone": "97143739700 / 971501148248",
        "email": "nitesh.pradhan@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "361fdc64-6b6f-4f37-abca-c52af8473b84",
    "firmName": "Pinsent Masons  LLP (DWTCA Branch)",
    "registrationNumber": "L-05487",
    "licenseIssueDate": "01/10/2025 00:00:00",
    "licenseExpiryDate": "01/09/2026 00:00:00"
  },
  {
    "id": "91d1e39e-e24f-4e39-ae59-c72ee7fc4c33",
    "slug": "grace-michelle-hunt",
    "name": "Grace Michelle Hunt",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/12/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Grace Michelle Hunt",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_91d1e39e-e24f-4e39-ae59-c72ee7fc4c33",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-04619",
    "licenseIssueDate": "03/12/2020 00:00:00",
    "licenseExpiryDate": "03/11/2026 00:00:00"
  },
  {
    "id": "9f266e17-9355-481a-88ee-8b1fc9dc207b",
    "slug": "grace-victoria-pigott",
    "name": "Grace Victoria Pigott",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHVgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/06/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Grace Victoria Pigott",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9f266e17-9355-481a-88ee-8b1fc9dc207b",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-06549",
    "licenseIssueDate": "11/06/2024 00:00:00",
    "licenseExpiryDate": "11/05/2025 00:00:00"
  },
  {
    "id": "e4549495-1f1f-4260-a8b4-b01a36fd2081",
    "slug": "graham-brewer",
    "name": "Graham Brewer",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/09/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Graham Brewer",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e4549495-1f1f-4260-a8b4-b01a36fd2081",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-00147",
    "licenseIssueDate": "02/09/2017 00:00:00",
    "licenseExpiryDate": "02/05/2026 00:00:00"
  },
  {
    "id": "9dfe679d-8511-4900-b35b-33f0d2637cbf",
    "slug": "graham-lovett",
    "name": "Graham Lovett",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/17/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Graham Lovett",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9dfe679d-8511-4900-b35b-33f0d2637cbf",
        "address": "ICD Brookfield Place ,DIFC ,120109 ,",
        "phone": "97143173000 / 971504465229",
        "email": "DubaiLAD@akingump.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9ff29eab-adb8-40f9-ab84-216e01a381e4",
    "firmName": "Akin Gump Strauss Hauer & Feld LLP",
    "registrationNumber": "L-00148",
    "licenseIssueDate": "04/17/2016 00:00:00",
    "licenseExpiryDate": "04/12/2026 00:00:00"
  },
  {
    "id": "a5dc81f4-3bdc-47e7-9bfd-9190eb7e1c83",
    "slug": "gratssiella-georges",
    "name": "Gratssiella Georges",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/22/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Gratssiella Georges",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a5dc81f4-3bdc-47e7-9bfd-9190eb7e1c83",
        "address": "21 ,Rolex Tower ,Emirates Grand Hotel ,94334 ,Dubai",
        "phone": "97143277772 / 97145584900",
        "email": "info@globaladvocates.net",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9b42810f-1d55-4aea-ac4a-7d9d1b25ac08",
    "firmName": "GLOBAL ADVOCACY & LEGAL COUNSEL",
    "registrationNumber": "L-04881",
    "licenseIssueDate": "03/22/2021 00:00:00",
    "licenseExpiryDate": "03/21/2026 00:00:00"
  },
  {
    "id": "347c9717-0119-452a-82c3-6b2aaf3aa03f",
    "slug": "greg-sibbald",
    "name": "Greg Sibbald",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/25/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Greg Sibbald",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_347c9717-0119-452a-82c3-6b2aaf3aa03f",
        "address": "",
        "phone": "97143742800 / 971506450677",
        "email": "jabbott21@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7a59d310-ff72-4318-b41c-27095c163d0f",
    "firmName": "CMS (UAE) LLP",
    "registrationNumber": "L-03472",
    "licenseIssueDate": "08/25/2016 00:00:00",
    "licenseExpiryDate": "08/21/2026 00:00:00"
  },
  {
    "id": "0b893ce2-d2f3-49c7-8a0b-d878bad79e8c",
    "slug": "gregg-hammond",
    "name": "Gregg Hammond",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/11/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Gregg Hammond",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0b893ce2-d2f3-49c7-8a0b-d878bad79e8c",
        "address": "THE OFFICES 1 ,DWTC ,115580 ,",
        "phone": "97143739700 / 971501148248",
        "email": "nitesh.pradhan@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "361fdc64-6b6f-4f37-abca-c52af8473b84",
    "firmName": "Pinsent Masons  LLP (DWTCA Branch)",
    "registrationNumber": "L-05067",
    "licenseIssueDate": "10/11/2021 00:00:00",
    "licenseExpiryDate": "10/10/2026 00:00:00"
  },
  {
    "id": "00abc1d7-741f-4307-8351-9c6c5375e1a4",
    "slug": "gretta-habib",
    "name": "Gretta Habib",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/13/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Gretta Habib",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_00abc1d7-741f-4307-8351-9c6c5375e1a4",
        "address": "",
        "phone": "97145953601 / 971508728645",
        "email": "Steven.Bainbridge@gtlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b4146aa6-efd1-41d7-819d-49da46353b0b",
    "firmName": "Greenberg Traurig Limited",
    "registrationNumber": "L-06013",
    "licenseIssueDate": "09/13/2023 00:00:00",
    "licenseExpiryDate": "09/12/2026 00:00:00"
  },
  {
    "id": "bb2fee61-5303-470a-967b-573beecb5772",
    "slug": "guillaume-marie-jean-denis-de-rocquigny-du-fayel",
    "name": "Guillaume Marie Jean Denis de Rocquigny du Fayel",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/04/2018",
    "licenseStatus": "active",
    "licenseExpiry": "2019-04-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Guillaume Marie Jean Denis de Rocquigny du Fayel",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bb2fee61-5303-470a-967b-573beecb5772",
        "address": "ali mohamed amin  ,205 - 104  ,اثراء  ,بالقرب من فندق جميرا طيران الامارات  ,10155 ,Dubai",
        "phone": "97143967188",
        "email": "aliadvocates71@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "298ff405-ca8b-4fc8-a674-74ae24832268",
    "firmName": "ALI NAQI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04081",
    "licenseIssueDate": "04/23/2018 00:00:00",
    "licenseExpiryDate": "04/20/2026 00:00:00"
  },
  {
    "id": "43e01908-8dae-4b46-8b36-2237e1fcbbbf",
    "slug": "gulsun-ozmen",
    "name": "Gulsun Ozmen",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/06/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Gulsun Ozmen",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_43e01908-8dae-4b46-8b36-2237e1fcbbbf",
        "address": "",
        "phone": "97143641686 / 971506288801",
        "email": "b.kadir@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0ba96df8-e4cc-49c2-8ae4-a42878d95926",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS LLC",
    "registrationNumber": "L-06070",
    "licenseIssueDate": "12/06/2023 00:00:00",
    "licenseExpiryDate": "12/05/2025 00:00:00"
  },
  {
    "id": "cff0be8f-520d-4716-8b22-f2f875f2de11",
    "slug": "gurmeet-singh",
    "name": "Gurmeet Singh",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/08/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Gurmeet Singh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cff0be8f-520d-4716-8b22-f2f875f2de11",
        "address": "- ,THE OFFICES 1 ,DWTC ,115580 ,Dubai",
        "phone": "97143739700 / 971562196031",
        "email": "catherine.workman@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6b4ebb23-ef2e-4305-a1ee-43a11e4b1cae",
    "firmName": "Pinsent Masons LLP - Dubai Branch",
    "registrationNumber": "L-01040",
    "licenseIssueDate": "10/08/2013 00:00:00",
    "licenseExpiryDate": "10/01/2026 00:00:00"
  },
  {
    "id": "3840bccc-cba5-4600-9ebe-36e4b0096946",
    "slug": "gurminder-sanghera",
    "name": "Gurminder Sanghera",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/08/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Gurminder Sanghera",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3840bccc-cba5-4600-9ebe-36e4b0096946",
        "address": "Level 14 ,Burj Daman ,Four Seasons Hotel ,119980 ,Dubai",
        "phone": "97143604070 / 971502450485",
        "email": "Philip.ireland@maples.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "cb7cc285-8538-469a-b075-ef30819bce69",
    "firmName": "Maples & Calder (Dubai) LLP",
    "registrationNumber": "L-02745",
    "licenseIssueDate": "12/08/2014 00:00:00",
    "licenseExpiryDate": "12/02/2025 00:00:00"
  },
  {
    "id": "83f85135-5fe3-4155-95d7-171865528e62",
    "slug": "gurujala-siddharth-goud",
    "name": "Gurujala Siddharth Goud",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/06/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Gurujala Siddharth Goud",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_83f85135-5fe3-4155-95d7-171865528e62",
        "address": "1 ,ICD Brookfield Place ,Dubai International Financial Centre ,9267 ,Dubai",
        "phone": "97147010975 / 971502977062",
        "email": "chris.sioufi@ae.ey.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "42e536ef-e3d8-4339-8572-657a7f7a0331",
    "firmName": "EY Law LLP",
    "registrationNumber": "L-06074",
    "licenseIssueDate": "11/06/2023 00:00:00",
    "licenseExpiryDate": "11/05/2025 00:00:00"
  },
  {
    "id": "5de74a47-da49-49d6-a9e8-6f41a394166f",
    "slug": "gustav-olof-martin-lexner",
    "name": "Gustav Olof Martin Lexner",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/05/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Gustav Olof Martin Lexner",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5de74a47-da49-49d6-a9e8-6f41a394166f",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-04977",
    "licenseIssueDate": "07/05/2021 00:00:00",
    "licenseExpiryDate": "07/04/2026 00:00:00"
  },
  {
    "id": "ed4180f4-370d-488d-9636-b0b318e2664f",
    "slug": "guy-terence-david-norman",
    "name": "Guy Terence David Norman",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/06/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Guy Terence David Norman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ed4180f4-370d-488d-9636-b0b318e2664f",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-05951",
    "licenseIssueDate": "09/06/2023 00:00:00",
    "licenseExpiryDate": "09/05/2026 00:00:00"
  },
  {
    "id": "870476a7-c0eb-47e3-a184-89e44e88c8c3",
    "slug": "guzel-sakaeva",
    "name": "Guzel Sakaeva",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/01/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Guzel Sakaeva",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_870476a7-c0eb-47e3-a184-89e44e88c8c3",
        "address": "",
        "phone": "97144230555 / 971504788443",
        "email": "yah@hfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c462c65e-185a-4e81-8425-a87e3a2b6842",
    "firmName": "Holman Fenwick Willan Middle East LLP",
    "registrationNumber": "L-05730",
    "licenseIssueDate": "03/01/2023 00:00:00",
    "licenseExpiryDate": "02/28/2026 00:00:00"
  },
  {
    "id": "747e3e5a-2cf7-4e5e-a46d-5f644730a6e0",
    "slug": "habib-mohamadin-adam-babikir",
    "name": "Habib Mohamadin Adam Babikir",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/01/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Habib Mohamadin Adam Babikir",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_747e3e5a-2cf7-4e5e-a46d-5f644730a6e0",
        "address": "23 ,Rolex Tower ,Trade Center Second ,116637 ,Dubai",
        "phone": "97144357577 / 971502101003",
        "email": "jasamin.fichte@fichtelegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "77bf4fd2-1cd1-4bda-a0c2-ffcac3980b76",
    "firmName": "Fichte & Co Legal Consultancy",
    "registrationNumber": "L-04854",
    "licenseIssueDate": "03/01/2021 00:00:00",
    "licenseExpiryDate": "02/28/2026 00:00:00"
  },
  {
    "id": "223db303-ce79-4598-bca5-2846d475bb51",
    "slug": "habib-saeed",
    "name": "Habib Saeed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/21/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Habib Saeed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_223db303-ce79-4598-bca5-2846d475bb51",
        "address": "",
        "phone": "97144478700 / 971528553200",
        "email": "Thomas.Wilson@squirepb.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "85be541a-c87f-45a9-a321-d90abd6b7298",
    "firmName": "Squire Patton Boggs (MEA) LLP",
    "registrationNumber": "L-04768",
    "licenseIssueDate": "10/21/2020 00:00:00",
    "licenseExpiryDate": "10/20/2025 00:00:00"
  },
  {
    "id": "07bb9817-10ed-4430-8f54-896c1a1480e0",
    "slug": "hadeer-ahmed-hassan-abdallah",
    "name": "Hadeer Ahmed Hassan AbdAllah",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/12/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hadeer Ahmed Hassan AbdAllah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_07bb9817-10ed-4430-8f54-896c1a1480e0",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-05310",
    "licenseIssueDate": "04/12/2022 00:00:00",
    "licenseExpiryDate": "04/11/2026 00:00:00"
  },
  {
    "id": "9416404a-2e8d-4aee-9387-959019812e4b",
    "slug": "hadiel-hussien",
    "name": "Hadiel Hussien",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBISAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/08/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hadiel Hussien",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9416404a-2e8d-4aee-9387-959019812e4b",
        "address": "",
        "phone": "97144073901 / 971503479508",
        "email": "Rania.Tadros@stephensonharwood.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dd5042a2-bb41-4123-9544-79c3fa831332",
    "firmName": "Stephenson Harwood (Middle East) LLP",
    "registrationNumber": "L-03658",
    "licenseIssueDate": "03/08/2017 00:00:00",
    "licenseExpiryDate": "03/04/2026 00:00:00"
  },
  {
    "id": "c23b9aff-2d1f-4bc4-b31f-f8ff7d46661d",
    "slug": "haethm-abdelwahab-ahmed",
    "name": "Haethm Abdelwahab Ahmed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/29/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Haethm Abdelwahab Ahmed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c23b9aff-2d1f-4bc4-b31f-f8ff7d46661d",
        "address": "",
        "phone": "97143300009 / 971501215000",
        "email": "mohamed@maa.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "af85c161-b73d-46a2-9fd7-4d8604007473",
    "firmName": "MOHAMED ALI ALHAMMADI ADVOCATES & LEGAL CONSULTANT",
    "registrationNumber": "L-02073",
    "licenseIssueDate": "11/29/2011 00:00:00",
    "licenseExpiryDate": "11/20/2025 00:00:00"
  },
  {
    "id": "f57e8a93-5aba-4f4e-8ec5-e0cc2d76db18",
    "slug": "hai-song-tan",
    "name": "Hai Song Tan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/19/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hai Song Tan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f57e8a93-5aba-4f4e-8ec5-e0cc2d76db18",
        "address": "THE OFFICES 1 ,DWTC ,115580 ,",
        "phone": "97143739700 / 971501148248",
        "email": "nitesh.pradhan@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "361fdc64-6b6f-4f37-abca-c52af8473b84",
    "firmName": "Pinsent Masons  LLP (DWTCA Branch)",
    "registrationNumber": "L-05902",
    "licenseIssueDate": "07/19/2023 00:00:00",
    "licenseExpiryDate": "07/18/2026 00:00:00"
  },
  {
    "id": "a2bf19fb-a698-48d6-9312-f1d1ddf01c2f",
    "slug": "haifaa-jihad-ibrahim",
    "name": "Haifaa Jihad Ibrahim",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBISgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/20/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Haifaa Jihad Ibrahim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a2bf19fb-a698-48d6-9312-f1d1ddf01c2f",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-04637",
    "licenseIssueDate": "02/20/2020 00:00:00",
    "licenseExpiryDate": "02/19/2026 00:00:00"
  },
  {
    "id": "c4be1a22-20d9-4428-bd3a-565e0833bc47",
    "slug": "haitham-elsafti",
    "name": "Haitham Elsafti",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/12/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Haitham Elsafti",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c4be1a22-20d9-4428-bd3a-565e0833bc47",
        "address": "Amer Sayed Al Marzooqi ,603 ,SAMA TOWER ,TRADE CENTER ,41727 ,Dubai",
        "phone": "97142500023",
        "email": "info@mlegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7ed7234c-a176-47f9-b66e-18524305fe3e",
    "firmName": "AMER AL MARZOOQI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03678",
    "licenseIssueDate": "05/12/2022 00:00:00",
    "licenseExpiryDate": "05/11/2026 00:00:00"
  },
  {
    "id": "19a09ae6-50b8-46fb-86e1-363324d46b19",
    "slug": "haitham-hamdy-elsayed-ahmed-elfaramawy",
    "name": "Haitham Hamdy Elsayed Ahmed Elfaramawy",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBISAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/06/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Haitham Hamdy Elsayed Ahmed Elfaramawy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_19a09ae6-50b8-46fb-86e1-363324d46b19",
        "address": "first floor ,Al Ferdous 4 ,Park and Shop ,12018 ,Dubai",
        "phone": "97143930222 / 971505122999",
        "email": "info@amanidarwishlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7e92f791-0024-4f89-84eb-1e2d979fd2d2",
    "firmName": "NADIA MOHAMMED ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-05395",
    "licenseIssueDate": "07/06/2022 00:00:00",
    "licenseExpiryDate": "07/05/2026 00:00:00"
  },
  {
    "id": "4932fd89-0785-4514-a465-7ea58a1554bd",
    "slug": "haitham-hawashin",
    "name": "Haitham Hawashin",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBISAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/26/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Haitham Hawashin",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4932fd89-0785-4514-a465-7ea58a1554bd",
        "address": "",
        "phone": "97144363636 / 971505572900",
        "email": "hassan.elsayed@bakerbotts.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "fd5d6571-d053-4436-9de5-c8a36ce7c6c9",
    "firmName": "Baker Botts LLP Legal Consultants Dubai Branch",
    "registrationNumber": "L-01198",
    "licenseIssueDate": "03/26/2014 00:00:00",
    "licenseExpiryDate": "03/19/2026 00:00:00"
  },
  {
    "id": "b8532e5f-5ced-4b4e-aade-cc9fa278b5d5",
    "slug": "haitham-nabeel-mohad-said-elhersh",
    "name": "Haitham Nabeel Mohad Said Elhersh",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/06/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Haitham Nabeel Mohad Said Elhersh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b8532e5f-5ced-4b4e-aade-cc9fa278b5d5",
        "address": "Hamad Abdul wahab alqawadi ,الطابق العاشر / مكتب 1002 ,فندق ذا اتش  ,المركز التجاري  ,00000 ,Dubai",
        "phone": "97145681225",
        "email": "alhamad_advo@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "f2476874-d6f1-491d-857f-df0917f9997a",
    "firmName": "ALHAMAD ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05377",
    "licenseIssueDate": "07/06/2022 00:00:00",
    "licenseExpiryDate": "07/05/2026 00:00:00"
  },
  {
    "id": "fd420af0-6f0b-45d9-a717-de394a6a5623",
    "slug": "hajar-qotb",
    "name": "Hajar Qotb",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIUQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/23/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hajar Qotb",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fd420af0-6f0b-45d9-a717-de394a6a5623",
        "address": "",
        "phone": "97143184600 / 971504468184",
        "email": "melaraby@gibsondunn.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c9d2c9d0-6e43-4253-a75d-cdeb400f8d8e",
    "firmName": "Gibson Dunn & Crutcher LLP",
    "registrationNumber": "L-06753",
    "licenseIssueDate": "04/23/2025 00:00:00",
    "licenseExpiryDate": "04/22/2026 00:00:00"
  },
  {
    "id": "44a20e8c-9eab-4478-9636-c07b3d655ee5",
    "slug": "hajer-el-moumni",
    "name": "Hajer El Moumni",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/29/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hajer El Moumni",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_44a20e8c-9eab-4478-9636-c07b3d655ee5",
        "address": "ICD-Brookfield Place ,DIFC ,119974 ,",
        "phone": "97143652000",
        "email": "david.charlier@ashurst.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c01c3c61-4d90-4058-8429-61dd01e615f5",
    "firmName": "Ashurst LLP-DIFC",
    "registrationNumber": "L-06119",
    "licenseIssueDate": "11/29/2023 00:00:00",
    "licenseExpiryDate": "11/28/2025 00:00:00"
  },
  {
    "id": "190f0fac-ed1d-4cda-a742-3cfc8cac0fac",
    "slug": "hala-abdul-ghani",
    "name": "Hala Abdul Ghani",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/14/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hala Abdul Ghani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_190f0fac-ed1d-4cda-a742-3cfc8cac0fac",
        "address": "THE OFFICES 1 ,DWTC ,115580 ,",
        "phone": "97143739700 / 971501148248",
        "email": "nitesh.pradhan@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "361fdc64-6b6f-4f37-abca-c52af8473b84",
    "firmName": "Pinsent Masons  LLP (DWTCA Branch)",
    "registrationNumber": "L-06672",
    "licenseIssueDate": "02/14/2025 00:00:00",
    "licenseExpiryDate": "02/13/2026 00:00:00"
  },
  {
    "id": "6dd32daf-9b42-40e3-9ed7-937cac2cc7c6",
    "slug": "hala-harb",
    "name": "hala harb",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBISAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/04/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: hala harb",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6dd32daf-9b42-40e3-9ed7-937cac2cc7c6",
        "address": "",
        "phone": "97143685555",
        "email": "maisa.maarouf@bsabh.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8afa232f-52ff-4dad-82c3-9a04d66eb853",
    "firmName": "B S A AHMED BIN HAZEEM & ASSOCIATES LLP - DIFC",
    "registrationNumber": "L-04514",
    "licenseIssueDate": "02/04/2022 00:00:00",
    "licenseExpiryDate": "02/03/2026 00:00:00"
  },
  {
    "id": "0df2fed5-0704-454e-924c-5d1c9f270b8b",
    "slug": "haleema-wahid",
    "name": "Haleema Wahid",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/28/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Haleema Wahid",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0df2fed5-0704-454e-924c-5d1c9f270b8b",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-04639",
    "licenseIssueDate": "08/28/2025 00:00:00",
    "licenseExpiryDate": "08/27/2026 00:00:00"
  },
  {
    "id": "be76d5bc-a50d-4b38-9f80-bfe3e7eacacd",
    "slug": "halim-ibrahim-elnadi-mohamed",
    "name": "halim ibrahim elnadi mohamed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBISQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/03/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: halim ibrahim elnadi mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_be76d5bc-a50d-4b38-9f80-bfe3e7eacacd",
        "address": "eman hassn  ,37 ,latifa tower ,dubai islamic bank ,384980 ,Dubai",
        "phone": "97142953088 / 971567779905",
        "email": "eman.advocates@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "24e2b72a-28d1-4d8f-aac7-c7d8ff2061f4",
    "firmName": "EMAN AL ALI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04498",
    "licenseIssueDate": "10/03/2019 00:00:00",
    "licenseExpiryDate": "10/02/2026 00:00:00"
  },
  {
    "id": "a7890245-3f89-4207-a329-75dd129811bd",
    "slug": "halim-kanaan",
    "name": "Halim Kanaan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBISwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/26/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Halim Kanaan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a7890245-3f89-4207-a329-75dd129811bd",
        "address": "Samir Kanaan ,Office 502 Floor 5 ,Bay Square Building 11 ,South Ridge Apartments ,101 ,Dubai",
        "phone": "97142775444",
        "email": "info@kanlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d0e51371-a813-49c7-a99e-641fda6bca77",
    "firmName": "KANAAN ADVOCATES& LEGAL CONSULTANTS",
    "registrationNumber": "L-01481",
    "licenseIssueDate": "02/26/2013 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "9cc5cf93-464e-4404-a233-3340fd185947",
    "slug": "halima-marjaan-ansari",
    "name": "Halima Marjaan Ansari",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/26/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Halima Marjaan Ansari",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9cc5cf93-464e-4404-a233-3340fd185947",
        "address": "Level 17, ICD Brookfield Place ,DIFC ,506503 ,",
        "phone": "97144375100 / 971588271196",
        "email": "libby.edwards-smith@gowlingwlg.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "436703ba-b9c0-4dcb-93b2-1299c7a051f4",
    "firmName": "Gowling WLG (UK) LLP (Dubai Branch)",
    "registrationNumber": "L-06399",
    "licenseIssueDate": "06/26/2024 00:00:00",
    "licenseExpiryDate": "06/25/2026 00:00:00"
  },
  {
    "id": "72ae8882-bb72-4c52-8e5a-2f9e7d11ff6b",
    "slug": "hamad-abdullah",
    "name": "Hamad  Abdullah",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hamad  Abdullah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_72ae8882-bb72-4c52-8e5a-2f9e7d11ff6b",
        "address": "",
        "phone": "97143098000 / 971552210883",
        "email": "belturk@rouse.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9df4d4e5-5243-4fae-8d95-463d110ce6a8",
    "firmName": "Rouse & Co International Limited (Dubai Branch)",
    "registrationNumber": "L-00470",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "215a02e7-e25d-4df6-be98-88d8653a8a97",
    "slug": "hamad-adeeb-mohamed-yasin",
    "name": "Hamad Adeeb Mohamed Yasin",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/19/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hamad Adeeb Mohamed Yasin",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_215a02e7-e25d-4df6-be98-88d8653a8a97",
        "address": "",
        "phone": "97144020800 / 971566830829",
        "email": "dean.ryburn@dentons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dfe13b7e-6625-45fd-ad63-9ee83af41194",
    "firmName": "Dentons & Co Dubai Branch-DED",
    "registrationNumber": "L-06724",
    "licenseIssueDate": "03/19/2025 00:00:00",
    "licenseExpiryDate": "03/18/2026 00:00:00"
  },
  {
    "id": "dd01018c-7d16-44f3-9e09-2254cb5baddf",
    "slug": "hamada-mohamed-abouelinin",
    "name": "Hamada Mohamed Abouelinin",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hamada Mohamed Abouelinin",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dd01018c-7d16-44f3-9e09-2254cb5baddf",
        "address": "samer tohme ,4th- office 433 ,Emarat Atrium ,Dubai Canal ,79436 ,Dubai",
        "phone": "97126722500",
        "email": "info@dxblawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "00b6334f-44e7-458e-8ce5-7d4256840067",
    "firmName": "MOHAMED ABDULLA LAWYERS AND LEGAL CONSULTANTS",
    "registrationNumber": "L-01479",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "734f35ab-415e-4e40-bf96-a3a4b45773eb",
    "slug": "hamdi-dawod",
    "name": "Hamdi Dawod",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/12/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hamdi Dawod",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_734f35ab-415e-4e40-bf96-a3a4b45773eb",
        "address": "Mezzanine / 09 ,Business Point  ,Behind Nissan Showroom ,85825 ,Dubai",
        "phone": "97142595777",
        "email": "ALMATROOSHI@OMALC.AE",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "588c9e2f-4f09-44bb-9e80-4e56d3f821b6",
    "firmName": "ALOWAIS & AL MATROOSHI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-03223",
    "licenseIssueDate": "12/12/2015 00:00:00",
    "licenseExpiryDate": "12/07/2025 00:00:00"
  },
  {
    "id": "94ebd2fb-0354-40a6-a4be-591bae9e6c54",
    "slug": "hamdy-abdelwanis-abdelghany-elfar",
    "name": "Hamdy Abdelwanis Abdelghany Elfar",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/25/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hamdy Abdelwanis Abdelghany Elfar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_94ebd2fb-0354-40a6-a4be-591bae9e6c54",
        "address": "",
        "phone": "97143348481",
        "email": "lawyers@maidor.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a48d1666-6ca7-461a-8197-a892ef0f3545",
    "firmName": "AL MAIDOOR ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03939",
    "licenseIssueDate": "12/25/2017 00:00:00",
    "licenseExpiryDate": "12/22/2025 00:00:00"
  },
  {
    "id": "4e785331-0887-481f-aad6-bd78e35bcb4d",
    "slug": "hamed-afzal",
    "name": "Hamed Afzal",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/15/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hamed Afzal",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4e785331-0887-481f-aad6-bd78e35bcb4d",
        "address": "ICD Brookfield Place ,Za'abeel 2 ,103747 ,",
        "phone": "97143696300 / 971506008159",
        "email": "mohammed.paracha@nortonrosefulbright.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c4aaee93-0ec4-4982-9a48-a23699492056",
    "firmName": "Norton Rose Fullbright (Middle East) LLP",
    "registrationNumber": "L-03173",
    "licenseIssueDate": "09/15/2015 00:00:00",
    "licenseExpiryDate": "09/10/2026 00:00:00"
  },
  {
    "id": "dec557fe-4e0e-4b25-9fbd-be3835df3046",
    "slug": "hamed-mohamed-elgamili",
    "name": "Hamed Mohamed Elgamili",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hamed Mohamed Elgamili",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dec557fe-4e0e-4b25-9fbd-be3835df3046",
        "address": "Noushad kn ,1 ,sama tower ,Chello Restaurant  ,87706 ,Dubai",
        "phone": "97142822744",
        "email": "info@hosanilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c063023c-8d6f-4566-8537-31e0c9977c77",
    "firmName": "AL HOSANY ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-01204",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "637963f0-e4ff-46ef-9a52-7bfa37cc4454",
    "slug": "hamish-gordon-smylie",
    "name": "HAMISH GORDON SMYLIE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/31/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: HAMISH GORDON SMYLIE",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_637963f0-e4ff-46ef-9a52-7bfa37cc4454",
        "address": "",
        "phone": "97143438897 / 971507753952",
        "email": "jdavidson@davidson-legal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d0200f27-9504-4653-a5c6-05e4bcab7ff0",
    "firmName": "Davidson & Co Legal Consultants",
    "registrationNumber": "L-06361",
    "licenseIssueDate": "05/31/2024 00:00:00",
    "licenseExpiryDate": "05/30/2026 00:00:00"
  },
  {
    "id": "7dfe0b75-2fe1-4517-b341-9dbd9b99b247",
    "slug": "hamza-rami-ahmad",
    "name": "Hamza Rami Ahmad",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/01/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hamza Rami Ahmad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7dfe0b75-2fe1-4517-b341-9dbd9b99b247",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-05353",
    "licenseIssueDate": "06/01/2022 00:00:00",
    "licenseExpiryDate": "05/31/2026 00:00:00"
  },
  {
    "id": "c516faf5-4645-47af-b18c-c5f26afc41db",
    "slug": "hamzah-abu-hassan",
    "name": "Hamzah Abu-Hassan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/18/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hamzah Abu-Hassan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c516faf5-4645-47af-b18c-c5f26afc41db",
        "address": "",
        "phone": "97143641686 / 971506288801",
        "email": "b.kadir@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0ba96df8-e4cc-49c2-8ae4-a42878d95926",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS LLC",
    "registrationNumber": "L-03405",
    "licenseIssueDate": "07/18/2016 00:00:00",
    "licenseExpiryDate": "07/14/2026 00:00:00"
  },
  {
    "id": "3843b06b-4e34-49fc-b60d-018d00f4ea3f",
    "slug": "hamzeh-al-rasheed",
    "name": "Hamzeh Al Rasheed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/15/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hamzeh Al Rasheed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3843b06b-4e34-49fc-b60d-018d00f4ea3f",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-03095",
    "licenseIssueDate": "09/15/2015 00:00:00",
    "licenseExpiryDate": "09/10/2026 00:00:00"
  },
  {
    "id": "ae0bf806-02d0-4efb-98a9-f824988016c0",
    "slug": "hanan-al-bashir",
    "name": "HANAN AL BASHIR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/07/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: HANAN AL BASHIR",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ae0bf806-02d0-4efb-98a9-f824988016c0",
        "address": "",
        "phone": "97143897000 / 971506553198",
        "email": "nasseralikhasawneh@eversheds-sutherland.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "74a21d43-41d8-480a-a6af-6939b7c98a95",
    "firmName": "Eversheds Sutherland (International LLP) Dubai Branch",
    "registrationNumber": "L-06768",
    "licenseIssueDate": "05/07/2025 00:00:00",
    "licenseExpiryDate": "05/06/2026 00:00:00"
  },
  {
    "id": "e351147c-f8ff-43f3-a7f8-08528452a325",
    "slug": "hanan-mohammed-ahmed-al-qennah",
    "name": "Hanan Mohammed Ahmed Al Qennah",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/01/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hanan Mohammed Ahmed Al Qennah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e351147c-f8ff-43f3-a7f8-08528452a325",
        "address": "HAMDAN ALSHAMSI ,الطابق الرابع مكتب 401, 406,407 ,بي سكوير 01 ,مجمع دبي سكوير ,116564 ,Dubai",
        "phone": "97143469262",
        "email": "courts@has.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de2c61a6-9d00-457e-ad1d-e73e4e62d9bd",
    "firmName": "HAMDAN ALSHAMSI LAWYER & LEGAL CONSULTANTS",
    "registrationNumber": "L-06979",
    "licenseIssueDate": "09/25/2025 00:00:00",
    "licenseExpiryDate": "09/24/2026 00:00:00"
  },
  {
    "id": "9c7467ad-8b2a-4d86-ab3c-67c6791464d1",
    "slug": "hang-fong-lo",
    "name": "Hang Fong Lo",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/30/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hang Fong Lo",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9c7467ad-8b2a-4d86-ab3c-67c6791464d1",
        "address": "",
        "phone": "97143553146 / 971506240472",
        "email": "ct@trenchlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4a6253d9-d6c0-479e-81a8-dcfe44ef60fa",
    "firmName": "Trench & Associates DMCC",
    "registrationNumber": "L-06750",
    "licenseIssueDate": "04/30/2025 00:00:00",
    "licenseExpiryDate": "04/29/2026 00:00:00"
  },
  {
    "id": "9e88fb12-7128-4763-9b4a-8eca4839c1c0",
    "slug": "hani-atta-abdelmajid-mansour",
    "name": "Hani Atta Abdelmajid Mansour",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/17/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hani Atta Abdelmajid Mansour",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9e88fb12-7128-4763-9b4a-8eca4839c1c0",
        "address": "",
        "phone": "97143212555",
        "email": "awigdubai@awiglaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ece8ea60-9ecb-4d8c-aca3-fb73e4e52406",
    "firmName": "AL WASL INTERNATIONAL GROUP - ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01952",
    "licenseIssueDate": "11/17/2011 00:00:00",
    "licenseExpiryDate": "11/08/2025 00:00:00"
  },
  {
    "id": "c529327f-ed4c-4ce1-b8c0-d0dd8cf18033",
    "slug": "hani-mohamed-hafez",
    "name": "Hani Mohamed Hafez",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hani Mohamed Hafez",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c529327f-ed4c-4ce1-b8c0-d0dd8cf18033",
        "address": "Hussain Ali Al Jaziri ,11 ,City Tower 2 ,Crown Plaza hotel Sheikh Zayed Road ,4253 ,Dubai",
        "phone": "97142626777 / 971529087670",
        "email": "courts@jaflaws.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c58d8654-b428-46b3-abd5-024e4331ee53",
    "firmName": "JAAFAR ALWAN & AL JAZIRI & ASSOCIATES",
    "registrationNumber": "L-01611",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "b6ecb0c7-3ce8-4bb1-b580-f39698949b3a",
    "slug": "hani-naja",
    "name": "Hani Naja",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/04/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hani Naja",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b6ecb0c7-3ce8-4bb1-b580-f39698949b3a",
        "address": "Al Fattan Currency House Tower 2 ,DIFC ,507176 ,",
        "phone": "/ 971552009003",
        "email": "Mohammad.AlRasheed@bakermckenzie.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "acd81e81-dead-4f7c-839e-0f2a57897265",
    "firmName": "Baker & Mckenzie LLP",
    "registrationNumber": "L-05056",
    "licenseIssueDate": "10/04/2021 00:00:00",
    "licenseExpiryDate": "10/03/2026 00:00:00"
  },
  {
    "id": "7c0a488b-07f1-44ac-bd89-050ffd77b716",
    "slug": "hania-mohamed-mostafa-kamal-meshref",
    "name": "Hania Mohamed Mostafa Kamal Meshref",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/10/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hania Mohamed Mostafa Kamal Meshref",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7c0a488b-07f1-44ac-bd89-050ffd77b716",
        "address": "ICD Brookfield Place ,Za'abeel 2 ,103747 ,",
        "phone": "97143696300 / 971506008159",
        "email": "mohammed.paracha@nortonrosefulbright.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c4aaee93-0ec4-4982-9a48-a23699492056",
    "firmName": "Norton Rose Fullbright (Middle East) LLP",
    "registrationNumber": "L-06953",
    "licenseIssueDate": "09/10/2025 00:00:00",
    "licenseExpiryDate": "09/09/2026 00:00:00"
  },
  {
    "id": "15e4c0a8-41d1-409a-890d-b273dd1424b1",
    "slug": "hanie-abdelnaby-amin-tawfik-elsebakhy",
    "name": "hanie abdelnaby amin tawfik elsebakhy",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/08/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: hanie abdelnaby amin tawfik elsebakhy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_15e4c0a8-41d1-409a-890d-b273dd1424b1",
        "address": "1201 ,برج تريو اي بي اي اوفيس  ,فندق نوافتيل ,8812 ,Dubai",
        "phone": "97144222555",
        "email": "lutfilaw2020@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9a3d884b-a443-4037-9eb4-f810c596cf33",
    "firmName": "LUTFI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06990"
  },
  {
    "id": "5c93916c-7d97-49d3-98a9-aeb79da20e67",
    "slug": "hanif-edgar-james-osman",
    "name": "Hanif Edgar James Osman",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/09/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hanif Edgar James Osman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5c93916c-7d97-49d3-98a9-aeb79da20e67",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-05847",
    "licenseIssueDate": "06/09/2023 00:00:00",
    "licenseExpiryDate": "06/08/2026 00:00:00"
  },
  {
    "id": "433f8aab-36c8-4252-8d59-c35edb07f77c",
    "slug": "hanna-chalhoub",
    "name": "Hanna Chalhoub",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/01/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hanna Chalhoub",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_433f8aab-36c8-4252-8d59-c35edb07f77c",
        "address": "",
        "phone": "97143184600 / 971504468184",
        "email": "melaraby@gibsondunn.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c9d2c9d0-6e43-4253-a75d-cdeb400f8d8e",
    "firmName": "Gibson Dunn & Crutcher LLP",
    "registrationNumber": "L-00846",
    "licenseIssueDate": "10/01/2015 00:00:00",
    "licenseExpiryDate": "09/26/2026 00:00:00"
  },
  {
    "id": "8a7b6bf2-dd1b-4d00-8c57-2076d7c25075",
    "slug": "hanna-karin-linnea-uhlin",
    "name": "Hanna Karin Linnea Uhlin",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBISwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/10/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hanna Karin Linnea Uhlin",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8a7b6bf2-dd1b-4d00-8c57-2076d7c25075",
        "address": "",
        "phone": "97143742800 / 971506450677",
        "email": "jabbott21@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7a59d310-ff72-4318-b41c-27095c163d0f",
    "firmName": "CMS (UAE) LLP",
    "registrationNumber": "L-04586"
  },
  {
    "id": "a77f2b02-202c-46eb-aa4d-2d6b4ab33e7f",
    "slug": "hannah-archer",
    "name": "Hannah Archer",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/02/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hannah Archer",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a77f2b02-202c-46eb-aa4d-2d6b4ab33e7f",
        "address": "NA ,Park Lane Tower ,NA ,119974 ,Dubai",
        "phone": "97143652000 / 971504515630",
        "email": "david.charlier@ashurst.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "af016ea4-05d8-4845-9d38-b95de499a172",
    "firmName": "Ashurst LLP Legal Consultants Dubai Branch-DED",
    "registrationNumber": "L-05576",
    "licenseIssueDate": "11/02/2022 00:00:00",
    "licenseExpiryDate": "11/01/2025 00:00:00"
  },
  {
    "id": "ddd2dc25-a050-4104-bd3c-4f9b6fbe208c",
    "slug": "hannah-gohar",
    "name": "Hannah Gohar",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/09/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hannah Gohar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ddd2dc25-a050-4104-bd3c-4f9b6fbe208c",
        "address": "",
        "phone": "97145119777 / 971508184427",
        "email": "richard.davies@bclplaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6c617112-4b98-414c-868a-7d0316427c21",
    "firmName": "Bryan Cave Leighton Paisner LLP",
    "registrationNumber": "L-04714",
    "licenseIssueDate": "07/09/2020 00:00:00",
    "licenseExpiryDate": "07/07/2026 00:00:00"
  },
  {
    "id": "19ea5f60-71ba-4f40-a0e2-6124b11cc3f8",
    "slug": "hannah-kate-braiding-watson",
    "name": "Hannah Kate Braiding-Watson",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBISwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/30/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hannah Kate Braiding-Watson",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_19ea5f60-71ba-4f40-a0e2-6124b11cc3f8",
        "address": "ICD Brookfield Place ,DIFC ,120109 ,",
        "phone": "97143173000 / 971504465229",
        "email": "DubaiLAD@akingump.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9ff29eab-adb8-40f9-ab84-216e01a381e4",
    "firmName": "Akin Gump Strauss Hauer & Feld LLP",
    "registrationNumber": "L-06777",
    "licenseIssueDate": "04/30/2025 00:00:00",
    "licenseExpiryDate": "04/29/2026 00:00:00"
  },
  {
    "id": "d52d14c2-998d-4313-95d2-4500e136e144",
    "slug": "hannah-kate-mcdonald",
    "name": "Hannah Kate McDonald",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBISwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/29/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hannah Kate McDonald",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d52d14c2-998d-4313-95d2-4500e136e144",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-04676",
    "licenseIssueDate": "04/29/2020 00:00:00",
    "licenseExpiryDate": "04/28/2026 00:00:00"
  },
  {
    "id": "28ca6a83-e9d6-44ca-b980-e8a6d8c3e946",
    "slug": "hany-ahmed-elhamrawy",
    "name": "Hany Ahmed Elhamrawy",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/11/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hany Ahmed Elhamrawy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_28ca6a83-e9d6-44ca-b980-e8a6d8c3e946",
        "address": "الميزانين - مكتب رقم 2  ,جسكوم جراند ريزيدنس  ,خلف المستشفي الكندي  ,12923 ,Dubai",
        "phone": "97142224668",
        "email": "aljabriadvocates@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "f44b772a-3149-4fde-85f7-177a97847c52",
    "firmName": "AL JABRI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03348",
    "licenseIssueDate": "05/11/2016 00:00:00",
    "licenseExpiryDate": "05/07/2026 00:00:00"
  },
  {
    "id": "63373f63-2886-4793-a29f-d4ce79631b88",
    "slug": "hany-hassan-ahmed-hassan",
    "name": "HANY HASSAN AHMED HASSAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBISAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/24/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: HANY HASSAN AHMED HASSAN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_63373f63-2886-4793-a29f-d4ce79631b88",
        "address": "Samia Luqman ,2nd floor ,Emarat Atrium Building ,across Holiday Inn Express Safa Park ,7273 ,Dubai",
        "phone": "97143211000",
        "email": "info@alsuwaidi.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0e5c3637-bc12-475c-a6b5-2d9ae84f2b8e",
    "firmName": "AL-SUWAIDI & COMPANY",
    "registrationNumber": "L-06738",
    "licenseIssueDate": "03/24/2025 00:00:00",
    "licenseExpiryDate": "03/23/2026 00:00:00"
  },
  {
    "id": "1dfc451b-52a3-44ff-bcd5-d55297842ab1",
    "slug": "hany-moustafa-el-nashal",
    "name": "Hany Moustafa El Nashal",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/12/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hany Moustafa El Nashal",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1dfc451b-52a3-44ff-bcd5-d55297842ab1",
        "address": "1302/ مكتب 1302 ,فندق الفيرمونت ,محطة مترو المركز التجاري ,33026 ,Dubai",
        "phone": "97143586113",
        "email": "info@ablawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "f04c12ed-cc71-442c-b504-173bbb4d322f",
    "firmName": "AMAL ALSUBAEI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02117",
    "licenseIssueDate": "04/12/2021 00:00:00",
    "licenseExpiryDate": "04/11/2026 00:00:00"
  },
  {
    "id": "49669299-0cba-4abc-8bfb-5fb8dfc6d51c",
    "slug": "hany-nassar",
    "name": "HANY MOHAMED AHMED HASSANEIN NASSAR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/03/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-03-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hany Nassar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_49669299-0cba-4abc-8bfb-5fb8dfc6d51c",
        "address": "",
        "phone": "97148321212",
        "email": "nasser@nmlawyers.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "71709458-e40a-45b3-9319-4c51c18891be",
    "firmName": "NASSER MALALLA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03677",
    "licenseIssueDate": "03/23/2017 00:00:00",
    "licenseExpiryDate": "03/22/2020 00:00:00"
  },
  {
    "id": "3c2ee055-93ac-416d-bbad-c6ff0abb4ba0",
    "slug": "hara-kee",
    "name": "Hara Kee",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBISwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/18/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hara Kee",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3c2ee055-93ac-416d-bbad-c6ff0abb4ba0",
        "address": "20 ,Index Tower West Tower ,DIFC ,507226 ,Dubai",
        "phone": "97142461900 / 971523391604",
        "email": "patrick.gearon@crsblaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e2ac552e-b9a7-450b-a84d-15119e583220",
    "firmName": "Charles Russell Speechlys LLP",
    "registrationNumber": "L-06915",
    "licenseIssueDate": "08/18/2025 00:00:00",
    "licenseExpiryDate": "08/17/2026 00:00:00"
  },
  {
    "id": "5104e577-76be-4fe5-87af-0ac31b81b709",
    "slug": "harald-plewka",
    "name": "Harald Plewka",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/28/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-01-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Harald Plewka",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5104e577-76be-4fe5-87af-0ac31b81b709",
        "address": "",
        "phone": "97144279812 / 971504597319",
        "email": "lyamalova@lylawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dd62d765-3845-4e09-b92b-1ba92c1e27e4",
    "firmName": "HPL Yamalova & Plewka FZCO",
    "registrationNumber": "L-02688",
    "licenseIssueDate": "01/28/2014 00:00:00",
    "licenseExpiryDate": "01/21/2026 00:00:00"
  },
  {
    "id": "b5f57d76-bbc5-4fae-bb44-441a17d0f51d",
    "slug": "harikrishnan-ravindran",
    "name": "Harikrishnan Ravindran",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Harikrishnan Ravindran",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b5f57d76-bbc5-4fae-bb44-441a17d0f51d",
        "address": "1201 ,برج تريو اي بي اي اوفيس  ,فندق نوافتيل ,8812 ,Dubai",
        "phone": "97144222555",
        "email": "lutfilaw2020@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9a3d884b-a443-4037-9eb4-f810c596cf33",
    "firmName": "LUTFI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02176",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "e9a6dff7-6cb9-408d-a4a8-42b4bb40bf3e",
    "slug": "haris-hanif",
    "name": "Haris Hanif",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBISAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Haris Hanif",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e9a6dff7-6cb9-408d-a4a8-42b4bb40bf3e",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-00573",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "143f98ed-b12c-437f-83e1-a8a3c2473ac3",
    "slug": "harjeet-bhatia",
    "name": "Harjeet Bhatia",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Harjeet Bhatia",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_143f98ed-b12c-437f-83e1-a8a3c2473ac3",
        "address": "1201 ,برج تريو اي بي اي اوفيس  ,فندق نوافتيل ,8812 ,Dubai",
        "phone": "97144222555",
        "email": "lutfilaw2020@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9a3d884b-a443-4037-9eb4-f810c596cf33",
    "firmName": "LUTFI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02177",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "e0f95d9a-a55b-41e8-8fb2-9260d47e3dd0",
    "slug": "harkeerat-wilson",
    "name": "Harkeerat Wilson",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/21/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Harkeerat Wilson",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e0f95d9a-a55b-41e8-8fb2-9260d47e3dd0",
        "address": "",
        "phone": "97143742800 / 971506450677",
        "email": "jabbott21@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7a59d310-ff72-4318-b41c-27095c163d0f",
    "firmName": "CMS (UAE) LLP",
    "registrationNumber": "L-00411",
    "licenseIssueDate": "09/21/2015 00:00:00",
    "licenseExpiryDate": "09/16/2026 00:00:00"
  },
  {
    "id": "65349b36-1a4d-4eff-8660-b55ef2c7b4c9",
    "slug": "harriet-lucy-mclaughlin-fong",
    "name": "Harriet Lucy McLaughlin Fong",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/28/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Harriet Lucy McLaughlin Fong",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_65349b36-1a4d-4eff-8660-b55ef2c7b4c9",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-04642",
    "licenseIssueDate": "04/28/2020 00:00:00",
    "licenseExpiryDate": "04/27/2026 00:00:00"
  },
  {
    "id": "e569373f-aca5-49d8-8e9d-39b686e94b1f",
    "slug": "harry-michael-england-jr",
    "name": "Harry Michael England Jr",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/26/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Harry Michael England Jr",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e569373f-aca5-49d8-8e9d-39b686e94b1f",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-04988",
    "licenseIssueDate": "07/26/2021 00:00:00",
    "licenseExpiryDate": "07/25/2026 00:00:00"
  },
  {
    "id": "e354fd89-6af4-4b17-b684-cc7fe17e55f2",
    "slug": "harsha-krishnakumar",
    "name": "Harsha Krishnakumar",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBISwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/08/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Harsha Krishnakumar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e354fd89-6af4-4b17-b684-cc7fe17e55f2",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-06305",
    "licenseIssueDate": "05/08/2024 00:00:00",
    "licenseExpiryDate": "05/07/2026 00:00:00"
  },
  {
    "id": "98bab7ce-1348-467e-b884-9883c90c8e4a",
    "slug": "harsimranjit-singh",
    "name": "Harsimranjit Singh",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/03/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Harsimranjit Singh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_98bab7ce-1348-467e-b884-9883c90c8e4a",
        "address": "",
        "phone": "97144020800 / 971566830829",
        "email": "dean.ryburn@dentons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dfe13b7e-6625-45fd-ad63-9ee83af41194",
    "firmName": "Dentons & Co Dubai Branch-DED",
    "registrationNumber": "L-06949",
    "licenseIssueDate": "08/26/2025 00:00:00",
    "licenseExpiryDate": "08/25/2026 00:00:00"
  },
  {
    "id": "bfb521bf-a2f6-4cb0-ab42-cae0e165b75a",
    "slug": "hasan-mahmood-mansoor-mohamed-hasan-alkoofi",
    "name": "Hasan Mahmood Mansoor Mohamed Hasan Alkoofi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/12/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hasan Mahmood Mansoor Mohamed Hasan Alkoofi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bfb521bf-a2f6-4cb0-ab42-cae0e165b75a",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506688 ,Dubai",
        "phone": "97147096600 / 971503556811",
        "email": "muneer.khan@simmons-simmons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d1725ca7-06ac-41b2-8d7b-a6e60665b73d",
    "firmName": "Simmons & Simmons (Middle East) LLP-DIFC",
    "registrationNumber": "L-05889",
    "licenseIssueDate": "07/12/2023 00:00:00",
    "licenseExpiryDate": "07/11/2026 00:00:00"
  },
  {
    "id": "bb335173-22da-4f8c-afd5-67728de51734",
    "slug": "hasan-mohammed-abdelhakeem-elshafiey",
    "name": "HASAN MOHAMMED ABDELHAKEEM ELSHAFIEY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/12/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hasan Mohammed Abdelhakeem Elshafiey",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bb335173-22da-4f8c-afd5-67728de51734",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "GALADARI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04797",
    "licenseIssueDate": "11/12/2020 00:00:00",
    "licenseExpiryDate": "11/11/2025 00:00:00"
  },
  {
    "id": "839c997c-6384-4ebb-b7b5-b3a7df31b606",
    "slug": "hasanali-pirbhai",
    "name": "Hasanali Pirbhai",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/21/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hasanali Pirbhai",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_839c997c-6384-4ebb-b7b5-b3a7df31b606",
        "address": "ICD Brookfield Place ,Za'abeel 2 ,103747 ,",
        "phone": "97143696300 / 971506008159",
        "email": "mohammed.paracha@nortonrosefulbright.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c4aaee93-0ec4-4982-9a48-a23699492056",
    "firmName": "Norton Rose Fullbright (Middle East) LLP",
    "registrationNumber": "L-05518",
    "licenseIssueDate": "09/21/2022 00:00:00",
    "licenseExpiryDate": "09/20/2026 00:00:00"
  },
  {
    "id": "175c96ca-3653-44bd-ae7c-a94f3a3f3b4a",
    "slug": "hashem-mohammed-sulaiman-al-ahdal",
    "name": "Hashem Mohammed Sulaiman Al-Ahdal",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/22/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hashem Mohammed Sulaiman Al-Ahdal",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_175c96ca-3653-44bd-ae7c-a94f3a3f3b4a",
        "address": "",
        "phone": "97143685555",
        "email": "maisa.maarouf@bsabh.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8afa232f-52ff-4dad-82c3-9a04d66eb853",
    "firmName": "B S A AHMED BIN HAZEEM & ASSOCIATES LLP - DIFC",
    "registrationNumber": "L-05260",
    "licenseIssueDate": "03/22/2022 00:00:00",
    "licenseExpiryDate": "03/21/2026 00:00:00"
  },
  {
    "id": "0b4e076b-0936-4ac1-9b59-466ba4af4ab4",
    "slug": "hassan-abbas-talib-shaban-salman",
    "name": "Hassan Abbas Talib Shaban Salman",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/13/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hassan Abbas Talib Shaban Salman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0b4e076b-0936-4ac1-9b59-466ba4af4ab4",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-06502",
    "licenseIssueDate": "09/13/2024 00:00:00",
    "licenseExpiryDate": "09/12/2026 00:00:00"
  },
  {
    "id": "1c497dd4-a216-4d19-a658-3755bcd18486",
    "slug": "hassan-abdalla-hassan-mohamed",
    "name": "HASSAN ABDALLA HASSAN MOHAMED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/17/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: HASSAN ABDALLA HASSAN MOHAMED",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1c497dd4-a216-4d19-a658-3755bcd18486",
        "address": "",
        "phone": "/ 971556915188",
        "email": "hassan.a.m.89@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "ecf18fcb-ce6b-40ab-8725-6734f867bcde",
    "firmName": "Dr. Hassan Abdalla Legal Consultancy",
    "registrationNumber": "L-06870",
    "licenseIssueDate": "06/17/2025 00:00:00",
    "licenseExpiryDate": "06/16/2026 00:00:00"
  },
  {
    "id": "45015b07-1d69-45cf-a4fd-4b5a467a8128",
    "slug": "hassan-abdellatif-elwardany-abdellatif",
    "name": "Hassan Abdellatif Elwardany Abdellatif",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/17/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hassan Abdellatif Elwardany Abdellatif",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_45015b07-1d69-45cf-a4fd-4b5a467a8128",
        "address": "جائزة الشيخ حمدان ,مبانى الحضيبة للجوائز - البلوك ب - الطابق السادس ,متحف الضيافة ,26596 ,Dubai",
        "phone": "97143889770",
        "email": "hamdamakkiadvocates@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "aaee8e41-be83-4596-99e8-716e84e93e28",
    "firmName": "HAMDA MAKKI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02464",
    "licenseIssueDate": "09/17/2013 00:00:00",
    "licenseExpiryDate": "09/10/2026 00:00:00"
  },
  {
    "id": "1b56c227-156b-4099-b4e2-002150210e65",
    "slug": "hassan-abdeltawwab-hassan",
    "name": "Hassan Abdeltawwab Hassan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hassan Abdeltawwab Hassan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1b56c227-156b-4099-b4e2-002150210e65",
        "address": "amal albastaki ,1903 ,court ,business bay ,127477 ,Dubai",
        "phone": "97142522202",
        "email": "info@amaladvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "f852bccd-2696-4190-9b40-77a8fb9c460f",
    "firmName": "AMAL ALBASTAKI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-02046",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "bbce815a-606f-47a8-ad95-94981581d5dc",
    "slug": "hassan-ahmed-hassan-mohamed-assran",
    "name": "hassan ahmed hassan mohamed assran",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/21/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: hassan ahmed hassan mohamed assran",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bbce815a-606f-47a8-ad95-94981581d5dc",
        "address": "engy nabeel ,609 ,Business Avenue Building ,خلف معرض نيسان للسيارات ,114332 ,Dubai",
        "phone": "97142666983 / 971505049385",
        "email": "mtgdubai@mtglegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2c10c414-70fa-4a29-b8ce-a320239738ad",
    "firmName": "ENGY NABEEL ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05674",
    "licenseIssueDate": "12/21/2022 00:00:00",
    "licenseExpiryDate": "12/20/2025 00:00:00"
  },
  {
    "id": "b91d1624-e821-4f8d-9898-1a5357754ddf",
    "slug": "hassan-attia-hemdan",
    "name": "Hassan Attia Hemdan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/16/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hassan Attia Hemdan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b91d1624-e821-4f8d-9898-1a5357754ddf",
        "address": "Alhajeya salem saeed alnoobi ,3rd  ,Al-hawai Tower  ,Behind financial center metro station  ,39779 ,Dubai",
        "phone": "97142963813",
        "email": "adv_aljazeera@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "f091b928-9e3d-4e24-b489-65ca31481366",
    "firmName": "AL HAJEYA ALNOOBI ADVOCATES AND LEGAL CONSULTANT",
    "registrationNumber": "L-01994",
    "licenseIssueDate": "11/16/2011 00:00:00",
    "licenseExpiryDate": "11/07/2025 00:00:00"
  },
  {
    "id": "c27ff692-9b19-4548-b3e3-265a247e19ae",
    "slug": "hassan-elhais",
    "name": "Hassan Elhais",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hassan Elhais",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c27ff692-9b19-4548-b3e3-265a247e19ae",
        "address": "29 ,ذا اتش هوتيل ,فندق فيرمونت ,40073 ,Dubai",
        "phone": "97143254000",
        "email": "info@alrowaad.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "759f5477-fdbd-406b-8831-354639c31036",
    "firmName": "AWATIF MOHAMMAD SHOQI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-01352",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "60e9b0f8-c5f0-4402-8649-2a4c9e5bf0ea",
    "slug": "hassan-elsaid-abdelal-ali",
    "name": "hassan elsaid abdelal ali",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/11/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: hassan elsaid abdelal ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_60e9b0f8-c5f0-4402-8649-2a4c9e5bf0ea",
        "address": "",
        "phone": "97145642777 / 971508551535",
        "email": "legal@alnajjarlawyer.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "1670d8d1-6114-4b77-b2da-9d4c0dc0054b",
    "firmName": "MOHAMMAD ALNAJJAR ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04831",
    "licenseIssueDate": "02/11/2021 00:00:00",
    "licenseExpiryDate": "02/10/2026 00:00:00"
  },
  {
    "id": "5fa680d2-0ec8-43be-9ee4-0e9b8fe4b411",
    "slug": "hassan-elshahat-zarad",
    "name": "Hassan Elshahat Zarad",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/10/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hassan Elshahat Zarad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5fa680d2-0ec8-43be-9ee4-0e9b8fe4b411",
        "address": "",
        "phone": "97143685555",
        "email": "maisa.maarouf@bsabh.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8afa232f-52ff-4dad-82c3-9a04d66eb853",
    "firmName": "B S A AHMED BIN HAZEEM & ASSOCIATES LLP - DIFC",
    "registrationNumber": "L-02681",
    "licenseIssueDate": "11/10/2014 00:00:00",
    "licenseExpiryDate": "11/04/2025 00:00:00"
  },
  {
    "id": "f6d34bb9-5ec6-48af-9863-79fc3d814d56",
    "slug": "hassan-ibrahim-hassan-ibrahim",
    "name": "Hassan Ibrahim hassan Ibrahim",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBISQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/10/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hassan Ibrahim hassan Ibrahim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f6d34bb9-5ec6-48af-9863-79fc3d814d56",
        "address": "",
        "phone": "97142594601",
        "email": "info@almazmilawfirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6d921a3f-66d8-409c-82d0-47ea77e53617",
    "firmName": "AHMED HASSAN ALMAAZMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01845",
    "licenseIssueDate": "02/10/2013 00:00:00",
    "licenseExpiryDate": "02/02/2026 00:00:00"
  },
  {
    "id": "ec4f73df-d999-4fe1-9880-abf77a04ce0e",
    "slug": "hassan-mer-ghani-salih",
    "name": "Hassan Mer Ghani Salih",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hassan Mer Ghani Salih",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ec4f73df-d999-4fe1-9880-abf77a04ce0e",
        "address": "Mohamed Thamer Yaqub Yousef Alserkal ,الطابق الثاني ,اعمار سكوير - بناء رقم 4 ,برج خليفة ,57409 ,Dubai",
        "phone": "97142622217 / 97142622217",
        "email": "mohamed@alserkallawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2a224392-a975-448f-aec5-0460984b1124",
    "firmName": "MOHAMED ALSERKAL ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02577",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "7da41f35-af78-4950-8104-d12e17d98261",
    "slug": "hassan-mohamed-mahmoud-abbas",
    "name": "Hassan Mohamed Mahmoud Abbas",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-02-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hassan Mohamed Mahmoud Abbas",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7da41f35-af78-4950-8104-d12e17d98261",
        "address": "Jane Naoe Elsayed ,Level No. 22 – Office No. (2201 – 2202) ,Concord Tower ,Media City ,99779 ,Dubai",
        "phone": "97143575999",
        "email": "info@binarab.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a718961d-c976-4a3c-bd09-585ec7c81310",
    "firmName": "RASHED BIN ARAB ADVOCATE AND LEGAL CONSULTANTS",
    "registrationNumber": "L-01562",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/23/2018 00:00:00"
  },
  {
    "id": "77923c02-4e78-463f-a4df-eb6971b1c755",
    "slug": "hassan-mohamed-mahmoud-abdelnabi",
    "name": "Hassan Mohamed Mahmoud Abdelnabi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/21/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hassan Mohamed Mahmoud Abdelnabi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_77923c02-4e78-463f-a4df-eb6971b1c755",
        "address": "الثاني 201 ,مركز البخيت ,بالقرب من مركز القبائل للتخفيضات ,12020 ,Dubai",
        "phone": "97142664411",
        "email": "redhalaw@eim.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ba85e0f4-24ae-4065-9d96-7392f96f75fe",
    "firmName": "AL REDHA & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06834",
    "licenseIssueDate": "05/21/2025 00:00:00",
    "licenseExpiryDate": "05/20/2026 00:00:00"
  },
  {
    "id": "812330a7-76c2-4f0f-918b-8964bed52ea5",
    "slug": "hassan-mohamed-mohamed-elagawany",
    "name": "hassan mohamed mohamed elagawany",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/04/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: hassan mohamed mohamed elagawany",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_812330a7-76c2-4f0f-918b-8964bed52ea5",
        "address": "",
        "phone": "97143685555",
        "email": "maisa.maarouf@bsabh.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8afa232f-52ff-4dad-82c3-9a04d66eb853",
    "firmName": "B S A AHMED BIN HAZEEM & ASSOCIATES LLP - DIFC",
    "registrationNumber": "L-04624",
    "licenseIssueDate": "03/04/2020 00:00:00",
    "licenseExpiryDate": "03/03/2026 00:00:00"
  },
  {
    "id": "ee6bbb6a-d509-449d-bcb5-2fc1ceb0fe20",
    "slug": "hassan-mohamed-soliman-ibrahim",
    "name": "Hassan Mohamed Soliman Ibrahim",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/05/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hassan Mohamed Soliman Ibrahim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ee6bbb6a-d509-449d-bcb5-2fc1ceb0fe20",
        "address": "",
        "phone": "97145786050 / 971509711102",
        "email": "info@emirates.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "676fafb7-1ca5-46d2-943e-39c211542422",
    "firmName": "RAYA AL AMERI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04833",
    "licenseIssueDate": "01/05/2021 00:00:00",
    "licenseExpiryDate": "01/04/2026 00:00:00"
  },
  {
    "id": "970f02dc-248b-4b42-9064-11057343caa4",
    "slug": "hassan-morshedy-mohamed-awed",
    "name": "Hassan Morshedy Mohamed Awed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/11/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hassan Morshedy Mohamed Awed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_970f02dc-248b-4b42-9064-11057343caa4",
        "address": "",
        "phone": "/ 971500000000",
        "email": "morshedy.legal@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9ae432c2-4110-4a73-9ff7-f5f33baaef76",
    "firmName": "MOHAMMED YOUSUF ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04846",
    "licenseIssueDate": "02/11/2021 00:00:00",
    "licenseExpiryDate": "02/10/2026 00:00:00"
  },
  {
    "id": "69b8a5b8-73e8-4c47-8c45-9bc87fccbc59",
    "slug": "hassan-mostafa-elsayed",
    "name": "Hassan Mostafa Elsayed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hassan Mostafa Elsayed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_69b8a5b8-73e8-4c47-8c45-9bc87fccbc59",
        "address": "",
        "phone": "97144363636 / 971505572900",
        "email": "hassan.elsayed@bakerbotts.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "fd5d6571-d053-4436-9de5-c8a36ce7c6c9",
    "firmName": "Baker Botts LLP Legal Consultants Dubai Branch",
    "registrationNumber": "L-00733",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "82a1b6d9-bdd7-4bd8-8fe7-64eb3c76aa47",
    "slug": "hassan-mubark-hassan-elsafi",
    "name": "Hassan Mubark Hassan Elsafi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/15/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hassan Mubark Hassan Elsafi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_82a1b6d9-bdd7-4bd8-8fe7-64eb3c76aa47",
        "address": "Hend Humaid Khalifa Bin Hendi Alaleeli  ,2/201 ,ALMIHIRI BLAZA - Al Khabisi , Hyundai Show ROOM  ,000 ,Dubai",
        "phone": "97143999691 / 971000000000",
        "email": "hend.alaleeli@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "17773ca4-24da-4486-9931-d51188bf4d88",
    "firmName": "HEND BIN HENDI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06103",
    "licenseIssueDate": "11/15/2023 00:00:00",
    "licenseExpiryDate": "11/14/2025 00:00:00"
  },
  {
    "id": "cc7f922c-699f-434a-843b-22ef29108508",
    "slug": "hassan-samir-abdalla-ismail-emran",
    "name": "Hassan Samir Abdalla Ismail Emran",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/11/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hassan Samir Abdalla Ismail Emran",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cc7f922c-699f-434a-843b-22ef29108508",
        "address": "O-4801, O-4901 ,Burj al Salam Office Tower ,H Hotel ,111801 ,Dubai",
        "phone": "97143544444",
        "email": "administration@horizlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4e25fb39-6659-44f0-bc8b-3ff0f067beb0",
    "firmName": "HORIZONS & CO - LAW FIRM",
    "registrationNumber": "L-06012",
    "licenseIssueDate": "10/11/2023 00:00:00",
    "licenseExpiryDate": "10/10/2026 00:00:00"
  },
  {
    "id": "50a619e1-b43f-4f5d-9dee-47a8326b065a",
    "slug": "hassan-shamt",
    "name": "Hassan Shamt",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hassan Shamt",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_50a619e1-b43f-4f5d-9dee-47a8326b065a",
        "address": "الطابق الثامن ,بزنس أفنيو ,خلف وكالة نيسان ,444775 ,Dubai",
        "phone": "97142501414",
        "email": "info@halalilaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "37ab9a73-e65f-4829-9402-6eac64c4c621",
    "firmName": "HASSAN AL ALI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-01385",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "d793d504-1f82-4bc0-aa9a-c53fa17845ca",
    "slug": "hatem-mohamed-mohamed-fleifel",
    "name": "Hatem mohamed mohamed fleifel",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/12/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hatem mohamed mohamed fleifel",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d793d504-1f82-4bc0-aa9a-c53fa17845ca",
        "address": "YASIR AL NAQBI ,21 ,48 BURJ ,SOFITEL DOWN  TOWN ,181111 ,Dubai",
        "phone": "97142689949",
        "email": "info@alnaqbipartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ad71430e-83ee-4cb5-a530-bc58db2618f6",
    "firmName": "ALNAQBI & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03514",
    "licenseIssueDate": "09/12/2025 00:00:00",
    "licenseExpiryDate": "09/11/2026 00:00:00"
  },
  {
    "id": "7b79fad7-a8f1-4632-851d-94b9daffeb54",
    "slug": "hatem-mustafa-salem-mustafa",
    "name": "HATEM MUSTAFA SALEM MUSTAFA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/12/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2023-04-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hatem Mustafa Salem Mustafa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7b79fad7-a8f1-4632-851d-94b9daffeb54",
        "address": "18 ,برج السلام ,سما تاور ,68068 ,Dubai",
        "phone": "97143519700 / 971507973939",
        "email": "info@ramadanlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "08cb3f04-3a05-4815-9f28-6aa33c4b63dd",
    "firmName": "AHMED RAMADAN ADVOCATES &LEGAL CONSULTANTS",
    "registrationNumber": "L-01818",
    "licenseIssueDate": "07/12/2012 00:00:00",
    "licenseExpiryDate": "07/04/2023 00:00:00"
  },
  {
    "id": "2da3bd72-efa5-4ba3-ad18-4fc85aaa1faf",
    "slug": "hatim-alzubi",
    "name": "Hatim Alzubi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hatim Alzubi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2da3bd72-efa5-4ba3-ad18-4fc85aaa1faf",
        "address": "Emirates Tower LLC ,Trade Centre 2 Dubai ,487915 ,",
        "phone": "97145548182 / 971559921117",
        "email": "hqzubi@zubipartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "f18ce257-9c27-4dbc-8186-c51fff8ec4f9",
    "firmName": "Al Zubi & Partners Legal Consultants",
    "registrationNumber": "L-01160",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "f1caad06-3373-4aa8-b287-77dc9184822f",
    "slug": "haya-amr-ramadan-al-bawab",
    "name": "Haya Amr Ramadan Al-Bawab",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/22/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Haya Amr Ramadan Al-Bawab",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f1caad06-3373-4aa8-b287-77dc9184822f",
        "address": "Index Tower ,DIFC ,506896 ,",
        "phone": "97142782300 / 971551154791",
        "email": "GLeggate@wfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e2b82cfc-80a5-4957-ae41-b1a7beb693c1",
    "firmName": "Watson, Farley & Williams (Middle East) LLP",
    "registrationNumber": "L-04821",
    "licenseIssueDate": "12/22/2020 00:00:00",
    "licenseExpiryDate": "12/21/2025 00:00:00"
  },
  {
    "id": "42b9f118-460e-440b-a0bb-82840a5d0741",
    "slug": "haya-ayman-yousef-al-barqawi",
    "name": "Haya Ayman Yousef Al Barqawi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/30/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Haya Ayman Yousef Al Barqawi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_42b9f118-460e-440b-a0bb-82840a5d0741",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-06583",
    "licenseIssueDate": "10/30/2024 00:00:00",
    "licenseExpiryDate": "10/29/2026 00:00:00"
  },
  {
    "id": "9ccfd663-9acc-43d9-a2c4-591e43f58e22",
    "slug": "haya-massoud",
    "name": "Haya Massoud",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/08/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Haya Massoud",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9ccfd663-9acc-43d9-a2c4-591e43f58e22",
        "address": "Al Fattan Currency House Tower 2 ,DIFC ,507176 ,",
        "phone": "/ 971552009003",
        "email": "Mohammad.AlRasheed@bakermckenzie.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "acd81e81-dead-4f7c-839e-0f2a57897265",
    "firmName": "Baker & Mckenzie LLP",
    "registrationNumber": "L-03766",
    "licenseIssueDate": "06/08/2017 00:00:00",
    "licenseExpiryDate": "06/05/2026 00:00:00"
  },
  {
    "id": "c98e085f-d5ea-4d38-841f-3ff26c3cbb0e",
    "slug": "haydar-abdelrahman-hassan-abdelrahman",
    "name": "Haydar Abdelrahman Hassan Abdelrahman",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/12/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Haydar Abdelrahman Hassan Abdelrahman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c98e085f-d5ea-4d38-841f-3ff26c3cbb0e",
        "address": "Mohammad Al Mheiri ,الاول ,امارات اتريم  ,شارع الشيخ زايد ,37979 ,Dubai",
        "phone": "97143333405",
        "email": "info@al-mheiri.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "455b5977-b40f-4801-b6bf-70838bb69abe",
    "firmName": "MOHAMMAD ALMEIHRI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02145",
    "licenseIssueDate": "05/12/2012 00:00:00",
    "licenseExpiryDate": "05/04/2026 00:00:00"
  },
  {
    "id": "a6d7f96b-6c7f-4e58-9f1c-dc121dfba5f4",
    "slug": "hayel-fadi-hourani",
    "name": "Hayel Fadi Hourani",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/11/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-02-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hayel Fadi Hourani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a6d7f96b-6c7f-4e58-9f1c-dc121dfba5f4",
        "address": "One Central, The Offices 5 ,Dubai World Trade Centre ,554660 ,",
        "phone": "97142052030 / 971506566494",
        "email": "chourani@houranipartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "59a73632-40a0-4849-b120-4308dc6f8015",
    "firmName": "Hourani & Partners Legal Consultancy FZCO",
    "registrationNumber": "L-01206",
    "licenseIssueDate": "01/11/2012 00:00:00",
    "licenseExpiryDate": "01/02/2026 00:00:00"
  },
  {
    "id": "999729ba-090f-4d37-931a-a2287063952b",
    "slug": "hayfa-assi",
    "name": "HAYFA ASSI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/14/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: HAYFA ASSI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_999729ba-090f-4d37-931a-a2287063952b",
        "address": "Central Park Towers ,507120 ,",
        "phone": "97143200940 / 971502397176",
        "email": "lsahbani@lpalaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4c158c98-1a29-48da-ade1-54e60bfd5b78",
    "firmName": "LPA (Middle East) LTD",
    "registrationNumber": "L-06680",
    "licenseIssueDate": "02/14/2025 00:00:00",
    "licenseExpiryDate": "02/13/2026 00:00:00"
  },
  {
    "id": "8198ae98-e5c6-4e16-8351-b31724d2e73a",
    "slug": "haytham-alieh",
    "name": "Haytham Alieh",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/01/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Haytham Alieh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8198ae98-e5c6-4e16-8351-b31724d2e73a",
        "address": "الطابق 7 مكتب رقم 070A ,برج رولكس  ,محطة مترو المركز المالي  ,66300 ,Dubai",
        "phone": "97143444029",
        "email": "ekp.khalidaltmimi@ekplegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "400838f1-4e75-4836-9698-b9e19dd30a18",
    "firmName": "KHALID ABDALLA ALTAMIMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03731",
    "licenseIssueDate": "03/01/2024 00:00:00",
    "licenseExpiryDate": "02/28/2026 00:00:00"
  },
  {
    "id": "bceb0386-e481-46b6-9e08-22767fb90bb4",
    "slug": "haytham-samir-abdelbaset-mohamed-nassar",
    "name": "HAYTHAM SAMIR ABDELBASET MOHAMED NASSAR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/31/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: HAYTHAM SAMIR ABDELBASET MOHAMED NASSAR",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bceb0386-e481-46b6-9e08-22767fb90bb4",
        "address": "YOUNIS MOHAMMED ALBLOOSHI ,3 - 1 ,the icon ,السيلكون ,117548 ,Dubai",
        "phone": "97145693206 / 971000000000",
        "email": "info@yblooshiadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "27278b02-4edf-490f-9d50-a1bc00678b6a",
    "firmName": "YOUNIS MOHAMMED AL BLOOSHI LAWYER & LEGAL CONSULTANTS",
    "registrationNumber": "L-05483",
    "licenseIssueDate": "08/31/2022 00:00:00",
    "licenseExpiryDate": "08/30/2026 00:00:00"
  },
  {
    "id": "0cac0391-5d71-470a-a95e-12fa6c6ca2ff",
    "slug": "hazel-shakur-quinn",
    "name": "Hazel Shakur Quinn",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/17/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hazel Shakur Quinn",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0cac0391-5d71-470a-a95e-12fa6c6ca2ff",
        "address": "",
        "phone": "97144020800 / 971566830829",
        "email": "dean.ryburn@dentons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dfe13b7e-6625-45fd-ad63-9ee83af41194",
    "firmName": "Dentons & Co Dubai Branch-DED",
    "registrationNumber": "L-06278",
    "licenseIssueDate": "04/17/2024 00:00:00",
    "licenseExpiryDate": "04/16/2026 00:00:00"
  },
  {
    "id": "fd871da8-25eb-46ce-9d6e-c1dc4df54f5c",
    "slug": "hazem-abdelfatah-saad-ahmed-darwish",
    "name": "HAZEM ABDELFATAH SAAD AHMED DARWISH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/08/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: HAZEM ABDELFATAH SAAD AHMED DARWISH",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fd871da8-25eb-46ce-9d6e-c1dc4df54f5c",
        "address": "",
        "phone": "97142500251",
        "email": "hassan.suwaidi@hhslawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "92cddf0e-969b-47c0-a9a7-9fb57a11d292",
    "firmName": "HASSAN HUMAID AL SUWAIDI ADVOCATES AND LEGAL CONSULTANCY",
    "registrationNumber": "L-05226",
    "licenseIssueDate": "03/08/2022 00:00:00",
    "licenseExpiryDate": "03/07/2026 00:00:00"
  },
  {
    "id": "9d2db128-8fb2-490b-8414-83f62b717a7f",
    "slug": "hazem-fathy-elsharma",
    "name": "Hazem Fathy Elsharma",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/21/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hazem Fathy Elsharma",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9d2db128-8fb2-490b-8414-83f62b717a7f",
        "address": "Mohamed Ali Saeed Humaid Al Kheyaili  ,Seventh Floor  ,Al Masaood Tower 2 ,Al Tadawi Medical Centre  ,88314 ,Dubai",
        "phone": "97142989662",
        "email": "info@mkladvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ec23636d-f937-474e-b86d-d7470fbb385b",
    "firmName": "MOHAMED ALKHEYAILI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02747",
    "licenseIssueDate": "04/21/2013 00:00:00",
    "licenseExpiryDate": "04/13/2026 00:00:00"
  },
  {
    "id": "9634a567-d642-4ad6-8a26-eefd252f9add",
    "slug": "hazem-hussein-abdalla-ahmed-abouteyour",
    "name": "Hazem Hussein Abdalla Ahmed Abouteyour",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBISAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/02/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hazem Hussein Abdalla Ahmed Abouteyour",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9634a567-d642-4ad6-8a26-eefd252f9add",
        "address": "B2207 ,لطيفة تاور ,بجانب فندق فوكو دبي‎ ,410889 ,Dubai",
        "phone": "97143447557",
        "email": "info@amirasaqeradvo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d4393464-394a-4311-ac7d-2247c5af8bad",
    "firmName": "AMIRA SAQER ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06439",
    "licenseIssueDate": "08/02/2024 00:00:00",
    "licenseExpiryDate": "08/01/2026 00:00:00"
  },
  {
    "id": "8f91b028-7986-45ee-8c81-caaa13ae43e9",
    "slug": "hazem-mahmoud-abd-rabou",
    "name": "Hazem Mahmoud Abd Rabou",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hazem Mahmoud Abd Rabou",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8f91b028-7986-45ee-8c81-caaa13ae43e9",
        "address": "الطابق 11 - مكتب رقم (1105 ، 1106)  ,برج السلام  ,منطقة المركز التجاري العالمي 1 ,211911 ,Dubai",
        "phone": "97143366769 / 971503636617",
        "email": "info@erlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "fffe1b8f-e9ab-488f-82eb-6151b8f007df",
    "firmName": "EMAN ALRIFAI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01598",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "0fef6a8b-dbcd-4fb5-8876-6658ae01e994",
    "slug": "haziq-arshad",
    "name": "Haziq Arshad",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/10/2023",
    "licenseStatus": "active",
    "licenseExpiry": "2024-10-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Haziq Arshad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0fef6a8b-dbcd-4fb5-8876-6658ae01e994",
        "address": "",
        "phone": "97144020800 / 971566830829",
        "email": "dean.ryburn@dentons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dfe13b7e-6625-45fd-ad63-9ee83af41194",
    "firmName": "Dentons & Co Dubai Branch-DED",
    "registrationNumber": "L-06039",
    "licenseIssueDate": "10/04/2023 00:00:00",
    "licenseExpiryDate": "10/03/2025 00:00:00"
  },
  {
    "id": "bb843877-68ee-4e96-a01c-c54a66cd30cb",
    "slug": "heather-dsilva",
    "name": "Heather D'Silva",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/02/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Heather D'Silva",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bb843877-68ee-4e96-a01c-c54a66cd30cb",
        "address": "",
        "phone": "97104309100 / 971564013758",
        "email": "c.royle@taylorwessing.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d51b6f43-8c62-486f-a1ab-6ee3b87c8006",
    "firmName": "Taylor Wessing LLP (Dubai Branch)",
    "registrationNumber": "L-05903",
    "licenseIssueDate": "08/02/2023 00:00:00",
    "licenseExpiryDate": "08/01/2026 00:00:00"
  },
  {
    "id": "1798e43e-fb0a-4bcd-b3f0-97ef51ea6e1b",
    "slug": "heather-hansen-martin",
    "name": "Heather Hansen Martin",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBISAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/30/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Heather Hansen Martin",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1798e43e-fb0a-4bcd-b3f0-97ef51ea6e1b",
        "address": "",
        "phone": "97147098484 / 971505577206",
        "email": "slshadmand@jonesday.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8892bfe9-d3ec-4158-b4fd-1844606f4f30",
    "firmName": "Jones Day",
    "registrationNumber": "L-05025",
    "licenseIssueDate": "08/30/2021 00:00:00",
    "licenseExpiryDate": "08/29/2026 00:00:00"
  },
  {
    "id": "43468ff1-fc18-44dc-8590-0ee5ac5ac88e",
    "slug": "helen-de-oliveira-carvalho",
    "name": "helen de oliveira carvalho",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/24/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: helen de oliveira carvalho",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_43468ff1-fc18-44dc-8590-0ee5ac5ac88e",
        "address": "",
        "phone": "97143553146 / 971506240472",
        "email": "ct@trenchlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4a6253d9-d6c0-479e-81a8-dcfe44ef60fa",
    "firmName": "Trench & Associates DMCC",
    "registrationNumber": "L-06430",
    "licenseIssueDate": "07/24/2024 00:00:00",
    "licenseExpiryDate": "07/23/2026 00:00:00"
  },
  {
    "id": "0a0773ba-d8f8-44c5-9f86-69f59b919965",
    "slug": "helen-margaret-elmer",
    "name": "Helen Margaret Elmer",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/01/2025",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Helen Margaret Elmer",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0a0773ba-d8f8-44c5-9f86-69f59b919965",
        "address": "",
        "phone": "97143184600 / 971504468184",
        "email": "melaraby@gibsondunn.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c9d2c9d0-6e43-4253-a75d-cdeb400f8d8e",
    "firmName": "Gibson Dunn & Crutcher LLP",
    "registrationNumber": "L-06639",
    "licenseIssueDate": "01/07/2025 00:00:00",
    "licenseExpiryDate": "01/06/2026 00:00:00"
  },
  {
    "id": "9314cdee-7d2e-47c7-afcf-e3ff7dd25df2",
    "slug": "helena-van-nguyen",
    "name": "Helena Van Nguyen",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIVgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/12/2023",
    "licenseStatus": "active",
    "licenseExpiry": "2024-12-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Helena Van Nguyen",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9314cdee-7d2e-47c7-afcf-e3ff7dd25df2",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-06133",
    "licenseIssueDate": "12/06/2023 00:00:00",
    "licenseExpiryDate": "12/05/2025 00:00:00"
  },
  {
    "id": "33b1aacd-782c-4d16-bb5c-7ca6be72c166",
    "slug": "helene-mathieu",
    "name": "Helene Mathieu",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/25/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Helene Mathieu",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_33b1aacd-782c-4d16-bb5c-7ca6be72c166",
        "address": "21 ,Ontario Tower ,Oposite Side Obberoi Hotel ,28845 ,Dubai",
        "phone": "97143644333 / 971506326165",
        "email": "helene@hmlc.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "18561830-7fc4-44dd-8c1a-aeecc61cd63f",
    "firmName": "Helene Mathieu Legal Consultants",
    "registrationNumber": "L-00396",
    "licenseIssueDate": "02/25/2012 00:00:00",
    "licenseExpiryDate": "02/16/2026 00:00:00"
  },
  {
    "id": "61197ae9-cecf-41a1-b591-ec24327d21b4",
    "slug": "heng-li",
    "name": "Heng Li",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/13/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Heng Li",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_61197ae9-cecf-41a1-b591-ec24327d21b4",
        "address": "SULAIMAN ALNAQBI ,5 ,Emaar Business Park 1 ,Emaar Business Park 1 ,0000 ,Dubai",
        "phone": "",
        "email": "hsrgro@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d10fb0e9-ccd7-4ac9-8f58-e21ff0d7d2f2",
    "firmName": "SULAIMAN AL NAQBI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06986"
  },
  {
    "id": "80816b64-14e1-4d75-8a1b-b919582cafce",
    "slug": "henrietta-louise-baker",
    "name": "Henrietta Louise Baker",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/05/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Henrietta Louise Baker",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_80816b64-14e1-4d75-8a1b-b919582cafce",
        "address": "",
        "phone": "97144020800 / 971566830829",
        "email": "dean.ryburn@dentons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dfe13b7e-6625-45fd-ad63-9ee83af41194",
    "firmName": "Dentons & Co Dubai Branch-DED",
    "registrationNumber": "L-05796",
    "licenseIssueDate": "07/05/2023 00:00:00",
    "licenseExpiryDate": "07/04/2026 00:00:00"
  },
  {
    "id": "dc940ec4-2fcc-47ea-baf4-2621c334b934",
    "slug": "hesa-alsaad",
    "name": "Hesa Alsaad",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/05/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hesa Alsaad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dc940ec4-2fcc-47ea-baf4-2621c334b934",
        "address": "ICD Brookfield Place ,Za'abeel 2 ,103747 ,",
        "phone": "97143696300 / 971506008159",
        "email": "mohammed.paracha@nortonrosefulbright.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c4aaee93-0ec4-4982-9a48-a23699492056",
    "firmName": "Norton Rose Fullbright (Middle East) LLP",
    "registrationNumber": "L-04076",
    "licenseIssueDate": "05/16/2025 00:00:00",
    "licenseExpiryDate": "05/15/2026 00:00:00"
  },
  {
    "id": "90022f78-2864-4c34-84a8-c7222c5dc498",
    "slug": "hesham-hassan-ali",
    "name": "Hesham Hassan Ali",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBISAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/28/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hesham Hassan Ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_90022f78-2864-4c34-84a8-c7222c5dc498",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-03128",
    "licenseIssueDate": "09/28/2015 00:00:00",
    "licenseExpiryDate": "09/23/2026 00:00:00"
  },
  {
    "id": "b938843e-176e-4f4a-bfb4-219283f7beba",
    "slug": "hesham-mahmoud-ahmed-mohamed",
    "name": "Hesham Mahmoud Ahmed Mohamed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/20/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hesham Mahmoud Ahmed Mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b938843e-176e-4f4a-bfb4-219283f7beba",
        "address": "MAYED  AL MRASHIDA  ,طيران ايران  ,برج السالمية  الطابق 8 مكتب رقم 804 ,الربج الاخضر  ,354999 ,Dubai",
        "phone": "97142225955 / 971552298952",
        "email": "info@mayedadv.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "314249aa-2f57-4a5c-bfb1-c5056cca52c8",
    "firmName": "MAYED ALMARASHDA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05133",
    "licenseIssueDate": "03/20/2025 00:00:00",
    "licenseExpiryDate": "03/19/2026 00:00:00"
  },
  {
    "id": "34ad4094-5474-48ea-abac-9f566d435bff",
    "slug": "hesham-mohamed-el-kouny",
    "name": "Hesham Mohamed El Kouny",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/27/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hesham Mohamed El Kouny",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_34ad4094-5474-48ea-abac-9f566d435bff",
        "address": "الطابق الثالث  ,SMJ1 ,مطعم حتوته مصرية  ,554531 ,Dubai",
        "phone": "97143443388 / 971524193537",
        "email": "info@nialawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4f4b0a10-f71b-4c6e-9bea-8fcaa4c64b75",
    "firmName": "NOURA ALAMIRI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01541",
    "licenseIssueDate": "11/27/2011 00:00:00",
    "licenseExpiryDate": "11/18/2025 00:00:00"
  },
  {
    "id": "c1e69f0d-220c-49c9-b617-ac2f896ab721",
    "slug": "hesham-mohamed-sedki-mohamed-elhabashi",
    "name": "HESHAM MOHAMED SEDKI MOHAMED ELHABASHI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/09/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2023-08-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hesham Mohamed Sedki Mohamed Elhabashi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c1e69f0d-220c-49c9-b617-ac2f896ab721",
        "address": "",
        "phone": "/ 971000000000",
        "email": "ahmed.advo@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "982063ca-143c-4793-84a0-193c57c43740",
    "firmName": "AHMED AL ALI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-04403",
    "licenseIssueDate": "05/09/2019 00:00:00",
    "licenseExpiryDate": "05/08/2023 00:00:00"
  },
  {
    "id": "37951f21-6e9e-40f4-aa44-667ddbe6dadd",
    "slug": "hesham-moustafa-mohamed",
    "name": "Hesham Moustafa Mohamed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/17/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hesham Moustafa Mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_37951f21-6e9e-40f4-aa44-667ddbe6dadd",
        "address": "الثامن مكتب 815 ,بزنس افينو  ,خلف وكالة نيسان  ,57134 ,Dubai",
        "phone": "97145463588",
        "email": "hisham@daralhekma.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e9592d3b-4f5e-43bf-9305-f85447bc9653",
    "firmName": "DAR AL HEKMAH LAWYERS & LEGAL CONSULTANCY",
    "registrationNumber": "L-03170",
    "licenseIssueDate": "11/17/2015 00:00:00",
    "licenseExpiryDate": "11/12/2025 00:00:00"
  },
  {
    "id": "ae7e5f42-8c3f-4dd5-bbff-06ac779838fe",
    "slug": "hessa-hesham-abdulla-qassim-alqassim",
    "name": "Hessa Hesham Abdulla Qassim AlQassim",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBISAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/05/2025",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hessa Hesham Abdulla Qassim AlQassim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ae7e5f42-8c3f-4dd5-bbff-06ac779838fe",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-06837",
    "licenseIssueDate": "05/21/2025 00:00:00",
    "licenseExpiryDate": "05/20/2026 00:00:00"
  },
  {
    "id": "8ff68551-54f1-4f7d-b4f8-139eab0d0451",
    "slug": "hilary-gachini-macharia",
    "name": "Hilary Gachini Macharia",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/19/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hilary Gachini Macharia",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8ff68551-54f1-4f7d-b4f8-139eab0d0451",
        "address": "1 ,Emaar Square 5 ,sheikh mohammed bin rashid BVD ,11987 ,Dubai",
        "phone": "97143043100 / 971507325154",
        "email": "amir.kordvani@pwc.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ea026b18-c93c-4f67-a1f2-4546320f8f3e",
    "firmName": "PWC Legal Middle East LLP",
    "registrationNumber": "L-06169",
    "licenseIssueDate": "01/19/2024 00:00:00",
    "licenseExpiryDate": "01/18/2026 00:00:00"
  },
  {
    "id": "afa834db-7a55-4ae2-830f-4df4a52f9c58",
    "slug": "himesh-kishan-sharma",
    "name": "Himesh Kishan Sharma",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBISwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/09/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Himesh Kishan Sharma",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_afa834db-7a55-4ae2-830f-4df4a52f9c58",
        "address": "Index Tower ,DIFC ,506896 ,",
        "phone": "97142782300 / 971551154791",
        "email": "GLeggate@wfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e2b82cfc-80a5-4957-ae41-b1a7beb693c1",
    "firmName": "Watson, Farley & Williams (Middle East) LLP",
    "registrationNumber": "L-06893",
    "licenseIssueDate": "07/09/2025 00:00:00",
    "licenseExpiryDate": "07/08/2026 00:00:00"
  },
  {
    "id": "6d172655-52a5-4ab5-9815-9dac718ee0fa",
    "slug": "hind-jamil-abukhalid-altamimi",
    "name": "HIND JAMIL KH ABUKHALID ALTAMIMI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBISgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/05/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-05-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: hind jamil abukhalid altamimi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6d172655-52a5-4ab5-9815-9dac718ee0fa",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-04099",
    "licenseIssueDate": "05/15/2018 00:00:00",
    "licenseExpiryDate": "05/14/2019 00:00:00"
  },
  {
    "id": "6a4849f4-cf71-4ba8-b522-82434e9e5e20",
    "slug": "hisham-ahmed-abdlsamiee-ahmed-diab",
    "name": "Hisham Ahmed Abdlsamiee Ahmed Diab",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/08/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hisham Ahmed Abdlsamiee Ahmed Diab",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6a4849f4-cf71-4ba8-b522-82434e9e5e20",
        "address": "",
        "phone": "97143433300",
        "email": "info@theattorneys.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "931ca6f7-8621-4da0-9545-a993725337e0",
    "firmName": "THE ATTORNIES ADVOCATES & LEGAL CONSULTANT",
    "registrationNumber": "L-07002"
  },
  {
    "id": "54312c61-c025-46cd-b94f-af4fb236d30d",
    "slug": "hisham-emile-nuri-oweiss",
    "name": "Hisham Emile Nuri Oweiss",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/22/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hisham Emile Nuri Oweiss",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_54312c61-c025-46cd-b94f-af4fb236d30d",
        "address": "South Tower, Emirates Financial Towers ,DIFC ,482025 ,",
        "phone": "97145875333 / 971503444388",
        "email": "c.dersahakian@cvml.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e2c6db70-04e7-4c7b-882a-6d2ffe4469ed",
    "firmName": "CVML Limited",
    "registrationNumber": "L-05234",
    "licenseIssueDate": "03/22/2022 00:00:00",
    "licenseExpiryDate": "03/21/2026 00:00:00"
  },
  {
    "id": "8f3c0491-d9e8-4f46-9738-fac62e11cfea",
    "slug": "hisham-mohamed-elshafey-mohamed-elshafey",
    "name": "Hisham Mohamed Elshafey Mohamed Elshafey",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/23/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hisham Mohamed Elshafey Mohamed Elshafey",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8f3c0491-d9e8-4f46-9738-fac62e11cfea",
        "address": "MOHAMMED MURTADA ALHASHMI ,3 ,LATIFA TOWER  ,CROWN PLAZA ,231400 ,Dubai",
        "phone": "97143521131",
        "email": "info@mhadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a5a2640f-b1b8-4512-b9ee-a8802d0c30fc",
    "firmName": "MOHAMMED AL HASHIMI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-03832",
    "licenseIssueDate": "07/23/2017 00:00:00",
    "licenseExpiryDate": "07/20/2026 00:00:00"
  },
  {
    "id": "a31532d0-5ea5-4769-b437-becbe099e7b7",
    "slug": "hitham-mohamed-audalla-bassam",
    "name": "Hitham Mohamed Audalla Bassam",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/08/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-08-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hitham Mohamed Audalla Bassam",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a31532d0-5ea5-4769-b437-becbe099e7b7",
        "address": "Hitham Bassam ,1 ,R549 ,بنك مصر ,99094 ,Dubai",
        "phone": "97142355517",
        "email": "hassanalabdooli@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "746e4dd4-f7bb-4efd-84f5-ad6b769ad28c",
    "firmName": "HASSAN AL ABDOOLI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03847",
    "licenseIssueDate": "08/29/2017 00:00:00",
    "licenseExpiryDate": "08/26/2025 00:00:00"
  },
  {
    "id": "09be1c49-f6ca-4410-b7a8-57ac44e5fefe",
    "slug": "hoda-barakat",
    "name": "Hoda Barakat",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hoda Barakat",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_09be1c49-f6ca-4410-b7a8-57ac44e5fefe",
        "address": "The H Hotel ,334249 ,Dubai",
        "phone": "97143050858 / 971506454751",
        "email": "hoda@hblegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "2476b8c2-8925-4cd7-8215-0d7a0791a955",
    "firmName": "Hoda Barakat Legal Consultancy",
    "registrationNumber": "L-01045",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "bfd369ae-dafe-4c64-9a51-80933c7be8c1",
    "slug": "hoda-bazzi",
    "name": "Hoda Bazzi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/11/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hoda Bazzi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bfd369ae-dafe-4c64-9a51-80933c7be8c1",
        "address": "Samir Kanaan ,Office 502 Floor 5 ,Bay Square Building 11 ,South Ridge Apartments ,101 ,Dubai",
        "phone": "97142775444",
        "email": "info@kanlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d0e51371-a813-49c7-a99e-641fda6bca77",
    "firmName": "KANAAN ADVOCATES& LEGAL CONSULTANTS",
    "registrationNumber": "L-03500",
    "licenseIssueDate": "10/11/2016 00:00:00",
    "licenseExpiryDate": "10/07/2025 00:00:00"
  },
  {
    "id": "5cb34789-97ac-4198-8e84-da00062d1dcc",
    "slug": "hosam-eldin-ahmed-ismail-elsayed",
    "name": "Hosam Eldin Ahmed Ismail Elsayed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/04/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hosam Eldin Ahmed Ismail Elsayed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5cb34789-97ac-4198-8e84-da00062d1dcc",
        "address": "Mohamed Thamer Yaqub Yousef Alserkal ,الطابق الثاني ,اعمار سكوير - بناء رقم 4 ,برج خليفة ,57409 ,Dubai",
        "phone": "97142622217 / 97142622217",
        "email": "mohamed@alserkallawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2a224392-a975-448f-aec5-0460984b1124",
    "firmName": "MOHAMED ALSERKAL ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04641",
    "licenseIssueDate": "03/04/2020 00:00:00",
    "licenseExpiryDate": "03/03/2026 00:00:00"
  },
  {
    "id": "85cc957c-19ed-4ba0-9374-74931df9e61c",
    "slug": "hosam-mohamed-hussein-khalifa",
    "name": "HOSAM MOHAMED HUSSEIN KHALIFA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/07/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2022-06-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hosam Mohamed Hussein Khalifa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_85cc957c-19ed-4ba0-9374-74931df9e61c",
        "address": "Ahmed Saleh Abulla Khamis ALramsi ,1305 ,Fairmont Dubai ,Burj Khalifa ,77857 ,Dubai",
        "phone": "97142720066",
        "email": "info@alramsyadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b84458c4-4c08-4fa7-8fd9-05b8787d4896",
    "firmName": "DR. AHMED ALRAMSI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04405",
    "licenseIssueDate": "12/07/2021 00:00:00",
    "licenseExpiryDate": "12/06/2022 00:00:00"
  },
  {
    "id": "372f99c4-264f-4138-87a7-6690232a8a92",
    "slug": "hosam-mohammed-hashim-bakr",
    "name": "hosam mohammed hashim bakr",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/17/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: hosam mohammed hashim bakr",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_372f99c4-264f-4138-87a7-6690232a8a92",
        "address": "Sara Shah Baik Elbloshi ,الطابق 13 - مكتب 1306 ,CLOVER BAY ,بجوار SONDER HOTEL ,112773 ,Dubai",
        "phone": "97143514666",
        "email": "admin@saraadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9271d191-2f3e-4570-93bf-34fb919bf6e0",
    "firmName": "SARA ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-04652",
    "licenseIssueDate": "10/17/2023 00:00:00",
    "licenseExpiryDate": "10/16/2026 00:00:00"
  },
  {
    "id": "d4a907c4-32e6-4566-b922-fc4634450449",
    "slug": "hosameldin-lotfy-hussein",
    "name": "Hosameldin Lotfy Hussein",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hosameldin Lotfy Hussein",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d4a907c4-32e6-4566-b922-fc4634450449",
        "address": "",
        "phone": "97145293307",
        "email": "info@hyadvocate.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0d19b22a-0678-43d9-ae17-061958b88e0e",
    "firmName": "HUDA YAQOOB ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01842",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "08ddde03-276e-4014-b36a-eb4c079f9b39",
    "slug": "hossam-abdel-wahab-ibrahim-elhangour",
    "name": "Hossam Abdel Wahab Ibrahim Elhangour",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/23/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hossam Abdel Wahab Ibrahim Elhangour",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_08ddde03-276e-4014-b36a-eb4c079f9b39",
        "address": "",
        "phone": "97142566800",
        "email": "fatema@alhammadiadvocate.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "07521705-aa90-4c3a-b5fd-c55e54889e60",
    "firmName": "MOHAMED AL HAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03991",
    "licenseIssueDate": "02/23/2022 00:00:00",
    "licenseExpiryDate": "02/22/2026 00:00:00"
  },
  {
    "id": "972640ad-35f7-45df-b38e-f09695834266",
    "slug": "hossam-elsayed-mahmoud-elsayed",
    "name": "Hossam Elsayed Mahmoud Elsayed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/26/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hossam Elsayed Mahmoud Elsayed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_972640ad-35f7-45df-b38e-f09695834266",
        "address": "SULAIMAN ALNAQBI ,5 ,Emaar Business Park 1 ,Emaar Business Park 1 ,0000 ,Dubai",
        "phone": "",
        "email": "hsrgro@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d10fb0e9-ccd7-4ac9-8f58-e21ff0d7d2f2",
    "firmName": "SULAIMAN AL NAQBI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06701",
    "licenseIssueDate": "02/26/2025 00:00:00",
    "licenseExpiryDate": "02/25/2026 00:00:00"
  },
  {
    "id": "86acace6-20dc-4e4a-bd44-8468fad283ba",
    "slug": "hossam-magdy-mohamed-ibrahim-bazazou",
    "name": "Hossam Magdy Mohamed Ibrahim Bazazou",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/05/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hossam Magdy Mohamed Ibrahim Bazazou",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_86acace6-20dc-4e4a-bd44-8468fad283ba",
        "address": "yousif alhammadi ,الخامس 513،514 ,بيزنس افينيو ,وكالة نيسان ,414145 ,Dubai",
        "phone": "97143307771",
        "email": "yousifadv@alhammadilegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b2331b5f-91be-4205-ad5c-6af317f654a4",
    "firmName": "YOUSIF ALHAMMADI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-06595",
    "licenseIssueDate": "12/05/2024 00:00:00",
    "licenseExpiryDate": "12/04/2025 00:00:00"
  },
  {
    "id": "caa31e91-b99a-4983-915e-5d565ac49f7f",
    "slug": "hossam-rabee",
    "name": "Hossam Rabee",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/02/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hossam Rabee",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_caa31e91-b99a-4983-915e-5d565ac49f7f",
        "address": "saeed ,310 & 311 ,business avenue ,منطقه بور سعيد التجاريه ,19410 ,Dubai",
        "phone": "97148868812",
        "email": "info@saeedalghafri.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5acd50c8-df41-496b-a969-926d40e45c46",
    "firmName": "SAEED ALGHAFRI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03210",
    "licenseIssueDate": "06/02/2024 00:00:00",
    "licenseExpiryDate": "06/01/2026 00:00:00"
  },
  {
    "id": "918f3f67-1462-47d3-9dc8-ab001298844a",
    "slug": "hossam-rashad-mohamed-omar",
    "name": "HOSSAM RASHAD MOHAMED OMAR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/07/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: HOSSAM RASHAD MOHAMED OMAR",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_918f3f67-1462-47d3-9dc8-ab001298844a",
        "address": "",
        "phone": "97142868681",
        "email": "hawailaw@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3f1d962a-159f-4d0f-82d0-ebd94930d6ae",
    "firmName": "LAW OFFICE OF MAHMOUD AL HAWAI ATTORNEYS &CONSULTANTS AT LAW",
    "registrationNumber": "L-06774",
    "licenseIssueDate": "05/07/2025 00:00:00",
    "licenseExpiryDate": "05/06/2026 00:00:00"
  },
  {
    "id": "dceb53e7-5fcf-40f4-bb95-5d27e061310c",
    "slug": "hossam-zakaria-esmaeil-esmaeil-aita",
    "name": "Hossam Zakaria Esmaeil Esmaeil Aita",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIWgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/23/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hossam Zakaria Esmaeil Esmaeil Aita",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dceb53e7-5fcf-40f4-bb95-5d27e061310c",
        "address": "",
        "phone": "97144531888 / 971971445318",
        "email": "info@suhaila.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3f71c0fe-93b9-4bea-82c4-fad46b21e883",
    "firmName": "SUHAILA ALMARZOOQI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04717",
    "licenseIssueDate": "07/23/2020 00:00:00",
    "licenseExpiryDate": "07/22/2026 00:00:00"
  },
  {
    "id": "3a5451db-07ff-4844-95aa-c6250d36457b",
    "slug": "hossameldin-abdelmoneim-abdelmqsoud",
    "name": "Hossameldin Abdelmoneim Abdelmqsoud",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/05/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hossameldin Abdelmoneim Abdelmqsoud",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3a5451db-07ff-4844-95aa-c6250d36457b",
        "address": "",
        "phone": "97143355577",
        "email": "daraladalah1991@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "61efd89c-1d0d-4136-8397-2814c745f0da",
    "firmName": "DAR AL ADALAH ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02035",
    "licenseIssueDate": "12/05/2011 00:00:00",
    "licenseExpiryDate": "11/24/2025 00:00:00"
  },
  {
    "id": "86679380-5e51-4c76-8be9-4a2a767a2d6c",
    "slug": "hossameldin-fawzy-khalifa",
    "name": "Hossameldin Fawzy Khalifa",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/01/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hossameldin Fawzy Khalifa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_86679380-5e51-4c76-8be9-4a2a767a2d6c",
        "address": "B2207 ,لطيفة تاور ,بجانب فندق فوكو دبي‎ ,410889 ,Dubai",
        "phone": "97143447557",
        "email": "info@amirasaqeradvo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d4393464-394a-4311-ac7d-2247c5af8bad",
    "firmName": "AMIRA SAQER ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02958",
    "licenseIssueDate": "06/01/2023 00:00:00",
    "licenseExpiryDate": "05/31/2026 00:00:00"
  },
  {
    "id": "fb85ad0d-3fd9-4662-9583-fc2a1f06eccd",
    "slug": "huai-yuan-jia",
    "name": "Huai Yuan JIA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/29/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Huai Yuan JIA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fb85ad0d-3fd9-4662-9583-fc2a1f06eccd",
        "address": "",
        "phone": "97142946164",
        "email": "info@albannai-law.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "73525ec0-5573-4652-8fd8-c2ef0f19b399",
    "firmName": "ALBANNAI & CO.",
    "registrationNumber": "L-04668",
    "licenseIssueDate": "04/29/2020 00:00:00",
    "licenseExpiryDate": "04/28/2026 00:00:00"
  },
  {
    "id": "d5805599-9daf-46ca-b18c-6d32882eb277",
    "slug": "hugh-fraser",
    "name": "Hugh Fraser",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/06/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hugh Fraser",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d5805599-9daf-46ca-b18c-6d32882eb277",
        "address": "Level 41, Emirates Towers ,Sheykh Zayed Road, World Trade Center, DIFC ,31303 ,",
        "phone": "97143827717 / 971585956361",
        "email": "hugh.fraser@hfi-consulting.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "9acfebc7-35ab-48b8-94cf-e2dc19cd54c6",
    "firmName": "Hugh Fraser International Legal Consultancy",
    "registrationNumber": "L-00466",
    "licenseIssueDate": "06/06/2022 00:00:00",
    "licenseExpiryDate": "06/05/2026 00:00:00"
  },
  {
    "id": "7167a663-aaf3-4db9-8984-8bec7e506798",
    "slug": "humayun-ahmad",
    "name": "Humayun Ahmad",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/01/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Humayun Ahmad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7167a663-aaf3-4db9-8984-8bec7e506798",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-03665",
    "licenseIssueDate": "03/01/2017 00:00:00",
    "licenseExpiryDate": "02/25/2026 00:00:00"
  },
  {
    "id": "8a8ed4b1-cc32-4285-8da1-594487a961ea",
    "slug": "huosin-altoomah",
    "name": "Huosin AlToomah",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/03/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Huosin AlToomah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8a8ed4b1-cc32-4285-8da1-594487a961ea",
        "address": "",
        "phone": "97148328997",
        "email": "info@alkindiadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "27ee82c9-8f98-4b21-b9be-2de8fe329b61",
    "firmName": "AMANI ALKINDI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03306",
    "licenseIssueDate": "02/03/2016 00:00:00",
    "licenseExpiryDate": "01/29/2026 00:00:00"
  },
  {
    "id": "7c1150a1-a303-4edc-b384-f28b0afe58b1",
    "slug": "husain-ali-abdulredha-dawani",
    "name": "Husain Ali Abdulredha Dawani",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/07/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Husain Ali Abdulredha Dawani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7c1150a1-a303-4edc-b384-f28b0afe58b1",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06775",
    "licenseIssueDate": "05/07/2025 00:00:00",
    "licenseExpiryDate": "05/06/2026 00:00:00"
  },
  {
    "id": "f0c1891f-3eab-4773-8cd6-aaf1179b72c4",
    "slug": "husam-hourani",
    "name": "Husam Hourani",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBISAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Husam Hourani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f0c1891f-3eab-4773-8cd6-aaf1179b72c4",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01264",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "cc420632-b263-46c1-99a7-27d62d111f89",
    "slug": "husameldin-khalid-barakat-mohamed",
    "name": "husameldin khalid barakat mohamed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBISwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/07/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: husameldin khalid barakat mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cc420632-b263-46c1-99a7-27d62d111f89",
        "address": "YASIR AL NAQBI ,21 ,48 BURJ ,SOFITEL DOWN  TOWN ,181111 ,Dubai",
        "phone": "97142689949",
        "email": "info@alnaqbipartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ad71430e-83ee-4cb5-a530-bc58db2618f6",
    "firmName": "ALNAQBI & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06772",
    "licenseIssueDate": "05/07/2025 00:00:00",
    "licenseExpiryDate": "05/06/2026 00:00:00"
  },
  {
    "id": "1745485b-b2b2-4812-9410-bb647635c755",
    "slug": "husayn-jibril-reza-asif-abbas-reza",
    "name": "HUSAYN JIBRIL REZA ASIF ABBAS REZA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBISgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/31/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: HUSAYN JIBRIL REZA ASIF ABBAS REZA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1745485b-b2b2-4812-9410-bb647635c755",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-06185",
    "licenseIssueDate": "01/31/2024 00:00:00",
    "licenseExpiryDate": "01/30/2026 00:00:00"
  },
  {
    "id": "ebbdbf3f-c776-49c2-a1db-630f71d58b05",
    "slug": "husni-al-far",
    "name": "HUSNI AL FAR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/03/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: HUSNI AL FAR",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ebbdbf3f-c776-49c2-a1db-630f71d58b05",
        "address": "",
        "phone": "97143779900 / 971508548052",
        "email": "jali@kslaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dff8529a-82be-431a-b72b-0192ff238011",
    "firmName": "King & Spalding LLP",
    "registrationNumber": "L-06375",
    "licenseIssueDate": "07/03/2024 00:00:00",
    "licenseExpiryDate": "07/02/2026 00:00:00"
  },
  {
    "id": "b121cb68-80a1-45d2-994a-8e306317a427",
    "slug": "hussain-ali-al-matrood",
    "name": "Hussain Ali Al Matrood",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hussain Ali Al Matrood",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b121cb68-80a1-45d2-994a-8e306317a427",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02846",
    "licenseIssueDate": "03/01/2015 00:00:00",
    "licenseExpiryDate": "02/23/2026 00:00:00"
  },
  {
    "id": "d143cc9f-230b-41b1-b44f-afcaadadb95f",
    "slug": "hussam-barjas",
    "name": "Hussam Barjas",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hussam Barjas",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d143cc9f-230b-41b1-b44f-afcaadadb95f",
        "address": "4 - 449 ,Emarat Atrium ,Gulf News ,413533 ,Dubai",
        "phone": "97143211966",
        "email": "icalc@internationalcounsels.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "382198c6-5727-490a-963b-91b675ddc7bc",
    "firmName": "INTERNATIONAL COUNSELS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01861",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "9366f6d6-38f0-4c0c-84e2-5d1cc7249c47",
    "slug": "hussein-abdel-rahman-shabana",
    "name": "Hussein Abdel Rahman Shabana",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/29/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hussein Abdel Rahman Shabana",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9366f6d6-38f0-4c0c-84e2-5d1cc7249c47",
        "address": "",
        "phone": "97143316868 / 971561446981",
        "email": "info@alhanaee.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "eb84bd6d-a78c-4fd6-8f46-4fab8eea60b5",
    "firmName": "ABDELAZIZ ALHANAEE ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-02074",
    "licenseIssueDate": "11/29/2011 00:00:00",
    "licenseExpiryDate": "11/20/2025 00:00:00"
  },
  {
    "id": "976f64c4-6fa2-4da2-9c37-eb6ad397ea14",
    "slug": "hussein-ahmad-al-momani",
    "name": "Hussein Ahmad Al Momani",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/15/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hussein Ahmad Al Momani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_976f64c4-6fa2-4da2-9c37-eb6ad397ea14",
        "address": "",
        "phone": "97143937700",
        "email": "info@galadarilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d863b662-c864-4193-8b3a-ff6ee5fe6c64",
    "firmName": "GALADARI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02594",
    "licenseIssueDate": "07/15/2013 00:00:00",
    "licenseExpiryDate": "07/08/2026 00:00:00"
  },
  {
    "id": "b9867175-91bc-46be-93c0-c40588d0be53",
    "slug": "hussein-bassyouny-elmanshaliny",
    "name": "Hussein Bassyouny Elmanshaliny",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/29/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hussein Bassyouny Elmanshaliny",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b9867175-91bc-46be-93c0-c40588d0be53",
        "address": "Saeed Tower 2 ,Trade centre ,124942 ,",
        "phone": "/ 971508470447",
        "email": "ravi@nexlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "42a35604-227b-4c05-8095-770c821b3d4f",
    "firmName": "Nexlaw Maritime Legal Consultancy",
    "registrationNumber": "L-01736",
    "licenseIssueDate": "10/29/2024 00:00:00",
    "licenseExpiryDate": "10/28/2025 00:00:00"
  },
  {
    "id": "0daf7dc5-a203-4d8a-8814-5a8c21829401",
    "slug": "hussein-elsayed-hussein-mohamed",
    "name": "Hussein Elsayed Hussein Mohamed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/08/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-08-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hussein Elsayed Hussein Mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0daf7dc5-a203-4d8a-8814-5a8c21829401",
        "address": "0 ,بن فارس 2 ,مستشفى البراحة ,22662 ,Dubai",
        "phone": "97142203333 / 9715048999911",
        "email": "seridi.advo@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c567de5a-f399-4c56-829e-06e37a2eb4fc",
    "firmName": "RASHED AHMED ALSEREIDI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04904",
    "licenseIssueDate": "08/22/2023 00:00:00",
    "licenseExpiryDate": "08/21/2025 00:00:00"
  },
  {
    "id": "611f7a18-bb41-4f21-aa97-d3468a4ee002",
    "slug": "hussein-elshebini",
    "name": "Hussein Elshebini",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hussein Elshebini",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_611f7a18-bb41-4f21-aa97-d3468a4ee002",
        "address": "",
        "phone": "97143368833",
        "email": "alkhouli@alkhoulilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0188c41d-cec9-4993-8610-23001bfcf8a7",
    "firmName": "MAAMOUN AL KHOULI & ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01182",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "12013655-1ece-4658-9826-ccd18ef01661",
    "slug": "hussein-kanji",
    "name": "Hussein Kanji",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBISwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/24/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hussein Kanji",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_12013655-1ece-4658-9826-ccd18ef01661",
        "address": "1 ,Emaar Square 5 ,sheikh mohammed bin rashid BVD ,11987 ,Dubai",
        "phone": "97143043100 / 971507325154",
        "email": "amir.kordvani@pwc.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ea026b18-c93c-4f67-a1f2-4546320f8f3e",
    "firmName": "PWC Legal Middle East LLP",
    "registrationNumber": "L-06422",
    "licenseIssueDate": "07/24/2024 00:00:00",
    "licenseExpiryDate": "07/23/2026 00:00:00"
  },
  {
    "id": "3c0691f7-d62a-420a-b8f8-2283468fa823",
    "slug": "hussein-metwally-hussein-elkeblawy",
    "name": "Hussein Metwally Hussein Elkeblawy",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hussein Metwally Hussein Elkeblawy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3c0691f7-d62a-420a-b8f8-2283468fa823",
        "address": "4 - 449 ,Emarat Atrium ,Gulf News ,413533 ,Dubai",
        "phone": "97143211966",
        "email": "icalc@internationalcounsels.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "382198c6-5727-490a-963b-91b675ddc7bc",
    "firmName": "INTERNATIONAL COUNSELS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01862",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "9c0bd17b-7d60-4798-a06c-0e7c78388302",
    "slug": "hussein-nicholas-leslie-baxter",
    "name": "Hussein Nicholas Leslie Baxter",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/12/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hussein Nicholas Leslie Baxter",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9c0bd17b-7d60-4798-a06c-0e7c78388302",
        "address": "",
        "phone": "/ 971000000000",
        "email": "tthesing@sidley.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "32091971-c716-41d1-a21d-cc50c9fb3214",
    "firmName": "Sidley Austin LLP",
    "registrationNumber": "L-04573",
    "licenseIssueDate": "12/12/2019 00:00:00",
    "licenseExpiryDate": "12/11/2025 00:00:00"
  },
  {
    "id": "e5019aa1-9081-4e11-9905-ca1351f01cd3",
    "slug": "hussein-wamid-hussein-mujalli",
    "name": "Hussein Wamid Hussein Mujalli",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/29/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hussein Wamid Hussein Mujalli",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e5019aa1-9081-4e11-9905-ca1351f01cd3",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06913",
    "licenseIssueDate": "07/29/2025 00:00:00",
    "licenseExpiryDate": "07/28/2026 00:00:00"
  },
  {
    "id": "2bd062c8-fc7b-4757-a043-305ab59cffb0",
    "slug": "iain-black",
    "name": "Iain Black",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/25/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Iain Black",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2bd062c8-fc7b-4757-a043-305ab59cffb0",
        "address": "",
        "phone": "97144020800 / 971566830829",
        "email": "dean.ryburn@dentons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dfe13b7e-6625-45fd-ad63-9ee83af41194",
    "firmName": "Dentons & Co Dubai Branch-DED",
    "registrationNumber": "L-00412",
    "licenseIssueDate": "02/25/2012 00:00:00",
    "licenseExpiryDate": "02/16/2026 00:00:00"
  },
  {
    "id": "6882a650-d0d2-4c78-9529-a596c730de1c",
    "slug": "iain-skinner",
    "name": "Iain Skinner",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/10/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Iain Skinner",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6882a650-d0d2-4c78-9529-a596c730de1c",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-02559",
    "licenseIssueDate": "09/10/2013 00:00:00",
    "licenseExpiryDate": "09/03/2026 00:00:00"
  },
  {
    "id": "9f8a4daf-1812-4fa7-980c-cdfea3e7fc81",
    "slug": "ian-arnott",
    "name": "Ian Arnott",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/02/2014",
    "licenseStatus": "active",
    "licenseExpiry": "2015-02-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ian Arnott",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9f8a4daf-1812-4fa7-980c-cdfea3e7fc81",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01539",
    "licenseIssueDate": "02/02/2014 00:00:00",
    "licenseExpiryDate": "01/26/2026 00:00:00"
  },
  {
    "id": "c2eb5614-a27e-45d4-956a-7e5b1f60fd9c",
    "slug": "ian-chung",
    "name": "Ian Chung",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/07/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ian Chung",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c2eb5614-a27e-45d4-956a-7e5b1f60fd9c",
        "address": "",
        "phone": "97144230555 / 971504788443",
        "email": "yah@hfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c462c65e-185a-4e81-8425-a87e3a2b6842",
    "firmName": "Holman Fenwick Willan Middle East LLP",
    "registrationNumber": "L-00619",
    "licenseIssueDate": "10/07/2011 00:00:00",
    "licenseExpiryDate": "09/28/2026 00:00:00"
  },
  {
    "id": "4d3ca97b-7ff9-4a10-93bb-b9328d058dfc",
    "slug": "ian-veall",
    "name": "IAN PETER VEALL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJVgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ian Veall",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4d3ca97b-7ff9-4a10-93bb-b9328d058dfc",
        "address": "Business Village Building A ,Port Saeed ,42717 ,",
        "phone": "97142229747 / 971506546369",
        "email": "iveall@dhbassociates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "24541c75-dcba-47a9-b858-e6bc97c41dbc",
    "firmName": "Donald Harry Bunker Legal Consultants",
    "registrationNumber": "L-01016",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2025 00:00:00"
  },
  {
    "id": "ed9009a8-cd85-43fd-9ab8-b98231e7d3ec",
    "slug": "ibrahim-abdulkader-hanifeh",
    "name": "Ibrahim Abdulkader Hanifeh",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/06/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ibrahim Abdulkader Hanifeh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ed9009a8-cd85-43fd-9ab8-b98231e7d3ec",
        "address": "Advo. Abdulla Al Awadi ,العاشر  ,برايم تاور  ,فندق فيدا ,26665 ,Dubai",
        "phone": "97143352200",
        "email": "info@abdullaalawadi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5075821f-98f5-4546-8fcd-6cdc74967dac",
    "firmName": "ABDULLA AL AWADI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02201",
    "licenseIssueDate": "08/06/2013 00:00:00",
    "licenseExpiryDate": "07/30/2026 00:00:00"
  },
  {
    "id": "7b5ac9e4-e211-41dd-a495-9ef89af308c6",
    "slug": "ibrahim-adaili",
    "name": "Ibrahim Adaili",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ibrahim Adaili",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7b5ac9e4-e211-41dd-a495-9ef89af308c6",
        "address": "الخامس  ,مكاتب عود ميثاء ,فندق رافلز ,11268 ,Dubai",
        "phone": "97143243330",
        "email": "avocat@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "25d2c9bd-dbba-41ac-aff9-5ba0f37290d6",
    "firmName": "AL QARI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-01344",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "8856851e-ba08-4929-a5bc-3f495ab43820",
    "slug": "ibrahim-ahmed-ibrahim",
    "name": "Ibrahim Ahmed Ibrahim",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/16/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ibrahim Ahmed Ibrahim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8856851e-ba08-4929-a5bc-3f495ab43820",
        "address": "Ibrahim Nagi ,Office 207, Level 2 ,Al Khaimah Building ,Behind Nissan Showroom ,20220 ,Dubai",
        "phone": "97142950001",
        "email": "info@alshaali-co.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a58e33e7-4134-4c4f-afa6-c129aefe104c",
    "firmName": "AL SHAALI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02615",
    "licenseIssueDate": "10/16/2014 00:00:00",
    "licenseExpiryDate": "10/10/2025 00:00:00"
  },
  {
    "id": "c8012f2c-f493-4c04-97aa-e69748fd66cb",
    "slug": "ibrahim-arafa-mahmoud-mohamed",
    "name": "Ibrahim Arafa Mahmoud Mohamed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/22/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ibrahim Arafa Mahmoud Mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c8012f2c-f493-4c04-97aa-e69748fd66cb",
        "address": "",
        "phone": "97143213302",
        "email": "lawfirm@liberallawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a791ae2d-579f-42dd-945f-b28c198a33e4",
    "firmName": "LIBERALS LAWYERS LEGAL CONSULTANTS AND LAWYERS",
    "registrationNumber": "L-05193",
    "licenseIssueDate": "02/22/2022 00:00:00",
    "licenseExpiryDate": "02/21/2026 00:00:00"
  },
  {
    "id": "c233f623-06d0-4c68-8298-de2e2999fbe8",
    "slug": "ibrahim-arimala",
    "name": "Ibrahim Arimala",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/13/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ibrahim Arimala",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c233f623-06d0-4c68-8298-de2e2999fbe8",
        "address": "13 ,Le Solarium Tower ,Arabian Gate ,185430 ,Dubai",
        "phone": "97145805135 / 971558703836",
        "email": "info@alnaqbilaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "24f8f7c8-a688-4587-9e87-f3105a99533a",
    "firmName": "MUSAAB ALI AL NAQBI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-01027",
    "licenseIssueDate": "04/13/2015 00:00:00",
    "licenseExpiryDate": "04/07/2026 00:00:00"
  },
  {
    "id": "2455e078-e8b3-4aa9-a7df-028f96c9501d",
    "slug": "ibrahim-damilola-hassan",
    "name": "Ibrahim Damilola Hassan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/28/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ibrahim Damilola Hassan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2455e078-e8b3-4aa9-a7df-028f96c9501d",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-06816",
    "licenseIssueDate": "05/28/2025 00:00:00",
    "licenseExpiryDate": "05/27/2026 00:00:00"
  },
  {
    "id": "f2e1055c-ee29-44e2-bd18-f3e57124d5e5",
    "slug": "ibrahim-elfeky",
    "name": "Ibrahim Elfeky",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/16/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ibrahim Elfeky",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f2e1055c-ee29-44e2-bd18-f3e57124d5e5",
        "address": "1404 ,توين  تاورز  ,بجانب فندق ريدسون بلو  ,40227 ,Dubai",
        "phone": "97142222407",
        "email": "info@daralbalaghadvocate.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "183a898c-3779-4747-92dd-33a8feb6a42c",
    "firmName": "DAR AL BALAGH ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-03138",
    "licenseIssueDate": "03/16/2015 00:00:00",
    "licenseExpiryDate": "03/10/2026 00:00:00"
  },
  {
    "id": "806a7dc6-b111-4621-8c4e-4e17aff38b57",
    "slug": "ibrahim-eltamari",
    "name": "Ibrahim Eltamari",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/26/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ibrahim Eltamari",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_806a7dc6-b111-4621-8c4e-4e17aff38b57",
        "address": "العاشر ,المسعود ,بجوار معرض تويوتا ,20085 ,Dubai",
        "phone": "97142945554",
        "email": "ahmedalamiri_law@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "91d66bc6-9b89-4272-9d03-494aed8c3f9e",
    "firmName": "AHMED AL AMIRI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-03375",
    "licenseIssueDate": "05/26/2016 00:00:00",
    "licenseExpiryDate": "05/22/2026 00:00:00"
  },
  {
    "id": "b6f4c2ed-bdb6-4878-8bf7-71fe0a0f0f60",
    "slug": "ibrahim-hussien",
    "name": "Ibrahim Hussien",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/21/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ibrahim Hussien",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b6f4c2ed-bdb6-4878-8bf7-71fe0a0f0f60",
        "address": "21 ,Rolex Tower ,Emirates Grand Hotel ,94334 ,Dubai",
        "phone": "97143277772 / 97145584900",
        "email": "info@globaladvocates.net",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9b42810f-1d55-4aea-ac4a-7d9d1b25ac08",
    "firmName": "GLOBAL ADVOCACY & LEGAL COUNSEL",
    "registrationNumber": "L-03338",
    "licenseIssueDate": "09/21/2015 00:00:00",
    "licenseExpiryDate": "09/16/2026 00:00:00"
  },
  {
    "id": "f7b43df4-3ef1-448e-aaa6-99dce79d2b5c",
    "slug": "ibrahim-khalaf-mohamed",
    "name": "Ibrahim Khalaf Mohamed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/29/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ibrahim Khalaf Mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f7b43df4-3ef1-448e-aaa6-99dce79d2b5c",
        "address": "السادس , مباني الحضيبة للجوائز  ,علم الاتحاد ,200 ,Dubai",
        "phone": "97143545111",
        "email": "altaher_alsabri@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "aced7900-0571-43e1-b49b-4740c6dc298f",
    "firmName": "AL TAHER & AL SABRI ADVOCATES",
    "registrationNumber": "L-03884",
    "licenseIssueDate": "08/29/2017 00:00:00",
    "licenseExpiryDate": "08/26/2026 00:00:00"
  },
  {
    "id": "971d76a9-ffaf-45e0-ada1-928804758278",
    "slug": "ibrahim-khalil-soumrany",
    "name": "Ibrahim Khalil Soumrany",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/23/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ibrahim Khalil Soumrany",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_971d76a9-ffaf-45e0-ada1-928804758278",
        "address": "",
        "phone": "97143184600 / 971504468184",
        "email": "melaraby@gibsondunn.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c9d2c9d0-6e43-4253-a75d-cdeb400f8d8e",
    "firmName": "Gibson Dunn & Crutcher LLP",
    "registrationNumber": "L-05022",
    "licenseIssueDate": "08/23/2021 00:00:00",
    "licenseExpiryDate": "08/22/2026 00:00:00"
  },
  {
    "id": "46c67fc6-4126-41ad-9969-6724b473fcea",
    "slug": "ibrahim-mahmoud-elgamal",
    "name": "Ibrahim Mahmoud Elgamal",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/16/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ibrahim Mahmoud Elgamal",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_46c67fc6-4126-41ad-9969-6724b473fcea",
        "address": "Naser almuharrami ,التاسع  ,SAMA TOWER ,مطعم تشيلو  ,0000 ,Dubai",
        "phone": "97144581795 / 971507388622",
        "email": "info@lawdxb.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "bc5ea246-1523-48e3-917c-682ff8a19466",
    "firmName": "NASER ABDULLA ALMUHARRAMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02723",
    "licenseIssueDate": "09/16/2025 00:00:00",
    "licenseExpiryDate": "09/15/2026 00:00:00"
  },
  {
    "id": "8434d0ed-941f-4248-910c-ea241212382c",
    "slug": "ibrahim-mansy",
    "name": "Ibrahim Mansy",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/12/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ibrahim Mansy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8434d0ed-941f-4248-910c-ea241212382c",
        "address": "SAAD AL HAMMADI ,مدخل البرج ,ويست بيري ,برج خليفه ,41747 ,Dubai",
        "phone": "97142405222",
        "email": "info@saadpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "18923100-5b94-44e2-b580-2e3b0cc17bf6",
    "firmName": "SAAD AL HAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03093",
    "licenseIssueDate": "08/12/2015 00:00:00",
    "licenseExpiryDate": "08/06/2026 00:00:00"
  },
  {
    "id": "f4f21f60-0d21-4632-b447-f95663738f28",
    "slug": "ibrahim-mohamed-ahmed-zikry",
    "name": "Ibrahim Mohamed Ahmed Zikry",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/26/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ibrahim Mohamed Ahmed Zikry",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f4f21f60-0d21-4632-b447-f95663738f28",
        "address": "",
        "phone": "97142500717",
        "email": "alishamrilawfirm@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e22c751b-e66d-497c-b5ee-3df32eab4831",
    "firmName": "ALI AL SHIMMARI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01753",
    "licenseIssueDate": "09/26/2011 00:00:00",
    "licenseExpiryDate": "09/17/2026 00:00:00"
  },
  {
    "id": "5b0cb0ac-5c4b-4c0c-a94f-807edf570224",
    "slug": "ibrahim-mohamed-ibrahim-elsayed-abouhalima",
    "name": "ibrahim mohamed ibrahim elsayed abouhalima",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/06/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ibrahim mohamed ibrahim elsayed abouhalima",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5b0cb0ac-5c4b-4c0c-a94f-807edf570224",
        "address": "",
        "phone": "97143997700 / 971503707978",
        "email": "info@alazazi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "92d43169-f680-4fdb-a7c0-1397ce308994",
    "firmName": "MOHAMED ALAZAZI LAWYERS & LEGAL CONSULTANCY",
    "registrationNumber": "L-04863",
    "licenseIssueDate": "05/06/2025 00:00:00",
    "licenseExpiryDate": "05/05/2026 00:00:00"
  },
  {
    "id": "817984c7-1810-4d23-9832-bc2e4ff288b3",
    "slug": "ibrahim-mohamed-ibrahim-mohamed",
    "name": "Ibrahim Mohamed Ibrahim Mohamed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/27/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ibrahim Mohamed Ibrahim Mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_817984c7-1810-4d23-9832-bc2e4ff288b3",
        "address": "HAMDAN ALSHAMSI ,الطابق الرابع مكتب 401, 406,407 ,بي سكوير 01 ,مجمع دبي سكوير ,116564 ,Dubai",
        "phone": "97143469262",
        "email": "courts@has.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de2c61a6-9d00-457e-ad1d-e73e4e62d9bd",
    "firmName": "HAMDAN ALSHAMSI LAWYER & LEGAL CONSULTANTS",
    "registrationNumber": "L-06142",
    "licenseIssueDate": "12/27/2023 00:00:00",
    "licenseExpiryDate": "12/26/2025 00:00:00"
  },
  {
    "id": "ae9197bf-d3ec-4a0c-a24c-97d067444a5e",
    "slug": "ibrahim-mohamed-kamal-mohamed-abdou",
    "name": "ibrahim mohamed kamal mohamed abdou",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/10/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ibrahim mohamed kamal mohamed abdou",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ae9197bf-d3ec-4a0c-a24c-97d067444a5e",
        "address": "khalid al kaitoob ,12 ,نسيمية تاور الطابق 12 1202 B ,فندق الفوكو  ,10755 ,Dubai",
        "phone": "97143586555",
        "email": "info@alkaitooblawyer.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "403277a6-eef2-4cfd-af95-9959280d6b40",
    "firmName": "AL KAITOOB ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04334",
    "licenseIssueDate": "03/10/2019 00:00:00",
    "licenseExpiryDate": "03/08/2026 00:00:00"
  },
  {
    "id": "bb41c577-665e-44b9-8172-ddcded986299",
    "slug": "ibrahim-mohamed-mohamed-elshami",
    "name": "Ibrahim Mohamed Mohamed Elshami",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ibrahim Mohamed Mohamed Elshami",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bb41c577-665e-44b9-8172-ddcded986299",
        "address": "",
        "phone": "97100000000",
        "email": "dubai@ahlegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "eae5fb25-fd19-436c-8668-3ac309424db4",
    "firmName": "ALI HABIB AND ASSOCIATES ADVOCATES AND LEGAL CONSULTANCY",
    "registrationNumber": "L-01837",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "5d50a6c4-3e5b-4ec3-8931-4a1d8cccedca",
    "slug": "ibrahim-nada",
    "name": "Ibrahim Nada",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/03/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ibrahim Nada",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5d50a6c4-3e5b-4ec3-8931-4a1d8cccedca",
        "address": "",
        "phone": "97142959933",
        "email": "alaliadv@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a65968c3-f5c5-4cf1-89eb-1704f1c99056",
    "firmName": "ABDULLA AL - ALI & ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01569",
    "licenseIssueDate": "06/03/2021 00:00:00",
    "licenseExpiryDate": "06/02/2026 00:00:00"
  },
  {
    "id": "bb18a898-ccaf-4b65-a1e2-ecf1a74915c3",
    "slug": "ibrahim-salaheldin-mohamed-hassan",
    "name": "Ibrahim Salaheldin Mohamed Hassan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/15/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ibrahim Salaheldin Mohamed Hassan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bb18a898-ccaf-4b65-a1e2-ecf1a74915c3",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06055",
    "licenseIssueDate": "11/15/2023 00:00:00",
    "licenseExpiryDate": "11/14/2025 00:00:00"
  },
  {
    "id": "90759c2f-fa72-4384-9d41-64b540f4b797",
    "slug": "ibrahim-salih-ismael",
    "name": "Ibrahim salih Ismael",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/15/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ibrahim salih Ismael",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_90759c2f-fa72-4384-9d41-64b540f4b797",
        "address": "",
        "phone": "97142507778 / 971506421661",
        "email": "feedback@alshamsilawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4b400e1b-7731-4a4b-9c37-a77e3c03ab78",
    "firmName": "NASSER AL SHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04735",
    "licenseIssueDate": "10/15/2020 00:00:00",
    "licenseExpiryDate": "10/14/2023 00:00:00"
  },
  {
    "id": "472705ac-1995-4bc6-a6c8-2ca11f3e0c07",
    "slug": "ibrahim-younes",
    "name": "Ibrahim Younes",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/01/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ibrahim Younes",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_472705ac-1995-4bc6-a6c8-2ca11f3e0c07",
        "address": "YASIR AL NAQBI ,21 ,48 BURJ ,SOFITEL DOWN  TOWN ,181111 ,Dubai",
        "phone": "97142689949",
        "email": "info@alnaqbipartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ad71430e-83ee-4cb5-a530-bc58db2618f6",
    "firmName": "ALNAQBI & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01196",
    "licenseIssueDate": "12/01/2021 00:00:00",
    "licenseExpiryDate": "11/30/2025 00:00:00"
  },
  {
    "id": "11fc5b46-c094-4ec7-861f-0cd6a23d3f19",
    "slug": "ibtissem-lassoued",
    "name": "Ibtissem Lassoued",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ibtissem Lassoued",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_11fc5b46-c094-4ec7-861f-0cd6a23d3f19",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01265",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "3b2a2c76-276f-4549-8f4d-a176667d0cd1",
    "slug": "igor-bichenkov",
    "name": "Igor Bichenkov",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/16/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Igor Bichenkov",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3b2a2c76-276f-4549-8f4d-a176667d0cd1",
        "address": "Index Tower ,DIFC ,506896 ,",
        "phone": "97142782300 / 971551154791",
        "email": "GLeggate@wfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e2b82cfc-80a5-4957-ae41-b1a7beb693c1",
    "firmName": "Watson, Farley & Williams (Middle East) LLP",
    "registrationNumber": "L-05580",
    "licenseIssueDate": "11/16/2022 00:00:00",
    "licenseExpiryDate": "11/15/2025 00:00:00"
  },
  {
    "id": "798ef267-d952-45ae-b8e1-5f460c8b4635",
    "slug": "igor-gorchakov",
    "name": "Igor Gorchakov",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/24/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Igor Gorchakov",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_798ef267-d952-45ae-b8e1-5f460c8b4635",
        "address": "",
        "phone": "97143641686 / 971506288801",
        "email": "b.kadir@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0ba96df8-e4cc-49c2-8ae4-a42878d95926",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS LLC",
    "registrationNumber": "L-05484"
  },
  {
    "id": "567c86b1-730b-4aa4-b9c0-6b5c4984c0a3",
    "slug": "ihab-ahmed-ibrahim-ibrahim-ahmed-elnaggar",
    "name": "Ihab Ahmed Ibrahim Ibrahim Ahmed Elnaggar",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/19/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ihab Ahmed Ibrahim Ibrahim Ahmed Elnaggar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_567c86b1-730b-4aa4-b9c0-6b5c4984c0a3",
        "address": "South Tower, Emirates Financial Towers ,DIFC ,482025 ,",
        "phone": "97145875333 / 971503444388",
        "email": "c.dersahakian@cvml.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "e2c6db70-04e7-4c7b-882a-6d2ffe4469ed",
    "firmName": "CVML Limited",
    "registrationNumber": "L-03809",
    "licenseIssueDate": "07/19/2017 00:00:00",
    "licenseExpiryDate": "07/16/2026 00:00:00"
  },
  {
    "id": "82a799c6-2a68-4c16-8530-f22164b77168",
    "slug": "ihab-ibrahim-mohamed-etman",
    "name": "Ihab Ibrahim Mohamed Etman",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/22/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ihab Ibrahim Mohamed Etman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_82a799c6-2a68-4c16-8530-f22164b77168",
        "address": "الطابق الخامس  ,القيادة ,مطار دبى رقم 2 ,13917 ,Dubai",
        "phone": "97142949003",
        "email": "info@brlegalese.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "cf14fc58-f25f-463d-b60f-bfe4a127da8b",
    "firmName": "AL BANNAI & AL RASHEDAN ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05202",
    "licenseIssueDate": "02/22/2022 00:00:00",
    "licenseExpiryDate": "02/21/2026 00:00:00"
  },
  {
    "id": "d0093336-7668-41e2-8b23-d8ba7aa08fd5",
    "slug": "ihab-mohammed-mahran-kamel",
    "name": "Ihab Mohammed Mahran Kamel",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/31/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ihab Mohammed Mahran Kamel",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d0093336-7668-41e2-8b23-d8ba7aa08fd5",
        "address": "",
        "phone": "97148876711",
        "email": "info@alattarlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "64ce7252-a854-4e99-8c45-6681a4c7ca55",
    "firmName": "ALIA ALATTAR ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05886",
    "licenseIssueDate": "05/31/2023 00:00:00",
    "licenseExpiryDate": "05/30/2026 00:00:00"
  },
  {
    "id": "28a08fed-6d47-453f-9cd5-99bb33a59567",
    "slug": "ilaria-francesca-bertolazzi",
    "name": "Ilaria Francesca Bertolazzi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/22/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ilaria Francesca Bertolazzi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_28a08fed-6d47-453f-9cd5-99bb33a59567",
        "address": "ICD Brookfield Place ,DIFC ,506516 ,",
        "phone": "97143695800 / 971505526206",
        "email": "scott.campbell@linklaters.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5cec94c0-0649-43b6-a2be-ab17ff422bce",
    "firmName": "LinkLaters LLP",
    "registrationNumber": "L-06320",
    "licenseIssueDate": "05/22/2024 00:00:00",
    "licenseExpiryDate": "05/21/2026 00:00:00"
  },
  {
    "id": "5a3d93a6-bef8-4b99-a6fb-90611ec5aa6d",
    "slug": "ilham-adan-abdullah",
    "name": "ILHAM ADAN ABDULLAH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/21/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ILHAM ADAN ABDULLAH",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5a3d93a6-bef8-4b99-a6fb-90611ec5aa6d",
        "address": "",
        "phone": "97143563900 / 971564663035",
        "email": "c.miller@Beale-Law.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0f74c5fc-87d6-451a-b380-576b0bc3ceb8",
    "firmName": "Beale & Company (Middle East)",
    "registrationNumber": "L-06461",
    "licenseIssueDate": "08/21/2024 00:00:00",
    "licenseExpiryDate": "08/20/2026 00:00:00"
  },
  {
    "id": "af5b02b1-d0d8-466e-a517-aed2321423c4",
    "slug": "ilham-kabbouri",
    "name": "Ilham Kabbouri",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/21/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-01-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ilham Kabbouri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_af5b02b1-d0d8-466e-a517-aed2321423c4",
        "address": "Gate Village 10 ,Dubai International Financial Centre ,504945 ,",
        "phone": "97143301800 / 971569904245",
        "email": "nikram@velaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "61216046-6cd5-410d-a301-532f3e520e30",
    "firmName": "Vinson & Elkins LLP",
    "registrationNumber": "L-04840",
    "licenseIssueDate": "01/21/2021 00:00:00",
    "licenseExpiryDate": "01/20/2026 00:00:00"
  },
  {
    "id": "0fbca6fa-77eb-43f3-85b1-9cbdf6295e32",
    "slug": "ilian-rumenov-petrov",
    "name": "ILIAN RUMENOV PETROV",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/05/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ILIAN RUMENOV PETROV",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0fbca6fa-77eb-43f3-85b1-9cbdf6295e32",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506688 ,Dubai",
        "phone": "97147096600 / 971503556811",
        "email": "muneer.khan@simmons-simmons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d1725ca7-06ac-41b2-8d7b-a6e60665b73d",
    "firmName": "Simmons & Simmons (Middle East) LLP-DIFC",
    "registrationNumber": "L-05888",
    "licenseIssueDate": "07/05/2023 00:00:00",
    "licenseExpiryDate": "07/04/2026 00:00:00"
  },
  {
    "id": "0d33e114-78a5-49b7-ab74-f5d39f5478f5",
    "slug": "imad-kassir",
    "name": "Imad Kassir",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/16/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Imad Kassir",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0d33e114-78a5-49b7-ab74-f5d39f5478f5",
        "address": "مطعم زعتر وزيت  ,اسبكت تاور  ,فندق تاج  ,118212 ,Dubai",
        "phone": "97144433013 / 97144433013",
        "email": "moaza.alkhadar.alc@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "1dc550f7-81c5-4a5a-9096-682d651b8688",
    "firmName": "MOAZA AL KHADAR ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03443",
    "licenseIssueDate": "08/16/2016 00:00:00",
    "licenseExpiryDate": "08/12/2026 00:00:00"
  },
  {
    "id": "9997045f-fa04-48e6-8d0c-1bcd45e9ddd8",
    "slug": "imad-mohammed",
    "name": "Imad Mohammed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Imad Mohammed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9997045f-fa04-48e6-8d0c-1bcd45e9ddd8",
        "address": "الثاني ,الفجر للاعمال  ,مركز القرهود للياقة الطبية - مستشفى القرهود  ,15105 ,Dubai",
        "phone": "97142222800",
        "email": "info@almudharreb.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "806f31e8-0ed0-40a1-9d26-ef999012f7ed",
    "firmName": "AL MUDHARREB & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02019",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "8c661d3c-aca0-423e-a7a1-55374bc0a3f6",
    "slug": "imad-najjar",
    "name": "Imad Najjar",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/22/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Imad Najjar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8c661d3c-aca0-423e-a7a1-55374bc0a3f6",
        "address": "",
        "phone": "97143244662 / 971506518966",
        "email": "najarlaw@eim.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "03128ecc-d5a8-4c5b-bf8d-e4b8ca185b21",
    "firmName": "Najjar & Associates Legal Consultants",
    "registrationNumber": "L-00456",
    "licenseIssueDate": "11/22/2011 00:00:00",
    "licenseExpiryDate": "11/13/2025 00:00:00"
  },
  {
    "id": "524aa672-d47e-4de9-9f44-20a60358a03d",
    "slug": "iman-abdelkhalek-ahmed-bayoumi",
    "name": "Iman Abdelkhalek Ahmed Bayoumi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Iman Abdelkhalek Ahmed Bayoumi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_524aa672-d47e-4de9-9f44-20a60358a03d",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01255",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "c2df2c96-0ccb-4e5b-9b9b-7279bc56fede",
    "slug": "imtiaz-shah",
    "name": "Imtiaz Shah",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Imtiaz Shah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c2df2c96-0ccb-4e5b-9b9b-7279bc56fede",
        "address": "",
        "phone": "97143779377 / 971505528593",
        "email": "rahail.ali@hoganlovells.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ef4b209f-a5f1-446f-82de-1b0675bbf53b",
    "firmName": "Hogan Lovells Middle East LLP",
    "registrationNumber": "L-00800",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "ee0774e4-cc51-466a-ba37-36d26cf22f21",
    "slug": "india-dawson",
    "name": "India Dawson",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/21/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: India Dawson",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ee0774e4-cc51-466a-ba37-36d26cf22f21",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506688 ,Dubai",
        "phone": "97147096600 / 971503556811",
        "email": "muneer.khan@simmons-simmons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d1725ca7-06ac-41b2-8d7b-a6e60665b73d",
    "firmName": "Simmons & Simmons (Middle East) LLP-DIFC",
    "registrationNumber": "L-05862",
    "licenseIssueDate": "06/21/2023 00:00:00",
    "licenseExpiryDate": "06/20/2026 00:00:00"
  },
  {
    "id": "4f86c755-cf60-44bd-b97d-e951f922b669",
    "slug": "ioana-raluca-paduraru",
    "name": "Ioana Raluca Paduraru",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/09/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ioana Raluca Paduraru",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4f86c755-cf60-44bd-b97d-e951f922b669",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-06516",
    "licenseIssueDate": "10/09/2024 00:00:00",
    "licenseExpiryDate": "10/08/2026 00:00:00"
  },
  {
    "id": "c51ab2f4-08dc-4bf0-8e30-041147c47839",
    "slug": "ioannis-petras",
    "name": "IOANNIS PETRAS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/06/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: IOANNIS PETRAS",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c51ab2f4-08dc-4bf0-8e30-041147c47839",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-05996",
    "licenseIssueDate": "09/06/2023 00:00:00",
    "licenseExpiryDate": "09/05/2026 00:00:00"
  },
  {
    "id": "f7857ccc-c743-4f44-abc7-c474ce9dbdf9",
    "slug": "iona-louise-arrol-hunter",
    "name": "Iona Louise Arrol Hunter",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/03/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Iona Louise Arrol Hunter",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f7857ccc-c743-4f44-abc7-c474ce9dbdf9",
        "address": "",
        "phone": "97143742800 / 971506450677",
        "email": "jabbott21@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7a59d310-ff72-4318-b41c-27095c163d0f",
    "firmName": "CMS (UAE) LLP",
    "registrationNumber": "L-05456",
    "licenseIssueDate": "08/03/2022 00:00:00",
    "licenseExpiryDate": "08/02/2026 00:00:00"
  },
  {
    "id": "94385b3a-5e67-459f-bcc9-9b6a79f510b7",
    "slug": "isabel-freudenberg",
    "name": "Isabel Freudenberg",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/17/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Isabel Freudenberg",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_94385b3a-5e67-459f-bcc9-9b6a79f510b7",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-06283",
    "licenseIssueDate": "04/17/2024 00:00:00",
    "licenseExpiryDate": "04/16/2026 00:00:00"
  },
  {
    "id": "8913946f-1869-473c-81a0-e357dfe1599d",
    "slug": "isabella-leonora-stewart-dunk",
    "name": "Isabella Leonora Stewart Dunk",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/01/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Isabella Leonora Stewart Dunk",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8913946f-1869-473c-81a0-e357dfe1599d",
        "address": "Gate Village 10 ,Dubai International Financial Centre ,504945 ,",
        "phone": "97143301800 / 971569904245",
        "email": "nikram@velaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "61216046-6cd5-410d-a301-532f3e520e30",
    "firmName": "Vinson & Elkins LLP",
    "registrationNumber": "L-06980",
    "licenseIssueDate": "09/25/2025 00:00:00",
    "licenseExpiryDate": "09/24/2026 00:00:00"
  },
  {
    "id": "d65c7e48-5510-4e6d-bbd2-3a923714948c",
    "slug": "isabelle-lauren-forrest",
    "name": "Isabelle Lauren Forrest",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/04/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Isabelle Lauren Forrest",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d65c7e48-5510-4e6d-bbd2-3a923714948c",
        "address": "",
        "phone": "97143779377 / 971505528593",
        "email": "rahail.ali@hoganlovells.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ef4b209f-a5f1-446f-82de-1b0675bbf53b",
    "firmName": "Hogan Lovells Middle East LLP",
    "registrationNumber": "L-05999",
    "licenseIssueDate": "09/04/2023 00:00:00",
    "licenseExpiryDate": "09/03/2026 00:00:00"
  },
  {
    "id": "0dc478d5-7232-444f-bfb7-9c50e830dff3",
    "slug": "ishwarya-singh-sanjeev-singh",
    "name": "Ishwarya Singh Sanjeev Singh",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/23/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ishwarya Singh Sanjeev Singh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0dc478d5-7232-444f-bfb7-9c50e830dff3",
        "address": "South Tower, Emirates Financial Towers ,DIFC ,482025 ,",
        "phone": "97145875333 / 971503444388",
        "email": "c.dersahakian@cvml.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e2c6db70-04e7-4c7b-882a-6d2ffe4469ed",
    "firmName": "CVML Limited",
    "registrationNumber": "L-06771",
    "licenseIssueDate": "04/23/2025 00:00:00",
    "licenseExpiryDate": "04/22/2026 00:00:00"
  },
  {
    "id": "acaaa9b3-68fa-497c-9e6d-33a941334f79",
    "slug": "islam-medhat-elsaid-talaab",
    "name": "ISLAM MEDHAT ELSAID TALAAB",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/07/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ISLAM MEDHAT ELSAID TALAAB",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_acaaa9b3-68fa-497c-9e6d-33a941334f79",
        "address": "",
        "phone": "97143979948",
        "email": "info@zbh-lawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "fd86842c-ebb0-4c94-b81a-5fc571367af7",
    "firmName": "ZUBAIDA BIN HENDI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06537",
    "licenseIssueDate": "10/07/2024 00:00:00",
    "licenseExpiryDate": "10/06/2026 00:00:00"
  },
  {
    "id": "d3a3278f-4e0c-48ec-981d-f593874eb4ab",
    "slug": "islam-samir-mohamed-adam",
    "name": "Islam Samir Mohamed Adam",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/27/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Islam Samir Mohamed Adam",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d3a3278f-4e0c-48ec-981d-f593874eb4ab",
        "address": "4th Floor/ Office no. 401 ,Business Avenue  ,Infront- Terminal 2  ,115263 ,Dubai",
        "phone": "97144518866",
        "email": "info@aldhaheriinternational.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "cf3c19c0-d396-4bcb-b1db-b81273ed0b4c",
    "firmName": "AL DHAHERI INTERNATIONAL ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06026",
    "licenseIssueDate": "09/27/2023 00:00:00",
    "licenseExpiryDate": "09/26/2026 00:00:00"
  },
  {
    "id": "858a13df-a36c-4c24-94bd-e2549f5694f1",
    "slug": "ismail-abdelgadir-mohammed-abdalla",
    "name": "Ismail Abdelgadir mohammed Abdalla",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/10/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ismail Abdelgadir mohammed Abdalla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_858a13df-a36c-4c24-94bd-e2549f5694f1",
        "address": "",
        "phone": "97142555000",
        "email": "info@kha.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0e4b9f0a-83fc-45c9-b0d3-f38013690624",
    "firmName": "KHALIFA BIN HUWAIDAN ALKETBI ADVOCATES & LEGAL CONSULTANT",
    "registrationNumber": "L-06332",
    "licenseIssueDate": "05/10/2024 00:00:00",
    "licenseExpiryDate": "05/09/2026 00:00:00"
  },
  {
    "id": "4c1095e1-dc59-46fc-be7b-9a6cc7123996",
    "slug": "ismail-bahaaaldain-ismail-helmy-mohamed",
    "name": "Ismail Bahaaaldain Ismail Helmy Mohamed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/11/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ismail Bahaaaldain Ismail Helmy Mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4c1095e1-dc59-46fc-be7b-9a6cc7123996",
        "address": "29 ,ذا اتش هوتيل ,فندق فيرمونت ,40073 ,Dubai",
        "phone": "97143254000",
        "email": "info@alrowaad.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "759f5477-fdbd-406b-8831-354639c31036",
    "firmName": "AWATIF MOHAMMAD SHOQI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-05153",
    "licenseIssueDate": "01/11/2022 00:00:00",
    "licenseExpiryDate": "01/10/2026 00:00:00"
  },
  {
    "id": "d9301ef2-59c4-4725-b98c-a9c3f6279ba7",
    "slug": "ismaila-ngum",
    "name": "Ismaila Ngum",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/04/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ismaila Ngum",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d9301ef2-59c4-4725-b98c-a9c3f6279ba7",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-06029",
    "licenseIssueDate": "10/04/2023 00:00:00",
    "licenseExpiryDate": "10/03/2026 00:00:00"
  },
  {
    "id": "03445aa1-7dfc-4c4b-b6bb-5a9e85090522",
    "slug": "israa-abdulla",
    "name": "Israa Abdulla",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/22/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Israa Abdulla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_03445aa1-7dfc-4c4b-b6bb-5a9e85090522",
        "address": "ABDELAZIZ MOHAMED ABDELGHANI AL KHAMIRI AL ALI ,3 ,DUBAI SUPREME COURT COMPLEX ,DUBAI COURT ,128334 ,Dubai",
        "phone": "97145519341 / 971505788557",
        "email": "info@raalc.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "73e54a15-f797-4e91-a501-ef988d8f8bf8",
    "firmName": "ABDELAZIZ AL KHAMIRI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06334",
    "licenseIssueDate": "05/22/2024 00:00:00",
    "licenseExpiryDate": "05/21/2026 00:00:00"
  },
  {
    "id": "eb44dc6d-14ca-4540-bf1a-5d5d360af123",
    "slug": "issam-moufak-dahman",
    "name": "issam moufak dahman",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/19/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: issam moufak dahman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_eb44dc6d-14ca-4540-bf1a-5d5d360af123",
        "address": "MAI ALFALASI ADVOCATES AND LEGAL CONSULTANCY ,RECEPTION ,GREEN TOWER ,UNITED ARAB BANK ,93279 ,Dubai",
        "phone": "97142230666 / 97142230666",
        "email": "info@maaflegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6845576a-b39d-45a5-a726-55d73bb5ee05",
    "firmName": "MAI ALFALASI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04907",
    "licenseIssueDate": "04/19/2021 00:00:00",
    "licenseExpiryDate": "04/18/2026 00:00:00"
  },
  {
    "id": "9d608205-eaf2-4541-afa4-95def920f76a",
    "slug": "iurii-nekrasov",
    "name": "Iurii Nekrasov",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/18/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Iurii Nekrasov",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9d608205-eaf2-4541-afa4-95def920f76a",
        "address": "ICD Brookfield Place ,DIFC ,506516 ,",
        "phone": "97143695800 / 971505526206",
        "email": "scott.campbell@linklaters.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5cec94c0-0649-43b6-a2be-ab17ff422bce",
    "firmName": "LinkLaters LLP",
    "registrationNumber": "L-05389",
    "licenseIssueDate": "07/18/2022 00:00:00",
    "licenseExpiryDate": "07/17/2026 00:00:00"
  },
  {
    "id": "e42d1fb9-7a80-4145-b215-12581459f8fc",
    "slug": "ivan-alexeevich-dorofeev",
    "name": "Ivan Alexeevich Dorofeev",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/03/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ivan Alexeevich Dorofeev",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e42d1fb9-7a80-4145-b215-12581459f8fc",
        "address": "1 ,ICD Brookfield Place ,Dubai International Financial Centre ,9267 ,Dubai",
        "phone": "97147010975 / 971502977062",
        "email": "chris.sioufi@ae.ey.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "42e536ef-e3d8-4339-8572-657a7f7a0331",
    "firmName": "EY Law LLP",
    "registrationNumber": "L-05826",
    "licenseIssueDate": "05/03/2023 00:00:00",
    "licenseExpiryDate": "05/02/2026 00:00:00"
  },
  {
    "id": "788d85e8-cade-4dc4-82b1-52e725970974",
    "slug": "ivan-paskal",
    "name": "Ivan Paskal",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/11/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ivan Paskal",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_788d85e8-cade-4dc4-82b1-52e725970974",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-05072",
    "licenseIssueDate": "10/11/2021 00:00:00",
    "licenseExpiryDate": "10/10/2026 00:00:00"
  },
  {
    "id": "3d699b39-fe2e-4f99-8c17-c931687eabbb",
    "slug": "ivana-cicic",
    "name": "Ivana Cicic",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/01/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ivana Cicic",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3d699b39-fe2e-4f99-8c17-c931687eabbb",
        "address": "ICD Brookfield Place ,Za'abeel 2 ,103747 ,",
        "phone": "97143696300 / 971506008159",
        "email": "mohammed.paracha@nortonrosefulbright.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c4aaee93-0ec4-4982-9a48-a23699492056",
    "firmName": "Norton Rose Fullbright (Middle East) LLP",
    "registrationNumber": "L-05737",
    "licenseIssueDate": "03/01/2023 00:00:00",
    "licenseExpiryDate": "02/28/2026 00:00:00"
  },
  {
    "id": "8fd52196-fca7-43d4-b4f8-3fd0a8815866",
    "slug": "iwan-wyn-walters",
    "name": "Iwan Wyn Walters",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/20/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Iwan Wyn Walters",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8fd52196-fca7-43d4-b4f8-3fd0a8815866",
        "address": "",
        "phone": "97144073901 / 971503479508",
        "email": "Rania.Tadros@stephensonharwood.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dd5042a2-bb41-4123-9544-79c3fa831332",
    "firmName": "Stephenson Harwood (Middle East) LLP",
    "registrationNumber": "L-04117",
    "licenseIssueDate": "03/20/2025 00:00:00",
    "licenseExpiryDate": "03/19/2026 00:00:00"
  },
  {
    "id": "232cb48f-477d-475d-b12b-cb9f569578fa",
    "slug": "izabella-szadkowska",
    "name": "Izabella Szadkowska",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/08/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Izabella Szadkowska",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_232cb48f-477d-475d-b12b-cb9f569578fa",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01267",
    "licenseIssueDate": "06/08/2020 00:00:00",
    "licenseExpiryDate": "06/07/2026 00:00:00"
  },
  {
    "id": "84105465-77b3-4759-b4c3-233af423cd11",
    "slug": "izora-gerges-alkhoury",
    "name": "IZORA GERGES ALKHOURY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/22/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: IZORA GERGES ALKHOURY",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_84105465-77b3-4759-b4c3-233af423cd11",
        "address": "",
        "phone": "97142552220",
        "email": "almaazmi.office@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e04d8a88-3378-40c8-a33a-b5e26a0c8507",
    "firmName": "ABDELRAHMAN AL MAAZMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05744",
    "licenseIssueDate": "02/22/2023 00:00:00",
    "licenseExpiryDate": "02/21/2026 00:00:00"
  },
  {
    "id": "953d57f7-d3cb-4ef5-ba75-31dc59db71f0",
    "slug": "izzeldin-osman-elrahman",
    "name": "Izzeldin Osman Elrahman",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/03/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Izzeldin Osman Elrahman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_953d57f7-d3cb-4ef5-ba75-31dc59db71f0",
        "address": "",
        "phone": "97142770003",
        "email": "info@hbhadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "f074c445-924d-40b2-9832-0b0a040c4e63",
    "firmName": "HAIDER BIN HAIDER ADVOCATES AND LEGAL CONSULTANT",
    "registrationNumber": "L-01573",
    "licenseIssueDate": "01/03/2023 00:00:00",
    "licenseExpiryDate": "01/02/2026 00:00:00"
  },
  {
    "id": "5b634e72-07f7-43be-b3fd-4abd24f5e637",
    "slug": "izzet-hassan",
    "name": "Izzet Hassan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/30/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Izzet Hassan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5b634e72-07f7-43be-b3fd-4abd24f5e637",
        "address": "0 ,ICD Brookfield Place Level 13 ,Trade Centre ,506569 ,Dubai",
        "phone": "97145099100 / 971501006965",
        "email": "menahr@freshfields.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "970f6246-e737-41a7-9c6c-5aa5b8335d45",
    "firmName": "Freshfields LLP DIFC",
    "registrationNumber": "L-06764",
    "licenseIssueDate": "04/30/2025 00:00:00",
    "licenseExpiryDate": "04/29/2026 00:00:00"
  },
  {
    "id": "8ba0db85-4890-40ab-ab26-2b647c2e0d43",
    "slug": "jack-hardman",
    "name": "Jack Hardman",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/15/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jack Hardman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8ba0db85-4890-40ab-ab26-2b647c2e0d43",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-02238",
    "licenseIssueDate": "01/15/2014 00:00:00",
    "licenseExpiryDate": "01/08/2026 00:00:00"
  },
  {
    "id": "4369ca33-5e4e-4bd6-b504-cb581d1f5cd4",
    "slug": "jack-liam-abrehart",
    "name": "Jack Liam Abrehart",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/14/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jack Liam Abrehart",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4369ca33-5e4e-4bd6-b504-cb581d1f5cd4",
        "address": "ICD Brookfield Place ,Za'abeel 2 ,103747 ,",
        "phone": "97143696300 / 971506008159",
        "email": "mohammed.paracha@nortonrosefulbright.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c4aaee93-0ec4-4982-9a48-a23699492056",
    "firmName": "Norton Rose Fullbright (Middle East) LLP",
    "registrationNumber": "L-06683",
    "licenseIssueDate": "02/14/2025 00:00:00",
    "licenseExpiryDate": "02/13/2026 00:00:00"
  },
  {
    "id": "df6e8bd4-8946-4e40-8cee-5cb7d499bd87",
    "slug": "jack-meegan",
    "name": "Jack Meegan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/17/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jack Meegan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_df6e8bd4-8946-4e40-8cee-5cb7d499bd87",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-06259",
    "licenseIssueDate": "04/17/2024 00:00:00",
    "licenseExpiryDate": "04/16/2026 00:00:00"
  },
  {
    "id": "77dcc79f-ae86-4557-ba84-0608b172a383",
    "slug": "jack-naeem-ayoub",
    "name": "Jack Naeem Ayoub",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/26/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jack Naeem Ayoub",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_77dcc79f-ae86-4557-ba84-0608b172a383",
        "address": "مطعم زعتر وزيت  ,اسبكت تاور  ,فندق تاج  ,118212 ,Dubai",
        "phone": "97144433013 / 97144433013",
        "email": "moaza.alkhadar.alc@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "1dc550f7-81c5-4a5a-9096-682d651b8688",
    "firmName": "MOAZA AL KHADAR ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06698",
    "licenseIssueDate": "02/26/2025 00:00:00",
    "licenseExpiryDate": "02/25/2026 00:00:00"
  },
  {
    "id": "04069a20-2bf3-44fb-8164-f16df1b4d494",
    "slug": "jack-rowland-tivey",
    "name": "Jack Rowland Tivey",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/06/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jack Rowland Tivey",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_04069a20-2bf3-44fb-8164-f16df1b4d494",
        "address": "THE OFFICES 1 ,DWTC ,115580 ,",
        "phone": "97143739700 / 971501148248",
        "email": "nitesh.pradhan@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "361fdc64-6b6f-4f37-abca-c52af8473b84",
    "firmName": "Pinsent Masons  LLP (DWTCA Branch)",
    "registrationNumber": "L-06128",
    "licenseIssueDate": "12/06/2023 00:00:00",
    "licenseExpiryDate": "12/05/2025 00:00:00"
  },
  {
    "id": "d8f1d49d-86a8-4a67-92a7-790e6a526f81",
    "slug": "jackson-kevin-carlile",
    "name": "Jackson Kevin Carlile",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/28/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jackson Kevin Carlile",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d8f1d49d-86a8-4a67-92a7-790e6a526f81",
        "address": "",
        "phone": "97143637999 / 971506525633",
        "email": "daniel.wood@walkersglobal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a3a9927b-d51c-490c-8be6-d575ea3eb041",
    "firmName": "Walkers (Middle East) LLP",
    "registrationNumber": "L-06809",
    "licenseIssueDate": "05/28/2025 00:00:00",
    "licenseExpiryDate": "05/27/2026 00:00:00"
  },
  {
    "id": "d63a2c38-7be5-4bb7-93ce-082f15c60854",
    "slug": "jacky-chrystelle-khoueiry",
    "name": "Jacky Chrystelle Khoueiry",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/09/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jacky Chrystelle Khoueiry",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d63a2c38-7be5-4bb7-93ce-082f15c60854",
        "address": "",
        "phone": "97147098484 / 971505577206",
        "email": "slshadmand@jonesday.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8892bfe9-d3ec-4158-b4fd-1844606f4f30",
    "firmName": "Jones Day",
    "registrationNumber": "L-06744",
    "licenseIssueDate": "04/09/2025 00:00:00",
    "licenseExpiryDate": "04/08/2026 00:00:00"
  },
  {
    "id": "16873698-87c8-436f-8622-394fc1f2db81",
    "slug": "jacopo-nicolo-alessandro-crivellaro",
    "name": "Jacopo Nicolo Alessandro Crivellaro",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/09/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jacopo Nicolo Alessandro Crivellaro",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_16873698-87c8-436f-8622-394fc1f2db81",
        "address": "Al Fattan Currency House Tower 2 ,DIFC ,507176 ,",
        "phone": "/ 971552009003",
        "email": "Mohammad.AlRasheed@bakermckenzie.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "acd81e81-dead-4f7c-839e-0f2a57897265",
    "firmName": "Baker & Mckenzie LLP",
    "registrationNumber": "L-06742",
    "licenseIssueDate": "04/09/2025 00:00:00",
    "licenseExpiryDate": "04/08/2026 00:00:00"
  },
  {
    "id": "2b392be2-8cf0-4e0f-9582-57fc5395f7e1",
    "slug": "jad-taha",
    "name": "Jad Taha",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/11/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jad Taha",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2b392be2-8cf0-4e0f-9582-57fc5395f7e1",
        "address": "Index Tower ,Dubai International Financial Centre ,507115 ,",
        "phone": "97143757160 / 971523490280",
        "email": "tthraya@mayerbrown.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c7f52b69-c049-4246-963a-9805b241f88a",
    "firmName": "Mayer Brown LLP",
    "registrationNumber": "L-03732",
    "licenseIssueDate": "05/11/2017 00:00:00",
    "licenseExpiryDate": "05/08/2026 00:00:00"
  },
  {
    "id": "11150ea9-5607-475b-ad4b-fd0bac57afb1",
    "slug": "jade-gar-wah-chu",
    "name": "Jade Gar Wah Chu",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/04/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jade Gar Wah Chu",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_11150ea9-5607-475b-ad4b-fd0bac57afb1",
        "address": "",
        "phone": "97143184600 / 971504468184",
        "email": "melaraby@gibsondunn.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c9d2c9d0-6e43-4253-a75d-cdeb400f8d8e",
    "firmName": "Gibson Dunn & Crutcher LLP",
    "registrationNumber": "L-04378",
    "licenseIssueDate": "04/04/2019 00:00:00",
    "licenseExpiryDate": "04/02/2026 00:00:00"
  },
  {
    "id": "2e9e75dd-173b-4150-8661-bf002c4a7701",
    "slug": "jahnvi-rajesh-jhaveri-rajesh-chandrasen-jhaveri",
    "name": "Jahnvi Rajesh Jhaveri Rajesh Chandrasen Jhaveri",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/17/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jahnvi Rajesh Jhaveri Rajesh Chandrasen Jhaveri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2e9e75dd-173b-4150-8661-bf002c4a7701",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-06277",
    "licenseIssueDate": "04/17/2024 00:00:00",
    "licenseExpiryDate": "04/16/2026 00:00:00"
  },
  {
    "id": "b5b57423-8bf3-4188-b954-621fd265dc1d",
    "slug": "jakub-roszyk",
    "name": "Jakub Roszyk",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/04/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-03-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jakub Roszyk",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b5b57423-8bf3-4188-b954-621fd265dc1d",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-06161",
    "licenseIssueDate": "01/04/2024 00:00:00",
    "licenseExpiryDate": "01/03/2026 00:00:00"
  },
  {
    "id": "3d4c5ca7-6cd2-40ab-b4b0-ac5f38b84bab",
    "slug": "jaleela-shante-johnson",
    "name": "Jaleela SHante Johnson",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/27/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jaleela SHante Johnson",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3d4c5ca7-6cd2-40ab-b4b0-ac5f38b84bab",
        "address": "",
        "phone": "97143742800 / 971506450677",
        "email": "jabbott21@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7a59d310-ff72-4318-b41c-27095c163d0f",
    "firmName": "CMS (UAE) LLP",
    "registrationNumber": "L-05418",
    "licenseIssueDate": "07/27/2022 00:00:00",
    "licenseExpiryDate": "07/26/2026 00:00:00"
  },
  {
    "id": "6398a0ee-ca61-481d-aaf8-ea34df27d63c",
    "slug": "jamal-ali-baddour",
    "name": "Jamal Ali Baddour",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/04/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-03-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jamal Ali Baddour",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6398a0ee-ca61-481d-aaf8-ea34df27d63c",
        "address": "6F 603, 605, 7F 704 ,Crystal Tower ,Dubai Mall ,117538 ,Dubai",
        "phone": "97146098700",
        "email": "pro@miolawfirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "417f90a1-03be-4dab-8eea-1bba7e16f536",
    "firmName": "ABU BAKER SALEM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05688",
    "licenseIssueDate": "01/04/2023 00:00:00",
    "licenseExpiryDate": "01/03/2026 00:00:00"
  },
  {
    "id": "68d69121-8523-4bc3-9ea2-07f8dbc150d3",
    "slug": "jamal-ismail",
    "name": "Jamal Ismail",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jamal Ismail",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_68d69121-8523-4bc3-9ea2-07f8dbc150d3",
        "address": "",
        "phone": "97143304457",
        "email": "abduljawad@alqasemadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "19925cdf-cf68-49a0-8196-3b36ace2acdb",
    "firmName": "ABDULLJAWAD ALQASEM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01219",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "43433f11-c23a-4c19-9bb5-a71655844e5f",
    "slug": "james-abbott",
    "name": "James Abbott",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: James Abbott",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_43433f11-c23a-4c19-9bb5-a71655844e5f",
        "address": "",
        "phone": "97143742800 / 971506450677",
        "email": "jabbott21@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "7a59d310-ff72-4318-b41c-27095c163d0f",
    "firmName": "CMS (UAE) LLP",
    "registrationNumber": "L-00151",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "55044233-3d04-4e49-a4ae-3349f1cb8447",
    "slug": "james-alessandro-colautti",
    "name": "James Alessandro Colautti",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/01/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: James Alessandro Colautti",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_55044233-3d04-4e49-a4ae-3349f1cb8447",
        "address": "20 ,Index Tower West Tower ,DIFC ,507226 ,Dubai",
        "phone": "97142461900 / 971523391604",
        "email": "patrick.gearon@crsblaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e2ac552e-b9a7-450b-a84d-15119e583220",
    "firmName": "Charles Russell Speechlys LLP",
    "registrationNumber": "L-05097",
    "licenseIssueDate": "11/01/2021 00:00:00",
    "licenseExpiryDate": "10/31/2026 00:00:00"
  },
  {
    "id": "2692bc07-ed04-4315-958b-12108386ab90",
    "slug": "james-baldwin",
    "name": "James Baldwin",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/10/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: James Baldwin",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2692bc07-ed04-4315-958b-12108386ab90",
        "address": "",
        "phone": "97144073901 / 971503479508",
        "email": "Rania.Tadros@stephensonharwood.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dd5042a2-bb41-4123-9544-79c3fa831332",
    "firmName": "Stephenson Harwood (Middle East) LLP",
    "registrationNumber": "L-02075",
    "licenseIssueDate": "10/10/2012 00:00:00",
    "licenseExpiryDate": "10/02/2026 00:00:00"
  },
  {
    "id": "74bd617a-a503-480e-a22c-613e3fb143f2",
    "slug": "james-boyd-berry",
    "name": "James Boyd Berry",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/17/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: James Boyd Berry",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_74bd617a-a503-480e-a22c-613e3fb143f2",
        "address": "1 ,API World Tower ,258.37 square meters ,52294 ,Dubai",
        "phone": "97143317552 / 971504524322",
        "email": "berry@jamesberrylaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "f85683bf-f79f-4e38-9b7c-a1a75cd840b4",
    "firmName": "James Berry & Associates Legal Consultants",
    "registrationNumber": "L-00350",
    "licenseIssueDate": "12/17/2011 00:00:00",
    "licenseExpiryDate": "12/08/2025 00:00:00"
  },
  {
    "id": "1e31dbae-7913-4bff-be34-677d4aeb8747",
    "slug": "james-coleman",
    "name": "James Coleman",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/22/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: James Coleman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1e31dbae-7913-4bff-be34-677d4aeb8747",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506688 ,Dubai",
        "phone": "97147096600 / 971503556811",
        "email": "muneer.khan@simmons-simmons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d1725ca7-06ac-41b2-8d7b-a6e60665b73d",
    "firmName": "Simmons & Simmons (Middle East) LLP-DIFC",
    "registrationNumber": "L-03278",
    "licenseIssueDate": "10/22/2015 00:00:00",
    "licenseExpiryDate": "10/17/2026 00:00:00"
  },
  {
    "id": "2e2ca98e-dade-4e2e-b029-d32cbf9bb76c",
    "slug": "james-dunne",
    "name": "James Dunne",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/04/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: James Dunne",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2e2ca98e-dade-4e2e-b029-d32cbf9bb76c",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-02755",
    "licenseIssueDate": "06/04/2014 00:00:00",
    "licenseExpiryDate": "05/29/2026 00:00:00"
  },
  {
    "id": "b9ca50e5-b4a1-41df-88e9-48ce065e3a08",
    "slug": "james-fox",
    "name": "James Fox",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/18/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: James Fox",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b9ca50e5-b4a1-41df-88e9-48ce065e3a08",
        "address": "Al Fattan Currency House - Tower 1  ,Dubai International Financial Center  ,507104 ,",
        "phone": "97143978565 / 971504587822",
        "email": "Raafat.hares@dwf.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "6e5f6dba-07af-4109-8c34-175296450f94",
    "firmName": "DWF (Middle East) LLP",
    "registrationNumber": "L-04028",
    "licenseIssueDate": "02/18/2018 00:00:00",
    "licenseExpiryDate": "02/15/2026 00:00:00"
  },
  {
    "id": "2b8a6f03-dba1-4cd9-9677-2ca9a40111e5",
    "slug": "james-iremonger",
    "name": "James Iremonger",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: James Iremonger",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2b8a6f03-dba1-4cd9-9677-2ca9a40111e5",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-00650",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "e3d0907c-6aff-4628-af0b-27664648be22",
    "slug": "james-marc-dadford",
    "name": "James Marc Dadford",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/11/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: James Marc Dadford",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e3d0907c-6aff-4628-af0b-27664648be22",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-04231",
    "licenseIssueDate": "10/11/2018 00:00:00",
    "licenseExpiryDate": "10/09/2026 00:00:00"
  },
  {
    "id": "419d17a1-0a04-4b4b-a1f1-b8a46635ef97",
    "slug": "james-osunsanmi",
    "name": "James Osunsanmi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/13/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: James Osunsanmi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_419d17a1-0a04-4b4b-a1f1-b8a46635ef97",
        "address": "",
        "phone": "97145953601 / 971508728645",
        "email": "Steven.Bainbridge@gtlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b4146aa6-efd1-41d7-819d-49da46353b0b",
    "firmName": "Greenberg Traurig Limited",
    "registrationNumber": "L-01969",
    "licenseIssueDate": "09/13/2012 00:00:00",
    "licenseExpiryDate": "09/05/2026 00:00:00"
  },
  {
    "id": "231f37ec-1979-428a-9754-fbe522a927f9",
    "slug": "james-plant",
    "name": "James Plant",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/29/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: James Plant",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_231f37ec-1979-428a-9754-fbe522a927f9",
        "address": "",
        "phone": "97144230555 / 971504788443",
        "email": "yah@hfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c462c65e-185a-4e81-8425-a87e3a2b6842",
    "firmName": "Holman Fenwick Willan Middle East LLP",
    "registrationNumber": "L-03098",
    "licenseIssueDate": "07/29/2015 00:00:00",
    "licenseExpiryDate": "07/24/2026 00:00:00"
  },
  {
    "id": "6535a66e-6f23-45e0-81bb-16be1ea7b5f2",
    "slug": "james-samuel-lehmann",
    "name": "James Samuel Lehmann",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/31/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: James Samuel Lehmann",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6535a66e-6f23-45e0-81bb-16be1ea7b5f2",
        "address": "Index Tower ,DIFC ,506896 ,",
        "phone": "97142782300 / 971551154791",
        "email": "GLeggate@wfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e2b82cfc-80a5-4957-ae41-b1a7beb693c1",
    "firmName": "Watson, Farley & Williams (Middle East) LLP",
    "registrationNumber": "L-06337",
    "licenseIssueDate": "05/31/2024 00:00:00",
    "licenseExpiryDate": "05/30/2026 00:00:00"
  },
  {
    "id": "ae67d687-7f3e-4857-ab7c-e9b9a9ae7606",
    "slug": "james-stull",
    "name": "James Stull",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/16/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-08-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: James Stull",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ae67d687-7f3e-4857-ab7c-e9b9a9ae7606",
        "address": "",
        "phone": "97143779900 / 971508548052",
        "email": "jali@kslaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dff8529a-82be-431a-b72b-0192ff238011",
    "firmName": "King & Spalding LLP",
    "registrationNumber": "L-01135",
    "licenseIssueDate": "01/16/2013 00:00:00",
    "licenseExpiryDate": "01/08/2026 00:00:00"
  },
  {
    "id": "85b8f530-c256-4250-9488-c7a62197398c",
    "slug": "james-whittam",
    "name": "James Whittam",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/04/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: James Whittam",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_85b8f530-c256-4250-9488-c7a62197398c",
        "address": "6 ,Office Nos. 603, 604 & 605, Level 6, Burj Daman ,Dubai International Financial Centre ,506555 ,Dubai",
        "phone": "97143506400 / 971504654755",
        "email": "r.hickman@aglaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8690f7d5-6b96-4649-9589-71303f2c2707",
    "firmName": "Addleshaw Goddard (Middle East) LLP",
    "registrationNumber": "L-05047",
    "licenseIssueDate": "10/04/2021 00:00:00",
    "licenseExpiryDate": "10/03/2026 00:00:00"
  },
  {
    "id": "104038d0-9ba7-4bc9-b822-699b4816d3b8",
    "slug": "james-william-thyer",
    "name": "James William Thyer",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/09/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: James William Thyer",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_104038d0-9ba7-4bc9-b822-699b4816d3b8",
        "address": "THE OFFICES 1 ,DWTC ,115580 ,",
        "phone": "97143739700 / 971501148248",
        "email": "nitesh.pradhan@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "361fdc64-6b6f-4f37-abca-c52af8473b84",
    "firmName": "Pinsent Masons  LLP (DWTCA Branch)",
    "registrationNumber": "L-06733",
    "licenseIssueDate": "04/09/2025 00:00:00",
    "licenseExpiryDate": "04/08/2026 00:00:00"
  },
  {
    "id": "a28225d4-585e-4883-b0df-7c6a636c6770",
    "slug": "james-willn",
    "name": "James Willn",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/21/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-01-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: James Willn",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a28225d4-585e-4883-b0df-7c6a636c6770",
        "address": "Index Tower ,506548 ,Dubai",
        "phone": "97147096300 / 971506767433",
        "email": "amateen@reedsmith.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b3f87e90-7ce9-4097-82c4-15232365f175",
    "firmName": "Reed Smith LLP",
    "registrationNumber": "L-01901",
    "licenseIssueDate": "01/21/2013 00:00:00",
    "licenseExpiryDate": "01/13/2026 00:00:00"
  },
  {
    "id": "4ec82410-2660-491d-bc24-d297d9afe68e",
    "slug": "jamie-paul-tredgold",
    "name": "JAMIE PAUL TREDGOLD",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/03/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: JAMIE PAUL TREDGOLD",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4ec82410-2660-491d-bc24-d297d9afe68e",
        "address": "IH-00-01-CP-05 ,DIFC ,506832 ,",
        "phone": "/ 971506957753",
        "email": "admin@supportlegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "1607c199-ca4b-4bc1-89e9-98dad0300645",
    "firmName": "Support Legal ( DIFC) Limited",
    "registrationNumber": "L-05809",
    "licenseIssueDate": "05/03/2023 00:00:00",
    "licenseExpiryDate": "05/02/2026 00:00:00"
  },
  {
    "id": "236eca31-9015-4eff-916a-e9a06afdac7f",
    "slug": "jamie-ryder",
    "name": "Jamie Ryder",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jamie Ryder",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_236eca31-9015-4eff-916a-e9a06afdac7f",
        "address": "Index Tower ,506548 ,Dubai",
        "phone": "97147096300 / 971506767433",
        "email": "amateen@reedsmith.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b3f87e90-7ce9-4097-82c4-15232365f175",
    "firmName": "Reed Smith LLP",
    "registrationNumber": "L-00652",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "bbb948f4-97fc-4ab1-8da4-0fe632d3cb61",
    "slug": "jan-olavi-jensen",
    "name": "Jan Olavi Jensen",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/04/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jan Olavi Jensen",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bbb948f4-97fc-4ab1-8da4-0fe632d3cb61",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-06457",
    "licenseIssueDate": "09/04/2024 00:00:00",
    "licenseExpiryDate": "09/03/2026 00:00:00"
  },
  {
    "id": "e6a9151a-3185-4b26-876c-89bae5a6e16b",
    "slug": "jan-stefan-schwarzfischer",
    "name": "Jan Stefan Schwarzfischer",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/21/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jan Stefan Schwarzfischer",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e6a9151a-3185-4b26-876c-89bae5a6e16b",
        "address": "ICD-Brookfield Place ,DIFC ,119974 ,",
        "phone": "97143652000",
        "email": "david.charlier@ashurst.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c01c3c61-4d90-4058-8429-61dd01e615f5",
    "firmName": "Ashurst LLP-DIFC",
    "registrationNumber": "L-05870",
    "licenseIssueDate": "06/21/2023 00:00:00",
    "licenseExpiryDate": "06/20/2026 00:00:00"
  },
  {
    "id": "8562ba29-4104-4054-a4e0-94bbd0306d41",
    "slug": "janardhan-shetty",
    "name": "Janardhan Shetty",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/22/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Janardhan Shetty",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8562ba29-4104-4054-a4e0-94bbd0306d41",
        "address": "",
        "phone": "97142776075 / 971588324788",
        "email": "avichal@kochhardubai.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "847eff7c-4142-431e-a8d6-f58ff60964f6",
    "firmName": "Kochhar & Co Inc Legal Consultants (Dubai Branch)",
    "registrationNumber": "L-00457",
    "licenseIssueDate": "11/22/2011 00:00:00",
    "licenseExpiryDate": "11/13/2025 00:00:00"
  },
  {
    "id": "fa8fac1f-2756-435a-9ceb-54bc77e3305a",
    "slug": "jane-elspeth-ina-elsolh",
    "name": "Jane Elspeth Ina Elsolh",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/24/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jane Elspeth Ina Elsolh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fa8fac1f-2756-435a-9ceb-54bc77e3305a",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-05784",
    "licenseIssueDate": "05/24/2023 00:00:00",
    "licenseExpiryDate": "05/23/2026 00:00:00"
  },
  {
    "id": "611c16b9-bd64-438f-b33d-5da555b9845a",
    "slug": "jane-flournoy",
    "name": "Jane Flournoy",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/01/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jane Flournoy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_611c16b9-bd64-438f-b33d-5da555b9845a",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506688 ,Dubai",
        "phone": "97147096600 / 971503556811",
        "email": "muneer.khan@simmons-simmons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d1725ca7-06ac-41b2-8d7b-a6e60665b73d",
    "firmName": "Simmons & Simmons (Middle East) LLP-DIFC",
    "registrationNumber": "L-00414",
    "licenseIssueDate": "11/01/2016 00:00:00",
    "licenseExpiryDate": "10/28/2025 00:00:00"
  },
  {
    "id": "b7781987-6f87-4fc0-a608-e9ef22734a31",
    "slug": "jane-iskandar",
    "name": "Jane Iskandar",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/15/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jane Iskandar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b7781987-6f87-4fc0-a608-e9ef22734a31",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-06023",
    "licenseIssueDate": "09/15/2023 00:00:00",
    "licenseExpiryDate": "09/14/2026 00:00:00"
  },
  {
    "id": "efff7fb7-6c18-407d-8a44-3bafc5ec809f",
    "slug": "janeen-pickering",
    "name": "Janeen Pickering",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/18/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Janeen Pickering",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_efff7fb7-6c18-407d-8a44-3bafc5ec809f",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-03329",
    "licenseIssueDate": "10/18/2015 00:00:00",
    "licenseExpiryDate": "10/13/2025 00:00:00"
  },
  {
    "id": "bb5131ae-f007-49a6-8c31-e897dc4ca93f",
    "slug": "janelle-moussa",
    "name": "Janelle Moussa",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/14/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Janelle Moussa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bb5131ae-f007-49a6-8c31-e897dc4ca93f",
        "address": "",
        "phone": "97143779377 / 971505528593",
        "email": "rahail.ali@hoganlovells.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ef4b209f-a5f1-446f-82de-1b0675bbf53b",
    "firmName": "Hogan Lovells Middle East LLP",
    "registrationNumber": "L-05654",
    "licenseIssueDate": "12/14/2022 00:00:00",
    "licenseExpiryDate": "12/13/2025 00:00:00"
  },
  {
    "id": "b61c0f82-45aa-495b-828f-72b8f3fd4890",
    "slug": "janine-mallis",
    "name": "Janine Mallis",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/04/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Janine Mallis",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b61c0f82-45aa-495b-828f-72b8f3fd4890",
        "address": "",
        "phone": "97144286300 / 971506256686",
        "email": "stuart.paterson@hsf.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2f0389b3-bfde-44f4-bdd6-6e1a22f9cab2",
    "firmName": "Herbert Smith Freehills Kramer LLP",
    "registrationNumber": "L-03161",
    "licenseIssueDate": "10/04/2015 00:00:00",
    "licenseExpiryDate": "09/29/2026 00:00:00"
  },
  {
    "id": "ca794f7a-6cbf-460e-8a5d-6d64d3a46091",
    "slug": "janis-reinholtz",
    "name": "Janis Reinholtz",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/08/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Janis Reinholtz",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ca794f7a-6cbf-460e-8a5d-6d64d3a46091",
        "address": "",
        "phone": "97144323671 / 971505589395",
        "email": "fba@amereller.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a139ca64-8897-4d1d-8d71-97446bc1e15a",
    "firmName": "Amereller Legal Consultancy LLC SOC",
    "registrationNumber": "L-06297",
    "licenseIssueDate": "05/08/2024 00:00:00",
    "licenseExpiryDate": "05/07/2026 00:00:00"
  },
  {
    "id": "82ee86ec-c120-472a-9961-ea83bfd47834",
    "slug": "jasamin-fichte",
    "name": "Jasamin Fichte",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jasamin Fichte",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_82ee86ec-c120-472a-9961-ea83bfd47834",
        "address": "23 ,Rolex Tower ,Trade Center Second ,116637 ,Dubai",
        "phone": "97144357577 / 971502101003",
        "email": "jasamin.fichte@fichtelegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "77bf4fd2-1cd1-4bda-a0c2-ffcac3980b76",
    "firmName": "Fichte & Co Legal Consultancy",
    "registrationNumber": "L-00546",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "a28ebe86-66e0-4be3-9061-025bf449eb81",
    "slug": "jasem-saleh-alanizy",
    "name": "Jasem Saleh Alanizy",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/28/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jasem Saleh Alanizy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a28ebe86-66e0-4be3-9061-025bf449eb81",
        "address": "6 ,Office Nos. 603, 604 & 605, Level 6, Burj Daman ,Dubai International Financial Centre ,506555 ,Dubai",
        "phone": "97143506400 / 971504654755",
        "email": "r.hickman@aglaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8690f7d5-6b96-4649-9589-71303f2c2707",
    "firmName": "Addleshaw Goddard (Middle East) LLP",
    "registrationNumber": "L-04478",
    "licenseIssueDate": "08/28/2019 00:00:00",
    "licenseExpiryDate": "08/27/2026 00:00:00"
  },
  {
    "id": "0dac26ba-e43a-4c18-8baa-335a9d38719f",
    "slug": "jason-anthony-gouveia",
    "name": "Jason Anthony Gouveia",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/15/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jason Anthony Gouveia",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0dac26ba-e43a-4c18-8baa-335a9d38719f",
        "address": "ICD-Brookfield Place ,DIFC ,119974 ,",
        "phone": "97143652000",
        "email": "david.charlier@ashurst.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c01c3c61-4d90-4058-8429-61dd01e615f5",
    "firmName": "Ashurst LLP-DIFC",
    "registrationNumber": "L-05106",
    "licenseIssueDate": "11/15/2021 00:00:00",
    "licenseExpiryDate": "11/14/2025 00:00:00"
  },
  {
    "id": "b71e64cf-7fa8-497a-a6f8-ca69152f9f44",
    "slug": "jason-bryan-parker",
    "name": "JASON BRYAN PARKER",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/03/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: JASON BRYAN PARKER",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b71e64cf-7fa8-497a-a6f8-ca69152f9f44",
        "address": "1 ,The Gate, East. ,The Gate District ,118273 ,Dubai",
        "phone": "97144019160 / 971506575038",
        "email": "ptiller@huntonak.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "61016a31-ead9-482a-b4d3-7cd63e5ba82b",
    "firmName": "Hunton Andrews Kurth Ltd",
    "registrationNumber": "L-06944",
    "licenseIssueDate": "08/22/2025 00:00:00",
    "licenseExpiryDate": "08/21/2026 00:00:00"
  },
  {
    "id": "be0d7cab-c8dd-4fb1-8795-cd737f79c155",
    "slug": "jason-francis-manyenyeni",
    "name": "Jason Francis Manyenyeni",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/02/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jason Francis Manyenyeni",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_be0d7cab-c8dd-4fb1-8795-cd737f79c155",
        "address": "Building 5 ,Dubai World Trade Centre ,212620 ,",
        "phone": "97143503600 / 971563631562",
        "email": "p.ellingham@kennedys-law.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "83d3ede1-3a28-4b03-8c92-6bd31a1cb95e",
    "firmName": "Kennedys Dubai LLP",
    "registrationNumber": "L-05950",
    "licenseIssueDate": "08/02/2023 00:00:00",
    "licenseExpiryDate": "08/01/2026 00:00:00"
  },
  {
    "id": "cc302bd4-1b06-4d17-b506-888cb31f18df",
    "slug": "jason-robert-corbett",
    "name": "Jason Robert Corbett",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/26/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jason Robert Corbett",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cc302bd4-1b06-4d17-b506-888cb31f18df",
        "address": "Unit 03-OF-02-03-OF-09, Level 03 ,Gate Village Building 08 ,Dubai International Financial Centre ,000 ,Dubai",
        "phone": "97100000000 / 971501051651",
        "email": "gabriel@uae.silklegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "790219ab-49b9-40f2-97c3-bff01feebf69",
    "firmName": "Silk Legal Company Limited",
    "registrationNumber": "L-06398",
    "licenseIssueDate": "06/26/2024 00:00:00",
    "licenseExpiryDate": "06/25/2026 00:00:00"
  },
  {
    "id": "54bcdb88-98a2-439c-a10c-c3f9f48ef64e",
    "slug": "jaspreet-shoker",
    "name": "Jaspreet Shoker",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/20/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jaspreet Shoker",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_54bcdb88-98a2-439c-a10c-c3f9f48ef64e",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506688 ,Dubai",
        "phone": "97147096600 / 971503556811",
        "email": "muneer.khan@simmons-simmons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d1725ca7-06ac-41b2-8d7b-a6e60665b73d",
    "firmName": "Simmons & Simmons (Middle East) LLP-DIFC",
    "registrationNumber": "L-04571",
    "licenseIssueDate": "02/20/2020 00:00:00",
    "licenseExpiryDate": "02/19/2026 00:00:00"
  },
  {
    "id": "e4baad58-06d8-4fbb-b7d3-6d98a98e2337",
    "slug": "javid-khalid-rafiq",
    "name": "Javid Khalid Rafiq",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/09/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Javid Khalid Rafiq",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e4baad58-06d8-4fbb-b7d3-6d98a98e2337",
        "address": "",
        "phone": "97143116556 / 971000000000",
        "email": "info@hazlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d34586c5-1e0a-4290-af29-23366d37b852",
    "firmName": "HOYAM ALZAROUNI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01442",
    "licenseIssueDate": "08/09/2012 00:00:00",
    "licenseExpiryDate": "08/01/2026 00:00:00"
  },
  {
    "id": "eb7d9cd8-48ea-438b-b1d1-5ee01075e2a1",
    "slug": "jean-francois-rycx",
    "name": "Jean-Francois Rycx",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jean-Francois Rycx",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_eb7d9cd8-48ea-438b-b1d1-5ee01075e2a1",
        "address": "",
        "phone": "97143467303 / 971506565383",
        "email": "rycx@rycx-advocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "7a4cdbcc-cf3b-4347-b745-b8e670c81ca0",
    "firmName": "Rycx Legal Consultants",
    "registrationNumber": "L-00398",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "bd2f9d8b-9f81-49b0-beb6-272fcc0c30cc",
    "slug": "jeanne-elize-visser",
    "name": "Jeanne Elize Visser",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/05/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jeanne Elize Visser",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bd2f9d8b-9f81-49b0-beb6-272fcc0c30cc",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-06712",
    "licenseIssueDate": "03/05/2025 00:00:00",
    "licenseExpiryDate": "03/04/2026 00:00:00"
  },
  {
    "id": "87d16673-0d28-4b1d-8a03-24d80422e860",
    "slug": "jeannette-kabbabe",
    "name": "Jeannette Kabbabe",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/07/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jeannette Kabbabe",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_87d16673-0d28-4b1d-8a03-24d80422e860",
        "address": "",
        "phone": "97143098000 / 971552210883",
        "email": "belturk@rouse.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9df4d4e5-5243-4fae-8d95-463d110ce6a8",
    "firmName": "Rouse & Co International Limited (Dubai Branch)",
    "registrationNumber": "L-03401",
    "licenseIssueDate": "11/07/2022 00:00:00",
    "licenseExpiryDate": "11/06/2025 00:00:00"
  },
  {
    "id": "b820d1f0-8a7d-4724-ac5a-6a5fccfcd8ac",
    "slug": "jed-savager",
    "name": "Jed Savager",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jed Savager",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b820d1f0-8a7d-4724-ac5a-6a5fccfcd8ac",
        "address": "- ,THE OFFICES 1 ,DWTC ,115580 ,Dubai",
        "phone": "97143739700 / 971562196031",
        "email": "catherine.workman@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6b4ebb23-ef2e-4305-a1ee-43a11e4b1cae",
    "firmName": "Pinsent Masons LLP - Dubai Branch",
    "registrationNumber": "L-00907",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "12e91839-f8be-4044-b9f7-9424b57284c0",
    "slug": "jeffrey-frimpong-effah",
    "name": "Jeffrey Frimpong Effah",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/15/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jeffrey Frimpong Effah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_12e91839-f8be-4044-b9f7-9424b57284c0",
        "address": "0 ,ICD Brookfield Place Level 13 ,Trade Centre ,506569 ,Dubai",
        "phone": "97145099100 / 971501006965",
        "email": "menahr@freshfields.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "970f6246-e737-41a7-9c6c-5aa5b8335d45",
    "firmName": "Freshfields LLP DIFC",
    "registrationNumber": "L-05238",
    "licenseIssueDate": "03/15/2022 00:00:00",
    "licenseExpiryDate": "03/14/2026 00:00:00"
  },
  {
    "id": "c0cd1826-0608-4e17-8cc5-8056d6e85edc",
    "slug": "jeffy-cruz-jeyakumar-thomas-varghese-jeyakumar",
    "name": "Jeffy Cruz Jeyakumar Thomas Varghese Jeyakumar",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/31/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jeffy Cruz Jeyakumar Thomas Varghese Jeyakumar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c0cd1826-0608-4e17-8cc5-8056d6e85edc",
        "address": "",
        "phone": "97142396646",
        "email": "advo_alblooshi@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3ab5acef-85ac-482b-91f2-4e0a34fd6af7",
    "firmName": "ABDELAZIZ AL BLOUSHI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06336",
    "licenseIssueDate": "06/02/2025 00:00:00",
    "licenseExpiryDate": "06/01/2026 00:00:00"
  },
  {
    "id": "e9cb25bb-f514-49f3-82c1-ad1dbfd0e6d3",
    "slug": "jeimmy-gabriela-ocana-benavides",
    "name": "Jeimmy Gabriela Ocana Benavides",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/24/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jeimmy Gabriela Ocana Benavides",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e9cb25bb-f514-49f3-82c1-ad1dbfd0e6d3",
        "address": "Index Tower ,DIFC ,506896 ,",
        "phone": "97142782300 / 971551154791",
        "email": "GLeggate@wfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e2b82cfc-80a5-4957-ae41-b1a7beb693c1",
    "firmName": "Watson, Farley & Williams (Middle East) LLP",
    "registrationNumber": "L-06434",
    "licenseIssueDate": "07/24/2024 00:00:00",
    "licenseExpiryDate": "07/23/2026 00:00:00"
  },
  {
    "id": "36f7b861-58dc-439f-9b49-d2b7354deb65",
    "slug": "jemima-clare-mcdonald",
    "name": "Jemima Clare McDonald",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/08/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jemima Clare McDonald",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_36f7b861-58dc-439f-9b49-d2b7354deb65",
        "address": "Building 5 ,Dubai World Trade Centre ,212620 ,",
        "phone": "97143503600 / 971563631562",
        "email": "p.ellingham@kennedys-law.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "83d3ede1-3a28-4b03-8c92-6bd31a1cb95e",
    "firmName": "Kennedys Dubai LLP",
    "registrationNumber": "L-04340",
    "licenseIssueDate": "03/08/2025 00:00:00",
    "licenseExpiryDate": "03/07/2026 00:00:00"
  },
  {
    "id": "9ca1b188-33c9-4d49-914c-09196c6a1932",
    "slug": "jenika-pankhania",
    "name": "Jenika Pankhania",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/30/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jenika Pankhania",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9ca1b188-33c9-4d49-914c-09196c6a1932",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-05611",
    "licenseIssueDate": "11/30/2022 00:00:00",
    "licenseExpiryDate": "11/29/2025 00:00:00"
  },
  {
    "id": "10f2560a-b035-4752-b3fd-9594ba275fe3",
    "slug": "jenine-t-abdeljaber",
    "name": "JENINE T ABDELJABER",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/16/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: JENINE T ABDELJABER",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_10f2560a-b035-4752-b3fd-9594ba275fe3",
        "address": "Index Tower ,506548 ,Dubai",
        "phone": "97147096300 / 971506767433",
        "email": "amateen@reedsmith.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b3f87e90-7ce9-4097-82c4-15232365f175",
    "firmName": "Reed Smith LLP",
    "registrationNumber": "L-04494",
    "licenseIssueDate": "08/16/2024 00:00:00",
    "licenseExpiryDate": "08/15/2026 00:00:00"
  },
  {
    "id": "5d834993-65dd-4820-99d9-da9e17130312",
    "slug": "jennifer-chimanga",
    "name": "Jennifer Chimanga",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/09/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jennifer Chimanga",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5d834993-65dd-4820-99d9-da9e17130312",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-06878",
    "licenseIssueDate": "07/09/2025 00:00:00",
    "licenseExpiryDate": "07/08/2026 00:00:00"
  },
  {
    "id": "6a58fdd3-cee6-46b9-90c0-297063d1ff85",
    "slug": "jennifer-hanna",
    "name": "Jennifer Hanna",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/25/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jennifer Hanna",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6a58fdd3-cee6-46b9-90c0-297063d1ff85",
        "address": "ICD Brookfield Place ,Za'abeel 2 ,103747 ,",
        "phone": "97143696300 / 971506008159",
        "email": "mohammed.paracha@nortonrosefulbright.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c4aaee93-0ec4-4982-9a48-a23699492056",
    "firmName": "Norton Rose Fullbright (Middle East) LLP",
    "registrationNumber": "L-04068",
    "licenseIssueDate": "03/25/2018 00:00:00",
    "licenseExpiryDate": "03/22/2026 00:00:00"
  },
  {
    "id": "21719dda-c9b3-4c91-9854-f46562d9ab56",
    "slug": "jennifer-kamal-abou-fadel",
    "name": "Jennifer Kamal Abou Fadel",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/03/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jennifer Kamal Abou Fadel",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_21719dda-c9b3-4c91-9854-f46562d9ab56",
        "address": "One Central, The Offices 5 ,Dubai World Trade Centre ,554660 ,",
        "phone": "97142052030 / 971506566494",
        "email": "chourani@houranipartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "59a73632-40a0-4849-b120-4308dc6f8015",
    "firmName": "Hourani & Partners Legal Consultancy FZCO",
    "registrationNumber": "L-04930",
    "licenseIssueDate": "05/03/2021 00:00:00",
    "licenseExpiryDate": "05/02/2026 00:00:00"
  },
  {
    "id": "1077107f-3253-4b97-b106-83f32dd5e6f9",
    "slug": "jennifer-leader",
    "name": "Jennifer Leader",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/07/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jennifer Leader",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1077107f-3253-4b97-b106-83f32dd5e6f9",
        "address": "THE OFFICES 1 ,DWTC ,115580 ,",
        "phone": "97143739700 / 971501148248",
        "email": "nitesh.pradhan@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "361fdc64-6b6f-4f37-abca-c52af8473b84",
    "firmName": "Pinsent Masons  LLP (DWTCA Branch)",
    "registrationNumber": "L-03019",
    "licenseIssueDate": "06/07/2015 00:00:00",
    "licenseExpiryDate": "06/02/2026 00:00:00"
  },
  {
    "id": "52e843b4-0e6b-4352-86af-c18d2e4a52dc",
    "slug": "jennifer-paterson",
    "name": "Jennifer Paterson",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/06/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jennifer Paterson",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_52e843b4-0e6b-4352-86af-c18d2e4a52dc",
        "address": "",
        "phone": "97144272700 / 971545824605",
        "email": "tony.griffiths@klgates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "fb8fc340-ceef-4b83-8f2b-9b24d4604967",
    "firmName": "K & L Gates LLP",
    "registrationNumber": "L-00952",
    "licenseIssueDate": "08/06/2017 00:00:00",
    "licenseExpiryDate": "08/03/2026 00:00:00"
  },
  {
    "id": "3b244c5e-6295-4d03-917f-efdec6c26a15",
    "slug": "jeremy-barker",
    "name": "Jeremy Barker",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/12/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jeremy Barker",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3b244c5e-6295-4d03-917f-efdec6c26a15",
        "address": "",
        "phone": "97145032600 / 971504577931",
        "email": "edmund.boyo@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8cca52de-2c74-4743-b8f2-0b904d96b132",
    "firmName": "CC Worldwide Limited",
    "registrationNumber": "L-03040",
    "licenseIssueDate": "03/12/2015 00:00:00",
    "licenseExpiryDate": "03/06/2026 00:00:00"
  },
  {
    "id": "537fdaa3-9bf5-468d-ab1b-1524835d5026",
    "slug": "jeremy-miocevic",
    "name": "Jeremy Miocevic",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jeremy Miocevic",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_537fdaa3-9bf5-468d-ab1b-1524835d5026",
        "address": "",
        "phone": "97143826100 / 971507380618",
        "email": "jmiocevic@curtis.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "0867bcc5-10fa-4783-91ae-b8f63e02e81a",
    "firmName": "Curtis Mallet-Prevost, Colt & Mosle LLP",
    "registrationNumber": "L-00931",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "89277d5b-a5d1-4f07-9493-0c05c92dff68",
    "slug": "jeremy-paul-munce",
    "name": "Jeremy Paul Munce",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/01/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jeremy Paul Munce",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_89277d5b-a5d1-4f07-9493-0c05c92dff68",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-04870",
    "licenseIssueDate": "03/01/2021 00:00:00",
    "licenseExpiryDate": "02/28/2026 00:00:00"
  },
  {
    "id": "3aa26d9f-23bf-4720-824f-22d1457d7cea",
    "slug": "jeremy-russell",
    "name": "Jeremy Russell",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/20/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jeremy Russell",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3aa26d9f-23bf-4720-824f-22d1457d7cea",
        "address": "",
        "phone": "97143563900 / 971564663035",
        "email": "c.miller@Beale-Law.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0f74c5fc-87d6-451a-b380-576b0bc3ceb8",
    "firmName": "Beale & Company (Middle East)",
    "registrationNumber": "L-03637",
    "licenseIssueDate": "02/20/2017 00:00:00",
    "licenseExpiryDate": "02/16/2026 00:00:00"
  },
  {
    "id": "2226d5f4-3756-4aff-b26b-0bd0e2f1762b",
    "slug": "jeremy-scott",
    "name": "Jeremy Scott",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/14/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jeremy Scott",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2226d5f4-3756-4aff-b26b-0bd0e2f1762b",
        "address": "6 ,Office Nos. 603, 604 & 605, Level 6, Burj Daman ,Dubai International Financial Centre ,506555 ,Dubai",
        "phone": "97143506400 / 971504654755",
        "email": "r.hickman@aglaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8690f7d5-6b96-4649-9589-71303f2c2707",
    "firmName": "Addleshaw Goddard (Middle East) LLP",
    "registrationNumber": "L-01269",
    "licenseIssueDate": "07/14/2014 00:00:00",
    "licenseExpiryDate": "07/08/2026 00:00:00"
  },
  {
    "id": "07d9b186-e6bc-43cc-a796-8805a458cec7",
    "slug": "jeremy-speller",
    "name": "Jeremy Speller",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/01/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jeremy Speller",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_07d9b186-e6bc-43cc-a796-8805a458cec7",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-03070",
    "licenseIssueDate": "02/01/2015 00:00:00",
    "licenseExpiryDate": "01/26/2026 00:00:00"
  },
  {
    "id": "d50de0a3-ad48-456d-bb49-b36bf5dbe955",
    "slug": "jerry-parks",
    "name": "Jerry Parks",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/08/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jerry Parks",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d50de0a3-ad48-456d-bb49-b36bf5dbe955",
        "address": "",
        "phone": "97104309100 / 971564013758",
        "email": "c.royle@taylorwessing.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d51b6f43-8c62-486f-a1ab-6ee3b87c8006",
    "firmName": "Taylor Wessing LLP (Dubai Branch)",
    "registrationNumber": "L-00999",
    "licenseIssueDate": "09/08/2011 00:00:00",
    "licenseExpiryDate": "08/30/2026 00:00:00"
  },
  {
    "id": "4a964481-0991-48e7-a90b-5be80dcd9412",
    "slug": "jessica-elizabeth-quinlan",
    "name": "Jessica Elizabeth Quinlan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/06/2022",
    "licenseStatus": "active",
    "licenseExpiry": "2023-06-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jessica Elizabeth Quinlan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4a964481-0991-48e7-a90b-5be80dcd9412",
        "address": "",
        "phone": "97143779377 / 971505528593",
        "email": "rahail.ali@hoganlovells.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ef4b209f-a5f1-446f-82de-1b0675bbf53b",
    "firmName": "Hogan Lovells Middle East LLP",
    "registrationNumber": "L-05351",
    "licenseIssueDate": "06/01/2022 00:00:00",
    "licenseExpiryDate": "05/31/2026 00:00:00"
  },
  {
    "id": "1ce90f0b-8d8a-44fa-901f-fece2344b49d",
    "slug": "jessica-jade-roux",
    "name": "Jessica Jade Roux",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/02/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jessica Jade Roux",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1ce90f0b-8d8a-44fa-901f-fece2344b49d",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-05954",
    "licenseIssueDate": "08/02/2023 00:00:00",
    "licenseExpiryDate": "08/01/2026 00:00:00"
  },
  {
    "id": "9bc0a4ba-5a87-44dd-852e-0ca1ba78eb51",
    "slug": "jessica-rose-lilla-mcsoriley",
    "name": "Jessica Rose Lilla MCSORILEY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/17/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jessica Rose Lilla MCSORILEY",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9bc0a4ba-5a87-44dd-852e-0ca1ba78eb51",
        "address": "Unit No. S1003, Level 10 ,Emirates Financial Towers ,Dubai International Financial Centre ,000 ,Dubai",
        "phone": "97144501900 / 971566072398",
        "email": "david.welford@ogier.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7387d35c-79ea-44c2-88c5-58669a5e825d",
    "firmName": "Ogier (DIFC) LLP",
    "registrationNumber": "L-06869",
    "licenseIssueDate": "06/17/2025 00:00:00",
    "licenseExpiryDate": "06/16/2026 00:00:00"
  },
  {
    "id": "298bb3bb-9d34-4320-8aad-1f462fd94ed5",
    "slug": "jessica-therese-white",
    "name": "Jessica Therese White",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/18/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jessica Therese White",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_298bb3bb-9d34-4320-8aad-1f462fd94ed5",
        "address": "THE OFFICES 1 ,DWTC ,115580 ,",
        "phone": "97143739700 / 971501148248",
        "email": "nitesh.pradhan@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "361fdc64-6b6f-4f37-abca-c52af8473b84",
    "firmName": "Pinsent Masons  LLP (DWTCA Branch)",
    "registrationNumber": "L-05385",
    "licenseIssueDate": "07/18/2022 00:00:00",
    "licenseExpiryDate": "07/17/2026 00:00:00"
  },
  {
    "id": "741a223c-2f41-49dc-a15f-21d4aed957e2",
    "slug": "jianxiao-feng",
    "name": "Jianxiao Feng",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/22/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jianxiao Feng",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_741a223c-2f41-49dc-a15f-21d4aed957e2",
        "address": "",
        "phone": "97144286300 / 971506256686",
        "email": "stuart.paterson@hsf.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2f0389b3-bfde-44f4-bdd6-6e1a22f9cab2",
    "firmName": "Herbert Smith Freehills Kramer LLP",
    "registrationNumber": "L-06331",
    "licenseIssueDate": "05/22/2024 00:00:00",
    "licenseExpiryDate": "05/21/2026 00:00:00"
  },
  {
    "id": "c1a50bb5-f238-40b5-837e-8ccabb7e2db9",
    "slug": "jie-zhang",
    "name": "Jie Zhang",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKWgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/23/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jie Zhang",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c1a50bb5-f238-40b5-837e-8ccabb7e2db9",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-06770",
    "licenseIssueDate": "04/23/2025 00:00:00",
    "licenseExpiryDate": "04/22/2026 00:00:00"
  },
  {
    "id": "a6e5337d-f5af-44e6-aa7d-a618055fb640",
    "slug": "jielei-yong",
    "name": "Jielei Yong",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/04/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jielei Yong",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a6e5337d-f5af-44e6-aa7d-a618055fb640",
        "address": "ICD Brookfield Place ,Za'abeel 2 ,103747 ,",
        "phone": "97143696300 / 971506008159",
        "email": "mohammed.paracha@nortonrosefulbright.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c4aaee93-0ec4-4982-9a48-a23699492056",
    "firmName": "Norton Rose Fullbright (Middle East) LLP",
    "registrationNumber": "L-06036",
    "licenseIssueDate": "10/04/2023 00:00:00",
    "licenseExpiryDate": "10/03/2026 00:00:00"
  },
  {
    "id": "271bad40-ec54-4341-a345-8e6949cda44b",
    "slug": "jihad-elias-elhaddad",
    "name": "Jihad Elias Elhaddad",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/17/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jihad Elias Elhaddad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_271bad40-ec54-4341-a345-8e6949cda44b",
        "address": "Alhajeya salem saeed alnoobi ,3rd  ,Al-hawai Tower  ,Behind financial center metro station  ,39779 ,Dubai",
        "phone": "97142963813",
        "email": "adv_aljazeera@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "f091b928-9e3d-4e24-b489-65ca31481366",
    "firmName": "AL HAJEYA ALNOOBI ADVOCATES AND LEGAL CONSULTANT",
    "registrationNumber": "L-01951",
    "licenseIssueDate": "11/17/2011 00:00:00",
    "licenseExpiryDate": "11/08/2025 00:00:00"
  },
  {
    "id": "efba4295-d1da-4ff9-9fae-bd16f8e15fce",
    "slug": "jimmy-jamil-haoula",
    "name": "Jimmy Jamil Haoula",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jimmy Jamil Haoula",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_efba4295-d1da-4ff9-9fae-bd16f8e15fce",
        "address": "",
        "phone": "97143685555",
        "email": "maisa.maarouf@bsabh.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8afa232f-52ff-4dad-82c3-9a04d66eb853",
    "firmName": "B S A AHMED BIN HAZEEM & ASSOCIATES LLP - DIFC",
    "registrationNumber": "L-01629",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "27784817-bdf3-4568-a413-710112c0dfa1",
    "slug": "jinal-harish-shah",
    "name": "JINAL CHAITANYA GHEEWALA HARISH BHACHUBHAI SHAH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/11/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2023-11-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: JINAL HARISH SHAH",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_27784817-bdf3-4568-a413-710112c0dfa1",
        "address": "HAMAD ABDULLA ABDULRAHMAN ALRAHMA ALHAMMADI ,14TH FLOOR - 1403 ,PARK PLACE TOWER ,WORLD TRADE CENTER ,114295 ,Dubai",
        "phone": "97144227465 / 971555507070",
        "email": "hessa.alshehhi@primecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d6da9923-01fb-4fd8-a9da-a02d2122dbde",
    "firmName": "Hessa Al Shehhi ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05661",
    "licenseIssueDate": "11/28/2022 00:00:00",
    "licenseExpiryDate": "11/27/2023 00:00:00"
  },
  {
    "id": "ee5de4c0-91dc-407b-8d20-5ca6d666e7dc",
    "slug": "jinan-jawad",
    "name": "Jinan Jawad",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/08/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jinan Jawad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ee5de4c0-91dc-407b-8d20-5ca6d666e7dc",
        "address": "20 ,Index Tower West Tower ,DIFC ,507226 ,Dubai",
        "phone": "97142461900 / 971523391604",
        "email": "patrick.gearon@crsblaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e2ac552e-b9a7-450b-a84d-15119e583220",
    "firmName": "Charles Russell Speechlys LLP",
    "registrationNumber": "L-06632",
    "licenseIssueDate": "01/08/2025 00:00:00",
    "licenseExpiryDate": "01/07/2026 00:00:00"
  },
  {
    "id": "564e545a-ee32-430e-90d8-43bccd8c20d1",
    "slug": "jingzhuo-wu",
    "name": "JINGZHUO WU",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/02/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: JINGZHUO WU",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_564e545a-ee32-430e-90d8-43bccd8c20d1",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-06850",
    "licenseIssueDate": "06/02/2025 00:00:00",
    "licenseExpiryDate": "06/01/2026 00:00:00"
  },
  {
    "id": "7e863032-f07e-4efe-88a5-f5508edf215b",
    "slug": "jirayr-habibian",
    "name": "jirayr habibian",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/07/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: jirayr habibian",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7e863032-f07e-4efe-88a5-f5508edf215b",
        "address": "3-505 ,AL KHABEESI BLDG ,AL KABEESI ,4948 ,Dubai",
        "phone": "97142222228",
        "email": "info@alkamali.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "054f38f4-9e51-4623-ad36-7941043a051c",
    "firmName": "AL KAMALI & COMPANY ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-04956",
    "licenseIssueDate": "06/07/2021 00:00:00",
    "licenseExpiryDate": "06/06/2026 00:00:00"
  },
  {
    "id": "170f32e4-1a4b-4c28-b738-95091182fbe3",
    "slug": "jiwon-ha",
    "name": "Jiwon Ha",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/21/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-01-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jiwon Ha",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_170f32e4-1a4b-4c28-b738-95091182fbe3",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-04829",
    "licenseIssueDate": "01/21/2021 00:00:00",
    "licenseExpiryDate": "01/20/2026 00:00:00"
  },
  {
    "id": "7ee2eb54-7ce3-410e-9bbc-15b11efbb161",
    "slug": "joanna-codling",
    "name": "Joanna Codling",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/25/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Joanna Codling",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7ee2eb54-7ce3-410e-9bbc-15b11efbb161",
        "address": "1 ,Emaar Square 5 ,sheikh mohammed bin rashid BVD ,11987 ,Dubai",
        "phone": "97143043100 / 971507325154",
        "email": "amir.kordvani@pwc.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ea026b18-c93c-4f67-a1f2-4546320f8f3e",
    "firmName": "PWC Legal Middle East LLP",
    "registrationNumber": "L-03715",
    "licenseIssueDate": "04/25/2017 00:00:00",
    "licenseExpiryDate": "04/22/2026 00:00:00"
  },
  {
    "id": "9cd37cdd-2fe1-4ca8-afe4-ce56330ac4d2",
    "slug": "joanna-jayne-stewart",
    "name": "JOANNA JAYNE STEWART",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/23/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: JOANNA JAYNE STEWART",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9cd37cdd-2fe1-4ca8-afe4-ce56330ac4d2",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-04301",
    "licenseIssueDate": "01/23/2019 00:00:00",
    "licenseExpiryDate": "01/21/2026 00:00:00"
  },
  {
    "id": "afdb18c8-0d85-4dd5-a885-35740bc545b9",
    "slug": "joanna-maria-ghattas-el-khoury",
    "name": "Joanna Maria Ghattas El Khoury",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/25/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Joanna Maria Ghattas El Khoury",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_afdb18c8-0d85-4dd5-a885-35740bc545b9",
        "address": "",
        "phone": "97143121800 / 971566017967",
        "email": "alishia.sullivan@morganlewis.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6eab20d7-8716-4b0a-8710-144d1d951c23",
    "firmName": "Morgan, Lewis & Bockius LLP (dubai Branch)",
    "registrationNumber": "L-04245",
    "licenseIssueDate": "10/25/2018 00:00:00",
    "licenseExpiryDate": "10/23/2026 00:00:00"
  },
  {
    "id": "96862ce9-11c0-476b-a6c7-516beb7b5055",
    "slug": "joanna-taylor",
    "name": "Joanna Taylor",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/08/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Joanna Taylor",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_96862ce9-11c0-476b-a6c7-516beb7b5055",
        "address": "Al Fattan Currency House Tower 2 ,DIFC ,507176 ,",
        "phone": "/ 971552009003",
        "email": "Mohammad.AlRasheed@bakermckenzie.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "acd81e81-dead-4f7c-839e-0f2a57897265",
    "firmName": "Baker & Mckenzie LLP",
    "registrationNumber": "L-00654",
    "licenseIssueDate": "06/08/2016 00:00:00",
    "licenseExpiryDate": "06/04/2026 00:00:00"
  },
  {
    "id": "b0ef17ec-9a97-4471-b506-db023be10dfb",
    "slug": "jocelyn-dare",
    "name": "Jocelyn Dare",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/12/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jocelyn Dare",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b0ef17ec-9a97-4471-b506-db023be10dfb",
        "address": "ICD-Brookfield Place ,DIFC ,119974 ,",
        "phone": "97143652000",
        "email": "david.charlier@ashurst.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c01c3c61-4d90-4058-8429-61dd01e615f5",
    "firmName": "Ashurst LLP-DIFC",
    "registrationNumber": "L-00604",
    "licenseIssueDate": "07/12/2023 00:00:00",
    "licenseExpiryDate": "07/11/2026 00:00:00"
  },
  {
    "id": "2371071c-fabb-4c81-b545-d92ca1586a4f",
    "slug": "jocelyn-jane-hayward",
    "name": "Jocelyn Jane Hayward",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/09/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jocelyn Jane Hayward",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2371071c-fabb-4c81-b545-d92ca1586a4f",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-06877",
    "licenseIssueDate": "07/09/2025 00:00:00",
    "licenseExpiryDate": "07/08/2026 00:00:00"
  },
  {
    "id": "962e8f7b-bb4f-47bb-9819-c7d8afc673f4",
    "slug": "jodi-louise-norman",
    "name": "Jodi Louise Norman",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/12/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jodi Louise Norman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_962e8f7b-bb4f-47bb-9819-c7d8afc673f4",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-04562",
    "licenseIssueDate": "12/12/2019 00:00:00",
    "licenseExpiryDate": "12/11/2025 00:00:00"
  },
  {
    "id": "6a11583b-454f-4ae2-9e6e-a1494965c9b1",
    "slug": "jodie-alice-martyndale-howard",
    "name": "Jodie Alice Martyndale Howard",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/02/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jodie Alice Martyndale Howard",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6a11583b-454f-4ae2-9e6e-a1494965c9b1",
        "address": "",
        "phone": "97147098484 / 971505577206",
        "email": "slshadmand@jonesday.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8892bfe9-d3ec-4158-b4fd-1844606f4f30",
    "firmName": "Jones Day",
    "registrationNumber": "L-05955",
    "licenseIssueDate": "08/02/2023 00:00:00",
    "licenseExpiryDate": "08/01/2026 00:00:00"
  },
  {
    "id": "4aa3f9ca-d19c-4674-8833-11925793e01a",
    "slug": "jodie-naa-anowa-reindorf",
    "name": "Jodie Naa Anowa Reindorf",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/01/2018",
    "licenseStatus": "active",
    "licenseExpiry": "2019-01-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jodie Naa Anowa Reindorf",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4aa3f9ca-d19c-4674-8833-11925793e01a",
        "address": "0 ,ICD Brookfield Place Level 13 ,Trade Centre ,506569 ,Dubai",
        "phone": "97145099100 / 971501006965",
        "email": "menahr@freshfields.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "970f6246-e737-41a7-9c6c-5aa5b8335d45",
    "firmName": "Freshfields LLP DIFC",
    "registrationNumber": "L-03955",
    "licenseIssueDate": "01/09/2018 00:00:00",
    "licenseExpiryDate": "01/06/2026 00:00:00"
  },
  {
    "id": "85f96817-75d4-4900-8ba5-4a05bd43be5c",
    "slug": "jody-waugh",
    "name": "Jody Waugh",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jody Waugh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_85f96817-75d4-4900-8ba5-4a05bd43be5c",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01271",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "32e74229-897b-4533-9e83-04372099a76c",
    "slug": "joe-charles-riches",
    "name": "Joe Charles Riches",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/26/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Joe Charles Riches",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_32e74229-897b-4533-9e83-04372099a76c",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-05140",
    "licenseIssueDate": "01/26/2022 00:00:00",
    "licenseExpiryDate": "01/25/2026 00:00:00"
  },
  {
    "id": "f0b60c9f-b7e3-4fa7-aceb-1a144d040dc8",
    "slug": "joe-clinton",
    "name": "Joe Clinton",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/07/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Joe Clinton",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f0b60c9f-b7e3-4fa7-aceb-1a144d040dc8",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-04950",
    "licenseIssueDate": "06/07/2021 00:00:00",
    "licenseExpiryDate": "06/06/2026 00:00:00"
  },
  {
    "id": "685f7b99-adcf-424a-9eff-fa4311e74ef6",
    "slug": "jogan-sanjiv-punjabi",
    "name": "Jogan Sanjiv Punjabi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/09/2022",
    "licenseStatus": "active",
    "licenseExpiry": "2023-09-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jogan Sanjiv Punjabi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_685f7b99-adcf-424a-9eff-fa4311e74ef6",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-05530",
    "licenseIssueDate": "09/13/2022 00:00:00",
    "licenseExpiryDate": "09/12/2026 00:00:00"
  },
  {
    "id": "841c2ea1-e765-4116-b792-06308e083e05",
    "slug": "johanna-hendry",
    "name": "Johanna Hendry",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/26/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Johanna Hendry",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_841c2ea1-e765-4116-b792-06308e083e05",
        "address": "",
        "phone": "97143637999 / 971506525633",
        "email": "daniel.wood@walkersglobal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a3a9927b-d51c-490c-8be6-d575ea3eb041",
    "firmName": "Walkers (Middle East) LLP",
    "registrationNumber": "L-03859",
    "licenseIssueDate": "09/26/2017 00:00:00",
    "licenseExpiryDate": "09/23/2026 00:00:00"
  },
  {
    "id": "16d5f4e5-ee5c-429c-a850-7b0be8823433",
    "slug": "johannes-koepp",
    "name": "Johannes Koepp",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/29/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-11-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Johannes Koepp",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_16d5f4e5-ee5c-429c-a850-7b0be8823433",
        "address": "",
        "phone": "97144363636 / 971505572900",
        "email": "hassan.elsayed@bakerbotts.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "fd5d6571-d053-4436-9de5-c8a36ce7c6c9",
    "firmName": "Baker Botts LLP Legal Consultants Dubai Branch",
    "registrationNumber": "L-06614",
    "licenseIssueDate": "11/29/2024 00:00:00",
    "licenseExpiryDate": "11/28/2025 00:00:00"
  },
  {
    "id": "8405293f-301f-4e12-b245-03fe46504314",
    "slug": "john-barlow",
    "name": "John Barlow",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/14/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: John Barlow",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8405293f-301f-4e12-b245-03fe46504314",
        "address": "",
        "phone": "97144230555 / 971504788443",
        "email": "yah@hfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c462c65e-185a-4e81-8425-a87e3a2b6842",
    "firmName": "Holman Fenwick Willan Middle East LLP",
    "registrationNumber": "L-03259",
    "licenseIssueDate": "09/14/2015 00:00:00",
    "licenseExpiryDate": "09/09/2026 00:00:00"
  },
  {
    "id": "d675bf08-5838-49f0-8b2f-7d2a843f36ce",
    "slug": "john-geddes",
    "name": "John Geddes",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/27/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: John Geddes",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d675bf08-5838-49f0-8b2f-7d2a843f36ce",
        "address": "",
        "phone": "97143742800 / 971506450677",
        "email": "jabbott21@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7a59d310-ff72-4318-b41c-27095c163d0f",
    "firmName": "CMS (UAE) LLP",
    "registrationNumber": "L-03204",
    "licenseIssueDate": "10/27/2015 00:00:00",
    "licenseExpiryDate": "10/22/2025 00:00:00"
  },
  {
    "id": "98fa28a5-4da7-4aa2-87c1-565b54bb1d2b",
    "slug": "john-lewis",
    "name": "John Lewis",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/11/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: John Lewis",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_98fa28a5-4da7-4aa2-87c1-565b54bb1d2b",
        "address": "",
        "phone": "97144073901 / 971503479508",
        "email": "Rania.Tadros@stephensonharwood.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dd5042a2-bb41-4123-9544-79c3fa831332",
    "firmName": "Stephenson Harwood (Middle East) LLP",
    "registrationNumber": "L-00290",
    "licenseIssueDate": "10/11/2011 00:00:00",
    "licenseExpiryDate": "10/02/2026 00:00:00"
  },
  {
    "id": "510c9512-fc48-41b5-94e1-48645d66ccd4",
    "slug": "john-oconnor",
    "name": "John O'Connor",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/20/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: John O'Connor",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_510c9512-fc48-41b5-94e1-48645d66ccd4",
        "address": "",
        "phone": "97143742800 / 971506450677",
        "email": "jabbott21@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7a59d310-ff72-4318-b41c-27095c163d0f",
    "firmName": "CMS (UAE) LLP",
    "registrationNumber": "L-01464",
    "licenseIssueDate": "11/20/2012 00:00:00",
    "licenseExpiryDate": "11/12/2025 00:00:00"
  },
  {
    "id": "454eb89b-1670-4f8e-aaa1-c4f14c027e60",
    "slug": "john-podgore",
    "name": "John Podgore",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/16/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: John Podgore",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_454eb89b-1670-4f8e-aaa1-c4f14c027e60",
        "address": "الطابق 14  ,برج 48 جيت  ,محطة مترو دبي  ,413633 ,Dubai",
        "phone": "97144412031",
        "email": "courts@adglegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4287f048-dc0c-4d51-9e0c-0c23356040ee",
    "firmName": "MOHAMMED AL DAHBASHI ADVOCATES",
    "registrationNumber": "L-01060",
    "licenseIssueDate": "04/16/2025 00:00:00",
    "licenseExpiryDate": "04/15/2026 00:00:00"
  },
  {
    "id": "f683a164-81ca-43c9-895f-47002ca0eed9",
    "slug": "johnny-farhart",
    "name": "Johnny Farhart",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/05/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Johnny Farhart",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f683a164-81ca-43c9-895f-47002ca0eed9",
        "address": "ICD-Brookfield Place ,DIFC ,119974 ,",
        "phone": "97143652000",
        "email": "david.charlier@ashurst.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c01c3c61-4d90-4058-8429-61dd01e615f5",
    "firmName": "Ashurst LLP-DIFC",
    "registrationNumber": "L-05877",
    "licenseIssueDate": "07/05/2023 00:00:00",
    "licenseExpiryDate": "07/04/2026 00:00:00"
  },
  {
    "id": "0b7f9fde-d51a-4341-aa30-0da928e69ff8",
    "slug": "johnson-cansin-cortelek",
    "name": "Johnson Cansin Cortelek",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/31/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Johnson Cansin Cortelek",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0b7f9fde-d51a-4341-aa30-0da928e69ff8",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-06193",
    "licenseIssueDate": "01/31/2024 00:00:00",
    "licenseExpiryDate": "01/30/2026 00:00:00"
  },
  {
    "id": "fa019f1a-b510-47d4-9698-e068910a1e09",
    "slug": "joliette-amhaz",
    "name": "Joliette Amhaz",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/23/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Joliette Amhaz",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fa019f1a-b510-47d4-9698-e068910a1e09",
        "address": "",
        "phone": "97148328997",
        "email": "info@alkindiadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "27ee82c9-8f98-4b21-b9be-2de8fe329b61",
    "firmName": "AMANI ALKINDI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03224",
    "licenseIssueDate": "12/23/2021 00:00:00",
    "licenseExpiryDate": "12/22/2025 00:00:00"
  },
  {
    "id": "87390cd7-f245-46a1-8655-ed121d85529e",
    "slug": "jon-bridgewater",
    "name": "Jon Bridgewater",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/12/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jon Bridgewater",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_87390cd7-f245-46a1-8655-ed121d85529e",
        "address": "",
        "phone": "97143742800 / 971506450677",
        "email": "jabbott21@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7a59d310-ff72-4318-b41c-27095c163d0f",
    "firmName": "CMS (UAE) LLP",
    "registrationNumber": "L-01645",
    "licenseIssueDate": "06/12/2012 00:00:00",
    "licenseExpiryDate": "06/04/2026 00:00:00"
  },
  {
    "id": "812631e8-d89d-4204-99b5-05fe203c03fa",
    "slug": "jonathan-brown",
    "name": "Jonathan Brown",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/11/2011",
    "licenseStatus": "active",
    "licenseExpiry": "2012-11-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jonathan Brown",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_812631e8-d89d-4204-99b5-05fe203c03fa",
        "address": "",
        "phone": "97143685555",
        "email": "maisa.maarouf@bsabh.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8afa232f-52ff-4dad-82c3-9a04d66eb853",
    "firmName": "B S A AHMED BIN HAZEEM & ASSOCIATES LLP - DIFC",
    "registrationNumber": "L-02078",
    "licenseIssueDate": "11/29/2011 00:00:00",
    "licenseExpiryDate": "11/20/2025 00:00:00"
  },
  {
    "id": "bace0356-96ed-46f5-9b8b-a130b28554c6",
    "slug": "jonathan-burton",
    "name": "Jonathan Burton",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/11/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jonathan Burton",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bace0356-96ed-46f5-9b8b-a130b28554c6",
        "address": "ICD Brookfield Place ,Za'abeel 2 ,103747 ,",
        "phone": "97143696300 / 971506008159",
        "email": "mohammed.paracha@nortonrosefulbright.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c4aaee93-0ec4-4982-9a48-a23699492056",
    "firmName": "Norton Rose Fullbright (Middle East) LLP",
    "registrationNumber": "L-02868",
    "licenseIssueDate": "02/11/2015 00:00:00",
    "licenseExpiryDate": "02/05/2026 00:00:00"
  },
  {
    "id": "d3e4ca7a-c492-4b07-a77e-058b616e0f67",
    "slug": "jonathan-calvin-burke",
    "name": "Jonathan Calvin Burke",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/13/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jonathan Calvin Burke",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d3e4ca7a-c492-4b07-a77e-058b616e0f67",
        "address": "",
        "phone": "97144073901 / 971503479508",
        "email": "Rania.Tadros@stephensonharwood.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dd5042a2-bb41-4123-9544-79c3fa831332",
    "firmName": "Stephenson Harwood (Middle East) LLP",
    "registrationNumber": "L-06997"
  },
  {
    "id": "3ae76c44-c8f6-4b9e-bfd7-2a855c31af41",
    "slug": "jonathan-david-roux",
    "name": "Jonathan David Roux",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/06/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jonathan David Roux",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3ae76c44-c8f6-4b9e-bfd7-2a855c31af41",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-05991",
    "licenseIssueDate": "09/06/2023 00:00:00",
    "licenseExpiryDate": "09/05/2026 00:00:00"
  },
  {
    "id": "360caad5-1871-49b6-b665-d647d704bf30",
    "slug": "jonathan-davidson",
    "name": "Jonathan Davidson",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/02/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jonathan Davidson",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_360caad5-1871-49b6-b665-d647d704bf30",
        "address": "",
        "phone": "97143438897 / 971507753952",
        "email": "jdavidson@davidson-legal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "d0200f27-9504-4653-a5c6-05e4bcab7ff0",
    "firmName": "Davidson & Co Legal Consultants",
    "registrationNumber": "L-00935",
    "licenseIssueDate": "11/02/2011 00:00:00",
    "licenseExpiryDate": "10/24/2025 00:00:00"
  },
  {
    "id": "c2ea2268-feee-4431-983f-ee6c2b909855",
    "slug": "jonathan-francis-downey",
    "name": "Jonathan Francis Downey",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/05/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jonathan Francis Downey",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c2ea2268-feee-4431-983f-ee6c2b909855",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-05522",
    "licenseIssueDate": "10/05/2022 00:00:00",
    "licenseExpiryDate": "10/04/2026 00:00:00"
  },
  {
    "id": "55097bb9-cd3d-4eb8-a3d8-181f3d91f8b6",
    "slug": "jonathan-fried",
    "name": "Jonathan Fried",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/20/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jonathan Fried",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_55097bb9-cd3d-4eb8-a3d8-181f3d91f8b6",
        "address": "ICD Brookfield Place ,DIFC ,506516 ,",
        "phone": "97143695800 / 971505526206",
        "email": "scott.campbell@linklaters.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5cec94c0-0649-43b6-a2be-ab17ff422bce",
    "firmName": "LinkLaters LLP",
    "registrationNumber": "L-02376",
    "licenseIssueDate": "10/20/2013 00:00:00",
    "licenseExpiryDate": "10/13/2026 00:00:00"
  },
  {
    "id": "83d902f5-7904-4108-9ce6-b7ed48a80466",
    "slug": "jonathan-george-simpson",
    "name": "Jonathan George Simpson",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/06/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jonathan George Simpson",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_83d902f5-7904-4108-9ce6-b7ed48a80466",
        "address": "",
        "phone": "97143685555",
        "email": "maisa.maarouf@bsabh.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8afa232f-52ff-4dad-82c3-9a04d66eb853",
    "firmName": "B S A AHMED BIN HAZEEM & ASSOCIATES LLP - DIFC",
    "registrationNumber": "L-06567",
    "licenseIssueDate": "10/21/2024 00:00:00",
    "licenseExpiryDate": "10/20/2025 00:00:00"
  },
  {
    "id": "e7d68810-1adc-4fec-8ed2-77b491f50a44",
    "slug": "jonathan-noble",
    "name": "Jonathan Noble",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/16/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jonathan Noble",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e7d68810-1adc-4fec-8ed2-77b491f50a44",
        "address": "",
        "phone": "97144323671 / 971505589395",
        "email": "fba@amereller.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a139ca64-8897-4d1d-8d71-97446bc1e15a",
    "firmName": "Amereller Legal Consultancy LLC SOC",
    "registrationNumber": "L-02627",
    "licenseIssueDate": "01/16/2014 00:00:00",
    "licenseExpiryDate": "01/09/2026 00:00:00"
  },
  {
    "id": "2a428b9e-e575-4a71-9205-c101b096223f",
    "slug": "jonathan-parker",
    "name": "Jonathan Parker",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/28/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jonathan Parker",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2a428b9e-e575-4a71-9205-c101b096223f",
        "address": "Level 17, ICD Brookfield Place ,DIFC ,506503 ,",
        "phone": "97144375100 / 971588271196",
        "email": "libby.edwards-smith@gowlingwlg.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "436703ba-b9c0-4dcb-93b2-1299c7a051f4",
    "firmName": "Gowling WLG (UK) LLP (Dubai Branch)",
    "registrationNumber": "L-03477",
    "licenseIssueDate": "08/28/2016 00:00:00",
    "licenseExpiryDate": "08/24/2026 00:00:00"
  },
  {
    "id": "060f9bba-b556-401f-ad80-8de9bda476ae",
    "slug": "jonathan-richard-brooks",
    "name": "Jonathan Richard Brooks",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/07/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jonathan Richard Brooks",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_060f9bba-b556-401f-ad80-8de9bda476ae",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04395",
    "licenseIssueDate": "05/07/2019 00:00:00",
    "licenseExpiryDate": "05/06/2026 00:00:00"
  },
  {
    "id": "2bed9b69-3120-4fbf-a252-68bf916db091",
    "slug": "jonathan-richard-vick",
    "name": "Jonathan Richard Vick",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/31/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-01-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jonathan Richard Vick",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2bed9b69-3120-4fbf-a252-68bf916db091",
        "address": "ICD Brookfield Place ,DIFC ,506516 ,",
        "phone": "97143695800 / 971505526206",
        "email": "scott.campbell@linklaters.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5cec94c0-0649-43b6-a2be-ab17ff422bce",
    "firmName": "LinkLaters LLP",
    "registrationNumber": "L-03979",
    "licenseIssueDate": "01/31/2018 00:00:00",
    "licenseExpiryDate": "01/28/2026 00:00:00"
  },
  {
    "id": "81d1302f-8bfb-4aa2-a07b-b397153d1033",
    "slug": "jonathan-silver",
    "name": "Jonathan Silver",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/11/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jonathan Silver",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_81d1302f-8bfb-4aa2-a07b-b397153d1033",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-00291",
    "licenseIssueDate": "10/11/2011 00:00:00",
    "licenseExpiryDate": "10/02/2026 00:00:00"
  },
  {
    "id": "4cf21af4-26f6-4f9e-bd3c-164fbe4ed5b6",
    "slug": "jonathan-sutcliffe",
    "name": "Jonathan Sutcliffe",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jonathan Sutcliffe",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4cf21af4-26f6-4f9e-bd3c-164fbe4ed5b6",
        "address": "",
        "phone": "97144272700 / 971545824605",
        "email": "tony.griffiths@klgates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "fb8fc340-ceef-4b83-8f2b-9b24d4604967",
    "firmName": "K & L Gates LLP",
    "registrationNumber": "L-00736",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "86c407f3-fb45-423e-adf3-bdfa540c24c5",
    "slug": "jooyoung-song",
    "name": "Jooyoung Song",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/12/2024",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jooyoung Song",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_86c407f3-fb45-423e-adf3-bdfa540c24c5",
        "address": "ICD Brookfield Place ,DIFC ,120109 ,",
        "phone": "97143173000 / 971504465229",
        "email": "DubaiLAD@akingump.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9ff29eab-adb8-40f9-ab84-216e01a381e4",
    "firmName": "Akin Gump Strauss Hauer & Feld LLP",
    "registrationNumber": "L-06613",
    "licenseIssueDate": "12/11/2024 00:00:00",
    "licenseExpiryDate": "12/10/2025 00:00:00"
  },
  {
    "id": "9e501218-af2a-4850-81b1-d650903fee9f",
    "slug": "jordan-lloyd-ellis",
    "name": "Jordan Lloyd Ellis",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/26/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jordan Lloyd Ellis",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9e501218-af2a-4850-81b1-d650903fee9f",
        "address": "",
        "phone": "97144073901 / 971503479508",
        "email": "Rania.Tadros@stephensonharwood.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dd5042a2-bb41-4123-9544-79c3fa831332",
    "firmName": "Stephenson Harwood (Middle East) LLP",
    "registrationNumber": "L-04358",
    "licenseIssueDate": "03/26/2019 00:00:00",
    "licenseExpiryDate": "03/24/2026 00:00:00"
  },
  {
    "id": "4675f0ee-0a59-424c-8ba0-639fa398912b",
    "slug": "joseph-durkin",
    "name": "Joseph Durkin",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/23/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2022-01-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Joseph Durkin",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4675f0ee-0a59-424c-8ba0-639fa398912b",
        "address": "",
        "phone": "97143266677 / 971506234989",
        "email": "md@khourilawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7f366bee-e90b-4c77-b535-ccd366935872",
    "firmName": "IBRAHIM KHOURI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-00936",
    "licenseIssueDate": "01/23/2019 00:00:00",
    "licenseExpiryDate": "01/27/2022 00:00:00"
  },
  {
    "id": "b038fd0e-cb48-4dc9-9622-a4ceb9907ba5",
    "slug": "joseph-lobo-clarence",
    "name": "Joseph Lobo Clarence",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/25/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Joseph Lobo Clarence",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b038fd0e-cb48-4dc9-9622-a4ceb9907ba5",
        "address": "",
        "phone": "97108307033",
        "email": "general.alshamsi@lawuae.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d29f6d04-dad1-4f59-9ae2-d4d245f63133",
    "firmName": "AL SHAMSI & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01228",
    "licenseIssueDate": "01/25/2012 00:00:00",
    "licenseExpiryDate": "01/16/2026 00:00:00"
  },
  {
    "id": "a5f285b6-a911-41e2-814b-0e9078fc248a",
    "slug": "josephine-louisa-hemsley-levick",
    "name": "Josephine Louisa Hemsley Levick",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/05/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Josephine Louisa Hemsley Levick",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a5f285b6-a911-41e2-814b-0e9078fc248a",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-05876",
    "licenseIssueDate": "07/05/2023 00:00:00",
    "licenseExpiryDate": "07/04/2026 00:00:00"
  },
  {
    "id": "296154e6-9b26-45f7-b33e-bf51f54cf089",
    "slug": "joshua-alexander-morrison",
    "name": "Joshua Alexander Morrison",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/04/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-03-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Joshua Alexander Morrison",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_296154e6-9b26-45f7-b33e-bf51f54cf089",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-06106",
    "licenseIssueDate": "01/04/2024 00:00:00",
    "licenseExpiryDate": "01/03/2026 00:00:00"
  },
  {
    "id": "3227a904-bb03-4c29-9ab1-53410d49d340",
    "slug": "joshua-garrett-kemp",
    "name": "Joshua Garrett Kemp",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/14/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Joshua Garrett Kemp",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3227a904-bb03-4c29-9ab1-53410d49d340",
        "address": "الطابق 14  ,برج 48 جيت  ,محطة مترو دبي  ,413633 ,Dubai",
        "phone": "97144412031",
        "email": "courts@adglegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4287f048-dc0c-4d51-9e0c-0c23356040ee",
    "firmName": "MOHAMMED AL DAHBASHI ADVOCATES",
    "registrationNumber": "L-05491",
    "licenseIssueDate": "09/14/2022 00:00:00",
    "licenseExpiryDate": "09/13/2026 00:00:00"
  },
  {
    "id": "3c4c3f2a-4ce1-4957-b896-d55da5fc026d",
    "slug": "joshua-james-cosoff",
    "name": "Joshua James Cosoff",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/21/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Joshua James Cosoff",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3c4c3f2a-4ce1-4957-b896-d55da5fc026d",
        "address": "",
        "phone": "97143742800 / 971506450677",
        "email": "jabbott21@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7a59d310-ff72-4318-b41c-27095c163d0f",
    "firmName": "CMS (UAE) LLP",
    "registrationNumber": "L-04749",
    "licenseIssueDate": "10/21/2020 00:00:00",
    "licenseExpiryDate": "10/20/2026 00:00:00"
  },
  {
    "id": "26b7fc3d-1c16-421c-aabd-57d0f833b08f",
    "slug": "joshua-myles-eaton",
    "name": "Joshua Myles Eaton",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/19/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Joshua Myles Eaton",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_26b7fc3d-1c16-421c-aabd-57d0f833b08f",
        "address": "",
        "phone": "97104309100 / 971564013758",
        "email": "c.royle@taylorwessing.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d51b6f43-8c62-486f-a1ab-6ee3b87c8006",
    "firmName": "Taylor Wessing LLP (Dubai Branch)",
    "registrationNumber": "L-06172",
    "licenseIssueDate": "01/19/2024 00:00:00",
    "licenseExpiryDate": "01/18/2026 00:00:00"
  },
  {
    "id": "65f97da8-35ff-4c69-834e-bc7fc3f325dc",
    "slug": "joy-kadi",
    "name": "Joy Kadi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/07/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Joy Kadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_65f97da8-35ff-4c69-834e-bc7fc3f325dc",
        "address": "Level 17, ICD Brookfield Place ,DIFC ,506503 ,",
        "phone": "97144375100 / 971588271196",
        "email": "libby.edwards-smith@gowlingwlg.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "436703ba-b9c0-4dcb-93b2-1299c7a051f4",
    "firmName": "Gowling WLG (UK) LLP (Dubai Branch)",
    "registrationNumber": "L-05257",
    "licenseIssueDate": "03/07/2022 00:00:00",
    "licenseExpiryDate": "03/06/2026 00:00:00"
  },
  {
    "id": "bd8f83d9-79c6-4f13-bdeb-61a9988d1f65",
    "slug": "joycia-young",
    "name": "Joycia Young",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/11/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Joycia Young",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bd8f83d9-79c6-4f13-bdeb-61a9988d1f65",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-00292",
    "licenseIssueDate": "10/11/2011 00:00:00",
    "licenseExpiryDate": "10/02/2026 00:00:00"
  },
  {
    "id": "02c069dc-b4f0-428a-a38e-da20107b253c",
    "slug": "joywin-mathew",
    "name": "Joywin Mathew",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/07/2022",
    "licenseStatus": "active",
    "licenseExpiry": "2023-07-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Joywin Mathew",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_02c069dc-b4f0-428a-a38e-da20107b253c",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-05443",
    "licenseIssueDate": "07/27/2022 00:00:00",
    "licenseExpiryDate": "07/26/2026 00:00:00"
  },
  {
    "id": "63b6e153-ede3-4c8e-9cc5-c3a16e8c384a",
    "slug": "jozif-mankryous",
    "name": "Jozif Mankryous",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/28/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jozif Mankryous",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_63b6e153-ede3-4c8e-9cc5-c3a16e8c384a",
        "address": "الطابق 11 - مكتب رقم (1105 ، 1106)  ,برج السلام  ,منطقة المركز التجاري العالمي 1 ,211911 ,Dubai",
        "phone": "97143366769 / 971503636617",
        "email": "info@erlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "fffe1b8f-e9ab-488f-82eb-6151b8f007df",
    "firmName": "EMAN ALRIFAI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03263",
    "licenseIssueDate": "04/28/2015 00:00:00",
    "licenseExpiryDate": "04/23/2026 00:00:00"
  },
  {
    "id": "822e1c34-95d0-48e4-9d33-1df1ecda9a98",
    "slug": "judith-kim",
    "name": "Judith Kim",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Judith Kim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_822e1c34-95d0-48e4-9d33-1df1ecda9a98",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-00606",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "65816c09-565f-4dad-8427-c425a2b319cf",
    "slug": "julia-ofer",
    "name": "Julia Ofer",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/23/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Julia Ofer",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_65816c09-565f-4dad-8427-c425a2b319cf",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-02567",
    "licenseIssueDate": "01/23/2014 00:00:00",
    "licenseExpiryDate": "01/16/2026 00:00:00"
  },
  {
    "id": "522d6cfb-8fe3-4260-8d65-678d125ff16f",
    "slug": "julian-awwad",
    "name": "Julian Awwad",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/04/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Julian Awwad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_522d6cfb-8fe3-4260-8d65-678d125ff16f",
        "address": "One Central, The Offices 5 ,Dubai World Trade Centre ,554660 ,",
        "phone": "97142052030 / 971506566494",
        "email": "chourani@houranipartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "59a73632-40a0-4849-b120-4308dc6f8015",
    "firmName": "Hourani & Partners Legal Consultancy FZCO",
    "registrationNumber": "L-06593",
    "licenseIssueDate": "11/04/2024 00:00:00",
    "licenseExpiryDate": "11/03/2025 00:00:00"
  },
  {
    "id": "38c4a444-9c55-474f-98ea-458a47ed0d31",
    "slug": "julian-grant",
    "name": "Julian Grant",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/07/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Julian Grant",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_38c4a444-9c55-474f-98ea-458a47ed0d31",
        "address": "",
        "phone": "97144286300 / 971506256686",
        "email": "stuart.paterson@hsf.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2f0389b3-bfde-44f4-bdd6-6e1a22f9cab2",
    "firmName": "Herbert Smith Freehills Kramer LLP",
    "registrationNumber": "L-05261",
    "licenseIssueDate": "04/07/2022 00:00:00",
    "licenseExpiryDate": "04/06/2026 00:00:00"
  },
  {
    "id": "b0c0865b-b15b-4164-ac7b-704a786db6bf",
    "slug": "julian-sigi-steimer",
    "name": "JULIAN SIGI STEIMER",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/22/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: JULIAN SIGI STEIMER",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b0c0865b-b15b-4164-ac7b-704a786db6bf",
        "address": "A7 ,Dubai Silicon Oasis ,29337 ,",
        "phone": "97144313060 / 971528448686",
        "email": "andres.ring@schlueter-graf.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2ce110f0-b433-4dbc-b15f-ab1a3b291c28",
    "firmName": "Schluter Graf Legal Consultants LLC",
    "registrationNumber": "L-06270",
    "licenseIssueDate": "03/22/2024 00:00:00",
    "licenseExpiryDate": "03/21/2026 00:00:00"
  },
  {
    "id": "8a707228-a975-4b7d-a47b-7e90017fadd2",
    "slug": "julie-jordana-nelly-dray",
    "name": "Julie Jordana Nelly Dray",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/01/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Julie Jordana Nelly Dray",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8a707228-a975-4b7d-a47b-7e90017fadd2",
        "address": "",
        "phone": "97143550004 / 971506246248",
        "email": "canlaw@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "1ae95666-08c9-4857-b2b4-480be766b063",
    "firmName": "Acker Choquette Legal Consultants",
    "registrationNumber": "L-05337",
    "licenseIssueDate": "06/01/2022 00:00:00",
    "licenseExpiryDate": "05/31/2026 00:00:00"
  },
  {
    "id": "32ca518b-7940-46f5-b896-b0faa1d8f548",
    "slug": "julie-lynne-beeton",
    "name": "Julie Lynne Beeton",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/26/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Julie Lynne Beeton",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_32ca518b-7940-46f5-b896-b0faa1d8f548",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-06389",
    "licenseIssueDate": "06/26/2024 00:00:00",
    "licenseExpiryDate": "06/25/2026 00:00:00"
  },
  {
    "id": "f47a4f2b-6874-4451-bccf-9845f5939a88",
    "slug": "julie-teperow",
    "name": "Julie Teperow",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/25/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Julie Teperow",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f47a4f2b-6874-4451-bccf-9845f5939a88",
        "address": "",
        "phone": "97142472100 / 971509224336",
        "email": "bhaley@cov.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "65a2e90a-6978-4292-b3f1-ecbebedd7b9a",
    "firmName": "Covington & Burling LLP (Middle East)",
    "registrationNumber": "L-03709",
    "licenseIssueDate": "04/25/2017 00:00:00",
    "licenseExpiryDate": "04/21/2026 00:00:00"
  },
  {
    "id": "cbc39f8c-aba2-4422-b6bb-32a36775d113",
    "slug": "julien-hansen",
    "name": "Julien Hansen",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/24/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Julien Hansen",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cbc39f8c-aba2-4422-b6bb-32a36775d113",
        "address": "",
        "phone": "97143826100 / 971507380618",
        "email": "jmiocevic@curtis.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0867bcc5-10fa-4783-91ae-b8f63e02e81a",
    "firmName": "Curtis Mallet-Prevost, Colt & Mosle LLP",
    "registrationNumber": "L-06415",
    "licenseIssueDate": "07/24/2024 00:00:00",
    "licenseExpiryDate": "07/23/2026 00:00:00"
  },
  {
    "id": "51038c8d-c674-4f34-aab9-9fbd3b0cc829",
    "slug": "junaid-tariq",
    "name": "Junaid Tariq",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/25/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Junaid Tariq",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_51038c8d-c674-4f34-aab9-9fbd3b0cc829",
        "address": "",
        "phone": "97144230555 / 971504788443",
        "email": "yah@hfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c462c65e-185a-4e81-8425-a87e3a2b6842",
    "firmName": "Holman Fenwick Willan Middle East LLP",
    "registrationNumber": "L-06490",
    "licenseIssueDate": "09/25/2024 00:00:00",
    "licenseExpiryDate": "09/24/2026 00:00:00"
  },
  {
    "id": "3ca758aa-11e1-439d-b805-4b28771b15bd",
    "slug": "junguk-yi",
    "name": "Junguk Yi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/13/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Junguk Yi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3ca758aa-11e1-439d-b805-4b28771b15bd",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506688 ,Dubai",
        "phone": "97147096600 / 971503556811",
        "email": "muneer.khan@simmons-simmons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d1725ca7-06ac-41b2-8d7b-a6e60665b73d",
    "firmName": "Simmons & Simmons (Middle East) LLP-DIFC",
    "registrationNumber": "L-06993"
  },
  {
    "id": "8729b2bb-0203-4201-a18a-81440bf73fe0",
    "slug": "junhong-henry-kim",
    "name": "Junhong Henry Kim",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/08/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Junhong Henry Kim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8729b2bb-0203-4201-a18a-81440bf73fe0",
        "address": "",
        "phone": "97144272700 / 971545824605",
        "email": "tony.griffiths@klgates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "fb8fc340-ceef-4b83-8f2b-9b24d4604967",
    "firmName": "K & L Gates LLP",
    "registrationNumber": "L-06299",
    "licenseIssueDate": "05/08/2024 00:00:00",
    "licenseExpiryDate": "05/07/2026 00:00:00"
  },
  {
    "id": "fc71aef4-521c-42fb-b110-7b9265b0c945",
    "slug": "justine-isabell-jamie-brandt-scharnowski",
    "name": "Justine Isabell Jamie Brandt Scharnowski",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/08/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-07-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Justine Isabell Jamie Brandt Scharnowski",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fc71aef4-521c-42fb-b110-7b9265b0c945",
        "address": "",
        "phone": "97143275888 / 971504506620",
        "email": "anders@anders.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ead06df1-7efa-4b25-80d0-710f815a1677",
    "firmName": "Anders Legal Consultancy LLC",
    "registrationNumber": "L-06641",
    "licenseIssueDate": "01/08/2025 00:00:00",
    "licenseExpiryDate": "01/07/2026 00:00:00"
  },
  {
    "id": "2e537f9b-2ca4-4869-8243-1dd4d9bea392",
    "slug": "justine-jamie-anne-ahmed",
    "name": "Justine Jamie Anne Ahmed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/15/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Justine Jamie Anne Ahmed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2e537f9b-2ca4-4869-8243-1dd4d9bea392",
        "address": "",
        "phone": "97143897000 / 971506553198",
        "email": "nasseralikhasawneh@eversheds-sutherland.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "74a21d43-41d8-480a-a6af-6939b7c98a95",
    "firmName": "Eversheds Sutherland (International LLP) Dubai Branch",
    "registrationNumber": "L-05459",
    "licenseIssueDate": "11/15/2024 00:00:00",
    "licenseExpiryDate": "11/14/2025 00:00:00"
  },
  {
    "id": "01e2df2a-a882-4f81-9f28-79aea76c311e",
    "slug": "justine-reeves",
    "name": "Justine Reeves",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/25/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Justine Reeves",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_01e2df2a-a882-4f81-9f28-79aea76c311e",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-00773",
    "licenseIssueDate": "02/25/2012 00:00:00",
    "licenseExpiryDate": "02/15/2026 00:00:00"
  },
  {
    "id": "25cde62b-c204-434e-8061-cce110ce0705",
    "slug": "jyothi-venugopal-manakkolil-venugopalan",
    "name": "Jyothi Venugopal Manakkolil Venugopalan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKVgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/20/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jyothi Venugopal Manakkolil Venugopalan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_25cde62b-c204-434e-8061-cce110ce0705",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05036",
    "licenseIssueDate": "09/20/2021 00:00:00",
    "licenseExpiryDate": "09/19/2026 00:00:00"
  },
  {
    "id": "eb9464ff-fa49-420a-9a62-68cab92acca8",
    "slug": "kadry-mohamed-zaghawa",
    "name": "Kadry Mohamed  Zaghawa",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/26/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Kadry Mohamed  Zaghawa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_eb9464ff-fa49-420a-9a62-68cab92acca8",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-01772",
    "licenseIssueDate": "09/26/2011 00:00:00",
    "licenseExpiryDate": "09/17/2026 00:00:00"
  },
  {
    "id": "206c5779-e821-4428-84b0-0fe6b647a8bd",
    "slug": "kahroba-kojouri-haraj",
    "name": "Kahroba Kojouri Haraj",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/06/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Kahroba Kojouri Haraj",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_206c5779-e821-4428-84b0-0fe6b647a8bd",
        "address": "",
        "phone": "97144020800 / 971566830829",
        "email": "dean.ryburn@dentons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dfe13b7e-6625-45fd-ad63-9ee83af41194",
    "firmName": "Dentons & Co Dubai Branch-DED",
    "registrationNumber": "L-06456",
    "licenseIssueDate": "08/06/2024 00:00:00",
    "licenseExpiryDate": "08/05/2026 00:00:00"
  },
  {
    "id": "3ee15062-2cd5-48d7-bd24-5ec2f5da9aea",
    "slug": "kamal-mohamedelamin-abdelsalam-musbah",
    "name": "Kamal Mohamedelamin Abdelsalam Musbah",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/01/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-01-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Kamal Mohamedelamin Abdelsalam Musbah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3ee15062-2cd5-48d7-bd24-5ec2f5da9aea",
        "address": "MOHAMMED ABDULLA MOHSIN ABDURAHIM ALBREIKI ,406 ,ويست بيري ,برج خليفة ,220219 ,Dubai",
        "phone": "97145574529",
        "email": "d@albraikiadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ef095fb8-c3b5-42bc-92fc-43528c870fe7",
    "firmName": "MOHAMMED ABDULLA ALBREIKE ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03980",
    "licenseIssueDate": "02/01/2018 00:00:00",
    "licenseExpiryDate": "01/31/2019 00:00:00"
  },
  {
    "id": "d1552500-660a-4abc-bfdd-2e952f77deb0",
    "slug": "kamar-jaffer",
    "name": "Kamar Jaffer",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/07/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Kamar Jaffer",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d1552500-660a-4abc-bfdd-2e952f77deb0",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-00520",
    "licenseIssueDate": "05/07/2018 00:00:00",
    "licenseExpiryDate": "05/04/2026 00:00:00"
  },
  {
    "id": "1ed00cc7-29f0-4a4e-b22f-e9db9f56c7f2",
    "slug": "kamel-abu-saqer",
    "name": "Kamel Abu Saqer",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/20/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Kamel Abu Saqer",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1ed00cc7-29f0-4a4e-b22f-e9db9f56c7f2",
        "address": "",
        "phone": "97144489983 / 971506554033",
        "email": "kamel@kaslegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "f56db7d0-6202-42ba-ba72-78fe503184bd",
    "firmName": "Kamel Abu Saqer Legal Consultancy",
    "registrationNumber": "L-00526",
    "licenseIssueDate": "10/20/2011 00:00:00",
    "licenseExpiryDate": "10/11/2026 00:00:00"
  },
  {
    "id": "64cac914-c911-487e-95e7-16d1b3be89f9",
    "slug": "kamel-mohamed-elsaid-zalhf",
    "name": "kamel mohamed elsaid zalhf",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/10/2022",
    "licenseStatus": "active",
    "licenseExpiry": "2023-10-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: kamel mohamed elsaid zalhf",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_64cac914-c911-487e-95e7-16d1b3be89f9",
        "address": "",
        "phone": "97142515101",
        "email": "legal@alinsaf.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2176cd73-0d8d-41e1-9db6-ab2d6fa210b5",
    "firmName": "AL INSAF ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-05604",
    "licenseIssueDate": "10/26/2022 00:00:00",
    "licenseExpiryDate": "10/25/2026 00:00:00"
  },
  {
    "id": "ef631e5c-f0c9-458b-ad1d-1c22f288cd83",
    "slug": "kamel-ryad-abdalla-mohamed-aly-elshendidy",
    "name": "Kamel Ryad Abdalla Mohamed Aly Elshendidy",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/23/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Kamel Ryad Abdalla Mohamed Aly Elshendidy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ef631e5c-f0c9-458b-ad1d-1c22f288cd83",
        "address": "",
        "phone": "97144230000 / 971552009022",
        "email": "UAE-CourtClerks@habibalmulla.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3eba82bb-8ec4-4cbd-80d0-a793cb993fde",
    "firmName": "Habib Al Mulla & Partners ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05977",
    "licenseIssueDate": "08/23/2023 00:00:00",
    "licenseExpiryDate": "08/22/2026 00:00:00"
  },
  {
    "id": "03986b8c-41b1-4d61-9636-26877d3702b5",
    "slug": "kamila-sielski",
    "name": "Kamila Sielski",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/07/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Kamila Sielski",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_03986b8c-41b1-4d61-9636-26877d3702b5",
        "address": "Emirates Financial Towers (South) ,DIFC ,506546 ,",
        "phone": "97147096700 / 971505573843",
        "email": "dk@kbh.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "291a9c0d-030a-4cef-8739-c6946f741117",
    "firmName": "KBH Limited",
    "registrationNumber": "L-05291",
    "licenseIssueDate": "04/07/2022 00:00:00",
    "licenseExpiryDate": "04/06/2026 00:00:00"
  },
  {
    "id": "12a8b85e-2b76-4a88-94c6-1f57f0bb00f9",
    "slug": "kamilia-zaripova",
    "name": "Kamilia Zaripova",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLWgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/21/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Kamilia Zaripova",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_12a8b85e-2b76-4a88-94c6-1f57f0bb00f9",
        "address": "",
        "phone": "97143121800 / 971566017967",
        "email": "alishia.sullivan@morganlewis.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6eab20d7-8716-4b0a-8710-144d1d951c23",
    "firmName": "Morgan, Lewis & Bockius LLP (dubai Branch)",
    "registrationNumber": "L-06607",
    "licenseIssueDate": "11/21/2024 00:00:00",
    "licenseExpiryDate": "11/20/2025 00:00:00"
  },
  {
    "id": "addf91b2-2977-41fa-9179-6f2a205f07c7",
    "slug": "kamran-singhtoor",
    "name": "Kamran SinghToor",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/19/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-01-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Kamran SinghToor",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_addf91b2-2977-41fa-9179-6f2a205f07c7",
        "address": "ICD Brookfield Place ,DIFC ,506516 ,",
        "phone": "97143695800 / 971505526206",
        "email": "scott.campbell@linklaters.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5cec94c0-0649-43b6-a2be-ab17ff422bce",
    "firmName": "LinkLaters LLP",
    "registrationNumber": "L-06168",
    "licenseIssueDate": "01/19/2024 00:00:00",
    "licenseExpiryDate": "01/18/2026 00:00:00"
  },
  {
    "id": "0c44f6d8-3010-417b-833c-e99aec754e8a",
    "slug": "kanan-kasuya",
    "name": "Kanan Kasuya",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/09/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Kanan Kasuya",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0c44f6d8-3010-417b-833c-e99aec754e8a",
        "address": "ICD Brookfield Place ,Za'abeel 2 ,103747 ,",
        "phone": "97143696300 / 971506008159",
        "email": "mohammed.paracha@nortonrosefulbright.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c4aaee93-0ec4-4982-9a48-a23699492056",
    "firmName": "Norton Rose Fullbright (Middle East) LLP",
    "registrationNumber": "L-03343",
    "licenseIssueDate": "05/09/2016 00:00:00",
    "licenseExpiryDate": "05/05/2026 00:00:00"
  },
  {
    "id": "7c2acd34-731b-4b32-bd0b-83b6516c0178",
    "slug": "kara-louise-henderson-price",
    "name": "Kara Louise Henderson Price",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/29/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Kara Louise Henderson Price",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7c2acd34-731b-4b32-bd0b-83b6516c0178",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-04680",
    "licenseIssueDate": "04/29/2020 00:00:00",
    "licenseExpiryDate": "04/28/2026 00:00:00"
  },
  {
    "id": "f9cebe0f-7963-4756-b684-892c43efd5c2",
    "slug": "karamali-bahrami",
    "name": "Karamali Bahrami",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Karamali Bahrami",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f9cebe0f-7963-4756-b684-892c43efd5c2",
        "address": "Jane Naoe Elsayed ,Level No. 22 – Office No. (2201 – 2202) ,Concord Tower ,Media City ,99779 ,Dubai",
        "phone": "97143575999",
        "email": "info@binarab.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a718961d-c976-4a3c-bd09-585ec7c81310",
    "firmName": "RASHED BIN ARAB ADVOCATE AND LEGAL CONSULTANTS",
    "registrationNumber": "L-01559",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "170c54f7-181c-4f1f-934f-c141ea230f83",
    "slug": "karie-akeelah",
    "name": "Karie Akeelah",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Karie Akeelah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_170c54f7-181c-4f1f-934f-c141ea230f83",
        "address": "",
        "phone": "97143025100 / 971501501837",
        "email": "ccairns@trowers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "976857f5-9092-43cf-987d-bfa794a3fa51",
    "firmName": "Trowers & Hamlins LLP",
    "registrationNumber": "L-00155",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "f0e48436-69cb-4088-bc78-effb853e5001",
    "slug": "kariem-o-m-bessisso",
    "name": "Kariem O M Bessisso",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/26/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-01-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Kariem O M Bessisso",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f0e48436-69cb-4088-bc78-effb853e5001",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-05147",
    "licenseIssueDate": "01/26/2022 00:00:00",
    "licenseExpiryDate": "01/25/2026 00:00:00"
  },
  {
    "id": "77a06ac0-5287-4a09-8874-e2be5906e308",
    "slug": "karim-abdallah-khalil-mohamed-adam",
    "name": "Karim Abdallah Khalil Mohamed Adam",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/08/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Karim Abdallah Khalil Mohamed Adam",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_77a06ac0-5287-4a09-8874-e2be5906e308",
        "address": "29 ,ذا اتش هوتيل ,فندق فيرمونت ,40073 ,Dubai",
        "phone": "97143254000",
        "email": "info@alrowaad.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "759f5477-fdbd-406b-8831-354639c31036",
    "firmName": "AWATIF MOHAMMAD SHOQI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-05103",
    "licenseIssueDate": "11/08/2021 00:00:00",
    "licenseExpiryDate": "11/07/2025 00:00:00"
  },
  {
    "id": "1ad150fc-9758-47b1-bb9d-1a17002abd19",
    "slug": "karim-ali-haidar",
    "name": "Karim Ali Haidar",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/03/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Karim Ali Haidar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1ad150fc-9758-47b1-bb9d-1a17002abd19",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-06524",
    "licenseIssueDate": "10/03/2024 00:00:00",
    "licenseExpiryDate": "10/02/2026 00:00:00"
  },
  {
    "id": "6bad1c18-57cd-4946-90f9-aae1d4736fbb",
    "slug": "karim-hamdy-mahmoud",
    "name": "Karim Hamdy Mahmoud",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/23/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Karim Hamdy Mahmoud",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6bad1c18-57cd-4946-90f9-aae1d4736fbb",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-02612",
    "licenseIssueDate": "06/23/2014 00:00:00",
    "licenseExpiryDate": "06/17/2026 00:00:00"
  },
  {
    "id": "29d090f2-9e3b-45e2-8541-29c4d7b0fe86",
    "slug": "karim-hassanali-shams-ud-din-vellani",
    "name": "Karim Hassanali Shams Ud Din Vellani",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/13/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Karim Hassanali Shams Ud Din Vellani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_29d090f2-9e3b-45e2-8541-29c4d7b0fe86",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-07005"
  },
  {
    "id": "a874aeda-3ade-45c5-a461-751bb44251ed",
    "slug": "karim-mahmoud-radwan-soliman",
    "name": "Karim Mahmoud Radwan Soliman",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/18/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2022-10-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Karim Mahmoud Radwan Soliman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a874aeda-3ade-45c5-a461-751bb44251ed",
        "address": "الطابق 11 - مكتب رقم (1105 ، 1106)  ,برج السلام  ,منطقة المركز التجاري العالمي 1 ,211911 ,Dubai",
        "phone": "97143366769 / 971503636617",
        "email": "info@erlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "fffe1b8f-e9ab-488f-82eb-6151b8f007df",
    "firmName": "EMAN ALRIFAI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05060",
    "licenseIssueDate": "10/18/2021 00:00:00",
    "licenseExpiryDate": "10/17/2022 00:00:00"
  },
  {
    "id": "9e6e634b-9360-4dbc-b954-00a6cd50c9eb",
    "slug": "karim-mohamed-ali",
    "name": "Karim Mohamed Ali",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Karim Mohamed Ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9e6e634b-9360-4dbc-b954-00a6cd50c9eb",
        "address": "Hussain Ali Al Jaziri ,11 ,City Tower 2 ,Crown Plaza hotel Sheikh Zayed Road ,4253 ,Dubai",
        "phone": "97142626777 / 971529087670",
        "email": "courts@jaflaws.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c58d8654-b428-46b3-abd5-024e4331ee53",
    "firmName": "JAAFAR ALWAN & AL JAZIRI & ASSOCIATES",
    "registrationNumber": "L-01606",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "54664760-f3a8-422e-b9bb-6a7730d33da2",
    "slug": "karim-mohamed-ezzeldin-aboelenein-salem",
    "name": "Karim Mohamed Ezzeldin Aboelenein Salem",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/07/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Karim Mohamed Ezzeldin Aboelenein Salem",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_54664760-f3a8-422e-b9bb-6a7730d33da2",
        "address": "Mohamed Nagy ,First floor  ,Clover Bay ,Business bay ,108 ,Dubai",
        "phone": "97143366404",
        "email": "fatimaalmehri5@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a359d947-1da5-4ef9-af87-719d01287fd0",
    "firmName": "FATEMA ALMHEIRI ADVOCATES &LEGAL CONSULTANTS",
    "registrationNumber": "L-03792",
    "licenseIssueDate": "11/07/2021 00:00:00",
    "licenseExpiryDate": "11/06/2025 00:00:00"
  },
  {
    "id": "f201b4fc-1a1f-4c0d-b29b-8f4351889045",
    "slug": "karim-mohmoud-radwan-soliman",
    "name": "Karim Mohmoud Radwan Soliman",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/07/2024",
    "licenseStatus": "active",
    "licenseExpiry": "2025-07-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Karim Mohmoud Radwan Soliman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f201b4fc-1a1f-4c0d-b29b-8f4351889045",
        "address": "",
        "phone": "97144230000 / 971552009022",
        "email": "UAE-CourtClerks@habibalmulla.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3eba82bb-8ec4-4cbd-80d0-a793cb993fde",
    "firmName": "Habib Al Mulla & Partners ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06427",
    "licenseIssueDate": "07/19/2024 00:00:00",
    "licenseExpiryDate": "07/18/2025 00:00:00"
  },
  {
    "id": "88fa6fcb-3ff1-41b9-a023-0731a438fb33",
    "slug": "karl-joseph-masi",
    "name": "Karl Joseph Masi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/07/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Karl Joseph Masi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_88fa6fcb-3ff1-41b9-a023-0731a438fb33",
        "address": "ICD Brookfield Place ,Za'abeel 2 ,103747 ,",
        "phone": "97143696300 / 971506008159",
        "email": "mohammed.paracha@nortonrosefulbright.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c4aaee93-0ec4-4982-9a48-a23699492056",
    "firmName": "Norton Rose Fullbright (Middle East) LLP",
    "registrationNumber": "L-05294",
    "licenseIssueDate": "04/07/2022 00:00:00",
    "licenseExpiryDate": "04/06/2026 00:00:00"
  },
  {
    "id": "85816e53-d805-441d-a4e8-3a8794953870",
    "slug": "karl-sami-touma",
    "name": "Karl Sami Touma",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/14/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Karl Sami Touma",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_85816e53-d805-441d-a4e8-3a8794953870",
        "address": "NABIH AHMED BADER ,Level M Office 203   , The Dubai Mall Fountain Views ,Social District Fountain Views,  Burak Restaurant ,182859 ,Dubai",
        "phone": "97142384655",
        "email": "nbader@eptalex.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "f766fe59-4307-4881-a130-fde85d0dd65d",
    "firmName": "MEG LEGAL SERVICES",
    "registrationNumber": "L-04693",
    "licenseIssueDate": "05/14/2020 00:00:00",
    "licenseExpiryDate": "05/13/2026 00:00:00"
  },
  {
    "id": "e9f2a8c9-0cb9-428d-8c0e-a1379c0862a1",
    "slug": "karolina-anna-lewicki",
    "name": "Karolina Anna Lewicki",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/21/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Karolina Anna Lewicki",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e9f2a8c9-0cb9-428d-8c0e-a1379c0862a1",
        "address": "",
        "phone": "97143121800 / 971566017967",
        "email": "alishia.sullivan@morganlewis.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6eab20d7-8716-4b0a-8710-144d1d951c23",
    "firmName": "Morgan, Lewis & Bockius LLP (dubai Branch)",
    "registrationNumber": "L-06573",
    "licenseIssueDate": "11/21/2024 00:00:00",
    "licenseExpiryDate": "11/20/2025 00:00:00"
  },
  {
    "id": "ec7d40f2-81b5-46aa-a98e-8b68dd8aba73",
    "slug": "kartika-tyagi-ravinder-tyagi",
    "name": "KARTIKA TYAGI RAVINDER TYAGI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/14/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: KARTIKA TYAGI RAVINDER TYAGI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ec7d40f2-81b5-46aa-a98e-8b68dd8aba73",
        "address": "10th Floor ,AlReem Tower ,Dubai Land Department ,32367 ,Dubai",
        "phone": "97142272701",
        "email": "midfaadv@eim.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "fe9068a7-b94d-49bb-88b3-6f8491a15389",
    "firmName": "AL MIDFA & ASSOCIATES",
    "registrationNumber": "L-06445",
    "licenseIssueDate": "08/14/2024 00:00:00",
    "licenseExpiryDate": "08/13/2026 00:00:00"
  },
  {
    "id": "318508c2-7bb2-43c9-a525-f27a4a69b5d7",
    "slug": "kasam-latif-kiani",
    "name": "Kasam Latif Kiani",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/17/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Kasam Latif Kiani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_318508c2-7bb2-43c9-a525-f27a4a69b5d7",
        "address": "One Central, The Offices 5 ,Dubai World Trade Centre ,554660 ,",
        "phone": "97142052030 / 971506566494",
        "email": "chourani@houranipartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "59a73632-40a0-4849-b120-4308dc6f8015",
    "firmName": "Hourani & Partners Legal Consultancy FZCO",
    "registrationNumber": "L-05327",
    "licenseIssueDate": "05/17/2022 00:00:00",
    "licenseExpiryDate": "05/16/2026 00:00:00"
  },
  {
    "id": "6905d4c1-d8af-4543-8b84-86d38777385e",
    "slug": "katherine-anne-iliff",
    "name": "Katherine Anne Iliff",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/01/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-01-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Katherine Anne Iliff",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6905d4c1-d8af-4543-8b84-86d38777385e",
        "address": "Index Tower ,506548 ,Dubai",
        "phone": "97147096300 / 971506767433",
        "email": "amateen@reedsmith.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b3f87e90-7ce9-4097-82c4-15232365f175",
    "firmName": "Reed Smith LLP",
    "registrationNumber": "L-05134",
    "licenseIssueDate": "02/01/2022 00:00:00",
    "licenseExpiryDate": "01/31/2026 00:00:00"
  },
  {
    "id": "d687fff2-2e11-4dd2-8091-02befd8d9e0a",
    "slug": "katherine-louise-seager",
    "name": "Katherine Louise Seager",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/26/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Katherine Louise Seager",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d687fff2-2e11-4dd2-8091-02befd8d9e0a",
        "address": "",
        "phone": "97143121800 / 971566017967",
        "email": "alishia.sullivan@morganlewis.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6eab20d7-8716-4b0a-8710-144d1d951c23",
    "firmName": "Morgan, Lewis & Bockius LLP (dubai Branch)",
    "registrationNumber": "L-06387",
    "licenseIssueDate": "06/26/2024 00:00:00",
    "licenseExpiryDate": "06/25/2026 00:00:00"
  },
  {
    "id": "9a02d0e4-8120-4fb6-a990-c2028fdc5220",
    "slug": "katherine-margaret-corcoran",
    "name": "Katherine Margaret Corcoran",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/04/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Katherine Margaret Corcoran",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9a02d0e4-8120-4fb6-a990-c2028fdc5220",
        "address": "",
        "phone": "97143742800 / 971506450677",
        "email": "jabbott21@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7a59d310-ff72-4318-b41c-27095c163d0f",
    "firmName": "CMS (UAE) LLP",
    "registrationNumber": "L-05053",
    "licenseIssueDate": "10/04/2021 00:00:00",
    "licenseExpiryDate": "10/03/2026 00:00:00"
  },
  {
    "id": "e571d741-8827-41d0-b056-c46902a58532",
    "slug": "kathinka-sophia-wiig-honore",
    "name": "Kathinka Sophia Wiig Honore",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/05/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Kathinka Sophia Wiig Honore",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e571d741-8827-41d0-b056-c46902a58532",
        "address": "1 ,ICD Brookfield Place ,Dubai International Financial Centre ,9267 ,Dubai",
        "phone": "97147010975 / 971502977062",
        "email": "chris.sioufi@ae.ey.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "42e536ef-e3d8-4339-8572-657a7f7a0331",
    "firmName": "EY Law LLP",
    "registrationNumber": "L-05549",
    "licenseIssueDate": "10/05/2022 00:00:00",
    "licenseExpiryDate": "10/04/2025 00:00:00"
  },
  {
    "id": "17494488-8e2a-4452-ab15-9be16a24771d",
    "slug": "katlego-johannes-lebea",
    "name": "Katlego Johannes Lebea",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/10/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Katlego Johannes Lebea",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_17494488-8e2a-4452-ab15-9be16a24771d",
        "address": "One Central, The Offices 5 ,Dubai World Trade Centre ,554660 ,",
        "phone": "97142052030 / 971506566494",
        "email": "chourani@houranipartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "59a73632-40a0-4849-b120-4308dc6f8015",
    "firmName": "Hourani & Partners Legal Consultancy FZCO",
    "registrationNumber": "L-06954",
    "licenseIssueDate": "09/01/2025 00:00:00",
    "licenseExpiryDate": "08/31/2026 00:00:00"
  },
  {
    "id": "6ef9d2cb-cc2e-40cf-98ad-cf41c0d9db3d",
    "slug": "katrina-morrison",
    "name": "Katrina Morrison",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/03/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Katrina Morrison",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6ef9d2cb-cc2e-40cf-98ad-cf41c0d9db3d",
        "address": "1 ,ICD Brookfield Place ,Dubai International Financial Centre ,9267 ,Dubai",
        "phone": "97147010975 / 971502977062",
        "email": "chris.sioufi@ae.ey.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "42e536ef-e3d8-4339-8572-657a7f7a0331",
    "firmName": "EY Law LLP",
    "registrationNumber": "L-03894",
    "licenseIssueDate": "10/03/2017 00:00:00",
    "licenseExpiryDate": "09/30/2026 00:00:00"
  },
  {
    "id": "0f872d7f-d342-4f55-80ab-55fd0047bdf4",
    "slug": "kavitha-achuthan-panicker",
    "name": "Kavitha Achuthan Panicker",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Kavitha Achuthan Panicker",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0f872d7f-d342-4f55-80ab-55fd0047bdf4",
        "address": "4th floor ,Al Saaha Offices Block D office 401A ,Burj Khalifa ,283773 ,Dubai",
        "phone": "97144221944",
        "email": "gov.depts@alsafarpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b7bbfaeb-1fdb-46d2-97cf-8e6432a9b8a7",
    "firmName": "AL SAFAR & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02456",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "ed68ae5f-f0af-4ba2-b065-9d22be28b7c6",
    "slug": "keely-sian-muston",
    "name": "Keely Sian Muston",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/09/2025",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Keely Sian Muston",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ed68ae5f-f0af-4ba2-b065-9d22be28b7c6",
        "address": "ICD-Brookfield Place ,DIFC ,119974 ,",
        "phone": "97143652000",
        "email": "david.charlier@ashurst.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c01c3c61-4d90-4058-8429-61dd01e615f5",
    "firmName": "Ashurst LLP-DIFC",
    "registrationNumber": "L-06258",
    "licenseIssueDate": "09/16/2025 00:00:00",
    "licenseExpiryDate": "09/15/2026 00:00:00"
  },
  {
    "id": "5583419d-b93d-4a65-acfc-ab53683e8378",
    "slug": "keith-bullen",
    "name": "Keith Bullen",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/06/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Keith Bullen",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5583419d-b93d-4a65-acfc-ab53683e8378",
        "address": "",
        "phone": "97143742800 / 971506450677",
        "email": "jabbott21@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7a59d310-ff72-4318-b41c-27095c163d0f",
    "firmName": "CMS (UAE) LLP",
    "registrationNumber": "L-00553",
    "licenseIssueDate": "05/06/2024 00:00:00",
    "licenseExpiryDate": "05/05/2026 00:00:00"
  },
  {
    "id": "eead1147-9249-4134-9edf-99abe8c0a574",
    "slug": "keith-hutchison",
    "name": "Keith Hutchison",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/11/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Keith Hutchison",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_eead1147-9249-4134-9edf-99abe8c0a574",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-00295",
    "licenseIssueDate": "10/11/2011 00:00:00",
    "licenseExpiryDate": "10/02/2026 00:00:00"
  },
  {
    "id": "4741a852-4207-4b0f-99a4-1cebf4e4de7d",
    "slug": "kellie-blyth",
    "name": "Kellie Blyth",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/10/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Kellie Blyth",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4741a852-4207-4b0f-99a4-1cebf4e4de7d",
        "address": "6 ,Office Nos. 603, 604 & 605, Level 6, Burj Daman ,Dubai International Financial Centre ,506555 ,Dubai",
        "phone": "97143506400 / 971504654755",
        "email": "r.hickman@aglaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8690f7d5-6b96-4649-9589-71303f2c2707",
    "firmName": "Addleshaw Goddard (Middle East) LLP",
    "registrationNumber": "L-00296",
    "licenseIssueDate": "05/10/2012 00:00:00",
    "licenseExpiryDate": "05/02/2026 00:00:00"
  },
  {
    "id": "22706b1a-1381-48f6-b635-f3cb8d837bce",
    "slug": "kelly-ann-dunn",
    "name": "Kelly Ann Dunn",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/02/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Kelly Ann Dunn",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_22706b1a-1381-48f6-b635-f3cb8d837bce",
        "address": "20 ,Index Tower West Tower ,DIFC ,507226 ,Dubai",
        "phone": "97142461900 / 971523391604",
        "email": "patrick.gearon@crsblaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e2ac552e-b9a7-450b-a84d-15119e583220",
    "firmName": "Charles Russell Speechlys LLP",
    "registrationNumber": "L-05937",
    "licenseIssueDate": "08/02/2023 00:00:00",
    "licenseExpiryDate": "08/01/2026 00:00:00"
  },
  {
    "id": "455bbbea-0881-4404-8d47-e8364b235f63",
    "slug": "kelly-richardson",
    "name": "Kelly Richardson",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/05/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2021-05-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Kelly Richardson",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_455bbbea-0881-4404-8d47-e8364b235f63",
        "address": "Saleh Ahmed Yousif Saleh Alobeidli ,2nd ,DUBAI SUPREME COURT COMPLEX ,Dubai Courts ,333842 ,Dubai",
        "phone": "97143546762",
        "email": "Laila@iclo.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "57836e55-f90c-4fb1-81d0-a735a168b9ac",
    "firmName": "INTERNATIONAL CONSULTANT LAW OFFICE",
    "registrationNumber": "L-03764",
    "licenseIssueDate": "05/30/2017 00:00:00",
    "licenseExpiryDate": "05/27/2021 00:00:00"
  },
  {
    "id": "21f385f8-8932-4146-9632-5dbc496f0742",
    "slug": "kende-anyos-szabo",
    "name": "Kende Anyos Szabo",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/26/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Kende Anyos Szabo",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_21f385f8-8932-4146-9632-5dbc496f0742",
        "address": "0 ,ICD Brookfield Place Level 13 ,Trade Centre ,506569 ,Dubai",
        "phone": "97145099100 / 971501006965",
        "email": "menahr@freshfields.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "970f6246-e737-41a7-9c6c-5aa5b8335d45",
    "firmName": "Freshfields LLP DIFC",
    "registrationNumber": "L-06385",
    "licenseIssueDate": "06/26/2024 00:00:00",
    "licenseExpiryDate": "06/25/2026 00:00:00"
  },
  {
    "id": "ec0022ff-984e-43c5-af79-2f24f4a2b09f",
    "slug": "kenneth-dixon",
    "name": "Kenneth Dixon",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/23/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Kenneth Dixon",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ec0022ff-984e-43c5-af79-2f24f4a2b09f",
        "address": "",
        "phone": "97143685555",
        "email": "maisa.maarouf@bsabh.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8afa232f-52ff-4dad-82c3-9a04d66eb853",
    "firmName": "B S A AHMED BIN HAZEEM & ASSOCIATES LLP - DIFC",
    "registrationNumber": "L-02510",
    "licenseIssueDate": "02/23/2014 00:00:00",
    "licenseExpiryDate": "02/16/2026 00:00:00"
  },
  {
    "id": "c9f9749d-80c2-4a67-a3a2-cb7a7ad4cd72",
    "slug": "kenza-bensaid",
    "name": "Kenza Bensaid",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/05/2021",
    "licenseStatus": "active",
    "licenseExpiry": "2022-05-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Kenza Bensaid",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c9f9749d-80c2-4a67-a3a2-cb7a7ad4cd72",
        "address": "ICD Brookfield Place ,Za'abeel 2 ,103747 ,",
        "phone": "97143696300 / 971506008159",
        "email": "mohammed.paracha@nortonrosefulbright.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c4aaee93-0ec4-4982-9a48-a23699492056",
    "firmName": "Norton Rose Fullbright (Middle East) LLP",
    "registrationNumber": "L-04942",
    "licenseIssueDate": "05/24/2021 00:00:00",
    "licenseExpiryDate": "05/23/2026 00:00:00"
  },
  {
    "id": "7c714bd1-16fe-4e9a-a50f-3729c04e7117",
    "slug": "keri-watkins",
    "name": "Keri Watkins",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Keri Watkins",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7c714bd1-16fe-4e9a-a50f-3729c04e7117",
        "address": "Al Fattan Currency House Tower 2 ,DIFC ,507176 ,",
        "phone": "/ 971552009003",
        "email": "Mohammad.AlRasheed@bakermckenzie.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "acd81e81-dead-4f7c-839e-0f2a57897265",
    "firmName": "Baker & Mckenzie LLP",
    "registrationNumber": "L-00658",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "35d5b686-d150-4618-ab07-0dd0bd924778",
    "slug": "kerri-anne-gevers",
    "name": "Kerri Anne Gevers",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/29/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Kerri Anne Gevers",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_35d5b686-d150-4618-ab07-0dd0bd924778",
        "address": "ICD Brookfield Place ,Za'abeel 2 ,103747 ,",
        "phone": "97143696300 / 971506008159",
        "email": "mohammed.paracha@nortonrosefulbright.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c4aaee93-0ec4-4982-9a48-a23699492056",
    "firmName": "Norton Rose Fullbright (Middle East) LLP",
    "registrationNumber": "L-06650",
    "licenseIssueDate": "01/29/2025 00:00:00",
    "licenseExpiryDate": "01/28/2026 00:00:00"
  },
  {
    "id": "26f7c8a0-df39-4f11-a06b-012a61ffcc32",
    "slug": "kerry-elizabeth-hydari",
    "name": "Kerry Elizabeth Hydari",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/22/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Kerry Elizabeth Hydari",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_26f7c8a0-df39-4f11-a06b-012a61ffcc32",
        "address": "",
        "phone": "97143298881",
        "email": "info@mslawuae.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2510dab9-717a-4a15-b189-4272261227e3",
    "firmName": "AL MADHANI & AL SHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06080",
    "licenseIssueDate": "11/22/2023 00:00:00",
    "licenseExpiryDate": "11/21/2025 00:00:00"
  },
  {
    "id": "078654b3-3520-4993-b63a-c2fda6759bc8",
    "slug": "kerryann-louise-buttle",
    "name": "Kerryann Louise Buttle",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/19/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Kerryann Louise Buttle",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_078654b3-3520-4993-b63a-c2fda6759bc8",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-05882",
    "licenseIssueDate": "07/19/2023 00:00:00",
    "licenseExpiryDate": "07/18/2026 00:00:00"
  },
  {
    "id": "f9ca3d01-9c84-4d3f-99b9-55bfa14c2fee",
    "slug": "keshav-raychaudhuri",
    "name": "Keshav Raychaudhuri",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/27/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Keshav Raychaudhuri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f9ca3d01-9c84-4d3f-99b9-55bfa14c2fee",
        "address": "",
        "phone": "97143438897 / 971507753952",
        "email": "jdavidson@davidson-legal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d0200f27-9504-4653-a5c6-05e4bcab7ff0",
    "firmName": "Davidson & Co Legal Consultants",
    "registrationNumber": "L-01513",
    "licenseIssueDate": "12/27/2018 00:00:00",
    "licenseExpiryDate": "12/25/2025 00:00:00"
  },
  {
    "id": "6a766335-3eaa-4277-8346-3a8877b4d78b",
    "slug": "kevin-antony-sharara",
    "name": "Kevin Antony Sharara",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/30/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Kevin Antony Sharara",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6a766335-3eaa-4277-8346-3a8877b4d78b",
        "address": "",
        "phone": "97144363636 / 971505572900",
        "email": "hassan.elsayed@bakerbotts.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "fd5d6571-d053-4436-9de5-c8a36ce7c6c9",
    "firmName": "Baker Botts LLP Legal Consultants Dubai Branch",
    "registrationNumber": "L-06760",
    "licenseIssueDate": "04/30/2025 00:00:00",
    "licenseExpiryDate": "04/29/2026 00:00:00"
  },
  {
    "id": "b8e8df07-1ca5-4936-b39d-593881881e9d",
    "slug": "kevin-jon-pearson",
    "name": "Kevin Jon Pearson",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/22/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Kevin Jon Pearson",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b8e8df07-1ca5-4936-b39d-593881881e9d",
        "address": "",
        "phone": "97143121800 / 971566017967",
        "email": "alishia.sullivan@morganlewis.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6eab20d7-8716-4b0a-8710-144d1d951c23",
    "firmName": "Morgan, Lewis & Bockius LLP (dubai Branch)",
    "registrationNumber": "L-05371",
    "licenseIssueDate": "06/22/2022 00:00:00",
    "licenseExpiryDate": "06/21/2026 00:00:00"
  },
  {
    "id": "8d54baf7-8614-449b-b836-c0bb84799ba5",
    "slug": "khadija-el-leithy",
    "name": "Khadija El Leithy",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/04/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Khadija El Leithy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8d54baf7-8614-449b-b836-c0bb84799ba5",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-05031",
    "licenseIssueDate": "10/04/2021 00:00:00",
    "licenseExpiryDate": "10/03/2026 00:00:00"
  },
  {
    "id": "84989e32-2afb-49dd-8c9c-241824c3e8d0",
    "slug": "khadija-er-raadi",
    "name": "khadija er raadi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/12/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: khadija er raadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_84989e32-2afb-49dd-8c9c-241824c3e8d0",
        "address": "ABDULRAHMAN MOHAMED ALAAMRI ,306 ,ACICO BUISINESS PARK ,NISSAN SHOW ROOM ,33731 ,Dubai",
        "phone": "97148819818 / 971503933245",
        "email": "info@alaamri.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "bf13bfd5-9c31-447d-a1f6-1939ed8ab235",
    "firmName": "ABDULRAHMAN ALAMERI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05559",
    "licenseIssueDate": "10/12/2022 00:00:00",
    "licenseExpiryDate": "10/11/2026 00:00:00"
  },
  {
    "id": "efc5983c-9313-4f79-950f-52b192906c17",
    "slug": "khadija-hussain",
    "name": "Khadija Hussain",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/25/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Khadija Hussain",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_efc5983c-9313-4f79-950f-52b192906c17",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04462",
    "licenseIssueDate": "07/25/2019 00:00:00",
    "licenseExpiryDate": "07/24/2026 00:00:00"
  },
  {
    "id": "351fb944-5818-40b3-b437-dbf502907605",
    "slug": "khalaf-obaid-ali-almamari",
    "name": "khalaf obaid ali almamari",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/25/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: khalaf obaid ali almamari",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_351fb944-5818-40b3-b437-dbf502907605",
        "address": "Hassan Mohammad Hassan Tamim ,الطابق السادس 614 ,اعمار بزنس بارك - 4  ,Zabeel house the greens - hotel  ,18122 ,Dubai",
        "phone": "97142999972",
        "email": "info@htlawyers.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6e2fe0dd-c3f8-40ae-9ed8-5e4fdf894d9b",
    "firmName": "HASSAN TAMIM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05697",
    "licenseIssueDate": "01/25/2023 00:00:00",
    "licenseExpiryDate": "01/24/2026 00:00:00"
  },
  {
    "id": "ea5d9343-8e80-4437-a017-4f49a09a1dba",
    "slug": "khaled-abdelhafiz-elderbashy",
    "name": "Khaled Abdelhafiz Elderbashy",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/28/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Khaled Abdelhafiz Elderbashy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ea5d9343-8e80-4437-a017-4f49a09a1dba",
        "address": "HASSAN AL BAKRI ,16 ,THE EXCHANGE TOWER ,DUBAI WATER CANAL ,89179 ,Dubai",
        "phone": "97145807888",
        "email": "secretary@alkathirilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b5f1d60b-df9b-4054-ac59-4543a6d06af4",
    "firmName": "SHOUQ ALKATHIRI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02126",
    "licenseIssueDate": "11/28/2016 00:00:00",
    "licenseExpiryDate": "11/24/2025 00:00:00"
  },
  {
    "id": "e7f6af5d-c50e-4116-85a8-45359f90556b",
    "slug": "khaled-adly-mohamed",
    "name": "Khaled Adly Mohamed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/06/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Khaled Adly Mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e7f6af5d-c50e-4116-85a8-45359f90556b",
        "address": "السادس , مباني الحضيبة للجوائز  ,علم الاتحاد ,200 ,Dubai",
        "phone": "97143545111",
        "email": "altaher_alsabri@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "aced7900-0571-43e1-b49b-4740c6dc298f",
    "firmName": "AL TAHER & AL SABRI ADVOCATES",
    "registrationNumber": "L-02220",
    "licenseIssueDate": "08/06/2013 00:00:00",
    "licenseExpiryDate": "07/30/2026 00:00:00"
  },
  {
    "id": "dd8a0ee3-3c80-45d0-b98b-7d0fdeba4b92",
    "slug": "khaled-ahmed-ibrahim-farah",
    "name": "Khaled Ahmed Ibrahim Farah",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/04/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Khaled Ahmed Ibrahim Farah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dd8a0ee3-3c80-45d0-b98b-7d0fdeba4b92",
        "address": "",
        "phone": "97143093222 / 971566651954",
        "email": "melissa.murray@twobirds.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3e1526e6-4c8d-4b6f-985f-ea05e9f99bcb",
    "firmName": "Bird & Bird (MEA) LLP",
    "registrationNumber": "L-06889",
    "licenseIssueDate": "07/04/2025 00:00:00",
    "licenseExpiryDate": "07/03/2026 00:00:00"
  },
  {
    "id": "6b08bec1-a2a3-4389-b97e-1f9020a5efc1",
    "slug": "khaled-ali-al-ansi",
    "name": "Khaled Ali Al-Ansi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Khaled Ali Al-Ansi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6b08bec1-a2a3-4389-b97e-1f9020a5efc1",
        "address": "yousif almaazmi ,التاسع  ,سيتاديل تاور  ,خلف فندق جي دبليوماريوت  ,94646 ,Dubai",
        "phone": "97144517744",
        "email": "info@cityint.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "59aaa82d-162e-4646-9bcc-f3349dfb2512",
    "firmName": "YOUSEF ALMAAZMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01700",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "d9d73436-5580-4889-9bfc-68ad86d21f9b",
    "slug": "khaled-alsayed-husein",
    "name": "Khaled Alsayed Husein",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/03/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Khaled Alsayed Husein",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d9d73436-5580-4889-9bfc-68ad86d21f9b",
        "address": "5 ,tasheel bldg ,nasr club ,116749 ,Dubai",
        "phone": "97143970701",
        "email": "salha@albastiadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c34580b3-9e80-4326-bd68-0eb2abbb06fc",
    "firmName": "SALHA ALBASTI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02371",
    "licenseIssueDate": "03/03/2014 00:00:00",
    "licenseExpiryDate": "02/24/2026 00:00:00"
  },
  {
    "id": "95dd880e-1cdc-4285-a1f7-8bfd6445ff21",
    "slug": "khaled-antar-said",
    "name": "KHALED ANTAR SAID",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/27/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: KHALED ANTAR SAID",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_95dd880e-1cdc-4285-a1f7-8bfd6445ff21",
        "address": "Office 413 - Block B ,Hamdan Bin Rashid Al Maktoum Foundation for Medical Science ,Makani No: 2598892707 ,000 ,Dubai",
        "phone": "97142571323 / 971554377771",
        "email": "info@alzaabi-binghalaita.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ff6f54b7-0992-43dc-8480-cfff31538d52",
    "firmName": "HAMAD ALZAABI & MUNA BIN GHALAITA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05052",
    "licenseIssueDate": "09/27/2021 00:00:00",
    "licenseExpiryDate": "09/26/2026 00:00:00"
  },
  {
    "id": "0625ac17-7bfd-49ba-af20-31fd863844e5",
    "slug": "khaled-bassiouni",
    "name": "Khaled Bassiouni",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/19/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Khaled Bassiouni",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0625ac17-7bfd-49ba-af20-31fd863844e5",
        "address": "",
        "phone": "97142722998",
        "email": "jalnuaimi.adv@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "1b84b124-19de-41b5-89de-ec40b2bd1d01",
    "firmName": "DR JAMAL ALNUAIMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03453",
    "licenseIssueDate": "05/19/2025 00:00:00",
    "licenseExpiryDate": "05/18/2026 00:00:00"
  },
  {
    "id": "f8dff7ca-0fa3-44cb-8eb4-31f5742f97ee",
    "slug": "khaled-eid-mohamed",
    "name": "Khaled Eid Mohamed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/18/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Khaled Eid Mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f8dff7ca-0fa3-44cb-8eb4-31f5742f97ee",
        "address": "",
        "phone": "97142955575",
        "email": "info@yalhamed.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "af6ac730-58a7-44a4-9f60-78811de374c7",
    "firmName": "YASIN ALHAMED ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02849",
    "licenseIssueDate": "02/18/2015 00:00:00",
    "licenseExpiryDate": "02/12/2026 00:00:00"
  },
  {
    "id": "2c3894dd-7a8d-4297-8aea-2a956bf4fd9f",
    "slug": "khaled-elsoaly",
    "name": "Khaled Elsoaly",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/16/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Khaled Elsoaly",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2c3894dd-7a8d-4297-8aea-2a956bf4fd9f",
        "address": "Office No. 601 ,Business Avenue Building ,Behind Nissan Showroom, Makani No: 3248594620 ,000 ,Dubai",
        "phone": "97142369992 / 971503199393",
        "email": "info@almheiriadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2fb2bd9b-adf2-48f2-a4d0-26aa52ed5e26",
    "firmName": "KHAWLA AL MHEIRI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03288",
    "licenseIssueDate": "05/16/2019 00:00:00",
    "licenseExpiryDate": "05/15/2026 00:00:00"
  },
  {
    "id": "0727c0eb-183f-4159-92cb-8e6c8d842324",
    "slug": "khaled-hashem-mohamed",
    "name": "Khaled Hashem Mohamed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Khaled Hashem Mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0727c0eb-183f-4159-92cb-8e6c8d842324",
        "address": "saadaldain ,407 ,سيتي باي مركز الاعمال  ,المستشفي الكندي ,182435 ,Dubai",
        "phone": "97142280908",
        "email": "alraya990@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d7e59e90-7dc8-4877-9c43-b3f1f8a52e72",
    "firmName": "AL RAYA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01215",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "49f1d10d-d54e-4b0d-9e8c-b57a89cea8d3",
    "slug": "khaled-hasna",
    "name": "Khaled Hasna",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/12/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Khaled Hasna",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_49f1d10d-d54e-4b0d-9e8c-b57a89cea8d3",
        "address": "Ahmad Al Otaibi ,6th floor /606 ,Century 21 Tower ,Alqabayel Center ,126936 ,Dubai",
        "phone": "97142697670",
        "email": "info@otaibilc.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5e10a3c0-085d-4e92-84b1-ec3013bc4bae",
    "firmName": "AL OTAIBI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02667",
    "licenseIssueDate": "06/12/2014 00:00:00",
    "licenseExpiryDate": "06/06/2026 00:00:00"
  },
  {
    "id": "aa2180a4-7373-4b23-b2f6-aeafeeaa6bcb",
    "slug": "khaled-mohamed-mousa",
    "name": "Khaled Mohamed Mousa",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/07/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-02-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Khaled Mohamed Mousa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_aa2180a4-7373-4b23-b2f6-aeafeeaa6bcb",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01722",
    "licenseIssueDate": "01/07/2016 00:00:00",
    "licenseExpiryDate": "01/02/2026 00:00:00"
  },
  {
    "id": "1e7e789c-dd7a-4961-a5f3-e454bc8eae6e",
    "slug": "khaled-mohamed-taha-dabour",
    "name": "khaled mohamed taha dabour",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/25/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: khaled mohamed taha dabour",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1e7e789c-dd7a-4961-a5f3-e454bc8eae6e",
        "address": "",
        "phone": "97143298881",
        "email": "info@mslawuae.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2510dab9-717a-4a15-b189-4272261227e3",
    "firmName": "AL MADHANI & AL SHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06627",
    "licenseIssueDate": "12/25/2024 00:00:00",
    "licenseExpiryDate": "12/24/2025 00:00:00"
  },
  {
    "id": "9a09c5fb-e113-4207-9c76-099610b496ee",
    "slug": "khaled-mohmoud-mahmoud-elnanaai",
    "name": "khaled mohmoud mahmoud elnanaai",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/19/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: khaled mohmoud mahmoud elnanaai",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9a09c5fb-e113-4207-9c76-099610b496ee",
        "address": "",
        "phone": "97145911811 / 971506137373",
        "email": "info@advoalhadhrami.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "52d0e50e-9741-4720-8ae1-7de3cbda373d",
    "firmName": "MOHAMED ALHEMEIRI LAWYERS AND LEGAL CONSULTANTS",
    "registrationNumber": "L-01796",
    "licenseIssueDate": "05/19/2023 00:00:00",
    "licenseExpiryDate": "05/18/2026 00:00:00"
  },
  {
    "id": "1b72b44f-37a3-4651-91f2-c2d9f779257a",
    "slug": "khaled-saad",
    "name": "khaled saad",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/25/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-01-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: khaled saad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1b72b44f-37a3-4651-91f2-c2d9f779257a",
        "address": "YASIR AL NAQBI ,21 ,48 BURJ ,SOFITEL DOWN  TOWN ,181111 ,Dubai",
        "phone": "97142689949",
        "email": "info@alnaqbipartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ad71430e-83ee-4cb5-a530-bc58db2618f6",
    "firmName": "ALNAQBI & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05705",
    "licenseIssueDate": "01/25/2023 00:00:00",
    "licenseExpiryDate": "01/24/2026 00:00:00"
  },
  {
    "id": "7ed85b98-ec5c-4349-b9a6-a6e9a5f7f835",
    "slug": "khaled-salah-adly-mohamed",
    "name": "khaled salah adly mohamed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/27/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: khaled salah adly mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7ed85b98-ec5c-4349-b9a6-a6e9a5f7f835",
        "address": "",
        "phone": "97142566800",
        "email": "fatema@alhammadiadvocate.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "07521705-aa90-4c3a-b5fd-c55e54889e60",
    "firmName": "MOHAMED AL HAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05048",
    "licenseIssueDate": "09/27/2021 00:00:00",
    "licenseExpiryDate": "09/26/2026 00:00:00"
  },
  {
    "id": "3edc8a55-138c-4a0f-8fda-ab21f6b4bfc3",
    "slug": "khaled-samy-gamaleldeen",
    "name": "Khaled Samy Gamaleldeen",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Khaled Samy Gamaleldeen",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3edc8a55-138c-4a0f-8fda-ab21f6b4bfc3",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01274",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "18560145-4bb1-4b47-8c35-8509c9ee7881",
    "slug": "khaledahmed-moustafa-ahmed-elgohari",
    "name": "khaledahmed moustafa ahmed elgohari",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/11/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: khaledahmed moustafa ahmed elgohari",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_18560145-4bb1-4b47-8c35-8509c9ee7881",
        "address": "",
        "phone": "97143685555",
        "email": "maisa.maarouf@bsabh.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8afa232f-52ff-4dad-82c3-9a04d66eb853",
    "firmName": "B S A AHMED BIN HAZEEM & ASSOCIATES LLP - DIFC",
    "registrationNumber": "L-04697",
    "licenseIssueDate": "06/11/2020 00:00:00",
    "licenseExpiryDate": "06/10/2026 00:00:00"
  },
  {
    "id": "fdd171e2-2d67-4684-887c-8a68a2ff7d22",
    "slug": "khalid-abbas-khalid-elkhider",
    "name": "Khalid Abbas Khalid Elkhider",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/16/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Khalid Abbas Khalid Elkhider",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fdd171e2-2d67-4684-887c-8a68a2ff7d22",
        "address": "",
        "phone": "97143366080",
        "email": "info@accordlawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0c25ab44-71a4-49f3-9d94-7b5a222500f2",
    "firmName": "ACCORD INTERNATIONAL ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06219",
    "licenseIssueDate": "02/16/2024 00:00:00",
    "licenseExpiryDate": "02/15/2026 00:00:00"
  },
  {
    "id": "1b4fc482-0541-4be7-9768-879897bb639a",
    "slug": "khalid-eldisagi-el-derderi",
    "name": "Khalid Eldisagi El Derderi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/29/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Khalid Eldisagi El Derderi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1b4fc482-0541-4be7-9768-879897bb639a",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-02080",
    "licenseIssueDate": "11/29/2011 00:00:00",
    "licenseExpiryDate": "11/20/2025 00:00:00"
  },
  {
    "id": "119eded3-d6d5-4f61-b76a-fb2e8c32163b",
    "slug": "khalid-hassan-ibrahim-abdo",
    "name": "Khalid Hassan Ibrahim Abdo",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/26/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Khalid Hassan Ibrahim Abdo",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_119eded3-d6d5-4f61-b76a-fb2e8c32163b",
        "address": "",
        "phone": "97143366080",
        "email": "info@accordlawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0c25ab44-71a4-49f3-9d94-7b5a222500f2",
    "firmName": "ACCORD INTERNATIONAL ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06704",
    "licenseIssueDate": "02/26/2025 00:00:00",
    "licenseExpiryDate": "02/25/2026 00:00:00"
  },
  {
    "id": "bb879322-59c8-4b20-84ff-f8cec421b82c",
    "slug": "khalid-mohamed-ebrahim",
    "name": "Khalid Mohamed Ebrahim",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/17/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Khalid Mohamed Ebrahim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bb879322-59c8-4b20-84ff-f8cec421b82c",
        "address": "",
        "phone": "97143528887",
        "email": "info@kashwanilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "01ccf3a9-cfd3-4fb5-b5ac-a912503c2630",
    "firmName": "KASHWANI LAW FIRM",
    "registrationNumber": "L-02188",
    "licenseIssueDate": "09/17/2013 00:00:00",
    "licenseExpiryDate": "09/10/2026 00:00:00"
  },
  {
    "id": "a5f7c933-194f-4903-bdbc-1f0412b485b9",
    "slug": "khalid-mohammed-mabrook-hamood-al-aamri",
    "name": "khalid Mohammed mabrook hamood Al Aamri",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/06/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: khalid Mohammed mabrook hamood Al Aamri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a5f7c933-194f-4903-bdbc-1f0412b485b9",
        "address": "1 ,Crystal Tower ,Business Bay ,1859 ,Dubai",
        "phone": "97142956661",
        "email": "info@amrplc.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "833edb7f-7a70-4ab6-9838-4782eb1b4f8a",
    "firmName": "ABDULLA MOHAMMED RASOUL ALHARMOODI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06883",
    "licenseIssueDate": "06/30/2025 00:00:00",
    "licenseExpiryDate": "06/29/2026 00:00:00"
  },
  {
    "id": "b168c830-c725-4df1-bbc6-8bc7583f4bbd",
    "slug": "khalid-suror-mirza-ardalan",
    "name": "Khalid Suror Mirza Ardalan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/21/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Khalid Suror Mirza Ardalan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b168c830-c725-4df1-bbc6-8bc7583f4bbd",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-03973",
    "licenseIssueDate": "12/21/2017 00:00:00",
    "licenseExpiryDate": "12/18/2025 00:00:00"
  },
  {
    "id": "a1e8c2b4-4d1c-4393-8401-d3a58ea59366",
    "slug": "khalid-yaagoob-alshariff-alkhider",
    "name": "Khalid Yaagoob Alshariff Alkhider",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/25/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Khalid Yaagoob Alshariff Alkhider",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a1e8c2b4-4d1c-4393-8401-d3a58ea59366",
        "address": "OBAID SAQER OBAID BUSIT ,20 ,Grosvenor Business Tower -  ,Sheikha noora tower ,333341 ,Dubai",
        "phone": "97144472777",
        "email": "busit@busitlegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ebfce11b-8cb4-42cc-95d3-71c6e17bfdf0",
    "firmName": "KHALIFA BIN HUWAIDAN ALKETBI ADVOCATES & LEGAL CONSULTANT",
    "registrationNumber": "L-06308",
    "licenseIssueDate": "04/25/2024 00:00:00",
    "licenseExpiryDate": "04/24/2026 00:00:00"
  },
  {
    "id": "44c82b83-cbc8-493f-a171-d371b4277b63",
    "slug": "khalil-gibran-abdulaziz",
    "name": "Khalil Gibran Abdulaziz",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/01/2025",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Khalil Gibran Abdulaziz",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_44c82b83-cbc8-493f-a171-d371b4277b63",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-06644",
    "licenseIssueDate": "01/09/2025 00:00:00",
    "licenseExpiryDate": "01/08/2026 00:00:00"
  },
  {
    "id": "c043a997-0ca7-4705-b802-0037be5f2ed9",
    "slug": "khamis-abdelfattah-khamis-moustafa",
    "name": "Khamis Abdelfattah Khamis Moustafa",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/23/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Khamis Abdelfattah Khamis Moustafa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c043a997-0ca7-4705-b802-0037be5f2ed9",
        "address": "14th Floor, No.2 ,Al Burj Al Salam ,Makani No: 27412 91443 ,000 ,Dubai",
        "phone": "97148823210 / 971565301153",
        "email": "info@tarishlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ca640589-e7ab-45e9-8d6e-52a161a80279",
    "firmName": "TARISH ALMANSOORI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05319",
    "licenseIssueDate": "05/23/2022 00:00:00",
    "licenseExpiryDate": "05/22/2026 00:00:00"
  },
  {
    "id": "a4fad3dc-e67b-41c4-8957-2ec10441639a",
    "slug": "khedr-ali",
    "name": "Khedr Ali",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/26/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Khedr Ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a4fad3dc-e67b-41c4-8957-2ec10441639a",
        "address": "next level restaurant  , centurion star - block B - office 806 & 807 ,behind day to day - opposite deira city center ,237766 ,Dubai",
        "phone": "97142622002",
        "email": "info@almaftool-advocate.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "bc6598b4-c5d3-4280-b29d-4c3c132c3a21",
    "firmName": "KHALIFA AL MAFTOOL ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-03370",
    "licenseIssueDate": "05/26/2016 00:00:00",
    "licenseExpiryDate": "05/22/2026 00:00:00"
  },
  {
    "id": "e19d854f-e32d-425c-9ad3-04d84f62b913",
    "slug": "kholoud-hafez-mohamed-hassan",
    "name": "Kholoud Hafez Mohamed Hassan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/12/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Kholoud Hafez Mohamed Hassan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e19d854f-e32d-425c-9ad3-04d84f62b913",
        "address": "",
        "phone": "97144230000 / 971552009022",
        "email": "UAE-CourtClerks@habibalmulla.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3eba82bb-8ec4-4cbd-80d0-a793cb993fde",
    "firmName": "Habib Al Mulla & Partners ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05548",
    "licenseIssueDate": "10/12/2022 00:00:00",
    "licenseExpiryDate": "10/11/2026 00:00:00"
  },
  {
    "id": "e23ef9c7-1c65-41ac-a284-1ce4c93c5647",
    "slug": "khurram-ali",
    "name": "Khurram Ali",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/26/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Khurram Ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e23ef9c7-1c65-41ac-a284-1ce4c93c5647",
        "address": "",
        "phone": "97144073901 / 971503479508",
        "email": "Rania.Tadros@stephensonharwood.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dd5042a2-bb41-4123-9544-79c3fa831332",
    "firmName": "Stephenson Harwood (Middle East) LLP",
    "registrationNumber": "L-01878",
    "licenseIssueDate": "10/26/2021 00:00:00",
    "licenseExpiryDate": "10/25/2025 00:00:00"
  },
  {
    "id": "a01c09e6-ce17-4906-a2cd-b8da8d7ad387",
    "slug": "khurram-yaqub",
    "name": "Khurram Yaqub",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/15/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Khurram Yaqub",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a01c09e6-ce17-4906-a2cd-b8da8d7ad387",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-05107",
    "licenseIssueDate": "11/15/2021 00:00:00",
    "licenseExpiryDate": "11/14/2025 00:00:00"
  },
  {
    "id": "49250a20-c0bf-4367-a51c-63b010b5917d",
    "slug": "khushboo-hashu-shahdadpuri",
    "name": "Khushboo Hashu Shahdadpuri",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/19/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Khushboo Hashu Shahdadpuri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_49250a20-c0bf-4367-a51c-63b010b5917d",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-05282",
    "licenseIssueDate": "04/19/2022 00:00:00",
    "licenseExpiryDate": "04/18/2026 00:00:00"
  },
  {
    "id": "4f037ddb-19fc-414d-9748-667b8262aca0",
    "slug": "kieron-martin-mcilmurray",
    "name": "Kieron Martin Mcilmurray",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/28/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Kieron Martin Mcilmurray",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4f037ddb-19fc-414d-9748-667b8262aca0",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-06818",
    "licenseIssueDate": "05/28/2025 00:00:00",
    "licenseExpiryDate": "05/27/2026 00:00:00"
  },
  {
    "id": "02221269-9287-4e16-8da8-4d7ea1862c7d",
    "slug": "kieron-zaman",
    "name": "Kieron Zaman",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLWgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/08/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Kieron Zaman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_02221269-9287-4e16-8da8-4d7ea1862c7d",
        "address": "ICD Brookfield Place ,DIFC ,506516 ,",
        "phone": "97143695800 / 971505526206",
        "email": "scott.campbell@linklaters.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5cec94c0-0649-43b6-a2be-ab17ff422bce",
    "firmName": "LinkLaters LLP",
    "registrationNumber": "L-01143",
    "licenseIssueDate": "10/08/2012 00:00:00",
    "licenseExpiryDate": "09/30/2026 00:00:00"
  },
  {
    "id": "01a9e95b-b376-4378-ba7a-92b4cc9bfb16",
    "slug": "kiersten-amanda-lucas",
    "name": "KIERSTEN AMANDA LUCAS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/30/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: KIERSTEN AMANDA LUCAS",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_01a9e95b-b376-4378-ba7a-92b4cc9bfb16",
        "address": "",
        "phone": "97144073901 / 971503479508",
        "email": "Rania.Tadros@stephensonharwood.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dd5042a2-bb41-4123-9544-79c3fa831332",
    "firmName": "Stephenson Harwood (Middle East) LLP",
    "registrationNumber": "L-03888",
    "licenseIssueDate": "10/30/2017 00:00:00",
    "licenseExpiryDate": "10/27/2025 00:00:00"
  },
  {
    "id": "84c156a0-3867-48a3-9cad-16575cd12e47",
    "slug": "kim-rosenberg",
    "name": "Kim Rosenberg",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/28/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Kim Rosenberg",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_84c156a0-3867-48a3-9cad-16575cd12e47",
        "address": "0 ,ICD Brookfield Place Level 13 ,Trade Centre ,506569 ,Dubai",
        "phone": "97145099100 / 971501006965",
        "email": "menahr@freshfields.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "970f6246-e737-41a7-9c6c-5aa5b8335d45",
    "firmName": "Freshfields LLP DIFC",
    "registrationNumber": "L-03261",
    "licenseIssueDate": "03/28/2023 00:00:00",
    "licenseExpiryDate": "03/27/2026 00:00:00"
  },
  {
    "id": "d50114b8-e8fd-45fd-a917-e20fd40619ed",
    "slug": "kim-victoria-mullins",
    "name": "Kim Victoria Mullins",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLVgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/25/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Kim Victoria Mullins",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d50114b8-e8fd-45fd-a917-e20fd40619ed",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-06506",
    "licenseIssueDate": "09/25/2024 00:00:00",
    "licenseExpiryDate": "09/24/2026 00:00:00"
  },
  {
    "id": "e39425ec-f45c-46ab-a090-c4fbaf6470f6",
    "slug": "kimberly-sze-ting-ng",
    "name": "Kimberly Sze Ting Ng",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/21/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Kimberly Sze Ting Ng",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e39425ec-f45c-46ab-a090-c4fbaf6470f6",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-05512",
    "licenseIssueDate": "09/21/2022 00:00:00",
    "licenseExpiryDate": "09/20/2026 00:00:00"
  },
  {
    "id": "79ffde56-cf5a-41db-879f-70d741d75560",
    "slug": "kinjal-mehta-labroo",
    "name": "Kinjal Mehta Labroo",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/17/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Kinjal Mehta Labroo",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_79ffde56-cf5a-41db-879f-70d741d75560",
        "address": "Building 5 ,Dubai World Trade Centre ,212620 ,",
        "phone": "97143503600 / 971563631562",
        "email": "p.ellingham@kennedys-law.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "83d3ede1-3a28-4b03-8c92-6bd31a1cb95e",
    "firmName": "Kennedys Dubai LLP",
    "registrationNumber": "L-05329",
    "licenseIssueDate": "05/17/2022 00:00:00",
    "licenseExpiryDate": "05/16/2026 00:00:00"
  },
  {
    "id": "808389b2-a153-418e-b40c-68811641bc6c",
    "slug": "kinshuk-kislaya",
    "name": "Kinshuk Kislaya",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/14/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Kinshuk Kislaya",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_808389b2-a153-418e-b40c-68811641bc6c",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-06685",
    "licenseIssueDate": "02/14/2025 00:00:00",
    "licenseExpiryDate": "02/13/2026 00:00:00"
  },
  {
    "id": "0c79e0aa-7a09-4d7b-a7d5-1d9faa7f8c54",
    "slug": "kirsten-oconnell",
    "name": "Kirsten O'Connell",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/30/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Kirsten O'Connell",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0c79e0aa-7a09-4d7b-a7d5-1d9faa7f8c54",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-01472",
    "licenseIssueDate": "12/30/2012 00:00:00",
    "licenseExpiryDate": "12/22/2025 00:00:00"
  },
  {
    "id": "c193991c-ada7-4c18-b400-81dc6aa96663",
    "slug": "kislay-kumar-rakesh-kumar",
    "name": "Kislay Kumar Rakesh Kumar",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/24/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Kislay Kumar Rakesh Kumar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c193991c-ada7-4c18-b400-81dc6aa96663",
        "address": "",
        "phone": "97144020800 / 971566830829",
        "email": "dean.ryburn@dentons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dfe13b7e-6625-45fd-ad63-9ee83af41194",
    "firmName": "Dentons & Co Dubai Branch-DED",
    "registrationNumber": "L-06423",
    "licenseIssueDate": "07/24/2024 00:00:00",
    "licenseExpiryDate": "07/23/2026 00:00:00"
  },
  {
    "id": "5f23219c-3e6f-4ba5-a96c-5ce9ed931846",
    "slug": "konstantin-levin",
    "name": "Konstantin Levin",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/23/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Konstantin Levin",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5f23219c-3e6f-4ba5-a96c-5ce9ed931846",
        "address": "HASSAN ALI MATAR ALRIYAMI ,24 ,GRASVENOR BUSINESS TOWER ,NEEDS SUPERMARKET ,215880 ,Dubai",
        "phone": "97144534188",
        "email": "courts@alriyamiadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a40a2f1f-69a9-429c-8086-dba9d985532b",
    "firmName": "HASAN ALRAYYAMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05016",
    "licenseIssueDate": "08/23/2021 00:00:00",
    "licenseExpiryDate": "08/22/2026 00:00:00"
  },
  {
    "id": "23c0268d-9939-48e2-a7d8-528b4b2bb9b1",
    "slug": "konstantinos-drousiotis",
    "name": "Konstantinos Drousiotis",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/31/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Konstantinos Drousiotis",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_23c0268d-9939-48e2-a7d8-528b4b2bb9b1",
        "address": "One Central, The Offices 5 ,Dubai World Trade Centre ,554660 ,",
        "phone": "97142052030 / 971506566494",
        "email": "chourani@houranipartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "59a73632-40a0-4849-b120-4308dc6f8015",
    "firmName": "Hourani & Partners Legal Consultancy FZCO",
    "registrationNumber": "L-06352",
    "licenseIssueDate": "05/31/2024 00:00:00",
    "licenseExpiryDate": "05/30/2026 00:00:00"
  },
  {
    "id": "77fa9517-2778-406f-97e0-90655e2c896b",
    "slug": "krati-jain-rajesh-jain",
    "name": "Krati Jain Rajesh Jain",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/18/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Krati Jain Rajesh Jain",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_77fa9517-2778-406f-97e0-90655e2c896b",
        "address": "",
        "phone": "97143098000 / 971552210883",
        "email": "belturk@rouse.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9df4d4e5-5243-4fae-8d95-463d110ce6a8",
    "firmName": "Rouse & Co International Limited (Dubai Branch)",
    "registrationNumber": "L-06931",
    "licenseIssueDate": "08/18/2025 00:00:00",
    "licenseExpiryDate": "08/17/2026 00:00:00"
  },
  {
    "id": "a7e36171-47af-4e9c-ab0a-8e06f6920838",
    "slug": "krishen-patel",
    "name": "Krishen Patel",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/15/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Krishen Patel",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a7e36171-47af-4e9c-ab0a-8e06f6920838",
        "address": "",
        "phone": "97145953601 / 971508728645",
        "email": "Steven.Bainbridge@gtlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b4146aa6-efd1-41d7-819d-49da46353b0b",
    "firmName": "Greenberg Traurig Limited",
    "registrationNumber": "L-05089",
    "licenseIssueDate": "11/15/2021 00:00:00",
    "licenseExpiryDate": "11/14/2025 00:00:00"
  },
  {
    "id": "74a0878d-4172-43ac-a2bb-c4cea5eacbac",
    "slug": "krishna-kartik-parikh",
    "name": "Krishna Kartik Parikh",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/25/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Krishna Kartik Parikh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_74a0878d-4172-43ac-a2bb-c4cea5eacbac",
        "address": "",
        "phone": "97143184600 / 971504468184",
        "email": "melaraby@gibsondunn.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c9d2c9d0-6e43-4253-a75d-cdeb400f8d8e",
    "firmName": "Gibson Dunn & Crutcher LLP",
    "registrationNumber": "L-05080",
    "licenseIssueDate": "10/25/2021 00:00:00",
    "licenseExpiryDate": "10/24/2026 00:00:00"
  },
  {
    "id": "5e8035a0-8262-4d84-9b97-f36095b95aeb",
    "slug": "kritika-mohan",
    "name": "Kritika Mohan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/16/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Kritika Mohan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5e8035a0-8262-4d84-9b97-f36095b95aeb",
        "address": "Index Tower ,506548 ,Dubai",
        "phone": "97147096300 / 971506767433",
        "email": "amateen@reedsmith.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b3f87e90-7ce9-4097-82c4-15232365f175",
    "firmName": "Reed Smith LLP",
    "registrationNumber": "L-06866",
    "licenseIssueDate": "06/16/2025 00:00:00",
    "licenseExpiryDate": "06/15/2026 00:00:00"
  },
  {
    "id": "15f20094-823f-47b3-9b8a-16e2521d1151",
    "slug": "krystle-koh-shao-phing",
    "name": "Krystle Koh Shao Phing",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/25/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Krystle Koh Shao Phing",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_15f20094-823f-47b3-9b8a-16e2521d1151",
        "address": "",
        "phone": "97143826100 / 971507380618",
        "email": "jmiocevic@curtis.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0867bcc5-10fa-4783-91ae-b8f63e02e81a",
    "firmName": "Curtis Mallet-Prevost, Colt & Mosle LLP",
    "registrationNumber": "L-06512",
    "licenseIssueDate": "09/25/2024 00:00:00",
    "licenseExpiryDate": "09/24/2026 00:00:00"
  },
  {
    "id": "82c5a58e-3b00-44bd-a223-6f0fc9ba732f",
    "slug": "krystyna-nechaieva",
    "name": "KRYSTYNA NECHAIEVA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/08/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2021-08-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Krystyna Nechaieva",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_82c5a58e-3b00-44bd-a223-6f0fc9ba732f",
        "address": "1007 ,برج لطيفة ,بجوار فندق كراون بلازل ,94873 ,Abu Dhabi",
        "phone": "97142951555 / 971567573911",
        "email": "info@mbhadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d3e210f-8234-4e00-b9e6-1167758a43ee",
    "firmName": "MOHAMMED BANI HASHEM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03464",
    "licenseIssueDate": "08/24/2016 00:00:00",
    "licenseExpiryDate": "08/20/2021 00:00:00"
  },
  {
    "id": "8ba6c420-b8b0-48f5-a4f3-db6d789774e0",
    "slug": "ksenia-andreeva",
    "name": "Ksenia Andreeva",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/08/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ksenia Andreeva",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8ba6c420-b8b0-48f5-a4f3-db6d789774e0",
        "address": "",
        "phone": "97143121800 / 971566017967",
        "email": "alishia.sullivan@morganlewis.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6eab20d7-8716-4b0a-8710-144d1d951c23",
    "firmName": "Morgan, Lewis & Bockius LLP (dubai Branch)",
    "registrationNumber": "L-05356",
    "licenseIssueDate": "06/08/2022 00:00:00",
    "licenseExpiryDate": "06/07/2026 00:00:00"
  },
  {
    "id": "988581df-1d49-49d8-9312-e3055b690c24",
    "slug": "ksenia-koroleva",
    "name": "Ksenia Koroleva",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/22/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ksenia Koroleva",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_988581df-1d49-49d8-9312-e3055b690c24",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506698 ,Dubai",
        "phone": "97147046300 / 971507900661",
        "email": "nada.mourad@lw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b2b92ce9-90a4-4e34-ae2f-ae0dc7ca9060",
    "firmName": "Latham & Watkins LLP",
    "registrationNumber": "L-05384",
    "licenseIssueDate": "06/22/2022 00:00:00",
    "licenseExpiryDate": "06/21/2026 00:00:00"
  },
  {
    "id": "94d42310-8288-4732-ab0f-1e31ee28f182",
    "slug": "kushagra-arora",
    "name": "Kushagra Arora",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/12/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Kushagra Arora",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_94d42310-8288-4732-ab0f-1e31ee28f182",
        "address": "",
        "phone": "97142659440",
        "email": "info@klaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d42ce31f-e881-40e1-bd66-bf2e5bb9bb1e",
    "firmName": "KHALED ALMARRI & PARTNERS& LEGAL CONSULTATIONS",
    "registrationNumber": "L-02050",
    "licenseIssueDate": "08/12/2013 00:00:00",
    "licenseExpiryDate": "08/05/2026 00:00:00"
  },
  {
    "id": "213632f0-0659-442e-9aab-6e78e28d141d",
    "slug": "kwan-lung-wong",
    "name": "Kwan Lung Wong",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/03/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Kwan Lung Wong",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_213632f0-0659-442e-9aab-6e78e28d141d",
        "address": "South Tower, Emirates Financial Towers ,DIFC ,482025 ,",
        "phone": "97145875333 / 971503444388",
        "email": "c.dersahakian@cvml.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e2c6db70-04e7-4c7b-882a-6d2ffe4469ed",
    "firmName": "CVML Limited",
    "registrationNumber": "L-06938",
    "licenseIssueDate": "08/20/2025 00:00:00",
    "licenseExpiryDate": "08/19/2026 00:00:00"
  },
  {
    "id": "886f2af1-9218-493c-b064-20267058887d",
    "slug": "kyle-nevin",
    "name": "Kyle Nevin",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/05/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Kyle Nevin",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_886f2af1-9218-493c-b064-20267058887d",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-02618",
    "licenseIssueDate": "02/05/2014 00:00:00",
    "licenseExpiryDate": "01/29/2026 00:00:00"
  },
  {
    "id": "18b320e0-adb2-4610-b6e6-be699f8b465b",
    "slug": "lakshmi-omanakuttan-leela-omanakuttan-pillai-gopala",
    "name": "Lakshmi Omanakuttan Leela Omanakuttan Pillai Gopala",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/10/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Lakshmi Omanakuttan Leela Omanakuttan Pillai Gopala",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_18b320e0-adb2-4610-b6e6-be699f8b465b",
        "address": "23 ,Rolex Tower ,Trade Center Second ,116637 ,Dubai",
        "phone": "97144357577 / 971502101003",
        "email": "jasamin.fichte@fichtelegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "77bf4fd2-1cd1-4bda-a0c2-ffcac3980b76",
    "firmName": "Fichte & Co Legal Consultancy",
    "registrationNumber": "L-06955",
    "licenseIssueDate": "09/02/2025 00:00:00",
    "licenseExpiryDate": "09/01/2026 00:00:00"
  },
  {
    "id": "59f752c8-4aa3-4e5a-a960-5685a5cfdd3a",
    "slug": "lama-al-khouli",
    "name": "Lama Al Khouli",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/08/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Lama Al Khouli",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_59f752c8-4aa3-4e5a-a960-5685a5cfdd3a",
        "address": "",
        "phone": "97143368833",
        "email": "alkhouli@alkhoulilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0188c41d-cec9-4993-8610-23001bfcf8a7",
    "firmName": "MAAMOUN AL KHOULI & ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01911",
    "licenseIssueDate": "02/08/2017 00:00:00",
    "licenseExpiryDate": "02/04/2026 00:00:00"
  },
  {
    "id": "ee1d0161-5d9c-4f3e-8868-2da809f42852",
    "slug": "lama-anwar-abou-ali",
    "name": "Lama Anwar Abou Ali",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/05/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Lama Anwar Abou Ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ee1d0161-5d9c-4f3e-8868-2da809f42852",
        "address": "",
        "phone": "97100000000 / 971529999965",
        "email": "beljeaan@meysan.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "18d46314-9f85-4421-9ec3-09c58c01fb76",
    "firmName": "Meysan Lawyers and Legal Consultants WLL",
    "registrationNumber": "L-06709",
    "licenseIssueDate": "03/05/2025 00:00:00",
    "licenseExpiryDate": "03/04/2026 00:00:00"
  },
  {
    "id": "b87fc8aa-43dd-456e-8981-957e7a760b7e",
    "slug": "lama-fouad-chehade",
    "name": "Lama Fouad Chehade",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/23/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Lama Fouad Chehade",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b87fc8aa-43dd-456e-8981-957e7a760b7e",
        "address": "1 ,Emaar Square 5 ,sheikh mohammed bin rashid BVD ,11987 ,Dubai",
        "phone": "97143043100 / 971507325154",
        "email": "amir.kordvani@pwc.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ea026b18-c93c-4f67-a1f2-4546320f8f3e",
    "firmName": "PWC Legal Middle East LLP",
    "registrationNumber": "L-06747",
    "licenseIssueDate": "04/23/2025 00:00:00",
    "licenseExpiryDate": "04/22/2026 00:00:00"
  },
  {
    "id": "c3b4ddcd-8927-4815-ac38-c518d0d6c6e0",
    "slug": "lama-m-reda-al-khashi",
    "name": "Lama M Reda Al Khashi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/21/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Lama M Reda Al Khashi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c3b4ddcd-8927-4815-ac38-c518d0d6c6e0",
        "address": "1 ,Emaar Square 5 ,sheikh mohammed bin rashid BVD ,11987 ,Dubai",
        "phone": "97143043100 / 971507325154",
        "email": "amir.kordvani@pwc.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ea026b18-c93c-4f67-a1f2-4546320f8f3e",
    "firmName": "PWC Legal Middle East LLP",
    "registrationNumber": "L-06903",
    "licenseIssueDate": "07/21/2025 00:00:00",
    "licenseExpiryDate": "07/20/2026 00:00:00"
  },
  {
    "id": "75d1ee7c-6163-4b03-90d3-aac61a5183e7",
    "slug": "lames-alexandra-alleehti",
    "name": "Lames Alexandra Alleehti",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/11/2023",
    "licenseStatus": "active",
    "licenseExpiry": "2024-11-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Lames Alexandra Alleehti",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_75d1ee7c-6163-4b03-90d3-aac61a5183e7",
        "address": "",
        "phone": "97142775444 / 971507886668",
        "email": "info@abdlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ad6c697f-ac72-4c32-a757-7cd13a6fcd3f",
    "firmName": "ABDULLA ALOBEIDLI ADVOCATES &LEGAL CONSULTANTS",
    "registrationNumber": "L-06108",
    "licenseIssueDate": "11/29/2023 00:00:00",
    "licenseExpiryDate": "11/28/2025 00:00:00"
  },
  {
    "id": "a7273aa3-81f6-4b45-a99b-1979d3f927be",
    "slug": "lamia-lorraine-al-lamki",
    "name": "Lamia Lorraine Al-Lamki",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/26/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Lamia Lorraine Al-Lamki",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a7273aa3-81f6-4b45-a99b-1979d3f927be",
        "address": "",
        "phone": "97144020800 / 971566830829",
        "email": "dean.ryburn@dentons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dfe13b7e-6625-45fd-ad63-9ee83af41194",
    "firmName": "Dentons & Co Dubai Branch-DED",
    "registrationNumber": "L-05908",
    "licenseIssueDate": "07/26/2023 00:00:00",
    "licenseExpiryDate": "07/25/2026 00:00:00"
  },
  {
    "id": "d8d49fac-72b4-47ce-b5dc-5388cfbf5640",
    "slug": "lana-abdelwahab-mohamed-yassin-elakkad",
    "name": "Lana Abdelwahab Mohamed Yassin Elakkad",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/22/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Lana Abdelwahab Mohamed Yassin Elakkad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d8d49fac-72b4-47ce-b5dc-5388cfbf5640",
        "address": "THE OFFICES 1 ,DWTC ,115580 ,",
        "phone": "97143739700 / 971501148248",
        "email": "nitesh.pradhan@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "361fdc64-6b6f-4f37-abca-c52af8473b84",
    "firmName": "Pinsent Masons  LLP (DWTCA Branch)",
    "registrationNumber": "L-06295",
    "licenseIssueDate": "05/22/2024 00:00:00",
    "licenseExpiryDate": "05/21/2026 00:00:00"
  },
  {
    "id": "9235815a-cc7d-4afe-8e6d-baa7a7619369",
    "slug": "lara-barbary",
    "name": "Lara Barbary",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Lara Barbary",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9235815a-cc7d-4afe-8e6d-baa7a7619369",
        "address": "",
        "phone": "97143685555",
        "email": "maisa.maarouf@bsabh.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8afa232f-52ff-4dad-82c3-9a04d66eb853",
    "firmName": "B S A AHMED BIN HAZEEM & ASSOCIATES LLP - DIFC",
    "registrationNumber": "L-01632",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "c48242fe-1be4-4afa-b548-2f6316137406",
    "slug": "lara-elmani",
    "name": "Lara Elmani",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/11/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Lara Elmani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c48242fe-1be4-4afa-b548-2f6316137406",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-06861",
    "licenseIssueDate": "06/11/2025 00:00:00",
    "licenseExpiryDate": "06/10/2026 00:00:00"
  },
  {
    "id": "a5ac8214-4fa5-4bcf-ae1c-770c9a120b84",
    "slug": "lara-imad-dajani",
    "name": "Lara Imad Dajani",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/03/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Lara Imad Dajani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a5ac8214-4fa5-4bcf-ae1c-770c9a120b84",
        "address": "0 ,ICD Brookfield Place Level 13 ,Trade Centre ,506569 ,Dubai",
        "phone": "97145099100 / 971501006965",
        "email": "menahr@freshfields.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "970f6246-e737-41a7-9c6c-5aa5b8335d45",
    "firmName": "Freshfields LLP DIFC",
    "registrationNumber": "L-05464",
    "licenseIssueDate": "08/03/2022 00:00:00",
    "licenseExpiryDate": "08/02/2026 00:00:00"
  },
  {
    "id": "82f11e2a-c7b3-4bfa-9d96-8526c44b0035",
    "slug": "laura-chele",
    "name": "Laura Chele",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/14/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Laura Chele",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_82f11e2a-c7b3-4bfa-9d96-8526c44b0035",
        "address": "",
        "phone": "97144230555 / 971504788443",
        "email": "yah@hfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c462c65e-185a-4e81-8425-a87e3a2b6842",
    "firmName": "Holman Fenwick Willan Middle East LLP",
    "registrationNumber": "L-05639",
    "licenseIssueDate": "12/14/2022 00:00:00",
    "licenseExpiryDate": "12/13/2025 00:00:00"
  },
  {
    "id": "eb90c967-7cfe-4636-9ce9-696f325aa901",
    "slug": "laura-eve-lonsdale",
    "name": "Laura Eve Lonsdale",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/25/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Laura Eve Lonsdale",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_eb90c967-7cfe-4636-9ce9-696f325aa901",
        "address": "ICD Brookfield Place ,Za'abeel 2 ,103747 ,",
        "phone": "97143696300 / 971506008159",
        "email": "mohammed.paracha@nortonrosefulbright.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c4aaee93-0ec4-4982-9a48-a23699492056",
    "firmName": "Norton Rose Fullbright (Middle East) LLP",
    "registrationNumber": "L-06966",
    "licenseIssueDate": "09/25/2025 00:00:00",
    "licenseExpiryDate": "09/24/2026 00:00:00"
  },
  {
    "id": "7d6a7db5-cfde-4c84-a3c8-324e042a72a4",
    "slug": "laura-michelle-sperling",
    "name": "Laura Michelle Sperling",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/07/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Laura Michelle Sperling",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7d6a7db5-cfde-4c84-a3c8-324e042a72a4",
        "address": "",
        "phone": "97104309100 / 971564013758",
        "email": "c.royle@taylorwessing.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d51b6f43-8c62-486f-a1ab-6ee3b87c8006",
    "firmName": "Taylor Wessing LLP (Dubai Branch)",
    "registrationNumber": "L-06138",
    "licenseIssueDate": "12/07/2023 00:00:00",
    "licenseExpiryDate": "12/06/2025 00:00:00"
  },
  {
    "id": "a1e8510d-61eb-49f3-b7e6-28785deb6cfb",
    "slug": "laura-olivia-mcguckin",
    "name": "Laura Olivia McGuckin",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/17/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Laura Olivia McGuckin",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a1e8510d-61eb-49f3-b7e6-28785deb6cfb",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-06275",
    "licenseIssueDate": "04/17/2024 00:00:00",
    "licenseExpiryDate": "04/16/2026 00:00:00"
  },
  {
    "id": "df3dbf2d-2eaf-4422-898c-949b763ab089",
    "slug": "laura-shingler",
    "name": "Laura Shingler",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/18/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Laura Shingler",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_df3dbf2d-2eaf-4422-898c-949b763ab089",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-03509",
    "licenseIssueDate": "11/18/2021 00:00:00",
    "licenseExpiryDate": "11/17/2025 00:00:00"
  },
  {
    "id": "acf5ef6b-33de-4098-bd86-fa04ae802905",
    "slug": "laureen-fredah-ampurire",
    "name": "Laureen Fredah Ampurire",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/11/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Laureen Fredah Ampurire",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_acf5ef6b-33de-4098-bd86-fa04ae802905",
        "address": "",
        "phone": "97143937700",
        "email": "info@galadarilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d863b662-c864-4193-8b3a-ff6ee5fe6c64",
    "firmName": "GALADARI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06836",
    "licenseIssueDate": "06/11/2025 00:00:00",
    "licenseExpiryDate": "06/10/2026 00:00:00"
  },
  {
    "id": "d406b01a-88af-45af-b90f-00b848bf582b",
    "slug": "lauren-jayne-banner",
    "name": "Lauren Jayne Banner",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/14/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Lauren Jayne Banner",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d406b01a-88af-45af-b90f-00b848bf582b",
        "address": "Index Tower ,506548 ,Dubai",
        "phone": "97147096300 / 971506767433",
        "email": "amateen@reedsmith.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b3f87e90-7ce9-4097-82c4-15232365f175",
    "firmName": "Reed Smith LLP",
    "registrationNumber": "L-06453",
    "licenseIssueDate": "08/14/2024 00:00:00",
    "licenseExpiryDate": "08/13/2026 00:00:00"
  },
  {
    "id": "a6b8521a-0bab-493a-8313-360d0cf83498",
    "slug": "lauren-sarah-scott",
    "name": "Lauren Sarah Scott",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/23/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Lauren Sarah Scott",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a6b8521a-0bab-493a-8313-360d0cf83498",
        "address": "6 ,Office Nos. 603, 604 & 605, Level 6, Burj Daman ,Dubai International Financial Centre ,506555 ,Dubai",
        "phone": "97143506400 / 971504654755",
        "email": "r.hickman@aglaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8690f7d5-6b96-4649-9589-71303f2c2707",
    "firmName": "Addleshaw Goddard (Middle East) LLP",
    "registrationNumber": "L-04657",
    "licenseIssueDate": "04/23/2020 00:00:00",
    "licenseExpiryDate": "04/22/2026 00:00:00"
  },
  {
    "id": "5fce5000-119d-413c-8e84-ce4966c92109",
    "slug": "lauren-talerman",
    "name": "Lauren Talerman",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/04/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Lauren Talerman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5fce5000-119d-413c-8e84-ce4966c92109",
        "address": "ICD Brookfield Place ,DIFC ,120109 ,",
        "phone": "97143173000 / 971504465229",
        "email": "DubaiLAD@akingump.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9ff29eab-adb8-40f9-ab84-216e01a381e4",
    "firmName": "Akin Gump Strauss Hauer & Feld LLP",
    "registrationNumber": "L-05040",
    "licenseIssueDate": "10/04/2021 00:00:00",
    "licenseExpiryDate": "10/03/2026 00:00:00"
  },
  {
    "id": "b2ceff41-0505-4bd2-8c31-807dece9c0ff",
    "slug": "laya-aoun",
    "name": "Laya Aoun",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/27/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Laya Aoun",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b2ceff41-0505-4bd2-8c31-807dece9c0ff",
        "address": "Al Fattan Currency House Tower 2 ,DIFC ,507176 ,",
        "phone": "/ 971552009003",
        "email": "Mohammad.AlRasheed@bakermckenzie.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "acd81e81-dead-4f7c-839e-0f2a57897265",
    "firmName": "Baker & Mckenzie LLP",
    "registrationNumber": "L-01794",
    "licenseIssueDate": "02/27/2012 00:00:00",
    "licenseExpiryDate": "02/18/2026 00:00:00"
  },
  {
    "id": "efb560b2-c4f9-4e54-bca9-ecd229f911ad",
    "slug": "layla-abed-ahmed-farraji",
    "name": "Layla Abed Ahmed Farraji",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/23/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Layla Abed Ahmed Farraji",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_efb560b2-c4f9-4e54-bca9-ecd229f911ad",
        "address": "Saleh Ahmed Yousif Saleh Alobeidli ,2nd ,DUBAI SUPREME COURT COMPLEX ,Dubai Courts ,333842 ,Dubai",
        "phone": "97143546762",
        "email": "Laila@iclo.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "57836e55-f90c-4fb1-81d0-a735a168b9ac",
    "firmName": "INTERNATIONAL CONSULTANT LAW OFFICE",
    "registrationNumber": "L-02952",
    "licenseIssueDate": "02/23/2015 00:00:00",
    "licenseExpiryDate": "02/17/2026 00:00:00"
  },
  {
    "id": "f1fcd098-dbc9-48ef-9b93-4f9a76286a32",
    "slug": "lazhar-sahbani",
    "name": "Lazhar Sahbani",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/06/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Lazhar Sahbani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f1fcd098-dbc9-48ef-9b93-4f9a76286a32",
        "address": "Central Park Towers ,507120 ,",
        "phone": "97143200940 / 971502397176",
        "email": "lsahbani@lpalaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4c158c98-1a29-48da-ade1-54e60bfd5b78",
    "firmName": "LPA (Middle East) LTD",
    "registrationNumber": "L-06592",
    "licenseIssueDate": "11/01/2024 00:00:00",
    "licenseExpiryDate": "10/31/2025 00:00:00"
  },
  {
    "id": "56989719-f801-4b2e-acb2-c7bd00dfd804",
    "slug": "leah-helaine-evans",
    "name": "Leah Helaine Evans",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/25/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Leah Helaine Evans",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_56989719-f801-4b2e-acb2-c7bd00dfd804",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506688 ,Dubai",
        "phone": "97147096600 / 971503556811",
        "email": "muneer.khan@simmons-simmons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d1725ca7-06ac-41b2-8d7b-a6e60665b73d",
    "firmName": "Simmons & Simmons (Middle East) LLP-DIFC",
    "registrationNumber": "L-06560",
    "licenseIssueDate": "10/17/2024 00:00:00",
    "licenseExpiryDate": "10/16/2025 00:00:00"
  },
  {
    "id": "9d0d8850-a860-4a50-b16b-d86672f8c82f",
    "slug": "leah-katherine-weldon",
    "name": "Leah Katherine Weldon",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/22/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Leah Katherine Weldon",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9d0d8850-a860-4a50-b16b-d86672f8c82f",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506688 ,Dubai",
        "phone": "97147096600 / 971503556811",
        "email": "muneer.khan@simmons-simmons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d1725ca7-06ac-41b2-8d7b-a6e60665b73d",
    "firmName": "Simmons & Simmons (Middle East) LLP-DIFC",
    "registrationNumber": "L-06339",
    "licenseIssueDate": "05/22/2024 00:00:00",
    "licenseExpiryDate": "05/21/2026 00:00:00"
  },
  {
    "id": "c11468d9-9ac9-49bf-94ae-88503c4ccd2d",
    "slug": "lee-irvine",
    "name": "Lee Irvine",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/30/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Lee Irvine",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c11468d9-9ac9-49bf-94ae-88503c4ccd2d",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506688 ,Dubai",
        "phone": "97147096600 / 971503556811",
        "email": "muneer.khan@simmons-simmons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d1725ca7-06ac-41b2-8d7b-a6e60665b73d",
    "firmName": "Simmons & Simmons (Middle East) LLP-DIFC",
    "registrationNumber": "L-00885",
    "licenseIssueDate": "04/30/2012 00:00:00",
    "licenseExpiryDate": "04/21/2026 00:00:00"
  },
  {
    "id": "9489e29f-2f75-4cf3-80dd-4709148ad778",
    "slug": "lee-martin-rogers",
    "name": "Lee Martin Rogers",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/05/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Lee Martin Rogers",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9489e29f-2f75-4cf3-80dd-4709148ad778",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-05879",
    "licenseIssueDate": "07/05/2023 00:00:00",
    "licenseExpiryDate": "07/04/2026 00:00:00"
  },
  {
    "id": "dfcf6dd0-1c6d-474b-9a64-1e6660eb7543",
    "slug": "lee-michael-mcmahon",
    "name": "Lee Michael Mcmahon",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/15/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Lee Michael Mcmahon",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dfcf6dd0-1c6d-474b-9a64-1e6660eb7543",
        "address": "IH-00-01-CP-05 ,DIFC ,506832 ,",
        "phone": "/ 971506957753",
        "email": "admin@supportlegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "1607c199-ca4b-4bc1-89e9-98dad0300645",
    "firmName": "Support Legal ( DIFC) Limited",
    "registrationNumber": "L-05239",
    "licenseIssueDate": "03/15/2022 00:00:00",
    "licenseExpiryDate": "03/14/2026 00:00:00"
  },
  {
    "id": "68e13b59-7cc4-4a0c-8078-da78f9272636",
    "slug": "lee-ranson",
    "name": "Lee Ranson",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/11/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Lee Ranson",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_68e13b59-7cc4-4a0c-8078-da78f9272636",
        "address": "",
        "phone": "97143897000 / 971506553198",
        "email": "nasseralikhasawneh@eversheds-sutherland.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "74a21d43-41d8-480a-a6af-6939b7c98a95",
    "firmName": "Eversheds Sutherland (International LLP) Dubai Branch",
    "registrationNumber": "L-06829",
    "licenseIssueDate": "06/11/2025 00:00:00",
    "licenseExpiryDate": "06/10/2026 00:00:00"
  },
  {
    "id": "d9a7cbab-28a3-4cd7-a0ea-2dc36a36359f",
    "slug": "leen-qablawi",
    "name": "Leen Qablawi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMUQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/05/2025",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Leen Qablawi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d9a7cbab-28a3-4cd7-a0ea-2dc36a36359f",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-06780",
    "licenseIssueDate": "05/14/2025 00:00:00",
    "licenseExpiryDate": "05/13/2026 00:00:00"
  },
  {
    "id": "454c4fda-8a77-4609-b0cc-e50384893fc7",
    "slug": "leila-ahmad-laila",
    "name": "Leila Ahmad Laila",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/07/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Leila Ahmad Laila",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_454c4fda-8a77-4609-b0cc-e50384893fc7",
        "address": "801/802 ,Park Place ,WTC ,384557 ,Dubai",
        "phone": "97143203999",
        "email": "info.dubai@alemlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e3088c8b-a7dc-4f38-a04d-cb4c7d050ed9",
    "firmName": "AHMED MOHAMMED BASHIR ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05268",
    "licenseIssueDate": "04/07/2022 00:00:00",
    "licenseExpiryDate": "04/06/2026 00:00:00"
  },
  {
    "id": "f235b0e5-e73f-4821-be5b-a040e7e50c94",
    "slug": "leila-drissi",
    "name": "Leila Drissi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/08/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Leila Drissi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f235b0e5-e73f-4821-be5b-a040e7e50c94",
        "address": "",
        "phone": "97144478700 / 971528553200",
        "email": "Thomas.Wilson@squirepb.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "85be541a-c87f-45a9-a321-d90abd6b7298",
    "firmName": "Squire Patton Boggs (MEA) LLP",
    "registrationNumber": "L-01001",
    "licenseIssueDate": "09/08/2011 00:00:00",
    "licenseExpiryDate": "08/30/2026 00:00:00"
  },
  {
    "id": "558acf8b-9db3-43d5-bf81-b868c9c36946",
    "slug": "leila-mohamed-mustafa-abu-mustafa",
    "name": "Leila Mohamed Mustafa Abu Mustafa",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/07/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Leila Mohamed Mustafa Abu Mustafa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_558acf8b-9db3-43d5-bf81-b868c9c36946",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-05653",
    "licenseIssueDate": "12/07/2022 00:00:00",
    "licenseExpiryDate": "12/06/2025 00:00:00"
  },
  {
    "id": "c789189a-3e56-46bd-8269-230a79bdaed6",
    "slug": "leith-ismail-gouta",
    "name": "Leith Ismail Gouta",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/18/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Leith Ismail Gouta",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c789189a-3e56-46bd-8269-230a79bdaed6",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-05392",
    "licenseIssueDate": "07/18/2022 00:00:00",
    "licenseExpiryDate": "07/17/2026 00:00:00"
  },
  {
    "id": "5880ea53-765f-4aec-b9f5-bb569bd6e029",
    "slug": "leonard-soudagar",
    "name": "Leonard Soudagar",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/08/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2025-04-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Leonard Soudagar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5880ea53-765f-4aec-b9f5-bb569bd6e029",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-03553",
    "licenseIssueDate": "12/08/2016 00:00:00",
    "licenseExpiryDate": "12/04/2025 00:00:00"
  },
  {
    "id": "877003f9-27ab-4c9b-a9eb-cea19d737ed0",
    "slug": "leonie-sellers",
    "name": "Leonie Sellers",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/01/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Leonie Sellers",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_877003f9-27ab-4c9b-a9eb-cea19d737ed0",
        "address": "Office 1A ,Silver Tower ,DMCC Al Mas Tower ,283149 ,Dubai",
        "phone": "97144542355 / 971564092949",
        "email": "pstone@fenwickelliott.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "45b03212-ac3a-4dbc-8b2d-10fc81273543",
    "firmName": "Fenwick Elliott LLP (DMCC Branch)",
    "registrationNumber": "L-03021",
    "licenseIssueDate": "03/01/2015 00:00:00",
    "licenseExpiryDate": "02/23/2026 00:00:00"
  },
  {
    "id": "a9111671-7b49-4bcd-91ec-bf94389f76e1",
    "slug": "leopold-thanickal-jose",
    "name": "Leopold Thanickal Jose",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/21/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Leopold Thanickal Jose",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a9111671-7b49-4bcd-91ec-bf94389f76e1",
        "address": "",
        "phone": "97143937700",
        "email": "info@galadarilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d863b662-c864-4193-8b3a-ff6ee5fe6c64",
    "firmName": "GALADARI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05602",
    "licenseIssueDate": "10/21/2022 00:00:00",
    "licenseExpiryDate": "10/20/2026 00:00:00"
  },
  {
    "id": "b40e6022-c975-4812-a33c-0b5f8ca450c8",
    "slug": "lev-sergeevich-batalov",
    "name": "Lev Sergeevich Batalov",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/27/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Lev Sergeevich Batalov",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b40e6022-c975-4812-a33c-0b5f8ca450c8",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-05434",
    "licenseIssueDate": "07/27/2022 00:00:00",
    "licenseExpiryDate": "07/26/2026 00:00:00"
  },
  {
    "id": "7a933431-6f21-48a8-95e6-881d43e4356e",
    "slug": "lewis-james-winton-calder",
    "name": "Lewis James Winton Calder",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/07/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Lewis James Winton Calder",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7a933431-6f21-48a8-95e6-881d43e4356e",
        "address": "",
        "phone": "97145953601 / 971508728645",
        "email": "Steven.Bainbridge@gtlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b4146aa6-efd1-41d7-819d-49da46353b0b",
    "firmName": "Greenberg Traurig Limited",
    "registrationNumber": "L-05289",
    "licenseIssueDate": "04/07/2022 00:00:00",
    "licenseExpiryDate": "04/06/2026 00:00:00"
  },
  {
    "id": "3b167853-e4ae-4647-a6b0-08c70c7d69eb",
    "slug": "leyla-alem-ep-hammoud",
    "name": "Leyla Alem Ep Hammoud",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/04/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Leyla Alem Ep Hammoud",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3b167853-e4ae-4647-a6b0-08c70c7d69eb",
        "address": "801/802 ,Park Place ,WTC ,384557 ,Dubai",
        "phone": "97143203999",
        "email": "info.dubai@alemlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e3088c8b-a7dc-4f38-a04d-cb4c7d050ed9",
    "firmName": "AHMED MOHAMMED BASHIR ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05044",
    "licenseIssueDate": "10/04/2021 00:00:00",
    "licenseExpiryDate": "10/03/2026 00:00:00"
  },
  {
    "id": "a49bef89-6311-4f74-9656-9369dd5801da",
    "slug": "li-mi-vun",
    "name": "Li Mi Vun",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Li Mi Vun",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a49bef89-6311-4f74-9656-9369dd5801da",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-00235",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "528c116b-853d-402c-8dfe-5c3452551243",
    "slug": "liam-eric-thomas",
    "name": "Liam Eric Thomas",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/20/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Liam Eric Thomas",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_528c116b-853d-402c-8dfe-5c3452551243",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-06264",
    "licenseIssueDate": "03/20/2024 00:00:00",
    "licenseExpiryDate": "03/19/2026 00:00:00"
  },
  {
    "id": "d6cc4f5e-81b7-415b-9a46-3f6eeb391934",
    "slug": "lilas-alakhras",
    "name": "Lilas Alakhras",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/26/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-01-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Lilas Alakhras",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d6cc4f5e-81b7-415b-9a46-3f6eeb391934",
        "address": "O-4801, O-4901 ,Burj al Salam Office Tower ,H Hotel ,111801 ,Dubai",
        "phone": "97143544444",
        "email": "administration@horizlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4e25fb39-6659-44f0-bc8b-3ff0f067beb0",
    "firmName": "HORIZONS & CO - LAW FIRM",
    "registrationNumber": "L-03437",
    "licenseIssueDate": "01/26/2023 00:00:00",
    "licenseExpiryDate": "01/25/2026 00:00:00"
  },
  {
    "id": "3e91411e-36f8-4b56-922f-c0f64f985c13",
    "slug": "lilas-shadi-nazmi-saeed",
    "name": "Lilas Shadi Nazmi Saeed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/31/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Lilas Shadi Nazmi Saeed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3e91411e-36f8-4b56-922f-c0f64f985c13",
        "address": "",
        "phone": "97144279812 / 971504597319",
        "email": "lyamalova@lylawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dd62d765-3845-4e09-b92b-1ba92c1e27e4",
    "firmName": "HPL Yamalova & Plewka FZCO",
    "registrationNumber": "L-05872",
    "licenseIssueDate": "05/31/2023 00:00:00",
    "licenseExpiryDate": "05/30/2026 00:00:00"
  },
  {
    "id": "fa9f36c7-93e8-493d-a2d1-83a92146792b",
    "slug": "lili-samuels",
    "name": "Lili Samuels",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/14/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Lili Samuels",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fa9f36c7-93e8-493d-a2d1-83a92146792b",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-06678",
    "licenseIssueDate": "02/14/2025 00:00:00",
    "licenseExpiryDate": "02/13/2026 00:00:00"
  },
  {
    "id": "87c9922e-a1d4-4302-b4f3-537264eab429",
    "slug": "lily-covic",
    "name": "Lily Covic",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/21/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Lily Covic",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_87c9922e-a1d4-4302-b4f3-537264eab429",
        "address": "",
        "phone": "97143025100 / 971501501837",
        "email": "ccairns@trowers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "976857f5-9092-43cf-987d-bfa794a3fa51",
    "firmName": "Trowers & Hamlins LLP",
    "registrationNumber": "L-05507",
    "licenseIssueDate": "09/21/2022 00:00:00",
    "licenseExpiryDate": "09/20/2026 00:00:00"
  },
  {
    "id": "054d62db-7f5c-49ff-94d8-2eecc0fcf9e8",
    "slug": "lily-iris-hurley",
    "name": "Lily Iris Hurley",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/03/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Lily Iris Hurley",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_054d62db-7f5c-49ff-94d8-2eecc0fcf9e8",
        "address": "",
        "phone": "97144073901 / 971503479508",
        "email": "Rania.Tadros@stephensonharwood.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dd5042a2-bb41-4123-9544-79c3fa831332",
    "firmName": "Stephenson Harwood (Middle East) LLP",
    "registrationNumber": "L-05560",
    "licenseIssueDate": "10/03/2022 00:00:00",
    "licenseExpiryDate": "10/02/2026 00:00:00"
  },
  {
    "id": "0460d298-6f01-4a55-affc-c8eceea85b91",
    "slug": "lina-alnashwati",
    "name": "Lina Alnashwati",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/06/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Lina Alnashwati",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0460d298-6f01-4a55-affc-c8eceea85b91",
        "address": "بلوك بي  ,R338 ,بجانب بناية سيتي بنك - بجوار مركز وافي  ,0554060326 ,Dubai",
        "phone": "97143337444",
        "email": "info@alsuwaidi-advo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "525230a9-87e0-4951-b745-c8d2a983cf8e",
    "firmName": "ABDULLA AL SUWAIDI ADVOCATES & LEGAL CONSULTANT",
    "registrationNumber": "L-03219",
    "licenseIssueDate": "09/06/2015 00:00:00",
    "licenseExpiryDate": "09/01/2026 00:00:00"
  },
  {
    "id": "fc23fc76-9823-4fe5-87c0-a45b0a8189b1",
    "slug": "lina-anatoliy-andreeva",
    "name": "Lina Anatoliy Andreeva",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/12/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Lina Anatoliy Andreeva",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fc23fc76-9823-4fe5-87c0-a45b0a8189b1",
        "address": "Bayswater Bay Tower ,Business Bay ,38252 ,",
        "phone": "97143246444 / 971506244364",
        "email": "6244364@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "42192f9f-9b0f-46c8-82ea-5b01bfbb71e6",
    "firmName": "Andreeva Legal Consultancy LLC",
    "registrationNumber": "L-03049",
    "licenseIssueDate": "08/12/2024 00:00:00",
    "licenseExpiryDate": "08/11/2026 00:00:00"
  },
  {
    "id": "5484d2c6-76e9-4fcf-ae60-682af3271a0f",
    "slug": "linda-el-halabi",
    "name": "Linda El- Halabi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/26/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Linda El- Halabi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5484d2c6-76e9-4fcf-ae60-682af3271a0f",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-05161",
    "licenseIssueDate": "01/26/2022 00:00:00",
    "licenseExpiryDate": "01/25/2026 00:00:00"
  },
  {
    "id": "088773e6-154d-4915-ac56-5b4cc397d704",
    "slug": "lindsay-anastasios-crawford",
    "name": "Lindsay Anastasios Crawford",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/14/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Lindsay Anastasios Crawford",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_088773e6-154d-4915-ac56-5b4cc397d704",
        "address": "",
        "phone": "97145953601 / 971508728645",
        "email": "Steven.Bainbridge@gtlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b4146aa6-efd1-41d7-819d-49da46353b0b",
    "firmName": "Greenberg Traurig Limited",
    "registrationNumber": "L-04681",
    "licenseIssueDate": "05/14/2020 00:00:00",
    "licenseExpiryDate": "05/12/2026 00:00:00"
  },
  {
    "id": "82ab8d42-3739-4c0e-b983-96c59e41ef1c",
    "slug": "lingduo-jiang",
    "name": "LINGDUO JIANG",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/23/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: LINGDUO JIANG",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_82ab8d42-3739-4c0e-b983-96c59e41ef1c",
        "address": "ICD Brookfield Place ,DIFC ,506516 ,",
        "phone": "97143695800 / 971505526206",
        "email": "scott.campbell@linklaters.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5cec94c0-0649-43b6-a2be-ab17ff422bce",
    "firmName": "LinkLaters LLP",
    "registrationNumber": "L-06757",
    "licenseIssueDate": "04/23/2025 00:00:00",
    "licenseExpiryDate": "04/22/2026 00:00:00"
  },
  {
    "id": "4792f758-53c6-4486-982e-b725a2ad7533",
    "slug": "lionel-assis-sequeira-philip-alex-sequeira",
    "name": "LIONEL ASSIS SEQUEIRA PHILIP ALEX SEQUEIRA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/25/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: LIONEL ASSIS SEQUEIRA PHILIP ALEX SEQUEIRA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4792f758-53c6-4486-982e-b725a2ad7533",
        "address": "10th Floor ,AlReem Tower ,Dubai Land Department ,32367 ,Dubai",
        "phone": "97142272701",
        "email": "midfaadv@eim.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "fe9068a7-b94d-49bb-88b3-6f8491a15389",
    "firmName": "AL MIDFA & ASSOCIATES",
    "registrationNumber": "L-06514",
    "licenseIssueDate": "09/25/2024 00:00:00",
    "licenseExpiryDate": "09/24/2026 00:00:00"
  },
  {
    "id": "f68f1896-8bf6-4751-aafe-65f426c21aad",
    "slug": "lisa-marie-merod",
    "name": "Lisa Marie Merod",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/17/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Lisa Marie Merod",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f68f1896-8bf6-4751-aafe-65f426c21aad",
        "address": "",
        "phone": "97143121800 / 971566017967",
        "email": "alishia.sullivan@morganlewis.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6eab20d7-8716-4b0a-8710-144d1d951c23",
    "firmName": "Morgan, Lewis & Bockius LLP (dubai Branch)",
    "registrationNumber": "L-04176",
    "licenseIssueDate": "07/17/2018 00:00:00",
    "licenseExpiryDate": "07/15/2026 00:00:00"
  },
  {
    "id": "a611810a-5fa3-4fa8-90e8-60d2f5944805",
    "slug": "lisa-michelle-carey",
    "name": "Lisa Michelle Carey",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/22/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Lisa Michelle Carey",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a611810a-5fa3-4fa8-90e8-60d2f5944805",
        "address": "",
        "phone": "97143897000 / 971506553198",
        "email": "nasseralikhasawneh@eversheds-sutherland.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "74a21d43-41d8-480a-a6af-6939b7c98a95",
    "firmName": "Eversheds Sutherland (International LLP) Dubai Branch",
    "registrationNumber": "L-05669",
    "licenseIssueDate": "03/22/2023 00:00:00",
    "licenseExpiryDate": "03/21/2026 00:00:00"
  },
  {
    "id": "461eeef5-ae48-46ea-ac4b-8c92cf7a6308",
    "slug": "liva-orleane",
    "name": "Liva Orleane",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/03/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Liva Orleane",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_461eeef5-ae48-46ea-ac4b-8c92cf7a6308",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-04919",
    "licenseIssueDate": "06/03/2024 00:00:00",
    "licenseExpiryDate": "06/02/2026 00:00:00"
  },
  {
    "id": "1497732b-2302-431e-8c56-a3859617a74e",
    "slug": "liyana-haikal-nezar-al-mifleh",
    "name": "Liyana Haikal Nezar Al Mifleh",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/08/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Liyana Haikal Nezar Al Mifleh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1497732b-2302-431e-8c56-a3859617a74e",
        "address": "0 ,ICD Brookfield Place Level 13 ,Trade Centre ,506569 ,Dubai",
        "phone": "97145099100 / 971501006965",
        "email": "menahr@freshfields.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "970f6246-e737-41a7-9c6c-5aa5b8335d45",
    "firmName": "Freshfields LLP DIFC",
    "registrationNumber": "L-04684",
    "licenseIssueDate": "09/08/2025 00:00:00",
    "licenseExpiryDate": "09/07/2026 00:00:00"
  },
  {
    "id": "1c5d4ac3-61f5-4646-8c1d-7a9383e041b0",
    "slug": "lois-mikaela-pickering",
    "name": "LOIS MIKAELA PICKERING",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/13/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: LOIS MIKAELA PICKERING",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1c5d4ac3-61f5-4646-8c1d-7a9383e041b0",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506698 ,Dubai",
        "phone": "97147046300 / 971507900661",
        "email": "nada.mourad@lw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b2b92ce9-90a4-4e34-ae2f-ae0dc7ca9060",
    "firmName": "Latham & Watkins LLP",
    "registrationNumber": "L-04288",
    "licenseIssueDate": "03/13/2024 00:00:00",
    "licenseExpiryDate": "03/12/2026 00:00:00"
  },
  {
    "id": "baf5d64b-e910-4e40-9f27-08ccc7260064",
    "slug": "lorna-jade-dean",
    "name": "Lorna Jade Dean",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/22/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Lorna Jade Dean",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_baf5d64b-e910-4e40-9f27-08ccc7260064",
        "address": "6 ,Office Nos. 603, 604 & 605, Level 6, Burj Daman ,Dubai International Financial Centre ,506555 ,Dubai",
        "phone": "97143506400 / 971504654755",
        "email": "r.hickman@aglaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8690f7d5-6b96-4649-9589-71303f2c2707",
    "firmName": "Addleshaw Goddard (Middle East) LLP",
    "registrationNumber": "L-06076",
    "licenseIssueDate": "11/22/2023 00:00:00",
    "licenseExpiryDate": "11/21/2025 00:00:00"
  },
  {
    "id": "18c4290e-fb90-47df-bb1c-d689db860eae",
    "slug": "louie-anton-gough",
    "name": "Louie Anton Gough",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/16/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Louie Anton Gough",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_18c4290e-fb90-47df-bb1c-d689db860eae",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-05598",
    "licenseIssueDate": "11/16/2022 00:00:00",
    "licenseExpiryDate": "11/15/2025 00:00:00"
  },
  {
    "id": "cd488112-146b-45b5-9c6d-fecea39d8860",
    "slug": "louisa-lynch",
    "name": "Louisa Lynch",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/10/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Louisa Lynch",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cd488112-146b-45b5-9c6d-fecea39d8860",
        "address": "",
        "phone": "97145953601 / 971508728645",
        "email": "Steven.Bainbridge@gtlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b4146aa6-efd1-41d7-819d-49da46353b0b",
    "firmName": "Greenberg Traurig Limited",
    "registrationNumber": "L-00502",
    "licenseIssueDate": "06/10/2012 00:00:00",
    "licenseExpiryDate": "06/03/2026 00:00:00"
  },
  {
    "id": "4d2ac907-5e63-486c-a62e-13d33ae84e20",
    "slug": "louise-anne-elizabeth-denman",
    "name": "Louise Anne Elizabeth Denman",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/06/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Louise Anne Elizabeth Denman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4d2ac907-5e63-486c-a62e-13d33ae84e20",
        "address": "",
        "phone": "97143637999 / 971506525633",
        "email": "daniel.wood@walkersglobal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a3a9927b-d51c-490c-8be6-d575ea3eb041",
    "firmName": "Walkers (Middle East) LLP",
    "registrationNumber": "L-05982",
    "licenseIssueDate": "09/06/2023 00:00:00",
    "licenseExpiryDate": "09/05/2026 00:00:00"
  },
  {
    "id": "5642fbe8-8ed6-45bc-829b-65843d1d35a5",
    "slug": "louise-gunn",
    "name": "Louise Gunn",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/11/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Louise Gunn",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5642fbe8-8ed6-45bc-829b-65843d1d35a5",
        "address": "",
        "phone": "97143742800 / 971506450677",
        "email": "jabbott21@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7a59d310-ff72-4318-b41c-27095c163d0f",
    "firmName": "CMS (UAE) LLP",
    "registrationNumber": "L-06579",
    "licenseIssueDate": "12/11/2024 00:00:00",
    "licenseExpiryDate": "12/10/2025 00:00:00"
  },
  {
    "id": "70d95a18-8c5b-4295-ab62-3ad46969fde9",
    "slug": "louise-manuseta-willneff",
    "name": "Louise Manuseta Willneff",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/05/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Louise Manuseta Willneff",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_70d95a18-8c5b-4295-ab62-3ad46969fde9",
        "address": "",
        "phone": "97144478700 / 971528553200",
        "email": "Thomas.Wilson@squirepb.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "85be541a-c87f-45a9-a321-d90abd6b7298",
    "firmName": "Squire Patton Boggs (MEA) LLP",
    "registrationNumber": "L-04795",
    "licenseIssueDate": "07/05/2023 00:00:00",
    "licenseExpiryDate": "07/04/2026 00:00:00"
  },
  {
    "id": "4416ac11-1e8a-490d-a38d-d70fa87f7eff",
    "slug": "lowna-mohamed-sajid",
    "name": "Lowna Mohamed Sajid",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Lowna Mohamed Sajid",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4416ac11-1e8a-490d-a38d-d70fa87f7eff",
        "address": "samer tohme ,4th- office 433 ,Emarat Atrium ,Dubai Canal ,79436 ,Dubai",
        "phone": "97126722500",
        "email": "info@dxblawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "00b6334f-44e7-458e-8ce5-7d4256840067",
    "firmName": "MOHAMED ABDULLA LAWYERS AND LEGAL CONSULTANTS",
    "registrationNumber": "L-01478",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "324bd30f-8a68-42e4-99ce-95d188b0f6fb",
    "slug": "lowri-llwyd",
    "name": "Lowri Llwyd",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/02/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Lowri Llwyd",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_324bd30f-8a68-42e4-99ce-95d188b0f6fb",
        "address": "6 ,Office Nos. 603, 604 & 605, Level 6, Burj Daman ,Dubai International Financial Centre ,506555 ,Dubai",
        "phone": "97143506400 / 971504654755",
        "email": "r.hickman@aglaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8690f7d5-6b96-4649-9589-71303f2c2707",
    "firmName": "Addleshaw Goddard (Middle East) LLP",
    "registrationNumber": "L-00954",
    "licenseIssueDate": "02/02/2012 00:00:00",
    "licenseExpiryDate": "01/24/2026 00:00:00"
  },
  {
    "id": "afcd8d3c-e649-4094-8bf3-2c102b8b24be",
    "slug": "lucas-pitts",
    "name": "Lucas Pitts",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/28/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Lucas Pitts",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_afcd8d3c-e649-4094-8bf3-2c102b8b24be",
        "address": "6 ,Office Nos. 603, 604 & 605, Level 6, Burj Daman ,Dubai International Financial Centre ,506555 ,Dubai",
        "phone": "97143506400 / 971504654755",
        "email": "r.hickman@aglaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8690f7d5-6b96-4649-9589-71303f2c2707",
    "firmName": "Addleshaw Goddard (Middle East) LLP",
    "registrationNumber": "L-02212",
    "licenseIssueDate": "03/28/2013 00:00:00",
    "licenseExpiryDate": "03/20/2026 00:00:00"
  },
  {
    "id": "31cfa1d0-d002-4eae-90da-901529e40e4d",
    "slug": "lucrezia-lorenzini",
    "name": "Lucrezia Lorenzini",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/27/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Lucrezia Lorenzini",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_31cfa1d0-d002-4eae-90da-901529e40e4d",
        "address": "Al Fattan Currency House Tower 2 ,DIFC ,507176 ,",
        "phone": "/ 971552009003",
        "email": "Mohammad.AlRasheed@bakermckenzie.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "acd81e81-dead-4f7c-839e-0f2a57897265",
    "firmName": "Baker & Mckenzie LLP",
    "registrationNumber": "L-05416",
    "licenseIssueDate": "07/27/2022 00:00:00",
    "licenseExpiryDate": "07/26/2026 00:00:00"
  },
  {
    "id": "ff15364c-c98b-4516-aaa2-d25e92661053",
    "slug": "lucy-gay-ison",
    "name": "LUCY GAY ISON",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/10/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: LUCY GAY ISON",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ff15364c-c98b-4516-aaa2-d25e92661053",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-04736",
    "licenseIssueDate": "09/10/2020 00:00:00",
    "licenseExpiryDate": "09/09/2026 00:00:00"
  },
  {
    "id": "93fb257d-577f-47b4-aa68-2937aee656f2",
    "slug": "lucy-margaret-catherine-williams",
    "name": "Lucy Margaret Catherine Williams",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/15/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Lucy Margaret Catherine Williams",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_93fb257d-577f-47b4-aa68-2937aee656f2",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-05247",
    "licenseIssueDate": "03/15/2022 00:00:00",
    "licenseExpiryDate": "03/14/2026 00:00:00"
  },
  {
    "id": "71b2d682-66dc-4fb1-8ba5-7541738d7c18",
    "slug": "lucy-melville",
    "name": "Lucy Melville",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/19/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Lucy Melville",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_71b2d682-66dc-4fb1-8ba5-7541738d7c18",
        "address": "6 ,Office Nos. 603, 604 & 605, Level 6, Burj Daman ,Dubai International Financial Centre ,506555 ,Dubai",
        "phone": "97143506400 / 971504654755",
        "email": "r.hickman@aglaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8690f7d5-6b96-4649-9589-71303f2c2707",
    "firmName": "Addleshaw Goddard (Middle East) LLP",
    "registrationNumber": "L-05284",
    "licenseIssueDate": "04/19/2022 00:00:00",
    "licenseExpiryDate": "04/18/2026 00:00:00"
  },
  {
    "id": "e820536b-6efb-4053-bc2b-c9b7def7ba0d",
    "slug": "lujain-ghassan-fawzi-asaf",
    "name": "Lujain Ghassan Fawzi Asaf",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/08/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Lujain Ghassan Fawzi Asaf",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e820536b-6efb-4053-bc2b-c9b7def7ba0d",
        "address": "- ,THE OFFICES 1 ,DWTC ,115580 ,Dubai",
        "phone": "97143739700 / 971562196031",
        "email": "catherine.workman@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6b4ebb23-ef2e-4305-a1ee-43a11e4b1cae",
    "firmName": "Pinsent Masons LLP - Dubai Branch",
    "registrationNumber": "L-05731",
    "licenseIssueDate": "03/08/2023 00:00:00",
    "licenseExpiryDate": "03/07/2026 00:00:00"
  },
  {
    "id": "7aa0b42a-f68d-4aca-8ca8-fc9ff0fa2364",
    "slug": "luka-kristovic",
    "name": "Luka Kristovic",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/22/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Luka Kristovic",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7aa0b42a-f68d-4aca-8ca8-fc9ff0fa2364",
        "address": "Al Fattan Currency House Tower 2 ,DIFC ,507176 ,",
        "phone": "/ 971552009003",
        "email": "Mohammad.AlRasheed@bakermckenzie.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "acd81e81-dead-4f7c-839e-0f2a57897265",
    "firmName": "Baker & Mckenzie LLP",
    "registrationNumber": "L-03641",
    "licenseIssueDate": "02/22/2017 00:00:00",
    "licenseExpiryDate": "02/18/2026 00:00:00"
  },
  {
    "id": "27faeaa0-51cb-4f6a-bf38-633c13c163ea",
    "slug": "luke-garrett",
    "name": "Luke Garrett",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/08/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Luke Garrett",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_27faeaa0-51cb-4f6a-bf38-633c13c163ea",
        "address": "",
        "phone": "97144230555 / 971504788443",
        "email": "yah@hfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c462c65e-185a-4e81-8425-a87e3a2b6842",
    "firmName": "Holman Fenwick Willan Middle East LLP",
    "registrationNumber": "L-01984",
    "licenseIssueDate": "10/08/2013 00:00:00",
    "licenseExpiryDate": "10/01/2026 00:00:00"
  },
  {
    "id": "5d9e803e-fe02-42d2-9fa2-2906f6878f0c",
    "slug": "luke-james-hackett",
    "name": "Luke James Hackett",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/05/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Luke James Hackett",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5d9e803e-fe02-42d2-9fa2-2906f6878f0c",
        "address": "Al Fattan Currency House Tower 2 ,DIFC ,507176 ,",
        "phone": "/ 971552009003",
        "email": "Mohammad.AlRasheed@bakermckenzie.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "acd81e81-dead-4f7c-839e-0f2a57897265",
    "firmName": "Baker & Mckenzie LLP",
    "registrationNumber": "L-06711",
    "licenseIssueDate": "03/05/2025 00:00:00",
    "licenseExpiryDate": "03/04/2026 00:00:00"
  },
  {
    "id": "75f40c73-ce4c-44e7-89b3-7f443133c08c",
    "slug": "luke-johnson",
    "name": "Luke Johnson",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/22/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Luke Johnson",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_75f40c73-ce4c-44e7-89b3-7f443133c08c",
        "address": "6 ,Office Nos. 603, 604 & 605, Level 6, Burj Daman ,Dubai International Financial Centre ,506555 ,Dubai",
        "phone": "97143506400 / 971504654755",
        "email": "r.hickman@aglaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8690f7d5-6b96-4649-9589-71303f2c2707",
    "firmName": "Addleshaw Goddard (Middle East) LLP",
    "registrationNumber": "L-03957",
    "licenseIssueDate": "01/22/2018 00:00:00",
    "licenseExpiryDate": "01/19/2026 00:00:00"
  },
  {
    "id": "568f2534-36dd-455c-966e-8eb9ab000a65",
    "slug": "luke-jonathan-aylett",
    "name": "Luke Jonathan Aylett",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/15/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Luke Jonathan Aylett",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_568f2534-36dd-455c-966e-8eb9ab000a65",
        "address": "6 ,Office Nos. 603, 604 & 605, Level 6, Burj Daman ,Dubai International Financial Centre ,506555 ,Dubai",
        "phone": "97143506400 / 971504654755",
        "email": "r.hickman@aglaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8690f7d5-6b96-4649-9589-71303f2c2707",
    "firmName": "Addleshaw Goddard (Middle East) LLP",
    "registrationNumber": "L-04070",
    "licenseIssueDate": "06/15/2023 00:00:00",
    "licenseExpiryDate": "06/14/2026 00:00:00"
  },
  {
    "id": "a879f0f3-e65a-40a1-aeee-1427f5d0d781",
    "slug": "luke-matthew-fittis",
    "name": "Luke Matthew Fittis",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/05/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Luke Matthew Fittis",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a879f0f3-e65a-40a1-aeee-1427f5d0d781",
        "address": "",
        "phone": "97144230555 / 971504788443",
        "email": "yah@hfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c462c65e-185a-4e81-8425-a87e3a2b6842",
    "firmName": "Holman Fenwick Willan Middle East LLP",
    "registrationNumber": "L-03925",
    "licenseIssueDate": "12/05/2017 00:00:00",
    "licenseExpiryDate": "12/02/2025 00:00:00"
  },
  {
    "id": "ae849dd6-f151-4631-9683-9a25707642e5",
    "slug": "luke-petith",
    "name": "Luke Petith",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/23/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Luke Petith",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ae849dd6-f151-4631-9683-9a25707642e5",
        "address": "",
        "phone": "97143637999 / 971506525633",
        "email": "daniel.wood@walkersglobal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a3a9927b-d51c-490c-8be6-d575ea3eb041",
    "firmName": "Walkers (Middle East) LLP",
    "registrationNumber": "L-03751",
    "licenseIssueDate": "05/23/2017 00:00:00",
    "licenseExpiryDate": "05/20/2026 00:00:00"
  },
  {
    "id": "fd9c2ef2-9046-4a13-8b43-e8c1e1a64777",
    "slug": "luke-robinson",
    "name": "Luke Robinson",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/02/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Luke Robinson",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fd9c2ef2-9046-4a13-8b43-e8c1e1a64777",
        "address": "",
        "phone": "97145953601 / 971508728645",
        "email": "Steven.Bainbridge@gtlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b4146aa6-efd1-41d7-819d-49da46353b0b",
    "firmName": "Greenberg Traurig Limited",
    "registrationNumber": "L-04134",
    "licenseIssueDate": "11/02/2023 00:00:00",
    "licenseExpiryDate": "11/01/2026 00:00:00"
  },
  {
    "id": "34be3b23-513c-4825-bf93-7e8cddedb50b",
    "slug": "luke-simon-wells",
    "name": "Luke Simon Wells",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/17/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Luke Simon Wells",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_34be3b23-513c-4825-bf93-7e8cddedb50b",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-06871",
    "licenseIssueDate": "06/17/2025 00:00:00",
    "licenseExpiryDate": "06/16/2026 00:00:00"
  },
  {
    "id": "173ef213-3494-49c3-aea8-55561010a249",
    "slug": "luke-tapp",
    "name": "Luke Tapp",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/12/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Luke Tapp",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_173ef213-3494-49c3-aea8-55561010a249",
        "address": "- ,THE OFFICES 1 ,DWTC ,115580 ,Dubai",
        "phone": "97143739700 / 971562196031",
        "email": "catherine.workman@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6b4ebb23-ef2e-4305-a1ee-43a11e4b1cae",
    "firmName": "Pinsent Masons LLP - Dubai Branch",
    "registrationNumber": "L-01276",
    "licenseIssueDate": "07/12/2012 00:00:00",
    "licenseExpiryDate": "07/04/2026 00:00:00"
  },
  {
    "id": "ba51f8c6-781e-45eb-b451-47374f8f78eb",
    "slug": "luma-alsaqqaf",
    "name": "LUMA ALSAQQAF",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/13/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: LUMA ALSAQQAF",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ba51f8c6-781e-45eb-b451-47374f8f78eb",
        "address": "Saleh Ahmed Yousif Saleh Alobeidli ,2nd ,DUBAI SUPREME COURT COMPLEX ,Dubai Courts ,333842 ,Dubai",
        "phone": "97143546762",
        "email": "Laila@iclo.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "57836e55-f90c-4fb1-81d0-a735a168b9ac",
    "firmName": "INTERNATIONAL CONSULTANT LAW OFFICE",
    "registrationNumber": "L-07008"
  },
  {
    "id": "6db4c6dd-3cb1-417a-94e1-9e4669ca385f",
    "slug": "luminita-rizescu",
    "name": "Luminita Rizescu",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/13/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Luminita Rizescu",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6db4c6dd-3cb1-417a-94e1-9e4669ca385f",
        "address": "4th floor ,Al Saaha Offices Block D office 401A ,Burj Khalifa ,283773 ,Dubai",
        "phone": "97144221944",
        "email": "gov.depts@alsafarpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b7bbfaeb-1fdb-46d2-97cf-8e6432a9b8a7",
    "firmName": "AL SAFAR & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03748",
    "licenseIssueDate": "03/13/2019 00:00:00",
    "licenseExpiryDate": "03/11/2026 00:00:00"
  },
  {
    "id": "9765cbd6-a56e-40bc-9b2d-d0fd91468bd6",
    "slug": "luna-shehayeb",
    "name": "Luna Shehayeb",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/21/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Luna Shehayeb",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9765cbd6-a56e-40bc-9b2d-d0fd91468bd6",
        "address": "",
        "phone": "97104309100 / 971564013758",
        "email": "c.royle@taylorwessing.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d51b6f43-8c62-486f-a1ab-6ee3b87c8006",
    "firmName": "Taylor Wessing LLP (Dubai Branch)",
    "registrationNumber": "L-06599",
    "licenseIssueDate": "11/21/2024 00:00:00",
    "licenseExpiryDate": "11/20/2025 00:00:00"
  },
  {
    "id": "3cae74b9-c156-45bf-9be5-05f7e1a4b9a9",
    "slug": "lydia-martine-thimon",
    "name": "LYDIA MARTINE THIMON",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/07/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: LYDIA MARTINE THIMON",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3cae74b9-c156-45bf-9be5-05f7e1a4b9a9",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-06135",
    "licenseIssueDate": "12/07/2023 00:00:00",
    "licenseExpiryDate": "12/06/2025 00:00:00"
  },
  {
    "id": "fa360c98-1f75-4c67-8dda-8a5795cb4d6d",
    "slug": "lynsey-jane-grossi",
    "name": "LYNSEY JANE GROSSI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/13/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: LYNSEY JANE GROSSI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fa360c98-1f75-4c67-8dda-8a5795cb4d6d",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-05146",
    "licenseIssueDate": "12/13/2021 00:00:00",
    "licenseExpiryDate": "12/12/2025 00:00:00"
  },
  {
    "id": "b7e58e3a-eb1f-450a-beea-183f43c13d9a",
    "slug": "lyudmila-yamalova",
    "name": "Lyudmila Yamalova",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/08/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Lyudmila Yamalova",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b7e58e3a-eb1f-450a-beea-183f43c13d9a",
        "address": "",
        "phone": "97144279812 / 971504597319",
        "email": "lyamalova@lylawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "dd62d765-3845-4e09-b92b-1ba92c1e27e4",
    "firmName": "HPL Yamalova & Plewka FZCO",
    "registrationNumber": "L-00981",
    "licenseIssueDate": "09/08/2011 00:00:00",
    "licenseExpiryDate": "08/30/2026 00:00:00"
  },
  {
    "id": "951547e3-d00e-4535-a1bf-afe285da944f",
    "slug": "mali-abdullatif-hafez",
    "name": "M.ALI ABDULLATIF HAFEZ",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/12/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: M.ALI ABDULLATIF HAFEZ",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_951547e3-d00e-4535-a1bf-afe285da944f",
        "address": "FAHD MOHAMED RASHED ALHADOURI ALYAMMAHI ,10 ,MAZE TOWER ,DIFC - FUTURE MUSEUM ,127077 ,Dubai",
        "phone": "97143596555",
        "email": "fhd6767@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4e636842-b67d-49a6-a11f-607b9a136380",
    "firmName": "NOURA ALHAJERI AND FAHD ALHADOURI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04978",
    "licenseIssueDate": "07/12/2021 00:00:00",
    "licenseExpiryDate": "07/11/2026 00:00:00"
  },
  {
    "id": "f6979f37-e991-428b-8913-c8bd876efe5c",
    "slug": "macky-osullivan",
    "name": "Macky O'Sullivan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/25/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Macky O'Sullivan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f6979f37-e991-428b-8913-c8bd876efe5c",
        "address": "",
        "phone": "97143779900 / 971508548052",
        "email": "jali@kslaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dff8529a-82be-431a-b72b-0192ff238011",
    "firmName": "King & Spalding LLP",
    "registrationNumber": "L-01103",
    "licenseIssueDate": "02/25/2012 00:00:00",
    "licenseExpiryDate": "02/16/2026 00:00:00"
  },
  {
    "id": "7ddc3a29-60c3-4217-8215-ad1fadd1ad92",
    "slug": "madayil-sherina",
    "name": "Madayil Sherina",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/25/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Madayil Sherina",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7ddc3a29-60c3-4217-8215-ad1fadd1ad92",
        "address": "4th Floor/ Office no. 401 ,Business Avenue  ,Infront- Terminal 2  ,115263 ,Dubai",
        "phone": "97144518866",
        "email": "info@aldhaheriinternational.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "cf3c19c0-d396-4bcb-b1db-b81273ed0b4c",
    "firmName": "AL DHAHERI INTERNATIONAL ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02636",
    "licenseIssueDate": "08/25/2022 00:00:00",
    "licenseExpiryDate": "08/24/2026 00:00:00"
  },
  {
    "id": "6d9eef3d-75fa-456f-986d-17cd3bad314d",
    "slug": "madeleine-mendy",
    "name": "Madeleine Mendy",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/15/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Madeleine Mendy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6d9eef3d-75fa-456f-986d-17cd3bad314d",
        "address": "Firas Hassan Al Choufi ,701 ,The Prime Tower ,Makani No: 25836 86879 ,125305 ,Dubai",
        "phone": "97144357246",
        "email": "info@binsevanadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4d3c9dcc-51c6-4883-b9ed-c65a7d1c5a57",
    "firmName": "BIN SEVAN ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-02538",
    "licenseIssueDate": "03/15/2014 00:00:00",
    "licenseExpiryDate": "03/08/2026 00:00:00"
  },
  {
    "id": "108199e2-e88a-4348-a54c-97c032ce6464",
    "slug": "madison-colangelo",
    "name": "Madison Colangelo",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/28/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Madison Colangelo",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_108199e2-e88a-4348-a54c-97c032ce6464",
        "address": "ICD Brookfield Place ,Za'abeel 2 ,103747 ,",
        "phone": "97143696300 / 971506008159",
        "email": "mohammed.paracha@nortonrosefulbright.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c4aaee93-0ec4-4982-9a48-a23699492056",
    "firmName": "Norton Rose Fullbright (Middle East) LLP",
    "registrationNumber": "L-06833",
    "licenseIssueDate": "05/28/2025 00:00:00",
    "licenseExpiryDate": "05/27/2026 00:00:00"
  },
  {
    "id": "1b6e2a89-f8e5-49fa-a05d-7636e81a4245",
    "slug": "magda-kofluk",
    "name": "Magda Kofluk",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/10/2022",
    "licenseStatus": "active",
    "licenseExpiry": "2023-10-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Magda Kofluk",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1b6e2a89-f8e5-49fa-a05d-7636e81a4245",
        "address": "",
        "phone": "97144073901 / 971503479508",
        "email": "Rania.Tadros@stephensonharwood.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dd5042a2-bb41-4123-9544-79c3fa831332",
    "firmName": "Stephenson Harwood (Middle East) LLP",
    "registrationNumber": "L-03480",
    "licenseIssueDate": "10/18/2022 00:00:00",
    "licenseExpiryDate": "10/17/2025 00:00:00"
  },
  {
    "id": "d5f2c021-2765-4729-9cab-be0cabb94c4d",
    "slug": "magdi-ahmed-ibrahim",
    "name": "Magdi Ahmed Ibrahim",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Magdi Ahmed Ibrahim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d5f2c021-2765-4729-9cab-be0cabb94c4d",
        "address": "الطابق الثامن ,بزنس أفنيو ,خلف وكالة نيسان ,444775 ,Dubai",
        "phone": "97142501414",
        "email": "info@halalilaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "37ab9a73-e65f-4829-9402-6eac64c4c621",
    "firmName": "HASSAN AL ALI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-02185",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "ffebb6ba-fa63-4a91-a215-86f5708fbbeb",
    "slug": "magdi-el-gohari",
    "name": "Magdi El Gohari",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/03/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Magdi El Gohari",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ffebb6ba-fa63-4a91-a215-86f5708fbbeb",
        "address": "",
        "phone": "97142736666",
        "email": "almohmon@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "651d46a2-cdc6-4e8e-99ad-7ee0f3ddca7a",
    "firmName": "AL MUHAMOON AL ARAB LAWYER & LEGAL CONSULTANCY",
    "registrationNumber": "L-03140",
    "licenseIssueDate": "08/03/2015 00:00:00",
    "licenseExpiryDate": "07/29/2026 00:00:00"
  },
  {
    "id": "2f25833c-357f-48d0-b447-2d7961117f89",
    "slug": "magdi-kamal-khamis",
    "name": "Magdi Kamal Khamis",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Magdi Kamal Khamis",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2f25833c-357f-48d0-b447-2d7961117f89",
        "address": "",
        "phone": "97142828999",
        "email": "info@gmalc.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2f9514bf-2175-40fe-8539-d1b4b32074b7",
    "firmName": "ALGURG & ALMATROOSHI ADVOCATES & LIGAL CONSULTANTS",
    "registrationNumber": "L-01390",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "7edbc8ff-a3dd-4cd3-b32b-077c620386f3",
    "slug": "magdy-elhoufy",
    "name": "Magdy Elhoufy",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Magdy Elhoufy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7edbc8ff-a3dd-4cd3-b32b-077c620386f3",
        "address": "Hussain Ali Al Jaziri ,11 ,City Tower 2 ,Crown Plaza hotel Sheikh Zayed Road ,4253 ,Dubai",
        "phone": "97142626777 / 971529087670",
        "email": "courts@jaflaws.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c58d8654-b428-46b3-abd5-024e4331ee53",
    "firmName": "JAAFAR ALWAN & AL JAZIRI & ASSOCIATES",
    "registrationNumber": "L-01597",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "8a9ec234-666d-4d30-addf-45a65d8bea6f",
    "slug": "magdy-mohamed-amin-abdemeged-abdlla",
    "name": "Magdy Mohamed Amin Abdemeged Abdlla",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/15/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Magdy Mohamed Amin Abdemeged Abdlla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8a9ec234-666d-4d30-addf-45a65d8bea6f",
        "address": "Dr. Ali Ismail Aljarman ,Roof Floor - Offices R03 & R04 ,MSM 1 Building ,Al Saffa First ,62639 ,Dubai",
        "phone": "97144393733",
        "email": "info@prestigeadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "22043b7f-55d2-4eb4-a173-3077ba390351",
    "firmName": "PRESTIGE ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01799",
    "licenseIssueDate": "07/15/2018 00:00:00",
    "licenseExpiryDate": "07/13/2026 00:00:00"
  },
  {
    "id": "13515263-590c-4bca-baa7-ad856f98bd18",
    "slug": "maged-ahmed-elsayad-mohamed-abdulla",
    "name": "MAGED AHMED ELSAYAD MOHAMED ABDULLA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/18/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MAGED AHMED ELSAYAD MOHAMED ABDULLA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_13515263-590c-4bca-baa7-ad856f98bd18",
        "address": "",
        "phone": "97142999720",
        "email": "meleihadvocates@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5dd70a2b-2ada-48f1-81e2-5885629a7035",
    "firmName": "MELEIH ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05070",
    "licenseIssueDate": "10/18/2021 00:00:00",
    "licenseExpiryDate": "10/17/2025 00:00:00"
  },
  {
    "id": "a6f5df46-7171-4f19-ad2a-7cce01cd860b",
    "slug": "maged-michaeil",
    "name": "Maged Michaeil",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/04/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Maged Michaeil",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a6f5df46-7171-4f19-ad2a-7cce01cd860b",
        "address": "HASSAN AL BAKRI ,16 ,THE EXCHANGE TOWER ,DUBAI WATER CANAL ,89179 ,Dubai",
        "phone": "97145807888",
        "email": "secretary@alkathirilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b5f1d60b-df9b-4054-ac59-4543a6d06af4",
    "firmName": "SHOUQ ALKATHIRI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01165",
    "licenseIssueDate": "01/04/2021 00:00:00",
    "licenseExpiryDate": "01/03/2026 00:00:00"
  },
  {
    "id": "693f6865-9496-463c-abac-fc455909bbc1",
    "slug": "magnus-alexander-taylor",
    "name": "Magnus Alexander Taylor",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/04/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Magnus Alexander Taylor",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_693f6865-9496-463c-abac-fc455909bbc1",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-06028",
    "licenseIssueDate": "10/04/2023 00:00:00",
    "licenseExpiryDate": "10/03/2026 00:00:00"
  },
  {
    "id": "f677cec1-9d29-48d2-a074-c87eb9064dcb",
    "slug": "maha-fadhel-abdulbaqi-abualhasan-alali",
    "name": "Maha Fadhel Abdulbaqi Abualhasan alali",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/19/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Maha Fadhel Abdulbaqi Abualhasan alali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f677cec1-9d29-48d2-a074-c87eb9064dcb",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-05290",
    "licenseIssueDate": "04/19/2022 00:00:00",
    "licenseExpiryDate": "04/18/2026 00:00:00"
  },
  {
    "id": "e086b7a2-db99-4d70-a879-343eb01c2b89",
    "slug": "maha-kaskas",
    "name": "Maha Kaskas",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/15/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Maha Kaskas",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e086b7a2-db99-4d70-a879-343eb01c2b89",
        "address": "ICD-Brookfield Place ,DIFC ,119974 ,",
        "phone": "97143652000",
        "email": "david.charlier@ashurst.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c01c3c61-4d90-4058-8429-61dd01e615f5",
    "firmName": "Ashurst LLP-DIFC",
    "registrationNumber": "L-02530",
    "licenseIssueDate": "03/15/2021 00:00:00",
    "licenseExpiryDate": "03/13/2026 00:00:00"
  },
  {
    "id": "f67bd3bf-06ad-4f04-a30d-c1fe48e04b56",
    "slug": "maher-abdelsalam-ibrahim",
    "name": "Maher Abdelsalam Ibrahim",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/27/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Maher Abdelsalam Ibrahim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f67bd3bf-06ad-4f04-a30d-c1fe48e04b56",
        "address": "",
        "phone": "97142959506",
        "email": "contactus@lawfirmint.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c137b8ba-d9dd-4ca4-9448-55721c8b99a4",
    "firmName": "LAW FIRM INTERNATIONAL ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-02381",
    "licenseIssueDate": "04/27/2014 00:00:00",
    "licenseExpiryDate": "04/20/2026 00:00:00"
  },
  {
    "id": "d272b527-17de-406a-b2e4-4b72e58e241b",
    "slug": "maher-alloubani",
    "name": "Maher Alloubani",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/28/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Maher Alloubani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d272b527-17de-406a-b2e4-4b72e58e241b",
        "address": "ISMAIL HASSAN EBRAHIM ALSAFFAR ,الطابق الثامن - مكتب 801 AFR ,الصقر للاعمال ,يوجد اسفل البناية مطعم وينديز ,25752 ,Dubai",
        "phone": "97143276805",
        "email": "info@alsaffar-legal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ceb9cbcf-79f3-462d-afe2-aa4c62eff72b",
    "firmName": "ISMAIL ALSAFFAR ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03650",
    "licenseIssueDate": "02/28/2017 00:00:00",
    "licenseExpiryDate": "02/24/2026 00:00:00"
  },
  {
    "id": "01d937e7-20b6-4e27-9ac8-1cce0c772d5b",
    "slug": "maher-alnashar",
    "name": "Maher Alnashar",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Maher Alnashar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_01d937e7-20b6-4e27-9ac8-1cce0c772d5b",
        "address": "20 ,Index Tower West Tower ,DIFC ,507226 ,Dubai",
        "phone": "97142461900 / 971523391604",
        "email": "patrick.gearon@crsblaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e2ac552e-b9a7-450b-a84d-15119e583220",
    "firmName": "Charles Russell Speechlys LLP",
    "registrationNumber": "L-01450",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "b82de833-bfd6-43ce-8437-23ac95272a08",
    "slug": "maher-ghalloussi",
    "name": "Maher Ghalloussi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/17/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Maher Ghalloussi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b82de833-bfd6-43ce-8437-23ac95272a08",
        "address": "Al Fattan Currency House Tower 2 ,DIFC ,507176 ,",
        "phone": "/ 971552009003",
        "email": "Mohammad.AlRasheed@bakermckenzie.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "acd81e81-dead-4f7c-839e-0f2a57897265",
    "firmName": "Baker & Mckenzie LLP",
    "registrationNumber": "L-05472",
    "licenseIssueDate": "08/17/2022 00:00:00",
    "licenseExpiryDate": "08/16/2026 00:00:00"
  },
  {
    "id": "b21bf6fb-1a7c-44fc-a82a-5584a8125c4a",
    "slug": "mahima-eades",
    "name": "Mahima Eades",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/08/2023",
    "licenseStatus": "active",
    "licenseExpiry": "2024-08-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mahima Eades",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b21bf6fb-1a7c-44fc-a82a-5584a8125c4a",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-04648",
    "licenseIssueDate": "08/08/2023 00:00:00",
    "licenseExpiryDate": "08/07/2026 00:00:00"
  },
  {
    "id": "7f184e8f-4ce1-4fb8-8d25-68f5e0d2adc2",
    "slug": "mahmmad-ahmad-desoky-aly",
    "name": "Mahmmad Ahmad Desoky Aly",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/12/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mahmmad Ahmad Desoky Aly",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7f184e8f-4ce1-4fb8-8d25-68f5e0d2adc2",
        "address": "Ahmed Saleh Abulla Khamis ALramsi ,1305 ,Fairmont Dubai ,Burj Khalifa ,77857 ,Dubai",
        "phone": "97142720066",
        "email": "info@alramsyadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b84458c4-4c08-4fa7-8fd9-05b8787d4896",
    "firmName": "DR. AHMED ALRAMSI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05907",
    "licenseIssueDate": "07/12/2023 00:00:00",
    "licenseExpiryDate": "07/11/2026 00:00:00"
  },
  {
    "id": "6fad99bb-d3be-46d8-b534-c4bf9e90182c",
    "slug": "mahmood-haji",
    "name": "Mahmood Haji",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mahmood Haji",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6fad99bb-d3be-46d8-b534-c4bf9e90182c",
        "address": "",
        "phone": "97143937700",
        "email": "info@galadarilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d863b662-c864-4193-8b3a-ff6ee5fe6c64",
    "firmName": "GALADARI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01493",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "fbc3f56d-bc81-4078-8b08-518689dc1ca3",
    "slug": "mahmood-nizar-abdellatif",
    "name": "Mahmood Nizar Abdellatif",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/30/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mahmood Nizar Abdellatif",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fbc3f56d-bc81-4078-8b08-518689dc1ca3",
        "address": "",
        "phone": "97104309100 / 971564013758",
        "email": "c.royle@taylorwessing.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d51b6f43-8c62-486f-a1ab-6ee3b87c8006",
    "firmName": "Taylor Wessing LLP (Dubai Branch)",
    "registrationNumber": "L-06907",
    "licenseIssueDate": "07/30/2025 00:00:00",
    "licenseExpiryDate": "07/29/2026 00:00:00"
  },
  {
    "id": "f718b99f-f9a1-4063-ba38-306904307480",
    "slug": "mahmoud-abdalla",
    "name": "Mahmoud Abdalla",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/01/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mahmoud Abdalla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f718b99f-f9a1-4063-ba38-306904307480",
        "address": "6 ,Business Point ,Nissan Showroom  ,443 ,Dubai",
        "phone": "97142999991",
        "email": "dubai@alrasheed.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a4fce061-88d2-4308-9c3a-dbb02f5cbe82",
    "firmName": "ALRASHEED & PARTNERS",
    "registrationNumber": "L-01179",
    "licenseIssueDate": "07/01/2012 00:00:00",
    "licenseExpiryDate": "06/22/2026 00:00:00"
  },
  {
    "id": "390ca5ea-9bc4-4b08-9518-21c4b3a18f17",
    "slug": "mahmoud-abdel-mohsen-negm",
    "name": "Mahmoud Abdel Mohsen Negm",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mahmoud Abdel Mohsen Negm",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_390ca5ea-9bc4-4b08-9518-21c4b3a18f17",
        "address": "",
        "phone": "97142664424",
        "email": "nagm009@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d9e56be7-6c69-408a-9a66-04ced959910a",
    "firmName": "ABDUL RAHMAN AL MOTAWA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02349",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "b4905160-5046-494b-b254-aba89ec0c9c0",
    "slug": "mahmoud-abdelaziz-hammad",
    "name": "Mahmoud Abdelaziz Hammad",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/27/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mahmoud Abdelaziz Hammad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b4905160-5046-494b-b254-aba89ec0c9c0",
        "address": "Second Floor - Office No. 224 ,Business Center ,Makani No: 3274893760 ,000 ,Dubai",
        "phone": "97145671576 / 971529969969",
        "email": "info@hamadalsayegh.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "38838899-8c67-45c6-8699-4c822e13f4b8",
    "firmName": "HAMAD AL SAYEGH ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02822",
    "licenseIssueDate": "05/27/2014 00:00:00",
    "licenseExpiryDate": "05/21/2026 00:00:00"
  },
  {
    "id": "f0fc542f-5f36-493e-9b98-7ba7a7324516",
    "slug": "mahmoud-abdelaziz-mahmoud-mohamed-ashour",
    "name": "Mahmoud Abdelaziz Mahmoud Mohamed Ashour",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/08/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mahmoud Abdelaziz Mahmoud Mohamed Ashour",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f0fc542f-5f36-493e-9b98-7ba7a7324516",
        "address": "الطابق الثامن  ,برج الجرج 1 ,دائرة الاراضي و الاملاك  ,9117 ,Dubai",
        "phone": "97143320004",
        "email": "info@hlootahlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4ad67cb4-18b4-4417-9b6a-d23a9fb368fb",
    "firmName": "HUSSAIN LOOTAH & PARTNERS - ATTORNEYS & COUNSELLORS AT LAW",
    "registrationNumber": "L-06995"
  },
  {
    "id": "3e344879-0931-40b8-85d7-f10169ac91f8",
    "slug": "mahmoud-abdelaziz-mahmoud-salem",
    "name": "MAHMOUD ABDELAZIZ MAHMOUD SALEM",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/01/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MAHMOUD ABDELAZIZ MAHMOUD SALEM",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3e344879-0931-40b8-85d7-f10169ac91f8",
        "address": "الطابق 33/ الوحدة : 3304 ,مبني المنارة /   الطابق 33/ الوحدة : 3304 ,فندق جي دبليو ماركيز  ,24002 ,Dubai",
        "phone": "97144254373",
        "email": "info@wkadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "332a3a67-50f2-424a-a5c1-d5abaf9a030b",
    "firmName": "WALEED ALMARZOOQI AND KHALID MOHAMED ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-06042",
    "licenseIssueDate": "11/01/2023 00:00:00",
    "licenseExpiryDate": "10/31/2025 00:00:00"
  },
  {
    "id": "94972451-66a0-4b1d-ac36-f26d65930fb9",
    "slug": "mahmoud-abdelghani-ali-hussein",
    "name": "Mahmoud Abdelghani Ali Hussein",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mahmoud Abdelghani Ali Hussein",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_94972451-66a0-4b1d-ac36-f26d65930fb9",
        "address": "",
        "phone": "97142220011",
        "email": "info@hammad.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8d0af4a8-053e-49f9-bed7-795d52e23286",
    "firmName": "YOUSUF BIN HAMMAD & ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01578",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "2004a70a-4071-4fcc-bee0-371dbc9f049e",
    "slug": "mahmoud-abdelgwad-attiea-elsakka",
    "name": "MAHMOUD ABDELGWAD ATTIEA ELSAKKA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/05/2021",
    "licenseStatus": "active",
    "licenseExpiry": "2022-05-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MAHMOUD ABDELGWAD ATTIEA ELSAKKA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2004a70a-4071-4fcc-bee0-371dbc9f049e",
        "address": "O-4801, O-4901 ,Burj al Salam Office Tower ,H Hotel ,111801 ,Dubai",
        "phone": "97143544444",
        "email": "administration@horizlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4e25fb39-6659-44f0-bc8b-3ff0f067beb0",
    "firmName": "HORIZONS & CO - LAW FIRM",
    "registrationNumber": "L-04954",
    "licenseIssueDate": "05/25/2021 00:00:00",
    "licenseExpiryDate": "05/24/2026 00:00:00"
  },
  {
    "id": "6b4885b4-0ca2-4710-868e-94b41cec2212",
    "slug": "mahmoud-abdelrahman-mahmoud-rashed",
    "name": "Mahmoud Abdelrahman Mahmoud Rashed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/31/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mahmoud Abdelrahman Mahmoud Rashed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6b4885b4-0ca2-4710-868e-94b41cec2212",
        "address": "11 ,بناية صبحة ايفوري 2 ,ماما شيلتر أوتيل ,9598 ,Dubai",
        "phone": "97143880171 / 971565359809",
        "email": "malawyer@malawyer.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "da6588ae-fc3b-4a88-8a5e-7836becb47d2",
    "firmName": "MAJID ALSKAIKH ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04333",
    "licenseIssueDate": "03/31/2019 00:00:00",
    "licenseExpiryDate": "03/29/2026 00:00:00"
  },
  {
    "id": "c309070c-f765-469f-ad07-2ca41923f19c",
    "slug": "mahmoud-ahmed-abdelhafez-ahmed",
    "name": "Mahmoud Ahmed Abdelhafez Ahmed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/10/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mahmoud Ahmed Abdelhafez Ahmed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c309070c-f765-469f-ad07-2ca41923f19c",
        "address": "23 ,Rolex Tower ,Trade Center Second ,116637 ,Dubai",
        "phone": "97144357577 / 971502101003",
        "email": "jasamin.fichte@fichtelegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "77bf4fd2-1cd1-4bda-a0c2-ffcac3980b76",
    "firmName": "Fichte & Co Legal Consultancy",
    "registrationNumber": "L-04730",
    "licenseIssueDate": "09/10/2020 00:00:00",
    "licenseExpiryDate": "09/09/2026 00:00:00"
  },
  {
    "id": "53ae2df3-8b98-4100-b39b-361b7da25a76",
    "slug": "mahmoud-ahmed-mahmoud-shehab",
    "name": "MAHMOUD AHMED MAHMOUD SHEHAB",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/10/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MAHMOUD AHMED MAHMOUD SHEHAB",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_53ae2df3-8b98-4100-b39b-361b7da25a76",
        "address": "amal albastaki ,1903 ,court ,business bay ,127477 ,Dubai",
        "phone": "97142522202",
        "email": "info@amaladvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "f852bccd-2696-4190-9b40-77a8fb9c460f",
    "firmName": "AMAL ALBASTAKI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-05436",
    "licenseIssueDate": "08/10/2022 00:00:00",
    "licenseExpiryDate": "08/09/2026 00:00:00"
  },
  {
    "id": "d0df0d82-878b-4fc0-b00c-c01a8e146a7a",
    "slug": "mahmoud-elsayed-ahmed",
    "name": "Mahmoud Elsayed Ahmed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/16/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mahmoud Elsayed Ahmed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d0df0d82-878b-4fc0-b00c-c01a8e146a7a",
        "address": "",
        "phone": "97144073901 / 971503479508",
        "email": "Rania.Tadros@stephensonharwood.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dd5042a2-bb41-4123-9544-79c3fa831332",
    "firmName": "Stephenson Harwood (Middle East) LLP",
    "registrationNumber": "L-03363",
    "licenseIssueDate": "05/16/2016 00:00:00",
    "licenseExpiryDate": "05/12/2026 00:00:00"
  },
  {
    "id": "4aaaf100-6776-42bd-8c8e-24f2d142254f",
    "slug": "mahmoud-elsayed-kabil",
    "name": "Mahmoud Elsayed Kabil",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mahmoud Elsayed Kabil",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4aaaf100-6776-42bd-8c8e-24f2d142254f",
        "address": "",
        "phone": "97142212494",
        "email": "bayanlaw@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3eaca0c8-938e-4864-add1-73e5c902b168",
    "firmName": "DAR AL BAYAN ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02526",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "b1261e9f-b120-43d0-992f-12a0b167d7b6",
    "slug": "mahmoud-fadlallah",
    "name": "Mahmoud Fadlallah",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/28/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mahmoud Fadlallah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b1261e9f-b120-43d0-992f-12a0b167d7b6",
        "address": "ICD Brookfield Place ,DIFC ,120109 ,",
        "phone": "97143173000 / 971504465229",
        "email": "DubaiLAD@akingump.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "9ff29eab-adb8-40f9-ab84-216e01a381e4",
    "firmName": "Akin Gump Strauss Hauer & Feld LLP",
    "registrationNumber": "L-02722",
    "licenseIssueDate": "09/28/2014 00:00:00",
    "licenseExpiryDate": "09/22/2026 00:00:00"
  },
  {
    "id": "12566ce3-50ac-4114-86f3-3359d4b78fb3",
    "slug": "mahmoud-hassan-mostafa-kamel-elsayed",
    "name": "Mahmoud Hassan Mostafa Kamel Elsayed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/18/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mahmoud Hassan Mostafa Kamel Elsayed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_12566ce3-50ac-4114-86f3-3359d4b78fb3",
        "address": "omar abdulazizi alomar ,15 ,prime tower ,blom bank france ,211940 ,Dubai",
        "phone": "97143808838 / 971504598082",
        "email": "omar.omar@oghlegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "171b4622-e4ec-4375-a9c4-3637bf6a8b17",
    "firmName": "ALOMAR & ALSABAH ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-06859",
    "licenseIssueDate": "06/18/2025 00:00:00",
    "licenseExpiryDate": "06/17/2026 00:00:00"
  },
  {
    "id": "7083dee2-bd80-48e5-8b64-c7991a86e6b9",
    "slug": "mahmoud-ibrahim-saad-ibrahim",
    "name": "MAHMOUD IBRAHIM SAAD IBRAHIM",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/16/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MAHMOUD IBRAHIM SAAD IBRAHIM",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7083dee2-bd80-48e5-8b64-c7991a86e6b9",
        "address": "Office 308 ,Owned by ACICO Gulf Real Estate LLC, Dubai branch ,Makani No: 3250094543 ,000 ,Dubai",
        "phone": "97142697998 / 971503567998",
        "email": "info@ayshamslaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0892f012-3fc4-4895-8d3b-abbb036938aa",
    "firmName": "AYESHA ALDHAHERI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06864",
    "licenseIssueDate": "06/16/2025 00:00:00",
    "licenseExpiryDate": "06/15/2026 00:00:00"
  },
  {
    "id": "55fa8435-da00-43a0-a87e-a93549cf77e7",
    "slug": "mahmoud-idris",
    "name": "Mahmoud Idris",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/02/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mahmoud Idris",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_55fa8435-da00-43a0-a87e-a93549cf77e7",
        "address": "ICD Brookfield Place ,Za'abeel 2 ,103747 ,",
        "phone": "97143696300 / 971506008159",
        "email": "mohammed.paracha@nortonrosefulbright.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c4aaee93-0ec4-4982-9a48-a23699492056",
    "firmName": "Norton Rose Fullbright (Middle East) LLP",
    "registrationNumber": "L-03272",
    "licenseIssueDate": "07/02/2015 00:00:00",
    "licenseExpiryDate": "06/27/2026 00:00:00"
  },
  {
    "id": "ca509ea1-01ba-49e5-9f7d-a9d009d969c5",
    "slug": "mahmoud-mahmoud-hassan-emara",
    "name": "mahmoud mahmoud hassan emara",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/08/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: mahmoud mahmoud hassan emara",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ca509ea1-01ba-49e5-9f7d-a9d009d969c5",
        "address": "saeed ,310 & 311 ,business avenue ,منطقه بور سعيد التجاريه ,19410 ,Dubai",
        "phone": "97148868812",
        "email": "info@saeedalghafri.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5acd50c8-df41-496b-a969-926d40e45c46",
    "firmName": "SAEED ALGHAFRI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06988"
  },
  {
    "id": "411c25ea-f8b0-4aa3-b957-8d8f9b42bd91",
    "slug": "mahmoud-marzouk-ahmed-elsayed",
    "name": "mahmoud marzouk ahmed elsayed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/21/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: mahmoud marzouk ahmed elsayed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_411c25ea-f8b0-4aa3-b957-8d8f9b42bd91",
        "address": "Jane Naoe Elsayed ,Level No. 22 – Office No. (2201 – 2202) ,Concord Tower ,Media City ,99779 ,Dubai",
        "phone": "97143575999",
        "email": "info@binarab.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a718961d-c976-4a3c-bd09-585ec7c81310",
    "firmName": "RASHED BIN ARAB ADVOCATE AND LEGAL CONSULTANTS",
    "registrationNumber": "L-05680",
    "licenseIssueDate": "12/21/2022 00:00:00",
    "licenseExpiryDate": "12/20/2025 00:00:00"
  },
  {
    "id": "e6a478a0-2b01-4262-a0eb-013bd891e174",
    "slug": "mahmoud-mohamed-abdelnabi-abouelnasr-atwan",
    "name": "mahmoud mohamed abdelnabi abouelnasr atwan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/03/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: mahmoud mohamed abdelnabi abouelnasr atwan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e6a478a0-2b01-4262-a0eb-013bd891e174",
        "address": "",
        "phone": "97142221758 / 971506984647",
        "email": "droit@eim.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7adc24ae-eaae-40c6-a30b-5097991f467b",
    "firmName": "BUJESSAIM & AL MALIKI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06748",
    "licenseIssueDate": "04/03/2025 00:00:00",
    "licenseExpiryDate": "04/02/2026 00:00:00"
  },
  {
    "id": "943a5c68-288e-4050-95a2-bdab56220d57",
    "slug": "mahmoud-mohamed-awad-othan",
    "name": "MAHMOUD MOHAMED AWAD OTHAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/13/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MAHMOUD MOHAMED AWAD OTHAN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_943a5c68-288e-4050-95a2-bdab56220d57",
        "address": "Naser almuharrami ,التاسع  ,SAMA TOWER ,مطعم تشيلو  ,0000 ,Dubai",
        "phone": "97144581795 / 971507388622",
        "email": "info@lawdxb.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "bc5ea246-1523-48e3-917c-682ff8a19466",
    "firmName": "NASER ABDULLA ALMUHARRAMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06137",
    "licenseIssueDate": "12/13/2023 00:00:00",
    "licenseExpiryDate": "12/12/2025 00:00:00"
  },
  {
    "id": "208fcc54-fc84-4458-b40a-6376a8d53675",
    "slug": "mahmoud-mohamed-elsaid-abelhak",
    "name": "Mahmoud Mohamed Elsaid Abelhak",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/06/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mahmoud Mohamed Elsaid Abelhak",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_208fcc54-fc84-4458-b40a-6376a8d53675",
        "address": "",
        "phone": "97145770472",
        "email": "bushaqer4@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2a8599d2-a4d7-4456-9165-ad546262d108",
    "firmName": "ARIF BUSHAQER ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05362",
    "licenseIssueDate": "07/06/2022 00:00:00",
    "licenseExpiryDate": "07/05/2026 00:00:00"
  },
  {
    "id": "44cc0b03-9745-4a6f-9314-38f5c563e0ab",
    "slug": "mahmoud-mohamed-fahmy-bihiry",
    "name": "Mahmoud Mohamed Fahmy Bihiry",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/24/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mahmoud Mohamed Fahmy Bihiry",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_44cc0b03-9745-4a6f-9314-38f5c563e0ab",
        "address": "",
        "phone": "97144270845",
        "email": "info@khairallahlegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "74569c18-b69d-4159-813d-9923b25d2dca",
    "firmName": "KHAIRALLAH ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01825",
    "licenseIssueDate": "02/24/2023 00:00:00",
    "licenseExpiryDate": "02/23/2026 00:00:00"
  },
  {
    "id": "9113ddcd-02c2-482c-a75f-0a8d63f3c283",
    "slug": "mahmoud-mohamed-ibrahim-ibrahim-khashaba",
    "name": "Mahmoud Mohamed Ibrahim Ibrahim Khashaba",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/31/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mahmoud Mohamed Ibrahim Ibrahim Khashaba",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9113ddcd-02c2-482c-a75f-0a8d63f3c283",
        "address": "Alhajeya salem saeed alnoobi ,3rd  ,Al-hawai Tower  ,Behind financial center metro station  ,39779 ,Dubai",
        "phone": "97142963813",
        "email": "adv_aljazeera@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "f091b928-9e3d-4e24-b489-65ca31481366",
    "firmName": "AL HAJEYA ALNOOBI ADVOCATES AND LEGAL CONSULTANT",
    "registrationNumber": "L-05854",
    "licenseIssueDate": "05/31/2023 00:00:00",
    "licenseExpiryDate": "05/30/2026 00:00:00"
  },
  {
    "id": "6489fa22-6572-4374-a07f-9e249b0fd56e",
    "slug": "mahmoud-mohamed-mousa-hassan-shahawy",
    "name": "Mahmoud Mohamed Mousa Hassan Shahawy",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/15/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mahmoud Mohamed Mousa Hassan Shahawy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6489fa22-6572-4374-a07f-9e249b0fd56e",
        "address": "A7 ,Dubai Silicon Oasis ,29337 ,",
        "phone": "97144313060 / 971528448686",
        "email": "andres.ring@schlueter-graf.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2ce110f0-b433-4dbc-b15f-ab1a3b291c28",
    "firmName": "Schluter Graf Legal Consultants LLC",
    "registrationNumber": "L-04761",
    "licenseIssueDate": "10/15/2020 00:00:00",
    "licenseExpiryDate": "10/14/2026 00:00:00"
  },
  {
    "id": "35b7bd12-3fe5-4a1d-ad5f-c702a9c9cba0",
    "slug": "mahmoud-mohamed-taher-el-eshnehi",
    "name": "MAHMOUD MOHAMED TAHER ELESHNEHI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/03/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2021-03-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: mahmoud mohamed taher el eshnehi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_35b7bd12-3fe5-4a1d-ad5f-c702a9c9cba0",
        "address": "saeed ,310 & 311 ,business avenue ,منطقه بور سعيد التجاريه ,19410 ,Dubai",
        "phone": "97148868812",
        "email": "info@saeedalghafri.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5acd50c8-df41-496b-a969-926d40e45c46",
    "firmName": "SAEED ALGHAFRI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04352",
    "licenseIssueDate": "03/13/2019 00:00:00",
    "licenseExpiryDate": "03/11/2021 00:00:00"
  },
  {
    "id": "c0eadf8b-ac4e-4cec-ad15-b32ed392d306",
    "slug": "mahmoud-mostafa",
    "name": "MAHMOUD MOSTAFA AHMED MOSTAFA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mahmoud Mostafa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c0eadf8b-ac4e-4cec-ad15-b32ed392d306",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-01278",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/21/2020 00:00:00"
  },
  {
    "id": "1390665e-be64-4534-85cb-3d4fa03af86c",
    "slug": "mahmoud-refaat-ahmed-elsabbagh",
    "name": "mahmoud refaat ahmed elsabbagh",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/25/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: mahmoud refaat ahmed elsabbagh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1390665e-be64-4534-85cb-3d4fa03af86c",
        "address": "",
        "phone": "97144472020",
        "email": "info@arnadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e6573267-5872-48d8-add1-06a3deccf9e4",
    "firmName": "ABDUL RAHMAN NASEEB ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06946",
    "licenseIssueDate": "08/25/2025 00:00:00",
    "licenseExpiryDate": "08/24/2026 00:00:00"
  },
  {
    "id": "b565f101-f66e-4e0a-8664-b599333f43cc",
    "slug": "mahmoud-samir-nabih-mohamed-eltantawy",
    "name": "Mahmoud Samir Nabih Mohamed Eltantawy",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/17/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mahmoud Samir Nabih Mohamed Eltantawy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b565f101-f66e-4e0a-8664-b599333f43cc",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04524",
    "licenseIssueDate": "10/17/2019 00:00:00",
    "licenseExpiryDate": "10/16/2026 00:00:00"
  },
  {
    "id": "9ee7d599-5b21-433d-bf5a-ff0710766131",
    "slug": "mahmoud-shabban-mohamed-ali",
    "name": "mahmoud shabban mohamed ali",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/22/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: mahmoud shabban mohamed ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9ee7d599-5b21-433d-bf5a-ff0710766131",
        "address": "Nawal Salem Saeed Salem ,508 ,S. I. T Tower ,SILICON OASIS ,0000 ,Dubai",
        "phone": "97145582139 / 971555425608",
        "email": "courts@nslawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8d7ab4a5-3c4d-4fa5-a466-d525e2054af8",
    "firmName": "NAWAL SALEM SAEED ADVOCATES &LEGAL CONSULTANTS",
    "registrationNumber": "L-05725",
    "licenseIssueDate": "02/22/2023 00:00:00",
    "licenseExpiryDate": "02/21/2026 00:00:00"
  },
  {
    "id": "0d681aef-619b-499f-958c-703dc206304d",
    "slug": "mahmoud-wagdy-ibrahim-hamouda-soliman",
    "name": "MAHMOUD WAGDY IBRAHIM HAMOUDA SOLIMAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/13/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MAHMOUD WAGDY IBRAHIM HAMOUDA SOLIMAN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0d681aef-619b-499f-958c-703dc206304d",
        "address": "ISMAIL HASSAN EBRAHIM ALSAFFAR ,الطابق الثامن - مكتب 801 AFR ,الصقر للاعمال ,يوجد اسفل البناية مطعم وينديز ,25752 ,Dubai",
        "phone": "97143276805",
        "email": "info@alsaffar-legal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ceb9cbcf-79f3-462d-afe2-aa4c62eff72b",
    "firmName": "ISMAIL ALSAFFAR ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05030",
    "licenseIssueDate": "09/13/2021 00:00:00",
    "licenseExpiryDate": "09/12/2026 00:00:00"
  },
  {
    "id": "835080ad-ca27-4d97-a349-81f725391214",
    "slug": "mai-mosleh-mohamed-imam",
    "name": "Mai Mosleh Mohamed Imam",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/06/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mai Mosleh Mohamed Imam",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_835080ad-ca27-4d97-a349-81f725391214",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-06797",
    "licenseIssueDate": "05/06/2025 00:00:00",
    "licenseExpiryDate": "05/05/2026 00:00:00"
  },
  {
    "id": "2a196f85-c09b-42a5-b948-1733133aa1f0",
    "slug": "majed-naim",
    "name": "Majed Naim",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/18/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Majed Naim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2a196f85-c09b-42a5-b948-1733133aa1f0",
        "address": "Majed Naim ,5 ,Aspect Tower ,Bay Avenue Mall ,554868 ,Dubai",
        "phone": "97147701106 / 971557665402",
        "email": "communicate@janahilegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "cdefbdd8-ff2a-4404-ab83-1565e2c39e9d",
    "firmName": "NISMA ALJANAHI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03408",
    "licenseIssueDate": "07/18/2016 00:00:00",
    "licenseExpiryDate": "07/14/2026 00:00:00"
  },
  {
    "id": "c1bd4502-f928-4fa6-92fd-6ca40deb79c2",
    "slug": "majid-obaid-saeed-bin-bashir-almheiri",
    "name": "Majid Obaid Saeed Bin Bashir Almheiri",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/03/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Majid Obaid Saeed Bin Bashir Almheiri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c1bd4502-f928-4fa6-92fd-6ca40deb79c2",
        "address": "",
        "phone": "971504514531 / 971504514531",
        "email": "bashirso@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "6ced8db0-e5c9-4227-9e21-ea84258e3de8",
    "firmName": "Bin Bashir Legal Consultants",
    "registrationNumber": "L-05457",
    "licenseIssueDate": "08/03/2022 00:00:00",
    "licenseExpiryDate": "08/02/2026 00:00:00"
  },
  {
    "id": "9449d0d0-fc63-4469-a29a-8b235580163a",
    "slug": "malak-abdel-azim-elmasry",
    "name": "Malak Abdel Azim Elmasry",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Malak Abdel Azim Elmasry",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9449d0d0-fc63-4469-a29a-8b235580163a",
        "address": "",
        "phone": "97142955575",
        "email": "info@yalhamed.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "af6ac730-58a7-44a4-9f60-78811de374c7",
    "firmName": "YASIN ALHAMED ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01279",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "6de1d77e-3cf1-4d4b-9487-9555c348a70a",
    "slug": "malavika-vijayan-thottathil-padmanabhan-nair-vijayan",
    "name": "Malavika Vijayan Thottathil Padmanabhan Nair Vijayan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNVgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/13/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Malavika Vijayan Thottathil Padmanabhan Nair Vijayan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6de1d77e-3cf1-4d4b-9487-9555c348a70a",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-06241",
    "licenseIssueDate": "03/13/2024 00:00:00",
    "licenseExpiryDate": "03/12/2026 00:00:00"
  },
  {
    "id": "11f737ee-17eb-4679-9c46-aa84bdd42306",
    "slug": "malek-al-rifai",
    "name": "Malek Al Rifai",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/14/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Malek Al Rifai",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_11f737ee-17eb-4679-9c46-aa84bdd42306",
        "address": "",
        "phone": "97143779900 / 971508548052",
        "email": "jali@kslaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dff8529a-82be-431a-b72b-0192ff238011",
    "firmName": "King & Spalding LLP",
    "registrationNumber": "L-02793",
    "licenseIssueDate": "12/14/2023 00:00:00",
    "licenseExpiryDate": "12/13/2025 00:00:00"
  },
  {
    "id": "860ae21c-147d-437d-a44f-8c63300e60e6",
    "slug": "mamdouh-mohamed-gamil-mohamed-tawfik",
    "name": "Mamdouh Mohamed Gamil Mohamed Tawfik",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/26/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mamdouh Mohamed Gamil Mohamed Tawfik",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_860ae21c-147d-437d-a44f-8c63300e60e6",
        "address": "Samia Luqman ,2nd floor ,Emarat Atrium Building ,across Holiday Inn Express Safa Park ,7273 ,Dubai",
        "phone": "97143211000",
        "email": "info@alsuwaidi.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0e5c3637-bc12-475c-a6b5-2d9ae84f2b8e",
    "firmName": "AL-SUWAIDI & COMPANY",
    "registrationNumber": "L-06687",
    "licenseIssueDate": "02/26/2025 00:00:00",
    "licenseExpiryDate": "02/25/2026 00:00:00"
  },
  {
    "id": "fc6ff56b-b5f2-411a-9098-6cd8dab7f5de",
    "slug": "mamdouh-rabie-abid",
    "name": "Mamdouh Rabie Abid",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/14/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mamdouh Rabie Abid",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fc6ff56b-b5f2-411a-9098-6cd8dab7f5de",
        "address": "الطابق الخامس ,الساحة ,سوق البحار ,26011 ,Dubai",
        "phone": "97142277717",
        "email": "info@alsahlawico.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a6811a79-5470-4c33-ad95-3ff8f661c052",
    "firmName": "AL SAHLAWI & CO ADVOCATES & CONSULTANTS",
    "registrationNumber": "L-02626",
    "licenseIssueDate": "09/14/2014 00:00:00",
    "licenseExpiryDate": "09/08/2026 00:00:00"
  },
  {
    "id": "cf5a743b-97b5-4c6f-a293-a2b85322ead6",
    "slug": "mamdouh-yousef-aboushama",
    "name": "Mamdouh Yousef Aboushama",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/11/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mamdouh Yousef Aboushama",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cf5a743b-97b5-4c6f-a293-a2b85322ead6",
        "address": "",
        "phone": "97142396646",
        "email": "advo_alblooshi@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3ab5acef-85ac-482b-91f2-4e0a34fd6af7",
    "firmName": "ABDELAZIZ AL BLOUSHI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02182",
    "licenseIssueDate": "03/11/2013 00:00:00",
    "licenseExpiryDate": "03/03/2026 00:00:00"
  },
  {
    "id": "89e05da9-26af-4254-814a-2a1ff434e654",
    "slug": "mamoon-khan",
    "name": "Mamoon Khan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mamoon Khan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_89e05da9-26af-4254-814a-2a1ff434e654",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01280",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "cbae3122-f6c7-43d7-a1d5-d3ff43477ef7",
    "slug": "mamoun-mohammad-abdelrazeq",
    "name": "Ma'moun Mohammad Abdelrazeq",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/22/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ma'moun Mohammad Abdelrazeq",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cbae3122-f6c7-43d7-a1d5-d3ff43477ef7",
        "address": "ABDULLAH AMIN ALZAROONI ,209+210+611+211 ,بزنس افينيو ,خلف وكالة النيسان ,12781 ,Dubai",
        "phone": "97142954299",
        "email": "zaroonilawyers@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "da078082-58a6-4951-b43c-9a5a9bf24934",
    "firmName": "ABDULLA AL ZAROONI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01195",
    "licenseIssueDate": "08/22/2012 00:00:00",
    "licenseExpiryDate": "08/14/2026 00:00:00"
  },
  {
    "id": "86691054-95b6-4845-bb08-63f18a9b5fe5",
    "slug": "mamoun-osman",
    "name": "Mamoun Osman",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/06/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mamoun Osman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_86691054-95b6-4845-bb08-63f18a9b5fe5",
        "address": "",
        "phone": "97143303900 / 971561753537",
        "email": "christopher@afridi-angell.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "30ce50dc-01a6-499d-8ace-3f807ddcb08d",
    "firmName": "Afridi & Angell-DED",
    "registrationNumber": "L-03824",
    "licenseIssueDate": "07/06/2017 00:00:00",
    "licenseExpiryDate": "07/03/2026 00:00:00"
  },
  {
    "id": "3c8a1693-0d95-4b3f-a1e6-a456eada88fb",
    "slug": "man-yin-jacqueline-chu",
    "name": "Man Yin Jacqueline Chu",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/05/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Man Yin Jacqueline Chu",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3c8a1693-0d95-4b3f-a1e6-a456eada88fb",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506688 ,Dubai",
        "phone": "97147096600 / 971503556811",
        "email": "muneer.khan@simmons-simmons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d1725ca7-06ac-41b2-8d7b-a6e60665b73d",
    "firmName": "Simmons & Simmons (Middle East) LLP-DIFC",
    "registrationNumber": "L-06366",
    "licenseIssueDate": "06/05/2024 00:00:00",
    "licenseExpiryDate": "06/04/2026 00:00:00"
  },
  {
    "id": "6c5e247a-27b9-4b4e-bd86-36efef4a794c",
    "slug": "manaf-samih-barakat-khreis",
    "name": "Manaf Samih Barakat Khreis",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/12/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Manaf Samih Barakat Khreis",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6c5e247a-27b9-4b4e-bd86-36efef4a794c",
        "address": "- ,Index Tower ,Dubai International Financial Centre ,9371 ,Dubai",
        "phone": "97143303900 / 971561753537",
        "email": "christopher@afridi-angell.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3e464dc8-b800-4ba2-ad91-24a5f9640fef",
    "firmName": "Afridi & Angell-DIFC",
    "registrationNumber": "L-06370",
    "licenseIssueDate": "06/12/2024 00:00:00",
    "licenseExpiryDate": "06/11/2026 00:00:00"
  },
  {
    "id": "6e620ad6-54a4-4bf5-acc0-19e4244b4e51",
    "slug": "manali-nitin-sangoi",
    "name": "Manali Nitin Sangoi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/01/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-01-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Manali Nitin Sangoi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6e620ad6-54a4-4bf5-acc0-19e4244b4e51",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-05179",
    "licenseIssueDate": "02/01/2022 00:00:00",
    "licenseExpiryDate": "01/31/2026 00:00:00"
  },
  {
    "id": "8e40f7a1-4dd9-4671-8e3d-c1f30842fb9d",
    "slug": "manek-narayan-palekar",
    "name": "Manek Narayan Palekar",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/11/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Manek Narayan Palekar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8e40f7a1-4dd9-4671-8e3d-c1f30842fb9d",
        "address": "6F 603, 605, 7F 704 ,Crystal Tower ,Dubai Mall ,117538 ,Dubai",
        "phone": "97146098700",
        "email": "pro@miolawfirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "417f90a1-03be-4dab-8eea-1bba7e16f536",
    "firmName": "ABU BAKER SALEM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01800",
    "licenseIssueDate": "03/11/2021 00:00:00",
    "licenseExpiryDate": "03/10/2026 00:00:00"
  },
  {
    "id": "0d6b59e7-a3c7-4df4-b87f-5c6296cb01ab",
    "slug": "manik-verma",
    "name": "MANIK VERMA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNVgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/13/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MANIK VERMA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0d6b59e7-a3c7-4df4-b87f-5c6296cb01ab",
        "address": "23 ,Rolex Tower ,Trade Center Second ,116637 ,Dubai",
        "phone": "97144357577 / 971502101003",
        "email": "jasamin.fichte@fichtelegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "77bf4fd2-1cd1-4bda-a0c2-ffcac3980b76",
    "firmName": "Fichte & Co Legal Consultancy",
    "registrationNumber": "L-04212",
    "licenseIssueDate": "03/13/2025 00:00:00",
    "licenseExpiryDate": "03/12/2026 00:00:00"
  },
  {
    "id": "4bbc7563-d0a6-424f-b25c-77edd81ff667",
    "slug": "manish-narayan",
    "name": "Manish Narayan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Manish Narayan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4bbc7563-d0a6-424f-b25c-77edd81ff667",
        "address": "",
        "phone": "97143937700",
        "email": "info@galadarilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d863b662-c864-4193-8b3a-ff6ee5fe6c64",
    "firmName": "GALADARI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01494",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "98ee9ddf-05be-435b-86df-407bf4f59773",
    "slug": "mansor-edress-osman-ebrahim",
    "name": "Mansor Edress Osman Ebrahim",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/21/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mansor Edress Osman Ebrahim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_98ee9ddf-05be-435b-86df-407bf4f59773",
        "address": "mohamed mahmoud mohamed elkormany ,بناية الوصل ,R549 يناية الوصل ,سيتي سنتر ديره ,83620 ,Dubai",
        "phone": "97142542000",
        "email": "info@aaalegalconsultants.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "927c60c9-145e-4bb5-8913-d6d6aa72f891",
    "firmName": "ABDALLA ALNAKHI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05664",
    "licenseIssueDate": "12/21/2022 00:00:00",
    "licenseExpiryDate": "12/20/2025 00:00:00"
  },
  {
    "id": "ebe77e7d-c3df-4c1c-a0f8-37ff91a978aa",
    "slug": "mansor-salem-ahmed-alqaisi",
    "name": "Mansor Salem Ahmed Alqaisi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/22/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mansor Salem Ahmed Alqaisi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ebe77e7d-c3df-4c1c-a0f8-37ff91a978aa",
        "address": "",
        "phone": "97145579711",
        "email": "info@mqadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9f91cca7-a15d-499f-b265-2a032fe38fa1",
    "firmName": "FATMA ALMUTAWA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05733",
    "licenseIssueDate": "02/22/2023 00:00:00",
    "licenseExpiryDate": "02/21/2026 00:00:00"
  },
  {
    "id": "3603be69-b4c3-4954-9866-ff83016ec446",
    "slug": "mansour-ahmed-mansour-ali",
    "name": "Mansour Ahmed Mansour Ali",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/08/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mansour Ahmed Mansour Ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3603be69-b4c3-4954-9866-ff83016ec446",
        "address": "Saif Saeed Rashid Alghubar Alshamsi ,الطابق 3 مكتب E313  ,مكاتب الساحة ب  ,برج خليفة ,20338 ,Dubai",
        "phone": "97144477044 / 971551630600",
        "email": "info@tlg.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "74f923b2-ef17-48a4-9af4-e15ddacb5e0e",
    "firmName": "THE LEGAL GROUP- ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06805",
    "licenseIssueDate": "05/08/2025 00:00:00",
    "licenseExpiryDate": "05/07/2026 00:00:00"
  },
  {
    "id": "147c4fb5-de81-445b-a1db-9f6cba61f18b",
    "slug": "mansour-elaraby",
    "name": "Mansour Elaraby",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/02/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mansour Elaraby",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_147c4fb5-de81-445b-a1db-9f6cba61f18b",
        "address": "",
        "phone": "97144230555 / 971504788443",
        "email": "yah@hfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c462c65e-185a-4e81-8425-a87e3a2b6842",
    "firmName": "Holman Fenwick Willan Middle East LLP",
    "registrationNumber": "L-01114",
    "licenseIssueDate": "08/02/2018 00:00:00",
    "licenseExpiryDate": "07/31/2026 00:00:00"
  },
  {
    "id": "ce634f6d-8192-4e40-9c1c-9c9b531c1913",
    "slug": "manuel-calzada-pla",
    "name": "Manuel Calzada Pla",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/16/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Manuel Calzada Pla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ce634f6d-8192-4e40-9c1c-9c9b531c1913",
        "address": "",
        "phone": "/ 971543665504",
        "email": "MC@ManuelCalzadaLegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "0c02b881-6155-4298-81da-bf9bb6c1a171",
    "firmName": "Manuel Calzada Legal Consultancy FZ LLC",
    "registrationNumber": "L-05975",
    "licenseIssueDate": "08/16/2023 00:00:00",
    "licenseExpiryDate": "08/15/2026 00:00:00"
  },
  {
    "id": "228e0534-f106-4155-9e05-5c78d649c119",
    "slug": "manuela-belmontes",
    "name": "Manuela Belmontes",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Manuela Belmontes",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_228e0534-f106-4155-9e05-5c78d649c119",
        "address": "Level 14 ,Burj Daman ,Four Seasons Hotel ,119980 ,Dubai",
        "phone": "97143604070 / 971502450485",
        "email": "Philip.ireland@maples.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "cb7cc285-8538-469a-b075-ef30819bce69",
    "firmName": "Maples & Calder (Dubai) LLP",
    "registrationNumber": "L-00593",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "7f11c448-7357-4a23-97a7-6175046bf0d2",
    "slug": "maral-nafar",
    "name": "Maral Nafar",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/05/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Maral Nafar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7f11c448-7357-4a23-97a7-6175046bf0d2",
        "address": "6 ,Office Nos. 603, 604 & 605, Level 6, Burj Daman ,Dubai International Financial Centre ,506555 ,Dubai",
        "phone": "97143506400 / 971504654755",
        "email": "r.hickman@aglaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8690f7d5-6b96-4649-9589-71303f2c2707",
    "firmName": "Addleshaw Goddard (Middle East) LLP",
    "registrationNumber": "L-05894",
    "licenseIssueDate": "07/05/2023 00:00:00",
    "licenseExpiryDate": "07/04/2026 00:00:00"
  },
  {
    "id": "0e9b750d-f638-4d73-8b52-0aaf88a78dab",
    "slug": "marc-ghammachi",
    "name": "Marc Ghammachi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/10/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Marc Ghammachi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0e9b750d-f638-4d73-8b52-0aaf88a78dab",
        "address": "",
        "phone": "97144230555 / 971504788443",
        "email": "yah@hfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c462c65e-185a-4e81-8425-a87e3a2b6842",
    "firmName": "Holman Fenwick Willan Middle East LLP",
    "registrationNumber": "L-03491",
    "licenseIssueDate": "10/10/2016 00:00:00",
    "licenseExpiryDate": "10/06/2026 00:00:00"
  },
  {
    "id": "e71173e9-6597-4a66-820d-14dc130c3a70",
    "slug": "marc-massihi",
    "name": "Marc Massihi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/26/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Marc Massihi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e71173e9-6597-4a66-820d-14dc130c3a70",
        "address": "مطعم زعتر وزيت  ,اسبكت تاور  ,فندق تاج  ,118212 ,Dubai",
        "phone": "97144433013 / 97144433013",
        "email": "moaza.alkhadar.alc@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "1dc550f7-81c5-4a5a-9096-682d651b8688",
    "firmName": "MOAZA AL KHADAR ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01888",
    "licenseIssueDate": "09/26/2011 00:00:00",
    "licenseExpiryDate": "09/17/2026 00:00:00"
  },
  {
    "id": "9e72ac0a-dc5c-4d3c-a284-843f11dff178",
    "slug": "marc-norman",
    "name": "Marc Norman",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/16/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Marc Norman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9e72ac0a-dc5c-4d3c-a284-843f11dff178",
        "address": "",
        "phone": "97142472100 / 971509224336",
        "email": "bhaley@cov.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "65a2e90a-6978-4292-b3f1-ecbebedd7b9a",
    "firmName": "Covington & Burling LLP (Middle East)",
    "registrationNumber": "L-00857",
    "licenseIssueDate": "12/16/2011 00:00:00",
    "licenseExpiryDate": "12/07/2025 00:00:00"
  },
  {
    "id": "0253659f-ea0f-4c55-a8ee-3ce99373fa37",
    "slug": "marcin-mikolaj-zawadzki",
    "name": "Marcin Mikolaj Zawadzki",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/05/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Marcin Mikolaj Zawadzki",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0253659f-ea0f-4c55-a8ee-3ce99373fa37",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-04037",
    "licenseIssueDate": "08/05/2021 00:00:00",
    "licenseExpiryDate": "08/04/2026 00:00:00"
  },
  {
    "id": "bc1a4dfd-e28d-4914-afbf-7e6e9bddfc6a",
    "slug": "marco-de-leo",
    "name": "Marco De Leo",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/04/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Marco De Leo",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bc1a4dfd-e28d-4914-afbf-7e6e9bddfc6a",
        "address": "NA ,Index tower ,NA ,506828 ,Dubai",
        "phone": "97154228569 / 971525567076",
        "email": "silviaelba.sartori@belex.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "f77150e9-6cee-4d5e-9619-7fa5f488aee3",
    "firmName": "BonelliErede Middle East LLP",
    "registrationNumber": "L-04146",
    "licenseIssueDate": "12/04/2017 00:00:00",
    "licenseExpiryDate": "12/01/2025 00:00:00"
  },
  {
    "id": "53f9cba5-e66a-4e97-88b0-433572ca1aae",
    "slug": "marcos-andrew-spanos",
    "name": "Marcos Andrew Spanos",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/01/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Marcos Andrew Spanos",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_53f9cba5-e66a-4e97-88b0-433572ca1aae",
        "address": "Al Fattan Currency House Tower 2 ,DIFC ,507176 ,",
        "phone": "/ 971552009003",
        "email": "Mohammad.AlRasheed@bakermckenzie.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "acd81e81-dead-4f7c-839e-0f2a57897265",
    "firmName": "Baker & Mckenzie LLP",
    "registrationNumber": "L-03887",
    "licenseIssueDate": "11/01/2017 00:00:00",
    "licenseExpiryDate": "10/29/2025 00:00:00"
  },
  {
    "id": "8d2b9475-80bc-4091-8a49-b88eefa855ac",
    "slug": "marcus-ashley-william-booth",
    "name": "Marcus Ashley William Booth",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/06/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Marcus Ashley William Booth",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8d2b9475-80bc-4091-8a49-b88eefa855ac",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-01793",
    "licenseIssueDate": "12/06/2018 00:00:00",
    "licenseExpiryDate": "12/04/2025 00:00:00"
  },
  {
    "id": "fa01bccb-1926-44c7-bb57-e81e3fe86af5",
    "slug": "maria-abdelsalam-elhag",
    "name": "Maria Abdelsalam Elhag",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/09/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Maria Abdelsalam Elhag",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fa01bccb-1926-44c7-bb57-e81e3fe86af5",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-04708",
    "licenseIssueDate": "07/09/2020 00:00:00",
    "licenseExpiryDate": "07/08/2026 00:00:00"
  },
  {
    "id": "b32a05bd-c333-41e2-9a4a-083a92f9d971",
    "slug": "maria-andraos",
    "name": "Maria Andraos",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/09/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Maria Andraos",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b32a05bd-c333-41e2-9a4a-083a92f9d971",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-05010",
    "licenseIssueDate": "08/09/2021 00:00:00",
    "licenseExpiryDate": "08/08/2026 00:00:00"
  },
  {
    "id": "e404a652-094a-405a-9d5e-3fecf40cfc0b",
    "slug": "maria-elena-anastasia-ooiejvaar",
    "name": "Maria Elena Anastasia Ooiejvaar",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/03/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Maria Elena Anastasia Ooiejvaar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e404a652-094a-405a-9d5e-3fecf40cfc0b",
        "address": "",
        "phone": "97143742800 / 971506450677",
        "email": "jabbott21@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7a59d310-ff72-4318-b41c-27095c163d0f",
    "firmName": "CMS (UAE) LLP",
    "registrationNumber": "L-04516",
    "licenseIssueDate": "10/03/2019 00:00:00",
    "licenseExpiryDate": "10/02/2026 00:00:00"
  },
  {
    "id": "e1431cb1-050e-40cd-8e97-1f4abca40ca7",
    "slug": "maria-laura-voda",
    "name": "Maria Laura Voda",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/22/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Maria Laura Voda",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e1431cb1-050e-40cd-8e97-1f4abca40ca7",
        "address": "23 ,Rolex Tower ,Trade Center Second ,116637 ,Dubai",
        "phone": "97144357577 / 971502101003",
        "email": "jasamin.fichte@fichtelegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "77bf4fd2-1cd1-4bda-a0c2-ffcac3980b76",
    "firmName": "Fichte & Co Legal Consultancy",
    "registrationNumber": "L-02032",
    "licenseIssueDate": "06/22/2020 00:00:00",
    "licenseExpiryDate": "06/21/2026 00:00:00"
  },
  {
    "id": "1af41cc0-2520-4b0f-9fa6-9f239bb21ba7",
    "slug": "maria-margaretha-du-toit",
    "name": "MARIA MARGARETHA DU TOIT",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/07/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2023-06-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Maria Margaretha Du Toit",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1af41cc0-2520-4b0f-9fa6-9f239bb21ba7",
        "address": "sohail jassem pararin ,34 ,Central Park Tower ,Dubai Mall ,233066 ,Dubai",
        "phone": "97144228410",
        "email": "info@mahmoodhussain.net",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "f3309481-3edd-4503-92d2-bd9f71ba513a",
    "firmName": "MAHMOOD HUSSAIN ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-05616",
    "licenseIssueDate": "12/07/2022 00:00:00",
    "licenseExpiryDate": "12/06/2023 00:00:00"
  },
  {
    "id": "4093ad5a-36f1-40ee-b25b-380380cfe084",
    "slug": "maria-mazin-kh-manna",
    "name": "Maria Mazin Kh Manna",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/09/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Maria Mazin Kh Manna",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4093ad5a-36f1-40ee-b25b-380380cfe084",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-06540",
    "licenseIssueDate": "10/09/2024 00:00:00",
    "licenseExpiryDate": "10/08/2026 00:00:00"
  },
  {
    "id": "c4ba9173-a5b0-4d90-8ff0-42abb65dfeea",
    "slug": "maria-ongoren",
    "name": "Maria Ongoren",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/22/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Maria Ongoren",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c4ba9173-a5b0-4d90-8ff0-42abb65dfeea",
        "address": "",
        "phone": "97143826100 / 971507380618",
        "email": "jmiocevic@curtis.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0867bcc5-10fa-4783-91ae-b8f63e02e81a",
    "firmName": "Curtis Mallet-Prevost, Colt & Mosle LLP",
    "registrationNumber": "L-06660",
    "licenseIssueDate": "01/22/2025 00:00:00",
    "licenseExpiryDate": "01/21/2026 00:00:00"
  },
  {
    "id": "6a4e62df-7b4f-4566-8945-2ec9ff82b09f",
    "slug": "maria-palmou",
    "name": "Maria Palmou",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/11/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Maria Palmou",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6a4e62df-7b4f-4566-8945-2ec9ff82b09f",
        "address": "",
        "phone": "97143303900 / 971561753537",
        "email": "christopher@afridi-angell.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "30ce50dc-01a6-499d-8ace-3f807ddcb08d",
    "firmName": "Afridi & Angell-DED",
    "registrationNumber": "L-03073",
    "licenseIssueDate": "07/11/2015 00:00:00",
    "licenseExpiryDate": "07/06/2026 00:00:00"
  },
  {
    "id": "5e66963e-8d67-48f0-b521-238abc70ca54",
    "slug": "maria-susan-john",
    "name": "Maria Susan John",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/14/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Maria Susan John",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5e66963e-8d67-48f0-b521-238abc70ca54",
        "address": "",
        "phone": "97143093222 / 971566651954",
        "email": "melissa.murray@twobirds.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3e1526e6-4c8d-4b6f-985f-ea05e9f99bcb",
    "firmName": "Bird & Bird (MEA) LLP",
    "registrationNumber": "L-06547",
    "licenseIssueDate": "10/14/2024 00:00:00",
    "licenseExpiryDate": "10/13/2026 00:00:00"
  },
  {
    "id": "36985d54-ec9e-4024-af0c-a7e8ac863589",
    "slug": "maria-zerkalova",
    "name": "Maria Zerkalova",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNWgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/30/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Maria Zerkalova",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_36985d54-ec9e-4024-af0c-a7e8ac863589",
        "address": "",
        "phone": "97144286300 / 971506256686",
        "email": "stuart.paterson@hsf.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2f0389b3-bfde-44f4-bdd6-6e1a22f9cab2",
    "firmName": "Herbert Smith Freehills Kramer LLP",
    "registrationNumber": "L-05626",
    "licenseIssueDate": "11/30/2022 00:00:00",
    "licenseExpiryDate": "11/29/2025 00:00:00"
  },
  {
    "id": "7c9ff22d-4dfe-4e44-abec-1d64782e7efe",
    "slug": "mariam-al-mashedadani",
    "name": "Mariam Al Mashedadani",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/21/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mariam Al Mashedadani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7c9ff22d-4dfe-4e44-abec-1d64782e7efe",
        "address": "20 ,Index Tower West Tower ,DIFC ,507226 ,Dubai",
        "phone": "97142461900 / 971523391604",
        "email": "patrick.gearon@crsblaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e2ac552e-b9a7-450b-a84d-15119e583220",
    "firmName": "Charles Russell Speechlys LLP",
    "registrationNumber": "L-06464",
    "licenseIssueDate": "08/21/2024 00:00:00",
    "licenseExpiryDate": "08/20/2026 00:00:00"
  },
  {
    "id": "9006c722-6d3e-419c-84a2-728a0fc41e30",
    "slug": "mariam-jaber",
    "name": "Mariam Jaber",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/07/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-06-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mariam Jaber",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9006c722-6d3e-419c-84a2-728a0fc41e30",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-06640",
    "licenseIssueDate": "01/07/2025 00:00:00",
    "licenseExpiryDate": "01/06/2026 00:00:00"
  },
  {
    "id": "e5656e14-88f1-49a0-b094-1d5dca4b2b03",
    "slug": "mariam-mohamed-sabet",
    "name": "Mariam Mohamed Sabet",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mariam Mohamed Sabet",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e5656e14-88f1-49a0-b094-1d5dca4b2b03",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01283",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "01bf9d86-c1cf-4db9-977e-457221a07ecf",
    "slug": "marian-farid-fayek-fared",
    "name": "Marian Farid Fayek Fared",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/01/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Marian Farid Fayek Fared",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_01bf9d86-c1cf-4db9-977e-457221a07ecf",
        "address": "Level 17, ICD Brookfield Place ,DIFC ,506503 ,",
        "phone": "97144375100 / 971588271196",
        "email": "libby.edwards-smith@gowlingwlg.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "436703ba-b9c0-4dcb-93b2-1299c7a051f4",
    "firmName": "Gowling WLG (UK) LLP (Dubai Branch)",
    "registrationNumber": "L-05098",
    "licenseIssueDate": "11/01/2021 00:00:00",
    "licenseExpiryDate": "10/31/2026 00:00:00"
  },
  {
    "id": "730b26d2-ac75-4054-ba73-e785ff94371a",
    "slug": "mariana-valentina-moncada-rodriguez",
    "name": "MARIANA VALENTINA MONCADA RODRIGUEZ",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNVgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/29/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MARIANA VALENTINA MONCADA RODRIGUEZ",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_730b26d2-ac75-4054-ba73-e785ff94371a",
        "address": "",
        "phone": "97144323671 / 971505589395",
        "email": "fba@amereller.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a139ca64-8897-4d1d-8d71-97446bc1e15a",
    "firmName": "Amereller Legal Consultancy LLC SOC",
    "registrationNumber": "L-06846",
    "licenseIssueDate": "05/29/2025 00:00:00",
    "licenseExpiryDate": "05/28/2026 00:00:00"
  },
  {
    "id": "0b9fa509-5888-436c-9874-11245419aee4",
    "slug": "marie-borye",
    "name": "Marie Borye",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/08/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Marie Borye",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0b9fa509-5888-436c-9874-11245419aee4",
        "address": "Index Tower ,506548 ,Dubai",
        "phone": "97147096300 / 971506767433",
        "email": "amateen@reedsmith.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b3f87e90-7ce9-4097-82c4-15232365f175",
    "firmName": "Reed Smith LLP",
    "registrationNumber": "L-01002",
    "licenseIssueDate": "09/08/2011 00:00:00",
    "licenseExpiryDate": "08/30/2026 00:00:00"
  },
  {
    "id": "4d6c5bac-97a3-4856-bf2c-8b7614f4c631",
    "slug": "marie-nuri-chowdhry",
    "name": "MARIE NURI CHOWDHRY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/18/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MARIE NURI CHOWDHRY",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4d6c5bac-97a3-4856-bf2c-8b7614f4c631",
        "address": "THE OFFICES 1 ,DWTC ,115580 ,",
        "phone": "97143739700 / 971501148248",
        "email": "nitesh.pradhan@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "361fdc64-6b6f-4f37-abca-c52af8473b84",
    "firmName": "Pinsent Masons  LLP (DWTCA Branch)",
    "registrationNumber": "L-04235",
    "licenseIssueDate": "02/18/2025 00:00:00",
    "licenseExpiryDate": "02/17/2026 00:00:00"
  },
  {
    "id": "23ac06e3-8733-45e1-ac53-36c0d9d73471",
    "slug": "marie-sophie-bandeira-vieira",
    "name": "Marie Sophie Bandeira Vieira",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/05/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Marie Sophie Bandeira Vieira",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_23ac06e3-8733-45e1-ac53-36c0d9d73471",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-05477",
    "licenseIssueDate": "10/05/2022 00:00:00",
    "licenseExpiryDate": "10/04/2026 00:00:00"
  },
  {
    "id": "7b64bc9c-0b10-41ae-8dd7-08c6fe0e8664",
    "slug": "marie-eliane-wakil",
    "name": "Marie-Eliane Wakil",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/05/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Marie-Eliane Wakil",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7b64bc9c-0b10-41ae-8dd7-08c6fe0e8664",
        "address": "- ,THE OFFICES 1 ,DWTC ,115580 ,Dubai",
        "phone": "97143739700 / 971562196031",
        "email": "catherine.workman@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6b4ebb23-ef2e-4305-a1ee-43a11e4b1cae",
    "firmName": "Pinsent Masons LLP - Dubai Branch",
    "registrationNumber": "L-04052",
    "licenseIssueDate": "04/05/2018 00:00:00",
    "licenseExpiryDate": "04/02/2026 00:00:00"
  },
  {
    "id": "3d5b231a-05a1-4035-ac1d-0100183f3c34",
    "slug": "mariela-ventsislavova-petsova",
    "name": "Mariela Ventsislavova Petsova",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNVgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/29/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-01-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mariela Ventsislavova Petsova",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3d5b231a-05a1-4035-ac1d-0100183f3c34",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506688 ,Dubai",
        "phone": "97147096600 / 971503556811",
        "email": "muneer.khan@simmons-simmons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d1725ca7-06ac-41b2-8d7b-a6e60665b73d",
    "firmName": "Simmons & Simmons (Middle East) LLP-DIFC",
    "registrationNumber": "L-06611",
    "licenseIssueDate": "11/27/2024 00:00:00",
    "licenseExpiryDate": "11/26/2025 00:00:00"
  },
  {
    "id": "58bef626-d719-4d5c-87b2-e3f6df3adc5a",
    "slug": "marija-lezala",
    "name": "Marija Lezala",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/28/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Marija Lezala",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_58bef626-d719-4d5c-87b2-e3f6df3adc5a",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-03156",
    "licenseIssueDate": "06/28/2015 00:00:00",
    "licenseExpiryDate": "06/23/2026 00:00:00"
  },
  {
    "id": "9c6bfb75-7855-46ee-864d-56bc39688593",
    "slug": "marilyn-belinda-acquah",
    "name": "Marilyn Belinda Acquah",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/25/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Marilyn Belinda Acquah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9c6bfb75-7855-46ee-864d-56bc39688593",
        "address": "Al Fattan Currency House Tower 2 ,DIFC ,507176 ,",
        "phone": "/ 971552009003",
        "email": "Mohammad.AlRasheed@bakermckenzie.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "acd81e81-dead-4f7c-839e-0f2a57897265",
    "firmName": "Baker & Mckenzie LLP",
    "registrationNumber": "L-06515",
    "licenseIssueDate": "09/25/2024 00:00:00",
    "licenseExpiryDate": "09/24/2026 00:00:00"
  },
  {
    "id": "e8651894-aea9-4470-ac49-1eb68f1cf0f9",
    "slug": "marina-fox",
    "name": "Marina Fox",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/07/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Marina Fox",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e8651894-aea9-4470-ac49-1eb68f1cf0f9",
        "address": "",
        "phone": "97144312968 / 971505588607",
        "email": "mail@marinafox.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "2670beb4-7797-49f9-be6b-fab06a95fa93",
    "firmName": "Marina Fox Legal Consultancy",
    "registrationNumber": "L-00597",
    "licenseIssueDate": "10/07/2011 00:00:00",
    "licenseExpiryDate": "09/28/2026 00:00:00"
  },
  {
    "id": "de438d8f-ad16-4db3-906a-43f77670634a",
    "slug": "marina-moskaleva",
    "name": "Marina Moskaleva",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/31/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-01-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Marina Moskaleva",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_de438d8f-ad16-4db3-906a-43f77670634a",
        "address": "ABDELAZIZ MOHAMED ABDELGHANI AL KHAMIRI AL ALI ,3 ,DUBAI SUPREME COURT COMPLEX ,DUBAI COURT ,128334 ,Dubai",
        "phone": "97145519341 / 971505788557",
        "email": "info@raalc.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "73e54a15-f797-4e91-a501-ef988d8f8bf8",
    "firmName": "ABDELAZIZ AL KHAMIRI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06189",
    "licenseIssueDate": "01/31/2024 00:00:00",
    "licenseExpiryDate": "01/30/2026 00:00:00"
  },
  {
    "id": "3054c1fa-f8ee-40b4-a628-2ba27ebe036e",
    "slug": "marina-walid-el-hachem",
    "name": "Marina Walid El Hachem",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/17/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Marina Walid El Hachem",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3054c1fa-f8ee-40b4-a628-2ba27ebe036e",
        "address": "",
        "phone": "97143685555",
        "email": "maisa.maarouf@bsabh.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8afa232f-52ff-4dad-82c3-9a04d66eb853",
    "firmName": "B S A AHMED BIN HAZEEM & ASSOCIATES LLP - DIFC",
    "registrationNumber": "L-05335",
    "licenseIssueDate": "05/17/2022 00:00:00",
    "licenseExpiryDate": "05/16/2026 00:00:00"
  },
  {
    "id": "d77c66a0-ff38-46e3-a90f-792f292c386a",
    "slug": "marion-carles-salmon",
    "name": "Marion Carles Salmon",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/07/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-07-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Marion Carles Salmon",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d77c66a0-ff38-46e3-a90f-792f292c386a",
        "address": "ali mohamed amin  ,205 - 104  ,اثراء  ,بالقرب من فندق جميرا طيران الامارات  ,10155 ,Dubai",
        "phone": "97143967188",
        "email": "aliadvocates71@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "298ff405-ca8b-4fc8-a674-74ae24832268",
    "firmName": "ALI NAQI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04165",
    "licenseIssueDate": "07/17/2018 00:00:00",
    "licenseExpiryDate": "07/16/2019 00:00:00"
  },
  {
    "id": "d2c68613-fe0e-4bd2-a303-1672ae7e236c",
    "slug": "marion-corinne-genova",
    "name": "Marion Corinne Genova",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/06/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Marion Corinne Genova",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d2c68613-fe0e-4bd2-a303-1672ae7e236c",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-06093",
    "licenseIssueDate": "12/06/2023 00:00:00",
    "licenseExpiryDate": "12/05/2025 00:00:00"
  },
  {
    "id": "50060071-e448-4aa3-b6dc-32831e92fca9",
    "slug": "marion-pearl-mahaga",
    "name": "Marion Pearl Mahaga",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/15/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Marion Pearl Mahaga",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_50060071-e448-4aa3-b6dc-32831e92fca9",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-05243",
    "licenseIssueDate": "03/15/2022 00:00:00",
    "licenseExpiryDate": "03/14/2026 00:00:00"
  },
  {
    "id": "8c55a34b-bb53-4b0b-bedb-7d8830a1afed",
    "slug": "marius-fritz",
    "name": "Marius Fritz",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/12/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Marius Fritz",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8c55a34b-bb53-4b0b-bedb-7d8830a1afed",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-06390",
    "licenseIssueDate": "07/12/2024 00:00:00",
    "licenseExpiryDate": "07/11/2026 00:00:00"
  },
  {
    "id": "98d98ae7-31c3-4781-85bd-b62945d8adb5",
    "slug": "mark-adams",
    "name": "Mark Adams",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/22/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mark Adams",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_98d98ae7-31c3-4781-85bd-b62945d8adb5",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-06662",
    "licenseIssueDate": "01/22/2025 00:00:00",
    "licenseExpiryDate": "01/21/2026 00:00:00"
  },
  {
    "id": "e7ec7086-ae35-438e-ad41-68e43858e7bc",
    "slug": "mark-beswetherick",
    "name": "Mark Beswetherick",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/11/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mark Beswetherick",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e7ec7086-ae35-438e-ad41-68e43858e7bc",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-00299",
    "licenseIssueDate": "10/11/2011 00:00:00",
    "licenseExpiryDate": "10/02/2026 00:00:00"
  },
  {
    "id": "2858eebf-9de5-4ee2-b576-c9718086e28c",
    "slug": "mark-bisch",
    "name": "Mark Bisch",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mark Bisch",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2858eebf-9de5-4ee2-b576-c9718086e28c",
        "address": "",
        "phone": "97144363636 / 971505572900",
        "email": "hassan.elsayed@bakerbotts.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "fd5d6571-d053-4436-9de5-c8a36ce7c6c9",
    "firmName": "Baker Botts LLP Legal Consultants Dubai Branch",
    "registrationNumber": "L-00737",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "ef197347-80b8-4903-ba78-8916e61b8862",
    "slug": "mark-blanksby",
    "name": "Mark Blanksby",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/11/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mark Blanksby",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ef197347-80b8-4903-ba78-8916e61b8862",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-00300",
    "licenseIssueDate": "10/11/2011 00:00:00",
    "licenseExpiryDate": "10/02/2026 00:00:00"
  },
  {
    "id": "811589d3-cdd3-4f6d-b07d-6dd122dad702",
    "slug": "mark-brown",
    "name": "Mark Brown",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/11/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mark Brown",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_811589d3-cdd3-4f6d-b07d-6dd122dad702",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01335",
    "licenseIssueDate": "04/11/2013 00:00:00",
    "licenseExpiryDate": "04/03/2026 00:00:00"
  },
  {
    "id": "9734d476-25cb-4020-a67d-19189d44e9ef",
    "slug": "mark-craig-tedeschi",
    "name": "Mark Craig Tedeschi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/19/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mark Craig Tedeschi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9734d476-25cb-4020-a67d-19189d44e9ef",
        "address": "Al Fattan Currency House Tower 2 ,DIFC ,507176 ,",
        "phone": "/ 971552009003",
        "email": "Mohammad.AlRasheed@bakermckenzie.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "acd81e81-dead-4f7c-839e-0f2a57897265",
    "firmName": "Baker & Mckenzie LLP",
    "registrationNumber": "L-05905",
    "licenseIssueDate": "07/19/2023 00:00:00",
    "licenseExpiryDate": "07/18/2026 00:00:00"
  },
  {
    "id": "1e0fa5e3-4623-4564-a8e5-a9aa2652881c",
    "slug": "mark-james-otoole",
    "name": "Mark James Otoole",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/09/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mark James Otoole",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1e0fa5e3-4623-4564-a8e5-a9aa2652881c",
        "address": "Level 41, Emirates Towers ,Sheykh Zayed Road, World Trade Center, DIFC ,31303 ,",
        "phone": "97143827717 / 971585956361",
        "email": "hugh.fraser@hfi-consulting.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9acfebc7-35ab-48b8-94cf-e2dc19cd54c6",
    "firmName": "Hugh Fraser International Legal Consultancy",
    "registrationNumber": "L-06736",
    "licenseIssueDate": "04/09/2025 00:00:00",
    "licenseExpiryDate": "04/08/2026 00:00:00"
  },
  {
    "id": "8a68614b-868d-4f03-bdf3-1b9d025ebe66",
    "slug": "mark-lakin",
    "name": "Mark Lakin",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/23/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mark Lakin",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8a68614b-868d-4f03-bdf3-1b9d025ebe66",
        "address": "",
        "phone": "97144073901 / 971503479508",
        "email": "Rania.Tadros@stephensonharwood.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dd5042a2-bb41-4123-9544-79c3fa831332",
    "firmName": "Stephenson Harwood (Middle East) LLP",
    "registrationNumber": "L-03699",
    "licenseIssueDate": "03/23/2017 00:00:00",
    "licenseExpiryDate": "03/19/2026 00:00:00"
  },
  {
    "id": "98d38877-e7af-4d45-8696-c5d445ab46d8",
    "slug": "mark-milad-yacoub-hanallah",
    "name": "Mark milad yacoub hanallah",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/11/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mark milad yacoub hanallah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_98d38877-e7af-4d45-8696-c5d445ab46d8",
        "address": "othman almarzooqi ,19th ,single business tower ,samaya tower ,114333 ,Dubai",
        "phone": "97142999970 / 971500000000",
        "email": "info@othmanadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a0cdd94d-cc5a-4617-b6a3-b23deb9852d5",
    "firmName": "OTHMAN ALMARZOOQI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06862",
    "licenseIssueDate": "06/11/2025 00:00:00",
    "licenseExpiryDate": "06/10/2026 00:00:00"
  },
  {
    "id": "5944a371-cb86-4f93-9be7-cd7b36b292d0",
    "slug": "mark-raymont",
    "name": "Mark Raymont",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mark Raymont",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5944a371-cb86-4f93-9be7-cd7b36b292d0",
        "address": "- ,THE OFFICES 1 ,DWTC ,115580 ,Dubai",
        "phone": "97143739700 / 971562196031",
        "email": "catherine.workman@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6b4ebb23-ef2e-4305-a1ee-43a11e4b1cae",
    "firmName": "Pinsent Masons LLP - Dubai Branch",
    "registrationNumber": "L-00913",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "65e848df-473e-463f-a198-b1dbc3497d88",
    "slug": "mark-vincent-tiggeman",
    "name": "Mark Vincent Tiggeman",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNVgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/27/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mark Vincent Tiggeman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_65e848df-473e-463f-a198-b1dbc3497d88",
        "address": "Burj Daman ,Dubai International Financial Center ,213241 ,",
        "phone": "97144549586 / 971564189768",
        "email": "darrenaharris123@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3cb06a05-1ad1-4487-9624-c2b716bfd2a7",
    "firmName": "Gateley UK LLP",
    "registrationNumber": "L-05407",
    "licenseIssueDate": "07/27/2022 00:00:00",
    "licenseExpiryDate": "07/26/2026 00:00:00"
  },
  {
    "id": "be0cbb3c-020f-4408-8aa9-7eb83aa3c0f4",
    "slug": "mark-wilson",
    "name": "Mark Wilson",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mark Wilson",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_be0cbb3c-020f-4408-8aa9-7eb83aa3c0f4",
        "address": "Building 5 ,Dubai World Trade Centre ,212620 ,",
        "phone": "97143503600 / 971563631562",
        "email": "p.ellingham@kennedys-law.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "83d3ede1-3a28-4b03-8c92-6bd31a1cb95e",
    "firmName": "Kennedys Dubai LLP",
    "registrationNumber": "L-00746",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "68e9b416-7fbf-4b74-b366-817a7d667e77",
    "slug": "marko-andreja-stamenkovic",
    "name": "Marko Andreja Stamenkovic",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/24/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Marko Andreja Stamenkovic",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_68e9b416-7fbf-4b74-b366-817a7d667e77",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-05808",
    "licenseIssueDate": "05/24/2023 00:00:00",
    "licenseExpiryDate": "05/23/2026 00:00:00"
  },
  {
    "id": "2079a1c7-680a-449c-a898-0a237005fdc3",
    "slug": "marlize-danielle-dumas",
    "name": "Marlize Danielle Dumas",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/18/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Marlize Danielle Dumas",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2079a1c7-680a-449c-a898-0a237005fdc3",
        "address": "Al Fattan Currency House Tower 2 ,DIFC ,507176 ,",
        "phone": "/ 971552009003",
        "email": "Mohammad.AlRasheed@bakermckenzie.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "acd81e81-dead-4f7c-839e-0f2a57897265",
    "firmName": "Baker & Mckenzie LLP",
    "registrationNumber": "L-05405",
    "licenseIssueDate": "07/18/2022 00:00:00",
    "licenseExpiryDate": "07/17/2026 00:00:00"
  },
  {
    "id": "4718ff0c-981d-4c44-baad-2efac3525022",
    "slug": "maroun-charles-abou-harb",
    "name": "Maroun Charles Abou Harb",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/08/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Maroun Charles Abou Harb",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4718ff0c-981d-4c44-baad-2efac3525022",
        "address": "",
        "phone": "97143685555",
        "email": "maisa.maarouf@bsabh.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8afa232f-52ff-4dad-82c3-9a04d66eb853",
    "firmName": "B S A AHMED BIN HAZEEM & ASSOCIATES LLP - DIFC",
    "registrationNumber": "L-05941",
    "licenseIssueDate": "08/08/2023 00:00:00",
    "licenseExpiryDate": "08/07/2026 00:00:00"
  },
  {
    "id": "b7165534-0f7a-465e-bbbd-a1def3eececd",
    "slug": "maroun-hannah-nasr",
    "name": "Maroun Hannah Nasr",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Maroun Hannah Nasr",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b7165534-0f7a-465e-bbbd-a1def3eececd",
        "address": "",
        "phone": "97142211313",
        "email": "info@daralhuqooq.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a35adad8-13e3-467b-8652-912b433c3fa4",
    "firmName": "DAR AL HUQOOQ LEGAL CONSULTANTS",
    "registrationNumber": "L-01567",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "84e7b748-6e56-4572-9675-961cb8558e4e",
    "slug": "maroun-louis-el-hachem",
    "name": "Maroun Louis El Hachem",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/16/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Maroun Louis El Hachem",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_84e7b748-6e56-4572-9675-961cb8558e4e",
        "address": "ICD-Brookfield Place ,DIFC ,119974 ,",
        "phone": "97143652000",
        "email": "david.charlier@ashurst.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c01c3c61-4d90-4058-8429-61dd01e615f5",
    "firmName": "Ashurst LLP-DIFC",
    "registrationNumber": "L-06220",
    "licenseIssueDate": "02/16/2024 00:00:00",
    "licenseExpiryDate": "02/15/2026 00:00:00"
  },
  {
    "id": "020487a1-86e2-4eff-b4ec-cb1673538d67",
    "slug": "marta-gabriela-chimanlal-de-almeida",
    "name": "Marta Gabriela Chimanlal De Almeida",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/31/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Marta Gabriela Chimanlal De Almeida",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_020487a1-86e2-4eff-b4ec-cb1673538d67",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-06182",
    "licenseIssueDate": "01/31/2024 00:00:00",
    "licenseExpiryDate": "01/30/2026 00:00:00"
  },
  {
    "id": "2c43095d-51f3-4b75-b26b-c686e07b438d",
    "slug": "marta-zieba",
    "name": "Marta Zieba",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNWgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/31/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Marta Zieba",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2c43095d-51f3-4b75-b26b-c686e07b438d",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-06335",
    "licenseIssueDate": "05/31/2024 00:00:00",
    "licenseExpiryDate": "05/30/2026 00:00:00"
  },
  {
    "id": "750a7f0b-45a4-4ae6-b2ce-21176c6468f2",
    "slug": "martin-amison",
    "name": "Martin Amison",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/08/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Martin Amison",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_750a7f0b-45a4-4ae6-b2ce-21176c6468f2",
        "address": "",
        "phone": "97143025100 / 971501501837",
        "email": "ccairns@trowers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "976857f5-9092-43cf-987d-bfa794a3fa51",
    "firmName": "Trowers & Hamlins LLP",
    "registrationNumber": "L-02956",
    "licenseIssueDate": "04/08/2015 00:00:00",
    "licenseExpiryDate": "04/02/2026 00:00:00"
  },
  {
    "id": "acae6d16-8e83-45af-b484-7adf79068d48",
    "slug": "martin-khoshdel",
    "name": "Martin Khoshdel",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/09/2023",
    "licenseStatus": "active",
    "licenseExpiry": "2024-09-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Martin Khoshdel",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_acae6d16-8e83-45af-b484-7adf79068d48",
        "address": "",
        "phone": "97143685555",
        "email": "maisa.maarouf@bsabh.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8afa232f-52ff-4dad-82c3-9a04d66eb853",
    "firmName": "B S A AHMED BIN HAZEEM & ASSOCIATES LLP - DIFC",
    "registrationNumber": "L-05263",
    "licenseIssueDate": "09/26/2023 00:00:00",
    "licenseExpiryDate": "09/25/2026 00:00:00"
  },
  {
    "id": "17290d88-dbdb-483a-88d1-0274efb076ca",
    "slug": "martin-richard-hayward",
    "name": "MARTIN RICHARD HAYWARD",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/10/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-08-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MARTIN RICHARD HAYWARD",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_17290d88-dbdb-483a-88d1-0274efb076ca",
        "address": "THE OFFICES 1 ,DWTC ,115580 ,",
        "phone": "97143739700 / 971501148248",
        "email": "nitesh.pradhan@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "361fdc64-6b6f-4f37-abca-c52af8473b84",
    "firmName": "Pinsent Masons  LLP (DWTCA Branch)",
    "registrationNumber": "L-04291",
    "licenseIssueDate": "01/10/2019 00:00:00",
    "licenseExpiryDate": "01/08/2026 00:00:00"
  },
  {
    "id": "ba922a5d-6db5-43f4-9e87-4053b63b0485",
    "slug": "marua-el-hatch",
    "name": "Marua El Hatch",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/16/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Marua El Hatch",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ba922a5d-6db5-43f4-9e87-4053b63b0485",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-05593",
    "licenseIssueDate": "11/16/2022 00:00:00",
    "licenseExpiryDate": "11/15/2025 00:00:00"
  },
  {
    "id": "3f2a15e4-5465-4c41-9214-af61e15b5962",
    "slug": "marwan-abdelhamid-awad",
    "name": "Marwan Abdelhamid Awad",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/29/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Marwan Abdelhamid Awad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3f2a15e4-5465-4c41-9214-af61e15b5962",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-02086",
    "licenseIssueDate": "11/29/2011 00:00:00",
    "licenseExpiryDate": "11/20/2025 00:00:00"
  },
  {
    "id": "0b980c8c-acd1-412c-953e-6044fc603bb4",
    "slug": "marwan-elaraby",
    "name": "Marwan Elaraby",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/20/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Marwan Elaraby",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0b980c8c-acd1-412c-953e-6044fc603bb4",
        "address": "",
        "phone": "97143184600 / 971504468184",
        "email": "melaraby@gibsondunn.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "c9d2c9d0-6e43-4253-a75d-cdeb400f8d8e",
    "firmName": "Gibson Dunn & Crutcher LLP",
    "registrationNumber": "L-03392",
    "licenseIssueDate": "06/20/2016 00:00:00",
    "licenseExpiryDate": "06/16/2026 00:00:00"
  },
  {
    "id": "b0fbe106-8f2a-47e2-a5c9-a9af4ea9ba32",
    "slug": "marwan-ksibati",
    "name": "Marwan Ksibati",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/25/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Marwan Ksibati",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b0fbe106-8f2a-47e2-a5c9-a9af4ea9ba32",
        "address": "21 ,Ontario Tower ,Oposite Side Obberoi Hotel ,28845 ,Dubai",
        "phone": "97143644333 / 971506326165",
        "email": "helene@hmlc.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "18561830-7fc4-44dd-8c1a-aeecc61cd63f",
    "firmName": "Helene Mathieu Legal Consultants",
    "registrationNumber": "L-00397",
    "licenseIssueDate": "02/25/2012 00:00:00",
    "licenseExpiryDate": "02/16/2026 00:00:00"
  },
  {
    "id": "8b6a4aa4-92e4-408a-a701-858ee7563862",
    "slug": "mary-ibrahim-khalaf-ghali",
    "name": "Mary Ibrahim Khalaf Ghali",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/03/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mary Ibrahim Khalaf Ghali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8b6a4aa4-92e4-408a-a701-858ee7563862",
        "address": "THE OFFICES 1 ,DWTC ,115580 ,",
        "phone": "97143739700 / 971501148248",
        "email": "nitesh.pradhan@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "361fdc64-6b6f-4f37-abca-c52af8473b84",
    "firmName": "Pinsent Masons  LLP (DWTCA Branch)",
    "registrationNumber": "L-05462",
    "licenseIssueDate": "08/03/2022 00:00:00",
    "licenseExpiryDate": "08/02/2026 00:00:00"
  },
  {
    "id": "67cdbefa-e5b8-48be-bfd9-e07f45046fd3",
    "slug": "maryam-chauhan",
    "name": "Maryam Chauhan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/22/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Maryam Chauhan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_67cdbefa-e5b8-48be-bfd9-e07f45046fd3",
        "address": "",
        "phone": "97142472100 / 971509224336",
        "email": "bhaley@cov.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "65a2e90a-6978-4292-b3f1-ecbebedd7b9a",
    "firmName": "Covington & Burling LLP (Middle East)",
    "registrationNumber": "L-06104",
    "licenseIssueDate": "11/22/2023 00:00:00",
    "licenseExpiryDate": "11/21/2025 00:00:00"
  },
  {
    "id": "3d2f6939-8d0e-4ec5-8586-849f400725e1",
    "slug": "maryam-nuwayyid-ahmed-mohammed-al-rafiee",
    "name": "Maryam Nuwayyid Ahmed Mohammed Al Rafiee",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/26/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Maryam Nuwayyid Ahmed Mohammed Al Rafiee",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3d2f6939-8d0e-4ec5-8586-849f400725e1",
        "address": "ICD Brookfield Place ,DIFC ,506516 ,",
        "phone": "97143695800 / 971505526206",
        "email": "scott.campbell@linklaters.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5cec94c0-0649-43b6-a2be-ab17ff422bce",
    "firmName": "LinkLaters LLP",
    "registrationNumber": "L-05825",
    "licenseIssueDate": "04/26/2023 00:00:00",
    "licenseExpiryDate": "04/25/2026 00:00:00"
  },
  {
    "id": "d40d2b4d-ba1a-4fcf-ba6e-5309f441c463",
    "slug": "masa-bassam-a-m-abu-issa",
    "name": "Masa Bassam A M Abu Issa",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/10/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Masa Bassam A M Abu Issa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d40d2b4d-ba1a-4fcf-ba6e-5309f441c463",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-06998"
  },
  {
    "id": "ec4c8fed-a173-479e-bb92-a7d75e30e3e2",
    "slug": "masao-morishita",
    "name": "Masao Morishita",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/16/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Masao Morishita",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ec4c8fed-a173-479e-bb92-a7d75e30e3e2",
        "address": "- ,Index Tower ,Dubai International Financial Centre ,9371 ,Dubai",
        "phone": "97143303900 / 971561753537",
        "email": "christopher@afridi-angell.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3e464dc8-b800-4ba2-ad91-24a5f9640fef",
    "firmName": "Afridi & Angell-DIFC",
    "registrationNumber": "L-04187",
    "licenseIssueDate": "08/16/2018 00:00:00",
    "licenseExpiryDate": "08/14/2026 00:00:00"
  },
  {
    "id": "2ab11d93-db78-45e7-b210-ee64f3491614",
    "slug": "mashair-mahgoub-ali-mahgoub",
    "name": "mashair mahgoub ali mahgoub",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/01/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: mashair mahgoub ali mahgoub",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2ab11d93-db78-45e7-b210-ee64f3491614",
        "address": "ادارة ا لمبنى  ,الريم ,الاتصالات  ,42423 ,Dubai",
        "phone": "97142222066",
        "email": "info@ozleco.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7a155f4a-20ec-44ff-863f-4f9fb43d0af4",
    "firmName": "ALOBAIDLI & ALZAROONI ADVOCATES&LEGAL CONSULTANTS",
    "registrationNumber": "L-06057",
    "licenseIssueDate": "11/01/2023 00:00:00",
    "licenseExpiryDate": "10/31/2025 00:00:00"
  },
  {
    "id": "31cc2e33-05a8-420d-b5a0-9ad189ed766a",
    "slug": "masood-khan",
    "name": "Masood Khan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/13/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Masood Khan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_31cc2e33-05a8-420d-b5a0-9ad189ed766a",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02294",
    "licenseIssueDate": "02/13/2014 00:00:00",
    "licenseExpiryDate": "02/06/2026 00:00:00"
  },
  {
    "id": "5d2c514f-acd2-42ac-a472-710fd95b70da",
    "slug": "masood-khan-afridi",
    "name": "Masood Khan Afridi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/16/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Masood Khan Afridi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5d2c514f-acd2-42ac-a472-710fd95b70da",
        "address": "",
        "phone": "97143303900 / 971561753537",
        "email": "christopher@afridi-angell.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "30ce50dc-01a6-499d-8ace-3f807ddcb08d",
    "firmName": "Afridi & Angell-DED",
    "registrationNumber": "L-00115",
    "licenseIssueDate": "12/16/2011 00:00:00",
    "licenseExpiryDate": "12/07/2025 00:00:00"
  },
  {
    "id": "57423d6f-81eb-49a8-a831-a0ed7bd9d17c",
    "slug": "masood-rashid-mohseni",
    "name": "Masood rashid mohseni",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/13/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Masood rashid mohseni",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_57423d6f-81eb-49a8-a831-a0ed7bd9d17c",
        "address": "KEFAH ALZAABI ,3005 ,برج لطيفه  ,ابراج لطيفه  ,97597 ,Dubai",
        "phone": "97142522260",
        "email": "info@jazlawyers.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6fab0ce0-5a6b-4586-a900-862950161d02",
    "firmName": "JASIM ALZAROONI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-07007"
  },
  {
    "id": "1a0ba20e-c1e1-4238-a928-dcf177e72d9b",
    "slug": "massimiliano-aita",
    "name": "Massimiliano Aita",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/03/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Massimiliano Aita",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1a0ba20e-c1e1-4238-a928-dcf177e72d9b",
        "address": "5 ,AL SUAIDI ,AL MARARR ,506803 ,Dubai",
        "phone": "97148283966 / 971502473435",
        "email": "info@difranciafirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0deeb936-18fc-456c-97dc-2e1cce547c2d",
    "firmName": "Di Francia Law Firm (Dubai Branch)",
    "registrationNumber": "L-06043",
    "licenseIssueDate": "01/04/2024 00:00:00",
    "licenseExpiryDate": "01/03/2026 00:00:00"
  },
  {
    "id": "d89c10f3-935e-4112-aaec-a68366b98471",
    "slug": "massimiliano-william-valli",
    "name": "Massimiliano William Valli",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/21/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-01-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Massimiliano William Valli",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d89c10f3-935e-4112-aaec-a68366b98471",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-04839",
    "licenseIssueDate": "01/21/2021 00:00:00",
    "licenseExpiryDate": "01/20/2026 00:00:00"
  },
  {
    "id": "87960c5d-75a5-413a-bad7-dc73210b41fc",
    "slug": "massoud-samer-walid-younes",
    "name": "Massoud Samer Walid Younes",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/12/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Massoud Samer Walid Younes",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_87960c5d-75a5-413a-bad7-dc73210b41fc",
        "address": "YASIR AL NAQBI ,21 ,48 BURJ ,SOFITEL DOWN  TOWN ,181111 ,Dubai",
        "phone": "97142689949",
        "email": "info@alnaqbipartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ad71430e-83ee-4cb5-a530-bc58db2618f6",
    "firmName": "ALNAQBI & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04908",
    "licenseIssueDate": "04/12/2021 00:00:00",
    "licenseExpiryDate": "04/11/2026 00:00:00"
  },
  {
    "id": "33f8a5ab-6367-4829-8b2c-fb6920522aea",
    "slug": "matthew-escritt",
    "name": "Matthew Escritt",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/09/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Matthew Escritt",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_33f8a5ab-6367-4829-8b2c-fb6920522aea",
        "address": "THE OFFICES 1 ,DWTC ,115580 ,",
        "phone": "97143739700 / 971501148248",
        "email": "nitesh.pradhan@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "361fdc64-6b6f-4f37-abca-c52af8473b84",
    "firmName": "Pinsent Masons  LLP (DWTCA Branch)",
    "registrationNumber": "L-00505",
    "licenseIssueDate": "09/09/2020 00:00:00",
    "licenseExpiryDate": "09/08/2026 00:00:00"
  },
  {
    "id": "db23891f-6ba4-48ac-9065-7857aea17e66",
    "slug": "matthew-harley",
    "name": "Matthew Harley",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/04/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-03-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Matthew Harley",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_db23891f-6ba4-48ac-9065-7857aea17e66",
        "address": "Index Tower ,506548 ,Dubai",
        "phone": "97147096300 / 971506767433",
        "email": "amateen@reedsmith.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b3f87e90-7ce9-4097-82c4-15232365f175",
    "firmName": "Reed Smith LLP",
    "registrationNumber": "L-03930",
    "licenseIssueDate": "02/04/2022 00:00:00",
    "licenseExpiryDate": "02/03/2026 00:00:00"
  },
  {
    "id": "400c5940-5603-406d-a222-c9b35ffe5b45",
    "slug": "matthew-james-rosenberg",
    "name": "Matthew James Rosenberg",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/11/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Matthew James Rosenberg",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_400c5940-5603-406d-a222-c9b35ffe5b45",
        "address": "- ,Index Tower ,Dubai International Financial Centre ,9371 ,Dubai",
        "phone": "97143303900 / 971561753537",
        "email": "christopher@afridi-angell.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3e464dc8-b800-4ba2-ad91-24a5f9640fef",
    "firmName": "Afridi & Angell-DIFC",
    "registrationNumber": "L-06492",
    "licenseIssueDate": "09/11/2024 00:00:00",
    "licenseExpiryDate": "09/10/2026 00:00:00"
  },
  {
    "id": "02b50169-e169-47dd-8b00-9e8d36acdf65",
    "slug": "matthew-joseph-carpenter",
    "name": "Matthew Joseph Carpenter",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/09/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Matthew Joseph Carpenter",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_02b50169-e169-47dd-8b00-9e8d36acdf65",
        "address": "ICD Brookfield Place ,Za'abeel 2 ,103747 ,",
        "phone": "97143696300 / 971506008159",
        "email": "mohammed.paracha@nortonrosefulbright.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c4aaee93-0ec4-4982-9a48-a23699492056",
    "firmName": "Norton Rose Fullbright (Middle East) LLP",
    "registrationNumber": "L-05707",
    "licenseIssueDate": "02/09/2023 00:00:00",
    "licenseExpiryDate": "02/08/2026 00:00:00"
  },
  {
    "id": "81b52773-d057-4ce7-bdb4-c8baaf758fb6",
    "slug": "matthew-page",
    "name": "Matthew Page",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/28/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Matthew Page",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_81b52773-d057-4ce7-bdb4-c8baaf758fb6",
        "address": "",
        "phone": "97144230000 / 971552009022",
        "email": "UAE-CourtClerks@habibalmulla.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3eba82bb-8ec4-4cbd-80d0-a793cb993fde",
    "firmName": "Habib Al Mulla & Partners ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02813",
    "licenseIssueDate": "01/28/2015 00:00:00",
    "licenseExpiryDate": "01/22/2026 00:00:00"
  },
  {
    "id": "aabbe5b5-2298-4214-b47c-d7883ad7bff0",
    "slug": "matthew-paul-dyson",
    "name": "MATTHEW PAUL DYSON",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/04/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MATTHEW PAUL DYSON",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_aabbe5b5-2298-4214-b47c-d7883ad7bff0",
        "address": "Al Fattan Currency House - Tower 1  ,Dubai International Financial Center  ,507104 ,",
        "phone": "97143978565 / 971504587822",
        "email": "Raafat.hares@dwf.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6e5f6dba-07af-4109-8c34-175296450f94",
    "firmName": "DWF (Middle East) LLP",
    "registrationNumber": "L-04027",
    "licenseIssueDate": "03/04/2018 00:00:00",
    "licenseExpiryDate": "03/01/2026 00:00:00"
  },
  {
    "id": "a8478095-6650-4d50-96ab-4d3811188d15",
    "slug": "matthew-richard-rodwell",
    "name": "Matthew Richard Rodwell",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/08/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Matthew Richard Rodwell",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a8478095-6650-4d50-96ab-4d3811188d15",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506698 ,Dubai",
        "phone": "97147046300 / 971507900661",
        "email": "nada.mourad@lw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b2b92ce9-90a4-4e34-ae2f-ae0dc7ca9060",
    "firmName": "Latham & Watkins LLP",
    "registrationNumber": "L-04031",
    "licenseIssueDate": "08/08/2024 00:00:00",
    "licenseExpiryDate": "08/07/2026 00:00:00"
  },
  {
    "id": "8c6caba6-d63c-4660-976d-406b63b85778",
    "slug": "matthew-shanahan",
    "name": "Matthew Shanahan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/18/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Matthew Shanahan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8c6caba6-d63c-4660-976d-406b63b85778",
        "address": "ICD Brookfield Place ,Za'abeel 2 ,103747 ,",
        "phone": "97143696300 / 971506008159",
        "email": "mohammed.paracha@nortonrosefulbright.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c4aaee93-0ec4-4982-9a48-a23699492056",
    "firmName": "Norton Rose Fullbright (Middle East) LLP",
    "registrationNumber": "L-03313",
    "licenseIssueDate": "10/18/2015 00:00:00",
    "licenseExpiryDate": "10/13/2026 00:00:00"
  },
  {
    "id": "a7e07088-cb0b-4e24-95a6-14a0ffc867ae",
    "slug": "matthew-terence-keats",
    "name": "Matthew Terence Keats",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/05/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Matthew Terence Keats",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a7e07088-cb0b-4e24-95a6-14a0ffc867ae",
        "address": "ICD Brookfield Place ,DIFC ,506516 ,",
        "phone": "97143695800 / 971505526206",
        "email": "scott.campbell@linklaters.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5cec94c0-0649-43b6-a2be-ab17ff422bce",
    "firmName": "LinkLaters LLP",
    "registrationNumber": "L-04769",
    "licenseIssueDate": "11/05/2020 00:00:00",
    "licenseExpiryDate": "11/04/2025 00:00:00"
  },
  {
    "id": "83d41442-6bf9-43db-a672-6bbadb2b956e",
    "slug": "matthew-william-powell",
    "name": "Matthew William Powell",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/24/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Matthew William Powell",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_83d41442-6bf9-43db-a672-6bbadb2b956e",
        "address": "",
        "phone": "97144478700 / 971528553200",
        "email": "Thomas.Wilson@squirepb.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "85be541a-c87f-45a9-a321-d90abd6b7298",
    "firmName": "Squire Patton Boggs (MEA) LLP",
    "registrationNumber": "L-04747",
    "licenseIssueDate": "09/24/2020 00:00:00",
    "licenseExpiryDate": "09/23/2026 00:00:00"
  },
  {
    "id": "229b3308-acd8-4ef0-84e9-aea73dbcc6ef",
    "slug": "matthias-maverick-ng",
    "name": "Matthias Maverick Ng",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/25/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Matthias Maverick Ng",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_229b3308-acd8-4ef0-84e9-aea73dbcc6ef",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506688 ,Dubai",
        "phone": "97147096600 / 971503556811",
        "email": "muneer.khan@simmons-simmons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d1725ca7-06ac-41b2-8d7b-a6e60665b73d",
    "firmName": "Simmons & Simmons (Middle East) LLP-DIFC",
    "registrationNumber": "L-05544",
    "licenseIssueDate": "09/25/2022 00:00:00",
    "licenseExpiryDate": "09/24/2026 00:00:00"
  },
  {
    "id": "66c14931-9bad-4108-a76b-7319311d621b",
    "slug": "maurice-katsigazi",
    "name": "Maurice Katsigazi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/12/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Maurice Katsigazi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_66c14931-9bad-4108-a76b-7319311d621b",
        "address": "",
        "phone": "97143742800 / 971506450677",
        "email": "jabbott21@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7a59d310-ff72-4318-b41c-27095c163d0f",
    "firmName": "CMS (UAE) LLP",
    "registrationNumber": "L-06409",
    "licenseIssueDate": "07/12/2024 00:00:00",
    "licenseExpiryDate": "07/11/2026 00:00:00"
  },
  {
    "id": "be47a48c-604a-4384-901c-97f243c0b6d4",
    "slug": "mauricio-sergio-rodrigo-arturo-costa-du-rels-flores",
    "name": "Mauricio Sergio Rodrigo Arturo Costa Du Rels Flores",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/09/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mauricio Sergio Rodrigo Arturo Costa Du Rels Flores",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_be47a48c-604a-4384-901c-97f243c0b6d4",
        "address": "",
        "phone": "97143826100 / 971507380618",
        "email": "jmiocevic@curtis.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0867bcc5-10fa-4783-91ae-b8f63e02e81a",
    "firmName": "Curtis Mallet-Prevost, Colt & Mosle LLP",
    "registrationNumber": "L-06520",
    "licenseIssueDate": "10/09/2024 00:00:00",
    "licenseExpiryDate": "10/08/2025 00:00:00"
  },
  {
    "id": "f4292970-932e-42fc-ad61-b2d4896b4770",
    "slug": "max-edward-davis",
    "name": "Max Edward Davis",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/19/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Max Edward Davis",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f4292970-932e-42fc-ad61-b2d4896b4770",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-05285",
    "licenseIssueDate": "04/19/2022 00:00:00",
    "licenseExpiryDate": "04/18/2026 00:00:00"
  },
  {
    "id": "9572e1dd-6639-406b-8c6e-9002790698ce",
    "slug": "maxi-luisa-niefer",
    "name": "Maxi Luisa Niefer",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/20/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Maxi Luisa Niefer",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9572e1dd-6639-406b-8c6e-9002790698ce",
        "address": "ICD Brookfield Place ,DIFC ,506516 ,",
        "phone": "97143695800 / 971505526206",
        "email": "scott.campbell@linklaters.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5cec94c0-0649-43b6-a2be-ab17ff422bce",
    "firmName": "LinkLaters LLP",
    "registrationNumber": "L-05390",
    "licenseIssueDate": "07/20/2022 00:00:00",
    "licenseExpiryDate": "07/19/2026 00:00:00"
  },
  {
    "id": "65a4d12b-5a3b-43f1-b055-be551da6ede7",
    "slug": "may-abdelhamid-mohamed-elmoghazi",
    "name": "May Abdelhamid Mohamed Elmoghazi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/07/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: May Abdelhamid Mohamed Elmoghazi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_65a4d12b-5a3b-43f1-b055-be551da6ede7",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-06785",
    "licenseIssueDate": "05/07/2025 00:00:00",
    "licenseExpiryDate": "05/06/2026 00:00:00"
  },
  {
    "id": "5c026980-b141-497e-9371-334085668396",
    "slug": "maya-al-qazaz",
    "name": "Maya Al Qazaz",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/22/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Maya Al Qazaz",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5c026980-b141-497e-9371-334085668396",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-06643",
    "licenseIssueDate": "01/22/2025 00:00:00",
    "licenseExpiryDate": "01/21/2026 00:00:00"
  },
  {
    "id": "0d471206-7df7-4c42-a1f4-c64b448cd9f1",
    "slug": "maya-bashir-ahmed",
    "name": "Maya Bashir Ahmed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/21/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Maya Bashir Ahmed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0d471206-7df7-4c42-a1f4-c64b448cd9f1",
        "address": "",
        "phone": "97144230555 / 971504788443",
        "email": "yah@hfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c462c65e-185a-4e81-8425-a87e3a2b6842",
    "firmName": "Holman Fenwick Willan Middle East LLP",
    "registrationNumber": "L-05246",
    "licenseIssueDate": "10/21/2024 00:00:00",
    "licenseExpiryDate": "10/20/2026 00:00:00"
  },
  {
    "id": "9c2c9095-8e15-4370-96e1-d9a890d96cb9",
    "slug": "maymoona-mandviwala",
    "name": "MAYMOONA TALIB HUSAIN YUSUFBHAI MANDVIWALA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/12/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2022-11-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Maymoona Mandviwala",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9c2c9095-8e15-4370-96e1-d9a890d96cb9",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02511",
    "licenseIssueDate": "12/04/2013 00:00:00",
    "licenseExpiryDate": "11/27/2022 00:00:00"
  },
  {
    "id": "3aa59b01-39c9-4447-afeb-7fe35d6053d0",
    "slug": "mays-kabbani",
    "name": "Mays Kabbani",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/16/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mays Kabbani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3aa59b01-39c9-4447-afeb-7fe35d6053d0",
        "address": "4th floor ,Al Saaha Offices Block D office 401A ,Burj Khalifa ,283773 ,Dubai",
        "phone": "97144221944",
        "email": "gov.depts@alsafarpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b7bbfaeb-1fdb-46d2-97cf-8e6432a9b8a7",
    "firmName": "AL SAFAR & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03661",
    "licenseIssueDate": "03/16/2017 00:00:00",
    "licenseExpiryDate": "03/12/2026 00:00:00"
  },
  {
    "id": "112cd82a-af54-4084-8366-1a32efff7a23",
    "slug": "maysoun-mhd-hassan-al-nashar",
    "name": "Maysoun Mhd Hassan Al Nashar",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/03/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Maysoun Mhd Hassan Al Nashar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_112cd82a-af54-4084-8366-1a32efff7a23",
        "address": "Sultan Hadif Al Owais ,504 ,Oud Metha ,Wafi Mall ,16686 ,Dubai",
        "phone": "97105053953 / 971509793158",
        "email": "info@alowaislegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "da23f476-a80d-4d5a-b180-5dbd879b540e",
    "firmName": "AL JALLAF ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02204",
    "licenseIssueDate": "03/03/2014 00:00:00",
    "licenseExpiryDate": "02/24/2026 00:00:00"
  },
  {
    "id": "5e8c494e-4325-45fc-a990-ef785b17b651",
    "slug": "mayss-mazen-hani-akasheh",
    "name": "Mayss Mazen Hani Akasheh",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/08/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mayss Mazen Hani Akasheh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5e8c494e-4325-45fc-a990-ef785b17b651",
        "address": "",
        "phone": "97144073901 / 971503479508",
        "email": "Rania.Tadros@stephensonharwood.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dd5042a2-bb41-4123-9544-79c3fa831332",
    "firmName": "Stephenson Harwood (Middle East) LLP",
    "registrationNumber": "L-05946",
    "licenseIssueDate": "08/08/2023 00:00:00",
    "licenseExpiryDate": "08/07/2026 00:00:00"
  },
  {
    "id": "03f6a9e4-8b50-4a49-b798-dfb6396dad0a",
    "slug": "mazen-youssef-ajjour",
    "name": "Mazen Youssef Ajjour",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mazen Youssef Ajjour",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_03f6a9e4-8b50-4a49-b798-dfb6396dad0a",
        "address": "الطابق الثالث ,بناية مكاتب عود ميثاء ,سيتي بانك ,78853 ,Dubai",
        "phone": "97142220585 / 971506555166",
        "email": "info@kasadv.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ec4ada87-49a0-432b-a843-e47adccd286f",
    "firmName": "KHALIFA ALSADA ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-02127",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "afae070f-e2a5-420b-a614-991fc91f9375",
    "slug": "mazin-salih-salman-mohamed",
    "name": "Mazin Salih Salman Mohamed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/28/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mazin Salih Salman Mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_afae070f-e2a5-420b-a614-991fc91f9375",
        "address": "",
        "phone": "97144073901 / 971503479508",
        "email": "Rania.Tadros@stephensonharwood.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dd5042a2-bb41-4123-9544-79c3fa831332",
    "firmName": "Stephenson Harwood (Middle East) LLP",
    "registrationNumber": "L-04303",
    "licenseIssueDate": "01/28/2019 00:00:00",
    "licenseExpiryDate": "01/26/2026 00:00:00"
  },
  {
    "id": "368acec8-710f-413f-96f7-6f67542148cf",
    "slug": "medhat-kholief",
    "name": "Medhat Kholief",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Medhat Kholief",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_368acec8-710f-413f-96f7-6f67542148cf",
        "address": "ABDULRAHMAN OMAR  ABDULLA MUKHAYER  ,NBK BANK ,LATIFA TOWER  ,NEAR CROWN PLAZA  ,185616 ,Dubai",
        "phone": "97143296968",
        "email": "hlp@hlplawfirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "617b9580-cff5-4ffa-b2bc-8788300a3c6e",
    "firmName": "AL HUQOOQ FOR ADVOCACY AND LEGAL CONSULTANCY",
    "registrationNumber": "L-01199",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "2cbb3c84-4243-40cf-b104-c7db5f391a78",
    "slug": "meera-shinh",
    "name": "Meera Shinh",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/22/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Meera Shinh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2cbb3c84-4243-40cf-b104-c7db5f391a78",
        "address": "",
        "phone": "97144484284 / 971559776272",
        "email": "nita@willsuae.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "272328d6-db51-4b0e-b8bc-5297a958940d",
    "firmName": "TWS Legal Consultants DMCC",
    "registrationNumber": "L-06663",
    "licenseIssueDate": "01/22/2025 00:00:00",
    "licenseExpiryDate": "01/21/2026 00:00:00"
  },
  {
    "id": "76ccaccb-c4dd-4b17-b987-61c845a95e38",
    "slug": "meghan-devine",
    "name": "Meghan Devine",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/12/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Meghan Devine",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_76ccaccb-c4dd-4b17-b987-61c845a95e38",
        "address": "",
        "phone": "97144020800 / 971566830829",
        "email": "dean.ryburn@dentons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dfe13b7e-6625-45fd-ad63-9ee83af41194",
    "firmName": "Dentons & Co Dubai Branch-DED",
    "registrationNumber": "L-04572",
    "licenseIssueDate": "12/12/2019 00:00:00",
    "licenseExpiryDate": "12/11/2025 00:00:00"
  },
  {
    "id": "75c73060-5974-4324-b0d1-1e124b5d77b2",
    "slug": "mehak-navneet-basant-kumar-kampani",
    "name": "Mehak Navneet Basant Kumar Kampani",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/05/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mehak Navneet Basant Kumar Kampani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_75c73060-5974-4324-b0d1-1e124b5d77b2",
        "address": "",
        "phone": "97144529091 / 971552805308",
        "email": "ashafi@ach-legal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4f3e1e80-c812-4585-9570-229cd96776a4",
    "firmName": "Anjarwalla, Collins and Haidermota Legal Consultants",
    "registrationNumber": "L-05927",
    "licenseIssueDate": "07/05/2023 00:00:00",
    "licenseExpiryDate": "07/04/2026 00:00:00"
  },
  {
    "id": "96776e31-6a2b-4ca6-924a-47c575f5dc42",
    "slug": "mehdi-seadon",
    "name": "Mehdi Seadon",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/11/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mehdi Seadon",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_96776e31-6a2b-4ca6-924a-47c575f5dc42",
        "address": "Building 5 ,Dubai World Trade Centre ,212620 ,",
        "phone": "97143503600 / 971563631562",
        "email": "p.ellingham@kennedys-law.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "83d3ede1-3a28-4b03-8c92-6bd31a1cb95e",
    "firmName": "Kennedys Dubai LLP",
    "registrationNumber": "L-04055",
    "licenseIssueDate": "04/11/2018 00:00:00",
    "licenseExpiryDate": "04/08/2026 00:00:00"
  },
  {
    "id": "f9d12f7e-528f-4fe8-a0af-5e2a9c330f2d",
    "slug": "mehtab-kassam",
    "name": "Mehtab Kassam",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/25/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mehtab Kassam",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f9d12f7e-528f-4fe8-a0af-5e2a9c330f2d",
        "address": "",
        "phone": "97144073901 / 971503479508",
        "email": "Rania.Tadros@stephensonharwood.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dd5042a2-bb41-4123-9544-79c3fa831332",
    "firmName": "Stephenson Harwood (Middle East) LLP",
    "registrationNumber": "L-03471",
    "licenseIssueDate": "08/25/2016 00:00:00",
    "licenseExpiryDate": "08/21/2026 00:00:00"
  },
  {
    "id": "1286e1e5-39c3-4681-bd6b-05d11eb7697c",
    "slug": "melissa-caroline-hartley",
    "name": "Melissa Caroline Hartley",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/11/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Melissa Caroline Hartley",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1286e1e5-39c3-4681-bd6b-05d11eb7697c",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-06842",
    "licenseIssueDate": "06/11/2025 00:00:00",
    "licenseExpiryDate": "06/10/2026 00:00:00"
  },
  {
    "id": "de160654-167b-456b-9078-6bbc521aa8ed",
    "slug": "melissa-claire-mallon",
    "name": "Melissa Claire Mallon",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/09/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Melissa Claire Mallon",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_de160654-167b-456b-9078-6bbc521aa8ed",
        "address": "",
        "phone": "97144020800 / 971566830829",
        "email": "dean.ryburn@dentons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dfe13b7e-6625-45fd-ad63-9ee83af41194",
    "firmName": "Dentons & Co Dubai Branch-DED",
    "registrationNumber": "L-05703",
    "licenseIssueDate": "02/09/2023 00:00:00",
    "licenseExpiryDate": "02/08/2026 00:00:00"
  },
  {
    "id": "fde0d9ef-3dc7-4751-a3e3-b7a3acdee9c5",
    "slug": "melissa-forbes",
    "name": "Melissa Forbes",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/08/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Melissa Forbes",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fde0d9ef-3dc7-4751-a3e3-b7a3acdee9c5",
        "address": "",
        "phone": "97144073901 / 971503479508",
        "email": "Rania.Tadros@stephensonharwood.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dd5042a2-bb41-4123-9544-79c3fa831332",
    "firmName": "Stephenson Harwood (Middle East) LLP",
    "registrationNumber": "L-01005",
    "licenseIssueDate": "09/08/2011 00:00:00",
    "licenseExpiryDate": "08/30/2026 00:00:00"
  },
  {
    "id": "327f1f25-4650-4dac-8056-a79cd390e482",
    "slug": "melissa-jane-mclaren",
    "name": "MELISSA JANE MCLAREN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/16/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MELISSA JANE MCLAREN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_327f1f25-4650-4dac-8056-a79cd390e482",
        "address": "- ,THE OFFICES 1 ,DWTC ,115580 ,Dubai",
        "phone": "97143739700 / 971562196031",
        "email": "catherine.workman@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6b4ebb23-ef2e-4305-a1ee-43a11e4b1cae",
    "firmName": "Pinsent Masons LLP - Dubai Branch",
    "registrationNumber": "L-00164",
    "licenseIssueDate": "06/16/2019 00:00:00",
    "licenseExpiryDate": "06/15/2026 00:00:00"
  },
  {
    "id": "1861fc89-9f72-4b54-b35c-5a0396f82374",
    "slug": "melissa-murray",
    "name": "Melissa Murray",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/13/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Melissa Murray",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1861fc89-9f72-4b54-b35c-5a0396f82374",
        "address": "",
        "phone": "97143093222 / 971566651954",
        "email": "melissa.murray@twobirds.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "3e1526e6-4c8d-4b6f-985f-ea05e9f99bcb",
    "firmName": "Bird & Bird (MEA) LLP",
    "registrationNumber": "L-02083",
    "licenseIssueDate": "04/13/2015 00:00:00",
    "licenseExpiryDate": "04/07/2026 00:00:00"
  },
  {
    "id": "955509e8-5abc-48ae-b450-9ccb1e2c0ce7",
    "slug": "melissa-naomi-ashdown",
    "name": "Melissa Naomi Ashdown",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/25/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Melissa Naomi Ashdown",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_955509e8-5abc-48ae-b450-9ccb1e2c0ce7",
        "address": "Index Tower ,506548 ,Dubai",
        "phone": "97147096300 / 971506767433",
        "email": "amateen@reedsmith.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b3f87e90-7ce9-4097-82c4-15232365f175",
    "firmName": "Reed Smith LLP",
    "registrationNumber": "L-06561",
    "licenseIssueDate": "10/17/2024 00:00:00",
    "licenseExpiryDate": "10/16/2026 00:00:00"
  },
  {
    "id": "1c2e6e41-d07b-4fbc-873b-bb9785c3160e",
    "slug": "melwyn-dsouza",
    "name": "Melwyn Dsouza",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/16/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Melwyn Dsouza",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1c2e6e41-d07b-4fbc-873b-bb9785c3160e",
        "address": "6F 603, 605, 7F 704 ,Crystal Tower ,Dubai Mall ,117538 ,Dubai",
        "phone": "97146098700",
        "email": "pro@miolawfirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "417f90a1-03be-4dab-8eea-1bba7e16f536",
    "firmName": "ABU BAKER SALEM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02733",
    "licenseIssueDate": "07/16/2014 00:00:00",
    "licenseExpiryDate": "07/10/2026 00:00:00"
  },
  {
    "id": "ccccfffb-3213-442a-942a-4b12e054fc77",
    "slug": "mena-zaher-agaipy-hana",
    "name": "Mena zaher agaipy hana",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNWgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/26/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mena zaher agaipy hana",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ccccfffb-3213-442a-942a-4b12e054fc77",
        "address": "",
        "phone": "97148843777 / 971508825889",
        "email": "info@arlawyers.me",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e49cde31-d86a-482d-a53c-b2eb1265fb1f",
    "firmName": "ABDULRAHMAN AHMED ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04793",
    "licenseIssueDate": "11/26/2020 00:00:00",
    "licenseExpiryDate": "11/25/2025 00:00:00"
  },
  {
    "id": "5a373933-69a9-435e-b4cb-605c1e72152a",
    "slug": "menelaos-photiou-kouzoupis",
    "name": "Menelaos Photiou Kouzoupis",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/06/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Menelaos Photiou Kouzoupis",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5a373933-69a9-435e-b4cb-605c1e72152a",
        "address": "",
        "phone": "97144073901 / 971503479508",
        "email": "Rania.Tadros@stephensonharwood.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dd5042a2-bb41-4123-9544-79c3fa831332",
    "firmName": "Stephenson Harwood (Middle East) LLP",
    "registrationNumber": "L-05947",
    "licenseIssueDate": "09/06/2023 00:00:00",
    "licenseExpiryDate": "09/05/2026 00:00:00"
  },
  {
    "id": "c2cd1eb0-0d14-4dba-b104-9acc20abddcf",
    "slug": "menshawy-elsaftawy",
    "name": "Menshawy Elsaftawy",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Menshawy Elsaftawy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c2cd1eb0-0d14-4dba-b104-9acc20abddcf",
        "address": "الخامس  ,مكاتب عود ميثاء ,فندق رافلز ,11268 ,Dubai",
        "phone": "97143243330",
        "email": "avocat@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "25d2c9bd-dbba-41ac-aff9-5ba0f37290d6",
    "firmName": "AL QARI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-01342",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "ded8e7fd-662c-4a98-b637-c8c5464c4532",
    "slug": "merline-rose-dsouza-robert-dsouza",
    "name": "Merline Rose Dsouza Robert Dsouza",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/22/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Merline Rose Dsouza Robert Dsouza",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ded8e7fd-662c-4a98-b637-c8c5464c4532",
        "address": "Samia Luqman ,2nd floor ,Emarat Atrium Building ,across Holiday Inn Express Safa Park ,7273 ,Dubai",
        "phone": "97143211000",
        "email": "info@alsuwaidi.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0e5c3637-bc12-475c-a6b5-2d9ae84f2b8e",
    "firmName": "AL-SUWAIDI & COMPANY",
    "registrationNumber": "L-05376",
    "licenseIssueDate": "06/22/2022 00:00:00",
    "licenseExpiryDate": "06/21/2026 00:00:00"
  },
  {
    "id": "c1c7a916-5720-40b8-bfee-2da8025af69a",
    "slug": "mhairi-fiona-cruickshank",
    "name": "Mhairi Fiona Cruickshank",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/08/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mhairi Fiona Cruickshank",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c1c7a916-5720-40b8-bfee-2da8025af69a",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-05363",
    "licenseIssueDate": "06/08/2022 00:00:00",
    "licenseExpiryDate": "06/07/2026 00:00:00"
  },
  {
    "id": "56306fb9-58be-4140-a30d-4e28601c87f6",
    "slug": "mhd-hassan-tawaklna",
    "name": "Mhd Hassan Tawaklna",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mhd Hassan Tawaklna",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_56306fb9-58be-4140-a30d-4e28601c87f6",
        "address": "",
        "phone": "97143937700",
        "email": "info@galadarilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d863b662-c864-4193-8b3a-ff6ee5fe6c64",
    "firmName": "GALADARI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01496",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "e1f7b060-23b3-42b0-b25c-211d7355f52d",
    "slug": "michael-adel-raghib-ibrahim-gerges",
    "name": "Michael Adel Raghib Ibrahim Gerges",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/30/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Michael Adel Raghib Ibrahim Gerges",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e1f7b060-23b3-42b0-b25c-211d7355f52d",
        "address": "الثالث  ,برج جيت  48  ,مخرج ميترو برج خليفه / دبي مول  ,181111 ,Dubai",
        "phone": "97145143423 / 971971451434",
        "email": "info.justice@fhsadvo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "690778ba-3332-4c06-b01f-ab5ec89ee304",
    "firmName": "FATEMA HASAN ALSHEHHI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-06559",
    "licenseIssueDate": "10/30/2024 00:00:00",
    "licenseExpiryDate": "10/29/2025 00:00:00"
  },
  {
    "id": "7814f4a9-f1df-4638-bf34-a315beca3e89",
    "slug": "michael-angel-hammond",
    "name": "Michael Angel Hammond",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/06/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Michael Angel Hammond",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7814f4a9-f1df-4638-bf34-a315beca3e89",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506698 ,Dubai",
        "phone": "97147046300 / 971507900661",
        "email": "nada.mourad@lw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b2b92ce9-90a4-4e34-ae2f-ae0dc7ca9060",
    "firmName": "Latham & Watkins LLP",
    "registrationNumber": "L-06109",
    "licenseIssueDate": "12/06/2023 00:00:00",
    "licenseExpiryDate": "12/05/2025 00:00:00"
  },
  {
    "id": "4ff85bac-a05b-4f8c-9915-b19c8f38bce9",
    "slug": "michael-boulos-farchakh",
    "name": "Michael Boulos Farchakh",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/19/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Michael Boulos Farchakh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4ff85bac-a05b-4f8c-9915-b19c8f38bce9",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-04251",
    "licenseIssueDate": "01/19/2022 00:00:00",
    "licenseExpiryDate": "01/18/2026 00:00:00"
  },
  {
    "id": "589901d0-f750-433a-9a89-f6ad3e7af70f",
    "slug": "michael-campbell",
    "name": "Michael Campbell",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/02/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Michael Campbell",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_589901d0-f750-433a-9a89-f6ad3e7af70f",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-03799",
    "licenseIssueDate": "05/02/2017 00:00:00",
    "licenseExpiryDate": "04/28/2026 00:00:00"
  },
  {
    "id": "3e739200-8cb2-44e6-ba10-7448fa7d216e",
    "slug": "michael-cortbawi",
    "name": "Michael Cortbawi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Michael Cortbawi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3e739200-8cb2-44e6-ba10-7448fa7d216e",
        "address": "",
        "phone": "97143685555",
        "email": "maisa.maarouf@bsabh.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8afa232f-52ff-4dad-82c3-9a04d66eb853",
    "firmName": "B S A AHMED BIN HAZEEM & ASSOCIATES LLP - DIFC",
    "registrationNumber": "L-01634",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "46e162be-7481-41e3-af93-fc14587271e7",
    "slug": "michael-ducker",
    "name": "Michael Ducker",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/17/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Michael Ducker",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_46e162be-7481-41e3-af93-fc14587271e7",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-03294",
    "licenseIssueDate": "01/17/2016 00:00:00",
    "licenseExpiryDate": "01/12/2026 00:00:00"
  },
  {
    "id": "356de86d-bad0-4783-9b1c-ee15271f05f9",
    "slug": "michael-graham-smale",
    "name": "Michael Graham Smale",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/18/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-01-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Michael Graham Smale",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_356de86d-bad0-4783-9b1c-ee15271f05f9",
        "address": "Building 5 ,Dubai World Trade Centre ,212620 ,",
        "phone": "97143503600 / 971563631562",
        "email": "p.ellingham@kennedys-law.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "83d3ede1-3a28-4b03-8c92-6bd31a1cb95e",
    "firmName": "Kennedys Dubai LLP",
    "registrationNumber": "L-05668",
    "licenseIssueDate": "01/18/2023 00:00:00",
    "licenseExpiryDate": "01/17/2026 00:00:00"
  },
  {
    "id": "d2d51dd9-9624-46bd-badd-22396184ff06",
    "slug": "michael-grose",
    "name": "Michael Grose",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/11/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Michael Grose",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d2d51dd9-9624-46bd-badd-22396184ff06",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-00303",
    "licenseIssueDate": "10/11/2011 00:00:00",
    "licenseExpiryDate": "10/02/2026 00:00:00"
  },
  {
    "id": "7a4a4b54-90a4-4284-b0b2-b47cab20831a",
    "slug": "michael-hartley",
    "name": "Michael Hartley",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/26/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Michael Hartley",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7a4a4b54-90a4-4284-b0b2-b47cab20831a",
        "address": "Al Fattan Currency House - Tower 1  ,Dubai International Financial Center  ,507104 ,",
        "phone": "97143978565 / 971504587822",
        "email": "Raafat.hares@dwf.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6e5f6dba-07af-4109-8c34-175296450f94",
    "firmName": "DWF (Middle East) LLP",
    "registrationNumber": "L-03080",
    "licenseIssueDate": "11/26/2024 00:00:00",
    "licenseExpiryDate": "11/25/2025 00:00:00"
  },
  {
    "id": "5be82d59-5129-4d80-a972-8fba17b0a135",
    "slug": "michael-james-stewart",
    "name": "Michael James Stewart",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/09/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Michael James Stewart",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5be82d59-5129-4d80-a972-8fba17b0a135",
        "address": "ICD Brookfield Place ,DIFC ,120109 ,",
        "phone": "97143173000 / 971504465229",
        "email": "DubaiLAD@akingump.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9ff29eab-adb8-40f9-ab84-216e01a381e4",
    "firmName": "Akin Gump Strauss Hauer & Feld LLP",
    "registrationNumber": "L-04398",
    "licenseIssueDate": "05/09/2019 00:00:00",
    "licenseExpiryDate": "05/08/2026 00:00:00"
  },
  {
    "id": "2a7d7d65-e047-4c2a-8675-1f78d79e3b8f",
    "slug": "michael-john-turrini",
    "name": "Michael John Turrini",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/02/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Michael John Turrini",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2a7d7d65-e047-4c2a-8675-1f78d79e3b8f",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-04185",
    "licenseIssueDate": "08/02/2018 00:00:00",
    "licenseExpiryDate": "07/31/2026 00:00:00"
  },
  {
    "id": "dbca45ec-5922-4156-ad4b-8e11640c81ae",
    "slug": "michael-lodovico-testori",
    "name": "Michael Lodovico Testori",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/08/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-07-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Michael Lodovico Testori",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dbca45ec-5922-4156-ad4b-8e11640c81ae",
        "address": "",
        "phone": "97143637999 / 971506525633",
        "email": "daniel.wood@walkersglobal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a3a9927b-d51c-490c-8be6-d575ea3eb041",
    "firmName": "Walkers (Middle East) LLP",
    "registrationNumber": "L-04581",
    "licenseIssueDate": "01/08/2020 00:00:00",
    "licenseExpiryDate": "01/07/2026 00:00:00"
  },
  {
    "id": "02e5bd9b-dc4b-4193-bd4c-568a374333d2",
    "slug": "michael-morris",
    "name": "Michael Morris",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/06/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Michael Morris",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_02e5bd9b-dc4b-4193-bd4c-568a374333d2",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-04517",
    "licenseIssueDate": "11/06/2019 00:00:00",
    "licenseExpiryDate": "11/05/2025 00:00:00"
  },
  {
    "id": "31b830e9-4c64-4531-8d13-ffe97fb3e0a5",
    "slug": "michael-paul-dunmore",
    "name": "Michael Paul Dunmore",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/21/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Michael Paul Dunmore",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_31b830e9-4c64-4531-8d13-ffe97fb3e0a5",
        "address": "Building 5 ,Dubai World Trade Centre ,212620 ,",
        "phone": "97143503600 / 971563631562",
        "email": "p.ellingham@kennedys-law.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "83d3ede1-3a28-4b03-8c92-6bd31a1cb95e",
    "firmName": "Kennedys Dubai LLP",
    "registrationNumber": "L-05006",
    "licenseIssueDate": "07/21/2025 00:00:00",
    "licenseExpiryDate": "07/20/2026 00:00:00"
  },
  {
    "id": "46565b12-9375-454f-8c00-bbbd3241db97",
    "slug": "michael-rainey",
    "name": "Michael Rainey",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/12/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Michael Rainey",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_46565b12-9375-454f-8c00-bbbd3241db97",
        "address": "",
        "phone": "97143779900 / 971508548052",
        "email": "jali@kslaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dff8529a-82be-431a-b72b-0192ff238011",
    "firmName": "Eversheds Sutherland (International LLP) Dubai Branch",
    "registrationNumber": "L-03239",
    "licenseIssueDate": "12/09/2015 00:00:00",
    "licenseExpiryDate": "12/04/2025 00:00:00"
  },
  {
    "id": "927afb82-f016-4132-80e0-02c8323be9c5",
    "slug": "michael-robert-chattle",
    "name": "Michael Robert Chattle",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/28/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Michael Robert Chattle",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_927afb82-f016-4132-80e0-02c8323be9c5",
        "address": "",
        "phone": "97143641686 / 971506288801",
        "email": "b.kadir@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0ba96df8-e4cc-49c2-8ae4-a42878d95926",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS LLC",
    "registrationNumber": "L-04781"
  },
  {
    "id": "7326a5f6-9741-4973-b0d4-bef6598ca811",
    "slug": "michael-robert-eybers",
    "name": "MICHAEL ROBERT EYBERS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/06/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MICHAEL ROBERT EYBERS",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7326a5f6-9741-4973-b0d4-bef6598ca811",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-05890",
    "licenseIssueDate": "09/06/2023 00:00:00",
    "licenseExpiryDate": "09/05/2026 00:00:00"
  },
  {
    "id": "cf4ffd50-6d5e-41e3-9d05-ca9251e27d69",
    "slug": "michael-robert-stevens",
    "name": "Michael Robert Stevens",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/24/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Michael Robert Stevens",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cf4ffd50-6d5e-41e3-9d05-ca9251e27d69",
        "address": "ICD Brookfield Place ,Za'abeel 2 ,103747 ,",
        "phone": "97143696300 / 971506008159",
        "email": "mohammed.paracha@nortonrosefulbright.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c4aaee93-0ec4-4982-9a48-a23699492056",
    "firmName": "Norton Rose Fullbright (Middle East) LLP",
    "registrationNumber": "L-05836",
    "licenseIssueDate": "05/24/2023 00:00:00",
    "licenseExpiryDate": "05/23/2026 00:00:00"
  },
  {
    "id": "ff9d6c7d-1add-4647-854a-bc552c5bb6f5",
    "slug": "michael-savva",
    "name": "Michael Savva",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/14/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Michael Savva",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ff9d6c7d-1add-4647-854a-bc552c5bb6f5",
        "address": "Index Tower ,DIFC ,506896 ,",
        "phone": "97142782300 / 971551154791",
        "email": "GLeggate@wfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e2b82cfc-80a5-4957-ae41-b1a7beb693c1",
    "firmName": "Watson, Farley & Williams (Middle East) LLP",
    "registrationNumber": "L-02640",
    "licenseIssueDate": "08/14/2014 00:00:00",
    "licenseExpiryDate": "08/08/2026 00:00:00"
  },
  {
    "id": "21aa767b-8a90-4a6c-9211-5f5d6ded960c",
    "slug": "michael-yow-shyong-chong",
    "name": "Michael Yow Shyong Chong",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/12/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Michael Yow Shyong Chong",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_21aa767b-8a90-4a6c-9211-5f5d6ded960c",
        "address": "- ,Index Tower ,Dubai International Financial Centre ,9371 ,Dubai",
        "phone": "97143303900 / 971561753537",
        "email": "christopher@afridi-angell.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3e464dc8-b800-4ba2-ad91-24a5f9640fef",
    "firmName": "Afridi & Angell-DIFC",
    "registrationNumber": "L-06386",
    "licenseIssueDate": "07/12/2024 00:00:00",
    "licenseExpiryDate": "07/11/2026 00:00:00"
  },
  {
    "id": "c765b549-88fe-46a5-a6de-d120510777b9",
    "slug": "michele-discepola",
    "name": "Michele Discepola",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/22/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Michele Discepola",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c765b549-88fe-46a5-a6de-d120510777b9",
        "address": "ICD Brookfield Place ,DIFC ,506516 ,",
        "phone": "97143695800 / 971505526206",
        "email": "scott.campbell@linklaters.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5cec94c0-0649-43b6-a2be-ab17ff422bce",
    "firmName": "LinkLaters LLP",
    "registrationNumber": "L-06073",
    "licenseIssueDate": "11/22/2023 00:00:00",
    "licenseExpiryDate": "11/21/2025 00:00:00"
  },
  {
    "id": "ec1ccd11-3da0-400f-b897-a0c9eaeb3fa4",
    "slug": "michelle-nicole-davis-ratcliffe",
    "name": "Michelle Nicole Davis-Ratcliffe",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/14/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Michelle Nicole Davis-Ratcliffe",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ec1ccd11-3da0-400f-b897-a0c9eaeb3fa4",
        "address": "6 ,Office Nos. 603, 604 & 605, Level 6, Burj Daman ,Dubai International Financial Centre ,506555 ,Dubai",
        "phone": "97143506400 / 971504654755",
        "email": "r.hickman@aglaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8690f7d5-6b96-4649-9589-71303f2c2707",
    "firmName": "Addleshaw Goddard (Middle East) LLP",
    "registrationNumber": "L-05592",
    "licenseIssueDate": "12/14/2022 00:00:00",
    "licenseExpiryDate": "12/13/2025 00:00:00"
  },
  {
    "id": "9c2d48a5-398a-427d-ad2a-93c6c1191cf6",
    "slug": "midya-helen-omar",
    "name": "Midya Helen Omar",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/21/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Midya Helen Omar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9c2d48a5-398a-427d-ad2a-93c6c1191cf6",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-06602",
    "licenseIssueDate": "11/21/2024 00:00:00",
    "licenseExpiryDate": "11/20/2025 00:00:00"
  },
  {
    "id": "ec05c1f5-192e-457b-8365-270034d847cc",
    "slug": "mikhael-haddad",
    "name": "Mikhael Haddad",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mikhael Haddad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ec05c1f5-192e-457b-8365-270034d847cc",
        "address": "الخامس  ,مكاتب عود ميثاء ,فندق رافلز ,11268 ,Dubai",
        "phone": "97143243330",
        "email": "avocat@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "25d2c9bd-dbba-41ac-aff9-5ba0f37290d6",
    "firmName": "AL QARI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-01341",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "81382eec-f564-4166-8f91-8d76d98881cf",
    "slug": "mikhail-bychikhin",
    "name": "Mikhail Bychikhin",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/22/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mikhail Bychikhin",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_81382eec-f564-4166-8f91-8d76d98881cf",
        "address": "",
        "phone": "97143826100 / 971507380618",
        "email": "jmiocevic@curtis.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0867bcc5-10fa-4783-91ae-b8f63e02e81a",
    "firmName": "Curtis Mallet-Prevost, Colt & Mosle LLP",
    "registrationNumber": "L-06327",
    "licenseIssueDate": "05/22/2024 00:00:00",
    "licenseExpiryDate": "05/21/2026 00:00:00"
  },
  {
    "id": "a341b413-668d-4f13-b2db-d583891f33d2",
    "slug": "millie-rose-hubbard",
    "name": "Millie Rose Hubbard",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/08/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Millie Rose Hubbard",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a341b413-668d-4f13-b2db-d583891f33d2",
        "address": "THE OFFICES 1 ,DWTC ,115580 ,",
        "phone": "97143739700 / 971501148248",
        "email": "nitesh.pradhan@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "361fdc64-6b6f-4f37-abca-c52af8473b84",
    "firmName": "Pinsent Masons  LLP (DWTCA Branch)",
    "registrationNumber": "L-06304",
    "licenseIssueDate": "05/08/2024 00:00:00",
    "licenseExpiryDate": "05/07/2026 00:00:00"
  },
  {
    "id": "7a82d0cd-f41e-419a-8e90-fd809ab3c516",
    "slug": "mina-ayse-morova",
    "name": "Mina Ayse Morova",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/05/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mina Ayse Morova",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7a82d0cd-f41e-419a-8e90-fd809ab3c516",
        "address": "Gate Village 10 ,Dubai International Financial Centre ,504945 ,",
        "phone": "97143301800 / 971569904245",
        "email": "nikram@velaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "61216046-6cd5-410d-a301-532f3e520e30",
    "firmName": "Vinson & Elkins LLP",
    "registrationNumber": "L-04982",
    "licenseIssueDate": "07/05/2021 00:00:00",
    "licenseExpiryDate": "07/04/2026 00:00:00"
  },
  {
    "id": "9d0ae526-d560-463c-98af-a6ee44636d09",
    "slug": "mira-saleh-akram-bagaeen",
    "name": "Mira Saleh Akram Bagaeen",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/02/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mira Saleh Akram Bagaeen",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9d0ae526-d560-463c-98af-a6ee44636d09",
        "address": "Index Tower ,506548 ,Dubai",
        "phone": "97147096300 / 971506767433",
        "email": "amateen@reedsmith.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b3f87e90-7ce9-4097-82c4-15232365f175",
    "firmName": "Reed Smith LLP",
    "registrationNumber": "L-06696",
    "licenseIssueDate": "02/19/2025 00:00:00",
    "licenseExpiryDate": "02/18/2026 00:00:00"
  },
  {
    "id": "4eae02bb-4296-4d83-8a29-fcb86007b824",
    "slug": "mirazizbek-makhamatzhanov",
    "name": "Mirazizbek Makhamatzhanov",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/06/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mirazizbek Makhamatzhanov",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4eae02bb-4296-4d83-8a29-fcb86007b824",
        "address": "Mohamed Alhammadi ,FLOOR 16 OFFICE B1605 ,LATIFA TOWER ,CLOSE TO CROWN PLAZA HOTEL ,76550 ,Dubai",
        "phone": "97143298866",
        "email": "admin@dralhammadilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "612e75e6-c3f3-479b-bc93-ee88982dea58",
    "firmName": "DR MOHAMED ALHAMMADI ADVOCATES & LEGAL CONSULTANTS OFFICE",
    "registrationNumber": "L-06105",
    "licenseIssueDate": "12/06/2023 00:00:00",
    "licenseExpiryDate": "12/05/2025 00:00:00"
  },
  {
    "id": "dd299364-c95b-415c-8b40-b83df85b7ab7",
    "slug": "mirghani-abdelaziz-mirghani-mohamed",
    "name": "MIRGHANI ABDELAZIZ MIRGHANI MOHAMED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/12/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-12-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mirghani Abdelaziz Mirghani Mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dd299364-c95b-415c-8b40-b83df85b7ab7",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-01869",
    "licenseIssueDate": "12/20/2017 00:00:00",
    "licenseExpiryDate": "12/19/2019 00:00:00"
  },
  {
    "id": "abe3b31a-81d7-4fd7-a372-f4cd1aae9ec5",
    "slug": "mirna-amir-joseph-lakah",
    "name": "MIRNA AMIR JOSEPH LAKAH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/02/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MIRNA AMIR JOSEPH LAKAH",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_abe3b31a-81d7-4fd7-a372-f4cd1aae9ec5",
        "address": "amal albastaki ,1903 ,court ,business bay ,127477 ,Dubai",
        "phone": "97142522202",
        "email": "info@amaladvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "f852bccd-2696-4190-9b40-77a8fb9c460f",
    "firmName": "AMAL ALBASTAKI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-06438",
    "licenseIssueDate": "08/02/2024 00:00:00",
    "licenseExpiryDate": "08/01/2026 00:00:00"
  },
  {
    "id": "5f599cf9-e975-49e2-b486-0e75676a8dcd",
    "slug": "misha-talwar-anand-talwar",
    "name": "MISHA TALWAR ANAND TALWAR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/08/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MISHA TALWAR ANAND TALWAR",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5f599cf9-e975-49e2-b486-0e75676a8dcd",
        "address": "Sarhan Hassan Mohamed Hassan Almuaini ,Office 1002, Level 10 ,THE OBEROI CENTRE ,Business Bay Metro Station ,1169 ,Dubai",
        "phone": "97142324000",
        "email": "info@drsarhanlawyer.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "14541022-bde4-43ab-9ba1-489e87187b42",
    "firmName": "DR SARHAN ALMUAINI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06465",
    "licenseIssueDate": "08/21/2024 00:00:00",
    "licenseExpiryDate": "08/20/2025 00:00:00"
  },
  {
    "id": "3ac3e795-92dc-4114-ae33-f76648893ee4",
    "slug": "missba-nizami",
    "name": "Missba Nizami",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/06/2024",
    "licenseStatus": "active",
    "licenseExpiry": "2025-06-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Missba Nizami",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3ac3e795-92dc-4114-ae33-f76648893ee4",
        "address": "",
        "phone": "97144230555 / 971504788443",
        "email": "yah@hfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c462c65e-185a-4e81-8425-a87e3a2b6842",
    "firmName": "Holman Fenwick Willan Middle East LLP",
    "registrationNumber": "L-06377",
    "licenseIssueDate": "06/26/2024 00:00:00",
    "licenseExpiryDate": "06/25/2026 00:00:00"
  },
  {
    "id": "13bfafc6-80ad-459e-927a-4c732329daf2",
    "slug": "moamen-ahmed-mohamed-mohamed-elwan",
    "name": "Moamen Ahmed Mohamed Mohamed Elwan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/23/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Moamen Ahmed Mohamed Mohamed Elwan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_13bfafc6-80ad-459e-927a-4c732329daf2",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-05343",
    "licenseIssueDate": "05/23/2022 00:00:00",
    "licenseExpiryDate": "05/22/2026 00:00:00"
  },
  {
    "id": "02c30a0a-481e-49b6-a3ca-a052b6c3c9bf",
    "slug": "moamen-mohamed-tarek-mohamed-mohamed-ahmed",
    "name": "Moamen Mohamed Tarek Mohamed Mohamed Ahmed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/06/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Moamen Mohamed Tarek Mohamed Mohamed Ahmed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_02c30a0a-481e-49b6-a3ca-a052b6c3c9bf",
        "address": "6F 603, 605, 7F 704 ,Crystal Tower ,Dubai Mall ,117538 ,Dubai",
        "phone": "97146098700",
        "email": "pro@miolawfirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "417f90a1-03be-4dab-8eea-1bba7e16f536",
    "firmName": "ABU BAKER SALEM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06798",
    "licenseIssueDate": "05/06/2025 00:00:00",
    "licenseExpiryDate": "05/05/2026 00:00:00"
  },
  {
    "id": "e7340bdf-1584-4801-b4bc-1e5996350f12",
    "slug": "moataz-ahmed-abdalnaby-mohamed-haidar",
    "name": "Moataz Ahmed Abdalnaby Mohamed Haidar",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/05/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Moataz Ahmed Abdalnaby Mohamed Haidar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e7340bdf-1584-4801-b4bc-1e5996350f12",
        "address": "",
        "phone": "97100000000 / 971504766660",
        "email": "info@eza.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "f6dee20d-9392-4f89-96bd-b1f89bcef71a",
    "firmName": "ESAM ALZAROONI ADVOCATES &LEGAL CONSULTANTS",
    "registrationNumber": "L-06609",
    "licenseIssueDate": "12/05/2024 00:00:00",
    "licenseExpiryDate": "12/04/2025 00:00:00"
  },
  {
    "id": "f3f2a0dd-1b56-4989-96f2-db57f800668c",
    "slug": "moataz-mohamed-abdo-khattab",
    "name": "Moataz Mohamed Abdo Khattab",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/12/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Moataz Mohamed Abdo Khattab",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f3f2a0dd-1b56-4989-96f2-db57f800668c",
        "address": "Bader Aljassmy ,3 ,دبي كوميرسيتي ,دبي كوميرسيتي ,410004 ,Dubai",
        "phone": "97148760777 / 971586842086",
        "email": "info@bajlegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7e820dd9-2748-4876-88db-ff7948542895",
    "firmName": "AL BASTAKI & Al JASMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05300",
    "licenseIssueDate": "04/12/2022 00:00:00",
    "licenseExpiryDate": "04/11/2026 00:00:00"
  },
  {
    "id": "ce2d032b-5251-4f04-8498-6d69ec13194c",
    "slug": "moaz-forawi",
    "name": "Moaz  Forawi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Moaz  Forawi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ce2d032b-5251-4f04-8498-6d69ec13194c",
        "address": "23 ,Rolex Tower ,Trade Center Second ,116637 ,Dubai",
        "phone": "97144357577 / 971502101003",
        "email": "jasamin.fichte@fichtelegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "77bf4fd2-1cd1-4bda-a0c2-ffcac3980b76",
    "firmName": "Fichte & Co Legal Consultancy",
    "registrationNumber": "L-00547",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "a272f1dd-bd68-4cb8-81fb-9c4ce990b9f7",
    "slug": "modather-nasr-gianwi",
    "name": "Modather Nasr Gianwi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/21/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Modather Nasr Gianwi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a272f1dd-bd68-4cb8-81fb-9c4ce990b9f7",
        "address": "1007 ,برج لطيفة ,بجوار فندق كراون بلازل ,94873 ,Abu Dhabi",
        "phone": "97142951555 / 971567573911",
        "email": "info@mbhadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d3e210f-8234-4e00-b9e6-1167758a43ee",
    "firmName": "MOHAMMED BANI HASHEM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01668",
    "licenseIssueDate": "10/21/2024 00:00:00",
    "licenseExpiryDate": "10/20/2026 00:00:00"
  },
  {
    "id": "4007b4f1-2c38-413a-a34e-8091c8090241",
    "slug": "mogamad-zain-satardien",
    "name": "Mogamad Zain Satardien",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNWgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/18/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mogamad Zain Satardien",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4007b4f1-2c38-413a-a34e-8091c8090241",
        "address": "One Central, The Offices 5 ,Dubai World Trade Centre ,554660 ,",
        "phone": "97142052030 / 971506566494",
        "email": "chourani@houranipartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "59a73632-40a0-4849-b120-4308dc6f8015",
    "firmName": "Hourani & Partners Legal Consultancy FZCO",
    "registrationNumber": "L-05433",
    "licenseIssueDate": "07/18/2022 00:00:00",
    "licenseExpiryDate": "07/17/2026 00:00:00"
  },
  {
    "id": "76cec3d2-7831-44d3-9879-19ff004cccea",
    "slug": "mohamad-basam",
    "name": "MOHAMAD BASAM",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/08/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MOHAMAD BASAM",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_76cec3d2-7831-44d3-9879-19ff004cccea",
        "address": "الخامس  ,البرج الأخضر  ,خلف فندق موسكو  ,5630 ,Dubai",
        "phone": "97142222888",
        "email": "fayadlaw@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "216ebf72-e55b-4446-b7a6-5c17ba8c9b5d",
    "firmName": "HIKMAT FAYAD AND ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05361",
    "licenseIssueDate": "06/08/2022 00:00:00",
    "licenseExpiryDate": "06/07/2026 00:00:00"
  },
  {
    "id": "6d0ef4ea-d7bf-46de-9e11-02830c6c964d",
    "slug": "mohamad-majd-baroudi",
    "name": "Mohamad Majd Baroudi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamad Majd Baroudi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6d0ef4ea-d7bf-46de-9e11-02830c6c964d",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02282",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "0fe73380-9c51-49dd-9eaa-1cd5e7cb9f55",
    "slug": "mohamad-nasser-el-dine-fayad",
    "name": "Mohamad Nasser El Dine Fayad",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/01/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamad Nasser El Dine Fayad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0fe73380-9c51-49dd-9eaa-1cd5e7cb9f55",
        "address": "YASIR AL NAQBI ,21 ,48 BURJ ,SOFITEL DOWN  TOWN ,181111 ,Dubai",
        "phone": "97142689949",
        "email": "info@alnaqbipartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ad71430e-83ee-4cb5-a530-bc58db2618f6",
    "firmName": "ALNAQBI & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05068",
    "licenseIssueDate": "11/01/2021 00:00:00",
    "licenseExpiryDate": "10/31/2025 00:00:00"
  },
  {
    "id": "5936839c-5022-4307-803b-d7dc35e12929",
    "slug": "mohamd-tamam-almasrani",
    "name": "MOHAMD TAMAM ALMASRANI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/09/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MOHAMD TAMAM ALMASRANI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5936839c-5022-4307-803b-d7dc35e12929",
        "address": "",
        "phone": "97150399980 / 971501547188",
        "email": "advocatesaraalsaedi@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c1be7ace-26d4-45ed-8292-e5992286f1ef",
    "firmName": "Sara Alsaedi Advocates and Legal Consultants",
    "registrationNumber": "L-05960",
    "licenseIssueDate": "08/09/2023 00:00:00",
    "licenseExpiryDate": "08/08/2026 00:00:00"
  },
  {
    "id": "0cd8e08a-2e14-4af0-a31c-f4e288f26db7",
    "slug": "mohamed-aamir-sheikh",
    "name": "Mohamed Aamir Sheikh",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/03/2023",
    "licenseStatus": "active",
    "licenseExpiry": "2024-03-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Aamir Sheikh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0cd8e08a-2e14-4af0-a31c-f4e288f26db7",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-05713",
    "licenseIssueDate": "03/22/2023 00:00:00",
    "licenseExpiryDate": "03/21/2026 00:00:00"
  },
  {
    "id": "34c22be5-073e-4ada-beb4-9f95cc8ddd28",
    "slug": "mohamed-abdalla-ismail-eldafrawy",
    "name": "Mohamed Abdalla Ismail Eldafrawy",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/08/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Abdalla Ismail Eldafrawy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_34c22be5-073e-4ada-beb4-9f95cc8ddd28",
        "address": "",
        "phone": "97144230000 / 971552009022",
        "email": "UAE-CourtClerks@habibalmulla.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3eba82bb-8ec4-4cbd-80d0-a793cb993fde",
    "firmName": "Habib Al Mulla & Partners ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02152",
    "licenseIssueDate": "02/08/2024 00:00:00",
    "licenseExpiryDate": "02/07/2026 00:00:00"
  },
  {
    "id": "30d798a0-383c-46b1-9e97-9d162a8a9776",
    "slug": "mohamed-abdallah-abdelrahman-azzam",
    "name": "mohamed abdallah abdelrahman azzam",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/28/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: mohamed abdallah abdelrahman azzam",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_30d798a0-383c-46b1-9e97-9d162a8a9776",
        "address": "SAAD AL HAMMADI ,مدخل البرج ,ويست بيري ,برج خليفه ,41747 ,Dubai",
        "phone": "97142405222",
        "email": "info@saadpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "18923100-5b94-44e2-b580-2e3b0cc17bf6",
    "firmName": "SAAD AL HAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04965",
    "licenseIssueDate": "06/28/2021 00:00:00",
    "licenseExpiryDate": "06/27/2026 00:00:00"
  },
  {
    "id": "d8bf072a-a950-471b-9cb2-42d0dad9bd65",
    "slug": "mohamed-abdel-moneim-mohamed-ibrahim",
    "name": "Mohamed Abdel Moneim Mohamed Ibrahim",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Abdel Moneim Mohamed Ibrahim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d8bf072a-a950-471b-9cb2-42d0dad9bd65",
        "address": "702-703 ,THE EXCHANGE TOWER ,NEAR IN BUSINESS BAY METRO STATION ,90009 ,Dubai",
        "phone": "97142327888",
        "email": "info@alowaislaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "83647634-f0b7-4ccb-b71c-6d00bfdb84de",
    "firmName": "ABDALLA ALOWAIS ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-01896",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "1c375073-9a00-44c6-aa6b-006047828d0c",
    "slug": "mohamed-abdelazim-elsayed-mohamed-khalifa",
    "name": "Mohamed AbdelAzim ElSayed Mohamed Khalifa",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/26/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed AbdelAzim ElSayed Mohamed Khalifa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1c375073-9a00-44c6-aa6b-006047828d0c",
        "address": "الخامس ,مونتانا ,هوم سنتر ,28834 ,Dubai",
        "phone": "97143963739",
        "email": "mousaadv@eim.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "af9dbfb0-4310-41bb-90aa-a3055b865d84",
    "firmName": "EBRAHIM ALI AL MOUSA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05554",
    "licenseIssueDate": "10/26/2022 00:00:00",
    "licenseExpiryDate": "10/25/2025 00:00:00"
  },
  {
    "id": "524bf99f-35e4-4ee6-b8d5-1a092476805e",
    "slug": "mohamed-abdelazim-hassouna",
    "name": "Mohamed Abdelazim Hassouna",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/18/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Abdelazim Hassouna",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_524bf99f-35e4-4ee6-b8d5-1a092476805e",
        "address": "",
        "phone": "97143573330",
        "email": "admin@dhahiadvocate.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5b668acf-1fdb-4057-81f9-05d9aeb7aca9",
    "firmName": "AHMED BIN DHAHI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02192",
    "licenseIssueDate": "10/18/2011 00:00:00",
    "licenseExpiryDate": "10/09/2026 00:00:00"
  },
  {
    "id": "0cb41bbf-1607-4dcb-aeb7-126d764f17db",
    "slug": "mohamed-abdelaziz-abdalla-saadalla",
    "name": "Mohamed Abdelaziz Abdalla Saadalla",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/30/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Abdelaziz Abdalla Saadalla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0cb41bbf-1607-4dcb-aeb7-126d764f17db",
        "address": "",
        "phone": "97142200399 / 971971422003",
        "email": "info@ssjlawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "43903b58-f2e6-4825-beac-fd001ee7018a",
    "firmName": "SAMYA SAEED ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06563",
    "licenseIssueDate": "10/30/2024 00:00:00",
    "licenseExpiryDate": "10/29/2025 00:00:00"
  },
  {
    "id": "278045aa-7e66-43f3-84b8-9c5144dc7239",
    "slug": "mohamed-abdelbaset-abounar",
    "name": "Mohamed Abdelbaset Abounar",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/28/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Abdelbaset Abounar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_278045aa-7e66-43f3-84b8-9c5144dc7239",
        "address": "",
        "phone": "97142868681",
        "email": "hawailaw@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3f1d962a-159f-4d0f-82d0-ebd94930d6ae",
    "firmName": "LAW OFFICE OF MAHMOUD AL HAWAI ATTORNEYS &CONSULTANTS AT LAW",
    "registrationNumber": "L-02878",
    "licenseIssueDate": "09/28/2014 00:00:00",
    "licenseExpiryDate": "09/22/2026 00:00:00"
  },
  {
    "id": "65a47421-dfed-453a-895b-8de1cb4017bd",
    "slug": "mohamed-abdelfattah-mohamed-helmy-elhoufy",
    "name": "mohamed abdelfattah mohamed helmy elhoufy",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/06/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: mohamed abdelfattah mohamed helmy elhoufy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_65a47421-dfed-453a-895b-8de1cb4017bd",
        "address": "6F 603, 605, 7F 704 ,Crystal Tower ,Dubai Mall ,117538 ,Dubai",
        "phone": "97146098700",
        "email": "pro@miolawfirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "417f90a1-03be-4dab-8eea-1bba7e16f536",
    "firmName": "ABU BAKER SALEM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05349",
    "licenseIssueDate": "07/06/2022 00:00:00",
    "licenseExpiryDate": "07/05/2026 00:00:00"
  },
  {
    "id": "899ecba3-ec59-4c5b-8e8b-21c28c09c8ad",
    "slug": "mohamed-abdelghaffar-ramadan-mohamed-badreldin",
    "name": "Mohamed Abdelghaffar Ramadan Mohamed Badreldin",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/08/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Abdelghaffar Ramadan Mohamed Badreldin",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_899ecba3-ec59-4c5b-8e8b-21c28c09c8ad",
        "address": "mansoor lootah ,مطعم شيلز ,صالح بن لاحج , مطعم شيلز  ,95151 ,Dubai",
        "phone": "97142833337 / 971559596445",
        "email": "info@mansoorlootahadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4488ad94-e6b8-4b33-8e21-04e8986bf218",
    "firmName": "MANSOOR LOTAAH ADVOCATES &LEGAL CONSULTANCY",
    "registrationNumber": "L-04593",
    "licenseIssueDate": "01/08/2020 00:00:00",
    "licenseExpiryDate": "01/07/2026 00:00:00"
  },
  {
    "id": "4fd587ea-f761-4deb-abfc-19ef363e2321",
    "slug": "mohamed-abdelkader",
    "name": "Mohamed Abdelkader",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/02/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Abdelkader",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4fd587ea-f761-4deb-abfc-19ef363e2321",
        "address": "13 ,المنارة ,الخليج التجاري  ,455755 ,Dubai",
        "phone": "97144106480",
        "email": "alessalawfirm@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "469613e7-96d7-4b4d-82f2-5ab24490a43f",
    "firmName": "HAMAD ALESSA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03593",
    "licenseIssueDate": "04/02/2024 00:00:00",
    "licenseExpiryDate": "04/01/2026 00:00:00"
  },
  {
    "id": "836e59c3-4fec-403a-ba4e-cb46f4995170",
    "slug": "mohamed-abdelkader-hefny",
    "name": "Mohamed Abdelkader Hefny",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/10/2013",
    "licenseStatus": "active",
    "licenseExpiry": "2014-10-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Abdelkader Hefny",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_836e59c3-4fec-403a-ba4e-cb46f4995170",
        "address": "ali mohamed amin  ,205 - 104  ,اثراء  ,بالقرب من فندق جميرا طيران الامارات  ,10155 ,Dubai",
        "phone": "97143967188",
        "email": "aliadvocates71@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "298ff405-ca8b-4fc8-a674-74ae24832268",
    "firmName": "ALI NAQI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02332",
    "licenseIssueDate": "10/29/2013 00:00:00",
    "licenseExpiryDate": "12/20/2025 00:00:00"
  },
  {
    "id": "c0243ca1-e0ae-4c53-851c-9b8d56c5f33b",
    "slug": "mohamed-abdelmonaim-mohamed-saad",
    "name": "MOHAMED ABDELMONAIM MOHAMED SAAD",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/06/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2023-05-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Abdelmonaim Mohamed Saad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c0243ca1-e0ae-4c53-851c-9b8d56c5f33b",
        "address": "الطابق الثاني - مكتب رقم 203 و 204  ,سيتي أفينو ,سيتى سنتر ديرة  ,83666 ,Dubai",
        "phone": "97142955050",
        "email": "adv.algharib@alghariblawfirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b1e23b77-356c-4678-ae4d-2ff4e494702b",
    "firmName": "ALGHARIB & PARTNERS ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-05144",
    "licenseIssueDate": "12/06/2021 00:00:00",
    "licenseExpiryDate": "12/05/2023 00:00:00"
  },
  {
    "id": "92494e31-f543-4a58-af8d-113ba78dfac0",
    "slug": "mohamed-abdelraheem",
    "name": "Mohamed Abdelraheem",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Abdelraheem",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_92494e31-f543-4a58-af8d-113ba78dfac0",
        "address": "10th Floor ,AlReem Tower ,Dubai Land Department ,32367 ,Dubai",
        "phone": "97142272701",
        "email": "midfaadv@eim.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "fe9068a7-b94d-49bb-88b3-6f8491a15389",
    "firmName": "AL MIDFA & ASSOCIATES",
    "registrationNumber": "L-01416",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "8e4a3f8c-36b5-4d88-adcd-e9c8db5cd24d",
    "slug": "mohamed-abdelrahman-mahrous-bakr",
    "name": "Mohamed Abdelrahman Mahrous Bakr",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Abdelrahman Mahrous Bakr",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8e4a3f8c-36b5-4d88-adcd-e9c8db5cd24d",
        "address": "O-4801, O-4901 ,Burj al Salam Office Tower ,H Hotel ,111801 ,Dubai",
        "phone": "97143544444",
        "email": "administration@horizlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4e25fb39-6659-44f0-bc8b-3ff0f067beb0",
    "firmName": "HORIZONS & CO - LAW FIRM",
    "registrationNumber": "L-01444",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "971ae049-c8bd-43b1-bab4-967ae7ca900e",
    "slug": "mohamed-abdelrhman-khafagy",
    "name": "Mohamed Abdelrhman Khafagy",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Abdelrhman Khafagy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_971ae049-c8bd-43b1-bab4-967ae7ca900e",
        "address": "الثالث  ,اركاد  ,الطاير للسيارات  ,20877 ,Dubai",
        "phone": "97142833355",
        "email": "Fahadadvo@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7dd7860a-cd36-443b-a1b7-62dd3050e6b9",
    "firmName": "FAHAD ABDULLA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03075",
    "licenseIssueDate": "01/03/2023 00:00:00",
    "licenseExpiryDate": "01/02/2026 00:00:00"
  },
  {
    "id": "f76da05c-504d-4321-a9d5-81d36d37d421",
    "slug": "mohamed-abdulkader-alnaeli",
    "name": "Mohamed Abdulkader Alnaeli",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/11/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Abdulkader Alnaeli",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f76da05c-504d-4321-a9d5-81d36d37d421",
        "address": "الطابق الثالث ,بناية مكاتب عود ميثاء ,سيتي بانك ,78853 ,Dubai",
        "phone": "97142220585 / 971506555166",
        "email": "info@kasadv.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ec4ada87-49a0-432b-a843-e47adccd286f",
    "firmName": "KHALIFA ALSADA ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-05166",
    "licenseIssueDate": "01/11/2022 00:00:00",
    "licenseExpiryDate": "01/10/2026 00:00:00"
  },
  {
    "id": "24222c5f-87ac-4c40-b5a4-0aa68be5149f",
    "slug": "mohamed-abou-el-fetouh-nil",
    "name": "Mohamed Abou El Fetouh Nil",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/25/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Abou El Fetouh Nil",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_24222c5f-87ac-4c40-b5a4-0aa68be5149f",
        "address": "MOHAMMED MURTADA ALHASHMI ,3 ,LATIFA TOWER  ,CROWN PLAZA ,231400 ,Dubai",
        "phone": "97143521131",
        "email": "info@mhadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a5a2640f-b1b8-4512-b9ee-a8802d0c30fc",
    "firmName": "MOHAMMED AL HASHIMI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-02432",
    "licenseIssueDate": "01/25/2012 00:00:00",
    "licenseExpiryDate": "01/16/2026 00:00:00"
  },
  {
    "id": "d52b3d7c-7e24-4eb8-b4c7-9a6da47b6764",
    "slug": "mohamed-abouelenein",
    "name": "Mohamed AbouElenein",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed AbouElenein",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d52b3d7c-7e24-4eb8-b4c7-9a6da47b6764",
        "address": "Floor 7 ,Sama Tower  ,Dubai World Trade Centre ,120059 ,Dubai",
        "phone": "97142954626 / 971506311169",
        "email": "info@jmadvocatesuae.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5a33c148-b449-40a3-a945-e3a2eb7cbdda",
    "firmName": "JASIM ALMAEENI ADVOCATES & LEGAL CONSULTANT",
    "registrationNumber": "L-01370",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "fca3a335-8857-4fbe-b089-fead57eb8648",
    "slug": "mohamed-abouelhamd-ahmed-elsayed-elsakag",
    "name": "Mohamed Abouelhamd Ahmed Elsayed Elsakag",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/28/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Abouelhamd Ahmed Elsayed Elsakag",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fca3a335-8857-4fbe-b089-fead57eb8648",
        "address": "ادارة ا لمبنى  ,الريم ,الاتصالات  ,42423 ,Dubai",
        "phone": "97142222066",
        "email": "info@ozleco.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7a155f4a-20ec-44ff-863f-4f9fb43d0af4",
    "firmName": "ALOBAIDLI & ALZAROONI ADVOCATES&LEGAL CONSULTANTS",
    "registrationNumber": "L-04970",
    "licenseIssueDate": "06/28/2021 00:00:00",
    "licenseExpiryDate": "06/27/2026 00:00:00"
  },
  {
    "id": "c3f33b9c-1cb3-471a-84ac-dedede84457f",
    "slug": "mohamed-adam-bala-edam",
    "name": "Mohamed Adam Bala Edam",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/12/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Adam Bala Edam",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c3f33b9c-1cb3-471a-84ac-dedede84457f",
        "address": "",
        "phone": "97142500251",
        "email": "hassan.suwaidi@hhslawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "92cddf0e-969b-47c0-a9a7-9fb57a11d292",
    "firmName": "HASSAN HUMAID AL SUWAIDI ADVOCATES AND LEGAL CONSULTANCY",
    "registrationNumber": "L-06365",
    "licenseIssueDate": "06/12/2024 00:00:00",
    "licenseExpiryDate": "06/11/2026 00:00:00"
  },
  {
    "id": "70c72d6c-f87e-4b9e-8942-dcb554184c64",
    "slug": "mohamed-adel-ahmed-mohamed",
    "name": "Mohamed Adel Ahmed Mohamed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/23/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Adel Ahmed Mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_70c72d6c-f87e-4b9e-8942-dcb554184c64",
        "address": "HAMAD ABDULLA ABDULRAHMAN ALRAHMA ALHAMMADI ,14TH FLOOR - 1403 ,PARK PLACE TOWER ,WORLD TRADE CENTER ,114295 ,Dubai",
        "phone": "97144227465 / 971555507070",
        "email": "hessa.alshehhi@primecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d6da9923-01fb-4fd8-a9da-a02d2122dbde",
    "firmName": "Hessa Al Shehhi ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05985",
    "licenseIssueDate": "08/23/2023 00:00:00",
    "licenseExpiryDate": "08/22/2026 00:00:00"
  },
  {
    "id": "0260d855-a8cf-40de-a9cc-720f0a6b74e4",
    "slug": "mohamed-adel-hussein-abdelaal",
    "name": "mohamed adel hussein  abdelaal",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/08/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: mohamed adel hussein  abdelaal",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0260d855-a8cf-40de-a9cc-720f0a6b74e4",
        "address": "",
        "phone": "97142955388 / 971507739863",
        "email": "arhilal@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "364483f1-f3e9-4475-a7de-733d3e03062c",
    "firmName": "HILAL & ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05100",
    "licenseIssueDate": "11/08/2021 00:00:00",
    "licenseExpiryDate": "11/07/2025 00:00:00"
  },
  {
    "id": "2d6e36d8-a946-4a15-b558-4d9945aded9a",
    "slug": "mohamed-ahmed-abdalla",
    "name": "Mohamed Ahmed Abdalla",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/04/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Ahmed Abdalla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2d6e36d8-a946-4a15-b558-4d9945aded9a",
        "address": "SAUD SULTAN HAMAD ,1st Floor ,AL GARHOOD BUSINESS CENTER ,Al Garhoud Medical Fitness Center ,21785 ,Dubai",
        "phone": "97143331110 / 971551127667",
        "email": "info@alshebliadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b3f35be9-7673-4d3f-954b-6f64de96bc2b",
    "firmName": "SAUD ALSHEBLI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02114",
    "licenseIssueDate": "10/04/2011 00:00:00",
    "licenseExpiryDate": "09/25/2026 00:00:00"
  },
  {
    "id": "09205a4f-eb0d-4a8f-98e7-233717036edb",
    "slug": "mohamed-ahmed-abdeldeam",
    "name": "Mohamed Ahmed Abdeldeam",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/18/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Ahmed Abdeldeam",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_09205a4f-eb0d-4a8f-98e7-233717036edb",
        "address": "KEFAH ALZAABI ,3005 ,برج لطيفه  ,ابراج لطيفه  ,97597 ,Dubai",
        "phone": "97142522260",
        "email": "info@jazlawyers.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6fab0ce0-5a6b-4586-a900-862950161d02",
    "firmName": "JASIM ALZAROONI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02828",
    "licenseIssueDate": "11/18/2014 00:00:00",
    "licenseExpiryDate": "11/12/2025 00:00:00"
  },
  {
    "id": "11552bf7-c520-4140-be4e-6723b11c4204",
    "slug": "mohamed-ahmed-ahmed",
    "name": "Mohamed Ahmed Ahmed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/25/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-01-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Ahmed Ahmed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_11552bf7-c520-4140-be4e-6723b11c4204",
        "address": "",
        "phone": "97108307033",
        "email": "general.alshamsi@lawuae.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d29f6d04-dad1-4f59-9ae2-d4d245f63133",
    "firmName": "AL SHAMSI & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01223",
    "licenseIssueDate": "01/25/2012 00:00:00",
    "licenseExpiryDate": "01/16/2026 00:00:00"
  },
  {
    "id": "b0c1b48f-cde9-41b0-81e7-d3ef1c24cfd4",
    "slug": "mohamed-ahmed-ahmed-nasr",
    "name": "Mohamed Ahmed Ahmed Nasr",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/01/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Ahmed Ahmed Nasr",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b0c1b48f-cde9-41b0-81e7-d3ef1c24cfd4",
        "address": "",
        "phone": "",
        "email": "albaqishilaw@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d0aa88d9-03fd-49f6-83da-bce7d0e19a17",
    "firmName": "SARAH ALBAQISHI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06040",
    "licenseIssueDate": "11/01/2023 00:00:00",
    "licenseExpiryDate": "10/31/2025 00:00:00"
  },
  {
    "id": "0a12c56f-4cb1-4d72-a2c2-bbc3bcc9fe3c",
    "slug": "mohamed-ahmed-khalaf-ahmed",
    "name": "mohamed ahmed khalaf ahmed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/17/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: mohamed ahmed khalaf ahmed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0a12c56f-4cb1-4d72-a2c2-bbc3bcc9fe3c",
        "address": "",
        "phone": "97143256020 / 971504400073",
        "email": "info@sw-advocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "05dddabf-0dfa-4843-b0a8-cf6eaa27136d",
    "firmName": "MOHAMMAD SHEHAB ALFARSI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06959",
    "licenseIssueDate": "09/17/2025 00:00:00",
    "licenseExpiryDate": "09/16/2026 00:00:00"
  },
  {
    "id": "95097802-ed18-44c6-8ac6-409cf0f38be2",
    "slug": "mohamed-ahmed-mohamed-abdelaal-elmasry",
    "name": "Mohamed Ahmed Mohamed Abdelaal Elmasry",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/08/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Ahmed Mohamed Abdelaal Elmasry",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_95097802-ed18-44c6-8ac6-409cf0f38be2",
        "address": "Samia Luqman ,2nd floor ,Emarat Atrium Building ,across Holiday Inn Express Safa Park ,7273 ,Dubai",
        "phone": "97143211000",
        "email": "info@alsuwaidi.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0e5c3637-bc12-475c-a6b5-2d9ae84f2b8e",
    "firmName": "AL-SUWAIDI & COMPANY",
    "registrationNumber": "L-05174",
    "licenseIssueDate": "02/08/2022 00:00:00",
    "licenseExpiryDate": "02/07/2026 00:00:00"
  },
  {
    "id": "2dab7e60-530d-4d8b-9409-6b8218146554",
    "slug": "mohamed-ahmed-mohamed-elsharkawy",
    "name": "Mohamed Ahmed Mohamed Elsharkawy",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/21/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Ahmed Mohamed Elsharkawy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2dab7e60-530d-4d8b-9409-6b8218146554",
        "address": "",
        "phone": "97143685555",
        "email": "maisa.maarouf@bsabh.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8afa232f-52ff-4dad-82c3-9a04d66eb853",
    "firmName": "B S A AHMED BIN HAZEEM & ASSOCIATES LLP - DIFC",
    "registrationNumber": "L-05673",
    "licenseIssueDate": "12/21/2022 00:00:00",
    "licenseExpiryDate": "12/20/2025 00:00:00"
  },
  {
    "id": "5c872720-3556-4283-9dfa-89ea8a519e52",
    "slug": "mohamed-ahmed-mohamed-ibrahim-elbadawi",
    "name": "MOHAMED AHMED MOHAMED IBRAHIM ELBADAWI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/14/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MOHAMED AHMED MOHAMED IBRAHIM ELBADAWI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5c872720-3556-4283-9dfa-89ea8a519e52",
        "address": "amna alzaabi ,213 ,مبنى مكاتب عود ميثاء ,سيتي بنك ,16189 ,Dubai",
        "phone": "97145822422",
        "email": "info@amnalegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a30322e3-d9be-4ba2-ba94-2ebf6f963319",
    "firmName": "AMNA ALZAABI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06338",
    "licenseIssueDate": "05/14/2024 00:00:00",
    "licenseExpiryDate": "05/13/2026 00:00:00"
  },
  {
    "id": "8ac24f3f-6362-4a94-9742-7f5f4b2c65e6",
    "slug": "mohamed-ahmed-mohamed-mohamed-felifel",
    "name": "Mohamed Ahmed Mohamed Mohamed Felifel",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/16/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Ahmed Mohamed Mohamed Felifel",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8ac24f3f-6362-4a94-9742-7f5f4b2c65e6",
        "address": "3-505 ,AL KHABEESI BLDG ,AL KABEESI ,4948 ,Dubai",
        "phone": "97142222228",
        "email": "info@alkamali.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "054f38f4-9e51-4623-ad36-7941043a051c",
    "firmName": "AL KAMALI & COMPANY ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-02262",
    "licenseIssueDate": "11/16/2011 00:00:00",
    "licenseExpiryDate": "11/07/2025 00:00:00"
  },
  {
    "id": "bdfc8ee3-5c2e-422e-8cbf-f8fcc437b4fb",
    "slug": "mohamed-ahmed-mohamed-omar-elnagar",
    "name": "MOHAMED AHMED MOHAMED OMAR ELNAGAR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/13/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MOHAMED AHMED MOHAMED OMAR ELNAGAR",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bdfc8ee3-5c2e-422e-8cbf-f8fcc437b4fb",
        "address": "Mohamed Thamer Yaqub Yousef Alserkal ,الطابق الثاني ,اعمار سكوير - بناء رقم 4 ,برج خليفة ,57409 ,Dubai",
        "phone": "97142622217 / 97142622217",
        "email": "mohamed@alserkallawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2a224392-a975-448f-aec5-0460984b1124",
    "firmName": "MOHAMED ALSERKAL ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06812",
    "licenseIssueDate": "05/13/2025 00:00:00",
    "licenseExpiryDate": "05/12/2026 00:00:00"
  },
  {
    "id": "3546b91d-a849-470f-982e-0bf7000bdd7b",
    "slug": "mohamed-ahmed-moheb-mahmoud-mansour",
    "name": "Mohamed Ahmed Moheb Mahmoud Mansour",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/30/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Ahmed Moheb Mahmoud Mansour",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3546b91d-a849-470f-982e-0bf7000bdd7b",
        "address": "15th Floor _ Office No. 1504 ,SOBHA SAPPHIRE ,Makani No: 2612485764 ,000 ,Dubai",
        "phone": "97145570789 / 971521800001",
        "email": "Info@iserkal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "196bb7bb-4be6-4029-9367-c100bd219d3f",
    "firmName": "ABDULLA AL HADDAD ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-06574",
    "licenseIssueDate": "10/30/2024 00:00:00",
    "licenseExpiryDate": "10/29/2025 00:00:00"
  },
  {
    "id": "3fb23b14-732b-4dc2-a364-24152115e52e",
    "slug": "mohamed-ahmed-noureldin-mohamed",
    "name": "mohamed ahmed noureldin mohamed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/08/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: mohamed ahmed noureldin mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3fb23b14-732b-4dc2-a364-24152115e52e",
        "address": "",
        "phone": "97145642777 / 971508551535",
        "email": "legal@alnajjarlawyer.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "1670d8d1-6114-4b77-b2da-9d4c0dc0054b",
    "firmName": "MOHAMMAD ALNAJJAR ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05761",
    "licenseIssueDate": "03/08/2023 00:00:00",
    "licenseExpiryDate": "03/07/2026 00:00:00"
  },
  {
    "id": "84431de4-4586-41c6-9d8c-358b2f4f6416",
    "slug": "mohamed-ahmed-osman-elsadek",
    "name": "Mohamed Ahmed Osman Elsadek",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/26/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Ahmed Osman Elsadek",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_84431de4-4586-41c6-9d8c-358b2f4f6416",
        "address": "الطابق العاشر - 1003 ,برج الريم ,خلف مقر اتصالات - ديرة ,64166 ,Dubai",
        "phone": "97143395953 / 971502110022",
        "email": "info@almazroueiadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0f57dd9c-c65a-4c45-bd06-695ca9e13f69",
    "firmName": "AHMED ALMAZROUEI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03870",
    "licenseIssueDate": "07/26/2017 00:00:00",
    "licenseExpiryDate": "07/23/2026 00:00:00"
  },
  {
    "id": "6f2c797a-bb4d-4ca7-84d9-813751ee9978",
    "slug": "mohamed-ahmed-shaaban",
    "name": "Mohamed Ahmed Shaaban",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/12/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Ahmed Shaaban",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6f2c797a-bb4d-4ca7-84d9-813751ee9978",
        "address": "",
        "phone": "97142552220",
        "email": "almaazmi.office@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e04d8a88-3378-40c8-a33a-b5e26a0c8507",
    "firmName": "ABDELRAHMAN AL MAAZMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02609",
    "licenseIssueDate": "04/12/2012 00:00:00",
    "licenseExpiryDate": "04/03/2026 00:00:00"
  },
  {
    "id": "d52d4f57-d336-41f5-be24-2b17f0b2be39",
    "slug": "mohamed-alaaeldin-elmaayergi",
    "name": "Mohamed Alaaeldin Elmaayergi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/31/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Alaaeldin Elmaayergi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d52d4f57-d336-41f5-be24-2b17f0b2be39",
        "address": "Adel Salem Abdulla Salem Alghafri ,16th floor, Office: 1602 ,Aspect Tower ,Bay Avenue Mall ,444470 ,Dubai",
        "phone": "97142807052 / 971555666589",
        "email": "info@adelalghafri.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d0789ea6-22d2-4893-aa99-e55ff1b4473a",
    "firmName": "ADEL AL GHAFRI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01976",
    "licenseIssueDate": "01/31/2023 00:00:00",
    "licenseExpiryDate": "01/30/2026 00:00:00"
  },
  {
    "id": "d21ce832-715d-4328-b690-4b284b6d5a74",
    "slug": "mohamed-al-fadly",
    "name": "Mohamed Al-Fadly",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/01/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Al-Fadly",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d21ce832-715d-4328-b690-4b284b6d5a74",
        "address": "MOHAMED IBRAHIM HASSAN ALSHAIBA ,KANA CAF ,51TOWER ,KANA CAFE ,35351 ,Dubai",
        "phone": "97142384444",
        "email": "Alshaiba@alshaibaadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3de1a3a0-760f-4d53-95b1-cecbac061394",
    "firmName": "ALSHAIBA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01710",
    "licenseIssueDate": "11/01/2011 00:00:00",
    "licenseExpiryDate": "10/23/2025 00:00:00"
  },
  {
    "id": "1a6d27f8-749c-4255-9f0f-5144b4878580",
    "slug": "mohamed-ali-abdellatif-saleh",
    "name": "Mohamed Ali Abdellatif Saleh",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/30/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Ali Abdellatif Saleh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1a6d27f8-749c-4255-9f0f-5144b4878580",
        "address": "HAMDAN ALSHAMSI ,الطابق الرابع مكتب 401, 406,407 ,بي سكوير 01 ,مجمع دبي سكوير ,116564 ,Dubai",
        "phone": "97143469262",
        "email": "courts@has.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de2c61a6-9d00-457e-ad1d-e73e4e62d9bd",
    "firmName": "HAMDAN ALSHAMSI LAWYER & LEGAL CONSULTANTS",
    "registrationNumber": "L-06916",
    "licenseIssueDate": "07/30/2025 00:00:00",
    "licenseExpiryDate": "07/29/2026 00:00:00"
  },
  {
    "id": "0ac1913c-5304-48af-836f-0bdc876171dc",
    "slug": "mohamed-ali-abou-sakr",
    "name": "Mohamed Ali Abou Sakr",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Ali Abou Sakr",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0ac1913c-5304-48af-836f-0bdc876171dc",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01284",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "a7a4cddb-9ae6-4376-8897-98abd5474719",
    "slug": "mohamed-ali-mansour-el-meligy",
    "name": "Mohamed Ali Mansour El Meligy",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Ali Mansour El Meligy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a7a4cddb-9ae6-4376-8897-98abd5474719",
        "address": "",
        "phone": "97148321212",
        "email": "nasser@nmlawyers.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "71709458-e40a-45b3-9319-4c51c18891be",
    "firmName": "NASSER MALALLA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01439",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "380f58b6-8c2d-49a2-a72a-713f6627d7fd",
    "slug": "mohamed-al-khanaty",
    "name": "Mohamed Al-Khanaty",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/23/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Al-Khanaty",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_380f58b6-8c2d-49a2-a72a-713f6627d7fd",
        "address": "0 ,ICD Brookfield Place Level 13 ,Trade Centre ,506569 ,Dubai",
        "phone": "97145099100 / 971501006965",
        "email": "menahr@freshfields.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "970f6246-e737-41a7-9c6c-5aa5b8335d45",
    "firmName": "Freshfields LLP DIFC",
    "registrationNumber": "L-03510",
    "licenseIssueDate": "11/23/2015 00:00:00",
    "licenseExpiryDate": "11/18/2025 00:00:00"
  },
  {
    "id": "07476970-0a21-41e4-b569-b806627d79aa",
    "slug": "mohamed-amr-mohamed-gamaleldin-elmahdy",
    "name": "Mohamed Amr Mohamed Gamaleldin Elmahdy",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/21/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Amr Mohamed Gamaleldin Elmahdy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_07476970-0a21-41e4-b569-b806627d79aa",
        "address": "",
        "phone": "97143937700",
        "email": "info@galadarilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d863b662-c864-4193-8b3a-ff6ee5fe6c64",
    "firmName": "GALADARI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06904",
    "licenseIssueDate": "07/21/2025 00:00:00",
    "licenseExpiryDate": "07/20/2026 00:00:00"
  },
  {
    "id": "1319a04b-07ca-44f5-8bc0-f01f0a61fafe",
    "slug": "mohamed-anis-moahmed-elhosary",
    "name": "Mohamed Anis Moahmed Elhosary",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/08/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-08-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Anis Moahmed Elhosary",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1319a04b-07ca-44f5-8bc0-f01f0a61fafe",
        "address": "ABDULKARIM MAKKI ,1605 ,Exchange Tower ,JW Marriott Marquis Hotel Dubai ,98777 ,Dubai",
        "phone": "97142406606",
        "email": "info@alfajeradvocate.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8f050b70-3ac6-4282-b9f7-ce19f14b4787",
    "firmName": "AL FAJER ADVOCATE & LEGAL CONSULTANTS",
    "registrationNumber": "L-03430",
    "licenseIssueDate": "08/15/2016 00:00:00",
    "licenseExpiryDate": "08/11/2020 00:00:00"
  },
  {
    "id": "74dd778c-d2ac-4a0b-a501-66a82d443df6",
    "slug": "mohamed-assem-hassan-mahmoud-mohamed",
    "name": "Mohamed Assem Hassan Mahmoud Mohamed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/18/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Assem Hassan Mahmoud Mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_74dd778c-d2ac-4a0b-a501-66a82d443df6",
        "address": "Fatima Mohammed Youseef Saddiq ,Floor 2, Office 215 ,Sultan Business Center ,Lamcy Plaza  ,114713 ,Dubai",
        "phone": "97145703330 / 971500000000",
        "email": "info@mnlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "f9b7a676-34db-4e8e-97b5-3ae354ee0661",
    "firmName": "FATIMA MOHAMMED ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06851",
    "licenseIssueDate": "06/18/2025 00:00:00",
    "licenseExpiryDate": "06/17/2026 00:00:00"
  },
  {
    "id": "eacf9c56-32cc-4e4f-8431-cc170846e8d3",
    "slug": "mohamed-atef-amin-abdelmaksoud",
    "name": "Mohamed Atef Amin Abdelmaksoud",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/31/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Atef Amin Abdelmaksoud",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_eacf9c56-32cc-4e4f-8431-cc170846e8d3",
        "address": "Index Tower ,DIFC ,506896 ,",
        "phone": "97142782300 / 971551154791",
        "email": "GLeggate@wfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e2b82cfc-80a5-4957-ae41-b1a7beb693c1",
    "firmName": "Watson, Farley & Williams (Middle East) LLP",
    "registrationNumber": "L-05842",
    "licenseIssueDate": "05/31/2023 00:00:00",
    "licenseExpiryDate": "05/30/2026 00:00:00"
  },
  {
    "id": "2f57d4de-dc9e-44fe-9055-e63a30db0700",
    "slug": "mohamed-bakr-mahmoud-abdelghani",
    "name": "Mohamed Bakr Mahmoud Abdelghani",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/08/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Bakr Mahmoud Abdelghani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2f57d4de-dc9e-44fe-9055-e63a30db0700",
        "address": "4th floor ,Al Saaha Offices Block D office 401A ,Burj Khalifa ,283773 ,Dubai",
        "phone": "97144221944",
        "email": "gov.depts@alsafarpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b7bbfaeb-1fdb-46d2-97cf-8e6432a9b8a7",
    "firmName": "AL SAFAR & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05181",
    "licenseIssueDate": "02/08/2022 00:00:00",
    "licenseExpiryDate": "02/07/2026 00:00:00"
  },
  {
    "id": "47f7df78-886c-4b6c-8826-f44e6f7a69f4",
    "slug": "mohamed-barakat",
    "name": "Mohamed Barakat",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/23/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Barakat",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_47f7df78-886c-4b6c-8826-f44e6f7a69f4",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-05649",
    "licenseIssueDate": "11/23/2022 00:00:00",
    "licenseExpiryDate": "11/22/2025 00:00:00"
  },
  {
    "id": "33c8c46a-ef18-4c88-b7ca-d15d3a897293",
    "slug": "mohamed-bushra-bakhit-mohamed",
    "name": "Mohamed Bushra Bakhit Mohamed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/08/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Bushra Bakhit Mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_33c8c46a-ef18-4c88-b7ca-d15d3a897293",
        "address": "samira ismail  ,الطابق التاسع - مكتب 902 ,برج سعيد 2 ,بنفس المبنى كنتاكي ,22223 ,Dubai",
        "phone": "97148873880 / 971585323296",
        "email": "info.zaroonilawyers@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "f31df5d9-3a8e-4129-a132-6bb30c924a15",
    "firmName": "SAMIRA ALZAROONI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-05774",
    "licenseIssueDate": "03/08/2023 00:00:00",
    "licenseExpiryDate": "03/07/2026 00:00:00"
  },
  {
    "id": "5d66af46-de34-489f-bd6e-39dc7039f8a3",
    "slug": "mohamed-dhaif-husain-saleh-husain",
    "name": "Mohamed Dhaif Husain Saleh Husain",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/12/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Dhaif Husain Saleh Husain",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5d66af46-de34-489f-bd6e-39dc7039f8a3",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-06703",
    "licenseIssueDate": "03/12/2025 00:00:00",
    "licenseExpiryDate": "03/11/2026 00:00:00"
  },
  {
    "id": "838464ce-9d7e-46ae-827d-0bebf14deea0",
    "slug": "mohamed-elbedery-hassan",
    "name": "Mohamed Elbedery Hassan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Elbedery Hassan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_838464ce-9d7e-46ae-827d-0bebf14deea0",
        "address": "4/406 ,Acico Business Park  ,Behind Nissan Showroom ,186344 ,Dubai",
        "phone": "97142989888 / 971505948989",
        "email": "AHMEDIBRAHIMLAW@GMAIL.COM",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dbb4bc27-1ace-4e78-8ee2-db7bfd85e001",
    "firmName": "AHMED IBRAHIM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01724",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "8a007ba0-2e2f-413d-9c12-00d8fed14aa8",
    "slug": "mohamed-eldesouky-abdelhady-badaway",
    "name": "MOHAMED ELDESOUKY ABDELHADY BADAWAY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/03/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MOHAMED ELDESOUKY ABDELHADY BADAWAY",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8a007ba0-2e2f-413d-9c12-00d8fed14aa8",
        "address": "13 ,Fairmont Hotel ,World Trade Centre metro station ,187082 ,Dubai",
        "phone": "97142367881",
        "email": "info@alhefeitilaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4675606d-79bb-4fd1-a3f6-a469d3d7cd31",
    "firmName": "ALHEFEITI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-04921",
    "licenseIssueDate": "07/03/2024 00:00:00",
    "licenseExpiryDate": "07/02/2026 00:00:00"
  },
  {
    "id": "ae25e69f-79bb-4030-9142-d4f20d41ab52",
    "slug": "mohamed-elghatit",
    "name": "Mohamed ElGhatit",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/18/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed ElGhatit",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ae25e69f-79bb-4030-9142-d4f20d41ab52",
        "address": "omar abdulazizi alomar ,15 ,prime tower ,blom bank france ,211940 ,Dubai",
        "phone": "97143808838 / 971504598082",
        "email": "omar.omar@oghlegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "171b4622-e4ec-4375-a9c4-3637bf6a8b17",
    "firmName": "ALOMAR & ALSABAH ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-00803",
    "licenseIssueDate": "04/18/2017 00:00:00",
    "licenseExpiryDate": "04/14/2026 00:00:00"
  },
  {
    "id": "24ba749e-7c90-40b1-a7d5-bae98183c795",
    "slug": "mohamed-elhawawy",
    "name": "Mohamed Elhawawy",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Elhawawy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_24ba749e-7c90-40b1-a7d5-bae98183c795",
        "address": "",
        "phone": "97144073901 / 971503479508",
        "email": "Rania.Tadros@stephensonharwood.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dd5042a2-bb41-4123-9544-79c3fa831332",
    "firmName": "Stephenson Harwood (Middle East) LLP",
    "registrationNumber": "L-01285",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "1ec4730d-afd4-42f6-b1a7-b77c8f99258c",
    "slug": "mohamed-elimam-ibrahim",
    "name": "Mohamed Elimam Ibrahim",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/15/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-01-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Elimam Ibrahim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1ec4730d-afd4-42f6-b1a7-b77c8f99258c",
        "address": "Samia Luqman ,2nd floor ,Emarat Atrium Building ,across Holiday Inn Express Safa Park ,7273 ,Dubai",
        "phone": "97143211000",
        "email": "info@alsuwaidi.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0e5c3637-bc12-475c-a6b5-2d9ae84f2b8e",
    "firmName": "AL-SUWAIDI & COMPANY",
    "registrationNumber": "L-02433",
    "licenseIssueDate": "01/15/2024 00:00:00",
    "licenseExpiryDate": "01/14/2026 00:00:00"
  },
  {
    "id": "90b8a9be-b10b-4147-bb03-452eaffc1762",
    "slug": "mohamed-elkhenany",
    "name": "Mohamed Elkhenany",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/05/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2019-02-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Elkhenany",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_90b8a9be-b10b-4147-bb03-452eaffc1762",
        "address": "AMNA IBRAHIM ALMUHSEN ,الطابق الاول مكتب 110  ,مركز الدانة ,بجانب فندق كارلتون بالاس ,171300 ,Dubai",
        "phone": "97143300766",
        "email": "amnaadvo@eim.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d272aefd-4d27-44d1-9b31-1df8b0682365",
    "firmName": "AMNA ALMUHSEN ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03227",
    "licenseIssueDate": "01/05/2016 00:00:00",
    "licenseExpiryDate": "01/02/2019 00:00:00"
  },
  {
    "id": "cf158dd9-ba0b-4110-ba70-86b987b81a9c",
    "slug": "mohamed-elmahdi",
    "name": "Mohamed Elmahdi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/25/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Elmahdi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cf158dd9-ba0b-4110-ba70-86b987b81a9c",
        "address": "ABDULLKAREIM AHMED ABDULLA EID ,الطابق الثانى - مكتب رقم 014 ,مركز الممزر  ,مقابل القياده العامه لشرطة دبي - بجوار مكتب وزارة العمل والعمال القديم  ,89505 ,Dubai",
        "phone": "97142388850",
        "email": "bineidadvocates@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ea633c29-6b4a-48a8-aaec-c801ece50744",
    "firmName": "BIN EID ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03525",
    "licenseIssueDate": "10/25/2016 00:00:00",
    "licenseExpiryDate": "10/21/2025 00:00:00"
  },
  {
    "id": "048b2c57-72c2-4979-95ad-3c4e2d1948e7",
    "slug": "mohamed-elqahwagy",
    "name": "Mohamed Elqahwagy",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/29/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Elqahwagy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_048b2c57-72c2-4979-95ad-3c4e2d1948e7",
        "address": "SUHAD FADHIL JABBAR MAHADI ALJUBOORI  ,1602 ,ذا اتش ,المركز التجارى الاول  ,99827 ,Dubai",
        "phone": "97142711100 / 971508661717",
        "email": "sj@suhadaljuboorilawfirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "762ae1a5-2cc6-418c-a6fd-6e195fe7234d",
    "firmName": "DR MOHAMED ALMUR ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03216",
    "licenseIssueDate": "04/29/2015 00:00:00",
    "licenseExpiryDate": "04/24/2026 00:00:00"
  },
  {
    "id": "e6d256ee-824f-4a24-8a80-31c6cec489ee",
    "slug": "mohamed-elsaady-abdelhamid-abdelazim",
    "name": "mohamed elsaady abdelhamid abdelazim",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/17/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: mohamed elsaady abdelhamid abdelazim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e6d256ee-824f-4a24-8a80-31c6cec489ee",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-06942",
    "licenseIssueDate": "09/17/2025 00:00:00",
    "licenseExpiryDate": "09/16/2026 00:00:00"
  },
  {
    "id": "1636dbe6-18c4-4d6e-a619-9ff966b83a22",
    "slug": "mohamed-elsayed-abdelwahab-abdelfattah",
    "name": "Mohamed Elsayed Abdelwahab Abdelfattah",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/04/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-03-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Elsayed Abdelwahab Abdelfattah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1636dbe6-18c4-4d6e-a619-9ff966b83a22",
        "address": "الطابق العاشر .. Tenth floor ,برج الحواي .. AL HAWAI TOWER  ,محطة مترو المركز المالي .. Financial Centre Metro Station  ,444091 ,Dubai",
        "phone": "97143393880 / 971554003333",
        "email": "info@maithadalmook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "1d8ed4ed-c950-4b53-ab18-fbbffbd29451",
    "firmName": "MAITHA DALMOOK ADVOCATES AND LEGAL CONSULTANCY",
    "registrationNumber": "L-05690",
    "licenseIssueDate": "01/04/2023 00:00:00",
    "licenseExpiryDate": "01/03/2026 00:00:00"
  },
  {
    "id": "c4aacf1b-1fab-4227-9b50-57371f664f86",
    "slug": "mohamed-elsayed-elkhedr",
    "name": "Mohamed Elsayed Elkhedr",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/03/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Elsayed Elkhedr",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c4aacf1b-1fab-4227-9b50-57371f664f86",
        "address": "next level restaurant  , centurion star - block B - office 806 & 807 ,behind day to day - opposite deira city center ,237766 ,Dubai",
        "phone": "97142622002",
        "email": "info@almaftool-advocate.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "bc6598b4-c5d3-4280-b29d-4c3c132c3a21",
    "firmName": "KHALIFA AL MAFTOOL ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-02876",
    "licenseIssueDate": "02/03/2015 00:00:00",
    "licenseExpiryDate": "01/28/2026 00:00:00"
  },
  {
    "id": "72f569b7-3198-4a4d-8d16-3a951b59127a",
    "slug": "mohamed-elsayed-hassan-aly-waer",
    "name": "MOHAMED ELSAYED HASSAN ALY WAER",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/22/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MOHAMED ELSAYED HASSAN ALY WAER",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_72f569b7-3198-4a4d-8d16-3a951b59127a",
        "address": "الطابق الثامن  ,برج الجرج 1 ,دائرة الاراضي و الاملاك  ,9117 ,Dubai",
        "phone": "97143320004",
        "email": "info@hlootahlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4ad67cb4-18b4-4417-9b6a-d23a9fb368fb",
    "firmName": "HUSSAIN LOOTAH & PARTNERS - ATTORNEYS & COUNSELLORS AT LAW",
    "registrationNumber": "L-04856",
    "licenseIssueDate": "02/22/2021 00:00:00",
    "licenseExpiryDate": "02/21/2026 00:00:00"
  },
  {
    "id": "f4818750-b11e-44d5-8b88-dfe652ae993a",
    "slug": "mohamed-elsayed-ibrahim-abdrabou",
    "name": "Mohamed Elsayed Ibrahim Abdrabou",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/23/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Elsayed Ibrahim Abdrabou",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f4818750-b11e-44d5-8b88-dfe652ae993a",
        "address": "",
        "phone": "97142280002",
        "email": "advoali2020@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5029a3dc-098b-4d3f-9e38-afb0eb4319d0",
    "firmName": "ALI IBRAHIM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05648",
    "licenseIssueDate": "11/23/2022 00:00:00",
    "licenseExpiryDate": "11/22/2025 00:00:00"
  },
  {
    "id": "67ad73dc-f51d-4c28-81d3-128d806bf569",
    "slug": "mohamed-elsayed-mohamed-elshennawy-elsahban",
    "name": "Mohamed elsayed mohamed elshennawy elsahban",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/03/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed elsayed mohamed elshennawy elsahban",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_67ad73dc-f51d-4c28-81d3-128d806bf569",
        "address": "Office M21 ,Garhoud Business Center ,Near GG Ko Metro Station Makani No: 4002124052 ,000 ,Dubai",
        "phone": "97142527751 / 971567778217",
        "email": "alshaaliattorneys25@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "47a484be-41d3-4e29-a5c3-ac1971bb44b0",
    "firmName": "AHMED ALSHAALI ATTORNEYS AT LAW",
    "registrationNumber": "L-06887",
    "licenseIssueDate": "07/03/2025 00:00:00",
    "licenseExpiryDate": "07/02/2026 00:00:00"
  },
  {
    "id": "32e01794-89ae-4d7e-9ba0-52231411093e",
    "slug": "mohamed-elsayed-saleh",
    "name": "Mohamed Elsayed Saleh",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/11/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Elsayed Saleh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_32e01794-89ae-4d7e-9ba0-52231411093e",
        "address": "",
        "phone": "97143944088 / 971547800401",
        "email": "info@almurlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "cfc90bc1-eca3-4d64-879b-70aeaa0925d3",
    "firmName": "DR MOHAMED ALMUR ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03406",
    "licenseIssueDate": "02/11/2025 00:00:00",
    "licenseExpiryDate": "02/10/2026 00:00:00"
  },
  {
    "id": "a21e9e92-0c6a-408c-aed2-a0398231d186",
    "slug": "mohamed-elsayed-zaky-ahmed-abdelgawad",
    "name": "Mohamed Elsayed Zaky Ahmed Abdelgawad",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/08/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Elsayed Zaky Ahmed Abdelgawad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a21e9e92-0c6a-408c-aed2-a0398231d186",
        "address": "الطابق 7 مكتب رقم 070A ,برج رولكس  ,محطة مترو المركز المالي  ,66300 ,Dubai",
        "phone": "97143444029",
        "email": "ekp.khalidaltmimi@ekplegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "400838f1-4e75-4836-9698-b9e19dd30a18",
    "firmName": "KHALID ABDALLA ALTAMIMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06803",
    "licenseIssueDate": "05/08/2025 00:00:00",
    "licenseExpiryDate": "05/07/2026 00:00:00"
  },
  {
    "id": "08af80b2-b348-46aa-bec9-bc23da62c485",
    "slug": "mohamed-elshahawy-elsayed",
    "name": "Mohamed Elshahawy Elsayed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Elshahawy Elsayed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_08af80b2-b348-46aa-bec9-bc23da62c485",
        "address": "ادارة ا لمبنى  ,الريم ,الاتصالات  ,42423 ,Dubai",
        "phone": "97142222066",
        "email": "info@ozleco.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7a155f4a-20ec-44ff-863f-4f9fb43d0af4",
    "firmName": "ALOBAIDLI & ALZAROONI ADVOCATES&LEGAL CONSULTANTS",
    "registrationNumber": "L-01205",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "f089aa50-0bf4-4e83-a064-c0bf493520c0",
    "slug": "mohamed-eltahir-mohamed-dafalla",
    "name": "Mohamed Eltahir Mohamed Dafalla",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/01/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Eltahir Mohamed Dafalla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f089aa50-0bf4-4e83-a064-c0bf493520c0",
        "address": "18 ,فندق مونارك  ,مركز التجاري ,98444 ,Dubai",
        "phone": "97143588777",
        "email": "info@bhadvoc.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "61266d12-f5b4-4466-a1a8-a45934d9e511",
    "firmName": "BIN HAIDER ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02144",
    "licenseIssueDate": "03/01/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "7e93bac8-2e44-4fa1-8b5f-074c424fd839",
    "slug": "mohamed-emad-mohamed-othman",
    "name": "Mohamed Emad Mohamed Othman",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/04/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Emad Mohamed Othman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7e93bac8-2e44-4fa1-8b5f-074c424fd839",
        "address": "",
        "phone": "97142776075 / 971588324788",
        "email": "avichal@kochhardubai.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "847eff7c-4142-431e-a8d6-f58ff60964f6",
    "firmName": "Kochhar & Co Inc Legal Consultants (Dubai Branch)",
    "registrationNumber": "L-02700",
    "licenseIssueDate": "05/04/2014 00:00:00",
    "licenseExpiryDate": "04/27/2026 00:00:00"
  },
  {
    "id": "1fafe772-7673-4751-ac5a-a33a6a87322b",
    "slug": "mohamed-emadeldin-mohamed-elsayed-allem",
    "name": "mohamed emadeldin mohamed elsayed allem",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/16/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: mohamed emadeldin mohamed elsayed allem",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1fafe772-7673-4751-ac5a-a33a6a87322b",
        "address": "Office No. 216 ,Al Wasl Building ,Opposite Dubai Mall Metro Station; Makani No: 8853725508 ,000 ,Dubai",
        "phone": "97145708388",
        "email": "sa.legaladvo@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "854c7388-093b-4e7c-b181-6a3d10225967",
    "firmName": "SAEED AL DAHMANI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06504",
    "licenseIssueDate": "09/16/2024 00:00:00",
    "licenseExpiryDate": "09/15/2026 00:00:00"
  },
  {
    "id": "fb533c6f-0ad7-40e9-8897-e54875ace2d4",
    "slug": "mohamed-esameldin-elgewily",
    "name": "Mohamed Esameldin Elgewily",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/10/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2021-09-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Esameldin Elgewily",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fb533c6f-0ad7-40e9-8897-e54875ace2d4",
        "address": "dalmook mohamed bin dalmook ,التاسع - مكتب 901 ,الشركة الوطنية للتأمينات العامة NGI ,مقابل سيتي سنتر ديرة بجوار سندس سويتس مريديان وفلورا كريك هوتيل ,3467 ,Dubai",
        "phone": "97142989222 / 971506455800",
        "email": "information@dalmook.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "564fc438-ce0f-40b0-9dc2-c01709da9e46",
    "firmName": "DALMOOK MOHAMMED DALMOOK ( ADVOCATE & LEGAL CONSULTANCY )",
    "registrationNumber": "L-01812",
    "licenseIssueDate": "10/05/2011 00:00:00",
    "licenseExpiryDate": "09/25/2021 00:00:00"
  },
  {
    "id": "4fb8ed50-0b58-480a-ab69-e6cce18d2c6f",
    "slug": "mohamed-essam-abdelmonem-elsheshtawy-shaban",
    "name": "mohamed essam abdelmonem elsheshtawy shaban",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/12/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: mohamed essam abdelmonem elsheshtawy shaban",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4fb8ed50-0b58-480a-ab69-e6cce18d2c6f",
        "address": "الطابق الثاني عشر - مكتب رقم 1203 ,برج سيتاديل ,مقابل فندق جي دبليو ماريوت ,91427 ,Dubai",
        "phone": "97143629899",
        "email": "md@imlawyeruae.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6735fd57-e905-4af6-a113-cc1e784b2510",
    "firmName": "EBRAHIM MOOSA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05910",
    "licenseIssueDate": "07/12/2023 00:00:00",
    "licenseExpiryDate": "07/11/2026 00:00:00"
  },
  {
    "id": "9f0c1c36-f54b-42c6-a3a9-3d30b2fa360a",
    "slug": "mohamed-fadi-yabroudi",
    "name": "Mohamed Fadi Yabroudi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/26/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Fadi Yabroudi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9f0c1c36-f54b-42c6-a3a9-3d30b2fa360a",
        "address": "Mezzanine / 09 ,Business Point  ,Behind Nissan Showroom ,85825 ,Dubai",
        "phone": "97142595777",
        "email": "ALMATROOSHI@OMALC.AE",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "588c9e2f-4f09-44bb-9e80-4e56d3f821b6",
    "firmName": "ALOWAIS & AL MATROOSHI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-02206",
    "licenseIssueDate": "06/26/2013 00:00:00",
    "licenseExpiryDate": "06/19/2026 00:00:00"
  },
  {
    "id": "983abe8c-23f3-4715-8ced-4eb91e0c1bbe",
    "slug": "mohamed-fahmey-hamed-ali",
    "name": "Mohamed Fahmey Hamed Ali",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/26/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Fahmey Hamed Ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_983abe8c-23f3-4715-8ced-4eb91e0c1bbe",
        "address": "Ali Saleh Atrooz  ,1103 ,EMPIRE HEIGHTS B ,دبي مول  ,18433 ,Dubai",
        "phone": "97142222511",
        "email": "info@araalaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "aab79fde-e700-45d7-904f-bde0a593a087",
    "firmName": "ARAA GROUP ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01885",
    "licenseIssueDate": "09/26/2011 00:00:00",
    "licenseExpiryDate": "09/17/2026 00:00:00"
  },
  {
    "id": "f9b91c27-3505-4bf2-90e7-506bef14b0c1",
    "slug": "mohamed-fathy-sayed-abdelfattah-mohamed-elnaggar",
    "name": "Mohamed Fathy Sayed Abdelfattah Mohamed Elnaggar",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/29/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Fathy Sayed Abdelfattah Mohamed Elnaggar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f9b91c27-3505-4bf2-90e7-506bef14b0c1",
        "address": "",
        "phone": "97143937700",
        "email": "info@galadarilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d863b662-c864-4193-8b3a-ff6ee5fe6c64",
    "firmName": "GALADARI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06120",
    "licenseIssueDate": "11/29/2023 00:00:00",
    "licenseExpiryDate": "11/28/2025 00:00:00"
  },
  {
    "id": "6a6c4f43-710f-4acf-8f72-eb999d39b55e",
    "slug": "mohamed-fekry-mahmoud-kora",
    "name": "Mohamed Fekry Mahmoud Kora",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/01/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Fekry Mahmoud Kora",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6a6c4f43-710f-4acf-8f72-eb999d39b55e",
        "address": "",
        "phone": "97143339002 / 971558818724",
        "email": "info@nhalhammadi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e78d4c87-2450-4a73-af8f-bdea91defa61",
    "firmName": "HESSA ALHAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04086",
    "licenseIssueDate": "05/01/2018 00:00:00",
    "licenseExpiryDate": "04/29/2026 00:00:00"
  },
  {
    "id": "f2658ce0-6c51-4794-81f3-ae8798579aaf",
    "slug": "mohamed-gaber-abdelmaged-abdelsabour",
    "name": "Mohamed Gaber Abdelmaged Abdelsabour",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/31/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Gaber Abdelmaged Abdelsabour",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f2658ce0-6c51-4794-81f3-ae8798579aaf",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04138",
    "licenseIssueDate": "05/31/2018 00:00:00",
    "licenseExpiryDate": "05/29/2026 00:00:00"
  },
  {
    "id": "09d1e0b2-3bc0-4127-988f-50b084d855bd",
    "slug": "mohamed-gadalla",
    "name": "Mohamed Gadalla",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/13/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Gadalla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_09d1e0b2-3bc0-4127-988f-50b084d855bd",
        "address": "",
        "phone": "97144472020",
        "email": "info@arnadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e6573267-5872-48d8-add1-06a3deccf9e4",
    "firmName": "ABDUL RAHMAN NASEEB ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03225",
    "licenseIssueDate": "10/13/2015 00:00:00",
    "licenseExpiryDate": "10/08/2026 00:00:00"
  },
  {
    "id": "a6ee3543-9c12-424f-a74e-4f287b35b2c0",
    "slug": "mohamed-gamal-hussein-ibrahim-algendy",
    "name": "Mohamed Gamal Hussein Ibrahim Algendy",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/24/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Gamal Hussein Ibrahim Algendy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a6ee3543-9c12-424f-a74e-4f287b35b2c0",
        "address": "الطابق الثاني عشر - مكتب رقم 1203 ,برج سيتاديل ,مقابل فندق جي دبليو ماريوت ,91427 ,Dubai",
        "phone": "97143629899",
        "email": "md@imlawyeruae.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6735fd57-e905-4af6-a113-cc1e784b2510",
    "firmName": "EBRAHIM MOOSA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04112",
    "licenseIssueDate": "05/24/2018 00:00:00",
    "licenseExpiryDate": "05/22/2026 00:00:00"
  },
  {
    "id": "ae06c61e-b663-4266-8662-92396559e9c7",
    "slug": "mohamed-gomaa-elsayed-elgamal",
    "name": "Mohamed Gomaa ELsayed Elgamal",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/21/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Gomaa ELsayed Elgamal",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ae06c61e-b663-4266-8662-92396559e9c7",
        "address": "",
        "phone": "97142566628 / 971508908030",
        "email": "info@halmaazmilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b0870ce2-bb48-4fd6-84c4-b053eeef75bd",
    "firmName": "HAMDAN SULAIMAN SALIM ALMAAZMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02422",
    "licenseIssueDate": "08/21/2025 00:00:00",
    "licenseExpiryDate": "08/20/2026 00:00:00"
  },
  {
    "id": "98b92753-6cc9-4c97-9d2d-acec82d9f26f",
    "slug": "mohamed-hamed-mahmoud-mohamed",
    "name": "MOHAMED HAMED MAHMOUD MOHAMED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/16/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MOHAMED HAMED MAHMOUD MOHAMED",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_98b92753-6cc9-4c97-9d2d-acec82d9f26f",
        "address": "Mezzanine / 09 ,Business Point  ,Behind Nissan Showroom ,85825 ,Dubai",
        "phone": "97142595777",
        "email": "ALMATROOSHI@OMALC.AE",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "588c9e2f-4f09-44bb-9e80-4e56d3f821b6",
    "firmName": "ALOWAIS & AL MATROOSHI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-06192",
    "licenseIssueDate": "02/16/2024 00:00:00",
    "licenseExpiryDate": "02/15/2026 00:00:00"
  },
  {
    "id": "e77e5050-c3f2-452c-b4f4-b1007bc4566e",
    "slug": "mohamed-hassan-abdelmagid-elhadad",
    "name": "MOHAMED HASSAN ABDELMAGID ELHADAD",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/24/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MOHAMED HASSAN ABDELMAGID ELHADAD",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e77e5050-c3f2-452c-b4f4-b1007bc4566e",
        "address": "next level restaurant  , centurion star - block B - office 806 & 807 ,behind day to day - opposite deira city center ,237766 ,Dubai",
        "phone": "97142622002",
        "email": "info@almaftool-advocate.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "bc6598b4-c5d3-4280-b29d-4c3c132c3a21",
    "firmName": "KHALIFA AL MAFTOOL ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-06175",
    "licenseIssueDate": "01/24/2024 00:00:00",
    "licenseExpiryDate": "01/23/2026 00:00:00"
  },
  {
    "id": "55518962-fbac-4a20-b9c7-4f174f3d2240",
    "slug": "mohamed-hassan-farghaly",
    "name": "Mohamed Hassan Farghaly",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/08/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Hassan Farghaly",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_55518962-fbac-4a20-b9c7-4f174f3d2240",
        "address": "",
        "phone": "97143368833",
        "email": "alkhouli@alkhoulilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0188c41d-cec9-4993-8610-23001bfcf8a7",
    "firmName": "MAAMOUN AL KHOULI & ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02331",
    "licenseIssueDate": "10/08/2012 00:00:00",
    "licenseExpiryDate": "09/30/2026 00:00:00"
  },
  {
    "id": "e8a2b6bc-5b63-40cd-8f24-b059c41c4dca",
    "slug": "mohamed-hassan-mohamed-hilal",
    "name": "Mohamed Hassan Mohamed Hilal",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/26/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Hassan Mohamed Hilal",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e8a2b6bc-5b63-40cd-8f24-b059c41c4dca",
        "address": "",
        "phone": "97143380333",
        "email": "info@fahadbintamim.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6924283e-95b7-4af2-85a3-cc6cbcc10a20",
    "firmName": "FAHAD BIN TAMIM ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-01883",
    "licenseIssueDate": "09/26/2011 00:00:00",
    "licenseExpiryDate": "09/18/2026 00:00:00"
  },
  {
    "id": "81d78418-9771-4c72-ae94-46ee780c3811",
    "slug": "mohamed-hassan-nada",
    "name": "Mohamed Hassan Nada",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/16/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Hassan Nada",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_81d78418-9771-4c72-ae94-46ee780c3811",
        "address": "HASSAN ALI MATAR ALRIYAMI ,24 ,GRASVENOR BUSINESS TOWER ,NEEDS SUPERMARKET ,215880 ,Dubai",
        "phone": "97144534188",
        "email": "courts@alriyamiadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a40a2f1f-69a9-429c-8086-dba9d985532b",
    "firmName": "HASAN ALRAYYAMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02342",
    "licenseIssueDate": "03/16/2015 00:00:00",
    "licenseExpiryDate": "03/10/2026 00:00:00"
  },
  {
    "id": "578dbc13-2b18-4359-bb2e-2871be5bd429",
    "slug": "mohamed-hassan-ramadan-abdelaal",
    "name": "MOHAMED HASSAN RAMADAN ABDELAAL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/02/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MOHAMED HASSAN RAMADAN ABDELAAL",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_578dbc13-2b18-4359-bb2e-2871be5bd429",
        "address": "- ,THE OFFICES 1 ,DWTC ,115580 ,Dubai",
        "phone": "97143739700 / 971562196031",
        "email": "catherine.workman@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6b4ebb23-ef2e-4305-a1ee-43a11e4b1cae",
    "firmName": "Pinsent Masons LLP - Dubai Branch",
    "registrationNumber": "L-04499",
    "licenseIssueDate": "10/02/2019 00:00:00",
    "licenseExpiryDate": "10/01/2026 00:00:00"
  },
  {
    "id": "ab2e221a-29ff-4df0-aac1-ad44ab9c0356",
    "slug": "mohamed-hassan-teleb",
    "name": "Mohamed Hassan Teleb",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/23/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Hassan Teleb",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ab2e221a-29ff-4df0-aac1-ad44ab9c0356",
        "address": "Alhajeya salem saeed alnoobi ,3rd  ,Al-hawai Tower  ,Behind financial center metro station  ,39779 ,Dubai",
        "phone": "97142963813",
        "email": "adv_aljazeera@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "f091b928-9e3d-4e24-b489-65ca31481366",
    "firmName": "AL HAJEYA ALNOOBI ADVOCATES AND LEGAL CONSULTANT",
    "registrationNumber": "L-03454",
    "licenseIssueDate": "08/23/2016 00:00:00",
    "licenseExpiryDate": "08/19/2026 00:00:00"
  },
  {
    "id": "aef663cc-a129-4822-b8c7-d55951bff99e",
    "slug": "mohamed-hassanin",
    "name": "Mohamed Hassanin",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/25/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Hassanin",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_aef663cc-a129-4822-b8c7-d55951bff99e",
        "address": "21 ,Rolex Tower ,Emirates Grand Hotel ,94334 ,Dubai",
        "phone": "97143277772 / 97145584900",
        "email": "info@globaladvocates.net",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9b42810f-1d55-4aea-ac4a-7d9d1b25ac08",
    "firmName": "GLOBAL ADVOCACY & LEGAL COUNSEL",
    "registrationNumber": "L-03526",
    "licenseIssueDate": "10/25/2016 00:00:00",
    "licenseExpiryDate": "10/21/2026 00:00:00"
  },
  {
    "id": "f794136a-aa66-4e44-8482-283a8af4d488",
    "slug": "mohamed-hussein-ahmed-abdelmeguid",
    "name": "Mohamed Hussein Ahmed Abdelmeguid",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Hussein Ahmed Abdelmeguid",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f794136a-aa66-4e44-8482-283a8af4d488",
        "address": "Samir Kanaan ,Office 502 Floor 5 ,Bay Square Building 11 ,South Ridge Apartments ,101 ,Dubai",
        "phone": "97142775444",
        "email": "info@kanlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d0e51371-a813-49c7-a99e-641fda6bca77",
    "firmName": "KANAAN ADVOCATES& LEGAL CONSULTANTS",
    "registrationNumber": "L-01480",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "00e501f2-f8dc-40b1-b912-0743a3e9d3f6",
    "slug": "mohamed-hussein-edries-ahmed",
    "name": "Mohamed Hussein Edries Ahmed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/23/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Hussein Edries Ahmed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_00e501f2-f8dc-40b1-b912-0743a3e9d3f6",
        "address": "",
        "phone": "97142237666",
        "email": "info@musaalamri.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "33313c27-5476-4398-bde0-ff404d0480c1",
    "firmName": "MOUSA ALAMRI ADVOCATES & LEGEL CONSULTANTS",
    "registrationNumber": "L-03838",
    "licenseIssueDate": "07/23/2017 00:00:00",
    "licenseExpiryDate": "07/20/2026 00:00:00"
  },
  {
    "id": "24a46504-fd43-4aff-8c01-f3d859324e6a",
    "slug": "mohamed-ibrahim-abdelrehiem",
    "name": "Mohamed Ibrahim Abdelrehiem",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/29/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Ibrahim Abdelrehiem",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_24a46504-fd43-4aff-8c01-f3d859324e6a",
        "address": "Fadi H. Hourani ,3 ,The Offices 5, One Central ,The Museum of the Future ,10152 ,Dubai",
        "phone": "97142052000",
        "email": "info@houranipartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c7a17e12-3d49-4166-82c8-271a6d223675",
    "firmName": "HOURANI & PATNERS",
    "registrationNumber": "L-02302",
    "licenseIssueDate": "04/29/2020 00:00:00",
    "licenseExpiryDate": "04/28/2026 00:00:00"
  },
  {
    "id": "7f1e49f6-0dd7-4da4-a80b-539f8427ec74",
    "slug": "mohamed-ibrahim-abualela-ibrahim-hussein",
    "name": "Mohamed Ibrahim Abualela Ibrahim Hussein",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/10/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Ibrahim Abualela Ibrahim Hussein",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7f1e49f6-0dd7-4da4-a80b-539f8427ec74",
        "address": "801/802 ,Park Place ,WTC ,384557 ,Dubai",
        "phone": "97143203999",
        "email": "info.dubai@alemlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e3088c8b-a7dc-4f38-a04d-cb4c7d050ed9",
    "firmName": "AHMED MOHAMMED BASHIR ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04929",
    "licenseIssueDate": "05/10/2021 00:00:00",
    "licenseExpiryDate": "05/09/2026 00:00:00"
  },
  {
    "id": "2bd69764-b21a-4797-97a8-1edf5f5ac1cf",
    "slug": "mohamed-ibrahim-ahmed-batea",
    "name": "Mohamed Ibrahim Ahmed Batea",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/13/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Ibrahim Ahmed Batea",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2bd69764-b21a-4797-97a8-1edf5f5ac1cf",
        "address": "الثالث مكتب 304 ,برج سما ,المركز التجاري  ,116623 ,Dubai",
        "phone": "97142723388",
        "email": "info@habibllc.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "373bb6e6-5948-493f-a6ac-2ea343840160",
    "firmName": "HABIB ALHOSANI LAWYERS & LEGAL CONSULTANTS",
    "registrationNumber": "L-05035",
    "licenseIssueDate": "09/13/2021 00:00:00",
    "licenseExpiryDate": "09/12/2026 00:00:00"
  },
  {
    "id": "c4e6e93e-9d95-4834-a23c-81821e01ebec",
    "slug": "mohamed-ibrahim-aly",
    "name": "Mohamed Ibrahim Aly",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/23/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Ibrahim Aly",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c4e6e93e-9d95-4834-a23c-81821e01ebec",
        "address": "khalid al kaitoob ,12 ,نسيمية تاور الطابق 12 1202 B ,فندق الفوكو  ,10755 ,Dubai",
        "phone": "97143586555",
        "email": "info@alkaitooblawyer.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "403277a6-eef2-4cfd-af95-9959280d6b40",
    "firmName": "AL KAITOOB ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02009",
    "licenseIssueDate": "05/23/2013 00:00:00",
    "licenseExpiryDate": "05/16/2026 00:00:00"
  },
  {
    "id": "34258a5d-4de0-4b06-b202-d25ea7ab6061",
    "slug": "mohamed-ibrahim-elkhatib",
    "name": "Mohamed Ibrahim Elkhatib",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/26/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Ibrahim Elkhatib",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_34258a5d-4de0-4b06-b202-d25ea7ab6061",
        "address": "",
        "phone": "97144230000 / 971552009022",
        "email": "UAE-CourtClerks@habibalmulla.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3eba82bb-8ec4-4cbd-80d0-a793cb993fde",
    "firmName": "Habib Al Mulla & Partners ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01779",
    "licenseIssueDate": "09/26/2011 00:00:00",
    "licenseExpiryDate": "09/17/2026 00:00:00"
  },
  {
    "id": "cb1d2aba-3f4a-433d-bdab-d9f00cadc350",
    "slug": "mohamed-ibrahim-mohamed-farahat",
    "name": "MOHAMED IBRAHIM MOHAMED FARAHAT",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/28/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MOHAMED IBRAHIM MOHAMED FARAHAT",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cb1d2aba-3f4a-433d-bdab-d9f00cadc350",
        "address": "406 ,رقة البطين  ,بجوار فندق كونكورد  ,92414 ,Dubai",
        "phone": "97142666331",
        "email": "almeshref2019@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b47f195f-addd-458d-85ec-bb93239bbe4b",
    "firmName": "MOHAMMED BEKHIT ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05498",
    "licenseIssueDate": "09/28/2022 00:00:00",
    "licenseExpiryDate": "09/27/2026 00:00:00"
  },
  {
    "id": "48df11b7-89a4-4a54-a31c-f81dcc9df477",
    "slug": "mohamed-ibrahim-thabet-mohamed",
    "name": "MOHAMED IBRAHIM THABET MOHAMED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/28/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MOHAMED IBRAHIM THABET MOHAMED",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_48df11b7-89a4-4a54-a31c-f81dcc9df477",
        "address": "الثالث  ,اركاد  ,الطاير للسيارات  ,20877 ,Dubai",
        "phone": "97142833355",
        "email": "Fahadadvo@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7dd7860a-cd36-443b-a1b7-62dd3050e6b9",
    "firmName": "FAHAD ABDULLA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04522",
    "licenseIssueDate": "08/28/2024 00:00:00",
    "licenseExpiryDate": "08/27/2026 00:00:00"
  },
  {
    "id": "f07a7dff-d186-412d-be79-04b7c00f4b82",
    "slug": "mohamed-ismail-ismail-elsamanoudi",
    "name": "Mohamed Ismail Ismail Elsamanoudi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Ismail Ismail Elsamanoudi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f07a7dff-d186-412d-be79-04b7c00f4b82",
        "address": "",
        "phone": "97142227008 / 971506245451",
        "email": "info@abdulmaliklaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5714833f-5b48-477b-a556-efa3a779f522",
    "firmName": "ABDULMALIK & ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01552",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "042bdb43-b145-44db-ba37-6ae919c55f0b",
    "slug": "mohamed-kamaleldin-elsayed-elshahat",
    "name": "MOHAMED KAMALELDIN ELSAYED ELSHAHAT",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/28/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MOHAMED KAMALELDIN ELSAYED ELSHAHAT",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_042bdb43-b145-44db-ba37-6ae919c55f0b",
        "address": "mohammed saeed salem alshamsi ,الاول ,مبنى خالد شعبان   ,دوار الساعه ,16916 ,Dubai",
        "phone": "",
        "email": "info@lawyer-uae.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e9d4f001-7001-4958-b95a-f283f1583a31",
    "firmName": "MOHAMMED SAEED ALSHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06452",
    "licenseIssueDate": "08/28/2024 00:00:00",
    "licenseExpiryDate": "08/27/2026 00:00:00"
  },
  {
    "id": "7c316636-9a28-417d-b8df-68214dace376",
    "slug": "mohamed-kamel-hussein",
    "name": "Mohamed Kamel Hussein",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/27/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Kamel Hussein",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7c316636-9a28-417d-b8df-68214dace376",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-03002",
    "licenseIssueDate": "05/27/2015 00:00:00",
    "licenseExpiryDate": "05/22/2026 00:00:00"
  },
  {
    "id": "d4b206c6-1c51-45e9-b04e-40923d781cd4",
    "slug": "mohamed-khalil",
    "name": "Mohamed Khalil",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/28/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Khalil",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d4b206c6-1c51-45e9-b04e-40923d781cd4",
        "address": "901-902 ,برج السلام ,فندق جراند شيراتون ,2741291443 ,Dubai",
        "phone": "97145877794 / 971586606660",
        "email": "obh@obhlawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "edbb7814-39f9-4ec9-b01d-9de1117e343e",
    "firmName": "OMAR KHALIFA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03501",
    "licenseIssueDate": "07/28/2023 00:00:00",
    "licenseExpiryDate": "07/27/2026 00:00:00"
  },
  {
    "id": "945ece4f-8447-4444-9002-8d754ba235e1",
    "slug": "mohamed-maher-mustafa-nour",
    "name": "Mohamed Maher Mustafa Nour",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/19/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Maher Mustafa Nour",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_945ece4f-8447-4444-9002-8d754ba235e1",
        "address": "HAMDAN ALSHAMSI ,الطابق الرابع مكتب 401, 406,407 ,بي سكوير 01 ,مجمع دبي سكوير ,116564 ,Dubai",
        "phone": "97143469262",
        "email": "courts@has.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de2c61a6-9d00-457e-ad1d-e73e4e62d9bd",
    "firmName": "HAMDAN ALSHAMSI LAWYER & LEGAL CONSULTANTS",
    "registrationNumber": "L-04914",
    "licenseIssueDate": "04/19/2021 00:00:00",
    "licenseExpiryDate": "04/18/2026 00:00:00"
  },
  {
    "id": "a356f23e-87ff-4398-8573-d516714599cf",
    "slug": "mohamed-mahjoubi",
    "name": "Mohamed Mahjoubi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/12/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-08-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Mahjoubi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a356f23e-87ff-4398-8573-d516714599cf",
        "address": "",
        "phone": "97147098484 / 971505577206",
        "email": "slshadmand@jonesday.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8892bfe9-d3ec-4158-b4fd-1844606f4f30",
    "firmName": "Jones Day",
    "registrationNumber": "L-03570",
    "licenseIssueDate": "01/12/2017 00:00:00",
    "licenseExpiryDate": "01/08/2026 00:00:00"
  },
  {
    "id": "af650f2f-35d8-42ff-85e9-0d221cdddff8",
    "slug": "mohamed-mahmoud-elsayed-elmahdi",
    "name": "Mohamed Mahmoud Elsayed Elmahdi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/07/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Mahmoud Elsayed Elmahdi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_af650f2f-35d8-42ff-85e9-0d221cdddff8",
        "address": "",
        "phone": "97142280002",
        "email": "advoali2020@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5029a3dc-098b-4d3f-9e38-afb0eb4319d0",
    "firmName": "ALI IBRAHIM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01536",
    "licenseIssueDate": "02/07/2012 00:00:00",
    "licenseExpiryDate": "01/29/2026 00:00:00"
  },
  {
    "id": "4db1d3fe-3d5d-4821-87ef-88bb3d20d62a",
    "slug": "mohamed-mekhemar-mekhemar",
    "name": "Mohamed Mekhemar Mekhemar",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Mekhemar Mekhemar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4db1d3fe-3d5d-4821-87ef-88bb3d20d62a",
        "address": "000000000 ,4 ,الريم  ,بلدية دبي  ,14593 ,Dubai",
        "phone": "97142276777",
        "email": "info@tglawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "593a5a42-a340-4daa-a8db-6d2673de29d5",
    "firmName": "MOHAMED AL HAJERI ADVOCATES & LEGAL CONSULTANTS  & NOTARY PUBLIC",
    "registrationNumber": "L-01391",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "d6b2be12-ce51-47dd-a694-a78e0113d1ab",
    "slug": "mohamed-mohamady-mohamed-kahla",
    "name": "Mohamed Mohamady Mohamed Kahla",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/07/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Mohamady Mohamed Kahla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d6b2be12-ce51-47dd-a694-a78e0113d1ab",
        "address": "",
        "phone": "97145539555",
        "email": "world-center@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "00c4764a-95da-417c-bdfc-8bafd4ff9fca",
    "firmName": "WORLD CENTER ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03853",
    "licenseIssueDate": "09/07/2017 00:00:00",
    "licenseExpiryDate": "09/04/2026 00:00:00"
  },
  {
    "id": "addc20e5-75b4-4a2f-b7cf-8144ae63c6f7",
    "slug": "mohamed-mohamed-ali-saleim",
    "name": "Mohamed Mohamed Ali Saleim",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/14/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Mohamed Ali Saleim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_addc20e5-75b4-4a2f-b7cf-8144ae63c6f7",
        "address": "",
        "phone": "97143889955",
        "email": "m.alhanafi@nooflaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6a72f470-256a-46d0-bead-acf13b981406",
    "firmName": "NOOF ALABDULLA ADVOCATES & LEGAL CONSULTANTS L.L.C",
    "registrationNumber": "L-02704",
    "licenseIssueDate": "03/14/2021 00:00:00",
    "licenseExpiryDate": "03/13/2026 00:00:00"
  },
  {
    "id": "a6e82500-6596-4a34-a781-fee2a8952452",
    "slug": "mohamed-mokbil-eisa",
    "name": "Mohamed Mokbil Eisa",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/09/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Mokbil Eisa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a6e82500-6596-4a34-a781-fee2a8952452",
        "address": "4th Floor/ Office no. 401 ,Business Avenue  ,Infront- Terminal 2  ,115263 ,Dubai",
        "phone": "97144518866",
        "email": "info@aldhaheriinternational.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "cf3c19c0-d396-4bcb-b1db-b81273ed0b4c",
    "firmName": "AL DHAHERI INTERNATIONAL ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02339",
    "licenseIssueDate": "10/09/2013 00:00:00",
    "licenseExpiryDate": "10/02/2026 00:00:00"
  },
  {
    "id": "74d6db6f-71fc-4805-9735-e451a5bb2c48",
    "slug": "mohamed-mostafa-elkholy",
    "name": "Mohamed Mostafa Elkholy",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/04/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Mostafa Elkholy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_74d6db6f-71fc-4805-9735-e451a5bb2c48",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02655",
    "licenseIssueDate": "09/04/2014 00:00:00",
    "licenseExpiryDate": "08/29/2026 00:00:00"
  },
  {
    "id": "f4a4fd5f-321c-4fde-8e4a-61f42f07ca34",
    "slug": "mohamed-mostafa-shehata-gad",
    "name": "Mohamed Mostafa Shehata Gad",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/08/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Mostafa Shehata Gad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f4a4fd5f-321c-4fde-8e4a-61f42f07ca34",
        "address": "1201 ,برج تريو اي بي اي اوفيس  ,فندق نوافتيل ,8812 ,Dubai",
        "phone": "97144222555",
        "email": "lutfilaw2020@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9a3d884b-a443-4037-9eb4-f810c596cf33",
    "firmName": "LUTFI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06989"
  },
  {
    "id": "def687f2-8ce9-4db2-b258-f77efb0d1985",
    "slug": "mohamed-nacim-bounouara",
    "name": "Mohamed Nacim Bounouara",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/26/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Nacim Bounouara",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_def687f2-8ce9-4db2-b258-f77efb0d1985",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-06382",
    "licenseIssueDate": "06/26/2024 00:00:00",
    "licenseExpiryDate": "06/25/2026 00:00:00"
  },
  {
    "id": "13a55eb4-4e21-4fde-9217-47cec5601e9f",
    "slug": "mohamed-nagib-mahmood-saleh",
    "name": "Mohamed Nagib Mahmood Saleh",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/21/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Nagib Mahmood Saleh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_13a55eb4-4e21-4fde-9217-47cec5601e9f",
        "address": "",
        "phone": "97143333386 / 971549916936",
        "email": "info@mtaadv.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "466f3ad4-73e1-44db-b8ec-b01e829d77c4",
    "firmName": "MOHAMMAD ALLINJAWI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01354",
    "licenseIssueDate": "01/21/2021 00:00:00",
    "licenseExpiryDate": "01/20/2026 00:00:00"
  },
  {
    "id": "a7fc37d1-4930-4382-b085-0b7d7a8bf676",
    "slug": "mohamed-nagy-sobhy-ramadan-elkhyary",
    "name": "mohamed nagy sobhy ramadan elkhyary",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/21/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: mohamed nagy sobhy ramadan elkhyary",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a7fc37d1-4930-4382-b085-0b7d7a8bf676",
        "address": "Mohamed Nagy ,First floor  ,Clover Bay ,Business bay ,108 ,Dubai",
        "phone": "97143366404",
        "email": "fatimaalmehri5@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a359d947-1da5-4ef9-af87-719d01287fd0",
    "firmName": "FATEMA ALMHEIRI ADVOCATES &LEGAL CONSULTANTS",
    "registrationNumber": "L-06156",
    "licenseIssueDate": "12/21/2023 00:00:00",
    "licenseExpiryDate": "12/20/2025 00:00:00"
  },
  {
    "id": "8cc703ad-28d2-44a7-98a8-6cf09b7e2273",
    "slug": "mohamed-osama-elbaghdady",
    "name": "Mohamed Osama Elbaghdady",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/09/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Osama Elbaghdady",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8cc703ad-28d2-44a7-98a8-6cf09b7e2273",
        "address": "",
        "phone": "97144230000 / 971552009022",
        "email": "UAE-CourtClerks@habibalmulla.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3eba82bb-8ec4-4cbd-80d0-a793cb993fde",
    "firmName": "Habib Al Mulla & Partners ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02768",
    "licenseIssueDate": "12/09/2014 00:00:00",
    "licenseExpiryDate": "12/03/2025 00:00:00"
  },
  {
    "id": "119ccb98-a4b7-487a-aede-144e6e3f652a",
    "slug": "mohamed-osama-elghaish",
    "name": "Mohamed Osama Elghaish",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/01/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Osama Elghaish",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_119ccb98-a4b7-487a-aede-144e6e3f652a",
        "address": "5 ,tasheel bldg ,nasr club ,116749 ,Dubai",
        "phone": "97143970701",
        "email": "salha@albastiadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c34580b3-9e80-4326-bd68-0eb2abbb06fc",
    "firmName": "SALHA ALBASTI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01711",
    "licenseIssueDate": "11/01/2011 00:00:00",
    "licenseExpiryDate": "10/23/2025 00:00:00"
  },
  {
    "id": "c0e15568-80a6-410b-ac12-7051ace25fca",
    "slug": "mohamed-osman-mohamed-almahi",
    "name": "Mohamed Osman Mohamed Almahi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/25/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-01-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Osman Mohamed Almahi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c0e15568-80a6-410b-ac12-7051ace25fca",
        "address": "Dr. Ali Ismail Aljarman ,Roof Floor - Offices R03 & R04 ,MSM 1 Building ,Al Saffa First ,62639 ,Dubai",
        "phone": "97144393733",
        "email": "info@prestigeadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "22043b7f-55d2-4eb4-a173-3077ba390351",
    "firmName": "PRESTIGE ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05698",
    "licenseIssueDate": "01/25/2023 00:00:00",
    "licenseExpiryDate": "01/24/2026 00:00:00"
  },
  {
    "id": "a8858871-86fe-4572-9ae8-0c747d8047fa",
    "slug": "mohamed-othman-mohamed",
    "name": "Mohamed Othman Mohamed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/25/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Othman Mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a8858871-86fe-4572-9ae8-0c747d8047fa",
        "address": "الطابق 11 - مكتب رقم (1105 ، 1106)  ,برج السلام  ,منطقة المركز التجاري العالمي 1 ,211911 ,Dubai",
        "phone": "97143366769 / 971503636617",
        "email": "info@erlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "fffe1b8f-e9ab-488f-82eb-6151b8f007df",
    "firmName": "EMAN ALRIFAI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01614",
    "licenseIssueDate": "02/25/2022 00:00:00",
    "licenseExpiryDate": "02/24/2026 00:00:00"
  },
  {
    "id": "39b60b05-495c-4852-8cb0-e557114929ba",
    "slug": "mohamed-rabih-nizam",
    "name": "Mohamed Rabih Nizam",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/05/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Rabih Nizam",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_39b60b05-495c-4852-8cb0-e557114929ba",
        "address": "الطابق الثامن  ,برج الجرج 1 ,دائرة الاراضي و الاملاك  ,9117 ,Dubai",
        "phone": "97143320004",
        "email": "info@hlootahlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4ad67cb4-18b4-4417-9b6a-d23a9fb368fb",
    "firmName": "HUSSAIN LOOTAH & PARTNERS - ATTORNEYS & COUNSELLORS AT LAW",
    "registrationNumber": "L-01589",
    "licenseIssueDate": "03/05/2013 00:00:00",
    "licenseExpiryDate": "02/25/2026 00:00:00"
  },
  {
    "id": "e7b05827-33b0-496f-9cbc-973461aff10a",
    "slug": "mohamed-ragab-mohamed-abdelkawi",
    "name": "Mohamed Ragab Mohamed Abdelkawi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/06/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Ragab Mohamed Abdelkawi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e7b05827-33b0-496f-9cbc-973461aff10a",
        "address": "Bader Aljassmy ,3 ,دبي كوميرسيتي ,دبي كوميرسيتي ,410004 ,Dubai",
        "phone": "97148760777 / 971586842086",
        "email": "info@bajlegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7e820dd9-2748-4876-88db-ff7948542895",
    "firmName": "AL BASTAKI & Al JASMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05110",
    "licenseIssueDate": "12/06/2021 00:00:00",
    "licenseExpiryDate": "12/05/2025 00:00:00"
  },
  {
    "id": "28652c68-849a-47f4-9750-104a9bd2187f",
    "slug": "mohamed-rashad-ibrahim-mofttah",
    "name": "Mohamed Rashad Ibrahim Mofttah",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/26/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Rashad Ibrahim Mofttah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_28652c68-849a-47f4-9750-104a9bd2187f",
        "address": "",
        "phone": "97108307033",
        "email": "general.alshamsi@lawuae.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d29f6d04-dad1-4f59-9ae2-d4d245f63133",
    "firmName": "AL SHAMSI & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04809",
    "licenseIssueDate": "11/26/2020 00:00:00",
    "licenseExpiryDate": "11/25/2025 00:00:00"
  },
  {
    "id": "70ec2c67-c2df-407f-8946-0aeafa28e412",
    "slug": "mohamed-roshdi-ibrahim",
    "name": "Mohamed Roshdi Ibrahim",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/11/2011",
    "licenseStatus": "active",
    "licenseExpiry": "2012-11-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Roshdi Ibrahim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_70ec2c67-c2df-407f-8946-0aeafa28e412",
        "address": "SAAD AL HAMMADI ,مدخل البرج ,ويست بيري ,برج خليفه ,41747 ,Dubai",
        "phone": "97142405222",
        "email": "info@saadpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "18923100-5b94-44e2-b580-2e3b0cc17bf6",
    "firmName": "SAAD AL HAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02089",
    "licenseIssueDate": "11/29/2011 00:00:00",
    "licenseExpiryDate": "11/20/2025 00:00:00"
  },
  {
    "id": "fdb0e6ff-09f7-4dd9-a6f1-85dd8a14c199",
    "slug": "mohamed-saad-elmaghazy-yousef",
    "name": "Mohamed Saad ElMaghazy Yousef",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/18/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Saad ElMaghazy Yousef",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fdb0e6ff-09f7-4dd9-a6f1-85dd8a14c199",
        "address": "abdulla nasser mansour hamad alkaabi ,life pharmacy ,al safa ,millennium plaza hotel ,113713 ,Dubai",
        "phone": "97143598998",
        "email": "advo.akd@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "05d59198-4e23-4b78-bb9b-d55bfcd69060",
    "firmName": "ABDULLA ALKAABI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06734",
    "licenseIssueDate": "03/18/2025 00:00:00",
    "licenseExpiryDate": "03/17/2026 00:00:00"
  },
  {
    "id": "d4276cf8-dde4-415f-b206-587a17ed9d37",
    "slug": "mohamed-saad-ezzelarab",
    "name": "Mohamed Saad Ezzelarab",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/06/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Saad Ezzelarab",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d4276cf8-dde4-415f-b206-587a17ed9d37",
        "address": "4th floor ,Al Saaha Offices Block D office 401A ,Burj Khalifa ,283773 ,Dubai",
        "phone": "97144221944",
        "email": "gov.depts@alsafarpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b7bbfaeb-1fdb-46d2-97cf-8e6432a9b8a7",
    "firmName": "AL SAFAR & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03001",
    "licenseIssueDate": "05/06/2015 00:00:00",
    "licenseExpiryDate": "05/01/2026 00:00:00"
  },
  {
    "id": "adc45744-bf36-47e1-a214-58f71a81d1bb",
    "slug": "mohamed-saad-mohamed-mowiena",
    "name": "Mohamed saad mohamed mowiena",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/15/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed saad mohamed mowiena",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_adc45744-bf36-47e1-a214-58f71a81d1bb",
        "address": "abdulla nasser mansour hamad alkaabi ,life pharmacy ,al safa ,millennium plaza hotel ,113713 ,Dubai",
        "phone": "97143598998",
        "email": "advo.akd@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "05d59198-4e23-4b78-bb9b-d55bfcd69060",
    "firmName": "ABDULLA ALKAABI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04871",
    "licenseIssueDate": "03/15/2021 00:00:00",
    "licenseExpiryDate": "03/14/2026 00:00:00"
  },
  {
    "id": "62f7624f-0913-4742-a459-030a6a9fd297",
    "slug": "mohamed-safwat-hassan",
    "name": "Mohamed Safwat Hassan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/20/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Safwat Hassan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_62f7624f-0913-4742-a459-030a6a9fd297",
        "address": "الطابق 11 - مكتب رقم (1105 ، 1106)  ,برج السلام  ,منطقة المركز التجاري العالمي 1 ,211911 ,Dubai",
        "phone": "97143366769 / 971503636617",
        "email": "info@erlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "fffe1b8f-e9ab-488f-82eb-6151b8f007df",
    "firmName": "EMAN ALRIFAI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01998",
    "licenseIssueDate": "10/20/2011 00:00:00",
    "licenseExpiryDate": "10/11/2026 00:00:00"
  },
  {
    "id": "cff7bbcd-571a-48a8-b716-b0aa6677bb12",
    "slug": "mohamed-salaheldin-tawfik-hassanein",
    "name": "Mohamed Salaheldin Tawfik Hassanein",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/19/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Salaheldin Tawfik Hassanein",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cff7bbcd-571a-48a8-b716-b0aa6677bb12",
        "address": "29 ,ذا اتش هوتيل ,فندق فيرمونت ,40073 ,Dubai",
        "phone": "97143254000",
        "email": "info@alrowaad.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "759f5477-fdbd-406b-8831-354639c31036",
    "firmName": "AWATIF MOHAMMAD SHOQI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-04489",
    "licenseIssueDate": "09/19/2019 00:00:00",
    "licenseExpiryDate": "09/18/2026 00:00:00"
  },
  {
    "id": "8c9fc845-ea64-46a0-a238-21e4fafd0dd3",
    "slug": "mohamed-salem-okasha",
    "name": "Mohamed Salem Okasha",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/01/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Salem Okasha",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8c9fc845-ea64-46a0-a238-21e4fafd0dd3",
        "address": "",
        "phone": "97143348481",
        "email": "lawyers@maidor.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a48d1666-6ca7-461a-8197-a892ef0f3545",
    "firmName": "AL MAIDOOR ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01704",
    "licenseIssueDate": "11/01/2011 00:00:00",
    "licenseExpiryDate": "10/23/2025 00:00:00"
  },
  {
    "id": "34f62c34-3dbe-4d73-ba1d-0ef647d23542",
    "slug": "mohamed-sayed-ahmed-elsayed-mohsen",
    "name": "Mohamed Sayed Ahmed Elsayed Mohsen",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/01/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Sayed Ahmed Elsayed Mohsen",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_34f62c34-3dbe-4d73-ba1d-0ef647d23542",
        "address": "العاشر ,المسعود ,بجوار معرض تويوتا ,20085 ,Dubai",
        "phone": "97142945554",
        "email": "ahmedalamiri_law@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "91d66bc6-9b89-4272-9d03-494aed8c3f9e",
    "firmName": "AHMED AL AMIRI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-04751",
    "licenseIssueDate": "10/01/2020 00:00:00",
    "licenseExpiryDate": "09/30/2026 00:00:00"
  },
  {
    "id": "547ac6b8-2c33-4313-9633-4d984fa2eb55",
    "slug": "mohamed-selim-hassan",
    "name": "Mohamed Selim Hassan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/08/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Selim Hassan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_547ac6b8-2c33-4313-9633-4d984fa2eb55",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03077",
    "licenseIssueDate": "09/08/2015 00:00:00",
    "licenseExpiryDate": "09/03/2026 00:00:00"
  },
  {
    "id": "3c9e0c4d-b7ff-4886-8ce9-9420925e0813",
    "slug": "mohamed-soliman-yakout-soliman-saad",
    "name": "Mohamed Soliman Yakout Soliman Saad",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/28/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Soliman Yakout Soliman Saad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3c9e0c4d-b7ff-4886-8ce9-9420925e0813",
        "address": "ABDULRAHMAN MOHAMED ALAAMRI ,306 ,ACICO BUISINESS PARK ,NISSAN SHOW ROOM ,33731 ,Dubai",
        "phone": "97148819818 / 971503933245",
        "email": "info@alaamri.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "bf13bfd5-9c31-447d-a1f6-1939ed8ab235",
    "firmName": "ABDULRAHMAN ALAMERI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05509",
    "licenseIssueDate": "09/28/2022 00:00:00",
    "licenseExpiryDate": "09/27/2026 00:00:00"
  },
  {
    "id": "71196dd3-aae0-4412-a0cb-0b6a2ca8f688",
    "slug": "mohamed-talaat-abuelmahasen-basuny",
    "name": "mohamed talaat abuelmahasen basuny",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/22/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: mohamed talaat abuelmahasen basuny",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_71196dd3-aae0-4412-a0cb-0b6a2ca8f688",
        "address": "",
        "phone": "97142830088 / 971505951775",
        "email": "dubai_lc@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dd2f1b59-88fd-4ade-9d8f-139a4b75fef0",
    "firmName": "DUBAI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05219",
    "licenseIssueDate": "02/22/2022 00:00:00",
    "licenseExpiryDate": "02/21/2026 00:00:00"
  },
  {
    "id": "950727c9-c637-4067-819c-55964acc4747",
    "slug": "mohamed-uzair-bulbulia",
    "name": "Mohamed Uzair Bulbulia",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNVQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/09/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Uzair Bulbulia",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_950727c9-c637-4067-819c-55964acc4747",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-06882",
    "licenseIssueDate": "07/09/2025 00:00:00",
    "licenseExpiryDate": "07/08/2026 00:00:00"
  },
  {
    "id": "38b6f49b-64dc-4edf-a04d-62280a43d679",
    "slug": "mohamed-wahid-elsadik-ayob",
    "name": "Mohamed Wahid Elsadik Ayob",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/29/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Wahid Elsadik Ayob",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_38b6f49b-64dc-4edf-a04d-62280a43d679",
        "address": "Mohamed Ibrahim amer ,25 ,Iris bay ,Business bay ,3939 ,Dubai",
        "phone": "97125520551",
        "email": "admin@khuloudsaeed.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "661fa52a-1fed-4a42-af84-3e1a7ba76603",
    "firmName": "KHULOUD SAEED ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03920",
    "licenseIssueDate": "03/29/2023 00:00:00",
    "licenseExpiryDate": "03/28/2026 00:00:00"
  },
  {
    "id": "e0e025ee-0a67-4c46-9bb0-f3cb8830ebf0",
    "slug": "mohamed-waleed-gebril",
    "name": "Mohamed Waleed Gebril",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/05/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Waleed Gebril",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e0e025ee-0a67-4c46-9bb0-f3cb8830ebf0",
        "address": "O-4801, O-4901 ,Burj al Salam Office Tower ,H Hotel ,111801 ,Dubai",
        "phone": "97143544444",
        "email": "administration@horizlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4e25fb39-6659-44f0-bc8b-3ff0f067beb0",
    "firmName": "HORIZONS & CO - LAW FIRM",
    "registrationNumber": "L-01814",
    "licenseIssueDate": "10/05/2011 00:00:00",
    "licenseExpiryDate": "09/25/2026 00:00:00"
  },
  {
    "id": "67b0f3b8-2378-46b7-a3be-f993095220f6",
    "slug": "mohamed-yasser-elsayed-kasem",
    "name": "Mohamed Yasser Elsayed Kasem",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/19/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Yasser Elsayed Kasem",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_67b0f3b8-2378-46b7-a3be-f993095220f6",
        "address": "othman almarzooqi ,19th ,single business tower ,samaya tower ,114333 ,Dubai",
        "phone": "97142999970 / 971500000000",
        "email": "info@othmanadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a0cdd94d-cc5a-4617-b6a3-b23deb9852d5",
    "firmName": "OTHMAN ALMARZOOQI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06721",
    "licenseIssueDate": "03/19/2025 00:00:00",
    "licenseExpiryDate": "03/18/2026 00:00:00"
  },
  {
    "id": "e3f06661-b6bc-4df4-800b-a34a3cef84f0",
    "slug": "mohamed-yassin-awad-elgeed-adam",
    "name": "Mohamed Yassin Awad Elgeed Adam",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/14/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Yassin Awad Elgeed Adam",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e3f06661-b6bc-4df4-800b-a34a3cef84f0",
        "address": "",
        "phone": "97108307033",
        "email": "general.alshamsi@lawuae.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d29f6d04-dad1-4f59-9ae2-d4d245f63133",
    "firmName": "AL SHAMSI & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03741",
    "licenseIssueDate": "05/14/2017 00:00:00",
    "licenseExpiryDate": "05/11/2026 00:00:00"
  },
  {
    "id": "79e38cc7-2d7e-4027-836d-89505c2b73d5",
    "slug": "mohamed-yousef",
    "name": "Mohamed Yousef",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/17/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Yousef",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_79e38cc7-2d7e-4027-836d-89505c2b73d5",
        "address": "",
        "phone": "97143333386 / 971549916936",
        "email": "info@mtaadv.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "466f3ad4-73e1-44db-b8ec-b01e829d77c4",
    "firmName": "MOHAMMAD ALLINJAWI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01670",
    "licenseIssueDate": "07/17/2016 00:00:00",
    "licenseExpiryDate": "07/13/2026 00:00:00"
  },
  {
    "id": "ff9378cb-4c0f-4f8f-bdb6-0bef14a37d62",
    "slug": "mohammad-ali-fayez-elghul",
    "name": "Mohammad Ali Fayez Elghul",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/22/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohammad Ali Fayez Elghul",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ff9378cb-4c0f-4f8f-bdb6-0bef14a37d62",
        "address": "HAMAD ABDULLA ABDULRAHMAN ALRAHMA ALHAMMADI ,14TH FLOOR - 1403 ,PARK PLACE TOWER ,WORLD TRADE CENTER ,114295 ,Dubai",
        "phone": "97144227465 / 971555507070",
        "email": "hessa.alshehhi@primecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d6da9923-01fb-4fd8-a9da-a02d2122dbde",
    "firmName": "Hessa Al Shehhi ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04853",
    "licenseIssueDate": "02/22/2021 00:00:00",
    "licenseExpiryDate": "02/21/2026 00:00:00"
  },
  {
    "id": "d80a56dc-e225-480a-ab8e-bd1dc1b4177d",
    "slug": "mohammad-atfeh",
    "name": "Mohammad Atfeh",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/23/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohammad Atfeh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d80a56dc-e225-480a-ab8e-bd1dc1b4177d",
        "address": "2 ,B62 ,Clock Tower ,13903 ,Dubai",
        "phone": "97142288808",
        "email": "Lawfirm@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2c26b6ea-311a-459a-aae1-8d9965fc9200",
    "firmName": "AL KHALEEJ ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03060",
    "licenseIssueDate": "12/23/2014 00:00:00",
    "licenseExpiryDate": "12/17/2025 00:00:00"
  },
  {
    "id": "c1021963-c8fa-4f47-86e4-dfba27373274",
    "slug": "mohammad-atiq-mubarak-saleh-alsaboosi",
    "name": "Mohammad Atiq Mubarak Saleh Alsaboosi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/22/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohammad Atiq Mubarak Saleh Alsaboosi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c1021963-c8fa-4f47-86e4-dfba27373274",
        "address": "BIN DASMAL BUILDING ,Al Goze ,00000 ,",
        "phone": "/ 971557959999",
        "email": "mahmmadalsaboosi@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "79cd353b-3808-4251-9bbc-af97fdf40780",
    "firmName": "Mohammad Alsaboosi Legal Advice",
    "registrationNumber": "L-06256",
    "licenseIssueDate": "03/22/2024 00:00:00",
    "licenseExpiryDate": "03/21/2026 00:00:00"
  },
  {
    "id": "c939e3dc-b3df-4a24-b88d-129cb2cddaa2",
    "slug": "mohammad-bassem-zein-aldin",
    "name": "Mohammad Bassem Zein Aldin",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohammad Bassem Zein Aldin",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c939e3dc-b3df-4a24-b88d-129cb2cddaa2",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01287",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "f0558b74-bc48-41ec-9db9-885376b79af0",
    "slug": "mohammad-ebrahim-ranjbar-ahmadabadi",
    "name": "mohammad ebrahim ranjbar ahmadabadi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/06/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: mohammad ebrahim ranjbar ahmadabadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f0558b74-bc48-41ec-9db9-885376b79af0",
        "address": "العاشر ,المسعود ,بجوار معرض تويوتا ,20085 ,Dubai",
        "phone": "97142945554",
        "email": "ahmedalamiri_law@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "91d66bc6-9b89-4272-9d03-494aed8c3f9e",
    "firmName": "AHMED AL AMIRI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-05350",
    "licenseIssueDate": "07/06/2022 00:00:00",
    "licenseExpiryDate": "07/05/2026 00:00:00"
  },
  {
    "id": "95840586-39f4-43ec-bdaf-c50ad566e614",
    "slug": "mohammad-hatem-subhi-alzibdeh",
    "name": "Mohammad Hatem Subhi AlZibdeh",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/03/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohammad Hatem Subhi AlZibdeh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_95840586-39f4-43ec-bdaf-c50ad566e614",
        "address": "Al Fattan Currency House Tower 2 ,DIFC ,507176 ,",
        "phone": "/ 971552009003",
        "email": "Mohammad.AlRasheed@bakermckenzie.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "acd81e81-dead-4f7c-839e-0f2a57897265",
    "firmName": "Baker & Mckenzie LLP",
    "registrationNumber": "L-06636",
    "licenseIssueDate": "01/03/2025 00:00:00",
    "licenseExpiryDate": "01/02/2026 00:00:00"
  },
  {
    "id": "6c0e283a-015b-4720-b491-f983fd856599",
    "slug": "mohammad-humaid-mohamed-alansari",
    "name": "Mohammad Humaid Mohamed Alansari",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/30/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohammad Humaid Mohamed Alansari",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6c0e283a-015b-4720-b491-f983fd856599",
        "address": "",
        "phone": "97143585135 / 971503564426",
        "email": "info@alansarilaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "42521deb-a4c5-41c9-989c-c10b046f34b5",
    "firmName": "HUMAID ALANSARI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06571",
    "licenseIssueDate": "10/30/2024 00:00:00",
    "licenseExpiryDate": "10/29/2025 00:00:00"
  },
  {
    "id": "09ab6a83-c3c8-47d6-8691-70167c2436ee",
    "slug": "mohammad-jamil-falah-alshraideh",
    "name": "Mohammad Jamil Falah Alshraideh",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/14/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohammad Jamil Falah Alshraideh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_09ab6a83-c3c8-47d6-8691-70167c2436ee",
        "address": "HAMAD ABDULLA ABDULRAHMAN ALRAHMA ALHAMMADI ,14TH FLOOR - 1403 ,PARK PLACE TOWER ,WORLD TRADE CENTER ,114295 ,Dubai",
        "phone": "97144227465 / 971555507070",
        "email": "hessa.alshehhi@primecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d6da9923-01fb-4fd8-a9da-a02d2122dbde",
    "firmName": "Hessa Al Shehhi ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04567",
    "licenseIssueDate": "11/14/2019 00:00:00",
    "licenseExpiryDate": "11/13/2025 00:00:00"
  },
  {
    "id": "af12395d-a9ba-447b-96d1-378785be0624",
    "slug": "mohammad-jawad-mohammad-nawash",
    "name": "Mohammad Jawad Mohammad Nawash",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/19/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohammad Jawad Mohammad Nawash",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_af12395d-a9ba-447b-96d1-378785be0624",
        "address": "20 ,Index Tower West Tower ,DIFC ,507226 ,Dubai",
        "phone": "97142461900 / 971523391604",
        "email": "patrick.gearon@crsblaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e2ac552e-b9a7-450b-a84d-15119e583220",
    "firmName": "Charles Russell Speechlys LLP",
    "registrationNumber": "L-04796",
    "licenseIssueDate": "11/19/2020 00:00:00",
    "licenseExpiryDate": "11/18/2025 00:00:00"
  },
  {
    "id": "56e4aa49-4a4d-4371-be39-9dda86d845dc",
    "slug": "mohammad-kawasmi",
    "name": "Mohammad Kawasmi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohammad Kawasmi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_56e4aa49-4a4d-4371-be39-9dda86d845dc",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01291",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "b29e8399-6816-4066-8348-19f61fd0033e",
    "slug": "mohammad-nabil-al-muhtaseb",
    "name": "Mohammad Nabil Al Muhtaseb",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohammad Nabil Al Muhtaseb",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b29e8399-6816-4066-8348-19f61fd0033e",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01289",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "b99c9728-3930-4bc0-8b96-c05194b0ddc4",
    "slug": "mohammad-paracha",
    "name": "Mohammad Paracha",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/07/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohammad Paracha",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b99c9728-3930-4bc0-8b96-c05194b0ddc4",
        "address": "ICD Brookfield Place ,Za'abeel 2 ,103747 ,",
        "phone": "97143696300 / 971506008159",
        "email": "mohammed.paracha@nortonrosefulbright.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "c4aaee93-0ec4-4982-9a48-a23699492056",
    "firmName": "Norton Rose Fullbright (Middle East) LLP",
    "registrationNumber": "L-00507",
    "licenseIssueDate": "10/07/2011 00:00:00",
    "licenseExpiryDate": "09/28/2026 00:00:00"
  },
  {
    "id": "34c5c6c6-d9de-4d92-8af6-a54975f66939",
    "slug": "mohammad-ratib-ahmad-elmughrabi",
    "name": "Mohammad Ratib Ahmad Elmughrabi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/09/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-08-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohammad Ratib Ahmad Elmughrabi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_34c5c6c6-d9de-4d92-8af6-a54975f66939",
        "address": "Alhajeya salem saeed alnoobi ,3rd  ,Al-hawai Tower  ,Behind financial center metro station  ,39779 ,Dubai",
        "phone": "97142963813",
        "email": "adv_aljazeera@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "f091b928-9e3d-4e24-b489-65ca31481366",
    "firmName": "AL HAJEYA ALNOOBI ADVOCATES AND LEGAL CONSULTANT",
    "registrationNumber": "L-04528",
    "licenseIssueDate": "10/09/2019 00:00:00",
    "licenseExpiryDate": "10/08/2020 00:00:00"
  },
  {
    "id": "f36161da-13ff-4f26-b4df-08ac5c0e2f10",
    "slug": "mohammad-reda-yahya-al-khateeb",
    "name": "MOHAMMAD REDA ELJATIB KABALAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/10/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2017-10-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohammad Reda Yahya Al Khateeb",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f36161da-13ff-4f26-b4df-08ac5c0e2f10",
        "address": "",
        "phone": "97142566660",
        "email": "dlr@ysalc.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "28be4513-86ae-4602-b4cc-8d52ba959e9e",
    "firmName": "YOUSUF AL SHARIF ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02158",
    "licenseIssueDate": "10/22/2012 00:00:00",
    "licenseExpiryDate": "10/17/2017 00:00:00"
  },
  {
    "id": "22a36d11-ffc6-4d1c-a077-8a099f021df7",
    "slug": "mohammad-tbaishat",
    "name": "Mohammad Tbaishat",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/16/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohammad Tbaishat",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_22a36d11-ffc6-4d1c-a077-8a099f021df7",
        "address": "- ,THE OFFICES 1 ,DWTC ,115580 ,Dubai",
        "phone": "97143739700 / 971562196031",
        "email": "catherine.workman@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6b4ebb23-ef2e-4305-a1ee-43a11e4b1cae",
    "firmName": "Pinsent Masons LLP - Dubai Branch",
    "registrationNumber": "L-00584",
    "licenseIssueDate": "10/16/2016 00:00:00",
    "licenseExpiryDate": "10/12/2026 00:00:00"
  },
  {
    "id": "7ad14b6e-4b6e-4fee-ab95-fd83b2743692",
    "slug": "mohammad-y-a-rwashdeh",
    "name": "MOHAMMAD Y A RWASHDEH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/10/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MOHAMMAD Y A RWASHDEH",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7ad14b6e-4b6e-4fee-ab95-fd83b2743692",
        "address": "",
        "phone": "97144272700 / 971545824605",
        "email": "tony.griffiths@klgates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "fb8fc340-ceef-4b83-8f2b-9b24d4604967",
    "firmName": "K & L Gates LLP",
    "registrationNumber": "L-02605",
    "licenseIssueDate": "10/10/2017 00:00:00",
    "licenseExpiryDate": "10/07/2026 00:00:00"
  },
  {
    "id": "f2cf7557-6605-4961-b09a-932f79e4bc4e",
    "slug": "mohammad-yousef-rasheed-nassar",
    "name": "mohammad yousef rasheed nassar",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/22/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: mohammad yousef rasheed nassar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f2cf7557-6605-4961-b09a-932f79e4bc4e",
        "address": "ABDULLKAREIM AHMED ABDULLA EID ,الطابق الثانى - مكتب رقم 014 ,مركز الممزر  ,مقابل القياده العامه لشرطة دبي - بجوار مكتب وزارة العمل والعمال القديم  ,89505 ,Dubai",
        "phone": "97142388850",
        "email": "bineidadvocates@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ea633c29-6b4a-48a8-aaec-c801ece50744",
    "firmName": "BIN EID ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06246",
    "licenseIssueDate": "03/22/2024 00:00:00",
    "licenseExpiryDate": "03/21/2026 00:00:00"
  },
  {
    "id": "ecc49544-90de-4fd6-a29a-7170ffc6dab0",
    "slug": "mohammed-abbas-hussain-al-obaidi",
    "name": "Mohammed Abbas Hussain Al Obaidi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/14/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-12-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohammed Abbas Hussain Al Obaidi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ecc49544-90de-4fd6-a29a-7170ffc6dab0",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-04297",
    "licenseIssueDate": "01/14/2019 00:00:00",
    "licenseExpiryDate": "01/12/2026 00:00:00"
  },
  {
    "id": "8966737a-a955-45db-b956-55f4c0beb53c",
    "slug": "mohammed-abdelfaheim",
    "name": "Mohammed Abdelfaheim",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohammed Abdelfaheim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8966737a-a955-45db-b956-55f4c0beb53c",
        "address": "29TH  ,PRISM TOWER ,J W MARRIOTT MARQUIS HOTEL  ,4790 ,Dubai",
        "phone": "97144539090",
        "email": "info@alkabban.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a9193879-c34b-4dae-99aa-d8e5ac8517cc",
    "firmName": "AL-KABBAN & ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01394",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "cf062a62-f6d1-47cd-9b35-1a3bf3240e0f",
    "slug": "mohammed-abdelwahab-mohammed-salih-mahmoud",
    "name": "Mohammed Abdelwahab Mohammed Salih Mahmoud",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/02/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohammed Abdelwahab Mohammed Salih Mahmoud",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cf062a62-f6d1-47cd-9b35-1a3bf3240e0f",
        "address": "21 ,Rolex Tower ,Emirates Grand Hotel ,94334 ,Dubai",
        "phone": "97143277772 / 97145584900",
        "email": "info@globaladvocates.net",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9b42810f-1d55-4aea-ac4a-7d9d1b25ac08",
    "firmName": "GLOBAL ADVOCACY & LEGAL COUNSEL",
    "registrationNumber": "L-06435",
    "licenseIssueDate": "08/02/2024 00:00:00",
    "licenseExpiryDate": "08/01/2026 00:00:00"
  },
  {
    "id": "3e667360-747a-4ad9-9716-f893b6eb7e9f",
    "slug": "mohammed-abdullah-faroq-luqman",
    "name": "Mohammed Abdullah Faroq Luqman",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/20/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohammed Abdullah Faroq Luqman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3e667360-747a-4ad9-9716-f893b6eb7e9f",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05042",
    "licenseIssueDate": "09/20/2021 00:00:00",
    "licenseExpiryDate": "09/19/2026 00:00:00"
  },
  {
    "id": "338335db-3175-41bf-85ec-5ea0e91671eb",
    "slug": "mohammed-al-ahdal",
    "name": "Mohammed Al Ahdal",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/03/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohammed Al Ahdal",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_338335db-3175-41bf-85ec-5ea0e91671eb",
        "address": "",
        "phone": "97143685555",
        "email": "maisa.maarouf@bsabh.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8afa232f-52ff-4dad-82c3-9a04d66eb853",
    "firmName": "B S A AHMED BIN HAZEEM & ASSOCIATES LLP - DIFC",
    "registrationNumber": "L-03550",
    "licenseIssueDate": "11/03/2016 00:00:00",
    "licenseExpiryDate": "10/30/2025 00:00:00"
  },
  {
    "id": "c78b437a-d639-4d4b-a5b0-2b84449afae0",
    "slug": "mohammed-al-shukairy",
    "name": "Mohammed Al- Shukairy",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohammed Al- Shukairy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c78b437a-d639-4d4b-a5b0-2b84449afae0",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-00168",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "d484a849-3b90-471a-97c9-ffcc8640508b",
    "slug": "mohammed-alkhatim-fadlallag-ali-mohammed-ahmed",
    "name": "Mohammed Alkhatim Fadlallag Ali Mohammed Ahmed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/08/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohammed Alkhatim Fadlallag Ali Mohammed Ahmed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d484a849-3b90-471a-97c9-ffcc8640508b",
        "address": "",
        "phone": "97145799599 / 971457995992",
        "email": "info@lmlegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "fed194c9-41cf-42f3-888e-924faa26b282",
    "firmName": "LUBNA MOOSA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05321",
    "licenseIssueDate": "05/08/2025 00:00:00",
    "licenseExpiryDate": "05/07/2026 00:00:00"
  },
  {
    "id": "75afd3e1-1fae-4ad8-88a8-19b579d748c2",
    "slug": "mohammed-assi-aziza",
    "name": "Mohammed Assi Aziza",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohammed Assi Aziza",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_75afd3e1-1fae-4ad8-88a8-19b579d748c2",
        "address": "ABDULLAH AMIN ALZAROONI ,209+210+611+211 ,بزنس افينيو ,خلف وكالة النيسان ,12781 ,Dubai",
        "phone": "97142954299",
        "email": "zaroonilawyers@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "da078082-58a6-4951-b43c-9a5a9bf24934",
    "firmName": "ABDULLA AL ZAROONI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01542",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "6622d2e7-faf0-45db-b826-bd7b024e113a",
    "slug": "mohammed-faisal-mohammed-salih-basama",
    "name": "MOHAMMED FAISAL MOHAMMED SALIH BASAMA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/08/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohammed Faisal Mohammed Salih Basama",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6622d2e7-faf0-45db-b826-bd7b024e113a",
        "address": "",
        "phone": "97143779900 / 971508548052",
        "email": "jali@kslaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dff8529a-82be-431a-b72b-0192ff238011",
    "firmName": "King & Spalding LLP",
    "registrationNumber": "L-04996",
    "licenseIssueDate": "08/09/2021 00:00:00",
    "licenseExpiryDate": "08/08/2026 00:00:00"
  },
  {
    "id": "764a5350-82fb-4f0e-b83f-743cea054eef",
    "slug": "mohammed-hussain-ali-tartir",
    "name": "MOHAMMED HUSSAIN ALI TARTIR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/02/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohammed Hussain Ali Tartir",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_764a5350-82fb-4f0e-b83f-743cea054eef",
        "address": "",
        "phone": "97104309100 / 971564013758",
        "email": "c.royle@taylorwessing.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d51b6f43-8c62-486f-a1ab-6ee3b87c8006",
    "firmName": "Taylor Wessing LLP (Dubai Branch)",
    "registrationNumber": "L-04627",
    "licenseIssueDate": "02/20/2020 00:00:00",
    "licenseExpiryDate": "02/19/2026 00:00:00"
  },
  {
    "id": "1a9ec535-bfcd-4d22-bb5c-79651819ec86",
    "slug": "mohammed-ibrahim-mustafa-abdelrahim",
    "name": "MOHAMMED IBRAHIM MUSTAFA ABDELRAHIM",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Civil Transactions-Insurance",
      "Personal Status-Custody & Alimony",
      "Commercial Transactions-Commercial Real Estate",
      "Civil Transactions-Tenancy",
      "Personal Status-Legacies and Inheritance",
      "Personal Status-Legal Capacity & Guardianship",
      "Personal Status-Marriage & Divorce",
      "Civil Transactions-Compensation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/05/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohammed Ibrahim Mustafa Abdelrahim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1a9ec535-bfcd-4d22-bb5c-79651819ec86",
        "address": "السابع - مكتب 704 ,قرية الأعمال - بلوك B ,دوار الساعة ,183303 ,Dubai",
        "phone": "97142280050",
        "email": "aisha@aishalawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d06b333-b07b-4ed3-813b-3b56f638b071",
    "firmName": "AAESHA ALTENEIJI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05212",
    "licenseIssueDate": "05/23/2024 00:00:00",
    "licenseExpiryDate": "05/22/2026 00:00:00"
  },
  {
    "id": "2282a37f-6f9b-438b-897b-0035da15265a",
    "slug": "mohammed-mana-hamed-mana-al-hinai",
    "name": "MOHAMMED MANA HAMED MANA AL HINAI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/19/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MOHAMMED MANA HAMED MANA AL HINAI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2282a37f-6f9b-438b-897b-0035da15265a",
        "address": "",
        "phone": "97142949937",
        "email": "info@rslawyers.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d544ee54-219a-446f-86c7-d6f4d1b1588c",
    "firmName": "REEM SALEH ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06723",
    "licenseIssueDate": "03/19/2025 00:00:00",
    "licenseExpiryDate": "03/18/2026 00:00:00"
  },
  {
    "id": "c6daa354-cbb5-4f91-83a0-77e4eee9f2b0",
    "slug": "mohammed-marwan-al-rasheed",
    "name": "MOHAMMAD MARWAN AHMAD AL RASHEED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/09/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohammed Marwan Al Rasheed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c6daa354-cbb5-4f91-83a0-77e4eee9f2b0",
        "address": "Al Fattan Currency House Tower 2 ,DIFC ,507176 ,",
        "phone": "/ 971552009003",
        "email": "Mohammad.AlRasheed@bakermckenzie.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "acd81e81-dead-4f7c-839e-0f2a57897265",
    "firmName": "Baker & Mckenzie LLP",
    "registrationNumber": "L-02591",
    "licenseIssueDate": "09/26/2022 00:00:00",
    "licenseExpiryDate": "09/25/2026 00:00:00"
  },
  {
    "id": "ca209db7-97a8-4c89-a6a7-33a2064ef9b3",
    "slug": "mohammed-mohsen-abouzeid",
    "name": "MOHAMMED MOHSEN ABOUZEID",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/01/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohammed Mohsen Abouzeid",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ca209db7-97a8-4c89-a6a7-33a2064ef9b3",
        "address": "0 ,ICD Brookfield Place Level 13 ,Trade Centre ,506569 ,Dubai",
        "phone": "97145099100 / 971501006965",
        "email": "menahr@freshfields.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "970f6246-e737-41a7-9c6c-5aa5b8335d45",
    "firmName": "Freshfields LLP DIFC",
    "registrationNumber": "L-06177",
    "licenseIssueDate": "01/31/2024 00:00:00",
    "licenseExpiryDate": "01/30/2026 00:00:00"
  },
  {
    "id": "10503798-4d24-4145-aff9-76071960b818",
    "slug": "mohammed-omar-shadid",
    "name": "MOHAMED OMAR MOHAMED SHEDEED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohammed Omar Shadid",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_10503798-4d24-4145-aff9-76071960b818",
        "address": "Hussain Ali Al Jaziri ,11 ,City Tower 2 ,Crown Plaza hotel Sheikh Zayed Road ,4253 ,Dubai",
        "phone": "97142626777 / 971529087670",
        "email": "courts@jaflaws.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c58d8654-b428-46b3-abd5-024e4331ee53",
    "firmName": "JAAFAR ALWAN & AL JAZIRI & ASSOCIATES",
    "registrationNumber": "L-01609",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "16defe54-44c6-4c73-b086-c3a4f5bfea67",
    "slug": "mohammed-rihan-raheem-mukachan-kandy-raheem",
    "name": "Mohammed Rihan Raheem Mukachan Kandy Raheem",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/09/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohammed Rihan Raheem Mukachan Kandy Raheem",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_16defe54-44c6-4c73-b086-c3a4f5bfea67",
        "address": "HOSSAM GAMAL MOHAMED ELSOKARY ,26 ,Citadel tower ,Marasi Drive ,5586 ,Dubai",
        "phone": "97142555110",
        "email": "fetouh@alnassar.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "83443142-de5a-4089-8798-9ed25b7885de",
    "firmName": "AL NASSAR ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06526",
    "licenseIssueDate": "10/09/2024 00:00:00",
    "licenseExpiryDate": "10/08/2025 00:00:00"
  },
  {
    "id": "c19af9e1-9abc-48e4-81ed-b5a90e5ca871",
    "slug": "mohammed-saad-swileh-al-kahtani",
    "name": "MOHAMMED SAAD SWILEH AL KAHTANI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/03/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: mohammed saad swileh al kahtani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c19af9e1-9abc-48e4-81ed-b5a90e5ca871",
        "address": "MOHAMMED ABDULLA MOHSIN ABDURAHIM ALBREIKI ,406 ,ويست بيري ,برج خليفة ,220219 ,Dubai",
        "phone": "97145574529",
        "email": "d@albraikiadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ef095fb8-c3b5-42bc-92fc-43528c870fe7",
    "firmName": "MOHAMMED ABDULLA ALBREIKE ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04051",
    "licenseIssueDate": "03/08/2018 00:00:00",
    "licenseExpiryDate": "03/05/2026 00:00:00"
  },
  {
    "id": "2c68f099-22e4-4131-b370-cf9b450bbcb4",
    "slug": "mohammed-said-abdullah-mohammed-al-abri",
    "name": "Mohammed Said Abdullah Mohammed Al Abri",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/01/2025",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohammed Said Abdullah Mohammed Al Abri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2c68f099-22e4-4131-b370-cf9b450bbcb4",
        "address": "",
        "phone": "97122222222",
        "email": "info@ayalegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "843234aa-d59b-4763-b69a-ba92f9cbba70",
    "firmName": "ALI YOUSUF ALAWADHI ADVOCATES & LEGAL CONSULTANTS L.L.C",
    "registrationNumber": "L-06655",
    "licenseIssueDate": "01/20/2025 00:00:00",
    "licenseExpiryDate": "01/19/2026 00:00:00"
  },
  {
    "id": "e63e2f73-24c7-4374-a7d0-b90f1e1fd367",
    "slug": "mohammed-shallal-habeeb-al-ani",
    "name": "MOHAMMED SHALLAL HABEEB AL ANI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/10/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohammed Shallal Habeeb Al Ani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e63e2f73-24c7-4374-a7d0-b90f1e1fd367",
        "address": "Azza Ebrahim Hasan Almulla ,6(602-603) ,Al Shoalla Building (Al Naboodah) ,deira city center ,12871 ,Dubai",
        "phone": "97142950010",
        "email": "dubai-secretary@dralmulla.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "fbf6220f-2608-4caa-895e-d45ae8a259a2",
    "firmName": "AZZA EBRAHIM HASAN ALMULLA ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-06987"
  },
  {
    "id": "1e0ebf17-e076-418e-a87d-958fe19c1b27",
    "slug": "mohammed-tawfeek-mohammed-ahmed",
    "name": "MOHAMMED TAWFEEK MOHAMMED AHMED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/07/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohammed Tawfeek Mohammed Ahmed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1e0ebf17-e076-418e-a87d-958fe19c1b27",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-05399",
    "licenseIssueDate": "07/06/2022 00:00:00",
    "licenseExpiryDate": "07/05/2026 00:00:00"
  },
  {
    "id": "f0a39680-20ef-41ef-b6c7-89cb35966bb8",
    "slug": "mohammed-yousuf-ahmed-raeialboom",
    "name": "MOHAMMED YOUSUF AHMED M RAEI ALBOOM",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/07/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohammed Yousuf Ahmed RaeiAlboom",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f0a39680-20ef-41ef-b6c7-89cb35966bb8",
        "address": "",
        "phone": "/ 971555527527",
        "email": "m.raialboomadvocates@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "e98bf25b-3da7-44cf-bb1c-28f6e31e271a",
    "firmName": "Mohammed Raei Alboom Legal Consultants",
    "registrationNumber": "L-06912",
    "licenseIssueDate": "07/25/2025 00:00:00",
    "licenseExpiryDate": "07/24/2026 00:00:00"
  },
  {
    "id": "7c4fa2d3-d372-4ad8-b91f-1c1d9c38c8ec",
    "slug": "mohammed-haykel-hajjaji",
    "name": "MOHAMMED HAYKEL HAJJAJI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/02/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-02-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohammed-Haykel Hajjaji",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7c4fa2d3-d372-4ad8-b91f-1c1d9c38c8ec",
        "address": "",
        "phone": "97142472100 / 971509224336",
        "email": "bhaley@cov.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "65a2e90a-6978-4292-b3f1-ecbebedd7b9a",
    "firmName": "Covington & Burling LLP (Middle East)",
    "registrationNumber": "L-02871",
    "licenseIssueDate": "02/08/2015 00:00:00",
    "licenseExpiryDate": "02/02/2026 00:00:00"
  },
  {
    "id": "c3fed2c8-dac1-4e53-8cec-5fa0771dfc9b",
    "slug": "mohammid-hamid-kamil-mohammid-selim",
    "name": "MOHAMMID HAMID KAMIL MOHAMMID SELIM",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/08/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: mohammid hamid kamil mohammid selim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c3fed2c8-dac1-4e53-8cec-5fa0771dfc9b",
        "address": "الثالث  ,اركاد  ,الطاير للسيارات  ,20877 ,Dubai",
        "phone": "97142833355",
        "email": "Fahadadvo@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7dd7860a-cd36-443b-a1b7-62dd3050e6b9",
    "firmName": "FAHAD ABDULLA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05001",
    "licenseIssueDate": "08/02/2021 00:00:00",
    "licenseExpiryDate": "08/01/2026 00:00:00"
  },
  {
    "id": "563bdebd-32e4-4f03-b788-5e80678d341a",
    "slug": "mohanan-manoj-vazheparambil",
    "name": "Mohanan Manoj Vazheparambil",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-02-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohanan Manoj Vazheparambil",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_563bdebd-32e4-4f03-b788-5e80678d341a",
        "address": "Nasser Yousuf Mohammed Aljaroodi ,الطابق الثاني - مكتب رقم 2015A ,مركز مزايا للتسوق  ,بالقرب من محطة مترو برج خليفة - دبي مول - مخرج رقم 2 ,5958 ,Dubai",
        "phone": "97143699915 / 971561339712",
        "email": "info@aljaroodiadv.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e9977c41-28ca-4173-b8d2-ef9fa1de8472",
    "firmName": "NASSER AL JAROODI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01863",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/22/2019 00:00:00"
  },
  {
    "id": "2ee0c6bd-f9cf-48c5-b7fb-eaf010d32c7e",
    "slug": "mohand-hassan-mahdi-elshaikh",
    "name": "MOHAND HASSAN MAHDI ELSHAIKH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/02/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-02-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohand Hassan Mahdi Elshaikh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2ee0c6bd-f9cf-48c5-b7fb-eaf010d32c7e",
        "address": "",
        "phone": "97143303900 / 971561753537",
        "email": "christopher@afridi-angell.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "30ce50dc-01a6-499d-8ace-3f807ddcb08d",
    "firmName": "Afridi & Angell-DED",
    "registrationNumber": "L-04838",
    "licenseIssueDate": "02/11/2021 00:00:00",
    "licenseExpiryDate": "02/10/2026 00:00:00"
  },
  {
    "id": "12c78e04-2654-42a7-a86f-7426f33539d8",
    "slug": "mohannad-abdelrazag-el-murtadi-suleiman",
    "name": "MOHANNAD ABDELRAZAG EL MURTADI SULEIMAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/02/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohannad Abdelrazag El Murtadi Suleiman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_12c78e04-2654-42a7-a86f-7426f33539d8",
        "address": "",
        "phone": "97143826100 / 971507380618",
        "email": "jmiocevic@curtis.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0867bcc5-10fa-4783-91ae-b8f63e02e81a",
    "firmName": "Curtis Mallet-Prevost, Colt & Mosle LLP",
    "registrationNumber": "L-06668",
    "licenseIssueDate": "02/14/2025 00:00:00",
    "licenseExpiryDate": "02/13/2026 00:00:00"
  },
  {
    "id": "7c8c5aa5-e564-4e43-81b9-c9cc665364ad",
    "slug": "mohd-ahmad-mohd-zaidan",
    "name": "MOHD AHMAD MOHD ZAIDAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/12/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohd Ahmad Mohd Zaidan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7c8c5aa5-e564-4e43-81b9-c9cc665364ad",
        "address": "HAMAD ABDULLA ABDULRAHMAN ALRAHMA ALHAMMADI ,14TH FLOOR - 1403 ,PARK PLACE TOWER ,WORLD TRADE CENTER ,114295 ,Dubai",
        "phone": "97144227465 / 971555507070",
        "email": "hessa.alshehhi@primecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d6da9923-01fb-4fd8-a9da-a02d2122dbde",
    "firmName": "Hessa Al Shehhi ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04580",
    "licenseIssueDate": "12/09/2019 00:00:00",
    "licenseExpiryDate": "12/08/2025 00:00:00"
  },
  {
    "id": "7cd05fb7-7588-4684-87e9-3432c37d9949",
    "slug": "mohd-sadique-bin-ibrahim-marican",
    "name": "MOHD SADIQUE BIN IBRAHIM MARICAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/11/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohd Sadique Bin Ibrahim Marican",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7cd05fb7-7588-4684-87e9-3432c37d9949",
        "address": "Gamal Yassein Abdalla ,الطابق 13  Floor No 13 ,بناية مركز ابروي (The Oberoi Center) ,فندق ابروي (The Oberoi Hotel) ,33299 ,Dubai",
        "phone": "97142828000",
        "email": "litigation@alaidarous.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9a923766-1fd1-4e06-a871-89662120384e",
    "firmName": "AL AIDAROUS ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-05342",
    "licenseIssueDate": "11/07/2023 00:00:00",
    "licenseExpiryDate": "11/06/2025 00:00:00"
  },
  {
    "id": "dc361f4c-8ed6-424f-bfb8-e3e1877de6f6",
    "slug": "mohnad-alknani",
    "name": "MOHNAD AHMAD ALKNANI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Civil Transactions-Construction and Contracts for Services",
      "Civil Transactions-Ownership & Title",
      "Criminal Law-Family Crimes",
      "Personal Status-Custody & Alimony",
      "Civil Transactions-Residential Real Estate",
      "Civil Transactions-Tenancy",
      "Commercial Transactions-Unfair competition",
      "Civil Transactions-Sale",
      "Proceedings-Cases and Proceedings before arbitral tribunals and other alternative dispute resolution bodies",
      "Personal Status-Marriage & Divorce",
      "Civil Transactions-Compensation",
      "Commercial Transactions-Intellectual Property (includes trademarks",
      "copy rights",
      "patents)"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/01/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohnad Alknani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dc361f4c-8ed6-424f-bfb8-e3e1877de6f6",
        "address": "ABDULLAH AMIN ALZAROONI ,209+210+611+211 ,بزنس افينيو ,خلف وكالة النيسان ,12781 ,Dubai",
        "phone": "97142954299",
        "email": "zaroonilawyers@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "da078082-58a6-4951-b43c-9a5a9bf24934",
    "firmName": "ABDULLA AL ZAROONI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03608",
    "licenseIssueDate": "02/01/2017 00:00:00",
    "licenseExpiryDate": "01/28/2026 00:00:00"
  },
  {
    "id": "64df419b-4a51-4d9c-ba5c-ab3131c40750",
    "slug": "mohsen-ahmed-kamel-ahmed-elshennawi",
    "name": "MOHSEN AHMED KAMEL AHMED ELSHENNAWI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/07/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohsen Ahmed Kamel Ahmed Elshennawi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_64df419b-4a51-4d9c-ba5c-ab3131c40750",
        "address": "",
        "phone": "97145579711",
        "email": "info@mqadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9f91cca7-a15d-499f-b265-2a032fe38fa1",
    "firmName": "FATMA ALMUTAWA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03839",
    "licenseIssueDate": "07/13/2017 00:00:00",
    "licenseExpiryDate": "07/10/2026 00:00:00"
  },
  {
    "id": "7a2a279f-a1da-46a8-a744-8100d5746b96",
    "slug": "mohsen-mohamed-zin-el-din",
    "name": "MOHSEN MOHAMED SOLIMAN ZINELDIN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohsen Mohamed Zin El-Din",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7a2a279f-a1da-46a8-a744-8100d5746b96",
        "address": "",
        "phone": "97143944088 / 971547800401",
        "email": "info@almurlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "cfc90bc1-eca3-4d64-879b-70aeaa0925d3",
    "firmName": "DR MOHAMED ALMUR ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02189",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "56238cf2-aea0-4b0f-a8a1-a6af5e3b57d5",
    "slug": "mohsen-moustafa-mohamed",
    "name": "MOHSEN MOUSTAFA ELMORSY MOHAMED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohsen Moustafa Mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_56238cf2-aea0-4b0f-a8a1-a6af5e3b57d5",
        "address": "4th Floor/ Office no. 401 ,Business Avenue  ,Infront- Terminal 2  ,115263 ,Dubai",
        "phone": "97144518866",
        "email": "info@aldhaheriinternational.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "cf3c19c0-d396-4bcb-b1db-b81273ed0b4c",
    "firmName": "AL DHAHERI INTERNATIONAL ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01371",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "9adf9371-6c0c-41d4-8c1c-a3569036bcb4",
    "slug": "mohsin-sarwar-abbasi",
    "name": "MOHSIN SARWAR ABBASI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/06/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohsin Sarwar Abbasi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9adf9371-6c0c-41d4-8c1c-a3569036bcb4",
        "address": "",
        "phone": "97143897000 / 971506553198",
        "email": "nasseralikhasawneh@eversheds-sutherland.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "74a21d43-41d8-480a-a6af-6939b7c98a95",
    "firmName": "Eversheds Sutherland (International LLP) Dubai Branch",
    "registrationNumber": "L-04429",
    "licenseIssueDate": "06/12/2019 00:00:00",
    "licenseExpiryDate": "06/11/2026 00:00:00"
  },
  {
    "id": "fd923d9a-2af4-4135-9a89-7d1f5b564118",
    "slug": "mohsin-yunus-suleman",
    "name": "MOHSIN YUNUS SULEMAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/07/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohsin Yunus Suleman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fd923d9a-2af4-4135-9a89-7d1f5b564118",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-02532",
    "licenseIssueDate": "07/17/2024 00:00:00",
    "licenseExpiryDate": "07/16/2026 00:00:00"
  },
  {
    "id": "a6dd28bb-a80f-48c2-b5b2-4c19d01534f3",
    "slug": "mojahed-al-sebae",
    "name": "MOJAHED OMAR AL SEBAE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Commercial Companies",
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Civil Transactions-POA & Sponsorship",
      "Civil Transactions-Insurance",
      "Civil Transactions-Construction and Contracts for Services",
      "Civil Transactions-Ownership & Title",
      "Civil Transactions-HR & Employee Affairs",
      "Commercial Transactions-Commercial Mortgage",
      "Commercial Transactions-Commercial Contracts",
      "Commercial Transactions-Bankruptcy",
      "Commercial Transactions-Unfair competition",
      "Civil Transactions-Labor & Workers",
      "Civil Transactions-Sale",
      "Commercial Transactions-Consumer protection",
      "Personal Status-Marriage & Divorce",
      "Civil Transactions-Compensation",
      "Commercial Transactions-Stock",
      "Criminal Law-Crimes against properties",
      "Commercial Transactions-E-Commerce"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/06/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mojahed Al Sebae",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a6dd28bb-a80f-48c2-b5b2-4c19d01534f3",
        "address": "",
        "phone": "/ 971000000000",
        "email": "info@alsebae.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "6f0ce9e2-8a80-46ee-a843-15e621a85237",
    "firmName": "Mojahed Al Sebae Legal Consultancy",
    "registrationNumber": "L-02513",
    "licenseIssueDate": "06/12/2024 00:00:00",
    "licenseExpiryDate": "06/11/2026 00:00:00"
  },
  {
    "id": "2b5a36fa-d3b1-4d5d-81b1-abfee082aef9",
    "slug": "molly-burke",
    "name": "MOLLY SARAH BURKE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/07/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Molly Burke",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2b5a36fa-d3b1-4d5d-81b1-abfee082aef9",
        "address": "Level 14 ,Burj Daman ,Four Seasons Hotel ,119980 ,Dubai",
        "phone": "97143604070 / 971502450485",
        "email": "Philip.ireland@maples.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "cb7cc285-8538-469a-b075-ef30819bce69",
    "firmName": "Gibson Dunn & Crutcher LLP",
    "registrationNumber": "L-05401",
    "licenseIssueDate": "07/18/2022 00:00:00",
    "licenseExpiryDate": "07/17/2026 00:00:00"
  },
  {
    "id": "718d2929-f58c-476f-89ca-5b6dd29c6d94",
    "slug": "mona-abu-zalaf",
    "name": "MONA ABU ZALAF",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/06/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mona Abu Zalaf",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_718d2929-f58c-476f-89ca-5b6dd29c6d94",
        "address": "ICD Brookfield Place ,DIFC ,506516 ,",
        "phone": "97143695800 / 971505526206",
        "email": "scott.campbell@linklaters.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5cec94c0-0649-43b6-a2be-ab17ff422bce",
    "firmName": "LinkLaters LLP",
    "registrationNumber": "L-05367",
    "licenseIssueDate": "06/08/2022 00:00:00",
    "licenseExpiryDate": "06/07/2026 00:00:00"
  },
  {
    "id": "de3cac09-1a17-4bd5-a329-0751e25a6dcc",
    "slug": "mona-faisal-mohamed-ali-husain-hammadi",
    "name": "Mona Faisal Mohamed Ali Husain Hammadi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/07/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mona Faisal Mohamed Ali Husain Hammadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_de3cac09-1a17-4bd5-a329-0751e25a6dcc",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-02997",
    "licenseIssueDate": "08/07/2024 00:00:00",
    "licenseExpiryDate": "08/06/2026 00:00:00"
  },
  {
    "id": "72c45e57-88be-47bd-960d-ff6acd2f731d",
    "slug": "mona-kalantar",
    "name": "MONA KALANTAR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/09/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mona Kalantar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_72c45e57-88be-47bd-960d-ff6acd2f731d",
        "address": "",
        "phone": "97143184600 / 971504468184",
        "email": "melaraby@gibsondunn.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c9d2c9d0-6e43-4253-a75d-cdeb400f8d8e",
    "firmName": "Gibson Dunn & Crutcher LLP",
    "registrationNumber": "L-06501",
    "licenseIssueDate": "09/25/2024 00:00:00",
    "licenseExpiryDate": "09/24/2026 00:00:00"
  },
  {
    "id": "37ac5fea-add1-4cbc-9292-6537d5a8b57c",
    "slug": "mona-lemp",
    "name": "MONA BARBARA LEMP",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/05/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mona Lemp",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_37ac5fea-add1-4cbc-9292-6537d5a8b57c",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-00804",
    "licenseIssueDate": "05/09/2022 00:00:00",
    "licenseExpiryDate": "05/08/2026 00:00:00"
  },
  {
    "id": "204a530e-93d8-49db-b3d2-b98c07ae2a26",
    "slug": "mona-mohamed-ahmed-ali-khamis",
    "name": "Mona Mohamed Ahmed Ali Khamis",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/10/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2022-10-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mona Mohamed Ahmed Ali Khamis",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_204a530e-93d8-49db-b3d2-b98c07ae2a26",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04529",
    "licenseIssueDate": "10/24/2019 00:00:00",
    "licenseExpiryDate": "10/23/2022 00:00:00"
  },
  {
    "id": "e2f7731f-de51-406e-9fe4-a132a36b789a",
    "slug": "mona-mohamed-zaki-moussa",
    "name": "Mona Mohamed Zaki Moussa",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/12/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2022-11-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mona Mohamed Zaki Moussa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e2f7731f-de51-406e-9fe4-a132a36b789a",
        "address": "مكتب رقم 403 – 504 - 102 ,القرن الواحد وعشرون ,مركز القبائل للتخفيضات ,68441 ,Dubai",
        "phone": "97142388763",
        "email": "shaikha.advo@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "80a47f20-166e-40d9-9dea-d793f4708270",
    "firmName": "SHAIKHA AHMAD ADVOCATES&LEGAL CONSULTANTS",
    "registrationNumber": "L-04989",
    "licenseIssueDate": "07/12/2021 00:00:00",
    "licenseExpiryDate": "07/11/2022 00:00:00"
  },
  {
    "id": "db39f2e1-279e-4403-a2c9-ba8fb57faef3",
    "slug": "mona-mostafa-fahmy-mostafa-elgady",
    "name": "MONA MOSTAFA FAHMY MOSTAFA ELGADY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/11/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mona Mostafa Fahmy Mostafa Elgady",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_db39f2e1-279e-4403-a2c9-ba8fb57faef3",
        "address": "21 ,Rolex Tower ,Emirates Grand Hotel ,94334 ,Dubai",
        "phone": "97143277772 / 97145584900",
        "email": "info@globaladvocates.net",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9b42810f-1d55-4aea-ac4a-7d9d1b25ac08",
    "firmName": "GLOBAL ADVOCACY & LEGAL COUNSEL",
    "registrationNumber": "L-05636",
    "licenseIssueDate": "11/23/2022 00:00:00",
    "licenseExpiryDate": "11/22/2025 00:00:00"
  },
  {
    "id": "2be80134-1ac5-49f0-992e-2b95817932d2",
    "slug": "monia-saadalah-al-khalaji",
    "name": "Monia Saadalah Al Khalaji",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/14/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2021-12-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Monia Saadalah Al Khalaji",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2be80134-1ac5-49f0-992e-2b95817932d2",
        "address": "ali mohamed saif ,مكتب 1501 ,داماس ,رقة البطين ,25900 ,Dubai",
        "phone": "97142555779 / 971553616616",
        "email": "info@aleter.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9dd97fa5-b744-465f-bac7-8ab23b9eda4f",
    "firmName": "ALI ALETER ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-04097",
    "licenseIssueDate": "05/14/2018 00:00:00",
    "licenseExpiryDate": "05/12/2021 00:00:00"
  },
  {
    "id": "02d3e0c0-58d1-4df7-8da1-1848d19bcd2c",
    "slug": "monika-humphreys-davies",
    "name": "MONIKA HUMPHREYS DAVIES",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/12/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Monika Humphreys Davies",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_02d3e0c0-58d1-4df7-8da1-1848d19bcd2c",
        "address": "",
        "phone": "97144073901 / 971503479508",
        "email": "Rania.Tadros@stephensonharwood.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dd5042a2-bb41-4123-9544-79c3fa831332",
    "firmName": "Stephenson Harwood (Middle East) LLP",
    "registrationNumber": "L-03922",
    "licenseIssueDate": "12/11/2017 00:00:00",
    "licenseExpiryDate": "12/08/2025 00:00:00"
  },
  {
    "id": "a3475aed-9573-48dd-8944-85558b85d1c1",
    "slug": "monique-o-donoghue",
    "name": "MONIQUE MENDEZ ODONOGHUE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/02/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Monique O' Donoghue",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a3475aed-9573-48dd-8944-85558b85d1c1",
        "address": "",
        "phone": "97142472100 / 971509224336",
        "email": "bhaley@cov.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "65a2e90a-6978-4292-b3f1-ecbebedd7b9a",
    "firmName": "Covington & Burling LLP (Middle East)",
    "registrationNumber": "L-02390",
    "licenseIssueDate": "02/17/2014 00:00:00",
    "licenseExpiryDate": "02/10/2026 00:00:00"
  },
  {
    "id": "a031b8e9-1aa4-4ab1-8904-b6626e858596",
    "slug": "montaser-mahmoud-hassan-abo-khalaa",
    "name": "MONTASER MAHMOUD HASSAN ABOKHALAA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/11/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-11-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Montaser Mahmoud Hassan Abo khalaa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a031b8e9-1aa4-4ab1-8904-b6626e858596",
        "address": "13 ,INTERNATIONAL BUSINESS TOWER ,Next to The First Collection Business Bay Hotel ,6917 ,Dubai",
        "phone": "97143421661 / 971527070780",
        "email": "mohammad@masoudlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "21caacdc-9052-48b5-921c-7c973ac4abd3",
    "firmName": "MOHAMMAD MASOUD ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04804",
    "licenseIssueDate": "11/26/2020 00:00:00",
    "licenseExpiryDate": "11/25/2025 00:00:00"
  },
  {
    "id": "23da0fdd-d639-48ff-8db7-5b72e448216c",
    "slug": "mosaab-tharwat-aly-mohamed",
    "name": "MOSAAB THARWAT ALY MOHAMED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Cases and Proceedings before Dubai International Financial Centre",
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Commercial Transactions-Bankruptcy",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Civil Transactions-Arbitration",
      "Commercial Transactions-Unfair competition",
      "Personal Status-Legacies and Inheritance",
      "Proceedings-Cases and Proceedings before arbitral tribunals and other alternative dispute resolution bodies",
      "Civil Transactions-Compensation",
      "Criminal Law-Crimes against properties"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mosaab Tharwat Aly Mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_23da0fdd-d639-48ff-8db7-5b72e448216c",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02254",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "65b30dc3-51b3-493a-b72c-db318561bce5",
    "slug": "mosaad-fathy-abdelaziz-ali",
    "name": "MOSAAD FATHY ABDELAZIZ ALI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/09/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mosaad Fathy Abdelaziz Ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_65b30dc3-51b3-493a-b72c-db318561bce5",
        "address": "",
        "phone": "97143352000",
        "email": "info@alahlialkhaja.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "34476e35-fd77-4a2d-9ad0-cf8cca5e403a",
    "firmName": "AL AHLI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04759",
    "licenseIssueDate": "10/01/2020 00:00:00",
    "licenseExpiryDate": "09/30/2026 00:00:00"
  },
  {
    "id": "151d7751-bf8c-422c-b62f-ff8d2222aa50",
    "slug": "mosaied-a-m-a-r-alajeel",
    "name": "Mosaied A M A R Alajeel",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/08/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mosaied A M A R Alajeel",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_151d7751-bf8c-422c-b62f-ff8d2222aa50",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-04226",
    "licenseIssueDate": "10/08/2018 00:00:00",
    "licenseExpiryDate": "10/06/2026 00:00:00"
  },
  {
    "id": "dc85b759-de9b-4682-886c-adf78193282a",
    "slug": "mostafa-abdelhady-aiub",
    "name": "MOSTAFA ABDELHADY MOHAMED AIUB",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Civil Transactions-Construction and Contracts for Services",
      "Commercial Transactions-Bankruptcy",
      "Civil Transactions-Arbitration",
      "Civil Transactions-Tenancy",
      "Personal Status-Legacies and Inheritance",
      "Commercial Transactions-Commercial Companies",
      "Commercial Transactions-Banking Operations",
      "Civil Transactions-Labor & Workers",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/04/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mostafa Abdelhady Aiub",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dc85b759-de9b-4682-886c-adf78193282a",
        "address": "haleema almarzooqi ,3 ,building 7A ,D3 ,9569 ,Dubai",
        "phone": "97143621113",
        "email": "haleema.almarzooqi@dhalaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4fb21617-b070-488f-8ce5-516725154e59",
    "firmName": "HALEEMA ALMARZOOQI & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03706",
    "licenseIssueDate": "04/18/2017 00:00:00",
    "licenseExpiryDate": "04/14/2026 00:00:00"
  },
  {
    "id": "9db0fe66-969a-4f63-b790-90f310f4366a",
    "slug": "mostafa-ahmed-attia-darwish",
    "name": "MOSTAFA AHMED ATTIA DARWISH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/02/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2022-01-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mostafa Ahmed Attia Darwish",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9db0fe66-969a-4f63-b790-90f310f4366a",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-04998",
    "licenseIssueDate": "08/02/2021 00:00:00",
    "licenseExpiryDate": "08/01/2022 00:00:00"
  },
  {
    "id": "f336bc3e-5f04-4c74-ba24-e3c649aedc62",
    "slug": "mostafa-ahmed-mahmoud-abdelhamid",
    "name": "MOSTAFA AHMED MAHMOUD ABDELHAMID",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/10/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mostafa Ahmed Mahmoud Abdelhamid",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f336bc3e-5f04-4c74-ba24-e3c649aedc62",
        "address": "",
        "phone": "97143300009 / 971501215000",
        "email": "mohamed@maa.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "af85c161-b73d-46a2-9fd7-4d8604007473",
    "firmName": "MOHAMED ALI ALHAMMADI ADVOCATES & LEGAL CONSULTANT",
    "registrationNumber": "L-06992"
  },
  {
    "id": "10605c24-5a11-4bc3-85e2-378f28b4c76c",
    "slug": "mostafa-ala-mostafa-abdellatif-habib",
    "name": "MOSTAFA ALAA MOSTAFA ABDELLATIF HABIB",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/10/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: mostafa ala mostafa abdellatif habib",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_10605c24-5a11-4bc3-85e2-378f28b4c76c",
        "address": "SAAD AL HAMMADI ,مدخل البرج ,ويست بيري ,برج خليفه ,41747 ,Dubai",
        "phone": "97142405222",
        "email": "info@saadpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "18923100-5b94-44e2-b580-2e3b0cc17bf6",
    "firmName": "SAAD AL HAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06528",
    "licenseIssueDate": "10/02/2024 00:00:00",
    "licenseExpiryDate": "10/01/2026 00:00:00"
  },
  {
    "id": "60e190ce-ea40-40db-836d-4b53a78c6e35",
    "slug": "mostafa-emadeldin-attia-ali",
    "name": "MOSTAFA EMADELDIN ATTIA ALI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/02/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mostafa Emadeldin Attia Ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_60e190ce-ea40-40db-836d-4b53a78c6e35",
        "address": "",
        "phone": "97144073901 / 971503479508",
        "email": "Rania.Tadros@stephensonharwood.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dd5042a2-bb41-4123-9544-79c3fa831332",
    "firmName": "Stephenson Harwood (Middle East) LLP",
    "registrationNumber": "L-05180",
    "licenseIssueDate": "02/08/2022 00:00:00",
    "licenseExpiryDate": "02/07/2026 00:00:00"
  },
  {
    "id": "4269e504-bdf8-43ea-a718-25d5d011583f",
    "slug": "mostafa-hamed-mohamed-mabrouk",
    "name": "MOSTAFA HAMED MOHAMED MABROUK",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/05/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mostafa Hamed Mohamed Mabrouk",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4269e504-bdf8-43ea-a718-25d5d011583f",
        "address": "",
        "phone": "97143184600 / 971504468184",
        "email": "melaraby@gibsondunn.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c9d2c9d0-6e43-4253-a75d-cdeb400f8d8e",
    "firmName": "Gibson Dunn & Crutcher LLP",
    "registrationNumber": "L-06779",
    "licenseIssueDate": "05/07/2025 00:00:00",
    "licenseExpiryDate": "05/06/2026 00:00:00"
  },
  {
    "id": "3a94e840-2927-4241-b92e-0ccfd2120ef4",
    "slug": "mostafa-ibrahim-abdelwahab-elish-dawoud",
    "name": "MOSTAFA IBRAHIM ABDELWAHAB ELISH DAWOUD",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/10/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mostafa Ibrahim Abdelwahab Elish Dawoud",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3a94e840-2927-4241-b92e-0ccfd2120ef4",
        "address": "",
        "phone": "97144230000 / 971552009022",
        "email": "UAE-CourtClerks@habibalmulla.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3eba82bb-8ec4-4cbd-80d0-a793cb993fde",
    "firmName": "Habib Al Mulla & Partners ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06572",
    "licenseIssueDate": "10/30/2024 00:00:00",
    "licenseExpiryDate": "10/29/2026 00:00:00"
  },
  {
    "id": "05d86f7f-c227-43ec-85bd-35a40abb505a",
    "slug": "mostafa-kamel-sayed-gouda",
    "name": "MOSTAFA KAMEL SAYED GOUDA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/02/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mostafa Kamel Sayed Gouda",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_05d86f7f-c227-43ec-85bd-35a40abb505a",
        "address": "",
        "phone": "97145539555",
        "email": "world-center@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "00c4764a-95da-417c-bdfc-8bafd4ff9fca",
    "firmName": "WORLD CENTER ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06205",
    "licenseIssueDate": "02/16/2024 00:00:00",
    "licenseExpiryDate": "02/15/2026 00:00:00"
  },
  {
    "id": "3ec30015-3220-44d4-84f0-0beb76196c72",
    "slug": "mostafa-mohamed-mohamed-mohamed-mohamed-mahmoud-aboubakr",
    "name": "MOSTAFA MOHAMED MOHAMED MOHAMED MOHAMED MAHMOUD ABOUBAKR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/05/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: mostafa mohamed mohamed mohamed mohamed mahmoud aboubakr",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3ec30015-3220-44d4-84f0-0beb76196c72",
        "address": "",
        "phone": "97143474007",
        "email": "info@alsabhanlegalgroup.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c31ad0e5-b382-4c9a-9fab-8853b1330f6b",
    "firmName": "DR AL SABBHAN LEGAL GROUP",
    "registrationNumber": "L-06841",
    "licenseIssueDate": "05/23/2025 00:00:00",
    "licenseExpiryDate": "05/22/2026 00:00:00"
  },
  {
    "id": "7c9ebfa3-54a4-4687-b2c9-b14f88ec4120",
    "slug": "mostafa-salah-hefny-hadhoud",
    "name": "MOSTAFA SALAH HEFNY HADHOUD",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/08/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: mostafa salah hefny hadhoud",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7c9ebfa3-54a4-4687-b2c9-b14f88ec4120",
        "address": "",
        "phone": "97143266669 / 971505479696",
        "email": "almasayba@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a1c5fd44-9a8b-4235-8ba0-8499d6832520",
    "firmName": "BASHAR ALMASAYBA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05482",
    "licenseIssueDate": "08/31/2022 00:00:00",
    "licenseExpiryDate": "08/30/2026 00:00:00"
  },
  {
    "id": "4bbed584-98f0-46a3-b1db-74f463cbc732",
    "slug": "mostafa-yassin-mohamed-hegab",
    "name": "MOSTAFA YASSIN MOHAMED HEGAB",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/01/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mostafa Yassin Mohamed Hegab",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4bbed584-98f0-46a3-b1db-74f463cbc732",
        "address": "mansoor lootah ,مطعم شيلز ,صالح بن لاحج , مطعم شيلز  ,95151 ,Dubai",
        "phone": "97142833337 / 971559596445",
        "email": "info@mansoorlootahadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4488ad94-e6b8-4b33-8e21-04e8986bf218",
    "firmName": "MANSOOR LOTAAH ADVOCATES &LEGAL CONSULTANCY",
    "registrationNumber": "L-06158",
    "licenseIssueDate": "01/24/2024 00:00:00",
    "licenseExpiryDate": "01/23/2026 00:00:00"
  },
  {
    "id": "f1faba70-2c08-45d1-8010-4482cf767a42",
    "slug": "mounir-ahmad-safi",
    "name": "MOUNIR AHMAD SAFI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/08/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mounir Ahmad Safi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f1faba70-2c08-45d1-8010-4482cf767a42",
        "address": "",
        "phone": "97148812191 / 971526343439",
        "email": "info@aqadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "bd7685ea-a57c-4a81-8b1b-d6c690263d86",
    "firmName": "ASHWAQ QAID ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06923",
    "licenseIssueDate": "08/05/2025 00:00:00",
    "licenseExpiryDate": "08/04/2026 00:00:00"
  },
  {
    "id": "3696aa7a-1f82-48ae-a8ff-2317b6cb4e16",
    "slug": "mourad-mousa-mahmood-atout",
    "name": "MOURAD MOUSA MAHMOOD ATOUT",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/09/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mourad Mousa Mahmood Atout",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3696aa7a-1f82-48ae-a8ff-2317b6cb4e16",
        "address": "Dr. Ali Ismail Aljarman ,Roof Floor - Offices R03 & R04 ,MSM 1 Building ,Al Saffa First ,62639 ,Dubai",
        "phone": "97144393733",
        "email": "info@prestigeadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "22043b7f-55d2-4eb4-a173-3077ba390351",
    "firmName": "PRESTIGE ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01992",
    "licenseIssueDate": "09/02/2024 00:00:00",
    "licenseExpiryDate": "09/01/2026 00:00:00"
  },
  {
    "id": "de2b1e56-374f-41e3-9a37-6821c24155a4",
    "slug": "moussa-khoury",
    "name": "MOUSSA A KHOURY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/01/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Moussa Khoury",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_de2b1e56-374f-41e3-9a37-6821c24155a4",
        "address": "",
        "phone": "97142986558",
        "email": "mak@maklegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "06d1b0e4-10d9-46d5-9f6b-44710029bb65",
    "firmName": "HIBA MAANI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01360",
    "licenseIssueDate": "01/19/2016 00:00:00",
    "licenseExpiryDate": "01/14/2026 00:00:00"
  },
  {
    "id": "9cbb0d11-2306-43cb-a0c6-ae21da7e1924",
    "slug": "moustafa-abdelhamid",
    "name": "MOUSTAFA FAHMY ABDELSHAFY ABDELHAMID",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/06/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Moustafa Abdelhamid",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9cbb0d11-2306-43cb-a0c6-ae21da7e1924",
        "address": "مكتب رقم 403 – 504 - 102 ,القرن الواحد وعشرون ,مركز القبائل للتخفيضات ,68441 ,Dubai",
        "phone": "97142388763",
        "email": "shaikha.advo@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "80a47f20-166e-40d9-9dea-d793f4708270",
    "firmName": "SHAIKHA AHMAD ADVOCATES&LEGAL CONSULTANTS",
    "registrationNumber": "L-00453",
    "licenseIssueDate": "06/22/2022 00:00:00",
    "licenseExpiryDate": "06/21/2026 00:00:00"
  },
  {
    "id": "8b6f3b20-8389-4ba3-83f1-125adc33bd73",
    "slug": "moustafa-ahmed-moustafa-awadalla",
    "name": "MOUSTAFA AHMED MOUSTAFA AWADALLA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/05/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Moustafa Ahmed Moustafa Awadalla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8b6f3b20-8389-4ba3-83f1-125adc33bd73",
        "address": "Sara Shah Baik Elbloshi ,الطابق 13 - مكتب 1306 ,CLOVER BAY ,بجوار SONDER HOTEL ,112773 ,Dubai",
        "phone": "97143514666",
        "email": "admin@saraadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9271d191-2f3e-4570-93bf-34fb919bf6e0",
    "firmName": "SARA ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-03754",
    "licenseIssueDate": "05/15/2017 00:00:00",
    "licenseExpiryDate": "05/12/2026 00:00:00"
  },
  {
    "id": "b6209c9e-7841-4cb4-a580-c6c8315f07fa",
    "slug": "moustafa-mohamed-gamaleldin-mohamed-regal",
    "name": "MOUSTAFA MOHAMED GAMALELDIN MOHAMED REGAL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/07/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Moustafa Mohamed Gamaleldin Mohamed Regal",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b6209c9e-7841-4cb4-a580-c6c8315f07fa",
        "address": "O-4801, O-4901 ,Burj al Salam Office Tower ,H Hotel ,111801 ,Dubai",
        "phone": "97143544444",
        "email": "administration@horizlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4e25fb39-6659-44f0-bc8b-3ff0f067beb0",
    "firmName": "HORIZONS & CO - LAW FIRM",
    "registrationNumber": "L-03206",
    "licenseIssueDate": "07/12/2021 00:00:00",
    "licenseExpiryDate": "07/11/2026 00:00:00"
  },
  {
    "id": "42337fbc-6cb5-44ad-adfc-0f6ee9ddd45b",
    "slug": "moustafa-mohamed-mansour",
    "name": "MOUSTAFA MOHAMED HASSAN MANSOUR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/11/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Moustafa Mohamed Mansour",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_42337fbc-6cb5-44ad-adfc-0f6ee9ddd45b",
        "address": "1404 ,توين  تاورز  ,بجانب فندق ريدسون بلو  ,40227 ,Dubai",
        "phone": "97142222407",
        "email": "info@daralbalaghadvocate.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "183a898c-3779-4747-92dd-33a8feb6a42c",
    "firmName": "DAR AL BALAGH ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-02983",
    "licenseIssueDate": "11/02/2014 00:00:00",
    "licenseExpiryDate": "10/27/2025 00:00:00"
  },
  {
    "id": "fcc74094-7297-43c7-9899-025fc35763cf",
    "slug": "moustafa-osman-kamal-osman",
    "name": "moustafa osman kamal osman",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/07/2024",
    "licenseStatus": "active",
    "licenseExpiry": "2025-07-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: moustafa osman kamal osman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fcc74094-7297-43c7-9899-025fc35763cf",
        "address": "",
        "phone": "97145571020",
        "email": "abdullaalmansoori80@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "1f7b1225-9eb2-412b-9776-298c43ff6240",
    "firmName": "ABDULLA EBRAHIM ALMULLA ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-06406",
    "licenseIssueDate": "07/03/2024 00:00:00",
    "licenseExpiryDate": "07/02/2025 00:00:00"
  },
  {
    "id": "a903cccf-aa34-443b-8e2d-a61cc4989df3",
    "slug": "moustafa-salah-elsayed-ramadan-abdo",
    "name": "MOUSTAFA SALAH ELSAYED RAMADAN ABDO",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/09/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Moustafa Salah Elsayed Ramadan Abdo",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a903cccf-aa34-443b-8e2d-a61cc4989df3",
        "address": "",
        "phone": "97143553062 / 971506316315",
        "email": "moc@lawyermuna.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ebaad15b-7645-4eda-aeab-efd4a2f10a2f",
    "firmName": "MUNA ALMAZROUEI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06005",
    "licenseIssueDate": "09/08/2023 00:00:00",
    "licenseExpiryDate": "09/07/2026 00:00:00"
  },
  {
    "id": "915bf855-0a73-40a6-afaf-4d489d52447a",
    "slug": "mubarak-abdelazim-eltayeb-ahmed",
    "name": "MUBARAK ABDELAZIM ELTAYEB AHMED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/01/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mubarak Abdelazim Eltayeb Ahmed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_915bf855-0a73-40a6-afaf-4d489d52447a",
        "address": "Bader Aljassmy ,3 ,دبي كوميرسيتي ,دبي كوميرسيتي ,410004 ,Dubai",
        "phone": "97148760777 / 971586842086",
        "email": "info@bajlegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7e820dd9-2748-4876-88db-ff7948542895",
    "firmName": "AL BASTAKI & Al JASMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05157",
    "licenseIssueDate": "01/11/2022 00:00:00",
    "licenseExpiryDate": "01/10/2026 00:00:00"
  },
  {
    "id": "6824b4b6-f41b-45e5-b18d-1165b9584321",
    "slug": "mudar-shakra",
    "name": "MUDAR SHAKRA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/05/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mudar Shakra",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6824b4b6-f41b-45e5-b18d-1165b9584321",
        "address": "KHALED AHMED ABDULLA AHMED ,24 ,Clover Bay ,SAAS Tower  ,288 ,Dubai",
        "phone": "97143453233",
        "email": "info@theadvocates.io",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b0e9ddc9-f4a3-4647-97ae-dc4ca90bcb6c",
    "firmName": "THE ADVOCATES",
    "registrationNumber": "L-06807",
    "licenseIssueDate": "05/09/2025 00:00:00",
    "licenseExpiryDate": "05/08/2026 00:00:00"
  },
  {
    "id": "a1536b75-6b0b-43af-928e-b22dbca89c24",
    "slug": "muhamad-yamen-ghazi-elidilbi",
    "name": "MUHAMAD YAMEN GHAZI ELIDILBI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Commercial Agency",
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Civil Transactions-POA & Sponsorship",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Civil Transactions-Insurance",
      "Personal Status-Wills",
      "Civil Transactions-Ownership & Title",
      "Civil Transactions-HR & Employee Affairs",
      "Criminal Law-Family Crimes",
      "Personal Status-Custody & Alimony",
      "Commercial Transactions-Commercial Contracts",
      "Civil Transactions-Immigration and Residency",
      "Commercial Transactions-Bankruptcy",
      "Commercial Transactions-Commercial Real Estate",
      "Civil Transactions-Residential Real Estate",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Civil Transactions-Arbitration",
      "Criminal Law-Hate crimes",
      "Civil Transactions-Tenancy",
      "Commercial Transactions-Unfair competition",
      "Criminal Law-Crimes against persons",
      "Personal Status-Legacies and Inheritance",
      "Commercial Transactions-Commercial Companies",
      "Civil Transactions-Labor & Workers",
      "Personal Status-Legal Capacity & Guardianship",
      "Criminal Law-Drug Crimes",
      "Civil Transactions-Sale",
      "Personal Status-Marriage & Divorce",
      "Personal Status-Child Abuse & Abduction",
      "Civil Transactions-Compensation",
      "Criminal Law-Crimes against properties",
      "Commercial Transactions-E-Commerce",
      "Criminal Law-Cybercrimes",
      "Commercial Transactions-Intellectual Property (includes trademarks",
      "copy rights",
      "patents)",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/02/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Muhamad Yamen Ghazi ELidilbi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a1536b75-6b0b-43af-928e-b22dbca89c24",
        "address": "Block B, Office 711 ,Business Village Building ,Next to Clock Circle, Makani No: 9443231484 ,000 ,Dubai",
        "phone": "97144503646 / 971504282855",
        "email": "info@uaelawyers.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "45c3eabb-348d-429a-98c8-35613c7f89fe",
    "firmName": "SALEM AL KHATERI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06224",
    "licenseIssueDate": "02/16/2024 00:00:00",
    "licenseExpiryDate": "02/15/2026 00:00:00"
  },
  {
    "id": "c7a3dcb5-0508-4b56-9887-53e169160dab",
    "slug": "muhammad-ali-qureshi",
    "name": "MUHAMMAD ALI QURESHI KHALID FAROOQ QURESHI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/04/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Muhammad Ali Qureshi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c7a3dcb5-0508-4b56-9887-53e169160dab",
        "address": "",
        "phone": "97148321212",
        "email": "nasser@nmlawyers.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "71709458-e40a-45b3-9319-4c51c18891be",
    "firmName": "NASSER MALALLA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03028",
    "licenseIssueDate": "04/03/2023 00:00:00",
    "licenseExpiryDate": "04/02/2026 00:00:00"
  },
  {
    "id": "85475465-d418-47a8-a71a-a8ece12b8523",
    "slug": "muhammad-bilal-afzal-syed-afzal-jamil-syed",
    "name": "MUHAMMAD BILAL AFZAL SYED AFZAL JAMIL SYED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/01/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Muhammad Bilal Afzal Syed Afzal Jamil Syed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_85475465-d418-47a8-a71a-a8ece12b8523",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-06652",
    "licenseIssueDate": "01/17/2025 00:00:00",
    "licenseExpiryDate": "01/16/2026 00:00:00"
  },
  {
    "id": "b15db03c-3cbc-4afe-b579-d598efe13bd3",
    "slug": "muhammad-bilal-ramzan-mohammad-ramzan",
    "name": "MUHAMMAD BILAL RAMZAN MOHAMMAD RAMZAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/12/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Muhammad Bilal Ramzan Mohammad Ramzan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b15db03c-3cbc-4afe-b579-d598efe13bd3",
        "address": "21 ,Rolex Tower ,Emirates Grand Hotel ,94334 ,Dubai",
        "phone": "97143277772 / 97145584900",
        "email": "info@globaladvocates.net",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9b42810f-1d55-4aea-ac4a-7d9d1b25ac08",
    "firmName": "GLOBAL ADVOCACY & LEGAL COUNSEL",
    "registrationNumber": "L-06144",
    "licenseIssueDate": "12/12/2023 00:00:00",
    "licenseExpiryDate": "12/11/2025 00:00:00"
  },
  {
    "id": "852f6965-7417-474f-afaf-22cc6a5d68d6",
    "slug": "muhammad-kaipravan",
    "name": "MUHAMMAD ALI KAIPRAVAN MOIDU KAIPRAVAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Muhammad Kaipravan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_852f6965-7417-474f-afaf-22cc6a5d68d6",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01286",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "878d503a-7887-4de8-b306-2fb2cf274db7",
    "slug": "muhammad-mohsin-naseer",
    "name": "MUHAMMAD MOHSIN NASEER NASEER AHMAD",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Civil Transactions-Arbitration"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Muhammad Mohsin Naseer",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_878d503a-7887-4de8-b306-2fb2cf274db7",
        "address": "O-4801, O-4901 ,Burj al Salam Office Tower ,H Hotel ,111801 ,Dubai",
        "phone": "97143544444",
        "email": "administration@horizlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4e25fb39-6659-44f0-bc8b-3ff0f067beb0",
    "firmName": "HORIZONS & CO - LAW FIRM",
    "registrationNumber": "L-02543",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "464d94b5-bdbd-48d5-b7e9-da2e4bd1bf70",
    "slug": "muhammad-mustafa-khalid-khalid-imran",
    "name": "MUHAMMAD MUSTAFA KHALID KHALID IMRAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/02/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Muhammad Mustafa Khalid Khalid Imran",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_464d94b5-bdbd-48d5-b7e9-da2e4bd1bf70",
        "address": "",
        "phone": "97143641686 / 971506288801",
        "email": "b.kadir@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0ba96df8-e4cc-49c2-8ae4-a42878d95926",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS LLC",
    "registrationNumber": "L-04630",
    "licenseIssueDate": "02/27/2020 00:00:00",
    "licenseExpiryDate": "02/26/2026 00:00:00"
  },
  {
    "id": "c1bc59ab-256a-420f-906d-d3c66785f13e",
    "slug": "muhammad-nahhas-abdalhamid-ali-radi",
    "name": "MUHAMMAD NAHHAS ABDALHAMID ALI RADI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/08/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Muhammad Nahhas Abdalhamid Ali Radi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c1bc59ab-256a-420f-906d-d3c66785f13e",
        "address": "othman almarzooqi ,19th ,single business tower ,samaya tower ,114333 ,Dubai",
        "phone": "97142999970 / 971500000000",
        "email": "info@othmanadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a0cdd94d-cc5a-4617-b6a3-b23deb9852d5",
    "firmName": "OTHMAN ALMARZOOQI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03429",
    "licenseIssueDate": "08/15/2016 00:00:00",
    "licenseExpiryDate": "08/11/2026 00:00:00"
  },
  {
    "id": "d5ce01e1-96be-43f6-baa8-c2838b3f9eb1",
    "slug": "muhammad-raees-qureshi",
    "name": "MUHAMMAD RAEES QURESHI ALLAH BAKSH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/11/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Muhammad Raees Qureshi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d5ce01e1-96be-43f6-baa8-c2838b3f9eb1",
        "address": "Alhajeya salem saeed alnoobi ,3rd  ,Al-hawai Tower  ,Behind financial center metro station  ,39779 ,Dubai",
        "phone": "97142963813",
        "email": "adv_aljazeera@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "f091b928-9e3d-4e24-b489-65ca31481366",
    "firmName": "AL HAJEYA ALNOOBI ADVOCATES AND LEGAL CONSULTANT",
    "registrationNumber": "L-01995",
    "licenseIssueDate": "11/16/2011 00:00:00",
    "licenseExpiryDate": "11/07/2025 00:00:00"
  },
  {
    "id": "b16dc5ee-e444-493e-ba12-b2e1a29eff40",
    "slug": "muhammad-yousef-muhammad-ahmed-elbialy",
    "name": "MUHAMMAD YOUSEF MUHAMMAD AHMED ELBIALY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Civil Transactions-HR & Employee Affairs",
      "Personal Status-Custody & Alimony",
      "Civil Transactions-Residential Real Estate",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Criminal Law-Crimes against persons",
      "Commercial Transactions-Commercial Companies",
      "Civil Transactions-Labor & Workers",
      "Criminal Law-Drug Crimes",
      "Personal Status-Marriage & Divorce",
      "Criminal Law-Crimes against properties",
      "Criminal Law-Cybercrimes",
      "Commercial Transactions-Intellectual Property (includes trademarks",
      "copy rights",
      "patents)",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/10/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Muhammad Yousef Muhammad Ahmed Elbialy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b16dc5ee-e444-493e-ba12-b2e1a29eff40",
        "address": "Saeed Sulayem Rashed Almazrouei ,M05 ,Al Durrah 4 ,Behind GGICO metro station ,11311 ,Dubai",
        "phone": "97143889000",
        "email": "info@sulayemlegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b221d5d0-c8b1-4064-a7a5-84cf410fd408",
    "firmName": "SAEED SULAYEM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06553",
    "licenseIssueDate": "10/16/2024 00:00:00",
    "licenseExpiryDate": "10/15/2026 00:00:00"
  },
  {
    "id": "792ad996-6a19-4801-97b9-3a6ba92ccdd4",
    "slug": "muhammed-hussain-ali",
    "name": "MUHAMMED HUSSAIN ALI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/04/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Muhammed Hussain Ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_792ad996-6a19-4801-97b9-3a6ba92ccdd4",
        "address": "ICD Brookfield Place ,DIFC ,506516 ,",
        "phone": "97143695800 / 971505526206",
        "email": "scott.campbell@linklaters.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5cec94c0-0649-43b6-a2be-ab17ff422bce",
    "firmName": "LinkLaters LLP",
    "registrationNumber": "L-06262",
    "licenseIssueDate": "04/17/2024 00:00:00",
    "licenseExpiryDate": "04/16/2026 00:00:00"
  },
  {
    "id": "a6a27eb9-001f-446f-b11c-ec11f17898b1",
    "slug": "muhanadalslam-ahme-mohanaed-ahmed-abdulla",
    "name": "MUHANADALSLAM AHMED MOHAMED AHMED ABDALLA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/02/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Muhanadalslam Ahme Mohanaed Ahmed Abdulla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a6a27eb9-001f-446f-b11c-ec11f17898b1",
        "address": "الطابق الثامن ,بزنس أفنيو ,خلف وكالة نيسان ,444775 ,Dubai",
        "phone": "97142501414",
        "email": "info@halalilaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "37ab9a73-e65f-4829-9402-6eac64c4c621",
    "firmName": "HASSAN AL ALI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-04842",
    "licenseIssueDate": "02/11/2021 00:00:00",
    "licenseExpiryDate": "02/10/2026 00:00:00"
  },
  {
    "id": "1506ac86-e941-4442-bb6d-2269c1ad21b1",
    "slug": "muhi-aldeen-anis-mushaweh",
    "name": "MUHI ALDEEN ANIS MUSHAWEH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/09/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Muhi Aldeen Anis Mushaweh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1506ac86-e941-4442-bb6d-2269c1ad21b1",
        "address": "بلوك بي  ,R338 ,بجانب بناية سيتي بنك - بجوار مركز وافي  ,0554060326 ,Dubai",
        "phone": "97143337444",
        "email": "info@alsuwaidi-advo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "525230a9-87e0-4951-b745-c8d2a983cf8e",
    "firmName": "ABDULLA AL SUWAIDI ADVOCATES & LEGAL CONSULTANT",
    "registrationNumber": "L-02599",
    "licenseIssueDate": "09/26/2011 00:00:00",
    "licenseExpiryDate": "09/17/2026 00:00:00"
  },
  {
    "id": "f0668a59-388d-4260-8d8f-dbd187e1f477",
    "slug": "muna-yahya-ahmed",
    "name": "MUNA YAHYA MOHAMED AHMED ELSEEMAT",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Muna Yahya Ahmed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f0668a59-388d-4260-8d8f-dbd187e1f477",
        "address": "Alawi Ghaleb Ali Saeed Aljaberi ,M ,Bussiness venue building  ,al nase club ,10103 ,Dubai",
        "phone": "97143436652",
        "email": "ajadvo017@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "80667ff5-8d9d-4ce3-860f-34cd7e4937bc",
    "firmName": "ALAWI ALJABERI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01731",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "f7b6f394-70ed-4492-8901-8eb0ea3ec96b",
    "slug": "muneer-khan",
    "name": "MUNEER FAISAL KHAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/10/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Muneer Khan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f7b6f394-70ed-4492-8901-8eb0ea3ec96b",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506688 ,Dubai",
        "phone": "97147096600 / 971503556811",
        "email": "muneer.khan@simmons-simmons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "d1725ca7-06ac-41b2-8d7b-a6e60665b73d",
    "firmName": "Simmons & Simmons (Middle East) LLP-DIFC",
    "registrationNumber": "L-00538",
    "licenseIssueDate": "10/07/2011 00:00:00",
    "licenseExpiryDate": "09/28/2026 00:00:00"
  },
  {
    "id": "9251ad92-201e-4c6b-85cc-aabfac1d2f6a",
    "slug": "munir-abdallah-suboh",
    "name": "MUNIR ABDALLAH IBRAHIM SUBOH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Munir Abdallah Suboh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9251ad92-201e-4c6b-85cc-aabfac1d2f6a",
        "address": "",
        "phone": "97104309100 / 971564013758",
        "email": "c.royle@taylorwessing.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d51b6f43-8c62-486f-a1ab-6ee3b87c8006",
    "firmName": "Taylor Wessing LLP (Dubai Branch)",
    "registrationNumber": "L-01292",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "51f32ad7-b9ac-4b2f-a926-53e9b6a7bc41",
    "slug": "murad-aref-majarri-otaibi",
    "name": "MURAD AREF MAJARRI OTAIBI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Murad Aref Majarri Otaibi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_51f32ad7-b9ac-4b2f-a926-53e9b6a7bc41",
        "address": "11 ,ميلينيوم بلازا  ,بجوار محطة ابراج الأمارات  ,410961 ,Dubai",
        "phone": "97142954626",
        "email": "info@advoamira.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "09f7b67c-8405-4dc9-982f-b8f9b921043c",
    "firmName": "DR AMIRA AL BASTAKI ADVOCATES AND LEGAL CONSULTANT",
    "registrationNumber": "L-01838",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "fbaa7fa7-d818-41ae-bb95-7121bb90e9f0",
    "slug": "murad-mohd-kheir-ayoub-abida",
    "name": "MURAD MOHD KHEIR AYOUB ABIDA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/11/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Murad Mohd Kheir Ayoub Abida",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fbaa7fa7-d818-41ae-bb95-7121bb90e9f0",
        "address": "21 ,Rolex Tower ,Emirates Grand Hotel ,94334 ,Dubai",
        "phone": "97143277772 / 97145584900",
        "email": "info@globaladvocates.net",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9b42810f-1d55-4aea-ac4a-7d9d1b25ac08",
    "firmName": "GLOBAL ADVOCACY & LEGAL COUNSEL",
    "registrationNumber": "L-05083",
    "licenseIssueDate": "11/08/2021 00:00:00",
    "licenseExpiryDate": "11/07/2025 00:00:00"
  },
  {
    "id": "08007c1c-a416-47ab-ac25-5ff38c4a6433",
    "slug": "murray-david-laing",
    "name": "Murray David Laing",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/14/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Murray David Laing",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_08007c1c-a416-47ab-ac25-5ff38c4a6433",
        "address": "",
        "phone": "97143637999 / 971506525633",
        "email": "daniel.wood@walkersglobal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a3a9927b-d51c-490c-8be6-d575ea3eb041",
    "firmName": "Walkers (Middle East) LLP",
    "registrationNumber": "L-06448",
    "licenseIssueDate": "08/14/2024 00:00:00",
    "licenseExpiryDate": "08/13/2026 00:00:00"
  },
  {
    "id": "9423b4ea-cc22-487e-b08b-104cca8198c7",
    "slug": "murshideldin-mohamed-yousif-elshikh",
    "name": "MURSHID ELDIN MOHAMED YOUSIF ELSHIKH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Personal Status-Custody & Alimony",
      "Criminal Law-Crimes against persons",
      "Personal Status-Legacies and Inheritance",
      "Civil Transactions-Sale",
      "Personal Status-Marriage & Divorce",
      "Personal Status-Child Abuse & Abduction",
      "Criminal Law-Crimes against properties",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/08/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Murshideldin Mohamed Yousif Elshikh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9423b4ea-cc22-487e-b08b-104cca8198c7",
        "address": "",
        "phone": "97142678800 / 971050646353",
        "email": "info@hussainaljahazilawyer.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9ac6b6e4-eb41-48d4-9dfa-407f711a64ad",
    "firmName": "HUSSAIN ALJAHAZI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-01975",
    "licenseIssueDate": "08/03/2022 00:00:00",
    "licenseExpiryDate": "08/02/2026 00:00:00"
  },
  {
    "id": "fb91c9eb-da16-453f-912e-772971b21717",
    "slug": "murtuza-hussain",
    "name": "MURTUZA HUSSAIN NASIR HUSSAIN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/09/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: murtuza hussain",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fb91c9eb-da16-453f-912e-772971b21717",
        "address": "",
        "phone": "97144073901 / 971503479508",
        "email": "Rania.Tadros@stephensonharwood.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dd5042a2-bb41-4123-9544-79c3fa831332",
    "firmName": "Stephenson Harwood (Middle East) LLP",
    "registrationNumber": "L-04205",
    "licenseIssueDate": "09/02/2018 00:00:00",
    "licenseExpiryDate": "08/31/2026 00:00:00"
  },
  {
    "id": "ab12b1d0-88b0-4ea7-a926-ed0e589d31b4",
    "slug": "musab-ibrahim-ahmed-mohamed-ali",
    "name": "MUSAB IBRAHIM AHMED MOHAMED ALI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Commercial Transactions-Commercial Real Estate",
      "Civil Transactions-Tenancy",
      "Proceedings-Cases and Proceedings before arbitral tribunals and other alternative dispute resolution bodies",
      "Personal Status-Marriage & Divorce",
      "Criminal Law-Crimes against properties"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/12/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Musab Ibrahim Ahmed Mohamed Ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ab12b1d0-88b0-4ea7-a926-ed0e589d31b4",
        "address": "",
        "phone": "97145786050 / 971509711102",
        "email": "info@emirates.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "676fafb7-1ca5-46d2-943e-39c211542422",
    "firmName": "RAYA AL AMERI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06123",
    "licenseIssueDate": "12/13/2023 00:00:00",
    "licenseExpiryDate": "12/12/2025 00:00:00"
  },
  {
    "id": "417cf78a-6be1-4a01-b42d-4f37b9c109d6",
    "slug": "muslim-tawfeeq-hasan",
    "name": "MUSLIM TAWFEEQ HASAN HASAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Muslim Tawfeeq Hasan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_417cf78a-6be1-4a01-b42d-4f37b9c109d6",
        "address": "zayed saeed saif alshamsi ,الرابع مكتب رقم 414 ,قرية الاعمال ,بجانب دائرة التنمية الاقتصادية - دوار الساعة  ,6030 ,Dubai",
        "phone": "97142680800",
        "email": "info@zayedalshamsi.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "295c7198-77b4-4f9a-a4d2-bad9a78e074d",
    "firmName": "ZAYED AL SHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01557",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "3bc6f173-65ef-4f6b-92e9-94e496921545",
    "slug": "mustafa-aljundi",
    "name": "Mustafa Aljundi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/11/2018",
    "licenseStatus": "active",
    "licenseExpiry": "2019-11-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mustafa Aljundi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3bc6f173-65ef-4f6b-92e9-94e496921545",
        "address": "ICD Brookfield Place ,Za'abeel 2 ,103747 ,",
        "phone": "97143696300 / 971506008159",
        "email": "mohammed.paracha@nortonrosefulbright.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c4aaee93-0ec4-4982-9a48-a23699492056",
    "firmName": "Norton Rose Fullbright (Middle East) LLP",
    "registrationNumber": "L-04267",
    "licenseIssueDate": "11/13/2018 00:00:00",
    "licenseExpiryDate": "11/11/2025 00:00:00"
  },
  {
    "id": "110e67bf-3047-4e85-8532-ff484d7cdd74",
    "slug": "mustafa-anwar-darwich",
    "name": "MUSTAFA ANWAR DARWICH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/01/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mustafa Anwar Darwich",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_110e67bf-3047-4e85-8532-ff484d7cdd74",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506698 ,Dubai",
        "phone": "97147046300 / 971507900661",
        "email": "nada.mourad@lw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b2b92ce9-90a4-4e34-ae2f-ae0dc7ca9060",
    "firmName": "Latham & Watkins LLP",
    "registrationNumber": "L-04596",
    "licenseIssueDate": "01/15/2020 00:00:00",
    "licenseExpiryDate": "01/14/2026 00:00:00"
  },
  {
    "id": "1582c214-6ce4-48b8-b380-044e6ba27fd4",
    "slug": "mustafa-mohamed-elsayed-elbashir",
    "name": "MUSTAFA MOHAMED ELSAYED ELBASHIR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/06/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mustafa Mohamed Elsayed Elbashir",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1582c214-6ce4-48b8-b380-044e6ba27fd4",
        "address": "",
        "phone": "97143997700 / 971503707978",
        "email": "info@alazazi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "92d43169-f680-4fdb-a7c0-1397ce308994",
    "firmName": "MOHAMED ALAZAZI LAWYERS & LEGAL CONSULTANCY",
    "registrationNumber": "L-06858",
    "licenseIssueDate": "06/18/2025 00:00:00",
    "licenseExpiryDate": "06/17/2026 00:00:00"
  },
  {
    "id": "d5dc9de3-71e8-427b-be12-3e9e7dff4bb5",
    "slug": "mustapha-nasser-fawzy-abdelgayed",
    "name": "MUSTAPHA NASSER FAWZY ABDELGAYED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/02/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mustapha Nasser Fawzy Abdelgayed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d5dc9de3-71e8-427b-be12-3e9e7dff4bb5",
        "address": "الطابق الثامن  ,برج الجرج 1 ,دائرة الاراضي و الاملاك  ,9117 ,Dubai",
        "phone": "97143320004",
        "email": "info@hlootahlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4ad67cb4-18b4-4417-9b6a-d23a9fb368fb",
    "firmName": "HUSSAIN LOOTAH & PARTNERS - ATTORNEYS & COUNSELLORS AT LAW",
    "registrationNumber": "L-06191",
    "licenseIssueDate": "02/16/2024 00:00:00",
    "licenseExpiryDate": "02/15/2026 00:00:00"
  },
  {
    "id": "51cb2e3f-5a3f-456e-9617-7077b246907c",
    "slug": "mutaz-kamal-alsayed-saadallah",
    "name": "MUTAZ KAMAL ALSAYED SAADALLAH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/10/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mutaz Kamal Alsayed Saadallah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_51cb2e3f-5a3f-456e-9617-7077b246907c",
        "address": "",
        "phone": "97145477552 / 971507474706",
        "email": "saifalshamsi.law@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a1313be0-55e4-49d0-987d-98d1dd84db7e",
    "firmName": "SAIF ALSHAMSI ADVOCATES AND LEGAL CONSULTANCY",
    "registrationNumber": "L-05556",
    "licenseIssueDate": "10/12/2022 00:00:00",
    "licenseExpiryDate": "10/11/2025 00:00:00"
  },
  {
    "id": "2345163b-fe81-4a86-bd45-a24a20468714",
    "slug": "myles-richard-sim-jun-fu",
    "name": "MYLES RICHARD SIM JUN FU",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/02/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Myles Richard Sim Jun Fu",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2345163b-fe81-4a86-bd45-a24a20468714",
        "address": "",
        "phone": "97143742800 / 971506450677",
        "email": "jabbott21@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7a59d310-ff72-4318-b41c-27095c163d0f",
    "firmName": "CMS (UAE) LLP",
    "registrationNumber": "L-05118",
    "licenseIssueDate": "02/12/2025 00:00:00",
    "licenseExpiryDate": "02/11/2026 00:00:00"
  },
  {
    "id": "3209dd96-3e54-401c-82aa-64a6bf066696",
    "slug": "myriam-fellag",
    "name": "MYRIAM FELLAG",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/08/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Myriam Fellag",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3209dd96-3e54-401c-82aa-64a6bf066696",
        "address": "Fadi H. Hourani ,3 ,The Offices 5, One Central ,The Museum of the Future ,10152 ,Dubai",
        "phone": "97142052000",
        "email": "info@houranipartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c7a17e12-3d49-4166-82c8-271a6d223675",
    "firmName": "Hourani & Partners Legal Consultancy FZCO",
    "registrationNumber": "L-06909",
    "licenseIssueDate": "08/18/2025 00:00:00",
    "licenseExpiryDate": "08/17/2026 00:00:00"
  },
  {
    "id": "15dce15e-5203-42d3-8b59-af7503818b1e",
    "slug": "myriam-simon",
    "name": "MYRIAM MAGDA SIMON",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/01/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Myriam Simon",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_15dce15e-5203-42d3-8b59-af7503818b1e",
        "address": "Gamal Yassein Abdalla ,الطابق 13  Floor No 13 ,بناية مركز ابروي (The Oberoi Center) ,فندق ابروي (The Oberoi Hotel) ,33299 ,Dubai",
        "phone": "97142828000",
        "email": "litigation@alaidarous.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9a923766-1fd1-4e06-a871-89662120384e",
    "firmName": "AL AIDAROUS ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-02334",
    "licenseIssueDate": "01/29/2014 00:00:00",
    "licenseExpiryDate": "01/22/2026 00:00:00"
  },
  {
    "id": "aaa7039c-70c0-4b30-a13c-7adf2475740a",
    "slug": "na-shang",
    "name": "NA SHANG",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/06/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Na Shang",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_aaa7039c-70c0-4b30-a13c-7adf2475740a",
        "address": "Hamdan Abdullah Abdulrahman Ali Alharmi ,2 office 211 ,MSM 1 ,Auto Land Motors ,6064 ,Dubai",
        "phone": "97142999559",
        "email": "hamdan@harmilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b0830edc-21a4-4df9-9d83-febcab7756da",
    "firmName": "HAMDAN AL HARMI & ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06844",
    "licenseIssueDate": "06/11/2025 00:00:00",
    "licenseExpiryDate": "06/10/2026 00:00:00"
  },
  {
    "id": "c85ce999-b070-4543-b946-19195aafdb15",
    "slug": "nabeel-ikram",
    "name": "NABEEL IKRAM",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nabeel Ikram",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c85ce999-b070-4543-b946-19195aafdb15",
        "address": "Gate Village 10 ,Dubai International Financial Centre ,504945 ,",
        "phone": "97143301800 / 971569904245",
        "email": "nikram@velaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "61216046-6cd5-410d-a301-532f3e520e30",
    "firmName": "Vinson & Elkins LLP",
    "registrationNumber": "L-01062",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "5074c96d-5d0e-4628-9667-c7010232ad22",
    "slug": "nabeel-omer",
    "name": "NABEEL ELHAJ HUSSEIN OMER",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/10/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nabeel Omer",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5074c96d-5d0e-4628-9667-c7010232ad22",
        "address": "",
        "phone": "97143380333",
        "email": "info@fahadbintamim.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6924283e-95b7-4af2-85a3-cc6cbcc10a20",
    "firmName": "FAHAD BIN TAMIM ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-03499",
    "licenseIssueDate": "10/11/2016 00:00:00",
    "licenseExpiryDate": "10/07/2025 00:00:00"
  },
  {
    "id": "5cc79fc9-ffd1-46ed-ad54-a8c368ca6070",
    "slug": "nabeela-afifi",
    "name": "NABEELA HASAN MAJED ALAFIFI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/02/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-02-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nabeela Afifi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5cc79fc9-ffd1-46ed-ad54-a8c368ca6070",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-06669",
    "licenseIssueDate": "02/14/2025 00:00:00",
    "licenseExpiryDate": "02/13/2026 00:00:00"
  },
  {
    "id": "40bcf075-dfd0-48de-a957-0ba5ff469c0a",
    "slug": "nabil-anwar-mohamed-elsayed-salama",
    "name": "NABIL ANWAR MOHAMED ELSAYED SALAMA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Commercial Transactions-Commercial Contracts",
      "Criminal Law-Crimes against persons",
      "Commercial Transactions-Commercial Companies",
      "Commercial Transactions-Banking Operations",
      "Criminal Law-Drug Crimes",
      "Civil Transactions-Sale",
      "Civil Transactions-Compensation",
      "Commercial Transactions-Intellectual Property (includes trademarks",
      "copy rights",
      "patents)",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nabil Anwar Mohamed Elsayed Salama",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_40bcf075-dfd0-48de-a957-0ba5ff469c0a",
        "address": "",
        "phone": "97142594601",
        "email": "info@almazmilawfirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6d921a3f-66d8-409c-82d0-47ea77e53617",
    "firmName": "AHMED HASSAN ALMAAZMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01844",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "324067fd-f555-448e-ab7b-30b6071beabe",
    "slug": "nabil-barahim",
    "name": "NABIL FUAD ABDULLA BA RAHIM",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/01/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nabil Barahim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_324067fd-f555-448e-ab7b-30b6071beabe",
        "address": "AL DIYAR RAG BIZ HQ BUSINESS CENTER ,ALWASL ,5922 ,",
        "phone": "97142284399 / 971506540033",
        "email": "nabil.barahim@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "bb8d29c8-092a-44ba-b960-00b20d622b97",
    "firmName": "Barahim Legal Consultants",
    "registrationNumber": "L-01087",
    "licenseIssueDate": "01/03/2013 00:00:00",
    "licenseExpiryDate": "12/26/2025 00:00:00"
  },
  {
    "id": "02b82ecc-638f-4800-ab43-ff5bb134c164",
    "slug": "nabil-issa",
    "name": "NABIL ADLY ISSA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/11/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nabil Issa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_02b82ecc-638f-4800-ab43-ff5bb134c164",
        "address": "",
        "phone": "97143779900 / 971508548052",
        "email": "jali@kslaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "dff8529a-82be-431a-b72b-0192ff238011",
    "firmName": "King & Spalding LLP",
    "registrationNumber": "L-00817",
    "licenseIssueDate": "11/22/2011 00:00:00",
    "licenseExpiryDate": "11/13/2025 00:00:00"
  },
  {
    "id": "382f3d0d-fc00-4eb6-8489-49cdebb42dad",
    "slug": "nabil-mohamed-abdelmonem-ibrahim",
    "name": "Nabil Mohamed Abdelmonem Ibrahim",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/02/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nabil Mohamed Abdelmonem Ibrahim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_382f3d0d-fc00-4eb6-8489-49cdebb42dad",
        "address": "ABDELAZIZ MOHAMED ABDELGHANI AL KHAMIRI AL ALI ,3 ,DUBAI SUPREME COURT COMPLEX ,DUBAI COURT ,128334 ,Dubai",
        "phone": "97145519341 / 971505788557",
        "email": "info@raalc.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "73e54a15-f797-4e91-a501-ef988d8f8bf8",
    "firmName": "ABDELAZIZ AL KHAMIRI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04390",
    "licenseIssueDate": "02/25/2022 00:00:00",
    "licenseExpiryDate": "02/24/2026 00:00:00"
  },
  {
    "id": "076401f8-5265-4f67-9ed7-f7a6c180f438",
    "slug": "nada-ashraf-ahmed-eloteifi",
    "name": "NADA ASHRAF AHMED ELOTEIFI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/03/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nada Ashraf Ahmed Eloteifi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_076401f8-5265-4f67-9ed7-f7a6c180f438",
        "address": "",
        "phone": "97144543900 / 971569199020",
        "email": "paul.hughes@kobrekim.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "259f7732-3596-4559-ae29-21cb6f4aa7d8",
    "firmName": "Kobre & Kim (GCC) LLP",
    "registrationNumber": "L-04867",
    "licenseIssueDate": "03/15/2021 00:00:00",
    "licenseExpiryDate": "03/14/2026 00:00:00"
  },
  {
    "id": "9368296d-4c5e-4bfb-b441-8941d3c2eb00",
    "slug": "nada-mohamed-gomaa-abdellatif",
    "name": "NADA MOHAMED GOMAA ABDELLATIF",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Civil Transactions-Insurance",
      "Civil Transactions-Construction and Contracts for Services",
      "Commercial Transactions-Commercial Contracts",
      "Civil Transactions-Immigration and Residency",
      "Civil Transactions-Residential Real Estate",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Civil Transactions-Tenancy",
      "Civil Transactions-Labor & Workers",
      "Civil Transactions-Sale",
      "Commercial Transactions-Sea and air freight",
      "Civil Transactions-Compensation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/03/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nada Mohamed Gomaa Abdellatif",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9368296d-4c5e-4bfb-b441-8941d3c2eb00",
        "address": "13 ,Le Solarium Tower ,Arabian Gate ,185430 ,Dubai",
        "phone": "97145805135 / 971558703836",
        "email": "info@alnaqbilaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "24f8f7c8-a688-4587-9e87-f3105a99533a",
    "firmName": "MUSAAB ALI AL NAQBI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-04628",
    "licenseIssueDate": "03/27/2021 00:00:00",
    "licenseExpiryDate": "03/26/2026 00:00:00"
  },
  {
    "id": "96f702b8-4d47-4d42-93c1-31199d3dace3",
    "slug": "nada-wilson-ramzy-mina",
    "name": "NADA WILSON RAMZY MINA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/10/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nada Wilson Ramzy Mina",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_96f702b8-4d47-4d42-93c1-31199d3dace3",
        "address": "ICD Brookfield Place ,DIFC ,506516 ,",
        "phone": "97143695800 / 971505526206",
        "email": "scott.campbell@linklaters.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5cec94c0-0649-43b6-a2be-ab17ff422bce",
    "firmName": "LinkLaters LLP",
    "registrationNumber": "L-06059",
    "licenseIssueDate": "10/11/2023 00:00:00",
    "licenseExpiryDate": "10/10/2026 00:00:00"
  },
  {
    "id": "eba50eee-2e77-4da6-a8e6-6b85d4ee2621",
    "slug": "nadeem-sheikh",
    "name": "NADEEM SHEIKH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/10/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2022-10-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nadeem Sheikh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_eba50eee-2e77-4da6-a8e6-6b85d4ee2621",
        "address": "الطابق 7 مكتب رقم 070A ,برج رولكس  ,محطة مترو المركز المالي  ,66300 ,Dubai",
        "phone": "97143444029",
        "email": "ekp.khalidaltmimi@ekplegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "400838f1-4e75-4836-9698-b9e19dd30a18",
    "firmName": "KHALID ABDALLA ALTAMIMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05078",
    "licenseIssueDate": "11/01/2021 00:00:00",
    "licenseExpiryDate": "10/31/2022 00:00:00"
  },
  {
    "id": "bb03d258-5d16-4ef1-84ac-018bc0224e7f",
    "slug": "nadeen-fuad-salem-haddadin",
    "name": "NADEEN FUAD SALEM HADDADIN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBORgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/03/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nadeen Fuad Salem Haddadin",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bb03d258-5d16-4ef1-84ac-018bc0224e7f",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-05767",
    "licenseIssueDate": "03/08/2023 00:00:00",
    "licenseExpiryDate": "03/07/2026 00:00:00"
  },
  {
    "id": "de1d768b-7631-4d9a-8c56-8ba39a1bfe77",
    "slug": "nader-ali-mohamed-edib",
    "name": "NADER ALI MOHAMED ELDIB",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/12/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nader Ali Mohamed Edib",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_de1d768b-7631-4d9a-8c56-8ba39a1bfe77",
        "address": "",
        "phone": "97143266669 / 971505479696",
        "email": "almasayba@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a1c5fd44-9a8b-4235-8ba0-8499d6832520",
    "firmName": "BASHAR ALMASAYBA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05687",
    "licenseIssueDate": "12/21/2022 00:00:00",
    "licenseExpiryDate": "12/20/2025 00:00:00"
  },
  {
    "id": "f05b707a-a84b-4233-95da-2a382c9a91e1",
    "slug": "nader-koudsi",
    "name": "NADER KOUDSI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/02/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nader Koudsi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f05b707a-a84b-4233-95da-2a382c9a91e1",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-05237",
    "licenseIssueDate": "02/18/2022 00:00:00",
    "licenseExpiryDate": "02/17/2026 00:00:00"
  },
  {
    "id": "2fa458e0-e8ff-45c9-b18f-5005586d7425",
    "slug": "nadia-akhter",
    "name": "NADIA AKHTER",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/01/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nadia Akhter",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2fa458e0-e8ff-45c9-b18f-5005586d7425",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-04767",
    "licenseIssueDate": "01/16/2025 00:00:00",
    "licenseExpiryDate": "01/15/2026 00:00:00"
  },
  {
    "id": "3d825b01-a22d-4878-82a9-7b5678fd6301",
    "slug": "nadia-fadi-el-tannir",
    "name": "NADIA FADI EL TANNIR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBORgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/06/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nadia Fadi El Tannir",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3d825b01-a22d-4878-82a9-7b5678fd6301",
        "address": "",
        "phone": "97143685555",
        "email": "maisa.maarouf@bsabh.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8afa232f-52ff-4dad-82c3-9a04d66eb853",
    "firmName": "B S A AHMED BIN HAZEEM & ASSOCIATES LLP - DIFC",
    "registrationNumber": "L-04698",
    "licenseIssueDate": "06/11/2020 00:00:00",
    "licenseExpiryDate": "06/10/2026 00:00:00"
  },
  {
    "id": "1f4c3b88-eaa8-4afa-b937-03ade7fa97c3",
    "slug": "nadia-stephenson",
    "name": "NADIA STEPHENSON",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/06/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nadia Stephenson",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1f4c3b88-eaa8-4afa-b937-03ade7fa97c3",
        "address": "6 ,Office Nos. 603, 604 & 605, Level 6, Burj Daman ,Dubai International Financial Centre ,506555 ,Dubai",
        "phone": "97143506400 / 971504654755",
        "email": "r.hickman@aglaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8690f7d5-6b96-4649-9589-71303f2c2707",
    "firmName": "Addleshaw Goddard (Middle East) LLP",
    "registrationNumber": "L-06874",
    "licenseIssueDate": "06/20/2025 00:00:00",
    "licenseExpiryDate": "06/19/2026 00:00:00"
  },
  {
    "id": "ea269f09-0c57-43e1-86a3-67f27ef877dc",
    "slug": "nadim-bardawil",
    "name": "NADIM BARDAWIL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nadim Bardawil",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ea269f09-0c57-43e1-86a3-67f27ef877dc",
        "address": "",
        "phone": "97143685555",
        "email": "maisa.maarouf@bsabh.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8afa232f-52ff-4dad-82c3-9a04d66eb853",
    "firmName": "B S A AHMED BIN HAZEEM & ASSOCIATES LLP - DIFC",
    "registrationNumber": "L-01636",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "d41d38f3-2c09-4996-b822-8b762c9f3940",
    "slug": "nadim-khan",
    "name": "NADIM KHAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/03/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nadim Khan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d41d38f3-2c09-4996-b822-8b762c9f3940",
        "address": "One Central, The Offices 5 ,Dubai World Trade Centre ,554660 ,",
        "phone": "97142052030 / 971506566494",
        "email": "chourani@houranipartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "59a73632-40a0-4849-b120-4308dc6f8015",
    "firmName": "Hourani & Partners Legal Consultancy FZCO",
    "registrationNumber": "L-00781",
    "licenseIssueDate": "03/12/2025 00:00:00",
    "licenseExpiryDate": "03/11/2026 00:00:00"
  },
  {
    "id": "fd19aed7-34bb-485d-8a0c-c22939957cdf",
    "slug": "nadine-el-helou",
    "name": "NADINE CHARBEL EL HELOU",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBORQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/03/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nadine El Helou",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fd19aed7-34bb-485d-8a0c-c22939957cdf",
        "address": "",
        "phone": "97143098000 / 971552210883",
        "email": "belturk@rouse.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9df4d4e5-5243-4fae-8d95-463d110ce6a8",
    "firmName": "Rouse & Co International Limited (Dubai Branch)",
    "registrationNumber": "L-04366",
    "licenseIssueDate": "03/25/2019 00:00:00",
    "licenseExpiryDate": "03/23/2026 00:00:00"
  },
  {
    "id": "7689fe38-117e-4675-a327-0dc4b7134426",
    "slug": "nadine-khaled-mahmoud-abdelmonim-azmi",
    "name": "NADINE KHALED MAHMOUD ABDELMONIM AZMI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/07/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nadine Khaled Mahmoud Abdelmonim Azmi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7689fe38-117e-4675-a327-0dc4b7134426",
        "address": "ICD-Brookfield Place ,DIFC ,119974 ,",
        "phone": "97143652000",
        "email": "david.charlier@ashurst.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c01c3c61-4d90-4058-8429-61dd01e615f5",
    "firmName": "Ashurst LLP-DIFC",
    "registrationNumber": "L-05928",
    "licenseIssueDate": "07/12/2023 00:00:00",
    "licenseExpiryDate": "07/11/2026 00:00:00"
  },
  {
    "id": "9476dbd8-2267-4808-b6c4-33b8449754f2",
    "slug": "nadine-ruth-wilson",
    "name": "Nadine Ruth Wilson",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/06/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-05-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nadine Ruth Wilson",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9476dbd8-2267-4808-b6c4-33b8449754f2",
        "address": "Burj Daman ,Dubai International Financial Center ,213241 ,",
        "phone": "97144549586 / 971564189768",
        "email": "darrenaharris123@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3cb06a05-1ad1-4487-9624-c2b716bfd2a7",
    "firmName": "Gateley UK LLP",
    "registrationNumber": "L-04599",
    "licenseIssueDate": "01/06/2020 00:00:00",
    "licenseExpiryDate": "01/05/2026 00:00:00"
  },
  {
    "id": "08fa2438-c538-4d65-b806-a5837d452667",
    "slug": "nafeth-ak-albarrawi",
    "name": "NAFETH A K ALBARRAWI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Commercial Transactions-Commercial Real Estate",
      "Civil Transactions-Tenancy",
      "Proceedings-Cases and Proceedings before arbitral tribunals and other alternative dispute resolution bodies",
      "Personal Status-Marriage & Divorce",
      "Criminal Law-Crimes against properties"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/09/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nafeth A.K Albarrawi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_08fa2438-c538-4d65-b806-a5837d452667",
        "address": "Dr. Ali Ismail Aljarman ,Roof Floor - Offices R03 & R04 ,MSM 1 Building ,Al Saffa First ,62639 ,Dubai",
        "phone": "97144393733",
        "email": "info@prestigeadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "22043b7f-55d2-4eb4-a173-3077ba390351",
    "firmName": "PRESTIGE ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02727",
    "licenseIssueDate": "09/19/2024 00:00:00",
    "licenseExpiryDate": "09/18/2026 00:00:00"
  },
  {
    "id": "63bdb086-ec1f-4f92-a005-20ccc8228f0d",
    "slug": "nageh-abdelsabour-ibrahim",
    "name": "NAGEH ABDELSABOUR ABDELRAHIM IBRAHIM",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/05/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nageh Abdelsabour Ibrahim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_63bdb086-ec1f-4f92-a005-20ccc8228f0d",
        "address": "Advo. Abdulla Al Awadi ,العاشر  ,برايم تاور  ,فندق فيدا ,26665 ,Dubai",
        "phone": "97143352200",
        "email": "info@abdullaalawadi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5075821f-98f5-4546-8fcd-6cdc74967dac",
    "firmName": "ABDULLA AL AWADI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03350",
    "licenseIssueDate": "05/10/2016 00:00:00",
    "licenseExpiryDate": "05/06/2026 00:00:00"
  },
  {
    "id": "b6e9870f-adbc-4a15-a9ea-6d6de72e2d41",
    "slug": "naglaa-ahmed-baioumi",
    "name": "NAGLAA AHMED ELSAYED BAIOUMI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/01/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Naglaa Ahmed Baioumi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b6e9870f-adbc-4a15-a9ea-6d6de72e2d41",
        "address": "الثاني 201 ,مركز البخيت ,بالقرب من مركز القبائل للتخفيضات ,12020 ,Dubai",
        "phone": "97142664411",
        "email": "redhalaw@eim.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ba85e0f4-24ae-4065-9d96-7392f96f75fe",
    "firmName": "AL REDHA & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03572",
    "licenseIssueDate": "01/05/2017 00:00:00",
    "licenseExpiryDate": "01/01/2026 00:00:00"
  },
  {
    "id": "baf2234a-ee87-4095-bc1e-f49016773b6f",
    "slug": "naief-yahia-baiyomi",
    "name": "NAIEF YAHIA IBRAHIM BAIYOMI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Naief Yahia Baiyomi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_baf2234a-ee87-4095-bc1e-f49016773b6f",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01293",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "198051c9-305b-446c-8b06-1ed68dbdefb8",
    "slug": "naima-labgaa",
    "name": "NAIMA LABGAA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/05/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Naima Labgaa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_198051c9-305b-446c-8b06-1ed68dbdefb8",
        "address": "4th floor ,Al Saaha Offices Block D office 401A ,Burj Khalifa ,283773 ,Dubai",
        "phone": "97144221944",
        "email": "gov.depts@alsafarpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b7bbfaeb-1fdb-46d2-97cf-8e6432a9b8a7",
    "firmName": "AL SAFAR & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04425",
    "licenseIssueDate": "05/30/2019 00:00:00",
    "licenseExpiryDate": "05/29/2026 00:00:00"
  },
  {
    "id": "d715d512-2f34-419b-92ee-15eafd98297e",
    "slug": "naina-anil-pagarani",
    "name": "NAINA ANIL PAGARANI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/12/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Naina Anil Pagarani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d715d512-2f34-419b-92ee-15eafd98297e",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-06146",
    "licenseIssueDate": "12/13/2023 00:00:00",
    "licenseExpiryDate": "12/12/2025 00:00:00"
  },
  {
    "id": "a20d7b56-8a66-4ae9-abe8-5e63ab4f2842",
    "slug": "naji-hawayek",
    "name": "NAJI HABIB HAWAYEK",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/10/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Naji Hawayek",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a20d7b56-8a66-4ae9-abe8-5e63ab4f2842",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-00305",
    "licenseIssueDate": "10/11/2011 00:00:00",
    "licenseExpiryDate": "10/02/2026 00:00:00"
  },
  {
    "id": "5d25ae82-8dd3-4920-a3e6-34f2d44fdca1",
    "slug": "naji-naji-khairallah",
    "name": "Naji Naji Khairallah",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/26/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Naji Naji Khairallah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5d25ae82-8dd3-4920-a3e6-34f2d44fdca1",
        "address": "South Tower, Emirates Financial Towers ,DIFC ,482025 ,",
        "phone": "97145875333 / 971503444388",
        "email": "c.dersahakian@cvml.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e2c6db70-04e7-4c7b-882a-6d2ffe4469ed",
    "firmName": "CVML Limited",
    "registrationNumber": "L-05222",
    "licenseIssueDate": "02/26/2025 00:00:00",
    "licenseExpiryDate": "02/25/2026 00:00:00"
  },
  {
    "id": "e1779b23-eb60-4b6c-958a-ecc574ce8529",
    "slug": "najmi-agha",
    "name": "NAJMI AGHA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/10/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-10-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Najmi Agha",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e1779b23-eb60-4b6c-958a-ecc574ce8529",
        "address": "5 ,tasheel bldg ,nasr club ,116749 ,Dubai",
        "phone": "97143970701",
        "email": "salha@albastiadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c34580b3-9e80-4326-bd68-0eb2abbb06fc",
    "firmName": "SALHA ALBASTI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01706",
    "licenseIssueDate": "11/01/2011 00:00:00",
    "licenseExpiryDate": "10/23/2020 00:00:00"
  },
  {
    "id": "b0936450-0ca2-44ed-8eed-188707f3a016",
    "slug": "najumudeen-aliyaru-kunju",
    "name": "NAJUMUDEEN ALIYARU KUNJU",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Najumudeen Aliyaru Kunju",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b0936450-0ca2-44ed-8eed-188707f3a016",
        "address": "Noushad kn ,1 ,sama tower ,Chello Restaurant  ,87706 ,Dubai",
        "phone": "97142822744",
        "email": "info@hosanilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c063023c-8d6f-4566-8537-31e0c9977c77",
    "firmName": "AL HOSANY ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-02396",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "bf20c98e-0f30-430a-b65a-0e2cce75f072",
    "slug": "nalothiya-nambirajah",
    "name": "NALOTHIYA NAMBIRAJAH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/07/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nalothiya Nambirajah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bf20c98e-0f30-430a-b65a-0e2cce75f072",
        "address": "0 ,ICD Brookfield Place Level 13 ,Trade Centre ,506569 ,Dubai",
        "phone": "97145099100 / 971501006965",
        "email": "menahr@freshfields.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "970f6246-e737-41a7-9c6c-5aa5b8335d45",
    "firmName": "Freshfields LLP DIFC",
    "registrationNumber": "L-04973",
    "licenseIssueDate": "07/05/2021 00:00:00",
    "licenseExpiryDate": "07/04/2026 00:00:00"
  },
  {
    "id": "51f7fd5b-7c66-47eb-a1b8-546dce025b96",
    "slug": "nanda-ziad-al-qazaz",
    "name": "NANDA ZIAD AL QAZAZ",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOWgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/11/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nanda Ziad Al Qazaz",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_51f7fd5b-7c66-47eb-a1b8-546dce025b96",
        "address": "Index Tower ,Dubai International Financial Centre ,507115 ,",
        "phone": "97143757160 / 971523490280",
        "email": "tthraya@mayerbrown.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c7f52b69-c049-4246-963a-9805b241f88a",
    "firmName": "Mayer Brown LLP",
    "registrationNumber": "L-04803",
    "licenseIssueDate": "11/19/2020 00:00:00",
    "licenseExpiryDate": "11/18/2025 00:00:00"
  },
  {
    "id": "0d176c3d-ec1d-4b73-8d9e-4d4b50ea7970",
    "slug": "nariman-mohamed-mostafa-mohamed-kewan",
    "name": "NARIMAN MOHAMED MOSTAFA MOHAMED KEWAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/05/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: nariman mohamed mostafa mohamed kewan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0d176c3d-ec1d-4b73-8d9e-4d4b50ea7970",
        "address": "",
        "phone": "97142966772",
        "email": "info@advocates-consultation.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "43806daf-e311-4130-a270-8aabc08c4ef4",
    "firmName": "OBAID AL EBRI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06786",
    "licenseIssueDate": "05/07/2025 00:00:00",
    "licenseExpiryDate": "05/06/2026 00:00:00"
  },
  {
    "id": "4f3bfba4-1474-478c-822e-c6387d090257",
    "slug": "naser-hisham-muhye-aldeen",
    "name": "NASER HISHAM MOHAMMAD MUHYE ALDEEN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/01/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Naser Hisham Muhye Aldeen",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4f3bfba4-1474-478c-822e-c6387d090257",
        "address": "HASSAN ALI MATAR ALRIYAMI ,24 ,GRASVENOR BUSINESS TOWER ,NEEDS SUPERMARKET ,215880 ,Dubai",
        "phone": "97144534188",
        "email": "courts@alriyamiadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a40a2f1f-69a9-429c-8086-dba9d985532b",
    "firmName": "HASAN ALRAYYAMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03334",
    "licenseIssueDate": "01/24/2016 00:00:00",
    "licenseExpiryDate": "01/19/2026 00:00:00"
  },
  {
    "id": "5863e857-5d10-40c2-a340-4da7762b9b5e",
    "slug": "nasir-hakim-salman-basheer",
    "name": "NASIR HAKIM SALMAN BASHEER",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Commercial Agency",
      "Civil Transactions-Arbitration",
      "Proceedings-Cases and Proceedings before arbitral tribunals and other alternative dispute resolution bodies",
      "Personal Status-Marriage & Divorce",
      "Criminal Law-Crimes against properties"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/11/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nasir Hakim Salman Basheer",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5863e857-5d10-40c2-a340-4da7762b9b5e",
        "address": "الثاني عشر مكتب 1201 ,مبنى امباير هايتس البرج B ,بنك رأس الخيمة ,00000 ,Dubai",
        "phone": "97142611689 / 971561234514",
        "email": "info@nja.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "490cb579-167c-4a7e-b679-997fb6780992",
    "firmName": "JASIM ALHADDAD ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03407",
    "licenseIssueDate": "11/29/2023 00:00:00",
    "licenseExpiryDate": "11/28/2025 00:00:00"
  },
  {
    "id": "087f70c1-3841-4c72-adeb-9eb6794e97b1",
    "slug": "nasma-al-sabe",
    "name": "NASMA ABDALLA MOHAMAD AL SABE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/08/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nasma Al Sabe",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_087f70c1-3841-4c72-adeb-9eb6794e97b1",
        "address": "One Central, The Offices 5 ,Dubai World Trade Centre ,554660 ,",
        "phone": "97142052030 / 971506566494",
        "email": "chourani@houranipartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "59a73632-40a0-4849-b120-4308dc6f8015",
    "firmName": "Hourani & Partners Legal Consultancy FZCO",
    "registrationNumber": "L-03798",
    "licenseIssueDate": "08/08/2024 00:00:00",
    "licenseExpiryDate": "08/07/2026 00:00:00"
  },
  {
    "id": "2794c138-bdc1-4c90-af76-b750d1442007",
    "slug": "nasr-badr-nasr-metwally",
    "name": "NASR BADR NASR METWALLY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/12/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nasr Badr Nasr Metwally",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2794c138-bdc1-4c90-af76-b750d1442007",
        "address": "Nawal Salem Saeed Salem ,508 ,S. I. T Tower ,SILICON OASIS ,0000 ,Dubai",
        "phone": "97145582139 / 971555425608",
        "email": "courts@nslawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8d7ab4a5-3c4d-4fa5-a466-d525e2054af8",
    "firmName": "NAWAL SALEM SAEED ADVOCATES &LEGAL CONSULTANTS",
    "registrationNumber": "L-06597",
    "licenseIssueDate": "12/05/2024 00:00:00",
    "licenseExpiryDate": "12/04/2025 00:00:00"
  },
  {
    "id": "9f1561b1-c3c8-4e03-b490-cdbdd8ddad70",
    "slug": "nasr-fadel-naguib-mahmoud-elsonbati",
    "name": "NASR FADEL NAGUIB MAHMOUD ELSONBATI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBORgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/02/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nasr Fadel Naguib Mahmoud Elsonbati",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9f1561b1-c3c8-4e03-b490-cdbdd8ddad70",
        "address": "الطابق الخامس  ,القيادة ,مطار دبى رقم 2 ,13917 ,Dubai",
        "phone": "97142949003",
        "email": "info@brlegalese.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "cf14fc58-f25f-463d-b60f-bfe4a127da8b",
    "firmName": "AL BANNAI & AL RASHEDAN ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05182",
    "licenseIssueDate": "02/08/2022 00:00:00",
    "licenseExpiryDate": "02/07/2026 00:00:00"
  },
  {
    "id": "ea7a00c4-4099-4fdf-9c58-5f7f8185c8b3",
    "slug": "nasreen-hago",
    "name": "NASREEN HAGO",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/01/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nasreen Hago",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ea7a00c4-4099-4fdf-9c58-5f7f8185c8b3",
        "address": "ICD Brookfield Place ,DIFC ,506516 ,",
        "phone": "97143695800 / 971505526206",
        "email": "scott.campbell@linklaters.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5cec94c0-0649-43b6-a2be-ab17ff422bce",
    "firmName": "LinkLaters LLP",
    "registrationNumber": "L-06190",
    "licenseIssueDate": "01/31/2024 00:00:00",
    "licenseExpiryDate": "01/30/2026 00:00:00"
  },
  {
    "id": "fd6c9b31-f556-4266-8114-af5e1ac920ba",
    "slug": "nassar-hussein-hassan",
    "name": "NASSAR HUSSEIN MOHAMED HASSAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nassar Hussein Hassan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fd6c9b31-f556-4266-8114-af5e1ac920ba",
        "address": "",
        "phone": "97143339002 / 971558818724",
        "email": "info@nhalhammadi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e78d4c87-2450-4a73-af8f-bdea91defa61",
    "firmName": "HESSA ALHAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01392",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "77a63777-5c49-4e9a-a219-d998f2a0d5b8",
    "slug": "nassar-nassar",
    "name": "NASSAR NASSAR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/09/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nassar Nassar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_77a63777-5c49-4e9a-a219-d998f2a0d5b8",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-05527",
    "licenseIssueDate": "09/12/2022 00:00:00",
    "licenseExpiryDate": "09/11/2026 00:00:00"
  },
  {
    "id": "bb904c1b-9797-4308-ac51-a2f9685ad2b8",
    "slug": "nasser-ali-khasawneh",
    "name": "NASSER ALI KHASAWNEH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/10/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nasser Ali Khasawneh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bb904c1b-9797-4308-ac51-a2f9685ad2b8",
        "address": "",
        "phone": "97143897000 / 971506553198",
        "email": "nasseralikhasawneh@eversheds-sutherland.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "74a21d43-41d8-480a-a6af-6939b7c98a95",
    "firmName": "Eversheds Sutherland (International LLP) Dubai Branch",
    "registrationNumber": "L-00477",
    "licenseIssueDate": "10/19/2011 00:00:00",
    "licenseExpiryDate": "10/10/2025 00:00:00"
  },
  {
    "id": "99d112b5-07a0-4d93-aa79-7260da28d189",
    "slug": "nasser-korany-ahmed",
    "name": "NASSER KORANY MEGAHED AHMED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/10/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2022-09-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nasser Korany Ahmed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_99d112b5-07a0-4d93-aa79-7260da28d189",
        "address": "",
        "phone": "97143474007",
        "email": "info@alsabhanlegalgroup.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c31ad0e5-b382-4c9a-9fab-8853b1330f6b",
    "firmName": "DR AL SABBHAN LEGAL GROUP",
    "registrationNumber": "L-01811",
    "licenseIssueDate": "10/05/2011 00:00:00",
    "licenseExpiryDate": "09/26/2022 00:00:00"
  },
  {
    "id": "f97b4c68-d8ef-4d17-928c-397f9109d577",
    "slug": "nasser-mohamed-ahmed",
    "name": "NASSER MOHAMED ABDELAZEM AHMED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/05/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nasser Mohamed Ahmed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f97b4c68-d8ef-4d17-928c-397f9109d577",
        "address": "",
        "phone": "97142942616",
        "email": "info@ilofficeuae.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "48ef4874-8647-4fb6-bedd-ffbad25accd1",
    "firmName": "KHALID KALANDAR ALMAAZMI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-02515",
    "licenseIssueDate": "05/29/2014 00:00:00",
    "licenseExpiryDate": "05/23/2026 00:00:00"
  },
  {
    "id": "b5705766-74fd-4524-95a6-630bb831e5fb",
    "slug": "nasser-yehia-youssef",
    "name": "NASSER YEHIA IBRAHIM BAIOUMY YOUSSEF",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nasser Yehia Youssef",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b5705766-74fd-4524-95a6-630bb831e5fb",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01744",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "994392dd-c28d-4967-8e59-574e3d24a667",
    "slug": "nasser-youssouf-ali-alali",
    "name": "NASSER YOUSSOUF ALI AL ALI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/06/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nasser Youssouf Ali AlALi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_994392dd-c28d-4967-8e59-574e3d24a667",
        "address": "O-4801, O-4901 ,Burj al Salam Office Tower ,H Hotel ,111801 ,Dubai",
        "phone": "97143544444",
        "email": "administration@horizlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4e25fb39-6659-44f0-bc8b-3ff0f067beb0",
    "firmName": "HORIZONS & CO - LAW FIRM",
    "registrationNumber": "L-04962",
    "licenseIssueDate": "06/14/2021 00:00:00",
    "licenseExpiryDate": "06/12/2026 00:00:00"
  },
  {
    "id": "0eed7db2-970b-482e-806b-6af8518365ac",
    "slug": "nassif-boumalhab",
    "name": "NASSIF BOUMALHAB",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/10/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nassif Boumalhab",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0eed7db2-970b-482e-806b-6af8518365ac",
        "address": "",
        "phone": "97145953601 / 971508728645",
        "email": "Steven.Bainbridge@gtlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b4146aa6-efd1-41d7-819d-49da46353b0b",
    "firmName": "Greenberg Traurig Limited",
    "registrationNumber": "L-00306",
    "licenseIssueDate": "10/11/2011 00:00:00",
    "licenseExpiryDate": "10/02/2026 00:00:00"
  },
  {
    "id": "dca217be-5436-4c75-a25a-aa48f7553225",
    "slug": "natalia-mouzoula",
    "name": "NATALIA MOUZOULA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/02/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Natalia Mouzoula",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dca217be-5436-4c75-a25a-aa48f7553225",
        "address": "",
        "phone": "97144529091 / 971552805308",
        "email": "ashafi@ach-legal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4f3e1e80-c812-4585-9570-229cd96776a4",
    "firmName": "Anjarwalla, Collins and Haidermota Legal Consultants",
    "registrationNumber": "L-06211",
    "licenseIssueDate": "02/21/2024 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "da898ebd-64a5-4da0-a412-aa47c1c83616",
    "slug": "natalie-adham-patrick-mackay",
    "name": "Natalie Adham Patrick Mackay",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/12/2020",
    "licenseStatus": "active",
    "licenseExpiry": "2021-12-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Natalie Adham Patrick Mackay",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_da898ebd-64a5-4da0-a412-aa47c1c83616",
        "address": "Office 1A ,Silver Tower ,DMCC Al Mas Tower ,283149 ,Dubai",
        "phone": "97144542355 / 971564092949",
        "email": "pstone@fenwickelliott.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "45b03212-ac3a-4dbc-8b2d-10fc81273543",
    "firmName": "Fenwick Elliott LLP (DMCC Branch)",
    "registrationNumber": "L-04811",
    "licenseIssueDate": "12/10/2020 00:00:00",
    "licenseExpiryDate": "12/09/2025 00:00:00"
  },
  {
    "id": "86dd4d81-3daa-40e2-a602-3166f3af42f2",
    "slug": "natalie-caroline-francis",
    "name": "NATALIE CAROLINE FRANCIS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/06/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Natalie Caroline Francis",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_86dd4d81-3daa-40e2-a602-3166f3af42f2",
        "address": "",
        "phone": "97144230555 / 971504788443",
        "email": "yah@hfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c462c65e-185a-4e81-8425-a87e3a2b6842",
    "firmName": "Holman Fenwick Willan Middle East LLP",
    "registrationNumber": "L-06378",
    "licenseIssueDate": "06/05/2024 00:00:00",
    "licenseExpiryDate": "06/04/2026 00:00:00"
  },
  {
    "id": "d8c7a87e-c602-46fa-96da-1d5f03f58438",
    "slug": "natalie-jensen",
    "name": "NATALIE NIXON JENSEN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/03/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Natalie Jensen",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d8c7a87e-c602-46fa-96da-1d5f03f58438",
        "address": "Index Tower ,DIFC ,506896 ,",
        "phone": "97142782300 / 971551154791",
        "email": "GLeggate@wfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e2b82cfc-80a5-4957-ae41-b1a7beb693c1",
    "firmName": "Watson, Farley & Williams (Middle East) LLP",
    "registrationNumber": "L-03669",
    "licenseIssueDate": "03/20/2017 00:00:00",
    "licenseExpiryDate": "03/16/2026 00:00:00"
  },
  {
    "id": "0d822ae0-28f5-4a60-b9e5-697df4696a0d",
    "slug": "natalie-jones",
    "name": "Natalie Jones",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/02/2012",
    "licenseStatus": "active",
    "licenseExpiry": "2013-02-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Natalie Jones",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0d822ae0-28f5-4a60-b9e5-697df4696a0d",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-01294",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/19/2026 00:00:00"
  },
  {
    "id": "26f19830-003f-4ec8-9959-19c4b1eec775",
    "slug": "natalie-ledger",
    "name": "NATALIE MARIE LEDGER",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Civil Transactions-Construction and Contracts for Services",
      "Civil Transactions-Arbitration",
      "Proceedings-Cases and Proceedings before arbitral tribunals and other alternative dispute resolution bodies",
      "Civil Transactions-Construction and Contracts for Services",
      "Civil Transactions-Arbitration",
      "Proceedings-Cases and Proceedings before arbitral tribunals and other alternative dispute resolution bodies",
      "Civil Transactions-Construction and Contracts for Services",
      "Civil Transactions-Arbitration",
      "Proceedings-Cases and Proceedings before arbitral tribunals and other alternative dispute resolution bodies",
      "Civil Transactions-Construction and Contracts for Services",
      "Civil Transactions-Arbitration",
      "Proceedings-Cases and Proceedings before arbitral tribunals and other alternative dispute resolution bodies",
      "Civil Transactions-Construction and Contracts for Services",
      "Civil Transactions-Arbitration",
      "Proceedings-Cases and Proceedings before arbitral tribunals and other alternative dispute resolution bodies",
      "Civil Transactions-Construction and Contracts for Services",
      "Civil Transactions-Arbitration",
      "Proceedings-Cases and Proceedings before arbitral tribunals and other alternative dispute resolution bodies"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/06/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Natalie Ledger",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_26f19830-003f-4ec8-9959-19c4b1eec775",
        "address": "",
        "phone": "97143563900 / 971564663035",
        "email": "c.miller@Beale-Law.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0f74c5fc-87d6-451a-b380-576b0bc3ceb8",
    "firmName": "Beale & Company (Middle East)",
    "registrationNumber": "L-03644",
    "licenseIssueDate": "06/06/2023 00:00:00",
    "licenseExpiryDate": "06/05/2026 00:00:00"
  },
  {
    "id": "621fdcf7-4630-4283-ba35-3cc3d618aba8",
    "slug": "natasha-maria-el-najjar",
    "name": "NATASHA MARIA EL NAJJAR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/11/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Natasha Maria El-Najjar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_621fdcf7-4630-4283-ba35-3cc3d618aba8",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-04790",
    "licenseIssueDate": "11/05/2020 00:00:00",
    "licenseExpiryDate": "11/04/2025 00:00:00"
  },
  {
    "id": "891977f5-f807-41e8-8255-06e58035cf20",
    "slug": "natasha-shezreen-shezadee-marican",
    "name": "NATASHA SHEZREEN SHEZADEE MARICAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/05/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Natasha Shezreen Shezadee Marican",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_891977f5-f807-41e8-8255-06e58035cf20",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-06325",
    "licenseIssueDate": "05/22/2024 00:00:00",
    "licenseExpiryDate": "05/21/2026 00:00:00"
  },
  {
    "id": "2ba62850-fa57-40dc-bd74-4f88a55cd3e6",
    "slug": "natasha-zahid",
    "name": "NATASHA SAJID ZAHID",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOWgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/06/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Natasha Zahid",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2ba62850-fa57-40dc-bd74-4f88a55cd3e6",
        "address": "",
        "phone": "97104309100 / 971564013758",
        "email": "c.royle@taylorwessing.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d51b6f43-8c62-486f-a1ab-6ee3b87c8006",
    "firmName": "Taylor Wessing LLP (Dubai Branch)",
    "registrationNumber": "L-00554",
    "licenseIssueDate": "06/06/2024 00:00:00",
    "licenseExpiryDate": "06/05/2026 00:00:00"
  },
  {
    "id": "513b8204-1bfb-4c7a-9e47-b89b68d3fc33",
    "slug": "nathan-hooper",
    "name": "Nathan Hooper",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/08/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nathan Hooper",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_513b8204-1bfb-4c7a-9e47-b89b68d3fc33",
        "address": "Emirates Financial Towers (South) ,DIFC ,506546 ,",
        "phone": "97147096700 / 971505573843",
        "email": "dk@kbh.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "291a9c0d-030a-4cef-8739-c6946f741117",
    "firmName": "KBH Limited",
    "registrationNumber": "L-03022",
    "licenseIssueDate": "04/08/2023 00:00:00",
    "licenseExpiryDate": "04/07/2026 00:00:00"
  },
  {
    "id": "ccb36e7b-5c59-4d9f-944f-d5ef0c6f331a",
    "slug": "navandeep-singh-matta-yuvinder-singh-matta",
    "name": "NAVANDEEP SINGH MATTA YUVINDER SINGH MATTA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/08/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Navandeep Singh Matta Yuvinder Singh Matta",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ccb36e7b-5c59-4d9f-944f-d5ef0c6f331a",
        "address": "",
        "phone": "97142776075 / 971588324788",
        "email": "avichal@kochhardubai.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "847eff7c-4142-431e-a8d6-f58ff60964f6",
    "firmName": "Kochhar & Co Inc Legal Consultants (Dubai Branch)",
    "registrationNumber": "L-06454",
    "licenseIssueDate": "08/06/2024 00:00:00",
    "licenseExpiryDate": "08/05/2026 00:00:00"
  },
  {
    "id": "a5770323-a8d2-47dd-9108-d236c3f912c8",
    "slug": "nawal-bashir-abdel-hadi",
    "name": "NAWAL BASHIR AHMED ABDEL HADI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nawal Bashir Abdel Hadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a5770323-a8d2-47dd-9108-d236c3f912c8",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01295",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "f3091f36-5329-4dd8-924e-b8ac10363bf9",
    "slug": "nayab-yousuf",
    "name": "NAYAB AZIZ YOUSAF",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/08/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nayab Yousuf",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f3091f36-5329-4dd8-924e-b8ac10363bf9",
        "address": "THE OFFICES 1 ,DWTC ,115580 ,",
        "phone": "97143739700 / 971501148248",
        "email": "nitesh.pradhan@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "361fdc64-6b6f-4f37-abca-c52af8473b84",
    "firmName": "Pinsent Masons  LLP (DWTCA Branch)",
    "registrationNumber": "L-03829",
    "licenseIssueDate": "08/30/2017 00:00:00",
    "licenseExpiryDate": "08/27/2026 00:00:00"
  },
  {
    "id": "f7a88bf6-7ae9-42fd-9858-a9bfd35938dc",
    "slug": "nayel-isa-abdulla-alborshaid",
    "name": "Nayel Isa Abdulla AlBorshaid",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/07/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nayel Isa Abdulla AlBorshaid",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f7a88bf6-7ae9-42fd-9858-a9bfd35938dc",
        "address": "",
        "phone": "97143025100 / 971501501837",
        "email": "ccairns@trowers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "976857f5-9092-43cf-987d-bfa794a3fa51",
    "firmName": "Trowers & Hamlins LLP",
    "registrationNumber": "L-06927",
    "licenseIssueDate": "08/07/2025 00:00:00",
    "licenseExpiryDate": "08/06/2026 00:00:00"
  },
  {
    "id": "26476558-11ab-4cd7-8906-1e3454ef1ee2",
    "slug": "nayla-comair",
    "name": "NAYLA COMAIR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/06/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nayla Comair",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_26476558-11ab-4cd7-8906-1e3454ef1ee2",
        "address": "",
        "phone": "97140000000 / 971564600544",
        "email": "nayla@obeidpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "6412dd75-56e7-47d4-90a8-5c34e1e0eb3a",
    "firmName": "Obeid Law Firm & Partners-Dubai Branch",
    "registrationNumber": "L-04966",
    "licenseIssueDate": "06/21/2021 00:00:00",
    "licenseExpiryDate": "06/20/2026 00:00:00"
  },
  {
    "id": "b8c31cc8-0d3a-4dd4-8b3b-dc723289c049",
    "slug": "nayla-sleiman",
    "name": "NAYLA SLEIMAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/10/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nayla Sleiman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b8c31cc8-0d3a-4dd4-8b3b-dc723289c049",
        "address": "مطعم زعتر وزيت  ,اسبكت تاور  ,فندق تاج  ,118212 ,Dubai",
        "phone": "97144433013 / 97144433013",
        "email": "moaza.alkhadar.alc@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "1dc550f7-81c5-4a5a-9096-682d651b8688",
    "firmName": "MOAZA AL KHADAR ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04543",
    "licenseIssueDate": "10/22/2019 00:00:00",
    "licenseExpiryDate": "10/21/2026 00:00:00"
  },
  {
    "id": "bb2b641c-13b3-4f5f-bf23-fe18eeea6039",
    "slug": "nazanin-aleyaseen",
    "name": "NAZANIN ALEYASEEN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nazanin Aleyaseen",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bb2b641c-13b3-4f5f-bf23-fe18eeea6039",
        "address": "",
        "phone": "97144272700 / 971545824605",
        "email": "tony.griffiths@klgates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "fb8fc340-ceef-4b83-8f2b-9b24d4604967",
    "firmName": "K & L Gates LLP",
    "registrationNumber": "L-00957",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "46c5b61a-3957-4a4b-b696-c127b3eaddb6",
    "slug": "nazanin-esfandnia",
    "name": "NAZANIN ESFANDNIA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBORQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/09/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nazanin Esfandnia",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_46c5b61a-3957-4a4b-b696-c127b3eaddb6",
        "address": "21 ,Rolex Tower ,Emirates Grand Hotel ,94334 ,Dubai",
        "phone": "97143277772 / 97145584900",
        "email": "info@globaladvocates.net",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9b42810f-1d55-4aea-ac4a-7d9d1b25ac08",
    "firmName": "GLOBAL ADVOCACY & LEGAL COUNSEL",
    "registrationNumber": "L-05506",
    "licenseIssueDate": "09/21/2022 00:00:00",
    "licenseExpiryDate": "09/20/2026 00:00:00"
  },
  {
    "id": "ebf5bf86-e0b1-42c0-bb80-05c8a1dabb57",
    "slug": "nazanin-maghsoudlou",
    "name": "NAZANIN MAGHSOUDLOU",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/08/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nazanin Maghsoudlou",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ebf5bf86-e0b1-42c0-bb80-05c8a1dabb57",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02652",
    "licenseIssueDate": "08/10/2014 00:00:00",
    "licenseExpiryDate": "08/04/2026 00:00:00"
  },
  {
    "id": "23d86687-2705-4125-91b8-e687276f4a80",
    "slug": "nazar-ahmed-hassan",
    "name": "NAZAR AHMED HAMID HASSAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nazar Ahmed Hassan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_23d86687-2705-4125-91b8-e687276f4a80",
        "address": "",
        "phone": "97142770003",
        "email": "info@hbhadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "f074c445-924d-40b2-9832-0b0a040c4e63",
    "firmName": "HAIDER BIN HAIDER ADVOCATES AND LEGAL CONSULTANT",
    "registrationNumber": "L-01575",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "55a3905d-e33d-4b94-b36f-8970a7b83106",
    "slug": "nazeli-sahakyan",
    "name": "NAZELI SAHAKYAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/08/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nazeli Sahakyan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_55a3905d-e33d-4b94-b36f-8970a7b83106",
        "address": "4th floor ,Al Saaha Offices Block D office 401A ,Burj Khalifa ,283773 ,Dubai",
        "phone": "97144221944",
        "email": "gov.depts@alsafarpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b7bbfaeb-1fdb-46d2-97cf-8e6432a9b8a7",
    "firmName": "AL SAFAR & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05962",
    "licenseIssueDate": "08/16/2023 00:00:00",
    "licenseExpiryDate": "08/15/2026 00:00:00"
  },
  {
    "id": "b72a0ff9-07b7-41cf-b73b-530c6aa37aea",
    "slug": "nazia-dinat",
    "name": "NAZIA DINAT",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBORAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/10/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nazia Dinat",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b72a0ff9-07b7-41cf-b73b-530c6aa37aea",
        "address": "ICD-Brookfield Place ,DIFC ,119974 ,",
        "phone": "97143652000",
        "email": "david.charlier@ashurst.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c01c3c61-4d90-4058-8429-61dd01e615f5",
    "firmName": "Ashurst LLP-DIFC",
    "registrationNumber": "L-07010"
  },
  {
    "id": "e6a41b41-cada-4cdf-a14f-aafe46752269",
    "slug": "nazia-hussain",
    "name": "NAZIA HUSSAIN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/02/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-02-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nazia Hussain",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e6a41b41-cada-4cdf-a14f-aafe46752269",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-06689",
    "licenseIssueDate": "02/14/2025 00:00:00",
    "licenseExpiryDate": "02/13/2026 00:00:00"
  },
  {
    "id": "4db1d69c-cc35-4dcc-b73b-85fe45131011",
    "slug": "nazim-hashim-sahal",
    "name": "NAZIM HASHIM SAHAL MOHAMMED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/12/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nazim Hashim Sahal",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4db1d69c-cc35-4dcc-b73b-85fe45131011",
        "address": "",
        "phone": "97143303900 / 971561753537",
        "email": "christopher@afridi-angell.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "30ce50dc-01a6-499d-8ace-3f807ddcb08d",
    "firmName": "Afridi & Angell-DED",
    "registrationNumber": "L-00118",
    "licenseIssueDate": "12/16/2011 00:00:00",
    "licenseExpiryDate": "12/07/2025 00:00:00"
  },
  {
    "id": "70c8670e-21cd-49b7-a6d4-4de83a7e8c30",
    "slug": "nazly-ahmed-amir-hafez-sadik",
    "name": "NAZLY AHMED AMIR HAFEZ SADIK",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/01/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nazly Ahmed Amir Hafez Sadik",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_70c8670e-21cd-49b7-a6d4-4de83a7e8c30",
        "address": "",
        "phone": "97143641686 / 971506288801",
        "email": "b.kadir@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0ba96df8-e4cc-49c2-8ae4-a42878d95926",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS LLC",
    "registrationNumber": "L-06642",
    "licenseIssueDate": "01/22/2025 00:00:00",
    "licenseExpiryDate": "01/21/2026 00:00:00"
  },
  {
    "id": "d937c4bf-642b-4d9b-9767-eefcbebda10a",
    "slug": "nazuma-hassan",
    "name": "NAZUMA HASSAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/10/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nazuma Hassan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d937c4bf-642b-4d9b-9767-eefcbebda10a",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-02744",
    "licenseIssueDate": "10/02/2014 00:00:00",
    "licenseExpiryDate": "09/26/2026 00:00:00"
  },
  {
    "id": "5b59a80f-7d76-4da6-bba4-44976bc6d167",
    "slug": "ndey-yassin-salla",
    "name": "NDEY YASSIN SALLA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/10/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ndey Yassin Salla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5b59a80f-7d76-4da6-bba4-44976bc6d167",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-06539",
    "licenseIssueDate": "10/09/2024 00:00:00",
    "licenseExpiryDate": "10/08/2026 00:00:00"
  },
  {
    "id": "65f504d9-d747-41fc-8d87-67984f059dc6",
    "slug": "neda-ali-akbar-bahador",
    "name": "NEDA ALI AKBAR BAHADOR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/05/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Neda Ali Akbar Bahador",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_65f504d9-d747-41fc-8d87-67984f059dc6",
        "address": "Al Fattan Currency House Tower 2 ,DIFC ,507176 ,",
        "phone": "/ 971552009003",
        "email": "Mohammad.AlRasheed@bakermckenzie.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "acd81e81-dead-4f7c-839e-0f2a57897265",
    "firmName": "Baker & Mckenzie LLP",
    "registrationNumber": "L-05819",
    "licenseIssueDate": "05/24/2023 00:00:00",
    "licenseExpiryDate": "05/23/2026 00:00:00"
  },
  {
    "id": "d0184261-be48-4949-b23b-dcba54322e05",
    "slug": "nedal-omar-albaradai",
    "name": "NEDAL OMAR ALBARADAI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nedal Omar Albaradai",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d0184261-be48-4949-b23b-dcba54322e05",
        "address": "Fatima Mohammed Youseef Saddiq ,Floor 2, Office 215 ,Sultan Business Center ,Lamcy Plaza  ,114713 ,Dubai",
        "phone": "97145703330 / 971500000000",
        "email": "info@mnlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "f9b7a676-34db-4e8e-97b5-3ae354ee0661",
    "firmName": "FATIMA MOHAMMED ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01446",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "2168d474-7cf8-4927-af8f-095a2d709197",
    "slug": "neelam-kaur",
    "name": "NEELAM KAUR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/06/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Neelam Kaur",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2168d474-7cf8-4927-af8f-095a2d709197",
        "address": "THE OFFICES 1 ,DWTC ,115580 ,",
        "phone": "97143739700 / 971501148248",
        "email": "nitesh.pradhan@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "361fdc64-6b6f-4f37-abca-c52af8473b84",
    "firmName": "Pinsent Masons  LLP (DWTCA Branch)",
    "registrationNumber": "L-06840",
    "licenseIssueDate": "06/11/2025 00:00:00",
    "licenseExpiryDate": "06/10/2026 00:00:00"
  },
  {
    "id": "6ae9d5bf-137c-4262-a218-6598ef82dc8d",
    "slug": "neelesh-kumar-shivanandan-pillai",
    "name": "NEELESH KUMAR SHIVANANDAN PILLAI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/06/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Neelesh Kumar Shivanandan Pillai",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6ae9d5bf-137c-4262-a218-6598ef82dc8d",
        "address": "23 ,Rolex Tower ,Trade Center Second ,116637 ,Dubai",
        "phone": "97144357577 / 971502101003",
        "email": "jasamin.fichte@fichtelegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "77bf4fd2-1cd1-4bda-a0c2-ffcac3980b76",
    "firmName": "Fichte & Co Legal Consultancy",
    "registrationNumber": "L-04149",
    "licenseIssueDate": "06/12/2018 00:00:00",
    "licenseExpiryDate": "06/10/2026 00:00:00"
  },
  {
    "id": "3507a784-db80-4643-ad10-6d9b66f2fe09",
    "slug": "neeraj-rajan-sabitha-rajan-kollayil-bhaskara-pillai",
    "name": "NEERAJ RAJAN SABITHA RAJAN KOLLAYIL BHASKARA PILLAI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/05/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Neeraj Rajan Sabitha Rajan Kollayil Bhaskara Pillai",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3507a784-db80-4643-ad10-6d9b66f2fe09",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-06300",
    "licenseIssueDate": "05/31/2024 00:00:00",
    "licenseExpiryDate": "05/30/2026 00:00:00"
  },
  {
    "id": "4b1d11ae-6a09-46e6-bd02-e224a7a4188f",
    "slug": "nehad-abdelwahab",
    "name": "NEHAD FAROUK ABDELHAMED ABDELWAHAB",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/02/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nehad Abdelwahab",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4b1d11ae-6a09-46e6-bd02-e224a7a4188f",
        "address": "11 مكتب رقم 1104 ,وصل بيزنش سنترال ,خلف سيتي سنتر ديره ,23404 ,Dubai",
        "phone": "97142865503 / 971502705678",
        "email": "info-dxb@almulla-advocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6a822223-cec3-43fe-b3a7-3d4a10d010c4",
    "firmName": "HASSAN ASHOOR AL MULLA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03646",
    "licenseIssueDate": "02/19/2017 00:00:00",
    "licenseExpiryDate": "02/15/2026 00:00:00"
  },
  {
    "id": "fa5029aa-e745-432f-acbe-2acaa9cd0d64",
    "slug": "neil-christopher-donald",
    "name": "NEIL CHRISTOPHER DONALD",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/09/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Neil Christopher Donald",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fa5029aa-e745-432f-acbe-2acaa9cd0d64",
        "address": "",
        "phone": "97143897000 / 971506553198",
        "email": "nasseralikhasawneh@eversheds-sutherland.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "74a21d43-41d8-480a-a6af-6939b7c98a95",
    "firmName": "Eversheds Sutherland (International LLP) Dubai Branch",
    "registrationNumber": "L-06482",
    "licenseIssueDate": "09/04/2024 00:00:00",
    "licenseExpiryDate": "09/03/2026 00:00:00"
  },
  {
    "id": "a04fbf5b-7c36-42c3-84ab-62e0da767eca",
    "slug": "nervana-ali-seddik-boroham",
    "name": "NERVANA ALI SEDDIK BOROHAM ZAGHLOULA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/12/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nervana Ali Seddik Boroham",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a04fbf5b-7c36-42c3-84ab-62e0da767eca",
        "address": "ABDELAZIZ MOHAMED ABDELGHANI AL KHAMIRI AL ALI ,3 ,DUBAI SUPREME COURT COMPLEX ,DUBAI COURT ,128334 ,Dubai",
        "phone": "97145519341 / 971505788557",
        "email": "info@raalc.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "73e54a15-f797-4e91-a501-ef988d8f8bf8",
    "firmName": "ABDELAZIZ AL KHAMIRI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04816",
    "licenseIssueDate": "12/22/2020 00:00:00",
    "licenseExpiryDate": "12/21/2025 00:00:00"
  },
  {
    "id": "836bff14-a3f5-46a1-89ce-5014a5ec361f",
    "slug": "nesreen-isameldin-osman",
    "name": "NESREEN ISAMELDIN OSMAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/06/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nesreen Isameldin Osman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_836bff14-a3f5-46a1-89ce-5014a5ec361f",
        "address": "- ,THE OFFICES 1 ,DWTC ,115580 ,Dubai",
        "phone": "97143739700 / 971562196031",
        "email": "catherine.workman@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6b4ebb23-ef2e-4305-a1ee-43a11e4b1cae",
    "firmName": "Pinsent Masons LLP - Dubai Branch",
    "registrationNumber": "L-02211",
    "licenseIssueDate": "06/14/2021 00:00:00",
    "licenseExpiryDate": "06/13/2026 00:00:00"
  },
  {
    "id": "6bdbee74-a3c7-4d64-a2bf-2a13beaac54e",
    "slug": "nhlanhla-treasure-tshabalala",
    "name": "NHLANHLA TREASURE TSHABALALA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/03/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nhlanhla Treasure Tshabalala",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6bdbee74-a3c7-4d64-a2bf-2a13beaac54e",
        "address": "THE OFFICES 1 ,DWTC ,115580 ,",
        "phone": "97143739700 / 971501148248",
        "email": "nitesh.pradhan@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "361fdc64-6b6f-4f37-abca-c52af8473b84",
    "firmName": "Pinsent Masons  LLP (DWTCA Branch)",
    "registrationNumber": "L-05279",
    "licenseIssueDate": "03/18/2022 00:00:00",
    "licenseExpiryDate": "03/17/2026 00:00:00"
  },
  {
    "id": "1d66c731-a7a7-41dc-9069-988e3110c0ed",
    "slug": "nia-john-durnion",
    "name": "NIA JOHN DURNION",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/04/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nia John Durnion",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1d66c731-a7a7-41dc-9069-988e3110c0ed",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506688 ,Dubai",
        "phone": "97147096600 / 971503556811",
        "email": "muneer.khan@simmons-simmons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d1725ca7-06ac-41b2-8d7b-a6e60665b73d",
    "firmName": "Simmons & Simmons (Middle East) LLP-DIFC",
    "registrationNumber": "L-06759",
    "licenseIssueDate": "04/30/2025 00:00:00",
    "licenseExpiryDate": "04/29/2026 00:00:00"
  },
  {
    "id": "60ef7724-844b-4edf-a245-9ad170efa986",
    "slug": "nichola-reece-burton",
    "name": "NICHOLA JAYNE REECE BURTON",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Cases and Proceedings before Dubai International Financial Centre",
      "Commercial Transactions-Commercial Real Estate",
      "Civil Transactions-Residential Real Estate",
      "Civil Transactions-Arbitration",
      "Proceedings-Cases and Proceedings before arbitral tribunals and other alternative dispute resolution bodies"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/07/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nichola Reece-Burton",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_60ef7724-844b-4edf-a245-9ad170efa986",
        "address": "1 ,API World Tower ,258.37 square meters ,52294 ,Dubai",
        "phone": "97143317552 / 971504524322",
        "email": "berry@jamesberrylaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "f85683bf-f79f-4e38-9b7c-a1a75cd840b4",
    "firmName": "James Berry & Associates Legal Consultants",
    "registrationNumber": "L-01116",
    "licenseIssueDate": "07/16/2012 00:00:00",
    "licenseExpiryDate": "07/08/2026 00:00:00"
  },
  {
    "id": "8ee7e0a5-a2b9-40a1-b21c-c2b51d5b9e26",
    "slug": "nicholas-anthony-ioannou",
    "name": "NICHOLAS ANTHONY IOANNOU",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/03/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nicholas Anthony Ioannou",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8ee7e0a5-a2b9-40a1-b21c-c2b51d5b9e26",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-06684",
    "licenseIssueDate": "03/05/2025 00:00:00",
    "licenseExpiryDate": "03/04/2026 00:00:00"
  },
  {
    "id": "de4b6cb0-44db-48e1-b1be-276005da6cd5",
    "slug": "nicholas-braganza",
    "name": "NICHOLAS ADAM BRAGANZA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nicholas Braganza",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_de4b6cb0-44db-48e1-b1be-276005da6cd5",
        "address": "",
        "phone": "97144230555 / 971504788443",
        "email": "yah@hfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c462c65e-185a-4e81-8425-a87e3a2b6842",
    "firmName": "Holman Fenwick Willan Middle East LLP",
    "registrationNumber": "L-00309",
    "licenseIssueDate": "02/12/2012 00:00:00",
    "licenseExpiryDate": "02/03/2026 00:00:00"
  },
  {
    "id": "ab44d496-4721-41dc-b22e-f44628264228",
    "slug": "nicholas-carnell",
    "name": "Nicholas Carnell",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nicholas Carnell",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ab44d496-4721-41dc-b22e-f44628264228",
        "address": "",
        "phone": "97143438897 / 971507753952",
        "email": "jdavidson@davidson-legal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d0200f27-9504-4653-a5c6-05e4bcab7ff0",
    "firmName": "Davidson & Co Legal Consultants",
    "registrationNumber": "L-00745",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "a2fb709d-6edd-4449-90aa-cdf39aba810d",
    "slug": "nicholas-clarence-wong",
    "name": "NICHOLAS CLARENCE WONG",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/05/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nicholas Clarence Wong",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a2fb709d-6edd-4449-90aa-cdf39aba810d",
        "address": "",
        "phone": "97145032600 / 971504577931",
        "email": "edmund.boyo@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8cca52de-2c74-4743-b8f2-0b904d96b132",
    "firmName": "CC Worldwide Limited",
    "registrationNumber": "L-06345",
    "licenseIssueDate": "05/20/2024 00:00:00",
    "licenseExpiryDate": "05/19/2026 00:00:00"
  },
  {
    "id": "c872b95c-da5a-4238-ba02-9b0d089f2a1e",
    "slug": "nicholas-james-bailey-green",
    "name": "NICHOLAS JAMES BAILEY GREEN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/05/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nicholas James Bailey Green",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c872b95c-da5a-4238-ba02-9b0d089f2a1e",
        "address": "",
        "phone": "97143025100 / 971501501837",
        "email": "ccairns@trowers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "976857f5-9092-43cf-987d-bfa794a3fa51",
    "firmName": "Trowers & Hamlins LLP",
    "registrationNumber": "L-04407",
    "licenseIssueDate": "05/16/2019 00:00:00",
    "licenseExpiryDate": "05/15/2026 00:00:00"
  },
  {
    "id": "a1df7187-66d6-4914-8347-a91e5ebd8c38",
    "slug": "nicholas-john-simpson",
    "name": "NICHOLAS JOHN SIMPSON",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/05/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nicholas John Simpson",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a1df7187-66d6-4914-8347-a91e5ebd8c38",
        "address": "",
        "phone": "97144020800 / 971566830829",
        "email": "dean.ryburn@dentons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dfe13b7e-6625-45fd-ad63-9ee83af41194",
    "firmName": "Dentons & Co Dubai Branch-DED",
    "registrationNumber": "L-06323",
    "licenseIssueDate": "05/22/2024 00:00:00",
    "licenseExpiryDate": "05/21/2026 00:00:00"
  },
  {
    "id": "47c94a47-3582-4aa9-94c2-3677333bd941",
    "slug": "nicholas-kok-hoe-chan",
    "name": "NICHOLAS KOK HOE CHAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/09/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nicholas Kok Hoe Chan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_47c94a47-3582-4aa9-94c2-3677333bd941",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-05513",
    "licenseIssueDate": "09/21/2022 00:00:00",
    "licenseExpiryDate": "09/20/2026 00:00:00"
  },
  {
    "id": "c045a1f9-fe83-42b8-aeaf-66642076a8f1",
    "slug": "nicholas-libert-oury",
    "name": "NICHOLAS LIBERT OURY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/08/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nicholas Libert Oury",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c045a1f9-fe83-42b8-aeaf-66642076a8f1",
        "address": "",
        "phone": "97144286300 / 971506256686",
        "email": "stuart.paterson@hsf.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2f0389b3-bfde-44f4-bdd6-6e1a22f9cab2",
    "firmName": "Herbert Smith Freehills Kramer LLP",
    "registrationNumber": "L-04194",
    "licenseIssueDate": "08/30/2018 00:00:00",
    "licenseExpiryDate": "08/28/2026 00:00:00"
  },
  {
    "id": "d63ad3d5-0c31-4237-b27a-46ede1093488",
    "slug": "nicholas-michael-reed",
    "name": "Nicholas Michael Reed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/01/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nicholas Michael Reed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d63ad3d5-0c31-4237-b27a-46ede1093488",
        "address": "",
        "phone": "97144020800 / 971566830829",
        "email": "dean.ryburn@dentons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dfe13b7e-6625-45fd-ad63-9ee83af41194",
    "firmName": "Dentons & Co Dubai Branch-DED",
    "registrationNumber": "L-05172",
    "licenseIssueDate": "02/01/2022 00:00:00",
    "licenseExpiryDate": "01/31/2026 00:00:00"
  },
  {
    "id": "43620916-c31d-4127-a6c4-49685a8a1dfb",
    "slug": "nicholas-oconnell",
    "name": "NICHOLAS JAMES OCONNELL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nicholas O'Connell",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_43620916-c31d-4127-a6c4-49685a8a1dfb",
        "address": "",
        "phone": "97143093222 / 971566651954",
        "email": "melissa.murray@twobirds.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3e1526e6-4c8d-4b6f-985f-ea05e9f99bcb",
    "firmName": "Bird & Bird (MEA) LLP",
    "registrationNumber": "L-01296",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "b30af900-39f7-43d4-84d2-028145a9db11",
    "slug": "nicholas-robert-meyer",
    "name": "NICHOLAS ROBERT MEYER",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nicholas Robert Meyer",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b30af900-39f7-43d4-84d2-028145a9db11",
        "address": "",
        "phone": "97143506800 / 971507244940",
        "email": "Chris.Williams@bracewelllaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "106d3ee7-86f2-4eae-9b49-fd8423095983",
    "firmName": "Bracewell LLP",
    "registrationNumber": "L-05205",
    "licenseIssueDate": "03/01/2022 00:00:00",
    "licenseExpiryDate": "02/28/2026 00:00:00"
  },
  {
    "id": "8844c34e-6bac-47b8-85a7-6285cbe752ee",
    "slug": "nicholas-robinson",
    "name": "NICHOLAS ALEXANDER ROBINSON",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/10/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nicholas Robinson",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8844c34e-6bac-47b8-85a7-6285cbe752ee",
        "address": "",
        "phone": "97143742800 / 971506450677",
        "email": "jabbott21@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7a59d310-ff72-4318-b41c-27095c163d0f",
    "firmName": "CMS (UAE) LLP",
    "registrationNumber": "L-00509",
    "licenseIssueDate": "10/07/2011 00:00:00",
    "licenseExpiryDate": "09/28/2026 00:00:00"
  },
  {
    "id": "6bf56f34-ea2f-4ac4-8564-a7c75b9a129a",
    "slug": "nicholas-sharratt",
    "name": "NICHOLAS ANTHONY SHARRATT",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/08/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nicholas Sharratt",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6bf56f34-ea2f-4ac4-8564-a7c75b9a129a",
        "address": "ICD Brookfield Place ,Za'abeel 2 ,103747 ,",
        "phone": "97143696300 / 971506008159",
        "email": "mohammed.paracha@nortonrosefulbright.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c4aaee93-0ec4-4982-9a48-a23699492056",
    "firmName": "Norton Rose Fullbright (Middle East) LLP",
    "registrationNumber": "L-00479",
    "licenseIssueDate": "08/08/2012 00:00:00",
    "licenseExpiryDate": "07/31/2026 00:00:00"
  },
  {
    "id": "f65b358e-016b-48b8-993e-43375459a045",
    "slug": "nicholas-tolley",
    "name": "NICHOLAS JAMES TOLLEY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/03/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nicholas Tolley",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f65b358e-016b-48b8-993e-43375459a045",
        "address": "THE OFFICES 1 ,DWTC ,115580 ,",
        "phone": "97143739700 / 971501148248",
        "email": "nitesh.pradhan@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "361fdc64-6b6f-4f37-abca-c52af8473b84",
    "firmName": "Pinsent Masons  LLP (DWTCA Branch)",
    "registrationNumber": "L-01680",
    "licenseIssueDate": "03/05/2018 00:00:00",
    "licenseExpiryDate": "03/02/2026 00:00:00"
  },
  {
    "id": "f63e6a5a-75a4-47f2-b7f0-92133fcb3525",
    "slug": "nicholas-watson",
    "name": "Nicholas Watson",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/06/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nicholas Watson",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f63e6a5a-75a4-47f2-b7f0-92133fcb3525",
        "address": "IH-00-01-CP-05 ,DIFC ,506832 ,",
        "phone": "/ 971506957753",
        "email": "admin@supportlegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "1607c199-ca4b-4bc1-89e9-98dad0300645",
    "firmName": "Support Legal ( DIFC) Limited",
    "registrationNumber": "L-05997",
    "licenseIssueDate": "11/06/2023 00:00:00",
    "licenseExpiryDate": "11/05/2025 00:00:00"
  },
  {
    "id": "82de1182-7593-4b7e-a7a9-cc731422e7a8",
    "slug": "nicola-elizabeth-toomey",
    "name": "NICOLA ELIZABETH TOOMEY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBORQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/03/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nicola Elizabeth Toomey",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_82de1182-7593-4b7e-a7a9-cc731422e7a8",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-05715",
    "licenseIssueDate": "03/22/2023 00:00:00",
    "licenseExpiryDate": "03/21/2026 00:00:00"
  },
  {
    "id": "76cf975a-45c9-4353-a7b6-cedce9c20d38",
    "slug": "nicola-jackson",
    "name": "NICOLA JACKSON",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/07/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nicola Jackson",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_76cf975a-45c9-4353-a7b6-cedce9c20d38",
        "address": "20 ,Index Tower West Tower ,DIFC ,507226 ,Dubai",
        "phone": "97142461900 / 971523391604",
        "email": "patrick.gearon@crsblaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e2ac552e-b9a7-450b-a84d-15119e583220",
    "firmName": "Charles Russell Speechlys LLP",
    "registrationNumber": "L-00366",
    "licenseIssueDate": "07/23/2020 00:00:00",
    "licenseExpiryDate": "07/22/2026 00:00:00"
  },
  {
    "id": "2e5f15f2-0237-4766-a207-136458195521",
    "slug": "nicola-lohrey-hontarrede",
    "name": "NICOLA LOHREY HONTARREDE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/06/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nicola Lohrey Hontarrede",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2e5f15f2-0237-4766-a207-136458195521",
        "address": "Boulevard Plaza Tower 2 ,Burj Khalifa ,23297 ,",
        "phone": "97142950020 / 971526443550",
        "email": "nicola.lohrey@roedl.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "e92477d1-b4b2-4506-b1a4-99c4a9cfa443",
    "firmName": "Roedl & Partner (Dubai Branch)",
    "registrationNumber": "L-05917",
    "licenseIssueDate": "06/21/2023 00:00:00",
    "licenseExpiryDate": "06/20/2026 00:00:00"
  },
  {
    "id": "6f1da84a-bf15-4759-a7b1-f3466c6985e5",
    "slug": "nicola-louise-halliday",
    "name": "Nicola Louise Halliday",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/08/2022",
    "licenseStatus": "active",
    "licenseExpiry": "2023-08-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nicola Louise Halliday",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6f1da84a-bf15-4759-a7b1-f3466c6985e5",
        "address": "",
        "phone": "97144286300 / 971506256686",
        "email": "stuart.paterson@hsf.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2f0389b3-bfde-44f4-bdd6-6e1a22f9cab2",
    "firmName": "Herbert Smith Freehills Kramer LLP",
    "registrationNumber": "L-05460",
    "licenseIssueDate": "08/03/2022 00:00:00",
    "licenseExpiryDate": "08/02/2026 00:00:00"
  },
  {
    "id": "d0ca41c3-6a32-40e9-b782-fd737aa16811",
    "slug": "nicola-minervini",
    "name": "NICOLA MINERVINI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/06/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nicola Minervini",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d0ca41c3-6a32-40e9-b782-fd737aa16811",
        "address": "ICD Brookfield Place ,DIFC ,120109 ,",
        "phone": "97143173000 / 971504465229",
        "email": "DubaiLAD@akingump.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9ff29eab-adb8-40f9-ab84-216e01a381e4",
    "firmName": "Akin Gump Strauss Hauer & Feld LLP",
    "registrationNumber": "L-04145",
    "licenseIssueDate": "06/25/2018 00:00:00",
    "licenseExpiryDate": "06/23/2026 00:00:00"
  },
  {
    "id": "fc04faf2-ff39-4a2b-807f-f5943b74f6c6",
    "slug": "nicola-renwick",
    "name": "NICOLA JANE RENWICK",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nicola Renwick",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fc04faf2-ff39-4a2b-807f-f5943b74f6c6",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-00242",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "fba102cc-8193-44f5-a17b-c1d1daa169a4",
    "slug": "nicolas-alejandro-pieri",
    "name": "NICOLAS ALEJANDRO PIERI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/04/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nicolas Alejandro Pieri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fba102cc-8193-44f5-a17b-c1d1daa169a4",
        "address": "",
        "phone": "97145953601 / 971508728645",
        "email": "Steven.Bainbridge@gtlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b4146aa6-efd1-41d7-819d-49da46353b0b",
    "firmName": "Greenberg Traurig Limited",
    "registrationNumber": "L-05259",
    "licenseIssueDate": "04/07/2022 00:00:00",
    "licenseExpiryDate": "04/06/2026 00:00:00"
  },
  {
    "id": "ca3f3f30-a3b5-4b03-ba86-b8dad2d70232",
    "slug": "nicolas-mansour-richa",
    "name": "NICOLAS MANSOUR RICHA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/05/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nicolas Mansour Richa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ca3f3f30-a3b5-4b03-ba86-b8dad2d70232",
        "address": "الخامس  ,البرج الأخضر  ,خلف فندق موسكو  ,5630 ,Dubai",
        "phone": "97142222888",
        "email": "fayadlaw@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "216ebf72-e55b-4446-b7a6-5c17ba8c9b5d",
    "firmName": "HIKMAT FAYAD AND ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06333",
    "licenseIssueDate": "05/29/2024 00:00:00",
    "licenseExpiryDate": "05/28/2026 00:00:00"
  },
  {
    "id": "4deb155a-91a0-493a-b4a1-62ce94c22a67",
    "slug": "nicole-buncher",
    "name": "NICOLE BUNCHER",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/07/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nicole Buncher",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4deb155a-91a0-493a-b4a1-62ce94c22a67",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-06420",
    "licenseIssueDate": "07/09/2024 00:00:00",
    "licenseExpiryDate": "07/08/2026 00:00:00"
  },
  {
    "id": "846d3819-196b-4fe5-8bf2-7072f477e8c2",
    "slug": "nicole-jamie-leahy",
    "name": "NICOLE JAMIE LEAHY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/07/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nicole Jamie Leahy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_846d3819-196b-4fe5-8bf2-7072f477e8c2",
        "address": "Office 1A ,Silver Tower ,DMCC Al Mas Tower ,283149 ,Dubai",
        "phone": "97144542355 / 971564092949",
        "email": "pstone@fenwickelliott.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "45b03212-ac3a-4dbc-8b2d-10fc81273543",
    "firmName": "Fenwick Elliott LLP (DMCC Branch)",
    "registrationNumber": "L-04861",
    "licenseIssueDate": "07/05/2024 00:00:00",
    "licenseExpiryDate": "07/04/2026 00:00:00"
  },
  {
    "id": "4925725b-cba8-4962-b8aa-b3d944361252",
    "slug": "nicole-vanessa-galledari",
    "name": "NICOLE VANESSA GALLEDARI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOVgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/08/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nicole Vanessa Galledari",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4925725b-cba8-4962-b8aa-b3d944361252",
        "address": "Al Fattan Currency House Tower 2 ,DIFC ,507176 ,",
        "phone": "/ 971552009003",
        "email": "Mohammad.AlRasheed@bakermckenzie.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "acd81e81-dead-4f7c-839e-0f2a57897265",
    "firmName": "Baker & Mckenzie LLP",
    "registrationNumber": "L-05956",
    "licenseIssueDate": "08/09/2023 00:00:00",
    "licenseExpiryDate": "08/08/2026 00:00:00"
  },
  {
    "id": "4126c37d-6f18-4e2f-8cc9-facea90c4c97",
    "slug": "nida-shareef-mohammed-shareef",
    "name": "Nida Shareef Mohammed Shareef",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/09/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nida Shareef Mohammed Shareef",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4126c37d-6f18-4e2f-8cc9-facea90c4c97",
        "address": "Burj Daman ,Dubai International Financial Center ,213241 ,",
        "phone": "97144549586 / 971564189768",
        "email": "darrenaharris123@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3cb06a05-1ad1-4487-9624-c2b716bfd2a7",
    "firmName": "Gateley UK LLP",
    "registrationNumber": "L-06873",
    "licenseIssueDate": "07/09/2025 00:00:00",
    "licenseExpiryDate": "07/08/2026 00:00:00"
  },
  {
    "id": "8fdc0770-2225-458e-a271-9452ce65c4a0",
    "slug": "nigel-hartridge",
    "name": "NIGEL TIMOTHY HARTRIDGE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Commercial Companies"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/10/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nigel Hartridge",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8fdc0770-2225-458e-a271-9452ce65c4a0",
        "address": "Central Park Towers ,507120 ,",
        "phone": "97143200940 / 971502397176",
        "email": "lsahbani@lpalaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "4c158c98-1a29-48da-ade1-54e60bfd5b78",
    "firmName": "LPA (Middle East) LTD",
    "registrationNumber": "L-00983",
    "licenseIssueDate": "10/16/2011 00:00:00",
    "licenseExpiryDate": "10/07/2026 00:00:00"
  },
  {
    "id": "1bc2e6c9-cd18-4bf0-8000-7fd1fe2791df",
    "slug": "niharika-sahni",
    "name": "NIHARIKA SAHNI PAWAN KUMAR SAHNI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/08/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Niharika Sahni",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1bc2e6c9-cd18-4bf0-8000-7fd1fe2791df",
        "address": "6 ,Office Nos. 603, 604 & 605, Level 6, Burj Daman ,Dubai International Financial Centre ,506555 ,Dubai",
        "phone": "97143506400 / 971504654755",
        "email": "r.hickman@aglaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8690f7d5-6b96-4649-9589-71303f2c2707",
    "firmName": "Addleshaw Goddard (Middle East) LLP",
    "registrationNumber": "L-05945",
    "licenseIssueDate": "08/02/2023 00:00:00",
    "licenseExpiryDate": "08/01/2026 00:00:00"
  },
  {
    "id": "7d7116b9-2266-4eb9-ba35-6bd94335f599",
    "slug": "nikhat-sardar",
    "name": "NIKHAT SARDAR KHAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Cases and Proceedings before Dubai International Financial Centre",
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Civil Transactions-Construction and Contracts for Services",
      "Civil Transactions-Ownership & Title",
      "Civil Transactions-HR & Employee Affairs",
      "Commercial Transactions-Commercial Mortgage",
      "Personal Status-Custody & Alimony",
      "Commercial Transactions-Bankruptcy",
      "Criminal Law-Hate crimes",
      "Civil Transactions-Tenancy",
      "Commercial Transactions-Unfair competition",
      "Criminal Law-Crimes against persons",
      "Commercial Transactions-Commercial Companies",
      "Commercial Transactions-Banking Operations",
      "Personal Status-Legal Capacity & Guardianship",
      "Criminal Law-Drug Crimes",
      "Civil Transactions-Sale",
      "Proceedings-Cases and Proceedings before arbitral tribunals and other alternative dispute resolution bodies",
      "Personal Status-Marriage & Divorce",
      "Personal Status-Child Abuse & Abduction",
      "Civil Transactions-Compensation",
      "Commercial Transactions-Stock",
      "Criminal Law-Crimes against properties",
      "Commercial Transactions-E-Commerce",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/09/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nikhat Sardar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7d7116b9-2266-4eb9-ba35-6bd94335f599",
        "address": "",
        "phone": "97142955388 / 971507739863",
        "email": "arhilal@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "364483f1-f3e9-4475-a7de-733d3e03062c",
    "firmName": "HILAL & ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01866",
    "licenseIssueDate": "09/29/2011 00:00:00",
    "licenseExpiryDate": "09/20/2026 00:00:00"
  },
  {
    "id": "a6db7b4d-4f50-4c3f-a021-8c32f3a0203d",
    "slug": "nikita-anilkumar-patel",
    "name": "NIKITA ANILKUMAR PATEL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/01/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nikita Anilkumar Patel",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a6db7b4d-4f50-4c3f-a021-8c32f3a0203d",
        "address": "",
        "phone": "97143025100 / 971501501837",
        "email": "ccairns@trowers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "976857f5-9092-43cf-987d-bfa794a3fa51",
    "firmName": "Trowers & Hamlins LLP",
    "registrationNumber": "L-02166",
    "licenseIssueDate": "01/21/2014 00:00:00",
    "licenseExpiryDate": "01/14/2026 00:00:00"
  },
  {
    "id": "b1cbe5d1-250d-43f1-8a87-7c9244e97655",
    "slug": "nikita-manro",
    "name": "NIKITA MANRO",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/10/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nikita Manro",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b1cbe5d1-250d-43f1-8a87-7c9244e97655",
        "address": "",
        "phone": "97143093222 / 971566651954",
        "email": "melissa.murray@twobirds.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3e1526e6-4c8d-4b6f-985f-ea05e9f99bcb",
    "firmName": "Bird & Bird (MEA) LLP",
    "registrationNumber": "L-06044",
    "licenseIssueDate": "10/18/2023 00:00:00",
    "licenseExpiryDate": "10/17/2026 00:00:00"
  },
  {
    "id": "266b6478-0cc1-4a21-9304-ae0e9f9eef7d",
    "slug": "nikita-sinitsin",
    "name": "NIKITA SINITSIN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/11/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nikita Sinitsin",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_266b6478-0cc1-4a21-9304-ae0e9f9eef7d",
        "address": "",
        "phone": "/ 971527856097",
        "email": "roman_zhavner@epamlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e2c7ecee-1913-48a7-a833-a10d08f984f4",
    "firmName": "EPAM Legal LLC",
    "registrationNumber": "L-06097",
    "licenseIssueDate": "11/22/2023 00:00:00",
    "licenseExpiryDate": "11/21/2025 00:00:00"
  },
  {
    "id": "a7bfa7d6-0803-49bd-8d96-8d5dead22b94",
    "slug": "nikolai-budnetskii",
    "name": "NIKOLAI BUDNETSKII",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/11/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nikolai Budnetskii",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a7bfa7d6-0803-49bd-8d96-8d5dead22b94",
        "address": "الطابق 14  ,برج 48 جيت  ,محطة مترو دبي  ,413633 ,Dubai",
        "phone": "97144412031",
        "email": "courts@adglegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4287f048-dc0c-4d51-9e0c-0c23356040ee",
    "firmName": "MOHAMMED AL DAHBASHI ADVOCATES",
    "registrationNumber": "L-06079",
    "licenseIssueDate": "11/06/2023 00:00:00",
    "licenseExpiryDate": "11/05/2025 00:00:00"
  },
  {
    "id": "8617cbc9-1b21-4910-ab7d-437df02d9141",
    "slug": "nikolai-riashin",
    "name": "NIKOLAI RIASHIN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/12/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nikolai Riashin",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8617cbc9-1b21-4910-ab7d-437df02d9141",
        "address": "ICD Brookfield Place ,DIFC ,120109 ,",
        "phone": "97143173000 / 971504465229",
        "email": "DubaiLAD@akingump.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9ff29eab-adb8-40f9-ab84-216e01a381e4",
    "firmName": "Akin Gump Strauss Hauer & Feld LLP",
    "registrationNumber": "L-05651",
    "licenseIssueDate": "12/14/2022 00:00:00",
    "licenseExpiryDate": "12/13/2025 00:00:00"
  },
  {
    "id": "2e836af0-2d1c-46e6-9306-96a82006fced",
    "slug": "nikolas-karl-colbridge",
    "name": "NIKOLAS KARL COLBRIDGE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/07/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nikolas Karl Colbridge",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2e836af0-2d1c-46e6-9306-96a82006fced",
        "address": "",
        "phone": "97144020800 / 971566830829",
        "email": "dean.ryburn@dentons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dfe13b7e-6625-45fd-ad63-9ee83af41194",
    "firmName": "Dentons & Co Dubai Branch-DED",
    "registrationNumber": "L-06910",
    "licenseIssueDate": "07/30/2025 00:00:00",
    "licenseExpiryDate": "07/29/2026 00:00:00"
  },
  {
    "id": "aa0f4f2d-f5b8-44a4-93ff-5f0dfe7eefcf",
    "slug": "nil-acar-ayanlar",
    "name": "NIL ACAR AYANLAR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/02/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: NIL ACAR AYANLAR",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_aa0f4f2d-f5b8-44a4-93ff-5f0dfe7eefcf",
        "address": "",
        "phone": "97143685555",
        "email": "maisa.maarouf@bsabh.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8afa232f-52ff-4dad-82c3-9a04d66eb853",
    "firmName": "B S A AHMED BIN HAZEEM & ASSOCIATES LLP - DIFC",
    "registrationNumber": "L-05561",
    "licenseIssueDate": "02/20/2025 00:00:00",
    "licenseExpiryDate": "02/19/2026 00:00:00"
  },
  {
    "id": "aaf411d0-e135-4af1-aec4-7a3a7079951f",
    "slug": "nileena-susan-alexander-prasad-alexander-george",
    "name": "NILEENA SUSAN ALEXANDER PRASAD ALEXANDER GEORGE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/09/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nileena Susan Alexander Prasad Alexander George",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_aaf411d0-e135-4af1-aec4-7a3a7079951f",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-06925",
    "licenseIssueDate": "08/05/2025 00:00:00",
    "licenseExpiryDate": "08/04/2026 00:00:00"
  },
  {
    "id": "8420db3c-2821-4d05-b465-ec3cdab8dc2a",
    "slug": "nils-eric-de-wolff",
    "name": "NILS ERIC DE WOLFF",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBORQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/05/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nils Eric De Wolff",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8420db3c-2821-4d05-b465-ec3cdab8dc2a",
        "address": "",
        "phone": "97145953601 / 971508728645",
        "email": "Steven.Bainbridge@gtlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b4146aa6-efd1-41d7-819d-49da46353b0b",
    "firmName": "Greenberg Traurig Limited",
    "registrationNumber": "L-04408",
    "licenseIssueDate": "05/19/2019 00:00:00",
    "licenseExpiryDate": "05/18/2026 00:00:00"
  },
  {
    "id": "7772d197-351c-435f-b225-f29c3389f90e",
    "slug": "nima-fath-ordoubadi",
    "name": "Nima Fath- Ordoubadi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBORgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nima Fath- Ordoubadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7772d197-351c-435f-b225-f29c3389f90e",
        "address": "",
        "phone": "97144478700 / 971528553200",
        "email": "Thomas.Wilson@squirepb.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "85be541a-c87f-45a9-a321-d90abd6b7298",
    "firmName": "Squire Patton Boggs (MEA) LLP",
    "registrationNumber": "L-01471",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "618e8e73-fd89-4e6f-8825-e1cce72b72ca",
    "slug": "nima-michael-moshggoo",
    "name": "NIMA MICHAEL MOSHGGOO",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/06/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nima Michael Moshggoo",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_618e8e73-fd89-4e6f-8825-e1cce72b72ca",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-04960",
    "licenseIssueDate": "06/07/2021 00:00:00",
    "licenseExpiryDate": "06/06/2026 00:00:00"
  },
  {
    "id": "f904edd4-1bf8-4521-ac54-e1fedec3573f",
    "slug": "nimi-mariam-sam",
    "name": "NIMI MARIAM SAM SAMUEL OOMMEN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/09/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nimi Mariam Sam",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f904edd4-1bf8-4521-ac54-e1fedec3573f",
        "address": "ABDELAZIZ MOHAMED ABDELGHANI AL KHAMIRI AL ALI ,3 ,DUBAI SUPREME COURT COMPLEX ,DUBAI COURT ,128334 ,Dubai",
        "phone": "97145519341 / 971505788557",
        "email": "info@raalc.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "73e54a15-f797-4e91-a501-ef988d8f8bf8",
    "firmName": "ABDELAZIZ AL KHAMIRI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06943",
    "licenseIssueDate": "08/22/2025 00:00:00",
    "licenseExpiryDate": "08/21/2026 00:00:00"
  },
  {
    "id": "edaa0983-a1b5-4136-b4b4-826514837939",
    "slug": "nina-claudia-fischer",
    "name": "NINA CLAUDIA FISCHER",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/02/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nina Claudia Fischer",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_edaa0983-a1b5-4136-b4b4-826514837939",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506688 ,Dubai",
        "phone": "97147096600 / 971503556811",
        "email": "muneer.khan@simmons-simmons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d1725ca7-06ac-41b2-8d7b-a6e60665b73d",
    "firmName": "Simmons & Simmons (Middle East) LLP-DIFC",
    "registrationNumber": "L-04649",
    "licenseIssueDate": "02/20/2020 00:00:00",
    "licenseExpiryDate": "02/19/2026 00:00:00"
  },
  {
    "id": "4ef3b94b-fe16-4c6f-a734-a1490d274acb",
    "slug": "nina-gogic",
    "name": "NINA GOGIC",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBORwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/12/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nina Gogic",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4ef3b94b-fe16-4c6f-a734-a1490d274acb",
        "address": "",
        "phone": "97142472100 / 971509224336",
        "email": "bhaley@cov.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "65a2e90a-6978-4292-b3f1-ecbebedd7b9a",
    "firmName": "Covington & Burling LLP (Middle East)",
    "registrationNumber": "L-02794",
    "licenseIssueDate": "05/30/2025 00:00:00",
    "licenseExpiryDate": "05/29/2026 00:00:00"
  },
  {
    "id": "ba4fddca-b335-4ca0-8a18-ea8c56db47a7",
    "slug": "nisha-raman-prabhakaran",
    "name": "NISHA RAMAN PRABHAKARAN RAMAN PRABHAKARAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nisha Raman Prabhakaran",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ba4fddca-b335-4ca0-8a18-ea8c56db47a7",
        "address": "",
        "phone": "97142664424",
        "email": "nagm009@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d9e56be7-6c69-408a-9a66-04ced959910a",
    "firmName": "ABDUL RAHMAN AL MOTAWA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02350",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "e64513eb-1fbf-4771-ac9a-165766c85375",
    "slug": "nishka-bharat-asarpota",
    "name": "NISHKA BHARAT ASARPOTA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/03/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nishka Bharat Asarpota",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e64513eb-1fbf-4771-ac9a-165766c85375",
        "address": "",
        "phone": "97143897000 / 971506553198",
        "email": "nasseralikhasawneh@eversheds-sutherland.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "74a21d43-41d8-480a-a6af-6939b7c98a95",
    "firmName": "Eversheds Sutherland (International LLP) Dubai Branch",
    "registrationNumber": "L-06722",
    "licenseIssueDate": "03/26/2025 00:00:00",
    "licenseExpiryDate": "03/25/2026 00:00:00"
  },
  {
    "id": "c35293f8-920d-4ecd-8e5e-3d3c83699266",
    "slug": "nita-maru",
    "name": "NITABEN MARU",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nita Maru",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c35293f8-920d-4ecd-8e5e-3d3c83699266",
        "address": "",
        "phone": "97144484284 / 971559776272",
        "email": "nita@willsuae.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "272328d6-db51-4b0e-b8bc-5297a958940d",
    "firmName": "TWS Legal Consultants DMCC",
    "registrationNumber": "L-01012",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "3a2ff37b-a29c-4924-b914-327ccf3894a9",
    "slug": "nizam-nseir",
    "name": "NIZAM NICOLAS NSEIR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Personal Status-Wills",
      "Commercial Transactions-Commercial Contracts",
      "Civil Transactions-Arbitration",
      "Proceedings-Cases and Proceedings before arbitral tribunals and other alternative dispute resolution bodies",
      "Criminal Law-Crimes against properties"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/11/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nizam Nseir",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3a2ff37b-a29c-4924-b914-327ccf3894a9",
        "address": "",
        "phone": "97142552220",
        "email": "almaazmi.office@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e04d8a88-3378-40c8-a33a-b5e26a0c8507",
    "firmName": "ABDELRAHMAN AL MAAZMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02300",
    "licenseIssueDate": "11/26/2013 00:00:00",
    "licenseExpiryDate": "11/19/2025 00:00:00"
  },
  {
    "id": "90e03d52-40ee-49b4-bd61-3bdb294dd73e",
    "slug": "noff-al-khafaji",
    "name": "Noff Al Khafaji",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/01/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Noff Al Khafaji",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_90e03d52-40ee-49b4-bd61-3bdb294dd73e",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02794",
    "licenseIssueDate": "01/01/2015 00:00:00",
    "licenseExpiryDate": "12/26/2025 00:00:00"
  },
  {
    "id": "0c5d6e75-a903-4798-affc-a5b76f849ecc",
    "slug": "noha-khaled-mansour-abdelsalam-elgendy",
    "name": "Noha Khaled Mansour Abdelsalam Elgendy",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/06/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Noha Khaled Mansour Abdelsalam Elgendy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0c5d6e75-a903-4798-affc-a5b76f849ecc",
        "address": "0 ,ICD Brookfield Place Level 13 ,Trade Centre ,506569 ,Dubai",
        "phone": "97145099100 / 971501006965",
        "email": "menahr@freshfields.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "970f6246-e737-41a7-9c6c-5aa5b8335d45",
    "firmName": "Freshfields LLP DIFC",
    "registrationNumber": "L-05365",
    "licenseIssueDate": "07/06/2022 00:00:00",
    "licenseExpiryDate": "07/05/2026 00:00:00"
  },
  {
    "id": "8018391f-bf7d-4b56-97e9-2ce6f44793f9",
    "slug": "nomaan-raja",
    "name": "Nomaan Raja",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nomaan Raja",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8018391f-bf7d-4b56-97e9-2ce6f44793f9",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506698 ,Dubai",
        "phone": "97147046300 / 971507900661",
        "email": "nada.mourad@lw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b2b92ce9-90a4-4e34-ae2f-ae0dc7ca9060",
    "firmName": "Latham & Watkins LLP",
    "registrationNumber": "L-00887",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "081fad09-573a-41dd-8588-91804952e590",
    "slug": "noor-al-baya",
    "name": "Noor Al-Baya",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/08/2021",
    "licenseStatus": "active",
    "licenseExpiry": "2022-08-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Noor Al-Baya",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_081fad09-573a-41dd-8588-91804952e590",
        "address": "0 ,ICD Brookfield Place Level 13 ,Trade Centre ,506569 ,Dubai",
        "phone": "97145099100 / 971501006965",
        "email": "menahr@freshfields.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "970f6246-e737-41a7-9c6c-5aa5b8335d45",
    "firmName": "Freshfields LLP DIFC",
    "registrationNumber": "L-05009",
    "licenseIssueDate": "08/09/2021 00:00:00",
    "licenseExpiryDate": "08/08/2026 00:00:00"
  },
  {
    "id": "b1960b16-d7fc-498e-b641-a239ecbedae6",
    "slug": "noor-hael-fayez-ezat-alwari",
    "name": "Noor Hael Fayez Ezat Alwari",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/01/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Noor Hael Fayez Ezat Alwari",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b1960b16-d7fc-498e-b641-a239ecbedae6",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06664",
    "licenseIssueDate": "01/23/2025 00:00:00",
    "licenseExpiryDate": "01/22/2026 00:00:00"
  },
  {
    "id": "16c64cac-934c-41bf-8d2a-f094db8bf562",
    "slug": "nooree-moola",
    "name": "Nooree Moola",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/20/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nooree Moola",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_16c64cac-934c-41bf-8d2a-f094db8bf562",
        "address": "",
        "phone": "97143184600 / 971504468184",
        "email": "melaraby@gibsondunn.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c9d2c9d0-6e43-4253-a75d-cdeb400f8d8e",
    "firmName": "Gibson Dunn & Crutcher LLP",
    "registrationNumber": "L-02519",
    "licenseIssueDate": "05/20/2014 00:00:00",
    "licenseExpiryDate": "05/14/2026 00:00:00"
  },
  {
    "id": "bfb62e90-1de0-4f5c-bc35-c604403a8a43",
    "slug": "noorjahan-begum-goffar",
    "name": "NOORJAHAN BEGUM GOFFAR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/10/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Noorjahan Begum Goffar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bfb62e90-1de0-4f5c-bc35-c604403a8a43",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-06548",
    "licenseIssueDate": "10/25/2024 00:00:00",
    "licenseExpiryDate": "10/24/2026 00:00:00"
  },
  {
    "id": "a5bdadf9-d247-4b44-ac8b-f6b7f34f68e8",
    "slug": "nootash-keyhani",
    "name": "Nootash Keyhani",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/07/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nootash Keyhani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a5bdadf9-d247-4b44-ac8b-f6b7f34f68e8",
        "address": "",
        "phone": "97143093222 / 971566651954",
        "email": "melissa.murray@twobirds.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3e1526e6-4c8d-4b6f-985f-ea05e9f99bcb",
    "firmName": "Bird & Bird (MEA) LLP",
    "registrationNumber": "L-05084",
    "licenseIssueDate": "01/07/2025 00:00:00",
    "licenseExpiryDate": "01/06/2026 00:00:00"
  },
  {
    "id": "7d1033ea-20fc-4d10-8ca0-ae90992b1e48",
    "slug": "nora-almuhamad",
    "name": "Nora Almuhamad",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/25/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nora Almuhamad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7d1033ea-20fc-4d10-8ca0-ae90992b1e48",
        "address": "Burj Daman ,Dubai International Financial Center ,213241 ,",
        "phone": "97144549586 / 971564189768",
        "email": "darrenaharris123@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3cb06a05-1ad1-4487-9624-c2b716bfd2a7",
    "firmName": "Gateley UK LLP",
    "registrationNumber": "L-03902",
    "licenseIssueDate": "10/25/2017 00:00:00",
    "licenseExpiryDate": "10/22/2025 00:00:00"
  },
  {
    "id": "a67f6ccf-f483-4181-9dc2-4e480601e741",
    "slug": "noran-al-mekhlafi",
    "name": "NORAN AL MEKHLAFI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/11/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Noran Al Mekhlafi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a67f6ccf-f483-4181-9dc2-4e480601e741",
        "address": "",
        "phone": "97143303900 / 971561753537",
        "email": "christopher@afridi-angell.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "30ce50dc-01a6-499d-8ace-3f807ddcb08d",
    "firmName": "Afridi & Angell-DED",
    "registrationNumber": "L-05093",
    "licenseIssueDate": "11/08/2021 00:00:00",
    "licenseExpiryDate": "11/07/2025 00:00:00"
  },
  {
    "id": "2ecaf837-81c9-4915-8435-753c313f1d93",
    "slug": "norlisa-hanlon-rosslee",
    "name": "Norlisa Hanlon Rosslee",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/19/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Norlisa Hanlon Rosslee",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2ecaf837-81c9-4915-8435-753c313f1d93",
        "address": "Burj Daman ,Dubai International Financial Center ,213241 ,",
        "phone": "97144549586 / 971564189768",
        "email": "darrenaharris123@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3cb06a05-1ad1-4487-9624-c2b716bfd2a7",
    "firmName": "Gateley UK LLP",
    "registrationNumber": "L-05288",
    "licenseIssueDate": "04/19/2022 00:00:00",
    "licenseExpiryDate": "04/18/2026 00:00:00"
  },
  {
    "id": "f9039f80-e30f-45c9-8b22-fcf4a21e691f",
    "slug": "nour-abi-rached",
    "name": "NOUR ABI RACHED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/03/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nour Abi Rached",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f9039f80-e30f-45c9-8b22-fcf4a21e691f",
        "address": "THE OFFICES 1 ,DWTC ,115580 ,",
        "phone": "97143739700 / 971501148248",
        "email": "nitesh.pradhan@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "361fdc64-6b6f-4f37-abca-c52af8473b84",
    "firmName": "Pinsent Masons  LLP (DWTCA Branch)",
    "registrationNumber": "L-06735",
    "licenseIssueDate": "03/19/2025 00:00:00",
    "licenseExpiryDate": "03/18/2026 00:00:00"
  },
  {
    "id": "c84648bf-1d69-4297-bf1c-2d2c7718c7f0",
    "slug": "nour-gemayel",
    "name": "NOUR GHASSAN GEMAYEL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBORwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/03/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nour Gemayel",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c84648bf-1d69-4297-bf1c-2d2c7718c7f0",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-04612",
    "licenseIssueDate": "03/04/2020 00:00:00",
    "licenseExpiryDate": "03/03/2026 00:00:00"
  },
  {
    "id": "37e9b094-135c-4b29-8c9d-4dff0684479d",
    "slug": "nour-mary-barakat",
    "name": "NOUR MARY FADI BARAKAT",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/11/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nour Mary Barakat",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_37e9b094-135c-4b29-8c9d-4dff0684479d",
        "address": "1 ,ICD Brookfield Place ,Dubai International Financial Centre ,9267 ,Dubai",
        "phone": "97147010975 / 971502977062",
        "email": "chris.sioufi@ae.ey.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "42e536ef-e3d8-4339-8572-657a7f7a0331",
    "firmName": "EY Law LLP",
    "registrationNumber": "L-06081",
    "licenseIssueDate": "11/15/2023 00:00:00",
    "licenseExpiryDate": "11/14/2025 00:00:00"
  },
  {
    "id": "a27e6430-71fc-4296-bfe1-e7486035c3b0",
    "slug": "nour-mhd-bassam-alsgea-ameni",
    "name": "NOUR MHO BASSAM ALSGEA AMENI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/08/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nour Mhd Bassam Alsgea Ameni",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a27e6430-71fc-4296-bfe1-e7486035c3b0",
        "address": "",
        "phone": "97143333386 / 971549916936",
        "email": "info@mtaadv.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "466f3ad4-73e1-44db-b8ec-b01e829d77c4",
    "firmName": "MOHAMMAD ALLINJAWI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05973",
    "licenseIssueDate": "08/23/2023 00:00:00",
    "licenseExpiryDate": "08/22/2026 00:00:00"
  },
  {
    "id": "cc06220d-af2c-4cec-a9e1-0382c429aa30",
    "slug": "nour-usama-fuad-steityeh",
    "name": "NOUR USAMA FUAD STEITYEH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOVQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/05/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nour Usama Fuad Steityeh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cc06220d-af2c-4cec-a9e1-0382c429aa30",
        "address": "21 ,Rolex Tower ,Emirates Grand Hotel ,94334 ,Dubai",
        "phone": "97143277772 / 97145584900",
        "email": "info@globaladvocates.net",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9b42810f-1d55-4aea-ac4a-7d9d1b25ac08",
    "firmName": "GLOBAL ADVOCACY & LEGAL COUNSEL",
    "registrationNumber": "L-05345",
    "licenseIssueDate": "06/01/2022 00:00:00",
    "licenseExpiryDate": "05/31/2026 00:00:00"
  },
  {
    "id": "7062f600-204e-4f47-9d75-481a22a8c689",
    "slug": "nourchene-cherif",
    "name": "NOURCHENE CHERIF",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/12/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nourchene Cherif",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7062f600-204e-4f47-9d75-481a22a8c689",
        "address": "",
        "phone": "97144230555 / 971504788443",
        "email": "yah@hfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c462c65e-185a-4e81-8425-a87e3a2b6842",
    "firmName": "Holman Fenwick Willan Middle East LLP",
    "registrationNumber": "L-05621",
    "licenseIssueDate": "12/07/2022 00:00:00",
    "licenseExpiryDate": "12/06/2025 00:00:00"
  },
  {
    "id": "2ab3f6d1-697e-4b77-a27b-79c1ca4bc36c",
    "slug": "noureldin-adel-mohamed-sadek-ghaleb",
    "name": "NOURELDIN ADEL MOHAMED SADEK GHALEB",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/08/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Noureldin Adel Mohamed Sadek Ghaleb",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2ab3f6d1-697e-4b77-a27b-79c1ca4bc36c",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-05014",
    "licenseIssueDate": "08/16/2021 00:00:00",
    "licenseExpiryDate": "08/15/2026 00:00:00"
  },
  {
    "id": "0acaeeb1-3395-4c93-b84a-98446412513d",
    "slug": "nouria-rashid-hammeda",
    "name": "Nouria Rashid Hammeda",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/09/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nouria Rashid Hammeda",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0acaeeb1-3395-4c93-b84a-98446412513d",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-06497",
    "licenseIssueDate": "09/25/2024 00:00:00",
    "licenseExpiryDate": "09/24/2026 00:00:00"
  },
  {
    "id": "3d2f115c-2450-4eec-a9c5-e82f75041ad3",
    "slug": "nouruddin-alkheir-mohamed",
    "name": "NOURUDDIN ALKHEIR AHMED MOHAMED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/12/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nouruddin Alkheir Mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3d2f115c-2450-4eec-a9c5-e82f75041ad3",
        "address": "",
        "phone": "97143968700",
        "email": "admin@haklegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ee61dd8d-28a2-4c21-9a46-a87635463b13",
    "firmName": "HEND ALKTEBI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02726",
    "licenseIssueDate": "12/31/2013 00:00:00",
    "licenseExpiryDate": "12/24/2025 00:00:00"
  },
  {
    "id": "99d8d07b-2407-43c3-9f1d-e374642408c5",
    "slug": "noushin-mohammadreza-rahmannejadi",
    "name": "NOUSHIN RAHMANNE JADI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/01/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Noushin Mohammadreza Rahmannejadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_99d8d07b-2407-43c3-9f1d-e374642408c5",
        "address": "O-4801, O-4901 ,Burj al Salam Office Tower ,H Hotel ,111801 ,Dubai",
        "phone": "97143544444",
        "email": "administration@horizlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4e25fb39-6659-44f0-bc8b-3ff0f067beb0",
    "firmName": "HORIZONS & CO - LAW FIRM",
    "registrationNumber": "L-03971",
    "licenseIssueDate": "01/16/2018 00:00:00",
    "licenseExpiryDate": "01/13/2025 00:00:00"
  },
  {
    "id": "73d39706-955e-4325-8d04-f12abf9a31e8",
    "slug": "nuoyu-fang",
    "name": "NUOYU FANG",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBORgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/08/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nuoyu Fang",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_73d39706-955e-4325-8d04-f12abf9a31e8",
        "address": "THE OFFICES 1 ,DWTC ,115580 ,",
        "phone": "97143739700 / 971501148248",
        "email": "nitesh.pradhan@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "361fdc64-6b6f-4f37-abca-c52af8473b84",
    "firmName": "Pinsent Masons  LLP (DWTCA Branch)",
    "registrationNumber": "L-06462",
    "licenseIssueDate": "08/21/2024 00:00:00",
    "licenseExpiryDate": "08/20/2026 00:00:00"
  },
  {
    "id": "d1002bee-020f-4c4b-a4df-038cca89f40c",
    "slug": "obaid-basit-sheikh-abdul-basit",
    "name": "OBAID BASIT SHEIKH ABDUL BASIT",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/05/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Obaid Basit Sheikh Abdul Basit",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d1002bee-020f-4c4b-a4df-038cca89f40c",
        "address": "6F 603, 605, 7F 704 ,Crystal Tower ,Dubai Mall ,117538 ,Dubai",
        "phone": "97146098700",
        "email": "pro@miolawfirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "417f90a1-03be-4dab-8eea-1bba7e16f536",
    "firmName": "ABU BAKER SALEM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06347",
    "licenseIssueDate": "05/31/2024 00:00:00",
    "licenseExpiryDate": "05/30/2026 00:00:00"
  },
  {
    "id": "c3bfebb4-cbcc-44ac-96b7-7fbf1244bf14",
    "slug": "ola-zein-el-dine",
    "name": "OLA ZEIN EL DINE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPWgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/01/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: OLA ZEIN EL DINE",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c3bfebb4-cbcc-44ac-96b7-7fbf1244bf14",
        "address": "",
        "phone": "97150399980 / 971501547188",
        "email": "advocatesaraalsaedi@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c1be7ace-26d4-45ed-8292-e5992286f1ef",
    "firmName": "Sara Alsaedi Advocates and Legal Consultants",
    "registrationNumber": "L-05685",
    "licenseIssueDate": "01/04/2023 00:00:00",
    "licenseExpiryDate": "01/03/2026 00:00:00"
  },
  {
    "id": "d41aaaaf-cffd-4a66-9008-718996540c3c",
    "slug": "olaloye-odunayo-oyedotun",
    "name": "Olaloye Odunayo Oyedotun",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/07/2025",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Olaloye Odunayo Oyedotun",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d41aaaaf-cffd-4a66-9008-718996540c3c",
        "address": "",
        "phone": "97104309100 / 971564013758",
        "email": "c.royle@taylorwessing.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d51b6f43-8c62-486f-a1ab-6ee3b87c8006",
    "firmName": "Taylor Wessing LLP (Dubai Branch)",
    "registrationNumber": "L-06905",
    "licenseIssueDate": "07/30/2025 00:00:00",
    "licenseExpiryDate": "07/29/2026 00:00:00"
  },
  {
    "id": "b5d81b60-efa5-4569-9bc8-ed972c8531f2",
    "slug": "olawale-lawal-sanni",
    "name": "OLAWALE LAWAL SANNI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/02/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Olawale Lawal Sanni",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b5d81b60-efa5-4569-9bc8-ed972c8531f2",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-04849",
    "licenseIssueDate": "02/15/2021 00:00:00",
    "licenseExpiryDate": "02/14/2026 00:00:00"
  },
  {
    "id": "950a29a9-c2f0-4716-bb90-ba4197a9c933",
    "slug": "olga-nelyubova",
    "name": "OLGA NELYUBOVA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/07/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Olga Nelyubova",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_950a29a9-c2f0-4716-bb90-ba4197a9c933",
        "address": "ICD Brookfield Place ,DIFC ,506516 ,",
        "phone": "97143695800 / 971505526206",
        "email": "scott.campbell@linklaters.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5cec94c0-0649-43b6-a2be-ab17ff422bce",
    "firmName": "LinkLaters LLP",
    "registrationNumber": "L-05419",
    "licenseIssueDate": "07/20/2022 00:00:00",
    "licenseExpiryDate": "07/19/2026 00:00:00"
  },
  {
    "id": "9dcefc07-597b-44a8-8c85-99593a4d084e",
    "slug": "oliver-james-francis-stevens",
    "name": "OLIVER JAMES FRANCIS STEVENS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/02/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Oliver James Francis Stevens",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9dcefc07-597b-44a8-8c85-99593a4d084e",
        "address": "6 ,Office Nos. 603, 604 & 605, Level 6, Burj Daman ,Dubai International Financial Centre ,506555 ,Dubai",
        "phone": "97143506400 / 971504654755",
        "email": "r.hickman@aglaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8690f7d5-6b96-4649-9589-71303f2c2707",
    "firmName": "Addleshaw Goddard (Middle East) LLP",
    "registrationNumber": "L-04852",
    "licenseIssueDate": "02/15/2021 00:00:00",
    "licenseExpiryDate": "02/14/2026 00:00:00"
  },
  {
    "id": "3fdcfe20-fad4-4b33-8f9e-d86672e023e6",
    "slug": "oliver-simpson",
    "name": "OLIVER JAMES SIMPSON",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Oliver Simpson",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3fdcfe20-fad4-4b33-8f9e-d86672e023e6",
        "address": "Level 14 ,Burj Daman ,Four Seasons Hotel ,119980 ,Dubai",
        "phone": "97143604070 / 971502450485",
        "email": "Philip.ireland@maples.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "cb7cc285-8538-469a-b075-ef30819bce69",
    "firmName": "Maples & Calder (Dubai) LLP",
    "registrationNumber": "L-00888",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "e16cb99a-b1d6-40c7-a2c7-9152f8fd43c4",
    "slug": "oliver-spence",
    "name": "OLIVER JAMES SPENCE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/03/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Oliver Spence",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e16cb99a-b1d6-40c7-a2c7-9152f8fd43c4",
        "address": "Index Tower ,506548 ,Dubai",
        "phone": "97147096300 / 971506767433",
        "email": "amateen@reedsmith.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b3f87e90-7ce9-4097-82c4-15232365f175",
    "firmName": "Reed Smith LLP",
    "registrationNumber": "L-05236",
    "licenseIssueDate": "03/15/2022 00:00:00",
    "licenseExpiryDate": "03/14/2026 00:00:00"
  },
  {
    "id": "f2823e18-c827-48b7-91d2-da8828caad67",
    "slug": "olivia-margaret-darlington",
    "name": "OLIVIA MARGARET DARLINGTON",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/01/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Olivia Margaret Darlington",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f2823e18-c827-48b7-91d2-da8828caad67",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-04584",
    "licenseIssueDate": "01/08/2020 00:00:00",
    "licenseExpiryDate": "01/07/2026 00:00:00"
  },
  {
    "id": "308cee39-2981-4dd8-bd12-5a8f5b87ea26",
    "slug": "olivia-rose-henshall",
    "name": "OLIVIA ROSE HENSHALL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/05/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Olivia Rose Henshall",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_308cee39-2981-4dd8-bd12-5a8f5b87ea26",
        "address": "THE OFFICES 1 ,DWTC ,115580 ,",
        "phone": "97143739700 / 971501148248",
        "email": "nitesh.pradhan@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "361fdc64-6b6f-4f37-abca-c52af8473b84",
    "firmName": "Pinsent Masons  LLP (DWTCA Branch)",
    "registrationNumber": "L-06762",
    "licenseIssueDate": "05/28/2025 00:00:00",
    "licenseExpiryDate": "05/27/2026 00:00:00"
  },
  {
    "id": "daffcd5f-e099-4d61-b886-c244ebb004ba",
    "slug": "ololade-temilade-odunubi",
    "name": "OLOLADE TEMILADE ODUNUBI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/10/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ololade Temilade Odunubi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_daffcd5f-e099-4d61-b886-c244ebb004ba",
        "address": "Al Fattan Currency House Tower 2 ,DIFC ,507176 ,",
        "phone": "/ 971552009003",
        "email": "Mohammad.AlRasheed@bakermckenzie.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "acd81e81-dead-4f7c-839e-0f2a57897265",
    "firmName": "Baker & Mckenzie LLP",
    "registrationNumber": "L-06058",
    "licenseIssueDate": "10/18/2023 00:00:00",
    "licenseExpiryDate": "10/17/2025 00:00:00"
  },
  {
    "id": "27d7b769-b410-4c93-8b4a-c0f8c2c14ee8",
    "slug": "oluwakorede-eniola-adedokun-atanda",
    "name": "OLUWAKOREDE ENIOLA ADEDOKUN ATANDA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/09/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Oluwakorede Eniola Adedokun Atanda",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_27d7b769-b410-4c93-8b4a-c0f8c2c14ee8",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-06933",
    "licenseIssueDate": "08/14/2025 00:00:00",
    "licenseExpiryDate": "08/13/2026 00:00:00"
  },
  {
    "id": "4ac6812e-0f77-4ea4-90ca-f4104e7880bb",
    "slug": "oluwatomisin-ifeoluwa-mosuro",
    "name": "OLUWATOMISIN IFEOLUWA MOSURO",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/12/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Oluwatomisin Ifeoluwa Mosuro",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4ac6812e-0f77-4ea4-90ca-f4104e7880bb",
        "address": "",
        "phone": "97143121800 / 971566017967",
        "email": "alishia.sullivan@morganlewis.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6eab20d7-8716-4b0a-8710-144d1d951c23",
    "firmName": "Morgan, Lewis & Bockius LLP (dubai Branch)",
    "registrationNumber": "L-04287",
    "licenseIssueDate": "12/19/2018 00:00:00",
    "licenseExpiryDate": "12/17/2025 00:00:00"
  },
  {
    "id": "e1c7cdf4-04fb-4bbc-a5a9-1b6200b0fed1",
    "slug": "omar-abdelhamid-mohamed-hegazy",
    "name": "OMAR ABDELHAMID MOHAMED HEGAZY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/09/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Omar Abdelhamid Mohamed Hegazy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e1c7cdf4-04fb-4bbc-a5a9-1b6200b0fed1",
        "address": "",
        "phone": "97145953601 / 971508728645",
        "email": "Steven.Bainbridge@gtlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b4146aa6-efd1-41d7-819d-49da46353b0b",
    "firmName": "Greenberg Traurig Limited",
    "registrationNumber": "L-05340",
    "licenseIssueDate": "09/28/2023 00:00:00",
    "licenseExpiryDate": "09/27/2026 00:00:00"
  },
  {
    "id": "04415565-3275-4a48-8a17-a0c9687c51f2",
    "slug": "omar-abdelmotleb-mosad-ramadan",
    "name": "OMAR ABDELMOTLEB MOSAD RAMADAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/08/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: OMAR ABDELMOTLEB MOSAD RAMADAN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_04415565-3275-4a48-8a17-a0c9687c51f2",
        "address": "",
        "phone": "97143304477 / 97143304477",
        "email": "admin@os-legal.net",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "1c406a06-cff7-4412-89fa-f6e5d9b647c0",
    "firmName": "KHALID ALSAROOKH ADVOCATES AND LEGAL CONSUTANCY",
    "registrationNumber": "L-05971",
    "licenseIssueDate": "08/09/2023 00:00:00",
    "licenseExpiryDate": "08/08/2026 00:00:00"
  },
  {
    "id": "3eb47539-0386-4530-a3d3-c0411ba5a089",
    "slug": "omar-abdul-hamid-al-arsan",
    "name": "OMAR ABDUL HAMID AL ARSAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/10/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Omar Abdul Hamid Al arsan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3eb47539-0386-4530-a3d3-c0411ba5a089",
        "address": "O-4801, O-4901 ,Burj al Salam Office Tower ,H Hotel ,111801 ,Dubai",
        "phone": "97143544444",
        "email": "administration@horizlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4e25fb39-6659-44f0-bc8b-3ff0f067beb0",
    "firmName": "HORIZONS & CO - LAW FIRM",
    "registrationNumber": "L-04255",
    "licenseIssueDate": "10/29/2018 00:00:00",
    "licenseExpiryDate": "10/26/2025 00:00:00"
  },
  {
    "id": "58179c36-53d0-4d5a-89bd-86d8244e8e69",
    "slug": "omar-ahmad-alsatari",
    "name": "OMAR AHMAD ABED ALKARIM ALSATARI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/09/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Omar Ahmad Alsatari",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_58179c36-53d0-4d5a-89bd-86d8244e8e69",
        "address": "HAMDAN ALSHAMSI ,الطابق الرابع مكتب 401, 406,407 ,بي سكوير 01 ,مجمع دبي سكوير ,116564 ,Dubai",
        "phone": "97143469262",
        "email": "courts@has.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de2c61a6-9d00-457e-ad1d-e73e4e62d9bd",
    "firmName": "HAMDAN ALSHAMSI LAWYER & LEGAL CONSULTANTS",
    "registrationNumber": "L-01584",
    "licenseIssueDate": "09/09/2025 00:00:00",
    "licenseExpiryDate": "09/08/2026 00:00:00"
  },
  {
    "id": "b6e08e63-f716-4157-ad48-45a1634a13ac",
    "slug": "omar-ahmad-ratib-aljuneidi",
    "name": "OMAR AHMAD RATIB ALJUNEIDI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/06/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Omar Ahmad Ratib Aljuneidi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b6e08e63-f716-4157-ad48-45a1634a13ac",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06854",
    "licenseIssueDate": "06/18/2025 00:00:00",
    "licenseExpiryDate": "06/17/2026 00:00:00"
  },
  {
    "id": "3424bab5-b25b-4b54-9c20-65d696a24775",
    "slug": "omar-ahmed-morsy-ruiz",
    "name": "OMAR AHMED MORSY RUIZ",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/10/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Omar Ahmed Morsy Ruiz",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3424bab5-b25b-4b54-9c20-65d696a24775",
        "address": "",
        "phone": "97143184600 / 971504468184",
        "email": "melaraby@gibsondunn.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c9d2c9d0-6e43-4253-a75d-cdeb400f8d8e",
    "firmName": "Gibson Dunn & Crutcher LLP",
    "registrationNumber": "L-04776",
    "licenseIssueDate": "10/21/2020 00:00:00",
    "licenseExpiryDate": "10/20/2025 00:00:00"
  },
  {
    "id": "01b3b68e-a205-47ef-acf5-3cfacad1a3bf",
    "slug": "omar-ahmed-salaheldin-mohamed-abdelbaky",
    "name": "OMAR AHMED SALAHELDIN MOHAMED ABDELBAKY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/01/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Omar Ahmed Salaheldin Mohamed Abdelbaky",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_01b3b68e-a205-47ef-acf5-3cfacad1a3bf",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-06178",
    "licenseIssueDate": "01/24/2024 00:00:00",
    "licenseExpiryDate": "01/23/2026 00:00:00"
  },
  {
    "id": "4a52b657-68ce-402f-85c3-a1707077e650",
    "slug": "omar-al-shomali",
    "name": "OMAR NASSER MOHD AL SHOMALI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/04/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Omar Al-Shomali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4a52b657-68ce-402f-85c3-a1707077e650",
        "address": "",
        "phone": "97143897000 / 971506553198",
        "email": "nasseralikhasawneh@eversheds-sutherland.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "74a21d43-41d8-480a-a6af-6939b7c98a95",
    "firmName": "Eversheds Sutherland (International LLP) Dubai Branch",
    "registrationNumber": "L-00859",
    "licenseIssueDate": "04/02/2017 00:00:00",
    "licenseExpiryDate": "03/29/2026 00:00:00"
  },
  {
    "id": "af61fa4e-6f6b-4c20-8b07-6aae0a5f0da3",
    "slug": "omar-anwar",
    "name": "OMAR ANWAR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/07/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Omar Anwar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_af61fa4e-6f6b-4c20-8b07-6aae0a5f0da3",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-06426",
    "licenseIssueDate": "07/24/2024 00:00:00",
    "licenseExpiryDate": "07/23/2026 00:00:00"
  },
  {
    "id": "0fce32f3-3dc1-474f-844e-44ca1095fbc7",
    "slug": "omar-el-sayed",
    "name": "OMAR ALAA EL DIN ALY MOHAMMED EL SAYED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Omar El Sayed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0fce32f3-3dc1-474f-844e-44ca1095fbc7",
        "address": "ICD Brookfield Place ,DIFC ,506516 ,",
        "phone": "97143695800 / 971505526206",
        "email": "scott.campbell@linklaters.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5cec94c0-0649-43b6-a2be-ab17ff422bce",
    "firmName": "LinkLaters LLP",
    "registrationNumber": "L-00722",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "c5eaa6c7-2a4e-4fc0-8982-86532f6746e1",
    "slug": "omar-emad-khattab",
    "name": "OMAR EMAD MAHMOUD KHATTAB",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Cases and Proceedings before Dubai International Financial Centre",
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Civil Transactions-POA & Sponsorship",
      "Civil Transactions-Insurance",
      "Civil Transactions-Construction and Contracts for Services",
      "Civil Transactions-Ownership & Title",
      "Criminal Law-Family Crimes",
      "Commercial Transactions-Commercial Contracts",
      "Commercial Transactions-Bankruptcy",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Civil Transactions-Arbitration",
      "Criminal Law-Hate crimes",
      "Civil Transactions-Tenancy",
      "Commercial Transactions-Unfair competition",
      "Criminal Law-Crimes against persons",
      "Commercial Transactions-Banking Operations",
      "Civil Transactions-Labor & Workers",
      "Civil Transactions-Sale",
      "Proceedings-Cases and Proceedings before arbitral tribunals and other alternative dispute resolution bodies",
      "Personal Status-Child Abuse & Abduction",
      "Civil Transactions-Compensation",
      "Criminal Law-Crimes against properties",
      "Criminal Law-Cybercrimes",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/08/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Omar Emad Khattab",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c5eaa6c7-2a4e-4fc0-8982-86532f6746e1",
        "address": "ICD Brookfield Place ,Za'abeel 2 ,103747 ,",
        "phone": "97143696300 / 971506008159",
        "email": "mohammed.paracha@nortonrosefulbright.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c4aaee93-0ec4-4982-9a48-a23699492056",
    "firmName": "Norton Rose Fullbright (Middle East) LLP",
    "registrationNumber": "L-02502",
    "licenseIssueDate": "08/10/2017 00:00:00",
    "licenseExpiryDate": "08/07/2026 00:00:00"
  },
  {
    "id": "7f784a31-0e62-4af9-9fbb-8fc1472c9771",
    "slug": "omar-hany-khodir-aziz-ahmed-khodir",
    "name": "OMAR HANY KHODIR AZIZ AHMED KHODIR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/02/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: OMAR HANY KHODIR AZIZ AHMED KHODIR",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7f784a31-0e62-4af9-9fbb-8fc1472c9771",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04337",
    "licenseIssueDate": "02/25/2019 00:00:00",
    "licenseExpiryDate": "02/23/2026 00:00:00"
  },
  {
    "id": "7b352aab-cc79-4ca2-9152-834a75f8c66d",
    "slug": "omar-hisham-mohamed-farid",
    "name": "OMAR HISHAM MOHAMED FARID",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/03/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Omar Hisham Mohamed Farid",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7b352aab-cc79-4ca2-9152-834a75f8c66d",
        "address": "ICD Brookfield Place ,DIFC ,120109 ,",
        "phone": "97143173000 / 971504465229",
        "email": "DubaiLAD@akingump.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9ff29eab-adb8-40f9-ab84-216e01a381e4",
    "firmName": "Akin Gump Strauss Hauer & Feld LLP",
    "registrationNumber": "L-05811",
    "licenseIssueDate": "03/26/2025 00:00:00",
    "licenseExpiryDate": "03/25/2026 00:00:00"
  },
  {
    "id": "c4a4d7de-8f55-4578-a21c-c6fbf161473e",
    "slug": "omar-ismail-tharwat-mohamed-zayed",
    "name": "OMAR ISMAIL THARWAT MOHAMED ZAYED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/08/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Omar Ismail Tharwat Mohamed Zayed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c4a4d7de-8f55-4578-a21c-c6fbf161473e",
        "address": "",
        "phone": "97143937700",
        "email": "info@galadarilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d863b662-c864-4193-8b3a-ff6ee5fe6c64",
    "firmName": "GALADARI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06930",
    "licenseIssueDate": "08/07/2025 00:00:00",
    "licenseExpiryDate": "08/06/2026 00:00:00"
  },
  {
    "id": "523ea390-4eae-4c63-856e-f672bc7e0f06",
    "slug": "omar-kamal-gharib-al-bakri",
    "name": "OMAR KAMAL GHARIB AL BAKRI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/03/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Omar Kamal Gharib Al Bakri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_523ea390-4eae-4c63-856e-f672bc7e0f06",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-06713",
    "licenseIssueDate": "03/05/2025 00:00:00",
    "licenseExpiryDate": "03/04/2026 00:00:00"
  },
  {
    "id": "ca27f07a-f641-42b6-a5bb-cfa5d0dbba0b",
    "slug": "omar-maayeh",
    "name": "OMAR BASSAM FARAH MAAYEH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/05/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Omar Maayeh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ca27f07a-f641-42b6-a5bb-cfa5d0dbba0b",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506698 ,Dubai",
        "phone": "97147046300 / 971507900661",
        "email": "nada.mourad@lw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b2b92ce9-90a4-4e34-ae2f-ae0dc7ca9060",
    "firmName": "Latham & Watkins LLP",
    "registrationNumber": "L-03005",
    "licenseIssueDate": "05/18/2015 00:00:00",
    "licenseExpiryDate": "05/13/2026 00:00:00"
  },
  {
    "id": "a42e0125-0249-4f10-bddb-50826b8ca1e3",
    "slug": "omar-mohamed-omar",
    "name": "OMAR MOHAMED ATWA OMAR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/11/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Omar Mohamed Omar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a42e0125-0249-4f10-bddb-50826b8ca1e3",
        "address": "4th Floor – offices 408 - 411 - 412 ,Business Village Building  - Block B ,Near Clock Tower ,49425 ,Dubai",
        "phone": "97143869999 / 971506446650",
        "email": "advocates@binmeshar.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d4ea63a4-952e-4374-a9df-97a521bb4cd5",
    "firmName": "BIN MESHAR & CO ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02564",
    "licenseIssueDate": "11/12/2013 00:00:00",
    "licenseExpiryDate": "11/05/2025 00:00:00"
  },
  {
    "id": "9d940251-d3c1-4258-a10e-19f186ee7950",
    "slug": "omar-momany",
    "name": "Omar Momany",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/08/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Omar Momany",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9d940251-d3c1-4258-a10e-19f186ee7950",
        "address": "",
        "phone": "97144478700 / 971528553200",
        "email": "Thomas.Wilson@squirepb.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "85be541a-c87f-45a9-a321-d90abd6b7298",
    "firmName": "Squire Patton Boggs (MEA) LLP",
    "registrationNumber": "L-01105",
    "licenseIssueDate": "09/08/2011 00:00:00",
    "licenseExpiryDate": "08/30/2026 00:00:00"
  },
  {
    "id": "dbbcd02b-828e-41b0-a2a6-ffdb13a2cfcf",
    "slug": "omar-nael-omar",
    "name": "OMAR NA EL OMAR OMAR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Omar Na'el Omar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dbbcd02b-828e-41b0-a2a6-ffdb13a2cfcf",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01297",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "aa9d2ce7-2d46-44d0-86b1-c683892b35d5",
    "slug": "omar-obeidat",
    "name": "Omar Obeidat",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Omar Obeidat",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_aa9d2ce7-2d46-44d0-86b1-c683892b35d5",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01298",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "b8fc1273-7976-41c0-ad5f-42e65757e1ef",
    "slug": "omar-rashid",
    "name": "OMAR RASHID",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Omar Rashid",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b8fc1273-7976-41c0-ad5f-42e65757e1ef",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-00171",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "924ec5f7-3423-44c5-b7fa-ee8274d337d6",
    "slug": "omar-sharief",
    "name": "OMAR SHARIEF",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/08/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Omar Sharief",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_924ec5f7-3423-44c5-b7fa-ee8274d337d6",
        "address": "",
        "phone": "97143093222 / 971566651954",
        "email": "melissa.murray@twobirds.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3e1526e6-4c8d-4b6f-985f-ea05e9f99bcb",
    "firmName": "Bird & Bird (MEA) LLP",
    "registrationNumber": "L-05942",
    "licenseIssueDate": "08/02/2023 00:00:00",
    "licenseExpiryDate": "08/01/2026 00:00:00"
  },
  {
    "id": "a030d416-2050-4f72-81b6-7acd4a1eb5e3",
    "slug": "omar-suleiman-qadora",
    "name": "OMAR SULEIMAN MOHD QADORA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/10/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Omar Suleiman Qadora",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a030d416-2050-4f72-81b6-7acd4a1eb5e3",
        "address": "Ibrahim Nagi ,Office 207, Level 2 ,Al Khaimah Building ,Behind Nissan Showroom ,20220 ,Dubai",
        "phone": "97142950001",
        "email": "info@alshaali-co.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a58e33e7-4134-4c4f-afa6-c129aefe104c",
    "firmName": "AL SHAALI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02003",
    "licenseIssueDate": "10/20/2011 00:00:00",
    "licenseExpiryDate": "10/11/2025 00:00:00"
  },
  {
    "id": "5a36010e-29df-4403-b2cb-bd7637001b28",
    "slug": "omar-tarek-moussally",
    "name": "OMAR TAREK MOUSSALLY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/12/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Omar Tarek Moussally",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5a36010e-29df-4403-b2cb-bd7637001b28",
        "address": "801/802 ,Park Place ,WTC ,384557 ,Dubai",
        "phone": "97143203999",
        "email": "info.dubai@alemlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e3088c8b-a7dc-4f38-a04d-cb4c7d050ed9",
    "firmName": "AHMED MOHAMMED BASHIR ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06628",
    "licenseIssueDate": "12/25/2024 00:00:00",
    "licenseExpiryDate": "12/24/2025 00:00:00"
  },
  {
    "id": "a0b2b144-3a17-432f-9956-2f76b23a3ee9",
    "slug": "omer-gasmelseid",
    "name": "Omer  Gasmelseid",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/13/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2020-09-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Omer  Gasmelseid",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a0b2b144-3a17-432f-9956-2f76b23a3ee9",
        "address": "mohamed mahmoud mohamed elkormany ,بناية الوصل ,R549 يناية الوصل ,سيتي سنتر ديره ,83620 ,Dubai",
        "phone": "97142542000",
        "email": "info@aaalegalconsultants.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "927c60c9-145e-4bb5-8913-d6d6aa72f891",
    "firmName": "ABDALLA ALNAKHI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03512",
    "licenseIssueDate": "10/13/2016 00:00:00",
    "licenseExpiryDate": "10/09/2020 00:00:00"
  },
  {
    "id": "edd03cca-ff4d-433e-a667-d21704f3dbfa",
    "slug": "omer-hassan-bakri",
    "name": "OMER HASSAN BAKRI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Commercial Agency",
      "Civil Transactions-POA & Sponsorship",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Civil Transactions-HR & Employee Affairs",
      "Criminal Law-Family Crimes",
      "Commercial Transactions-Commercial Contracts",
      "Civil Transactions-Immigration and Residency",
      "Commercial Transactions-Bankruptcy",
      "Criminal Law-Hate crimes",
      "Civil Transactions-Tenancy",
      "Commercial Transactions-Unfair competition",
      "Criminal Law-Crimes against persons",
      "Commercial Transactions-Commercial Companies",
      "Civil Transactions-Labor & Workers",
      "Criminal Law-Drug Crimes",
      "Civil Transactions-Sale",
      "Personal Status-Child Abuse & Abduction",
      "Civil Transactions-Compensation",
      "Criminal Law-Crimes against properties",
      "Criminal Law-Cybercrimes",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/12/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Omer Hassan Bakri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_edd03cca-ff4d-433e-a667-d21704f3dbfa",
        "address": "",
        "phone": "97143303900 / 971561753537",
        "email": "christopher@afridi-angell.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "30ce50dc-01a6-499d-8ace-3f807ddcb08d",
    "firmName": "Afridi & Angell-DED",
    "registrationNumber": "L-00120",
    "licenseIssueDate": "12/16/2011 00:00:00",
    "licenseExpiryDate": "12/07/2025 00:00:00"
  },
  {
    "id": "daf90f0b-f1ee-4622-8730-5da952bb0171",
    "slug": "omer-mohamed-elsharif-abd-alla",
    "name": "OMER MOHAMED ELSHARIF ABDALLA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/05/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Omer Mohamed Elsharif Abd Alla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_daf90f0b-f1ee-4622-8730-5da952bb0171",
        "address": "",
        "phone": "97142555000",
        "email": "info@kha.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0e4b9f0a-83fc-45c9-b0d3-f38013690624",
    "firmName": "KHALIFA BIN HUWAIDAN ALKETBI ADVOCATES & LEGAL CONSULTANT",
    "registrationNumber": "L-04925",
    "licenseIssueDate": "05/10/2021 00:00:00",
    "licenseExpiryDate": "05/09/2026 00:00:00"
  },
  {
    "id": "9226da78-ff92-420c-aece-04a07f7e25b2",
    "slug": "omer-sayed-ibrahim-mohamed",
    "name": "OMER SAYED IBRAHIM MOHAMED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/12/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Omer Sayed Ibrahim Mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9226da78-ff92-420c-aece-04a07f7e25b2",
        "address": "",
        "phone": "97142770003",
        "email": "info@hbhadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "f074c445-924d-40b2-9832-0b0a040c4e63",
    "firmName": "HAIDER BIN HAIDER ADVOCATES AND LEGAL CONSULTANT",
    "registrationNumber": "L-04283",
    "licenseIssueDate": "12/11/2018 00:00:00",
    "licenseExpiryDate": "12/09/2025 00:00:00"
  },
  {
    "id": "363a7e58-a68b-423e-b7a2-5065a0099f06",
    "slug": "omer-serdaneh",
    "name": "OMAR M A ABUSERDANEH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Omer Serdaneh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_363a7e58-a68b-423e-b7a2-5065a0099f06",
        "address": "",
        "phone": "97142999434 / 971563666333",
        "email": "info@moaza-advocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6311e53c-d1e0-469a-92a1-e290c2faf954",
    "firmName": "MOZA ALJABRI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02020",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "d448b9a1-9990-4d58-af52-371457709a47",
    "slug": "omotomwa-adeyefa",
    "name": "OMOTOMIWA ADEYEFA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/05/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Omotomwa Adeyefa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d448b9a1-9990-4d58-af52-371457709a47",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-06815",
    "licenseIssueDate": "05/28/2025 00:00:00",
    "licenseExpiryDate": "05/27/2026 00:00:00"
  },
  {
    "id": "0ed0a7c1-be74-4861-bdb6-192d01ec88a5",
    "slug": "oonagh-mccullagh",
    "name": "OONAGH MCCULLAGH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/12/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Oonagh McCullagh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0ed0a7c1-be74-4861-bdb6-192d01ec88a5",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-05127",
    "licenseIssueDate": "12/13/2021 00:00:00",
    "licenseExpiryDate": "12/12/2025 00:00:00"
  },
  {
    "id": "92cfefe7-0a7c-455a-877f-03edd1801e78",
    "slug": "osama-daneshyar",
    "name": "OSAMA DANESHYAR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/09/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Osama Daneshyar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_92cfefe7-0a7c-455a-877f-03edd1801e78",
        "address": "901-902 ,برج السلام ,فندق جراند شيراتون ,2741291443 ,Dubai",
        "phone": "97145877794 / 971586606660",
        "email": "obh@obhlawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "edbb7814-39f9-4ec9-b01d-9de1117e343e",
    "firmName": "OMAR KHALIFA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02632",
    "licenseIssueDate": "09/15/2014 00:00:00",
    "licenseExpiryDate": "09/09/2026 00:00:00"
  },
  {
    "id": "d915ce9e-2fcb-4af4-a3f2-4ace0fe82323",
    "slug": "osama-elsaid-taher-elhattab",
    "name": "OSAMA ELSAID TAHER ALI ELHATTAB",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Commercial Agency",
      "Civil Transactions-POA & Sponsorship",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Civil Transactions-Insurance",
      "Civil Transactions-Construction and Contracts for Services",
      "Commercial Transactions-Commercial Mortgage",
      "Commercial Transactions-Bankruptcy",
      "Commercial Transactions-Commercial Companies",
      "Commercial Transactions-Banking Operations",
      "Civil Transactions-Labor & Workers",
      "Civil Transactions-Compensation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/02/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Osama Elsaid Taher Elhattab",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d915ce9e-2fcb-4af4-a3f2-4ace0fe82323",
        "address": "haleema almarzooqi ,3 ,building 7A ,D3 ,9569 ,Dubai",
        "phone": "97143621113",
        "email": "haleema.almarzooqi@dhalaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4fb21617-b070-488f-8ce5-516725154e59",
    "firmName": "HALEEMA ALMARZOOQI & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04864",
    "licenseIssueDate": "02/22/2021 00:00:00",
    "licenseExpiryDate": "02/21/2026 00:00:00"
  },
  {
    "id": "1fa3f063-2bc9-4ea9-9f54-3832b03b13a1",
    "slug": "osama-gouda-ekila",
    "name": "OSAMA GOUDA ABDELSATAR EKILA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/04/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Osama Gouda Ekila",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1fa3f063-2bc9-4ea9-9f54-3832b03b13a1",
        "address": "الخامس ,مونتانا ,هوم سنتر ,28834 ,Dubai",
        "phone": "97143963739",
        "email": "mousaadv@eim.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "af9dbfb0-4310-41bb-90aa-a3055b865d84",
    "firmName": "EBRAHIM ALI AL MOUSA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01543",
    "licenseIssueDate": "04/19/2012 00:00:00",
    "licenseExpiryDate": "04/11/2026 00:00:00"
  },
  {
    "id": "b4b708ad-a813-4f86-a200-fd3b836096f2",
    "slug": "osama-kh-s-najjar",
    "name": "OSAMA KH S NAJJAR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/07/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Osama Kh S Najjar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b4b708ad-a813-4f86-a200-fd3b836096f2",
        "address": "",
        "phone": "97142512221",
        "email": "info@ahal-advocacy.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9367d5c4-b8c9-49a6-a229-7da2663c3957",
    "firmName": "ABDULLAH HUSSAIN ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06919",
    "licenseIssueDate": "07/31/2025 00:00:00",
    "licenseExpiryDate": "07/30/2026 00:00:00"
  },
  {
    "id": "1f4d1a48-56a8-4e89-86e6-9021bbaeba81",
    "slug": "ossama-khamis",
    "name": "OSSAMA KAMAL ABDELLATIF KHAMIS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ossama Khamis",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1f4d1a48-56a8-4e89-86e6-9021bbaeba81",
        "address": "",
        "phone": "97142828999",
        "email": "info@gmalc.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2f9514bf-2175-40fe-8539-d1b4b32074b7",
    "firmName": "ALGURG & ALMATROOSHI ADVOCATES & LIGAL CONSULTANTS",
    "registrationNumber": "L-01389",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "3ca2f658-83dd-42ea-ad87-78f106e68b8b",
    "slug": "ossama-mohamed-el-gammal",
    "name": "OSSAMA MOHAMED FAWZY ALI ELGAMMAL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/11/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ossama Mohamed El Gammal",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3ca2f658-83dd-42ea-ad87-78f106e68b8b",
        "address": "Diana Mohamed Hamade ,A.301.S-7 ,Multaqa Avenue 1 ,Mirdif ,10223 ,Dubai",
        "phone": "97142733029",
        "email": "info@dianahamade.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de3ee3af-bda3-4ac6-96b7-fc737b52458c",
    "firmName": "DAINA HAMADE ATTORNYES AT LAW",
    "registrationNumber": "L-02994",
    "licenseIssueDate": "11/08/2014 00:00:00",
    "licenseExpiryDate": "11/02/2025 00:00:00"
  },
  {
    "id": "3da980b3-eacc-4b7c-be4e-94943bbe5bc6",
    "slug": "ossama-mohamed-elmorsy",
    "name": "OSSAMA MOHAMED MOHAMED ELMORSY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/11/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ossama Mohamed Elmorsy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3da980b3-eacc-4b7c-be4e-94943bbe5bc6",
        "address": "3-505 ,AL KHABEESI BLDG ,AL KABEESI ,4948 ,Dubai",
        "phone": "97142222228",
        "email": "info@alkamali.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "054f38f4-9e51-4623-ad36-7941043a051c",
    "firmName": "AL KAMALI & COMPANY ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-02244",
    "licenseIssueDate": "11/16/2011 00:00:00",
    "licenseExpiryDate": "11/07/2025 00:00:00"
  },
  {
    "id": "80784da0-5782-4e2f-abd1-36eb38d88a9c",
    "slug": "ossama-mohammed-mohammed",
    "name": "OSSAMA MOHAMED MOHAMED ABDELHAFIZ",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/11/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2022-11-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ossama Mohammed Mohammed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_80784da0-5782-4e2f-abd1-36eb38d88a9c",
        "address": "",
        "phone": "97142942616",
        "email": "info@ilofficeuae.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "48ef4874-8647-4fb6-bedd-ffbad25accd1",
    "firmName": "KHALID KALANDAR ALMAAZMI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-04791",
    "licenseIssueDate": "11/26/2020 00:00:00",
    "licenseExpiryDate": "11/25/2022 00:00:00"
  },
  {
    "id": "b0b43c79-0394-4622-a9ba-5ef4b64612d7",
    "slug": "othmane-saadani-hassani",
    "name": "OTHMANE SAADANI HASSANI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/02/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Othmane Saadani Hassani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b0b43c79-0394-4622-a9ba-5ef4b64612d7",
        "address": "Firas Hassan Al Choufi ,701 ,The Prime Tower ,Makani No: 25836 86879 ,125305 ,Dubai",
        "phone": "97144357246",
        "email": "info@binsevanadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4d3c9dcc-51c6-4883-b9ed-c65a7d1c5a57",
    "firmName": "BIN SEVAN ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-06686",
    "licenseIssueDate": "02/14/2025 00:00:00",
    "licenseExpiryDate": "02/13/2026 00:00:00"
  },
  {
    "id": "df3c8d1e-79f7-4926-9bd4-c0c220fbea21",
    "slug": "ouassila-afrit",
    "name": "ouassila afrit",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/26/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ouassila afrit",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_df3c8d1e-79f7-4926-9bd4-c0c220fbea21",
        "address": "Abdulrahman Ali Alshaali  ,7 ,برج المسعود 2 ,معرض سيارات تويوتا - ديره ,00000 ,Dubai",
        "phone": "97143300780 / 971971454749",
        "email": "abdulrahman@alshaalilegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8fc61dff-5618-4cd0-91c2-617c55c9acda",
    "firmName": "ABDULRHMAN ALSHAALI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06697",
    "licenseIssueDate": "02/26/2025 00:00:00",
    "licenseExpiryDate": "02/25/2026 00:00:00"
  },
  {
    "id": "e167999b-886f-494e-abdc-e7479ff255df",
    "slug": "owen-etwaroo",
    "name": "OWEN ETWAROO",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/09/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Owen Etwaroo",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e167999b-886f-494e-abdc-e7479ff255df",
        "address": "Al Fattan Currency House Tower 2 ,DIFC ,507176 ,",
        "phone": "/ 971552009003",
        "email": "Mohammad.AlRasheed@bakermckenzie.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "acd81e81-dead-4f7c-839e-0f2a57897265",
    "firmName": "Baker & Mckenzie LLP",
    "registrationNumber": "L-06950",
    "licenseIssueDate": "08/27/2025 00:00:00",
    "licenseExpiryDate": "08/26/2026 00:00:00"
  },
  {
    "id": "b3775c90-42ca-474a-8944-92e1124ec0ad",
    "slug": "owen-kumae-barry-afriye",
    "name": "OWEN KUMAE BARRY AFRIYE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/06/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Owen Kumae Barry Afriye",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b3775c90-42ca-474a-8944-92e1124ec0ad",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506688 ,Dubai",
        "phone": "97147096600 / 971503556811",
        "email": "muneer.khan@simmons-simmons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d1725ca7-06ac-41b2-8d7b-a6e60665b73d",
    "firmName": "Simmons & Simmons (Middle East) LLP-DIFC",
    "registrationNumber": "L-05867",
    "licenseIssueDate": "06/21/2023 00:00:00",
    "licenseExpiryDate": "06/20/2026 00:00:00"
  },
  {
    "id": "47d1279f-fe11-464f-8e96-e9e244748112",
    "slug": "owen-richards",
    "name": "OWEN JOHN PHILIP RICHARDS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/09/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Owen Richards",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_47d1279f-fe11-464f-8e96-e9e244748112",
        "address": "6 ,Office Nos. 603, 604 & 605, Level 6, Burj Daman ,Dubai International Financial Centre ,506555 ,Dubai",
        "phone": "97143506400 / 971504654755",
        "email": "r.hickman@aglaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8690f7d5-6b96-4649-9589-71303f2c2707",
    "firmName": "Addleshaw Goddard (Middle East) LLP",
    "registrationNumber": "L-02172",
    "licenseIssueDate": "09/26/2013 00:00:00",
    "licenseExpiryDate": "09/19/2026 00:00:00"
  },
  {
    "id": "aea63239-d856-4791-b12c-fa1c9cd5dc45",
    "slug": "pakinam-mohamed-el-badrawi",
    "name": "PAKINAM MOHAMED EL BADRAWI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/10/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Pakinam Mohamed El Badrawi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_aea63239-d856-4791-b12c-fa1c9cd5dc45",
        "address": "",
        "phone": "97144272700 / 971545824605",
        "email": "tony.griffiths@klgates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "fb8fc340-ceef-4b83-8f2b-9b24d4604967",
    "firmName": "K & L Gates LLP",
    "registrationNumber": "L-05085",
    "licenseIssueDate": "10/25/2021 00:00:00",
    "licenseExpiryDate": "10/24/2025 00:00:00"
  },
  {
    "id": "f846c578-001f-4722-b736-65897cb0e6c2",
    "slug": "pallavi-shaunak-satpute-shaunak-rameshchandra-satpute",
    "name": "PALLAVI SHAUNAK SATPUTE SHAUNAK RAMESHCHANDRA SATPUTE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/07/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Pallavi Shaunak Satpute Shaunak Rameshchandra Satpute",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f846c578-001f-4722-b736-65897cb0e6c2",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-05441",
    "licenseIssueDate": "07/27/2022 00:00:00",
    "licenseExpiryDate": "07/26/2026 00:00:00"
  },
  {
    "id": "b06e31e0-e546-43cd-8442-52fae61ce189",
    "slug": "pamela-haidat",
    "name": "PAMELA HAIDAT",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/01/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Pamela Haidat",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b06e31e0-e546-43cd-8442-52fae61ce189",
        "address": "15th Floor _ Office No. 1504 ,SOBHA SAPPHIRE ,Makani No: 2612485764 ,000 ,Dubai",
        "phone": "97145570789 / 971521800001",
        "email": "Info@iserkal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "196bb7bb-4be6-4029-9367-c100bd219d3f",
    "firmName": "IBRAHIM ALSERKAL ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06630",
    "licenseIssueDate": "01/08/2025 00:00:00",
    "licenseExpiryDate": "01/07/2026 00:00:00"
  },
  {
    "id": "d36903b8-72b9-4c4f-9f31-34ca74a79004",
    "slug": "pardeep-kaur-jagpal",
    "name": "PARDEEP KAUR JAGPAL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/10/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Pardeep Kaur Jagpal",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d36903b8-72b9-4c4f-9f31-34ca74a79004",
        "address": "",
        "phone": "97144020800 / 971566830829",
        "email": "dean.ryburn@dentons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dfe13b7e-6625-45fd-ad63-9ee83af41194",
    "firmName": "Dentons & Co Dubai Branch-DED",
    "registrationNumber": "L-06034",
    "licenseIssueDate": "10/04/2023 00:00:00",
    "licenseExpiryDate": "10/03/2026 00:00:00"
  },
  {
    "id": "8145ebef-b832-450a-817c-a32c73c400ef",
    "slug": "paridhi-poddar-om-prakash-poddar",
    "name": "PARIDHI PODDAR OM PRAKASH PODDAR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/08/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Paridhi Poddar Om Prakash Poddar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8145ebef-b832-450a-817c-a32c73c400ef",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-05452",
    "licenseIssueDate": "08/03/2022 00:00:00",
    "licenseExpiryDate": "08/02/2026 00:00:00"
  },
  {
    "id": "2b141ac7-a467-4bd9-af6e-10aaf6cd2d93",
    "slug": "patric-mcgonigal",
    "name": "PATRIC MC GONIGAL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/12/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Patric McGonigal",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2b141ac7-a467-4bd9-af6e-10aaf6cd2d93",
        "address": "21 ,Rolex Tower ,Emirates Grand Hotel ,94334 ,Dubai",
        "phone": "97143277772 / 97145584900",
        "email": "info@globaladvocates.net",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9b42810f-1d55-4aea-ac4a-7d9d1b25ac08",
    "firmName": "GLOBAL ADVOCACY & LEGAL COUNSEL",
    "registrationNumber": "L-05635",
    "licenseIssueDate": "12/14/2022 00:00:00",
    "licenseExpiryDate": "12/13/2025 00:00:00"
  },
  {
    "id": "009c55a2-b6e8-4bb6-877a-87727ae5a1e5",
    "slug": "patricia-tiller",
    "name": "PATRICIA MICHELLE TILLER",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/06/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Patricia Tiller",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_009c55a2-b6e8-4bb6-877a-87727ae5a1e5",
        "address": "",
        "phone": "97143506800 / 971507244940",
        "email": "Chris.Williams@bracewelllaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "106d3ee7-86f2-4eae-9b49-fd8423095983",
    "firmName": "Bracewell LLP",
    "registrationNumber": "L-00556",
    "licenseIssueDate": "06/28/2012 00:00:00",
    "licenseExpiryDate": "06/20/2026 00:00:00"
  },
  {
    "id": "acd13d72-faf2-4455-82f7-81ccb5b53743",
    "slug": "patricia-ugalde-revilla",
    "name": "PATRICIA UGALDE REVILLA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQVQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/04/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Patricia Ugalde Revilla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_acd13d72-faf2-4455-82f7-81ccb5b53743",
        "address": "Index Tower ,Dubai International Financial Centre ,507115 ,",
        "phone": "97143757160 / 971523490280",
        "email": "tthraya@mayerbrown.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c7f52b69-c049-4246-963a-9805b241f88a",
    "firmName": "Mayer Brown LLP",
    "registrationNumber": "L-05299",
    "licenseIssueDate": "04/07/2022 00:00:00",
    "licenseExpiryDate": "04/06/2026 00:00:00"
  },
  {
    "id": "2b1e294b-7987-4db0-85d7-ad8dc40977f0",
    "slug": "patrick-animbom-chindo",
    "name": "PATRICK ANIMBOM CHINDO",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/08/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Patrick Animbom Chindo",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2b1e294b-7987-4db0-85d7-ad8dc40977f0",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-06455",
    "licenseIssueDate": "08/06/2024 00:00:00",
    "licenseExpiryDate": "08/05/2026 00:00:00"
  },
  {
    "id": "dea31fef-67f8-4983-affd-d757b393179c",
    "slug": "patrick-david-gearons",
    "name": "PATRICK DAVID GEARON",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/10/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Patrick David Gearons",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dea31fef-67f8-4983-affd-d757b393179c",
        "address": "20 ,Index Tower West Tower ,DIFC ,507226 ,Dubai",
        "phone": "97142461900 / 971523391604",
        "email": "patrick.gearon@crsblaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e2ac552e-b9a7-450b-a84d-15119e583220",
    "firmName": "Charles Russell Speechlys LLP",
    "registrationNumber": "L-04748",
    "licenseIssueDate": "10/21/2020 00:00:00",
    "licenseExpiryDate": "10/20/2026 00:00:00"
  },
  {
    "id": "84018556-9857-4111-9691-b53d0285ee28",
    "slug": "patrick-david-stone",
    "name": "PATRICK DAVID STONE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/11/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Patrick David Stone",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_84018556-9857-4111-9691-b53d0285ee28",
        "address": "Office 1A ,Silver Tower ,DMCC Al Mas Tower ,283149 ,Dubai",
        "phone": "97144542355 / 971564092949",
        "email": "pstone@fenwickelliott.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "45b03212-ac3a-4dbc-8b2d-10fc81273543",
    "firmName": "Fenwick Elliott LLP (DMCC Branch)",
    "registrationNumber": "L-04266",
    "licenseIssueDate": "11/13/2018 00:00:00",
    "licenseExpiryDate": "11/11/2025 00:00:00"
  },
  {
    "id": "15bb8cdc-ffb8-4893-9470-ca17266460f3",
    "slug": "patrick-david-sutton-mattocks",
    "name": "PATRICK DAVID SUTTON MATTOCKS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/12/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Patrick David Sutton-Mattocks",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_15bb8cdc-ffb8-4893-9470-ca17266460f3",
        "address": "ICD Brookfield Place ,DIFC ,506516 ,",
        "phone": "97143695800 / 971505526206",
        "email": "scott.campbell@linklaters.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5cec94c0-0649-43b6-a2be-ab17ff422bce",
    "firmName": "LinkLaters LLP",
    "registrationNumber": "L-03943",
    "licenseIssueDate": "12/19/2017 00:00:00",
    "licenseExpiryDate": "12/16/2025 00:00:00"
  },
  {
    "id": "e5f2dac8-d2d6-4c2d-a74d-e16c07f994d4",
    "slug": "patrick-gabriel-ogrady",
    "name": "PATRICK GABRIEL OGRADY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/09/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Patrick Gabriel O'Grady",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e5f2dac8-d2d6-4c2d-a74d-e16c07f994d4",
        "address": "",
        "phone": "97142472100 / 971509224336",
        "email": "bhaley@cov.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "65a2e90a-6978-4292-b3f1-ecbebedd7b9a",
    "firmName": "Covington & Burling LLP (Middle East)",
    "registrationNumber": "L-04197",
    "licenseIssueDate": "09/03/2018 00:00:00",
    "licenseExpiryDate": "09/01/2026 00:00:00"
  },
  {
    "id": "90bccda5-1f16-44be-b6dc-1800152dc12c",
    "slug": "patrick-hassan",
    "name": "PATRICK FRANCIS LOUGHRAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/11/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Patrick Hassan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_90bccda5-1f16-44be-b6dc-1800152dc12c",
        "address": "",
        "phone": "97144020800 / 971566830829",
        "email": "dean.ryburn@dentons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dfe13b7e-6625-45fd-ad63-9ee83af41194",
    "firmName": "Dentons & Co Dubai Branch-DED",
    "registrationNumber": "L-05125",
    "licenseIssueDate": "11/22/2021 00:00:00",
    "licenseExpiryDate": "11/21/2025 00:00:00"
  },
  {
    "id": "69e65dc7-789e-49ca-b87a-950cff23a863",
    "slug": "patrick-kanaan-khoury",
    "name": "PATRICK KANAAN KHOURY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/06/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: PATRICK KANAAN KHOURY",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_69e65dc7-789e-49ca-b87a-950cff23a863",
        "address": "الطابق 7 مكتب رقم 070A ,برج رولكس  ,محطة مترو المركز المالي  ,66300 ,Dubai",
        "phone": "97143444029",
        "email": "ekp.khalidaltmimi@ekplegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "400838f1-4e75-4836-9698-b9e19dd30a18",
    "firmName": "KHALID ABDALLA ALTAMIMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04959",
    "licenseIssueDate": "06/14/2021 00:00:00",
    "licenseExpiryDate": "06/13/2026 00:00:00"
  },
  {
    "id": "e19c3ab5-ff2f-46be-bfd6-84e2215273c0",
    "slug": "patrick-malone",
    "name": "PATRICK RAFAEL DILLON MALONE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/09/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Patrick Malone",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e19c3ab5-ff2f-46be-bfd6-84e2215273c0",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-01183",
    "licenseIssueDate": "09/10/2017 00:00:00",
    "licenseExpiryDate": "09/07/2026 00:00:00"
  },
  {
    "id": "68ef3ec9-1799-4397-bf96-f5b6aa13ba28",
    "slug": "patrick-tweedale",
    "name": "PATRICK OLIVER TWEEDALE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/12/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Patrick Tweedale",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_68ef3ec9-1799-4397-bf96-f5b6aa13ba28",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-02276",
    "licenseIssueDate": "12/04/2013 00:00:00",
    "licenseExpiryDate": "11/27/2025 00:00:00"
  },
  {
    "id": "2ecf4a8a-60ed-4b4b-a2f6-27759db85bc0",
    "slug": "patrik-daintry",
    "name": "PATRIK MIKAEL RIDGWAY DAINTRY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/08/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Patrik Daintry",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2ecf4a8a-60ed-4b4b-a2f6-27759db85bc0",
        "address": "",
        "phone": "97143742800 / 971506450677",
        "email": "jabbott21@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7a59d310-ff72-4318-b41c-27095c163d0f",
    "firmName": "CMS (UAE) LLP",
    "registrationNumber": "L-03822",
    "licenseIssueDate": "08/22/2017 00:00:00",
    "licenseExpiryDate": "08/19/2026 00:00:00"
  },
  {
    "id": "929ade25-85f5-4bc9-8598-e02092f4c12d",
    "slug": "paul-allen",
    "name": "PAUL ROBERT ALLEN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Paul Allen",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_929ade25-85f5-4bc9-8598-e02092f4c12d",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-00670",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "ea0ba57d-22f4-4424-8b5b-7744675793a8",
    "slug": "paul-blakeway",
    "name": "PAUL ALEXANDER BLAKEWAY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/06/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Paul Blakeway",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ea0ba57d-22f4-4424-8b5b-7744675793a8",
        "address": "O-4801, O-4901 ,Burj al Salam Office Tower ,H Hotel ,111801 ,Dubai",
        "phone": "97143544444",
        "email": "administration@horizlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4e25fb39-6659-44f0-bc8b-3ff0f067beb0",
    "firmName": "HORIZONS & CO - LAW FIRM",
    "registrationNumber": "L-01368",
    "licenseIssueDate": "06/17/2013 00:00:00",
    "licenseExpiryDate": "06/10/2026 00:00:00"
  },
  {
    "id": "0af6b42b-d705-4c00-8930-3b2b9bf8757e",
    "slug": "paul-bugingo",
    "name": "PAUL BUGABE BUGINGO",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Paul Bugingo",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0af6b42b-d705-4c00-8930-3b2b9bf8757e",
        "address": "الطابق 14  ,برج 48 جيت  ,محطة مترو دبي  ,413633 ,Dubai",
        "phone": "97144412031",
        "email": "courts@adglegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4287f048-dc0c-4d51-9e0c-0c23356040ee",
    "firmName": "MOHAMMED AL DAHBASHI ADVOCATES",
    "registrationNumber": "L-00421",
    "licenseIssueDate": "02/25/2012 00:00:00",
    "licenseExpiryDate": "02/16/2026 00:00:00"
  },
  {
    "id": "efad4d2c-a2cf-42bd-af0e-95ae0ea77261",
    "slug": "paul-daniel-oliver-langley",
    "name": "PAUL DANIEL OLIVER LANGLEY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/11/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Paul Daniel Oliver Langley",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_efad4d2c-a2cf-42bd-af0e-95ae0ea77261",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-05123",
    "licenseIssueDate": "11/22/2021 00:00:00",
    "licenseExpiryDate": "11/21/2025 00:00:00"
  },
  {
    "id": "ecfee207-50ba-4d50-ac7f-70e2aba6356e",
    "slug": "paul-george-cata",
    "name": "PAUL GEORGE CATA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/03/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Paul George Cata",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ecfee207-50ba-4d50-ac7f-70e2aba6356e",
        "address": "4th floor ,Al Saaha Offices Block D office 401A ,Burj Khalifa ,283773 ,Dubai",
        "phone": "97144221944",
        "email": "gov.depts@alsafarpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b7bbfaeb-1fdb-46d2-97cf-8e6432a9b8a7",
    "firmName": "AL SAFAR & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06716",
    "licenseIssueDate": "03/12/2025 00:00:00",
    "licenseExpiryDate": "03/11/2026 00:00:00"
  },
  {
    "id": "b7b78210-4389-40cb-942b-8918caff24a5",
    "slug": "paul-hughes",
    "name": "PAUL RICHARD HUGHES",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/11/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Paul Hughes",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b7b78210-4389-40cb-942b-8918caff24a5",
        "address": "",
        "phone": "97144543900 / 971569199020",
        "email": "paul.hughes@kobrekim.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "259f7732-3596-4559-ae29-21cb6f4aa7d8",
    "firmName": "Kobre & Kim (GCC) LLP",
    "registrationNumber": "L-01465",
    "licenseIssueDate": "11/27/2012 00:00:00",
    "licenseExpiryDate": "11/19/2025 00:00:00"
  },
  {
    "id": "5aa0a334-4e77-43ee-ba06-d3e8ac203d72",
    "slug": "paul-justin-mansouri",
    "name": "PAUL JUSTIN MANSOURI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/09/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Paul Justin Mansouri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5aa0a334-4e77-43ee-ba06-d3e8ac203d72",
        "address": "ICD Brookfield Place ,Za'abeel 2 ,103747 ,",
        "phone": "97143696300 / 971506008159",
        "email": "mohammed.paracha@nortonrosefulbright.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c4aaee93-0ec4-4982-9a48-a23699492056",
    "firmName": "Norton Rose Fullbright (Middle East) LLP",
    "registrationNumber": "L-04530",
    "licenseIssueDate": "09/18/2025 00:00:00",
    "licenseExpiryDate": "09/17/2026 00:00:00"
  },
  {
    "id": "e7c3fdd6-b3bd-4ab2-aed7-f28d5d0ca38f",
    "slug": "paul-latto",
    "name": "PAUL STUART LATTO",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Paul Latto",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e7c3fdd6-b3bd-4ab2-aed7-f28d5d0ca38f",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-00174",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "0d67c0e7-31cb-4b36-9266-d29fd588402f",
    "slug": "paul-mcviety",
    "name": "PAUL ALEXANDER MCVIETY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Paul McViety",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0d67c0e7-31cb-4b36-9266-d29fd588402f",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-00671",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "fc8d0b01-c7a6-40b9-9501-e274f5ec140b",
    "slug": "paul-michael-suckling",
    "name": "PAUL MICHAEL SUCKLING",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/03/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Paul Michael Suckling",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fc8d0b01-c7a6-40b9-9501-e274f5ec140b",
        "address": "",
        "phone": "97143937700",
        "email": "info@galadarilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d863b662-c864-4193-8b3a-ff6ee5fe6c64",
    "firmName": "GALADARI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04362",
    "licenseIssueDate": "04/01/2019 00:00:00",
    "licenseExpiryDate": "03/30/2026 00:00:00"
  },
  {
    "id": "52b9c42e-8378-4d0b-b570-0d8106a88b20",
    "slug": "paul-muscat",
    "name": "PAUL JOSEPH MUSCAT",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/12/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Paul Muscat",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_52b9c42e-8378-4d0b-b570-0d8106a88b20",
        "address": "",
        "phone": "97143098000 / 971552210883",
        "email": "belturk@rouse.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9df4d4e5-5243-4fae-8d95-463d110ce6a8",
    "firmName": "Rouse & Co International Limited (Dubai Branch)",
    "registrationNumber": "L-03229",
    "licenseIssueDate": "12/15/2015 00:00:00",
    "licenseExpiryDate": "12/10/2025 00:00:00"
  },
  {
    "id": "528491cd-e4df-485e-9202-a4cddc89d1a5",
    "slug": "paul-richard-baloukjy",
    "name": "PAUL RICHARD BALOUKJY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/08/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Paul Richard Baloukjy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_528491cd-e4df-485e-9202-a4cddc89d1a5",
        "address": "",
        "phone": "97143937700",
        "email": "info@galadarilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d863b662-c864-4193-8b3a-ff6ee5fe6c64",
    "firmName": "GALADARI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06914",
    "licenseIssueDate": "08/18/2025 00:00:00",
    "licenseExpiryDate": "08/17/2026 00:00:00"
  },
  {
    "id": "afc982e5-289d-4aca-aeee-f22f7c8b051e",
    "slug": "paul-richard-coates",
    "name": "PAUL RICHARD COATES",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/06/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Paul Richard Coates",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_afc982e5-289d-4aca-aeee-f22f7c8b051e",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-00173",
    "licenseIssueDate": "06/27/2018 00:00:00",
    "licenseExpiryDate": "06/25/2026 00:00:00"
  },
  {
    "id": "09f1c9a4-7921-4abd-a441-7937ab36bf9a",
    "slug": "paul-richard-woodward",
    "name": "PAUL RICHARD WOODWARD",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/04/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Paul Richard Woodward",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_09f1c9a4-7921-4abd-a441-7937ab36bf9a",
        "address": "",
        "phone": "97145124129 / 971547315151",
        "email": "ryan@constructionlaw.co.za",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9b87f290-69e4-4ce7-abac-c0457574a0a5",
    "firmName": "Tiefenthaler Attorneys Incorporated - Dubai Branch",
    "registrationNumber": "L-06756",
    "licenseIssueDate": "04/23/2025 00:00:00",
    "licenseExpiryDate": "04/22/2026 00:00:00"
  },
  {
    "id": "7a84d893-761f-4ee9-af83-b49b04c07091",
    "slug": "paul-scarr",
    "name": "Paul Scarr",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/14/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Paul Scarr",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7a84d893-761f-4ee9-af83-b49b04c07091",
        "address": "IH-00-01-CP-05 ,DIFC ,506832 ,",
        "phone": "/ 971506957753",
        "email": "admin@supportlegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "1607c199-ca4b-4bc1-89e9-98dad0300645",
    "firmName": "Support Legal ( DIFC) Limited",
    "registrationNumber": "L-00785",
    "licenseIssueDate": "03/14/2022 00:00:00",
    "licenseExpiryDate": "03/13/2026 00:00:00"
  },
  {
    "id": "20ac436c-c886-4a64-b6be-473dc05a5074",
    "slug": "paul-taylor",
    "name": "PAUL DAVID TAYLOR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Paul Taylor",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_20ac436c-c886-4a64-b6be-473dc05a5074",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-00764",
    "licenseIssueDate": "02/22/2012 00:00:00",
    "licenseExpiryDate": "02/13/2026 00:00:00"
  },
  {
    "id": "e83a5b6d-2f68-4737-a4ac-01c325f86138",
    "slug": "paul-wynne",
    "name": "PAUL JOSEPH WYNNE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/05/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Paul Wynne",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e83a5b6d-2f68-4737-a4ac-01c325f86138",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-02495",
    "licenseIssueDate": "05/21/2014 00:00:00",
    "licenseExpiryDate": "05/15/2026 00:00:00"
  },
  {
    "id": "a97b6195-7b40-41ff-835b-5d409bb37359",
    "slug": "paula-guevara",
    "name": "PAULA VILLEGAS GUEVARA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Commercial Agency",
      "Commercial Transactions-Commercial Contracts",
      "Commercial Transactions-Commercial Companies"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/04/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Paula Guevara",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a97b6195-7b40-41ff-835b-5d409bb37359",
        "address": "",
        "phone": "97144230000 / 971552009022",
        "email": "UAE-CourtClerks@habibalmulla.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3eba82bb-8ec4-4cbd-80d0-a793cb993fde",
    "firmName": "Habib Al Mulla & Partners ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03707",
    "licenseIssueDate": "04/20/2017 00:00:00",
    "licenseExpiryDate": "04/17/2026 00:00:00"
  },
  {
    "id": "a4491b26-4740-4244-88d3-e304fbfd6a0e",
    "slug": "paulo-henrique-teixeira-rage",
    "name": "PAULO HENRIQUE TEIXEIRA RAGE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/05/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Paulo Henrique Teixeira Rage",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a4491b26-4740-4244-88d3-e304fbfd6a0e",
        "address": "Index Tower ,Dubai International Financial Centre ,507115 ,",
        "phone": "97143757160 / 971523490280",
        "email": "tthraya@mayerbrown.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c7f52b69-c049-4246-963a-9805b241f88a",
    "firmName": "Mayer Brown LLP",
    "registrationNumber": "L-06315",
    "licenseIssueDate": "05/22/2024 00:00:00",
    "licenseExpiryDate": "05/21/2026 00:00:00"
  },
  {
    "id": "50a8ef53-1659-424a-8c3c-ac144aa7643c",
    "slug": "pavel-sukholinskiy",
    "name": "PAVEL SUKHOLINSKIY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/11/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Pavel Sukholinskiy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_50a8ef53-1659-424a-8c3c-ac144aa7643c",
        "address": "",
        "phone": "/ 971527856097",
        "email": "roman_zhavner@epamlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e2c7ecee-1913-48a7-a833-a10d08f984f4",
    "firmName": "EPAM Legal LLC",
    "registrationNumber": "L-06077",
    "licenseIssueDate": "11/06/2023 00:00:00",
    "licenseExpiryDate": "11/05/2025 00:00:00"
  },
  {
    "id": "b28e8d54-89e8-4912-905f-8aed83429619",
    "slug": "pawel-janusz-szaja",
    "name": "PAWEL JANUSZ SZAJA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/09/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Pawel Janusz Szaja",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b28e8d54-89e8-4912-905f-8aed83429619",
        "address": "",
        "phone": "97145953601 / 971508728645",
        "email": "Steven.Bainbridge@gtlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b4146aa6-efd1-41d7-819d-49da46353b0b",
    "firmName": "Greenberg Traurig Limited",
    "registrationNumber": "L-04983",
    "licenseIssueDate": "09/25/2024 00:00:00",
    "licenseExpiryDate": "09/24/2026 00:00:00"
  },
  {
    "id": "96c0f1c9-fa69-4b3c-a772-040649cffde4",
    "slug": "payam-beheshti",
    "name": "PAYAM BEHESHTI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/05/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Payam Beheshti",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_96c0f1c9-fa69-4b3c-a772-040649cffde4",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506688 ,Dubai",
        "phone": "97147096600 / 971503556811",
        "email": "muneer.khan@simmons-simmons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d1725ca7-06ac-41b2-8d7b-a6e60665b73d",
    "firmName": "Simmons & Simmons (Middle East) LLP-DIFC",
    "registrationNumber": "L-00176",
    "licenseIssueDate": "05/13/2020 00:00:00",
    "licenseExpiryDate": "05/12/2026 00:00:00"
  },
  {
    "id": "bab6e737-5ee6-4d27-b44b-c5a5ee5557a3",
    "slug": "payel-guatam-mazumdar-mazumdar",
    "name": "PAYEL GAUTAM MAZUMDAR MAZUMDAR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/11/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-11-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Payel Guatam Mazumdar Mazumdar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bab6e737-5ee6-4d27-b44b-c5a5ee5557a3",
        "address": "",
        "phone": "97144230000 / 971552009022",
        "email": "UAE-CourtClerks@habibalmulla.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3eba82bb-8ec4-4cbd-80d0-a793cb993fde",
    "firmName": "Habib Al Mulla & Partners ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06122",
    "licenseIssueDate": "11/24/2023 00:00:00",
    "licenseExpiryDate": "11/23/2025 00:00:00"
  },
  {
    "id": "0d7aed9f-dd4f-4181-aaaa-63d50753775f",
    "slug": "perla-baaklini",
    "name": "Perla Baaklini",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/17/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Perla Baaklini",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0d7aed9f-dd4f-4181-aaaa-63d50753775f",
        "address": "South Tower, Emirates Financial Towers ,DIFC ,482025 ,",
        "phone": "97145875333 / 971503444388",
        "email": "c.dersahakian@cvml.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e2c6db70-04e7-4c7b-882a-6d2ffe4469ed",
    "firmName": "CVML Limited",
    "registrationNumber": "L-05831",
    "licenseIssueDate": "05/17/2023 00:00:00",
    "licenseExpiryDate": "05/16/2026 00:00:00"
  },
  {
    "id": "6c9f85cd-e923-4e37-9c55-8020279342df",
    "slug": "perla-michel-el-choueiry",
    "name": "PERLA MICHEL EL CHOUEIRY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/05/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Perla Michel El Choueiry",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6c9f85cd-e923-4e37-9c55-8020279342df",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-04422",
    "licenseIssueDate": "05/29/2019 00:00:00",
    "licenseExpiryDate": "05/28/2026 00:00:00"
  },
  {
    "id": "02149648-fd97-42e8-917e-e067eff9ca16",
    "slug": "perpetua-socorro-gracias",
    "name": "Perpetua Socorro Gracias",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/10/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2021-09-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Perpetua Socorro Gracias",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_02149648-fd97-42e8-917e-e067eff9ca16",
        "address": "الطابق الخامس ,الساحة ,سوق البحار ,26011 ,Dubai",
        "phone": "97142277717",
        "email": "info@alsahlawico.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a6811a79-5470-4c33-ad95-3ff8f661c052",
    "firmName": "AL SAHLAWI & CO ADVOCATES & CONSULTANTS",
    "registrationNumber": "L-01846",
    "licenseIssueDate": "10/05/2011 00:00:00",
    "licenseExpiryDate": "09/26/2021 00:00:00"
  },
  {
    "id": "5db09747-6776-4bb4-9a4e-89f7c1a74675",
    "slug": "pervez-akhtar",
    "name": "PERVEZ AKHTAR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/09/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Pervez Akhtar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5db09747-6776-4bb4-9a4e-89f7c1a74675",
        "address": "0 ,ICD Brookfield Place Level 13 ,Trade Centre ,506569 ,Dubai",
        "phone": "97145099100 / 971501006965",
        "email": "menahr@freshfields.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "970f6246-e737-41a7-9c6c-5aa5b8335d45",
    "firmName": "Freshfields LLP DIFC",
    "registrationNumber": "L-00585",
    "licenseIssueDate": "09/08/2011 00:00:00",
    "licenseExpiryDate": "08/30/2026 00:00:00"
  },
  {
    "id": "11d6f9ec-5c92-4095-9331-0afd54164cdd",
    "slug": "peter-bowring",
    "name": "Peter Bowring",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/29/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2019-01-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Peter Bowring",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_11d6f9ec-5c92-4095-9331-0afd54164cdd",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-03617",
    "licenseIssueDate": "01/29/2017 00:00:00",
    "licenseExpiryDate": "01/27/2019 00:00:00"
  },
  {
    "id": "36aed348-7ec7-446c-8505-65ce378c2a6a",
    "slug": "peter-ellingham",
    "name": "PETER WILLIAM JOHN ELLINGHAM",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Civil Transactions-Insurance"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/01/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Peter Ellingham",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_36aed348-7ec7-446c-8505-65ce378c2a6a",
        "address": "Building 5 ,Dubai World Trade Centre ,212620 ,",
        "phone": "97143503600 / 971563631562",
        "email": "p.ellingham@kennedys-law.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "83d3ede1-3a28-4b03-8c92-6bd31a1cb95e",
    "firmName": "Kennedys Dubai LLP",
    "registrationNumber": "L-01153",
    "licenseIssueDate": "01/21/2013 00:00:00",
    "licenseExpiryDate": "01/13/2026 00:00:00"
  },
  {
    "id": "e7fe951d-a1f6-42fe-a0f7-94db05408477",
    "slug": "peter-greatrex",
    "name": "PETER JOHN WILLIAM GREATREX",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/09/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Peter Greatrex",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e7fe951d-a1f6-42fe-a0f7-94db05408477",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-03858",
    "licenseIssueDate": "09/20/2017 00:00:00",
    "licenseExpiryDate": "09/17/2026 00:00:00"
  },
  {
    "id": "da7ec0bb-8ca2-4387-907d-80c1cac5ba5d",
    "slug": "peter-hodgins",
    "name": "PETER JOHN HODGINS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/10/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Peter Hodgins",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_da7ec0bb-8ca2-4387-907d-80c1cac5ba5d",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-00314",
    "licenseIssueDate": "10/11/2011 00:00:00",
    "licenseExpiryDate": "10/02/2026 00:00:00"
  },
  {
    "id": "90ddeaf4-41dc-4550-b47a-065cec43a8ce",
    "slug": "peter-jack-anagnostou",
    "name": "PETER JACK ANAGNOSTOU",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/03/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Peter Jack Anagnostou",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_90ddeaf4-41dc-4550-b47a-065cec43a8ce",
        "address": "Level 17, ICD Brookfield Place ,DIFC ,506503 ,",
        "phone": "97144375100 / 971588271196",
        "email": "libby.edwards-smith@gowlingwlg.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "436703ba-b9c0-4dcb-93b2-1299c7a051f4",
    "firmName": "Gowling WLG (UK) LLP (Dubai Branch)",
    "registrationNumber": "L-02167",
    "licenseIssueDate": "03/07/2024 00:00:00",
    "licenseExpiryDate": "03/06/2026 00:00:00"
  },
  {
    "id": "fcb9571b-2dc7-4454-b782-178db99bbdd0",
    "slug": "peter-michael-harry-cullen",
    "name": "Peter Michael Harry Cullen",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/03/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Peter Michael Harry Cullen",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fcb9571b-2dc7-4454-b782-178db99bbdd0",
        "address": "ICD Brookfield Place ,DIFC ,506516 ,",
        "phone": "97143695800 / 971505526206",
        "email": "scott.campbell@linklaters.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5cec94c0-0649-43b6-a2be-ab17ff422bce",
    "firmName": "LinkLaters LLP",
    "registrationNumber": "L-04155",
    "licenseIssueDate": "07/03/2018 00:00:00",
    "licenseExpiryDate": "07/01/2026 00:00:00"
  },
  {
    "id": "5fa70185-a0a8-4a7a-8330-ca88c83cb215",
    "slug": "peter-schluter",
    "name": "PETER SCHLUTER",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/11/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Peter Schluter",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5fa70185-a0a8-4a7a-8330-ca88c83cb215",
        "address": "A7 ,Dubai Silicon Oasis ,29337 ,",
        "phone": "97144313060 / 971528448686",
        "email": "andres.ring@schlueter-graf.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2ce110f0-b433-4dbc-b15f-ab1a3b291c28",
    "firmName": "Schluter Graf Legal Consultants LLC",
    "registrationNumber": "L-00389",
    "licenseIssueDate": "11/22/2011 00:00:00",
    "licenseExpiryDate": "11/13/2025 00:00:00"
  },
  {
    "id": "924c3e7c-fd86-4be5-aaa6-b6fd834f2ee6",
    "slug": "peter-smith",
    "name": "PETER OLIVER SMITH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Cases and Proceedings before Dubai International Financial Centre",
      "Civil Transactions-Construction and Contracts for Services",
      "Civil Transactions-HR & Employee Affairs",
      "Commercial Transactions-Bankruptcy",
      "Civil Transactions-Arbitration",
      "Personal Status-Legacies and Inheritance",
      "Commercial Transactions-Commercial Companies",
      "Commercial Transactions-Banking Operations",
      "Civil Transactions-Labor & Workers",
      "Proceedings-Cases and Proceedings before arbitral tribunals and other alternative dispute resolution bodies",
      "Criminal Law-Cybercrimes"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/01/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Peter Smith",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_924c3e7c-fd86-4be5-aaa6-b6fd834f2ee6",
        "address": "20 ,Index Tower West Tower ,DIFC ,507226 ,Dubai",
        "phone": "97142461900 / 971523391604",
        "email": "patrick.gearon@crsblaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e2ac552e-b9a7-450b-a84d-15119e583220",
    "firmName": "Charles Russell Speechlys LLP",
    "registrationNumber": "L-03618",
    "licenseIssueDate": "01/29/2017 00:00:00",
    "licenseExpiryDate": "01/25/2026 00:00:00"
  },
  {
    "id": "583cb736-76b1-4a61-8148-fd7e78caa0aa",
    "slug": "peter-somekh",
    "name": "PETER ANTHONY NICHOLAS SOMEKH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Peter Somekh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_583cb736-76b1-4a61-8148-fd7e78caa0aa",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-00672",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "4f3c7d13-e25d-4a08-99e0-c991bde0df50",
    "slug": "petru-nedelcu",
    "name": "Petru Nedelcu",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/17/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Petru Nedelcu",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4f3c7d13-e25d-4a08-99e0-c991bde0df50",
        "address": "4th floor ,Al Saaha Offices Block D office 401A ,Burj Khalifa ,283773 ,Dubai",
        "phone": "97144221944",
        "email": "gov.depts@alsafarpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b7bbfaeb-1fdb-46d2-97cf-8e6432a9b8a7",
    "firmName": "AL SAFAR & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03861",
    "licenseIssueDate": "09/17/2017 00:00:00",
    "licenseExpiryDate": "09/14/2026 00:00:00"
  },
  {
    "id": "6c572fb7-285a-4172-8f0e-dd908516663d",
    "slug": "philip-clarke",
    "name": "PHILIP CLARKE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/02/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Philip Clarke",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6c572fb7-285a-4172-8f0e-dd908516663d",
        "address": "",
        "phone": "97144073901 / 971503479508",
        "email": "Rania.Tadros@stephensonharwood.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dd5042a2-bb41-4123-9544-79c3fa831332",
    "firmName": "Stephenson Harwood (Middle East) LLP",
    "registrationNumber": "L-05196",
    "licenseIssueDate": "02/15/2022 00:00:00",
    "licenseExpiryDate": "02/14/2026 00:00:00"
  },
  {
    "id": "26c6318c-9784-4ca0-92a9-1456735de6e2",
    "slug": "philip-dowsett",
    "name": "PHILIP RICHARD DOWSETT",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/09/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Philip Dowsett",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_26c6318c-9784-4ca0-92a9-1456735de6e2",
        "address": "6 ,Office Nos. 603, 604 & 605, Level 6, Burj Daman ,Dubai International Financial Centre ,506555 ,Dubai",
        "phone": "97143506400 / 971504654755",
        "email": "r.hickman@aglaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8690f7d5-6b96-4649-9589-71303f2c2707",
    "firmName": "Addleshaw Goddard (Middle East) LLP",
    "registrationNumber": "L-00517",
    "licenseIssueDate": "09/24/2014 00:00:00",
    "licenseExpiryDate": "09/18/2026 00:00:00"
  },
  {
    "id": "d68f1f9a-8a87-41e1-8cf0-60ba0fafcfbc",
    "slug": "philip-hanson",
    "name": "PHILIP MATTHEW HANSON",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/07/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Philip Hanson",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d68f1f9a-8a87-41e1-8cf0-60ba0fafcfbc",
        "address": "",
        "phone": "97144286300 / 971506256686",
        "email": "stuart.paterson@hsf.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2f0389b3-bfde-44f4-bdd6-6e1a22f9cab2",
    "firmName": "Herbert Smith Freehills Kramer LLP",
    "registrationNumber": "L-02298",
    "licenseIssueDate": "07/09/2014 00:00:00",
    "licenseExpiryDate": "07/03/2026 00:00:00"
  },
  {
    "id": "e16d8b35-02e4-4ac2-ac69-ef6024572b75",
    "slug": "philip-ireland",
    "name": "PHILIP JAMES IRELAND",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Philip Ireland",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e16d8b35-02e4-4ac2-ac69-ef6024572b75",
        "address": "Level 14 ,Burj Daman ,Four Seasons Hotel ,119980 ,Dubai",
        "phone": "97143604070 / 971502450485",
        "email": "Philip.ireland@maples.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "cb7cc285-8538-469a-b075-ef30819bce69",
    "firmName": "Maples & Calder (Dubai) LLP",
    "registrationNumber": "L-00594",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "02bd45e1-c920-444d-8e9c-ff895f6cf22a",
    "slug": "philip-james-devenish",
    "name": "PHILIP JAMES DEVENISH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/03/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Philip James Devenish",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_02bd45e1-c920-444d-8e9c-ff895f6cf22a",
        "address": "",
        "phone": "97147098484 / 971505577206",
        "email": "slshadmand@jonesday.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8892bfe9-d3ec-4158-b4fd-1844606f4f30",
    "firmName": "Jones Day",
    "registrationNumber": "L-05741",
    "licenseIssueDate": "03/22/2023 00:00:00",
    "licenseExpiryDate": "03/21/2026 00:00:00"
  },
  {
    "id": "79e5f3fd-42dc-46da-83e6-78c4dc320179",
    "slug": "philip-michael-chalmers",
    "name": "PHILIP MICHAEL CHALMERS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/07/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Philip Michael Chalmers",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_79e5f3fd-42dc-46da-83e6-78c4dc320179",
        "address": "6 ,Office Nos. 603, 604 & 605, Level 6, Burj Daman ,Dubai International Financial Centre ,506555 ,Dubai",
        "phone": "97143506400 / 971504654755",
        "email": "r.hickman@aglaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8690f7d5-6b96-4649-9589-71303f2c2707",
    "firmName": "Addleshaw Goddard (Middle East) LLP",
    "registrationNumber": "L-04167",
    "licenseIssueDate": "07/24/2018 00:00:00",
    "licenseExpiryDate": "07/22/2026 00:00:00"
  },
  {
    "id": "b56411dc-1e6d-4a8c-88eb-291e3cf96111",
    "slug": "philip-oriordan",
    "name": "PHILIP JAMES ORIORDAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/10/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Philip O'Riordan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b56411dc-1e6d-4a8c-88eb-291e3cf96111",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-00315",
    "licenseIssueDate": "10/11/2011 00:00:00",
    "licenseExpiryDate": "10/02/2026 00:00:00"
  },
  {
    "id": "94a93c34-dacd-4c69-950e-f2be92d23a15",
    "slug": "philip-smith",
    "name": "PHILIP JONATHAN CORFIELD SMITH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Philip Smith",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_94a93c34-dacd-4c69-950e-f2be92d23a15",
        "address": "",
        "phone": "97143897000 / 971506553198",
        "email": "nasseralikhasawneh@eversheds-sutherland.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "74a21d43-41d8-480a-a6af-6939b7c98a95",
    "firmName": "Pinsent Masons LLP - Dubai Branch",
    "registrationNumber": "L-00917",
    "licenseIssueDate": "10/31/2024 00:00:00",
    "licenseExpiryDate": "10/30/2025 00:00:00"
  },
  {
    "id": "46779006-76c9-4a6c-b24b-b9bc80d1dbda",
    "slug": "philip-zacharias-vavalidis",
    "name": "PHILIP ZACHARIAS VAVALIDIS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQWgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/01/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Philip Zacharias Vavalidis",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_46779006-76c9-4a6c-b24b-b9bc80d1dbda",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-04561",
    "licenseIssueDate": "01/13/2025 00:00:00",
    "licenseExpiryDate": "01/12/2026 00:00:00"
  },
  {
    "id": "48f86888-be52-4fdf-ab9d-3442059533c2",
    "slug": "philippe-habib",
    "name": "PHILIPPE HABIB",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/06/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Philippe Habib",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_48f86888-be52-4fdf-ab9d-3442059533c2",
        "address": "",
        "phone": "97143826100 / 971507380618",
        "email": "jmiocevic@curtis.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0867bcc5-10fa-4783-91ae-b8f63e02e81a",
    "firmName": "Curtis Mallet-Prevost, Colt & Mosle LLP",
    "registrationNumber": "L-03774",
    "licenseIssueDate": "06/15/2017 00:00:00",
    "licenseExpiryDate": "06/12/2026 00:00:00"
  },
  {
    "id": "60b6d9e3-ba5d-4d74-a952-4855d2f62457",
    "slug": "philippine-marie-michele-lagroy-de-croutte-de-saint-martin",
    "name": "PHILIPPINE MARIE MICHELE LAGROY DE CROUTTE DE SAINT MARTIN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/10/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Philippine Marie Michele Lagroy De Croutte De Saint Martin",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_60b6d9e3-ba5d-4d74-a952-4855d2f62457",
        "address": "1 ,Emaar Square 5 ,sheikh mohammed bin rashid BVD ,11987 ,Dubai",
        "phone": "97143043100 / 971507325154",
        "email": "amir.kordvani@pwc.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ea026b18-c93c-4f67-a1f2-4546320f8f3e",
    "firmName": "PWC Legal Middle East LLP",
    "registrationNumber": "L-06519",
    "licenseIssueDate": "10/09/2024 00:00:00",
    "licenseExpiryDate": "10/08/2026 00:00:00"
  },
  {
    "id": "443b401c-e104-435d-bcfb-eba0ec72304d",
    "slug": "phillip-john-shaw",
    "name": "PHILLIP JOHN SHAW",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/07/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Phillip John Shaw",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_443b401c-e104-435d-bcfb-eba0ec72304d",
        "address": "ICD Brookfield Place ,DIFC ,506516 ,",
        "phone": "97143695800 / 971505526206",
        "email": "scott.campbell@linklaters.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5cec94c0-0649-43b6-a2be-ab17ff422bce",
    "firmName": "LinkLaters LLP",
    "registrationNumber": "L-06391",
    "licenseIssueDate": "07/24/2024 00:00:00",
    "licenseExpiryDate": "07/23/2026 00:00:00"
  },
  {
    "id": "775ef5b5-1376-4f45-8c10-a17f30fbe2fb",
    "slug": "phillip-sacks",
    "name": "PHILLIP CHARLES SACKS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/11/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Phillip Sacks",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_775ef5b5-1376-4f45-8c10-a17f30fbe2fb",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-00818",
    "licenseIssueDate": "11/22/2011 00:00:00",
    "licenseExpiryDate": "11/13/2025 00:00:00"
  },
  {
    "id": "2d2f2162-8947-4c08-b170-ed5235020a4d",
    "slug": "phillipa-english",
    "name": "Phillipa English",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/10/2023",
    "licenseStatus": "active",
    "licenseExpiry": "2024-10-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Phillipa English",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2d2f2162-8947-4c08-b170-ed5235020a4d",
        "address": "",
        "phone": "97144073901 / 971503479508",
        "email": "Rania.Tadros@stephensonharwood.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dd5042a2-bb41-4123-9544-79c3fa831332",
    "firmName": "Stephenson Harwood (Middle East) LLP",
    "registrationNumber": "L-02929",
    "licenseIssueDate": "10/30/2023 00:00:00",
    "licenseExpiryDate": "10/29/2025 00:00:00"
  },
  {
    "id": "51be1370-cb72-465a-be48-80799f7b1b9c",
    "slug": "pierre-heitzmann",
    "name": "PIERRE ROBERT FRANCOIS HEITZMANN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Pierre Heitzmann",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_51be1370-cb72-465a-be48-80799f7b1b9c",
        "address": "",
        "phone": "97147098484 / 971505577206",
        "email": "slshadmand@jonesday.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8892bfe9-d3ec-4158-b4fd-1844606f4f30",
    "firmName": "Jones Day",
    "registrationNumber": "L-01136",
    "licenseIssueDate": "02/06/2012 00:00:00",
    "licenseExpiryDate": "01/28/2026 00:00:00"
  },
  {
    "id": "47914d52-9a3e-4a9c-a2a5-b8144d6e5645",
    "slug": "pierre-lucas",
    "name": "PIERRE YVES DANIEL LUCAS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/11/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Pierre Lucas",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_47914d52-9a3e-4a9c-a2a5-b8144d6e5645",
        "address": "",
        "phone": "97143467303 / 971506565383",
        "email": "rycx@rycx-advocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7a4cdbcc-cf3b-4347-b745-b8e670c81ca0",
    "firmName": "Rycx Legal Consultants",
    "registrationNumber": "L-03307",
    "licenseIssueDate": "11/04/2015 00:00:00",
    "licenseExpiryDate": "10/30/2026 00:00:00"
  },
  {
    "id": "e5129d33-5c60-4721-a734-5345df43e62e",
    "slug": "pierre-mehawej",
    "name": "PIERRE MILAD MEHAWEJ",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Pierre Mehawej",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e5129d33-5c60-4721-a734-5345df43e62e",
        "address": "samer tohme ,4th- office 433 ,Emarat Atrium ,Dubai Canal ,79436 ,Dubai",
        "phone": "97126722500",
        "email": "info@dxblawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "00b6334f-44e7-458e-8ce5-7d4256840067",
    "firmName": "MOHAMED ABDULLA LAWYERS AND LEGAL CONSULTANTS",
    "registrationNumber": "L-01475",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "93b18fee-9528-49a5-9aa5-3249b4019eb0",
    "slug": "piers-andrew-douglas-drysdale",
    "name": "PIERS ANDREW DOUGLAS DRYSDALE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/07/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Piers Andrew Douglas Drysdale",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_93b18fee-9528-49a5-9aa5-3249b4019eb0",
        "address": "Hamdan Abdullah Abdulrahman Ali Alharmi ,2 office 211 ,MSM 1 ,Auto Land Motors ,6064 ,Dubai",
        "phone": "97142999559",
        "email": "hamdan@harmilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b0830edc-21a4-4df9-9d83-febcab7756da",
    "firmName": "HAMDAN AL HARMI & ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05387",
    "licenseIssueDate": "07/20/2022 00:00:00",
    "licenseExpiryDate": "07/19/2026 00:00:00"
  },
  {
    "id": "b85308c0-7088-4ac7-9c61-8a4e07eee4cd",
    "slug": "portia-catherine-clare-cox",
    "name": "PORTIA CATHERINE CLARE COX",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/07/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Portia Catherine Clare Cox",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b85308c0-7088-4ac7-9c61-8a4e07eee4cd",
        "address": "",
        "phone": "97144286300 / 971506256686",
        "email": "stuart.paterson@hsf.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2f0389b3-bfde-44f4-bdd6-6e1a22f9cab2",
    "firmName": "Herbert Smith Freehills Kramer LLP",
    "registrationNumber": "L-06433",
    "licenseIssueDate": "07/24/2024 00:00:00",
    "licenseExpiryDate": "07/23/2026 00:00:00"
  },
  {
    "id": "c2d3055f-6a22-4407-819d-526010aabb8a",
    "slug": "prachi-trivedi",
    "name": "PRACHI TRIVEDI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/02/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Prachi Trivedi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c2d3055f-6a22-4407-819d-526010aabb8a",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-04280",
    "licenseIssueDate": "02/21/2025 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "64fb0f08-fc92-4c4e-893b-ea056581c91e",
    "slug": "prakruthi-panchalingegowda-panchegowda",
    "name": "PRAKRUTHI PANCHALINGEGOWDA PANCHEGOWDA PANCHALINGEGOWDA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/08/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Prakruthi Panchalingegowda Panchegowda",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_64fb0f08-fc92-4c4e-893b-ea056581c91e",
        "address": "ICD Brookfield Place ,Za'abeel 2 ,103747 ,",
        "phone": "97143696300 / 971506008159",
        "email": "mohammed.paracha@nortonrosefulbright.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c4aaee93-0ec4-4982-9a48-a23699492056",
    "firmName": "Norton Rose Fullbright (Middle East) LLP",
    "registrationNumber": "L-05972",
    "licenseIssueDate": "08/16/2023 00:00:00",
    "licenseExpiryDate": "08/15/2026 00:00:00"
  },
  {
    "id": "7abe72b7-282d-44c0-9436-cc3f030713b9",
    "slug": "pratheesh-prameela-radhakrishnan-nair",
    "name": "PRATHEESH PRAMEELA RADHAKRISHNAN NAIR RADHAKRISHNAN NAIR KOCHU GOVINDA PILLA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/08/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: PRATHEESH PRAMEELA RADHAKRISHNAN NAIR",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7abe72b7-282d-44c0-9436-cc3f030713b9",
        "address": "HOSSAM GAMAL MOHAMED ELSOKARY ,26 ,Citadel tower ,Marasi Drive ,5586 ,Dubai",
        "phone": "97142555110",
        "email": "fetouh@alnassar.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "83443142-de5a-4089-8798-9ed25b7885de",
    "firmName": "AL NASSAR ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04469",
    "licenseIssueDate": "08/13/2024 00:00:00",
    "licenseExpiryDate": "08/12/2026 00:00:00"
  },
  {
    "id": "f756f4eb-5ec4-454f-8a2a-82f261f8e919",
    "slug": "prema-maria-govind",
    "name": "PREMA MARIA GOVIND HITTI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/09/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Prema Maria Govind",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f756f4eb-5ec4-454f-8a2a-82f261f8e919",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-06517",
    "licenseIssueDate": "09/25/2024 00:00:00",
    "licenseExpiryDate": "09/24/2026 00:00:00"
  },
  {
    "id": "e04b563f-fbb4-4839-9241-a896b2140c78",
    "slug": "prince-chanai",
    "name": "PRINCE CHANAI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/10/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: PRINCE CHANAI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e04b563f-fbb4-4839-9241-a896b2140c78",
        "address": "3-505 ,AL KHABEESI BLDG ,AL KABEESI ,4948 ,Dubai",
        "phone": "97142222228",
        "email": "info@alkamali.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "054f38f4-9e51-4623-ad36-7941043a051c",
    "firmName": "AL KAMALI & COMPANY ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-04778",
    "licenseIssueDate": "10/14/2020 00:00:00",
    "licenseExpiryDate": "10/13/2025 00:00:00"
  },
  {
    "id": "3ab6ff02-5634-4c93-8e07-366ddaa39e0c",
    "slug": "priti-dugar",
    "name": "PRITI DUGAR ASHIT JAGAT SINGH DUGAR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/09/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: priti dugar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3ab6ff02-5634-4c93-8e07-366ddaa39e0c",
        "address": "Sara Shah Baik Elbloshi ,الطابق 13 - مكتب 1306 ,CLOVER BAY ,بجوار SONDER HOTEL ,112773 ,Dubai",
        "phone": "97143514666",
        "email": "admin@saraadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9271d191-2f3e-4570-93bf-34fb919bf6e0",
    "firmName": "SARA ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-04741",
    "licenseIssueDate": "09/24/2020 00:00:00",
    "licenseExpiryDate": "09/23/2026 00:00:00"
  },
  {
    "id": "86601893-8363-4b63-80b4-18a87268078e",
    "slug": "priya-tanu-shah",
    "name": "PRIYA TANU SHAH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/08/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Priya Tanu Shah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_86601893-8363-4b63-80b4-18a87268078e",
        "address": "Index Tower ,Dubai International Financial Centre ,507115 ,",
        "phone": "97143757160 / 971523490280",
        "email": "tthraya@mayerbrown.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c7f52b69-c049-4246-963a-9805b241f88a",
    "firmName": "Mayer Brown LLP",
    "registrationNumber": "L-06922",
    "licenseIssueDate": "08/18/2025 00:00:00",
    "licenseExpiryDate": "08/17/2026 00:00:00"
  },
  {
    "id": "9b4573df-d417-4318-a0e8-4fccec4fab88",
    "slug": "pro-lc1-desc",
    "name": "Pro LC1 (DESC)",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/09/2021",
    "licenseStatus": "active",
    "licenseExpiry": "2022-09-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Pro LC1 (DESC)",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9b4573df-d417-4318-a0e8-4fccec4fab88",
        "address": "",
        "phone": "97140000000 / 971508360023",
        "email": "annadurai@legal.dubai.gov.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "34535f10-f4ea-464a-93a1-5337328fdd81",
    "firmName": "Pro LCF1 (DESC)"
  },
  {
    "id": "0a9f1db0-f0ed-4601-b45c-9a66edbdc538",
    "slug": "pronnoy-kishore-sengupta",
    "name": "PRONNOY KISHORE SENGUPTA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/03/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Pronnoy Kishore Sengupta",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0a9f1db0-f0ed-4601-b45c-9a66edbdc538",
        "address": "ICD-Brookfield Place ,DIFC ,119974 ,",
        "phone": "97143652000",
        "email": "david.charlier@ashurst.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c01c3c61-4d90-4058-8429-61dd01e615f5",
    "firmName": "Ashurst LLP-DIFC",
    "registrationNumber": "L-05274"
  },
  {
    "id": "273bbba4-50b5-4f1e-ad0a-c7fec36a6e96",
    "slug": "punte-a-hosseini",
    "name": "PUNTE A HOSSEINI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/10/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Punte-A Hosseini",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_273bbba4-50b5-4f1e-ad0a-c7fec36a6e96",
        "address": "",
        "phone": "97144073901 / 971503479508",
        "email": "Rania.Tadros@stephensonharwood.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dd5042a2-bb41-4123-9544-79c3fa831332",
    "firmName": "Stephenson Harwood (Middle East) LLP",
    "registrationNumber": "L-06558",
    "licenseIssueDate": "10/16/2024 00:00:00",
    "licenseExpiryDate": "10/15/2026 00:00:00"
  },
  {
    "id": "5eae5a65-ab70-4f5b-b1ba-0473768d1dd8",
    "slug": "qasim-aslam",
    "name": "QASIM ALI ASLAM",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBRQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Qasim Aslam",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5eae5a65-ab70-4f5b-b1ba-0473768d1dd8",
        "address": "",
        "phone": "97144020800 / 971566830829",
        "email": "dean.ryburn@dentons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dfe13b7e-6625-45fd-ad63-9ee83af41194",
    "firmName": "Dentons & Co Dubai Branch-DED",
    "registrationNumber": "L-00423",
    "licenseIssueDate": "02/25/2012 00:00:00",
    "licenseExpiryDate": "02/16/2026 00:00:00"
  },
  {
    "id": "de45292e-56fd-47b1-ad0c-110ec36bccc2",
    "slug": "qays-alzubi",
    "name": "Qays Alzubi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBRQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Qays Alzubi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_de45292e-56fd-47b1-ad0c-110ec36bccc2",
        "address": "Emirates Tower LLC ,Trade Centre 2 Dubai ,487915 ,",
        "phone": "97145548182 / 971559921117",
        "email": "hqzubi@zubipartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "f18ce257-9c27-4dbc-8186-c51fff8ec4f9",
    "firmName": "Al Zubi & Partners Legal Consultants",
    "registrationNumber": "L-00440",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "5643d2d6-0aa0-4e2b-998c-92fb7bd0fd74",
    "slug": "qudeer-latif",
    "name": "QUDEER LATIF",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBRTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Qudeer Latif",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5643d2d6-0aa0-4e2b-998c-92fb7bd0fd74",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-00179",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "db71ae7a-c55a-456c-9af6-9c8eb20b8eaf",
    "slug": "raahil-mirchandani",
    "name": "RAAHIL MAHESH MIRCHANDANI MAHESH PARSRAM MIRCHANDANI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/07/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Raahil Mirchandani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_db71ae7a-c55a-456c-9af6-9c8eb20b8eaf",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-06428",
    "licenseIssueDate": "07/24/2024 00:00:00",
    "licenseExpiryDate": "07/23/2026 00:00:00"
  },
  {
    "id": "6b5310dd-1edc-4751-afbd-f38e70c08dfa",
    "slug": "rabie-abdel-halim-ahmed",
    "name": "RABIE RAMADAN ABDEL HALIM AHMED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/06/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rabie Abdel-Halim Ahmed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6b5310dd-1edc-4751-afbd-f38e70c08dfa",
        "address": "4TH FLOOR ,AL HARTHY ,DUBAI CUSTOMS ,34143 ,Dubai",
        "phone": "97143930039",
        "email": "admin@advocatesuae.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4e22d3f8-438f-4c16-9a7f-91e6e29dc5f6",
    "firmName": "AL MATROOSHI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-01420",
    "licenseIssueDate": "06/26/2014 00:00:00",
    "licenseExpiryDate": "06/20/2026 00:00:00"
  },
  {
    "id": "164390b3-8887-4671-bc9f-6d69d80560d1",
    "slug": "rabih-tabbara",
    "name": "RABIH TABBARA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rabih Tabbara",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_164390b3-8887-4671-bc9f-6d69d80560d1",
        "address": "",
        "phone": "97144230000 / 971552009022",
        "email": "UAE-CourtClerks@habibalmulla.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3eba82bb-8ec4-4cbd-80d0-a793cb993fde",
    "firmName": "Habib Al Mulla & Partners ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-00926",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "72e4368d-bc9e-488b-9b6d-c1a3674340ed",
    "slug": "rachael-elizabeth-norris",
    "name": "RACHAEL ELIZABETH JARVIS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/10/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rachael Elizabeth Norris",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_72e4368d-bc9e-488b-9b6d-c1a3674340ed",
        "address": "6 ,Office Nos. 603, 604 & 605, Level 6, Burj Daman ,Dubai International Financial Centre ,506555 ,Dubai",
        "phone": "97143506400 / 971504654755",
        "email": "r.hickman@aglaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8690f7d5-6b96-4649-9589-71303f2c2707",
    "firmName": "Addleshaw Goddard (Middle East) LLP",
    "registrationNumber": "L-06025",
    "licenseIssueDate": "10/18/2023 00:00:00",
    "licenseExpiryDate": "10/17/2026 00:00:00"
  },
  {
    "id": "c1453222-6e3e-40c0-9f59-025cccf44755",
    "slug": "rachael-peterson",
    "name": "RACHAEL PETERSEN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/11/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rachael Peterson",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c1453222-6e3e-40c0-9f59-025cccf44755",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-03548",
    "licenseIssueDate": "11/29/2021 00:00:00",
    "licenseExpiryDate": "11/28/2025 00:00:00"
  },
  {
    "id": "a9c903e7-0739-455e-be47-66a90ea9c119",
    "slug": "rachel-adrienne-pereira",
    "name": "RACHEL ADRIENNE PEREIRA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/09/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rachel Adrienne Pereira",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a9c903e7-0739-455e-be47-66a90ea9c119",
        "address": "",
        "phone": "97143438897 / 971507753952",
        "email": "jdavidson@davidson-legal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d0200f27-9504-4653-a5c6-05e4bcab7ff0",
    "firmName": "Davidson & Co Legal Consultants",
    "registrationNumber": "L-06014",
    "licenseIssueDate": "09/13/2023 00:00:00",
    "licenseExpiryDate": "09/12/2026 00:00:00"
  },
  {
    "id": "5cbc57f7-f16b-45da-87b2-0cfaed8b409a",
    "slug": "rachel-mamatha-mannam-ebenezer-mannam",
    "name": "RACHEL MAMATHA MANNAM EBENEZER MANNAM",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/12/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: RACHEL MAMATHA MANNAM EBENEZER MANNAM",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5cbc57f7-f16b-45da-87b2-0cfaed8b409a",
        "address": "HAMDAN ALSHAMSI ,الطابق الرابع مكتب 401, 406,407 ,بي سكوير 01 ,مجمع دبي سكوير ,116564 ,Dubai",
        "phone": "97143469262",
        "email": "courts@has.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de2c61a6-9d00-457e-ad1d-e73e4e62d9bd",
    "firmName": "HAMDAN ALSHAMSI LAWYER & LEGAL CONSULTANTS",
    "registrationNumber": "L-06612",
    "licenseIssueDate": "12/11/2024 00:00:00",
    "licenseExpiryDate": "12/10/2025 00:00:00"
  },
  {
    "id": "4b4df782-ed38-4842-9c01-65e49da9411a",
    "slug": "rachel-sui-chuen-lee",
    "name": "RACHEL SUI CHUEN LEE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/03/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rachel Sui Chuen Lee",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4b4df782-ed38-4842-9c01-65e49da9411a",
        "address": "Index Tower ,DIFC ,506896 ,",
        "phone": "97142782300 / 971551154791",
        "email": "GLeggate@wfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e2b82cfc-80a5-4957-ae41-b1a7beb693c1",
    "firmName": "Watson, Farley & Williams (Middle East) LLP",
    "registrationNumber": "L-06261",
    "licenseIssueDate": "03/19/2024 00:00:00",
    "licenseExpiryDate": "03/18/2026 00:00:00"
  },
  {
    "id": "11b95ba7-fd8c-4b9e-a975-f2eafd4f8538",
    "slug": "rachel-telford",
    "name": "RACHEL VICTORIA TELFORD",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/09/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rachel Telford",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_11b95ba7-fd8c-4b9e-a975-f2eafd4f8538",
        "address": "6 ,Office Nos. 603, 604 & 605, Level 6, Burj Daman ,Dubai International Financial Centre ,506555 ,Dubai",
        "phone": "97143506400 / 971504654755",
        "email": "r.hickman@aglaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8690f7d5-6b96-4649-9589-71303f2c2707",
    "firmName": "Addleshaw Goddard (Middle East) LLP",
    "registrationNumber": "L-00383",
    "licenseIssueDate": "09/08/2011 00:00:00",
    "licenseExpiryDate": "08/30/2026 00:00:00"
  },
  {
    "id": "cc498411-ea65-4eb7-a023-3950ddf6b9ea",
    "slug": "radwan-ahmed-el-alamy",
    "name": "RADWAN AHMED AHMED ELALAMY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/01/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Radwan Ahmed El-Alamy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cc498411-ea65-4eb7-a023-3950ddf6b9ea",
        "address": "000000000 ,4 ,الريم  ,بلدية دبي  ,14593 ,Dubai",
        "phone": "97142276777",
        "email": "info@tglawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "593a5a42-a340-4daa-a8db-6d2673de29d5",
    "firmName": "MOHAMED AL HAJERI ADVOCATES & LEGAL CONSULTANTS  & NOTARY PUBLIC",
    "registrationNumber": "L-01229",
    "licenseIssueDate": "01/25/2012 00:00:00",
    "licenseExpiryDate": "01/16/2026 00:00:00"
  },
  {
    "id": "92d3a62a-c7b4-458f-b325-41d663c66282",
    "slug": "raed-hammam-abdelhamid-hammam-el-sonbaty",
    "name": "RAED HAMMAM ABDELHAMID HAMMAM ELSONBATY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/10/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Raed Hammam Abdelhamid Hammam El Sonbaty",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_92d3a62a-c7b4-458f-b325-41d663c66282",
        "address": "Adel Salem Abdulla Salem Alghafri ,16th floor, Office: 1602 ,Aspect Tower ,Bay Avenue Mall ,444470 ,Dubai",
        "phone": "97142807052 / 971555666589",
        "email": "info@adelalghafri.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d0789ea6-22d2-4893-aa99-e55ff1b4473a",
    "firmName": "ADEL AL GHAFRI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02195",
    "licenseIssueDate": "10/10/2012 00:00:00",
    "licenseExpiryDate": "10/02/2026 00:00:00"
  },
  {
    "id": "5b96aba3-fb60-4217-b7d0-57bc1068cb08",
    "slug": "rafe-khokhar",
    "name": "RAFE HANIF KHOKHAR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/10/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rafe Khokhar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5b96aba3-fb60-4217-b7d0-57bc1068cb08",
        "address": "Index Tower ,Dubai International Financial Centre ,507115 ,",
        "phone": "97143757160 / 971523490280",
        "email": "tthraya@mayerbrown.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c7f52b69-c049-4246-963a-9805b241f88a",
    "firmName": "Mayer Brown LLP",
    "registrationNumber": "L-03328",
    "licenseIssueDate": "10/18/2015 00:00:00",
    "licenseExpiryDate": "10/13/2026 00:00:00"
  },
  {
    "id": "e63367aa-f559-48cb-9ce2-c038e9d5d5c0",
    "slug": "rafik-mohamed-afifi",
    "name": "RAFIK MOHAMED EZZAT ABDELZAHER AFIFY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/12/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-11-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rafik Mohamed Afifi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e63367aa-f559-48cb-9ce2-c038e9d5d5c0",
        "address": "3902 ,single business tower ,Sheikh Zayed Rd.  ,90077 ,Dubai",
        "phone": "97143804141 / 97143804141",
        "email": "info@united-advocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "52ebf695-ce46-4e03-abc9-f4d8d2f8a356",
    "firmName": "UNITED ADVOCATES",
    "registrationNumber": "L-02812",
    "licenseIssueDate": "12/07/2014 00:00:00",
    "licenseExpiryDate": "12/01/2025 00:00:00"
  },
  {
    "id": "96ae1735-15b7-4bd6-abc7-48be4c9f734f",
    "slug": "ragab-turky",
    "name": "RAGAB ABDELMOEZ ABDELMEGID TORKY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/11/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-11-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ragab Turky",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_96ae1735-15b7-4bd6-abc7-48be4c9f734f",
        "address": "111 ,AL HATHBOUR ,CANADIAN HOSPITAL ,96555 ,Dubai",
        "phone": "97142656000",
        "email": "alawadhi.advocates@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b1c98bb5-4fdc-4e2a-8d16-ba2fa7afcace",
    "firmName": "ALAWADHI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02006",
    "licenseIssueDate": "11/21/2011 00:00:00",
    "licenseExpiryDate": "11/12/2025 00:00:00"
  },
  {
    "id": "aa21e34f-9176-4510-8707-9520db889076",
    "slug": "ragaei-sayed-aly-abdelrehim",
    "name": "RAGAEI SAYED ALY ABDELREHIM",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/03/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ragaei sayed aly abdelrehim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_aa21e34f-9176-4510-8707-9520db889076",
        "address": "",
        "phone": "97143889955",
        "email": "m.alhanafi@nooflaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6a72f470-256a-46d0-bead-acf13b981406",
    "firmName": "NOOF ALABDULLA ADVOCATES & LEGAL CONSULTANTS L.L.C",
    "registrationNumber": "L-05271",
    "licenseIssueDate": "03/22/2022 00:00:00",
    "licenseExpiryDate": "03/21/2026 00:00:00"
  },
  {
    "id": "4b46b3d9-2897-483a-ac8d-04afdbbac422",
    "slug": "raghd-mohammed-hammad",
    "name": "RAGHD MOHAMMAD HAMED HAMMAD",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/12/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Raghd Mohammed Hammad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4b46b3d9-2897-483a-ac8d-04afdbbac422",
        "address": "الطابق 7 مكتب رقم 070A ,برج رولكس  ,محطة مترو المركز المالي  ,66300 ,Dubai",
        "phone": "97143444029",
        "email": "ekp.khalidaltmimi@ekplegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "400838f1-4e75-4836-9698-b9e19dd30a18",
    "firmName": "KHALID ABDALLA ALTAMIMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02346",
    "licenseIssueDate": "12/10/2013 00:00:00",
    "licenseExpiryDate": "12/03/2025 00:00:00"
  },
  {
    "id": "f143d166-95a6-4d01-8ea3-fa1a9653a116",
    "slug": "raghib-masrur",
    "name": "RAGHIB MASRUR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/08/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Raghib Masrur",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f143d166-95a6-4d01-8ea3-fa1a9653a116",
        "address": "0 ,ICD Brookfield Place Level 13 ,Trade Centre ,506569 ,Dubai",
        "phone": "97145099100 / 971501006965",
        "email": "menahr@freshfields.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "970f6246-e737-41a7-9c6c-5aa5b8335d45",
    "firmName": "Freshfields LLP DIFC",
    "registrationNumber": "L-03805",
    "licenseIssueDate": "08/21/2025 00:00:00",
    "licenseExpiryDate": "08/20/2026 00:00:00"
  },
  {
    "id": "e51e66bb-5095-4dc7-97dc-6d643629988e",
    "slug": "raghid-el-hajjar",
    "name": "RAGHID FAWZI EL HAJJAR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/12/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Raghid El Hajjar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e51e66bb-5095-4dc7-97dc-6d643629988e",
        "address": "Amer Sayed Al Marzooqi ,603 ,SAMA TOWER ,TRADE CENTER ,41727 ,Dubai",
        "phone": "97142500023",
        "email": "info@mlegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7ed7234c-a176-47f9-b66e-18524305fe3e",
    "firmName": "AMER AL MARZOOQI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06596",
    "licenseIssueDate": "12/05/2024 00:00:00",
    "licenseExpiryDate": "12/04/2025 00:00:00"
  },
  {
    "id": "c65528df-7632-4e92-8a5f-7763e8462c5f",
    "slug": "rahail-ali",
    "name": "RAHAIL FARMAN ALI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Commercial Agency",
      "Commercial Transactions-Commercial Mortgage",
      "Commercial Transactions-Commercial Contracts",
      "Commercial Transactions-Commercial Real Estate",
      "Commercial Transactions-Unfair competition",
      "Commercial Transactions-Commercial Companies",
      "Commercial Transactions-E-Commerce"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rahail Ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c65528df-7632-4e92-8a5f-7763e8462c5f",
        "address": "",
        "phone": "97143779377 / 971505528593",
        "email": "rahail.ali@hoganlovells.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "ef4b209f-a5f1-446f-82de-1b0675bbf53b",
    "firmName": "Hogan Lovells Middle East LLP",
    "registrationNumber": "L-00805",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "81ea5d31-9ffe-4aa6-8284-71e41e5a1cf5",
    "slug": "rahat-hussein-dar",
    "name": "RAHAT HUSSAIN DAR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/12/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rahat Hussein Dar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_81ea5d31-9ffe-4aa6-8284-71e41e5a1cf5",
        "address": "",
        "phone": "97143303900 / 971561753537",
        "email": "christopher@afridi-angell.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "30ce50dc-01a6-499d-8ace-3f807ddcb08d",
    "firmName": "Afridi & Angell-DED",
    "registrationNumber": "L-02148",
    "licenseIssueDate": "12/16/2011 00:00:00",
    "licenseExpiryDate": "12/07/2025 00:00:00"
  },
  {
    "id": "1375dd3a-b61b-49c8-95ac-6a5503e0a94e",
    "slug": "raheela-habib",
    "name": "RAHEELA HABIB HABIB UR REHMAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/07/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Raheela Habib",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1375dd3a-b61b-49c8-95ac-6a5503e0a94e",
        "address": "Alhajeya salem saeed alnoobi ,3rd  ,Al-hawai Tower  ,Behind financial center metro station  ,39779 ,Dubai",
        "phone": "97142963813",
        "email": "adv_aljazeera@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "f091b928-9e3d-4e24-b489-65ca31481366",
    "firmName": "AL HAJEYA ALNOOBI ADVOCATES AND LEGAL CONSULTANT",
    "registrationNumber": "L-03810",
    "licenseIssueDate": "07/11/2023 00:00:00",
    "licenseExpiryDate": "07/10/2026 00:00:00"
  },
  {
    "id": "d9387f74-a168-4346-9c67-bc17eb63f668",
    "slug": "rahma-said-abdelsalam-elsayed",
    "name": "RAHMA SAID ABDELSALAM ELSAYED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/12/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rahma Said Abdelsalam Elsayed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d9387f74-a168-4346-9c67-bc17eb63f668",
        "address": "amal albastaki ,1903 ,court ,business bay ,127477 ,Dubai",
        "phone": "97142522202",
        "email": "info@amaladvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "f852bccd-2696-4190-9b40-77a8fb9c460f",
    "firmName": "AMAL ALBASTAKI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-06618",
    "licenseIssueDate": "12/25/2024 00:00:00",
    "licenseExpiryDate": "12/24/2025 00:00:00"
  },
  {
    "id": "5abd7621-a716-4b9a-b31c-edd22de27562",
    "slug": "rahul-kumar-sharda",
    "name": "RAHUL KUMAR SHARDA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/01/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rahul Kumar Sharda",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5abd7621-a716-4b9a-b31c-edd22de27562",
        "address": "",
        "phone": "97142566660",
        "email": "dlr@ysalc.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "28be4513-86ae-4602-b4cc-8d52ba959e9e",
    "firmName": "YOUSUF AL SHARIF ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06204",
    "licenseIssueDate": "01/31/2024 00:00:00",
    "licenseExpiryDate": "01/30/2026 00:00:00"
  },
  {
    "id": "bd12f049-7e01-4db0-8096-ba74b0890fba",
    "slug": "raid-kanj",
    "name": "RAID ZAID KANJ",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Raid Kanj",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bd12f049-7e01-4db0-8096-ba74b0890fba",
        "address": "Firas Hassan Al Choufi ,701 ,The Prime Tower ,Makani No: 25836 86879 ,125305 ,Dubai",
        "phone": "97144357246",
        "email": "info@binsevanadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4d3c9dcc-51c6-4883-b9ed-c65a7d1c5a57",
    "firmName": "BIN SEVAN ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-01654",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "aaa4caf0-e6e0-4c80-acbc-b397f50c7df1",
    "slug": "rajiv-kumar-suri-kewal-krishan-suri",
    "name": "RAJIV KUMAR SURI KEWAL KRISHAN SURI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Commercial Agency",
      "Proceedings-Cases and Proceedings before Dubai International Financial Centre",
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Personal Status-Wills",
      "Commercial Transactions-Commercial Contracts",
      "Civil Transactions-Arbitration",
      "Proceedings-Cases and Proceedings before arbitral tribunals and other alternative dispute resolution bodies",
      "Criminal Law-Cybercrimes",
      "Commercial Transactions-Intellectual Property (includes trademarks",
      "copy rights",
      "patents)"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/06/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rajiv Kumar Suri Kewal Krishan Suri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_aaa4caf0-e6e0-4c80-acbc-b397f50c7df1",
        "address": "Samia Luqman ,2nd floor ,Emarat Atrium Building ,across Holiday Inn Express Safa Park ,7273 ,Dubai",
        "phone": "97143211000",
        "email": "info@alsuwaidi.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0e5c3637-bc12-475c-a6b5-2d9ae84f2b8e",
    "firmName": "AL-SUWAIDI & COMPANY",
    "registrationNumber": "L-05380",
    "licenseIssueDate": "06/22/2022 00:00:00",
    "licenseExpiryDate": "06/21/2026 00:00:00"
  },
  {
    "id": "8ea85dc1-2876-4ae8-b3fd-4a21360315a6",
    "slug": "raka-roy",
    "name": "RAKA ROY SAMARESH CHAKRABORTY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/03/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Raka Roy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8ea85dc1-2876-4ae8-b3fd-4a21360315a6",
        "address": "",
        "phone": "97143937700",
        "email": "info@galadarilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d863b662-c864-4193-8b3a-ff6ee5fe6c64",
    "firmName": "GALADARI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04347",
    "licenseIssueDate": "03/19/2019 00:00:00",
    "licenseExpiryDate": "03/17/2026 00:00:00"
  },
  {
    "id": "a2afe90a-1f5d-4910-992f-ae821f247cdc",
    "slug": "rakesh-nelson",
    "name": "RAKESH NELSON",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/09/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rakesh Nelson",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a2afe90a-1f5d-4910-992f-ae821f247cdc",
        "address": "THE OFFICES 1 ,DWTC ,115580 ,",
        "phone": "97143739700 / 971501148248",
        "email": "nitesh.pradhan@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "361fdc64-6b6f-4f37-abca-c52af8473b84",
    "firmName": "Pinsent Masons  LLP (DWTCA Branch)",
    "registrationNumber": "L-06484",
    "licenseIssueDate": "09/11/2024 00:00:00",
    "licenseExpiryDate": "09/10/2026 00:00:00"
  },
  {
    "id": "37065a46-934b-4d58-9445-56f0f5c2a22b",
    "slug": "rama-al-kassaji",
    "name": "RAMA MOHAMMAD AHMAD AL KASSAJI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/05/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rama Al Kassaji",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_37065a46-934b-4d58-9445-56f0f5c2a22b",
        "address": "الخامس ,الشعلة بلوك اية ,داناتا ,127179 ,Dubai",
        "phone": "97143318888 / 971509984724",
        "email": "ameizar@salamadvo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "1b4e6bd9-712b-49bf-a169-fd31ea45cd51",
    "firmName": "SALAM ADVOCATE  & LEGAL CONSULTANTS",
    "registrationNumber": "L-03358",
    "licenseIssueDate": "05/10/2016 00:00:00",
    "licenseExpiryDate": "05/06/2026 00:00:00"
  },
  {
    "id": "2026f12a-c46a-4816-aa05-a3a407ff1134",
    "slug": "ramadan-mohamed-elsayed-ali",
    "name": "RAMADAN MOHAMED ELSAYED ALI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Civil Transactions-HR & Employee Affairs",
      "Personal Status-Custody & Alimony",
      "Civil Transactions-Residential Real Estate",
      "Civil Transactions-Arbitration",
      "Civil Transactions-Tenancy",
      "Commercial Transactions-Unfair competition",
      "Criminal Law-Crimes against persons",
      "Personal Status-Legacies and Inheritance",
      "Commercial Transactions-Commercial Companies",
      "Commercial Transactions-Banking Operations",
      "Civil Transactions-Labor & Workers",
      "Personal Status-Legal Capacity & Guardianship",
      "Criminal Law-Drug Crimes",
      "Personal Status-Marriage & Divorce",
      "Civil Transactions-Compensation",
      "Criminal Law-Cybercrimes"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/08/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: RAMADAN MOHAMED ELSAYED ALI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2026f12a-c46a-4816-aa05-a3a407ff1134",
        "address": "10th Floor ,AlReem Tower ,Dubai Land Department ,32367 ,Dubai",
        "phone": "97142272701",
        "email": "midfaadv@eim.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "fe9068a7-b94d-49bb-88b3-6f8491a15389",
    "firmName": "AL MIDFA & ASSOCIATES",
    "registrationNumber": "L-06437",
    "licenseIssueDate": "08/02/2024 00:00:00",
    "licenseExpiryDate": "08/01/2026 00:00:00"
  },
  {
    "id": "b406b267-f39d-40fc-bdf8-f10a2ae2624e",
    "slug": "ramadan-nagi-abdelaziz",
    "name": "RAMADAN NAGY MOHAMED ABDELAZIZ",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/02/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ramadan Nagi Abdelaziz",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b406b267-f39d-40fc-bdf8-f10a2ae2624e",
        "address": "Firas Hassan Al Choufi ,701 ,The Prime Tower ,Makani No: 25836 86879 ,125305 ,Dubai",
        "phone": "97144357246",
        "email": "info@binsevanadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4d3c9dcc-51c6-4883-b9ed-c65a7d1c5a57",
    "firmName": "BIN SEVAN ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-01655",
    "licenseIssueDate": "02/27/2013 00:00:00",
    "licenseExpiryDate": "02/19/2026 00:00:00"
  },
  {
    "id": "9dbb03e0-757b-447d-ae22-dabdda4b062b",
    "slug": "ramatu-umu-khuntumi-wurie",
    "name": "RAMATULAI UMU KHUNTUM ALPHA WURIE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSVQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/11/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ramatu Umu Khuntumi Wurie",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9dbb03e0-757b-447d-ae22-dabdda4b062b",
        "address": "",
        "phone": "97144286300 / 971506256686",
        "email": "stuart.paterson@hsf.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2f0389b3-bfde-44f4-bdd6-6e1a22f9cab2",
    "firmName": "Herbert Smith Freehills Kramer LLP",
    "registrationNumber": "L-05572",
    "licenseIssueDate": "11/02/2022 00:00:00",
    "licenseExpiryDate": "11/01/2025 00:00:00"
  },
  {
    "id": "03581394-8148-4ec7-8087-1f509d6c290c",
    "slug": "ramesh-messius-fernando",
    "name": "RAMESH MESSIUS FERNANDO",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/03/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ramesh Messius Fernando",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_03581394-8148-4ec7-8087-1f509d6c290c",
        "address": "",
        "phone": "97143303900 / 971561753537",
        "email": "christopher@afridi-angell.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "30ce50dc-01a6-499d-8ace-3f807ddcb08d",
    "firmName": "Afridi & Angell-DED",
    "registrationNumber": "L-05709",
    "licenseIssueDate": "03/16/2023 00:00:00",
    "licenseExpiryDate": "03/15/2026 00:00:00"
  },
  {
    "id": "9c95033c-e731-4260-b187-59da28f4acc3",
    "slug": "ramez-hammoud",
    "name": "RAMEZ MUSTAPHA HAMMOUD",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/01/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: RAMEZ HAMMOUD",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9c95033c-e731-4260-b187-59da28f4acc3",
        "address": "الخامس  ,البرج الأخضر  ,خلف فندق موسكو  ,5630 ,Dubai",
        "phone": "97142222888",
        "email": "fayadlaw@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "216ebf72-e55b-4446-b7a6-5c17ba8c9b5d",
    "firmName": "HIKMAT FAYAD AND ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04355",
    "licenseIssueDate": "01/28/2025 00:00:00",
    "licenseExpiryDate": "01/27/2026 00:00:00"
  },
  {
    "id": "946b58d7-af2b-421b-a852-010f4bbe7c1e",
    "slug": "ramez-mounir-mikhail",
    "name": "RAMEZ MOUNIR ABDELNOUR MIKHAIL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Personal Status-Wills",
      "Personal Status-Custody & Alimony",
      "Commercial Transactions-Commercial Contracts",
      "Commercial Transactions-Commercial Real Estate",
      "Civil Transactions-Tenancy",
      "Civil Transactions-Labor & Workers",
      "Civil Transactions-Sale",
      "Civil Transactions-Compensation",
      "Criminal Law-Crimes against properties"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/02/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ramez Mounir Mikhail",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_946b58d7-af2b-421b-a852-010f4bbe7c1e",
        "address": "",
        "phone": "97143366260",
        "email": "mail@aljallaflegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d54e2e1d-7afb-435d-ab9e-5301c7e17a1f",
    "firmName": "AL JALLAF ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-00454",
    "licenseIssueDate": "02/24/2014 00:00:00",
    "licenseExpiryDate": "02/17/2026 00:00:00"
  },
  {
    "id": "7d105552-e652-4f49-a149-bfb06d1cc502",
    "slug": "rami-al-tal",
    "name": "RAMI TAYSEER HUSSEIN AL TAL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rami Al-Tal",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7d105552-e652-4f49-a149-bfb06d1cc502",
        "address": "",
        "phone": "97144230555 / 971504788443",
        "email": "yah@hfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c462c65e-185a-4e81-8425-a87e3a2b6842",
    "firmName": "Holman Fenwick Willan Middle East LLP",
    "registrationNumber": "L-01685",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "4ad109f4-a015-4148-9aff-1618f9866861",
    "slug": "rami-michael-zayat",
    "name": "RAMI MICHAEL ZAYAT",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/05/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rami Michael Zayat",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4ad109f4-a015-4148-9aff-1618f9866861",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-04937",
    "licenseIssueDate": "05/24/2021 00:00:00",
    "licenseExpiryDate": "05/23/2026 00:00:00"
  },
  {
    "id": "3143a19d-ecc5-4088-bdb1-615157aa274b",
    "slug": "rami-mohamed-albederi-abdelbaki-khalifa-hassan",
    "name": "RAMI MOHAMED ALBEDERI ABDELBAKI KHALIFA HASSAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/10/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rami Mohamed Albederi Abdelbaki Khalifa Hassan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3143a19d-ecc5-4088-bdb1-615157aa274b",
        "address": "4/406 ,Acico Business Park  ,Behind Nissan Showroom ,186344 ,Dubai",
        "phone": "97142989888 / 971505948989",
        "email": "AHMEDIBRAHIMLAW@GMAIL.COM",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dbb4bc27-1ace-4e78-8ee2-db7bfd85e001",
    "firmName": "AHMED IBRAHIM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06024",
    "licenseIssueDate": "10/04/2023 00:00:00",
    "licenseExpiryDate": "10/03/2026 00:00:00"
  },
  {
    "id": "ae879483-c73a-4f19-ac4a-d3d7c6a63c81",
    "slug": "rami-obeid",
    "name": "RAMI YOUSSEF OBEID",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/05/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rami Obeid",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ae879483-c73a-4f19-ac4a-d3d7c6a63c81",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-02496",
    "licenseIssueDate": "05/04/2014 00:00:00",
    "licenseExpiryDate": "04/27/2026 00:00:00"
  },
  {
    "id": "60a521c4-64e3-4feb-941b-76abfcc38355",
    "slug": "rami-omar-abdel-latif",
    "name": "RAMI OMAR DEEB ABDEL LATIF",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rami Omar Abdel Latif",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_60a521c4-64e3-4feb-941b-76abfcc38355",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-01302",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "cc86d9e7-df18-41f6-aca1-c808c02b8ba5",
    "slug": "ramsey-jurdi",
    "name": "RAMSEY BEHJAT JURDI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/12/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ramsey Jurdi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cc86d9e7-df18-41f6-aca1-c808c02b8ba5",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-00860",
    "licenseIssueDate": "12/16/2011 00:00:00",
    "licenseExpiryDate": "12/07/2025 00:00:00"
  },
  {
    "id": "c95cc56d-0684-4bea-9187-d7ce06d41257",
    "slug": "ramsha-hayat",
    "name": "RAMSHA HAYAT",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/05/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ramsha Hayat",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c95cc56d-0684-4bea-9187-d7ce06d41257",
        "address": "- ,Index Tower ,Dubai International Financial Centre ,9371 ,Dubai",
        "phone": "97143303900 / 971561753537",
        "email": "christopher@afridi-angell.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3e464dc8-b800-4ba2-ad91-24a5f9640fef",
    "firmName": "Afridi & Angell-DIFC",
    "registrationNumber": "L-06825",
    "licenseIssueDate": "05/28/2025 00:00:00",
    "licenseExpiryDate": "05/27/2026 00:00:00"
  },
  {
    "id": "5711cdd0-6029-4d7e-8c6b-0bd676b34dc7",
    "slug": "ramy-george-saad-ghabrial",
    "name": "RAMY GEORGE SAAD GHABRIAL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/09/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: RAMY GEORGE SAAD GHABRIAL",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5711cdd0-6029-4d7e-8c6b-0bd676b34dc7",
        "address": "amal albastaki ,1903 ,court ,business bay ,127477 ,Dubai",
        "phone": "97142522202",
        "email": "info@amaladvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "f852bccd-2696-4190-9b40-77a8fb9c460f",
    "firmName": "AMAL ALBASTAKI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-06936",
    "licenseIssueDate": "09/17/2025 00:00:00",
    "licenseExpiryDate": "09/16/2026 00:00:00"
  },
  {
    "id": "a26fbdae-492f-470d-bfe8-ff03b11ad7cd",
    "slug": "rana-joseph-sebaly",
    "name": "RANA JOSEPH SEBALY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/08/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rana Joseph Sebaly",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a26fbdae-492f-470d-bfe8-ff03b11ad7cd",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-04184",
    "licenseIssueDate": "08/14/2018 00:00:00",
    "licenseExpiryDate": "08/12/2026 00:00:00"
  },
  {
    "id": "e756f971-a3af-46f3-90ca-4bf2857601df",
    "slug": "rana-karim-bou-moghlbay",
    "name": "RANA KARIM BOU MOGHLBAY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: RANA KARIM BOU MOGHLBAY",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e756f971-a3af-46f3-90ca-4bf2857601df",
        "address": "",
        "phone": "97142552220",
        "email": "almaazmi.office@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e04d8a88-3378-40c8-a33a-b5e26a0c8507",
    "firmName": "ABDELRAHMAN AL MAAZMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05245",
    "licenseIssueDate": "03/01/2022 00:00:00",
    "licenseExpiryDate": "02/28/2026 00:00:00"
  },
  {
    "id": "f0f91ca4-e0b2-4d7e-a6c4-174644de7218",
    "slug": "rana-marwan-al-shoufi",
    "name": "RANA MARWAN AL SHOUFI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/08/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rana Marwan Al Shoufi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f0f91ca4-e0b2-4d7e-a6c4-174644de7218",
        "address": "4th floor ,Al Saaha Offices Block D office 401A ,Burj Khalifa ,283773 ,Dubai",
        "phone": "97144221944",
        "email": "gov.depts@alsafarpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b7bbfaeb-1fdb-46d2-97cf-8e6432a9b8a7",
    "firmName": "AL SAFAR & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05980",
    "licenseIssueDate": "08/23/2023 00:00:00",
    "licenseExpiryDate": "08/22/2026 00:00:00"
  },
  {
    "id": "b7fd47bc-4db8-48b8-8e4d-5abb7aed3934",
    "slug": "rana-rouphael",
    "name": "RANA ROUPHAEL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Personal Status-Wills",
      "Civil Transactions-Residential Real Estate",
      "Civil Transactions-Arbitration",
      "Commercial Transactions-Commercial Companies",
      "Commercial Transactions-Banking Operations",
      "Civil Transactions-Labor & Workers",
      "Proceedings-Cases and Proceedings before arbitral tribunals and other alternative dispute resolution bodies"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/08/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rana Rouphael",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b7fd47bc-4db8-48b8-8e4d-5abb7aed3934",
        "address": "الخامس  ,مكاتب عود ميثاء ,فندق رافلز ,11268 ,Dubai",
        "phone": "97143243330",
        "email": "avocat@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "25d2c9bd-dbba-41ac-aff9-5ba0f37290d6",
    "firmName": "AL QARI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-05463",
    "licenseIssueDate": "08/03/2022 00:00:00",
    "licenseExpiryDate": "08/02/2026 00:00:00"
  },
  {
    "id": "c2c165bb-6f5d-44cb-858b-d0beb028a77a",
    "slug": "randa-mahdy-mohamed-ebrahim-elska",
    "name": "RANDA MAHDY MOHAMED EBRAHIM ELSKA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Commercial Transactions-Commercial Mortgage",
      "Commercial Transactions-Commercial Contracts",
      "Commercial Transactions-Commercial Real Estate",
      "Civil Transactions-Residential Real Estate",
      "Personal Status-Legacies and Inheritance"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/09/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: randa mahdy mohamed ebrahim elska",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c2c165bb-6f5d-44cb-858b-d0beb028a77a",
        "address": "dalmook mohamed bin dalmook ,التاسع - مكتب 901 ,الشركة الوطنية للتأمينات العامة NGI ,مقابل سيتي سنتر ديرة بجوار سندس سويتس مريديان وفلورا كريك هوتيل ,3467 ,Dubai",
        "phone": "97142989222 / 971506455800",
        "email": "information@dalmook.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "564fc438-ce0f-40b0-9dc2-c01709da9e46",
    "firmName": "DALMOOK MOHAMMED DALMOOK ( ADVOCATE & LEGAL CONSULTANCY )",
    "registrationNumber": "L-06489",
    "licenseIssueDate": "09/10/2024 00:00:00",
    "licenseExpiryDate": "09/09/2026 00:00:00"
  },
  {
    "id": "b8e8dee5-b1aa-4636-8baa-49bb5aca3fdc",
    "slug": "randall-walker",
    "name": "RANDALL CLIVE RUSSELL WALKER",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/04/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Randall Walker",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b8e8dee5-b1aa-4636-8baa-49bb5aca3fdc",
        "address": "",
        "phone": "97143779377 / 971505528593",
        "email": "rahail.ali@hoganlovells.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ef4b209f-a5f1-446f-82de-1b0675bbf53b",
    "firmName": "Hogan Lovells Middle East LLP",
    "registrationNumber": "L-03738",
    "licenseIssueDate": "04/27/2017 00:00:00",
    "licenseExpiryDate": "04/23/2026 00:00:00"
  },
  {
    "id": "73b1e052-71fa-46fb-b989-8366ed066f34",
    "slug": "rania-bader",
    "name": "RANIA MOHAMED ABDELHAMID BADER",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/03/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rania Bader",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_73b1e052-71fa-46fb-b989-8366ed066f34",
        "address": "",
        "phone": "97142942616",
        "email": "info@ilofficeuae.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "48ef4874-8647-4fb6-bedd-ffbad25accd1",
    "firmName": "KHALID KALANDAR ALMAAZMI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-01688",
    "licenseIssueDate": "03/15/2015 00:00:00",
    "licenseExpiryDate": "03/09/2026 00:00:00"
  },
  {
    "id": "86c7a4c5-3a99-4348-bfb6-41b0cb68fe79",
    "slug": "rania-tadros",
    "name": "RANIA TADROS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/06/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rania Tadros",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_86c7a4c5-3a99-4348-bfb6-41b0cb68fe79",
        "address": "",
        "phone": "97144073901 / 971503479508",
        "email": "Rania.Tadros@stephensonharwood.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "dd5042a2-bb41-4123-9544-79c3fa831332",
    "firmName": "Stephenson Harwood (Middle East) LLP",
    "registrationNumber": "L-02329",
    "licenseIssueDate": "06/17/2013 00:00:00",
    "licenseExpiryDate": "06/10/2026 00:00:00"
  },
  {
    "id": "79a6e86f-42eb-4362-b49b-6520bbe7811d",
    "slug": "rany-rifaat",
    "name": "RANY RIFAAT",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/10/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rany Rifaat",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_79a6e86f-42eb-4362-b49b-6520bbe7811d",
        "address": "",
        "phone": "97143641686 / 971506288801",
        "email": "b.kadir@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0ba96df8-e4cc-49c2-8ae4-a42878d95926",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS LLC",
    "registrationNumber": "L-05333",
    "licenseIssueDate": "10/18/2023 00:00:00",
    "licenseExpiryDate": "10/17/2026 00:00:00"
  },
  {
    "id": "670a3fb3-c5a3-4e78-a994-7b9544dcb03e",
    "slug": "raphaele-marie-michele-nicole-pamard",
    "name": "RAPHAELE MARIE MICHELE NICOLE PAMARD",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/03/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Raphaele Marie Michele Nicole Pamard",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_670a3fb3-c5a3-4e78-a994-7b9544dcb03e",
        "address": "Central Park Towers ,507120 ,",
        "phone": "97143200940 / 971502397176",
        "email": "lsahbani@lpalaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4c158c98-1a29-48da-ade1-54e60bfd5b78",
    "firmName": "LPA (Middle East) LTD",
    "registrationNumber": "L-04632",
    "licenseIssueDate": "03/05/2020 00:00:00",
    "licenseExpiryDate": "03/04/2026 00:00:00"
  },
  {
    "id": "66fbb868-aa8d-4ae4-969f-59689d5a1aef",
    "slug": "rasha-issam-al-ardah",
    "name": "RASHA ISSAM MAHMOUD AL ARDAH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rasha Issam Al-Ardah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_66fbb868-aa8d-4ae4-969f-59689d5a1aef",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01303",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "739165aa-22b5-45ee-9218-24e346a550d1",
    "slug": "rasheeda-kizhakkethil",
    "name": "RASHEEDA KIZHAKKETHIL MOHAMMED KIZHAKKETHIL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/10/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rasheeda Kizhakkethil",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_739165aa-22b5-45ee-9218-24e346a550d1",
        "address": "",
        "phone": "97145148832 / 971502061303",
        "email": "dxbcourts@nhadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "bf5657d9-ea57-4099-89ca-c51bd6c1c641",
    "firmName": "NAWAL ALHOSANI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-01193",
    "licenseIssueDate": "10/20/2011 00:00:00",
    "licenseExpiryDate": "10/11/2025 00:00:00"
  },
  {
    "id": "817cc91e-a222-4f56-9f25-fc59566f408d",
    "slug": "rashi-sudhir-jain-sudhir-rajendra-jain",
    "name": "RASHI SUDHIR JAIN SUDHIR RAJENDRA JAIN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/05/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rashi Sudhir Jain Sudhir Rajendra Jain",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_817cc91e-a222-4f56-9f25-fc59566f408d",
        "address": "",
        "phone": "97143025100 / 971501501837",
        "email": "ccairns@trowers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "976857f5-9092-43cf-987d-bfa794a3fa51",
    "firmName": "Trowers & Hamlins LLP",
    "registrationNumber": "L-06804",
    "licenseIssueDate": "05/28/2025 00:00:00",
    "licenseExpiryDate": "05/27/2026 00:00:00"
  },
  {
    "id": "a0cf541f-630e-49b6-9dfc-3695b9d277b7",
    "slug": "rasmi-ragy-gabrial",
    "name": "RASMI RAGY GABRIAL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Commercial Agency",
      "Civil Transactions-POA & Sponsorship",
      "Civil Transactions-Insurance",
      "Civil Transactions-Ownership & Title",
      "Civil Transactions-HR & Employee Affairs",
      "Commercial Transactions-Commercial Mortgage",
      "Commercial Transactions-Commercial Contracts",
      "Commercial Transactions-Bankruptcy",
      "Commercial Transactions-Commercial Real Estate",
      "Civil Transactions-Residential Real Estate",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Civil Transactions-Arbitration",
      "Civil Transactions-Tenancy",
      "Criminal Law-Crimes against persons",
      "Commercial Transactions-Commercial Companies",
      "Commercial Transactions-Banking Operations",
      "Criminal Law-Drug Crimes",
      "Civil Transactions-Sale",
      "Commercial Transactions-Sea and air freight",
      "Commercial Transactions-Consumer protection",
      "Civil Transactions-Compensation",
      "Commercial Transactions-Stock",
      "Criminal Law-Crimes against properties"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/11/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rasmi Ragy Gabrial",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a0cf541f-630e-49b6-9dfc-3695b9d277b7",
        "address": "الطابق الثالث ,مجمع المحكمة العليا دبي ,مجمع المحكمة العليا دبي ,45556 ,Dubai",
        "phone": "97145570632 / 971503977375",
        "email": "rasmi@aahadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d47fa75-0239-4031-a3a5-d132d2fa393b",
    "firmName": "ABDULLA AL HADDAD ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-03183",
    "licenseIssueDate": "11/04/2015 00:00:00",
    "licenseExpiryDate": "10/29/2026 00:00:00"
  },
  {
    "id": "1e2ba306-df2c-4535-a32e-4cb8a511e48e",
    "slug": "rassan-azhari",
    "name": "RASSAN ROBERT DR AZHARI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/09/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rassan Azhari",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1e2ba306-df2c-4535-a32e-4cb8a511e48e",
        "address": "",
        "phone": "97144473557 / 971506884811",
        "email": "ceo@azhari-law.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "169d1d08-9788-417a-9352-9189689cf5fb",
    "firmName": "Azhari Legal Consultancy",
    "registrationNumber": "L-00530",
    "licenseIssueDate": "09/15/2011 00:00:00",
    "licenseExpiryDate": "09/06/2026 00:00:00"
  },
  {
    "id": "787bf322-4569-4e3f-9a97-c92367676fc0",
    "slug": "ratul-roshan-randeep-lal",
    "name": "Ratul Roshan Randeep Lal",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/09/2025",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ratul Roshan Randeep Lal",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_787bf322-4569-4e3f-9a97-c92367676fc0",
        "address": "ICD Brookfield Place ,Za'abeel 2 ,103747 ,",
        "phone": "97143696300 / 971506008159",
        "email": "mohammed.paracha@nortonrosefulbright.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c4aaee93-0ec4-4982-9a48-a23699492056",
    "firmName": "Norton Rose Fullbright (Middle East) LLP"
  },
  {
    "id": "022ff744-18d1-4b22-b736-2108c4ea3361",
    "slug": "ravi-jawani",
    "name": "RAVI PRABHUDAS JAWANI PRABHUDAS GORDHANDAS JAWANI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ravi Jawani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_022ff744-18d1-4b22-b736-2108c4ea3361",
        "address": "23 ,Rolex Tower ,Trade Center Second ,116637 ,Dubai",
        "phone": "97144357577 / 971502101003",
        "email": "jasamin.fichte@fichtelegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "77bf4fd2-1cd1-4bda-a0c2-ffcac3980b76",
    "firmName": "Fichte & Co Legal Consultancy",
    "registrationNumber": "L-00549",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "1da803af-c69f-4d13-83e7-b5c4901a7676",
    "slug": "ravi-ravindran",
    "name": "RAVI RAVINDRAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/01/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ravi Ravindran",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1da803af-c69f-4d13-83e7-b5c4901a7676",
        "address": "Saeed Tower 2 ,Trade centre ,124942 ,",
        "phone": "/ 971508470447",
        "email": "ravi@nexlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "42a35604-227b-4c05-8095-770c821b3d4f",
    "firmName": "Nexlaw Maritime Legal Consultancy",
    "registrationNumber": "L-03598",
    "licenseIssueDate": "01/24/2017 00:00:00",
    "licenseExpiryDate": "01/20/2026 00:00:00"
  },
  {
    "id": "c5b2b17c-5ba2-465f-8e75-3eb4f15c167d",
    "slug": "ravinder-bhullar",
    "name": "Ravinder Bhullar",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ravinder Bhullar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c5b2b17c-5ba2-465f-8e75-3eb4f15c167d",
        "address": "",
        "phone": "97144478700 / 971528553200",
        "email": "Thomas.Wilson@squirepb.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "85be541a-c87f-45a9-a321-d90abd6b7298",
    "firmName": "Squire Patton Boggs (MEA) LLP",
    "registrationNumber": "L-00557",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "40a04ab1-2fbb-42dc-a387-06860c7f6a7c",
    "slug": "ravindra-krishnarao-modgekar",
    "name": "RAVINDRA KRISHNARAO MODGEKAR MODGEKAR KRISHNARAO CHUDAMANI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/04/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ravindra Krishnarao Modgekar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_40a04ab1-2fbb-42dc-a387-06860c7f6a7c",
        "address": "Advo. Abdulla Al Awadi ,العاشر  ,برايم تاور  ,فندق فيدا ,26665 ,Dubai",
        "phone": "97143352200",
        "email": "info@abdullaalawadi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5075821f-98f5-4546-8fcd-6cdc74967dac",
    "firmName": "ABDULLA AL AWADI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05305",
    "licenseIssueDate": "04/26/2022 00:00:00",
    "licenseExpiryDate": "04/25/2026 00:00:00"
  },
  {
    "id": "0e3ab53e-0899-4cef-9de9-263151d43f22",
    "slug": "raya-mohammadassem-m-alkhatib",
    "name": "Raya Mohammadassem M Alkhatib",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/11/2023",
    "licenseStatus": "active",
    "licenseExpiry": "2024-11-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Raya Mohammadassem M Alkhatib",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0e3ab53e-0899-4cef-9de9-263151d43f22",
        "address": "",
        "phone": "97143093222 / 971566651954",
        "email": "melissa.murray@twobirds.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3e1526e6-4c8d-4b6f-985f-ea05e9f99bcb",
    "firmName": "Bird & Bird (MEA) LLP",
    "registrationNumber": "L-06064",
    "licenseIssueDate": "11/01/2023 00:00:00",
    "licenseExpiryDate": "10/31/2025 00:00:00"
  },
  {
    "id": "0a8915d6-3690-43a5-bcf9-41103bf93027",
    "slug": "rayane-ziad-al-hayek",
    "name": "RAYANE ZIAD AL HAYEK",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSWgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/09/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rayane Ziad Al Hayek",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0a8915d6-3690-43a5-bcf9-41103bf93027",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-06485",
    "licenseIssueDate": "09/11/2024 00:00:00",
    "licenseExpiryDate": "09/10/2026 00:00:00"
  },
  {
    "id": "5c9bcc32-7275-4ba5-9dc2-e7d3308cdba0",
    "slug": "rayanne-louise-sharaf-el-din-ibrahim",
    "name": "RAYANNE LOUISE SHARAF EL DIN IBRAHIM",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/11/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rayanne Louise Sharaf El Din Ibrahim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5c9bcc32-7275-4ba5-9dc2-e7d3308cdba0",
        "address": "",
        "phone": "97144286300 / 971506256686",
        "email": "stuart.paterson@hsf.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2f0389b3-bfde-44f4-bdd6-6e1a22f9cab2",
    "firmName": "Herbert Smith Freehills Kramer LLP",
    "registrationNumber": "L-06581",
    "licenseIssueDate": "10/25/2024 00:00:00",
    "licenseExpiryDate": "10/24/2025 00:00:00"
  },
  {
    "id": "0fcf8e1d-0ccf-4de9-b908-aa4cd8265af2",
    "slug": "raymond-kisswany",
    "name": "RAYMOND KISSWANY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/04/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Raymond Kisswany",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0fcf8e1d-0ccf-4de9-b908-aa4cd8265af2",
        "address": "",
        "phone": "97143438897 / 971507753952",
        "email": "jdavidson@davidson-legal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d0200f27-9504-4653-a5c6-05e4bcab7ff0",
    "firmName": "Davidson & Co Legal Consultants",
    "registrationNumber": "L-02583",
    "licenseIssueDate": "04/15/2021 00:00:00",
    "licenseExpiryDate": "04/14/2026 00:00:00"
  },
  {
    "id": "1be82500-eeae-431d-990c-1b608d87bd10",
    "slug": "raza-rizvi",
    "name": "RAZA ABBAS RIZVI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/10/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Raza Rizvi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1be82500-eeae-431d-990c-1b608d87bd10",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506688 ,Dubai",
        "phone": "97147096600 / 971503556811",
        "email": "muneer.khan@simmons-simmons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d1725ca7-06ac-41b2-8d7b-a6e60665b73d",
    "firmName": "Simmons & Simmons (Middle East) LLP-DIFC",
    "registrationNumber": "L-00541",
    "licenseIssueDate": "10/07/2011 00:00:00",
    "licenseExpiryDate": "09/28/2026 00:00:00"
  },
  {
    "id": "c6bcd8d5-9b77-4ccf-b155-85fca7dbbe0b",
    "slug": "razan-abdallah-m-obeidat",
    "name": "RAZAN ABDALLAH M OBEIDAT",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/03/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Razan Abdallah M. Obeidat",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c6bcd8d5-9b77-4ccf-b155-85fca7dbbe0b",
        "address": "Al Fattan Currency House Tower 2 ,DIFC ,507176 ,",
        "phone": "/ 971552009003",
        "email": "Mohammad.AlRasheed@bakermckenzie.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "acd81e81-dead-4f7c-839e-0f2a57897265",
    "firmName": "Baker & Mckenzie LLP",
    "registrationNumber": "L-06725",
    "licenseIssueDate": "03/26/2025 00:00:00",
    "licenseExpiryDate": "03/25/2026 00:00:00"
  },
  {
    "id": "66ea010c-c343-467a-8927-84d6aed8751c",
    "slug": "rdina-abaker-mohmmed-sallh",
    "name": "RDINA ABAKER MOHMMED SALIH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/02/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: RDINA ABAKER MOHMMED SALLH",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_66ea010c-c343-467a-8927-84d6aed8751c",
        "address": "1606 ,فندق الكونراد - برج المكاتب ,فندق الفيرمونت ,84333 ,Dubai",
        "phone": "97142218787 / 971505773332",
        "email": "info@alshamsilawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "fa7eb7e5-d5d3-404a-91ba-06a1efeb207e",
    "firmName": "ALI OBAID ALSHAMSI LAWYERS & LEGAL CONSULTANTS",
    "registrationNumber": "L-04865",
    "licenseIssueDate": "02/22/2021 00:00:00",
    "licenseExpiryDate": "02/21/2026 00:00:00"
  },
  {
    "id": "0ac303ed-bf26-485a-8324-88e095ec2c79",
    "slug": "rebecca-copley",
    "name": "REBECCA COPLEY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/10/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rebecca Copley",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0ac303ed-bf26-485a-8324-88e095ec2c79",
        "address": "",
        "phone": "97143897000 / 971506553198",
        "email": "nasseralikhasawneh@eversheds-sutherland.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "74a21d43-41d8-480a-a6af-6939b7c98a95",
    "firmName": "Eversheds Sutherland (International LLP) Dubai Branch",
    "registrationNumber": "L-03507",
    "licenseIssueDate": "10/03/2016 00:00:00",
    "licenseExpiryDate": "09/29/2026 00:00:00"
  },
  {
    "id": "98c77f03-2f00-448b-a15e-36e3ff549884",
    "slug": "rebecca-goldring",
    "name": "REBECCA GOLDRING",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/09/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rebecca Goldring",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_98c77f03-2f00-448b-a15e-36e3ff549884",
        "address": "",
        "phone": "97143025100 / 971501501837",
        "email": "ccairns@trowers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "976857f5-9092-43cf-987d-bfa794a3fa51",
    "firmName": "Trowers & Hamlins LLP",
    "registrationNumber": "L-06443",
    "licenseIssueDate": "09/04/2024 00:00:00",
    "licenseExpiryDate": "09/03/2026 00:00:00"
  },
  {
    "id": "2be7472a-7cd9-4dec-86a6-06b52153f130",
    "slug": "rebecca-hilton",
    "name": "REBECCA JANE HILTON",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/11/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rebecca Hilton",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2be7472a-7cd9-4dec-86a6-06b52153f130",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-02823",
    "licenseIssueDate": "11/23/2014 00:00:00",
    "licenseExpiryDate": "11/17/2025 00:00:00"
  },
  {
    "id": "9a0a0f6b-e617-40dc-a7fb-3eb704843f82",
    "slug": "rebecca-kelly",
    "name": "REBECCA LEE KELLY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/10/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rebecca Kelly",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9a0a0f6b-e617-40dc-a7fb-3eb704843f82",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-00318",
    "licenseIssueDate": "10/11/2011 00:00:00",
    "licenseExpiryDate": "10/02/2025 00:00:00"
  },
  {
    "id": "932a36c0-e191-4163-8546-e72a06fc5629",
    "slug": "rebecca-leanne-neville",
    "name": "REBECCA LEANNE NEVILLE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rebecca Leanne Neville",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_932a36c0-e191-4163-8546-e72a06fc5629",
        "address": "Al Fattan Currency House - Tower 1  ,Dubai International Financial Center  ,507104 ,",
        "phone": "97143978565 / 971504587822",
        "email": "Raafat.hares@dwf.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6e5f6dba-07af-4109-8c34-175296450f94",
    "firmName": "DWF (Middle East) LLP",
    "registrationNumber": "L-05220",
    "licenseIssueDate": "03/01/2022 00:00:00",
    "licenseExpiryDate": "02/28/2026 00:00:00"
  },
  {
    "id": "46a94c99-439e-4467-a94e-2a7364232a05",
    "slug": "rebecca-louise-comerford",
    "name": "REBECCA LOUISE COMERFORD",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/06/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rebecca Louise Comerford",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_46a94c99-439e-4467-a94e-2a7364232a05",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-05845",
    "licenseIssueDate": "06/09/2023 00:00:00",
    "licenseExpiryDate": "06/08/2026 00:00:00"
  },
  {
    "id": "faf76746-1133-4fb5-9511-3981ee6267b3",
    "slug": "rebecca-louise-platts",
    "name": "REBECCA LOUISE PLATTS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/06/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: REBECCA LOUISE PLATTS",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_faf76746-1133-4fb5-9511-3981ee6267b3",
        "address": "1 ,ICD Brookfield Place ,Dubai International Financial Centre ,9267 ,Dubai",
        "phone": "97147010975 / 971502977062",
        "email": "chris.sioufi@ae.ey.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "42e536ef-e3d8-4339-8572-657a7f7a0331",
    "firmName": "EY Law LLP",
    "registrationNumber": "L-04704",
    "licenseIssueDate": "06/18/2020 00:00:00",
    "licenseExpiryDate": "06/17/2026 00:00:00"
  },
  {
    "id": "c601c91e-9bdf-4669-9cab-86a7311cfb2e",
    "slug": "rebecca-mary-eade",
    "name": "REBECCA MARY EADE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/06/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rebecca Mary Eade",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c601c91e-9bdf-4669-9cab-86a7311cfb2e",
        "address": "",
        "phone": "97143093222 / 971566651954",
        "email": "melissa.murray@twobirds.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3e1526e6-4c8d-4b6f-985f-ea05e9f99bcb",
    "firmName": "Bird & Bird (MEA) LLP",
    "registrationNumber": "L-06376",
    "licenseIssueDate": "06/05/2024 00:00:00",
    "licenseExpiryDate": "06/04/2026 00:00:00"
  },
  {
    "id": "595d7af4-170d-454c-a510-bb8c92b9850f",
    "slug": "rebecca-mclerie",
    "name": "REBECCA ANNE MCLERIE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/08/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rebecca McLerie",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_595d7af4-170d-454c-a510-bb8c92b9850f",
        "address": "",
        "phone": "97143121800 / 971566017967",
        "email": "alishia.sullivan@morganlewis.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6eab20d7-8716-4b0a-8710-144d1d951c23",
    "firmName": "Morgan, Lewis & Bockius LLP (dubai Branch)",
    "registrationNumber": "L-00319",
    "licenseIssueDate": "08/29/2012 00:00:00",
    "licenseExpiryDate": "08/21/2026 00:00:00"
  },
  {
    "id": "fb9c78b2-81fc-4448-80e3-f710e4d39b72",
    "slug": "rebecca-oluwabukunola-i-a-longe",
    "name": "REBECCA OLUWABUKUNOLA I A LONGE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/04/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rebecca Oluwabukunola I A Longe",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fb9c78b2-81fc-4448-80e3-f710e4d39b72",
        "address": "",
        "phone": "97142472100 / 971509224336",
        "email": "bhaley@cov.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "65a2e90a-6978-4292-b3f1-ecbebedd7b9a",
    "firmName": "Covington & Burling LLP (Middle East)",
    "registrationNumber": "L-06761",
    "licenseIssueDate": "04/23/2025 00:00:00",
    "licenseExpiryDate": "04/22/2026 00:00:00"
  },
  {
    "id": "0d484226-11fe-4a8e-8f58-20aca9674a5e",
    "slug": "rebekah-jones",
    "name": "REBEKAH CHARYS JONES",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/05/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rebekah Jones",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0d484226-11fe-4a8e-8f58-20aca9674a5e",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-04690",
    "licenseIssueDate": "05/14/2020 00:00:00",
    "licenseExpiryDate": "05/13/2026 00:00:00"
  },
  {
    "id": "3c7dd323-9d9b-4d49-bc44-bb77fd42327e",
    "slug": "rebekah-linton",
    "name": "REBEKAH LINTON",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/05/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: REBEKAH LINTON",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3c7dd323-9d9b-4d49-bc44-bb77fd42327e",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-06795",
    "licenseIssueDate": "05/14/2025 00:00:00",
    "licenseExpiryDate": "05/13/2026 00:00:00"
  },
  {
    "id": "4eab11af-88fd-4bb4-bada-f386464d609c",
    "slug": "reda-ismail-hegazy",
    "name": "REDA ISMAIL MOHAMED MOHAMED HEGAZY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/12/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Reda Ismail Hegazy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4eab11af-88fd-4bb4-bada-f386464d609c",
        "address": "Samia Luqman ,2nd floor ,Emarat Atrium Building ,across Holiday Inn Express Safa Park ,7273 ,Dubai",
        "phone": "97143211000",
        "email": "info@alsuwaidi.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0e5c3637-bc12-475c-a6b5-2d9ae84f2b8e",
    "firmName": "AL-SUWAIDI & COMPANY",
    "registrationNumber": "L-02236",
    "licenseIssueDate": "12/28/2011 00:00:00",
    "licenseExpiryDate": "12/19/2025 00:00:00"
  },
  {
    "id": "e87fa657-25c3-4dc1-a52d-8493f7bffdf5",
    "slug": "reda-mohamed-kenawy",
    "name": "REDA MOHAMED MOHAMED KENAWY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/04/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Reda Mohamed Kenawy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e87fa657-25c3-4dc1-a52d-8493f7bffdf5",
        "address": "abdulla nasser mansour hamad alkaabi ,life pharmacy ,al safa ,millennium plaza hotel ,113713 ,Dubai",
        "phone": "97143598998",
        "email": "advo.akd@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "05d59198-4e23-4b78-bb9b-d55bfcd69060",
    "firmName": "ABDULLA ALKAABI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01737",
    "licenseIssueDate": "04/09/2025 00:00:00",
    "licenseExpiryDate": "04/08/2026 00:00:00"
  },
  {
    "id": "538027d1-96a2-4289-adc0-b9291e133600",
    "slug": "reda-morgan-abd-elwanis-kassem",
    "name": "REDA MORGAN ABDELWANIS KASSEM",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/07/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Reda Morgan Abd Elwanis Kassem",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_538027d1-96a2-4289-adc0-b9291e133600",
        "address": "Hadeel Ali alshaali  ,الطابق السادس  ,بناية زمردة ,بلدية دبي المختبرات المركزية ,212633 ,Dubai",
        "phone": "97165503035",
        "email": "hadeelalshaali_90@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "18a7fc47-63d9-4928-a864-fa55559de45b",
    "firmName": "HADEEL ALSHAALI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04160",
    "licenseIssueDate": "07/11/2018 00:00:00",
    "licenseExpiryDate": "07/09/2026 00:00:00"
  },
  {
    "id": "f0e3d09b-efd2-4af2-8c30-3934fd02533c",
    "slug": "reef-fadi-hourani",
    "name": "REEF FADI HOURANI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/09/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Reef Fadi Hourani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f0e3d09b-efd2-4af2-8c30-3934fd02533c",
        "address": "One Central, The Offices 5 ,Dubai World Trade Centre ,554660 ,",
        "phone": "97142052030 / 971506566494",
        "email": "chourani@houranipartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "59a73632-40a0-4849-b120-4308dc6f8015",
    "firmName": "Hourani & Partners Legal Consultancy FZCO",
    "registrationNumber": "L-06951",
    "licenseIssueDate": "08/28/2025 00:00:00",
    "licenseExpiryDate": "08/27/2026 00:00:00"
  },
  {
    "id": "481736cf-58f0-4c9c-bce1-93c2e35a4ead",
    "slug": "reem-abdalla-ahmed-ali",
    "name": "REEM ABDALLA AHMED ALI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/08/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Reem Abdalla Ahmed Ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_481736cf-58f0-4c9c-bce1-93c2e35a4ead",
        "address": "MOHAMMED MURTADA ALHASHMI ,3 ,LATIFA TOWER  ,CROWN PLAZA ,231400 ,Dubai",
        "phone": "97143521131",
        "email": "info@mhadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a5a2640f-b1b8-4512-b9ee-a8802d0c30fc",
    "firmName": "MOHAMMED AL HASHIMI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-03849",
    "licenseIssueDate": "08/03/2017 00:00:00",
    "licenseExpiryDate": "07/31/2026 00:00:00"
  },
  {
    "id": "055eca50-1831-4aa8-8199-ff24f48f0823",
    "slug": "reem-alsayegh",
    "name": "REEM MIRZA ALI HASSAN ALSAYEGH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Reem Alsayegh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_055eca50-1831-4aa8-8199-ff24f48f0823",
        "address": "ICD Brookfield Place ,DIFC ,506516 ,",
        "phone": "97143695800 / 971505526206",
        "email": "scott.campbell@linklaters.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5cec94c0-0649-43b6-a2be-ab17ff422bce",
    "firmName": "LinkLaters LLP",
    "registrationNumber": "L-00723",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "6c6db149-72e5-4e6f-a45d-23571b9e6fa1",
    "slug": "reem-hala-bangina",
    "name": "REEM HALA BANGINA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/06/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Reem Hala Bangina",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6c6db149-72e5-4e6f-a45d-23571b9e6fa1",
        "address": "Building 5 ,Dubai World Trade Centre ,212620 ,",
        "phone": "97143503600 / 971563631562",
        "email": "p.ellingham@kennedys-law.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "83d3ede1-3a28-4b03-8c92-6bd31a1cb95e",
    "firmName": "Kennedys Dubai LLP",
    "registrationNumber": "L-05837",
    "licenseIssueDate": "06/09/2023 00:00:00",
    "licenseExpiryDate": "06/08/2026 00:00:00"
  },
  {
    "id": "fc14afa7-3bc7-4522-9462-18848a03e040",
    "slug": "reem-kabour",
    "name": "REEM KABOUR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/08/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Reem Kabour",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fc14afa7-3bc7-4522-9462-18848a03e040",
        "address": "Index Tower ,Dubai International Financial Centre ,507115 ,",
        "phone": "97143757160 / 971523490280",
        "email": "tthraya@mayerbrown.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c7f52b69-c049-4246-963a-9805b241f88a",
    "firmName": "Mayer Brown LLP",
    "registrationNumber": "L-06921",
    "licenseIssueDate": "08/18/2025 00:00:00",
    "licenseExpiryDate": "08/17/2026 00:00:00"
  },
  {
    "id": "55fc3c80-85fc-40bc-ad8a-14407b58e64f",
    "slug": "reem-masood-mahmood-faqihi",
    "name": "Reem Masood Mahmood Faqihi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/05/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Reem Masood Mahmood Faqihi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_55fc3c80-85fc-40bc-ad8a-14407b58e64f",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-04941",
    "licenseIssueDate": "05/24/2021 00:00:00",
    "licenseExpiryDate": "05/23/2026 00:00:00"
  },
  {
    "id": "cc01b45a-ca23-4eac-a018-6d2be3fc4035",
    "slug": "refat-mustafa-zidan",
    "name": "REFAT MUSTAFA EBRAHEM HASSAN ZIDAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/10/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Refat Mustafa Zidan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cc01b45a-ca23-4eac-a018-6d2be3fc4035",
        "address": "O-4801, O-4901 ,Burj al Salam Office Tower ,H Hotel ,111801 ,Dubai",
        "phone": "97143544444",
        "email": "administration@horizlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4e25fb39-6659-44f0-bc8b-3ff0f067beb0",
    "firmName": "HORIZONS & CO - LAW FIRM",
    "registrationNumber": "L-01813",
    "licenseIssueDate": "10/05/2011 00:00:00",
    "licenseExpiryDate": "09/25/2026 00:00:00"
  },
  {
    "id": "92fd88b9-8e3d-46dd-9869-8e364a887dbf",
    "slug": "reghard-willem-smith",
    "name": "Reghard Willem Smith",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/07/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Reghard Willem Smith",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_92fd88b9-8e3d-46dd-9869-8e364a887dbf",
        "address": "",
        "phone": "97143637999 / 971506525633",
        "email": "daniel.wood@walkersglobal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a3a9927b-d51c-490c-8be6-d575ea3eb041",
    "firmName": "Walkers (Middle East) LLP",
    "registrationNumber": "L-04260",
    "licenseIssueDate": "11/07/2018 00:00:00",
    "licenseExpiryDate": "11/05/2025 00:00:00"
  },
  {
    "id": "ed473f3c-c889-4e60-a0b8-a0ea74845d32",
    "slug": "rehab-ahmed-ibraheem-ali-abdelwahab",
    "name": "REHAB AHMED IBRAHEEM ALI ABDELWAHAB",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/11/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rehab Ahmed Ibraheem Ali Abdelwahab",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ed473f3c-c889-4e60-a0b8-a0ea74845d32",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506698 ,Dubai",
        "phone": "97147046300 / 971507900661",
        "email": "nada.mourad@lw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b2b92ce9-90a4-4e34-ae2f-ae0dc7ca9060",
    "firmName": "Latham & Watkins LLP",
    "registrationNumber": "L-05640",
    "licenseIssueDate": "11/30/2022 00:00:00",
    "licenseExpiryDate": "11/29/2025 00:00:00"
  },
  {
    "id": "36d4dc6c-0161-4ced-a9bf-9a008421cc81",
    "slug": "remon-thabet-shafik-beshai",
    "name": "REMON THABET SHAFIK BESHAI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/06/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Remon Thabet Shafik Beshai",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_36d4dc6c-0161-4ced-a9bf-9a008421cc81",
        "address": "Unit 801, 8th Floor ,Damac Executive Heights ,Time Oak Hotel ,112888 ,Dubai",
        "phone": "97144355959 / 971551049797",
        "email": "a.motei@motei.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b898c8c8-b27a-4895-a7df-903b3dec14f6",
    "firmName": "Motei & Associates L.L.C",
    "registrationNumber": "L-03359",
    "licenseIssueDate": "06/27/2019 00:00:00",
    "licenseExpiryDate": "06/26/2026 00:00:00"
  },
  {
    "id": "b07ddcb3-5e8d-4f69-ac8e-293fa0f8b236",
    "slug": "remy-katherine-browning",
    "name": "REMY KATHERINE BROWNING",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/07/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Remy Katherine Browning",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b07ddcb3-5e8d-4f69-ac8e-293fa0f8b236",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-06885",
    "licenseIssueDate": "07/30/2025 00:00:00",
    "licenseExpiryDate": "07/29/2026 00:00:00"
  },
  {
    "id": "c25fa3fe-b75a-40ae-b456-7c361f5e2138",
    "slug": "renee-deborah-athena-lindo",
    "name": "RENEE DEBORAH ATHENA LINDO",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/05/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Renee Deborah Athena Lindo",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c25fa3fe-b75a-40ae-b456-7c361f5e2138",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-05400",
    "licenseIssueDate": "05/20/2024 00:00:00",
    "licenseExpiryDate": "05/19/2026 00:00:00"
  },
  {
    "id": "b413a66a-2561-4db0-81ef-514634173a54",
    "slug": "rhea-jabbour",
    "name": "RHEA JABBOUR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/03/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: RHEA JABBOUR",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b413a66a-2561-4db0-81ef-514634173a54",
        "address": "1 ,ICD Brookfield Place ,Dubai International Financial Centre ,9267 ,Dubai",
        "phone": "97147010975 / 971502977062",
        "email": "chris.sioufi@ae.ey.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "42e536ef-e3d8-4339-8572-657a7f7a0331",
    "firmName": "EY Law LLP",
    "registrationNumber": "L-06732",
    "licenseIssueDate": "03/26/2025 00:00:00",
    "licenseExpiryDate": "03/25/2026 00:00:00"
  },
  {
    "id": "1df064d2-3602-455f-b861-c02c240efcb5",
    "slug": "rhianne-eloise-hale",
    "name": "RHIANNE ELOISE HALE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/02/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-02-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rhianne Eloise Hale",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1df064d2-3602-455f-b861-c02c240efcb5",
        "address": "6 ,Office Nos. 603, 604 & 605, Level 6, Burj Daman ,Dubai International Financial Centre ,506555 ,Dubai",
        "phone": "97143506400 / 971504654755",
        "email": "r.hickman@aglaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8690f7d5-6b96-4649-9589-71303f2c2707",
    "firmName": "Addleshaw Goddard (Middle East) LLP",
    "registrationNumber": "L-05200",
    "licenseIssueDate": "02/15/2022 00:00:00",
    "licenseExpiryDate": "02/14/2026 00:00:00"
  },
  {
    "id": "f7bf4196-56e9-42cc-824d-1572950d542d",
    "slug": "rhyley-james-terry-griffith",
    "name": "RHYLEY JAMES TERRY GRIFFITH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/06/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rhyley James Terry Griffith",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f7bf4196-56e9-42cc-824d-1572950d542d",
        "address": "",
        "phone": "97144230555 / 971504788443",
        "email": "yah@hfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c462c65e-185a-4e81-8425-a87e3a2b6842",
    "firmName": "Holman Fenwick Willan Middle East LLP",
    "registrationNumber": "L-04920",
    "licenseIssueDate": "06/20/2024 00:00:00",
    "licenseExpiryDate": "06/19/2026 00:00:00"
  },
  {
    "id": "023d8133-ef23-4ab6-9803-5987657d9a87",
    "slug": "rhys-john-rowland",
    "name": "RHYS JOHN ROWLAND",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/12/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rhys John Rowland",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_023d8133-ef23-4ab6-9803-5987657d9a87",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-05657",
    "licenseIssueDate": "12/07/2022 00:00:00",
    "licenseExpiryDate": "12/06/2025 00:00:00"
  },
  {
    "id": "a0944da2-0522-49cf-adcb-8bf31181e9c7",
    "slug": "riad-elkerdasy",
    "name": "RIAD AWAD MAHMOUD ELKERDASY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Riad Elkerdasy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a0944da2-0522-49cf-adcb-8bf31181e9c7",
        "address": "",
        "phone": "97142424288 / 971588961163",
        "email": "info@malshaikhadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "73d5d3aa-9089-4c36-8cd2-4057677338f3",
    "firmName": "MOHAMED ALSHAIKH ADVOCATES &LEGAL CONSULTANTS",
    "registrationNumber": "L-01426",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "7d90261e-3ea7-4e86-9c75-bef5210a2010",
    "slug": "riaz-ul-haq",
    "name": "RIAZ UL HAQ",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSVQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/11/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Riaz Ul Haq",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7d90261e-3ea7-4e86-9c75-bef5210a2010",
        "address": "",
        "phone": "97144020800 / 971566830829",
        "email": "dean.ryburn@dentons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dfe13b7e-6625-45fd-ad63-9ee83af41194",
    "firmName": "Dentons & Co Dubai Branch-DED",
    "registrationNumber": "L-05587",
    "licenseIssueDate": "11/02/2022 00:00:00",
    "licenseExpiryDate": "11/01/2025 00:00:00"
  },
  {
    "id": "5d10899c-390c-4ae4-b90e-b0c05d880894",
    "slug": "riccardo-denaro",
    "name": "RICCARDO DENARO",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/11/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Riccardo Denaro",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5d10899c-390c-4ae4-b90e-b0c05d880894",
        "address": "NA ,Index tower ,NA ,506828 ,Dubai",
        "phone": "97154228569 / 971525567076",
        "email": "silviaelba.sartori@belex.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "f77150e9-6cee-4d5e-9619-7fa5f488aee3",
    "firmName": "BonelliErede Middle East LLP",
    "registrationNumber": "L-06099",
    "licenseIssueDate": "11/22/2023 00:00:00",
    "licenseExpiryDate": "11/21/2025 00:00:00"
  },
  {
    "id": "84a215d7-8cc2-46b5-a72e-ada379f4f2c4",
    "slug": "richard-briggs",
    "name": "RICHARD HOWARD BRIGGS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/11/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Richard Briggs",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_84a215d7-8cc2-46b5-a72e-ada379f4f2c4",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-02097",
    "licenseIssueDate": "11/29/2011 00:00:00",
    "licenseExpiryDate": "11/20/2025 00:00:00"
  },
  {
    "id": "29ee3abc-0d98-4bfc-a92d-3fe3cdae2aa8",
    "slug": "richard-catling",
    "name": "RICHARD JOHN SELBY CATLING",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Richard Catling",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_29ee3abc-0d98-4bfc-a92d-3fe3cdae2aa8",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01307",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "4cbe7788-a583-42f9-9e70-e191e8208a95",
    "slug": "richard-chamberlain",
    "name": "RICHARD ANDREW CHAMBERLAIN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/03/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Richard Chamberlain",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4cbe7788-a583-42f9-9e70-e191e8208a95",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-02872",
    "licenseIssueDate": "03/03/2015 00:00:00",
    "licenseExpiryDate": "02/25/2026 00:00:00"
  },
  {
    "id": "d3799862-7956-48e6-a9fa-ece987879e37",
    "slug": "richard-chudzynski",
    "name": "RICHARD ANTHONY CHUDZYNSKI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/03/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Richard Chudzynski",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d3799862-7956-48e6-a9fa-ece987879e37",
        "address": "",
        "phone": "97143897000 / 971506553198",
        "email": "nasseralikhasawneh@eversheds-sutherland.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "74a21d43-41d8-480a-a6af-6939b7c98a95",
    "firmName": "Eversheds Sutherland (International LLP) Dubai Branch",
    "registrationNumber": "L-02690",
    "licenseIssueDate": "03/04/2025 00:00:00",
    "licenseExpiryDate": "03/03/2026 00:00:00"
  },
  {
    "id": "03f590db-6fd0-437b-b44e-b50b98799a27",
    "slug": "richard-clarke",
    "name": "RICHARD PETER DENIS CLARKE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Cases and Proceedings before Dubai International Financial Centre",
      "Proceedings-Cases and Proceedings before arbitral tribunals and other alternative dispute resolution bodies"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/08/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Richard Clarke",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_03f590db-6fd0-437b-b44e-b50b98799a27",
        "address": "",
        "phone": "97144543900 / 971569199020",
        "email": "paul.hughes@kobrekim.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "259f7732-3596-4559-ae29-21cb6f4aa7d8",
    "firmName": "Kobre & Kim (GCC) LLP",
    "registrationNumber": "L-03106",
    "licenseIssueDate": "08/23/2015 00:00:00",
    "licenseExpiryDate": "08/18/2026 00:00:00"
  },
  {
    "id": "f0234a70-4e98-4412-a161-90157dcbc63e",
    "slug": "richard-dassin",
    "name": "RICHARD DASSIN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/11/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Richard Dassin",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f0234a70-4e98-4412-a161-90157dcbc63e",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-03895",
    "licenseIssueDate": "11/12/2017 00:00:00",
    "licenseExpiryDate": "11/09/2025 00:00:00"
  },
  {
    "id": "acad3ea7-1b07-43ce-92ba-bd159750ef42",
    "slug": "richard-gibbon",
    "name": "Richard Gibbon",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/06/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Richard Gibbon",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_acad3ea7-1b07-43ce-92ba-bd159750ef42",
        "address": "",
        "phone": "97144478700 / 971528553200",
        "email": "Thomas.Wilson@squirepb.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "85be541a-c87f-45a9-a321-d90abd6b7298",
    "firmName": "Squire Patton Boggs (MEA) LLP",
    "registrationNumber": "L-00945",
    "licenseIssueDate": "02/06/2012 00:00:00",
    "licenseExpiryDate": "01/28/2026 00:00:00"
  },
  {
    "id": "5e6b6774-af2f-4c3a-b206-d15fd6d86179",
    "slug": "richard-hughes",
    "name": "RICHARD GRAHAM HUGHES",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/05/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Richard Hughes",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5e6b6774-af2f-4c3a-b206-d15fd6d86179",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-00673",
    "licenseIssueDate": "05/22/2012 00:00:00",
    "licenseExpiryDate": "05/14/2026 00:00:00"
  },
  {
    "id": "e5b7f879-4c28-41d3-ac41-eb5e6d189fe7",
    "slug": "richard-huw-davies",
    "name": "Richard Huw Davies",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/21/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Richard Huw Davies",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e5b7f879-4c28-41d3-ac41-eb5e6d189fe7",
        "address": "",
        "phone": "97145119777 / 971508184427",
        "email": "richard.davies@bclplaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "6c617112-4b98-414c-868a-7d0316427c21",
    "firmName": "Bryan Cave Leighton Paisner LLP",
    "registrationNumber": "L-04760",
    "licenseIssueDate": "10/21/2020 00:00:00",
    "licenseExpiryDate": "10/20/2026 00:00:00"
  },
  {
    "id": "9ceb7ca9-2d33-478e-a047-3221e32a6ef4",
    "slug": "richard-imran-ding",
    "name": "RICHARD IMRAN DING",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/05/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Richard Imran Ding",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9ceb7ca9-2d33-478e-a047-3221e32a6ef4",
        "address": "",
        "phone": "97142396646",
        "email": "advo_alblooshi@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3ab5acef-85ac-482b-91f2-4e0a34fd6af7",
    "firmName": "ABDELAZIZ AL BLOUSHI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04121",
    "licenseIssueDate": "05/24/2018 00:00:00",
    "licenseExpiryDate": "05/22/2026 00:00:00"
  },
  {
    "id": "c1a1c31b-821a-488a-b4df-132d392d466c",
    "slug": "richard-keenan",
    "name": "RICHARD JOHN KEENAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/12/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Richard Keenan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c1a1c31b-821a-488a-b4df-132d392d466c",
        "address": "",
        "phone": "97142472100 / 971509224336",
        "email": "bhaley@cov.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "65a2e90a-6978-4292-b3f1-ecbebedd7b9a",
    "firmName": "Covington & Burling LLP (Middle East)",
    "registrationNumber": "L-00862",
    "licenseIssueDate": "12/16/2011 00:00:00",
    "licenseExpiryDate": "12/07/2025 00:00:00"
  },
  {
    "id": "4134cbb9-ee92-4963-b0a6-e9f999222662",
    "slug": "richard-marc-gerard-hamilton",
    "name": "RICHARD MARC GERARD HAMILTON",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/05/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Richard Marc Gerard Hamilton",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4134cbb9-ee92-4963-b0a6-e9f999222662",
        "address": "ICD Brookfield Place ,Za'abeel 2 ,103747 ,",
        "phone": "97143696300 / 971506008159",
        "email": "mohammed.paracha@nortonrosefulbright.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c4aaee93-0ec4-4982-9a48-a23699492056",
    "firmName": "Norton Rose Fullbright (Middle East) LLP",
    "registrationNumber": "L-05800",
    "licenseIssueDate": "05/24/2023 00:00:00",
    "licenseExpiryDate": "05/23/2026 00:00:00"
  },
  {
    "id": "a3c2ef9b-5cc6-4a58-a1f3-f294c6d0c799",
    "slug": "richard-martin-dupay",
    "name": "RICHARD MARTIN DUPAY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/03/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Richard Martin Dupay",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a3c2ef9b-5cc6-4a58-a1f3-f294c6d0c799",
        "address": "",
        "phone": "97145119777 / 971508184427",
        "email": "richard.davies@bclplaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6c617112-4b98-414c-868a-7d0316427c21",
    "firmName": "Bryan Cave Leighton Paisner LLP",
    "registrationNumber": "L-06267",
    "licenseIssueDate": "03/22/2024 00:00:00",
    "licenseExpiryDate": "03/21/2026 00:00:00"
  },
  {
    "id": "b618087b-4aa0-4648-a6fa-e007add635b0",
    "slug": "richard-parris",
    "name": "RICHARD HUGH PARRIS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Richard Parris",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b618087b-4aa0-4648-a6fa-e007add635b0",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-00181",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "444e40a3-a8a8-41df-a9b3-92d9135cb3ab",
    "slug": "richard-strub",
    "name": "RICHARD HENRY STRUB",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/10/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Richard Strub",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_444e40a3-a8a8-41df-a9b3-92d9135cb3ab",
        "address": "",
        "phone": "97144230555 / 971504788443",
        "email": "yah@hfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c462c65e-185a-4e81-8425-a87e3a2b6842",
    "firmName": "Holman Fenwick Willan Middle East LLP",
    "registrationNumber": "L-03532",
    "licenseIssueDate": "10/27/2016 00:00:00",
    "licenseExpiryDate": "10/23/2026 00:00:00"
  },
  {
    "id": "f9d1057a-2965-4f53-b669-6a504afeead0",
    "slug": "rick-saha",
    "name": "RICK SAHA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/02/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-02-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rick Saha",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f9d1057a-2965-4f53-b669-6a504afeead0",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-06679",
    "licenseIssueDate": "02/14/2025 00:00:00",
    "licenseExpiryDate": "02/13/2026 00:00:00"
  },
  {
    "id": "133b67ae-fca9-451a-aca7-36e117232800",
    "slug": "ridhiima-kapoor",
    "name": "RIDHIIMA KAPOOR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/03/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ridhiima Kapoor",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_133b67ae-fca9-451a-aca7-36e117232800",
        "address": "Unit No. S1003, Level 10 ,Emirates Financial Towers ,Dubai International Financial Centre ,000 ,Dubai",
        "phone": "97144501900 / 971566072398",
        "email": "david.welford@ogier.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7387d35c-79ea-44c2-88c5-58669a5e825d",
    "firmName": "Ogier (DIFC) LLP",
    "registrationNumber": "L-06235",
    "licenseIssueDate": "03/13/2024 00:00:00",
    "licenseExpiryDate": "03/12/2026 00:00:00"
  },
  {
    "id": "7f619ca7-d1b4-4c1c-8b8f-c40f43e3ce76",
    "slug": "rim-jean-dagher",
    "name": "RIM JEAN DAGHER",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/02/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rim Jean Dagher",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7f619ca7-d1b4-4c1c-8b8f-c40f43e3ce76",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-06708",
    "licenseIssueDate": "02/21/2025 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "9fab0ed1-0cf4-4c0f-a2cb-1772d9de7995",
    "slug": "rima-abdellah",
    "name": "REMA AHMED ABDULLAH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/05/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rima Abdellah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9fab0ed1-0cf4-4c0f-a2cb-1772d9de7995",
        "address": "",
        "phone": "97108307033",
        "email": "general.alshamsi@lawuae.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d29f6d04-dad1-4f59-9ae2-d4d245f63133",
    "firmName": "AL SHAMSI & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02193",
    "licenseIssueDate": "05/21/2013 00:00:00",
    "licenseExpiryDate": "05/14/2026 00:00:00"
  },
  {
    "id": "5f1b184c-3afb-4e85-8fe0-de36fb91b666",
    "slug": "rima-mourad",
    "name": "RIMA MOURAD",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rima Mourad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5f1b184c-3afb-4e85-8fe0-de36fb91b666",
        "address": "",
        "phone": "97143685555",
        "email": "maisa.maarouf@bsabh.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8afa232f-52ff-4dad-82c3-9a04d66eb853",
    "firmName": "B S A AHMED BIN HAZEEM & ASSOCIATES LLP - DIFC",
    "registrationNumber": "L-01639",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "4a888911-b791-432a-a03c-9de31f057610",
    "slug": "rima-sabri-mahmoud",
    "name": "RIMA SABRI MAHMOUD",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/07/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rima Sabri Mahmoud",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4a888911-b791-432a-a03c-9de31f057610",
        "address": "",
        "phone": "97143897000 / 971506553198",
        "email": "nasseralikhasawneh@eversheds-sutherland.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "74a21d43-41d8-480a-a6af-6939b7c98a95",
    "firmName": "Eversheds Sutherland (International LLP) Dubai Branch",
    "registrationNumber": "L-06901",
    "licenseIssueDate": "07/30/2025 00:00:00",
    "licenseExpiryDate": "07/29/2026 00:00:00"
  },
  {
    "id": "e211fafd-99c1-484d-9d90-b2a6c7b0cab1",
    "slug": "rindala-beydoun",
    "name": "Rindala Beydoun",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/15/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rindala Beydoun",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e211fafd-99c1-484d-9d90-b2a6c7b0cab1",
        "address": "",
        "phone": "97145979700 / 971505532609",
        "email": "rbeydoun@t-lawadvisors.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "3d9f2bb9-85fe-49cc-9187-0b808bfa2a2d",
    "firmName": "Rindala Beydoun Legal Consultancy",
    "registrationNumber": "L-01070",
    "licenseIssueDate": "03/15/2021 00:00:00",
    "licenseExpiryDate": "03/14/2026 00:00:00"
  },
  {
    "id": "df0c8d13-7d90-45e1-ab8d-b17bf07876d6",
    "slug": "rishi-sengupta",
    "name": "RISHI SENGUPTA DEBDATTA SENGUPTA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Civil Transactions-Insurance"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/08/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rishi Sengupta",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_df0c8d13-7d90-45e1-ab8d-b17bf07876d6",
        "address": "Building 5 ,Dubai World Trade Centre ,212620 ,",
        "phone": "97143503600 / 971563631562",
        "email": "p.ellingham@kennedys-law.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "83d3ede1-3a28-4b03-8c92-6bd31a1cb95e",
    "firmName": "Kennedys Dubai LLP",
    "registrationNumber": "L-00749",
    "licenseIssueDate": "08/29/2012 00:00:00",
    "licenseExpiryDate": "08/21/2026 00:00:00"
  },
  {
    "id": "fa54a9fb-57eb-43c3-8608-d7d5dae4d7e0",
    "slug": "rita-chebli",
    "name": "RITA GEORGES CHEBLI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/09/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rita Chebli",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fa54a9fb-57eb-43c3-8608-d7d5dae4d7e0",
        "address": "مطعم زعتر وزيت  ,اسبكت تاور  ,فندق تاج  ,118212 ,Dubai",
        "phone": "97144433013 / 97144433013",
        "email": "moaza.alkhadar.alc@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "1dc550f7-81c5-4a5a-9096-682d651b8688",
    "firmName": "MOAZA AL KHADAR ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01887",
    "licenseIssueDate": "09/26/2011 00:00:00",
    "licenseExpiryDate": "09/17/2026 00:00:00"
  },
  {
    "id": "00b09b65-d15d-4e7e-bce0-3663cc1cc005",
    "slug": "rita-jaballah",
    "name": "RITA JABALLAH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rita Jaballah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_00b09b65-d15d-4e7e-bce0-3663cc1cc005",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01308",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "2e6f6b92-8875-47d3-a982-1888b56b243e",
    "slug": "rita-marlene-kaufmann",
    "name": "RITA MARLENE KAUFMANN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/03/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rita Marlene Kaufmann",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2e6f6b92-8875-47d3-a982-1888b56b243e",
        "address": "Firas Hassan Al Choufi ,701 ,The Prime Tower ,Makani No: 25836 86879 ,125305 ,Dubai",
        "phone": "97144357246",
        "email": "info@binsevanadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4d3c9dcc-51c6-4883-b9ed-c65a7d1c5a57",
    "firmName": "BIN SEVAN ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-06727",
    "licenseIssueDate": "03/26/2025 00:00:00",
    "licenseExpiryDate": "03/25/2026 00:00:00"
  },
  {
    "id": "1ea6c322-e458-4422-969f-75349c38374e",
    "slug": "rizwan-kanji",
    "name": "RIZWAN HAIDERALI KANJI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/11/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rizwan Kanji",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1ea6c322-e458-4422-969f-75349c38374e",
        "address": "ICD Brookfield Place ,DIFC ,120109 ,",
        "phone": "97143173000 / 971504465229",
        "email": "DubaiLAD@akingump.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9ff29eab-adb8-40f9-ab84-216e01a381e4",
    "firmName": "Akin Gump Strauss Hauer & Feld LLP",
    "registrationNumber": "L-00820",
    "licenseIssueDate": "11/22/2011 00:00:00",
    "licenseExpiryDate": "11/13/2025 00:00:00"
  },
  {
    "id": "13760f42-4bf9-47e0-8174-b20e6de2b765",
    "slug": "robert-christopher-crawford",
    "name": "ROBERT CHRISTOPHER CRAWFORD",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/07/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ROBERT CHRISTOPHER CRAWFORD",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_13760f42-4bf9-47e0-8174-b20e6de2b765",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-06886",
    "licenseIssueDate": "07/09/2025 00:00:00",
    "licenseExpiryDate": "07/08/2026 00:00:00"
  },
  {
    "id": "5ce81b12-22c0-46ad-b701-2731f6d01100",
    "slug": "robert-daniel-james",
    "name": "ROBERT DANIEL JAMES",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/04/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Robert Daniel James",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5ce81b12-22c0-46ad-b701-2731f6d01100",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-04073",
    "licenseIssueDate": "04/16/2018 00:00:00",
    "licenseExpiryDate": "04/13/2026 00:00:00"
  },
  {
    "id": "6bbdaae6-cfe5-4290-9389-c5486cf82d09",
    "slug": "robert-harker",
    "name": "ROBERT JAMES HARKER",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Robert Harker",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6bbdaae6-cfe5-4290-9389-c5486cf82d09",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-00725",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "d4d76882-f3a5-4fd3-9db0-9329cd7630bb",
    "slug": "robert-hugh-booth",
    "name": "ROBERT HUGH BOOTH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/07/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Robert Hugh Booth",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d4d76882-f3a5-4fd3-9db0-9329cd7630bb",
        "address": "",
        "phone": "97144363636 / 971505572900",
        "email": "hassan.elsayed@bakerbotts.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "fd5d6571-d053-4436-9de5-c8a36ce7c6c9",
    "firmName": "Baker Botts LLP Legal Consultants Dubai Branch",
    "registrationNumber": "L-05442",
    "licenseIssueDate": "07/27/2022 00:00:00",
    "licenseExpiryDate": "07/26/2026 00:00:00"
  },
  {
    "id": "96902a85-1ce2-47c0-89b3-6eb3a3c88664",
    "slug": "robert-lachlan-morris",
    "name": "ROBERT LACHLAN MORRIS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/12/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Robert Lachlan Morris",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_96902a85-1ce2-47c0-89b3-6eb3a3c88664",
        "address": "6 ,Office Nos. 603, 604 & 605, Level 6, Burj Daman ,Dubai International Financial Centre ,506555 ,Dubai",
        "phone": "97143506400 / 971504654755",
        "email": "r.hickman@aglaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8690f7d5-6b96-4649-9589-71303f2c2707",
    "firmName": "Addleshaw Goddard (Middle East) LLP",
    "registrationNumber": "L-05159",
    "licenseIssueDate": "12/30/2021 00:00:00",
    "licenseExpiryDate": "12/29/2025 00:00:00"
  },
  {
    "id": "aa1d67f7-4ca5-44c8-9e3f-ff6101c0d3fc",
    "slug": "robert-lawrence",
    "name": "ROBERT LAWRENCE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/10/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Robert Lawrence",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_aa1d67f7-4ca5-44c8-9e3f-ff6101c0d3fc",
        "address": "",
        "phone": "97144230555 / 971504788443",
        "email": "yah@hfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c462c65e-185a-4e81-8425-a87e3a2b6842",
    "firmName": "Holman Fenwick Willan Middle East LLP",
    "registrationNumber": "L-00321",
    "licenseIssueDate": "10/11/2011 00:00:00",
    "licenseExpiryDate": "10/02/2026 00:00:00"
  },
  {
    "id": "d4cbefc5-9843-4a2c-90cf-395736a99f9f",
    "slug": "robert-mitchley",
    "name": "ROBERT MITCHLEY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/09/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Robert Mitchley",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d4cbefc5-9843-4a2c-90cf-395736a99f9f",
        "address": "",
        "phone": "97143685555",
        "email": "maisa.maarouf@bsabh.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8afa232f-52ff-4dad-82c3-9a04d66eb853",
    "firmName": "B S A AHMED BIN HAZEEM & ASSOCIATES LLP - DIFC",
    "registrationNumber": "L-03413",
    "licenseIssueDate": "09/05/2023 00:00:00",
    "licenseExpiryDate": "09/04/2026 00:00:00"
  },
  {
    "id": "b73c9cc7-0f6d-45b2-a1dd-e22e5864ef4b",
    "slug": "robert-whitehead",
    "name": "ROBERT WHITEHEAD",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/01/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Robert Whitehead",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b73c9cc7-0f6d-45b2-a1dd-e22e5864ef4b",
        "address": "HAMDAN ALSHAMSI ,الطابق الرابع مكتب 401, 406,407 ,بي سكوير 01 ,مجمع دبي سكوير ,116564 ,Dubai",
        "phone": "97143469262",
        "email": "courts@has.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de2c61a6-9d00-457e-ad1d-e73e4e62d9bd",
    "firmName": "HAMDAN ALSHAMSI LAWYER & LEGAL CONSULTANTS",
    "registrationNumber": "L-03950",
    "licenseIssueDate": "01/02/2018 00:00:00",
    "licenseExpiryDate": "12/30/2025 00:00:00"
  },
  {
    "id": "f757aeee-292d-483f-9950-5a741cf8adf1",
    "slug": "roberta-di-siena",
    "name": "ROBERTA DI SIENA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/01/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Roberta Di Siena",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f757aeee-292d-483f-9950-5a741cf8adf1",
        "address": "Mezzanine / 09 ,Business Point  ,Behind Nissan Showroom ,85825 ,Dubai",
        "phone": "97142595777",
        "email": "ALMATROOSHI@OMALC.AE",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "588c9e2f-4f09-44bb-9e80-4e56d3f821b6",
    "firmName": "ALOWAIS & AL MATROOSHI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-03609",
    "licenseIssueDate": "01/19/2017 00:00:00",
    "licenseExpiryDate": "01/15/2026 00:00:00"
  },
  {
    "id": "7f794b57-4e0c-48db-bdff-c4b989fd3427",
    "slug": "roberto-flammia",
    "name": "ROBERTO FLAMMIA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/12/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Roberto Flammia",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7f794b57-4e0c-48db-bdff-c4b989fd3427",
        "address": "NA ,Index tower ,NA ,506828 ,Dubai",
        "phone": "97154228569 / 971525567076",
        "email": "silviaelba.sartori@belex.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "f77150e9-6cee-4d5e-9619-7fa5f488aee3",
    "firmName": "BonelliErede Middle East LLP",
    "registrationNumber": "L-04147",
    "licenseIssueDate": "12/04/2017 00:00:00",
    "licenseExpiryDate": "12/01/2025 00:00:00"
  },
  {
    "id": "9a42ab13-a481-4deb-8e90-7d9f31b5dd80",
    "slug": "robin-balmer",
    "name": "ROBIN LESLIE BALMER",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Robin Balmer",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9a42ab13-a481-4deb-8e90-7d9f31b5dd80",
        "address": "",
        "phone": "97143742800 / 971506450677",
        "email": "jabbott21@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7a59d310-ff72-4318-b41c-27095c163d0f",
    "firmName": "CMS (UAE) LLP",
    "registrationNumber": "L-00183",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "74b13801-ae04-4c4f-8a8f-a2ee4ebd6536",
    "slug": "robin-hickman",
    "name": "ROBIN NICHOLAS HICKMAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/12/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Robin Hickman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_74b13801-ae04-4c4f-8a8f-a2ee4ebd6536",
        "address": "6 ,Office Nos. 603, 604 & 605, Level 6, Burj Daman ,Dubai International Financial Centre ,506555 ,Dubai",
        "phone": "97143506400 / 971504654755",
        "email": "r.hickman@aglaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "8690f7d5-6b96-4649-9589-71303f2c2707",
    "firmName": "Addleshaw Goddard (Middle East) LLP",
    "registrationNumber": "L-00184",
    "licenseIssueDate": "12/06/2016 00:00:00",
    "licenseExpiryDate": "12/02/2025 00:00:00"
  },
  {
    "id": "92450206-733d-4db2-a3da-9faa40b7f648",
    "slug": "robyn-susan-cutler",
    "name": "ROBYN SUSAN CUTLER",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/08/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Robyn Susan Cutler",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_92450206-733d-4db2-a3da-9faa40b7f648",
        "address": "",
        "phone": "97143897000 / 971506553198",
        "email": "nasseralikhasawneh@eversheds-sutherland.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "74a21d43-41d8-480a-a6af-6939b7c98a95",
    "firmName": "Eversheds Sutherland (International LLP) Dubai Branch",
    "registrationNumber": "L-06920",
    "licenseIssueDate": "08/18/2025 00:00:00",
    "licenseExpiryDate": "08/17/2026 00:00:00"
  },
  {
    "id": "fc8f9f28-60cd-4ae2-9365-5cd2727db270",
    "slug": "rodolphe-pellerin",
    "name": "RODOLPHE ROGER PELLERIN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rodolphe Pellerin",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fc8f9f28-60cd-4ae2-9365-5cd2727db270",
        "address": "1 ,ICD Brookfield Place ,Dubai International Financial Centre ,9267 ,Dubai",
        "phone": "97147010975 / 971502977062",
        "email": "chris.sioufi@ae.ey.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "42e536ef-e3d8-4339-8572-657a7f7a0331",
    "firmName": "EY Law LLP",
    "registrationNumber": "L-01063",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "9b609386-b895-4f52-8c49-b3dbe0670b3f",
    "slug": "rodrigo-care",
    "name": "RODRIGO CARE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Cases and Proceedings before Dubai International Financial Centre",
      "Civil Transactions-Construction and Contracts for Services",
      "Civil Transactions-Arbitration",
      "Personal Status-Legacies and Inheritance",
      "Commercial Transactions-Sea and air freight",
      "Proceedings-Cases and Proceedings before arbitral tribunals and other alternative dispute resolution bodies",
      "Criminal Law-Crimes against properties"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/08/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rodrigo Care",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9b609386-b895-4f52-8c49-b3dbe0670b3f",
        "address": "",
        "phone": "97143937700",
        "email": "info@galadarilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d863b662-c864-4193-8b3a-ff6ee5fe6c64",
    "firmName": "GALADARI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05451",
    "licenseIssueDate": "08/03/2022 00:00:00",
    "licenseExpiryDate": "08/02/2026 00:00:00"
  },
  {
    "id": "32d91c6c-4249-40f1-9851-0868f3ad6fcf",
    "slug": "roger-el-khalil",
    "name": "ROGER TANSA ELKHALIL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/01/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Roger El Khalil",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_32d91c6c-4249-40f1-9851-0868f3ad6fcf",
        "address": "",
        "phone": "97142986558",
        "email": "mak@maklegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "06d1b0e4-10d9-46d5-9f6b-44710029bb65",
    "firmName": "HIBA MAANI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01361",
    "licenseIssueDate": "01/08/2012 00:00:00",
    "licenseExpiryDate": "12/30/2025 00:00:00"
  },
  {
    "id": "ed671a12-c22e-45c5-b85c-3e56f45b00b8",
    "slug": "roger-gaspard",
    "name": "ROGER GASPARD",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/08/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Roger Gaspard",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ed671a12-c22e-45c5-b85c-3e56f45b00b8",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-04206",
    "licenseIssueDate": "08/27/2018 00:00:00",
    "licenseExpiryDate": "08/25/2026 00:00:00"
  },
  {
    "id": "06c06b22-dbb4-4d04-89b3-9fbf5fb3b679",
    "slug": "rohit-gulati",
    "name": "ROHIT GULATI NARINDER KUMAR GULATI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/02/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rohit Gulati",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_06c06b22-dbb4-4d04-89b3-9fbf5fb3b679",
        "address": "4th floor ,Al Saaha Offices Block D office 401A ,Burj Khalifa ,283773 ,Dubai",
        "phone": "97144221944",
        "email": "gov.depts@alsafarpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b7bbfaeb-1fdb-46d2-97cf-8e6432a9b8a7",
    "firmName": "AL SAFAR & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04323",
    "licenseIssueDate": "02/25/2019 00:00:00",
    "licenseExpiryDate": "02/23/2026 00:00:00"
  },
  {
    "id": "0c233957-a88a-4cdc-b5e0-bb455e6e98c5",
    "slug": "rohit-kochhar",
    "name": "ROHIT KOCHHAR KEWAL KRISHAN KOCHHAR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/06/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rohit Kochhar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0c233957-a88a-4cdc-b5e0-bb455e6e98c5",
        "address": "",
        "phone": "97142776075 / 971588324788",
        "email": "avichal@kochhardubai.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "847eff7c-4142-431e-a8d6-f58ff60964f6",
    "firmName": "Kochhar & Co Inc Legal Consultants (Dubai Branch)",
    "registrationNumber": "L-03396",
    "licenseIssueDate": "06/29/2016 00:00:00",
    "licenseExpiryDate": "06/25/2026 00:00:00"
  },
  {
    "id": "36972dab-e701-4fe8-ab86-2cf6f4ac2343",
    "slug": "roma-diva-patel",
    "name": "ROMA DIVA PATEL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/05/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Roma Diva Patel",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_36972dab-e701-4fe8-ab86-2cf6f4ac2343",
        "address": "Office 1A ,Silver Tower ,DMCC Al Mas Tower ,283149 ,Dubai",
        "phone": "97144542355 / 971564092949",
        "email": "pstone@fenwickelliott.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "45b03212-ac3a-4dbc-8b2d-10fc81273543",
    "firmName": "Fenwick Elliott LLP (DMCC Branch)",
    "registrationNumber": "L-06289",
    "licenseIssueDate": "05/08/2024 00:00:00",
    "licenseExpiryDate": "05/07/2026 00:00:00"
  },
  {
    "id": "7b818b7d-2e52-441d-9f0d-cf6af36c6756",
    "slug": "roman-boiko",
    "name": "ROMAN BOIKO",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Commercial Agency",
      "Civil Transactions-Insurance",
      "Civil Transactions-Construction and Contracts for Services",
      "Civil Transactions-Ownership & Title",
      "Commercial Transactions-Commercial Mortgage",
      "Commercial Transactions-Commercial Contracts",
      "Commercial Transactions-Commercial Real Estate",
      "Civil Transactions-Residential Real Estate",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Civil Transactions-Arbitration",
      "Civil Transactions-Tenancy",
      "Commercial Transactions-Commercial Companies",
      "Civil Transactions-Sale",
      "Commercial Transactions-Sea and air freight",
      "Commercial Transactions-E-Commerce",
      "Commercial Transactions-Intellectual Property (includes trademarks",
      "copy rights",
      "patents)"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/08/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Roman Boiko",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7b818b7d-2e52-441d-9f0d-cf6af36c6756",
        "address": "MOHAMMED MURTADA ALHASHMI ,3 ,LATIFA TOWER  ,CROWN PLAZA ,231400 ,Dubai",
        "phone": "97143521131",
        "email": "info@mhadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a5a2640f-b1b8-4512-b9ee-a8802d0c30fc",
    "firmName": "MOHAMMED AL HASHIMI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-03848",
    "licenseIssueDate": "08/03/2017 00:00:00",
    "licenseExpiryDate": "07/31/2026 00:00:00"
  },
  {
    "id": "c6c90de0-87ca-4d98-a34b-cca7b56dfd97",
    "slug": "roman-khodykin",
    "name": "ROMAN KHODYKIN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/09/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Roman Khodykin",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c6c90de0-87ca-4d98-a34b-cca7b56dfd97",
        "address": "",
        "phone": "97145119777 / 971508184427",
        "email": "richard.davies@bclplaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6c617112-4b98-414c-868a-7d0316427c21",
    "firmName": "Bryan Cave Leighton Paisner LLP",
    "registrationNumber": "L-06962",
    "licenseIssueDate": "09/10/2025 00:00:00",
    "licenseExpiryDate": "09/09/2026 00:00:00"
  },
  {
    "id": "267613be-2cad-44cc-859b-354b98652d84",
    "slug": "roman-zhavner",
    "name": "ROMAN ZHAVNER",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSWgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/05/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Roman Zhavner",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_267613be-2cad-44cc-859b-354b98652d84",
        "address": "",
        "phone": "/ 971527856097",
        "email": "roman_zhavner@epamlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "e2c7ecee-1913-48a7-a833-a10d08f984f4",
    "firmName": "EPAM Legal LLC",
    "registrationNumber": "L-06828",
    "licenseIssueDate": "05/28/2025 00:00:00",
    "licenseExpiryDate": "05/27/2026 00:00:00"
  },
  {
    "id": "3c660f5d-4598-45fd-bd8c-a81e8d42ef91",
    "slug": "romano-xavier-dolbey",
    "name": "ROMANO XAVIER DOLBEY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSWAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Personal Status-Wills",
      "Personal Status-Legacies and Inheritance"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/08/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Romano Xavier Dolbey",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3c660f5d-4598-45fd-bd8c-a81e8d42ef91",
        "address": "1 ,API World Tower ,258.37 square meters ,52294 ,Dubai",
        "phone": "97143317552 / 971504524322",
        "email": "berry@jamesberrylaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "f85683bf-f79f-4e38-9b7c-a1a75cd840b4",
    "firmName": "James Berry & Associates Legal Consultants",
    "registrationNumber": "L-05465",
    "licenseIssueDate": "08/17/2022 00:00:00",
    "licenseExpiryDate": "08/16/2026 00:00:00"
  },
  {
    "id": "20bb6e46-dc8c-4e77-80a7-62be19e1043c",
    "slug": "ronald-daniel-nobbs",
    "name": "RONALD DANIEL NOBBS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/10/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ronald Daniel Nobbs",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_20bb6e46-dc8c-4e77-80a7-62be19e1043c",
        "address": "",
        "phone": "97144073901 / 971503479508",
        "email": "Rania.Tadros@stephensonharwood.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dd5042a2-bb41-4123-9544-79c3fa831332",
    "firmName": "Stephenson Harwood (Middle East) LLP",
    "registrationNumber": "L-06536",
    "licenseIssueDate": "10/04/2024 00:00:00",
    "licenseExpiryDate": "10/03/2026 00:00:00"
  },
  {
    "id": "d0486cf0-c057-423a-9068-e2aad8bcb05b",
    "slug": "ronald-stewart-graham",
    "name": "RONALD STEWART GRAHAM",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/10/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: RONALD STEWART GRAHAM",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d0486cf0-c057-423a-9068-e2aad8bcb05b",
        "address": "",
        "phone": "97104309100 / 971564013758",
        "email": "c.royle@taylorwessing.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "d51b6f43-8c62-486f-a1ab-6ee3b87c8006",
    "firmName": "Taylor Wessing LLP (Dubai Branch)",
    "registrationNumber": "L-05061",
    "licenseIssueDate": "10/11/2021 00:00:00",
    "licenseExpiryDate": "10/10/2026 00:00:00"
  },
  {
    "id": "86705fd3-6bc5-4683-969a-527d393e5659",
    "slug": "rony-eid",
    "name": "RONY FAYROUZ EID",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/09/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rony Eid",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_86705fd3-6bc5-4683-969a-527d393e5659",
        "address": "Al Fattan Currency House Tower 2 ,DIFC ,507176 ,",
        "phone": "/ 971552009003",
        "email": "Mohammad.AlRasheed@bakermckenzie.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "acd81e81-dead-4f7c-839e-0f2a57897265",
    "firmName": "Baker & Mckenzie LLP",
    "registrationNumber": "L-01782",
    "licenseIssueDate": "09/26/2011 00:00:00",
    "licenseExpiryDate": "09/17/2026 00:00:00"
  },
  {
    "id": "8aaca3af-1eed-4fef-b857-e811a0e556e3",
    "slug": "rory-charles-gordon-page",
    "name": "RORY CHARLES GORDON PAGE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/03/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rory Charles Gordon Page",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8aaca3af-1eed-4fef-b857-e811a0e556e3",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-06242",
    "licenseIssueDate": "03/13/2024 00:00:00",
    "licenseExpiryDate": "03/12/2026 00:00:00"
  },
  {
    "id": "60113423-1e56-4406-b094-0c05a0359462",
    "slug": "rosanna-christy-gilbey",
    "name": "ROSANNA CHRISTY GILBEY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/07/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rosanna Christy Gilbey",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_60113423-1e56-4406-b094-0c05a0359462",
        "address": "",
        "phone": "97143742800 / 971506450677",
        "email": "jabbott21@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7a59d310-ff72-4318-b41c-27095c163d0f",
    "firmName": "CMS (UAE) LLP",
    "registrationNumber": "L-06431",
    "licenseIssueDate": "07/24/2024 00:00:00",
    "licenseExpiryDate": "07/23/2026 00:00:00"
  },
  {
    "id": "ae7abd7b-2650-413a-9cf8-5b7a6bff8eaf",
    "slug": "roshanak-bassiri-gharb",
    "name": "ROSHANAK BASSIRI GHARB",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/11/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Roshanak Bassiri Gharb",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ae7abd7b-2650-413a-9cf8-5b7a6bff8eaf",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-04264",
    "licenseIssueDate": "11/05/2018 00:00:00",
    "licenseExpiryDate": "11/03/2025 00:00:00"
  },
  {
    "id": "8c05b2c5-56bd-47d2-b0d4-ac4c94b8a8a1",
    "slug": "roshanali-rafiq-jaffer",
    "name": "ROSHANALI RAFIQ JAFFER JAFFER ROSHANALI KAMRUDDIN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/09/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Roshanali Rafiq Jaffer",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8c05b2c5-56bd-47d2-b0d4-ac4c94b8a8a1",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04207",
    "licenseIssueDate": "09/11/2018 00:00:00",
    "licenseExpiryDate": "09/09/2026 00:00:00"
  },
  {
    "id": "2a7338a2-aead-4d9f-9e51-33b218ec68b4",
    "slug": "roshni-chadda",
    "name": "Roshni Chadda",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/12/2022",
    "licenseStatus": "active",
    "licenseExpiry": "2023-12-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Roshni Chadda",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2a7338a2-aead-4d9f-9e51-33b218ec68b4",
        "address": "1 ,API World Tower ,258.37 square meters ,52294 ,Dubai",
        "phone": "97143317552 / 971504524322",
        "email": "berry@jamesberrylaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "f85683bf-f79f-4e38-9b7c-a1a75cd840b4",
    "firmName": "James Berry & Associates Legal Consultants",
    "registrationNumber": "L-05646",
    "licenseIssueDate": "12/14/2022 00:00:00",
    "licenseExpiryDate": "12/13/2025 00:00:00"
  },
  {
    "id": "67c81f93-2311-4bda-a672-530e38302c67",
    "slug": "ross-wilson",
    "name": "ROSS WILSON",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/11/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ross Wilson",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_67c81f93-2311-4bda-a672-530e38302c67",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-05573",
    "licenseIssueDate": "11/02/2022 00:00:00",
    "licenseExpiryDate": "11/01/2025 00:00:00"
  },
  {
    "id": "cec0115a-6152-4f5e-9678-18f53d9101b4",
    "slug": "rostislav-strigalev",
    "name": "ROSTISLAV STRIGALEV",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/06/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rostislav Strigalev",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cec0115a-6152-4f5e-9678-18f53d9101b4",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-05863",
    "licenseIssueDate": "06/21/2023 00:00:00",
    "licenseExpiryDate": "06/20/2026 00:00:00"
  },
  {
    "id": "d38b1be4-b02d-4142-92b8-e154787ce28e",
    "slug": "roula-maalouf",
    "name": "ROULA GERGI MAALOUF",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/11/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-11-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Roula Maalouf",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d38b1be4-b02d-4142-92b8-e154787ce28e",
        "address": "5 ,LIBERTY HOUSE ,RITZ HOTEL DIFC ,506949 ,Dubai",
        "phone": "97143860090 / 971507887401",
        "email": "maalouf@iaalo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "8d9bc487-6793-4ea8-a629-49ba36823552",
    "firmName": "IAA MIDDLE EAST LEGAL CONSULTANTS LTD",
    "registrationNumber": "L-02779",
    "licenseIssueDate": "11/26/2014 00:00:00",
    "licenseExpiryDate": "11/20/2025 00:00:00"
  },
  {
    "id": "71751bc4-4124-4f41-a11c-3cce61aebfb5",
    "slug": "roustam-farman",
    "name": "ROUSTAM FARMAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/10/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Roustam Farman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_71751bc4-4124-4f41-a11c-3cce61aebfb5",
        "address": "",
        "phone": "97143528887",
        "email": "info@kashwanilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "01ccf3a9-cfd3-4fb5-b5ac-a912503c2630",
    "firmName": "KASHWANI LAW FIRM",
    "registrationNumber": "L-03271",
    "licenseIssueDate": "10/06/2015 00:00:00",
    "licenseExpiryDate": "10/03/2026 00:00:00"
  },
  {
    "id": "1e04d503-0841-4c09-af1f-84816540b0a6",
    "slug": "rowan-hamza-mohamed-noor-alzubair-mohd-noor",
    "name": "Rowan Hamza Mohamed Noor Alzubair Mohd Noor",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/06/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rowan Hamza Mohamed Noor Alzubair Mohd Noor",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1e04d503-0841-4c09-af1f-84816540b0a6",
        "address": "O-4801, O-4901 ,Burj al Salam Office Tower ,H Hotel ,111801 ,Dubai",
        "phone": "97143544444",
        "email": "administration@horizlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4e25fb39-6659-44f0-bc8b-3ff0f067beb0",
    "firmName": "HORIZONS & CO - LAW FIRM",
    "registrationNumber": "L-06234",
    "licenseIssueDate": "03/06/2024 00:00:00",
    "licenseExpiryDate": "03/05/2026 00:00:00"
  },
  {
    "id": "3a5ef68d-fb2a-49cb-93a2-ab87802f4874",
    "slug": "rubina-khnom",
    "name": "RUBINA KHNOM",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/09/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rubina Khnom",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3a5ef68d-fb2a-49cb-93a2-ab87802f4874",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-06971",
    "licenseIssueDate": "09/23/2025 00:00:00",
    "licenseExpiryDate": "09/22/2026 00:00:00"
  },
  {
    "id": "c2221646-89d9-42ce-9e2d-31b6c396ae4f",
    "slug": "rudolf-goldschmidt",
    "name": "RUDOLF YVES GOLDSCHMIDT",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/09/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rudolf Goldschmidt",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c2221646-89d9-42ce-9e2d-31b6c396ae4f",
        "address": "One Central, The Offices 5 ,Dubai World Trade Centre ,554660 ,",
        "phone": "97142052030 / 971506566494",
        "email": "chourani@houranipartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "59a73632-40a0-4849-b120-4308dc6f8015",
    "firmName": "Hourani & Partners Legal Consultancy FZCO",
    "registrationNumber": "L-02764",
    "licenseIssueDate": "09/08/2014 00:00:00",
    "licenseExpiryDate": "09/02/2026 00:00:00"
  },
  {
    "id": "4a0363aa-ca4c-4303-894d-de86d5b45639",
    "slug": "rula-dajani",
    "name": "Rula Dajani",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/10/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rula Dajani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4a0363aa-ca4c-4303-894d-de86d5b45639",
        "address": "",
        "phone": "97144230555 / 971504788443",
        "email": "yah@hfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c462c65e-185a-4e81-8425-a87e3a2b6842",
    "firmName": "Holman Fenwick Willan Middle East LLP",
    "registrationNumber": "L-00626",
    "licenseIssueDate": "10/07/2011 00:00:00",
    "licenseExpiryDate": "09/27/2026 00:00:00"
  },
  {
    "id": "16f8fb4c-b125-40bd-aa53-ab9afecf1096",
    "slug": "rupert-charles-nodder",
    "name": "RUPERT CHARLES NODDER",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/04/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rupert Charles Nodder",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_16f8fb4c-b125-40bd-aa53-ab9afecf1096",
        "address": "",
        "phone": "97143742800 / 971506450677",
        "email": "jabbott21@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7a59d310-ff72-4318-b41c-27095c163d0f",
    "firmName": "CMS (UAE) LLP",
    "registrationNumber": "L-06737",
    "licenseIssueDate": "04/23/2025 00:00:00",
    "licenseExpiryDate": "04/22/2026 00:00:00"
  },
  {
    "id": "b2859030-149f-4a7b-8c4d-9121a4f4f954",
    "slug": "rupert-tristram-harper",
    "name": "RUPERT TRISTRAM HARPER",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/09/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rupert Tristram Harper",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b2859030-149f-4a7b-8c4d-9121a4f4f954",
        "address": "",
        "phone": "97142472100 / 971509224336",
        "email": "bhaley@cov.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "65a2e90a-6978-4292-b3f1-ecbebedd7b9a",
    "firmName": "Covington & Burling LLP (Middle East)",
    "registrationNumber": "L-04491",
    "licenseIssueDate": "09/18/2019 00:00:00",
    "licenseExpiryDate": "09/17/2026 00:00:00"
  },
  {
    "id": "26a6ce10-ce16-4658-8c92-da96c89262c8",
    "slug": "russul-hamid-jawad-khazraji",
    "name": "RUSSUL HAMID JAWAD KHAZRAJI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/02/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Russul Hamid Jawad Khazraji",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_26a6ce10-ce16-4658-8c92-da96c89262c8",
        "address": "",
        "phone": "97144472020",
        "email": "info@arnadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e6573267-5872-48d8-add1-06a3deccf9e4",
    "firmName": "ABDUL RAHMAN NASEEB ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05169",
    "licenseIssueDate": "02/08/2022 00:00:00",
    "licenseExpiryDate": "02/07/2026 00:00:00"
  },
  {
    "id": "501c10c2-3370-47ec-a7e9-9a77690ab763",
    "slug": "rustum-shah",
    "name": "RUSTUM SHAH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rustum Shah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_501c10c2-3370-47ec-a7e9-9a77690ab763",
        "address": "",
        "phone": "97144073901 / 971503479508",
        "email": "Rania.Tadros@stephensonharwood.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dd5042a2-bb41-4123-9544-79c3fa831332",
    "firmName": "Stephenson Harwood (Middle East) LLP",
    "registrationNumber": "L-00806",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "194c10c9-db6b-495c-89cf-a4e4e1fb7d24",
    "slug": "ruth-stephen",
    "name": "RUTH MARY STEPHEN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/01/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ruth Stephen",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_194c10c9-db6b-495c-89cf-a4e4e1fb7d24",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506688 ,Dubai",
        "phone": "97147096600 / 971503556811",
        "email": "muneer.khan@simmons-simmons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d1725ca7-06ac-41b2-8d7b-a6e60665b73d",
    "firmName": "Simmons & Simmons (Middle East) LLP-DIFC",
    "registrationNumber": "L-03627",
    "licenseIssueDate": "01/31/2017 00:00:00",
    "licenseExpiryDate": "01/27/2026 00:00:00"
  },
  {
    "id": "eb33c03e-8002-44b8-acbd-bbfdb05513c0",
    "slug": "ryan-anthony-nash",
    "name": "RYAN ANTHONY NASH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/05/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ryan Anthony Nash",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_eb33c03e-8002-44b8-acbd-bbfdb05513c0",
        "address": "",
        "phone": "97143184600 / 971504468184",
        "email": "melaraby@gibsondunn.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c9d2c9d0-6e43-4253-a75d-cdeb400f8d8e",
    "firmName": "Gibson Dunn & Crutcher LLP",
    "registrationNumber": "L-05325",
    "licenseIssueDate": "05/17/2022 00:00:00",
    "licenseExpiryDate": "05/16/2026 00:00:00"
  },
  {
    "id": "e7cc4d1d-0b53-4e07-a06a-558dcebde394",
    "slug": "ryan-du-preez",
    "name": "RYAN DU PREEZ",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/01/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ryan Du Preez",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e7cc4d1d-0b53-4e07-a06a-558dcebde394",
        "address": "",
        "phone": "97145124129 / 971547315151",
        "email": "ryan@constructionlaw.co.za",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "9b87f290-69e4-4ce7-abac-c0457574a0a5",
    "firmName": "Tiefenthaler Attorneys Incorporated - Dubai Branch",
    "registrationNumber": "L-06621",
    "licenseIssueDate": "01/08/2025 00:00:00",
    "licenseExpiryDate": "01/07/2026 00:00:00"
  },
  {
    "id": "29ee71ac-d6a6-4f83-ae71-c4fa26e14ec6",
    "slug": "ryan-shanley",
    "name": "RYAN SHANLEY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/05/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ryan Shanley",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_29ee71ac-d6a6-4f83-ae71-c4fa26e14ec6",
        "address": "6 ,Office Nos. 603, 604 & 605, Level 6, Burj Daman ,Dubai International Financial Centre ,506555 ,Dubai",
        "phone": "97143506400 / 971504654755",
        "email": "r.hickman@aglaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8690f7d5-6b96-4649-9589-71303f2c2707",
    "firmName": "Addleshaw Goddard (Middle East) LLP",
    "registrationNumber": "L-06808",
    "licenseIssueDate": "05/28/2025 00:00:00",
    "licenseExpiryDate": "05/27/2026 00:00:00"
  },
  {
    "id": "694cc61a-09c5-4100-93a0-9a0b8753b0e1",
    "slug": "ryan-whelan",
    "name": "RYAN THOMAS WHELAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/10/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ryan Whelan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_694cc61a-09c5-4100-93a0-9a0b8753b0e1",
        "address": "",
        "phone": "97144073901 / 971503479508",
        "email": "Rania.Tadros@stephensonharwood.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dd5042a2-bb41-4123-9544-79c3fa831332",
    "firmName": "Stephenson Harwood (Middle East) LLP",
    "registrationNumber": "L-02031",
    "licenseIssueDate": "10/10/2013 00:00:00",
    "licenseExpiryDate": "10/03/2026 00:00:00"
  },
  {
    "id": "fddc41d3-cc6f-424b-8566-a12992148490",
    "slug": "rym-khouaja",
    "name": "RYM SALMA ACHOUR EP KHOUAJA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/02/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rym Khouaja",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fddc41d3-cc6f-424b-8566-a12992148490",
        "address": "",
        "phone": "97144230555 / 971504788443",
        "email": "yah@hfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c462c65e-185a-4e81-8425-a87e3a2b6842",
    "firmName": "Holman Fenwick Willan Middle East LLP",
    "registrationNumber": "L-03318",
    "licenseIssueDate": "02/10/2016 00:00:00",
    "licenseExpiryDate": "02/05/2026 00:00:00"
  },
  {
    "id": "ceb7c502-3b66-4c9c-81fc-3344c81ab95b",
    "slug": "saad-abdelfattah-ali-shawaly",
    "name": "SAAD ABDELFATTAH ALI SHAWALY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/02/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: saad abdelfattah ali shawaly",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ceb7c502-3b66-4c9c-81fc-3344c81ab95b",
        "address": "SAAD AL HAMMADI ,مدخل البرج ,ويست بيري ,برج خليفه ,41747 ,Dubai",
        "phone": "97142405222",
        "email": "info@saadpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "18923100-5b94-44e2-b580-2e3b0cc17bf6",
    "firmName": "SAAD AL HAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06208",
    "licenseIssueDate": "02/16/2024 00:00:00",
    "licenseExpiryDate": "02/15/2026 00:00:00"
  },
  {
    "id": "8a938b3c-9773-44bf-aaee-3c153dc8604d",
    "slug": "saad-allah-mohammad-rachawany",
    "name": "SAAD ALLAH MOHAMMAD RACHAWANY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/07/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Saad Allah Mohammad Rachawany",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8a938b3c-9773-44bf-aaee-3c153dc8604d",
        "address": "Ahmad Al Otaibi ,6th floor /606 ,Century 21 Tower ,Alqabayel Center ,126936 ,Dubai",
        "phone": "97142697670",
        "email": "info@otaibilc.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5e10a3c0-085d-4e92-84b1-ec3013bc4bae",
    "firmName": "AL OTAIBI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06899",
    "licenseIssueDate": "07/15/2025 00:00:00",
    "licenseExpiryDate": "07/14/2026 00:00:00"
  },
  {
    "id": "9b3eb979-55bc-4606-9e87-11782da6ae71",
    "slug": "saad-elagawany",
    "name": "SAAD YOUNES MOHAMED ELAGAWANY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Saad Elagawany",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9b3eb979-55bc-4606-9e87-11782da6ae71",
        "address": "",
        "phone": "97143685555",
        "email": "maisa.maarouf@bsabh.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8afa232f-52ff-4dad-82c3-9a04d66eb853",
    "firmName": "B S A AHMED BIN HAZEEM & ASSOCIATES LLP - DIFC",
    "registrationNumber": "L-01641",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "72b8e994-83fa-4ed2-8b12-9583e98e03c0",
    "slug": "saad-foad-abdelmalek",
    "name": "SAAD FOUAD SHOKRY ABDELMALEK",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/07/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Saad Foad Abdelmalek",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_72b8e994-83fa-4ed2-8b12-9583e98e03c0",
        "address": "HASSAN AL BAKRI ,16 ,THE EXCHANGE TOWER ,DUBAI WATER CANAL ,89179 ,Dubai",
        "phone": "97145807888",
        "email": "secretary@alkathirilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b5f1d60b-df9b-4054-ac59-4543a6d06af4",
    "firmName": "SHOUQ ALKATHIRI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01831",
    "licenseIssueDate": "08/01/2013 00:00:00",
    "licenseExpiryDate": "07/25/2026 00:00:00"
  },
  {
    "id": "db413b68-33ce-4c29-a5ca-7bf9e0568870",
    "slug": "saad-mian",
    "name": "SAAD KAMIL MIAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/03/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Saad Mian",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_db413b68-33ce-4c29-a5ca-7bf9e0568870",
        "address": "0 ,ICD Brookfield Place Level 13 ,Trade Centre ,506569 ,Dubai",
        "phone": "97145099100 / 971501006965",
        "email": "menahr@freshfields.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "970f6246-e737-41a7-9c6c-5aa5b8335d45",
    "firmName": "Freshfields LLP DIFC",
    "registrationNumber": "L-03675",
    "licenseIssueDate": "03/22/2017 00:00:00",
    "licenseExpiryDate": "03/18/2026 00:00:00"
  },
  {
    "id": "0e07d942-a477-4106-8c63-4cf1a630cbe5",
    "slug": "saadeldin-eid-ibrahim-moussa",
    "name": "SAADELDIN EID IBRAHIM MOUSSA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Criminal Law-Crimes against persons"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Saadeldin Eid Ibrahim Moussa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0e07d942-a477-4106-8c63-4cf1a630cbe5",
        "address": "first/105 ,Al Shafar Investment ,noor bank metro station ,34655 ,Dubai",
        "phone": "97143386111",
        "email": "unionadvocates1@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "109f3fc4-62e8-4523-9372-95aaf9a76483",
    "firmName": "UNION ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02257",
    "licenseIssueDate": "02/08/2012 00:00:00",
    "licenseExpiryDate": "01/30/2026 00:00:00"
  },
  {
    "id": "4eb3b7b3-c99f-47ae-8b32-e07af41bafd5",
    "slug": "saba-al-sultani",
    "name": "SABA ABDUL WAHID SHAKIR AL SULTANI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/10/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Saba Al Sultani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4eb3b7b3-c99f-47ae-8b32-e07af41bafd5",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-00323",
    "licenseIssueDate": "10/14/2022 00:00:00",
    "licenseExpiryDate": "10/13/2026 00:00:00"
  },
  {
    "id": "9c8c1105-1ef5-4fa8-81eb-a40f76af2dac",
    "slug": "sabah-shelton",
    "name": "SABAH SHELTON",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/04/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sabah Shelton",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9c8c1105-1ef5-4fa8-81eb-a40f76af2dac",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-03434",
    "licenseIssueDate": "04/24/2024 00:00:00",
    "licenseExpiryDate": "04/23/2026 00:00:00"
  },
  {
    "id": "48d3d4f2-799a-4339-a8ae-a712d755ef14",
    "slug": "sabeeha-moolla",
    "name": "SABEEHA MOOLLA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/09/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sabeeha Moolla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_48d3d4f2-799a-4339-a8ae-a712d755ef14",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-06476",
    "licenseIssueDate": "09/04/2024 00:00:00",
    "licenseExpiryDate": "09/03/2026 00:00:00"
  },
  {
    "id": "ceb770d7-1b2c-4aea-be51-837218c0564e",
    "slug": "saber-elsayed-ahmed-ali-deyab",
    "name": "SABER ALSAYED AHMED ALI DEYAB",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/07/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Saber Elsayed Ahmed Ali Deyab",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ceb770d7-1b2c-4aea-be51-837218c0564e",
        "address": "",
        "phone": "97142566660",
        "email": "dlr@ysalc.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "28be4513-86ae-4602-b4cc-8d52ba959e9e",
    "firmName": "YOUSUF AL SHARIF ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04712",
    "licenseIssueDate": "07/09/2020 00:00:00",
    "licenseExpiryDate": "07/08/2026 00:00:00"
  },
  {
    "id": "eb979c3d-c5c6-4b5b-a208-c6a8c15f0349",
    "slug": "sabihah-maida-uthman-mahmud",
    "name": "SABIHAH MAIDA UTHMAN MAHMUD",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/02/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-02-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sabihah Maida Uthman Mahmud",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_eb979c3d-c5c6-4b5b-a208-c6a8c15f0349",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-06692",
    "licenseIssueDate": "02/19/2025 00:00:00",
    "licenseExpiryDate": "02/18/2026 00:00:00"
  },
  {
    "id": "e081b790-ddaf-445f-9580-9c9a3bdbc166",
    "slug": "sabina-passi",
    "name": "SABINA MARIA PASSI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/05/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sabina Passi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e081b790-ddaf-445f-9580-9c9a3bdbc166",
        "address": "6 ,Office Nos. 603, 604 & 605, Level 6, Burj Daman ,Dubai International Financial Centre ,506555 ,Dubai",
        "phone": "97143506400 / 971504654755",
        "email": "r.hickman@aglaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8690f7d5-6b96-4649-9589-71303f2c2707",
    "firmName": "Addleshaw Goddard (Middle East) LLP",
    "registrationNumber": "L-03772",
    "licenseIssueDate": "05/30/2017 00:00:00",
    "licenseExpiryDate": "05/27/2026 00:00:00"
  },
  {
    "id": "ee6edcfe-3267-4caa-a905-cd8e4d2cabfb",
    "slug": "sabitha-rafeekh",
    "name": "SABITHA RAFEEKH CHOORAKKULAM MAKKAR ABDULKHADAR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/08/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sabitha Rafeekh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ee6edcfe-3267-4caa-a905-cd8e4d2cabfb",
        "address": "ادارة ا لمبنى  ,الريم ,الاتصالات  ,42423 ,Dubai",
        "phone": "97142222066",
        "email": "info@ozleco.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7a155f4a-20ec-44ff-863f-4f9fb43d0af4",
    "firmName": "ALOBAIDLI & ALZAROONI ADVOCATES&LEGAL CONSULTANTS",
    "registrationNumber": "L-03449",
    "licenseIssueDate": "08/22/2016 00:00:00",
    "licenseExpiryDate": "08/18/2026 00:00:00"
  },
  {
    "id": "4b860ade-74cb-475d-b7b0-1306fe09d8b9",
    "slug": "sabra-ferhat",
    "name": "SABRA FERHAT",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/11/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sabra Ferhat",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4b860ade-74cb-475d-b7b0-1306fe09d8b9",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-06582",
    "licenseIssueDate": "10/28/2024 00:00:00",
    "licenseExpiryDate": "10/27/2025 00:00:00"
  },
  {
    "id": "f05b801b-fae8-4b4e-a89b-126f0e35ecea",
    "slug": "sabri-mohamed-abdehamid-elfakharany",
    "name": "SABRI MOHAMED ABDELHAMID ELFAKHARANY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/10/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sabri Mohamed Abdehamid Elfakharany",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f05b801b-fae8-4b4e-a89b-126f0e35ecea",
        "address": "othman almarzooqi ,19th ,single business tower ,samaya tower ,114333 ,Dubai",
        "phone": "97142999970 / 971500000000",
        "email": "info@othmanadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a0cdd94d-cc5a-4617-b6a3-b23deb9852d5",
    "firmName": "OTHMAN ALMARZOOQI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05045"
  },
  {
    "id": "f42b997d-9aa1-464f-a547-8586645f87fd",
    "slug": "sabrina-boughida",
    "name": "SABRINA BOUGHIDA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/01/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sabrina BOUGHIDA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f42b997d-9aa1-464f-a547-8586645f87fd",
        "address": "1201 ,برج تريو اي بي اي اوفيس  ,فندق نوافتيل ,8812 ,Dubai",
        "phone": "97144222555",
        "email": "lutfilaw2020@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9a3d884b-a443-4037-9eb4-f810c596cf33",
    "firmName": "LUTFI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04837",
    "licenseIssueDate": "01/21/2021 00:00:00",
    "licenseExpiryDate": "01/20/2026 00:00:00"
  },
  {
    "id": "724a512b-8fdb-431b-9909-514be865a22c",
    "slug": "sabrina-devenish",
    "name": "SABRINA DEVENISH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/06/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sabrina Devenish",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_724a512b-8fdb-431b-9909-514be865a22c",
        "address": "",
        "phone": "97143641686 / 971506288801",
        "email": "b.kadir@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0ba96df8-e4cc-49c2-8ae4-a42878d95926",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS LLC",
    "registrationNumber": "L-05830",
    "licenseIssueDate": "06/21/2023 00:00:00",
    "licenseExpiryDate": "06/20/2026 00:00:00"
  },
  {
    "id": "b67f4f77-ecb8-47b2-86a6-ef72901dc41f",
    "slug": "sabrina-saxena",
    "name": "SABRINA KULSUM SAXENA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/05/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sabrina Saxena",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b67f4f77-ecb8-47b2-86a6-ef72901dc41f",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03787",
    "licenseIssueDate": "05/15/2017 00:00:00",
    "licenseExpiryDate": "05/12/2026 00:00:00"
  },
  {
    "id": "efd97a67-9eb6-4a00-b4eb-6c50fc3bec96",
    "slug": "sachin-karia",
    "name": "SACHIN NALINCHANDRA KARIA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sachin Karia",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_efd97a67-9eb6-4a00-b4eb-6c50fc3bec96",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-00247",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "c98286ae-dd25-4195-94d7-46e950e352a9",
    "slug": "sachin-kerur",
    "name": "SACHIN GANGADHAR KERUR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sachin Kerur",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c98286ae-dd25-4195-94d7-46e950e352a9",
        "address": "Index Tower ,506548 ,Dubai",
        "phone": "97147096300 / 971506767433",
        "email": "amateen@reedsmith.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "b3f87e90-7ce9-4097-82c4-15232365f175",
    "firmName": "Reed Smith LLP",
    "registrationNumber": "L-00920",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "eeb3e93b-2766-4320-91b1-a87ffab8c8ba",
    "slug": "sadaq-ali-haje",
    "name": "Sadaq Ali Haje",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/07/2024",
    "licenseStatus": "active",
    "licenseExpiry": "2025-07-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sadaq Ali Haje",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_eeb3e93b-2766-4320-91b1-a87ffab8c8ba",
        "address": "",
        "phone": "97143897000 / 971506553198",
        "email": "nasseralikhasawneh@eversheds-sutherland.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "74a21d43-41d8-480a-a6af-6939b7c98a95",
    "firmName": "Eversheds Sutherland (International LLP) Dubai Branch",
    "registrationNumber": "L-06410",
    "licenseIssueDate": "07/24/2024 00:00:00",
    "licenseExpiryDate": "07/23/2026 00:00:00"
  },
  {
    "id": "4928a943-68d7-4124-ae7e-de35c462e6b1",
    "slug": "sadia-rana",
    "name": "SADIA RANA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/07/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sadia Rana",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4928a943-68d7-4124-ae7e-de35c462e6b1",
        "address": "Al Fattan Currency House - Tower 1  ,Dubai International Financial Center  ,507104 ,",
        "phone": "97143978565 / 971504587822",
        "email": "Raafat.hares@dwf.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6e5f6dba-07af-4109-8c34-175296450f94",
    "firmName": "DWF (Middle East) LLP",
    "registrationNumber": "L-05925",
    "licenseIssueDate": "07/26/2023 00:00:00",
    "licenseExpiryDate": "07/25/2026 00:00:00"
  },
  {
    "id": "a2b3a483-e551-4b2c-96d5-6134db0a0427",
    "slug": "sadiq-jafar",
    "name": "SADIQ JAFAR DHIA JAFAR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/11/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sadiq Jafar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a2b3a483-e551-4b2c-96d5-6134db0a0427",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-02098",
    "licenseIssueDate": "11/29/2011 00:00:00",
    "licenseExpiryDate": "11/20/2025 00:00:00"
  },
  {
    "id": "c4f3550c-eb25-4bb1-8285-e2124f9bb0ac",
    "slug": "saeed-mohamed-abbas-shareef",
    "name": "SAEED MOHAMED ABBAS MOHAMED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Saeed Mohamed Abbas Shareef",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c4f3550c-eb25-4bb1-8285-e2124f9bb0ac",
        "address": "",
        "phone": "97142946164",
        "email": "info@albannai-law.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "73525ec0-5573-4652-8fd8-c2ef0f19b399",
    "firmName": "ALBANNAI & CO.",
    "registrationNumber": "L-01411",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "8e8676a5-d426-4f7f-96c4-76d4b7ea17fa",
    "slug": "saeed-mohamed-nageeb-abdalla",
    "name": "SAEED MOHAMED NAGEEB ABDALLA ABBAS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/09/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Saeed Mohamed Nageeb Abdalla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8e8676a5-d426-4f7f-96c4-76d4b7ea17fa",
        "address": "",
        "phone": "97142946164",
        "email": "info@albannai-law.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "73525ec0-5573-4652-8fd8-c2ef0f19b399",
    "firmName": "ALBANNAI & CO.",
    "registrationNumber": "L-01884",
    "licenseIssueDate": "09/26/2011 00:00:00",
    "licenseExpiryDate": "09/17/2026 00:00:00"
  },
  {
    "id": "1a5afe39-cd3f-48cf-8b0e-a99a627901fe",
    "slug": "safe-radwan-almobideen",
    "name": "SAFE RADWAN MOHAMAD ALMOBIDEEN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Safe Radwan Almobideen",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1a5afe39-cd3f-48cf-8b0e-a99a627901fe",
        "address": "",
        "phone": "97144073901 / 971503479508",
        "email": "Rania.Tadros@stephensonharwood.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dd5042a2-bb41-4123-9544-79c3fa831332",
    "firmName": "Stephenson Harwood (Middle East) LLP",
    "registrationNumber": "L-01311",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "ae11e7b5-1090-4cc7-ac03-13e06e523649",
    "slug": "safwan-aref-hekmat-al-bakkour",
    "name": "SAFWAN AREF HEKMAT AL BAKKOUR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/03/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Safwan Aref Hekmat Al Bakkour",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ae11e7b5-1090-4cc7-ac03-13e06e523649",
        "address": "الطابق العاشر - 1003 ,برج الريم ,خلف مقر اتصالات - ديرة ,64166 ,Dubai",
        "phone": "97143395953 / 971502110022",
        "email": "info@almazroueiadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0f57dd9c-c65a-4c45-bd06-695ca9e13f69",
    "firmName": "AHMED ALMAZROUEI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06730",
    "licenseIssueDate": "03/19/2025 00:00:00",
    "licenseExpiryDate": "03/18/2026 00:00:00"
  },
  {
    "id": "54564bf3-0bdc-44a7-81c5-e97ec767388a",
    "slug": "safwan-fozi-munther",
    "name": "SAFWAN FOZI MUNTHER",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/10/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Safwan Fozi Munther",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_54564bf3-0bdc-44a7-81c5-e97ec767388a",
        "address": "Firas Hassan Al Choufi ,701 ,The Prime Tower ,Makani No: 25836 86879 ,125305 ,Dubai",
        "phone": "97144357246",
        "email": "info@binsevanadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4d3c9dcc-51c6-4883-b9ed-c65a7d1c5a57",
    "firmName": "BIN SEVAN ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-03881",
    "licenseIssueDate": "10/31/2017 00:00:00",
    "licenseExpiryDate": "10/28/2025 00:00:00"
  },
  {
    "id": "dbc6b20e-8167-4cd5-9e08-7aef309c8fcd",
    "slug": "sahal-hussein-suleman",
    "name": "SAHAL HUSSEIN SULEMAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/08/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sahal Hussein Suleman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dbc6b20e-8167-4cd5-9e08-7aef309c8fcd",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-05881",
    "licenseIssueDate": "08/09/2023 00:00:00",
    "licenseExpiryDate": "08/08/2026 00:00:00"
  },
  {
    "id": "35648aa5-dc6d-419a-8db9-b2673227f5ff",
    "slug": "sahar-rahmatollah-masoumi",
    "name": "SAHAR RAHMATOLLAH MASOUMI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/12/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sahar  Rahmatollah Masoumi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_35648aa5-dc6d-419a-8db9-b2673227f5ff",
        "address": "السادس , مباني الحضيبة للجوائز  ,علم الاتحاد ,200 ,Dubai",
        "phone": "97143545111",
        "email": "altaher_alsabri@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "aced7900-0571-43e1-b49b-4740c6dc298f",
    "firmName": "AL TAHER & AL SABRI ADVOCATES",
    "registrationNumber": "L-05634",
    "licenseIssueDate": "12/14/2022 00:00:00",
    "licenseExpiryDate": "12/13/2025 00:00:00"
  },
  {
    "id": "80dd8275-0e11-440c-9557-598998841ca5",
    "slug": "sahar-abas",
    "name": "SAHAR ABAS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Commercial Contracts",
      "Commercial Transactions-Commercial Companies"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/01/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sahar Abas",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_80dd8275-0e11-440c-9557-598998841ca5",
        "address": "ICD Brookfield Place ,DIFC ,120109 ,",
        "phone": "97143173000 / 971504465229",
        "email": "DubaiLAD@akingump.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9ff29eab-adb8-40f9-ab84-216e01a381e4",
    "firmName": "Akin Gump Strauss Hauer & Feld LLP",
    "registrationNumber": "L-05191",
    "licenseIssueDate": "02/01/2022 00:00:00",
    "licenseExpiryDate": "01/31/2026 00:00:00"
  },
  {
    "id": "6229d4e5-74fa-4a6e-b06f-092c0ca0cf96",
    "slug": "sahar-abdulla-mohamed-obaid-ahmed",
    "name": "SAHAR ABDULLA MOHAMED OBAID AHMED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/12/2022",
    "licenseStatus": "active",
    "licenseExpiry": "2023-12-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: SAHAR ABDULLA MOHAMED OBAID AHMED",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6229d4e5-74fa-4a6e-b06f-092c0ca0cf96",
        "address": "Abdulrahman Ali Alshaali  ,7 ,برج المسعود 2 ,معرض سيارات تويوتا - ديره ,00000 ,Dubai",
        "phone": "97143300780 / 971971454749",
        "email": "abdulrahman@alshaalilegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8fc61dff-5618-4cd0-91c2-617c55c9acda",
    "firmName": "ABDULRHMAN ALSHAALI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05683",
    "licenseIssueDate": "12/21/2022 00:00:00",
    "licenseExpiryDate": "12/20/2025 00:00:00"
  },
  {
    "id": "dc730b8b-30f4-4d2f-8fc6-fa85dc679feb",
    "slug": "sahar-tarhini",
    "name": "SAHAR HUSSEIN TARHINI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/10/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sahar Tarhini",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dc730b8b-30f4-4d2f-8fc6-fa85dc679feb",
        "address": "",
        "phone": "97143093222 / 971566651954",
        "email": "melissa.murray@twobirds.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3e1526e6-4c8d-4b6f-985f-ea05e9f99bcb",
    "firmName": "Bird & Bird (MEA) LLP",
    "registrationNumber": "L-05564",
    "licenseIssueDate": "10/12/2022 00:00:00",
    "licenseExpiryDate": "10/11/2026 00:00:00"
  },
  {
    "id": "178e79e4-8067-4b09-9154-9a2307496c2b",
    "slug": "said-alsharif",
    "name": "SAID ATALLA M S ALSHARIF",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Said Alsharif",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_178e79e4-8067-4b09-9154-9a2307496c2b",
        "address": "الخامس  ,مكاتب عود ميثاء ,فندق رافلز ,11268 ,Dubai",
        "phone": "97143243330",
        "email": "avocat@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "25d2c9bd-dbba-41ac-aff9-5ba0f37290d6",
    "firmName": "AL QARI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-01345",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "f30a09c7-95ab-4196-b5c8-a829d2c2b229",
    "slug": "said-fettoh-mostafa-abdelwahab-elnagar",
    "name": "SAID FETTOH MOSTAFA ABDELWAHAB ELNAGAR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Commercial Agency",
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Commercial Transactions-Commercial Contracts",
      "Commercial Transactions-Bankruptcy",
      "Personal Status-Legacies and Inheritance",
      "Commercial Transactions-Commercial Companies",
      "Civil Transactions-Compensation",
      "Criminal Law-Crimes against properties"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/07/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Said Fettoh Mostafa Abdelwahab Elnagar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f30a09c7-95ab-4196-b5c8-a829d2c2b229",
        "address": "الطابق 11 - مكتب رقم (1105 ، 1106)  ,برج السلام  ,منطقة المركز التجاري العالمي 1 ,211911 ,Dubai",
        "phone": "97143366769 / 971503636617",
        "email": "info@erlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "fffe1b8f-e9ab-488f-82eb-6151b8f007df",
    "firmName": "EMAN ALRIFAI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04994",
    "licenseIssueDate": "07/05/2021 00:00:00",
    "licenseExpiryDate": "07/04/2026 00:00:00"
  },
  {
    "id": "515c2fd5-8bb3-4cfe-9866-f7c7b0530481",
    "slug": "said-mahmoud-refaei",
    "name": "SAID MAHMOUD HASSANEIN MOHAMED REFAEI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Said Mahmoud Refaei",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_515c2fd5-8bb3-4cfe-9866-f7c7b0530481",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01746",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "c878c0d3-d6ff-4e3f-ae1f-348992cfa1cc",
    "slug": "said-nasser-said-al-sadi",
    "name": "Said Nasser Said AL Sadi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/06/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Said Nasser Said AL Sadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c878c0d3-d6ff-4e3f-ae1f-348992cfa1cc",
        "address": "SAUD SULTAN HAMAD ,1st Floor ,AL GARHOOD BUSINESS CENTER ,Al Garhoud Medical Fitness Center ,21785 ,Dubai",
        "phone": "97143331110 / 971551127667",
        "email": "info@alshebliadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b3f35be9-7673-4d3f-954b-6f64de96bc2b",
    "firmName": "SAUD ALSHEBLI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06233",
    "licenseIssueDate": "03/06/2024 00:00:00",
    "licenseExpiryDate": "03/05/2026 00:00:00"
  },
  {
    "id": "d9266ee0-93fc-4915-b2f7-05386bd2cec7",
    "slug": "saif-bajes-awwad-elfawaer",
    "name": "SAIF BAJES AWWAD ELFAWAER",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/02/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Saif Bajes Awwad Elfawaer",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d9266ee0-93fc-4915-b2f7-05386bd2cec7",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04006",
    "licenseIssueDate": "02/20/2018 00:00:00",
    "licenseExpiryDate": "02/17/2026 00:00:00"
  },
  {
    "id": "82bbd4d3-3510-4e21-8da9-32a14b146150",
    "slug": "saif-bashar-abdulelah",
    "name": "SAIF BASHAR ABDULELAH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/05/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Saif Bashar Abdulelah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_82bbd4d3-3510-4e21-8da9-32a14b146150",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-06789",
    "licenseIssueDate": "05/14/2025 00:00:00",
    "licenseExpiryDate": "05/13/2026 00:00:00"
  },
  {
    "id": "5c786e1a-5d6c-4645-97a1-e977696e3af7",
    "slug": "saim-ali-khan-arif-ali-khan",
    "name": "SAIM ALI KHAN ARIF ALI KHAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/07/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Saim Ali Khan Arif Ali Khan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5c786e1a-5d6c-4645-97a1-e977696e3af7",
        "address": "",
        "phone": "97143685555",
        "email": "maisa.maarouf@bsabh.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8afa232f-52ff-4dad-82c3-9a04d66eb853",
    "firmName": "B S A AHMED BIN HAZEEM & ASSOCIATES LLP - DIFC",
    "registrationNumber": "L-05929",
    "licenseIssueDate": "07/26/2023 00:00:00",
    "licenseExpiryDate": "07/25/2026 00:00:00"
  },
  {
    "id": "bc7fedd5-20da-4ed6-9a3d-d73d78992af9",
    "slug": "sajeda-attalah-khamis-abu-zeit",
    "name": "Sajeda Attalah Khamis Abu Zeit",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/10/2020",
    "licenseStatus": "active",
    "licenseExpiry": "2021-10-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sajeda Attalah Khamis Abu Zeit",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bc7fedd5-20da-4ed6-9a3d-d73d78992af9",
        "address": "1 ,Emaar Square 5 ,sheikh mohammed bin rashid BVD ,11987 ,Dubai",
        "phone": "97143043100 / 971507325154",
        "email": "amir.kordvani@pwc.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ea026b18-c93c-4f67-a1f2-4546320f8f3e",
    "firmName": "PWC Legal Middle East LLP",
    "registrationNumber": "L-04766",
    "licenseIssueDate": "10/28/2020 00:00:00",
    "licenseExpiryDate": "10/27/2025 00:00:00"
  },
  {
    "id": "73fa8044-bc5d-42be-af3d-4fd3a4e0d13c",
    "slug": "sajid-poolimakkool",
    "name": "SAJID POOLIMAKKOOL ABOOBACKER POOLIMAKKOOL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/09/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sajid Poolimakkool",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_73fa8044-bc5d-42be-af3d-4fd3a4e0d13c",
        "address": "HANI RAJAB MOOSA ABDULLA ALJASMI ,M ,LIBERTY ,SHARJAH BANK ,123887 ,Dubai",
        "phone": "97142957744",
        "email": "info@aljasmilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "04b37ea9-3ebd-45ff-9b0f-56fa9ee7e6fd",
    "firmName": "HANI AL JASMI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-01377",
    "licenseIssueDate": "09/05/2024 00:00:00",
    "licenseExpiryDate": "09/04/2026 00:00:00"
  },
  {
    "id": "6880e966-8c54-4831-8014-ba56a258b71a",
    "slug": "sajjad-hussein-juma",
    "name": "SAJJAD HUSSEIN JUMA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/02/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-02-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sajjad Hussein Juma",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6880e966-8c54-4831-8014-ba56a258b71a",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-04647",
    "licenseIssueDate": "02/20/2020 00:00:00",
    "licenseExpiryDate": "02/19/2026 00:00:00"
  },
  {
    "id": "0eea7e96-8414-45f1-90db-0997b705237a",
    "slug": "sakher-ahmad-alaqaileh",
    "name": "SAKHER AHMAD MOHAMMAD ALAQAILEH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/10/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sakher Ahmad Alaqaileh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0eea7e96-8414-45f1-90db-0997b705237a",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01331",
    "licenseIssueDate": "10/18/2012 00:00:00",
    "licenseExpiryDate": "10/10/2026 00:00:00"
  },
  {
    "id": "c0be181a-0b94-4efc-8afd-67af99ce1275",
    "slug": "sakshi-sethi",
    "name": "SAKSHI SETHI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sakshi Sethi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c0be181a-0b94-4efc-8afd-67af99ce1275",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01312",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "1fad54a7-2d02-4bdf-81ba-881b88d9b16b",
    "slug": "saladin-al-jurf",
    "name": "SALADIN ADEL ALJURF",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/11/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Saladin Al-Jurf",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1fad54a7-2d02-4bdf-81ba-881b88d9b16b",
        "address": "",
        "phone": "97145953601 / 971508728645",
        "email": "Steven.Bainbridge@gtlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b4146aa6-efd1-41d7-819d-49da46353b0b",
    "firmName": "Greenberg Traurig Limited",
    "registrationNumber": "L-03417",
    "licenseIssueDate": "11/29/2024 00:00:00",
    "licenseExpiryDate": "11/28/2025 00:00:00"
  },
  {
    "id": "a045393b-60d1-4f86-8540-9d75592a237e",
    "slug": "salah-abdelmonem-aly-gaballa",
    "name": "SALAH ABDELMONEM ALY GABALLA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/09/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Salah Abdelmonem Aly Gaballa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a045393b-60d1-4f86-8540-9d75592a237e",
        "address": "HAMAD ABDULLA ABDULRAHMAN ALRAHMA ALHAMMADI ,14TH FLOOR - 1403 ,PARK PLACE TOWER ,WORLD TRADE CENTER ,114295 ,Dubai",
        "phone": "97144227465 / 971555507070",
        "email": "hessa.alshehhi@primecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d6da9923-01fb-4fd8-a9da-a02d2122dbde",
    "firmName": "Hessa Al Shehhi ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01783",
    "licenseIssueDate": "09/26/2011 00:00:00",
    "licenseExpiryDate": "09/17/2026 00:00:00"
  },
  {
    "id": "74d8d4c5-326f-4400-9b27-7a1578642776",
    "slug": "salah-farahat-abdelwahab-aafia",
    "name": "SALAH FARAHAT ABDELWAHAB AAFIA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/12/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-11-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Salah Farahat Abdelwahab Aafia",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_74d8d4c5-326f-4400-9b27-7a1578642776",
        "address": "",
        "phone": "97143355577",
        "email": "daraladalah1991@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "61efd89c-1d0d-4136-8397-2814c745f0da",
    "firmName": "DAR AL ADALAH ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02043",
    "licenseIssueDate": "12/05/2011 00:00:00",
    "licenseExpiryDate": "11/26/2025 00:00:00"
  },
  {
    "id": "37c3a8e9-531c-4ba9-880a-abddeb55fa37",
    "slug": "salah-mohamed-abdelsalam-mohamed",
    "name": "SALAH MOHAMED ABDELSALAM MOHAMED SAAD",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/04/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Salah Mohamed Abdelsalam Mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_37c3a8e9-531c-4ba9-880a-abddeb55fa37",
        "address": "4 ,ALHUDIBA AWARD COMPLEX BLOCK B ,UNION FLAG HOUSE ,50229 ,Dubai",
        "phone": "97143258888 / 971501009595",
        "email": "hr@binsowaidan.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "36d64a1b-4461-4159-9965-ed44c59d3e88",
    "firmName": "BIN SOWAIDAN ADVOCATES & LEGAL CONSULTANTCY",
    "registrationNumber": "L-04071",
    "licenseIssueDate": "04/18/2018 00:00:00",
    "licenseExpiryDate": "04/16/2026 00:00:00"
  },
  {
    "id": "fa0cc61a-9784-4d66-80cb-d65d0c37d364",
    "slug": "salaheldin-elsayed-moustafa",
    "name": "SALAHELDIN ELSAYED MOHAMED MOUSTAFA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/12/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Salaheldin Elsayed Moustafa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fa0cc61a-9784-4d66-80cb-d65d0c37d364",
        "address": "1404 ,توين  تاورز  ,بجانب فندق ريدسون بلو  ,40227 ,Dubai",
        "phone": "97142222407",
        "email": "info@daralbalaghadvocate.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "183a898c-3779-4747-92dd-33a8feb6a42c",
    "firmName": "AL SHAMSI & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01808",
    "licenseIssueDate": "12/11/2011 00:00:00",
    "licenseExpiryDate": "12/02/2025 00:00:00"
  },
  {
    "id": "aadfe44b-1a70-454c-bea1-1bbaf39e2c92",
    "slug": "salam-m-s-alsmadi",
    "name": "SALAM M S ALSMADI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/12/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Salam M S Alsmadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_aadfe44b-1a70-454c-bea1-1bbaf39e2c92",
        "address": "Mohamed Thamer Yaqub Yousef Alserkal ,الطابق الثاني ,اعمار سكوير - بناء رقم 4 ,برج خليفة ,57409 ,Dubai",
        "phone": "97142622217 / 97142622217",
        "email": "mohamed@alserkallawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2a224392-a975-448f-aec5-0460984b1124",
    "firmName": "MOHAMED ALSERKAL ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-00890",
    "licenseIssueDate": "12/12/2018 00:00:00",
    "licenseExpiryDate": "12/10/2025 00:00:00"
  },
  {
    "id": "df0e25b3-d2a9-45bc-9f2f-3e89f0ce0a7f",
    "slug": "salim-shukri-sader",
    "name": "SALIM CHOUCRI SADER",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/10/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Salim Shukri Sader",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_df0e25b3-d2a9-45bc-9f2f-3e89f0ce0a7f",
        "address": "Fadi H. Hourani ,3 ,The Offices 5, One Central ,The Museum of the Future ,10152 ,Dubai",
        "phone": "97142052000",
        "email": "info@houranipartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c7a17e12-3d49-4166-82c8-271a6d223675",
    "firmName": "HOURANI & PATNERS",
    "registrationNumber": "L-01209",
    "licenseIssueDate": "10/04/2012 00:00:00",
    "licenseExpiryDate": "09/26/2026 00:00:00"
  },
  {
    "id": "418f9e98-c092-4591-b9a2-26c72462abd1",
    "slug": "sally-said-kotb",
    "name": "SALLY SAID MAHMOUD KOTB",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/09/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sally Said Kotb",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_418f9e98-c092-4591-b9a2-26c72462abd1",
        "address": "Al Fattan Currency House Tower 2 ,DIFC ,507176 ,",
        "phone": "/ 971552009003",
        "email": "Mohammad.AlRasheed@bakermckenzie.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "acd81e81-dead-4f7c-839e-0f2a57897265",
    "firmName": "Baker & Mckenzie LLP",
    "registrationNumber": "L-01784",
    "licenseIssueDate": "09/30/2025 00:00:00",
    "licenseExpiryDate": "09/29/2026 00:00:00"
  },
  {
    "id": "6b72da9d-3e80-45b0-830c-e0d31cca4a4f",
    "slug": "sally-yamak",
    "name": "SALLY TALAL YAMAK",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/05/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sally Yamak",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6b72da9d-3e80-45b0-830c-e0d31cca4a4f",
        "address": "1 ,ICD Brookfield Place ,Dubai International Financial Centre ,9267 ,Dubai",
        "phone": "97147010975 / 971502977062",
        "email": "chris.sioufi@ae.ey.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "42e536ef-e3d8-4339-8572-657a7f7a0331",
    "firmName": "EY Law LLP",
    "registrationNumber": "L-05853",
    "licenseIssueDate": "05/17/2023 00:00:00",
    "licenseExpiryDate": "05/16/2026 00:00:00"
  },
  {
    "id": "f1007343-8160-483c-865e-3d8a32e3c473",
    "slug": "salma-ali-mohamed-shamseldin",
    "name": "SALMA ALI MOHAMED SHAMSELDIN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/08/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Salma Ali Mohamed Shamseldin",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f1007343-8160-483c-865e-3d8a32e3c473",
        "address": "Al Fattan Currency House Tower 2 ,DIFC ,507176 ,",
        "phone": "/ 971552009003",
        "email": "Mohammad.AlRasheed@bakermckenzie.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "acd81e81-dead-4f7c-839e-0f2a57897265",
    "firmName": "Baker & Mckenzie LLP",
    "registrationNumber": "L-04179",
    "licenseIssueDate": "08/02/2018 00:00:00",
    "licenseExpiryDate": "07/31/2026 00:00:00"
  },
  {
    "id": "6d224cb0-7537-4e3e-a2b1-959089a217ef",
    "slug": "salma-mowlid",
    "name": "SALMA MOWLID ALI SALAD",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/08/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Salma Mowlid",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6d224cb0-7537-4e3e-a2b1-959089a217ef",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-04986",
    "licenseIssueDate": "08/09/2021 00:00:00",
    "licenseExpiryDate": "08/08/2026 00:00:00"
  },
  {
    "id": "f928c918-f035-4658-933a-07032c69df80",
    "slug": "salmaan-kotwal",
    "name": "SALMAAN KOTWAL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/30/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: SALMAAN KOTWAL",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f928c918-f035-4658-933a-07032c69df80",
        "address": "",
        "phone": "97144478700 / 971528553200",
        "email": "Thomas.Wilson@squirepb.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "85be541a-c87f-45a9-a321-d90abd6b7298",
    "firmName": "Squire Patton Boggs (MEA) LLP",
    "registrationNumber": "L-05601",
    "licenseIssueDate": "11/30/2022 00:00:00",
    "licenseExpiryDate": "11/29/2025 00:00:00"
  },
  {
    "id": "23a468af-6a95-47a5-8d0a-058af217bfef",
    "slug": "salman-khaled-abdulla-abdulaziz-hamza",
    "name": "Salman Khaled Abdulla Abdulaziz Hamza",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/01/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Salman Khaled Abdulla Abdulaziz Hamza",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_23a468af-6a95-47a5-8d0a-058af217bfef",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06682",
    "licenseIssueDate": "01/30/2025 00:00:00",
    "licenseExpiryDate": "01/29/2026 00:00:00"
  },
  {
    "id": "43aaae7b-3e35-4b5e-b8f4-f0fa935a485f",
    "slug": "salman-mohamed-esaameldin-abdelsalam-madkour",
    "name": "SALMAN MOHAMED ESSAMELDIN ABDELSALAM MADKOUR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/08/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Salman Mohamed Esaameldin Abdelsalam Madkour",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_43aaae7b-3e35-4b5e-b8f4-f0fa935a485f",
        "address": "",
        "phone": "97143685555",
        "email": "maisa.maarouf@bsabh.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8afa232f-52ff-4dad-82c3-9a04d66eb853",
    "firmName": "B S A AHMED BIN HAZEEM & ASSOCIATES LLP - DIFC",
    "registrationNumber": "L-04725",
    "licenseIssueDate": "08/13/2020 00:00:00",
    "licenseExpiryDate": "08/12/2026 00:00:00"
  },
  {
    "id": "90faf6d8-3c48-4962-be08-9e65ce1224d4",
    "slug": "salman-mohammed-a-alhamrani",
    "name": "Salman Mohammed A Alhamrani",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/12/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Salman Mohammed A Alhamrani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_90faf6d8-3c48-4962-be08-9e65ce1224d4",
        "address": "",
        "phone": "97144230555 / 971504788443",
        "email": "yah@hfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c462c65e-185a-4e81-8425-a87e3a2b6842",
    "firmName": "Holman Fenwick Willan Middle East LLP",
    "registrationNumber": "L-06342",
    "licenseIssueDate": "06/12/2024 00:00:00",
    "licenseExpiryDate": "06/11/2026 00:00:00"
  },
  {
    "id": "9441e63f-14ad-462b-9f6a-a67854984d35",
    "slug": "salvija-matonyte",
    "name": "SALVIJA LLOYD",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/02/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Salvija Matonyte",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9441e63f-14ad-462b-9f6a-a67854984d35",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-05171",
    "licenseIssueDate": "02/21/2025 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "00a042b3-2617-4038-a84a-fbaeb3af15d2",
    "slug": "salwan-saher-abed-abed",
    "name": "SALWAN SAHER ABED ALSAMAWI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/11/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Salwan Saher Abed Abed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_00a042b3-2617-4038-a84a-fbaeb3af15d2",
        "address": "",
        "phone": "97145132619 / 971543630593",
        "email": "info@alfaisal.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "fd647c60-3bff-4297-87f1-6437acf45575",
    "firmName": "FAISAL SALEM ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-06096",
    "licenseIssueDate": "11/15/2023 00:00:00",
    "licenseExpiryDate": "11/14/2025 00:00:00"
  },
  {
    "id": "505a3321-31e5-430b-a530-e7d2c659cb10",
    "slug": "sam-bayat-makou",
    "name": "SAM BAYAT MAKOU",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/01/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sam Bayat Makou",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_505a3321-31e5-430b-a530-e7d2c659cb10",
        "address": "Al Moosa tower 2 ,Trade Center  ,32422 ,",
        "phone": "97143554646 / 971527547777",
        "email": "sam.bayat@bayatgroup.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "9c5f75c6-0137-45c8-87b2-e7f4a4884749",
    "firmName": "Bayat Legal Services",
    "registrationNumber": "L-00373",
    "licenseIssueDate": "01/06/2012 00:00:00",
    "licenseExpiryDate": "12/28/2025 00:00:00"
  },
  {
    "id": "d2dd7ffd-a49d-484d-baeb-1cd3e4fa4ca3",
    "slug": "samaa-abdalla",
    "name": "SAMAA ABDALLA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/06/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Samaa Abdalla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d2dd7ffd-a49d-484d-baeb-1cd3e4fa4ca3",
        "address": "Index Tower ,DIFC ,506896 ,",
        "phone": "97142782300 / 971551154791",
        "email": "GLeggate@wfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e2b82cfc-80a5-4957-ae41-b1a7beb693c1",
    "firmName": "Watson, Farley & Williams (Middle East) LLP",
    "registrationNumber": "L-05866",
    "licenseIssueDate": "06/21/2023 00:00:00",
    "licenseExpiryDate": "06/20/2026 00:00:00"
  },
  {
    "id": "89a30ba0-c9b5-4dfe-af29-75f9443a3b28",
    "slug": "samad-ehab-fazal",
    "name": "SAMAD EHAB FAZAL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/10/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Samad Ehab Fazal",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_89a30ba0-c9b5-4dfe-af29-75f9443a3b28",
        "address": "ICD Brookfield Place ,DIFC ,506516 ,",
        "phone": "97143695800 / 971505526206",
        "email": "scott.campbell@linklaters.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5cec94c0-0649-43b6-a2be-ab17ff422bce",
    "firmName": "LinkLaters LLP",
    "registrationNumber": "L-06432",
    "licenseIssueDate": "10/09/2024 00:00:00",
    "licenseExpiryDate": "10/08/2026 00:00:00"
  },
  {
    "id": "09e3fd17-f2f0-4da2-bef4-c554d765633e",
    "slug": "samah-adnan-zeid",
    "name": "SAMAH ADNAN ZEID",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/07/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: SAMAH ADNAN ZEID",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_09e3fd17-f2f0-4da2-bef4-c554d765633e",
        "address": "MOHAMED IBRAHIM HASSAN ALSHAIBA ,KANA CAF ,51TOWER ,KANA CAFE ,35351 ,Dubai",
        "phone": "97142384444",
        "email": "Alshaiba@alshaibaadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3de1a3a0-760f-4d53-95b1-cecbac061394",
    "firmName": "ALSHAIBA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05944",
    "licenseIssueDate": "07/18/2023 00:00:00",
    "licenseExpiryDate": "07/17/2026 00:00:00"
  },
  {
    "id": "b221b394-d67b-4bf9-94f4-442207ef63e0",
    "slug": "samantha-hally-yung",
    "name": "SAMANTHA HALLY YUNG",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/03/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Samantha Hally Yung",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b221b394-d67b-4bf9-94f4-442207ef63e0",
        "address": "Level 17, ICD Brookfield Place ,DIFC ,506503 ,",
        "phone": "97144375100 / 971588271196",
        "email": "libby.edwards-smith@gowlingwlg.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "436703ba-b9c0-4dcb-93b2-1299c7a051f4",
    "firmName": "Gowling WLG (UK) LLP (Dubai Branch)",
    "registrationNumber": "L-05722",
    "licenseIssueDate": "03/29/2023 00:00:00",
    "licenseExpiryDate": "03/28/2026 00:00:00"
  },
  {
    "id": "c812f538-a9d0-466f-8639-752261e90ba5",
    "slug": "samantha-shaw",
    "name": "SAMANTHA JANE SHAW",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/06/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Samantha Shaw",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c812f538-a9d0-466f-8639-752261e90ba5",
        "address": "",
        "phone": "97145953601 / 971508728645",
        "email": "Steven.Bainbridge@gtlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b4146aa6-efd1-41d7-819d-49da46353b0b",
    "firmName": "Greenberg Traurig Limited",
    "registrationNumber": "L-03793",
    "licenseIssueDate": "06/28/2022 00:00:00",
    "licenseExpiryDate": "06/27/2026 00:00:00"
  },
  {
    "id": "c948abf4-ec9b-4f58-a0b4-528b0c15637d",
    "slug": "samar-akhtar-alam",
    "name": "SAMAR AKHTAR ALAM",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/10/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Samar Akhtar Alam",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c948abf4-ec9b-4f58-a0b4-528b0c15637d",
        "address": "",
        "phone": "97104309100 / 971564013758",
        "email": "c.royle@taylorwessing.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d51b6f43-8c62-486f-a1ab-6ee3b87c8006",
    "firmName": "Taylor Wessing LLP (Dubai Branch)",
    "registrationNumber": "L-06588",
    "licenseIssueDate": "10/31/2024 00:00:00",
    "licenseExpiryDate": "10/30/2026 00:00:00"
  },
  {
    "id": "fe8a280b-c22b-4313-8045-1e1c8e2be40c",
    "slug": "sameera-kimatrai",
    "name": "SAMEERA KIMATRAI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/06/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sameera Kimatrai",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fe8a280b-c22b-4313-8045-1e1c8e2be40c",
        "address": "",
        "phone": "97143184600 / 971504468184",
        "email": "melaraby@gibsondunn.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c9d2c9d0-6e43-4253-a75d-cdeb400f8d8e",
    "firmName": "Gibson Dunn & Crutcher LLP",
    "registrationNumber": "L-03907",
    "licenseIssueDate": "06/06/2023 00:00:00",
    "licenseExpiryDate": "06/05/2026 00:00:00"
  },
  {
    "id": "76b6476d-054f-41c3-b007-54fd8a96255f",
    "slug": "sameh-ahmed-mohamed-elsalmy",
    "name": "SAMEH AHMED MOHAMED ELSALMY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/25/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: SAMEH AHMED MOHAMED ELSALMY",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_76b6476d-054f-41c3-b007-54fd8a96255f",
        "address": "South Tower, Emirates Financial Towers ,DIFC ,482025 ,",
        "phone": "97145875333 / 971503444388",
        "email": "c.dersahakian@cvml.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e2c6db70-04e7-4c7b-882a-6d2ffe4469ed",
    "firmName": "CVML Limited",
    "registrationNumber": "L-04591",
    "licenseIssueDate": "03/25/2025 00:00:00",
    "licenseExpiryDate": "03/24/2026 00:00:00"
  },
  {
    "id": "08e2976a-2f9f-49e6-8153-5489bbdfe644",
    "slug": "sameh-aly-mohamed-bassiouny",
    "name": "SAMEH ALY MOHAMED BASSIOUNY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/09/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sameh Aly Mohamed Bassiouny",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_08e2976a-2f9f-49e6-8153-5489bbdfe644",
        "address": "HAMAD ABDULLA ABDULRAHMAN ALRAHMA ALHAMMADI ,14TH FLOOR - 1403 ,PARK PLACE TOWER ,WORLD TRADE CENTER ,114295 ,Dubai",
        "phone": "97144227465 / 971555507070",
        "email": "hessa.alshehhi@primecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d6da9923-01fb-4fd8-a9da-a02d2122dbde",
    "firmName": "Hessa Al Shehhi ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06006",
    "licenseIssueDate": "09/27/2023 00:00:00",
    "licenseExpiryDate": "09/26/2026 00:00:00"
  },
  {
    "id": "5ed1ba99-1d0a-4611-b054-57691f784fdd",
    "slug": "sameh-fathy-marey",
    "name": "SAMEH FATHY KAMAL MOHAMED MAREY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/11/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sameh Fathy Marey",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5ed1ba99-1d0a-4611-b054-57691f784fdd",
        "address": "",
        "phone": "97144560410 / 971551096724",
        "email": "info1@a-lawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ebbfa096-ef29-4660-9201-8c03bd4be3fe",
    "firmName": "MUSALLAM ALMAHHRAMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02803",
    "licenseIssueDate": "11/16/2014 00:00:00",
    "licenseExpiryDate": "11/10/2025 00:00:00"
  },
  {
    "id": "b8a739f9-0ac1-4bd7-a26b-ae66109665e4",
    "slug": "sameh-ibrahim-elbarbari",
    "name": "SAMEH IBRAHIM ZIDAN ELBARBARI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sameh Ibrahim Elbarbari",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b8a739f9-0ac1-4bd7-a26b-ae66109665e4",
        "address": "",
        "phone": "97142229944",
        "email": "almaarif_law@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3aecd13e-7d3e-45ab-a8a3-b58a36ee77b3",
    "firmName": "AL MAARIF ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01424",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "a7a7e560-18ec-4a88-a835-f749baa0edd3",
    "slug": "sameh-nazih-reyad-nabwy",
    "name": "SAMEH NAZIH REYAD NABWY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/08/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sameh Nazih Reyad Nabwy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a7a7e560-18ec-4a88-a835-f749baa0edd3",
        "address": "Ali Saleh Atrooz  ,1103 ,EMPIRE HEIGHTS B ,دبي مول  ,18433 ,Dubai",
        "phone": "97142222511",
        "email": "info@araalaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "aab79fde-e700-45d7-904f-bde0a593a087",
    "firmName": "ARAA GROUP ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04737",
    "licenseIssueDate": "08/29/2025 00:00:00",
    "licenseExpiryDate": "08/28/2026 00:00:00"
  },
  {
    "id": "3156c020-02f4-44c7-84f3-e3869bc0648f",
    "slug": "samer-abou-said",
    "name": "SAMER NADIM ABOU SAID",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/12/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Samer Abou Said",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3156c020-02f4-44c7-84f3-e3869bc0648f",
        "address": "مطعم زعتر وزيت  ,اسبكت تاور  ,فندق تاج  ,118212 ,Dubai",
        "phone": "97144433013 / 97144433013",
        "email": "moaza.alkhadar.alc@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "1dc550f7-81c5-4a5a-9096-682d651b8688",
    "firmName": "MOAZA AL KHADAR ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03304",
    "licenseIssueDate": "12/21/2015 00:00:00",
    "licenseExpiryDate": "12/15/2025 00:00:00"
  },
  {
    "id": "c144e3a5-8794-4982-80c8-efd70289ef33",
    "slug": "samer-eido",
    "name": "SAMER EIDO",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/06/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Samer Eido",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c144e3a5-8794-4982-80c8-efd70289ef33",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-04426",
    "licenseIssueDate": "06/12/2019 00:00:00",
    "licenseExpiryDate": "06/11/2026 00:00:00"
  },
  {
    "id": "84553d2d-9167-47fe-90fa-5443c59eb018",
    "slug": "samer-jameel-mohammad-abdo",
    "name": "Samer Jameel Mohammad Abdo",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/29/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Samer Jameel Mohammad Abdo",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_84553d2d-9167-47fe-90fa-5443c59eb018",
        "address": "",
        "phone": "97143116556 / 971000000000",
        "email": "info@hazlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d34586c5-1e0a-4290-af29-23366d37b852",
    "firmName": "HOYAM ALZAROUNI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01441",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "8600fd35-7c27-4f2e-aef2-c3d9333343bf",
    "slug": "samer-mahmoud-zaghmout",
    "name": "SAMER MAHMOUD ZAGHMOUT",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/07/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Samer Mahmoud Zaghmout",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8600fd35-7c27-4f2e-aef2-c3d9333343bf",
        "address": "الخامس  ,مكاتب عود ميثاء ,فندق رافلز ,11268 ,Dubai",
        "phone": "97143243330",
        "email": "avocat@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "25d2c9bd-dbba-41ac-aff9-5ba0f37290d6",
    "firmName": "AL QARI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-05352",
    "licenseIssueDate": "07/06/2022 00:00:00",
    "licenseExpiryDate": "07/05/2026 00:00:00"
  },
  {
    "id": "753afd40-13c1-41fb-8b65-8de93f27d5d1",
    "slug": "samer-qudah",
    "name": "SAMER MUFLEH AWWAD QUDAH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Samer Qudah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_753afd40-13c1-41fb-8b65-8de93f27d5d1",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01313",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "9b775240-be63-4d34-a512-042734fd6894",
    "slug": "samer-tohme",
    "name": "SAMER HOUSSEIN TOHME",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Samer Tohme",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9b775240-be63-4d34-a512-042734fd6894",
        "address": "samer tohme ,4th- office 433 ,Emarat Atrium ,Dubai Canal ,79436 ,Dubai",
        "phone": "97126722500",
        "email": "info@dxblawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "00b6334f-44e7-458e-8ce5-7d4256840067",
    "firmName": "MOHAMED ABDULLA LAWYERS AND LEGAL CONSULTANTS",
    "registrationNumber": "L-01476",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "121d32e4-c46f-4f81-bed2-dbcf0514a764",
    "slug": "sami-al-louzi",
    "name": "SAMI EID RASHED AL LOUZI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/07/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sami Al Louzi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_121d32e4-c46f-4f81-bed2-dbcf0514a764",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-02802",
    "licenseIssueDate": "07/16/2014 00:00:00",
    "licenseExpiryDate": "07/10/2026 00:00:00"
  },
  {
    "id": "2ef4e253-cf6d-4864-8121-15787f491384",
    "slug": "sami-ben-dechiche",
    "name": "SAMI BEN DECHICHE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/10/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sami Ben Dechiche",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2ef4e253-cf6d-4864-8121-15787f491384",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506688 ,Dubai",
        "phone": "97147096600 / 971503556811",
        "email": "muneer.khan@simmons-simmons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d1725ca7-06ac-41b2-8d7b-a6e60665b73d",
    "firmName": "Simmons & Simmons (Middle East) LLP-DIFC",
    "registrationNumber": "L-05571",
    "licenseIssueDate": "10/10/2022 00:00:00",
    "licenseExpiryDate": "10/09/2025 00:00:00"
  },
  {
    "id": "ae038ac7-2a26-4186-9f44-e5d2f39ee132",
    "slug": "sami-rahim",
    "name": "SAMI RAHIM",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/02/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sami Rahim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ae038ac7-2a26-4186-9f44-e5d2f39ee132",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-06212",
    "licenseIssueDate": "02/21/2024 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "68dab50d-2507-429f-bf9f-44fef26ef761",
    "slug": "sami-saygh",
    "name": "SAMI SAYGH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/11/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sami Saygh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_68dab50d-2507-429f-bf9f-44fef26ef761",
        "address": "Al Fattan Currency House Tower 2 ,DIFC ,507176 ,",
        "phone": "/ 971552009003",
        "email": "Mohammad.AlRasheed@bakermckenzie.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "acd81e81-dead-4f7c-839e-0f2a57897265",
    "firmName": "Baker & Mckenzie LLP",
    "registrationNumber": "L-05116",
    "licenseIssueDate": "11/07/2021 00:00:00",
    "licenseExpiryDate": "11/06/2025 00:00:00"
  },
  {
    "id": "0b3687ae-705a-47e5-aadd-bcb5512c98bc",
    "slug": "sami-tannous",
    "name": "SAMI NAIM TANNOUS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/05/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sami Tannous",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0b3687ae-705a-47e5-aadd-bcb5512c98bc",
        "address": "0 ,ICD Brookfield Place Level 13 ,Trade Centre ,506569 ,Dubai",
        "phone": "97145099100 / 971501006965",
        "email": "menahr@freshfields.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "970f6246-e737-41a7-9c6c-5aa5b8335d45",
    "firmName": "Freshfields LLP DIFC",
    "registrationNumber": "L-00588",
    "licenseIssueDate": "05/06/2012 00:00:00",
    "licenseExpiryDate": "04/27/2026 00:00:00"
  },
  {
    "id": "a84188fa-4ce1-4387-bf9f-5ac16604f182",
    "slug": "samir-abdelaziz-zeidan-hussein-dorgham",
    "name": "SAMIR ABDELAZIZ ZEIDAN HUSSEIN DORGHAM",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/03/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Samir Abdelaziz Zeidan Hussein Dorgham",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a84188fa-4ce1-4387-bf9f-5ac16604f182",
        "address": "",
        "phone": "97142251011",
        "email": "info@ajlc.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "aa38fc5e-9318-46e5-aaeb-e64f98419097",
    "firmName": "ABDULHAMEED ALJASMI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-04364",
    "licenseIssueDate": "03/31/2019 00:00:00",
    "licenseExpiryDate": "03/29/2026 00:00:00"
  },
  {
    "id": "6b8c9649-dcb6-41cb-9dbd-ac53858f1394",
    "slug": "samir-ahmed-tamam-elsayed",
    "name": "SAMIR AHMED TAMAM ELSAYED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/02/2023",
    "licenseStatus": "active",
    "licenseExpiry": "2024-02-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: SAMIR AHMED TAMAM ELSAYED",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6b8c9649-dcb6-41cb-9dbd-ac53858f1394",
        "address": "",
        "phone": "97142515101",
        "email": "legal@alinsaf.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2176cd73-0d8d-41e1-9db6-ab2d6fa210b5",
    "firmName": "AL INSAF ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-05720",
    "licenseIssueDate": "02/22/2023 00:00:00",
    "licenseExpiryDate": "02/21/2026 00:00:00"
  },
  {
    "id": "495149c6-159d-4a6e-afad-e901ff092621",
    "slug": "samir-bou-maroun",
    "name": "SAMIR BOU MAROUN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/06/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Samir Bou Maroun",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_495149c6-159d-4a6e-afad-e901ff092621",
        "address": "samer tohme ,4th- office 433 ,Emarat Atrium ,Dubai Canal ,79436 ,Dubai",
        "phone": "97126722500",
        "email": "info@dxblawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "00b6334f-44e7-458e-8ce5-7d4256840067",
    "firmName": "MOHAMED ABDULLA LAWYERS AND LEGAL CONSULTANTS",
    "registrationNumber": "L-01477",
    "licenseIssueDate": "07/01/2019 00:00:00",
    "licenseExpiryDate": "06/30/2026 00:00:00"
  },
  {
    "id": "2687eb38-1838-4cf9-bd69-546cde5da90c",
    "slug": "samir-kantaria",
    "name": "SAMIR NATVARLAL KANTARIA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Samir Kantaria",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2687eb38-1838-4cf9-bd69-546cde5da90c",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01314",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "98c0e796-3ae6-408c-b212-9cc1942153d4",
    "slug": "samir-mohamed",
    "name": "SAMIR ANWAR IBRAHIM MOHAMED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Commercial Agency",
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Civil Transactions-Insurance",
      "Civil Transactions-Construction and Contracts for Services",
      "Personal Status-Custody & Alimony",
      "Commercial Transactions-Bankruptcy",
      "Commercial Transactions-Commercial Real Estate",
      "Civil Transactions-Tenancy",
      "Commercial Transactions-Commercial Companies",
      "Commercial Transactions-Banking Operations",
      "Civil Transactions-Labor & Workers",
      "Civil Transactions-Sale",
      "Proceedings-Cases and Proceedings before arbitral tribunals and other alternative dispute resolution bodies",
      "Personal Status-Marriage & Divorce",
      "Civil Transactions-Compensation",
      "Criminal Law-Crimes against properties",
      "Criminal Law-Cybercrimes",
      "Commercial Transactions-Intellectual Property (includes trademarks",
      "copy rights",
      "patents)",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/02/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-02-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Samir Mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_98c0e796-3ae6-408c-b212-9cc1942153d4",
        "address": "ADNAN OBAID ALSHAALI , Second floor - FLAT 201A ,Al Khaimah Building ,Al Ittihad Road, Deira ,238837 ,Dubai",
        "phone": "97142392332 / 971505544558",
        "email": "adnan@alshaali-advocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b49edb5e-abf1-49fe-8f56-ded39a7348cc",
    "firmName": "ADNAN OBAID ALSHAALI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03333",
    "licenseIssueDate": "02/08/2016 00:00:00",
    "licenseExpiryDate": "02/03/2026 00:00:00"
  },
  {
    "id": "eea5749d-64e9-4991-a502-f05796286488",
    "slug": "samir-mohamed-mashali",
    "name": "SAMIR MOHAMED IBRAHIM MASHALI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/09/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Samir Mohamed Mashali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_eea5749d-64e9-4991-a502-f05796286488",
        "address": "",
        "phone": "97144230000 / 971552009022",
        "email": "UAE-CourtClerks@habibalmulla.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3eba82bb-8ec4-4cbd-80d0-a793cb993fde",
    "firmName": "Habib Al Mulla & Partners ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01785",
    "licenseIssueDate": "09/26/2011 00:00:00",
    "licenseExpiryDate": "09/17/2026 00:00:00"
  },
  {
    "id": "e48a61a6-007b-4dff-b78b-5025ffa354a0",
    "slug": "samir-safar-aly",
    "name": "SAMIR HESHAM KAMAL SAFAR ALY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/10/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Samir Safar-Aly",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e48a61a6-007b-4dff-b78b-5025ffa354a0",
        "address": "1 ,Emaar Square 5 ,sheikh mohammed bin rashid BVD ,11987 ,Dubai",
        "phone": "97143043100 / 971507325154",
        "email": "amir.kordvani@pwc.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ea026b18-c93c-4f67-a1f2-4546320f8f3e",
    "firmName": "PWC Legal Middle East LLP",
    "registrationNumber": "L-03061",
    "licenseIssueDate": "10/09/2014 00:00:00",
    "licenseExpiryDate": "10/03/2026 00:00:00"
  },
  {
    "id": "fa716fdc-7a58-420e-ab5c-aeb4b04e3726",
    "slug": "samiya-idi",
    "name": "SAMYA IDI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/11/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Samiya Idi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fa716fdc-7a58-420e-ab5c-aeb4b04e3726",
        "address": "",
        "phone": "97142472100 / 971509224336",
        "email": "bhaley@cov.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "65a2e90a-6978-4292-b3f1-ecbebedd7b9a",
    "firmName": "Covington & Burling LLP (Middle East)",
    "registrationNumber": "L-06605",
    "licenseIssueDate": "11/21/2024 00:00:00",
    "licenseExpiryDate": "11/20/2025 00:00:00"
  },
  {
    "id": "6e1afdcc-b159-4261-bc74-3f8ca6848155",
    "slug": "sammy-louise-lockhart",
    "name": "SAMMY LOUISE LOCKHART",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/05/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sammy Louise Lockhart",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6e1afdcc-b159-4261-bc74-3f8ca6848155",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506698 ,Dubai",
        "phone": "97147046300 / 971507900661",
        "email": "nada.mourad@lw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b2b92ce9-90a4-4e34-ae2f-ae0dc7ca9060",
    "firmName": "Latham & Watkins LLP",
    "registrationNumber": "L-06799",
    "licenseIssueDate": "05/28/2025 00:00:00",
    "licenseExpiryDate": "05/27/2026 00:00:00"
  },
  {
    "id": "849200a7-ec7e-4f23-81c7-24b5ac96328f",
    "slug": "sammy-nanneh",
    "name": "SAMMY NANNEH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/06/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: SAMMY NANNEH",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_849200a7-ec7e-4f23-81c7-24b5ac96328f",
        "address": "- ,THE OFFICES 1 ,DWTC ,115580 ,Dubai",
        "phone": "97143739700 / 971562196031",
        "email": "catherine.workman@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6b4ebb23-ef2e-4305-a1ee-43a11e4b1cae",
    "firmName": "Pinsent Masons LLP - Dubai Branch",
    "registrationNumber": "L-04433",
    "licenseIssueDate": "06/18/2019 00:00:00",
    "licenseExpiryDate": "06/17/2026 00:00:00"
  },
  {
    "id": "ff24cf1f-e9b2-49fb-a2c7-46df9e74d4d4",
    "slug": "samuel-edward-ridge",
    "name": "SAMUEL EDWARD RIDGE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/05/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Samuel Edward Ridge",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ff24cf1f-e9b2-49fb-a2c7-46df9e74d4d4",
        "address": "",
        "phone": "97143742800 / 971506450677",
        "email": "jabbott21@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7a59d310-ff72-4318-b41c-27095c163d0f",
    "firmName": "CMS (UAE) LLP",
    "registrationNumber": "L-05787",
    "licenseIssueDate": "05/11/2023 00:00:00",
    "licenseExpiryDate": "05/10/2026 00:00:00"
  },
  {
    "id": "cf4541a2-e666-4391-88fc-efc1460748b8",
    "slug": "samuel-henry-george-adrian-white",
    "name": "SAMUEL HENRY GEORGE ADRIAN WHITE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/02/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Samuel Henry George Adrian White",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cf4541a2-e666-4391-88fc-efc1460748b8",
        "address": "",
        "phone": "97143742800 / 971506450677",
        "email": "jabbott21@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7a59d310-ff72-4318-b41c-27095c163d0f",
    "firmName": "CMS (UAE) LLP",
    "registrationNumber": "L-06218",
    "licenseIssueDate": "02/21/2024 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "dbef80e4-629a-455f-8bca-db0c3b3851ac",
    "slug": "samuel-ryan-oneill",
    "name": "SAMUEL RYAN ONEILL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/10/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Samuel Ryan Oneill",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dbef80e4-629a-455f-8bca-db0c3b3851ac",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-05499",
    "licenseIssueDate": "10/05/2022 00:00:00",
    "licenseExpiryDate": "10/04/2026 00:00:00"
  },
  {
    "id": "a31b0df2-00bc-48ac-9a44-5b2558985a20",
    "slug": "samuel-song",
    "name": "Samuel Song",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/05/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Samuel Song",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a31b0df2-00bc-48ac-9a44-5b2558985a20",
        "address": "",
        "phone": "97144478700 / 971528553200",
        "email": "Thomas.Wilson@squirepb.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "85be541a-c87f-45a9-a321-d90abd6b7298",
    "firmName": "Squire Patton Boggs (MEA) LLP",
    "registrationNumber": "L-03691",
    "licenseIssueDate": "04/05/2017 00:00:00",
    "licenseExpiryDate": "05/03/2026 00:00:00"
  },
  {
    "id": "e9da73d6-931f-418f-a87d-85569b35cd65",
    "slug": "samuel-thomas-hunt",
    "name": "SAMUEL THOMAS HUNT",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/01/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Samuel Thomas Hunt",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e9da73d6-931f-418f-a87d-85569b35cd65",
        "address": "",
        "phone": "97144286300 / 971506256686",
        "email": "stuart.paterson@hsf.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2f0389b3-bfde-44f4-bdd6-6e1a22f9cab2",
    "firmName": "Herbert Smith Freehills Kramer LLP",
    "registrationNumber": "L-06176",
    "licenseIssueDate": "01/19/2024 00:00:00",
    "licenseExpiryDate": "01/18/2026 00:00:00"
  },
  {
    "id": "962e7f75-5297-4a7b-ab66-a076da8ecea3",
    "slug": "samuel-wakerley",
    "name": "SAMUEL RICHARD WAKERLEY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/10/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Samuel Wakerley",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_962e7f75-5297-4a7b-ab66-a076da8ecea3",
        "address": "",
        "phone": "97144230555 / 971504788443",
        "email": "yah@hfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c462c65e-185a-4e81-8425-a87e3a2b6842",
    "firmName": "Holman Fenwick Willan Middle East LLP",
    "registrationNumber": "L-00627",
    "licenseIssueDate": "10/07/2011 00:00:00",
    "licenseExpiryDate": "09/28/2026 00:00:00"
  },
  {
    "id": "a0179af7-f81c-4f5b-ba50-f8ab4b8c2b4c",
    "slug": "samuel-william-bold",
    "name": "SAMUEL WILLIAM BOLD",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/11/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Samuel William Bold",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a0179af7-f81c-4f5b-ba50-f8ab4b8c2b4c",
        "address": "NA ,Park Lane Tower ,NA ,119974 ,Dubai",
        "phone": "97143652000 / 971504515630",
        "email": "david.charlier@ashurst.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "af016ea4-05d8-4845-9d38-b95de499a172",
    "firmName": "Ashurst LLP Legal Consultants Dubai Branch-DED",
    "registrationNumber": "L-05613",
    "licenseIssueDate": "11/02/2022 00:00:00",
    "licenseExpiryDate": "11/01/2025 00:00:00"
  },
  {
    "id": "26fe782b-5703-42db-9670-4633a99813b3",
    "slug": "samy-fatthalla",
    "name": "SAMY FATTHALLA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/02/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Samy Fatthalla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_26fe782b-5703-42db-9670-4633a99813b3",
        "address": "",
        "phone": "97104309100 / 971564013758",
        "email": "c.royle@taylorwessing.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d51b6f43-8c62-486f-a1ab-6ee3b87c8006",
    "firmName": "Taylor Wessing LLP (Dubai Branch)",
    "registrationNumber": "L-06222",
    "licenseIssueDate": "02/16/2024 00:00:00",
    "licenseExpiryDate": "02/15/2026 00:00:00"
  },
  {
    "id": "dd7cafb3-afcd-4a95-8353-d4b7924c5910",
    "slug": "samy-ibrahim-mohamed-el-beksh",
    "name": "SAMY IBRAHIM MOHAMED EL BEKSH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/08/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: SAMY IBRAHIM MOHAMED EL BEKSH",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dd7cafb3-afcd-4a95-8353-d4b7924c5910",
        "address": "AL SHEHHI GROUP ADVOCATES & LEGAL CONSULTANT ,الأول ,بناية المسعود ,مقابل لفندي ماريوت ,172662 ,Dubai",
        "phone": "97142384222",
        "email": "dubai@alshehhilawyer.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "bcc63eb3-5fc8-42bd-beb1-b29798bdcee4",
    "firmName": "AL SHEHHI GROUP ADVOCATES & LEGAL CONSULTANT",
    "registrationNumber": "L-06924",
    "licenseIssueDate": "08/05/2025 00:00:00",
    "licenseExpiryDate": "08/04/2026 00:00:00"
  },
  {
    "id": "f6826a2e-3b43-41e7-bbf3-b85bbd43eece",
    "slug": "sana-ahmed-ameer-ahmed",
    "name": "SANA AHMED AMEER AHMED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/05/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sana Ahmed Ameer Ahmed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f6826a2e-3b43-41e7-bbf3-b85bbd43eece",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-06363",
    "licenseIssueDate": "05/31/2024 00:00:00",
    "licenseExpiryDate": "05/30/2026 00:00:00"
  },
  {
    "id": "cc6da129-7c10-451f-857a-a2a29417c090",
    "slug": "sana-fatima-siddik",
    "name": "SANA FATIMA SIDDIK",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/11/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sana Fatima Siddik",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cc6da129-7c10-451f-857a-a2a29417c090",
        "address": "",
        "phone": "97145953601 / 971508728645",
        "email": "Steven.Bainbridge@gtlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b4146aa6-efd1-41d7-819d-49da46353b0b",
    "firmName": "Greenberg Traurig Limited",
    "registrationNumber": "L-03231",
    "licenseIssueDate": "11/22/2015 00:00:00",
    "licenseExpiryDate": "11/17/2025 00:00:00"
  },
  {
    "id": "38c7b7ff-5995-4c19-a34a-9e8b5f2f1f7d",
    "slug": "sanam-majid",
    "name": "SANAM MAJID",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/09/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sanam Majid",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_38c7b7ff-5995-4c19-a34a-9e8b5f2f1f7d",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-06000",
    "licenseIssueDate": "09/06/2023 00:00:00",
    "licenseExpiryDate": "09/05/2026 00:00:00"
  },
  {
    "id": "bfc11933-8203-472b-b016-2b10a3af94c9",
    "slug": "sanchia-marissa-wheeler",
    "name": "SANCHIA MARISSA WHEELER",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/10/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sanchia Marissa Wheeler",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bfc11933-8203-472b-b016-2b10a3af94c9",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-06522",
    "licenseIssueDate": "10/09/2024 00:00:00",
    "licenseExpiryDate": "10/08/2026 00:00:00"
  },
  {
    "id": "71459dae-8fdd-408f-9e5f-18298af65206",
    "slug": "sandeep-athipatta-narayanan",
    "name": "Sandeep Athipatta Narayanan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2021-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sandeep Athipatta Narayanan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_71459dae-8fdd-408f-9e5f-18298af65206",
        "address": "",
        "phone": "97142828999",
        "email": "info@gmalc.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2f9514bf-2175-40fe-8539-d1b4b32074b7",
    "firmName": "ALGURG & ALMATROOSHI ADVOCATES & LIGAL CONSULTANTS",
    "registrationNumber": "L-02324",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2021 00:00:00"
  },
  {
    "id": "4735dff7-72da-4005-8f0b-887b715301d7",
    "slug": "sandeep-dhama",
    "name": "SANDEEP DHAMA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sandeep Dhama",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4735dff7-72da-4005-8f0b-887b715301d7",
        "address": "",
        "phone": "97144073901 / 971503479508",
        "email": "Rania.Tadros@stephensonharwood.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dd5042a2-bb41-4123-9544-79c3fa831332",
    "firmName": "Stephenson Harwood (Middle East) LLP",
    "registrationNumber": "L-00973",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "deee4b4a-e120-4f94-b80d-2f3262cb7e20",
    "slug": "sandrine-tanos-el-haber",
    "name": "SANDRINE TANOS EL HABER",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/10/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sandrine Tanos El Haber",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_deee4b4a-e120-4f94-b80d-2f3262cb7e20",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-06576",
    "licenseIssueDate": "10/30/2024 00:00:00",
    "licenseExpiryDate": "10/29/2026 00:00:00"
  },
  {
    "id": "afdb4120-1401-4bd8-a57a-6364d6801fda",
    "slug": "sang-yun-kim",
    "name": "SANG YUN KIM",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/03/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sang Yun Kim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_afdb4120-1401-4bd8-a57a-6364d6801fda",
        "address": "",
        "phone": "97144543900 / 971569199020",
        "email": "paul.hughes@kobrekim.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "259f7732-3596-4559-ae29-21cb6f4aa7d8",
    "firmName": "Kobre & Kim (GCC) LLP",
    "registrationNumber": "L-06244",
    "licenseIssueDate": "03/06/2024 00:00:00",
    "licenseExpiryDate": "03/05/2026 00:00:00"
  },
  {
    "id": "3e1d17c8-e3bd-4a79-81cb-9cdc6de98052",
    "slug": "sapna-desai",
    "name": "SAPNA DESAI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/10/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sapna Desai",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3e1d17c8-e3bd-4a79-81cb-9cdc6de98052",
        "address": "",
        "phone": "97143025100 / 971501501837",
        "email": "ccairns@trowers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "976857f5-9092-43cf-987d-bfa794a3fa51",
    "firmName": "Trowers & Hamlins LLP",
    "registrationNumber": "L-05406",
    "licenseIssueDate": "10/10/2024 00:00:00",
    "licenseExpiryDate": "10/09/2026 00:00:00"
  },
  {
    "id": "44c15c46-1d88-452b-b617-0eb7f1b5eb38",
    "slug": "sara-alawadhi",
    "name": "SARA FAISALRABEE MOHD SHARIF ALAWADHI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/10/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sara Alawadhi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_44c15c46-1d88-452b-b617-0eb7f1b5eb38",
        "address": "1 ,Emaar Square 5 ,sheikh mohammed bin rashid BVD ,11987 ,Dubai",
        "phone": "97143043100 / 971507325154",
        "email": "amir.kordvani@pwc.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ea026b18-c93c-4f67-a1f2-4546320f8f3e",
    "firmName": "PWC Legal Middle East LLP",
    "registrationNumber": "L-02746",
    "licenseIssueDate": "10/22/2024 00:00:00",
    "licenseExpiryDate": "10/21/2026 00:00:00"
  },
  {
    "id": "04c35aac-d641-47ef-9dd3-3b14147d49d4",
    "slug": "sara-aranjo",
    "name": "SARA KOLEILAT ARANJO",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/01/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sara Aranjo",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_04c35aac-d641-47ef-9dd3-3b14147d49d4",
        "address": "",
        "phone": "97143121800 / 971566017967",
        "email": "alishia.sullivan@morganlewis.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6eab20d7-8716-4b0a-8710-144d1d951c23",
    "firmName": "Morgan, Lewis & Bockius LLP (dubai Branch)",
    "registrationNumber": "L-03269",
    "licenseIssueDate": "01/27/2016 00:00:00",
    "licenseExpiryDate": "01/22/2026 00:00:00"
  },
  {
    "id": "931847e4-a592-4918-9763-770def5aa340",
    "slug": "sara-corradi",
    "name": "SARA CORRADI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Commercial Agency",
      "Civil Transactions-POA & Sponsorship",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Commercial Transactions-Commercial Contracts",
      "Commercial Transactions-Bankruptcy",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Civil Transactions-Arbitration",
      "Civil Transactions-Tenancy",
      "Commercial Transactions-Commercial Companies",
      "Civil Transactions-Sale",
      "Proceedings-Cases and Proceedings before arbitral tribunals and other alternative dispute resolution bodies",
      "Commercial Transactions-Consumer protection",
      "Commercial Transactions-Stock"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/07/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: sara corradi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_931847e4-a592-4918-9763-770def5aa340",
        "address": "1 ,Park Place Towe ,. ,9353 ,Dubai",
        "phone": "97143317110 / 971000000000",
        "email": "elena@meyer-reumann.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e294ccf7-baca-4016-876d-fcf8d296a3fc",
    "firmName": "Meyer Reumann & Partners",
    "registrationNumber": "L-04709",
    "licenseIssueDate": "07/23/2020 00:00:00",
    "licenseExpiryDate": "07/22/2026 00:00:00"
  },
  {
    "id": "1ccf80a7-422c-4470-a924-1533580f6164",
    "slug": "sara-holder",
    "name": "SARA ANNABEL HOLDER",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sara Holder",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1ccf80a7-422c-4470-a924-1533580f6164",
        "address": "",
        "phone": "97143098000 / 971552210883",
        "email": "belturk@rouse.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9df4d4e5-5243-4fae-8d95-463d110ce6a8",
    "firmName": "Rouse & Co International Limited (Dubai Branch)",
    "registrationNumber": "L-00448",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "0da62f5d-5c5e-4f6f-b713-6f0c977fdbc2",
    "slug": "sara-khoja",
    "name": "Sara Khoja",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/11/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sara Khoja",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0da62f5d-5c5e-4f6f-b713-6f0c977fdbc2",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-00324",
    "licenseIssueDate": "10/11/2011 00:00:00",
    "licenseExpiryDate": "10/02/2026 00:00:00"
  },
  {
    "id": "7a5ed6fc-80fa-4c00-a318-ba3d12254d0f",
    "slug": "sara-magdy-mohamed-elmenshawy",
    "name": "SARA MAGDY MOHAMED ELMENSHAWY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/06/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sara Magdy Mohamed Elmenshawy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7a5ed6fc-80fa-4c00-a318-ba3d12254d0f",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-04666",
    "licenseIssueDate": "06/07/2023 00:00:00",
    "licenseExpiryDate": "06/06/2026 00:00:00"
  },
  {
    "id": "fcdacd83-74e8-4158-a3f9-a2758ad97815",
    "slug": "sara-mohamadali-aghaei",
    "name": "SARA MOHAMMADALI AGHAEI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/09/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sara Mohamadali Aghaei",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fcdacd83-74e8-4158-a3f9-a2758ad97815",
        "address": "4th floor ,Al Saaha Offices Block D office 401A ,Burj Khalifa ,283773 ,Dubai",
        "phone": "97144221944",
        "email": "gov.depts@alsafarpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b7bbfaeb-1fdb-46d2-97cf-8e6432a9b8a7",
    "firmName": "AL SAFAR & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06500",
    "licenseIssueDate": "09/25/2024 00:00:00",
    "licenseExpiryDate": "09/24/2026 00:00:00"
  },
  {
    "id": "833fd87a-136f-4444-8045-c0525b093d42",
    "slug": "sara-r-abdul-maged-al-kabban",
    "name": "SARA R ABDUL MAGED AL KABBAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/07/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: SARA R ABDUL MAGED AL KABBAN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_833fd87a-136f-4444-8045-c0525b093d42",
        "address": "29TH  ,PRISM TOWER ,J W MARRIOTT MARQUIS HOTEL  ,4790 ,Dubai",
        "phone": "97144539090",
        "email": "info@alkabban.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a9193879-c34b-4dae-99aa-d8e5ac8517cc",
    "firmName": "AL-KABBAN & ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06892",
    "licenseIssueDate": "07/08/2025 00:00:00",
    "licenseExpiryDate": "07/07/2026 00:00:00"
  },
  {
    "id": "2165b464-3634-4bcb-81f0-ba3d2aa7e19c",
    "slug": "sara-sheffield",
    "name": "SARA JAYNE SHEFFIELD",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Cases and Proceedings before Dubai International Financial Centre"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/11/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sara Sheffield",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2165b464-3634-4bcb-81f0-ba3d2aa7e19c",
        "address": "20 ,Index Tower West Tower ,DIFC ,507226 ,Dubai",
        "phone": "97142461900 / 971523391604",
        "email": "patrick.gearon@crsblaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e2ac552e-b9a7-450b-a84d-15119e583220",
    "firmName": "Charles Russell Speechlys LLP",
    "registrationNumber": "L-01985",
    "licenseIssueDate": "11/11/2013 00:00:00",
    "licenseExpiryDate": "11/04/2025 00:00:00"
  },
  {
    "id": "c2baddb0-0908-4154-8af6-575d0084c3e4",
    "slug": "saraah-badr-gibson",
    "name": "SAARAH BADR GIBSON",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/09/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Saraah Badr Gibson",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c2baddb0-0908-4154-8af6-575d0084c3e4",
        "address": "",
        "phone": "97143093222 / 971566651954",
        "email": "melissa.murray@twobirds.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3e1526e6-4c8d-4b6f-985f-ea05e9f99bcb",
    "firmName": "Bird & Bird (MEA) LLP",
    "registrationNumber": "L-02694",
    "licenseIssueDate": "09/19/2024 00:00:00",
    "licenseExpiryDate": "09/18/2026 00:00:00"
  },
  {
    "id": "c20fa59d-05b8-4a84-933c-f1fad2171848",
    "slug": "sarah-abdulla-abdulhameed-alaiwat",
    "name": "Sarah Abdulla Abdulhameed Alaiwat",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/08/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sarah Abdulla Abdulhameed Alaiwat",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c20fa59d-05b8-4a84-933c-f1fad2171848",
        "address": "20 ,Index Tower West Tower ,DIFC ,507226 ,Dubai",
        "phone": "97142461900 / 971523391604",
        "email": "patrick.gearon@crsblaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e2ac552e-b9a7-450b-a84d-15119e583220",
    "firmName": "Charles Russell Speechlys LLP",
    "registrationNumber": "L-05940",
    "licenseIssueDate": "08/23/2023 00:00:00",
    "licenseExpiryDate": "08/22/2026 00:00:00"
  },
  {
    "id": "598821d6-c6d8-4617-a56a-70982b051a6b",
    "slug": "sarah-awula-ama-greenstreet",
    "name": "SARAH AWULA AMA GREENSTREET",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/03/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sarah Awula Ama Greenstreet",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_598821d6-c6d8-4617-a56a-70982b051a6b",
        "address": "6 ,Office Nos. 603, 604 & 605, Level 6, Burj Daman ,Dubai International Financial Centre ,506555 ,Dubai",
        "phone": "97143506400 / 971504654755",
        "email": "r.hickman@aglaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8690f7d5-6b96-4649-9589-71303f2c2707",
    "firmName": "Addleshaw Goddard (Middle East) LLP",
    "registrationNumber": "L-06717",
    "licenseIssueDate": "03/12/2025 00:00:00",
    "licenseExpiryDate": "03/11/2026 00:00:00"
  },
  {
    "id": "df436243-bb4f-4e87-8b0a-bce44bb78954",
    "slug": "sarah-june-anne-sheppard",
    "name": "SARAH JUNE ANNE SHEPPARD",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/10/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sarah June Anne Sheppard",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_df436243-bb4f-4e87-8b0a-bce44bb78954",
        "address": "ICD Brookfield Place ,Za'abeel 2 ,103747 ,",
        "phone": "97143696300 / 971506008159",
        "email": "mohammed.paracha@nortonrosefulbright.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c4aaee93-0ec4-4982-9a48-a23699492056",
    "firmName": "Norton Rose Fullbright (Middle East) LLP",
    "registrationNumber": "L-06037",
    "licenseIssueDate": "10/04/2023 00:00:00",
    "licenseExpiryDate": "10/03/2026 00:00:00"
  },
  {
    "id": "ded70121-b448-46c5-986f-055e0e2f52ac",
    "slug": "sarah-lawrence",
    "name": "Sarah Lawrence",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/15/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sarah Lawrence",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ded70121-b448-46c5-986f-055e0e2f52ac",
        "address": "",
        "phone": "97144478700 / 971528553200",
        "email": "Thomas.Wilson@squirepb.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "85be541a-c87f-45a9-a321-d90abd6b7298",
    "firmName": "Squire Patton Boggs (MEA) LLP",
    "registrationNumber": "L-02556",
    "licenseIssueDate": "04/15/2013 00:00:00",
    "licenseExpiryDate": "04/07/2026 00:00:00"
  },
  {
    "id": "ee83315f-a278-4fac-826b-b66764b28272",
    "slug": "sarah-lee-mckone",
    "name": "SARAH LEE MCKONE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/11/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sarah Lee McKone",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ee83315f-a278-4fac-826b-b66764b28272",
        "address": "ICD Brookfield Place ,Za'abeel 2 ,103747 ,",
        "phone": "97143696300 / 971506008159",
        "email": "mohammed.paracha@nortonrosefulbright.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c4aaee93-0ec4-4982-9a48-a23699492056",
    "firmName": "Norton Rose Fullbright (Middle East) LLP",
    "registrationNumber": "L-05519",
    "licenseIssueDate": "11/19/2024 00:00:00",
    "licenseExpiryDate": "11/18/2025 00:00:00"
  },
  {
    "id": "5bb0ffba-e579-4988-b831-c26c757629ab",
    "slug": "sarah-mohamed-ahmed-eltomy",
    "name": "Sarah Mohamed Ahmed Eltomy",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/06/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-06-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sarah Mohamed Ahmed Eltomy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5bb0ffba-e579-4988-b831-c26c757629ab",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-04132",
    "licenseIssueDate": "06/18/2018 00:00:00",
    "licenseExpiryDate": "06/17/2019 00:00:00"
  },
  {
    "id": "3ebdde1e-6029-4b3e-b811-8c727f66eb0e",
    "slug": "sarah-nohra",
    "name": "SARAH NOHRA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/03/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sarah Nohra",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3ebdde1e-6029-4b3e-b811-8c727f66eb0e",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-06729",
    "licenseIssueDate": "03/26/2025 00:00:00",
    "licenseExpiryDate": "03/25/2026 00:00:00"
  },
  {
    "id": "a843ba2a-0609-40f7-ae52-7620fe2a9b77",
    "slug": "sarah-osama-amin-hassan-elserafy",
    "name": "SARAH OSAMA AMIN HASSAN ELSERAFY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/08/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sarah Osama Amin Hassan ElSerafy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a843ba2a-0609-40f7-ae52-7620fe2a9b77",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04190",
    "licenseIssueDate": "08/27/2018 00:00:00",
    "licenseExpiryDate": "08/25/2026 00:00:00"
  },
  {
    "id": "a8e9d251-85ef-447b-bcf4-a1211ba0cf54",
    "slug": "sarah-pearson",
    "name": "SARAH REBECCA COLITA PEARSON BAIRD",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/07/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sarah Pearson",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a8e9d251-85ef-447b-bcf4-a1211ba0cf54",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-03782",
    "licenseIssueDate": "07/10/2017 00:00:00",
    "licenseExpiryDate": "07/07/2026 00:00:00"
  },
  {
    "id": "97787529-c189-474e-b31b-f208b8a3cb3b",
    "slug": "sarah-willa-mary-findlay",
    "name": "SARAH WILLA MARY FINDLAY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/07/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sarah Willa Mary Findlay",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_97787529-c189-474e-b31b-f208b8a3cb3b",
        "address": "Index Tower ,DIFC ,506896 ,",
        "phone": "97142782300 / 971551154791",
        "email": "GLeggate@wfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e2b82cfc-80a5-4957-ae41-b1a7beb693c1",
    "firmName": "Watson, Farley & Williams (Middle East) LLP",
    "registrationNumber": "L-06417",
    "licenseIssueDate": "07/24/2024 00:00:00",
    "licenseExpiryDate": "07/23/2026 00:00:00"
  },
  {
    "id": "e0f2d8be-daca-4a23-9030-a3ba9370ff6d",
    "slug": "sarah-jane-mahood",
    "name": "SARAH JANE MAHOOD",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/04/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sarah-Jane Mahood",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e0f2d8be-daca-4a23-9030-a3ba9370ff6d",
        "address": "",
        "phone": "97145953601 / 971508728645",
        "email": "Steven.Bainbridge@gtlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b4146aa6-efd1-41d7-819d-49da46353b0b",
    "firmName": "Greenberg Traurig Limited",
    "registrationNumber": "L-02494",
    "licenseIssueDate": "04/13/2014 00:00:00",
    "licenseExpiryDate": "04/06/2026 00:00:00"
  },
  {
    "id": "846887d3-692c-42da-9fa0-7155513d8271",
    "slug": "sarit-thomas",
    "name": "SARIT EIRA THOMAS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/09/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sarit Thomas",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_846887d3-692c-42da-9fa0-7155513d8271",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-01009",
    "licenseIssueDate": "09/08/2011 00:00:00",
    "licenseExpiryDate": "08/30/2026 00:00:00"
  },
  {
    "id": "15520ba6-f314-4400-bc5a-76f9c0311511",
    "slug": "sarosh-mewawalla",
    "name": "SAROSH HOMI MEWAWALLA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sarosh Mewawalla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_15520ba6-f314-4400-bc5a-76f9c0311511",
        "address": "",
        "phone": "97144286300 / 971506256686",
        "email": "stuart.paterson@hsf.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2f0389b3-bfde-44f4-bdd6-6e1a22f9cab2",
    "firmName": "Herbert Smith Freehills Kramer LLP",
    "registrationNumber": "L-00728",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "7c418730-ac1b-4391-9f4a-1246b43b3edc",
    "slug": "sarthak-sharma-sunil-kumar-sharma",
    "name": "SARTHAK SHARMA SUNIL KUMAR SHARMA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/05/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sarthak Sharma Sunil Kumar Sharma",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7c418730-ac1b-4391-9f4a-1246b43b3edc",
        "address": "",
        "phone": "97142776075 / 971588324788",
        "email": "avichal@kochhardubai.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "847eff7c-4142-431e-a8d6-f58ff60964f6",
    "firmName": "Kochhar & Co Inc Legal Consultants (Dubai Branch)",
    "registrationNumber": "L-05793",
    "licenseIssueDate": "05/03/2023 00:00:00",
    "licenseExpiryDate": "05/02/2026 00:00:00"
  },
  {
    "id": "10430465-81d3-48f8-8e91-d788cfa0aa7a",
    "slug": "sau-lin-wan",
    "name": "SAU LIN WAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/10/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: SAU LIN WAN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_10430465-81d3-48f8-8e91-d788cfa0aa7a",
        "address": "",
        "phone": "97143093222 / 971566651954",
        "email": "melissa.murray@twobirds.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3e1526e6-4c8d-4b6f-985f-ea05e9f99bcb",
    "firmName": "Bird & Bird (MEA) LLP",
    "registrationNumber": "L-03911",
    "licenseIssueDate": "10/26/2017 00:00:00",
    "licenseExpiryDate": "10/23/2026 00:00:00"
  },
  {
    "id": "4de3f637-d6c2-4834-b6e2-4758bd2e9bc0",
    "slug": "saurbh-kothari",
    "name": "SAURBH KOTHARI SUSHIL KUMAR KOTHARI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/12/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Saurbh Kothari",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4de3f637-d6c2-4834-b6e2-4758bd2e9bc0",
        "address": "",
        "phone": "97143303900 / 971561753537",
        "email": "christopher@afridi-angell.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "30ce50dc-01a6-499d-8ace-3f807ddcb08d",
    "firmName": "Afridi & Angell-DED",
    "registrationNumber": "L-00123",
    "licenseIssueDate": "12/16/2011 00:00:00",
    "licenseExpiryDate": "12/07/2025 00:00:00"
  },
  {
    "id": "3d808ef4-f301-4eb8-8f65-7af3a5489813",
    "slug": "sayed-mohamed-saeed-sadeq-mohamed-alalawi",
    "name": "Sayed Mohamed Saeed Sadeq Mohamed Alalawi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/01/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sayed Mohamed Saeed Sadeq Mohamed Alalawi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3d808ef4-f301-4eb8-8f65-7af3a5489813",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506688 ,Dubai",
        "phone": "97147096600 / 971503556811",
        "email": "muneer.khan@simmons-simmons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d1725ca7-06ac-41b2-8d7b-a6e60665b73d",
    "firmName": "Simmons & Simmons (Middle East) LLP-DIFC",
    "registrationNumber": "L-05689",
    "licenseIssueDate": "01/04/2023 00:00:00",
    "licenseExpiryDate": "01/03/2026 00:00:00"
  },
  {
    "id": "6dcf9bd4-a21c-4405-9fa8-91117a258c32",
    "slug": "sayed-sayel-m-obeidat",
    "name": "SAED SAYEL M OBEIDAT",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/12/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sayed Sayel M Obeidat",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6dcf9bd4-a21c-4405-9fa8-91117a258c32",
        "address": "",
        "phone": "97143897000 / 971506553198",
        "email": "nasseralikhasawneh@eversheds-sutherland.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "74a21d43-41d8-480a-a6af-6939b7c98a95",
    "firmName": "Eversheds Sutherland (International LLP) Dubai Branch",
    "registrationNumber": "L-06129",
    "licenseIssueDate": "12/13/2023 00:00:00",
    "licenseExpiryDate": "12/12/2025 00:00:00"
  },
  {
    "id": "ee2cd2dc-93b2-4417-be50-82ab8bb86320",
    "slug": "sayf-maan-munir-shuqair",
    "name": "SAYF MAAN MUNIR SHUQAIR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/05/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sayf Ma'an Munir Shuqair",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ee2cd2dc-93b2-4417-be50-82ab8bb86320",
        "address": "",
        "phone": "97143779900 / 971508548052",
        "email": "jali@kslaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dff8529a-82be-431a-b72b-0192ff238011",
    "firmName": "King & Spalding LLP",
    "registrationNumber": "L-04421",
    "licenseIssueDate": "05/30/2019 00:00:00",
    "licenseExpiryDate": "05/29/2026 00:00:00"
  },
  {
    "id": "2bcd9d36-63d1-4db2-a301-c1db13d206a2",
    "slug": "sbusiso-mbulelo-zusakhe-maseko",
    "name": "SBUSISO MBULELO ZUSAKHE MASEKO",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/03/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sbusiso Mbulelo Zusakhe Maseko",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2bcd9d36-63d1-4db2-a301-c1db13d206a2",
        "address": "THE OFFICES 1 ,DWTC ,115580 ,",
        "phone": "97143739700 / 971501148248",
        "email": "nitesh.pradhan@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "361fdc64-6b6f-4f37-abca-c52af8473b84",
    "firmName": "Pinsent Masons  LLP (DWTCA Branch)",
    "registrationNumber": "L-05786",
    "licenseIssueDate": "03/29/2023 00:00:00",
    "licenseExpiryDate": "03/28/2026 00:00:00"
  },
  {
    "id": "416d5a0d-b214-43a6-b99a-d8c45d3736cb",
    "slug": "scheherazade-kersi-dubash",
    "name": "SCHEHERAZADE KERSI DUBASH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/11/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Scheherazade Kersi Dubash",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_416d5a0d-b214-43a6-b99a-d8c45d3736cb",
        "address": "THE OFFICES 1 ,DWTC ,115580 ,",
        "phone": "97143739700 / 971501148248",
        "email": "nitesh.pradhan@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "361fdc64-6b6f-4f37-abca-c52af8473b84",
    "firmName": "Pinsent Masons  LLP (DWTCA Branch)",
    "registrationNumber": "L-06067",
    "licenseIssueDate": "11/06/2023 00:00:00",
    "licenseExpiryDate": "11/05/2025 00:00:00"
  },
  {
    "id": "71b5c366-aec5-43c6-bdc6-a3f88e8667a7",
    "slug": "scott-andrew-cameron",
    "name": "SCOTT ANDREW CAMERON",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/09/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Scott Andrew Cameron",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_71b5c366-aec5-43c6-bdc6-a3f88e8667a7",
        "address": "0 ,ICD Brookfield Place Level 13 ,Trade Centre ,506569 ,Dubai",
        "phone": "97145099100 / 971501006965",
        "email": "menahr@freshfields.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "970f6246-e737-41a7-9c6c-5aa5b8335d45",
    "firmName": "Freshfields LLP DIFC",
    "registrationNumber": "L-05539",
    "licenseIssueDate": "09/21/2022 00:00:00",
    "licenseExpiryDate": "09/20/2026 00:00:00"
  },
  {
    "id": "5eafaf3e-8261-40e1-82a6-96e9c9ef776d",
    "slug": "scott-campbell",
    "name": "SCOTT DAVID CAMPBELL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Scott Campbell",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5eafaf3e-8261-40e1-82a6-96e9c9ef776d",
        "address": "ICD Brookfield Place ,DIFC ,506516 ,",
        "phone": "97143695800 / 971505526206",
        "email": "scott.campbell@linklaters.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "5cec94c0-0649-43b6-a2be-ab17ff422bce",
    "firmName": "LinkLaters LLP",
    "registrationNumber": "L-00729",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "dc64d6c0-8718-4459-81e5-e940e39be15b",
    "slug": "scott-david-geelan",
    "name": "SCOTT DAVID GEELAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/03/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Scott David Geelan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dc64d6c0-8718-4459-81e5-e940e39be15b",
        "address": "ICD Brookfield Place ,DIFC ,506516 ,",
        "phone": "97143695800 / 971505526206",
        "email": "scott.campbell@linklaters.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5cec94c0-0649-43b6-a2be-ab17ff422bce",
    "firmName": "LinkLaters LLP",
    "registrationNumber": "L-05751",
    "licenseIssueDate": "03/29/2023 00:00:00",
    "licenseExpiryDate": "03/28/2026 00:00:00"
  },
  {
    "id": "dbf1fec9-ea0f-4021-a20d-3960c6c74a99",
    "slug": "scott-lambert",
    "name": "SCOTT JAMES LAMBERT",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/05/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Scott Lambert",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dbf1fec9-ea0f-4021-a20d-3960c6c74a99",
        "address": "الطابق 14  ,برج 48 جيت  ,محطة مترو دبي  ,413633 ,Dubai",
        "phone": "97144412031",
        "email": "courts@adglegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4287f048-dc0c-4d51-9e0c-0c23356040ee",
    "firmName": "MOHAMMED AL DAHBASHI ADVOCATES",
    "registrationNumber": "L-02514",
    "licenseIssueDate": "05/08/2014 00:00:00",
    "licenseExpiryDate": "05/02/2026 00:00:00"
  },
  {
    "id": "dfea531e-0fbb-4280-ad53-58c5a42993ba",
    "slug": "se-won-park",
    "name": "SE WON PARK",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/07/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Se Won Park",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dfea531e-0fbb-4280-ad53-58c5a42993ba",
        "address": "One Central, The Offices 5 ,Dubai World Trade Centre ,554660 ,",
        "phone": "97142052030 / 971506566494",
        "email": "chourani@houranipartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "59a73632-40a0-4849-b120-4308dc6f8015",
    "firmName": "Hourani & Partners Legal Consultancy FZCO",
    "registrationNumber": "L-06897",
    "licenseIssueDate": "07/30/2025 00:00:00",
    "licenseExpiryDate": "07/29/2026 00:00:00"
  },
  {
    "id": "d6e1eb08-6cd2-43f9-8bb5-f8e2140adbfb",
    "slug": "sean-angle",
    "name": "SEAN LEONARD ANGLE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/05/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sean Angle",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d6e1eb08-6cd2-43f9-8bb5-f8e2140adbfb",
        "address": "",
        "phone": "97145683100 / 971559223103",
        "email": "rossi@bonnard-lawson.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2b373724-e557-4c31-a968-7d37d9393842",
    "firmName": "Bonnard Lawson Legal Consultants L.L.C",
    "registrationNumber": "L-00678",
    "licenseIssueDate": "05/25/2025 00:00:00",
    "licenseExpiryDate": "05/24/2026 00:00:00"
  },
  {
    "id": "60e07b27-6beb-4674-9f91-0eae220183bf",
    "slug": "sean-christopher-tobin",
    "name": "SEAN CHRISTOPHER TOBIN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/08/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: SEAN CHRISTOPHER TOBIN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_60e07b27-6beb-4674-9f91-0eae220183bf",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-05875",
    "licenseIssueDate": "08/21/2025 00:00:00",
    "licenseExpiryDate": "08/20/2026 00:00:00"
  },
  {
    "id": "1d5b48b3-d272-4a7b-be1b-c902d1e428cc",
    "slug": "sean-cope",
    "name": "SEAN LAWRENCE COPE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/09/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sean Cope",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1d5b48b3-d272-4a7b-be1b-c902d1e428cc",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-02589",
    "licenseIssueDate": "09/11/2014 00:00:00",
    "licenseExpiryDate": "09/05/2026 00:00:00"
  },
  {
    "id": "a91d24e3-83ed-4912-9515-6a079dd8c677",
    "slug": "sean-gary-cameron",
    "name": "SEAN GARY CAMERON",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/09/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sean Gary Cameron",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a91d24e3-83ed-4912-9515-6a079dd8c677",
        "address": "ICD Brookfield Place ,DIFC ,506516 ,",
        "phone": "97143695800 / 971505526206",
        "email": "scott.campbell@linklaters.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5cec94c0-0649-43b6-a2be-ab17ff422bce",
    "firmName": "LinkLaters LLP",
    "registrationNumber": "L-06932",
    "licenseIssueDate": "08/12/2025 00:00:00",
    "licenseExpiryDate": "08/11/2026 00:00:00"
  },
  {
    "id": "1771f83c-e5c5-4a57-beff-04d4dc6f43fc",
    "slug": "sean-whitham",
    "name": "SEAN ANTHONY WHITHAM",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/12/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sean Whitham",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1771f83c-e5c5-4a57-beff-04d4dc6f43fc",
        "address": "",
        "phone": "97144286300 / 971506256686",
        "email": "stuart.paterson@hsf.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2f0389b3-bfde-44f4-bdd6-6e1a22f9cab2",
    "firmName": "Herbert Smith Freehills Kramer LLP",
    "registrationNumber": "L-03251",
    "licenseIssueDate": "12/10/2015 00:00:00",
    "licenseExpiryDate": "12/05/2025 00:00:00"
  },
  {
    "id": "9c84aa94-001c-4480-83a3-4ff1974f54f9",
    "slug": "sebastian-charles-roberts",
    "name": "SEBASTIAN CHARLES ROBERTS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/11/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sebastian Charles Roberts",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9c84aa94-001c-4480-83a3-4ff1974f54f9",
        "address": "",
        "phone": "97144286300 / 971506256686",
        "email": "stuart.paterson@hsf.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2f0389b3-bfde-44f4-bdd6-6e1a22f9cab2",
    "firmName": "Herbert Smith Freehills Kramer LLP",
    "registrationNumber": "L-04248",
    "licenseIssueDate": "11/05/2018 00:00:00",
    "licenseExpiryDate": "11/03/2025 00:00:00"
  },
  {
    "id": "1f08d48d-4fd6-433c-aaed-66dd26ad37d5",
    "slug": "sebastian-thierry-hoarau",
    "name": "SEBASTIAN THIERRY HOARAU",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/05/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sebastian Thierry Hoarau",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1f08d48d-4fd6-433c-aaed-66dd26ad37d5",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-04932",
    "licenseIssueDate": "05/03/2021 00:00:00",
    "licenseExpiryDate": "05/02/2026 00:00:00"
  },
  {
    "id": "18749ed0-7312-4d83-b26c-383f63e36853",
    "slug": "seema-bono",
    "name": "SEEMA NISHA SUNIT BONO",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/10/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Seema Bono",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_18749ed0-7312-4d83-b26c-383f63e36853",
        "address": "- ,THE OFFICES 1 ,DWTC ,115580 ,Dubai",
        "phone": "97143739700 / 971562196031",
        "email": "catherine.workman@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6b4ebb23-ef2e-4305-a1ee-43a11e4b1cae",
    "firmName": "Pinsent Masons LLP - Dubai Branch",
    "registrationNumber": "L-02671",
    "licenseIssueDate": "10/09/2014 00:00:00",
    "licenseExpiryDate": "10/03/2026 00:00:00"
  },
  {
    "id": "ecea480d-1bb3-4b5b-a585-21aacd73f62c",
    "slug": "serafettin-eren-ayanlar",
    "name": "SERAFETTIN EREN AYANLAR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/08/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Serafettin Eren Ayanlar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ecea480d-1bb3-4b5b-a585-21aacd73f62c",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-05013",
    "licenseIssueDate": "08/23/2021 00:00:00",
    "licenseExpiryDate": "08/22/2026 00:00:00"
  },
  {
    "id": "492e5af9-f668-4ed1-9d91-8cdee1093e30",
    "slug": "serena-marie-stangroom",
    "name": "SERENA MARIE MCLEOD",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/11/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Serena Marie Stangroom",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_492e5af9-f668-4ed1-9d91-8cdee1093e30",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-05586",
    "licenseIssueDate": "11/02/2022 00:00:00",
    "licenseExpiryDate": "11/01/2025 00:00:00"
  },
  {
    "id": "ef30562b-066f-4c11-b32c-d15bca8d1a44",
    "slug": "serena-montalbano",
    "name": "SERENA BOSCIA MONTALBANO",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/04/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Serena Montalbano",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ef30562b-066f-4c11-b32c-d15bca8d1a44",
        "address": "",
        "phone": "97143826100 / 971507380618",
        "email": "jmiocevic@curtis.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0867bcc5-10fa-4783-91ae-b8f63e02e81a",
    "firmName": "Curtis Mallet-Prevost, Colt & Mosle LLP",
    "registrationNumber": "L-01859",
    "licenseIssueDate": "04/29/2025 00:00:00",
    "licenseExpiryDate": "04/28/2026 00:00:00"
  },
  {
    "id": "8f90a1ce-d2ab-4388-bf6f-92aee8d7afe9",
    "slug": "sergei-slichenko",
    "name": "SERGEI SLICHENKO",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/07/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sergei Slichenko",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8f90a1ce-d2ab-4388-bf6f-92aee8d7afe9",
        "address": "",
        "phone": "97143779900 / 971508548052",
        "email": "jali@kslaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dff8529a-82be-431a-b72b-0192ff238011",
    "firmName": "King & Spalding LLP",
    "registrationNumber": "L-05934",
    "licenseIssueDate": "07/26/2023 00:00:00",
    "licenseExpiryDate": "07/25/2026 00:00:00"
  },
  {
    "id": "2904b97e-ed81-45f8-a78f-5f938838356a",
    "slug": "sergejs-dilevka",
    "name": "SERGEJS DILEVKA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/08/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sergejs Dilevka",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2904b97e-ed81-45f8-a78f-5f938838356a",
        "address": "",
        "phone": "97143937700",
        "email": "info@galadarilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d863b662-c864-4193-8b3a-ff6ee5fe6c64",
    "firmName": "GALADARI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04475",
    "licenseIssueDate": "08/22/2019 00:00:00",
    "licenseExpiryDate": "08/21/2026 00:00:00"
  },
  {
    "id": "d65e5692-3f93-4704-a827-00723f487c39",
    "slug": "sergey-avakyan",
    "name": "Sergey Avakyan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/07/2022",
    "licenseStatus": "active",
    "licenseExpiry": "2023-07-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sergey Avakyan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d65e5692-3f93-4704-a827-00723f487c39",
        "address": "ICD Brookfield Place ,Za'abeel 2 ,103747 ,",
        "phone": "97143696300 / 971506008159",
        "email": "mohammed.paracha@nortonrosefulbright.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c4aaee93-0ec4-4982-9a48-a23699492056",
    "firmName": "Norton Rose Fullbright (Middle East) LLP",
    "registrationNumber": "L-05393",
    "licenseIssueDate": "07/20/2022 00:00:00",
    "licenseExpiryDate": "07/19/2026 00:00:00"
  },
  {
    "id": "402a6523-5cbb-4c8a-bb7d-820ed5c59a00",
    "slug": "sergey-shiposha",
    "name": "SERGEY SHIPOSHA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/04/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sergey Shiposha",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_402a6523-5cbb-4c8a-bb7d-820ed5c59a00",
        "address": "ICD Brookfield Place ,DIFC ,506516 ,",
        "phone": "97143695800 / 971505526206",
        "email": "scott.campbell@linklaters.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5cec94c0-0649-43b6-a2be-ab17ff422bce",
    "firmName": "LinkLaters LLP",
    "registrationNumber": "L-05323",
    "licenseIssueDate": "04/26/2022 00:00:00",
    "licenseExpiryDate": "04/25/2026 00:00:00"
  },
  {
    "id": "0aa60519-cc37-41db-b527-35a0a735c67a",
    "slug": "sergio-ochagavia-barbarin",
    "name": "Sergio Ochagavia Barbarin",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/06/2025",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sergio Ochagavia Barbarin",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0aa60519-cc37-41db-b527-35a0a735c67a",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-06852",
    "licenseIssueDate": "06/11/2025 00:00:00",
    "licenseExpiryDate": "06/10/2026 00:00:00"
  },
  {
    "id": "d15fbd27-be46-4922-b520-d767b3b025e7",
    "slug": "sergio-oliveri",
    "name": "Sergio Oliveri",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/26/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sergio Oliveri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d15fbd27-be46-4922-b520-d767b3b025e7",
        "address": "",
        "phone": "97145851677 / 971508009612",
        "email": "antonio.varvaro@amv-eurolegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2834e81b-8706-4672-8b39-01356b145ac0",
    "firmName": "Antonio M Varvaro Legal Consultants",
    "registrationNumber": "L-06159",
    "licenseIssueDate": "12/26/2023 00:00:00",
    "licenseExpiryDate": "12/25/2025 00:00:00"
  },
  {
    "id": "5e0a9df6-a7dc-4701-8170-3905706d9408",
    "slug": "seyavash-rahnema",
    "name": "SEYAVASH RAHNEMA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/04/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Seyavash Rahnema",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5e0a9df6-a7dc-4701-8170-3905706d9408",
        "address": "THE OFFICES 1 ,DWTC ,115580 ,",
        "phone": "97143739700 / 971501148248",
        "email": "nitesh.pradhan@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "361fdc64-6b6f-4f37-abca-c52af8473b84",
    "firmName": "Pinsent Masons  LLP (DWTCA Branch)",
    "registrationNumber": "L-03556",
    "licenseIssueDate": "04/15/2021 00:00:00",
    "licenseExpiryDate": "04/14/2026 00:00:00"
  },
  {
    "id": "da62879a-9ca2-4551-9d8b-ca81239e25d9",
    "slug": "shaakir-yunus-daud",
    "name": "SHAAKIR YUNUS DAUD",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/10/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Shaakir Yunus Daud",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_da62879a-9ca2-4551-9d8b-ca81239e25d9",
        "address": "",
        "phone": "97144020800 / 971566830829",
        "email": "dean.ryburn@dentons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dfe13b7e-6625-45fd-ad63-9ee83af41194",
    "firmName": "Dentons & Co Dubai Branch-DED",
    "registrationNumber": "L-04510",
    "licenseIssueDate": "10/03/2019 00:00:00",
    "licenseExpiryDate": "10/02/2026 00:00:00"
  },
  {
    "id": "34a3d1df-deeb-47da-8106-23f2b9fe7eee",
    "slug": "shaban-al-mutawalli",
    "name": "SHABAN ELMETWALLI SHABAN ELMETWALLI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Shaban Al Mutawalli",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_34a3d1df-deeb-47da-8106-23f2b9fe7eee",
        "address": "",
        "phone": "97143685555",
        "email": "maisa.maarouf@bsabh.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8afa232f-52ff-4dad-82c3-9a04d66eb853",
    "firmName": "B S A AHMED BIN HAZEEM & ASSOCIATES LLP - DIFC",
    "registrationNumber": "L-01642",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "96758dbb-8c78-4f3c-a6ea-3cb901436dfc",
    "slug": "shaban-mohamed-shaban-mohamed",
    "name": "SHABAN MOHAMED SHABAN MOHAMED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/11/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-11-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: shaban mohamed shaban mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_96758dbb-8c78-4f3c-a6ea-3cb901436dfc",
        "address": "",
        "phone": "97142280002",
        "email": "advoali2020@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5029a3dc-098b-4d3f-9e38-afb0eb4319d0",
    "firmName": "ALI IBRAHIM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01534",
    "licenseIssueDate": "11/21/2017 00:00:00",
    "licenseExpiryDate": "11/18/2025 00:00:00"
  },
  {
    "id": "c5e37c81-c983-45cc-a60b-b96774b0fe9e",
    "slug": "shabana-saleem",
    "name": "SHABANA SALEEM",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/09/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Shabana Saleem",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c5e37c81-c983-45cc-a60b-b96774b0fe9e",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-06494",
    "licenseIssueDate": "09/11/2024 00:00:00",
    "licenseExpiryDate": "09/10/2026 00:00:00"
  },
  {
    "id": "5f64f639-7845-47ad-bb3e-d0c6ab8eeed2",
    "slug": "shabnam-karim",
    "name": "SHABNAM AISHA KARIM",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/03/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Shabnam Karim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5f64f639-7845-47ad-bb3e-d0c6ab8eeed2",
        "address": "ICD Brookfield Place ,Za'abeel 2 ,103747 ,",
        "phone": "97143696300 / 971506008159",
        "email": "mohammed.paracha@nortonrosefulbright.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c4aaee93-0ec4-4982-9a48-a23699492056",
    "firmName": "Norton Rose Fullbright (Middle East) LLP",
    "registrationNumber": "L-02707",
    "licenseIssueDate": "03/17/2014 00:00:00",
    "licenseExpiryDate": "03/10/2026 00:00:00"
  },
  {
    "id": "2c85c46b-aa52-46c3-a5b0-6aad02b85c1c",
    "slug": "shadha-zawawi-raza-shah-zawawi",
    "name": "SHADHA ZAWAWI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTWgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/08/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Shadha Zawawi Raza Shah Zawawi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2c85c46b-aa52-46c3-a5b0-6aad02b85c1c",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-04229",
    "licenseIssueDate": "08/19/2024 00:00:00",
    "licenseExpiryDate": "08/18/2026 00:00:00"
  },
  {
    "id": "aaf12a75-3cd3-456c-be09-9f961bfe17e8",
    "slug": "shadi-kousa",
    "name": "SHADI KOUSA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/01/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Shadi Kousa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_aaf12a75-3cd3-456c-be09-9f961bfe17e8",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-05699",
    "licenseIssueDate": "01/25/2023 00:00:00",
    "licenseExpiryDate": "01/24/2026 00:00:00"
  },
  {
    "id": "abe466f6-5c42-4683-990b-3381180bfcfe",
    "slug": "shady-mohamed-samy-ahmed-hanafy-ashour",
    "name": "SHADY MOHAMED SAMY AHMED HANAFY ASHOUR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/04/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Shady Mohamed Samy Ahmed Hanafy Ashour",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_abe466f6-5c42-4683-990b-3381180bfcfe",
        "address": "1606 ,فندق الكونراد - برج المكاتب ,فندق الفيرمونت ,84333 ,Dubai",
        "phone": "97142218787 / 971505773332",
        "email": "info@alshamsilawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "fa7eb7e5-d5d3-404a-91ba-06a1efeb207e",
    "firmName": "ALI OBAID ALSHAMSI LAWYERS & LEGAL CONSULTANTS",
    "registrationNumber": "L-05821",
    "licenseIssueDate": "04/26/2023 00:00:00",
    "licenseExpiryDate": "04/25/2026 00:00:00"
  },
  {
    "id": "7a56be02-5d38-4883-9253-f3af00307670",
    "slug": "shafei-ahmed-mahmoud",
    "name": "SHAFIEY AHMED SHAFIEY MAHMOUD",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Shafei Ahmed Mahmoud",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7a56be02-5d38-4883-9253-f3af00307670",
        "address": "الطابق 11 - مكتب رقم (1105 ، 1106)  ,برج السلام  ,منطقة المركز التجاري العالمي 1 ,211911 ,Dubai",
        "phone": "97143366769 / 971503636617",
        "email": "info@erlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "fffe1b8f-e9ab-488f-82eb-6151b8f007df",
    "firmName": "EMAN ALRIFAI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01605",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "ea9a7b99-808e-40b9-ada7-4ec598f983ae",
    "slug": "shafi-masjid",
    "name": "SHAFI MOGRAL MASJID MOGRAL ABDUL KHADER ABDUL RAHIMAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/01/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Shafi Masjid",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ea9a7b99-808e-40b9-ada7-4ec598f983ae",
        "address": "abdulla nasser mansour hamad alkaabi ,life pharmacy ,al safa ,millennium plaza hotel ,113713 ,Dubai",
        "phone": "97143598998",
        "email": "advo.akd@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "05d59198-4e23-4b78-bb9b-d55bfcd69060",
    "firmName": "ABDULLA ALKAABI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03601",
    "licenseIssueDate": "01/22/2017 00:00:00",
    "licenseExpiryDate": "01/18/2026 00:00:00"
  },
  {
    "id": "308f682f-fc4c-400f-bd71-7c489c823d78",
    "slug": "shagun-jaggi-vikram-jaggi",
    "name": "SHAGUN JAGGI VIKRAM JAGGI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/03/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Shagun Jaggi Vikram Jaggi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_308f682f-fc4c-400f-bd71-7c489c823d78",
        "address": "0 ,ICD Brookfield Place Level 13 ,Trade Centre ,506569 ,Dubai",
        "phone": "97145099100 / 971501006965",
        "email": "menahr@freshfields.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "970f6246-e737-41a7-9c6c-5aa5b8335d45",
    "firmName": "Freshfields LLP DIFC",
    "registrationNumber": "L-06257",
    "licenseIssueDate": "03/14/2024 00:00:00",
    "licenseExpiryDate": "03/13/2026 00:00:00"
  },
  {
    "id": "61f24dca-7ab1-47a7-8136-44ce6e688e49",
    "slug": "shahed-ahmed",
    "name": "SHAHED AHMED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/04/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Shahed Ahmed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_61f24dca-7ab1-47a7-8136-44ce6e688e49",
        "address": "Office 1A ,Silver Tower ,DMCC Al Mas Tower ,283149 ,Dubai",
        "phone": "97144542355 / 971564092949",
        "email": "pstone@fenwickelliott.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "45b03212-ac3a-4dbc-8b2d-10fc81273543",
    "firmName": "Fenwick Elliott LLP (DMCC Branch)",
    "registrationNumber": "L-04675",
    "licenseIssueDate": "04/30/2020 00:00:00",
    "licenseExpiryDate": "04/28/2026 00:00:00"
  },
  {
    "id": "c04da0ea-fe30-4cfe-a9a3-f1319b307b1e",
    "slug": "shaher-amin-hairab",
    "name": "SHAHER AMIN HAIRAB",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Civil Transactions-POA & Sponsorship",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Civil Transactions-Insurance",
      "Civil Transactions-Construction and Contracts for Services",
      "Civil Transactions-Ownership & Title",
      "Personal Status-Custody & Alimony",
      "Commercial Transactions-Commercial Contracts",
      "Commercial Transactions-Bankruptcy",
      "Commercial Transactions-Commercial Real Estate",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Civil Transactions-Arbitration",
      "Civil Transactions-Tenancy",
      "Commercial Transactions-Commercial Companies",
      "Civil Transactions-Labor & Workers",
      "Personal Status-Legal Capacity & Guardianship",
      "Civil Transactions-Sale",
      "Proceedings-Cases and Proceedings before arbitral tribunals and other alternative dispute resolution bodies",
      "Personal Status-Marriage & Divorce",
      "Criminal Law-Crimes against properties"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/02/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: SHAHER AMIN HAIRAB",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c04da0ea-fe30-4cfe-a9a3-f1319b307b1e",
        "address": "",
        "phone": "97145571020",
        "email": "abdullaalmansoori80@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "1f7b1225-9eb2-412b-9776-298c43ff6240",
    "firmName": "ABDULLA EBRAHIM ALMULLA ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-06229",
    "licenseIssueDate": "02/16/2024 00:00:00",
    "licenseExpiryDate": "02/15/2026 00:00:00"
  },
  {
    "id": "03aedeb5-838c-4512-bee6-78deb1171842",
    "slug": "shahram-safai",
    "name": "SHAHRAM SAFAI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/12/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Shahram Safai",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_03aedeb5-838c-4512-bee6-78deb1171842",
        "address": "",
        "phone": "97143303900 / 971561753537",
        "email": "christopher@afridi-angell.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "30ce50dc-01a6-499d-8ace-3f807ddcb08d",
    "firmName": "Afridi & Angell-DED",
    "registrationNumber": "L-00124",
    "licenseIssueDate": "12/16/2011 00:00:00",
    "licenseExpiryDate": "12/07/2025 00:00:00"
  },
  {
    "id": "a1b5b840-6cbf-4610-b8b7-1a345196d7f1",
    "slug": "shahrzad-askarpour",
    "name": "SHAHRZAD MITRA ASKARPOUR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/04/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Shahrzad Askarpour",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a1b5b840-6cbf-4610-b8b7-1a345196d7f1",
        "address": "ICD Brookfield Place ,Za'abeel 2 ,103747 ,",
        "phone": "97143696300 / 971506008159",
        "email": "mohammed.paracha@nortonrosefulbright.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c4aaee93-0ec4-4982-9a48-a23699492056",
    "firmName": "Norton Rose Fullbright (Middle East) LLP",
    "registrationNumber": "L-00790",
    "licenseIssueDate": "04/04/2024 00:00:00",
    "licenseExpiryDate": "04/03/2026 00:00:00"
  },
  {
    "id": "a375ab96-5611-4e98-8dda-19938c9bed61",
    "slug": "shahzad-akhter",
    "name": "SHAHZAD AKHTER ISMAIL ANEES",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/10/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Shahzad Akhter",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a375ab96-5611-4e98-8dda-19938c9bed61",
        "address": "الطابق الثامن ,بزنس أفنيو ,خلف وكالة نيسان ,444775 ,Dubai",
        "phone": "97142501414",
        "email": "info@halalilaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "37ab9a73-e65f-4829-9402-6eac64c4c621",
    "firmName": "HASSAN AL ALI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-02537",
    "licenseIssueDate": "10/09/2013 00:00:00",
    "licenseExpiryDate": "10/02/2026 00:00:00"
  },
  {
    "id": "4141db56-65ea-429d-83b9-9b99e6f8dac3",
    "slug": "shaji-kesavan-natarajan",
    "name": "SHAJI KESAVAN NATARAJAN KESAVAN NATARAJAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/01/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Shaji Kesavan Natarajan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4141db56-65ea-429d-83b9-9b99e6f8dac3",
        "address": "الخامس ,الشعلة بلوك اية ,داناتا ,127179 ,Dubai",
        "phone": "97143318888 / 971509984724",
        "email": "ameizar@salamadvo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "1b4e6bd9-712b-49bf-a169-fd31ea45cd51",
    "firmName": "SALAM ADVOCATE  & LEGAL CONSULTANTS",
    "registrationNumber": "L-01226",
    "licenseIssueDate": "01/25/2012 00:00:00",
    "licenseExpiryDate": "01/16/2026 00:00:00"
  },
  {
    "id": "012788dc-c6e9-41d3-84f5-867434f2e93e",
    "slug": "shaker-kamel-abdelbar",
    "name": "SHAKER KAMEL IBRAHIM ALI ABDELBAR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Commercial Agency",
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Civil Transactions-POA & Sponsorship",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Civil Transactions-Insurance",
      "Personal Status-Wills",
      "Civil Transactions-Construction and Contracts for Services",
      "Civil Transactions-Ownership & Title",
      "Civil Transactions-HR & Employee Affairs",
      "Commercial Transactions-Commercial Mortgage",
      "Criminal Law-Family Crimes",
      "Personal Status-Custody & Alimony",
      "Civil Transactions-Immigration and Residency",
      "Commercial Transactions-Bankruptcy",
      "Commercial Transactions-Commercial Real Estate",
      "Civil Transactions-Residential Real Estate",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Civil Transactions-Arbitration",
      "Criminal Law-Hate crimes",
      "Civil Transactions-Tenancy",
      "Commercial Transactions-Unfair competition",
      "Criminal Law-Crimes against persons",
      "Personal Status-Legacies and Inheritance",
      "Commercial Transactions-Commercial Companies",
      "Commercial Transactions-Banking Operations",
      "Civil Transactions-Labor & Workers",
      "Personal Status-Legal Capacity & Guardianship",
      "Criminal Law-Drug Crimes",
      "Commercial Transactions-Sea and air freight",
      "Proceedings-Cases and Proceedings before arbitral tribunals and other alternative dispute resolution bodies",
      "Personal Status-Marriage & Divorce",
      "Personal Status-Child Abuse & Abduction",
      "Criminal Law-Crimes against properties",
      "Criminal Law-Cybercrimes",
      "Commercial Transactions-Intellectual Property (includes trademarks",
      "copy rights",
      "patents)",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Shaker kamel Abdelbar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_012788dc-c6e9-41d3-84f5-867434f2e93e",
        "address": "108 - Block B ,Saraya Avenue ,Near Al Dar University ,712 ,Dubai",
        "phone": "97142990995",
        "email": "info@royaalawadhi.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "18906d5a-a350-4afa-be12-29a69a83b69b",
    "firmName": "ROYA ALAWADHI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02423",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "82d2ecaa-9abc-4072-8184-47ac85fb04a3",
    "slug": "shakir-mabrur",
    "name": "SHAKIR MABRUR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/07/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Shakir Mabrur",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_82d2ecaa-9abc-4072-8184-47ac85fb04a3",
        "address": "One Central, The Offices 5 ,Dubai World Trade Centre ,554660 ,",
        "phone": "97142052030 / 971506566494",
        "email": "chourani@houranipartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "59a73632-40a0-4849-b120-4308dc6f8015",
    "firmName": "Hourani & Partners Legal Consultancy FZCO",
    "registrationNumber": "L-04169",
    "licenseIssueDate": "07/24/2018 00:00:00",
    "licenseExpiryDate": "07/22/2026 00:00:00"
  },
  {
    "id": "19919cf5-6a1e-4eda-b169-eb7c65a4f959",
    "slug": "shakir-mogalia",
    "name": "SHAKIR MOGALIA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/04/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Shakir Mogalia",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_19919cf5-6a1e-4eda-b169-eb7c65a4f959",
        "address": "ICD Brookfield Place ,Za'abeel 2 ,103747 ,",
        "phone": "97143696300 / 971506008159",
        "email": "mohammed.paracha@nortonrosefulbright.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c4aaee93-0ec4-4982-9a48-a23699492056",
    "firmName": "Norton Rose Fullbright (Middle East) LLP",
    "registrationNumber": "L-05266",
    "licenseIssueDate": "04/19/2022 00:00:00",
    "licenseExpiryDate": "04/18/2026 00:00:00"
  },
  {
    "id": "634c5cd9-b37f-49db-9c04-d78445d09fb3",
    "slug": "shalagh-massingham",
    "name": "SHALAGH ALTAIR MASSINGHAM",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/01/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Shalagh Massingham",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_634c5cd9-b37f-49db-9c04-d78445d09fb3",
        "address": "",
        "phone": "97143897000 / 971506553198",
        "email": "nasseralikhasawneh@eversheds-sutherland.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "74a21d43-41d8-480a-a6af-6939b7c98a95",
    "firmName": "Eversheds Sutherland (International LLP) Dubai Branch",
    "registrationNumber": "L-03597",
    "licenseIssueDate": "01/24/2017 00:00:00",
    "licenseExpiryDate": "01/20/2026 00:00:00"
  },
  {
    "id": "3b5537aa-3a03-4104-b5d6-087d01d3f851",
    "slug": "shan-harsukh-linesh-maru",
    "name": "SHAN HARSUKH LINESH MARU",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/01/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Shan Harsukh Linesh Maru",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3b5537aa-3a03-4104-b5d6-087d01d3f851",
        "address": "",
        "phone": "97144484284 / 971559776272",
        "email": "nita@willsuae.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "272328d6-db51-4b0e-b8bc-5297a958940d",
    "firmName": "TWS Legal Consultants DMCC",
    "registrationNumber": "L-06147",
    "licenseIssueDate": "01/04/2024 00:00:00",
    "licenseExpiryDate": "01/03/2026 00:00:00"
  },
  {
    "id": "302869ec-1a85-40d6-89bc-be9628373476",
    "slug": "shane-jury",
    "name": "SHANE JURY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/01/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Shane Jury",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_302869ec-1a85-40d6-89bc-be9628373476",
        "address": "ICD-Brookfield Place ,DIFC ,119974 ,",
        "phone": "97143652000",
        "email": "david.charlier@ashurst.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c01c3c61-4d90-4058-8429-61dd01e615f5",
    "firmName": "Ashurst LLP-DIFC",
    "registrationNumber": "L-01144",
    "licenseIssueDate": "01/09/2013 00:00:00",
    "licenseExpiryDate": "12/31/2025 00:00:00"
  },
  {
    "id": "5ca27e7d-ccad-4c7f-9c16-1bdcb8075dce",
    "slug": "shane-ryan-jaftha",
    "name": "SHANE RYAN JAFTHA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/07/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Shane Ryan Jaftha",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5ca27e7d-ccad-4c7f-9c16-1bdcb8075dce",
        "address": "",
        "phone": "97143506800 / 971507244940",
        "email": "Chris.Williams@bracewelllaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "106d3ee7-86f2-4eae-9b49-fd8423095983",
    "firmName": "Bracewell LLP",
    "registrationNumber": "L-04166",
    "licenseIssueDate": "07/19/2018 00:00:00",
    "licenseExpiryDate": "07/17/2026 00:00:00"
  },
  {
    "id": "ac6f556a-1557-42ae-a047-c1a1d4cdf658",
    "slug": "shane-wilson",
    "name": "SHANE WILSON",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Bankruptcy",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Commercial Transactions-Commercial Companies",
      "Commercial Transactions-Banking Operations"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/10/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Shane Wilson",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ac6f556a-1557-42ae-a047-c1a1d4cdf658",
        "address": "",
        "phone": "97144363636 / 971505572900",
        "email": "hassan.elsayed@bakerbotts.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "fd5d6571-d053-4436-9de5-c8a36ce7c6c9",
    "firmName": "Baker Botts LLP Legal Consultants Dubai Branch",
    "registrationNumber": "L-00523",
    "licenseIssueDate": "10/07/2011 00:00:00",
    "licenseExpiryDate": "09/29/2026 00:00:00"
  },
  {
    "id": "20f9ff61-5e9d-48c1-8528-afd89e500afa",
    "slug": "shani-salim",
    "name": "SHANI SALIM EDRIS MOHAMMAD SALIM",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Sea and air freight"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Shani Salim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_20f9ff61-5e9d-48c1-8528-afd89e500afa",
        "address": "",
        "phone": "97143937700",
        "email": "info@galadarilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d863b662-c864-4193-8b3a-ff6ee5fe6c64",
    "firmName": "GALADARI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01502",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "5f712491-7285-4561-9f22-077bd7c125a4",
    "slug": "sharif-jamoos",
    "name": "SHARIF JAMOOS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/10/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sharif Jamoos",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5f712491-7285-4561-9f22-077bd7c125a4",
        "address": "",
        "phone": "97144073901 / 971503479508",
        "email": "Rania.Tadros@stephensonharwood.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dd5042a2-bb41-4123-9544-79c3fa831332",
    "firmName": "Stephenson Harwood (Middle East) LLP",
    "registrationNumber": "L-05086",
    "licenseIssueDate": "10/25/2021 00:00:00",
    "licenseExpiryDate": "10/24/2025 00:00:00"
  },
  {
    "id": "4884f16d-4133-46d6-b1b2-4e4b19968b5c",
    "slug": "shashwat-mishra",
    "name": "SHASHWAT MISHRA MAHESH KUMAR MISHRA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/03/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Shashwat Mishra",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4884f16d-4133-46d6-b1b2-4e4b19968b5c",
        "address": "M19 ,بناية مركز القرهود للأعمال ,مستشفى القرهود التخصصي  ,445499 ,Dubai",
        "phone": "97142999949",
        "email": "info@hsadvo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e07b0a55-9fe6-457d-a9ff-a1dada995416",
    "firmName": "HUMAID YOUSUF ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03366",
    "licenseIssueDate": "03/22/2018 00:00:00",
    "licenseExpiryDate": "03/19/2026 00:00:00"
  },
  {
    "id": "90ef182c-2df6-4b59-a5bc-bb071830e773",
    "slug": "shayan-ahmad-najib",
    "name": "SHAYAN AHMAD NAJIB",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/02/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Shayan Ahmad Najib",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_90ef182c-2df6-4b59-a5bc-bb071830e773",
        "address": "",
        "phone": "97143506800 / 971507244940",
        "email": "Chris.Williams@bracewelllaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "106d3ee7-86f2-4eae-9b49-fd8423095983",
    "firmName": "Bracewell LLP",
    "registrationNumber": "L-04315",
    "licenseIssueDate": "02/13/2019 00:00:00",
    "licenseExpiryDate": "02/11/2026 00:00:00"
  },
  {
    "id": "b7afa822-7449-4c6a-b168-6fada3f86c3d",
    "slug": "shayan-dasgupta",
    "name": "SHAYAN DASGUPTA SUVANKAR DASGUPTA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/01/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Shayan Dasgupta",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b7afa822-7449-4c6a-b168-6fada3f86c3d",
        "address": "1 ,Emaar Square 5 ,sheikh mohammed bin rashid BVD ,11987 ,Dubai",
        "phone": "97143043100 / 971507325154",
        "email": "amir.kordvani@pwc.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ea026b18-c93c-4f67-a1f2-4546320f8f3e",
    "firmName": "PWC Legal Middle East LLP",
    "registrationNumber": "L-06167",
    "licenseIssueDate": "01/19/2024 00:00:00",
    "licenseExpiryDate": "01/18/2026 00:00:00"
  },
  {
    "id": "17ead4e9-91d5-418f-9692-6962b9811d4f",
    "slug": "sheeza-ahmed",
    "name": "SHEEZA AHMED ZIAUDDIN AHMED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sheeza Ahmed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_17ead4e9-91d5-418f-9692-6962b9811d4f",
        "address": "AG House- Building Num 581 ,Al Muteena, Dubai ,11169 ,",
        "phone": "97143257977 / 971507086100",
        "email": "sheeza@mandviwallaandzafar.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "8569b29e-bcb6-4ddd-90d8-c6b90718e267",
    "firmName": "Mandviwalla & Zafar Limited Liability Partnership",
    "registrationNumber": "L-00824",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "b1153fa3-4a82-42db-ba83-d9a8b0bf5888",
    "slug": "shehab-abdallah-mohamed-abdelrehem",
    "name": "SHEHAB ABDALLAH MOHAMED ABDELREHEM",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/04/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Shehab Abdallah Mohamed Abdelrehem",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b1153fa3-4a82-42db-ba83-d9a8b0bf5888",
        "address": "الطابق الثامن  ,برج الجرج 1 ,دائرة الاراضي و الاملاك  ,9117 ,Dubai",
        "phone": "97143320004",
        "email": "info@hlootahlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4ad67cb4-18b4-4417-9b6a-d23a9fb368fb",
    "firmName": "HUSSAIN LOOTAH & PARTNERS - ATTORNEYS & COUNSELLORS AT LAW",
    "registrationNumber": "L-05295",
    "licenseIssueDate": "04/12/2022 00:00:00",
    "licenseExpiryDate": "04/11/2026 00:00:00"
  },
  {
    "id": "4962a45d-8d90-493e-b75b-88b9bbf2831b",
    "slug": "shehab-mamdouh-abdelmohsen-abobaker-abdelmoteleb",
    "name": "SHEHAB MAMDOUH ABDELMOHSEN ABOBAKER ABDELMOTELEB",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Criminal Law-Crimes against persons"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/05/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Shehab Mamdouh Abdelmohsen Abobaker Abdelmoteleb",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4962a45d-8d90-493e-b75b-88b9bbf2831b",
        "address": "23 ,Rolex Tower ,Trade Center Second ,116637 ,Dubai",
        "phone": "97144357577 / 971502101003",
        "email": "jasamin.fichte@fichtelegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "77bf4fd2-1cd1-4bda-a0c2-ffcac3980b76",
    "firmName": "Fichte & Co Legal Consultancy",
    "registrationNumber": "L-03208",
    "licenseIssueDate": "05/26/2021 00:00:00",
    "licenseExpiryDate": "05/25/2026 00:00:00"
  },
  {
    "id": "bd3f192a-6330-41eb-b453-66192d645031",
    "slug": "sheila-shadmand",
    "name": "SHEILA LADAN SHADMAND",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sheila Shadmand",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bd3f192a-6330-41eb-b453-66192d645031",
        "address": "",
        "phone": "97147098484 / 971505577206",
        "email": "slshadmand@jonesday.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "8892bfe9-d3ec-4158-b4fd-1844606f4f30",
    "firmName": "Jones Day",
    "registrationNumber": "L-00946",
    "licenseIssueDate": "02/06/2012 00:00:00",
    "licenseExpiryDate": "01/28/2026 00:00:00"
  },
  {
    "id": "299405e0-536e-4dcb-855b-1d7944b27238",
    "slug": "shengyue-vicky-chen",
    "name": "SHENGYUE CHEN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTVgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/02/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Shengyue Vicky Chen",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_299405e0-536e-4dcb-855b-1d7944b27238",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-06213",
    "licenseIssueDate": "02/21/2024 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "d0d72f0e-84e0-47cd-8ef8-6602a29d7528",
    "slug": "sher-bostan-khan",
    "name": "SHER BOSTAN KHAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/07/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sher Bostan Khan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d0d72f0e-84e0-47cd-8ef8-6602a29d7528",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-05403",
    "licenseIssueDate": "07/18/2022 00:00:00",
    "licenseExpiryDate": "07/17/2026 00:00:00"
  },
  {
    "id": "6336dc46-0bd1-4488-a042-e319810a40e5",
    "slug": "sherief-abbas-hassan-hosny-rashed",
    "name": "SHERIEF ABBAS HASSAN HOSNY RASHED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/09/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sherief Abbas Hassan Hosny Rashed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6336dc46-0bd1-4488-a042-e319810a40e5",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-06965",
    "licenseIssueDate": "09/16/2025 00:00:00",
    "licenseExpiryDate": "09/15/2026 00:00:00"
  },
  {
    "id": "3823aac4-1d60-4465-bdea-7ff2097ba18b",
    "slug": "sherif-abdelrahman-mohamed-abdelrahman",
    "name": "SHERIF ABDELRAHMAN MOHAMED ABDELRAHMAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/09/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sherif Abdelrahman Mohamed Abdelrahman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3823aac4-1d60-4465-bdea-7ff2097ba18b",
        "address": "omar abdulazizi alomar ,15 ,prime tower ,blom bank france ,211940 ,Dubai",
        "phone": "97143808838 / 971504598082",
        "email": "omar.omar@oghlegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "171b4622-e4ec-4375-a9c4-3637bf6a8b17",
    "firmName": "ALOMAR & ALSABAH ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-01317",
    "licenseIssueDate": "09/26/2011 00:00:00",
    "licenseExpiryDate": "09/17/2026 00:00:00"
  },
  {
    "id": "b28ce0f3-b58d-4fae-9297-630ce240e0ad",
    "slug": "sherif-abdelrahmen-etman",
    "name": "SHERIF ABDELRAHMEN ABDELRAHMEN MOHAMED ETMAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sherif Abdelrahmen Etman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b28ce0f3-b58d-4fae-9297-630ce240e0ad",
        "address": "",
        "phone": "97143641686 / 971506288801",
        "email": "b.kadir@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0ba96df8-e4cc-49c2-8ae4-a42878d95926",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS LLC",
    "registrationNumber": "L-01316",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "b19e928b-ec1b-4943-bc5f-2d690cdd3ec4",
    "slug": "sherif-abdilmonem-mahmod-abeedo",
    "name": "SHERIF ABDILMONEM MAHMOD ABEEDO",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/10/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sherif Abdilmonem Mahmod Abeedo",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b19e928b-ec1b-4943-bc5f-2d690cdd3ec4",
        "address": "Alhajeya salem saeed alnoobi ,3rd  ,Al-hawai Tower  ,Behind financial center metro station  ,39779 ,Dubai",
        "phone": "97142963813",
        "email": "adv_aljazeera@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "f091b928-9e3d-4e24-b489-65ca31481366",
    "firmName": "AL HAJEYA ALNOOBI ADVOCATES AND LEGAL CONSULTANT",
    "registrationNumber": "L-05540",
    "licenseIssueDate": "10/12/2022 00:00:00",
    "licenseExpiryDate": "10/11/2025 00:00:00"
  },
  {
    "id": "105ebb92-96c0-44c8-b729-53c3d02b3d55",
    "slug": "sherif-hussein-othman",
    "name": "SHERIF HUSSEIN ABUZEID OTHMAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/10/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sherif Hussein Othman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_105ebb92-96c0-44c8-b729-53c3d02b3d55",
        "address": "الخامس ,الشعلة بلوك اية ,داناتا ,127179 ,Dubai",
        "phone": "97143318888 / 971509984724",
        "email": "ameizar@salamadvo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "1b4e6bd9-712b-49bf-a169-fd31ea45cd51",
    "firmName": "SALAM ADVOCATE  & LEGAL CONSULTANTS",
    "registrationNumber": "L-01742",
    "licenseIssueDate": "10/23/2012 00:00:00",
    "licenseExpiryDate": "10/15/2025 00:00:00"
  },
  {
    "id": "da77d460-9977-4f6d-923c-65ae491d10bb",
    "slug": "sherif-keshk",
    "name": "SHERIF TALAAT ELSAID MOHAMED KESHK",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/10/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sherif Keshk",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_da77d460-9977-4f6d-923c-65ae491d10bb",
        "address": "",
        "phone": "97142955575",
        "email": "info@yalhamed.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "af6ac730-58a7-44a4-9f60-78811de374c7",
    "firmName": "YASIN ALHAMED ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02957",
    "licenseIssueDate": "10/11/2016 00:00:00",
    "licenseExpiryDate": "10/07/2026 00:00:00"
  },
  {
    "id": "60730ba2-34d3-4ffd-aa8a-1352e6b1966f",
    "slug": "sherif-maher",
    "name": "SHERIF MAHER EL SAYED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/09/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sherif Maher",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_60730ba2-34d3-4ffd-aa8a-1352e6b1966f",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-01912",
    "licenseIssueDate": "09/26/2013 00:00:00",
    "licenseExpiryDate": "09/19/2026 00:00:00"
  },
  {
    "id": "edeb0c3f-c608-4b5f-b733-881f235ad403",
    "slug": "sherif-mamdouh-mahmoud-mohamed-ahmed-elagoz",
    "name": "SHERIF MAMDOUH MAHMOUD MOHAMED AHMED ELAGOZ",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Civil Transactions-Insurance",
      "Civil Transactions-Construction and Contracts for Services",
      "Civil Transactions-Ownership & Title",
      "Civil Transactions-HR & Employee Affairs",
      "Personal Status-Custody & Alimony",
      "Commercial Transactions-Commercial Contracts",
      "Civil Transactions-Tenancy",
      "Criminal Law-Crimes against persons",
      "Commercial Transactions-Commercial Companies",
      "Criminal Law-Drug Crimes",
      "Civil Transactions-Sale",
      "Personal Status-Marriage & Divorce",
      "Civil Transactions-Compensation",
      "Criminal Law-Crimes against properties",
      "Criminal Law-Cybercrimes",
      "Commercial Transactions-Intellectual Property (includes trademarks",
      "copy rights",
      "patents)"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/12/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sherif Mamdouh Mahmoud Mohamed Ahmed Elagoz",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_edeb0c3f-c608-4b5f-b733-881f235ad403",
        "address": "",
        "phone": "97143793798 / 971504407878",
        "email": "n.alawar@alawarlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0209756c-e854-4fa0-836a-abe019e9fcd0",
    "firmName": "NASSER ALAWAR ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06149",
    "licenseIssueDate": "12/14/2023 00:00:00",
    "licenseExpiryDate": "12/13/2025 00:00:00"
  },
  {
    "id": "8d2eee71-3f29-4b2b-9a15-c1dc71182679",
    "slug": "sherif-salem-mohamed-okasha",
    "name": "SHERIF SALEM MOHAMED OKASHA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/12/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sherif Salem Mohamed Okasha",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8d2eee71-3f29-4b2b-9a15-c1dc71182679",
        "address": "",
        "phone": "97143355577",
        "email": "daraladalah1991@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "61efd89c-1d0d-4136-8397-2814c745f0da",
    "firmName": "DAR AL ADALAH ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02036",
    "licenseIssueDate": "12/05/2011 00:00:00",
    "licenseExpiryDate": "11/26/2025 00:00:00"
  },
  {
    "id": "a6480b61-1c95-4a42-a10f-ae4cc9e2ff45",
    "slug": "sherif-samy-ayad-guirguis",
    "name": "SHERIF SAMY AYAD GUIRGUIS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/11/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sherif Samy Ayad Guirguis",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a6480b61-1c95-4a42-a10f-ae4cc9e2ff45",
        "address": "SAAD AL HAMMADI ,مدخل البرج ,ويست بيري ,برج خليفه ,41747 ,Dubai",
        "phone": "97142405222",
        "email": "info@saadpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "18923100-5b94-44e2-b580-2e3b0cc17bf6",
    "firmName": "SAAD AL HAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01955",
    "licenseIssueDate": "11/13/2011 00:00:00",
    "licenseExpiryDate": "11/03/2025 00:00:00"
  },
  {
    "id": "c0b7495a-7225-4d77-9dcc-87868b11ffbf",
    "slug": "shibani-kapur",
    "name": "SHIBANI KAPUR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/05/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Shibani Kapur",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c0b7495a-7225-4d77-9dcc-87868b11ffbf",
        "address": "",
        "phone": "97143897000 / 971506553198",
        "email": "nasseralikhasawneh@eversheds-sutherland.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "74a21d43-41d8-480a-a6af-6939b7c98a95",
    "firmName": "Eversheds Sutherland (International LLP) Dubai Branch",
    "registrationNumber": "L-04695",
    "licenseIssueDate": "05/21/2020 00:00:00",
    "licenseExpiryDate": "05/20/2026 00:00:00"
  },
  {
    "id": "6d61888e-ce14-4fb0-b0e4-f335959e444b",
    "slug": "shibeer-ahmed",
    "name": "SHIBEER AHMED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/09/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Shibeer Ahmed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6d61888e-ce14-4fb0-b0e4-f335959e444b",
        "address": "",
        "phone": "97145953601 / 971508728645",
        "email": "Steven.Bainbridge@gtlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b4146aa6-efd1-41d7-819d-49da46353b0b",
    "firmName": "Greenberg Traurig Limited",
    "registrationNumber": "L-02389",
    "licenseIssueDate": "09/28/2023 00:00:00",
    "licenseExpiryDate": "09/27/2026 00:00:00"
  },
  {
    "id": "b9b9528f-ffa6-471d-a7e6-c016be567bef",
    "slug": "shiladitya-majumdar",
    "name": "SHILADITYA MAJUMDAR SAIBAL MAJUMDAR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/04/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Shiladitya Majumdar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b9b9528f-ffa6-471d-a7e6-c016be567bef",
        "address": "",
        "phone": "97143025100 / 971501501837",
        "email": "ccairns@trowers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "976857f5-9092-43cf-987d-bfa794a3fa51",
    "firmName": "Trowers & Hamlins LLP",
    "registrationNumber": "L-04335",
    "licenseIssueDate": "04/16/2024 00:00:00",
    "licenseExpiryDate": "04/15/2026 00:00:00"
  },
  {
    "id": "ebee64fc-9170-47b0-84b4-92ee622ce83d",
    "slug": "shiraz-khan",
    "name": "SHIRAZ KHAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/04/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Shiraz Khan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ebee64fc-9170-47b0-84b4-92ee622ce83d",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03771",
    "licenseIssueDate": "04/02/2017 00:00:00",
    "licenseExpiryDate": "03/29/2026 00:00:00"
  },
  {
    "id": "52147815-0914-49d8-8326-fc3368ac32b0",
    "slug": "shiraz-sethi",
    "name": "SHIRAZ ZEYD SETHI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Shiraz Sethi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_52147815-0914-49d8-8326-fc3368ac32b0",
        "address": "",
        "phone": "97144020800 / 971566830829",
        "email": "dean.ryburn@dentons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dfe13b7e-6625-45fd-ad63-9ee83af41194",
    "firmName": "Dentons & Co Dubai Branch-DED",
    "registrationNumber": "L-01643",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "6fe69b44-b7ed-412c-804f-2755dee718b5",
    "slug": "shireen-fazal",
    "name": "SHIREEN FAZAL MASOOD FAZAL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Shireen Fazal",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6fe69b44-b7ed-412c-804f-2755dee718b5",
        "address": "Gamal Yassein Abdalla ,الطابق 13  Floor No 13 ,بناية مركز ابروي (The Oberoi Center) ,فندق ابروي (The Oberoi Hotel) ,33299 ,Dubai",
        "phone": "97142828000",
        "email": "litigation@alaidarous.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9a923766-1fd1-4e06-a871-89662120384e",
    "firmName": "AL AIDAROUS ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-01834",
    "licenseIssueDate": "02/19/2012 00:00:00",
    "licenseExpiryDate": "02/10/2026 00:00:00"
  },
  {
    "id": "aa2f3a62-1894-4a86-9e99-6f2564721afa",
    "slug": "shivani-shah-jagdish-rasiklal-shah",
    "name": "SHIVANI SHAH JAGDISH RASIKLAL SHAH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/08/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Shivani Shah Jagdish Rasiklal Shah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_aa2f3a62-1894-4a86-9e99-6f2564721afa",
        "address": "HAMDAN ALSHAMSI ,الطابق الرابع مكتب 401, 406,407 ,بي سكوير 01 ,مجمع دبي سكوير ,116564 ,Dubai",
        "phone": "97143469262",
        "email": "courts@has.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de2c61a6-9d00-457e-ad1d-e73e4e62d9bd",
    "firmName": "HAMDAN ALSHAMSI LAWYER & LEGAL CONSULTANTS",
    "registrationNumber": "L-06466",
    "licenseIssueDate": "08/21/2024 00:00:00",
    "licenseExpiryDate": "08/20/2026 00:00:00"
  },
  {
    "id": "b7a6faab-18dc-4c89-80ec-71c271dc07e1",
    "slug": "shruti-brockett",
    "name": "SHRUTI BROCKETT",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/05/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Shruti Brockett",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b7a6faab-18dc-4c89-80ec-71c271dc07e1",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-05344",
    "licenseIssueDate": "06/01/2022 00:00:00",
    "licenseExpiryDate": "05/31/2026 00:00:00"
  },
  {
    "id": "9b5f774b-8516-40c6-bf69-2832bd55d039",
    "slug": "shruti-singh-baghel",
    "name": "SHRUTI SINGH BAGHEL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/04/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Shruti Singh Baghel",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9b5f774b-8516-40c6-bf69-2832bd55d039",
        "address": "- ,Index Tower ,Dubai International Financial Centre ,9371 ,Dubai",
        "phone": "97143303900 / 971561753537",
        "email": "christopher@afridi-angell.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3e464dc8-b800-4ba2-ad91-24a5f9640fef",
    "firmName": "Afridi & Angell-DIFC",
    "registrationNumber": "L-06766",
    "licenseIssueDate": "04/30/2025 00:00:00",
    "licenseExpiryDate": "04/29/2026 00:00:00"
  },
  {
    "id": "f120ce8e-ebf2-4749-a400-dac42a2306af",
    "slug": "shweta-padmanabhan-ramasubramanian-padmanabhan",
    "name": "SHWETA PADMANABHAN S SURYANARAYANAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/10/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Shweta Padmanabhan Ramasubramanian Padmanabhan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f120ce8e-ebf2-4749-a400-dac42a2306af",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506688 ,Dubai",
        "phone": "97147096600 / 971503556811",
        "email": "muneer.khan@simmons-simmons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d1725ca7-06ac-41b2-8d7b-a6e60665b73d",
    "firmName": "Simmons & Simmons (Middle East) LLP-DIFC",
    "registrationNumber": "L-06564",
    "licenseIssueDate": "10/18/2024 00:00:00",
    "licenseExpiryDate": "10/17/2026 00:00:00"
  },
  {
    "id": "3d71c507-abcb-435a-a132-fc1e7b637c7b",
    "slug": "shwini-elin-dsouza-eric-dsouza",
    "name": "SHWINI ELIN DSOUZA ERIC DSOUZA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/03/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Shwini Elin Dsouza Eric Dsouza",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3d71c507-abcb-435a-a132-fc1e7b637c7b",
        "address": "",
        "phone": "97144073901 / 971503479508",
        "email": "Rania.Tadros@stephensonharwood.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dd5042a2-bb41-4123-9544-79c3fa831332",
    "firmName": "Stephenson Harwood (Middle East) LLP",
    "registrationNumber": "L-06726",
    "licenseIssueDate": "03/26/2025 00:00:00",
    "licenseExpiryDate": "03/25/2026 00:00:00"
  },
  {
    "id": "85a75fe8-77c0-43d8-8551-31795d9957b2",
    "slug": "shyam-ashwin-kotadia",
    "name": "SHYAM ASHWIN KOTADIA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/05/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Shyam Ashwin Kotadia",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_85a75fe8-77c0-43d8-8551-31795d9957b2",
        "address": "ICD Brookfield Place ,Za'abeel 2 ,103747 ,",
        "phone": "97143696300 / 971506008159",
        "email": "mohammed.paracha@nortonrosefulbright.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c4aaee93-0ec4-4982-9a48-a23699492056",
    "firmName": "Norton Rose Fullbright (Middle East) LLP",
    "registrationNumber": "L-05788",
    "licenseIssueDate": "05/11/2023 00:00:00",
    "licenseExpiryDate": "05/10/2026 00:00:00"
  },
  {
    "id": "1a911644-67b4-47f9-95b9-6220142671b1",
    "slug": "shyamal-jeewoolall",
    "name": "SHYAMAL KUMAR REETOO JEEWOOLALL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/01/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Shyamal Jeewoolall",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1a911644-67b4-47f9-95b9-6220142671b1",
        "address": "",
        "phone": "97144230555 / 971504788443",
        "email": "yah@hfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c462c65e-185a-4e81-8425-a87e3a2b6842",
    "firmName": "Holman Fenwick Willan Middle East LLP",
    "registrationNumber": "L-03311",
    "licenseIssueDate": "01/13/2016 00:00:00",
    "licenseExpiryDate": "01/08/2026 00:00:00"
  },
  {
    "id": "6921d8a6-fbbf-4293-85e2-d876241aadfa",
    "slug": "sibusiso-roderick-ngwila",
    "name": "SIBUSISO RODERICK NGWILA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/03/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sibusiso Roderick Ngwila",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6921d8a6-fbbf-4293-85e2-d876241aadfa",
        "address": "ICD-Brookfield Place ,DIFC ,119974 ,",
        "phone": "97143652000",
        "email": "david.charlier@ashurst.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c01c3c61-4d90-4058-8429-61dd01e615f5",
    "firmName": "Ashurst LLP-DIFC",
    "registrationNumber": "L-06728",
    "licenseIssueDate": "03/26/2025 00:00:00",
    "licenseExpiryDate": "03/25/2026 00:00:00"
  },
  {
    "id": "0ad8a252-1647-4b42-b196-3e7e8450256d",
    "slug": "sidanth-rajagopal",
    "name": "SIDANTH RAJAGOPAL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/07/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sidanth Rajagopal",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0ad8a252-1647-4b42-b196-3e7e8450256d",
        "address": "",
        "phone": "97143121800 / 971566017967",
        "email": "alishia.sullivan@morganlewis.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6eab20d7-8716-4b0a-8710-144d1d951c23",
    "firmName": "Morgan, Lewis & Bockius LLP (dubai Branch)",
    "registrationNumber": "L-01876",
    "licenseIssueDate": "07/04/2019 00:00:00",
    "licenseExpiryDate": "07/03/2026 00:00:00"
  },
  {
    "id": "35be0e95-3f73-4022-930f-7e3571b69a43",
    "slug": "sik-kin-to",
    "name": "SIK KIN TO",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/07/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: SIK KIN TO",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_35be0e95-3f73-4022-930f-7e3571b69a43",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-06418",
    "licenseIssueDate": "07/24/2024 00:00:00",
    "licenseExpiryDate": "07/23/2026 00:00:00"
  },
  {
    "id": "72cf14db-73a3-4169-b06d-e2ad9fc56ca7",
    "slug": "sima-al-baterni",
    "name": "SIMA M ZAHED AL BATERNI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/04/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sima Al Baterni",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_72cf14db-73a3-4169-b06d-e2ad9fc56ca7",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-04899",
    "licenseIssueDate": "04/12/2021 00:00:00",
    "licenseExpiryDate": "04/11/2026 00:00:00"
  },
  {
    "id": "d57004a4-f125-45f6-831e-c23acb05c96e",
    "slug": "simon-andrew-gamboni",
    "name": "SIMON ANDREW GAMBONI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/02/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Simon Andrew Gamboni",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d57004a4-f125-45f6-831e-c23acb05c96e",
        "address": "",
        "phone": "97144230555 / 971504788443",
        "email": "yah@hfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c462c65e-185a-4e81-8425-a87e3a2b6842",
    "firmName": "Holman Fenwick Willan Middle East LLP",
    "registrationNumber": "L-03982",
    "licenseIssueDate": "02/04/2018 00:00:00",
    "licenseExpiryDate": "02/01/2026 00:00:00"
  },
  {
    "id": "f96c417a-2631-4fe4-8367-5e6bfae7ee7c",
    "slug": "simon-clive-elliott",
    "name": "SIMON CLIVE ELLIOTT",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/03/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Simon Clive Elliott",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f96c417a-2631-4fe4-8367-5e6bfae7ee7c",
        "address": "Level 17, ICD Brookfield Place ,DIFC ,506503 ,",
        "phone": "97144375100 / 971588271196",
        "email": "libby.edwards-smith@gowlingwlg.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "436703ba-b9c0-4dcb-93b2-1299c7a051f4",
    "firmName": "Gowling WLG (UK) LLP (Dubai Branch)",
    "registrationNumber": "L-04044",
    "licenseIssueDate": "03/22/2018 00:00:00",
    "licenseExpiryDate": "03/19/2026 00:00:00"
  },
  {
    "id": "905d6457-d740-4126-b114-f575780acafc",
    "slug": "simon-edwin-bowshell-green",
    "name": "SIMON EDWIN BOWSHELL GREEN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/01/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Simon Edwin Bowshell Green",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_905d6457-d740-4126-b114-f575780acafc",
        "address": "20 ,Index Tower West Tower ,DIFC ,507226 ,Dubai",
        "phone": "97142461900 / 971523391604",
        "email": "patrick.gearon@crsblaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "e2ac552e-b9a7-450b-a84d-15119e583220",
    "firmName": "Charles Russell Speechlys LLP",
    "registrationNumber": "L-04004",
    "licenseIssueDate": "01/18/2018 00:00:00",
    "licenseExpiryDate": "01/15/2026 00:00:00"
  },
  {
    "id": "4b2fc0cc-f28c-403d-a703-3ae0dcefa3e1",
    "slug": "simon-isgar",
    "name": "SIMON PETER DENIS ISGAR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/12/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Simon Isgar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4b2fc0cc-f28c-403d-a703-3ae0dcefa3e1",
        "address": "الطابق 7 مكتب رقم 070A ,برج رولكس  ,محطة مترو المركز المالي  ,66300 ,Dubai",
        "phone": "97143444029",
        "email": "ekp.khalidaltmimi@ekplegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "400838f1-4e75-4836-9698-b9e19dd30a18",
    "firmName": "KHALID ABDALLA ALTAMIMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-00688",
    "licenseIssueDate": "12/16/2011 00:00:00",
    "licenseExpiryDate": "12/07/2025 00:00:00"
  },
  {
    "id": "1a5d45e3-2184-4780-8ae6-bd5932728f50",
    "slug": "simon-john-shooter",
    "name": "SIMON JOHN SHOOTER",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/02/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Simon John Shooter",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1a5d45e3-2184-4780-8ae6-bd5932728f50",
        "address": "",
        "phone": "97143093222 / 971566651954",
        "email": "melissa.murray@twobirds.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3e1526e6-4c8d-4b6f-985f-ea05e9f99bcb",
    "firmName": "Bird & Bird (MEA) LLP",
    "registrationNumber": "L-06227",
    "licenseIssueDate": "02/21/2024 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "8f5859d5-0e75-4342-a4e5-6ab6da113791",
    "slug": "simon-nicholas-lamb",
    "name": "SIMON NICHOLAS LAMB",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/05/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Simon Nicholas Lamb",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8f5859d5-0e75-4342-a4e5-6ab6da113791",
        "address": "ICD Brookfield Place ,Za'abeel 2 ,103747 ,",
        "phone": "97143696300 / 971506008159",
        "email": "mohammed.paracha@nortonrosefulbright.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c4aaee93-0ec4-4982-9a48-a23699492056",
    "firmName": "Norton Rose Fullbright (Middle East) LLP",
    "registrationNumber": "L-06303",
    "licenseIssueDate": "05/08/2024 00:00:00",
    "licenseExpiryDate": "05/07/2026 00:00:00"
  },
  {
    "id": "cc52ed59-0a6e-4ce5-ab57-2541a6465bcb",
    "slug": "simon-roderick",
    "name": "SIMON JOHN RODERICK",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Simon Roderick",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cc52ed59-0a6e-4ce5-ab57-2541a6465bcb",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-00249",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "61262629-246a-4cf9-a614-df14a7617c9b",
    "slug": "simona-spazzini",
    "name": "SIMONA SPAZZINI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/10/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Simona Spazzini",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_61262629-246a-4cf9-a614-df14a7617c9b",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-05535",
    "licenseIssueDate": "10/05/2022 00:00:00",
    "licenseExpiryDate": "10/04/2026 00:00:00"
  },
  {
    "id": "e82e7eb0-1e5e-4388-821a-cc2b1e9226b8",
    "slug": "simran-basra",
    "name": "SIMRAN BASRA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Commercial Contracts"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/04/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Simran Basra",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e82e7eb0-1e5e-4388-821a-cc2b1e9226b8",
        "address": "",
        "phone": "97144363636 / 971505572900",
        "email": "hassan.elsayed@bakerbotts.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "fd5d6571-d053-4436-9de5-c8a36ce7c6c9",
    "firmName": "Baker Botts LLP Legal Consultants Dubai Branch",
    "registrationNumber": "L-06755",
    "licenseIssueDate": "04/23/2025 00:00:00",
    "licenseExpiryDate": "04/22/2026 00:00:00"
  },
  {
    "id": "25ecb704-f348-449a-819e-965bea5f2f49",
    "slug": "sinan-amso",
    "name": "SINAN AMSO",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/11/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sinan Amso",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_25ecb704-f348-449a-819e-965bea5f2f49",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-05590",
    "licenseIssueDate": "11/02/2022 00:00:00",
    "licenseExpiryDate": "11/01/2026 00:00:00"
  },
  {
    "id": "62808ceb-a7fb-4b76-b766-e790659e22b2",
    "slug": "siobhain-corr",
    "name": "Siobhain Corr",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/31/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Siobhain Corr",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_62808ceb-a7fb-4b76-b766-e790659e22b2",
        "address": "ICD Brookfield Place ,Za'abeel 2 ,103747 ,",
        "phone": "97143696300 / 971506008159",
        "email": "mohammed.paracha@nortonrosefulbright.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c4aaee93-0ec4-4982-9a48-a23699492056",
    "firmName": "Norton Rose Fullbright (Middle East) LLP",
    "registrationNumber": "L-06343",
    "licenseIssueDate": "05/31/2024 00:00:00",
    "licenseExpiryDate": "05/30/2026 00:00:00"
  },
  {
    "id": "4237023e-5a11-425c-a42d-85a80d967ec9",
    "slug": "sirajuddin-ahmed",
    "name": "SIRAJUDDIN AHMED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sirajuddin Ahmed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4237023e-5a11-425c-a42d-85a80d967ec9",
        "address": "Mohamed Alhammadi ,FLOOR 16 OFFICE B1605 ,LATIFA TOWER ,CLOSE TO CROWN PLAZA HOTEL ,76550 ,Dubai",
        "phone": "97143298866",
        "email": "admin@dralhammadilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "612e75e6-c3f3-479b-bc93-ee88982dea58",
    "firmName": "DR MOHAMED ALHAMMADI ADVOCATES & LEGAL CONSULTANTS OFFICE",
    "registrationNumber": "L-01429",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "5ce30b73-8386-45ae-93f2-1515e8524eae",
    "slug": "sleiman-joseph-el-jorr",
    "name": "SLEIMAN JOSEPH EL JORR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/10/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sleiman Joseph El Jorr",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5ce30b73-8386-45ae-93f2-1515e8524eae",
        "address": "21 ,Rolex Tower ,Emirates Grand Hotel ,94334 ,Dubai",
        "phone": "97143277772 / 97145584900",
        "email": "info@globaladvocates.net",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9b42810f-1d55-4aea-ac4a-7d9d1b25ac08",
    "firmName": "GLOBAL ADVOCACY & LEGAL COUNSEL",
    "registrationNumber": "L-01751",
    "licenseIssueDate": "10/11/2011 00:00:00",
    "licenseExpiryDate": "10/02/2026 00:00:00"
  },
  {
    "id": "445dbacf-7158-4958-9e50-89fcfc8bcd3e",
    "slug": "sleiman-lebbos",
    "name": "Sleiman Lebbos",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/04/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-04-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sleiman Lebbos",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_445dbacf-7158-4958-9e50-89fcfc8bcd3e",
        "address": "السادس - مكتب 604 ,الوصل بيزنس سنتر - مبنى رقم R549 ,بنك مصر ,2079 ,Dubai",
        "phone": "97143961112",
        "email": "reception@rslawfirm.org",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "33654f3d-b8f9-48ad-bbba-42847367b511",
    "firmName": "RASHED AL SHEHHI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04386",
    "licenseIssueDate": "04/18/2019 00:00:00",
    "licenseExpiryDate": "04/17/2020 00:00:00"
  },
  {
    "id": "a1718b3e-b242-4ff1-98e5-72ac9146526c",
    "slug": "slimon-rahimzada",
    "name": "SLIMON RAHIMZADA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/08/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Slimon  Rahimzada",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a1718b3e-b242-4ff1-98e5-72ac9146526c",
        "address": "ICD-Brookfield Place ,DIFC ,119974 ,",
        "phone": "97143652000",
        "email": "david.charlier@ashurst.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c01c3c61-4d90-4058-8429-61dd01e615f5",
    "firmName": "Ashurst LLP-DIFC",
    "registrationNumber": "L-05834",
    "licenseIssueDate": "08/02/2023 00:00:00",
    "licenseExpiryDate": "08/01/2026 00:00:00"
  },
  {
    "id": "7cc02958-eede-4458-a24d-11cdb7cd64a3",
    "slug": "smail-houidi",
    "name": "Smail Houidi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/09/2023",
    "licenseStatus": "active",
    "licenseExpiry": "2024-09-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Smail Houidi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7cc02958-eede-4458-a24d-11cdb7cd64a3",
        "address": "ICD Brookfield Place ,DIFC ,120109 ,",
        "phone": "97143173000 / 971504465229",
        "email": "DubaiLAD@akingump.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9ff29eab-adb8-40f9-ab84-216e01a381e4",
    "firmName": "Akin Gump Strauss Hauer & Feld LLP",
    "registrationNumber": "L-06002",
    "licenseIssueDate": "09/05/2023 00:00:00",
    "licenseExpiryDate": "09/04/2025 00:00:00"
  },
  {
    "id": "74f64a9c-3695-4939-8645-d149aab5007b",
    "slug": "smko-adham",
    "name": "SMKO ASAAD ADHAM ADHAM",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Smko Adham",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_74f64a9c-3695-4939-8645-d149aab5007b",
        "address": "الثاني ,الفجر للاعمال  ,مركز القرهود للياقة الطبية - مستشفى القرهود  ,15105 ,Dubai",
        "phone": "97142222800",
        "email": "info@almudharreb.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "806f31e8-0ed0-40a1-9d26-ef999012f7ed",
    "firmName": "AL MUDHARREB & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02023",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/21/2019 00:00:00"
  },
  {
    "id": "307ed5dc-12ea-4527-a831-f37352cd0ebb",
    "slug": "smriti-ganotra-radhey-shyam",
    "name": "SMRITI GANOTRA RADHEY SHYAM",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/01/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: smriti ganotra radhey shyam",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_307ed5dc-12ea-4527-a831-f37352cd0ebb",
        "address": "othman almarzooqi ,19th ,single business tower ,samaya tower ,114333 ,Dubai",
        "phone": "97142999970 / 971500000000",
        "email": "info@othmanadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a0cdd94d-cc5a-4617-b6a3-b23deb9852d5",
    "firmName": "OTHMAN ALMARZOOQI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06635",
    "licenseIssueDate": "01/03/2025 00:00:00",
    "licenseExpiryDate": "01/02/2026 00:00:00"
  },
  {
    "id": "b010d808-56e4-42af-ad2b-4148baa455a6",
    "slug": "sofian-dhifallah",
    "name": "Sofian Dhifallah",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/18/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sofian Dhifallah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b010d808-56e4-42af-ad2b-4148baa455a6",
        "address": "",
        "phone": "/ 971000000000",
        "email": "tthesing@sidley.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "32091971-c716-41d1-a21d-cc50c9fb3214",
    "firmName": "Sidley Austin LLP",
    "registrationNumber": "L-05424",
    "licenseIssueDate": "07/18/2022 00:00:00",
    "licenseExpiryDate": "07/17/2026 00:00:00"
  },
  {
    "id": "271bdcb5-8fa0-4cde-b51d-da2c9b038c69",
    "slug": "somar",
    "name": "somar",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/22/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2024-02-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: somar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_271bdcb5-8fa0-4cde-b51d-da2c9b038c69",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-103994x0",
    "licenseIssueDate": "01/22/2018 00:00:00",
    "licenseExpiryDate": "11/02/2024 00:00:00"
  },
  {
    "id": "2ece5f6a-ec2c-44d8-a4c5-3061d0282c66",
    "slug": "somesha-k-ferdinand",
    "name": "SOMESHA K FERDINAND",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/06/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Somesha K Ferdinand",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2ece5f6a-ec2c-44d8-a4c5-3061d0282c66",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-06853",
    "licenseIssueDate": "06/11/2025 00:00:00",
    "licenseExpiryDate": "06/10/2026 00:00:00"
  },
  {
    "id": "b1f3ecd9-e3ab-4f4b-809b-09b5de12f81b",
    "slug": "somya-priyadarshini-mithliesh-kumar",
    "name": "Somya Priyadarshini Mithliesh Kumar",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/11/2023",
    "licenseStatus": "active",
    "licenseExpiry": "2024-11-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Somya Priyadarshini Mithliesh Kumar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b1f3ecd9-e3ab-4f4b-809b-09b5de12f81b",
        "address": "amal albastaki ,1903 ,court ,business bay ,127477 ,Dubai",
        "phone": "97142522202",
        "email": "info@amaladvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "f852bccd-2696-4190-9b40-77a8fb9c460f",
    "firmName": "AMAL ALBASTAKI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-06087",
    "licenseIssueDate": "11/22/2023 00:00:00",
    "licenseExpiryDate": "11/21/2025 00:00:00"
  },
  {
    "id": "932e501b-63db-4f3a-95de-5e71cf9d2ebc",
    "slug": "sonal-dingri",
    "name": "SONAL DINGRI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/08/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sonal Dingri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_932e501b-63db-4f3a-95de-5e71cf9d2ebc",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-05447",
    "licenseIssueDate": "08/17/2022 00:00:00",
    "licenseExpiryDate": "08/16/2026 00:00:00"
  },
  {
    "id": "00a5a929-c12e-401a-ad1d-7dc5c8c97e0e",
    "slug": "sonia-guimaraes-bessa",
    "name": "SONIA GUIMARAES BESSA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/06/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sonia Guimaraes Bessa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_00a5a929-c12e-401a-ad1d-7dc5c8c97e0e",
        "address": "",
        "phone": "97143303900 / 971561753537",
        "email": "christopher@afridi-angell.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "30ce50dc-01a6-499d-8ace-3f807ddcb08d",
    "firmName": "Afridi & Angell-DED",
    "registrationNumber": "L-04126",
    "licenseIssueDate": "06/06/2018 00:00:00",
    "licenseExpiryDate": "06/04/2026 00:00:00"
  },
  {
    "id": "869fb0b4-8c35-4307-b068-ec33591895e2",
    "slug": "sonia-rahman",
    "name": "SONIA ABDUL RAHMAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/09/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sonia Rahman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_869fb0b4-8c35-4307-b068-ec33591895e2",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-01141",
    "licenseIssueDate": "09/11/2012 00:00:00",
    "licenseExpiryDate": "09/04/2026 00:00:00"
  },
  {
    "id": "0f490786-092d-4b39-b7f7-b99e11ab794c",
    "slug": "sonya-bhalla",
    "name": "Sonya Bhalla",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/07/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sonya Bhalla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0f490786-092d-4b39-b7f7-b99e11ab794c",
        "address": "IH-00-01-CP-05 ,DIFC ,506832 ,",
        "phone": "/ 971506957753",
        "email": "admin@supportlegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "1607c199-ca4b-4bc1-89e9-98dad0300645",
    "firmName": "Support Legal ( DIFC) Limited",
    "registrationNumber": "L-04823",
    "licenseIssueDate": "01/07/2021 00:00:00",
    "licenseExpiryDate": "01/06/2026 00:00:00"
  },
  {
    "id": "025c0eb4-6984-4b5d-9025-f9d3eee374b6",
    "slug": "sophia-khursheed-niazi",
    "name": "SOPHIA KHURSHEED NIAZI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/10/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sophia Khursheed Niazi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_025c0eb4-6984-4b5d-9025-f9d3eee374b6",
        "address": "One Central, The Offices 5 ,Dubai World Trade Centre ,554660 ,",
        "phone": "97142052030 / 971506566494",
        "email": "chourani@houranipartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "59a73632-40a0-4849-b120-4308dc6f8015",
    "firmName": "Hourani & Partners Legal Consultancy FZCO",
    "registrationNumber": "L-05090",
    "licenseIssueDate": "10/25/2021 00:00:00",
    "licenseExpiryDate": "10/24/2025 00:00:00"
  },
  {
    "id": "c119f3a3-911b-4705-908a-02824156fa7a",
    "slug": "sophia-maria-theresa-cafoor-camps",
    "name": "SOPHIA MARIA THERESA CAFOOR CAMPS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/10/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sophia Maria Theresa Cafoor Camps",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c119f3a3-911b-4705-908a-02824156fa7a",
        "address": "",
        "phone": "97143779900 / 971508548052",
        "email": "jali@kslaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dff8529a-82be-431a-b72b-0192ff238011",
    "firmName": "King & Spalding LLP",
    "registrationNumber": "L-04798",
    "licenseIssueDate": "10/30/2023 00:00:00",
    "licenseExpiryDate": "10/29/2025 00:00:00"
  },
  {
    "id": "f602ce33-ffde-4ef9-ba0a-6e140aa9c649",
    "slug": "sophia-suleman",
    "name": "SOPHIA SULEMAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/04/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sophia Suleman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f602ce33-ffde-4ef9-ba0a-6e140aa9c649",
        "address": "1 ,ICD Brookfield Place ,Dubai International Financial Centre ,9267 ,Dubai",
        "phone": "97147010975 / 971502977062",
        "email": "chris.sioufi@ae.ey.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "42e536ef-e3d8-4339-8572-657a7f7a0331",
    "firmName": "EY Law LLP",
    "registrationNumber": "L-05734",
    "licenseIssueDate": "04/02/2024 00:00:00",
    "licenseExpiryDate": "04/01/2026 00:00:00"
  },
  {
    "id": "38d204ea-c9c9-4901-ae38-c388165f3b6a",
    "slug": "sophie-elizabeth-larsen",
    "name": "SOPHIE ELIZABETH LARSEN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/10/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sophie Elizabeth Larsen",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_38d204ea-c9c9-4901-ae38-c388165f3b6a",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-05065",
    "licenseIssueDate": "10/11/2021 00:00:00",
    "licenseExpiryDate": "10/10/2026 00:00:00"
  },
  {
    "id": "781b196d-5522-4d78-9973-f0ab7451a97b",
    "slug": "sophie-jade-bradstreet",
    "name": "SOPHIE JADE BRADSTREET",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/01/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sophie Jade Bradstreet",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_781b196d-5522-4d78-9973-f0ab7451a97b",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-05143",
    "licenseIssueDate": "02/01/2022 00:00:00",
    "licenseExpiryDate": "01/31/2026 00:00:00"
  },
  {
    "id": "b56d1a18-aece-4557-b5c2-a342241c41c1",
    "slug": "sophie-nicole-kassis",
    "name": "SOPHIE NICOLE KASSIS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/06/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sophie Nicole Kassis",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b56d1a18-aece-4557-b5c2-a342241c41c1",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-04949",
    "licenseIssueDate": "06/07/2021 00:00:00",
    "licenseExpiryDate": "06/06/2026 00:00:00"
  },
  {
    "id": "4309886a-9903-4860-85f1-0018fa6459ae",
    "slug": "sourabh-bhattacharya-anirudhya-bhattacharya",
    "name": "SOURABH BHATTACHARYA ANIRUDHYA BHATTACHARYA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/06/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sourabh Bhattacharya Anirudhya Bhattacharya",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4309886a-9903-4860-85f1-0018fa6459ae",
        "address": "",
        "phone": "97143121800 / 971566017967",
        "email": "alishia.sullivan@morganlewis.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6eab20d7-8716-4b0a-8710-144d1d951c23",
    "firmName": "Morgan, Lewis & Bockius LLP (dubai Branch)",
    "registrationNumber": "L-04967",
    "licenseIssueDate": "06/21/2021 00:00:00",
    "licenseExpiryDate": "06/20/2026 00:00:00"
  },
  {
    "id": "85dec304-43a6-470c-8177-107be399d85b",
    "slug": "sowmia-geo-thomas",
    "name": "SOWMIA THOMAS PLACKAL ANTHONY THOMAS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sowmia Geo Thomas",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_85dec304-43a6-470c-8177-107be399d85b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-02325",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/21/2020 00:00:00"
  },
  {
    "id": "b3dfd7ae-2be2-4e90-9c07-dd80a059f2ef",
    "slug": "sreehari-velayudhan-vadukumchery",
    "name": "SREEHARI VELAYUDHAN VADUKUMCHERY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTVgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sreehari Velayudhan Vadukumchery",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b3dfd7ae-2be2-4e90-9c07-dd80a059f2ef",
        "address": "1201 ,برج تريو اي بي اي اوفيس  ,فندق نوافتيل ,8812 ,Dubai",
        "phone": "97144222555",
        "email": "lutfilaw2020@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9a3d884b-a443-4037-9eb4-f810c596cf33",
    "firmName": "LUTFI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02181",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "1b852d74-4595-4b00-a3aa-3f7f1104a74d",
    "slug": "stanislav-gordeev",
    "name": "STANISLAV GORDEEV",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/08/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Stanislav Gordeev",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1b852d74-4595-4b00-a3aa-3f7f1104a74d",
        "address": "الثاني 201 ,مركز البخيت ,بالقرب من مركز القبائل للتخفيضات ,12020 ,Dubai",
        "phone": "97142664411",
        "email": "redhalaw@eim.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ba85e0f4-24ae-4065-9d96-7392f96f75fe",
    "firmName": "AL REDHA & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05026",
    "licenseIssueDate": "08/30/2021 00:00:00",
    "licenseExpiryDate": "08/29/2026 00:00:00"
  },
  {
    "id": "28c16da6-c451-4736-af5a-fe4d2c0b9349",
    "slug": "stanley-andrew-lee-schama",
    "name": "STANLEY ANDREW LEE SCHAMA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/07/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Stanley Andrew Lee Schama",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_28c16da6-c451-4736-af5a-fe4d2c0b9349",
        "address": "- ,Index Tower ,Dubai International Financial Centre ,9371 ,Dubai",
        "phone": "97143303900 / 971561753537",
        "email": "christopher@afridi-angell.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3e464dc8-b800-4ba2-ad91-24a5f9640fef",
    "firmName": "Afridi & Angell-DIFC",
    "registrationNumber": "L-05916",
    "licenseIssueDate": "07/19/2023 00:00:00",
    "licenseExpiryDate": "07/18/2026 00:00:00"
  },
  {
    "id": "5e76c9a4-2bec-4ac3-8612-c322ec6cef6e",
    "slug": "stefan-pislevik",
    "name": "STEFAN PISLEVIK",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/11/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Stefan Pislevik",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5e76c9a4-2bec-4ac3-8612-c322ec6cef6e",
        "address": "0 ,ICD Brookfield Place Level 13 ,Trade Centre ,506569 ,Dubai",
        "phone": "97145099100 / 971501006965",
        "email": "menahr@freshfields.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "970f6246-e737-41a7-9c6c-5aa5b8335d45",
    "firmName": "Freshfields LLP DIFC",
    "registrationNumber": "L-04808",
    "licenseIssueDate": "11/26/2020 00:00:00",
    "licenseExpiryDate": "11/25/2025 00:00:00"
  },
  {
    "id": "7e0a5171-69fc-4425-a7b0-d0ecc2df266e",
    "slug": "stefano-giovannini",
    "name": "Stefano Giovannini",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/08/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Stefano Giovannini",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7e0a5171-69fc-4425-a7b0-d0ecc2df266e",
        "address": "5 ,AL SUAIDI ,AL MARARR ,506803 ,Dubai",
        "phone": "97148283966 / 971502473435",
        "email": "info@difranciafirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0deeb936-18fc-456c-97dc-2e1cce547c2d",
    "firmName": "Di Francia Law Firm (Dubai Branch)",
    "registrationNumber": "L-01032",
    "licenseIssueDate": "10/08/2013 00:00:00",
    "licenseExpiryDate": "10/01/2025 00:00:00"
  },
  {
    "id": "8b3aeb1f-a1ea-4f35-b3b6-8f35d69aa89b",
    "slug": "stella-hae-won-kim",
    "name": "STELLA HAE WON KIM",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/05/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: STELLA HAE WON KIM",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8b3aeb1f-a1ea-4f35-b3b6-8f35d69aa89b",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-06792",
    "licenseIssueDate": "05/14/2025 00:00:00",
    "licenseExpiryDate": "05/13/2026 00:00:00"
  },
  {
    "id": "0095f559-aaab-4a48-99c1-53cc961c17cf",
    "slug": "stephanie-ann-stewart",
    "name": "STEPHANIE ANN STEWART",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/03/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: STEPHANIE ANN STEWART",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0095f559-aaab-4a48-99c1-53cc961c17cf",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-06252",
    "licenseIssueDate": "03/12/2024 00:00:00",
    "licenseExpiryDate": "03/11/2026 00:00:00"
  },
  {
    "id": "59c06900-b196-4537-ae71-7fe082d164d7",
    "slug": "stephanie-beatrice-nasnas",
    "name": "STEPHANIE BEATRICE NASNAS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/09/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Stephanie Beatrice Nasnas",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_59c06900-b196-4537-ae71-7fe082d164d7",
        "address": "NA ,Park Lane Tower ,NA ,119974 ,Dubai",
        "phone": "97143652000 / 971504515630",
        "email": "david.charlier@ashurst.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "af016ea4-05d8-4845-9d38-b95de499a172",
    "firmName": "Ashurst LLP Legal Consultants Dubai Branch-DED",
    "registrationNumber": "L-06935",
    "licenseIssueDate": "08/18/2025 00:00:00",
    "licenseExpiryDate": "08/17/2026 00:00:00"
  },
  {
    "id": "aeb7422d-5a41-466b-9cb2-9c15e16e025d",
    "slug": "stephanie-charlotte-hawes",
    "name": "STEPHANIE FULLER",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/01/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Stephanie Charlotte Hawes",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_aeb7422d-5a41-466b-9cb2-9c15e16e025d",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506698 ,Dubai",
        "phone": "97147046300 / 971507900661",
        "email": "nada.mourad@lw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b2b92ce9-90a4-4e34-ae2f-ae0dc7ca9060",
    "firmName": "Latham & Watkins LLP",
    "registrationNumber": "L-04208",
    "licenseIssueDate": "01/16/2025 00:00:00",
    "licenseExpiryDate": "01/15/2026 00:00:00"
  },
  {
    "id": "049235fc-91e1-4e74-a11e-096f9305a049",
    "slug": "stephanie-elizabeth-melone",
    "name": "STEPHANIE ELIZABETH MELONE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/05/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Stephanie Elizabeth Melone",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_049235fc-91e1-4e74-a11e-096f9305a049",
        "address": "",
        "phone": "97143742800 / 971506450677",
        "email": "jabbott21@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7a59d310-ff72-4318-b41c-27095c163d0f",
    "firmName": "CMS (UAE) LLP",
    "registrationNumber": "L-06328",
    "licenseIssueDate": "05/22/2024 00:00:00",
    "licenseExpiryDate": "05/21/2026 00:00:00"
  },
  {
    "id": "695b2e5b-6b60-41fd-a825-483db64497d4",
    "slug": "stephanie-nazareth",
    "name": "STEPHANIE NAZARETH GEORGE NAZARETH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/07/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Stephanie Nazareth",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_695b2e5b-6b60-41fd-a825-483db64497d4",
        "address": "- ,Index Tower ,Dubai International Financial Centre ,9371 ,Dubai",
        "phone": "97143303900 / 971561753537",
        "email": "christopher@afridi-angell.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3e464dc8-b800-4ba2-ad91-24a5f9640fef",
    "firmName": "Afridi & Angell-DIFC",
    "registrationNumber": "L-05898",
    "licenseIssueDate": "07/19/2023 00:00:00",
    "licenseExpiryDate": "07/18/2026 00:00:00"
  },
  {
    "id": "cb7403f4-1fa2-43ac-b4fe-642f05eae748",
    "slug": "stephanie-samuell",
    "name": "STEPHANIE SUSAN REES",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/10/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Stephanie Samuell",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cb7403f4-1fa2-43ac-b4fe-642f05eae748",
        "address": "Al Fattan Currency House Tower 2 ,DIFC ,507176 ,",
        "phone": "/ 971552009003",
        "email": "Mohammad.AlRasheed@bakermckenzie.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "acd81e81-dead-4f7c-839e-0f2a57897265",
    "firmName": "Baker & Mckenzie LLP",
    "registrationNumber": "L-00922",
    "licenseIssueDate": "10/19/2015 00:00:00",
    "licenseExpiryDate": "10/14/2025 00:00:00"
  },
  {
    "id": "c3667a6f-5e91-447d-bec9-c3b94f79db4b",
    "slug": "stephanie-zuyen-sen-dang",
    "name": "STEPHANIE ZUYEN SEN DANG",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTWgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/11/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-11-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Stephanie Zuyen Sen Dang",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c3667a6f-5e91-447d-bec9-c3b94f79db4b",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506698 ,Dubai",
        "phone": "97147046300 / 971507900661",
        "email": "nada.mourad@lw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b2b92ce9-90a4-4e34-ae2f-ae0dc7ca9060",
    "firmName": "Latham & Watkins LLP",
    "registrationNumber": "L-04806",
    "licenseIssueDate": "11/26/2020 00:00:00",
    "licenseExpiryDate": "11/25/2025 00:00:00"
  },
  {
    "id": "83f21bcf-ab63-4711-ae42-6c928855acc8",
    "slug": "stephany-malhame",
    "name": "STEPHANY JEAN CLAUDE MALHAME",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/04/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Stephany Malhame",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_83f21bcf-ab63-4711-ae42-6c928855acc8",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03788",
    "licenseIssueDate": "05/01/2017 00:00:00",
    "licenseExpiryDate": "04/27/2026 00:00:00"
  },
  {
    "id": "c777c701-a038-4df9-b9a5-0bec0e395111",
    "slug": "stephen-ballantine",
    "name": "STEPHEN BALLANTINE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Civil Transactions-Insurance"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/08/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Stephen Ballantine",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c777c701-a038-4df9-b9a5-0bec0e395111",
        "address": "",
        "phone": "97143937700",
        "email": "info@galadarilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d863b662-c864-4193-8b3a-ff6ee5fe6c64",
    "firmName": "GALADARI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01516",
    "licenseIssueDate": "08/16/2012 00:00:00",
    "licenseExpiryDate": "08/08/2026 00:00:00"
  },
  {
    "id": "200cddd7-8159-4acb-ba25-369edf396832",
    "slug": "stephen-burke",
    "name": "STEPHEN DAVID BURKE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/04/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Stephen Burke",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_200cddd7-8159-4acb-ba25-369edf396832",
        "address": "6 ,Office Nos. 603, 604 & 605, Level 6, Burj Daman ,Dubai International Financial Centre ,506555 ,Dubai",
        "phone": "97143506400 / 971504654755",
        "email": "r.hickman@aglaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8690f7d5-6b96-4649-9589-71303f2c2707",
    "firmName": "Addleshaw Goddard (Middle East) LLP",
    "registrationNumber": "L-00742",
    "licenseIssueDate": "04/16/2012 00:00:00",
    "licenseExpiryDate": "04/07/2026 00:00:00"
  },
  {
    "id": "92ddf4f1-31e4-4880-84ea-062c3a68883b",
    "slug": "stephen-hodgson",
    "name": "STEPHEN JOHN HODGSON",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/05/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Stephen Hodgson",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_92ddf4f1-31e4-4880-84ea-062c3a68883b",
        "address": "",
        "phone": "97144323671 / 971505589395",
        "email": "fba@amereller.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a139ca64-8897-4d1d-8d71-97446bc1e15a",
    "firmName": "Amereller Legal Consultancy LLC SOC",
    "registrationNumber": "L-03874",
    "licenseIssueDate": "06/01/2017 00:00:00",
    "licenseExpiryDate": "05/29/2026 00:00:00"
  },
  {
    "id": "045878a6-9965-4e94-ab20-14ffb5e01702",
    "slug": "stephen-kelly",
    "name": "STEPHEN JAMES KELLY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/10/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Stephen Kelly",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_045878a6-9965-4e94-ab20-14ffb5e01702",
        "address": "",
        "phone": "97145953601 / 971508728645",
        "email": "Steven.Bainbridge@gtlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b4146aa6-efd1-41d7-819d-49da46353b0b",
    "firmName": "Greenberg Traurig Limited",
    "registrationNumber": "L-00332",
    "licenseIssueDate": "10/11/2011 00:00:00",
    "licenseExpiryDate": "10/02/2026 00:00:00"
  },
  {
    "id": "bd864a9c-0819-423c-9801-97000e45dc5e",
    "slug": "stephen-robert-rigby",
    "name": "STEPHEN ROBERT RIGBY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/04/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Stephen Robert Rigby",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bd864a9c-0819-423c-9801-97000e45dc5e",
        "address": "ICD-Brookfield Place ,DIFC ,119974 ,",
        "phone": "97143652000",
        "email": "david.charlier@ashurst.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c01c3c61-4d90-4058-8429-61dd01e615f5",
    "firmName": "Ashurst LLP-DIFC",
    "registrationNumber": "L-04924",
    "licenseIssueDate": "04/26/2021 00:00:00",
    "licenseExpiryDate": "04/25/2026 00:00:00"
  },
  {
    "id": "fb2afab8-a19d-4a40-a955-318be2b32e3b",
    "slug": "stephen-sullivan",
    "name": "STEPHEN SULLIVAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/03/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Stephen Sullivan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fb2afab8-a19d-4a40-a955-318be2b32e3b",
        "address": "",
        "phone": "97143025100 / 971501501837",
        "email": "ccairns@trowers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "976857f5-9092-43cf-987d-bfa794a3fa51",
    "firmName": "Trowers & Hamlins LLP",
    "registrationNumber": "L-02213",
    "licenseIssueDate": "03/18/2013 00:00:00",
    "licenseExpiryDate": "03/10/2026 00:00:00"
  },
  {
    "id": "71e34995-ee65-47ff-b95f-16b34cad6e80",
    "slug": "steven-bainbridge",
    "name": "STEVEN FRANK DANIEL BAINBRIDGE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/09/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Steven Bainbridge",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_71e34995-ee65-47ff-b95f-16b34cad6e80",
        "address": "",
        "phone": "97145953601 / 971508728645",
        "email": "Steven.Bainbridge@gtlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "b4146aa6-efd1-41d7-819d-49da46353b0b",
    "firmName": "Greenberg Traurig Limited",
    "registrationNumber": "L-02296",
    "licenseIssueDate": "09/28/2023 00:00:00",
    "licenseExpiryDate": "09/27/2026 00:00:00"
  },
  {
    "id": "8301614a-20c2-42ee-8e1e-a9df601a840f",
    "slug": "steven-henderson",
    "name": "STEVEN ROBERT CONRAD HENDERSON",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Steven Henderson",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8301614a-20c2-42ee-8e1e-a9df601a840f",
        "address": "",
        "phone": "97143897000 / 971506553198",
        "email": "nasseralikhasawneh@eversheds-sutherland.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "74a21d43-41d8-480a-a6af-6939b7c98a95",
    "firmName": "Eversheds Sutherland (International LLP) Dubai Branch",
    "registrationNumber": "L-02592",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "6d7448a0-4ecc-4611-927c-ae289601bf56",
    "slug": "steven-jennings",
    "name": "STEVEN ROBERT JENNINGS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/04/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Steven Jennings",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6d7448a0-4ecc-4611-927c-ae289601bf56",
        "address": "",
        "phone": "97143897000 / 971506553198",
        "email": "nasseralikhasawneh@eversheds-sutherland.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "74a21d43-41d8-480a-a6af-6939b7c98a95",
    "firmName": "Eversheds Sutherland (International LLP) Dubai Branch",
    "registrationNumber": "L-00730",
    "licenseIssueDate": "04/27/2021 00:00:00",
    "licenseExpiryDate": "04/26/2026 00:00:00"
  },
  {
    "id": "9325df93-0800-4680-afa1-7f69feaa6af8",
    "slug": "stevie-louise-gallagher",
    "name": "STEVIE LOUISE GALLAGHER",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/09/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Stevie Louise Gallagher",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9325df93-0800-4680-afa1-7f69feaa6af8",
        "address": "ICD Brookfield Place ,Za'abeel 2 ,103747 ,",
        "phone": "97143696300 / 971506008159",
        "email": "mohammed.paracha@nortonrosefulbright.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c4aaee93-0ec4-4982-9a48-a23699492056",
    "firmName": "Norton Rose Fullbright (Middle East) LLP",
    "registrationNumber": "L-06970",
    "licenseIssueDate": "09/23/2025 00:00:00",
    "licenseExpiryDate": "09/22/2026 00:00:00"
  },
  {
    "id": "030184ed-c5c3-43b5-bdac-f97e3493adda",
    "slug": "stincy-joseph",
    "name": "STINCY MARY JOSEPH JOSEPH THOMAS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/11/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Stincy Joseph",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_030184ed-c5c3-43b5-bdac-f97e3493adda",
        "address": "- ,Index Tower ,Dubai International Financial Centre ,9371 ,Dubai",
        "phone": "97143303900 / 971561753537",
        "email": "christopher@afridi-angell.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3e464dc8-b800-4ba2-ad91-24a5f9640fef",
    "firmName": "Afridi & Angell-DIFC",
    "registrationNumber": "L-02506",
    "licenseIssueDate": "11/27/2013 00:00:00",
    "licenseExpiryDate": "11/20/2025 00:00:00"
  },
  {
    "id": "3a8b2032-e482-4bbb-b8e0-37db8ba68eb7",
    "slug": "stuart-faysal-hadi-brocklehurst",
    "name": "Stuart Faysal Hadi Brocklehurst",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/21/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Stuart Faysal Hadi Brocklehurst",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3a8b2032-e482-4bbb-b8e0-37db8ba68eb7",
        "address": "",
        "phone": "97145683100 / 971559223103",
        "email": "rossi@bonnard-lawson.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2b373724-e557-4c31-a968-7d37d9393842",
    "firmName": "Bonnard Lawson Legal Consultants L.L.C",
    "registrationNumber": "L-04742",
    "licenseIssueDate": "10/21/2020 00:00:00",
    "licenseExpiryDate": "10/20/2026 00:00:00"
  },
  {
    "id": "5f2938b3-7c56-4329-9fa2-318a83d38094",
    "slug": "stuart-iain-storry",
    "name": "STUART IAIN STORRY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/04/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Stuart Iain Storry",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5f2938b3-7c56-4329-9fa2-318a83d38094",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506688 ,Dubai",
        "phone": "97147096600 / 971503556811",
        "email": "muneer.khan@simmons-simmons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d1725ca7-06ac-41b2-8d7b-a6e60665b73d",
    "firmName": "Simmons & Simmons (Middle East) LLP-DIFC",
    "registrationNumber": "L-06754",
    "licenseIssueDate": "04/23/2025 00:00:00",
    "licenseExpiryDate": "04/22/2026 00:00:00"
  },
  {
    "id": "ba202072-e661-4c1a-b694-5d8c4e80fc5e",
    "slug": "stuart-j-ure",
    "name": "STUART CRANSTON URE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Stuart J. Ure",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ba202072-e661-4c1a-b694-5d8c4e80fc5e",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-00193",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "b2dcfefd-a8bf-4fad-b084-a3d6bd9d2b86",
    "slug": "stuart-j-walker",
    "name": "STUART JAMES WALKER",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/12/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Stuart J. Walker",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b2dcfefd-a8bf-4fad-b084-a3d6bd9d2b86",
        "address": "",
        "phone": "97143303900 / 971561753537",
        "email": "christopher@afridi-angell.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "30ce50dc-01a6-499d-8ace-3f807ddcb08d",
    "firmName": "Afridi & Angell-DED",
    "registrationNumber": "L-00126",
    "licenseIssueDate": "12/16/2011 00:00:00",
    "licenseExpiryDate": "12/07/2025 00:00:00"
  },
  {
    "id": "cfa35e23-69d5-4bc6-954f-ad7ad79225f7",
    "slug": "stuart-kerry-peters",
    "name": "Stuart Kerry Peters",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/25/2020 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Stuart Kerry Peters",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cfa35e23-69d5-4bc6-954f-ad7ad79225f7",
        "address": "ICD Brookfield Place ,DIFC ,506516 ,",
        "phone": "97143695800 / 971505526206",
        "email": "scott.campbell@linklaters.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5cec94c0-0649-43b6-a2be-ab17ff422bce",
    "firmName": "LinkLaters LLP",
    "registrationNumber": "L-04707",
    "licenseIssueDate": "06/25/2020 00:00:00",
    "licenseExpiryDate": "06/24/2026 00:00:00"
  },
  {
    "id": "30d6071c-b020-4d20-bc17-d57992fc3cfc",
    "slug": "stuart-paterson",
    "name": "STUART JAMES HOLM PATERSON",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Stuart Paterson",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_30d6071c-b020-4d20-bc17-d57992fc3cfc",
        "address": "",
        "phone": "97144286300 / 971506256686",
        "email": "stuart.paterson@hsf.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "2f0389b3-bfde-44f4-bdd6-6e1a22f9cab2",
    "firmName": "Herbert Smith Freehills Kramer LLP",
    "registrationNumber": "L-00791",
    "licenseIssueDate": "02/25/2012 00:00:00",
    "licenseExpiryDate": "02/16/2026 00:00:00"
  },
  {
    "id": "ec4c8b71-29ac-43c9-b12b-87e930e19855",
    "slug": "stuart-pryke",
    "name": "STUART PRYKE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/07/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Stuart Pryke",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ec4c8b71-29ac-43c9-b12b-87e930e19855",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-05948",
    "licenseIssueDate": "07/20/2023 00:00:00",
    "licenseExpiryDate": "07/19/2026 00:00:00"
  },
  {
    "id": "946b479d-4b08-431d-a980-e9305d4105c2",
    "slug": "stuart-roger-jordan",
    "name": "STUART ROGER JORDAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/10/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Stuart Roger Jordan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_946b479d-4b08-431d-a980-e9305d4105c2",
        "address": "",
        "phone": "97144363636 / 971505572900",
        "email": "hassan.elsayed@bakerbotts.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "fd5d6571-d053-4436-9de5-c8a36ce7c6c9",
    "firmName": "Baker Botts LLP Legal Consultants Dubai Branch",
    "registrationNumber": "L-06550",
    "licenseIssueDate": "10/15/2024 00:00:00",
    "licenseExpiryDate": "10/14/2026 00:00:00"
  },
  {
    "id": "3b585d34-1c3c-48ef-9fc9-35950cdb9a0c",
    "slug": "sudhanshu-singh",
    "name": "SUDHANSHU SINGH SUBHASH SINGH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/06/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sudhanshu Singh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3b585d34-1c3c-48ef-9fc9-35950cdb9a0c",
        "address": "13 ,Le Solarium Tower ,Arabian Gate ,185430 ,Dubai",
        "phone": "97145805135 / 971558703836",
        "email": "info@alnaqbilaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "24f8f7c8-a688-4587-9e87-f3105a99533a",
    "firmName": "MUSAAB ALI AL NAQBI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-04444",
    "licenseIssueDate": "06/30/2019 00:00:00",
    "licenseExpiryDate": "06/29/2026 00:00:00"
  },
  {
    "id": "31dbd1d8-17d8-42a6-b910-64dc5ba4ba85",
    "slug": "sudheer-vijayamma-devarajan",
    "name": "SUDHEER VIJAYAMMA DEVARAJAN PONNAMMA NARAYANAN DEVARAJAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTVgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Personal Status-Wills",
      "Criminal Law-Family Crimes",
      "Commercial Transactions-Commercial Contracts",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Civil Transactions-Arbitration",
      "Civil Transactions-Tenancy",
      "Civil Transactions-Sale",
      "Personal Status-Marriage & Divorce"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/03/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sudheer Vijayamma Devarajan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_31dbd1d8-17d8-42a6-b910-64dc5ba4ba85",
        "address": "6 ,latifa tower ,near crown plaza hotel  ,102999 ,Dubai",
        "phone": "97143799979",
        "email": "lawkmq@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b9d24779-27c2-4989-bf7f-4e73e5a670ff",
    "firmName": "KHALID BIN MOHAMMAD ALQASEMI ATTORNEY & LEGAL CONSULTANTS",
    "registrationNumber": "L-02412",
    "licenseIssueDate": "03/17/2013 00:00:00",
    "licenseExpiryDate": "03/09/2026 00:00:00"
  },
  {
    "id": "c1ce3908-dc8b-47db-a01e-a08667ab5906",
    "slug": "suditi-surana",
    "name": "SUDITI SURANA PRAVEEN SURANA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/12/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Suditi Surana",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c1ce3908-dc8b-47db-a01e-a08667ab5906",
        "address": "",
        "phone": "97144073901 / 971503479508",
        "email": "Rania.Tadros@stephensonharwood.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dd5042a2-bb41-4123-9544-79c3fa831332",
    "firmName": "Stephenson Harwood (Middle East) LLP",
    "registrationNumber": "L-05128",
    "licenseIssueDate": "12/13/2021 00:00:00",
    "licenseExpiryDate": "12/12/2025 00:00:00"
  },
  {
    "id": "99a05835-0253-471e-aa4f-09d068dc9d0e",
    "slug": "suhail-rana-rana-abdul-qayyum",
    "name": "SUHAIL RANA RANA ABDUL QAYYUM",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Commercial Agency",
      "Proceedings-Cases and Proceedings before Dubai International Financial Centre",
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Personal Status-Wills",
      "Criminal Law-Family Crimes",
      "Personal Status-Custody & Alimony",
      "Commercial Transactions-Bankruptcy",
      "Criminal Law-Hate crimes",
      "Personal Status-Legacies and Inheritance",
      "Personal Status-Legal Capacity & Guardianship",
      "Criminal Law-Drug Crimes",
      "Proceedings-Cases and Proceedings before arbitral tribunals and other alternative dispute resolution bodies",
      "Civil Transactions-Compensation",
      "Criminal Law-Cybercrimes",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/07/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Suhail Rana Rana Abdul Qayyum",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_99a05835-0253-471e-aa4f-09d068dc9d0e",
        "address": "الطابق الرابع ,الصقر للاعمال ,محطة مترو ابراج الامارات  ,67476 ,Dubai",
        "phone": "97143444210",
        "email": "assistant@albannaadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e3ffafe9-0f0c-4d88-a976-2bdfd7d18411",
    "firmName": "IBRAHIM ALBANNA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05935",
    "licenseIssueDate": "07/26/2023 00:00:00",
    "licenseExpiryDate": "07/25/2026 00:00:00"
  },
  {
    "id": "f961a589-666f-4ec8-9c93-879b2efbd5cc",
    "slug": "suhail-rashid-mirza",
    "name": "SUHAIL HUMAYUN RASHID MIRZA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/07/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Suhail Rashid Mirza",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f961a589-666f-4ec8-9c93-879b2efbd5cc",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-01108",
    "licenseIssueDate": "07/31/2023 00:00:00",
    "licenseExpiryDate": "07/30/2026 00:00:00"
  },
  {
    "id": "2ceeebd7-ba9d-4f7c-81d2-5fbfbb4d1928",
    "slug": "sujith-mathew",
    "name": "SUJITH MATHEW MATHEW ZACHARIA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/07/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sujith Mathew",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2ceeebd7-ba9d-4f7c-81d2-5fbfbb4d1928",
        "address": "",
        "phone": "97142396646",
        "email": "advo_alblooshi@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3ab5acef-85ac-482b-91f2-4e0a34fd6af7",
    "firmName": "ABDELAZIZ AL BLOUSHI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02180",
    "licenseIssueDate": "07/11/2012 00:00:00",
    "licenseExpiryDate": "07/03/2026 00:00:00"
  },
  {
    "id": "5c625d8f-c4b1-42e3-bb51-254cfc39f6c7",
    "slug": "sulakshana-rangajith-senanayake",
    "name": "SULAKSHANA RANGAJITH SENANAYAKE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/10/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sulakshana Rangajith Senanayake",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5c625d8f-c4b1-42e3-bb51-254cfc39f6c7",
        "address": "",
        "phone": "97143303900 / 971561753537",
        "email": "christopher@afridi-angell.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "30ce50dc-01a6-499d-8ace-3f807ddcb08d",
    "firmName": "Afridi & Angell-DED",
    "registrationNumber": "L-03889",
    "licenseIssueDate": "10/18/2017 00:00:00",
    "licenseExpiryDate": "10/15/2025 00:00:00"
  },
  {
    "id": "f35e8399-9b36-492a-9dc1-1038bad36b2e",
    "slug": "sunandini-das-jana-kalyan-das",
    "name": "SUNANDINI DAS JANA KALYAN DAS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/03/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sunandini Das Jana Kalyan Das",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f35e8399-9b36-492a-9dc1-1038bad36b2e",
        "address": "",
        "phone": "97143779900 / 971508548052",
        "email": "jali@kslaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dff8529a-82be-431a-b72b-0192ff238011",
    "firmName": "King & Spalding LLP",
    "registrationNumber": "L-05735",
    "licenseIssueDate": "03/16/2023 00:00:00",
    "licenseExpiryDate": "03/15/2026 00:00:00"
  },
  {
    "id": "df92c6df-f509-419b-94a9-ef711e1a6158",
    "slug": "sundeep-puri",
    "name": "SUNDEEP PURI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/03/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sundeep Puri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_df92c6df-f509-419b-94a9-ef711e1a6158",
        "address": "6 ,Office Nos. 603, 604 & 605, Level 6, Burj Daman ,Dubai International Financial Centre ,506555 ,Dubai",
        "phone": "97143506400 / 971504654755",
        "email": "r.hickman@aglaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8690f7d5-6b96-4649-9589-71303f2c2707",
    "firmName": "Addleshaw Goddard (Middle East) LLP",
    "registrationNumber": "L-00187",
    "licenseIssueDate": "03/24/2015 00:00:00",
    "licenseExpiryDate": "03/18/2026 00:00:00"
  },
  {
    "id": "c0031f65-0968-40c5-886c-435612e04a7e",
    "slug": "sundus-azmat-khan",
    "name": "SUNDUS AZMAT KHAN AZMAT ULLAH KHAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/12/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: SUNDUS AZMAT KHAN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c0031f65-0968-40c5-886c-435612e04a7e",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-04282",
    "licenseIssueDate": "12/11/2018 00:00:00",
    "licenseExpiryDate": "12/09/2025 00:00:00"
  },
  {
    "id": "80287747-e4ba-4860-a6ff-0a2355f9b54b",
    "slug": "suneer-kumar-komath",
    "name": "SUNEER KUMAR CHENOLI KOMATH KOMATH KRISHNAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/12/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Suneer Kumar Komath",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_80287747-e4ba-4860-a6ff-0a2355f9b54b",
        "address": "Samia Luqman ,2nd floor ,Emarat Atrium Building ,across Holiday Inn Express Safa Park ,7273 ,Dubai",
        "phone": "97143211000",
        "email": "info@alsuwaidi.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0e5c3637-bc12-475c-a6b5-2d9ae84f2b8e",
    "firmName": "AL-SUWAIDI & COMPANY",
    "registrationNumber": "L-02237",
    "licenseIssueDate": "12/28/2011 00:00:00",
    "licenseExpiryDate": "12/19/2025 00:00:00"
  },
  {
    "id": "b3f01c3c-336d-4ad7-aa93-ddd28022e87b",
    "slug": "sunil-george",
    "name": "SUNIL CHAKKEDATH GEORGE KAVARAMATHULLA GEORGE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/01/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sunil George",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b3f01c3c-336d-4ad7-aa93-ddd28022e87b",
        "address": "abdulla nasser mansour hamad alkaabi ,life pharmacy ,al safa ,millennium plaza hotel ,113713 ,Dubai",
        "phone": "97143598998",
        "email": "advo.akd@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "05d59198-4e23-4b78-bb9b-d55bfcd69060",
    "firmName": "ABDULLA ALKAABI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03585",
    "licenseIssueDate": "01/11/2017 00:00:00",
    "licenseExpiryDate": "01/07/2026 00:00:00"
  },
  {
    "id": "c115c8d4-05fa-43e2-90ff-c9c6a3f55a6b",
    "slug": "sunil-raju-ambalavelil",
    "name": "SUNIL RAJU AMBALAVELIL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/05/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sunil Raju Ambalavelil",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c115c8d4-05fa-43e2-90ff-c9c6a3f55a6b",
        "address": "",
        "phone": "97145548499",
        "email": "legal@nyk.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "86fac3dc-bced-468b-8e4c-43324e2aa906",
    "firmName": "NASSER ALKHAMIS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04092",
    "licenseIssueDate": "05/07/2018 00:00:00",
    "licenseExpiryDate": "05/05/2026 00:00:00"
  },
  {
    "id": "1264e367-d48e-40f5-8020-f437ea20ceb8",
    "slug": "sunita-singh-dalal",
    "name": "SUNITA SINGH DALAL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/09/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sunita Singh-Dalal",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1264e367-d48e-40f5-8020-f437ea20ceb8",
        "address": "One Central, The Offices 5 ,Dubai World Trade Centre ,554660 ,",
        "phone": "97142052030 / 971506566494",
        "email": "chourani@houranipartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "59a73632-40a0-4849-b120-4308dc6f8015",
    "firmName": "Hourani & Partners Legal Consultancy FZCO",
    "registrationNumber": "L-01940",
    "licenseIssueDate": "09/23/2022 00:00:00",
    "licenseExpiryDate": "09/22/2026 00:00:00"
  },
  {
    "id": "6c26b78d-de78-4e4e-a5c4-7b2c3f210cb4",
    "slug": "surabhi-singhi",
    "name": "SURABHI SINGHI SUDHIR SINGHI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/06/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: SURABHI SINGHI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6c26b78d-de78-4e4e-a5c4-7b2c3f210cb4",
        "address": "",
        "phone": "97143093222 / 971566651954",
        "email": "melissa.murray@twobirds.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3e1526e6-4c8d-4b6f-985f-ea05e9f99bcb",
    "firmName": "Bird & Bird (MEA) LLP",
    "registrationNumber": "L-04427",
    "licenseIssueDate": "06/12/2019 00:00:00",
    "licenseExpiryDate": "06/11/2026 00:00:00"
  },
  {
    "id": "554a6ee4-e870-4496-9d16-a56b9bb14ca4",
    "slug": "susie-abdel-nabi",
    "name": "SUSIE AMAL ABDEL NABI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/10/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Susie Abdel-Nabi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_554a6ee4-e870-4496-9d16-a56b9bb14ca4",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-00334",
    "licenseIssueDate": "10/11/2011 00:00:00",
    "licenseExpiryDate": "10/02/2026 00:00:00"
  },
  {
    "id": "fbbc28c4-5611-4266-b9b8-34230699dc3c",
    "slug": "suzannah-fairbairn",
    "name": "SUZANNAH MARIE FAIRBAIRN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/03/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Suzannah Fairbairn",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fbbc28c4-5611-4266-b9b8-34230699dc3c",
        "address": "",
        "phone": "97144020800 / 971566830829",
        "email": "dean.ryburn@dentons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dfe13b7e-6625-45fd-ad63-9ee83af41194",
    "firmName": "Dentons & Co Dubai Branch-DED",
    "registrationNumber": "L-03747",
    "licenseIssueDate": "03/26/2017 00:00:00",
    "licenseExpiryDate": "03/22/2026 00:00:00"
  },
  {
    "id": "60d9aaee-09cc-4e82-9e2e-0ca9037ac366",
    "slug": "suzannah-newboult",
    "name": "SUZANNAH MAY NEWBOULT",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/10/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Suzannah Newboult",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_60d9aaee-09cc-4e82-9e2e-0ca9037ac366",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-02660",
    "licenseIssueDate": "10/13/2014 00:00:00",
    "licenseExpiryDate": "10/07/2026 00:00:00"
  },
  {
    "id": "a6e5a67a-aecf-4179-9911-d7ab98ffab1f",
    "slug": "suzanne-abdallah",
    "name": "SUZANNE MOUNIR ABDALLAH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Suzanne Abdallah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a6e5a67a-aecf-4179-9911-d7ab98ffab1f",
        "address": "omar abdulazizi alomar ,15 ,prime tower ,blom bank france ,211940 ,Dubai",
        "phone": "97143808838 / 971504598082",
        "email": "omar.omar@oghlegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "171b4622-e4ec-4375-a9c4-3637bf6a8b17",
    "firmName": "ALOMAR & ALSABAH ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-01321",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "763484d2-bbb9-4d1a-a5b6-bf04bb384a93",
    "slug": "suzanne-gingles",
    "name": "SUZANNE GINGLES",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/03/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Suzanne Gingles",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_763484d2-bbb9-4d1a-a5b6-bf04bb384a93",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-05283",
    "licenseIssueDate": "03/31/2022 00:00:00",
    "licenseExpiryDate": "03/30/2026 00:00:00"
  },
  {
    "id": "5e4032df-743f-47bd-83ac-271743099fe7",
    "slug": "svetlana-volevich",
    "name": "SVETLANA VOLEVICH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTVgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/12/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Svetlana Volevich",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5e4032df-743f-47bd-83ac-271743099fe7",
        "address": "ICD Brookfield Place ,DIFC ,120109 ,",
        "phone": "97143173000 / 971504465229",
        "email": "DubaiLAD@akingump.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9ff29eab-adb8-40f9-ab84-216e01a381e4",
    "firmName": "Akin Gump Strauss Hauer & Feld LLP",
    "registrationNumber": "L-05632",
    "licenseIssueDate": "12/07/2022 00:00:00",
    "licenseExpiryDate": "12/06/2025 00:00:00"
  },
  {
    "id": "210f6db0-4364-4c3d-b5be-ab9c4cd94362",
    "slug": "swetha-sivaram-ramjee-sivaram",
    "name": "SWETHA SIVARAM RAMJEE SIVARAM",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/09/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Swetha Sivaram Ramjee Sivaram",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_210f6db0-4364-4c3d-b5be-ab9c4cd94362",
        "address": "HAMDAN ALSHAMSI ,الطابق الرابع مكتب 401, 406,407 ,بي سكوير 01 ,مجمع دبي سكوير ,116564 ,Dubai",
        "phone": "97143469262",
        "email": "courts@has.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de2c61a6-9d00-457e-ad1d-e73e4e62d9bd",
    "firmName": "HAMDAN ALSHAMSI LAWYER & LEGAL CONSULTANTS",
    "registrationNumber": "L-06952",
    "licenseIssueDate": "09/25/2025 00:00:00",
    "licenseExpiryDate": "09/24/2026 00:00:00"
  },
  {
    "id": "d3e876c1-23fc-4ed2-9871-cfa628badb4d",
    "slug": "syed-azam-uddin",
    "name": "SYED AZAM UDDIN SYED VAJEEH UDDIN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/09/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Syed Azam Uddin",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d3e876c1-23fc-4ed2-9871-cfa628badb4d",
        "address": "HAMDAN ALSHAMSI ,الطابق الرابع مكتب 401, 406,407 ,بي سكوير 01 ,مجمع دبي سكوير ,116564 ,Dubai",
        "phone": "97143469262",
        "email": "courts@has.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de2c61a6-9d00-457e-ad1d-e73e4e62d9bd",
    "firmName": "HAMDAN ALSHAMSI LAWYER & LEGAL CONSULTANTS",
    "registrationNumber": "L-06961",
    "licenseIssueDate": "09/25/2025 00:00:00",
    "licenseExpiryDate": "09/24/2026 00:00:00"
  },
  {
    "id": "c2f2cf5a-31e8-496c-8cda-87e7c1a4d3fc",
    "slug": "syed-khan",
    "name": "SYED RASHID RAZA KHAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/03/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Syed Khan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c2f2cf5a-31e8-496c-8cda-87e7c1a4d3fc",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02435",
    "licenseIssueDate": "03/12/2014 00:00:00",
    "licenseExpiryDate": "03/05/2026 00:00:00"
  },
  {
    "id": "5abf8fd1-28b7-44bb-b100-2332b703b144",
    "slug": "syed-rizvi",
    "name": "SYED HASAN ANWAR RIZVI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/08/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Syed Rizvi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5abf8fd1-28b7-44bb-b100-2332b703b144",
        "address": "Level 07, Gate Village Building 10 ,Dubai International Financial Centre ,507014 ,",
        "phone": "97144019410 / 971504557972",
        "email": "hasan.rizvi@riaabg.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "827d9d4c-3af8-4363-a38f-9b8eafda9b85",
    "firmName": "RIAA Barker Gillette (Middle East) LLP",
    "registrationNumber": "L-00997",
    "licenseIssueDate": "08/12/2015 00:00:00",
    "licenseExpiryDate": "08/07/2026 00:00:00"
  },
  {
    "id": "77cbb705-b123-459d-9bcf-92a196bda816",
    "slug": "szymon-andrzej-durlo",
    "name": "Szymon Andrzej Durlo",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/30/2021 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Szymon Andrzej Durlo",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_77cbb705-b123-459d-9bcf-92a196bda816",
        "address": "",
        "phone": "97143637999 / 971506525633",
        "email": "daniel.wood@walkersglobal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a3a9927b-d51c-490c-8be6-d575ea3eb041",
    "firmName": "Walkers (Middle East) LLP",
    "registrationNumber": "L-05142",
    "licenseIssueDate": "12/30/2021 00:00:00",
    "licenseExpiryDate": "12/29/2025 00:00:00"
  },
  {
    "id": "136e5b37-948e-4f80-acb7-c5b086056574",
    "slug": "tabasam-faqir",
    "name": "TABASAM FAQIR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBURgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/11/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tabasam Faqir",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_136e5b37-948e-4f80-acb7-c5b086056574",
        "address": "0 ,ICD Brookfield Place Level 13 ,Trade Centre ,506569 ,Dubai",
        "phone": "97145099100 / 971501006965",
        "email": "menahr@freshfields.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "970f6246-e737-41a7-9c6c-5aa5b8335d45",
    "firmName": "Freshfields LLP DIFC",
    "registrationNumber": "L-03938",
    "licenseIssueDate": "11/16/2017 00:00:00",
    "licenseExpiryDate": "11/13/2025 00:00:00"
  },
  {
    "id": "f4577d86-79fc-4f77-a3c4-2e80a3daa0ce",
    "slug": "taha-ramdan-ahmed",
    "name": "TAHA RAMADAN ABDEL HALIM AHMED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Civil Transactions-Tenancy"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Taha Ramdan Ahmed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f4577d86-79fc-4f77-a3c4-2e80a3daa0ce",
        "address": "",
        "phone": "97143937700",
        "email": "info@galadarilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d863b662-c864-4193-8b3a-ff6ee5fe6c64",
    "firmName": "GALADARI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01505",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "94583010-f672-4877-ab95-6f93e0c00304",
    "slug": "taha-tawawala",
    "name": "TAHA HABIB TAWAWALA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/04/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Taha Tawawala",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_94583010-f672-4877-ab95-6f93e0c00304",
        "address": "Amer Sayed Al Marzooqi ,603 ,SAMA TOWER ,TRADE CENTER ,41727 ,Dubai",
        "phone": "97142500023",
        "email": "info@mlegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7ed7234c-a176-47f9-b66e-18524305fe3e",
    "firmName": "AMER AL MARZOOQI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02249",
    "licenseIssueDate": "04/21/2015 00:00:00",
    "licenseExpiryDate": "04/16/2026 00:00:00"
  },
  {
    "id": "293224d4-88c2-414c-a306-93c436b6a6d9",
    "slug": "tahan-thraya",
    "name": "TAHAN THRAYA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/03/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tahan Thraya",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_293224d4-88c2-414c-a306-93c436b6a6d9",
        "address": "Index Tower ,Dubai International Financial Centre ,507115 ,",
        "phone": "97143757160 / 971523490280",
        "email": "tthraya@mayerbrown.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "c7f52b69-c049-4246-963a-9805b241f88a",
    "firmName": "Mayer Brown LLP",
    "registrationNumber": "L-02900",
    "licenseIssueDate": "03/18/2015 00:00:00",
    "licenseExpiryDate": "03/12/2026 00:00:00"
  },
  {
    "id": "989baf7c-bbbd-49a6-a02a-643a4e4f6f53",
    "slug": "taher-ahmed",
    "name": "TAHER AHMED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/01/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Taher Ahmed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_989baf7c-bbbd-49a6-a02a-643a4e4f6f53",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506688 ,Dubai",
        "phone": "97147096600 / 971503556811",
        "email": "muneer.khan@simmons-simmons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d1725ca7-06ac-41b2-8d7b-a6e60665b73d",
    "firmName": "Simmons & Simmons (Middle East) LLP-DIFC",
    "registrationNumber": "L-06180",
    "licenseIssueDate": "01/31/2024 00:00:00",
    "licenseExpiryDate": "01/30/2026 00:00:00"
  },
  {
    "id": "242819bc-fbbf-458e-990e-30215f4775d0",
    "slug": "tahra-abdel-mutaal-mamoun-abdallah",
    "name": "Tahra Abdel Mutaal Mamoun Abdallah",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/07/2025",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tahra Abdel Mutaal Mamoun Abdallah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_242819bc-fbbf-458e-990e-30215f4775d0",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-04576",
    "licenseIssueDate": "07/22/2025 00:00:00",
    "licenseExpiryDate": "07/21/2026 00:00:00"
  },
  {
    "id": "8966a677-4c2e-49d9-a7e6-910977305af8",
    "slug": "taisiia-vorotilova",
    "name": "TAISIIA VOROTILOVA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUVgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/07/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Taisiia Vorotilova",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8966a677-4c2e-49d9-a7e6-910977305af8",
        "address": "Al Fattan Currency House Tower 2 ,DIFC ,507176 ,",
        "phone": "/ 971552009003",
        "email": "Mohammad.AlRasheed@bakermckenzie.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "acd81e81-dead-4f7c-839e-0f2a57897265",
    "firmName": "Baker & Mckenzie LLP",
    "registrationNumber": "L-05921",
    "licenseIssueDate": "07/19/2023 00:00:00",
    "licenseExpiryDate": "07/18/2026 00:00:00"
  },
  {
    "id": "23849533-eefc-43df-b692-8a86b4f0e9f4",
    "slug": "takahiro-kawaguchi",
    "name": "Takahiro Kawaguchi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/18/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Takahiro Kawaguchi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_23849533-eefc-43df-b692-8a86b4f0e9f4",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-06616",
    "licenseIssueDate": "12/06/2024 00:00:00",
    "licenseExpiryDate": "12/05/2025 00:00:00"
  },
  {
    "id": "9bc268d4-3229-4330-93bc-d00838e68295",
    "slug": "tala-towfic-louis-shomar",
    "name": "TALA TOWFIC LOUIS SHOMAR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/10/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tala Towfic Louis Shomar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9bc268d4-3229-4330-93bc-d00838e68295",
        "address": "Al Fattan Currency House Tower 2 ,DIFC ,507176 ,",
        "phone": "/ 971552009003",
        "email": "Mohammad.AlRasheed@bakermckenzie.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "acd81e81-dead-4f7c-839e-0f2a57897265",
    "firmName": "Baker & Mckenzie LLP",
    "registrationNumber": "L-04238",
    "licenseIssueDate": "10/03/2018 00:00:00",
    "licenseExpiryDate": "09/30/2026 00:00:00"
  },
  {
    "id": "f56c74e4-be67-4da1-ba7c-f11ef8cbfd83",
    "slug": "talal-al-qaisi",
    "name": "TALAL SALEM AHMAD ALQAISI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/01/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Talal Al Qaisi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f56c74e4-be67-4da1-ba7c-f11ef8cbfd83",
        "address": "",
        "phone": "97145579711",
        "email": "info@mqadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9f91cca7-a15d-499f-b265-2a032fe38fa1",
    "firmName": "FATMA ALMUTAWA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01506",
    "licenseIssueDate": "01/25/2016 00:00:00",
    "licenseExpiryDate": "01/20/2026 00:00:00"
  },
  {
    "id": "45f99efd-1e5a-4674-af8f-7dfdfb6f3a87",
    "slug": "talal-elmakkawi",
    "name": "TALAL ELMAKKAWI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBURQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/05/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Talal Elmakkawi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_45f99efd-1e5a-4674-af8f-7dfdfb6f3a87",
        "address": "TWENTY ,ALMASRAF TOWER ,DUBAI MUNICIPALITY ,3858 ,Dubai",
        "phone": "97142222314",
        "email": "apxjuris@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "f8f827cb-389c-48f1-841e-a39afdd09f7d",
    "firmName": "APEX JURIS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03347",
    "licenseIssueDate": "05/09/2016 00:00:00",
    "licenseExpiryDate": "05/05/2026 00:00:00"
  },
  {
    "id": "49b74284-9ba5-41e8-b99b-68f4aa5575a3",
    "slug": "talal-mohammad-qasem-abdaljabbar",
    "name": "TALAL MOHAMMAD QASEM ABDALJABBAR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/09/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Talal Mohammad Qasem Abdaljabbar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_49b74284-9ba5-41e8-b99b-68f4aa5575a3",
        "address": "Dr. Ali Ismail Aljarman ,Roof Floor - Offices R03 & R04 ,MSM 1 Building ,Al Saffa First ,62639 ,Dubai",
        "phone": "97144393733",
        "email": "info@prestigeadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "22043b7f-55d2-4eb4-a173-3077ba390351",
    "firmName": "PRESTIGE ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06486",
    "licenseIssueDate": "09/06/2024 00:00:00",
    "licenseExpiryDate": "09/05/2026 00:00:00"
  },
  {
    "id": "26ba88ea-ba55-4a28-bd59-c8173769aa51",
    "slug": "tamam-al-ghrawi",
    "name": "TAMAM AL GHRAWI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/09/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tamam Al-Ghrawi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_26ba88ea-ba55-4a28-bd59-c8173769aa51",
        "address": "Majed Naim ,5 ,Aspect Tower ,Bay Avenue Mall ,554868 ,Dubai",
        "phone": "97147701106 / 971557665402",
        "email": "communicate@janahilegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "cdefbdd8-ff2a-4404-ab83-1565e2c39e9d",
    "firmName": "NISMA ALJANAHI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05541",
    "licenseIssueDate": "09/23/2022 00:00:00",
    "licenseExpiryDate": "09/22/2026 00:00:00"
  },
  {
    "id": "d7456559-896c-4bdd-951c-1710860c37a5",
    "slug": "tamer-mohamed-mohamed-mohamed-tageldin",
    "name": "TAMER MOHAMED MOHAMED MOHAMED TAGELDIN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Civil Transactions-POA & Sponsorship",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Criminal Law-Family Crimes",
      "Personal Status-Custody & Alimony",
      "Commercial Transactions-Commercial Contracts",
      "Civil Transactions-Residential Real Estate",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Criminal Law-Hate crimes",
      "Civil Transactions-Tenancy",
      "Commercial Transactions-Unfair competition",
      "Criminal Law-Crimes against persons",
      "Personal Status-Legacies and Inheritance",
      "Commercial Transactions-Commercial Companies",
      "Civil Transactions-Labor & Workers",
      "Personal Status-Legal Capacity & Guardianship",
      "Criminal Law-Drug Crimes",
      "Civil Transactions-Sale",
      "Commercial Transactions-Sea and air freight",
      "Personal Status-Marriage & Divorce",
      "Personal Status-Child Abuse & Abduction",
      "Civil Transactions-Compensation",
      "Criminal Law-Crimes against properties",
      "Criminal Law-Cybercrimes",
      "Commercial Transactions-Intellectual Property (includes trademarks",
      "copy rights",
      "patents)",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/04/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tamer mohamed mohamed mohamed tageldin",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d7456559-896c-4bdd-951c-1710860c37a5",
        "address": "saeed thani ben ghulaita ,الطابق الاول علوي رقم المكتب 109  ,التجاري ام الشيف  ,مطعم سلطان سراي ,398 ,Dubai",
        "phone": "97143333309 / 971502660044",
        "email": "saeedalmuhairi@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ef647e96-a648-4410-bb78-03c38a83d79e",
    "firmName": "SAEED BIN GHULAITA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04080",
    "licenseIssueDate": "04/24/2018 00:00:00",
    "licenseExpiryDate": "04/22/2026 00:00:00"
  },
  {
    "id": "64f3ac02-99d1-406b-af82-8888c92977d2",
    "slug": "tamer-mohsen-rashwan",
    "name": "TAMER MOHSEN MOUKTAR RASHWAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/09/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tamer Mohsen Rashwan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_64f3ac02-99d1-406b-af82-8888c92977d2",
        "address": "Mohammed Saghaer Ali Al Awami Al Mansoori ,3 ,IT PLAZA ,Green Belt Supermarket ,25626 ,Dubai",
        "phone": "97143338885",
        "email": "info@alawami.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6ada2495-c722-4585-bbc3-2b70e5c9fcf9",
    "firmName": "ALAWAMI ALMANSOORI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-02643",
    "licenseIssueDate": "09/21/2016 00:00:00",
    "licenseExpiryDate": "09/17/2026 00:00:00"
  },
  {
    "id": "1bd2b9ed-fd1f-4302-8727-7513f1c02d9f",
    "slug": "tamim-momeni",
    "name": "TAMIM MOMENI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/10/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: TAMIM MOMENI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1bd2b9ed-fd1f-4302-8727-7513f1c02d9f",
        "address": "الطابق 7 مكتب رقم 070A ,برج رولكس  ,محطة مترو المركز المالي  ,66300 ,Dubai",
        "phone": "97143444029",
        "email": "ekp.khalidaltmimi@ekplegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "400838f1-4e75-4836-9698-b9e19dd30a18",
    "firmName": "KHALID ABDALLA ALTAMIMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03931",
    "licenseIssueDate": "10/07/2024 00:00:00",
    "licenseExpiryDate": "10/06/2026 00:00:00"
  },
  {
    "id": "2bc932b0-529d-4b7c-b905-be805174bc2f",
    "slug": "tammam-tawil",
    "name": "TAMMAM YOUNES AL TAWIL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tammam Tawil",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2bc932b0-529d-4b7c-b905-be805174bc2f",
        "address": "مركز وافي للتسوق  ,بلوك ايه ,خلف فندق موفنبيك ,11672 ,Dubai",
        "phone": "97143796990",
        "email": "alzeyoudi@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e5af688d-2190-4a5e-bb51-52b925fc1fb7",
    "firmName": "AL ZEYOUDI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01218",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "adcb4441-4421-4dda-87d2-adfc07b05117",
    "slug": "tammie-le",
    "name": "TAMMIE LE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/03/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tammie Le",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_adcb4441-4421-4dda-87d2-adfc07b05117",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-04844",
    "licenseIssueDate": "03/12/2025 00:00:00",
    "licenseExpiryDate": "03/11/2026 00:00:00"
  },
  {
    "id": "8eff35ce-b366-47c2-afe6-ca27a88554ef",
    "slug": "tania-afrin",
    "name": "TANIA AFRIN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/08/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tania Afrin",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8eff35ce-b366-47c2-afe6-ca27a88554ef",
        "address": "",
        "phone": "97144020800 / 971566830829",
        "email": "dean.ryburn@dentons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dfe13b7e-6625-45fd-ad63-9ee83af41194",
    "firmName": "Dentons & Co Dubai Branch-DED",
    "registrationNumber": "L-06469",
    "licenseIssueDate": "08/21/2024 00:00:00",
    "licenseExpiryDate": "08/20/2026 00:00:00"
  },
  {
    "id": "06acf16e-bc9d-4bd4-a943-ea1157624a32",
    "slug": "tania-diab",
    "name": "Tania Diab",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBURAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/21/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tania Diab",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_06acf16e-bc9d-4bd4-a943-ea1157624a32",
        "address": "",
        "phone": "97143637999 / 971506525633",
        "email": "daniel.wood@walkersglobal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a3a9927b-d51c-490c-8be6-d575ea3eb041",
    "firmName": "Walkers (Middle East) LLP",
    "registrationNumber": "L-05505",
    "licenseIssueDate": "09/21/2022 00:00:00",
    "licenseExpiryDate": "09/20/2026 00:00:00"
  },
  {
    "id": "419750cb-4163-406d-9f2f-9037fe56b169",
    "slug": "tania-samantha-de-swart",
    "name": "TANIA SAMANTHA DE SWART",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/05/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tania Samantha De Swart",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_419750cb-4163-406d-9f2f-9037fe56b169",
        "address": "Building 5 ,Dubai World Trade Centre ,212620 ,",
        "phone": "97143503600 / 971563631562",
        "email": "p.ellingham@kennedys-law.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "83d3ede1-3a28-4b03-8c92-6bd31a1cb95e",
    "firmName": "Kennedys Dubai LLP",
    "registrationNumber": "L-06291",
    "licenseIssueDate": "05/22/2024 00:00:00",
    "licenseExpiryDate": "05/21/2026 00:00:00"
  },
  {
    "id": "29275a10-77b3-49bd-832f-af8bac360de6",
    "slug": "tania-su-wen-forichon",
    "name": "TANIA SU WEN FORICHON",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/04/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tania Su Wen Forichon",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_29275a10-77b3-49bd-832f-af8bac360de6",
        "address": "",
        "phone": "97144286300 / 971506256686",
        "email": "stuart.paterson@hsf.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2f0389b3-bfde-44f4-bdd6-6e1a22f9cab2",
    "firmName": "Herbert Smith Freehills Kramer LLP",
    "registrationNumber": "L-06247",
    "licenseIssueDate": "04/17/2024 00:00:00",
    "licenseExpiryDate": "04/16/2026 00:00:00"
  },
  {
    "id": "dec323eb-8a32-441d-ba0c-8189935949dd",
    "slug": "tanisha-piyush-agarwal",
    "name": "TANISHA PIYUSH AGARWAL PIYUSH TEJKARAN AGARWAL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/07/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tanisha Piyush Agarwal",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dec323eb-8a32-441d-ba0c-8189935949dd",
        "address": "",
        "phone": "97104309100 / 971564013758",
        "email": "c.royle@taylorwessing.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d51b6f43-8c62-486f-a1ab-6ee3b87c8006",
    "firmName": "Taylor Wessing LLP (Dubai Branch)",
    "registrationNumber": "L-06906",
    "licenseIssueDate": "07/30/2025 00:00:00",
    "licenseExpiryDate": "07/29/2026 00:00:00"
  },
  {
    "id": "a59e5502-206e-4078-8bfc-83a103b001d7",
    "slug": "tanisha-saxena",
    "name": "TANISHA SAXENA RAJIV SAXENA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/01/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: TANISHA SAXENA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a59e5502-206e-4078-8bfc-83a103b001d7",
        "address": "",
        "phone": "97144230555 / 971504788443",
        "email": "yah@hfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c462c65e-185a-4e81-8425-a87e3a2b6842",
    "firmName": "Holman Fenwick Willan Middle East LLP",
    "registrationNumber": "L-03984",
    "licenseIssueDate": "01/24/2018 00:00:00",
    "licenseExpiryDate": "01/21/2026 00:00:00"
  },
  {
    "id": "c4101cf7-03d0-42e5-aa7d-792a7043e226",
    "slug": "tanvi-pahwa",
    "name": "TANVI PAHWA SANJAY PAHWA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/02/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tanvi Pahwa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c4101cf7-03d0-42e5-aa7d-792a7043e226",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-06186",
    "licenseIssueDate": "02/21/2024 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "bfac4ca9-c920-4602-9428-18c1e0593b13",
    "slug": "tanya-garg",
    "name": "TANYA GARG DEEPAK GARG",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBURwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/07/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tanya Garg",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bfac4ca9-c920-4602-9428-18c1e0593b13",
        "address": "",
        "phone": "97143303900 / 971561753537",
        "email": "christopher@afridi-angell.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "30ce50dc-01a6-499d-8ace-3f807ddcb08d",
    "firmName": "Afridi & Angell-DED",
    "registrationNumber": "L-05913",
    "licenseIssueDate": "07/19/2023 00:00:00",
    "licenseExpiryDate": "07/18/2026 00:00:00"
  },
  {
    "id": "f0c16701-49b2-4bec-9431-5e8de98b3076",
    "slug": "tarek-abdelaziz-hussein-nawwar",
    "name": "TAREK ABDELAZIZ HUSSEIN NAWWAR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/04/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: tarek abdelaziz hussein nawwar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f0c16701-49b2-4bec-9431-5e8de98b3076",
        "address": "Hitham Bassam ,1 ,R549 ,بنك مصر ,99094 ,Dubai",
        "phone": "97142355517",
        "email": "hassanalabdooli@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "746e4dd4-f7bb-4efd-84f5-ad6b769ad28c",
    "firmName": "HASSAN AL ABDOOLI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04900",
    "licenseIssueDate": "04/05/2021 00:00:00",
    "licenseExpiryDate": "04/04/2026 00:00:00"
  },
  {
    "id": "813c75d8-1c3b-4626-95cd-deaa815df6ac",
    "slug": "tarek-alayyashi",
    "name": "TAREK BAHAA ED DIN MUSTAFA ALAYYASHI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/08/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tarek Alayyashi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_813c75d8-1c3b-4626-95cd-deaa815df6ac",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03452",
    "licenseIssueDate": "08/22/2016 00:00:00",
    "licenseExpiryDate": "08/18/2026 00:00:00"
  },
  {
    "id": "f1fab82d-e3d1-491a-9358-e4c213a6bc8e",
    "slug": "tarek-bahgat-ab-badawy",
    "name": "TAREK BAHGAT AB BADAWY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/12/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tarek Bahgat Ab Badawy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f1fab82d-e3d1-491a-9358-e4c213a6bc8e",
        "address": "",
        "phone": "97100000000 / 971529999965",
        "email": "beljeaan@meysan.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "18d46314-9f85-4421-9ec3-09c58c01fb76",
    "firmName": "Meysan Lawyers and Legal Consultants WLL",
    "registrationNumber": "L-06624",
    "licenseIssueDate": "12/25/2024 00:00:00",
    "licenseExpiryDate": "12/24/2025 00:00:00"
  },
  {
    "id": "9dea2d77-88f3-423a-a83d-cce889db010e",
    "slug": "tarek-elbassyouny",
    "name": "TAREK FETOUH MOHAMED ELBASSYOUNY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBURQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tarek Elbassyouny",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9dea2d77-88f3-423a-a83d-cce889db010e",
        "address": "",
        "phone": "97143456345 / 971582878951",
        "email": "alfalasi_advocates@yahoo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "eb1babc3-0723-4d8e-a69c-728a5dcce69e",
    "firmName": "AL FALASI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01387",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "44967d3f-6b15-4656-9f0a-bfb75161917b",
    "slug": "tarek-fares-rchaid",
    "name": "Tarek Fares Rchaid",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBURgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/10/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2020-04-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tarek Fares Rchaid",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_44967d3f-6b15-4656-9f0a-bfb75161917b",
        "address": "8 ,Burlington Tower ,SAFA park ,46886 ,Dubai",
        "phone": "97143425552 / 971509025904",
        "email": "info@deaifis.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b7a53c09-124c-4689-81ff-992765c70b8a",
    "firmName": "DEAIFIS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03068",
    "licenseIssueDate": "11/10/2014 00:00:00",
    "licenseExpiryDate": "11/04/2020 00:00:00"
  },
  {
    "id": "94067849-1950-485f-b848-8453fc98c852",
    "slug": "tarek-hafez-ahmed-eldib",
    "name": "TAREK HAFEZ AHMED ELDIB",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tarek Hafez Ahmed Eldib",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_94067849-1950-485f-b848-8453fc98c852",
        "address": "",
        "phone": "97142959933",
        "email": "alaliadv@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a65968c3-f5c5-4cf1-89eb-1704f1c99056",
    "firmName": "ABDULLA AL - ALI & ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01537",
    "licenseIssueDate": "02/07/2012 00:00:00",
    "licenseExpiryDate": "01/29/2026 00:00:00"
  },
  {
    "id": "474ae440-c222-4392-b43d-5994e83d8fa8",
    "slug": "tarek-jairwdeh",
    "name": "TAREK MHD MONER JAIRWDEH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tarek Jairwdeh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_474ae440-c222-4392-b43d-5994e83d8fa8",
        "address": "1 ,Park Place Towe ,. ,9353 ,Dubai",
        "phone": "97143317110 / 971000000000",
        "email": "elena@meyer-reumann.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e294ccf7-baca-4016-876d-fcf8d296a3fc",
    "firmName": "Meyer Reumann & Partners",
    "registrationNumber": "L-00346",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "7d5dac9d-a04a-42c0-8b4f-f4218d0b3e45",
    "slug": "tarek-khaled-al-soliman",
    "name": "TAREK KHALED AL SOLIMAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/10/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tarek Khaled Al Soliman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7d5dac9d-a04a-42c0-8b4f-f4218d0b3e45",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506698 ,Dubai",
        "phone": "97147046300 / 971507900661",
        "email": "nada.mourad@lw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b2b92ce9-90a4-4e34-ae2f-ae0dc7ca9060",
    "firmName": "Latham & Watkins LLP",
    "registrationNumber": "L-06543",
    "licenseIssueDate": "10/11/2024 00:00:00",
    "licenseExpiryDate": "10/10/2025 00:00:00"
  },
  {
    "id": "90dd6b88-2f97-428f-bd85-e622a8d6aa40",
    "slug": "tarek-khanachet",
    "name": "TAREK MICHAEL KHANACHET",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/04/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tarek Khanachet",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_90dd6b88-2f97-428f-bd85-e622a8d6aa40",
        "address": "",
        "phone": "97142472100 / 971509224336",
        "email": "bhaley@cov.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "65a2e90a-6978-4292-b3f1-ecbebedd7b9a",
    "firmName": "Covington & Burling LLP (Middle East)",
    "registrationNumber": "L-03713",
    "licenseIssueDate": "04/10/2017 00:00:00",
    "licenseExpiryDate": "04/06/2026 00:00:00"
  },
  {
    "id": "b18c79dd-cb74-458b-b267-afa87bb0bccd",
    "slug": "tarek-mahmoud-al-saadi",
    "name": "TAREK MAHMOUD AL SAADI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/12/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tarek Mahmoud Al Saadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b18c79dd-cb74-458b-b267-afa87bb0bccd",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05671",
    "licenseIssueDate": "12/21/2022 00:00:00",
    "licenseExpiryDate": "12/20/2025 00:00:00"
  },
  {
    "id": "640e6e35-b3a9-4213-8818-6e63bc34c15b",
    "slug": "tarek-muhammad",
    "name": "TAREK MUHAMMAD",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/04/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tarek Muhammad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_640e6e35-b3a9-4213-8818-6e63bc34c15b",
        "address": "yousif almaazmi ,التاسع  ,سيتاديل تاور  ,خلف فندق جي دبليوماريوت  ,94646 ,Dubai",
        "phone": "97144517744",
        "email": "info@cityint.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "59aaa82d-162e-4646-9bcc-f3349dfb2512",
    "firmName": "YOUSEF ALMAAZMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02357",
    "licenseIssueDate": "04/15/2014 00:00:00",
    "licenseExpiryDate": "04/08/2026 00:00:00"
  },
  {
    "id": "c18fe15e-22e4-445a-9fad-306f979fb7c8",
    "slug": "tarek-saad-saad",
    "name": "TAREK SAAD MAHMOUD SAAD",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/09/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tarek Saad Saad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c18fe15e-22e4-445a-9fad-306f979fb7c8",
        "address": "الطابق 7 مكتب رقم 070A ,برج رولكس  ,محطة مترو المركز المالي  ,66300 ,Dubai",
        "phone": "97143444029",
        "email": "ekp.khalidaltmimi@ekplegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "400838f1-4e75-4836-9698-b9e19dd30a18",
    "firmName": "KHALID ABDALLA ALTAMIMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01791",
    "licenseIssueDate": "09/26/2011 00:00:00",
    "licenseExpiryDate": "09/17/2026 00:00:00"
  },
  {
    "id": "c5a98dbf-0f89-4667-9942-35dcd779903b",
    "slug": "tarek-salah-abdalla-ahmed",
    "name": "TAREK SALAH ABDALLA AHMED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/11/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tarek Salah Abdalla Ahmed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c5a98dbf-0f89-4667-9942-35dcd779903b",
        "address": "ali mohamed amin  ,205 - 104  ,اثراء  ,بالقرب من فندق جميرا طيران الامارات  ,10155 ,Dubai",
        "phone": "97143967188",
        "email": "aliadvocates71@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "298ff405-ca8b-4fc8-a674-74ae24832268",
    "firmName": "ALI NAQI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02252",
    "licenseIssueDate": "11/21/2017 00:00:00",
    "licenseExpiryDate": "11/18/2025 00:00:00"
  },
  {
    "id": "fbd6e8c8-e312-4678-b007-f7a24a47e7db",
    "slug": "tarek-saleh-shabaan-hessen-gadalla",
    "name": "TAREK SALEH SHABAAN HESSEN GADALLA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/01/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tarek Saleh Shabaan Hessen Gadalla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fbd6e8c8-e312-4678-b007-f7a24a47e7db",
        "address": "",
        "phone": "97144073901 / 971503479508",
        "email": "Rania.Tadros@stephensonharwood.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dd5042a2-bb41-4123-9544-79c3fa831332",
    "firmName": "Stephenson Harwood (Middle East) LLP",
    "registrationNumber": "L-05706",
    "licenseIssueDate": "01/25/2023 00:00:00",
    "licenseExpiryDate": "01/24/2026 00:00:00"
  },
  {
    "id": "4d0d511b-d668-41ae-b688-812651459424",
    "slug": "tareq-me-toubassi",
    "name": "TAREQ MARWAN EMILE TOUBASSI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/04/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tareq M.E. Toubassi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4d0d511b-d668-41ae-b688-812651459424",
        "address": "1 ,The Gate, East. ,The Gate District ,118273 ,Dubai",
        "phone": "97144019160 / 971506575038",
        "email": "ptiller@huntonak.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "61016a31-ead9-482a-b4d3-7cd63e5ba82b",
    "firmName": "Bracewell LLP",
    "registrationNumber": "L-04898",
    "licenseIssueDate": "04/05/2021 00:00:00",
    "licenseExpiryDate": "04/04/2026 00:00:00"
  },
  {
    "id": "27765aed-9938-40cc-be8c-5384fd36094d",
    "slug": "tareq-thugan-abdallah-obeidat",
    "name": "TAREQ THUGAN ABDALLAH OBEIDAT",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/01/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tareq Thugan Abdallah Obeidat",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_27765aed-9938-40cc-be8c-5384fd36094d",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-04611",
    "licenseIssueDate": "01/15/2020 00:00:00",
    "licenseExpiryDate": "01/14/2026 00:00:00"
  },
  {
    "id": "386bf2e5-6cd0-4051-a7e7-ab533e29c5e8",
    "slug": "tarig-mubarak-ahmed-mahmoud",
    "name": "TARIG MUBARAK AHMED MAHMOUD",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/01/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tarig Mubarak Ahmed Mahmoud",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_386bf2e5-6cd0-4051-a7e7-ab533e29c5e8",
        "address": "",
        "phone": "97122222222",
        "email": "info@ayalegal.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "843234aa-d59b-4763-b69a-ba92f9cbba70",
    "firmName": "ALI YOUSUF ALAWADHI ADVOCATES & LEGAL CONSULTANTS L.L.C",
    "registrationNumber": "L-06667",
    "licenseIssueDate": "01/24/2025 00:00:00",
    "licenseExpiryDate": "01/23/2026 00:00:00"
  },
  {
    "id": "3fad688b-83c9-4cd8-9e63-a00650665bc7",
    "slug": "tarik-tawfik-nassar",
    "name": "TARIK TAWFIK ELSAYED AHMED NASSAR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/04/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tarik Tawfik Nassar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3fad688b-83c9-4cd8-9e63-a00650665bc7",
        "address": "amal albastaki ,1903 ,court ,business bay ,127477 ,Dubai",
        "phone": "97142522202",
        "email": "info@amaladvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "f852bccd-2696-4190-9b40-77a8fb9c460f",
    "firmName": "AMAL ALBASTAKI ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-02030",
    "licenseIssueDate": "05/01/2012 00:00:00",
    "licenseExpiryDate": "04/23/2026 00:00:00"
  },
  {
    "id": "363117f0-9ebe-44b3-b97e-4fec2f31ad68",
    "slug": "tariq-imam",
    "name": "TARIQ ALI IMAM",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Civil Transactions-Ownership & Title",
      "Commercial Transactions-Commercial Real Estate",
      "Civil Transactions-Tenancy",
      "Civil Transactions-Sale"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tariq Imam",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_363117f0-9ebe-44b3-b97e-4fec2f31ad68",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-00194",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "edc95a74-77d9-483b-ae27-a1d9af1f8a40",
    "slug": "tariq-khan-mansoor-ahmad-khan",
    "name": "TARIQ KHAN MANSOOR AHMAD KHAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/02/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tariq Khan Mansoor Ahmad Khan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_edc95a74-77d9-483b-ae27-a1d9af1f8a40",
        "address": "sohail jassem pararin ,34 ,Central Park Tower ,Dubai Mall ,233066 ,Dubai",
        "phone": "97144228410",
        "email": "info@mahmoodhussain.net",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "f3309481-3edd-4503-92d2-bd9f71ba513a",
    "firmName": "MAHMOOD HUSSAIN ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-06674",
    "licenseIssueDate": "02/14/2025 00:00:00",
    "licenseExpiryDate": "02/13/2026 00:00:00"
  },
  {
    "id": "32d3682a-8851-4083-9908-5ab65677d365",
    "slug": "tariq-mohd-zeyad-idais",
    "name": "TARIQ MOHD ZEYAD IBRAHIM IDAIS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/02/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tariq Moh'd Zeyad Idais",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_32d3682a-8851-4083-9908-5ab65677d365",
        "address": "",
        "phone": "97144230555 / 971504788443",
        "email": "yah@hfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c462c65e-185a-4e81-8425-a87e3a2b6842",
    "firmName": "Holman Fenwick Willan Middle East LLP",
    "registrationNumber": "L-02837",
    "licenseIssueDate": "02/17/2022 00:00:00",
    "licenseExpiryDate": "02/16/2026 00:00:00"
  },
  {
    "id": "5aa8c87c-4668-4424-9af4-5d650145e2b6",
    "slug": "taskeen-moolla",
    "name": "TASKEEN MOOLLA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Taskeen Moolla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5aa8c87c-4668-4424-9af4-5d650145e2b6",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-05232",
    "licenseIssueDate": "03/01/2022 00:00:00",
    "licenseExpiryDate": "02/28/2026 00:00:00"
  },
  {
    "id": "412ad37a-196e-426a-85d6-911c58cbc163",
    "slug": "tasleem-sayani",
    "name": "TASLEEM SAYANI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Personal Status-Legacies and Inheritance",
      "Personal Status-Legal Capacity & Guardianship"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/12/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tasleem Sayani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_412ad37a-196e-426a-85d6-911c58cbc163",
        "address": "",
        "phone": "97144073901 / 971503479508",
        "email": "Rania.Tadros@stephensonharwood.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dd5042a2-bb41-4123-9544-79c3fa831332",
    "firmName": "Stephenson Harwood (Middle East) LLP",
    "registrationNumber": "L-00352",
    "licenseIssueDate": "12/17/2011 00:00:00",
    "licenseExpiryDate": "12/08/2025 00:00:00"
  },
  {
    "id": "d30ce991-eb7a-4fc4-8dd4-c7b3e59e46da",
    "slug": "tawfik-taye",
    "name": "TAWFIK GAMIL TAWFIK AHMED TAYE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Civil Transactions-Construction and Contracts for Services",
      "Criminal Law-Family Crimes",
      "Personal Status-Custody & Alimony",
      "Commercial Transactions-Commercial Contracts",
      "Civil Transactions-Immigration and Residency",
      "Civil Transactions-Tenancy",
      "Criminal Law-Crimes against persons",
      "Commercial Transactions-Commercial Companies",
      "Civil Transactions-Labor & Workers",
      "Criminal Law-Drug Crimes",
      "Personal Status-Marriage & Divorce",
      "Criminal Law-Crimes against properties",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/09/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tawfik Taye",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d30ce991-eb7a-4fc4-8dd4-c7b3e59e46da",
        "address": "FATIMA MOHAMMAD ALMAZAM ,3RD FLOOR ,LIBERTY ,BESIDE BANK OF SHARJAH ,35630 ,Dubai",
        "phone": "97142822278",
        "email": "tanany@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5c727678-4d31-4064-9400-932655fce73e",
    "firmName": "ALMASA ADVOCATES",
    "registrationNumber": "L-01406",
    "licenseIssueDate": "09/26/2011 00:00:00",
    "licenseExpiryDate": "09/17/2026 00:00:00"
  },
  {
    "id": "5a1bcd52-95c0-4dee-a560-f037aa4989f1",
    "slug": "tayler-jade-sani",
    "name": "TAYLER JADE SANI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/05/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tayler jade Sani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5a1bcd52-95c0-4dee-a560-f037aa4989f1",
        "address": "",
        "phone": "97144073901 / 971503479508",
        "email": "Rania.Tadros@stephensonharwood.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dd5042a2-bb41-4123-9544-79c3fa831332",
    "firmName": "Stephenson Harwood (Middle East) LLP",
    "registrationNumber": "L-06811",
    "licenseIssueDate": "05/28/2025 00:00:00",
    "licenseExpiryDate": "05/27/2026 00:00:00"
  },
  {
    "id": "14ee0cc9-65cd-4ea8-b636-6734d45ef8cd",
    "slug": "tayler-scott-wright",
    "name": "TAYLER SCOTT WRIGHT",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/06/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tayler Scott Wright",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_14ee0cc9-65cd-4ea8-b636-6734d45ef8cd",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-06371",
    "licenseIssueDate": "06/05/2024 00:00:00",
    "licenseExpiryDate": "06/04/2026 00:00:00"
  },
  {
    "id": "7e4694d8-2017-46b4-8da2-bb7ba5e81d55",
    "slug": "tejas-shiroor",
    "name": "TEJAS SHIROOR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/10/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tejas Shiroor",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7e4694d8-2017-46b4-8da2-bb7ba5e81d55",
        "address": "",
        "phone": "97143897000 / 971506553198",
        "email": "nasseralikhasawneh@eversheds-sutherland.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "74a21d43-41d8-480a-a6af-6939b7c98a95",
    "firmName": "Eversheds Sutherland (International LLP) Dubai Branch",
    "registrationNumber": "L-06041",
    "licenseIssueDate": "10/04/2023 00:00:00",
    "licenseExpiryDate": "10/03/2025 00:00:00"
  },
  {
    "id": "34a7adee-67a7-4ec4-a23a-f86471a5b0de",
    "slug": "terrence-maris-moloney",
    "name": "TERRENCE MARIS MOLONEY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/11/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Terrence Maris Moloney",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_34a7adee-67a7-4ec4-a23a-f86471a5b0de",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-06584",
    "licenseIssueDate": "10/28/2024 00:00:00",
    "licenseExpiryDate": "10/27/2025 00:00:00"
  },
  {
    "id": "bad93f45-cefc-492b-b7d2-bdea7c4b0974",
    "slug": "tessa-crawford",
    "name": "TESSA RUBY MARY CRAWFORD",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/11/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tessa Crawford",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bad93f45-cefc-492b-b7d2-bdea7c4b0974",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05615",
    "licenseIssueDate": "11/02/2022 00:00:00",
    "licenseExpiryDate": "11/01/2025 00:00:00"
  },
  {
    "id": "48b48eb6-bf3f-4e47-bb5c-5562d1795050",
    "slug": "test-lc2-desc",
    "name": "Test LC2 (DESC)",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/09/2021",
    "licenseStatus": "active",
    "licenseExpiry": "2022-09-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Test LC2 (DESC)",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_48b48eb6-bf3f-4e47-bb5c-5562d1795050",
        "address": "",
        "phone": "97140000000 / 971508360023",
        "email": "annadurai@legal.dubai.gov.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "34535f10-f4ea-464a-93a1-5337328fdd81",
    "firmName": "Pro LCF1 (DESC)"
  },
  {
    "id": "7dd16d44-4385-4394-b8bb-082f22d65126",
    "slug": "test-user",
    "name": "Test User",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUVQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/12/2014",
    "licenseStatus": "active",
    "licenseExpiry": "2015-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Test User",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7dd16d44-4385-4394-b8bb-082f22d65126",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member"
  },
  {
    "id": "90ff86c2-c177-41cd-8b37-29984b3dbc30",
    "slug": "thabile-zamanguni-gcabashe",
    "name": "THABILE ZAMANGUNI FRANCIS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUWgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/10/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Thabile Zamanguni Gcabashe",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_90ff86c2-c177-41cd-8b37-29984b3dbc30",
        "address": "",
        "phone": "97143563900 / 971564663035",
        "email": "c.miller@Beale-Law.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0f74c5fc-87d6-451a-b380-576b0bc3ceb8",
    "firmName": "Beale & Company (Middle East)",
    "registrationNumber": "L-06538",
    "licenseIssueDate": "10/09/2024 00:00:00",
    "licenseExpiryDate": "10/08/2026 00:00:00"
  },
  {
    "id": "41ce07ab-3536-429e-ad00-63450a5b5a19",
    "slug": "thabit-mohammed-abdullah-altameemi",
    "name": "THABIT MOHAMMED ABDULLAH ALTAMEEMI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/10/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Thabit Mohammed Abdullah Altameemi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_41ce07ab-3536-429e-ad00-63450a5b5a19",
        "address": "1 ,The Gate, East. ,The Gate District ,118273 ,Dubai",
        "phone": "97144019160 / 971506575038",
        "email": "ptiller@huntonak.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "61016a31-ead9-482a-b4d3-7cd63e5ba82b",
    "firmName": "Hunton Andrews Kurth Ltd",
    "registrationNumber": "L-07009"
  },
  {
    "id": "e51a6950-ff4b-454e-810c-e7f35e66448b",
    "slug": "thai-scott",
    "name": "THAI SCOTT",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/03/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Thai Scott",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e51a6950-ff4b-454e-810c-e7f35e66448b",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-06718",
    "licenseIssueDate": "03/12/2025 00:00:00",
    "licenseExpiryDate": "03/11/2026 00:00:00"
  },
  {
    "id": "a74e53ed-cf07-4e2b-af75-e2569b8c349a",
    "slug": "thamer-towfic-louis-shomar",
    "name": "Thamer Towfic Louis Shomar",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/03/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Thamer Towfic Louis Shomar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a74e53ed-cf07-4e2b-af75-e2569b8c349a",
        "address": "",
        "phone": "97144478700 / 971528553200",
        "email": "Thomas.Wilson@squirepb.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "85be541a-c87f-45a9-a321-d90abd6b7298",
    "firmName": "Squire Patton Boggs (MEA) LLP",
    "registrationNumber": "L-06513",
    "licenseIssueDate": "10/03/2024 00:00:00",
    "licenseExpiryDate": "10/02/2026 00:00:00"
  },
  {
    "id": "a28d2f24-44bd-4b79-9785-923febee7ed6",
    "slug": "tharwat-ali-mohamed-abdeltawab",
    "name": "THARWAT ALI MOHAMED ABDELTAWAB",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/07/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tharwat Ali Mohamed Abdeltawab",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a28d2f24-44bd-4b79-9785-923febee7ed6",
        "address": "HANI RAJAB MOOSA ABDULLA ALJASMI ,M ,LIBERTY ,SHARJAH BANK ,123887 ,Dubai",
        "phone": "97142957744",
        "email": "info@aljasmilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "04b37ea9-3ebd-45ff-9b0f-56fa9ee7e6fd",
    "firmName": "HANI AL JASMI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-05932",
    "licenseIssueDate": "07/12/2023 00:00:00",
    "licenseExpiryDate": "07/11/2026 00:00:00"
  },
  {
    "id": "a3d240f9-5701-4393-8c49-6fc56bc37a33",
    "slug": "thembela-sifiso-mzwandile-ndwandwe",
    "name": "THEMBELA SIFISO MZWANDILE NDWANDWE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/02/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Thembela Sifiso Mzwandile Ndwandwe",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a3d240f9-5701-4393-8c49-6fc56bc37a33",
        "address": "0 ,ICD Brookfield Place Level 13 ,Trade Centre ,506569 ,Dubai",
        "phone": "97145099100 / 971501006965",
        "email": "menahr@freshfields.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "970f6246-e737-41a7-9c6c-5aa5b8335d45",
    "firmName": "Freshfields LLP DIFC",
    "registrationNumber": "L-04620",
    "licenseIssueDate": "02/14/2024 00:00:00",
    "licenseExpiryDate": "02/13/2026 00:00:00"
  },
  {
    "id": "df443aa5-5e69-4fb1-895d-8d3abfe80077",
    "slug": "thenjiwe-pamela-moyo",
    "name": "Thenjiwe Pamela Moyo",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/04/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Thenjiwe Pamela Moyo",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_df443aa5-5e69-4fb1-895d-8d3abfe80077",
        "address": "Burj Daman ,Dubai International Financial Center ,213241 ,",
        "phone": "97144549586 / 971564189768",
        "email": "darrenaharris123@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3cb06a05-1ad1-4487-9624-c2b716bfd2a7",
    "firmName": "Gateley UK LLP",
    "registrationNumber": "L-01115",
    "licenseIssueDate": "04/04/2012 00:00:00",
    "licenseExpiryDate": "03/26/2026 00:00:00"
  },
  {
    "id": "fb120a53-de68-44ab-92af-30ba246ce36f",
    "slug": "theresa-abrefa",
    "name": "Theresa Abrefa",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/08/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Theresa Abrefa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fb120a53-de68-44ab-92af-30ba246ce36f",
        "address": "IH-00-01-CP-05 ,DIFC ,506832 ,",
        "phone": "/ 971506957753",
        "email": "admin@supportlegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "1607c199-ca4b-4bc1-89e9-98dad0300645",
    "firmName": "Support Legal ( DIFC) Limited",
    "registrationNumber": "L-06307",
    "licenseIssueDate": "05/08/2024 00:00:00",
    "licenseExpiryDate": "05/07/2026 00:00:00"
  },
  {
    "id": "9ede184c-d175-4644-a021-ed8631932a73",
    "slug": "therese-abou-zeid",
    "name": "THERESE ABOU ZEID EP FADI NAKHLE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Therese Abou-Zeid",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9ede184c-d175-4644-a021-ed8631932a73",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-00679",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "56f7365d-9ac1-4a67-a530-3ee8a0d6a792",
    "slug": "theunis-cornelis-claassen",
    "name": "THEUNIS CORNELIS CLAASSEN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/05/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Theunis Cornelis Claassen",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_56f7365d-9ac1-4a67-a530-3ee8a0d6a792",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-05807",
    "licenseIssueDate": "05/24/2023 00:00:00",
    "licenseExpiryDate": "05/23/2026 00:00:00"
  },
  {
    "id": "19949151-69fb-485f-a05a-aa99fc6a2087",
    "slug": "thomas-barrington-anderson",
    "name": "THOMAS BARRINGTON ANDERSON",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/04/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Thomas Barrington Anderson",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_19949151-69fb-485f-a05a-aa99fc6a2087",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-05272",
    "licenseIssueDate": "04/26/2022 00:00:00",
    "licenseExpiryDate": "04/25/2026 00:00:00"
  },
  {
    "id": "2f7d126c-8a94-46dd-a4bc-bb8b445f5031",
    "slug": "thomas-bicknell",
    "name": "THOMAS DAVID BICKNELL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/10/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Thomas Bicknell",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2f7d126c-8a94-46dd-a4bc-bb8b445f5031",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-02291",
    "licenseIssueDate": "10/11/2024 00:00:00",
    "licenseExpiryDate": "10/10/2026 00:00:00"
  },
  {
    "id": "c6abdccd-fcb3-4c30-a984-7c3961dda53f",
    "slug": "thomas-briggs",
    "name": "Thomas Briggs",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/23/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Thomas Briggs",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c6abdccd-fcb3-4c30-a984-7c3961dda53f",
        "address": "IH-00-01-CP-05 ,DIFC ,506832 ,",
        "phone": "/ 971506957753",
        "email": "admin@supportlegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "1607c199-ca4b-4bc1-89e9-98dad0300645",
    "firmName": "Support Legal ( DIFC) Limited",
    "registrationNumber": "L-03591",
    "licenseIssueDate": "02/23/2022 00:00:00",
    "licenseExpiryDate": "02/22/2026 00:00:00"
  },
  {
    "id": "2fb5d6fc-f01c-467f-a040-1d31dbb2c41d",
    "slug": "thomas-cochrane",
    "name": "Thomas Cochrane",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/17/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-08-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Thomas Cochrane",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2fb5d6fc-f01c-467f-a040-1d31dbb2c41d",
        "address": "",
        "phone": "97143637999 / 971506525633",
        "email": "daniel.wood@walkersglobal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a3a9927b-d51c-490c-8be6-d575ea3eb041",
    "firmName": "Walkers (Middle East) LLP",
    "registrationNumber": "L-00691",
    "licenseIssueDate": "01/17/2012 00:00:00",
    "licenseExpiryDate": "01/08/2026 00:00:00"
  },
  {
    "id": "5ab353e8-c4f2-4ad3-9b8e-37b8b2f5cdfc",
    "slug": "thomas-david-swarbrick",
    "name": "THOMAS DAVID SWARBRICK",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBURAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/03/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Thomas David Swarbrick",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5ab353e8-c4f2-4ad3-9b8e-37b8b2f5cdfc",
        "address": "",
        "phone": "97143506800 / 971507244940",
        "email": "Chris.Williams@bracewelllaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "106d3ee7-86f2-4eae-9b49-fd8423095983",
    "firmName": "Bracewell LLP",
    "registrationNumber": "L-04363",
    "licenseIssueDate": "04/01/2019 00:00:00",
    "licenseExpiryDate": "03/30/2026 00:00:00"
  },
  {
    "id": "4b7998b9-1fc8-40fb-99cd-c7f1e7e0fb8f",
    "slug": "thomas-duncan-farrar-lloyd",
    "name": "THOMAS DUNCAN FARRAR LLOYD",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBURAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/01/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Thomas Duncan Farrar Lloyd",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4b7998b9-1fc8-40fb-99cd-c7f1e7e0fb8f",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-05198",
    "licenseIssueDate": "02/01/2022 00:00:00",
    "licenseExpiryDate": "01/31/2026 00:00:00"
  },
  {
    "id": "19a112f1-4d9e-4d1e-be49-d7668f081c85",
    "slug": "thomas-guy-nolda",
    "name": "THOMAS GUY NOLDA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBURwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/04/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Thomas Guy Nolda",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_19a112f1-4d9e-4d1e-be49-d7668f081c85",
        "address": "Hamdan Abdullah Abdulrahman Ali Alharmi ,2 office 211 ,MSM 1 ,Auto Land Motors ,6064 ,Dubai",
        "phone": "97142999559",
        "email": "hamdan@harmilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b0830edc-21a4-4df9-9d83-febcab7756da",
    "firmName": "HAMDAN AL HARMI & ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05313",
    "licenseIssueDate": "04/26/2022 00:00:00",
    "licenseExpiryDate": "04/25/2026 00:00:00"
  },
  {
    "id": "d7cf37f0-2cd6-49de-ba86-6eb6893700ab",
    "slug": "thomas-moore-thesing",
    "name": "Thomas Moore Thesing",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/28/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Thomas Moore Thesing",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d7cf37f0-2cd6-49de-ba86-6eb6893700ab",
        "address": "",
        "phone": "/ 971000000000",
        "email": "tthesing@sidley.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "32091971-c716-41d1-a21d-cc50c9fb3214",
    "firmName": "Sidley Austin LLP",
    "registrationNumber": "L-06778",
    "licenseIssueDate": "05/28/2025 00:00:00",
    "licenseExpiryDate": "05/27/2026 00:00:00"
  },
  {
    "id": "c91521ac-7326-4c36-983b-0c60d8157b23",
    "slug": "thomas-neighbour",
    "name": "THOMAS MATTHEW NEIGHBOUR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/10/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Thomas Neighbour",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c91521ac-7326-4c36-983b-0c60d8157b23",
        "address": "",
        "phone": "97144230555 / 971504788443",
        "email": "yah@hfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c462c65e-185a-4e81-8425-a87e3a2b6842",
    "firmName": "Holman Fenwick Willan Middle East LLP",
    "registrationNumber": "L-02930",
    "licenseIssueDate": "10/26/2014 00:00:00",
    "licenseExpiryDate": "10/20/2026 00:00:00"
  },
  {
    "id": "e89f92fc-b943-4fdf-ae9f-d20565ea8d0f",
    "slug": "thomas-parkin",
    "name": "THOMAS PARKIN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/05/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Thomas Parkin",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e89f92fc-b943-4fdf-ae9f-d20565ea8d0f",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-04665",
    "licenseIssueDate": "05/27/2024 00:00:00",
    "licenseExpiryDate": "05/26/2026 00:00:00"
  },
  {
    "id": "dfa7a220-a0c5-4b91-8057-312ef7b26e0f",
    "slug": "thomas-robert-r-jacques",
    "name": "THOMAS ROBERT R JACQUES",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/02/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Thomas Robert R Jacques",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dfa7a220-a0c5-4b91-8057-312ef7b26e0f",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-04848",
    "licenseIssueDate": "02/15/2021 00:00:00",
    "licenseExpiryDate": "02/14/2026 00:00:00"
  },
  {
    "id": "c5f28bfb-be16-420c-ae73-c0a5a2e4cbcd",
    "slug": "thomas-snider",
    "name": "THOMAS ROBERT SNIDER",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/03/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Thomas Snider",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c5f28bfb-be16-420c-ae73-c0a5a2e4cbcd",
        "address": "20 ,Index Tower West Tower ,DIFC ,507226 ,Dubai",
        "phone": "97142461900 / 971523391604",
        "email": "patrick.gearon@crsblaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e2ac552e-b9a7-450b-a84d-15119e583220",
    "firmName": "Charles Russell Speechlys LLP",
    "registrationNumber": "L-03681",
    "licenseIssueDate": "03/07/2017 00:00:00",
    "licenseExpiryDate": "03/03/2026 00:00:00"
  },
  {
    "id": "d33bde22-8332-4e85-94b6-193f1a597d69",
    "slug": "thomas-stanton-calvert",
    "name": "THOMAS STANTON CALVERT",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/01/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Thomas Stanton Calvert",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d33bde22-8332-4e85-94b6-193f1a597d69",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-05692",
    "licenseIssueDate": "01/18/2023 00:00:00",
    "licenseExpiryDate": "01/17/2026 00:00:00"
  },
  {
    "id": "1968b8d4-ed94-4d57-8b87-45390dc7e6b5",
    "slug": "thomas-william-gordon-bramah",
    "name": "THOMAS WILLIAM GORDON BRAMAH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/02/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Thomas William Gordon Bramah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1968b8d4-ed94-4d57-8b87-45390dc7e6b5",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-04600",
    "licenseIssueDate": "02/27/2020 00:00:00",
    "licenseExpiryDate": "02/26/2026 00:00:00"
  },
  {
    "id": "c6ff5659-91e8-4475-80ff-5e23e4e0b5f8",
    "slug": "thomas-wilson",
    "name": "Thomas Wilson",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/15/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Thomas Wilson",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c6ff5659-91e8-4475-80ff-5e23e4e0b5f8",
        "address": "",
        "phone": "97144478700 / 971528553200",
        "email": "Thomas.Wilson@squirepb.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "85be541a-c87f-45a9-a321-d90abd6b7298",
    "firmName": "Squire Patton Boggs (MEA) LLP",
    "registrationNumber": "L-00928",
    "licenseIssueDate": "02/15/2022 00:00:00",
    "licenseExpiryDate": "02/14/2026 00:00:00"
  },
  {
    "id": "79e3fa3d-d711-451c-b9a1-5d33c8b87d31",
    "slug": "thulisile-moatlhodi",
    "name": "THULISILE MOATLHODI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/05/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Thulisile Moatlhodi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_79e3fa3d-d711-451c-b9a1-5d33c8b87d31",
        "address": "",
        "phone": "97145032600 / 971504577931",
        "email": "edmund.boyo@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8cca52de-2c74-4743-b8f2-0b904d96b132",
    "firmName": "CC Worldwide Limited",
    "registrationNumber": "L-06781",
    "licenseIssueDate": "05/14/2025 00:00:00",
    "licenseExpiryDate": "05/13/2026 00:00:00"
  },
  {
    "id": "808169dd-f603-4931-9416-7959041d3b09",
    "slug": "tien-tai",
    "name": "TIEN TAI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tien Tai",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_808169dd-f603-4931-9416-7959041d3b09",
        "address": "",
        "phone": "97144230555 / 971504788443",
        "email": "yah@hfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c462c65e-185a-4e81-8425-a87e3a2b6842",
    "firmName": "Holman Fenwick Willan Middle East LLP",
    "registrationNumber": "L-00426",
    "licenseIssueDate": "02/25/2012 00:00:00",
    "licenseExpiryDate": "02/16/2026 00:00:00"
  },
  {
    "id": "2971843d-5966-4c18-bd85-de3aad7e19fb",
    "slug": "tigran-saakian",
    "name": "TIGRAN SAAKIAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/07/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tigran Saakian",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2971843d-5966-4c18-bd85-de3aad7e19fb",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-05408",
    "licenseIssueDate": "07/27/2022 00:00:00",
    "licenseExpiryDate": "07/26/2026 00:00:00"
  },
  {
    "id": "6eba6ae0-c411-4a21-82f1-1a51d8bdac63",
    "slug": "tijana-suvacarov",
    "name": "TIJANA SUVACAROV",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/05/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tijana Suvacarov",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6eba6ae0-c411-4a21-82f1-1a51d8bdac63",
        "address": "",
        "phone": "97147098484 / 971505577206",
        "email": "slshadmand@jonesday.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8892bfe9-d3ec-4158-b4fd-1844606f4f30",
    "firmName": "Jones Day",
    "registrationNumber": "L-06788",
    "licenseIssueDate": "05/14/2025 00:00:00",
    "licenseExpiryDate": "05/13/2026 00:00:00"
  },
  {
    "id": "bb9ab115-846b-43ec-b25c-7b8383ff865c",
    "slug": "tillie-ines-rose",
    "name": "TILLIE INES ROSE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/05/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: TILLIE INES ROSE",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bb9ab115-846b-43ec-b25c-7b8383ff865c",
        "address": "Emirates Financial Towers (South) ,DIFC ,506546 ,",
        "phone": "97147096700 / 971505573843",
        "email": "dk@kbh.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "291a9c0d-030a-4cef-8739-c6946f741117",
    "firmName": "KBH Limited",
    "registrationNumber": "L-06710",
    "licenseIssueDate": "03/05/2025 00:00:00",
    "licenseExpiryDate": "03/04/2026 00:00:00"
  },
  {
    "id": "f6980695-d5c0-4856-ba41-eb6c5727064c",
    "slug": "timofey-nosov",
    "name": "TIMOFEY NOSOV",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/02/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Timofey Nosov",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f6980695-d5c0-4856-ba41-eb6c5727064c",
        "address": "",
        "phone": "97143685555",
        "email": "maisa.maarouf@bsabh.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8afa232f-52ff-4dad-82c3-9a04d66eb853",
    "firmName": "B S A AHMED BIN HAZEEM & ASSOCIATES LLP - DIFC",
    "registrationNumber": "L-06649",
    "licenseIssueDate": "02/14/2025 00:00:00",
    "licenseExpiryDate": "02/13/2026 00:00:00"
  },
  {
    "id": "51626808-b36b-45ec-aff0-0939a2d1c95b",
    "slug": "timothy-casben",
    "name": "TIMOTHY JOHN CASBEN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/01/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Timothy Casben",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_51626808-b36b-45ec-aff0-0939a2d1c95b",
        "address": "Level 17, ICD Brookfield Place ,DIFC ,506503 ,",
        "phone": "97144375100 / 971588271196",
        "email": "libby.edwards-smith@gowlingwlg.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "436703ba-b9c0-4dcb-93b2-1299c7a051f4",
    "firmName": "Gowling WLG (UK) LLP (Dubai Branch)",
    "registrationNumber": "L-00834",
    "licenseIssueDate": "01/06/2012 00:00:00",
    "licenseExpiryDate": "12/28/2025 00:00:00"
  },
  {
    "id": "bacddba0-1ebe-4308-9e47-2f896f013e00",
    "slug": "timothy-james-travers",
    "name": "Timothy James Travers",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/06/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-06-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Timothy James Travers",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bacddba0-1ebe-4308-9e47-2f896f013e00",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "registrationNumber": "L-04141",
    "licenseIssueDate": "06/20/2018 00:00:00",
    "licenseExpiryDate": "06/19/2019 00:00:00"
  },
  {
    "id": "a9c6b046-22b8-4212-a0d2-90752073a4a3",
    "slug": "timothy-john-armsby",
    "name": "TIMOTHY JOHN ARMSBY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/05/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Timothy John Armsby",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a9c6b046-22b8-4212-a0d2-90752073a4a3",
        "address": "THE OFFICES 1 ,DWTC ,115580 ,",
        "phone": "97143739700 / 971501148248",
        "email": "nitesh.pradhan@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "361fdc64-6b6f-4f37-abca-c52af8473b84",
    "firmName": "Pinsent Masons  LLP (DWTCA Branch)",
    "registrationNumber": "L-04113",
    "licenseIssueDate": "05/28/2018 00:00:00",
    "licenseExpiryDate": "05/26/2026 00:00:00"
  },
  {
    "id": "a279aefc-2465-4e4f-a661-5a957eacc21e",
    "slug": "timothy-peter-cardiff",
    "name": "TIMOTHY PETER CARDIFF",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/08/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Timothy Peter Cardiff",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a279aefc-2465-4e4f-a661-5a957eacc21e",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-05454",
    "licenseIssueDate": "08/03/2022 00:00:00",
    "licenseExpiryDate": "08/02/2026 00:00:00"
  },
  {
    "id": "6c1737f2-a387-471a-80d5-69dd4480ee8a",
    "slug": "tina-asgarian",
    "name": "TINA ASGARIAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/09/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tina Asgarian",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6c1737f2-a387-471a-80d5-69dd4480ee8a",
        "address": "Unit No. S1003, Level 10 ,Emirates Financial Towers ,Dubai International Financial Centre ,000 ,Dubai",
        "phone": "97144501900 / 971566072398",
        "email": "david.welford@ogier.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7387d35c-79ea-44c2-88c5-58669a5e825d",
    "firmName": "Ogier (DIFC) LLP",
    "registrationNumber": "L-04377",
    "licenseIssueDate": "09/12/2021 00:00:00",
    "licenseExpiryDate": "09/11/2026 00:00:00"
  },
  {
    "id": "e41b3dd5-bb59-4908-9f93-6cfc05524854",
    "slug": "tina-hsieh",
    "name": "TINA HSIEH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/05/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tina Hsieh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e41b3dd5-bb59-4908-9f93-6cfc05524854",
        "address": "Al Fattan Currency House Tower 2 ,DIFC ,507176 ,",
        "phone": "/ 971552009003",
        "email": "Mohammad.AlRasheed@bakermckenzie.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "acd81e81-dead-4f7c-839e-0f2a57897265",
    "firmName": "Baker & Mckenzie LLP",
    "registrationNumber": "L-06316",
    "licenseIssueDate": "05/22/2024 00:00:00",
    "licenseExpiryDate": "05/21/2026 00:00:00"
  },
  {
    "id": "1a39fef6-3679-4077-bae5-a3b565b75139",
    "slug": "tina-sharma",
    "name": "TINA SHARMA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/07/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tina Sharma",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1a39fef6-3679-4077-bae5-a3b565b75139",
        "address": "",
        "phone": "97143506800 / 971507244940",
        "email": "Chris.Williams@bracewelllaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "106d3ee7-86f2-4eae-9b49-fd8423095983",
    "firmName": "Bracewell LLP",
    "registrationNumber": "L-06884",
    "licenseIssueDate": "07/09/2025 00:00:00",
    "licenseExpiryDate": "07/08/2026 00:00:00"
  },
  {
    "id": "e5ecd306-1d31-4436-90aa-07c103cecd6e",
    "slug": "tinille-letricia-soupen",
    "name": "TINILLE LETRICIA SOUPEN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/01/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tinille Letricia Soupen",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e5ecd306-1d31-4436-90aa-07c103cecd6e",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-05696",
    "licenseIssueDate": "01/18/2023 00:00:00",
    "licenseExpiryDate": "01/17/2026 00:00:00"
  },
  {
    "id": "177afac7-f4f8-4f35-a1fb-f704a9455b04",
    "slug": "tinyiko-mbhekwa-ndlovu",
    "name": "TINYIKO MBHEKWA NDLOVU",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/07/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tinyiko Mbhekwa Ndlovu",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_177afac7-f4f8-4f35-a1fb-f704a9455b04",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-05871",
    "licenseIssueDate": "07/05/2023 00:00:00",
    "licenseExpiryDate": "07/04/2026 00:00:00"
  },
  {
    "id": "a4afa3a0-96ee-46d3-81ef-5fc5129349eb",
    "slug": "tochukwunna-idowu-israel-bolarinwa",
    "name": "TOCHUKWUNNA IDOWU ISRAEL BOLARINWA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/11/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: TOCHUKWUNNA IDOWU ISRAEL BOLARINWA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a4afa3a0-96ee-46d3-81ef-5fc5129349eb",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-06587",
    "licenseIssueDate": "11/06/2024 00:00:00",
    "licenseExpiryDate": "11/05/2025 00:00:00"
  },
  {
    "id": "a4718e15-cbf1-4007-945d-2dd8413b2f44",
    "slug": "tohin-munshi",
    "name": "TOHIN MUNSHI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/03/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tohin Munshi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a4718e15-cbf1-4007-945d-2dd8413b2f44",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Simmons & Simmons (Middle East) LLP-DIFC",
    "registrationNumber": "L-06706",
    "licenseIssueDate": "03/05/2025 00:00:00",
    "licenseExpiryDate": "03/04/2026 00:00:00"
  },
  {
    "id": "8bd56821-b7d7-4da7-b66f-d859b0492858",
    "slug": "toluwanimi-oluwafayokunlefunmi-arowojolu",
    "name": "TOLUWANIMI OLUWAFAYOKUNLEFUNMI AROWOJOLU",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/04/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Toluwanimi Oluwafayokunlefunmi Arowojolu",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8bd56821-b7d7-4da7-b66f-d859b0492858",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-04653",
    "licenseIssueDate": "04/23/2020 00:00:00",
    "licenseExpiryDate": "04/22/2026 00:00:00"
  },
  {
    "id": "d2dc55f6-cb28-414d-9119-9e06acc06ef5",
    "slug": "tom-francis-langsford",
    "name": "TOM FRANCIS LANGSFORD",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBURgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/08/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tom Francis Langsford",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d2dc55f6-cb28-414d-9119-9e06acc06ef5",
        "address": "6 ,Office Nos. 603, 604 & 605, Level 6, Burj Daman ,Dubai International Financial Centre ,506555 ,Dubai",
        "phone": "97143506400 / 971504654755",
        "email": "r.hickman@aglaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8690f7d5-6b96-4649-9589-71303f2c2707",
    "firmName": "Addleshaw Goddard (Middle East) LLP",
    "registrationNumber": "L-04472",
    "licenseIssueDate": "08/22/2019 00:00:00",
    "licenseExpiryDate": "08/21/2026 00:00:00"
  },
  {
    "id": "738fe84a-694f-4382-9a3b-6ed1bb38226d",
    "slug": "tom-keya",
    "name": "TOM KEYA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/05/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tom Keya",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_738fe84a-694f-4382-9a3b-6ed1bb38226d",
        "address": "6F 603, 605, 7F 704 ,Crystal Tower ,Dubai Mall ,117538 ,Dubai",
        "phone": "97146098700",
        "email": "pro@miolawfirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "417f90a1-03be-4dab-8eea-1bba7e16f536",
    "firmName": "ABU BAKER SALEM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05813",
    "licenseIssueDate": "05/11/2023 00:00:00",
    "licenseExpiryDate": "05/10/2026 00:00:00"
  },
  {
    "id": "53d294c5-e378-49fa-beff-5717fd19a3da",
    "slug": "tomas-cerdan",
    "name": "Tomas Cerdan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/21/2015 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tomas Cerdan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_53d294c5-e378-49fa-beff-5717fd19a3da",
        "address": "",
        "phone": "97144478700 / 971528553200",
        "email": "Thomas.Wilson@squirepb.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "85be541a-c87f-45a9-a321-d90abd6b7298",
    "firmName": "Squire Patton Boggs (MEA) LLP",
    "registrationNumber": "L-02943",
    "licenseIssueDate": "04/21/2015 00:00:00",
    "licenseExpiryDate": "04/16/2026 00:00:00"
  },
  {
    "id": "4a46c599-3c8d-43a4-ae9e-f59af7de0221",
    "slug": "tonderai-tapiwa-wellington-nyandoro",
    "name": "TONDERAI TAPIWA WELLINGTON NYANDORO",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/02/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tonderai Tapiwa Wellington Nyandoro",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4a46c599-3c8d-43a4-ae9e-f59af7de0221",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-04019",
    "licenseIssueDate": "02/26/2018 00:00:00",
    "licenseExpiryDate": "02/23/2026 00:00:00"
  },
  {
    "id": "7b71f691-64d7-4a4b-bb0e-49fa3ec41acc",
    "slug": "toni-badra",
    "name": "TONI BADRA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/10/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Toni Badra",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7b71f691-64d7-4a4b-bb0e-49fa3ec41acc",
        "address": "1201 ,برج تريو اي بي اي اوفيس  ,فندق نوافتيل ,8812 ,Dubai",
        "phone": "97144222555",
        "email": "lutfilaw2020@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9a3d884b-a443-4037-9eb4-f810c596cf33",
    "firmName": "LUTFI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-07000"
  },
  {
    "id": "35d48190-61c5-48e3-a14b-536c797a1687",
    "slug": "toni-prskalo",
    "name": "TONI PRSKALO",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/07/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Toni Prskalo",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_35d48190-61c5-48e3-a14b-536c797a1687",
        "address": "ICD Brookfield Place ,DIFC ,120109 ,",
        "phone": "97143173000 / 971504465229",
        "email": "DubaiLAD@akingump.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9ff29eab-adb8-40f9-ab84-216e01a381e4",
    "firmName": "Akin Gump Strauss Hauer & Feld LLP",
    "registrationNumber": "L-06894",
    "licenseIssueDate": "07/09/2025 00:00:00",
    "licenseExpiryDate": "07/08/2026 00:00:00"
  },
  {
    "id": "871abb87-988f-41b1-96bc-ace46d7af2d9",
    "slug": "tony-maalouli",
    "name": "TONY FOUAD MAALOULI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Commercial Agency",
      "Proceedings-Cases and Proceedings before Dubai International Financial Centre",
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Civil Transactions-POA & Sponsorship",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Civil Transactions-Insurance",
      "Civil Transactions-Construction and Contracts for Services",
      "Civil Transactions-Ownership & Title",
      "Civil Transactions-HR & Employee Affairs",
      "Commercial Transactions-Commercial Mortgage",
      "Criminal Law-Family Crimes",
      "Personal Status-Custody & Alimony",
      "Commercial Transactions-Commercial Contracts",
      "Commercial Transactions-Bankruptcy",
      "Commercial Transactions-Commercial Real Estate",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Civil Transactions-Arbitration",
      "Criminal Law-Hate crimes",
      "Civil Transactions-Tenancy",
      "Commercial Transactions-Unfair competition",
      "Criminal Law-Crimes against persons",
      "Personal Status-Legacies and Inheritance",
      "Commercial Transactions-Commercial Companies",
      "Civil Transactions-Labor & Workers",
      "Personal Status-Legal Capacity & Guardianship",
      "Criminal Law-Drug Crimes",
      "Civil Transactions-Sale",
      "Proceedings-Cases and Proceedings before arbitral tribunals and other alternative dispute resolution bodies",
      "Personal Status-Marriage & Divorce",
      "Personal Status-Child Abuse & Abduction",
      "Civil Transactions-Compensation",
      "Commercial Transactions-Stock",
      "Criminal Law-Crimes against properties",
      "Commercial Transactions-E-Commerce",
      "Criminal Law-Cybercrimes",
      "Commercial Transactions-Intellectual Property (includes trademarks",
      "copy rights",
      "patents)",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/10/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: TONY MAALOULI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_871abb87-988f-41b1-96bc-ace46d7af2d9",
        "address": "Mubarak Abdullah ,7 ,Westburry Offices Tower 1 ,Burj Khalifa ,122352 ,Dubai",
        "phone": "97143298711 / 971504649812",
        "email": "proconsult@uaeahead.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c314e20b-1f39-4c2d-8b81-8af5888cee30",
    "firmName": "PROCONSULT ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04249",
    "licenseIssueDate": "10/30/2018 00:00:00",
    "licenseExpiryDate": "10/28/2025 00:00:00"
  },
  {
    "id": "b69cf64a-29c7-4343-882c-58d9adc8da59",
    "slug": "tony-nicholson",
    "name": "TONY KARL NICHOLSON",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Commercial Agency",
      "Commercial Transactions-Commercial Mortgage",
      "Commercial Transactions-Commercial Contracts",
      "Commercial Transactions-Commercial Real Estate",
      "Commercial Transactions-Unfair competition",
      "Commercial Transactions-Commercial Companies",
      "Commercial Transactions-E-Commerce"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/01/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tony Nicholson",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b69cf64a-29c7-4343-882c-58d9adc8da59",
        "address": "",
        "phone": "97144020800 / 971566830829",
        "email": "dean.ryburn@dentons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dfe13b7e-6625-45fd-ad63-9ee83af41194",
    "firmName": "Dentons & Co Dubai Branch-DED",
    "registrationNumber": "L-03790",
    "licenseIssueDate": "01/30/2024 00:00:00",
    "licenseExpiryDate": "01/29/2026 00:00:00"
  },
  {
    "id": "21ae4b74-5a7c-45dd-9910-ab239271e6ac",
    "slug": "toufic-safie",
    "name": "TOUFIC NOURI SAFIE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/09/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Toufic Safie",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_21ae4b74-5a7c-45dd-9910-ab239271e6ac",
        "address": "",
        "phone": "97144073901 / 971503479508",
        "email": "Rania.Tadros@stephensonharwood.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dd5042a2-bb41-4123-9544-79c3fa831332",
    "firmName": "Stephenson Harwood (Middle East) LLP",
    "registrationNumber": "L-02468",
    "licenseIssueDate": "10/01/2012 00:00:00",
    "licenseExpiryDate": "09/23/2026 00:00:00"
  },
  {
    "id": "dd5b669e-a2cb-47d7-8300-3c353d231cd6",
    "slug": "trisha-jivan",
    "name": "TRISHA JIVAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/05/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Trisha Jivan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dd5b669e-a2cb-47d7-8300-3c353d231cd6",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-05792",
    "licenseIssueDate": "05/11/2023 00:00:00",
    "licenseExpiryDate": "05/10/2026 00:00:00"
  },
  {
    "id": "b2c83dc3-bec6-4298-905a-ee50f46d12ae",
    "slug": "tsoline-sarkis-gharibian",
    "name": "Tsoline Sarkis Gharibian",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/31/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tsoline Sarkis Gharibian",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b2c83dc3-bec6-4298-905a-ee50f46d12ae",
        "address": "South Tower, Emirates Financial Towers ,DIFC ,482025 ,",
        "phone": "97145875333 / 971503444388",
        "email": "c.dersahakian@cvml.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e2c6db70-04e7-4c7b-882a-6d2ffe4469ed",
    "firmName": "CVML Limited",
    "registrationNumber": "L-05486",
    "licenseIssueDate": "08/31/2022 00:00:00",
    "licenseExpiryDate": "08/30/2026 00:00:00"
  },
  {
    "id": "0a34527e-c019-4b84-8d4e-7ef5fd4b534e",
    "slug": "tumise-olamide-jegede",
    "name": "TUMISE OLAMIDE JEGEDE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/04/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tumise Olamide Jegede",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0a34527e-c019-4b84-8d4e-7ef5fd4b534e",
        "address": "0 ,ICD Brookfield Place Level 13 ,Trade Centre ,506569 ,Dubai",
        "phone": "97145099100 / 971501006965",
        "email": "menahr@freshfields.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "970f6246-e737-41a7-9c6c-5aa5b8335d45",
    "firmName": "Freshfields LLP DIFC",
    "registrationNumber": "L-04072",
    "licenseIssueDate": "04/16/2018 00:00:00",
    "licenseExpiryDate": "04/13/2026 00:00:00"
  },
  {
    "id": "237fc67b-001c-4ff9-bc21-829fb7239cfe",
    "slug": "tyne-christopher-scott-hugo",
    "name": "TYNE CHRISTOPHER SCOTT HUGO",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/01/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tyne Christopher Scott Hugo",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_237fc67b-001c-4ff9-bc21-829fb7239cfe",
        "address": "",
        "phone": "97143685555",
        "email": "maisa.maarouf@bsabh.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8afa232f-52ff-4dad-82c3-9a04d66eb853",
    "firmName": "B S A AHMED BIN HAZEEM & ASSOCIATES LLP - DIFC",
    "registrationNumber": "L-03962",
    "licenseIssueDate": "01/07/2022 00:00:00",
    "licenseExpiryDate": "01/06/2026 00:00:00"
  },
  {
    "id": "b06c1675-4261-4db0-8953-40963fc542e8",
    "slug": "udayan-mukherjee",
    "name": "UDAYAN MUKHERJEE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBVTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-02-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Udayan Mukherjee",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b06c1675-4261-4db0-8953-40963fc542e8",
        "address": "",
        "phone": "97144020800 / 971566830829",
        "email": "dean.ryburn@dentons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dfe13b7e-6625-45fd-ad63-9ee83af41194",
    "firmName": "Dentons & Co Dubai Branch-DED",
    "registrationNumber": "L-00427",
    "licenseIssueDate": "02/25/2012 00:00:00",
    "licenseExpiryDate": "02/16/2026 00:00:00"
  },
  {
    "id": "0a57e139-148c-4bfa-bbc8-41d004e408cf",
    "slug": "ugonna-edomobi",
    "name": "UGONNA NWAMAKA EDOMOBI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBVRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Civil Transactions-HR & Employee Affairs"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/09/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ugonna Edomobi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0a57e139-148c-4bfa-bbc8-41d004e408cf",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-02330",
    "licenseIssueDate": "09/09/2013 00:00:00",
    "licenseExpiryDate": "09/02/2026 00:00:00"
  },
  {
    "id": "48ef1e11-4a38-4d0b-8ecf-431f825fc716",
    "slug": "umbreen-meenai",
    "name": "UMBREEN FATIMA MEENAI IMRAN ASGHAR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBVTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/10/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Umbreen Meenai",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_48ef1e11-4a38-4d0b-8ecf-431f825fc716",
        "address": "Index Tower ,506548 ,Dubai",
        "phone": "97147096300 / 971506767433",
        "email": "amateen@reedsmith.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b3f87e90-7ce9-4097-82c4-15232365f175",
    "firmName": "Reed Smith LLP",
    "registrationNumber": "L-02843",
    "licenseIssueDate": "10/29/2014 00:00:00",
    "licenseExpiryDate": "10/23/2025 00:00:00"
  },
  {
    "id": "84b9da76-d2ff-47e2-bba9-c3a84d7ec791",
    "slug": "umera-ali",
    "name": "UMERA ALI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBVQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/11/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Umera Ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_84b9da76-d2ff-47e2-bba9-c3a84d7ec791",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506688 ,Dubai",
        "phone": "97147096600 / 971503556811",
        "email": "muneer.khan@simmons-simmons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d1725ca7-06ac-41b2-8d7b-a6e60665b73d",
    "firmName": "Simmons & Simmons (Middle East) LLP-DIFC",
    "registrationNumber": "L-04269",
    "licenseIssueDate": "11/15/2018 00:00:00",
    "licenseExpiryDate": "11/13/2025 00:00:00"
  },
  {
    "id": "539ce035-a3ab-42ff-86db-d0a10cea677c",
    "slug": "umme-salamah-zoher-tyebjee",
    "name": "UMME SALAMAH ZOHER TYEBJEE TYEBJEE ZOHER ABDULHUSEIN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBVUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/12/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Umme Salamah Zoher Tyebjee",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_539ce035-a3ab-42ff-86db-d0a10cea677c",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-06622",
    "licenseIssueDate": "12/11/2024 00:00:00",
    "licenseExpiryDate": "12/10/2025 00:00:00"
  },
  {
    "id": "b09102b7-0620-4729-9366-eee7df4b86df",
    "slug": "ummey-hashmi",
    "name": "UMMEY TAMEEM HASHMI NOORUL HASAN HASHMI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBVSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Commercial Agency",
      "Proceedings-Cases and Proceedings before Dubai International Financial Centre",
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Civil Transactions-POA & Sponsorship",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Personal Status-Wills",
      "Civil Transactions-Construction and Contracts for Services",
      "Civil Transactions-Ownership & Title",
      "Civil Transactions-HR & Employee Affairs",
      "Commercial Transactions-Commercial Mortgage",
      "Criminal Law-Family Crimes",
      "Personal Status-Custody & Alimony",
      "Commercial Transactions-Commercial Contracts",
      "Civil Transactions-Immigration and Residency",
      "Commercial Transactions-Bankruptcy",
      "Commercial Transactions-Commercial Real Estate",
      "Civil Transactions-Arbitration",
      "Criminal Law-Hate crimes",
      "Civil Transactions-Tenancy",
      "Commercial Transactions-Unfair competition",
      "Commercial Transactions-Commercial Companies",
      "Criminal Law-Drug Crimes",
      "Civil Transactions-Sale",
      "Commercial Transactions-Sea and air freight",
      "Proceedings-Cases and Proceedings before arbitral tribunals and other alternative dispute resolution bodies",
      "Commercial Transactions-Consumer protection",
      "Personal Status-Marriage & Divorce",
      "Commercial Transactions-Stock",
      "Criminal Law-Cybercrimes",
      "Commercial Transactions-Intellectual Property (includes trademarks",
      "copy rights",
      "patents)",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/05/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ummey Hashmi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b09102b7-0620-4729-9366-eee7df4b86df",
        "address": "",
        "phone": "97142776075 / 971588324788",
        "email": "avichal@kochhardubai.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "847eff7c-4142-431e-a8d6-f58ff60964f6",
    "firmName": "Kochhar & Co Inc Legal Consultants (Dubai Branch)",
    "registrationNumber": "L-02809",
    "licenseIssueDate": "05/22/2014 00:00:00",
    "licenseExpiryDate": "05/16/2026 00:00:00"
  },
  {
    "id": "c18ee1bb-cb84-4122-8314-4411bf49e163",
    "slug": "umraan-mohammed-naeem",
    "name": "UMRAAN MOHAMMED NAEEM",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBVTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/08/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Umraan Mohammed Naeem",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c18ee1bb-cb84-4122-8314-4411bf49e163",
        "address": "0 ,ICD Brookfield Place Level 13 ,Trade Centre ,506569 ,Dubai",
        "phone": "97145099100 / 971501006965",
        "email": "menahr@freshfields.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "970f6246-e737-41a7-9c6c-5aa5b8335d45",
    "firmName": "Freshfields LLP DIFC",
    "registrationNumber": "L-04466",
    "licenseIssueDate": "08/07/2019 00:00:00",
    "licenseExpiryDate": "08/06/2026 00:00:00"
  },
  {
    "id": "1f37e020-1a24-4ac5-a963-bb6068adbdd7",
    "slug": "unkar-singh-chanian",
    "name": "UNKAR SINGH CHANIAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBVUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/09/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Unkar Singh Chanian",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1f37e020-1a24-4ac5-a963-bb6068adbdd7",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-06976",
    "licenseIssueDate": "09/25/2025 00:00:00",
    "licenseExpiryDate": "09/24/2026 00:00:00"
  },
  {
    "id": "7ce1aff5-59d7-4d7f-afc2-4ebe535161ed",
    "slug": "usama-munir",
    "name": "USAMA MUNIR MUNIR KHAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBVTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/03/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Usama Munir",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7ce1aff5-59d7-4d7f-afc2-4ebe535161ed",
        "address": "A7 ,Dubai Silicon Oasis ,29337 ,",
        "phone": "97144313060 / 971528448686",
        "email": "andres.ring@schlueter-graf.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2ce110f0-b433-4dbc-b15f-ab1a3b291c28",
    "firmName": "Schluter Graf Legal Consultants LLC",
    "registrationNumber": "L-04880",
    "licenseIssueDate": "03/22/2021 00:00:00",
    "licenseExpiryDate": "03/21/2026 00:00:00"
  },
  {
    "id": "467857f7-c06f-4e71-937c-866f7f104bbc",
    "slug": "usman-hamid-malik",
    "name": "USMAN HAMID MALIK",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBVSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/07/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Usman Hamid Malik",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_467857f7-c06f-4e71-937c-866f7f104bbc",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-06447",
    "licenseIssueDate": "07/25/2024 00:00:00",
    "licenseExpiryDate": "07/24/2026 00:00:00"
  },
  {
    "id": "043240b3-6c0a-4c09-b4bd-a1ddb39f0c17",
    "slug": "uzmah-shah",
    "name": "UZMAH SHAH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBVUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/08/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Uzmah Shah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_043240b3-6c0a-4c09-b4bd-a1ddb39f0c17",
        "address": "",
        "phone": "97144020800 / 971566830829",
        "email": "dean.ryburn@dentons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dfe13b7e-6625-45fd-ad63-9ee83af41194",
    "firmName": "Dentons & Co Dubai Branch-DED",
    "registrationNumber": "L-05969",
    "licenseIssueDate": "08/16/2023 00:00:00",
    "licenseExpiryDate": "08/15/2026 00:00:00"
  },
  {
    "id": "c061a4b7-8da1-4f11-a687-d98ba8edbf82",
    "slug": "vadim-iskhakov",
    "name": "VADIM ISKHAKOV",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBWSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/11/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Vadim Iskhakov",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c061a4b7-8da1-4f11-a687-d98ba8edbf82",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-05609",
    "licenseIssueDate": "11/30/2022 00:00:00",
    "licenseExpiryDate": "11/29/2025 00:00:00"
  },
  {
    "id": "69e034be-9db6-4e10-8022-270bc3803f4d",
    "slug": "vaidehi-reddy-keesara-vijayvardhan-reddy-keesara",
    "name": "VAIDEHI REDDY KEESARA VIJAYVARDHAN REDDY KEESARA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBWUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/09/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Vaidehi Reddy Keesara Vijayvardhan Reddy Keesara",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_69e034be-9db6-4e10-8022-270bc3803f4d",
        "address": "",
        "phone": "97143298881",
        "email": "info@mslawuae.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2510dab9-717a-4a15-b189-4272261227e3",
    "firmName": "AL MADHANI & AL SHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06957",
    "licenseIssueDate": "09/03/2025 00:00:00",
    "licenseExpiryDate": "09/02/2026 00:00:00"
  },
  {
    "id": "47710e71-296c-4b8e-a082-31b30b9ca041",
    "slug": "vaishali-dhanawat",
    "name": "VAISHALI DHANAWAT NARAYAN KUMAR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBWRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/03/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Vaishali Dhanawat",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_47710e71-296c-4b8e-a082-31b30b9ca041",
        "address": "",
        "phone": "97143303900 / 971561753537",
        "email": "christopher@afridi-angell.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "30ce50dc-01a6-499d-8ace-3f807ddcb08d",
    "firmName": "Afridi & Angell-DED",
    "registrationNumber": "L-05710",
    "licenseIssueDate": "03/16/2023 00:00:00",
    "licenseExpiryDate": "03/15/2026 00:00:00"
  },
  {
    "id": "e8cb1813-f89a-4b2f-bd71-f54e1630846c",
    "slug": "valery-kalla-nformba",
    "name": "VALERY KALLA NFORMBA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBWSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/06/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Valery Kalla Nformba",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e8cb1813-f89a-4b2f-bd71-f54e1630846c",
        "address": "ICD Brookfield Place ,DIFC ,506516 ,",
        "phone": "97143695800 / 971505526206",
        "email": "scott.campbell@linklaters.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5cec94c0-0649-43b6-a2be-ab17ff422bce",
    "firmName": "LinkLaters LLP",
    "registrationNumber": "L-05370",
    "licenseIssueDate": "06/22/2022 00:00:00",
    "licenseExpiryDate": "06/21/2026 00:00:00"
  },
  {
    "id": "af87b08c-2126-42e6-9080-abd238664a8d",
    "slug": "vasiliki-papadopoulos",
    "name": "VASILIKI MARIA PAPADOPOULOS ARIF",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBWUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/10/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Vasiliki Papadopoulos",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_af87b08c-2126-42e6-9080-abd238664a8d",
        "address": "ICD-Brookfield Place ,DIFC ,119974 ,",
        "phone": "97143652000",
        "email": "david.charlier@ashurst.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c01c3c61-4d90-4058-8429-61dd01e615f5",
    "firmName": "Ashurst LLP-DIFC",
    "registrationNumber": "L-03320",
    "licenseIssueDate": "10/27/2023 00:00:00",
    "licenseExpiryDate": "10/26/2026 00:00:00"
  },
  {
    "id": "1cc773e0-9667-49c2-aa39-7fc77bc14d98",
    "slug": "verena-nosko",
    "name": "VERENA NOSKO",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBWTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/05/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Verena Nosko",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1cc773e0-9667-49c2-aa39-7fc77bc14d98",
        "address": "1 ,Park Place Towe ,. ,9353 ,Dubai",
        "phone": "97143317110 / 971000000000",
        "email": "elena@meyer-reumann.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e294ccf7-baca-4016-876d-fcf8d296a3fc",
    "firmName": "Meyer Reumann & Partners",
    "registrationNumber": "L-05326",
    "licenseIssueDate": "06/01/2022 00:00:00",
    "licenseExpiryDate": "05/31/2026 00:00:00"
  },
  {
    "id": "e26074c1-f691-40c0-9b5e-85dc43f8b5fd",
    "slug": "victor-adel-ragheb-ibrahim",
    "name": "VICTOR ADEL RAGHEB IBRAHIM",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBWQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/05/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: victor adel ragheb ibrahim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e26074c1-f691-40c0-9b5e-85dc43f8b5fd",
        "address": "الثالث  ,برج جيت  48  ,مخرج ميترو برج خليفه / دبي مول  ,181111 ,Dubai",
        "phone": "97145143423 / 971971451434",
        "email": "info.justice@fhsadvo.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "690778ba-3332-4c06-b01f-ab5ec89ee304",
    "firmName": "FATEMA HASAN ALSHEHHI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-04074",
    "licenseIssueDate": "05/06/2025 00:00:00",
    "licenseExpiryDate": "05/05/2026 00:00:00"
  },
  {
    "id": "a339ca8d-7292-4ae2-a352-fea858940620",
    "slug": "victoria-elizabeth-ferres",
    "name": "Victoria Elizabeth Ferres",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBWRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/03/2022",
    "licenseStatus": "active",
    "licenseExpiry": "2023-03-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Victoria Elizabeth Ferres",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a339ca8d-7292-4ae2-a352-fea858940620",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-05278",
    "licenseIssueDate": "03/17/2022 00:00:00",
    "licenseExpiryDate": "03/16/2026 00:00:00"
  },
  {
    "id": "99cb83dc-89d8-42c1-808c-8493a0b32415",
    "slug": "victoria-hambly",
    "name": "VICTORIA KATE ST AMOUR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBWSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/10/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Victoria Hambly",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_99cb83dc-89d8-42c1-808c-8493a0b32415",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "210291f4-864f-4eb4-b150-d4b9536c8005",
    "firmName": "Clifford Chance LLP-DIFC",
    "registrationNumber": "L-03256",
    "licenseIssueDate": "10/24/2022 00:00:00",
    "licenseExpiryDate": "10/23/2026 00:00:00"
  },
  {
    "id": "544a7329-3e12-4563-b2a4-bfc18cca1607",
    "slug": "victoria-jane-clucas",
    "name": "VICTORIA JANE EVANS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBWSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/10/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Victoria Jane Clucas",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_544a7329-3e12-4563-b2a4-bfc18cca1607",
        "address": "Al Fattan Currency House - Tower 1  ,Dubai International Financial Center  ,507104 ,",
        "phone": "97143978565 / 971504587822",
        "email": "Raafat.hares@dwf.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6e5f6dba-07af-4109-8c34-175296450f94",
    "firmName": "DWF (Middle East) LLP",
    "registrationNumber": "L-04779",
    "licenseIssueDate": "10/22/2020 00:00:00",
    "licenseExpiryDate": "10/21/2025 00:00:00"
  },
  {
    "id": "a28bb01c-d734-4125-94fb-d46dbcb5802a",
    "slug": "victoria-woods",
    "name": "VICTORIA MAY WOODS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBWVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/11/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Victoria Woods",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a28bb01c-d734-4125-94fb-d46dbcb5802a",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-02102",
    "licenseIssueDate": "11/11/2012 00:00:00",
    "licenseExpiryDate": "11/03/2025 00:00:00"
  },
  {
    "id": "79fb18b5-98db-4d16-9d9a-8cf8320013a7",
    "slug": "vida-grace-nodque-serrano",
    "name": "VIDA GRACE NODQUE SERRANO",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBWRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/04/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: VIDA GRACE  NODQUE SERRANO",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_79fb18b5-98db-4d16-9d9a-8cf8320013a7",
        "address": "Samia Luqman ,2nd floor ,Emarat Atrium Building ,across Holiday Inn Express Safa Park ,7273 ,Dubai",
        "phone": "97143211000",
        "email": "info@alsuwaidi.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0e5c3637-bc12-475c-a6b5-2d9ae84f2b8e",
    "firmName": "AL-SUWAIDI & COMPANY",
    "registrationNumber": "L-04048",
    "licenseIssueDate": "04/02/2018 00:00:00",
    "licenseExpiryDate": "03/30/2026 00:00:00"
  },
  {
    "id": "14f4c744-8ce3-4ebe-b1f0-0abfb43081ed",
    "slug": "viktoria-carmona",
    "name": "Viktoria Carmona",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBWQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/01/2017",
    "licenseStatus": "active",
    "licenseExpiry": "2018-01-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Viktoria Carmona",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_14f4c744-8ce3-4ebe-b1f0-0abfb43081ed",
        "address": "1 ,Emaar Square 5 ,sheikh mohammed bin rashid BVD ,11987 ,Dubai",
        "phone": "97143043100 / 971507325154",
        "email": "amir.kordvani@pwc.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ea026b18-c93c-4f67-a1f2-4546320f8f3e",
    "firmName": "PWC Legal Middle East LLP",
    "registrationNumber": "L-03567",
    "licenseIssueDate": "01/04/2017 00:00:00",
    "licenseExpiryDate": "12/31/2025 00:00:00"
  },
  {
    "id": "4faa8555-ffb5-46de-8675-d15b8e53f7d4",
    "slug": "vindhya-sarachandra-bose",
    "name": "VINDHYA SARACHANDRA BOSE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBWUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/12/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-11-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Vindhya Sarachandra Bose",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4faa8555-ffb5-46de-8675-d15b8e53f7d4",
        "address": "",
        "phone": "97143355577",
        "email": "daraladalah1991@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "61efd89c-1d0d-4136-8397-2814c745f0da",
    "firmName": "DAR AL ADALAH ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02039",
    "licenseIssueDate": "12/05/2011 00:00:00",
    "licenseExpiryDate": "11/26/2025 00:00:00"
  },
  {
    "id": "d0b60da3-13ca-4cf4-bbd4-912399102afb",
    "slug": "viren-sunil-bhojwani",
    "name": "VIREN SUNIL BHOJWANI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBWUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/11/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: VIREN SUNIL BHOJWANI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d0b60da3-13ca-4cf4-bbd4-912399102afb",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-06565",
    "licenseIssueDate": "11/06/2024 00:00:00",
    "licenseExpiryDate": "11/05/2025 00:00:00"
  },
  {
    "id": "6da73cf2-20d8-47d7-8fff-792494a2f6d7",
    "slug": "virginia-santini",
    "name": "VIRGINIA SANTINI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBWUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/08/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Virginia Santini",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6da73cf2-20d8-47d7-8fff-792494a2f6d7",
        "address": "Building 5 ,Dubai World Trade Centre ,212620 ,",
        "phone": "97143503600 / 971563631562",
        "email": "p.ellingham@kennedys-law.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "83d3ede1-3a28-4b03-8c92-6bd31a1cb95e",
    "firmName": "Kennedys Dubai LLP",
    "registrationNumber": "L-06898",
    "licenseIssueDate": "08/18/2025 00:00:00",
    "licenseExpiryDate": "08/17/2026 00:00:00"
  },
  {
    "id": "09a5a32b-565f-48e1-ab47-aa9cf9916883",
    "slug": "vishal-mukesh-patel",
    "name": "VISHAL MUKESH PATEL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBWTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/11/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Vishal Mukesh Patel",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_09a5a32b-565f-48e1-ab47-aa9cf9916883",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506688 ,Dubai",
        "phone": "97147096600 / 971503556811",
        "email": "muneer.khan@simmons-simmons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "d1725ca7-06ac-41b2-8d7b-a6e60665b73d",
    "firmName": "Simmons & Simmons (Middle East) LLP-DIFC",
    "registrationNumber": "L-06566",
    "licenseIssueDate": "11/06/2024 00:00:00",
    "licenseExpiryDate": "11/05/2025 00:00:00"
  },
  {
    "id": "5eb03a4a-40d0-4005-8dce-373bde957e43",
    "slug": "vivek-kumar-agrawalla",
    "name": "VIVEK KUMAR AGRAWALLA MOHAN LAL AGRAWALLA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBWSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/11/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Vivek Kumar Agrawalla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5eb03a4a-40d0-4005-8dce-373bde957e43",
        "address": "",
        "phone": "97143300009 / 971501215000",
        "email": "mohamed@maa.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "af85c161-b73d-46a2-9fd7-4d8604007473",
    "firmName": "MOHAMED ALI ALHAMMADI ADVOCATES & LEGAL CONSULTANT",
    "registrationNumber": "L-01120",
    "licenseIssueDate": "11/07/2012 00:00:00",
    "licenseExpiryDate": "10/29/2025 00:00:00"
  },
  {
    "id": "6ebe82c4-e2b9-454b-a760-c1ee7b10f52e",
    "slug": "vladislav-kiryushin",
    "name": "VLADISLAV KIRYUSHIN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBWSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/09/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Vladislav Kiryushin",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6ebe82c4-e2b9-454b-a760-c1ee7b10f52e",
        "address": "",
        "phone": "97144230555 / 971504788443",
        "email": "yah@hfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c462c65e-185a-4e81-8425-a87e3a2b6842",
    "firmName": "Holman Fenwick Willan Middle East LLP",
    "registrationNumber": "L-01084",
    "licenseIssueDate": "09/26/2017 00:00:00",
    "licenseExpiryDate": "09/23/2026 00:00:00"
  },
  {
    "id": "6c895799-ea79-42fe-9410-8ebdc1c1b063",
    "slug": "vladislav-spirin",
    "name": "VLADISLAV SPIRIN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBWUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/07/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Vladislav Spirin",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6c895799-ea79-42fe-9410-8ebdc1c1b063",
        "address": "ICD Brookfield Place ,DIFC ,506516 ,",
        "phone": "97143695800 / 971505526206",
        "email": "scott.campbell@linklaters.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5cec94c0-0649-43b6-a2be-ab17ff422bce",
    "firmName": "LinkLaters LLP",
    "registrationNumber": "L-05394",
    "licenseIssueDate": "07/18/2022 00:00:00",
    "licenseExpiryDate": "07/17/2026 00:00:00"
  },
  {
    "id": "f5771fab-666c-4863-ac14-a7ae13a0577a",
    "slug": "vyasna-mahadevey",
    "name": "VYASNA MAHADEVEY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBWTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/09/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Vyasna Mahadevey",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f5771fab-666c-4863-ac14-a7ae13a0577a",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-05028",
    "licenseIssueDate": "09/20/2021 00:00:00",
    "licenseExpiryDate": "09/19/2026 00:00:00"
  },
  {
    "id": "d219aefb-cbca-49a8-b8fb-a25c1c3af04c",
    "slug": "wadzanai-vudzijena",
    "name": "WADZANAI VUDZIJENA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXVgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/12/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Wadzanai Vudzijena",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d219aefb-cbca-49a8-b8fb-a25c1c3af04c",
        "address": "",
        "phone": "97144323671 / 971505589395",
        "email": "fba@amereller.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a139ca64-8897-4d1d-8d71-97446bc1e15a",
    "firmName": "Amereller Legal Consultancy LLC SOC",
    "registrationNumber": "L-05596",
    "licenseIssueDate": "12/04/2024 00:00:00",
    "licenseExpiryDate": "12/03/2025 00:00:00"
  },
  {
    "id": "14b865ff-ecce-4aba-9379-cb87a90dba44",
    "slug": "wael-adel-abdelaati-elgouhari",
    "name": "WAEL ADEL ABDELAATI ELGOUHARI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/05/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Wael Adel Abdelaati Elgouhari",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_14b865ff-ecce-4aba-9379-cb87a90dba44",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-05880",
    "licenseIssueDate": "05/31/2023 00:00:00",
    "licenseExpiryDate": "05/30/2026 00:00:00"
  },
  {
    "id": "a1860443-6a93-462b-9d5a-990eba1d2aa1",
    "slug": "wael-ibrahim-hassan-ahmed-hassan-shawaf",
    "name": "WAEL IBRAHIM HASSAN AHMED HASSAN SHAWAF",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Commercial Transactions-Commercial Contracts",
      "Criminal Law-Crimes against properties"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/09/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Wael Ibrahim Hassan Ahmed Hassan Shawaf",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a1860443-6a93-462b-9d5a-990eba1d2aa1",
        "address": "FATIMA ABDULAZIZ  ,الطابق السابع ,برج المنال  ,مقابل متحف المستقبل  ,861 ,Dubai",
        "phone": "97143555566",
        "email": "info@fazlegal.net",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8ae2a2bf-6a88-4194-87ef-f1ac38baef55",
    "firmName": "FATIMA ABDELAZIZ ADVOCATES & LEGAL CONSULTANT",
    "registrationNumber": "L-05039",
    "licenseIssueDate": "09/13/2021 00:00:00",
    "licenseExpiryDate": "09/12/2026 00:00:00"
  },
  {
    "id": "5e7b6948-1374-4bb6-9e80-ff2cbf28b132",
    "slug": "wael-mahrous",
    "name": "WAEL GABER MOHAMED SAYED AHMED MAHROUS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Commercial Agency",
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Civil Transactions-POA & Sponsorship",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Civil Transactions-Insurance",
      "Personal Status-Wills",
      "Civil Transactions-Construction and Contracts for Services",
      "Civil Transactions-Ownership & Title",
      "Commercial Transactions-Commercial Mortgage",
      "Personal Status-Custody & Alimony",
      "Commercial Transactions-Commercial Contracts",
      "Commercial Transactions-Bankruptcy",
      "Civil Transactions-Residential Real Estate",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Civil Transactions-Arbitration",
      "Civil Transactions-Tenancy",
      "Commercial Transactions-Unfair competition",
      "Criminal Law-Crimes against persons",
      "Personal Status-Legacies and Inheritance",
      "Commercial Transactions-Commercial Companies",
      "Civil Transactions-Labor & Workers",
      "Personal Status-Legal Capacity & Guardianship",
      "Civil Transactions-Sale",
      "Proceedings-Cases and Proceedings before arbitral tribunals and other alternative dispute resolution bodies",
      "Personal Status-Marriage & Divorce",
      "Civil Transactions-Compensation",
      "Commercial Transactions-Stock",
      "Criminal Law-Crimes against properties",
      "Commercial Transactions-E-Commerce",
      "Criminal Law-Cybercrimes",
      "Commercial Transactions-Intellectual Property (includes trademarks",
      "copy rights",
      "patents)",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/01/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Wael Mahrous",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5e7b6948-1374-4bb6-9e80-ff2cbf28b132",
        "address": "الطابق 8 مكتب رقم 802-804 ,AL MASAOOD TOWE 2 ,الفطيم للسيارات  - ديرة  ,31909 ,Dubai",
        "phone": "97142946948",
        "email": "hadi.jomah@baitulhikma.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a1a1a791-7d0a-4afa-a043-cd85f0998888",
    "firmName": "BAITULHIKMA LAWYERS",
    "registrationNumber": "L-03610",
    "licenseIssueDate": "01/22/2017 00:00:00",
    "licenseExpiryDate": "01/18/2026 00:00:00"
  },
  {
    "id": "93621aaa-698f-46f8-a3af-c2c8d4697ea8",
    "slug": "wael-metwally-elsaid",
    "name": "WAEL METWALLY ELSAID MAREY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/03/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Wael Metwally Elsaid",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_93621aaa-698f-46f8-a3af-c2c8d4697ea8",
        "address": "",
        "phone": "97142212494",
        "email": "bayanlaw@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3eaca0c8-938e-4864-add1-73e5c902b168",
    "firmName": "DAR AL BAYAN ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02896",
    "licenseIssueDate": "03/02/2015 00:00:00",
    "licenseExpiryDate": "02/24/2026 00:00:00"
  },
  {
    "id": "b60676f2-4dae-4011-a53a-69f526d8a69b",
    "slug": "wael-mohamed-hussein-deyab",
    "name": "WAEL MOHAMED HUSSEIN DEYAB",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Civil Transactions-Construction and Contracts for Services",
      "Criminal Law-Family Crimes",
      "Personal Status-Custody & Alimony",
      "Commercial Transactions-Commercial Contracts",
      "Civil Transactions-Tenancy",
      "Criminal Law-Crimes against persons",
      "Personal Status-Legacies and Inheritance",
      "Civil Transactions-Labor & Workers",
      "Civil Transactions-Sale",
      "Commercial Transactions-Sea and air freight",
      "Personal Status-Marriage & Divorce",
      "Civil Transactions-Compensation",
      "Criminal Law-Crimes against properties"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/06/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Wael Mohamed Hussein Deyab",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b60676f2-4dae-4011-a53a-69f526d8a69b",
        "address": "Samia Luqman ,2nd floor ,Emarat Atrium Building ,across Holiday Inn Express Safa Park ,7273 ,Dubai",
        "phone": "97143211000",
        "email": "info@alsuwaidi.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0e5c3637-bc12-475c-a6b5-2d9ae84f2b8e",
    "firmName": "AL-SUWAIDI & COMPANY",
    "registrationNumber": "L-04987",
    "licenseIssueDate": "06/30/2021 00:00:00",
    "licenseExpiryDate": "06/29/2026 00:00:00"
  },
  {
    "id": "ed2d8432-e559-40af-942d-a3d0b20d6ea8",
    "slug": "wael-mohamed-said",
    "name": "WAEL MOHAMED REFAAT MOHAMED SAIED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Criminal Law-Crimes against properties",
      "Criminal Law-Drug Crimes",
      "Personal Status-Custody & Alimony"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/06/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Wael Mohamed Said",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ed2d8432-e559-40af-942d-a3d0b20d6ea8",
        "address": "MOHAMMED MURTADA ALHASHMI ,3 ,LATIFA TOWER  ,CROWN PLAZA ,231400 ,Dubai",
        "phone": "97143521131",
        "email": "info@mhadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a5a2640f-b1b8-4512-b9ee-a8802d0c30fc",
    "firmName": "MOHAMMED AL HASHIMI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-02393",
    "licenseIssueDate": "06/07/2012 00:00:00",
    "licenseExpiryDate": "05/30/2026 00:00:00"
  },
  {
    "id": "fda946bd-78e0-4b66-8d1b-edd4256d2b5e",
    "slug": "wael-nasereldin-hassan-mazhar",
    "name": "WAEL NASERELDIN HASSAN MAZHAR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/05/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: wael nasereldin hassan mazhar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fda946bd-78e0-4b66-8d1b-edd4256d2b5e",
        "address": "",
        "phone": "97142966772",
        "email": "info@advocates-consultation.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "43806daf-e311-4130-a270-8aabc08c4ef4",
    "firmName": "OBAID AL EBRI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06823",
    "licenseIssueDate": "05/14/2025 00:00:00",
    "licenseExpiryDate": "05/13/2026 00:00:00"
  },
  {
    "id": "0895d857-fb0b-4044-93b3-fddffbf5cc65",
    "slug": "wael-sayed-hassan-mohamed",
    "name": "WAEL SAYED HASSAN MOHAMED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/12/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Wael Sayed Hassan Mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0895d857-fb0b-4044-93b3-fddffbf5cc65",
        "address": "Mohamed Thamer Yaqub Yousef Alserkal ,الطابق الثاني ,اعمار سكوير - بناء رقم 4 ,برج خليفة ,57409 ,Dubai",
        "phone": "97142622217 / 97142622217",
        "email": "mohamed@alserkallawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2a224392-a975-448f-aec5-0460984b1124",
    "firmName": "MOHAMED ALSERKAL ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05137",
    "licenseIssueDate": "12/06/2021 00:00:00",
    "licenseExpiryDate": "12/05/2025 00:00:00"
  },
  {
    "id": "9255783a-f3ec-4c8e-8750-d036c048279e",
    "slug": "wagdy-nabil-ibrahim-ibrahim-ismail",
    "name": "WAGDY NABIL IBRAHIM IBRAHIM ISMAIL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/05/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Wagdy Nabil Ibrahim Ibrahim Ismail",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9255783a-f3ec-4c8e-8750-d036c048279e",
        "address": "",
        "phone": "97144230000 / 971552009022",
        "email": "UAE-CourtClerks@habibalmulla.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3eba82bb-8ec4-4cbd-80d0-a793cb993fde",
    "firmName": "Habib Al Mulla & Partners ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06817",
    "licenseIssueDate": "05/13/2025 00:00:00",
    "licenseExpiryDate": "05/12/2026 00:00:00"
  },
  {
    "id": "30a9ca8c-839a-43e0-b024-61fb63cb589a",
    "slug": "wahid-ramadan-werdani-sayed-ahmed",
    "name": "WAHID RAMADAN WERDANI SAYED AHMED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/09/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Wahid Ramadan Werdani Sayed Ahmed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_30a9ca8c-839a-43e0-b024-61fb63cb589a",
        "address": "الطابق 33/ الوحدة : 3304 ,مبني المنارة /   الطابق 33/ الوحدة : 3304 ,فندق جي دبليو ماركيز  ,24002 ,Dubai",
        "phone": "97144254373",
        "email": "info@wkadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "332a3a67-50f2-424a-a5c1-d5abaf9a030b",
    "firmName": "WALEED ALMARZOOQI AND KHALID MOHAMED ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-06021",
    "licenseIssueDate": "09/27/2023 00:00:00",
    "licenseExpiryDate": "09/26/2026 00:00:00"
  },
  {
    "id": "15a6eee4-1cc1-4b9d-9a93-10ebc8ccfee7",
    "slug": "wail-siddig-elhadi-elkhidir",
    "name": "WAIL SIDDIG ELHADI ELKHIDIR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/06/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: wail siddig elhadi elkhidir",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_15a6eee4-1cc1-4b9d-9a93-10ebc8ccfee7",
        "address": "Mohamed Alhammadi ,FLOOR 16 OFFICE B1605 ,LATIFA TOWER ,CLOSE TO CROWN PLAZA HOTEL ,76550 ,Dubai",
        "phone": "97143298866",
        "email": "admin@dralhammadilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "612e75e6-c3f3-479b-bc93-ee88982dea58",
    "firmName": "DR MOHAMED ALHAMMADI ADVOCATES & LEGAL CONSULTANTS OFFICE",
    "registrationNumber": "L-06383",
    "licenseIssueDate": "06/12/2024 00:00:00",
    "licenseExpiryDate": "06/11/2026 00:00:00"
  },
  {
    "id": "8e1d2e22-0f05-4b3a-8f15-461ab02cb924",
    "slug": "wajid-ashraf",
    "name": "WAJID MAHMOOD ASHRAF",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/11/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Wajid Ashraf",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_8e1d2e22-0f05-4b3a-8f15-461ab02cb924",
        "address": "",
        "phone": "97143121800 / 971566017967",
        "email": "alishia.sullivan@morganlewis.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6eab20d7-8716-4b0a-8710-144d1d951c23",
    "firmName": "Morgan, Lewis & Bockius LLP (dubai Branch)",
    "registrationNumber": "L-06568",
    "licenseIssueDate": "11/06/2024 00:00:00",
    "licenseExpiryDate": "11/05/2026 00:00:00"
  },
  {
    "id": "788ef818-0296-41ff-a425-7559a3c0eef7",
    "slug": "wajih-alshikh-saadou",
    "name": "Wajih Alshikh Saadou",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/11/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2021-10-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Wajih Alshikh Saadou",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_788ef818-0296-41ff-a425-7559a3c0eef7",
        "address": "YASIR AL NAQBI ,21 ,48 BURJ ,SOFITEL DOWN  TOWN ,181111 ,Dubai",
        "phone": "97142689949",
        "email": "info@alnaqbipartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ad71430e-83ee-4cb5-a530-bc58db2618f6",
    "firmName": "ALNAQBI & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02645",
    "licenseIssueDate": "11/05/2013 00:00:00",
    "licenseExpiryDate": "10/29/2021 00:00:00"
  },
  {
    "id": "18c708a8-561c-4152-988b-9a583f2858ed",
    "slug": "waleed-adel-khalil-ibrahim-abosamrah",
    "name": "WALEED ADEL KHALIL IBRAHIM ABOSAMRAH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Personal Status-Wills",
      "Criminal Law-Family Crimes",
      "Personal Status-Custody & Alimony",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Civil Transactions-Tenancy",
      "Civil Transactions-Labor & Workers",
      "Personal Status-Legal Capacity & Guardianship",
      "Criminal Law-Drug Crimes",
      "Personal Status-Marriage & Divorce",
      "Personal Status-Child Abuse & Abduction",
      "Civil Transactions-Compensation",
      "Criminal Law-Crimes against properties",
      "Criminal Law-Cybercrimes",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/05/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Waleed Adel Khalil Ibrahim Abosamrah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_18c708a8-561c-4152-988b-9a583f2858ed",
        "address": "first floor ,Al Ferdous 4 ,Park and Shop ,12018 ,Dubai",
        "phone": "97143930222 / 971505122999",
        "email": "info@amanidarwishlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7e92f791-0024-4f89-84eb-1e2d979fd2d2",
    "firmName": "NADIA MOHAMMED ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-06344",
    "licenseIssueDate": "05/29/2024 00:00:00",
    "licenseExpiryDate": "05/28/2026 00:00:00"
  },
  {
    "id": "3ad1d221-4601-4f1d-8727-6624a53755da",
    "slug": "waleed-mohammed-al-hooti",
    "name": "Waleed Mohammed Al Hooti",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/11/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Waleed Mohammed Al Hooti",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3ad1d221-4601-4f1d-8727-6624a53755da",
        "address": "",
        "phone": "97143688984",
        "email": "legalsolutions@alattay.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "110bcc76-e3fc-40c6-960f-9dfd1ffd5067",
    "firmName": "HESSA ALATTAY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02105",
    "licenseIssueDate": "11/11/2013 00:00:00",
    "licenseExpiryDate": "11/04/2025 00:00:00"
  },
  {
    "id": "9fe40af7-3213-494c-9bff-10708dafd437",
    "slug": "waleed-mohammed-mohammed-elmoghazey",
    "name": "Waleed Mohammed Mohammed Elmoghazey",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/09/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-08-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Waleed Mohammed Mohammed Elmoghazey",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9fe40af7-3213-494c-9bff-10708dafd437",
        "address": "",
        "phone": "97143595552",
        "email": "rashid.alkaitoob@rk-advocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8ea99c01-7cd1-44a3-84c3-8dd51ccf5908",
    "firmName": "RASHID AL KAITOOB ADVOCATES & LEGAL COSULTANTS",
    "registrationNumber": "L-04199",
    "licenseIssueDate": "09/02/2018 00:00:00",
    "licenseExpiryDate": "08/31/2025 00:00:00"
  },
  {
    "id": "3431e2ad-e48b-4f9e-9e2d-7eea54135eed",
    "slug": "waleed-yousef",
    "name": "WALEED YOUSEF",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/07/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Waleed Yousef",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3431e2ad-e48b-4f9e-9e2d-7eea54135eed",
        "address": "",
        "phone": "97144020800 / 971566830829",
        "email": "dean.ryburn@dentons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dfe13b7e-6625-45fd-ad63-9ee83af41194",
    "firmName": "Dentons & Co Dubai Branch-DED",
    "registrationNumber": "L-06880",
    "licenseIssueDate": "07/09/2025 00:00:00",
    "licenseExpiryDate": "07/08/2026 00:00:00"
  },
  {
    "id": "f0a9202f-891f-4237-ab0d-f627854f89e4",
    "slug": "walid-ahmed-hassan-ahmed",
    "name": "WALID AHMED HASSAN MOHAMED AHMED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/08/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Walid Ahmed Hassan Ahmed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f0a9202f-891f-4237-ab0d-f627854f89e4",
        "address": "6F 603, 605, 7F 704 ,Crystal Tower ,Dubai Mall ,117538 ,Dubai",
        "phone": "97146098700",
        "email": "pro@miolawfirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "417f90a1-03be-4dab-8eea-1bba7e16f536",
    "firmName": "ABU BAKER SALEM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02202",
    "licenseIssueDate": "08/05/2013 00:00:00",
    "licenseExpiryDate": "07/29/2026 00:00:00"
  },
  {
    "id": "e7f1f9ce-389b-4166-ae86-97817451ac84",
    "slug": "walid-assaad",
    "name": "WALID MALIH ASSAAD",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Civil Transactions-Construction and Contracts for Services",
      "Civil Transactions-Ownership & Title",
      "Commercial Transactions-Commercial Contracts",
      "Civil Transactions-Residential Real Estate",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Civil Transactions-Arbitration",
      "Civil Transactions-Tenancy",
      "Commercial Transactions-Unfair competition",
      "Criminal Law-Crimes against persons",
      "Commercial Transactions-Commercial Companies",
      "Civil Transactions-Labor & Workers",
      "Civil Transactions-Sale",
      "Proceedings-Cases and Proceedings before arbitral tribunals and other alternative dispute resolution bodies",
      "Civil Transactions-Compensation",
      "Criminal Law-Crimes against properties",
      "Commercial Transactions-E-Commerce",
      "Criminal Law-Cybercrimes",
      "Commercial Transactions-Intellectual Property (includes trademarks",
      "copy rights",
      "patents)",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/10/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Walid Assaad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e7f1f9ce-389b-4166-ae86-97817451ac84",
        "address": "",
        "phone": "97143799916 / 971556407627",
        "email": "ask@mahlawfirm.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a1880a30-0b15-4045-b91e-b3e4e776bc7e",
    "firmName": "MOHAMED ALHATHBOOR ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05073",
    "licenseIssueDate": "10/18/2021 00:00:00",
    "licenseExpiryDate": "10/17/2026 00:00:00"
  },
  {
    "id": "55cc37d1-7a0d-4879-8a4b-016138701774",
    "slug": "walid-el-kantari",
    "name": "Walid El Kantari",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/05/2016",
    "licenseStatus": "active",
    "licenseExpiry": "2017-05-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Walid El Kantari",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_55cc37d1-7a0d-4879-8a4b-016138701774",
        "address": "الطابق الثالث -مكتب رقم 312  ,اعمار بزنس بارك -مبنى رقم 4  ,مصرف رأس الخيمة الوطنى ,336684 ,Dubai",
        "phone": "97144466072 / 971569807807",
        "email": "infobiadvocates@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "abb9efff-73d9-42e6-af59-29b92f4e2d09",
    "firmName": "SAEED ALMUHARRAMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03376",
    "licenseIssueDate": "05/26/2016 00:00:00",
    "licenseExpiryDate": "05/22/2026 00:00:00"
  },
  {
    "id": "af41ee16-7cc4-4ac7-a946-265bc3801657",
    "slug": "walid-elsayed-emara",
    "name": "WALID ELSAYED EMARA ALI EMARA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Walid Elsayed Emara",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_af41ee16-7cc4-4ac7-a946-265bc3801657",
        "address": "Hussain Ali Al Jaziri ,11 ,City Tower 2 ,Crown Plaza hotel Sheikh Zayed Road ,4253 ,Dubai",
        "phone": "97142626777 / 971529087670",
        "email": "courts@jaflaws.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c58d8654-b428-46b3-abd5-024e4331ee53",
    "firmName": "JAAFAR ALWAN & AL JAZIRI & ASSOCIATES",
    "registrationNumber": "L-01603",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "2fca8d82-2403-42ab-a24f-b8d93e4ec3b5",
    "slug": "walid-elsayed-shebl-hamad",
    "name": "WALEED ELSAYED SHEBL HAMAD",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Walid Elsayed Shebl Hamad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2fca8d82-2403-42ab-a24f-b8d93e4ec3b5",
        "address": "Gamal Yassein Abdalla ,الطابق 13  Floor No 13 ,بناية مركز ابروي (The Oberoi Center) ,فندق ابروي (The Oberoi Hotel) ,33299 ,Dubai",
        "phone": "97142828000",
        "email": "litigation@alaidarous.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9a923766-1fd1-4e06-a871-89662120384e",
    "firmName": "AL AIDAROUS ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-01833",
    "licenseIssueDate": "02/19/2012 00:00:00",
    "licenseExpiryDate": "02/10/2026 00:00:00"
  },
  {
    "id": "78a99786-ec7c-4b6c-bf6b-c425844f0640",
    "slug": "walid-farag-alla-mohamed-abouokada",
    "name": "WALID FARAGALLA MOHAMED ABOUOKADA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Criminal Law-Family Crimes",
      "Personal Status-Custody & Alimony",
      "Commercial Transactions-Commercial Contracts",
      "Civil Transactions-Residential Real Estate",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Civil Transactions-Tenancy",
      "Criminal Law-Crimes against persons",
      "Criminal Law-Drug Crimes",
      "Civil Transactions-Sale",
      "Civil Transactions-Compensation",
      "Criminal Law-Crimes against properties",
      "Criminal Law-Cybercrimes",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/01/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Walid farag Alla Mohamed abouokada",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_78a99786-ec7c-4b6c-bf6b-c425844f0640",
        "address": "Yaqoub Almaamzi ,6th Floor, office 606 ,Building 1 A ,Near Dubai Mall ,554801 ,Dubai",
        "phone": "97145686523 / 971000000000",
        "email": "info@almazmy.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3e828642-9baf-47a6-a42a-320c714638bf",
    "firmName": "YAQOUB ALMAAZMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03968",
    "licenseIssueDate": "01/22/2018 00:00:00",
    "licenseExpiryDate": "01/19/2026 00:00:00"
  },
  {
    "id": "f3e6e667-6e60-4c16-bae5-da882a1b51e7",
    "slug": "walid-fathi-mohamed-batisha",
    "name": "Walid Fathi Mohamed Batisha",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/10/2020",
    "licenseStatus": "active",
    "licenseExpiry": "2021-10-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Walid Fathi Mohamed Batisha",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f3e6e667-6e60-4c16-bae5-da882a1b51e7",
        "address": "Khawla Saeed Mohammed Salem ,414 ,DBCS BUILDING ,محكمة الاحوال الشخصية ,73879 ,Dubai",
        "phone": "97143530354 / 971503787848",
        "email": "info@ksadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e961ec37-b1f5-4b83-8382-639604c8fdaf",
    "firmName": "KHAWLA SAEED ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04786",
    "licenseIssueDate": "10/22/2020 00:00:00",
    "licenseExpiryDate": "10/21/2025 00:00:00"
  },
  {
    "id": "6c7bf747-529e-4e0c-8916-73db752444ea",
    "slug": "walid-magdy-azzam",
    "name": "WALID MAGDY MAHMOUD ALI AZZAM",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/11/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Walid Magdy Azzam",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6c7bf747-529e-4e0c-8916-73db752444ea",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-02103",
    "licenseIssueDate": "11/29/2011 00:00:00",
    "licenseExpiryDate": "11/20/2025 00:00:00"
  },
  {
    "id": "f27ddf91-519a-4743-a58b-ce17a7736fe2",
    "slug": "walid-mohamed-abbas-ashour",
    "name": "WALID MOHAMED ABBAS ASHOUR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/11/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Walid Mohamed Abbas Ashour",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f27ddf91-519a-4743-a58b-ce17a7736fe2",
        "address": "SAAD AL HAMMADI ,مدخل البرج ,ويست بيري ,برج خليفه ,41747 ,Dubai",
        "phone": "97142405222",
        "email": "info@saadpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "18923100-5b94-44e2-b580-2e3b0cc17bf6",
    "firmName": "SAAD AL HAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01956",
    "licenseIssueDate": "11/13/2011 00:00:00",
    "licenseExpiryDate": "11/04/2025 00:00:00"
  },
  {
    "id": "a9c5db3c-12dc-40c3-a3de-96776d9c341f",
    "slug": "ward-brent-rasmussen",
    "name": "Ward Brent Rasmussen",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/03/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2021-03-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ward Brent Rasmussen",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a9c5db3c-12dc-40c3-a3de-96776d9c341f",
        "address": "الطابق 7 مكتب رقم 070A ,برج رولكس  ,محطة مترو المركز المالي  ,66300 ,Dubai",
        "phone": "97143444029",
        "email": "ekp.khalidaltmimi@ekplegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "400838f1-4e75-4836-9698-b9e19dd30a18",
    "firmName": "KHALID ABDALLA ALTAMIMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04087",
    "licenseIssueDate": "03/28/2018 00:00:00",
    "licenseExpiryDate": "03/25/2021 00:00:00"
  },
  {
    "id": "d4577706-596d-41fb-940c-2f8a83cba347",
    "slug": "waseem-khokhar",
    "name": "WASEEM IRSHAD KHOKHAR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/10/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Waseem Khokhar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d4577706-596d-41fb-940c-2f8a83cba347",
        "address": "4 - 449 ,Emarat Atrium ,Gulf News ,413533 ,Dubai",
        "phone": "97143211966",
        "email": "icalc@internationalcounsels.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "382198c6-5727-490a-963b-91b675ddc7bc",
    "firmName": "INTERNATIONAL COUNSELS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-00991",
    "licenseIssueDate": "10/16/2011 00:00:00",
    "licenseExpiryDate": "10/07/2025 00:00:00"
  },
  {
    "id": "c0e3c50f-e5ab-4b96-a5e6-5250b3a41488",
    "slug": "wassim-tony-el-mardini",
    "name": "WASSIM TONY EL MARDINI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/05/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Wassim Tony El Mardini",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c0e3c50f-e5ab-4b96-a5e6-5250b3a41488",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-05827",
    "licenseIssueDate": "05/17/2023 00:00:00",
    "licenseExpiryDate": "05/16/2026 00:00:00"
  },
  {
    "id": "3b43c4b0-9e37-4ae9-b6ed-eee238bb727d",
    "slug": "wayne-jones",
    "name": "WAYNE HARVEY JONES",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/10/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Wayne Jones",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3b43c4b0-9e37-4ae9-b6ed-eee238bb727d",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-00340",
    "licenseIssueDate": "10/11/2011 00:00:00",
    "licenseExpiryDate": "10/02/2026 00:00:00"
  },
  {
    "id": "ee35990e-8dfd-4591-a038-ad6769d10ce3",
    "slug": "wesley-matthew-wood",
    "name": "WESLEY MATTHEW WOOD",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/06/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: WESLEY MATTHEW WOOD",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ee35990e-8dfd-4591-a038-ad6769d10ce3",
        "address": "HAMDAN ALSHAMSI ,الطابق الرابع مكتب 401, 406,407 ,بي سكوير 01 ,مجمع دبي سكوير ,116564 ,Dubai",
        "phone": "97143469262",
        "email": "courts@has.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de2c61a6-9d00-457e-ad1d-e73e4e62d9bd",
    "firmName": "HAMDAN ALSHAMSI LAWYER & LEGAL CONSULTANTS",
    "registrationNumber": "L-04045",
    "licenseIssueDate": "06/11/2025 00:00:00",
    "licenseExpiryDate": "06/10/2026 00:00:00"
  },
  {
    "id": "3bc17326-9076-4a67-9160-8015135d3637",
    "slug": "wieslawa-maria-sarkhel",
    "name": "WIESLAWA MARIA SARKHEL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/05/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Wieslawa Maria Sarkhel",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3bc17326-9076-4a67-9160-8015135d3637",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-06813",
    "licenseIssueDate": "05/28/2025 00:00:00",
    "licenseExpiryDate": "05/27/2026 00:00:00"
  },
  {
    "id": "5d36dc93-40c9-4e07-948d-6249b6d67068",
    "slug": "wilhelmina-frederika-tess-luijcx",
    "name": "WILHELMINA FREDERIKA TESS LUIJCX",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/08/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Wilhelmina Frederika Tess Luijcx",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5d36dc93-40c9-4e07-948d-6249b6d67068",
        "address": "",
        "phone": "97143506800 / 971507244940",
        "email": "Chris.Williams@bracewelllaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "106d3ee7-86f2-4eae-9b49-fd8423095983",
    "firmName": "Bracewell LLP",
    "registrationNumber": "L-06450",
    "licenseIssueDate": "08/14/2024 00:00:00",
    "licenseExpiryDate": "08/13/2026 00:00:00"
  },
  {
    "id": "9d23d4c3-7659-42da-bee6-f594cf988c30",
    "slug": "willem-steenkamp",
    "name": "WILLEM MONTIE STEENKAMP",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/12/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Willem Steenkamp",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9d23d4c3-7659-42da-bee6-f594cf988c30",
        "address": "",
        "phone": "97143641686 / 971506288801",
        "email": "b.kadir@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0ba96df8-e4cc-49c2-8ae4-a42878d95926",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS LLC",
    "registrationNumber": "L-01324",
    "licenseIssueDate": "12/12/2023 00:00:00",
    "licenseExpiryDate": "12/11/2025 00:00:00"
  },
  {
    "id": "d69428aa-b2cd-4210-ac0e-96e27e167fc4",
    "slug": "william-cadwaladr",
    "name": "WILLIAM EDWARD JOHN CADWALADR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/08/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: William Cadwaladr",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d69428aa-b2cd-4210-ac0e-96e27e167fc4",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-03473",
    "licenseIssueDate": "08/25/2016 00:00:00",
    "licenseExpiryDate": "08/21/2026 00:00:00"
  },
  {
    "id": "0f840943-7f79-4afa-9c4e-7a59b6e9c3bd",
    "slug": "william-ian-tunstall-prince",
    "name": "WILLIAM IAN TUNSTALL PRINCE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/05/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: William Ian Tunstall - Prince",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0f840943-7f79-4afa-9c4e-7a59b6e9c3bd",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-05332",
    "licenseIssueDate": "05/17/2022 00:00:00",
    "licenseExpiryDate": "05/16/2026 00:00:00"
  },
  {
    "id": "4418b10b-0bff-49a2-a46d-99159de53edb",
    "slug": "william-jefferies",
    "name": "WILLIAM ALEXANDER JEFFERIES",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/03/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: William Jefferies",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4418b10b-0bff-49a2-a46d-99159de53edb",
        "address": "",
        "phone": "97143025100 / 971501501837",
        "email": "ccairns@trowers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "976857f5-9092-43cf-987d-bfa794a3fa51",
    "firmName": "Trowers & Hamlins LLP",
    "registrationNumber": "L-02210",
    "licenseIssueDate": "03/28/2013 00:00:00",
    "licenseExpiryDate": "03/20/2026 00:00:00"
  },
  {
    "id": "9ab4cfde-547c-4469-86f9-ea7b3f534d1e",
    "slug": "william-reichert",
    "name": "WILLIAM MICHAEL REICHERT",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/01/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: William Reichert",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9ab4cfde-547c-4469-86f9-ea7b3f534d1e",
        "address": "THE OFFICES 1 ,DWTC ,115580 ,",
        "phone": "97143739700 / 971501148248",
        "email": "nitesh.pradhan@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "361fdc64-6b6f-4f37-abca-c52af8473b84",
    "firmName": "Pinsent Masons  LLP (DWTCA Branch)",
    "registrationNumber": "L-03292",
    "licenseIssueDate": "01/14/2016 00:00:00",
    "licenseExpiryDate": "01/09/2026 00:00:00"
  },
  {
    "id": "c046f4eb-1294-4653-809d-24e695d455c2",
    "slug": "william-rhodes-evans",
    "name": "WILLIAM RHODES EVANS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/10/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: William Rhodes Evans",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c046f4eb-1294-4653-809d-24e695d455c2",
        "address": "Al Fattan Currency House - Tower 1  ,Dubai International Financial Center  ,507104 ,",
        "phone": "97143978565 / 971504587822",
        "email": "Raafat.hares@dwf.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6e5f6dba-07af-4109-8c34-175296450f94",
    "firmName": "DWF (Middle East) LLP",
    "registrationNumber": "L-04780",
    "licenseIssueDate": "10/22/2020 00:00:00",
    "licenseExpiryDate": "10/21/2025 00:00:00"
  },
  {
    "id": "7b46ba17-ad00-4c3e-a261-7104f1d987cd",
    "slug": "william-richard-gray-sugden",
    "name": "WILLIAM RICHARD GRAY SUGDEN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/10/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: WILLIAM RICHARD GRAY SUGDEN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7b46ba17-ad00-4c3e-a261-7104f1d987cd",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-06527",
    "licenseIssueDate": "10/09/2024 00:00:00",
    "licenseExpiryDate": "10/08/2026 00:00:00"
  },
  {
    "id": "664c81c1-fd2b-4a02-bbff-b85403f9ea79",
    "slug": "william-seivewright",
    "name": "WILLIAM EDWARD FINDLAY SEIVEWRIGHT",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: William Seivewright",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_664c81c1-fd2b-4a02-bbff-b85403f9ea79",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-00892",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "936644ca-375c-4667-9434-b65dd916a281",
    "slug": "william-smith",
    "name": "WILLIAM JAMES SMITH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2023-02-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: William Smith",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_936644ca-375c-4667-9434-b65dd916a281",
        "address": "",
        "phone": "97143093222 / 971566651954",
        "email": "melissa.murray@twobirds.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3e1526e6-4c8d-4b6f-985f-ea05e9f99bcb",
    "firmName": "Bird & Bird (MEA) LLP",
    "registrationNumber": "L-00900",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/19/2023 00:00:00"
  },
  {
    "id": "aae889f8-038b-4321-a035-a30703b900e9",
    "slug": "william-thomas-prasifka",
    "name": "WILLIAM THOMAS PRASIFKA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/03/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: William Thomas Prasifka",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_aae889f8-038b-4321-a035-a30703b900e9",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Habib Al Mulla & Partners ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05277",
    "licenseIssueDate": "03/17/2022 00:00:00",
    "licenseExpiryDate": "03/16/2026 00:00:00"
  },
  {
    "id": "34df13d5-1df7-48b9-8c5f-862a563a3abe",
    "slug": "wissam-dagher",
    "name": "WISSAM DAGHER",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Wissam Dagher",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_34df13d5-1df7-48b9-8c5f-862a563a3abe",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-00684",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "1f3f6e27-a009-4059-9476-cc0ff69567bf",
    "slug": "xu-yongji",
    "name": "XU YONGJI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBYWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Xu Yongji",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1f3f6e27-a009-4059-9476-cc0ff69567bf",
        "address": "",
        "phone": "97143897000 / 971506553198",
        "email": "nasseralikhasawneh@eversheds-sutherland.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "74a21d43-41d8-480a-a6af-6939b7c98a95",
    "firmName": "Eversheds Sutherland (International LLP) Dubai Branch",
    "registrationNumber": "L-00904",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "6efbeddc-5790-41f7-931b-7b7257866380",
    "slug": "xue-meng-zhang",
    "name": "XUE MENG ZHANG",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBYTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/05/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2022-03-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Xue Meng Zhang",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6efbeddc-5790-41f7-931b-7b7257866380",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-04256",
    "licenseIssueDate": "11/05/2018 00:00:00",
    "licenseExpiryDate": "11/03/2022 00:00:00"
  },
  {
    "id": "2223931e-766e-4b8f-bb60-56329c89f990",
    "slug": "yacine-francis",
    "name": "YACINE FRANCIS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/09/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Yacine Francis",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2223931e-766e-4b8f-bb60-56329c89f990",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-00253",
    "licenseIssueDate": "09/10/2012 00:00:00",
    "licenseExpiryDate": "09/02/2026 00:00:00"
  },
  {
    "id": "3e59b279-6678-4311-83cb-146dc84b4ea6",
    "slug": "yacoub-raja-rabie",
    "name": "YACOUB RAJA RABIE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/03/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Yacoub Raja Rabie",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3e59b279-6678-4311-83cb-146dc84b4ea6",
        "address": "1 ,ICD Brookfield Place ,Dubai International Financial Centre ,9267 ,Dubai",
        "phone": "97147010975 / 971502977062",
        "email": "chris.sioufi@ae.ey.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "42e536ef-e3d8-4339-8572-657a7f7a0331",
    "firmName": "EY Law LLP",
    "registrationNumber": "L-04644",
    "licenseIssueDate": "03/05/2020 00:00:00",
    "licenseExpiryDate": "03/04/2026 00:00:00"
  },
  {
    "id": "886876fd-e660-49cb-bcd2-8fbbdde68835",
    "slug": "yaman-al-hawamdeh",
    "name": "YAMAN MAHMOUD AHMAD AL HAWAMDEH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/10/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Yaman Al Hawamdeh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_886876fd-e660-49cb-bcd2-8fbbdde68835",
        "address": "",
        "phone": "97144230555 / 971504788443",
        "email": "yah@hfw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Owner",
    "firmId": "c462c65e-185a-4e81-8425-a87e3a2b6842",
    "firmName": "Holman Fenwick Willan Middle East LLP",
    "registrationNumber": "L-00629",
    "licenseIssueDate": "10/07/2011 00:00:00",
    "licenseExpiryDate": "09/28/2026 00:00:00"
  },
  {
    "id": "cfe304a8-1e5e-4535-aeb3-d2f2a90e2e15",
    "slug": "yamen-fouad-deeb",
    "name": "YAMEN FOUAD DEEB",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/08/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Yamen Fouad Deeb",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cfe304a8-1e5e-4535-aeb3-d2f2a90e2e15",
        "address": "Second Floor - Office No. 44 ,SUNSET Mall ,Makani No: 2129186503 ,000 ,Dubai",
        "phone": "97100000000 / 971558989828",
        "email": "L.ALMARZOOQI1110@GMAIL.COM",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "fd6217fa-7d75-4e40-9295-6daa554c87d1",
    "firmName": "MOHAMED ABDULLA ALMARZOOQI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05981",
    "licenseIssueDate": "08/23/2023 00:00:00",
    "licenseExpiryDate": "08/22/2026 00:00:00"
  },
  {
    "id": "f8c3c283-da85-4179-8168-7a27a465de03",
    "slug": "yan-shen-tan",
    "name": "TAN YAN SHEN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/10/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Yan Shen Tan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f8c3c283-da85-4179-8168-7a27a465de03",
        "address": "",
        "phone": "97147098484 / 971505577206",
        "email": "slshadmand@jonesday.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "8892bfe9-d3ec-4158-b4fd-1844606f4f30",
    "firmName": "Jones Day",
    "registrationNumber": "L-06984"
  },
  {
    "id": "24ab821d-e0b2-4ca3-a85c-0a129ff32bc8",
    "slug": "yanal-abul-failat",
    "name": "YANAL ABUL FAILAT",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/03/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Yanal Abul Failat",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_24ab821d-e0b2-4ca3-a85c-0a129ff32bc8",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-05766",
    "licenseIssueDate": "03/29/2023 00:00:00",
    "licenseExpiryDate": "03/28/2026 00:00:00"
  },
  {
    "id": "eea8d109-acb5-4fef-8063-d87f9f513c69",
    "slug": "yanmin-ma",
    "name": "Yanmin Ma",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/03/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Yanmin Ma",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_eea8d109-acb5-4fef-8063-d87f9f513c69",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-04822",
    "licenseIssueDate": "09/03/2024 00:00:00",
    "licenseExpiryDate": "09/02/2026 00:00:00"
  },
  {
    "id": "05ac930f-4666-4477-97b6-88a6afb61f3d",
    "slug": "yannick-alexandre-luis-hefti",
    "name": "YANNICK ALEXANDRE LUIS HEFTI ROSSIER",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/01/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Yannick Alexandre Luis Hefti",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_05ac930f-4666-4477-97b6-88a6afb61f3d",
        "address": "",
        "phone": "97143093222 / 971566651954",
        "email": "melissa.murray@twobirds.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3e1526e6-4c8d-4b6f-985f-ea05e9f99bcb",
    "firmName": "Bird & Bird (MEA) LLP",
    "registrationNumber": "L-04595",
    "licenseIssueDate": "01/30/2020 00:00:00",
    "licenseExpiryDate": "01/29/2026 00:00:00"
  },
  {
    "id": "7f19ab04-bcf0-44f8-a718-6c17f4472c6f",
    "slug": "yannick-whorms",
    "name": "YANNICK STEFANO WHORMS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/03/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Yannick Whorms",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7f19ab04-bcf0-44f8-a718-6c17f4472c6f",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "563739b7-e060-4925-9dc8-6c36ec982349",
    "firmName": "White & Case LLP-DIFC",
    "registrationNumber": "L-04484",
    "licenseIssueDate": "03/20/2023 00:00:00",
    "licenseExpiryDate": "03/19/2026 00:00:00"
  },
  {
    "id": "fdad9ebd-d90e-4ab5-82af-f7952df4c652",
    "slug": "yara-a",
    "name": "Yara A",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/01/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Yara A",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_fdad9ebd-d90e-4ab5-82af-f7952df4c652",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2d30e6cf-d364-474a-abe0-690798e7f9ca",
    "firmName": "AL TAMIMI & COMPANY LIMITED",
    "registrationNumber": "L-06977",
    "licenseIssueDate": "09/25/2025 00:00:00",
    "licenseExpiryDate": "09/24/2026 00:00:00"
  },
  {
    "id": "c453147c-4815-48af-95e1-80464c352a53",
    "slug": "yara-assaad-riachy",
    "name": "YARA ASSAAD RIACHY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/04/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Yara Assaad Riachy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c453147c-4815-48af-95e1-80464c352a53",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-04912",
    "licenseIssueDate": "04/12/2021 00:00:00",
    "licenseExpiryDate": "04/11/2026 00:00:00"
  },
  {
    "id": "21e2de45-af45-4ff5-ae5e-c60e22acdde2",
    "slug": "yaser-shaban-elzawawy",
    "name": "Yaser Shaban Elzawawy",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/02/2012",
    "licenseStatus": "active",
    "licenseExpiry": "2013-02-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Yaser Shaban Elzawawy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_21e2de45-af45-4ff5-ae5e-c60e22acdde2",
        "address": "khadijah sohail hassan asaadi ,طابق الميزانيين  ,ايميجت  ,مترو الخليج التجاري  ,41342 ,Dubai",
        "phone": "97143438885",
        "email": "info@asaadi.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "264cfea6-1419-45d4-9264-7dba3f26da68",
    "firmName": "KHADIJAH SOHAIL LAWYERS & LEGAL CONSULTANTS",
    "registrationNumber": "L-02241",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "24a22723-a47f-4304-83ba-8057923a26ea",
    "slug": "yashwant-mathur-satish-mathur",
    "name": "YASHWANT MATHUR SATISH MATHUR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/07/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Yashwant Mathur Satish Mathur",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_24a22723-a47f-4304-83ba-8057923a26ea",
        "address": "",
        "phone": "97142776075 / 971588324788",
        "email": "avichal@kochhardubai.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "847eff7c-4142-431e-a8d6-f58ff60964f6",
    "firmName": "Kochhar & Co Inc Legal Consultants (Dubai Branch)",
    "registrationNumber": "L-05374",
    "licenseIssueDate": "07/18/2022 00:00:00",
    "licenseExpiryDate": "07/17/2026 00:00:00"
  },
  {
    "id": "81d5d4c3-ad63-470b-9b23-3a64e6311aa3",
    "slug": "yasin-khalaf-al-janabi",
    "name": "YASIN KHALAF ABAD AL JANABI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/11/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Yasin Khalaf Al-Janabi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_81d5d4c3-ad63-470b-9b23-3a64e6311aa3",
        "address": "الطابق العاشر - 1003 ,برج الريم ,خلف مقر اتصالات - ديرة ,64166 ,Dubai",
        "phone": "97143395953 / 971502110022",
        "email": "info@almazroueiadvocates.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "0f57dd9c-c65a-4c45-bd06-695ca9e13f69",
    "firmName": "AHMED ALMAZROUEI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01723",
    "licenseIssueDate": "11/17/2011 00:00:00",
    "licenseExpiryDate": "11/08/2025 00:00:00"
  },
  {
    "id": "5dc74311-dabc-471b-acad-d3cf4d6505c5",
    "slug": "yasmeen-said",
    "name": "YASMEEN SAID",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/10/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Yasmeen Said",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5dc74311-dabc-471b-acad-d3cf4d6505c5",
        "address": "",
        "phone": "97143742800 / 971506450677",
        "email": "jabbott21@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7a59d310-ff72-4318-b41c-27095c163d0f",
    "firmName": "CMS (UAE) LLP",
    "registrationNumber": "L-06999"
  },
  {
    "id": "081d1cfa-e165-4a35-b4d8-ba3bed909453",
    "slug": "yasser-ahmed-elmaddah",
    "name": "YASSER AHMED ATTA IBRAHIM ELMADDAH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Commercial Agency",
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Civil Transactions-Insurance",
      "Civil Transactions-Construction and Contracts for Services",
      "Civil Transactions-Ownership & Title",
      "Civil Transactions-HR & Employee Affairs",
      "Commercial Transactions-Commercial Mortgage",
      "Commercial Transactions-Commercial Contracts",
      "Civil Transactions-Immigration and Residency",
      "Commercial Transactions-Bankruptcy",
      "Commercial Transactions-Commercial Real Estate",
      "Civil Transactions-Residential Real Estate",
      "Civil Transactions-Tenancy",
      "Criminal Law-Crimes against persons",
      "Commercial Transactions-Commercial Companies",
      "Commercial Transactions-Banking Operations",
      "Civil Transactions-Labor & Workers",
      "Civil Transactions-Sale",
      "Civil Transactions-Compensation",
      "Commercial Transactions-Stock",
      "Criminal Law-Crimes against properties",
      "Commercial Transactions-E-Commerce",
      "Criminal Law-Cybercrimes"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/10/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Yasser Ahmed Elmaddah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_081d1cfa-e165-4a35-b4d8-ba3bed909453",
        "address": "",
        "phone": "97143213302",
        "email": "lawfirm@liberallawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a791ae2d-579f-42dd-945f-b28c198a33e4",
    "firmName": "LIBERALS LAWYERS LEGAL CONSULTANTS AND LAWYERS",
    "registrationNumber": "L-02657",
    "licenseIssueDate": "10/15/2014 00:00:00",
    "licenseExpiryDate": "10/09/2025 00:00:00"
  },
  {
    "id": "e6de2df4-8b3e-4090-b09f-93b91e1ac275",
    "slug": "yasser-el-sayed-el-arabi-azzouz",
    "name": "YASSER ELSAYED ELARABI SABER AZOUZ",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Commercial Agency",
      "Civil Transactions-POA & Sponsorship",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Personal Status-Wills",
      "Civil Transactions-Ownership & Title",
      "Civil Transactions-HR & Employee Affairs",
      "Commercial Transactions-Commercial Mortgage",
      "Personal Status-Custody & Alimony",
      "Commercial Transactions-Commercial Contracts",
      "Civil Transactions-Immigration and Residency",
      "Commercial Transactions-Bankruptcy",
      "Civil Transactions-Residential Real Estate",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Civil Transactions-Arbitration",
      "Criminal Law-Hate crimes",
      "Civil Transactions-Tenancy",
      "Commercial Transactions-Unfair competition",
      "Criminal Law-Crimes against persons",
      "Personal Status-Legacies and Inheritance",
      "Personal Status-Legal Capacity & Guardianship",
      "Criminal Law-Drug Crimes",
      "Civil Transactions-Sale",
      "Personal Status-Marriage & Divorce",
      "Civil Transactions-Compensation",
      "Criminal Law-Crimes against properties",
      "Commercial Transactions-Intellectual Property (includes trademarks",
      "copy rights",
      "patents)",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Yasser El Sayed El Arabi Azzouz",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e6de2df4-8b3e-4090-b09f-93b91e1ac275",
        "address": "702-703 ,THE EXCHANGE TOWER ,NEAR IN BUSINESS BAY METRO STATION ,90009 ,Dubai",
        "phone": "97142327888",
        "email": "info@alowaislaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "83647634-f0b7-4ccb-b71c-6d00bfdb84de",
    "firmName": "ABDALLA ALOWAIS ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-01895",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "76e41be1-6ad6-4600-976e-b86e658c1da3",
    "slug": "yasser-elkot",
    "name": "Yasser Elkot",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/07/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-04-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Yasser Elkot",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_76e41be1-6ad6-4600-976e-b86e658c1da3",
        "address": "Jane Naoe Elsayed ,Level No. 22 – Office No. (2201 – 2202) ,Concord Tower ,Media City ,99779 ,Dubai",
        "phone": "97143575999",
        "email": "info@binarab.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a718961d-c976-4a3c-bd09-585ec7c81310",
    "firmName": "RASHED BIN ARAB ADVOCATE AND LEGAL CONSULTANTS",
    "registrationNumber": "L-03214",
    "licenseIssueDate": "11/07/2015 00:00:00",
    "licenseExpiryDate": "11/04/2018 00:00:00"
  },
  {
    "id": "f690815c-38c4-4ff1-ac89-29efdc890301",
    "slug": "yasser-hamdy-ahmed-mohamed-abdelsalam-madkour",
    "name": "YASSER HAMDY AHMED MOHAMED ABDELSALAM MADKOUR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/07/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Yasser Hamdy Ahmed Mohamed Abdelsalam Madkour",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f690815c-38c4-4ff1-ac89-29efdc890301",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-03851",
    "licenseIssueDate": "07/05/2017 00:00:00",
    "licenseExpiryDate": "07/02/2026 00:00:00"
  },
  {
    "id": "2b003ad5-a47d-4b9e-b1b7-79c8ed364689",
    "slug": "yasser-mohamed-attia-ebid",
    "name": "YASSER MOHAMED ATTIA EBID",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/08/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Yasser Mohamed Attia Ebid",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2b003ad5-a47d-4b9e-b1b7-79c8ed364689",
        "address": "omar abdulazizi alomar ,15 ,prime tower ,blom bank france ,211940 ,Dubai",
        "phone": "97143808838 / 971504598082",
        "email": "omar.omar@oghlegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "171b4622-e4ec-4375-a9c4-3637bf6a8b17",
    "firmName": "ALOMAR & ALSABAH ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-03867",
    "licenseIssueDate": "08/25/2023 00:00:00",
    "licenseExpiryDate": "08/24/2026 00:00:00"
  },
  {
    "id": "86c71d69-60e3-4678-9e5f-65aaa17cdc0a",
    "slug": "yasser-mohamed-elgendy",
    "name": "YASSER MOHAMED MOHAMED MOHAMED ELGENDY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Yasser Mohamed Elgendy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_86c71d69-60e3-4678-9e5f-65aaa17cdc0a",
        "address": "18 ,فندق مونارك  ,مركز التجاري ,98444 ,Dubai",
        "phone": "97143588777",
        "email": "info@bhadvoc.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "61266d12-f5b4-4466-a1a8-a45934d9e511",
    "firmName": "BIN HAIDER ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01449",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "907007ad-3c1c-4d54-b63c-b8356c6bdad9",
    "slug": "yasser-mohamed-muflahi",
    "name": "YASSER MOHAMED MUFLAHI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/04/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Yasser Mohamed Muflahi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_907007ad-3c1c-4d54-b63c-b8356c6bdad9",
        "address": "ICD Brookfield Place ,Za'abeel 2 ,103747 ,",
        "phone": "97143696300 / 971506008159",
        "email": "mohammed.paracha@nortonrosefulbright.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c4aaee93-0ec4-4982-9a48-a23699492056",
    "firmName": "Norton Rose Fullbright (Middle East) LLP",
    "registrationNumber": "L-05265",
    "licenseIssueDate": "04/19/2022 00:00:00",
    "licenseExpiryDate": "04/18/2026 00:00:00"
  },
  {
    "id": "f2d75650-3afa-4d53-81f0-0275834a5721",
    "slug": "yasser-mohamed-yehia-aly-elhawary",
    "name": "YASSER MOHAMED YEHIA ALY ELHAWARY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/03/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Yasser Mohamed Yehia Aly ElHawary",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f2d75650-3afa-4d53-81f0-0275834a5721",
        "address": "",
        "phone": "97143300009 / 971501215000",
        "email": "mohamed@maa.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "af85c161-b73d-46a2-9fd7-4d8604007473",
    "firmName": "MOHAMED ALI ALHAMMADI ADVOCATES & LEGAL CONSULTANT",
    "registrationNumber": "L-04042",
    "licenseIssueDate": "03/21/2018 00:00:00",
    "licenseExpiryDate": "03/18/2026 00:00:00"
  },
  {
    "id": "3e87cdbb-a859-49ac-b3f1-186dd927e34c",
    "slug": "yazan-othman-mohd-subhi-al-shwaimat",
    "name": "YAZAN OTHMAN MOHD SUBHI AL SHWAIMAT",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/07/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Yazan Othman Mohd Subhi Al Shwaimat",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3e87cdbb-a859-49ac-b3f1-186dd927e34c",
        "address": "0 ,ICD Brookfield Place Level 13 ,Trade Centre ,506569 ,Dubai",
        "phone": "97145099100 / 971501006965",
        "email": "menahr@freshfields.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "970f6246-e737-41a7-9c6c-5aa5b8335d45",
    "firmName": "Freshfields LLP DIFC",
    "registrationNumber": "L-06419",
    "licenseIssueDate": "07/19/2024 00:00:00",
    "licenseExpiryDate": "07/18/2026 00:00:00"
  },
  {
    "id": "f1a3821b-8d11-48cc-8dcd-c2ee1ab5dfb1",
    "slug": "yazan-saoudi",
    "name": "YAZAN M S SAOUDI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Yazan Saoudi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f1a3821b-8d11-48cc-8dcd-c2ee1ab5dfb1",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01326",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "2905618f-de49-4b35-9002-1f954afbdcc3",
    "slug": "yazeed-samain",
    "name": "YAZEED HANI KHALEEL SAMAIN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/11/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-11-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Yazeed Samain",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2905618f-de49-4b35-9002-1f954afbdcc3",
        "address": "901-902 ,برج السلام ,فندق جراند شيراتون ,2741291443 ,Dubai",
        "phone": "97145877794 / 971586606660",
        "email": "obh@obhlawyers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "edbb7814-39f9-4ec9-b01d-9de1117e343e",
    "firmName": "OMAR KHALIFA ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01510",
    "licenseIssueDate": "11/29/2021 00:00:00",
    "licenseExpiryDate": "11/28/2025 00:00:00"
  },
  {
    "id": "cbaaa56e-e5fd-434e-b779-38ad8f8fdfd5",
    "slug": "yi-se-park",
    "name": "YI SE PARK",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/06/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Yi Se Park",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_cbaaa56e-e5fd-434e-b779-38ad8f8fdfd5",
        "address": "",
        "phone": "97143121800 / 971566017967",
        "email": "alishia.sullivan@morganlewis.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6eab20d7-8716-4b0a-8710-144d1d951c23",
    "firmName": "Morgan, Lewis & Bockius LLP (dubai Branch)",
    "registrationNumber": "L-04171",
    "licenseIssueDate": "07/01/2021 00:00:00",
    "licenseExpiryDate": "06/30/2026 00:00:00"
  },
  {
    "id": "19a095e5-d392-4102-8be8-55f7e0c32168",
    "slug": "yonghui-qiu",
    "name": "YONGHUI QIU",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZUQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/05/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Yonghui Qiu",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_19a095e5-d392-4102-8be8-55f7e0c32168",
        "address": "THE OFFICES 1 ,DWTC ,115580 ,",
        "phone": "97143739700 / 971501148248",
        "email": "nitesh.pradhan@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "361fdc64-6b6f-4f37-abca-c52af8473b84",
    "firmName": "Pinsent Masons  LLP (DWTCA Branch)",
    "registrationNumber": "L-06806",
    "licenseIssueDate": "05/28/2025 00:00:00",
    "licenseExpiryDate": "05/27/2026 00:00:00"
  },
  {
    "id": "ee048878-ee2e-4aef-8a36-c0d3a0612194",
    "slug": "yorgo-ghanem-abi-khalil",
    "name": "YORGO GHANEM ABI KHALIL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/09/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Yorgo Ghanem Abi Khalil",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ee048878-ee2e-4aef-8a36-c0d3a0612194",
        "address": "الطابق الخامس ,الساحة ,سوق البحار ,26011 ,Dubai",
        "phone": "97142277717",
        "email": "info@alsahlawico.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a6811a79-5470-4c33-ad95-3ff8f661c052",
    "firmName": "AL SAHLAWI & CO ADVOCATES & CONSULTANTS",
    "registrationNumber": "L-06963",
    "licenseIssueDate": "09/17/2025 00:00:00",
    "licenseExpiryDate": "09/16/2026 00:00:00"
  },
  {
    "id": "dbcd7d35-ce5a-4a0f-be75-8990e3707ab2",
    "slug": "younus-alam",
    "name": "YOUNUS ALAM",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/08/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Younus Alam",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dbcd7d35-ce5a-4a0f-be75-8990e3707ab2",
        "address": "",
        "phone": "97143025100 / 971501501837",
        "email": "ccairns@trowers.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "976857f5-9092-43cf-987d-bfa794a3fa51",
    "firmName": "Trowers & Hamlins LLP",
    "registrationNumber": "L-06918",
    "licenseIssueDate": "08/18/2025 00:00:00",
    "licenseExpiryDate": "08/17/2026 00:00:00"
  },
  {
    "id": "644c687d-37a6-41fd-ae74-ffee4fc63b33",
    "slug": "yousef-ali-bugaighis",
    "name": "YOUSEF ALI BUGAIGHIS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/08/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Yousef Ali Bugaighis",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_644c687d-37a6-41fd-ae74-ffee4fc63b33",
        "address": "Al Fattan Currency House Tower 2 ,DIFC ,507176 ,",
        "phone": "/ 971552009003",
        "email": "Mohammad.AlRasheed@bakermckenzie.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "acd81e81-dead-4f7c-839e-0f2a57897265",
    "firmName": "Baker & Mckenzie LLP",
    "registrationNumber": "L-05473",
    "licenseIssueDate": "08/17/2022 00:00:00",
    "licenseExpiryDate": "08/16/2026 00:00:00"
  },
  {
    "id": "acc4ba7f-9bf9-478d-96a2-c2bcf9ab019d",
    "slug": "yousef-mammoun-mamdouh-alshakah",
    "name": "YOUSEF MAMMOUN MAMDOUH ALSHAKAH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/09/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Yousef Mammoun Mamdouh Alshakah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_acc4ba7f-9bf9-478d-96a2-c2bcf9ab019d",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-06001",
    "licenseIssueDate": "09/05/2023 00:00:00",
    "licenseExpiryDate": "09/04/2026 00:00:00"
  },
  {
    "id": "a910618b-9db0-4f4f-a7fa-80bb25a9c60f",
    "slug": "yousef-mohamed-alamly",
    "name": "YOUSEF MOHAMED MOHAMED MOHAMED ALAMLY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Personal Status-Wills",
      "Civil Transactions-Tenancy",
      "Commercial Transactions-Commercial Companies",
      "Civil Transactions-Labor & Workers",
      "Civil Transactions-Sale",
      "Commercial Transactions-Stock",
      "Criminal Law-Crimes against properties"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/09/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Yousef Mohamed Alamly",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a910618b-9db0-4f4f-a7fa-80bb25a9c60f",
        "address": "ICD Brookfield Place ,Za'abeel 2 ,103747 ,",
        "phone": "97143696300 / 971506008159",
        "email": "mohammed.paracha@nortonrosefulbright.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c4aaee93-0ec4-4982-9a48-a23699492056",
    "firmName": "Norton Rose Fullbright (Middle East) LLP",
    "registrationNumber": "L-02170",
    "licenseIssueDate": "09/10/2024 00:00:00",
    "licenseExpiryDate": "09/09/2026 00:00:00"
  },
  {
    "id": "311ef3e3-9989-4671-afa3-dd06e18ec14f",
    "slug": "youssab-emad-halim-rafla",
    "name": "Youssab Emad Halim Rafla",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/09/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Youssab Emad Halim Rafla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_311ef3e3-9989-4671-afa3-dd06e18ec14f",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-05965",
    "licenseIssueDate": "08/09/2023 00:00:00",
    "licenseExpiryDate": "08/08/2026 00:00:00"
  },
  {
    "id": "c0fa0da5-8487-4fe0-b90f-34f60383cc60",
    "slug": "youssef-ali-youssef",
    "name": "YOUSSEF ALI ALI YOUSSEF",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/01/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Youssef Ali Youssef",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c0fa0da5-8487-4fe0-b90f-34f60383cc60",
        "address": "6F 603, 605, 7F 704 ,Crystal Tower ,Dubai Mall ,117538 ,Dubai",
        "phone": "97146098700",
        "email": "pro@miolawfirm.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "417f90a1-03be-4dab-8eea-1bba7e16f536",
    "firmName": "ABU BAKER SALEM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02197",
    "licenseIssueDate": "01/05/2012 00:00:00",
    "licenseExpiryDate": "12/27/2025 00:00:00"
  },
  {
    "id": "d4098b05-96b8-4cc4-82b1-eea88ecc6ffc",
    "slug": "youssef-eid",
    "name": "YOUSSEF ABDEL WAHAB YOUSSEF EID",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/10/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Youssef Eid",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d4098b05-96b8-4cc4-82b1-eea88ecc6ffc",
        "address": "",
        "phone": "97143348481",
        "email": "lawyers@maidor.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "a48d1666-6ca7-461a-8197-a892ef0f3545",
    "firmName": "AL MAIDOOR ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01716",
    "licenseIssueDate": "11/01/2011 00:00:00",
    "licenseExpiryDate": "10/23/2025 00:00:00"
  },
  {
    "id": "ccf9fe9d-c8af-46db-8904-64d8629abe6e",
    "slug": "youssef-elazzab-attia",
    "name": "YOUSSEF ELAZZAB YOUSSEF ATTIA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Youssef Elazzab Attia",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ccf9fe9d-c8af-46db-8904-64d8629abe6e",
        "address": "شركة قطر للتأمين ,مركز الدانة ,فندق كارلتون بالاس ,80239 ,Dubai",
        "phone": "97142247451",
        "email": "nooradvo@eim.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "09f7be53-e98a-499b-a46b-3635ebba9c54",
    "firmName": "NAWAL MOHAMED AL BADY  ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-01720",
    "licenseIssueDate": "02/16/2012 00:00:00",
    "licenseExpiryDate": "02/07/2026 00:00:00"
  },
  {
    "id": "1d14a43a-4284-4393-8140-c7bba215116b",
    "slug": "youssef-eltanany",
    "name": "YOUSSEF MOUSTAFA YOUSSEF ELTANANY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/09/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Youssef Eltanany",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1d14a43a-4284-4393-8140-c7bba215116b",
        "address": "FATIMA MOHAMMAD ALMAZAM ,3RD FLOOR ,LIBERTY ,BESIDE BANK OF SHARJAH ,35630 ,Dubai",
        "phone": "97142822278",
        "email": "tanany@emirates.net.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "5c727678-4d31-4064-9400-932655fce73e",
    "firmName": "ALMASA ADVOCATES",
    "registrationNumber": "L-01408",
    "licenseIssueDate": "09/26/2011 00:00:00",
    "licenseExpiryDate": "09/17/2026 00:00:00"
  },
  {
    "id": "5025e1d2-6e16-48ba-bb75-14b0fc2cf9e5",
    "slug": "youssef-khalaf",
    "name": "Youssef Khalaf",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/28/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Youssef Khalaf",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5025e1d2-6e16-48ba-bb75-14b0fc2cf9e5",
        "address": "O-4801, O-4901 ,Burj al Salam Office Tower ,H Hotel ,111801 ,Dubai",
        "phone": "97143544444",
        "email": "administration@horizlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4e25fb39-6659-44f0-bc8b-3ff0f067beb0",
    "firmName": "HORIZONS & CO - LAW FIRM",
    "registrationNumber": "L-03684",
    "licenseIssueDate": "03/28/2017 00:00:00",
    "licenseExpiryDate": "03/24/2026 00:00:00"
  },
  {
    "id": "13739931-de7f-4eed-838d-d6ec2bb3b005",
    "slug": "youssef-khattar",
    "name": "YOUSSEF KHATTAR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/11/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Youssef Khattar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_13739931-de7f-4eed-838d-d6ec2bb3b005",
        "address": "",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de972132-ce4d-4000-b7ee-71cb5557b048",
    "firmName": "DLA Piper Middle East LLP",
    "registrationNumber": "L-06111",
    "licenseIssueDate": "11/29/2023 00:00:00",
    "licenseExpiryDate": "11/28/2025 00:00:00"
  },
  {
    "id": "acc5c1d2-4f21-4c1a-a1c9-634bd39a8bd0",
    "slug": "youssef-mohamed-eyad-saady-khalil",
    "name": "YOUSSEF MOHAMED EYAD SAADY KHALIL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/09/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Youssef Mohamed Eyad Saady Khalil",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_acc5c1d2-4f21-4c1a-a1c9-634bd39a8bd0",
        "address": "",
        "phone": "97144286300 / 971506256686",
        "email": "stuart.paterson@hsf.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2f0389b3-bfde-44f4-bdd6-6e1a22f9cab2",
    "firmName": "Herbert Smith Freehills Kramer LLP",
    "registrationNumber": "L-06498",
    "licenseIssueDate": "09/11/2024 00:00:00",
    "licenseExpiryDate": "09/10/2026 00:00:00"
  },
  {
    "id": "7fc71ba2-4929-4462-a5ab-16be5472ba13",
    "slug": "youssef-nasri-bakhache",
    "name": "YOUSSEF NASRI BAKHACHE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Commercial Contracts",
      "Civil Transactions-Tenancy",
      "Commercial Transactions-Commercial Companies",
      "Civil Transactions-Labor & Workers",
      "Commercial Transactions-Consumer protection",
      "Commercial Transactions-E-Commerce"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/12/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Youssef Nasri Bakhache",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7fc71ba2-4929-4462-a5ab-16be5472ba13",
        "address": "Central Park Towers ,507120 ,",
        "phone": "97143200940 / 971502397176",
        "email": "lsahbani@lpalaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4c158c98-1a29-48da-ade1-54e60bfd5b78",
    "firmName": "LPA (Middle East) LTD",
    "registrationNumber": "L-05131",
    "licenseIssueDate": "12/06/2021 00:00:00",
    "licenseExpiryDate": "12/05/2025 00:00:00"
  },
  {
    "id": "bac6e073-2ba5-4339-823e-54456b544cdd",
    "slug": "youssef-shoieb-hafez-el-gamal",
    "name": "YOUSSEF SHOIEB HAFEZ AHMED ELGAMAL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Commercial Agency",
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Civil Transactions-Insurance",
      "Civil Transactions-Construction and Contracts for Services",
      "Civil Transactions-HR & Employee Affairs",
      "Commercial Transactions-Commercial Mortgage",
      "Personal Status-Custody & Alimony",
      "Commercial Transactions-Commercial Contracts",
      "Commercial Transactions-Bankruptcy",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Civil Transactions-Tenancy",
      "Criminal Law-Crimes against persons",
      "Commercial Transactions-Commercial Companies",
      "Commercial Transactions-Banking Operations",
      "Civil Transactions-Labor & Workers",
      "Criminal Law-Drug Crimes",
      "Civil Transactions-Sale",
      "Commercial Transactions-Sea and air freight",
      "Personal Status-Marriage & Divorce",
      "Civil Transactions-Compensation",
      "Criminal Law-Crimes against properties",
      "Criminal Law-Cybercrimes",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/05/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: YOUSSEF SHOIEB HAFEZ EL GAMAL",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bac6e073-2ba5-4339-823e-54456b544cdd",
        "address": "Saeed Sulayem Rashed Almazrouei ,M05 ,Al Durrah 4 ,Behind GGICO metro station ,11311 ,Dubai",
        "phone": "97143889000",
        "email": "info@sulayemlegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b221d5d0-c8b1-4064-a7a5-84cf410fd408",
    "firmName": "SAEED SULAYEM ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05860",
    "licenseIssueDate": "05/17/2023 00:00:00",
    "licenseExpiryDate": "05/16/2026 00:00:00"
  },
  {
    "id": "f4258160-8ccd-4092-80ca-6a6351b18b70",
    "slug": "yulia-amanbaeva",
    "name": "YULIA AMANBAEVA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/12/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Yulia Amanbaeva",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f4258160-8ccd-4092-80ca-6a6351b18b70",
        "address": "Mohamed Alhammadi ,FLOOR 16 OFFICE B1605 ,LATIFA TOWER ,CLOSE TO CROWN PLAZA HOTEL ,76550 ,Dubai",
        "phone": "97143298866",
        "email": "admin@dralhammadilaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "612e75e6-c3f3-479b-bc93-ee88982dea58",
    "firmName": "DR MOHAMED ALHAMMADI ADVOCATES & LEGAL CONSULTANTS OFFICE",
    "registrationNumber": "L-04585",
    "licenseIssueDate": "12/16/2019 00:00:00",
    "licenseExpiryDate": "12/15/2025 00:00:00"
  },
  {
    "id": "895d5d7e-ed01-453c-a404-74ddffa85f29",
    "slug": "yulia-kasiyanova",
    "name": "YULIA IGOREVNA KASIYANOVA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Civil Transactions-HR & Employee Affairs"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/09/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Yulia Kasiyanova",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_895d5d7e-ed01-453c-a404-74ddffa85f29",
        "address": "A7 ,Dubai Silicon Oasis ,29337 ,",
        "phone": "97144313060 / 971528448686",
        "email": "andres.ring@schlueter-graf.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2ce110f0-b433-4dbc-b15f-ab1a3b291c28",
    "firmName": "Schluter Graf Legal Consultants LLC",
    "registrationNumber": "L-00393",
    "licenseIssueDate": "09/17/2012 00:00:00",
    "licenseExpiryDate": "09/09/2026 00:00:00"
  },
  {
    "id": "6a36a1bf-00a5-4a43-93d0-19f370e4601b",
    "slug": "yuliya-charniauskaya",
    "name": "Yuliya Charniauskaya",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/04/2015",
    "licenseStatus": "active",
    "licenseExpiry": "2016-04-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Yuliya Charniauskaya",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6a36a1bf-00a5-4a43-93d0-19f370e4601b",
        "address": "",
        "phone": "97142552220",
        "email": "almaazmi.office@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "e04d8a88-3378-40c8-a33a-b5e26a0c8507",
    "firmName": "ABDELRAHMAN AL MAAZMI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-01804",
    "licenseIssueDate": "04/13/2015 00:00:00",
    "licenseExpiryDate": "04/07/2026 00:00:00"
  },
  {
    "id": "72e4e2bb-79d5-429f-88d8-3e0dede2e817",
    "slug": "yumna-saem-al-daher",
    "name": "YUMNA SAEMALDAHER",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/02/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Yumna Saem Al Daher",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_72e4e2bb-79d5-429f-88d8-3e0dede2e817",
        "address": "",
        "phone": "97142942616",
        "email": "info@ilofficeuae.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "48ef4874-8647-4fb6-bedd-ffbad25accd1",
    "firmName": "KHALID KALANDAR ALMAAZMI ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-02260",
    "licenseIssueDate": "02/05/2013 00:00:00",
    "licenseExpiryDate": "01/28/2026 00:00:00"
  },
  {
    "id": "e9a791f4-4b75-4fb3-ab66-d99208c11272",
    "slug": "zafer-sheikh-oghli",
    "name": "Zafer Sheikh Oghli",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/02/2012",
    "licenseStatus": "active",
    "licenseExpiry": "2013-02-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Zafer Sheikh Oghli",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e9a791f4-4b75-4fb3-ab66-d99208c11272",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "7d2f8d87-b1b6-45f6-bd36-52d8784a34a2",
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02281",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "1354d693-596c-4c76-97d1-2eb6b9088ab8",
    "slug": "zaghloul-zaghloul-mohamed-mohamed-elsayed",
    "name": "ZAGHLOUL ZAGHLOUL MOHAMED MOHAMED ELSAYED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaWgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Commercial Agency",
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center",
      "Civil Transactions-Insurance",
      "Civil Transactions-Construction and Contracts for Services",
      "Civil Transactions-HR & Employee Affairs",
      "Commercial Transactions-Commercial Mortgage",
      "Personal Status-Custody & Alimony",
      "Commercial Transactions-Commercial Contracts",
      "Civil Transactions-Residential Real Estate",
      "Commercial Transactions-Bills of Exchange",
      "Cheques",
      "Promissory Notes",
      "Civil Transactions-Arbitration",
      "Civil Transactions-Tenancy",
      "Criminal Law-Crimes against persons",
      "Commercial Transactions-Commercial Companies",
      "Civil Transactions-Labor & Workers",
      "Criminal Law-Drug Crimes",
      "Civil Transactions-Sale",
      "Personal Status-Marriage & Divorce",
      "Civil Transactions-Compensation",
      "Criminal Law-Crimes against properties",
      "Commercial Transactions-E-Commerce",
      "Criminal Law-Cybercrimes",
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/01/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Zaghloul Zaghloul Mohamed Mohamed Elsayed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1354d693-596c-4c76-97d1-2eb6b9088ab8",
        "address": "ISMAIL HASSAN EBRAHIM ALSAFFAR ,الطابق الثامن - مكتب 801 AFR ,الصقر للاعمال ,يوجد اسفل البناية مطعم وينديز ,25752 ,Dubai",
        "phone": "97143276805",
        "email": "info@alsaffar-legal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ceb9cbcf-79f3-462d-afe2-aa4c62eff72b",
    "firmName": "ISMAIL ALSAFFAR ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05152",
    "licenseIssueDate": "01/11/2022 00:00:00",
    "licenseExpiryDate": "01/10/2026 00:00:00"
  },
  {
    "id": "dcb23cec-0d94-4334-9836-09e22a137b2b",
    "slug": "zahra-aziz-syed-azizur-rahman",
    "name": "ZAHRA AZIZ SYED AZIZUR RAHMAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/07/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Zahra Aziz Syed Azizur Rahman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dcb23cec-0d94-4334-9836-09e22a137b2b",
        "address": "- ,Index Tower ,Dubai International Financial Centre ,9371 ,Dubai",
        "phone": "97143303900 / 971561753537",
        "email": "christopher@afridi-angell.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3e464dc8-b800-4ba2-ad91-24a5f9640fef",
    "firmName": "Afridi & Angell-DIFC",
    "registrationNumber": "L-06902",
    "licenseIssueDate": "07/30/2025 00:00:00",
    "licenseExpiryDate": "07/29/2026 00:00:00"
  },
  {
    "id": "a17b41af-b9de-4613-9220-bdb94fcd9a52",
    "slug": "zahra-knapper",
    "name": "ZAHRA KNAPPER",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/08/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Zahra Knapper",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_a17b41af-b9de-4613-9220-bdb94fcd9a52",
        "address": "",
        "phone": "97144363636 / 971505572900",
        "email": "hassan.elsayed@bakerbotts.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "fd5d6571-d053-4436-9de5-c8a36ce7c6c9",
    "firmName": "Baker Botts LLP Legal Consultants Dubai Branch",
    "registrationNumber": "L-05883",
    "licenseIssueDate": "08/02/2023 00:00:00",
    "licenseExpiryDate": "08/01/2026 00:00:00"
  },
  {
    "id": "1f4ead1b-5117-4768-aa14-7efcd09eed3e",
    "slug": "zahra-mashhood",
    "name": "ZAHRA MASHHOOD",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/07/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Zahra Mashhood",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1f4ead1b-5117-4768-aa14-7efcd09eed3e",
        "address": "ICD Brookfield Place ,DIFC ,120109 ,",
        "phone": "97143173000 / 971504465229",
        "email": "DubaiLAD@akingump.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9ff29eab-adb8-40f9-ab84-216e01a381e4",
    "firmName": "Akin Gump Strauss Hauer & Feld LLP",
    "registrationNumber": "L-05904",
    "licenseIssueDate": "07/19/2023 00:00:00",
    "licenseExpiryDate": "07/18/2026 00:00:00"
  },
  {
    "id": "2463a1cf-832c-4fda-b3aa-3a144667d632",
    "slug": "zahra-rose-salmaan-khawaja",
    "name": "Zahra Rose Salmaan Khawaja",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/27/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Zahra Rose Salmaan Khawaja",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2463a1cf-832c-4fda-b3aa-3a144667d632",
        "address": "",
        "phone": "97144020800 / 971566830829",
        "email": "dean.ryburn@dentons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "dfe13b7e-6625-45fd-ad63-9ee83af41194",
    "firmName": "Dentons & Co Dubai Branch-DED",
    "registrationNumber": "L-04325",
    "licenseIssueDate": "02/27/2019 00:00:00",
    "licenseExpiryDate": "02/25/2026 00:00:00"
  },
  {
    "id": "97ef4e88-34e4-4186-a150-f3fddfe80a15",
    "slug": "zaid-abushattal",
    "name": "ZAID SAQER MATROUK ABUSHATTAL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/04/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Zaid Abushattal",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_97ef4e88-34e4-4186-a150-f3fddfe80a15",
        "address": "",
        "phone": "97144272700 / 971545824605",
        "email": "tony.griffiths@klgates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "fb8fc340-ceef-4b83-8f2b-9b24d4604967",
    "firmName": "K & L Gates LLP",
    "registrationNumber": "L-03857",
    "licenseIssueDate": "09/04/2017 00:00:00",
    "licenseExpiryDate": "09/01/2026 00:00:00"
  },
  {
    "id": "b6176c3d-35a4-4e41-923b-3f150f5b5fba",
    "slug": "zaid-ali-wani",
    "name": "ZAID ALI WANI SHOUKAT ALI WANI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/06/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2023-06-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Zaid Ali Wani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b6176c3d-35a4-4e41-923b-3f150f5b5fba",
        "address": "sohail jassem pararin ,34 ,Central Park Tower ,Dubai Mall ,233066 ,Dubai",
        "phone": "97144228410",
        "email": "info@mahmoodhussain.net",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "f3309481-3edd-4503-92d2-bd9f71ba513a",
    "firmName": "MAHMOOD HUSSAIN ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-05373",
    "licenseIssueDate": "06/22/2022 00:00:00",
    "licenseExpiryDate": "06/21/2023 00:00:00"
  },
  {
    "id": "791e7c7e-d26c-49e3-831b-889121def71e",
    "slug": "zaid-al-rizzo",
    "name": "ZAID AL RIZZO",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/05/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Zaid Al-Rizzo",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_791e7c7e-d26c-49e3-831b-889121def71e",
        "address": "ICD-Brookfield Place ,DIFC ,119974 ,",
        "phone": "97143652000",
        "email": "david.charlier@ashurst.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c01c3c61-4d90-4058-8429-61dd01e615f5",
    "firmName": "Ashurst LLP-DIFC",
    "registrationNumber": "L-04095",
    "licenseIssueDate": "05/08/2018 00:00:00",
    "licenseExpiryDate": "11/03/2025 00:00:00"
  },
  {
    "id": "bc50e3d0-9626-435f-96c4-5c655a07b7f5",
    "slug": "zaki-abd-elmoneim-zaki-mohamed",
    "name": "ZAKI ABDELMONEIM ZAKI MOHAMED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/10/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Zaki Abd Elmoneim Zaki Mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bc50e3d0-9626-435f-96c4-5c655a07b7f5",
        "address": "21 ,Rolex Tower ,Emirates Grand Hotel ,94334 ,Dubai",
        "phone": "97143277772 / 97145584900",
        "email": "info@globaladvocates.net",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9b42810f-1d55-4aea-ac4a-7d9d1b25ac08",
    "firmName": "GLOBAL ADVOCACY & LEGAL COUNSEL",
    "registrationNumber": "L-02033",
    "licenseIssueDate": "10/24/2012 00:00:00",
    "licenseExpiryDate": "10/16/2026 00:00:00"
  },
  {
    "id": "bf0c5a59-ba61-436a-813d-04cde41eb3e2",
    "slug": "zara-merali",
    "name": "ZARA ANGELINA MERALI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/06/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Zara Merali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bf0c5a59-ba61-436a-813d-04cde41eb3e2",
        "address": "0 ,ICD Brookfield Place Level 13 ,Trade Centre ,506569 ,Dubai",
        "phone": "97145099100 / 971501006965",
        "email": "menahr@freshfields.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "970f6246-e737-41a7-9c6c-5aa5b8335d45",
    "firmName": "Freshfields LLP DIFC",
    "registrationNumber": "L-03397",
    "licenseIssueDate": "06/29/2016 00:00:00",
    "licenseExpiryDate": "06/25/2026 00:00:00"
  },
  {
    "id": "7b196e44-8965-42f2-bd02-81f12ee06844",
    "slug": "zarak-khan-eyaz-ahmad",
    "name": "Zarak Khan Eyaz Ahmad",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/05/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Zarak Khan Eyaz Ahmad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7b196e44-8965-42f2-bd02-81f12ee06844",
        "address": "IH-00-01-CP-05 ,DIFC ,506832 ,",
        "phone": "/ 971506957753",
        "email": "admin@supportlegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "1607c199-ca4b-4bc1-89e9-98dad0300645",
    "firmName": "Support Legal ( DIFC) Limited",
    "registrationNumber": "L-05667",
    "licenseIssueDate": "12/05/2022 00:00:00",
    "licenseExpiryDate": "12/04/2025 00:00:00"
  },
  {
    "id": "4fc59221-eaed-49a4-80ea-b0637124d8a2",
    "slug": "zarghona-fazal",
    "name": "ZARGHONA FAZAL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/11/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Zarghona Fazal",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4fc59221-eaed-49a4-80ea-b0637124d8a2",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4309e28c-2b73-49f5-b30a-6f00e5dd4fdd",
    "firmName": "HADEF & PARTNERS L.L.C",
    "registrationNumber": "L-01137",
    "licenseIssueDate": "11/07/2012 00:00:00",
    "licenseExpiryDate": "10/30/2025 00:00:00"
  },
  {
    "id": "f86bb95b-beff-481d-9823-b72ea4beb42f",
    "slug": "zarin-tasnim-begum",
    "name": "ZARIN TASNIM BEGUM",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/04/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Zarin Tasnim Begum",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f86bb95b-beff-481d-9823-b72ea4beb42f",
        "address": "ICD-Brookfield Place ,DIFC ,119974 ,",
        "phone": "97143652000",
        "email": "david.charlier@ashurst.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c01c3c61-4d90-4058-8429-61dd01e615f5",
    "firmName": "Ashurst LLP-DIFC",
    "registrationNumber": "L-06767",
    "licenseIssueDate": "04/23/2025 00:00:00",
    "licenseExpiryDate": "04/22/2026 00:00:00"
  },
  {
    "id": "f9217d4a-a39b-4b08-8bff-f8540fd2545d",
    "slug": "zarina-ashraf-baig",
    "name": "ZARINA ASHRAF BAIG ISMAIL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/09/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Zarina Ashraf Baig",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f9217d4a-a39b-4b08-8bff-f8540fd2545d",
        "address": "الطابق الاول  ,بناية مشاريع قرقاش - مكتب رقم 102  ,وكاله مرسيدس  ,393947 ,Dubai",
        "phone": "97143799917",
        "email": "info@amt-legal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "2485aa73-a460-4867-9452-297e9feb733e",
    "firmName": "MARYAM ABDULLAH ADVOCATES AND LEGAL CONSULTANTS",
    "registrationNumber": "L-02498",
    "licenseIssueDate": "09/26/2011 00:00:00",
    "licenseExpiryDate": "09/17/2026 00:00:00"
  },
  {
    "id": "44c97c24-fb19-490a-98bd-2bfef4c899eb",
    "slug": "zayed-mohmed-husain-bakheet-hudaijan",
    "name": "ZAYED MOHAMED HUSAIN BAKHEET",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/12/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Zayed MOHMED HUSAIN BAKHEET HUDAIJAN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_44c97c24-fb19-490a-98bd-2bfef4c899eb",
        "address": "406 ,رقة البطين  ,بجوار فندق كونكورد  ,92414 ,Dubai",
        "phone": "97142666331",
        "email": "almeshref2019@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b47f195f-addd-458d-85ec-bb93239bbe4b",
    "firmName": "MOHAMMED BEKHIT ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05675",
    "licenseIssueDate": "12/21/2022 00:00:00",
    "licenseExpiryDate": "12/20/2025 00:00:00"
  },
  {
    "id": "6eef17c6-a740-4435-903a-5bae4b52712d",
    "slug": "zeiad-ahmed-gomaa",
    "name": "ZEIAD AHMED ABDELAZIZ GOMAA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/10/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Zeiad Ahmed Gomaa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6eef17c6-a740-4435-903a-5bae4b52712d",
        "address": "",
        "phone": "97143333386 / 971549916936",
        "email": "info@mtaadv.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "466f3ad4-73e1-44db-b8ec-b01e829d77c4",
    "firmName": "MOHAMMAD ALLINJAWI ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02186",
    "licenseIssueDate": "10/14/2012 00:00:00",
    "licenseExpiryDate": "10/06/2026 00:00:00"
  },
  {
    "id": "ac36c19c-003a-4d18-a333-95f49a080e5f",
    "slug": "zeid-hanania",
    "name": "ZEID DAOUD ANASTAS HANANIA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/06/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Zeid Hanania",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ac36c19c-003a-4d18-a333-95f49a080e5f",
        "address": "",
        "phone": "97143897000 / 971506553198",
        "email": "nasseralikhasawneh@eversheds-sutherland.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "74a21d43-41d8-480a-a6af-6939b7c98a95",
    "firmName": "Eversheds Sutherland (International LLP) Dubai Branch",
    "registrationNumber": "L-00592",
    "licenseIssueDate": "06/14/2015 00:00:00",
    "licenseExpiryDate": "06/09/2026 00:00:00"
  },
  {
    "id": "4fca4428-8545-4993-bea9-7410a01bcfce",
    "slug": "zeid-qursha",
    "name": "ZEID AKRAM QURSHA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaUQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Zeid Qursha",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4fca4428-8545-4993-bea9-7410a01bcfce",
        "address": "0 ,Burj Daman ,Dubai International Financial Center  ,506678 ,Dubai",
        "phone": "97144267100 / 971971566038",
        "email": "david.foster@allenovery.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "55e38c6c-febf-429c-aa23-024ec5811406",
    "firmName": "Allen Overy Shearman Sterling LLP",
    "registrationNumber": "L-00255",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "66a05e85-80ea-4056-aee9-683e727dde7d",
    "slug": "zeina-el-haje-obeid",
    "name": "ZEINA EL HAJE OBEID",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/06/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Zeina El Haje Obeid",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_66a05e85-80ea-4056-aee9-683e727dde7d",
        "address": "",
        "phone": "97140000000 / 971564600544",
        "email": "nayla@obeidpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6412dd75-56e7-47d4-90a8-5c34e1e0eb3a",
    "firmName": "Obeid Law Firm & Partners-Dubai Branch",
    "registrationNumber": "L-04968",
    "licenseIssueDate": "06/21/2021 00:00:00",
    "licenseExpiryDate": "06/20/2026 00:00:00"
  },
  {
    "id": "902bbbcd-6f04-4830-aaca-bf951fa60517",
    "slug": "zeina-mouannes",
    "name": "ZEINA MOUANESS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/04/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Zeina Mouannes",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_902bbbcd-6f04-4830-aaca-bf951fa60517",
        "address": "Firas Hassan Al Choufi ,701 ,The Prime Tower ,Makani No: 25836 86879 ,125305 ,Dubai",
        "phone": "97144357246",
        "email": "info@binsevanadvocates.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "4d3c9dcc-51c6-4883-b9ed-c65a7d1c5a57",
    "firmName": "BIN SEVAN ADVOCATES & LEGAL CONSULTANCY",
    "registrationNumber": "L-05743",
    "licenseIssueDate": "04/26/2023 00:00:00",
    "licenseExpiryDate": "04/25/2026 00:00:00"
  },
  {
    "id": "6510bbe5-a7c3-4ec5-876a-01b5143e41d8",
    "slug": "zeina-rifai",
    "name": "ZEINA RIFAI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/08/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Zeina Rifai",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6510bbe5-a7c3-4ec5-876a-01b5143e41d8",
        "address": "1 ,Emaar Square 5 ,sheikh mohammed bin rashid BVD ,11987 ,Dubai",
        "phone": "97143043100 / 971507325154",
        "email": "amir.kordvani@pwc.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "ea026b18-c93c-4f67-a1f2-4546320f8f3e",
    "firmName": "PWC Legal Middle East LLP",
    "registrationNumber": "L-06458",
    "licenseIssueDate": "08/14/2024 00:00:00",
    "licenseExpiryDate": "08/13/2026 00:00:00"
  },
  {
    "id": "91561a9f-1407-4c2c-b335-64e836248015",
    "slug": "zeineb-bouraoui",
    "name": "ZEINEB BOURAOUI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/05/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Zeineb Bouraoui",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_91561a9f-1407-4c2c-b335-64e836248015",
        "address": "One Central, The Offices 5 ,Dubai World Trade Centre ,554660 ,",
        "phone": "97142052030 / 971506566494",
        "email": "chourani@houranipartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "59a73632-40a0-4849-b120-4308dc6f8015",
    "firmName": "Hourani & Partners Legal Consultancy FZCO",
    "registrationNumber": "L-06824",
    "licenseIssueDate": "05/28/2025 00:00:00",
    "licenseExpiryDate": "05/27/2026 00:00:00"
  },
  {
    "id": "9b039bd0-5dc1-48a9-8d92-a55d3fb75658",
    "slug": "zeyad-yousef-mustafa-imsiei",
    "name": "ZEYAD YOUSEF MUSTAFA IMSIEI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Commercial Transactions-Commercial Real Estate",
      "Civil Transactions-Residential Real Estate"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Zeyad Yousef Mustafa Imsiei",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9b039bd0-5dc1-48a9-8d92-a55d3fb75658",
        "address": "1201 ,برج تريو اي بي اي اوفيس  ,فندق نوافتيل ,8812 ,Dubai",
        "phone": "97144222555",
        "email": "lutfilaw2020@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9a3d884b-a443-4037-9eb4-f810c596cf33",
    "firmName": "LUTFI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-02175",
    "licenseIssueDate": "02/29/2012 00:00:00",
    "licenseExpiryDate": "02/20/2026 00:00:00"
  },
  {
    "id": "3ec94ee2-cf4e-4b10-91b3-bcb1f8347567",
    "slug": "zhao-wenjie",
    "name": "WENJIE ZHAO",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/07/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Zhao Wenjie",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3ec94ee2-cf4e-4b10-91b3-bcb1f8347567",
        "address": "Hamad Abdul wahab alqawadi ,الطابق العاشر / مكتب 1002 ,فندق ذا اتش  ,المركز التجاري  ,00000 ,Dubai",
        "phone": "97145681225",
        "email": "alhamad_advo@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "f2476874-d6f1-491d-857f-df0917f9997a",
    "firmName": "ALHAMAD ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-05429",
    "licenseIssueDate": "07/18/2022 00:00:00",
    "licenseExpiryDate": "07/17/2026 00:00:00"
  },
  {
    "id": "b99f8e50-01f8-4e8c-a87d-bc3a4e14df50",
    "slug": "zhouzhang-chen",
    "name": "ZHOUZHANG CHEN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/11/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Zhouzhang Chen",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b99f8e50-01f8-4e8c-a87d-bc3a4e14df50",
        "address": "4th floor ,Al Saaha Offices Block D office 401A ,Burj Khalifa ,283773 ,Dubai",
        "phone": "97144221944",
        "email": "gov.depts@alsafarpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b7bbfaeb-1fdb-46d2-97cf-8e6432a9b8a7",
    "firmName": "AL SAFAR & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "registrationNumber": "L-06100",
    "licenseIssueDate": "11/22/2023 00:00:00",
    "licenseExpiryDate": "11/21/2025 00:00:00"
  },
  {
    "id": "f80e9529-a14b-4cdb-82a7-b1da152db2d8",
    "slug": "ziad-el-oud",
    "name": "ZIAD EL OUD",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/06/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ziad El Oud",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f80e9529-a14b-4cdb-82a7-b1da152db2d8",
        "address": "ICD Brookfield Place ,DIFC ,120109 ,",
        "phone": "97143173000 / 971504465229",
        "email": "DubaiLAD@akingump.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "9ff29eab-adb8-40f9-ab84-216e01a381e4",
    "firmName": "Akin Gump Strauss Hauer & Feld LLP",
    "registrationNumber": "L-06855",
    "licenseIssueDate": "06/11/2025 00:00:00",
    "licenseExpiryDate": "06/10/2026 00:00:00"
  },
  {
    "id": "9bf2879c-57e2-43f4-863b-fd37068ed490",
    "slug": "ziad-emile-el-hajj-obeid",
    "name": "ZIAD EMILE EL HAJJ OBEID",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/08/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ziad Emile El Hajj Obeid",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9bf2879c-57e2-43f4-863b-fd37068ed490",
        "address": "",
        "phone": "97140000000 / 971564600544",
        "email": "nayla@obeidpartners.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "6412dd75-56e7-47d4-90a8-5c34e1e0eb3a",
    "firmName": "Obeid Law Firm & Partners-Dubai Branch",
    "registrationNumber": "L-05017",
    "licenseIssueDate": "08/16/2021 00:00:00",
    "licenseExpiryDate": "08/15/2026 00:00:00"
  },
  {
    "id": "6f2b8cbb-f29b-40e6-8089-36f6a417c716",
    "slug": "ziad-samir-chebli",
    "name": "ZIAD SAMIR CHEBLI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/12/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ziad Samir Chebli",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6f2b8cbb-f29b-40e6-8089-36f6a417c716",
        "address": "HAMDAN ALSHAMSI ,الطابق الرابع مكتب 401, 406,407 ,بي سكوير 01 ,مجمع دبي سكوير ,116564 ,Dubai",
        "phone": "97143469262",
        "email": "courts@has.law",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "de2c61a6-9d00-457e-ad1d-e73e4e62d9bd",
    "firmName": "HAMDAN ALSHAMSI LAWYER & LEGAL CONSULTANTS",
    "registrationNumber": "L-06130",
    "licenseIssueDate": "12/06/2023 00:00:00",
    "licenseExpiryDate": "12/05/2025 00:00:00"
  },
  {
    "id": "f345e6e2-9485-44fc-be44-ea544247af86",
    "slug": "zil-ur-rehman-riaz-ur-rehman",
    "name": "ZIL UR REHMAN RIAZ UR REHMAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaVQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/09/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Zil Ur Rehman Riaz Ur Rehman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f345e6e2-9485-44fc-be44-ea544247af86",
        "address": "THE OFFICES 1 ,DWTC ,115580 ,",
        "phone": "97143739700 / 971501148248",
        "email": "nitesh.pradhan@pinsentmasons.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "361fdc64-6b6f-4f37-abca-c52af8473b84",
    "firmName": "Pinsent Masons  LLP (DWTCA Branch)",
    "registrationNumber": "L-05983",
    "licenseIssueDate": "09/06/2023 00:00:00",
    "licenseExpiryDate": "09/05/2026 00:00:00"
  },
  {
    "id": "190a34f4-d604-4216-8a87-d139b87e824d",
    "slug": "zoe-ireland",
    "name": "Zoe Ireland",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/28/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Zoe Ireland",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_190a34f4-d604-4216-8a87-d139b87e824d",
        "address": "IH-00-01-CP-05 ,DIFC ,506832 ,",
        "phone": "/ 971506957753",
        "email": "admin@supportlegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "1607c199-ca4b-4bc1-89e9-98dad0300645",
    "firmName": "Support Legal ( DIFC) Limited",
    "registrationNumber": "L-06822",
    "licenseIssueDate": "05/28/2025 00:00:00",
    "licenseExpiryDate": "05/27/2026 00:00:00"
  },
  {
    "id": "30f64e50-cb8e-4b9c-901c-9369ce12c5c7",
    "slug": "zoe-victoria-tite",
    "name": "ZOE VICTORIA TITE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaVgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/05/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Zoe Victoria Tite",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_30f64e50-cb8e-4b9c-901c-9369ce12c5c7",
        "address": "",
        "phone": "97143844000 / 971566810785",
        "email": "Sophie.Seymour@clydeco.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "3c1ff203-4ddb-44f9-9917-c8db1a2967a3",
    "firmName": "Clyde & Co LLP",
    "registrationNumber": "L-05740",
    "licenseIssueDate": "05/03/2023 00:00:00",
    "licenseExpiryDate": "05/02/2026 00:00:00"
  },
  {
    "id": "e27f8fb4-343f-4524-afdb-a6e42c7414ef",
    "slug": "zoe-zhang",
    "name": "ZOE ZHANG",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaWgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/03/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Zoe Zhang",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e27f8fb4-343f-4524-afdb-a6e42c7414ef",
        "address": "",
        "phone": "97145953601 / 971508728645",
        "email": "Steven.Bainbridge@gtlaw.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "b4146aa6-efd1-41d7-819d-49da46353b0b",
    "firmName": "Greenberg Traurig Limited",
    "registrationNumber": "L-06272",
    "licenseIssueDate": "03/25/2024 00:00:00",
    "licenseExpiryDate": "03/24/2026 00:00:00"
  },
  {
    "id": "4530140b-44fd-4b6d-b4c3-7a345f4db679",
    "slug": "zubair-mir",
    "name": "ZUBAIR MIR MOHAMED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzM3NDE1MTtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNDBlMWU7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-02-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Zubair Mir",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4530140b-44fd-4b6d-b4c3-7a345f4db679",
        "address": "ICD Brookfield Place ,Za'abeel 2 ,103747 ,",
        "phone": "97143696300 / 971506008159",
        "email": "mohammed.paracha@nortonrosefulbright.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Consultancy",
        "description": "Legal Consultant services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Legal_Consultancy_Individuals",
    "role": "Team Member",
    "firmId": "c4aaee93-0ec4-4982-9a48-a23699492056",
    "firmName": "Norton Rose Fullbright (Middle East) LLP",
    "registrationNumber": "L-00793",
    "licenseIssueDate": "02/25/2012 00:00:00",
    "licenseExpiryDate": "02/16/2026 00:00:00"
  },
  {
    "id": "337d420c-e3ef-41c1-8e2f-ece1f6eaa32a",
    "slug": "dr-muhammad-obaid-yousef-al-awasiya-al-zaabi",
    "name": "Dr. Muhammad Obaid Yousef Al-Awasiya Al-Zaabi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Dr. Muhammad Obaid Yousef Al-Awasiya Al-Zaabi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_337d420c-e3ef-41c1-8e2f-ece1f6eaa32a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4362",
    "company": "Dr. Mohammed Al Zaabi Advocates and Legal Consultants"
  },
  {
    "id": "5762b1f9-c833-4f24-b9ad-5780fe2d71b0",
    "slug": "khalifa-al-khatri-advocates-and-legal-consultants-dubai",
    "name": "Khalifa Al Khatri Advocates and Legal Consultants - Dubai",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEtBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Khalifa Al Khatri Advocates and Legal Consultants - Dubai",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5762b1f9-c833-4f24-b9ad-5780fe2d71b0",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4321",
    "owner": "Dr. Ahmed Hilal Ibrahim Al-Dhanhani"
  },
  {
    "id": "d90a508b-387d-42c6-b7de-f37ff34b42ff",
    "slug": "al-badi-advocates-and-legal-consultants-llc",
    "name": "Al Badi Advocates and Legal Consultants LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFCCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Al Badi Advocates and Legal Consultants LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_d90a508b-387d-42c6-b7de-f37ff34b42ff",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2573",
    "owner": "Ibrahim Salem Al-Badi"
  },
  {
    "id": "48f7a6c6-5e9f-4628-825e-1885ed57d3a9",
    "slug": "ibrahim-abdul-razzaq-al-tamimi",
    "name": "Ibrahim Abdul Razzaq Al Tamimi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ibrahim Abdul Razzaq Al Tamimi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_48f7a6c6-5e9f-4628-825e-1885ed57d3a9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "36",
    "company": "Al Tamimi Law Firm and Legal Consultations"
  },
  {
    "id": "51763797-5f1a-4e76-8230-4bf405704a6b",
    "slug": "al-ketbi-partners-advocates-and-legal-consultants",
    "name": "Al Ketbi & Partners Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFLCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Al Ketbi & Partners Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_51763797-5f1a-4e76-8230-4bf405704a6b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3935",
    "owner": "Ibrahim Abdullah Hussein bin Ali"
  },
  {
    "id": "dc9c5413-4612-4b2c-a5a9-16bb988deb12",
    "slug": "ibrahim-al-qasim-advocates-and-legal-consultantsdubai",
    "name": "Ibrahim Al Qasim Advocates and Legal Consultants/Dubai",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIElBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Ibrahim Al Qasim Advocates and Legal Consultants/Dubai",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_dc9c5413-4612-4b2c-a5a9-16bb988deb12",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "232",
    "owner": "Ibrahim Muhammad Ahmed Al-Qasim"
  },
  {
    "id": "fd7ae3b6-feb6-4c76-8405-f5d1255c2a23",
    "slug": "al-zahmi-advocates-and-legal-consultants-abu-dhabi-branch",
    "name": "Al Zahmi Advocates and Legal Consultants - Abu Dhabi Branch",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFaCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Al Zahmi Advocates and Legal Consultants - Abu Dhabi Branch",
    "consultationFee": 500,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_fd7ae3b6-feb6-4c76-8405-f5d1255c2a23",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "1370, 3498",
    "owner": "Ibrahim Hilal Obaid Al Neyadi"
  },
  {
    "id": "c1013cec-4b6d-428d-8a76-3e900de2738d",
    "slug": "sat-partners-advocates-and-legal-consultants",
    "name": "Sat & Partners Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNQCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Sat & Partners Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c1013cec-4b6d-428d-8a76-3e900de2738d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2309",
    "owner": "Abu Bakr Abdul Qadir Muhammad Yusuf Karmastanji"
  },
  {
    "id": "f36f55be-de38-40d3-8625-52a92a286553",
    "slug": "ahmed-ibrahim-abdul-rahman-al-zarouni",
    "name": "Ahmed Ibrahim Abdul Rahman Al Zarouni",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ahmed Ibrahim Abdul Rahman Al Zarouni",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_f36f55be-de38-40d3-8625-52a92a286553",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3305",
    "company": "Ahmed Al Zarouni Law Firm and Legal Consultations"
  },
  {
    "id": "710d93f7-b3f6-4265-a5a4-3e7dfc0b58ee",
    "slug": "ahmed-jassim-abdullah-al-rashed",
    "name": "Ahmed Jassim Abdullah Al-Rashed",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ahmed Jassim Abdullah Al-Rashed",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_710d93f7-b3f6-4265-a5a4-3e7dfc0b58ee",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "578",
    "company": "Al-Rashed Advocates and Legal Consultants"
  },
  {
    "id": "10aafea4-eeea-44cd-ab99-b5528c7e3b59",
    "slug": "ahmed-jumaa-mohammed-al-raisi",
    "name": "Ahmed Jumaa Mohammed Al-Raisi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ahmed Jumaa Mohammed Al-Raisi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_10aafea4-eeea-44cd-ab99-b5528c7e3b59",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "889",
    "company": "Ahmed Al-Raisi Advocates and Legal Consultants"
  },
  {
    "id": "a9e73d91-b3b3-46ac-a48b-3ba11d3637d1",
    "slug": "ahmed-hassan-ahmed-jarman",
    "name": "Ahmed Hassan Ahmed Jarman",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ahmed Hassan Ahmed Jarman",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_a9e73d91-b3b3-46ac-a48b-3ba11d3637d1",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3860",
    "company": "Ahmed Jarman Law Firm and Legal Consultations"
  },
  {
    "id": "30be58a5-dec6-4df2-80af-60157dd13ca3",
    "slug": "sultan-al-badi-and-partners-are-lawyers-and-legal-consultants",
    "name": "Sultan Al Badi and Partners are lawyers and legal consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Sultan Al Badi and Partners are lawyers and legal consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_30be58a5-dec6-4df2-80af-60157dd13ca3",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "1522, 3249, 4177",
    "owner": "Ahmed Hassan Saeed Omar Al-Zubaidi"
  },
  {
    "id": "a6b3cc29-ca41-44ba-a788-3903414a3142",
    "slug": "ahmed-hassan-ali-hashem",
    "name": "Ahmed Hassan Ali Hashem",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ahmed Hassan Ali Hashem",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_a6b3cc29-ca41-44ba-a788-3903414a3142",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "197",
    "company": "Hashem Group for Law and Legal Consultations"
  },
  {
    "id": "8538b9f2-4b76-4cd4-9ce8-8a2b38ba153a",
    "slug": "ahmed-hassan-al-mazmi-lawyers-and-legal-consultants",
    "name": "Ahmed Hassan Al-Mazmi Lawyers and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Ahmed Hassan Al-Mazmi Lawyers and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_8538b9f2-4b76-4cd4-9ce8-8a2b38ba153a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "121",
    "owner": "Ahmed Hassan Muhammad Abdullah"
  },
  {
    "id": "1fd509cb-3ae7-4c6a-aa6a-0d57f93acd2e",
    "slug": "ahmed-khamis-al-sam-al-zeyoudi",
    "name": "Ahmed Khamis Al-Sam Al-Zeyoudi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ahmed Khamis Al-Sam Al-Zeyoudi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_1fd509cb-3ae7-4c6a-aa6a-0d57f93acd2e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3929",
    "company": "Ahmed Khamis Al-Zeyoudi Advocates and Legal Consultants"
  },
  {
    "id": "1db8397f-3a00-4039-8428-1bcc0000c5b1",
    "slug": "ahmed-ziyad-abdullah-ibrahim-galadari",
    "name": "Ahmed Ziyad Abdullah Ibrahim Galadari",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBWgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ahmed Ziyad Abdullah Ibrahim Galadari",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1db8397f-3a00-4039-8428-1bcc0000c5b1",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4172",
    "company": "Galadari Lawyers and Legal Consultants Sole Proprietorship LLC - Dubai"
  },
  {
    "id": "f4ad4585-0b3a-423c-8bd9-b077b847269e",
    "slug": "psa-ahmed-bin-hazim-partners-advocates-and-legal-consultants",
    "name": "PSA Ahmed Bin Hazim & Partners Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFBBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: PSA Ahmed Bin Hazim & Partners Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_f4ad4585-0b3a-423c-8bd9-b077b847269e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2334, 3043, 4125",
    "owner": "Ahmed Saeed Salem bin Hazim Al Suwaidi"
  },
  {
    "id": "98485a03-227a-4537-a73b-5f0eb572b821",
    "slug": "ahmed-sultan-ahmed-sultan-al-hantoubi",
    "name": "Ahmed Sultan Ahmed Sultan Al-Hantoubi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ahmed Sultan Ahmed Sultan Al-Hantoubi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_98485a03-227a-4537-a73b-5f0eb572b821",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2339",
    "company": "Al Hantoubi Law Firm and Legal Consultations"
  },
  {
    "id": "ea0415b3-46db-411b-8149-dada07d87aaf",
    "slug": "ahmed-saleh-al-awdali",
    "name": "Ahmed Saleh Al-Awdali",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ahmed Saleh Al-Awdali",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_ea0415b3-46db-411b-8149-dada07d87aaf",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "1429",
    "company": "Ahmed Saleh Al-Awdali Lawyers and Legal Consultants LLC - S.P.C"
  },
  {
    "id": "7f3bd931-5218-4909-b2d1-807c71933b5b",
    "slug": "ahmed-abdul-aziz-jassim-abdullah-keshwani",
    "name": "Ahmed Abdul Aziz Jassim Abdullah Keshwani",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ahmed Abdul Aziz Jassim Abdullah Keshwani",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_7f3bd931-5218-4909-b2d1-807c71933b5b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "127",
    "company": "Kashwani Advocates and Legal Consultants"
  },
  {
    "id": "6660f870-2689-497f-92d8-de99a5ec5fbd",
    "slug": "ahmed-abdul-rahman-abdullah-ali-al-hammadi",
    "name": "Ahmed Abdul Rahman Abdullah Ali Al Hammadi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ahmed Abdul Rahman Abdullah Ali Al Hammadi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_6660f870-2689-497f-92d8-de99a5ec5fbd",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4026",
    "company": "Al Obaidly and Al Zarouni Advocates and Legal Consultants"
  },
  {
    "id": "f2990151-4d38-4b6e-a9e9-cea3f942e136",
    "slug": "ahmed-abdul-karim-ahmed-abdullah-eid",
    "name": "Ahmed Abdul Karim Ahmed Abdullah Eid",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ahmed Abdul Karim Ahmed Abdullah Eid",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_f2990151-4d38-4b6e-a9e9-cea3f942e136",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2308",
    "company": "Bin Eid Law Firm and Legal Consultations"
  },
  {
    "id": "dec625ed-0b3f-44e2-9b59-15c06259dc76",
    "slug": "ahmed-abdullah-rashid-al-dhaheri",
    "name": "Ahmed Abdullah Rashid Al Dhaheri",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ahmed Abdullah Rashid Al Dhaheri",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_dec625ed-0b3f-44e2-9b59-15c06259dc76",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3861",
    "company": "Ahmed Abdullah Al Dhaheri Law Firm and Legal Consultations"
  },
  {
    "id": "daf96b13-f168-4aa6-9f7c-55e48fbf2193",
    "slug": "abdullah-al-zarouni-law-firm-and-legal-consultations",
    "name": "Abdullah Al Zarouni Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Abdullah Al Zarouni Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_daf96b13-f168-4aa6-9f7c-55e48fbf2193",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3491",
    "owner": "Ahmed Abdullah Saleh Hassan Al-Jaziri"
  },
  {
    "id": "b9099265-574d-400e-a0c7-f0afca0332e6",
    "slug": "ahmed-abdullah-muhammad-hussein-ahli",
    "name": "Ahmed Abdullah Muhammad Hussein Ahli",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ahmed Abdullah Muhammad Hussein Ahli",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_b9099265-574d-400e-a0c7-f0afca0332e6",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4310",
    "company": "Ahmed Abdullah Ahli Law Firm and Legal Consultations"
  },
  {
    "id": "1d05e486-1e35-4ce2-af86-e35733f210eb",
    "slug": "ahmed-ali-saeed-al-hussaini",
    "name": "Ahmed Ali Saeed Al-Hussaini",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ahmed Ali Saeed Al-Hussaini",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_1d05e486-1e35-4ce2-af86-e35733f210eb",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2593",
    "company": "Ahmed Al-Hussaini Law Firm and Legal Consultations"
  },
  {
    "id": "e4788748-30b6-4e94-8759-356eb0f923f3",
    "slug": "ahmed-ali-saleh-al-mazmi",
    "name": "Ahmed Ali Saleh Al-Mazmi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ahmed Ali Saleh Al-Mazmi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e4788748-30b6-4e94-8759-356eb0f923f3",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "1577",
    "company": "Ahmed Al-Mazmi Advocates and Legal Consultants"
  },
  {
    "id": "46c950a2-b16b-4ed6-a429-e2cc97c3dcf6",
    "slug": "hadef-and-partners-advocates-and-legal-consultants",
    "name": "Hadef and Partners Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhQCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Hadef and Partners Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_46c950a2-b16b-4ed6-a429-e2cc97c3dcf6",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "22, 781, 2600, 2998, 3018, 3918, 4156, 4521, 4527",
    "owner": "Ahmed Mohammed Haji Al Hammadi"
  },
  {
    "id": "264a532d-6f71-4b7a-9bf4-0423890a1412",
    "slug": "ahmed-mohammed-abdul-rahman-al-shehhi",
    "name": "Ahmed Mohammed Abdul Rahman Al Shehhi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ahmed Mohammed Abdul Rahman Al Shehhi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_264a532d-6f71-4b7a-9bf4-0423890a1412",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3620",
    "company": "Majid Al-Sheikh Advocates and Legal Consultants"
  },
  {
    "id": "0bf09a8d-5471-4eb7-9c92-65c69c6b02fd",
    "slug": "ahmed-muhammad-ali-al-kamali",
    "name": "Ahmed Muhammad Ali Al Kamali",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ahmed Muhammad Ali Al Kamali",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_0bf09a8d-5471-4eb7-9c92-65c69c6b02fd",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "361",
    "company": "Al Kamali & Partners are lawyers and legal consultants"
  },
  {
    "id": "304e7290-b17a-4a75-89d6-19721c06371c",
    "slug": "al-tamimi-partners-advocates-and-legal-consultants-llc",
    "name": "Al Tamimi & Partners Advocates and Legal Consultants LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFUCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Al Tamimi & Partners Advocates and Legal Consultants LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_304e7290-b17a-4a75-89d6-19721c06371c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "468, 3095, 3156, 3704, 4219, 4232, 4580, 4593",
    "owner": "Ahmed Mohamed Mohamed Hussein Khairy"
  },
  {
    "id": "6fb3e04d-1327-400b-8dbb-191a1f5ef578",
    "slug": "ahmed-mohammed-matar-al-muhairi",
    "name": "Ahmed Mohammed Matar Al Muhairi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ahmed Mohammed Matar Al Muhairi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_6fb3e04d-1327-400b-8dbb-191a1f5ef578",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3384",
    "company": "Ahmed Matar Al Muhairi Advocates and Legal Consultants"
  },
  {
    "id": "4c5c61c0-f9c2-4cf3-a351-5efe5676a1a8",
    "slug": "dr-al-sabhan-and-associates-legal-group",
    "name": "Dr. Al-Sabhan and Associates Legal Group",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Dr. Al-Sabhan and Associates Legal Group",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_4c5c61c0-f9c2-4cf3-a351-5efe5676a1a8",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2524, 3164, 4265, 4424",
    "owner": "Asmaa Amer Omar Keda Al Kathiri"
  },
  {
    "id": "8993c76d-cd12-4570-b3d5-b51723130a2b",
    "slug": "asmaa-ali-mohsen-al-musabi",
    "name": "Asmaa Ali Mohsen Al-Musabi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Asmaa Ali Mohsen Al-Musabi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_8993c76d-cd12-4570-b3d5-b51723130a2b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2550",
    "company": "Asmaa Ali Al-Musabi Advocates and Legal Consultants"
  },
  {
    "id": "ae05fbb5-b1b1-4ada-abe6-197be8578db8",
    "slug": "noura-al-hajri-advocates-partners-and-legal-consultations-dubai",
    "name": "Noura Al Hajri Advocates & Partners and Legal Consultations - Dubai -",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE5BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Noura Al Hajri Advocates & Partners and Legal Consultations - Dubai -",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ae05fbb5-b1b1-4ada-abe6-197be8578db8",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2342, 3166",
    "owner": "Asmaa Muhammad Issa Muhammad Al-Raisi"
  },
  {
    "id": "96d46c80-f821-4eae-abfb-56e436c309c6",
    "slug": "amani-darwish-ahmed-al-zarouni",
    "name": "Amani Darwish Ahmed Al Zarouni",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Amani Darwish Ahmed Al Zarouni",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_96d46c80-f821-4eae-abfb-56e436c309c6",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2878",
    "company": "Amani Darwish Law Firm and Legal Consultations"
  },
  {
    "id": "fcb471d3-0b5b-4d0b-894e-c27adb02880e",
    "slug": "amani-abdullah-ali-abdullah-al-kindi",
    "name": "Amani Abdullah Ali Abdullah Al Kindi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Amani Abdullah Ali Abdullah Al Kindi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_fcb471d3-0b5b-4d0b-894e-c27adb02880e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3223",
    "company": "Amani Al Kindi Advocates and Legal Consultations LLC"
  },
  {
    "id": "d93410d6-6181-4320-a541-a2755d68354f",
    "slug": "al-suwaidi-partners-advocates-and-legal-consultants-dubai",
    "name": "Al Suwaidi & Partners Advocates and Legal Consultants - Dubai",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Al Suwaidi & Partners Advocates and Legal Consultants - Dubai",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d93410d6-6181-4320-a541-a2755d68354f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "947, 2521, 4122",
    "owner": "Amal Ahmed Abdullah Al-Amiri"
  },
  {
    "id": "f3953767-4bcb-4b5c-81a2-b02e4ccf6988",
    "slug": "noura-ahmed-law-firm-and-legal-consultations",
    "name": "Noura Ahmed Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE5BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Noura Ahmed Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_f3953767-4bcb-4b5c-81a2-b02e4ccf6988",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3396, 4474",
    "owner": "Amal Ahmed Issa Taher"
  },
  {
    "id": "22684bc0-960b-465e-afd7-f0ea8479f45b",
    "slug": "amal-hassan-muhammad-haji-karam",
    "name": "Amal Hassan Muhammad Haji Karam",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Amal Hassan Muhammad Haji Karam",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_22684bc0-960b-465e-afd7-f0ea8479f45b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3039",
    "company": "Amal Hassan Karam Advocates and Legal Consultants"
  },
  {
    "id": "8b98a835-5d51-43cc-a0a0-5e5ba8c5f014",
    "slug": "mohammed-abdullah-al-buraiki-law-firm-and-legal-consultations",
    "name": "Mohammed Abdullah Al Buraiki Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Mohammed Abdullah Al Buraiki Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_8b98a835-5d51-43cc-a0a0-5e5ba8c5f014",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "1463, 1473, 4703",
    "owner": "Amal Hassan Yaslam Al-Buraiki"
  },
  {
    "id": "92bd986a-f783-49c2-a12c-4aea4cde582c",
    "slug": "amna-ahmed-mahmoud-hassan-al-hammadi",
    "name": "Amna Ahmed Mahmoud Hassan Al Hammadi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Amna Ahmed Mahmoud Hassan Al Hammadi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_92bd986a-f783-49c2-a12c-4aea4cde582c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4567",
    "company": "Khaled Kalender Al-Mazmi Advocates and Legal Consultants"
  },
  {
    "id": "164ad8b4-f11f-43f2-8b1e-64b797ec6615",
    "slug": "amna-ali-qasim-shaheen",
    "name": "Amna Ali Qasim Shaheen",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Amna Ali Qasim Shaheen",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_164ad8b4-f11f-43f2-8b1e-64b797ec6615",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3622",
    "company": "Dubai Advocates and Legal Consultants"
  },
  {
    "id": "ab2d8db6-5043-4a5d-8380-661c20d35f4c",
    "slug": "amna-muhammad-khamis-al-darmaki",
    "name": "Amna Muhammad Khamis Al Darmaki",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Amna Muhammad Khamis Al Darmaki",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_ab2d8db6-5043-4a5d-8380-661c20d35f4c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3230",
    "company": "Shouq Al Kathiri Advocates and Legal Consultants"
  },
  {
    "id": "ded5cd9e-c7ca-4fc7-a3bf-f49e373a36a3",
    "slug": "habib-al-mulla-partners-advocates-and-legal-consultants-abu-dhabi",
    "name": "Habib Al Mulla & Partners Advocates and Legal Consultants - Abu Dhabi",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Habib Al Mulla & Partners Advocates and Legal Consultants - Abu Dhabi",
    "consultationFee": 500,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_ded5cd9e-c7ca-4fc7-a3bf-f49e373a36a3",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "109, 604, 1852, 4142, 4339, 4532",
    "owner": "Amir Muhammad Yousef Al Khaja"
  },
  {
    "id": "c01d99a4-c8b0-478a-834c-3861596879f0",
    "slug": "amira-rashid-mohammed-salem-al-saridi",
    "name": "SAEED SAIF MAKTOUM KHAMIS",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/10/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Amira Rashid Mohammed Salem Al-Saridi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c01d99a4-c8b0-478a-834c-3861596879f0",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "L-2143",
    "company": "Amira Al-Saridi Law Firm and Legal Consultations"
  },
  {
    "id": "017acc93-f29b-4056-9b94-7bc6c97e4b4e",
    "slug": "amina-ali-jaafar-ali-bin-jaafar",
    "name": "Amina Ali Jaafar Ali bin Jaafar",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Amina Ali Jaafar Ali bin Jaafar",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_017acc93-f29b-4056-9b94-7bc6c97e4b4e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3071",
    "company": "Amina Ali Bin Jaafar Law Firm and Legal Consultations"
  },
  {
    "id": "1a8fec67-4c56-4641-b4ee-367cb3f5ca3a",
    "slug": "iman-hassan-ali-muhammad-al-ali",
    "name": "Iman Hassan Ali Muhammad Al Ali",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Iman Hassan Ali Muhammad Al Ali",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_1a8fec67-4c56-4641-b4ee-367cb3f5ca3a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3069",
    "company": "Eman Al Ali Law Firm and Legal Consultations"
  },
  {
    "id": "6c367781-e415-40b0-b520-455d56b6f98c",
    "slug": "iman-abdullah-saad-salem-al-khanbashi",
    "name": "Iman Abdullah Saad Salem Al-Khanbashi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Iman Abdullah Saad Salem Al-Khanbashi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_6c367781-e415-40b0-b520-455d56b6f98c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4558",
    "company": "Lubna Moussa Advocates and Legal Consultants"
  },
  {
    "id": "4375c3f7-0989-4285-bc27-92ed7e6a7deb",
    "slug": "ayman-abdel-rahim-ahmed-merdas",
    "name": "Ayman Abdel Rahim Ahmed Merdas",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ayman Abdel Rahim Ahmed Merdas",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4375c3f7-0989-4285-bc27-92ed7e6a7deb",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "429",
    "company": "Global Lawyers and Legal Consultants - Dubai"
  },
  {
    "id": "34a3a0b9-0302-458d-a84e-ed09d35c151d",
    "slug": "galadari-lawyers-and-legal-consultants-sole-proprietorship-llc-dubai",
    "name": "Galadari Lawyers and Legal Consultants Sole Proprietorship LLC - Dubai",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEdMCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Galadari Lawyers and Legal Consultants Sole Proprietorship LLC - Dubai",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_34a3a0b9-0302-458d-a84e-ed09d35c151d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3734, 4524, 4533, 4535",
    "owner": "Ibtisam Jaafar Ali Al-Raisi"
  },
  {
    "id": "56e61ac7-7cff-4e43-8a4c-944ad97c4310",
    "slug": "ibtisam-hussein-ahmed-jaraghi-moazabad",
    "name": "Ibtisam Hussein Ahmed Jaraghi Moazabad",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ibtisam Hussein Ahmed Jaraghi Moazabad",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_56e61ac7-7cff-4e43-8a4c-944ad97c4310",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4418",
    "company": "Ali Jassim Law Firm and Legal Consultations"
  },
  {
    "id": "4679f3c3-f675-47f8-9602-a015653cc3be",
    "slug": "ibtisam-abdullah-salem-addas-al-jabri",
    "name": "Ibtisam Abdullah Salem Addas Al Jabri",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ibtisam Abdullah Salem Addas Al Jabri",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_4679f3c3-f675-47f8-9602-a015653cc3be",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3153",
    "company": "Ibtisam Abdullah Al Jabri Law Firm and Legal Consultations"
  },
  {
    "id": "3c18a891-653a-405a-9fe3-baecfe774bea",
    "slug": "azza-ibrahim-hassan-al-mulla-law-firm-and-legal-consultations-office-llc",
    "name": "Azza Ibrahim Hassan Al Mulla Law Firm and Legal Consultations Office LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFJCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Azza Ibrahim Hassan Al Mulla Law Firm and Legal Consultations Office LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_3c18a891-653a-405a-9fe3-baecfe774bea",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4068, 4281, 4590",
    "owner": "Abrar Ahmed Abdullah Muhammad"
  },
  {
    "id": "d21f7955-3f9c-4e73-ab65-8563c4bdf652",
    "slug": "abrar-abdul-rahman-ali-muhammad-al-muaini",
    "name": "Abrar Abdul Rahman Ali Muhammad Al-Muaini",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abrar Abdul Rahman Ali Muhammad Al-Muaini",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_d21f7955-3f9c-4e73-ab65-8563c4bdf652",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4157",
    "company": "Khaled Majed Law Firm and Legal Consultations"
  },
  {
    "id": "561e8a44-1d58-4b9a-bc1b-9ad754e80ec0",
    "slug": "khalifa-al-sada-law-firm-and-legal-consultations",
    "name": "Khalifa Al Sada Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEtBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Khalifa Al Sada Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_561e8a44-1d58-4b9a-bc1b-9ad754e80ec0",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3956, 4021",
    "owner": "Abrar replaces Salem"
  },
  {
    "id": "23436a1e-2775-4109-acb0-f383fd4e74b9",
    "slug": "ibrahim-hassan-salem-ali-al-hammadi",
    "name": "Ibrahim Hassan Salem Ali Al Hammadi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ibrahim Hassan Salem Ali Al Hammadi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_23436a1e-2775-4109-acb0-f383fd4e74b9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3348",
    "company": "Ibrahim Al Hammadi Law Firm and Legal Consultations"
  },
  {
    "id": "ee8197d5-8394-4591-a346-a93ca3d6252c",
    "slug": "ibrahim-ali-ibrahim-ali-al-sarkal",
    "name": "Ibrahim Ali Ibrahim Ali Al Sarkal",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ibrahim Ali Ibrahim Ali Al Sarkal",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_ee8197d5-8394-4591-a346-a93ca3d6252c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2987",
    "company": "Ibrahim Al Sarkal Advocates and Legal Consultants"
  },
  {
    "id": "a0a7dbbb-2941-44d8-99b0-d7a50d63dcb6",
    "slug": "ibrahim-ali-obaid-saleh-al-ali",
    "name": "Ibrahim Ali Obaid Saleh Al Ali",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ibrahim Ali Obaid Saleh Al Ali",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_a0a7dbbb-2941-44d8-99b0-d7a50d63dcb6",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4317",
    "company": "Ibrahim Ali Al Ali Law Firm and Legal Consultations"
  },
  {
    "id": "217966e7-570b-4bc9-af1d-592adbede69b",
    "slug": "the-office-of-lawyer-mahmoud-al-hawai-lawyers-and-legal-consultants-llc",
    "name": "The office of Lawyer Mahmoud Al-Hawai Lawyers and Legal Consultants LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE9MCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: The office of Lawyer Mahmoud Al-Hawai Lawyers and Legal Consultants LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_217966e7-570b-4bc9-af1d-592adbede69b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4547",
    "owner": "Ibrahim Mahmoud Ibrahim Al-Hawai Al-Zarouni"
  },
  {
    "id": "0c42c0d7-8090-435f-9201-2e9dfa35fcbc",
    "slug": "abu-bakr-salem-advocates-and-legal-consultants-llc",
    "name": "Abu Bakr Salem Advocates and Legal Consultants LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFCCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Abu Bakr Salem Advocates and Legal Consultants LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_0c42c0d7-8090-435f-9201-2e9dfa35fcbc",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "116, 2269, 2644, 2809, 4283, 4289",
    "owner": "Abu Bakr Salem Awad Al-Menhali"
  },
  {
    "id": "f8ef965e-5c67-49d4-a405-e4494c8eba86",
    "slug": "sheikha-ghaleb-al-mansouri-advocates-and-legal-consultants",
    "name": "Sheikha Ghaleb Al Mansouri Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNHCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Sheikha Ghaleb Al Mansouri Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_f8ef965e-5c67-49d4-a405-e4494c8eba86",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4613",
    "owner": "Ahlam Nasser Masoud Nasser Al-Ismaili"
  },
  {
    "id": "130a41bc-078f-4e19-bb4a-c5d33c32f2d3",
    "slug": "ahmed-ibrahim-law-firm-and-legal-consultations",
    "name": "Ahmed Ibrahim Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFJCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Ahmed Ibrahim Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_130a41bc-078f-4e19-bb4a-c5d33c32f2d3",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "363",
    "owner": "Ahmed Ibrahim Ahmed Muhammad"
  },
  {
    "id": "8c3a080b-d10f-461a-9830-c8a05b942930",
    "slug": "ahmed-thani-juma-al-hameli",
    "name": "Ahmed Thani Juma Al Hameli",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ahmed Thani Juma Al Hameli",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_8c3a080b-d10f-461a-9830-c8a05b942930",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3993",
    "company": "Ahmed Al Hameli Law Office and Legal Consultations"
  },
  {
    "id": "e6f42ff0-ea4f-49dd-8161-558c3081689f",
    "slug": "ahmed-hadid-thuwaini-walid-al-junaibi",
    "name": "Ahmed Hadid Thuwaini Walid Al-Junaibi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ahmed Hadid Thuwaini Walid Al-Junaibi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e6f42ff0-ea4f-49dd-8161-558c3081689f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3664",
    "company": "Ahmed Hadid Al-Junaibi Law Firm"
  },
  {
    "id": "e7fb1617-9c0d-4980-b933-195d2c724a0e",
    "slug": "ahmed-hussein-al-marzouqi-law-firm-and-legal-consultations",
    "name": "Ahmed Hussein Al Marzouqi Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Ahmed Hussein Al Marzouqi Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e7fb1617-9c0d-4980-b933-195d2c724a0e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4549",
    "owner": "Ahmed Hussein Ali Nazri Al Marzouki"
  },
  {
    "id": "1f9c527c-5b36-479f-a4dd-df032ca1603d",
    "slug": "ahmed-hamid-abbas-karamak-al-balushi",
    "name": "Ahmed Hamid Abbas Karamak Al Balushi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ahmed Hamid Abbas Karamak Al Balushi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_1f9c527c-5b36-479f-a4dd-df032ca1603d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4368",
    "company": "Ahmed Hamid Al Balushi Advocates and Legal Consultants"
  },
  {
    "id": "1c1d9f31-fd2f-4f9a-9691-493df5c11e2d",
    "slug": "jaber-rashid-al-salami-advocates-and-legal-consultants",
    "name": "Jaber Rashid Al Salami Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEpSCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Jaber Rashid Al Salami Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_1c1d9f31-fd2f-4f9a-9691-493df5c11e2d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2953, 4311",
    "owner": "Ahmed Rashid Muhammad Jaber Al-Salami"
  },
  {
    "id": "bc9c00cd-d7a7-4d1c-816e-e0866cc69a7d",
    "slug": "ibrahim-ali-karam-khoury-advocates-and-legal-consultants",
    "name": "Ibrahim Ali Karam Khoury Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIElBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Ibrahim Ali Karam Khoury Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_bc9c00cd-d7a7-4d1c-816e-e0866cc69a7d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4529",
    "owner": "Ahmed Salem Al-Abd Awad Al-Kaabi"
  },
  {
    "id": "500e2257-3005-4e5d-8a5f-8fb5ce7a997e",
    "slug": "ahmed-salem-saif-mohammed-al-nuaimi",
    "name": "Ahmed Salem Saif Mohammed Al Nuaimi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ahmed Salem Saif Mohammed Al Nuaimi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_500e2257-3005-4e5d-8a5f-8fb5ce7a997e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4426",
    "company": "Office of Ahmed Salem Al Nuaimi Law Firm and Legal Consultations"
  },
  {
    "id": "37da306f-e4e1-45d5-b357-00eb43bdf5eb",
    "slug": "ahmed-murshid-al-kaabi-partners-advocates-and-legal-consultants-llc",
    "name": "Ahmed Murshid Al Kaabi & Partners Advocates and Legal Consultants LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Ahmed Murshid Al Kaabi & Partners Advocates and Legal Consultants LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_37da306f-e4e1-45d5-b357-00eb43bdf5eb",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2706, 4102, 4300, 4318",
    "owner": "Ahmed Salem Muhammad Murshid Al-Kaabi"
  },
  {
    "id": "4f8c8ff7-ea74-40ab-ab93-79b577b0330b",
    "slug": "ahmed-saeed-al-suwaidi-law-firm-and-legal-consultations",
    "name": "Ahmed Saeed Al Suwaidi Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Ahmed Saeed Al Suwaidi Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_4f8c8ff7-ea74-40ab-ab93-79b577b0330b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4564",
    "owner": "Ahmed Saeed Juma Mubarak Al-Suwaidi"
  },
  {
    "id": "31455ab6-0ae3-4c2b-80b0-e2f99bbe7cc0",
    "slug": "ahmed-saeed-salim-rashid-al-mazrouei",
    "name": "Ahmed Saeed Salim Rashid Al Mazrouei",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ahmed Saeed Salim Rashid Al Mazrouei",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_31455ab6-0ae3-4c2b-80b0-e2f99bbe7cc0",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4203",
    "company": "Saeed Saleem Advocates and Legal Consultants"
  },
  {
    "id": "b043840f-579d-46f0-aedd-5ebe3d5f9ceb",
    "slug": "al-zahmi-advocates-and-legal-consultants-fujairah",
    "name": "Al Zahmi Advocates and Legal Consultants - Fujairah",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFaCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Al Zahmi Advocates and Legal Consultants - Fujairah",
    "consultationFee": 500,
    "emirate": "Fujairah",
    "verified": true,
    "offices": [
      {
        "id": "office_b043840f-579d-46f0-aedd-5ebe3d5f9ceb",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Fujairah",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3157, 3916, 4515",
    "owner": "Ahmed Saeed Mubarak Obaid Al-Zahmi"
  },
  {
    "id": "e7379143-7b01-417d-b1ae-bbfd77efbf66",
    "slug": "dr-ahmed-al-ramsi-advocates-and-legal-consultants-abu-dhabi",
    "name": "Dr. Ahmed Al Ramsi Advocates and Legal Consultants - Abu Dhabi",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Dr. Ahmed Al Ramsi Advocates and Legal Consultants - Abu Dhabi",
    "consultationFee": 500,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_e7379143-7b01-417d-b1ae-bbfd77efbf66",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "513, 4198",
    "owner": "Ahmed Saleh Abdullah Khamis Al-Ramsi"
  },
  {
    "id": "f5fc35e7-1cd7-4360-bfb2-ee4351091e24",
    "slug": "ahmed-abdul-rahman-al-zarouni-law-firm-and-legal-consultations",
    "name": "Ahmed Abdul Rahman Al Zarouni Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Ahmed Abdul Rahman Al Zarouni Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_f5fc35e7-1cd7-4360-bfb2-ee4351091e24",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4597",
    "owner": "Ahmed Abdel-Rahman Mohamed Abdel-Rahman Al-Zarouni"
  },
  {
    "id": "8d04b14e-cbb5-46e1-a79d-61491e8b4742",
    "slug": "ahmed-abdel-latif-ahmed-younis-al-hammadi",
    "name": "Ahmed Abdel Latif Ahmed Younis Al Hammadi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ahmed Abdel Latif Ahmed Younis Al Hammadi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_8d04b14e-cbb5-46e1-a79d-61491e8b4742",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4568",
    "company": "Ahmed Abdul Latif Al Hammadi Advocates and Legal Consultations - LLC - S.P.C"
  },
  {
    "id": "994f9e24-f909-48c4-9ada-0f45772264e4",
    "slug": "ahmed-abdul-latif-dhaen-abdullah-al-dhaen",
    "name": "Ahmed Abdul Latif Dhaen Abdullah Al Dhaen",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ahmed Abdul Latif Dhaen Abdullah Al Dhaen",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_994f9e24-f909-48c4-9ada-0f45772264e4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4165",
    "company": "Ahmed Dhaen Al-Dhaen Law Firm and Legal Consultations"
  },
  {
    "id": "efd8477a-5fb2-4f70-92de-809a19605b6b",
    "slug": "ahmed-abdullah-ibrahim-galadari",
    "name": "Ahmed Abdullah Ibrahim Galadari",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ahmed Abdullah Ibrahim Galadari",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_efd8477a-5fb2-4f70-92de-809a19605b6b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "279",
    "company": "Galadari Lawyers and Legal Consultants Sole Proprietorship LLC - Dubai"
  },
  {
    "id": "ab17acd4-1aec-49e2-ac84-3f004fbc3d30",
    "slug": "ahmed-abdullah-al-naqbi-law-firm-and-legal-consultations",
    "name": "Ahmed Abdullah Al Naqbi Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Ahmed Abdullah Al Naqbi Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_ab17acd4-1aec-49e2-ac84-3f004fbc3d30",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4039",
    "owner": "Ahmed Abdullah Muhammad bin Askar Al-Naqbi"
  },
  {
    "id": "cedd371c-44fb-4129-9a0f-1fcbce99e731",
    "slug": "ahmed-abdullah-muhammad-malak-anwahi",
    "name": "Ahmed Abdullah Muhammad Malak Anwahi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ahmed Abdullah Muhammad Malak Anwahi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_cedd371c-44fb-4129-9a0f-1fcbce99e731",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2358",
    "company": "Ahmed Anwahi Advocates and Legal Consultants"
  },
  {
    "id": "8fd9f92e-674e-4aa0-a809-e20edd05589d",
    "slug": "fatima-hassan-al-shehhi-advocates-and-legal-consultations-llc",
    "name": "Fatima Hassan Al Shehhi Advocates and Legal Consultations LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEZICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Fatima Hassan Al Shehhi Advocates and Legal Consultations LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_8fd9f92e-674e-4aa0-a809-e20edd05589d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4149, 4313",
    "owner": "Ahmed Abdullah Musa Murad"
  },
  {
    "id": "7f143c5d-4480-4145-87d5-b95bb7b6d9b3",
    "slug": "al-masa-advocates-and-legal-consultants-sharjah",
    "name": "Al Masa Advocates and Legal Consultants - Sharjah",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Al Masa Advocates and Legal Consultants - Sharjah",
    "consultationFee": 500,
    "emirate": "Sharjah",
    "verified": true,
    "offices": [
      {
        "id": "office_7f143c5d-4480-4145-87d5-b95bb7b6d9b3",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Sharjah",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4560",
    "owner": "Ahmed Abdel Wahab Ahmed Al-Fili"
  },
  {
    "id": "840938a2-47f9-452d-ae6d-933f43ab3462",
    "slug": "al-saeedi-advocates-and-legal-consultants-sharjah",
    "name": "Al Saeedi Advocates and Legal Consultants - Sharjah",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Al Saeedi Advocates and Legal Consultants - Sharjah",
    "consultationFee": 500,
    "emirate": "Sharjah",
    "verified": true,
    "offices": [
      {
        "id": "office_840938a2-47f9-452d-ae6d-933f43ab3462",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Sharjah",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "91, 2887",
    "owner": "Ahmed Obaid Khamis Ali Al-Bedawy"
  },
  {
    "id": "2e436f19-f207-4192-a91c-43b196d9b544",
    "slug": "ahmed-ali-hussein-al-shaali",
    "name": "Ahmed Ali Hussein Al-Shaali",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ahmed Ali Hussein Al-Shaali",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_2e436f19-f207-4192-a91c-43b196d9b544",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4099",
    "company": "Ahmed Al-Shaali Law Firm"
  },
  {
    "id": "b8f1670f-0082-40b8-b349-385b86ddbf9c",
    "slug": "al-ghareeb-partners-are-lawyers-and-legal-consultants-abu-dhabi",
    "name": "Al Ghareeb Partners are lawyers and legal consultants Abu Dhabi",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFHCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Al Ghareeb Partners are lawyers and legal consultants Abu Dhabi",
    "consultationFee": 500,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_b8f1670f-0082-40b8-b349-385b86ddbf9c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4571, 4605, 4623",
    "owner": "Ahmed Ali Khalil Al-Hawai"
  },
  {
    "id": "978b8c30-db5f-434d-969d-c3b2b3315027",
    "slug": "ahmed-mohamed-abdel-rahman-bermo-al-marzouqi",
    "name": "Ahmed Mohamed Abdel Rahman Bermo Al Marzouqi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ahmed Mohamed Abdel Rahman Bermo Al Marzouqi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_978b8c30-db5f-434d-969d-c3b2b3315027",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3785",
    "company": "Abdul Rahman Al Mazmi Advocates and Legal Consultants"
  },
  {
    "id": "954af989-c643-4fa7-bbdb-b9526ae34c1a",
    "slug": "ahmed-muhammad-abdullah-barakat-abdul-samad",
    "name": "Ahmed Muhammad Abdullah Barakat Abdul Samad",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ahmed Muhammad Abdullah Barakat Abdul Samad",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_954af989-c643-4fa7-bbdb-b9526ae34c1a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4150",
    "company": "Ahmed Mohamed Abdel Samad Law Firm and Legal Consultations"
  },
  {
    "id": "17e0b90d-89fc-4099-a3a1-79cb69c025f0",
    "slug": "alia-saeed-al-abri-advocates-and-legal-consultants",
    "name": "Alia Saeed Al Abri Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Alia Saeed Al Abri Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_17e0b90d-89fc-4099-a3a1-79cb69c025f0",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4302",
    "owner": "Ahmed Mohamed Mahmoud Mahmoud"
  },
  {
    "id": "7854675f-b683-45f7-b794-9b935da614a6",
    "slug": "ahmed-murad-ahmed-ahmadi-al-balushi",
    "name": "Ahmed Murad Ahmed Ahmadi Al Balushi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ahmed Murad Ahmed Ahmadi Al Balushi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_7854675f-b683-45f7-b794-9b935da614a6",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4284",
    "company": "Dr. Ahmed Al-Maamari Law Firm and Legal Consultations"
  },
  {
    "id": "01528ae3-6500-4836-adb8-649a578b3c32",
    "slug": "ahmed-murad-abdullah-ali-al-balushi",
    "name": "Ahmed Murad Abdullah Ali Al Balushi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ahmed Murad Abdullah Ali Al Balushi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_01528ae3-6500-4836-adb8-649a578b3c32",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4051",
    "company": "Ahmed Murad Al Balushi Law Firm and Legal Consultations Office"
  },
  {
    "id": "8e2fbba4-2c26-4b0e-a090-5a2ad00c45ed",
    "slug": "ahmed-nagy-jaber-aisoub-al-ahbabi",
    "name": "Ahmed Nagy Jaber Aisoub Al-Ahbabi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ahmed Nagy Jaber Aisoub Al-Ahbabi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_8e2fbba4-2c26-4b0e-a090-5a2ad00c45ed",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3139",
    "company": "Ahmed Naji Law Office and Legal Consultations"
  },
  {
    "id": "9def6b7d-80d0-45a5-b731-615a55c70de4",
    "slug": "osama-muhammad-ahmed-salem-al-salmi",
    "name": "Osama Muhammad Ahmed Salem Al-Salmi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Osama Muhammad Ahmed Salem Al-Salmi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_9def6b7d-80d0-45a5-b731-615a55c70de4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3078",
    "company": "Osama Al-Salmi Advocates and Legal Consultants"
  },
  {
    "id": "1bfa1d74-6d19-47e9-9e2b-4bc16bcd374c",
    "slug": "hamid-al-ghafli-law-firm-and-legal-consultations",
    "name": "Hamid Al-Ghafli Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Hamid Al-Ghafli Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_1bfa1d74-6d19-47e9-9e2b-4bc16bcd374c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2532",
    "owner": "Khamis Al Mansouri bracelets"
  },
  {
    "id": "a8e15d2c-82b4-459f-8a04-a38417bc9852",
    "slug": "asmaa-abdul-rahman-sharaf-muhammad-al-maamari",
    "name": "Asmaa Abdul Rahman Sharaf Muhammad Al Maamari",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Asmaa Abdul Rahman Sharaf Muhammad Al Maamari",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_a8e15d2c-82b4-459f-8a04-a38417bc9852",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4253",
    "company": "Kashwani Advocates and Legal Consultants"
  },
  {
    "id": "99d0e6f5-267a-4295-915f-be56fe647f1b",
    "slug": "asmaa-abdullah-yaqut-dhiyab-al-tamimi",
    "name": "Asmaa Abdullah Yaqut Dhiyab Al-Tamimi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Asmaa Abdullah Yaqut Dhiyab Al-Tamimi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_99d0e6f5-267a-4295-915f-be56fe647f1b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4141",
    "company": "Asmaa Al Tamimi Advocates and Legal Consultants"
  },
  {
    "id": "be0362a8-a4c3-459b-8d3b-7de041f4e602",
    "slug": "names-muhammad-sultan-abdullah-al-shamsi",
    "name": "Names: Muhammad Sultan Abdullah Al Shamsi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Names: Muhammad Sultan Abdullah Al Shamsi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_be0362a8-a4c3-459b-8d3b-7de041f4e602",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4206",
    "company": "Al-Bakr Law Firm and Legal Consultations"
  },
  {
    "id": "a86da136-c4cf-4f00-9543-20d3e76a5571",
    "slug": "ismail-ibrahim-saqr-al-hosani",
    "name": "Ismail Ibrahim Saqr Al Hosani",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ismail Ibrahim Saqr Al Hosani",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_a86da136-c4cf-4f00-9543-20d3e76a5571",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4210",
    "company": "Ismail Ibrahim Al Hosani Advocates and Legal Consultants"
  },
  {
    "id": "366cf38f-a2c8-466f-be91-7322aea38090",
    "slug": "ismail-hamid-ismail-al-harda-al-zaabi",
    "name": "Ismail Hamid Ismail Al-Harda Al-Zaabi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ismail Hamid Ismail Al-Harda Al-Zaabi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_366cf38f-a2c8-466f-be91-7322aea38090",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4350",
    "company": "Ismail Al-Harada Al-Zaabi Advocates and Legal Consultants LLC"
  },
  {
    "id": "768c0a29-5233-4b99-9ba2-d9566107e6d9",
    "slug": "mohammed-bani-hashem-advocates-and-legal-consultants-sharjah",
    "name": "Mohammed Bani Hashem Advocates and Legal Consultants - Sharjah",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1CCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Mohammed Bani Hashem Advocates and Legal Consultants - Sharjah",
    "consultationFee": 500,
    "emirate": "Sharjah",
    "verified": true,
    "offices": [
      {
        "id": "office_768c0a29-5233-4b99-9ba2-d9566107e6d9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Sharjah",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4500",
    "owner": "Supervised by Abdullah Hassan bin Malik"
  },
  {
    "id": "f377de04-b96e-4b45-8c52-40e1b85ed6d1",
    "slug": "alaa-ibrahim-muhammad-abdullah-al-jasmi",
    "name": "Alaa Ibrahim Muhammad Abdullah Al Jasmi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Alaa Ibrahim Muhammad Abdullah Al Jasmi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_f377de04-b96e-4b45-8c52-40e1b85ed6d1",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4065",
    "company": "Alaa Ibrahim Al Jasmi Advocates and Legal Consultations"
  },
  {
    "id": "2419339b-c20f-4fe7-9d29-77300884f891",
    "slug": "ali-habib-law-firm-and-legal-consultations-one-person-company",
    "name": "Ali Habib Law Firm and Legal Consultations - One Person Company",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Ali Habib Law Firm and Legal Consultations - One Person Company",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_2419339b-c20f-4fe7-9d29-77300884f891",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3524, 4410, 4459, 4562",
    "owner": "Alaa Salem Ali Jazem Omar"
  },
  {
    "id": "9372f94b-b898-422a-a67f-1d53d2aeb0fa",
    "slug": "dr-ahmed-abdullah-al-suwaidi",
    "name": "Dr. Ahmed Abdullah Al Suwaidi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Dr. Ahmed Abdullah Al Suwaidi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_9372f94b-b898-422a-a67f-1d53d2aeb0fa",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "62",
    "company": "Ahmed Abdullah Al Suwaidi Advocates and Legal Consultants"
  },
  {
    "id": "dc6ff19a-9b0e-4e8c-bd7a-8353e8c01bff",
    "slug": "dr-ahmed-ali-hamoud-al-maamari",
    "name": "Dr. Ahmed Ali Hamoud Al-Maamari",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Dr. Ahmed Ali Hamoud Al-Maamari",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_dc6ff19a-9b0e-4e8c-bd7a-8353e8c01bff",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2823",
    "company": "Dr. Ahmed Al-Maamari Law Firm and Legal Consultations"
  },
  {
    "id": "8309eaed-c286-4fc2-aeb5-90cca340592a",
    "slug": "dr-ahmed-mohammed-rashid-bin-al-shaiba-al-muhairi",
    "name": "Dr. Ahmed Mohammed Rashid bin Al Shaiba Al Muhairi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Dr. Ahmed Mohammed Rashid bin Al Shaiba Al Muhairi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_8309eaed-c286-4fc2-aeb5-90cca340592a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4323",
    "company": "Dr. Ahmed bin Al Shaiba Al Muhairi Advocates and Legal Consultants"
  },
  {
    "id": "46746eb5-f01f-4111-a143-0723dce7c209",
    "slug": "dr-badr-saleh-faraj-al-kathiri",
    "name": "Dr. Badr Saleh Faraj Al Kathiri",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Dr. Badr Saleh Faraj Al Kathiri",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_46746eb5-f01f-4111-a143-0723dce7c209",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4322",
    "company": "Dr. Badr Saleh Al Kathiri Law Office and Legal Consultations"
  },
  {
    "id": "c74fe517-9761-4790-a78d-cb47a61498b0",
    "slug": "post-advocates-and-legal-consultations-llc",
    "name": "Post Advocates and Legal Consultations LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFBBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Post Advocates and Legal Consultations LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c74fe517-9761-4790-a78d-cb47a61498b0",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "235, 4401",
    "owner": "Dr. Hassan Ali Al Marzouqi"
  },
  {
    "id": "6526892e-6b31-4a7f-9e6e-fe9dd4430c2f",
    "slug": "dr-sarhan-hassan-muhammad-hassan-al-muaini",
    "name": "Dr. Sarhan Hassan Muhammad Hassan Al-Muaini",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Dr. Sarhan Hassan Muhammad Hassan Al-Muaini",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_6526892e-6b31-4a7f-9e6e-fe9dd4430c2f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3855",
    "company": "Dr. Sarhan Al-Muaini Advocates and Legal Consultants"
  },
  {
    "id": "0bb95a07-6bbb-4bf1-80ae-e480b82ccef3",
    "slug": "dr-mahmoud-hussein-advocates-and-legal-consultants-llc",
    "name": "Dr. Mahmoud Hussein Advocates and Legal Consultants LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1ICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Dr. Mahmoud Hussein Advocates and Legal Consultants LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_0bb95a07-6bbb-4bf1-80ae-e480b82ccef3",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3496, 4121, 4166, 4423",
    "owner": "Dr. Salman Mohammed Ahmed Mohammed Al-Taweel"
  },
  {
    "id": "1602106b-e049-49ec-92d4-9bf0992a14b2",
    "slug": "dr-abdul-rahman-abdullah-yaqut-dhiyab-al-tamimi",
    "name": "Dr. Abdul Rahman Abdullah Yaqut Dhiyab Al Tamimi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Dr. Abdul Rahman Abdullah Yaqut Dhiyab Al Tamimi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_1602106b-e049-49ec-92d4-9bf0992a14b2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3706",
    "company": "Abdul Rahman Abdullah Al Tamimi Law Firm and Legal Consultations"
  },
  {
    "id": "96496e77-ff30-4d65-85a0-9f0af9d4da30",
    "slug": "dr-adnan-muhammad-yousef-al-hammadi",
    "name": "Dr. Adnan Muhammad Yousef Al Hammadi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Dr. Adnan Muhammad Yousef Al Hammadi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_96496e77-ff30-4d65-85a0-9f0af9d4da30",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2502",
    "company": "Dr. Adnan Mohammed Al Hammadi's office"
  },
  {
    "id": "6a4893da-f00a-4e39-8ae9-5347a068dd14",
    "slug": "dr-muhammad-ahmed-ali-al-hafiti",
    "name": "Dr. Muhammad Ahmed Ali Al-Hafiti",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Dr. Muhammad Ahmed Ali Al-Hafiti",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_6a4893da-f00a-4e39-8ae9-5347a068dd14",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4710",
    "company": "Dr. Adnan Mohammed Al Hammadi's office"
  },
  {
    "id": "1a8b6dfe-8884-4351-be18-96c20f8a2f90",
    "slug": "dr-mohammed-saeed-mohammed-hilal-al-muhairi",
    "name": "Dr. Mohammed Saeed Mohammed Hilal Al Muhairi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Dr. Mohammed Saeed Mohammed Hilal Al Muhairi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_1a8b6dfe-8884-4351-be18-96c20f8a2f90",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4262",
    "company": "Ghanem Al Muhairi Advocates and Legal Consultants"
  },
  {
    "id": "483358e4-d52e-4a25-9010-ae13f812c893",
    "slug": "dr-muhammad-abdullah-ahmed-muhammad-al-mulla",
    "name": "Dr. Muhammad Abdullah Ahmed Muhammad Al-Mulla",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Dr. Muhammad Abdullah Ahmed Muhammad Al-Mulla",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_483358e4-d52e-4a25-9010-ae13f812c893",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4037",
    "company": "Majid Hamad Al Kalbani Advocates and Legal Consultants"
  },
  {
    "id": "e697b76b-06bd-4eb9-9803-6eb5e65ab316",
    "slug": "dr-youssef-al-marzouqi",
    "name": "Dr. Youssef Al Marzouqi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Dr. Youssef Al Marzouqi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e697b76b-06bd-4eb9-9803-6eb5e65ab316",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3049",
    "company": "Dr. Yousef Al Marzouqi Advocates and Legal Consultants"
  },
  {
    "id": "4db56b7a-200b-4e0e-8dc5-a4b2b50e36b1",
    "slug": "al-naqbi-partners-advocates-and-legal-consultants",
    "name": "Al-Naqbi & Partners Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFQCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Al-Naqbi & Partners Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_4db56b7a-200b-4e0e-8dc5-a4b2b50e36b1",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2179",
    "owner": "Dr. Hawraa Musa Abdul Rasoul Musa Ahmed"
  },
  {
    "id": "8fb3659b-cac2-4b90-88dd-c8e2a6288d3b",
    "slug": "dr-rawda-muhammad-salem-hayai-al-mansouri",
    "name": "Dr. Rawda Muhammad Salem Hayai Al Mansouri",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Dr. Rawda Muhammad Salem Hayai Al Mansouri",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_8fb3659b-cac2-4b90-88dd-c8e2a6288d3b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4259",
    "company": "Rawda Mohammed Al Mansouri Advocates and Legal Consultants"
  },
  {
    "id": "b0b5c562-61b0-43e4-82f6-a235738c625f",
    "slug": "sheikh-dr-abdullah-issa-abdulaziz-al-mualla",
    "name": "Sheikh Dr. Abdullah Issa Abdulaziz Al-Mualla",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Sheikh Dr. Abdullah Issa Abdulaziz Al-Mualla",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_b0b5c562-61b0-43e4-82f6-a235738c625f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4077",
    "company": "Abdullah Al-Mualla Law Firm and Legal Consultations Office"
  },
  {
    "id": "f2631ea0-08ee-4fe2-abeb-0fc4cd96c2b8",
    "slug": "sheikh-khalid-ahmed-salem-al-qasimi",
    "name": "Sheikh Khalid Ahmed Salem Al Qasimi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Sheikh Khalid Ahmed Salem Al Qasimi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_f2631ea0-08ee-4fe2-abeb-0fc4cd96c2b8",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3782",
    "company": "Sheikh Khalid bin Ahmed Al Qasimi Advocates and Legal Consultants"
  },
  {
    "id": "5170e870-215f-44b5-842d-72e0b013f22b",
    "slug": "sheikh-rashid-bin-nasser-bin-rashid-bin-humaid-al-nuaimi",
    "name": "Sheikh Rashid bin Nasser bin Rashid bin Humaid Al Nuaimi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Sheikh Rashid bin Nasser bin Rashid bin Humaid Al Nuaimi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_5170e870-215f-44b5-842d-72e0b013f22b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4357",
    "company": "Sheikh Rashid Bin Nasser Al Nuaimi Law Firm and Legal Consultations Office"
  },
  {
    "id": "07033255-dec3-47ab-ac4b-981bbb62262b",
    "slug": "sheikh-ali-jamal-bin-nasser-bin-rashid-al-nuaimi",
    "name": "Sheikh Ali Jamal bin Nasser bin Rashid Al Nuaimi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Sheikh Ali Jamal bin Nasser bin Rashid Al Nuaimi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_07033255-dec3-47ab-ac4b-981bbb62262b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4531",
    "company": "Sheikh Ali Jamal Al Nuaimi Advocates and Legal Consultations"
  },
  {
    "id": "36a7be37-c14c-4121-9a76-ab38611ebb13",
    "slug": "sheikha-aisha-ali-muhammad-ali-al-mualla",
    "name": "Sheikha Aisha Ali Muhammad Ali Al-Mualla",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Sheikha Aisha Ali Muhammad Ali Al-Mualla",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_36a7be37-c14c-4121-9a76-ab38611ebb13",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4602",
    "company": "Khaled Ateeq Al Marri Advocates and Legal Consultants"
  },
  {
    "id": "d2753273-22dc-4fe8-950e-923078dbbc46",
    "slug": "al-anoud-al-shaiba-ali-al-darmaki",
    "name": "Al-Anoud Al-Shaiba Ali Al-Darmaki",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Al-Anoud Al-Shaiba Ali Al-Darmaki",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_d2753273-22dc-4fe8-950e-923078dbbc46",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3169",
    "company": "Al-Anoud Salem Al-Darmaki Advocates and Legal Consultants"
  },
  {
    "id": "598e928b-ff68-439a-bab9-32259d227758",
    "slug": "house-of-wisdom-advocates-and-legal-consultationsabu-dhabi",
    "name": "House of Wisdom Advocates and Legal Consultations/Abu Dhabi",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhXCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: House of Wisdom Advocates and Legal Consultations/Abu Dhabi",
    "consultationFee": 500,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_598e928b-ff68-439a-bab9-32259d227758",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "24, 4582, 4674",
    "owner": "Al-Anoud Hassan Saeed Ali Al-Muharami"
  },
  {
    "id": "1598a661-7340-4bb0-95c7-102f78b21ee5",
    "slug": "al-wasl-international-group-lawyers-and-legal-consultants",
    "name": "Al Wasl International Group Lawyers and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFXCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Al Wasl International Group Lawyers and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_1598a661-7340-4bb0-95c7-102f78b21ee5",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4494, 4495",
    "owner": "Al-Anoud Ali Saeed Ham Abdullah"
  },
  {
    "id": "1896afc0-1c9b-4b50-b08f-b33182782768",
    "slug": "al-anoud-muhammad-saleh-alawi-al-buraiki",
    "name": "Al-Anoud Muhammad Saleh Alawi Al-Buraiki",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Al-Anoud Muhammad Saleh Alawi Al-Buraiki",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_1896afc0-1c9b-4b50-b08f-b33182782768",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3959",
    "company": "Al-Anoud Mohammed Saleh Al-Buraiki Law Firm and Legal Consultations Office"
  },
  {
    "id": "c435da4f-b8b1-4974-ad29-f87808706c09",
    "slug": "global-lawyers-and-legal-consultants-dubai",
    "name": "Global Lawyers and Legal Consultants - Dubai",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEdMCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Global Lawyers and Legal Consultants - Dubai",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_c435da4f-b8b1-4974-ad29-f87808706c09",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4134, 4234",
    "owner": "Al-Anoud Yacoub Al-Shamsi"
  },
  {
    "id": "664dc397-f258-4604-869e-0cef8927cabd",
    "slug": "salma-al-ketbi-law-firm-and-legal-consultations",
    "name": "Salma Al Ketbi Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Salma Al Ketbi Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_664dc397-f258-4604-869e-0cef8927cabd",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4251",
    "owner": "Al-Yazia Rashid Khamis Karaz Al-Sabousi"
  },
  {
    "id": "8495414f-7294-47aa-a651-a10193d69758",
    "slug": "al-yazia-suhail-al-nuaimi-advocates-and-legal-consultants",
    "name": "Al Yazia Suhail Al Nuaimi Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFZCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Al Yazia Suhail Al Nuaimi Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_8495414f-7294-47aa-a651-a10193d69758",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3168",
    "owner": "Al-Yazia Suhail Hareb Zuwaid Al-Nuaimi"
  },
  {
    "id": "ff15ca47-42a9-4fc1-8b9d-da063db1b2a4",
    "slug": "naila-ali-al-muhairi-advocates-and-legal-consultants",
    "name": "Naila Ali Al Muhairi Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE5BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Naila Ali Al Muhairi Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_ff15ca47-42a9-4fc1-8b9d-da063db1b2a4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4421",
    "owner": "Al-Yazia Muhammad Hilal Arar Al-Dhaheri"
  },
  {
    "id": "3a93e41d-c5b2-423f-8d8e-e4dd6d9a0922",
    "slug": "amal-muhammad-sobhi-sheikh-omar",
    "name": "Amal Muhammad Sobhi Sheikh Omar",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Amal Muhammad Sobhi Sheikh Omar",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_3a93e41d-c5b2-423f-8d8e-e4dd6d9a0922",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2686",
    "company": "Amal Mohamed Omar Law Firm and Legal Consultations"
  },
  {
    "id": "e7080975-92a1-4d8a-9d67-822f0baed177",
    "slug": "omar-khalifa-advocates-and-legal-consultations-llc",
    "name": "Omar Khalifa Advocates and Legal Consultations LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE9LCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Omar Khalifa Advocates and Legal Consultations LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e7080975-92a1-4d8a-9d67-822f0baed177",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2193, 2297, 4476, 4723",
    "owner": "Amani Ibrahim Khalifa Muhammad Al-Saeedi"
  },
  {
    "id": "cfe894d1-219e-4175-9bca-541e975816fc",
    "slug": "amal-abdullah-ali-al-hammadi",
    "name": "Amal Abdullah Ali Al Hammadi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Amal Abdullah Ali Al Hammadi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_cfe894d1-219e-4175-9bca-541e975816fc",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4518",
    "company": "Muhammad Al-Lingawi Law Firm and Legal Consultations"
  },
  {
    "id": "9e9058e2-d599-40b9-9153-9ca285591358",
    "slug": "lutfi-partners-advocates-and-legal-consultantsdubai",
    "name": "Lutfi & Partners Advocates and Legal Consultants/Dubai",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIExQCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Lutfi & Partners Advocates and Legal Consultants/Dubai",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_9e9058e2-d599-40b9-9153-9ca285591358",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "59, 4516",
    "owner": "Amal Nazih Abdullah Mutlaq"
  },
  {
    "id": "8c57fa2c-6c4d-4497-8b39-4c5d1f64bd3a",
    "slug": "amna-rashid-ahmed-rashid-al-harmoudi",
    "name": "Amna Rashid Ahmed Rashid Al Harmoudi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Amna Rashid Ahmed Rashid Al Harmoudi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_8c57fa2c-6c4d-4497-8b39-4c5d1f64bd3a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4299",
    "company": "Faisal Al Zarouni Advocates and Legal Consultants"
  },
  {
    "id": "fba6eb08-336c-4290-8bdf-6f6db69e3f9d",
    "slug": "amna-ahmed-saeed-rashid-al-naqbi",
    "name": "Amna Ahmed Saeed Rashid Al-Naqbi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Amna Ahmed Saeed Rashid Al-Naqbi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_fba6eb08-336c-4290-8bdf-6f6db69e3f9d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4594",
    "company": "Diana Hamada Law Firm"
  },
  {
    "id": "439d56db-6c78-4f1e-97fb-3e9c6c1c2a6c",
    "slug": "fahd-saeed-al-zeyoudi-advocates-and-legal-consultants",
    "name": "Fahd Saeed Al Zeyoudi Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEZTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Fahd Saeed Al Zeyoudi Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_439d56db-6c78-4f1e-97fb-3e9c6c1c2a6c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2879, 4512",
    "owner": "Ismail's security behind Ismail"
  },
  {
    "id": "805c58b5-813d-4825-a45a-21eb0bbf0351",
    "slug": "emirates-law-firm-and-legal-consultations-llc",
    "name": "Emirates Law Firm and Legal Consultations LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEVMCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Emirates Law Firm and Legal Consultations LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_805c58b5-813d-4825-a45a-21eb0bbf0351",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "813, 3939, 3998, 4312",
    "owner": "His security was Khaled Muhammad Kadfour Al Muhairi"
  },
  {
    "id": "fb6e5444-2db2-4f7e-9f2b-9b414305c365",
    "slug": "amna-ali-al-kayai-advocates-and-legal-consultants-llc",
    "name": "Amna Ali Al-Kayai Advocates and Legal Consultants LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Amna Ali Al-Kayai Advocates and Legal Consultants LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_fb6e5444-2db2-4f7e-9f2b-9b414305c365",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3909",
    "owner": "Security for Ibrahim Al-Kayay Al-Shamsi"
  },
  {
    "id": "6ae5c969-1d8a-46d5-86a5-cfb09d4d55f4",
    "slug": "security-on-salem-bin-mahri-al-kathiri",
    "name": "Security on Salem bin Mahri Al Kathiri",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Security on Salem bin Mahri Al Kathiri",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_6ae5c969-1d8a-46d5-86a5-cfb09d4d55f4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2712",
    "company": "Amna Al Kathiri Law Firm and Legal Consultations"
  },
  {
    "id": "fc3c577e-19b7-42df-aa66-1713dcd60abe",
    "slug": "his-security-is-majid-muhammad-al-sheikh-ahmed-al-khazraji",
    "name": "His security is Majid Muhammad Al-Sheikh Ahmed Al-Khazraji",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: His security is Majid Muhammad Al-Sheikh Ahmed Al-Khazraji",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_fc3c577e-19b7-42df-aa66-1713dcd60abe",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4503",
    "company": "Majid Al-Sheikh Advocates and Legal Consultants"
  },
  {
    "id": "c4a9e36b-0abe-4c0c-9ade-756e3b635b98",
    "slug": "hassan-al-riyami-advocates-and-legal-consultants",
    "name": "Hassan Al Riyami Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Hassan Al Riyami Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c4a9e36b-0abe-4c0c-9ade-756e3b635b98",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "262, 4268, 4555",
    "owner": "Muhammad Ali Muhammad's security"
  },
  {
    "id": "c24eeb6a-af8f-4d0f-b527-39bd560a67dd",
    "slug": "his-security-was-musa-muhammad-matar-ahmed",
    "name": "His security was Musa Muhammad Matar Ahmed",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: His security was Musa Muhammad Matar Ahmed",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c24eeb6a-af8f-4d0f-b527-39bd560a67dd",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3079",
    "company": "Al Dhaheri International Law Firm and Legal Consultations"
  },
  {
    "id": "c6cef0c4-c18c-470f-a25a-fff450492374",
    "slug": "princess-juma-saeed-sebit-al-kaabi",
    "name": "Princess Juma Saeed Sebit Al Kaabi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Princess Juma Saeed Sebit Al Kaabi",
    "consultationFee": 400,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_c6cef0c4-c18c-470f-a25a-fff450492374",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4530",
    "company": "Al-Raed Advocates and Legal Consultants/Abu Dhabi"
  },
  {
    "id": "1c159ddc-ee55-478c-b8e3-7a3f85925bd0",
    "slug": "amira-salem-mubarak-hamad-al-junaibi",
    "name": "Amira Salem Mubarak Hamad Al Junaibi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Amira Salem Mubarak Hamad Al Junaibi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1c159ddc-ee55-478c-b8e3-7a3f85925bd0",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4333",
    "company": "Amal Khamis Advocates and Legal Consultants/Dubai"
  },
  {
    "id": "70dc84f5-02d1-49f0-a9aa-659d28a2a52d",
    "slug": "amira-muhammad-saqr-muhammad-al-souri",
    "name": "IBRAHIM HASSAN AHMAD MOHAMED ALMARZOOQI",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/07/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Amira Muhammad Saqr Muhammad Al-Souri",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_70dc84f5-02d1-49f0-a9aa-659d28a2a52d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "L-2118",
    "company": "Amira Saqr Law Firm and Legal Consultations"
  },
  {
    "id": "cd3f0422-05a6-40d5-8f8b-d7879f9d7515",
    "slug": "abdullah-muhammad-rasoul-and-partners-advocates-and-legal-consultants",
    "name": "Abdullah Muhammad Rasoul and Partners Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Abdullah Muhammad Rasoul and Partners Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_cd3f0422-05a6-40d5-8f8b-d7879f9d7515",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3076, 3393, 3873, 4338, 4502, 4732",
    "owner": "Omaima Rushdi Abdel Karim Akkawi"
  },
  {
    "id": "be39ac6a-143d-422d-8f2f-242f00fc44ed",
    "slug": "amina-ahmed-hassan-mubarak-al-ahmad",
    "name": "Amina Ahmed Hassan Mubarak Al-Ahmad",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Amina Ahmed Hassan Mubarak Al-Ahmad",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_be39ac6a-143d-422d-8f2f-242f00fc44ed",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4478",
    "company": "Amina Al-Ahmad Advocates and Legal Consultants"
  },
  {
    "id": "c46915f5-848b-43a5-b103-ad8a8fc10879",
    "slug": "habib-al-mulla-and-partners",
    "name": "Habib Al Mulla and Partners",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Habib Al Mulla and Partners",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c46915f5-848b-43a5-b103-ad8a8fc10879",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4666",
    "owner": "Amina Mohammed Sharif Mohammed Saleh Al Jasmi"
  },
  {
    "id": "702259c8-985a-45fa-be46-b508ad5f7784",
    "slug": "hussein-mohammed-al-hosani-advocates-and-legal-consultants",
    "name": "Hussein Mohammed Al Hosani Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Hussein Mohammed Al Hosani Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_702259c8-985a-45fa-be46-b508ad5f7784",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4163",
    "owner": "Intisar Salem Hassan Al-Hamoud"
  },
  {
    "id": "091770de-5603-4f7f-a572-9c27a4cd88a8",
    "slug": "angie-nabil-advocates-and-legal-consultants-abu-dhabi-branch",
    "name": "Angie Nabil Advocates and Legal Consultants - Abu Dhabi Branch",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFOCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Angie Nabil Advocates and Legal Consultants - Abu Dhabi Branch",
    "consultationFee": 500,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_091770de-5603-4f7f-a572-9c27a4cd88a8",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "734, 3187, 4490",
    "owner": "Engy Nabil Mahmoud Ali Hassan"
  },
  {
    "id": "76bd1b05-381c-4d8d-860e-a139ac7998c5",
    "slug": "anfal-abdullah-khalifa-abdullah-al-kaabi",
    "name": "Anfal Abdullah Khalifa Abdullah Al Kaabi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Anfal Abdullah Khalifa Abdullah Al Kaabi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_76bd1b05-381c-4d8d-860e-a139ac7998c5",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4550",
    "company": "Zayed Al Mazrouei Advocates and Legal Consultants"
  },
  {
    "id": "4926e526-ac65-42c1-ae5a-64e2d5ef4bb3",
    "slug": "fahd-abdullah-law-firm-lawyers-and-legal-consultants",
    "name": "Fahd Abdullah Law Firm, lawyers and legal consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEZBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Fahd Abdullah Law Firm, lawyers and legal consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_4926e526-ac65-42c1-ae5a-64e2d5ef4bb3",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4175",
    "owner": "Iman Ali Saif Al-Nadas Al-Kutbi"
  },
  {
    "id": "7178b133-0ed4-413c-ab98-8350d53011c8",
    "slug": "iman-younis-muhammad-ismail-al-rifai",
    "name": "Iman Younis Muhammad Ismail Al-Rifai",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Iman Younis Muhammad Ismail Al-Rifai",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_7178b133-0ed4-413c-ab98-8350d53011c8",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "794",
    "company": "Iman Al-Rifai Advocates and Legal Consultations"
  },
  {
    "id": "4a931cf8-a968-4247-9569-31a11b2eb520",
    "slug": "enas-abdullah-law-firm-and-legal-consultations",
    "name": "Enas Abdullah Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEVBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Enas Abdullah Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_4a931cf8-a968-4247-9569-31a11b2eb520",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4178",
    "owner": "Enas Abdullah Naji Al-Maznai"
  },
  {
    "id": "61a9a3e4-49d0-4822-b3fe-c89033ac7417",
    "slug": "buthaina-ahmed-abdullah-saeed-al-dhanhani",
    "name": "Buthaina Ahmed Abdullah Saeed Al-Dhanhani",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Buthaina Ahmed Abdullah Saeed Al-Dhanhani",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_61a9a3e4-49d0-4822-b3fe-c89033ac7417",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4256",
    "company": "Hassan Al Riyami Advocates and Legal Consultants"
  },
  {
    "id": "29dc55d4-81a2-4c79-b0b5-79398d5e87d8",
    "slug": "badr-ismail-al-ansari",
    "name": "Badr Ismail Al Ansari",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Badr Ismail Al Ansari",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_29dc55d4-81a2-4c79-b0b5-79398d5e87d8",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "100",
    "company": "Badr Al Ansari Law Firm and Legal Consultations"
  },
  {
    "id": "252426f3-df13-4509-acaf-8744c5276f92",
    "slug": "badr-hamad-ahmed-al-zaabi",
    "name": "Badr Hamad Ahmed Al Zaabi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Badr Hamad Ahmed Al Zaabi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_252426f3-df13-4509-acaf-8744c5276f92",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3072",
    "company": "Badr Hamad Al Zaabi Law Firm and Legal Consultations"
  },
  {
    "id": "192346d3-d5c0-48d9-a4fe-4ccf076d5336",
    "slug": "badr-abdul-rahman-muhammad-al-jasmi",
    "name": "Badr Abdul Rahman Muhammad Al Jasmi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Badr Abdul Rahman Muhammad Al Jasmi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_192346d3-d5c0-48d9-a4fe-4ccf076d5336",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3884",
    "company": "Al Bastaki and Al Jasmi Advocates and Legal Consultants"
  },
  {
    "id": "aff0c3b8-a966-432a-9071-dfc325ecbc31",
    "slug": "abdullah-al-awadhi-lawyers-and-legal-consultants-llc-single-person-llc",
    "name": "Abdullah Al-Awadhi Lawyers and Legal Consultants LLC Single Person (LLC)",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Abdullah Al-Awadhi Lawyers and Legal Consultants LLC Single Person (LLC)",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_aff0c3b8-a966-432a-9071-dfc325ecbc31",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4060",
    "owner": "Badr Abdullah Hassan Abdullah Balhoush"
  },
  {
    "id": "ee706d8b-e9cd-4752-8176-56e9801a98fb",
    "slug": "badr-mohammed-al-gurg",
    "name": "Badr Mohammed Al Gurg",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Badr Mohammed Al Gurg",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_ee706d8b-e9cd-4752-8176-56e9801a98fb",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "418",
    "company": "Al Gurg and Al Matrooshi are lawyers and legal consultants"
  },
  {
    "id": "637e5ddc-1c74-4293-a8b7-64d201e0ff71",
    "slug": "al-anoud-mohammed-saleh-al-buraiki-law-firm-and-legal-consultations-office",
    "name": "Al-Anoud Mohammed Saleh Al-Buraiki Law Firm and Legal Consultations Office",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Al-Anoud Mohammed Saleh Al-Buraiki Law Firm and Legal Consultations Office",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_637e5ddc-1c74-4293-a8b7-64d201e0ff71",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4468",
    "owner": "Saleh's blessing on Saleh bin Hariz"
  },
  {
    "id": "c54e44b5-7ff9-4f5b-99e8-d90f3271106f",
    "slug": "bashair-mubarak-amer-awad-al-amr",
    "name": "Bashair Mubarak Amer Awad Al Amr",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Bashair Mubarak Amer Awad Al Amr",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c54e44b5-7ff9-4f5b-99e8-d90f3271106f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4291",
    "company": "Sultan Mohammed Al Matrooshi Advocates and Legal Consultations"
  },
  {
    "id": "408874fc-0c8b-4f26-b770-68892ab6d842",
    "slug": "ali-salem-al-alawi-law-firm-and-legal-consultations",
    "name": "Ali Salem Al-Alawi Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Ali Salem Al-Alawi Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_408874fc-0c8b-4f26-b770-68892ab6d842",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4675",
    "owner": "Bashayer Salem Ali Marshoud Al-Hafiti"
  },
  {
    "id": "3baf49fe-5400-4816-91ba-4b3b854580e0",
    "slug": "law-firm-for-trial-5124",
    "name": "Law firm for trial 5124",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIExGCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Law firm for trial 5124",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_3baf49fe-5400-4816-91ba-4b3b854580e0",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "22222",
    "owner": "Workout 2"
  },
  {
    "id": "731fe16c-270f-4c63-a0de-17724ed11636",
    "slug": "al-kumaiti-law-firm-llc",
    "name": "Al Kumaiti Law Firm LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFLCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Al Kumaiti Law Firm LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_731fe16c-270f-4c63-a0de-17724ed11636",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3735, 4286",
    "owner": "Edited by Saleh Khamis Al-Mukhaini Al-Junaibi"
  },
  {
    "id": "3e86de10-1773-4e76-b18a-82b314969039",
    "slug": "taima-yousef-saeed-jumairi-al-mazrouei",
    "name": "Taima Yousef Saeed Jumairi Al Mazrouei",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Taima Yousef Saeed Jumairi Al Mazrouei",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_3e86de10-1773-4e76-b18a-82b314969039",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4241",
    "company": "Mohammed Al Sarkal Law Firm and Legal Consultations"
  },
  {
    "id": "e8a2bca2-58fc-4f57-9701-f7963ec21bed",
    "slug": "insightful-ahmed-abdulaziz-al-sabbagh",
    "name": "Insightful Ahmed Abdulaziz Al-Sabbagh",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Insightful Ahmed Abdulaziz Al-Sabbagh",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e8a2bca2-58fc-4f57-9701-f7963ec21bed",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2183",
    "company": "Thaqiqa Ahmed Al-Sabbagh Law Firm and Legal Consultations Office"
  },
  {
    "id": "cbf8e0fd-e588-4a27-9c42-b01865b61351",
    "slug": "thamer-ali-khamis-khalfan-in-al-jafla",
    "name": "Thamer Ali Khamis Khalfan in Al Jafla",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Thamer Ali Khamis Khalfan in Al Jafla",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_cbf8e0fd-e588-4a27-9c42-b01865b61351",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4096",
    "company": "Thamer Ali Baljafla Law Firm and Legal Consultations"
  },
  {
    "id": "a0e7f401-506b-4a6d-9291-e05ea0296eb8",
    "slug": "jaber-jaafar-qambar-al-ansari",
    "name": "Jaber Jaafar Qambar Al Ansari",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Jaber Jaafar Qambar Al Ansari",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_a0e7f401-506b-4a6d-9291-e05ea0296eb8",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "742",
    "company": "Jaber Al Ansari Advocates and Legal Consultants"
  },
  {
    "id": "33d9211d-2c36-461e-9c0a-f7370f18c1ee",
    "slug": "mohammed-al-dahbashi-law-firm-llc",
    "name": "Mohammed Al-Dahbashi Law Firm LLC.",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Mohammed Al-Dahbashi Law Firm LLC.",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_33d9211d-2c36-461e-9c0a-f7370f18c1ee",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2957, 2963",
    "owner": "Jaber Abdullah Ibrahim Al Amiri"
  },
  {
    "id": "77ec6b4e-d6e4-40c4-a2fc-bd221856825e",
    "slug": "jassim-al-zarouni-law-firm-and-legal-consultations",
    "name": "Jassim Al Zarouni Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEpBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Jassim Al Zarouni Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_77ec6b4e-d6e4-40c4-a2fc-bd221856825e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3495",
    "owner": "Jassim Reda Mohammed Saleh Al-Zarouni"
  },
  {
    "id": "118e9ff2-7853-4c07-aae3-97f9130b6945",
    "slug": "jassim-abdullah-mohammed-ahmed-al-balushi",
    "name": "Jassim Abdullah Mohammed Ahmed Al Balushi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Jassim Abdullah Mohammed Ahmed Al Balushi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_118e9ff2-7853-4c07-aae3-97f9130b6945",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4010",
    "company": "Jassim Al Balushi Advocates and Legal Consultants"
  },
  {
    "id": "181076ff-811b-4e88-9de4-c66f85ebfc5c",
    "slug": "jassim-ali-al-haddad",
    "name": "Jassim Ali Al-Haddad",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Jassim Ali Al-Haddad",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_181076ff-811b-4e88-9de4-c66f85ebfc5c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4032",
    "company": "Jassim Al-Haddad Law Firm and Legal Consultations"
  },
  {
    "id": "031f304d-190d-4758-870c-3b8a1870ae4e",
    "slug": "jassim-mohammed-rashid-khamis-al-khadeem-al-antali",
    "name": "Jassim Mohammed Rashid Khamis Al-Khadeem Al-Antali",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Jassim Mohammed Rashid Khamis Al-Khadeem Al-Antali",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_031f304d-190d-4758-870c-3b8a1870ae4e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "959",
    "company": "Dr. Jassim Al-Antali Advocates and Legal Consultants"
  },
  {
    "id": "d853d506-92b2-4bd2-996c-b1c150f31d70",
    "slug": "jassim-mohammed-abdul-karim-al-mudharib-al-ahmad",
    "name": "Jassim Mohammed Abdul Karim Al-Mudharib Al-Ahmad",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Jassim Mohammed Abdul Karim Al-Mudharib Al-Ahmad",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_d853d506-92b2-4bd2-996c-b1c150f31d70",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4235",
    "company": "International Legal Office for Advocates and Legal Consultations"
  },
  {
    "id": "535f225b-0989-414a-bfeb-822764cd4c71",
    "slug": "jassim-mohammed-abdullah-shagrouf-al-shehhi",
    "name": "Jassim Mohammed Abdullah Shagrouf Al Shehhi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Jassim Mohammed Abdullah Shagrouf Al Shehhi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_535f225b-0989-414a-bfeb-822764cd4c71",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "1205",
    "company": "Jassim Al Shehhi Advocates and Legal Consultants"
  },
  {
    "id": "787e9ca8-0ff2-4d61-af8c-ea75aaa5fff6",
    "slug": "jamal-ismail-jamal-abdullah-al-hosani",
    "name": "Jamal Ismail Jamal Abdullah Al Hosani",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Jamal Ismail Jamal Abdullah Al Hosani",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_787e9ca8-0ff2-4d61-af8c-ea75aaa5fff6",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4637",
    "company": "Musab Ali Al Naqbi Advocates and Legal Consultants"
  },
  {
    "id": "c3e56c82-55f4-4ae1-8b2e-9dc9b716be06",
    "slug": "jamal-hassan-abdo-al-najjar",
    "name": "Jamal Hassan Abdo Al-Najjar",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Jamal Hassan Abdo Al-Najjar",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c3e56c82-55f4-4ae1-8b2e-9dc9b716be06",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4309",
    "company": "Jamal Al-Najjar Law Firm and Legal Consultations"
  },
  {
    "id": "90b02450-7772-42a2-b87a-bb0cc62ee1ff",
    "slug": "al-bastaki-and-al-jasmi-advocates-and-legal-consultants",
    "name": "Al Bastaki and Al Jasmi Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFCCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Al Bastaki and Al Jasmi Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_90b02450-7772-42a2-b87a-bb0cc62ee1ff",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4432",
    "owner": "Jamal Hussein Ahmed Al-Sumaiti"
  },
  {
    "id": "dbf5da17-8541-4b59-9027-0a309d7d6486",
    "slug": "jamal-hamad-obaid-al-shehhi",
    "name": "Jamal Hamad Obaid Al Shehhi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Jamal Hamad Obaid Al Shehhi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_dbf5da17-8541-4b59-9027-0a309d7d6486",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4429",
    "company": "Jamal Al Shehhi Advocates and Legal Consultations LLC"
  },
  {
    "id": "9be897fc-7607-4eb0-8cc1-f94a3d9db3b2",
    "slug": "jamal-abdul-rahman-jassim-ibrahim-al-nuaimi",
    "name": "Jamal Abdul Rahman Jassim Ibrahim Al Nuaimi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Jamal Abdul Rahman Jassim Ibrahim Al Nuaimi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_9be897fc-7607-4eb0-8cc1-f94a3d9db3b2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4030",
    "company": "Jamal Al Nuaimi Advocates and Legal Consultants"
  },
  {
    "id": "ce8655d3-5126-49d3-8ca5-363ceb5ccab0",
    "slug": "jamal-abdullah-majid-al-shamsi",
    "name": "Jamal Abdullah Majid Al Shamsi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Jamal Abdullah Majid Al Shamsi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_ce8655d3-5126-49d3-8ca5-363ceb5ccab0",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "339",
    "company": "Jamal Al Shamsi Advocates and Legal Consultations"
  },
  {
    "id": "54e6452b-0305-40ca-a2c3-9f42286031a0",
    "slug": "gamal-murad-ali-murad-al-raisi",
    "name": "Gamal Murad Ali Murad Al-Raisi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Gamal Murad Ali Murad Al-Raisi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_54e6452b-0305-40ca-a2c3-9f42286031a0",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4252",
    "company": "Jamal Al-Raisi Law Firm and Legal Consultations"
  },
  {
    "id": "adbd47f2-d0d7-40bc-855c-809adabf2ce4",
    "slug": "jumaa-ahmed-obaid-ahmed-malih",
    "name": "Jumaa Ahmed Obaid Ahmed Malih",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Jumaa Ahmed Obaid Ahmed Malih",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_adbd47f2-d0d7-40bc-855c-809adabf2ce4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "898",
    "company": "Maleh Advocates and Legal Consultants"
  },
  {
    "id": "6b981280-2b52-4e80-8d13-22f83f644857",
    "slug": "jumaa-butti-al-bawardi",
    "name": "Jumaa Butti Al Bawardi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Jumaa Butti Al Bawardi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_6b981280-2b52-4e80-8d13-22f83f644857",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "12",
    "company": "Al Bawardi Law Firm and Legal Consultations"
  },
  {
    "id": "1a91a273-29ac-4834-8f82-fbc75f5e4a00",
    "slug": "juma-khalifa-law-firm-and-legal-consultations-llc",
    "name": "Juma Khalifa Law Firm and Legal Consultations LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEpLCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Juma Khalifa Law Firm and Legal Consultations LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_1a91a273-29ac-4834-8f82-fbc75f5e4a00",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3319, 4537",
    "owner": "Friday, Khalifa, Friday of sour"
  },
  {
    "id": "a413c399-66ea-4761-9f71-062e8cff5fed",
    "slug": "compiled-by-muhammad-ahmed-doura-al-kaabi",
    "name": "Compiled by Muhammad Ahmed Doura Al-Kaabi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Compiled by Muhammad Ahmed Doura Al-Kaabi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_a413c399-66ea-4761-9f71-062e8cff5fed",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4451",
    "company": "Hamdan Dhahi Al Kaabi Law Firm, Legal Consultations"
  },
  {
    "id": "e6168c64-8b3b-4fdb-8fd5-12937a467ace",
    "slug": "all-of-them-are-suitable-for-lawyers-and-legal-consultations",
    "name": "All of them are suitable for lawyers and legal consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFUCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: All of them are suitable for lawyers and legal consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e6168c64-8b3b-4fdb-8fd5-12937a467ace",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3365",
    "owner": "Saleh Al-Ghailani Association"
  },
  {
    "id": "2740e655-0a9f-4cf4-a35d-9f666ad2899c",
    "slug": "jamila-saeed-majid-saeed-al-muhairi",
    "name": "HAMDAN ABDALLA MOHAMED HUSSAIN ALRAYSSI",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/07/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Jamila Saeed Majid Saeed Al Muhairi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_2740e655-0a9f-4cf4-a35d-9f666ad2899c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "L-2117",
    "company": "Jamila Al Muhairi Advocates and Legal Consultants"
  },
  {
    "id": "9a409d7c-e796-42d3-9026-5899b7054860",
    "slug": "jamila-ghulam-haider-muhammad-al-balushi",
    "name": "Jamila Ghulam Haider Muhammad Al Balushi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Jamila Ghulam Haider Muhammad Al Balushi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_9a409d7c-e796-42d3-9026-5899b7054860",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2310",
    "company": "The office of lawyer Jamila Ghulam Haider Al Balushi"
  },
  {
    "id": "8354ddc3-0daa-49aa-9193-e64a31c7f1fc",
    "slug": "jihad-saeed-ali-bin-sahouh-al-suwaidi",
    "name": "Jihad Saeed Ali bin Sahouh Al Suwaidi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Jihad Saeed Ali bin Sahouh Al Suwaidi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_8354ddc3-0daa-49aa-9193-e64a31c7f1fc",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3618",
    "company": "Jihad Saeed Bin Sahouh Advocates and Legal Consultants"
  },
  {
    "id": "5cc63f04-750d-4fe8-9cb6-ce8048471b6f",
    "slug": "hatem-hussein-nasser-al-khulaifi",
    "name": "Hatem Hussein Nasser Al-Khulaifi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBISAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Hatem Hussein Nasser Al-Khulaifi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_5cc63f04-750d-4fe8-9cb6-ce8048471b6f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2276",
    "company": "Hatem Hussein Al-Khulaifi Advocates and Legal Consultants"
  },
  {
    "id": "6559356a-8a1a-4bf9-9120-9efbf9ec1e70",
    "slug": "hamid-al-sayyid-abu-bakr-hussein-al-hamid-al-hashimi",
    "name": "Hamid Al-Sayyid Abu Bakr Hussein Al-Hamid Al-Hashimi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Hamid Al-Sayyid Abu Bakr Hussein Al-Hamid Al-Hashimi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_6559356a-8a1a-4bf9-9120-9efbf9ec1e70",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4681",
    "company": "Muhammad Abdul-Ilah Al-Hamid Advocates and Legal Consultants"
  },
  {
    "id": "d34222c8-2341-489b-9e37-aabd0981aae3",
    "slug": "hamid-salem-ali-salem-al-alawi",
    "name": "Hamid Salem Ali Salem Al-Alawi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Hamid Salem Ali Salem Al-Alawi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_d34222c8-2341-489b-9e37-aabd0981aae3",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4180",
    "company": "Ali Salem Al-Alawi Law Firm and Legal Consultations"
  },
  {
    "id": "27e64af0-fdc2-4fb3-b98f-1711673e4c8a",
    "slug": "habib-abdul-rahim-abdullah-al-hosani",
    "name": "Habib Abdul Rahim Abdullah Al Hosani",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Habib Abdul Rahim Abdullah Al Hosani",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_27e64af0-fdc2-4fb3-b98f-1711673e4c8a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "1319",
    "company": "Habib Al Hosani Law Firm and Legal Consultations is a one person company LLC"
  },
  {
    "id": "2f3b7057-1dc4-4cf7-a1d1-0ed7cef7b247",
    "slug": "bin-ismail-law-firm-and-legal-consultations",
    "name": "Bin Ismail Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEJJCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Bin Ismail Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_2f3b7057-1dc4-4cf7-a1d1-0ed7cef7b247",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "42",
    "owner": "Hassan Ismail Al-Aidarous"
  },
  {
    "id": "d3f55827-936c-439a-817a-bb92f54a8195",
    "slug": "hassan-jassim-ali-hassan-al-hammadi",
    "name": "Hassan Jassim Ali Hassan Al Hammadi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBISgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Hassan Jassim Ali Hassan Al Hammadi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_d3f55827-936c-439a-817a-bb92f54a8195",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3724",
    "company": "Saif Ali Al Hammadi Advocates and Legal Consultants"
  },
  {
    "id": "eb8572ac-e8d8-45ac-86e2-19ef4235ceb4",
    "slug": "hassan-rashid-hassan-ahmed-al-marashdeh",
    "name": "Hassan Rashid Hassan Ahmed Al-Marashdeh",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Hassan Rashid Hassan Ahmed Al-Marashdeh",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_eb8572ac-e8d8-45ac-86e2-19ef4235ceb4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2109",
    "company": "Al-Balushi and Al-Marashda Advocates and Legal Consultants"
  },
  {
    "id": "3c72c783-00a1-46b7-95e5-e103cbb1deab",
    "slug": "hassan-ramadan-abdullah-muhammad-al-qablan",
    "name": "Hassan Ramadan Abdullah Muhammad Al-Qablan",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Hassan Ramadan Abdullah Muhammad Al-Qablan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_3c72c783-00a1-46b7-95e5-e103cbb1deab",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4097",
    "company": "Dubai Advocates and Legal Consultants"
  },
  {
    "id": "5d983851-729f-4d60-9692-e5e36fd5a262",
    "slug": "hassan-salem-bin-samie-law-firm-and-legal-consultations-office",
    "name": "Hassan Salem Bin Samie Law Firm and Legal Consultations Office",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Hassan Salem Bin Samie Law Firm and Legal Consultations Office",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_5d983851-729f-4d60-9692-e5e36fd5a262",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4062, 4196",
    "owner": "Hassan Salem Sami Saadan Al-Ahbabi"
  },
  {
    "id": "72692bab-73b3-4c58-b0cf-fbe6791780b3",
    "slug": "hassan-abdul-rahman-hassan-abdullah-dashkouni",
    "name": "Hassan Abdul Rahman Hassan Abdullah Dashkouni",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Hassan Abdul Rahman Hassan Abdullah Dashkouni",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_72692bab-73b3-4c58-b0cf-fbe6791780b3",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "982",
    "company": "United Lawyers Advocates and Legal Consultants"
  },
  {
    "id": "6f601183-d383-410a-aa69-79b8a238648c",
    "slug": "hassan-abdullah-muhammad-al-abdouli",
    "name": "Hassan Abdullah Muhammad Al-Abdouli",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Hassan Abdullah Muhammad Al-Abdouli",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_6f601183-d383-410a-aa69-79b8a238648c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "1653",
    "company": "Hassan Al-Abdouli Law Firm and Legal Consultations"
  },
  {
    "id": "8f7f6b94-c016-43ce-beaf-d866f3b8e055",
    "slug": "hassan-abdullah-muhammad-ali-al-ali",
    "name": "Hassan Abdullah Muhammad Ali Al Ali",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Hassan Abdullah Muhammad Ali Al Ali",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_8f7f6b94-c016-43ce-beaf-d866f3b8e055",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2194",
    "company": "Hassan Al Ali Law Firm and Legal Consultations"
  },
  {
    "id": "b9797079-6089-4894-bd6b-9ddb9b1bb3a0",
    "slug": "saif-sultan-al-mahrezi-advocates-and-legal-consultations-sharjah",
    "name": "Saif Sultan Al Mahrezi Advocates and Legal Consultations - Sharjah",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Saif Sultan Al Mahrezi Advocates and Legal Consultations - Sharjah",
    "consultationFee": 500,
    "emirate": "Sharjah",
    "verified": true,
    "offices": [
      {
        "id": "office_b9797079-6089-4894-bd6b-9ddb9b1bb3a0",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Sharjah",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4057, 4438, 4543",
    "owner": "Hassan Obaid Musa Abdullah Al Kaabi"
  },
  {
    "id": "708676f0-4910-45d3-b206-6e6d81dcaba7",
    "slug": "hassan-ali-law-firm-and-legal-consultations",
    "name": "Hassan Ali Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Hassan Ali Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_708676f0-4910-45d3-b206-6e6d81dcaba7",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3589",
    "owner": "Hassan Ali Abdullah Shahdad"
  },
  {
    "id": "3cacf2c6-93ae-4f6e-8062-8cd7982ebb5c",
    "slug": "hassan-ali-youssef-jumaa-al-marzouqi",
    "name": "Hassan Ali Youssef Jumaa Al Marzouqi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Hassan Ali Youssef Jumaa Al Marzouqi",
    "consultationFee": 400,
    "emirate": "Ajman",
    "verified": true,
    "offices": [
      {
        "id": "office_3cacf2c6-93ae-4f6e-8062-8cd7982ebb5c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Ajman",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "1341",
    "company": "Hassan Ali Al Marzouqi Advocates and Legal Consultations / Ajman"
  },
  {
    "id": "1638452b-04e6-43c5-b2a8-42ec3d953ad3",
    "slug": "hassan-mal-allah-khalfan-al-hammadi",
    "name": "Hassan Mal Allah Khalfan Al Hammadi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Hassan Mal Allah Khalfan Al Hammadi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_1638452b-04e6-43c5-b2a8-42ec3d953ad3",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4271",
    "company": "Majid Al Jallaf Advocates and Legal Consultants"
  },
  {
    "id": "48907407-7c90-4a72-b982-540eee822f44",
    "slug": "hassan-muhammad-hassan-tamim",
    "name": "Hassan Muhammad Hassan Tamim",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Hassan Muhammad Hassan Tamim",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_48907407-7c90-4a72-b982-540eee822f44",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2160",
    "company": "Hassan Tamim Law Firm and Legal Consultations"
  },
  {
    "id": "9c2ef201-fed6-4314-8e07-694def4a980b",
    "slug": "hassan-muhammad-hassan-karam",
    "name": "Hassan Muhammad Hassan Karam",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Hassan Muhammad Hassan Karam",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_9c2ef201-fed6-4314-8e07-694def4a980b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3915",
    "company": "Hassan Mohamed Karam Law Firm and Legal Consultations"
  },
  {
    "id": "6fb9daa7-1f7c-4797-b9d1-f744e6ac350a",
    "slug": "hassan-mohammed-yahya-advocates-and-legal-consultations-llc-spc",
    "name": "Hassan Mohammed Yahya Advocates and Legal Consultations (L.L.C-S.P.C.)",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Hassan Mohammed Yahya Advocates and Legal Consultations (L.L.C-S.P.C.)",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_6fb9daa7-1f7c-4797-b9d1-f744e6ac350a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2175",
    "owner": "Hassan Muhammad Yahya Abdullah"
  },
  {
    "id": "f78e42a8-0234-4a6c-a959-4a2e7195ba19",
    "slug": "hassan-murad-abdullah-muhammad-shamal",
    "name": "Hassan Murad Abdullah Muhammad Shamal",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Hassan Murad Abdullah Muhammad Shamal",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_f78e42a8-0234-4a6c-a959-4a2e7195ba19",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "928",
    "company": "Hassan Murad Shamal Advocates and Legal Consultations LLC"
  },
  {
    "id": "62a2af95-71f2-4c06-bcb6-fc92a50a7c98",
    "slug": "hussein-hassan-muhammad-al-ali",
    "name": "Hussein Hassan Muhammad Al Ali",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBISAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Hussein Hassan Muhammad Al Ali",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_62a2af95-71f2-4c06-bcb6-fc92a50a7c98",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4054",
    "company": "Hussein Hassan Al Ali Law Firm and Legal Consultations"
  },
  {
    "id": "5edd863f-5895-4783-9147-f4a9958d29cb",
    "slug": "hussein-hamza-salem-al-duwailah-al-hashemi",
    "name": "Hussein Hamza Salem Al-Duwailah Al-Hashemi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBISAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Hussein Hamza Salem Al-Duwailah Al-Hashemi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_5edd863f-5895-4783-9147-f4a9958d29cb",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4098",
    "company": "Hussein Al-Duwailah Al-Hashemi Advocates and Legal Consultants"
  },
  {
    "id": "f77ff5d2-4594-402f-8d83-23a8464f704f",
    "slug": "muhammad-al-ghafli-lawyers-and-legal-consultants-llc",
    "name": "Muhammad Al-Ghafli Lawyers and Legal Consultants LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Muhammad Al-Ghafli Lawyers and Legal Consultants LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_f77ff5d2-4594-402f-8d83-23a8464f704f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3438",
    "owner": "Hussein Abdul Qader Abdullah Al Emadi"
  },
  {
    "id": "a1301c03-bf56-4574-9638-81a20b55bb27",
    "slug": "al-sahlawi-and-associates-are-lawyers-and-consultants",
    "name": "Al-Sahlawi and Associates are lawyers and consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Al-Sahlawi and Associates are lawyers and consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_a1301c03-bf56-4574-9638-81a20b55bb27",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "385, 2397, 2440, 4632",
    "owner": "Hussein Abdullah Saleh Ahmed bin Rashid"
  },
  {
    "id": "bb1ea9fe-1be1-4e11-920d-d1094b6dbb89",
    "slug": "hussein-ali-hussein-al-jaziri",
    "name": "Hussein Ali Hussein Al-Jaziri",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Hussein Ali Hussein Al-Jaziri",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_bb1ea9fe-1be1-4e11-920d-d1094b6dbb89",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "52",
    "company": "Jaafar Alwan, Al-Jaziri and Partners are lawyers and legal consultants"
  },
  {
    "id": "233a5aed-9f9f-4ee6-9af0-2885aca5c4b0",
    "slug": "hussein-ali-abdul-rahman-lootah",
    "name": "Hussein Ali Abdul Rahman Lootah",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Hussein Ali Abdul Rahman Lootah",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_233a5aed-9f9f-4ee6-9af0-2885aca5c4b0",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "114",
    "company": "Hussein Lootah and Associates are lawyers and legal consultants"
  },
  {
    "id": "c3a8a911-a5f8-4903-8c4e-4646171aea38",
    "slug": "hussein-ali-muhammad-hassan-al-bishr",
    "name": "Hussein Ali Muhammad Hassan Al-Bishr",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Hussein Ali Muhammad Hassan Al-Bishr",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c3a8a911-a5f8-4903-8c4e-4646171aea38",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3658",
    "company": "Hussein Ali Al-Bishr Advocates and Legal Consultants"
  },
  {
    "id": "46040384-d213-4b09-9df1-c983726fa469",
    "slug": "hussein-ali-nasser-al-harithi",
    "name": "Hussein Ali Nasser Al Harithi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Hussein Ali Nasser Al Harithi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_46040384-d213-4b09-9df1-c983726fa469",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4471",
    "company": "Hussein Ali Al Harithi Advocates and Legal Consultations - LLC - S.P.C"
  },
  {
    "id": "6e203bca-adac-4cb1-8073-93157238273d",
    "slug": "majid-hamad-al-kalbani-advocates-and-legal-consultants",
    "name": "Majid Hamad Al Kalbani Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1ICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Majid Hamad Al Kalbani Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_6e203bca-adac-4cb1-8073-93157238273d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4328",
    "owner": "Hussein Qitas Baqir Al Farsi"
  },
  {
    "id": "4c3edab9-12e9-412c-ad93-f91dc226a998",
    "slug": "hussein-mirza-ahmed-abdullah",
    "name": "Hussein Mirza Ahmed Abdullah",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Hussein Mirza Ahmed Abdullah",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_4c3edab9-12e9-412c-ad93-f91dc226a998",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3984",
    "company": "Hussein Mirza Advocates and Legal Consultations"
  },
  {
    "id": "9d00ef8d-6ea2-4737-b603-d2e7f4d4beaa",
    "slug": "husseina-rashid-hamid-rashid-al-maamari",
    "name": "Husseina Rashid Hamid Rashid Al-Maamari",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Husseina Rashid Hamid Rashid Al-Maamari",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_9d00ef8d-6ea2-4737-b603-d2e7f4d4beaa",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4505",
    "company": "Jamal Al Nuaimi Advocates and Legal Consultants"
  },
  {
    "id": "95fff251-4478-4bc2-9188-f327ff59ed0a",
    "slug": "hessa-hamid-abdullah-al-sharaa-al-mazmi",
    "name": "Hessa Hamid Abdullah Al-Sharaa Al-Mazmi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBISAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Hessa Hamid Abdullah Al-Sharaa Al-Mazmi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_95fff251-4478-4bc2-9188-f327ff59ed0a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3919",
    "company": "Hessa Humaid Al-Sharaa Advocates and Legal Consultants"
  },
  {
    "id": "5326847b-8b9f-4005-b7a2-7b42da47b755",
    "slug": "hessa-salem-ismail-saeed-al-hammadi",
    "name": "Hessa Salem Ismail Saeed Al Hammadi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Hessa Salem Ismail Saeed Al Hammadi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_5326847b-8b9f-4005-b7a2-7b42da47b755",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3549",
    "company": "Hessa Al Hammadi Advocates and Legal Consultants"
  },
  {
    "id": "79382e54-6d03-4c8f-946d-e6a3ca06565e",
    "slug": "jassim-al-suwaidi-law-firm-partners",
    "name": "Jassim Al Suwaidi Law Firm & Partners",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEpBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Jassim Al Suwaidi Law Firm & Partners",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_79382e54-6d03-4c8f-946d-e6a3ca06565e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4154, 4261",
    "owner": "Hessa Abdullah Ahmed Hosni Al Shehhi"
  },
  {
    "id": "7c818553-cebc-4fbb-8d78-01c7e7cfb26e",
    "slug": "his-share-on-hassan-ali-al-mismari",
    "name": "His share on Hassan Ali Al-Mismari",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: His share on Hassan Ali Al-Mismari",
    "consultationFee": 400,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_7c818553-cebc-4fbb-8d78-01c7e7cfb26e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4510",
    "company": "Al-Ittihad Advocates and Legal Consultants/Abu Dhabi"
  },
  {
    "id": "effdc8a4-aefb-4256-a7e7-ffb3964c80d9",
    "slug": "al-mannai-law-firm-and-legal-consultations",
    "name": "Al Mannai Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Al Mannai Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_effdc8a4-aefb-4256-a7e7-ffb3964c80d9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "1538",
    "owner": "Halawa Obaid Ali Al-Mannai"
  },
  {
    "id": "369ec2c3-4016-4ad8-bfb8-de8287a9f7f9",
    "slug": "sweetness-by-muhammad-bin-sarhan-al-shehhi",
    "name": "Sweetness by Muhammad bin Sarhan Al-Shehhi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Sweetness by Muhammad bin Sarhan Al-Shehhi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_369ec2c3-4016-4ad8-bfb8-de8287a9f7f9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4305",
    "company": "Issam Al Zarouni Law Firm and Legal Consultations"
  },
  {
    "id": "b0d6a6fc-0532-43a2-b660-2e7821ce7cf2",
    "slug": "hamad-ahmed-obaid-mohammed-al-sayegh",
    "name": "Hamad Ahmed Obaid Mohammed Al Sayegh",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Hamad Ahmed Obaid Mohammed Al Sayegh",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_b0d6a6fc-0532-43a2-b660-2e7821ce7cf2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2959",
    "company": "Hamad Al Sayegh Advocates and Legal Consultants"
  },
  {
    "id": "5c24a176-7e8e-47de-b4fd-e19854d0c26c",
    "slug": "ibrahim-ahmed-praised-the-professor",
    "name": "Ibrahim Ahmed praised the professor",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ibrahim Ahmed praised the professor",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_5c24a176-7e8e-47de-b4fd-e19854d0c26c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4194",
    "company": "Dr. Hamad Al-Ustath Advocates and Legal Consultants"
  },
  {
    "id": "7e1bf790-b7bd-41c1-b49e-3f44a55956df",
    "slug": "noura-tayseer-advocates-and-legal-consultations-llc",
    "name": "Noura Tayseer Advocates and Legal Consultations LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE5UCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Noura Tayseer Advocates and Legal Consultations LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_7e1bf790-b7bd-41c1-b49e-3f44a55956df",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4191, 4209",
    "owner": "Hamad Hamid Issa Sultan Al Suwaidi"
  },
  {
    "id": "4921727c-1cda-42d2-8b5d-ec84ac821d86",
    "slug": "hamad-saeed-obaid-salij-al-ketbi",
    "name": "Hamad Saeed Obaid Salij Al Ketbi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Hamad Saeed Obaid Salij Al Ketbi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_4921727c-1cda-42d2-8b5d-ec84ac821d86",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4159",
    "company": "Hamad Saeed Al Ketbi Advocates and Legal Consultants"
  },
  {
    "id": "9ecbe976-a807-4dd5-85a9-ef01763220b3",
    "slug": "hamad-saif-ibrahim-muhammad-al-zaabi",
    "name": "Hamad Saif Ibrahim Muhammad Al Zaabi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Hamad Saif Ibrahim Muhammad Al Zaabi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_9ecbe976-a807-4dd5-85a9-ef01763220b3",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4320",
    "company": "Hamad Al Zaabi and Mona Bin Ghalita Law Firm and Legal Consultations"
  },
  {
    "id": "4b033bc6-2a4b-4906-92d7-b9a5369d3862",
    "slug": "hamad-duha-khasib-mazul-al-muqbali",
    "name": "Hamad Duha Khasib Mazul Al-Muqbali",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Hamad Duha Khasib Mazul Al-Muqbali",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_4b033bc6-2a4b-4906-92d7-b9a5369d3862",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4129",
    "company": "Hamad Dhahi Al-Muqbali Law Firm and Legal Consultations"
  },
  {
    "id": "ce3f2dff-bff7-4d0e-9ca4-690933f0843a",
    "slug": "hamad-abdullah-abdul-rahman-muhammad-al-saeedi",
    "name": "Hamad Abdullah Abdul Rahman Muhammad Al-Saeedi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Hamad Abdullah Abdul Rahman Muhammad Al-Saeedi",
    "consultationFee": 400,
    "emirate": "Sharjah",
    "verified": true,
    "offices": [
      {
        "id": "office_ce3f2dff-bff7-4d0e-9ca4-690933f0843a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Sharjah",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2235",
    "company": "Al Saeedi Advocates and Legal Consultants - Sharjah"
  },
  {
    "id": "fdae498b-c4e4-4880-aeb4-a11f283235e7",
    "slug": "dr-hamad-al-dabani-al-nuaimi-advocates-and-legal-consultants-llc-one-person",
    "name": "Dr. Hamad Al Dabani Al Nuaimi Advocates and Legal Consultants LLC (one person)",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Dr. Hamad Al Dabani Al Nuaimi Advocates and Legal Consultants LLC (one person)",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_fdae498b-c4e4-4880-aeb4-a11f283235e7",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3005",
    "owner": "Hamad Ali Abdullah Al-Dabbani Al-Nuaimi"
  },
  {
    "id": "ce0a155c-2024-4e91-83c6-ea113780ab7b",
    "slug": "hamad-issa-muhammad-al-issa",
    "name": "Hamad Issa Muhammad Al-Issa",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBISQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Hamad Issa Muhammad Al-Issa",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_ce0a155c-2024-4e91-83c6-ea113780ab7b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2346",
    "company": "Hamad Al-Issa Advocates and Legal Consultants LLC"
  },
  {
    "id": "3d15880a-e722-44d2-80d1-24708853c13c",
    "slug": "hamad-mohammed-al-mutawa-al-nuaimi",
    "name": "Hamad Mohammed Al Mutawa Al Nuaimi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Hamad Mohammed Al Mutawa Al Nuaimi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_3d15880a-e722-44d2-80d1-24708853c13c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3787",
    "company": "Hamad Mohammed Al Mutawa Al Nuaimi Advocates and Legal Consultants"
  },
  {
    "id": "316e333e-95e3-4ea4-bed2-5ea9bca0f901",
    "slug": "dr-hamad-mohammed-al-esayi-law-office-and-legal-consultations",
    "name": "Dr. Hamad Mohammed Al-Esayi Law Office and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Dr. Hamad Mohammed Al-Esayi Law Office and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_316e333e-95e3-4ea4-bed2-5ea9bca0f901",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4483",
    "owner": "Hamad Mohammed Zayed Suleiman Al-Essayi"
  },
  {
    "id": "907efccd-9ff4-46b8-91df-3fd9860a0334",
    "slug": "mohammed-ahmed-al-zaabi-law-firm-and-legal-consultations",
    "name": "Mohammed Ahmed Al Zaabi Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Mohammed Ahmed Al Zaabi Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_907efccd-9ff4-46b8-91df-3fd9860a0334",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3992, 3995, 4455",
    "owner": "Hamad Nasser Saeed Salem Al Alawi"
  },
  {
    "id": "459f87fd-78f7-4df8-b3a7-3bbea3d7dd8a",
    "slug": "hamad-younis-muhammad-abdullah-al-mazmi",
    "name": "Hamad Younis Muhammad Abdullah Al-Mazmi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Hamad Younis Muhammad Abdullah Al-Mazmi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_459f87fd-78f7-4df8-b3a7-3bbea3d7dd8a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4588",
    "company": "Mohamed Ahmed Law Firm and Legal Consultations"
  },
  {
    "id": "1744a155-ae29-4878-aa14-92e15f50ee20",
    "slug": "hamdan-al-shehhi-law-firm-and-legal-consultations-office",
    "name": "Hamdan Al Shehhi Law Firm and Legal Consultations Office",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Hamdan Al Shehhi Law Firm and Legal Consultations Office",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_1744a155-ae29-4878-aa14-92e15f50ee20",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2222",
    "owner": "Hamdan Hassan Abdullah Al-Hadiya Al-Shehhi"
  },
  {
    "id": "c96a6c73-a19d-412a-8ab1-7b2f4facfbc1",
    "slug": "hamdan-suleiman-salem-al-mazmi-advocates-and-legal-consultants",
    "name": "Hamdan Suleiman Salem Al Mazmi Advocates and Legal Consultants.",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Hamdan Suleiman Salem Al Mazmi Advocates and Legal Consultants.",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c96a6c73-a19d-412a-8ab1-7b2f4facfbc1",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4205, 4610",
    "owner": "Hamdan Suleiman Salem Suleiman Al-Mazmi"
  },
  {
    "id": "59373c7f-5b88-4446-b24b-083081e49fdb",
    "slug": "hamdan-dhahi-khalfan-subeih-al-kaabi",
    "name": "Hamdan Dhahi Khalfan Subeih Al Kaabi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Hamdan Dhahi Khalfan Subeih Al Kaabi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_59373c7f-5b88-4446-b24b-083081e49fdb",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4090",
    "company": "Hamdan Dhahi Al Kaabi Law Firm, Legal Consultations"
  },
  {
    "id": "03ad2b7d-a2be-4348-bd47-0c1f8d9437c2",
    "slug": "hamdan-abdullah-muhammad-hussein-al-raisi",
    "name": "Hamdan Abdullah Muhammad Hussein Al-Raisi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Hamdan Abdullah Muhammad Hussein Al-Raisi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_03ad2b7d-a2be-4348-bd47-0c1f8d9437c2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3880",
    "company": "Bin Haider Law Firm and Legal Consultations"
  },
  {
    "id": "204a5e39-b600-41df-9d0e-352e018dec35",
    "slug": "hamdan-ali-al-ghaithi-law-firm-and-legal-consultations-one-person-company-llc",
    "name": "Hamdan Ali Al Ghaithi Law Firm and Legal Consultations - One Person Company LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Hamdan Ali Al Ghaithi Law Firm and Legal Consultations - One Person Company LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_204a5e39-b600-41df-9d0e-352e018dec35",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3708",
    "owner": "Hamdan Ali Muhammad Saeed Al-Ghaithi"
  },
  {
    "id": "9a7d046e-40eb-49c2-9d54-7853c28b1db1",
    "slug": "khadija-muhammad-nour-al-marzouqi-advocates-and-legal-consultants",
    "name": "Khadija Muhammad Nour Al Marzouqi Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEtNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Khadija Muhammad Nour Al Marzouqi Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_9a7d046e-40eb-49c2-9d54-7853c28b1db1",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4659",
    "owner": "Hamdan Muhammad Saleh Salmeen Al-Menhali"
  },
  {
    "id": "d0637f2b-21d1-4ad1-9d5c-68340277bcb7",
    "slug": "hamid-ali-muhammad-hussein-al-mazmi",
    "name": "Hamid Ali Muhammad Hussein Al-Mazmi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Hamid Ali Muhammad Hussein Al-Mazmi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_d0637f2b-21d1-4ad1-9d5c-68340277bcb7",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4113",
    "company": "Hamid Ali Al-Mazmi Advocates and Legal Consultants"
  },
  {
    "id": "885f0275-33f1-4a49-9c59-475e9042be86",
    "slug": "hamid-mubarak-yaqut-mubarak-al-ghafli",
    "name": "Hamid Mubarak Yaqut Mubarak Al-Ghafli",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Hamid Mubarak Yaqut Mubarak Al-Ghafli",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_885f0275-33f1-4a49-9c59-475e9042be86",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2472",
    "company": "Hamid Al-Ghafli Law Firm and Legal Consultations"
  },
  {
    "id": "7b76c76f-5627-44e7-8aa8-fe99e3b47127",
    "slug": "hamid-muhammad-redha-al-ansari",
    "name": "Hamid Muhammad Redha Al Ansari",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Hamid Muhammad Redha Al Ansari",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_7b76c76f-5627-44e7-8aa8-fe99e3b47127",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3679",
    "company": "Hamid Al Ansari Advocates and Legal Consultants"
  },
  {
    "id": "a3e979d2-04af-413e-9a66-650f16a5f5e0",
    "slug": "hamid-muhammad-saleh-ali-al-ali",
    "name": "Hamid Muhammad Saleh Ali Al Ali",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Hamid Muhammad Saleh Ali Al Ali",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_a3e979d2-04af-413e-9a66-650f16a5f5e0",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3804",
    "company": "Kashwani Advocates and Legal Consultants"
  },
  {
    "id": "df3c6a4e-2b85-474b-a395-2ab12e5734fa",
    "slug": "hamid-youssef-rabie-ali",
    "name": "Hamid Youssef Rabie Ali",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Hamid Youssef Rabie Ali",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_df3c6a4e-2b85-474b-a395-2ab12e5734fa",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2187",
    "company": "Hamid Youssef Advocates and Legal Consultants"
  },
  {
    "id": "e1bf8913-1eda-4cd7-bb14-163f582f6bc4",
    "slug": "hanan-ahmed-hassan-ahmed-al-balushi",
    "name": "Hanan Ahmed Hassan Ahmed Al Balushi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Hanan Ahmed Hassan Ahmed Al Balushi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e1bf8913-1eda-4cd7-bb14-163f582f6bc4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3656",
    "company": "Habib Al Hosani Advocates and Legal Consultants"
  },
  {
    "id": "2bff8831-db4e-4af8-bdeb-d8eca333c5b2",
    "slug": "nourhan-abdul-latif-al-zaabi-advocates-and-legal-consultants",
    "name": "Nourhan Abdul Latif Al Zaabi Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE5BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Nourhan Abdul Latif Al Zaabi Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_2bff8831-db4e-4af8-bdeb-d8eca333c5b2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4240",
    "owner": "Hanan Ahmed Hussein Ali Al Balushi"
  },
  {
    "id": "22f3d1e0-735e-4c45-ad77-e2a226ee0c9e",
    "slug": "hanan-salem-law-firm-and-legal-consultations",
    "name": "Hanan Salem Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Hanan Salem Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_22f3d1e0-735e-4c45-ad77-e2a226ee0c9e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "761",
    "owner": "Hanan Salem Hassan Al-Bayd"
  },
  {
    "id": "a53e6813-b0c1-4583-8139-12841f2f53db",
    "slug": "hanan-abdullah-ahmed-saeed-al-marzouqi",
    "name": "Hanan Abdullah Ahmed Saeed Al Marzouqi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Hanan Abdullah Ahmed Saeed Al Marzouqi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_a53e6813-b0c1-4583-8139-12841f2f53db",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4181",
    "company": "Law firm for trial - 2"
  },
  {
    "id": "62329596-1776-4b2f-95a1-f8b29704ae18",
    "slug": "hanan-yahya-ali-law-firm-and-legal-consultations",
    "name": "Hanan Yahya Ali Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhZCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Hanan Yahya Ali Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_62329596-1776-4b2f-95a1-f8b29704ae18",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4075",
    "owner": "Hanan Yahya Ali Boutabtoub"
  },
  {
    "id": "b978a6e6-b79f-44f7-a515-df237724c4d0",
    "slug": "al-afaq-partners-law-office-llc",
    "name": "Al-Afaq & Partners - Law Office LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFQCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Al-Afaq & Partners - Law Office LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_b978a6e6-b79f-44f7-a515-df237724c4d0",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "372, 2525, 2902, 4428",
    "owner": "Houria Matar Juma Rashed Al-Qaidi"
  },
  {
    "id": "42a97ff4-e2de-46d0-9c0b-45c72ec675cf",
    "slug": "the-life-of-muhammad-ibrahim-muhammad-al-naqbi",
    "name": "The life of Muhammad Ibrahim Muhammad Al-Naqbi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: The life of Muhammad Ibrahim Muhammad Al-Naqbi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_42a97ff4-e2de-46d0-9c0b-45c72ec675cf",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4116",
    "company": "Issa Salem Advocates and Legal Consultants"
  },
  {
    "id": "b80d26b8-06a8-40ac-8518-0a6e62eac325",
    "slug": "the-life-of-muhammad-rashid-ali-al-zeyoudi",
    "name": "The life of Muhammad Rashid Ali Al-Zeyoudi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: The life of Muhammad Rashid Ali Al-Zeyoudi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_b80d26b8-06a8-40ac-8518-0a6e62eac325",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4089",
    "company": "Yousef Mohammed Al-Zeyoudi Law Firm and Legal Consultations Office"
  },
  {
    "id": "fecc7cdd-e4cd-4d77-b67b-ed3642fea059",
    "slug": "khaled-ahmed-salem-makhashin",
    "name": "Khaled Ahmed Salem Makhashin",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Khaled Ahmed Salem Makhashin",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_fecc7cdd-e4cd-4d77-b67b-ed3642fea059",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2888",
    "company": "Khaled Makhashin Advocates and Legal Consultants"
  },
  {
    "id": "edc18137-cadd-4e90-aaef-03e9472117db",
    "slug": "khaled-juma-abdullah-mohammed-al-suwaidi",
    "name": "Khaled Juma Abdullah Mohammed Al Suwaidi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Khaled Juma Abdullah Mohammed Al Suwaidi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_edc18137-cadd-4e90-aaef-03e9472117db",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4064",
    "company": "Khaled Juma Al Suwaidi Advocates and Legal Consultants"
  },
  {
    "id": "ef3bca28-5b78-4425-be95-1b33a7933032",
    "slug": "khaled-hassan-saleh-hassan-al-marzouqi",
    "name": "Khaled Hassan Saleh Hassan Al Marzouqi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Khaled Hassan Saleh Hassan Al Marzouqi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_ef3bca28-5b78-4425-be95-1b33a7933032",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4592",
    "company": "Khaled Hassan Al Marzouqi Advocates and Legal Consultants"
  },
  {
    "id": "ca2f4b01-9bb1-4f1f-ac6b-a45bd2eaaf89",
    "slug": "khaled-khalfan-hamad-al-marri",
    "name": "Khaled Khalfan Hamad Al Marri",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Khaled Khalfan Hamad Al Marri",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_ca2f4b01-9bb1-4f1f-ac6b-a45bd2eaaf89",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4119",
    "company": "Khaled Khalfan Al Marri Law Firm and Legal Consultations"
  },
  {
    "id": "22056ecc-59f6-455a-a8dd-f9602b1fdb53",
    "slug": "khaled-khalifa-mohammed-al-hathboor",
    "name": "Khaled Khalifa Mohammed Al Hathboor",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Khaled Khalifa Mohammed Al Hathboor",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_22056ecc-59f6-455a-a8dd-f9602b1fdb53",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3159",
    "company": "Khaled Al Hathboor Law Firm and Legal Consultations"
  },
  {
    "id": "6e056db0-8966-4de0-ab93-a794c5840825",
    "slug": "khaled-saleh-omar-bin-fadl-al-buraiki",
    "name": "Khaled Saleh Omar bin Fadl Al-Buraiki",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Khaled Saleh Omar bin Fadl Al-Buraiki",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_6e056db0-8966-4de0-ab93-a794c5840825",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "186",
    "company": "Khaled Saleh Al Buraiki Law Firm"
  },
  {
    "id": "315081ae-2505-4ddd-97f8-cabeadec2a1e",
    "slug": "khaled-ateeq-ali-mashout-al-marri",
    "name": "Khaled Ateeq Ali Mashout Al Marri",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Khaled Ateeq Ali Mashout Al Marri",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_315081ae-2505-4ddd-97f8-cabeadec2a1e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3123",
    "company": "Khaled Ateeq Al Marri Advocates and Legal Consultants"
  },
  {
    "id": "6aa48101-e019-4e82-bb00-7602c4f8f586",
    "slug": "khaled-ajeel-ali-abdullah-al-junaibi",
    "name": "Khaled Ajeel Ali Abdullah Al-Junaibi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Khaled Ajeel Ali Abdullah Al-Junaibi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_6aa48101-e019-4e82-bb00-7602c4f8f586",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4041",
    "company": "Abdullah Ali Al-Junaibi Advocates and Legal Consultants"
  },
  {
    "id": "b892dbd0-4aae-494e-a7a0-8efddeb2473f",
    "slug": "khaled-ali-ahmed-bin-hammad-al-marri",
    "name": "Khaled Ali Ahmed bin Hammad Al Marri",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Khaled Ali Ahmed bin Hammad Al Marri",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_b892dbd0-4aae-494e-a7a0-8efddeb2473f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4366",
    "company": "Nawal Mohammed Al Badi Law Firm and Legal Consultations"
  },
  {
    "id": "1abe12d7-e0df-4851-933a-7fd844cd4024",
    "slug": "khalid-bin-jamhour-al-ahbabi-law-firm-and-legal-consultations",
    "name": "Khalid bin Jamhour Al Ahbabi Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEtCCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Khalid bin Jamhour Al Ahbabi Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_1abe12d7-e0df-4851-933a-7fd844cd4024",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2311, 3948, 4336, 4386",
    "owner": "Khaled Ali Nasser, Al-Ahbabi fans"
  },
  {
    "id": "71b80646-9a24-4a46-8328-34ed661a176b",
    "slug": "khaled-mubarak-hayya-bin-zayoud-al-shamsi",
    "name": "Khaled Mubarak Hayya bin Zayoud Al Shamsi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Khaled Mubarak Hayya bin Zayoud Al Shamsi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_71b80646-9a24-4a46-8328-34ed661a176b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4579",
    "company": "Eman Mohammed Al Zaabi Advocates and Legal Consultants"
  },
  {
    "id": "0a214265-0091-438b-af11-4238e0ea44b9",
    "slug": "khaled-muhammad-abdullah-al-saroukh",
    "name": "Khaled Muhammad Abdullah Al-Saroukh",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Khaled Muhammad Abdullah Al-Saroukh",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_0a214265-0091-438b-af11-4238e0ea44b9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3231",
    "company": "Khaled Mohammed Al-Saroukh Advocates and Legal Consultants"
  },
  {
    "id": "fc32bc33-723c-449e-a784-53ca879f8aa9",
    "slug": "khaled-mohammed-abdullah-saeed-al-zaabi",
    "name": "Khaled Mohammed Abdullah Saeed Al Zaabi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Khaled Mohammed Abdullah Saeed Al Zaabi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_fc32bc33-723c-449e-a784-53ca879f8aa9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2335",
    "company": "Khaled Al Zaabi Law Firm and Legal Consultations"
  },
  {
    "id": "87573952-1d43-4f0b-96fe-efc536429741",
    "slug": "khadija-saeed-mubarak-mahboob-al-zaabi",
    "name": "Khadija Saeed Mubarak Mahboob Al Zaabi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Khadija Saeed Mubarak Mahboob Al Zaabi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_87573952-1d43-4f0b-96fe-efc536429741",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4551",
    "company": "Obaid Abdullah Al Abri Advocates and Legal Consultants"
  },
  {
    "id": "38021940-3ab8-4598-b0a8-362fcffc5ab5",
    "slug": "khadija-ahmed-muhammad-ali-al-mir",
    "name": "Khadija Ahmed Muhammad Ali Al-Mir",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Khadija Ahmed Muhammad Ali Al-Mir",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_38021940-3ab8-4598-b0a8-362fcffc5ab5",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4356",
    "company": "Khadija Ahmed Al-Mir Law Firm and Legal Consultations Office"
  },
  {
    "id": "fb63f9ac-35f8-4f1b-bc58-7287043054d1",
    "slug": "khadija-muhammad-ali-ahmed-al-hammadi",
    "name": "Khadija Muhammad Ali Ahmed Al Hammadi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Khadija Muhammad Ali Ahmed Al Hammadi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_fb63f9ac-35f8-4f1b-bc58-7287043054d1",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4450",
    "company": "Mohammed Abdullah and Yousef Al Hammadi Advocates and Legal Consultants"
  },
  {
    "id": "63073a4b-60f2-4fbe-a776-fc7d0ddf41dd",
    "slug": "khalfan-khalifa-rashid-sabt-al-shamsi",
    "name": "Khalfan Khalifa Rashid Sabt Al Shamsi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Khalfan Khalifa Rashid Sabt Al Shamsi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_63073a4b-60f2-4fbe-a776-fc7d0ddf41dd",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4463",
    "company": "Nasser Youssef Al-Khamis Law Firm and Legal Consultations"
  },
  {
    "id": "90cbb8d8-04ab-4816-9daa-d8794dda4788",
    "slug": "khalfan-rashid-ahmed-al-murr-al-kaabi",
    "name": "Khalfan Rashid Ahmed Al-Murr Al-Kaabi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Khalfan Rashid Ahmed Al-Murr Al-Kaabi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_90cbb8d8-04ab-4816-9daa-d8794dda4788",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "933",
    "company": "Dr. Khalfan Rashid Al Kaabi Law Firm"
  },
  {
    "id": "5460d49f-8ea6-456b-b9fe-e53526fb1bcf",
    "slug": "kholoud-hamza-ibrahim-al-mallouhi",
    "name": "Kholoud Hamza Ibrahim Al-Mallouhi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Kholoud Hamza Ibrahim Al-Mallouhi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_5460d49f-8ea6-456b-b9fe-e53526fb1bcf",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4138",
    "company": "Obaid Al-Mazmi Advocates and Legal Consultants"
  },
  {
    "id": "9225a179-926f-4e6f-bd41-67032371aed7",
    "slug": "kholoud-khalfan-obaid-ali-al-alayli",
    "name": "Kholoud Khalfan Obaid Ali Al-Alayli",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Kholoud Khalfan Obaid Ali Al-Alayli",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_9225a179-926f-4e6f-bd41-67032371aed7",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4497",
    "company": "Rima Al-Jarashi Advocates and Legal Consultants"
  },
  {
    "id": "6cbebccf-45a9-4fdc-bcc9-ae744c45a53c",
    "slug": "kholoud-saeed-ali-saeed-al-ali",
    "name": "KHALID JUMA ALMAS",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/10/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Kholoud Saeed Ali Saeed Al Ali",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_6cbebccf-45a9-4fdc-bcc9-ae744c45a53c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "L-2144",
    "company": "Kholoud Saeed Advocates and Legal Consultants"
  },
  {
    "id": "039eece1-b3bf-4516-9964-bea128df26ad",
    "slug": "araa-group-for-advocates-and-legal-consultations",
    "name": "Araa Group for Advocates and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFHCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Araa Group for Advocates and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_039eece1-b3bf-4516-9964-bea128df26ad",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4007, 4469",
    "owner": "Kholoud Saeed Mohammed Al-Shibli"
  },
  {
    "id": "47a764a8-78ac-4b72-86d2-46a1be49f021",
    "slug": "khalifa-rashid-hassan-ahmed-al-salman",
    "name": "Khalifa Rashid Hassan Ahmed Al-Salman",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Khalifa Rashid Hassan Ahmed Al-Salman",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_47a764a8-78ac-4b72-86d2-46a1be49f021",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "713",
    "company": "Al-Salman Advocates and Legal Consultants"
  },
  {
    "id": "f645419a-fb2c-4ac2-8617-5d94a70552c7",
    "slug": "khalifa-mohin-bakhit-mubarak-al-taniji",
    "name": "Khalifa Mohin Bakhit Mubarak Al-Taniji",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Khalifa Mohin Bakhit Mubarak Al-Taniji",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_f645419a-fb2c-4ac2-8617-5d94a70552c7",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "1365",
    "company": "Arab International Law Firm and Legal Consultations"
  },
  {
    "id": "7bc15230-46e5-4349-879f-c5ac7eec7bc6",
    "slug": "khalifa-khalfan-salem-muftah-al-mansouri",
    "name": "Khalifa Khalfan Salem Muftah Al Mansouri",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Khalifa Khalfan Salem Muftah Al Mansouri",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_7bc15230-46e5-4349-879f-c5ac7eec7bc6",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3874",
    "company": "Sheikha Saqr Al Mansouri & Partners Advocates and Legal Consultants"
  },
  {
    "id": "e35a1994-47f9-4074-9921-c761e6b7abeb",
    "slug": "khalifa-al-wahedi-law-firm-and-legal-consultations",
    "name": "Khalifa Al Wahedi Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEtBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Khalifa Al Wahedi Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e35a1994-47f9-4074-9921-c761e6b7abeb",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4596",
    "owner": "Khalifa Salem Awad Mohsen Al-Wahidi"
  },
  {
    "id": "12662c70-c023-4998-83ae-3c891ca65b36",
    "slug": "khalifa-abdul-rahman-al-sayyid-ibrahim-al-sada",
    "name": "Khalifa Abdul Rahman Al-Sayyid Ibrahim Al-Sada",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Khalifa Abdul Rahman Al-Sayyid Ibrahim Al-Sada",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_12662c70-c023-4998-83ae-3c891ca65b36",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2975",
    "company": "Khalifa Al Sada Law Firm and Legal Consultations"
  },
  {
    "id": "44d643bd-2a92-4e94-a60c-a2fefe8cda64",
    "slug": "his-successor-abdullah-muhammad-al-maftul-al-nuaimi",
    "name": "His successor, Abdullah Muhammad Al-Maftul Al-Nuaimi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: His successor, Abdullah Muhammad Al-Maftul Al-Nuaimi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_44d643bd-2a92-4e94-a60c-a2fefe8cda64",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "173",
    "company": "Khalifa Al-Maftool Advocates and Legal Consultants"
  },
  {
    "id": "9854d006-0cba-4d9d-8448-3e59861d7522",
    "slug": "khalil-khader-ali-al-abadi-al-mansouri",
    "name": "Khalil Khader Ali Al-Abadi Al-Mansouri",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Khalil Khader Ali Al-Abadi Al-Mansouri",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_9854d006-0cba-4d9d-8448-3e59861d7522",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "384",
    "company": "Creativity Law Firm and Legal Consultations"
  },
  {
    "id": "24d16cf4-8de4-4eac-a9fd-e2d674ea2812",
    "slug": "khamis-rashid-khamis-al-mukhaini-al-junaibi",
    "name": "KHOULA RASHID MURAD AL BALUSHI",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/11/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Khamis Rashid Khamis Al-Mukhaini Al-Junaibi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_24d16cf4-8de4-4eac-a9fd-e2d674ea2812",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "L-2051",
    "company": "Nawal Salem Saeed Advocates and Legal Consultants"
  },
  {
    "id": "7f2043aa-dbde-40d8-a39d-711f2275b828",
    "slug": "khamis-salem-saeed-al-dhaheri",
    "name": "Khamis Salem Saeed Al Dhaheri",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Khamis Salem Saeed Al Dhaheri",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_7f2043aa-dbde-40d8-a39d-711f2275b828",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2807",
    "company": "Khamis Al Dhaheri Law Firm and Legal Consultations"
  },
  {
    "id": "65187b3b-6b37-4c84-a4c5-b2da0d25f491",
    "slug": "khamis-saeed-khalfan-saeed-al-kaabi",
    "name": "Khamis Saeed Khalfan Saeed Al Kaabi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Khamis Saeed Khalfan Saeed Al Kaabi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_65187b3b-6b37-4c84-a4c5-b2da0d25f491",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3013",
    "company": "Dr. Adnan Mohammed Al Hammadi's office"
  },
  {
    "id": "feb1c031-8e4d-4ff5-b61f-179535e272e5",
    "slug": "sarah-al-saadi-advocates-and-legal-consultations-llc",
    "name": "Sarah Al-Saadi Advocates and Legal Consultations LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Sarah Al-Saadi Advocates and Legal Consultations LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_feb1c031-8e4d-4ff5-b61f-179535e272e5",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4507",
    "owner": "Khamis Obaid Muhammad Khamis Al Zaabi"
  },
  {
    "id": "12ff015f-0669-4c4b-a6c9-a5c0e45527f3",
    "slug": "khawla-thani-mohammed-saif-al-muhairi",
    "name": "Khawla Thani Mohammed Saif Al Muhairi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Khawla Thani Mohammed Saif Al Muhairi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_12ff015f-0669-4c4b-a6c9-a5c0e45527f3",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3897",
    "company": "Khawla Al Muhairi Advocates and Legal Consultants"
  },
  {
    "id": "4a384984-1085-43d9-8da3-4c779622d376",
    "slug": "khawla-muhammad-yahya-ismail-al-balushi",
    "name": "Khawla Muhammad Yahya Ismail Al Balushi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Khawla Muhammad Yahya Ismail Al Balushi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_4a384984-1085-43d9-8da3-4c779622d376",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4304",
    "company": "Youssef Al Hammadi Advocates and Legal Consultants"
  },
  {
    "id": "afda5abc-e950-4e20-9b25-a435bda27301",
    "slug": "his-uncle-ahmed-muhammad-dimas-al-suwaidi",
    "name": "His uncle, Ahmed Muhammad Dimas Al-Suwaidi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIVQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: His uncle, Ahmed Muhammad Dimas Al-Suwaidi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_afda5abc-e950-4e20-9b25-a435bda27301",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4144",
    "company": "Ahmed Hamid Al Balushi Advocates and Legal Consultants"
  },
  {
    "id": "942f50d0-9be6-4513-b2c8-1971b025fe8c",
    "slug": "rashid-dimas-al-suwaidi-advocates-and-legal-consultants",
    "name": "Rashid Dimas Al Suwaidi Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFJECiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Rashid Dimas Al Suwaidi Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_942f50d0-9be6-4513-b2c8-1971b025fe8c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4546",
    "owner": "Khawla Saeed Muhammad Basis Al-Taniji"
  },
  {
    "id": "3efd19b2-f8f5-4d34-83cc-1ef4c2e4a510",
    "slug": "awad-al-eryani-advocates-and-legal-consultations-llc",
    "name": "Awad Al-Eryani Advocates and Legal Consultations LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Awad Al-Eryani Advocates and Legal Consultations LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_3efd19b2-f8f5-4d34-83cc-1ef4c2e4a510",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2368, 4076",
    "owner": "Dr. Abdullah Mabkhout Salem Mohammed Al Rashidi"
  },
  {
    "id": "91eca399-5372-4d2c-aa2e-1ed3b5596a2b",
    "slug": "dr-mohammed-al-hammadi-advocates-and-legal-consultants-dubai",
    "name": "Dr. Mohammed Al Hammadi Advocates and Legal Consultants - Dubai",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Dr. Mohammed Al Hammadi Advocates and Legal Consultants - Dubai",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_91eca399-5372-4d2c-aa2e-1ed3b5596a2b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "74",
    "owner": "Dr. Jassim Ali Salem Nasser Al Shamsi"
  },
  {
    "id": "4a4eab3e-c644-409c-ade1-cd484083b073",
    "slug": "dana-sabah-muhammad-hassan",
    "name": "Dana Sabah Muhammad Hassan",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Dana Sabah Muhammad Hassan",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_4a4eab3e-c644-409c-ade1-cd484083b073",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "805",
    "company": "Mona Al-Sabbagh Advocates and Legal Consultants"
  },
  {
    "id": "d8b02520-4d5f-41b9-9dd8-050e85c57eb2",
    "slug": "darwish-muhammad-ali-al-rumaithi-law-firm",
    "name": "Darwish Muhammad Ali Al Rumaithi Law Firm",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIERNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Darwish Muhammad Ali Al Rumaithi Law Firm",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_d8b02520-4d5f-41b9-9dd8-050e85c57eb2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "77",
    "owner": "Darwish Muhammad Ali Al-Rumaithi"
  },
  {
    "id": "e26ff82a-69ef-435e-8c16-59dc44139383",
    "slug": "dalmouk-muhammad-humaid-bin-dalmouk",
    "name": "Dalmouk Muhammad Humaid bin Dalmouk",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBETQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Dalmouk Muhammad Humaid bin Dalmouk",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e26ff82a-69ef-435e-8c16-59dc44139383",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "40",
    "company": "Dalmouk Mohammed Dalmouk Lawyers and Legal Consultants/Dubai"
  },
  {
    "id": "b8571997-a3db-43f2-be1f-cc14c33be667",
    "slug": "memory-of-sultan-muhammad-salem-al-madhani",
    "name": "Memory of Sultan Muhammad Salem Al Madhani",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Memory of Sultan Muhammad Salem Al Madhani",
    "consultationFee": 400,
    "emirate": "Sharjah",
    "verified": true,
    "offices": [
      {
        "id": "office_b8571997-a3db-43f2-be1f-cc14c33be667",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Sharjah",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3625",
    "company": "Al-Hamad Advocates and Legal Consultants / Sharjah"
  },
  {
    "id": "a8f2f796-931d-4a78-9f53-e7730c8209bf",
    "slug": "rashid-ahmed-ghareeb-howishal-al-saridi",
    "name": "Rashid Ahmed Ghareeb Howishal Al-Saridi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Rashid Ahmed Ghareeb Howishal Al-Saridi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_a8f2f796-931d-4a78-9f53-e7730c8209bf",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3770",
    "company": "Rashid Ahmed Al-Saridi Advocates and Legal Consultants"
  },
  {
    "id": "8348c0fa-c842-494a-85f8-02c2adf5c6ef",
    "slug": "rashid-ahmed-rashid-ahmed-al-shehhi",
    "name": "Rashid Ahmed Rashid Ahmed Al Shehhi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Rashid Ahmed Rashid Ahmed Al Shehhi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_8348c0fa-c842-494a-85f8-02c2adf5c6ef",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4437",
    "company": "Dr. Zubaida Jassim Al-Mazmi Advocates and Legal Consultants"
  },
  {
    "id": "c40b96b0-d846-4154-9c55-3864d9559d61",
    "slug": "rashid-ahmed-obaid-dimas-al-suwaidi",
    "name": "Rashid Ahmed Obaid Dimas Al Suwaidi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Rashid Ahmed Obaid Dimas Al Suwaidi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c40b96b0-d846-4154-9c55-3864d9559d61",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3009",
    "company": "Rashid Dimas Al Suwaidi Advocates and Legal Consultants"
  },
  {
    "id": "cc45c52b-a4f0-442c-87dc-8593a02c38f0",
    "slug": "fahd-bin-rashid-al-sarkal-law-firm-and-legal-consultations",
    "name": "Fahd bin Rashid Al Sarkal Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEZCCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Fahd bin Rashid Al Sarkal Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_cc45c52b-a4f0-442c-87dc-8593a02c38f0",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2764, 4137, 4489",
    "owner": "Rashid Hassan Ibrahim Ahmed"
  },
  {
    "id": "54535c24-8355-4dd1-a8ed-7546da06c7da",
    "slug": "rashid-hassan-rashid-al-hammadi",
    "name": "Rashid Hassan Rashid Al Hammadi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Rashid Hassan Rashid Al Hammadi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_54535c24-8355-4dd1-a8ed-7546da06c7da",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4024",
    "company": "Rashid Hassan Al Hammadi Advocates and Legal Consultants"
  },
  {
    "id": "b0915a26-015f-481a-b6e8-14dd27105ac1",
    "slug": "rashid-saeed-rashid-ali-al-shehhi",
    "name": "ALI MOHAMED ALI",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/12/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Rashid Saeed Rashid Ali Al Shehhi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_b0915a26-015f-481a-b6e8-14dd27105ac1",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "L-1606",
    "company": "Rashed Al Shehhi Advocates and Legal Consultants"
  },
  {
    "id": "9e38b36b-c6e4-45d4-bdd7-cf5c48ea5675",
    "slug": "rashid-saeed-salem-bin-suwaidan-al-suwaidi",
    "name": "Rashid Saeed Salem bin Suwaidan Al Suwaidi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Rashid Saeed Salem bin Suwaidan Al Suwaidi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_9e38b36b-c6e4-45d4-bdd7-cf5c48ea5675",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2303",
    "company": "Bin Suwaidan Law Firm and Legal Consultations"
  },
  {
    "id": "5231edd6-222a-4268-8f3a-52fa48eebbfa",
    "slug": "rashid-sultan-rashid-sultan-al-kaitoub",
    "name": "Rashid Sultan Rashid Sultan Al Kaitoub",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Rashid Sultan Rashid Sultan Al Kaitoub",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_5231edd6-222a-4268-8f3a-52fa48eebbfa",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2234",
    "company": "Rashid Al Kaitoub Advocates and Legal Consultants"
  },
  {
    "id": "d6ce3136-0373-4686-aa9a-7dea8fcc86a4",
    "slug": "rashid-saif-saeed-al-zubadi-al-ali",
    "name": "Rashid Saif Saeed Al-Zubadi Al Ali",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Rashid Saif Saeed Al-Zubadi Al Ali",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_d6ce3136-0373-4686-aa9a-7dea8fcc86a4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "814",
    "company": "Rashid Saif Advocates and Legal Consultants"
  },
  {
    "id": "84d81680-6470-4f36-b4b2-40a73263a87b",
    "slug": "rashid-abbas-dadiyah-rubari",
    "name": "Rashid Abbas Dadiyah Rubari",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Rashid Abbas Dadiyah Rubari",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_84d81680-6470-4f36-b4b2-40a73263a87b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3621",
    "company": "Rashid Abbas Advocates and Legal Consultants"
  },
  {
    "id": "8a136a65-c98b-4362-bb24-bc31dc8cc8bd",
    "slug": "rashid-abdullah-hassan-aboud-al-hafiti",
    "name": "Rashid Abdullah Hassan Aboud Al-Hafiti",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Rashid Abdullah Hassan Aboud Al-Hafiti",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_8a136a65-c98b-4362-bb24-bc31dc8cc8bd",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3492",
    "company": "Rashid Abdullah Al-Hafiti Advocates and Legal Consultants"
  },
  {
    "id": "757cac0d-a1eb-4d1a-b6cd-f8e45a4f8937",
    "slug": "rashid-abdullah-ali-al-nuaimi",
    "name": "Rashid Abdullah Ali Al Nuaimi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Rashid Abdullah Ali Al Nuaimi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_757cac0d-a1eb-4d1a-b6cd-f8e45a4f8937",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2238",
    "company": "Rashid Al Nuaimi Law Firm and Legal Consultations"
  },
  {
    "id": "197eb4a7-915d-4ec4-9489-a144d447c8f4",
    "slug": "international-accreditation-center-for-advocates-and-legal-consultations",
    "name": "International Accreditation Center for Advocates and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIElBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: International Accreditation Center for Advocates and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_197eb4a7-915d-4ec4-9489-a144d447c8f4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "508",
    "owner": "Rashid Obaid Saif Hammad Al-Hafiti"
  },
  {
    "id": "00dbb559-24f1-481f-895c-597e3e62fca5",
    "slug": "rashid-ali-arshoud-al-khanbouli-al-shehhi",
    "name": "Rashid Ali Arshoud Al-Khanbouli Al-Shehhi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Rashid Ali Arshoud Al-Khanbouli Al-Shehhi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_00dbb559-24f1-481f-895c-597e3e62fca5",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2854",
    "company": "Alpha Law Firm and Legal Consultations"
  },
  {
    "id": "a3ff82c4-a2d2-4671-8871-2a2d12b910ff",
    "slug": "rashid-ali-muhammad-al-harithi-al-naqbi",
    "name": "Rashid Ali Muhammad Al-Harithi Al-Naqbi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Rashid Ali Muhammad Al-Harithi Al-Naqbi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_a3ff82c4-a2d2-4671-8871-2a2d12b910ff",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2520",
    "company": "Rashid Al Naqbi Advocates and Legal Consultants"
  },
  {
    "id": "5db01860-de3c-4d63-b1cc-b3b268deaae2",
    "slug": "rashid-mohammed-saeed-bujasim",
    "name": "Rashid Mohammed Saeed Bujasim",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Rashid Mohammed Saeed Bujasim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5db01860-de3c-4d63-b1cc-b3b268deaae2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "13",
    "company": "Bujasim and Al-Maliki Lawyers and Legal Consultants / Dubai"
  },
  {
    "id": "b30e4d4d-d4ec-4d87-a275-46f9b11e9e71",
    "slug": "rashid-mohammed-abdullah-saeed-lootah",
    "name": "Rashid Mohammed Abdullah Saeed Lootah",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Rashid Mohammed Abdullah Saeed Lootah",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_b30e4d4d-d4ec-4d87-a275-46f9b11e9e71",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2752",
    "company": "Rashid Lootah Advocates and Legal Consultants"
  },
  {
    "id": "324d8019-fc30-4f56-88e3-e709ed00c986",
    "slug": "rashid-mohammed-abdullah-mohammed-al-hafiti",
    "name": "Rashid Mohammed Abdullah Mohammed Al-Hafiti",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Rashid Mohammed Abdullah Mohammed Al-Hafiti",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_324d8019-fc30-4f56-88e3-e709ed00c986",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2591",
    "company": "Rashid Mohammed Al-Hafiti Advocates and Legal Consultants"
  },
  {
    "id": "77428684-3e2b-455d-9427-e905fcf68135",
    "slug": "al-rasheed-and-partners-advocates-and-legal-consultants",
    "name": "Al-Rasheed and Partners Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFQCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Al-Rasheed and Partners Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_77428684-3e2b-455d-9427-e905fcf68135",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "163",
    "owner": "Rashid Muhammad Ali Muhammad Al-Rashid"
  },
  {
    "id": "749f73ae-b378-43e7-85fc-f7ecf0b7563d",
    "slug": "raya-salem-suhail-al-ameri",
    "name": "Raya Salem Suhail Al Ameri",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Raya Salem Suhail Al Ameri",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_749f73ae-b378-43e7-85fc-f7ecf0b7563d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3236",
    "company": "Raya Al Ameri Law Firm and Legal Consultations"
  },
  {
    "id": "5df0470a-1597-4bbb-b8b3-b01c2c41e11c",
    "slug": "rabia-abdel-rahman-law-firm-and-legal-consultations",
    "name": "Rabia Abdel Rahman Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFJBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Rabia Abdel Rahman Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_5df0470a-1597-4bbb-b8b3-b01c2c41e11c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2324",
    "owner": "Rabia Abdel Rahman Mahboob"
  },
  {
    "id": "879cfd51-b072-46c8-a5ce-ce86dab24838",
    "slug": "raja-abdullah-hamad-al-hadfi-al-ketbi",
    "name": "Raja Abdullah Hamad Al-Hadfi Al-Ketbi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Raja Abdullah Hamad Al-Hadfi Al-Ketbi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_879cfd51-b072-46c8-a5ce-ce86dab24838",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4280",
    "company": "Ghanem Al Muhairi Advocates and Legal Consultants"
  },
  {
    "id": "2e08ca2a-f293-41da-8662-098cccd21e37",
    "slug": "rafia-saeed-ali-salem-al-shehhi",
    "name": "Rafia Saeed Ali Salem Al Shehhi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Rafia Saeed Ali Salem Al Shehhi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_2e08ca2a-f293-41da-8662-098cccd21e37",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4484",
    "company": "Abeer Al-Dahmani Law Firm and Legal Consultations"
  },
  {
    "id": "9cc40eb9-8b73-4d0e-a8b1-c848e6e1d8e8",
    "slug": "mohammed-al-balushi-and-ruqaya-ali-law-firm",
    "name": "Mohammed Al Balushi and Ruqaya Ali Law Firm",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Mohammed Al Balushi and Ruqaya Ali Law Firm",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_9cc40eb9-8b73-4d0e-a8b1-c848e6e1d8e8",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2765",
    "owner": "Ruqaya Ali Muhammad Baghi"
  },
  {
    "id": "af5e46e3-c05c-4c40-a299-fd1b2280dcfa",
    "slug": "ruqaya-muhammad-ali-abdullah-al-janahi",
    "name": "Ruqaya Muhammad Ali Abdullah Al Janahi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ruqaya Muhammad Ali Abdullah Al Janahi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_af5e46e3-c05c-4c40-a299-fd1b2280dcfa",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3424",
    "company": "Ruqaya Mohammed Al Janahi Advocates and Legal Consultants"
  },
  {
    "id": "58f5b13f-9293-4e64-9cfd-d36a8f8bac36",
    "slug": "ramadan-kareem-bakhsh-al-balushi",
    "name": "Ramadan Kareem Bakhsh Al Balushi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ramadan Kareem Bakhsh Al Balushi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_58f5b13f-9293-4e64-9cfd-d36a8f8bac36",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4618",
    "company": "Ramadan Karim Al Balushi Advocates and Legal Consultants"
  },
  {
    "id": "8dd43ca5-20a6-4003-8225-3e279a70484f",
    "slug": "rana-louay-saadi-hussein-al-qadiri",
    "name": "Rana Louay Saadi Hussein Al-Qadiri",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Rana Louay Saadi Hussein Al-Qadiri",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_8dd43ca5-20a6-4003-8225-3e279a70484f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4581",
    "company": "Marwa Al Riyami Advocates and Legal Consultants"
  },
  {
    "id": "aeeb081d-a159-44ac-bfed-c01d98593e35",
    "slug": "bin-haider-law-firm-and-legal-consultations",
    "name": "Bin Haider Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEJICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Bin Haider Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_aeeb081d-a159-44ac-bfed-c01d98593e35",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4701",
    "owner": "Randa Ali Muhammad Bawazir"
  },
  {
    "id": "7335ab9f-4a6a-47ab-89f6-816f964a9db8",
    "slug": "halima-al-marzouqi-and-associates-are-lawyers-and-legal-consultants",
    "name": "Halima Al Marzouqi and Associates are lawyers and legal consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Halima Al Marzouqi and Associates are lawyers and legal consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_7335ab9f-4a6a-47ab-89f6-816f964a9db8",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "1836, 2994, 3418",
    "owner": "Abdulaziz Abdulrahman Fouladh Kindergarten"
  },
  {
    "id": "ee367c07-a69c-447a-b00e-2ec3daa2192b",
    "slug": "dr-rayasa-abdel-rahman-advocates-and-legal-consultants-llc",
    "name": "Dr. Rayasa Abdel Rahman Advocates and Legal Consultants LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFJBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Dr. Rayasa Abdel Rahman Advocates and Legal Consultants LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_ee367c07-a69c-447a-b00e-2ec3daa2192b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3397",
    "owner": "Headed by Abdul Rahman Saeed Ahmed"
  },
  {
    "id": "066394fd-3595-4ad2-882e-35df07585e20",
    "slug": "ali-habib-and-partners-advocates-and-legal-consultants",
    "name": "Ali Habib and Partners Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Ali Habib and Partners Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_066394fd-3595-4ad2-882e-35df07585e20",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3921",
    "owner": "Riyasa Dhigham Katami"
  },
  {
    "id": "a789ee1c-01df-49f6-8e4e-50110be6e0eb",
    "slug": "mohammed-al-marzouqi-advocates-and-legal-consultants",
    "name": "Mohammed Al Marzouqi Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Mohammed Al Marzouqi Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_a789ee1c-01df-49f6-8e4e-50110be6e0eb",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "81, 2112",
    "owner": "Riyad Muhammad Sharif Al-Shaibani"
  },
  {
    "id": "7b0c7975-6f86-4dfb-905f-3e552efaae3b",
    "slug": "reed-al-dhaheri-advocates-and-legal-consultants-llc",
    "name": "Reed Al Dhaheri Advocates and Legal Consultants LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFJBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Reed Al Dhaheri Advocates and Legal Consultants LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_7b0c7975-6f86-4dfb-905f-3e552efaae3b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2877",
    "owner": "Reid Hamad Khamis Al-Sheriani Al-Dhaheri"
  },
  {
    "id": "51809d9c-30a7-4bba-9fce-7b50df1c6744",
    "slug": "reem-saleh-advocates-and-legal-consultations-llc",
    "name": "Reem Saleh Advocates and Legal Consultations LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFJTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Reem Saleh Advocates and Legal Consultations LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_51809d9c-30a7-4bba-9fce-7b50df1c6744",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2590",
    "owner": "Reem Saleh Mahdi"
  },
  {
    "id": "1ec2f2d1-66b9-4f04-8c79-bb6c007ff6dc",
    "slug": "reem-abdullah-ahmed-mohammed-al-hammadi",
    "name": "Reem Abdullah Ahmed Mohammed Al Hammadi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Reem Abdullah Ahmed Mohammed Al Hammadi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_1ec2f2d1-66b9-4f04-8c79-bb6c007ff6dc",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4140",
    "company": "Mohammed Al Hashemi Advocates and Legal Consultants"
  },
  {
    "id": "0e3d6e00-f7f3-4907-b6bd-1abdd74bf189",
    "slug": "zainab-al-balushi-and-sheikha-al-alawi-advocates-and-legal-consultants",
    "name": "Zainab Al Balushi and Sheikha Al Alawi Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFpBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Zainab Al Balushi and Sheikha Al Alawi Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_0e3d6e00-f7f3-4907-b6bd-1abdd74bf189",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3089, 4578",
    "owner": "Reem Ali Ahmed Al-Afrit, Kuwaiti"
  },
  {
    "id": "bcbd7d5e-aa68-445f-9d66-6d73e5072ea5",
    "slug": "reem-emad-el-din-abdel-qader-ali",
    "name": "Reem Emad El-Din Abdel Qader Ali",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Reem Emad El-Din Abdel Qader Ali",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_bcbd7d5e-aa68-445f-9d66-6d73e5072ea5",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4453",
    "company": "Ali Muhammad Al-Eter Law Firm and Legal Consultations"
  },
  {
    "id": "c81c9334-c9b7-49d7-b85a-fdaf6b053638",
    "slug": "abdulaziz-al-ameri-law-firm-and-legal-consultations",
    "name": "Abdulaziz Al Ameri Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Abdulaziz Al Ameri Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c81c9334-c9b7-49d7-b85a-fdaf6b053638",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "34, 4063",
    "owner": "Reem Awad Al-Abd Ali Al-Amiri"
  },
  {
    "id": "287f99c2-4c82-41c5-9538-8580e91b0e94",
    "slug": "rima-yousef-obaid-abdullah-al-balushi",
    "name": "WALID ALI ABDULLA KAMALI",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/01/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Rima Yousef Obaid Abdullah Al Balushi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_287f99c2-4c82-41c5-9538-8580e91b0e94",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "L-2064",
    "company": "Middle East Law Firm"
  },
  {
    "id": "a6b424f9-32ac-43e4-82d2-524528b8a12c",
    "slug": "zayed-saad-abdullah-ali-al-minhali",
    "name": "Zayed Saad Abdullah Ali Al-Minhali",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Zayed Saad Abdullah Ali Al-Minhali",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_a6b424f9-32ac-43e4-82d2-524528b8a12c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3981",
    "company": "Nujoud Bin Haider Advocates and Legal Consultants"
  },
  {
    "id": "bfc78553-51de-45ac-91a5-567f78d73247",
    "slug": "zayed-ali-talib-al-khulaifi",
    "name": "Zayed Ali Talib Al-Khulaifi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Zayed Ali Talib Al-Khulaifi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_bfc78553-51de-45ac-91a5-567f78d73247",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3910",
    "company": "Zayed Ali Al-Khulaifi Advocates and Legal Consultants"
  },
  {
    "id": "87d9ec30-ba11-46dc-9a1c-c866a357b421",
    "slug": "zayed-mattar-khamis-khalfan-al-mazrouei",
    "name": "Zayed Mattar Khamis Khalfan Al Mazrouei",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Zayed Mattar Khamis Khalfan Al Mazrouei",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_87d9ec30-ba11-46dc-9a1c-c866a357b421",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4288",
    "company": "Zayed Al Mazrouei Advocates and Legal Consultants"
  },
  {
    "id": "b4b2dee5-f1db-4391-b56b-18a45d1b0fb6",
    "slug": "zubaida-mubarak-bin-hindi",
    "name": "Zubaida Mubarak bin Hindi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Zubaida Mubarak bin Hindi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_b4b2dee5-f1db-4391-b56b-18a45d1b0fb6",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3801",
    "company": "Zubaida Bin Hindi Advocates and Legal Consultants"
  },
  {
    "id": "d012460d-aa7e-40fd-9560-b1194d4b676a",
    "slug": "zulekha-hassan-ahmed-al-hosani",
    "name": "Zulekha Hassan Ahmed Al Hosani",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Zulekha Hassan Ahmed Al Hosani",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_d012460d-aa7e-40fd-9560-b1194d4b676a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4185",
    "company": "Zulekha Hassan Al Hosani Advocates and Legal Consultants - One Person Company LLC"
  },
  {
    "id": "965073be-da36-4d05-b937-a8e382919b6c",
    "slug": "zahra-azza-idris-abu-taj",
    "name": "Zahra Azza Idris Abu Taj",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Zahra Azza Idris Abu Taj",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_965073be-da36-4d05-b937-a8e382919b6c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2458",
    "company": "Zahra Idris Law Firm and Legal Consultations"
  },
  {
    "id": "18f0d6be-9129-48a1-861d-7f2e023c58a9",
    "slug": "ziad-abdullah-ibrahim-galadari",
    "name": "Ziad Abdullah Ibrahim Galadari",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ziad Abdullah Ibrahim Galadari",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_18f0d6be-9129-48a1-861d-7f2e023c58a9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "89",
    "company": "Galadari Lawyers and Legal Consultants Sole Proprietorship LLC - Dubai"
  },
  {
    "id": "09370bca-0046-4b5f-bddd-1e164c082b91",
    "slug": "zainab-abdul-rahman-obaid-al-raisi",
    "name": "Zainab Abdul Rahman Obaid Al-Raisi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Zainab Abdul Rahman Obaid Al-Raisi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_09370bca-0046-4b5f-bddd-1e164c082b91",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4342",
    "company": "Awatef Mohamed Shawqi Law Firm, Legal Consultations"
  },
  {
    "id": "5abe4b85-bd6d-4b89-970a-b9e9ace92430",
    "slug": "ahmed-al-mazmi-advocates-and-legal-consultants",
    "name": "Ahmed Al-Mazmi Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Ahmed Al-Mazmi Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_5abe4b85-bd6d-4b89-970a-b9e9ace92430",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2986",
    "owner": "Zainab Ali Issa"
  },
  {
    "id": "96df06cf-2a21-4d05-a32a-ca9eabb3c471",
    "slug": "zainab-qul-zar-ali-dabraldin-al-balushi",
    "name": "Zainab Qul Zar Ali Dabraldin Al Balushi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaUQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Zainab Qul Zar Ali Dabraldin Al Balushi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_96df06cf-2a21-4d05-a32a-ca9eabb3c471",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3953",
    "company": "Zainab Al Balushi and Sheikha Al Alawi Advocates and Legal Consultants"
  },
  {
    "id": "62914137-d037-40f7-b1b0-aea53d311c4c",
    "slug": "abdul-rahman-al-ameri-advocates-and-legal-consultations-llc",
    "name": "Abdul Rahman Al Ameri Advocates and Legal Consultations LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFSCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Abdul Rahman Al Ameri Advocates and Legal Consultations LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_62914137-d037-40f7-b1b0-aea53d311c4c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4011, 4248",
    "owner": "Sarah Juma Saeed Khalifa Al Kaabi"
  },
  {
    "id": "8e5b42a9-6d0e-462a-9ca0-1e52852a4a13",
    "slug": "sarah-shah-baig-mohammed-al-balushi",
    "name": "Sarah Shah Baig Mohammed Al Balushi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Sarah Shah Baig Mohammed Al Balushi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_8e5b42a9-6d0e-462a-9ca0-1e52852a4a13",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "358",
    "company": "Sarah Law Firm and Legal Consultations"
  },
  {
    "id": "6211f5f2-1cd9-4b90-abca-8c9f0a11fae0",
    "slug": "sarah-abdul-rahman-abdul-aziz-abdul-karim-al-dosari",
    "name": "Sarah Abdul Rahman Abdul Aziz Abdul Karim Al Dosari",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Sarah Abdul Rahman Abdul Aziz Abdul Karim Al Dosari",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_6211f5f2-1cd9-4b90-abca-8c9f0a11fae0",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4397",
    "company": "Saeed Al Rashidi Advocates and Legal Consultants"
  },
  {
    "id": "3d754481-2aae-44f9-918d-c4ab3f4dbcba",
    "slug": "sarah-abdullah-ghanem-ahmed-abdul-qader",
    "name": "Sarah Abdullah Ghanem Ahmed Abdul Qader",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Sarah Abdullah Ghanem Ahmed Abdul Qader",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_3d754481-2aae-44f9-918d-c4ab3f4dbcba",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3501",
    "company": "Abdullah Al-Obaidly Advocates and Legal Consultants"
  },
  {
    "id": "45f9ea45-1109-4e5b-a3ad-0949e5ea9deb",
    "slug": "salem-khamis-al-yamahi-advocates-and-legal-consultations-llc",
    "name": "Salem Khamis Al Yamahi Advocates and Legal Consultations LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNLCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Salem Khamis Al Yamahi Advocates and Legal Consultations LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_45f9ea45-1109-4e5b-a3ad-0949e5ea9deb",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2535, 3768",
    "owner": "Sarah Matar Ahmed Ghaith Al Suwaidi"
  },
  {
    "id": "fba540ff-5d3e-4965-836c-03e286f12baf",
    "slug": "sarah-hilal-suleiman-salem-al-saadi",
    "name": "Sarah Hilal Suleiman Salem Al-Saadi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Sarah Hilal Suleiman Salem Al-Saadi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_fba540ff-5d3e-4965-836c-03e286f12baf",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2331",
    "company": "Sarah Al-Saadi Advocates and Legal Consultations LLC"
  },
  {
    "id": "f249819a-1c0b-4554-9af8-96c95086687b",
    "slug": "sarah-ibrahim-ali-ahmed",
    "name": "Sarah Ibrahim Ali Ahmed",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Sarah Ibrahim Ali Ahmed",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_f249819a-1c0b-4554-9af8-96c95086687b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3155",
    "company": "Sarah Ibrahim Advocates and Legal Consultants"
  },
  {
    "id": "cc49b5ad-f37a-4446-a347-6df2dbbc48f1",
    "slug": "sarah-hassan-issa-ali-al-balushi",
    "name": "Sarah Hassan Issa Ali Al Balushi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Sarah Hassan Issa Ali Al Balushi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_cc49b5ad-f37a-4446-a347-6df2dbbc48f1",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4519",
    "company": "Muhammad Al-Lingawi Law Firm and Legal Consultations"
  },
  {
    "id": "0eb566d2-6c24-4a77-acad-a8adefb0a3c7",
    "slug": "sarah-abdel-hamid-muhammad-ismail-al-askar",
    "name": "Sarah Abdel Hamid Muhammad Ismail Al-Askar",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Sarah Abdel Hamid Muhammad Ismail Al-Askar",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_0eb566d2-6c24-4a77-acad-a8adefb0a3c7",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4158",
    "company": "Gulf Consultant for Law and Legal Consultations"
  },
  {
    "id": "5a180346-7369-46f6-bc35-120cbd0fe41a",
    "slug": "sarah-abdel-moneim-salem-bin-suwaidan-al-suwaidi",
    "name": "Sarah Abdel Moneim Salem bin Suwaidan Al Suwaidi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Sarah Abdel Moneim Salem bin Suwaidan Al Suwaidi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_5a180346-7369-46f6-bc35-120cbd0fe41a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4390",
    "company": "Bin Suwaidan Law Firm and Legal Consultations"
  },
  {
    "id": "3b559ddc-def9-4ecb-bf4d-cf3cd8eb2878",
    "slug": "al-maidour-advocates-and-legal-consultants-llc",
    "name": "Al Maidour Advocates and Legal Consultants LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Al Maidour Advocates and Legal Consultants LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_3b559ddc-def9-4ecb-bf4d-cf3cd8eb2878",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4213, 4334",
    "owner": "Sarah, Ghulam Rasul Muhammad Othman"
  },
  {
    "id": "978f0e00-52a3-48e6-bffe-06e443cebd32",
    "slug": "amal-al-rashidi-law-firm-and-legal-consultations",
    "name": "Amal Al Rashidi Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Amal Al Rashidi Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_978f0e00-52a3-48e6-bffe-06e443cebd32",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3997",
    "owner": "Sarah Muhammad Ahmed Jaafar Nasiri"
  },
  {
    "id": "b5095b62-015e-47e6-ac1c-17e22301e713",
    "slug": "ali-sultan-bin-qadeeb-advocates-and-legal-consultations",
    "name": "Ali Sultan Bin Qadeeb Advocates and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Ali Sultan Bin Qadeeb Advocates and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_b5095b62-015e-47e6-ac1c-17e22301e713",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4275",
    "owner": "Sarah Muhammad Saleh Salem Al-Hamid"
  },
  {
    "id": "9869215f-17b0-42e3-9a71-ac17bf5f2717",
    "slug": "salem-hadid-obaid-gharib-al-khamisi",
    "name": "Salem Hadid Obaid Gharib Al-Khamisi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Salem Hadid Obaid Gharib Al-Khamisi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_9869215f-17b0-42e3-9a71-ac17bf5f2717",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2220",
    "company": "Salem Hadid Law Firm and Legal Consultations"
  },
  {
    "id": "1a85f7d3-171b-47ee-be79-ab452efeb94b",
    "slug": "salem-bin-bahyan-advocates-and-legal-consultantsabu-dhabi",
    "name": "Salem Bin Bahyan Advocates and Legal Consultants/Abu Dhabi",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNCCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Salem Bin Bahyan Advocates and Legal Consultants/Abu Dhabi",
    "consultationFee": 500,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_1a85f7d3-171b-47ee-be79-ab452efeb94b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "746",
    "owner": "Salem Hamad Bahyan Barot Al-Amri"
  },
  {
    "id": "0700519c-993f-47af-9fd5-460d514a6c34",
    "slug": "salem-rashid-abdullah-muftah-al-khatri",
    "name": "Salem Rashid Abdullah Muftah Al Khatri",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Salem Rashid Abdullah Muftah Al Khatri",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_0700519c-993f-47af-9fd5-460d514a6c34",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3655",
    "company": "Salem Al Khatri Law Firm and Legal Consultations"
  },
  {
    "id": "530a1956-8dde-4874-92cf-55f5c1f92a5e",
    "slug": "salem-saeed-ahmed-saeed-bin-kuwir",
    "name": "Salem Saeed Ahmed Saeed Bin Kuwir",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Salem Saeed Ahmed Saeed Bin Kuwir",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_530a1956-8dde-4874-92cf-55f5c1f92a5e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3606",
    "company": "Bin Haider Law Firm and Legal Consultations"
  },
  {
    "id": "8c975fb8-0665-4070-96f5-a0a5afea72ab",
    "slug": "salem-saeed-salem-raafit",
    "name": "Salem Saeed Salem Raafit",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Salem Saeed Salem Raafit",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_8c975fb8-0665-4070-96f5-a0a5afea72ab",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "138",
    "company": "Salem Saeed Advocates and Legal Consultants"
  },
  {
    "id": "1ef18fb0-6f4c-4116-9bf8-f402af7967f3",
    "slug": "salem-suhail-al-ameri-advocates-and-legal-consultants",
    "name": "Salem Suhail Al Ameri Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Salem Suhail Al Ameri Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_1ef18fb0-6f4c-4116-9bf8-f402af7967f3",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3093",
    "owner": "Salem Suhail Saleh Mohammed Al-Amiri"
  },
  {
    "id": "f6e9e6d7-af6c-49bd-9c34-cd758605fe29",
    "slug": "salem-saif-salem-al-kubaisi-al-ali",
    "name": "Salem Saif Salem Al Kubaisi Al Ali",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Salem Saif Salem Al Kubaisi Al Ali",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_f6e9e6d7-af6c-49bd-9c34-cd758605fe29",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "63",
    "company": "Salem Al Kubaisi Advocates and Legal Consultants"
  },
  {
    "id": "9cb2e4c3-fc32-44c9-bf01-4eb3aebb6e6f",
    "slug": "dr-salem-al-murr-advocates-and-legal-consultants",
    "name": "Dr. Salem Al Murr Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Dr. Salem Al Murr Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_9cb2e4c3-fc32-44c9-bf01-4eb3aebb6e6f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2093",
    "owner": "Salem Abdullah Muhammad Al-Murr Al-Naqbi"
  },
  {
    "id": "adb2adfe-2c39-439b-bc07-60aaf208fa23",
    "slug": "salem-ali-al-ahbabi-law-office-and-legal-consultations",
    "name": "Salem Ali Al Ahbabi Law Office and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Salem Ali Al Ahbabi Law Office and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_adb2adfe-2c39-439b-bc07-60aaf208fa23",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4135",
    "owner": "Salem Ali Mane’ Mufreh Al-Ahbabi"
  },
  {
    "id": "c6dca81a-147d-4cce-bb0d-530a8ee163cf",
    "slug": "salem-mohammed-al-jaber-advocates-and-legal-consultants-llc-spc",
    "name": "Salem Mohammed Al Jaber Advocates and Legal Consultants - LLC - S.P.C",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Salem Mohammed Al Jaber Advocates and Legal Consultants - LLC - S.P.C",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c6dca81a-147d-4cce-bb0d-530a8ee163cf",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4477",
    "owner": "Salem Muhammad Issa Al Jaber Al Ali"
  },
  {
    "id": "78897c06-64c2-4bb8-8ead-9b4d66bd907d",
    "slug": "salem-marhoon-muslim-al-yahyai",
    "name": "Salem Marhoon Muslim Al Yahyai",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Salem Marhoon Muslim Al Yahyai",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_78897c06-64c2-4bb8-8ead-9b4d66bd907d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2612",
    "company": "Salem Marhoon Al Yahyai Advocates and Legal Consultants"
  },
  {
    "id": "eec08922-de67-49fa-8e85-51926befc5e9",
    "slug": "samer-ali-hassan",
    "name": "Samer Ali Hassan",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Samer Ali Hassan",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_eec08922-de67-49fa-8e85-51926befc5e9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "10001",
    "company": "Law firm for trial 5124"
  },
  {
    "id": "a32fe8c7-0a71-48dd-9fde-db880d513390",
    "slug": "sami-jamal-youssef-al-sawalhi",
    "name": "Sami Jamal Youssef Al-Sawalhi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Sami Jamal Youssef Al-Sawalhi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_a32fe8c7-0a71-48dd-9fde-db880d513390",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3790",
    "company": "Sami Al-Sawalhi Law Firm and Legal Consultations (One Person Company) LLC"
  },
  {
    "id": "825dec3f-5839-41d4-8c21-6e7012cab83c",
    "slug": "sami-khamis-walid-jumah-al-ali",
    "name": "Sami Khamis Walid Jumah Al-Ali",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Sami Khamis Walid Jumah Al-Ali",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_825dec3f-5839-41d4-8c21-6e7012cab83c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "453",
    "company": "Al Sharq Law Firm and Legal Consultations"
  },
  {
    "id": "79fd76c3-2631-4f6c-9532-8c2bd616bba3",
    "slug": "dr-mohammed-al-hammadi-advocates-and-legal-consultants-abu-dhabi",
    "name": "Dr. Mohammed Al Hammadi Advocates and Legal Consultants - Abu Dhabi",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Dr. Mohammed Al Hammadi Advocates and Legal Consultants - Abu Dhabi",
    "consultationFee": 500,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_79fd76c3-2631-4f6c-9532-8c2bd616bba3",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "1336, 4415",
    "owner": "Samia Salem Ahmed Al-Raqabi Al-Musabi"
  },
  {
    "id": "48903196-1b42-4bc9-8d3c-2a025e81c581",
    "slug": "samia-saeed-muhammad-ayoub",
    "name": "Samia Saeed Muhammad Ayoub",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Samia Saeed Muhammad Ayoub",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_48903196-1b42-4bc9-8d3c-2a025e81c581",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3976",
    "company": "Samia Saeed Advocates and Legal Consultants"
  },
  {
    "id": "389a6ab9-012f-4ba1-8126-751c80e46c6e",
    "slug": "sabeel-salem-rashid-rahma-al-balushi",
    "name": "Sabeel Salem Rashid Rahma Al Balushi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Sabeel Salem Rashid Rahma Al Balushi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_389a6ab9-012f-4ba1-8126-751c80e46c6e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "1445",
    "company": "Sabeel Salem Law Firm"
  },
  {
    "id": "30e702ef-4f7c-4ddd-b5d6-7a4d3399369e",
    "slug": "saad-mohammed-abdullah-al-hammadi",
    "name": "Saad Mohammed Abdullah Al Hammadi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Saad Mohammed Abdullah Al Hammadi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_30e702ef-4f7c-4ddd-b5d6-7a4d3399369e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "413",
    "company": "Saad Al Hammadi Advocates and Legal Consultants/Dubai"
  },
  {
    "id": "2b1ce5c0-76d7-4242-95a6-9ae938fdc9dc",
    "slug": "saad-al-din-jaafar-al-nukhadha",
    "name": "Saad al-Din Jaafar al-Nukhadha",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Saad al-Din Jaafar al-Nukhadha",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2b1ce5c0-76d7-4242-95a6-9ae938fdc9dc",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "702",
    "company": "Al-Raya Law Firm and Legal Consultations/Dubai"
  },
  {
    "id": "8d4aba2a-d993-4cdb-b337-21571299224c",
    "slug": "saud-ahmed-abdul-karim-ismail-al-zarouni",
    "name": "Saud Ahmed Abdul Karim Ismail Al Zarouni",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Saud Ahmed Abdul Karim Ismail Al Zarouni",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_8d4aba2a-d993-4cdb-b337-21571299224c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2708",
    "company": "Saud Al Zarouni Advocates and Legal Consultants"
  },
  {
    "id": "d756234a-8f05-4f73-bd0a-c11cfeedae24",
    "slug": "saud-ahmed-ali-bibi-al-shehhi",
    "name": "Saud Ahmed Ali Bibi Al Shehhi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Saud Ahmed Ali Bibi Al Shehhi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_d756234a-8f05-4f73-bd0a-c11cfeedae24",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4103",
    "company": "Saud Ahmed Al Shehhi Advocates and Legal Consultants"
  },
  {
    "id": "d26b7d4e-d833-4d51-a098-3c53db5620c8",
    "slug": "saud-abdul-rahman-muhammad-balhaj-al-marashdeh",
    "name": "Saud Abdul Rahman Muhammad Balhaj Al Marashdeh",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Saud Abdul Rahman Muhammad Balhaj Al Marashdeh",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_d26b7d4e-d833-4d51-a098-3c53db5620c8",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3256",
    "company": "Saud Belhaj Advocates and Legal Consultants"
  },
  {
    "id": "a934b333-6d82-4294-9cca-cf62fc592631",
    "slug": "saud-mubarak-saleh-shahbal-al-tamimi",
    "name": "Saud Mubarak Saleh Shahbal Al-Tamimi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Saud Mubarak Saleh Shahbal Al-Tamimi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_a934b333-6d82-4294-9cca-cf62fc592631",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4391",
    "company": "Hassan Al Riyami Advocates and Legal Consultants"
  },
  {
    "id": "8e4a7030-2636-4a64-a3ac-2289cfe30fd2",
    "slug": "saud-mohammed-abdul-hamid-mohammed",
    "name": "Saud Mohammed Abdul Hamid Mohammed",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Saud Mohammed Abdul Hamid Mohammed",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_8e4a7030-2636-4a64-a3ac-2289cfe30fd2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3461",
    "company": "Saud Mohammed Abdul Hamid Advocates and Legal Consultants"
  },
  {
    "id": "6ee10d80-6e10-47bf-ac64-e6b9ef64192f",
    "slug": "house-of-wisdom-law-firm-and-legal-consultations",
    "name": "House of Wisdom Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhXCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: House of Wisdom Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_6ee10d80-6e10-47bf-ac64-e6b9ef64192f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3853",
    "owner": "Saud Mohammed Issa Al Suwaidi"
  },
  {
    "id": "71693940-647f-464f-b7b8-9346d922f777",
    "slug": "saeed-ibrahim-al-sayyid-ahmed-al-hashemi",
    "name": "Saeed Ibrahim Al-Sayyid Ahmed Al-Hashemi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Saeed Ibrahim Al-Sayyid Ahmed Al-Hashemi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_71693940-647f-464f-b7b8-9346d922f777",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2778",
    "company": "Saeed Al Hashemi Advocates and Legal Consultants"
  },
  {
    "id": "7630aee5-ed6a-45c8-ad7d-aa563edcc2dd",
    "slug": "saeed-ahmed-mohammed-al-awadi",
    "name": "Saeed Ahmed Mohammed Al-Awadi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Saeed Ahmed Mohammed Al-Awadi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_7630aee5-ed6a-45c8-ad7d-aa563edcc2dd",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3006",
    "company": "Saeed Al-Awadi Advocates and Legal Consultants"
  },
  {
    "id": "2a5e40e8-4263-4d43-b5cc-f38ae329b734",
    "slug": "saeed-thani-ali-bin-ghalita-al-muhairi",
    "name": "Saeed Thani Ali bin Ghalita Al Muhairi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Saeed Thani Ali bin Ghalita Al Muhairi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_2a5e40e8-4263-4d43-b5cc-f38ae329b734",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3773",
    "company": "Saeed Bin Ghalita Law Firm and Legal Consultations"
  },
  {
    "id": "f691612c-dd90-4f91-b5d6-87500ce37887",
    "slug": "saeed-hatem-karama-al-menhali",
    "name": "Saeed Hatem Karama Al Menhali",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Saeed Hatem Karama Al Menhali",
    "consultationFee": 400,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_f691612c-dd90-4f91-b5d6-87500ce37887",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3616",
    "company": "Saeed Hatem Al Menhali & Partners Advocates and Legal Consultants LLC - Abu Dhabi"
  },
  {
    "id": "25631e71-9019-44d1-99a8-ca25a5c9df56",
    "slug": "saeed-hussein-ali-hussein-al-loughani",
    "name": "Saeed Hussein Ali Hussein Al-Loughani",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Saeed Hussein Ali Hussein Al-Loughani",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_25631e71-9019-44d1-99a8-ca25a5c9df56",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4182",
    "company": "Saeed Hussein Ali Al-Loughani Advocates and Legal Consultants"
  },
  {
    "id": "d963f2cc-9c5e-40d7-8d07-f5ca27823295",
    "slug": "saeed-khalfan-muhammad-ali-al-dahmani",
    "name": "Saeed Khalfan Muhammad Ali Al-Dahmani",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Saeed Khalfan Muhammad Ali Al-Dahmani",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_d963f2cc-9c5e-40d7-8d07-f5ca27823295",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3776",
    "company": "Saeed Al-Dahmani Law Firm and Legal Consultations"
  },
  {
    "id": "59fdf43e-27a6-41a6-9803-6700135a8e07",
    "slug": "saeed-khamis-saeed-juma-al-naqbi",
    "name": "Saeed Khamis Saeed Juma Al Naqbi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Saeed Khamis Saeed Juma Al Naqbi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_59fdf43e-27a6-41a6-9803-6700135a8e07",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4435",
    "company": "Saeed Al Naqbi Advocates and Legal Consultants"
  },
  {
    "id": "e88fedb0-2df4-4aa1-baf9-840d11f1d7e8",
    "slug": "hamad-bin-jarwan-and-partners-advocates-and-legal-consultants",
    "name": "Hamad bin Jarwan and Partners Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhCCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Hamad bin Jarwan and Partners Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e88fedb0-2df4-4aa1-baf9-840d11f1d7e8",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4297, 4364, 4377",
    "owner": "Saeed Salem in Al-Arsa Al-Shamsi"
  },
  {
    "id": "8e324562-883c-4933-9b3d-44a170ddcc23",
    "slug": "dr-saeed-al-mazrouei-advocates-and-legal-consultants-llc-spc",
    "name": "Dr. Saeed Al Mazrouei Advocates and Legal Consultants - LLC - S.P.C",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Dr. Saeed Al Mazrouei Advocates and Legal Consultants - LLC - S.P.C",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_8e324562-883c-4933-9b3d-44a170ddcc23",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3986",
    "owner": "Saeed Salem Khalifa Salem Al Mazroui"
  },
  {
    "id": "699d039a-b49d-4776-9459-0ac9fda5bfff",
    "slug": "saeed-salem-khamis-suleiman-al-shamsi",
    "name": "MOHAMED SALEH ALI ABDALLA",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/07/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Saeed Salem Khamis Suleiman Al Shamsi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_699d039a-b49d-4776-9459-0ac9fda5bfff",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "L-2124",
    "company": "Saeed Salem Al Shamsi Advocates and Legal Consultants"
  },
  {
    "id": "cf7a3bd6-b461-4a8d-a09a-49c2dbfa36cf",
    "slug": "saeed-salmeen-al-menhali-advocates-and-legal-consultants",
    "name": "Saeed Salmeen Al Menhali Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Saeed Salmeen Al Menhali Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_cf7a3bd6-b461-4a8d-a09a-49c2dbfa36cf",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "90",
    "owner": "Saeed Salmeen Nasib Mugheethat Al-Minhali"
  },
  {
    "id": "ee699bbd-3c24-4cab-a8a9-ff5419a9cd4c",
    "slug": "saeed-salim-ali-al-ketbi",
    "name": "NASER ABDELAZIZ SHAHEEN ALRAHMA ALRAEESI",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/08/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Saeed Salim Ali Al Ketbi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_ee699bbd-3c24-4cab-a8a9-ff5419a9cd4c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "L-2134",
    "company": "Saeed Al Ketbi Law Firm and Legal Consultations"
  },
  {
    "id": "55e85895-787a-4b28-8c2c-4fcf33385e8e",
    "slug": "saeed-suhail-muslim-al-rashidi",
    "name": "Saeed Suhail Muslim Al Rashidi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Saeed Suhail Muslim Al Rashidi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_55e85895-787a-4b28-8c2c-4fcf33385e8e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3242",
    "company": "Saeed Al Rashidi Advocates and Legal Consultants"
  },
  {
    "id": "b01cdce8-d766-4548-8da2-1413b9b97fb6",
    "slug": "saeed-saif-maktoum-khamis-al-mansouri",
    "name": "Saeed Saif Maktoum Khamis Al Mansouri",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Saeed Saif Maktoum Khamis Al Mansouri",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_b01cdce8-d766-4548-8da2-1413b9b97fb6",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4616",
    "company": "Saif Ahmed Ibrahim Law Office and Legal Consultations"
  },
  {
    "id": "7b3e9e6d-daab-4c85-8c08-fe22f4bd4584",
    "slug": "saeed-al-sharmi-advocates-and-legal-consultations-llc",
    "name": "Saeed Al Sharmi Advocates and Legal Consultations LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Saeed Al Sharmi Advocates and Legal Consultations LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_7b3e9e6d-daab-4c85-8c08-fe22f4bd4584",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4040",
    "owner": "Saeed Abdullah Khamis Al-Khalawi Al-Sharmi"
  },
  {
    "id": "96ee9998-5c7e-4a97-9992-3591985740bb",
    "slug": "saeed-abdullah-saeed-al-zeyoudi",
    "name": "Saeed Abdullah Saeed Al-Zeyoudi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Saeed Abdullah Saeed Al-Zeyoudi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_96ee9998-5c7e-4a97-9992-3591985740bb",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "1206",
    "company": "Kholoud Saeed Advocates and Legal Consultants"
  },
  {
    "id": "2d475357-d9d2-4dee-b5c6-f9309c0d9bb2",
    "slug": "saeed-abdullah-talib-muhammad-ahmed",
    "name": "Saeed Abdullah Talib Muhammad Ahmed",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Saeed Abdullah Talib Muhammad Ahmed",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_2d475357-d9d2-4dee-b5c6-f9309c0d9bb2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4276",
    "company": "Gulf Lawyers and Legal Consultants"
  },
  {
    "id": "f122220d-d33a-42a5-9d41-5000e3dc33b9",
    "slug": "saeed-ali-saeed-hamdan-al-shehhi",
    "name": "Saeed Ali Saeed Hamdan Al Shehhi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Saeed Ali Saeed Hamdan Al Shehhi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_f122220d-d33a-42a5-9d41-5000e3dc33b9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2195",
    "company": "Shouq Al Kathiri Advocates and Legal Consultants"
  },
  {
    "id": "c2d863a4-e518-4739-802c-f5fc341f109f",
    "slug": "saeed-ali-muhammad-bin-qaddad-al-muhairi",
    "name": "Saeed Ali Muhammad bin Qaddad Al Muhairi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Saeed Ali Muhammad bin Qaddad Al Muhairi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c2d863a4-e518-4739-802c-f5fc341f109f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4188",
    "company": "Saeed Al Muhairi Advocates and Legal Consultants"
  },
  {
    "id": "c87544c9-1679-401b-a9f5-08338acd39c8",
    "slug": "saeed-issa-bakhit-huwaireb-al-mansouri",
    "name": "Saeed Issa Bakhit Huwaireb Al Mansouri",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Saeed Issa Bakhit Huwaireb Al Mansouri",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c87544c9-1679-401b-a9f5-08338acd39c8",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4353",
    "company": "Saeed Huwaireb Al Mansouri Law Office and Legal Consultations"
  },
  {
    "id": "1507173d-db59-4d26-b0f2-893e5152fbea",
    "slug": "saeed-hatem-al-menhali-partners-advocates-and-legal-consultants-llc-abu-dhabi",
    "name": "Saeed Hatem Al Menhali & Partners Advocates and Legal Consultants LLC - Abu Dhabi",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Saeed Hatem Al Menhali & Partners Advocates and Legal Consultants LLC - Abu Dhabi",
    "consultationFee": 500,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_1507173d-db59-4d26-b0f2-893e5152fbea",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3177, 4638",
    "owner": "Saida Tarish Khalil Ibrahim Al-Khamiri"
  },
  {
    "id": "cf220d19-853a-4429-bf99-c4f270673524",
    "slug": "salama-saif-muhammad-tarish-al-muhairbi",
    "name": "Salama Saif Muhammad Tarish Al Muhairbi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Salama Saif Muhammad Tarish Al Muhairbi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_cf220d19-853a-4429-bf99-c4f270673524",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4461",
    "company": "Salama Saif Mohammed Al Muhairbi Law Firm"
  },
  {
    "id": "ae0ef156-033f-479d-866c-bf4f5ba0cf76",
    "slug": "mohammed-saif-al-tamimi-law-firm-and-legal-consultations-al-ain-branch",
    "name": "Mohammed Saif Al Tamimi Law Firm and Legal Consultations - Al Ain Branch",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1TCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Mohammed Saif Al Tamimi Law Firm and Legal Consultations - Al Ain Branch",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_ae0ef156-033f-479d-866c-bf4f5ba0cf76",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3503, 4082, 4345",
    "owner": "Peace be upon Ahmed Al-Salf Al-Nuaimi"
  },
  {
    "id": "aa6e1f98-a223-4d39-8913-b601ec1994b2",
    "slug": "peace-be-upon-you-mubarak-ghalib-khasuni-al-ketbi",
    "name": "Peace be upon you, Mubarak Ghalib Khasuni Al-Ketbi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Peace be upon you, Mubarak Ghalib Khasuni Al-Ketbi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_aa6e1f98-a223-4d39-8913-b601ec1994b2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4184",
    "company": "Nourhan Abdul Latif Al Zaabi Advocates and Legal Consultants"
  },
  {
    "id": "0fa20322-b21f-4364-92c6-c4b72ba1b8d3",
    "slug": "sultan-ibrahim-sultan-muhammad-al-obaidli",
    "name": "Sultan Ibrahim Sultan Muhammad Al-Obaidli",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Sultan Ibrahim Sultan Muhammad Al-Obaidli",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_0fa20322-b21f-4364-92c6-c4b72ba1b8d3",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3924",
    "company": "Prestige Law Firm and Legal Consultations"
  },
  {
    "id": "d7158ab7-b92c-4bba-9c57-1b2735a7e797",
    "slug": "sultan-ahmed-abdul-karim-karam-al-balushi",
    "name": "Sultan Ahmed Abdul Karim Karam Al Balushi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Sultan Ahmed Abdul Karim Karam Al Balushi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_d7158ab7-b92c-4bba-9c57-1b2735a7e797",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2247",
    "company": "Abdul Rahman Al Mazmi Advocates and Legal Consultants"
  },
  {
    "id": "4ed7f304-a549-4db1-9d41-a5e4c535d3e6",
    "slug": "sultan-ismail-abdullah-ibrahim-al-hosani",
    "name": "Sultan Ismail Abdullah Ibrahim Al Hosani",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Sultan Ismail Abdullah Ibrahim Al Hosani",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_4ed7f304-a549-4db1-9d41-a5e4c535d3e6",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3685",
    "company": "Saeed Al Rashidi Advocates and Legal Consultants"
  },
  {
    "id": "1ab53774-3f2d-4cd6-b98e-f40240339565",
    "slug": "sultan-rashid-obaid-saif-al-hafiti",
    "name": "Sultan Rashid Obaid Saif Al Hafiti",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Sultan Rashid Obaid Saif Al Hafiti",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_1ab53774-3f2d-4cd6-b98e-f40240339565",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4395",
    "company": "International Accreditation Center for Advocates and Legal Consultations"
  },
  {
    "id": "331dd0b9-d939-4df8-835d-68a0af1591c0",
    "slug": "sultan-saleh-awad-mohsen-al-wahidi",
    "name": "Sultan Saleh Awad Mohsen Al-Wahidi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Sultan Saleh Awad Mohsen Al-Wahidi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_331dd0b9-d939-4df8-835d-68a0af1591c0",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4351",
    "company": "Sultan Al Wahidi Advocates and Legal Consultations"
  },
  {
    "id": "370e6285-b089-4554-b6c7-a4f3fb48cfb0",
    "slug": "sultan-abdullah-obaid-musa-al-farsi",
    "name": "Sultan Abdullah Obaid Musa Al Farsi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Sultan Abdullah Obaid Musa Al Farsi",
    "consultationFee": 400,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_370e6285-b089-4554-b6c7-a4f3fb48cfb0",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2929",
    "company": "Dr. Al Khazraji Advocates and Legal Consultants/Abu Dhabi"
  },
  {
    "id": "e6fdd24b-e5cd-4eec-bf07-1d110f11bd96",
    "slug": "sultan-abdullah-muhammad-al-marzouqi",
    "name": "Sultan Abdullah Muhammad Al Marzouqi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Sultan Abdullah Muhammad Al Marzouqi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e6fdd24b-e5cd-4eec-bf07-1d110f11bd96",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "406",
    "company": "Sultan Al Marzouqi Advocates and Legal Consultants"
  },
  {
    "id": "07edecf0-91bb-4681-a79b-4bc7a18a692d",
    "slug": "sultan-obaid-salem-bin-dhiban-al-mansouri",
    "name": "Sultan Obaid Salem bin Dhiban Al Mansouri",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Sultan Obaid Salem bin Dhiban Al Mansouri",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_07edecf0-91bb-4681-a79b-4bc7a18a692d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2780",
    "company": "Sultan bin Dhiban Al Mansouri Advocates and Legal Consultants"
  },
  {
    "id": "c26d00bc-520b-49eb-9c4c-3b4b862079d5",
    "slug": "sultan-obaid-muhammad-basloum-al-zaabi",
    "name": "Sultan Obaid Muhammad Basloum Al Zaabi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Sultan Obaid Muhammad Basloum Al Zaabi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c26d00bc-520b-49eb-9c4c-3b4b862079d5",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4050",
    "company": "Obaid Al-Mazmi Law Firm and Legal Consultations"
  },
  {
    "id": "83e25354-56dd-419c-b4b3-a53326519484",
    "slug": "sultan-al-shukaili-law-firm-llc-spc",
    "name": "Sultan Al Shukaili Law Firm - LLC - S.P.C",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Sultan Al Shukaili Law Firm - LLC - S.P.C",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_83e25354-56dd-419c-b4b3-a53326519484",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "487",
    "owner": "Sultan Muhammad Al-Shukaili"
  },
  {
    "id": "24b57acc-14bd-4cda-860d-5ffb71b5aa74",
    "slug": "sultan-muhammad-abdul-rahman-abdul-aziz-al-matroushi",
    "name": "Sultan Muhammad Abdul Rahman Abdul Aziz Al Matroushi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Sultan Muhammad Abdul Rahman Abdul Aziz Al Matroushi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_24b57acc-14bd-4cda-860d-5ffb71b5aa74",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4528",
    "company": "Sultan Mohammed Al Matrooshi Advocates and Legal Consultations"
  },
  {
    "id": "1cfb7638-4e75-4b0c-a7e0-6bdb15e8b6aa",
    "slug": "sultan-yusuf-ahmed-ali-al-ali",
    "name": "Sultan Yusuf Ahmed Ali Al Ali",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Sultan Yusuf Ahmed Ali Al Ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1cfb7638-4e75-4b0c-a7e0-6bdb15e8b6aa",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4269",
    "company": "Yousef Al Ali Advocates and Legal Consultants/Dubai"
  },
  {
    "id": "f6379456-9bdc-42de-a14f-d4e5418a4920",
    "slug": "sultan-youssef-ahmed-muhammad-al-jaziri",
    "name": "Sultan Youssef Ahmed Muhammad Al-Jaziri",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Sultan Youssef Ahmed Muhammad Al-Jaziri",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_f6379456-9bdc-42de-a14f-d4e5418a4920",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4170",
    "company": "Jaafar Alwan, Al-Jaziri and Partners are lawyers and legal consultants"
  },
  {
    "id": "d1f4bb6e-e77a-47e2-80c3-bf6f5bb91db2",
    "slug": "salman-mohammed-al-hammadi-law-firm-and-legal-consultations",
    "name": "Salman Mohammed Al Hammadi Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Salman Mohammed Al Hammadi Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_d1f4bb6e-e77a-47e2-80c3-bf6f5bb91db2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4685",
    "owner": "Salman Muhammad Mal Allah Suleiman Al-Hammadi"
  },
  {
    "id": "1b769ece-fa21-4a4b-aefb-3dfb489f6c3e",
    "slug": "dr-abdulaziz-al-shamsi-advocates-and-legal-consultants",
    "name": "Dr. Abdulaziz Al Shamsi Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Dr. Abdulaziz Al Shamsi Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_1b769ece-fa21-4a4b-aefb-3dfb489f6c3e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3343, 4108, 4417",
    "owner": "Salma Hamad Saud Salem Al-Maamari"
  },
  {
    "id": "2499c2e9-536c-41f3-a9db-9940f6a2dd63",
    "slug": "salma-rashid-khalfan-abbad-al-mansouri",
    "name": "Salma Rashid Khalfan Abbad Al Mansouri",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Salma Rashid Khalfan Abbad Al Mansouri",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_2499c2e9-536c-41f3-a9db-9940f6a2dd63",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4117",
    "company": "Salma Rashid Al Mansouri Law Firm and Legal Consultations"
  },
  {
    "id": "12306aea-3f8d-4dee-96a7-73509d77cf29",
    "slug": "salma-saeed-mohammed-al-bakr-al-zaabi",
    "name": "Salma Saeed Mohammed Al-Bakr Al-Zaabi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Salma Saeed Mohammed Al-Bakr Al-Zaabi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_12306aea-3f8d-4dee-96a7-73509d77cf29",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4197",
    "company": "Al-Bakr Law Firm and Legal Consultations"
  },
  {
    "id": "ded8ed2b-b3c9-4c59-96f7-27847d27166f",
    "slug": "salma-saeed-muhammad-al-qahomi-al-zeyoudi",
    "name": "Salma Saeed Muhammad Al-Qahomi Al-Zeyoudi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Salma Saeed Muhammad Al-Qahomi Al-Zeyoudi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_ded8ed2b-b3c9-4c59-96f7-27847d27166f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4071",
    "company": "Salma Saeed Al-Zeyoudi Advocates and Legal Consultants"
  },
  {
    "id": "d4e266c0-b83e-4e16-9d79-dad6dd39fc9f",
    "slug": "salma-saeed-musabah-al-ketbi",
    "name": "Salma Saeed Musabah Al Ketbi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Salma Saeed Musabah Al Ketbi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_d4e266c0-b83e-4e16-9d79-dad6dd39fc9f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2779",
    "company": "Salma Al Ketbi Law Firm and Legal Consultations"
  },
  {
    "id": "60d5c674-7b42-4c8b-bf11-2333dca60da3",
    "slug": "salma-mohammed-al-mansouri-advocates-and-legal-consultations-llc-spc",
    "name": "Salma Mohammed Al Mansouri Advocates and Legal Consultations - LLC - S.P.C",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Salma Mohammed Al Mansouri Advocates and Legal Consultations - LLC - S.P.C",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_60d5c674-7b42-4c8b-bf11-2333dca60da3",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4031",
    "owner": "Salma Muhammad Salem Shafi Al-Mansouri"
  },
  {
    "id": "054c369e-dc4a-45dd-92df-ae57baffcc5e",
    "slug": "salwa-muhammad-muhammad-omar",
    "name": "Salwa Muhammad Muhammad Omar",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Salwa Muhammad Muhammad Omar",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_054c369e-dc4a-45dd-92df-ae57baffcc5e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2895",
    "company": "Salwa Omar Law Firm and Legal Consultations"
  },
  {
    "id": "9464f1da-0e1c-4a19-803d-33a043313335",
    "slug": "sulaiman-al-menhali-advocates-and-legal-consultants",
    "name": "Sulaiman Al Menhali Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Sulaiman Al Menhali Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_9464f1da-0e1c-4a19-803d-33a043313335",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "283",
    "owner": "Suleiman Ahmed Rashid Al-Menhali"
  },
  {
    "id": "b818cbef-3082-4bc5-b061-246714ad95ad",
    "slug": "suleiman-ahmed-al-dhanhani-law-firm-and-legal-consultations",
    "name": "Suleiman Ahmed Al Dhanhani Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Suleiman Ahmed Al Dhanhani Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_b818cbef-3082-4bc5-b061-246714ad95ad",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2630",
    "owner": "Suleiman Ahmed Suleiman Al-Sharari Al-Dhanhani"
  },
  {
    "id": "282135c8-ca29-4791-95a1-ac06746c9d03",
    "slug": "suleiman-salem-muhammad-zaid-al-karbi",
    "name": "Suleiman Salem Muhammad Zaid Al-Karbi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Suleiman Salem Muhammad Zaid Al-Karbi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_282135c8-ca29-4791-95a1-ac06746c9d03",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3486",
    "company": "Suleiman Salem Al-Karbi Advocates and Legal Consultants"
  },
  {
    "id": "a22e6126-2077-4981-af71-32efd3ff32a4",
    "slug": "suleiman-muhammad-hassan-al-maamari",
    "name": "Suleiman Muhammad Hassan Al-Maamari",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Suleiman Muhammad Hassan Al-Maamari",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_a22e6126-2077-4981-af71-32efd3ff32a4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4009",
    "company": "Suleiman Mohammed Al-Maamari Law Firm and Legal Consultations"
  },
  {
    "id": "d7c9855e-3aa2-4a4f-96d4-40cab14b888a",
    "slug": "samar-marwan-khaled-geha",
    "name": "Samar Marwan Khaled Geha",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Samar Marwan Khaled Geha",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_d7c9855e-3aa2-4a4f-96d4-40cab14b888a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3965",
    "company": "Al-Thiqa Law Firm and Legal Consultations"
  },
  {
    "id": "8e8472bc-210d-4467-b964-8a46c10dbbee",
    "slug": "al-owais-and-al-matroushi-advocates-and-legal-consultants",
    "name": "Al Owais and Al Matroushi Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFPCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Al Owais and Al Matroushi Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_8e8472bc-210d-4467-b964-8a46c10dbbee",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2625",
    "owner": "Samira Saeed Salem Saeed Al Abdouli"
  },
  {
    "id": "05663468-db8a-4009-b20f-274a604fe044",
    "slug": "samira-fakher-hussein-advocates-and-legal-consultants",
    "name": "Samira Fakher Hussein Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNGCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Samira Fakher Hussein Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_05663468-db8a-4009-b20f-274a604fe044",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3238",
    "owner": "Samira Fakher Hussein Al-Zarkan"
  },
  {
    "id": "fff599b5-a3c3-4b67-9c2a-635d7ec19f0c",
    "slug": "his-name-was-muhammad-khamis-saeed-al-kaabi",
    "name": "His name was Muhammad Khamis Saeed Al Kaabi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: His name was Muhammad Khamis Saeed Al Kaabi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_fff599b5-a3c3-4b67-9c2a-635d7ec19f0c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4208",
    "company": "Hessa Humaid Al-Sharaa Advocates and Legal Consultants"
  },
  {
    "id": "18b8a9b6-8285-4fcc-b987-fee25d8adb4d",
    "slug": "supported-by-ali-salem-hassan-al-hantoubi",
    "name": "Supported by Ali Salem Hassan Al-Hantoubi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Supported by Ali Salem Hassan Al-Hantoubi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_18b8a9b6-8285-4fcc-b987-fee25d8adb4d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3115",
    "company": "Sindia Al-Hantoubi Advocates and Legal Consultants"
  },
  {
    "id": "028ca6fc-56f9-4a11-bc6b-b67355dc16a9",
    "slug": "suhad-fadel-jabbar-mahdi-al-jubouri",
    "name": "Suhad Fadel Jabbar Mahdi Al-Jubouri",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Suhad Fadel Jabbar Mahdi Al-Jubouri",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_028ca6fc-56f9-4a11-bc6b-b67355dc16a9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2635",
    "company": "Suhad Al-Jubouri Advocates and Legal Consultants"
  },
  {
    "id": "79f973c8-6b29-46bd-a031-a4054b3dabb9",
    "slug": "mohammed-bani-hashem-advocates-and-legal-consultants",
    "name": "Mohammed Bani Hashem Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1CCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Mohammed Bani Hashem Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_79f973c8-6b29-46bd-a031-a4054b3dabb9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3234",
    "owner": "Suhail Haj Saad Al-Sheikh"
  },
  {
    "id": "971f9928-db53-42ed-b92c-6a1f71ae5604",
    "slug": "suhail-ashour-al-kathiri-lawyers-and-legal-consultants-one-person-company-llc",
    "name": "Suhail Ashour Al Kathiri Lawyers and Legal Consultants - One Person Company - LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Suhail Ashour Al Kathiri Lawyers and Legal Consultants - One Person Company - LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_971f9928-db53-42ed-b92c-6a1f71ae5604",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4491",
    "owner": "Suhail Ashour Muhammad Salem Al-Kathiri"
  },
  {
    "id": "8d41db14-2800-4cb7-93d9-32d92e21069c",
    "slug": "suhaila-ali-bakhit-abdullah-al-neyadi",
    "name": "Suhaila Ali Bakhit Abdullah Al Neyadi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Suhaila Ali Bakhit Abdullah Al Neyadi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_8d41db14-2800-4cb7-93d9-32d92e21069c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3004",
    "company": "Suhaila Ali Al Neyadi Advocates and Legal Consultants"
  },
  {
    "id": "25a96cc7-82ce-49b4-bb4e-8a427d1f159a",
    "slug": "suhaila-youssef-musa-youssef-al-marzouqi",
    "name": "Suhaila Youssef Musa Youssef Al Marzouqi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Suhaila Youssef Musa Youssef Al Marzouqi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_25a96cc7-82ce-49b4-bb4e-8a427d1f159a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3931",
    "company": "Suhaila Al Marzouqi Advocates and Legal Consultants"
  },
  {
    "id": "080cf5e1-9a2d-463a-a2fb-2415584ddca5",
    "slug": "saif-ahmed-ibrahim-muhammad-al-balushi",
    "name": "Saif Ahmed Ibrahim Muhammad Al Balushi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Saif Ahmed Ibrahim Muhammad Al Balushi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_080cf5e1-9a2d-463a-a2fb-2415584ddca5",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4409",
    "company": "Saif Ahmed Ibrahim Law Office and Legal Consultations"
  },
  {
    "id": "e134b7e2-46dc-4487-bdf8-88be13717db5",
    "slug": "saif-ahmed-saeed-othman-al-wahidi",
    "name": "Saif Ahmed Saeed Othman Al-Wahidi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Saif Ahmed Saeed Othman Al-Wahidi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e134b7e2-46dc-4487-bdf8-88be13717db5",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4296",
    "company": "Dr. Saif Al-Wahidi Law Firm and Legal Consultations - One Person Company LLC"
  },
  {
    "id": "d09c7cf3-25a3-4db3-a844-55582c45e083",
    "slug": "saif-sultan-ali-al-mahrezi",
    "name": "Saif Sultan Ali Al Mahrezi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Saif Sultan Ali Al Mahrezi",
    "consultationFee": 400,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_d09c7cf3-25a3-4db3-a844-55582c45e083",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4056",
    "company": "Saif Sultan Al Mahrezi Advocates and Legal Consultations - Abu Dhabi Branch"
  },
  {
    "id": "8e70ab3e-2a0e-4f56-ac62-5fa77e14d45b",
    "slug": "saif-salman-qahtan-al-shamsi",
    "name": "Saif Salman Qahtan Al Shamsi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Saif Salman Qahtan Al Shamsi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_8e70ab3e-2a0e-4f56-ac62-5fa77e14d45b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3617",
    "company": "Saif Salman Al Shamsi Advocates and Legal Consultations - One Person Company LLC"
  },
  {
    "id": "450b0029-f0dd-4a5d-8122-28529e730d88",
    "slug": "saif-obaid-rashid-al-shamsi",
    "name": "MOHAMED EISA MOHAMED",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/01/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Saif Obaid Rashid Al Shamsi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_450b0029-f0dd-4a5d-8122-28529e730d88",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "L-2066",
    "company": "Saif Al Shamsi Advocates and Legal Consultants"
  },
  {
    "id": "1922f544-944b-418c-a39b-320a112078ff",
    "slug": "saif-ali-al-hammadi-advocates-and-legal-consultants",
    "name": "Saif Ali Al Hammadi Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Saif Ali Al Hammadi Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_1922f544-944b-418c-a39b-320a112078ff",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3170",
    "owner": "Saif Ali Ibrahim Al-Hammadi"
  },
  {
    "id": "65b1508f-adca-4dc9-8069-f0e728ee0575",
    "slug": "saif-nasser-musabah-khamis-al-kalbani",
    "name": "Saif Nasser Musabah Khamis Al-Kalbani",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Saif Nasser Musabah Khamis Al-Kalbani",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_65b1508f-adca-4dc9-8069-f0e728ee0575",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2481",
    "company": "Alpha Law Firm and Legal Consultations"
  },
  {
    "id": "9532c8c0-8603-41d9-9e3f-c3455455a3f8",
    "slug": "saif-younis-muhammad-ismail-al-rifai",
    "name": "Saif Younis Muhammad Ismail Al-Rifai",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Saif Younis Muhammad Ismail Al-Rifai",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_9532c8c0-8603-41d9-9e3f-c3455455a3f8",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2985",
    "company": "Iman Al-Rifai Advocates and Legal Consultations"
  },
  {
    "id": "4d55556f-6a32-418f-960a-2fe72836a7a1",
    "slug": "shaheen-ishaq-ismail-al-mazmi",
    "name": "Shaheen Ishaq Ismail Al-Mazmi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Shaheen Ishaq Ismail Al-Mazmi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_4d55556f-6a32-418f-960a-2fe72836a7a1",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4552",
    "company": "Obaid Al-Mazmi Advocates and Legal Consultants"
  },
  {
    "id": "f16101bd-b841-4370-bc35-92476060ad27",
    "slug": "shorouk-salem-salem-al-buraiki",
    "name": "Shorouk Salem Salem Al-Buraiki",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Shorouk Salem Salem Al-Buraiki",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_f16101bd-b841-4370-bc35-92476060ad27",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2554",
    "company": "Shorouk Saleh Al-Buraiki Law Firm and Legal Consultations"
  },
  {
    "id": "42ac988d-595a-4e12-8f53-78a277a63afd",
    "slug": "sherine-naji-rashed-musabah-al-dhaheri",
    "name": "Sherine Naji Rashed Musabah Al Dhaheri",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Sherine Naji Rashed Musabah Al Dhaheri",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_42ac988d-595a-4e12-8f53-78a277a63afd",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4278",
    "company": "Sharina Naji Al Dhaheri Law Firm and Legal Consultations is a one person company LLC"
  },
  {
    "id": "c5680458-2c9d-4f8a-853a-1eec5b03bc2e",
    "slug": "majid-bin-qaish-and-shuaib-al-awadi-advocates-and-legal-consultants-llc",
    "name": "Majid Bin Qaish and Shuaib Al Awadi Advocates and Legal Consultants LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1CCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Majid Bin Qaish and Shuaib Al Awadi Advocates and Legal Consultants LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c5680458-2c9d-4f8a-853a-1eec5b03bc2e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3821, 3851",
    "owner": "Shuaib Aziz Muhammad Sharif Al-Awadi"
  },
  {
    "id": "1a1a5a74-11ca-4cec-90c1-05a63cb6cf36",
    "slug": "shamma-salem-saeed-bin-hashel-al-tunaiji",
    "name": "Shamma Salem Saeed bin Hashel Al Tunaiji",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Shamma Salem Saeed bin Hashel Al Tunaiji",
    "consultationFee": 400,
    "emirate": "Sharjah",
    "verified": true,
    "offices": [
      {
        "id": "office_1a1a5a74-11ca-4cec-90c1-05a63cb6cf36",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Sharjah",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2642",
    "company": "Khalifa Al Khatri Advocates and Legal Consultants, Sharjah"
  },
  {
    "id": "0a1251bb-3b75-4f91-82e0-238e32515be3",
    "slug": "al-rowad-advocates-and-legal-consultants-dubai",
    "name": "Al Rowad Advocates and Legal Consultants - Dubai",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFSCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Al Rowad Advocates and Legal Consultants - Dubai",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_0a1251bb-3b75-4f91-82e0-238e32515be3",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3042",
    "owner": "Shamaa Mohammed Hassan Al Marzouqi"
  },
  {
    "id": "2e4c5041-9dcf-45e1-82a7-3621f72a6dbd",
    "slug": "shama-musabah-saeed-khalaf-al-kaabi",
    "name": "Shama Musabah Saeed Khalaf Al Kaabi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Shama Musabah Saeed Khalaf Al Kaabi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_2e4c5041-9dcf-45e1-82a7-3621f72a6dbd",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4014",
    "company": "Shama Musabah Al Kaabi Law Firm and Legal Consultations."
  },
  {
    "id": "da666512-5648-42d3-8940-68099e71eab3",
    "slug": "shamsa-ali-rashid-saif-al-baddawi",
    "name": "Shamsa Ali Rashid Saif Al-Baddawi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Shamsa Ali Rashid Saif Al-Baddawi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_da666512-5648-42d3-8940-68099e71eab3",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3084",
    "company": "Shamsa Al-Badwawi Advocates and Legal Consultants"
  },
  {
    "id": "eef3393c-bac8-4420-bb50-0bf33e594187",
    "slug": "khaled-abdullah-al-tamimi-law-firm-and-legal-consultations",
    "name": "Khaled Abdullah Al Tamimi Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEtBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Khaled Abdullah Al Tamimi Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_eef3393c-bac8-4420-bb50-0bf33e594187",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4258",
    "owner": "Shamsa Ibrahim Sahib Khan Al Mandoos"
  },
  {
    "id": "fbc5341c-aaf0-4d4c-868b-e733908c4898",
    "slug": "shamsa-jamal-saeed-hamdan-al-shamsi",
    "name": "Shamsa Jamal Saeed Hamdan Al Shamsi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Shamsa Jamal Saeed Hamdan Al Shamsi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_fbc5341c-aaf0-4d4c-868b-e733908c4898",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4475",
    "company": "Mohammed Saeed Al Shamsi Advocates and Legal Consultations"
  },
  {
    "id": "d6318781-f42a-4f3d-b5f1-d21c3c8805b4",
    "slug": "global-lawyers-and-legal-consultants-abu-dhabi",
    "name": "Global Lawyers and Legal Consultants - Abu Dhabi",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEdMCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Global Lawyers and Legal Consultants - Abu Dhabi",
    "consultationFee": 500,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_d6318781-f42a-4f3d-b5f1-d21c3c8805b4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "443, 3550",
    "owner": "Shamsa Muhammad Abdel-Razzaq Muhammad Al-Khoury"
  },
  {
    "id": "75d5638c-c23c-44d1-856a-a58cb3611f46",
    "slug": "shamsa-hashem-salem-khadim-al-wahshi",
    "name": "Shamsa Hashem Salem Khadim Al Wahshi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Shamsa Hashem Salem Khadim Al Wahshi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_75d5638c-c23c-44d1-856a-a58cb3611f46",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4526",
    "company": "Hamdan Al Kaabi Law Firm and Legal Consultations"
  },
  {
    "id": "3dde434b-45a3-4ab1-803a-35391bf665ce",
    "slug": "youssef-al-sharif-advocates-and-legal-consultants-sae-y-m-m",
    "name": "Youssef Al Sharif Advocates and Legal Consultants S.A.E. y. M. M.",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFlBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Youssef Al Sharif Advocates and Legal Consultants S.A.E. y. M. M.",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_3dde434b-45a3-4ab1-803a-35391bf665ce",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4246",
    "owner": "Youssef Abdel Ghaffar Al Sharif Al Ali witnessed"
  },
  {
    "id": "69ced5bd-ebbe-447c-9330-638acd1bf50c",
    "slug": "shawq-mohsen-badr-bin-kada-al-kathiri",
    "name": "Shawq Mohsen Badr bin Kada Al Kathiri",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Shawq Mohsen Badr bin Kada Al Kathiri",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_69ced5bd-ebbe-447c-9330-638acd1bf50c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "471",
    "company": "Shouq Al Kathiri Advocates and Legal Consultants"
  },
  {
    "id": "2284ffae-6756-4f7b-b62f-681fe17c46a7",
    "slug": "sheikha-saif-obaid-saif-al-kindi",
    "name": "Sheikha Saif Obaid Saif Al Kindi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Sheikha Saif Obaid Saif Al Kindi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_2284ffae-6756-4f7b-b62f-681fe17c46a7",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3615",
    "company": "Sheikha Saif Al Kindi Advocates and Legal Consultants"
  },
  {
    "id": "f0ebe4e9-b143-4b3a-b788-4f6ebd368763",
    "slug": "al-saif-law-firm-and-legal-consultations",
    "name": "Al Saif Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Al Saif Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_f0ebe4e9-b143-4b3a-b788-4f6ebd368763",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4482",
    "owner": "Sheikha Muhammad Ibrahim Al-Ghamlassi"
  },
  {
    "id": "ed9baf18-1565-4377-a864-c70493a72008",
    "slug": "sheikh-ahmed-abdullah-sultan",
    "name": "Sheikh Ahmed Abdullah Sultan",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Sheikh Ahmed Abdullah Sultan",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_ed9baf18-1565-4377-a864-c70493a72008",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "948",
    "company": "Sheikha Ahmed Advocates and Legal Consultants"
  },
  {
    "id": "7ac9b912-de3f-4900-aaae-baa8b1c47509",
    "slug": "sheikh-saqr-saif-saleh-al-mansouri",
    "name": "Sheikh Saqr Saif Saleh Al Mansouri",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Sheikh Saqr Saif Saleh Al Mansouri",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_7ac9b912-de3f-4900-aaae-baa8b1c47509",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3334",
    "company": "Sheikha Saqr Al Mansouri & Partners Advocates and Legal Consultants"
  },
  {
    "id": "cd3a34a7-99e1-4ff1-bd06-f6e2c6b4a591",
    "slug": "sheikh-abdullah-rashid-juma-al-shamsi",
    "name": "Sheikh Abdullah Rashid Juma Al Shamsi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Sheikh Abdullah Rashid Juma Al Shamsi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_cd3a34a7-99e1-4ff1-bd06-f6e2c6b4a591",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4079",
    "company": "Mohammed Nakhira Al Dhaheri Advocates and Legal Consultants"
  },
  {
    "id": "ed7bed30-a385-4eb2-80cb-6e343440e9b3",
    "slug": "sheikh-ali-hamad-bin-afaid-al-qaidi",
    "name": "Sheikh Ali Hamad bin Afaid Al-Qaidi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Sheikh Ali Hamad bin Afaid Al-Qaidi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_ed7bed30-a385-4eb2-80cb-6e343440e9b3",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3769",
    "company": "Sheikha Ali Al-Qaidi Advocates and Legal Consultants"
  },
  {
    "id": "bcb76243-6479-42e3-8b92-2603dd1dd524",
    "slug": "maryam-obaid-al-balushi-law-office-and-legal-consultations",
    "name": "Maryam Obaid Al Balushi Law Office and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1PCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Maryam Obaid Al Balushi Law Office and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_bcb76243-6479-42e3-8b92-2603dd1dd524",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4604",
    "owner": "Sheikha Awad Salem Aida Al Kathiri"
  },
  {
    "id": "32fc1522-165a-4f1b-adaf-38cb82b14043",
    "slug": "sheikh-ghalib-muhammad-saeed-al-mansouri",
    "name": "Sheikh Ghalib Muhammad Saeed Al Mansouri",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Sheikh Ghalib Muhammad Saeed Al Mansouri",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_32fc1522-165a-4f1b-adaf-38cb82b14043",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4591",
    "company": "Sheikha Ghaleb Al Mansouri Advocates and Legal Consultants"
  },
  {
    "id": "d0cf24e1-66da-4250-91f2-3aef10edd224",
    "slug": "sheikh-muhammad-suleiman-saif-al-hosani",
    "name": "Sheikh Muhammad Suleiman Saif Al Hosani",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Sheikh Muhammad Suleiman Saif Al Hosani",
    "consultationFee": 400,
    "emirate": "Fujairah",
    "verified": true,
    "offices": [
      {
        "id": "office_d0cf24e1-66da-4250-91f2-3aef10edd224",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Fujairah",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4416",
    "company": "Al Zahmi Advocates and Legal Consultants - Fujairah"
  },
  {
    "id": "9b65bd35-20bb-4948-bf6c-32c889f19164",
    "slug": "shaima-jamal-al-ameri-advocates-and-legal-consultants-llc",
    "name": "Shaima Jamal Al Ameri Advocates and Legal Consultants LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNKCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Shaima Jamal Al Ameri Advocates and Legal Consultants LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_9b65bd35-20bb-4948-bf6c-32c889f19164",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3478",
    "owner": "Shaima Jamal Jaafar Al-Amiri"
  },
  {
    "id": "d13cc877-5098-4437-a853-69dfc917bc78",
    "slug": "lutfi-partners-advocates-and-legal-consultants-sharjah",
    "name": "Lutfi & Partners Advocates and Legal Consultants - Sharjah",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIExQCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Lutfi & Partners Advocates and Legal Consultants - Sharjah",
    "consultationFee": 500,
    "emirate": "Sharjah",
    "verified": true,
    "offices": [
      {
        "id": "office_d13cc877-5098-4437-a853-69dfc917bc78",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Sharjah",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2615",
    "owner": "Shaima Salem Abdullah bin Suwaidan Al-Qaidi"
  },
  {
    "id": "0dfd343b-7bbf-42d5-9db0-7235087f3a0f",
    "slug": "shaima-saif-ahmed-saif-al-shehhi",
    "name": "Shaima Saif Ahmed Saif Al Shehhi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Shaima Saif Ahmed Saif Al Shehhi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_0dfd343b-7bbf-42d5-9db0-7235087f3a0f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3381",
    "company": "Shaima Saif Al Shehhi Law Firm and Legal Consultations"
  },
  {
    "id": "0729cdd2-bd36-40ab-84b2-be43bd1f7fa6",
    "slug": "shaima-abdullah-mohammed-barot-al-hammadi",
    "name": "Shaima Abdullah Mohammed Barot Al Hammadi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Shaima Abdullah Mohammed Barot Al Hammadi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_0729cdd2-bd36-40ab-84b2-be43bd1f7fa6",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2337",
    "company": "Shaima Al Hammadi Advocates and Legal Consultants"
  },
  {
    "id": "48784e2c-57bb-47a7-86fd-5169e076c100",
    "slug": "shaima-ghanem-saeed-khalfan-al-kaabi",
    "name": "Shaima Ghanem Saeed Khalfan Al Kaabi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Shaima Ghanem Saeed Khalfan Al Kaabi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_48784e2c-57bb-47a7-86fd-5169e076c100",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4046",
    "company": "Khalfan Al Kaabi Advocates and Legal Consultants"
  },
  {
    "id": "5da278e2-40b4-4f1a-a9a9-9d2f2c0b2d81",
    "slug": "ahmed-abdullah-al-dhaheri-law-firm-and-legal-consultations",
    "name": "Ahmed Abdullah Al Dhaheri Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Ahmed Abdullah Al Dhaheri Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_5da278e2-40b4-4f1a-a9a9-9d2f2c0b2d81",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3695, 4608",
    "owner": "Saleh Rabie Hassan Ali Al-Sayari"
  },
  {
    "id": "3546c503-8426-491e-8c19-e501aaa8d71b",
    "slug": "saleh-ramadan-al-qablan-law-firm-and-legal-consultations",
    "name": "Saleh Ramadan Al Qablan Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNSCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Saleh Ramadan Al Qablan Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_3546c503-8426-491e-8c19-e501aaa8d71b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4538",
    "owner": "Saleh Ramadan Abdullah Muhammad Al-Qablan"
  },
  {
    "id": "b88f9c93-371d-4955-a9fa-23228568a339",
    "slug": "saleh-abdul-rahman-saif-al-saleh",
    "name": "Saleh Abdul Rahman Saif Al Saleh",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Saleh Abdul Rahman Saif Al Saleh",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_b88f9c93-371d-4955-a9fa-23228568a339",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3788",
    "company": "Saleh Al Saleh Law Firm and Legal Consultations"
  },
  {
    "id": "5125a51a-e8a1-4148-97bb-20dec001582d",
    "slug": "saleh-abdullah-mubarak-al-sanani",
    "name": "Saleh Abdullah Mubarak Al-Sanani",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Saleh Abdullah Mubarak Al-Sanani",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_5125a51a-e8a1-4148-97bb-20dec001582d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "210",
    "company": "Saleh Al-Sanani Law Firm and Legal Consultations"
  },
  {
    "id": "317a2704-f61e-478d-aecb-6b02ba0deada",
    "slug": "sabiha-salem-mohammed-salem-al-saridi",
    "name": "Sabiha Salem Mohammed Salem Al-Saridi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Sabiha Salem Mohammed Salem Al-Saridi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_317a2704-f61e-478d-aecb-6b02ba0deada",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "986",
    "company": "Sabiha Salem Al-Saridi Advocates and Legal Consultants"
  },
  {
    "id": "102c0130-baca-4db5-83c6-6e1962a83a93",
    "slug": "saleha-al-basti-advocates-and-legal-consultants-dubai",
    "name": "Saleha Al Basti Advocates and Legal Consultants, Dubai",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Saleha Al Basti Advocates and Legal Consultants, Dubai",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_102c0130-baca-4db5-83c6-6e1962a83a93",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4308",
    "owner": "Safaa Muhammad Sanqur Qambar Al-Mazmi"
  },
  {
    "id": "59a43fe7-b7ae-4f35-89c8-ac8e7caa6557",
    "slug": "safaa-muhammad-abdullah-salem-al-jabri",
    "name": "Safaa Muhammad Abdullah Salem Al Jabri",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Safaa Muhammad Abdullah Salem Al Jabri",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_59a43fe7-b7ae-4f35-89c8-ac8e7caa6557",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2552",
    "company": "Safaa Mohammed Al Jabri Advocates and Legal Consultations LLC. and"
  },
  {
    "id": "d3367706-4dcf-47a8-b885-f0e47d5bf3b5",
    "slug": "saqr-ibrahim-saqr-al-marzouqi",
    "name": "Saqr Ibrahim Saqr Al Marzouqi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Saqr Ibrahim Saqr Al Marzouqi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_d3367706-4dcf-47a8-b885-f0e47d5bf3b5",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2250",
    "company": "Dr. Saqr Al Marzouqi Advocates and Legal Consultants"
  },
  {
    "id": "a1b83066-28f0-428f-9383-6b0396deab8f",
    "slug": "salah-hassan-mohamed-mubasheri",
    "name": "Salah Hassan Mohamed Mubasheri",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Salah Hassan Mohamed Mubasheri",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_a1b83066-28f0-428f-9383-6b0396deab8f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "1096",
    "company": "Al Mubasheri Law Firm and Legal Consultations"
  },
  {
    "id": "570af548-391e-4d6d-a5f5-c8552a789bc2",
    "slug": "salah-mohammed-al-hassani-law-firm-and-legal-consultations",
    "name": "Salah Mohammed Al-Hassani Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Salah Mohammed Al-Hassani Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_570af548-391e-4d6d-a5f5-c8552a789bc2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "710",
    "owner": "Salah Muhammad Hussein Al-Hasani"
  },
  {
    "id": "6d3ff243-94a7-49ed-a299-18c88ff6aacf",
    "slug": "tarish-eid-muhammad-bin-ghawaifa-al-mansouri",
    "name": "Tarish Eid Muhammad bin Ghawaifa Al Mansouri",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBURQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Tarish Eid Muhammad bin Ghawaifa Al Mansouri",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_6d3ff243-94a7-49ed-a299-18c88ff6aacf",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4731",
    "company": "Tarish Al Mansouri Advocates and Legal Consultations LLC"
  },
  {
    "id": "53c5b75d-214a-453f-a155-2b56a877ebbc",
    "slug": "tariq-hussein-abdul-latif-al-sarkal",
    "name": "Tariq Hussein Abdul Latif Al Sarkal",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Tariq Hussein Abdul Latif Al Sarkal",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_53c5b75d-214a-453f-a155-2b56a877ebbc",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "371",
    "company": "Tariq Al Sarkal Law Firm and Legal Consultations"
  },
  {
    "id": "2af94e26-e6bf-4c21-a7af-76f3527fac45",
    "slug": "makki-law-firm-and-legal-consultations-ajman",
    "name": "Makki Law Firm and Legal Consultations / Ajman",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1MCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Makki Law Firm and Legal Consultations / Ajman",
    "consultationFee": 500,
    "emirate": "Ajman",
    "verified": true,
    "offices": [
      {
        "id": "office_2af94e26-e6bf-4c21-a7af-76f3527fac45",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Ajman",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "250",
    "owner": "Tariq Makki Jaafar"
  },
  {
    "id": "f28eb107-3ec7-4abf-8ab0-69d45ba5bc64",
    "slug": "talal-hassan-muslim-khawars-top-scorer",
    "name": "Talal Hassan, Muslim Khawar's top scorer",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Talal Hassan, Muslim Khawar's top scorer",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_f28eb107-3ec7-4abf-8ab0-69d45ba5bc64",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4511",
    "company": "Maryam Ahmed Salem Law Office"
  },
  {
    "id": "a050b106-a842-4af1-9f9f-bd7065f3e9a3",
    "slug": "talal-mohammed-ghanem-al-habtari",
    "name": "Talal Mohammed Ghanem Al Habtari",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiM1MTczZTI7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Talal Mohammed Ghanem Al Habtari",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_a050b106-a842-4af1-9f9f-bd7065f3e9a3",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3914",
    "company": "Talal Mohammed Al Habtari Advocates and Legal Consultants"
  },
  {
    "id": "56ee3be8-9d80-43c6-ad1a-34725fdf1b96",
    "slug": "hind-mohammed-al-owais-advocates-and-legal-consultants",
    "name": "Hind Mohammed Al Owais Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Hind Mohammed Al Owais Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_56ee3be8-9d80-43c6-ad1a-34725fdf1b96",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2264, 2511, 4458",
    "owner": "Aisha Ahmed Ibrahim Al-Kharji"
  },
  {
    "id": "28cbdcdf-7184-4127-b617-9b8541bea81b",
    "slug": "aisha-hassan-ali-yousef-al-balushi",
    "name": "Aisha Hassan Ali Yousef Al Balushi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Aisha Hassan Ali Yousef Al Balushi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_28cbdcdf-7184-4127-b617-9b8541bea81b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4091",
    "company": "Aisha Hassan Advocates and Legal Consultants"
  },
  {
    "id": "3633bcd3-6641-471f-9244-9510a11dabe4",
    "slug": "aisha-saeed-hamid-musabeh-al-hindassi",
    "name": "Aisha Saeed Hamid Musabeh Al-Hindassi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Aisha Saeed Hamid Musabeh Al-Hindassi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_3633bcd3-6641-471f-9244-9510a11dabe4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4088",
    "company": "Aisha Saeed Al-Hindassi Advocates and Legal Consultants"
  },
  {
    "id": "27ae903f-6d4e-4dba-85af-57dbc9f648ad",
    "slug": "aisha-abdul-latif-dhaen-abdullah-al-dhaen",
    "name": "Aisha Abdul Latif Dhaen Abdullah Al Dhaen",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Aisha Abdul Latif Dhaen Abdullah Al Dhaen",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_27ae903f-6d4e-4dba-85af-57dbc9f648ad",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4481",
    "company": "Ahmed Dhaen Al-Dhaen Law Firm and Legal Consultations"
  },
  {
    "id": "1b29a5f3-9b30-4a1c-aa97-a657948ae103",
    "slug": "aisha-muhammad-saleh-ahmed-al-marzouqi",
    "name": "Aisha Muhammad Saleh Ahmed Al Marzouqi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Aisha Muhammad Saleh Ahmed Al Marzouqi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_1b29a5f3-9b30-4a1c-aa97-a657948ae103",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3955",
    "company": "Ali Jassim Law Firm and Legal Consultations"
  },
  {
    "id": "7579f255-31b9-4e9c-948d-8c3ab153b24d",
    "slug": "ahmed-khamis-al-zeyoudi-advocates-and-legal-consultants",
    "name": "Ahmed Khamis Al-Zeyoudi Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFLCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Ahmed Khamis Al-Zeyoudi Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_7579f255-31b9-4e9c-948d-8c3ab153b24d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3543",
    "owner": "Aisha Muhammad Omar Al-Bannai"
  },
  {
    "id": "a6090983-0129-47a8-a7c0-3d5e987e5f3e",
    "slug": "aisha-nasser-muhammad-al-zarouni",
    "name": "Aisha Nasser Muhammad Al Zarouni",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Aisha Nasser Muhammad Al Zarouni",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_a6090983-0129-47a8-a7c0-3d5e987e5f3e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2304",
    "company": "Ali Al-Shawab Advocates and Legal Consultants"
  },
  {
    "id": "555b11cd-5509-475e-8b08-f623f7a96b4e",
    "slug": "fatima-abdullah-belfaqih-law-firm-and-legal-consultations-one-person-company-llc",
    "name": "Fatima Abdullah Belfaqih Law Firm and Legal Consultations - One Person Company LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEZBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Fatima Abdullah Belfaqih Law Firm and Legal Consultations - One Person Company LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_555b11cd-5509-475e-8b08-f623f7a96b4e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4396",
    "owner": "Aisha Ahmed Sultan Khamis Al Kaabi"
  },
  {
    "id": "511f6fca-4e8d-4ec6-a94c-2ac91c50b6cd",
    "slug": "aisha-khalaf-obaid-al-mazroui",
    "name": "Aisha Khalaf Obaid Al Mazroui",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Aisha Khalaf Obaid Al Mazroui",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_511f6fca-4e8d-4ec6-a94c-2ac91c50b6cd",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4224",
    "company": "Aisha Khalaf Al Mazroui Advocates and Legal Consultants"
  },
  {
    "id": "e9191e18-7e9a-4a1f-aeb3-45f58a7d1a59",
    "slug": "aisha-al-taniji-advocates-and-legal-consultants-llc",
    "name": "Aisha Al Taniji Advocates and Legal Consultants LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Aisha Al Taniji Advocates and Legal Consultants LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e9191e18-7e9a-4a1f-aeb3-45f58a7d1a59",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "596",
    "owner": "Aisha Rashid Mohammed Abbas Al-Taniji"
  },
  {
    "id": "3acb82d6-2163-4ef5-b539-b09b2785697c",
    "slug": "aisha-sabt-gohar-suwayd-al-dhaheri",
    "name": "Aisha Sabt Gohar Suwayd Al Dhaheri",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Aisha Sabt Gohar Suwayd Al Dhaheri",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_3acb82d6-2163-4ef5-b539-b09b2785697c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4153",
    "company": "Aisha Al Dhaheri Advocates and Legal Consultants"
  },
  {
    "id": "c932cf0f-deab-42d0-8d63-0f17e30790c0",
    "slug": "aisha-saud-obaid-harmoul-al-shamsi",
    "name": "Aisha Saud Obaid Harmoul Al Shamsi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Aisha Saud Obaid Harmoul Al Shamsi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c932cf0f-deab-42d0-8d63-0f17e30790c0",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4561",
    "company": "Aisha Harmoul Al Shamsi Advocates and Legal Consultants"
  },
  {
    "id": "7e4eb493-8002-4b6f-aa44-52c96ff1cbd1",
    "slug": "mohammed-abdullah-al-ameri-law-firm-and-legal-consultations",
    "name": "Mohammed Abdullah Al Ameri Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Mohammed Abdullah Al Ameri Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_7e4eb493-8002-4b6f-aa44-52c96ff1cbd1",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2724, 8888",
    "owner": "Aisha Saeed Ali Al-Hamidi Al-Yamahi"
  },
  {
    "id": "4ac25b4f-997d-4243-9f8d-5b7093af1141",
    "slug": "aisha-abdul-salam-muhammad-al-jaziri",
    "name": "Aisha Abdul Salam Muhammad Al-Jaziri",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Aisha Abdul Salam Muhammad Al-Jaziri",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_4ac25b4f-997d-4243-9f8d-5b7093af1141",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3119",
    "company": "Aisha Al-Jaziri Advocates and Legal Consultants"
  },
  {
    "id": "a8b35ba2-453c-4a42-b5ac-8a27ff0fa619",
    "slug": "aisha-issa-al-awadhi-advocates-and-legal-consultations-llc",
    "name": "Aisha Issa Al-Awadhi Advocates and Legal Consultations LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFJCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Aisha Issa Al-Awadhi Advocates and Legal Consultations LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_a8b35ba2-453c-4a42-b5ac-8a27ff0fa619",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4022",
    "owner": "Aisha Issa Yousef Ahmed Al-Awadi"
  },
  {
    "id": "0b09591e-d79c-4345-90a5-456ad12d9096",
    "slug": "abdullah-al-yasi-law-firm-and-legal-consultations",
    "name": "Abdullah Al Yasi Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Abdullah Al Yasi Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_0b09591e-d79c-4345-90a5-456ad12d9096",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3216, 4629",
    "owner": "Aisha Muhammad Ahmed Nasser Al-Yasi"
  },
  {
    "id": "e5df41d4-6db2-4c4f-a25d-587cb089f1bd",
    "slug": "hamad-saeed-al-ketbi-advocates-and-legal-consultants",
    "name": "Hamad Saeed Al Ketbi Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Hamad Saeed Al Ketbi Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e5df41d4-6db2-4c4f-a25d-587cb089f1bd",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3475, 4717",
    "owner": "Aisha Muhammad Ismail Muhammad Al-Harmoudi"
  },
  {
    "id": "11468b52-c1ca-42ad-968a-f0e5e84070d6",
    "slug": "aisha-marwan-saif-obaid-al-zaabi",
    "name": "Aisha Marwan Saif Obaid Al Zaabi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Aisha Marwan Saif Obaid Al Zaabi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_11468b52-c1ca-42ad-968a-f0e5e84070d6",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4446",
    "company": "Dr. Sarhan Al-Muaini Advocates and Legal Consultants"
  },
  {
    "id": "b3637d77-7413-415c-b528-c9ce13cbea8b",
    "slug": "faisal-hamad-al-balushi-advocates-and-legal-consultants",
    "name": "Faisal Hamad Al Balushi Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEZICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Faisal Hamad Al Balushi Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_b3637d77-7413-415c-b528-c9ce13cbea8b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4643",
    "owner": "Abed Abdullah Hamad Al-Dahba Al-Amiri"
  },
  {
    "id": "ea595629-1e2f-47e1-a9c2-1416221f9eff",
    "slug": "adel-hussein-falouh-badr-al-rabia",
    "name": "Adel Hussein Falouh Badr Al Rabia",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Adel Hussein Falouh Badr Al Rabia",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_ea595629-1e2f-47e1-a9c2-1416221f9eff",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3674",
    "company": "Adel Hussein Al Rabia Law Firm and Legal Consultations"
  },
  {
    "id": "ff9aa173-95ad-41a8-abaf-472c553737ca",
    "slug": "adel-salem-al-ghaferi-law-firm-and-legal-consultations",
    "name": "Adel Salem Al-Ghaferi Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Adel Salem Al-Ghaferi Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_ff9aa173-95ad-41a8-abaf-472c553737ca",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2243, 4509",
    "owner": "Adel Salem Abdullah Salem Al-Ghafri"
  },
  {
    "id": "e9a3d1e1-b2a3-40a2-a641-ce2aa6b0a0c8",
    "slug": "adel-abdel-qader-hamid-fakher",
    "name": "Adel Abdel Qader Hamid Fakher",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Adel Abdel Qader Hamid Fakher",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e9a3d1e1-b2a3-40a2-a641-ce2aa6b0a0c8",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2288",
    "company": "Adel Fakher Advocates and Legal Consultants"
  },
  {
    "id": "535d2c22-6df4-495e-93a6-96ffd3674a0b",
    "slug": "abdullah-bin-hamad-al-muhairi-law-firm-and-legal-consultations-office",
    "name": "Abdullah bin Hamad Al Muhairi Law Firm and Legal Consultations Office",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFCCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Abdullah bin Hamad Al Muhairi Law Firm and Legal Consultations Office",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_535d2c22-6df4-495e-93a6-96ffd3674a0b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4267",
    "owner": "Adel Obaid Mubarak Al Sharif Al Ali"
  },
  {
    "id": "0a23e304-00d7-4164-8c08-7e868deb2a53",
    "slug": "adel-mohammed-saif-saeed-al-kaabi",
    "name": "Adel Mohammed Saif Saeed Al Kaabi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Adel Mohammed Saif Saeed Al Kaabi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_0a23e304-00d7-4164-8c08-7e868deb2a53",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "880",
    "company": "Hamdan Dhahi Al Kaabi Law Firm, Legal Consultations"
  },
  {
    "id": "7e96da60-4f5a-4301-a16c-12afe034467b",
    "slug": "arif-salem-al-menhali-law-firm-and-legal-consultations-office",
    "name": "Arif Salem Al Menhali Law Firm and Legal Consultations Office",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Arif Salem Al Menhali Law Firm and Legal Consultations Office",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_7e96da60-4f5a-4301-a16c-12afe034467b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4066, 4466",
    "owner": "Arif Salem Al-Abd Al-Menhali"
  },
  {
    "id": "d6a01ee6-e8a4-4c57-a563-4c9876fec531",
    "slug": "arif-muhammad-abdulaziz-ahmed-al-suwaidi",
    "name": "FALIM SALEM SAEED SAIF SAEED ALSHAMSI",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/05/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Arif Muhammad Abdulaziz Ahmed Al Suwaidi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_d6a01ee6-e8a4-4c57-a563-4c9876fec531",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "L-2097",
    "company": "Hassan Al-Abdouli Law Firm and Legal Consultations"
  },
  {
    "id": "4064c299-562a-48bb-90d2-0edf904a418c",
    "slug": "arif-muhammad-obaid-bushaqar-al-falasi",
    "name": "Arif Muhammad Obaid Bushaqar Al Falasi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Arif Muhammad Obaid Bushaqar Al Falasi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_4064c299-562a-48bb-90d2-0edf904a418c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4408",
    "company": "Arif Bushkar Advocates and Legal Consultants"
  },
  {
    "id": "c35e7a1c-e1c0-4b78-b74e-4e20512397cf",
    "slug": "abdel-aziz-ali-gomaa-salehi",
    "name": "Abdel Aziz Ali Gomaa Salehi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abdel Aziz Ali Gomaa Salehi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c35e7a1c-e1c0-4b78-b74e-4e20512397cf",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4542",
    "company": "Abdulaziz Ali Salehi Law Firm and Legal Consultations"
  },
  {
    "id": "118246c5-2914-4a5e-995a-82535f6c81cb",
    "slug": "abdul-basit-abdullah-al-junaibi-advocates-and-legal-consultations-llc",
    "name": "Abdul Basit Abdullah Al Junaibi Advocates and Legal Consultations LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFCCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Abdul Basit Abdullah Al Junaibi Advocates and Legal Consultations LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_118246c5-2914-4a5e-995a-82535f6c81cb",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3688",
    "owner": "Abdul Basit Abdullah Hamad Yousef Al-Junaibi"
  },
  {
    "id": "0d07a7d6-e0a6-468a-9a46-ea67945246c0",
    "slug": "abdul-jawad-al-qasim-law-office-and-legal-consultations",
    "name": "Abdul Jawad Al Qasim Law Office and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFKCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Abdul Jawad Al Qasim Law Office and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_0d07a7d6-e0a6-468a-9a46-ea67945246c0",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4043",
    "owner": "Abdul-Jawad Abdul-Aziz Muhammad Al-Qasim"
  },
  {
    "id": "7e4466e6-e643-44e7-bd33-5b158a7f0413",
    "slug": "abdul-hakim-bin-harz-law-firm-and-legal-consultations",
    "name": "Abdul Hakim Bin Harz Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Abdul Hakim Bin Harz Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_7e4466e6-e643-44e7-bd33-5b158a7f0413",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2305, 4352",
    "owner": "Abdul Hakim Habib Mansour bin Haraz"
  },
  {
    "id": "985b5200-1c2a-4979-a57f-465ada3b2ce9",
    "slug": "abdul-hakim-ali-hussein-al-khulaifi",
    "name": "Abdul Hakim Ali Hussein Al-Khulaifi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abdul Hakim Ali Hussein Al-Khulaifi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_985b5200-1c2a-4979-a57f-465ada3b2ce9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2596",
    "company": "Abdul Hakim Ali Al-Khulaifi Law Firm and Legal Consultations One Person Company LLC"
  },
  {
    "id": "c33cd5f6-d7fa-470f-86ce-1de5d9fe2c9f",
    "slug": "abdul-hamid-ghuloum-murad-yousef-saleh-al-balushi",
    "name": "Abdul Hamid Ghuloum Murad Yousef Saleh Al Balushi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abdul Hamid Ghuloum Murad Yousef Saleh Al Balushi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c33cd5f6-d7fa-470f-86ce-1de5d9fe2c9f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3167",
    "company": "Abdul Hamid Yousef Al Balushi Advocates and Legal Consultants"
  },
  {
    "id": "31ceaf1a-9c22-4600-8619-4e253942b935",
    "slug": "abdul-rahman-ahmed-law-firm-and-legal-consultations",
    "name": "Abdul Rahman Ahmed Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFSCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Abdul Rahman Ahmed Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_31ceaf1a-9c22-4600-8619-4e253942b935",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "129",
    "owner": "Abdul Rahman Ahmed Abdullah Muhammad"
  },
  {
    "id": "c7fef997-c2ab-4176-b5cd-44a5d82806c0",
    "slug": "abdul-rahman-abdul-ghaffar-al-sharif",
    "name": "Abdul Rahman Abdul Ghaffar Al Sharif",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abdul Rahman Abdul Ghaffar Al Sharif",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c7fef997-c2ab-4176-b5cd-44a5d82806c0",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "83",
    "company": "Al Sharif Lawyers and Legal Consultants"
  },
  {
    "id": "62e61584-adfa-46f8-89f6-f6dc4c645c3b",
    "slug": "abdul-rahman-abdullah-ahmed-mahmoud-al-marzouqi",
    "name": "Abdul Rahman Abdullah Ahmed Mahmoud Al Marzouqi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abdul Rahman Abdullah Ahmed Mahmoud Al Marzouqi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_62e61584-adfa-46f8-89f6-f6dc4c645c3b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4514",
    "company": "Muhammad Ali Al Hammadi Law Firm and Legal Consultations"
  },
  {
    "id": "e152032e-fba6-482e-9188-b656f47c4bec",
    "slug": "abdul-rahman-abdullah-al-harbi-law-firm-and-legal-consultations",
    "name": "Abdul Rahman Abdullah Al Harbi Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFSCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Abdul Rahman Abdullah Al Harbi Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e152032e-fba6-482e-9188-b656f47c4bec",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2743",
    "owner": "Abdul Rahman Abdullah Qasim Muhammad Al-Harbi"
  },
  {
    "id": "f2d32941-95e3-446d-ae7b-04ec49b58d3c",
    "slug": "abdul-rahman-al-musaibi-and-partners-advocates-and-legal-consultants",
    "name": "Abdul Rahman Al-Musaibi and Partners Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFSCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Abdul Rahman Al-Musaibi and Partners Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_f2d32941-95e3-446d-ae7b-04ec49b58d3c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4499",
    "owner": "Abdul Rahman Obaid Hamid Rashid Al Musabi"
  },
  {
    "id": "8e292b20-6e57-4443-afb7-d6959afb8379",
    "slug": "abdul-rahman-obaid-sahouh-al-suwaidi",
    "name": "Abdul Rahman Obaid Sahouh Al Suwaidi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abdul Rahman Obaid Sahouh Al Suwaidi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_8e292b20-6e57-4443-afb7-d6959afb8379",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4072",
    "company": "Jihad Saeed Bin Sahouh Advocates and Legal Consultants"
  },
  {
    "id": "6324a959-fe6f-4ade-a989-0fe1e9460f61",
    "slug": "abdul-rahman-ali-hussein-muhammad-al-shaali",
    "name": "Abdul Rahman Ali Hussein Muhammad Al-Shaali",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abdul Rahman Ali Hussein Muhammad Al-Shaali",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_6324a959-fe6f-4ade-a989-0fe1e9460f61",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3951",
    "company": "Abdul Rahman Al Shaali Lawyers and Legal Consultants"
  },
  {
    "id": "df9d0f87-7229-45e3-ad0a-616985505440",
    "slug": "abdul-rahman-ali-abdul-rahman-lootah",
    "name": "Abdul Rahman Ali Abdul Rahman Lootah",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abdul Rahman Ali Abdul Rahman Lootah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_df9d0f87-7229-45e3-ad0a-616985505440",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "48",
    "company": "Abdul Rahman Lootah & Partners Advocates and Legal Consultants/Dubai"
  },
  {
    "id": "9964e8c8-8d22-4a6c-9af9-e20f6258e5ff",
    "slug": "abdul-rahman-ali-ghanem-ali-al-ali",
    "name": "Abdul Rahman Ali Ghanem Ali Al Ali",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abdul Rahman Ali Ghanem Ali Al Ali",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_9964e8c8-8d22-4a6c-9af9-e20f6258e5ff",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4298",
    "company": "Hammam Bin Ramlan Advocates and Legal Consultants"
  },
  {
    "id": "78a9cc86-9efa-4de7-b639-18a99445bb65",
    "slug": "al-huquq-law-firm-llc",
    "name": "Al-Huquq Law Firm LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFMCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Al-Huquq Law Firm LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_78a9cc86-9efa-4de7-b639-18a99445bb65",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "144, 474",
    "owner": "Abdul Rahman Omar Abdullah Mukhair"
  },
  {
    "id": "7fe4e8c2-cef7-4d84-91bf-d4a4e40399ac",
    "slug": "bin-hussein-advocates-and-legal-consultations-llc",
    "name": "Bin Hussein Advocates and Legal Consultations LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEJICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Bin Hussein Advocates and Legal Consultations LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_7fe4e8c2-cef7-4d84-91bf-d4a4e40399ac",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2108",
    "owner": "Abdul Rahman Muhammad Sultan Al-Azm Al Ali"
  },
  {
    "id": "f4f793a5-c52c-462b-a0db-605ed814f095",
    "slug": "al-obaidly-and-al-zarouni-advocates-and-legal-consultants",
    "name": "Al Obaidly and Al Zarouni Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFPCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Al Obaidly and Al Zarouni Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_f4f793a5-c52c-462b-a0db-605ed814f095",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4228",
    "owner": "Abdul Rahman Muhammad Abdullah Al-Obaidli"
  },
  {
    "id": "68bc93cc-6d46-48bc-ab07-382eb9c50dfe",
    "slug": "abdul-rahman-muhammad-issa-al-ameri",
    "name": "Abdul Rahman Muhammad Issa Al Ameri",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abdul Rahman Muhammad Issa Al Ameri",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_68bc93cc-6d46-48bc-ab07-382eb9c50dfe",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3008",
    "company": "Abdul Rahman Al Ameri Advocates and Legal Consultations LLC"
  },
  {
    "id": "aefe8122-8258-48ee-9070-d57b3b4ddc0a",
    "slug": "abdul-rahman-muhammad-murad-abdul-rahman-al-mazmi",
    "name": "Abdul Rahman Muhammad Murad Abdul Rahman Al Mazmi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abdul Rahman Muhammad Murad Abdul Rahman Al Mazmi",
    "consultationFee": 400,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_aefe8122-8258-48ee-9070-d57b3b4ddc0a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "919",
    "company": "Abdul Rahman Al Mazmi Advocates and Legal Consultations - Abu Dhabi Branch"
  },
  {
    "id": "3b09e23b-b461-4cd3-bf04-1b8e9afd1bb1",
    "slug": "abdul-rahman-nasser-alawi-abdullah-al-bu-haliqa",
    "name": "Abdul Rahman Nasser Alawi Abdullah Al Bu Haliqa",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abdul Rahman Nasser Alawi Abdullah Al Bu Haliqa",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_3b09e23b-b461-4cd3-bf04-1b8e9afd1bb1",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4078",
    "company": "Dr. Abdul Rahman Nasser Al Bu Haliqa Advocates and Legal Consultants"
  },
  {
    "id": "6028d4d5-b491-416d-9d5e-5f7e1ce784da",
    "slug": "abdul-rahman-naseeb-abdul-rahman",
    "name": "Abdul Rahman Naseeb Abdul Rahman",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abdul Rahman Naseeb Abdul Rahman",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_6028d4d5-b491-416d-9d5e-5f7e1ce784da",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "851",
    "company": "Abdul Rahman Naseeb Advocates and Legal Consultants"
  },
  {
    "id": "56fb4bbe-8e13-4201-ab79-ad69b1e9c03b",
    "slug": "abdul-rahim-ismail-abdul-aziz-al-zarouni",
    "name": "ASHRAF ALI ABDULLA HASSAN BINMALEK",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/05/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abdul Rahim Ismail Abdul Aziz Al Zarouni",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_56fb4bbe-8e13-4201-ab79-ad69b1e9c03b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "L-2098",
    "company": "Abdul Rahim Law Firm and Legal Consultations"
  },
  {
    "id": "0c45f250-e796-4954-8041-3ea982892033",
    "slug": "abdul-razzaq-morgan-law-firm-and-legal-consultations",
    "name": "Abdul Razzaq Morgan Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFSCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Abdul Razzaq Morgan Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_0c45f250-e796-4954-8041-3ea982892033",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3271",
    "owner": "Abdul Razzaq Morgan Congratulations Bilal"
  },
  {
    "id": "f0afdbec-a019-4763-a894-4140f4190fce",
    "slug": "abdulaziz-ahmed-abdulaziz-ahmed-al-zarouni",
    "name": "Abdulaziz Ahmed Abdulaziz Ahmed Al-Zarouni",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abdulaziz Ahmed Abdulaziz Ahmed Al-Zarouni",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_f0afdbec-a019-4763-a894-4140f4190fce",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "823",
    "company": "Dr. Sarhan Al-Muaini Advocates and Legal Consultants"
  },
  {
    "id": "dd19de70-f51a-4f22-b3d9-21cd4c2a1c1a",
    "slug": "abdul-aziz-jassim-abdullah-abdul-razzaq-al-naqbi",
    "name": "Abdul Aziz Jassim Abdullah Abdul Razzaq Al Naqbi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abdul Aziz Jassim Abdullah Abdul Razzaq Al Naqbi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_dd19de70-f51a-4f22-b3d9-21cd4c2a1c1a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4576",
    "company": "Al-Naqbi & Partners Advocates and Legal Consultants"
  },
  {
    "id": "0d1dba38-a3de-4799-9b89-9effb0e55ca1",
    "slug": "abdulaziz-hamid-issa-sultan-al-suwaidi",
    "name": "Abdulaziz Hamid Issa Sultan Al Suwaidi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abdulaziz Hamid Issa Sultan Al Suwaidi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_0d1dba38-a3de-4799-9b89-9effb0e55ca1",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4407",
    "company": "Majid Hamad Al Kalbani Advocates and Legal Consultants"
  },
  {
    "id": "ec904f16-993f-4da2-941d-401ad05e66c7",
    "slug": "abdulaziz-daoud-saif-al-din-al-yaqoub",
    "name": "Abdulaziz Daoud Saif Al-Din Al-Yaqoub",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abdulaziz Daoud Saif Al-Din Al-Yaqoub",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_ec904f16-993f-4da2-941d-401ad05e66c7",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4047",
    "company": "Bin Suwaidan Law Firm and Legal Consultations"
  },
  {
    "id": "734580ee-fc11-42ce-a040-40b166ee95b6",
    "slug": "abdul-qader-alawi-nasser-al-haithami",
    "name": "Abdul Qader Alawi Nasser Al Haithami",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abdul Qader Alawi Nasser Al Haithami",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_734580ee-fc11-42ce-a040-40b166ee95b6",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "154",
    "company": "Al Haithami Advocates and Legal Consultations"
  },
  {
    "id": "a1be5702-cada-4487-abc8-492eb8845011",
    "slug": "abdul-karim-ahmed-abdullah-eid",
    "name": "Abdul Karim Ahmed Abdullah Eid",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abdul Karim Ahmed Abdullah Eid",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_a1be5702-cada-4487-abc8-492eb8845011",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "544",
    "company": "Bin Eid Law Firm and Legal Consultations"
  },
  {
    "id": "41a1c784-f27c-4c1f-adc1-3237c78cbf91",
    "slug": "abdul-latif-muhammad-abu-bakr-ahmed-al-hammadi",
    "name": "Abdul Latif Muhammad Abu Bakr Ahmed Al Hammadi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abdul Latif Muhammad Abu Bakr Ahmed Al Hammadi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_41a1c784-f27c-4c1f-adc1-3237c78cbf91",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "931",
    "company": "Abdul Latif Al Hammadi Law Firm and Legal Consultations"
  },
  {
    "id": "b0c9955b-694e-4f1d-add1-79a5910a2b26",
    "slug": "abdullah-ibrahim-al-mulla-advocates-and-legal-consultations-llc",
    "name": "Abdullah Ibrahim Al Mulla Advocates and Legal Consultations LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFJCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Abdullah Ibrahim Al Mulla Advocates and Legal Consultations LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_b0c9955b-694e-4f1d-add1-79a5910a2b26",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2974",
    "owner": "Abdullah Ibrahim Hassan Al-Mulla"
  },
  {
    "id": "b98aa886-26e7-4a4d-b205-cd2a8c409661",
    "slug": "abdullah-ibrahim-muhammad-ahmed-al-qasim",
    "name": "Abdullah Ibrahim Muhammad Ahmed Al-Qasim",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abdullah Ibrahim Muhammad Ahmed Al-Qasim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b98aa886-26e7-4a4d-b205-cd2a8c409661",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3382",
    "company": "Ibrahim Al Qasim Advocates and Legal Consultants/Dubai"
  },
  {
    "id": "3c7d812b-c7d1-4f9b-a549-ba53594a8c58",
    "slug": "abdullah-ahmed-abdullah-al-zaabi",
    "name": "MOHAMMED SAEED ABDULLAH ALHUMAIDI ALSHEMEILI",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/12/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abdullah Ahmed Abdullah Al Zaabi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_3c7d812b-c7d1-4f9b-a549-ba53594a8c58",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "L-770",
    "company": "Abdullah Ahmed Law Firm and Legal Consultations"
  },
  {
    "id": "90c99904-713f-4158-9b57-34008fb6371a",
    "slug": "abdullah-al-raisi-advocates-and-legal-consultants-llc",
    "name": "Abdullah Al Raisi Advocates and Legal Consultants LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Abdullah Al Raisi Advocates and Legal Consultants LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_90c99904-713f-4158-9b57-34008fb6371a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2186",
    "owner": "Abdullah Adam Muhammad Al-Raisi"
  },
  {
    "id": "6ccfd755-6e54-4e4b-957d-18e07bb7a0ee",
    "slug": "abdullah-ibrahim-al-mansouri",
    "name": "Abdullah Ibrahim Al Mansouri",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abdullah Ibrahim Al Mansouri",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_6ccfd755-6e54-4e4b-957d-18e07bb7a0ee",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2838",
    "company": "Abdullah Ibrahim Al Mansouri Advocates and Legal Consultations"
  },
  {
    "id": "56041a7e-bc53-40aa-9217-11d103ab50e4",
    "slug": "abdullah-ahmed-abdulaziz-qasim-al-haddad",
    "name": "Abdullah Ahmed Abdulaziz Qasim Al-Haddad",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abdullah Ahmed Abdulaziz Qasim Al-Haddad",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_56041a7e-bc53-40aa-9217-11d103ab50e4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4307",
    "company": "Abdullah Al-Haddad Law Firm and Legal Consultations"
  },
  {
    "id": "5df30b41-6d7e-497b-ba09-098802b47a0a",
    "slug": "abdullah-ahmed-abdullah-muhammad-ahli",
    "name": "Abdullah Ahmed Abdullah Muhammad Ahli",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abdullah Ahmed Abdullah Muhammad Ahli",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5df30b41-6d7e-497b-ba09-098802b47a0a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4496",
    "company": "Global Lawyers and Legal Consultants - Dubai"
  },
  {
    "id": "0d1a7d9e-09c8-4a22-abdb-b5174b8f6266",
    "slug": "abdullah-ahmed-othman-al-othman-al-hammadi",
    "name": "Abdullah Ahmed Othman Al Othman Al Hammadi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abdullah Ahmed Othman Al Othman Al Hammadi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_0d1a7d9e-09c8-4a22-abdb-b5174b8f6266",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4611",
    "company": "Hassan Al Riyami Advocates and Legal Consultants"
  },
  {
    "id": "9eb758e3-e0eb-44ef-b736-03b0d2eb7851",
    "slug": "abdullah-jassim-abdullah-abdul-razzaq-abdullah-al-naqbi",
    "name": "Abdullah Jassim Abdullah Abdul Razzaq Abdullah Al Naqbi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abdullah Jassim Abdullah Abdul Razzaq Abdullah Al Naqbi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_9eb758e3-e0eb-44ef-b736-03b0d2eb7851",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3966",
    "company": "Al-Naqbi & Partners Advocates and Legal Consultants"
  },
  {
    "id": "4584739b-2318-4c54-bcce-0a4fdd30fc2d",
    "slug": "abdullah-haji-law-firm-and-legal-consultations",
    "name": "Abdullah Haji Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Abdullah Haji Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_4584739b-2318-4c54-bcce-0a4fdd30fc2d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "891",
    "owner": "Abdullah Haji Gholam Ali"
  },
  {
    "id": "bfa1d0d7-f384-4f14-a024-78c1f92a6e53",
    "slug": "abdullah-al-ali-and-partners-advocates-and-legal-consultantsdubai",
    "name": "Abdullah Al Ali and Partners Advocates and Legal Consultants/Dubai",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Abdullah Al Ali and Partners Advocates and Legal Consultants/Dubai",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_bfa1d0d7-f384-4f14-a024-78c1f92a6e53",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "215",
    "owner": "Abdullah Hassan Abdullah Al-Ali"
  },
  {
    "id": "a5fc0b36-a6c0-40c5-b005-f7b85c032ee5",
    "slug": "abdullah-hussein-rashid-lootah",
    "name": "Abdullah Hussein Rashid Lootah",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abdullah Hussein Rashid Lootah",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_a5fc0b36-a6c0-40c5-b005-f7b85c032ee5",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3233",
    "company": "Mansour Lootah Advocates and Legal Consultants"
  },
  {
    "id": "10d493cb-465a-486f-939e-4c41f6c08b8b",
    "slug": "hamdan-rashoud-al-zeyoudi-advocates-and-legal-consultations",
    "name": "Hamdan Rashoud Al Zeyoudi Advocates and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhSCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Hamdan Rashoud Al Zeyoudi Advocates and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_10d493cb-465a-486f-939e-4c41f6c08b8b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4061",
    "owner": "Abdullah Hamdan Rashid Rashoud Al-Zeyoudi"
  },
  {
    "id": "8c37c582-6ba6-4ab3-8588-68b573619b7e",
    "slug": "abdullah-al-naqbi-law-firm-and-legal-consultations",
    "name": "Abdullah Al Naqbi Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Abdullah Al Naqbi Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_8c37c582-6ba6-4ab3-8588-68b573619b7e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4372",
    "owner": "Abdullah Khalaf Muhammad Abdullah Al-Naqbi"
  },
  {
    "id": "82d430e6-b1f0-4024-a896-c793f3ecca15",
    "slug": "abdullah-khamis-al-dhaheri-law-firm-and-legal-consultations",
    "name": "Abdullah Khamis Al Dhaheri Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFLCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Abdullah Khamis Al Dhaheri Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_82d430e6-b1f0-4024-a896-c793f3ecca15",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2800",
    "owner": "Abdullah Khamis Saeed Nasser Al-Dhaheri"
  },
  {
    "id": "cb94243d-e422-46da-b011-7eeedbdb0572",
    "slug": "abdullah-rashid-al-morshedy-advocates-and-legal-consultants",
    "name": "Abdullah Rashid Al Morshedy Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFSCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Abdullah Rashid Al Morshedy Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_cb94243d-e422-46da-b011-7eeedbdb0572",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3937",
    "owner": "Abdullah Rashid Saeed Al Morshedi"
  },
  {
    "id": "03a9b335-520a-4272-b8b6-75156a23d253",
    "slug": "abdullah-rashid-obaid-bukhwaisra-al-shamsi",
    "name": "Abdullah Rashid Obaid Bukhwaisra Al Shamsi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abdullah Rashid Obaid Bukhwaisra Al Shamsi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_03a9b335-520a-4272-b8b6-75156a23d253",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4480",
    "company": "Khalifa Bin Omair Advocates and Legal Consultants"
  },
  {
    "id": "f62b4163-d91f-446c-9a9e-b0aab0c9b4c2",
    "slug": "abdullah-rashid-mohammed-rashid-al-zaabi",
    "name": "Abdullah Rashid Mohammed Rashid Al Zaabi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abdullah Rashid Mohammed Rashid Al Zaabi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_f62b4163-d91f-446c-9a9e-b0aab0c9b4c2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3882",
    "company": "Abu Bakr Salem Awad"
  },
  {
    "id": "afe47199-d980-4e36-97d0-1fc74596388f",
    "slug": "abdullah-may-god-have-mercy-on-him-abdullah-al-owais",
    "name": "Abdullah, may God have mercy on him, Abdullah Al Owais",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abdullah, may God have mercy on him, Abdullah Al Owais",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_afe47199-d980-4e36-97d0-1fc74596388f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "820",
    "company": "Al Owais and Al Matroushi Advocates and Legal Consultants"
  },
  {
    "id": "10f0d8bb-bdff-4acf-9345-847c68a35813",
    "slug": "abdullah-salem-al-zaabi-advocates-and-legal-consultations-llc",
    "name": "Abdullah Salem Al Zaabi Advocates and Legal Consultations LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Abdullah Salem Al Zaabi Advocates and Legal Consultations LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_10f0d8bb-bdff-4acf-9345-847c68a35813",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4112",
    "owner": "Abdullah Salem Ibrahim Al-Yaqoub Al-Zaabi"
  },
  {
    "id": "e1a9cdde-6001-4161-9383-fe0ba77ecae3",
    "slug": "abdullah-salem-mohammed-rashid-al-qaidi",
    "name": "Abdullah Salem Mohammed Rashid Al-Qaidi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abdullah Salem Mohammed Rashid Al-Qaidi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e1a9cdde-6001-4161-9383-fe0ba77ecae3",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "777",
    "company": "Abdullah Al-Qaidi Law Firm and Legal Consultations"
  },
  {
    "id": "a563bc5b-c403-4dae-9641-1983c7468aa7",
    "slug": "mohammed-abdullah-advocates-and-legal-consultations-abu-dhabi",
    "name": "Mohammed Abdullah Advocates and Legal Consultations - Abu Dhabi",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Mohammed Abdullah Advocates and Legal Consultations - Abu Dhabi",
    "consultationFee": 500,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_a563bc5b-c403-4dae-9641-1983c7468aa7",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "705, 3730, 3962",
    "owner": "Abdullah Saeed Muhammad Salmeen Al-Mahri"
  },
  {
    "id": "79b93d4c-4988-41a3-8e72-a966ea2b57d8",
    "slug": "al-otaiba-and-hamdan-budabas-advocates-and-legal-consultants-abu-dhabi",
    "name": "Al Otaiba and Hamdan Budabas Advocates and Legal Consultants - Abu Dhabi",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFPCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Al Otaiba and Hamdan Budabas Advocates and Legal Consultants - Abu Dhabi",
    "consultationFee": 500,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_79b93d4c-4988-41a3-8e72-a966ea2b57d8",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4577",
    "owner": "Abdullah Sultan Abdullah Muhammad Al Marzouqi Al Marzouqi"
  },
  {
    "id": "890eac37-b6da-4009-b90f-c97f183b11d3",
    "slug": "angie-nabil-law-firm-and-legal-consultations-dubai-branch",
    "name": "Angie Nabil Law Firm and Legal Consultations - Dubai Branch",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFOCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Angie Nabil Law Firm and Legal Consultations - Dubai Branch",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_890eac37-b6da-4009-b90f-c97f183b11d3",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2068",
    "owner": "Abdullah Suwaiket Muhammad Al-Hajri"
  },
  {
    "id": "02268f8c-b4d2-4858-b8cc-76592c757053",
    "slug": "abdullah-saif-kharbash-saeed-al-saadi",
    "name": "Abdullah Saif Kharbash Saeed Al-Saadi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abdullah Saif Kharbash Saeed Al-Saadi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_02268f8c-b4d2-4858-b8cc-76592c757053",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3711",
    "company": "Abdullah Saif Al-Saadi Law Firm and Legal Consultations"
  },
  {
    "id": "ca455acb-f022-4386-b84c-c3a0d7c8de43",
    "slug": "abdullah-saleh-al-jafri-law-firm-llc",
    "name": "Abdullah Saleh Al Jafri Law Firm LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Abdullah Saleh Al Jafri Law Firm LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_ca455acb-f022-4386-b84c-c3a0d7c8de43",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4667",
    "owner": "Abdullah Saleh Sharif Ali Saleh Al-Jafri"
  },
  {
    "id": "34b54a3e-b318-4cd8-802a-0245334937f8",
    "slug": "abdullah-saleh-mohammed-abdul-wahed-al-marzouqi",
    "name": "Abdullah Saleh Mohammed Abdul Wahed Al Marzouqi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abdullah Saleh Mohammed Abdul Wahed Al Marzouqi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_34b54a3e-b318-4cd8-802a-0245334937f8",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2848",
    "company": "Abdullah Al Marzouqi Lawyers and Legal Consultants"
  },
  {
    "id": "5d87b4e9-c59e-4996-ac00-b26989359947",
    "slug": "abdullah-abdul-qadir-al-haithami",
    "name": "Abdullah Abdul Qadir Al Haithami",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abdullah Abdul Qadir Al Haithami",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_5d87b4e9-c59e-4996-ac00-b26989359947",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2211",
    "company": "Al Haithami Advocates and Legal Consultations"
  },
  {
    "id": "e5fa51c6-7848-407f-b9f4-cca5eb71750b",
    "slug": "ali-muhammad-al-eter-law-firm-and-legal-consultations",
    "name": "Ali Muhammad Al-Eter Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Ali Muhammad Al-Eter Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e5fa51c6-7848-407f-b9f4-cca5eb71750b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2522, 3232",
    "owner": "Abdullah Abdul Rahman Al-Sheikh Al-Janahi"
  },
  {
    "id": "4527ffbc-1195-423d-bb26-c7cd71345e3d",
    "slug": "abdullah-abdul-wahab-abdul-aziz-al-hosani",
    "name": "Abdullah Abdul Wahab Abdul Aziz Al Hosani",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abdullah Abdul Wahab Abdul Aziz Al Hosani",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_4527ffbc-1195-423d-bb26-c7cd71345e3d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3391",
    "company": "Mohammed Abdullah Al Marzouqi Advocates and Legal Consultations"
  },
  {
    "id": "3a9972b4-d037-49d9-b707-775ff98019d4",
    "slug": "maryam-hiaz-and-wijdan-bou-shehab-advocates-and-legal-consultants",
    "name": "Maryam Hiaz and Wijdan Bou Shehab Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1ICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Maryam Hiaz and Wijdan Bou Shehab Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_3a9972b4-d037-49d9-b707-775ff98019d4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2678, 2781, 4705",
    "owner": "Abdullah Obaid Juma Ghanem Al Shamsi"
  },
  {
    "id": "c6a13216-085f-4085-ba09-8b613e5619ff",
    "slug": "abdullah-obaid-suleiman-hamad-al-mutawa",
    "name": "Abdullah Obaid Suleiman Hamad Al Mutawa",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abdullah Obaid Suleiman Hamad Al Mutawa",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c6a13216-085f-4085-ba09-8b613e5619ff",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4411",
    "company": "Musab Ali Al Naqbi Advocates and Legal Consultants"
  },
  {
    "id": "7702ca42-d2cf-4f73-aa8e-adc34731cee2",
    "slug": "abdullah-aqeel-taher-advocates-and-legal-consultants",
    "name": "Abdullah Aqeel Taher Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Abdullah Aqeel Taher Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_7702ca42-d2cf-4f73-aa8e-adc34731cee2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2701",
    "owner": "Abdullah Aqeel Taher Al-Mahri"
  },
  {
    "id": "1c6a4db9-964f-4894-8092-910e1a48c94c",
    "slug": "abdullah-ali-abdullah-al-junaibi",
    "name": "Abdullah Ali Abdullah Al-Junaibi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abdullah Ali Abdullah Al-Junaibi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_1c6a4db9-964f-4894-8092-910e1a48c94c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "278",
    "company": "Abdullah Ali Al-Junaibi Advocates and Legal Consultants"
  },
  {
    "id": "c11e167b-131d-4c94-b79e-c06f10d31990",
    "slug": "abdullah-ali-muhammad-ahmed-al-obaidly",
    "name": "Abdullah Ali Muhammad Ahmed Al-Obaidly",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abdullah Ali Muhammad Ahmed Al-Obaidly",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c11e167b-131d-4c94-b79e-c06f10d31990",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2242",
    "company": "Abdullah Al-Obaidly Advocates and Legal Consultants"
  },
  {
    "id": "c58cf448-3cbb-4743-84ae-86e9dd1fca69",
    "slug": "office-of-abdullah-qahtan-al-shehhi-law-firm-and-legal-consultations",
    "name": "Office of Abdullah Qahtan Al Shehhi Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE9BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Office of Abdullah Qahtan Al Shehhi Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c58cf448-3cbb-4743-84ae-86e9dd1fca69",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3996",
    "owner": "Abdullah Qahtan Abdullah Al-Qahtan Al-Shehhi"
  },
  {
    "id": "fc36862c-5c26-486e-bc17-e404d2b4f072",
    "slug": "abdullah-mubarak-al-ameri-law-office-and-legal-consultations",
    "name": "Abdullah Mubarak Al Ameri Law Office and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Abdullah Mubarak Al Ameri Law Office and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_fc36862c-5c26-486e-bc17-e404d2b4f072",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4020",
    "owner": "Abdullah Mubarak Congratulations Omar Al-Amiri"
  },
  {
    "id": "9e84822d-6a03-4697-a2eb-e25a67eaccd1",
    "slug": "abdullah-mohammed-jaber-law-firm-and-legal-consultations",
    "name": "Abdullah Mohammed Jaber Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Abdullah Mohammed Jaber Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_9e84822d-6a03-4697-a2eb-e25a67eaccd1",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4260",
    "owner": "Abdullah Muhammad Jaber Abdullah Al-Harbi"
  },
  {
    "id": "2c55e7ad-a07a-4554-9cec-cc5882622214",
    "slug": "abdullah-mohammed-salem-hamouda-al-nuaimi",
    "name": "Abdullah Mohammed Salem Hamouda Al Nuaimi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abdullah Mohammed Salem Hamouda Al Nuaimi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_2c55e7ad-a07a-4554-9cec-cc5882622214",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2740",
    "company": "Abdullah Al Nuaimi Advocates and Legal Consultations LLC"
  },
  {
    "id": "e2ffbdb9-b68e-4fe0-8edf-cc1e7da6fbab",
    "slug": "abdullah-muhammad-saeed-hamoud-al-busaidi",
    "name": "Abdullah Muhammad Saeed Hamoud Al Busaidi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abdullah Muhammad Saeed Hamoud Al Busaidi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e2ffbdb9-b68e-4fe0-8edf-cc1e7da6fbab",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4044",
    "company": "Khaled Ateeq Al Marri Advocates and Legal Consultants"
  },
  {
    "id": "17cc907c-2768-49f1-b631-f4ab841f1fc0",
    "slug": "khalifa-bin-huwaiden-al-ketbi-advocates-and-legal-consultants",
    "name": "Khalifa bin Huwaiden Al Ketbi Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEtCCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Khalifa bin Huwaiden Al Ketbi Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_17cc907c-2768-49f1-b631-f4ab841f1fc0",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3906, 3973",
    "owner": "Abdullah Muhammad Abdul Rahman Saad"
  },
  {
    "id": "feee1051-16c4-454f-bc58-18a306c3eecd",
    "slug": "abdullah-muhammad-abdullah-al-omran-al-shamsi",
    "name": "Abdullah Muhammad Abdullah Al-Omran Al-Shamsi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abdullah Muhammad Abdullah Al-Omran Al-Shamsi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_feee1051-16c4-454f-bc58-18a306c3eecd",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "1030",
    "company": "Abdullah Al-Omran Law Firm and Legal Consultations"
  },
  {
    "id": "4f98892c-cbeb-4e09-88d7-f26ddeab899a",
    "slug": "abdullah-muhammad-abdullah-suleiman-al-qadi",
    "name": "Abdullah Muhammad Abdullah Suleiman Al-Qadi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abdullah Muhammad Abdullah Suleiman Al-Qadi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_4f98892c-cbeb-4e09-88d7-f26ddeab899a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2279",
    "company": "Abda Al-Qadi Advocates and Legal Consultants"
  },
  {
    "id": "b5ad06c9-fa62-4a48-b729-aa0e5f9beb99",
    "slug": "abdullah-muhammad-abdullah-abdul-rahman-al-bannai",
    "name": "Abdullah Muhammad Abdullah Abdul Rahman Al-Bannai",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abdullah Muhammad Abdullah Abdul Rahman Al-Bannai",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b5ad06c9-fa62-4a48-b729-aa0e5f9beb99",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "650",
    "company": "Agents are lawyers and legal consultants/Dubai"
  },
  {
    "id": "0e4358e8-4fc2-4e80-86ef-134f3af31de5",
    "slug": "abdullah-mohammed-al-yasi-law-firm-and-legal-consultations",
    "name": "Abdullah Mohammed Al Yasi Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Abdullah Mohammed Al Yasi Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_0e4358e8-4fc2-4e80-86ef-134f3af31de5",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4430",
    "owner": "Abdullah Muhammad Abdullah Abdul Rahman Al-Yasi"
  },
  {
    "id": "766bb561-bdd0-45e3-9819-dfeed1f66512",
    "slug": "abdullah-muhammad-obaid-al-maftul-al-ali",
    "name": "Abdullah Muhammad Obaid Al-Maftul Al Ali",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abdullah Muhammad Obaid Al-Maftul Al Ali",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_766bb561-bdd0-45e3-9819-dfeed1f66512",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4486",
    "company": "Abdullah Al-Maftoul Law Firm and Legal Consultations"
  },
  {
    "id": "403d2b57-a96a-46cf-a311-b52115531382",
    "slug": "abdullah-musabah-saeed-ali-al-mazroui",
    "name": "Abdullah Musabah Saeed Ali Al Mazroui",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abdullah Musabah Saeed Ali Al Mazroui",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_403d2b57-a96a-46cf-a311-b52115531382",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4508",
    "company": "Abdullah Al Mazrouei Advocates and Legal Consultants"
  },
  {
    "id": "aa7a0d0a-e31c-4f49-8c27-a0381a90c8c6",
    "slug": "abdullah-musabah-obaid-bin-hamad-al-muhairi",
    "name": "Abdullah Musabah Obaid bin Hamad Al Muhairi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abdullah Musabah Obaid bin Hamad Al Muhairi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_aa7a0d0a-e31c-4f49-8c27-a0381a90c8c6",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3040",
    "company": "Abdullah bin Hamad Al Muhairi Law Firm and Legal Consultations Office"
  },
  {
    "id": "2a0cea43-5be8-4044-91d6-86d7cd041043",
    "slug": "abdullah-matar-al-zaabi",
    "name": "Abdullah Matar Al Zaabi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abdullah Matar Al Zaabi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_2a0cea43-5be8-4044-91d6-86d7cd041043",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "86",
    "company": "Abdullah Matar Al Zaabi Law Office"
  },
  {
    "id": "956d804c-032b-49fd-96c9-1be0853e30ad",
    "slug": "abdullah-mahdi-al-otaibi-advocates-and-legal-consultations-llc",
    "name": "Abdullah Mahdi Al Otaibi Advocates and Legal Consultations LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Abdullah Mahdi Al Otaibi Advocates and Legal Consultations LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_956d804c-032b-49fd-96c9-1be0853e30ad",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3672",
    "owner": "Abdullah Mahdi Fahd Badi Al-Otaibi"
  },
  {
    "id": "f6bd5989-98bf-4c8b-9bdb-7415d5cda1d1",
    "slug": "abdullah-bin-harib-and-partners-llc-spc",
    "name": "Abdullah bin Harib and Partners LLC - S.P.C",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFCCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Abdullah bin Harib and Partners LLC - S.P.C",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_f6bd5989-98bf-4c8b-9bdb-7415d5cda1d1",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2638",
    "owner": "Abdullah Youssef Abdullah bin Hareb Al Muhairi"
  },
  {
    "id": "46ba0da4-90d8-4c13-873d-4ac2d9254a9d",
    "slug": "abdullah-yusuf-mirza-ali-hassan-al-najjar",
    "name": "Abdullah Yusuf Mirza Ali Hassan Al-Najjar",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abdullah Yusuf Mirza Ali Hassan Al-Najjar",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_46ba0da4-90d8-4c13-873d-4ac2d9254a9d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2548",
    "company": "Abdullah Al-Najjar Law Firm and Legal Consultations"
  },
  {
    "id": "7134d0ee-cb93-4b23-b5f7-7ec310f898f1",
    "slug": "drs-office-abdullah-bin-yarouf-advocates-and-legal-consultants",
    "name": "Dr.'s office Abdullah bin Yarouf Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIERPCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Dr.'s office Abdullah bin Yarouf Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_7134d0ee-cb93-4b23-b5f7-7ec310f898f1",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3894",
    "owner": "Abdul Nasser Hassan Rashid Al Zaabi"
  },
  {
    "id": "0d7aa29e-1d25-424d-b399-2d8e6dc77d2e",
    "slug": "abdul-hadi-jassim-mohammed-abdullah-al-hammadi",
    "name": "Abdul Hadi Jassim Mohammed Abdullah Al Hammadi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abdul Hadi Jassim Mohammed Abdullah Al Hammadi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_0d7aa29e-1d25-424d-b399-2d8e6dc77d2e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3638",
    "company": "Office of Lawyer Abdul Hadi Jassim Al Hammadi for Law and Legal Consultations"
  },
  {
    "id": "2784b592-421d-4abd-adc2-18ccb276e844",
    "slug": "mohammed-nakhira-al-dhaheri-advocates-and-legal-consultants",
    "name": "Mohammed Nakhira Al Dhaheri Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1OCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Mohammed Nakhira Al Dhaheri Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_2784b592-421d-4abd-adc2-18ccb276e844",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3827",
    "owner": "Abdul Wahab Mir Ahmed Abdul"
  },
  {
    "id": "794c35bf-1944-408e-b8d9-6ffaa371d860",
    "slug": "khalifa-bin-omair-advocates-and-legal-consultants",
    "name": "Khalifa Bin Omair Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEtCCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Khalifa Bin Omair Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_794c35bf-1944-408e-b8d9-6ffaa371d860",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "124",
    "owner": "Obaid Juma Al-Ghazal"
  },
  {
    "id": "9712959b-57cb-4be5-865c-bb0baba80170",
    "slug": "obaid-saleh-obaid-bin-khaseef-al-shuwaihy",
    "name": "Obaid Saleh Obaid bin Khaseef Al-Shuwaihy",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Obaid Saleh Obaid bin Khaseef Al-Shuwaihy",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_9712959b-57cb-4be5-865c-bb0baba80170",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2563",
    "company": "Khalifa Bin Omair Advocates and Legal Consultants"
  },
  {
    "id": "3fb2017d-e5fb-46e4-bd29-57e0e58e2263",
    "slug": "obaid-abdullah-mubarak-al-abri",
    "name": "Obaid Abdullah Mubarak Al Abri",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Obaid Abdullah Mubarak Al Abri",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_3fb2017d-e5fb-46e4-bd29-57e0e58e2263",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3317",
    "company": "Obaid Abdullah Al Abri Advocates and Legal Consultants"
  },
  {
    "id": "97889760-4b53-4fb3-9431-180934dd3d6c",
    "slug": "abeer-abdul-rahim-muhammad-sharif-al-ali",
    "name": "Abeer Abdul Rahim Muhammad Sharif Al Ali",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abeer Abdul Rahim Muhammad Sharif Al Ali",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_97889760-4b53-4fb3-9431-180934dd3d6c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3786",
    "company": "Prestige Law Firm and Legal Consultations"
  },
  {
    "id": "fc66e6cf-1d74-49c7-8962-b4673355af5f",
    "slug": "abeer-obaid-fares-al-dahmani",
    "name": "Abeer Obaid Fares Al-Dahmani",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abeer Obaid Fares Al-Dahmani",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_fc66e6cf-1d74-49c7-8962-b4673355af5f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2545",
    "company": "Abeer Al-Dahmani Law Firm and Legal Consultations"
  },
  {
    "id": "015ca5ee-1311-49e7-9488-72f7b2d7d891",
    "slug": "abeer-musabeh-obaid-suleiman-al-mishani",
    "name": "Abeer Musabeh Obaid Suleiman Al-Mishani",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abeer Musabeh Obaid Suleiman Al-Mishani",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_015ca5ee-1311-49e7-9488-72f7b2d7d891",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3963",
    "company": "Abeer Musabeh Obaid Advocates and Legal Consultants"
  },
  {
    "id": "43283fc3-e350-4ba1-a950-1e077ba32956",
    "slug": "othman-abdullah-may-god-have-mercy-on-him-omran-al-shamsi",
    "name": "Othman Abdullah, may God have mercy on him Omran Al Shamsi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Othman Abdullah, may God have mercy on him Omran Al Shamsi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_43283fc3-e350-4ba1-a950-1e077ba32956",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4059",
    "company": "Obaid Al Shamsi Advocates and Legal Consultants"
  },
  {
    "id": "d1990d6f-5397-4a0d-973e-e4c14527b411",
    "slug": "othman-muhammad-hassan-muhammad-al-marzouqi",
    "name": "Othman Muhammad Hassan Muhammad Al-Marzouqi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Othman Muhammad Hassan Muhammad Al-Marzouqi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_d1990d6f-5397-4a0d-973e-e4c14527b411",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4179",
    "company": "Othman Al Marzouqi Advocates and Legal Consultations"
  },
  {
    "id": "6a28f73c-9098-4910-97bf-dc88c4770a06",
    "slug": "tortured-by-hassan-hamad-ali-al-hajri",
    "name": "Tortured by Hassan Hamad Ali Al-Hajri",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Tortured by Hassan Hamad Ali Al-Hajri",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_6a28f73c-9098-4910-97bf-dc88c4770a06",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4444",
    "company": "Khalifa Bin Omair Advocates and Legal Consultants"
  },
  {
    "id": "4ac1c4e6-e5ac-434f-b942-800a48c5516b",
    "slug": "atheebah-anbar-obaid-al-mazrouei",
    "name": "Atheebah Anbar Obaid Al Mazrouei",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Atheebah Anbar Obaid Al Mazrouei",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_4ac1c4e6-e5ac-434f-b942-800a48c5516b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4452",
    "company": "Saeed Al-Dahmani Law Firm and Legal Consultations"
  },
  {
    "id": "b3cf7cac-aca8-449b-ad2e-177ade50f5b2",
    "slug": "essam-abdel-amir-al-tamimi",
    "name": "Essam Abdel Amir Al Tamimi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Essam Abdel Amir Al Tamimi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_b3cf7cac-aca8-449b-ad2e-177ade50f5b2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "153",
    "company": "Al Tamimi & Partners Advocates and Legal Consultants LLC"
  },
  {
    "id": "6aca822b-5fce-4e5b-8c25-06189f694100",
    "slug": "issam-abdul-rahman-hassan-ali-al-zarouni",
    "name": "Issam Abdul Rahman Hassan Ali Al Zarouni",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Issam Abdul Rahman Hassan Ali Al Zarouni",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_6aca822b-5fce-4e5b-8c25-06189f694100",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3891",
    "company": "Issam Al Zarouni Law Firm and Legal Consultations"
  },
  {
    "id": "7bece4d5-5c88-481d-a3cb-5948d8e9d846",
    "slug": "ismat-ibrahim-advocates-and-legal-consultantsabu-dhabi",
    "name": "Ismat Ibrahim Advocates and Legal Consultants/Abu Dhabi",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIElJCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Ismat Ibrahim Advocates and Legal Consultants/Abu Dhabi",
    "consultationFee": 500,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_7bece4d5-5c88-481d-a3cb-5948d8e9d846",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "43",
    "owner": "Ismat Ibrahim Ahmed"
  },
  {
    "id": "17755f79-207e-4654-a37d-b563a48b5cd2",
    "slug": "afaf-morgan-law-firm-and-legal-consultations",
    "name": "Afaf Morgan Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Afaf Morgan Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_17755f79-207e-4654-a37d-b563a48b5cd2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "902",
    "owner": "Afaf Morgan, Nasib Mubarak"
  },
  {
    "id": "a61d8acb-d05c-42b9-9ddf-60ef358ddc73",
    "slug": "afra-hassan-saeed-salem-al-nuaimi",
    "name": "Afra Hassan Saeed Salem Al Nuaimi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Afra Hassan Saeed Salem Al Nuaimi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_a61d8acb-d05c-42b9-9ddf-60ef358ddc73",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4683",
    "company": "Jamal Al Nuaimi Advocates and Legal Consultants"
  },
  {
    "id": "8a110bd9-3d88-456b-983b-69ee8b0f9fd3",
    "slug": "afra-abdul-rahman-obaid-khalifa-my-family",
    "name": "Afra Abdul Rahman Obaid Khalifa my family",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Afra Abdul Rahman Obaid Khalifa my family",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_8a110bd9-3d88-456b-983b-69ee8b0f9fd3",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3775",
    "company": "Khaled Ateeq Al Marri Advocates and Legal Consultants"
  },
  {
    "id": "ed8bfe08-0a7b-49e7-af2d-c4e847dce0e0",
    "slug": "afra-mukhtar-muhammad-ali-al-marzouqi",
    "name": "Afra Mukhtar Muhammad Ali Al Marzouqi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Afra Mukhtar Muhammad Ali Al Marzouqi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_ed8bfe08-0a7b-49e7-af2d-c4e847dce0e0",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4319",
    "company": "Afra Mukhtar Al Marzouqi Advocates and Legal Consultations - One Person Company LLC"
  },
  {
    "id": "65139816-38b8-456f-9a85-b6379b1c03cf",
    "slug": "alawi-al-jabri-law-firm-and-legal-consultations",
    "name": "Alawi Al Jabri Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Alawi Al Jabri Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_65139816-38b8-456f-9a85-b6379b1c03cf",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "566",
    "owner": "Alawi Ghalib Ali Saeed Al-Jabri"
  },
  {
    "id": "f02b2215-701a-4b9d-a7ae-57b20135d54b",
    "slug": "ali-ibrahim-mohammed-al-hammadi",
    "name": "Ali Ibrahim Mohammed Al Hammadi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ali Ibrahim Mohammed Al Hammadi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_f02b2215-701a-4b9d-a7ae-57b20135d54b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "976",
    "company": "Ali Ibrahim Law Firm and Legal Consultations"
  },
  {
    "id": "97194fd4-1427-4bae-b3cf-48f849f24361",
    "slug": "ali-ismail-ibrahim-al-jarman",
    "name": "Ali Ismail Ibrahim Al-Jarman",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ali Ismail Ibrahim Al-Jarman",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_97194fd4-1427-4bae-b3cf-48f849f24361",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "733",
    "company": "Prestige Law Firm and Legal Consultations"
  },
  {
    "id": "cab4429d-a52b-4df9-a680-52ae57d94d34",
    "slug": "ali-ibrahim-muhammad-dahmash-al-taniji",
    "name": "Ali Ibrahim Muhammad Dahmash Al-Taniji",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ali Ibrahim Muhammad Dahmash Al-Taniji",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_cab4429d-a52b-4df9-a680-52ae57d94d34",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3240",
    "company": "Office of Ali Ibrahim Al-Taniji Law Firm and Consultations"
  },
  {
    "id": "59a8b1e3-e8a1-4747-a4bc-7dad6328f4a0",
    "slug": "ali-ahmed-ibrahim-khatam-al-hosani",
    "name": "Ali Ahmed Ibrahim Khatam Al Hosani",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ali Ahmed Ibrahim Khatam Al Hosani",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_59a8b1e3-e8a1-4747-a4bc-7dad6328f4a0",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4556",
    "company": "Ali Ahmed Ibrahim Khatam Al Hosani Advocates and Legal Consultants LLC"
  },
  {
    "id": "c7ecbe49-3172-43f3-8c94-cd05b0f515f0",
    "slug": "ali-ahmed-hassan-al-dokki",
    "name": "Ali Ahmed Hassan Al-Dokki",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ali Ahmed Hassan Al-Dokki",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c7ecbe49-3172-43f3-8c94-cd05b0f515f0",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "352",
    "company": "Ali Ahmed Al-Dokki Law Firm and Legal Consultations"
  },
  {
    "id": "a84f89da-0035-4b4f-ae01-c640a781f896",
    "slug": "ali-collected-by-obaid-zayed-al-ketbi",
    "name": "Ali collected by Obaid Zayed Al Ketbi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ali collected by Obaid Zayed Al Ketbi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_a84f89da-0035-4b4f-ae01-c640a781f896",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3644",
    "company": "Ali Jumaa Al Ketbi Law Firm and Legal Consultations"
  },
  {
    "id": "10855e58-de93-4e90-bc28-a4323f49591b",
    "slug": "ali-jairallah-ali-mani-al-ahbabi",
    "name": "Ali Jairallah Ali Mani’ Al-Ahbabi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ali Jairallah Ali Mani’ Al-Ahbabi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_10855e58-de93-4e90-bc28-a4323f49591b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4187",
    "company": "Ali Jawir Allah Al-Ahbabi Advocates and Legal Consultants"
  },
  {
    "id": "4129d7e0-6907-42c6-91df-694fae5153cb",
    "slug": "ali-hassan-youssef-hassan-al-hammadi",
    "name": "Ali Hassan Youssef Hassan Al Hammadi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ali Hassan Youssef Hassan Al Hammadi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_4129d7e0-6907-42c6-91df-694fae5153cb",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2722",
    "company": "Ali Hassan Al Hammadi Law Firm and Legal Consultations"
  },
  {
    "id": "7d34144f-43cd-4d15-8491-87eda46340b8",
    "slug": "ali-hussein-aday-al-shammari",
    "name": "Ali Hussein Aday Al-Shammari",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ali Hussein Aday Al-Shammari",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_7d34144f-43cd-4d15-8491-87eda46340b8",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "319",
    "company": "Ali Al-Shammari Law Firm and Legal Consultations"
  },
  {
    "id": "69766855-5bad-48ce-9f5e-8778f6898767",
    "slug": "ali-hussein-mal-allah-hussein-al-hammadi",
    "name": "Ali Hussein Mal Allah Hussein Al Hammadi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ali Hussein Mal Allah Hussein Al Hammadi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_69766855-5bad-48ce-9f5e-8778f6898767",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3783",
    "company": "Al Obaidly and Al Zarouni Advocates and Legal Consultants"
  },
  {
    "id": "0a654094-9fc5-4ad4-9771-2558b3cab731",
    "slug": "ali-hamad-saif-nasser-al-abri",
    "name": "Ali Hamad Saif Nasser Al-Abri",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ali Hamad Saif Nasser Al-Abri",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_0a654094-9fc5-4ad4-9771-2558b3cab731",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4360",
    "company": "Khalfan Al Kaabi Advocates and Legal Consultants"
  },
  {
    "id": "4b0bfe28-0333-4b12-97ae-d327ab467194",
    "slug": "ali-khalaf-hussein-al-hosani",
    "name": "Ali Khalaf Hussein Al Hosani",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ali Khalaf Hussein Al Hosani",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_4b0bfe28-0333-4b12-97ae-d327ab467194",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2225",
    "company": "Ali Khalaf Al Hosani Advocates and Legal Consultants"
  },
  {
    "id": "6f2ad32b-046b-4af8-807a-559e14b0ff5e",
    "slug": "younis-mohammed-al-balushi-advocates-and-legal-consultants",
    "name": "Younis Mohammed Al Balushi Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFlNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Younis Mohammed Al Balushi Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_6f2ad32b-046b-4af8-807a-559e14b0ff5e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2544",
    "owner": "Ali Rashid Ali Al Mansouri"
  },
  {
    "id": "398faf66-b1b7-49be-a6b1-bda07b02ac87",
    "slug": "ali-salem-ali-salem-al-alawi",
    "name": "Ali Salem Ali Salem Al Alawi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ali Salem Ali Salem Al Alawi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_398faf66-b1b7-49be-a6b1-bda07b02ac87",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3907",
    "company": "Ali Salem Al-Alawi Law Firm and Legal Consultations"
  },
  {
    "id": "f862bad9-bfd8-4953-82ef-b077cfbdb135",
    "slug": "ali-saeed-rashid-ali-al-hafiti",
    "name": "Ali Saeed Rashid Ali Al-Hafiti",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ali Saeed Rashid Ali Al-Hafiti",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_f862bad9-bfd8-4953-82ef-b077cfbdb135",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2197",
    "company": "Ali Saeed Al-Hafiti Advocates and Legal Consultants"
  },
  {
    "id": "338227ac-6864-496b-943f-788b0ae32088",
    "slug": "ali-sultan-hamid-the-penis-of-the-ali",
    "name": "Ali Sultan Hamid, the penis of the Ali",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ali Sultan Hamid, the penis of the Ali",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_338227ac-6864-496b-943f-788b0ae32088",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4111",
    "company": "Ali Sultan Bin Qadeeb Advocates and Legal Consultations"
  },
  {
    "id": "6acaaf41-2a64-47d9-9446-c977a5c5f617",
    "slug": "ali-suleiman-abdullah-colonel-al-naqbi",
    "name": "Ali Suleiman Abdullah, Colonel Al-Naqbi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ali Suleiman Abdullah, Colonel Al-Naqbi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_6acaaf41-2a64-47d9-9446-c977a5c5f617",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "1003",
    "company": "Ali Suleiman Al-Aqeed Advocates and Legal Consultants"
  },
  {
    "id": "8772ae96-3ca6-488e-b385-b9746bf60e4b",
    "slug": "ali-abdullah-hussein-al-hosani",
    "name": "Ali Abdullah Hussein Al Hosani",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ali Abdullah Hussein Al Hosani",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_8772ae96-3ca6-488e-b385-b9746bf60e4b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "192",
    "company": "Ali Al Hosani Advocates and Legal Consultants"
  },
  {
    "id": "f46b1611-54ea-4968-a891-7e8d2e1e64d2",
    "slug": "ali-al-hammadi-law-firm-advocates-and-legal-consultants",
    "name": "Ali Al Hammadi Law Firm Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Ali Al Hammadi Law Firm Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_f46b1611-54ea-4968-a891-7e8d2e1e64d2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2876",
    "owner": "Ali Abdullah Ali Al-Qawadi Al-Hammadi"
  },
  {
    "id": "680c1b24-6c70-40d1-8b19-d5fa8cda1f67",
    "slug": "ali-abdullah-mohammed-ahmed-al-nuaimi",
    "name": "Ali Abdullah Mohammed Ahmed Al Nuaimi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ali Abdullah Mohammed Ahmed Al Nuaimi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_680c1b24-6c70-40d1-8b19-d5fa8cda1f67",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3881",
    "company": "Ali Al Nuaimi Advocates and Legal Consultants"
  },
  {
    "id": "c7c5a2cf-7933-41dd-a80c-721d25cc6913",
    "slug": "ali-obaid-hamid-obaid-al-shamsi",
    "name": "Ali Obaid Hamid Obaid Al Shamsi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ali Obaid Hamid Obaid Al Shamsi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c7c5a2cf-7933-41dd-a80c-721d25cc6913",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3087",
    "company": "Ali Obaid Al Shamsi Advocates and Consultants LLC"
  },
  {
    "id": "c3e19020-0f63-463b-b3f3-2a823c52b79f",
    "slug": "al-midfa-partners-llc",
    "name": "Al Midfa & Partners LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Al Midfa & Partners LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c3e19020-0f63-463b-b3f3-2a823c52b79f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "1018, 1209",
    "owner": "Ali Obaid Muhammad Al-Saroumi Al-Shamili"
  },
  {
    "id": "5d741274-045f-4f4c-9434-e6753f379fca",
    "slug": "ali-suwaidan-law-firm-and-legal-consultations",
    "name": "Ali Suwaidan Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Ali Suwaidan Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_5d741274-045f-4f4c-9434-e6753f379fca",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3977",
    "owner": "Ali Mohsen Suwaidan Al-Amiri"
  },
  {
    "id": "e9cf8259-a5bb-49e6-a2a6-bc9cae96dd0c",
    "slug": "ali-muhammad-ahmed-rahimi-law-firm-and-legal-consultations",
    "name": "Ali Muhammad Ahmed Rahimi Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Ali Muhammad Ahmed Rahimi Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e9cf8259-a5bb-49e6-a2a6-bc9cae96dd0c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3029",
    "owner": "Ali Muhammad Ahmed Mahmoud Rahimi Shahwari"
  },
  {
    "id": "6e01ca30-e306-4796-a460-846de03ff951",
    "slug": "ali-muhammad-amin-abdullah-naqi",
    "name": "Ali Muhammad Amin Abdullah Naqi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ali Muhammad Amin Abdullah Naqi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_6e01ca30-e306-4796-a460-846de03ff951",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2594",
    "company": "Ali Naqi Law Firm and Legal Consultations"
  },
  {
    "id": "38d84b6e-d56c-4b18-b9dc-cdcfa9c32599",
    "slug": "mira-ali-al-jallaf-advocates-and-legal-consultants",
    "name": "Mira Ali Al Jallaf Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Mira Ali Al Jallaf Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_38d84b6e-d56c-4b18-b9dc-cdcfa9c32599",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3602, 3608",
    "owner": "Ali Muhammad Hassan Al-Jallaf"
  },
  {
    "id": "9525de74-c7f1-4504-b530-b145f19079b1",
    "slug": "ali-muhammad-hamdan-al-mahri",
    "name": "Ali Muhammad Hamdan Al Mahri",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ali Muhammad Hamdan Al Mahri",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_9525de74-c7f1-4504-b530-b145f19079b1",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3547",
    "company": "Ali Mohammed Al Mahri Law Firm and Legal Consultations"
  },
  {
    "id": "9142f924-c4b8-42a8-8343-f9e3a394c869",
    "slug": "ali-muhammad-ali-al-malih-al-fazari",
    "name": "Ali Muhammad Ali Al-Malih Al-Fazari",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ali Muhammad Ali Al-Malih Al-Fazari",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_9142f924-c4b8-42a8-8343-f9e3a394c869",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3675",
    "company": "Ali Al-Lamaleh Advocates and Legal Consultants"
  },
  {
    "id": "2e333fbb-8a2e-467e-ba41-0c53e99230dd",
    "slug": "ali-muhammad-omar-al-aidarous",
    "name": "Ali Muhammad Omar Al-Aidarous",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ali Muhammad Omar Al-Aidarous",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_2e333fbb-8a2e-467e-ba41-0c53e99230dd",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "145",
    "company": "Al-Aidaroos Advocates and Legal Consultations/Dubai"
  },
  {
    "id": "d6e047a8-ca60-472d-bf84-882f62c2657c",
    "slug": "ali-mir-mutlab-amiri",
    "name": "Ali Mir Mutlab Amiri",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ali Mir Mutlab Amiri",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_d6e047a8-ca60-472d-bf84-882f62c2657c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "541",
    "company": "Amiri Lawyers and Legal Consultants"
  },
  {
    "id": "be0fc388-7d19-4720-a7f5-2805c58415a3",
    "slug": "mohammed-al-hajri-law-firm-legal-consultations-and-notary-public",
    "name": "Mohammed Al-Hajri Law Firm, Legal Consultations and Notary Public",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Mohammed Al-Hajri Law Firm, Legal Consultations and Notary Public",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_be0fc388-7d19-4720-a7f5-2805c58415a3",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4324",
    "owner": "Ali Nasser Salem Ali Al Busaidi"
  },
  {
    "id": "0143e4bd-27fb-489d-b2ad-488b5907e2ef",
    "slug": "ali-awam-al-yami-advocates-and-legal-consultants",
    "name": "Ali Awam Al Yami Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Ali Awam Al Yami Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_0143e4bd-27fb-489d-b2ad-488b5907e2ef",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2633",
    "owner": "Ali Hadi Hamad Awam Al-Yami"
  },
  {
    "id": "a19d3cd1-c3e0-43a5-99a5-560343adaf95",
    "slug": "ali-yousef-abdullah-shaheen-al-balushi",
    "name": "Ali Yousef Abdullah Shaheen Al Balushi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ali Yousef Abdullah Shaheen Al Balushi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_a19d3cd1-c3e0-43a5-99a5-560343adaf95",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4609",
    "company": "Faisal Hamad Al Balushi Advocates and Legal Consultants"
  },
  {
    "id": "b85174dc-d118-459a-8447-ac07ff978353",
    "slug": "alia-habib-muhammad-sharif-al-mulla",
    "name": "Alia Habib Muhammad Sharif Al Mulla",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Alia Habib Muhammad Sharif Al Mulla",
    "consultationFee": 400,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_b85174dc-d118-459a-8447-ac07ff978353",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3074",
    "company": "Habib Al Mulla & Partners Advocates and Legal Consultants - Abu Dhabi"
  },
  {
    "id": "5d743416-e0af-4553-807a-3958d816d105",
    "slug": "alia-hussein-ali-muhammad-al-helou",
    "name": "Alia Hussein Ali Muhammad Al-Helou",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Alia Hussein Ali Muhammad Al-Helou",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_5d743416-e0af-4553-807a-3958d816d105",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2341",
    "company": "Al-Balushi and Al-Marashda Advocates and Legal Consultants"
  },
  {
    "id": "fcc6aba2-27c6-48d8-b0c9-b3cb46ab61c2",
    "slug": "alia-salem-majid-salem-al-nuaimi",
    "name": "Alia Salem Majid Salem Al Nuaimi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Alia Salem Majid Salem Al Nuaimi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_fcc6aba2-27c6-48d8-b0c9-b3cb46ab61c2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4544",
    "company": "Alia Salem Al Nuaimi Advocates and Legal Consultants - LLC - S.P.C"
  },
  {
    "id": "dc43e5db-6e4f-4c97-bc8d-9fe47d0fd875",
    "slug": "alia-saeed-saif-al-abri",
    "name": "Alia Saeed Saif Al Abri",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Alia Saeed Saif Al Abri",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_dc43e5db-6e4f-4c97-bc8d-9fe47d0fd875",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4048",
    "company": "Alia Saeed Al Abri Advocates and Legal Consultants"
  },
  {
    "id": "2899747f-d031-464b-9ef3-5208798d1905",
    "slug": "alia-abdullah-khalil-ali-al-marzouqi",
    "name": "Alia Abdullah Khalil Ali Al Marzouqi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Alia Abdullah Khalil Ali Al Marzouqi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_2899747f-d031-464b-9ef3-5208798d1905",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3933",
    "company": "Alia Abdullah Al Marzouqi Law Firm and Legal Consultations - One Person Company LLC"
  },
  {
    "id": "cea8ba73-74c4-4071-ba28-0aafd72d8747",
    "slug": "khaled-ateeq-al-marri-advocates-and-legal-consultants",
    "name": "Khaled Ateeq Al Marri Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEtBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Khaled Ateeq Al Marri Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_cea8ba73-74c4-4071-ba28-0aafd72d8747",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4440",
    "owner": "Alia Abdullah Mubarak Al Dhaheri"
  },
  {
    "id": "f09a0b43-1dec-445c-a3ad-8c44f4971963",
    "slug": "al-awami-al-mansouri-advocates-and-legal-consultants",
    "name": "Al Awami Al Mansouri Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Al Awami Al Mansouri Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_f09a0b43-1dec-445c-a3ad-8c44f4971963",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2180, 3122",
    "owner": "Alia Ali Saleh"
  },
  {
    "id": "2f43d546-b49c-4e09-b684-65b9a6477b96",
    "slug": "by-ahmed-abdel-rahim-al-attar",
    "name": "By Ahmed Abdel Rahim Al-Attar",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: By Ahmed Abdel Rahim Al-Attar",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_2f43d546-b49c-4e09-b684-65b9a6477b96",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4080",
    "company": "Ali Al-Attar Law Firm and Legal Consultations Office"
  },
  {
    "id": "591422de-1a2c-454c-b24f-d42fec12de97",
    "slug": "ammar-khalfan-muhammad-ali-al-dahmani",
    "name": "Ammar Khalfan Muhammad Ali Al-Dahmani",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ammar Khalfan Muhammad Ali Al-Dahmani",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_591422de-1a2c-454c-b24f-d42fec12de97",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4434",
    "company": "Ammar Khalfan Al-Dahmani Advocates and Legal Consultations LLC"
  },
  {
    "id": "44ba9982-3c08-4421-9391-496c70a74978",
    "slug": "ammar-abdullah-abdul-rahman-muhammad-al-saidi",
    "name": "Ammar Abdullah Abdul Rahman Muhammad Al-Saidi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ammar Abdullah Abdul Rahman Muhammad Al-Saidi",
    "consultationFee": 400,
    "emirate": "Sharjah",
    "verified": true,
    "offices": [
      {
        "id": "office_44ba9982-3c08-4421-9391-496c70a74978",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Sharjah",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4399",
    "company": "Al Saeedi Advocates and Legal Consultants - Sharjah"
  },
  {
    "id": "751f7d6d-e00c-4783-bdfa-075e03c83959",
    "slug": "ammar-al-mulla-law-firm-and-legal-consultations",
    "name": "Ammar Al Mulla Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Ammar Al Mulla Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_751f7d6d-e00c-4783-bdfa-075e03c83959",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2922",
    "owner": "Ammar Ali Ahmed Ali Al-Mulla"
  },
  {
    "id": "cc3478e6-10e9-4a73-8323-89fc8906f0a9",
    "slug": "omar-ahmed-khamis-bin-madi-al-hilali",
    "name": "Omar Ahmed Khamis bin Madi Al-Hilali",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Omar Ahmed Khamis bin Madi Al-Hilali",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_cc3478e6-10e9-4a73-8323-89fc8906f0a9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4004",
    "company": "Omar Ahmed Al-Hilali Law Office and Legal Consultations"
  },
  {
    "id": "a95be615-0cd9-453c-a477-994e15f63bcc",
    "slug": "omar-hamid-obaid-maadhad-al-shamsi",
    "name": "Omar Hamid Obaid Maadhad Al Shamsi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Omar Hamid Obaid Maadhad Al Shamsi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_a95be615-0cd9-453c-a477-994e15f63bcc",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4272",
    "company": "Omar Humaid Al Shamsi Advocates and Legal Consultants"
  },
  {
    "id": "66cb3689-2331-45e2-8fbc-8d328b3bd904",
    "slug": "omar-rashid-hamid-masoud-al-ghafri",
    "name": "Omar Rashid Hamid Masoud Al-Ghafri",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Omar Rashid Hamid Masoud Al-Ghafri",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_66cb3689-2331-45e2-8fbc-8d328b3bd904",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2969",
    "company": "Omar Rashid Al-Ghafri Advocates and Legal Consultants"
  },
  {
    "id": "aa31063b-cc86-41a2-aa74-cb969794f5f4",
    "slug": "omar-abdulaziz-ibrahim-abdulrahman-al-sabhan",
    "name": "Omar Abdulaziz Ibrahim Abdulrahman Al-Sabhan",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Omar Abdulaziz Ibrahim Abdulrahman Al-Sabhan",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_aa31063b-cc86-41a2-aa74-cb969794f5f4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2523",
    "company": "Dr. Al-Sabhan and Associates Legal Group"
  },
  {
    "id": "6b02bda1-d33c-4624-ba59-df2f7eb4a88a",
    "slug": "omar-abdullah-saeed-al-balushi",
    "name": "Omar Abdullah Saeed Al Balushi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Omar Abdullah Saeed Al Balushi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_6b02bda1-d33c-4624-ba59-df2f7eb4a88a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "1744",
    "company": "Faisal Hamad Al Balushi Advocates and Legal Consultants"
  },
  {
    "id": "01844066-ee5e-42db-8430-169144b2e340",
    "slug": "omar-ali-saeed-mahboob-al-nuaimi",
    "name": "Omar Ali Saeed Mahboob Al Nuaimi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Omar Ali Saeed Mahboob Al Nuaimi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_01844066-ee5e-42db-8430-169144b2e340",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4120",
    "company": "Omar Mahboob Al Nuaimi Advocates and Legal Consultants"
  },
  {
    "id": "86e7c631-d3ec-4393-9fc9-431659fbb5b0",
    "slug": "omar-muhammad-ali-mubarak-al-sabousi",
    "name": "Omar Muhammad Ali Mubarak Al-Sabousi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Omar Muhammad Ali Mubarak Al-Sabousi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_86e7c631-d3ec-4393-9fc9-431659fbb5b0",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2666",
    "company": "Khaled Majed Law Firm and Legal Consultations"
  },
  {
    "id": "b898952e-14b0-4473-8cfc-f84db72886ab",
    "slug": "omar-sharif-advocates-and-legal-consultations-llc",
    "name": "Omar Sharif Advocates and Legal Consultations LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE9TCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Omar Sharif Advocates and Legal Consultations LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_b898952e-14b0-4473-8cfc-f84db72886ab",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3772",
    "owner": "Omar Muhammad Sharif Othman Youssef Suleiman"
  },
  {
    "id": "ce335537-7c9e-49e1-bc67-7a1659869d4c",
    "slug": "omair-nasser-hussein-abdullah-al-harithi",
    "name": "Omair Nasser Hussein Abdullah Al Harithi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Omair Nasser Hussein Abdullah Al Harithi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_ce335537-7c9e-49e1-bc67-7a1659869d4c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4092",
    "company": "Omair Nasser Al Harithi Advocates and Legal Consultations"
  },
  {
    "id": "2b1549ec-5def-4908-bad7-9ff27cc275de",
    "slug": "the-era-of-saif-muhammad-al-ghais-al-zaabi",
    "name": "The era of Saif Muhammad Al-Ghais Al-Zaabi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: The era of Saif Muhammad Al-Ghais Al-Zaabi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_2b1549ec-5def-4908-bad7-9ff27cc275de",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4454",
    "company": "Ahed Saif Al Zaabi Advocates and Legal Consultants"
  },
  {
    "id": "1183c0cb-8d24-4973-b45e-bd2e3aaca1d8",
    "slug": "nujoud-al-hammadi-and-partners-advocates-and-legal-consultants-llc",
    "name": "Nujoud Al Hammadi and Partners Advocates and Legal Consultants - LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE5BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Nujoud Al Hammadi and Partners Advocates and Legal Consultants - LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_1183c0cb-8d24-4973-b45e-bd2e3aaca1d8",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3379, 3854",
    "owner": "Ohood Khalaf Ali Khalaf Al Hosani"
  },
  {
    "id": "7cd62b24-04ed-4ad8-b872-5a2b9860b72d",
    "slug": "ohood-amer-ali-al-naili-al-shamsi",
    "name": "Ohood Amer Ali Al-Naili Al-Shamsi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ohood Amer Ali Al-Naili Al-Shamsi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_7cd62b24-04ed-4ad8-b872-5a2b9860b72d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4164",
    "company": "Al-Nasr Law Firm and Legal Consultations"
  },
  {
    "id": "1a8c8645-55fd-4af2-b090-e4eb8762ecf4",
    "slug": "ohood-nasser-muhammad-al-khalidi",
    "name": "Ohood Nasser Muhammad Al-Khalidi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ohood Nasser Muhammad Al-Khalidi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_1a8c8645-55fd-4af2-b090-e4eb8762ecf4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2782",
    "company": "Al-Murshid Advocates and Legal Consultants"
  },
  {
    "id": "1a3b1ab9-fafe-4c5a-858a-a3ec9f37046b",
    "slug": "sheikha-saqr-al-mansouri-partners-advocates-and-legal-consultants",
    "name": "Sheikha Saqr Al Mansouri & Partners Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Sheikha Saqr Al Mansouri & Partners Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_1a3b1ab9-fafe-4c5a-858a-a3ec9f37046b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4545",
    "owner": "Emotions of Ismail Mubarak Musa Al-Sharif"
  },
  {
    "id": "f6cbe710-5563-4e0d-a936-ec5b9b6b76b7",
    "slug": "issa-ahmed-ali-obaid-shattaf-al-ali",
    "name": "Issa Ahmed Ali Obaid Shattaf Al Ali",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Issa Ahmed Ali Obaid Shattaf Al Ali",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_f6cbe710-5563-4e0d-a936-ec5b9b6b76b7",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3485",
    "company": "Mansour Lootah Advocates and Legal Consultants"
  },
  {
    "id": "f755a2f5-1ede-450c-843d-03b2d3193972",
    "slug": "issa-ziyad-abdullah-ibrahim-galadari",
    "name": "Issa Ziyad Abdullah Ibrahim Galadari",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJWgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Issa Ziyad Abdullah Ibrahim Galadari",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_f755a2f5-1ede-450c-843d-03b2d3193972",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4171",
    "company": "Galadari Lawyers and Legal Consultants Sole Proprietorship LLC - Dubai"
  },
  {
    "id": "140e013a-5da7-4667-acb1-927348f86159",
    "slug": "issa-salem-ahmed-al-harsi-al-mahri",
    "name": "Issa Salem Ahmed Al-Harsi Al-Mahri",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Issa Salem Ahmed Al-Harsi Al-Mahri",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_140e013a-5da7-4667-acb1-927348f86159",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3082",
    "company": "Issa Salem Advocates and Legal Consultants"
  },
  {
    "id": "91025898-5c12-4f0d-9ff3-3781f733081c",
    "slug": "issa-salem-ali-salem-al-qaidi",
    "name": "Issa Salem Ali Salem Al-Qaidi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Issa Salem Ali Salem Al-Qaidi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_91025898-5c12-4f0d-9ff3-3781f733081c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3681",
    "company": "Issa Salem Al-Qaidi Law Firm and Legal Consultations"
  },
  {
    "id": "456bc694-8840-4cc5-a2fa-0c644004a5a3",
    "slug": "issa-abdul-wahed-abdul-wahed-abdullah-al-shehhi",
    "name": "Issa Abdul Wahed Abdul Wahed Abdullah Al Shehhi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Issa Abdul Wahed Abdul Wahed Abdullah Al Shehhi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_456bc694-8840-4cc5-a2fa-0c644004a5a3",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4005",
    "company": "Issa Abdul Wahed Al Shehhi Advocates and Legal Consultants"
  },
  {
    "id": "ba84cb9b-2035-4786-a449-d4469b7af363",
    "slug": "issa-aqeel-abdullah-al-shehhi",
    "name": "Issa Aqeel Abdullah Al Shehhi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Issa Aqeel Abdullah Al Shehhi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_ba84cb9b-2035-4786-a449-d4469b7af363",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2236",
    "company": "Al-Kitub Law Firm and Legal Consultations"
  },
  {
    "id": "fa3b8d2f-9dd9-4228-9ac3-dd32e24e9097",
    "slug": "issa-muhammad-faqir-mallazhi-al-balushi",
    "name": "BUTHAINA JAMIL HASSAN MIRZA ALSAYEGH",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/10/2020",
    "licenseStatus": "suspended",
    "licenseExpiry": "2022-10-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Issa Muhammad Faqir Mallazhi Al Balushi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_fa3b8d2f-9dd9-4228-9ac3-dd32e24e9097",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "L-1464",
    "company": "Office of Issa Mohammed Al Balushi Law Firm and Legal Consultations"
  },
  {
    "id": "488d5607-cb19-4da1-90b1-350110bde50e",
    "slug": "issa-muhammad-muhanna-majid-al-nuaimi",
    "name": "Issa Muhammad Muhanna Majid Al Nuaimi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Issa Muhammad Muhanna Majid Al Nuaimi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_488d5607-cb19-4da1-90b1-350110bde50e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "204",
    "company": "Dr. Issa Al Nuaimi Advocates and Legal Consultants"
  },
  {
    "id": "ed1e671b-ac1e-427c-8c27-5fb5f123d8ff",
    "slug": "ghazi-ibrahim-ahmed-bin",
    "name": "Ghazi Ibrahim Ahmed bin",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ghazi Ibrahim Ahmed bin",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_ed1e671b-ac1e-427c-8c27-5fb5f123d8ff",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "739",
    "company": "Bin Seifan Advocates and Legal Consultants"
  },
  {
    "id": "a5801c0f-bc2c-4934-98bb-db1ce36eb073",
    "slug": "ghalia-al-jabri-and-fatima-al-jabri-law-firm-and-legal-consultations-llc",
    "name": "Ghalia Al Jabri and Fatima Al Jabri Law Firm and Legal Consultations LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEdBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Ghalia Al Jabri and Fatima Al Jabri Law Firm and Legal Consultations LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_a5801c0f-bc2c-4934-98bb-db1ce36eb073",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3662, 3663",
    "owner": "Ghalia Abdullah Hassan Abdullah Al-Jabri"
  },
  {
    "id": "938645b2-7aed-4c1b-a176-da004e22b646",
    "slug": "international-consultant-for-law-and-legal-consultancy",
    "name": "International consultant for law and legal consultancy",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIElDCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: International consultant for law and legal consultancy",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_938645b2-7aed-4c1b-a176-da004e22b646",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "725",
    "owner": "Ghanem Jaber Ghassab Al-Hajri"
  },
  {
    "id": "3be5402f-6789-4db3-8da5-dcd185cfb7f1",
    "slug": "ghanem-ali-al-ahbabi-law-firm-and-legal-consultations",
    "name": "Ghanem Ali Al Ahbabi Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEdBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Ghanem Ali Al Ahbabi Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_3be5402f-6789-4db3-8da5-dcd185cfb7f1",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4049",
    "owner": "Ghanem Ali Nasser Ali Al-Ahbabi"
  },
  {
    "id": "06c50863-acc3-4d52-842c-7b7d11a3a46e",
    "slug": "ghanem-mohammed-saeed-mohammed-al-muhairi",
    "name": "Ghanem Mohammed Saeed Mohammed Al Muhairi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ghanem Mohammed Saeed Mohammed Al Muhairi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_06c50863-acc3-4d52-842c-7b7d11a3a46e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4160",
    "company": "Ghanem Al Muhairi Advocates and Legal Consultants"
  },
  {
    "id": "f881a99a-826c-4a50-b89e-225e54bb938d",
    "slug": "gharib-khalifa-gharib-walid-al-shamsi",
    "name": "Gharib Khalifa Gharib Walid Al Shamsi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Gharib Khalifa Gharib Walid Al Shamsi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_f881a99a-826c-4a50-b89e-225e54bb938d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3614",
    "company": "Hassan Al-Abdouli Law Firm and Legal Consultations"
  },
  {
    "id": "395e2480-90c9-45bf-8b89-7b9d34e26e37",
    "slug": "faten-tamim-abdel-shafi-al-salibi",
    "name": "Faten Tamim Abdel Shafi Al-Salibi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Faten Tamim Abdel Shafi Al-Salibi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_395e2480-90c9-45bf-8b89-7b9d34e26e37",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4708",
    "company": "Faten tamim ABDULSHAFI"
  },
  {
    "id": "bbd1e6e1-4cbc-4e14-a324-c4a226ccd35c",
    "slug": "fares-hassan-youssef-mohammed-al-hammadi",
    "name": "Fares Hassan Youssef Mohammed Al Hammadi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Fares Hassan Youssef Mohammed Al Hammadi",
    "consultationFee": 400,
    "emirate": "Sharjah",
    "verified": true,
    "offices": [
      {
        "id": "office_bbd1e6e1-4cbc-4e14-a324-c4a226ccd35c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Sharjah",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4173",
    "company": "Al Etizan Advocates and Legal Consultants / Sharjah"
  },
  {
    "id": "8f502558-e154-4399-8627-6d909d6ce401",
    "slug": "farouk-mohammed-al-hammadi-law-firm-and-legal-consultations",
    "name": "Farouk Mohammed Al Hammadi Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEZNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Farouk Mohammed Al Hammadi Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_8f502558-e154-4399-8627-6d909d6ce401",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4161",
    "owner": "Farouk Muhammad Abdullah Muhammad Al-Hammadi"
  },
  {
    "id": "dacbcb44-fd7e-4787-aa98-df3a74d3a9d7",
    "slug": "majid-al-jallaf-advocates-and-legal-consultants",
    "name": "Majid Al Jallaf Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Majid Al Jallaf Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_dacbcb44-fd7e-4787-aa98-df3a74d3a9d7",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4473",
    "owner": "Fatima Khalifa Muhammad"
  },
  {
    "id": "744e82fb-04c0-41fa-8eba-1a14aa485e13",
    "slug": "fatima-salem-al-ameri-law-firm-and-legal-consultations-one-person-company-llc",
    "name": "Fatima Salem Al Ameri Law Firm and Legal Consultations One Person Company LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEZTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Fatima Salem Al Ameri Law Firm and Legal Consultations One Person Company LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_744e82fb-04c0-41fa-8eba-1a14aa485e13",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3945",
    "owner": "Fatima Salem Al-Amiri"
  },
  {
    "id": "53e4a46b-6415-4ab4-9026-54794a1f9f25",
    "slug": "fatima-saeed-khamis-al-kaabi",
    "name": "Fatima Saeed Khamis Al Kaabi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Fatima Saeed Khamis Al Kaabi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_53e4a46b-6415-4ab4-9026-54794a1f9f25",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3083",
    "company": "Fatima Samsoum Al Kaabi Law Firm and Legal Consultations"
  },
  {
    "id": "75a378aa-0b88-476d-8676-975ba21fdc9b",
    "slug": "fatima-saeed-salem-al-kaabi",
    "name": "Fatima Saeed Salem Al Kaabi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Fatima Saeed Salem Al Kaabi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_75a378aa-0b88-476d-8676-975ba21fdc9b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3913",
    "company": "Fatima Saeed Al Kaabi Advocates and Legal Consultants"
  },
  {
    "id": "171c6a53-cd6a-42d8-820f-6717bfa2eece",
    "slug": "fatima-abdel-aziz-law-firm-and-legal-consultations",
    "name": "Fatima Abdel Aziz Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEZBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Fatima Abdel Aziz Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_171c6a53-cd6a-42d8-820f-6717bfa2eece",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "789",
    "owner": "Fatima Abdul Aziz Muhammad"
  },
  {
    "id": "e509654c-c66f-4930-9094-44aa7875a83e",
    "slug": "fatima-abdulaziz-muhammad-ali-al-qasim",
    "name": "Fatima Abdulaziz Muhammad Ali Al-Qasim",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Fatima Abdulaziz Muhammad Ali Al-Qasim",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e509654c-c66f-4930-9094-44aa7875a83e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4548",
    "company": "Fatima Al Qasim Advocates and Legal Consultants"
  },
  {
    "id": "82bd27dc-c0c9-4366-981a-f74f860e44ad",
    "slug": "fatima-abdullah-khamis-bin-hakim-al-dahmani",
    "name": "Fatima Abdullah Khamis bin Hakim Al-Dahmani",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Fatima Abdullah Khamis bin Hakim Al-Dahmani",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_82bd27dc-c0c9-4366-981a-f74f860e44ad",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4343",
    "company": "Musab Ali Al Naqbi Advocates and Legal Consultants"
  },
  {
    "id": "a072a483-198c-4b1b-90d2-e2b608f4b4c4",
    "slug": "fatima-abdullah-mohammed-al-balushi",
    "name": "Fatima Abdullah Mohammed Al Balushi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Fatima Abdullah Mohammed Al Balushi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_a072a483-198c-4b1b-90d2-e2b608f4b4c4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3791",
    "company": "Mohammed Al Owais Advocates and Legal Consultants"
  },
  {
    "id": "13209408-1458-4249-b765-c9d155d36ad7",
    "slug": "fatima-abdullah-muhammad-al-watani-al-ali",
    "name": "Fatima Abdullah Muhammad Al-Watani Al Ali",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Fatima Abdullah Muhammad Al-Watani Al Ali",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_13209408-1458-4249-b765-c9d155d36ad7",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3673",
    "company": "Fatima Al Ali Law Firm and Legal Consultations"
  },
  {
    "id": "a88f76a0-8af3-4fa7-9f0a-ea88fba4fcc2",
    "slug": "fatima-abdullah-mohammed-abdullah-al-hammadi",
    "name": "Fatima Abdullah Mohammed Abdullah Al Hammadi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Fatima Abdullah Mohammed Abdullah Al Hammadi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_a88f76a0-8af3-4fa7-9f0a-ea88fba4fcc2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3068",
    "company": "Mohammed Al Hammadi Law Firm and Legal Consultations"
  },
  {
    "id": "8c8593fc-7151-413e-8a5d-98a961642d90",
    "slug": "fatima-mohammed-hassan-al-hashemi",
    "name": "Fatima Mohammed Hassan Al Hashemi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Fatima Mohammed Hassan Al Hashemi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_8c8593fc-7151-413e-8a5d-98a961642d90",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3646",
    "company": "Fatima Mohammed Al Hashemi Law Firm and Legal Consultations"
  },
  {
    "id": "337f8c6a-f13b-4e81-b119-091a354a77d2",
    "slug": "fatima-mohammed-advocates-and-legal-consultants",
    "name": "Fatima Mohammed Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEZNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Fatima Mohammed Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_337f8c6a-f13b-4e81-b119-091a354a77d2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3246",
    "owner": "Fatima Muhammad Siddiq"
  },
  {
    "id": "58cd62e1-c0e5-4447-b6de-fe811b29de58",
    "slug": "amna-al-zaabi-advocates-and-legal-consultants",
    "name": "Amna Al Zaabi Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Amna Al Zaabi Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_58cd62e1-c0e5-4447-b6de-fe811b29de58",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4394",
    "owner": "Fatima Muhammad Ali Al-Attar"
  },
  {
    "id": "09b78f65-5bbf-44da-b1be-dbfde564d996",
    "slug": "fatima-muhammad-omar-mubarak-bawazir",
    "name": "Fatima Muhammad Omar Mubarak Bawazir",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Fatima Muhammad Omar Mubarak Bawazir",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_09b78f65-5bbf-44da-b1be-dbfde564d996",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4245",
    "company": "Qamasha Ali Muhammad Law Firm Legal Consultations"
  },
  {
    "id": "d97ec103-0cad-4851-8b95-22703551a386",
    "slug": "haider-bin-haider-advocates-and-legal-consultants",
    "name": "Haider Bin Haider Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhCCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Haider Bin Haider Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_d97ec103-0cad-4851-8b95-22703551a386",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4427",
    "owner": "Fatima Musalat Hani Saeed"
  },
  {
    "id": "339443f9-5b4b-4ffd-ba19-63273c048fe4",
    "slug": "fatima-yousef-khalil-al-yasi",
    "name": "Fatima Yousef Khalil Al Yasi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Fatima Yousef Khalil Al Yasi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_339443f9-5b4b-4ffd-ba19-63273c048fe4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4388",
    "company": "Alpha Law Firm and Legal Consultations"
  },
  {
    "id": "c5836ccc-eb35-49a4-9161-916c2aae185e",
    "slug": "fatima-ahmed-salem-saeed",
    "name": "Fatima Ahmed Salem Saeed",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Fatima Ahmed Salem Saeed",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c5836ccc-eb35-49a4-9161-916c2aae185e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4104",
    "company": "Prestige Law Firm and Legal Consultations"
  },
  {
    "id": "fd8e4c58-0833-4271-a22e-5c7de2aebd48",
    "slug": "fatima-ismail-abdul-karim-hassan-al-zarouni",
    "name": "Fatima Ismail Abdul Karim Hassan Al-Zarouni",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Fatima Ismail Abdul Karim Hassan Al-Zarouni",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_fd8e4c58-0833-4271-a22e-5c7de2aebd48",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4331",
    "company": "Omar Rashid Al-Ghafri Advocates and Legal Consultants"
  },
  {
    "id": "ce4a05b0-2465-44d0-bbe0-0b768ae4193b",
    "slug": "fatima-hassan-ibrahim-ali-al-balushi",
    "name": "Fatima Hassan Ibrahim Ali Al Balushi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Fatima Hassan Ibrahim Ali Al Balushi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_ce4a05b0-2465-44d0-bbe0-0b768ae4193b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4642",
    "company": "Amer Al Marzouqi Advocates and Legal Consultants"
  },
  {
    "id": "c8e1c4d9-852f-4bf1-a4ae-6a174af11fac",
    "slug": "fatima-hassan-suleiman-al-shehhi",
    "name": "Fatima Hassan Suleiman Al Shehhi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Fatima Hassan Suleiman Al Shehhi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c8e1c4d9-852f-4bf1-a4ae-6a174af11fac",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3980",
    "company": "Fatima Hassan Al Shehhi Advocates and Legal Consultations LLC"
  },
  {
    "id": "c427b3b9-a03f-4ce8-b04e-bb6c9a77b6bc",
    "slug": "fatima-hussein-ali-ahmed",
    "name": "Fatima Hussein Ali Ahmed",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Fatima Hussein Ali Ahmed",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c427b3b9-a03f-4ce8-b04e-bb6c9a77b6bc",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4599",
    "company": "Fatima Hussein Advocates and Legal Consultations"
  },
  {
    "id": "85a08c05-d25f-4381-982c-6f9de02a6a14",
    "slug": "fatima-rashid-sultan-saif-al-neyadi",
    "name": "Fatima Rashid Sultan Saif Al Neyadi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Fatima Rashid Sultan Saif Al Neyadi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_85a08c05-d25f-4381-982c-6f9de02a6a14",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3687",
    "company": "Zayed Al Mazrouei Advocates and Legal Consultants"
  },
  {
    "id": "1ab0477d-479d-45cf-af25-d2f04440f4df",
    "slug": "fatima-ramadan-ahmed-ramadan-al-hosani",
    "name": "Fatima Ramadan Ahmed Ramadan Al Hosani",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Fatima Ramadan Ahmed Ramadan Al Hosani",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_1ab0477d-479d-45cf-af25-d2f04440f4df",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3163",
    "company": "Amna Al Shehhi Advocates and Legal Consultants"
  },
  {
    "id": "fd33d608-e52e-42b2-bf56-7cd084bbd5ee",
    "slug": "fatima-salem-saeed-saif-al-shamsi",
    "name": "Fatima Salem Saeed Saif Al Shamsi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Fatima Salem Saeed Saif Al Shamsi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_fd33d608-e52e-42b2-bf56-7cd084bbd5ee",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4295",
    "company": "Marwan Mohamed Lawyers and Legal Consultants"
  },
  {
    "id": "7d201586-b175-4ccb-b740-4e2b12fc1d76",
    "slug": "abdullah-al-kaabi-law-firm-and-legal-consultations",
    "name": "Abdullah Al Kaabi Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Abdullah Al Kaabi Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_7d201586-b175-4ccb-b740-4e2b12fc1d76",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4374, 4412",
    "owner": "Fatima Salem Obaid Saeed Al-Saadi"
  },
  {
    "id": "63859be6-ff1d-4252-8387-7d3e12a1431f",
    "slug": "fatima-saif-abdul-rahman-ibrahim-al-muhairi",
    "name": "Fatima Saif Abdul Rahman Ibrahim Al Muhairi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Fatima Saif Abdul Rahman Ibrahim Al Muhairi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_63859be6-ff1d-4252-8387-7d3e12a1431f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3604",
    "company": "Fatima Al Muhairi Advocates and Legal Consultants"
  },
  {
    "id": "a61358a8-b8ef-4a27-9a6f-2fa4831c7486",
    "slug": "fatima-saif-al-mazrouei-advocates-and-legal-consultants-llc-spc",
    "name": "Fatima Saif Al Mazrouei Advocates and Legal Consultants - LLC - S.P.C",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEZTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Fatima Saif Al Mazrouei Advocates and Legal Consultants - LLC - S.P.C",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_a61358a8-b8ef-4a27-9a6f-2fa4831c7486",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3386",
    "owner": "Fatima Saif Mohammed Suleiman Al Mazroui"
  },
  {
    "id": "48b8f716-8801-4e69-8243-bd25df28d270",
    "slug": "fatima-sharif-muhammad-youssef-al-obaidly",
    "name": "Fatima Sharif Muhammad Youssef Al-Obaidly",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Fatima Sharif Muhammad Youssef Al-Obaidly",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_48b8f716-8801-4e69-8243-bd25df28d270",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4148",
    "company": "Sherif Al Obaidly Advocates and Legal Consultants"
  },
  {
    "id": "aeff1bff-8f62-409b-b9fe-79bc11d5744f",
    "slug": "fatima-saleh-hamid-abdullah-al-rashidi",
    "name": "Fatima Saleh Hamid Abdullah Al Rashidi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Fatima Saleh Hamid Abdullah Al Rashidi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_aeff1bff-8f62-409b-b9fe-79bc11d5744f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4441",
    "company": "Ibrahim Ali Karam Khoury Advocates and Legal Consultants"
  },
  {
    "id": "51bcc806-4f42-4981-8eb0-e45094d0f93d",
    "slug": "fatima-abdul-quddus-al-obaidli-law-firm-and-legal-consultations-office",
    "name": "Fatima Abdul Quddus Al Obaidli Law Firm and Legal Consultations Office",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEZBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Fatima Abdul Quddus Al Obaidli Law Firm and Legal Consultations Office",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_51bcc806-4f42-4981-8eb0-e45094d0f93d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4193",
    "owner": "Fatima Abdul Quddus Abdul Razzaq Muhammad Al Obaidly"
  },
  {
    "id": "f10a8fb9-d721-43b0-a45f-43af00291e07",
    "slug": "fatima-abdullah-omar-abdullah-belfaqih",
    "name": "Fatima Abdullah Omar Abdullah Belfaqih",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Fatima Abdullah Omar Abdullah Belfaqih",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_f10a8fb9-d721-43b0-a45f-43af00291e07",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4363",
    "company": "Fatima Abdullah Belfaqih Law Firm and Legal Consultations - One Person Company LLC"
  },
  {
    "id": "d68168a6-9df3-4153-9893-f18a76da803a",
    "slug": "fatima-abdullah-muhammad-suleiman",
    "name": "Fatima Abdullah Muhammad Suleiman",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Fatima Abdullah Muhammad Suleiman",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_d68168a6-9df3-4153-9893-f18a76da803a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4220",
    "company": "Fatima Abdullah Law Firm"
  },
  {
    "id": "79570fbd-a6e7-4f2f-be2c-7f1979989ae5",
    "slug": "fatima-ali-mal-allah-muhammad-ghanem",
    "name": "Fatima Ali Mal Allah Muhammad Ghanem",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Fatima Ali Mal Allah Muhammad Ghanem",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_79570fbd-a6e7-4f2f-be2c-7f1979989ae5",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4236",
    "company": "Nasser Mal Allah Law Firm and Legal Consultations"
  },
  {
    "id": "f02a90e7-a5be-4a52-bc5d-8d9b310dde04",
    "slug": "mohammed-bin-jabr-al-shamsi-law-firm-and-legal-consultations",
    "name": "Mohammed bin Jabr Al Shamsi Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1CCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Mohammed bin Jabr Al Shamsi Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_f02a90e7-a5be-4a52-bc5d-8d9b310dde04",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4327",
    "owner": "Fatima Ali Muhammad Hassan"
  },
  {
    "id": "39e10805-eaca-4c0f-a712-11dfd3fe7845",
    "slug": "fatima-majid-muhair-ghanem-al-qubaisi",
    "name": "Fatima Majid Muhair Ghanem Al Qubaisi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Fatima Majid Muhair Ghanem Al Qubaisi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_39e10805-eaca-4c0f-a712-11dfd3fe7845",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4523",
    "company": "Fatima Al Qubaisi Advocates and Legal Consultants"
  },
  {
    "id": "8b5f880a-7d97-46fa-9488-1a6e4acdd6b6",
    "slug": "fatima-mohammed-rashid-ali-al-zeyoudi",
    "name": "Fatima Mohammed Rashid Ali Al-Zeyoudi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Fatima Mohammed Rashid Ali Al-Zeyoudi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_8b5f880a-7d97-46fa-9488-1a6e4acdd6b6",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4378",
    "company": "Omar Rashid Al-Ghafri Advocates and Legal Consultants"
  },
  {
    "id": "9304f255-7e38-42f8-9d16-aa960d294f6d",
    "slug": "fatima-muhammad-muhammad-ahmed-al-zeyoudi",
    "name": "Fatima Muhammad Muhammad Ahmed Al-Zeyoudi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Fatima Muhammad Muhammad Ahmed Al-Zeyoudi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_9304f255-7e38-42f8-9d16-aa960d294f6d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3387",
    "company": "Al-Zayoudi Law Firm and Legal Consultations"
  },
  {
    "id": "5f3a4404-f0fb-48a3-a4a3-5f53ebcb47ff",
    "slug": "walid-al-marzouqi-and-khaled-mohammed-advocates-and-legal-consultantsdubai",
    "name": "Walid Al Marzouqi and Khaled Mohammed Advocates and Legal Consultants/Dubai",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFdBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Walid Al Marzouqi and Khaled Mohammed Advocates and Legal Consultants/Dubai",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5f3a4404-f0fb-48a3-a4a3-5f53ebcb47ff",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4522",
    "owner": "Fatima Muhammad Youssef Ahmed Al-Yassi"
  },
  {
    "id": "7d61f2a2-3c9c-4891-a80c-11cbd19933d9",
    "slug": "fatima-youssef-ahmed-abdullah-al-mulla",
    "name": "Fatima Youssef Ahmed Abdullah Al-Mulla",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Fatima Youssef Ahmed Abdullah Al-Mulla",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_7d61f2a2-3c9c-4891-a80c-11cbd19933d9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4192",
    "company": "Khalifa Al-Maftool Advocates and Legal Consultants"
  },
  {
    "id": "160ba330-d574-4d5c-b071-96aa032125c2",
    "slug": "farhan-saeed-hamoud-al-badi-al-otaibi",
    "name": "Farhan Saeed Hamoud Al Badi Al Otaibi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Farhan Saeed Hamoud Al Badi Al Otaibi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_160ba330-d574-4d5c-b071-96aa032125c2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4419",
    "company": "Alpha Law Firm and Legal Consultations"
  },
  {
    "id": "e1ea6585-e57b-4e29-8d14-68972bf388b9",
    "slug": "farid-abdullah-abdul-rahman-abdullah-al-awadi",
    "name": "Farid Abdullah Abdul Rahman Abdullah Al-Awadi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Farid Abdullah Abdul Rahman Abdullah Al-Awadi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e1ea6585-e57b-4e29-8d14-68972bf388b9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "775",
    "company": "Al-Awadhi Law Firm and Legal Consultations"
  },
  {
    "id": "c497960e-6cbd-458b-8030-185db5ca3257",
    "slug": "farid-fayrouz-muhammad-ali-al-hassan",
    "name": "Farid Fayrouz Muhammad Ali Al-Hassan",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Farid Fayrouz Muhammad Ali Al-Hassan",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c497960e-6cbd-458b-8030-185db5ca3257",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3774",
    "company": "Farid Al-Hassan Advocates and Legal Consultants"
  },
  {
    "id": "5822c956-fd2e-4e4d-ab11-2e7daec5950e",
    "slug": "fahd-bin-rashid-bin-issa-bin-abdul-latif-al-sarkal",
    "name": "Fahd bin Rashid bin Issa bin Abdul Latif Al Sarkal",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Fahd bin Rashid bin Issa bin Abdul Latif Al Sarkal",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_5822c956-fd2e-4e4d-ab11-2e7daec5950e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4100",
    "company": "Fahd bin Rashid Al Sarkal Law Firm and Legal Consultations"
  },
  {
    "id": "557e841b-7317-40d1-b9d5-d02671a9c807",
    "slug": "fahad-sultan-lootah",
    "name": "Fahad Sultan Lootah",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Fahad Sultan Lootah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_557e841b-7317-40d1-b9d5-d02671a9c807",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "318",
    "company": "Lootah Advocates and Legal Consultants/Dubai"
  },
  {
    "id": "89282eab-f15f-4b86-9400-7af74d9c6e4f",
    "slug": "fahd-sultan-muhammad-baharun-al-ali",
    "name": "Fahd Sultan Muhammad Baharun Al Ali",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Fahd Sultan Muhammad Baharun Al Ali",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_89282eab-f15f-4b86-9400-7af74d9c6e4f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4126",
    "company": "Fahd Baharun Al Ali Law Firm and Legal Consultations"
  },
  {
    "id": "e1265ae1-bf18-4793-8591-b7d1c03d3bfe",
    "slug": "fahd-abdullah-law-office-and-legal-consultations",
    "name": "Fahd Abdullah Law Office and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEZBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Fahd Abdullah Law Office and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e1265ae1-bf18-4793-8591-b7d1c03d3bfe",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2290",
    "owner": "Fahd Abdullah Qambar Muhammad"
  },
  {
    "id": "e0ff9bfd-bb47-47e3-8fc0-7371f6a44917",
    "slug": "fahd-muhammad-abdullah-khamis-al-hosani",
    "name": "Fahd Muhammad Abdullah Khamis Al Hosani",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Fahd Muhammad Abdullah Khamis Al Hosani",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e0ff9bfd-bb47-47e3-8fc0-7371f6a44917",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4425",
    "company": "Fahd Al Hosani Advocates and Legal Consultations LLC"
  },
  {
    "id": "bdbb6175-807f-4cb8-8dc2-fd75f0fe5ff9",
    "slug": "dr-sarhan-al-muaini-advocates-and-legal-consultants",
    "name": "Dr. Sarhan Al-Muaini Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Dr. Sarhan Al-Muaini Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_bdbb6175-807f-4cb8-8dc2-fd75f0fe5ff9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4445",
    "owner": "Fahd Muhammad Ali Nasser"
  },
  {
    "id": "788cf603-8c41-433b-81cf-a0a97eccb412",
    "slug": "al-shamsi-and-partners-advocates-and-legal-consultants",
    "name": "Al Shamsi and Partners Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Al Shamsi and Partners Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_788cf603-8c41-433b-81cf-a0a97eccb412",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4094",
    "owner": "Fawzia Muhammad Hassan Mulla Ali"
  },
  {
    "id": "45afeb03-e3c2-4a64-8617-d6d18c0a959b",
    "slug": "fawziah-muhammad-azim-saif-al-din-yaqoub",
    "name": "Fawziah Muhammad Azim Saif al-Din Yaqoub",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Fawziah Muhammad Azim Saif al-Din Yaqoub",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_45afeb03-e3c2-4a64-8617-d6d18c0a959b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4212",
    "company": "Fawzia Mohammed Advocates and Legal Consultations"
  },
  {
    "id": "001a08d0-eb1d-4311-88c2-d48be93d54ec",
    "slug": "fawzia-al-mulla-law-firm-and-legal-consultations",
    "name": "Fawzia Al Mulla Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEZBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Fawzia Al Mulla Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_001a08d0-eb1d-4311-88c2-d48be93d54ec",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3892",
    "owner": "Fawzia Mahmoud Ahmed Muhammad Al-Mulla"
  },
  {
    "id": "77f59c36-00bd-444d-a301-1a03c7fe484f",
    "slug": "faisal-hassan-ali-al-shehhi",
    "name": "Faisal Hassan Ali Al Shehhi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Faisal Hassan Ali Al Shehhi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_77f59c36-00bd-444d-a301-1a03c7fe484f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4365",
    "company": "Faisal Hassan Al Shehhi Advocates and Legal Consultations LLC"
  },
  {
    "id": "031f78c8-9cbf-4078-b2e7-a4807719b38b",
    "slug": "faisal-hamad-nour-al-balushi",
    "name": "Faisal Hamad Nour Al Balushi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Faisal Hamad Nour Al Balushi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_031f78c8-9cbf-4078-b2e7-a4807719b38b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3613",
    "company": "Faisal Hamad Al Balushi Advocates and Legal Consultants"
  },
  {
    "id": "556b8c7a-f3e3-40e1-9b6f-aca1d134c5f6",
    "slug": "faisal-rashid-obaid-bin-dhawi-al-nuaimi",
    "name": "Faisal Rashid Obaid bin Dhawi Al Nuaimi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Faisal Rashid Obaid bin Dhawi Al Nuaimi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_556b8c7a-f3e3-40e1-9b6f-aca1d134c5f6",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3322",
    "company": "Faisal Al Nuaimi Law Firm and Legal Consultations"
  },
  {
    "id": "1a051628-fa8a-45dd-86ef-df5c1f2e7e48",
    "slug": "faisal-salem-fayrouz-salem",
    "name": "Faisal Salem Fayrouz Salem",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Faisal Salem Fayrouz Salem",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_1a051628-fa8a-45dd-86ef-df5c1f2e7e48",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3610",
    "company": "Faisal Salem Advocates and Legal Consultants"
  },
  {
    "id": "d599aabf-d276-4756-8388-a9be9923a5ac",
    "slug": "faisal-saeed-mohammed-rashid-al-hafiti",
    "name": "Faisal Saeed Mohammed Rashid Al-Hafiti",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Faisal Saeed Mohammed Rashid Al-Hafiti",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_d599aabf-d276-4756-8388-a9be9923a5ac",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2962",
    "company": "Dr. Faisal Al-Hafiti Advocates and Legal Consultations LLC"
  },
  {
    "id": "42ec7563-584a-4b2f-93fd-77e84ec092e4",
    "slug": "faisal-obaid-mohammed-obaid-al-zaabi",
    "name": "Faisal Obaid Mohammed Obaid Al Zaabi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Faisal Obaid Mohammed Obaid Al Zaabi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_42ec7563-584a-4b2f-93fd-77e84ec092e4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3460",
    "company": "Faisal Obaid Al Zaabi Advocates and Legal Consultants"
  },
  {
    "id": "d6762e10-5b14-4de1-b0f6-b8a014edcf15",
    "slug": "faisal-issa-muhammad-al-qasim",
    "name": "Faisal Issa Muhammad Al Qasim",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Faisal Issa Muhammad Al Qasim",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_d6762e10-5b14-4de1-b0f6-b8a014edcf15",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4218",
    "company": "Faisal Al Qasim Advocates and Legal Consultants"
  },
  {
    "id": "4b4325bc-d7a1-404f-89b4-d1591f84f887",
    "slug": "cloth-by-ali-muhammad-abdullah",
    "name": "Cloth by Ali Muhammad Abdullah",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Cloth by Ali Muhammad Abdullah",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_4b4325bc-d7a1-404f-89b4-d1591f84f887",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4151",
    "company": "Qamasha Ali Muhammad Law Firm Legal Consultations"
  },
  {
    "id": "f694da5e-a9dc-45d0-8cce-9fe3ee6c24f1",
    "slug": "qamar-saleh-salem-al-kasadi",
    "name": "Qamar Saleh Salem Al-Kasadi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBRUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Qamar Saleh Salem Al-Kasadi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_f694da5e-a9dc-45d0-8cce-9fe3ee6c24f1",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2825",
    "company": "Qamar Al-Kasadi Law Firm and Legal Consultations"
  },
  {
    "id": "3f4b8c67-4d6e-4313-a2c4-ba9bdf841ec8",
    "slug": "kasib-muhammad-rashid-ahmed-al-hassani",
    "name": "Kasib Muhammad Rashid Ahmed Al-Hassani",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Kasib Muhammad Rashid Ahmed Al-Hassani",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_3f4b8c67-4d6e-4313-a2c4-ba9bdf841ec8",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4301",
    "company": "Kaseb Muhammad Al-Hassani Advocates and Legal Consultants"
  },
  {
    "id": "eaeb4b12-81f5-4123-baa6-2abd63ce4f40",
    "slug": "mohammed-al-najjar-law-firm-and-legal-consultations",
    "name": "Mohammed Al-Najjar Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Mohammed Al-Najjar Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_eaeb4b12-81f5-4123-baa6-2abd63ce4f40",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4045",
    "owner": "Kaltham Adel Hassan Al-Mahza"
  },
  {
    "id": "88b964c6-06f2-446b-940f-2ff955618517",
    "slug": "kaltham-muhammad-juma-abdullah-al-falasi",
    "name": "Kaltham Muhammad Juma Abdullah Al Falasi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Kaltham Muhammad Juma Abdullah Al Falasi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_88b964c6-06f2-446b-940f-2ff955618517",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4189",
    "company": "Kaltham Al Falasi Advocates and Legal Consultants"
  },
  {
    "id": "324be6b1-aa92-4e14-b255-1caa7a75e2f5",
    "slug": "kanaan-issa-youssef-ahmed-al-hosani",
    "name": "Kanaan Issa Youssef Ahmed Al Hosani",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Kanaan Issa Youssef Ahmed Al Hosani",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_324be6b1-aa92-4e14-b255-1caa7a75e2f5",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4239",
    "company": "Kanaan Issa Al Hosani Advocates and Legal Consultants"
  },
  {
    "id": "bd1dc991-d38e-44a2-ac47-6b626b39b4dd",
    "slug": "lubna-musa-rashid-hatamla",
    "name": "Lubna Musa Rashid Hatamla",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Lubna Musa Rashid Hatamla",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_bd1dc991-d38e-44a2-ac47-6b626b39b4dd",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4003",
    "company": "Lubna Moussa Advocates and Legal Consultants"
  },
  {
    "id": "859da544-62d3-4286-82bb-8a801875854f",
    "slug": "lubna-walid-mohammed-advocates-and-legal-consultants",
    "name": "Lubna Walid Mohammed Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIExXCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Lubna Walid Mohammed Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_859da544-62d3-4286-82bb-8a801875854f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3779",
    "owner": "Lubna Walid Muhammad Tamliya"
  },
  {
    "id": "85df4bf1-bcfc-4507-a6f9-9669265206d4",
    "slug": "latifa-abdel-moneim-salem-bin-suwaidan",
    "name": "Latifa Abdel Moneim Salem bin Suwaidan",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Latifa Abdel Moneim Salem bin Suwaidan",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_85df4bf1-bcfc-4507-a6f9-9669265206d4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4347",
    "company": "Bin Suwaidan Law Firm and Legal Consultations"
  },
  {
    "id": "5c7c9528-e15b-4cc3-844e-9fe8379762ac",
    "slug": "latifa-khalfan-al-mazroui-advocates-and-legal-consultants",
    "name": "Latifa Khalfan Al Mazroui Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIExLCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Latifa Khalfan Al Mazroui Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_5c7c9528-e15b-4cc3-844e-9fe8379762ac",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4073",
    "owner": "Latifa Khalfan Mohammed Al Mazrouei"
  },
  {
    "id": "212b9c03-d151-43a1-9dc4-b2351123e853",
    "slug": "laila-hamza-al-mulla-law-firm-and-legal-consultations",
    "name": "Laila Hamza Al Mulla Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIExICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Laila Hamza Al Mulla Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_212b9c03-d151-43a1-9dc4-b2351123e853",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2182",
    "owner": "Laila Hamza Ismail Muhammad Al-Mulla"
  },
  {
    "id": "84dcc7c1-f9ac-4b3e-bffe-5b85370df953",
    "slug": "ras-al-khaimah-law-firm-llc",
    "name": "Ras Al Khaimah Law Firm LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFJBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Ras Al Khaimah Law Firm LLC",
    "consultationFee": 500,
    "emirate": "Ras Al Khaimah",
    "verified": true,
    "offices": [
      {
        "id": "office_84dcc7c1-f9ac-4b3e-bffe-5b85370df953",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Ras Al Khaimah",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3875",
    "owner": "Laila Saeed Abdullah Laqtari Al-Otaibi"
  },
  {
    "id": "8bfdf2be-06ad-44cd-bd19-6d09047f3830",
    "slug": "laila-saleh-abdullah-al-junaibi",
    "name": "Laila Saleh Abdullah Al-Junaibi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Laila Saleh Abdullah Al-Junaibi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_8bfdf2be-06ad-44cd-bd19-6d09047f3830",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3310",
    "company": "Laila Saleh Al-Junaibi Advocates and Legal Consultations"
  },
  {
    "id": "043a92d3-6984-430e-a42c-cf7444d7e996",
    "slug": "laila-issa-suleiman-al-mahri",
    "name": "Laila Issa Suleiman Al Mahri",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Laila Issa Suleiman Al Mahri",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_043a92d3-6984-430e-a42c-cf7444d7e996",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "607",
    "company": "Laila Al Mahri Law Firm and Legal Consultations"
  },
  {
    "id": "11a42d26-006c-4114-8a28-ff0ad233a13b",
    "slug": "laila-muhammad-tawei-advocates-and-legal-consultants",
    "name": "Laila Muhammad Tawei Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIExNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Laila Muhammad Tawei Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_11a42d26-006c-4114-8a28-ff0ad233a13b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4325",
    "owner": "Laila Muhammad Ahmed Tawy"
  },
  {
    "id": "13d02ebf-40fa-42a3-a5ad-4add098ac765",
    "slug": "majid-al-jassim-law-firm-and-legal-consultations",
    "name": "Majid Al Jassim Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Majid Al Jassim Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_13d02ebf-40fa-42a3-a5ad-4add098ac765",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4035",
    "owner": "Majid Ahmed Mohammed Abdullah Al-Jassim"
  },
  {
    "id": "bb44791e-b5a1-4881-a54e-da1e554061d0",
    "slug": "majid-hamad-saeed-hamad-al-kalbani",
    "name": "Majid Hamad Saeed Hamad Al Kalbani",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Majid Hamad Saeed Hamad Al Kalbani",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_bb44791e-b5a1-4881-a54e-da1e554061d0",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4036",
    "company": "Majid Hamad Al Kalbani Advocates and Legal Consultants"
  },
  {
    "id": "917b3590-5e16-4dcc-9765-bcdb7914b195",
    "slug": "majid-saeed-hamad-al-jallaf-al-shuwaihi",
    "name": "Majid Saeed Hamad Al-Jallaf Al-Shuwaihi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Majid Saeed Hamad Al-Jallaf Al-Shuwaihi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_917b3590-5e16-4dcc-9765-bcdb7914b195",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "1268",
    "company": "Majid Al Jallaf Advocates and Legal Consultants"
  },
  {
    "id": "fd38870d-c359-4f33-b24b-8d2352ed31e9",
    "slug": "majid-abdullah-juma-muhammad-al-hosani",
    "name": "Majid Abdullah Juma Muhammad Al Hosani",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Majid Abdullah Juma Muhammad Al Hosani",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_fd38870d-c359-4f33-b24b-8d2352ed31e9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4644",
    "company": "Zayed Al Shamsi Advocates and Legal Consultants"
  },
  {
    "id": "be532e98-9560-4f74-b542-9a910db344ac",
    "slug": "majid-muhammad-al-sheikh-al-khazraji",
    "name": "Majid Muhammad Al-Sheikh Al-Khazraji",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Majid Muhammad Al-Sheikh Al-Khazraji",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_be532e98-9560-4f74-b542-9a910db344ac",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4",
    "company": "Majid Al-Sheikh Advocates and Legal Consultants"
  },
  {
    "id": "92b8d5e8-38dd-44ed-9ce8-6a89a08977e7",
    "slug": "abdullah-ibrahim-al-mansouri-advocates-and-legal-consultations",
    "name": "Abdullah Ibrahim Al Mansouri Advocates and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFJCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Abdullah Ibrahim Al Mansouri Advocates and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_92b8d5e8-38dd-44ed-9ce8-6a89a08977e7",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3713",
    "owner": "Majid Muhammad Abdullah Abdullah Al-Amiri"
  },
  {
    "id": "5ec0908c-7ffa-4829-a5ab-0082fc66f9fc",
    "slug": "mind-ahmed-mohammed-ahmed",
    "name": "Mind Ahmed Mohammed Ahmed",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Mind Ahmed Mohammed Ahmed",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_5ec0908c-7ffa-4829-a5ab-0082fc66f9fc",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2771",
    "company": "Manea Ahmed Law Firm and Legal Consultations"
  },
  {
    "id": "2f7ba9d8-20ee-4a96-be5b-ae4045273035",
    "slug": "mana-saeed-saif-hareb-al-muhairi",
    "name": "Mana Saeed Saif Hareb Al Muhairi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Mana Saeed Saif Hareb Al Muhairi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_2f7ba9d8-20ee-4a96-be5b-ae4045273035",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3890",
    "company": "Prestige Law Firm and Legal Consultations"
  },
  {
    "id": "5a38d96f-29e0-4bef-b0af-07df125c11f7",
    "slug": "mana-muhammad-ahmed-muhammad-abdullah",
    "name": "Mana Muhammad Ahmed Muhammad Abdullah",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Mana Muhammad Ahmed Muhammad Abdullah",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_5a38d96f-29e0-4bef-b0af-07df125c11f7",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4382",
    "company": "Mohamed Ahmed Law Firm and Legal Consultations"
  },
  {
    "id": "75c24f20-2c93-4f71-88d6-899316bb3c97",
    "slug": "maid-muhammad-jumah-hamid-al-marashdeh",
    "name": "Maid Muhammad Jumah Hamid Al-Marashdeh",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Maid Muhammad Jumah Hamid Al-Marashdeh",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_75c24f20-2c93-4f71-88d6-899316bb3c97",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3665",
    "company": "Mayed Al Marashda Advocates and Legal Consultants"
  },
  {
    "id": "fcd2c6f3-da62-48dd-96b6-f89038022981",
    "slug": "al-majd-law-firm-and-legal-consultations",
    "name": "Al Majd Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Al Majd Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_fcd2c6f3-da62-48dd-96b6-f89038022981",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "680",
    "owner": "Majd Khaled Othman"
  },
  {
    "id": "c144c08d-c965-41f2-aa93-8085fa861d2c",
    "slug": "magdy-gharib-nasser-al-ahbabi",
    "name": "Magdy Gharib Nasser Al-Ahbabi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Magdy Gharib Nasser Al-Ahbabi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c144c08d-c965-41f2-aa93-8085fa861d2c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3003",
    "company": "Majdi Al-Ahbabi Law Firm and Legal Consultations"
  },
  {
    "id": "b68f6d7e-e90e-4063-8b5a-63ce141efec6",
    "slug": "his-beloved-baqir-hussain-was-disdained",
    "name": "His beloved Baqir Hussain was disdained",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: His beloved Baqir Hussain was disdained",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_b68f6d7e-e90e-4063-8b5a-63ce141efec6",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4247",
    "company": "Mansour Lootah Advocates and Legal Consultants"
  },
  {
    "id": "7c8c9c73-241b-438e-a8f9-0be0b767e142",
    "slug": "muhammad-ibrahim-abdullah-al-bastaki",
    "name": "Muhammad Ibrahim Abdullah Al Bastaki",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Ibrahim Abdullah Al Bastaki",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_7c8c9c73-241b-438e-a8f9-0be0b767e142",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3619",
    "company": "Amal Al Bastaki Advocates and Legal Consultants"
  },
  {
    "id": "0c1be999-4df4-4063-a857-64f2fd2ef582",
    "slug": "mohammed-ahmed-al-zaabi",
    "name": "Mohammed Ahmed Al Zaabi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Mohammed Ahmed Al Zaabi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_0c1be999-4df4-4063-a857-64f2fd2ef582",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "223",
    "company": "Mohammed Ahmed Al Zaabi Law Firm and Legal Consultations"
  },
  {
    "id": "3956b5ef-82da-4073-8e73-6bbbc04c34a0",
    "slug": "muhammad-ahmed-al-sheikh-mahfouz-al-sheikh",
    "name": "Muhammad Ahmed Al-Sheikh Mahfouz Al-Sheikh",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Ahmed Al-Sheikh Mahfouz Al-Sheikh",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_3956b5ef-82da-4073-8e73-6bbbc04c34a0",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3856",
    "company": "Mohammed Al-Sheikh Advocates and Legal Consultations"
  },
  {
    "id": "6a893f05-5e14-4f6e-ba9b-e1de2d67f231",
    "slug": "ahmed-al-amiri-advocates-and-legal-consultations-dubai",
    "name": "Ahmed Al Amiri Advocates and Legal Consultations/ Dubai",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Ahmed Al Amiri Advocates and Legal Consultations/ Dubai",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_6a893f05-5e14-4f6e-ba9b-e1de2d67f231",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3494",
    "owner": "Muhammad Ahmed Ali Ibrahim Al-Amiri"
  },
  {
    "id": "66df00e6-0381-4251-a5f2-a01bb8341a26",
    "slug": "muhammad-ahmed-ali-ahmed-al-lingawi",
    "name": "Muhammad Ahmed Ali Ahmed Al-Lingawi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Ahmed Ali Ahmed Al-Lingawi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_66df00e6-0381-4251-a5f2-a01bb8341a26",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2412",
    "company": "Muhammad Al-Lingawi Law Firm and Legal Consultations"
  },
  {
    "id": "60006a2a-dcf5-4480-8b24-976e22f7d93a",
    "slug": "issam-al-zarouni-law-firm-and-legal-consultations",
    "name": "Issam Al Zarouni Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIElBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Issam Al Zarouni Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_60006a2a-dcf5-4480-8b24-976e22f7d93a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4404",
    "owner": "Muhammad Ahmed Ali Al-Murshedy"
  },
  {
    "id": "bff59aab-86ef-4b56-864d-3a0bd5835edc",
    "slug": "muhammad-ahmed-ali-abdullah-al-najjar",
    "name": "Muhammad Ahmed Ali Abdullah Al-Najjar",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Ahmed Ali Abdullah Al-Najjar",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_bff59aab-86ef-4b56-864d-3a0bd5835edc",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3888",
    "company": "Mohammed Al-Najjar Law Firm and Legal Consultations"
  },
  {
    "id": "fb707b42-dab0-4feb-9bf7-f98162937b1a",
    "slug": "muhammad-ahmed-ghulam-darwish-al-balushi",
    "name": "Muhammad Ahmed Ghulam Darwish Al Balushi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Ahmed Ghulam Darwish Al Balushi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_fb707b42-dab0-4feb-9bf7-f98162937b1a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2476",
    "company": "Mohammed Al Balushi and Ruqaya Ali Law Firm"
  },
  {
    "id": "e79d7ec3-9ce1-412c-9a43-06b4aa3c1de4",
    "slug": "muhammad-ibrahim-hassan-al-shaiba",
    "name": "Muhammad Ibrahim Hassan Al-Shaiba",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Ibrahim Hassan Al-Shaiba",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e79d7ec3-9ce1-412c-9a43-06b4aa3c1de4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "647",
    "company": "Al Shaiba Advocates and Legal Consultants"
  },
  {
    "id": "c504ba49-7cc3-40b6-b89f-098b536afacd",
    "slug": "muhammad-ibrahim-hassan-ali-al-marzouqi",
    "name": "Muhammad Ibrahim Hassan Ali Al Marzouqi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Ibrahim Hassan Ali Al Marzouqi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c504ba49-7cc3-40b6-b89f-098b536afacd",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3574",
    "company": "Mohammed Ibrahim Al Marzouqi Law Firm"
  },
  {
    "id": "0b7e7676-49c6-4c49-a83c-60691924259a",
    "slug": "muhammad-ibrahim-muhammad-salmeen",
    "name": "Muhammad Ibrahim Muhammad Salmeen",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Ibrahim Muhammad Salmeen",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_0b7e7676-49c6-4c49-a83c-60691924259a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4598",
    "company": "Mohamed Ibrahim Salmeen Law Firm and Legal Consultations Office"
  },
  {
    "id": "b97baf97-e7a2-41d6-99ee-f2cc3790977a",
    "slug": "muhammad-ahmed-sheikh-nassar-ibrahim-al-shammari",
    "name": "Muhammad Ahmed Sheikh Nassar Ibrahim Al-Shammari",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Ahmed Sheikh Nassar Ibrahim Al-Shammari",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_b97baf97-e7a2-41d6-99ee-f2cc3790977a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4349",
    "company": "Mohammed bin Nassar Al-Shammari Law Firm and Legal Consultations"
  },
  {
    "id": "b65e75ed-1e39-41ec-8d8a-7dc5a1246ee1",
    "slug": "muhammad-ahmed-muhammad-abdullah-lubari",
    "name": "Muhammad Ahmed Muhammad Abdullah Lubari",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Ahmed Muhammad Abdullah Lubari",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_b65e75ed-1e39-41ec-8d8a-7dc5a1246ee1",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3994",
    "company": "Ahmed Ibrahim Law Firm and Legal Consultations"
  },
  {
    "id": "73b61d67-f527-4f3c-ac33-0eaaa1059f8a",
    "slug": "muhammad-ahmed-muhammad-naji-al-hashidi",
    "name": "Muhammad Ahmed Muhammad Naji Al-Hashidi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Ahmed Muhammad Naji Al-Hashidi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_73b61d67-f527-4f3c-ac33-0eaaa1059f8a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4513",
    "company": "Hayel Al-Harbi Lawyers and Legal Consultants"
  },
  {
    "id": "081bf2c2-73fb-42e9-8cb0-d87d8f4f612d",
    "slug": "muhammad-al-barak-abdullah-salem-al-amiri",
    "name": "Muhammad Al-Barak Abdullah Salem Al-Amiri",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Al-Barak Abdullah Salem Al-Amiri",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_081bf2c2-73fb-42e9-8cb0-d87d8f4f612d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4506",
    "company": "Mohammed Al-Barak Al-Amiri Law Firm and Legal Consultations"
  },
  {
    "id": "725b2893-2a90-4862-9fb6-f844ab53624c",
    "slug": "mohammed-al-omar-al-menhali-law-firm-and-legal-consultations-office",
    "name": "Mohammed Al Omar Al Menhali Law Firm and Legal Consultations Office",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Mohammed Al Omar Al Menhali Law Firm and Legal Consultations Office",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_725b2893-2a90-4862-9fb6-f844ab53624c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4087",
    "owner": "Muhammad Al-Omar Saleh Saeed Al-Menhali"
  },
  {
    "id": "bddeeeaa-21cf-4739-ac8a-3719f443225f",
    "slug": "muhammad-butti-thani-tarish-al-shamsi",
    "name": "Muhammad Butti Thani Tarish Al Shamsi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Butti Thani Tarish Al Shamsi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_bddeeeaa-21cf-4739-ac8a-3719f443225f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4237",
    "company": "Zayed Al Shamsi Advocates and Legal Consultants"
  },
  {
    "id": "852c5f6b-7c47-4244-ad74-7af5fb573f06",
    "slug": "muhammad-thamer-yaqoub-yousef-al-sarkal",
    "name": "AYSHA ABDULRAHMAN MOHAMED ABDULLA ALTENEIJI",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/03/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Thamer Yaqoub Yousef Al Sarkal",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_852c5f6b-7c47-4244-ad74-7af5fb573f06",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "L-1934",
    "company": "Mohammed Al Sarkal Law Firm and Legal Consultations"
  },
  {
    "id": "35757a88-3682-4bc9-bdad-c1839dabcab2",
    "slug": "muhammad-jaber-ahmed-bin-jabr-al-shamsi",
    "name": "Muhammad Jaber Ahmed bin Jabr Al Shamsi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Jaber Ahmed bin Jabr Al Shamsi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_35757a88-3682-4bc9-bdad-c1839dabcab2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4127",
    "company": "Mohammed bin Jabr Al Shamsi Law Firm and Legal Consultations"
  },
  {
    "id": "3b359ff2-b39e-4f0b-b6a7-776553aabeb1",
    "slug": "abdulaziz-al-khamiri-law-firm-and-legal-consultations",
    "name": "Abdulaziz Al-Khamiri Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Abdulaziz Al-Khamiri Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_3b359ff2-b39e-4f0b-b6a7-776553aabeb1",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4266",
    "owner": "Muhammad Jassim Muhammad Al-Mazmi"
  },
  {
    "id": "14c24a54-8a87-4d15-a0c1-4fa2154aa06a",
    "slug": "muhammad-jamal-saif-obaid-al-hathboor",
    "name": "Muhammad Jamal Saif Obaid Al Hathboor",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Jamal Saif Obaid Al Hathboor",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_14c24a54-8a87-4d15-a0c1-4fa2154aa06a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2999",
    "company": "Muhammad Al Hathboor Law Firm and Legal Consultations"
  },
  {
    "id": "515e6846-e6bc-464d-b69e-24ce6543e02e",
    "slug": "muhammad-jamil-ghanem-ali-al-alawi",
    "name": "Muhammad Jamil Ghanem Ali Al-Alawi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Jamil Ghanem Ali Al-Alawi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_515e6846-e6bc-464d-b69e-24ce6543e02e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4028",
    "company": "Mohammed Jamil Al-Alawi Law Firm and Legal Consultations"
  },
  {
    "id": "3f0319e5-78fd-476d-b27a-414e5fc412cb",
    "slug": "ali-hassan-al-hammadi-law-firm-and-legal-consultations",
    "name": "Ali Hassan Al Hammadi Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Ali Hassan Al Hammadi Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_3f0319e5-78fd-476d-b27a-414e5fc412cb",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3703, 4539",
    "owner": "Muhammad Haji Hassan Ali Al Marzouqi"
  },
  {
    "id": "be2206d2-f57c-433a-93d5-91df75e4c005",
    "slug": "muhammad-hamid-qayed-al-azazi",
    "name": "Muhammad Hamid Qayed Al-Azazi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Hamid Qayed Al-Azazi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_be2206d2-f57c-433a-93d5-91df75e4c005",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "1314",
    "company": "Mohammed Al-Azazi Law Firm and Legal Consultations"
  },
  {
    "id": "547540c8-81ab-443c-99d5-32c84f2a4b6a",
    "slug": "muhammad-hassan-ibrahim-abdullah-al-shaer",
    "name": "Muhammad Hassan Ibrahim Abdullah Al-Shaer",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Hassan Ibrahim Abdullah Al-Shaer",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_547540c8-81ab-443c-99d5-32c84f2a4b6a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4101",
    "company": "Mohamed Hassan Al-Shaer Law Firm and Legal Consultations"
  },
  {
    "id": "eb2a97e3-ac2b-456b-9d46-1c4978940dac",
    "slug": "muhammad-hassan-darwish-on-the-main-page",
    "name": "Muhammad Hassan Darwish on the main page",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Hassan Darwish on the main page",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_eb2a97e3-ac2b-456b-9d46-1c4978940dac",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4700",
    "company": "Dr. Mohamed Hassan Al-Raisi Advocates and Legal Consultants"
  },
  {
    "id": "b38ca293-852a-4681-9bdc-bfdc83329de7",
    "slug": "al-tamimi-partners-advocates-and-legal-consultants",
    "name": "Al Tamimi & Partners Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFUCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Al Tamimi & Partners Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_b38ca293-852a-4681-9bdc-bfdc83329de7",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2255, 3502, 4167, 4243",
    "owner": "Muhammad Hassan Muhammad Arab"
  },
  {
    "id": "934ca8d1-c1a9-40a8-93b0-5b70cdef4369",
    "slug": "muhammad-hassan-youssef-hatem-al-hosani",
    "name": "Muhammad Hassan Youssef Hatem Al Hosani",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Hassan Youssef Hatem Al Hosani",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_934ca8d1-c1a9-40a8-93b0-5b70cdef4369",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2504",
    "company": "Mohamed Hassan Hatem Law Firm and Legal Consultations"
  },
  {
    "id": "80df9ecc-e2b7-403a-8c4d-4bc38a82b672",
    "slug": "hamdan-al-kaabi-law-firm-and-legal-consultations",
    "name": "Hamdan Al Kaabi Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Hamdan Al Kaabi Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_80df9ecc-e2b7-403a-8c4d-4bc38a82b672",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4371",
    "owner": "Muhammad Hamad Mabkhout Suwaidan Al-Menhali"
  },
  {
    "id": "8c066238-3572-4730-85e8-187be4afa91c",
    "slug": "muhammad-hamid-abdullah-hassan-al-sabah",
    "name": "Muhammad Hamid Abdullah Hassan Al-Sabah",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Hamid Abdullah Hassan Al-Sabah",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_8c066238-3572-4730-85e8-187be4afa91c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2606",
    "company": "Al Omar and Al Sabah Law Firm"
  },
  {
    "id": "e2e401a4-3ac2-4f34-ab3b-a2156e59baee",
    "slug": "mohammed-khadem-al-ghaithi-advocates-and-legal-consultants",
    "name": "Mohammed Khadem Al Ghaithi Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1LCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Mohammed Khadem Al Ghaithi Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e2e401a4-3ac2-4f34-ab3b-a2156e59baee",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3792",
    "owner": "Muhammad Khadem Saeed Muhammad Al-Ghaithi"
  },
  {
    "id": "21d41c50-56a7-433a-93ad-266192977191",
    "slug": "muhammad-khazal-muhammad-abdul-jabbar-al-obaidli",
    "name": "Muhammad Khazal Muhammad Abdul-Jabbar Al-Obaidli",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Khazal Muhammad Abdul-Jabbar Al-Obaidli",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_21d41c50-56a7-433a-93ad-266192977191",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3198",
    "company": "Mohammed Bani Hashem Advocates and Legal Consultants"
  },
  {
    "id": "30ab9695-2054-40af-8e3c-0ba409dcb935",
    "slug": "muhammad-dalham-muhammad-dalham-al-hajri",
    "name": "Muhammad Dalham Muhammad Dalham Al-Hajri",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Dalham Muhammad Dalham Al-Hajri",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_30ab9695-2054-40af-8e3c-0ba409dcb935",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3280",
    "company": "Muhammad Dalham Al-Hajri Law Offices and Legal Consultations - LLC - S.P.C"
  },
  {
    "id": "33682ab1-a2ed-4c66-88af-190253452d74",
    "slug": "muhammad-rashid-salem-rashid-al-ghafli",
    "name": "Muhammad Rashid Salem Rashid Al-Ghafli",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Rashid Salem Rashid Al-Ghafli",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_33682ab1-a2ed-4c66-88af-190253452d74",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4361",
    "company": "Mohammed Rashid Al-Ghafli Law Firm and Legal Consultations"
  },
  {
    "id": "9a7f5947-7433-4f67-82d9-a54e0b29a7c5",
    "slug": "al-reyadah-law-firm-and-legal-consultationsabu-dhabi",
    "name": "Al Reyadah Law Firm and Legal Consultations/Abu Dhabi",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFSCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Al Reyadah Law Firm and Legal Consultations/Abu Dhabi",
    "consultationFee": 500,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_9a7f5947-7433-4f67-82d9-a54e0b29a7c5",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "193",
    "owner": "Muhammad Rashid Ali Al Hosani"
  },
  {
    "id": "ace36ba7-caab-41b3-be6a-8ee491913510",
    "slug": "muhammad-rashid-muhammad-bin-jabr-al-suwaidi",
    "name": "Muhammad Rashid Muhammad bin Jabr Al Suwaidi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Rashid Muhammad bin Jabr Al Suwaidi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_ace36ba7-caab-41b3-be6a-8ee491913510",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "159",
    "company": "Al Suwaidi & Partners Advocates and Legal Consultants - Dubai"
  },
  {
    "id": "8ef97d10-8b52-4286-b245-68af06c8755e",
    "slug": "mohammed-bin-qanzoul-al-ketbi-law-firm-and-legal-consultations",
    "name": "Mohammed bin Qanzoul Al Ketbi Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1CCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Mohammed bin Qanzoul Al Ketbi Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_8ef97d10-8b52-4286-b245-68af06c8755e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4145",
    "owner": "Muhammad Rashid Muhammad bin Qanzul Al-Kutbi"
  },
  {
    "id": "a40f0958-ac89-474d-82a9-58d5205d1049",
    "slug": "muhammad-salem-saeed-muhammad-al-jabri",
    "name": "Muhammad Salem Saeed Muhammad Al-Jabri",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Salem Saeed Muhammad Al-Jabri",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_a40f0958-ac89-474d-82a9-58d5205d1049",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4612",
    "company": "Al Jabri Law Firm and Legal Consultations"
  },
  {
    "id": "c4c9f2bc-e7d5-44db-a366-52d6fbbd7e1e",
    "slug": "muhammad-salem-suwaidan-muhammad-al-muqbali",
    "name": "Muhammad Salem Suwaidan Muhammad Al-Muqbali",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Salem Suwaidan Muhammad Al-Muqbali",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c4c9f2bc-e7d5-44db-a366-52d6fbbd7e1e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3490",
    "company": "Mohammed bin Suwaidan Al-Muqbali Advocates and Legal Consultants"
  },
  {
    "id": "47b30b5b-1ffa-4f47-a8a0-5a91c2503c56",
    "slug": "muhammad-salem-muhammad-hassan-al-khatri",
    "name": "Muhammad Salem Muhammad Hassan Al Khatri",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Salem Muhammad Hassan Al Khatri",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_47b30b5b-1ffa-4f47-a8a0-5a91c2503c56",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3247",
    "company": "Mohammed Al Khatri Law Firm and Legal Consultations"
  },
  {
    "id": "edfd8bbe-ac28-411d-b548-be6e91308402",
    "slug": "muhammad-saeed-obaid-bin-khamsun-al-naqbi",
    "name": "Muhammad Saeed Obaid bin Khamsun Al-Naqbi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Saeed Obaid bin Khamsun Al-Naqbi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_edfd8bbe-ac28-411d-b548-be6e91308402",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4716",
    "company": "Abdullah Al-Nakhi Law Firm and Legal Consultations"
  },
  {
    "id": "b0a41372-ef50-4b42-b0ff-5bafcb6b4d82",
    "slug": "muhammad-saeed-obaid-matar-al-naqbi",
    "name": "Muhammad Saeed Obaid Matar Al-Naqbi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Saeed Obaid Matar Al-Naqbi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_b0a41372-ef50-4b42-b0ff-5bafcb6b4d82",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4285",
    "company": "Awatef Mohamed Shawqi Law Firm, Legal Consultations"
  },
  {
    "id": "1bd4cbc5-3b99-4e82-a568-0fcaed407d26",
    "slug": "muhammad-saeed-al-ahbabi-law-firm-and-legal-consultations-one-person-company-llc",
    "name": "Muhammad Saeed Al Ahbabi Law Firm and Legal Consultations - One Person Company LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1TCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Muhammad Saeed Al Ahbabi Law Firm and Legal Consultations - One Person Company LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_1bd4cbc5-3b99-4e82-a568-0fcaed407d26",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4290",
    "owner": "Muhammad Saeed Muhammad Fahd Al-Ahbabi"
  },
  {
    "id": "e3398783-dd8a-4abf-8d76-e20dd5615e6f",
    "slug": "muhammad-sultan-abdulaziz-rashid-al-nuaimi",
    "name": "Muhammad Sultan Abdulaziz Rashid Al Nuaimi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Sultan Abdulaziz Rashid Al Nuaimi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e3398783-dd8a-4abf-8d76-e20dd5615e6f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4540",
    "company": "Mohammed Sultan Al Nuaimi Advocates and Legal Consultations LLC"
  },
  {
    "id": "e7ea7870-2333-45ab-b8a3-cfe89b0410fd",
    "slug": "muhammad-salman-hassan-al-sabri",
    "name": "Muhammad Salman Hassan Al-Sabri",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Salman Hassan Al-Sabri",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e7ea7870-2333-45ab-b8a3-cfe89b0410fd",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "185",
    "company": "Al-Taher and Al-Sabri Law Firm and Legal Consultations"
  },
  {
    "id": "60a24700-b7f1-4f69-8fe3-7c9344244d7d",
    "slug": "hilal-partners-are-lawyers-and-legal-consultants",
    "name": "Hilal & Partners are lawyers and legal consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhQCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Hilal & Partners are lawyers and legal consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_60a24700-b7f1-4f69-8fe3-7c9344244d7d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2927",
    "owner": "Mohamed Saif Hamid Bouassiba"
  },
  {
    "id": "2fea2c6a-e505-44b3-b38e-2204b288394e",
    "slug": "muhammad-saif-abdul-rahman-bin-darwish-al-taniji",
    "name": "Muhammad Saif Abdul Rahman bin Darwish Al-Taniji",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Saif Abdul Rahman bin Darwish Al-Taniji",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_2fea2c6a-e505-44b3-b38e-2204b288394e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4293",
    "company": "Dr. Muhammad Saif Al-Taniji Advocates and Legal Consultants"
  },
  {
    "id": "9f4dbc43-31ef-4546-87fb-a97e60710f68",
    "slug": "muhammad-saif-muhammad-saif-al-tamimi",
    "name": "Muhammad Saif Muhammad Saif Al Tamimi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Saif Muhammad Saif Al Tamimi",
    "consultationFee": 400,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_9f4dbc43-31ef-4546-87fb-a97e60710f68",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3603",
    "company": "Mohammed Saif Al Tamimi Advocates and Legal Consultants - Abu Dhabi"
  },
  {
    "id": "e3e31040-c186-4229-ab5e-c68bce863320",
    "slug": "muhammad-shihab-ahmed-thani-al-farsi",
    "name": "Muhammad Shihab Ahmed Thani Al Farsi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Shihab Ahmed Thani Al Farsi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e3e31040-c186-4229-ab5e-c68bce863320",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4133",
    "company": "Muhammad Shehab Al Farsi Advocates and Legal Consultations LLC"
  },
  {
    "id": "df26a3a9-ec5b-49a6-af94-eacf6c175e65",
    "slug": "al-ittihad-law-firm-and-legal-consultations",
    "name": "Al-Ittihad Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFMCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Al-Ittihad Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_df26a3a9-ec5b-49a6-af94-eacf6c175e65",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3777",
    "owner": "Muhammad Saleh Al-Menhali"
  },
  {
    "id": "6fd9c2e7-de08-47f9-92c0-ea79dc38b234",
    "slug": "mubarak-abdullah-advocates-and-legal-consultantsabu-dhabi",
    "name": "Mubarak Abdullah Advocates and Legal Consultants/Abu Dhabi",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Mubarak Abdullah Advocates and Legal Consultants/Abu Dhabi",
    "consultationFee": 500,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_6fd9c2e7-de08-47f9-92c0-ea79dc38b234",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3554",
    "owner": "Muhammad Saleh Jariba Hussein"
  },
  {
    "id": "25b75ab9-eab5-463f-a6e7-e156424a93db",
    "slug": "muhammad-abbas-qambar-muhammad-al-balushi",
    "name": "Muhammad Abbas Qambar Muhammad Al Balushi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Abbas Qambar Muhammad Al Balushi",
    "consultationFee": 400,
    "emirate": "Sharjah",
    "verified": true,
    "offices": [
      {
        "id": "office_25b75ab9-eab5-463f-a6e7-e156424a93db",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Sharjah",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4472",
    "company": "Al-Hamad Advocates and Legal Consultants / Sharjah"
  },
  {
    "id": "3c058b9b-80aa-421b-a36e-77dd270ebe32",
    "slug": "muhammad-abd-al-rahman-muhammad-al-bakr",
    "name": "Muhammad Abd al-Rahman Muhammad al-Bakr",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Abd al-Rahman Muhammad al-Bakr",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_3c058b9b-80aa-421b-a36e-77dd270ebe32",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "104",
    "company": "Al-Bakr Law Firm and Legal Consultations"
  },
  {
    "id": "c2f08ce9-af6b-4ff8-8873-5fd309d54be0",
    "slug": "abdul-malik-and-partners-are-lawyers-and-legal-consultants",
    "name": "Abdul Malik and Partners are lawyers and legal consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Abdul Malik and Partners are lawyers and legal consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c2f08ce9-af6b-4ff8-8873-5fd309d54be0",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "341, 2744",
    "owner": "Muhammad Abd al-Malik Mustafa Ahli"
  },
  {
    "id": "17bcec51-8616-4325-9c28-732b7ffefc2e",
    "slug": "muhammad-abdul-ilah-hadi-hussein-al-hamid",
    "name": "Muhammad Abdul-Ilah Hadi Hussein Al-Hamid",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Abdul-Ilah Hadi Hussein Al-Hamid",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_17bcec51-8616-4325-9c28-732b7ffefc2e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3306",
    "company": "Muhammad Abdul-Ilah Al-Hamid Advocates and Legal Consultants"
  },
  {
    "id": "b62f979c-0117-4f25-9c16-f32c348eacd2",
    "slug": "muhammad-abdul-hamid-abdullah-al-khazraji",
    "name": "Muhammad Abdul Hamid Abdullah Al Khazraji",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Abdul Hamid Abdullah Al Khazraji",
    "consultationFee": 400,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_b62f979c-0117-4f25-9c16-f32c348eacd2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "231",
    "company": "Dr. Al Khazraji Advocates and Legal Consultants/Abu Dhabi"
  },
  {
    "id": "5e2633c2-c7b3-48f3-988f-eed7567e6606",
    "slug": "muhammad-abdul-rahman-muhammad-abdullah-al-suwaidi",
    "name": "Muhammad Abdul Rahman Muhammad Abdullah Al Suwaidi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Abdul Rahman Muhammad Abdullah Al Suwaidi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_5e2633c2-c7b3-48f3-988f-eed7567e6606",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3828",
    "company": "Younis Mohammed Al Balushi Advocates and Legal Consultants"
  },
  {
    "id": "7b9c9321-2a03-4bb7-adbd-0f413430e846",
    "slug": "muhammad-abdul-qadir-alawi-al-haythami-al-harthy",
    "name": "SAIF ALI EBRAHEEM",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/01/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Abdul Qadir Alawi Al-Haythami Al-Harthy",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_7b9c9321-2a03-4bb7-adbd-0f413430e846",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "L-1914",
    "company": "Al Haithami Advocates and Legal Consultations"
  },
  {
    "id": "d6e12aaf-3daf-4dc0-b49b-522106608df7",
    "slug": "muhammad-abdullah-saeed-al-mazloum-al-suwaidi",
    "name": "Muhammad Abdullah Saeed Al-Mazloum Al-Suwaidi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Abdullah Saeed Al-Mazloum Al-Suwaidi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_d6e12aaf-3daf-4dc0-b49b-522106608df7",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "1089",
    "company": "Mohammed Al Suwaidi Advocates and Legal Consultants"
  },
  {
    "id": "723711ef-1bc5-41e7-a59b-49ac3b1b29ce",
    "slug": "muhammad-abdullah-saeed-nahil-al-nuaimi",
    "name": "Muhammad Abdullah Saeed Nahil Al Nuaimi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Abdullah Saeed Nahil Al Nuaimi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_723711ef-1bc5-41e7-a59b-49ac3b1b29ce",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4216",
    "company": "Salem Bin Bahyan Advocates and Legal Consultants/Al Ain"
  },
  {
    "id": "eed5902b-afbf-4649-a753-fa77f8241a76",
    "slug": "muhammad-abdullah-abdul-karim-blocki",
    "name": "OMRAN ALI SALIM NASIR ALRAWI",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/01/2004",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-01-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Abdullah Abdul Karim Blocki",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_eed5902b-afbf-4649-a753-fa77f8241a76",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "L-374",
    "company": "Salam Law Firm and Legal Consultations"
  },
  {
    "id": "036da97e-d28b-4ef7-993c-e1461c749a64",
    "slug": "muhammad-abdullah-ali-bamakhramah-al-humairi",
    "name": "Muhammad Abdullah Ali Bamakhramah Al-Humairi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Abdullah Ali Bamakhramah Al-Humairi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_036da97e-d28b-4ef7-993c-e1461c749a64",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3922",
    "company": "Office of Muhammad Bamakhrama Al-Humairi Law Firm and Legal Consultations"
  },
  {
    "id": "10238e39-7ac4-4b03-9aad-a6855c3f19b4",
    "slug": "muhammad-abdullah-muhammad-abdullah-al-murr",
    "name": "Muhammad Abdullah Muhammad Abdullah Al-Murr",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Abdullah Muhammad Abdullah Al-Murr",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_10238e39-7ac4-4b03-9aad-a6855c3f19b4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4634",
    "company": "Dr. Muhammad Al-Murr Law Firm and Legal Consultations"
  },
  {
    "id": "e63456bf-f40e-4b56-bc0c-d01de693db30",
    "slug": "muhammad-obaid-khalfan-al-suwaidi",
    "name": "Muhammad Obaid Khalfan Al Suwaidi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Obaid Khalfan Al Suwaidi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e63456bf-f40e-4b56-bc0c-d01de693db30",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "723",
    "company": "Ittefaq International Law Firm and Legal Consultations"
  },
  {
    "id": "d39c985d-7c54-412e-9c25-b443e98aa80c",
    "slug": "muhammad-obaid-muhammad-hussein-al-shaali",
    "name": "Muhammad Obaid Muhammad Hussein Al-Shaali",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Obaid Muhammad Hussein Al-Shaali",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_d39c985d-7c54-412e-9c25-b443e98aa80c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "1092",
    "company": "Adnan Obaid Al-Shaali Law Firm and Legal Consultations"
  },
  {
    "id": "89f9999b-428d-4e60-970f-6c19cfcd9f88",
    "slug": "muhammad-ali-ahmed-al-mujaini",
    "name": "Muhammad Ali Ahmed Al-Mujaini",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Ali Ahmed Al-Mujaini",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_89f9999b-428d-4e60-970f-6c19cfcd9f88",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3778",
    "company": "Muhammad Ali Al-Mujaini Law Firm and Legal Consultations"
  },
  {
    "id": "b4ebbc84-4076-4125-979e-7302756b6026",
    "slug": "muhammad-ali-ahmed-abdullah-al-dhanhani",
    "name": "Muhammad Ali Ahmed Abdullah Al-Dhanhani",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Ali Ahmed Abdullah Al-Dhanhani",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_b4ebbc84-4076-4125-979e-7302756b6026",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4387",
    "company": "Muhammad Ali Al-Dhanhani Law Firm and Legal Consultations"
  },
  {
    "id": "e09da74d-feda-4b02-ac28-3ce4e013b6c6",
    "slug": "muhammad-ali-bey-muhammad-bashir-al-mazmi",
    "name": "Muhammad Ali Bey Muhammad Bashir Al-Mazmi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Ali Bey Muhammad Bashir Al-Mazmi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e09da74d-feda-4b02-ac28-3ce4e013b6c6",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "509",
    "company": "Al Tadamon Law Firm and Legal Consultations"
  },
  {
    "id": "cce3c546-aa11-4164-acae-60a44a1476cb",
    "slug": "muhammad-ali-hamid-muhammad-al-kumaiti",
    "name": "MOHAMMAD ABDULLA HUMAID ALHOULI ALSUWAIDI",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/05/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Ali Hamid Muhammad Al-Kumaiti",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_cce3c546-aa11-4164-acae-60a44a1476cb",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "L-2099",
    "company": "Mohammed Al-Kumaiti Law Firm and Legal Consultations"
  },
  {
    "id": "3c01604d-4a6b-4f92-82c9-bc7568935a2a",
    "slug": "muhammad-ali-abdullah-al-houti",
    "name": "Muhammad Ali Abdullah Al-Houti",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Ali Abdullah Al-Houti",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_3c01604d-4a6b-4f92-82c9-bc7568935a2a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4414",
    "company": "Mohammed Al-Houti Advocates and Legal Consultations"
  },
  {
    "id": "ab376055-1769-46c7-a7bd-6dccfec967fc",
    "slug": "muhammad-ali-abdullah-al-kamali",
    "name": "Muhammad Ali Abdullah Al Kamali",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Ali Abdullah Al Kamali",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_ab376055-1769-46c7-a7bd-6dccfec967fc",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "380",
    "company": "Al Kamali & Partners are lawyers and legal consultants"
  },
  {
    "id": "60465f08-3cbf-47ce-96b2-f458325f96e0",
    "slug": "muhammad-ali-muhammad-bin-qaddad-al-muhairi",
    "name": "Muhammad Ali Muhammad bin Qaddad Al Muhairi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Ali Muhammad bin Qaddad Al Muhairi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_60465f08-3cbf-47ce-96b2-f458325f96e0",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3536",
    "company": "Mohammed Al Muhairi Advocates and Legal Consultations"
  },
  {
    "id": "aff2b926-2e3c-46b2-b95e-dbe10f094c20",
    "slug": "muhammad-ali-muhammad-ali-al-dahbashi",
    "name": "Muhammad Ali Muhammad Ali Al-Dahbashi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Ali Muhammad Ali Al-Dahbashi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_aff2b926-2e3c-46b2-b95e-dbe10f094c20",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2237",
    "company": "Mohammed Al-Dahbashi Law Firm LLC"
  },
  {
    "id": "8aa9b9a2-4f6b-4f79-99fe-bfcb5a01419e",
    "slug": "mohammed-omar-al-siyabi-law-office-and-legal-consultations",
    "name": "Mohammed Omar Al Siyabi Law Office and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1PCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Mohammed Omar Al Siyabi Law Office and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_8aa9b9a2-4f6b-4f79-99fe-bfcb5a01419e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4340",
    "owner": "Muhammad Omar Hudayb Salem Al-Siyabi"
  },
  {
    "id": "2cf4a3f2-4749-4d67-83bd-fd2ff15ef733",
    "slug": "muhammad-eid-jassim-al-suwaidi",
    "name": "Muhammad Eid Jassim Al Suwaidi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Eid Jassim Al Suwaidi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_2cf4a3f2-4749-4d67-83bd-fd2ff15ef733",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2541",
    "company": "Mohammed Eid Al Suwaidi Law Firm and Legal Consultations - One Person Company LLC"
  },
  {
    "id": "ef666596-27e3-4a3d-aefc-0bcfb325b16c",
    "slug": "muhammad-issa-bakhit-huwaireb-al-mansouri",
    "name": "Muhammad Issa Bakhit Huwaireb Al Mansouri",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Issa Bakhit Huwaireb Al Mansouri",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_ef666596-27e3-4a3d-aefc-0bcfb325b16c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2484",
    "company": "Office of Mohammed Issa Al Mansouri Law Firm and Legal Consultations"
  },
  {
    "id": "3df66be6-4039-4b2f-a14c-3700b916a7ba",
    "slug": "muhammad-issa-shambiah-muftah-al-balushi",
    "name": "Muhammad Issa Shambiah Muftah Al Balushi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Issa Shambiah Muftah Al Balushi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_3df66be6-4039-4b2f-a14c-3700b916a7ba",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3313",
    "company": "Mohammed Issa Al Balushi Advocates and Legal Consultations"
  },
  {
    "id": "971b931e-4671-40c2-bc39-c95c93dcce6c",
    "slug": "muhammad-mubarak-rashed-salem-al-ghafli",
    "name": "Muhammad Mubarak Rashed Salem Al-Ghafli",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Mubarak Rashed Salem Al-Ghafli",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_971b931e-4671-40c2-bc39-c95c93dcce6c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2993",
    "company": "Mohammed Mubarak Rashid Al-Ghafli Law Firm and Legal Consultations"
  },
  {
    "id": "50079e29-5f16-4f44-bc8f-ad8932ed0eaf",
    "slug": "muhammad-mubarak-muhammad-al-washam-al-junaibi",
    "name": "Muhammad Mubarak Muhammad Al-Washam Al-Junaibi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Mubarak Muhammad Al-Washam Al-Junaibi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_50079e29-5f16-4f44-bc8f-ad8932ed0eaf",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4222",
    "company": "Mohammed Al-Washam Al-Junaibi Advocates and Legal Consultations"
  },
  {
    "id": "0face728-e45d-4d33-8ce1-e2ad4518be3b",
    "slug": "muhammad-marwan-abdullah-al-matroushi",
    "name": "Muhammad Marwan Abdullah Al Matroushi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Marwan Abdullah Al Matroushi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_0face728-e45d-4d33-8ce1-e2ad4518be3b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4400",
    "company": "Al Owais and Al Matroushi Advocates and Legal Consultants"
  },
  {
    "id": "9f9fd26f-8db2-40cd-a45f-4b020f6a7040",
    "slug": "mohammed-nasser-bou-farha-al-shamsi",
    "name": "Mohammed Nasser Bou Farha Al Shamsi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Mohammed Nasser Bou Farha Al Shamsi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_9f9fd26f-8db2-40cd-a45f-4b020f6a7040",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3920",
    "company": "Mohammed Nasser Al Shamsi Advocates and Legal Consultants"
  },
  {
    "id": "c1c2d573-764f-4134-9b48-bed7898c8747",
    "slug": "muhammad-najib-abdullah-haj-hassan-fadlani",
    "name": "Muhammad Najib Abdullah Haj Hassan Fadlani",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Najib Abdullah Haj Hassan Fadlani",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c1c2d573-764f-4134-9b48-bed7898c8747",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4465",
    "company": "Fahd Abdullah Law Firm, lawyers and legal consultants"
  },
  {
    "id": "7d6690d8-502d-4209-a48d-6d13db550c31",
    "slug": "mahmoud-ibrahim-abdullah-al-hawai",
    "name": "Mahmoud Ibrahim Abdullah Al-Hawai",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Mahmoud Ibrahim Abdullah Al-Hawai",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_7d6690d8-502d-4209-a48d-6d13db550c31",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "119",
    "company": "The office of Lawyer Mahmoud Al-Hawai Lawyers and Legal Consultants LLC"
  },
  {
    "id": "726cd31c-ec5d-46af-98bc-d3d0e2a9d475",
    "slug": "mahmoud-muhammad-jaber-muhammad-al-ali",
    "name": "Mahmoud Muhammad Jaber Muhammad Al Ali",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Mahmoud Muhammad Jaber Muhammad Al Ali",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_726cd31c-ec5d-46af-98bc-d3d0e2a9d475",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3767",
    "company": "Mahmoud bin Jaber Law Firm and Legal Consultations"
  },
  {
    "id": "95a9a47e-f3d0-4dc2-9e43-68f8cb4f4e92",
    "slug": "dar-al-adala-law-firm-and-legal-consultations",
    "name": "Dar Al Adala Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIERBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Dar Al Adala Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_95a9a47e-f3d0-4dc2-9e43-68f8cb4f4e92",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "309",
    "owner": "Mahmoud Muhammad Abdullah Jamal Ahli"
  },
  {
    "id": "55ef16fa-958c-4cd8-968a-ed8bb4120773",
    "slug": "mahmoud-youssef-abdel-rahim-ahmed-al-hammadi",
    "name": "Mahmoud Youssef Abdel Rahim Ahmed Al Hammadi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Mahmoud Youssef Abdel Rahim Ahmed Al Hammadi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_55ef16fa-958c-4cd8-968a-ed8bb4120773",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4467",
    "company": "Khadija Suhail Advocates and Legal Consultants"
  },
  {
    "id": "c473a8e6-0b83-46ab-83ce-ed120ae935de",
    "slug": "marwa-hamad-saeed-muslim-al-riyami",
    "name": "Marwa Hamad Saeed Muslim Al Riyami",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Marwa Hamad Saeed Muslim Al Riyami",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c473a8e6-0b83-46ab-83ce-ed120ae935de",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2843",
    "company": "Marwa Al Riyami Advocates and Legal Consultants"
  },
  {
    "id": "afed3a4d-6d6b-4ed0-832b-282c38b889dc",
    "slug": "mohammed-al-dahbashi-law-firm-llc",
    "name": "Mohammed Al-Dahbashi Law Firm LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Mohammed Al-Dahbashi Law Firm LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_afed3a4d-6d6b-4ed0-832b-282c38b889dc",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4498",
    "owner": "Marwa Saif Jumah Hamad Al-Mashghouni"
  },
  {
    "id": "78a0d245-0b33-4d8b-9183-ef2c0dbdad5e",
    "slug": "marwa-saleh-khalifa-rashid-al-muhairi",
    "name": "Marwa Saleh Khalifa Rashid Al Muhairi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Marwa Saleh Khalifa Rashid Al Muhairi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_78a0d245-0b33-4d8b-9183-ef2c0dbdad5e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4517",
    "company": "Ali Al Mansouri Advocates and Legal Consultants"
  },
  {
    "id": "71a9eab4-d928-4a57-8559-f13c5617fb3a",
    "slug": "marwa-al-suwaidi-advocates-and-legal-consultations-llc",
    "name": "Marwa Al Suwaidi Advocates and Legal Consultations LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Marwa Al Suwaidi Advocates and Legal Consultations LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_71a9eab4-d928-4a57-8559-f13c5617fb3a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2463",
    "owner": "Marwa on Friday according to Al-Suwaidi"
  },
  {
    "id": "27a6df7d-f8ec-4eeb-aaa7-1ae97bb2e3c6",
    "slug": "al-gharib-partners-lawyers-legal-consultants-llc",
    "name": "Al Gharib & Partners Lawyers & Legal Consultants LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFHCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Al Gharib & Partners Lawyers & Legal Consultants LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_27a6df7d-f8ec-4eeb-aaa7-1ae97bb2e3c6",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4570",
    "owner": "Marwa Mukhtar Muhammad Baqir Ghareeb"
  },
  {
    "id": "1fc64ec8-9783-46d7-a972-c1f0eaf08571",
    "slug": "marwa-suleiman-muhammad-karazon",
    "name": "Marwa Suleiman Muhammad Karazon",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Marwa Suleiman Muhammad Karazon",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_1fc64ec8-9783-46d7-a972-c1f0eaf08571",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4355",
    "company": "Marwa Suleiman Advocates and Legal Consultations"
  },
  {
    "id": "88a41524-53ed-464d-b2f5-1c8b7d5fa95d",
    "slug": "maryam-ibrahim-ghuloum-ali-abdullah-robar",
    "name": "Maryam Ibrahim Ghuloum Ali Abdullah Robar",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Maryam Ibrahim Ghuloum Ali Abdullah Robar",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_88a41524-53ed-464d-b2f5-1c8b7d5fa95d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4303",
    "company": "Maryam Robar Advocates and Legal Consultants"
  },
  {
    "id": "30098218-5954-4f80-9a64-89c203feab23",
    "slug": "maryam-ibrahim-al-ameri-advocates-and-legal-consultants",
    "name": "Maryam Ibrahim Al Ameri Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1JCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Maryam Ibrahim Al Ameri Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_30098218-5954-4f80-9a64-89c203feab23",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3540",
    "owner": "Maryam Ibrahim Muhammad Ali Al-Amiri"
  },
  {
    "id": "b31e6f43-df10-4615-ba6b-6265c68a7699",
    "slug": "khaled-khalfan-al-marri-law-firm-and-legal-consultations",
    "name": "Khaled Khalfan Al Marri Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEtLCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Khaled Khalfan Al Marri Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_b31e6f43-df10-4615-ba6b-6265c68a7699",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4457",
    "owner": "Maryam Ahmed Abdul Rahman Al Jarman"
  },
  {
    "id": "003cdffd-2649-427a-aec2-92c719ce9925",
    "slug": "maryam-ismail-muhammad-al-hosani",
    "name": "Maryam Ismail Muhammad Al Hosani",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Maryam Ismail Muhammad Al Hosani",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_003cdffd-2649-427a-aec2-92c719ce9925",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4214",
    "company": "Maryam Ismail Al Hosani Advocates and Legal Consultants"
  },
  {
    "id": "c1b7e91f-90c0-4984-be1f-a22dc164e9dc",
    "slug": "maryam-juma-ibrahim-muhammad-al-hammadi",
    "name": "Maryam Juma Ibrahim Muhammad Al Hammadi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Maryam Juma Ibrahim Muhammad Al Hammadi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c1b7e91f-90c0-4984-be1f-a22dc164e9dc",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4230",
    "company": "Nawal Al Hosani Law Firm and Legal Consultations"
  },
  {
    "id": "1d4489fa-6127-4c80-b399-3b4dec9fc2f6",
    "slug": "maryam-hassan-abdullah-ali-al-hammadi",
    "name": "Maryam Hassan Abdullah Ali Al Hammadi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Maryam Hassan Abdullah Ali Al Hammadi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_1d4489fa-6127-4c80-b399-3b4dec9fc2f6",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3842",
    "company": "Maryam Hassan Al Hammadi Advocates and Legal Consultants - LLC - S.P.C"
  },
  {
    "id": "fb794be3-940e-4257-a08a-4995dfe57bdb",
    "slug": "maryam-hamid-abdullah-al-shaiba-al-nuaimi",
    "name": "Maryam Hamid Abdullah Al Shaiba Al Nuaimi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Maryam Hamid Abdullah Al Shaiba Al Nuaimi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_fb794be3-940e-4257-a08a-4995dfe57bdb",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4136",
    "company": "Gulf Lawyers and Legal Consultants"
  },
  {
    "id": "09c3232f-dd8f-45a6-afa9-5c617fda9a09",
    "slug": "maryam-khamis-musabah-khamis-al-yamahi",
    "name": "Maryam Khamis Musabah Khamis Al-Yamahi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Maryam Khamis Musabah Khamis Al-Yamahi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_09c3232f-dd8f-45a6-afa9-5c617fda9a09",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3940",
    "company": "Ali Saeed Al-Hafiti Advocates and Legal Consultants"
  },
  {
    "id": "3f2e16d9-6dd1-40a6-beb6-95e4ae5b3173",
    "slug": "maryam-saeed-hamid-abdullah-al-suwaidi",
    "name": "Maryam Saeed Hamid Abdullah Al Suwaidi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Maryam Saeed Hamid Abdullah Al Suwaidi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_3f2e16d9-6dd1-40a6-beb6-95e4ae5b3173",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4420",
    "company": "Maryam Saeed Al Suwaidi Advocates and Legal Consultants - LLC - S.P.C"
  },
  {
    "id": "753ac582-acae-4787-ae41-a4f5fc400dec",
    "slug": "maryam-suleiman-ibrahim-al-saroumi",
    "name": "Maryam Suleiman Ibrahim Al-Saroumi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Maryam Suleiman Ibrahim Al-Saroumi",
    "consultationFee": 400,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_753ac582-acae-4787-ae41-a4f5fc400dec",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4565",
    "company": "Al-Raed Advocates and Legal Consultants/Abu Dhabi"
  },
  {
    "id": "32848067-1bdf-4921-88dc-f2293bedfb1a",
    "slug": "maryam-saif-on-a-ring",
    "name": "Maryam Saif on a ring",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Maryam Saif on a ring",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_32848067-1bdf-4921-88dc-f2293bedfb1a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4223",
    "company": "Maryam Saif Khatam Advocates and Legal Consultants"
  },
  {
    "id": "22cd7cb9-782a-4c98-9bc7-1b66db3ed2a5",
    "slug": "maryam-saleh-saeed-shams-al-kindi",
    "name": "Maryam Saleh Saeed Shams Al Kindi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Maryam Saleh Saeed Shams Al Kindi",
    "consultationFee": 400,
    "emirate": "Fujairah",
    "verified": true,
    "offices": [
      {
        "id": "office_22cd7cb9-782a-4c98-9bc7-1b66db3ed2a5",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Fujairah",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4448",
    "company": "Saleh Shams Advocates and Legal Consultants/Fujairah"
  },
  {
    "id": "9d905730-c88d-4838-b7e1-27c7c7a46d41",
    "slug": "maryam-abdullah-murad-al-balushi",
    "name": "Maryam Abdullah Murad Al Balushi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Maryam Abdullah Murad Al Balushi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_9d905730-c88d-4838-b7e1-27c7c7a46d41",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2842",
    "company": "Maryam Abdullah Advocates and Legal Consultants"
  },
  {
    "id": "7e41688d-d63d-41a2-b4f0-2f2d42c0cff9",
    "slug": "maryam-abdel-wahab-talal-al-huraibi",
    "name": "Maryam Abdel Wahab Talal Al-Huraibi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Maryam Abdel Wahab Talal Al-Huraibi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_7e41688d-d63d-41a2-b4f0-2f2d42c0cff9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4439",
    "company": "Rashid Al Kaitoub Advocates and Legal Consultants"
  },
  {
    "id": "8bff833c-a09d-4ba1-b25a-a2fed962d03f",
    "slug": "maryam-obaid-abdullah-mohammed-al-balushi",
    "name": "Maryam Obaid Abdullah Mohammed Al Balushi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Maryam Obaid Abdullah Mohammed Al Balushi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_8bff833c-a09d-4ba1-b25a-a2fed962d03f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3932",
    "company": "Maryam Obaid Al Balushi Law Office and Legal Consultations"
  },
  {
    "id": "7e6819ab-15aa-42f0-bba5-cbbee1954a93",
    "slug": "maryam-ali-khalifa-humaid-al-shamsi",
    "name": "Maryam Ali Khalifa Humaid Al Shamsi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Maryam Ali Khalifa Humaid Al Shamsi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_7e6819ab-15aa-42f0-bba5-cbbee1954a93",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2208",
    "company": "Maryam Ali Al Shamsi Advocates and Legal Consultants"
  },
  {
    "id": "a90de4f8-49e3-4ee1-9fca-312005053f70",
    "slug": "maryam-ali-abdullah-law-firm-and-legal-consultations",
    "name": "Maryam Ali Abdullah Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Maryam Ali Abdullah Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_a90de4f8-49e3-4ee1-9fca-312005053f70",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3544, 4646",
    "owner": "Maryam Ali Abdullah Al Balushi"
  },
  {
    "id": "a91cbe28-67ec-4023-b5d0-47b3b918835e",
    "slug": "kifah-al-zaabi-advocates-and-legal-consultants-sharjah",
    "name": "Kifah Al Zaabi Advocates and Legal Consultants - Sharjah",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEtBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Kifah Al Zaabi Advocates and Legal Consultants - Sharjah",
    "consultationFee": 500,
    "emirate": "Sharjah",
    "verified": true,
    "offices": [
      {
        "id": "office_a91cbe28-67ec-4023-b5d0-47b3b918835e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Sharjah",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4130",
    "owner": "Maryam Ali Mubarak Hamed Al Darmaki"
  },
  {
    "id": "b9229161-f0d2-48dd-a599-e89119d02dbf",
    "slug": "maryam-issa-ahmed-bin-salman-al-nuaimi",
    "name": "Maryam Issa Ahmed bin Salman Al Nuaimi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Maryam Issa Ahmed bin Salman Al Nuaimi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_b9229161-f0d2-48dd-a599-e89119d02dbf",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3893",
    "company": "Issa Ahmed bin Salman Advocates and Legal Consultants"
  },
  {
    "id": "892661c5-bfd3-4b89-8b94-aff6625dc9cf",
    "slug": "maryam-issa-ali-issa-al-shamsi",
    "name": "Maryam Issa Ali Issa Al Shamsi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Maryam Issa Ali Issa Al Shamsi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_892661c5-bfd3-4b89-8b94-aff6625dc9cf",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4015",
    "company": "Maryam Al Shamsi Advocates and Legal Consultations"
  },
  {
    "id": "4e50e980-b9aa-4b6a-b1e9-f6dab8aa9b65",
    "slug": "maryam-issa-muhammad-abdel-aziz-al-yasi",
    "name": "Maryam Issa Muhammad Abdel Aziz Al Yasi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Maryam Issa Muhammad Abdel Aziz Al Yasi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_4e50e980-b9aa-4b6a-b1e9-f6dab8aa9b65",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3378",
    "company": "Maryam Al Yasi Advocates and Legal Consultants"
  },
  {
    "id": "376b636d-fdbe-4843-ad84-8f0954e1696d",
    "slug": "maryam-ghaleb-saeed-bin-hammad-al-nuaimi",
    "name": "Maryam Ghaleb Saeed bin Hammad Al Nuaimi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Maryam Ghaleb Saeed bin Hammad Al Nuaimi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_376b636d-fdbe-4843-ad84-8f0954e1696d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4274",
    "company": "Ahmed Mohamed Bashir Law Firm and Legal Consultations Office"
  },
  {
    "id": "588466db-1a81-4316-9db2-2487ab0af7f6",
    "slug": "maryam-muhammad-ibrahim-al-taniji",
    "name": "Maryam Muhammad Ibrahim Al-Taniji",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Maryam Muhammad Ibrahim Al-Taniji",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_588466db-1a81-4316-9db2-2487ab0af7f6",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "1050",
    "company": "Al-Aidaroos Advocates and Legal Consultations/Dubai"
  },
  {
    "id": "e2c0370e-e8cc-41fe-9cf4-653247f68a3d",
    "slug": "future-vision-for-law-and-legal-consultancy",
    "name": "Future vision for law and legal consultancy",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEZWCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Future vision for law and legal consultancy",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e2c0370e-e8cc-41fe-9cf4-653247f68a3d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3534",
    "owner": "Maryam Muhammad Ahmed Al-Hadrami"
  },
  {
    "id": "b266eaba-626a-4627-a040-e25a1fcb4b74",
    "slug": "maryam-muhammad-ali-al-hadoori-al-hamoudi",
    "name": "Maryam Muhammad Ali Al-Hadoori Al-Hamoudi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Maryam Muhammad Ali Al-Hadoori Al-Hamoudi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_b266eaba-626a-4627-a040-e25a1fcb4b74",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2566",
    "company": "Dalmouk Mohammed Dalmouk Lawyers and Legal Consultants/Dubai"
  },
  {
    "id": "71516f03-800d-4882-bf1a-04e230854bda",
    "slug": "maryam-muhammad-mubarak-mughair-al-khaili",
    "name": "Maryam Muhammad Mubarak Mughair Al Khaili",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Maryam Muhammad Mubarak Mughair Al Khaili",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_71516f03-800d-4882-bf1a-04e230854bda",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4534",
    "company": "Ali Al Mansouri Advocates and Legal Consultants"
  },
  {
    "id": "c52fc89d-0aa7-4ca4-aae9-95af4b4e8409",
    "slug": "abdul-qader-ismail-and-partners-lawyers-and-legal-consultants-one-person-company-llc",
    "name": "Abdul Qader Ismail and Partners, Lawyers and Legal Consultants, One Person Company LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFRCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Abdul Qader Ismail and Partners, Lawyers and Legal Consultants, One Person Company LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c52fc89d-0aa7-4ca4-aae9-95af4b4e8409",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4231",
    "owner": "Muzna Muhammad Thamer Al Mansouri"
  },
  {
    "id": "a279643e-b78d-4a40-be26-51ccaf86045f",
    "slug": "musab-ali-al-naqbi-advocates-and-legal-consultants",
    "name": "Musab Ali Al Naqbi Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Musab Ali Al Naqbi Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_a279643e-b78d-4a40-be26-51ccaf86045f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2246",
    "owner": "Musaab Ali Muhammad Abdullah Al-Naqbi"
  },
  {
    "id": "0b6ad57a-657e-4316-b74b-501e282b0673",
    "slug": "the-interest-of-suleiman-saleh-amer-al-saari",
    "name": "The interest of Suleiman Saleh Amer Al-Sa’ari",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: The interest of Suleiman Saleh Amer Al-Sa’ari",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_0b6ad57a-657e-4316-b74b-501e282b0673",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4027",
    "company": "Mohammed Abdullah Al Ameri Law Firm and Legal Consultations"
  },
  {
    "id": "9db1939f-5c1c-4261-bb16-aeca2c5bcea5",
    "slug": "matar-humaid-hassan-juma-al-shamsi",
    "name": "Matar Humaid Hassan Juma Al Shamsi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Matar Humaid Hassan Juma Al Shamsi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_9db1939f-5c1c-4261-bb16-aeca2c5bcea5",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3649",
    "company": "Matar Humaid Al Shamsi Advocates and Legal Consultants"
  },
  {
    "id": "bdb4e860-92ec-422a-91a9-57ffbca9d264",
    "slug": "moayed-moayed-mohamed-dhaen-al-mansouri",
    "name": "Moayed Moayed Mohamed Dhaen Al Mansouri",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Moayed Moayed Mohamed Dhaen Al Mansouri",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_bdb4e860-92ec-422a-91a9-57ffbca9d264",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4067",
    "company": "Moayed Al Mansouri Law Firm and Legal Consultations"
  },
  {
    "id": "2c56e92c-44ef-463a-aea7-7e3c7e4d416f",
    "slug": "manar-saif-ali-al-muslimani-al-naqbi",
    "name": "Manar Saif Ali Al-Muslimani Al-Naqbi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Manar Saif Ali Al-Muslimani Al-Naqbi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_2c56e92c-44ef-463a-aea7-7e3c7e4d416f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2811",
    "company": "Al Hantoubi Law Firm and Legal Consultations"
  },
  {
    "id": "5de80751-7b4f-4fb7-9318-011ae71296a9",
    "slug": "dar-al-hekma-advocates-and-legal-consultationsabu-dhabi",
    "name": "Dar Al-Hekma Advocates and Legal Consultations/Abu Dhabi",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIERBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Dar Al-Hekma Advocates and Legal Consultations/Abu Dhabi",
    "consultationFee": 500,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_5de80751-7b4f-4fb7-9318-011ae71296a9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2094",
    "owner": "Manal Abdel Rahman Ibrahim"
  },
  {
    "id": "e45ba914-a8c1-45eb-ab18-cb42fee53b75",
    "slug": "mansour-abdul-qader-ali-law-firm-and-legal-consultations",
    "name": "Mansour Abdul Qader Ali Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Mansour Abdul Qader Ali Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e45ba914-a8c1-45eb-ab18-cb42fee53b75",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4023",
    "owner": "Mansour Abdel Qader Ali Mohamed Mahmoud"
  },
  {
    "id": "ba57b86a-8afc-4f10-96aa-6f5e7e21da9c",
    "slug": "mansour-abdullah-ali-al-hammadi",
    "name": "Mansour Abdullah Ali Al Hammadi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Mansour Abdullah Ali Al Hammadi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_ba57b86a-8afc-4f10-96aa-6f5e7e21da9c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "1300",
    "company": "Al Saif Law Firm and Legal Consultations"
  },
  {
    "id": "53190457-ee0f-4af0-86a7-dcbc19be0bf8",
    "slug": "mansour-abdullah-muhammad-abdullah-al-bastaki",
    "name": "Mansour Abdullah Muhammad Abdullah Al Bastaki",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Mansour Abdullah Muhammad Abdullah Al Bastaki",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_53190457-ee0f-4af0-86a7-dcbc19be0bf8",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4433",
    "company": "Al Bastaki and Al Jasmi Advocates and Legal Consultants"
  },
  {
    "id": "18f60433-0e48-43f0-9c0c-0c4a5ee896e4",
    "slug": "mansour-issa-lootah",
    "name": "Mansour Issa Lootah",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Mansour Issa Lootah",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_18f60433-0e48-43f0-9c0c-0c4a5ee896e4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "551",
    "company": "Mansour Lootah Advocates and Legal Consultants"
  },
  {
    "id": "c4c4b8ae-bec5-44c0-aa4c-90e49611c677",
    "slug": "mansour-mohammed-abdullah-law-office-and-legal-consultations",
    "name": "Mansour Mohammed Abdullah Law Office and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1NCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Mansour Mohammed Abdullah Law Office and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c4c4b8ae-bec5-44c0-aa4c-90e49611c677",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4684",
    "owner": "Mansour Muhammad Abdullah Ali Hassan"
  },
  {
    "id": "c8085b7b-059e-4713-b61e-6b4eb75c0ce0",
    "slug": "jaafar-alwan-al-jaziri-and-partners-are-lawyers-and-legal-consultants",
    "name": "Jaafar Alwan, Al-Jaziri and Partners are lawyers and legal consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEpBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Jaafar Alwan, Al-Jaziri and Partners are lawyers and legal consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c8085b7b-059e-4713-b61e-6b4eb75c0ce0",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2286",
    "owner": "Mansour Muhammad Ali Muhammad Al Kamali"
  },
  {
    "id": "97237b37-5c77-44a9-8508-ec2851eafd55",
    "slug": "mona-ahmed-bin-ghalita",
    "name": "Mona Ahmed bin Ghalita",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Mona Ahmed bin Ghalita",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_97237b37-5c77-44a9-8508-ec2851eafd55",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4221",
    "company": "Hamad Al Zaabi and Mona Bin Ghalita Lawyers and Legal Consultations, a limited liability office"
  },
  {
    "id": "43ef37a0-ce1d-405c-8e6d-61fb71b72d89",
    "slug": "mona-ahmed-abdel-aziz-al-sabagh",
    "name": "Mona Ahmed Abdel Aziz Al-Sabagh",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Mona Ahmed Abdel Aziz Al-Sabagh",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_43ef37a0-ce1d-405c-8e6d-61fb71b72d89",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "494",
    "company": "Mona Al-Sabbagh Advocates and Legal Consultants"
  },
  {
    "id": "c53d4252-e414-46cd-a543-0b0cd87186de",
    "slug": "muhammad-salman-law-firm-and-legal-consultations",
    "name": "Muhammad Salman Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1TCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Muhammad Salman Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c53d4252-e414-46cd-a543-0b0cd87186de",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "661",
    "owner": "Mona Jumaa Abbas Abdullah"
  },
  {
    "id": "53b04983-0ddc-40d4-8076-1c37130a090f",
    "slug": "mona-khalifa-rashid-al-shamsi",
    "name": "Mona Khalifa Rashid Al Shamsi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Mona Khalifa Rashid Al Shamsi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_53b04983-0ddc-40d4-8076-1c37130a090f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3923",
    "company": "Mona Al Shamsi Advocates and Legal Consultations LLC"
  },
  {
    "id": "eef5f532-cd38-4d7c-84be-8e3ba0812ff8",
    "slug": "mona-rashid-al-shehhi-advocates-and-legal-consultants",
    "name": "Mona Rashid Al Shehhi Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1SCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Mona Rashid Al Shehhi Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_eef5f532-cd38-4d7c-84be-8e3ba0812ff8",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4449",
    "owner": "Mona Rashid Saeed Al-Qayshi Al-Shehhi"
  },
  {
    "id": "01d7ff58-de6d-4f29-8d17-91debeb3698d",
    "slug": "mona-salem-hassan-ali-al-muallem",
    "name": "Mona Salem Hassan Ali Al-Muallem",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Mona Salem Hassan Ali Al-Muallem",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_01d7ff58-de6d-4f29-8d17-91debeb3698d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2176",
    "company": "Mona Al-Muallem Advocates and Legal Consultants"
  },
  {
    "id": "56de2fa6-0ae4-4732-af93-ca3c4cb29eba",
    "slug": "mona-saeed-law-firm-and-legal-consultations-one-person-company-llc",
    "name": "Mona Saeed Law Firm and Legal Consultations - One Person Company LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1TCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Mona Saeed Law Firm and Legal Consultations - One Person Company LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_56de2fa6-0ae4-4732-af93-ca3c4cb29eba",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3941",
    "owner": "Mona Saeed Muhammad Musan"
  },
  {
    "id": "63e82ecc-993f-4f5d-a68e-11bd59ce509c",
    "slug": "mona-saif-khalifa-bu-adeel-al-mazroui",
    "name": "Mona Saif Khalifa Bu Adeel Al Mazroui",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Mona Saif Khalifa Bu Adeel Al Mazroui",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_63e82ecc-993f-4f5d-a68e-11bd59ce509c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4013",
    "company": "Mona Al Mazroui Advocates and Legal Consultants"
  },
  {
    "id": "3fbf704b-e4e7-48f2-86f5-8d4b696fdd25",
    "slug": "mona-abdel-aziz-muhammad-makahla",
    "name": "Mona Abdel Aziz Muhammad Makahla",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Mona Abdel Aziz Muhammad Makahla",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_3fbf704b-e4e7-48f2-86f5-8d4b696fdd25",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3383",
    "company": "Bin Ismail Law Firm and Legal Consultations"
  },
  {
    "id": "9c98d999-8006-4906-bc72-73b8a1e3c9b9",
    "slug": "mona-mubarak-muhammad-abu-khater-al-qubaisi",
    "name": "Mona Mubarak Muhammad Abu Khater Al Qubaisi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Mona Mubarak Muhammad Abu Khater Al Qubaisi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_9c98d999-8006-4906-bc72-73b8a1e3c9b9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4442",
    "company": "Mona Mubarak Al Qubaisi Advocates and Legal Consultants"
  },
  {
    "id": "47fd6046-4283-4fd6-9f06-0a895f805331",
    "slug": "mona-al-ansari-advocates-and-legal-consultantsdubai",
    "name": "Mona Al Ansari Advocates and Legal Consultants/Dubai",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Mona Al Ansari Advocates and Legal Consultants/Dubai",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_47fd6046-4283-4fd6-9f06-0a895f805331",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "314",
    "owner": "Mona Muhammad Al-Ansari"
  },
  {
    "id": "b48ee82b-62dd-4529-b7f4-bdea65841024",
    "slug": "mona-muhammad-salem-rashdan",
    "name": "Mona Muhammad Salem Rashdan",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Mona Muhammad Salem Rashdan",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_b48ee82b-62dd-4529-b7f4-bdea65841024",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2990",
    "company": "Mona Al-Rashdan Law Firm and Legal Consultations"
  },
  {
    "id": "236104b2-f08e-424e-abdf-4b57bc6cf5eb",
    "slug": "mona-al-mulla-advocates-and-legal-consultants",
    "name": "Mona Al Mulla Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Mona Al Mulla Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_236104b2-f08e-424e-abdf-4b57bc6cf5eb",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3086",
    "owner": "Mona Muhammad Faraj Al-Mulla"
  },
  {
    "id": "2905a980-0da5-42cb-b369-4f984ab4b372",
    "slug": "mona-muhammad-musa-al-mandoos-al-balushi",
    "name": "Mona Muhammad Musa Al Mandoos Al Balushi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Mona Muhammad Musa Al Mandoos Al Balushi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_2905a980-0da5-42cb-b369-4f984ab4b372",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3161",
    "company": "Bin Haider Law Firm and Legal Consultations"
  },
  {
    "id": "690beba2-e99d-4415-bf97-239d5018d502",
    "slug": "office-of-munira-ahmed-al-ameri-and-mansour-fuhaid-al-harithi-law-firm-and-legal-consultations-llc",
    "name": "Office of Munira Ahmed Al Ameri and Mansour Fuhaid Al Harithi Law Firm and Legal Consultations LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE9NCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Office of Munira Ahmed Al Ameri and Mansour Fuhaid Al Harithi Law Firm and Legal Consultations LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_690beba2-e99d-4415-bf97-239d5018d502",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2277",
    "owner": "Munira Ahmed Aida Mubarak Al-Amiri"
  },
  {
    "id": "5da566e4-22fc-42a0-8059-76fa0247fd85",
    "slug": "munira-abdullah-sabt-law-office-and-legal-consultations",
    "name": "Munira Abdullah Sabt Law Office and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Munira Abdullah Sabt Law Office and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_5da566e4-22fc-42a0-8059-76fa0247fd85",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4162",
    "owner": "Muneera Abdullah Sabt Al-Hammadi"
  },
  {
    "id": "879bb389-ace6-4f44-8d16-77dc7f225ec7",
    "slug": "munira-muhammad-reda-ali-lari",
    "name": "Munira Muhammad Reda Ali Lari",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Munira Muhammad Reda Ali Lari",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_879bb389-ace6-4f44-8d16-77dc7f225ec7",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3934",
    "company": "Munira Lari Law Firm and Legal Consultations - LLC - S.P.C"
  },
  {
    "id": "3489dbe7-3ecd-4c74-bb72-5da44338da1f",
    "slug": "maha-abdullah-law-firm-and-legal-consultations",
    "name": "Maha Abdullah Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Maha Abdullah Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_3489dbe7-3ecd-4c74-bb72-5da44338da1f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2569",
    "owner": "Maha Abdullah Mahmoud"
  },
  {
    "id": "676e10e7-9c7a-48a3-8486-ab77e119a736",
    "slug": "maha-ali-ismail-ali-al-fahim",
    "name": "Maha Ali Ismail Ali Al Fahim",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Maha Ali Ismail Ali Al Fahim",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_676e10e7-9c7a-48a3-8486-ab77e119a736",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2338",
    "company": "Maha Al Fahim Advocates and Legal Consultants"
  },
  {
    "id": "ffe93ab0-55f0-4f92-b781-0a1e71ed5df8",
    "slug": "dr-amira-al-bastaki-advocates-and-legal-consultants",
    "name": "Dr. Amira Al Bastaki Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Dr. Amira Al Bastaki Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_ffe93ab0-55f0-4f92-b781-0a1e71ed5df8",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4630",
    "owner": "Maha Muhammad Ghanem Sohrab Ahli"
  },
  {
    "id": "347ae303-86ab-41ec-a265-d90f6ebb22b3",
    "slug": "maha-munir-mohammed-rashid-al-otaibi",
    "name": "Maha Munir Mohammed Rashid Al Otaibi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Maha Munir Mohammed Rashid Al Otaibi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_347ae303-86ab-41ec-a265-d90f6ebb22b3",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4520",
    "company": "Awatef Mohamed Shawqi Law Firm, Legal Consultations"
  },
  {
    "id": "44533152-8f44-4594-bfc6-5d3806c198d3",
    "slug": "maha-yousef-yaqoub-ali-al-hosani",
    "name": "Maha Yousef Yaqoub Ali Al Hosani",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Maha Yousef Yaqoub Ali Al Hosani",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_44533152-8f44-4594-bfc6-5d3806c198d3",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4115",
    "company": "Khaled Ateeq Al Marri Advocates and Legal Consultants"
  },
  {
    "id": "72babbb6-9e5b-4c83-bdef-d8ad5b9f0bbe",
    "slug": "al-safar-partners-advocates-and-legal-consultantsdubai",
    "name": "Al-Safar & Partners Advocates and Legal Consultants/Dubai",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFQCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Al-Safar & Partners Advocates and Legal Consultants/Dubai",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_72babbb6-9e5b-4c83-bdef-d8ad5b9f0bbe",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "261",
    "owner": "Mahdi Safar Ghuloum Abdullah Al-Majidi"
  },
  {
    "id": "7c7fe8e6-223a-43cf-957d-bc4ace56b5cd",
    "slug": "abdullah-mohammeds-foal-is-al-obaida-al-suwaidi",
    "name": "Abdullah Mohammed's foal is Al-Obaida Al-Suwaidi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abdullah Mohammed's foal is Al-Obaida Al-Suwaidi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_7c7fe8e6-223a-43cf-957d-bc4ace56b5cd",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4242",
    "company": "Hassan Al Riyami Advocates and Legal Consultants"
  },
  {
    "id": "49964c32-e671-42a0-8fe0-1591a27b5d09",
    "slug": "moza-al-khazar-law-firm-and-legal-consultations",
    "name": "Moza Al Khazar Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Moza Al Khazar Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_49964c32-e671-42a0-8fe0-1591a27b5d09",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "1758",
    "owner": "Moza Obaid Rabei Al Khadhar"
  },
  {
    "id": "3969556e-b16b-49f2-94e2-eb6821d43b44",
    "slug": "moza-thani-rashid-thani-al-rumaithi",
    "name": "Moza Thani Rashid Thani Al Rumaithi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Moza Thani Rashid Thani Al Rumaithi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_3969556e-b16b-49f2-94e2-eb6821d43b44",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3949",
    "company": "Moza Thani Al Rumaithi Law Firm and Legal Consultations."
  },
  {
    "id": "953620b3-01e7-4301-a3a8-36faf972d411",
    "slug": "moza-hamad-obaid-al-nuaimi",
    "name": "Moza Hamad Obaid Al Nuaimi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Moza Hamad Obaid Al Nuaimi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_953620b3-01e7-4301-a3a8-36faf972d411",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4264",
    "company": "Abdulaziz Al-Khamiri Law Firm and Legal Consultations"
  },
  {
    "id": "dc06d29c-00c3-4dd1-8370-1cb7b4dee2c7",
    "slug": "moza-hamid-sultan-abdullah-al-suwaidi",
    "name": "Moza Hamid Sultan Abdullah Al Suwaidi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Moza Hamid Sultan Abdullah Al Suwaidi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_dc06d29c-00c3-4dd1-8370-1cb7b4dee2c7",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4287",
    "company": "Jassim Al-Haddad Law Firm and Legal Consultations"
  },
  {
    "id": "b4a0f099-0d63-42e0-920a-f1d54550feee",
    "slug": "moza-abdul-rahman-youssef-bin-hareb-al-muhairi",
    "name": "Moza Abdul Rahman Youssef bin Hareb Al Muhairi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Moza Abdul Rahman Youssef bin Hareb Al Muhairi",
    "consultationFee": 400,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_b4a0f099-0d63-42e0-920a-f1d54550feee",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4595",
    "company": "House of Wisdom Advocates and Legal Consultations/Abu Dhabi"
  },
  {
    "id": "b2b96a59-25eb-49c5-80bf-b88ad4d90789",
    "slug": "mohammed-al-hammadi-law-firm-and-legal-consultations",
    "name": "Mohammed Al Hammadi Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Mohammed Al Hammadi Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_b2b96a59-25eb-49c5-80bf-b88ad4d90789",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3237",
    "owner": "Moza Ali Murad Ibrahim"
  },
  {
    "id": "56822e73-d5f0-427b-a289-ab5bb0119e0b",
    "slug": "moza-muhammad-saeed-khamas-al-dhahouri",
    "name": "Moza Muhammad Saeed Khamas Al-Dhahouri",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Moza Muhammad Saeed Khamas Al-Dhahouri",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_56822e73-d5f0-427b-a289-ab5bb0119e0b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4183",
    "company": "Hanan Salem Law Firm and Legal Consultations"
  },
  {
    "id": "5e34c8bd-2d91-4f74-98da-1badeea89110",
    "slug": "musa-al-amery-law-firm-and-legal-consultations",
    "name": "Musa Al Amery Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Musa Al Amery Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_5e34c8bd-2d91-4f74-98da-1badeea89110",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "302",
    "owner": "Musa Issa Musa Al-Amiri"
  },
  {
    "id": "0c560ea6-bf6b-4be2-a317-2f4457b2c707",
    "slug": "mai-abdul-rahman-naseeb-bin-naseeb-al-falasi",
    "name": "Mai Abdul Rahman Naseeb bin Naseeb Al Falasi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Mai Abdul Rahman Naseeb bin Naseeb Al Falasi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_0c560ea6-bf6b-4be2-a317-2f4457b2c707",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2539",
    "company": "Mai Abdul Rahman Naseeb Advocates and Legal Consultants"
  },
  {
    "id": "7ac7ed72-6ba8-4029-9326-0655afed2a5a",
    "slug": "maitha-khalfan-ghanem-al-kaabi",
    "name": "Maitha Khalfan Ghanem Al Kaabi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Maitha Khalfan Ghanem Al Kaabi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_7ac7ed72-6ba8-4029-9326-0655afed2a5a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4124",
    "company": "Khalfan Al Kaabi Advocates and Legal Consultants"
  },
  {
    "id": "afb55afd-c299-4d56-abf8-cdec70fcb929",
    "slug": "maitha-mohammed-rashid-mashroom-al-kaabi",
    "name": "Maitha Mohammed Rashid Mashroom Al Kaabi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Maitha Mohammed Rashid Mashroom Al Kaabi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_afb55afd-c299-4d56-abf8-cdec70fcb929",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4354",
    "company": "Salem Bin Bahyan Advocates and Legal Consultants/Al Ain"
  },
  {
    "id": "f74cf514-98fb-4348-bfcc-5b6276a31d2c",
    "slug": "maitha-saeed-hamdan-bin-dalmouk-al-falasi",
    "name": "Maitha Saeed Hamdan bin Dalmouk Al Falasi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Maitha Saeed Hamdan bin Dalmouk Al Falasi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_f74cf514-98fb-4348-bfcc-5b6276a31d2c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4195",
    "company": "Maitha Dalmouk Advocates and Legal Consultants"
  },
  {
    "id": "91f68923-ed1d-4586-8681-3b6a941e848c",
    "slug": "maitha-talib-khamis-al-balushi",
    "name": "Maitha Talib Khamis Al Balushi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Maitha Talib Khamis Al Balushi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_91f68923-ed1d-4586-8681-3b6a941e848c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4053",
    "company": "International Center for Advocacy and Legal Consultation/Dubai"
  },
  {
    "id": "39851e37-3d81-456e-b368-e1cc2ea7dbaa",
    "slug": "maitha-abdul-rahman-naseeb-bin-naseeb-al-falasi",
    "name": "Maitha Abdul Rahman Naseeb bin Naseeb Al Falasi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Maitha Abdul Rahman Naseeb bin Naseeb Al Falasi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_39851e37-3d81-456e-b368-e1cc2ea7dbaa",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4139",
    "company": "Abdul Rahman Naseeb Advocates and Legal Consultants"
  },
  {
    "id": "858a08d0-6a1e-4077-a002-f09f81edad9f",
    "slug": "maitha-abdel-moneim-salem-obaid-bin-suwaidan-al-suwaidi",
    "name": "Maitha Abdel Moneim Salem Obaid bin Suwaidan Al Suwaidi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Maitha Abdel Moneim Salem Obaid bin Suwaidan Al Suwaidi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_858a08d0-6a1e-4077-a002-f09f81edad9f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4344",
    "company": "Bin Suwaidan Law Firm and Legal Consultations"
  },
  {
    "id": "26885d50-4311-4928-a758-a50424624c72",
    "slug": "mira-khalfan-saif-baljafla-al-mansouri",
    "name": "Mira Khalfan Saif Baljafla Al Mansouri",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Mira Khalfan Saif Baljafla Al Mansouri",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_26885d50-4311-4928-a758-a50424624c72",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4201",
    "company": "Hadeel Al-Shaali Law Firm and Legal Consultations"
  },
  {
    "id": "08a1e7de-9a17-45a5-bb50-31dd8ece2e10",
    "slug": "mira-rashid-ahmed-bournaqin-al-ali",
    "name": "Mira Rashid Ahmed Bournaqin Al Ali",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Mira Rashid Ahmed Bournaqin Al Ali",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_08a1e7de-9a17-45a5-bb50-31dd8ece2e10",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4720",
    "company": "Ibrahim Ali Al-Mousa Law Firm and Legal Consultations"
  },
  {
    "id": "ed25bccd-a94d-416c-956a-ba45e19611d5",
    "slug": "mira-ali-jumah-hamad-al-junaibi",
    "name": "Mira Ali Jumah Hamad Al-Junaibi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Mira Ali Jumah Hamad Al-Junaibi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_ed25bccd-a94d-416c-956a-ba45e19611d5",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4294",
    "company": "Mira Ali Al-Junaibi Advocates and Legal Consultations"
  },
  {
    "id": "5cd86516-63b5-4f09-8048-34b7ca7982cd",
    "slug": "mira-jalal-akbar-juma-al-balushi",
    "name": "Mira Jalal Akbar Juma Al Balushi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Mira Jalal Akbar Juma Al Balushi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_5cd86516-63b5-4f09-8048-34b7ca7982cd",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4012",
    "company": "Rights Law Firm and Legal Consultations"
  },
  {
    "id": "29d41137-8d5c-42af-ad77-f22d9d4abc83",
    "slug": "mead-youssef-abdul-karim-youssef-al-shirawi",
    "name": "Mead Youssef Abdul Karim Youssef Al-Shirawi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Mead Youssef Abdul Karim Youssef Al-Shirawi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_29d41137-8d5c-42af-ad77-f22d9d4abc83",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2292",
    "company": "Dr.'s office Mead Youssef Al-Shirawi Advocates and Legal Consultants"
  },
  {
    "id": "e1ea2d24-0506-4cae-9823-4a598bf96a89",
    "slug": "obaid-abdullah-al-abri-advocates-and-legal-consultants",
    "name": "Obaid Abdullah Al Abri Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE9BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Obaid Abdullah Al Abri Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e1ea2d24-0506-4cae-9823-4a598bf96a89",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4704",
    "owner": "Maymouna Ali Amer Al-Jaidi"
  },
  {
    "id": "b3a2c0e5-7cc6-42c4-a007-879a038347df",
    "slug": "nadia-mohamed-law-firm-and-legal-consultations",
    "name": "Nadia Mohamed Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE5NCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Nadia Mohamed Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_b3a2c0e5-7cc6-42c4-a007-879a038347df",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3546",
    "owner": "Nadia Mohamed Ramadan"
  },
  {
    "id": "2748e460-02b5-4218-b8bc-4e338fc4dead",
    "slug": "nadia-muhammad-habib-al-youssef",
    "name": "Nadia Muhammad Habib Al-Youssef",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Nadia Muhammad Habib Al-Youssef",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_2748e460-02b5-4218-b8bc-4e338fc4dead",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3160",
    "company": "Nadia Al-Youssef Advocates and Legal Consultants"
  },
  {
    "id": "69bb8b3a-cb80-4108-986f-9fc8cf68e05f",
    "slug": "nasser-jarman-butti-al-ahbabi",
    "name": "AMEENA AHMED HASAN M ALAHMED",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/04/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Nasser Jarman Butti Al-Ahbabi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_69bb8b3a-cb80-4108-986f-9fc8cf68e05f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "L-2091",
    "company": "Nasser Butti Advocates and Legal Consultants"
  },
  {
    "id": "01cbbdaf-42b9-4f45-a8d1-ac13e947bf7b",
    "slug": "nasser-saeed-majid-saeed-al-muhairi",
    "name": "Nasser Saeed Majid Saeed Al Muhairi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Nasser Saeed Majid Saeed Al Muhairi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_01cbbdaf-42b9-4f45-a8d1-ac13e947bf7b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4292",
    "company": "Nasser Saeed Al Muhairi Advocates and Legal Consultants"
  },
  {
    "id": "3e654618-b66d-4311-9182-f81ae121e6b4",
    "slug": "nasser-shayea-al-hajri-advocates-and-legal-consultants",
    "name": "MOAZA ABDULRAHMAN YOUSUF BIN HAREB ALMHERI",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE5TCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/30/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Nasser Shayea Al Hajri Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_3e654618-b66d-4311-9182-f81ae121e6b4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2055",
    "owner": "Nasser Shayea Hammoud Salim Al-Hajri"
  },
  {
    "id": "ed277f02-e78c-4422-a325-78c0fed665c6",
    "slug": "nasser-saleh-ahmed-dhaif-allah-al-musabi",
    "name": "Nasser Saleh Ahmed Dhaif Allah Al-Musabi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Nasser Saleh Ahmed Dhaif Allah Al-Musabi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_ed277f02-e78c-4422-a325-78c0fed665c6",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4384",
    "company": "Dr. Yousef Al Marzouqi Advocates and Legal Consultants"
  },
  {
    "id": "8ec5603c-2137-4c87-b8ed-5abe63d12862",
    "slug": "nasser-abdul-rahman-muhammad-ismail-al-hosani",
    "name": "Nasser Abdul Rahman Muhammad Ismail Al Hosani",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Nasser Abdul Rahman Muhammad Ismail Al Hosani",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_8ec5603c-2137-4c87-b8ed-5abe63d12862",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4128",
    "company": "Nasser Abdul Rahman Al Hosani Advocates and Legal Consultations"
  },
  {
    "id": "294d672d-a55f-4ae0-9a2d-c39961683713",
    "slug": "nasser-abdul-aziz-shaheen-al-rahma-the-main-office",
    "name": "Nasser Abdul Aziz Shaheen Al Rahma, the main office",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Nasser Abdul Aziz Shaheen Al Rahma, the main office",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_294d672d-a55f-4ae0-9a2d-c39961683713",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4370",
    "company": "Nasser Abdul Aziz Shaheen Advocates and Legal Consultants"
  },
  {
    "id": "e029ee49-b771-445e-96f3-89988b723de6",
    "slug": "nasser-abdullah-salem-al-mahrami",
    "name": "Nasser Abdullah Salem Al Mahrami",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Nasser Abdullah Salem Al Mahrami",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e029ee49-b771-445e-96f3-89988b723de6",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3321",
    "company": "Nasser Abdullah Al Mahrami Advocates and Legal Consultants"
  },
  {
    "id": "3bbf1551-c226-45b3-a3ec-1768f7610dba",
    "slug": "nasser-abdul-wahed-abdul-rahman-al-awar",
    "name": "Nasser Abdul Wahed Abdul Rahman Al Awar",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Nasser Abdul Wahed Abdul Rahman Al Awar",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_3bbf1551-c226-45b3-a3ec-1768f7610dba",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3942",
    "company": "Nasser Al Awar Advocates and Legal Consultants"
  },
  {
    "id": "1d29706d-7724-44fa-bc86-0b7bf7362a50",
    "slug": "nasser-obaid-al-khawar-al-kaabis-guide",
    "name": "Nasser Obaid, Al Khawar Al Kaabi’s guide",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Nasser Obaid, Al Khawar Al Kaabi’s guide",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_1d29706d-7724-44fa-bc86-0b7bf7362a50",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4381",
    "company": "The office of lawyer Jamila Ghulam Haider Al Balushi"
  },
  {
    "id": "064c794a-2bb9-487b-94be-8462449a9174",
    "slug": "nasser-mal-allah-qasim-al-hammadi",
    "name": "Nasser Mal Allah Qasim Al Hammadi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Nasser Mal Allah Qasim Al Hammadi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_064c794a-2bb9-487b-94be-8462449a9174",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2588",
    "company": "Nasser Mal Allah Al Hammadi Advocates and Legal Consultants"
  },
  {
    "id": "7e0df5db-1394-46e2-ba1a-8fb70e76c040",
    "slug": "nasser-mal-allah-law-firm-and-legal-consultations",
    "name": "Nasser Mal Allah Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE5NCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Nasser Mal Allah Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_7e0df5db-1394-46e2-ba1a-8fb70e76c040",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "462",
    "owner": "Nasser Mal Allah Muhammad Ghanem"
  },
  {
    "id": "b00a04a7-128e-4452-acba-f03f504fb14d",
    "slug": "nasser-youssef-ali-nasser-al-khamis",
    "name": "Nasser Youssef Ali Nasser Al-Khamis",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Nasser Youssef Ali Nasser Al-Khamis",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_b00a04a7-128e-4452-acba-f03f504fb14d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4131",
    "company": "Nasser Youssef Al-Khamis Law Firm and Legal Consultations"
  },
  {
    "id": "fddac537-3f9c-4592-a798-8eded833749e",
    "slug": "nasser-abdullah-hassan-muhammad-murshid",
    "name": "Nasser Abdullah Hassan Muhammad Murshid",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Nasser Abdullah Hassan Muhammad Murshid",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_fddac537-3f9c-4592-a798-8eded833749e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "772",
    "company": "Arab Lawyers Advocates and Legal Consultants"
  },
  {
    "id": "906c66b7-95c3-43b9-bb4e-cdca62bf8c49",
    "slug": "naameh-muhammad-ahmed-al-obaid-god-almighty",
    "name": "Naameh Muhammad Ahmed Al-Obaid, God Almighty",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiM1MTczZTI7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Naameh Muhammad Ahmed Al-Obaid, God Almighty",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_906c66b7-95c3-43b9-bb4e-cdca62bf8c49",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4033",
    "company": "Dr. Ibrahim Hassan Al-Mulla Advocates and Legal Consultants"
  },
  {
    "id": "260668e4-2661-4d3c-ae80-fd8c7d93f9fe",
    "slug": "nahed-abdullah-hamid-al-abri",
    "name": "Nahed Abdullah Hamid Al Abri",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Nahed Abdullah Hamid Al Abri",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_260668e4-2661-4d3c-ae80-fd8c7d93f9fe",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4326",
    "company": "Nahed Abdullah Al Abri Law Firm and Legal Consultations"
  },
  {
    "id": "0547f367-9340-4828-b4bf-811866673bd3",
    "slug": "naglaa-ahmed-badawy-law-office-and-legal-consultations",
    "name": "AHMAD ABDULWAHAB AHMAD AL FILI",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE5BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/19/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Naglaa Ahmed Badawy Law Office and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_0547f367-9340-4828-b4bf-811866673bd3",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2042",
    "owner": "Naglaa Ahmed Badawy Al-Kubaisi"
  },
  {
    "id": "ae3e6a4d-dee8-400b-b2b0-40478434f867",
    "slug": "naglaa-rashid-mohammed-rashid-al-zaabi",
    "name": "Naglaa Rashid Mohammed Rashid Al Zaabi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Naglaa Rashid Mohammed Rashid Al Zaabi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_ae3e6a4d-dee8-400b-b2b0-40478434f867",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2451",
    "company": "Najla Rashid Al Zaabi Advocates and Legal Consultants - LLC - S.P.C."
  },
  {
    "id": "3f1a2755-78a4-4a2d-ab21-6a03ef849d03",
    "slug": "star-abdullah-abdul-rahim-abdullah-keshwani",
    "name": "Star Abdullah Abdul Rahim Abdullah Keshwani",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Star Abdullah Abdul Rahim Abdullah Keshwani",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_3f1a2755-78a4-4a2d-ab21-6a03ef849d03",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3678",
    "company": "Younis Mohammed Al Balushi Advocates and Legal Consultants"
  },
  {
    "id": "c776fdad-ad2a-49cd-945c-d22163347942",
    "slug": "nujoud-nahyan-ibrahim-al-hammadi",
    "name": "Nujoud Nahyan Ibrahim Al Hammadi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Nujoud Nahyan Ibrahim Al Hammadi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c776fdad-ad2a-49cd-945c-d22163347942",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3380",
    "company": "Nujoud Al Hammadi and Partners Advocates and Legal Consultants - LLC"
  },
  {
    "id": "c1888fb9-f9bc-4cd9-9743-0f4545a9a304",
    "slug": "nada-muhammad-khamis-hassan-al-muhairbi",
    "name": "Nada Muhammad Khamis Hassan Al Muhairbi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Nada Muhammad Khamis Hassan Al Muhairbi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c1888fb9-f9bc-4cd9-9743-0f4545a9a304",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4069",
    "company": "Nada Mohammed Al Muhairbi Law Office and Legal Consultations"
  },
  {
    "id": "e37dfb01-2412-4ff3-801a-d7c512431978",
    "slug": "nashwa-ahmed-mohammed",
    "name": "Nashwa Ahmed Mohammed",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Nashwa Ahmed Mohammed",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e37dfb01-2412-4ff3-801a-d7c512431978",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4583",
    "company": "Dr. Nashwa Ahmed Mohammed Advocates and Legal Consultants LLC (Single Person Company)"
  },
  {
    "id": "a25b01fa-f490-4004-93b0-8652d8e3cbf9",
    "slug": "nashwa-abdullah-khalifa-al-qubaisi",
    "name": "Nashwa Abdullah Khalifa Al Qubaisi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Nashwa Abdullah Khalifa Al Qubaisi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_a25b01fa-f490-4004-93b0-8652d8e3cbf9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "543",
    "company": "Nashwa Al Qubaisi Advocates and Legal Consultants"
  },
  {
    "id": "7d3476f1-da18-4444-b50e-81490e3c757b",
    "slug": "al-ahly-advocates-and-legal-consultations-llc",
    "name": "Al Ahly Advocates and Legal Consultations LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Al Ahly Advocates and Legal Consultations LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_7d3476f1-da18-4444-b50e-81490e3c757b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2110",
    "owner": "Nawal Hassan Khalaf Muhammad Al Hosani"
  },
  {
    "id": "3607bd84-0b17-4a5a-925f-26f9a0806934",
    "slug": "nawal-salem-saeed-salem-batwih",
    "name": "Nawal Salem Saeed Salem Batwih",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Nawal Salem Saeed Salem Batwih",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_3607bd84-0b17-4a5a-925f-26f9a0806934",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3671",
    "company": "Nawal Salem Saeed Advocates and Legal Consultants"
  },
  {
    "id": "4660c916-9b73-4ba5-96c4-4a99f1d6149f",
    "slug": "nawal-issa-humaid-abdullah-al-zaabi",
    "name": "Nawal Issa Humaid Abdullah Al Zaabi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Nawal Issa Humaid Abdullah Al Zaabi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_4660c916-9b73-4ba5-96c4-4a99f1d6149f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3964",
    "company": "Nawal Issa Al Zaabi Advocates and Legal Consultants"
  },
  {
    "id": "2d59e9ad-be64-4206-b0bd-a89fa45ac35f",
    "slug": "nour-saeed-juma-al-suwaidi",
    "name": "Nour Saeed Juma Al Suwaidi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Nour Saeed Juma Al Suwaidi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_2d59e9ad-be64-4206-b0bd-a89fa45ac35f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3612",
    "company": "Saeed Al Suwaidi Advocates and Legal Consultants"
  },
  {
    "id": "ab3dc261-7c15-4e72-8e38-da6d17af8a0c",
    "slug": "noura-al-amiri-law-firm-and-legal-consultations",
    "name": "Noura Al Amiri Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE5BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Noura Al Amiri Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_ab3dc261-7c15-4e72-8e38-da6d17af8a0c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "1246",
    "owner": "Noura Ibrahim Al-Amiri"
  },
  {
    "id": "c24dd2bb-b83e-40cc-9b44-62f734bff264",
    "slug": "noura-ahmed-mohammed-ahmed-al-hosani",
    "name": "Noura Ahmed Mohammed Ahmed Al Hosani",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Noura Ahmed Mohammed Ahmed Al Hosani",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c24dd2bb-b83e-40cc-9b44-62f734bff264",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3643",
    "company": "Sarah Law Firm and Legal Consultations"
  },
  {
    "id": "bc3a67bd-3bd3-4432-b77b-4e5a29ff08a2",
    "slug": "noura-rashid-juma-al-rushdi-al-morshedy",
    "name": "Noura Rashid Juma Al Rushdi Al Morshedy",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Noura Rashid Juma Al Rushdi Al Morshedy",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_bc3a67bd-3bd3-4432-b77b-4e5a29ff08a2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3961",
    "company": "Faisal Salem Advocates and Legal Consultants"
  },
  {
    "id": "58f1c6bd-f017-4d4b-87da-9dff6408f4de",
    "slug": "noura-khaled-ahmed-salem-makhashin",
    "name": "Noura Khaled Ahmed Salem Makhashin",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Noura Khaled Ahmed Salem Makhashin",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_58f1c6bd-f017-4d4b-87da-9dff6408f4de",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4589",
    "company": "Noura Khaled Makhashin Law Firm and Legal Consultations"
  },
  {
    "id": "3546feff-3db3-4bf4-af83-513335baf671",
    "slug": "noura-al-hajri-advocates-and-legal-consultations-al-ain",
    "name": "Noura Al Hajri Advocates and Legal Consultations - Al Ain",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE5BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Noura Al Hajri Advocates and Legal Consultations - Al Ain",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_3546feff-3db3-4bf4-af83-513335baf671",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "2289",
    "owner": "Noura Sahmi Nasser Jamal Al-Hajri"
  },
  {
    "id": "6f7ff4d3-b1a9-4e42-ad26-5afdcce7df39",
    "slug": "nourhan-abdul-latif-abdul-rahman-al-zaabi",
    "name": "Nourhan Abdul Latif Abdul Rahman Al Zaabi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Nourhan Abdul Latif Abdul Rahman Al Zaabi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_6f7ff4d3-b1a9-4e42-ad26-5afdcce7df39",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3784",
    "company": "Nourhan Abdul Latif Al Zaabi Advocates and Legal Consultants"
  },
  {
    "id": "c44d906e-cb8c-4087-b315-8ae4f6671b13",
    "slug": "nouf-qasim-advocates-and-legal-consultations-llc",
    "name": "Nouf Qasim Advocates and Legal Consultations LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE5RCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Nouf Qasim Advocates and Legal Consultations LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c44d906e-cb8c-4087-b315-8ae4f6671b13",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4207",
    "owner": "Nouf Abu al-Fadl Muhammad Qasim Baydar Yamji"
  },
  {
    "id": "1fcb91fa-e1a3-4072-9546-998988cf410d",
    "slug": "nouf-suhail-saeed-ali-al-kaabi",
    "name": "Nouf Suhail Saeed Ali Al Kaabi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Nouf Suhail Saeed Ali Al Kaabi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_1fcb91fa-e1a3-4072-9546-998988cf410d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4229",
    "company": "Rashid Khalil Obaid Advocates and Legal Consultants"
  },
  {
    "id": "c0d98be2-2292-42dd-8758-501b135674f8",
    "slug": "nouf-saleh-ali-sweileh-al-buraiki",
    "name": "Nouf Saleh Ali Sweileh Al-Buraiki",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Nouf Saleh Ali Sweileh Al-Buraiki",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c0d98be2-2292-42dd-8758-501b135674f8",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4143",
    "company": "Roya Al-Awadhi Lawyers and Legal Consultants"
  },
  {
    "id": "3b5696a0-1499-4431-a775-ef18c27567ed",
    "slug": "fahd-bin-tamim-advocates-and-legal-consultants-llc",
    "name": "Fahd Bin Tamim Advocates and Legal Consultants LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEZCCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Fahd Bin Tamim Advocates and Legal Consultants LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_3b5696a0-1499-4431-a775-ef18c27567ed",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3428",
    "owner": "Nouf Abdul Rahim Mohammed Al Hashemi"
  },
  {
    "id": "24e05b7f-5be9-4003-b339-36f54b71ed54",
    "slug": "nouf-abdullah-ahmed-al-abdullah",
    "name": "Nouf Abdullah Ahmed Al Abdullah",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Nouf Abdullah Ahmed Al Abdullah",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_24e05b7f-5be9-4003-b339-36f54b71ed54",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2883",
    "company": "Nouf Al Abdullah Advocates and Legal Consultations LLC"
  },
  {
    "id": "cc9547d7-caee-4472-9ac2-017cc463e81e",
    "slug": "nouf-mustafa-ahmed-muhammad-saif",
    "name": "Nouf Mustafa Ahmed Muhammad Saif",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Nouf Mustafa Ahmed Muhammad Saif",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_cc9547d7-caee-4472-9ac2-017cc463e81e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2555",
    "company": "Nouf Saif Law Firm and Legal Consultations"
  },
  {
    "id": "bce76917-3038-4942-bcab-7eac3cf19e8c",
    "slug": "naila-ali-khamis-mohammed-al-muhairi",
    "name": "Naila Ali Khamis Mohammed Al Muhairi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Naila Ali Khamis Mohammed Al Muhairi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_bce76917-3038-4942-bcab-7eac3cf19e8c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3686",
    "company": "Naila Ali Al Muhairi Advocates and Legal Consultants"
  },
  {
    "id": "bad8e139-ece4-4d81-bc37-681f65fa47e4",
    "slug": "hashem-salem-saif-law-firm-and-legal-consultations",
    "name": "Hashem Salem Saif Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Hashem Salem Saif Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_bad8e139-ece4-4d81-bc37-681f65fa47e4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3400",
    "owner": "Hashem Salem Saif Abdullah"
  },
  {
    "id": "5bf05540-0b85-4b3c-bccb-2cf007afff9f",
    "slug": "hashem-ali-muhammad-omar-al-aidarous",
    "name": "Hashem Ali Muhammad Omar Al-Aidarous",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Hashem Ali Muhammad Omar Al-Aidarous",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5bf05540-0b85-4b3c-bccb-2cf007afff9f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3073",
    "company": "Al-Aidaroos Advocates and Legal Consultations/Dubai"
  },
  {
    "id": "f3a4c954-2ee2-44fb-9d89-0b77616e6fbc",
    "slug": "hashem-ali-hashem-ahmed-al-hashemi",
    "name": "Hashem Ali Hashem Ahmed Al Hashemi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Hashem Ali Hashem Ahmed Al Hashemi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_f3a4c954-2ee2-44fb-9d89-0b77616e6fbc",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "1017",
    "company": "Hashem Al Hashemi Law Firm and Legal Consultations"
  },
  {
    "id": "70a4999b-c222-43fb-9b3b-11e78e84352f",
    "slug": "hayel-al-harbi-lawyers-and-legal-consultants-one-person-company-llc-branch",
    "name": "Hayel Al Harbi Lawyers and Legal Consultants - One Person Company LLC - Branch",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Hayel Al Harbi Lawyers and Legal Consultants - One Person Company LLC - Branch",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_70a4999b-c222-43fb-9b3b-11e78e84352f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "66",
    "owner": "Hayel Muhammad Abdel Majeed Al-Harbi"
  },
  {
    "id": "e8919cad-3fc8-47cf-9d26-c974834a0042",
    "slug": "heba-muhammad-yahya-law-firm-and-legal-consultations",
    "name": "Heba Muhammad Yahya Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Heba Muhammad Yahya Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e8919cad-3fc8-47cf-9d26-c974834a0042",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3661",
    "owner": "Heba Muhammad Yahya Hassan Hamiko"
  },
  {
    "id": "2efdf988-497d-44ee-b9ea-c044797bbfe3",
    "slug": "hoda-ahmed-sheikh-nassar-al-shammari",
    "name": "Hoda Ahmed Sheikh Nassar Al-Shammari",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Hoda Ahmed Sheikh Nassar Al-Shammari",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_2efdf988-497d-44ee-b9ea-c044797bbfe3",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3388",
    "company": "Mohammed Bani Hashem Advocates and Legal Consultants"
  },
  {
    "id": "fe9926cd-da43-405d-b681-35d2e6472b34",
    "slug": "hoda-ibrahim-ibrahim-mustafa-al-hammadi",
    "name": "Hoda Ibrahim Ibrahim Mustafa Al Hammadi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBISQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Hoda Ibrahim Ibrahim Mustafa Al Hammadi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_fe9926cd-da43-405d-b681-35d2e6472b34",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4250",
    "company": "Huda Ibrahim Al Hammadi Law Firm and Legal Consultations"
  },
  {
    "id": "d94cdada-bc50-4393-8f44-e68b03ba3bc0",
    "slug": "hoda-hassan-youssef-mohammed-al-hammadi",
    "name": "Hoda Hassan Youssef Mohammed Al Hammadi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBISAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Hoda Hassan Youssef Mohammed Al Hammadi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_d94cdada-bc50-4393-8f44-e68b03ba3bc0",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4249",
    "company": "Hoda Al Hammadi Law Firm and Legal Consultations"
  },
  {
    "id": "411e9656-c74b-471d-8911-4989f99db4c8",
    "slug": "hoda-al-mazmi-advocates-and-legal-consultations-one-person-company-llc",
    "name": "Hoda Al Mazmi Advocates and Legal Consultations - One Person Company LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Hoda Al Mazmi Advocates and Legal Consultations - One Person Company LLC",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_411e9656-c74b-471d-8911-4989f99db4c8",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3356",
    "owner": "Hoda Muhammad Ali Juma Al-Mazmi"
  },
  {
    "id": "4bd514e2-1a57-408d-ac24-9e1c3fa03cc2",
    "slug": "hoda-yaqoub-law-firm-and-legal-consultations",
    "name": "Hoda Yaqoub Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhZCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Hoda Yaqoub Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_4bd514e2-1a57-408d-ac24-9e1c3fa03cc2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3654",
    "owner": "Hoda Yacoub Darwish Johar"
  },
  {
    "id": "e361bd97-68bd-498d-87be-45160d651617",
    "slug": "hadeel-ali-khalifa-ali-al-shaali",
    "name": "Hadeel Ali Khalifa Ali Al-Shaali",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Hadeel Ali Khalifa Ali Al-Shaali",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e361bd97-68bd-498d-87be-45160d651617",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2719",
    "company": "Hadeel Al-Shaali Law Firm and Legal Consultations"
  },
  {
    "id": "af85dc95-7cfb-4c60-9128-2ef105d6e234",
    "slug": "hazza-dhafer-masoud-al-ahbabi",
    "name": "Hazza Dhafer Masoud Al Ahbabi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Hazza Dhafer Masoud Al Ahbabi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_af85dc95-7cfb-4c60-9128-2ef105d6e234",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3002",
    "company": "Hazza Al-Ahbabi Advocates and Legal Consultants"
  },
  {
    "id": "9d0a8917-1a14-4ab0-8151-0d6051916953",
    "slug": "hammam-bin-ramlan-mohammed-al-hajri",
    "name": "MAYMOUNA ALI AMER AL JEAIDI",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/10/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Hammam bin Ramlan Mohammed Al Hajri",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_9d0a8917-1a14-4ab0-8151-0d6051916953",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "L-2146",
    "company": "Hammam Bin Ramlan Advocates and Legal Consultants"
  },
  {
    "id": "4dbc630d-ec86-4a28-b7cc-55325a10b883",
    "slug": "hanadi-al-naqbi-law-firm-and-legal-consultations",
    "name": "Hanadi Al Naqbi Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Hanadi Al Naqbi Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_4dbc630d-ec86-4a28-b7cc-55325a10b883",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3958",
    "owner": "Hanadi Salem Ali Al-Othmani Al-Naqbi"
  },
  {
    "id": "9df4661b-4543-4820-b66a-74a9264c4c0f",
    "slug": "dr-hind-bin-hindi-law-firm-and-legal-consultations",
    "name": "Dr. Hind Bin Hindi Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhCCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Dr. Hind Bin Hindi Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_9df4661b-4543-4820-b66a-74a9264c4c0f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3420",
    "owner": "Hind Hamid Khalifa bin Hindi Al-Alili"
  },
  {
    "id": "114a934c-aaaa-4cf5-92cc-ccfe4ec5598f",
    "slug": "hind-hamid-abdullah-al-shaiba-al-nuaimi",
    "name": "Hind Hamid Abdullah Al Shaiba Al Nuaimi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBISAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Hind Hamid Abdullah Al Shaiba Al Nuaimi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_114a934c-aaaa-4cf5-92cc-ccfe4ec5598f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4375",
    "company": "Hind Humaid Al Nuaimi Advocates and Legal Consultants"
  },
  {
    "id": "1edb1a9c-31cd-4200-a494-eb879532872b",
    "slug": "hind-hamid-ali-ghadeer-al-ketbi",
    "name": "Hind Hamid Ali Ghadeer Al Ketbi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBISAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Hind Hamid Ali Ghadeer Al Ketbi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_1edb1a9c-31cd-4200-a494-eb879532872b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "1362",
    "company": "Hind Al Ketbi Law Firm and Legal Consultations"
  },
  {
    "id": "f9a33f07-ac11-41ed-af44-5d7ff8111f7e",
    "slug": "dr-yousef-al-marzouqi-advocates-and-legal-consultants",
    "name": "Dr. Yousef Al Marzouqi Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFlBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Dr. Yousef Al Marzouqi Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_f9a33f07-ac11-41ed-af44-5d7ff8111f7e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3318",
    "owner": "Hind Salem Hassan Al Shehhi"
  },
  {
    "id": "464fff62-a61c-4053-b95d-5072b679ee88",
    "slug": "nasser-al-shamsi-advocates-and-legal-consultants-abu-dhabi",
    "name": "Nasser Al Shamsi Advocates and Legal Consultants, Abu Dhabi",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE5BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Nasser Al Shamsi Advocates and Legal Consultants, Abu Dhabi",
    "consultationFee": 500,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_464fff62-a61c-4053-b95d-5072b679ee88",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "1648",
    "owner": "Hind Shehab Hamad Al-Houli Al-Suwaidi"
  },
  {
    "id": "6e636169-e812-482a-9840-35bd70107345",
    "slug": "hind-abdel-aziz-shahdad-suleiman-al-mazmi",
    "name": "Hind Abdel Aziz Shahdad Suleiman Al-Mazmi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Hind Abdel Aziz Shahdad Suleiman Al-Mazmi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_6e636169-e812-482a-9840-35bd70107345",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3395",
    "company": "Obaid Al-Mazmi Advocates and Legal Consultants"
  },
  {
    "id": "0ce43283-34b4-4e43-94f5-1af1fdd0aef8",
    "slug": "hind-muhammad-humaid-al-owais-al-shamsi",
    "name": "Hind Muhammad Humaid Al Owais Al Shamsi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Hind Muhammad Humaid Al Owais Al Shamsi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_0ce43283-34b4-4e43-94f5-1af1fdd0aef8",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2405",
    "company": "Hind Mohammed Al Owais Advocates and Legal Consultants"
  },
  {
    "id": "7367cc74-2ad6-4e50-8d58-5ca91fa7c9d9",
    "slug": "hanouf-muhammad-ali-tamim",
    "name": "Hanouf Muhammad Ali Tamim",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Hanouf Muhammad Ali Tamim",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_7367cc74-2ad6-4e50-8d58-5ca91fa7c9d9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3659",
    "company": "Hanouf Mohammed Tamim Advocates and Legal Consultants"
  },
  {
    "id": "c12035c3-c032-4757-b1ef-f94f4e64f37b",
    "slug": "sheikh-rashid-bin-nasser-al-nuaimi-law-firm-and-legal-consultations-office",
    "name": "Sheikh Rashid Bin Nasser Al Nuaimi Law Firm and Legal Consultations Office",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNSCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Sheikh Rashid Bin Nasser Al Nuaimi Law Firm and Legal Consultations Office",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c12035c3-c032-4757-b1ef-f94f4e64f37b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4341",
    "owner": "Haitham Ahmed Saif Al-Amri"
  },
  {
    "id": "baf2704d-243e-40f4-9206-9eaee3a0c183",
    "slug": "haitham-salah-jalal-abdullah-muhammad",
    "name": "Haitham Salah Jalal Abdullah Muhammad",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Haitham Salah Jalal Abdullah Muhammad",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_baf2704d-243e-40f4-9206-9eaee3a0c183",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3294",
    "company": "Haitham Salah Law Firm and Legal Consultations"
  },
  {
    "id": "8d66e986-e4e6-4672-b4c0-13056643832e",
    "slug": "haitham-muhammad-saif-abdullah-al-yamahi",
    "name": "Haitham Muhammad Saif Abdullah Al Yamahi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Haitham Muhammad Saif Abdullah Al Yamahi",
    "consultationFee": 400,
    "emirate": "Sharjah",
    "verified": true,
    "offices": [
      {
        "id": "office_8d66e986-e4e6-4672-b4c0-13056643832e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Sharjah",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2547",
    "company": "Daifis Lawyers and Legal Consultants/ Sharjah"
  },
  {
    "id": "8fc5c0fc-a17d-4fee-ab7f-7485c708afc9",
    "slug": "wadha-muhammad-abdullah-al-nuaimi",
    "name": "Wadha Muhammad Abdullah Al Nuaimi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Wadha Muhammad Abdullah Al Nuaimi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_8fc5c0fc-a17d-4fee-ab7f-7485c708afc9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3950",
    "company": "Wadha Mohammed Al Nuaimi Advocates and Legal Consultants"
  },
  {
    "id": "3787aa8e-9c74-414a-b857-32978836c29c",
    "slug": "fatima-al-ali-law-firm-and-legal-consultations",
    "name": "Fatima Al Ali Law Firm and Legal Consultations",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEZBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Fatima Al Ali Law Firm and Legal Consultations",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_3787aa8e-9c74-414a-b857-32978836c29c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "4107",
    "owner": "Wafa Suleiman Saeed Ali Al-Dhanhani"
  },
  {
    "id": "a67837be-a311-4dc6-b9e2-509eadbeb66e",
    "slug": "wafa-obaid-masoud-salmeen-al-falasi",
    "name": "Wafa Obaid Masoud Salmeen Al Falasi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Wafa Obaid Masoud Salmeen Al Falasi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_a67837be-a311-4dc6-b9e2-509eadbeb66e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4202",
    "company": "Wafa Obaid Al Falasi Advocates and Legal Consultants"
  },
  {
    "id": "d6ddcf73-6b9e-4da4-9f03-f1d2206192aa",
    "slug": "wafa-ali-ibrahim-abdullah-al-hosani",
    "name": "Wafa Ali Ibrahim Abdullah Al Hosani",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Wafa Ali Ibrahim Abdullah Al Hosani",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_d6ddcf73-6b9e-4da4-9f03-f1d2206192aa",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3245",
    "company": "Wafa Ali Al Hosani Advocates and Legal Consultants"
  },
  {
    "id": "24743585-298b-43a7-af1b-2c73db216670",
    "slug": "loyalty-of-jaber-nasser-saleh-al-rahma",
    "name": "Loyalty of Jaber Nasser Saleh Al Rahma",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Loyalty of Jaber Nasser Saleh Al Rahma",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_24743585-298b-43a7-af1b-2c73db216670",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3021",
    "company": "Walaa Jaber Al Rahma Law Firm and Legal Consultations"
  },
  {
    "id": "bac50428-eaf7-41c6-a939-4c0c8a11b8e0",
    "slug": "walid-khaled-muhammad-abdullah-al-sayari",
    "name": "Walid Khaled Muhammad Abdullah Al-Sayari",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Walid Khaled Muhammad Abdullah Al-Sayari",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_bac50428-eaf7-41c6-a939-4c0c8a11b8e0",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4479",
    "company": "Muhammad Abdul-Ilah Al-Hamid Advocates and Legal Consultants"
  },
  {
    "id": "454b442b-8c0f-4beb-8303-a3cbd3561017",
    "slug": "walid-abdullah-rashid-bin-alawi-al-shamili",
    "name": "Walid Abdullah Rashid bin Alawi Al-Shamili",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Walid Abdullah Rashid bin Alawi Al-Shamili",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_454b442b-8c0f-4beb-8303-a3cbd3561017",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2656",
    "company": "Walid Abdullah Al-Shamili Law Firm and Legal Consultations"
  },
  {
    "id": "6aae4d3f-632a-481d-adb1-ef80495d9646",
    "slug": "walid-ali-abdullah-al-kamali",
    "name": "Walid Ali Abdullah Al Kamali",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Walid Ali Abdullah Al Kamali",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_6aae4d3f-632a-481d-adb1-ef80495d9646",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4587",
    "company": "Al Kamali & Partners are lawyers and legal consultants"
  },
  {
    "id": "313b68c2-e0ad-4cab-b063-5fe10035633b",
    "slug": "walid-ali-yousef-al-ali",
    "name": "Walid Ali Yousef Al Ali",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Walid Ali Yousef Al Ali",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_313b68c2-e0ad-4cab-b063-5fe10035633b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4200",
    "company": "Jamal Al Nuaimi Advocates and Legal Consultants"
  },
  {
    "id": "0b2549e7-a670-4c88-b617-ea6426c796f2",
    "slug": "yathrib-abdul-aziz-yahya-shafyan",
    "name": "Yathrib Abdul Aziz Yahya Shafyan",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Yathrib Abdul Aziz Yahya Shafyan",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_0b2549e7-a670-4c88-b617-ea6426c796f2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4105",
    "company": "Mohammed Al-Azazi Law Firm and Legal Consultations"
  },
  {
    "id": "14ce8dd4-5fb4-4138-80eb-af51ce9fafd2",
    "slug": "saleh-ahmed-al-saadi-delivers",
    "name": "Saleh Ahmed Al-Saadi delivers",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Saleh Ahmed Al-Saadi delivers",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_14ce8dd4-5fb4-4138-80eb-af51ce9fafd2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "417",
    "company": "Yeslam Al-Saadi Advocates and Legal Consultants"
  },
  {
    "id": "136a6f20-c4eb-4618-ac67-f7133c33039e",
    "slug": "yaqoub-muhammad-murad-abdul-rahman-al-mazmi",
    "name": "Yaqoub Muhammad Murad Abdul Rahman Al-Mazmi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Yaqoub Muhammad Murad Abdul Rahman Al-Mazmi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_136a6f20-c4eb-4618-ac67-f7133c33039e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3162",
    "company": "Yaqoub Al-Mazmi Advocates and Legal Consultations"
  },
  {
    "id": "7bd68f4d-57b1-4f14-a079-5924d9669b43",
    "slug": "youssef-ahmed-abdullah-abdul-rahim-al-harmoudi",
    "name": "Youssef Ahmed Abdullah Abdul Rahim Al Harmoudi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Youssef Ahmed Abdullah Abdul Rahim Al Harmoudi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_7bd68f4d-57b1-4f14-a079-5924d9669b43",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "451",
    "company": "Dar Al Bayan Law Firm and Legal Consultations/ Dubai"
  },
  {
    "id": "a5cc0f7a-84be-4b89-94a6-11560af32c3e",
    "slug": "al-shehhi-group-lawyers-and-legal-consultants",
    "name": "Al Shehhi Group Lawyers and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Al Shehhi Group Lawyers and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_a5cc0f7a-84be-4b89-94a6-11560af32c3e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "884",
    "owner": "Youssef Khalaf Youssef Al Hammadi"
  },
  {
    "id": "1e4c27c0-2197-492c-868c-44e5406d8e75",
    "slug": "yousef-bin-hammad-partners-advocates-and-legal-consultantsdubai",
    "name": "Yousef Bin Hammad & Partners Advocates and Legal Consultants/Dubai",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFlCCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Yousef Bin Hammad & Partners Advocates and Legal Consultants/Dubai",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_1e4c27c0-2197-492c-868c-44e5406d8e75",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "295",
    "owner": "Youssef Khalifa Ahmed bin Hammad Al Marri"
  },
  {
    "id": "3c4a6af1-7a07-40f3-8ef0-db5cb9dd5ca7",
    "slug": "yousef-sayed-ali-al-rifai-advocates-and-legal-consultants-llc-spc",
    "name": "Yousef Sayed Ali Al-Rifai Advocates and Legal Consultants - LLC - S.P.C",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFlTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Yousef Sayed Ali Al-Rifai Advocates and Legal Consultants - LLC - S.P.C",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_3c4a6af1-7a07-40f3-8ef0-db5cb9dd5ca7",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "190",
    "owner": "Youssef Sayed Ali Al-Rifai Al-Hosani"
  },
  {
    "id": "ae89e67b-175b-41c0-a7a0-393630f37314",
    "slug": "youssef-abdul-karim-youssef-abdullah",
    "name": "Youssef Abdul Karim Youssef Abdullah",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Youssef Abdul Karim Youssef Abdullah",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_ae89e67b-175b-41c0-a7a0-393630f37314",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4413",
    "company": "Obaid Al-Mazmi Advocates and Legal Consultants"
  },
  {
    "id": "879c37e7-8fcb-4b0f-be3d-9391a0d63f54",
    "slug": "youssef-ali-hassan-al-marzouqi",
    "name": "Youssef Ali Hassan Al Marzouqi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Youssef Ali Hassan Al Marzouqi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_879c37e7-8fcb-4b0f-be3d-9391a0d63f54",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2861",
    "company": "Yousef Ali Al Marzouqi Advocates and Legal Consultants"
  },
  {
    "id": "7fa741d6-19d7-4f81-b215-b69b56c2422d",
    "slug": "youssef-issa-al-sayyah-advocates-and-legal-consultants",
    "name": "Youssef Issa Al Sayyah Advocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmaXJtR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNTE3M2UyO3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJmaXJtU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNiIgc3RkRGV2aWF0aW9uPSIxMiIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xNSkiLz4KICAgICAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgICA8L2RlZnM+CiAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iMjAiIHJ5PSIyMCIgCiAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI2Zpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCNmaXJtU2hhZG93KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFlJCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Services"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Youssef Issa Al Sayyah Advocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_7fa741d6-19d7-4f81-b215-b69b56c2422d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Firm services",
        "price": 500,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Firms",
    "registrationNumber": "3050",
    "owner": "Youssef Issa Salem Al-Sayyah"
  },
  {
    "id": "554d92fa-2c74-4231-969d-481f845cf176",
    "slug": "youssef-muhammad-ahmed-ibrahim-al-naqbi",
    "name": "Youssef Muhammad Ahmed Ibrahim Al-Naqbi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Youssef Muhammad Ahmed Ibrahim Al-Naqbi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_554d92fa-2c74-4231-969d-481f845cf176",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2245",
    "company": "Hani Al Jasmi Advocates and Legal Consultants"
  },
  {
    "id": "8cb3206b-24ba-44d5-a08f-f549dd237d18",
    "slug": "youssef-mohammed-ahmed-al-hammadi",
    "name": "Youssef Mohammed Ahmed Al Hammadi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Youssef Mohammed Ahmed Al Hammadi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_8cb3206b-24ba-44d5-a08f-f549dd237d18",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "1454",
    "company": "Youssef Al Hammadi Advocates and Legal Consultants"
  },
  {
    "id": "df11b22d-688a-42d3-9b2c-ebff1c002e49",
    "slug": "yousef-mohammed-rashid-ali-al-zeyoudi",
    "name": "Yousef Mohammed Rashid Ali Al-Zeyoudi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Yousef Mohammed Rashid Ali Al-Zeyoudi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_df11b22d-688a-42d3-9b2c-ebff1c002e49",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2582",
    "company": "Yousef Mohammed Al-Zeyoudi Law Firm and Legal Consultations Office"
  },
  {
    "id": "4728b0eb-0259-421f-a797-a8294bf71fc4",
    "slug": "youssef-muhammad-ali-ahmed-al-hammadi",
    "name": "Youssef Muhammad Ali Ahmed Al Hammadi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Youssef Muhammad Ali Ahmed Al Hammadi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_4728b0eb-0259-421f-a797-a8294bf71fc4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3235",
    "company": "Mohammed Abdullah and Yousef Al Hammadi Advocates and Legal Consultants"
  },
  {
    "id": "f8a3ff7e-513e-4aa1-a43b-a45848cba806",
    "slug": "youssef-muhammad-youssef-ahmed-al-youssef",
    "name": "Youssef Muhammad Youssef Ahmed Al-Youssef",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Youssef Muhammad Youssef Ahmed Al-Youssef",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_f8a3ff7e-513e-4aa1-a43b-a45848cba806",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3780",
    "company": "Al-Ittihad Law Firm and Legal Consultations"
  },
  {
    "id": "d755442b-d7e1-4344-aae4-c3daa2103c81",
    "slug": "younis-abdul-qadir-muhammad-hassan-al-balushi",
    "name": "Younis Abdul Qadir Muhammad Hassan Al Balushi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Younis Abdul Qadir Muhammad Hassan Al Balushi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_d755442b-d7e1-4344-aae4-c3daa2103c81",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3761",
    "company": "Ali Ibrahim Law Firm and Legal Consultations"
  },
  {
    "id": "c041e48c-fcd5-49f0-8671-ad325156a58e",
    "slug": "younis-muhammad-abdullah-hassan-al-balushi",
    "name": "Younis Muhammad Abdullah Hassan Al Balushi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Younis Muhammad Abdullah Hassan Al Balushi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c041e48c-fcd5-49f0-8671-ad325156a58e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3130",
    "company": "Younis Mohammed Al Balushi Advocates and Legal Consultants"
  },
  {
    "id": "4a8bcf4c-3990-4bf3-a3b3-2bfa8782c01b",
    "slug": "ahmed-mohammed-jaafar-mohammed-al-zaabi",
    "name": "Ahmed Mohammed Jaafar Mohammed Al Zaabi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ahmed Mohammed Jaafar Mohammed Al Zaabi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_4a8bcf4c-3990-4bf3-a3b3-2bfa8782c01b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2295"
  },
  {
    "id": "5d38b517-25f1-4ad3-baff-a87073332bc2",
    "slug": "asmaa-mohammed-ahmed-al-balushi",
    "name": "AISHA MOHAMED AHMED NASIR",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/08/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Asmaa Mohammed Ahmed Al Balushi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_5d38b517-25f1-4ad3-baff-a87073332bc2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "L-2129"
  },
  {
    "id": "b9e9746c-2a69-49fe-87d9-933602f60b9c",
    "slug": "amin-muhammad-rasul-al-awadi",
    "name": "Amin Muhammad Rasul Al-Awadi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Amin Muhammad Rasul Al-Awadi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_b9e9746c-2a69-49fe-87d9-933602f60b9c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2556"
  },
  {
    "id": "b484ecd9-7d8f-4ec9-a385-62447b2ef713",
    "slug": "ibrahim-nabil-al-haj-atallah-hassan-muhammad",
    "name": "Ibrahim Nabil Al-Haj Atallah Hassan Muhammad",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiM1MTczZTI7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ibrahim Nabil Al-Haj Atallah Hassan Muhammad",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_b484ecd9-7d8f-4ec9-a385-62447b2ef713",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2793"
  },
  {
    "id": "b858c275-0ec8-4fce-9f80-9170c08d4e0d",
    "slug": "ahmed-abdullah-mohammed-abdul-wahab-al-nuaimi",
    "name": "ALI SALIM ALI SALIM ALNUAIMI",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/04/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ahmed Abdullah Mohammed Abdul Wahab Al Nuaimi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_b858c275-0ec8-4fce-9f80-9170c08d4e0d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "L-932"
  },
  {
    "id": "6ab8588d-bbed-49f0-bf1f-3f57e81a873c",
    "slug": "al-jawhara-tariq-hussein-al-sarkal-al-ali",
    "name": "Al-Jawhara Tariq Hussein Al-Sarkal Al Ali",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Al-Jawhara Tariq Hussein Al-Sarkal Al Ali",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_6ab8588d-bbed-49f0-bf1f-3f57e81a873c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4217"
  },
  {
    "id": "b208ef94-8cc2-4b58-9ccb-6dab47590721",
    "slug": "dr-salah-obaid-muhammad-al-ghoul-al-salami",
    "name": "Dr. Salah Obaid Muhammad Al-Ghoul Al-Salami",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Dr. Salah Obaid Muhammad Al-Ghoul Al-Salami",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_b208ef94-8cc2-4b58-9ccb-6dab47590721",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "1111111222"
  },
  {
    "id": "f01063e0-d4ae-4cdb-9b33-ad62b53f9d37",
    "slug": "amna-bakhit-humaid-khamis-al-shamsi",
    "name": "Amna Bakhit Humaid Khamis Al Shamsi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Amna Bakhit Humaid Khamis Al Shamsi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_f01063e0-d4ae-4cdb-9b33-ad62b53f9d37",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4204"
  },
  {
    "id": "8e3dd82a-67f2-4594-a0ca-6b3e1b1f8a0a",
    "slug": "jamal-ahmed-ali-abdullah",
    "name": "MOAZA HUMAID SULTAN ABDULLA ALSUWAIDI",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/01/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Jamal Ahmed Ali Abdullah",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_8e3dd82a-67f2-4594-a0ca-6b3e1b1f8a0a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "L-1741"
  },
  {
    "id": "91ec3ea0-2f2a-4664-9882-ce9e1b1bac10",
    "slug": "hanan-ahmed-muhammad-saleh-al-janahi",
    "name": "Hanan Ahmed Muhammad Saleh Al-Janahi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Hanan Ahmed Muhammad Saleh Al-Janahi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_91ec3ea0-2f2a-4664-9882-ce9e1b1bac10",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4443"
  },
  {
    "id": "6aebd6ce-4dde-4af5-a5df-a55e3bd30f60",
    "slug": "khalaf-saeed-khalaf-saeed-al-kaabi",
    "name": "Khalaf Saeed Khalaf Saeed Al Kaabi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiM1MTczZTI7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Khalaf Saeed Khalaf Saeed Al Kaabi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_6aebd6ce-4dde-4af5-a5df-a55e3bd30f60",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "1111111390"
  },
  {
    "id": "d3ddef92-d21c-4349-a57e-5e64dc020270",
    "slug": "khawla-muhammad-ibrahim-saeed-mutout",
    "name": "Khawla Muhammad Ibrahim Saeed Mutout",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Khawla Muhammad Ibrahim Saeed Mutout",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_d3ddef92-d21c-4349-a57e-5e64dc020270",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2882"
  },
  {
    "id": "12e8c1b8-fe7d-4b47-9284-48ceed0c61d0",
    "slug": "rashid-abdul-rahman-rashdan",
    "name": "Rashid Abdul Rahman Rashdan",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Rashid Abdul Rahman Rashdan",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_12e8c1b8-fe7d-4b47-9284-48ceed0c61d0",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "712"
  },
  {
    "id": "120aa574-cf33-490b-992e-0642d78f1a87",
    "slug": "ruqaya-abdul-hay-ali-sayed-al-hashemi",
    "name": "Ruqaya Abdul-Hay Ali Sayed Al-Hashemi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Ruqaya Abdul-Hay Ali Sayed Al-Hashemi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_120aa574-cf33-490b-992e-0642d78f1a87",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4123"
  },
  {
    "id": "1fff08ac-e9bb-448b-baf8-10000fe7428b",
    "slug": "sarah-hussein-mohammed-al-yasi",
    "name": "Sarah Hussein Mohammed Al Yasi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Sarah Hussein Mohammed Al Yasi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_1fff08ac-e9bb-448b-baf8-10000fe7428b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3825"
  },
  {
    "id": "b730ccd4-0f1b-4616-b057-695dc7d4758f",
    "slug": "sarah-abdel-wahab-arif",
    "name": "Sarah Abdel Wahab Arif",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Sarah Abdel Wahab Arif",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_b730ccd4-0f1b-4616-b057-695dc7d4758f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3917"
  },
  {
    "id": "0a695a51-4c68-4e3b-aea2-8a02a2e6082b",
    "slug": "saleh-mutawa-greets-salem-al-minhali",
    "name": "Saleh Mutawa greets Salem Al-Minhali",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiM1MTczZTI7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Saleh Mutawa greets Salem Al-Minhali",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_0a695a51-4c68-4e3b-aea2-8a02a2e6082b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3357"
  },
  {
    "id": "23123a21-5e2f-4a5a-8dcc-67d686ce2a23",
    "slug": "tariq-saeed-bilal-al-dosari",
    "name": "Tariq Saeed Bilal Al-Dosari",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Tariq Saeed Bilal Al-Dosari",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_23123a21-5e2f-4a5a-8dcc-67d686ce2a23",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2181"
  },
  {
    "id": "3747b037-7aaa-43de-a774-f6b0ba977861",
    "slug": "abdul-rahman-hader-obaid-al-mujihim-al-shammari",
    "name": "Abdul Rahman Hader Obaid Al-Mujihim Al-Shammari",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Abdul Rahman Hader Obaid Al-Mujihim Al-Shammari",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_3747b037-7aaa-43de-a774-f6b0ba977861",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4462"
  },
  {
    "id": "f7bc6b09-1594-4d60-9e1f-71c7d8ff73ee",
    "slug": "obaid-ibrahim-obaid-ali-al-nuaimi",
    "name": "Obaid Ibrahim Obaid Ali Al Nuaimi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiM1MTczZTI7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Obaid Ibrahim Obaid Ali Al Nuaimi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_f7bc6b09-1594-4d60-9e1f-71c7d8ff73ee",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2319"
  },
  {
    "id": "933dd61d-f981-469b-97f8-c2e3053ab6ba",
    "slug": "muhammad-bin-hamad-al-ruwaishidi",
    "name": "ABDELKARIM ALI ABDELKARIM MOHAMED",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/08/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad bin Hamad Al-Ruwaishidi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_933dd61d-f981-469b-97f8-c2e3053ab6ba",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "L-1848"
  },
  {
    "id": "7048f603-299a-44ee-8fbb-61f339463c12",
    "slug": "muhammad-saeed-rashid-al-tayyari-bani-ibrahim",
    "name": "Muhammad Saeed Rashid Al Tayyari Bani Ibrahim",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Saeed Rashid Al Tayyari Bani Ibrahim",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_7048f603-299a-44ee-8fbb-61f339463c12",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3264"
  },
  {
    "id": "edb79129-146a-445b-9465-7071c0d37152",
    "slug": "muhammad-suleiman-muhammad-ali-aliwa-al-shehhi",
    "name": "Muhammad Suleiman Muhammad Ali Aliwa Al-Shehhi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Suleiman Muhammad Ali Aliwa Al-Shehhi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_edb79129-146a-445b-9465-7071c0d37152",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "2278"
  },
  {
    "id": "001bdc4c-7048-433a-94e9-7e0d01d54768",
    "slug": "muhammad-ali-khalfan-muhammad-al-neyadi",
    "name": "Muhammad Ali Khalfan Muhammad Al Neyadi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Ali Khalfan Muhammad Al Neyadi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_001bdc4c-7048-433a-94e9-7e0d01d54768",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3513"
  },
  {
    "id": "64d7bfcb-87dd-4ceb-bf6a-5435ec1f7e0b",
    "slug": "muhammad-musa-ahmed-muhammad",
    "name": "Muhammad Musa Ahmed Muhammad",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Muhammad Musa Ahmed Muhammad",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_64d7bfcb-87dd-4ceb-bf6a-5435ec1f7e0b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3529"
  },
  {
    "id": "efaa92c1-e6b4-4a17-9637-486ea207e713",
    "slug": "maryam-ali-musa-hassan-al-marwa",
    "name": "Maryam Ali Musa Hassan Al-Marwa",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Maryam Ali Musa Hassan Al-Marwa",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_efaa92c1-e6b4-4a17-9637-486ea207e713",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "4660"
  },
  {
    "id": "73f7f535-703d-45c2-a2fa-909245a5075a",
    "slug": "maitha-abdullah-ali-sultan-al-hammadi",
    "name": "Maitha Abdullah Ali Sultan Al Hammadi",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Maitha Abdullah Ali Sultan Al Hammadi",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_73f7f535-703d-45c2-a2fa-909245a5075a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3539"
  },
  {
    "id": "63cbf117-f4d7-4dc8-b8fb-18293a5ecd94",
    "slug": "nour-ali-muhammad-al-bar",
    "name": "Nour Ali Muhammad Al-Bar",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Nour Ali Muhammad Al-Bar",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_63cbf117-f4d7-4dc8-b8fb-18293a5ecd94",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "1111111432"
  },
  {
    "id": "e05cb2d6-783c-4352-afa8-01fc33379aca",
    "slug": "youssef-muhammad-ahmed-muhammad-abdul-karim-al-ali",
    "name": "Youssef Muhammad Ahmed Muhammad Abdul Karim Al Ali",
    "title": "Advocacy Lawyer",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwMDBkN2M7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgICAgIDxmaWx0ZXIgaWQ9InNoYWRvdyIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSI+CiAgICAgICAgICAgICAgPGZlRHJvcFNoYWRvdyBkeD0iMCIgZHk9IjQiIHN0ZERldmlhdGlvbj0iOCIgZmxvb2QtY29sb3I9InJnYmEoMCwwLDAsMC4xKSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3NoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjYwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBZTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Lawyer"
    ],
    "description": "Licensed advocacy lawyer: Youssef Muhammad Ahmed Muhammad Abdul Karim Al Ali",
    "consultationFee": 400,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e05cb2d6-783c-4352-afa8-01fc33379aca",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Advocacy",
        "description": "Advocacy Lawyer services",
        "price": 400,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Advocacy_Individuals",
    "registrationNumber": "3504"
  },
  {
    "id": "temp_6590",
    "name": "Hassan Elamin Legal Consultancy",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhFCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/13/2013 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2025-06-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Hassan Elamin Legal Consultancy",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "CF-2013-00113",
    "offices": [
      {
        "address": "1,برج كلوفر باي ,مراسي درايف,Dubai,66111",
        "phone": "97144224422",
        "email": "alaminhassan@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "address": "1,برج كلوفر باي ,مراسي درايف,Dubai,66111",
    "phone": "97144224422",
    "email": "alaminhassan@hotmail.com"
  },
  {
    "id": "temp_6591",
    "name": "Mishcon de Reya LLP (DWTCA Branch)",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1ECiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/11/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/10/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Mishcon de Reya LLP (DWTCA Branch)",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "CF-2025-00187",
    "offices": [
      {
        "address": "Office No. 1501, 1502 & 1506, Floor 15,One Za",
        "phone": "97100000000",
        "email": "chris.skipper@mishcon.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "address": "Office No. 1501, 1502 & 1506, Floor 15,One Za",
    "phone": "97100000000",
    "email": "chris.skipper@mishcon.com"
  },
  {
    "id": "temp_6592",
    "name": "DSK Legal Services LLP - Dubai Branch",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIERMCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/22/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "07/21/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: DSK Legal Services LLP - Dubai Branch",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "CF-2025-00185",
    "offices": [
      {
        "address": "Units P03-19,Bay Square - 12 – P03,Business B",
        "phone": "97100000000",
        "email": "vinodh.kumar@dsklegal.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "address": "Units P03-19,Bay Square - 12 – P03,Business B",
    "phone": "97100000000",
    "email": "vinodh.kumar@dsklegal.com"
  },
  {
    "id": "temp_6593",
    "name": "Anett Pertl Legal Consultants",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFQCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/11/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/10/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Anett Pertl Legal Consultants",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "CF-2025-00186",
    "offices": [
      {
        "address": "Office No. 2202-04,BD BLVD Plaza T2 - 2202,Bu",
        "phone": "97100000000",
        "email": "dr.anettpertl@hotmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "address": "Office No. 2202-04,BD BLVD Plaza T2 - 2202,Bu",
    "phone": "97100000000",
    "email": "dr.anettpertl@hotmail.com"
  },
  {
    "id": "temp_6594",
    "name": "ADVOCATES UNIT",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFVCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 50,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/01/1900 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "1900-01-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: ADVOCATES UNIT",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "ADF-0000-02",
    "offices": [
      {
        "address": "N/A",
        "phone": "97112345678",
        "email": "sample@samlpe.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "address": "N/A",
    "phone": "97112345678",
    "email": "sample@samlpe.com"
  },
  {
    "id": "temp_6595",
    "name": "HAMAD SAEED ALKETBI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/25/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "06/24/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: HAMAD SAEED ALKETBI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "ADF-2025-775",
    "offices": [
      {
        "address": "N/A",
        "phone": "97145527871",
        "email": "hamad_alketbilegal@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "address": "N/A",
    "phone": "97145527871",
    "email": "hamad_alketbilegal@outlook.com"
  },
  {
    "id": "temp_6596",
    "name": "MARIAM ALTENEIJI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/10/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "09/09/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: MARIAM ALTENEIJI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "ADF-2025-782",
    "offices": [
      {
        "address": "N/A",
        "phone": "97144900693",
        "email": "Ask@akhlaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "address": "N/A",
    "phone": "97144900693",
    "email": "Ask@akhlaw.ae"
  },
  {
    "id": "temp_6597",
    "name": "DR ADNAN MOHAMED ALHAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIERBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/17/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "07/16/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: DR ADNAN MOHAMED ALHAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "ADF-2025-776",
    "offices": [
      {
        "address": "N/A",
        "phone": "N/A",
        "email": "Info@dradnan.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "address": "N/A",
    "phone": "N/A",
    "email": "Info@dradnan.ae"
  },
  {
    "id": "temp_6598",
    "name": "AL WASL INTERNATIONAL GROUP ADVOCATES AND LEGAL CONSULTANTS- THE DUBAI TECHNOLOGY AND MEDIA FREE ZON",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFXCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/26/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "01/25/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: AL WASL INTERNATIONAL GROUP ADVOCATES AND LEGAL CONSULTANTS- THE DUBAI TECHNOLOGY AND MEDIA FREE ZON",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "ADF-2012-86",
    "offices": [
      {
        "address": "N/A",
        "phone": "97143901155",
        "email": "legal@awigdic.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "address": "N/A",
    "phone": "97143901155",
    "email": "legal@awigdic.ae"
  },
  {
    "id": "temp_6599",
    "name": "OUTSIDE DUBAI FIRM",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE9ECiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 50,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/01/1900 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "1900-01-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: OUTSIDE DUBAI FIRM",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "ADF-0000-01",
    "offices": [
      {
        "address": "N/A",
        "phone": "97112345678",
        "email": "___sample@samlpe.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "address": "N/A",
    "phone": "97112345678",
    "email": "___sample@samlpe.com"
  },
  {
    "id": "temp_6600",
    "name": "IBRAHIM ALHOSANI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIElBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/05/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "03/04/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: IBRAHIM ALHOSANI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "ADF-2025-763",
    "offices": [
      {
        "address": "N/A",
        "phone": "97142154000",
        "email": "infoline@ilaw.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "address": "N/A",
    "phone": "97142154000",
    "email": "infoline@ilaw.ae"
  },
  {
    "id": "temp_6601",
    "name": "AHMED HUMAID ALBLOOSHI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/28/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "05/27/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: AHMED HUMAID ALBLOOSHI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "ADF-2025-773",
    "offices": [
      {
        "address": "Office No. C-54,HAMAD ABDULAZIZ ABDULLAH AL J",
        "phone": "97100000000",
        "email": "legal@ahalegalgroup.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "address": "Office No. C-54,HAMAD ABDULAZIZ ABDULLAH AL J",
    "phone": "97100000000",
    "email": "legal@ahalegalgroup.com"
  },
  {
    "id": "temp_6602",
    "name": "ABDULAZIZ ALABLAM ADVOCATES & LEGAL CONSULTANTS",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/06/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "08/05/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: ABDULAZIZ ALABLAM ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "ADF-2025-780",
    "offices": [
      {
        "address": "N/A",
        "phone": "97142845200",
        "email": "info@alablam.org",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "address": "N/A",
    "phone": "97142845200",
    "email": "info@alablam.org"
  },
  {
    "id": "temp_6603",
    "name": "FADIL ALZAROONI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEZBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/23/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "07/22/2026 00:00:00",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: FADIL ALZAROONI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "ADF-2025-779",
    "offices": [
      {
        "address": "N/A",
        "phone": "97142820062",
        "email": "info@falzarooni.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "address": "N/A",
    "phone": "97142820062",
    "email": "info@falzarooni.com"
  },
  {
    "id": "temp_6604",
    "name": "Amany Saad Mohamed Hassan",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/06/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Amany Saad Mohamed Hassan",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07024",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Mayer Brown LLP"
  },
  {
    "id": "temp_6605",
    "name": "Charles William Lilley",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIENXCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/28/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Charles William Lilley",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07093",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Bryan Cave Leighton Paisner LLP"
  },
  {
    "id": "temp_6606",
    "name": "Ali Queisi",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFRCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/28/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Ali Queisi",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07037",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Curtis Mallet-Prevost, Colt & Mosle LLP"
  },
  {
    "id": "temp_6607",
    "name": "Faisal S A Al Ashkar",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEZTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/26/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Faisal S A Al Ashkar",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-06707",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Morgan, Lewis & Bockius LLP (dubai Branch)"
  },
  {
    "id": "temp_6608",
    "name": "Adnan Bekdur",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFCCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/03/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Adnan Bekdur",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-05426",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "White & Case LLP-DIFC"
  },
  {
    "id": "temp_6609",
    "name": "Mohammed Nageeb Mansoor Al Oj",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1OCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/14/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Mohammed Nageeb Mansoor Al Oj",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07067",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Hourani & Partners Legal Consultancy FZCO"
  },
  {
    "id": "temp_6610",
    "name": "Valerio Vitelli",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFZWCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/12/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Valerio Vitelli",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07065",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Addleshaw Goddard (Middle East) LLP"
  },
  {
    "id": "temp_6611",
    "name": "Mohamed Magdy Abdelwadod Abdelhalim",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1NCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/15/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2022-11-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Mohamed Magdy Abdelwadod Abdelhalim",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03436",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "N/A"
  },
  {
    "id": "temp_6612",
    "name": "Jack Robertson Brasher",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEpSCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/21/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Jack Robertson Brasher",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07026",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "White & Case LLP-DIFC"
  },
  {
    "id": "temp_6613",
    "name": "Barnaby Gowrie",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEJHCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/30/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2021-01-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Barnaby Gowrie",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-04305",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "N/A"
  },
  {
    "id": "temp_6614",
    "name": "Bhargavi Jayant Gadre Jayant Shripad Gadre",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEJKCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/29/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Bhargavi Jayant Gadre Jayant Shripad Gadre",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07045",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Fichte & Co Legal Consultancy"
  },
  {
    "id": "temp_6615",
    "name": "Noor Al Heialy",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE5BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/28/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Noor Al Heialy",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03569",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Simmons & Simmons (Middle East) LLP-DIFC"
  },
  {
    "id": "temp_6616",
    "name": "Samantha Martin",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/02/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Samantha Martin",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03383",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Trowers & Hamlins LLP"
  },
  {
    "id": "temp_6617",
    "name": "Wael Ahmed Hassan Elhefnawi",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFdBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/06/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Wael Ahmed Hassan Elhefnawi",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07059",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "AMAL ALSUBAEI ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "temp_6618",
    "name": "Dina Issa",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIERJCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/18/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Dina Issa",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-04520",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Simmons & Simmons (Middle East) LLP-DIFC"
  },
  {
    "id": "temp_6619",
    "name": "ehab ibrahim ahmed salama",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEVJCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/06/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: ehab ibrahim ahmed salama",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07035",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "AYESHA AL JAZIRI ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "temp_6620",
    "name": "Danah Ahmad Mardini",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIERBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/06/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Danah Ahmad Mardini",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07030",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "CVML Limited"
  },
  {
    "id": "temp_6621",
    "name": "Panashe Jinga",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFBKCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/30/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Panashe Jinga",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07048",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Freshfields LLP DIFC"
  },
  {
    "id": "temp_6622",
    "name": "Nadir Mahjoub Ali",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE5NCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/10/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2020-06-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Nadir Mahjoub Ali",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03352",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "N/A"
  },
  {
    "id": "temp_6623",
    "name": "Amani Ali Fawaz",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/11/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Amani Ali Fawaz",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07086",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "DWF (Middle East) LLP"
  },
  {
    "id": "temp_6624",
    "name": "Hannah Mahmood",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/05/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Hannah Mahmood",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07097",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Allen Overy Shearman Sterling LLP"
  },
  {
    "id": "temp_6625",
    "name": "Vinodh Kumar Thankappan",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFZLCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/27/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Vinodh Kumar Thankappan",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07088",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "DSK Legal Services LLP - Dubai Branch"
  },
  {
    "id": "temp_6626",
    "name": "Edward Kramer",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEVLCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/25/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Edward Kramer",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00409",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Greenberg Traurig Limited"
  },
  {
    "id": "temp_6627",
    "name": "Alexander William James Mcmyn",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFXCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/22/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Alexander William James Mcmyn",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07014",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "White & Case LLP-DIFC"
  },
  {
    "id": "temp_6628",
    "name": "Mohammed Karbal",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1LCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/09/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2019-02-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Mohammed Karbal",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00458",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "N/A"
  },
  {
    "id": "temp_6629",
    "name": "John Skipper",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEpTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/11/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: John Skipper",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03820",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Mishcon de Reya LLP (DWTCA Branch)"
  },
  {
    "id": "temp_6630",
    "name": "DANISA NAIDOO",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEROCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/29/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: DANISA NAIDOO",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07041",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Baker Botts LLP Legal Consultants Dubai Branch"
  },
  {
    "id": "temp_6631",
    "name": "Stacey Rachel White",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNSCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/21/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Stacey Rachel White",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07075",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Ashurst LLP Legal Consultants Dubai Branch-DED"
  },
  {
    "id": "temp_6632",
    "name": "Jeremy Jonathan Thomas",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEpKCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/04/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Jeremy Jonathan Thomas",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07055",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Allen Overy Shearman Sterling LLP"
  },
  {
    "id": "temp_6633",
    "name": "Feteiha Mahmoud Feteiha Korra",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEZNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/25/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Feteiha Mahmoud Feteiha Korra",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-06741",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "TARISH ALMANSOORI ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "temp_6634",
    "name": "Ahmed ElMaamoun Mohamed ElShorbagy",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFFCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/08/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Ahmed ElMaamoun Mohamed ElShorbagy",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-05958",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Reed Smith LLP"
  },
  {
    "id": "temp_6635",
    "name": "Pabitra Parthapratim Dutta Parthapratim Nirmal Dutta",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFBQCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/12/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Pabitra Parthapratim Dutta Parthapratim Nirmal Dutta",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07064",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Fichte & Co Legal Consultancy"
  },
  {
    "id": "temp_6636",
    "name": "omar shafiey ahmed shafiey",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE9TCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/19/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: omar shafiey ahmed shafiey",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07074",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "EMAN ALRIFAI ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "temp_6637",
    "name": "Jonathan Kelly Huth",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEpLCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/07/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Jonathan Kelly Huth",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07061",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Charles Russell Speechlys LLP"
  },
  {
    "id": "temp_6638",
    "name": "mohamed wardany tawfek ali",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1XCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/11/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: mohamed wardany tawfek ali",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07080",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "DR GHAITH ALSUWAIDI ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "temp_6639",
    "name": "Eugene Bang",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEVCCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/10/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Eugene Bang",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07062",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Allen Overy Shearman Sterling LLP"
  },
  {
    "id": "temp_6640",
    "name": "Antoni Maria Roszkowski",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/28/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Antoni Maria Roszkowski",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07094",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Allen Overy Shearman Sterling LLP"
  },
  {
    "id": "temp_6641",
    "name": "Hasan Jasim Hasan Al Musawi",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhKCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/21/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Hasan Jasim Hasan Al Musawi",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07076",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Ashurst LLP Legal Consultants Dubai Branch-DED"
  },
  {
    "id": "temp_6642",
    "name": "Briony Kate Aston Mitchell",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEJLCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/31/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Briony Kate Aston Mitchell",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07101",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "LinkLaters LLP"
  },
  {
    "id": "temp_6643",
    "name": "Holly Faye Alderton",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhGCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/22/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Holly Faye Alderton",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07019",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Gibson Dunn & Crutcher LLP"
  },
  {
    "id": "temp_6644",
    "name": "Lorraine Korang Mintah",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIExLCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/22/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Lorraine Korang Mintah",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07017",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Watson, Farley & Williams (Middle East) LLP"
  },
  {
    "id": "temp_6645",
    "name": "Isabel Emily Bennett Lowson",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIElFCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/30/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Isabel Emily Bennett Lowson",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-04577",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Latham & Watkins LLP"
  },
  {
    "id": "temp_6646",
    "name": "Joshua Chia Sheng Rong",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEpDCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/29/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Joshua Chia Sheng Rong",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07044",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Herbert Smith Freehills Kramer LLP"
  },
  {
    "id": "temp_6647",
    "name": "Samir Mahmoud Abdelgawad Mohamed",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/12/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2019-10-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Samir Mahmoud Abdelgawad Mohamed",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03854",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "N/A"
  },
  {
    "id": "temp_6648",
    "name": "Oliver James Colston-Weeks",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE9KCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/22/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Oliver James Colston-Weeks",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-06975",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "CMS (UAE) LLP"
  },
  {
    "id": "temp_6649",
    "name": "Carter Hoppe",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIENICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/24/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2018-11-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Carter Hoppe",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00399",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "N/A"
  },
  {
    "id": "temp_6650",
    "name": "Rizwan Irfan Butt Irfan Mahmood Butt",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFJJCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/19/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Rizwan Irfan Butt Irfan Mahmood Butt",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-04435",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Simmons & Simmons (Middle East) LLP-DIFC"
  },
  {
    "id": "temp_6651",
    "name": "Fatma Betul Tumenci",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEZCCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/06/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Fatma Betul Tumenci",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07058",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Ashurst LLP-DIFC"
  },
  {
    "id": "temp_6652",
    "name": "Karolina Roszkowska",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEtSCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/29/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Karolina Roszkowska",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07042",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Clyde & Co LLP"
  },
  {
    "id": "temp_6653",
    "name": "Amr Samir Mohamed Abdelhamid Kasem",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/11/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Amr Samir Mohamed Abdelhamid Kasem",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07082",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "AL TAMIMI & COMPANY LIMITED"
  },
  {
    "id": "temp_6654",
    "name": "Danielle Gibson",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIERHCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/30/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Danielle Gibson",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07049",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Latham & Watkins LLP"
  },
  {
    "id": "temp_6655",
    "name": "James Griffin",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEpHCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/16/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2019-08-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: James Griffin",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00687",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "N/A"
  },
  {
    "id": "temp_6656",
    "name": "Michael Gerard Powner",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1HCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/26/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Michael Gerard Powner",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07084",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Charles Russell Speechlys LLP"
  },
  {
    "id": "temp_6657",
    "name": "SAEID HOSSEIN AHMADI",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/06/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: SAEID HOSSEIN AHMADI",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07057",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "PRESTIGE ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "temp_6658",
    "name": "Yan Yang",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFlZCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/28/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Yan Yang",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07039",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "SULAIMAN AL NAQBI ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "temp_6659",
    "name": "Jan Dirk L. De Corte",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEpECiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/22/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Jan Dirk L. De Corte",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07020",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Jones Day"
  },
  {
    "id": "temp_6660",
    "name": "Gennady Yurin",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEdZCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/17/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Gennady Yurin",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-05468",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "temp_6661",
    "name": "Renee Whitney Latoya Freeman",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFJXCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/06/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Renee Whitney Latoya Freeman",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07060",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Stephenson Harwood (Middle East) LLP"
  },
  {
    "id": "temp_6662",
    "name": "Seneba Jama",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNKCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/21/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Seneba Jama",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07077",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Covington & Burling LLP (Middle East)"
  },
  {
    "id": "temp_6663",
    "name": "mohannad salah ali mohamed",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1TCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/11/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: mohannad salah ali mohamed",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07090",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "BIN HAIDER ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "temp_6664",
    "name": "Johannes Gerhart Jonas",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEpHCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/22/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Johannes Gerhart Jonas",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07021",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Cohen & Gresser LLP"
  },
  {
    "id": "temp_6665",
    "name": "Makram Sayed Mohamed Elsoudany",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1TCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/06/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Makram Sayed Mohamed Elsoudany",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07025",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "HADEF & PARTNERS L.L.C"
  },
  {
    "id": "temp_6666",
    "name": "Simon Kanwardeep Perhar",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNLCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/31/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Simon Kanwardeep Perhar",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-05832",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "B S A AHMED BIN HAZEEM & ASSOCIATES LLP - DIFC"
  },
  {
    "id": "temp_6667",
    "name": "Parnika Chaturvedi",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFBDCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/22/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Parnika Chaturvedi",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01163",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Quinn Emanuel Urquhart & Sullivan UK LLP- Dubai Branch"
  },
  {
    "id": "temp_6668",
    "name": "Edward James Crosse",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEVKCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/23/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Edward James Crosse",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07034",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Simmons & Simmons (Middle East) LLP-DIFC"
  },
  {
    "id": "temp_6669",
    "name": "Joseph Sobhi Ezzat Abdelnour Girgis",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEpTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/30/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Joseph Sobhi Ezzat Abdelnour Girgis",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-06776",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Gateley UK LLP"
  },
  {
    "id": "temp_6670",
    "name": "Martin Skehill",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1TCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/28/2016 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Martin Skehill",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03302",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Hunton Andrews Kurth Ltd"
  },
  {
    "id": "temp_6671",
    "name": "Shurooq Zainal",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNaCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/14/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Shurooq Zainal",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00329",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Shurooq Zainal Legal Consultants LLC"
  },
  {
    "id": "temp_6672",
    "name": "Ramy Osama Ramadan",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFJPCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/28/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Ramy Osama Ramadan",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-04143",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Dentons & Co Dubai Branch-DED"
  },
  {
    "id": "temp_6673",
    "name": "David Trem Lekashingo",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIERUCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/21/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: David Trem Lekashingo",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07028",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Allen Overy Shearman Sterling LLP"
  },
  {
    "id": "temp_6674",
    "name": "KIMIA KALANTARIAN",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEtLCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/20/2018 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: KIMIA KALANTARIAN",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-04272",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Bird & Bird (MEA) LLP"
  },
  {
    "id": "temp_6675",
    "name": "Tania Ramesh Kumar Singla Ramesh Kumar Amrit Paul",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFRSCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/30/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Tania Ramesh Kumar Singla Ramesh Kumar Amrit Paul",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07047",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Trowers & Hamlins LLP"
  },
  {
    "id": "temp_6676",
    "name": "Ban George William Lahham",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEJHCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/26/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Ban George William Lahham",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07085",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Clyde & Co LLP"
  },
  {
    "id": "temp_6677",
    "name": "Fawzi Ramzi Zeini",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEZSCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/03/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Fawzi Ramzi Zeini",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-05785",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "DLA Piper Middle East LLP"
  },
  {
    "id": "temp_6678",
    "name": "Tomas Furlong",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFRGCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/01/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Tomas Furlong",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-06994",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Herbert Smith Freehills Kramer LLP"
  },
  {
    "id": "temp_6679",
    "name": "Mohamed Ahmed Mohamed",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/10/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Mohamed Ahmed Mohamed",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02806",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "AMAL ALSUBAEI ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "temp_6680",
    "name": "Himanshu Goswami Dinesh Kumar Goswami",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhHCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/28/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Himanshu Goswami Dinesh Kumar Goswami",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07092",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "KHALED ALMARRI & PARTNERS& LEGAL CONSULTATIONS"
  },
  {
    "id": "temp_6681",
    "name": "Pouneh saatnia",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFBTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/04/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Pouneh saatnia",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07052",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "AZZA EBRAHIM HASAN ALMULLA ADVOCATES AND LEGAL CONSULTANTS"
  },
  {
    "id": "temp_6682",
    "name": "Shiva Alireza Dakhili",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/22/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Shiva Alireza Dakhili",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07018",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Latham & Watkins LLP"
  },
  {
    "id": "temp_6683",
    "name": "Jack William Kewley",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEpXCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/17/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Jack William Kewley",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07070",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "KBH Limited"
  },
  {
    "id": "temp_6684",
    "name": "Abigail Sian Tobin",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/29/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Abigail Sian Tobin",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07046",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Support Legal ( DIFC) Limited"
  },
  {
    "id": "temp_6685",
    "name": "Evelina Gurtskaya",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEVHCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/18/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Evelina Gurtskaya",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-06047",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "AMAL ALBASTAKI ADVOCATES & LEGAL CONSULTANCY"
  },
  {
    "id": "temp_6686",
    "name": "Hiba Barakeh",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhCCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/04/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Hiba Barakeh",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07054",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "MOAZA AL KHADAR ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "temp_6687",
    "name": "Alfie Foster Cranmer",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFGCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/30/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Alfie Foster Cranmer",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07050",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Pinsent Masons  LLP (DWTCA Branch)"
  },
  {
    "id": "temp_6688",
    "name": "HANY ATEF HUSSEIN ELASHHAT",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/21/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: HANY ATEF HUSSEIN ELASHHAT",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07078",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "AL-KABBAN & ASSOCIATES ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "temp_6689",
    "name": "Mohammed Mansoor Yasin Yasin",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1NCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/10/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2020-09-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Mohammed Mansoor Yasin Yasin",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-04437",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "N/A"
  },
  {
    "id": "temp_6690",
    "name": "Khaled Mossad Abd el monem Ebid",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEtNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/17/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Khaled Mossad Abd el monem Ebid",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07068",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "RASHID KHALIL OBAID ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "temp_6691",
    "name": "HAYAT AHMAD",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/22/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: HAYAT AHMAD",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-06985",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "AL TAMIMI & COMPANY LIMITED"
  },
  {
    "id": "temp_6692",
    "name": "Ali Naji Nasser Al Masaabi",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFOCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/20/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Ali Naji Nasser Al Masaabi",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-04317",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Latham & Watkins LLP"
  },
  {
    "id": "temp_6693",
    "name": "EVGENY YAFASOV",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEVZCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/04/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: EVGENY YAFASOV",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-06888",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "HAMDAN ALSHAMSI LAWYER & LEGAL CONSULTANTS"
  },
  {
    "id": "temp_6694",
    "name": "Anda Musaraj",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/28/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Anda Musaraj",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07091",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "ABDELAZIZ AL KHAMIRI ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "temp_6695",
    "name": "Ferig Atef Mohamed Hassan Ferig",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEZBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/29/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Ferig Atef Mohamed Hassan Ferig",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03836",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "DAR AL ADALAH ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "temp_6696",
    "name": "AHMED MOHAMED MOHAMED ELDAKHAKHNY",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/06/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: AHMED MOHAMED MOHAMED ELDAKHAKHNY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07032",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "GALAL HUSSEIN LEGAL CONSULTANCIES AND ADVOCATES"
  },
  {
    "id": "temp_6697",
    "name": "Mahdi Belal Alabd",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1CCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/06/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Mahdi Belal Alabd",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07029",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "AMANI ALKINDI ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "temp_6698",
    "name": "Ibrahim Diallo",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIElECiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/19/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Ibrahim Diallo",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07072",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Allen Overy Shearman Sterling LLP"
  },
  {
    "id": "temp_6699",
    "name": "Christopher  Gambrill",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIENHCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/16/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2019-08-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Christopher  Gambrill",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00686",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "N/A"
  },
  {
    "id": "temp_6700",
    "name": "Bita Mozafari",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEJNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/22/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Bita Mozafari",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07023",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Norton Rose Fullbright (Middle East) LLP"
  },
  {
    "id": "temp_6701",
    "name": "Sultan Nasser Mohamed Al-Shidhani",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNOCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/11/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Sultan Nasser Mohamed Al-Shidhani",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07089",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Allen Overy Shearman Sterling LLP"
  },
  {
    "id": "temp_6702",
    "name": "Wing Kit Winnie Chan",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFdLCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/28/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Wing Kit Winnie Chan",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07038",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Allen Overy Shearman Sterling LLP"
  },
  {
    "id": "temp_6703",
    "name": "Mahmoud Mohamed Hamed Ismail Hamed",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1NCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/25/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Mahmoud Mohamed Hamed Ismail Hamed",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07081",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "HOURANI & PATNERS"
  },
  {
    "id": "temp_6704",
    "name": "William Neil Stewart",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFdOCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/22/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: William Neil Stewart",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07016",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Watson, Farley & Williams (Middle East) LLP"
  },
  {
    "id": "temp_6705",
    "name": "Khalid Mohammed Amin M Dahlawi",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEtNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/04/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Khalid Mohammed Amin M Dahlawi",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-06535",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Allen Overy Shearman Sterling LLP"
  },
  {
    "id": "temp_6706",
    "name": "Amardeep Shoker",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/23/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Amardeep Shoker",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-04670",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Ashurst LLP-DIFC"
  },
  {
    "id": "temp_6707",
    "name": "Soham Kumar Mohit Sat Kumar",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNLCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/22/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Soham Kumar Mohit Sat Kumar",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07011",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "KHALED ALMARRI & PARTNERS& LEGAL CONSULTATIONS"
  },
  {
    "id": "temp_6708",
    "name": "Pavel Kocian",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFBLCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/22/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Pavel Kocian",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07031",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Addleshaw Goddard (Middle East) LLP"
  },
  {
    "id": "temp_6709",
    "name": "Victoria Kate Wyer",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFZLCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/21/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Victoria Kate Wyer",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07027",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Dentons & Co Dubai Branch-DED"
  },
  {
    "id": "temp_6710",
    "name": "Firas Al-Hamed",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEZBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/23/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Firas Al-Hamed",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07033",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Baker & Mckenzie LLP"
  },
  {
    "id": "temp_6711",
    "name": "Kateryna Frolova",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEtGCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/09/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Kateryna Frolova",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07098",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Clyde & Co LLP"
  },
  {
    "id": "temp_6712",
    "name": "Hadi Albyr Melki",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/17/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Hadi Albyr Melki",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07069",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "KHALID ABDALLA ALTAMIMI ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "temp_6713",
    "name": "Sinead Quigley",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNRCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/22/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Sinead Quigley",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03612",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Rouse & Co International Limited (Dubai Branch)"
  },
  {
    "id": "temp_6714",
    "name": "Emma Louise Brown",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEVMCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/11/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Emma Louise Brown",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-05794",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Stephenson Harwood (Middle East) LLP"
  },
  {
    "id": "temp_6715",
    "name": "VICTORIA EVELYN SMYLIE",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFZFCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/12/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: VICTORIA EVELYN SMYLIE",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03928",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "DLA Piper Middle East LLP"
  },
  {
    "id": "temp_6716",
    "name": "Tushaar Garg",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFRHCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/11/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Tushaar Garg",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07063",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "LinkLaters LLP"
  },
  {
    "id": "temp_6717",
    "name": "Maria Ivanova",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1JCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/03/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2027-01-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Maria Ivanova",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-04309",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Watson, Farley & Williams (Middle East) LLP"
  },
  {
    "id": "temp_6718",
    "name": "Fawzi Ghassan Mashal",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEZHCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/06/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Fawzi Ghassan Mashal",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-06578",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Morgan, Lewis & Bockius LLP (dubai Branch)"
  },
  {
    "id": "temp_6719",
    "name": "Josh Michael Farquharson",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEpNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/04/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Josh Michael Farquharson",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07053",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Simmons & Simmons (Middle East) LLP-DIFC"
  },
  {
    "id": "temp_6720",
    "name": "Ayman Makram Abdelfattah Abdelkhalek",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/20/2011 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Ayman Makram Abdelfattah Abdelkhalek",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01558",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "HAMAD SAEED ALKETBI ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "temp_6721",
    "name": "Annett Anna Dr. Kato",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/21/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Annett Anna Dr. Kato",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02130",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Anett Pertl Legal Consultants"
  },
  {
    "id": "temp_6722",
    "name": "Joanne Strain",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEpTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/22/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Joanne Strain",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00968",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Quinn Emanuel Urquhart & Sullivan UK LLP- Dubai Branch"
  },
  {
    "id": "temp_6723",
    "name": "Mohsen Mohammed Mohsen Al Khubani",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1NCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/24/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Mohsen Mohammed Mohsen Al Khubani",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07079",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "SAUD ALSHEBLI ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "temp_6724",
    "name": "Saher Aziz Khan Khan Aziz Dawood",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/22/2023 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Saher Aziz Khan Khan Aziz Dawood",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-06086",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Simmons & Simmons (Middle East) LLP-DIFC"
  },
  {
    "id": "temp_6725",
    "name": "Georgios Chrysospathis",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEdDCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/16/2022 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Georgios Chrysospathis",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-05276",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Ashurst LLP-DIFC"
  },
  {
    "id": "temp_6726",
    "name": "Jessika Stadwick",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEpTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/12/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Jessika Stadwick",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01270",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "DWF (Middle East) LLP"
  },
  {
    "id": "temp_6727",
    "name": "Hany Maher Marghany Ibrahim",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/11/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Hany Maher Marghany Ibrahim",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07095",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Habib Al Mulla & Partners ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "temp_6728",
    "name": "Rajwah Al Kuhaymi",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFJBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/25/2012 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2020-02-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Rajwah Al Kuhaymi",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02173",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "N/A"
  },
  {
    "id": "temp_6729",
    "name": "Yara Nassib Akoum",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFlOCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/31/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Yara Nassib Akoum",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07051",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Hugh Fraser International Legal Consultancy"
  },
  {
    "id": "temp_6730",
    "name": "Lina Ehab Mohammed Elsawy",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIExFCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/19/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Lina Ehab Mohammed Elsawy",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07073",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "MOHAMED ALI ALHAMMADI ADVOCATES & LEGAL CONSULTANT"
  },
  {
    "id": "temp_6731",
    "name": "Shouq Haider Abdul Rahman Al Majali",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNICiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/11/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Shouq Haider Abdul Rahman Al Majali",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07087",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Squire Patton Boggs (MEA) LLP"
  },
  {
    "id": "temp_6732",
    "name": "Charlotte Theresa Oneill",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIENUCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/22/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Charlotte Theresa Oneill",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07012",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Walkers (Middle East) LLP"
  },
  {
    "id": "temp_6733",
    "name": "Aleksei Batishchev",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFCCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/17/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Aleksei Batishchev",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-05502",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Norton Rose Fullbright (Middle East) LLP"
  },
  {
    "id": "temp_6734",
    "name": "Patricia do Carmo Santos Correia",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFBECiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/05/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Patricia do Carmo Santos Correia",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07056",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Kennedys Dubai LLP"
  },
  {
    "id": "temp_6735",
    "name": "Daniel Christopher Smailes",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIERDCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/13/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Daniel Christopher Smailes",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07066",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Clifford Chance LLP-DIFC"
  },
  {
    "id": "temp_6736",
    "name": "Sara Samir Kamal Farid",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFNTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/16/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Sara Samir Kamal Farid",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07022",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "DWF (Middle East) LLP"
  },
  {
    "id": "temp_6737",
    "name": "Olivia Mary Laura Rice Mellor",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE9NCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/22/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Olivia Mary Laura Rice Mellor",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07015",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Stephenson Harwood (Middle East) LLP"
  },
  {
    "id": "temp_6738",
    "name": "Kholood mohmmad salari zadeh",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEtNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/06/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Kholood mohmmad salari zadeh",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07040",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "AL SAYYAH ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "temp_6739",
    "name": "Abdo abou nasr",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/30/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Abdo abou nasr",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-05873",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "AHMED HASSAN ALMAAZMI ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "temp_6740",
    "name": "Aysegul Wallis",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFXCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/04/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Aysegul Wallis",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07096",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Stephenson Harwood (Middle East) LLP"
  },
  {
    "id": "temp_6741",
    "name": "Mohamed Mahmoud Ali Metawea",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE1NCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/19/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Mohamed Mahmoud Ali Metawea",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07071",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "AL TAMIMI & COMPANY LIMITED"
  },
  {
    "id": "temp_6742",
    "name": "Anushri Uttarwar Srinivas Uttarwar",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFVCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/10/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Anushri Uttarwar Srinivas Uttarwar",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07013",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "DLA Piper Middle East LLP"
  },
  {
    "id": "temp_6743",
    "name": "Victoria Josephine May Warner",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFZKCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/10/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Victoria Josephine May Warner",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07099",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Allen Overy Shearman Sterling LLP"
  },
  {
    "id": "temp_6744",
    "name": "Omar Abdulraheem Tayeb",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE9BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/06/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Omar Abdulraheem Tayeb",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07036",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Eversheds Sutherland (International LLP) Dubai Branch"
  },
  {
    "id": "temp_6745",
    "name": "Duane Matthew Keighran",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIERNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/05/2019 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2021-04-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Duane Matthew Keighran",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-04471",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "N/A"
  },
  {
    "id": "temp_6746",
    "name": "HAMAD DEHAI AL MUQBALI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhECiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/30/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: HAMAD DEHAI AL MUQBALI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "ADF-2025-770",
    "offices": [
      {
        "address": "Office No. G06-514,THE EXCHANGE TOWER,Busines",
        "phone": "97100000000",
        "email": "hamad9994811@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "address": "Office No. G06-514,THE EXCHANGE TOWER,Busines",
    "phone": "97100000000",
    "email": "hamad9994811@gmail.com"
  },
  {
    "id": "temp_6747",
    "name": "DR ABDULRAHMAN NASSER ALBUHALEEQA ADVOCATES & LEGAL CONSULTANTS",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIERBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/19/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: DR ABDULRAHMAN NASSER ALBUHALEEQA ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "ADF-2024-751-2",
    "offices": [
      {
        "address": "Office No. 1305,Grosvenor Tower,Bur Dubai - B",
        "phone": "97142555054",
        "email": "vipabdul@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "address": "Office No. 1305,Grosvenor Tower,Bur Dubai - B",
    "phone": "97142555054",
    "email": "vipabdul@gmail.com"
  },
  {
    "id": "temp_6748",
    "name": "Nashwa Ahmed Mohamed",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIE5BCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/04/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Nashwa Ahmed Mohamed",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "2048",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "OUTSIDE DUBAI FIRM"
  },
  {
    "id": "temp_6749",
    "name": "Humaid Mohamed Saleh Ali Al-ALi",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhNCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/25/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Humaid Mohamed Saleh Ali Al-ALi",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "2119",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "MOHAMMED AL HASHIMI ADVOCATES AND LEGAL CONSU"
  },
  {
    "id": "temp_6750",
    "name": "Ahmed Juma Hassan Mohamed Alraeesi",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFKCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/02/2017 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Ahmed Juma Hassan Mohamed Alraeesi",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "1228",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "N/A"
  },
  {
    "id": "temp_6751",
    "name": "Anfal Abdulla Khalifa Abdulla Alkaabi",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/30/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Anfal Abdulla Khalifa Abdulla Alkaabi",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "2038",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "ZAYED ALMAZROUEI ADVOCATES & LEGAL CONSULTANT"
  },
  {
    "id": "temp_6752",
    "name": "Khamis Obaid Mohammed Khamis Al Zaabi",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEtPCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/24/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Khamis Obaid Mohammed Khamis Al Zaabi",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "2052",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Sara Alsaedi Advocates and Legal Consultants"
  },
  {
    "id": "temp_6753",
    "name": "Hamad Younis Mohamed Abdalla Almaazmi",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhZCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/04/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Hamad Younis Mohamed Abdalla Almaazmi",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "2049",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "MOHAMMED AHMED ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "temp_6754",
    "name": "rana luai sadi hussain alqadri",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIFJMCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/20/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: rana luai sadi hussain alqadri",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "2044",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "MARWA ALRIYAMI ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "temp_6755",
    "name": "hamed salem ali salem alalawi",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEhTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/15/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: hamed salem ali salem alalawi",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "1601",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "OUTSIDE DUBAI FIRM"
  },
  {
    "id": "temp_6756",
    "name": "Amna ahmad mahmoud hasan alhammadi",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/13/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Amna ahmad mahmoud hasan alhammadi",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "2041",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "ADVOCATES UNIT"
  },
  {
    "id": "temp_6757",
    "name": "AHMAD SAEED JUMA MUBARAK ALSUWAIDI",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFTCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/20/2024 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: AHMAD SAEED JUMA MUBARAK ALSUWAIDI",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "2043",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "OUTSIDE DUBAI FIRM"
  },
  {
    "id": "temp_6758",
    "name": "Bader Ismail Hassan Al Ansari",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEJJCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/04/2014 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2020-03-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Bader Ismail Hassan Al Ansari",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "938",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "N/A"
  },
  {
    "id": "temp_6759",
    "name": "Ahmed Abdelkhalik Mohamed Abdelkhalik",
    "title": "Legal Professional",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzFlNDBhZjtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMxZTQwYWY7c3RvcC1vcGFjaXR5OjAuOCIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjU4IiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgogICAgICAgICAgPHRleHQgeD0iNjAiIHk9IjcwIiBmb250LWZhbWlseT0iSW50ZXIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgc2Fucy1zZXJpZiIgCiAgICAgICAgICAgICAgICBmb250LXNpemU9IjMyIiBmb250LXdlaWdodD0iNjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgIEFBCiAgICAgICAgICA8L3RleHQ+CiAgICAgICAgPC9zdmc+",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/29/2025 00:00:00",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed"
    ],
    "description": "Licensed legal professional: Ahmed Abdelkhalik Mohamed Abdelkhalik",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07100",
    "offices": [
      {
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "HAMAD SAEED ALKETBI ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "4496038f-ae83-41b4-8f0c-705d6bfd0f73",
    "slug": "oliver-james-colston-weeks",
    "name": "OLIVER JAMES COLSTON WEEKS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5PSjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/10/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: OLIVER JAMES COLSTON WEEKS",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-06975",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_4496038f-ae83-41b4-8f0c-705d6bfd0f73",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "eaf9612c-d8b8-44a5-b176-f7fcee39a30b",
    "slug": "olivia-mary-laura-rice-mellor",
    "name": "OLIVIA MARY LAURA RICE MELLOR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5PTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/10/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: OLIVIA MARY LAURA RICE MELLOR",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07015",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_eaf9612c-d8b8-44a5-b176-f7fcee39a30b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "b5d9fda4-3d0c-4b1f-a37f-7f77377c1d5d",
    "slug": "omar-abdul-raheem-tayeb-mohamed-ebrahim",
    "name": "OMAR ABDUL RAHEEM TAYEB MOHAMED EBRAHIM",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5PQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/10/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: OMAR ABDUL RAHEEM TAYEB MOHAMED EBRAHIM",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07036",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_b5d9fda4-3d0c-4b1f-a37f-7f77377c1d5d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "135694b1-c865-4abc-afec-de16abf90206",
    "slug": "parnika-chaturvedi-girish-chandra-chaturvedi",
    "name": "PARNIKA CHATURVEDI GIRISH CHANDRA CHATURVEDI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5QQzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/10/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: PARNIKA CHATURVEDI GIRISH CHANDRA CHATURVEDI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01163",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_135694b1-c865-4abc-afec-de16abf90206",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "39adf721-eb9a-4e7e-8bf4-feef0c26ebf2",
    "slug": "pavel-kocian",
    "name": "PAVEL KOCIAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5QSzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/10/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: PAVEL KOCIAN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07031",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_39adf721-eb9a-4e7e-8bf4-feef0c26ebf2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "62c21d29-6a0e-4605-b41a-4a4ca0726a58",
    "slug": "saher-aziz-khan",
    "name": "SAHER AZIZ KHAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/11/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: SAHER AZIZ KHAN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-06086",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_62c21d29-6a0e-4605-b41a-4a4ca0726a58",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "b5e4238c-97f8-44aa-b17d-8b1e093ab523",
    "slug": "samantha-tamsin-rosanne-martin",
    "name": "SAMANTHA TAMSIN ROSANNE MARTIN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TVDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/04/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: SAMANTHA TAMSIN ROSANNE MARTIN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03383",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_b5e4238c-97f8-44aa-b17d-8b1e093ab523",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "9245f48c-d4d2-4bea-b89f-03692afc550c",
    "slug": "sara-samir-kamal-farid",
    "name": "SARA SAMIR KAMAL FARID",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/10/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: SARA SAMIR KAMAL FARID",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07022",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_9245f48c-d4d2-4bea-b89f-03692afc550c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "ec2d3d17-141d-451b-b4f4-b86a7db0cc46",
    "slug": "shiva-alireza-dakhili",
    "name": "SHIVA ALIREZA DAKHILI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/10/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: SHIVA ALIREZA DAKHILI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07018",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_ec2d3d17-141d-451b-b4f4-b86a7db0cc46",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "e58e38fd-794a-49b1-982e-60401781cc20",
    "slug": "simon-kanwardeep-perhar",
    "name": "SIMON KANWARDEEP PERHAR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TSzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/10/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: SIMON KANWARDEEP PERHAR",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-05832",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_e58e38fd-794a-49b1-982e-60401781cc20",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "ce97ba9c-4686-4ed5-b910-64d2cfa4af28",
    "slug": "sinead-mary-quigley",
    "name": "SINEAD MARY QUIGLEY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/10/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: SINEAD MARY QUIGLEY",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03612",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_ce97ba9c-4686-4ed5-b910-64d2cfa4af28",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "3ece4ad7-c54b-46af-9a06-6e3b8554ff31",
    "slug": "soham-kumar-mohit-sat-kumar",
    "name": "SOHAM KUMAR MOHIT SAT KUMAR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TSzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/10/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: SOHAM KUMAR MOHIT SAT KUMAR",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07011",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_3ece4ad7-c54b-46af-9a06-6e3b8554ff31",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "7f7cce12-27d8-4577-84d7-70e7211f872e",
    "slug": "tomas-patrick-kirby-furlong",
    "name": "TOMAS PATRICK KIRBY FURLONG",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5UUDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/09/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: TOMAS PATRICK KIRBY FURLONG",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-06994",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_7f7cce12-27d8-4577-84d7-70e7211f872e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "75a6d686-2833-4161-a0bc-52cba1439ecb",
    "slug": "victoria-evelyn-gee",
    "name": "VICTORIA EVELYN GEE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5WRTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/11/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: VICTORIA EVELYN GEE",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03928",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_75a6d686-2833-4161-a0bc-52cba1439ecb",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "b1f0e22f-5610-4404-9aa2-1b5dd72718eb",
    "slug": "victoria-kate-wyer",
    "name": "VICTORIA KATE WYER",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5WSzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/10/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: VICTORIA KATE WYER",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07027",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_b1f0e22f-5610-4404-9aa2-1b5dd72718eb",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "14481271-909f-4595-8797-d769bacc02ac",
    "slug": "william-neil-stewart",
    "name": "WILLIAM NEIL STEWART",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5XTjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/10/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: WILLIAM NEIL STEWART",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07016",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_14481271-909f-4595-8797-d769bacc02ac",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "5d9d7192-ca3b-4908-8934-d368a3cb2423",
    "slug": "alfie-foster-cranmer",
    "name": "ALFIE FOSTER CRANMER",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BRjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/10/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ALFIE FOSTER CRANMER",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07050",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_5d9d7192-ca3b-4908-8934-d368a3cb2423",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "b21a5005-4a8a-4439-b65d-2371a1b1044f",
    "slug": "ali-queisi",
    "name": "ALI QUEISI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BUTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/10/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ALI QUEISI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07037",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_b21a5005-4a8a-4439-b65d-2371a1b1044f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "8fb27032-14c1-4421-9ecd-d11c8d9208ed",
    "slug": "anushri-uttarwar-srinivas-uttarwar",
    "name": "ANUSHRI UTTARWAR SRINIVAS UTTARWAR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BVTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/10/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ANUSHRI UTTARWAR SRINIVAS UTTARWAR",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07013",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_8fb27032-14c1-4421-9ecd-d11c8d9208ed",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "dcea7374-c696-44ed-85d1-d8dfbfa56c72",
    "slug": "bhargavi-jayant-gadre-jayant-shripad-gadre",
    "name": "BHARGAVI JAYANT GADRE JAYANT SHRIPAD GADRE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5CSjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/10/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: BHARGAVI JAYANT GADRE JAYANT SHRIPAD GADRE",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07045",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_dcea7374-c696-44ed-85d1-d8dfbfa56c72",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "b5faea46-e25c-49a0-9f50-85a4293eb5b5",
    "slug": "danielle-gibson",
    "name": "DANIELLE GIBSON",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ERzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/10/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: DANIELLE GIBSON",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07049",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_b5faea46-e25c-49a0-9f50-85a4293eb5b5",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "7fd1e8d6-049c-413f-bea6-ab7dac9fe24d",
    "slug": "danisa-naidoo",
    "name": "DANISA NAIDOO",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ETjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/10/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: DANISA NAIDOO",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07041",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_7fd1e8d6-049c-413f-bea6-ab7dac9fe24d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "2984e539-c11c-4bbf-b243-d5a9228a4276",
    "slug": "eugene-bang",
    "name": "EUGENE BANG",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5FQjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/11/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: EUGENE BANG",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07062",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_2984e539-c11c-4bbf-b243-d5a9228a4276",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "398b7bb6-fd29-43f6-b1ee-7f56a4fdfe40",
    "slug": "fatma-betul-tumenci",
    "name": "FATMA BETUL TUMENCI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5GQjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/11/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: FATMA BETUL TUMENCI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07058",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_398b7bb6-fd29-43f6-b1ee-7f56a4fdfe40",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "13a71d46-18c0-4c2b-a201-b22ad4d66931",
    "slug": "firas-al-hamed",
    "name": "FIRAS AL HAMED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5GQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/10/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: FIRAS AL HAMED",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07033",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_13a71d46-18c0-4c2b-a201-b22ad4d66931",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "f13c9c6f-4694-4d1a-8c76-9ae06b6ec7d0",
    "slug": "hiba-barakeh",
    "name": "HIBA BARAKEH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5IQjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/11/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: HIBA BARAKEH",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07054",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_f13c9c6f-4694-4d1a-8c76-9ae06b6ec7d0",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "6da70aff-9b7f-472f-b71c-a734b6629eca",
    "slug": "jeremy-jonathan-thomas",
    "name": "JEREMY JONATHAN THOMAS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5KSjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/11/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: JEREMY JONATHAN THOMAS",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07055",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_6da70aff-9b7f-472f-b71c-a734b6629eca",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "bb132fd7-0c63-42f9-b2bf-43d33f66fb67",
    "slug": "jonathan-kelly-huth",
    "name": "JONATHAN KELLY HUTH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5KSzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/11/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: JONATHAN KELLY HUTH",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07061",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_bb132fd7-0c63-42f9-b2bf-43d33f66fb67",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "13818a99-2fda-4ee6-8753-e0e70e3d768d",
    "slug": "josh-michael-farquharson",
    "name": "JOSH MICHAEL FARQUHARSON",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5KTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/11/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: JOSH MICHAEL FARQUHARSON",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07053",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_13818a99-2fda-4ee6-8753-e0e70e3d768d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "4b26407a-5c9d-4b28-ae8b-54ed2c5a2be5",
    "slug": "joshua-chia-sheng-rong",
    "name": "JOSHUA CHIA SHENG RONG",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5KQzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/10/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: JOSHUA CHIA SHENG RONG",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07044",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_4b26407a-5c9d-4b28-ae8b-54ed2c5a2be5",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "cf626239-539d-49a9-af4f-9862306bb7e2",
    "slug": "karolina-roszkowska",
    "name": "KAROLINA ROSZKOWSKA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5LUjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/10/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: KAROLINA ROSZKOWSKA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07042",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_cf626239-539d-49a9-af4f-9862306bb7e2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "2694aa82-4ffc-4385-bf0e-c486938379b7",
    "slug": "mohamed-alaaeldin-lotfy-ramadan-elabd",
    "name": "MOHAMED ALAAELDIN LOTFY RAMADAN ELABD",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/06/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MOHAMED ALAAELDIN LOTFY RAMADAN ELABD",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-06881",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_2694aa82-4ffc-4385-bf0e-c486938379b7",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "ba56c82e-c39b-472a-ad72-3ef181063dd9",
    "slug": "panashe-jinga",
    "name": "PANASHE JINGA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5QSjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/10/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: PANASHE JINGA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07048",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_ba56c82e-c39b-472a-ad72-3ef181063dd9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "daa8dba7-60f7-40a6-9d36-63d083530ce0",
    "slug": "patricia-do-carmo-santos-correia",
    "name": "PATRICIA DO CARMO SANTOS CORREIA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5QRDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/11/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: PATRICIA DO CARMO SANTOS CORREIA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07056",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_daa8dba7-60f7-40a6-9d36-63d083530ce0",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "cd990985-e747-46ae-a434-bd327a3ab55d",
    "slug": "pouneh-saatnia",
    "name": "POUNEH SAATNIA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5QUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/11/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: POUNEH SAATNIA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07052",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_cd990985-e747-46ae-a434-bd327a3ab55d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "c7e95ed4-bb9b-4b8d-b07e-5d5cdd999324",
    "slug": "renee-whitney-latoya-freeman",
    "name": "RENEE WHITNEY LATOYA FREEMAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5SVzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/11/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: RENEE WHITNEY LATOYA FREEMAN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07060",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_c7e95ed4-bb9b-4b8d-b07e-5d5cdd999324",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "e1e6cba0-6bf3-4fc0-940b-afa0bd6f03f9",
    "slug": "saeid-hossein-ahmadi",
    "name": "SAEID HOSSEIN AHMADI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TSDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/11/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: SAEID HOSSEIN AHMADI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07057",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_e1e6cba0-6bf3-4fc0-940b-afa0bd6f03f9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "d79737ed-3ed6-4216-99cf-57949d701229",
    "slug": "sergei-kalinin",
    "name": "SERGEI KALININ",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TSzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/10/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: SERGEI KALININ",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07043",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_d79737ed-3ed6-4216-99cf-57949d701229",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "e885c76e-3d6b-4ece-9769-eafe9c22afa4",
    "slug": "tania-ramesh-kumar-singla-ramesh-kumar-amrit-paul-singla",
    "name": "TANIA RAMESH KUMAR SINGLA RAMESH KUMAR AMRIT PAUL SINGLA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5UUjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/10/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: TANIA RAMESH KUMAR SINGLA RAMESH KUMAR AMRIT PAUL SINGLA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07047",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_e885c76e-3d6b-4ece-9769-eafe9c22afa4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "e5aa52e8-7e21-4842-8c8c-eb363e91a122",
    "slug": "tushaar-garg",
    "name": "TUSHAAR GARG",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5URzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/11/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: TUSHAAR GARG",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07063",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_e5aa52e8-7e21-4842-8c8c-eb363e91a122",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "ee546ece-a901-4001-90a9-16c1b06ed549",
    "slug": "wael-ahmed-hassan-elhefnawi",
    "name": "WAEL AHMED HASSAN ELHEFNAWI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5XQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/11/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: WAEL AHMED HASSAN ELHEFNAWI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07059",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_ee546ece-a901-4001-90a9-16c1b06ed549",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "3543ce8b-4a72-46bb-ae4a-0196fcfb5227",
    "slug": "wing-kit-winnie-chan",
    "name": "WING KIT WINNIE CHAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5XSzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/10/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: WING KIT WINNIE CHAN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07038",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_3543ce8b-4a72-46bb-ae4a-0196fcfb5227",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "86b4f928-6ea5-4a5b-85fd-ebdf6a34b6d2",
    "slug": "yan-yang",
    "name": "YAN YANG",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ZWTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/10/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: YAN YANG",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07039",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_86b4f928-6ea5-4a5b-85fd-ebdf6a34b6d2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "dff39d97-493b-4970-8bb6-c18772320f4c",
    "slug": "yara-nassib-akoum",
    "name": "YARA NASSIB AKOUM",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ZTjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/10/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: YARA NASSIB AKOUM",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07051",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_dff39d97-493b-4970-8bb6-c18772320f4c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "2f904eaf-b3bf-4730-b537-0d8146d00e3a",
    "slug": "farrukh-khan",
    "name": "FARRUKH KHAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5GSzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Commercial Transactions-Commercial Contracts",
      "Commercial Transactions-Banking Operations"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/01/2026",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: FARRUKH KHAN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07108",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_2f904eaf-b3bf-4730-b537-0d8146d00e3a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "2dd6e9bc-822b-49c0-80aa-435f55f2dc73",
    "slug": "ahmed-ahmed",
    "name": "AHMED AHMED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts",
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/12/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: AHMED AHMED",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07116",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_2dd6e9bc-822b-49c0-80aa-435f55f2dc73",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "e3a21dde-97a4-4534-83aa-cf9fe4678348",
    "slug": "ahmed-abdelkhalik-mohamed-abdelkhalik",
    "name": "AHMED ABDELKHALIK MOHAMED ABDELKHALIK",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/12/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: AHMED ABDELKHALIK MOHAMED ABDELKHALIK",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07100",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_e3a21dde-97a4-4534-83aa-cf9fe4678348",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "d3744f61-a6bc-48b2-84d7-53cd8877b4ec",
    "slug": "nour-abbas",
    "name": "NOUR ABBAS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5OQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Commercial Transactions-Commercial Contracts",
      "Commercial Transactions-Commercial Companies"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/01/2026",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: NOUR ABBAS",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07117",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_d3744f61-a6bc-48b2-84d7-53cd8877b4ec",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "138965cb-ce10-4c1d-a43a-b2cc0b320e64",
    "slug": "abbas-kermalli",
    "name": "ABBAS KERMALLI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BSzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Commercial Transactions-Commercial Mortgage",
      "Commercial Transactions-Consumer protection"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/01/2026",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ABBAS KERMALLI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07115",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_138965cb-ce10-4c1d-a43a-b2cc0b320e64",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "d92a47b9-95df-47ff-b7ed-b81cbcaed53e",
    "slug": "vinodh-kumar-thankappan-kakkadiyil-narayanan-thankappan-nair",
    "name": "VINODH KUMAR THANKAPPAN KAKKADIYIL NARAYANAN THANKAPPAN NAIR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5WSzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/11/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: VINODH KUMAR THANKAPPAN KAKKADIYIL NARAYANAN THANKAPPAN NAIR",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07088",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_d92a47b9-95df-47ff-b7ed-b81cbcaed53e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "2aa80b34-7305-43a3-92cb-b7804076eb73",
    "slug": "hatem-eissa",
    "name": "HATEM EISSA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5IRTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts",
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Proceedings-Cases and Proceedings before Dubai International Financial Centre"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/12/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: HATEM EISSA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07104",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_2aa80b34-7305-43a3-92cb-b7804076eb73",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "036d1d88-0459-45fb-af11-57db3e618230",
    "slug": "abdalmageed-eisa",
    "name": "ABDALMAGEED EISA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BRTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts",
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/12/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ABDALMAGEED EISA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07103",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_036d1d88-0459-45fb-af11-57db3e618230",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "afa2995f-d07a-4310-9b65-9e88854d565c",
    "slug": "xuwei-li",
    "name": "XUWEI LI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5YTDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Civil Transactions-Construction and Contracts for Services",
      "Civil Transactions-Arbitration"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/01/2026",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: XUWEI LI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07102",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_afa2995f-d07a-4310-9b65-9e88854d565c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "325667ce-9aac-4f35-ac1a-28e7f3547e92",
    "slug": "mohammad-haykal",
    "name": "MOHAMMAD HAYKAL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NSDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Proceedings-Cases and Proceedings before Dubai International Financial Centre",
      "Proceedings-Cases and Proceedings before arbitral tribunals and other alternative dispute resolution bodies"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/12/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MOHAMMAD HAYKAL",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07106",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_325667ce-9aac-4f35-ac1a-28e7f3547e92",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "6a99424b-589e-4e1d-aef8-c06ddfe24c62",
    "slug": "julia-launders",
    "name": "JULIA LAUNDERS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5KTDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Commercial Transactions-E-Commerce",
      "Commercial Transactions-Intellectual Property (includes trademarks",
      "copy rights",
      "patents)",
      "Commercial Transactions-Commercial Contracts"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/01/2026",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: JULIA LAUNDERS",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07126",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_6a99424b-589e-4e1d-aef8-c06ddfe24c62",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "1a0772d7-1c13-491f-af42-1b53108ebe6d",
    "slug": "hosameldin-zaghloul",
    "name": "HOSAMELDIN ZAGHLOUL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5IWjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Proceedings-Criminal Cases and Proceedings before Dubai Courts",
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Personal Status-Legacies and Inheritance"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/12/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: HOSAMELDIN ZAGHLOUL",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07105",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_1a0772d7-1c13-491f-af42-1b53108ebe6d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "68344947-4af6-46fc-a2ad-356d6987d073",
    "slug": "sara-awad-elhassan-elnour",
    "name": "SARA AWAD ELHASSAN ELNOUR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/02/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: SARA AWAD ELHASSAN ELNOUR",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03639",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_68344947-4af6-46fc-a2ad-356d6987d073",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "81640b2b-e47f-40a7-b23d-b4008f41a927",
    "slug": "shurooq-fareed-abdulrahman-zainal",
    "name": "SHUROOQ FAREED ABDULRAHMAN ZAINAL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TRjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/12/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: SHUROOQ FAREED ABDULRAHMAN ZAINAL",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00329",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_81640b2b-e47f-40a7-b23d-b4008f41a927",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "02570a7b-ab46-40a8-9bef-32bdb503d547",
    "slug": "farah-salem-h-el-yacoubi",
    "name": "FARAH SALEM H EL YACOUBI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5GUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/06/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-06-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: FARAH SALEM H EL YACOUBI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-04142",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_02570a7b-ab46-40a8-9bef-32bdb503d547",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "2034cd62-a92a-4ced-87a7-47cec57d4dc6",
    "slug": "mayssa-khattar",
    "name": "Mayssa Khattar",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NSzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/06/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-06-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mayssa Khattar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-04131",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_2034cd62-a92a-4ced-87a7-47cec57d4dc6",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "d78771cf-d3b2-47cb-91fe-81219fb26c42",
    "slug": "emily-madeleine-albou",
    "name": "Emily Madeleine Albou",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5FTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/10/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-10-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Emily Madeleine Albou",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-04232",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_d78771cf-d3b2-47cb-91fe-81219fb26c42",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "4b3931f3-3c6f-47ee-84e6-3497f1963007",
    "slug": "mario-haxhiymeri",
    "name": "MARIO HAXHIYMERI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NSDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/10/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-10-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MARIO HAXHIYMERI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-04240",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_4b3931f3-3c6f-47ee-84e6-3497f1963007",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "ce1e4dbc-bdd6-4776-ad95-3f871942632b",
    "slug": "jonathan-shaw",
    "name": "Jonathan Shaw",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5KUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/10/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-10-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jonathan Shaw",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03603",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_ce1e4dbc-bdd6-4776-ad95-3f871942632b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "3ac7d131-7786-4038-87ef-ab98fdb26e8e",
    "slug": "briony-kate-aston-mitchell",
    "name": "BRIONY KATE ASTON MITCHELL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5CSzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/12/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: BRIONY KATE ASTON MITCHELL",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07101",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_3ac7d131-7786-4038-87ef-ab98fdb26e8e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "d5b2a071-37f2-43e8-b576-eccf0fa9414c",
    "slug": "jonathan-david-mark-williamson",
    "name": "Jonathan David Mark Williamson",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5KRDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/04/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-04-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jonathan David Mark Williamson",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-04084",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_d5b2a071-37f2-43e8-b576-eccf0fa9414c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "6e4f6295-83bd-421f-a2b7-a4ee18d693fa",
    "slug": "hannah-o-donovan",
    "name": "Hannah O' Donovan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ITzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/01/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-01-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hannah O' Donovan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03590",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_6e4f6295-83bd-421f-a2b7-a4ee18d693fa",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "a08579dc-a432-4297-824b-d267e98a32d9",
    "slug": "tapobrata-mukhopadhyay",
    "name": "Tapobrata Mukhopadhyay",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5UTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/05/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-05-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tapobrata Mukhopadhyay",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-04105",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_a08579dc-a432-4297-824b-d267e98a32d9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "4eef7749-1424-41ce-86b1-b23253832b8f",
    "slug": "sarah-jayne-steed",
    "name": "SARAH JAYNE STEED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TSjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/03/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-03-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: SARAH JAYNE STEED",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03673",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_4eef7749-1424-41ce-86b1-b23253832b8f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "0fcbaa38-baf4-4c51-9fcd-6b6d9304e3fe",
    "slug": "rabah-bashir",
    "name": "RABAH BASHIR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5SQjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/02/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-02-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: RABAH BASHIR",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-04025",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_0fcbaa38-baf4-4c51-9fcd-6b6d9304e3fe",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "04e461b4-540f-4bab-9947-0b45e14369dd",
    "slug": "shaikha-abdulrahman-faiz-humaid-alshamsi",
    "name": "SHAIKHA ABDULRAHMAN FAIZ HUMAID ALSHAMSI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/03/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-03-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: SHAIKHA ABDULRAHMAN FAIZ HUMAID ALSHAMSI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-04371",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_04e461b4-540f-4bab-9947-0b45e14369dd",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "6952bd3c-e2db-4722-8db4-6014788f9d79",
    "slug": "raissa-hajjar",
    "name": "Raissa HAJJAR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5SSDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/01/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-01-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Raissa HAJJAR",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03967",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_6952bd3c-e2db-4722-8db4-6014788f9d79",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "d40364c1-48d4-4d2e-b5c7-504781731854",
    "slug": "jenna-bhatia",
    "name": "Jenna Bhatia",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5KQjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/03/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-03-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jenna Bhatia",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03704",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_d40364c1-48d4-4d2e-b5c7-504781731854",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "2d87c764-757e-49d7-ac3d-637433033dc8",
    "slug": "moustafa-hassan-refaat-hassan",
    "name": "Moustafa Hassan Refaat Hassan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NSDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/11/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-11-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Moustafa Hassan Refaat Hassan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-04270",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_2d87c764-757e-49d7-ac3d-637433033dc8",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "e46d4ef0-74e5-40bf-8b19-ca68306848aa",
    "slug": "moustafa-shamseldin-noureldin-mohamed",
    "name": "MOUSTAFA SHAMSELDIN NOURELDIN MOHAMED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/07/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-07-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MOUSTAFA SHAMSELDIN NOURELDIN MOHAMED",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03869",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_e46d4ef0-74e5-40bf-8b19-ca68306848aa",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "c8d2afc1-0b5e-4fb7-a4e8-3035de36c242",
    "slug": "brinda-shroff-narendra-shroff",
    "name": "BRINDA SHROFF NARENDRA SHROFF",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5CUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/11/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2017-11-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: BRINDA SHROFF NARENDRA SHROFF",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03613",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_c8d2afc1-0b5e-4fb7-a4e8-3035de36c242",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "cb072e5b-05cf-4073-ac6a-fa1014dff171",
    "slug": "faris-allouzi",
    "name": "Faris Allouzi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5GQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/01/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-01-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Faris Allouzi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03702",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_cb072e5b-05cf-4073-ac6a-fa1014dff171",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "f6ffbe71-6ac7-4987-8997-b6e4ee4c5e45",
    "slug": "freya-mcdonald-byrne",
    "name": "FREYA MCDONALD BYRNE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5GTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/01/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-01-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: FREYA MCDONALD BYRNE",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03323",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_f6ffbe71-6ac7-4987-8997-b6e4ee4c5e45",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "d382d84c-8aae-4c42-848f-b1405d2ed412",
    "slug": "mashael-alshebaiky",
    "name": "Mashael Alshebaiky",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/10/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2017-10-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mashael Alshebaiky",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03534",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_d382d84c-8aae-4c42-848f-b1405d2ed412",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "ceb858f2-b07a-4d82-bcfd-5903fe10f05f",
    "slug": "wajd-mulham-ibrahim-najjar",
    "name": "WAJD MULHAM IBRAHIM NAJJAR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5XTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/08/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-08-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: WAJD MULHAM IBRAHIM NAJJAR",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03852",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_ceb858f2-b07a-4d82-bcfd-5903fe10f05f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "68140c13-d17f-4d33-8294-a55b7e97c417",
    "slug": "sankalp-labroo",
    "name": "Sankalp Labroo",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TTDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/03/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-03-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sankalp Labroo",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02796",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_68140c13-d17f-4d33-8294-a55b7e97c417",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "2ca08eb2-f0cd-4b90-948f-8ef86bbe1012",
    "slug": "thomas-howell",
    "name": "Thomas Howell",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5USDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/05/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-05-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Thomas Howell",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03018",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_2ca08eb2-f0cd-4b90-948f-8ef86bbe1012",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "d57469cc-c9aa-4195-b83f-0304f3b2d07f",
    "slug": "armando-vicente-arballo",
    "name": "ARMANDO VICENTE ARBALLO",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BVjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/03/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-03-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ARMANDO VICENTE ARBALLO",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-04367",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_d57469cc-c9aa-4195-b83f-0304f3b2d07f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "84fd5a18-3a28-4160-82be-e80e2636e866",
    "slug": "mohamed-magdy-abdelwadod-abdelhalim",
    "name": "MOHAMED MAGDY ABDELWADOD ABDELHALIM",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/08/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2022-08-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MOHAMED MAGDY ABDELWADOD ABDELHALIM",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03436",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_84fd5a18-3a28-4160-82be-e80e2636e866",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "ce5aa515-36ef-4b7e-b87a-76436ac781dd",
    "slug": "noor-al-heialy",
    "name": "NOOR AL HEIALY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5OQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/11/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: NOOR AL HEIALY",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03569",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_ce5aa515-36ef-4b7e-b87a-76436ac781dd",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "85c612ba-3842-4efb-9573-41831c81f529",
    "slug": "yasmeen-ghali",
    "name": "Yasmeen Ghali",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ZRzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/01/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-01-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Yasmeen Ghali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02821",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_85c612ba-3842-4efb-9573-41831c81f529",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "680fd575-75a5-4904-a081-e79a8e7f7b52",
    "slug": "mattia-pontillo",
    "name": "Mattia Pontillo",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NUDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/01/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-01-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mattia Pontillo",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03630",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_680fd575-75a5-4904-a081-e79a8e7f7b52",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "ccde34b6-9fb3-4589-93f1-a4b30d1db74d",
    "slug": "melissa-chan-yee-ching",
    "name": "MELISSA CHAN YEE CHING",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NQzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/07/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-07-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MELISSA CHAN YEE CHING",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02493",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_ccde34b6-9fb3-4589-93f1-a4b30d1db74d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "07a7ddc7-0805-435f-9a12-dce0df5839fc",
    "slug": "ciara-ros",
    "name": "Ciara Ros",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5DUjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/09/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-09-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ciara Ros",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03186",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_07a7ddc7-0805-435f-9a12-dce0df5839fc",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "cc9a65ea-6e47-4b31-a964-b950494c832c",
    "slug": "emily-lang",
    "name": "Emily Lang",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5FTDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/10/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2017-10-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Emily Lang",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03530",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_cc9a65ea-6e47-4b31-a964-b950494c832c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "16ff4f3a-291f-4c44-8e90-d1901e4ac3a4",
    "slug": "james-contos",
    "name": "James Contos",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5KQzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/01/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-01-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: James Contos",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03631",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_16ff4f3a-291f-4c44-8e90-d1901e4ac3a4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "0cb2239a-221c-4e0d-ba53-44edc6ff1e48",
    "slug": "rania-nadim-el-tawil",
    "name": "RANIA NADIM EL TAWIL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5STjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/08/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-08-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: RANIA NADIM EL TAWIL",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03426",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_0cb2239a-221c-4e0d-ba53-44edc6ff1e48",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "e30711d0-b626-4572-a1d2-8e1ee95765d1",
    "slug": "emma-louise-hughes",
    "name": "EMMA LOUISE HUGHES",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5FTDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/11/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-11-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: EMMA LOUISE HUGHES",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-04271",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_e30711d0-b626-4572-a1d2-8e1ee95765d1",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "265d3594-24e5-4efc-8ba8-b0271f0d5573",
    "slug": "michelle-joseph-stephan",
    "name": "MICHELLE JOSEPH STEPHAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NSjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/01/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-01-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MICHELLE JOSEPH STEPHAN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02831",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_265d3594-24e5-4efc-8ba8-b0271f0d5573",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "0d018632-05e9-4f8a-a366-9f8869cbca9e",
    "slug": "saima-mosdiq",
    "name": "Saima Mosdiq",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/11/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-11-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Saima Mosdiq",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03791",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_0d018632-05e9-4f8a-a366-9f8869cbca9e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "b9c3dfd6-6da6-49a3-bde9-c8085b507b27",
    "slug": "joshua-felix-cohen",
    "name": "JOSHUA FELIX COHEN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5KRjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/08/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-08-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: JOSHUA FELIX COHEN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03476",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_b9c3dfd6-6da6-49a3-bde9-c8085b507b27",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "74d47fd5-7286-42ba-a9d1-4bf2061e6849",
    "slug": "kenda-shaheen",
    "name": "Kenda Shaheen",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5LUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/07/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-07-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Kenda Shaheen",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03813",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_74d47fd5-7286-42ba-a9d1-4bf2061e6849",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "f5e660d1-428d-4bf3-866e-afc53c0f3721",
    "slug": "hiam-mohd-tamjid",
    "name": "HIAM MOHD TAMJID",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ITTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/01/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-01-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: HIAM MOHD TAMJID",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01328",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_f5e660d1-428d-4bf3-866e-afc53c0f3721",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "afc3c3e0-c5c5-4091-b253-c12ff859ab29",
    "slug": "thomas-bamford",
    "name": "Thomas Bamford",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5UQjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/11/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-10-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Thomas Bamford",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03331",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_afc3c3e0-c5c5-4091-b253-c12ff859ab29",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "c792727a-f0b1-4caf-aa98-d5e8c4943940",
    "slug": "asma-ali-salim-rashed-al-shamsi",
    "name": "Asma Ali Salim Rashed Al Shamsi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/03/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-03-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Asma Ali Salim Rashed Al Shamsi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-04353",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_c792727a-f0b1-4caf-aa98-d5e8c4943940",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "8a7fb0f9-c08e-45a6-9a57-5a288b2c0b8e",
    "slug": "amer-samer-hussein-jaghoub",
    "name": "AMER SAMER HUSSEIN JAGHOUB",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/03/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-03-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: AMER SAMER HUSSEIN JAGHOUB",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01158",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_8a7fb0f9-c08e-45a6-9a57-5a288b2c0b8e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "75e1e691-792a-44e2-8bc1-bf1d7b33947b",
    "slug": "nasim-bazari",
    "name": "NASIM BAZARI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5OQjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/02/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-02-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: NASIM BAZARI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-04026",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_75e1e691-792a-44e2-8bc1-bf1d7b33947b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "a661c2e2-7079-44f0-8c16-40cd781e8646",
    "slug": "mohammed-asim-arshad",
    "name": "Mohammed Asim Arshad",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/06/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-06-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohammed Asim Arshad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03398",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_a661c2e2-7079-44f0-8c16-40cd781e8646",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "d928ba4d-7332-44d3-ac1e-29563b7a0d69",
    "slug": "mohamed-amr-ahmed-fouad-abas",
    "name": "Mohamed Amr Ahmed Fouad Abas",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/03/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-03-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Amr Ahmed Fouad Abas",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02194",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_d928ba4d-7332-44d3-ac1e-29563b7a0d69",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "80c1510d-9042-4e94-9577-39052d693716",
    "slug": "robert-hughes",
    "name": "Robert Hughes",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5SSDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/04/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-04-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Robert Hughes",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03711",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_80c1510d-9042-4e94-9577-39052d693716",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "c977e91e-2ef7-4d42-8584-f5bb5259bfc2",
    "slug": "stephen-doherty",
    "name": "Stephen Doherty",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TRDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/12/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-12-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Stephen Doherty",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03942",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_c977e91e-2ef7-4d42-8584-f5bb5259bfc2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "d05d553c-899b-48e5-b331-a3a075bafebc",
    "slug": "toby-mccrindle",
    "name": "Toby McCrindle",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5UTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/07/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-07-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Toby McCrindle",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03389",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_d05d553c-899b-48e5-b331-a3a075bafebc",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "04b44879-e9d6-4062-bf59-7a968b06df30",
    "slug": "suna-jabeen-waheed",
    "name": "SUNA JABEEN WAHEED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TSjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/01/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-01-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: SUNA JABEEN WAHEED",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02263",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_04b44879-e9d6-4062-bf59-7a968b06df30",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "48c27545-85f7-45cd-81f9-d61f878a0093",
    "slug": "amber-pledge",
    "name": "Amber Pledge",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BUDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/07/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-07-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Amber Pledge",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03410",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_48c27545-85f7-45cd-81f9-d61f878a0093",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "bd9a0706-c33c-41b1-aecc-05e6b9137274",
    "slug": "muhammad-sherif-mostafa-fathi-elhaggan",
    "name": "Muhammad Sherif Mostafa Fathi Elhaggan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/06/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-06-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Muhammad Sherif Mostafa Fathi Elhaggan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03786",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_bd9a0706-c33c-41b1-aecc-05e6b9137274",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "e708617c-4e51-4556-998a-459d900e2e3d",
    "slug": "ritwick-ghosh",
    "name": "Ritwick Ghosh",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5SRzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/03/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-03-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ritwick Ghosh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02857",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_e708617c-4e51-4556-998a-459d900e2e3d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "698ddb81-12b0-4f24-ba73-50ca6fa042ff",
    "slug": "lama-majdalani",
    "name": "LAMA MAJDALANI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5MTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/03/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-03-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: LAMA MAJDALANI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02304",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_698ddb81-12b0-4f24-ba73-50ca6fa042ff",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "1729e038-4c2b-422e-a207-c587b20dea85",
    "slug": "elizabeth-mcauliffe",
    "name": "Elizabeth McAuliffe",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5FTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/05/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-05-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Elizabeth McAuliffe",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03379",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_1729e038-4c2b-422e-a207-c587b20dea85",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "56c718f0-7678-453b-aef7-1c0c46f79800",
    "slug": "yasmene-cerfontyne",
    "name": "YASMENE CERFONTYNE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ZQzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/12/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2017-12-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: YASMENE CERFONTYNE",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02766",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_56c718f0-7678-453b-aef7-1c0c46f79800",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "ba6f93f3-281d-41fd-b833-114b16901246",
    "slug": "aqsa-basit-ghulam-basit",
    "name": "AQSA BASIT GHULAM BASIT",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/12/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-12-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: AQSA BASIT GHULAM BASIT",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03940",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_ba6f93f3-281d-41fd-b833-114b16901246",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "6e98a640-1c6e-44a6-a4e9-eb30698baff4",
    "slug": "hasan-mandviwalla",
    "name": "Hasan Mandviwalla",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ITTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/02/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-02-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hasan Mandviwalla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02465",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_6e98a640-1c6e-44a6-a4e9-eb30698baff4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "8ab38e5a-1097-40ee-92ab-174fc74d02e6",
    "slug": "nour-el-bezre",
    "name": "Nour El Bezre",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ORTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/11/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-11-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nour El Bezre",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03310",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_8ab38e5a-1097-40ee-92ab-174fc74d02e6",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "7459d2ff-6607-43ac-824d-8816f6473c2f",
    "slug": "nasser-marwan-haddad",
    "name": "NASSER MARWAN HADDAD",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5OTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/08/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2017-08-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: NASSER MARWAN HADDAD",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02634",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_7459d2ff-6607-43ac-824d-8816f6473c2f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "c486d3f9-63dc-4dc7-918a-eb7de50f71c9",
    "slug": "nicole-newdigate",
    "name": "Nicole Newdigate",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5OTjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/07/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-07-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nicole Newdigate",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03120",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_c486d3f9-63dc-4dc7-918a-eb7de50f71c9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "049c15ce-720d-41a1-b27c-f54fa4957ae6",
    "slug": "amr-a-n-m-hijazi",
    "name": "Amr A N M Hijazi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/04/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-04-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Amr A N M Hijazi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-014392",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_049c15ce-720d-41a1-b27c-f54fa4957ae6",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "ee271955-594c-4796-8a37-dfccd37d4a8e",
    "slug": "adele-oherlihy",
    "name": "ADELE OHERLIHY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BTzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/10/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-10-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ADELE OHERLIHY",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03523",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_ee271955-594c-4796-8a37-dfccd37d4a8e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "a0b030bc-2c60-4e55-81a0-6faaf463db1e",
    "slug": "veronique-lasserre",
    "name": "VERONIQUE LASSERRE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5WTDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/08/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-08-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: VERONIQUE LASSERRE",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03466",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_a0b030bc-2c60-4e55-81a0-6faaf463db1e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "092613cd-620e-42ee-a265-7c0071b4abfd",
    "slug": "carolina-varga",
    "name": "CAROLINA VARGA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5DVjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/11/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-10-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: CAROLINA VARGA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03536",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_092613cd-620e-42ee-a265-7c0071b4abfd",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "27de04a6-4771-43e6-b226-d2616cd6a294",
    "slug": "ahmed-mohamed-metwaly-ekila",
    "name": "AHMED MOHAMED METWALY EKILA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/11/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-11-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: AHMED MOHAMED METWALY EKILA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02777",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_27de04a6-4771-43e6-b226-d2616cd6a294",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "17a5ae5b-88a6-444d-94a0-816b8b46821b",
    "slug": "rebecca-elias-gerges",
    "name": "REBECCA ELIAS GERGES",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5SRTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/06/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-06-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: REBECCA ELIAS GERGES",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03025",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_17a5ae5b-88a6-444d-94a0-816b8b46821b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "09b34d85-22e7-4244-acc0-a4362d414512",
    "slug": "karim-tarek-mostafa-mokhtar-hassan-eltantawi",
    "name": "KARIM TAREK MOSTAFA MOKHTAR HASSAN ELTANTAWI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5LVDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/06/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-06-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: KARIM TAREK MOSTAFA MOKHTAR HASSAN ELTANTAWI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03850",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_09b34d85-22e7-4244-acc0-a4362d414512",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "58d75ed8-c6c7-4991-8886-cde23194e041",
    "slug": "kirsty-coventry",
    "name": "Kirsty Coventry",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5LQzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/05/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-04-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Kirsty Coventry",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03761",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_58d75ed8-c6c7-4991-8886-cde23194e041",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "bf3906ce-2b65-406a-b4da-f8a4109cb5a4",
    "slug": "sarra-alsamarrai",
    "name": "Sarra Alsamarrai",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/05/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-05-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sarra Alsamarrai",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02647",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_bf3906ce-2b65-406a-b4da-f8a4109cb5a4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "e533e980-129d-4aeb-8bc1-ee141722ebf9",
    "slug": "marija-ozolins",
    "name": "Marija Ozolins",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NTzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/02/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Marija Ozolins",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03642",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_e533e980-129d-4aeb-8bc1-ee141722ebf9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "dd82ffd8-1072-450d-ac31-803a22bf61d8",
    "slug": "anna-sakr",
    "name": "Anna Sakr",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/06/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-06-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Anna Sakr",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02520",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_dd82ffd8-1072-450d-ac31-803a22bf61d8",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "aa5c0684-20b5-4c62-91df-82739072d8cb",
    "slug": "sylvana-romero",
    "name": "Sylvana Romero",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TUjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/02/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-01-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sylvana Romero",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03620",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_aa5c0684-20b5-4c62-91df-82739072d8cb",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "9c0e256a-5616-4bd8-b151-85f028c662a1",
    "slug": "mushfique-khan",
    "name": "Mushfique Khan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NSzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/02/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-01-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mushfique Khan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02555",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_9c0e256a-5616-4bd8-b151-85f028c662a1",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "67e0708c-6533-42f1-bbcf-2babda0e1765",
    "slug": "sarah-anne-french",
    "name": "SARAH ANNE FRENCH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/12/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2017-12-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: SARAH ANNE FRENCH",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01718",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_67e0708c-6533-42f1-bbcf-2babda0e1765",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "03533ec8-bd6b-4542-8d81-6fd8a9ce02a0",
    "slug": "katy-hacking",
    "name": "KATY HACKING",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5LSDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/10/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-10-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: KATY HACKING",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01509",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_03533ec8-bd6b-4542-8d81-6fd8a9ce02a0",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "8c287e9f-4541-4cb4-af0e-d53093dcbea9",
    "slug": "tom-gray",
    "name": "Tom Gray",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5URzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/05/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-05-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tom Gray",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03030",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_8c287e9f-4541-4cb4-af0e-d53093dcbea9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "a48aa53c-3432-43d7-be61-1c5fc406bb6e",
    "slug": "neil-westwood",
    "name": "Neil Westwood",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5OVzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/01/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-01-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Neil Westwood",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02932",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_a48aa53c-3432-43d7-be61-1c5fc406bb6e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "ded19de8-3583-40bc-a432-980da4173c43",
    "slug": "kylie-pennick",
    "name": "KYLIE PENNICK",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5LUDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/03/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-03-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: KYLIE PENNICK",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-04346",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_ded19de8-3583-40bc-a432-980da4173c43",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "3b5254e2-7f8f-4fea-8161-1968d17e14a9",
    "slug": "jack-allen-fitt",
    "name": "JACK ALLEN FITT",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5KQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/01/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-01-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: JACK ALLEN FITT",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03978",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_3b5254e2-7f8f-4fea-8161-1968d17e14a9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "32564af8-4906-4627-a632-0625a6c85383",
    "slug": "georgiana-steiger",
    "name": "Georgiana Steiger",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5HUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/10/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-10-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Georgiana Steiger",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02873",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_32564af8-4906-4627-a632-0625a6c85383",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "3aba8cc9-77a7-41b0-a79f-717e1ec374f6",
    "slug": "edouard-georges-salwan",
    "name": "EDOUARD GEORGES SALWAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5FRzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/05/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-05-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: EDOUARD GEORGES SALWAN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03755",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_3aba8cc9-77a7-41b0-a79f-717e1ec374f6",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "11055035-de48-4b17-8fc9-920f3e1ab1d5",
    "slug": "george-murphy",
    "name": "George Murphy",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5HTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/04/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-04-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: George Murphy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03762",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_11055035-de48-4b17-8fc9-920f3e1ab1d5",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "7751810e-8cdc-406c-a80d-a32644629b43",
    "slug": "thomas-mcdonnell",
    "name": "Thomas McDonnell",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5UTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/09/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2017-09-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Thomas McDonnell",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02830",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_7751810e-8cdc-406c-a80d-a32644629b43",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "a640b62e-e0c1-4dfa-87f9-4f3f31a220b6",
    "slug": "george-ramzi-khoury",
    "name": "George Ramzi Khoury",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5HUjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/03/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-03-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: George Ramzi Khoury",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02902",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_a640b62e-e0c1-4dfa-87f9-4f3f31a220b6",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "87d8e338-9406-48c0-90a2-7a3641a6c15c",
    "slug": "mariam-gehad-abdelmalik-auda",
    "name": "Mariam Gehad Abdelmalik Auda",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NRzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/12/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-12-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mariam Gehad Abdelmalik Auda",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03972",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_87d8e338-9406-48c0-90a2-7a3641a6c15c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "eed2b786-15d3-40d7-b808-4082c684aca8",
    "slug": "leila-shabankareh",
    "name": "Leila Shabankareh",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5MUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2017-02-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Leila Shabankareh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00718",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_eed2b786-15d3-40d7-b808-4082c684aca8",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "d3a419f2-a155-4027-9e42-5c0acafa9f2e",
    "slug": "ida-mokhtassi",
    "name": "Ida Mokhtassi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5JTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/01/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-01-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ida Mokhtassi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03297",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_d3a419f2-a155-4027-9e42-5c0acafa9f2e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "b775768a-ffa5-4ab5-978a-cefafe92b2b6",
    "slug": "rachel-o-brien",
    "name": "Rachel O'Brien",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5STzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/01/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-01-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rachel O'Brien",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03629",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_b775768a-ffa5-4ab5-978a-cefafe92b2b6",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "e8fc0755-4473-457e-821a-d0e72244ed5f",
    "slug": "ali-dheyaa-ibrahim-ibrahim",
    "name": "ALI DHEYAA IBRAHIM IBRAHIM",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BRDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/07/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-07-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ALI DHEYAA IBRAHIM IBRAHIM",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03837",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_e8fc0755-4473-457e-821a-d0e72244ed5f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "69dfd451-d975-4f95-b530-f616571f5e15",
    "slug": "mehreen-shafiq-manzar-shafiq",
    "name": "MEHREEN SHAFIQ MANZAR SHAFIQ",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/08/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-08-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MEHREEN SHAFIQ MANZAR SHAFIQ",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03164",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_69dfd451-d975-4f95-b530-f616571f5e15",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "4ce5e8ca-7727-4775-828c-dd67547efc85",
    "slug": "zahra-parvez-petafi",
    "name": "ZAHRA PARVEZ PETAFI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5aUDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/02/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-02-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ZAHRA PARVEZ PETAFI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02408",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_4ce5e8ca-7727-4775-828c-dd67547efc85",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "b618f427-1f20-4ca1-a7bb-aefab827bf0a",
    "slug": "jess-mcguirk",
    "name": "Jess Mcguirk",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5KTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/01/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-01-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jess Mcguirk",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03293",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_b618f427-1f20-4ca1-a7bb-aefab827bf0a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "a2d5b3f9-cd86-4ed3-bb25-38e7603c2b4b",
    "slug": "alia-ahmed",
    "name": "ALIA AHMED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/06/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-06-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ALIA AHMED",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03390",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_a2d5b3f9-cd86-4ed3-bb25-38e7603c2b4b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "34e158f7-d583-4b49-8dce-fec92e78bef3",
    "slug": "alistair-david-bates-price",
    "name": "ALISTAIR DAVID BATES PRICE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BRDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/11/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-11-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ALISTAIR DAVID BATES PRICE",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00896",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_34e158f7-d583-4b49-8dce-fec92e78bef3",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "9b38a9b7-e433-4e26-a4b5-67997af2cc12",
    "slug": "hussein-magdy-hussein-masry",
    "name": "HUSSEIN MAGDY HUSSEIN MASRY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ITTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-02-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: HUSSEIN MAGDY HUSSEIN MASRY",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01617",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_9b38a9b7-e433-4e26-a4b5-67997af2cc12",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "51930503-a9ea-4add-be54-a1721ea488d2",
    "slug": "jennifer-agnew",
    "name": "Jennifer Agnew",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5KQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/01/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-01-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jennifer Agnew",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02716",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_51930503-a9ea-4add-be54-a1721ea488d2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "9ecac638-3df1-44ff-8082-43f1f265fde2",
    "slug": "walid-alrifai",
    "name": "Walid Alrifai",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5XQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-02-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Walid Alrifai",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01402",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_9ecac638-3df1-44ff-8082-43f1f265fde2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "1d4d5e1e-d312-4715-9c5b-9cf609f53378",
    "slug": "joseph-andrew-neilson",
    "name": "JOSEPH ANDREW NEILSON",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5KQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/06/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-06-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: JOSEPH ANDREW NEILSON",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02829",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_1d4d5e1e-d312-4715-9c5b-9cf609f53378",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "5942aa43-6a77-46a4-93a5-2475b6115e10",
    "slug": "dimity-erickson",
    "name": "Dimity Erickson",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ERTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/05/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-05-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Dimity Erickson",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03354",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_5942aa43-6a77-46a4-93a5-2475b6115e10",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "bf4e40a9-d4a9-41ec-83a5-57f1a66a4b38",
    "slug": "nadia-barazi",
    "name": "Nadia Barazi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5OQjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/01/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-01-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nadia Barazi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-04002",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_bf4e40a9-d4a9-41ec-83a5-57f1a66a4b38",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "252abee6-fd8b-4d8b-a75d-027c419f6b63",
    "slug": "abdulkarim-ali-y-alamri",
    "name": "Abdulkarim Ali Y Alamri",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/11/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-11-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abdulkarim Ali Y Alamri",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03916",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_252abee6-fd8b-4d8b-a75d-027c419f6b63",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "8465c274-1f4c-49d7-b065-f650e23a5bfa",
    "slug": "amelia-trotter",
    "name": "Amelia Trotter",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BVDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/10/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-10-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Amelia Trotter",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03883",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_8465c274-1f4c-49d7-b065-f650e23a5bfa",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "a6e0a879-5ab1-4b00-b77a-0de97a1b12e7",
    "slug": "arjmand-ghafoor",
    "name": "Arjmand Ghafoor",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BRzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/08/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-08-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Arjmand Ghafoor",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03144",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_a6e0a879-5ab1-4b00-b77a-0de97a1b12e7",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "77337865-85c0-4062-9889-4973bcd6b754",
    "slug": "ammar-mahmoud-abdel-kareim-al-tarawneh",
    "name": "AMMAR MAHMOUD ABDEL KAREIM AL TARAWNEH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/04/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-04-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: AMMAR MAHMOUD ABDEL KAREIM AL TARAWNEH",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02429",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_77337865-85c0-4062-9889-4973bcd6b754",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "32210ae3-6927-4721-ae5c-889f066dd44c",
    "slug": "yazen-ali-salman",
    "name": "YAZEN ALI SALMAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ZQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/08/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-08-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: YAZEN ALI SALMAN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02141",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_32210ae3-6927-4721-ae5c-889f066dd44c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "5aa5eee6-f39e-42a4-b812-8b8ae112a862",
    "slug": "ahmed-saad-antar-ali-kassem",
    "name": "AHMED SAAD ANTAR ALI KASSEM",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-02-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: AHMED SAAD ANTAR ALI KASSEM",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01386",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_5aa5eee6-f39e-42a4-b812-8b8ae112a862",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "01afd4d5-87fa-40e4-a06b-71b4639a9e71",
    "slug": "yvonne-foo",
    "name": "Yvonne Foo",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ZRjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/02/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Yvonne Foo",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00925",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_01afd4d5-87fa-40e4-a06b-71b4639a9e71",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "2ddf532d-59c7-43e4-bd09-aefbe6a65e40",
    "slug": "mahmoud-hassan-hassan",
    "name": "Mahmoud Hassan Hassan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NSDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/09/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-09-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mahmoud Hassan Hassan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02460",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_2ddf532d-59c7-43e4-bd09-aefbe6a65e40",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "3253c6fe-e3c6-4a68-8b16-8d06dc2497a1",
    "slug": "khaled-o-m-almajayda",
    "name": "KHALED O M ALMAJAYDA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5LTzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-02-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: KHALED O M ALMAJAYDA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01579",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_3253c6fe-e3c6-4a68-8b16-8d06dc2497a1",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "f4fad22d-932d-4382-973e-3aa5926142a8",
    "slug": "mark-hatfull",
    "name": "Mark Hatfull",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NSDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/09/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-08-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mark Hatfull",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00779",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_f4fad22d-932d-4382-973e-3aa5926142a8",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "89fac372-d83d-49dd-b472-1b4c9c7497f9",
    "slug": "charlotte-rowley",
    "name": "Charlotte Rowley",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5DUjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/05/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-05-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Charlotte Rowley",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03378",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_89fac372-d83d-49dd-b472-1b4c9c7497f9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "96f09d2b-baef-4fad-804b-4388cfca13ae",
    "slug": "margarida-dos-santos-b-da-silva-narciso-nogueira",
    "name": "MARGARIDA DOS SANTOS B DA SILVA NARCISO NOGUEIRA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NRDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/05/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-05-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MARGARIDA DOS SANTOS B DA SILVA NARCISO NOGUEIRA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03377",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_96f09d2b-baef-4fad-804b-4388cfca13ae",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "8927b915-c172-4f78-b1cc-38721417a3e8",
    "slug": "joshua-loren-watts",
    "name": "JOSHUA LOREN WATTS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5KTDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/10/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-10-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: JOSHUA LOREN WATTS",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-04233",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_8927b915-c172-4f78-b1cc-38721417a3e8",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "b8a1898c-a994-42de-b641-fb1215a14d48",
    "slug": "anna-newman",
    "name": "Anna Newman",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BTjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-02-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Anna Newman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00899",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_b8a1898c-a994-42de-b641-fb1215a14d48",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "c99458ab-83af-4b43-b002-58d72ba52729",
    "slug": "zakiyya-islam-chowdhury",
    "name": "ZAKIYYA ISLAM CHOWDHURY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5aSTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/04/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-04-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ZAKIYYA ISLAM CHOWDHURY",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-04079",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_c99458ab-83af-4b43-b002-58d72ba52729",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "015e8d55-b92e-4ac0-b491-4c4e5cdc91b7",
    "slug": "dawda-jawara",
    "name": "Dawda Jawara",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ESjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/08/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-08-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Dawda Jawara",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03122",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_015e8d55-b92e-4ac0-b491-4c4e5cdc91b7",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "b8f8ee1c-f92b-4dab-8f93-e137fbcd8eec",
    "slug": "myriem-kadmiri",
    "name": "MYRIEM KADMIRI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NSzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/12/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2017-11-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MYRIEM KADMIRI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02000",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_b8f8ee1c-f92b-4dab-8f93-e137fbcd8eec",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "c45f02c9-215f-42c4-8abc-bd53d97de7b3",
    "slug": "dongok-jeon",
    "name": "Dongok Jeon",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ESjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/12/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-12-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Dongok Jeon",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02915",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_c45f02c9-215f-42c4-8abc-bd53d97de7b3",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "bdcfd411-9987-4d58-92af-43eee8a5dc61",
    "slug": "sarah-milne",
    "name": "Sarah Milne",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/09/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-09-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sarah Milne",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03862",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_bdcfd411-9987-4d58-92af-43eee8a5dc61",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "7240a708-0622-4590-9868-02a49a667994",
    "slug": "adam-short",
    "name": "Adam Short",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/05/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-05-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Adam Short",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03753",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_7240a708-0622-4590-9868-02a49a667994",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "7dff29fa-28e1-4934-8765-1ec666d48b9a",
    "slug": "craig-purdie",
    "name": "CRAIG PURDIE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5DUDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/02/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-01-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: CRAIG PURDIE",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03296",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_7dff29fa-28e1-4934-8765-1ec666d48b9a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "df9a6939-bf9f-46e3-a33f-01ebec53fb47",
    "slug": "james-clarke",
    "name": "James Clarke",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5KQzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/09/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-09-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: James Clarke",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03158",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_df9a6939-bf9f-46e3-a33f-01ebec53fb47",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "7c6c59a6-6e8d-43eb-bf9a-ab888fcde475",
    "slug": "karim-husni-shiyab",
    "name": "KARIM HUSNI SHIYAB",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5LSDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-02-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: KARIM HUSNI SHIYAB",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01272",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_7c6c59a6-6e8d-43eb-bf9a-ab888fcde475",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "6cd0fabe-31f3-4ad7-9d02-8dc2b5953f59",
    "slug": "rajwah-al-kuhaymi",
    "name": "Rajwah Al Kuhaymi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5SQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-02-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rajwah Al Kuhaymi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02173",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_6cd0fabe-31f3-4ad7-9d02-8dc2b5953f59",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "232125a1-2f91-410b-b5f5-7c8f2178e2dd",
    "slug": "jodie-adoki",
    "name": "Jodie Adoki",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5KQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/11/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-11-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jodie Adoki",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01462",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_232125a1-2f91-410b-b5f5-7c8f2178e2dd",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "19cb5da0-9791-410f-92ee-ee7b58379fd4",
    "slug": "farah-mohamad-nehme",
    "name": "FARAH MOHAMAD NEHME",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5GTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/02/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-02-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: FARAH MOHAMAD NEHME",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03659",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_19cb5da0-9791-410f-92ee-ee7b58379fd4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "218ab5d7-744a-4cd0-a535-ac5be68b2b4e",
    "slug": "anna-gillian-newland",
    "name": "ANNA GILLIAN NEWLAND",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BRzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/01/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-01-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ANNA GILLIAN NEWLAND",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02919",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_218ab5d7-744a-4cd0-a535-ac5be68b2b4e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "10158e81-878b-47f2-910b-8175ba746a29",
    "slug": "rajiv-nawbatt",
    "name": "Rajiv Nawbatt",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5STjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/11/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-11-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rajiv Nawbatt",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02094",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_10158e81-878b-47f2-910b-8175ba746a29",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "825a6780-f45e-46ea-a2b4-206d2d32612c",
    "slug": "nidal-antoine-makhoul",
    "name": "NIDAL ANTOINE MAKHOUL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5OQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/03/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-02-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: NIDAL ANTOINE MAKHOUL",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03668",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_825a6780-f45e-46ea-a2b4-206d2d32612c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "2ba0f75e-4696-4667-844a-037775bb5ee4",
    "slug": "philipp-julius-dr-clemens",
    "name": "Philipp Julius Dr Clemens",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5QSjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/09/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-09-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Philipp Julius Dr Clemens",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-04215",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_2ba0f75e-4696-4667-844a-037775bb5ee4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "4282fd85-6d32-44e6-a440-4e6ae2e6fd4b",
    "slug": "kamaljit-dosanjh",
    "name": "KAMALJIT DOSANJH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5LRDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/05/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-05-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: KAMALJIT DOSANJH",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00293",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_4282fd85-6d32-44e6-a440-4e6ae2e6fd4b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "340881be-e0b2-4830-812f-4febdf4dd0cd",
    "slug": "hesham-abdelkader-elsayed",
    "name": "Hesham Abdelkader Elsayed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5IQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/05/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-05-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hesham Abdelkader Elsayed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03115",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_340881be-e0b2-4830-812f-4febdf4dd0cd",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "f3ff16ac-bec7-4258-adf8-0dddd473caba",
    "slug": "lina-brunel",
    "name": "LINA BRUNEL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5MQjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/01/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-01-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: LINA BRUNEL",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02403",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_f3ff16ac-bec7-4258-adf8-0dddd473caba",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "74c03620-0397-407f-b617-6dc1f9abd32e",
    "slug": "marwa-soliman-mohamed-elmahdy-soliman",
    "name": "MARWA SOLIMAN MOHAMED ELMAHDY SOLIMAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/12/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2017-12-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MARWA SOLIMAN MOHAMED ELMAHDY SOLIMAN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02798",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_74c03620-0397-407f-b617-6dc1f9abd32e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "3dc53eb5-50a1-47e5-9e69-48f55ee6dff2",
    "slug": "dorine-farah",
    "name": "Dorine Farah",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ERjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/01/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-01-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Dorine Farah",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03327",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_3dc53eb5-50a1-47e5-9e69-48f55ee6dff2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "b1f9fa08-0305-4d03-963b-b168752022d5",
    "slug": "rhiannon-joseph",
    "name": "Rhiannon Joseph",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5SSjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/07/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-07-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rhiannon Joseph",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03103",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_b1f9fa08-0305-4d03-963b-b168752022d5",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "badf1ca8-4ec0-4e67-b703-de20b55a9706",
    "slug": "sai-pidatala",
    "name": "Sai Pidatala",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TUDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/06/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-06-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sai Pidatala",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02216",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_badf1ca8-4ec0-4e67-b703-de20b55a9706",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "32eb26c8-72d5-4aa0-bd25-8511a6f5db01",
    "slug": "benjamin-davies",
    "name": "BENJAMIN DAVIES",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5CRDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-02-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: BENJAMIN DAVIES",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00707",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_32eb26c8-72d5-4aa0-bd25-8511a6f5db01",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "4bdb671c-b8ca-4dc1-8ad5-89f4c00a5f39",
    "slug": "ronnie-dabbasi",
    "name": "Ronnie Dabbasi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5SRDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/12/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-12-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ronnie Dabbasi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00121",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_4bdb671c-b8ca-4dc1-8ad5-89f4c00a5f39",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "56091967-45e5-4a58-a83b-617120ac271e",
    "slug": "nada-moallem",
    "name": "Nada Moallem",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5OTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/10/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-10-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nada Moallem",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02736",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_56091967-45e5-4a58-a83b-617120ac271e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "1e653170-22c6-4a42-b86e-b169afbc431e",
    "slug": "ibrahim-moustafa-abdellah-moustafa",
    "name": "IBRAHIM MOUSTAFA ABDELLAH MOUSTAFA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5JTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/11/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-11-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: IBRAHIM MOUSTAFA ABDELLAH MOUSTAFA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03964",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_1e653170-22c6-4a42-b86e-b169afbc431e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "11d77830-0a91-4270-a251-50f84c0efd95",
    "slug": "paul-jones",
    "name": "Paul Jones",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5QSjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-02-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Paul Jones",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03667",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_11d77830-0a91-4270-a251-50f84c0efd95",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "5e948b67-525b-4fbd-b5f3-d8651dd97f55",
    "slug": "jennifer-al-salim",
    "name": "Jennifer Al Salim",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5KQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/01/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-01-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jennifer Al Salim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03599",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_5e948b67-525b-4fbd-b5f3-d8651dd97f55",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "8f3011eb-594d-45cb-adc1-da672567930f",
    "slug": "ahmed-ali-ahmed-mohamed-ahmed",
    "name": "AHMED ALI AHMED MOHAMED AHMED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/05/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-05-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: AHMED ALI AHMED MOHAMED AHMED",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02355",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_8f3011eb-594d-45cb-adc1-da672567930f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "47aa3bbe-19b4-484a-9358-495ab47fcd7b",
    "slug": "mahmoud-elzahy-elsaid-mahmoud-elzahy",
    "name": "MAHMOUD ELZAHY ELSAID MAHMOUD ELZAHY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NRTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/09/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2017-09-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MAHMOUD ELZAHY ELSAID MAHMOUD ELZAHY",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03213",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_47aa3bbe-19b4-484a-9358-495ab47fcd7b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "422cd684-b8cc-478f-8421-6ffc340131c5",
    "slug": "robert-edward-lewsley",
    "name": "ROBERT EDWARD LEWSLEY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5SRTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-02-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ROBERT EDWARD LEWSLEY",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01309",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_422cd684-b8cc-478f-8421-6ffc340131c5",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "16448f5f-b5bb-462d-9816-908a3068547f",
    "slug": "roopal-jobanputra",
    "name": "ROOPAL JOBANPUTRA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5SSjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/01/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-12-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ROOPAL JOBANPUTRA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00832",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_16448f5f-b5bb-462d-9816-908a3068547f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "8351246a-efad-4d63-91e4-a3d18c6d5b5c",
    "slug": "hannah-mckinlay",
    "name": "Hannah McKinlay",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ITTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2016-02-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hannah McKinlay",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00713",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_8351246a-efad-4d63-91e4-a3d18c6d5b5c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "423552ce-ccbe-480c-ab95-78d049a69f7b",
    "slug": "eslam-ahmed-sadek-amer",
    "name": "ESLAM AHMED SADEK AMER",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5FQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-02-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ESLAM AHMED SADEK AMER",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02320",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_423552ce-ccbe-480c-ab95-78d049a69f7b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "dec828e4-5391-450c-9b21-9048f2a18d97",
    "slug": "ahmed-abdelsattar-zaki-ali",
    "name": "AHMED ABDELSATTAR ZAKI ALI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/07/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-07-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: AHMED ABDELSATTAR ZAKI ALI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03814",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_dec828e4-5391-450c-9b21-9048f2a18d97",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "ae8083b5-72d2-4027-8d11-2ddf1190b009",
    "slug": "bahaaeldin-galal-mohamed-abdelrahman-abourida",
    "name": "BAHAAELDIN GALAL MOHAMED ABDELRAHMAN ABOURIDA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5CRzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/01/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-01-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: BAHAAELDIN GALAL MOHAMED ABDELRAHMAN ABOURIDA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02004",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_ae8083b5-72d2-4027-8d11-2ddf1190b009",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "61fce5ba-b5f1-4f16-a668-138f6fa8dd2f",
    "slug": "grant-pilkington",
    "name": "Grant Pilkington",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5HUDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/03/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-03-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Grant Pilkington",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00617",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_61fce5ba-b5f1-4f16-a668-138f6fa8dd2f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "ac1b2a44-0fcf-4051-949f-841fd2ce29ae",
    "slug": "kristen-samara-houghton-angus",
    "name": "KRISTEN SAMARA HOUGHTON ANGUS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5LUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/10/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-09-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: KRISTEN SAMARA HOUGHTON ANGUS",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00297",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_ac1b2a44-0fcf-4051-949f-841fd2ce29ae",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "acc581b4-a268-4258-ae98-42739bfb6fab",
    "slug": "jack-nichols",
    "name": "Jack Nichols",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5KTjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2017-02-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jack Nichols",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00714",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_acc581b4-a268-4258-ae98-42739bfb6fab",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "b5396835-918d-48ef-8999-a1dae99852d6",
    "slug": "tamer-ibrahim-nouh",
    "name": "Tamer Ibrahim Nouh",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5USTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/04/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-04-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tamer Ibrahim Nouh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02391",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_b5396835-918d-48ef-8999-a1dae99852d6",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "9a4239c7-1a94-4a4e-a826-5ea2ed46474f",
    "slug": "sameer-u-din-ali-khan",
    "name": "SAMEER U DIN ALI KHAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TVTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/12/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-12-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: SAMEER U DIN ALI KHAN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00833",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_9a4239c7-1a94-4a4e-a826-5ea2ed46474f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "0d4c7361-7f20-4060-8254-792136b5440c",
    "slug": "philip-werner-engels",
    "name": "PHILIP WERNER ENGELS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5QVzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/09/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-09-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: PHILIP WERNER ENGELS",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03267",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_0d4c7361-7f20-4060-8254-792136b5440c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "d516e9cf-4153-40fc-bc0d-8899060afd5a",
    "slug": "renata-rai",
    "name": "Renata Rai",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5SUjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/08/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-08-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Renata Rai",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01305",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_d516e9cf-4153-40fc-bc0d-8899060afd5a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "6c872dbe-a690-4cb8-9316-f7a64a8abc57",
    "slug": "lara-nicolas-turquieh",
    "name": "LARA NICOLAS TURQUIEH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5MTjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/11/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2017-11-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: LARA NICOLAS TURQUIEH",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01999",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_6c872dbe-a690-4cb8-9316-f7a64a8abc57",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "48584862-c317-45e5-b971-abb21e6e2662",
    "slug": "marcel-trost",
    "name": "MARCEL TROST",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NVDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/08/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-08-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MARCEL TROST",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03427",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_48584862-c317-45e5-b971-abb21e6e2662",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "47110e2f-2fb9-46ce-a618-5a60ff1e587a",
    "slug": "mohamed-shamseldin-noureldin-mohamed-khalil",
    "name": "MOHAMED SHAMSELDIN NOURELDIN MOHAMED KHALIL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/05/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-05-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MOHAMED SHAMSELDIN NOURELDIN MOHAMED KHALIL",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-04106",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_47110e2f-2fb9-46ce-a618-5a60ff1e587a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "4f4c22e4-0599-486c-a1cf-569857b8e9f9",
    "slug": "alena-parker",
    "name": "Alena Parker",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BUDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-02-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alena Parker",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02454",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_4f4c22e4-0599-486c-a1cf-569857b8e9f9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "97bda6cd-e1c3-4758-b99c-da04482206d2",
    "slug": "rami-bani-salameh",
    "name": "Rami Bani Salameh",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5SQjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/10/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-10-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rami Bani Salameh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01707",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_97bda6cd-e1c3-4758-b99c-da04482206d2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "47b5655c-ae95-4426-9dd2-96303d2887e5",
    "slug": "mohamed-ahmed-mohamed-mohamed-ghanem",
    "name": "MOHAMED AHMED MOHAMED MOHAMED GHANEM",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/05/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-05-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MOHAMED AHMED MOHAMED MOHAMED GHANEM",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03357",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_47b5655c-ae95-4426-9dd2-96303d2887e5",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "8665faa1-175f-4a11-b124-c5903e6865b2",
    "slug": "sherif-mohamed-sherif-abdelwahab-ali",
    "name": "SHERIF MOHAMED SHERIF ABDELWAHAB ALI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/10/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-10-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: SHERIF MOHAMED SHERIF ABDELWAHAB ALI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01766",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_8665faa1-175f-4a11-b124-c5903e6865b2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "0e4b4c4e-1c72-45f2-b910-24ffde5ba0cf",
    "slug": "claire-elizabeth-barker",
    "name": "CLAIRE ELIZABETH BARKER",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5DRTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-02-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: CLAIRE ELIZABETH BARKER",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00137",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_0e4b4c4e-1c72-45f2-b910-24ffde5ba0cf",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "0dd9500c-f2a3-4fbc-aca6-54cb3d2d0810",
    "slug": "elliott-joseph-eames",
    "name": "ELLIOTT JOSEPH EAMES",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5FSjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/07/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-06-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ELLIOTT JOSEPH EAMES",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00280",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_0dd9500c-f2a3-4fbc-aca6-54cb3d2d0810",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "e092bdb0-6ea7-4b76-a357-39b7ed4ceb5f",
    "slug": "joanna-rita-klat",
    "name": "JOANNA RITA KLAT",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5KUjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/11/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-10-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: JOANNA RITA KLAT",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00953",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_e092bdb0-6ea7-4b76-a357-39b7ed4ceb5f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "f69aa5f0-c8fb-4f60-98f9-2e0479230b9f",
    "slug": "fakih-elmadhoun",
    "name": "Fakih Elmadhoun",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5GRTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/06/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2017-06-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Fakih Elmadhoun",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03202",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_f69aa5f0-c8fb-4f60-98f9-2e0479230b9f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "aa8a6b9a-f589-447c-b4bb-8f7216b5d7f6",
    "slug": "nabil-charaf",
    "name": "Nabil Charaf",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5OQzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/03/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-03-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nabil Charaf",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03674",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_aa8a6b9a-f589-447c-b4bb-8f7216b5d7f6",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "20fb4d94-e8c2-4a71-aae9-1f1f9d8e6eac",
    "slug": "roberta-quacquarini",
    "name": "ROBERTA QUACQUARINI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5SUTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-02-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ROBERTA QUACQUARINI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00344",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_20fb4d94-e8c2-4a71-aae9-1f1f9d8e6eac",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "da79c026-c118-4862-bc1d-b4c8ecec2532",
    "slug": "ana-severova",
    "name": "Ana Severova",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/07/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-07-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ana Severova",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00732",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_da79c026-c118-4862-bc1d-b4c8ecec2532",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "a6b1d75d-7153-4726-9463-895db9791b53",
    "slug": "ceyda-okur",
    "name": "Ceyda Okur",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5DTzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/02/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ceyda Okur",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02895",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_a6b1d75d-7153-4726-9463-895db9791b53",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "78ef24c6-e48a-4f1c-a4b1-5d1bc787b52c",
    "slug": "carolyn-ang-tsu-hsien",
    "name": "CAROLYN ANG TSU HSIEN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5DQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/08/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-08-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: CAROLYN ANG TSU HSIEN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03111",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_78ef24c6-e48a-4f1c-a4b1-5d1bc787b52c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "4f1e1f0b-b4d8-4278-ab40-312e160aa584",
    "slug": "kokila-alagh-gopal-krishan-alagh",
    "name": "KOKILA ALAGH GOPAL KRISHAN ALAGH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5LQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/06/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-06-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: KOKILA ALAGH GOPAL KRISHAN ALAGH",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02597",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_4f1e1f0b-b4d8-4278-ab40-312e160aa584",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "c33dfe62-2e4c-4b7c-bc94-5fde2490242f",
    "slug": "kelly-anne-tymburski",
    "name": "KELLY ANNE TYMBURSKI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5LQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: KELLY ANNE TYMBURSKI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00911",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_c33dfe62-2e4c-4b7c-bc94-5fde2490242f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "20c388f5-3534-410d-a0ba-d3a2e5a87a0b",
    "slug": "rhona-byrne",
    "name": "RHONA BYRNE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5SQjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-02-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: RHONA BYRNE",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01117",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_20c388f5-3534-410d-a0ba-d3a2e5a87a0b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "43e7a0ef-d0c7-4b1c-8a69-e184234b4bbb",
    "slug": "salah-abdulkarim-shawa",
    "name": "Salah Abdulkarim Shawa",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/11/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-11-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Salah Abdulkarim Shawa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02788",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_43e7a0ef-d0c7-4b1c-8a69-e184234b4bbb",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "d4f135d2-a9cb-423d-8ffc-e7ac06c80971",
    "slug": "faris-al-amoudi",
    "name": "Faris Al Amoudi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5GQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/10/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-09-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Faris Al Amoudi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02387",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_d4f135d2-a9cb-423d-8ffc-e7ac06c80971",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "f9235179-89a4-4fe4-b095-27284269e04a",
    "slug": "mathieu-daguerre",
    "name": "MATHIEU DAGUERRE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NRDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/10/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-10-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MATHIEU DAGUERRE",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01532",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_f9235179-89a4-4fe4-b095-27284269e04a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "4aa9c8a1-6002-453b-918e-71ad7ad27515",
    "slug": "ghada-hossameldin-elehwany",
    "name": "Ghada Hossameldin Elehwany",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5HSDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/01/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-01-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ghada Hossameldin Elehwany",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02826",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_4aa9c8a1-6002-453b-918e-71ad7ad27515",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "f0fc49ac-f72f-4bb7-bd60-bf86afa830f4",
    "slug": "christopher-james-young",
    "name": "CHRISTOPHER JAMES YOUNG",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5DSjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-02-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: CHRISTOPHER JAMES YOUNG",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00601",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_f0fc49ac-f72f-4bb7-bd60-bf86afa830f4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "c67b0242-cc06-4ab3-85cb-1f6fc306b390",
    "slug": "james-rayner",
    "name": "James Rayner",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5KUjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/08/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-08-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: James Rayner",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03475",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_c67b0242-cc06-4ab3-85cb-1f6fc306b390",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "5fd44552-43d3-482f-9a4f-13b368aa5b0f",
    "slug": "jamie-liddington",
    "name": "JAMIE LIDDINGTON",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5KTDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/08/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-08-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: JAMIE LIDDINGTON",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02076",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_5fd44552-43d3-482f-9a4f-13b368aa5b0f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "ae3dc26a-7b9f-4f6f-93b1-3808870aa706",
    "slug": "helen-hangari",
    "name": "Helen Hangari",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ISDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-02-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Helen Hangari",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00647",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_ae3dc26a-7b9f-4f6f-93b1-3808870aa706",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "ce5272b5-ddc4-4369-81e6-3484b8d0c520",
    "slug": "simon-mabin",
    "name": "Simon Mabin",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/10/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-09-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Simon Mabin",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00963",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_ce5272b5-ddc4-4369-81e6-3484b8d0c520",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "65fbea2a-9a59-4969-929f-12d8fa71a942",
    "slug": "anna-rimmington",
    "name": "Anna Rimmington",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BUjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Anna Rimmington",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00133",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_65fbea2a-9a59-4969-929f-12d8fa71a942",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "85d9048d-10ac-4abe-9055-0bbf45c8f084",
    "slug": "eleanor-milne",
    "name": "Eleanor Milne",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5FTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-02-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Eleanor Milne",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00219",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_85d9048d-10ac-4abe-9055-0bbf45c8f084",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "e5aef1f3-d2b6-42ce-8ae7-d3e6a88f83dc",
    "slug": "mabrouk-ibrahim-aly",
    "name": "Mabrouk Ibrahim Aly",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NSTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/08/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-07-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mabrouk Ibrahim Aly",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02541",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_e5aef1f3-d2b6-42ce-8ae7-d3e6a88f83dc",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "19092593-e14a-46ce-806c-388cb84a1261",
    "slug": "mohamed-hamdy-fathy",
    "name": "Mohamed Hamdy Fathy",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NSDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/09/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-09-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Hamdy Fathy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01776",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_19092593-e14a-46ce-806c-388cb84a1261",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "b6bcba9d-4075-4038-b201-07d583188adc",
    "slug": "khalila-meggouh",
    "name": "KHALILA MEGGOUH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5LTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/08/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-08-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: KHALILA MEGGOUH",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00501",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_b6bcba9d-4075-4038-b201-07d583188adc",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "ac7af3f2-d7b3-4559-8384-19d638e7ca61",
    "slug": "barnaby-gowrie",
    "name": "Barnaby Gowrie",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5CRzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/01/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2021-01-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Barnaby Gowrie",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-04305",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_ac7af3f2-d7b3-4559-8384-19d638e7ca61",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "3585a7f3-b259-4abc-9630-6d31ed177aee",
    "slug": "elizabeth-riesenburg",
    "name": "ELIZABETH RIESENBURG",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5FUjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/09/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-09-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ELIZABETH RIESENBURG",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01764",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_3585a7f3-b259-4abc-9630-6d31ed177aee",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "a8563264-47f3-4076-9013-2f026f0d5e88",
    "slug": "brian-patrick-gillespie",
    "name": "BRIAN PATRICK GILLESPIE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5CUDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: BRIAN PATRICK GILLESPIE",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00208",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_a8563264-47f3-4076-9013-2f026f0d5e88",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "92d165e5-0172-49e3-ba8c-f40714ba7d84",
    "slug": "ziad-haddad",
    "name": "ZIAD HADDAD",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5aSDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/10/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2017-10-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ZIAD HADDAD",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01039",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_92d165e5-0172-49e3-ba8c-f40714ba7d84",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "afff5e58-0f1b-4aea-88a5-2e7d43b3481c",
    "slug": "ashraf-mohamed-elsaid-gouda-mohamed-azab",
    "name": "ASHRAF MOHAMED ELSAID GOUDA MOHAMED AZAB",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-01-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ASHRAF MOHAMED ELSAID GOUDA MOHAMED AZAB",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02119",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_afff5e58-0f1b-4aea-88a5-2e7d43b3481c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "c0628209-ff1b-4d56-8079-77874d3a1d21",
    "slug": "musa-machooka",
    "name": "Musa Machooka",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-02-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Musa Machooka",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02318",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_c0628209-ff1b-4d56-8079-77874d3a1d21",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "8e3c5bc1-2e67-4a63-98be-b2e3187f3993",
    "slug": "mohammed-qasem-mohammed-obeidat",
    "name": "MOHAMMED QASEM MOHAMMED OBEIDAT",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NUTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/06/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-06-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MOHAMMED QASEM MOHAMMED OBEIDAT",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03780",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_8e3c5bc1-2e67-4a63-98be-b2e3187f3993",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "73505eb2-e386-43a3-8616-31df3a2020c8",
    "slug": "prinstan-joseph",
    "name": "Prinstan Joseph",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5QSjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/01/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-01-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Prinstan Joseph",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02969",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_73505eb2-e386-43a3-8616-31df3a2020c8",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "d72f2d6c-891c-4149-90f2-19aaa15cabb6",
    "slug": "salah-hassan-ibrahim-hassan",
    "name": "SALAH HASSAN IBRAHIM HASSAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TSDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/05/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-05-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: SALAH HASSAN IBRAHIM HASSAN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02781",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_d72f2d6c-891c-4149-90f2-19aaa15cabb6",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "dd875dd1-60fa-4ceb-aa7c-acbf00421424",
    "slug": "lynn-albert-brandes",
    "name": "Lynn-Albert Brandes",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5MQjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2017-02-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Lynn-Albert Brandes",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00719",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_dd875dd1-60fa-4ceb-aa7c-acbf00421424",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "d33e0a21-e6db-4f0c-b16e-a7e445aac802",
    "slug": "hyunjong-kim",
    "name": "HYUNJONG KIM",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ISzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/04/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-04-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: HYUNJONG KIM",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03191",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_d33e0a21-e6db-4f0c-b16e-a7e445aac802",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "42786803-4383-447e-973d-76e8e717e2a1",
    "slug": "dr-frederic-khanian",
    "name": "Dr Frederic Khanian",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ERjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/08/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-08-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Dr Frederic Khanian",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03705",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_42786803-4383-447e-973d-76e8e717e2a1",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "3a9f47fc-1792-49a6-bc59-f6a8edfbfcd1",
    "slug": "sivakumaran-balakrishnan",
    "name": "Sivakumaran Balakrishnan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TQjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/05/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-05-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sivakumaran Balakrishnan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03756",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_3a9f47fc-1792-49a6-bc59-f6a8edfbfcd1",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "c192f5d3-9e10-41a8-a833-dd6399ecae88",
    "slug": "mohamed-awad-sadek-awad-el-esawi",
    "name": "MOHAMED AWAD SADEK AWAD EL ESAWI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/05/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2017-05-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MOHAMED AWAD SADEK AWAD EL ESAWI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02272",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_c192f5d3-9e10-41a8-a833-dd6399ecae88",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "e019f5b5-a6e7-4f70-96d8-8c2996286039",
    "slug": "warren-thomson",
    "name": "Warren Thomson",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5XVDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-02-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Warren Thomson",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00810",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_e019f5b5-a6e7-4f70-96d8-8c2996286039",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "9db2ff92-3ac6-4000-b7b3-112f8220ed85",
    "slug": "alexandra-kvatch",
    "name": "Alexandra Kvatch",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BSzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-02-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Alexandra Kvatch",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00693",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_9db2ff92-3ac6-4000-b7b3-112f8220ed85",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "bbbad1d7-bffd-49b9-b64e-bb58674ef78d",
    "slug": "richard-paul-devine",
    "name": "RICHARD PAUL DEVINE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5SUDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-02-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: RICHARD PAUL DEVINE",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00740",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_bbbad1d7-bffd-49b9-b64e-bb58674ef78d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "94af0834-f4b3-441e-8cab-54e8d4a0b43a",
    "slug": "omar-ziyad-hadi-khurshid-hadi",
    "name": "OMAR ZIYAD HADI KHURSHID HADI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5PWjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/12/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-12-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: OMAR ZIYAD HADI KHURSHID HADI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00119",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_94af0834-f4b3-441e-8cab-54e8d4a0b43a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "80b424dc-7206-40e8-9704-4a570b672fdf",
    "slug": "christopher-mainwaring-taylor",
    "name": "Christopher Mainwaring-Taylor",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5DTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-02-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Christopher Mainwaring-Taylor",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00212",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_80b424dc-7206-40e8-9704-4a570b672fdf",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "40f75b17-5945-4b17-b13f-2bf6c40c28e6",
    "slug": "michiel-visser",
    "name": "Michiel Visser",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NVjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/08/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-08-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Michiel Visser",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03479",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_40f75b17-5945-4b17-b13f-2bf6c40c28e6",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "d3fb99e5-7a25-4288-826a-53ca4716d96e",
    "slug": "mohammed-jahangir-kamal",
    "name": "MOHAMMED JAHANGIR KAMAL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NSjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/09/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-09-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MOHAMMED JAHANGIR KAMAL",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01078",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_d3fb99e5-7a25-4288-826a-53ca4716d96e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "40d70536-b364-4494-8d6f-66a3d9874ca4",
    "slug": "sinead-boden",
    "name": "Sinead Boden",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TQjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/07/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-07-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sinead Boden",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00330",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_40d70536-b364-4494-8d6f-66a3d9874ca4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "d75feb28-6251-4e68-ade0-1af437f0edb7",
    "slug": "benjamin-bruton",
    "name": "Benjamin Bruton",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5CQjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/11/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-11-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Benjamin Bruton",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01713",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_d75feb28-6251-4e68-ade0-1af437f0edb7",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "c8ea1b72-c53d-47ad-9c0f-109658568357",
    "slug": "timothy-watkins",
    "name": "Timothy Watkins",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5UVzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-02-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Timothy Watkins",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00681",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_c8ea1b72-c53d-47ad-9c0f-109658568357",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "aa4306e4-9f5d-4d2d-b861-1a33be931bba",
    "slug": "gordon-blanke",
    "name": "GORDON BLANKE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5HQjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/09/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-09-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: GORDON BLANKE",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01768",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_aa4306e4-9f5d-4d2d-b861-1a33be931bba",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "8719b498-d183-4f81-bd65-a1d94016d8a8",
    "slug": "bahgat-ezzat-ahmed-abdelsamie",
    "name": "Bahgat Ezzat Ahmed Abdelsamie",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5CRTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-02-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Bahgat Ezzat Ahmed Abdelsamie",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02131",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_8719b498-d183-4f81-bd65-a1d94016d8a8",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "06031f81-59a4-44fa-87ae-ab84f586045e",
    "slug": "mohamad-hassan-al-jarrah",
    "name": "MOHAMAD HASSAN AL JARRAH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NSDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/08/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-08-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MOHAMAD HASSAN AL JARRAH",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03433",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_06031f81-59a4-44fa-87ae-ab84f586045e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "87fbd738-8bff-4075-b314-548f8550c085",
    "slug": "mohammed-moyn-uddin",
    "name": "MOHAMMED MOYN UDDIN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/05/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-05-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MOHAMMED MOYN UDDIN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03749",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_87fbd738-8bff-4075-b314-548f8550c085",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "e619cb90-45f5-44c8-b11c-6dde9e680c95",
    "slug": "clare-louise-raven",
    "name": "CLARE LOUISE RAVEN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5DTDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/11/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-11-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: CLARE LOUISE RAVEN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02071",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_e619cb90-45f5-44c8-b11c-6dde9e680c95",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "b25e544c-5669-4a54-b5f7-0faf519aa84a",
    "slug": "ashraf-touhami-abdelazim-mohamed",
    "name": "Ashraf Touhami Abdelazim Mohamed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BVDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/05/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-05-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ashraf Touhami Abdelazim Mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03742",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_b25e544c-5669-4a54-b5f7-0faf519aa84a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "ba5eec75-81c1-4a89-9fb0-e513e77b99d0",
    "slug": "camille-fawzi-chamoun",
    "name": "CAMILLE FAWZI CHAMOUN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5DRjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-02-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: CAMILLE FAWZI CHAMOUN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02780",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_ba5eec75-81c1-4a89-9fb0-e513e77b99d0",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "d12776d0-ef19-42ee-8c43-601369eb3a8c",
    "slug": "zeeshan-ali-dhar",
    "name": "ZEESHAN ALI DHAR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5aQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/09/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-09-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ZEESHAN ALI DHAR",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02295",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_d12776d0-ef19-42ee-8c43-601369eb3a8c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "ff01514b-7191-47da-8a18-42bb5000de46",
    "slug": "nicholas-geoffrey-stuart",
    "name": "NICHOLAS GEOFFREY STUART",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ORzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-02-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: NICHOLAS GEOFFREY STUART",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00241",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_ff01514b-7191-47da-8a18-42bb5000de46",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "6dc05e3f-47bf-4a6d-a9a2-719396b14544",
    "slug": "yehya-mahmoud-hafez-hassan-moamena",
    "name": "YEHYA MAHMOUD HAFEZ HASSAN MOAMENA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ZTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/04/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-04-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: YEHYA MAHMOUD HAFEZ HASSAN MOAMENA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02801",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_6dc05e3f-47bf-4a6d-a9a2-719396b14544",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "2dcfce81-0d13-4f8e-b043-39c7b6c2316c",
    "slug": "nicola-green",
    "name": "Nicola Green",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ORzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/03/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-03-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nicola Green",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-04056",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_2dcfce81-0d13-4f8e-b043-39c7b6c2316c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "60448f74-bff7-4e4f-a075-66101a155da4",
    "slug": "adam-douglas-peters",
    "name": "ADAM DOUGLAS PETERS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BRDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/06/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-06-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ADAM DOUGLAS PETERS",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00630",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_60448f74-bff7-4e4f-a075-66101a155da4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "250973a7-e075-4958-9a7f-99e0aba97de1",
    "slug": "nicola-mariani",
    "name": "NICOLA MARIANI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5OTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/09/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-09-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: NICOLA MARIANI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03860",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_250973a7-e075-4958-9a7f-99e0aba97de1",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "a7aa3f3d-290d-4931-b646-4763ebd5ae63",
    "slug": "ali-awais",
    "name": "Ali Awais",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/05/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-05-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ali Awais",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03750",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_a7aa3f3d-290d-4931-b646-4763ebd5ae63",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "4812a223-0483-4215-868a-aa4a40b3bbb8",
    "slug": "arafa-abdulla-abdelgadir-abdalla",
    "name": "ARAFA ABDULLA ABDELGADIR ABDALLA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ARAFA ABDULLA ABDELGADIR ABDALLA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01365",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_4812a223-0483-4215-868a-aa4a40b3bbb8",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "58e92000-8d56-4929-8a61-33f124978cf8",
    "slug": "jason-ryan-mendens",
    "name": "JASON RYAN MENDENS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5KUjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/08/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-08-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: JASON RYAN MENDENS",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03898",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_58e92000-8d56-4929-8a61-33f124978cf8",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "99bf2012-e805-427f-ba93-5d38e70c325b",
    "slug": "guido-labriola",
    "name": "Guido Labriola",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5HTDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/02/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-02-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Guido Labriola",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03109",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_99bf2012-e805-427f-ba93-5d38e70c325b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "f2605af3-21c3-41ed-8954-3a7c74d161b2",
    "slug": "malek-basel-fared",
    "name": "MALEK BASEL FARED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NQjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/10/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2017-10-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MALEK BASEL FARED",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02002",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_f2605af3-21c3-41ed-8954-3a7c74d161b2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "2bcfa6e9-1db6-4f6e-8fa4-5f6e69649a0f",
    "slug": "mohamed-abdelbadie-abdelaal-khalil",
    "name": "MOHAMED ABDELBADIE ABDELAAL KHALIL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/11/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-10-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MOHAMED ABDELBADIE ABDELAAL KHALIL",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02661",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_2bcfa6e9-1db6-4f6e-8fa4-5f6e69649a0f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "6b68286e-83b9-47f9-b92d-266aee633a08",
    "slug": "mohamed-sewilam-mohamed-mohamed",
    "name": "MOHAMED SEWILAM MOHAMED MOHAMED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/09/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2017-08-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MOHAMED SEWILAM MOHAMED MOHAMED",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01894",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_6b68286e-83b9-47f9-b92d-266aee633a08",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "a1cc00e8-acb9-42cf-adc8-da46d91a11c7",
    "slug": "mohamed-ahmed-aly-ahmed-hamza",
    "name": "MOHAMED AHMED ALY AHMED HAMZA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/02/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-02-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MOHAMED AHMED ALY AHMED HAMZA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-04322",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_a1cc00e8-acb9-42cf-adc8-da46d91a11c7",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "1c408861-7487-4c61-8ac7-30dafcc880f2",
    "slug": "yassir-margani-osman-mustfa",
    "name": "YASSIR MARGANI OSMAN MUSTFA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ZTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/07/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-07-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: YASSIR MARGANI OSMAN MUSTFA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03117",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_1c408861-7487-4c61-8ac7-30dafcc880f2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "a8b89ed9-640b-4c6c-8309-787c47b816a0",
    "slug": "nada-samir-abdul-hamid-boskan",
    "name": "NADA SAMIR ABDUL HAMID BOSKAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5OUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/06/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-06-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: NADA SAMIR ABDUL HAMID BOSKAN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-04137",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_a8b89ed9-640b-4c6c-8309-787c47b816a0",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "292b95a0-2f4a-484f-9710-be6db2fbfe5a",
    "slug": "wafa-moussavi",
    "name": "Wafa Moussavi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5XTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/07/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-07-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Wafa Moussavi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01185",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_292b95a0-2f4a-484f-9710-be6db2fbfe5a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "1ff821cf-2e08-40f7-9b8f-3dbcc8f9821f",
    "slug": "neil-large",
    "name": "NEIL LARGE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5OTDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/10/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-10-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: NEIL LARGE",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-04523",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_1ff821cf-2e08-40f7-9b8f-3dbcc8f9821f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "520f85d5-35e5-438b-bf15-8e26eb854eb4",
    "slug": "bjoern-gehle",
    "name": "BJOERN GEHLE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5CRzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-02-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: BJOERN GEHLE",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00901",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_520f85d5-35e5-438b-bf15-8e26eb854eb4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "c7c057db-5da1-4b77-9e7c-4f835a88fca5",
    "slug": "arti-sangar",
    "name": "Arti Sangar",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-02-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Arti Sangar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01043",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_c7c057db-5da1-4b77-9e7c-4f835a88fca5",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "3e7bfe9b-8212-4d79-80df-b5ededc9dbc8",
    "slug": "valeria-lysenko",
    "name": "VALERIA LYSENKO",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5WTDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/11/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-11-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: VALERIA LYSENKO",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02101",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_3e7bfe9b-8212-4d79-80df-b5ededc9dbc8",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "a9ba4c1b-bd52-432e-8937-71b2965f6728",
    "slug": "amr-abdelrehim-abdulla",
    "name": "Amr Abdelrehim Abdulla",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/09/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-09-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Amr Abdelrehim Abdulla",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02703",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_a9ba4c1b-bd52-432e-8937-71b2965f6728",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "f6fd8590-439d-4265-bc3d-0fa4a74d9a80",
    "slug": "jayshree-rohitash-gupta-lalit-kumar-manilal-shah",
    "name": "JAYSHREE ROHITASH GUPTA LALIT KUMAR MANILAL SHAH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5KUjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-02-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: JAYSHREE ROHITASH GUPTA LALIT KUMAR MANILAL SHAH",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00653",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_f6fd8590-439d-4265-bc3d-0fa4a74d9a80",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "b98589e9-e55a-4a99-8d45-f7245255a0e1",
    "slug": "elsaid-elhanafi-abouelenein-hanafi",
    "name": "ELSAID ELHANAFI ABOUELENEIN HANAFI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5FRTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-02-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ELSAID ELHANAFI ABOUELENEIN HANAFI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01852",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_b98589e9-e55a-4a99-8d45-f7245255a0e1",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "548065a6-da2e-4ce2-9d74-1c1feab74e54",
    "slug": "mohamed-majed-kilarji",
    "name": "MOHAMED MAJED KILARJI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/10/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-09-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MOHAMED MAJED KILARJI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02404",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_548065a6-da2e-4ce2-9d74-1c1feab74e54",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "4fd88c4f-fd08-4ae0-9c8f-864a7f08518a",
    "slug": "stuart-lawrence-davies",
    "name": "STUART LAWRENCE DAVIES",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TTDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/09/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-09-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: STUART LAWRENCE DAVIES",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03877",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_4fd88c4f-fd08-4ae0-9c8f-864a7f08518a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "ee908b99-b191-4b4e-8934-be288d7756c0",
    "slug": "natalie-rosa-poussardin",
    "name": "NATALIE ROSA POUSSARDIN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5OUjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/10/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-09-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: NATALIE ROSA POUSSARDIN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00956",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_ee908b99-b191-4b4e-8934-be288d7756c0",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "937d82d4-7a0a-4b66-a7c0-b6edeaa0bc12",
    "slug": "kerie-receveur",
    "name": "Kerie Receveur",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5LUjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/03/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-03-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Kerie Receveur",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02903",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_937d82d4-7a0a-4b66-a7c0-b6edeaa0bc12",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "410c2af0-3060-4b53-a142-d31ad90d561c",
    "slug": "yasser-soliman-abdelkawi-mohamed",
    "name": "YASSER SOLIMAN ABDELKAWI MOHAMED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ZUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/07/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-07-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: YASSER SOLIMAN ABDELKAWI MOHAMED",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03421",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_410c2af0-3060-4b53-a142-d31ad90d561c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "ce99f03d-2fb8-433a-b5ce-1f36194548ac",
    "slug": "gavin-watson",
    "name": "Gavin Watson",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5HVzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-02-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Gavin Watson",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01058",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_ce99f03d-2fb8-433a-b5ce-1f36194548ac",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "00fc4fb9-8e8a-49ad-ae1f-3a32a3f52c39",
    "slug": "james-griffin",
    "name": "James Griffin",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5KRzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/12/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-12-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: James Griffin",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00687",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_00fc4fb9-8e8a-49ad-ae1f-3a32a3f52c39",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "d6b7131a-cb48-4826-804a-3159e4dbb395",
    "slug": "abdelmoneim-mohamed-elzarka",
    "name": "Abdelmoneim Mohamed Elzarka",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/02/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-02-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abdelmoneim Mohamed Elzarka",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02701",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_d6b7131a-cb48-4826-804a-3159e4dbb395",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "84dc2203-141c-44e6-b181-a1d1fb4f1898",
    "slug": "cara-fox-dwyer",
    "name": "CARA FOX DWYER",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5DRjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/10/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2017-10-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: CARA FOX DWYER",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00475",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_84dc2203-141c-44e6-b181-a1d1fb4f1898",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "cb0bd28e-1a91-4df5-8ebb-20d64c0c6015",
    "slug": "peter-timchur",
    "name": "Peter Timchur",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5QVDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Peter Timchur",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00245",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_cb0bd28e-1a91-4df5-8ebb-20d64c0c6015",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "e7446415-bb4c-4f1c-854f-9695bbcdbd83",
    "slug": "jongeun-lee",
    "name": "Jongeun Lee",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5KTDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/12/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-12-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jongeun Lee",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01743",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_e7446415-bb4c-4f1c-854f-9695bbcdbd83",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "5ad0dd48-01e8-4c36-a1af-30bdda38b0a2",
    "slug": "hani-farouk-abdelhamid-megahed",
    "name": "HANI FAROUK ABDELHAMID MEGAHED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5IRjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/07/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-07-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: HANI FAROUK ABDELHAMID MEGAHED",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03009",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_5ad0dd48-01e8-4c36-a1af-30bdda38b0a2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "8ef64f52-cbd3-4a77-84a9-30fe69f3231d",
    "slug": "mostafa-abouhantash-abdelrahim-teleb",
    "name": "MOSTAFA ABOUHANTASH ABDELRAHIM TELEB",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/12/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-12-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MOSTAFA ABOUHANTASH ABDELRAHIM TELEB",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02840",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_8ef64f52-cbd3-4a77-84a9-30fe69f3231d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "74550949-0893-45c3-b839-231ee2c027a9",
    "slug": "craig-shepherd",
    "name": "Craig Shepherd",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5DUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-02-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Craig Shepherd",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00770",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_74550949-0893-45c3-b839-231ee2c027a9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "26d5fe27-546a-474e-9837-9e28bdfb2688",
    "slug": "gamal-ibrahim-abdelhafez-abdelaty",
    "name": "Gamal Ibrahim Abdelhafez Abdelaty",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5HSTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/06/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-06-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Gamal Ibrahim Abdelhafez Abdelaty",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01996",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_26d5fe27-546a-474e-9837-9e28bdfb2688",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "749ee706-1636-421d-a001-799ac54f9a17",
    "slug": "ibrahim-stephan",
    "name": "Ibrahim Stephan",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5JUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/01/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-01-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ibrahim Stephan",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03987",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_749ee706-1636-421d-a001-799ac54f9a17",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "6269849b-9986-4296-91a6-f30884bd21a9",
    "slug": "robert-patterson",
    "name": "Robert Patterson",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5SUDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/10/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-10-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Robert Patterson",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03531",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_6269849b-9986-4296-91a6-f30884bd21a9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "6ef6ec3b-f867-4609-afda-aea5bfebd836",
    "slug": "christopher-gambrill",
    "name": "Christopher Gambrill",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5DRzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/12/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-12-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Christopher Gambrill",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00686",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_6ef6ec3b-f867-4609-afda-aea5bfebd836",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "6bdaac98-7a2e-496a-8414-d0a4d8c51e24",
    "slug": "mohamed-ibrahim-attia-abdelmoeti",
    "name": "Mohamed Ibrahim Attia Abdelmoeti",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NSTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/09/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-09-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Ibrahim Attia Abdelmoeti",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03855",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_6bdaac98-7a2e-496a-8414-d0a4d8c51e24",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "2bfcf7f7-0e95-40e2-9bbf-34bf579c94e1",
    "slug": "ammar-m-a-abu-namous",
    "name": "AMMAR M A ABU NAMOUS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/03/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-02-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: AMMAR M A ABU NAMOUS",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02617",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_2bfcf7f7-0e95-40e2-9bbf-34bf579c94e1",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "5d21dc90-a9c3-4ae3-a530-74191bc721da",
    "slug": "elie-mikhael",
    "name": "Elie Mikhael",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5FTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/03/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-03-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Elie Mikhael",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02899",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_5d21dc90-a9c3-4ae3-a530-74191bc721da",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "713bd675-da0d-4c87-bf0f-7ca6824de217",
    "slug": "john-bourke",
    "name": "John Bourke",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5KQjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/10/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-09-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: John Bourke",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00513",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_713bd675-da0d-4c87-bf0f-7ca6824de217",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "9462a2fc-8620-4535-8867-7ff9bb642204",
    "slug": "gamal-aly-aly-elgamal",
    "name": "GAMAL ALY ALY ELGAMAL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5HQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/03/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-02-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: GAMAL ALY ALY ELGAMAL",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02122",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_9462a2fc-8620-4535-8867-7ff9bb642204",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "93fdb2a5-7aa5-46ae-8c28-fa59b5d067f7",
    "slug": "jonathan-ivinson",
    "name": "JONATHAN IVINSON",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5KSTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/03/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-03-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: JONATHAN IVINSON",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03698",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_93fdb2a5-7aa5-46ae-8c28-fa59b5d067f7",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "39f90cc5-b313-42c2-8b85-e8094e40e4ef",
    "slug": "ummer-farook-ayaniyad-abdulla-murshinganakkam",
    "name": "UMMER FAROOK AYANIYAD ABDULLA MURSHINGANAKKAM",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5VRjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/10/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-10-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: UMMER FAROOK AYANIYAD ABDULLA MURSHINGANAKKAM",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00442",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_39f90cc5-b313-42c2-8b85-e8094e40e4ef",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "c3ab8495-cc7f-4211-88b9-a298a287f9ec",
    "slug": "edward-hardcastle",
    "name": "Edward Hardcastle",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5FSDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/11/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2017-11-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Edward Hardcastle",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01944",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_c3ab8495-cc7f-4211-88b9-a298a287f9ec",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "3fd6aa50-5b30-4f51-b900-c5d6a4598b18",
    "slug": "paola-petti",
    "name": "PAOLA PETTI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5QUDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-02-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: PAOLA PETTI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01571",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_3fd6aa50-5b30-4f51-b900-c5d6a4598b18",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "002ee6c5-30c5-485d-87a0-61aeceb1db3d",
    "slug": "neale-downes",
    "name": "Neale Downes",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ORDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/01/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-01-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Neale Downes",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01007",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_002ee6c5-30c5-485d-87a0-61aeceb1db3d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "7efdc61e-aa91-439a-95e1-f34d1251035b",
    "slug": "mohamed-kamel-abdellatif-hassaballa",
    "name": "MOHAMED KAMEL ABDELLATIF HASSABALLA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NSzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/01/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-01-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MOHAMED KAMEL ABDELLATIF HASSABALLA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02112",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_7efdc61e-aa91-439a-95e1-f34d1251035b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "79a54d2a-62f9-4a4d-b8f0-6ec0773e9b81",
    "slug": "eveline-montgomerie",
    "name": "Eveline Montgomerie",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5FTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/09/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-09-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Eveline Montgomerie",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02795",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_79a54d2a-62f9-4a4d-b8f0-6ec0773e9b81",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "0652dff3-1dba-440e-9eee-12061acf7bc4",
    "slug": "sheena-sood",
    "name": "Sheena Sood",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/04/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-04-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sheena Sood",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02974",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_0652dff3-1dba-440e-9eee-12061acf7bc4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "924e46ac-0098-4497-b535-e53ea4d24762",
    "slug": "hamish-walton",
    "name": "Hamish Walton",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5IVzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-02-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hamish Walton",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00967",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_924e46ac-0098-4497-b535-e53ea4d24762",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "a411375c-dedd-48ba-821c-2cb6253929c1",
    "slug": "sanad-hasan-salem-saleh",
    "name": "SANAD HASAN SALEM SALEH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TSDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/02/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-02-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: SANAD HASAN SALEM SALEH",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-04007",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_a411375c-dedd-48ba-821c-2cb6253929c1",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "cdd84314-768a-49b8-9c83-c028732dc082",
    "slug": "essam-el-hagar",
    "name": "Essam El Hagar",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5FRTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/08/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2021-08-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Essam El Hagar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03150",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_cdd84314-768a-49b8-9c83-c028732dc082",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "8a84a877-425c-4d99-81e8-492a7d394a71",
    "slug": "owen-edward-waft",
    "name": "OWEN EDWARD WAFT",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5PRTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-02-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: OWEN EDWARD WAFT",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00959",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_8a84a877-425c-4d99-81e8-492a7d394a71",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "85f13187-b341-44ef-99b8-f58265e07c05",
    "slug": "bimal-desai",
    "name": "Bimal Desai",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5CRDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Bimal Desai",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00207",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_85f13187-b341-44ef-99b8-f58265e07c05",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "9bc37385-8c14-4707-bc22-05dc227b5ae9",
    "slug": "ietemad-nour",
    "name": "Ietemad Nour",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5JTjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/03/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2021-03-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ietemad Nour",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02762",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_9bc37385-8c14-4707-bc22-05dc227b5ae9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "a2a3d4fe-7d81-4faf-9b77-4c10e1793ede",
    "slug": "khaled-badry-gadalla-mahmoud",
    "name": "KHALED BADRY GADALLA MAHMOUD",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5LQjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/11/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-11-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: KHALED BADRY GADALLA MAHMOUD",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02055",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_a2a3d4fe-7d81-4faf-9b77-4c10e1793ede",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "eed1f063-4e1b-419c-8552-a0c4e1725e89",
    "slug": "steven-hunt",
    "name": "Steven Hunt",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TSDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/01/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-01-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Steven Hunt",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03071",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_eed1f063-4e1b-419c-8552-a0c4e1725e89",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "d4408fab-93c9-420e-bd8a-e848eaadd455",
    "slug": "warren-roy-luyt",
    "name": "WARREN ROY LUYT",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5XUjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/07/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-07-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: WARREN ROY LUYT",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03845",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_d4408fab-93c9-420e-bd8a-e848eaadd455",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "98a222e1-97c3-4f7b-90d7-b0b901392629",
    "slug": "asief-qureshi",
    "name": "Asief Qureshi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BUTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/08/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2017-08-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Asief Qureshi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03638",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_98a222e1-97c3-4f7b-90d7-b0b901392629",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "953f72aa-b016-4c0d-a952-61858977c784",
    "slug": "duncan-clive-macnab",
    "name": "DUNCAN CLIVE MACNAB",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5EQzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: DUNCAN CLIVE MACNAB",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00218",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_953f72aa-b016-4c0d-a952-61858977c784",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "2414ce08-effe-46d3-8b36-cb4316b64f18",
    "slug": "john-nelson-chrisman",
    "name": "John Nelson Chrisman",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5KTjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/10/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-10-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: John Nelson Chrisman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-04230",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_2414ce08-effe-46d3-8b36-cb4316b64f18",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "c1cad93c-a578-4e33-a989-e5b7e4b6ae07",
    "slug": "iain-goalen",
    "name": "Iain Goalen",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5JRzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/11/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-10-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Iain Goalen",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03541",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_c1cad93c-a578-4e33-a989-e5b7e4b6ae07",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "d4c3de3f-3a62-43f4-9bd0-c9d534ae4ae4",
    "slug": "arumugam-rajenthran",
    "name": "Arumugam Rajenthran",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BUjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/02/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Arumugam Rajenthran",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-04001",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_d4c3de3f-3a62-43f4-9bd0-c9d534ae4ae4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "ee28b1a4-dd03-4f64-8502-f246671bb819",
    "slug": "john-sheils",
    "name": "John Sheils",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5KUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/02/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: John Sheils",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03645",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_ee28b1a4-dd03-4f64-8502-f246671bb819",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "62c096b5-7f72-40e3-854b-298f5a43496d",
    "slug": "yves-bonnard",
    "name": "Yves Bonnard",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ZQjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/04/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-04-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Yves Bonnard",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02471",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_62c096b5-7f72-40e3-854b-298f5a43496d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "5266ec1b-59c4-4e9f-9480-66e551e10e3d",
    "slug": "elhadi-hassan-bakri-ali",
    "name": "ELHADI HASSAN BAKRI ALI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5FSDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/09/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2017-09-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ELHADI HASSAN BAKRI ALI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02047",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_5266ec1b-59c4-4e9f-9480-66e551e10e3d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "cc0318e9-deaf-41cd-8953-cafe3239f03f",
    "slug": "ahmed-mohamed-ismail-elbakari",
    "name": "AHMED MOHAMED ISMAIL ELBAKARI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/11/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-11-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: AHMED MOHAMED ISMAIL ELBAKARI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01965",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_cc0318e9-deaf-41cd-8953-cafe3239f03f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "6c13b6cb-c8a9-4f5f-b276-78e3cc75e00d",
    "slug": "tarek-mohamed-fahmy-mohamed-elrashidy",
    "name": "TAREK MOHAMED FAHMY MOHAMED ELRASHIDY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5UTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/01/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-01-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: TAREK MOHAMED FAHMY MOHAMED ELRASHIDY",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02668",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_6c13b6cb-c8a9-4f5f-b276-78e3cc75e00d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "14630eb9-98fe-4a17-8fd3-e8a6e3d40572",
    "slug": "ahmed-eltigani-babiker-eltigani-ahmed",
    "name": "AHMED ELTIGANI BABIKER ELTIGANI AHMED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BRTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2021-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: AHMED ELTIGANI BABIKER ELTIGANI AHMED",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01703",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_14630eb9-98fe-4a17-8fd3-e8a6e3d40572",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "2030f036-a95c-456c-b846-7046deb3e687",
    "slug": "el-sayed-abdel-wahab-mohamed-elkabily",
    "name": "EL SAYED ABDEL WAHAB MOHAMED ELKABILY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5FUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/11/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-11-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: EL SAYED ABDEL WAHAB MOHAMED ELKABILY",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03917",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_2030f036-a95c-456c-b846-7046deb3e687",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "e43a56a2-6a05-4d0d-9b00-1354c39c9d6e",
    "slug": "boutros-rizk",
    "name": "Boutros Rizk",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5CUjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/02/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2017-02-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Boutros Rizk",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03152",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_e43a56a2-6a05-4d0d-9b00-1354c39c9d6e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "82d5d2d2-f2d1-48b4-95a6-3ca74c562f80",
    "slug": "rami-mamoun-mustafa",
    "name": "Rami Mamoun Mustafa",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5STTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/02/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-02-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rami Mamoun Mustafa",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02854",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_82d5d2d2-f2d1-48b4-95a6-3ca74c562f80",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "f02a2658-2753-46e7-8a86-b7f76cd04adb",
    "slug": "hassan-atreis-mohamed-sayed",
    "name": "HASSAN ATREIS MOHAMED SAYED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5IQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/09/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-09-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: HASSAN ATREIS MOHAMED SAYED",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02427",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_f02a2658-2753-46e7-8a86-b7f76cd04adb",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "c9e23594-e874-4801-88f1-6d0e7ed561ad",
    "slug": "neil-miller",
    "name": "Neil Miller",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5OTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/04/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2016-04-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Neil Miller",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02378",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_c9e23594-e874-4801-88f1-6d0e7ed561ad",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "e5b1a89b-15fa-4d97-8f68-def1968cbd30",
    "slug": "mark-fraser",
    "name": "MARK FRASER",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NRjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/09/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-08-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MARK FRASER",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01004",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_e5b1a89b-15fa-4d97-8f68-def1968cbd30",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "09a18f85-c740-4ddc-b7a9-9d806ca943ac",
    "slug": "khaled-kasem-oraby-selim",
    "name": "KHALED KASEM ORABY SELIM",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5LSzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/01/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-01-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: KHALED KASEM ORABY SELIM",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03956",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_09a18f85-c740-4ddc-b7a9-9d806ca943ac",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "c694b860-789e-4391-bc26-aa6a37f276b6",
    "slug": "louise-roman",
    "name": "Louise Roman",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5MUjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/09/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-09-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Louise Roman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02970",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_c694b860-789e-4391-bc26-aa6a37f276b6",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "45e0f0db-afd7-467d-92a2-671e69cb4427",
    "slug": "caroline-kehoe",
    "name": "Caroline Kehoe",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5DSzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/05/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-05-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Caroline Kehoe",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02171",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_45e0f0db-afd7-467d-92a2-671e69cb4427",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "ab78a448-e2c3-4280-9357-026c43825c72",
    "slug": "michael-diaz",
    "name": "Michael Diaz",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NRDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-02-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Michael Diaz",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01871",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_ab78a448-e2c3-4280-9357-026c43825c72",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "06b8a1d5-aa63-4d60-a07d-72714d68af95",
    "slug": "mahmoud-nasreldin-ahmed-fadeel",
    "name": "Mahmoud Nasreldin Ahmed Fadeel",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NTjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/05/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-05-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mahmoud Nasreldin Ahmed Fadeel",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03757",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_06b8a1d5-aa63-4d60-a07d-72714d68af95",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "22eaf629-1370-42f0-be1a-49fa3c2cc64a",
    "slug": "kerri-lea-lefebvre",
    "name": "KERRI LEA LEFEBVRE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5LTDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-02-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: KERRI LEA LEFEBVRE",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00753",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_22eaf629-1370-42f0-be1a-49fa3c2cc64a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "6fa22b41-60be-472e-b255-37eec74d86bf",
    "slug": "khalil-bazzina-soliman-khalil-ibrahim",
    "name": "KHALIL BAZZINA SOLIMAN KHALIL IBRAHIM",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5LQjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/02/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-02-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: KHALIL BAZZINA SOLIMAN KHALIL IBRAHIM",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01382",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_6fa22b41-60be-472e-b255-37eec74d86bf",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "b2df72f0-7535-4d99-887b-6ed3da82ec6e",
    "slug": "mahmoud-ahmed-hahafi-mahmoud",
    "name": "MAHMOUD AHMED HAHAFI MAHMOUD",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/04/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-04-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MAHMOUD AHMED HAHAFI MAHMOUD",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02242",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_b2df72f0-7535-4d99-887b-6ed3da82ec6e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "8331f0ca-9d3e-4fd2-9c95-2b42a20e070d",
    "slug": "husien-m-aref-husien",
    "name": "HUSIEN M AREF HUSIEN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ITTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/10/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-10-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: HUSIEN M AREF HUSIEN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02664",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_8331f0ca-9d3e-4fd2-9c95-2b42a20e070d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "263a4fba-0b9b-4a64-b294-ae4ce6dcea23",
    "slug": "wahid-abdelaal-ali-osman",
    "name": "Wahid Abdelaal Ali Osman",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5XQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/12/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-11-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Wahid Abdelaal Ali Osman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02053",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_263a4fba-0b9b-4a64-b294-ae4ce6dcea23",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "ec1b05c2-383d-4735-8152-917fba044de1",
    "slug": "abdelsalam-elsiddig-mohamed-ahmed-abdelmutalib",
    "name": "ABDELSALAM ELSIDDIG MOHAMED AHMED ABDELMUTALIB",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BRTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/04/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-04-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ABDELSALAM ELSIDDIG MOHAMED AHMED ABDELMUTALIB",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02598",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_ec1b05c2-383d-4735-8152-917fba044de1",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "2b856599-8817-4364-9f13-c2d061750b9e",
    "slug": "tarek-salah-abdala-ahmed",
    "name": "Tarek Salah Abdala Ahmed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5UUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/11/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-11-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tarek Salah Abdala Ahmed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-0391299",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_2b856599-8817-4364-9f13-c2d061750b9e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "17c9dc4d-51de-4fd9-8ee0-b45b6bbffb5b",
    "slug": "andrew-maccuish",
    "name": "Andrew MacCuish",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/03/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-03-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Andrew MacCuish",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01154",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_17c9dc4d-51de-4fd9-8ee0-b45b6bbffb5b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "4bc41bbc-3446-4309-bdd6-37ec201e6867",
    "slug": "james-foster",
    "name": "James Foster",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5KRjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/01/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-12-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: James Foster",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00831",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_4bc41bbc-3446-4309-bdd6-37ec201e6867",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "8e8906cb-6f9a-401a-8142-eb73ceafddc5",
    "slug": "mohamed-anwar-elsheiwi",
    "name": "Mohamed Anwar ElSheiwi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/07/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-07-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Anwar ElSheiwi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02315",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_8e8906cb-6f9a-401a-8142-eb73ceafddc5",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "b41731a3-128b-4135-acf8-eab1b1919ae6",
    "slug": "ossama-sadek-ibrahim",
    "name": "Ossama Sadek Ibrahim",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5PUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-02-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ossama Sadek Ibrahim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01738",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_b41731a3-128b-4135-acf8-eab1b1919ae6",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "7f17990c-353c-4c2d-a3e1-4be4b549fbc5",
    "slug": "elsayed-abdelmoneim-elsayed-moustafa",
    "name": "ELSAYED ABDELMONEIM ELSAYED MOUSTAFA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5FQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ELSAYED ABDELMONEIM ELSAYED MOUSTAFA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02608",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_7f17990c-353c-4c2d-a3e1-4be4b549fbc5",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "98097a21-2339-4836-ad16-fab9ebc02217",
    "slug": "paul-harter",
    "name": "Paul Harter",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5QSDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-02-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Paul Harter",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00849",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_98097a21-2339-4836-ad16-fab9ebc02217",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "3aae65c8-7c58-43af-8a0b-c4e42d3efbdf",
    "slug": "moueen-hussain-ali",
    "name": "Moueen Hussain Ali",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NSDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-02-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Moueen Hussain Ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02183",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_3aae65c8-7c58-43af-8a0b-c4e42d3efbdf",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "ad333d5e-2cc7-46ea-987e-5f76a8339859",
    "slug": "malek-abdelghani-suleiman",
    "name": "Malek Abdelghani Suleiman",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Malek Abdelghani Suleiman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01664",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_ad333d5e-2cc7-46ea-987e-5f76a8339859",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "62d62679-d755-448a-a335-65af07636f9b",
    "slug": "mitri-najjar",
    "name": "Mitri Najjar",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NTjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-02-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mitri Najjar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00848",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_62d62679-d755-448a-a335-65af07636f9b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "b8589d3a-b354-4a9c-8fcc-36083336c9e2",
    "slug": "jean-elie-kikano",
    "name": "Jean Elie Kikano",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5KRTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/11/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-11-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jean Elie Kikano",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01945",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_b8589d3a-b354-4a9c-8fcc-36083336c9e2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "4f6f1803-e2b7-4e6e-8727-9eb0cfab2ecf",
    "slug": "gamal-elsaid-akel",
    "name": "Gamal Elsaid Akel",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5HRTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/11/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2017-11-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Gamal Elsaid Akel",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02394",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_4f6f1803-e2b7-4e6e-8727-9eb0cfab2ecf",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "ad82df88-3388-4091-9b6d-3f660cda4e3e",
    "slug": "mark-hoyle",
    "name": "Mark Hoyle",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NSDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-02-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mark Hoyle",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00971",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_ad82df88-3388-4091-9b6d-3f660cda4e3e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "3784a36d-03bf-4e42-b6c1-e27a8086fd66",
    "slug": "hassan-abou-fares",
    "name": "Hassan Abou Fares",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5IQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-02-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hassan Abou Fares",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00459",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_3784a36d-03bf-4e42-b6c1-e27a8086fd66",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "2ac89bd4-fa94-4a14-94a3-6ce38045326a",
    "slug": "mustafa-mohamed-abuidris-manoufali",
    "name": "MUSTAFA MOHAMED ABUIDRIS MANOUFALI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/11/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-11-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MUSTAFA MOHAMED ABUIDRIS MANOUFALI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02090",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_2ac89bd4-fa94-4a14-94a3-6ce38045326a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "bc036d17-806e-4261-811e-9c681e65d5cd",
    "slug": "mohamed-ahmed-elhag-mohamed",
    "name": "MOHAMED AHMED ELHAG MOHAMED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/10/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-10-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MOHAMED AHMED ELHAG MOHAMED",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03511",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_bc036d17-806e-4261-811e-9c681e65d5cd",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "a2ffd381-091c-4701-827e-dde46a19b7d9",
    "slug": "hassan-mahdy-ali",
    "name": "Hassan Mahdy Ali",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ITTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hassan Mahdy Ali",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01596",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_a2ffd381-091c-4701-827e-dde46a19b7d9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "9d6772a3-466b-4983-bdb0-891943a7c6ff",
    "slug": "mohamed-abdalla-mohamed-hamad",
    "name": "Mohamed Abdalla Mohamed Hamad",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/09/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-09-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Abdalla Mohamed Hamad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03157",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_9d6772a3-466b-4983-bdb0-891943a7c6ff",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "b2e29c07-bb34-4cbe-a4ea-8e4ac5b02fa8",
    "slug": "khaldoon-talib-rashash-dala-ali",
    "name": "KHALDOON TALIB RASHASH DALA ALI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5LVDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/12/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-12-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: KHALDOON TALIB RASHASH DALA ALI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03012",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_b2e29c07-bb34-4cbe-a4ea-8e4ac5b02fa8",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "d290b56e-1f87-4791-90a9-aa25743cd172",
    "slug": "mohamed-sayed-mohamed-aly-omar",
    "name": "MOHAMED SAYED MOHAMED ALY OMAR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/05/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-05-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MOHAMED SAYED MOHAMED ALY OMAR",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-104105",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_d290b56e-1f87-4791-90a9-aa25743cd172",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "f6dceace-3b3b-41b8-96d1-18f218e7bd68",
    "slug": "justin-ede",
    "name": "Justin Ede",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5KRTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/07/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-07-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Justin Ede",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02631",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_f6dceace-3b3b-41b8-96d1-18f218e7bd68",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "e8a41cea-f43c-40ff-8cd4-3dd9900ccca7",
    "slug": "zaher-mohamed-zaher",
    "name": "Zaher Mohamed Zaher",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5aTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2017-02-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Zaher Mohamed Zaher",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01698",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_e8a41cea-f43c-40ff-8cd4-3dd9900ccca7",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "c7f2b35a-ebbf-451c-9916-1d213a682d95",
    "slug": "bruce-palmer",
    "name": "Bruce Palmer",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5CUDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Bruce Palmer",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00929",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_c7f2b35a-ebbf-451c-9916-1d213a682d95",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "580a447d-5a38-458f-8997-0250b03c44ec",
    "slug": "carter-hoppe",
    "name": "Carter Hoppe",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5DSDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/11/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-11-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Carter Hoppe",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00399",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_580a447d-5a38-458f-8997-0250b03c44ec",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "d07fecb5-e5e6-4141-b750-856712c7bffc",
    "slug": "osama-nachef",
    "name": "Osama Nachef",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5PTjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-02-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Osama Nachef",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00385",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_d07fecb5-e5e6-4141-b750-856712c7bffc",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "8cbcabcc-ec83-47c2-a4d1-749b8677e9c1",
    "slug": "rolf-meyer-reumann",
    "name": "Rolf Meyer-Reumann",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5STTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-02-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rolf Meyer-Reumann",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00345",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_8cbcabcc-ec83-47c2-a4d1-749b8677e9c1",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "dc62a540-7a31-4b31-9ca4-fb291ffc968b",
    "slug": "badreddin-mohamad-almoukhlf",
    "name": "Badreddin Mohamad Almoukhlf",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5CTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/09/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-09-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Badreddin Mohamad Almoukhlf",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02602",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_dc62a540-7a31-4b31-9ca4-fb291ffc968b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "ae606883-59de-449d-8069-7ae49535e592",
    "slug": "donald-bunker",
    "name": "Donald Bunker",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5EQjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-02-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Donald Bunker",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01015",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_ae606883-59de-449d-8069-7ae49535e592",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "1a0dbb18-e36d-4c6b-820a-8fab90e220f4",
    "slug": "fawzi-mohamed-sami-hussein",
    "name": "FAWZI MOHAMED SAMI HUSSEIN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5GTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-02-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: FAWZI MOHAMED SAMI HUSSEIN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01581",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_1a0dbb18-e36d-4c6b-820a-8fab90e220f4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "27725f90-efce-4eb9-b8fd-a82e33cead24",
    "slug": "rasheed-haroun",
    "name": "Rasheed Haroun",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5SSDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/02/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-01-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rasheed Haroun",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00378",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_27725f90-efce-4eb9-b8fd-a82e33cead24",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "5d0bb8b0-a24b-4384-b98d-3b2bcad6c61c",
    "slug": "mohamed-ibrahim-awad-ibrahim",
    "name": "Mohamed Ibrahim Awad Ibrahim",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NSTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/08/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-08-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Ibrahim Awad Ibrahim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03438",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_5d0bb8b0-a24b-4384-b98d-3b2bcad6c61c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "9c0ebd6d-9c15-413f-94d0-9129a9651ed0",
    "slug": "khiloni-jobanputra",
    "name": "Khiloni Jobanputra",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5LSjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/12/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2024-12-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Khiloni Jobanputra",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-06113",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_9c0ebd6d-9c15-413f-94d0-9129a9651ed0",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "a0b38462-718d-4528-aea4-f5df0dfa1f15",
    "slug": "omar-masadeh",
    "name": "OMAR MASADEH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5PTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Criminal Law-Cybercrimes",
      "Commercial Transactions-Bankruptcy",
      "Commercial Transactions-Commercial Contracts"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/01/2026",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: OMAR MASADEH",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07107",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_a0b38462-718d-4528-aea4-f5df0dfa1f15",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "7e54bcf6-31f6-4022-a2fa-9ac0938b603b",
    "slug": "khalid-mohammed-amin-m-dahlawi",
    "name": "Khalid Mohammed Amin M Dahlawi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5LTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/11/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Khalid Mohammed Amin M Dahlawi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-06535",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_7e54bcf6-31f6-4022-a2fa-9ac0938b603b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "159f7fd9-4f8c-4a74-b097-ed2b3e0077eb",
    "slug": "georgios-chrysospathis",
    "name": "GEORGIOS CHRYSOSPATHIS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5HQzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/03/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: GEORGIOS CHRYSOSPATHIS",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-05276",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_159f7fd9-4f8c-4a74-b097-ed2b3e0077eb",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "c57e9178-453d-4aca-adc3-c23f44925a70",
    "slug": "amardeep-kaur-shoker",
    "name": "AMARDEEP KAUR SHOKER",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BSzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/07/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: AMARDEEP KAUR SHOKER",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-04670",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_c57e9178-453d-4aca-adc3-c23f44925a70",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "72c3f2dd-55f7-46e2-b814-b04e32d20461",
    "slug": "john-christopher-skipper",
    "name": "JOHN CHRISTOPHER SKIPPER",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5KQzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/11/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: JOHN CHRISTOPHER SKIPPER",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03820",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_72c3f2dd-55f7-46e2-b814-b04e32d20461",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "d0e7bd96-16a0-4397-81f4-d30425e7c332",
    "slug": "aleksei-batishchev",
    "name": "ALEKSEI BATISHCHEV",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/11/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ALEKSEI BATISHCHEV",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-05502",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_d0e7bd96-16a0-4397-81f4-d30425e7c332",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "139188e7-8115-49d3-8cf0-ef7077011e53",
    "slug": "dina-issa",
    "name": "DINA ISSA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ESTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/12/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: DINA ISSA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-04520",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_139188e7-8115-49d3-8cf0-ef7077011e53",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "678eb9fa-eba7-47d3-a979-b5efe4729e7d",
    "slug": "rizwan-irfan-butt-irfan-mahmood-butt",
    "name": "RIZWAN IRFAN BUTT IRFAN MAHMOOD BUTT",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5SSTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/06/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: RIZWAN IRFAN BUTT IRFAN MAHMOOD BUTT",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-04435",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_678eb9fa-eba7-47d3-a979-b5efe4729e7d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "1ff1f6c5-2e1b-4143-9180-0f55d49c44e0",
    "slug": "pabitra-parthapratim-dutta-parthapratim-nirmal-dutta",
    "name": "PABITRA PARTHAPRATIM DUTTA PARTHAPRATIM NIRMAL DUTTA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5QUDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/11/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: PABITRA PARTHAPRATIM DUTTA PARTHAPRATIM NIRMAL DUTTA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07064",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_1ff1f6c5-2e1b-4143-9180-0f55d49c44e0",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "3d7455f8-36d8-43b0-9c2c-c7394dcbb29e",
    "slug": "mohammed-nageeb-mansoor-al-oj",
    "name": "MOHAMMED NAGEEB MANSOOR AL OJ",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NTjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "12/11/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MOHAMMED NAGEEB MANSOOR AL OJ",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07067",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_3d7455f8-36d8-43b0-9c2c-c7394dcbb29e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "77427592-354e-4a02-bc4b-caacba43bd02",
    "slug": "hadi-albyr-melki",
    "name": "HADI ALBYR MELKI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5IQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/11/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: HADI ALBYR MELKI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07069",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_77427592-354e-4a02-bc4b-caacba43bd02",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "b6ce21cc-6e63-4bce-8533-29596efc18de",
    "slug": "ibrahima-diallo",
    "name": "IBRAHIMA DIALLO",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5JRDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/11/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: IBRAHIMA DIALLO",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07072",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_b6ce21cc-6e63-4bce-8533-29596efc18de",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "c51676ab-f53e-49e4-b171-4037839304e9",
    "slug": "lina-ehab-mohammed-elsawy",
    "name": "LINA EHAB MOHAMMED ELSAWY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5MRTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/11/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: LINA EHAB MOHAMMED ELSAWY",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07073",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_c51676ab-f53e-49e4-b171-4037839304e9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "fed3ce2e-336c-4e80-bf29-7b9bd6c2eee9",
    "slug": "stacey-rachel-white",
    "name": "STACEY RACHEL WHITE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TUjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/11/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: STACEY RACHEL WHITE",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07075",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_fed3ce2e-336c-4e80-bf29-7b9bd6c2eee9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "4e272363-1e2a-46f8-b2ad-4378713cde5a",
    "slug": "hasan-jasim-hasan-al-musawi",
    "name": "HASAN JASIM HASAN AL MUSAWI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ISjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/11/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: HASAN JASIM HASAN AL MUSAWI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07076",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_4e272363-1e2a-46f8-b2ad-4378713cde5a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "b1d8cd16-930d-4565-911c-38e7410b9aff",
    "slug": "seneba-awil-jama",
    "name": "SENEBA AWIL JAMA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/11/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: SENEBA AWIL JAMA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07077",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_b1d8cd16-930d-4565-911c-38e7410b9aff",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "42e222df-0a7f-486e-b01b-5971a379815b",
    "slug": "hany-atef-hussein-elashhat",
    "name": "HANY ATEF HUSSEIN ELASHHAT",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5IQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/11/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: HANY ATEF HUSSEIN ELASHHAT",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07078",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_42e222df-0a7f-486e-b01b-5971a379815b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "7d182a6d-f6c1-4855-bc83-8db9877d0af7",
    "slug": "mohsen-mohammed-mohsen-al-khubani",
    "name": "MOHSEN MOHAMMED MOHSEN AL KHUBANI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/11/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MOHSEN MOHAMMED MOHSEN AL KHUBANI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07079",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_7d182a6d-f6c1-4855-bc83-8db9877d0af7",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "25a8fcae-06b4-4f6d-b1e7-ec7125eb9cde",
    "slug": "michael-gerard-powner",
    "name": "MICHAEL GERARD POWNER",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NRzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/12/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MICHAEL GERARD POWNER",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07084",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_25a8fcae-06b4-4f6d-b1e7-ec7125eb9cde",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "2d055536-52ef-49d5-a544-516f367e1d99",
    "slug": "ban-george-william-lahham",
    "name": "BAN GEORGE WILLIAM LAHHAM",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5CRzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/11/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: BAN GEORGE WILLIAM LAHHAM",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07085",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_2d055536-52ef-49d5-a544-516f367e1d99",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "6df57191-00cd-4e05-ba08-6e425a6027b9",
    "slug": "shouq-haider-abdul-rahman-al-majali",
    "name": "SHOUQ HAIDER ABDUL RAHMAN AL MAJALI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TSDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/12/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: SHOUQ HAIDER ABDUL RAHMAN AL MAJALI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07087",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_6df57191-00cd-4e05-ba08-6e425a6027b9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "27e7a62c-bcff-4823-a270-65680ecc0794",
    "slug": "sultan-nasser-mohamed-al-shidhani",
    "name": "Sultan Nasser Mohamed Al-Shidhani",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TTjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/11/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sultan Nasser Mohamed Al-Shidhani",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07089",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_27e7a62c-bcff-4823-a270-65680ecc0794",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "dffc3276-1afb-4319-9b90-38e4767fc444",
    "slug": "mohannad-salah-ali-mohamed",
    "name": "MOHANNAD SALAH ALI MOHAMED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/12/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MOHANNAD SALAH ALI MOHAMED",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07090",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_dffc3276-1afb-4319-9b90-38e4767fc444",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "1e545535-7d5c-4ac8-b4ae-af3c69be601c",
    "slug": "anda-musaraj",
    "name": "ANDA MUSARAJ",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/12/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ANDA MUSARAJ",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07091",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_1e545535-7d5c-4ac8-b4ae-af3c69be601c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "f05aa01c-5fc2-4851-8982-cc98390a4bca",
    "slug": "himanshu-goswami-dinesh-kumar-goswami",
    "name": "HIMANSHU GOSWAMI DINESH KUMAR GOSWAMI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5IRzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/11/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: HIMANSHU GOSWAMI DINESH KUMAR GOSWAMI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07092",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_f05aa01c-5fc2-4851-8982-cc98390a4bca",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "54b627f4-16fe-46ae-a4bf-6694387ffc24",
    "slug": "antoni-maria-roszkowski",
    "name": "ANTONI MARIA ROSZKOWSKI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/11/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ANTONI MARIA ROSZKOWSKI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07094",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_54b627f4-16fe-46ae-a4bf-6694387ffc24",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "96c8ac4f-3806-4459-8643-07c069d5cfde",
    "slug": "hany-maher-marghany-ibrahim",
    "name": "HANY MAHER MARGHANY IBRAHIM",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ITTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/11/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: HANY MAHER MARGHANY IBRAHIM",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07095",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_96c8ac4f-3806-4459-8643-07c069d5cfde",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "4885cb8b-04d8-4379-b7b5-9a477c6e09e8",
    "slug": "aysegul-wallis",
    "name": "AYSEGUL WALLIS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BVzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/12/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: AYSEGUL WALLIS",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07096",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_4885cb8b-04d8-4379-b7b5-9a477c6e09e8",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "c0e5c3cf-3c5d-4b51-a9b9-5fbf1ac8703b",
    "slug": "hannah-mahmood",
    "name": "HANNAH MAHMOOD",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ITTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/12/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: HANNAH MAHMOOD",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07097",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_c0e5c3cf-3c5d-4b51-a9b9-5fbf1ac8703b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "f246fb35-ec33-48e0-9d84-ad4839399817",
    "slug": "victoria-josephine-may-warner",
    "name": "VICTORIA JOSEPHINE MAY WARNER",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5WSjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/12/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: VICTORIA JOSEPHINE MAY WARNER",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07099",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_f246fb35-ec33-48e0-9d84-ad4839399817",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "fefd408f-7ded-481d-95f2-581ff5421b68",
    "slug": "anjani-rai",
    "name": "Anjani Rai",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BUjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/10/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-07-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Anjani Rai",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02928",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_fefd408f-7ded-481d-95f2-581ff5421b68",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "3b2db99b-edf7-4c90-b410-4eafc119590a",
    "slug": "nadir-mahjoub-badwi-ali",
    "name": "NADIR MAHJOUB BADWI ALI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5OTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/10/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-06-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: NADIR MAHJOUB BADWI ALI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03352",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_3b2db99b-edf7-4c90-b410-4eafc119590a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "67616b21-b6bc-428f-b92d-822ad1f5ca48",
    "slug": "stephen-jurgenson",
    "name": "Stephen Jurgenson",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TSjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/10/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2017-08-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Stephen Jurgenson",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03300",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_67616b21-b6bc-428f-b92d-822ad1f5ca48",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "7b01d5a3-d3ea-42d0-8827-938064c1cd0c",
    "slug": "duane-matthew-keighran",
    "name": "Duane Matthew Keighran",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ETTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/05/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2021-04-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Duane Matthew Keighran",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-04471",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_7b01d5a3-d3ea-42d0-8827-938064c1cd0c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "201192ba-d284-4dfc-9c5f-a28b9058bb88",
    "slug": "mohammed-mansoor-yasin-yasin",
    "name": "Mohammed Mansoor Yasin Yasin",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/10/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-09-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohammed Mansoor Yasin Yasin",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-04437",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_201192ba-d284-4dfc-9c5f-a28b9058bb88",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "1e40734e-fa34-4d41-9399-946f6641f4ab",
    "slug": "cecilia-bicca",
    "name": "CECILIA BICCA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5DQjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/12/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-11-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: CECILIA BICCA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01540",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_1e40734e-fa34-4d41-9399-946f6641f4ab",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "8c2e95d5-e138-4d79-aaa5-028e7e2a5a24",
    "slug": "hisham-eldin-abd-elrahman",
    "name": "Hisham Eldin Abd Elrahman",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5IRTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/09/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-08-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hisham Eldin Abd Elrahman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03580",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_8c2e95d5-e138-4d79-aaa5-028e7e2a5a24",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "a9fa001c-d211-4baf-a879-996d421d76c8",
    "slug": "osama-ahmed-ombada-ahmed",
    "name": "OSAMA AHMED OMBADA AHMED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5PQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/10/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-06-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: OSAMA AHMED OMBADA AHMED",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02674",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_a9fa001c-d211-4baf-a879-996d421d76c8",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "3a4477c8-a3a2-4719-9b40-f31a9438d8f0",
    "slug": "zillah-kate-kisswany",
    "name": "ZILLAH KATE KISSWANY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5aSzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/09/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-07-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ZILLAH KATE KISSWANY",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02935",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_3a4477c8-a3a2-4719-9b40-f31a9438d8f0",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "46f1827d-d7b7-452a-ad0e-a61cba1f18fa",
    "slug": "samir-eid-ibrahim-ghonam",
    "name": "SAMIR EID IBRAHIM GHONAM",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TRTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/06/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-01-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: SAMIR EID IBRAHIM GHONAM",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02057",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_46f1827d-d7b7-452a-ad0e-a61cba1f18fa",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "0fe4d5b7-4b69-456f-b149-2b951e50a1b0",
    "slug": "edesiliwemen-obetoh",
    "name": "Edesiliwemen Obetoh",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5FTzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/12/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-09-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Edesiliwemen Obetoh",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03149",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_0fe4d5b7-4b69-456f-b149-2b951e50a1b0",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "f963deac-de2b-4df3-a30d-1515b4747ca6",
    "slug": "carl-fennessy",
    "name": "Carl Fennessy",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5DRjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/05/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-02-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Carl Fennessy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03089",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_f963deac-de2b-4df3-a30d-1515b4747ca6",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "fded5b6d-6ae7-4ec7-b66d-eec500c4f6c9",
    "slug": "jessika-marie-stadwick",
    "name": "JESSIKA MARIE STADWICK",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5KTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/12/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: JESSIKA MARIE STADWICK",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01270",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_fded5b6d-6ae7-4ec7-b66d-eec500c4f6c9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "f8b96e5b-8053-4eed-9d3a-08b3f956da55",
    "slug": "abdelhafiz-abdelhamid-abdelhafiz-serageldin",
    "name": "ABDELHAFIZ ABDELHAMID ABDELHAFIZ SERAGELDIN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/05/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2017-03-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ABDELHAFIZ ABDELHAMID ABDELHAFIZ SERAGELDIN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01987",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_f8b96e5b-8053-4eed-9d3a-08b3f956da55",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "7cde0faa-36b2-4436-9544-4266017a6cec",
    "slug": "ahmed-essam-el-din-mohamed-arif",
    "name": "AHMED ESSAM EL DIN MOHAMED ARIF",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BRTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/08/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-01-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: AHMED ESSAM EL DIN MOHAMED ARIF",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00565",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_7cde0faa-36b2-4436-9544-4266017a6cec",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "6021f2b6-9965-4c93-aefe-0310969ce22e",
    "slug": "ahmed-abdelmoaty-hafez-ibrahim-mohamed-elads",
    "name": "AHMED ABDELMOATY HAFEZ IBRAHIM MOHAMED ELADS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/12/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2017-10-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: AHMED ABDELMOATY HAFEZ IBRAHIM MOHAMED ELADS",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03201",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_6021f2b6-9965-4c93-aefe-0310969ce22e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "61aa6129-48c4-41cf-ab0a-833d62308d36",
    "slug": "peter-hansen",
    "name": "Peter Hansen",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5QSDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/08/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2017-05-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Peter Hansen",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02737",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_61aa6129-48c4-41cf-ab0a-833d62308d36",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "aabd7fe6-7745-40bb-b1f6-5c8bbbe5b028",
    "slug": "nour-jasim-hineidi",
    "name": "NOUR JASIM HINEIDI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5OSjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/05/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-03-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: NOUR JASIM HINEIDI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02912",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_aabd7fe6-7745-40bb-b1f6-5c8bbbe5b028",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "1a2f7041-7268-4402-a6a1-2d62d01bc389",
    "slug": "sophie-philippa-neilson",
    "name": "SOPHIE PHILIPPA NEILSON",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TUDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/08/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-06-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: SOPHIE PHILIPPA NEILSON",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03555",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_1a2f7041-7268-4402-a6a1-2d62d01bc389",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "f20dcc30-60a5-4533-90b2-22a86dcbffc2",
    "slug": "adnan-ashraf-ashraf",
    "name": "Adnan Ashraf Ashraf",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/07/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-01-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Adnan Ashraf Ashraf",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02449",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_f20dcc30-60a5-4533-90b2-22a86dcbffc2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "da15a287-f29c-4ef0-85da-aceeec8ff6d2",
    "slug": "agha-sahib",
    "name": "Agha Sahib",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/05/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2017-02-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Agha Sahib",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02676",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_da15a287-f29c-4ef0-85da-aceeec8ff6d2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "0911b174-a3b9-47fe-8472-c2afe662dfee",
    "slug": "abdelhamid-ahmed-farag-mahmoud",
    "name": "ABDELHAMID AHMED FARAG MAHMOUD",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/04/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-02-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ABDELHAMID AHMED FARAG MAHMOUD",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03574",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_0911b174-a3b9-47fe-8472-c2afe662dfee",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "1c552f3f-3cf6-4d4a-b569-6747ddbee4fe",
    "slug": "alan-fraser-henderson",
    "name": "ALAN FRASER HENDERSON",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BRjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/11/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-04-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ALAN FRASER HENDERSON",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00358",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_1c552f3f-3cf6-4d4a-b569-6747ddbee4fe",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "4acc5207-2440-4a41-a2ce-1f10546fa1d8",
    "slug": "alec-james-emmerson",
    "name": "ALEC JAMES EMMERSON",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BSjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/11/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-04-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ALEC JAMES EMMERSON",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00259",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_4acc5207-2440-4a41-a2ce-1f10546fa1d8",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "2081b728-a051-4c5a-9a3a-4ff0b2833937",
    "slug": "alexander-thomas-hillback",
    "name": "ALEXANDER THOMAS HILLBACK",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BVDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/04/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-03-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ALEXANDER THOMAS HILLBACK",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-04219",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_2081b728-a051-4c5a-9a3a-4ff0b2833937",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "49547178-ecfc-464c-afd7-b6437623110a",
    "slug": "amjad-f-m-jandaly",
    "name": "AMJAD F M JANDALY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BRjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/03/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-02-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: AMJAD F M JANDALY",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03686",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_49547178-ecfc-464c-afd7-b6437623110a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "1b79737c-d760-4915-b912-88e83b1321ed",
    "slug": "allison-joanna-beirne",
    "name": "ALLISON JOANNA BEIRNE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BSjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/11/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-04-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ALLISON JOANNA BEIRNE",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00262",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_1b79737c-d760-4915-b912-88e83b1321ed",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "3dce96ad-c65e-4758-9b9a-6946b29ee221",
    "slug": "amany-ahmed-kamal-ahmed-elbagoury",
    "name": "AMANY AHMED KAMAL AHMED ELBAGOURY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/06/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-05-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: AMANY AHMED KAMAL AHMED ELBAGOURY",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03880",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_3dce96ad-c65e-4758-9b9a-6946b29ee221",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "290f399d-d481-4039-9858-41a07e2f6c19",
    "slug": "andrew-david-kirk",
    "name": "ANDREW DAVID KIRK",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BRDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/11/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-07-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ANDREW DAVID KIRK",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02580",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_290f399d-d481-4039-9858-41a07e2f6c19",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "3b1c96b2-c67a-45d2-afc4-3703c2db9906",
    "slug": "anne-kristin-hoffmann-da-silva",
    "name": "ANNE KRISTIN HOFFMANN DA SILVA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BSzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/11/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-05-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ANNE KRISTIN HOFFMANN DA SILVA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01906",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_3b1c96b2-c67a-45d2-afc4-3703c2db9906",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "fbad7ffb-efb0-46ac-9ce3-0c31371c75c1",
    "slug": "aseel-abdulameer-hasan",
    "name": "ASEEL ABDULAMEER HASAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/05/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-02-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ASEEL ABDULAMEER HASAN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03222",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_fbad7ffb-efb0-46ac-9ce3-0c31371c75c1",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "69d86fe4-b952-48f2-88d2-7150f31d9da5",
    "slug": "ashraf-ibrahim-maysour-ahmed-hafze-shoukri",
    "name": "ASHRAF IBRAHIM MAYSOUR AHMED HAFZE SHOUKRI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BSTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/12/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-09-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ASHRAF IBRAHIM MAYSOUR AHMED HAFZE SHOUKRI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03141",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_69d86fe4-b952-48f2-88d2-7150f31d9da5",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "d8cf1c48-3f81-4518-b62f-3254b6f99267",
    "slug": "benjamin-stewart-dancy",
    "name": "BENJAMIN STEWART DANCY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5CUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/08/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-03-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: BENJAMIN STEWART DANCY",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02639",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_d8cf1c48-3f81-4518-b62f-3254b6f99267",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "f3d6fb51-46a5-40e7-920f-1098a391e19a",
    "slug": "christos-charalambous",
    "name": "CHRISTOS CHARALAMBOUS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5DQzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/08/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-04-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: CHRISTOS CHARALAMBOUS",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02882",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_f3d6fb51-46a5-40e7-920f-1098a391e19a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "1eb2279e-d657-4139-b882-78eade6d1b59",
    "slug": "dania-umair-ansari-umair-khalid-ansari",
    "name": "DANIA UMAIR ANSARI UMAIR KHALID ANSARI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5EVTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/11/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-10-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: DANIA UMAIR ANSARI UMAIR KHALID ANSARI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-04295",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_1eb2279e-d657-4139-b882-78eade6d1b59",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "7dfd3517-fafe-4c3b-9f17-5cad16b03b80",
    "slug": "donya-fredj",
    "name": "DONYA FREDJ",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ERjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/07/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-03-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: DONYA FREDJ",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03244",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_7dfd3517-fafe-4c3b-9f17-5cad16b03b80",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "8eee843b-c0bf-4529-a60e-b4712b0a3eb2",
    "slug": "ekta-malhotra-sunil-malhotra",
    "name": "EKTA MALHOTRA SUNIL MALHOTRA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5FTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/11/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-07-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: EKTA MALHOTRA SUNIL MALHOTRA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03004",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_8eee843b-c0bf-4529-a60e-b4712b0a3eb2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "eca5dc85-6fe7-40a5-8228-9182c36f6a06",
    "slug": "faizal-puthusseril-latheef-puthusseril-said-muhammed-abdul-latheef",
    "name": "FAIZAL PUTHUSSERIL LATHEEF PUTHUSSERIL SAID MUHAMMED ABDUL LATHEEF",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5GUDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/08/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-04-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: FAIZAL PUTHUSSERIL LATHEEF PUTHUSSERIL SAID MUHAMMED ABDUL LATHEEF",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03176",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_eca5dc85-6fe7-40a5-8228-9182c36f6a06",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "d8407922-95b3-450c-90b7-87c23d616f20",
    "slug": "fareya-azfar-azfar-obaidullah",
    "name": "FAREYA AZFAR AZFAR OBAIDULLAH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5GQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/04/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-02-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: FAREYA AZFAR AZFAR OBAIDULLAH",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01696",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_d8407922-95b3-450c-90b7-87c23d616f20",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "8134a1f7-7811-4924-96c4-7903ffd5c707",
    "slug": "farzaneh-hosseini",
    "name": "FARZANEH HOSSEINI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5GSDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/01/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: FARZANEH HOSSEINI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03949",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_8134a1f7-7811-4924-96c4-7903ffd5c707",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "f6d74348-43d6-4c19-8123-de432bf68460",
    "slug": "fouad-faris-fouad-shaban",
    "name": "FOUAD FARIS FOUAD SHABAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5GRjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/10/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-08-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: FOUAD FARIS FOUAD SHABAN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03496",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_f6d74348-43d6-4c19-8123-de432bf68460",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "be924388-d6d2-47f9-8887-a47478f7858d",
    "slug": "galina-gedrovich",
    "name": "GALINA GEDROVICH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5HRzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/12/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-11-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: GALINA GEDROVICH",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02961",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_be924388-d6d2-47f9-8887-a47478f7858d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "a9e21362-1ab5-4382-bd4e-380946ece33a",
    "slug": "hannah-rashid",
    "name": "Hannah Rashid",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5IUjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/07/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-03-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Hannah Rashid",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02572",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_a9e21362-1ab5-4382-bd4e-380946ece33a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "13433db6-3639-4bf2-a65b-8ea57ab35187",
    "slug": "giulia-de-michelis",
    "name": "GIULIA DE MICHELIS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5HRDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/09/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-06-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: GIULIA DE MICHELIS",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03301",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_13433db6-3639-4bf2-a65b-8ea57ab35187",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "d2965f77-6ea0-4622-8b63-ba7a1e65c656",
    "slug": "hatem-mohamed-elsayed-elafify",
    "name": "HATEM MOHAMED ELSAYED ELAFIFY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ITTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/11/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2017-10-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: HATEM MOHAMED ELSAYED ELAFIFY",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03497",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_d2965f77-6ea0-4622-8b63-ba7a1e65c656",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "78ee111a-05db-4bff-b12e-fc139c0c09f2",
    "slug": "irina-heaver",
    "name": "IRINA HEAVER",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5JSDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/12/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-11-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: IRINA HEAVER",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03937",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_78ee111a-05db-4bff-b12e-fc139c0c09f2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "54cfb2d6-f7d7-47a3-9fab-703821250f4d",
    "slug": "ismail-fathi-mohamed-elazhary",
    "name": "ISMAIL FATHI MOHAMED ELAZHARY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5JRjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/10/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-05-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ISMAIL FATHI MOHAMED ELAZHARY",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01399",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_54cfb2d6-f7d7-47a3-9fab-703821250f4d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "5d43967e-0951-4bfd-9356-431254b9fa9e",
    "slug": "ibrahim-eldesouky-elsayed-taha-salama-metawe",
    "name": "IBRAHIM ELDESOUKY ELSAYED TAHA SALAMA METAWE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5JRTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/04/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-03-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: IBRAHIM ELDESOUKY ELSAYED TAHA SALAMA METAWE",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-04157",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_5d43967e-0951-4bfd-9356-431254b9fa9e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "3f0b512a-f05a-448b-a4f3-713f3ef37378",
    "slug": "michael-lipman",
    "name": "MICHAEL LIPMAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NTDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/03/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-01-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MICHAEL LIPMAN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03607",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_3f0b512a-f05a-448b-a4f3-713f3ef37378",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "1145a2b5-3e03-4b36-97ed-017eef6c2221",
    "slug": "michelle-louise-ayed",
    "name": "MICHELLE LOUISE AYED",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NTDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/04/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-01-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MICHELLE LOUISE AYED",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03198",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_1145a2b5-3e03-4b36-97ed-017eef6c2221",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "8aa03913-8f30-418e-a27e-250a747549d9",
    "slug": "mohamed-mohamed-moustafa-radwan",
    "name": "MOHAMED MOHAMED MOUSTAFA RADWAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/02/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-01-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MOHAMED MOHAMED MOUSTAFA RADWAN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03717",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_8aa03913-8f30-418e-a27e-250a747549d9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "7e3ae131-5254-4d8f-b33b-39a77d3060f9",
    "slug": "prarthna-chaddha-arvind-chaddha",
    "name": "PRARTHNA CHADDHA ARVIND CHADDHA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5QQzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/11/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-04-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: PRARTHNA CHADDHA ARVIND CHADDHA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00317",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_7e3ae131-5254-4d8f-b33b-39a77d3060f9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "4553d259-2915-4fc4-9a72-3cd8d79d9846",
    "slug": "royston-pendley",
    "name": "ROYSTON PENDLEY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5SUDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/05/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-03-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ROYSTON PENDLEY",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01025",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_4553d259-2915-4fc4-9a72-3cd8d79d9846",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "b0a80edd-a9ca-4b89-8f9d-a2452c59c379",
    "slug": "kristian-perussich",
    "name": "KRISTIAN PERUSSICH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5LUDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/11/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-09-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: KRISTIAN PERUSSICH",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-04011",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_b0a80edd-a9ca-4b89-8f9d-a2452c59c379",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "b7b9c80d-9a92-45e6-922c-7e191f2e6570",
    "slug": "sahar-anwar-ahmed-ali-badran",
    "name": "SAHAR ANWAR AHMED ALI BADRAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/11/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-10-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: SAHAR ANWAR AHMED ALI BADRAN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03961",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_b7b9c80d-9a92-45e6-922c-7e191f2e6570",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "57e2cadf-eabf-4d1f-8a34-429473a9e29d",
    "slug": "sami-osman",
    "name": "SAMI OSMAN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TTzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/03/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-01-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: SAMI OSMAN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03545",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_57e2cadf-eabf-4d1f-8a34-429473a9e29d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "a1c4adf5-8b0f-4ad6-9362-a401d845dfaa",
    "slug": "laura-jane-capelin",
    "name": "LAURA JANE CAPELIN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5MSjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/06/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-01-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: LAURA JANE CAPELIN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02844",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_a1c4adf5-8b0f-4ad6-9362-a401d845dfaa",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "88fa62aa-c790-4996-b4bb-26a12b2854b0",
    "slug": "leah-mcdoom",
    "name": "LEAH MCDOOM",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5MTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/11/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-10-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: LEAH MCDOOM",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-04161",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_88fa62aa-c790-4996-b4bb-26a12b2854b0",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "7c85e5f5-9904-4355-b118-00ec386a74a7",
    "slug": "shah-saber-ahmed-farooqi",
    "name": "SHAH SABER AHMED FAROOQI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/04/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-01-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: SHAH SABER AHMED FAROOQI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03136",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_7c85e5f5-9904-4355-b118-00ec386a74a7",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "b1ee7a70-5121-41dc-9d25-9c0961f8ffbf",
    "slug": "suraya-turk",
    "name": "SURAYA TURK",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TVDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/03/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-01-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: SURAYA TURK",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03552",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_b1ee7a70-5121-41dc-9d25-9c0961f8ffbf",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "06b1ea0d-34c9-4036-a553-0151b32347e6",
    "slug": "mahmoud-shehat-saber-shehata",
    "name": "MAHMOUD SHEHAT SABER SHEHATA",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/05/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-04-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MAHMOUD SHEHAT SABER SHEHATA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-04030",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_06b1ea0d-34c9-4036-a553-0151b32347e6",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "b7752020-9ee9-476f-8dfa-f9878dd2eed6",
    "slug": "thaaer-moqbl-khairi-aljuboori",
    "name": "THAAER MOQBL KHAIRI ALJUBOORI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5UTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/08/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-02-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: THAAER MOQBL KHAIRI ALJUBOORI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01820",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_b7752020-9ee9-476f-8dfa-f9878dd2eed6",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "e033ea83-65a3-4bf8-ad54-dca1644352b5",
    "slug": "martin-botik",
    "name": "Martin Botik",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NQjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/07/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2017-01-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Martin Botik",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00503",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_e033ea83-65a3-4bf8-ad54-dca1644352b5",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "dfe54e1a-527c-404f-ad85-3956f12b3cb1",
    "slug": "matthew-culver",
    "name": "Matthew Culver",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NQzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/12/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2017-07-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Matthew Culver",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01083",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_dfe54e1a-527c-404f-ad85-3956f12b3cb1",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "a8da598e-f890-4204-966a-f623f719305b",
    "slug": "varun-vaid-mukul-vaid",
    "name": "VARUN VAID MUKUL VAID",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5WVjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/04/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-03-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: VARUN VAID MUKUL VAID",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03835",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_a8da598e-f890-4204-966a-f623f719305b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "f274b44a-5b93-42fc-aa69-047a199f054d",
    "slug": "victoria-caroline-yates",
    "name": "VICTORIA CAROLINE YATES",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5WQzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/05/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-04-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: VICTORIA CAROLINE YATES",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03653",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_f274b44a-5b93-42fc-aa69-047a199f054d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "b6e83b0f-6562-4970-994e-b6c385a0f489",
    "slug": "vsevolod-sazonov",
    "name": "VSEVOLOD SAZONOV",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5WUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/09/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-07-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: VSEVOLOD SAZONOV",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03346",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_b6e83b0f-6562-4970-994e-b6c385a0f489",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "72107370-76b1-4dba-83b8-754330307ccd",
    "slug": "michelle-mansour",
    "name": "MICHELLE MANSOUR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/10/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-09-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MICHELLE MANSOUR",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-04065",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_72107370-76b1-4dba-83b8-754330307ccd",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "64b6eaa7-29e3-4a30-bf1a-52e33c80acfc",
    "slug": "zahra-saleem-baig",
    "name": "ZAHRA SALEEM BAIG",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5aUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/05/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-04-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ZAHRA SALEEM BAIG",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03633",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_64b6eaa7-29e3-4a30-bf1a-52e33c80acfc",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "c5cbe807-0809-4519-9fb2-bfcd34728321",
    "slug": "mohamedelmogtaba-kamal-mohamed-hussein",
    "name": "MOHAMEDELMOGTABA KAMAL MOHAMED HUSSEIN",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NSzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/11/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-10-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MOHAMEDELMOGTABA KAMAL MOHAMED HUSSEIN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03999",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_c5cbe807-0809-4519-9fb2-bfcd34728321",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "4f999f2f-a2bd-49af-92c9-8a88ac8335a8",
    "slug": "nicolas-melki",
    "name": "Nicolas Melki",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5OTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/04/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-01-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nicolas Melki",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03326",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_4f999f2f-a2bd-49af-92c9-8a88ac8335a8",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "d1e2f915-16bb-4d39-ad98-ea1e1b0e6519",
    "slug": "pavel-zhivkov-kalev",
    "name": "PAVEL ZHIVKOV KALEV",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5QWjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/09/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-06-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: PAVEL ZHIVKOV KALEV",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03344",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_d1e2f915-16bb-4d39-ad98-ea1e1b0e6519",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "7dcba1fa-66d9-46be-9137-0573a7a96f67",
    "slug": "prateek-karamchandani",
    "name": "PRATEEK KARAMCHANDANI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5QSzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/04/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-01-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: PRATEEK KARAMCHANDANI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03571",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_7dcba1fa-66d9-46be-9137-0573a7a96f67",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "54bcf9b1-318e-4455-8587-9ce6ca4f8dcc",
    "slug": "rabih-el-fakhry",
    "name": "RABIH EL FAKHRY",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5SRTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/10/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-07-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: RABIH EL FAKHRY",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03351",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_54bcf9b1-318e-4455-8587-9ce6ca4f8dcc",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "3d35f863-75c0-406f-8612-0fb9985f0ac2",
    "slug": "rachel-dawson",
    "name": "Rachel Dawson",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5SRDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/02/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2017-01-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Rachel Dawson",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02533",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_3d35f863-75c0-406f-8612-0fb9985f0ac2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "aa61f355-7aeb-4134-9821-2d4af5ea1f04",
    "slug": "racheal-mosunmola-adepeju-sanni",
    "name": "RACHEAL MOSUNMOLA ADEPEJU SANNI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5STTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/11/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-09-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: RACHEAL MOSUNMOLA ADEPEJU SANNI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03196",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_aa61f355-7aeb-4134-9821-2d4af5ea1f04",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "149911da-e484-4992-a273-3fa9d78844ab",
    "slug": "rula-mohd-rajab-nasser",
    "name": "RULA MOHD RAJAB NASSER",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5STTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/10/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-08-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: RULA MOHD RAJAB NASSER",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03871",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_149911da-e484-4992-a273-3fa9d78844ab",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "fe7627d0-abd1-4b2e-ad28-14bf277c70db",
    "slug": "sameh-ashour",
    "name": "Sameh Ashour",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/09/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2017-07-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sameh Ashour",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03308",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_fe7627d0-abd1-4b2e-ad28-14bf277c70db",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "5ea03c12-037b-4d61-9b03-0be54749a72d",
    "slug": "sarah-malik",
    "name": "SARAH MALIK",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/06/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-01-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: SARAH MALIK",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02568",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_5ea03c12-037b-4d61-9b03-0be54749a72d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "119766b6-789d-4907-a726-0518140b365d",
    "slug": "sharon-phyllis-stultz-karim",
    "name": "Sharon Phyllis Stultz Karim",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TUDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/11/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2017-05-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sharon Phyllis Stultz Karim",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-01752",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_119766b6-789d-4907-a726-0518140b365d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "109d045e-5dc4-4235-9693-ac90074373d4",
    "slug": "sharif-subhi-sebastian-hamadeh",
    "name": "SHARIF SUBHI SEBASTIAN HAMADEH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/11/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-03-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: SHARIF SUBHI SEBASTIAN HAMADEH",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00327",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_109d045e-5dc4-4235-9693-ac90074373d4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "36331c9c-d65d-48da-bc4c-e85edbe15a0c",
    "slug": "yasser-balall-yaqub",
    "name": "YASSER BALALL YAQUB",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ZQjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/07/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2017-06-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: YASSER BALALL YAQUB",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00865",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_36331c9c-d65d-48da-bc4c-e85edbe15a0c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "04e984c3-9906-48bf-ad7a-6e1c56e59f0a",
    "slug": "jawahir-alsubaie",
    "name": "Jawahir Alsubaie",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5KQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/11/2016",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-09-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jawahir Alsubaie",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03242",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_04e984c3-9906-48bf-ad7a-6e1c56e59f0a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "5af91e2e-e18a-4df1-a506-ed310e275263",
    "slug": "jeremie-witt",
    "name": "Jeremie Witt",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5KVzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/10/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-04-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jeremie Witt",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00908",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_5af91e2e-e18a-4df1-a506-ed310e275263",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "ae9ff9fa-806f-42da-b547-a2dece2886cd",
    "slug": "lindsay-macdonald",
    "name": "Lindsay Macdonald",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5MTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/12/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-11-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Lindsay Macdonald",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03913",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_ae9ff9fa-806f-42da-b547-a2dece2886cd",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "d29a53b1-fd52-4943-8b32-857d7994c138",
    "slug": "maha-abdulrahman-a-alnowaisser",
    "name": "Maha Abdulrahman A Alnowaisser",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/05/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-04-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Maha Abdulrahman A Alnowaisser",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03923",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_d29a53b1-fd52-4943-8b32-857d7994c138",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "72ba705a-40b4-4f48-92c8-a133ee2d0d26",
    "slug": "maliha-laith-maan-abu-nowar",
    "name": "MALIHA LAITH MAAN ABU NOWAR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NTDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/05/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-04-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MALIHA LAITH MAAN ABU NOWAR",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03992",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_72ba705a-40b4-4f48-92c8-a133ee2d0d26",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "23f4266b-9ab0-438f-add9-833a271303bc",
    "slug": "marc-hammerson",
    "name": "Marc Hammerson",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NSDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/09/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-05-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Marc Hammerson",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02720",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_23f4266b-9ab0-438f-add9-833a271303bc",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "f1b3e8a9-1be2-4701-bbbc-c3beb07f0890",
    "slug": "michael-o-reilly",
    "name": "Michael O'Reilly",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NTzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/11/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-04-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Michael O'Reilly",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00364",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_f1b3e8a9-1be2-4701-bbbc-c3beb07f0890",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "9456950a-c194-4bfe-88f5-86623054bc08",
    "slug": "mohammed-mosilhy",
    "name": "Mohammed Mosilhy",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/05/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-04-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohammed Mosilhy",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03611",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_9456950a-c194-4bfe-88f5-86623054bc08",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "3bfade27-1651-4c1c-8ba3-a113c492f271",
    "slug": "mohamed-taha-elghamri-elattar",
    "name": "MOHAMED TAHA ELGHAMRI ELATTAR",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NVDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/12/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-08-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: MOHAMED TAHA ELGHAMRI ELATTAR",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02418",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_3bfade27-1651-4c1c-8ba3-a113c492f271",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "ed637d67-ccc9-4648-bf86-03799529fb28",
    "slug": "takamasa-makita",
    "name": "Takamasa Makita",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5UTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/11/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-04-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Takamasa Makita",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00335",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_ed637d67-ccc9-4648-bf86-03799529fb28",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "26447377-20d3-4d04-8e59-d668dfb50c6d",
    "slug": "wael-nazir-obeid",
    "name": "Wael Nazir Obeid",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5XTjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/07/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-02-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Wael Nazir Obeid",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02118",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_26447377-20d3-4d04-8e59-d668dfb50c6d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "f25d33a2-f7f0-451b-a9d0-4c14a03d3c5e",
    "slug": "adele-louise-merifield",
    "name": "Adele Louise Merifield",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BTDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/11/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-10-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Adele Louise Merifield",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-04012",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_f25d33a2-f7f0-451b-a9d0-4c14a03d3c5e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "b5a2c08a-b8ed-4413-bb4f-01c0bea0379c",
    "slug": "ahmed-mahmoud-hafez-morsi",
    "name": "Ahmed Mahmoud Hafez Morsi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/06/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-04-03",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Ahmed Mahmoud Hafez Morsi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03692",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_b5a2c08a-b8ed-4413-bb4f-01c0bea0379c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "dfb7a93a-0fc4-435e-ba8e-4f682f992ad2",
    "slug": "asees-kaur-johar",
    "name": "Asees Kaur Johar",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BSzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/09/2019",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-08-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Asees Kaur Johar",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-04293",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_dfb7a93a-0fc4-435e-ba8e-4f682f992ad2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "bf3d8c3a-20a7-4039-b53a-1ba025a439f9",
    "slug": "craig-joseph-abbott",
    "name": "Craig Joseph Abbott",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5DSjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/12/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-10-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Craig Joseph Abbott",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-04040",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_bf3d8c3a-20a7-4039-b53a-1ba025a439f9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "0d036150-2e9c-4f83-8c84-e07b74006221",
    "slug": "madeleine-patricia-haller",
    "name": "Madeleine Patricia Haller",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NUDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/03/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-02-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Madeleine Patricia Haller",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03948",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_0d036150-2e9c-4f83-8c84-e07b74006221",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "8d2efe50-d8d8-4259-a6f1-fabfe0615cdb",
    "slug": "wouter-sebastian-frederik-kolkman",
    "name": "Wouter Sebastian Frederik Kolkman",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5XUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/04/2018",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-03-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Wouter Sebastian Frederik Kolkman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-04198",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_8d2efe50-d8d8-4259-a6f1-fabfe0615cdb",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "ba15eb78-6692-4453-9d2d-5f9dd2bbbb3f",
    "slug": "daniel-john-page",
    "name": "DANIEL JOHN PAGE",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ESjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/11/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-04-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: DANIEL JOHN PAGE",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00360",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_ba15eb78-6692-4453-9d2d-5f9dd2bbbb3f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "86b85974-6aff-499c-a553-33eef40c7a69",
    "slug": "nicholas-white",
    "name": "Nicholas White",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5OVzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/11/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2017-05-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Nicholas White",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00365",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_86b85974-6aff-499c-a553-33eef40c7a69",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "99cfd48e-c8d6-465e-a783-11554e3c53d6",
    "slug": "sharafeldein-elsiddig-muhmoud-elsiddig",
    "name": "SHARAFELDEIN ELSIDDIG MUHMOUD ELSIDDIG",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TRTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/10/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2018-09-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: SHARAFELDEIN ELSIDDIG MUHMOUD ELSIDDIG",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03581",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_99cfd48e-c8d6-465e-a783-11554e3c53d6",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "c0234871-947e-43de-b407-a63858cd9aff",
    "slug": "samir-mahmoud-abdelgawad-mohamed",
    "name": "Samir Mahmoud Abdelgawad Mohamed",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/12/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-10-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Samir Mahmoud Abdelgawad Mohamed",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03854",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_c0234871-947e-43de-b407-a63858cd9aff",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "17e09e1b-9f28-4cca-9874-3272ab1b645d",
    "slug": "mohammed-karbal",
    "name": "Mohammed Karbal",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NSzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/09/2011",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-02-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohammed Karbal",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-00458",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_17e09e1b-9f28-4cca-9874-3272ab1b645d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "9e41e8b1-040f-4ee9-929b-2c6ef5a8a4c7",
    "slug": "abdalla-ibrahim-elmahdi",
    "name": "Abdalla Ibrahim Elmahdi",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BSTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/09/2012",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-02-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Abdalla Ibrahim Elmahdi",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02353",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_9e41e8b1-040f-4ee9-929b-2c6ef5a8a4c7",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "2501a870-6a0d-4011-aae9-9f1ad168b70d",
    "slug": "jasvinder-moman",
    "name": "Jasvinder Moman",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5KTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/08/2013",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-02-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Jasvinder Moman",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02563",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_2501a870-6a0d-4011-aae9-9f1ad168b70d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "7c62cb47-ed0c-47fd-b0d9-300de31956d9",
    "slug": "karim-zein",
    "name": "Karim Zein",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5LWjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/12/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-08-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Karim Zein",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02845",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_7c62cb47-ed0c-47fd-b0d9-300de31956d9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "02b8fc4c-ccef-450c-8b28-b26ab55cea69",
    "slug": "lulia-hito",
    "name": "Lulia Hito",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5MSDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/07/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-03-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Lulia Hito",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03253",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_02b8fc4c-ccef-450c-8b28-b26ab55cea69",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "7623d643-41d0-459c-ae7e-211c75e2d7de",
    "slug": "mohamed-ahmed-gad",
    "name": "Mohamed Ahmed Gad",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/07/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-01-11",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Mohamed Ahmed Gad",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02774",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_7623d643-41d0-459c-ae7e-211c75e2d7de",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "1f0d2def-2c72-4cd8-a2c3-a24fec75a0c2",
    "slug": "satish-grover",
    "name": "Satish Grover",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TRzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/09/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-05-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Satish Grover",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03099",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_1f0d2def-2c72-4cd8-a2c3-a24fec75a0c2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "061621dc-dd59-4b1d-aecc-2de4b4b76a24",
    "slug": "sheridan-steiger",
    "name": "Sheridan Steiger",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/12/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-08-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Sheridan Steiger",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03096",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_061621dc-dd59-4b1d-aecc-2de4b4b76a24",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "a3b5befa-4951-412e-831c-1eae6a6be42a",
    "slug": "tamer-farouk-azzab",
    "name": "Tamer Farouk Azzab",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5URjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/07/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-02-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tamer Farouk Azzab",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02773",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_a3b5befa-4951-412e-831c-1eae6a6be42a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "a8d58152-5ab5-4bd9-a94a-8b69ba4cf517",
    "slug": "tarig-mubarak-osman-elnour",
    "name": "Tarig Mubarak Osman Elnour",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5UTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/09/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-05-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Tarig Mubarak Osman Elnour",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03336",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_a8d58152-5ab5-4bd9-a94a-8b69ba4cf517",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "9d18a09e-db82-401e-805f-7ddcf1dfa666",
    "slug": "thomas-burke",
    "name": "Thomas Burke",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5UQjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/05/2015",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-01-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Thomas Burke",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-02910",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_9d18a09e-db82-401e-805f-7ddcf1dfa666",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "83b70271-c1bb-44c8-a860-17715c7f7b27",
    "slug": "dixin-deng",
    "name": "Dixin Deng",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ERDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/10/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-07-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Dixin Deng",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03725",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_83b70271-c1bb-44c8-a860-17715c7f7b27",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "cf41d393-5cf8-427c-98b2-4c4035746990",
    "slug": "emma-fox",
    "name": "Emma Fox",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5FRjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/07/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-05-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Emma Fox",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03812",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_cf41d393-5cf8-427c-98b2-4c4035746990",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "64c8e6b6-f82c-4980-b149-ee71d5639a86",
    "slug": "eric-mannion",
    "name": "Eric Mannion",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5FTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "31/10/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-07-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Eric Mannion",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03584",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_64c8e6b6-f82c-4980-b149-ee71d5639a86",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "d9ffe69c-4467-4f62-9ba7-214c02b2425a",
    "slug": "irfan-butt",
    "name": "Irfan Butt",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5JQjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "04/09/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2019-07-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Irfan Butt",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-03723",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_d9ffe69c-4467-4f62-9ba7-214c02b2425a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "5ecf560e-8142-4662-b641-7de093148136",
    "slug": "hayley-ryerson",
    "name": "HAYLEY RYERSON",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5IUjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Commercial Transactions-Commercial Contracts",
      "Commercial Transactions-Commercial Contracts",
      "Commercial Transactions-Commercial Companies",
      "Commercial Transactions-Commercial Companies"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/01/2026",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: HAYLEY RYERSON",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07111",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_5ecf560e-8142-4662-b641-7de093148136",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "056d096e-b0af-43d4-9a1b-3d1fda6b933d",
    "slug": "jennifer-dool",
    "name": "JENNIFER DOOL",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5KRDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Commercial Transactions-Commercial Real Estate",
      "Civil Transactions-Residential Real Estate"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/01/2026",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: JENNIFER DOOL",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07122",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_056d096e-b0af-43d4-9a1b-3d1fda6b933d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "f5e9f37f-f8b2-45f6-bf5c-1d401fdaa157",
    "slug": "niaz-bux",
    "name": "NIAZ BUX",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5OQjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Proceedings-Cases and Proceedings before arbitral tribunals and other alternative dispute resolution bodies",
      "Commercial Transactions-Commercial Contracts",
      "Commercial Transactions-Commercial Real Estate"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/01/2026",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: NIAZ BUX",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07110",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_f5e9f37f-f8b2-45f6-bf5c-1d401fdaa157",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "e44f2d66-690e-4524-a90a-66c5bcb79da5",
    "slug": "hany-gaber",
    "name": "HANY GABER",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5IRzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Commercial Transactions-Commercial Contracts",
      "Civil Transactions-Construction and Contracts for Services",
      "Civil Transactions-Residential Real Estate"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/01/2026",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: HANY GABER",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07119",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_e44f2d66-690e-4524-a90a-66c5bcb79da5",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "5f66611d-8b3a-490c-b04b-eed568e03144",
    "slug": "tarik-sharif",
    "name": "TARIK SHARIF",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5UUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Civil Transactions-Compensation",
      "Civil Transactions-Arbitration"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/01/2026",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: TARIK SHARIF",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07123",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_5f66611d-8b3a-490c-b04b-eed568e03144",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "008bc04b-8883-43e0-9ebd-5deb0d823aa8",
    "slug": "hussein-olleik",
    "name": "HUSSEIN OLLEIK",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ITzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Proceedings-Cases and Proceedings before Dubai International Financial Centre",
      "Proceedings-Cases and Proceedings before arbitral tribunals and other alternative dispute resolution bodies",
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Proceedings-Cases and Proceedings before Dubai International Financial Centre",
      "Proceedings-Cases and Proceedings before arbitral tribunals and other alternative dispute resolution bodies"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/01/2026",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: HUSSEIN OLLEIK",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07124",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_008bc04b-8883-43e0-9ebd-5deb0d823aa8",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "b1f6f184-8e73-43bb-9779-e36ccceabd5d",
    "slug": "anita-budeiri",
    "name": "ANITA BUDEIRI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Commercial Transactions-Commercial Real Estate"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/01/2026",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ANITA BUDEIRI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07125",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_b1f6f184-8e73-43bb-9779-e36ccceabd5d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "cf5855d6-afb0-4be3-ac93-56ccf549833c",
    "slug": "ghazal-hawwari",
    "name": "GHAZAL HAWWARI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5HSDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Commercial Transactions-Commercial Contracts",
      "Commercial Transactions-Commercial Companies",
      "Commercial Transactions-Commercial Agency"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/01/2026",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: GHAZAL HAWWARI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07120",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_cf5855d6-afb0-4be3-ac93-56ccf549833c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "0aa07556-b19c-4384-a5da-62422cda9efb",
    "slug": "ahmad-chami",
    "name": "AHMAD CHAMI",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Personal Status-Legacies and Inheritance",
      "Personal Status-Wills",
      "Commercial Transactions-Commercial Contracts"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/01/2026",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: AHMAD CHAMI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07113",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_0aa07556-b19c-4384-a5da-62422cda9efb",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "c718a4e1-ecad-4645-b09e-a1ab644c13ab",
    "slug": "antara-das",
    "name": "ANTARA DAS",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BRDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Commercial Transactions-Commercial Contracts",
      "Commercial Transactions-Commercial Companies",
      "Commercial Transactions-Commercial Real Estate"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/01/2026",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: ANTARA DAS",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-07112",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_c718a4e1-ecad-4645-b09e-a1ab644c13ab",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "ddd58b0d-7690-4781-9b17-fc8f8c277f29",
    "slug": "vanessa-mwaka-chipo-simpungwe",
    "name": "Vanessa Mwaka Chipo Simpungwe",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5WTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/11/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: Vanessa Mwaka Chipo Simpungwe",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-05659",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_ddd58b0d-7690-4781-9b17-fc8f8c277f29",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "7bcccc9e-38ea-4787-b395-aa99abbfad56",
    "slug": "ali-alkindi-legal-consultants",
    "name": "Ali Alkindi Legal Consultants",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Ali Alkindi Legal Consultants",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_7bcccc9e-38ea-4787-b395-aa99abbfad56",
        "address": "Office No.507-17, Mai Tower,Al Nahda First, Dubai,UNITED ARAB EMIRATES",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No.507-17, Mai Tower,Al Nahda First, Dubai,UNITED ARAB EMIRATES"
  },
  {
    "id": "fd196763-7167-4914-ac71-6781c56c219f",
    "slug": "hamad-alneyadi-legal-consultancy",
    "name": "HAMAD ALNEYADI LEGAL CONSULTANCY",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5IQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: HAMAD ALNEYADI LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_fd196763-7167-4914-ac71-6781c56c219f",
        "address": "-",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "حمد مطر راشد بن مسيعد النيادي",
    "address": "-"
  },
  {
    "id": "489402d0-8aa9-4d2b-bbba-44aba3044a9e",
    "slug": "mahran-international-legal-solutions-mils",
    "name": "Mahran International Legal Solutions (MILS)",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NSTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Mahran International Legal Solutions (MILS)",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_489402d0-8aa9-4d2b-bbba-44aba3044a9e",
        "address": "-",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "محمد محمود عبد الرحيم حسين مهران",
    "address": "-"
  },
  {
    "id": "e82d6699-fb3b-4c97-9cf4-7c3e3021f884",
    "slug": "three-crowns-middle-east-llp",
    "name": "Three Crowns (Middle East) LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5UQzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Three Crowns (Middle East) LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_e82d6699-fb3b-4c97-9cf4-7c3e3021f884",
        "address": "Units 703, Level 7, Burj Daman,Dubai International Financial Centre, Dubai, UNITED ARAB EMIRATES",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Units 703, Level 7, Burj Daman,Dubai International Financial Centre, Dubai, UNITED ARAB EMIRATES"
  },
  {
    "id": "1083f5d0-8a1c-45ce-abb6-6e29c21b6c56",
    "slug": "tyche-capital-legal-consultancy",
    "name": "TYCHE CAPITAL LEGAL CONSULTANCY",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5UQzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: TYCHE CAPITAL LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_1083f5d0-8a1c-45ce-abb6-6e29c21b6c56",
        "address": "-",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "NATHAN NACER EDDINE TAFER",
    "address": "-"
  },
  {
    "id": "5593008e-c977-42bc-a17f-ef5a5f9264ab",
    "slug": "abdulla-hmeid-legal-consultants",
    "name": "Abdulla Hmeid Legal Consultants",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BSDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Abdulla Hmeid Legal Consultants",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_5593008e-c977-42bc-a17f-ef5a5f9264ab",
        "address": "Level 4, Gate No.2, Hamarain Centre, P.O.Box 722, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Level 4, Gate No.2, Hamarain Centre, P.O.Box 722, Dubai"
  },
  {
    "id": "91d96fd9-96ee-4a6b-964a-c561c1ad7f82",
    "slug": "agha-and-co",
    "name": "Agha and Co",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Agha and Co",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_91d96fd9-96ee-4a6b-964a-c561c1ad7f82",
        "address": "Office No.101, Al Barsha Boutique Building, Al Barsha 01, P.O.Box 390104, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No.101, Al Barsha Boutique Building, Al Barsha 01, P.O.Box 390104, Dubai"
  },
  {
    "id": "c161ae8e-7a7b-49c9-a21f-843e3db6a686",
    "slug": "amereller-legal-consultancy-l-l-c-s-o-c",
    "name": "Amereller Legal Consultancy L.L.C S.O.C",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BTDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Amereller Legal Consultancy L.L.C S.O.C",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_c161ae8e-7a7b-49c9-a21f-843e3db6a686",
        "address": "Office No.1402, Level 14, One Business Bay, Sheikh Zayed Road, P.O. Box 97706, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No.1402, Level 14, One Business Bay, Sheikh Zayed Road, P.O. Box 97706, Dubai"
  },
  {
    "id": "0492ad2a-1799-4edf-99b2-3c0f62151839",
    "slug": "anders-legal-consultancy-l-l-c",
    "name": "Anders Legal Consultancy L.L.C",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BTDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Anders Legal Consultancy L.L.C",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_0492ad2a-1799-4edf-99b2-3c0f62151839",
        "address": "Office No.801 & 806, Level 08, Sama Tower, Sheikh Zayed Road, P.O. Box 333558, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No.801 & 806, Level 08, Sama Tower, Sheikh Zayed Road, P.O. Box 333558, Dubai"
  },
  {
    "id": "cc9c83b0-5029-400d-8ac4-99fee7f6b266",
    "slug": "ashish-mehta-associates-legal-consultants-l-l-c",
    "name": "Ashish Mehta & Associates Legal Consultants L.L.C",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Ashish Mehta & Associates Legal Consultants L.L.C",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_cc9c83b0-5029-400d-8ac4-99fee7f6b266",
        "address": "Office No.702, Saeed Tower 2, Trade Centre First, P.O.Box 32045, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No.702, Saeed Tower 2, Trade Centre First, P.O.Box 32045, Dubai"
  },
  {
    "id": "a1c5c1ea-fff4-4084-b587-6768aba19bd8",
    "slug": "bae-kim-lee-llc-dwtc-branch",
    "name": "Bae, Kim & Lee LLC (DWTC Branch)",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5CSzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Bae, Kim & Lee LLC (DWTC Branch)",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_a1c5c1ea-fff4-4084-b587-6768aba19bd8",
        "address": "Unit No. 233, Level 02, The Offices 1-One Central, Dubai World Trade Centre,",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Unit No. 233, Level 02, The Offices 1-One Central, Dubai World Trade Centre,"
  },
  {
    "id": "1322e6f1-d61f-4327-80f9-44a8e03d55f9",
    "slug": "bennett-jones-middle-east-llp",
    "name": "Bennett Jones (Middle East) LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5CSjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Bennett Jones (Middle East) LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_1322e6f1-d61f-4327-80f9-44a8e03d55f9",
        "address": "Level 13, East Wing, The Gate Building, Dubai International Financial Centre, P.O. Box 482016, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Level 13, East Wing, The Gate Building, Dubai International Financial Centre, P.O. Box 482016, Dubai"
  },
  {
    "id": "09237ff7-2e8f-486c-902e-b5649fe2c8e8",
    "slug": "bonnard-lawson-legal-consultants-llc",
    "name": "Bonnard Lawson Legal Consultants LLC",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5CTDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Bonnard Lawson Legal Consultants LLC",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_09237ff7-2e8f-486c-902e-b5649fe2c8e8",
        "address": "Office No.2501, Level 25, Al Habtoor Business Tower, Dubai Marina, P.O.Box 450136, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No.2501, Level 25, Al Habtoor Business Tower, Dubai Marina, P.O.Box 450136, Dubai"
  },
  {
    "id": "445dda10-24fc-4d52-8e63-9593b2b320d8",
    "slug": "carter-hoppe-legal-consultants",
    "name": "Carter Hoppe Legal Consultants",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5DSDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Carter Hoppe Legal Consultants",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_445dda10-24fc-4d52-8e63-9593b2b320d8",
        "address": "Office 407, Al Abbas Building 2,Bank Street, Bur Dubai P.O.Box 31737, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office 407, Al Abbas Building 2,Bank Street, Bur Dubai P.O.Box 31737, Dubai"
  },
  {
    "id": "0b6fc3a8-e691-4318-9bd8-05f8350414a2",
    "slug": "chadbourne-park-llc-dubai-branch",
    "name": "Chadbourne & Park LLC (Dubai Branch)",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5DUDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Chadbourne & Park LLC (Dubai Branch)",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_0b6fc3a8-e691-4318-9bd8-05f8350414a2",
        "address": "Unit No.2001-2002-2004, Level 20, Boulevard Plaza Tower 1, Burj Khalifa District, P.O.Box 23927, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Unit No.2001-2002-2004, Level 20, Boulevard Plaza Tower 1, Burj Khalifa District, P.O.Box 23927, Dubai"
  },
  {
    "id": "d9dc7fae-3f01-4d4f-9ffa-81d6201b60df",
    "slug": "charles-russel-speechlys-llp",
    "name": "Charles Russel Speechlys LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5DUjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Charles Russel Speechlys LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_d9dc7fae-3f01-4d4f-9ffa-81d6201b60df",
        "address": "Office No. 2002,Level 20,Index Tower,Dubai International Financial Centre,P.O. Box 507226, Dubai,United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 2002,Level 20,Index Tower,Dubai International Financial Centre,P.O. Box 507226, Dubai,United Arab Emirates"
  },
  {
    "id": "edcc011c-96e0-4124-b381-17d9958354b1",
    "slug": "clifford-chance-llp-ded",
    "name": "Clifford Chance LLP-DED",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5DQzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Clifford Chance LLP-DED",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_edcc011c-96e0-4124-b381-17d9958354b1",
        "address": "Level 15, Burj Daman, Dubai International Financial Centre, P.O. Box 9380, Dubai, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Level 15, Burj Daman, Dubai International Financial Centre, P.O. Box 9380, Dubai, United Arab Emirates"
  },
  {
    "id": "0bf3b396-0954-4ba0-aaf2-914cbb016a95",
    "slug": "cms-cameron-mckenna-llp-dmcc-branch",
    "name": "CMS Cameron McKenna LLP (DMCC Branch)",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5DQzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: CMS Cameron McKenna LLP (DMCC Branch)",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_0bf3b396-0954-4ba0-aaf2-914cbb016a95",
        "address": "Unit No. 3207-9, Platinum Tower, Cluster I, Jumeirah Lake Towers, P. O. Box 336750",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Unit No. 3207-9, Platinum Tower, Cluster I, Jumeirah Lake Towers, P. O. Box 336750"
  },
  {
    "id": "9d0001cf-fdfa-4f71-888d-da709d1761fa",
    "slug": "colin-biggers-paisley-lawyers-middle-east",
    "name": "Colin Biggers & Paisley Lawyers ( Middle East)",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5DQjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Colin Biggers & Paisley Lawyers ( Middle East)",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_9d0001cf-fdfa-4f71-888d-da709d1761fa",
        "address": "Office No.11, Al Khabeesi Pony Building, Al Khabeesi, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No.11, Al Khabeesi Pony Building, Al Khabeesi, Dubai"
  },
  {
    "id": "29ef4737-3c21-47a5-95c3-59fa76bea1f4",
    "slug": "conyers-dill-pearman-limited",
    "name": "Conyers Dill & Pearman Limited",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5DRDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Conyers Dill & Pearman Limited",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_29ef4737-3c21-47a5-95c3-59fa76bea1f4",
        "address": "Level 02, Gate Village 4,Dubai International Financial Centre, P.O. Box 506528, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Level 02, Gate Village 4,Dubai International Financial Centre, P.O. Box 506528, Dubai"
  },
  {
    "id": "cad867a9-d1b3-41b6-b261-6998f6aa813d",
    "slug": "dentons-co-dubai-branch",
    "name": "Dentons & Co Dubai Branch",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5EQzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Dentons & Co Dubai Branch",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_cad867a9-d1b3-41b6-b261-6998f6aa813d",
        "address": "Level 18, Boulevard Plaza 2, Burj Khalifa District, P.O. Box 1756, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Level 18, Boulevard Plaza 2, Burj Khalifa District, P.O. Box 1756, Dubai"
  },
  {
    "id": "e8d00efb-7d56-42ab-a1f7-c318f138c158",
    "slug": "dentons-co-difc",
    "name": "Dentons & Co- DIFC",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5EQzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Dentons & Co- DIFC",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_e8d00efb-7d56-42ab-a1f7-c318f138c158",
        "address": "Office No.708, Level 7, Liberty House, Dubai International Financial Centre, P.O Box 1756, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No.708, Level 7, Liberty House, Dubai International Financial Centre, P.O Box 1756, Dubai"
  },
  {
    "id": "90880b05-adfa-4ff5-9cf0-e7db42febad9",
    "slug": "diaz-reus-targ-dubai-llp",
    "name": "Diaz Reus & Targ (Dubai) LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5EUjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Diaz Reus & Targ (Dubai) LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_90880b05-adfa-4ff5-9cf0-e7db42febad9",
        "address": "Office No. 31, Level 03, Gate Village 04, Dubai International Financial Centre, P.O. Box 113355, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 31, Level 03, Gate Village 04, Dubai International Financial Centre, P.O. Box 113355, Dubai"
  },
  {
    "id": "ea8fede1-dbaa-4b3c-bf6f-53264ec316e6",
    "slug": "everys-legal-consultancy-dubai-branch",
    "name": "Everys Legal Consultancy (Dubai Branch)",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5FTDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Everys Legal Consultancy (Dubai Branch)",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_ea8fede1-dbaa-4b3c-bf6f-53264ec316e6",
        "address": "Office No. 2501, The Faimont, Sheikh Zayed Road, P.O. Box 73310, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 2501, The Faimont, Sheikh Zayed Road, P.O. Box 73310, Dubai"
  },
  {
    "id": "b7caea4a-c188-4e40-8abf-85def329e0da",
    "slug": "ferris-co",
    "name": "Ferris & Co",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5GQzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Ferris & Co",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_b7caea4a-c188-4e40-8abf-85def329e0da",
        "address": "Office No.2303, Al Moosa Tower 2, Sheikh Zayed Road, P.O.Box 75542, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No.2303, Al Moosa Tower 2, Sheikh Zayed Road, P.O.Box 75542, Dubai"
  },
  {
    "id": "66874e1d-ac12-496f-84f1-c7e05d059f67",
    "slug": "freshfields-llp-difc",
    "name": "Freshfields LLP-DIFC",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5GTDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Freshfields LLP-DIFC",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_66874e1d-ac12-496f-84f1-c7e05d059f67",
        "address": "Level 13, ICD Brookfield Place,, Dubai International Financial Centre Sheikh Zayed Road, P.O.Box 506569, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Level 13, ICD Brookfield Place,, Dubai International Financial Centre Sheikh Zayed Road, P.O.Box 506569, Dubai"
  },
  {
    "id": "877b1e81-7a34-4183-a4e3-8a0717c9f9e5",
    "slug": "freshfields-llp-ded",
    "name": "Freshfields LLP-DED",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5GTDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Freshfields LLP-DED",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_877b1e81-7a34-4183-a4e3-8a0717c9f9e5",
        "address": "Office No.823, Tamani Arts Office, Business Bay, P.O. Box 506569, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No.823, Tamani Arts Office, Business Bay, P.O. Box 506569, Dubai"
  },
  {
    "id": "f07df3fb-b054-48c3-8a25-e0ee0cc71776",
    "slug": "fulbright-jaworski-llp",
    "name": "Fulbright & Jaworski LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5GSjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Fulbright & Jaworski LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_f07df3fb-b054-48c3-8a25-e0ee0cc71776",
        "address": "Level 24, Festival Tower, Dubai Festival City, P.O.Box 35767, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Level 24, Festival Tower, Dubai Festival City, P.O.Box 35767, Dubai"
  },
  {
    "id": "01c200eb-4f44-4415-8a9a-bfcb49bf6051",
    "slug": "gardi-associates",
    "name": "Gardi & Associates",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5HQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Gardi & Associates",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_01c200eb-4f44-4415-8a9a-bfcb49bf6051",
        "address": "Office No.301, Faisal Abdullah Saleh Al Gurg Building, Oud Metha, Bur Dubai , P.O. Box 22489, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No.301, Faisal Abdullah Saleh Al Gurg Building, Oud Metha, Bur Dubai , P.O. Box 22489, Dubai"
  },
  {
    "id": "c5753ad9-51e5-4239-8b15-7c7116084937",
    "slug": "hassan-elamin-legal-consultancy",
    "name": "Hassan Elamin Legal Consultancy",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5IRTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Hassan Elamin Legal Consultancy",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_c5753ad9-51e5-4239-8b15-7c7116084937",
        "address": "Office No.203-11, Clover Bay Tower, Business Bay, P.O. Box 66111, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No.203-11, Clover Bay Tower, Business Bay, P.O. Box 66111, Dubai"
  },
  {
    "id": "ebcd0087-4e1c-4df2-98ea-166e562daa98",
    "slug": "iaa-middle-east-legal-consultants-ltd",
    "name": "IAA (Middle East) Legal Consultants Ltd",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5JKDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: IAA (Middle East) Legal Consultants Ltd",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_ebcd0087-4e1c-4df2-98ea-166e562daa98",
        "address": "Unit 514, Level 5, Liberty House, Dubai International Financial Centre, PO Box 506949, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Unit 514, Level 5, Liberty House, Dubai International Financial Centre, PO Box 506949, Dubai"
  },
  {
    "id": "d73e9966-6a84-49e4-a54f-3ef17ff37e56",
    "slug": "ince-co-middle-east-llp",
    "name": "Ince & Co Middle East LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5JQzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Ince & Co Middle East LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_d73e9966-6a84-49e4-a54f-3ef17ff37e56",
        "address": "Office No.1001-1004, Level 10, The Maze Tower, Sheikh Zayed Road, P.O. Box 123004, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No.1001-1004, Level 10, The Maze Tower, Sheikh Zayed Road, P.O. Box 123004, Dubai"
  },
  {
    "id": "5d194a91-0f2b-4817-ad15-9f46c2ef50d9",
    "slug": "international-law-firm-mizzau",
    "name": "International Law Firm Mizzau",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5JTDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: International Law Firm Mizzau",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_5d194a91-0f2b-4817-ad15-9f46c2ef50d9",
        "address": "Office No.908, Level 9, Al Etihad Building, Port Saeed, Deira, P.O.Box 116670, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No.908, Level 9, Al Etihad Building, Port Saeed, Deira, P.O.Box 116670, Dubai"
  },
  {
    "id": "7a410961-e5f7-443e-806e-d080d015fbdc",
    "slug": "jernakov-legal-consultants",
    "name": "Jernakov Legal Consultants",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5KTDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Jernakov Legal Consultants",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_7a410961-e5f7-443e-806e-d080d015fbdc",
        "address": "Office No.O-07C, Building 5, Al Khor Tower, Baniyas Street, Deira, P.O. Box 22557, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No.O-07C, Building 5, Al Khor Tower, Baniyas Street, Deira, P.O. Box 22557, Dubai"
  },
  {
    "id": "d03b2dd1-e0c8-48a5-9485-7329f796e6e1",
    "slug": "jurisgulf-legal-consultants",
    "name": "Jurisgulf Legal Consultants",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5KTDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Jurisgulf Legal Consultants",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_d03b2dd1-e0c8-48a5-9485-7329f796e6e1",
        "address": "Level 05, Office No.502A, API World Tower, Sheikh Zayed Road, P.O. Box 29425, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Level 05, Office No.502A, API World Tower, Sheikh Zayed Road, P.O. Box 29425, Dubai"
  },
  {
    "id": "6d11cde2-e06d-4356-9c7a-541c6ab0c293",
    "slug": "just-wills-al-wasiyya-jlt",
    "name": "Just Wills, Al Wasiyya JLT",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5KVzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Just Wills, Al Wasiyya JLT",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_6d11cde2-e06d-4356-9c7a-541c6ab0c293",
        "address": "Office 1006, Level 10, The Fortune Executive Tower, Jumeirah Lake Towers, P.O. Box 75671, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office 1006, Level 10, The Fortune Executive Tower, Jumeirah Lake Towers, P.O. Box 75671, Dubai"
  },
  {
    "id": "4e30dbb6-5b96-45a1-9e6a-d13670d534af",
    "slug": "karbal-co-legal-consultants",
    "name": "Karbal & Co Legal Consultants",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5LQzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Karbal & Co Legal Consultants",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_4e30dbb6-5b96-45a1-9e6a-d13670d534af",
        "address": "Office No.1001, Saeed Tower 2, Sheikh Zayed Road, P.O. Box 73868, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No.1001, Saeed Tower 2, Sheikh Zayed Road, P.O. Box 73868, Dubai"
  },
  {
    "id": "89b17d2a-a996-4a0a-8bc1-d12f72088874",
    "slug": "king-wood-mallesons-mena-llp",
    "name": "King & Wood Mallesons (MENA) LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5LVzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: King & Wood Mallesons (MENA) LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_89b17d2a-a996-4a0a-8bc1-d12f72088874",
        "address": "Suite 303, Dxb Tower, Trade Centre First P.O. Box 24482, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Suite 303, Dxb Tower, Trade Centre First P.O. Box 24482, Dubai"
  },
  {
    "id": "a65e1747-91e9-436b-84ec-980d06cfe73a",
    "slug": "king-wood-mallesons-mena-llp-difc",
    "name": "King & Wood Mallesons (MENA) LLP-DIFC",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5LVzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: King & Wood Mallesons (MENA) LLP-DIFC",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_a65e1747-91e9-436b-84ec-980d06cfe73a",
        "address": "Unit No. 105,Level 01,Gate Village Building 01,Dubai International Financial Centre,P.O. Box 24482, Dubai,United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Unit No. 105,Level 01,Gate Village Building 01,Dubai International Financial Centre,P.O. Box 24482, Dubai,United Arab Emirates"
  },
  {
    "id": "ab977ee5-c81c-47f9-bc24-5ce59cf32cc7",
    "slug": "kurtha-co-legal-consultants",
    "name": "Kurtha & Co. Legal Consultants",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5LQzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Kurtha & Co. Legal Consultants",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_ab977ee5-c81c-47f9-bc24-5ce59cf32cc7",
        "address": "Office G03, Sultan Ahmad Mohd Lootah Building, Al Marar, Deira, P.O. Box 120617, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office G03, Sultan Ahmad Mohd Lootah Building, Al Marar, Deira, P.O. Box 120617, Dubai"
  },
  {
    "id": "b9291bf9-baac-4a47-806f-f6a23a031b43",
    "slug": "loyens-loeff-emirates-b-v",
    "name": "Loyens & Loeff Emirates B.V",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5MTDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Loyens & Loeff Emirates B.V",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_b9291bf9-baac-4a47-806f-f6a23a031b43",
        "address": "Office No.202, Level 2, Gate Village Building 10, Dubai International Financial Centre, P.O. Box 506647, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No.202, Level 2, Gate Village Building 10, Dubai International Financial Centre, P.O. Box 506647, Dubai"
  },
  {
    "id": "3748a8e3-cefc-452e-8ac3-bff1cfea3fe6",
    "slug": "lpa-middle-east-ltd",
    "name": "LPA (Middle East) Ltd.",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5MKDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: LPA (Middle East) Ltd.",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_3748a8e3-cefc-452e-8ac3-bff1cfea3fe6",
        "address": "Unit 17-34, Level 17, Central Park Towers, Dubai International Financial Tower, P.O. Box 507120, Dubai, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Unit 17-34, Level 17, Central Park Towers, Dubai International Financial Tower, P.O. Box 507120, Dubai, United Arab Emirates"
  },
  {
    "id": "3f7f308f-d1db-40d1-a6ca-478ee5118644",
    "slug": "mohammad-ibrahim-salmeen-legal-consultancy",
    "name": "Mohammad Ibrahim Salmeen Legal Consultancy",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NSTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Mohammad Ibrahim Salmeen Legal Consultancy",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_3f7f308f-d1db-40d1-a6ca-478ee5118644",
        "address": "Office No.103, D-2 Tower, Al Barsha First.",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No.103, D-2 Tower, Al Barsha First."
  },
  {
    "id": "e42855e2-99e0-440b-9cc0-4910d7b333e4",
    "slug": "mohammed-mansoor-yasin-legal-consultancy",
    "name": "Mohammed Mansoor Yasin Legal Consultancy",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Mohammed Mansoor Yasin Legal Consultancy",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_e42855e2-99e0-440b-9cc0-4910d7b333e4",
        "address": "Office 4201-26, Emirates Towers Office Tower, Trade Center Second",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office 4201-26, Emirates Towers Office Tower, Trade Center Second"
  },
  {
    "id": "b007f7f4-10cb-4839-9902-6278e9da2981",
    "slug": "molinari-legal-consultancy",
    "name": "Molinari Legal Consultancy",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NTDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Molinari Legal Consultancy",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_b007f7f4-10cb-4839-9902-6278e9da2981",
        "address": "Office No 306, Emarat Atrium, Sheikh Zayed Road, P.O. Box 58006, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No 306, Emarat Atrium, Sheikh Zayed Road, P.O. Box 58006, Dubai"
  },
  {
    "id": "d3b6d11d-43e1-48f5-91c8-bc1c94b4b8e9",
    "slug": "norton-rose-fulbright-middle-east-llp",
    "name": "Norton Rose Fulbright (Middle East) LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5OUjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Norton Rose Fulbright (Middle East) LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_d3b6d11d-43e1-48f5-91c8-bc1c94b4b8e9",
        "address": "Unit L12-01A,Level 12,ICD Brookfield Place,, Dubai International Financial Centre, P.O. Box 103747, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Unit L12-01A,Level 12,ICD Brookfield Place,, Dubai International Financial Centre, P.O. Box 103747, Dubai"
  },
  {
    "id": "1d5b6126-2c49-4c2d-aae9-c0f93dfcea5b",
    "slug": "osama-nachef-associates-solicitors-legal-advisors",
    "name": "Osama Nachef & Associates Solicitors & Legal Advisors",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5PTjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Osama Nachef & Associates Solicitors & Legal Advisors",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_1d5b6126-2c49-4c2d-aae9-c0f93dfcea5b",
        "address": "Office No.201A, Level 2, Al Khaimah Building, Port Saeed, Deira, P.O. Box 31141, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No.201A, Level 2, Al Khaimah Building, Port Saeed, Deira, P.O. Box 31141, Dubai"
  },
  {
    "id": "d955b9d8-bff1-401a-8664-fdcdf158c2a7",
    "slug": "pillsbury-winthrop-shaw-pittman-middle-east-llp",
    "name": "Pillsbury Winthrop Shaw Pittman (Middle East) LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5QVzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Pillsbury Winthrop Shaw Pittman (Middle East) LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_d955b9d8-bff1-401a-8664-fdcdf158c2a7",
        "address": "Unit C1408, 14thfloor, Burj Daman Office Towers, P.O.Box 506886, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Unit C1408, 14thfloor, Burj Daman Office Towers, P.O.Box 506886, Dubai"
  },
  {
    "id": "0c265889-dd3a-4b67-a15f-b10b7e78ed15",
    "slug": "rad-partners",
    "name": "RAD & Partners",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5SUDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: RAD & Partners",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_0c265889-dd3a-4b67-a15f-b10b7e78ed15",
        "address": "Unit No. 2302, Level 23, HDS Tower, Jumeirah Lake Towers, P.O. Box 120858, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Unit No. 2302, Level 23, HDS Tower, Jumeirah Lake Towers, P.O. Box 120858, Dubai"
  },
  {
    "id": "4361a02c-31bd-48a1-bda2-010885444575",
    "slug": "rasheed-haroon-legal-services",
    "name": "Rasheed Haroon Legal Services",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5SSDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Rasheed Haroon Legal Services",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_4361a02c-31bd-48a1-bda2-010885444575",
        "address": "Office No.1001B, Pearl Building , Naser Square, P.O.Box 3376, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No.1001B, Pearl Building , Naser Square, P.O.Box 3376, Dubai"
  },
  {
    "id": "9d07e567-c497-4cc2-9519-7ecdd482fa70",
    "slug": "ritter-legal-consultants",
    "name": "Ritter Legal Consultants",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5STDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Ritter Legal Consultants",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_9d07e567-c497-4cc2-9519-7ecdd482fa70",
        "address": "Office No. 538, Business Village, Port Saeed, P.O. Box 40992, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 538, Business Village, Port Saeed, P.O. Box 40992, Dubai"
  },
  {
    "id": "0c927e2a-7de7-4393-a24a-dbfb7a2ee613",
    "slug": "sapientia-legal-consultants",
    "name": "Sapientia Legal Consultants",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TTDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Sapientia Legal Consultants",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_0c927e2a-7de7-4393-a24a-dbfb7a2ee613",
        "address": "Office No.1406, City Tower 1, Sheikh Zayed Road, P.O.Box 73321, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No.1406, City Tower 1, Sheikh Zayed Road, P.O.Box 73321, Dubai"
  },
  {
    "id": "a7460c11-b453-470b-b5a1-6c3326ad0422",
    "slug": "schl-ter-graf-and-partner-legal-consultants-llc",
    "name": "Schlüter Graf and Partner Legal Consultants LLC",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TRzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Schlüter Graf and Partner Legal Consultants LLC",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_a7460c11-b453-470b-b5a1-6c3326ad0422",
        "address": "Office No. 304,305,306 Dubai Digital Park – Office A7, Nadd Hessa, P.O. Box 29337, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 304,305,306 Dubai Digital Park – Office A7, Nadd Hessa, P.O. Box 29337, Dubai"
  },
  {
    "id": "f2aba376-5a62-45b5-b854-7cb64fa62d19",
    "slug": "shaikh-abdulla-al-mualla-legal-consultancy",
    "name": "Shaikh Abdulla Al Mualla Legal Consultancy",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Shaikh Abdulla Al Mualla Legal Consultancy",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_f2aba376-5a62-45b5-b854-7cb64fa62d19",
        "address": "Office No.1605, Hamad Suhail Al Khaily Building, Riggat Al Futtaim, Al Maktoum Street, Dubai, P.O. Box 28774",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No.1605, Hamad Suhail Al Khaily Building, Riggat Al Futtaim, Al Maktoum Street, Dubai, P.O. Box 28774"
  },
  {
    "id": "c1b1895f-5bc9-45b2-a7be-623fa120740c",
    "slug": "shearman-sterling-middle-east-llp",
    "name": "Shearman & Sterling Middle East LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Shearman & Sterling Middle East LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_c1b1895f-5bc9-45b2-a7be-623fa120740c",
        "address": "Unit No. GV-00-08-03-OF-03, Level 3, Gate Village 8, P.O.Box 506771,Dubai International Financial Centre, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Unit No. GV-00-08-03-OF-03, Level 3, Gate Village 8, P.O.Box 506771,Dubai International Financial Centre, Dubai"
  },
  {
    "id": "1d609b68-8fa8-4370-8d19-30cec82c25d5",
    "slug": "stage-legal-consultancy",
    "name": "Stage Legal Consultancy",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TTDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Stage Legal Consultancy",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_1d609b68-8fa8-4370-8d19-30cec82c25d5",
        "address": "Office No.115,Building R338, Umm Hurair Second, P.O.Box 47700, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No.115,Building R338, Umm Hurair Second, P.O.Box 47700, Dubai"
  },
  {
    "id": "dc0cfd5c-707e-4670-b457-2018df964329",
    "slug": "stibbe-dubai-b-v",
    "name": "Stibbe Dubai B.V.",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TRDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Stibbe Dubai B.V.",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_dc0cfd5c-707e-4670-b457-2018df964329",
        "address": "Office No.12, Level 3, Gate Village 10, Dubai International Financial Centre, P.O.Box 506631, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No.12, Level 3, Gate Village 10, Dubai International Financial Centre, P.O.Box 506631, Dubai"
  },
  {
    "id": "6026f7e2-794b-4266-b0b2-012057a6c763",
    "slug": "taylor-wessing-middle-east-llp-difc",
    "name": "Taylor Wessing (Middle East) LLP-DIFC",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5UVzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Taylor Wessing (Middle East) LLP-DIFC",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_6026f7e2-794b-4266-b0b2-012057a6c763",
        "address": "Office No. 10, Level 4, Liberty House, Dubai International Financial Centre, P.O. Box 33675, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 10, Level 4, Liberty House, Dubai International Financial Centre, P.O. Box 33675, Dubai"
  },
  {
    "id": "2ce8a3a8-2471-4e7d-8ecc-a57fb9f7c57b",
    "slug": "the-di-francia-firm-dubai-ltd",
    "name": "The Di Francia Firm (Dubai) Ltd",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ERjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: The Di Francia Firm (Dubai) Ltd",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_2ce8a3a8-2471-4e7d-8ecc-a57fb9f7c57b",
        "address": "Office No.6, Level 6, Liberty House, Dubai International Financial Centre, P.O. Box 31303, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No.6, Level 6, Liberty House, Dubai International Financial Centre, P.O. Box 31303, Dubai"
  },
  {
    "id": "2f2e120e-a724-4c1d-bf32-201140734a84",
    "slug": "the-rights-lawyers-fz-llc",
    "name": "The Rights Lawyers FZ LLC",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5STDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: The Rights Lawyers FZ LLC",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_2f2e120e-a724-4c1d-bf32-201140734a84",
        "address": "Office No. 420, Level 4, Building 8, Dubai Media City, P.O. Box 502175, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 420, Level 4, Building 8, Dubai Media City, P.O. Box 502175, Dubai"
  },
  {
    "id": "b9ac3aff-d231-484c-afa7-9a83d997c874",
    "slug": "voitin-walker-davis-legal-consultancy",
    "name": "Voitin Walker Davis Legal Consultancy",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5WVzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Voitin Walker Davis Legal Consultancy",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_b9ac3aff-d231-484c-afa7-9a83d997c874",
        "address": "Office No. 131-133, Level 1, Emaraat Atrium Building, Sheikh Zayed Raod, P.O.Box 58077 Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 131-133, Level 1, Emaraat Atrium Building, Sheikh Zayed Raod, P.O.Box 58077 Dubai"
  },
  {
    "id": "14937cef-9c77-4298-ab2a-74428643c8b1",
    "slug": "weil-gotshal-manges-llp",
    "name": "Weil, Gotshal & Manges LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5XRzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Weil, Gotshal & Manges LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_14937cef-9c77-4298-ab2a-74428643c8b1",
        "address": "Office No.6, Level 07, Al Fattan Currency House, Dubai International Financial Centre, P.O. Box 506781, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No.6, Level 07, Al Fattan Currency House, Dubai International Financial Centre, P.O. Box 506781, Dubai"
  },
  {
    "id": "b5e419d7-d8c2-49de-9252-97eed2ea4637",
    "slug": "white-case-llp-dubai-branch-ded",
    "name": "White & Case LLP (Dubai Branch)-DED",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5XQzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: White & Case LLP (Dubai Branch)-DED",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_b5e419d7-d8c2-49de-9252-97eed2ea4637",
        "address": "Office No.801, Capricorn Tower, Sheikh Zayed Road, P.O.Box 9705, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No.801, Capricorn Tower, Sheikh Zayed Road, P.O.Box 9705, Dubai"
  },
  {
    "id": "b87800ba-4a38-44aa-8857-4e1b2dc37c51",
    "slug": "winston-strawn-middle-east-llp",
    "name": "Winston & Strawn Middle East LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5XUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Winston & Strawn Middle East LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_b87800ba-4a38-44aa-8857-4e1b2dc37c51",
        "address": "Level 10,Burj Daman,Dubai International Financial Centre,P.O. Box 507024, Dubai,",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Level 10,Burj Daman,Dubai International Financial Centre,P.O. Box 507024, Dubai,"
  },
  {
    "id": "3b6afd73-1acb-4b25-92c0-97c35f862efb",
    "slug": "rimon-limited",
    "name": "Rimon Limited",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5STDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Rimon Limited",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_3b6afd73-1acb-4b25-92c0-97c35f862efb",
        "address": "Unit 51, Level 14,Central Park Offices,Dubai International Financial Centre,Dubai,United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Unit 51, Level 14,Central Park Offices,Dubai International Financial Centre,Dubai,United Arab Emirates"
  },
  {
    "id": "a0ade89b-b80f-4560-8c64-ca9d84da8a73",
    "slug": "tareq-thabit-legal-consultancy",
    "name": "Tareq Thabit Legal Consultancy",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5UVDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Tareq Thabit Legal Consultancy",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_a0ade89b-b80f-4560-8c64-ca9d84da8a73",
        "address": "Office No. M119-023, Shaikha Mhara-Al Qusais Bldg, Al Qusais Second, P.O. Box:235485, Dubai,United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. M119-023, Shaikha Mhara-Al Qusais Bldg, Al Qusais Second, P.O. Box:235485, Dubai,United Arab Emirates"
  },
  {
    "id": "5a30d487-be8c-4846-8ff3-e80359d3b853",
    "slug": "ali-yousuf-alawadhi-for-legal-consultants",
    "name": "Ali Yousuf Alawadhi For Legal Consultants",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BWTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Ali Yousuf Alawadhi For Legal Consultants",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_5a30d487-be8c-4846-8ff3-e80359d3b853",
        "address": "Office No.3015, PR1063-Mazaya Shopping Centre, Al Wasl, P.O. Box: 333443, Dubai,United Arab, Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No.3015, PR1063-Mazaya Shopping Centre, Al Wasl, P.O. Box: 333443, Dubai,United Arab, Emirates"
  },
  {
    "id": "68a0e3c6-1858-409e-98bb-78d54b6e86b5",
    "slug": "anett-pertl-legal-consultants",
    "name": "Anett Pertl Legal Consultants",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BUDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Anett Pertl Legal Consultants",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_68a0e3c6-1858-409e-98bb-78d54b6e86b5",
        "address": "Office No. 2202-04, BD BLVD Plaza T2 - 2202, Burj Khalifa, Dubai, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 2202-04, BD BLVD Plaza T2 - 2202, Burj Khalifa, Dubai, United Arab Emirates"
  },
  {
    "id": "2064c050-8b9a-45f4-b74a-f68d746c2624",
    "slug": "dsk-legal-services-llp-dubai-branch",
    "name": "DSK Legal Services LLP – Dubai Branch",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ETDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: DSK Legal Services LLP – Dubai Branch",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_2064c050-8b9a-45f4-b74a-f68d746c2624",
        "address": "Units P03-19, Bay Square - 12 – P03, Business Bay, Dubai, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Units P03-19, Bay Square - 12 – P03, Business Bay, Dubai, United Arab Emirates"
  },
  {
    "id": "534fbd40-3c0e-4063-9965-3ddbbeb74a80",
    "slug": "anima-aurea",
    "name": "Anima Aurea",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Anima Aurea",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_534fbd40-3c0e-4063-9965-3ddbbeb74a80",
        "address": "-",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "maria palazuelos",
    "address": "-"
  },
  {
    "id": "5a94b0c1-4819-4598-beae-0c3656a5dcb8",
    "slug": "dac-beachcroft-llp",
    "name": "DAC Beachcroft LLP",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5EQjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: DAC Beachcroft LLP",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_5a94b0c1-4819-4598-beae-0c3656a5dcb8",
        "address": "-",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "Khurram Shamsee",
    "address": "-"
  },
  {
    "id": "142d9496-f72b-4e62-963f-d6f9fc0d42b5",
    "slug": "elevate-legal-consultancy-llc",
    "name": "ELEVATE LEGAL CONSULTANCY LLC",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5FTDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: ELEVATE LEGAL CONSULTANCY LLC",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_142d9496-f72b-4e62-963f-d6f9fc0d42b5",
        "address": "-",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "PARTHA SARATHI CHOUDHURY",
    "address": "-"
  },
  {
    "id": "b8b849f2-8665-4924-8742-d1379eef8444",
    "slug": "mahran-international-legal-solutions-mils",
    "name": "Mahran International Legal Solutions (MILS)",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NSTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Mahran International Legal Solutions (MILS)",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_b8b849f2-8665-4924-8742-d1379eef8444",
        "address": "-",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "محمد محمود عبد الرحيم حسين مهران",
    "address": "-"
  },
  {
    "id": "5a13a4ff-cf92-40c4-b6e8-6a9475a2a4e2",
    "slug": "mishcon-de-reya-llp-dwtca-branch",
    "name": "Mishcon de Reya LLP (DWTCA Branch)",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NRDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Mishcon de Reya LLP (DWTCA Branch)",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_5a13a4ff-cf92-40c4-b6e8-6a9475a2a4e2",
        "address": "Office No. 1501, 1502 & 1506, Floor 15 One Zabeel Tower A, Zabeel 1, Dubai, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 1501, 1502 & 1506, Floor 15 One Zabeel Tower A, Zabeel 1, Dubai, United Arab Emirates"
  },
  {
    "id": "b3223106-402d-4791-8991-f8473e662c88",
    "slug": "elevate-legal-consultancy-llc",
    "name": "ELEVATE LEGAL CONSULTANCY LLC",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5FTDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: ELEVATE LEGAL CONSULTANCY LLC",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_b3223106-402d-4791-8991-f8473e662c88",
        "address": "-",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "PARTHA SARATHI CHOUDHURY",
    "address": "-"
  },
  {
    "id": "92004ba2-43b1-4eee-a950-7fbfdf60144a",
    "slug": "hamad-alneyadi-legal-consultancy",
    "name": "HAMAD ALNEYADI LEGAL CONSULTANCY",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5IQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: HAMAD ALNEYADI LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_92004ba2-43b1-4eee-a950-7fbfdf60144a",
        "address": "-",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "حمد مطر راشد بن مسيعد النيادى",
    "address": "-"
  },
  {
    "id": "b78106b7-3654-41bf-a94f-0b812e32ff04",
    "slug": "hamad-alneyadi-legal-consultancy-l-l-c-s-p-c",
    "name": "HAMAD ALNEYADI LEGAL CONSULTANCY - L.L.C - S.P.C",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5IQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: HAMAD ALNEYADI LEGAL CONSULTANCY - L.L.C - S.P.C",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_b78106b7-3654-41bf-a94f-0b812e32ff04",
        "address": "-",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "حمد مطر راشد بن مسيعد النيادى",
    "address": "-"
  },
  {
    "id": "d224ca17-d1b7-4272-9d1e-401c62582dfc",
    "slug": "kamgate",
    "name": "KAMGATE",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5LQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: KAMGATE",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_d224ca17-d1b7-4272-9d1e-401c62582dfc",
        "address": "-",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "IBRAHIM MOHAMED KAMAL MOHAMED ABDOU",
    "address": "-"
  },
  {
    "id": "6bb84528-c317-402f-890b-ab0756352351",
    "slug": "rectus-juris-legal-consultancy",
    "name": "Rectus juris legal consultancy",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5SSjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Rectus juris legal consultancy",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_6bb84528-c317-402f-890b-ab0756352351",
        "address": "-",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "shanthi palani",
    "address": "-"
  },
  {
    "id": "eb07f4fc-2acc-443d-adcb-7c6d44fc083c",
    "slug": "alshaima-legal-consulting",
    "name": "AlShaima Legal Consulting",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BTDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: AlShaima Legal Consulting",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_eb07f4fc-2acc-443d-adcb-7c6d44fc083c",
        "address": "-",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "شيماء محمد رؤوف حاج صالح",
    "address": "-"
  },
  {
    "id": "c2fbfe00-c557-400c-928d-6ae9ce00ee31",
    "slug": "esfandiari-legal-service",
    "name": "Esfandiari Legal Service",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5FTDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Esfandiari Legal Service",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_c2fbfe00-c557-400c-928d-6ae9ce00ee31",
        "address": "-",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "Yousef Reza Haji Esfandiari",
    "address": "-"
  },
  {
    "id": "7a81ccc5-a565-484c-9e38-f8e7f574b844",
    "slug": "lexdesk360-sowaidan-associates",
    "name": "LexDesk360 - Sowaidan & Associates",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5MLTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: LexDesk360 - Sowaidan & Associates",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_7a81ccc5-a565-484c-9e38-f8e7f574b844",
        "address": "-",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "Walid Sowaidan",
    "address": "-"
  },
  {
    "id": "f49da5dd-e977-4e08-b845-8905fa30c936",
    "slug": "nomos-legal-advisory",
    "name": "NOMOS LEGAL ADVISORY",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5OTDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: NOMOS LEGAL ADVISORY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_f49da5dd-e977-4e08-b845-8905fa30c936",
        "address": "-",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "Abdulrahman Ahmad Abdulaziz Qassim Al Haddad",
    "address": "-"
  },
  {
    "id": "15eea62b-dd69-480e-ad27-6901894de564",
    "slug": "versatile-global-associates",
    "name": "Versatile Global Associates",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5WRzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Versatile Global Associates",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_15eea62b-dd69-480e-ad27-6901894de564",
        "address": "-",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "B Padhi",
    "address": "-"
  },
  {
    "id": "d7bc966d-57ee-494e-95fe-8526e19c7f77",
    "slug": "alghazal-legal-consultancy-l-l-c",
    "name": "ALGHAZAL LEGAL CONSULTANCY L L C",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BTDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: ALGHAZAL LEGAL CONSULTANCY L L C",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_d7bc966d-57ee-494e-95fe-8526e19c7f77",
        "address": "-",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "موفق محمد غزال",
    "address": "-"
  },
  {
    "id": "5a2d6204-01b1-4b1f-b783-c6643cbbb27c",
    "slug": "alghazal-legal-consultancy-l-l-c",
    "name": "ALGHAZAL LEGAL CONSULTANCY L L C",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BTDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: ALGHAZAL LEGAL CONSULTANCY L L C",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_5a2d6204-01b1-4b1f-b783-c6643cbbb27c",
        "address": "-",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "موفق محمد غزال",
    "address": "-"
  },
  {
    "id": "b39b4823-b0bf-43a5-8dbb-76b28a3fb80b",
    "slug": "makhsimov-and-company",
    "name": "Makhsimov and Company",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NQzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Makhsimov and Company",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_b39b4823-b0bf-43a5-8dbb-76b28a3fb80b",
        "address": "-",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "Alisher Makhsimov",
    "address": "-"
  },
  {
    "id": "50093bfa-84e2-4994-a32e-b8c40e3ea263",
    "slug": "noya-legal-consultants",
    "name": "Noya Legal Consultants",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5OTDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: Noya Legal Consultants",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_50093bfa-84e2-4994-a32e-b8c40e3ea263",
        "address": "-",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "Pavan Kumar Rao Polkampally",
    "address": "-"
  },
  {
    "id": "2ac2a429-a1c0-406c-8bf7-540ec6ff0ece",
    "slug": "said-abouelmakaremaligomaa",
    "name": "SAID ABOUELMAKAREMALIGOMAA",
    "title": "Legal Consultancy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultancy Firm"
    ],
    "description": "Licensed legal consultancy firm: SAID ABOUELMAKAREMALIGOMAA",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Legal_Consultancy_Firms",
    "offices": [
      {
        "id": "office_2ac2a429-a1c0-406c-8bf7-540ec6ff0ece",
        "address": "-",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "سعيد ابو المكارم على جمعه",
    "address": "-"
  },
  {
    "id": "4499583c-68b1-4331-9b9a-914844f98315",
    "slug": "abdulla-rahma-abdulla-rahma",
    "name": "ABDULLA RAHMA ABDULLA RAHMA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BUjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 18,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/03/2007",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ABDULLA RAHMA ABDULLA RAHMA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-601",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_4499583c-68b1-4331-9b9a-914844f98315",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "ALOWAIS AND ALMATROOSHI ADVOCATE AND LEGAL CONSULTANTS"
  },
  {
    "id": "db42d84c-8528-4847-90b4-5e91c6a43224",
    "slug": "bader-ismaeel-hasan-alansaari-almarzooqi",
    "name": "BADER ISMAEEL HASAN ALANSAARI ALMARZOOQI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5CSTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/05/2014",
    "licenseStatus": "suspended",
    "licenseExpiry": "2020-05-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: BADER ISMAEEL HASAN ALANSAARI ALMARZOOQI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-938",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_db42d84c-8528-4847-90b4-5e91c6a43224",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "ADVOCATES UNIT"
  },
  {
    "id": "ab0d056e-969a-4384-af36-de4f27ffbb53",
    "slug": "ahmed-juma-hassan-mohamed-alraeesi",
    "name": "AHMED JUMA HASSAN MOHAMED ALRAEESI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BSjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/10/2017",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: AHMED JUMA HASSAN MOHAMED ALRAEESI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-1228",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_ab0d056e-969a-4384-af36-de4f27ffbb53",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "AHMED AL RAEESI ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "ba38a239-a025-44f1-a840-8bd8d94026ff",
    "slug": "hamed-salem-ali-salem",
    "name": "HAMED SALEM ALI SALEM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5IUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "14/10/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-13",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: HAMED SALEM ALI SALEM",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-1601",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_ba38a239-a025-44f1-a840-8bd8d94026ff",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "OUTSIDE DUBAI FIRM"
  },
  {
    "id": "6e58ce28-93aa-4f13-9e4a-3ff88a809648",
    "slug": "khalifa-mohammad-khalifa",
    "name": "KHALIFA MOHAMMAD KHALIFA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5LTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/12/2021",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: KHALIFA MOHAMMAD KHALIFA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-1611",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_6e58ce28-93aa-4f13-9e4a-3ff88a809648",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "SALHA ALKHALAFI ADVOCATES &LEGAL CONSULTANTS"
  },
  {
    "id": "82b85739-305b-424b-a666-f3d930f5368b",
    "slug": "maha-abdulla-mahmoud-humaidan-hammad",
    "name": "MAHA ABDULLA MAHMOUD HUMAIDAN HAMMAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/01/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: MAHA ABDULLA MAHMOUD HUMAIDAN HAMMAD",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-1624",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_82b85739-305b-424b-a666-f3d930f5368b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "OUTSIDE DUBAI FIRM"
  },
  {
    "id": "f10e7f67-9a55-417e-8325-536a638d37cb",
    "slug": "yaqoob-yousuf-mohammad",
    "name": "YAQOOB YOUSUF MOHAMMAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ZWTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/06/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: YAQOOB YOUSUF MOHAMMAD",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-1674",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_f10e7f67-9a55-417e-8325-536a638d37cb",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "GLOBAL ADVOCACY & LEGAL COUNSEL"
  },
  {
    "id": "ed7283ff-bc83-4958-b0a5-4b973ecc1879",
    "slug": "rawdha-mohammed-salem-hayai-al-mansouri",
    "name": "RAWDHA MOHAMMED SALEM HAYAI AL MANSOURI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5STTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/07/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: RAWDHA MOHAMMED SALEM HAYAI AL MANSOURI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-1688",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_ed7283ff-bc83-4958-b0a5-4b973ecc1879",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "OUTSIDE DUBAI FIRM"
  },
  {
    "id": "13dcde7e-474a-4030-9927-993545f357bd",
    "slug": "ahmed-rashed-ahmed",
    "name": "AHMED RASHED AHMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BUjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/10/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: AHMED RASHED AHMED",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-1718",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_13dcde7e-474a-4030-9927-993545f357bd",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "HAMDAN ALSHAMSI LAWYER & LEGAL CONSULTANTS"
  },
  {
    "id": "3e072bfc-d313-4ed5-901a-20a83cf1a8ea",
    "slug": "nasser-saeed-majid-saeed",
    "name": "NASSER SAEED MAJID SAEED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5OUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/01/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: NASSER SAEED MAJID SAEED",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-1758",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_3e072bfc-d313-4ed5-901a-20a83cf1a8ea",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "OUTSIDE DUBAI FIRM"
  },
  {
    "id": "5d28e61d-3d4e-4594-a034-002c9aac7ddd",
    "slug": "rola-ibrahim-mohsen-jaber",
    "name": "ROLA IBRAHIM MOHSEN JABER",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5SSTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "26/02/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-25",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ROLA IBRAHIM MOHSEN JABER",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-1776",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_5d28e61d-3d4e-4594-a034-002c9aac7ddd",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "MOHAMMED ALI ALHAMMADI ADVOCATES & LEGAL CONSULTANCY"
  },
  {
    "id": "9e328a54-d2a0-4058-81f9-d3172126fd1a",
    "slug": "mohamed-alkori-mohamed-suhail",
    "name": "MOHAMED ALKORI MOHAMED SUHAIL",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/03/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: MOHAMED ALKORI MOHAMED SUHAIL",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-1791",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_9e328a54-d2a0-4058-81f9-d3172126fd1a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "SAEED HATEM ALMENHALI AND ASSOCIATES ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "02555d3e-b372-4ff0-a92d-7623e15f883f",
    "slug": "dr-jamal-hussain-ahmad-alsumaiti",
    "name": "DR JAMAL HUSSAIN AHMAD ALSUMAITI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ESjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/06/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: DR JAMAL HUSSAIN AHMAD ALSUMAITI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-1827",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_02555d3e-b372-4ff0-a92d-7623e15f883f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "AL BASTAKI & Al JASMI ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "cf683deb-cc1d-4665-a4ff-647cfce2a86a",
    "slug": "sara-bader-mahfoudh-alhadrami",
    "name": "SARA BADER MAHFOUDH ALHADRAMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TQjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/07/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: SARA BADER MAHFOUDH ALHADRAMI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-1836",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_cf683deb-cc1d-4665-a4ff-647cfce2a86a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "BUSIT ADVOCATES AND LEGAL CONSULTANTS"
  },
  {
    "id": "f44d84a1-02d8-4ddb-86e5-4de8a459a6dd",
    "slug": "kaaseb-mohamed-rashed-ahmed-alhassani",
    "name": "KAASEB MOHAMED RASHED AHMED ALHASSANI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5LTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/07/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: KAASEB MOHAMED RASHED AHMED ALHASSANI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-1846",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_f44d84a1-02d8-4ddb-86e5-4de8a459a6dd",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "OUTSIDE DUBAI FIRM"
  },
  {
    "id": "1fdfeef6-c86c-4020-9296-43fbb0087c9a",
    "slug": "mohammed-abdulla-khamis",
    "name": "MOHAMMED ABDULLA KHAMIS",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/08/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: MOHAMMED ABDULLA KHAMIS",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-1862",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_1fdfeef6-c86c-4020-9296-43fbb0087c9a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "FAHAD ALHOSANI ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "35c2d4a2-515e-4eab-b356-485d8209ab39",
    "slug": "fatema-musalit-hani-saeed-ghorzeldin",
    "name": "FATEMA MUSALIT HANI SAEED GHORZELDIN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5GTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/10/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: FATEMA MUSALIT HANI SAEED GHORZELDIN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-1877",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_35c2d4a2-515e-4eab-b356-485d8209ab39",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "HAIDER BIN HAIDER ADVOCATES AND LEGAL CONSULTANT"
  },
  {
    "id": "1604615b-6dc1-49ce-a520-2bcba5cd3788",
    "slug": "mohammad-yahya-ismail-ead",
    "name": "MOHAMMAD YAHYA ISMAIL EAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NWTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/01/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: MOHAMMAD YAHYA ISMAIL EAD",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-1910",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_1604615b-6dc1-49ce-a520-2bcba5cd3788",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "YOUSIF AL HAMMADI ADVOCATES & LEGAL CONSULTANCY"
  },
  {
    "id": "94acd42d-5b6f-4756-9097-d577613986da",
    "slug": "obaid-saleh-obaid-binkhesaif-alshuweihi",
    "name": "OBAID SALEH OBAID BINKHESAIF ALSHUWEIHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5PUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/03/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: OBAID SALEH OBAID BINKHESAIF ALSHUWEIHI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-1930",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_94acd42d-5b6f-4756-9097-d577613986da",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "KHALIFA BIN OMAIR ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "1377bc1f-52e2-49fa-a050-c4b98b28c0ff",
    "slug": "shrook-ali-saeed-ham",
    "name": "SHROOK ALI SAEED HAM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/04/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: SHROOK ALI SAEED HAM",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-1946",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_1377bc1f-52e2-49fa-a050-c4b98b28c0ff",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "AL WASL INTERNATIONAL GROUP - ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "f10f131b-6f8c-475c-9e44-04975a61ea1c",
    "slug": "suhail-ashour-mohamed-salem",
    "name": "SUHAIL ASHOUR MOHAMED SALEM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/04/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: SUHAIL ASHOUR MOHAMED SALEM",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-1948",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_f10f131b-6f8c-475c-9e44-04975a61ea1c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "OUTSIDE DUBAI FIRM"
  },
  {
    "id": "519bc928-ca23-4fda-85aa-c277c86a93f2",
    "slug": "hussain-ali-nasser-alharthi",
    "name": "HUSSAIN ALI NASSER ALHARTHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5IQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/05/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: HUSSAIN ALI NASSER ALHARTHI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-1957",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_519bc928-ca23-4fda-85aa-c277c86a93f2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "OUTSIDE DUBAI FIRM"
  },
  {
    "id": "6903061a-a57f-459f-aae2-482014cab91a",
    "slug": "ahmed-mohammed-mahmood-mahmood",
    "name": "AHMED MOHAMMED MAHMOOD MAHMOOD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/09/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: AHMED MOHAMMED MAHMOOD MAHMOOD",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2032",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_6903061a-a57f-459f-aae2-482014cab91a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "ADVOCATES UNIT"
  },
  {
    "id": "54b949eb-edef-4207-a5ed-7e30cff69222",
    "slug": "ahmed-mohammed-mahmood-mahmood",
    "name": "AHMED MOHAMMED MAHMOOD MAHMOOD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/09/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: AHMED MOHAMMED MAHMOOD MAHMOOD",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2032",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_54b949eb-edef-4207-a5ed-7e30cff69222",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "ADVOCATES UNIT"
  },
  {
    "id": "b3291f34-2acf-4087-9813-943abb67ec2f",
    "slug": "amal-qaid-nasser-al-qamesh",
    "name": "AMAL QAID NASSER AL QAMESH",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BUTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/10/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: AMAL QAID NASSER AL QAMESH",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2041",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_b3291f34-2acf-4087-9813-943abb67ec2f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "FAHAD ALHOSANI ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "ada3d96d-19b8-4faa-8a27-e770a10b2f41",
    "slug": "anfal-abdulla-khalifa-abdulla-alkaabi",
    "name": "ANFAL ABDULLA KHALIFA ABDULLA ALKAABI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/10/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ANFAL ABDULLA KHALIFA ABDULLA ALKAABI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2043",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_ada3d96d-19b8-4faa-8a27-e770a10b2f41",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "ZAYED ALMAZROUEI ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "46ce419b-975d-4f1f-8ab4-bc3ad3d1615b",
    "slug": "shakh-ali-jamal-bin-nasser-bin-rashed-alnuaimi",
    "name": "SHAKH ALI JAMAL BIN NASSER BIN RASHED ALNUAIMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/12/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: SHAKH ALI JAMAL BIN NASSER BIN RASHED ALNUAIMI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2055",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_46ce419b-975d-4f1f-8ab4-bc3ad3d1615b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "OUTSIDE DUBAI FIRM"
  },
  {
    "id": "3de56c30-487e-4ece-857e-7bb6017f136a",
    "slug": "abdulaziz-ali-juma-shaban",
    "name": "ABDULAZIZ ALI JUMA SHABAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/12/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ABDULAZIZ ALI JUMA SHABAN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2058",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_3de56c30-487e-4ece-857e-7bb6017f136a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "OUTSIDE DUBAI FIRM"
  },
  {
    "id": "765e7c42-d03b-4edd-a47b-4bcccafe5f58",
    "slug": "shaikha-ghaleb-mohammed-saeed-almansouri",
    "name": "SHAIKHA GHALEB MOHAMMED SAEED ALMANSOURI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TRzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/02/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: SHAIKHA GHALEB MOHAMMED SAEED ALMANSOURI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2078",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_765e7c42-d03b-4edd-a47b-4bcccafe5f58",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "OUTSIDE DUBAI FIRM"
  },
  {
    "id": "86db889f-228b-4c50-bc3e-d648ec870b45",
    "slug": "nada-sarour-abdulla",
    "name": "NADA SAROUR ABDULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5OUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/02/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: NADA SAROUR ABDULLA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2079",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_86db889f-228b-4c50-bc3e-d648ec870b45",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "KHALIFA BIN HUWAIDAN ALKATBI ADVOCATES & LEGAL CONSULTANT"
  },
  {
    "id": "c27cf086-217d-442d-ab5b-e599e739d8e9",
    "slug": "khalid-ramadan-darwish-mohamed-alhosani",
    "name": "KHALID RAMADAN DARWISH MOHAMED ALHOSANI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5LUjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/04/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: KHALID RAMADAN DARWISH MOHAMED ALHOSANI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2089",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_c27cf086-217d-442d-ab5b-e599e739d8e9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "HAMDAN SULAIMAN SALIM ALMAAZMI ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "c6223be0-db31-4742-bec7-39790f163927",
    "slug": "mohammed-hassan-darweesh-ali-alraeesi",
    "name": "MOHAMMED HASSAN DARWEESH ALI ALRAEESI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NSDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "13/04/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-12",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: MOHAMMED HASSAN DARWEESH ALI ALRAEESI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2092",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_c6223be0-db31-4742-bec7-39790f163927",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "DR. MOHAMMED HASSAN ALRAEESI ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "509fd002-ee3e-4715-99d4-385a80c12034",
    "slug": "majed-abdulla-jumaa-mohamed",
    "name": "MAJED ABDULLA JUMAA MOHAMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/06/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: MAJED ABDULLA JUMAA MOHAMED",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2106",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_509fd002-ee3e-4715-99d4-385a80c12034",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "ZAYED AL SHAMSI ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "d8355b45-b164-4ea3-bd03-02c2afba0304",
    "slug": "rana-luai-sadi-alqadri",
    "name": "RANA LUAI SADI ALQADRI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5STDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/11/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-11-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: RANA LUAI SADI ALQADRI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2049",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_d8355b45-b164-4ea3-bd03-02c2afba0304",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "MARWA ALRIYAMI ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "59efe545-b0ed-4d06-9f69-c01def8c44aa",
    "slug": "hamad-younis-mohamed-abdalla-mohamed",
    "name": "HAMAD YOUNIS MOHAMED ABDALLA MOHAMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5IWTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/12/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: HAMAD YOUNIS MOHAMED ABDALLA MOHAMED",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2054",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_59efe545-b0ed-4d06-9f69-c01def8c44aa",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "MOHAMMED AHMED ADVOCATE & LEGEL CONSULTANTS"
  },
  {
    "id": "46afe4bf-84c5-4c0e-9ce9-955a86268695",
    "slug": "khamis-obaid-mohamed-khamis-alzaabi",
    "name": "KHAMIS OBAID MOHAMED KHAMIS ALZAABI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5LTzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/12/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: KHAMIS OBAID MOHAMED KHAMIS ALZAABI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2057",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_46afe4bf-84c5-4c0e-9ce9-955a86268695",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "SARA AL SAEDI ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "15aeb3a6-fa6b-4cc4-b0a5-ec4896de4c10",
    "slug": "amna-ahmed-saeed-rashid-alnaqbi",
    "name": "AMNA AHMED SAEED RASHID ALNAQBI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/12/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: AMNA AHMED SAEED RASHID ALNAQBI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2059",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_15aeb3a6-fa6b-4cc4-b0a5-ec4896de4c10",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "DIANA HAMADE ATTORNEYS AT LAW"
  },
  {
    "id": "10b91f0e-db2c-460b-ba19-ba27e83856a7",
    "slug": "abdulrahman-yousuf-abdulla",
    "name": "ABDULRAHMAN YOUSUF ABDULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BWTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/12/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2025-12-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ABDULRAHMAN YOUSUF ABDULLA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2060",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_10b91f0e-db2c-460b-ba19-ba27e83856a7",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "BAITULHIKMA LAWYERS"
  },
  {
    "id": "bfc5ec18-05f7-4911-b31c-a0298601f756",
    "slug": "aisha-saud-obaid-harmoul-alshamsi",
    "name": "AISHA SAUD OBAID HARMOUL ALSHAMSI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/12/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: AISHA SAUD OBAID HARMOUL ALSHAMSI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2061",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_bfc5ec18-05f7-4911-b31c-a0298601f756",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "OUTSIDE DUBAI FIRM"
  },
  {
    "id": "348c30b6-425d-4c5b-a42c-97c60e0da503",
    "slug": "ali-ahmed-ibrahim-khatim",
    "name": "ALI AHMED IBRAHIM KHATIM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Proceedings-Civil Cases and Proceedings before Dubai Courts",
      "Proceedings-Cases and Proceedings before Dubai International Financial Centre",
      "Proceedings-Cases and Proceedings before Rental Dispute Resolution Center"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/01/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ALI AHMED IBRAHIM KHATIM",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2062",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_348c30b6-425d-4c5b-a42c-97c60e0da503",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "OUTSIDE DUBAI FIRM"
  },
  {
    "id": "608965b2-e5fa-4bfb-84c8-55d43e85b043",
    "slug": "jasim-abdalla-abdelrazaq-abdalla",
    "name": "JASIM ABDALLA ABDELRAZAQ ABDALLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5KQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/01/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: JASIM ABDALLA ABDELRAZAQ ABDALLA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2063",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_608965b2-e5fa-4bfb-84c8-55d43e85b043",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "ALNAQBI & PARTNERS ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "f867c232-eef7-4279-b820-cfc5607c553f",
    "slug": "jasem-mohammed-abdulla-s-alshehhi",
    "name": "JASEM MOHAMMED ABDULLA S ALSHEHHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5KTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/01/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: JASEM MOHAMMED ABDULLA S ALSHEHHI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2065",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_f867c232-eef7-4279-b820-cfc5607c553f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "OUTSIDE DUBAI FIRM"
  },
  {
    "id": "eacafd15-845f-46fa-aeee-783e41151351",
    "slug": "khaled-mahdi-fahed-badi-alateibi",
    "name": "KHALED MAHDI FAHED BADI ALATEIBI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5LTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/01/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: KHALED MAHDI FAHED BADI ALATEIBI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2067",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_eacafd15-845f-46fa-aeee-783e41151351",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "OUTSIDE DUBAI FIRM"
  },
  {
    "id": "6aeaf2fc-30b7-44ff-a4c9-17ee9d4395ac",
    "slug": "jameela-ghulam-haidar-mohammed-alblooshi",
    "name": "JAMEELA GHULAM HAIDAR MOHAMMED ALBLOOSHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5KRzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/01/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: JAMEELA GHULAM HAIDAR MOHAMMED ALBLOOSHI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2068",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_6aeaf2fc-30b7-44ff-a4c9-17ee9d4395ac",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "OUTSIDE DUBAI FIRM"
  },
  {
    "id": "1ea2a97f-af51-4415-91fe-e3f8fdb2654e",
    "slug": "nayef-ali-hassan-ahmed-almeraikhi",
    "name": "NAYEF ALI HASSAN AHMED ALMERAIKHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5OQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/01/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: NAYEF ALI HASSAN AHMED ALMERAIKHI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2069",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_1ea2a97f-af51-4415-91fe-e3f8fdb2654e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "AL GHARIB & PARTNERS ADVOCATES LEGAL CONSULTANTS"
  },
  {
    "id": "b3912508-0abc-4941-9a0a-1c29e08c3829",
    "slug": "marwa-mukhtar-mohd-baqir",
    "name": "MARWA MUKHTAR MOHD BAQIR",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/01/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-01-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: MARWA MUKHTAR MOHD BAQIR",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2070",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_b3912508-0abc-4941-9a0a-1c29e08c3829",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "AL GHARIB & PARTNERS ADVOCATES LEGAL CONSULTANTS"
  },
  {
    "id": "8e7fd2ea-5897-4d7f-9db7-f5e3da7d3e56",
    "slug": "abdulrahman-obaid-ahmed-saeed-almheiri",
    "name": "ABDULRAHMAN OBAID AHMED SAEED ALMHEIRI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BTzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/02/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-02-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ABDULRAHMAN OBAID AHMED SAEED ALMHEIRI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2071",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_8e7fd2ea-5897-4d7f-9db7-f5e3da7d3e56",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "OUTSIDE DUBAI FIRM"
  },
  {
    "id": "1ee68c9a-01cd-42f0-bf68-079938dba454",
    "slug": "ahmad-sulaiman-hassan",
    "name": "AHMAD SULAIMAN HASSAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/02/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-02-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: AHMAD SULAIMAN HASSAN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2072",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_1ee68c9a-01cd-42f0-bf68-079938dba454",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "SAUD AL SHEBLI ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "793e1cd6-bbb1-44a2-9738-2ca6d471e85d",
    "slug": "abdalla-ahmed-othman-alothman-alhammadi",
    "name": "ABDALLA AHMED OTHMAN ALOTHMAN ALHAMMADI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/02/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-02-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ABDALLA AHMED OTHMAN ALOTHMAN ALHAMMADI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2075",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_793e1cd6-bbb1-44a2-9738-2ca6d471e85d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "HASAN ALRAYYAMI ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "a8085fcd-e237-4376-aab2-519a11b6dc66",
    "slug": "salem-saeed-mohamed",
    "name": "SALEM SAEED MOHAMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/02/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-02-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: SALEM SAEED MOHAMED",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2076",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_a8085fcd-e237-4376-aab2-519a11b6dc66",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "AL JABRI ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "96733b19-c209-4e4f-90e8-f4b102b58d9c",
    "slug": "saeed-ali-saeed-hamdan-alshehhi",
    "name": "SAEED ALI SAEED HAMDAN ALSHEHHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/02/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-02-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: SAEED ALI SAEED HAMDAN ALSHEHHI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2077",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_96733b19-c209-4e4f-90e8-f4b102b58d9c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "SHOUQ ALKATHIRI ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "5feff1ac-d57b-4fd7-8a25-97369bbe1beb",
    "slug": "baraka-saleh-ali-saleh-bin-hraiz",
    "name": "BARAKA SALEH ALI SALEH BIN HRAIZ",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5CUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/02/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: BARAKA SALEH ALI SALEH BIN HRAIZ",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2080",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_5feff1ac-d57b-4fd7-8a25-97369bbe1beb",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "OUTSIDE DUBAI FIRM"
  },
  {
    "id": "83273995-525c-4a60-a680-75d6645261e5",
    "slug": "ali-khalifa-humaid",
    "name": "ALI KHALIFA HUMAID",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BSzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/02/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ALI KHALIFA HUMAID",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2081",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_83273995-525c-4a60-a680-75d6645261e5",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "OUTSIDE DUBAI FIRM"
  },
  {
    "id": "233e18f7-ae71-4b95-91ae-53f1f7d7493e",
    "slug": "ali-yousef-abdulla-shaheen",
    "name": "ALI YOUSEF ABDULLA SHAHEEN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BWTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/02/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ALI YOUSEF ABDULLA SHAHEEN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2082",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_233e18f7-ae71-4b95-91ae-53f1f7d7493e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "OUTSIDE DUBAI FIRM"
  },
  {
    "id": "383bf6ea-8d90-49a5-911e-d21cdf9073fb",
    "slug": "maryam-khameis-w-o-saeed-r-a-ahmed",
    "name": "MARYAM KHAMEIS W O SAEED R A AHMED",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NSzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/02/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: MARYAM KHAMEIS W O SAEED R A AHMED",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2083",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_383bf6ea-8d90-49a5-911e-d21cdf9073fb",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "OUTSIDE DUBAI FIRM"
  },
  {
    "id": "aa6c014d-de8e-484b-b541-9e3650667280",
    "slug": "fatima-abduraheem-jumaa-abbas-alkhoori",
    "name": "FATIMA ABDURAHEEM JUMAA ABBAS ALKHOORI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5GQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/03/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: FATIMA ABDURAHEEM JUMAA ABBAS ALKHOORI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2085",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_aa6c014d-de8e-484b-b541-9e3650667280",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "ABDULLA EBRAHIM ALMANSOORI LAWYERS AND LEGAL CONSULTANTS"
  },
  {
    "id": "7925fe3e-4ed7-40a6-a0a3-3913973e5984",
    "slug": "eshaaq-ahmed-mohamed-esmaeil-al-blooshi",
    "name": "ESHAAQ AHMED MOHAMED ESMAEIL AL BLOOSHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5FQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/03/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ESHAAQ AHMED MOHAMED ESMAEIL AL BLOOSHI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2088",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_7925fe3e-4ed7-40a6-a0a3-3913973e5984",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "RAYA ALAMERI ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "f69ea340-9265-46bd-aee3-e3357a3b76e4",
    "slug": "sultan-abdulla-mohamed-salem",
    "name": "SULTAN ABDULLA MOHAMED SALEM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/04/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: SULTAN ABDULLA MOHAMED SALEM",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2090",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_f69ea340-9265-46bd-aee3-e3357a3b76e4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "ALOTEIBA & HAMDAN BUDEBES ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "1f331077-fe48-433d-962f-c1bae84ad023",
    "slug": "nasir-masoud-nasir-majid",
    "name": "NASIR MASOUD NASIR MAJID",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5OTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "20/04/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-19",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: NASIR MASOUD NASIR MAJID",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2093",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_1f331077-fe48-433d-962f-c1bae84ad023",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "MOHAMMED AL MARZOOQI ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "a0ac9ae3-976c-4ba5-8606-ce6e4379171f",
    "slug": "fatima-saleem-obaid-saeed-alsaadi",
    "name": "FATIMA SALEEM OBAID SAEED ALSAADI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5GUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/04/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: FATIMA SALEEM OBAID SAEED ALSAADI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2094",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_a0ac9ae3-976c-4ba5-8606-ce6e4379171f",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "ABDULLA AL KAABI ADVOCATES & LEGAL CONSULTANCY"
  },
  {
    "id": "8f11355e-4424-4693-aa55-f06c29c88e72",
    "slug": "shaheen-ishaq-ismail-almaazmi",
    "name": "SHAHEEN ISHAQ ISMAIL ALMAAZMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TSTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/04/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: SHAHEEN ISHAQ ISMAIL ALMAAZMI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2095",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_8f11355e-4424-4693-aa55-f06c29c88e72",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "OBAID AL MAZIMI ADVOCATES & LEGAL CONSULTANCY"
  },
  {
    "id": "12175f6a-1ede-420f-b450-b539e1d8f7a4",
    "slug": "n-sh-m-a-kouda",
    "name": "N SH M A KOUDA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5OUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "30/04/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-29",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: N SH M A KOUDA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2096",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_12175f6a-1ede-420f-b450-b539e1d8f7a4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "AHMED ALZAROONI ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "3058e7c2-6a65-4d9a-84e9-31c413aeb32a",
    "slug": "rania-kh-al-achmati",
    "name": "RANIA KH AL ACHMATI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5SSzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/05/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: RANIA KH AL ACHMATI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2100",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_3058e7c2-6a65-4d9a-84e9-31c413aeb32a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "TARISH ALMANSOORI ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "91af08d9-e3fd-492a-b662-552b979c87e6",
    "slug": "abdulaziz-humaid-essa-sultan-alsuwaidi",
    "name": "ABDULAZIZ HUMAID ESSA SULTAN ALSUWAIDI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BSDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/06/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ABDULAZIZ HUMAID ESSA SULTAN ALSUWAIDI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2102",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_91af08d9-e3fd-492a-b662-552b979c87e6",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "MAJID HAMAD AL KALBANI ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "1d4874ca-f9b4-438d-930c-4e1399d77a23",
    "slug": "jamal-ismail-jamal-abdulla-alhosani",
    "name": "JAMAL ISMAIL JAMAL ABDULLA ALHOSANI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5KSTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/06/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: JAMAL ISMAIL JAMAL ABDULLA ALHOSANI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2103",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_1d4874ca-f9b4-438d-930c-4e1399d77a23",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "MUSAAB ALI AL NAQBI ADVOCATES & LEGAL CONSULTANCY"
  },
  {
    "id": "bf9afdc2-3dd7-4cbc-97a7-53054eff35d2",
    "slug": "safa-mohamed-abdulla-salem",
    "name": "SAFA MOHAMED ABDULLA SALEM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/06/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: SAFA MOHAMED ABDULLA SALEM",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2105",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_bf9afdc2-3dd7-4cbc-97a7-53054eff35d2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "OUTSIDE DUBAI FIRM"
  },
  {
    "id": "14926e30-e9bd-4ff9-8c33-1ec238eca844",
    "slug": "musleha-sulaiman-saleh-amer-alseiari",
    "name": "MUSLEHA SULAIMAN SALEH AMER ALSEIARI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/06/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: MUSLEHA SULAIMAN SALEH AMER ALSEIARI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2107",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_14926e30-e9bd-4ff9-8c33-1ec238eca844",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "OUTSIDE DUBAI FIRM"
  },
  {
    "id": "eb029de0-747d-4759-b73f-24a727724761",
    "slug": "jamila-rashed-salem-buti",
    "name": "JAMILA RASHED SALEM BUTI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5KUjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/06/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: JAMILA RASHED SALEM BUTI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2108",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_eb029de0-747d-4759-b73f-24a727724761",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "ALAWAMI ALMANSOORI ADVOCATES AND LEGAL CONSULTANTS"
  },
  {
    "id": "47d04037-6f36-4514-8661-51833bdb6424",
    "slug": "alia-ali-saleh",
    "name": "ALIA ALI SALEH",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/06/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ALIA ALI SALEH",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2110",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_47d04037-6f36-4514-8661-51833bdb6424",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "ALAWAMI ALMANSOORI ADVOCATES AND LEGAL CONSULTANTS"
  },
  {
    "id": "8d778736-0662-49bb-9165-a66fc4817183",
    "slug": "mariam-hashem-mohammed-ahmed-alkaabi",
    "name": "MARIAM HASHEM MOHAMMED AHMED ALKAABI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NSDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "25/06/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-24",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: MARIAM HASHEM MOHAMMED AHMED ALKAABI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2111",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_8d778736-0662-49bb-9165-a66fc4817183",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "OUTSIDE DUBAI FIRM"
  },
  {
    "id": "f5b4ef00-859a-4c47-86eb-3596352eaa17",
    "slug": "rashid-hassan-ibrahim",
    "name": "RASHID HASSAN IBRAHIM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5SSDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "08/07/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-07",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: RASHID HASSAN IBRAHIM",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2112",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_f5b4ef00-859a-4c47-86eb-3596352eaa17",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "OUTSIDE DUBAI FIRM"
  },
  {
    "id": "42801f1b-542c-49b3-8d26-966562c1487c",
    "slug": "fatma-hassan-ibrahim-ali",
    "name": "FATMA HASSAN IBRAHIM ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5GSDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/07/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: FATMA HASSAN IBRAHIM ALI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2113",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_42801f1b-542c-49b3-8d26-966562c1487c",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "AMER AL MARZOOQI ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "79241327-625b-4608-a8a3-f7daa74f0263",
    "slug": "ahmed-ali-khalil-alhawai",
    "name": "AHMED ALI KHALIL ALHAWAI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/07/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: AHMED ALI KHALIL ALHAWAI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2114",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_79241327-625b-4608-a8a3-f7daa74f0263",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "AL GHARIB & PARTNERS ADVOCATES LEGAL CONSULTANTS"
  },
  {
    "id": "2edaf7c8-8ddf-4183-a0d1-20c69b0b556e",
    "slug": "reem-emad-al-deen-abdul-qader-ali",
    "name": "REEM EMAD AL DEEN ABDUL QADER ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5SRTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/07/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: REEM EMAD AL DEEN ABDUL QADER ALI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2115",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_2edaf7c8-8ddf-4183-a0d1-20c69b0b556e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "ALI ALETER ADVOCATES & LEGAL CONSULTANCY"
  },
  {
    "id": "c248c425-7de1-4c18-b3b4-1c0d07cfa09d",
    "slug": "sara-ali-yousif-almulla-alhammadi",
    "name": "SARA ALI YOUSIF ALMULLA ALHAMMADI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "10/07/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-09",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: SARA ALI YOUSIF ALMULLA ALHAMMADI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2116",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_c248c425-7de1-4c18-b3b4-1c0d07cfa09d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "OUTSIDE DUBAI FIRM"
  },
  {
    "id": "4234ef84-3606-4d39-9684-830d4fe0f695",
    "slug": "bashaer-mubarak-amer-awadh-binamro",
    "name": "BASHAER MUBARAK AMER AWADH BINAMRO",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5CTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "15/07/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-14",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: BASHAER MUBARAK AMER AWADH BINAMRO",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2119",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_4234ef84-3606-4d39-9684-830d4fe0f695",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Testing-Firm"
  },
  {
    "id": "381797e0-f00d-437d-b5cd-7ba97d24de3e",
    "slug": "ali-salem-ali-salem-alalawi",
    "name": "ALI SALEM ALI SALEM ALALAWI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/07/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ALI SALEM ALI SALEM ALALAWI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2120",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_381797e0-f00d-437d-b5cd-7ba97d24de3e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "OUTSIDE DUBAI FIRM"
  },
  {
    "id": "f3a7252c-50b4-410a-8b39-5e0e0094f6a9",
    "slug": "bashayer-salem-ali-s-a-marshoud",
    "name": "BASHAYER SALEM ALI S A MARSHOUD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5CUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/07/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: BASHAYER SALEM ALI S A MARSHOUD",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2121",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_f3a7252c-50b4-410a-8b39-5e0e0094f6a9",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "OUTSIDE DUBAI FIRM"
  },
  {
    "id": "fb113a0c-5994-4790-8375-8b1058e2da1a",
    "slug": "ameena-mohd-sharif-mohamed-saleh",
    "name": "AMEENA MOHD SHARIF MOHAMED SALEH",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/07/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: AMEENA MOHD SHARIF MOHAMED SALEH",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2122",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_fb113a0c-5994-4790-8375-8b1058e2da1a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "HABIB ALMULLA & PARTNERS"
  },
  {
    "id": "1a1693a8-8ddc-425e-a2cc-555ae3217a19",
    "slug": "abdulla-saleh-sharif-ali-saleh",
    "name": "ABDULLA SALEH SHARIF ALI SALEH",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/07/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ABDULLA SALEH SHARIF ALI SALEH",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2123",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_1a1693a8-8ddc-425e-a2cc-555ae3217a19",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "OUTSIDE DUBAI FIRM"
  },
  {
    "id": "533629e0-c704-4766-b6c3-d8700f01faae",
    "slug": "alya-salem-majed-salem-alnuaimi",
    "name": "ALYA SALEM MAJED SALEM ALNUAIMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/07/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ALYA SALEM MAJED SALEM ALNUAIMI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2125",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_533629e0-c704-4766-b6c3-d8700f01faae",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "OUTSIDE DUBAI FIRM"
  },
  {
    "id": "8265767c-a5c5-40b5-9110-6575e2bab0e8",
    "slug": "saleh-rabeea-hasan-ali-alseiari",
    "name": "SALEH RABEEA HASAN ALI ALSEIARI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TUjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/08/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: SALEH RABEEA HASAN ALI ALSEIARI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2127",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_8265767c-a5c5-40b5-9110-6575e2bab0e8",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "OUTSIDE DUBAI FIRM"
  },
  {
    "id": "91a051b6-0eb0-4770-bb7d-eac4259b103e",
    "slug": "afra-hasan-saeed-salem-alnuaimi",
    "name": "AFRA HASAN SAEED SALEM ALNUAIMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BSDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "17/08/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-16",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: AFRA HASAN SAEED SALEM ALNUAIMI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2128",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_91a051b6-0eb0-4770-bb7d-eac4259b103e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "DR JAMAL ALNUAIMI ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "623cd307-c2a8-49f6-b49e-1d7e5d39a14b",
    "slug": "adel-mohammed-saif-saeed-alkaabi",
    "name": "ADEL MOHAMMED SAIF SAEED ALKAABI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/08/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ADEL MOHAMMED SAIF SAEED ALKAABI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2130",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_623cd307-c2a8-49f6-b49e-1d7e5d39a14b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "OUTSIDE DUBAI FIRM"
  },
  {
    "id": "b861533a-334d-4183-a00f-074c0a283883",
    "slug": "maha-yousif-yaagoub-ali-alhosani",
    "name": "MAHA YOUSIF YAAGOUB ALI ALHOSANI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NWTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/08/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: MAHA YOUSIF YAAGOUB ALI ALHOSANI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2132",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_b861533a-334d-4183-a00f-074c0a283883",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "OUTSIDE DUBAI FIRM"
  },
  {
    "id": "a8c47e26-ce6e-4820-b70c-4c98449319b8",
    "slug": "fahad-fadil-abdelrahman-alhamer-al-ali",
    "name": "FAHAD FADIL ABDELRAHMAN ALHAMER AL ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5GRjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "18/08/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-17",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: FAHAD FADIL ABDELRAHMAN ALHAMER AL ALI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2133",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_a8c47e26-ce6e-4820-b70c-4c98449319b8",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "AL SAHLAWI & CO ADVOCATES & CONSULTANTS"
  },
  {
    "id": "fc5f45df-b1b8-4985-897b-e338b7c20e17",
    "slug": "mohamed-khazaal-mohamed-abduljabbar-alobeidli",
    "name": "MOHAMED KHAZAAL MOHAMED ABDULJABBAR ALOBEIDLI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NSzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/08/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: MOHAMED KHAZAAL MOHAMED ABDULJABBAR ALOBEIDLI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2135",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_fc5f45df-b1b8-4985-897b-e338b7c20e17",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "MOHAMMED BANI HASHEM ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "085aca75-3291-421b-93ae-107ff5a1721b",
    "slug": "mansour-mohamed-abdalla-ali-hassan",
    "name": "MANSOUR MOHAMED ABDALLA ALI HASSAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/09/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: MANSOUR MOHAMED ABDALLA ALI HASSAN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2136",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_085aca75-3291-421b-93ae-107ff5a1721b",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "OUTSIDE DUBAI FIRM"
  },
  {
    "id": "c5af28b5-2d3e-48c2-849b-d1848e857844",
    "slug": "yousef-khalaf-yousef-abdulla-bahri",
    "name": "YOUSEF KHALAF YOUSEF ABDULLA BAHRI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ZSzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/09/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: YOUSEF KHALAF YOUSEF ABDULLA BAHRI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2137",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_c5af28b5-2d3e-48c2-849b-d1848e857844",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "AL SHEHHI GROUP ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "122af302-1d83-4e5f-ba58-1272a1ee47f5",
    "slug": "hussain-qaitas-baqer-alfarsi",
    "name": "HUSSAIN QAITAS BAQER ALFARSI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5IUTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/09/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: HUSSAIN QAITAS BAQER ALFARSI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2138",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_122af302-1d83-4e5f-ba58-1272a1ee47f5",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "MAJID HAMAD AL KALBANI ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "1710c919-0891-4309-93ac-37d108a7cd88",
    "slug": "maryam-hasan-mohammed-alsayiedhasan-alhashmi",
    "name": "MARYAM HASAN MOHAMMED ALSAYIEDHASAN ALHASHMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NSDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/09/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: MARYAM HASAN MOHAMMED ALSAYIEDHASAN ALHASHMI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2139",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_1710c919-0891-4309-93ac-37d108a7cd88",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "OUTSIDE DUBAI FIRM"
  },
  {
    "id": "6d9ff54c-cb83-4f49-9f3d-58f46a313ee3",
    "slug": "saeed-salem-ali-khamis",
    "name": "SAEED SALEM ALI KHAMIS",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/09/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: SAEED SALEM ALI KHAMIS",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2140",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_6d9ff54c-cb83-4f49-9f3d-58f46a313ee3",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "MOHAMMED ABDULLA ALBREIKE LEGAL CONSULTANTS"
  },
  {
    "id": "5c3d66d1-7b81-4044-9a31-ff1b7a687a9d",
    "slug": "shamsa-mohammed-abdul-razzaq-m-alkhoori",
    "name": "SHAMSA MOHAMMED ABDUL RAZZAQ M.ALKHOORI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "28/09/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-27",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: SHAMSA MOHAMMED ABDUL RAZZAQ M.ALKHOORI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2141",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_5c3d66d1-7b81-4044-9a31-ff1b7a687a9d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "GLOBAL ADVOCACY & LEGAL COUNSEL"
  },
  {
    "id": "c3bd13ee-22d6-452a-aeb9-76d524f8f3a7",
    "slug": "maha-mohammad-ghanim-suhrab-mohammad",
    "name": "MAHA MOHAMMAD GHANIM SUHRAB MOHAMMAD",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/10/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: MAHA MOHAMMAD GHANIM SUHRAB MOHAMMAD",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2142",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_c3bd13ee-22d6-452a-aeb9-76d524f8f3a7",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "DR AMIRA Al BASTAKI ADVOCATES AND LEGAL CONSULTANT"
  },
  {
    "id": "347ac91c-6abf-4252-88fa-2c4579ef336e",
    "slug": "salman-mohamed-malalla-s-alhammadi",
    "name": "SALMAN MOHAMED MALALLA S.ALHAMMADI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/10/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: SALMAN MOHAMED MALALLA S.ALHAMMADI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2145",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_347ac91c-6abf-4252-88fa-2c4579ef336e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "OUTSIDE DUBAI FIRM"
  },
  {
    "id": "0ebe3c5b-4ecc-48e0-b62b-287224359f72",
    "slug": "reyadh-mohamed-shareef-taher-alsheebani",
    "name": "REYADH MOHAMED SHAREEF TAHER ALSHEEBANI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5STTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "21/10/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-20",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: REYADH MOHAMED SHAREEF TAHER ALSHEEBANI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2147",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_0ebe3c5b-4ecc-48e0-b62b-287224359f72",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "MOHAMMED AL MARZOOQI ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "463b71ff-e044-4e6d-8455-edc73d555f63",
    "slug": "ramadan-karim-bakhsh-alblooshi",
    "name": "RAMADAN KARIM BAKHSH ALBLOOSHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5SSzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "23/10/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-22",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: RAMADAN KARIM BAKHSH ALBLOOSHI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2148",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_463b71ff-e044-4e6d-8455-edc73d555f63",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "OUTSIDE DUBAI FIRM"
  },
  {
    "id": "a91149d9-98b8-466a-9756-118f9dda143a",
    "slug": "awadh-salem-eidha",
    "name": "AWADH SALEM EIDHA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "29/10/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-10-28",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: AWADH SALEM EIDHA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2149",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_a91149d9-98b8-466a-9756-118f9dda143a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "MARIAM OBAID ALBLOOSHI ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "b223713f-24c1-4f49-87ba-bd97f59b5d44",
    "slug": "sultan-ahmad-ali",
    "name": "SULTAN AHMAD ALI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/11/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: SULTAN AHMAD ALI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2150",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_b223713f-24c1-4f49-87ba-bd97f59b5d44",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "LOUBNA WALIED MOHAMED ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "83c44821-6c5f-49f5-b1b5-2f1507187989",
    "slug": "faten-tamim",
    "name": "FATEN TAMIM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5GVDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "02/11/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-01",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: FATEN TAMIM",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2151",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_83c44821-6c5f-49f5-b1b5-2f1507187989",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "OUTSIDE DUBAI FIRM"
  },
  {
    "id": "b0b47206-df34-4895-bccf-c034ebd4194a",
    "slug": "sara-matar-ahmed-ghaith-alsuwaidi",
    "name": "SARA MATAR AHMED GHAITH ALSUWAIDI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/11/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: SARA MATAR AHMED GHAITH ALSUWAIDI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2152",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_b0b47206-df34-4895-bccf-c034ebd4194a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "OUTSIDE DUBAI FIRM"
  },
  {
    "id": "3f160295-e844-45a7-b762-dff1ea53f922",
    "slug": "randa-ali-mohammed-ali-bawazeer",
    "name": "RANDA ALI MOHAMMED ALI BAWAZEER",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5SQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/11/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: RANDA ALI MOHAMMED ALI BAWAZEER",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2153",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_3f160295-e844-45a7-b762-dff1ea53f922",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "BIN HAIDER ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "7721faed-ac6a-4e3d-81df-5bbe0adda574",
    "slug": "rashid-ahmed-khalfan",
    "name": "RASHID AHMED KHALFAN",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5SQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/11/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: RASHID AHMED KHALFAN",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2154",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_7721faed-ac6a-4e3d-81df-5bbe0adda574",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "EBRAHIM ALI AL MOUSA ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "472127ac-7e51-431b-a262-74af55654dc4",
    "slug": "faisal-mohammad-hashim",
    "name": "FAISAL MOHAMMAD HASHIM",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5GTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/11/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: FAISAL MOHAMMAD HASHIM",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2155",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_472127ac-7e51-431b-a262-74af55654dc4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "Bader Hamad Al Zaabi Advocates and Legal consultants"
  },
  {
    "id": "68b601be-d578-4860-b75f-f4f4eb0f76e1",
    "slug": "abdulrahman-mohd-abdulrahman-a-alnuaimi",
    "name": "ABDULRAHMAN MOHD ABDULRAHMAN A.ALNUAIMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/07/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ABDULRAHMAN MOHD ABDULRAHMAN A.ALNUAIMI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-781",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_68b601be-d578-4860-b75f-f4f4eb0f76e1",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "ADVOCATES UNIT"
  },
  {
    "id": "58a18b72-d863-46db-a0b5-f22ce4720ca1",
    "slug": "habib-almulla-partners",
    "name": "HABIB ALMULLA & PARTNERS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5IQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HABIB ALMULLA & PARTNERS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_58a18b72-d863-46db-a0b5-f22ce4720ca1",
        "address": "level 14 & offices No. (402،601،602), O14 Tower, Business Bay Road, P.O. Box 2269, Dubai, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "level 14 & offices No. (402،601،602), O14 Tower, Business Bay Road, P.O. Box 2269, Dubai, United Arab Emirates"
  },
  {
    "id": "cd94eba7-2dd7-4cf6-8014-8dc6e1ae3901",
    "slug": "kka-law-firm",
    "name": "Kka law firm",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5LTDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Kka law firm",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_cd94eba7-2dd7-4cf6-8014-8dc6e1ae3901",
        "address": "-",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "Khalfan Alshamsi",
    "address": "-"
  },
  {
    "id": "8b315da4-82a8-475e-8e1e-6035e391076d",
    "slug": "mouza-hamad-alnuaimi-advocates-legal-consultants",
    "name": "MOUZA HAMAD ALNUAIMI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NSDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MOUZA HAMAD ALNUAIMI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_8b315da4-82a8-475e-8e1e-6035e391076d",
        "address": "-",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "MOUZA HAMAD OBAID ALNOUIMI",
    "address": "-"
  },
  {
    "id": "47f19087-8b57-4c9b-84a8-610538bb9cf8",
    "slug": "saeed-bin-sulaiman-advocates-and-legal-consultants",
    "name": "SAEED BIN SULAIMAN ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TQjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SAEED BIN SULAIMAN ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_47f19087-8b57-4c9b-84a8-610538bb9cf8",
        "address": "-",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "سعيد حمد محمد احمد بن سليمان",
    "address": "-"
  },
  {
    "id": "60730688-be20-4648-8039-8b1ad9a78715",
    "slug": "ali-bin-tamim-co-advocates-legal-consultansy",
    "name": "ALI BIN TAMIM & CO ADVOCATES & LEGAL CONSULTANSY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALI BIN TAMIM & CO ADVOCATES & LEGAL CONSULTANSY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_60730688-be20-4648-8039-8b1ad9a78715",
        "address": "Office No. 305, Level 3, Al Bakheet Centre, Al Khubaisi, Deira, P.O. Box 81177, Dubai, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 305, Level 3, Al Bakheet Centre, Al Khubaisi, Deira, P.O. Box 81177, Dubai, United Arab Emirates"
  },
  {
    "id": "ed8ec816-8afa-4f4b-8487-6c9612c1d527",
    "slug": "hikmat-fayad-associates-advo-leg-consultants",
    "name": "HIKMAT FAYAD & ASSOCIATES ADVO.& LEG.CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5IRjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HIKMAT FAYAD & ASSOCIATES ADVO.& LEG.CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_ed8ec816-8afa-4f4b-8487-6c9612c1d527",
        "address": "Office No. 503, Level 5, Green Tower Bldg, Al Ras Street, Riggat Al Buteen, Deira, P.O. Box 5630, Dubai, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 503, Level 5, Green Tower Bldg, Al Ras Street, Riggat Al Buteen, Deira, P.O. Box 5630, Dubai, United Arab Emirates"
  },
  {
    "id": "903e0ca3-bf21-4af9-99ac-3c32e49830c5",
    "slug": "hilal-associates-advocates-legal-consultants",
    "name": "HILAL &ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5IJmFtcDs8L3RleHQ+PC9zdmc+",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HILAL &ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_903e0ca3-bf21-4af9-99ac-3c32e49830c5",
        "address": "Office No. (801& 802), Level 8, Dubai National Insurance Building, Port Saeed, Deira, P.O. Box 7372, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. (801& 802), Level 8, Dubai National Insurance Building, Port Saeed, Deira, P.O. Box 7372, Dubai"
  },
  {
    "id": "0516b32a-f9ab-4feb-af1b-626947d8ed7a",
    "slug": "dalmook-mohammed-dalmook-advocate-legal-consultancy",
    "name": "DALMOOK MOHAMMED DALMOOK ADVOCATE & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ETTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: DALMOOK MOHAMMED DALMOOK ADVOCATE & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_0516b32a-f9ab-4feb-af1b-626947d8ed7a",
        "address": "Office No. 901, Al Etihad Building, Level 9, Opposite Deira City Centre, Deira, P.O. Box 3467, Dubai, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 901, Al Etihad Building, Level 9, Opposite Deira City Centre, Deira, P.O. Box 3467, Dubai, United Arab Emirates"
  },
  {
    "id": "8989e056-500c-4dbf-9be7-5abd622af35e",
    "slug": "almaidoor-advocates-legal-consultants",
    "name": "ALMAIDOOR ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALMAIDOOR ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_8989e056-500c-4dbf-9be7-5abd622af35e",
        "address": "Office No. 506, Level 5, Montana Building, Zabeel Street, Al Karama, Bur Dubai, P.O. Box. 113443, Dubai, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 506, Level 5, Montana Building, Zabeel Street, Al Karama, Bur Dubai, P.O. Box. 113443, Dubai, United Arab Emirates"
  },
  {
    "id": "db98c6db-aa33-48ea-96d4-90b0c9391235",
    "slug": "al-haddad-associates-advocates-legal-consultants",
    "name": "AL HADDAD & ASSOCIATES - ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BSDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL HADDAD & ASSOCIATES - ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_db98c6db-aa33-48ea-96d4-90b0c9391235",
        "address": "Office No. 2505, Level 25, Fairmont Hotel, office Building, Sheikh Zayed Road, P.O. Box 27720, Dubai, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 2505, Level 25, Fairmont Hotel, office Building, Sheikh Zayed Road, P.O. Box 27720, Dubai, United Arab Emirates"
  },
  {
    "id": "2d887824-ce10-4f0b-b82a-f885ec226ef2",
    "slug": "ali-al-mannaei-advocates-and-legal-consultants",
    "name": "ALI AL MANNAEI ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALI AL MANNAEI ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_2d887824-ce10-4f0b-b82a-f885ec226ef2",
        "address": "Office No. 101, Level 1, Royal Plaza Building, Al Rigga Street, Deira, P.O. Box. 184569, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 101, Level 1, Royal Plaza Building, Al Rigga Street, Deira, P.O. Box. 184569, Dubai"
  },
  {
    "id": "6ac84933-19cf-46ea-8a8f-2ef75f3003db",
    "slug": "alkamali-company-advocates-legal-consultants",
    "name": "ALKAMALI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALKAMALI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_6ac84933-19cf-46ea-8a8f-2ef75f3003db",
        "address": "Office No. ( 205 B6), Level 2, H.H Shaikh Saud Bin Saqar Tower, P.O. Box. 4948, Dubai, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. ( 205 B6), Level 2, H.H Shaikh Saud Bin Saqar Tower, P.O. Box. 4948, Dubai, United Arab Emirates"
  },
  {
    "id": "04143c6a-a45a-41af-b17f-060f1f10a998",
    "slug": "azza-ibrahim-hassan-al-mulla-advocates-legal-consultants",
    "name": "AZZA IBRAHIM HASSAN AL MULLA ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BSTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AZZA IBRAHIM HASSAN AL MULLA ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_04143c6a-a45a-41af-b17f-060f1f10a998",
        "address": "Office No A602-A603, Level 6, Level 6 , City Avenue Building, Port Saeed, Deira, No. 3199094438, P.O. Box. 12871, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No A602-A603, Level 6, Level 6 , City Avenue Building, Port Saeed, Deira, No. 3199094438, P.O. Box. 12871, Dubai"
  },
  {
    "id": "9e45ffd9-def0-43c9-85e8-4699b5374c4a",
    "slug": "ahmad-bin-dhahi-advocates-legal-consultants",
    "name": "AHMAD BIN DHAHI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AHMAD BIN DHAHI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_9e45ffd9-def0-43c9-85e8-4699b5374c4a",
        "address": "Office No. 105, Level 1, Nasr Plaza, Owned by Al Nasr SC, P.O. Box. 285230, Dubai, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 105, Level 1, Nasr Plaza, Owned by Al Nasr SC, P.O. Box. 285230, Dubai, United Arab Emirates"
  },
  {
    "id": "041f6345-972d-4c12-82eb-a991bac33dbc",
    "slug": "haleema-almarzooqi-partners-advocates-legal-consultants",
    "name": "HALEEMA ALMARZOOQI &PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5IQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HALEEMA ALMARZOOQI &PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_041f6345-972d-4c12-82eb-a991bac33dbc",
        "address": "Office No. 1101, 11 Level, Trade Center First ,Khaled Al Attar Tower, P.O. Box. 410961, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 1101, 11 Level, Trade Center First ,Khaled Al Attar Tower, P.O. Box. 410961, United Arab Emirates"
  },
  {
    "id": "ef95bbac-585d-484f-9d42-11c841ae8fbf",
    "slug": "dar-al-adala-advocates-legal-consultants",
    "name": "DAR AL ADALA ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5EQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: DAR AL ADALA ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_ef95bbac-585d-484f-9d42-11c841ae8fbf",
        "address": "Office No. (56,57,58), Level 5, Al Zumordah Building, Umm Hurair Street, Al Hamriyah, Bur Dubai, P.O. Box 15878, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. (56,57,58), Level 5, Al Zumordah Building, Umm Hurair Street, Al Hamriyah, Bur Dubai, P.O. Box 15878, Dubai"
  },
  {
    "id": "54f74102-5477-41d6-b2ad-25c9b7bb39ca",
    "slug": "abdulrahman-lootah-associates-advocates-legal-consultancy",
    "name": "ABDULRAHMAN LOOTAH & ASSOCIATES ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BTDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDULRAHMAN LOOTAH & ASSOCIATES ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_54f74102-5477-41d6-b2ad-25c9b7bb39ca",
        "address": "Office No. 204, Level 2, Al Etihad Real state Building, Al Etihad Street, Port Saeed, Deira, P.O. Box. 4866, Dubai, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 204, Level 2, Al Etihad Real state Building, Al Etihad Street, Port Saeed, Deira, P.O. Box. 4866, Dubai, United Arab Emirates"
  },
  {
    "id": "7412fe0c-b942-48e5-b995-2d73b27df232",
    "slug": "dar-al-hekma-lawyers-legal-consultancy",
    "name": "DAR AL HEKMA LAWYERS & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5EQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: DAR AL HEKMA LAWYERS & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_7412fe0c-b942-48e5-b995-2d73b27df232",
        "address": "Office No. 815, Level 8, Business Avenue Building, Al Etihad Street, Port Saeed, Deira, Makani No.: 3248594620",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 815, Level 8, Business Avenue Building, Al Etihad Street, Port Saeed, Deira, Makani No.: 3248594620"
  },
  {
    "id": "5c9e0932-eccb-4f50-b5eb-6088e7f7522b",
    "slug": "abdulhakim-binherz-advocates-and-legal-consultants",
    "name": "ABDULHAKIM BINHERZ ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDULHAKIM BINHERZ ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_5c9e0932-eccb-4f50-b5eb-6088e7f7522b",
        "address": "Office No. 3801, 38th Level, Latifa Tower, Sheikh Zayed Road, Trade Centre 1st, P.O. Box. 97598, Dubai,",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 3801, 38th Level, Latifa Tower, Sheikh Zayed Road, Trade Centre 1st, P.O. Box. 97598, Dubai,"
  },
  {
    "id": "e7aa6def-9f4e-43fb-99a9-2323eb9598a0",
    "slug": "alsuwaidi-company-l-l-c",
    "name": "ALSUWAIDI & COMPANY L.L.C",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALSUWAIDI & COMPANY L.L.C",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_e7aa6def-9f4e-43fb-99a9-2323eb9598a0",
        "address": "Office No. (250,251,252& 253), Level 2, Emarat Atrium Building, Sheikh Zayed Road, Bur Dubai, P.O. Box. 7273, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. (250,251,252& 253), Level 2, Emarat Atrium Building, Sheikh Zayed Road, Bur Dubai, P.O. Box. 7273, Dubai"
  },
  {
    "id": "8b3583f3-3102-4fe3-b4f4-a88750cdf49a",
    "slug": "noof-alabdulla-advocates-legal-consultants",
    "name": "NOOF ALABDULLA ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5OQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: NOOF ALABDULLA ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_8b3583f3-3102-4fe3-b4f4-a88750cdf49a",
        "address": "Office No. 101, Level 1, Burj Gate 48, Sheikh Zayed Road, Bur Dubai, P.O. Box. 555567, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 101, Level 1, Burj Gate 48, Sheikh Zayed Road, Bur Dubai, P.O. Box. 555567, Dubai"
  },
  {
    "id": "99b4ee1d-edd6-4b5b-a3d1-64b6f99653b2",
    "slug": "hourani-partners",
    "name": "HOURANI & PARTNERS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5IUDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HOURANI & PARTNERS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_99b4ee1d-edd6-4b5b-a3d1-64b6f99653b2",
        "address": "Office No. 304, Level 3, Offices Building 5, One Central, Trade Center Second, Bur Dubai, Makani No. 2760891214",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 304, Level 3, Offices Building 5, One Central, Trade Center Second, Bur Dubai, Makani No. 2760891214"
  },
  {
    "id": "1d6563d7-159f-470a-9064-ba45e2e97dad",
    "slug": "al-wasl-international-group-advocates-and-legal-consultants",
    "name": "AL WASL INTERNATIONAL GROUP ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BVzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL WASL INTERNATIONAL GROUP ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_1d6563d7-159f-470a-9064-ba45e2e97dad",
        "address": "Office No. 106, Level 1, Building 13, Dubai Internet City, P.O. Box 502248, Dubai, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 106, Level 1, Building 13, Dubai Internet City, P.O. Box 502248, Dubai, United Arab Emirates"
  },
  {
    "id": "eb8c9f67-9304-4adc-af69-448458214b73",
    "slug": "al-aidarous-advocates-legal-consultants",
    "name": "AL AIDAROUS ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL AIDAROUS ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_eb8c9f67-9304-4adc-af69-448458214b73",
        "address": "Office No. (1301), Level 13, Oberoi Center, Al A'amal Street, Business Bay, Bur Dubai, P.O. Box. 33299, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. (1301), Level 13, Oberoi Center, Al A'amal Street, Business Bay, Bur Dubai, P.O. Box. 33299, Dubai"
  },
  {
    "id": "8e4d11cf-c7cc-4cbd-9d41-c850fc3501ee",
    "slug": "mohammad-amin-gheyath-advocates",
    "name": "MOHAMMAD AMIN GHEYATH ADVOCATES",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MOHAMMAD AMIN GHEYATH ADVOCATES",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_8e4d11cf-c7cc-4cbd-9d41-c850fc3501ee",
        "address": "-",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "-"
  },
  {
    "id": "7cec39d4-0da9-4491-9c25-75ba279d78df",
    "slug": "nawal-mohamed-albady-advocates-legal-consultants",
    "name": "NAWAL MOHAMED ALBADY ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5OTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: NAWAL MOHAMED ALBADY ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_7cec39d4-0da9-4491-9c25-75ba279d78df",
        "address": "Office No. (608), Level 6, Al Dana Centre,, Al Maktoum Street, Deira, P.O. Box. 80239, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. (608), Level 6, Al Dana Centre,, Al Maktoum Street, Deira, P.O. Box. 80239, Dubai"
  },
  {
    "id": "59d7abde-3d9e-411d-a43f-d9b87054220c",
    "slug": "b-s-a-ahmad-bin-hazeem-associates-dubai-international-financial-centre-branch",
    "name": "B S A AHMAD BIN HAZEEM & ASSOCIATES - DUBAI INTERNATIONAL FINANCIAL CENTRE BRANCH",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5CUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: B S A AHMAD BIN HAZEEM & ASSOCIATES - DUBAI INTERNATIONAL FINANCIAL CENTRE BRANCH",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_59d7abde-3d9e-411d-a43f-d9b87054220c",
        "address": "Office No. 604 [، 605 ، 606 ، 601], Level 6, Building No. 3, Dubai International Financial Centre, P.O. Box. 262, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 604 [، 605 ، 606 ، 601], Level 6, Building No. 3, Dubai International Financial Centre, P.O. Box. 262, Dubai"
  },
  {
    "id": "ed5fc030-7640-434a-8977-9e8eba1bfbe5",
    "slug": "bin-eid-advocates-legel-consultants",
    "name": "BIN EID ADVOCATES & LEGEL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5CRTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: BIN EID ADVOCATES & LEGEL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_ed5fc030-7640-434a-8977-9e8eba1bfbe5",
        "address": "Office No. 014, Level 2 ,Al Mamzar Center, Near the former Labour Office,Hor Al Anz East , Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 014, Level 2 ,Al Mamzar Center, Near the former Labour Office,Hor Al Anz East , Dubai"
  },
  {
    "id": "4b96fead-b9ef-4260-a2b5-7ad06fbfd176",
    "slug": "meleih-advocates-and-legal-consultants",
    "name": "MELEIH ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MELEIH ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_4b96fead-b9ef-4260-a2b5-7ad06fbfd176",
        "address": "Office No. (304-305), Level 3, Al Sho'la Building, Port Saeed, Deira, P.O. Box. 127934, Dubai, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. (304-305), Level 3, Al Sho'la Building, Port Saeed, Deira, P.O. Box. 127934, Dubai, United Arab Emirates"
  },
  {
    "id": "739b8154-810a-4363-8f60-69b4cc4e7c99",
    "slug": "al-madhani-alshamsi-advocates-legal-consultants",
    "name": "AL MADHANI & ALSHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL MADHANI & ALSHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_739b8154-810a-4363-8f60-69b4cc4e7c99",
        "address": "Office No. (2701& 2702), Level 27, Single Business Tower, Sheikh Zayed Road, Bur Dubai, P.O. Box. 184884, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. (2701& 2702), Level 27, Single Business Tower, Sheikh Zayed Road, Bur Dubai, P.O. Box. 184884, Dubai"
  },
  {
    "id": "7137aa78-3872-4246-8e8b-bf55f21d5d77",
    "slug": "al-tamimi-company-fz-llc",
    "name": "AL TAMIMI & COMPANY FZ-LLC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BVDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL TAMIMI & COMPANY FZ-LLC",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_7137aa78-3872-4246-8e8b-bf55f21d5d77",
        "address": "DMC-BLD05-DQ-F01-016 -- First Floor, Dubai Media City, Dubai, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "DMC-BLD05-DQ-F01-016 -- First Floor, Dubai Media City, Dubai, United Arab Emirates"
  },
  {
    "id": "1f18bbb6-efc7-4bce-b3ba-fd77ec449a66",
    "slug": "rashed-bin-arab-advocate-and-legal-colsultants",
    "name": "RASHED BIN ARAB ADVOCATE AND LEGAL COLSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5SQjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: RASHED BIN ARAB ADVOCATE AND LEGAL COLSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_1f18bbb6-efc7-4bce-b3ba-fd77ec449a66",
        "address": "22nd floor / 2201-02, Second row - Street: Media City -, Concord Tower Building",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "22nd floor / 2201-02, Second row - Street: Media City -, Concord Tower Building"
  },
  {
    "id": "9abb9e30-1374-4b0d-b731-b5a4f60c4c88",
    "slug": "abdulla-alawadi-advocates-legal-consultants",
    "name": "ABDULLA ALAWADI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDULLA ALAWADI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_9abb9e30-1374-4b0d-b731-b5a4f60c4c88",
        "address": "Office No. (1001, 1008, 1009& 1012), Level 10, Prime Tower, Khalifa Street, Business Bay, Makani No. 258368679, P.O. Box. 26665, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. (1001, 1008, 1009& 1012), Level 10, Prime Tower, Khalifa Street, Business Bay, Makani No. 258368679, P.O. Box. 26665, Dubai"
  },
  {
    "id": "5e960f1f-8ef6-4776-a42d-be88446f6073",
    "slug": "ahmed-albannai-advocates-legal-consultants",
    "name": "AHMED ALBANNAI ADVOCATES LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AHMED ALBANNAI ADVOCATES LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_5e960f1f-8ef6-4776-a42d-be88446f6073",
        "address": "Office No. 502, Level 5, Al Rosatamani Building, Port Saeed, Deira, P.O. Box. 13917, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 502, Level 5, Al Rosatamani Building, Port Saeed, Deira, P.O. Box. 13917, Dubai"
  },
  {
    "id": "901ac3f2-6be4-4432-8bd4-beaff8e01151",
    "slug": "algurg-almatrooshi-advocates-legal-consultants",
    "name": "ALGURG & ALMATROOSHI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALGURG & ALMATROOSHI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_901ac3f2-6be4-4432-8bd4-beaff8e01151",
        "address": "Level 24, Burjman Centre, Offices Tower, Khalid Bin Waleed Street, Al Mankhool, Bur Dubai, P.O. Box. 30767, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Level 24, Burjman Centre, Offices Tower, Khalid Bin Waleed Street, Al Mankhool, Bur Dubai, P.O. Box. 30767, Dubai"
  },
  {
    "id": "84bb81b4-5023-4d9f-9d15-3f84b60795ab",
    "slug": "al-safar-partners-advocates-legal-consultants",
    "name": "AL SAFAR & PARTNERS ADVOCATES &LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL SAFAR & PARTNERS ADVOCATES &LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_84bb81b4-5023-4d9f-9d15-3f84b60795ab",
        "address": "Office No. 401, Downtown Building, Palace Hotel Entrance, Square Offices, Block (D), Burj Khalifa Area, Business Bay, P.O. Box. 283773, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 401, Downtown Building, Palace Hotel Entrance, Square Offices, Block (D), Burj Khalifa Area, Business Bay, P.O. Box. 283773, Dubai"
  },
  {
    "id": "8a150385-621b-4a38-82d8-74cfd076bd63",
    "slug": "abdul-rahman-al-mutawa-advocates-legal-consultants",
    "name": "ABDUL RAHMAN AL MUTAWA ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BUjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDUL RAHMAN AL MUTAWA ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_8a150385-621b-4a38-82d8-74cfd076bd63",
        "address": "Office No. M04, Mezzanine Floor, Bu Haleeba Plaza Building, Al Muraqqabat Street, Deira, P.O. Box. 13321, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. M04, Mezzanine Floor, Bu Haleeba Plaza Building, Al Muraqqabat Street, Deira, P.O. Box. 13321, Dubai"
  },
  {
    "id": "d67cf1db-d94e-4284-b166-2403bb2bf287",
    "slug": "bin-ismail-advocates-and-legal-consultancy",
    "name": "BIN ISMAIL ADVOCATES AND LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5CSTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: BIN ISMAIL ADVOCATES AND LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_d67cf1db-d94e-4284-b166-2403bb2bf287",
        "address": "Office No. 1002, Level 10, Al Maktoum Road, Riggat Al Buteen Plaza Building , Deira, Makani No. 2563986945, P.O. Box. 115791, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 1002, Level 10, Al Maktoum Road, Riggat Al Buteen Plaza Building , Deira, Makani No. 2563986945, P.O. Box. 115791, Dubai"
  },
  {
    "id": "dce0da07-451a-4162-b16f-328478af736c",
    "slug": "khalifa-al-maftool-advocates-legal-consultants",
    "name": "KHALIFA AL MAFTOOL ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5LQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: KHALIFA AL MAFTOOL ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_dce0da07-451a-4162-b16f-328478af736c",
        "address": "Office No. (806& 807), B 2, Centurion Star Building, Port Saeed, Deira, P.O. Box. 237766, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. (806& 807), B 2, Centurion Star Building, Port Saeed, Deira, P.O. Box. 237766, Dubai"
  },
  {
    "id": "f0729dba-0a5e-49a5-a151-4f0e63c67b75",
    "slug": "yousif-almaazmi-advocates-and-legal-consultants",
    "name": "YOUSIF ALMAAZMI ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ZQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: YOUSIF ALMAAZMI ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_f0729dba-0a5e-49a5-a151-4f0e63c67b75",
        "address": "Office No. (904), Level 9, Citadel Tower, Business Bay Street, Bur Dubai, P.O. Box. 94646, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. (904), Level 9, Citadel Tower, Business Bay Street, Bur Dubai, P.O. Box. 94646, Dubai"
  },
  {
    "id": "2cdf6caa-65fb-413d-829d-30e3dfc02d0d",
    "slug": "b-s-a-ahmad-bin-hazeem-associates",
    "name": "B S A AHMAD BIN HAZEEM & ASSOCIATES",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5CUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: B S A AHMAD BIN HAZEEM & ASSOCIATES",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_2cdf6caa-65fb-413d-829d-30e3dfc02d0d",
        "address": "Office No. 1401, Level 14, Al Rigal Tower, Business Bay, P.O. Box. 262, Dubai, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 1401, Level 14, Al Rigal Tower, Business Bay, P.O. Box. 262, Dubai, United Arab Emirates"
  },
  {
    "id": "dcdd65cc-4471-4a28-94b3-08ed1dca3869",
    "slug": "araa-group-advocate-legal-consultancy",
    "name": "ARAA GROUP ADVOCATE & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BRzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ARAA GROUP ADVOCATE & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_dcdd65cc-4471-4a28-94b3-08ed1dca3869",
        "address": "Office No. (1103), Empire Heights Tower B, Trade Center Area, Bar Dubai, P.O. Box. 184433, Dubai,",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. (1103), Empire Heights Tower B, Trade Center Area, Bar Dubai, P.O. Box. 184433, Dubai,"
  },
  {
    "id": "5a78b915-a293-4ebd-bb54-64ab873caef2",
    "slug": "al-mashreq-international-advocates-legal-consultants",
    "name": "AL MASHREQ INTERNATIONAL ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL MASHREQ INTERNATIONAL ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_5a78b915-a293-4ebd-bb54-64ab873caef2",
        "address": "Office No. 801, Level 8, Burlington Tower, Business Bay, Bur Dubai, P.O. Box. 97779, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 801, Level 8, Burlington Tower, Business Bay, Bur Dubai, P.O. Box. 97779, Dubai"
  },
  {
    "id": "e6f5f5d7-7084-44f9-a6eb-dce85c428aee",
    "slug": "fatma-al-moosa-advocate-legal-consultancy",
    "name": "FATMA AL MOOSA ADVOCATE & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5GQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: FATMA AL MOOSA ADVOCATE & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_e6f5f5d7-7084-44f9-a6eb-dce85c428aee",
        "address": "Office No. 3008, 8th Floor, Iris Bay Tower, Al Mustaqbal St., Business Bay, Bur Dubai, Makani No. 2466086696",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 3008, 8th Floor, Iris Bay Tower, Al Mustaqbal St., Business Bay, Bur Dubai, Makani No. 2466086696"
  },
  {
    "id": "c12d2f4b-d4b6-41a3-bbc1-a418121fe84b",
    "slug": "ahmed-al-mazmi-advocates-legal-consultants",
    "name": "AHMED AL MAZMI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AHMED AL MAZMI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_c12d2f4b-d4b6-41a3-bbc1-a418121fe84b",
        "address": "Office No. 107, 1 Floor, Bur Dubai -- um Hurair 2, Dubai Supreme Court Complex, P.O. Box. 56637, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 107, 1 Floor, Bur Dubai -- um Hurair 2, Dubai Supreme Court Complex, P.O. Box. 56637, Dubai"
  },
  {
    "id": "caaabc2b-efde-424f-b7d9-0242e87f619a",
    "slug": "al-gharib-partners-advocates-legal-consultants",
    "name": "AL GHARIB & PARTNERS ADVOCATES LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BRzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL GHARIB & PARTNERS ADVOCATES LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_caaabc2b-efde-424f-b7d9-0242e87f619a",
        "address": "Office No. (203& 204), Level 2, City Avenue Building, Port Saeed, Deira, P.O. Box. 83666, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. (203& 204), Level 2, City Avenue Building, Port Saeed, Deira, P.O. Box. 83666, Dubai"
  },
  {
    "id": "0835d60a-1faa-403c-b07d-418e80085eec",
    "slug": "allied-advocates-leagl-consultants-l-l-c",
    "name": "ALLIED ADVOCATES & LEAGL CONSULTANTS L.L.C",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALLIED ADVOCATES & LEAGL CONSULTANTS L.L.C",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_0835d60a-1faa-403c-b07d-418e80085eec",
        "address": "Office No. 101, Level 1, Canal Central Hotel, Al Abraj Street, Business Bay, bur Dubai, Makani No. 2530286061",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 101, Level 1, Canal Central Hotel, Al Abraj Street, Business Bay, bur Dubai, Makani No. 2530286061"
  },
  {
    "id": "4a959a02-2a91-4296-b789-a9544235934b",
    "slug": "aloteiba-hamdan-budebes-advocates-legal-consultants",
    "name": "ALOTEIBA & HAMDAN BUDEBES ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BSDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALOTEIBA & HAMDAN BUDEBES ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_4a959a02-2a91-4296-b789-a9544235934b",
        "address": "Office No. 35, Mezanine Floor, Arabilla Building, Deira, P.O. Box. 127637, Dubai, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 35, Mezanine Floor, Arabilla Building, Deira, P.O. Box. 127637, Dubai, United Arab Emirates"
  },
  {
    "id": "a1fb2356-6463-43cc-8c4a-79bae177c7b0",
    "slug": "al-shehhi-group-advocates-legal-consultants",
    "name": "AL SHEHHI GROUP ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL SHEHHI GROUP ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_a1fb2356-6463-43cc-8c4a-79bae177c7b0",
        "address": "Office No. 101, Level 1, Al Masaood Tower, Regat Albuteen Area, Deira, P.O. Box. 172662, Dubai,",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 101, Level 1, Al Masaood Tower, Regat Albuteen Area, Deira, P.O. Box. 172662, Dubai,"
  },
  {
    "id": "597e538c-3784-4088-8b3d-8e67d21b8787",
    "slug": "dr-al-sabbhan-legal-group-assoclates",
    "name": "DR AL SABBHAN LEGAL GROUP&ASSOCLATES",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5EQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: DR AL SABBHAN LEGAL GROUP&ASSOCLATES",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_597e538c-3784-4088-8b3d-8e67d21b8787",
        "address": "Office No. M01, Mezzanine Level, Al Barsha Shopping Centre, Behind of Al Barsha Traffic Department , Al Quoz 3, P.O. Box. 11784, Dubai,",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. M01, Mezzanine Level, Al Barsha Shopping Centre, Behind of Al Barsha Traffic Department , Al Quoz 3, P.O. Box. 11784, Dubai,"
  },
  {
    "id": "4ca0fc3d-c4b1-4909-a15a-1012aabcc2da",
    "slug": "al-rasheed-partners",
    "name": "AL RASHEED & PARTNERS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BUjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL RASHEED & PARTNERS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_4ca0fc3d-c4b1-4909-a15a-1012aabcc2da",
        "address": "Office No. (602 & 603), Level 6, Business Point Building, Port Saeed, Deira, P.O. Box 443, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. (602 & 603), Level 6, Business Point Building, Port Saeed, Deira, P.O. Box 443, Dubai"
  },
  {
    "id": "005531b5-f22a-419b-af9b-056850b0bc7a",
    "slug": "law-office-of-mahmoud-al-hawai-attorneys-consultants-at-law",
    "name": "LAW OFFICE OF MAHMOUD AL HAWAI ATTORNEYS & CONSULTANTS AT LAW",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5MTzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: LAW OFFICE OF MAHMOUD AL HAWAI ATTORNEYS & CONSULTANTS AT LAW",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_005531b5-f22a-419b-af9b-056850b0bc7a",
        "address": "Office No. 204, Level 2, Zalfa Building, Al Garhoud, Deira, P.O. Box. 36951, Dubai,",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 204, Level 2, Zalfa Building, Al Garhoud, Deira, P.O. Box. 36951, Dubai,"
  },
  {
    "id": "88350f35-5d9b-46fd-ae39-5addadb56ca9",
    "slug": "hani-al-jasmi-advocates-legal-consultants",
    "name": "HANI AL JASMI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5IQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HANI AL JASMI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_88350f35-5d9b-46fd-ae39-5addadb56ca9",
        "address": "Office No 4, Mezzanine Level, Liberty Building, SHK Rashid Street Al Garhoud, Dubai, Makani No. 3273193073",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No 4, Mezzanine Level, Liberty Building, SHK Rashid Street Al Garhoud, Dubai, Makani No. 3273193073"
  },
  {
    "id": "f688d55f-edda-45aa-85a9-2aaeb656ccf8",
    "slug": "alhouby-advocate-legal-consultancy-office",
    "name": "ALHOUBY ADVOCATE & LEGAL CONSULTANCY OFFICE",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALHOUBY ADVOCATE & LEGAL CONSULTANCY OFFICE",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_f688d55f-edda-45aa-85a9-2aaeb656ccf8",
        "address": "Office No. 1606, Level 16, The Prime Tower, Business Bay, Bur Dubai, Makani No. 2583686879",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 1606, Level 16, The Prime Tower, Business Bay, Bur Dubai, Makani No. 2583686879"
  },
  {
    "id": "5e6b9d2f-0c52-42f3-b844-70f071957a8d",
    "slug": "diana-hamade-attorneys-at-law",
    "name": "DIANA HAMADE ATTORNEYS AT LAW",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ESDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: DIANA HAMADE ATTORNEYS AT LAW",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_5e6b9d2f-0c52-42f3-b844-70f071957a8d",
        "address": "Third Floor -- Office A301-S-7 Mirdif -- Dubai Hills -- Street 78 -- Office Building United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Third Floor -- Office A301-S-7 Mirdif -- Dubai Hills -- Street 78 -- Office Building United Arab Emirates"
  },
  {
    "id": "772c311b-2fe7-4561-85a9-e22c99c0dc5f",
    "slug": "ahmad-almadani-advocates-legal-consultants",
    "name": "AHMAD ALMADANI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AHMAD ALMADANI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_772c311b-2fe7-4561-85a9-e22c99c0dc5f",
        "address": "Office No. PR2, Level P4, Tamani Arts Office Bulding , Business Bay Area, Bar Dubai, P.O. Box. 22929, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. PR2, Level P4, Tamani Arts Office Bulding , Business Bay Area, Bar Dubai, P.O. Box. 22929, Dubai"
  },
  {
    "id": "e1c16432-9bf3-4ca3-977f-cb241b29ae11",
    "slug": "ali-habib-advocates-and-legal-consultancy",
    "name": "ALI HABIB ADVOCATES AND LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BSDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALI HABIB ADVOCATES AND LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_e1c16432-9bf3-4ca3-977f-cb241b29ae11",
        "address": "Office No. 105, Level 1 , Sama Tower, Sheikh Zayed Road, Bur Dubai, P.O. Box. 7049, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 105, Level 1 , Sama Tower, Sheikh Zayed Road, Bur Dubai, P.O. Box. 7049, Dubai"
  },
  {
    "id": "73ea928d-54b2-46e8-955a-24a1de5bb35e",
    "slug": "al-falasi-advocates-legal-consultancy",
    "name": "AL FALASI ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BRjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL FALASI ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_73ea928d-54b2-46e8-955a-24a1de5bb35e",
        "address": "Office No. 301, Level 3, Dubai Maritime City, Dubai Real Estate Centre, Bur Dubai, P.O. Box. 16038, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 301, Level 3, Dubai Maritime City, Dubai Real Estate Centre, Bur Dubai, P.O. Box. 16038, Dubai"
  },
  {
    "id": "1b587e2c-1dce-47be-8566-deed9e023196",
    "slug": "yaslem-alsaadi-advocate-legal-consultant",
    "name": "YASLEM ALSAADI ADVOCATE & LEGAL CONSULTANT",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ZQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: YASLEM ALSAADI ADVOCATE & LEGAL CONSULTANT",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_1b587e2c-1dce-47be-8566-deed9e023196",
        "address": "Office No. 406, Level 4, Al Garhoud Area, DBCS Building, P.O. Box. 24445, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 406, Level 4, Al Garhoud Area, DBCS Building, P.O. Box. 24445, Dubai"
  },
  {
    "id": "646d67b7-8954-4883-a55a-f8685f7da5ef",
    "slug": "shaikha-ahmad-advocates-legal-consultants",
    "name": "SHAIKHA AHMAD ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SHAIKHA AHMAD ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_646d67b7-8954-4883-a55a-f8685f7da5ef",
        "address": "Office No. 403 ,Level 4, Al Muraqqabat Street, Century 21 Building, Al Muraqqabat, Deira,",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 403 ,Level 4, Al Muraqqabat Street, Century 21 Building, Al Muraqqabat, Deira,"
  },
  {
    "id": "c6fe6b39-de63-4752-b454-40002f38adc0",
    "slug": "al-maftool-advocates-legal-consultants",
    "name": "AL MAFTOOL ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL MAFTOOL ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_c6fe6b39-de63-4752-b454-40002f38adc0",
        "address": "Office No. 501, Level 5, Al Zarouni, Al Rigga Street, Deira, P.O. Box. 64318, Dubai,",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 501, Level 5, Al Zarouni, Al Rigga Street, Deira, P.O. Box. 64318, Dubai,"
  },
  {
    "id": "a5ea5dd6-a481-4bd3-b141-8373b5b4a824",
    "slug": "aisha-ateeq-advocets-and-legal-consaltint",
    "name": "AISHA ATEEQ ADVOCETS AND LEGAL CONSALTINT",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AISHA ATEEQ ADVOCETS AND LEGAL CONSALTINT",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_a5ea5dd6-a481-4bd3-b141-8373b5b4a824",
        "address": "Office No. M28, Mezanine Floor, Sky Business Building, Al Khairan District, P.O. Box. 48818, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. M28, Mezanine Floor, Sky Business Building, Al Khairan District, P.O. Box. 48818, Dubai"
  },
  {
    "id": "d5eeb123-680f-47a0-8f4e-a2066410501d",
    "slug": "bin-khalfoon-vocates-legal-consultants",
    "name": "BIN KHALFOON VOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5CSzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: BIN KHALFOON VOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_d5eeb123-680f-47a0-8f4e-a2066410501d",
        "address": "Office No.410, 4Th Floor, Atrium Center Building, Al Mankhool, Bur Dubai, Makani No. 2871194507",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No.410, 4Th Floor, Atrium Center Building, Al Mankhool, Bur Dubai, Makani No. 2871194507"
  },
  {
    "id": "31a93dab-76e7-4a7a-ae79-0f2602c31c40",
    "slug": "mansoor-lootah-advocates-legal-consultancy",
    "name": "MANSOOR LOOTAH ADVOCATES &LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NTDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MANSOOR LOOTAH ADVOCATES &LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_31a93dab-76e7-4a7a-ae79-0f2602c31c40",
        "address": "Office No. 112, 113, 115,116 Level 1, Saleh Bin Lahej Building, Garhoud Road, Deira, Makani No. 3265793279",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 112, 113, 115,116 Level 1, Saleh Bin Lahej Building, Garhoud Road, Deira, Makani No. 3265793279"
  },
  {
    "id": "eef1d83c-ccd8-4dee-9e7a-b350b38c7675",
    "slug": "dr-mahmood-hussain-advocates-legal-consultancy",
    "name": "DR MAHMOOD HUSSAIN ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ETTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: DR MAHMOOD HUSSAIN ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_eef1d83c-ccd8-4dee-9e7a-b350b38c7675",
        "address": "Office No.303, Level 3, Bay Tower Building, Al Abraj Street, Bur Dubai, P.O. Box. 233066, Dubai,",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No.303, Level 3, Bay Tower Building, Al Abraj Street, Bur Dubai, P.O. Box. 233066, Dubai,"
  },
  {
    "id": "29fb8c4b-0c6c-4232-be47-e52160565dbd",
    "slug": "amiri-advocates-legal-consultants",
    "name": "AMIRI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AMIRI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_29fb8c4b-0c6c-4232-be47-e52160565dbd",
        "address": "Office No. M05, Mezzanine floor, Al Wasl Kindergarten Building, Al Wasl , El Shikh Zayed Road, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. M05, Mezzanine floor, Al Wasl Kindergarten Building, Al Wasl , El Shikh Zayed Road, United Arab Emirates"
  },
  {
    "id": "a57bd417-441a-4af9-8219-e1799ce3d426",
    "slug": "khalifa-bin-huwaidan-alkatbi-advocates-legal-consultant",
    "name": "KHALIFA BIN HUWAIDAN ALKATBI ADVOCATES & LEGAL CONSULTANT",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5LQjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: KHALIFA BIN HUWAIDAN ALKATBI ADVOCATES & LEGAL CONSULTANT",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_a57bd417-441a-4af9-8219-e1799ce3d426",
        "address": "Office No. 207 & 208, 2nd Level, City Avenue Building, Port Saeed, Deira, P.O. Box. 41333, Dubai, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 207 & 208, 2nd Level, City Avenue Building, Port Saeed, Deira, P.O. Box. 41333, Dubai, United Arab Emirates"
  },
  {
    "id": "6f446046-aaec-4407-8508-b79d99fbcd04",
    "slug": "abdelrahman-almaazmi-advocates-legal-consultants",
    "name": "ABDELRAHMAN ALMAAZMI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDELRAHMAN ALMAAZMI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_6f446046-aaec-4407-8508-b79d99fbcd04",
        "address": "Office No. M03, Mezzanine Level, Business Avenue Building, Port Saeed, Deira, P.O. Box. 35593, Dubai,",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. M03, Mezzanine Level, Business Avenue Building, Port Saeed, Deira, P.O. Box. 35593, Dubai,"
  },
  {
    "id": "751e3c3f-a853-4d7b-b02d-1d3cc6edc282",
    "slug": "alowais-and-almatrooshi-advocate-and-legal-consultants",
    "name": "ALOWAIS AND ALMATROOSHI ADVOCATE AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALOWAIS AND ALMATROOSHI ADVOCATE AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_751e3c3f-a853-4d7b-b02d-1d3cc6edc282",
        "address": "Office No. 9, Mezzanine Level, Business Point Building, Port Saeed, Deira, P.O. Box. 85828, Dubai,",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 9, Mezzanine Level, Business Point Building, Port Saeed, Deira, P.O. Box. 85828, Dubai,"
  },
  {
    "id": "37438d69-f721-4c65-bf1a-915c75541fd9",
    "slug": "mohammed-ahmed-advocate-legel-consultants",
    "name": "MOHAMMED AHMED ADVOCATE & LEGEL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MOHAMMED AHMED ADVOCATE & LEGEL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_37438d69-f721-4c65-bf1a-915c75541fd9",
        "address": "Office No. 1902, 19th Level, Millennium Plaza, Offices, Sheikh Zayed Road, Bur Dubai, P.O. Box. 90095, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 1902, 19th Level, Millennium Plaza, Offices, Sheikh Zayed Road, Bur Dubai, P.O. Box. 90095, Dubai"
  },
  {
    "id": "bbaa29b7-dddc-4a7b-8345-9c7fa9126607",
    "slug": "ali-alshimmari-advocates-legal-consultants",
    "name": "ALI ALSHIMMARI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALI ALSHIMMARI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_bbaa29b7-dddc-4a7b-8345-9c7fa9126607",
        "address": "Office No. 710, 7th Level, Business Avenue Building, Port Saeed, Deira, P.O. Box. 1909, Dubai,",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 710, 7th Level, Business Avenue Building, Port Saeed, Deira, P.O. Box. 1909, Dubai,"
  },
  {
    "id": "53a3dd95-f467-4aa3-a1f1-a2fb2c824303",
    "slug": "rashed-alshehhi-advocates-legal-consultants",
    "name": "RASHED ALSHEHHI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5SQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: RASHED ALSHEHHI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_53a3dd95-f467-4aa3-a1f1-a2fb2c824303",
        "address": "Office No. 604, 6 Floor, Wasl Business Center Building, Deira, Port Saeed , P.O. Box. 2079, Dubai, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 604, 6 Floor, Wasl Business Center Building, Deira, Port Saeed , P.O. Box. 2079, Dubai, United Arab Emirates"
  },
  {
    "id": "d54ead67-adc4-4a96-b3e9-b669ffff722e",
    "slug": "salem-alharthi-law-advocates-legal-consultancy",
    "name": "SALEM ALHARTHI LAW ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SALEM ALHARTHI LAW ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_d54ead67-adc4-4a96-b3e9-b669ffff722e",
        "address": "Office No. 801,8th Level, Emmar Square, Burj Khalifa Area, Bullding No.6, Sheikh Zayed Road, Bur Dubai, P.O. Box. 235635, Dubai,",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 801,8th Level, Emmar Square, Burj Khalifa Area, Bullding No.6, Sheikh Zayed Road, Bur Dubai, P.O. Box. 235635, Dubai,"
  },
  {
    "id": "cd7366af-1972-40f3-8495-5befa1fda0fb",
    "slug": "moaza-alkhadar-advocates-legal-consultancy",
    "name": "MOAZA ALKHADAR ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MOAZA ALKHADAR ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_cd7366af-1972-40f3-8495-5befa1fda0fb",
        "address": "Office No. 3401, 34th Level, Aspect Tower, Business Bay, Bur Dubai, P.O. Box. 118212, Dubai, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 3401, 34th Level, Aspect Tower, Business Bay, Bur Dubai, P.O. Box. 118212, Dubai, United Arab Emirates"
  },
  {
    "id": "34adf60b-ecc8-4a53-b72e-3b4c4af4e517",
    "slug": "jabir-rashid-alsalami-advocates-legel-consultancy",
    "name": "JABIR RASHID ALSALAMI ADVOCATES & LEGEL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5KUjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: JABIR RASHID ALSALAMI ADVOCATES & LEGEL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_34adf60b-ecc8-4a53-b72e-3b4c4af4e517",
        "address": "Office No. 3607, 36th Level, Latifa Tower, Block B, Sheikh Zayed Road, 1st Trade Centre, Bur Dubai, P.O. Box. 3117, Dubai,",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 3607, 36th Level, Latifa Tower, Block B, Sheikh Zayed Road, 1st Trade Centre, Bur Dubai, P.O. Box. 3117, Dubai,"
  },
  {
    "id": "60c06980-a359-46f3-b819-fb4ff3362ac2",
    "slug": "mohamed-aleghfeli-advocates-legal-consultants",
    "name": "MOHAMED ALEGHFELI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MOHAMED ALEGHFELI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_60c06980-a359-46f3-b819-fb4ff3362ac2",
        "address": "Office No. M3, Mezzanine Floor, Al Khaimah Building, Al Etihad Road, Port Saeed, Deira, B.O Box: 83859, Dubai,",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. M3, Mezzanine Floor, Al Khaimah Building, Al Etihad Road, Port Saeed, Deira, B.O Box: 83859, Dubai,"
  },
  {
    "id": "2c561f92-229f-4d2c-8b26-595ae9b1e8b3",
    "slug": "mohammed-abdulla-albreike-legal-consultants",
    "name": "MOHAMMED ABDULLA ALBREIKE LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MOHAMMED ABDULLA ALBREIKE LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_2c561f92-229f-4d2c-8b26-595ae9b1e8b3",
        "address": "Office No. 602, Almasaood Building, Al Maktoum Road, Riqqat Al Buteen, P.O. Box. 220219, Dubai,",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 602, Almasaood Building, Al Maktoum Road, Riqqat Al Buteen, P.O. Box. 220219, Dubai,"
  },
  {
    "id": "3c7c0e3a-d07b-411a-81de-b067f092072c",
    "slug": "al-matrooshi-advocates-legal-consultancy",
    "name": "AL MATROOSHI ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL MATROOSHI ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_3c7c0e3a-d07b-411a-81de-b067f092072c",
        "address": "Office No. 401, Level 4, Al Harthy Building,Al Raffa, Al Mina Road, Bar Dubai, P.O. Box. 34143, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 401, Level 4, Al Harthy Building,Al Raffa, Al Mina Road, Bar Dubai, P.O. Box. 34143, Dubai"
  },
  {
    "id": "67351c0c-123f-4124-a523-fb63d2875dee",
    "slug": "hadeel-al-shaali-advocates-legal-consultants",
    "name": "HADEEL AL SHAALI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5IQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HADEEL AL SHAALI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_67351c0c-123f-4124-a523-fb63d2875dee",
        "address": "Office No. 65 B, Zumorrodah Building, Block B, Um Hurair Street, Al Karama, Bur Dubai, Makani No. 2679290478",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 65 B, Zumorrodah Building, Block B, Um Hurair Street, Al Karama, Bur Dubai, Makani No. 2679290478"
  },
  {
    "id": "50ddd0b6-20af-4c2d-a91f-cd978399c7d3",
    "slug": "mohamed-alhajeri-advocates-legal-consultants-notary-public",
    "name": "MOHAMED ALHAJERI ADVOCATES & LEGAL CONSULTANTS& NOTARY PUBLIC",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MOHAMED ALHAJERI ADVOCATES & LEGAL CONSULTANTS& NOTARY PUBLIC",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_50ddd0b6-20af-4c2d-a91f-cd978399c7d3",
        "address": "Office No. 203, 2nd Level, Al Reem Tower, Al Maktoum Road, Deira, P.O. Box 14593 Dubai, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 203, 2nd Level, Al Reem Tower, Al Maktoum Road, Deira, P.O. Box 14593 Dubai, United Arab Emirates"
  },
  {
    "id": "a2026af4-7556-4c41-8c4a-557779af3767",
    "slug": "hadeya-hamad-advocacy-legal-consultancy",
    "name": "HADEYA HAMAD ADVOCACY & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ISDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HADEYA HAMAD ADVOCACY & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_a2026af4-7556-4c41-8c4a-557779af3767",
        "address": "Office No. 203, 2nd Level, Bay Square 2 Tower, Sheikh Zayed Road, Business Bay, P.O. Box. 58820, Dubai, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 203, 2nd Level, Bay Square 2 Tower, Sheikh Zayed Road, Business Bay, P.O. Box. 58820, Dubai, United Arab Emirates"
  },
  {
    "id": "ab3adf8e-e655-4d22-83f3-bec13f0b9c0d",
    "slug": "nujood-bin-haider-advocates-leagl-consultants",
    "name": "NUJOOD BIN HAIDER ADVOCATES & LEAGL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5OQjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: NUJOOD BIN HAIDER ADVOCATES & LEAGL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_ab3adf8e-e655-4d22-83f3-bec13f0b9c0d",
        "address": "Office No. 204, 2rd Level, Mohammed Omar Bin Haider Group Building, Al Garhoud, Deira, P.O. Box. 3555, Dubai,",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 204, 2rd Level, Mohammed Omar Bin Haider Group Building, Al Garhoud, Deira, P.O. Box. 3555, Dubai,"
  },
  {
    "id": "d2b76219-b75f-4dec-93b1-eb4790371091",
    "slug": "roya-alawadhi-advocates-and-legal-consultants",
    "name": "ROYA ALAWADHI ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5SQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ROYA ALAWADHI ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_d2b76219-b75f-4dec-93b1-eb4790371091",
        "address": "Office No. 108B, 1st Level, Sarya Avenue Building, Al Garhoud, Deira, P.O. Box. 712, Dubai, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 108B, 1st Level, Sarya Avenue Building, Al Garhoud, Deira, P.O. Box. 712, Dubai, United Arab Emirates"
  },
  {
    "id": "9f1a8f57-5230-499e-9142-2f14b2adb79d",
    "slug": "abdulla-al-mansoori-advocates-legal-consultancy",
    "name": "ABDULLA AL MANSOORI ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDULLA AL MANSOORI ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_9f1a8f57-5230-499e-9142-2f14b2adb79d",
        "address": "Office No. 2607, 26th Level, Prism Tower, Bur Dubai, P.O. Box. 393164, Dubai, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 2607, 26th Level, Prism Tower, Bur Dubai, P.O. Box. 393164, Dubai, United Arab Emirates"
  },
  {
    "id": "5b518cf9-a965-40f0-8ed0-41a9751f2cd1",
    "slug": "abdulla-alsuwaidi-advocates-legal-consultants",
    "name": "ABDULLA ALSUWAIDI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDULLA ALSUWAIDI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_5b518cf9-a965-40f0-8ed0-41a9751f2cd1",
        "address": "Office No. (523 -- 522) Building R338 -- Block B, owned by Dubai Real Estate Corporation, Bur Dubai -- Um Hurair 2",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. (523 -- 522) Building R338 -- Block B, owned by Dubai Real Estate Corporation, Bur Dubai -- Um Hurair 2"
  },
  {
    "id": "73700399-de93-4919-bfae-e62ca7b6e260",
    "slug": "rashid-alkaitoob-advocates-legal-consultants",
    "name": "RASHID ALKAITOOB ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5SQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: RASHID ALKAITOOB ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_73700399-de93-4919-bfae-e62ca7b6e260",
        "address": "Office No. 501, 5th Level, Saeed Tower 2, Shaikh Zayed Road, Bur Dubai, P.O. Box. 6670, Dubai, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 501, 5th Level, Saeed Tower 2, Shaikh Zayed Road, Bur Dubai, P.O. Box. 6670, Dubai, United Arab Emirates"
  },
  {
    "id": "06058945-dee7-4296-89a9-8c1f0a1c9ea5",
    "slug": "abdelaziz-alzaabi-advocates-legal-consultancy",
    "name": "ABDELAZIZ ALZAABI ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDELAZIZ ALZAABI ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_06058945-dee7-4296-89a9-8c1f0a1c9ea5",
        "address": "Office No. M5, Mezzanine Level, Oud Metha Aera,Business Venue Building, Umm Harir Road, Bar Dubai, P.O. Box. 414121, Dubai,",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. M5, Mezzanine Level, Oud Metha Aera,Business Venue Building, Umm Harir Road, Bar Dubai, P.O. Box. 414121, Dubai,"
  },
  {
    "id": "e958f083-a5e9-441f-b75c-2ad047dea21f",
    "slug": "fahad-bin-tamim-advocates-legal-consultantcy",
    "name": "FAHAD BIN TAMIM ADVOCATES & LEGAL CONSULTANTCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5GQjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: FAHAD BIN TAMIM ADVOCATES & LEGAL CONSULTANTCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_e958f083-a5e9-441f-b75c-2ad047dea21f",
        "address": "Office No. 309, 310, 311, 3rd Level, Sheikh Zayed Road, Emarat Atrium Building, P.O. Box. 11996, Dubai, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 309, 310, 311, 3rd Level, Sheikh Zayed Road, Emarat Atrium Building, P.O. Box. 11996, Dubai, United Arab Emirates"
  },
  {
    "id": "97a89bc5-e7d4-4c6c-b188-35e2cc564b50",
    "slug": "ismail-al-safar-advocates-and-legal-consultants",
    "name": "ISMAIL AL SAFAR ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5JQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ISMAIL AL SAFAR ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_97a89bc5-e7d4-4c6c-b188-35e2cc564b50",
        "address": "Office No. (902-901), 9th Level, Falcon Tower, Sheikh Zayed Road, Bur Dubai, P.O. Box. 25752, Dubai, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. (902-901), 9th Level, Falcon Tower, Sheikh Zayed Road, Bur Dubai, P.O. Box. 25752, Dubai, United Arab Emirates"
  },
  {
    "id": "ae481e85-a56d-482d-b396-6cd482bc7c37",
    "slug": "aaesha-alteneaji-advocates-legal-consultants",
    "name": "AAESHA ALTENEAJI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AAESHA ALTENEAJI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_ae481e85-a56d-482d-b396-6cd482bc7c37",
        "address": "Office No. 704, 7th Level, Block B, Business Village Building, Port Saeed, Deira, P.O. Box. 183303, Dubai,",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 704, 7th Level, Block B, Business Village Building, Port Saeed, Deira, P.O. Box. 183303, Dubai,"
  },
  {
    "id": "1d7313a9-069c-4cbe-a244-68003bcf9fc6",
    "slug": "khadijah-sohail-advocates-legal-consultants",
    "name": "KHADIJAH SOHAIL ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5LUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: KHADIJAH SOHAIL ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_1d7313a9-069c-4cbe-a244-68003bcf9fc6",
        "address": "Office No. M04, Almezanen Level, Emgate Building, Business Bay Area, Bur Dubai, P.O. Box. 87676, Dubai,",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. M04, Almezanen Level, Emgate Building, Business Bay Area, Bur Dubai, P.O. Box. 87676, Dubai,"
  },
  {
    "id": "102debb6-6725-4114-948d-83ff2cb055d5",
    "slug": "yasin-alhamed-advocates-and-legal-consultants",
    "name": "YASIN ALHAMED ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ZQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: YASIN ALHAMED ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_102debb6-6725-4114-948d-83ff2cb055d5",
        "address": "Office No. 2506, 25 Level, ETA Star Almanara Tower, Al Abraj St., Bur Dubai, P.O. Box. 28292, Dubai, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 2506, 25 Level, ETA Star Almanara Tower, Al Abraj St., Bur Dubai, P.O. Box. 28292, Dubai, United Arab Emirates"
  },
  {
    "id": "2563142e-bc27-4b28-8f84-35b4d3ab7142",
    "slug": "khalid-abdulla-al-tamimi-advocates-legal-consultants",
    "name": "KHALID ABDULLA AL TAMIMI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5LQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: KHALID ABDULLA AL TAMIMI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_2563142e-bc27-4b28-8f84-35b4d3ab7142",
        "address": "Office No.4701, 47th Level, Burj Al Salam, Sheikh Zayed Road, Trade Centre First, P.O. Box. 66300, Dubai,",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No.4701, 47th Level, Burj Al Salam, Sheikh Zayed Road, Trade Centre First, P.O. Box. 66300, Dubai,"
  },
  {
    "id": "6291eba7-d5d9-458a-bfdc-5688d81dafd0",
    "slug": "adnan-obaid-alshaali-advocates-legal-consultancy",
    "name": "ADNAN OBAID ALSHAALI ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BTzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ADNAN OBAID ALSHAALI ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_6291eba7-d5d9-458a-bfdc-5688d81dafd0",
        "address": "Office No. 201 A, Level 2, Al Khaimah Building, Al Etihad Road, Deira, Makani No. 3235694882",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 201 A, Level 2, Al Khaimah Building, Al Etihad Road, Deira, Makani No. 3235694882"
  },
  {
    "id": "856ee1f9-bdd8-406a-95e5-c83f459228a6",
    "slug": "noura-almaazmi-advocates-legal-consultants",
    "name": "NOURA ALMAAZMI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5OQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: NOURA ALMAAZMI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_856ee1f9-bdd8-406a-95e5-c83f459228a6",
        "address": "Office No. 1702, Oberoi Hotel Al A'amal Street,Business Bay , P.O. Box. 414224, Dubai, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 1702, Oberoi Hotel Al A'amal Street,Business Bay , P.O. Box. 414224, Dubai, United Arab Emirates"
  },
  {
    "id": "b02ebbfe-0fe0-4d06-999e-492e557ab443",
    "slug": "yousif-al-hammadi-advocates-legal-consultancy",
    "name": "YOUSIF AL HAMMADI ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ZQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: YOUSIF AL HAMMADI ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_b02ebbfe-0fe0-4d06-999e-492e557ab443",
        "address": "Office No. (513 &514), Level 5, Business Avenue, Al Etihad Street, Port Saeed, Deira, P.O. Box. 414145, Dubai,",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. (513 &514), Level 5, Business Avenue, Al Etihad Street, Port Saeed, Deira, P.O. Box. 414145, Dubai,"
  },
  {
    "id": "d6405445-5c7d-4e9f-ac15-d9d7874f9efb",
    "slug": "abdulla-al-kaabi-advocates-legal-consultancy",
    "name": "ABDULLA AL KAABI ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDULLA AL KAABI ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_d6405445-5c7d-4e9f-ac15-d9d7874f9efb",
        "address": "Office No. (501& 505), 5th Level, Alsafa Tower, First Commercial Center Area, Bur Dubai, P.O. Box. 113713, Dubai, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. (501& 505), 5th Level, Alsafa Tower, First Commercial Center Area, Bur Dubai, P.O. Box. 113713, Dubai, United Arab Emirates"
  },
  {
    "id": "3c5a656d-a69b-4935-a497-a4361c83f787",
    "slug": "ahmed-anwahi-advocates-legal-consultancy",
    "name": "AHMED ANWAHI ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AHMED ANWAHI ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_3c5a656d-a69b-4935-a497-a4361c83f787",
        "address": "Office No. 2005-2006 , Second floor, Mazaya Center, Block C Sheikh Zayed Street, Al Wasl",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 2005-2006 , Second floor, Mazaya Center, Block C Sheikh Zayed Street, Al Wasl"
  },
  {
    "id": "87043eb1-bfc8-4253-9851-be0f6a95f2a6",
    "slug": "fatma-al-mutawa-advocates-legal-consultants",
    "name": "FATMA AL MUTAWA ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5GQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: FATMA AL MUTAWA ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_87043eb1-bfc8-4253-9851-be0f6a95f2a6",
        "address": "Office No. 2019, Level 12, Clover Bay Tower, Towers Street, Business Bay, Bur Dubai, P.O. Box. 28629, Dubai,",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 2019, Level 12, Clover Bay Tower, Towers Street, Business Bay, Bur Dubai, P.O. Box. 28629, Dubai,"
  },
  {
    "id": "75b559b1-ec21-425e-abee-6135a47b8df9",
    "slug": "muna-al-sabbagh-advocates-legal-consultancy",
    "name": "MUNA AL SABBAGH ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MUNA AL SABBAGH ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_75b559b1-ec21-425e-abee-6135a47b8df9",
        "address": "Office No. B53, 5th Level, Zumorrodah Building, Um Hurair St., Al Karama, Bur Dubai, Makani No. 2949829875",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. B53, 5th Level, Zumorrodah Building, Um Hurair St., Al Karama, Bur Dubai, Makani No. 2949829875"
  },
  {
    "id": "5e7f455c-4998-424f-9dc4-7eb3c4af1117",
    "slug": "ali-khalaf-al-hosani-advocates-legal-consultants",
    "name": "ALI KHALAF AL HOSANI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BSzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALI KHALAF AL HOSANI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_5e7f455c-4998-424f-9dc4-7eb3c4af1117",
        "address": "Office No. 1007, Level 10, Al Manara Tower, Business Bay,Bur Dubai, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 1007, Level 10, Al Manara Tower, Business Bay,Bur Dubai, United Arab Emirates"
  },
  {
    "id": "1d6c98ed-a379-47c1-ada0-34c09cae6eb5",
    "slug": "ali-musabbah-advocates-legel-consultants",
    "name": "ALI MUSABBAH ADVOCATES & LEGEL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALI MUSABBAH ADVOCATES & LEGEL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_1d6c98ed-a379-47c1-ada0-34c09cae6eb5",
        "address": "Office No. (1704), Level 17, Al Reem Tower, Al Maktoum Road, Deira, P.O. Box. 20052, Dubai,",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. (1704), Level 17, Al Reem Tower, Al Maktoum Road, Deira, P.O. Box. 20052, Dubai,"
  },
  {
    "id": "66618d80-5147-4a29-bf3e-67c25d3f8ffb",
    "slug": "amna-almuhsen-advocates-legal-consultancy",
    "name": "AMNA ALMUHSEN ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AMNA ALMUHSEN ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_66618d80-5147-4a29-bf3e-67c25d3f8ffb",
        "address": "Office No. 110, Level 1, Al Dana Building, Al Maktoum Road, Al Murqabat Area,Deira, P.O. Box. 171300, Dubai, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 110, Level 1, Al Dana Building, Al Maktoum Road, Al Murqabat Area,Deira, P.O. Box. 171300, Dubai, United Arab Emirates"
  },
  {
    "id": "deaa7efd-f942-429e-9a22-306282a1b559",
    "slug": "juma-al-naqbi-advocates-legal-consultants",
    "name": "JUMA AL NAQBI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5KQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: JUMA AL NAQBI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_deaa7efd-f942-429e-9a22-306282a1b559",
        "address": "Office No. 1105, Sheikh Zayed Road, Business Bay, Iris Bay Building United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 1105, Sheikh Zayed Road, Business Bay, Iris Bay Building United Arab Emirates"
  },
  {
    "id": "7bab39f3-5064-4719-a628-f7283fc7dae0",
    "slug": "waleed-almarzooqi-and-khalid-mohamed-advocates-legal-consultancy",
    "name": "WALEED ALMARZOOQI AND KHALID MOHAMED ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5XQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: WALEED ALMARZOOQI AND KHALID MOHAMED ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_7bab39f3-5064-4719-a628-f7283fc7dae0",
        "address": "Office No. (3304), Level 33, Al Manara Tower, Business Bay, Bur Dubai, P.O. Box. 24002, Dubai,",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. (3304), Level 33, Al Manara Tower, Business Bay, Bur Dubai, P.O. Box. 24002, Dubai,"
  },
  {
    "id": "50cbcaeb-7718-42ab-a384-5fbe9bff2884",
    "slug": "fatmah-al-ali-advocates-and-legal-consultants",
    "name": "FATMAH AL ALI ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5GQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: FATMAH AL ALI ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_50cbcaeb-7718-42ab-a384-5fbe9bff2884",
        "address": "Office No. 702, Level 7, Prism Tower, Alsaada street, Business Bay, P.O. Box. 34357, Dubai,",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 702, Level 7, Prism Tower, Alsaada street, Business Bay, P.O. Box. 34357, Dubai,"
  },
  {
    "id": "f389656a-1ef8-401e-ad57-7688d4f581f3",
    "slug": "mohammed-al-marzooqi-advocates-legal-consultants",
    "name": "MOHAMMED AL MARZOOQI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MOHAMMED AL MARZOOQI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_f389656a-1ef8-401e-ad57-7688d4f581f3",
        "address": "Office No. 405, 4th Level, Business Point Building, Port Saeed, Deira, P.O. Box. 109905, Dubai,",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 405, 4th Level, Business Point Building, Port Saeed, Deira, P.O. Box. 109905, Dubai,"
  },
  {
    "id": "9c073161-f298-4a04-8874-4c3822512bb3",
    "slug": "obaid-al-mazimi-advocates-legal-consultancy",
    "name": "OBAID AL MAZIMI ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5PQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: OBAID AL MAZIMI ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_9c073161-f298-4a04-8874-4c3822512bb3",
        "address": "Office No. 2106, Level 21, The Exchange Tower, Al Mostaqbal Street, Business Bay, Bur Dubai, Makani No. 2468586742",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 2106, Level 21, The Exchange Tower, Al Mostaqbal Street, Business Bay, Bur Dubai, Makani No. 2468586742"
  },
  {
    "id": "4ee3a2ed-bb1f-4611-b14c-235107b2fe78",
    "slug": "abdulhameed-aljasmi-advocates-legal-consultants",
    "name": "ABDULHAMEED ALJASMI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDULHAMEED ALJASMI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_4ee3a2ed-bb1f-4611-b14c-235107b2fe78",
        "address": "Office No. 2202, 22nd Level, Single Business Tower, Sheikh Zayed Road, Business Bay, Bur Dubai, P.O. Box. 79441, Dubai, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 2202, 22nd Level, Single Business Tower, Sheikh Zayed Road, Business Bay, Bur Dubai, P.O. Box. 79441, Dubai, United Arab Emirates"
  },
  {
    "id": "3cd55004-fff5-401e-a5fe-aada4f1d70fd",
    "slug": "alomar-alsabah-advocates",
    "name": "ALOMAR & ALSABAH ADVOCATES",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALOMAR & ALSABAH ADVOCATES",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_3cd55004-fff5-401e-a5fe-aada4f1d70fd",
        "address": "Office No. (809-1208-1207-1507-1508), Level 12, Business Bay, Prime Tower, P.O. Box 211940, Dubai, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. (809-1208-1207-1507-1508), Level 12, Business Bay, Prime Tower, P.O. Box 211940, Dubai, United Arab Emirates"
  },
  {
    "id": "553c9261-0a05-45a9-9a59-5437e98b264c",
    "slug": "hamdan-alkaabi-advocates-legal-consultans",
    "name": "HAMDAN ALKAABI ADVOCATES & LEGAL CONSULTANS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5IQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HAMDAN ALKAABI ADVOCATES & LEGAL CONSULTANS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_553c9261-0a05-45a9-9a59-5437e98b264c",
        "address": "Office No. 1304, Floor 13, Sheikh Zayed Road, Trade Center First, AlMoosa Tower 1, P.O. Box. 25635, Dubai,",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 1304, Floor 13, Sheikh Zayed Road, Trade Center First, AlMoosa Tower 1, P.O. Box. 25635, Dubai,"
  },
  {
    "id": "fcba3bef-29fa-4cb9-abba-c3d3c2352936",
    "slug": "dr-sarhan-almuaini-advocate-and-legal-consultant",
    "name": "DR SARHAN ALMUAINI ADVOCATE AND LEGAL CONSULTANT",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5EUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: DR SARHAN ALMUAINI ADVOCATE AND LEGAL CONSULTANT",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_fcba3bef-29fa-4cb9-abba-c3d3c2352936",
        "address": "Office No. (1002 ), Level 10, Oberoi, Bur Dubai, Business Bay P.O. Box. 37150, Dubai,",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. (1002 ), Level 10, Oberoi, Bur Dubai, Business Bay P.O. Box. 37150, Dubai,"
  },
  {
    "id": "462c33ca-372d-4ce7-bc7e-ff5b3a4523a0",
    "slug": "habib-al-hosany-advocates-legal-consultants",
    "name": "HABIB AL HOSANY ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5IQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HABIB AL HOSANY ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_462c33ca-372d-4ce7-bc7e-ff5b3a4523a0",
        "address": "Office No. 304, Level 3, Sama Tower, Sheikh Zayed Road, Trade Centre First, P.O. Box. 116623, Dubai,",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 304, Level 3, Sama Tower, Sheikh Zayed Road, Trade Centre First, P.O. Box. 116623, Dubai,"
  },
  {
    "id": "d2455ff9-f534-4ae0-b02c-ccfa992caded",
    "slug": "obaid-alshamsi-advocates-legal-consultants",
    "name": "OBAID ALSHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5PQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: OBAID ALSHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_d2455ff9-f534-4ae0-b02c-ccfa992caded",
        "address": "Al Garhoud - Al Garhoud Business Center Building - Office No. M22 United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Al Garhoud - Al Garhoud Business Center Building - Office No. M22 United Arab Emirates"
  },
  {
    "id": "6f847069-2429-40a6-b8d4-b690cbecd944",
    "slug": "suliman-al-naqbi-advocates-legal-consultants",
    "name": "SULIMAN AL NAQBI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SULIMAN AL NAQBI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_6f847069-2429-40a6-b8d4-b690cbecd944",
        "address": "Office No. 505 -- CNPC Building - Emaar Business Center -- Green Garden-- Third Al Thanyah United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 505 -- CNPC Building - Emaar Business Center -- Green Garden-- Third Al Thanyah United Arab Emirates"
  },
  {
    "id": "f6cb46b2-d4a2-4c13-add9-3407669d6004",
    "slug": "adel-fakhir-advocates-legal-consultants",
    "name": "ADEL FAKHIR ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BRjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ADEL FAKHIR ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_f6cb46b2-d4a2-4c13-add9-3407669d6004",
        "address": "Office No. 502 Owned by Maitha Ali Abdalla Al Owais Port Saeed, Deira P.O. Box. 231211, Dubai, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 502 Owned by Maitha Ali Abdalla Al Owais Port Saeed, Deira P.O. Box. 231211, Dubai, United Arab Emirates"
  },
  {
    "id": "7a66dffa-6830-40e8-a7ee-9c089184afe7",
    "slug": "awad-alaryani-advocates-legal-consultants",
    "name": "AWAD ALARYANI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AWAD ALARYANI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_7a66dffa-6830-40e8-a7ee-9c089184afe7",
        "address": "Office No.113, 1st Level, Office Court Building, Oud Metha, Bur Dubai, P.O. Box.238801, Dubai, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No.113, 1st Level, Office Court Building, Oud Metha, Bur Dubai, P.O. Box.238801, Dubai, United Arab Emirates"
  },
  {
    "id": "55bc8305-ce04-4a26-82e7-9a2d8656383c",
    "slug": "dr-ahmed-alramsy-lawyers-consultants",
    "name": "DR.AHMED ALRAMSY LAWYERS & CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5EQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: DR.AHMED ALRAMSY LAWYERS & CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_55bc8305-ce04-4a26-82e7-9a2d8656383c",
        "address": "Office No. 1305, 13 Level, Fairmont Hotel, Sheikh Zayed Road, P.O. Box. 77857, Dubai, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 1305, 13 Level, Fairmont Hotel, Sheikh Zayed Road, P.O. Box. 77857, Dubai, United Arab Emirates"
  },
  {
    "id": "98c29b23-0cb7-4902-a462-c55a9a659836",
    "slug": "fahad-abdalla-advocates-legal-consultants",
    "name": "FAHAD ABDALLA ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5GQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: FAHAD ABDALLA ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_98c29b23-0cb7-4902-a462-c55a9a659836",
        "address": "Level 3 -Office No. 306 Street No. 57 - Orkida Building Deira - Al Garhoud",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Level 3 -Office No. 306 Street No. 57 - Orkida Building Deira - Al Garhoud"
  },
  {
    "id": "ca12ff49-1cab-49ec-b6cb-05074a7304c6",
    "slug": "khalifa-bin-omair-advocates-legal-consultants",
    "name": "KHALIFA BIN OMAIR ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5LQjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: KHALIFA BIN OMAIR ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_ca12ff49-1cab-49ec-b6cb-05074a7304c6",
        "address": "Office No. 1203, Level 12, The Exchange Tower, Al Saada Road, Business Bay Area, P.O. Box 212109, Dubai,",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 1203, Level 12, The Exchange Tower, Al Saada Road, Business Bay Area, P.O. Box 212109, Dubai,"
  },
  {
    "id": "83a2e6ba-296e-4f82-bee8-1598d3e02349",
    "slug": "salem-bin-bahyan-advocates-legal-consultants",
    "name": "SALEM BIN BAHYAN ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TQjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SALEM BIN BAHYAN ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_83a2e6ba-296e-4f82-bee8-1598d3e02349",
        "address": "Office No.1103, Level 11, Latifa Tower , Shikh Zayed Street, The first commercial center, Bur Dubai, P.O. Box. 20611, Dubai,",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No.1103, Level 11, Latifa Tower , Shikh Zayed Street, The first commercial center, Bur Dubai, P.O. Box. 20611, Dubai,"
  },
  {
    "id": "cad7b367-583f-429d-b0d5-b20b84a48543",
    "slug": "al-balooshi-and-al-marashda-advocates-legal-consultants",
    "name": "AL BALOOSHI AND AL MARASHDA ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AL BALOOSHI AND AL MARASHDA ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_cad7b367-583f-429d-b0d5-b20b84a48543",
        "address": "Office No. 306,305,304, 3rd. Level, Block C, Al Hudaiba Award Complex, 2nd of December Street, Jumeira, P.O. Box.19676, Dubai,",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 306,305,304, 3rd. Level, Block C, Al Hudaiba Award Complex, 2nd of December Street, Jumeira, P.O. Box.19676, Dubai,"
  },
  {
    "id": "d8c790ed-709a-40df-90d8-784bcc0caa76",
    "slug": "heba-ahli-advocates-legal-consultants",
    "name": "HEBA AHLI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5IQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HEBA AHLI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_d8c790ed-709a-40df-90d8-784bcc0caa76",
        "address": "Office No. 604, Level 6, Prime Business Center, Al Barsha South 4, Bur Dubai, Makani No. 2583686879, P.O. Box. 414142, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 604, Level 6, Prime Business Center, Al Barsha South 4, Bur Dubai, Makani No. 2583686879, P.O. Box. 414142, Dubai"
  },
  {
    "id": "3b8472d2-c973-422f-9e3b-6940b7b28e30",
    "slug": "rashid-alnaqbi-vocates-legal-consultants",
    "name": "RASHID ALNAQBI VOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5SQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: RASHID ALNAQBI VOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_3b8472d2-c973-422f-9e3b-6940b7b28e30",
        "address": "Office No. 1002, Al Abraj Street, Clover Bay Tower, Makani No. 2471287454, P.O. Box. 117277, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 1002, Al Abraj Street, Clover Bay Tower, Makani No. 2471287454, P.O. Box. 117277, Dubai"
  },
  {
    "id": "57a0b579-ef42-4463-8a8c-0dad9118b4bf",
    "slug": "salem-kubaisi-advocates-legal-consultants",
    "name": "SALEM KUBAISI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TSzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SALEM KUBAISI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_57a0b579-ef42-4463-8a8c-0dad9118b4bf",
        "address": "Office No. 114, Level1, City Bay Business Centre Building, Hor Al Ans Area,Deira, Dubai, P.O. Box 93075, Dubai,",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 114, Level1, City Bay Business Centre Building, Hor Al Ans Area,Deira, Dubai, P.O. Box 93075, Dubai,"
  },
  {
    "id": "df3d8492-e096-4ee7-9bd4-ccf582182d3d",
    "slug": "hessah-alshehhi-advocates-legal-consultants",
    "name": "HESSAH ALSHEHHI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5IQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HESSAH ALSHEHHI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_df3d8492-e096-4ee7-9bd4-ccf582182d3d",
        "address": "Office No. 1403, 14th Floor, Park Place, Sheikh Zayed Road, Trade Center First, Bur Dubai, Makani No. 2706990907",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 1403, 14th Floor, Park Place, Sheikh Zayed Road, Trade Center First, Bur Dubai, Makani No. 2706990907"
  },
  {
    "id": "2d0a769a-ddfe-45d5-a02f-d04a9f7407bf",
    "slug": "suhad-aljuboori-advocates-legal-consultancy",
    "name": "SUHAD ALJUBOORI ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SUHAD ALJUBOORI ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_2d0a769a-ddfe-45d5-a02f-d04a9f7407bf",
        "address": "Office No. 1602, Level 16, The H Hotel, SHK Zayed Street, Trade Center 1st, Bur Dubai, Makani No. 2746691529",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 1602, Level 16, The H Hotel, SHK Zayed Street, Trade Center 1st, Bur Dubai, Makani No. 2746691529"
  },
  {
    "id": "50418fe9-ad6e-4364-a562-b943085c1615",
    "slug": "afaf-morjan-advocates-legal-consultants",
    "name": "AFAF MORJAN ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AFAF MORJAN ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_50418fe9-ad6e-4364-a562-b943085c1615",
        "address": "Office No.A303, Level 3, Gulf Towers, Um Hurair Second, Bur Dubai, P.O. Box. 35192, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No.A303, Level 3, Gulf Towers, Um Hurair Second, Bur Dubai, P.O. Box. 35192, Dubai"
  },
  {
    "id": "abb70755-1d63-4f2a-a0c5-2d456924a732",
    "slug": "jasim-almaeeni-law-advocates-legal-consultants",
    "name": "JASIM ALMAEENI LAW ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5KQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: JASIM ALMAEENI LAW ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_abb70755-1d63-4f2a-a0c5-2d456924a732",
        "address": "Office No. 702, 7th Level, Sama Tower, Shiekh Zayed Street, Trade Center First , Bur dubai , P.O. Box. 120059, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 702, 7th Level, Sama Tower, Shiekh Zayed Street, Trade Center First , Bur dubai , P.O. Box. 120059, Dubai"
  },
  {
    "id": "32d0863a-39b3-4cf2-8cfb-4f6ccb94a3ad",
    "slug": "mariam-ahmed-salem-advocates-legal-consultants",
    "name": "MARIAM AHMED SALEM ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MARIAM AHMED SALEM ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_32d0863a-39b3-4cf2-8cfb-4f6ccb94a3ad",
        "address": "Deira -- Union Building -- Opposite Deira City Centre, Second Floor -- Office 205",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Deira -- Union Building -- Opposite Deira City Centre, Second Floor -- Office 205"
  },
  {
    "id": "e3a958d5-5ea6-4b54-876f-4b18adbb0e59",
    "slug": "khalid-alsuwadi-advocates-legal-consultants",
    "name": "KHALID ALSUWADI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5LQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: KHALID ALSUWADI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_e3a958d5-5ea6-4b54-876f-4b18adbb0e59",
        "address": "Office No. 513, Level 5, Parklane Tower, Business Bay Area, Bar Dubai, P.O. Box 122533, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 513, Level 5, Parklane Tower, Business Bay Area, Bar Dubai, P.O. Box 122533, Dubai"
  },
  {
    "id": "8a36f25f-5f9d-4fee-8813-61defca2667a",
    "slug": "maha-alfahim-advocates-legal-consultants",
    "name": "MAHA ALFAHIM ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MAHA ALFAHIM ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_8a36f25f-5f9d-4fee-8813-61defca2667a",
        "address": "Office No GL-4, Level G, Wafi Residence Building, Um Hurair Road, Bur Dubai, P.O. Box. 60999, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No GL-4, Level G, Wafi Residence Building, Um Hurair Road, Bur Dubai, P.O. Box. 60999, Dubai"
  },
  {
    "id": "cfd46846-53d4-46fe-91b8-fc953f1daed9",
    "slug": "mohammed-ali-alhammadi-advocates-legal-consultancy",
    "name": "MOHAMMED ALI ALHAMMADI ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MOHAMMED ALI ALHAMMADI ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_cfd46846-53d4-46fe-91b8-fc953f1daed9",
        "address": "Office No. 1303, Level 13, The H Hotel Complex Building, Trade Center First Area, Bar Dubai, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 1303, Level 13, The H Hotel Complex Building, Trade Center First Area, Bar Dubai, Dubai"
  },
  {
    "id": "2eb8e901-b33c-43e6-a1c4-ed8980326f3c",
    "slug": "ahmed-almazrouei-advocates-legal-consultancy",
    "name": "AHMED ALMAZROUEI ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AHMED ALMAZROUEI ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_2eb8e901-b33c-43e6-a1c4-ed8980326f3c",
        "address": "Office No. 1003, Rega Al Buteen, Alreem Tower, Al Maktoum road, Deira, Makani No.3035795150",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 1003, Rega Al Buteen, Alreem Tower, Al Maktoum road, Deira, Makani No.3035795150"
  },
  {
    "id": "6282e469-4312-4387-ac3f-d3a06c22710e",
    "slug": "fatima-abdelaziz-advocates-legal-consultants",
    "name": "FATIMA ABDELAZIZ ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5GQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: FATIMA ABDELAZIZ ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_6282e469-4312-4387-ac3f-d3a06c22710e",
        "address": "The First Commercial Center - Building: Crowne Plaza - Office Tower -- 22nd Floor - Office 2205",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "The First Commercial Center - Building: Crowne Plaza - Office Tower -- 22nd Floor - Office 2205"
  },
  {
    "id": "3c0d74b2-e08b-4fef-adb6-ceb2b6ed398a",
    "slug": "marwa-al-suwaidi-advocates-legal-consultants",
    "name": "MARWA Al SUWAIDI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MARWA Al SUWAIDI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_3c0d74b2-e08b-4fef-adb6-ceb2b6ed398a",
        "address": "Office No. 914, Level 9, Business Avenue, Al Etihad Street, Port Saeed, Deira, P.O. Box 77728, Dubai, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 914, Level 9, Business Avenue, Al Etihad Street, Port Saeed, Deira, P.O. Box 77728, Dubai, United Arab Emirates"
  },
  {
    "id": "634eeb35-85e6-498a-8430-f2a67b5b3f30",
    "slug": "saeed-bin-ghulata-advocates-legal-consultants",
    "name": "SAEED BIN GHULATA ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TQjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SAEED BIN GHULATA ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_634eeb35-85e6-498a-8430-f2a67b5b3f30",
        "address": "Office No2501, 25. Level, Business Bay Area, Aspect Tower Building, Alsaeada Street, Bar Dubai, P.O. Box.398, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No2501, 25. Level, Business Bay Area, Aspect Tower Building, Alsaeada Street, Bar Dubai, P.O. Box.398, Dubai"
  },
  {
    "id": "a96f080b-d4c9-4307-a6d7-bb2526e86185",
    "slug": "hussain-mohamed-alhosani-advocates-legal-consultancy",
    "name": "HUSSAIN MOHAMED ALHOSANI ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ITTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HUSSAIN MOHAMED ALHOSANI ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_a96f080b-d4c9-4307-a6d7-bb2526e86185",
        "address": "Office No. 314, Level 3, Business Avenue, Al Maktoum St., Port Saeed, Deira, Makani No. 3248594620",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 314, Level 3, Business Avenue, Al Maktoum St., Port Saeed, Deira, Makani No. 3248594620"
  },
  {
    "id": "d2c1f052-7210-45e6-8c6b-b8eb5be1ba2a",
    "slug": "nadia-mohammed-law-firm-legal-consultancy",
    "name": "NADIA MOHAMMED LAW FIRM LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5OTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: NADIA MOHAMMED LAW FIRM LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_d2c1f052-7210-45e6-8c6b-b8eb5be1ba2a",
        "address": "Office No. 128, Level 1, Alferdous 4 Building, Alsaffa First Area, Bar Dubai, P.O. Box. 12018, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 128, Level 1, Alferdous 4 Building, Alsaffa First Area, Bar Dubai, P.O. Box. 12018, Dubai"
  },
  {
    "id": "f6c6ea50-dc18-48c5-9277-3f2dccc1ba88",
    "slug": "hassan-ashoor-almulla-advocates-legal-consultants",
    "name": "HASSAN ASHOOR ALMULLA ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5IQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HASSAN ASHOOR ALMULLA ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_f6c6ea50-dc18-48c5-9277-3f2dccc1ba88",
        "address": "Level 11, Office No. 1104, Union Street - Behind Deira City Centre - Al Wassl Business Central Building, Port Saeed Area, Deira, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Level 11, Office No. 1104, Union Street - Behind Deira City Centre - Al Wassl Business Central Building, Port Saeed Area, Deira, United Arab Emirates"
  },
  {
    "id": "62d60031-1927-4edb-804b-498ef676e563",
    "slug": "mohammed-abdulla-yousuf-alhammadi-advocate-legal-consultants",
    "name": "MOHAMMED ABDULLA & YOUSUF ALHAMMADI ADVOCATE LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MOHAMMED ABDULLA & YOUSUF ALHAMMADI ADVOCATE LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_62d60031-1927-4edb-804b-498ef676e563",
        "address": "Office No1502, 5. Level, Trade Center First, Latifa Tower, Sheikh Zayed Road, Bar Dubai, P.O. Box.410114, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No1502, 5. Level, Trade Center First, Latifa Tower, Sheikh Zayed Road, Bar Dubai, P.O. Box.410114, Dubai"
  },
  {
    "id": "98923440-58f5-4c6c-be54-bf12d862bded",
    "slug": "abdulhamid-yousuf-albalooshi-advocate-legal-consultants",
    "name": "ABDULHAMID YOUSUF ALBALOOSHI ADVOCATE & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BWTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDULHAMID YOUSUF ALBALOOSHI ADVOCATE & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_98923440-58f5-4c6c-be54-bf12d862bded",
        "address": "Office No. 1401-1402-1404, Sheikh Zayed Road, Aspin Commercial Tower, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 1401-1402-1404, Sheikh Zayed Road, Aspin Commercial Tower, United Arab Emirates"
  },
  {
    "id": "975172b3-b0a1-41ad-8521-a356bbf45804",
    "slug": "abdulrahman-alaamri-advocates-legal-consultants",
    "name": "ABDULRAHMAN ALAAMRI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDULRAHMAN ALAAMRI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_975172b3-b0a1-41ad-8521-a356bbf45804",
        "address": "Office No. 305,306, Level 3,ACICO Business Park Builiding , Port Saeed, Deira, P.O. Box 33731, Dubai, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 305,306, Level 3,ACICO Business Park Builiding , Port Saeed, Deira, P.O. Box 33731, Dubai, United Arab Emirates"
  },
  {
    "id": "6086da82-dd97-4a5f-ae4f-06f74e1d3318",
    "slug": "mohammad-alnajjar-advocates-legal-consultants",
    "name": "MOHAMMAD ALNAJJAR ADVOCATES LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MOHAMMAD ALNAJJAR ADVOCATES LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_6086da82-dd97-4a5f-ae4f-06f74e1d3318",
        "address": "Office No. (1402-1403), Level 14, The Prime Tower, Business Bay Area, Bar Dubai, Marasi Drive Streer",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. (1402-1403), Level 14, The Prime Tower, Business Bay Area, Bar Dubai, Marasi Drive Streer"
  },
  {
    "id": "48e06bbc-f880-488e-a472-fa6ba4970261",
    "slug": "raya-alameri-advocates-legal-consultants",
    "name": "RAYA ALAMERI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5SQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: RAYA ALAMERI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_48e06bbc-f880-488e-a472-fa6ba4970261",
        "address": "Office No. 2006, Level 20, Opal Tower, Business Bay Area,Bur Dubai, P.O. Box 90678, Dubai, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 2006, Level 20, Opal Tower, Business Bay Area,Bur Dubai, P.O. Box 90678, Dubai, United Arab Emirates"
  },
  {
    "id": "88c57886-d73c-4f6c-9e2b-a5202fba8f25",
    "slug": "bader-hamad-al-zaabi-advocates-and-legal-consultants",
    "name": "Bader Hamad Al Zaabi Advocates and Legal consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5CSDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Bader Hamad Al Zaabi Advocates and Legal consultants",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_88c57886-d73c-4f6c-9e2b-a5202fba8f25",
        "address": "Office No. 3403, Level 34, Burj Al Salam, Trade Centre One, Sheikh Zayed Road, P.O. Box. 89498, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 3403, Level 34, Burj Al Salam, Trade Centre One, Sheikh Zayed Road, P.O. Box. 89498, Dubai"
  },
  {
    "id": "54a8aab9-5c95-43f3-95fc-ab4ce7238aea",
    "slug": "sara-al-saedi-advocates-legal-consultants",
    "name": "SARA AL SAEDI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SARA AL SAEDI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_54a8aab9-5c95-43f3-95fc-ab4ce7238aea",
        "address": "Office No. 304, Level 3, ACICO Business Park Builiding, Port Saeed, Deira, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 304, Level 3, ACICO Business Park Builiding, Port Saeed, Deira, United Arab Emirates"
  },
  {
    "id": "7dc72ff1-1a4d-4fa6-bfa2-370fb6e5e811",
    "slug": "saud-al-shebli-advocates-legal-consultants",
    "name": "SAUD AL SHEBLI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SAUD AL SHEBLI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_7dc72ff1-1a4d-4fa6-bfa2-370fb6e5e811",
        "address": "Office 107, 108, Al Garhoud Business Center - First Floor, Deira -- Al Garhoud, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office 107, 108, Al Garhoud Business Center - First Floor, Deira -- Al Garhoud, United Arab Emirates"
  },
  {
    "id": "1c595113-d6f1-4fd4-92fc-fb034e77d6dd",
    "slug": "mohamed-alazazi-advocates-legal-consultants",
    "name": "MOHAMED ALAZAZI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MOHAMED ALAZAZI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_1c595113-d6f1-4fd4-92fc-fb034e77d6dd",
        "address": "Office No. 3702, 37th Level, Concord Tower, Dubai Internet City, Al Safouh Second, Makani No.: 1406477044, P.O. Box. 35014, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 3702, 37th Level, Concord Tower, Dubai Internet City, Al Safouh Second, Makani No.: 1406477044, P.O. Box. 35014, Dubai"
  },
  {
    "id": "f524d324-bb76-43cb-8f98-d100050af523",
    "slug": "noura-alamiri-advocates-and-legal-consultants",
    "name": "NOURA ALAMIRI ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5OQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: NOURA ALAMIRI ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_f524d324-bb76-43cb-8f98-d100050af523",
        "address": "Office No.301-302, Level 3, Building SMJ 1, Al Saffa First, Sheikh Zayed Road",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No.301-302, Level 3, Building SMJ 1, Al Saffa First, Sheikh Zayed Road"
  },
  {
    "id": "fc9d3212-4fc8-4ed0-96cb-973811dfb6e6",
    "slug": "ali-al-nuaimi-advocates-and-legal-consultants",
    "name": "ALI AL NUAIMI ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALI AL NUAIMI ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_fc9d3212-4fc8-4ed0-96cb-973811dfb6e6",
        "address": "Office No. 1805, 18th Level, Latifa Towers, Sheikh Zayed Road, Trade Center First, P.O. Box. 98588, Dubai, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 1805, 18th Level, Latifa Towers, Sheikh Zayed Road, Trade Center First, P.O. Box. 98588, Dubai, United Arab Emirates"
  },
  {
    "id": "9334d1e1-fc31-4411-ba52-aac76b141f83",
    "slug": "fatima-mohammed-advocates-legal-counsultants",
    "name": "FATIMA MOHAMMED ADVOCATES & LEGAL COUNSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5GTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: FATIMA MOHAMMED ADVOCATES & LEGAL COUNSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_9334d1e1-fc31-4411-ba52-aac76b141f83",
        "address": "Oud Metha - Bur Dubai, Building: Sultan Business Center, Second Floor-Office 215",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Oud Metha - Bur Dubai, Building: Sultan Business Center, Second Floor-Office 215"
  },
  {
    "id": "eee09c56-41f1-4249-92bb-5155e5a972e0",
    "slug": "salwa-omar-advocates-legal-consultants",
    "name": "SALWA OMAR ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TTzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SALWA OMAR ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_eee09c56-41f1-4249-92bb-5155e5a972e0",
        "address": "Office No. 308, Level 3, Clover Bay Tower, Marasi Drive Street, Business Bay, Bur Dubai, P.O. Box. 251443, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 308, Level 3, Clover Bay Tower, Marasi Drive Street, Business Bay, Bur Dubai, P.O. Box. 251443, Dubai"
  },
  {
    "id": "0138ade5-942c-4586-a68b-9b1c0fd32a76",
    "slug": "mohammed-allinjawi-advocates-legal-consultants",
    "name": "MOHAMMED ALLINJAWI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MOHAMMED ALLINJAWI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_0138ade5-942c-4586-a68b-9b1c0fd32a76",
        "address": "Office No. 2102, Fairmont Dubai Building, Sheikh Zayed Road, Business Bay, Bur Dubai, Makani No. 2719591105",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 2102, Fairmont Dubai Building, Sheikh Zayed Road, Business Bay, Bur Dubai, Makani No. 2719591105"
  },
  {
    "id": "51b52acb-6c31-4389-bf8c-9c3dc0b05299",
    "slug": "abdalla-almarzooqi-advocates-legal-consultants",
    "name": "ABDALLA ALMARZOOQI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDALLA ALMARZOOQI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_51b52acb-6c31-4389-bf8c-9c3dc0b05299",
        "address": "Office No. 409, 4th Floor, Business Avenue 515 Sheikh Rashid Street, Port Said",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 409, 4th Floor, Business Avenue 515 Sheikh Rashid Street, Port Said"
  },
  {
    "id": "b2ebe602-4046-48f0-8ebd-12a12bbff751",
    "slug": "abdullatif-aljassmi-advocates-legal-consultants",
    "name": "ABDULLATIF ALJASSMI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDULLATIF ALJASSMI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_b2ebe602-4046-48f0-8ebd-12a12bbff751",
        "address": "Office No. 2309, 23 Floor, Burlington Tower, Business Bay, Bur Dubai, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 2309, 23 Floor, Burlington Tower, Business Bay, Bur Dubai, United Arab Emirates"
  },
  {
    "id": "10f3a70e-a779-455e-b149-f89cc17c8d2c",
    "slug": "saeed-ali-taher-advocates-legal-consultancy",
    "name": "SAEED ALI TAHER ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SAEED ALI TAHER ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_10f3a70e-a779-455e-b149-f89cc17c8d2c",
        "address": "Office No. 804, 8Th Level, Al Nouf Tower, Um Hurair Street, Port Saeed, Deira, Makani No. 3134794396",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 804, 8Th Level, Al Nouf Tower, Um Hurair Street, Port Saeed, Deira, Makani No. 3134794396"
  },
  {
    "id": "9f6d50d4-a121-40fc-b2c4-1c04b7c320ca",
    "slug": "nawal-salem-saeed-advocates-legal-consultants",
    "name": "NAWAL SALEM SAEED ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5OUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: NAWAL SALEM SAEED ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_9f6d50d4-a121-40fc-b2c4-1c04b7c320ca",
        "address": "Office No. 508, Nadd Hessa Street, Silicon Oasis, SIT Tower",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 508, Nadd Hessa Street, Silicon Oasis, SIT Tower"
  },
  {
    "id": "63e9551d-919b-4077-9d8e-f7488564ea5a",
    "slug": "saif-alshamsi-advocates-and-legal-consultancy-na",
    "name": "SAIF ALSHAMSI ADVOCATES AND LEGAL CONSULTANCY NA",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SAIF ALSHAMSI ADVOCATES AND LEGAL CONSULTANCY NA",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_63e9551d-919b-4077-9d8e-f7488564ea5a",
        "address": "-",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "-"
  },
  {
    "id": "f43eb63a-11c7-48cc-a033-dfce57a51069",
    "slug": "othman-almarzooqi-advocates-and-legal-consultations",
    "name": "OTHMAN ALMARZOOQI ADVOCATES AND LEGAL CONSULTATIONS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5PQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: OTHMAN ALMARZOOQI ADVOCATES AND LEGAL CONSULTATIONS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_f43eb63a-11c7-48cc-a033-dfce57a51069",
        "address": "Office No. 1505, Level 15, Single Business Tower, Business Bay, Sheikh Zayed Road, P.O. Box 114333, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 1505, Level 15, Single Business Tower, Business Bay, Sheikh Zayed Road, P.O. Box 114333, Dubai"
  },
  {
    "id": "38f14c15-0e59-4c0e-822d-006752d33c23",
    "slug": "hashim-salem-saif-advocates-and-legal-consultants",
    "name": "HASHIM SALEM SAIF ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5IUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HASHIM SALEM SAIF ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_38f14c15-0e59-4c0e-822d-006752d33c23",
        "address": "Office No. 907, Level 9, Al Fattan Plaza Building, Al Garhoud",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 907, Level 9, Al Fattan Plaza Building, Al Garhoud"
  },
  {
    "id": "c358c4dc-0f1e-46b7-838a-5c22dafdc4a9",
    "slug": "sulaiman-salem-alkarbi-advocates-legal-consultants",
    "name": "SULAIMAN SALEM ALKARBI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SULAIMAN SALEM ALKARBI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_c358c4dc-0f1e-46b7-838a-5c22dafdc4a9",
        "address": "Office No. 1104, 11TH Floor, Executive Tower, Business Bay, Bur Dubai, Makani No. 2527285837",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 1104, 11TH Floor, Executive Tower, Business Bay, Bur Dubai, Makani No. 2527285837"
  },
  {
    "id": "b350016a-c2ef-41e8-ae6d-8635c96fd5a3",
    "slug": "asma-ali-almessabi-advocates-legal-consultants",
    "name": "ASMA ALI ALMESSABI ADVOCATES &LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ASMA ALI ALMESSABI ADVOCATES &LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_b350016a-c2ef-41e8-ae6d-8635c96fd5a3",
        "address": "Office No.303, Floor 3, Sheikha Raisa Al Maktoum Building, Al Wasel, Bur Dubai, P.O Box. 417839, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No.303, Floor 3, Sheikha Raisa Al Maktoum Building, Al Wasel, Bur Dubai, P.O Box. 417839, Dubai"
  },
  {
    "id": "299570ec-e3fc-40ca-9efd-23fa71531910",
    "slug": "ahmed-german-advocates-legal-consultants",
    "name": "AHMED GERMAN ADVOCATES &LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BRzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AHMED GERMAN ADVOCATES &LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_299570ec-e3fc-40ca-9efd-23fa71531910",
        "address": "Al Garhoud, GOLF PARK BLDG, Floor MF-032, Makani No. 2720587240, P. O Box. 47888, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Al Garhoud, GOLF PARK BLDG, Floor MF-032, Makani No. 2720587240, P. O Box. 47888, Dubai"
  },
  {
    "id": "c36c907f-273c-4149-8243-229c124f5ba9",
    "slug": "nadia-alyousuf-advocates-legal-consultancy",
    "name": "NADIA ALYOUSUF ADVOCATES & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5OQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: NADIA ALYOUSUF ADVOCATES & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_c36c907f-273c-4149-8243-229c124f5ba9",
        "address": "Al Quoz 1, Sheikh Zayed Road, Level 1, Kia Mall, Office No. 129",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Al Quoz 1, Sheikh Zayed Road, Level 1, Kia Mall, Office No. 129"
  },
  {
    "id": "824a0731-654f-40f4-8c25-355c0c2481bf",
    "slug": "salha-alkhalafi-advocates-legal-consultants",
    "name": "SALHA ALKHALAFI ADVOCATES &LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SALHA ALKHALAFI ADVOCATES &LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_824a0731-654f-40f4-8c25-355c0c2481bf",
        "address": "Office No.M-01, Um Hurair First, AL Khallafi Building, Burjuman, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No.M-01, Um Hurair First, AL Khallafi Building, Burjuman, United Arab Emirates"
  },
  {
    "id": "f277e18e-9cad-49b7-9f59-dc43ee24b04e",
    "slug": "ahmed-eisa-advocates-legal-consultants",
    "name": "AHMED EISA ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BRTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AHMED EISA ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_f277e18e-9cad-49b7-9f59-dc43ee24b04e",
        "address": "Office No. 210, Al Khaima Building, Port Saeed, Deira, Dubai, , Makani No. 3235694882, P.O. Box. 14748, Dubai,",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 210, Al Khaima Building, Port Saeed, Deira, Dubai, , Makani No. 3235694882, P.O. Box. 14748, Dubai,"
  },
  {
    "id": "cb1666d8-7401-4169-b85d-0cf1b1ec9dea",
    "slug": "mohamed-alshaikh-advocates-legal-consultants-581",
    "name": "MOHAMED ALSHAIKH ADVOCATES &LEGAL CONSULTANTS 581",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: MOHAMED ALSHAIKH ADVOCATES &LEGAL CONSULTANTS 581",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_cb1666d8-7401-4169-b85d-0cf1b1ec9dea",
        "address": "-",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "-"
  },
  {
    "id": "f5db746b-b3e5-48db-9c25-afbbab0810e6",
    "slug": "alitezan-advocates-and-legal-consultants",
    "name": "ALITEZAN ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALITEZAN ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_f5db746b-b3e5-48db-9c25-afbbab0810e6",
        "address": "Office No. 1304, Level 13, Al Reem Tower, Al Maktoum Road, Deira, Makani No. 3035795150, P.O. Box. 1456, Dubai,",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 1304, Level 13, Al Reem Tower, Al Maktoum Road, Deira, Makani No. 3035795150, P.O. Box. 1456, Dubai,"
  },
  {
    "id": "c205304e-ac0d-4a3b-813e-48f3e6f3f902",
    "slug": "naser-abdulla-almuharrami-advocates-legal-consultants",
    "name": "NASER ABDULLA ALMUHARRAMI ADVOCATES &LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5OQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: NASER ABDULLA ALMUHARRAMI ADVOCATES &LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_c205304e-ac0d-4a3b-813e-48f3e6f3f902",
        "address": "Office No. OF0905, Trade Center First, H E SHEIKH MOHAMED BINBUTTI AL HAMED Building, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. OF0905, Trade Center First, H E SHEIKH MOHAMED BINBUTTI AL HAMED Building, United Arab Emirates"
  },
  {
    "id": "7ce2eb22-5fab-4be5-be2a-27870e1db48e",
    "slug": "saeed-alnaqbi-advocates-legal-consultants",
    "name": "SAEED ALNAQBI ADVOCATES &LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SAEED ALNAQBI ADVOCATES &LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_7ce2eb22-5fab-4be5-be2a-27870e1db48e",
        "address": "Office No. (1705 & 1706), 17th Floor, Al Masraf Tower, Bani Yas Street, Deira, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. (1705 & 1706), 17th Floor, Al Masraf Tower, Bani Yas Street, Deira, United Arab Emirates"
  },
  {
    "id": "bee17b0f-5af0-4852-82b4-8b557f2c595a",
    "slug": "sahar-advocates-legal-consultants",
    "name": "SAHAR ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SAHAR ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_bee17b0f-5af0-4852-82b4-8b557f2c595a",
        "address": "Al Barsha First - Rassis Business Center -- Office No. 0102-400, Makani No: 1835378040, United Arab Emirates, P.O. Box. 33727, Dubai,UNITED ARAB EMIRATES",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Al Barsha First - Rassis Business Center -- Office No. 0102-400, Makani No: 1835378040, United Arab Emirates, P.O. Box. 33727, Dubai,UNITED ARAB EMIRATES"
  },
  {
    "id": "ea4ce756-b38b-4bb2-801d-ec831fbe8205",
    "slug": "sarah-albaqishi-advocate-legal-consultancy",
    "name": "SARAH ALBAQISHI ADVOCATE & LEGAL CONSULTANCY",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SARAH ALBAQISHI ADVOCATE & LEGAL CONSULTANCY",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_ea4ce756-b38b-4bb2-801d-ec831fbe8205",
        "address": "Dubai - Trade Center First, Sheikh Zayed Road - Building: Al Mousa Tower 1, Floor 1/Office 105, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Dubai - Trade Center First, Sheikh Zayed Road - Building: Al Mousa Tower 1, Floor 1/Office 105, United Arab Emirates"
  },
  {
    "id": "0147da48-df43-4031-9cbd-05978ad2f3e8",
    "slug": "suhaila-almarzooqi-advocates-legal-consultants",
    "name": "SUHAILA ALMARZOOQI ADVOCATES &LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SUHAILA ALMARZOOQI ADVOCATES &LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_0147da48-df43-4031-9cbd-05978ad2f3e8",
        "address": "Office No.218, Al Shafar Investment Building, SHK Zayed Street, Al Qouz, Bur Dubai, Makani No. 2138082888,",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No.218, Al Shafar Investment Building, SHK Zayed Street, Al Qouz, Bur Dubai, Makani No. 2138082888,"
  },
  {
    "id": "1cb30e8a-f393-4feb-8ac6-e51eede5b02d",
    "slug": "nasser-yousuf-alkhamis-advocates-legal-consultants",
    "name": "NASSER YOUSUF ALKHAMIS ADVOCATES &LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5OWTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: NASSER YOUSUF ALKHAMIS ADVOCATES &LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_1cb30e8a-f393-4feb-8ac6-e51eede5b02d",
        "address": "Office No.1107, Trade Centre First,Sheikh Zayed Road, Building B Latifa Towers, P.O Box. 235699, Dubai,",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No.1107, Trade Centre First,Sheikh Zayed Road, Building B Latifa Towers, P.O Box. 235699, Dubai,"
  },
  {
    "id": "9e8e92a7-9c58-4abb-9fd4-3f08db68876c",
    "slug": "sami-alsawalhi-advocates-legal-consultants",
    "name": "SAMI ALSAWALHI ADVOCATES &LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SAMI ALSAWALHI ADVOCATES &LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_9e8e92a7-9c58-4abb-9fd4-3f08db68876c",
        "address": "Office No.107,level 1, Bu Shaqer Building ,Garhoud, Deira,Block B, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No.107,level 1, Bu Shaqer Building ,Garhoud, Deira,Block B, United Arab Emirates"
  },
  {
    "id": "4f201765-ca98-4dc6-b182-d8fe1484c81a",
    "slug": "sulaiman-al-shebli-advocates-legal-consultants",
    "name": "SULAIMAN AL SHEBLI ADVOCATES &LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SULAIMAN AL SHEBLI ADVOCATES &LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_4f201765-ca98-4dc6-b182-d8fe1484c81a",
        "address": "Office No.202,level 2, Rega Al Buteen,Al Salemiyah Tower, Deira, P.O Box. 25044, Dubai,",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No.202,level 2, Rega Al Buteen,Al Salemiyah Tower, Deira, P.O Box. 25044, Dubai,"
  },
  {
    "id": "530276d5-569e-44dd-a6e0-5d3313516639",
    "slug": "abdulla-alnuaimi-advocates-legal-consultants",
    "name": "ABDULLA ALNUAIMI ADVOCATES &LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDULLA ALNUAIMI ADVOCATES &LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_530276d5-569e-44dd-a6e0-5d3313516639",
        "address": "Office No.216,level 2, Garhoud Star, Al Garhoud, Deira, P.O Box. 444712, Dubai,",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No.216,level 2, Garhoud Star, Al Garhoud, Deira, P.O Box. 444712, Dubai,"
  },
  {
    "id": "e32515de-84f4-494a-8539-79b04138d1b8",
    "slug": "amna-alzaabi-advocates-legal-consultants",
    "name": "AMNA ALZAABI ADVOCATES &LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AMNA ALZAABI ADVOCATES &LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_e32515de-84f4-494a-8539-79b04138d1b8",
        "address": "Business Bay , Silver Tower, Level 15 ,Office No. 1502, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Business Bay , Silver Tower, Level 15 ,Office No. 1502, United Arab Emirates"
  },
  {
    "id": "71df019e-df97-4cbc-bcf2-c3b924369268",
    "slug": "fareed-alhassan-advocates-legal-consultants",
    "name": "FAREED ALHASSAN ADVOCATES &LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5GQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: FAREED ALHASSAN ADVOCATES &LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_71df019e-df97-4cbc-bcf2-c3b924369268",
        "address": "Office No.M03, Golden Business Centre, Port Saeed, Deira, P.O Box. 455067 , Dubai,",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No.M03, Golden Business Centre, Port Saeed, Deira, P.O Box. 455067 , Dubai,"
  },
  {
    "id": "30508832-95f0-4bb8-a29a-45ad96a815e5",
    "slug": "rashed-ahmed-al-sereidi-advocates-and-legal-consultants",
    "name": "RASHED AHMED AL SEREIDI ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5SQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: RASHED AHMED AL SEREIDI ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_30508832-95f0-4bb8-a29a-45ad96a815e5",
        "address": "Office No.404, Al Owais Tower, Port Saeed, Deira, P.O Box. 22662, Dubai,",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No.404, Al Owais Tower, Port Saeed, Deira, P.O Box. 22662, Dubai,"
  },
  {
    "id": "7904a2dc-d139-488f-b6b6-2b6b0a21c2fd",
    "slug": "jasim-al-haddad-advocates-legal-consultants",
    "name": "JASIM AL HADDAD ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5KQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: JASIM AL HADDAD ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_7904a2dc-d139-488f-b6b6-2b6b0a21c2fd",
        "address": "Office No. 1201 --1202 --1206,12 Floor, Embraer Tower Building ,Burj B,Burj Khalifa Area, Marasi Drive",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 1201 --1202 --1206,12 Floor, Embraer Tower Building ,Burj B,Burj Khalifa Area, Marasi Drive"
  },
  {
    "id": "23f0e758-3d7a-4b04-b22c-471e663dc0dc",
    "slug": "khalid-alzaabi-advocates-and-legal-consultants",
    "name": "KHALID ALZAABI ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5LQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: KHALID ALZAABI ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_23f0e758-3d7a-4b04-b22c-471e663dc0dc",
        "address": "Office No. 304, Ithraa Tower, Al Gharhood, Deira, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 304, Ithraa Tower, Al Gharhood, Deira, United Arab Emirates"
  },
  {
    "id": "b8d658e6-9cd2-444b-bfbe-469b45d8906f",
    "slug": "abdulla-alhaddad-advocates-and-legal-consultants",
    "name": "ABDULLA ALHADDAD ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDULLA ALHADDAD ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_b8d658e6-9cd2-444b-bfbe-469b45d8906f",
        "address": "Um Hurair 2 - Street: Riyadh - Building : Supreme Court Complex, 3rd Floor - Office 304-305",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Um Hurair 2 - Street: Riyadh - Building : Supreme Court Complex, 3rd Floor - Office 304-305"
  },
  {
    "id": "9c542fca-fe58-418b-8da9-2dd4e16f93eb",
    "slug": "huda-yaqoob-advocates-legal-consultants",
    "name": "HUDA YAQOOB ADVOCATES &LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5IWTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: HUDA YAQOOB ADVOCATES &LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_9c542fca-fe58-418b-8da9-2dd4e16f93eb",
        "address": "Office No.803, Al Saqr Business, Sheikh Zayed Street,",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No.803, Al Saqr Business, Sheikh Zayed Street,"
  },
  {
    "id": "c28ea3ae-75be-4b23-a02d-694adb93bdd2",
    "slug": "abdulla-ebrahim-almulla-advocates-legal-consultants",
    "name": "ABDULLA EBRAHIM ALMULLA ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BRTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDULLA EBRAHIM ALMULLA ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_c28ea3ae-75be-4b23-a02d-694adb93bdd2",
        "address": "Business Bay Area - Building : Bay Square No. 12 - 5th floor / 506, UNITED ARAB EMIRATES",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Business Bay Area - Building : Bay Square No. 12 - 5th floor / 506, UNITED ARAB EMIRATES"
  },
  {
    "id": "4dc70946-30b9-4d4e-82cd-7df2e2887df2",
    "slug": "khaled-almarri-partners-advocates-legal-consultants",
    "name": "KHALED ALMARRI & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5LQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: KHALED ALMARRI & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_4dc70946-30b9-4d4e-82cd-7df2e2887df2",
        "address": "Trade Center Second - Maze Tower -- Office No. 301, Makani No: 2664489951, UNITED ARAB EMIRATES",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Trade Center Second - Maze Tower -- Office No. 301, Makani No: 2664489951, UNITED ARAB EMIRATES"
  },
  {
    "id": "d226326e-ac8f-4105-af44-8b7a93e3fec0",
    "slug": "adel-alghafri-advocates-legal-consultants",
    "name": "ADEL ALGHAFRI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ADEL ALGHAFRI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_d226326e-ac8f-4105-af44-8b7a93e3fec0",
        "address": "Business Bay -- Al Mustaqbal Street -- Aspect Tower Building, 16th Floor -- Office No. 1602, United Arab Emirates",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Business Bay -- Al Mustaqbal Street -- Aspect Tower Building, 16th Floor -- Office No. 1602, United Arab Emirates"
  },
  {
    "id": "73888a56-f4b2-4168-acff-b385008ea703",
    "slug": "dr-faisal-alhefeiti-advocates-legal-consultants",
    "name": "DR FAISAL ALHEFEITI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ERjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: DR FAISAL ALHEFEITI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_73888a56-f4b2-4168-acff-b385008ea703",
        "address": "Bur Dubai -- Um Hurair -- Nextgen Robopark Investment -- Office No. 103",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Bur Dubai -- Um Hurair -- Nextgen Robopark Investment -- Office No. 103"
  },
  {
    "id": "70943220-83f8-4e15-8bea-1c433bee5178",
    "slug": "faisal-alqasim-advocates-legal-consultants",
    "name": "FAISAL ALQASIM ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5GQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: FAISAL ALQASIM ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_70943220-83f8-4e15-8bea-1c433bee5178",
        "address": "Deira - Al Khor Plaza - Office No. 10, Makani No: 3252993264, UNITED ARAB EMIRATES",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Deira - Al Khor Plaza - Office No. 10, Makani No: 3252993264, UNITED ARAB EMIRATES"
  },
  {
    "id": "aca32c69-f310-4b7f-9619-f8336c98eef4",
    "slug": "dr-hend-bin-hendi-advocates-legal-consultants",
    "name": "DR HEND BIN HENDI ADVOCATES&LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5ESDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: DR HEND BIN HENDI ADVOCATES&LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_aca32c69-f310-4b7f-9619-f8336c98eef4",
        "address": "Al Khabeesi - Deira, Building: Abdulrahman Mohamed Al Sheikh - 2nd Floor - Office 202",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Al Khabeesi - Deira, Building: Abdulrahman Mohamed Al Sheikh - 2nd Floor - Office 202"
  },
  {
    "id": "9a010951-549b-4087-b366-537ccacea5dd",
    "slug": "ali-yousuf-alawadhi-advocates-legal-consultants",
    "name": "ALI YOUSUF ALAWADHI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BWTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALI YOUSUF ALAWADHI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_9a010951-549b-4087-b366-537ccacea5dd",
        "address": "Office No. 3015, Entrance A, MAZAYA CENTRE, Al WASL, Dubai",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Office No. 3015, Entrance A, MAZAYA CENTRE, Al WASL, Dubai"
  },
  {
    "id": "a1e65fb7-4997-4b10-a1b8-6491cec42430",
    "slug": "ahmed-alshaali-advocates-and-legal-consultants",
    "name": "AHMED ALSHAALI ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AHMED ALSHAALI ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_a1e65fb7-4997-4b10-a1b8-6491cec42430",
        "address": "Garhoud, Garhoud Business Center, Office M21, near GG Co Metro Station, Makani No. 4002124052",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "Garhoud, Garhoud Business Center, Office M21, near GG Co Metro Station, Makani No. 4002124052"
  },
  {
    "id": "7dbefe29-6e37-415e-9cfd-0d162256c00e",
    "slug": "hamad-saeed-alketbiadvocates-and-legal-consultants",
    "name": "Hamad Saeed AlketbiAdvocates and Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5IUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Hamad Saeed AlketbiAdvocates and Legal Consultants",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_7dbefe29-6e37-415e-9cfd-0d162256c00e",
        "address": "-",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "-"
  },
  {
    "id": "680e370e-2f45-4a0d-9cd9-e1f6b95de271",
    "slug": "abdulaziz-alablam-advocates-legal-consultants",
    "name": "ABDULAZIZ ALABLAM ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDULAZIZ ALABLAM ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_680e370e-2f45-4a0d-9cd9-e1f6b95de271",
        "address": "-",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "-"
  },
  {
    "id": "55952638-f253-4671-8b44-75a6dfeefefe",
    "slug": "advocates-unit",
    "name": "ADVOCATES UNIT",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BVTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ADVOCATES UNIT",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_55952638-f253-4671-8b44-75a6dfeefefe",
        "address": "-",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "-"
  },
  {
    "id": "b7f9f268-603f-4d00-8ef6-00ea84127ef9",
    "slug": "alaanoud-mohamed-saleh-albriki-law-offices-l-l-c-s-p-c",
    "name": "ALAANOUD MOHAMED SALEH ALBRIKI LAW OFFICES - L.L.C - S.P.C",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ALAANOUD MOHAMED SALEH ALBRIKI LAW OFFICES - L.L.C - S.P.C",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_b7f9f268-603f-4d00-8ef6-00ea84127ef9",
        "address": "-",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "العنود صالح البريكي",
    "address": "-"
  },
  {
    "id": "fe9950cd-d73f-4ed9-9138-1eb04c9cd9f5",
    "slug": "fadil-alzarooni-advocates-legal-consultants",
    "name": "FADIL ALZAROONI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5GQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: FADIL ALZAROONI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_fe9950cd-d73f-4ed9-9138-1eb04c9cd9f5",
        "address": "-",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "-"
  },
  {
    "id": "e000f1ed-64f0-49e3-8610-bd843c259e5d",
    "slug": "outside-dubai-firm",
    "name": "OUTSIDE DUBAI FIRM",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5PRDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: OUTSIDE DUBAI FIRM",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_e000f1ed-64f0-49e3-8610-bd843c259e5d",
        "address": "-",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "-",
    "address": "-"
  },
  {
    "id": "b00466fe-3ca2-4d0f-b2a7-128f845a8721",
    "slug": "abdulla-almazrouei-advocates-legal-consultants",
    "name": "ABDULLA ALMAZROUEI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: ABDULLA ALMAZROUEI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_b00466fe-3ca2-4d0f-b2a7-128f845a8721",
        "address": "-",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "ABDULLA MUSABBEH SAEED ALI ALMAZROOEI",
    "address": "-"
  },
  {
    "id": "8d269293-009e-4da2-91fc-0e73af5a43dd",
    "slug": "ahad-saif-al-zaabi-advocates-legal-consultants",
    "name": "Ahad Saif Al Zaabi Advocates & Legal Consultants",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Ahad Saif Al Zaabi Advocates & Legal Consultants",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_8d269293-009e-4da2-91fc-0e73af5a43dd",
        "address": "-",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "AHAD SAIF MOHAMMED AHMED",
    "address": "-"
  },
  {
    "id": "b65850ee-9484-4a9d-836d-97a9b859b00c",
    "slug": "khamis-alzaabi-advocates-and-legal-consultants",
    "name": "KHAMIS ALZAABI ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5LQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: KHAMIS ALZAABI ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_b65850ee-9484-4a9d-836d-97a9b859b00c",
        "address": "-",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "KHAMIS OBAID MOHAMED KHAMIS ALZAABI",
    "address": "-"
  },
  {
    "id": "3f8ae152-d409-4635-bb8c-262f1cb49bfa",
    "slug": "kka-law-firm",
    "name": "Kka law firm",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5LTDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: Kka law firm",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_3f8ae152-d409-4635-bb8c-262f1cb49bfa",
        "address": "-",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "Khalfan Alshamsi",
    "address": "-"
  },
  {
    "id": "73390e65-48a9-4e57-8c46-539abdf782cc",
    "slug": "salha-hudaim-aljabri-advocates-and-legal-consultants",
    "name": "SALHA HUDAIM ALJABRI ADVOCATES AND LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5TSDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: SALHA HUDAIM ALJABRI ADVOCATES AND LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_73390e65-48a9-4e57-8c46-539abdf782cc",
        "address": "-",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "SALHA KHUDAIM MUBARAK KHUDAIM ALJABRI",
    "address": "-"
  },
  {
    "id": "12093b3d-3032-4572-9589-796bc31d0c77",
    "slug": "ahmed-humaid-alblooshi-advocates-legal-consultants",
    "name": "AHMED HUMAID ALBLOOSHI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BSDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: AHMED HUMAID ALBLOOSHI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_12093b3d-3032-4572-9589-796bc31d0c77",
        "address": "-",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "KHAWLA AHMED MOHAMED DIMAS ALSUWAIDI",
    "address": "-"
  },
  {
    "id": "950ccb2d-ceff-4629-bd6b-39b2602521dc",
    "slug": "dr-adnan-mohamed-alhammadi-advocates-legal-consultants",
    "name": "DR ADNAN MOHAMED ALHAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "title": "Advocacy Firm",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5EQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "-",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocacy Firm"
    ],
    "description": "Licensed advocacy firm: DR ADNAN MOHAMED ALHAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "consultationFee": 500,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "-",
    "category": "Advocacy_Firms",
    "offices": [
      {
        "id": "office_950ccb2d-ceff-4629-bd6b-39b2602521dc",
        "address": "-",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "owner": "ADNAN MOHAMED YOUSEF MALAHAYAN",
    "address": "-"
  },
  {
    "id": "303f2967-69d1-4745-b0a0-bc30c28b1ec2",
    "slug": "philip-smith",
    "name": "PHILIP SMITH",
    "title": "Legal Consultant",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMzc0MTUxO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5QUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Legal Consultancy",
      "Corporate Law"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "05/11/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-11-04",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Legal Consultant"
    ],
    "description": "Licensed legal consultant: PHILIP SMITH",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-06589",
    "category": "Legal_Consultancy_Individuals",
    "offices": [
      {
        "id": "office_303f2967-69d1-4745-b0a0-bc30c28b1ec2",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ]
  },
  {
    "id": "76051d6f-920d-406e-bf46-1e9f8d8ee211",
    "slug": "hamdan-sulaiman-salim-sulaiman-almaazmi",
    "name": "HAMDAN SULAIMAN SALIM SULAIMAN ALMAAZMI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5IUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "24/01/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-01-23",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: HAMDAN SULAIMAN SALIM SULAIMAN ALMAAZMI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-1623",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_76051d6f-920d-406e-bf46-1e9f8d8ee211",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "HAMDAN SULAIMAN SALIM ALMAAZMI ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "8ec7fb02-2768-415a-9450-6b5c15c53374",
    "slug": "asma-mohammed-sultan-abdulla-alshamsi",
    "name": "ASMA MOHAMMED SULTAN ABDULLA ALSHAMSI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "27/03/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-03-26",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ASMA MOHAMMED SULTAN ABDULLA ALSHAMSI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-1644",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_8ec7fb02-2768-415a-9450-6b5c15c53374",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "OUTSIDE DUBAI FIRM"
  },
  {
    "id": "5f5e323b-0fe4-40c9-ae72-79e6c213b52e",
    "slug": "aishah-khalaf-obaid-almazrouei",
    "name": "AISHAH KHALAF OBAID ALMAZROUEI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BSzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/04/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: AISHAH KHALAF OBAID ALMAZROUEI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-1648",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_5f5e323b-0fe4-40c9-ae72-79e6c213b52e",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "AISHAH KHALAF ALMAZROUEI ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "0b137b62-eee2-4cda-9db1-46e4447d6c16",
    "slug": "faisal-saeed-ali-binzaal-aldhaheri",
    "name": "FAISAL SAEED ALI BINZAAL ALDHAHERI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5GUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/06/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: FAISAL SAEED ALI BINZAAL ALDHAHERI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-1670",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_0b137b62-eee2-4cda-9db1-46e4447d6c16",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "OUTSIDE DUBAI FIRM"
  },
  {
    "id": "d705caf5-14ad-4eea-9736-5ef2a46a8e0d",
    "slug": "hend-rashid-abdulmajid-almehairi",
    "name": "HEND RASHID ABDULMAJID ALMEHAIRI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5IUjwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "09/08/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-08",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: HEND RASHID ABDULMAJID ALMEHAIRI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-1694",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_d705caf5-14ad-4eea-9736-5ef2a46a8e0d",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "6379c174-ccb1-4b29-ad44-c61e1f5ac1e0",
    "slug": "asmaa-abdulla-saeed-khameis-alabdouli",
    "name": "ASMAA ABDULLA SAEED KHAMEIS ALABDOULI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/09/2022",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-09-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ASMAA ABDULLA SAEED KHAMEIS ALABDOULI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-1705",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_6379c174-ccb1-4b29-ad44-c61e1f5ac1e0",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "ASMAA ABULLA ALABDOULI ADVOCATES AND LEGAL CONSULTANTS"
  },
  {
    "id": "21de8d42-0615-416a-9742-c0912c1ca986",
    "slug": "afra-mohammed-khamis-mughair-alkhaili",
    "name": "AFRA MOHAMMED KHAMIS MUGHAIR ALKHAILI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BTTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "01/05/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-04-30",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: AFRA MOHAMMED KHAMIS MUGHAIR ALKHAILI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-1804",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_21de8d42-0615-416a-9742-c0912c1ca986",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "OUTSIDE DUBAI FIRM"
  },
  {
    "id": "1f63bf80-7bcd-4799-a897-578e98eaf7bf",
    "slug": "ahmed-humaid-abbas-karmak-alblooshi",
    "name": "AHMED HUMAID ABBAS KARMAK ALBLOOSHI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BSDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "07/05/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-06",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: AHMED HUMAID ABBAS KARMAK ALBLOOSHI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-1805",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_1f63bf80-7bcd-4799-a897-578e98eaf7bf",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "OUTSIDE DUBAI FIRM"
  },
  {
    "id": "258e8d01-0b58-4fc0-95ca-8c53f85c37c4",
    "slug": "afra-ali-rashed-mohammed-alkuwaiti",
    "name": "AFRA ALI RASHED MOHAMMED ALKUWAITI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Criminal Law-Family Crimes",
      "Commercial Transactions-Consumer protection",
      "Commercial Transactions-Intellectual Property (includes trademarks",
      "copy rights",
      "patents)"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/05/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: AFRA ALI RASHED MOHAMMED ALKUWAITI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-1810",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_258e8d01-0b58-4fc0-95ca-8c53f85c37c4",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "ABDULLA MOHAMMED RASOUL ALHARMOODI ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "e2771b9a-584d-470c-b78b-7566a04e65f6",
    "slug": "fatima-abdulla-omar-abdulla-balfaqeeh",
    "name": "FATIMA ABDULLA OMAR ABDULLA BALFAQEEH",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5GQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/06/2023",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: FATIMA ABDULLA OMAR ABDULLA BALFAQEEH",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-1816",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_e2771b9a-584d-470c-b78b-7566a04e65f6",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "OUTSIDE DUBAI FIRM"
  },
  {
    "id": "3cbb2d1e-a7db-4e4e-a42a-c1cee54eb65a",
    "slug": "abdulla-saeed-hassan-saif-alzaabi",
    "name": "ABDULLA SAEED HASSAN SAIF ALZAABI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BUzwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "06/02/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-02-05",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ABDULLA SAEED HASSAN SAIF ALZAABI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-1920",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_3cbb2d1e-a7db-4e4e-a42a-c1cee54eb65a",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "OUTSIDE DUBAI FIRM"
  },
  {
    "id": "ccba12a4-2f7b-4a1f-af43-696d9d6d6368",
    "slug": "amna-ismail-khalaf-ismail",
    "name": "AMNA ISMAIL KHALAF ISMAIL",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BSTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "16/05/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-05-15",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: AMNA ISMAIL KHALAF ISMAIL",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-1967",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_ccba12a4-2f7b-4a1f-af43-696d9d6d6368",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "FAHAD SAEED ALZEYOUDI ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "3534faf6-c403-4f7b-9783-d46529e1b5dc",
    "slug": "noura-hasan-marzouq-awadh-alseiari",
    "name": "NOURA HASAN MARZOUQ AWADH ALSEIARI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5OSDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/07/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-07-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: NOURA HASAN MARZOUQ AWADH ALSEIARI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2013",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_3534faf6-c403-4f7b-9783-d46529e1b5dc",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "ALI HASAN ALHAMMADI ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "8159c3c2-fa29-41f1-8e5b-f9c80b77c622",
    "slug": "ashwaq-qaid-nasser-alqamesh",
    "name": "ASHWAQ QAID NASSER ALQAMESH",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BUTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "11/08/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-10",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ASHWAQ QAID NASSER ALQAMESH",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2018",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_8159c3c2-fa29-41f1-8e5b-f9c80b77c622",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "ASHWAQ QAID ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "bbfc6465-e7b8-4935-b607-09971bcff864",
    "slug": "abrar-ahmed-abdulla",
    "name": "ABRAR AHMED ABDULLA",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BQTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "22/12/2024",
    "licenseStatus": "suspended",
    "licenseExpiry": "2027-12-21",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ABRAR AHMED ABDULLA",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2056",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_bbfc6465-e7b8-4935-b607-09971bcff864",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "AZZA IBRAHIM HASSAN AL MULLA ADVOCATES & LEGAL CONSULTANTS"
  },
  {
    "id": "94f61491-2ecf-4558-9fdd-3f4b2ca2bb27",
    "slug": "ali-eisa-saif-ballekhailib-alshamsi",
    "name": "ALI EISA SAIF BALLEKHAILIB ALSHAMSI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5BRTwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "19/06/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-06-18",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: ALI EISA SAIF BALLEKHAILIB ALSHAMSI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2104",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_94f61491-2ecf-4558-9fdd-3f4b2ca2bb27",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "AL GHARIB & PARTNERS ADVOCATES LEGAL CONSULTANTS"
  },
  {
    "id": "f9ed1cee-17a9-4705-bc11-961eda201919",
    "slug": "mohamed-dalham-mohamed-alfuhaid-alhajeri",
    "name": "MOHAMED DALHAM MOHAMED ALFUHAID ALHAJERI",
    "title": "Advocate",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eToxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMWU0MGFmO3N0b3Atb3BhY2l0eTowLjgiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI1OCIgZmlsbD0idXJsKCNnKSIvPjx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj5NRDwvdGV4dD48L3N2Zz4=",
    "specializations": [
      "Advocacy",
      "Legal Representation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "03/08/2025",
    "licenseStatus": "suspended",
    "licenseExpiry": "2026-08-02",
    "education": [
      "Legal Education"
    ],
    "achievements": [
      "Licensed Advocate"
    ],
    "description": "Licensed advocate: MOHAMED DALHAM MOHAMED ALFUHAID ALHAJERI",
    "consultationFee": 400,
    "emirate": "Dubai",
    "verified": true,
    "registrationNumber": "L-2126",
    "category": "Advocacy_Individuals",
    "offices": [
      {
        "id": "office_f9ed1cee-17a9-4705-bc11-961eda201919",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "firmName": "OUTSIDE DUBAI FIRM"
  }
];

export const totalLawyers = 7741;
